(function () {
    'use strict';

    var pages = [
        'ui.router',
        'InovaceClientApp.pages.auth',
        'InovaceClientApp.pages.main'
    ];

    angular.module('InovaceClientApp.pages', pages)
        .config(['$urlRouterProvider', '$httpProvider', '$stateProvider', routeConfig])
        .run(['$state', '$transitions', '$rootScope', 'authService', 'toastr', 'utilService', onRun]);

    /** @ngInject */
    function routeConfig($urlRouterProvider, $httpProvider, $stateProvider) {
        $urlRouterProvider.otherwise('/login');
        $httpProvider.interceptors.push('httpInterceptor');
    }

    //
    function onRun($state, $transitions, $rootScope, authService, toastr, utilService) {

        $transitions.onBefore({
            to: function (state) {
                return state.name != 'login';
            }
        }, function (trans) {
            if(trans.to().title != null)
                // $rootScope.title = trans.to().title.includes("Profile") ? "Profile":trans.to().title;
                // console.log($rootScope.title)
            if (!authService.isAuthenticated()) {
                var params = {
                    prevState : trans.to().name
                }

                return $state.target("login", params);
            } else {
                if (!$rootScope.loggedInUser) $rootScope.loggedInUser = authService.getLoggedInUser();
                var defaultState = 'profile';
                if ($rootScope.loggedInUser.isCompanyAdmin || $rootScope.loggedInUser.isAdmin || $rootScope.loggedInUser.isHrManager || $rootScope.loggedInUser.isGroupAdmin) defaultState = 'dashboard.attendanceDashboard';
                if ($rootScope.loggedInUser.isLineManager) defaultState = 'employees.manageEmployees';

                // check module on off permission
                if (trans.to().data && trans.to().data.code != null) {
                    if (!utilService.hasPermission(trans.to().data.code))
                        return $state.target(defaultState);
                }


                // Line Manager
                // if (!$rootScope.loggedInUser.isCompanyAdmin
                //     && !$rootScope.loggedInUser.isAdmin
                //     && $rootScope.loggedInUser.isLineManager
                //     && trans.to().lineManagerPermitted
                //     && trans.to().lineManagerPermitted === true) return true;
                if(!$rootScope.loggedInUser.employeeRoles.includes('COMPANY_ADMIN')
                    && !$rootScope.loggedInUser.employeeRoles.includes('ADMIN')
                    && $rootScope.loggedInUser.employeeRoles.includes('LINE_MANAGER')
                    && trans.to().roles.includes('LINE_MANAGER')) return true;

                //Group Admin
                if($rootScope.loggedInUser.isGroupAdmin){
                    // if(trans.to().groupAdminPermitted && trans.to().groupAdminPermitted == true){
                    //     return true;
                    // }
                    if(trans.to().roles.includes('GROUP_ADMIN')){
                        return true;
                    }
                   else {
                        // $rootScope.title = "test123"+trans.from().title;
                        return false;
                    }
                }
                var found = false;
                if(trans.to().roles != null) {
                    trans.to().roles.forEach(function (role) {
                        if ($rootScope.loggedInUser.employeeRoles.includes(role)) found = true;
                    });
                }
                if(found) return true;

                //Site management page access for site managers and admins who are not admin or HR manager
                // if(trans.to().siteManagementManagerPermitted && $rootScope.loggedInUser.isSiteManagementManager) return true;
                // if(trans.to().siteManagementAdminPermitted && $rootScope.loggedInUser.isSiteManagementAdmin) return true;

                //Payroll management page access for site managers and admins who are not admin or HR manager
                // if(trans.to().payrollManagerPermitted && $rootScope.loggedInUser.isPayrollManager) return true;
                // if(trans.to().payrollApproverPermitted && $rootScope.loggedInUser.isPayrollApprover) return true;

                // if(trans.to().parkingOperationsManagerPermitted && $rootScope.loggedInUser.isParkingOperationsManager) return true;

                if (!authService.isAdmin() && $rootScope.loggedInUser.isLineManager) return $state.target(defaultState);

                // General User
                // if (trans.to().generalUserPermitted && trans.to().generalUserPermitted === true) return true;

                if (!authService.isAdmin()) return $state.target(defaultState);
            }
        });

        $transitions.onSuccess({
        },function (trans) {
            if(!trans.to().analyticsHeaderTitle){
                $rootScope.title = trans.to().analyticsTitle;
            }
            else  $rootScope.title = trans.to().analyticsHeaderTitle +" - "+ trans.to().analyticsTitle;
            // console.log(trans.to())
        })

        $rootScope.$on('unauthorized', function () {
            if(authService.isAuthenticated()){
                authService.clearSession();
                $state.transitionTo('login');
                toastr.error('Your session has expired! Please sign in again!', 'Session Expired!', {
                    "autoDismiss": false,
                    "positionClass": "toast-top-right",
                    "type": "error",
                    "timeOut": "5000",
                    "extendedTimeOut": "2000",
                    "allowHtml": false,
                    "closeButton": false,
                    "tapToDismiss": true,
                    "progressBar": false,
                    "newestOnTop": true,
                    "maxOpened": 0,
                    "preventDuplicates": false,
                    "preventOpenDuplicates": false
                });
            }
        });
        $rootScope.$on('server-down', function () {
            // console.log("server down event");
            authService.clearSession();
            $state.transitionTo('login');
            toastr.error('Please try again later!', 'Server problem!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        });
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            // console.log("state change error event");
            // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
            event.preventDefault();
            toastr.error('Please try again later!', 'Server problem!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
            $state.go('dashboard.attendanceDashboard');
        });

        //
    }

    // analytics.$inject = ['$rootScope', '$location', '$window'];
    // function analytics($rootScope, $location, $window) {
    //
    //     // initialise google analytics
    //     // $window.ga('create', 'G-8BWV5GM2DE', 'auto');
    //
    //     // track pageview on state change
    //     $rootScope.$on('$stateChangeSuccess', function (event) {
    //         // $window.gtag('set', 'page', $location.path());
    //         // gtag('config', 'GA_MEASUREMENT_ID');
    //         if (!$window.ga) return; $window.ga('send', 'pageview', { page: $location.path() });
    //
    //         // $window.ga('send', 'pageview', $location.path());
    //     });
    // }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'BlurAdmin.theme.components',
  ]);

})();

(function(){
    'use strict';

    var authStateModules = [
        'ui.router',
        'InovaceClientApp.pages.auth.login',
        'InovaceClientApp.pages.auth.logout'
    ];

    angular.module('InovaceClientApp.pages.auth', authStateModules)
        .config(['$stateProvider' , function ($stateProvider) {
            $stateProvider
                /* public template*/
                .state('public', {
                    url : "",
                    views : {
                        'root' : {
                            templateUrl : 'app/pages/auth/auth.html'
                        }
                    },
                    abstract : true,
                    roles: ['LINE_MANAGER'],
                    // lineManagerPermitted: true
                })
        }]);
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main', [
        'ui.router',
        'InovaceClientApp.pages.main.attendanceReport',
        'InovaceClientApp.pages.main.employees',
        'InovaceClientApp.pages.main.dashboard',
        'InovaceClientApp.pages.main.profile',
        'InovaceClientApp.pages.main.companies',
        'InovaceClientApp.pages.main.offices',
        'InovaceClientApp.pages.main.settings',
        'InovaceClientApp.pages.main.shiftManagement',
        'InovaceClientApp.pages.main.leave',
        'InovaceClientApp.pages.main.devices',
        'InovaceClientApp.pages.main.pendingApprovals',
        'InovaceClientApp.pages.main.overtime',
        'InovaceClientApp.pages.main.sms',
        'InovaceClientApp.pages.main.payroll',
        'InovaceClientApp.pages.main.projectManagement',
        'InovaceClientApp.pages.main.notifications',
        'InovaceClientApp.pages.main.visitorManagement',
        'InovaceClientApp.pages.main.siteManagement',
        'InovaceClientApp.pages.main.parkingManagement',
        'InovaceClientApp.pages.main.membershipManagement',
        'InovaceClientApp.pages.main.billing',
    ]).config(['$stateProvider', 'baSidebarServiceProvider', 'FCMProvider', function ($stateProvider, baSidebarServiceProvider, FCMProvider) {
        $stateProvider
        /* public template*/
            .state('app', {
                url: '',
                views : {
                    'root' : {
                        templateUrl: 'app/pages/main/main.html',
                        controller : 'MainCtrl'
                    }
                },
                abstract : true
            });
        baSidebarServiceProvider.addStaticItem({
            title: 'My Profile',
            icon : 'ion-person',
            order: 160,
            stateRef: 'profile'
        });
        if(firebase.messaging.isSupported()){
            FCMProvider.init();
        }
    }]);
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

(function(){
    'use strict';

    angular.module('InovaceClientApp.pages.auth.logout', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('logout', {
                url: '/logout',
                parent : 'public',
                views : {
                    'pub@public' : {
                        template : '<head><title>Logout - Tipsoi HR Management</title></head>',
                        controller : 'LogoutCtrl'
                    }
                },
                title: 'Logout',
                roles: ['GENERAL_USER','LINE_MANAGER','GROUP_ADMIN'],
                // generalUserPermitted : true,
                // lineManagerPermitted: true,
                // groupAdminPermitted : true
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("InovaceClientApp.pages.main.attendanceReport", [
            "InovaceClientApp.pages.main.attendanceReport.detailedAttendanceReport",
            "InovaceClientApp.pages.main.attendanceReport.monthlyReport",
            "InovaceClientApp.pages.main.attendanceReport.detailedMonthlyReport",
            "InovaceClientApp.pages.main.attendanceReport.departmentReport",
            "InovaceClientApp.pages.main.attendanceReport.shiftReport",
            "InovaceClientApp.pages.main.attendanceReport.weeklyReport",
            "InovaceClientApp.pages.main.attendanceReport.dailyReport",
            "InovaceClientApp.pages.main.attendanceReport.leaveReport",
            "InovaceClientApp.pages.main.attendanceReport.leaveHistoryReport",
            "InovaceClientApp.pages.main.attendanceReport.leaveBalanceReport",
            "InovaceClientApp.pages.main.attendanceReport.absentReport",
            "InovaceClientApp.pages.main.attendanceReport.monthlyAbsentReport",
            "InovaceClientApp.pages.main.attendanceReport.dailyAbsentReport",
            "InovaceClientApp.pages.main.attendanceReport.lateReport",
            "InovaceClientApp.pages.main.attendanceReport.dailyLateReport",
            "InovaceClientApp.pages.main.attendanceReport.workingHourReport",
            "InovaceClientApp.pages.main.attendanceReport.pandemicReport",
            "InovaceClientApp.pages.main.attendanceReport.fieldVisitReport",
            "InovaceClientApp.pages.main.attendanceReport.allLogs",
            "InovaceClientApp.pages.main.attendanceReport.mobilePunchReport",
            "InovaceClientApp.pages.main.attendanceReport.locationTrackingReport",
            "InovaceClientApp.pages.main.attendanceReport.unrecognisedLogs",
            "InovaceClientApp.pages.main.attendanceReport.serverRoomOccupancyReport",
            "InovaceClientApp.pages.main.attendanceReport.salaryComparisonSummary",
            "InovaceClientApp.pages.main.attendanceReport.individualSalaryComparison",
            "InovaceClientApp.pages.main.attendanceReport.siteAttendanceReport",
            "InovaceClientApp.pages.main.attendanceReport.siteSummaryReport",
            "InovaceClientApp.pages.main.attendanceReport.individualSalaryComparison",
            "InovaceClientApp.pages.main.attendanceReport.monthOnMonthSalaryComparison",
            // 'InovaceClientApp.pages.main.attendanceReport.dailyParkingReport',
            // 'InovaceClientApp.pages.main.attendanceReport.monthlyParkingReport',
            "InovaceClientApp.pages.main.attendanceReport.individualAttendanceReport",
            "InovaceClientApp.pages.main.attendanceReport.dailyDiningReport",
            "InovaceClientApp.pages.main.attendanceReport.monthlyDiningReport",
            "InovaceClientApp.pages.main.attendanceReport.detailedDiningReport",
            "InovaceClientApp.pages.main.attendanceReport.locationDeviationReport",
        ])
        .config(["$stateProvider", routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state("attendanceReport", {
            url: "/reports",
            abstract: true,
            views: {
                app: {
                    template:
                        '<div ui-view="attendanceReport" autoscroll="true" autoscroll-body-top>&nbsp;</div>',
                },
            },
            parent: "app",
            title: "attendanceReport",
            sidebarMeta: {
                icon: "ion-clipboard",
                order: 50,
            },
            roles: ["LINE_MANAGER", "GROUP_ADMIN"],
            // lineManagerPermitted: true,
            // groupAdminPermitted : true,
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('InovaceClientApp.pages.main.billing', ['ui.router'])
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider.state('billing', {
        url: '/billing',
        parent: 'app', // renders inside main layout
        views: {
          'app': {
            templateUrl: 'app/pages/main/billing/billing.html',
            controller: 'BillingCtrl'
          }
        },
        title: 'Billing',
        roles: ['ADMIN','HR_MANAGER' , 'GENERAL_USER'] // optional, mirrors sidebar
      });
    }]);
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.companies', ['720kb.tooltips'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('companies', {
                url: '/companies',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/companies/companies.html',
                        controller: 'CompaniesCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Company',
                // sidebarMeta: {
                //     icon: 'ion-ios-briefcase',
                //     order: 140
                // }

            });
        $stateProvider
            .state('companyDetails', {
                url: '/companies/:companyId',
                params : {
                    companyId : {
                        squash : false,
                        value : null
                    }
                },
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/companies/companyDetails/companyDetails.html',
                        controller: 'CompanyDetailsCtrl',
                        controllerAs : "vm"
                    }
                },
                title: 'Company Offices'
            });


    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.dashboard',[
            'InovaceClientApp.pages.main.dashboard.attendanceDashboard',
            'InovaceClientApp.pages.main.dashboard.occupancyDashboard'
        ]).config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="dashboard" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent:'app',
                title: 'dashboard',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 25
                },
                // groupAdminPermitted : true,
                // moduleId: 11
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.devices', [
            'InovaceClientApp.pages.main.devices.devicesList',
            'InovaceClientApp.pages.main.devices.deviceDetails',
            'InovaceClientApp.pages.main.devices.allocationHistory'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('devices', {
                url: '/devices',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="devices" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'devices',
                sidebarMeta: {
                    icon : 'ion-ipod',
                    order: 180
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.employees', [
            'InovaceClientApp.pages.main.employees.manageEmployees',
            'InovaceClientApp.pages.main.employees.batchCreateEmployees',
            'InovaceClientApp.pages.main.employees.createEmployee',
            'InovaceClientApp.pages.main.employees.syncExternal',
            'InovaceClientApp.pages.main.employees.fieldVisit'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees', {
                url: '/employees',
                abstract:true,
                views : {
                    'app' : {
                        template: '<div ui-view="employees" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                data:{code:'2001'},
                parent:'app',
                title: 'employees',
                sidebarMeta: {
                    icon : 'ion-person-stalker',
                    order: 70
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                // groupAdminPermitted : false
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.leave',
         [
             'InovaceClientApp.pages.main.leave.leavePolicy',
             'InovaceClientApp.pages.main.leave.leaveCategory',
             'InovaceClientApp.pages.main.leave.leaveCategoryPolicyConfiguration',
             'InovaceClientApp.pages.main.leave.applyLeaveForOthers',
             'InovaceClientApp.pages.main.leave.uploadLeaveBalance'
         ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('leave', {
                url: '/leave',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="leave" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'Leave',
                sidebarMeta: {
                    icon : 'ion-ios-minus-outline',
                    order: 150
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement',[
            'InovaceClientApp.pages.main.membershipManagement.members',
            'InovaceClientApp.pages.main.membershipManagement.membershipDashboard',
            'InovaceClientApp.pages.main.membershipManagement.membershipSettings',
            'InovaceClientApp.pages.main.membershipManagement.subscriptionReport',
            'InovaceClientApp.pages.main.membershipManagement.monthlyReport',
            'InovaceClientApp.pages.main.membershipManagement.dailyReport',
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('membershipManagement', {
                url: '/membership-management',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="membershipManagement" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'Membership Management',
                sidebarMeta: {
                    icon : 'ion-ios-location',
                    // order: 221
                },
                roles: ['ADMIN', 'HR_MANAGER'],
                // data :{code: '12001'},
                // membershipManagementAdminPermitted: true,
                // membershipManagementManagerPermitted: true
            });

    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.notifications', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('notifications', {
                url: '/notifications',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/notifications/notifications.html',
                        controller : 'NotificationsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'notifications.title',
                roles: ['GENERAL_USER'],
                // generalUserPermitted : true
            });
    }

})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.offices', [ ])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('officeDetails', {
                url: '/offices/:officeId',
                params : {
                    officeId : {
                        squash : false,
                        value : null
                    }
                },
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/companies/companyDetails/companyDetails.html',
                        controller: 'CompanyDetailsCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Office',
                sidebarMeta: {
                    icon : 'ion-clipboard',
                    order: 200
                }
            });


    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.overtime',[
            'InovaceClientApp.pages.main.overtime.manageOvertime',
            'InovaceClientApp.pages.main.overtime.overtimeAllocator',
            'InovaceClientApp.pages.main.overtime.overtimeReport',
            'InovaceClientApp.pages.main.overtime.monthlyOvertimeSummary'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('overtime', {
                url: '/overtime',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="overtime" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'overtimeMenu',
                sidebarMeta: {
                    icon : 'ion-clock',
                    order: 200
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement',[
            'InovaceClientApp.pages.main.parkingManagement.liveFeedAndDashboard',
            'InovaceClientApp.pages.main.parkingManagement.vehicles',
            'InovaceClientApp.pages.main.parkingManagement.billSetup',
            'InovaceClientApp.pages.main.parkingManagement.parkingSlotSetup',
            'InovaceClientApp.pages.main.parkingManagement.dailyParkingReport',
            'InovaceClientApp.pages.main.parkingManagement.monthlyParkingReport'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('parkingManagement', {
                url: '/parking-management',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="parkingManagement" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'parkingManagement',
                data :{code: '11101'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll',[
            'InovaceClientApp.pages.main.payroll.salaryManagement',
            'InovaceClientApp.pages.main.payroll.payrollSettings',
            'ngFileUpload',
            'InovaceClientApp.pages.main.payroll.viewOrGenerateSalary',
            'InovaceClientApp.pages.main.payroll.salaryCertificate',
            'InovaceClientApp.pages.main.payroll.salaryComponentUpload',
            'InovaceClientApp.pages.main.payroll.absentOrLeaveWithoutPay',
            'InovaceClientApp.pages.main.payroll.payslip',
            'InovaceClientApp.pages.main.payroll.bankPaymentAdvice',
            'InovaceClientApp.pages.main.payroll.salaryCertificate',
            'InovaceClientApp.pages.main.payroll.salaryComparison',
            'InovaceClientApp.pages.main.payroll.manageBanks',
            'InovaceClientApp.pages.main.payroll.manageBranches',
            'InovaceClientApp.pages.main.payroll.loanManagement',
            'InovaceClientApp.pages.main.payroll.providentFundMember',
            'InovaceClientApp.pages.main.payroll.providentFundStatement',
            'InovaceClientApp.pages.main.payroll.providentFundAccountManagement',

        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll', {
                url: '/payroll',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="payroll" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'Payroll',
                sidebarMeta: {
                    icon : 'ion-cash',
                    order: 221
                },
                data :{code: '10003'},
            });

    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.pendingApprovals', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('pendingApprovals', {
                url: '/pending-approvals',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/pendingApprovals/pendingApprovals.html',
                        controller: 'PendingApprovalsCtrl',
                        controllerAs: "vm"
                    }
                },
                roles: ['GENERAL_USER', 'LINE_MANAGER'],
                // generalUserPermitted : true,
                title: 'pendingApprovals',
                analyticsTitle:'Pending Approvals',
                analyticsHeaderTitle:null,
                sidebarMeta: {
                    icon : 'ion-android-checkmark-circle',
                    order: 170
                },
                // lineManagerPermitted: true
            })
            .state('leaveApplicationDetails', {
                url: '/pending-approvals/leave-application-details',
                params : {
                    leaveLogId : null,
                    applicantId : null,
                    applicantName : null
                },
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/pendingApprovals/leaveApplicationDetails/leaveApplicationDetails.html',
                        controller: 'LeaveApplicationDetailsCtrl',
                        controllerAs: 'vm'
                    }
                },
                roles: ['GENERAL_USER','LINE_MANAGER'],
                // generalUserPermitted : true,
                title: 'leaveApplicationDetails',
                analyticsTitle:'Leave Application Details',
                analyticsHeaderTitle:'Pending Approvals',
                // lineManagerPermitted: true
            });
    }
})();

(function () {
  'use strict';

  angular.module('InovaceClientApp.pages.main.profile', ['ngFileUpload', 'ngImgCrop', 'daterangepicker','ui.bootstrap.datetimepicker','ui.bootstrap'])
      .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('profile', {
                url: '/profile/:employeeId',
                params : {
                    employeeId : {
                        squash : false,
                        value : null,
                        dynamic: true
                    },
                    showTab : {
                        value : null,
                    },
                    scrollTo : {
                        value : null,
                    }
                },
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/profile/profile.html',
                        controller: 'ProfileCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Profile',
                roles: ['GENERAL_USER','LINE_MANAGER'],
                // generalUserPermitted : true,
                // lineManagerPermitted: true,
                analyticsTitle:'Profile',
                analyticsHeaderTitle:null,
                moduleId: 18
            });
    }

})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement',[
            'InovaceClientApp.pages.main.projectManagement.projects',
            'InovaceClientApp.pages.main.projectManagement.tasks',
            'InovaceClientApp.pages.main.projectManagement.teams',
            'InovaceClientApp.pages.main.projectManagement.products',
            'InovaceClientApp.pages.main.projectManagement.projectIssues',
            'InovaceClientApp.pages.main.projectManagement.clients',
            'InovaceClientApp.pages.main.projectManagement.issueCreators'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement', {
                url: '/project-management',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="projectManagement" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'projectManagement',
                sidebarMeta: {
                    icon : 'ion-settings',
                    order: 210
                },
                // data :{code: '10001'},
            });

        $stateProvider
            .state('projectManagement.perDayTimeSheetReport', {
                url: '/timesheet-report',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/perDayTimeSheetReport/report.html',
                        controller : 'TimeSheetReportCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Timesheet Report',
                analyticsTitle:'Timesheet Report',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 140
                },
                roles : ['PROJECT_MANAGER','LINE_MANAGER']
            })

        $stateProvider
            .state('projectManagement.projectWorkHourReport', {
                url: '/project-work-hour-report',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/projectWorkHourReport/report.html',
                        controller : 'ProjectWorkHourReportCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Work Hour Report',
                analyticsTitle:'Work Hour Report',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 143
                },
                roles : ['PROJECT_MANAGER','LINE_MANAGER']
            })

        $stateProvider
            .state('projectManagement.monthlyProjectDedicationReport', {
                url: '/monthly-project-dedication-report',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/monthlyProjectDedication/report.html',
                        controller : 'MonthlyProjectDedicationReportCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Monthly Dedication',
                analyticsTitle:'Monthly Dedication Report',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 144
                },
                roles : ['PROJECT_MANAGER','LINE_MANAGER']
            })

        $stateProvider
            .state('projectManagement.projectGanttChart', {
                url: '/project-gantt-chart',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/projectGanttChart/report.html',
                        controller : 'ProjectGanttChartReportCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Gantt Chart Projects',
                analyticsTitle:'Gantt Chart Projects',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 145
                },
                roles : ['PROJECT_MANAGER','LINE_MANAGER']
            })

        $stateProvider
            .state('projectManagement.peopleGanttChart', {
                url: '/people-gantt-chart',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/peopleGanttChart/report.html',
                        controller : 'PeopleGanttChartReportCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Gantt Chart People',
                analyticsTitle:'Gantt Chart People',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 146
                },
                roles : ['PROJECT_MANAGER','LINE_MANAGER']
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings',[
            'InovaceClientApp.pages.main.settings.susidiaries',
            'InovaceClientApp.pages.main.settings.departments',
            'InovaceClientApp.pages.main.settings.subDepartments',
            'InovaceClientApp.pages.main.settings.designations',
            'InovaceClientApp.pages.main.settings.employmentType',
            'InovaceClientApp.pages.main.settings.workplaces',
            'InovaceClientApp.pages.main.settings.holidays',
            'InovaceClientApp.pages.main.settings.mobilePunch',
            'InovaceClientApp.pages.main.settings.geofencing',
            'InovaceClientApp.pages.main.settings.locationTrackingAccessSettings',
            'InovaceClientApp.pages.main.settings.notification',
            'InovaceClientApp.pages.main.settings.accessArea',
            'InovaceClientApp.pages.main.settings.approvals',
            'InovaceClientApp.pages.main.settings.specialDays'
            // 'InovaceClientApp.pages.main.settings.weeklyOffDayPolicy'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings', {
                url: '/settings',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="settings" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'settings',
                sidebarMeta: {
                    icon : 'ion-settings',
                    order: 90
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.shiftManagement',[
            'InovaceClientApp.pages.main.shiftManagement.shiftGroups',
            'InovaceClientApp.pages.main.shiftManagement.shifts',
            'InovaceClientApp.pages.main.shiftManagement.roster',
            'InovaceClientApp.pages.main.shiftManagement.dynamicShiftGroups'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('shiftManagement', {
                url: '/shift-management',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="shiftManagement" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'shiftManagement',
                sidebarMeta: {
                    icon : 'ion-clock',
                    order: 100
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.siteManagement',[
            'InovaceClientApp.pages.main.siteManagement.siteManagementDashboard',
            'InovaceClientApp.pages.main.siteManagement.manageSites',
            'InovaceClientApp.pages.main.siteManagement.siteAttendanceReport',
            'InovaceClientApp.pages.main.siteManagement.siteSummaryReport',
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('siteManagement', {
                url: '/site-management',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="siteManagement" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'Site Management',
                sidebarMeta: {
                    icon : 'ion-ios-location',
                    // order: 221
                },
                roles: ['SITE_MANAGEMENT_ADMIN', 'SITE_MANAGEMENT_MANAGER'],
                data :{code: '12001'},
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: true
            });

    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.sms', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('sms', {
                url: '/sms',
                parent : 'app',
                data:{code:'9008'},
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/sms/sms.html',
                        controller: 'SmsCtrl',
                        controllerAs: "vm"
                    }
                },
                // generalUserPermitted : true,
                code:9008,
                title: 'sms',
                sidebarMeta: {
                    icon : 'ion-android-checkmark-circle',
                    order: 220
                },
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement',[
            'InovaceClientApp.pages.main.visitorManagement.createAppointment',
            'InovaceClientApp.pages.main.visitorManagement.editAppointment',
            'InovaceClientApp.pages.main.visitorManagement.visitorCategory',
            'InovaceClientApp.pages.main.visitorManagement.manageCard',
            'InovaceClientApp.pages.main.visitorManagement.assignRole',
            'InovaceClientApp.pages.main.visitorManagement.visitPurpose',
            // 'InovaceClientApp.pages.main.visitorManagement.accessArea',
            'InovaceClientApp.pages.main.visitorManagement.myVisitorProfile',
            'InovaceClientApp.pages.main.visitorManagement.appointmentLog',
            'InovaceClientApp.pages.main.visitorManagement.reception'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement', {
                url: '/visitor-management',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="visitorManagement" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'visitorManagement',
                data :{code: '11001'}
            });
    }
})();
(function(){
    'use strict';

    angular.module('InovaceClientApp.pages.auth.login', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('login', {
                url : '/login',
                params : {
                    prevState : null
                },
                parent : 'public',
                views : {
                    'pub@public' : {
                        templateUrl : 'app/pages/auth/login/login.html',
                        controller : 'LoginCtrl'
                    }
                },
                title : 'Login',
                analyticsTitle: 'Tipsoi - HR Management',
                roles: ['GENERAL_USER','LINE_MANAGER'],
                // generalUserPermitted : true,
                // lineManagerPermitted: true
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.absentReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.absentReport', {
                url: '/absentReport',
                data:{code:'4017'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/absentReport/absentReport.html',
                        controller: 'AbsentReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'absentReport',
                sidebarMeta: {
                    order: 58
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 1
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.allLogs', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.allLogs', {
                url: '/all-logs',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/allLogs/allLogs.html',
                        controller: 'AllLogsCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'All Logs',
                analyticsTitle: 'All Logs',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 81
                },
                params: {
                    officeId: null
                },
                data :{code: '4023'},
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyLateReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.dailyLateReport', {
                url: '/daily-late-attendance',
                data:{code:'4017'},
                params: {
                    attDateInMillis: null,
                    employmentTypeIds: null,
                    subsidiaryIds: null,
                    workplaceIds: null
                },
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/dailyLateReport/dailyLateReport.html',
                        controller: 'DailyLateReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Daily Late Report',
                analyticsTitle: 'Daily Late Attendance',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 60
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 5
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.dailyReport', {
                url: '/daily-attendance',
                data:{code: null},
                params: {
                    checkedAttendanceStatus: null,
                    attDateInMillis: null,
                    employmentTypeIds: null,
                    subsidiaryIds: null,
                    workplaceIds: null
                },
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/dailyReport/dailyReport.html',
                        controller: 'DailyReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'dailyReport',
                analyticsTitle:'Daily Attendance',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 56
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 2
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.departmentReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('attendanceReport.departmentReport', {
                url: '/department-attendance',
                data: {code: '4016'},
                views: {
                    'attendanceReport': {
                        templateUrl: 'app/pages/main/attendanceReport/departmentReport/departmentReport.html',
                        controller: 'DepartmentReportCtrl',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    departmentId: null,
                    attDateInMillis: null,
                    employmentTypeIds: null,
                    subsidiaryIds: null,
                    workplaceIds: null
                },
                title: 'departmentReport',
                analyticsTitle:'Department Attendance',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 52
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 3
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedAttendanceReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.detailedAttendanceReport', {
                url: '/detailed-attendance',
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/detailed/attendance-page-root.html',
                        controller: 'AttendanceReportRootCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'detailedAttendanceReport',
                analyticsTitle: 'Detailed Attendance',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 51
                },
                params: {
                    officeId: null
                },
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted : true,
                moduleId: 4
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedMonthlyReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.detailedMonthlyReport', {
                url: '/detailed-monthly-attendance',
                data:{code:'4015'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/detailedMonthlyReport/detailedMonthlyReport.html',
                        controller: 'DetailedMonthlyReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'detailedMonthlyReport',
                analyticsTitle: 'Detailed Monthly Attendance',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 54
                },
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted:true,
                moduleId: 7
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.fieldVisitReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.fieldVisitReport', {
                url: '/field-visit',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/fieldVisitReport/fieldVisitReport.html',
                        controller: 'FieldVisitReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'fieldVisitReport',
                analyticsTitle: 'Field Visit',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 80
                },
                params: {
                    officeId: null
                },
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.individualAttendanceReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.individualAttendanceReport', {
                url: '/individual-attendance',
                data:{code:'4015'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/individualAttendanceReport/individualAttendanceReport.html',
                        controller: 'IndividualAttendanceReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Attendance Report',
                analyticsTitle: 'Individual Attendance',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 56
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 2
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.lateReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.lateReport', {
                url: '/late-attendance',
                data:{code:'4017'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/lateReport/lateReport.html',
                        controller: 'LateReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'lateReport',
                analyticsTitle: 'Late Attendance',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 59
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 5
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.leaveReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.leaveReport', {
                url: '/leaveReport',
                data:{code:'4018'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/leaveReport/leaveReport.html',
                        controller: 'LeaveReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'leaveReport',
                sidebarMeta: {
                    order: 57
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 6
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.locationDeviationReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('attendanceReport.locationDeviationReport', {
                url: '/location-deviation',
                views: {
                    'attendanceReport': {
                        templateUrl: 'app/pages/main/attendanceReport/locationDeviationReport/locationDeviationReport.html',
                        controller: 'LocationDeviationReportCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'locationDeviationReport',
                analyticsTitle: 'Location Deviation Report',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 52
                },
                params: {
                    officeId: null
                },
                roles: ['ADMIN', 'LINE_MANAGER', 'GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted : true,
                moduleId: 4026
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.locationTrackingReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.locationTrackingReport', {
                url: '/location-tracking-report',
                data:{code:'9007'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/locationTrackingReport/locationTrackingReport.html',
                        controller: 'LocationTrackingReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Location Tracking Report',
                analyticsTitle: 'Location Tracking',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 82
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                params: {
                    officeId: null
                }
                // data :{code: '4023'},
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.mobilePunchReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.mobilePunchReport', {
                url: '/mobile-punch',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/mobilePunchReport/mobilePunchReport.html',
                        controller: 'MobilePunchReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Mobile Punch Report',
                analyticsTitle: 'Mobile Punch',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 82
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                params: {
                    officeId: null
                }
                // data :{code: '4023'},
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthlyReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.monthlyReport', {
                url: '/monthly-attendance',
                data:{code:'4015'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/monthlyReport/monthlyReport.html',
                        controller: 'MonthlyReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'monthlyReport',
                analyticsTitle: 'Monthly Attendance',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 54
                },
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted:true,
                moduleId: 7
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.pandemicReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.pandemicReport', {
                url: '/pandemic',
                data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/pandemicReport/pandemicReport.html',
                        controller: 'PandemicReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'pandemicReport',
                analyticsTitle: 'Pandemic',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 70
                },
                params: {
                    officeId: null
                },
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.serverRoomOccupancyReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.serverRoomOccupancyReport', {
                url: '/server-room-occupancy',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/serverRoomOccupancyReport/serverRoomOccupancyReport.html',
                        controller: 'ServerRoomOccupancyReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Occupancy Report',
                analyticsTitle:'Server Room Occupancy',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 82
                },
                params: {
                    officeId: null
                },
                data :{code: '4024'},
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.shiftReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.shiftReport', {
                url: '/shift',
                data:{code:'4016'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/shiftReport/shiftReport.html',
                        controller: 'ShiftReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'shiftReport',
                analyticsTitle:'Shift',
                analyticsHeaderTitle:'Reports',
                // sidebarMeta: {
                //     order: 53
                // },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 8
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.siteAttendanceReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.siteAttendanceReport', {
                url: '/siteAttendanceReport',
                data:{code:'12001'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/siteAttendanceReport/siteAttendanceReport.html',
                        controller: 'SiteAttendanceReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'siteAttendanceReport',
                sidebarMeta: {
                    // order: 54
                },
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted:true,
                moduleId: 7
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.siteSummaryReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.siteSummaryReport', {
                url: '/siteSummaryReport',
                data: {code:'12001'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/siteSummaryReport/siteSummaryReport.html',
                        controller: 'SiteSummaryReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'siteSummaryReport',
                sidebarMeta: {
                    // order: 56
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: null
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.unrecognisedLogs', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.unrecognisedLogs', {
                url: '/unauthorised-logs',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/unrecognisedLogs/unrecognisedLogs.html',
                        controller: 'UnrecognisedLogsCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Unauthorised Logs',
                analyticsTitle:'Unauthorised Logs',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 83
                },
                params: {
                    officeId: null
                },
                data :{code: '4023'},
                // moduleId: 109
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.weeklyReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.weeklyReport', {
                url: '/weeklyReport',
                data:{
                  code:'4015',
                },
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/weeklyReport/weeklyReport.html',
                        controller: 'WeeklyReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'weeklyReport',
                // sidebarMeta: {
                //     order: 55
                // },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 9
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.workingHourReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.workingHourReport', {
                url: '/working-hour',
                data:{code:'4016'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/workingHourReport/workingHourReport.html',
                        controller: 'WorkingHourReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'workingHourReport',
                analyticsTitle:'Working Hour',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 60
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 10
            });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard.attendanceDashboard', [
        'easypiechart',
        'ui.carousel',
        'ngAnimate',
    ]).config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.attendanceDashboard', {
                url: '/attendance',
                views : {
                    'dashboard' : {
                        templateUrl: 'app/pages/main/dashboard/dashboard-root.html',
                        controller : 'DashboardCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Attendance',
                analyticsTitle: 'Tipsoi - Dashboard',
                analyticsHeaderTitle: null,
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 25
                },
                roles: ['GROUP_ADMIN'],
                // groupAdminPermitted : true,
                moduleId: 11
            });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard.occupancyDashboard', [
    ]).config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.occupancyDashboard', {
                url: '/occupancy',
                views : {
                    'dashboard' : {
                        templateUrl: 'app/pages/main/dashboard/occupancyDashboard/occupancyDashboard.html',
                        controller : 'OccupancyDashboardCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Occupancy',
                analyticsTitle: 'Tipsoi - Occupancy Dashboard',
                analyticsHeaderTitle: null,
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 30
                },
                data : {
                    code: '1008'
                }
            });
    }

})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.devices.allocationHistory', [
            'smart-table'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('devices.allocationHistory', {
                url: '/allocation-history',
                views : {
                    'devices' : {
                        templateUrl: 'app/pages/main/devices/allocationHistory/allocationHistory.html',
                        controller: 'AllocationHistoryCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'allocationHistory',
                // sidebarMeta: {
                //     icon : 'ion-ipod',
                //     order: 200
                // },
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.devices.devicesList', [
            'smart-table'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('devices.devicesList', {
                url: '/list',
                views : {
                    'devices' : {
                        templateUrl: 'app/pages/main/devices/devicesList/devices.html',
                        controller: 'DeviceCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'deviceList',
                analyticsTitle:'Device List',
                analyticsHeaderTitle:'Devices',
                sidebarMeta: {
                    icon : 'ion-ipod',
                    order: 190
                },
                moduleId: 12
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.employees.batchCreateEmployees',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees.batchCreateEmployees', {
                url: '/batch-create-employees',
                views : {
                    'employees' : {
                        templateUrl:'app/pages/main/employees/batchCreate/batchCreateEmployees.html',
                        controller : 'BatchCreateEmployeesCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'createBatch',
                analyticsTitle:'Batch Create Employees',
                analyticsHeaderTitle:'Employees',
                sidebarMeta: {
                    order: 78
                },
                moduleId: 16
            })
            .state('employees.verifyBatchCreate', {
                url: '/batch-create-employees/verify',
                params : {
                    file : null,
                    payrollAvailable : null,
                    payrollType : null
                },
                views : {
                    'employees' : {
                        templateUrl:'app/pages/main/employees/batchCreate/uploadConfirmation/uploadConfirmation.html',
                        controller : 'UploadConfirmationCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Employee Batch Create Confirmation',
                analyticsTitle:'Batch Create Employees Verify',
                analyticsHeaderTitle:'Employees',
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.employees.createEmployee',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees.createEmployeeSingle', {
                url: '/create-single-employee',
                views : {
                    'employees' : {
                        templateUrl:'app/pages/main/employees/manage/create/createEmployee.html',
                        controller : 'EmployeeCreateCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Create Employee',
                analyticsTitle:'Create An Employee ',
                analyticsHeaderTitle:'Employees',
                sidebarMeta: {
                    order: 76
                },
                moduleId: 14
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.employees.fieldVisit',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees.fieldVisit', {
                url: '/field-visit',
                views : {
                    'employees' : {
                        templateUrl:'app/pages/main/employees/fieldVisit/fieldVisit.html',
                        controller : 'EmployeeFieldVisitCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Field Visit',
                analyticsTitle:'Field Visit',
                analyticsHeaderTitle:'Employees',
                sidebarMeta: {
                    order: 90
                }
            })
            .state('employees.applyFieldVisit',{
                url: '/apply-field-visit',
                views : {
                    'employees' :{
                        templateUrl : 'app/pages/main/employees/fieldVisit/apply/applyFieldVisit.html',
                        controller : 'ApplyFieldVisitCtrl',
                        controllerAs : 'vm',
                    }
                },
                title: 'Field Visit',
                analyticsTitle:'Apply Field Visit',
                analyticsHeaderTitle:'Employees',
            });
    }
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.employees.manageEmployees', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees.manageEmployees', {
                url: '/manage-employees',
                views : {
                    'employees' : {
                        templateUrl: 'app/pages/main/employees/manage/employees.html',
                        controller: 'EmployeesCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'manageEmployees',
                analyticsTitle:'Manage Employees',
                analyticsHeaderTitle:'Employees',
                sidebarMeta: {
                    order: 75
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true
            });

        $stateProvider
            .state('createEmployee', {
                url: '/manage/employees/create-employee',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/employees/manage/create/createEmployee.html',
                        controller : 'EmployeeCreateCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Create Employee',
                analyticsTitle:'Create Employee',
                analyticsHeaderTitle:'Employees',

                moduleId: 14
            });

        $stateProvider.state('employeeActions', {
                url: '/manage/employees/employee-actions',
                params : {
                    selectedEmployees : {
                        squash : false,
                        value : null
                    },
                    notSelectedEmployees : {
                        squash : false,
                        value : null
                    },
                    allSelected : false,
                },
                title : 'Employee Actions',
                analyticsTitle:'Employee Actions',
                analyticsHeaderTitle:'Employees',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/employees/manage/actions/employeeActions.html',
                        controller : 'EmployeeActionsCtrl',
                        controllerAs : 'vm'
                    }
                },
            moduleId: 15,
            roles: ['LINE_MANAGER'],
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.employees.syncExternal',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees.syncExternal', {
                url: '/sync-external',
                views : {
                    'employees' : {
                        templateUrl:'app/pages/main/employees/syncExternal/syncExternal.html',
                        controller : 'SyncExternalCtrl',
                        controllerAs : 'vm'
                    }
                },
                data :{code: '10000'},
                title: 'Sync External',
                analyticsTitle:'Sync External',
                analyticsHeaderTitle:'Employees',
                sidebarMeta: {
                    order: 80
                }
            });
    }
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.leave.applyLeaveForOthers',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('leave.applyLeaveForOthers', {
                url: '/apply-leave',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/applyLeaveForOthers/applyLeaveForOthers.html',
                        controller : 'ApplyLeaveForOthersCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Apply Leave',
                analyticsTitle:'Apply Leave',
                analyticsHeaderTitle:'Leave',
                sidebarMeta: {
                    order: 181
                }
            })
            .state('leave.applyLeaveForEmployees',{
                url: '/apply-leave-application',
                views : {
                    'leave' :{
                        templateUrl : 'app/pages/main/leave/applyLeaveForOthers/applyLeaveForEmployees/applyLeaveForEmployees.html',
                        controller : 'ApplyLeaveForEmployeesCtrl',
                        controllerAs : 'vm',
                    }
                },
                title: ' Apply Leave',
                analyticsTitle:'Apply Leave Application For Others',
                analyticsHeaderTitle:'Leave',
            });
    }
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.leave.leaveCategory', ['xeditable'])
        .config(['$stateProvider', routeConfig])
        .run(['editableOptions', function(editableOptions) {
            editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
        }]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('leave.leaveCategory', {
                url: '/leave-category',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/leaveCategory/leaveCategory.html',
                        controller:'LeavePolicyCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'leaveCategories',
                analyticsTitle:'Leave Categories',
                analyticsHeaderTitle:'Leave',
                sidebarMeta: {
                    order: 160
                },
                moduleId: 17
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.leave.leaveCategoryPolicyConfiguration', ['xeditable'])
        .config(['$stateProvider', routeConfig])
        .run(['editableOptions', function(editableOptions) {
            editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
        }]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('leave.leaveCategoryPolicyConfiguration', {
                url: '/leave-category-policy-configuration',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/leaveCategoryPolicyConfiguration/leaveCategoryPolicyConfiguration.html',
                        controller:'LeaveCategoryPolicyConfigurationCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Configuration',
                analyticsTitle:'Configuration',
                analyticsHeaderTitle:'Leave',
                sidebarMeta: {
                    order: 180
                },
                moduleId: 17
            })

            .state('leave.createLeaveCategoryPolicyConfiguration', {
                url :'/leave-category-policy-configuration/create',
                views : {
                    'leave' : {
                        templateUrl: 'app/pages/main/leave/leaveCategoryPolicyConfiguration/create/createConfiguration.html',
                        controller: 'CreateConfigurationCtrl',
                        controllerAs:'vm'
                    }
                },
                title : 'Create New Configuration',
                analyticsTitle:'Create New Configuration',
                analyticsHeaderTitle:'Leave',
                moduleId : 17
            })

            .state('leave.configurationDetails', {
                url:'/leave-category-policy-configuration/leavePolicy/:leavePolicyId',
                params : {
                    leavePolicyId : {
                        squash : false,
                        value : null
                    }
                },
                views : {
                    'leave' : {
                        templateUrl: 'app/pages/main/leave/leaveCategoryPolicyConfiguration/edit/editConfiguration.html',
                        controller: 'EditConfigurationCtrl',
                        controllerAs:'vm'
                    }
                },
                title : 'Configuration Details',
                analyticsTitle:'Edit Configuration Details',
                analyticsHeaderTitle:'Leave',
                moduleId : 17
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.leave.leavePolicy', ['xeditable'])
        .config(['$stateProvider', routeConfig])
        .run(['editableOptions', function(editableOptions) {
            editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
        }]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('leave.leavePolicy', {
                url: '/leave-policy',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/leavePolicy/leavePolicy.html',
                        controller:'LeavePolicyCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'leavePolicy',
                analyticsTitle:'Leave Policy',
                analyticsHeaderTitle:'Leave',
                sidebarMeta: {
                    order: 170
                },
                moduleId: 17
            });


    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.leave.uploadLeaveBalance',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('leave.uploadLeaveBalance', {
                url: '/upload-leave-balance',
                views : {
                    'leave' : {
                        templateUrl:'app/pages/main/leave/uploadLeaveBalance/uploadLeaveBalance.html',
                        controller : 'UploadLeaveBalanceCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted:true,
                title: 'Upload Leave Balance',
                analyticsTitle:'Upload Leave Balance',
                analyticsHeaderTitle:'Leave',
                sidebarMeta: {
                },
                moduleId: 17
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement.members', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('membershipManagement.members', {
                url: '/members',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/members/members.html',
                        controller: 'MembersCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Membership Management',
                data: {code: '13001'},
                analyticsTitle:'Members',
                analyticsHeaderTitle:'Membership Management',
            })
            .state('membershipManagement.createMember', {
                url: '/members/create',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/members/create/createMember.html',
                        controller: 'CreateMemberCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Membership Management',
                analyticsTitle:'Add New Member',
                analyticsHeaderTitle:'Membership Management',
            })
            .state('membershipManagement.editMember', {
                url: '/members/edit/:memberId',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/members/edit/editMember.html',
                        controller: 'EditMemberCtrl',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    memberId:null
                },
                title: 'Membership Management',
                analyticsTitle:'Edit Member',
                analyticsHeaderTitle:'Membership Management',
            })
            .state('membershipManagement.upgrade', {
                url: '/members/upgrade/:subscriptionId',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/members/upgrade/upgradePackage.html',
                        controller: 'UpgradePackageCtrl',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    memberInfo:null,
                    memberName:null,
                },
                title: 'Membership Management',
                analyticsTitle:'Upgrade Package',
                analyticsHeaderTitle:'Membership Management',
            })
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement.membershipDashboard', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('membershipManagement.membershipDashboard', {
                url: '/dashboard',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/membershipDashboard/membershipDashboard.html',
                        controller: 'MembershipDashboardCtrl',
                        controllerAs: 'vm'
                    }
                },
                // title: 'Membership Dashboard',
                analyticsTitle:'Dashboard',
                analyticsHeaderTitle:'Membership Management',
                data: {code: '13001'},
            })
            // .state('membershipManagement.create', {
            //     url: '/members/create',
            //     views: {
            //         'membershipManagement': {
            //             templateUrl: 'app/pages/main/membershipManagement/members/create/createVehicle.html',
            //             controller: 'CreateVehicleCtrl',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     title: 'Membership Management'
            // })
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement.membershipSettings', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('membershipManagement.membershipSettings', {
                url: '/settings',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/membershipSettings/membershipSettings.html',
                        controller: 'MembershipsSettingsCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Membership Settings',
                data: {code: '13001'},
                analyticsTitle:'Settings',
                analyticsHeaderTitle:'Membership Management',
            })
            .state('membershipManagement.create', {
                url: '/settings/create-package',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/membershipSettings/create/createPackage.html',
                        controller: 'CreatePackageCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Create Package',
                analyticsTitle:'Create Membership Package',
                analyticsHeaderTitle:'Membership Management',
            })
            .state('membershipManagement.edit', {
                url: '/settings/edit-package/:id',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/membershipSettings/edit/editPackage.html',
                        controller: 'EditPackageCtrl',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    packageInfo: null
                },
                title: 'Edit Package',
                analyticsTitle:'Edit Membership Package',
                analyticsHeaderTitle:'Membership Management',
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.overtime.manageOvertime', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('overtime.manage',
                {
                    url: '/overtime/manage',
                    views : {
                        'overtime' : {
                            templateUrl: 'app/pages/main/overtime/manageOvertime/manageOvertime.html',
                            controller:'ManageOvertimeCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Manage Overtime',
                    // sidebarMeta: {
                    //     order: 203
                    // },
                    roles: ['LINE_MANAGER'],
                    // lineManagerPermitted: true,
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.overtime.monthlyOvertimeSummary', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('overtime.monthlyOvertimeSummary', {
                url: '/monthly-overtime-summary',
                views : {
                    'overtime' : {
                        templateUrl: 'app/pages/main/overtime/monthlyReport/monthlyOvertimeSummary.html',
                        controller: 'MonthlyOvertimeSummaryCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'overtimeMonthlySummary',
                analyticsTitle:'Monthly Summary',
                analyticsHeaderTitle:'Overtime Menu',
                sidebarMeta: {
                    order: 65
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.overtime.overtimeAllocator', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('overtime.allocator',
                {
                    url: '/overtime-allocator',
                    views : {
                        'overtime' : {
                            templateUrl: 'app/pages/main/overtime/overtimeAllocator/table/overtimeAllocatorTable.html',
                            controller:'OvertimeAllocatorTableCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'overtimeAllocator',
                    analyticsTitle:'Overtime Allocator',
                    analyticsHeaderTitle:'Overtime Menu',
                    sidebarMeta: {
                        order: 205
                    },
                    roles: ['LINE_MANAGER'],
                    // lineManagerPermitted: true,
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.overtime.overtimeReport', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('overtime.report',
                {
                    url: '/overtime-report',
                    views : {
                        'overtime' : {
                            templateUrl: 'app/pages/main/overtime/overtimeReport/table/overtimeReportTable.html',
                            controller:'OvertimeReportTableCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'overtimeReport',
                    analyticsTitle:'Overtime Report',
                    analyticsHeaderTitle:'Overtime Menu',
                    sidebarMeta: {
                        order: 205
                    },
                    roles: ['LINE_MANAGER'],
                    // lineManagerPermitted: true,
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement.liveFeedAndDashboard',['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('parkingManagement.liveFeedAndDashboard', {
                url: '/live-feedback-and-dashboard',
                views : {
                    'parkingManagement' : {
                        templateUrl:'app/pages/main/parkingManagement/liveFeedAndDashboard/liveFeedAndDashboard.html',
                        controller : 'LiveFeedAndDashboardCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PARKING_OPERATIONS_MANAGER'],
                // parkingOperationsManagerPermitted: true,
                title: 'Live Feed & Dashboard',
                analyticsTitle:'Live Feedback And Dashboard',
                analyticsHeaderTitle:'Parking Management',
                data :{code: '11101'},
            })
            .state('parkingManagement.enterVehicle', {
                url: '/vehicle-entry',
                views : {
                    'parkingManagement' : {
                        templateUrl:'app/pages/main/parkingManagement/liveFeedAndDashboard/enterVehicle/enterVehicle.html',
                        controller : 'EnterVehicleCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PARKING_OPERATIONS_MANAGER'],
                // parkingOperationsManagerPermitted: true,
                title: 'Parking Management',
                analyticsTitle:'Vehicle Entry',
                analyticsHeaderTitle:'Parking Management',
                data :{code: '11101'},
        })
            .state('parkingManagement.exitVehicle', {
                url: '/exit-vehicle/:summaryId',

                views : {
                    'parkingManagement' : {
                        templateUrl:'app/pages/main/parkingManagement/liveFeedAndDashboard/exitVehicle/exitVehicle.html',
                        controller : 'ExitVehicleCtrl',
                        controllerAs : 'vm'
                    }
                },
                params:{
                    summaryId: null
                },
                roles: ['PARKING_OPERATIONS_MANAGER'],
                // parkingOperationsManagerPermitted: true,
                title: 'Parking Management',
                analyticsTitle:'Exit Vehicle',
                analyticsHeaderTitle:'Parking Management',
                data :{code: '11101'},
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement.parkingSlotSetup', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('parkingManagement.parkingSlotSetup', {
                url: '/parking-slot-setup',
                views: {
                    'parkingManagement': {
                        templateUrl: 'app/pages/main/parkingManagement/parkingSlotSetup/parkingSlotSetup.html',
                        controller: 'ParkingSlotSetCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Parking Management',
                analyticsTitle:'Parking Slot Setup',
                analyticsHeaderTitle:'Parking Management',
                data: {code: '11101'},
            })
            .state('parkingManagement.parkingSlotSetupCreate', {
                url: '/parking-slot-setup/create',
                views: {
                    'parkingManagement': {
                        templateUrl: 'app/pages/main/parkingManagement/parkingSlotSetup/create/createParkingSlotSetup.html',
                        controller: 'CreateParkingSlotSetupCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Parking Management',
                analyticsTitle:'Create Parking Slot Setup',
                analyticsHeaderTitle:'Parking Management',
                data: {code: '11101'},
            })
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement.vehicles', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('parkingManagement.vehicles', {
                url: '/vehicles',
                views: {
                    'parkingManagement': {
                        templateUrl: 'app/pages/main/parkingManagement/vehicles/vehicles.html',
                        controller: 'VehiclesCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Parking Management',
                analyticsTitle:'Vehicle List',
                analyticsHeaderTitle:'Parking Management',
                data: {code: '11101'},
            })
            .state('parkingManagement.create', {
                url: '/vehicles/create',
                views: {
                    'parkingManagement': {
                        templateUrl: 'app/pages/main/parkingManagement/vehicles/create/createVehicle.html',
                        controller: 'CreateVehicleCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Parking Management',
                analyticsTitle:'Register New Vehicle',
                analyticsHeaderTitle:'Parking Management',
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.salaryComparison',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.salaryComparison', {
                url: '/salaryComparison',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/comparisonReport/comparisonReport.html',
                        controller : 'ComparisonReportCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'Salary Summary',
                sidebarMeta: {
                    order: 226
                },
                data :{code: '10003'},
            });

    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.loanManagement',['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.loanManagement', {
                url: '/loan-management',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/loanManagement/loanManagement.html',
                        controller : 'LoanManagementCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'Loan Management',
                analyticsTitle:'Loan Management',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 224
                },
                data :{code: '10003'},
            })
            .state('payroll.addNewLoanOrSalaryAdvanceType', {
            url: '/loan-management/add-new-loan-or-advance-salary',
                params : {
                    selectedLoanType: null
                },
            views : {
                'payroll' : {
                    templateUrl:'app/pages/main/payroll/loanManagement/loanOrSalaryAdvanceInput/addNewLoanOrSalaryAdvanceType.html',
                    controller : 'AddNewLoanOrSalaryAdvanceTypeCtrl',
                    controllerAs : 'vm'
                }
            },
            roles: ['PAYROLL_MANAGER'],
            // payrollManagerPermitted : true,
            // payrollApproverPermitted : false,
            title: 'Loan/Advance Salary Input',
            analyticsTitle:'Loan Management - Add New Loan Or Advanced Salary Type',
            analyticsHeaderTitle:'Payroll',
        })
            .state('payroll.editLoanOrSalaryDetails', {
                url: '/loan-management/edit-loan-or-advanced-salary',
                params : {
                    employeeInfo: null
                },
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/loanManagement/partials/editLoanOrSalaryDetails/editLoanOrSalaryDetails.html',
                        controller : 'EditLoanOrSalaryDetailsCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Loan/Advance Salary Input',
                analyticsTitle:'Loan Management - Edit Loan/Advance Salary',
                analyticsHeaderTitle:'Payroll',
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.payrollSettings',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.payrollSettings', {
                url: '/payroll-settings',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/payrollSettings/payrollSettings.html',
                        controller : 'PayrollSettingsCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Payroll Settings',
                analyticsTitle:'Payroll Settings',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 222,
                    icon : 'ion-cash'
                },
                data :{code: '10003'},
            })
            .state('payroll.salaryComponentSettings', {
            url: '/payroll-settings/add-new-salary-component',
            params : {
                settingsId: null
            },
            views : {
                'payroll' : {
                    templateUrl:'app/pages/main/payroll/payrollSettings/salaryComponentSettings/salaryComponentSettings.html',
                    controller : 'SalaryComponentSettingsCtrl',
                    controllerAs : 'vm'
                }
            },
            roles: ['PAYROLL_MANAGER'],
            // payrollManagerPermitted : true,
            // payrollApproverPermitted : false,
            title: 'Salary Component Settings',
            analyticsTitle:'Add New Salary Component Settings',
            analyticsHeaderTitle:'Payroll',
        })
        .state('payroll.editPayrollComponent', {
            url: '/payroll-settings/edit-payroll-component/:componentId',
            params : {
                componentId: null
            },
            views : {
                'payroll' : {
                    templateUrl:'app/pages/main/payroll/payrollSettings/editPayrollComponent/editPayrollComponents.html',
                    controller : 'EditPayrollComponentsCtrl',
                    controllerAs : 'vm'
                }
            },
            roles: ['PAYROLL_MANAGER'],
            // payrollManagerPermitted : true,
            // payrollApproverPermitted : false,
            title: 'Salary Component Settings',
            analyticsTitle:'Edit Salary Component Settings',
            analyticsHeaderTitle:'Payroll',
        });

    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.payslip',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.payslip', {
                url: '/payslip',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/payslip/payslip.html',
                        controller : 'PayslipCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'Payslip',
                analyticsTitle:'Payslip',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                },
                data :{},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.salaryCertificate',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.salaryCertificate', {
                url: '/salary-certificate',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/salaryCertificate/salaryCertificate.html',
                        controller : 'SalaryCertificateCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'Salary Certificate',
                analyticsTitle:'Salary Certificate',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 226
                },
                data :{code: '10003'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.salaryManagement',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.salaryManagement', {
                url: '/salary-management',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/salaryManagement/salaryManagement.html',
                        controller : 'SalaryManagementCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Salary Management',
                analyticsTitle:'Salary Management',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 223
                },
                data :{code: '10003'},
            })
            .state('payroll.batchUpload', {
                url: '/batch-upload-confirmation',
                params : {
                    file : null,
                    payrollType : null
                },
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/salaryManagement/batchUploadConfirmation/batchUploadConfirmation.html',
                        controller : 'BatchUploadConfirmationCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Payroll Upload Confirmation',
                analyticsTitle:'Payroll Upload Confirmation',
                analyticsHeaderTitle:'Payroll',
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary',['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.viewOrGenerateSalary', {
                url: '/view-or-generate-salary',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/viewOrGenerateSalary/viewOrGenerateSalary.html',
                        controller : 'ViewOrGenerateSalaryCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'View/Generate Salary',
                analyticsTitle:'View/Generate Salary',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 224
                },
                data :{code: '10003'},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.clients',['uiSwitch',])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.clients', {
                url: '/clients',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/clients/clients.html',
                        controller : 'ClientsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Clients',
                analyticsTitle: 'Clients',
                analyticsHeaderTitle:'Client Management',
                sidebarMeta: {
                    order: 162
                },
                roles: ['PROJECT_MANAGER', 'GENERAL_USER']
            })
            .state('projectManagement.createProjectClient', {
                url: '/clients/create',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/clients/create/createProjectClient.html',
                        controller : 'CreateProjectClientCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Clients',
                analyticsTitle:'Create New Client',
                analyticsHeaderTitle:'Client Management',
                roles: ['PROJECT_MANAGER']
            })
            .state('projectManagement.editProjectClient', {
                url: '/clients/edit',
                params : {
                    clientDetails: null
                },
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/clients/edit/editProjectClient.html',
                        controller : 'EditProjectClientCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Clients',
                analyticsTitle:'Edit Client',
                analyticsHeaderTitle:'Client Management',
                    roles: ['PROJECT_MANAGER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.issueCreators',['uiSwitch',])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.issueCreators', {
                url: '/issue-creators',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/issueCreators/issueCreators.html',
                        controller : 'IssueCreatorsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Issue Creators',
                analyticsTitle:'Issue Creators',
                analyticsHeaderTitle:'Issue Creators',
                sidebarMeta: {
                    order: 172
                },
                roles : ['PROJECT_MANAGER', 'GENERAL_USER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.products',['uiSwitch',])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.products', {
                url: '/products',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/products/products.html',
                        controller : 'ProductsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Products',
                analyticsTitle:'Products',
                analyticsHeaderTitle:'Issue Tracker',
                sidebarMeta: {
                    order: 110
                },
                roles: ['PROJECT_MANAGER', 'GENERAL_USER']
            })
            .state('projectManagement.createProduct', {
                url: '/products/createProduct',
                views : {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/products/createProduct/createProduct.html',
                        controller: 'CreateProductCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Create Product',
                analyticsTitle:'Create Product',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            })
            .state('projectManagement.editProduct', {
                url: '/products/editProduct',
                views : {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/products/editProduct/editProduct.html',
                        controller: 'EditProductCtrl',
                        controllerAs: "vm"
                    }
                },
                params : {
                    productToEdit : {
                        squash : false,
                        value : null,
                        // dynamic: true
                    },
                },
                title: 'Edit Product',
                analyticsTitle:'Edit Product',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.projectIssues',['uiSwitch',])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.projectIssues', {
                url: '/issues',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/projectIssues/projectIssues.html',
                        controller : 'ProjectIssuesCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Issue Tracker',
                analyticsTitle:'Issue Tracker',
                analyticsHeaderTitle:'Issue Tracker',
                sidebarMeta: {
                    order: 110
                },
                roles : ['GENERAL_USER']
            })
            .state('projectManagement.viewIssue', {
                url: '/issues/view',
                views: {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/projectIssues/viewIssue/viewIssue.html',
                        controller: 'ViewIssueCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Issue Tracker',
                analyticsTitle:'View Issue',
                analyticsHeaderTitle:'Project Management',
                params: {
                    issueDetails: null
                },
                roles : ['GENERAL_USER']
            })
            .state('projectManagement.editIssue', {
                url: '/issues/edit',
                views: {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/projectIssues/editIssue/editIssue.html',
                        controller: 'EditIssueCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Issue Tracker',
                analyticsTitle:'Edit Issue',
                analyticsHeaderTitle:'Project Management',
                params: {
                    issueDetails: null
                },
                roles : ['GENERAL_USER']
            })
            .state('projectManagement.createIssue', {
                url: '/issues/create',
                views: {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/projectIssues/createIssue/createIssue.html',
                        controller: 'CreateIssueCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Issue Tracker',
                analyticsTitle:'Create Issue',
                analyticsHeaderTitle:'Project Management',
                roles : ['GENERAL_USER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.projects',['uiSwitch',])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.projects', {
                url: '/projects',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/projects/projects.html',
                        controller : 'ProjectsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Projects',
                analyticsTitle:'Projects',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 110
                },
                roles: ['PROJECT_MANAGER', 'GENERAL_USER']
            })
            .state('projectManagement.createProject', {
                url: '/projects/create',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/projects/createProject/createProject.html',
                        controller : 'CreateProjectCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Project',
                analyticsTitle:'Create New Project',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            })
            .state('projectManagement.editProject', {
                url: '/projects/edit/',
                params : {
                    projectDetails: null
                },
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/projects/editProject/regular/editProject.html',
                        controller : 'EditProjectCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Projects',
                analyticsTitle:'Edit Project',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            })
            .state('projectManagement.editTdhProject', {
                url: '/projects/edit/:projectId',
                views : {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/projects/editProject/tdh/editProject.html',
                        controller: 'EditTdhProjectCtrl',
                        controllerAs: "vm"
                    }
                },
                params : {
                    projectId : {
                        squash : false,
                        value : null,
                        dynamic: true
                    },
                },
                title: 'Edit Project',
                analyticsTitle:'Edit Project',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.tasks',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.tasks', {
                url: '/tasks',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/tasks/tasks.html',
                        controller : 'TasksCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Tasks',
                analyticsTitle:'Tasks',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 120
                },
                roles: ['PROJECT_MANAGER']
            }).state('projectManagement.editTask', {
                url: '/tasks/edit/:taskId',
                views : {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/tasks/editTask/editTask.html',
                        controller: 'EditTaskCtrl',
                        controllerAs: "vm"
                    }
                },
                params : {
                    taskId : {
                        squash : false,
                        value : null,
                        dynamic: true
                    },
                },
                title: 'Edit Task',
                analyticsTitle:'Edit Task',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.projectManagement.teams',['uiSwitch',])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projectManagement.teams', {
                url: '/teams',
                views : {
                    'projectManagement' : {
                        templateUrl:'app/pages/main/projectManagement/teams/teams.html',
                        controller : 'TeamsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Teams',
                analyticsTitle:'Teams',
                analyticsHeaderTitle:'Project Management',
                sidebarMeta: {
                    order: 130
                },
                roles: ['PROJECT_MANAGER']
            }).state('projectManagement.editTeam', {
                url: '/teams/edit/:teamId',
                views : {
                    'projectManagement' : {
                        templateUrl: 'app/pages/main/projectManagement/teams/editTeam/editTeam.html',
                        controller: 'EditTeamCtrl',
                        controllerAs: "vm"
                    }
                },
                params : {
                    teamId : {
                        squash : false,
                        value : null,
                        dynamic: true
                    },
                },
                title: 'Edit Team',
                analyticsTitle:'Edit Team',
                analyticsHeaderTitle:'Project Management',
                roles: ['PROJECT_MANAGER']
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.accessArea',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.accessArea', {
                url: '/access-area',
                views : {
                    'settings' : {
                        templateUrl:'app/pages/main/settings/accessArea/accessArea.html',
                        controller : 'AccessAreaCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Access Areas',
                analyticsTitle:'Access Area',
                analyticsHeaderTitle:'Settings',
                data :{code: '11001'},
                sidebarMeta: {
                    order: 189
                }
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.approvals',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.approvals', {
                url: '/approvals',
                views : {
                    'settings' : {
                        templateUrl:'app/pages/main/settings/approvals/approvals.html',
                        controller : 'ApprovalsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Approvals',
                analyticsTitle:'Approvals',
                analyticsHeaderTitle:'Settings',
                data :{code: '6015'},
                roles: ['ADMIN', 'LINE_MANAGER'],
                sidebarMeta: {
                    order: 189
                }
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.departments',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.departments', {
                url: '/departments',
                views : {
                    'settings' : {
                     templateUrl:'app/pages/main/settings/departments/departments.html',
                        controller : 'DepartmentsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'departments',
                analyticsTitle:'Departments',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 110
                }
            })
            .state('settings.departmentDetails', {
            url: '/departments/:departmentId',
            params : {
                departmentId: {
                    squash: false,
                    value: null
                }
            },
            views : {
                'settings' : {
                    templateUrl:'app/pages/main/settings/departments/details/departmentDetails.html',
                    controller : 'DepartmentDetailsCtrl',
                    controllerAs : 'vm'
                }
            },
            title:'Department Details'
        });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.designations', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.designations', {
                url: '/designations',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/designations/designations.html',
                        controller : 'DesignationsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'designations',
                analyticsTitle:'Designations',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 100
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.employmentType', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.employmentType', {
                url: '/employment-type',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/employmentType/employmentType.html',
                        controller : 'EmploymentTypeCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'employmentTypes',
                analyticsTitle:'Employment Types',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 105
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.holidays',['ngAnimate','toastr','ui.bootstrap', 'ui.bootstrap.tpls','mwl.calendar'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.holidays', {
                url: '/holidays',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/holidays/holidays.html',
                        controller : 'HolidayCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'holidays',
                analyticsTitle:'Holidays',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 190
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.notification', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.notification', {
                url: '/notification',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/notification/notification.html',
                        controller : 'NotificationCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'notification',
                analyticsTitle:'Notification',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 112
                },
                data: {
                    code: '9011'
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.shifts', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.shifts',
            {
                url: '/shifts',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/shifts/shifts.html',
                        controller:'ShiftCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'shifts',
                analyticsTitle:'Shifts',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 90
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.specialDays',['ngAnimate','toastr','ui.bootstrap', 'ui.bootstrap.tpls','mwl.calendar'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.specialDays', {
                url: '/special-days',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/specialDays/specialDays.html',
                        controller : 'SpecialDayCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Special Days',
                analyticsTitle:'Special Days',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 190
                }
            });
    }
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.subDepartments',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.subDepartments', {
                url: '/sub-departments',
                views : {
                    'settings' : {
                        templateUrl:'app/pages/main/settings/subDepartments/subDepartments.html',
                        controller : 'SubDepartmentsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'subDepartments',
                analyticsTitle:'Sub Departments',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 110
                }
            })
            // .state('settings.departmentDetails', {
            //     url: '/subDepartments/:subDepartmentId',
            //     params : {
            //         subDepartmentId: {
            //             squash: false,
            //             value: null
            //         }
            //     },
            //     views : {
            //         'settings' : {
            //             templateUrl:'app/pages/main/settings/subDepartments/details/departmentDetails.html',
            //             controller : 'SubDepartmentDetailsCtrl',
            //             controllerAs : 'vm'
            //         }
            //     },
            //     title:'Sub Department Details'
            // });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.susidiaries', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.subsidiaries', {
                url: '/subsidiaries',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/subsidiary/subsidiaries.html',
                        controller : 'SubsidiariesCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'subsidiaries',
                analyticsTitle:'Subsidiaries',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 100
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.weeklyOffDayPolicy', ['xeditable','ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.weeklyOffDayPolicy', {
                url: '/weekly-off-day',
                views : {
                    'settings' : {
                        templateUrl:'app/pages/main/settings/weeklyOffDayPolicy/weeklyOffDayPolicy.html',
                        controller:'WeeklyOffDaysPolicyCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Weekly Off Day',
                sidebarMeta: {
                    order: 180
                }
            })


    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.workplaces', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.workplaces', {
                url: '/workplaces',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/workplace/workplace.html',
                        controller : 'WorkplaceCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'workplaces',
                analyticsTitle:'Workplaces',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 112
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.shiftManagement.dynamicShiftGroups', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('shiftManagement.dynamicShiftGroups', {
                url: '/dynamic-shift-groups',
                views : {
                    'shiftManagement' : {
                        templateUrl: 'app/pages/main/shiftManagement/dynamicShiftGroups/dynamicShiftGroups.html',
                        controller : 'DynamicShiftGroupsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'dynamicShiftGroups',
                analyticsTitle:'Dynamic Shift Groups',
                analyticsHeaderTitle:'Shift Management',
                sidebarMeta: {
                    order: 135
                },
                data :{code: '10004'},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.shiftManagement.roster', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('shiftManagement.roster', {
                url: '/roster',
                views : {
                    'shiftManagement' : {
                        templateUrl: 'app/pages/main/shiftManagement/roster/roster.html',
                        controller : 'RosterCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'roster',
                analyticsTitle:'Roster',
                analyticsHeaderTitle:'Shift Management',
                sidebarMeta: {
                    order: 145
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.shiftManagement.shiftGroups', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('shiftManagement.shiftGroups', {
                url: '/shift-groups',
                views : {
                    'shiftManagement' : {
                        templateUrl: 'app/pages/main/shiftManagement/shiftGroups/shiftGroups.html',
                        controller : 'ShiftGroupsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'shiftGroups',
                analyticsTitle:'Shift Groups',
                analyticsHeaderTitle:'Shift Management',
                sidebarMeta: {
                    order: 135
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.shiftManagement.shifts', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('shiftManagement.shifts', {
                url: '/shifts',
                views : {
                    'shiftManagement' : {
                        templateUrl: 'app/pages/main/shiftManagement/shifts/shifts.html',
                        controller : 'ShiftsCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Shifts',
                analyticsTitle:'Shifts',
                analyticsHeaderTitle:'Shift Management',
                sidebarMeta: {
                    order: 130
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.siteManagement.manageSites',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('siteManagement.manageSites', {
                url: '/manage-sites',
                views : {
                    'siteManagement' : {
                        templateUrl:'app/pages/main/siteManagement/manageSites/manageSites.html',
                        controller : 'ManageSitesCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Manage Sites',
                analyticsTitle:'Manage Sites',
                analyticsHeaderTitle:'Site Management',
                data :{code: '12001'},
                sidebarMeta: {},
                roles: ['SITE_MANAGEMENT_ADMIN'],
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: false,
            })
            .state('siteManagement.createSites', {
                url: '/manage-sites/create',
                views : {
                    'siteManagement' : {
                        templateUrl:'app/pages/main/siteManagement/manageSites/create/createSites.html',
                        controller : 'CreateSitesCtrl',
                        controllerAs : 'vm'
                    }
                },
                data :{code: '12001'},
                title: 'Manage Sites',
                roles: ['SITE_MANAGEMENT_ADMIN'],
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: false,
                analyticsTitle:'Create Sites',
                analyticsHeaderTitle:'Site Management',
            })
            .state('siteManagement.viewSites', {
                url: '/manage-sites/view-sites/:siteId',
                params : {
                    siteId : null
                },
                views : {
                    'siteManagement' : {
                        templateUrl:'app/pages/main/siteManagement/manageSites/viewSites/viewSites.html',
                        controller : 'ViewSitesCtrl',
                        controllerAs : 'vm'
                    }
                },
                data :{code: '12001'},
                title: 'Manage Sites',
                roles: ['SITE_MANAGEMENT_ADMIN'],
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: false,
                analyticsTitle:'View Sites',
                analyticsHeaderTitle:'Site Management',
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('siteManagement.siteManagementDashboard', {
                url: '/dashboard',
                views : {
                    'siteManagement' : {
                        templateUrl:'app/pages/main/siteManagement/siteManagementDashboard/siteManagementDashboard.html',
                        controller : 'SiteManagementDashboardCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Manage Site Attendance Dashboard',
                analyticsTitle:'Dashboard',
                analyticsHeaderTitle:'Site Management',
                data :{},
                sidebarMeta: {},
                roles: ['SITE_MANAGEMENT_ADMIN', 'SITE_MANAGEMENT_MANAGER'],
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: true,
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.appointmentLog',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.appointmentLog', {
                url: '/appointment-log',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/appointmentLog/appointmentLog.html',
                        controller : 'AppointmentLogCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['GENERAL_USER'],
                // generalUserPermitted:true,
                title: 'Visitor Management System',
                analyticsTitle:'Appointment Log',
                analyticsHeaderTitle:'Visitor Management',
                data :{code: '11001'},
                sidebarMeta: {
                    order: 196
                }
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.createAppointment',['ngCroppie'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.createAppointment', {
                url: '/create-appointment',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/createAppointment/createAppointment.html',
                        controller : 'CreateAppointmentCtrl',
                        controllerAs : 'vm'
                    }
                },
                params:{
                    visitor:null,
                },
                roles: ['GENERAL_USER'],
                // generalUserPermitted : true,
                title: 'Create New Appointment',
                analyticsTitle:'Create New Appointment',
                analyticsHeaderTitle:'Visitor Management',
                sidebarMeta: {
                    order: 183
                },
                data :{code: '11001'},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.editAppointment',['ngCroppie'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.editAppointment', {
                url: '/edit-appointment',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/editAppointment/editAppointment.html',
                        controller : 'EditAppointmentCtrl',
                        controllerAs : 'vm'
                    }
                },
                params:{
                    //visitorId:null,
                    appointmentId:null,
                },
                roles: ['GENERAL_USER'],
                // generalUserPermitted : true,
                title: 'Edit Appointment',
                analyticsTitle:'Edit Appointment',
                analyticsHeaderTitle:'Visitor Management',
                sidebarMeta: {
                    order: 183
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.reception', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.reception', {
                url: '/reception',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/reception/reception.html',
                        controller : 'ReceptionCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Reception',
                roles: ['GENERAL_USER'],
                // generalUserPermitted : true,
                sidebarMeta: {
                    order: 200
                },
                data :{code: '11001'},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyAbsentReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.dailyAbsentReport', {
                url: '/daily-absent',
                data:{code:'4017'},
                params: {
                    attDateInMillis: null,
                    employmentTypeIds: null,
                    subsidiaryIds: null,
                    workplaceIds: null
                },
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/absentReport/dailyAbsentReport/dailyAbsentReport.html',
                        controller: 'DailyAbsentReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'absentReport',
                analyticsTitle: 'Daily Absent Report',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 58
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 1
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthlyAbsentReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.monthlyAbsentReport', {
                url: '/monthly-absent',
                data:{code:'4017'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/absentReport/monthlyAbsentReport/monthlyAbsentReport.html',
                        controller: 'MonthlyAbsentReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'monthlyAbsentReport',
                analyticsTitle: 'Monthly Absent Report',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 59
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 1
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyDiningReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.dailyDiningReport', {
                url: '/daily-dining-report',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/diningReport/dailyDiningReport/dailyDiningReport.html',
                        controller: 'DailyDiningReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Dining Report',
                analyticsTitle: 'Daily Dining Report',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 81
                },
                params: {
                    officeId: null
                },
                data :{code: '4025'},
                // moduleId: 109
            });
    }
})();

(function () {
    "use strict";

    angular
        .module(
            "InovaceClientApp.pages.main.attendanceReport.detailedDiningReport",
            ["ng", "daterangepicker"]
        )
        .config(["$stateProvider", routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state("attendanceReport.detailedDiningReport", {
            url: "/detailed-dining-report",
            // data:{code:'10002'},
            views: {
                attendanceReport: {
                    templateUrl:
                        "app/pages/main/attendanceReport/diningReport/detailedDiningReport/detailedDiningReport.html",
                    controller: "DetailedDiningReportCtrl",
                    controllerAs: "vm",
                },
            },
            title: "Dining Report",
            analyticsTitle: "Detailed Dining Report",
            analyticsHeaderTitle: "Reports",
            sidebarMeta: {
                order: 81,
            },
            params: {
                officeId: null,
            },
            data: { code: "4025" },
            // moduleId: 109
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthlyDiningReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.monthlyDiningReport', {
                url: '/monthly-dining-report',
                // data:{code:'10002'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/diningReport/monthlyDiningReport/monthlyDiningReport.html',
                        controller: 'MonthlyDiningReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Dining Report',
                analyticsTitle: 'Monthly Dining Report',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 81
                },
                params: {
                    officeId: null
                },
                data :{code: '4025'},
                // moduleId: 109
            });
    }
})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.leaveBalanceReport', ['ng', 'uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.leaveBalanceReport', {
                url: '/leave-balance',
                data:{code:'4017'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/leaveReport/leaveBalanceReport/leaveBalanceReport.html',
                        controller: 'LeaveBalanceReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'leaveBalanceReport',
                analyticsTitle: 'Leave Balance',
                analyticsHeaderTitle: 'Reports',
                sidebarMeta: {
                    order: 59
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 1
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.leaveHistoryReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.leaveHistoryReport', {
                url: '/leave-history',
                data:{code:'4017'},
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/leaveReport/leaveHistoryReport/leaveHistoryReport.html',
                        controller: 'LeaveHistoryReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'leaveReport',
                analyticsTitle: 'Leave History',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 58
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 1
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.individualSalaryComparison', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.individualSalaryComparison', {
                url: '/individualSalaryComparison',
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/salaryReport/individualSalaryComparison/individualSalaryComparison.html',
                        controller: 'IndividualSalaryComparison',
                        controllerAs:'vm'
                    }
                },
                title: 'Individual Salary Comparison',
                sidebarMeta: {
                    order: 58
                },
                // lineManagerPermitted: false,
                moduleId: 1,
                roles: ['PAYROLL_MANAGER','LINE_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                data :{code: '10003'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.salaryComparisonSummary', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.salaryComparisonSummary', {
                url: '/salary-comparison-summary',
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/salaryReport/salaryComparisonSummary/salaryComparisonSummary.html',
                        controller: 'SalaryComparisonSummaryCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Salary Comparison Summary',
                analyticsTitle:'Salary Comparison Summary',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 58
                },
                // lineManagerPermitted: false,
                moduleId: 1,
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER','LINE_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                data :{code: '10003'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthOnMonthSalaryComparison', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('attendanceReport.monthOnMonthSalaryComparison', {
                url: '/month-on-month-salary-comparison',
                data: null,
                views : {
                    'attendanceReport' : {
                        templateUrl: 'app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/monthOnMonthSalaryComparison.html',
                        controller: 'MonthOnMonthSalaryComparison',
                        controllerAs:'vm'
                    }
                },
                title: 'Month On Month Salary Comparison',
                analyticsTitle:'Month On Month Salary Comparison',
                analyticsHeaderTitle:'Reports',
                sidebarMeta: {
                    order: 58
                },
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true,
                moduleId: 1
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.devices.deviceDetails', [
            'smart-table'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('devices.deviceDetails', {
                url: '/details/:deviceId',
                params:{device:null,deviceId:null},
                views : {
                    'devices' : {
                        templateUrl: 'app/pages/main/devices/devicesList/allocations/root/allocationsRoot.html',
                        controller: 'AllocationsRootCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'deviceAllocationDetails',
                analyticsTitle:'Allocation Details',
                analyticsHeaderTitle:'Devices',
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement.dailyReport', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('membershipManagement.dailyReport', {
                url: '/daily-report',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/reports/membershipDailyReport/membershipDailyReport.html',
                        controller: 'MembershipDailyReportCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Membership Daily Report',
                analyticsTitle:'Daily Report',
                analyticsHeaderTitle:'Membership Management',
                data: {code: '13001'},
            })

    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement.subscriptionReport', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('membershipManagement.subscriptionReport', {
                url: '/subscription-report',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/reports/subscriptionReport/subscriptionReport.html',
                        controller: 'SubscriptionReportCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Membership Subscription Report',
                data: {code: '13001'},
                analyticsTitle:'Subscription Report',
                analyticsHeaderTitle:'Membership Management',
            })

    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.membershipManagement.monthlyReport', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('membershipManagement.monthlyReport', {
                url: '/monthly-report',
                views: {
                    'membershipManagement': {
                        templateUrl: 'app/pages/main/membershipManagement/reports/membershipMonthlyReport/membershipMonthlyReport.html',
                        controller: 'MembershipMonthlyReportCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: 'Membership Monthly Report',
                data: {code: '13001'},
                analyticsTitle:'Monthly Report',
                analyticsHeaderTitle:'Membership Management',
            })

    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement.dailyParkingReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('parkingManagement.dailyParkingReport', {
                url: '/daily-parking-report',
                data:{code:'11101'},
                views : {
                    'parkingManagement' : {
                        templateUrl: 'app/pages/main/parkingManagement/parkingReport/dailyReport/dailyParkingReport.html',
                        controller: 'DailyParkingReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Parking Management',
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted:true,
                analyticsTitle:'Daily Parking Report',
                analyticsHeaderTitle:'Parking Management',
                moduleId: 7
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement.monthlyParkingReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('parkingManagement.monthlyParkingReport', {
                url: '/monthly-parking-report',
                data:{code:'11101'},
                views : {
                    'parkingManagement' : {
                        templateUrl: 'app/pages/main/parkingManagement/parkingReport/monthlyReport/monthlyParkingReport.html',
                        controller: 'MonthlyParkingReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'Parking Management',
                roles: ['LINE_MANAGER','GROUP_ADMIN'],
                // lineManagerPermitted: true,
                // groupAdminPermitted:true,
                analyticsTitle:'Monthly Parking Report',
                analyticsHeaderTitle:'Parking Management',
                moduleId: 7
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.parkingManagement.billSetup',['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('parkingManagement.billSetup', {
                url: '/bill-setup',
                views : {
                    'parkingManagement' : {
                        templateUrl:'app/pages/main/parkingManagement/settings/billSetup/billSetup.html',
                        controller : 'BillSetupCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Parking Management',
                analyticsTitle:'Bill Setup',
                analyticsHeaderTitle:'Parking Management',
                data :{code: '11101'},
            })
            .state('parkingManagement.createBillSetup', {
                url: '/create-new-bill',
                views: {
                    'parkingManagement' : {
                        templateUrl: 'app/pages/main/parkingManagement/settings/billSetup/createBillSetup/createBillSetup.html',
                        controller: 'CreateBillSetupCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: "Parking Management",
                analyticsTitle:'Create New Bill',
                analyticsHeaderTitle:'Parking Management',
            })
            .state('parkingManagement.updateBillSetup', {
                url: '/update-bill',
                views: {
                    'parkingManagement' : {
                        templateUrl: 'app/pages/main/parkingManagement/settings/billSetup/updateBillSetup/updateBillSetup.html',
                        controller: 'UpdateBillSetupCtrl',
                        controllerAs: 'vm'
                    }
                },
                title: "Parking Management",
                analyticsTitle:'Update Bill',
                analyticsHeaderTitle:'Parking Management',
                params: {
                    vehicleType : null
                }
            })
        ;
    }
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.manageBanks', ['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('payroll.manageBanks', {
                url: '/manage-banks',
                views: {
                    'payroll': {
                        templateUrl: 'app/pages/main/payroll/bankSettings/bankManagement/manageBanks.html',
                        controller: 'ManageBanksCtrl',
                        controllerAs: 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted: true,
                // payrollApproverPermitted: true,
                title: 'Manage Banks',
                analyticsTitle:'Manage Banks',
                analyticsHeaderTitle:'Payroll',
                data: {code: '10003'},
            })
            .state('payroll.bankPaymentAdviceEditor', {
                url: '/bank-payment-advice-editor',
                params:
                    {bankId: null},
                views: {
                    'payroll': {
                        templateUrl: 'app/pages/main/payroll/bankSettings/bankManagement/adviceLetterEditor/bankPaymentAdviceEditor.html',
                        controller: 'BankPaymentAdviceEditorCtrl',
                        controllerAs: 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted: true,
                // payrollApproverPermitted: true,
                title: 'Bank Payment Advice Editor',
                analyticsTitle:'Bank Payment Advice Editor',
                analyticsHeaderTitle:'Payroll',
                data: {code: '10004'},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.manageBranches',['uiSwitch', 'ui.bootstrap'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.manageBranches', {
                url: '/manage-branches',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/bankSettings/branchManagement/manageBranches.html',
                        controller : 'ManageBranchesCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : true,
                title: 'Manage Branches',
                analyticsTitle:'Manage Branches',
                analyticsHeaderTitle:'Payroll',
                data :{code: '10003'},
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.absentOrLeaveWithoutPay',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.absentOrLeaveWithoutPay', {
                url: '/absent-or-leave-without-pay',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentOrLeaveWithoutPay.html',
                        controller : 'AbsentOrLeaveWithoutPayCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Monthly Salary Process',
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                analyticsTitle:'Absent Or Leave Without Pay',
                analyticsHeaderTitle:'Payroll',
                data :{},
                sidebarMeta: {
                }
            })
            .state('payroll.absentTypeInputForIndividualEmployee', {
                url: '/absent-or-leave-without-pay/add-absent-type-input-for-individual-employee',
                params : {
                    initialSelection: null
                },
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentTypeInputForIndividualEmployee/create/absentTypeInputForIndividual.html',
                        controller : 'AbsentTypeInputForIndividualCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Monthly Salary Process',
                analyticsTitle:'Absent Type Input For Individual Employee',
                analyticsHeaderTitle:'Payroll',
            })
            .state('payroll.absentTypeForIndividualEmployeeUpdate', {
            url: '/absent-or-leave-without-pay/edit-absent-type-input-for-individual-employee',
            params : {
                absenceTypeComponent: null
            },
            views : {
                'payroll' : {
                    templateUrl:'app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentTypeInputForIndividualEmployee/update/editAbsenceTypeForIndividual.html',
                    controller : 'EditAbsenceTypeForIndividualCtrl',
                    controllerAs : 'vm'
                }
            },
            roles: ['PAYROLL_MANAGER'],
            // payrollManagerPermitted : true,
            // payrollApproverPermitted : false,
            title: 'Monthly Salary Process',
            analyticsTitle:'Update Absent Type Input For Individual Employee',
            analyticsHeaderTitle:'Payroll',
        });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.salaryComponentUpload',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.salaryComponentUpload', {
                url: '/additional-salary-component-upload',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/salaryComponentUpload.html',
                        controller : 'SalaryComponentUploadCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Monthly Salary Process',
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                analyticsTitle:'Additional Salary Component Upload',
                analyticsHeaderTitle:'Payroll',
                data :{},
                sidebarMeta: {
                }
            })
            .state('payroll.individualAdditionalSalaryComponent', {
                url: '/individual-additional-salary-component/add',
                params : {
                    initialSelection: null
                },
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/create/individualAdditionalSalaryComponent.html',
                        controller : 'IndividualAdditionalSalaryComponentCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Monthly Salary Process',
                analyticsTitle:'Add Individual Additional Salary Component',
                analyticsHeaderTitle:'Payroll',
            })
            .state('payroll.individualAdditionalSalaryComponentUpdate', {
                url: '/individual-additional-salary-component/update',
                params : {
                    additionalComponent: null
                },
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/update/editIndividualAdditionalSalaryComponent.html',
                        controller : 'EditIndividualAdditionalSalaryComponentCtrl',
                        controllerAs : 'vm'
                    }
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Monthly Salary Process',
                analyticsTitle:'Update Individual Additional Salary Component',
                analyticsHeaderTitle:'Payroll',
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.bankPaymentAdvice',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.bankPaymentAdvice', {
                url: '/bank-payment-advice',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/bankPaymentAdvice/bankPaymentAdvice.html',
                        controller : 'BankPaymentAdviceCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Monthly Salary Process',
                analyticsTitle:'Bank Payment Advice',
                analyticsHeaderTitle:'Payroll',
                data :{},
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                sidebarMeta: {
                }
            })
            .state('payroll.individualBankPaymentAdvice', {
                url: '/individual-bank-payment-advice/bank-id/:bankId/monthly-salary-id/:monthlySalaryId',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/monthlySalaryProcess/bankPaymentAdvice/individualBankPaymentAdvice/individualBankPaymentAdvice.html',
                        controller : 'IndividualBankPaymentAdviceCtrl',
                        controllerAs : 'vm'
                    }
                },
                params : {
                    bankId: null,
                    monthlySalaryId : null
                },
                roles: ['PAYROLL_MANAGER'],
                // payrollManagerPermitted : true,
                // payrollApproverPermitted : false,
                title: 'Monthly Salary Process',
                analyticsTitle:'Individual Bank Payment Advice',
                analyticsHeaderTitle:'Payroll',
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.providentFundMember',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.providentFundMember', {
                url: '/provident-fund-member',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/providentFund/providentFundMember/providentFundMember.html',
                        controller : 'ProvidentFundMemberCtrl',
                        controllerAs : 'vm'
                    }
                },
                payrollManagerPermitted : true,
                payrollApproverPermitted : true,
                title: 'Provident Fund',
                analyticsTitle:'Provident Fund',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 226
                },
                data :{code: '10003'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.providentFundStatement',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.providentFundStatement', {
                url: '/provident-fund-statement',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/providentFund/providentFundStatement/providentFundStatement.html',
                        controller : 'ProvidentFundStatementCtrl',
                        controllerAs : 'vm'
                    }
                },
                payrollManagerPermitted : true,
                payrollApproverPermitted : true,
                title: 'Provident Fund',
                analyticsTitle:'Provident Fund Statement',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 226
                },
                data :{code: '10003'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.payroll.providentFundAccountManagement',['uiSwitch'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('payroll.providentFundAccountManagement', {
                url: '/provident-fund-account-management',
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/providentFund/providentFundAccountManagement/providentFundAccountManagement.html',
                        controller : 'ProvidentFundAccountManagementCtrl',
                        controllerAs : 'vm'
                    }
                },
                payrollManagerPermitted : true,
                payrollApproverPermitted : true,
                title: 'Provident Fund',
                analyticsTitle:'Provident-fund-account-management',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 226
                },
                data :{code: '10003'}
            })
            .state('payroll.providentFundAccountDetails', {
                url: '/provident-fund-account-details',
                params: {
                    pfAccountInfo: null
                },
                views : {
                    'payroll' : {
                        templateUrl:'app/pages/main/payroll/providentFund/providentFundAccountManagement/accountDetails/providentFundAccountDetails.html',
                        controller : 'ProvidentFundAccountDetailsCtrl',
                        controllerAs : 'vm'
                    }
                },
                payrollManagerPermitted : true,
                payrollApproverPermitted : true,
                title: 'Provident Fund',
                analyticsTitle:'Provident-fund-account-details',
                analyticsHeaderTitle:'Payroll',
                sidebarMeta: {
                    order: 226
                },
                data :{code: '10003'}
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.geofencing', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.geofencing', {
                url: '/geo-fencing',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/mobileAttendance/geoFencing/geoFencing.html',
                        controller: 'GeoFencingSettingCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Geo Fencing Access Settings',
                analyticsTitle:'Geo Fencing Access',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 76
                },
                data :{code: '9009'},
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true
            })

    }
})();


(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.shifts', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.shifts',
                {
                    url: '/shifts',
                    views : {
                        'settings' : {
                            templateUrl: 'app/pages/main/settings/shifts/shifts.html',
                            controller:'ShiftCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'shifts',
                    sidebarMeta: {
                        order: 90
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.locationTrackingAccessSettings', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.locationTrackingAccessSettings', {
                url: '/location-tracking-access-settings',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/mobileAttendance/locationTrackingAccessSettings/locationTrackingAccessSettings.html',
                        controller: 'LocationTrackingAccessSettingsCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Location Tracking Access Settings',
                analyticsTitle:'Location Tracking Access',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 77
                },
                data :{code: '9007'},
                roles: ['ADMIN','HR_MANAGER'],
                // lineManagerPermitted: true
            })

    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.mobilePunch', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.mobilePunch', {
                url: '/mobile-punch',
                views : {
                    'settings' : {
                        templateUrl: 'app/pages/main/settings/mobileAttendance/mobilePunch/mobilePunch.html',
                        controller: 'MobilePunchSettingsCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Mobile Punch Access Settings',
                analyticsTitle:'Mobile Punch Access',
                analyticsHeaderTitle:'Settings',
                sidebarMeta: {
                    order: 75
                },
                data :{code: '9006'},
                roles: ['LINE_MANAGER'],
                // lineManagerPermitted: true
            });

    }
})();


(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.settings.shifts', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('settings.shifts',
                {
                    url: '/shifts',
                    views : {
                        'settings' : {
                            templateUrl: 'app/pages/main/settings/shifts/shifts.html',
                            controller:'ShiftCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'shifts',
                    sidebarMeta: {
                        order: 90
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.siteManagement.siteAttendanceReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('siteManagement.siteAttendanceReport', {
                url: '/site-attendance-report',
                data:{code:'12001'},
                views : {
                    'siteManagement' : {
                        templateUrl: 'app/pages/main/siteManagement/siteManagementReports/siteAttendanceReport/siteAttendanceReport.html',
                        controller: 'SiteAttendanceReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'siteAttendanceReport',
                analyticsTitle:'Site Attendance Report',
                analyticsHeaderTitle:'Site Management',
                sidebarMeta: {
                    // order: 54
                },
                roles: ['SITE_MANAGEMENT_ADMIN'],
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: false
                // moduleId: 7
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.siteManagement.siteSummaryReport', ['ng', 'daterangepicker'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('siteManagement.siteSummaryReport', {
                url: '/site-summary-report',
                data: {code:'12001'},
                views : {
                    'siteManagement' : {
                        templateUrl: 'app/pages/main/siteManagement/siteManagementReports/siteSummaryReport/siteSummaryReport.html',
                        controller: 'SiteSummaryReportCtrl',
                        controllerAs:'vm'
                    }
                },
                title: 'siteSummaryReport',
                analyticsTitle:'Site Summary Report',
                analyticsHeaderTitle:'Site Management',
                sidebarMeta: {
                    // order: 56
                },
                roles: ['SITE_MANAGEMENT_ADMIN'],
                // siteManagementAdminPermitted: true,
                // siteManagementManagerPermitted: false
                // moduleId: null
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.assignRole',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.assignRole', {
                url: '/assign-role',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/visitorSettings/assignRole/assignRole.html',
                        controller : 'AssignRoleCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Assign Role',
                analyticsTitle:'Assign Role',
                analyticsHeaderTitle:'Visitor Management',
                data :{code: '11001'},
                roles: ['VISITOR_MANAGEMENT_ADMIN'],
                sidebarMeta: {
                    order: 192
                }
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.manageCard',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.manageCard', {
                url: '/manage-card',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/visitorSettings/manageCard/manageCard.html',
                        controller : 'ManageCardCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Manage Card',
                analyticsTitle:'Manage Card',
                analyticsHeaderTitle:'Visitor Management',
                data :{code: '11001'},
                roles: ['VISITOR_MANAGEMENT_ADMIN'],
                sidebarMeta: {
                    order: 191
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.visitPurpose',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.visitPurpose', {
                url: '/visit-purpose',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurpose.html',
                        controller : 'VisitPurposeCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Visit Purpose',
                analyticsTitle:'Visit Purpose',
                analyticsHeaderTitle:'Visitor Management',
                data :{code: '11001'},
                roles: ['VISITOR_MANAGEMENT_ADMIN'],
                sidebarMeta: {
                    order: 188
                }
            })
    }
})();
(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.visitorCategory',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.visitorCategory', {
                url: '/visitor-category',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategory.html',
                        controller : 'VisitorCategoryCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Visitor Categories',
                analyticsTitle:'Visitor Categories',
                analyticsHeaderTitle:'Visitor Management',
                data :{code: '11001'},
                roles: ['VISITOR_MANAGEMENT_ADMIN'],
                sidebarMeta: {
                    order: 187
                }
            })
    }
})();
'use strict';

var app = angular.module('InovaceClientApp', [
    'pascalprecht.translate',
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngBootstrap',
    'ui.bootstrap.datetimepicker',
    'BlurAdmin.theme',
    'InovaceClientApp.pages',
    'colorpicker.module',
    '720kb.tooltips',
    'ui.bootstrap',
    'webcam',
]);

app.config(['$locationProvider','$translateProvider','ENGLISH','ENGLISH_MODIFIED_BANGABHABAN','BANGABHABAN_OFFICE_ID', function ($locationProvider,$translateProvider,englishJson,modifiedEnglishJson,BANGABHABAN_OFFICE_ID) {
    // enable html5Mode for pushstate ('#'-less URLs
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
    $translateProvider.translations('en', englishJson).translations('en_modified',modifiedEnglishJson).determinePreferredLanguage(function () {
        //determine the perefered language based on office id
        if(localStorage.getItem('userInfo')!=null){
            var loggedInUserOfficeId=JSON.parse(localStorage.getItem('userInfo')).officeId
            if(loggedInUserOfficeId != null && loggedInUserOfficeId === BANGABHABAN_OFFICE_ID.id){
                return 'en_modified';
            }
        }
        return 'en';
    });
}]);
app.run(['$rootScope', '$document', '$compile', 'authService', 'subscriptionGateService',
  function ($rootScope, $document, $compile, authService, subscriptionGateService) {

    function ensureMountedInsideContent() {
      var doc = $document[0];
      var content = doc.querySelector('.al-content');
      if (!content) return;

      var existing = doc.querySelector('.subscription-gate-root');
      if (existing) {
        if (existing.parentNode !== content) content.appendChild(existing);
      } else {
        var el = angular.element('<subscription-gate></subscription-gate>');
        angular.element(content).append(el);
        $compile(el)($rootScope);
      }
    }

    ensureMountedInsideContent();
    $rootScope.$on('$viewContentLoaded', ensureMountedInsideContent);
    $rootScope.$on('$stateChangeSuccess', ensureMountedInsideContent);

    function refreshIfLoggedIn() {
      if (authService.getLoggedInToken()) subscriptionGateService.refresh();
    }
    refreshIfLoggedIn();
    $rootScope.$on('$stateChangeSuccess', refreshIfLoggedIn);
  }
]);

app.config(function(toastrConfig) {
    angular.extend(toastrConfig, {
        autoDismiss: false,
        containerId: 'toast-container',
        maxOpened: 1,
        newestOnTop: true,
        positionClass: 'toast-top-right',
        preventDuplicates: false,
        preventOpenDuplicates: false,
        target: 'body',
    });
});

(function () {
    // var apiLink = 'http://localserver.inovacetech.com:90/inovace-client/api/v1';
    // var apiLink = 'http://dev.client.inovacetech.com/inovace-client/api/v1';
    // var apiLink = 'https://clients.inovacetech.com/inovace-client/api/v1';
//     var apiLink = 'https://test.clients.inovacetech.com/inovace-client/api/v1';
    // var apiLink = 'http://127.0.0.1:1990/inovace-client/api/v1';
    //var apiLink = 'http://192.168.1.145:1990/inovace-client/api/v1';
    //var apiLink = 'http://192.168.0.101:1990/inovace-client/api/v1';
    // var apiLink = 'http://clone.inovacetech.com/inovace-client/api/v1';
    // var apiLink = 'http://192.168.1.131:1990/inovace-client/api/v1';
    // var env = window.location.hostname.split('.')[0];
    // if(env) {
    //     if(env === 'test') {
    //         apiLink = 'http://test.clients.inovacetech.com/inovace-client/api/v1';
    //     } else if (env === 'www' || env === 'clients') {
    //         apiLink = 'https://clients.inovacetech.com/inovace-client/api/v1';
    //     } else {
    //         apiLink = 'http://127.0.0.1:1990/inovace-client/api/v1';
    //     }
    // }
    var apiLink = window.location.origin + "/inovace-client/api/v1";
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') apiLink = 'http://127.0.0.1:1990/inovace-client/api/v1';
    //console.log("base apiLink: " + apiLink);

    app.constant('imageNotResize', [41, 83]); //Office ID: UAP = 41, Rediant = 83
    app.constant('API', {
        googleApiKey : "AIzaSyBFYCquJm2ND6MOU6buv3ZJy_Nas1JxmD0",
        versions                         : {
            list : apiLink + '/versions',
        },
        modules                          : {
            list : apiLink + '/modules',
        },
        employee                         : {
            'base'                                   : apiLink + '/employee/',
            'search'                                 : apiLink + '/employee/search-by-name',
            'pageTopSearch'                          : apiLink + '/employee/search-by-name-id',
            'create'                                 : apiLink + '/employee/',
            'delete'                                 : apiLink + '/employee/delete',
            'resign'                                 : apiLink + '/employee/resign',
            'rehire'                                 : apiLink + '/employee/rehire',
            'batchCreate'                            : apiLink + '/employee/batch-create/',
            'all'                                    : apiLink + '/employee',
            'getAddressListOfEmployee'               : {
                'prefix' : apiLink + '/employee/',
                'suffix' : '/address/'
            },
            'getPendingApprovalsCount'               : apiLink + '/employee/approval-count/',
            'getEnrolmentInformation'                : apiLink + '/employee/getEnrolmentInformation/',
            'getFilteredEmployeeNames'               : apiLink + '/employee/names',
            'findById'                               : apiLink + '/employee/profile/',
            'updateBasicInfo'                        : apiLink + '/employee/profile/',
            'changeEmployeeSite'                     : apiLink + '/site-management/change-employee-site/',
            'updateLineManager'                      : apiLink + '/employee/line-manager/',
            'updateBatchShiftGroup'                  : apiLink + '/employee/updateBatchShiftGroup/',
            'updateHrManager'                        : apiLink + '/employee/hr-manager/',
            'getProfile'                             : apiLink + '/employee/basic-profile/',
            'uploadProfilePicture'                   : apiLink + '/employee/profile/picture/',
            'removeProfilePicture'                   : apiLink + '/employee/profile/picture/remove/',
            'updateDetailsInfo'                      : apiLink + '/employee/profile/details/',
            'getDetailsInfo'                         : apiLink + '/employee/profile/details/',
            'updatePassword'                         : apiLink + '/employee/password/',
            'updatePasswordEmployee'                 : apiLink + '/employee/password-employee/',
            'uploadDocument'                         : apiLink + '/employee/profile/',
            'setCompanyAdmin'                        : apiLink + '/employee/set-company-admin/',
            'transferEmployees'                      : apiLink + '/employee/transfer/',
            'includeInAttendanceReport'              : apiLink + '/employee/include-in-attendance-report/',
            'getEmployeeDocuments'                   : apiLink + '/employee/documents/',
            'deleteEmployeeDocument'                 : apiLink + '/employee/documents/delete/',
            'manualEntry'                            : apiLink + '/employee/profile/manual/',
            'manualEntryApprover'                    : apiLink + '/employee/profile/manual/approver/',
            'manualEntryApprove'                     : apiLink + '/employee/profile/manual/approver/approve/',
            'manualEntryReject'                      : apiLink + '/employee/profile/manual/approver/reject/',
            'updateManagerOrAdminRole'               : {
                "prefix" : apiLink + '/employee/',
                "suffix" : "/managerOrAdminRole/"
            },
            'setAsManager'                           : {
                "prefix" : apiLink + "/employee",
                "suffix" : "/setAsManager"
            },
            'getShiftAssignmentStatus'               : {
                "prefix" : apiLink + "/employee/",
                "suffix" : "/getShiftAssignmentStatus"
            },
            'toggleLineManagerShiftManagement'       : {
                "prefix" : apiLink + "/employee/",
                "suffix" : "/toggleLineManagerShiftManagement"
            },
            'updateReportPosition'                   : {
                "prefix" : apiLink + '/employee/',
                "suffix" : "/reportPosition/"
            },
            'deleteAddress'                          : apiLink + '/employee/address/',
            'createAddress'                          : {
                "prefix" : apiLink + '/employee/',
                "suffix" : '/address/'
            },
            'updateAddress'                          : {
                "prefix" : apiLink + '/employee/',
                "suffix" : '/address/'
            },
            'enrolEmployee'                          : apiLink + '/employee/enrollment/enroll/',
            'employeesAssignedToWeeklyOffDaysPolicy' : apiLink + '/employee/' + 'weekly-off-days/',
            'enrol'                                  : {
                'getFingers'             : apiLink + '/employee/enrollment/',
                'deleteFinger'           : apiLink + '/employee/enrollment/delete/',
                'getTemporaryEnrolments' : apiLink + '/employee/enrollment/temporary-enrolments',
                'enrollFromTemporary'    : apiLink + '/employee/enrollment/enrol-from-temporary/'
            },
            'updateBatchDepartment'                  : apiLink + '/employee/updateBatchDepartment/',
            'updateBatchSubDepartment'               : apiLink + '/employee/updateBatchSubDepartment/',
            'updateBatchDesignation'                 : apiLink + '/employee/updateBatchDesignation/',
            'updateBatchEmploymentType'              : apiLink + '/employee/updateBatchEmploymentType/',
            'updateBatchSubsidiary'                  : apiLink + '/employee/updateBatchSubsidiary/',
            'getAllProjectsOfAnEmployee'             : apiLink + '/employee-project/',
            'updateProjectDedicationOfAnEmployee'    : {
                'prefix' : apiLink + '/employee-project/',
                'suffix' : '/update'
            },
            'cancelManualEntryLog'                   : apiLink + '/employee/cancel-manual-entry/',
            'syncThirdParty'                         : apiLink + '/employee/sync-third-party/',
            'syncThirdPartyAll'                      : apiLink + '/employee/sync-third-party/all',
            'exportAsExcel'                          : apiLink + '/employee/list/excel?',
            'getInformation'                         : apiLink + '/employee/get-information',
            'verifyEmployeePayrollSetupExcel'        : apiLink + '/employee/payroll/batch-upload/verify',
            'submitEmployeePayrollSetupExcel'        : apiLink + '/employee/payroll/batch-upload/submit',
            'batchCreateExcelDownload'               : apiLink + '/employee/batch-create/download-sample',
            'verifyBatchCreateExcel'                 : apiLink + '/employee/batch-create/verify',
            'submitBatchCreateExcel'                 : apiLink + '/employee/batch-create/submit',
            'checkEmployeeOfficeIdValidity'          : apiLink + '/employee/check-id-validity',
            'subsidiaryAdmin'                        : apiLink + '/employee/subsidiary-admin'
        },
        manualEntry                      : {
            'paginated'             : apiLink + '/manual-entry/',
            'getManualEntryHistory' : apiLink + '/manual-entry/history/',
            'excelUrl'              : apiLink + '/manual-entry/export/excel',
            'getApprovalSystem'     : apiLink + '/manual-entry/get-approver-system/',
            'setApprovalSystem'     : apiLink + '/manual-entry/set-approver-system/'
        },
        firebase                         : {
            'signin' : apiLink + '/notification/firebase/signin'
        },
        auth                             : {
            'signin'  : apiLink + '/auth/signin',
            'signout' : apiLink + '/auth/signout',
            'refresh' : apiLink + '/auth/refresh'
        },
        subsidiary                       : {
            'all' : apiLink + '/subsidiary/',
            'create' : apiLink +'/subsidiary/create-subsidiary',
            'update' : apiLink + '/subsidiary/update-subsidiary'
        },
        designation                      : {
            'all'        : apiLink + '/designation/',
            'updateInfo' : apiLink + '/designation/',
        },
        workplace                        : {
            'all'                  : apiLink + '/workplace/',
            'updateInfo'           : apiLink + '/workplace/',
            'updateBatchWorkplace' : apiLink + '/workplace/batch/'
        },
        department                       : {
            'all'  : apiLink + '/department',
            'list' : apiLink + '/department/',
        },
        subDepartment                    : {
            'all'  : apiLink + '/sub-department',
            'list' : apiLink + '/sub-department/',
        },
        shift                            : {
            'all'                : apiLink + '/shift/',
            'getAllForDashboard' : apiLink + '/shift/for-dashboard',
            'list'               : apiLink + '/shift/list/',
            "getCurrentShift"    : apiLink + '/shift/current',
            'updateBatchShift'   : apiLink + '/shift/updateBatch/'
        },
        shiftGroup                       : {
            'all'    : apiLink + '/shift-group/',
            'create' : apiLink + '/shift-group/',
            'delete' : {
                'prefix' : apiLink + '/shift-group/',
                'suffix' : '/delete'
            }
        },
        dynamicShiftGroup                : {
            'all'    : apiLink + '/dynamic-shift-group',
            'create' : apiLink + '/dynamic-shift-group/create',
            'update' : apiLink + '/dynamic-shift-group/update/'
        },
        shiftn                           : {
            'all'    : apiLink + '/shiftn/',
            'create' : apiLink + '/shiftn/',
            'delete' : {
                'prefix' : apiLink + '/shiftn/',
                'suffix' : '/delete'
            }
        },
        roster                           : {
        'getBasic'           : apiLink + '/roster/',
        'updateBasic'        : apiLink + '/roster/basic/',
        'advanced'           : apiLink + '/roster/advanced/',
        'profile'            : apiLink + '/roster/profile/',
        'getNextShiftChange' : apiLink + '/roster/next-shift-change',
        'getLatestOffday'    : apiLink + '/roster/latest-offday',
        'getShiftTiming'     : apiLink + '/roster/shift-group',
        'downloadRoster'     : apiLink + '/roster/roster-download-excel'
        },
        dashboard                        : {
            'getOverallAndDepartmentWiseAttendance' : apiLink + '/dashboard/overall-and-department-wise-attendance',
            'getAttendanceFeed'                     : apiLink + '/dashboard/attendanceFeed',
            'getCompanyAttendanceFeed'              : apiLink + '/dashboard/company-attendanceFeed',
            'getOverallAndOfficeWiseAttendance'     : apiLink + '/dashboard/company-overall-and-department-wise-attendance',
            'getTopFiveLate'                        : apiLink + '/dashboard/mostLates',
            'getTopFiveLeastLate'                   : apiLink + '/dashboard/leastLates',
            'getSubscriptionStatus'                 : apiLink + '/dashboard/subscription-status',
            'occupancy'                             : apiLink + '/dashboard/occupancy',
            'lateFeed'                              : apiLink + '/dashboard/lates',
            'leaveFeed'                             : apiLink + '/dashboard/employees-on-leave',
            'onTimeFeed'                            : apiLink + '/dashboard/onTime',
            'bestAttendancesFeed'                   : apiLink + '/dashboard/bestAttendance',
            'occupancyReportExcel'                  : apiLink + '/dashboard/occupancy/download-excel',
            'birthday'                              : apiLink + '/dashboard/birthday'
        },
        groupDashboard                   : {
            'getOverAllAndCompanyWiseAttendance' : apiLink + '/group-dashboard/overall-and-company-wise-attendance/',
            'getAttendanceFeed'                  : apiLink + '/group-dashboard/group-attendanceFeed',
            'getTopFiveAbsents'                  : apiLink + '/group-dashboard/mostAbsents',
            'getTopFiveLeastAbsents'             : apiLink + '/group-dashboard/leastAbsents',
            'getCompanyList'                     : apiLink + '/group-dashboard/company'
        },
        attendance                       : {
            'getByFilter'                      : apiLink + "/attendance",
            'getIndividualReport'              : apiLink + "/attendance/individual-attendance-report",
            'getByFilterDailySummary'          : apiLink + "/attendance/daily-summary",
            'getByFilterDailyAbsent'           : apiLink + "/attendance/daily-absent",
            'getByFilterDailyLate'             : apiLink + "/attendance/daily-late-report",
            'getByFilterMonthlyAbsent'         : apiLink + "/attendance/monthly-absent",
            'getByFilterLeaveHistory'          : apiLink + "/attendance/leave-history",
            'getLeaveBalance'                  : apiLink + "/attendance/leave-balance",
            'uploadRemainingLeaveBalanceExcelFile' : apiLink + "/attendance/leave-balance/upload-excel",
            'downloadSampleExcelFile'          : apiLink + "/attendance/leave-balance-sample",
            'getPunchReport'                   : apiLink + "/attendance/punch-report",
            'getMobilePunchReport'             : apiLink + "/mobile-punch/",
            'getMobilePunchReportExcel'        : apiLink + "/mobile-punch/report/excel",
            'getLocationTrackReport'           : apiLink + "/location-tracking/",
            'getLocationTrackingReportExcel'   : apiLink + "/location-tracking/report/excel",
            'getPunchReportExcel'              : apiLink + "/attendance/punch-report/excel/",
            'getPandemicReport'                : apiLink + "/attendance/pandemic-report",
            'leaveLateAbsent'                  : apiLink + "/attendance/leave-late-absent",
            'detailedBoth'                     : apiLink + "/attendance/detailed/both/",
            'detailedBothExcel'                : apiLink + "/attendance/detailed/both/export/excel/",
            'manualEntryForBothTypeAttendance' : apiLink + "/attendance/manual-entry/both-type/",
            'createMissingPunch'               : apiLink + "/attendance/missing-punch/",
            'createManualEntry'                : apiLink + "/attendance/manual-entry/",
            'getExcel'                         : apiLink + "/attendance/export-attendance-report",
            'getExcelAllPages'                 : apiLink + "/attendance/export-attendance-report-all-pages",
            'getWorkingHourExcel'              : apiLink + "/attendance/export-attendance-report/working-hour",
            'getWorkingHourPdf'                : apiLink + "/attendance/download/working-hour-report-pdf",
            'getPdf'                           : apiLink + "/attendance/export-attendance-report/pdf",
            'leaveLateAbsentExcel'             : apiLink + '/attendance/lla-report-excel',
            'lateReportPdf'                    : apiLink + '/attendance/download/late-report-pdf',
            'getMonthlyReportExcel'            : apiLink + "/attendance/monthly-attendance-report",
            'getMonthlyReportPdf'              : apiLink + "/attendance/monthly-attendance-report/pdf",
            'getMonthlyVerticalReportPdf'      : apiLink + "/attendance/monthly-attendance-report/pdf/vertical",
            'getProfileAttendanceExcel'        : apiLink + "/attendance/profile-attendance-report",
            'getLateAttendanceHistory'         : apiLink + "/attendance/late-entries/",
            'getMonthlyTimesheetApproval'      : apiLink + "/monthly-timesheet-approval/",
            'getManualEntryReport'             : apiLink + "/attendance/manual-entry-report/",
            'getManualEntryReportExcel'        : apiLink + "/attendance/manual-entry-report-excel/",
            'deleteAttendanceLogEntry'         : apiLink + "/attendance/detailed/both/delete-entry/",
            'getUnrecognisedLogs'              : apiLink + "/attendance/unrecognised",
            'getUnrecognisedLogReportExcel'    : apiLink + "/attendance/unrecognised/download-excel",
            'getDailyReportExcel'              : apiLink + "/attendance/daily-report-excel",
            'getDailyReportExcelAllPages'      : apiLink + "/attendance/daily-report-excel-all-pages",
            'getDailyReportPdf'                : apiLink + "/attendance/daily-report-pdf",
            'getDailyAbsentReportExcel'        : apiLink + "/attendance/daily-absent-excel",
            'getDailyAbsentReportPdf'          : apiLink + "/attendance/daily-absent-pdf",
            'getDailyLateReportExcel'          : apiLink + "/attendance/daily-late-report-excel",
            'getDailyLateReportPdf'            : apiLink + "/attendance/daily-late-report-pdf",
            'getMonthlyAbsentReportExcel'      : apiLink + "/attendance/monthly-absent-excel",
            'getMonthlyAbsentReportPdf'        : apiLink + "/attendance/monthly-absent-pdf",
            'getMonthlyReportExcelV5'          : apiLink + "/attendance/monthly-report-excel",
            'getMonthlyReportPdfV5'            : apiLink + "/attendance/monthly-report-pdf",
            'getDetailedMonthlyReportExcelV5'  : apiLink + "/attendance/detailed-monthly-report-excel",
            'getDetailedMonthlyReportExcelAllPages'  : apiLink + "/attendance/detailed-monthly-report-excel-all-pages",
            'getDetailedMonthlyReportPdfV5'    : apiLink + "/attendance/detailed-monthly-report-pdf",
            'getLeaveHistoryReportExcel'      : apiLink + "/attendance/leave-history-excel",
            'getLeaveBalanceReportExcel'       : apiLink + "/attendance/leave-balance-report-excel",
            'getLeaveHistoryReportPdf'        : apiLink + "/attendance/leave-history-pdf",
            'getServerOccupancyReport'         : apiLink + "/attendance/server-occupancy",
            'getServerRoomOccupancyReportExcel': apiLink + "/attendance/server-occupancy/download-excel",
            'getSiteAttendanceReportUrl'       : apiLink + "/site-management/site-report",
            'getSiteAttendanceReportUrlExcelUrl': apiLink + "/site-management/site-report/download-excel",
            'getSiteAttendanceReportUrlPdfUrl'  : apiLink + "/site-management/site-report/download-pdf",
            'getIndividualMonthlyAttendanceExcel' : apiLink + "/attendance/individual-attendance-report-excel",
            'getIndividualMonthlyAttendancePdf' : apiLink +  "/attendance/individual-attendance-report-pdf",
            'getDailyDiningReport'              : apiLink + "/attendance/daily-dining-report",
            'getDailyDiningReportExcel'         : apiLink + "/attendance/daily-dining-report-excel",
            'getDailyDiningReportPdf'         : apiLink + "/attendance/daily-dining-report-pdf",
            'getMonthlyDiningReportExcel'         : apiLink + "/attendance/monthly-dining-report-excel",
            'getMonthlyDiningReportPdf'         : apiLink + "/attendance/monthly-dining-report-pdf",
            'getMonthlyDiningReport'            : apiLink + "/attendance/monthly-dining-report",
            'getDetailedDiningReportExcel'         : apiLink + "/attendance/detailed-dining-report-excel",
            'getDetailedDiningReportPdf'         : apiLink + "/attendance/detailed-dining-report-pdf",
            'getDetailedDiningReport'            : apiLink + "/attendance/detailed-dining-report",
            'getLocationDeviation'             : apiLink + "/attendance/location-deviation",
            'getLocationDeviationExcel'        : apiLink + "/attendance/export-location-deviation-report",
            'getLocationDeviationExcelAllPages': apiLink + "/attendance/export-location-deviation-all-pages",
        },
        company                          : {
            'all' : apiLink + '/company/'
        },
        office                           : {
            'all'            : apiLink + '/office/',
            'companyOffices' : apiLink + '/office/company/',
            'getBillingInfo' : apiLink + '/office/get-billing-info'

        },
        holiday                          : {
            'all'    : apiLink + '/holiday/',
            'create' : apiLink + '/holiday/'
        },
        specialDay: {
            'all'    : apiLink + '/special-day',
            'fetch'  : apiLink + '/special-day',
            'create' : apiLink + '/special-day/create-special-day',
            'update' : apiLink + '/special-day/update-special-day/',
            'delete' : apiLink + '/special-day/update-special-day/',

        },

        leavePolicy                      : {
            'all'                           : apiLink + '/leave-policy/',
            'list'                          : apiLink + '/leave-policy/list/',
            'updateName'                    : apiLink + '/leave-policy/update-name/',
            'delete'                        : apiLink + '/leave-policy/delete/',
            'updateDetails'                 : apiLink + '/leave-policy/updateDetails/',
            'addLeaveCategoryToLeavePolicy' : {
                'prefix' : apiLink + '/leave-policy/',
                'suffix' : '/leave-per-category/add/'
            },
            'updatePolicyPerCategory'       : {
                'prefix' : apiLink + '/leave-policy/leave-per-category/',
                'suffix' : '/update/'
            },
            'deleteLeavePerCategory'        : {
                'prefix' : apiLink + '/leave-policy/leave-per-category/',
                'suffix' : '/delete/'
            },
            'updateBatchLeavePolicy'        : apiLink + '/leave-policy/updateBatch/',
            'batchCarryOn'                  : apiLink + '/leave-policy/carry-on-batch/',
            'employeeLeavePolicy'           : apiLink + '/leave-policy/employee/'
        },
        leaveCategoryPolicyConfiguration : {
            'all'                      : apiLink + '/leave-category-policy',
            'create'                   : apiLink + '/leave-category-policy/create/',
            'policywiseConfigurations' : apiLink + '/leave-category-policy/configs-by-leave-policy/',
            'delete'                   : apiLink + '/leave-category-policy/delete/',
            'update'                   : apiLink + '/leave-category-policy/update/',
            'addNewToExistingPolicy'   : apiLink + '/leave-category-policy/add-new/',
            'deleteByPolicy'           : apiLink + '/leave-category-policy/delete-by-policy/',
        },
        employmentType                   : {
            'all' : apiLink + '/employment-type/',
        },
        leaveCategory                    : {
            'all' : apiLink + '/leave-category/'
        },
        weeklyOffDaysPolicy              : {
            'all'                            : apiLink + '/weekly-off-days/',
            'update'                         : apiLink + '/weekly-off-days/',
            'updateBatchWeeklyOffDaysPolicy' : apiLink + '/weekly-off-days/updateBatch/'
        },
        remainingLeaves                           : {
            'employeeRemainingLeaves'             : apiLink + '/remaining-leave/',
            'employeeRemainingLeavesInFiscalYear' : apiLink + '/remaining-leave/fiscal-year/',
            'exchangeLeave'                       : apiLink + '/remaining-leave/exchange-leave/',
            'allLeaves'                           : apiLink + '/remaining-leave/all/',
            'approversLeaves'                     : apiLink + '/remaining-leave/approvers/',
            'getDistinctDateRange'                : apiLink + '/remaining-leave/distinct-date-ranges/'

        },

        leaveManagement                : {
            'applyForLeave'                            : apiLink + '/leave-management/apply/employee/',
            'updateLeaveLog'                           : apiLink + '/leave-management/update/employee/',
            'cancelLeaveLog'                           : apiLink + '/leave-management/cancel/employee/',
            'applyForHalfDayLeave'                     : apiLink + '/leave-management/apply/employee/half/',
            'rejectLeave'                              : apiLink + '/leave-management/reject/',
            'approveLeave'                             : apiLink + '/leave-management/approve/',
            'getHalfDayApplicationsOfApprover'         : apiLink + '/leave-management/half-day/applications/approver/',
            'setLeaveFirstApproverBatch'               : apiLink + '/leave-management/set-approver/batch/',
            'isEmployeeEligibleForLeave'               : apiLink + '/leave-management/leave-eligibility/employee/',
            'getAllLeaveApplications'                  : apiLink + '/leave-management/all-leave-applications/',
            'getAllLeaveApplicationsInFiscalYear'      : apiLink + '/leave-management/fiscal-year-all-leave-applications/',
            'approveOrRejectHalfDayLeave'              : apiLink + '/leave-management/approve-reject/half-day/',
            'getAllLeaveLogs'                          : apiLink + '/leave-management/all-leave-logs/',
            'getApplicationDetails'                    : apiLink + '/leave-management/application-details/',
            'getAcceptedLeaveLogs'                     : apiLink + '/leave-management/accepted-leaves/',
            'currentAndUpdatedLeaveApplicationDetails' : apiLink + '/leave-management/application-latest-history/',
            'adjustLeaveApplication'                   : apiLink + '/leave-management/adjust/',
            'cancelLeaveApplication'                   : apiLink + '/leave-management/cancel/',
            'getLeaveHistory'                          : apiLink + '/leave-management/leave-history/',
            'getApprovalSystem'                        : apiLink + '/leave-management/get-approver-system/',
            'setApprovalSystem'                        : apiLink + '/leave-management/set-approver-system/',
            'getSequentialLeaveApprovalSystem'         : apiLink + '/leave-management/sequential-approval/'
        },
        device                         : {
            'getAllWithEnrolmentFeature' : apiLink + '/devices/enrolment-feature/',
            'getAll'                     : apiLink + '/devices/',
            'allocate'                   : apiLink + '/devices/allocate/',
            'allocateEmployee'           : apiLink + '/devices/allocate/employees/',
            'allocateOrRevokeEmployeeToAccessArea': apiLink + '/devices/allocate/access-area',
            'getAllocations'             : apiLink + '/devices/allocations/',
            'getAllocatedAnUnallocated'  : apiLink + '/devices/allocated-unallocated/',
            'batchAllocate'              : apiLink + '/devices/allocateBatch/',
            'batchRevoke'                : apiLink + '/devices/revokeBatch/',
            'allocateBatchToManyDevice'  : apiLink + '/devices/allocateBatchToManyDevice/',
            'temporarilyAllocate'        : apiLink + '/devices/allocate/temporary/',
            'temporarilyAllocateMultiple'        : apiLink + '/devices/allocate/temporary/multiple',
            'employeeAllocations'        : apiLink + '/devices/employeeAllocations/',
            'startEnrolment'             : apiLink + '/devices/start/',
            'stopEnrolment'              : apiLink + '/devices/stop/',
            'personEnrolmentStart'       : apiLink + '/devices/person-enrolment/start/',
            'enrolmentStats'             : apiLink + '/devices/stats/',
            'updateDevice'               : apiLink + '/devices/edit/',
            'getAllScheduledAllocations' : apiLink + '/devices/scheduled_allocations/',
            'allocateEveryone'           : apiLink + '/devices/allocate-all/',
            'getTemporaryPermissions'    : apiLink + '/devices/temporary-permissions/',
        },
        overtime                       : {
            'report'                  : apiLink + '/overtime/report/',
            'changeStatus'            : apiLink + '/overtime/change-status/',
            'excelReport'             : apiLink + '/overtime/excel-report',
            'overtimeReportPdf'               : apiLink + '/overtime/download/overtime-report-pdf',

            'getProfileOvertimeExcel' : apiLink + "/overtime/profile-overtime-report",
            'monthlyOvertimeExcel'    : apiLink + "/overtime/monthly-overtime-report",
            'updateApprovedOvertime'  : apiLink + "/overtime/approve-overtime/",
            'getPendingOvertimeCount' : apiLink + "/overtime/pending-overtime/"

        },
        educationHistory               : {
            'getAll' : apiLink + '/employee/',
            'update' : apiLink + '/employee/education-history/',
            'delete' : apiLink + '/employee/education-history/delete/'
        },
        employmentHistory              : {
            'getAll' : {
                'prefix' : apiLink + '/employee/',
                'suffix' : '/employment-history/'
            },
            'update' : apiLink + '/employee/employment-history/',
            'delete' : apiLink + '/employee/employment-history/delete/'
        },
        scheduledEmployeeCreateRequest : {
            'getAll' : apiLink + '/scheduled-employee-create-requests/',
            'retry'  : apiLink + '/scheduled-employee-create-requests/retry/'
        },
        lateApprovalManagement         : {
            'applyForLateApproval'                   : apiLink + '/late-approval-management/apply/employee/',
            'rejectLateApprovalRequest'              : apiLink + '/late-approval-management/reject/',
            'acceptLateApprovalRequest'              : apiLink + '/late-approval-management/approve/',
            'setLateFirstApproverBatch'              : apiLink + '/late-approval-management/set-approver/batch/',
            'getAllLateApprovalApplications'         : apiLink + '/late-approval-management/approval-requests/',
            'getLateAttendanceRecordsOfAnEmployee'   : apiLink + '/late-approval-management/late-entries/',
            'getPendingLateApprovalLogsOfAnEmployee' : apiLink + '/late-approval-management/late-approvals/',
            'cancelLateApproval'                     : apiLink + '/late-approval-management/late-approvals/',
            'getApprovalSystem'                      : apiLink + '/late-approval-management/get-approver-system/',
            'setApprovalSystem'                      : apiLink + '/late-approval-management/set-approver-system/'
        },
        manualEntryApprovalManagement         : {
            'setManualEntryApproverBatch'              : apiLink + '/employee/set-manual_entry_approver/batch/',
            'getAllLateApprovalApplications'         : apiLink + '/late-approval-management/approval-requests/',
            'getLateAttendanceRecordsOfAnEmployee'   : apiLink + '/late-approval-management/late-entries/',
            'getPendingLateApprovalLogsOfAnEmployee' : apiLink + '/late-approval-management/late-approvals/',
            'cancelLateApproval'                     : apiLink + '/late-approval-management/late-approvals/',
            'getApprovalSystem'                      : apiLink + '/manual-entry/get-approver-system/',
            'setApprovalSystem'                      : apiLink + '/manual-entry/set-approver-system/'
        },
        monthlyTimesheetApproval       : {
            'getHrApplications' : apiLink + '/monthly-timesheet-approval/pending/',
            'approve'           : apiLink + '/monthly-timesheet-approval/approve/'
        },

        sms                            : {
            'getEmployee' : apiLink + '/sms/getlist',
            'send'        : apiLink + '/sms/send'
        },
        project                        : {
            'all' : apiLink + '/project-work/',
            'filtered' : apiLink + '/project-work/all',
            'simple' : apiLink + '/project-work/list',
            'create' : apiLink + '/project-work/create',
            'update' : apiLink + '/project-work/update',
            'delete' : apiLink + '/project-work/delete-project/',
            'deleteTdhProject' : apiLink + '/project-work/delete/',
            'getAllProducts': apiLink+'/product/get-all/',
            'deleteProduct': apiLink+'/product/delete/',
            'createProduct': apiLink+'/product/create/',
            'editProduct': apiLink+'/product/update/',
            'createProductSegment': apiLink+'/product-segment/create/',
            'getAllProductSegments': apiLink+'/product-segment/get-all/',
            'simplifiedProductList' : apiLink + '/product/get-all/simple',
            types : {
                'all' : apiLink + '/project-type/get-all',
                'create' : apiLink + '/project-type/create'
            }
        },
        projectIssues : {
            'create' : apiLink + '/project-issue/create',
            'update' : apiLink + '/project-issue/edit',
            'search' : apiLink + '/project-issue/search',
            'details' : apiLink + '/project-issue/details/',
            'allLogs' : apiLink + '/project-issue/logs',
            'updateLog' : apiLink + '/project-issue/log/update',
            'creators' : apiLink + '/project-issue/creators',
            'removeCreator' : apiLink + '/project-issue/remove-creator/',
            'addCreator' : apiLink + '/project-issue/add-creator/'
        },
        task                           : {
            'all' : apiLink + '/task/',
        },
        team                           : {
            'all' : apiLink + '/team/',
        },
        projectClient                  : {
            organisationType : {
                'all' : apiLink + '/organisation-type/all',
                'create' : apiLink + '/organisation-type/create'
            },
            'all' : apiLink + '/project-management/clients',
            'create' : apiLink + '/project-management/clients/create',
            'update' : apiLink + '/project-management/clients/update',
            'delete' : apiLink + '/project-management/clients/delete/',
            'simplifiedList' : apiLink + '/project-management/clients/list'
        },
        notification                   : {
            'getAllNotifications'                                   : apiLink + '/notification/',
            'getNotificationsSettingsByEmpId'                       : apiLink + '/notification/',
            'getNotificationsSettingsByEmpIdAndNotificationGroups'  : apiLink + '/notification/get-all/',
            'markAllAsRead'                                         : apiLink + '/notification/mark-all-as-read/',
            'markAsRead'                                            : apiLink + '/notification/mark-as-read/',
            'updateBatchNotificationSettings'                       : apiLink + '/notification/settings/updateBatch/',
            'updateBatchNotificationSettingsByEmployeeId'           : apiLink + '/notification/settings/updateBatch/',
            'getAllEmployee'                                        : apiLink + '/notification/employee/',
            'getNotificationSummary'                                : apiLink + '/notification/summary/',
            'getEmployeeListByNotificationGroup'                    : apiLink + '/notification/employee/'
        },
        temporaryPermissions           : {
            'getTemporaryPermissionsHistory' : apiLink + '/temporary-permission/',
            'cancelOrRevoke'                 : apiLink + '/temporary-permission/cancel/'
        },
        payrollManagement              : {
            'salaryComparison'               : apiLink + '/payroll-management' + '/salary-comparison-summary',
            'salaryComparisonExcelUrl'       :apiLink + '/payroll-management' + '/salary-comparison-summary'+'/download-excel',
            // 'salaryComparison'               : apiLink+'/payroll-report/comparison-report',
            'createPayrollSettings'          : apiLink + '/payroll-management' + '/settings/create',
            'getPayrollSettingsStatus'       : apiLink + '/payroll-management' + '/settings-status/',
            'updatePayrollSettings'          : apiLink + '/payroll-management' + '/settings/update',
            'createPayrollComponent'         : apiLink + '/payroll-management' + '/settings/component',
            'getPayrollSettingsData'         : apiLink + '/payroll-management' + '/settings/',
            'getPayrollSettingsByComTypeAndStatus': apiLink + '/payroll-management' + '/settings-by-type-status/',
            'getSalaryManagementList'        : apiLink + '/payroll-management' + '/salary-management',
            'getEmployeePayrollComponents'   : apiLink + '/payroll-management/employee-payroll/components/',
            'setupEmployeePayrollComponents' : apiLink + '/payroll-management/employee-payroll/setup/',
            'getProcessedSalaries'           : apiLink + '/payroll-management/generated-salary/processed',
            'getUnprocessedSalaries'         : apiLink + '/payroll-management/generated-salary/unprocessed',
            'getSalarySummary'               : apiLink + '/payroll-management/generated-salary/summary',
            'generateSalary'                 : apiLink + '/payroll-management/generate-salary/',
            'updateSalaryDetails'            : apiLink + '/payroll-management/generated-salary/edit',
            'processSalary'                  : apiLink + '/payroll-management/generated-salary/process',
            'undoSalary'                     : apiLink + '/payroll-management/generated-salary/undo',
            'sendForApproval'                : apiLink + '/payroll-management/generated-salary/request-for-approval/',
            'getEmployeeInfoWithSalary'      : apiLink + '/payroll-management/employee-info/',
            'generateSalaryCertificate'      : apiLink + '/payroll-management/salary-certificate/',
            'getProfilePaymentDetails'       : apiLink +  '/payroll-management/profile-payroll?employeeId=',
            'postProfilePaymentDetails'       : apiLink +  '/payroll-management/profile-payroll?employeeId=',
            'downloadSalaryCertificate'      : apiLink + '/payroll-management/salary-certificate/download/',
            'approveSalary'                  : apiLink + '/payroll-management/generated-salary/approve/',
            'rollbackSalary'                 : apiLink + '/payroll-management/generated-salary/roll-back/',
            'paySalary'                      : apiLink + '/payroll-management/generated-salary/pay/',
            'salaryLog'                      : apiLink + '/payroll-management/salary-log/',
            'downloadSalaryReport'           : apiLink + '/payroll-management/salary/download',
            'getSampleExcelFile'             : apiLink + '/payroll-management/salary/download-sample',
            'getEmpAddPayComponent'          : apiLink + '/payroll-management/employee-additional-salary-component',
            'getAbsentLwpComponent'          : apiLink + '/payroll-management/employee-lwp-component',
            'getPayslipData'                 : apiLink + '/payroll-management/payslip',
            'getMonthOnMonthComparison'      : apiLink + '/payroll-management/month-on-month-comparison',
            'saveMonthOnMonthComparisonRemarks': apiLink + '/payroll-report/month-on-month-comparison-remarks/save',
            'getBankAdviceSummary'           : apiLink + '/bank-management/bank/payment-advice/summary',
            'getMonthOnMonthComparisonReportExcel': apiLink + "/payroll-report/month-on-month-comparison-excel",
            'getBankPaymentAdviceDetails'    : apiLink + '/bank-management/individual-payment/',
            'updateIndividualBankPayment'    : apiLink + '/bank-management/individual-payment/update',

        },
        loanManagement:{
            'loanSummaryOfOffice': apiLink + '/loan/loan-summary-of-office',
            'getAllLoan': apiLink + '/loan/all',
            'addNewLoan': apiLink + '/loan/add-new',
            'getEmployeeLastLoan': apiLink + '/loan/employee-previous-loan',
            'deferALoan': apiLink + '/loan/defer',
            'settleALoan': apiLink + '/loan/settle',
            'getInstallmentsOfLoan':apiLink+'/loan/instalments/',
            'getProfileWithLoanInfo':apiLink+'/loan/employee-previous-loan/',
            'addNewLoanForAnEmployee':apiLink+'/loan/add-new/',
            'editCurrentLoanOfAnEmployee':apiLink+'/loan/edit-loan/',
            'loanAdvSalaryDetailsReport' : apiLink+'/loan/detailsReport/',

        },
        additionalPayrollComponents : {
            'addLeaveWithoutPay' : apiLink + '/additional-component/absent-salary-calculation',
            'updateLeaveWithoutPay' : apiLink + '/additional-component/absent-salary-calculation/update',
            'createAdditionalForEmployee' : apiLink + '/additional-component/employee-payroll/create',
            'updateAdditionalForEmployee' : apiLink + '/additional-component/employee-payroll/update',
            'uploadAdditionalComponentExcelFile' : apiLink + '/additional-component/upload-excel',
            'uploadLeaveApplyCalculationExcelFile' : apiLink + '/additional-component/upload-absent-salary-calculation',
            'deleteSingAdditional' : apiLink + '/additional-component/employee-record/delete',
            'downloadAdditionalComponentSampleExcel' : apiLink + '/additional-component/additional-component-sample',
            'downloadLeaveApplySampleExcel' : apiLink + '/additional-component/absent-leave-salary-sample'
        },
        bankManagement : {
            'getAllBranches' : apiLink + '/bank-management/bank/branch',
            'getAllBanks' : apiLink + '/bank-management/bank',
            'createNewBank' : apiLink + '/bank-management/bank/create',
            'updateBank' : apiLink + '/bank-management/bank/update',
            'createNewBranch' : apiLink + '/bank-management/bank/branch/create',
            'updateBranch' : apiLink + '/bank-management/bank/branch/update',
            'downloadAdviceLetter' : apiLink + '/bank-management/download-advice-letter',
            'saveBankPaymentAdviceEditorData': apiLink + '/bank-management/save-bank-payment-advice/',
            'getBankPaymentAdviceEditorData': apiLink + '/bank-management/get-bank-payment-advice/',
        },
        providentFund:{
            "getMemberList"              : apiLink + '/provident-fund/members',
            "getPFMemberDetails"         : apiLink + '/provident-fund/member-details',
            "addPFMember"                : apiLink + '/provident-fund/member/add',
            "getPFStatement"             : apiLink + '/provident-fund/statement/',
            "getPFAccountYear"           : apiLink + '/provident-fund/account-year',
            "getPFAccountSummary"        : apiLink + '/provident-fund/accounts/summary',
            "getPFMemberAccountDetails"  : apiLink + '/provident-fund/accounts/',
            "uploadInterest"             : apiLink + '/provident-fund/accounts/upload-interest/',
            "getUploadInterestStatus"    : apiLink + '/provident-fund/accounts/yearly-account/',
            "closeAccountingYear"        : apiLink + '/provident-fund/accounts/close/',
            "getYearlyAccountDetails"    : apiLink + '/provident-fund/accounts/details/',
            "uploadSeparationPayment"    : apiLink + '/provident-fund/accounts/upload-separation-payment/',
            "uploadForfeitedAmount"      : apiLink + '/provident-fund/accounts/upload-forfeited-amount/',
            "getAccountingYear"          : apiLink + '/provident-fund/accounts/active-yearly-account/',
            "getPFMemberExcel"           : apiLink + '/provident-fund/members/excel',
            "getAccountManagementExcel"  : apiLink + '/provident-fund/accounts/summary/excel/',
            "getStatementPdf"            : apiLink + '/provident-fund/statement/pdf/',
        },
        mobilePunch                    : {
            'updatePermission' : apiLink + '/mobile-punch/batch-update-mobile-punch-status/',
            'getExcel'         : apiLink + '/mobile-punch/get-mobile-punch-excel/'
        },
        geoFencing                    : {
            'all'                        : apiLink + '/geo-fencing',
            'updateGeoFencingPermission' : apiLink + '/geo-fencing/batch-update-geo-fencing-status/',
            'getExcel'                   : apiLink + '/geo-fencing/get-geo-fencing-excel/'
        },
        locationTrackingAccess                 : {
            'all'                              : apiLink + '/location-tracking-access-setting',
            'updateLocationTrackingPermission' : apiLink + '/location-tracking-access-setting/batch-update-location-tracking-access-status/',
            'getExcel'                         : apiLink + '/location-tracking-access-setting/get-location-tracking-access-excel/'
        },
        visitorCategory                : {
            'all'    : apiLink + '/visitor-category/',
            'delete' : apiLink + '/visitor-category/delete/',
            'update' : apiLink + '/visitor-category/update/'
        },
        visitPurpose                   : {
            'all'    : apiLink + '/visit-purpose/',
            'delete' : apiLink + '/visit-purpose/delete/',
            'update' : apiLink + '/visit-purpose/update/'
        },
        visitors                       : {
            'all'            : apiLink + '/visitor/all-visitors',
            'blocked'        : apiLink + '/visitor/blocked-visitors',
            'upcoming'       : apiLink + '/visitor/upcoming',
            'oneInfo'        : apiLink + '/visitor/',
            'visitorUpdate'  : apiLink + '/visitor/update/',
            'delete'         : apiLink + '/visit-purpose/delete/',
            'update'         : apiLink + '/visit-purpose/update/',
            'visitorHistory' : apiLink + '/visitor/visit-history/',
            'upcomingVisit'  : apiLink + '/visitor/upcoming-visit/',
            'block'          : apiLink + '/visitor/block/',
            'unblock'        : apiLink + '/visitor/unblock/',
            'search'         : apiLink + '/visitor/search'
        },
        visitHistory                   : {
            'allCheckOut'                 : apiLink + '/visit-history/checkouts/',
            'checkOutInfo'                : apiLink + '/visit-history/checkouts/',
            'checkOutVisitor'             : apiLink + '/visit-history/check-out/',
            'checkIn'                     : apiLink + '/visit-history/check-in',
            'createAppointmentAndCheckIn' : apiLink + '/visit-history/new-appointment/check-in'
        },
        appointmentLog                 : {
            'all'    : apiLink + '/appointment/appointment-log/',
            'cancel' : apiLink + '/appointment/cancel/'
        },
        visitorCard                    : {
            'all'            : apiLink + '/visitor-card',
            'create'         : apiLink + '/visitor-card/create',
            'batch'          : apiLink + '/visitor-card/batch-create',
            'edit'           : apiLink + '/visitor-card/edit',
            'activate'       : apiLink + '/visitor-card/activate/',
            'deactivate'     : apiLink + '/visitor-card/deactivate/',
            'delete'         : apiLink + '/visitor-card/delete/',
            'availableCards' : apiLink + '/visitor-card/available',
            'downloadSample' : apiLink + '/visitor-card/download-sample'
        },
        assignRole                     : {
            'all'    : apiLink + '/employee-role/visitor-management/',
            'delete' : apiLink + '/employee-role/visitor-management/delete/',
            'update' : apiLink + '/employee-role/visitor-management/update/',
        },
        visitorAccessArea              : {
            'all' : apiLink + '/visitor-access-area',
        },
        appointment                    : {
            'create'             : apiLink + '/appointment/create',
            'availableVisitors'  : apiLink + '/appointment/available-visitors',
            'visitorsOfToday'    : apiLink + '/appointment/visitors/today',
            'getAppointmentInfo' : apiLink + '/appointment/',
            'updateAppointment'  : apiLink + '/appointment/update/',
        },
        accessArea               : {
            'all'    : apiLink + '/visitor-access-area/',
            'delete' : apiLink + '/visitor-access-area/delete/',
            'update' : apiLink + '/visitor-access-area/update/'
        },
        parkingManagement: {
            billSetup :{
                'all'            : apiLink + '/vehicle-type/',
                'delete'         : apiLink + '/vehicle-type/delete/',
                'update'         : apiLink + '/vehicle-type/update/',
            },
            vehicle :{
                "getAll"             : apiLink + '/vehicle/',
                "save"               : apiLink + '/vehicle/save',
                "delete"             : apiLink + '/vehicle/delete/',
                "searchVehicle"      : apiLink + '/vehicle/search/'
            },
            parkingSlot :{
                "getAll"       : apiLink + '/parking-slot' + '/',
                "save"      : apiLink + '/parking-slot' + '/save',
                "delete"      : apiLink + '/parking-slot' + '/delete/',
            },
            'entryVehicle'       : apiLink + '/parking-summary/entry-vehicle/',
            'liveFeed'           : apiLink + '/parking-summary/live-feed/',
            'enteredVehicle'     : apiLink + '/parking-summary/entered-vehicle/',
            'summaryDetails'     : apiLink + '/parking-summary/',
            'exitVehicle'        : apiLink + '/parking-summary/exit-vehicle/',
            'exitWithoutPrint'   : apiLink + '/parking-summary/exit-without-print/',
            'slotInfo'           : apiLink + '/parking-summary/slot-info/',
            'dailyReport'        : apiLink + '/parking-summary/daily-report/',
            'monthlyReport'      : apiLink + '/parking-summary/monthly-report/',
            'monthlyReportPdf'   : apiLink + '/parking-summary/monthly-report/pdf',
            'monthlyReportExcel' : apiLink + '/parking-summary/monthly-report/excel',
            'dailyExcelURL'      : apiLink + '/parking-summary/daily-report/excel/',
            'dailyReportPdfURL'  : apiLink + '/parking-summary/daily-report/pdf/',
            'nearbyVehicle'      : apiLink + '/parking-summary/nearby-vehicle/entry',
            'nearbyVehicleExit'  : apiLink + '/parking-summary/nearby-vehicle/exit',
            'nearbyVehicleDetails': apiLink + '/vehicle/details/'
        },
        siteManagement            :{
            'allSiteData'         : apiLink + '/site-management/sites',
            'createNewSite'       : apiLink + '/site-management/',
            'getDetailsOfOneSite' : apiLink + '/site-management/',
            'getSiteManagers'     : apiLink + '/site-management/available-managers',
            'updateSite'          : apiLink + '/site-management/update/',
            'addEmployeeToSite'   : apiLink + '/site-management/add-employee-to-site/',
            'deleteSite'          : apiLink + '/site-management/delete/',
            'siteSummaryReport'   : apiLink + '/site-management/site-summary/',
            'siteSummaryReportPdf': apiLink + '/site-management/site-summary/download-pdf/',
            'siteSummaryReportExcel': apiLink + '/site-management/site-summary/download-excel/',
            'getDashboardSummary'  : apiLink + '/site-management/dashboard-summary',
            'getBarchartDataOfASite'  : apiLink + '/site-management/site-date-bar-chart',
            'getMostlyPresentEmployees'  : apiLink + '/site-management/mostly-present',
            'getMostlyOnTimeEmployees'  : apiLink + '/site-management/mostly-on-time',
            'getTopActiveSites'    : apiLink + '/site-management/top-active-sites',
            assignRole            :{
                'save'            : apiLink + '/employee-role/site-management/save/',
                'delete'          : apiLink + '/employee-role/site-management/delete/'
            }

        },
        externalSync : {
            'syncEmployeesBBL' : apiLink + '/external-sync/employees/bbl/'
        },
        membershipManagement: {
            'all'                     : apiLink + '/membership/package/get/all',
            'createOrEditPackage'     : apiLink + '/membership/package/save',
            'dashboardAllAttendance'     : apiLink + '/membership/dashboard/all-member-feed/',
            'dashboardTotalVisitToday'     : apiLink + '/membership/dashboard/total-visit-today/',
            'dashboardAttendanceFeed'     : apiLink + '/membership/dashboard/attendance-feed/',
            'dashboardBirthday'     : apiLink + '/membership/dashboard/employee-birthday/',
            'deletePackage'           : apiLink + '/membership/package/archive/',
            report:{
              'dailyReport'            :apiLink+ '/membership/report/daily/',
                'dailyReportExcel'            :apiLink+ '/membership/report/daily-report-excel?',
              'monthly'                :apiLink+'/membership/report/monthly/',
                'monthlyReportExcel'            :apiLink+ '/membership/report/monthly-report-excel?',

                'subscription'           :apiLink+'/membership/report/subscription/',
                'subscriptionReportExcel'            :apiLink+ '/membership/report/subscription-report-excel?',

            },
            members : {
                'active'              : apiLink + '/subscription/members',
                'getInfoOfAMember'    : apiLink + '/subscription/',
                'renew'               : apiLink + '/subscription/renew/',
                'createNewMember'     : apiLink + '/subscription/',
                'update'              : apiLink + '/subscription/update/',
                'uploadFile'          : apiLink + '/subscription/upload',
                'upgradeSubscription'          : apiLink + '/subscription/upgrade/',
                'delete'              : apiLink + '/subscription/delete/',
                'removeFile'          : apiLink + '/subscription/document/delete/',
            }
        },
        generalSettings                      : {
            'officeReportSettings'                : apiLink + '/general-settings/office-report-settings/',
            'officeLinemanagerEnrollmentSettings' : apiLink + '/general-settings/linemanager-enrollment-settings/',
            'officeFiscalYearInfo'                : apiLink + '/general-settings/office-fiscal-year/',
        },
    });

    app.constant('aclLevel', {
        value : 'office'
    });

    app.constant('CONSTANT', {
        apiLink : 'http://127.0.0.0:1990/inovace-client/api/v1'
    });

    app.constant('TIME_IN_MILLISECOND', {
        'ONE_SECOND' : 1000,
        'ONE_MINUTE' : 60 * 1000,
        'ONE_HOUR'   : 60 * 60 * 1000,
        'ONE_DAY'    : 24 * 60 * 60 * 1000,
        'SEVEN_DAYS' : 7 * 24 * 60 * 60 * 1000
    });
    app.constant('GENDER', [
        {id : 1, name : "Male"},
        {id : 2, name : "Female"},
        {id : 3, name : "Other"}
    ]);

    app.constant('LEAVE_APPLICABILITY_TYPE', [
        {id : 0, name : "Both"},
        {id : 1, name : "Male"},
        {id : 2, name : "Female"},
        {id : 3, name : "Other"}
    ]);

    app.constant('EMPLOYEE_STATUS', [
        {id : 0, name : "Inactive"},
        {id : 1, name : "Active", ticked : true},
        {id : 2, name : "Terminated"},
        {id : 3, name : "Resigned"},
        {id : 4, name : "Transferred"},
    ]);
    app.constant('ATTENDANCE_STATUS', [
        {id : 1, name : "Present"},
        {id : 5, name: 'On Time'},
        {id : 2, name : "Absent"},
        {id : 3, name : "Late"},
        {id : 4, name : "On Leave"},
        {id : 6, name :"Special Day"},
    ]);

    app.constant('DINING_OPTIONS', [
        {id : -1, name : "Any"},
        {id : 1, name : "Yes"},
        {id : 0, name : "No"}
    ]);

    app.constant('RESIGN_STATUS', [
        {id : 2, name : "Terminate"},
        {id : 3, name : "Resign"}
    ]);
    app.constant('BLOOD_GROUP', [
        {id : "A+", name : "A+"},
        {id : "A-", name : "A-"},
        {id : "B+", name : "B+"},
        {id : "B-", name : "B-"},
        {id : "AB+", name : "AB+"},
        {id : "AB-", name : "AB-"},
        {id : "O+", name : "O+"},
        {id : "O-", name : "O-"}
    ]);

    app.constant('_', window._);

    app.constant('RESPONSE_CODE', {
        success  : 200,
        notFound : 404,
        error    : 500,
        rfid_duplicate: 409
    });

    app.constant('TASK_STATUS', [
        {'name' : 'Done', 'id' : 2},
        {'name' : 'Todo', 'id' : 1}
    ]);

    app.constant('VIDEO_URLS', {
        1  : {
            "title" : "Absent Report",
            "src"   : "https://www.youtube.com/embed/E91393OY7sQ"
        },
        2  : {
            "title" : "Daily Reports",
            "src"   : "https://www.youtube.com/embed/5roerXO50"
        },
        3  : {
            "title" : "Department Report",
            "src"   : "https://www.youtube.com/embed/fvIM7SUGm54"
        },
        4  : {
            "title" : "Detailed Reports",
            "src"   : "https://www.youtube.com/embed/T6Qwg73-HE8"
        },
        5  : {
            "title" : "Late Report",
            "src"   : "https://www.youtube.com/embed/qGMweiEsNXg"
        },
        6  : {
            "title" : "",
            "src"   : ""
        },
        7  : {
            "title" : "Monthly Report",
            "src"   : "https://www.youtube.com/embed/511ACMOXJ28"
        },
        8  : {
            "title" : "Shift Report",
            "src"   : "https://www.youtube.com/embed/hG_FJDEVxCA"
        },
        9  : {
            "title" : "Weekly Report",
            "src"   : "https://www.youtube.com/embed/yjOHjvcdfQI"
        },
        10 : {
            "title" : "Working Hour Report",
            "src"   : "https://www.youtube.com/embed/Y6sLDEyF7nY"
        },
        11 : {
            "title" : "Dashboard",
            "src"   : "https://www.youtube.com/embed/aYyj5yl_Djs"
        },
        12 : {
            "title" : "Device",
            "src"   : "https://www.youtube.com/embed/bx9QbF1FsDk"
        },
        13 : {
            "title" : "",
            "src"   : ""
        },
        14 : {
            "title" : "Create Employee",
            "src"   : "https://www.youtube.com/embed/AjVp6D0rms4"
        },
        15 : {
            "title" : "Manage Employee - Employee Action",
            "src"   : "https://www.youtube.com/embed/mH0VlbBrGzw"
        },
        16 : {
            "title" : "Manage Employee Create Batch",
            "src"   : "https://www.youtube.com/embed/aENGTUoZ_Q8"
        },
        17 : {
            "title" : "Leave Category Policy",
            "src"   : "https://www.youtube.com/embed/GTNaGjDwG30"
        },
        18 : {
            "title" : "Manage Employee Profile",
            "src"   : "https://www.youtube.com/embed/videoseries?list=PLdQvxf4UxZdYi7OUDChavtRG175wlK2fM"
        }
    });
    app.constant('manageEmployeeComponents',
        [
            {
                name  : 'Assign Department',
                value : 'assignDepartment',
            },
            {
                name  : 'Assign Sub Department',
                value : 'assignSubDepartment',
            },
            {
                name  : 'Assign Shift Group',
                value : 'assignShiftGroup'
            },
            {
                name  : 'Assign Designation',
                value : 'assignDesignation',
            },
            {
                name  : 'Assign Leave Policy',
                value : 'assignLeavePolicy',
            },
            {
                name  : 'Assign to Site',
                value : 'assignToSite',
            },
            {
                name  : 'Assign Leave First Approver',
                value : 'assignLeaveFirstApprover',
            },
            {
                name  : 'Assign Leave Second Approver',
                value : 'assignLeaveSecondApprover',
            },
            {
                name  : 'Assign Late First Approver',
                value : 'assignLateFirstApprover',
            },
            {
                name  : 'Assign Late Second Approver',
                value : 'assignLateSecondApprover',
            },
            {
                name  : 'Assign Manual Entry First Approver',
                value : 'assignManualEntryFirstApprover',
            },
            {
                name  : 'Assign Manual Entry Second Approver',
                value : 'assignManualEntrySecondApprover',
            },
            {
                name  : 'Assign Line Manager',
                value : 'assignLineManager',
            },
            {
                name  : 'Assign Hr Manager',
                value : 'assignHrManager',
            },
            {
                name  : 'Set Include In Attendance Report',
                value : 'includeInAttendanceReport',
            },
            {
                name  : 'Set Exclude In Attendance Report',
                value : 'excludeInAttendanceReport',
            },
            {
                name  : 'Allocate To Device',
                value : 'allocateToDevice',
            },
            {
                name  : 'Allocate To Access Area',
                value : 'allocateToAccessArea',
            },
            {
                name  : 'Revoke From Device',
                value : 'revokeFromDevice',
            },
            {
                name  : 'Revoke From Access Area',
                value : 'revokeFromAccessArea',
            },
            {
                name  : 'Temporary Permissions',
                value : 'temporaryPermissions',
            },
            {
                name  : 'Transfer Employees (Company Admin Only)',
                value : 'transferEmployees'
            },
            {
                name  : 'Update Workplace',
                value : 'updateWorkplace',
            },
            {
                name  : 'Update Employment Type',
                value : 'updateEmploymentType',
            },
            {
                name  : 'Delete Employees',
                value : 'deleteEmployees',
            },
            {
                name  : 'Allow or Disallow Overtime',
                value : 'allowOvertime',
            },
            {
                name  : 'Carry Leaves',
                value : 'carryLeaves'
            },
            {
                name  : 'Sync External',
                value : 'syncExternal'
            },
            {
                name     : 'Notification Settings',
                value    : 'notificationSettings',
                disabled : false,
            }
        ])

    app.constant('manageEmployeeComponentsForLineManager',
        [
            {
                name  : 'Assign Shift Group',
                value : 'assignShiftGroup'
            }
        ])

    app.constant('PRINTMEDIABOOTSTRAP',
        {link : "https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css"});

    app.constant('notificationGroups', [
        {
            name  : 'Office Time Reminder',
            value : 100,
            disabled : false
        },
        {
            name  : 'Early Exit  Notification',
            value : 900,
            disabled : false
        },
        {
            name  : 'Absent Notification',
            value : 400,
            disabled : false
        },
        {
            name     : 'Late Entry Notification',
            value    : 200,
            disabled : true
        },
        {
            name     : 'First Punch of This Day Notification',
            value    : 300,
            disabled : false
        },

        {
            name     : 'New Leave Application Notification',
            value    : 500,
            disabled : true
        },
        {
            name     : 'Leave Application Updated  Notification',
            value    : 501,
            disabled : true
        },
        {
            name     : 'Leave Application Approved/Rejected  Notification',
            value    : 502,
            disabled : true
        },
        {
            name     : 'New Late Application Notification',
            value    : 600,
            disabled : true
        },
        {
            name     : 'Late Application Updated  Notification',
            value    : 601,
            disabled : true
        },
        {
            name     : 'Late Application Approved/Rejected  Notification',
            value    : 602,
            disabled : true
        },
        {
            name     : 'New Manual Entry Application Notification',
            value    : 700,
            disabled : true
        },
        {
            name     : 'Manual Entry Application Updated  Notification',
            value    : 701,
            disabled : true
        },
        {
            name     : 'Manual Entry Application Approved/Rejected  Notification',
            value    : 702,
            disabled : true
        },
        {
            name     : 'New Field Visit Application Notification',
            value    : 800,
            disabled : true
        },
        {
            name     : 'Field Visit Application Updated  Notification',
            value    : 801,
            disabled : true
        },
        {
            name     : 'Field Visit Application Approved/Rejected  Notification',
            value    : 802,
            disabled : true
        },

    ]);
    app.constant('notificationSettingsMap',{
            min_before_shift_start    : 'How many minutes before the shift time',
            when_to_check_absent    : 'When to check absent ',
            at_start    : 'At start',
            '30_min_before_start'    : '30 min before start',
            '30_min_after_start'    : '30 min after start',
            at_end    : 'At end',
            when_to_check_early_exit    : 'When to check early exit',
            at_shift_end    : 'At shift end'


        }
    )
    app.constant('notificationTypes', [
        {
            name  : 'SMS',
            value : 1
        },
        {
            name  : 'Email',
            value : 2
        },
        {
            name  : 'Push Notification',
            value : 3
        }
    ]);

    app.constant('LOAN_TYPE', [
        {name:'Advance Salary', value:1 },
        {name:'Loan', value: 2}
    ]);

    app.constant('LOAN_PAYMENT_MODES', [
        {name:'Salary', value: 1 },
        {name:'Cash/Cheque', value: 2}
    ]);

    app.constant('notificationRecipientTypes', [
        {
            name  : 'Employee Himself',
            value : 1
        },
        {
            name  : 'Employee\'s Line Manager',
            value : 2
        },
        {
            name  : 'Employee\'s HR Manager',
            value : 3
        }
    ]);

    app.constant('MODULES', {
        SITE_MANAGEMENT: '12001',
        PROJECT_MANAGEMENT: '10001',
        ISSUE_TRACKER: '100011',
        SUBSIDIARY: '9013'
    });

    app.constant('BANGABHABAN_OFFICE_ID', {
        id: 3871,
        // id:279
    });
    app.constant('INOVACE_OFFICEID', 279);
    app.constant('TDH_OFFICE_ID', 472);

    app.constant('LEAVE_CARRY_TYPES', [
        {id : 0, name : "None"},
        {id : 1, name : "Fixed Amount"},
        {id : 2, name : "Percentage"}
    ]);

    app.constant('LEAVE_APPROVAL_STATUS', [
        {id : 0, name : "Pending"},
        {id : 1, name : "Approved"},
        {id : 2, name : "Rejected"}
    ])

    app.constant('EARNED_LEAVE_CRITERIA', [
        {id : 1, name : "Based on working on holiday/offday"},
        // { id: 2, name : "Based on working overtime" }
    ]);

    app.constant('EARNED_LEAVE_CAP_TYPES', [
        {id : 0, name : "None"},
        {id : 1, name : "Daily"},
        {id : 2, name : "Monthly"},
        {id : 3, name : "Yearly"}
    ]);

    app.constant('EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST', [
        {id : 0, name : "None"},
        {id : 1, name : "Day(s)"},
        {id : 2, name : "Month(s)"},
        {id : 3, name : "Year(s)"}
    ]);

    app.constant('ISSUE_PRIORITIES', [
        {id : 1, value : 1, text : "Low"},
        {id : 2, value : 2, text : "Medium"},
        {id : 3, value : 3, text : "High"}
    ]);

    app.constant('ISSUE_STATUSES', [
        {id : 1, value : 1, text : "Open"},
        {id : 2, value : 2, text : "On going"},
        {id : 3, value : 3, text : "Done"},
        {id : 4, value : 4, text : "Closed"}
    ]);

    app.constant('NUM_OF_DAYS_IN_EACH_TIME_WINDOW', [0, 1, 30, 365]);

    app.constant('MONTH_NAMES', ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]);
    app.constant('MONTH_NAMES_SHORT', ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);

    app.constant('APPOINTMENT_REPETITION_TYPES', [
        {id : 0, name : "None"},
        {id : 1, name : "Everyday"},
        {id : 2, name : "Every Week"},
        {id : 3, name : "Every Month"}
    ]);

    app.constant('APPOINTMENT_INVITATION_TYPES', [
        // { id: 1, name : "SMS"},
        {id : 2, name : "Email"}
    ]);

    app.constant('VISITOR_QUESTIONS', [
        {index : 0, value : false, label : "Fever (100.4° F/37.8° C or greater as measured by an oral thermometer)"},
        {index : 1, value : false, label : "Shortness of breath or difficulty breathing"},
        {index : 2, value : false, label : "Sore throat"},
        {index : 3, value : false, label : "New loss of taste or smell"}
    ]);
    app.constant('COMPONENT_TYPE', [
        {value : 1, name : "Basic Pay"},
        {value : 2, name : "Allowance"},
        {value : 3, name : "Long Term Benefit"},
        {value : 4, name : "Non Cash Benefit"},
        {value : 5, name : "Additional"},
        {value : 6, name : "Bonus"},
        {value : 7, name : "Arrears"},
        {value : 8, name : "LWP Deduction"},
        {value : 9, name : "Absent Deduction"},
        {value : 10,name : "Income Tax Deduction"},
        {value : 11,name : "Loan Deduction"},
    ]);
    app.constant('COMPONENT_CATEGORY', [
        {value : 1, name : "Additive"},
        {value : -1, name : "Deductive"},
    ]);
    app.constant('COMPONENT_GROUP', [
        {value : 1, name : "Master"},
        {value : 2, name : "Additional"},
    ]);
    app.constant('PARENT_COMPONENT', [
        {value : 0, name : "None"},
        {value : 1, name : "Gross Salary"},
        {value : 2, name : "Basic Salary"},
    ]);
    app.constant('VALUE_TYPE', [
        {value : 1, name : "Percentage"},
        {value : 2, name : "Fixed Amount"},
        {value : 3, name : "Variable"},
    ]);
    app.constant('PAYMENT_MODE', [
        {value : 1, name : "Monthly"},
        {value : 2, name : "Yearly"},
    ]);
    app.constant('VALUE_DETERMINER',[
        {value : 0, name : "None" },
        {value : 1, name : "Gross"},
        {value : 2, name : "Basic"}
    ]);
    app.constant('REPORT_SETTINGS', {
        viewMonthLimit : 12,
        downloadMonthLimit : 1
    });
    app.constant('CREATE_EMPLOYEE_GUARD', {
        moduleCode: '14001',
        limit: 10,
        stateName: 'createEmployee'
    });
    app.constant('ANALYTICS_CONSTANT',{
        mainAnalyticsId: 'G-2JMNQ44BH2',
        testAnalyticsId: 'G-8BWV5GM2DE',
        open: 'Open',
        tab: 'tab',
        modal: 'modal',
        apply: 'apply',
        edit: 'edit',
        save: 'Save',
        delete: 'Delete',
        create: 'create',
        confirm: 'Confirm',
        takePicture: 'Take Picture',
        next: 'Next',
        ok: 'Ok',
        downloadExcel: 'Download Excel',
        downloadPdf: 'Download PDF',
        downloadVerticalPdf: 'Downlolad Vertical PDF',
        excelUrl: 'download-excel',
        pdfUrl: 'download-pdf',
        verticalPdfUrl: 'download-vertical-pdf',
        search: 'search',
        createEmployeeUrl: 'create-employee',
        createEmployeeTitle: 'Create Employee',
        sort: 'sort',
        selectAllUrl: 'select-all',
        selectAllTitle: 'Select All',
        select: 'select',
        saveUrl: 'save',
        enrolment: 'enrolment',
        employeeAction: 'employee-action',
        advancedOption: 'advanced-option',
        downloadSample: 'download-sample',
        activateAll: 'activate-all',
        deactivateAll: 'deactivate-all',
        notificationForAll: 'notification-for-all',
        upload: 'upload',
        retry: 'retry',
        add: 'add',
        download: 'download',
        basicView: 'basic-view',
        advancedView: 'advanced-view',
        showDetailedView: 'show-detailed-view',
        adjust: 'adjust',
        applyLeave: 'apply-leave',
        viewError: 'view-error',
        view: 'view',
        uploadExcel: 'upload-excel',
        viewDetails: 'view-details',
        approve: 'approve',
        reject: 'reject',
        remove: 'remove',
        addNewComponent: 'add-new-component',
        yes: 'yes',
        verify: 'verify',
        update: 'update',
        generateSalary: 'generate-salary',
        viewSalaryReport: 'view-salary-report',
        salaryLog: 'Salary Log',
        generateReport: 'generate-report',
        print: 'print',
        submit: 'submit',
        changePassword: 'change-password',
        projectDedication: 'project-dedication',
        employeeDocuments: 'employee-documents',
        enrol: 'Enrol',
        set: 'set',
        include: 'include',
        change: 'change',
        attendanceReport: 'attendance-report',
        devicePermissions: 'device-permissions',
        payroll: 'payroll',
        pendingApproval: 'pending-approval',
        cancel: 'cancel',
        close: 'close',
        profileSearch : 'profile-search',
        devices : 'devices',
        allocate : 'allocate',
        revoke : 'revoke',
        assign : 'assign',
        transfer : 'transfer',
        change : 'change'
        }
    );
    app.constant('GP_CLIENT_OFFICE_IDS', [116,207,206,222,226,228,229,240,242,247,248,249,251,253,260,262,269,270,273,276,277,288,289,361,362,366,368,370,371,373,376,377,380,381,382,383,384,387,389,391,393,394,395,397,390,392,388,396,398,399,400,401,402,403,404,405,406,407,409,411,413,416,415,414,412,410,408,417,418,419,431,432,433,442,445,449,450,453,456,457,458,460,461,462,463,464,465,466,467,468,469,470,471,473,474,475,477,479,482,489,490,491,494,498,499,509,533,584,647,748,749,770,785,799,857,885,888,889,892,911,915,1043,1160,1284,1342,1435,1873,1939,1943,2258,3454,3679,3689,3742,3748,3771,3807,3823]);

    app.constant('GBPL_CLIENT_OFFICE_IDS', [544,566,567,571,579,588,616,623,626,628,634,636,637,639,640,645,648,656,658,659,662,663,664,665,667,668,669,670,671,672,676,677,679,681,682,691,692,696,700,701,702,706,708,710,711,712,713,714,715,716,717,718,719,720,721,723,725,727,729,731,733,740,746,747,750,752,756,757,759,760,766,777,780,781,783,784,786,797,801,804,806,811,812,813,817,818,819,821,823,827,830,831,832,836,837,839,844,845,846,847,851,852,855,856,858,859,866,870,871,874,875,877,882,883,887,890,894,898,900,902,907,909,912,913,916,918,921,922,925,926,928,929,930,931,932,933,936,937,938,939,940,941,942,943,946,947,967,968,969,974,975,977,980,999,1003,1004,1007,1017,1051,1054,1068,1070,1082,1089,1110,1116,1118,1136,1140,1144,1146,1150,1154,1172,1176,1186,1194,1204,1227,1236,1246,1248,1250,1252,1255,1270,1276,1280,1285,1297,1337,1352,1358,1367,1372,1373,1374,1375,1376,1390,1411,1421,1430,1436,1438,1440,1443,1444,1445,1446,1449,1454,1455,1457,1459,1460,1496,1497,1553,1555,1556,1635,1691,1702,1769,1940,1941,1944,1983,2003,2107,2122,2133,2146,2169,2236,2464,2853,2854,2858,2862,2864,2865,2866,2867,2868,2872,2884,2886,2911,2960]);

    app.constant('INACTIVITY_DURATION', 7200000); // 2 hours

    app.constant('INACTIVITY_LOGOUT_DISABLED_OFFICE_IDS', [661])

    app.constant('LINE_MANAGER_MODULE', 2017);

}).call(this);

(function () {
    app.constant('ENGLISH_MODIFIED_BANGABHABAN', {
        //General
        submit                            : 'Submit',
        apply                             : 'Apply',
        pleaseWait                        : 'Please wait ...',
        confirm                           : 'Confirm',
        approve                           : 'Approve',
        type                              : 'Type',
        endDate                           : 'End Date',
        designation                       : 'Designation',
        employmentType                    : 'Employment Type',
        department                        : 'Section',
        shift                             : 'Shift',
        shiftGroup                        : 'Shift Group',
        company                           : 'Company',
        workplace                         : 'Workplace',
        location                          : 'Location',
        deleteConfirmation                : 'Do you want to delete this',
        remove                            : 'Remove',
        description                       : 'Description',
        link                              : 'Link',
        search                            : 'Search',
        dateRange                         : 'Date Range',
        attendanceReportOf                : 'Attendance Report of',
        fieldVisitReportOf                : 'Field Visit Report of',
        date                              : 'Date',
        reason                            : 'Reason',
        entryTime                         : 'Entry Time',
        lateBy                            : 'Late By',
        approvalOne                       : 'Approval One',
        approvalTwo                       : 'Approval Two',
        status                            : 'Status',
        pending                           : 'Pending',
        accepted                          : 'Accepted',
        rejected                          : 'Rejected',
        cancelled                         : 'Cancelled',
        notApplied                        : 'Not Applied',
        timeLine                          : 'Timeline',
        hrApproval                        : 'HR Manager Approval',
        firstApproval                     : 'First Approver Status',
        secondApproval                    : 'Second Approver Status',
        lineApproval                      : 'Section Officer Approval',
        detailedAttendanceLogs            : 'Detailed Attendance Logs',
        time                              : 'Time',
        device                            : 'Device',
        entryType                         : 'Entry Type',
        manualEntry                       : 'Manual Entry',
        addNewManualEntry                 : 'Add New Manual Entry',
        manualEntryInfo                   : 'Manual Entry Info (If Applicable)',
        notApplicable                     : 'Not Applicable',
        requestor                         : 'Requestor',
        punchType                         : 'Punch Type',
        first                             : 'First',
        last                              : 'Last',
        showing                           : 'Showing',
        showingPage                       : 'Showing page ',
        outOf                             : 'out of ',
        pages                             : 'pages',
        missingPunch                      : 'Missing Punch',
        selectType                        : 'Select Type',
        fieldVisitText                    : 'Field Visit',
        leaveApplyForOthers               : 'Apply Leave for other employees',
        leaveApplication                  : 'Leave Application',
        category                          : 'Category',
        numberOfDays                      : 'Number Of Days',
        timeline                          : 'Timeline',
        file                              : 'File',
        hand                              : 'Hand',
        finger                            : 'Finger',
        template                          : 'Template',
        left                              : 'Left',
        right                             : 'Right',
        or                                : 'Or',
        register                          : 'Register',
        delete                            : 'Delete',
        selectADevice                     : 'Select a Device',
        start                             : 'Start',
        stop                              : 'Stop',
        selectAType                       : 'Select a Type',
        selectAYear                       : 'Select a Year',
        full                              : 'Full',
        half                              : 'Half',
        startAndEndDate                   : 'Start and End Date',
        leaveCategory                     : 'Leave Category',
        selectACategory                   : 'Select a Category',
        uploadFile                        : 'Upload File',
        startDate                         : 'Start Date',
        leaveHalf                         : 'Leave Half',
        selectALeaveHalf                  : 'Select a Leave Half',
        firstHalf                         : 'First Half',
        secondHalf                        : 'Second Half',
        identifier                        : "Identifier",
        phoneNumber                       : 'Phone Number',
        mobile                            : 'Mobile',
        from                              : 'From',
        to                                : 'To',
        timing                            : 'Timing',
        action                            : 'Action',
        actions                           : 'Actions',
        edit                              : 'Edit',
        update                            : 'Update',
        cancel                            : 'Cancel',
        exitTime                          : 'Exit Time',
        applyForLateApproval              : 'Apply for Late Approval',
        selectADate                       : 'Select A Date',
        areYouSureYouWantToChangeStatusOf : 'Do you want to change status of ',
        areYouSureYouWantTo               : 'Do you want to',
        include                           : 'include',
        changeEmployeeStatus              : 'Change Employee Status',
        forTheEmployees                   : 'for the employees',
        yes                               : 'Yes',
        no                                : 'No',
        employeeResignation               : 'Employee Resignation',
        rehireEmployee                    : 'Rehire Employee',
        remark                            : 'Remark',
        resignationDate                   : 'Resignation Date',
        documentUpload                    : 'Document Upload',
        documentType                      : 'Document Type',
        upload                            : 'Upload',
        rowsPerPage                       : 'Rows Per Page',
        count                             : 'Count',
        name                              : 'Name',
        employeeName                      : 'Employee Name',
        lineManager                       : 'Section Officer',
        manualEntryFirstApprover          : 'First Approver',
        manualEntrySecondApprover         : 'Second Approver',
        hrManager                         : 'HR Manager',
        monthWithColon                    : 'Month:',
        dateRangeWithColon                : 'Date Range:',
        monthlyAttendanceReport           : 'Monthly Attendance Report',
        weeklyAttendanceReport            : 'Weekly Attendance Report',
        mask                              : 'Mask',
        temperature                       : 'Temperature',
        viewOnlyUnknownPeopleLogs         : 'View only unknown people logs',
        viewAllUnauthorisedLogs           : 'View All unauthorised logs',
        rfidCard                          : 'RFID Card',
        inOut                             : 'In/Out',
        loginPageTitle                    : 'Login - Tipsoi HR Management',
        loginPageText                     : 'নির্ভুল, সহজতর এবং সময়সাশ্রয়ী ব্যবস্থাপনায় টিপসই HRM',
        geoLocationBased                  : 'GEO-Location Based',
        smartAttendanceSystem             : 'Smart Attendance System',
        email                             : 'Email',
        emailOrEmployeeId                 : "Email/Employee ID",
        password                          : 'Password',
        active                            : 'Active',
        inactive                          : 'Inactive',
        success                           : 'Success!',
        confirmation                      : 'Confirmation',
        remarks                           : 'Remarks',
        employeeEmployee                  : 'Search Employee',
        pleaseSelect                      : 'Please Select',
        none                              : 'None',
        na                                : 'N/A',
        pushNotification                  : 'Push Notification',
        year                              : 'Year',
        total                             : 'Total',
        searchEmployee                    : 'Search Employee',
        amount                            : 'Amount',



        //Table Summaries
        sl                   : 'SL',
        id                   : 'ID',
        entry                : 'Entry',
        exit                 : 'Exit',
        present              : 'Present',
        absent               : 'Absent',
        earlyExit            : 'Early Exit',
        leave                : 'Leave',
        late                 : 'Late',
        pendingLate          : 'Pending Late',
        approval             : 'Approval',
        applicationStatus    : 'Application\nStatus',
        applications         : 'Applications',
        today                : 'Today',
        given                : 'Given',
        totalLate            : 'Total Late',
        thisMonth            : 'This Month',
        InHours              : 'in Hours',
        dayOff               : 'Day off',
        expected             : 'Expected',
        average              : 'Average',
        actual               : 'Actual',
        difference           : 'Difference',
        hours                : 'Hours',
        noAttendanceFound    : 'Sorry no attendance data found within given limit or filters',
        noDataFound          : 'Sorry no data found within given limit or filters',
        noLeaves             : 'No leaves.',
        totalWorked          : 'Total Worked',
        expectedWorkingHour  : 'Expected Working Hour',
        offDays              : 'Off Days',
        holidays             : 'Holidays',
        specialDays          : 'Special Days',
        totalEmployees       : 'Total Employees',
        totalAbsentDays      : 'Total Absent Days',
        totalWorkingHourLoss : 'Total Working Hour Loss',
        totalOnTime          : 'Total on Time',
        workingDays          : 'Working Days',
        expectedHours        : 'Expected Hours',
        workingHours         : 'Working Hours',
        fieldVisits          : 'Field Visits',
        averageWorkingHour   : 'Average Working Hour',
        otHours              : 'OT Hours',
        absentDays           : 'Absent Days',
        leaveDays            : 'Leave Days',
        noOfFieldVisits      : 'Field Visits',
        lateHours            : 'Late Hours',
        overTimeHours        : 'Overtime Hours',
        employeeType         : 'Employee Type',
        office               : 'Office',
        totalAbsent          : 'Total Absent',
        totalPresent         : 'Total Present',
        lastAbsent           : 'Last Absent',
        last30dayAbsent      : 'Absent in Last 30 Days',
        days                 : 'Days',
        dates                : 'Dates',
        noOutPunch           : 'No Out Punch',
        employeeId           : 'Employee Id',
        dateOfJoining        : 'Date Of Joining',
        paymentMethod        : 'Payment Method',
        routingNo            : 'routingNo',
        earnings             : 'Earnings',
        amountInBDT          : 'Amount(in BDT)',
        deduction            : 'Deduction',
        bankName             : 'Bank Name',
        numberOfEmployees    : 'Number of Employees',
        netPayment           : 'Net Payment',
        bankPayment          : 'Bank Payment',
        cashPayment          : 'Cash Payment',
        accountNo            : 'Account No',
        bank                 : 'Bank',
        cash                 : 'Cash',
        totalSalary          : 'Total Salary',
        totalDeduction       : 'Total Deduction',
        netPayable           : 'Net Payable',
        latitude             : 'Latitude',
        longitude            : 'Longitude',
        siteName             : 'Site Name',
        siteManager          : 'Site Manager',
        differance           : 'Differance',
        leaveType            : 'Leave Type',
        entitled             : 'Entitled',
        balance              : 'Balance',
        joiningDate          : 'Joining Date',
        confirmationDate     : 'Confirmation Date',
        membershipDate       : 'Membership Date',
        separationDate       : 'Separation Date',
        memberName           : 'Member Name',
        contactNumber        : 'Contact Number',
        package              : 'Package',
        packageAmount        : 'Package Amount',
        expiryDate           : 'Expiry Date',
        totalMember          : 'Total Member',
        hour                 : 'Hour',
        totalHourSpent       : 'Total Hour Spent',
        approvedLates        : 'Approved Lates',
        leaveApprovalStatus  : 'Approval Status',




        vehicleNumber        : 'Vehicle Number',
        ownerOrDriverName    : 'Owner/Driver Name',
        driverName           : 'Driver Name',
        ownerName            : 'Owner Name',
        driverMobileNumber   : 'Driver Mobile Number',
        parkingType          : 'Parking Type',
        totalHours           : 'Total Hours',
        billTk               : 'Bill Amount',
        employee             : 'Employee',
        visitor              : 'Visitor',
        totalParking         : 'Total Parking',
        totalHour            : 'Total Hour',
        totalEmployee        : 'Total Employee',
        onTime               : 'On Time',
        totalSites           : 'Total Sites',
        whenToCheckAbsent    : 'When to Check Absent',





        leaveHistoryReportOf         : 'Leave History Report Of ',
        totalLeaveDays               : 'Total Leave Days',
        totalWorkingHourLossForLeave : 'Total Working Hour Loss For Leave',


        //Side-Bar Texts
        dashboard                : 'Dashboard',
        attendanceReport         : 'Attendance Report',
        detailedAttendanceReport : 'Detailed Attendance',
        departmentReport         : 'Section Report',
        shiftReport              : 'Shift Report',
        monthlyReport            : 'Monthly Report',
        detailedMonthlyReport    : 'Detailed Monthly Report',
        weeklyReport             : 'Weekly Report',
        dailyReport              : 'Daily Report',
        siteAttendanceReport     : 'Site Attendance Report',
        siteSummaryReport        : 'Site Summary Report',
        leaveReport              : 'Leave Report',
        monthlyAbsentReport      : 'Absent Summary Report',
        lateReport               : 'Late Report',
        workingHourReport        : 'Working Hour Report',
        employees                : 'Employees',
        manageEmployees          : ' Manage Employees',
        createBatch              : 'Create Batch',
        settings                 : 'Settings ',
        designations             : 'Designations',
        employmentTypes          : 'Employment Types',
        departments              : 'Sections',
        subDepartments           : 'Sub Sections',
        workplaces               : 'Workplaces',
        shiftManagement          : 'Shift Management',
        shifts                   : 'Shifts',
        shiftGroups              : 'Shift Groups',
        roster                   : 'Roster',
        leaveCategories          : 'Leave Categories',
        leavePolicy              : 'Leave Policy',
        pendingApprovals         : 'Pending Approvals',
        leaveApplicationDetails  : 'Leave Application Details',
        deviceList               : 'Device List',
        deviceAllocationDetails  : 'Device Allocation Details',
        allocationHistory        : 'Allocation History',
        overtimeMenu             : 'Overtime Menu',
        overtimeMonthlySummary   : 'Monthly Summary',
        overtimeReport           : 'Overtime Report',
        overtimeAllocator        : 'Overtime Allocator',
        sms                      : 'SMS',
        projectManagement        : 'Project Management',
        pandemicReport           : 'Pandemic Report',
        fieldVisitReport         : 'Field Visit Report',
        dynamicShiftGroups       : 'Dynamic Shift Groups',

        //Absent Repost Texts
        absentReport      : 'Absent Report',
        dailyAbsentReport : 'Daily Absent Report',

        leaveHistoryReport : "Leave History Report",
        leaveBalanceReport : "Leave Balance Report",

        //Salary Reports
        salaryReport               : 'Salary Report',
        salaryComparisonSummary    : {
            title      : 'Salary Comparison Summary',
            component  : 'Component',
            difference : 'Difference',
        },
        individualSalaryComparison : 'Individual Salary Comparison',
        monthOnMonthComparison     : 'Month on Month Comparison',
        //Dashboard Texts

        dashboardPresent         : 'Present',
        dashboardAbsent          : 'Absent',
        dashboardLate            : 'Late',
        dashboardOntime          : 'On Time',
        departmentWiseAttendance : 'Section Wise Attendance',
        officeWiseAttendance     : 'Office Wise Attendance',
        companyWiseAttendance    : 'Company Wise Attendance',
        mostAbsents              : 'Most Absents',
        mostLates                : 'Most Lates',
        lateToday                : 'On-Time Today',
        onLeave                  : 'Best Attendances This Month',
        leastAbsents             : 'Least Absents',
        leastLates               : 'Least Lates',
        attendanceFeed           : 'Attendance Feed',
        calender                 : 'Calender',

        userLogin : {
            signInFailed   : 'Sign in Failed',
            incorrectInput : 'Incorrect email or password'
        },
        //Profile Texts
        //Profile Information -->
        notSet      : 'Not Set',
        remarksHere : 'Remarks Here',
        notAssigned : 'Not Assigned',
        generalInfo : {
            name           : 'Name',
            id             : 'ID',
            identifier     : 'Identifier',
            email          : 'Email',
            department     : 'Section',
            subDepartment  : 'Sub Section',
            designation    : 'Designation',
            employmentType : 'Employment Type',
            shiftGroup     : 'Shift Group',
            gender         : 'Gender',
            primaryText    : 'Primary Text',
            secondaryText  : 'Secondary Text',
            rfid           : 'RFID',
            reportPosition : 'Report Position',
            leavePolicy    : 'Leave Policy',
            joiningDate    : 'Joining Date',
            endDate        : 'End Date',
            workplace      : 'Workplace',
            lineManager    : 'Section Officer',
            hrManager      : 'HR Manager',
            site           : 'Site'

        },
        //Approver Information
        approverInformation : {
            firstLeaveApprover  : 'First Leave Approver',
            secondLeaveApprover : 'Second Leave Approver',
            firstLateApprover   : 'First Late Approver',
            secondLateApprover  : 'Second Late Approver',
            firstManualEntryApprover   : 'First Manual Entry Approver',
            secondManualEntryApprover  : 'Second Manual Entry Approver'
        },

        //Personal And Contact Information
        personalAndContactInformation : {
            fathersName   : 'Father\'s Name',
            mothersName   : 'Mother\'s Name ',
            bloodGroup    : 'Blood Group',
            dateOfBirth   : 'Date of Birth',
            nationalId    : 'National ID',
            officePhone   : 'Office Phone',
            homePhone     : 'Home Phone',
            cellPhone     : 'Cell Phone',
            personalPhone : 'Personal Phone'

        },
        //Address
        address : {
            address        : 'Address',
            noAddressFound : 'No Address Found',
            permanent      : 'Permanent',
            present        : 'Present',
            home           : ' Home',
            subDistrict    : 'Thana',
            district       : 'District',
            addAddress     : 'Add Address'
        },
        //Change Password
        changePassword : {
            password        : 'Password',
            confirmPassword : 'Confirm Password'
        },
        //Employment History
        employmentHistory : {
            employmentHistory       : 'Employment History',
            createEmploymentHistory : 'Create Employment History',
            editEmploymentHistory   : 'Edit Employment History',
            companyName             : 'Company Name',
            companyBusiness         : 'Company Business',
            responsibilities        : 'Responsibilities',
            notFound                : 'No Employment History provided. Please click here to add one.'

        },
        //Education History
        educationHistory : {
            educationHistory       : 'Education History',
            createEducationHistory : 'Create Education History',
            editEducationHistory   : 'Edit Education History',
            deleteConfirmation     : 'Do you want to delete this education history?',
            notFound               : 'No Education History provided. Please click here to add one.',
            degreeName             : 'Degree Name',
            institution            : 'Institution',
            board                  : 'Board',
            year                   : 'Year',
            grade                  : 'Grade',

        },
        //Employee Documents
        employeeDocuments : {
            documents : 'Documents',
            notFound  : 'No Documents Found',
            ssc       : 'SSC Certificate',
            hsc       : 'HSC Certificate',
            bachelors : 'Bachelors Certificate',
            passport  : 'Passport',
            nid       : 'NID'
        },
        //Profile Actions
        profileActions : {
            applyForLeave               : 'Apply for Leave',
            applyForLateApproval        : 'Apply for Late Approval',
            manualEntry                 : 'Manual Entry',
            enrolFingerprint            : 'Enrol Fingerprint',
            removeAdminRole             : 'Remove Admin Role',
            setAsAdmin                  : 'Set as Admin',
            setAsHrManager              : 'Set as HR Manager',
            removeHrManagerRole         : 'Remove HR Manager Role',
            setAsLineManager            : 'Set as Section Officer',
            removeLineManagerRole       : 'Remove Section Officer Role',
            makeEmployeeStatusActive    : 'Make Employee Status Active',
            makeEmployeeStatusInactive  : 'Make Employee Status Inactive',
            resignEmployee              : 'Resign Employee',
            rehireEmployee              : 'Rehire Employee',
            deleteEmployee              : 'Delete Employee',
            disallowOvertime            : 'Disallow Overtime',
            allowOvertime               : 'Allow Overtime',
            includeInAttendanceReport   : 'Include in Attendance Report',
            include                     : 'include',
            excludeFromAttendanceReport : 'Exclude From Attendance Report',
            syncEmployee                : 'Sync Employee',
            setAsSiteManager            : 'Set as Site Manager',
            removeSiteManagerRole       : 'Remove Site Manager Role',
            removeSiteAdminRole         : 'Remove Site Admin Role',
            setAsSiteAdmin              : 'Set as Site Admin',
            setAsProjectManager         : 'Set as Project Manager',
            removeProjectManagerRole    : 'Remove Project Manager Role'

        },
        //Profile Attendance Report
        profileAttendanceReport : {
            punchDeleteModal : {
                title            : 'Confirmation',
                confirmationText : 'Are you sure you want to delete this punch'
            }
        },

        //Dashboard
        dashboardText : {
            degreeCelsius             : '°C',
            warning                   : '**Warning: Your subscription has expired.<br />Please pay your due yearly subscription fees to avoid interruption in your service connectivity.<br />If you have already cleared all of your due fees, you can ignore this message.',
            warningForGBPLClients     : '**Warning: Your subscription to Tipsoi Smart Attendance System has expired.<br />Please call 01313359293 and pay your due subscription fees to avoid interruption in your service connectivity. If you have already paid, please ignore this message.',
            warningForGPClients       : '**Warning: Your subscription has expired.<br />Please contact GrameenPhone, your service will be interrupted after 25 June 2022.<br />If you have already cleared all of your due fees, you can ignore this message.',
            reminderTextPart1         : '**Reminder: Your subscription will be expired within',
            reminderTextPart2         : 'days. Please pay your yearly subscription fee to avoid interruption in service connectivity.',
            time                      : 'Time:',
            late                      : 'Late',
            totalLates                : 'Shift Start Time -',
            lineManager               : 'Section Officer -',
            noOneIsOnLeaveText        : 'No best attendance data found for this month.',
            from                      : 'From:',
            date                      : 'Date:',
            total                     : 'Total',
            day                       : 'day',
            s                         : 's',
            toWithColon               : 'To:',
            name                      : 'Name',
            workingDays               : 'Working Days',
            absent                    : 'Absent',
            occupancyDashboardHeading : 'Occupancy Dashboard',
            inside                    : 'Inside',
            outside                   : 'Outside',
            totalPresent              : 'Present - ',
            totalOnTime               : 'On-Time - ',

        },

        //Employees
        //Manage Employees
        manageAllEmployees : {
            title                   : 'Manage Employees',
            filter                  : {
                offices           : 'Offices',
                company           : 'Company',
                office            : 'Office',
                departments       : 'Sections',
                subDepartments    : 'Sub Sections',
                designations      : 'Designations',
                shiftGroups       : 'Shift Groups',
                gender            : 'Gender',
                workplace         : 'Workplace',
                subsidiary        : 'Subsidiary',
                status            : 'status',
                searchByName      : 'Search By Name/ID/RFID',
                employmentType    : 'Employment Type',
                searchButton      : 'Search',
                mobilePunchStatus : 'Mobile Punch Status',
            },
            createEmployeeButton    : 'Create Employee',
            employeeActionButton    : 'Employee Action',
            showEnrolmentButton     : 'Show Enrolment',
            downloadExcelButton     : 'Download Excel',
            selectAllButton         : 'Select All',
            sortByButton            : 'Sort By',
            rowPerPageInputLabel    : 'Rows Per Page',
            selectOption            : {
                rowPerPageValue_10   : '10',
                rowPerPageValue_50   : '50',
                rowPerPageValue_100  : '100',
                rowPerPageValue_1000 : '1000',
            },
            emptyResultText         : 'No employees with given filter found',
            employeeListTableHeader : {
                image          : 'Image',
                id             : 'ID',
                name           : 'Name',
                office         : 'Office',
                department     : 'Section',
                shiftGroup     : 'Shift Group',
                employmentType : 'Employment Type',
                designation    : 'Designation',
                workplace      : 'Workplace',
                lineManager    : 'Section Officer',
                status         : 'Status',
                fingerprints   : 'Fingerprints',
                rfid           : 'RFID'
            }
        },

        //Create Employee
        createEmployee : {
            title                : 'Create Employee',
            selectGender         : 'Select Gender',
            selectDesignation    : 'Select Designation',
            selectDepartment     : 'Select Section',
            selectSubDepartment  : 'Select Sub Section',
            selectLeavePolicy    : 'Select Policy',
            selectEmploymentType : 'Select Employment Type',
            selectShiftGroup     : 'Select Shift Group',
            selectWorkplace      : 'Select Workplace',

            inputForm    : {
                name                 : 'Name',
                email                : 'Email',
                gender               : 'Gender',
                password             : 'Password',
                confirmPassword      : 'Confirm Password',
                uploadImage          : 'Upload Image',
                startDate            : 'Start Date',
                designation          : 'Designation',
                department           : 'Section',
                subDepartment        : 'Sub Section',
                leavePolicy          : 'Leave Policy',
                employmentType       : 'Employment Type',
                shiftGroup           : 'Shift Group',
                workplace            : 'Workplace',
                reportPosition       : 'Report Position',
                employeeId           : 'Employee ID',
                rfid                 : 'RFID',
                primaryDisplayText   : 'Primary Display Text',
                secondaryDisplayText : 'Secondary Display Text',
                maxTenChar           : '(Maximum 10 characters)',
                endDate              : 'End Date',
                addEndDate           : 'Add End Date (Optional)'
            },
            errorMsg     : {
                name                 : 'Name is required',
                invalidEmail         : 'Invalid Email',
                emptyEmail           : 'Email is Required',
                password             : 'Password is required',
                invalidCapital       : 'Password does not contain required amount of capital letters: ',
                invalidSmall         : 'Password does not contain required amount of small letters: ',
                invalidSymbol        : 'Password does not contain required amount of special characters: ',
                invalidNumber        : 'Password does not contain required amount of numbers: ',
                consecutiveChar      : 'Password can not have consecutive characters more than ',
                invalidLength        : 'Password does not have required length: ',
                invalidIllegalSymbol : 'Password can only have these special characters: !@#$%^&*',
                invalidPassword      : 'Password is invalid',
                commonPassword       : 'Password can not be a common password or a word in dictionary',
                similarWithUserInfo  : 'Password can not be similar with user information',
                confirmPassword      : 'Password is required',
                department           : 'Select a Section from the list',
                employmentType       : 'Select an Employment Type from the list',
                primaryDisplayText   : 'Primary Display Text is required',
                secondaryDisplayText : 'Secondary Display Text is required',
                startDate            : 'Start Date is required',
                gender               : 'Gender is required',
                shiftGroup           : 'Shift Group is required',
                emptyEmployeeId      : 'Employee ID is required',
                usedEmployeeId       : 'ID is already in use'
            },
            createButton : 'Create New Employee'
        },

        //Create Batch
        employeesBatchCreation : {
            batchCreateTabHeader           : 'Batch Create',
            historyTabHeader               : 'History',
            employeeCreationGuidline       : 'Employee Creation Guidelines',
            employeeCreationGuidlineList   : {
                listItem_1 : 'ID and Email need to be unique for each Employee.',
                listItem_2 : 'Mandatory Fields are marked in the Sample File.',
                listItem_3 : 'RFID number must be the first 10 digits only, e.g. (0002547896).',
                listItem_4 : 'No gaps are allowed between rows. Rows after gap won\'t be counted.',
                listItem_5 : 'Uploaded Excel file must be xls or xlsx only.',
                listItem_6 : 'Primary and Secondary Display Text can not be more than 10 characters.',
                listItem_7 : 'Report Position must be a number.',
            },
            informationChanged             : 'Information Changed',
            employeesTableHeader           : {
                id             : 'ID',
                employeeName   : 'Employee Name',
                email          : 'Email',
                reportPosition : 'Report Position',
                rfid           : 'RFID',
                primaryText    : 'Primary Text',
                secondaryText  : 'Secondary Text',
                joiningDate    : 'Joining Date',
                endDate        : 'End Date',
                workplace      : 'Workplace',
                employmentType : 'Employment Type',
                salary         : 'Salary',
                paymentMethod  : 'Payment Mode',
                bankName       : 'Bank Name',
                accountNumber  : 'Account No',
                routingNumber  : 'Routing No',
            },
            employeesWithNoChangeText      : 'No changes on existing employees',
            NoNewEmployees                 : 'No new employees',
            newEmployee                    : 'New Employee',
            retryButton                    : 'Retry',
            cancelUploadButton             : 'Cancel Upload',
            confirmButton                  : 'Confirm',
            downloadSample                 : 'Download Sample',
            uploadFile                     : 'Upload File',
            chooseFileButton               : 'Choose File',
            noFileChoosen                  : "No File Choosen",
            uploadButton                   : 'Upload',
            batchCreationHistory           : 'Batch Creation History',
            historyTableHeader             : {
                employeeOfficeId : 'Employee ID',
                name             : 'Name',
                email            : 'Email',
                reportPosition   : 'Report Position',
                rfid             : 'RFID',
                primaryText      : 'Primary Text',
                secondaryText    : 'Secondary Text',
                status           : 'Status',
                action           : 'Action'

            },
            historyTableStatusColumnValues : {
                pending : 'Pending',
                failed  : 'Failed',
                done    : 'Done'

            },
            noHistory                      : 'No Batch Creation History Found'
        },

        //Employee Actions
        employeeActions : {
            employeeList              : 'Employee List',
            employeeSelectionLabel    : 'Select Employee',
            employeeSelectButton      : 'Select',
            selectAction              : 'Select Actions',
            allocateToAccessArea      : 'Allocate Employee(s) to access area',
            revokeFromAccessArea      : 'Revoke Employee(s) from access area',
            employeeTableHeader       : {
                name        : 'Name',
                company     : 'Company',
                office      : 'Office',
                department  : 'Section',
                shiftGroup  : 'Shift Group',
                designation : 'Designation',
                action      : 'Action'
            },
            removeButton              : 'Remove',
            saveButton                : 'Save',
            noEmployeeSelected        : 'No Employee Selected',
            assignmentSectionTitle    : {
                includeInAttendanceReport:'Include In Attendance Report',
                excludeInAttendanceReport:'Exclude In Attendance Report',
                includeInAttendanceReportBtn:'Include Selected Employee(s) In Attendance Report',
                excludeInAttendanceReportBtn:'Exclude Selected Employee(s) In Attendance Report',
                department           : 'Assign Section',
                subDepartment        : 'Assign Sub Section',
                subsidiary           : 'Assign Subsidiary',
                shiftGroup           : 'Assign To Shift Group',
                designation          : 'Assign Designation',
                leavePolicy          : 'Assign Leave Policy',
                assignToSite         : 'Assign To Site',
                leaveFirstApprover   : 'Assign Leave First Approver',
                leaveSecondApprover  : 'Assign Leave Second Approver',
                lateFirstApprover    : 'Assign Late First Approver',
                lateSecondApprover   : 'Assign Late Second Approver',
                lineManager          : 'Assign Section Officer',
                hrManager            : 'Assign HR Manager',
                allocateToDevice     : 'Allocate To Device',
                revokeFromDevice     : 'Revoke From Device',
                temporaryPermissions : 'Temporary Permissions',
                employeeTransfer     : 'Transfer Employees',
                updateWorkplace      : 'Update Workplace',
                updateEmploymentType : 'Update Employment Type',
                deleteEmployee       : 'Delete Employees',
                overtime             : 'Allow Or Disallow Overtime',
                leaveCarry           : 'Carry Leaves',
                notificationSettings : 'Notification Settings'
            },
            deleteButton              : 'Delete',
            allowButton               : 'Allow',
            disallowButton            : 'Disallow',
            submitButton              : 'Submit',
            syncButton                : 'Sync',
            fromDateLabel             : 'From',
            toDateLabel               : 'To',
            deviceLabel               : 'Device',
            yearLabel                 : 'Year',
            maxNumberLabel            : 'Maximum',
            thirdPartySyncLabel       : 'Sync From Third Party',
            deleteEmployees           : 'Delete Employees',
            selectADepartment         : 'Select a Section',
            selectASubDepartment      : 'Select a Sub section',
            selectASubsidiary         : 'Select a Subsidiary',
            selectADesignation        : 'Select a designation',
            selectAShiftGroup         : 'Select a shift group',
            selectALeavePolicy        : 'Select a leave Policy',
            selectASite               : 'Select a Site',
            onAllEmployeesSelected    : 'Working with all employees of this office.',
            deleteModal               : {
                title            : 'Delete Employee?',
                confirmationText : 'Are you sure you want to delete the employees?',
                submitButton     : 'Confirm'
            },
            rehireModal               : {
                title            : 'Rehire Employee?',
                confirmationText : 'Are you sure you want to rehire this employee?',
                submitButton     : 'Confirm'
            },
            thirdPartySyncTableHeader : {
                id     : 'ID',
                name   : 'Name',
                status : 'Status'
            },
            notification              : {
                selectGroup                        : 'Select Notification Group',
                selectRecipients                   : 'Select Recipients',
                sms                                : 'SMS',
                email                              : 'Email',
                pushNotification                   : 'Push Notification',
                recipientSelf                      : 'Employee Himself',
                recipientLineManager               : 'Employee\'s Section Officer',
                recipientHRManager                 : 'Employee\'s HR Manager',
                typeSMS                            : 'SMS',
                typeEmail                          : 'Email',
                typePush                           : 'Push Notification',
                moreSettings                       : 'Configure Notification',
                officeTimeNotifyBeforeStartTime    : 'How many minutes before the shift time',
                whenToCheckAbsent                  : 'When to Check absent',
                whenToCheckAbsent_atStart          : 'At Shift Start Time',
                whenToCheckAbsent_30minBeforeStart : '30 Minutes Before Shift Start Time',
                whenToCheckAbsent_atEnd            : 'At Shift End Time',
                whenToCheckEarlyExit               : 'When to Check Early Exit',
                whenToCheckEarlyExit_atEnd         : 'At Shift End Time',
            }
        },
        //Field Visit
        fieldVisit : {
            buttons                       : {
                allFieldVisits      : 'All Field Visits',
                pendingFieldVisits  : 'Pending Field Visits',
                acceptedFieldVisits : 'Accepted Field Visits',
            },
            noResultFoundText             : 'No field visits found with given filters.',
            employeesTableHeader          : {
                employeeName : 'Employee Name',
                dateRange    : 'Date Range',
                status       : 'Status',
                action       : 'Action'
            },
            applyFieldVisitButton         : 'Apply Field Visit',
            applicationInfoHeader         : 'Field Visit Application Information',
            applicationInfoTable          : {
                dateRange         : 'Date Range',
                reason            : 'Reason',
                entry             : 'Entry',
                exit              : 'Exit',
                location          : 'Location',
                hrManagerStatus   : 'Second Approver Status',
                lineManagerStatus : 'First Approver Status',
                firstApproverStatus : '1st Approver Status',
                firstApproverComment : '1st Approver Comment',
                secondApproverStatus : '2nd Approver Status',
                secondApproverComment : '2nd Approver Comment',
                appliedBy         : 'Applied by',
            },
            applyNewFieldVisitHeadingText : 'Apply new field visit',
            selectEmployee                : 'Select Employee',
            selectDateRange               : 'Select Date Range',
            selectTime                    : 'Select Time',
            area                          : 'Area',
            placeholderTextForArea        : 'Enter Area',
            forceApproveText              : 'Approvals needed from Approvers',
            lastFiveFieldVisitHeading     : 'Last 5 Field Visits',
            approvedByAdmin               : 'Approved By Admin',
        },

        syncExternal : {
            guidelinesTitle : 'Employee Sync Guidelines',
            guidelines      : {
                guideline_1 : 'Please confirm with Inovace Support team that the sync functionality has been activated for your office.',
                guideline_2 : 'Enter the ids in a comma separated line below.',
                guideline_3 : 'Please make sure that none of the Designations and Sections in your system has a duplicate name.',
                guideline_4 : 'Refrain from using spaces after the commas.',
            },
            inputIds        : 'Input Ids',
            placeholderText : 'Enter Ids',
            tableHeader     : {
                id     : 'ID',
                name   : 'name',
                status : 'Status'
            },
            syncButton      : 'Sync',
            syncAllButton   : 'Sync All',
            syncAll24hButton : 'Sync changes of last 24 hours'
        },

        companies : {
            createCompany             : 'Create Company',
            editCompany               : 'Edit Company',
            tooltipText2              : 'Edit',
            tooltipText1              : 'Offices',
            name                      : 'Name',
            officeType                : 'Office Type',
            location                  : 'Location',
            description               : 'Description',
            companyTableHeader        : {
                id      : 'ID',
                actions : 'Actions'
            },
            companyDetailsTableHeader : {
                hash        : '#',
                location    : 'Location',
                description : 'Description',
                actions     : 'Actions'
            },
            officeTypeName            : {
                corporate     : 'Corporate',
                factory       : 'Factory',
                noTypeDefined : 'No Type Defined',
            },
            placeholderText           : 'Enter Name',
            saveChangesButton         : 'Save Changes',

            createOfficeModal : {
                createOffice               : 'Create Office',
                placeholderTextLocation    : 'Enter Location',
                placeholderTextDescription : 'Enter Description',
                createOfficeButton         : 'Create Office',
            },
            selectYourOption  : 'Select your option'

        },

        //Offices
        offices : {
            name                   : 'Name',
            location               : 'Location',
            officeType             : 'Office Type',
            description            : 'Description',
            corporate              : 'Corporate',
            attendanceChardHeading : 'Office Attendance Charts',
            officeCharts           : 'Office Charts',
            officeTableHeader      : {
                hash        : '#',
                officeType  : 'Office Type',
                description : 'Description',
            }
        },


        //Common keywords
        commonKeywords        : {
            dateAndTime                    : 'Date &amp; Time',
            statusActive                   : 'Active',
            statusInactive                 : 'Inactive',
            editTooltipText                : 'Edit',
            deleteTooltipText              : 'Delete',
            yesButton                      : 'Yes',
            noButton                       : 'No',
            okButton                       : 'Ok',
            okayButton                     : 'Okay',
            editButton                     : 'Edit',
            viewButton                     : 'View',
            deleteButton                   : 'Delete',
            deleteAllButton                : 'Delete All',
            removeButton                   : 'Remove',
            filterButton                   : 'Filter',
            submitButton                   : 'Submit',
            uploadButton                   : 'Upload',
            searchButton                   : 'Search',
            closeButton                    : 'Close',
            saveButton                     : 'Save',
            saveSettingButton              : 'Save Setting',
            createSiteButton               : 'Create Site',
            editSiteButton                 : 'Edit Site',
            addNewButton                   : 'Add New',
            createButton                   : 'Create',
            updateButton                   : 'Update',
            approveButton                  : 'Approve',
            rejectButton                   : 'Reject',
            viewErrorButton                : 'View Error',
            turnOffButton                  : 'Turn Off',
            createPackageButton            : 'Create Package',
            editPackageButton              : 'Edit Package',
            addNewMemberButton             : 'Add New Member',
            downloadForwardingLetterButton : 'Download Forwarding Letter',

            confirmButton                         : 'Confirm',
            logInButton                           : 'Log In',
            cancelButton                          : 'Cancel',
            renewalButton                         : 'Renewal',
            upgradePackageButton                  : 'Upgrade Package',
            backButton                            : 'Back',
            confirmEntryButton                    : 'Confirm Entry',
            entryVehicle                          : 'Entry Vehicle',
            exitVehicle                           : 'Exit Vehicle',
            printAndExit                          : 'Print & Exit',
            exitVehicleAndPrintReceipt            : 'Confirm Exit',
            excelButton                           : 'Excel',
            uploadExcelButton                     : 'Upload Excel',
            uploadDocumentButton                  : 'Upload Document',
            exportAsPdfButton                     : 'PDF',
            sortByButton                          : 'Sort By',
            printButton                           : 'Print',
            downloadExcelButton                   : 'Download Excel',
            saveChangesButton                     : 'Save Changes',
            advanceOptionsButton                  : 'Advanced Options',
            sl                                    : 'SL',
            notSet                                : 'Not Set',
            na                                    : 'N/A',
            pleaseWait                            : 'Please Wait..',
            searchByNameId                        : 'Search Employee by Name/ID',
            searchVehicle                         : 'Search by Employee Name/ID/Vehicle Number ',
            searchByParking                       : 'Search by Vehicle number/Driver name/Owner name',
            pending                               : 'Pending',
            accepted                              : 'Accepted',
            rejected                              : 'Rejected',
            cancelled                             : 'Cancelled',
            approved                              : 'Approved',
            first                                 : 'First',
            last                                  : 'Last',
            showingPage                           : 'Showing page',
            showing                               : 'Showing',
            outOf                                 : ' out of ',
            pages                                 : 'pages.',
            employeeInformationHeading            : 'Employee Information',
            OwnerInformationHeading               : 'Owner Information',
            memberInformationHeading              : 'Member Information',
            subscriptionInformationHeading        : 'Subscription Information',
            employeeName                          : 'Employee Name',
            ownerName                             : 'Owner Name',
            vehicleNumber                         : 'Vehicle Number',
            companyName                           : 'Company Name',
            employeeNameOrId                      : 'Employee Name/Id',
            employeeId                            : 'Employee ID',
            name                                  : 'Name',
            id                                    : 'ID',
            hash                                  : '#',
            designation                           : 'Designation',
            department                            : 'Section',
            shiftGroup                            : 'Shift Group',
            employmentType                        : 'Employment Type',
            workplace                             : 'Workplace',
            dummyModalText                        : 'Select an entry to see the details',
            dummyModalText2                       : 'Select an employee to see the details',
            from                                  : 'From',
            to                                    : 'To',
            smallTo                               : 'to',
            reason                                : 'Reason',
            placeholderTextForReason              : 'Enter Reason',
            dateRange                             : 'Date Range',
            entry                                 : 'Entry',
            exit                                  : 'Exit',
            location                              : 'Location',
            hrManagerStatus                       : 'HR Manager Status',
            lineManagerStatus                     : 'Section Officer Status',
            appliedBy                             : 'Applied by',
            selectEmployee                        : 'Select Employee',
            startDate                             : 'Start Date',
            endDate                               : 'End Date',
            download                              : 'Download',
            oneDay                                : '1 day',
            halfDay                               : 'Half day',
            submittedFile                         : 'Submitted File',
            noFileSubmitted                       : 'No File Submitted',
            details                               : 'Details',
            previous                              : 'Previous',
            updated                               : 'Updated',
            leaveBalance                          : 'Leave Balance',
            category                              : 'Category',
            total                                 : 'Total',
            used                                  : 'Used',
            remaining                             : 'Remaining',
            lastFiveLeaves                        : 'Last 5 Leaves',
            leaveDate                             : 'Leave Date',
            leaveType                             : 'Leave Type',
            leaveHalf                             : 'Leave Half',
            numberOfDays                          : 'Number of Days',
            questionMark                          : '?',
            adjust                                : 'Adjust',
            cancel                                : 'Cancel',
            firstApproverStatus                   : '1st Approver Status',
            firstApproverComment                   : '1st Approver Comment',
            secondApproverStatus                  : '2nd Approver Status',
            secondApproverComment                  : '2nd Approver Comment',
            full                                  : 'Full',
            half                                  : 'Half',
            uploadFile                            : 'Upload File',
            applyButton                           : 'Apply',
            action                                : 'Action',
            actions                               : 'Actions',
            primaryText                           : 'Primary Text',
            secondaryText                         : 'Secondary Text',
            rfid                                  : 'RFID',
            rowsPerPage                           : 'Rows Per Page',
            two                                   : '2',
            five                                  : '5',
            ten                                   : '10',
            twenty                                : '20',
            thirty_one                            : '31',
            fifty                                 : '50',
            hundred                               : '100',
            fiveHundred                           : '500',
            thousand                              : '1000',
            fiftyThousand                         : '50000',
            fiveHundredThousand                   : '500000',
            mismatch                              : 'Mismatch',
            noDataFoundWithGivenFilters           : 'No data found with the given filters',
            filter                                : 'Filter',
            project                               : 'Project',
            task                                  : 'Task',
            punchStatus                           : 'Punch Status',
            success                               : 'Success',
            office                                : 'Office',
            employment                            : 'Employment',
            type                                  : 'Type',
            early                                 : 'Early',
            expected                              : 'Expected',
            actual                                : 'Actual',
            difference                            : 'Difference',
            average                               : 'Average',
            hours                                 : 'Hours',
            manualEntry                           : 'Manual Entry',
            fieldVisit                            : 'Field Visit',
            holiday                               : 'Holiday',
            offDay                                : 'Off Day',
            leave                                 : 'Leave',
            fhAbsent                              : 'FH Absent',
            date                                  : 'Date',
            company                               : 'Company',
            shifts                                : 'Shifts',
            departments                           : 'Sections',
            addNewComponentForIndividualEmpButton : 'Add New Component For Individual Employee',
            addAbsenceTypeForIndividualEmpButton  : 'Add Absence Type For Individual Employee',
            downloadComponentUpFileButton         : 'Download Component Upload File',
            downloadAbsenceUpFileButton           : 'Download Absence Upload File',
            downloadBankAdviceLetter              : 'Download Bank Advice Letter',
            selectYear                            : 'Select Year',
            notificationStatus                    : 'Notification Status',
            dataNotFound                          : 'Data Not Found',

            passPoor                              : 'Poor',
            passWeak                              : 'Weak',
            passGood                              : 'Good',
            passStrong                            : 'Strong',
            passStrength                          : 'Password Strength',

        },
        commonPlaceholderText : {
            insertName    : 'Insert Name',
            insertInitial : 'Insert Initial',
        },

        //Settings

        // notificationSettings
        notificationSettings : {
            removeFromNotification                  : ' will be removed form the notification group.',
            title                                   : "Notification",
            allEmployee                             : "All Employee",
            notificationGroup                       : "Notification Group",
            notificationGroupName                   : "Notification Group Name",
            setNotification                         : "Set Notification",
            setNotificationForAllEmployee           : "Set Notification For All Employee",
            editButton                              : "Edit",
            selected                                : "Selected",
            and                                     : "and",
            others                                  : "others",
            erased                                  : "erased",
            forThe                                  : "for the",
            selectedEmployees                       : "selected employees",
            forThisNotificationGroup                : "for this notification group.",
            selectNotificationGroup                 : "Select Notification Group",
            notificationConfiguration               : "Notification Configuration",
            nowPressSetNotification                 : "Now press \"Set Notification\"",
            toSelectNotificationForSelectedEmployees : "to select a notification for the selected employee",
            thePreviousNotificationSettings         : "The previous notification settings will be",
            notificationConfigurationHeading        : "Notification Configuration: ",
            errorList                               : "Error List",


        },
        //Designations
        designationSettings : {
            title         : 'Designations',
            createButton  : 'Create Designation',
            loadButton    : 'Load More',
            tableHeader   : {
                name       : 'Name',
                hierarchy  : 'Hierarchy',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Designation',
                nameInputLabel            : 'Name',
                hierarchyInputLabel       : 'Hierarchy',
                nameInputPlaceholder      : 'Insert Name',
                hierarchyInputPlaceHolder : 'Hierarchy'
            },
            editModal     : {
                title            : 'Edit Designation',
                statusInputLabel : 'Status',
                saveButton       : 'Save Changes'
            },
            deleteModal   : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete designation',
                confirmationTextExtension : 'Deleting this  will unset the designation of all the employees that currently have this designation.'
            }
        },

        //Employment Types
        employmentTypeSettings : {
            title         : 'Employment Types',
            createButton  : 'Create Employment Type',
            tableHeader   : {
                name       : 'Name',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                : 'Create Employment Type',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name',
                submitButton         : 'Create'
            },
            editModal     : {
                title        : 'Edit Employment Type',
                submitButton : 'Submit'
            },
            deleteModal   : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete employment type',
                confirmationTextExtension : 'Deleting this  will unset the employment type of all the employees that currently have this employment type.'
            }
        },

        //Departments
        departmentSettings : {
            title         : 'Sections',
            createButton  : 'Create Section',
            tableHeader   : {
                name       : 'Name',
                hierarchy  : 'Hierarchy',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Section',
                nameInputLabel            : 'Name',
                hierarchyInputLabel       : 'Hierarchy',
                nameInputPlaceholder      : 'Insert Name',
                hierarchyInputPlaceHolder : 'Hierarchy',
                submitButton              : 'Add Section'
            },
            editModal     : {
                title            : 'Edit Section',
                statusInputLabel : 'Status',
                submitButton     : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete section',
                questionMark     : '?'
            }
        },


        //Sub Departments
        subDepartmentSettings : {
            title         : 'Sub Sections',
            createButton  : 'Create Sub Section',
            tableHeader   : {
                name       : 'Name',
                hierarchy  : 'Hierarchy',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Sub Section',
                nameInputLabel            : 'Name',
                hierarchyInputLabel       : 'Hierarchy',
                nameInputPlaceholder      : 'Insert Name',
                hierarchyInputPlaceHolder : 'Hierarchy',
                submitButton              : 'Add Sub Section'
            },
            editModal     : {
                title            : 'Edit Sub Section',
                statusInputLabel : 'Status',
                submitButton     : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete sub section',
                questionMark     : '?'
            }
        },

        //Workplaces
        workplaceSettings : {
            title         : 'Workplaces',
            createButton  : 'Create Workplace',
            tableHeader   : {
                dbUid      : 'DB Unique ID',
                name       : 'Name',
                officeName : 'Office Name',
                latitude   : 'Latitude',
                longitude  : 'Longitude',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Workplace',
                nameInputLabel            : 'Name',
                latitudeInputLabel        : 'Latitude',
                longitudeInputLabel       : 'Longitude',
                nameInputPlaceholder      : 'Insert Name',
                latitudeInputPlaceholder  : 'Insert Latitude',
                longitudeInputPlaceholder : 'Insert Longitude'
            },
            editModal     : {
                title        : 'Edit Workplace',
                submitButton : 'Save Changes'
            },
            deleteModal   : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete workplace',
                confirmationTextExtension : 'Deleting this  will unset the workplace of all the employees that currently have this workplace.'
            }
        },

        //Holidays
        holidaySettings : {
            title             : 'Holidays',
            previousButton    : 'Previous',
            todayButton       : 'Today',
            nextButton        : 'Next',
            yearRadioLabel    : 'Year',
            monthRadioLabel   : 'Month',
            weekRadioLabel    : 'Week',
            dayRadioLabel     : 'Day',
            addButton         : 'Add New Holiday',
            tableHeader       : {
                title   : 'Title',
                date    : 'Date',
                actions : 'Actions'
            },
            creationModal     : {
                title            : 'Create Holiday',
                titleInputLabel  : 'Holiday Title',
                dateInputLabel   : 'Date',
                confirmationText : 'Are you sure you want to create the holiday named'
            },
            editSectionHeader : 'Edit Holidays',
            editModal         : {
                title            : 'Update Holiday',
                confirmationText : 'Are you sure you want to edit the holiday named'
            },
            deleteModal       : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete the holiday named'
            }
        },
        //Shift Management
        shiftSettings : {
            title         : 'Shifts',
            createButton  : 'Create Shift',
            tableHeader   : {
                name            : 'Name (Initial)',
                officeName      : 'Office Name',
                startTime       : 'Start Time',
                endTime         : 'End Time',
                lateAfter       : 'Late After',
                earlyExitBefore : 'Early Exit Before',
                firstHalfEndsAt : 'First Half Ends At',
                breakEndsAt     : 'Break Ends At',
                colour          : 'Colour',
                isDefaultShift  : 'Default Shift',
                status          : 'Status',
                actions         : 'Actions'
            },
            creationModal : {
                title                     : 'Create Shift',
                nameInputLabel            : 'Name',
                nameInputPlaceholder      : 'Insert Name',
                initialInputLabel         : 'Initial',
                initialInputPlaceholder   : 'Insert Initial',
                startTimeInputLabel       : 'Start Time',
                endTimeInputLabel         : 'End Time',
                lateAfterInputLabel       : 'Late After',
                earlyExitBeforeInputLabel : 'Early Exit Before',
                firstHalfEndsInputLabel   : 'First Half Ends',
                breakTimeEndsInputLabel   : 'Break Time Ends',
                firstHalfAbsentInputLabel : 'First Half Absent',
                shiftInfoText             : '* By defaults all shifts are associated with',
                shiftColor                : 'RED ',
                colorChangeInfoText       : 'color. To change color click',
                colorChangeInfoLink       : 'here.'
            },
            editModal     : {
                title            : 'Edit Shift',
                colourInputLabel : 'Colour',
                updateButton     : 'Update Shift'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete Shift named'
            }
        },

        //Shift Group Settings
        shiftGroupSettings : {
            title         : 'Shift Groups',
            createButton  : 'Create Shift Group',
            tableHeader   : {
                name         : 'Name',
                officeName   : 'Office Name',
                isDefault    : 'Default',
                offDays      : 'Off Days',
                status       : 'Status',
                actions      : 'Actions',
                activeShifts : 'Active Shifts',
            },
            creationModal : {
                title                : 'Create Shift Group',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name',
                defaultOffDayLabel   : 'Default Off Days',
                shiftsLabel          : 'Shifts',
            },
            editModal     : {
                title        : 'Edit Shift Group',
                submitButton : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete shift group named'
            }
        },

        dynamicShiftGroupSettings : {
            title         : 'Dynamic Shift Groups',
            createButton  : 'Create Dynamic Shift Group',
            tableHeader   : {
                name         : 'Name',
                officeName   : 'Office Name',
                isDefault    : 'Is Default',
                offDays      : 'Off Days',
                status       : 'Status',
                actions      : 'Actions',
                activeShifts : 'Active Shifts',
            },
            creationModal : {
                title                : 'Create Dynamic Shift Group',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name',
                defaultOffDayLabel   : 'Default Off Days',
                selectedShiftsLabel  : 'Selected Shifts'
            },
            editModal     : {
                title        : 'Edit Dynamic Shift Group',
                submitButton : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete shift group named'
            }
        },

        //Roster Settings
        rosterSettings : {
            basicViewTabLabel    : 'Basic View',
            advancedViewTabLabel : 'Advanced View',
            waitText             : 'Please wait while the rosters are loading...',
            tableHeader          : {
                shiftGroup          : 'Shift Group',
                currentRunningShift : 'Current Running Shift',
                nextChange          : 'Next Change',
                nextOffday          : 'Next Offday',
                actions             : 'Actions'
            },
            showChangeButton     : 'Show next change',
            showOffdayButton     : 'Show next offday',
            editModal            : {
                title                     : 'Edit Roster',
                warningText               : 'Editing In The Basic View will change from the effective date to the rest of the current year.',
                startAndEndDateInputLabel : 'Start And End Date',
                hrefText                  : 'here',
                shiftSelectLabel          : 'Choose Shift',
                offdaySelectLabel         : 'Choose Off Days',
                submitButton              : 'Save Changes',
                chooseDateRangeText       : 'To choose a date range click',
                effectiveDateInputLabel   : 'Effective Date'
            },
            resetButton          : 'Reset',
            repeatButton         : 'Repeat',
            saveButton           : 'Save Changes',
            repeatModal          : {
                title                 : 'Shift Rotation',
                shiftGroupSelectLabel : 'Choose Shift Group',
                copyLabel             : 'Copy From :: Choose Start Date And End Date',
                pasteLabel            : 'Paste On :: Choose Start Date And End Date',
                submitButton          : 'Paste &amp; Rotate'
            },
            cellShiftChangeModal : {
                title        : 'Choose Shift',
                submitButton : 'Set Shift'
            }
        },

        //Apply leave
        applyLeave : {
            allLeaves                     : 'All Leaves',
            pendingLeaves                 : 'Pending Leaves',
            approvedLeaves                : 'approved Leaves',
            applyLeaveTableHeader         : {
                employeeName : 'Employee Name',
                category     : 'Category',
                dateRange    : 'Date Range',
                status       : 'Status',
                action       : 'Action',
            },
            noActionAvailable             : 'No Action Available',
            noResultsToBeShown            : 'No Results to be Shown.',
            applyLeaveButton              : 'Apply Leave',
            leavePolicy                   : 'Leave Policy',
            employmentType                : 'Employment Type',
            remainingLeavesHeading        : 'Remaining Leaves Information',
            remainingLeaveTableHeader     : {
                category : 'Category',
                total    : 'Total',
                used     : 'Used'
            },
            leaveApplicationInformation   : 'Leave Application Information',
            leaveApplicationInformationTh : {
                category          : 'Category',
                applicationType   : 'Application Type',
                dateOfApplication : 'Date of Application',
                leaveType         : 'Leave Type',
                leaveHalf         : 'Leave Half',
            },
            selectCategory                : 'Select Category',
            pleaseSelect                  : 'Please Select',
            selectType                    : 'Select Type',
            availableDays                 : 'Available Days',
            selectHalf                    : 'Select Half',
            selectDate                    : 'Select Date',
            range                         : 'Range',
            firstHalf                     : 'First Half',
            secondHalf                    : 'Second Half',
            placeholderTextForReason      : 'Reason',
            lastFiveLeavesHeading         : 'Last 5 Leaves',
            noLeavesFound                 : 'No leaves found',
            medicalLeave                  : 'Medical Leave',
            annualLeave                   : 'Medical Leave',
            casualLeave                   : 'Medical Leave',


        },


        //Leave Category Settings
        leaveCategorySettings : {
            title         : 'Leave Categories',
            createButton  : 'Create Leave Category',
            tableHeader   : {
                name   : 'Name',
                action : 'Action',
                actions : 'Actions'
            },
            creationModal : {
                title                : 'Create Leave Category',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Enter Name',
                submitButton         : 'Submit'
            },
            editModal     : {
                title : 'Edit Leave Category'
            },
            deleteModal   : {
                title            : 'Delete Leave Category',
                confirmationText : 'Do you want to delete the leave category named',
                submitButton     : 'Confirm'
            }
        },

        //Leave Policy Settings
        leavePolicySettings : {
            title           : 'Leave Policies',
            createButton    : 'Create New Leave Policy',
            tableHeader     : {
                name           : 'Name',
                category       : 'Category',
                numberOfLeaves : 'Number of Leaves',
                actions        : 'Actions'
            },
            creationModal   : {
                title                : 'Create Leave Policy',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Enter Name',
                submitButton         : 'Submit'
            },
            deleteModal     : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete the Leave Policy named',
                confirmationTextExtension : 'Deleting this will unset the leave policy of all the employees that have this leave policy'
            },
            editLeavePolicy : {
                title                : 'Edit Leave Policy',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name Here',
                updateButton         : 'Update',
                saveButton           : 'Save Changes',
                submitButton         : 'Add Category'
            }
        },

        //Leave Category-Policy configurations
        leaveCategoryPolicyConfigurations : {
            title            : 'Category-Policy Configurations',
            createButton     : 'Create New Configuration',
            tableHeader      : {
                policy            : 'Policy',
                category          : 'Category',
                numberOfLeaves    : 'Number of Leaves',
                earnedLeaveStatus : 'Earned Leave Status',
                actions           : 'Actions'
            },
            info:{
                maximumAllowedLeaves   : 'Maximum number of leaves per year for this category',
                consecutiveDays        : 'Maximum number of leaves that can be taken in a row.',
                countOfDaysAsLeaves    : 'If leaves are taken before and after a holiday, the holiday will be considered as leave',
                maximumLeavesPerMonth  : 'This defines how many leaves you want to allow per month',
                applicability          : 'For gender specific leave categories. E.g Maternity leave',
                eligibleAfter          : 'Number of days of employment required to avail this leave',
                enableProrata          : 'Joining Date will be considered when allocating leaves. E.g if an employee joins on 1st July, he/she will get only half the amount of leaves per year',
                maxAvailTimes: 'Maximum number of times this leave can be taken by employee',
                enableEarnedLeave: 'Extra leaves will be earned for working on off-day/holiday',
                leavesToFileUpload: 'Maximum Number of consecutive leaves, for which file upload is mandatory.',
                leaveCarryType: 'Select whether leave carry calculation will be based on percentage or fixed amount.',
                maximumLeavesToCarry: 'Maximum number/percentage of leaves to carry forward',
                enablePastDateSelection : 'Select whether a leave can be applied for a past date',
                setPastDateSelectionLimit : 'Specify the number of days after which a previous leave can be applied'
            },
            create           : {
                title    : 'New Configuration',
                form     : {
                    policyInputLabel                         : 'Select Leave Policy',
                    categoryInputLabel                       : 'Select Leave Category',
                    totalDaysInputLabel                      : 'Maximum Number of Allowed Leaves',
                    consecutiveDaysInputLabel                : 'Consecutive Days',
                    monthlyRestrictionInputLabel             : 'Maximum Number of Leaves Per Month',
                    fileUploadConditionInputLabel            : 'Number of Leaves to Provide File',
                    maxCarryInputLabel                       : 'Maximum Number of Leaves to Carry',
                    countOffdaysInputLabel                   : 'Count Offdays as Leaves',
                    carryTypeInputLabel                      : 'Leave Carry Type',
                    earnedLeaveEnabledInputLabel             : 'Enable Earned Leave',
                    earnedLeaveCriteriaInputLabel            : 'Earned Leave Criteria',
                    maxEarnedLeaveCountInputLabel            : 'Maximum Number of Earned Leave',
                    perDayEarnedLeaveRequiredHoursInputLabel : 'Required Work-hours for Per Day Earned Leave',
                    earnedLeaveCapTypeInputLabel             : 'Earned Leave Calculation Period',
                    earnedLeaveCapAmountInputLabel           : 'Number of Earned Leave Calculation Period Units',
                    expiryTimeWindowInputLabel               : 'Earned Leave Validity Period',
                    createButton                             : 'Create New Configuration',
                    addMoreButton                            : 'Add More Categories',
                    removeButton                             : 'Remove',
                    selectApplicability                      : 'Select Applicability',
                    eligibleAfterJoiningDate                 : 'Eligible After Joining Date',
                    proRataEnabledInputLabel                 : 'Enable Pro Rata',
                    maxAvailTimes                            : 'Max Avail Times',
                    enablePastDateSelectionInputLabel        : 'Enable Previous Date Selection',
                    pastDateSelectionLimitInputLabel        : 'Previous Date Selection Limit'

                },
                errorMsg : {
                    policy              : 'Leave policy is required',
                    category            : 'Leave category is required',
                    totalDays           : {
                        required : 'Maximum Number of Allowed Leaves is required',
                        invalid  : 'Invalid number of leaves'
                    },
                    earnedLeaveCriteria : 'You must select a criterion if earned leave is enabled',
                    invalidInput        : 'Invalid input',
                    required : 'Input is required for this field'
                }
            },
            edit             : {
                title    : 'Edit Configuration',
                form     : {
                    policyInputLabel                         : 'Select Leave Policy',
                    categoryInputLabel                       : 'Select Leave Category',
                    totalDaysInputLabel                      : 'Maximum Number of Allowed Leaves',
                    consecutiveDaysInputLabel                : 'Consecutive Days',
                    monthlyRestrictionInputLabel             : 'Maximum Number of Leaves Per Month',
                    fileUploadConditionInputLabel            : 'Number of Leaves to Provide File',
                    maxCarryInputLabel                       : 'Maximum Number of Leaves to Carry',
                    countOffdaysInputLabel                   : 'Count Offdays as Leaves',
                    carryTypeInputLabel                      : 'Leave Carry Type',
                    earnedLeaveEnabledInputLabel             : 'Enable Earned Leave',
                    earnedLeaveCriteriaInputLabel            : 'Earned Leave Criteria',
                    maxEarnedLeaveCountInputLabel            : 'Maximum Number of Earned Leave',
                    perDayEarnedLeaveRequiredHoursInputLabel : 'Required Work-hours for Per Day Earned Leave',
                    earnedLeaveCapTypeInputLabel             : 'Earned Leave Calculation Period',
                    earnedLeaveCapAmountInputLabel           : 'Number of Earned Leave Calculation Period Units',
                    expiryTimeWindowInputLabel               : 'Earned Leave Validity Period',
                    createButton                             : 'Create New Configuration',
                    addMoreButton                            : 'Add More Categories',
                    removeButton                             : 'Remove',
                    saveButton                               : 'Save Changes',
                    enablePastDateSelectionInputLabel        : 'Enable Previous Date Selection',
                    pastDateSelectionLimitInputLabel         : 'Previous Date Selection Limit'
                },
                errorMsg : {
                    policy              : 'Leave policy is required',
                    category            : 'Leave category is required',
                    totalDays           : {
                        required : 'Maximum Number of Allowed Leaves is required',
                        invalid  : 'Invalid number of leaves'
                    },
                    earnedLeaveCriteria : 'You must select a criterion if earned leave is enabled',
                    invalidInput        : 'Invalid input',
                    required            : 'Input is required for this field'
                }
            },
            deleteModal      : {
                title                          : 'Confirmation',
                confirmationText               : 'Do you want to delete the Leave Policy named',
                confirmationTextExtension      : 'Deleting this will unset the leave policy of all the employees that have this leave policy.',
                categoryDeleteConfirmationText : 'Are you sure you want to delete this leave category from this policy'
            },
            selectPolicy     : 'Select Policy',
            selectCategory   : 'Select Category',
            selectCriteria   : 'Select Criteria',
            leavePolicyName  : 'Leave Policy Name:',
            selectApplicability: 'Select Applicability',
            placeholderText0 : '0'
        },

        //Pending Approvals
        pendingApplicationApprovals : {
            leave                       : {
                title            : 'Pending Leave Applications',
                noApplicationMsg : 'Looks like no pending leave requests here!'
            },
            late                        : {
                title            : 'Pending Late Approval Applications',
                noApplicationMsg : 'Looks like no pending late approval requests here!'
            },
            manualEntry                 : {
                title            : 'Pending Manual Entry Applications',
                noApplicationMsg : 'Looks like no pending manual entry approval requests here!'
            },
            timeSheet                   : {
                title            : 'Pending Timesheet Approvals',
                noApplicationMsg : 'Looks like no time sheet approval requests here!',
                approvalModal    : {
                    title : 'Timesheet Confirmation',
                    text  : 'Do you want to approve this time sheet?'
                },
                rejectionModal   : {
                    title : 'Reject Timesheet Confirmation',
                    text  : 'Do you want to reject this application?'
                }
            },
            overtime                    : {
                title                  : 'Pending Overtime Approvals',
                confirmation           : 'Confirmation',
                allowOvertime          : 'Are you sure you want to allow overtime for selected employees?',
                disallowOvertime       : 'Are you sure you want to disallow overtime for selected employees?',
                company                : 'Company',
                office                 : 'Office',
                departments            : 'Sections',
                shifts                 : 'Shifts',
                searchByNameID         : 'Search by name/ID',
                searchButton           : 'Search',
                allowOvertimeButton    : 'Allow Overtime',
                disallowOvertimeButton : 'Disallow Overtime',
                overtimeTableHeader    : {
                    image          : 'Image',
                    name           : 'Name',
                    department     : 'Section',
                    shift          : 'Shift',
                    designation    : 'Designation',
                    overtimeStatus : 'Overtime Status',
                },
            },
            tableHeader                 : {
                name                      : 'Name',
                category                  : 'Category',
                timeline                  : 'Timeline',
                entryTime                 : 'Entry Time',
                exitTime                  : 'Exit Time',
                numberOfDays              : 'Number of Days',
                days                      : 'Days',
                reason                    : 'Reason',
                type                      : 'Type',
                leaveType                 : 'Leave Type',
                applicationType           : 'Application Type',
                otherApprovalStatus       : 'Other Approval Status',
                file                      : 'File',
                actions                   : 'Actions',
                date                      : 'Date',
                year                      : 'Year',
                month                     : 'Month',
                lineManager               : 'Section Officer',
                lineManagerApprovalStatus : 'Section Officer Approval Status'
            },
            approveButton               : 'Approve',
            rejectButton                : 'Reject',
            viewDetailsButton           : 'View Details',
            approvalModal               : {
                title                   : 'Approval Confirmation',
                modalText               : 'Do you want to accept this application? You can also give a comment.',
                commentInputLabel       : 'Comment',
                commentInputPlaceholder : 'You accepted this application because ...',
                submitButton            : 'Submit &amp; Accept',
                cancelButton            : 'Cancel'
            },
            rejectionModal              : {
                title                   : 'Reject Application Confirmation',
                modalText               : 'Do you want to reject this application? If so, please give a comment -',
                commentInputLabel       : 'Comment',
                commentInputPlaceholder : 'You rejected this application because ...',
                submitButton            : 'Submit &amp; Reject Application',
                cancelButton            : 'Cancel'
            },
            leaveApplicationDetails     : {
                title : 'Pending Leave Application of '
            },
            to                          : 'to',
            numberOfPendingApprovals    : 'Looks like you have',
            pending                     : 'approvals pending',
            applicationDetails          : 'Application Details',
            applicationDetailsTableInfo : {
                applicationType     : 'Application Type',
                leaveCategory       : 'Leave Category',
                applyDate           : 'Apply Date',
                leaveType           : 'Leave Type',
                leaveHalf           : 'Leave Half',
                reasonOfLeave       : 'Reason of Leave',
                otherApprovalStatus : 'Other Approval Status',
                leaveCategory       : 'Leave Category',
                numberOfDays        : 'Number of Days',
                leaveType           : 'Leave Type',
            },
            noPreviousLog               : '--',
            unavailableLeaveBalance     : 'Leave balance is not available, leave policy may not be assigned for this employee',
            noLeaveTaken                : 'Employee hasn\'t taken any leaves this year',
            approveModal                : {
                heading : 'Manual Entry Approval Confirmation',
                text    : 'Do you want to approve this application?'
            },
            rejectModal                 : {
                heading : 'Reject Manual Entry Application Confirmation',
                text    : 'Do you want to reject this application?'
            }


        },

        //Devices
        //List
        devices        : {
            revokeButton                          : 'Revoke',
            allocateButton                        : 'Allocate',
            allocatedButton                       : "Allocated",
            unallocatedButton                     : "Unallocated",
            temporaryAllocationButton             : "Temporary Allocation",
            temporary                             : 'Temporary',
            active                                : 'Active',
            inactive                              : 'Inactive',
            upcoming                              : 'Upcoming',
            allocationStartDate                   : 'Allocation Start Date',
            allocationEndDate                     : 'Allocation End Date',
            temporaryAllocationInformationHeading : 'Temporary Allocation Information',
        },
        deviceListPage : {
            title          : 'Devices',
            allocateButton : 'Allocate All To All Devices',
            filters        : {
                phoneNumber                 : 'Phone Number',
                phoneNumberInputPlaceholder : 'Device Phone number ...',
                identifier                  : 'Identifier',
                identifierInputPlaceholder  : 'Device identifier ...',
                location                    : 'Location',
                locationInputPlaceholder    : 'Device location ...',
                offices                     : 'Offices',
                loadDevice                  : 'Load Device',
                submitButton                : 'Search Devices',
                notFoundText                : 'No devices could be found with filters',
            },
            tableHeader    : {
                identifier  : 'Identifier',
                phoneNumber : 'Phone Number',
                description : 'Description',
                location    : 'Location',
                type        : 'Type',
                lastUpdated : 'Last Updated',
                action      : 'Action'
            },
            editModal      : {
                title                 : 'Edit Device Information',
                identifierLabel       : 'Device Identifier',
                phoneNumberLabel      : 'Phone Number',
                descriptionInputLabel : 'Description',
                locationInputLabel    : 'Location',
                submitButton          : 'Update'
            },
            editModalTitle : 'Do you want to allocate everyone to all devices?'
        },

        //Allocation History
        deviceAllocationHistory : {
            title         : 'Allocation History',
            filters       : {
                search                 : 'Search',
                searchInputPlaceholder : 'Employee or Device ...'
            },
            tableHeader   : {
                image    : 'Image',
                name     : 'Name',
                device   : 'Device',
                location : 'Location',
                action   : 'Action',
                date     : 'Date',
                status   : 'Status'
            },
            statusDone    : 'Done',
            statusPending : 'Pending',
            statusFailed  : 'Failed'
        },

        //Overtime Menu
        //Monthly Summary
        overtimeSummary : {
            title        : 'Monthly Summary',
            tableHeader  : {
                image         : 'Image',
                name          : 'Name',
                department    : 'Section',
                designation   : 'Designation',
                type          : 'Employee Type',
                totalOvertime : 'Total Overtime',
                totalApproved : 'Total Approved'
            },
            notFoundText : 'Sorry no overtime data found within given limit'
        },

        //Overtime Report
        overtimeDetailedReport : {
            title         : 'Detailed Report',
            tableHeader   : {
                image       : 'Image',
                name        : 'Name',
                department  : 'Section',
                designation : 'Designation',
                shiftGroup  : 'Shift Group',
                total       : 'Total OT Hours',
                approved    : 'Approved OT Hours'
            },
            notFoundText  : 'Sorry no overtime data found within given limit',
            approvalModal : {
                title                    : 'Approve Overtime',
                overtimeInputLabel       : 'Overtime',
                overtimeInputPlaceholder : 'Insert in hour:minutes format',
                submitButton             : 'Create'
            }
        },

        //SMS
        sendSms : {
            title               : 'SMS',
            employeeSelectLabel : 'Select Employee',
            sendButton          : 'Send',
            smsInputLabel       : 'Write SMS Here',
            confirmationModal   : {
                title            : 'Send SMS',
                confirmationText : 'Are you sure you want to send sms to these employees?'
            }
        },

        //Profile Leave
        profileLeave : {
            remainingLeavesInYear           : 'Remaining Leaves in Year ',
            remainingLeaves                 : 'Remaining Leaves',
            noLeavePolicyOrApproverAssigned : 'No leave policy or Leave Approver is assigned to employee',
            remainingLeave                  : 'Remaining Leaves',
            noApplicationsFound             : 'No Applications found for selected year'
        },
        //Profile Enrol
        profileEnrol : {
            selectAHand            : 'Select a Hand',
            selectAFinger          : 'Select a Finger',
            thumb                  : 'Thumb',
            index                  : 'Index',
            middle                 : 'Middle',
            ring                   : 'Ring',
            pinky                  : 'Pinky',
            chooseAFileFromServer  : 'Choose a file from server',
            noEnrolmentRecordFound : 'No enrolment record found for this employee.',
            enrolFromDevice        : 'Enrol From Device',
            enrolmentRunningTo     : 'Enrolment Running up to ',
            enrolmentNotRunning    : 'Enrolment Not Running',
            refreshEnrolments      : 'Refresh Enrolments',
            deleteConfirmation     : 'Are you sure you want to delete the enrolment of the selected fingers?',
        },
        profileAccessAreaPermission : {
            allocateUserToAccessArea   : "Allocate User To Access Area",
            revokeUserFromAccessArea   : "Revoke User From Access Area",
            selectArea                 : "Select Access Area",

        },
        //Profile Device Permissions
        profileDevicePermissions : {
            allocatedDevicesOf   : "Allocated Devices of ",
            allocateUserToDevice : 'Allocate User to Device',
            revokeUserFromDevice : 'Revoke User from Device',
            notAllocatedInDevice : 'Not allocated in any devices.',
            temporaryPermissions : 'Temporary Permissions',
        },
        profilePayroll           : {
            paymentDetails    : "Payment Details ",
            paymentMode       : "Payment Mode",
            selectPaymentMode : "Select Payment Mode",
            grossSalary       : "Gross Salary",
            bankPayment       : "Bank Payment",
            cashPayment       : "Cash Payment",
            bankName          : "Bank Name",
            selectBankName    : "Select Bank Name",
            routingNumber        : "Routing No",
            selectRoutingNo   : "Select Routing No",
            accountNumber     : "Account Number",
            salaryDetails     : "Salary Details",
            salaryComponents  : "Salary Components",
            amount            : "Amount",
            // allocateUserToDevice : 'Allocate User to Device',
            // revokeUserFromDevice : 'Revoke User from Device',
            // notAllocatedInDevice : 'Not allocated in any devices.',
            // temporaryPermissions : 'Temporary Permissions'
        },
        //Profile Roster
        profileRoster           : {
            timingDetailsOf : 'Time details of '
        },
        profilePendingApprovals : {
            pendingLeaveRequests          : 'Pending Leave Requests',
            noLeaveRequests               : 'Looks like no pending leave requests here!',
            pendingLateApprovalRequests   : 'Pending Late Approval Applications',
            noLateRequests                : 'Looks like no pending late approval requests here!',
            pendingManualEntryRequests    : 'Pending Manual Entry Applications',
            noManualEntryRequests         : 'Looks like no pending manual entry approval requests here!',
            cancelLateLog                 : 'Cancel Late Approval',
            cancelLateLogConfirmation     : 'Cancel this late approval application?',
            cancelLeave                   : 'Cancel Leave',
            cancelLeaveConfirmation       : 'Are you sure you want to cancel this leave application?',
            editLeaveApplication          : 'Edit Leave Application',
            cancelManualEntry             : 'Cancel Manual Entry',
            cancelFieldVisit              : 'Cancel Field Visit',
            cancelManualEntryConfirmation : 'Do want to cancel this manual entry application?',
            cancelFieldVisitConfirmation  : 'Are you sure you want to cancel this field visit application?'
        },

        //Project management
        projects : {
            title         : 'Project List',
            tableHeader   : {
                name        : 'Name',
                startTime   : 'Start',
                deadline    : 'Deadline',
                description : 'Description',
                status      : 'Status',
                actions     : 'Actions',
                referenceCode : 'Reference Code',
                projectName : 'Project Name',
                product : 'Product',
                kam : 'K.A.M.',
                clientName : 'Client Name',
                projectType : 'Project Type',
                startDate : 'Start Date',
                dueDate : 'Due Date',
                endDate : 'End Date',
                noOfIssues : 'No. of Issues'
            },
            emptyTableBody : "No records found",
            filter : {
                projectTypes : 'Project Types',
                products : 'Products',
                clients : 'Clients',
                kams : 'K.A.M.s',
                searchInputPlaceholder : "Search Project by Reference/Name",
            },
            createButton  : 'Create New Project',
            searchButton : 'Search',
            create : {
                panelTitle : 'Create New Project',
                projectNameInputLabel : "Project Name",
                projectTypeInputLabel : "Type",
                clientInputLabel : "Client",
                productInputLabel : "Product",
                referenceCodeInputLabel : "Reference Code",
                startDateInputLabel : "Start Date",
                dueDateInputLabel : "Due Date",
                kamInputLabel : "K.A.M.",
                organisationTypeInputLabel : "Organisation Type",
                createProjectButtonLabel : "Create Project",
            },
            edit : {
                panelTitle : 'Edit Project'
            },
            creationModal : {
                title                       : 'Create Project',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                submitButton                : 'Add Project',
                addPeople                   : 'Add People',
                addTeam                     : 'Add Team',
            },
            editModal     : {
                title                       : 'Edit Project',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                statusInputLabel            : 'Status',
                submitButton                : 'Save Changes',
                addButton                   : 'Add',
                peopleInTheProjectHeading   : 'People in the project',
                picture                     : 'Picture',
                name                        : 'Name',
                action                      : 'Action'
            },
            deleteModal   : {
                title               : 'Confirmation',
                confirmationText    : 'Are you sure you want to delete?',
                confirmationText2   : 'Are you sure you want to delete project',
                deleteProjectHeader : 'Delete Project',

            },
            product     :  {
                productSegment: 'Product Segment',
                deleteProductodalStatement: 'Do you want to delete this product',
                segment: 'Segment',
                productOwner: 'Owner',
                title: 'Product List',
                createProduct : 'Create New Product',
                editProduct : 'Save Changes',
                createNewProduct : 'Create Product',
                editPanelTitle : 'Edit Product',
                table : {
                    productName : 'Product Name',
                    segment     : 'Segment',
                    description : 'Description',
                    owner : 'Owner',
                    action : 'Action',
                    edit:'Edit',
                    delete:'Delete',
                    emptyBody : "No records found",
                },
            },
            issues     :  {
                issueDate       : 'Issue Date',
                projectName     : 'Project Name',
                productName     : 'Product Name',
                submittedBy     : 'Submitted By',
                allocateTo      : 'Allocate To',
                status          : 'Status',
                priority        : 'Priority',
                title           : 'Issue List',
                createButton    : 'Add New Issue',
                issueDetails    : 'Issue Details',
                searchInputPlaceholder : 'Search issue by ticket no./project name',
                table : {
                    date        : 'Issue Date & Time',
                    projectName : 'Project Name',
                    productName : 'Product Name',
                    submittedBy : 'Submitted By',
                    ticketNo    : 'Ticket No',
                    allocateTo  : 'Allocate To',
                    status      : 'Status',
                    dateAndTime : 'Last Modified',
                    priority    : 'Priority',
                    action      : 'Action',
                    edit        : 'Edit',
                    view        : 'View',
                    emptyTableBody : "No records found"
                },
                lowPriority : "Low",
                mediumPriority : "Medium",
                highPriority : "High"
            },
            issue     : {
                productName     : 'Product Name',
                projectName     : 'Project Name',
                projectRefNo    : 'Project Reference No',
                projectNamePlaceholder : 'Select Project Name',
                dateAndTime     : 'Date & Time',
                issueDateAndTime: 'Issue Date & Time',
                entryDateAndTime: 'Entry Date & Time',
                ticketNo        : 'Ticket No',
                priority        : 'Priority',
                priorityPlaceholder : 'Select Priority',
                status          : 'Status',
                statusPlaceholder : 'Select status',
                supportDoc      : 'Support Document',
                allocateTo      : 'Allocate To',
                submittedBy     : 'Submitted By',
                description     : 'Description',
                uploadSupDoc    : 'Upload Support Document',
                addNewIssue     : 'Add New Issue',
                editIssue       : 'Edit Issue',
                cancelButton    : 'Cancel',
                addIssueButton  : 'Add Issue',
                updateIssueButton  : 'Update Issue',
                pleaseSelectPlaceholder : 'Please select',
                logInfo: {
                    title           : 'Log Information',
                    updateLogButton : 'Update Log',
                    startDate       : 'Start Date & Time',
                    allocateTo      : 'Allocate To',
                    transferTo      : 'Transfer To',
                    transferToPlaceholder : 'Select whom to transfer',
                    status          : 'Status',
                    statusPlaceholder : 'Select status',
                    endDate         : 'End Date & Time',
                    remarks         : 'Remarks',
                    remarksPlaceholder : 'Write remarks',
                    issueLogUpdateTitle: 'Issue Log Update',
                    cancelButton    : 'Cancel',
                    updateButton    : 'Update',
                    timestamp : "Timestamp",
                    action : "Action",
                    noLogsFound : "No Logs Found"
                }
            },
            issueCreators : {
                title : "Issue Creator List",
                searchInputPlaceholder : "Search Creator by Name/ID",
                table : {
                    creator : "Creator Name",
                    action : "Action",
                    emptyTableBody : "Nobody is assigned as issue creator"
                },
                createModal : {
                    title : "Assign New Issue Creator",
                    employeeInputLabel : "Select Employee"
                },
                createButton : "Assign Issue Creator"
            }
        },

        tasks : {
            title          : 'Tasks',
            date           : 'Date',
            employees      : 'Employees',
            tableHeader    : {
                name        : 'Name',
                description : 'Description',
                status      : 'Status',
                actions     : 'Actions',
                project     : 'Project',
                startTime   : 'Start',
                deadline    : 'Deadline'
            },
            statusComplete : 'Done',
            statusTodo     : 'Todo',
            statusInactive : 'Inactive',
            createButton   : 'Create Task',
            creationModal  : {
                title                       : 'Create Task',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                submitButton                : 'Add Task',
                startTimeInputLabel         : 'Start Time'
            },
            editModal      : {
                title                       : 'Edit Task',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                statusInputLabel            : 'Status',
                submitButton                : 'Save Changes',
                addPeopleHeading            : 'People in the task'
            },
            deleteModal    : {
                title             : 'Confirmation',
                deleteTaskTitle   : 'Delete Task',
                confirmationText  : 'Are you sure you want to delete?',
                confirmationText2 : 'Are you sure you want to delete task'
            }
        },

        teams           : {
            title         : 'Teams',
            tableHeader   : {
                name        : 'Name',
                description : 'Description',
                status      : 'Status',
                actions     : 'Actions'
            },
            createButton  : 'Create Team',
            creationModal : {
                title                       : 'Create Team',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                submitButton                : 'Add Team'
            },
            editModal     : {
                title                       : 'Edit Team',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                statusInputLabel            : 'Status',
                submitButton                : 'Save Changes',
                peopleInTheTeamHeading      : 'People in the team',
            },
            deleteModal   : {
                title             : 'Confirmation',
                deleteTeamHeading : 'Delete Team',
                confirmationText  : 'Are you sure you want to delete?',
                confirmationText2 : 'Do you want to delete team'
            }
        },
        timeSheetReport : {
            project           : 'Project',
            task              : 'Task',
            team              : 'Team',
            employee          : 'Employee',
            date              : 'Date',
            start             : 'Start',
            end               : 'End',
            totalTime         : 'Total Time',
            description       : 'Description',
            picture           : 'Picture',
            totalWorkHour     : 'Total Work Hour',
            year              : 'Year',
            month             : 'Month',
            projectDedication : 'Project Dedication',
            hoursSpent        : 'Hours Spent',
            name              : 'Name',
            status            : 'Status',
            addTaskButton     : 'Add task',
            tasks             : 'Tasks',
            people            : 'People',
            peopleInHeading   : 'People in',

        },
        projectClients : {
            panelTitle : "Client List",
            table : {
                headers : {
                    serial : "SL",
                    clientName : "Client Name",
                    contactPerson : "Contact Person",
                    contactNumber : "Contact Number",
                    contactEmail : "Contact Email",
                    type : "Type",
                    kam : "K.A.M.",
                    action : "Action"
                },
                emptyBody : "No records found",
            },
            createButton : "Create New Client",
            editButton : "Edit",
            deleteButton : "Delete",
            sortButton : "Sort By",
            searchButton : "Search",
            filterButton : "Filter",
            filter : {
                searchInputPlaceholder : "Search Clients by Name/Email/Contact Number",
                searchInputLabel : "Search Clients",
                organisationTypes : "Organisation Types",
                kams : "K.A.M.s"
            },
            create : {
                panelTitle : "Create New Client",
                clientNameInputLabel : "Client Name",
                contactNameInputLabel : "Contact Person Name",
                contactDesignationInputLabel : "Contact Person Designation",
                contactNumberInputLabel : "Contact Number",
                contactEmailInputLabel : "Contact Email",
                kamInputLabel : "K.A.M.",
                organisationTypeInputLabel : "Organisation Type",
                createClientButtonLabel : "Create Client",
            },
            edit : {
                panelTitle : "Edit Client"
            },
            delete : {
                modalTitle : "Confirmation",
                modalBodyText : "Are you sure you want to delete"
            }
        },
        //Profile
        profile                 : {
            date                              : 'Date',
            deletedAt                         : 'Deleted at:',
            deletedBy                         : 'Deleted by:',
            noAttendanceLogsFound             : 'No Attendance logs found for employee',
            downloadAllButton                 : 'Download All',
            manualEntry                       : 'Manual Entry',
            selectType                        : 'Select Type',
            missingPunch                      : 'Missing Punch',
            fieldVisit                        : 'Field Visit',
            reason                            : 'Reason',
            placeholderForReason              : 'Enter Reason',
            entryTime                         : 'Entry Time',
            exitTime                          : 'Exit Time',
            selectADevice                     : 'Select Device(s)',
            selectDevice                      : 'Select Device',
            time                              : 'Time',
            hours                             : 'Hours',
            selectDateRange                   : 'Select Date Range',
            selectTime                        : 'Select Time',
            area                              : 'Area',
            hrManager                         : 'HR Manager',
            lineManager                       : 'Section Officer',
            entry                             : 'Entry',
            exit                              : 'Exit',
            status                            : 'Status',
            attendanceTableHeading            : 'Attendance Table',
            holiday                           : 'Holiday',
            holidays                          : 'Holidays',
            offDay                            : 'Off Day',
            offDays                           : 'Off Days',
            leave                             : 'Leave',
            absent                            : 'Absent',
            present                           : 'Present',
            late                              : 'Late',
            approvedLates                     : 'Approved Lates',
            earlyExit                         : 'Early Exit',
            lateEntriesHeading                : 'Late Entries',
            noComment                         : 'No Comment',
            dashDash                          : '--',
            notApplied                        : 'Not Applied',
            summaryHeading                    : 'Summary',
            expectedHours                     : 'Expected Hours',
            actualHours                       : 'Actual Hours',
            identifier                        : 'Identifier',
            phoneNumber                       : 'Phone Number',
            RFIDStatus                        : 'RFID Status',
            FingerprintStatus                 : 'Fingerprint Status',
            FaceStatus                        : 'Face Status',
            description                       : 'Description',
            location                          : 'Location',
            type                              : 'Type',
            deviceId                          : 'Device ID',
            startDate                         : 'Start Date',
            endDate                           : 'End Date',
            allocateButton                    : 'Allocate',
            revokeButton                      : 'Revoke',
            enrolEmployee                     : 'Enrol Employee',
            startButton                       : 'Start',
            stopButton                        : 'Stop',
            enrolFingerButton                 : 'Enrol Finger',
            leftHand                          : 'Left Hand',
            rightHand                         : 'Right Hand',
            ApplyForLeaveButton               : 'Apply For Leave',
            leaveDetailsOf                    : 'Leave Details Of',
            leaveBalanceHeading               : 'Leave Balance',
            applicationType                   : 'Application Type',
            leaveAdjustApplicationInfoHeading : 'Leave Application Information: Adjust',
            leaveApplicationInfoHeading       : 'Leave Application Information:',
            applyDate                         : 'Apply Date',
            leaveAdjustment                   : 'Leave Adjustment',
            leaveCancellation                 : 'Leave Cancellation',
            half                              : 'Half',
            full                              : 'Full',
            leaveReason                       : 'Leave Reason',
            uploadAFile                       : 'Upload A File',
            noFileSubmitted                   : 'No file submitted',
            areYouSureHeading                 : 'Are you sure?',
            notificationOrMessageSentHeading  : 'A notification/email will be sent to your approvers regarding the change.',
            pleaseWaitText                    : 'Please Wait',
            yourApplicationBeingProcessed     : 'Your application is being processed.',
            details                           : 'Details',
            submittedInformation              : 'Submitted Information',
            reasonOfCancellation              : 'Reason Of Cancellation',
            reasonOfCancellationPlaceholder   : 'Please write the reason',
            applyForLeaveHeading              : 'Apply for Leave',
            availableDays                     : 'Available Days',
            overtimeReportOf                  : 'Overtime Report of',
            overtime                          : 'Overtime',
            total                             : 'Total',
            actions                           : 'Actions',
            placeholderForAddress             : 'Address',
            placeholderForType                : 'Type',
            placeholderForThana               : 'Thana',
            placeholderForDistrict            : 'District',
            placeholderForRemark              : 'Remark',
            confirmation                      : 'Confirmation',
            currently                         : 'Currently',
            isCurrently                       : 'is currently',
            is                                : 'Is',
            isNot                             : 'Is Not',
            areYouSureYouWantTo               : 'Are you sure you want to',
            revokeThisPrivilegeFrom           : 'revoke this privilege from',
            allowThisPrivilegeTo              : 'allow this privilege to',
            revokingRoleHeadingPart1          : 'Revoking this role will unset all employees\'',
            revokingRoleHeadingPart2          : 'who have this employee as',
            project                           : 'Project',
            deleteAddress                     : 'Delete Address',
            deleteAddressAcknowledgement      : 'Do you want to delete this address?',
            deleteDocumentAcknowledgement     : 'Do you want to delete this document?',
            includedInAttendanceReport        : 'included in attendance report.',
            notIncludedInAttendanceReport     : 'not included in attendance reports.',
            exclude                           : 'exclude',
            include                           : 'include',
            updateStatus                      : 'Update Status',
            disallowOvertime                  : ' disallow Overtime',
            allowOvertime                     : ' allow Overtime',
            isCompanyAdmin                    : 'Is Company Admin',
            notCompanyAdmin                   : 'Not Company Admin',
            revokeCompanyAdminPrivilege       : 'revoke company admin privilege',
            allowCompanyAdminPrivilege        : 'allow company admin privilege',
            of                                : 'of',
            timesheetEntry                    : 'Timesheet Entry',
            startTime                         : 'Start Time',
            endTime                           : 'End Time',
            changeProfilePicture              : 'Change Profile Picture',
            documents                         : 'Documents',
            approverInfoHeading               : 'Approver Information',
            changePassword                    : 'Change Password',
            generalInfoHeading                : 'General Information',
            contactInfoHeading                : 'Personal & Contact Information',
            profilePicRemoveHeading           : 'Do you want to remove profile picture?',
            uploadProfilePicHeading           : 'Upload Profile Picture',
            selectImage                       : 'Select Image',
            updateProjectDedicationHeading    : 'Update Project Dedication',
            dedicationPercentage              : 'Dedication Percentage',
            projectDedication                 : 'Project Dedication',
            notificationSettings              : 'Notification Settings',
            taskDedication                    : 'Task Dedication',
            setPercentageButton               : 'Set Percentage',
            totalDedication                   : 'Total Dedication',
            timeSpent                         : 'Time Spent',
            totalTime                         : 'Total Time',
            upgradeForUnlockFeaturesHeading   : 'upgrade For Unlock Features',
            features                          : 'Features',
            basic                             : 'Basic',
            intermediate                      : 'Intermediate',
            advanced                          : 'Advanced',
            maybeLaterButton                  : 'Maybe Later',
            upgradeNowButton                  : 'Upgrade Now',
            pleaseSelect                      : 'Please Select',
            addTask                           : 'Add Task',
            firstApproverStatus               : 'First Approver Status',
            secondApproverStatus              : 'Second Approver Status',

        },
        loginPage               : {},
        payrollSettings         : {
            dontHavePayrollSettingsHeading : 'You do not have any payroll settings. Please create one.',
            createPayrollSettingsButton    : 'Create Payroll Settings',
            selectPayrollType              : 'Select Payroll Type',
            componentCode                  : 'Component Code',
            componentName                  : 'Component Name',
            componentType                  : 'Component Type',
            componentCategory              : 'Component Category',
            valueType                      : 'Value Type',
            percentageOf                   : '% of',
            value                          : 'Value',
            status                         : 'Status',
            action                         : 'Action',
            addNewComponentButton          : 'Add New Component',
            saveSettingsButton             : 'Save Settings',
            updateSettingsButton           : 'Update Settings',
            editSettingsButton             : 'Edit Settings',
            payrollTypeHeading             : 'Payroll Type',
            addition                       : 'Addition',
            deduction                      : 'Deduction',
            percentage                     : '%',
            fixed                          : 'Fixed',
            variable                       : 'Variable',
            active                         : 'Active',
            inactive                       : 'Inactive',
            amount                         : 'Amount',
            days                           : "Days(s)",
            absenceType                    : 'Absence Type',
            basicPay                       : 'Basic Pay',
            allowance                      : 'Allowance',
            longTermBenefit                : 'Long Term Benefit',
            nonCashBenefit                 : 'Non Cash Benefit',
            additional                     : 'Additional',
            bonus                          : 'Bonus',
            arrears                        : 'Arrears',
            lwpDeduction                   : 'LWP Deduction',
            absentDeduction                : 'Absent Deduction',
            incomeTaxDeduction             : 'Income Tax Deduction',
            loanDeduction                  : 'Loan Deduction',

        },
        salaryComponentSettings : {
            componentPolicySettings          : 'Component Policy Settings',
            componentGroup                   : 'Component Group',
            parentComponent                  : 'Parent Component',
            calculationPercentage            : 'Calculation Percentage',
            calculationFixedAmount           : 'Fixed Amount',
            calculationVariable              : 'Variable',
            festivalBonus                    : 'Festival Bonus',
            bonusEligibility                 : 'Bonus Eligibility',
            bonusProratePeriod               : 'Bonus Prorate Period(Days)',
            bonusCalculationBasis            : 'Bonus Calculation Basis',
            percentageCalculation            : 'Percentage Calculation',
            bonusCalculationCutoffDate       : 'Bonus Calculation Cutoff Date',
            considerInGrossSalaryCalculation : 'Consider in Gross Salary Calculation',
            confirmationBenefit              : 'Confirmation Benefit',
            noOfTimeInstallment              : 'No of Time/Installment',
            componentDistribution            : 'Component Distribution',
            componentInformationHeading      : 'Component Information',
            componentsToBeDistributed        : 'Components to be distributed',
            noOfDays                         : 'No of days',
            successMessage                   : 'Salary Component Settings saved Successfully.'

        },
        monthlySalaryProcess    : {
            individualAdditionalSalaryComponentHeading : 'Individual Additional Salary Component Input',
            AbsenceTypeSalaryComponentHeading : 'Absence Type input for individual employee',
            searchEmployee                             : 'Search Employee',
            absenceType                                : 'Absence Type',
            deleteAdditionalComponent                  : 'Do you want to delete this Additional Component?',
            deleteAbsentLwpComponent                   : 'Do you want to delete this Absent/Leave Component?',
        },
        bankPaymentAdvice       : {
            salaryMonth        : 'Salary month',
            notApprovedText    : 'Salary for sep 2021 is not Approved yet.',
            viewPreviousButton : 'View History From Last Month - '
        },

        payrollManagement    : {
            allEmployee               : 'All Employee',
            payrollActive             : 'Payroll Active',
            payrollInactive           : 'Payroll Inactive',
            grossSalary               : 'Gross Salary',
            netPayable                : 'Net Payable',
            setUpNow                  : 'Set Up Now',
            downloadPayrollUploadFile : 'Download Payroll Upload File',
            uploadPayrollInformation  : 'Upload Payroll Information',
            editInformation           : 'Edit Information',
            payrollInformation        : 'Payroll Information',
            amount                    : 'Amount',
            value                     : 'Value',
            percentageSign            : '%',
            fixed                     : 'Fixed',
            bankInformation           : 'Bank Information',
            paymentMode               : 'Payment Mode',
            bankName                  : 'Bank Name',
            routingNumber             : 'Routing Number',
            accountNumber             : 'Account Number',
            payrollInfoIsNotSetUp     : 'Employee payroll information is not set up',
            saveSetUp                 : 'Save Set Up',
            basicSalary               : 'Basic Salary',
            houseRentAllowance        : 'House Rent Allowance',
            conveyanceAllowance       : 'Conveyance Allowance',
            medicalAllowance          : 'Medical Allowance',
            dummyAmount               : '18000',
            noEmployeeInTheSystem     : 'You do not have any employees yet in this HRM system',
            textLine1                 : 'You can create employees and set up their payroll easily by uploading an excel file using our',
            textLine2                 : 'format given bellow. Please download the sample excel file to begin with.',
            buttonText1               : 'Upload employee information+payroll from excel',
            buttonText2               : 'Download sample excel file',
            dateOfJoining             : 'Date of Joining',
        },
        viewOrGenerateSalary : {
            salaryMonth           : 'Salary Month',
            salaryState           : 'Salary State',
            inProcess             : 'In Process',
            approved              : 'Approved',
            paid                  : 'Paid',
            employeeId            : 'Employee ID',
            employeeName          : 'Employee Name',
            dateAndTime           : 'Date & Time',
            totalEmployee         : 'Total Employee',
            totalNetPayable       : 'Total Net Payable',
            processedSalary       : 'Processed Salary',
            unprocessedSalary     : 'Unprocessed Salary',
            rollbackButton        : 'Rollback',
            approveButton         : 'Approve',
            paySalaryButton       : 'Pay Salary',
            salaryLogButton       : 'Salary Log',
            sendForApprovalButton : 'Send for Approval',
            undoSalaryButton      : 'Undo Salary',
            processSalaryButton   : 'Process Salary',
            downloadExcelButton   : 'Download Excel',
            salaryDetails         : 'Salary Details',
            action                : 'Action',
            remarks               : 'Remarks',
            edited                : 'Edited',
            editButton            : 'Edit',
            processButton         : 'Process',
            salaryComponent       : 'Salary Component',
            amount                : 'Amount',
            monthlyGrossSalary    : 'Monthly Gross Salary',
            totalSalary           : 'Total Salary',
            totalDeduction        : 'Total Deduction',
            calculatedAmount      : 'Calculated Amount',
            updatedAmount         : 'Updated Amount',
            generateSalary        : 'Generate Salary',
            viewSalaryReport      : 'View Salary Report',
            salaryGenerationText  : 'Salaries for the given month are generating, and it\'ll take a while. You\'ll get notified once the process has finished.',
            modalTitle            : 'Are you sure?',
            salaryNotSetup        : 'Salary Not Setup',

            amountComparisonModal         : {
                bodyHeading : 'Do you want to proceed without saving the changes?'
            },
            approveSalaryModal            : {
                bodyHeading : 'Do you want to approve this salary?',
            },
            paySalaryModal                : {
                bodyHeading : 'Do you want to pay this salary?',
                paySalaryText1: 'This will close the current salary month and open to process',
                paySalaryText2: 'the upcoming month\'s salary',
            },
            processSalaryModal            : {
                processFailedHeading     : 'Processing failed for some employees',
                processSalaryForAll      : 'Do you want to process the salary of all unprocessed employees?',
                processSalaryForOne      : 'Do you want to process the salary of',
                processSalaryForMultiple : 'Do you want to process the salary of Selected employees?',
            },
            undoSalaryModal               : {
                undoSalaryForAll      : 'Do you want to undo the salary of all processed employees?',
                undoSalaryForOne      : 'Do you want to undo the salary of',
                undoSalaryForMultiple : 'Do you want to process the salary of Selected employees?',
            },
            rollbackSalaryModal           : {
                bodyHeading : 'Do you want to rollback the salary?'
            },
            salaryLogModal                : {
                title       : 'Salary Log',
                bodyHeading : 'Do you want to rollback the salary?',
            },
            sendSalaryForApprovalLogModal : {
                bodyHeading : 'Do you want to send the salary for approval?',
            },
        },
        loanManagement:{
            totalLoanAmount:'Total Loan Amount',
            totalRemainingLoan:'Remaining Loan',
            activeLoans:'Active',
            loanRecovered:'Loan Recovered',
            type:'Type',
            loanAmount:'Loan Amount',
            repaidAmount:'Repaid Amount',
            loanAmountLoanDetails:'Loan Amount : ',
            repaidAmountLoanDetails:'Repaid Amount : ',
            loanOrSalaryAdvanceInputTitle : 'Add New Loan/Advance Salary',
            editLoanOrAdvanceSalaryInputTitle : 'Edit Loan/Advance Salary',
            previousLoanStatus : 'Previous Loan Status',
            previousLoanTaken : 'Previous Loan Taken',
            expectedSettlementMonth : 'Expected Settlement Month',
            noOfInstallment : 'No of Installment : ',
            installmentStartFrom : 'Installment Start From',
            loanDetails:'Loan/Advance Salary Details',
            loanRequestDate:'Loan Request Date : ',
            loanDisburseDate:'Loan Disburse Date : ',
            remainingAmount:'Remaining Amount : ',
            remainingInstallment:'Remaining Amount',
            emiNo:'EMI No',
            month:'Month',
            emiAmount:'EMI Amount',
            loanBalance:'Loan Balance',
            installmentMonths:'Installment Months',
            status:'Status',
            remarks:'Remarks:',
            deferLoan:'Defer Loan',
            earlySettlement:'Early Settlement',
            doYouWantToSaveTheText:'Do you want to save the',
            deferLoanQuestion:'Do you want to defer the loan of ',
            earlySettlementQuestion:'Do you want to Early Settlement the Loan payment for ',
            paymentMode: 'Payment Mode',
            yes:'yes',
            no:'no',
            loanDeferMonth:'Loan Defer Month (s)',
        },
        salaryCertificate : {
            totalPayment         : 'Total Payment',
            signatoryInformation : 'Signatory Information',
            signatoryNameOrId    : 'Signatory Name/Id',
            signatoryDesignation : 'Signatory Designation',
            signatoryDepartment  : 'Signatory Section',
            generateButton       : 'Generate',
            toWhomItMayConcern   : 'To whom it may concern',
            textPart1            : 'This is to certify that',
            textPart2            : 'is working as a',
            textPart3            : 'employee of',
            textPart4            : 'Currently he is working as',
            textPart5            : 'under',
            textPart6            : 'His salary details are below:',
            for                  : 'For',
            printButton          : 'Print',
            downloadDocButton    : 'Download Doc',
            employeeId           : 'Employee ID:',
        },

        bankManagement : {
            addNewBankBtn : 'Add New Bank',
            addNewBranchBtn : 'Add New Branch',
            bankList : {
                tableHeader : {
                    bankName : "Bank Name",
                    code : "Code",
                    accountName : "Account Name",
                    accountNumber : "Account Number",
                    status : "Status",
                    actions : "Actions"
                },
                adviceLetterBtn : "Create/Modify Payment Advice Letter",
                emptyTableBody : "No records found"
            },
            branchList : {
                tableHeader : {
                    bankName : "Bank Name",
                    branchName : "Branch Name",
                    routingNumber : "Routing Number",
                    status : "Status",
                    action : "Action"
                },
                emptyTableBody : "No records found"
            },
            addNewBankModal : {
                title : 'Add New Bank',
                nameInputLabel : 'Bank Name',
                nameInputPlaceholder : 'Bank Name',
                codeInputLabel : 'Code',
                codeInputPlaceholder : 'Code',
                accountNameInputLabel : 'Corporate Account Name',
                accountNameInputPlaceholder : 'Account Name',
                accountNumberInputLabel : 'Corporate Account Number',
                accountNumberInputPlaceholder : 'Account Number',
                addressInputLabel : 'Address',
                addressInputPlaceholder : 'Address',
                statusInputLabel : 'Status',
                bankSummaryHeader : 'Bank Summary',
                tableHeader : {
                    bankName : "Bank Name",
                    status : "Status",
                    action : "Action"
                },
                emptyTableBody : "No records found"
            },
            editBankModal : {
                title : 'Edit Bank',
                nameInputLabel : 'Bank Name',
                nameInputPlaceholder : 'Bank Name',
                codeInputLabel : 'Code',
                codeInputPlaceholder : 'Code',
                accountNameInputLabel : 'Corporate Account Name',
                accountNameInputPlaceholder : 'Account Name',
                accountNumberInputLabel : 'Corporate Account Number',
                accountNumberInputPlaceholder : 'Account Number',
                addressInputLabel : 'Address',
                addressInputPlaceholder : 'Address',
                statusInputLabel : 'Status'
            },
            addNewBranchModal : {
                title : 'Add New Branch',
                bankNameInputLabel : 'Bank Name',
                branchNameInputLabel : 'Branch Name',
                routingNumberInputLabel : 'Routing Number',
                branchNameInputPlaceholder : 'Branch Name',
                routingNumberInputPlaceholder : 'Routing Number',
                statusInputLabel : 'Status'
            },
            editBranchModal : {
                title : 'Edit Branch',
                bankNameInputLabel : 'Bank Name',
                branchNameInputLabel : 'Branch Name',
                routingNumberInputLabel : 'Routing Number',
                branchNameInputPlaceholder : 'Branch Name',
                routingNumberInputPlaceholder : 'Routing Number',
                statusInputLabel : 'Status'
            }
        },
        providentFund : {
            membersSubscription              : 'Member\'s Subscription',
            interestOnMembersSubscription    : 'Interest on Member\'s Subscription',
            companysContribution             : 'Company\'s Contribution',
            interestOnCompanysContribution   : 'Interest on Company\'s Contribution',
            totalContribution                : 'Total Contribution',
            PFLoan                           : 'PF Loan',
            PFLoanRecovered                  : 'PF Loan Recovered',
            PFBalance                        : 'PF Balance',
            active                          : 'Active',
            pending                         : 'Pending',
            separated                       : 'Separated',
            PFMemberDetails                 : 'PF Member Details',
            joining                         : 'Joining',
            confirmation                    : 'Confirmation',
            membership                      : 'Membership',
            separation                      : 'Separation',
            joiningDate                     : 'Joining Date',
            confirmationDate                : 'Confirmation Date',
            membershipDate                  : 'Membership Date',
            separationDate                  : 'Separation Date',
            action                          : 'Action',
            add                             : 'Add',
            remarks                         : 'Remarks',
            pfMembershipTenure              : 'PF Membership Tenure',
            openingBalance                  : 'Opening Balance',
            totalOpeningBalance             : 'Total Opening Balance',
            contributionDuringTheYear       : 'Contribution During The Year',
            totalContributionThisYear       : 'Total Contribution This Year',
            remainingLoanBalance            : 'Remaining Loan Balance',
            paymentDuringTheYear            : 'Payment During The Year',
            balanceAfterTheYear             : 'Balance After The Year',
            forfeitureForTheYear            : 'Forfeiture For The Year',
            balance                         : 'Balance',
            totalPF                         : 'Total PF',
            pFDetails                       : 'PF Details',
            pFLoan                          : 'PF Loan',
            loanAmount                      : 'Loan Amount',
            loanRecovered                   : 'Loan Recovered',
            remainingAmount                 : 'Remaining Amount',
            closeCurrentAccountingYear      : 'Close Current Accounting Year',
            uploadInterest                  : 'Upload Interest',
            reuploadInterest                : 'Reupload Interest',
            doYouWantToCloseAccounting      : 'Do you want to close PF Accounting',
            pFAccountManagement             : 'PF Account Management',
            accountingYear                  : 'Accounting Year',
            interestDuringTheYear           : 'Interest During The Year',
            totalPFBalance                  : 'Total PF Balance',

            doYouWantToUploadInterest       : 'Do you want to upload the interest for the ',
            doYouWantToAdd                  : 'Do you want to add ',
            asAPFMember                     : 'as a PF member?',
            accountYear                     : 'Account year',
            accountingYear                  : 'Accounting year',
            insertAmount                    : 'Insert Amount',
            pfStatement                     : 'PF Statement',
            balanceAfterPayments            : 'Balance After Payments',
            balanceOnLastDate               : 'Balance as on Last date of the year',
            month                           : 'Month'
        },

        visitorManagement : {
            createAppointment : {
                uploadOrTakePhoto       : 'Upload/Take Photo',
                visitorInformationEntry : 'Visitor Information Entry',
                selectCategory          : "Select Visitor Category",
                searchHost              : "Search Host by Name/ID",
                selectBloodGroup        : "Blood Group",
                emergencyContactLabel   : "Emergency Contact",
                nextButton              : "Next",
                lessAdvancedButton      : "Less",
                advancedButton          : "Advanced options",
                addVisitorButton        : "Add More Visitors+",
                selectHost              : "Select Host",
                selectDate              : "Select Date",
                entryTime               : "Entry Time",
                exitTime                : "Exit Time",
                confirmAppointment      : "Confirm Appointment",
                selectVisitPurpose      : "Select Pupose of Visit",
                visitors                : "Visitors",
                recurringVisit          : "Recurring Visit",
                sendInvitation          : "Send Invitation",
                capturePhotoModal       : {
                    header                : "Take visitor photo",
                    cameraUnavailableText : "Webcam not found or Permission denied.",
                    takePictureButton     : "Take Picture",
                    fileUploadButton      : "Select a photo from your computer"
                }
            },
            visitorCategory   : {
                createButton  : "Create Visitor Category",
                tableHeader   : {
                    visitorCategories : "Visitor Categories",
                    action            : "Action",
                    actions           : "Actions"
                },
                creationModal : {
                    title                : 'Create Visitor Category',
                    nameInputLabel       : 'Visitor Category Name',
                    nameInputPlaceholder : 'Enter Category Name',
                    createButton         : 'Create',
                    cancelButton         : 'Cancel'
                },
                deleteModal   : {
                    title            : 'Confirmation',
                    confirmationText : 'Are you sure you want to delete the visitor category named',
                },
                updateModal   : {
                    title                : 'Edit Visitor Category',
                    nameInputLabel       : 'Name',
                    nameInputPlaceholder : 'Enter Name',
                },
            },
            accessArea        : {
                title         : "Access Area",
                createButton  : "Create New Access Area",
                tableHeader   : {
                    accessAreas : "Access Areas",
                    code        : "Codes",
                    action      : "Action",
                    actions     : "Actions"
                },
                creationModal : {
                    title                : "Create Access Area",
                    nameInputLabel       : "Name",
                    codeInputLabel       : "Code",
                    nameInputPlaceholder : "Enter Name",
                    codeInputPlaceholder : "Enter Code",
                    createButton         : "Create",
                },
                deleteModal   : {
                    title            : "Confirmation",
                    confirmationText : "Are you sure you want to remove Access Area ",
                },
                updateModal   : {
                    title : "Update Access Area",
                },
            },
            myVisitorProfile  : {
                title             : "My Visitor Profile",
                search            : "Search Visitor",
                upComingVisitors  : "Upcoming Visitors",
                allVisitors       : "All Visitors",
                noResultFoundText : "No Visitors",
                visitorNames      : "Visitor Names",
                action            : "Action",
                actions           : "Actions",
                visitorInfoTitle  : "Visitor Information",
                createNewVisit    : "Create New Visit",
                saveChanges       : "Save Changes",
                save              : "Save",
                visitorMobile     : "Mobile : ",
                visitorEmail      : "Email : ",
                organization      : "Organisation : ",
                address           : "Address : ",
                visitorCategory   : "Visitor Category : ",
                createdBy         : "Created By : ",
                last5Visits       : "Last 5 Visits",
                upcomingVisit     : "Upcoming Visit",
                visitorBlock      : "Block",
                visitorsBlocked   : "Blocked",
                visitorEdit       : "Edit",
            },
            visitPurpose      : {
                title         : "Visit Purposes",
                createButton  : "Create Visit Purpose",
                tableHeader   : {
                    visitPurposes : "Visit Purposes",
                    action        : "Action",
                    actions       : "Actions"
                },
                creationModal : {
                    title                : 'Create Visit Purpose',
                    nameInputLabel       : 'Visit Purpose Name',
                    nameInputPlaceholder : 'Enter Purpose Name',
                    createButton         : 'Create',
                    cancelButton         : 'Cancel'
                },
                deleteModal   : {
                    title            : 'Confirmation',
                    confirmationText : 'Are you sure you want to delete this purpose of visit',
                },
                updateModal   : {
                    title                : 'Edit Visit Purpose',
                    nameInputLabel       : 'Visit Purpose Name',
                    nameInputPlaceholder : 'Enter New Name',
                    updateButton         : 'Update',
                },
            },
            visitorCard       : {
                createButton   : "Create Visitor Card",
                downloadButton : "Download Sample Excel",
                uploadButton   : "Upload Sample Excel",
                tableHeader    : {
                    shortCode  : "Short Code",
                    rfidNumber : "RFID Number",
                    status     : "Status",
                    action     : "Action",
                    actions    : "Actions"
                },
                emptyTableBody : "No records found",
                creationModal  : {
                    title                : "Create Visitor Card",
                    rfidInputLabel       : "RFID",
                    rfidInputPlaceHolder : "RFID",
                    codeInputLabel       : "Short Code",
                    codeInputPlaceHolder : "Short Code"
                },
                editModal      : {
                    title                : "Edit Visitor Card",
                    rfidInputLabel       : "RFID",
                    rfidInputPlaceHolder : "RFID",
                    codeInputLabel       : "Short Code",
                    codeInputPlaceHolder : "Short Code",
                    statusInputLabel     : "Status"
                },
                deleteModal    : {
                    title            : "Confirmation",
                    confirmationText : "Are you sure you want to delete "
                }
            },
            assignRole        : {
                assignButton  : "Assign Role",
                tableHeader   : {
                    employeeName : "Employee Name",
                    role         : "Role",
                    action       : "Action",
                    actions      : "Actions"
                },
                creationModal : {
                    title               : "Assign Role",
                    selectEmployeeLabel : "Select Employee",
                    selectRoleLabel     : "Select Role",
                    assignButton        : "Assign",
                },
                deleteModal   : {
                    title             : "Confirmation",
                    confirmationText  : "Are you sure you want to remove ",
                    confirmationText2 : "from ",
                }
            },
            reception         : {
                checkIn : {
                    searchCheckout           : "Search Host/Visitor/Organization/Card",
                    preRegisteredAppointment : "Pre-registered Appointment",
                    newAppointment           : "New Appointment",
                    searchInputPlaceholder   : "Search Visitor By Mobile Number/Name/Organisation/Host Name/Host ID",
                    visitorListTable         : {
                        entry : "ENTRY:",
                        exit  : "EXIT:",

                    },
                    visitorInfo              : {
                        mobileNumberLabel     : "Mobile: ",
                        categoryNameLabel     : "Visitor Category: ",
                        accessAreaLabel       : "Access Area: ",
                        reasonLabel           : "Reason: ",
                        organisationNameLabel : "Organisation Name: ",
                        entryTimeLabel        : "Entry: ",
                        exitTimeLabel         : "Exit: ",
                    },
                    questions                : {
                        title    : "Health Check",
                        checkAll : "Check All"
                    },
                    cardAssignment           : {
                        cardSelectionLabel    : "Issue Card",
                        itemInputSectionLabel : "Items Carried",
                        itemAddLabel          : "+ Add Item",
                        itemTable             : {
                            nameColumnTitle        : "Item Name",
                            descriptionColumnTitle : "Description",
                            quantityColumnTitle    : "Quantity",
                            emptyTable             : "No Items have been added."
                        },
                        checkInButton         : "CHECK IN"
                    },
                    newAppointmentForm       : {
                        accessAreaLabel         : "Access Area",
                        selectAccessAreaLabel   : "Select Access Area",
                        visitPurposeLabel       : "Purpose of Visit",
                        selectVisitPurposeLabel : "Select Purpose of Visit",
                        selectHostLabel         : "Host Information"
                    },
                    confirmationModal        : {
                        title            : "Confirmation",
                        confirmationText : "Are you sure you want to check-in "
                    }
                }
            },
            successModal      : {
                headerText                    : 'Successful!',
                appointmentCreationSuccessMsg : 'You have successfully created an appointment!',
                checkInSuccessMsg             : 'Visitor has been successfully Checked In!',
                checkOutSuccessMsg            : 'Visitor has been successfully Checked Out!',
                editSuccess                   : 'Appointment has been edited successfully!',
            },
            checkIn           : 'Check In',
            checkOut          : 'Check Out',
            hostName          : 'Host Name',
            visitorName       : 'Visitor Name',
            visitorMobile     : 'Visitor Mobile',
            noUpcomingVisit   : 'No upcoming visit',
            noPastVisits      : 'No past visits',
        },

        //Site Management
        siteManagement        : {
            siteManagementTitle    : 'Site Management',
            createSites            : 'Create Sites',
            viewSites              : 'View Sites',
            siteName               : 'Site Name',
            siteAddress            : 'Site Address',
            siteManager            : 'Site Manager',
            assignSiteManager      : 'Assign Site Manager',
            mostlyOnTimeEmployee   : "Mostly On Time Employee",
            topActiveSites         : "Top Active Sites",
            mostlyPresentEmployee  : "Mostly Present Employee",
            expectedAttendance     : "Expected Attendance",
            actualAttendance       : "Actual Attendance",
        },


        filters            : {
            companies          : 'Companies',
            offices            : 'Offices',
            year               : 'Year',
            month              : 'Month',
            departments        : 'Sections',
            subDepartments     : 'Sub Sections',
            designations       : 'Designations',
            shiftGroups        : 'Shift Groups',
            gender             : 'Gender',
            employmentType     : 'Employment Type',
            workplaces         : 'Workplaces',
            leaveCategories    : 'Leave Categories',
            leaveApprovalStatus: 'Leave Approval Status',
            component          : 'Component',
            absenceType        : 'Absence Type',
            searchEmployee     : 'Search Employee',
            filterByNetPayment : 'Filter By Net Payment',
            from               : 'From',
            to                 : 'To',
            salaryMonth        : 'Salary Month',
            comparisonMonth    : 'Comparison Month',
            searchByNameID     : 'Search Employee by Name/ID'
        },
        parkingManagement       :{
            liveFeed            : 'Live Feed',
            enteredVehicles     : 'Entered Vehicles',
            total               : 'Total Slot',
            available           : 'Total Available',
            occupied            : 'Total Occupied',
            registerNewVehicles : "Register New Vehicle",
            parkingSlotSetup    : "Parking Slot Setup",
            ownerInformation    : "Owner Information",
            ownerInformationEntry: "Owner Information Entry",
            vehicleInformation  : "Vehicle Information",
            vehicleInformationEntry: "Vehicle Information Entry",
            driverInformation   : "Driver Information",
            driverInformationEntry   : "Driver Information Entry",
            code                : "Code",
            brand               : "Brand",
            model               : "Model",
            vehicleType         : "Vehicle Type",
            contactNumber       : "Contact Number",
            mobileNumber        : "Mobile Number",
            companyName         : 'Company Name',
            email               : "Email",
            selectOrEnterType   : "Select/Enter Type",
            color               : "Color",
            selectColor         : "Enter Color",
            enterModel          : "Enter Model",
            enterBrand          : "Enter Brand",
            enterDriverMobileNo : "Enter Driver mobile Number",
            enterDriverName     : "Enter Driver Name",
            enterVehicleNumber  : "Enter Vehicle Number",
            enterMobileNumber   : "Enter Mobile Number",
            enterEmail          : "Enter Email",
            enterCompanyName    : "Enter Company Name",
            confirmRegistration : "Confirm Registration",
            foundNearby         : 'Found Nearby',
            vehicleNumber       : 'Vehicle Number',
            driverName          : 'Driver Name',
            driverMobileNumber  : 'Driver Mobile Number',
            ownerName           : 'Owner Name',
            ownerMobileNumber   : 'Owner Mobile Number',
            parkingType         : 'Parking Type: ',
            entryTime           : 'Entry Time',
            baseFare            : 'Base Fare',
            entryVehicle        : 'Entry Vehicle',
            exitVehicle         : 'Exit Vehicle',
            timeSpent           : 'Time Spent',
            billSetup           : 'Bill Setup',
            billSetupNew        : 'Setup New Bill',
            createNewBill       : 'Create New Bill',
            updateNewBill       : 'Update Bill',
            billType            : 'Bill Type',
            baseHour            : 'Base Hour',
            baseFareTk          : 'Base Fare Tk',
            baseFareInTk        : 'Base Fare in Tk',
            hourlyFareTk        : 'Hourly Fare Tk',
            hourlyFareInTk      : 'Hourly Fare In Tk',
            deleteModal         : 'Are you sure you want to delete vehicle type ',
            saveButton          : 'Save',
            cancelButton        : 'Cancel',
            employeeParking     : 'Employee Parking',
            visitorParking      : 'Visitor Parking',
            totalParking        : 'Total Parking',
            totalBill           : 'Total Bill Amount',
            amount              : 'Amount',
            paid                : 'Paid',
            tollFree            : 'Toll Free',
            createBillSetupErrorMassage: 'This field is required and can\'t be negative',
            requiredMessage     : 'This field is required',


            numberOfSlot        : 'Number Of Slot',
            enterNumberOfSlot   : "Enter Number Of Slot",
            createSlot          : "Create Slot",
            updateSlot          : 'Update Slot',

            printSlip           : {
                parkingBill         : 'DSE Parking Bill',
                driverMobile        : 'Driver Mobile',
                totalHourSpent      : 'Total Hour Spent',
                hoursFare           : 'Hours Fare',
                totalFare           : 'Total Fare',
            }

        },
        membershipManagement: {
            dashboard: {
                liveAttendanceFeed      : 'Live Feed',
                totalMemberVisitToday   : 'Total Member Visit Today',
                mostActiveMembers       : 'Most Active Members',
                soonToBeExpired         : 'Soon To Be Expired',
                notComingToLong         : 'Not Coming For Too Long',
            },
            members: {
                searchInputPlaceholder: 'Search Member By Name',
                active                : 'Active',
                expireSoon            : 'Expire Soon',
                expired               : 'Expired',
                memberName            : 'Member Name',
                memberId              : 'Member ID',
                email                 : 'Email',
                mobile                : 'Mobile',
                gender                : "Gender",
                dateOfBirth           : "Date Of Birth",
                joiningDate           : "Joining Date",
                nid                   : "NID",
                presentAddress        : "Present Address",
                uploadDocument        : "Upload Document",
                package               : 'Package',
                contactNumber         : 'Contact Number',
                addNewMemberButton    : 'Add New Member',
                renewalSubscriptionButton  : 'Renewal Subscription',
                upgradeSubscriptionButton  : 'Upgrade Subscription',
                packageType           : 'Package Type',
                duration              : 'Duration',
                packageStartDate      : 'Package Start Date',
                packageEndDate        : 'Package End Date',
                packageAmount         : 'Package Amount',
                paidAmount            : 'Paid Amount',
                renewal               : 'Renewal',
                upgrade               : 'Upgrade',
                upgradePackage        : 'Upgrade Package',
                expireDate            : 'Expire Date',
                expiredDate           : 'Expired Date',
                renewalModal          : 'Membership Renewal is Successful',
                memberInfo            : 'Member Information',
                addNewMember          : 'Add New Member',
                editNewMember         : 'Edit New Member',
                subscriptionInformation: "Subscription Information",
                selectPackage         : "Select Package",
                rfidCard              : "RFID Card",
                selectAccessDevice    : "Select Access Device",
                doYouWantToDeleteMember : 'Do you want to delete the member',
                doYouWantToRenewMembership : 'Do you want to renew the membership of',
                doYouWantToRemoveFile : 'Do you want to remove the file',
                doYouWantToRenewalMember : 'Do you want to renewal membership of',
                doYouWantToUpgradeMember : 'Do you want to upgrade membership of',
                confirmButton         : 'Confirm Membership Upgrade',
            },
            settings: {
                title                    : "Settings",
                createButton             : "Create New Package",
                packageName              : "Package Name",
                packageDuration          : "Package Duration",
                duration                 : "Duration",
                noOfMonths               : "Number of Months",
                price                    : "Price",
                packagePrice             : "Package Price",
                createPackage            : "Create Package",
                editPackage              : "Edit Package",
                doYouWantToDeletePackage : 'Do you want to delete package'
            }
        },
        noData             : "No Data",
        noManualEntryFound : "No Manual Entries found",
        area               : "Area",
        noFieldVisitsFound : "No Field Visits found",
        noLateEntriesFound : "No Late Entries found",
        notifications      : {
            title             : 'Notifications',
            noNotificationMsg : "Looks like no notifications here to show!"
        },
        downloadLimitWarningModal : {
            warningText : "You can not download reports of more than 1 month.",
            contactMessage : "Please contact Customer Support for further assistance."
        }

        //This is a change to show a demo of git system
    });
}).call(this);

(function () {
    app.constant('ENGLISH', {
        //General
        submit                            : 'Submit',
        apply                             : 'Apply',
        pleaseWait                        : 'Please wait ...',
        confirm                           : 'Confirm',
        approve                           : 'Approve',
        type                              : 'Type',
        endDate                           : 'End Date',
        designation                       : 'Designation',
        employmentType                    : 'Employment Type',
        department                        : 'Department',
        shift                             : 'Shift',
        shiftGroup                        : 'Shift Group',
        company                           : 'Company',
        workplace                         : 'Workplace',
        location                          : 'Location',
        deleteConfirmation                : 'Do you want to delete this',
        remove                            : 'Remove',
        description                       : 'Description',
        link                              : 'Link',
        search                            : 'Search',
        dateRange                         : 'Date Range',
        attendanceReportOf                : 'Attendance Report of',
        fieldVisitReportOf                : 'Field Visit Report of',
        date                              : 'Date',
        reason                            : 'Reason',
        entryTime                         : 'Entry Time',
        lateBy                            : 'Late By',
        approvalOne                       : 'Approval One',
        approvalTwo                       : 'Approval Two',
        status                            : 'Status',
        pending                           : 'Pending',
        accepted                          : 'Accepted',
        rejected                          : 'Rejected',
        cancelled                         : 'Cancelled',
        notApplied                        : 'Not Applied',
        timeLine                          : 'Timeline',
        hrApproval                        : 'HR Manager Approval',
        firstApproval                     : 'First Approver Status',
        secondApproval                    : 'Second Approver Status',
        lineApproval                      : 'Line Manager Approval',
        detailedAttendanceLogs            : 'Detailed Attendance Logs',
        time                              : 'Time',
        device                            : 'Device',
        entryType                         : 'Entry Type',
        manualEntry                       : 'Manual Entry',
        addNewManualEntry                 : 'Add New Manual Entry',
        manualEntryInfo                   : 'Manual Entry Info (If Applicable)',
        notApplicable                     : 'Not Applicable',
        requestor                         : 'Requestor',
        punchType                         : 'Punch Type',
        first                             : 'First',
        last                              : 'Last',
        showing                           : 'Showing',
        showingPage                       : 'Showing page ',
        outOf                             : 'out of ',
        pages                             : 'pages',
        missingPunch                      : 'Missing Punch',
        selectType                        : 'Select Type',
        fieldVisitText                    : 'Field Visit',
        leaveApplyForOthers               : 'Apply Leave for other employees',
        leaveApplication                  : 'Leave Application',
        category                          : 'Category',
        numberOfDays                      : 'Number Of Days',
        timeline                          : 'Timeline',
        file                              : 'File',
        hand                              : 'Hand',
        finger                            : 'Finger',
        template                          : 'Template',
        left                              : 'Left',
        right                             : 'Right',
        or                                : 'Or',
        register                          : 'Register',
        delete                            : 'Delete',
        selectADevice                     : 'Select a Device',
        start                             : 'Start',
        stop                              : 'Stop',
        selectAType                       : 'Select a Type',
        selectAYear                       : 'Select a Year',
        full                              : 'Full',
        half                              : 'Half',
        startAndEndDate                   : 'Start and End Date',
        leaveCategory                     : 'Leave Category',
        selectACategory                   : 'Select a Category',
        uploadFile                        : 'Upload File',
        startDate                         : 'Start Date',
        leaveHalf                         : 'Leave Half',
        selectALeaveHalf                  : 'Select a Leave Half',
        firstHalf                         : 'First Half',
        secondHalf                        : 'Second Half',
        identifier                        : "Identifier",
        phoneNumber                       : 'Phone Number',
        mobile                            : 'Mobile',
        from                              : 'From',
        to                                : 'To',
        timing                            : 'Timing',
        action                            : 'Action',
        actions                           : 'Actions',
        edit                              : 'Edit',
        update                            : 'Update',
        cancel                            : 'Cancel',
        exitTime                          : 'Exit Time',
        applyForLateApproval              : 'Apply for Late Approval',
        selectADate                       : 'Select A Date',
        areYouSureYouWantToChangeStatusOf : 'Do you want to change status of ',
        areYouSureYouWantTo               : 'Do you want to',
        include                           : 'include',
        changeEmployeeStatus              : 'Change Employee Status',
        forTheEmployees                   : 'for the employees',
        yes                               : 'Yes',
        no                                : 'No',
        employeeResignation               : 'Employee Resignation',
        rehireEmployee                    : 'Rehire Employee',
        remark                            : 'Remark',
        resignationDate                   : 'Resignation Date',
        documentUpload                    : 'Document Upload',
        documentType                      : 'Document Type',
        upload                            : 'Upload',
        rowsPerPage                       : 'Rows Per Page',
        count                             : 'Count',
        name                              : 'Name',
        employeeName                      : 'Employee Name',
        lineManager                       : 'Line Manager',
        manualEntryFirstApprover          : 'First Approver',
        manualEntrySecondApprover         : 'Second Approver',
        hrManager                         : 'HR Manager',
        monthWithColon                    : 'Month:',
        dateRangeWithColon                : 'Date Range:',
        monthlyAttendanceReport           : 'Monthly Attendance Report',
        weeklyAttendanceReport            : 'Weekly Attendance Report',
        mask                              : 'Mask',
        temperature                       : 'Temperature',
        viewOnlyUnknownPeopleLogs         : 'View only unknown people logs',
        viewAllUnauthorisedLogs           : 'View All unauthorised logs',
        rfidCard                          : 'RFID Card',
        inOut                             : 'In/Out',
        loginPageTitle                    : 'Login - Tipsoi HR Management',
        loginPageText                     : 'নির্ভুল, সহজতর এবং সময়সাশ্রয়ী ব্যবস্থাপনায় টিপসই HRM',
        geoLocationBased                  : 'GEO-Location Based',
        smartAttendanceSystem             : 'Smart Attendance System',
        email                             : 'Email',
        emailOrEmployeeId                 : "Email/Employee ID",
        password                          : 'Password',
        active                            : 'Active',
        inactive                          : 'Inactive',
        success                           : 'Success!',
        confirmation                      : 'Confirmation',
        remarks                           : 'Remarks',
        employeeEmployee                  : 'Search Employee',
        pleaseSelect                      : 'Please Select',
        none                              : 'None',
        na                                : 'N/A',
        pushNotification                  : 'Push Notification',
        year                              : 'Year',
        total                             : 'Total',
        searchEmployee                    : 'Search Employee',
        amount                            : 'Amount',



        //Table Summaries
        sl                   : 'SL',
        id                   : 'ID',
        entry                : 'Entry',
        exit                 : 'Exit',
        present              : 'Present',
        absent               : 'Absent',
        earlyExit            : 'Early Exit',
        leave                : 'Leave',
        late                 : 'Late',
        pendingLate          : 'Pending Late',
        approval             : 'Approval',
        applicationStatus    : 'Application\nStatus',
        applications         : 'Applications',
        today                : 'Today',
        given                : 'Given',
        totalLate            : 'Total Late',
        thisMonth            : 'This Month',
        InHours              : 'in Hours',
        dayOff               : 'Day off',
        expected             : 'Expected',
        average              : 'Average',
        actual               : 'Actual',
        difference           : 'Difference',
        hours                : 'Hours',
        noAttendanceFound    : 'Sorry no attendance data found within given limit or filters',
        noDataFound          : 'Sorry no data found within given limit or filters',
        noLeaves             : 'No leaves.',
        totalWorked          : 'Total Worked',
        expectedWorkingHour  : 'Expected Working Hour',
        offDays              : 'Off Days',
        holidays             : 'Holidays',
        specialDays          : 'Special Day',
        totalEmployees       : 'Total Employees',
        totalAbsentDays      : 'Total Absent Days',
        totalWorkingHourLoss : 'Total Working Hour Loss',
        totalOnTime          : 'Total on Time',
        workingDays          : 'Working Days',
        expectedHours        : 'Expected Hours',
        workingHours         : 'Working Hours',
        fieldVisits          : 'Field Visits',
        averageWorkingHour   : 'Average Working Hour',
        otHours              : 'OT Hours',
        absentDays           : 'Absent Days',
        leaveDays            : 'Leave Days',
        noOfFieldVisits      : 'Field Visits',
        lateHours            : 'Late Hours',
        overTimeHours        : 'Overtime Hours',
        employeeType         : 'Employee Type',
        office               : 'Office',
        totalAbsent          : 'Total Absent',
        totalPresent         : 'Total Present',
        lastAbsent           : 'Last Absent',
        last30dayAbsent      : 'Absent in Last 30 Days',
        day                  : 'Day',
        days                 : 'Days',
        dates                : 'Dates',
        lunch                : 'Lunch',
        dinner               : 'Dinner',
        noOutPunch           : 'No Out Punch',
        employeeId           : 'Employee Id',
        dateOfJoining        : 'Date Of Joining',
        paymentMethod        : 'Payment Method',
        routingNo            : 'routingNo',
        earnings             : 'Earnings',
        amountInBDT          : 'Amount(in BDT)',
        deduction            : 'Deduction',
        bankName             : 'Bank Name',
        numberOfEmployees    : 'Number of Employees',
        netPayment           : 'Net Payment',
        bankPayment          : 'Bank Payment',
        cashPayment          : 'Cash Payment',
        accountNo            : 'Account No',
        bank                 : 'Bank',
        cash                 : 'Cash',
        totalSalary          : 'Total Salary',
        totalDeduction       : 'Total Deduction',
        netPayable           : 'Net Payable',
        latitude             : 'Latitude',
        longitude            : 'Longitude',
        siteName             : 'Site Name',
        siteManager          : 'Site Manager',
        differance           : 'Differance',
        leaveType            : 'Leave Type',
        entitled             : 'Entitled',
        balance              : 'Balance',
        joiningDate          : 'Joining Date',
        confirmationDate     : 'Confirmation Date',
        membershipDate       : 'Membership Date',
        separationDate       : 'Separation Date',
        memberName           : 'Member Name',
        contactNumber        : 'Contact Number',
        package              : 'Package',
        packageAmount        : 'Package Amount',
        expiryDate           : 'Expiry Date',
        totalMember          : 'Total Member',
        hour                 : 'Hour',
        totalHourSpent       : 'Total Hour Spent',
        approvedLates        : 'Approved Lates',
        leaveApprovalStatus  : 'Approval Status',




        vehicleNumber        : 'Vehicle Number',
        ownerOrDriverName    : 'Owner/Driver Name',
        driverName           : 'Driver Name',
        ownerName            : 'Owner Name',
        driverMobileNumber   : 'Driver Mobile Number',
        parkingType          : 'Parking Type',
        totalHours           : 'Total Hours',
        billTk               : 'Bill Amount',
        employee             : 'Employee',
        visitor              : 'Visitor',
        totalParking         : 'Total Parking',
        totalHour            : 'Total Hour',
        totalEmployee        : 'Total Employee',
        onTime               : 'On Time',
        totalSites           : 'Total Sites',
        whenToCheckAbsent    : 'When to Check Absent',





        leaveHistoryReportOf         : 'Leave History Report Of ',
        totalLeaveDays               : 'Total Leave Days',
        totalWorkingHourLossForLeave : 'Total Working Hour Loss For Leave',


        //Side-Bar Texts
        dashboard                : 'Dashboard',
        attendanceReport         : 'Attendance Report',
        detailedAttendanceReport : 'Detailed Attendance',
        departmentReport         : 'Department Report',
        shiftReport              : 'Shift Report',
        monthlyReport            : 'Monthly Report',
        detailedMonthlyReport    : 'Detailed Monthly Report',
        weeklyReport             : 'Weekly Report',
        dailyReport              : 'Daily Report',
        locationDeviationReport  : 'Location Deviation',
        siteAttendanceReport     : 'Site Attendance Report',
        siteSummaryReport        : 'Site Summary Report',
        leaveReport              : 'Leave Report',
        monthlyAbsentReport      : 'Absent Summary Report',
        lateReport               : 'Late Report',
        workingHourReport        : 'Working Hour Report',
        employees                : 'Employees',
        manageEmployees          : ' Manage Employees',
        createBatch              : 'Create Batch',
        settings                 : 'Settings ',
        designations             : 'Designations',
        employmentTypes          : 'Employment Types',
        departments              : 'Departments',
        subDepartments           : 'Sub Departments',
        workplaces               : 'Workplaces',
        shiftManagement          : 'Shift Management',
        shifts                   : 'Shifts',
        shiftGroups              : 'Shift Groups',
        roster                   : 'Roster',
        leaveCategories          : 'Leave Categories',
        leavePolicy              : 'Leave Policy',
        pendingApprovals         : 'Pending Approvals',
        leaveApplicationDetails  : 'Leave Application Details',
        deviceList               : 'Device List',
        deviceAllocationDetails  : 'Device Allocation Details',
        allocationHistory        : 'Allocation History',
        overtimeMenu             : 'Overtime Menu',
        overtimeMonthlySummary   : 'Monthly Summary',
        overtimeReport           : 'Overtime Report',
        overtimeAllocator        : 'Overtime Allocator',
        sms                      : 'SMS',
        projectManagement        : 'Project Management',
        pandemicReport           : 'Pandemic Report',
        fieldVisitReport         : 'Field Visit Report',
        dynamicShiftGroups       : 'Dynamic Shift Groups',

        //Absent Repost Texts
        absentReport      : 'Absent Report',
        dailyAbsentReport : 'Daily Absent Report',

        diningReport      : 'Dining Report',
        dailyDiningReport : 'Daily Report',
        monthlyDiningReport : 'Monthly Report',
        detailedDiningReport : 'Detailed Report',
        totalLunch       : 'Total Lunch',
        totalDinner      : 'Total Dinner',

        leaveHistoryReport : "Leave History Report",
        leaveBalanceReport : "Leave Balance Report",

        //Salary Reports
        salaryReport               : 'Salary Report',
        salaryComparisonSummary    : {
            title      : 'Salary Comparison Summary',
            component  : 'Component',
            difference : 'Difference',
        },
        individualSalaryComparison : 'Individual Salary Comparison',
        monthOnMonthComparison     : 'Month on Month Comparison',
        //Dashboard Texts

        dashboardFilter          : {
            employeeCategory: 'Employee Type',
            company         : 'Subsidiary',
            workplace       : 'Workplace',
        },
        dashboardPresent         : 'Present',
        dashboardAbsent          : 'Absent',
        dashboardLate            : 'Late',
        dashboardOntime          : 'On Time',
        departmentWiseAttendance : 'Department Wise Attendance',
        officeWiseAttendance     : 'Office Wise Attendance',
        companyWiseAttendance    : 'Company Wise Attendance',
        mostAbsents              : 'Most Absents',
        mostLates                : 'Most Lates',
        lateToday                : 'Late Today',
        onLeave                  : 'On Leave',
        leastAbsents             : 'Least Absents',
        leastLates               : 'Least Lates',
        attendanceFeed           : 'Attendance Feed',
        calender                 : 'Calender',

        userLogin : {
            signInFailed   : 'Sign in Failed',
            incorrectInput : 'Incorrect email or password'
        },
        //Profile Texts
        //Profile Information -->
        notSet      : 'Not Set',
        remarksHere : 'Remarks Here',
        notAssigned : 'Not Assigned',
        generalInfo : {
            name           : 'Name',
            id             : 'ID',
            identifier     : 'Identifier',
            email          : 'Email',
            department     : 'Department',
            subDepartment  : 'Sub Department',
            designation    : 'Designation',
            employmentType : 'Employment Type',
            shiftGroup     : 'Shift Group',
            gender         : 'Gender',
            primaryText    : 'Primary Text',
            secondaryText  : 'Secondary Text',
            rfid           : 'RFID',
            personId3rdPartyDevice : 'PersonID 3rd party Device',
            reportPosition : 'Report Position',
            leavePolicy    : 'Leave Policy',
            joiningDate    : 'Joining Date',
            endDate        : 'End Date',
            workplace      : 'Workplace',
            lineManager    : 'Line Manager',
            hrManager      : 'HR Manager',
            site           : 'Site'

        },
        //Approver Information
        approverInformation : {
            firstLeaveApprover  : 'First Leave Approver',
            secondLeaveApprover : 'Second Leave Approver',
            firstLateApprover   : 'First Late Approver',
            secondLateApprover  : 'Second Late Approver',
            firstManualEntryApprover   : 'First Manual Entry Approver',
            secondManualEntryApprover  : 'Second Manual Entry Approver'
        },

        //Personal And Contact Information
        personalAndContactInformation : {
            fathersName   : 'Father\'s Name',
            mothersName   : 'Mother\'s Name ',
            bloodGroup    : 'Blood Group',
            dateOfBirth   : 'Date of Birth',
            nationalId    : 'National ID',
            officePhone   : 'Office Phone',
            homePhone     : 'Home Phone',
            cellPhone     : 'Cell Phone',
            personalPhone : 'Personal Phone'

        },
        //Address
        address : {
            address        : 'Address',
            noAddressFound : 'No Address Found',
            permanent      : 'Permanent',
            present        : 'Present',
            home           : ' Home',
            subDistrict    : 'Thana',
            district       : 'District',
            addAddress     : 'Add Address'
        },
        //Change Password
        changePassword : {
            password        : 'Password',
            confirmPassword : 'Confirm Password'
        },
        //Employment History
        employmentHistory : {
            employmentHistory       : 'Employment History',
            createEmploymentHistory : 'Create Employment History',
            editEmploymentHistory   : 'Edit Employment History',
            companyName             : 'Company Name',
            companyBusiness         : 'Company Business',
            responsibilities        : 'Responsibilities',
            notFound                : 'No Employment History provided. Please click here to add one.'

        },
        //Education History
        educationHistory : {
            educationHistory       : 'Education History',
            createEducationHistory : 'Create Education History',
            editEducationHistory   : 'Edit Education History',
            deleteConfirmation     : 'Do you want to delete this education history?',
            notFound               : 'No Education History provided. Please click here to add one.',
            degreeName             : 'Degree Name',
            institution            : 'Institution',
            board                  : 'Board',
            year                   : 'Year',
            grade                  : 'Grade',

        },
        //Employee Documents
        employeeDocuments : {
            documents : 'Documents',
            notFound  : 'No Documents Found',
            ssc       : 'SSC Certificate',
            hsc       : 'HSC Certificate',
            bachelors : 'Bachelors Certificate',
            passport  : 'Passport',
            nid       : 'NID',
            cv        : 'CV'
        },
        //Profile Actions
        profileActions : {
            applyForLeave               : 'Apply for Leave',
            applyForLateApproval        : 'Apply for Late Approval',
            manualEntry                 : 'Manual Entry',
            enrolFingerprint            : 'Enrol Fingerprint',
            removeAdminRole             : 'Remove Admin Role',
            removeSubsidiaryAdminRole   : 'Remove Subsidiary Admin Role',
            setAsAdmin                  : 'Set as Admin',
            setAsSubsidiaryAdmin        : 'Set as Subsidiary Admin',
            setAsHrManager              : 'Set as HR Manager',
            removeHrManagerRole         : 'Remove HR Manager Role',
            setAsLineManager            : 'Set as Line Manager',
            removeLineManagerRole       : 'Remove Line Manager Role',
            allowLineManagerShiftManagement : 'Allow Shift Change',
            disallowLineManagerShiftManagement : 'Disable Shift Change',
            makeEmployeeStatusActive    : 'Make Employee Status Active',
            makeEmployeeStatusInactive  : 'Make Employee Status Inactive',
            resignEmployee              : 'Resign Employee',
            rehireEmployee              : 'Rehire Employee',
            deleteEmployee              : 'Delete Employee',
            disallowOvertime            : 'Disallow Overtime',
            allowOvertime               : 'Allow Overtime',
            includeInAttendanceReport   : 'Include in Attendance Report',
            include                     : 'include',
            excludeFromAttendanceReport : 'Exclude From Attendance Report',
            syncEmployee                : 'Sync Employee',
            setAsSiteManager            : 'Set as Site Manager',
            removeSiteManagerRole       : 'Remove Site Manager Role',
            removeSiteAdminRole         : 'Remove Site Admin Role',
            setAsSiteAdmin              : 'Set as Site Admin',
            setAsProjectManager         : 'Set as Project Manager',
            removeProjectManagerRole    : 'Remove Project Manager Role'

        },
        //Profile Attendance Report
        profileAttendanceReport : {
            punchDeleteModal : {
                title            : 'Confirmation',
                confirmationText : 'Are you sure you want to delete this punch'
            }
        },

        //Dashboard
        dashboardText : {
            degreeCelsius             : '°C',
            warning                   : '**Warning: Your subscription has expired.<br />Please pay your due yearly subscription fees to avoid interruption in your service connectivity.<br />If you have already cleared all of your due fees, you can ignore this message.',
            warningForGBPLClients     : '**Warning: Your subscription to Tipsoi Smart Attendance System has expired.<br />Please call 01313359293 and pay your due subscription fees to avoid interruption in your service connectivity. If you have already paid, please ignore this message.',
            warningForGPClients       : '**Warning: Your service will be interrupted indefinitely after 10 September 2022.<br />Please contact Grameenphone to resolve this matter.',
            reminderTextPart1         : '**Reminder: Your subscription will be expired within',
            reminderTextPart2         : 'days. Please pay your yearly subscription fee to avoid interruption in service connectivity.',
            time                      : 'Time:',
            late                      : 'Late',
            totalLates                : 'Total Lates This Month -',
            lineManager               : 'Line Manager -',
            noOneIsOnLeaveText        : 'No one is on leave today or in near future.',
            from                      : 'From:',
            date                      : 'Date:',
            total                     : 'Total',
            day                       : 'day',
            s                         : 's',
            toWithColon               : 'To:',
            name                      : 'Name',
            workingDays               : 'Working Days',
            absent                    : 'Absent',
            occupancyDashboardHeading : 'Occupancy Dashboard',
            inside                    : 'Inside',
            outside                   : 'Outside',


        },

        //Employees
        //Manage Employees
        manageAllEmployees : {
            title                   : 'Manage Employees',
            filter                  : {
                offices: 'Offices',
                company: 'Company',
                office: 'Office',
                departments: 'Departments',
                subDepartments: 'Sub Departments',
                designations: 'Designations',
                shiftGroups: 'Shift Groups',
                gender: 'Gender',
                workplace: 'Workplace',
                subsidiary: 'Subsidiary',
                status: 'status',
                searchByName: 'Search By Name/ID/RFID',
                employmentType: 'Employment Type',
                searchButton: 'Search',
                mobilePunchStatus: 'Mobile Punch Status',
                geoFencingStatus: 'Geo Fencing Status',
                trackingStatus: 'Tracking Status',
                searchById: 'Search By ID',
                searchByCentralServerID: 'Search By Central Server ID'

            },
            createEmployeeButton    : 'Create Employee',
            employeeActionButton    : 'Employee Action',
            showEnrolmentButton     : 'Show Enrolment',
            downloadExcelButton     : 'Download Excel',
            selectAllButton         : 'Select All',
            sortByButton            : 'Sort By',
            rowPerPageInputLabel    : 'Rows Per Page',
            selectOption            : {
                rowPerPageValue_10   : '10',
                rowPerPageValue_50   : '50',
                rowPerPageValue_100  : '100',
                rowPerPageValue_1000 : '1000',
            },
            emptyResultText         : 'No employees with given filter found',
            employeeListTableHeader : {
                image          : 'Image',
                id             : 'ID',
                name           : 'Name',
                office         : 'Office',
                department     : 'Department',
                shiftGroup     : 'Shift Group',
                employmentType : 'Employment Type',
                designation    : 'Designation',
                workplace      : 'Workplace',
                lineManager    : 'Line Manager',
                status         : 'Status',
                fingerprints   : 'Fingerprints',
                rfid           : 'RFID'
            },

        },
        dinnerTableHeader  : {
            lunch          : 'Lunch',
            dinner         : 'Dinner',
        },

        //Create Employee
        createEmployee : {
            title                : 'Create Employee',
            selectGender         : 'Select Gender',
            selectDesignation    : 'Select Designation',
            selectDepartment     : 'Select Department',
            selectSubDepartment  : 'Select Sub Department',
            selectLeavePolicy    : 'Select Policy',
            selectEmploymentType : 'Select Employment Type',
            selectShiftGroup     : 'Select Shift Group',
            selectWorkplace      : 'Select Workplace',

            inputForm    : {
                name                 : 'Name',
                email                : 'Email',
                gender               : 'Gender',
                password             : 'Password',
                confirmPassword      : 'Confirm Password',
                uploadImage          : 'Upload Image',
                startDate            : 'Start Date',
                designation          : 'Designation',
                department           : 'Department',
                subDepartment        : 'Sub Department',
                leavePolicy          : 'Leave Policy',
                employmentType       : 'Employment Type',
                shiftGroup           : 'Shift Group',
                workplace            : 'Workplace',
                reportPosition       : 'Report Position',
                employeeId           : 'Employee ID',
                rfid                 : 'RFID',
                personId3rdPartyDevice : 'PersonID 3rd party Device',
                primaryDisplayText   : 'Primary Display Text',
                secondaryDisplayText : 'Secondary Display Text',
                maxTenChar           : '(Maximum 10 characters)',
                endDate              : 'End Date',
                addEndDate           : 'Add End Date (Optional)'
            },
            errorMsg     : {
                name                 : 'Name is required',
                invalidEmail         : 'Invalid Email',
                emptyEmail           : 'Email is Required',
                password             : 'Password is required',
                invalidCapital       : 'Password does not contain required amount of capital letters: ',
                invalidSmall         : 'Password does not contain required amount of small letters: ',
                invalidSymbol        : 'Password does not contain required amount of special characters: ',
                invalidNumber        : 'Password does not contain required amount of numbers: ',
                consecutiveChar      : 'Password can not have consecutive characters more than ',
                invalidLength        : 'Password does not have required length: ',
                invalidIllegalSymbol : 'Password can only have these special characters: !@#$%^&*',
                invalidPassword      : 'Password is invalid',
                commonPassword       : 'Password can not be a common password or a word in dictionary',
                similarWithUserInfo  : 'Password can not be similar with user information',
                confirmPassword      : 'Password is required',
                department           : 'Select a Department from the list',
                employmentType       : 'Select an Employment Type from the list',
                primaryDisplayText   : 'Primary Display Text is required',
                secondaryDisplayText : 'Secondary Display Text is required',
                startDate            : 'Start Date is required',
                gender               : 'Gender is required',
                shiftGroup           : 'Shift Group is required',
                emptyEmployeeId      : 'Employee ID is required',
                usedEmployeeId       : 'ID is already in use'
            },
            createButton : 'Create New Employee'
        },

        //Create Batch
        employeesBatchCreation : {
            batchCreateTabHeader           : 'Batch Create',
            historyTabHeader               : 'History',
            employeeCreationGuidline       : 'Employee Creation Guidelines',
            employeeCreationGuidlineList   : {
                listItem_1 : 'ID and Email need to be unique for each Employee.',
                listItem_2 : 'Mandatory Fields are marked in the Sample File.',
                listItem_3 : 'RFID number must be the first 10 digits only, e.g. (0002547896).',
                listItem_4 : 'No gaps are allowed between rows. Rows after gap won\'t be counted.',
                listItem_5 : 'Uploaded Excel file must be xls or xlsx only.',
                listItem_6 : 'Primary and Secondary Display Text can not be more than 10 characters.',
                listItem_7 : 'Report Position must be a number.',
            },
            informationChanged             : 'Information Changed',
            employeesTableHeader           : {
                id             : 'ID',
                employeeName   : 'Employee Name',
                email          : 'Email',
                reportPosition : 'Report Position',
                rfid           : 'RFID',
                personId3rdPartyDevice : 'PersonID 3rd party Device',
                primaryText    : 'Primary Text',
                secondaryText  : 'Secondary Text',
                joiningDate    : 'Joining Date',
                endDate        : 'End Date',
                workplace      : 'Workplace',
                employmentType : 'Employment Type',
                salary         : 'Salary',
                paymentMethod  : 'Payment Mode',
                bankName       : 'Bank Name',
                accountNumber  : 'Account No',
                routingNumber  : 'Routing No',
            },
            employeesWithNoChangeText      : 'No changes on existing employees',
            NoNewEmployees                 : 'No new employees',
            newEmployee                    : 'New Employee',
            retryButton                    : 'Retry',
            cancelUploadButton             : 'Cancel Upload',
            confirmButton                  : 'Confirm',
            downloadSample                 : 'Download Sample',
            uploadFile                     : 'Upload File',
            chooseFileButton               : 'Choose File',
            noFileChoosen                  : "No File Choosen",
            uploadButton                   : 'Upload',
            batchCreationHistory           : 'Batch Creation History',
            historyTableHeader             : {
                employeeOfficeId : 'Employee ID',
                name             : 'Name',
                email            : 'Email',
                reportPosition   : 'Report Position',
                rfid             : 'RFID',
                personId3rdPartyDevice : 'PersonID 3rd party Device',
                primaryText      : 'Primary Text',
                secondaryText    : 'Secondary Text',
                subsidiaryName   : 'Subsidiary Name',
                status           : 'Status',
                action           : 'Action'

            },
            historyTableStatusColumnValues : {
                pending : 'Pending',
                failed  : 'Failed',
                done    : 'Done'

            },
            noHistory                      : 'No Batch Creation History Found'
        },

        //Employee Actions
        employeeActions : {
            employeeList              : 'Employee List',
            employeeSelectionLabel    : 'Select Employee',
            employeeSelectButton      : 'Select',
            selectAction              : 'Select Actions',
            allocateToAccessArea      : 'Allocate Employee(s) to access area',
            revokeFromAccessArea      : 'Revoke Employee(s) from access area',
            employeeTableHeader       : {
                name        : 'Name',
                company     : 'Company',
                office      : 'Office',
                department  : 'Department',
                shiftGroup  : 'Shift Group',
                designation : 'Designation',
                action      : 'Action'
            },
            removeButton              : 'Remove',
            saveButton                : 'Save',
            noEmployeeSelected        : 'No Employee Selected',
            assignmentSectionTitle    : {
                includeInAttendanceReport:'Include In Attendance Report',
                excludeInAttendanceReport:'Exclude In Attendance Report',
                includeInAttendanceReportBtn:'Include Selected Employee(s) In Attendance Report',
                excludeInAttendanceReportBtn:'Exclude Selected Employee(s) In Attendance Report',
                department           : 'Assign Department',
                subDepartment        : 'Assign Sub Department',
                subsidiary           : 'Assign Subsidiary',
                shiftGroup           : 'Assign To Shift Group',
                designation          : 'Assign Designation',
                leavePolicy          : 'Assign Leave Policy',
                assignToSite         : 'Assign To Site',
                leaveFirstApprover   : 'Assign Leave First Approver',
                leaveSecondApprover  : 'Assign Leave Second Approver',
                lateFirstApprover    : 'Assign Late First Approver',
                lateSecondApprover   : 'Assign Late Second Approver',
                lineManager          : 'Assign Line Manager',
                hrManager            : 'Assign HR Manager',
                allocateToDevice     : 'Allocate To Device',
                revokeFromDevice     : 'Revoke From Device',
                temporaryPermissions : 'Temporary Permissions',
                employeeTransfer     : 'Transfer Employees',
                updateWorkplace      : 'Update Workplace',
                updateEmploymentType : 'Update Employment Type',
                deleteEmployee       : 'Delete Employees',
                overtime             : 'Allow Or Disallow Overtime',
                leaveCarry           : 'Carry Leaves',
                notificationSettings : 'Notification Settings'
            },
            deleteButton              : 'Delete',
            allowButton               : 'Allow',
            disallowButton            : 'Disallow',
            submitButton              : 'Submit',
            syncButton                : 'Sync',
            fromDateLabel             : 'From',
            toDateLabel               : 'To',
            deviceLabel               : 'Device',
            yearLabel                 : 'Year',
            maxNumberLabel            : 'Maximum',
            thirdPartySyncLabel       : 'Sync From Third Party',
            deleteEmployees           : 'Delete Employees',
            selectADepartment         : 'Select a department',
            selectASubDepartment      : 'Select a Sub department',
            selectASubsidiary         : 'Select a Subsidiary',
            selectADesignation        : 'Select a designation',
            selectAShiftGroup         : 'Select a shift group',
            selectALeavePolicy        : 'Select a leave Policy',
            selectASite               : 'Select a Site',
            onAllEmployeesSelected    : 'Working with all employees of this office.',
            deleteModal               : {
                title            : 'Delete Employee?',
                confirmationText : 'Are you sure you want to delete the employees?',
                submitButton     : 'Confirm'
            },
            rehireModal               : {
                title            : 'Rehire Employee?',
                confirmationText : 'Are you sure you want to rehire this employee?',
                submitButton     : 'Confirm'
            },
            thirdPartySyncTableHeader : {
                id     : 'ID',
                name   : 'Name',
                status : 'Status'
            },
            notification              : {
                selectGroup                        : 'Select Notification Group',
                selectRecipients                   : 'Select Recipients',
                sms                                : 'SMS',
                email                              : 'Email',
                pushNotification                   : 'Push Notification',
                recipientSelf                      : 'Employee Himself',
                recipientLineManager               : 'Employee\'s Line Manager',
                recipientHRManager                 : 'Employee\'s HR Manager',
                typeSMS                            : 'SMS',
                typeEmail                          : 'Email',
                typePush                           : 'Push Notification',
                moreSettings                       : 'Configure Notification',
                officeTimeNotifyBeforeStartTime    : 'How many minutes before the shift time',
                whenToCheckAbsent                  : 'When to Check absent',
                whenToCheckAbsent_atStart          : 'At Shift Start Time',
                whenToCheckAbsent_30minBeforeStart : '30 Minutes Before Shift Start Time',
                whenToCheckAbsent_atEnd            : 'At Shift End Time',
                whenToCheckEarlyExit               : 'When to Check Early Exit',
                whenToCheckEarlyExit_atEnd         : 'At Shift End Time',
            }
        },
        //Field Visit
        fieldVisit : {
            buttons                       : {
                allFieldVisits      : 'All Field Visits',
                pendingFieldVisits  : 'Pending Field Visits',
                acceptedFieldVisits : 'Accepted Field Visits',
            },
            noResultFoundText             : 'No field visits found with given filters.',
            employeesTableHeader          : {
                employeeName : 'Employee Name',
                dateRange    : 'Date Range',
                status       : 'Status',
                action       : 'Action'
            },
            applyFieldVisitButton         : 'Apply Field Visit',
            applicationInfoHeader         : 'Field Visit Application Information',
            applicationInfoTable          : {
                dateRange         : 'Date Range',
                reason            : 'Reason',
                entry             : 'Entry',
                exit              : 'Exit',
                location          : 'Location',
                hrManagerStatus   : 'Second Approver Status',
                lineManagerStatus : 'First Approver Status',
                firstApproverStatus : '1st Approver Status',
                firstApproverComment : '1st Approver Comment',
                secondApproverStatus : '2nd Approver Status',
                secondApproverComment : '2nd Approver Comment',
                appliedBy         : 'Applied by',
            },
            applyNewFieldVisitHeadingText : 'Apply new field visit',
            selectEmployee                : 'Select Employee',
            selectDateRange               : 'Select Date Range',
            selectTime                    : 'Select Time',
            area                          : 'Area',
            placeholderTextForArea        : 'Enter Area',
            forceApproveText              : 'Approvals needed from Approvers',
            lastFiveFieldVisitHeading     : 'Last 5 Field Visits',
            approvedByAdmin               : 'Approved By Admin',
        },

        syncExternal : {
            guidelinesTitle : 'Employee Sync Guidelines',
            guidelines      : {
                guideline_1 : 'Please confirm with Inovace Support team that the sync functionality has been activated for your office.',
                guideline_2 : 'Enter the ids in a comma separated line below.',
                guideline_3 : 'Please make sure that none of the Designations and Departments in your system has a duplicate name.',
                guideline_4 : 'Refrain from using spaces after the commas.',
            },
            inputIds        : 'Input Ids',
            placeholderText : 'Enter Ids',
            tableHeader     : {
                id     : 'ID',
                name   : 'name',
                status : 'Status'
            },
            syncButton      : 'Sync',
            syncAllButton   : 'Sync All',
            syncAll24hButton : 'Sync changes of last 24 hours'
        },

        companies : {
            createCompany             : 'Create Company',
            editCompany               : 'Edit Company',
            tooltipText2              : 'Edit',
            tooltipText1              : 'Offices',
            name                      : 'Name',
            officeType                : 'Office Type',
            location                  : 'Location',
            description               : 'Description',
            companyTableHeader        : {
                id      : 'ID',
                actions : 'Actions'
            },
            companyDetailsTableHeader : {
                hash        : '#',
                location    : 'Location',
                description : 'Description',
                actions     : 'Actions'
            },
            officeTypeName            : {
                corporate     : 'Corporate',
                factory       : 'Factory',
                noTypeDefined : 'No Type Defined',
            },
            placeholderText           : 'Enter Name',
            saveChangesButton         : 'Save Changes',

            createOfficeModal : {
                createOffice               : 'Create Office',
                placeholderTextLocation    : 'Enter Location',
                placeholderTextDescription : 'Enter Description',
                createOfficeButton         : 'Create Office',
            },
            selectYourOption  : 'Select your option'

        },

        //Offices
        offices : {
            name                   : 'Name',
            location               : 'Location',
            officeType             : 'Office Type',
            description            : 'Description',
            corporate              : 'Corporate',
            attendanceChardHeading : 'Office Attendance Charts',
            officeCharts           : 'Office Charts',
            officeTableHeader      : {
                hash        : '#',
                officeType  : 'Office Type',
                description : 'Description',
            }
        },


        //Common keywords
        commonKeywords        : {
            dateAndTime                    : 'Date &amp; Time',
            statusActive                   : 'Active',
            statusInactive                 : 'Inactive',
            editTooltipText                : 'Edit',
            deleteTooltipText              : 'Delete',
            yesButton                      : 'Yes',
            noButton                       : 'No',
            okButton                       : 'Ok',
            okayButton                     : 'Okay',
            editButton                     : 'Edit',
            viewButton                     : 'View',
            deleteButton                   : 'Delete',
            deleteAllButton                : 'Delete All',
            removeButton                   : 'Remove',
            filterButton                   : 'Filter',
            submitButton                   : 'Submit',
            uploadButton                   : 'Upload',
            searchButton                   : 'Search',
            closeButton                    : 'Close',
            saveButton                     : 'Save',
            saveSettingButton              : 'Save Setting',
            createSiteButton               : 'Create Site',
            editSiteButton                 : 'Edit Site',
            addNewButton                   : 'Add New',
            createButton                   : 'Create',
            updateButton                   : 'Update',
            approveButton                  : 'Approve',
            rejectButton                   : 'Reject',
            viewErrorButton                : 'View Error',
            turnOffButton                  : 'Turn Off',
            createPackageButton            : 'Create Package',
            editPackageButton              : 'Edit Package',
            addNewMemberButton             : 'Add New Member',
            downloadForwardingLetterButton : 'Download Forwarding Letter',

            confirmButton                         : 'Confirm',
            logInButton                           : 'Log In',
            cancelButton                          : 'Cancel',
            renewalButton                         : 'Renewal',
            upgradePackageButton                  : 'Upgrade Package',
            backButton                            : 'Back',
            confirmEntryButton                    : 'Confirm Entry',
            entryVehicle                          : 'Entry Vehicle',
            exitVehicle                           : 'Exit Vehicle',
            printAndExit                          : 'Print & Exit',
            exitVehicleAndPrintReceipt            : 'Confirm Exit',
            excelButton                           : 'Excel',
            uploadExcelButton                     : 'Upload Excel',
            uploadDocumentButton                  : 'Upload Document',
            exportAsPdfButton                     : 'PDF',
            sortByButton                          : 'Sort By',
            printButton                           : 'Print',
            downloadExcelButton                   : 'Download Excel',
            saveChangesButton                     : 'Save Changes',
            advanceOptionsButton                  : 'Advanced Options',
            sl                                    : 'SL',
            notSet                                : 'Not Set',
            na                                    : 'N/A',
            notset                                : 'Not Set',
            pleaseWait                            : 'Please Wait..',
            searchByNameId                        : 'Search Employee by Name/ID',
            searchVehicle                         : 'Search by Employee Name/ID/Vehicle Number ',
            searchByParking                       : 'Search by Vehicle number/Driver name/Owner name',
            pending                               : 'Pending',
            accepted                              : 'Accepted',
            rejected                              : 'Rejected',
            cancelled                             : 'Cancelled',
            approved                              : 'Approved',
            first                                 : 'First',
            last                                  : 'Last',
            showingPage                           : 'Showing page',
            showing                               : 'Showing',
            outOf                                 : ' out of ',
            pages                                 : 'pages.',
            employeeInformationHeading            : 'Employee Information',
            OwnerInformationHeading               : 'Owner Information',
            memberInformationHeading              : 'Member Information',
            subscriptionInformationHeading        : 'Subscription Information',
            employeeName                          : 'Employee Name',
            ownerName                             : 'Owner Name',
            vehicleNumber                         : 'Vehicle Number',
            companyName                           : 'Company Name',
            employeeNameOrId                      : 'Employee Name/Id',
            employeeId                            : 'Employee ID',
            name                                  : 'Name',
            id                                    : 'ID',
            hash                                  : '#',
            designation                           : 'Designation',
            department                            : 'Department',
            shiftGroup                            : 'Shift Group',
            employmentType                        : 'Employment Type',
            workplace                             : 'Workplace',
            dummyModalText                        : 'Select an entry to see the details',
            dummyModalText2                       : 'Select an employee to see the details',
            from                                  : 'From',
            to                                    : 'To',
            smallTo                               : 'to',
            reason                                : 'Reason',
            placeholderTextForReason              : 'Enter Reason',
            dateRange                             : 'Date Range',
            entry                                 : 'Entry',
            exit                                  : 'Exit',
            location                              : 'Location',
            hrManagerStatus                       : 'HR Manager Status',
            lineManagerStatus                     : 'Line Manager Status',
            appliedBy                             : 'Applied by',
            selectEmployee                        : 'Select Employee',
            startDate                             : 'Start Date',
            endDate                               : 'End Date',
            download                              : 'Download',
            oneDay                                : '1 day',
            halfDay                               : 'Half day',
            submittedFile                         : 'Submitted File',
            noFileSubmitted                       : 'No File Submitted',
            details                               : 'Details',
            previous                              : 'Previous',
            updated                               : 'Updated',
            leaveBalance                          : 'Leave Balance',
            category                              : 'Category',
            total                                 : 'Total',
            used                                  : 'Used',
            remaining                             : 'Remaining',
            lastFiveLeaves                        : 'Last 5 Leaves',
            leaveDate                             : 'Leave Date',
            leaveType                             : 'Leave Type',
            leaveHalf                             : 'Leave Half',
            numberOfDays                          : 'Number of Days',
            questionMark                          : '?',
            adjust                                : 'Adjust',
            cancel                                : 'Cancel',
            firstApproverStatus                   : '1st Approver Status',
            firstApproverComment                   : '1st Approver Comment',
            secondApproverStatus                  : '2nd Approver Status',
            secondApproverComment                  : '2nd Approver Comment',
            full                                  : 'Full',
            half                                  : 'Half',
            uploadFile                            : 'Upload File',
            applyButton                           : 'Apply',
            action                                : 'Action',
            actions                               : 'Actions',
            primaryText                           : 'Primary Text',
            secondaryText                         : 'Secondary Text',
            rfid                                  : 'RFID',
            personId3rdPartyDevice                : 'PersonID 3rd party Device',
            rowsPerPage                           : 'Rows Per Page',
            two                                   : '2',
            five                                  : '5',
            ten                                   : '10',
            twenty                                : '20',
            thirty_one                            : '31',
            fifty                                 : '50',
            hundred                               : '100',
            fiveHundred                           : '500',
            thousand                              : '1000',
            fiftyThousand                         : '50000',
            fiveHundredThousand                   : '500000',
            mismatch                              : 'Mismatch',
            noDataFoundWithGivenFilters           : 'No data found with the given filters',
            filter                                : 'Filter',
            project                               : 'Project',
            task                                  : 'Task',
            punchStatus                           : 'Punch Status',
            geoFencingStatus                      : 'Geo Fencing Status',
            success                               : 'Success',
            office                                : 'Office',
            employment                            : 'Employment',
            type                                  : 'Type',
            early                                 : 'Early',
            expected                              : 'Expected',
            actual                                : 'Actual',
            difference                            : 'Difference',
            average                               : 'Average',
            hours                                 : 'Hours',
            manualEntry                           : 'Manual Entry',
            fieldVisit                            : 'Field Visit',
            holiday                               : 'Holiday',
            specialDay                            : 'Special Day',
            offDay                                : 'Off Day',
            leave                                 : 'Leave',
            fhAbsent                              : 'FH Absent',
            date                                  : 'Date',
            company                               : 'Company',
            shifts                                : 'Shifts',
            departments                           : 'Departments',
            addNewComponentForIndividualEmpButton : 'Add New Component For Individual Employee',
            addAbsenceTypeForIndividualEmpButton  : 'Add Absence Type For Individual Employee',
            downloadComponentUpFileButton         : 'Download Component Upload File',
            downloadAbsenceUpFileButton           : 'Download Absence Upload File',
            downloadBankAdviceLetter              : 'Download Bank Advice Letter',
            selectYear                            : 'Select Year',
            notificationStatus                    : 'Notification Status',
            dataNotFound                          : 'Data Not Found',

            passPoor                              : 'Poor',
            passWeak                              : 'Weak',
            passGood                              : 'Good',
            passStrong                            : 'Strong',
            passStrength                          : 'Password Strength',
            trackingStatus                        : 'Tracking Status',

        },
        commonPlaceholderText : {
            insertName    : 'Insert Name',
            insertInitial : 'Insert Initial',
        },

        //Settings

        // notificationSettings
        notificationSettings : {
            removeFromNotification                  : ' will be removed form the notification group.',
            title                                   : "Notification",
            allEmployee                             : "All Employee",
            notificationGroup                       : "Notification Group",
            notificationGroupName                   : "Notification Group Name",
            setNotification                         : "Set Notification",
            setNotificationForAllEmployee           : "Set Notification For All Employee",
            editButton                              : "Edit",
            selected                                : "Selected",
            and                                     : "and",
            others                                  : "others",
            erased                                  : "erased",
            forThe                                  : "for the",
            selectedEmployees                       : "selected employees",
            forThisNotificationGroup                : "for this notification group.",
            selectNotificationGroup                 : "Select Notification Group",
            notificationConfiguration               : "Notification Configuration",
            nowPressSetNotification                 : "Now press \"Set Notification\"",
            toSelectNotificationForSelectedEmployees : "to select a notification for the selected employee",
            thePreviousNotificationSettings         : "The previous notification settings will be",
            notificationConfigurationHeading        : "Notification Configuration: ",
            errorList                               : "Error List",


        },
        //Designations
        designationSettings : {
            title         : 'Designations',
            createButton  : 'Create Designation',
            loadButton    : 'Load More',
            tableHeader   : {
                name       : 'Name',
                hierarchy  : 'Hierarchy',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Designation',
                nameInputLabel            : 'Name',
                hierarchyInputLabel       : 'Hierarchy',
                nameInputPlaceholder      : 'Insert Name',
                hierarchyInputPlaceHolder : 'Hierarchy'
            },
            editModal     : {
                title            : 'Edit Designation',
                statusInputLabel : 'Status',
                saveButton       : 'Save Changes'
            },
            deleteModal   : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete designation',
                confirmationTextExtension : 'Deleting this  will unset the designation of all the employees that currently have this designation.'
            }
        },

        //Employment Types
        employmentTypeSettings : {
            title         : 'Employment Types',
            createButton  : 'Create Employment Type',
            tableHeader   : {
                name       : 'Name',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                : 'Create Employment Type',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name',
                submitButton         : 'Create'
            },
            editModal     : {
                title        : 'Edit Employment Type',
                submitButton : 'Submit'
            },
            deleteModal   : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete employment type',
                confirmationTextExtension : 'Deleting this  will unset the employment type of all the employees that currently have this employment type.'
            }
        },
        subsidiarySettings : {
            deleteModal :{
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete subsidiary',
                questionMark              : '?'
            }
        },
        //Departments
        departmentSettings : {
            title         : 'Departments',
            createButton  : 'Create Department',
            tableHeader   : {
                name       : 'Name',
                hierarchy  : 'Hierarchy',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Department',
                nameInputLabel            : 'Name',
                hierarchyInputLabel       : 'Hierarchy',
                nameInputPlaceholder      : 'Insert Name',
                hierarchyInputPlaceHolder : 'Hierarchy',
                submitButton              : 'Add Department'
            },
            editModal     : {
                title            : 'Edit Department',
                statusInputLabel : 'Status',
                submitButton     : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete department',
                questionMark     : '?'
            }
        },


        //Sub Departments
        subDepartmentSettings : {
            title         : 'Sub Departments',
            createButton  : 'Create Sub Department',
            tableHeader   : {
                name       : 'Name',
                hierarchy  : 'Hierarchy',
                officeName : 'Office Name',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Sub Department',
                nameInputLabel            : 'Name',
                hierarchyInputLabel       : 'Hierarchy',
                nameInputPlaceholder      : 'Insert Name',
                hierarchyInputPlaceHolder : 'Hierarchy',
                submitButton              : 'Add Sub Department'
            },
            editModal     : {
                title            : 'Edit Sub Department',
                statusInputLabel : 'Status',
                submitButton     : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete sub department',
                questionMark     : '?'
            }
        },

        //Workplaces
        workplaceSettings : {
            title         : 'Workplaces',
            createButton  : 'Create Workplace',
            tableHeader   : {
                dbUid      : 'DB Unique ID',
                name       : 'Name',
                officeName : 'Office Name',
                latitude   : 'Latitude',
                longitude  : 'Longitude',
                status     : 'Status',
                actions    : 'Actions'
            },
            creationModal : {
                title                     : 'Create Workplace',
                nameInputLabel            : 'Name',
                latitudeInputLabel        : 'Latitude',
                longitudeInputLabel       : 'Longitude',
                nameInputPlaceholder      : 'Insert Name',
                latitudeInputPlaceholder  : 'Insert Latitude',
                longitudeInputPlaceholder : 'Insert Longitude'
            },
            editModal     : {
                title        : 'Edit Workplace',
                submitButton : 'Save Changes'
            },
            deleteModal   : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete workplace',
                confirmationTextExtension : 'Deleting this  will unset the workplace of all the employees that currently have this workplace.'
            }
        },

        //Holidays
        holidaySettings : {
            title             : 'Holidays',
            previousButton    : 'Previous',
            todayButton       : 'Today',
            nextButton        : 'Next',
            yearRadioLabel    : 'Year',
            monthRadioLabel   : 'Month',
            weekRadioLabel    : 'Week',
            dayRadioLabel     : 'Day',
            addButton         : 'Add New Holiday',
            tableHeader       : {
                title   : 'Title',
                date    : 'Date',
                actions : 'Actions'
            },
            creationModal     : {
                title            : 'Create Holiday',
                titleInputLabel  : 'Holiday Title',
                dateInputLabel   : 'Date',
                confirmationText : 'Are you sure you want to create the holiday named'
            },
            editSectionHeader : 'Edit Holidays',
            editModal         : {
                title            : 'Update Holiday',
                confirmationText : 'Are you sure you want to edit the holiday named'
            },
            deleteModal       : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete the holiday named'
            }
        },
        //Shift Management
        shiftSettings : {
            title         : 'Shifts',
            createButton  : 'Create Shift',
            tableHeader   : {
                name            : 'Name (Initial)',
                officeName      : 'Office Name',
                startTime       : 'Start Time',
                endTime         : 'End Time',
                lateAfter       : 'Late After',
                earlyExitBefore : 'Early Exit Before',
                firstHalfEndsAt : 'First Half Ends At',
                breakEndsAt     : 'Break Ends At',
                colour          : 'Colour',
                isDefaultShift  : 'Default Shift',
                status          : 'Status',
                actions         : 'Actions'
            },
            creationModal : {
                title                     : 'Create Shift',
                nameInputLabel            : 'Name',
                nameInputPlaceholder      : 'Insert Name',
                initialInputLabel         : 'Initial',
                initialInputPlaceholder   : 'Insert Initial',
                startTimeInputLabel       : 'Start Time',
                endTimeInputLabel         : 'End Time',
                lateAfterInputLabel       : 'Late After',
                earlyExitBeforeInputLabel : 'Early Exit Before',
                firstHalfEndsInputLabel   : 'First Half Ends',
                breakTimeEndsInputLabel   : 'Break Time Ends',
                firstHalfAbsentInputLabel : 'First Half Absent',
                shiftInfoText             : '* By defaults all shifts are associated with',
                shiftColor                : 'RED ',
                colorChangeInfoText       : 'color. To change color click',
                colorChangeInfoLink       : 'here.'
            },
            editModal     : {
                title            : 'Edit Shift',
                colourInputLabel : 'Colour',
                updateButton     : 'Update Shift'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete Shift named'
            }
        },

        //Shift Group Settings
        shiftGroupSettings : {
            title         : 'Shift Groups',
            createButton  : 'Create Shift Group',
            tableHeader   : {
                name         : 'Name',
                officeName   : 'Office Name',
                isDefault    : 'Default',
                offDays      : 'Off Days',
                status       : 'Status',
                actions      : 'Actions',
                activeShifts : 'Active Shifts',
            },
            creationModal : {
                title                : 'Create Shift Group',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name',
                defaultOffDayLabel   : 'Default Off Days',
                shiftsLabel          : 'Shifts',
            },
            editModal     : {
                title        : 'Edit Shift Group',
                submitButton : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete shift group named'
            }
        },

        dynamicShiftGroupSettings : {
            title         : 'Dynamic Shift Groups',
            createButton  : 'Create Dynamic Shift Group',
            tableHeader   : {
                name         : 'Name',
                officeName   : 'Office Name',
                isDefault    : 'Is Default',
                offDays      : 'Off Days',
                status       : 'Status',
                actions      : 'Actions',
                activeShifts : 'Active Shifts',
            },
            creationModal : {
                title                : 'Create Dynamic Shift Group',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name',
                defaultOffDayLabel   : 'Default Off Days',
                selectedShiftsLabel  : 'Selected Shifts'
            },
            editModal     : {
                title        : 'Edit Dynamic Shift Group',
                submitButton : 'Save Changes'
            },
            deleteModal   : {
                title            : 'Confirmation',
                confirmationText : 'Do you want to delete shift group named'
            }
        },
         // Special Day Settings
         specialDaySettings: {
            title: 'Special Days',
            previousButton: 'Previous',
            todayButton: 'Today',
            nextButton: 'Next',
            yearRadioLabel: 'Year',
            monthRadioLabel: 'Month',
            weekRadioLabel: 'Week',
            dayRadioLabel: 'Day',
            addButton: 'Add New Special Day',
            tableHeader: {
                title: 'Title',
                date: 'Date',
                workplaces: 'Branches',
                actions: 'Actions'

            },
            creationModal: {
                title: 'Create Special Day',
                titleInputLabel: 'Special Day Title',
                dateInputLabel: 'Date',
                workplaceInputLabel: 'Workplace',
                confirmationText: 'Are you sure you want to create the special day named'
            },
            editSectionHeader: 'Edit Special Days',
            editModal: {
                title: 'Update Special Day',
                confirmationText: 'Are you sure you want to edit the special day named'
            },
            deleteModal: {
                title: 'Confirmation',
                confirmationText: 'Do you want to delete the special day named'
            }
        },

        //Roster Settings
        rosterSettings : {
            basicViewTabLabel    : 'Basic View',
            advancedViewTabLabel : 'Advanced View',
            waitText             : 'Please wait while the rosters are loading...',
            tableHeader          : {
                shiftGroup          : 'Shift Group',
                currentRunningShift : 'Current Running Shift',
                nextChange          : 'Next Change',
                nextOffday          : 'Next Offday',
                actions             : 'Actions'
            },
            showChangeButton     : 'Show next change',
            showOffdayButton     : 'Show next offday',
            editModal            : {
                title                     : 'Edit Roster',
                warningText               : 'Editing In The Basic View will change from the effective date to the rest of the current year.',
                startAndEndDateInputLabel : 'Start And End Date',
                hrefText                  : 'here',
                shiftSelectLabel          : 'Choose Shift',
                offdaySelectLabel         : 'Choose Off Days',
                submitButton              : 'Save Changes',
                chooseDateRangeText       : 'To choose a date range click',
                effectiveDateInputLabel   : 'Effective Date'
            },
            resetButton          : 'Reset',
            repeatButton         : 'Repeat',
            saveButton           : 'Save Changes',
            repeatModal          : {
                title                 : 'Shift Rotation',
                shiftGroupSelectLabel : 'Choose Shift Group',
                copyLabel             : 'Copy From :: Choose Start Date And End Date',
                pasteLabel            : 'Paste On :: Choose Start Date And End Date',
                submitButton          : 'Paste &amp; Rotate'
            },
            cellShiftChangeModal : {
                title        : 'Choose Shift',
                submitButton : 'Set Shift'
            },
            rosterDownload  : {
                title       : 'Download Roster',
                download    : 'Download'
            }
        },

        //Apply leave
        applyLeave : {
            allLeaves                     : 'All Leaves',
            pendingLeaves                 : 'Pending Leaves',
            approvedLeaves                : 'approved Leaves',
            applyLeaveTableHeader         : {
                employeeName : 'Employee Name',
                category     : 'Category',
                dateRange    : 'Date Range',
                status       : 'Status',
                action       : 'Action',
            },
            noActionAvailable             : 'No Action Available',
            noResultsToBeShown            : 'No Results to be Shown.',
            applyLeaveButton              : 'Apply Leave',
            leavePolicy                   : 'Leave Policy',
            employmentType                : 'Employment Type',
            remainingLeavesHeading        : 'Remaining Leaves Information',
            remainingLeaveTableHeader     : {
                category : 'Category',
                total    : 'Total',
                used     : 'Used'
            },
            leaveApplicationInformation   : 'Leave Application Information',
            leaveApplicationInformationTh : {
                category          : 'Category',
                applicationType   : 'Application Type',
                dateOfApplication : 'Date of Application',
                leaveType         : 'Leave Type',
                leaveHalf         : 'Leave Half',
            },
            selectCategory                : 'Select Category',
            pleaseSelect                  : 'Please Select',
            selectType                    : 'Select Type',
            availableDays                 : 'Available Days',
            selectHalf                    : 'Select Half',
            selectDate                    : 'Select Date',
            range                         : 'Range',
            firstHalf                     : 'First Half',
            secondHalf                    : 'Second Half',
            placeholderTextForReason      : 'Reason',
            lastFiveLeavesHeading         : 'Last 5 Leaves',
            noLeavesFound                 : 'No leaves found',
            medicalLeave                  : 'Medical Leave',
            annualLeave                   : 'Medical Leave',
            casualLeave                   : 'Medical Leave',


        },


        //Leave Category Settings
        leaveCategorySettings : {
            title         : 'Leave Categories',
            createButton  : 'Create Leave Category',
            tableHeader   : {
                name   : 'Name',
                action : 'Action',
                actions : 'Actions'
            },
            creationModal : {
                title                : 'Create Leave Category',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Enter Name',
                submitButton         : 'Submit'
            },
            editModal     : {
                title : 'Edit Leave Category'
            },
            deleteModal   : {
                title            : 'Delete Leave Category',
                confirmationText : 'Do you want to delete the leave category named',
                submitButton     : 'Confirm'
            }
        },

        //Leave Policy Settings
        leavePolicySettings : {
            title           : 'Leave Policies',
            createButton    : 'Create New Leave Policy',
            tableHeader     : {
                name           : 'Name',
                category       : 'Category',
                numberOfLeaves : 'Number of Leaves',
                actions        : 'Actions'
            },
            creationModal   : {
                title                : 'Create Leave Policy',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Enter Name',
                submitButton         : 'Submit'
            },
            deleteModal     : {
                title                     : 'Confirmation',
                confirmationText          : 'Do you want to delete the Leave Policy named',
                confirmationTextExtension : 'Deleting this will unset the leave policy of all the employees that have this leave policy'
            },
            editLeavePolicy : {
                title                : 'Edit Leave Policy',
                nameInputLabel       : 'Name',
                nameInputPlaceholder : 'Insert Name Here',
                updateButton         : 'Update',
                saveButton           : 'Save Changes',
                submitButton         : 'Add Category'
            }
        },
        // Approvals settings
        approvals : {
            title                    : "Approvals",
            approverSystem           : "Approver System",
            singleApprover           : "Single Approver",
            multipleApprover         : "Multiple Approver",
            leaveInfo                : "You can configure Approval Process for leave approvals in the Leave Configuration page"
        },

        //Leave Category-Policy configurations
        leaveCategoryPolicyConfigurations : {
            title            : 'Category-Policy Configurations',
            createButton     : 'Create New Configuration',
            tableHeader      : {
                policy            : 'Policy',
                category          : 'Category',
                numberOfLeaves    : 'Number of Leaves',
                earnedLeaveStatus : 'Earned Leave Status',
                actions           : 'Actions'
            },
            info:{
                maximumAllowedLeaves   : 'Maximum number of leaves per year for this category',
                consecutiveDays        : 'Maximum number of leaves that can be taken in a row.',
                countOfDaysAsLeaves    : 'If leaves are taken before and after a holiday, the holiday will be considered as leave',
                maximumLeavesPerMonth  : 'This defines how many leaves you want to allow per month',
                applicability          : 'For gender specific leave categories. E.g Maternity leave',
                eligibleAfter          : 'Number of days of employment required to avail this leave',
                enableProrata          : 'Joining Date will be considered when allocating leaves. E.g if an employee joins on 1st July, he/she will get only half the amount of leaves per year',
                maxAvailTimes: 'Maximum number of times this leave can be taken by employee',
                enableEarnedLeave: 'Extra leaves will be earned for working on off-day/holiday',
                leavesToFileUpload: 'Maximum Number of consecutive leaves, for which file upload is mandatory.',
                leaveCarryType: 'Select whether leave carry calculation will be based on percentage or fixed amount.',
                maximumLeavesToCarry: 'Maximum number/percentage of leaves to carry forward',
                enablePastDateSelection : 'Select whether a leave can be applied for a past date',
                setPastDateSelectionLimit : 'Specify the number of days after which a previous leave can be applied',
                enableSingleLeaveApprover : 'Allow leaves to be approved by a single approver',
                enableSequentialLeaveApprover : 'Allow leaves to be approved by multiple approvers in sequence',
            },
            create           : {
                title    : 'New Configuration',
                form     : {
                    policyInputLabel                         : 'Select Leave Policy',
                    categoryInputLabel                       : 'Select Leave Category',
                    totalDaysInputLabel                      : 'Maximum Number of Allowed Leaves',
                    consecutiveDaysInputLabel                : 'Consecutive Days',
                    monthlyRestrictionInputLabel             : 'Maximum Number of Leaves Per Month',
                    fileUploadConditionInputLabel            : 'Number of Leaves to Provide File',
                    maxCarryInputLabel                       : 'Maximum Number of Leaves to Carry',
                    countOffdaysInputLabel                   : 'Count Offdays as Leaves',
                    carryTypeInputLabel                      : 'Leave Carry Type',
                    earnedLeaveEnabledInputLabel             : 'Enable Earned Leave',
                    earnedLeaveCriteriaInputLabel            : 'Earned Leave Criteria',
                    maxEarnedLeaveCountInputLabel            : 'Maximum Number of Earned Leave',
                    perDayEarnedLeaveRequiredHoursInputLabel : 'Required Work-hours for Per Day Earned Leave',
                    earnedLeaveCapTypeInputLabel             : 'Earned Leave Calculation Period',
                    earnedLeaveCapAmountInputLabel           : 'Number of Earned Leave Calculation Period Units',
                    expiryTimeWindowInputLabel               : 'Earned Leave Validity Period',
                    createButton                             : 'Create New Configuration',
                    addMoreButton                            : 'Add More Categories',
                    removeButton                             : 'Remove',
                    selectApplicability                      : 'Select Applicability',
                    eligibleAfterJoiningDate                 : 'Eligible After Joining Date',
                    proRataEnabledInputLabel                 : 'Enable Pro Rata',
                    maxAvailTimes                            : 'Max Avail Times',
                    enablePastDateSelectionInputLabel        : 'Enable Previous Date Selection',
                    pastDateSelectionLimitInputLabel        : 'Previous Date Selection Limit',
                    enableSingleLeaveApproverLabel           : 'Enable Single Leave Approver',
                    enableSequentialLeaveApproverLabel       : 'Enable Sequential Leave Approver'

                },
                errorMsg : {
                    policy              : 'Leave policy is required',
                    category            : 'Leave category is required',
                    totalDays           : {
                        required : 'Maximum Number of Allowed Leaves is required',
                        invalid  : 'Invalid number of leaves'
                    },
                    earnedLeaveCriteria : 'You must select a criterion if earned leave is enabled',
                    invalidInput        : 'Invalid input',
                    required : 'Input is required for this field'
                }
            },
            edit             : {
                title    : 'Edit Configuration',
                form     : {
                    policyInputLabel                         : 'Select Leave Policy',
                    categoryInputLabel                       : 'Select Leave Category',
                    totalDaysInputLabel                      : 'Maximum Number of Allowed Leaves',
                    consecutiveDaysInputLabel                : 'Consecutive Days',
                    monthlyRestrictionInputLabel             : 'Maximum Number of Leaves Per Month',
                    fileUploadConditionInputLabel            : 'Number of Leaves to Provide File',
                    maxCarryInputLabel                       : 'Maximum Number of Leaves to Carry',
                    countOffdaysInputLabel                   : 'Count Offdays as Leaves',
                    carryTypeInputLabel                      : 'Leave Carry Type',
                    earnedLeaveEnabledInputLabel             : 'Enable Earned Leave',
                    earnedLeaveCriteriaInputLabel            : 'Earned Leave Criteria',
                    maxEarnedLeaveCountInputLabel            : 'Maximum Number of Earned Leave',
                    perDayEarnedLeaveRequiredHoursInputLabel : 'Required Work-hours for Per Day Earned Leave',
                    earnedLeaveCapTypeInputLabel             : 'Earned Leave Calculation Period',
                    earnedLeaveCapAmountInputLabel           : 'Number of Earned Leave Calculation Period Units',
                    expiryTimeWindowInputLabel               : 'Earned Leave Validity Period',
                    createButton                             : 'Create New Configuration',
                    addMoreButton                            : 'Add More Categories',
                    removeButton                             : 'Remove',
                    saveButton                               : 'Save Changes',
                    enablePastDateSelectionInputLabel        : 'Enable Previous Date Selection',
                    pastDateSelectionLimitInputLabel        : 'Previous Date Selection Limit'
                },
                errorMsg : {
                    policy              : 'Leave policy is required',
                    category            : 'Leave category is required',
                    totalDays           : {
                        required : 'Maximum Number of Allowed Leaves is required',
                        invalid  : 'Invalid number of leaves'
                    },
                    earnedLeaveCriteria : 'You must select a criterion if earned leave is enabled',
                    invalidInput        : 'Invalid input',
                    required            : 'Input is required for this field'
                }
            },
            deleteModal      : {
                title                          : 'Confirmation',
                confirmationText               : 'Do you want to delete the Leave Policy named',
                confirmationTextExtension      : 'Deleting this will unset the leave policy of all the employees that have this leave policy.',
                categoryDeleteConfirmationText : 'Are you sure you want to delete this leave category from this policy'
            },
            selectPolicy     : 'Select Policy',
            selectCategory   : 'Select Category',
            selectCriteria   : 'Select Criteria',
            leavePolicyName  : 'Leave Policy Name:',
            selectApplicability: 'Select Applicability',
            placeholderText0 : '0'
        },

        //Pending Approvals
        pendingApplicationApprovals : {
            leave                       : {
                title            : 'Pending Leave Applications',
                noApplicationMsg : 'Looks like no pending leave requests here!'
            },
            late                        : {
                title            : 'Pending Late Approval Applications',
                noApplicationMsg : 'Looks like no pending late approval requests here!'
            },
            manualEntry                 : {
                title            : 'Pending Manual Entry Applications',
                noApplicationMsg : 'Looks like no pending manual entry approval requests here!'
            },
            timeSheet                   : {
                title            : 'Pending Timesheet Approvals',
                noApplicationMsg : 'Looks like no time sheet approval requests here!',
                approvalModal    : {
                    title : 'Timesheet Confirmation',
                    text  : 'Do you want to approve this time sheet?'
                },
                rejectionModal   : {
                    title : 'Reject Timesheet Confirmation',
                    text  : 'Do you want to reject this application?'
                }
            },
            overtime                    : {
                title                  : 'Pending Overtime Approvals',
                confirmation           : 'Confirmation',
                allowOvertime          : 'Are you sure you want to allow overtime for selected employees?',
                disallowOvertime       : 'Are you sure you want to disallow overtime for selected employees?',
                company                : 'Company',
                office                 : 'Office',
                departments            : 'Departments',
                shifts                 : 'Shifts',
                searchByNameID         : 'Search by name/ID',
                searchButton           : 'Search',
                allowOvertimeButton    : 'Allow Overtime',
                disallowOvertimeButton : 'Disallow Overtime',
                overtimeTableHeader    : {
                    image          : 'Image',
                    name           : 'Name',
                    department     : 'Department',
                    shift          : 'Shift',
                    designation    : 'Designation',
                    overtimeStatus : 'Overtime Status',
                },
                noApplicationMsg : 'Looks like no pending overtime approval here!'
            },
            tableHeader                 : {
                name                      : 'Name',
                category                  : 'Category',
                timeline                  : 'Timeline',
                entryTime                 : 'Entry Time',
                exitTime                  : 'Exit Time',
                numberOfDays              : 'Number of Days',
                days                      : 'Days',
                reason                    : 'Reason',
                type                      : 'Type',
                leaveType                 : 'Leave Type',
                applicationType           : 'Application Type',
                otherApprovalStatus       : 'Other Approval Status',
                file                      : 'File',
                actions                   : 'Actions',
                date                      : 'Date',
                year                      : 'Year',
                month                     : 'Month',
                lineManager               : 'Line Manager',
                lineManagerApprovalStatus : 'Line Manager Approval Status'
            },
            approveButton               : 'Approve',
            rejectButton                : 'Reject',
            viewDetailsButton           : 'View Details',
            approvalModal               : {
                title                   : 'Approval Confirmation',
                modalText               : 'Do you want to accept this application? You can also give a comment.',
                commentInputLabel       : 'Comment',
                commentInputPlaceholder : 'You accepted this application because ...',
                submitButton            : 'Submit &amp; Accept',
                cancelButton            : 'Cancel'
            },
            rejectionModal              : {
                title                   : 'Reject Application Confirmation',
                modalText               : 'Do you want to reject this application? If so, please give a comment -',
                commentInputLabel       : 'Comment',
                commentInputPlaceholder : 'You rejected this application because ...',
                submitButton            : 'Submit &amp; Reject Application',
                cancelButton            : 'Cancel'
            },
            leaveApplicationDetails     : {
                title : 'Pending Leave Application of '
            },
            to                          : 'to',
            numberOfPendingApprovals    : 'Looks like you have',
            pending                     : 'approvals pending',
            applicationDetails          : 'Application Details',
            applicationDetailsTableInfo : {
                applicationType     : 'Application Type',
                leaveCategory       : 'Leave Category',
                applyDate           : 'Apply Date',
                leaveType           : 'Leave Type',
                leaveHalf           : 'Leave Half',
                reasonOfLeave       : 'Reason of Leave',
                otherApprovalStatus : 'Other Approval Status',
                leaveCategory       : 'Leave Category',
                numberOfDays        : 'Number of Days',
                leaveType           : 'Leave Type',
            },
            noPreviousLog               : '--',
            unavailableLeaveBalance     : 'Leave balance is not available, leave policy may not be assigned for this employee',
            noLeaveTaken                : 'Employee hasn\'t taken any leaves this year',
            approveModal                : {
                heading : 'Manual Entry Approval Confirmation',
                text    : 'Do you want to approve this application?'
            },
            rejectModal                 : {
                heading : 'Reject Manual Entry Application Confirmation',
                text    : 'Do you want to reject this application?'
            }


        },

        //Devices
        //List
        devices        : {
            revokeButton                          : 'Revoke',
            allocateButton                        : 'Allocate',
            allocatedButton                       : "Allocated",
            unallocatedButton                     : "Unallocated",
            temporaryAllocationButton             : "Temporary Allocation",
            temporary                             : 'Temporary',
            active                                : 'Active',
            inactive                              : 'Inactive',
            upcoming                              : 'Upcoming',
            allocationStartDate                   : 'Allocation Start Date',
            allocationEndDate                     : 'Allocation End Date',
            temporaryAllocationInformationHeading : 'Temporary Allocation Information',
        },
        deviceListPage : {
            title          : 'Devices',
            allocateButton : 'Allocate All To All Devices',
            statusNotAvailable : 'N/A',
            statusConnected : 'Connected',
            statusDisconnected : 'Disconnected',
            filters        : {
                phoneNumber                 : 'Phone Number',
                phoneNumberInputPlaceholder : 'Device Phone number ...',
                identifier                  : 'Identifier',
                identifierInputPlaceholder  : 'Device identifier ...',
                location                    : 'Location',
                locationInputPlaceholder    : 'Device location ...',
                offices                     : 'Offices',
                loadDevice                  : 'Load Device',
                submitButton                : 'Search Devices',
                notFoundText                : 'No devices could be found with filters',
            },
            tableHeader    : {
                identifier  : 'Identifier',
                phoneNumber : 'Phone Number',
                description : 'Description',
                location    : 'Location',
                workplace   : 'Workplace',
                type        : 'Type',
                lastUpdated : 'Last Updated',
                action      : 'Action',
                connectionStatus: 'Connection Status',
                connectedAt : 'Connected At',
                lastCommunication: 'Last Communication'
            },
            editModal      : {
                title                 : 'Edit Device Information',
                identifierLabel       : 'Device Identifier',
                phoneNumberLabel      : 'Phone Number',
                descriptionInputLabel : 'Description',
                locationInputLabel    : 'Location',
                workplaceInputLabel   : 'Workplace',
                submitButton          : 'Update',
                workplaceLabel        : 'Workplace',
                workplacePlaceholder  : 'Select a workplace…',
                noWorkplaceSelected   : 'No workplace selected',
                changeWorkplace       : 'Change Workplace',
            },
            editModalTitle : 'Do you want to allocate everyone to all devices?'
        },

        //Allocation History
        deviceAllocationHistory : {
            title         : 'Allocation History',
            filters       : {
                search                 : 'Search',
                searchInputPlaceholder : 'Employee or Device ...'
            },
            tableHeader   : {
                image    : 'Image',
                name     : 'Name',
                device   : 'Device',
                location : 'Location',
                action   : 'Action',
                date     : 'Date',
                status   : 'Status'
            },
            statusDone    : 'Done',
            statusPending : 'Pending',
            statusFailed  : 'Failed'
        },

        //Overtime Menu
        //Monthly Summary
        overtimeSummary : {
            title        : 'Monthly Summary',
            tableHeader  : {
                image         : 'Image',
                name          : 'Name',
                department    : 'Department',
                designation   : 'Designation',
                type          : 'Employment Type',
                totalOvertime : 'Total Overtime',
                totalApproved : 'Total Approved'
            },
            notFoundText : 'Sorry no overtime data found within given limit'
        },

        //Overtime Report
        overtimeDetailedReport : {
            title         : 'Detailed Report',
            tableHeader   : {
                image       : 'Image',
                name        : 'Name',
                department  : 'Department',
                designation : 'Designation',
                shiftGroup  : 'Shift Group',
                total       : 'Total OT Hours',
                approved    : 'Approved OT Hours'
            },
            notFoundText  : 'Sorry no overtime data found within given limit',
            approvalModal : {
                title                    : 'Approve Overtime',
                overtimeInputLabel       : 'Overtime',
                overtimeInputPlaceholder : 'Insert in hour:minutes format',
                submitButton             : 'Create'
            }
        },

        //SMS
        sendSms : {
            title               : 'SMS',
            employeeSelectLabel : 'Select Employee',
            sendButton          : 'Send',
            smsInputLabel       : 'Write SMS Here',
            confirmationModal   : {
                title            : 'Send SMS',
                confirmationText : 'Are you sure you want to send sms to these employees?'
            }
        },

        //Profile Leave
        profileLeave : {
            remainingLeavesInYear           : 'Remaining Leaves in Year ',
            remainingLeaves                 : 'Remaining Leaves',
            noLeavePolicyOrApproverAssigned : 'No leave policy or Leave Approver is assigned to employee',
            remainingLeave                  : 'Remaining Leaves',
            noApplicationsFound             : 'No Applications found for selected year'
        },
        //Profile Enrol
        profileEnrol : {
            selectAHand            : 'Select a Hand',
            selectAFinger          : 'Select a Finger',
            thumb                  : 'Thumb',
            index                  : 'Index',
            middle                 : 'Middle',
            ring                   : 'Ring',
            pinky                  : 'Pinky',
            chooseAFileFromServer  : 'Choose a file from server',
            noEnrolmentRecordFound : 'No enrolment record found for this employee.',
            enrolFromDevice        : 'Enrol From Device',
            enrolmentRunningTo     : 'Enrolment Running up to ',
            enrolmentNotRunning    : 'Enrolment Not Running',
            refreshEnrolments      : 'Refresh Enrolments',
            deleteConfirmation     : 'Are you sure you want to delete the enrolment of the selected fingers?',
        },
        profileAccessAreaPermission : {
            allocateUserToAccessArea   : "Allocate User To Access Area",
            revokeUserFromAccessArea   : "Revoke User From Access Area",
            selectArea                 : "Select Access Area",

        },
        //Profile Device Permissions
        profileDevicePermissions : {
            allocatedDevicesOf   : "Allocated Devices of ",
            allocateUserToDevice : 'Allocate User to Device',
            revokeUserFromDevice : 'Revoke User from Device',
            notAllocatedInDevice : 'Not allocated in any devices.',
            temporaryPermissions : 'Temporary Permissions',
        },
        profilePayroll           : {
            paymentDetails    : "Payment Details ",
            paymentMode       : "Payment Mode",
            selectPaymentMode : "Select Payment Mode",
            grossSalary       : "Gross Salary",
            bankPayment       : "Bank Payment",
            cashPayment       : "Cash Payment",
            bankName          : "Bank Name",
            selectBankName    : "Select Bank Name",
            routingNumber        : "Routing No",
            selectRoutingNo   : "Select Routing No",
            accountNumber     : "Account Number",
            salaryDetails     : "Salary Details",
            salaryComponents  : "Salary Components",
            amount            : "Amount",
            // allocateUserToDevice : 'Allocate User to Device',
            // revokeUserFromDevice : 'Revoke User from Device',
            // notAllocatedInDevice : 'Not allocated in any devices.',
            // temporaryPermissions : 'Temporary Permissions'
        },
        //Profile Roster
        profileRoster           : {
            timingDetailsOf : 'Time details of '
        },
        profilePendingApprovals : {
            pendingLeaveRequests          : 'Pending Leave Requests',
            noLeaveRequests               : 'Looks like no pending leave requests here!',
            pendingLateApprovalRequests   : 'Pending Late Approval Applications',
            noLateRequests                : 'Looks like no pending late approval requests here!',
            pendingManualEntryRequests    : 'Pending Manual Entry Applications',
            noManualEntryRequests         : 'Looks like no pending manual entry approval requests here!',
            cancelLateLog                 : 'Cancel Late Approval',
            cancelLateLogConfirmation     : 'Cancel this late approval application?',
            cancelLeave                   : 'Cancel Leave',
            cancelLeaveConfirmation       : 'Are you sure you want to cancel this leave application?',
            editLeaveApplication          : 'Edit Leave Application',
            cancelManualEntry             : 'Cancel Manual Entry',
            cancelFieldVisit              : 'Cancel Field Visit',
            cancelManualEntryConfirmation : 'Do want to cancel this manual entry application?',
            cancelFieldVisitConfirmation  : 'Are you sure you want to cancel this field visit application?'
        },

        //Project management
        projects : {
            title         : 'Project List',
            tableHeader   : {
                name        : 'Name',
                startTime   : 'Start',
                deadline    : 'Deadline',
                description : 'Description',
                status      : 'Status',
                actions     : 'Actions',
                referenceCode : 'Reference Code',
                projectName : 'Project Name',
                product : 'Product',
                kam : 'K.A.M.',
                clientName : 'Client Name',
                projectType : 'Project Type',
                startDate : 'Start Date',
                dueDate : 'Due Date',
                endDate : 'End Date',
                noOfIssues : 'No. of Issues'
            },
            emptyTableBody : "No records found",
            filter : {
                projectTypes : 'Project Types',
                products : 'Products',
                clients : 'Clients',
                kams : 'K.A.M.s',
                searchInputPlaceholder : "Search Project by Reference/Name",
            },
            createButton  : 'Create New Project',
            searchButton : 'Search',
            create : {
                panelTitle : 'Create New Project',
                projectNameInputLabel : "Project Name",
                projectTypeInputLabel : "Type",
                clientInputLabel : "Client",
                productInputLabel : "Product",
                referenceCodeInputLabel : "Reference Code",
                startDateInputLabel : "Start Date",
                dueDateInputLabel : "Due Date",
                kamInputLabel : "K.A.M.",
                organisationTypeInputLabel : "Organisation Type",
                createProjectButtonLabel : "Create Project",
            },
            edit : {
                panelTitle : 'Edit Project'
            },
            creationModal : {
                title                       : 'Create Project',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                submitButton                : 'Add Project',
                addPeople                   : 'Add People',
                addTeam                     : 'Add Team',
            },
            editModal     : {
                title                       : 'Edit Project',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                statusInputLabel            : 'Status',
                submitButton                : 'Save Changes',
                addButton                   : 'Add',
                peopleInTheProjectHeading   : 'People in the project',
                picture                     : 'Picture',
                name                        : 'Name',
                action                      : 'Action'
            },
            deleteModal   : {
                title               : 'Confirmation',
                confirmationText    : 'Are you sure you want to delete?',
                confirmationText2   : 'Are you sure you want to delete project',
                deleteProjectHeader : 'Delete Project',

            },
            product     :  {
                productSegment: 'Product Segment',
                deleteProductodalStatement: 'Do you want to delete this product',
                segment: 'Segment',
                productOwner: 'Owner',
                title: 'Product List',
                createProduct : 'Create New Product',
                editProduct : 'Save Changes',
                createNewProduct : 'Create Product',
                editPanelTitle : 'Edit Product',
                table : {
                    productName : 'Product Name',
                    segment     : 'Segment',
                    description : 'Description',
                    owner : 'Owner',
                    action : 'Action',
                    edit:'Edit',
                    delete:'Delete',
                    emptyBody : "No records found",
                },
            },
            issues     :  {
                issueDate       : 'Issue Date',
                projectName     : 'Project Name',
                productName     : 'Product Name',
                submittedBy     : 'Submitted By',
                allocateTo      : 'Allocate To',
                status          : 'Status',
                priority        : 'Priority',
                title           : 'Issue List',
                createButton    : 'Add New Issue',
                issueDetails    : 'Issue Details',
                searchInputPlaceholder : 'Search issue by ticket no./project name',
                table : {
                    date        : 'Issue Date & Time',
                    projectName : 'Project Name',
                    productName : 'Product Name',
                    submittedBy : 'Submitted By',
                    ticketNo    : 'Ticket No',
                    allocateTo  : 'Allocate To',
                    status      : 'Status',
                    dateAndTime : 'Last Modified',
                    priority    : 'Priority',
                    action      : 'Action',
                    edit        : 'Edit',
                    view        : 'View',
                    emptyTableBody : "No records found"
                },
                lowPriority : "Low",
                mediumPriority : "Medium",
                highPriority : "High"
            },
            issue     : {
                productName     : 'Product Name',
                projectName     : 'Project Name',
                projectRefNo    : 'Project Reference No',
                projectNamePlaceholder : 'Select Project Name',
                dateAndTime     : 'Date & Time',
                issueDateAndTime: 'Issue Date & Time',
                entryDateAndTime: 'Entry Date & Time',
                ticketNo        : 'Ticket No',
                priority        : 'Priority',
                priorityPlaceholder : 'Select Priority',
                status          : 'Status',
                statusPlaceholder : 'Select status',
                supportDoc      : 'Support Document',
                allocateTo      : 'Allocate To',
                submittedBy     : 'Submitted By',
                description     : 'Description',
                uploadSupDoc    : 'Upload Support Document',
                addNewIssue     : 'Add New Issue',
                editIssue       : 'Edit Issue',
                cancelButton    : 'Cancel',
                addIssueButton  : 'Add Issue',
                updateIssueButton  : 'Update Issue',
                pleaseSelectPlaceholder : 'Please select',
                logInfo: {
                    title           : 'Log Information',
                    updateLogButton : 'Update Log',
                    startDate       : 'Start Date & Time',
                    allocateTo      : 'Allocate To',
                    transferTo      : 'Transfer To',
                    transferToPlaceholder : 'Select whom to transfer',
                    status          : 'Status',
                    statusPlaceholder : 'Select status',
                    endDate         : 'End Date & Time',
                    remarks         : 'Remarks',
                    remarksPlaceholder : 'Write remarks',
                    issueLogUpdateTitle: 'Issue Log Update',
                    cancelButton    : 'Cancel',
                    updateButton    : 'Update',
                    timestamp : "Timestamp",
                    action : "Action",
                    noLogsFound : "No Logs Found"
                }
            },
            issueCreators : {
                title : "Issue Creator List",
                searchInputPlaceholder : "Search Creator by Name/ID",
                table : {
                    creator : "Creator Name",
                    action : "Action",
                    emptyTableBody : "Nobody is assigned as issue creator"
                },
                createModal : {
                    title : "Assign New Issue Creator",
                    employeeInputLabel : "Select Employee"
                },
                createButton : "Assign Issue Creator"
            }
        },

        tasks : {
            title          : 'Tasks',
            date           : 'Date',
            employees      : 'Employees',
            tableHeader    : {
                name        : 'Name',
                description : 'Description',
                status      : 'Status',
                actions     : 'Actions',
                project     : 'Project',
                startTime   : 'Start',
                deadline    : 'Deadline'
            },
            statusComplete : 'Done',
            statusTodo     : 'Todo',
            statusInactive : 'Inactive',
            createButton   : 'Create Task',
            creationModal  : {
                title                       : 'Create Task',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                submitButton                : 'Add Task',
                startTimeInputLabel         : 'Start Time'
            },
            editModal      : {
                title                       : 'Edit Task',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                statusInputLabel            : 'Status',
                submitButton                : 'Save Changes',
                addPeopleHeading            : 'People in the task'
            },
            deleteModal    : {
                title             : 'Confirmation',
                deleteTaskTitle   : 'Delete Task',
                confirmationText  : 'Are you sure you want to delete?',
                confirmationText2 : 'Are you sure you want to delete task'
            }
        },

        teams           : {
            title         : 'Teams',
            tableHeader   : {
                name        : 'Name',
                description : 'Description',
                status      : 'Status',
                actions     : 'Actions'
            },
            createButton  : 'Create Team',
            creationModal : {
                title                       : 'Create Team',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                submitButton                : 'Add Team'
            },
            editModal     : {
                title                       : 'Edit Team',
                nameInputLabel              : 'Name',
                descriptionInputLabel       : 'Description',
                nameInputPlaceholder        : 'Insert Name Here',
                descriptionInputPlaceHolder : 'Description',
                statusInputLabel            : 'Status',
                submitButton                : 'Save Changes',
                peopleInTheTeamHeading      : 'People in the team',
            },
            deleteModal   : {
                title             : 'Confirmation',
                deleteTeamHeading : 'Delete Team',
                confirmationText  : 'Are you sure you want to delete?',
                confirmationText2 : 'Do you want to delete team'
            }
        },
        timeSheetReport : {
            project           : 'Project',
            task              : 'Task',
            team              : 'Team',
            employee          : 'Employee',
            date              : 'Date',
            start             : 'Start',
            end               : 'End',
            totalTime         : 'Total Time',
            description       : 'Description',
            picture           : 'Picture',
            totalWorkHour     : 'Total Work Hour',
            year              : 'Year',
            month             : 'Month',
            projectDedication : 'Project Dedication',
            hoursSpent        : 'Hours Spent',
            name              : 'Name',
            status            : 'Status',
            addTaskButton     : 'Add task',
            tasks             : 'Tasks',
            people            : 'People',
            peopleInHeading   : 'People in',

        },
        projectClients : {
            panelTitle : "Client List",
            table : {
                headers : {
                    serial : "SL",
                    clientName : "Client Name",
                    contactPerson : "Contact Person",
                    contactNumber : "Contact Number",
                    contactEmail : "Contact Email",
                    type : "Type",
                    kam : "K.A.M.",
                    action : "Action"
                },
                emptyBody : "No records found",
            },
            createButton : "Create New Client",
            editButton : "Edit",
            deleteButton : "Delete",
            sortButton : "Sort By",
            searchButton : "Search",
            filterButton : "Filter",
            filter : {
                searchInputPlaceholder : "Search Clients by Name/Email/Contact Number",
                searchInputLabel : "Search Clients",
                organisationTypes : "Organisation Types",
                kams : "K.A.M.s"
            },
            create : {
                panelTitle : "Create New Client",
                clientNameInputLabel : "Client Name",
                contactNameInputLabel : "Contact Person Name",
                contactDesignationInputLabel : "Contact Person Designation",
                contactNumberInputLabel : "Contact Number",
                contactEmailInputLabel : "Contact Email",
                kamInputLabel : "K.A.M.",
                organisationTypeInputLabel : "Organisation Type",
                createClientButtonLabel : "Create Client",
            },
            edit : {
                panelTitle : "Edit Client"
            },
            delete : {
                modalTitle : "Confirmation",
                modalBodyText : "Are you sure you want to delete"
            }
        },
        //Profile
        profile                 : {
            date                              : 'Date',
            deletedAt                         : 'Deleted at:',
            deletedBy                         : 'Deleted by:',
            noAttendanceLogsFound             : 'No Attendance logs found for employee',
            downloadAllButton                 : 'Download All',
            manualEntry                       : 'Manual Entry',
            selectType                        : 'Select Type',
            missingPunch                      : 'Missing Punch',
            fieldVisit                        : 'Field Visit',
            reason                            : 'Reason',
            placeholderForReason              : 'Enter Reason',
            entryTime                         : 'Entry Time',
            exitTime                          : 'Exit Time',
            selectADevice                     : 'Select Device(s)',
            selectDevice                      : 'Select Device',
            time                              : 'Time',
            hours                             : 'Hours',
            selectDateRange                   : 'Select Date Range',
            selectTime                        : 'Select Time',
            area                              : 'Area',
            hrManager                         : 'HR Manager',
            lineManager                       : 'Line Manager',
            entry                             : 'Entry',
            exit                              : 'Exit',
            status                            : 'Status',
            attendanceTableHeading            : 'Attendance Table',
            holiday                           : 'Holiday',
            holidays                          : 'Holidays',
            specialDay                        : 'Special Day',
            specialDays                       : 'Special Days',
            offDay                            : 'Off Day',
            offDays                           : 'Off Days',
            leave                             : 'Leave',
            absent                            : 'Absent',
            present                           : 'Present',
            late                              : 'Late',
            approvedLates                     : 'Approved Lates',
            earlyExit                         : 'Early Exit',
            lateEntriesHeading                : 'Late Entries',
            noComment                         : 'No Comment',
            dashDash                          : '--',
            notApplied                        : 'Not Applied',
            summaryHeading                    : 'Summary',
            expectedHours                     : 'Expected Hours',
            actualHours                       : 'Actual Hours',
            identifier                        : 'Identifier',
            phoneNumber                       : 'Phone Number',
            RFIDStatus                        : 'RFID Status',
            FingerprintStatus                 : 'Fingerprint Status',
            FaceStatus                        : 'Face Status',
            description                       : 'Description',
            location                          : 'Location',
            type                              : 'Type',
            deviceId                          : 'Device ID',
            startDate                         : 'Start Date',
            endDate                           : 'End Date',
            allocateButton                    : 'Allocate',
            revokeButton                      : 'Revoke',
            enrolEmployee                     : 'Enrol Employee',
            startButton                       : 'Start',
            stopButton                        : 'Stop',
            enrolFingerButton                 : 'Enrol Finger',
            leftHand                          : 'Left Hand',
            rightHand                         : 'Right Hand',
            ApplyForLeaveButton               : 'Apply For Leave',
            leaveDetailsOf                    : 'Leave Details Of',
            leaveBalanceHeading               : 'Leave Balance',
            applicationType                   : 'Application Type',
            leaveAdjustApplicationInfoHeading : 'Leave Application Information: Adjust',
            leaveApplicationInfoHeading       : 'Leave Application Information:',
            applyDate                         : 'Apply Date',
            leaveAdjustment                   : 'Leave Adjustment',
            leaveCancellation                 : 'Leave Cancellation',
            half                              : 'Half',
            full                              : 'Full',
            leaveReason                       : 'Leave Reason',
            uploadAFile                       : 'Upload A File',
            noFileSubmitted                   : 'No file submitted',
            areYouSureHeading                 : 'Are you sure?',
            notificationOrMessageSentHeading  : 'A notification/email will be sent to your approvers regarding the change.',
            pleaseWaitText                    : 'Please Wait',
            yourApplicationBeingProcessed     : 'Your application is being processed.',
            details                           : 'Details',
            submittedInformation              : 'Submitted Information',
            reasonOfCancellation              : 'Reason Of Cancellation',
            reasonOfCancellationPlaceholder   : 'Please write the reason',
            applyForLeaveHeading              : 'Apply for Leave',
            availableDays                     : 'Available Days',
            overtimeReportOf                  : 'Overtime Report of',
            overtime                          : 'Overtime',
            total                             : 'Total',
            actions                           : 'Actions',
            placeholderForAddress             : 'Address',
            placeholderForType                : 'Type',
            placeholderForThana               : 'Thana',
            placeholderForDistrict            : 'District',
            placeholderForRemark              : 'Remark',
            confirmation                      : 'Confirmation',
            currently                         : 'Currently',
            isCurrently                       : 'is currently',
            is                                : 'Is',
            isNot                             : 'Is Not',
            can                               : 'Can',
            canNot                            : 'Can Not',
            areYouSureYouWantTo               : 'Are you sure you want to',
            revokeThisPrivilegeFrom           : 'revoke this privilege from',
            allowThisPrivilegeTo              : 'allow this privilege to',
            revokingRoleHeadingPart1          : 'Revoking this role will unset all employees\'',
            revokingRoleHeadingPart2          : 'who have this employee as',
            project                           : 'Project',
            deleteAddress                     : 'Delete Address',
            deleteAddressAcknowledgement      : 'Do you want to delete this address?',
            deleteDocumentAcknowledgement     : 'Do you want to delete this document?',
            includedInAttendanceReport        : 'included in attendance report.',
            notIncludedInAttendanceReport     : 'not included in attendance reports.',
            exclude                           : 'exclude',
            include                           : 'include',
            updateStatus                      : 'Update Status',
            disallowOvertime                  : ' disallow Overtime',
            allowOvertime                     : ' allow Overtime',
            isCompanyAdmin                    : 'Is Company Admin',
            notCompanyAdmin                   : 'Not Company Admin',
            revokeCompanyAdminPrivilege       : 'revoke company admin privilege',
            allowCompanyAdminPrivilege        : 'allow company admin privilege',
            of                                : 'of',
            timesheetEntry                    : 'Timesheet Entry',
            startTime                         : 'Start Time',
            endTime                           : 'End Time',
            changeProfilePicture              : 'Change Profile Picture',
            documents                         : 'Documents',
            approverInfoHeading               : 'Approver Information',
            changePassword                    : 'Change Password',
            generalInfoHeading                : 'General Information',
            contactInfoHeading                : 'Personal & Contact Information',
            profilePicRemoveHeading           : 'Do you want to remove profile picture?',
            uploadProfilePicHeading           : 'Upload Profile Picture',
            selectImage                       : 'Select Image',
            updateProjectDedicationHeading    : 'Update Project Dedication',
            dedicationPercentage              : 'Dedication Percentage',
            projectDedication                 : 'Project Dedication',
            notificationSettings              : 'Notification Settings',
            taskDedication                    : 'Task Dedication',
            setPercentageButton               : 'Set Percentage',
            totalDedication                   : 'Total Dedication',
            timeSpent                         : 'Time Spent',
            totalTime                         : 'Total Time',
            upgradeForUnlockFeaturesHeading   : 'upgrade For Unlock Features',
            features                          : 'Features',
            basic                             : 'Basic',
            intermediate                      : 'Intermediate',
            advanced                          : 'Advanced',
            maybeLaterButton                  : 'Maybe Later',
            upgradeNowButton                  : 'Upgrade Now',
            pleaseSelect                      : 'Please Select',
            addTask                           : 'Add Task',
            firstApproverStatus               : 'First Approver Status',
            secondApproverStatus              : 'Second Approver Status',

        },
        loginPage               : {},
        payrollSettings         : {
            dontHavePayrollSettingsHeading : 'You do not have any payroll settings. Please create one.',
            createPayrollSettingsButton    : 'Create Payroll Settings',
            selectPayrollType              : 'Select Payroll Type',
            componentCode                  : 'Component Code',
            componentName                  : 'Component Name',
            componentType                  : 'Component Type',
            componentCategory              : 'Component Category',
            valueType                      : 'Value Type',
            percentageOf                   : '% of',
            value                          : 'Value',
            status                         : 'Status',
            action                         : 'Action',
            addNewComponentButton          : 'Add New Component',
            saveSettingsButton             : 'Save Settings',
            updateSettingsButton           : 'Update Settings',
            editSettingsButton             : 'Edit Settings',
            payrollTypeHeading             : 'Payroll Type',
            addition                       : 'Addition',
            deduction                      : 'Deduction',
            percentage                     : '%',
            fixed                          : 'Fixed',
            variable                       : 'Variable',
            active                         : 'Active',
            inactive                       : 'Inactive',
            amount                         : 'Amount',
            days                           : "Days(s)",
            absenceType                    : 'Absence Type',
            basicPay                       : 'Basic Pay',
            allowance                      : 'Allowance',
            longTermBenefit                : 'Long Term Benefit',
            nonCashBenefit                 : 'Non Cash Benefit',
            additional                     : 'Additional',
            bonus                          : 'Bonus',
            arrears                        : 'Arrears',
            lwpDeduction                   : 'LWP Deduction',
            absentDeduction                : 'Absent Deduction',
            incomeTaxDeduction             : 'Income Tax Deduction',
            loanDeduction                  : 'Loan Deduction',

        },
        salaryComponentSettings : {
            componentPolicySettings          : 'Component Policy Settings',
            componentGroup                   : 'Component Group',
            parentComponent                  : 'Parent Component',
            calculationPercentage            : 'Calculation Percentage',
            calculationFixedAmount           : 'Fixed Amount',
            calculationVariable              : 'Variable',
            festivalBonus                    : 'Festival Bonus',
            bonusEligibility                 : 'Bonus Eligibility',
            bonusProratePeriod               : 'Bonus Prorate Period(Days)',
            bonusCalculationBasis            : 'Bonus Calculation Basis',
            percentageCalculation            : 'Percentage Calculation',
            bonusCalculationCutoffDate       : 'Bonus Calculation Cutoff Date',
            considerInGrossSalaryCalculation : 'Consider in Gross Salary Calculation',
            confirmationBenefit              : 'Confirmation Benefit',
            noOfTimeInstallment              : 'No of Time/Installment',
            componentDistribution            : 'Component Distribution',
            componentInformationHeading      : 'Component Information',
            componentsToBeDistributed        : 'Components to be distributed',
            noOfDays                         : 'No of days',
            successMessage                   : 'Salary Component Settings saved Successfully.'

        },
        monthlySalaryProcess    : {
            individualAdditionalSalaryComponentHeading : 'Individual Additional Salary Component Input',
            AbsenceTypeSalaryComponentHeading : 'Absence Type input for individual employee',
            searchEmployee                             : 'Search Employee',
            absenceType                                : 'Absence Type',
            deleteAdditionalComponent                  : 'Do you want to delete this Additional Component?',
            deleteAbsentLwpComponent                   : 'Do you want to delete this Absent/Leave Component?',
        },
        bankPaymentAdvice       : {
            salaryMonth        : 'Salary month',
            notApprovedText    : 'Salary for sep 2021 is not Approved yet.',
            viewPreviousButton : 'View History From Last Month - '
        },

        payrollManagement    : {
            allEmployee               : 'All Employee',
            payrollActive             : 'Payroll Active',
            payrollInactive           : 'Payroll Inactive',
            grossSalary               : 'Gross Salary',
            netPayable                : 'Net Payable',
            setUpNow                  : 'Set Up Now',
            downloadPayrollUploadFile : 'Download Payroll Upload File',
            uploadPayrollInformation  : 'Upload Payroll Information',
            editInformation           : 'Edit Information',
            payrollInformation        : 'Payroll Information',
            amount                    : 'Amount',
            value                     : 'Value',
            percentageSign            : '%',
            fixed                     : 'Fixed',
            bankInformation           : 'Bank Information',
            paymentMode               : 'Payment Mode',
            bankName                  : 'Bank Name',
            routingNumber             : 'Routing Number',
            accountNumber             : 'Account Number',
            payrollInfoIsNotSetUp     : 'Employee payroll information is not set up',
            saveSetUp                 : 'Save Set Up',
            basicSalary               : 'Basic Salary',
            houseRentAllowance        : 'House Rent Allowance',
            conveyanceAllowance       : 'Conveyance Allowance',
            medicalAllowance          : 'Medical Allowance',
            dummyAmount               : '18000',
            noEmployeeInTheSystem     : 'You do not have any employees yet in this HRM system',
            textLine1                 : 'You can create employees and set up their payroll easily by uploading an excel file using our',
            textLine2                 : 'format given bellow. Please download the sample excel file to begin with.',
            buttonText1               : 'Upload employee information+payroll from excel',
            buttonText2               : 'Download sample excel file',
            dateOfJoining             : 'Date of Joining',
        },
        viewOrGenerateSalary : {
            salaryMonth           : 'Salary Month',
            salaryState           : 'Salary State',
            inProcess             : 'In Process',
            approved              : 'Approved',
            paid                  : 'Paid',
            employeeId            : 'Employee ID',
            employeeName          : 'Employee Name',
            dateAndTime           : 'Date & Time',
            totalEmployee         : 'Total Employee',
            totalNetPayable       : 'Total Net Payable',
            processedSalary       : 'Processed Salary',
            unprocessedSalary     : 'Unprocessed Salary',
            rollbackButton        : 'Rollback',
            approveButton         : 'Approve',
            paySalaryButton       : 'Pay Salary',
            salaryLogButton       : 'Salary Log',
            sendForApprovalButton : 'Send for Approval',
            undoSalaryButton      : 'Undo Salary',
            processSalaryButton   : 'Process Salary',
            downloadExcelButton   : 'Download Excel',
            salaryDetails         : 'Salary Details',
            action                : 'Action',
            remarks               : 'Remarks',
            edited                : 'Edited',
            editButton            : 'Edit',
            processButton         : 'Process',
            salaryComponent       : 'Salary Component',
            amount                : 'Amount',
            monthlyGrossSalary    : 'Monthly Gross Salary',
            totalSalary           : 'Total Salary',
            totalDeduction        : 'Total Deduction',
            calculatedAmount      : 'Calculated Amount',
            updatedAmount         : 'Updated Amount',
            generateSalary        : 'Generate Salary',
            viewSalaryReport      : 'View Salary Report',
            salaryGenerationText  : 'Salaries for the given month are generating, and it\'ll take a while. You\'ll get notified once the process has finished.',
            modalTitle            : 'Are you sure?',
            salaryNotSetup        : 'Salary Not Setup',

            amountComparisonModal         : {
                bodyHeading : 'Do you want to proceed without saving the changes?'
            },
            approveSalaryModal            : {
                bodyHeading : 'Do you want to approve this salary?',
            },
            paySalaryModal                : {
                bodyHeading : 'Do you want to pay this salary?',
                paySalaryText1: 'This will close the current salary month and open to process',
                paySalaryText2: 'the upcoming month\'s salary',
            },
            processSalaryModal            : {
                processFailedHeading     : 'Processing failed for some employees',
                processSalaryForAll      : 'Do you want to process the salary of all unprocessed employees?',
                processSalaryForOne      : 'Do you want to process the salary of',
                processSalaryForMultiple : 'Do you want to process the salary of Selected employees?',
            },
            undoSalaryModal               : {
                undoSalaryForAll      : 'Do you want to undo the salary of all processed employees?',
                undoSalaryForOne      : 'Do you want to undo the salary of',
                undoSalaryForMultiple : 'Do you want to process the salary of Selected employees?',
            },
            rollbackSalaryModal           : {
                bodyHeading : 'Do you want to rollback the salary?'
            },
            salaryLogModal                : {
                title       : 'Salary Log',
                bodyHeading : 'Do you want to rollback the salary?',
            },
            sendSalaryForApprovalLogModal : {
                bodyHeading : 'Do you want to send the salary for approval?',
            },
        },
        loanManagement:{
            totalLoanAmount:'Total Loan Amount',
            totalRemainingLoan:'Remaining Loan',
            activeLoans:'Active',
            loanRecovered:'Loan Recovered',
            type:'Type',
            loanAmount:'Loan Amount',
            repaidAmount:'Repaid Amount',
            loanAmountLoanDetails:'Loan Amount : ',
            repaidAmountLoanDetails:'Repaid Amount : ',
            loanOrSalaryAdvanceInputTitle : 'Add New Loan/Advance Salary',
            editLoanOrAdvanceSalaryInputTitle : 'Edit Loan/Advance Salary',
            previousLoanStatus : 'Previous Loan Status',
            previousLoanTaken : 'Previous Loan Taken',
            expectedSettlementMonth : 'Expected Settlement Month',
            noOfInstallment : 'No of Installment : ',
            installmentStartFrom : 'Installment Start From',
            loanDetails:'Loan/Advance Salary Details',
            loanRequestDate:'Loan Request Date : ',
            loanDisburseDate:'Loan Disburse Date : ',
            remainingAmount:'Remaining Amount : ',
            remainingInstallment:'Remaining Amount',
            emiNo:'EMI No',
            month:'Month',
            emiAmount:'EMI Amount',
            loanBalance:'Loan Balance',
            installmentMonths:'Installment Months',
            status:'Status',
            remarks:'Remarks:',
            deferLoan:'Defer Loan',
            earlySettlement:'Early Settlement',
            doYouWantToSaveTheText:'Do you want to save the',
            deferLoanQuestion:'Do you want to defer the loan of ',
            earlySettlementQuestion:'Do you want to Early Settlement the Loan payment for ',
            paymentMode: 'Payment Mode',
            yes:'yes',
            no:'no',
            loanDeferMonth:'Loan Defer Month (s)',
        },
        salaryCertificate : {
            totalPayment         : 'Total Payment',
            signatoryInformation : 'Signatory Information',
            signatoryNameOrId    : 'Signatory Name/Id',
            signatoryDesignation : 'Signatory Designation',
            signatoryDepartment  : 'Signatory Department',
            generateButton       : 'Generate',
            toWhomItMayConcern   : 'To whom it may concern',
            textPart1            : 'This is to certify that',
            textPart2            : 'is working as a',
            textPart3            : 'employee of',
            textPart4            : 'Currently he is working as',
            textPart5            : 'under',
            textPart6            : 'His salary details are below:',
            for                  : 'For',
            printButton          : 'Print',
            downloadDocButton    : 'Download Doc',
            employeeId           : 'Employee ID:',
        },

        bankManagement : {
            addNewBankBtn : 'Add New Bank',
            addNewBranchBtn : 'Add New Branch',
            bankList : {
                tableHeader : {
                    bankName : "Bank Name",
                    code : "Code",
                    accountName : "Account Name",
                    accountNumber : "Account Number",
                    status : "Status",
                    actions : "Actions"
                },
                adviceLetterBtn : "Create/Modify Payment Advice Letter",
                emptyTableBody : "No records found"
            },
            branchList : {
                tableHeader : {
                    bankName : "Bank Name",
                    branchName : "Branch Name",
                    routingNumber : "Routing Number",
                    status : "Status",
                    action : "Action"
                },
                emptyTableBody : "No records found"
            },
            addNewBankModal : {
                title : 'Add New Bank',
                nameInputLabel : 'Bank Name',
                nameInputPlaceholder : 'Bank Name',
                codeInputLabel : 'Code',
                codeInputPlaceholder : 'Code',
                accountNameInputLabel : 'Corporate Account Name',
                accountNameInputPlaceholder : 'Account Name',
                accountNumberInputLabel : 'Corporate Account Number',
                accountNumberInputPlaceholder : 'Account Number',
                addressInputLabel : 'Address',
                addressInputPlaceholder : 'Address',
                statusInputLabel : 'Status',
                bankSummaryHeader : 'Bank Summary',
                tableHeader : {
                    bankName : "Bank Name",
                    status : "Status",
                    action : "Action"
                },
                emptyTableBody : "No records found"
            },
            editBankModal : {
                title : 'Edit Bank',
                nameInputLabel : 'Bank Name',
                nameInputPlaceholder : 'Bank Name',
                codeInputLabel : 'Code',
                codeInputPlaceholder : 'Code',
                accountNameInputLabel : 'Corporate Account Name',
                accountNameInputPlaceholder : 'Account Name',
                accountNumberInputLabel : 'Corporate Account Number',
                accountNumberInputPlaceholder : 'Account Number',
                addressInputLabel : 'Address',
                addressInputPlaceholder : 'Address',
                statusInputLabel : 'Status'
            },
            addNewBranchModal : {
                title : 'Add New Branch',
                bankNameInputLabel : 'Bank Name',
                branchNameInputLabel : 'Branch Name',
                routingNumberInputLabel : 'Routing Number',
                branchNameInputPlaceholder : 'Branch Name',
                routingNumberInputPlaceholder : 'Routing Number',
                statusInputLabel : 'Status'
            },
            editBranchModal : {
                title : 'Edit Branch',
                bankNameInputLabel : 'Bank Name',
                branchNameInputLabel : 'Branch Name',
                routingNumberInputLabel : 'Routing Number',
                branchNameInputPlaceholder : 'Branch Name',
                routingNumberInputPlaceholder : 'Routing Number',
                statusInputLabel : 'Status'
            }
        },
        providentFund : {
           membersSubscription              : 'Member\'s Subscription',
           interestOnMembersSubscription    : 'Interest on Member\'s Subscription',
           companysContribution             : 'Company\'s Contribution',
           interestOnCompanysContribution   : 'Interest on Company\'s Contribution',
           totalContribution                : 'Total Contribution',
           PFLoan                           : 'PF Loan',
           PFLoanRecovered                  : 'PF Loan Recovered',
           PFBalance                        : 'PF Balance',
            active                          : 'Active',
            pending                         : 'Pending',
            separated                       : 'Separated',
            PFMemberDetails                 : 'PF Member Details',
            joining                         : 'Joining',
            confirmation                    : 'Confirmation',
            membership                      : 'Membership',
            separation                      : 'Separation',
            joiningDate                     : 'Joining Date',
            confirmationDate                : 'Confirmation Date',
            membershipDate                  : 'Membership Date',
            separationDate                  : 'Separation Date',
            action                          : 'Action',
            add                             : 'Add',
            remarks                         : 'Remarks',
            pfMembershipTenure              : 'PF Membership Tenure',
            openingBalance                  : 'Opening Balance',
            totalOpeningBalance             : 'Total Opening Balance',
            contributionDuringTheYear       : 'Contribution During The Year',
            totalContributionThisYear       : 'Total Contribution This Year',
            remainingLoanBalance            : 'Remaining Loan Balance',
            paymentDuringTheYear            : 'Payment During The Year',
            balanceAfterTheYear             : 'Balance After The Year',
            forfeitureForTheYear            : 'Forfeiture For The Year',
            balance                         : 'Balance',
            totalPF                         : 'Total PF',
            pFDetails                       : 'PF Details',
            pFLoan                          : 'PF Loan',
            loanAmount                      : 'Loan Amount',
            loanRecovered                   : 'Loan Recovered',
            remainingAmount                 : 'Remaining Amount',
            closeCurrentAccountingYear      : 'Close Current Accounting Year',
            uploadInterest                  : 'Upload Interest',
            reuploadInterest                : 'Reupload Interest',
            doYouWantToCloseAccounting      : 'Do you want to close PF Accounting',
            pFAccountManagement             : 'PF Account Management',
            accountingYear                  : 'Accounting Year',
            interestDuringTheYear           : 'Interest During The Year',
            totalPFBalance                  : 'Total PF Balance',

            doYouWantToUploadInterest       : 'Do you want to upload the interest for the ',
            doYouWantToAdd                  : 'Do you want to add ',
            asAPFMember                     : 'as a PF member?',
            accountYear                     : 'Account year',
            accountingYear                  : 'Accounting year',
            insertAmount                    : 'Insert Amount',
            pfStatement                     : 'PF Statement',
            balanceAfterPayments            : 'Balance After Payments',
            balanceOnLastDate               : 'Balance as on Last date of the year',
            month                           : 'Month'
        },

        visitorManagement : {
            createAppointment : {
                uploadOrTakePhoto       : 'Upload/Take Photo',
                visitorInformationEntry : 'Visitor Information Entry',
                selectCategory          : "Select Visitor Category",
                searchHost              : "Search Host by Name/ID",
                selectBloodGroup        : "Blood Group",
                emergencyContactLabel   : "Emergency Contact",
                nextButton              : "Next",
                lessAdvancedButton      : "Less",
                advancedButton          : "Advanced options",
                addVisitorButton        : "Add More Visitors+",
                selectHost              : "Select Host",
                selectDate              : "Select Date",
                entryTime               : "Entry Time",
                exitTime                : "Exit Time",
                confirmAppointment      : "Confirm Appointment",
                selectVisitPurpose      : "Select Pupose of Visit",
                visitors                : "Visitors",
                recurringVisit          : "Recurring Visit",
                sendInvitation          : "Send Invitation",
                capturePhotoModal       : {
                    header                : "Take visitor photo",
                    cameraUnavailableText : "Webcam not found or Permission denied.",
                    takePictureButton     : "Take Picture",
                    fileUploadButton      : "Select a photo from your computer"
                }
            },
            visitorCategory   : {
                createButton  : "Create Visitor Category",
                tableHeader   : {
                    visitorCategories : "Visitor Categories",
                    action            : "Action",
                    actions           : "Actions"
                },
                creationModal : {
                    title                : 'Create Visitor Category',
                    nameInputLabel       : 'Visitor Category Name',
                    nameInputPlaceholder : 'Enter Category Name',
                    createButton         : 'Create',
                    cancelButton         : 'Cancel'
                },
                deleteModal   : {
                    title            : 'Confirmation',
                    confirmationText : 'Are you sure you want to delete the visitor category named',
                },
                updateModal   : {
                    title                : 'Edit Visitor Category',
                    nameInputLabel       : 'Name',
                    nameInputPlaceholder : 'Enter Name',
                },
            },
            accessArea        : {
                title         : "Access Area",
                createButton  : "Create New Access Area",
                tableHeader   : {
                    accessAreas : "Access Areas",
                    code        : "Codes",
                    action      : "Action",
                    actions     : "Actions"
                },
                creationModal : {
                    title                : "Create Access Area",
                    nameInputLabel       : "Name",
                    codeInputLabel       : "Code",
                    nameInputPlaceholder : "Enter Name",
                    codeInputPlaceholder : "Enter Code",
                    createButton         : "Create",
                },
                deleteModal   : {
                    title            : "Confirmation",
                    confirmationText : "Are you sure you want to remove Access Area ",
                },
                updateModal   : {
                    title : "Update Access Area",
                },
            },
            myVisitorProfile  : {
                title             : "My Visitor Profile",
                search            : "Search Visitor",
                upComingVisitors  : "Upcoming Visitors",
                allVisitors       : "All Visitors",
                noResultFoundText : "No Visitors",
                visitorNames      : "Visitor Names",
                action            : "Action",
                actions           : "Actions",
                visitorInfoTitle  : "Visitor Information",
                createNewVisit    : "Create New Visit",
                saveChanges       : "Save Changes",
                save              : "Save",
                visitorMobile     : "Mobile : ",
                visitorEmail      : "Email : ",
                organization      : "Organisation : ",
                address           : "Address : ",
                visitorCategory   : "Visitor Category : ",
                createdBy         : "Created By : ",
                last5Visits       : "Last 5 Visits",
                upcomingVisit     : "Upcoming Visit",
                visitorBlock      : "Block",
                visitorsBlocked   : "Blocked",
                visitorEdit       : "Edit",
            },
            visitPurpose      : {
                title         : "Visit Purposes",
                createButton  : "Create Visit Purpose",
                tableHeader   : {
                    visitPurposes : "Visit Purposes",
                    action        : "Action",
                    actions       : "Actions"
                },
                creationModal : {
                    title                : 'Create Visit Purpose',
                    nameInputLabel       : 'Visit Purpose Name',
                    nameInputPlaceholder : 'Enter Purpose Name',
                    createButton         : 'Create',
                    cancelButton         : 'Cancel'
                },
                deleteModal   : {
                    title            : 'Confirmation',
                    confirmationText : 'Are you sure you want to delete this purpose of visit',
                },
                updateModal   : {
                    title                : 'Edit Visit Purpose',
                    nameInputLabel       : 'Visit Purpose Name',
                    nameInputPlaceholder : 'Enter New Name',
                    updateButton         : 'Update',
                },
            },
            visitorCard       : {
                createButton   : "Create Visitor Card",
                downloadButton : "Download Sample Excel",
                uploadButton   : "Upload Sample Excel",
                tableHeader    : {
                    shortCode  : "Short Code",
                    rfidNumber : "RFID Number",
                    status     : "Status",
                    action     : "Action",
                    actions    : "Actions"
                },
                emptyTableBody : "No records found",
                creationModal  : {
                    title                : "Create Visitor Card",
                    rfidInputLabel       : "RFID",
                    rfidInputPlaceHolder : "RFID",
                    codeInputLabel       : "Short Code",
                    codeInputPlaceHolder : "Short Code"
                },
                editModal      : {
                    title                : "Edit Visitor Card",
                    rfidInputLabel       : "RFID",
                    rfidInputPlaceHolder : "RFID",
                    codeInputLabel       : "Short Code",
                    codeInputPlaceHolder : "Short Code",
                    statusInputLabel     : "Status"
                },
                deleteModal    : {
                    title            : "Confirmation",
                    confirmationText : "Are you sure you want to delete "
                }
            },
            assignRole        : {
                assignButton  : "Assign Role",
                tableHeader   : {
                    employeeName : "Employee Name",
                    role         : "Role",
                    action       : "Action",
                    actions      : "Actions"
                },
                creationModal : {
                    title               : "Assign Role",
                    selectEmployeeLabel : "Select Employee",
                    selectRoleLabel     : "Select Role",
                    assignButton        : "Assign",
                },
                deleteModal   : {
                    title             : "Confirmation",
                    confirmationText  : "Are you sure you want to remove ",
                    confirmationText2 : "from ",
                }
            },
            reception         : {
                checkIn : {
                    searchCheckout           : "Search Host/Visitor/Organization/Card",
                    preRegisteredAppointment : "Pre-registered Appointment",
                    newAppointment           : "New Appointment",
                    searchInputPlaceholder   : "Search Visitor By Mobile Number/Name/Organisation/Host Name/Host ID",
                    visitorListTable         : {
                        entry : "ENTRY:",
                        exit  : "EXIT:",

                    },
                    visitorInfo              : {
                        mobileNumberLabel     : "Mobile: ",
                        categoryNameLabel     : "Visitor Category: ",
                        accessAreaLabel       : "Access Area: ",
                        reasonLabel           : "Reason: ",
                        organisationNameLabel : "Organisation Name: ",
                        entryTimeLabel        : "Entry: ",
                        exitTimeLabel         : "Exit: ",
                    },
                    questions                : {
                        title    : "Health Check",
                        checkAll : "Check All"
                    },
                    cardAssignment           : {
                        cardSelectionLabel    : "Issue Card",
                        itemInputSectionLabel : "Items Carried",
                        itemAddLabel          : "+ Add Item",
                        itemTable             : {
                            nameColumnTitle        : "Item Name",
                            descriptionColumnTitle : "Description",
                            quantityColumnTitle    : "Quantity",
                            emptyTable             : "No Items have been added."
                        },
                        checkInButton         : "CHECK IN"
                    },
                    newAppointmentForm       : {
                        accessAreaLabel         : "Access Area",
                        selectAccessAreaLabel   : "Select Access Area",
                        visitPurposeLabel       : "Purpose of Visit",
                        selectVisitPurposeLabel : "Select Purpose of Visit",
                        selectHostLabel         : "Host Information"
                    },
                    confirmationModal        : {
                        title            : "Confirmation",
                        confirmationText : "Are you sure you want to check-in "
                    }
                }
            },
            successModal      : {
                headerText                    : 'Successful!',
                appointmentCreationSuccessMsg : 'You have successfully created an appointment!',
                checkInSuccessMsg             : 'Visitor has been successfully Checked In!',
                checkOutSuccessMsg            : 'Visitor has been successfully Checked Out!',
                editSuccess                   : 'Appointment has been edited successfully!',
            },
            checkIn           : 'Check In',
            checkOut          : 'Check Out',
            hostName          : 'Host Name',
            visitorName       : 'Visitor Name',
            visitorMobile     : 'Visitor Mobile',
            noUpcomingVisit   : 'No upcoming visit',
            noPastVisits      : 'No past visits',
        },

        //Site Management
        siteManagement        : {
            siteManagementTitle    : 'Site Management',
            createSites            : 'Create Sites',
            viewSites              : 'View Sites',
            siteName               : 'Site Name',
            siteAddress            : 'Site Address',
            siteManager            : 'Site Manager',
            assignSiteManager      : 'Assign Site Manager',
            mostlyOnTimeEmployee   : "Mostly On Time Employee",
            topActiveSites         : "Top Active Sites",
            mostlyPresentEmployee  : "Mostly Present Employee",
            expectedAttendance     : "Expected Attendance",
            actualAttendance       : "Actual Attendance",
        },


        filters            : {
            companies          : 'Companies',
            offices            : 'Offices',
            year               : 'Year',
            month              : 'Month',
            departments        : 'Departments',
            subDepartments     : 'Sub Departments',
            designations       : 'Designations',
            shiftGroups        : 'Shift Groups',
            gender             : 'Gender',
            employmentType     : 'Employment Type',
            workplaces         : 'Workplaces',
            leaveCategories    : 'Leave Categories',
            leaveApprovalStatus: 'Leave Approval Status',
            component          : 'Component',
            absenceType        : 'Absence Type',
            searchEmployee     : 'Search Employee',
            filterByNetPayment : 'Filter By Net Payment',
            from               : 'From',
            to                 : 'To',
            salaryMonth        : 'Salary Month',
            comparisonMonth    : 'Comparison Month',
            searchByNameID     : 'Search Employee by Name/ID'
        },
        parkingManagement       :{
            liveFeed            : 'Live Feed',
            enteredVehicles     : 'Entered Vehicles',
            total               : 'Total Slot',
            available           : 'Total Available',
            occupied            : 'Total Occupied',
            registerNewVehicles : "Register New Vehicle",
            parkingSlotSetup    : "Parking Slot Setup",
            ownerInformation    : "Owner Information",
            ownerInformationEntry: "Owner Information Entry",
            vehicleInformation  : "Vehicle Information",
            vehicleInformationEntry: "Vehicle Information Entry",
            driverInformation   : "Driver Information",
            driverInformationEntry   : "Driver Information Entry",
            code                : "Code",
            brand               : "Brand",
            model               : "Model",
            vehicleType         : "Vehicle Type",
            contactNumber       : "Contact Number",
            mobileNumber        : "Mobile Number",
            companyName         : 'Company Name',
            email               : "Email",
            selectOrEnterType   : "Select/Enter Type",
            color               : "Color",
            selectColor         : "Enter Color",
            enterModel          : "Enter Model",
            enterBrand          : "Enter Brand",
            enterDriverMobileNo : "Enter Driver mobile Number",
            enterDriverName     : "Enter Driver Name",
            enterVehicleNumber  : "Enter Vehicle Number",
            enterMobileNumber   : "Enter Mobile Number",
            enterEmail          : "Enter Email",
            enterCompanyName    : "Enter Company Name",
            confirmRegistration : "Confirm Registration",
            foundNearby         : 'Found Nearby',
            vehicleNumber       : 'Vehicle Number',
            driverName          : 'Driver Name',
            driverMobileNumber  : 'Driver Mobile Number',
            ownerName           : 'Owner Name',
            ownerMobileNumber   : 'Owner Mobile Number',
            parkingType         : 'Parking Type: ',
            entryTime           : 'Entry Time',
            baseFare            : 'Base Fare',
            entryVehicle        : 'Entry Vehicle',
            exitVehicle         : 'Exit Vehicle',
            timeSpent           : 'Time Spent',
            billSetup           : 'Bill Setup',
            billSetupNew        : 'Setup New Bill',
            createNewBill       : 'Create New Bill',
            updateNewBill       : 'Update Bill',
            billType            : 'Bill Type',
            baseHour            : 'Base Hour',
            baseFareTk          : 'Base Fare Tk',
            baseFareInTk        : 'Base Fare in Tk',
            hourlyFareTk        : 'Hourly Fare Tk',
            hourlyFareInTk      : 'Hourly Fare In Tk',
            deleteModal         : 'Are you sure you want to delete vehicle type ',
            saveButton          : 'Save',
            cancelButton        : 'Cancel',
            employeeParking     : 'Employee Parking',
            visitorParking      : 'Visitor Parking',
            totalParking        : 'Total Parking',
            totalBill           : 'Total Bill Amount',
            amount              : 'Amount',
            paid                : 'Paid',
            tollFree            : 'Toll Free',
            createBillSetupErrorMassage: 'This field is required and can\'t be negative',
            requiredMessage     : 'This field is required',


            numberOfSlot        : 'Number Of Slot',
            enterNumberOfSlot   : "Enter Number Of Slot",
            createSlot          : "Create Slot",
            updateSlot          : 'Update Slot',

            printSlip           : {
                parkingBill         : 'DSE Parking Bill',
                driverMobile        : 'Driver Mobile',
                totalHourSpent      : 'Total Hour Spent',
                hoursFare           : 'Hours Fare',
                totalFare           : 'Total Fare',
            }

        },
        membershipManagement: {
            dashboard: {
                liveAttendanceFeed      : 'Live Feed',
                totalMemberVisitToday   : 'Total Member Visit Today',
                mostActiveMembers       : 'Most Active Members',
                soonToBeExpired         : 'Soon To Be Expired',
                notComingToLong         : 'Not Coming For Too Long',
            },
            members: {
                searchInputPlaceholder: 'Search Member By Name',
                active                : 'Active',
                expireSoon            : 'Expire Soon',
                expired               : 'Expired',
                memberName            : 'Member Name',
                memberId              : 'Member ID',
                email                 : 'Email',
                mobile                : 'Mobile',
                gender                : "Gender",
                dateOfBirth           : "Date Of Birth",
                joiningDate           : "Joining Date",
                nid                   : "NID",
                presentAddress        : "Present Address",
                uploadDocument        : "Upload Document",
                package               : 'Package',
                contactNumber         : 'Contact Number',
                addNewMemberButton    : 'Add New Member',
                renewalSubscriptionButton  : 'Renewal Subscription',
                upgradeSubscriptionButton  : 'Upgrade Subscription',
                packageType           : 'Package Type',
                duration              : 'Duration',
                packageStartDate      : 'Package Start Date',
                packageEndDate        : 'Package End Date',
                packageAmount         : 'Package Amount',
                paidAmount            : 'Paid Amount',
                renewal               : 'Renewal',
                upgrade               : 'Upgrade',
                upgradePackage        : 'Upgrade Package',
                expireDate            : 'Expire Date',
                expiredDate           : 'Expired Date',
                renewalModal          : 'Membership Renewal is Successful',
                memberInfo            : 'Member Information',
                addNewMember          : 'Add New Member',
                editNewMember         : 'Edit Member',
                subscriptionInformation: "Subscription Information",
                selectPackage         : "Select Package",
                rfidCard              : "RFID Card",
                selectAccessDevice    : "Select Access Device",
                doYouWantToDeleteMember : 'Do you want to delete the member',
                doYouWantToRenewMembership : 'Do you want to renew the membership of',
                doYouWantToRemoveFile : 'Do you want to remove the file',
                doYouWantToRenewalMember : 'Do you want to renewal membership of',
                doYouWantToUpgradeMember : 'Do you want to upgrade membership of',
                confirmButton         : 'Confirm Membership Upgrade',
            },
            settings: {
                title                    : "Settings",
                createButton             : "Create New Package",
                packageName              : "Package Name",
                packageDuration          : "Package Duration",
                duration                 : "Duration",
                noOfMonths               : "Number of Months",
                price                    : "Price",
                packagePrice             : "Package Price",
                createPackage            : "Create Package",
                editPackage              : "Edit Package",
                doYouWantToDeletePackage : 'Do you want to delete package'
            }
        },
        noData             : "No Data",
        noManualEntryFound : "No Manual Entries found",
        area               : "Area",
        noFieldVisitsFound : "No Field Visits found",
        noLateEntriesFound : "No Late Entries found",
        notifications      : {
            title             : 'Notifications',
            noNotificationMsg : "Looks like no notifications here to show!"
        },
        downloadLimitWarningModal : {
            warningText : "You can not download reports of more than 1 month.",
            contactMessage : "Please contact Customer Support for further assistance."
        }

        //This is a change to show a demo of git system
    });
}).call(this);

/*!
 * angular-translate - v2.18.2 - 2020-01-04
 *
 * Copyright (c) 2020 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module unless amdModuleId is set
        define([], function () {
            return (factory());
        });
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        factory();
    }
}(this, function () {

    /**
     * @ngdoc overview
     * @name pascalprecht.translate
     *
     * @description
     * The main module which holds everything together.
     */
    runTranslate.$inject = ['$translate'];
    $translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
    $translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
    translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
    translateAttrDirective.$inject = ['$translate', '$rootScope'];
    translateCloakDirective.$inject = ['$translate', '$rootScope'];
    translateFilterFactory.$inject = ['$parse', '$translate'];
    $translationCache.$inject = ['$cacheFactory'];
    angular.module('pascalprecht.translate', ['ng'])
        .run(runTranslate);

    function runTranslate($translate) {

        'use strict';

        var key = $translate.storageKey(),
            storage = $translate.storage();

        var fallbackFromIncorrectStorageValue = function () {
            var preferred = $translate.preferredLanguage();
            if (angular.isString(preferred)) {
                $translate.use(preferred);
                // $translate.use() will also remember the language.
                // So, we don't need to call storage.put() here.
            } else {
                storage.put(key, $translate.use());
            }
        };

        fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

        if (storage) {
            if (!storage.get(key)) {
                fallbackFromIncorrectStorageValue();
            } else {
                $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
            }
        } else if (angular.isString($translate.preferredLanguage())) {
            $translate.use($translate.preferredLanguage());
        }
    }

    runTranslate.displayName = 'runTranslate';

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateSanitizationProvider
     *
     * @description
     *
     * Configurations for $translateSanitization
     */
    angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

    function $translateSanitizationProvider () {

        'use strict';

        var $sanitize,
            $sce,
            currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
            hasConfiguredStrategy = false,
            hasShownNoStrategyConfiguredWarning = false,
            strategies;

        /**
         * Definition of a sanitization strategy function
         * @callback StrategyFunction
         * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
         * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
         * @return {string|object}
         */

        /**
         * @ngdoc property
         * @name strategies
         * @propertyOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Following strategies are built-in:
         * <dl>
         *   <dt>sanitize</dt>
         *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
         *   <dt>escape</dt>
         *   <dd>Escapes HTML in the translation</dd>
         *   <dt>sanitizeParameters</dt>
         *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
         *   <dt>escapeParameters</dt>
         *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
         *   <dt>escaped</dt>
         *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
         * </dl>
         *
         */

        strategies = {
            sanitize: function (value, mode/*, context*/) {
                if (mode === 'text') {
                    value = htmlSanitizeValue(value);
                }
                return value;
            },
            escape: function (value, mode/*, context*/) {
                if (mode === 'text') {
                    value = htmlEscapeValue(value);
                }
                return value;
            },
            sanitizeParameters: function (value, mode/*, context*/) {
                if (mode === 'params') {
                    value = mapInterpolationParameters(value, htmlSanitizeValue);
                }
                return value;
            },
            escapeParameters: function (value, mode/*, context*/) {
                if (mode === 'params') {
                    value = mapInterpolationParameters(value, htmlEscapeValue);
                }
                return value;
            },
            sce: function (value, mode, context) {
                if (mode === 'text') {
                    value = htmlTrustValue(value);
                } else if (mode === 'params') {
                    if (context !== 'filter') {
                        // do html escape in filter context #1101
                        value = mapInterpolationParameters(value, htmlEscapeValue);
                    }
                }
                return value;
            },
            sceParameters: function (value, mode/*, context*/) {
                if (mode === 'params') {
                    value = mapInterpolationParameters(value, htmlTrustValue);
                }
                return value;
            }
        };
        // Support legacy strategy name 'escaped' for backwards compatibility.
        // TODO should be removed in 3.0
        strategies.escaped = strategies.escapeParameters;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Adds a sanitization strategy to the list of known strategies.
         *
         * @param {string} strategyName - unique key for a strategy
         * @param {StrategyFunction} strategyFunction - strategy function
         * @returns {object} this
         */
        this.addStrategy = function (strategyName, strategyFunction) {
            strategies[strategyName] = strategyFunction;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Removes a sanitization strategy from the list of known strategies.
         *
         * @param {string} strategyName - unique key for a strategy
         * @returns {object} this
         */
        this.removeStrategy = function (strategyName) {
            delete strategies[strategyName];
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
         *
         * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
         * @returns {object} this
         */
        this.useStrategy = function (strategy) {
            hasConfiguredStrategy = true;
            currentStrategy = strategy;
            return this;
        };

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translateSanitization
         * @requires $injector
         * @requires $log
         *
         * @description
         * Sanitizes interpolation parameters and translated texts.
         *
         */
        this.$get = ['$injector', '$log', function ($injector, $log) {

            var cachedStrategyMap = {};

            var applyStrategies = function (value, mode, context, selectedStrategies) {
                angular.forEach(selectedStrategies, function (selectedStrategy) {
                    if (angular.isFunction(selectedStrategy)) {
                        value = selectedStrategy(value, mode, context);
                    } else if (angular.isFunction(strategies[selectedStrategy])) {
                        value = strategies[selectedStrategy](value, mode, context);
                    } else if (angular.isString(strategies[selectedStrategy])) {
                        if (!cachedStrategyMap[strategies[selectedStrategy]]) {
                            try {
                                cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
                            } catch (e) {
                                cachedStrategyMap[strategies[selectedStrategy]] = function() {};
                                throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
                            }
                        }
                        value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
                    } else {
                        throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
                    }
                });
                return value;
            };

            // TODO: should be removed in 3.0
            var showNoStrategyConfiguredWarning = function () {
                if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
                    $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
                    hasShownNoStrategyConfiguredWarning = true;
                }
            };

            if ($injector.has('$sanitize')) {
                $sanitize = $injector.get('$sanitize');
            }
            if ($injector.has('$sce')) {
                $sce = $injector.get('$sce');
            }

            return {
                /**
                 * @ngdoc function
                 * @name pascalprecht.translate.$translateSanitization#useStrategy
                 * @methodOf pascalprecht.translate.$translateSanitization
                 *
                 * @description
                 * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
                 *
                 * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
                 */
                useStrategy: (function (self) {
                    return function (strategy) {
                        self.useStrategy(strategy);
                    };
                })(this),

                /**
                 * @ngdoc function
                 * @name pascalprecht.translate.$translateSanitization#sanitize
                 * @methodOf pascalprecht.translate.$translateSanitization
                 *
                 * @description
                 * Sanitizes a value.
                 *
                 * @param {string|object} value The value which should be sanitized.
                 * @param {string} mode The current sanitization mode, either 'params' or 'text'.
                 * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
                 * @param {string} [context] The context of this call: filter, service. Default is service
                 * @returns {string|object} sanitized value
                 */
                sanitize: function (value, mode, strategy, context) {
                    if (!currentStrategy) {
                        showNoStrategyConfiguredWarning();
                    }

                    if (!strategy && strategy !== null) {
                        strategy = currentStrategy;
                    }

                    if (!strategy) {
                        return value;
                    }

                    if (!context) {
                        context = 'service';
                    }

                    var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
                    return applyStrategies(value, mode, context, selectedStrategies);
                }
            };
        }];

        var htmlEscapeValue = function (value) {
            var element = angular.element('<div></div>');
            element.text(value); // not chainable, see #1044
            return element.html();
        };

        var htmlSanitizeValue = function (value) {
            if (!$sanitize) {
                throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
            }
            return $sanitize(value);
        };

        var htmlTrustValue = function (value) {
            if (!$sce) {
                throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
            }
            return $sce.trustAsHtml(value);
        };

        var mapInterpolationParameters = function (value, iteratee, stack) {
            if (angular.isDate(value)) {
                return value;
            } else if (angular.isObject(value)) {
                var result = angular.isArray(value) ? [] : {};

                if (!stack) {
                    stack = [];
                } else {
                    if (stack.indexOf(value) > -1) {
                        throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
                    }
                }

                stack.push(value);
                angular.forEach(value, function (propertyValue, propertyKey) {

                    /* Skipping function properties. */
                    if (angular.isFunction(propertyValue)) {
                        return;
                    }

                    result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
                });
                stack.splice(-1, 1); // remove last

                return result;
            } else if (angular.isNumber(value)) {
                return value;
            } else if (value === true || value === false) {
                return value;
            } else if (!angular.isUndefined(value) && value !== null) {
                return iteratee(value);
            } else {
                return value;
            }
        };
    }

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateProvider
     * @description
     *
     * $translateProvider allows developers to register translation-tables, asynchronous loaders
     * and similar to configure translation behavior directly inside of a module.
     *
     */
    angular.module('pascalprecht.translate')
        .constant('pascalprechtTranslateOverrider', {})
        .provider('$translate', $translate);

    function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

        'use strict';

        var $translationTable = {},
            $preferredLanguage,
            $availableLanguageKeys = [],
            $languageKeyAliases,
            $fallbackLanguage,
            $fallbackWasString,
            $uses,
            $nextLang,
            $storageFactory,
            $storageKey = $STORAGE_KEY,
            $storagePrefix,
            $missingTranslationHandlerFactory,
            $interpolationFactory,
            $interpolatorFactories = [],
            $loaderFactory,
            $cloakClassName = 'translate-cloak',
            $loaderOptions,
            $notFoundIndicatorLeft,
            $notFoundIndicatorRight,
            $postCompilingEnabled = false,
            $forceAsyncReloadEnabled = false,
            $nestedObjectDelimeter = '.',
            $isReady = false,
            $keepContent = false,
            loaderCache,
            directivePriority = 0,
            statefulFilter = true,
            postProcessFn,
            uniformLanguageTagResolver = 'default',
            languageTagResolver = {
                'default' : function (tag) {
                    return (tag || '').split('-').join('_');
                },
                java : function (tag) {
                    var temp = (tag || '').split('-').join('_');
                    var parts = temp.split('_');
                    return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
                },
                bcp47 : function (tag) {
                    var temp = (tag || '').split('_').join('-');
                    var parts = temp.split('-');

                    switch (parts.length) {
                        case 1: // language only
                            parts[0] = parts[0].toLowerCase();
                            break;
                        case 2: // language-script or language-region
                            parts[0] = parts[0].toLowerCase();
                            if (parts[1].length === 4) { // parts[1] is script
                                parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
                            } else { // parts[1] is region
                                parts[1] = parts[1].toUpperCase();
                            }
                            break;
                        case 3: // language-script-region
                            parts[0] = parts[0].toLowerCase();
                            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
                            parts[2] = parts[2].toUpperCase();
                            break;
                        default:
                            return temp;
                    }

                    return parts.join('-');
                },
                'iso639-1' : function (tag) {
                    var temp = (tag || '').split('_').join('-');
                    var parts = temp.split('-');
                    return parts[0].toLowerCase();
                }
            };

        var version = '2.18.2';

        // tries to determine the browsers language
        var getFirstBrowserLanguage = function () {

            // internal purpose only
            if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
                return pascalprechtTranslateOverrider.getLocale();
            }

            var nav = $windowProvider.$get().navigator,
                browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
                i,
                language;

            // support for HTML 5.1 "navigator.languages"
            if (angular.isArray(nav.languages)) {
                for (i = 0; i < nav.languages.length; i++) {
                    language = nav.languages[i];
                    if (language && language.length) {
                        return language;
                    }
                }
            }

            // support for other well known properties in browsers
            for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
                language = nav[browserLanguagePropertyKeys[i]];
                if (language && language.length) {
                    return language;
                }
            }

            return null;
        };
        getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

        // tries to determine the browsers locale
        var getLocale = function () {
            var locale = getFirstBrowserLanguage() || '';
            if (languageTagResolver[uniformLanguageTagResolver]) {
                locale = languageTagResolver[uniformLanguageTagResolver](locale);
            }
            return locale;
        };
        getLocale.displayName = 'angular-translate/service: getLocale';

        /**
         * @name indexOf
         * @private
         *
         * @description
         * indexOf polyfill. Kinda sorta.
         *
         * @param {array} array Array to search in.
         * @param {string} searchElement Element to search for.
         *
         * @returns {int} Index of search element.
         */
        var indexOf = function (array, searchElement) {
            for (var i = 0, len = array.length; i < len; i++) {
                if (array[i] === searchElement) {
                    return i;
                }
            }
            return -1;
        };

        /**
         * @name trim
         * @private
         *
         * @description
         * trim polyfill
         *
         * @returns {string} The string stripped of whitespace from both ends
         */
        var trim = function () {
            return this.toString().replace(/^\s+|\s+$/g, '');
        };

        /**
         * @name lowercase
         * @private
         *
         * @description
         * Return the lowercase string only if the type is string
         *
         * @returns {string} The string all in lowercase
         */
        var lowercase = function (string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        };

        var negotiateLocale = function (preferred) {
            if (!preferred) {
                return;
            }

            var avail = [],
                locale = lowercase(preferred),
                i = 0,
                n = $availableLanguageKeys.length;

            for (; i < n; i++) {
                avail.push(lowercase($availableLanguageKeys[i]));
            }

            // Check for an exact match in our list of available keys
            i = indexOf(avail, locale);
            if (i > -1) {
                return $availableLanguageKeys[i];
            }

            if ($languageKeyAliases) {
                var alias;
                for (var langKeyAlias in $languageKeyAliases) {
                    if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
                        var hasWildcardKey = false;
                        var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
                            lowercase(langKeyAlias) === lowercase(preferred);

                        if (langKeyAlias.slice(-1) === '*') {
                            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
                        }
                        if (hasExactKey || hasWildcardKey) {
                            alias = $languageKeyAliases[langKeyAlias];
                            if (indexOf(avail, lowercase(alias)) > -1) {
                                return alias;
                            }
                        }
                    }
                }
            }

            // Check for a language code without region
            var parts = preferred.split('_');

            if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
                return parts[0];
            }

            // If everything fails, return undefined.
            return;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#translations
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a new translation table for specific language key.
         *
         * To register a translation table for specific language, pass a defined language
         * key as first parameter.
         *
         * <pre>
         *  // register translation table for language: 'de_DE'
         *  $translateProvider.translations('de_DE', {
         *    'GREETING': 'Hallo Welt!'
         *  });
         *
         *  // register another one
         *  $translateProvider.translations('en_US', {
         *    'GREETING': 'Hello world!'
         *  });
         * </pre>
         *
         * When registering multiple translation tables for for the same language key,
         * the actual translation table gets extended. This allows you to define module
         * specific translation which only get added, once a specific module is loaded in
         * your app.
         *
         * Invoking this method with no arguments returns the translation table which was
         * registered with no language key. Invoking it with a language key returns the
         * related translation table.
         *
         * @param {string} langKey A language key.
         * @param {object} translationTable A plain old JavaScript object that represents a translation table.
         *
         */
        var translations = function (langKey, translationTable) {

            if (!langKey && !translationTable) {
                return $translationTable;
            }

            if (langKey && !translationTable) {
                if (angular.isString(langKey)) {
                    return $translationTable[langKey];
                }
            } else {
                if (!angular.isObject($translationTable[langKey])) {
                    $translationTable[langKey] = {};
                }
                angular.extend($translationTable[langKey], flatObject(translationTable));
            }
            return this;
        };

        this.translations = translations;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#cloakClassName
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         *
         * Let's you change the class name for `translate-cloak` directive.
         * Default class name is `translate-cloak`.
         *
         * @param {string} name translate-cloak class name
         */
        this.cloakClassName = function (name) {
            if (!name) {
                return $cloakClassName;
            }
            $cloakClassName = name;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         *
         * Let's you change the delimiter for namespaced translations.
         * Default delimiter is `.`.
         *
         * @param {string} delimiter namespace separator
         */
        this.nestedObjectDelimeter = function (delimiter) {
            if (!delimiter) {
                return $nestedObjectDelimeter;
            }
            $nestedObjectDelimeter = delimiter;
            return this;
        };

        /**
         * @name flatObject
         * @private
         *
         * @description
         * Flats an object. This function is used to flatten given translation data with
         * namespaces, so they are later accessible via dot notation.
         */
        var flatObject = function (data, path, result, prevKey) {
            var key, keyWithPath, keyWithShortPath, val;

            if (!path) {
                path = [];
            }
            if (!result) {
                result = {};
            }
            for (key in data) {
                if (!Object.prototype.hasOwnProperty.call(data, key)) {
                    continue;
                }
                val = data[key];
                if (angular.isObject(val)) {
                    flatObject(val, path.concat(key), result, key);
                } else {
                    keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
                    if (path.length && key === prevKey) {
                        // Create shortcut path (foo.bar == foo.bar.bar)
                        keyWithShortPath = '' + path.join($nestedObjectDelimeter);
                        // Link it to original path
                        result[keyWithShortPath] = '@:' + keyWithPath;
                    }
                    result[keyWithPath] = val;
                }
            }
            return result;
        };
        flatObject.displayName = 'flatObject';

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#addInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Adds interpolation services to angular-translate, so it can manage them.
         *
         * @param {object} factory Interpolation service factory
         */
        this.addInterpolation = function (factory) {
            $interpolatorFactories.push(factory);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use interpolation functionality of messageformat.js.
         * This is useful when having high level pluralization and gender selection.
         */
        this.useMessageFormatInterpolation = function () {
            return this.useInterpolation('$translateMessageFormatInterpolation');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate which interpolation style to use as default, application-wide.
         * Simply pass a factory/service name. The interpolation service has to implement
         * the correct interface.
         *
         * @param {string} factory Interpolation service name.
         */
        this.useInterpolation = function (factory) {
            $interpolationFactory = factory;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Simply sets a sanitation strategy type.
         *
         * @param {string} value Strategy type.
         */
        this.useSanitizeValueStrategy = function (value) {
            $translateSanitizationProvider.useStrategy(value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#preferredLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which of the registered translation tables to use for translation
         * at initial startup by passing a language key. Similar to `$translateProvider#use`
         * only that it says which language to **prefer**.
         * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
         *
         * @param {string} langKey A language key.
         */
        this.preferredLanguage = function (langKey) {
            if (langKey) {
                setupPreferredLanguage(langKey);
                return this;
            }
            return $preferredLanguage;
        };
        var setupPreferredLanguage = function (langKey) {
            if (langKey) {
                $preferredLanguage = langKey;
            }
            return $preferredLanguage;
        };
        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found. E.g. when
         * setting the indicator as 'X' and one tries to translate a translation id
         * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
         *
         * Internally this methods sets a left indicator and a right indicator using
         * `$translateProvider.translationNotFoundIndicatorLeft()` and
         * `$translateProvider.translationNotFoundIndicatorRight()`.
         *
         * **Note**: These methods automatically add a whitespace between the indicators
         * and the translation id.
         *
         * @param {string} indicator An indicator, could be any string.
         */
        this.translationNotFoundIndicator = function (indicator) {
            this.translationNotFoundIndicatorLeft(indicator);
            this.translationNotFoundIndicatorRight(indicator);
            return this;
        };

        /**
         * ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found left to the
         * translation id.
         *
         * @param {string} indicator An indicator.
         */
        this.translationNotFoundIndicatorLeft = function (indicator) {
            if (!indicator) {
                return $notFoundIndicatorLeft;
            }
            $notFoundIndicatorLeft = indicator;
            return this;
        };

        /**
         * ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found right to the
         * translation id.
         *
         * @param {string} indicator An indicator.
         */
        this.translationNotFoundIndicatorRight = function (indicator) {
            if (!indicator) {
                return $notFoundIndicatorRight;
            }
            $notFoundIndicatorRight = indicator;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#fallbackLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which of the registered translation tables to use when missing translations
         * at initial startup by passing a language key. Similar to `$translateProvider#use`
         * only that it says which language to **fallback**.
         *
         * @param {string||array} langKey A language key.
         *
         */
        this.fallbackLanguage = function (langKey) {
            fallbackStack(langKey);
            return this;
        };

        var fallbackStack = function (langKey) {
            if (langKey) {
                if (angular.isString(langKey)) {
                    $fallbackWasString = true;
                    $fallbackLanguage = [langKey];
                } else if (angular.isArray(langKey)) {
                    $fallbackWasString = false;
                    $fallbackLanguage = langKey;
                }
                if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                    $fallbackLanguage.push($preferredLanguage);
                }

                return this;
            } else {
                if ($fallbackWasString) {
                    return $fallbackLanguage[0];
                } else {
                    return $fallbackLanguage;
                }
            }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#use
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Set which translation table to use for translation by given language key. When
         * trying to 'use' a language which isn't provided, it'll throw an error.
         *
         * You actually don't have to use this method since `$translateProvider#preferredLanguage`
         * does the job too.
         *
         * @param {string} langKey A language key.
         */
        this.use = function (langKey) {
            if (langKey) {
                if (!$translationTable[langKey] && (!$loaderFactory)) {
                    // only throw an error, when not loading translation data asynchronously
                    throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
                }
                $uses = langKey;
                return this;
            }
            return $uses;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#resolveClientLocale
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
         *
         * @returns {string} the current client/browser language key
         */
        this.resolveClientLocale = function () {
            return getLocale();
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#storageKey
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which key must represent the choosed language by a user in the storage.
         *
         * @param {string} key A key for the storage.
         */
        var storageKey = function (key) {
            if (!key) {
                if ($storagePrefix) {
                    return $storagePrefix + $storageKey;
                }
                return $storageKey;
            }
            $storageKey = key;
            return this;
        };

        this.storageKey = storageKey;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useUrlLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
         *
         * @param {string} url Url
         * @param {Object=} options Optional configuration object
         */
        this.useUrlLoader = function (url, options) {
            return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
         *
         * @param {Object=} options Optional configuration object
         */
        this.useStaticFilesLoader = function (options) {
            return this.useLoader('$translateStaticFilesLoader', options);
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use any other service as loader.
         *
         * @param {string} loaderFactory Factory name to use
         * @param {Object=} options Optional configuration object
         */
        this.useLoader = function (loaderFactory, options) {
            $loaderFactory = loaderFactory;
            $loaderOptions = options || {};
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLocalStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
         *
         */
        this.useLocalStorage = function () {
            return this.useStorage('$translateLocalStorage');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useCookieStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
         */
        this.useCookieStorage = function () {
            return this.useStorage('$translateCookieStorage');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use custom service as storage layer.
         */
        this.useStorage = function (storageFactory) {
            $storageFactory = storageFactory;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#storagePrefix
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets prefix for storage key.
         *
         * @param {string} prefix Storage key prefix
         */
        this.storagePrefix = function (prefix) {
            if (!prefix) {
                return prefix;
            }
            $storagePrefix = prefix;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use built-in log handler when trying to translate
         * a translation Id which doesn't exist.
         *
         * This is actually a shortcut method for `useMissingTranslationHandler()`.
         *
         */
        this.useMissingTranslationHandlerLog = function () {
            return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Expects a factory name which later gets instantiated with `$injector`.
         * This method can be used to tell angular-translate to use a custom
         * missingTranslationHandler. Just build a factory which returns a function
         * and expects a translation id as argument.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.useMissingTranslationHandler('customHandler');
         *  });
         *
         *  app.factory('customHandler', function (dep1, dep2) {
         *    return function (translationId) {
         *      // something with translationId and dep1 and dep2
         *    };
         *  });
         * </pre>
         *
         * @param {string} factory Factory name
         */
        this.useMissingTranslationHandler = function (factory) {
            $missingTranslationHandlerFactory = factory;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#usePostCompiling
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If post compiling is enabled, all translated values will be processed
         * again with AngularJS' $compile.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.usePostCompiling(true);
         *  });
         * </pre>
         *
         * @param {string} factory Factory name
         */
        this.usePostCompiling = function (value) {
            $postCompilingEnabled = !(!value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#forceAsyncReload
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If force async reload is enabled, async loader will always be called
         * even if $translationTable already contains the language key, adding
         * possible new entries to the $translationTable.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.forceAsyncReload(true);
         *  });
         * </pre>
         *
         * @param {boolean} value - valid values are true or false
         */
        this.forceAsyncReload = function (value) {
            $forceAsyncReloadEnabled = !(!value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate which language tag should be used as a result when determining
         * the current browser language.
         *
         * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
         *
         * <pre>
         * $translateProvider
         *   .uniformLanguageTag('bcp47')
         *   .determinePreferredLanguage()
         * </pre>
         *
         * The resolver currently supports:
         * * default
         *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
         *     en-US => en_US
         *     en_US => en_US
         *     en-us => en_us
         * * java
         *     like default, but the second part will be always in uppercase
         *     en-US => en_US
         *     en_US => en_US
         *     en-us => en_US
         * * BCP 47 (RFC 4646 & 4647)
         *     EN => en
         *     en-US => en-US
         *     en_US => en-US
         *     en-us => en-US
         *     sr-latn => sr-Latn
         *     sr-latn-rs => sr-Latn-RS
         *
         * See also:
         * * http://en.wikipedia.org/wiki/IETF_language_tag
         * * http://www.w3.org/International/core/langtags/
         * * http://tools.ietf.org/html/bcp47
         *
         * @param {string|object} options - options (or standard)
         * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
         */
        this.uniformLanguageTag = function (options) {

            if (!options) {
                options = {};
            } else if (angular.isString(options)) {
                options = {
                    standard : options
                };
            }

            uniformLanguageTagResolver = options.standard;

            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to try to determine on its own which language key
         * to set as preferred language. When `fn` is given, angular-translate uses it
         * to determine a language key, otherwise it uses the built-in `getLocale()`
         * method.
         *
         * The `getLocale()` returns a language key in the format `[lang]_[country]` or
         * `[lang]` depending on what the browser provides.
         *
         * Use this method at your own risk, since not all browsers return a valid
         * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
         *
         * @param {Function=} fn Function to determine a browser's locale
         */
        this.determinePreferredLanguage = function (fn) {

            var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

            if (!$availableLanguageKeys.length) {
                $preferredLanguage = locale;
            } else {
                $preferredLanguage = negotiateLocale(locale) || locale;
            }

            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a set of language keys the app will work with. Use this method in
         * combination with
         * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
         * When available languages keys are registered, angular-translate
         * tries to find the best fitting language key depending on the browsers locale,
         * considering your language key convention.
         *
         * @param {object} languageKeys Array of language keys the your app will use
         * @param {object=} aliases Alias map.
         */
        this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
            if (languageKeys) {
                $availableLanguageKeys = languageKeys;
                if (aliases) {
                    $languageKeyAliases = aliases;
                }
                return this;
            }
            return $availableLanguageKeys;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLoaderCache
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a cache for internal $http based loaders.
         * {@link pascalprecht.translate.$translationCache $translationCache}.
         * When false the cache will be disabled (default). When true or undefined
         * the cache will be a default (see $cacheFactory). When an object it will
         * be treat as a cache object itself: the usage is $http({cache: cache})
         *
         * @param {object} cache boolean, string or cache-object
         */
        this.useLoaderCache = function (cache) {
            if (cache === false) {
                // disable cache
                loaderCache = undefined;
            } else if (cache === true) {
                // enable cache using AJS defaults
                loaderCache = true;
            } else if (typeof(cache) === 'undefined') {
                // enable cache using default
                loaderCache = '$translationCache';
            } else if (cache) {
                // enable cache using given one (see $cacheFactory)
                loaderCache = cache;
            }
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#directivePriority
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets the default priority of the translate directive. The standard value is `0`.
         * Calling this function without an argument will return the current value.
         *
         * @param {number} priority for the translate-directive
         */
        this.directivePriority = function (priority) {
            if (priority === undefined) {
                // getter
                return directivePriority;
            } else {
                // setter with chaining
                directivePriority = priority;
                return this;
            }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#statefulFilter
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
         * have to explicit define this behavior.
         * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
         * meaning being stateful.
         * Calling this function without an argument will return the current value.
         *
         * @param {boolean} state - defines the state of the filter
         */
        this.statefulFilter = function (state) {
            if (state === undefined) {
                // getter
                return statefulFilter;
            } else {
                // setter with chaining
                statefulFilter = state;
                return this;
            }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#postProcess
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * The post processor will be intercept right after the translation result. It can modify the result.
         *
         * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
         */
        this.postProcess = function (fn) {
            if (fn) {
                postProcessFn = fn;
            } else {
                postProcessFn = undefined;
            }
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#keepContent
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If keepContent is set to true than translate directive will always use innerHTML
         * as a default translation
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.keepContent(true);
         *  });
         * </pre>
         *
         * @param {boolean} value - valid values are true or false
         */
        this.keepContent = function (value) {
            $keepContent = !(!value);
            return this;
        };

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translate
         * @requires $interpolate
         * @requires $log
         * @requires $rootScope
         * @requires $q
         *
         * @description
         * The `$translate` service is the actual core of angular-translate. It expects a translation id
         * and optional interpolate parameters to translate contents.
         *
         * <pre>
         *  $translate('HEADLINE_TEXT').then(function (translation) {
         *    $scope.translatedText = translation;
         *  });
         * </pre>
         *
         * @param {string|array} translationId A token which represents a translation id
         *                                     This can be optionally an array of translation ids which
         *                                     results that the function returns an object where each key
         *                                     is the translation id and the value the translation.
         * @param {object=} [interpolateParams={}] An object hash for dynamic values
         * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
         * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
         *                                        as default text in case it is not found in any configured language
         * @param {string=} [forceLanguage=false] A language to be used instead of the current language
         * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
         * @returns {object} promise
         */
        this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

            var Storage,
                defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
                pendingLoader = false,
                interpolatorHashMap = {},
                langPromises = {},
                fallbackIndex,
                startFallbackIteration;

            var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
                if (!$uses && $preferredLanguage) {
                    $uses = $preferredLanguage;
                }
                var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
                    (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

                // Check forceLanguage is present
                if (forceLanguage) {
                    loadTranslationsIfMissing(forceLanguage);
                }

                // Duck detection: If the first argument is an array, a bunch of translations was requested.
                // The result is an object.
                if (angular.isArray(translationId)) {
                    // Inspired by Q.allSettled by Kris Kowal
                    // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
                    // This transforms all promises regardless resolved or rejected
                    var translateAll = function (translationIds) {
                        var results = {}; // storing the actual results
                        var promises = []; // promises to wait for
                        // Wraps the promise a) being always resolved and b) storing the link id->value
                        var translate = function (translationId) {
                            var deferred = $q.defer();
                            var regardless = function (value) {
                                results[translationId] = value;
                                deferred.resolve([translationId, value]);
                            };
                            // we don't care whether the promise was resolved or rejected; just store the values
                            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
                            return deferred.promise;
                        };
                        for (var i = 0, c = translationIds.length; i < c; i++) {
                            promises.push(translate(translationIds[i]));
                        }
                        // wait for all (including storing to results)
                        return $q.all(promises).then(function () {
                            // return the results
                            return results;
                        });
                    };
                    return translateAll(translationId);
                }

                var deferred = $q.defer();

                // trim off any whitespace
                if (translationId) {
                    translationId = trim.apply(translationId);
                } else {
                    throw new TypeError('translationId must be a not empty string');
                }

                var promiseToWaitFor = (function () {
                    var promise = langPromises[uses] || langPromises[$preferredLanguage];

                    fallbackIndex = 0;

                    if ($storageFactory && !promise) {
                        // looks like there's no pending promise for $preferredLanguage or
                        // $uses. Maybe there's one pending for a language that comes from
                        // storage.
                        var langKey = Storage.get($storageKey);
                        promise = langPromises[langKey];

                        if ($fallbackLanguage && $fallbackLanguage.length) {
                            var index = indexOf($fallbackLanguage, langKey);
                            // maybe the language from storage is also defined as fallback language
                            // we increase the fallback language index to not search in that language
                            // as fallback, since it's probably the first used language
                            // in that case the index starts after the first element
                            fallbackIndex = (index === 0) ? 1 : 0;

                            // but we can make sure to ALWAYS fallback to preferred language at least
                            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                                $fallbackLanguage.push($preferredLanguage);
                            }
                        }
                    }
                    return promise;
                }());

                if (!promiseToWaitFor) {
                    // no promise to wait for? okay. Then there's no loader registered
                    // nor is a one pending for language that comes from storage.
                    // We can just translate.
                    determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                } else {
                    var promiseResolved = function () {
                        // $uses may have changed while waiting
                        if (!forceLanguage) {
                            uses = $uses;
                        }
                        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                    };
                    promiseResolved.displayName = 'promiseResolved';

                    promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
                }
                return deferred.promise;
            };

            /**
             * @name applyNotFoundIndicators
             * @private
             *
             * @description
             * Applies not fount indicators to given translation id, if needed.
             * This function gets only executed, if a translation id doesn't exist,
             * which is why a translation id is expected as argument.
             *
             * @param {string} translationId Translation id.
             * @returns {string} Same as given translation id but applied with not found
             * indicators.
             */
            var applyNotFoundIndicators = function (translationId) {
                // applying notFoundIndicators
                if ($notFoundIndicatorLeft) {
                    translationId = [$notFoundIndicatorLeft, translationId].join(' ');
                }
                if ($notFoundIndicatorRight) {
                    translationId = [translationId, $notFoundIndicatorRight].join(' ');
                }
                return translationId;
            };

            /**
             * @name useLanguage
             * @private
             *
             * @description
             * Makes actual use of a language by setting a given language key as used
             * language and informs registered interpolators to also use the given
             * key as locale.
             *
             * @param {string} key Locale key.
             */
            var useLanguage = function (key) {
                $uses = key;

                // make sure to store new language key before triggering success event
                if ($storageFactory) {
                    Storage.put($translate.storageKey(), $uses);
                }

                $rootScope.$emit('$translateChangeSuccess', {language : key});

                // inform default interpolator
                defaultInterpolator.setLocale($uses);

                var eachInterpolator = function (interpolator, id) {
                    interpolatorHashMap[id].setLocale($uses);
                };
                eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

                // inform all others too!
                angular.forEach(interpolatorHashMap, eachInterpolator);
                $rootScope.$emit('$translateChangeEnd', {language : key});
            };

            /**
             * @name loadAsync
             * @private
             *
             * @description
             * Kicks off registered async loader using `$injector` and applies existing
             * loader options. When resolved, it updates translation tables accordingly
             * or rejects with given language key.
             *
             * @param {string} key Language key.
             * @return {Promise} A promise.
             */
            var loadAsync = function (key) {
                if (!key) {
                    throw 'No language key specified for loading.';
                }

                var deferred = $q.defer();

                $rootScope.$emit('$translateLoadingStart', {language : key});
                pendingLoader = true;

                var cache = loaderCache;
                if (typeof(cache) === 'string') {
                    // getting on-demand instance of loader
                    cache = $injector.get(cache);
                }

                var loaderOptions = angular.extend({}, $loaderOptions, {
                    key : key,
                    $http : angular.extend({}, {
                        cache : cache
                    }, $loaderOptions.$http)
                });

                var onLoaderSuccess = function (data) {
                    var translationTable = {};
                    $rootScope.$emit('$translateLoadingSuccess', {language : key});

                    if (angular.isArray(data)) {
                        angular.forEach(data, function (table) {
                            angular.extend(translationTable, flatObject(table));
                        });
                    } else {
                        angular.extend(translationTable, flatObject(data));
                    }
                    pendingLoader = false;
                    deferred.resolve({
                        key : key,
                        table : translationTable
                    });
                    $rootScope.$emit('$translateLoadingEnd', {language : key});
                };
                onLoaderSuccess.displayName = 'onLoaderSuccess';

                var onLoaderError = function (key) {
                    $rootScope.$emit('$translateLoadingError', {language : key});
                    deferred.reject(key);
                    $rootScope.$emit('$translateLoadingEnd', {language : key});
                };
                onLoaderError.displayName = 'onLoaderError';

                $injector.get($loaderFactory)(loaderOptions)
                    .then(onLoaderSuccess, onLoaderError);

                return deferred.promise;
            };

            if ($storageFactory) {
                Storage = $injector.get($storageFactory);

                if (!Storage.get || !Storage.put) {
                    throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
                }
            }

            // if we have additional interpolations that were added via
            // $translateProvider.addInterpolation(), we have to map'em
            if ($interpolatorFactories.length) {
                var eachInterpolationFactory = function (interpolatorFactory) {
                    var interpolator = $injector.get(interpolatorFactory);
                    // setting initial locale for each interpolation service
                    interpolator.setLocale($preferredLanguage || $uses);
                    // make'em recognizable through id
                    interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
                };
                eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

                angular.forEach($interpolatorFactories, eachInterpolationFactory);
            }

            /**
             * @name getTranslationTable
             * @private
             *
             * @description
             * Returns a promise that resolves to the translation table
             * or is rejected if an error occurred.
             *
             * @param langKey
             * @returns {Q.promise}
             */
            var getTranslationTable = function (langKey) {
                var deferred = $q.defer();
                if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
                    deferred.resolve($translationTable[langKey]);
                } else if (langPromises[langKey]) {
                    var onResolve = function (data) {
                        translations(data.key, data.table);
                        deferred.resolve(data.table);
                    };
                    onResolve.displayName = 'translationTableResolver';
                    langPromises[langKey].then(onResolve, deferred.reject);
                } else {
                    deferred.reject();
                }
                return deferred.promise;
            };

            /**
             * @name getFallbackTranslation
             * @private
             *
             * @description
             * Returns a promise that will resolve to the translation
             * or be rejected if no translation was found for the language.
             * This function is currently only used for fallback language translation.
             *
             * @param langKey The language to translate to.
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy
             * @returns {Q.promise}
             */
            var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                var deferred = $q.defer();

                var onResolve = function (translationTable) {
                    if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
                        Interpolator.setLocale(langKey);
                        var translation = translationTable[translationId];
                        if (translation.substr(0, 2) === '@:') {
                            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
                                .then(deferred.resolve, deferred.reject);
                        } else {
                            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
                            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

                            deferred.resolve(interpolatedValue);

                        }
                        Interpolator.setLocale($uses);
                    } else {
                        deferred.reject();
                    }
                };
                onResolve.displayName = 'fallbackTranslationResolver';

                getTranslationTable(langKey).then(onResolve, deferred.reject);

                return deferred.promise;
            };

            /**
             * @name getFallbackTranslationInstant
             * @private
             *
             * @description
             * Returns a translation
             * This function is currently only used for fallback language translation.
             *
             * @param langKey The language to translate to.
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy sanitize strategy override
             *
             * @returns {string} translation
             */
            var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                var result, translationTable = $translationTable[langKey];

                if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
                    Interpolator.setLocale(langKey);
                    result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
                    result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
                    // workaround for TrustedValueHolderType
                    if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
                        var result2 = result.$$unwrapTrustedValue();
                        if (result2.substr(0, 2) === '@:') {
                            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
                        }
                    } else if (result.substr(0, 2) === '@:') {
                        return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
                    }
                    Interpolator.setLocale($uses);
                }

                return result;
            };


            /**
             * @name translateByHandler
             * @private
             *
             * Translate by missing translation handler.
             *
             * @param translationId
             * @param interpolateParams
             * @param defaultTranslationText
             * @param sanitizeStrategy sanitize strategy override
             *
             * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
             * absent
             */
            var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
                // If we have a handler factory - we might also call it here to determine if it provides
                // a default text for a translationid that can't be found anywhere in our tables
                if ($missingTranslationHandlerFactory) {
                    return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
                } else {
                    return translationId;
                }
            };

            /**
             * @name resolveForFallbackLanguage
             * @private
             *
             * Recursive helper function for fallbackTranslation that will sequentially look
             * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
             *
             * @param fallbackLanguageIndex
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param defaultTranslationText
             * @param sanitizeStrategy
             * @returns {Q.promise} Promise that will resolve to the translation.
             */
            var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
                var deferred = $q.defer();

                if (fallbackLanguageIndex < $fallbackLanguage.length) {
                    var langKey = $fallbackLanguage[fallbackLanguageIndex];
                    getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
                        function (data) {
                            deferred.resolve(data);
                        },
                        function () {
                            // Look in the next fallback language for a translation.
                            // It delays the resolving by passing another promise to resolve.
                            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                        }
                    );
                } else {
                    // No translation found in any fallback language
                    // if a default translation text is set in the directive, then return this as a result
                    if (defaultTranslationText) {
                        deferred.resolve(defaultTranslationText);
                    } else {
                        var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

                        // if no default translation is set and an error handler is defined, send it to the handler
                        // and then return the result if it isn't undefined
                        if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
                            deferred.resolve(missingTranslationHandlerTranslation);
                        } else {
                            deferred.reject(applyNotFoundIndicators(translationId));
                        }
                    }
                }
                return deferred.promise;
            };

            /**
             * @name resolveForFallbackLanguageInstant
             * @private
             *
             * Recursive helper function for fallbackTranslation that will sequentially look
             * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
             *
             * @param fallbackLanguageIndex
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy
             * @returns {string} translation
             */
            var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                var result;

                if (fallbackLanguageIndex < $fallbackLanguage.length) {
                    var langKey = $fallbackLanguage[fallbackLanguageIndex];
                    result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
                    if (!result && result !== '') {
                        result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
                    }
                }
                return result;
            };

            /**
             * Translates with the usage of the fallback languages.
             *
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param defaultTranslationText
             * @param sanitizeStrategy
             * @returns {Q.promise} Promise, that resolves to the translation.
             */
            var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
                // Start with the fallbackLanguage with index 0
                return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
            };

            /**
             * Translates with the usage of the fallback languages.
             *
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy
             * @returns {String} translation
             */
            var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                // Start with the fallbackLanguage with index 0
                return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
            };

            var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

                var deferred = $q.defer();

                var table = uses ? $translationTable[uses] : $translationTable,
                    Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

                // if the translation id exists, we can just interpolate it
                if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
                    var translation = table[translationId];

                    // If using link, rerun $translate with linked translationId and return it
                    if (translation.substr(0, 2) === '@:') {

                        $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
                            .then(deferred.resolve, deferred.reject);
                    } else {
                        //
                        var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
                        resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
                        deferred.resolve(resolvedTranslation);
                    }
                } else {
                    var missingTranslationHandlerTranslation;
                    // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
                    if ($missingTranslationHandlerFactory && !pendingLoader) {
                        missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
                    }

                    // since we couldn't translate the inital requested translation id,
                    // we try it now with one or more fallback languages, if fallback language(s) is
                    // configured.
                    if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                        fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
                            .then(function (translation) {
                                deferred.resolve(translation);
                            }, function (_translationId) {
                                deferred.reject(applyNotFoundIndicators(_translationId));
                            });
                    } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                        // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        if (defaultTranslationText) {
                            deferred.resolve(defaultTranslationText);
                        } else {
                            deferred.resolve(missingTranslationHandlerTranslation);
                        }
                    } else {
                        if (defaultTranslationText) {
                            deferred.resolve(defaultTranslationText);
                        } else {
                            deferred.reject(applyNotFoundIndicators(translationId));
                        }
                    }
                }
                return deferred.promise;
            };

            var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

                var result, table = uses ? $translationTable[uses] : $translationTable,
                    Interpolator = defaultInterpolator;

                // if the interpolation id exists use custom interpolator
                if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
                    Interpolator = interpolatorHashMap[interpolationId];
                }

                // if the translation id exists, we can just interpolate it
                if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
                    var translation = table[translationId];

                    // If using link, rerun $translate with linked translationId and return it
                    if (translation.substr(0, 2) === '@:') {
                        result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
                    } else {
                        result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
                        result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
                    }
                } else {
                    var missingTranslationHandlerTranslation;
                    // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
                    if ($missingTranslationHandlerFactory && !pendingLoader) {
                        missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
                    }

                    // since we couldn't translate the inital requested translation id,
                    // we try it now with one or more fallback languages, if fallback language(s) is
                    // configured.
                    if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                        fallbackIndex = 0;
                        result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
                    } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                        // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        result = missingTranslationHandlerTranslation;
                    } else {
                        result = applyNotFoundIndicators(translationId);
                    }
                }

                return result;
            };

            var clearNextLangAndPromise = function (key) {
                if ($nextLang === key) {
                    $nextLang = undefined;
                }
                langPromises[key] = undefined;
            };

            var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
                var fn = postProcessFn;

                if (fn) {

                    if (typeof(fn) === 'string') {
                        // getting on-demand instance
                        fn = $injector.get(fn);
                    }
                    if (fn) {
                        return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
                    }
                }

                return resolvedTranslation;
            };

            var loadTranslationsIfMissing = function (key) {
                if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
                    langPromises[key] = loadAsync(key).then(function (translation) {
                        translations(translation.key, translation.table);
                        return translation;
                    });
                }
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#preferredLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the language key for the preferred language.
             *
             * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
             *
             * @return {string} preferred language key
             */
            $translate.preferredLanguage = function (langKey) {
                if (langKey) {
                    setupPreferredLanguage(langKey);
                }
                return $preferredLanguage;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#cloakClassName
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the configured class name for `translate-cloak` directive.
             *
             * @return {string} cloakClassName
             */
            $translate.cloakClassName = function () {
                return $cloakClassName;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#nestedObjectDelimeter
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the configured delimiter for nested namespaces.
             *
             * @return {string} nestedObjectDelimeter
             */
            $translate.nestedObjectDelimeter = function () {
                return $nestedObjectDelimeter;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#fallbackLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the language key for the fallback languages or sets a new fallback stack.
             * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
             *
             * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
             *
             * @return {string||array} fallback language key
             */
            $translate.fallbackLanguage = function (langKey) {
                if (langKey !== undefined && langKey !== null) {
                    fallbackStack(langKey);

                    // as we might have an async loader initiated and a new translation language might have been defined
                    // we need to add the promise to the stack also. So - iterate.
                    if ($loaderFactory) {
                        if ($fallbackLanguage && $fallbackLanguage.length) {
                            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                                if (!langPromises[$fallbackLanguage[i]]) {
                                    langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
                                }
                            }
                        }
                    }
                    $translate.use($translate.use());
                }
                if ($fallbackWasString) {
                    return $fallbackLanguage[0];
                } else {
                    return $fallbackLanguage;
                }

            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#useFallbackLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Sets the first key of the fallback language stack to be used for translation.
             * Therefore all languages in the fallback array BEFORE this key will be skipped!
             *
             * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
             * get back to the whole stack
             */
            $translate.useFallbackLanguage = function (langKey) {
                if (langKey !== undefined && langKey !== null) {
                    if (!langKey) {
                        startFallbackIteration = 0;
                    } else {
                        var langKeyPosition = indexOf($fallbackLanguage, langKey);
                        if (langKeyPosition > -1) {
                            startFallbackIteration = langKeyPosition;
                        }
                    }

                }

            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#proposedLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the language key of language that is currently loaded asynchronously.
             *
             * @return {string} language key
             */
            $translate.proposedLanguage = function () {
                return $nextLang;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#storage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns registered storage.
             *
             * @return {object} Storage
             */
            $translate.storage = function () {
                return Storage;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#negotiateLocale
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns a language key based on available languages and language aliases. If a
             * language key cannot be resolved, returns undefined.
             *
             * If no or a falsy key is given, returns undefined.
             *
             * @param {string} [key] Language key
             * @return {string|undefined} Language key or undefined if no language key is found.
             */
            $translate.negotiateLocale = negotiateLocale;

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#use
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Tells angular-translate which language to use by given language key. This method is
             * used to change language at runtime. It also takes care of storing the language
             * key in a configured store to let your app remember the choosed language.
             *
             * When trying to 'use' a language which isn't available it tries to load it
             * asynchronously with registered loaders.
             *
             * Returns promise object with loaded language file data or string of the currently used language.
             *
             * If no or a falsy key is given it returns the currently used language key.
             * The returned string will be ```undefined``` if setting up $translate hasn't finished.
             * @example
             * $translate.use("en_US").then(function(data){
             *   $scope.text = $translate("HELLO");
             * });
             *
             * @param {string=} key Language key
             * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
             */
            $translate.use = function (key) {
                if (!key) {
                    return $uses;
                }

                var deferred = $q.defer();
                deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

                $rootScope.$emit('$translateChangeStart', {language : key});

                // Try to get the aliased language key
                var aliasedKey = negotiateLocale(key);
                // Ensure only registered language keys will be loaded
                if ($availableLanguageKeys.length > 0 && !aliasedKey) {
                    return $q.reject(key);
                }

                if (aliasedKey) {
                    key = aliasedKey;
                }

                // if there isn't a translation table for the language we've requested,
                // we load it asynchronously
                $nextLang = key;
                if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
                    langPromises[key] = loadAsync(key).then(function (translation) {
                        translations(translation.key, translation.table);
                        deferred.resolve(translation.key);
                        if ($nextLang === key) {
                            useLanguage(translation.key);
                        }
                        return translation;
                    }, function (key) {
                        $rootScope.$emit('$translateChangeError', {language : key});
                        deferred.reject(key);
                        $rootScope.$emit('$translateChangeEnd', {language : key});
                        return $q.reject(key);
                    });
                    langPromises[key]['finally'](function () {
                        clearNextLangAndPromise(key);
                    })['catch'](angular.noop); // we don't care about errors (clearing)
                } else if (langPromises[key]) {
                    // we are already loading this asynchronously
                    // resolve our new deferred when the old langPromise is resolved
                    langPromises[key].then(function (translation) {
                        if ($nextLang === translation.key) {
                            useLanguage(translation.key);
                        }
                        deferred.resolve(translation.key);
                        return translation;
                    }, function (key) {
                        // find first available fallback language if that request has failed
                        if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
                            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
                        } else {
                            return deferred.reject(key);
                        }
                    });
                } else {
                    deferred.resolve(key);
                    useLanguage(key);
                }

                return deferred.promise;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#resolveClientLocale
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
             *
             * @returns {string} the current client/browser language key
             */
            $translate.resolveClientLocale = function () {
                return getLocale();
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#storageKey
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the key for the storage.
             *
             * @return {string} storage key
             */
            $translate.storageKey = function () {
                return storageKey();
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isPostCompilingEnabled
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether post compiling is enabled or not
             *
             * @return {bool} storage key
             */
            $translate.isPostCompilingEnabled = function () {
                return $postCompilingEnabled;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether force async reload is enabled or not
             *
             * @return {boolean} forceAsyncReload value
             */
            $translate.isForceAsyncReloadEnabled = function () {
                return $forceAsyncReloadEnabled;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isKeepContent
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether keepContent or not
             *
             * @return {boolean} keepContent value
             */
            $translate.isKeepContent = function () {
                return $keepContent;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#refresh
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
             * the module will drop all existent translation tables and load new version of those which
             * are currently in use.
             *
             * Refresh means that the module will drop target translation table and try to load it again.
             *
             * In case there are no loaders registered the refresh() method will throw an Error.
             *
             * If the module is able to refresh translation tables refresh() method will broadcast
             * $translateRefreshStart and $translateRefreshEnd events.
             *
             * @example
             * // this will drop all currently existent translation tables and reload those which are
             * // currently in use
             * $translate.refresh();
             * // this will refresh a translation table for the en_US language
             * $translate.refresh('en_US');
             *
             * @param {string} langKey A language key of the table, which has to be refreshed
             *
             * @return {promise} Promise, which will be resolved in case a translation tables refreshing
             * process is finished successfully, and reject if not.
             */
            $translate.refresh = function (langKey) {
                if (!$loaderFactory) {
                    throw new Error('Couldn\'t refresh translation table, no loader registered!');
                }

                $rootScope.$emit('$translateRefreshStart', {language : langKey});

                var deferred = $q.defer(), updatedLanguages = {};

                //private helper
                function loadNewData(languageKey) {
                    var promise = loadAsync(languageKey);
                    //update the load promise cache for this language
                    langPromises[languageKey] = promise;
                    //register a data handler for the promise
                    promise.then(function (data) {
                            //clear the cache for this language
                            $translationTable[languageKey] = {};
                            //add the new data for this language
                            translations(languageKey, data.table);
                            //track that we updated this language
                            updatedLanguages[languageKey] = true;
                        },
                        //handle rejection to appease the $q validation
                        angular.noop);
                    return promise;
                }

                //set up post-processing
                deferred.promise.then(
                    function () {
                        for (var key in $translationTable) {
                            if ($translationTable.hasOwnProperty(key)) {
                                //delete cache entries that were not updated
                                if (!(key in updatedLanguages)) {
                                    delete $translationTable[key];
                                }
                            }
                        }
                        if ($uses) {
                            useLanguage($uses);
                        }
                    },
                    //handle rejection to appease the $q validation
                    angular.noop
                )['finally'](
                    function () {
                        $rootScope.$emit('$translateRefreshEnd', {language : langKey});
                    }
                );

                if (!langKey) {
                    // if there's no language key specified we refresh ALL THE THINGS!
                    var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
                    if ($uses && languagesToReload.indexOf($uses) === -1) {
                        languagesToReload.push($uses);
                    }
                    $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

                } else if ($translationTable[langKey]) {
                    //just refresh the specified language cache
                    loadNewData(langKey).then(deferred.resolve, deferred.reject);

                } else {
                    deferred.reject();
                }

                return deferred.promise;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#instant
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns a translation instantly from the internal state of loaded translation. All rules
             * regarding the current language, the preferred language of even fallback languages will be
             * used except any promise handling. If a language was not found, an asynchronous loading
             * will be invoked in the background.
             *
             * @param {string|array} translationId A token which represents a translation id
             *                                     This can be optionally an array of translation ids which
             *                                     results that the function's promise returns an object where
             *                                     each key is the translation id and the value the translation.
             * @param {object=} [interpolateParams={}] Params
             * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
             * @param {string=} [forceLanguage=false] A language to be used instead of the current language
             * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
             *
             * @return {string|object} translation
             */
            $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

                // we don't want to re-negotiate $uses
                var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
                    (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

                // Detect undefined and null values to shorten the execution and prevent exceptions
                if (translationId === null || angular.isUndefined(translationId)) {
                    return translationId;
                }

                // Check forceLanguage is present
                if (forceLanguage) {
                    loadTranslationsIfMissing(forceLanguage);
                }

                // Duck detection: If the first argument is an array, a bunch of translations was requested.
                // The result is an object.
                if (angular.isArray(translationId)) {
                    var results = {};
                    for (var i = 0, c = translationId.length; i < c; i++) {
                        results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
                    }
                    return results;
                }

                // We discarded unacceptable values. So we just need to verify if translationId is empty String
                if (angular.isString(translationId) && translationId.length < 1) {
                    return translationId;
                }

                // trim off any whitespace
                if (translationId) {
                    translationId = trim.apply(translationId);
                }

                var result, possibleLangKeys = [];
                if ($preferredLanguage) {
                    possibleLangKeys.push($preferredLanguage);
                }
                if (uses) {
                    possibleLangKeys.push(uses);
                }
                if ($fallbackLanguage && $fallbackLanguage.length) {
                    possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
                }
                for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
                    var possibleLangKey = possibleLangKeys[j];
                    if ($translationTable[possibleLangKey]) {
                        if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
                            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
                        }
                    }
                    if (typeof result !== 'undefined') {
                        break;
                    }
                }

                if (!result && result !== '') {
                    if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
                        result = applyNotFoundIndicators(translationId);
                    } else {
                        // Return translation of default interpolator if not found anything.
                        result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

                        // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        var missingTranslationHandlerTranslation;
                        if ($missingTranslationHandlerFactory && !pendingLoader) {
                            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
                        }

                        if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                            result = missingTranslationHandlerTranslation;
                        }
                    }
                }

                return result;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#versionInfo
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the current version information for the angular-translate library
             *
             * @return {string} angular-translate version
             */
            $translate.versionInfo = function () {
                return version;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#loaderCache
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the defined loaderCache.
             *
             * @return {boolean|string|object} current value of loaderCache
             */
            $translate.loaderCache = function () {
                return loaderCache;
            };

            // internal purpose only
            $translate.directivePriority = function () {
                return directivePriority;
            };

            // internal purpose only
            $translate.statefulFilter = function () {
                return statefulFilter;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isReady
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether the service is "ready" to translate (i.e. loading 1st language).
             *
             * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
             *
             * @return {boolean} current value of ready
             */
            $translate.isReady = function () {
                return $isReady;
            };

            var $onReadyDeferred = $q.defer();
            $onReadyDeferred.promise.then(function () {
                $isReady = true;
            });

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#onReady
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
             *
             * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
             *
             * @param {Function=} fn Function to invoke when service is ready
             * @return {object} Promise resolved when service is ready
             */
            $translate.onReady = function (fn) {
                var deferred = $q.defer();
                if (angular.isFunction(fn)) {
                    deferred.promise.then(fn);
                }
                if ($isReady) {
                    deferred.resolve();
                } else {
                    $onReadyDeferred.promise.then(deferred.resolve);
                }
                return deferred.promise;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * This function simply returns the registered language keys being defined before in the config phase
             * With this, an application can use the array to provide a language selection dropdown or similar
             * without any additional effort
             *
             * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
             */
            $translate.getAvailableLanguageKeys = function () {
                if ($availableLanguageKeys.length > 0) {
                    return $availableLanguageKeys;
                }
                return null;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#getTranslationTable
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns translation table by the given language key.
             *
             * Unless a language is provided it returns a translation table of the current one.
             * Note: If translation dictionary is currently downloading or in progress
             * it will return null.
             *
             * @param {string} langKey A token which represents a translation id
             *
             * @return {object} a copy of angular-translate $translationTable
             */
            $translate.getTranslationTable = function (langKey) {
                langKey = langKey || $translate.use();
                if (langKey && $translationTable[langKey]) {
                    return angular.copy($translationTable[langKey]);
                }
                return null;
            };

            // Whenever $translateReady is being fired, this will ensure the state of $isReady
            var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
                $onReadyDeferred.resolve();
                globalOnReadyListener(); // one time only
                globalOnReadyListener = null;
            });
            var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
                $onReadyDeferred.resolve();
                globalOnChangeListener(); // one time only
                globalOnChangeListener = null;
            });

            if ($loaderFactory) {

                // If at least one async loader is defined and there are no
                // (default) translations available we should try to load them.
                if (angular.equals($translationTable, {})) {
                    if ($translate.use()) {
                        $translate.use($translate.use());
                    }
                }

                // Also, if there are any fallback language registered, we start
                // loading them asynchronously as soon as we can.
                if ($fallbackLanguage && $fallbackLanguage.length) {
                    var processAsyncResult = function (translation) {
                        translations(translation.key, translation.table);
                        $rootScope.$emit('$translateChangeEnd', {language : translation.key});
                        return translation;
                    };
                    for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                        var fallbackLanguageId = $fallbackLanguage[i];
                        if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
                            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
                        }
                    }
                }
            } else {
                $rootScope.$emit('$translateReady', {language : $translate.use()});
            }

            return $translate;
        }];
    }

    $translate.displayName = 'displayName';

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateDefaultInterpolation
     * @requires $interpolate
     *
     * @description
     * Uses angular's `$interpolate` services to interpolate strings against some values.
     *
     * Be aware to configure a proper sanitization strategy.
     *
     * See also:
     * * {@link pascalprecht.translate.$translateSanitization}
     *
     * @return {object} $translateDefaultInterpolation Interpolator service
     */
    angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

    function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

        'use strict';

        var $translateInterpolator = {},
            $locale,
            $identifier = 'default';

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Sets current locale (this is currently not use in this interpolation).
         *
         * @param {string} locale Language key or locale.
         */
        $translateInterpolator.setLocale = function (locale) {
            $locale = locale;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Returns an identifier for this interpolation service.
         *
         * @returns {string} $identifier
         */
        $translateInterpolator.getInterpolationIdentifier = function () {
            return $identifier;
        };

        /**
         * @deprecated will be removed in 3.0
         * @see {@link pascalprecht.translate.$translateSanitization}
         */
        $translateInterpolator.useSanitizeValueStrategy = function (value) {
            $translateSanitization.useStrategy(value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Interpolates given value agains given interpolate params using angulars
         * `$interpolate` service.
         *
         * Since AngularJS 1.5, `value` must not be a string but can be anything input.
         *
         * @param {string} value translation
         * @param {object} [interpolationParams={}] interpolation params
         * @param {string} [context=undefined] current context (filter, directive, service)
         * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
         * @param {string} translationId current translationId
         *
         * @returns {string} interpolated string
         */
        $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
            interpolationParams = interpolationParams || {};
            interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

            var interpolatedText;
            if (angular.isNumber(value)) {
                // numbers are safe
                interpolatedText = '' + value;
            } else if (angular.isString(value)) {
                // strings must be interpolated (that's the job here)
                interpolatedText = $interpolate(value)(interpolationParams);
                interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
            } else {
                // neither a number or a string, cant interpolate => empty string
                interpolatedText = '';
            }

            return interpolatedText;
        };

        return $translateInterpolator;
    }

    $translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

    angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc directive
     * @name pascalprecht.translate.directive:translate
     * @requires $interpolate,
     * @requires $compile,
     * @requires $parse,
     * @requires $rootScope
     * @restrict AE
     *
     * @description
     * Translates given translation id either through attribute or DOM content.
     * Internally it uses $translate service to translate the translation id. It possible to
     * pass an optional `translate-values` object literal as string into translation id.
     *
     * @param {string=} translate Translation id which could be either string or interpolated string.
     * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
     * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
     * @param {string=} translate-default will be used unless translation was successful
     * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
     * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
     * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
     *
     * @example
     <example module="ngView">
     <file name="index.html">
     <div ng-controller="TranslateCtrl">

     <pre translate="TRANSLATION_ID"></pre>
     <pre translate>TRANSLATION_ID</pre>
     <pre translate translate-attr-title="TRANSLATION_ID"></pre>
     <pre translate="{{translationId}}"></pre>
     <pre translate>{{translationId}}</pre>
     <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
     <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
     <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
     <pre translate translate-values="{{values}}">WITH_VALUES</pre>
     <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
     <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

     </div>
     </file>
     <file name="script.js">
     angular.module('ngView', ['pascalprecht.translate'])

     .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

     angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
     </file>
     <file name="scenario.js">
     it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
     </file>
     </example>
     */
        .directive('translate', translateDirective);
    function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

        'use strict';

        /**
         * @name trim
         * @private
         *
         * @description
         * trim polyfill
         *
         * @returns {string} The string stripped of whitespace from both ends
         */
        var trim = function() {
            return this.toString().replace(/^\s+|\s+$/g, '');
        };

        /**
         * @name lowercase
         * @private
         *
         * @description
         * Return the lowercase string only if the type is string
         *
         * @returns {string} The string all in lowercase
         */
        var lowercase = function (string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        };

        return {
            restrict: 'AE',
            scope: true,
            priority: $translate.directivePriority(),
            compile: function (tElement, tAttr) {

                var translateValuesExist = (tAttr.translateValues) ?
                    tAttr.translateValues : undefined;

                var translateInterpolation = (tAttr.translateInterpolation) ?
                    tAttr.translateInterpolation : undefined;

                var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
                    tAttr.translateSanitizeStrategy : undefined;

                var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

                var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
                    watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

                return function linkFn(scope, iElement, iAttr) {

                    scope.interpolateParams = {};
                    scope.preText = '';
                    scope.postText = '';
                    scope.translateNamespace = getTranslateNamespace(scope);
                    var translationIds = {};

                    var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
                        // initial setup
                        if (iAttr.translateValues) {
                            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
                        }
                        // initially fetch all attributes if existing and fill the params
                        if (translateValueExist) {
                            for (var attr in tAttr) {
                                if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                                    var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                                    interpolateParams[attributeName] = tAttr[attr];
                                }
                            }
                        }
                    };

                    // Ensures any change of the attribute "translate" containing the id will
                    // be re-stored to the scope's "translationId".
                    // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
                    var observeElementTranslation = function (translationId) {

                        // Remove any old watcher
                        if (angular.isFunction(observeElementTranslation._unwatchOld)) {
                            observeElementTranslation._unwatchOld();
                            observeElementTranslation._unwatchOld = undefined;
                        }

                        if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
                            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');

                            // Resolve translation id by inner html if required
                            var interpolateMatches = iElementText.match(interpolateRegExp);
                            // Interpolate translation id if required
                            if (angular.isArray(interpolateMatches)) {
                                scope.preText = interpolateMatches[1];
                                scope.postText = interpolateMatches[3];
                                translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
                                var watcherMatches = iElementText.match(watcherRegExp);
                                if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                                    observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                                        translationIds.translate = newValue;
                                        updateTranslations();
                                    });
                                }
                            } else {
                                // do not assigne the translation id if it is empty.
                                translationIds.translate = !iElementText ? undefined : iElementText;
                            }
                        } else {
                            translationIds.translate = translationId;
                        }
                        updateTranslations();
                    };

                    var observeAttributeTranslation = function (translateAttr) {
                        iAttr.$observe(translateAttr, function (translationId) {
                            translationIds[translateAttr] = translationId;
                            updateTranslations();
                        });
                    };

                    // initial setup with values
                    initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

                    var firstAttributeChangedEvent = true;
                    iAttr.$observe('translate', function (translationId) {
                        if (typeof translationId === 'undefined') {
                            // case of element "<translate>xyz</translate>"
                            observeElementTranslation('');
                        } else {
                            // case of regular attribute
                            if (translationId !== '' || !firstAttributeChangedEvent) {
                                translationIds.translate = translationId;
                                updateTranslations();
                            }
                        }
                        firstAttributeChangedEvent = false;
                    });

                    for (var translateAttr in iAttr) {
                        if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
                            observeAttributeTranslation(translateAttr);
                        }
                    }

                    iAttr.$observe('translateDefault', function (value) {
                        scope.defaultText = value;
                        updateTranslations();
                    });

                    if (translateSanitizeStrategyExist) {
                        iAttr.$observe('translateSanitizeStrategy', function (value) {
                            scope.sanitizeStrategy = $parse(value)(scope.$parent);
                            updateTranslations();
                        });
                    }

                    if (translateValuesExist) {
                        iAttr.$observe('translateValues', function (interpolateParams) {
                            if (interpolateParams) {
                                scope.$parent.$watch(function () {
                                    angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                                });
                            }
                        });
                    }

                    if (translateValueExist) {
                        var observeValueAttribute = function (attrName) {
                            iAttr.$observe(attrName, function (value) {
                                var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
                                scope.interpolateParams[attributeName] = value;
                            });
                        };
                        for (var attr in iAttr) {
                            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                                observeValueAttribute(attr);
                            }
                        }
                    }

                    // Master update function
                    var updateTranslations = function () {
                        for (var key in translationIds) {
                            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
                                updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
                            }
                        }
                    };

                    // Put translation processing function outside loop
                    var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
                        if (translationId) {
                            // if translation id starts with '.' and translateNamespace given, prepend namespace
                            if (translateNamespace && translationId.charAt(0) === '.') {
                                translationId = translateNamespace + translationId;
                            }

                            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
                                .then(function (translation) {
                                    applyTranslation(translation, scope, true, translateAttr);
                                }, function (translationId) {
                                    applyTranslation(translationId, scope, false, translateAttr);
                                });
                        } else {
                            // as an empty string cannot be translated, we can solve this using successful=false
                            applyTranslation(translationId, scope, false, translateAttr);
                        }
                    };

                    var applyTranslation = function (value, scope, successful, translateAttr) {
                        if (!successful) {
                            if (typeof scope.defaultText !== 'undefined') {
                                value = scope.defaultText;
                            }
                        }
                        if (translateAttr === 'translate') {
                            // default translate into innerHTML
                            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
                                iElement.empty().append(scope.preText + value + scope.postText);
                            }
                            var globallyEnabled = $translate.isPostCompilingEnabled();
                            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
                            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
                            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
                                $compile(iElement.contents())(scope);
                            }
                        } else {
                            // translate attribute
                            var attributeName = iAttr.$attr[translateAttr];
                            if (attributeName.substr(0, 5) === 'data-') {
                                // ensure html5 data prefix is stripped
                                attributeName = attributeName.substr(5);
                            }
                            attributeName = attributeName.substr(15);
                            iElement.attr(attributeName, value);
                        }
                    };

                    if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
                        scope.$watch('interpolateParams', updateTranslations, true);
                    }

                    // Replaced watcher on translateLanguage with event listener
                    scope.$on('translateLanguageChanged', updateTranslations);

                    // Ensures the text will be refreshed after the current language was changed
                    // w/ $translate.use(...)
                    var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

                    // ensure translation will be looked up at least one
                    if (iElement.text().length) {
                        if (iAttr.translate) {
                            observeElementTranslation(iAttr.translate);
                        } else {
                            observeElementTranslation('');
                        }
                    } else if (iAttr.translate) {
                        // ensure attribute will be not skipped
                        observeElementTranslation(iAttr.translate);
                    }
                    updateTranslations();
                    scope.$on('$destroy', unbind);
                };
            }
        };
    }

    /**
     * Returns the scope's namespace.
     * @private
     * @param scope
     * @returns {string}
     */
    function getTranslateNamespace(scope) {
        'use strict';
        if (scope.translateNamespace) {
            return scope.translateNamespace;
        }
        if (scope.$parent) {
            return getTranslateNamespace(scope.$parent);
        }
    }

    translateDirective.displayName = 'translateDirective';

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc directive
     * @name pascalprecht.translate.directive:translate-attr
     * @restrict A
     *
     * @description
     * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
     * Internally it uses `translate` service to translate translation id. It possible to
     * pass an optional `translate-values` object literal as string into translation id.
     *
     * @param {string=} translate-attr Object literal mapping attributes to translation ids.
     * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
     * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
     *
     * @example
     <example module="ngView">
     <file name="index.html">
     <div ng-controller="TranslateCtrl">

     <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

     </div>
     </file>
     <file name="script.js">
     angular.module('ngView', ['pascalprecht.translate'])

     .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

     angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
     </file>
     <file name="scenario.js">
     it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
     </file>
     </example>
     */
        .directive('translateAttr', translateAttrDirective);
    function translateAttrDirective($translate, $rootScope) {

        'use strict';

        return {
            restrict: 'A',
            priority: $translate.directivePriority(),
            link: function linkFn(scope, element, attr) {

                var translateAttr,
                    translateValues,
                    translateSanitizeStrategy,
                    previousAttributes = {};

                // Main update translations function
                var updateTranslations = function () {
                    angular.forEach(translateAttr, function (translationId, attributeName) {
                        if (!translationId) {
                            return;
                        }
                        previousAttributes[attributeName] = true;

                        // if translation id starts with '.' and translateNamespace given, prepend namespace
                        if (scope.translateNamespace && translationId.charAt(0) === '.') {
                            translationId = scope.translateNamespace + translationId;
                        }
                        $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
                            .then(function (translation) {
                                element.attr(attributeName, translation);
                            }, function (translationId) {
                                element.attr(attributeName, translationId);
                            });
                    });

                    // Removing unused attributes that were previously used
                    angular.forEach(previousAttributes, function (flag, attributeName) {
                        if (!translateAttr[attributeName]) {
                            element.removeAttr(attributeName);
                            delete previousAttributes[attributeName];
                        }
                    });
                };

                // Watch for attribute changes
                watchAttribute(
                    scope,
                    attr.translateAttr,
                    function (newValue) { translateAttr = newValue; },
                    updateTranslations
                );
                // Watch for value changes
                watchAttribute(
                    scope,
                    attr.translateValues,
                    function (newValue) { translateValues = newValue; },
                    updateTranslations
                );
                // Watch for sanitize strategy changes
                watchAttribute(
                    scope,
                    attr.translateSanitizeStrategy,
                    function (newValue) { translateSanitizeStrategy = newValue; },
                    updateTranslations
                );

                if (attr.translateValues) {
                    scope.$watch(attr.translateValues, updateTranslations, true);
                }

                // Replaced watcher on translateLanguage with event listener
                scope.$on('translateLanguageChanged', updateTranslations);

                // Ensures the text will be refreshed after the current language was changed
                // w/ $translate.use(...)
                var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

                updateTranslations();
                scope.$on('$destroy', unbind);
            }
        };
    }

    function watchAttribute(scope, attribute, valueCallback, changeCallback) {
        'use strict';
        if (!attribute) {
            return;
        }
        if (attribute.substr(0, 2) === '::') {
            attribute = attribute.substr(2);
        } else {
            scope.$watch(attribute, function(newValue) {
                valueCallback(newValue);
                changeCallback();
            }, true);
        }
        valueCallback(scope.$eval(attribute));
    }

    translateAttrDirective.displayName = 'translateAttrDirective';

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc directive
     * @name pascalprecht.translate.directive:translateCloak
     * @requires $translate
     * @restrict A
     *
     * $description
     * Adds a `translate-cloak` class name to the given element where this directive
     * is applied initially and removes it, once a loader has finished loading.
     *
     * This directive can be used to prevent initial flickering when loading translation
     * data asynchronously.
     *
     * The class name is defined in
     * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
     *
     * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
     *                                  or hiding the cloak. Basically it relies on the translation
     *                                  resolve.
     */
        .directive('translateCloak', translateCloakDirective);

    function translateCloakDirective($translate, $rootScope) {

        'use strict';

        return {
            compile : function (tElement) {
                var applyCloak = function (element) {
                        element.addClass($translate.cloakClassName());
                    },
                    removeCloak = function (element) {
                        element.removeClass($translate.cloakClassName());
                    };
                applyCloak(tElement);

                return function linkFn(scope, iElement, iAttr) {
                    //Create bound functions that incorporate the active DOM element.
                    var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
                    if (iAttr.translateCloak && iAttr.translateCloak.length) {
                        // Register a watcher for the defined translation allowing a fine tuned cloak
                        iAttr.$observe('translateCloak', function (translationId) {
                            $translate(translationId).then(iRemoveCloak, iApplyCloak);
                        });
                        $rootScope.$on('$translateChangeSuccess', function () {
                            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
                        });
                    } else {
                        $translate.onReady(iRemoveCloak);
                    }
                };
            }
        };
    }

    translateCloakDirective.displayName = 'translateCloakDirective';

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc directive
     * @name pascalprecht.translate.directive:translateNamespace
     * @restrict A
     *
     * @description
     * Translates given translation id either through attribute or DOM content.
     * Internally it uses `translate` filter to translate translation id. It is possible to
     * pass an optional `translate-values` object literal as string into translation id.
     *
     * @param {string=} translate namespace name which could be either string or interpolated string.
     *
     * @example
     <example module="ngView">
     <file name="index.html">
     <div translate-namespace="CONTENT">

     <div>
     <h1 translate>.HEADERS.TITLE</h1>
     <h1 translate>.HEADERS.WELCOME</h1>
     </div>

     <div translate-namespace=".HEADERS">
     <h1 translate>.TITLE</h1>
     <h1 translate>.WELCOME</h1>
     </div>

     </div>
     </file>
     <file name="script.js">
     angular.module('ngView', ['pascalprecht.translate'])

     .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

     </file>
     </example>
     */
        .directive('translateNamespace', translateNamespaceDirective);

    function translateNamespaceDirective() {

        'use strict';

        return {
            restrict: 'A',
            scope: true,
            compile: function () {
                return {
                    pre: function (scope, iElement, iAttrs) {
                        scope.translateNamespace = _getTranslateNamespace(scope);

                        if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
                            scope.translateNamespace += iAttrs.translateNamespace;
                        } else {
                            scope.translateNamespace = iAttrs.translateNamespace;
                        }
                    }
                };
            }
        };
    }

    /**
     * Returns the scope's namespace.
     * @private
     * @param scope
     * @returns {string}
     */
    function _getTranslateNamespace(scope) {
        'use strict';
        if (scope.translateNamespace) {
            return scope.translateNamespace;
        }
        if (scope.$parent) {
            return _getTranslateNamespace(scope.$parent);
        }
    }

    translateNamespaceDirective.displayName = 'translateNamespaceDirective';

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc directive
     * @name pascalprecht.translate.directive:translateLanguage
     * @restrict A
     *
     * @description
     * Forces the language to the directives in the underlying scope.
     *
     * @param {string=} translate language that will be negotiated.
     *
     * @example
     <example module="ngView">
     <file name="index.html">
     <div>

     <div>
     <h1 translate>HELLO</h1>
     </div>

     <div translate-language="de">
     <h1 translate>HELLO</h1>
     </div>

     </div>
     </file>
     <file name="script.js">
     angular.module('ngView', ['pascalprecht.translate'])

     .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

     </file>
     </example>
     */
        .directive('translateLanguage', translateLanguageDirective);

    function translateLanguageDirective() {

        'use strict';

        return {
            restrict: 'A',
            scope: true,
            compile: function () {
                return function linkFn(scope, iElement, iAttrs) {

                    iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
                        scope.translateLanguage = newTranslateLanguage;
                    });

                    scope.$watch('translateLanguage', function(){
                        scope.$broadcast('translateLanguageChanged');
                    });
                };
            }
        };
    }

    translateLanguageDirective.displayName = 'translateLanguageDirective';

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc filter
     * @name pascalprecht.translate.filter:translate
     * @requires $parse
     * @requires pascalprecht.translate.$translate
     * @function
     *
     * @description
     * Uses `$translate` service to translate contents. Accepts interpolate parameters
     * to pass dynamized values though translation.
     *
     * @param {string} translationId A translation id to be translated.
     * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
     *
     * @returns {string} Translated text.
     *
     * @example
     <example module="ngView">
     <file name="index.html">
     <div ng-controller="TranslateCtrl">

     <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
     <pre>{{ translationId | translate }}</pre>
     <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
     <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

     </div>
     </file>
     <file name="script.js">
     angular.module('ngView', ['pascalprecht.translate'])

     .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

     angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
     </file>
     </example>
     */
        .filter('translate', translateFilterFactory);

    function translateFilterFactory($parse, $translate) {

        'use strict';

        var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
            if (!angular.isObject(interpolateParams)) {
                var ctx = this || {
                    '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
                };
                interpolateParams = $parse(interpolateParams)(ctx);
            }

            return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
        };

        if ($translate.statefulFilter()) {
            translateFilter.$stateful = true;
        }

        return translateFilter;
    }

    translateFilterFactory.displayName = 'translateFilterFactory';

    angular.module('pascalprecht.translate')

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translationCache
     * @requires $cacheFactory
     *
     * @description
     * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
     * can load translation tables directly into the cache by consuming the
     * `$translationCache` service directly.
     *
     * @return {object} $cacheFactory object.
     */
        .factory('$translationCache', $translationCache);

    function $translationCache($cacheFactory) {

        'use strict';

        return $cacheFactory('translations');
    }

    $translationCache.displayName = '$translationCache';
    return 'pascalprecht.translate';

}));

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config($provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);

  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      // preloader.loadAmCharts(),
      $timeout(2000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 500);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('filesModel', function () {
            return {
                controller: function($parse, $element, $attrs, $scope){
                    var exp = $parse($attrs.filesModel);
                    $element.on('change', function(){
                        exp.assign($scope, this.files[0]);
                        $scope.$apply();
                    });
                }
            };
        })
})();
(function () {
    'use strict';

    angular
        .module('InovaceClientApp.pages.main')
        .directive('fixedColumnTable', fixedColumnTable);

    fixedColumnTable.$inject = ['$timeout'];
    // Documentation URL: https://technology.cap-hpi.com/blog/fixing-column-headers-using-angular/
    // Implementation example URL: http://embed.plnkr.co/T3toctDpLk2kw0DGv0cM/
    function fixedColumnTable($timeout) {
        return {
            restrict: 'A',
            scope: {
                fixedColumns: "@"
            },
            link: function (scope, element) {
                var container = element[0];

                function activate() {
                    applyClasses('thead tr', 'cross', 'th');
                    applyClasses('tbody tr', 'fixed-cell', 'td');

                    var leftHeaders = [].concat.apply([], container.querySelectorAll('tbody td.fixed-cell'));
                    var topHeaders = [].concat.apply([], container.querySelectorAll('thead th'));
                    var crossHeaders = [].concat.apply([], container.querySelectorAll('thead th.cross'));

                    container.addEventListener("scroll", function () {
                        var x = container.scrollLeft;
                        var y = container.scrollTop;

                        //Update the left header positions when the container is scrolled
                        leftHeaders.forEach(function (leftHeader) {
                            leftHeader.style.transform = translate(x, 0);
                        });

                        //Update the top header positions when the container is scrolled
                        topHeaders.forEach(function (topHeader) {
                            topHeader.style.transform = translate(0, y);
                        });

                        //Update headers that are part of the header and the left column
                        crossHeaders.forEach(function (crossHeader) {
                            crossHeader.style.transform = translate(x, y);
                        });

                    }, false);

                    function translate(x, y) {
                        return 'translate(' + x + 'px, ' + y + 'px)';
                    }

                    function applyClasses(selector, newClass, cell) {
                        var arrayItems = [].concat.apply([], container.querySelectorAll(selector));
                        var currentElement;
                        var colspan;

                        arrayItems.forEach(function (row, i) {
                            var numFixedColumns = scope.fixedColumns;
                            var currentRow = angular.element(row);
                            for (var j = 0; j < numFixedColumns && !currentRow.hasClass('skip-freeze'); j++) {
                                currentElement = currentRow.find(cell)[j];
                                currentElement.classList.add(newClass);

                                if (currentElement.hasAttribute('colspan')) {
                                    colspan = currentElement.getAttribute('colspan');
                                    numFixedColumns -= (parseInt(colspan) - 1);
                                }
                            }
                        });
                    }
                }

                $timeout(function () {
                    activate();
                }, 0);

                scope.$on('refreshFixedColumns', function () {
                    $timeout(function () {
                        activate();
                        container.scrollLeft = 0;
                    }, 0);
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('noClick', function () {
            return {
                replace: true,
                link: function(scope, elem, attr) {
                    if (attr['ngDisabled']) {
                        elem.unbind('click')
                    }
                }

            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('percentAdd', function () {
            return {
                restrict: 'EA',
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    //
                    // var addSpaces = function(value) {
                    //     if (typeof(value) == typeof(undefined))
                    //         return value;
                    //     var parsedValue = value.toString()
                    //         .replace(/[^\dA-Za-z]/g, '')
                    //         .replace(/(.{4})/g, '$1-').trim()
                    //         .toUpperCase()
                    //         .replace(/-$/, '');
                    //     return parsedValue;
                    // }
                    //
                    // var removeSpaces = function(value) {
                    //     if (typeof(value) == typeof(undefined))
                    //         return value;
                    //     var parsedValue = value.toString().replace(/\s/g, '').replace(/-/g, '');
                    //     return parsedValue;
                    // }

                    var parseViewValue = function(value) {
                        // var viewValue = addSpaces(value);
                        if(!value) return;
                        value = value.replaceAll('%','');
                        ngModel.$viewValue = value.replaceAll('%','');
                        if(isNaN(value)){
                            ngModel.$viewValue = '';
                            ngModel.$render();
                            return value;
                        }
                        ngModel.$viewValue = value.replaceAll('%','') + "%";
                        ngModel.$render();
                        // Return what we want the model value to be
                        return value.replaceAll('%','');
                    }

                    var formatModelValue = function(value) {
                        if(!value) return;
                        if(isNaN(value) && value.includes('%')){
                            value = value.replaceAll('%','')
                            ngModel.$modelValue = value.replaceAll('%','');
                        }
                        return value;
                    }

                    ngModel.$parsers.push(parseViewValue);
                    ngModel.$formatters.push(formatModelValue);
                }
            }
        })
})();

(function() {
  'use strict';
  
  // Constants
  var SUBSCRIPTION_CONSTANTS = {
    BANNER_TYPES: {
      WARN: 'warn',
      URGENT: 'urgent',
      EXPIRED: 'expired'
    },
    RENEWAL_DAYS: {
      WARNING_7_DAYS: 7,
      WARNING_3_DAYS: 3,
      DEACTIVATION_DAYS: 8
    },
    CSS_IDS: {
      STYLES: 'subscription-gate-styles',
      LOCK_STYLES: 'subscription-gate-lock-styles',
      BANNER_SPACER: 'subscription-banner-spacer'
    },
    SELECTORS: {
      TOPBAR: '#topbar, .topbar, .navbar, .page-top, .app-header',
      PROFILE: '.al-user-profile, .profile-dropdown, .profile-toggle-link',
      SIGNOUT: '.signout'
    },
    DATE_FORMAT: 'dd/MM/yyyy',
    DEFAULT_DATE_TEXT: 'notSet',
    DISMISSAL: {
      STORAGE_KEY: 'subscriptionBannerDismissal',
      COUNTDOWN_HOURS: 24,
      MAX_RELOAD_COUNT: 3
    }
  };

  /**
   * Generates the subscription gate template
   * @returns {string} HTML template string
   */
  function generateSubscriptionTemplate() {
    return '<div class="subscription-gate-root">' +
      // 7-day banner (only for privileged users - admin/HR manager)
      '<div ng-if="vm.status.warn7Days && !vm.status.isExpired && !vm.status.warn3Days && vm.isUserPrivileged && !vm.isDismissed" class="subscription-banner warn">' +
        '<div class="banner-content" ng-click="vm.goToRenew()">' +
        'Dear Client, Your Tipsoi HRM subscription is nearing its renewal date - ' +
        '[ {{ (vm.dueDateMs | date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ].' +
        ' Please<span class="renew-link-text">click here</span> ' +
        ' to renew your subscription and enjoy uninterrupted service.' +
        '</div>' +
        '<button class="banner-close-btn" ng-click="vm.dismissBanner($event)" title="Dismiss banner">&times;</button>' +
      '</div>' +

      // 3-day banner (only for privileged users - admin/HR manager)
      '<div ng-if="vm.status.warn3Days && !vm.status.isExpired && vm.isUserPrivileged && !vm.isDismissed" class="subscription-banner urgent">' +
        '<div class="banner-content" ng-click="vm.goToRenew()">' +
        '<span class="flash-text">Dear Client, Your Tipsoi HRM subscription is about to end on ' +
        '[ {{ (vm.dueDateMs | date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ].' +
        ' <span class="renew-link-text">click here</span>' +
        ' to renew now and ensure seamless access to all features</span>' +
        '</div>' +
        '<button class="banner-close-btn" ng-click="vm.dismissBanner($event)" title="Dismiss banner">&times;</button>' +
      '</div>' +

      // EXPIRED banner for privileged users (admin/HR manager)
      '<div ng-if="vm.status.isExpired && vm.isUserPrivileged && !vm.isDismissed" class="subscription-banner expired">' +
        '<div class="banner-content" ng-click="vm.goToRenew()">' +
        '<span class="flash-text">Dear Client, Your Tipsoi HRM subscription has ended on '+
        '[ {{ (vm.dueDateMs | date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ].' +
         ' <span class="renew-link-text">click here</span>' +
        ' to renew now and ensure seamless access to all features. Please renew before '+
        '[ {{ (vm.dueDateMs +(' + (SUBSCRIPTION_CONSTANTS.RENEWAL_DAYS.DEACTIVATION_DAYS * 24 * 60 * 60 * 1000) + ')| date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ]' +
         ' to avoid panel deactivation. '+
        '</span>' +
        '</div>' +
        //'<button class="banner-close-btn" ng-click="vm.dismissBanner($event)" title="Dismiss banner">&times;</button>' +
      '</div>' +

//      // EXPIRED banner for normal users (no click functionality)
//      '<div ng-if="vm.status.isExpired && !vm.isUserPrivileged && !vm.isDismissed" class="subscription-banner expired">' +
//        '<div class="banner-content">' +
//        '<span class="flash-text">Dear Client, Your Tipsoi HRM subscription has expired on '+
//        '[ {{ (vm.dueDateMs | date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ].' +
//        ' Please contact your administrator to renew the subscription. This panel will be deactivated on '+
//        '[ {{ (vm.dueDateMs +(' + (SUBSCRIPTION_CONSTANTS.RENEWAL_DAYS.DEACTIVATION_DAYS * 24 * 60 * 60 * 1000) + ')| date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ]' +
//        '</span>' +
//        '</div>' +
//        //'<button class="banner-close-btn" ng-click="vm.dismissBanner($event)" title="Dismiss banner">&times;</button>' +
//      '</div>' +

      // EXPIRED PRIORITY banner (entire area is clickable; TEXT flashes)
      '<div ng-if="vm.status.isExpiredPriority && vm.isUserPrivileged && !vm.isDismissed" class="subscription-banner expired">' +
        '<div class="banner-content" ng-click="vm.goToRenew()">' +
        '<span class="flash-text">Dear Client, Your Tipsoi HRM subscription has ended on  '+
        '[ {{ (vm.dueDateMs | date:"' + SUBSCRIPTION_CONSTANTS.DATE_FORMAT + '") || "' + SUBSCRIPTION_CONSTANTS.DEFAULT_DATE_TEXT + '" }} ].' +
        ' <span class="renew-link-text">Click here</span>' +
        ' to renew now and ensure seamless access to all features.' +
        '</span>' +
        '</div>' +
        //'<button class="banner-close-btn" ng-click="vm.dismissBanner($event)" title="Dismiss banner">&times;</button>' +
      '</div>' +
    '</div>';
  }

  angular.module('InovaceClientApp')
    .directive('subscriptionGate', ['$rootScope', '$state', '$document', '$window', 'subscriptionGateService', 'authService',
      function($rootScope, $state, $document, $window, subscriptionGateService, authService) {
        return {
          restrict: 'E',
          replace: true,
          template: generateSubscriptionTemplate(),

          controllerAs: 'vm',
          controller: ['$scope', function($scope){
            var vm = this;

            /**
             * Robust boolean coercion that handles string values properly
             * @param {*} value - Value to convert to boolean
             * @returns {boolean} Converted boolean value
             */
            function convertToBoolean(value) {
              if (typeof value === 'string') {
                var trimmedValue = value.trim().toLowerCase();
                var truthyValues = ['true', '1', 'yes'];
                var falsyValues = ['false', '0', 'no', 'null', 'undefined', ''];
                
                if (truthyValues.includes(trimmedValue)) return true;
                if (falsyValues.includes(trimmedValue)) return false;
              }
              return !!value;
            }

            /**
             * Get banner dismissal data from localStorage
             * @returns {Object|null} Dismissal data or null
             */
            function getBannerDismissalData() {
              try {
                var data = $window.localStorage.getItem(SUBSCRIPTION_CONSTANTS.DISMISSAL.STORAGE_KEY);
                return data ? JSON.parse(data) : null;
              } catch (error) {
                return null;
              }
            }

            /**
             * Save banner dismissal data to localStorage
             * @param {Object} data - Dismissal data to save
             */
            function saveBannerDismissalData(data) {
              try {
                $window.localStorage.setItem(SUBSCRIPTION_CONSTANTS.DISMISSAL.STORAGE_KEY, JSON.stringify(data));
              } catch (error) {
                // Silently handle localStorage errors
              }
            }

            /**
             * Clear banner dismissal data from localStorage
             */
            function clearBannerDismissalData() {
              try {
                $window.localStorage.removeItem(SUBSCRIPTION_CONSTANTS.DISMISSAL.STORAGE_KEY);
              } catch (error) {
                // Silently handle localStorage errors
              }
            }

            /**
             * Check if banner should be dismissed based on timer and reload count
             * @returns {boolean} True if banner should be dismissed
             */
            function shouldBannerBeDismissed() {
              var dismissalData = getBannerDismissalData();
              
              if (!dismissalData) {
                return false;
              }

              var currentTime = Date.now();
              var dismissedUntil = dismissalData.dismissedUntil || 0;

              // Check if countdown period has expired
              if (currentTime >= dismissedUntil) {
                clearBannerDismissalData();
                return false;
              }

              // Check reload count
              var reloadCount = dismissalData.reloadCount || 0;
              if (reloadCount >= SUBSCRIPTION_CONSTANTS.DISMISSAL.MAX_RELOAD_COUNT) {
                // Reset dismissal and reload count
                clearBannerDismissalData();
                return false;
              }

              return true;
            }

            /**
             * Increment page reload counter
             */
            function incrementReloadCounter() {
              var dismissalData = getBannerDismissalData();
              
              if (dismissalData && dismissalData.dismissedUntil > Date.now()) {
                dismissalData.reloadCount = (dismissalData.reloadCount || 0) + 1;
                saveBannerDismissalData(dismissalData);
              }
            }

            /**
             * Dismiss banner and start countdown timer
             * @param {Event} event - Click event
             */
            function dismissBanner(event) {
              if (event) {
                event.preventDefault();
                event.stopPropagation();
              }

              var currentTime = Date.now();
              var countdownMs = SUBSCRIPTION_CONSTANTS.DISMISSAL.COUNTDOWN_HOURS * 60 * 60 * 1000;
              var dismissedUntil = currentTime + countdownMs;

              var dismissalData = {
                dismissedUntil: dismissedUntil,
                reloadCount: 0
              };

              saveBannerDismissalData(dismissalData);
              vm.isDismissed = true;

              // Apply digest cycle to update view
              if (!$scope.$$phase) {
                $scope.$apply();
              }
            }

            /**
             * Initialize subscription status object
             */
            function initializeSubscriptionStatus() {
              vm.status = {
                warn7Days: false,
                warn3Days: false,
                isExpired: false,
                isExpiredPriority: false,
                daysBeforeExpiry: null
              };
            }

            /**
             * Check if current state is billing/renewal state
             * @returns {boolean} True if in billing state
             */
            function isInBillingState() {
              try {
                return !!($state && $state.current && $state.current.name &&
                          $state.current.name.indexOf('billing') !== -1);
              } catch (error) { 
                return false; 
              }
            }

            /**
             * Force redirect to billing page if locked
             */
            function redirectToBillingIfLocked() {
              if (vm.isHardLocked && !isInBillingState()) {
                try { 
                  $state.go('billing'); 
                } catch (error) { 
                  $window.location.href = '#/billing'; 
                }
              }
            }

            /**
             * Update lock visibility based on current state
             */
            function updateLockVisibility() {
              vm.showPlainLock = !!vm.status.isExpired && !isInBillingState();
            }

            /**
             * Check if user has admin or HR manager privileges
             * @returns {boolean} True if user is privileged
             */
            function checkUserPrivileges() {
              var user = $rootScope.loggedInUser ||
                        (authService && authService.getLoggedInUser && authService.getLoggedInUser()) ||
                        {};
              return !!(user.isAdmin || user.isHrManager);
            }

            /**
             * Parse days before expiry from various input types
             * @param {*} daysValue - Days value to parse
             * @returns {number|null} Parsed days or null
             */
            function parseDaysBeforeExpiry(daysValue) {
              if (typeof daysValue === 'number') {
                return daysValue;
              }
              
              if (typeof daysValue === 'string' && daysValue.trim() !== '' && !isNaN(+daysValue)) {
                return +daysValue;
              }
              
              return null;
            }

            /**
             * Synchronize subscription status from root scope
             */
            function synchronizeSubscriptionStatus() {
              var subscriptionStatus = $rootScope.subscriptionStatus || vm.status;

              vm.status.warn7Days = convertToBoolean(subscriptionStatus.warn7Days);
              vm.status.warn3Days = convertToBoolean(subscriptionStatus.warn3Days);
              vm.status.isExpired = convertToBoolean(subscriptionStatus.isExpired);
              vm.status.isExpiredPriority = convertToBoolean(subscriptionStatus.isExpiredPriority);
              vm.status.daysBeforeExpiry = parseDaysBeforeExpiry(subscriptionStatus.daysBeforeExpiry);
              vm.isHardLocked = convertToBoolean(subscriptionStatus.isPastGracePeriodDays);

              updateLockVisibility();
              redirectToBillingIfLocked();
            }

            /**
             * Check if element is a navigation link
             * @param {Element} element - DOM element to check
             * @returns {boolean} True if element is a navigation link
             */
            function isNavigationLink(element) {
              return element.tagName === 'A' &&
                     (element.hasAttribute('ui-sref') ||
                      (element.hasAttribute('href') && element.getAttribute('href') !== '#') ||
                      element.textContent.trim() === 'Home' ||
                      element.innerHTML.includes('Home'));
            }

            /**
             * Block navigation clicks for non-privileged users when locked
             * @param {Event} event - Click event
             */
            function handleNavigationClickBlocking(event) {
              if (vm.isHardLocked && !checkUserPrivileges()) {
                var target = event.target;
                var element = target.closest('a') || target;

                if (isNavigationLink(element)) {
                  event.preventDefault();
                  event.stopPropagation();
                  event.stopImmediatePropagation();
                  redirectToBillingIfLocked();
                  return false;
                }
              }
            }

            /**
             * Get billing URL from subscription service
             * @returns {string|null} Billing URL or null
             */
            function getBillingUrl() {
              if (subscriptionGateService && subscriptionGateService.paymentUrl) {
                return subscriptionGateService.paymentUrl;
              }
              
              if (subscriptionGateService && subscriptionGateService.getBillingUrl) {
                return subscriptionGateService.getBillingUrl();
              }
              
              return null;
            }

            /**
             * Navigate to renewal page
             * @param {Event} event - Click event
             */
            function navigateToRenewal(event) {
              if (event) {
                event.preventDefault();
                event.stopPropagation();
              }

              if (!checkUserPrivileges()) {
                return;
              }

              var billingUrl = getBillingUrl();
              if (billingUrl) {
                var newWindow = $window.open(billingUrl, '_blank');
                if (newWindow) { 
                  try { 
                    newWindow.opener = null; 
                  } catch (error) {
                    // Silently handle opener assignment error
                  } 
                }
              }
            }

            // Initialize controller
            initializeSubscriptionStatus();
            vm.isUserPrivileged = checkUserPrivileges();
            vm.isHardLocked = false;

            // Initialize due date from service
            vm.dueDateMs = (subscriptionGateService && subscriptionGateService.getBillingDueDate)
              ? subscriptionGateService.getBillingDueDate()
              : null;

            /**
             * Check and update banner dismiss status periodically
             */
            function checkBannerDismissStatus() {
              var wasDismissed = vm.isDismissed;
              vm.isDismissed = shouldBannerBeDismissed();
              
              // If dismissal status changed, trigger digest cycle
              if (wasDismissed !== vm.isDismissed) {
                if (!$scope.$$phase) {
                  $scope.$apply();
                }
              }
            }

            // Initialize banner dismissal state
            vm.isDismissed = shouldBannerBeDismissed();
            
            // Increment reload counter if banner is currently dismissed
            if (vm.isDismissed) {
              incrementReloadCounter();
            }

            // Initial check to ensure banner state is correct
            checkBannerDismissStatus();

            // Watch for user changes and update privilege status
            $scope.$watch(function() {
              return $rootScope.loggedInUser;
            }, function() {
              vm.isUserPrivileged = checkUserPrivileges();
            }, true);

            // Keep due date synced with the service
            $scope.$watch(function () {
              return (subscriptionGateService && subscriptionGateService.getBillingDueDate)
                ? subscriptionGateService.getBillingDueDate()
                : null;
            }, function (newValue) {
              vm.dueDateMs = newValue;
            });


//            if (subscriptionGateService && subscriptionGateService.refresh) {
//              subscriptionGateService.refresh();
//            }

            // Watch subscription status changes
            $scope.$watch(function(){ 
              return $rootScope.subscriptionStatus; 
            }, synchronizeSubscriptionStatus, true);

            // Block navigation attempts while locked
            $scope.$on('$stateChangeStart', function (event, toState) {
              if (vm.isHardLocked && toState && toState.name && toState.name.indexOf('billing') === -1) {
                event.preventDefault();
                redirectToBillingIfLocked();
              }
            });

            // Add click listener for navigation blocking
            $document[0].addEventListener('click', handleNavigationClickBlocking, true);

            // Update lock visibility on state changes
            $scope.$on('$stateChangeSuccess', function(){ 
              updateLockVisibility(); 
            });

            // Set up periodic check for banner dismiss expiration (every 30 seconds)
            var dismissCheckInterval = setInterval(checkBannerDismissStatus, 30000);

            // Clean up interval on scope destroy
            $scope.$on('$destroy', function() {
              if (dismissCheckInterval) {
                clearInterval(dismissCheckInterval);
              }
            });

            // Expose methods to template
            vm.goToRenew = navigateToRenewal;
            vm.dismissBanner = dismissBanner;
          }],

          link: function(scope, element) {
            /**
             * Generate CSS styles for subscription banners
             * @returns {string} CSS styles string
             */
            function generateBannerStyles() {
              return [
                // Banner fixed to top
                '.subscription-banner{position:fixed;left:0;right:0;top:0;z-index:99999;' +
                  'padding:10px 50px 10px 16px;text-align:center;font-weight:600;display:flex;align-items:center;justify-content:center}',
                '.subscription-banner.warn{background:#FFFF00;border-bottom:1px solid #ffd7b3}',
                '.subscription-banner.urgent{background:#FFFF00;border-bottom:1px solid #ffbdbd}',
                // Banner content wrapper
                '.subscription-banner .banner-content{flex:1;cursor:pointer}',
                // Close button styling
                '.subscription-banner .banner-close-btn{position:absolute;right:10px;top:50%;transform:translateY(-50%);' +
                  'background:transparent;border:none;font-size:32px;line-height:1;cursor:pointer;' +
                  'color:rgba(0,0,0,0.6);padding:0;width:32px;height:32px;display:flex;align-items:center;' +
                  'justify-content:center;font-weight:300;transition:color 0.2s ease,transform 0.2s ease}',
                '.subscription-banner .banner-close-btn:hover{color:rgba(0,0,0,0.9);transform:translateY(-50%) scale(1.1)}',
                '.subscription-banner .banner-close-btn:active{transform:translateY(-50%) scale(0.95)}',
                // Flashing text (used ONLY on 3-day + expired)
                '@keyframes sub-flash{0%,100%{opacity:1}50%{opacity:.15}}',
                '.flash-text{animation:sub-flash 1s linear infinite}',
                // Expired look
                '.subscription-banner.expired{background:#FF7F50;color:#000;border-bottom:1px solid #d9363e;cursor:pointer}',
                '.subscription-banner .renew-link-text{text-decoration:underline;font-style:italic;color:#007bff;margin-left:6px}',
                // Spacer that reserves space under the fixed banner
                '#subscription-banner-spacer{display:block;width:100%;height:0;}',
                // Optional expired card styling
                '.subscription-plain-card{position:relative;z-index:1;max-width:980px;margin:40px auto;' +
                  'padding:26px 24px; font-size:16px; line-height:26px;' +
                  'text-align:center;}',
                '.subscription-plain-card .big-btn{padding:12px 34px;font-size:18px; margin-top: 20px;}',
                '.subscription-plain-msg{background:#d6e6f8;border:1px solid #b5cdf3;border-radius:16px;' +
                  'padding:18px 24px;margin-bottom:16px;font-weight:600}'
              ].join('');
            }

            /**
             * Generate CSS styles for lock functionality
             * @returns {string} CSS styles string
             */
            function generateLockStyles() {
              return [
                // Disable clicks on *descendants* of header areas
                'body.subscription-hard-lock #topbar *,' +
                'body.subscription-hard-lock .topbar *,' +
                'body.subscription-hard-lock .navbar *,' +
                'body.subscription-hard-lock .page-top *,' +
                'body.subscription-hard-lock .app-header *{' +
                  'pointer-events:none !important;' +
                '}',
                // Allow the avatar toggle + its dropdown to work
                'body.subscription-hard-lock .al-user-profile,' +
                'body.subscription-hard-lock .al-user-profile *,' +
                'body.subscription-hard-lock .profile-dropdown,' +
                'body.subscription-hard-lock .profile-dropdown *,' +
                'body.subscription-hard-lock .profile-toggle-link{' +
                  'pointer-events:auto !important;' +
                '}',
                // Inside dropdown, keep everything disabled…
                'body.subscription-hard-lock .profile-dropdown a{' +
                  'pointer-events:none !important;opacity:.5;cursor:default;' +
                '}',
                // …except the Logout link (which already has class="signout")
                'body.subscription-hard-lock .profile-dropdown a.signout{' +
                  'pointer-events:auto !important;opacity:1;cursor:pointer;' +
                '}'
              ].join('');
            }

            /**
             * Create and inject CSS styles if they don't exist
             * @param {string} cssId - CSS element ID
             * @param {string} cssContent - CSS content to inject
             */
            function injectStylesIfNotExists(cssId, cssContent) {
              if (!$document[0].getElementById(cssId)) {
                var styleElement = $document[0].createElement('style');
                styleElement.id = cssId;
                styleElement.type = 'text/css';
                styleElement.appendChild($document[0].createTextNode(cssContent));
                $document[0].head.appendChild(styleElement);
              }
            }

            // Inject banner styles
            injectStylesIfNotExists(SUBSCRIPTION_CONSTANTS.CSS_IDS.STYLES, generateBannerStyles());

            // ---------- Banner Spacer Logic ----------
            var document = $document[0];
            var bodyElement = document.body;
            var spacerElement = document.getElementById(SUBSCRIPTION_CONSTANTS.CSS_IDS.BANNER_SPACER);
            
            if (!spacerElement) {
              spacerElement = document.createElement('div');
              spacerElement.id = SUBSCRIPTION_CONSTANTS.CSS_IDS.BANNER_SPACER;
            }

            /**
             * Ensure spacer is positioned at the top of the body
             */
            function ensureSpacerAtTop() {
              if (bodyElement.firstChild !== spacerElement) {
                bodyElement.insertBefore(spacerElement, bodyElement.firstChild);
              }
            }

            /**
             * Remove spacer from DOM
             */
            function removeSpacer() {
              if (spacerElement.parentNode) {
                spacerElement.parentNode.removeChild(spacerElement);
              }
            }

            /**
             * Get the currently active banner element
             * @returns {Element|null} Active banner element or null
             */
            function getActiveBannerElement() {
              // Priority: EXPIRED PRIORITY > EXPIRED > 3-day > 7-day
              return element[0].querySelector('.subscription-banner.expired[ng-if*="isExpiredPriority"]') ||
                     element[0].querySelector('.subscription-banner.expired[ng-if*="isExpired"]') ||
                     element[0].querySelector('.subscription-banner.urgent') ||
                     element[0].querySelector('.subscription-banner.warn');
            }

            /**
             * Check if any banner is currently active
             * @returns {boolean} True if any banner is active
             */
            function isBannerActive() {
              var viewModel = scope.vm || {};
              var status = viewModel.status || {};
              var shouldShowBanner = status.isExpired || status.isExpiredPriority || status.warn3Days || status.warn7Days;
              
              // For all banners, check if they are dismissed
              if (shouldShowBanner) {
                return !viewModel.isDismissed;
              }
              
              return false;
            }

            /**
             * Apply spacer height based on active banner
             */
            function applySpacerHeight() {
              var bannerElement = getActiveBannerElement();
              if (!bannerElement) { 
                removeSpacer(); 
                return; 
              }
              
              ensureSpacerAtTop();
              var bannerHeight = bannerElement.offsetHeight || 0;
              spacerElement.style.height = bannerHeight + 'px';
            }

            /**
             * Handle banner visibility changes
             */
            function handleBannerVisibilityChange() {
              if (isBannerActive()) {
                setTimeout(applySpacerHeight, 0);
              } else {
                removeSpacer();
              }
            }

            /**
             * Toggle topbar blocking based on lock state
             * @param {boolean} isBlocked - Whether to block the topbar
             */
            function toggleTopbarBlocking(isBlocked) {
              if (isBlocked) {
                bodyElement.classList.add('subscription-hard-lock');
              } else {
                bodyElement.classList.remove('subscription-hard-lock');
              }
            }

            /**
             * Handle window resize events
             */
            function handleWindowResize() {
              if (isBannerActive()) {
                applySpacerHeight();
              }
            }

            /**
             * Clean up event listeners and DOM elements
             */
            function cleanup() {
              toggleTopbarBlocking(false);
              $document[0].removeEventListener('click', handleNavigationClickBlocking, true);
              angular.element($window).off('resize', handleWindowResize);
              removeSpacer();
            }

            // Inject lock styles
            injectStylesIfNotExists(SUBSCRIPTION_CONSTANTS.CSS_IDS.LOCK_STYLES, generateLockStyles());

            // Watch for banner status changes
            scope.$watch(function(){
              var viewModel = scope.vm || {};
              var status = viewModel.status || {};
              return [status.warn3Days, status.warn7Days, status.isExpired, status.isExpiredPriority, viewModel.isDismissed].join('|');
            }, handleBannerVisibilityChange);

            // Watch for lock state changes
            scope.$watch(function(){ 
              return !!(scope.vm && scope.vm.isHardLocked); 
            }, function(isLocked){
              toggleTopbarBlocking(!!isLocked);
            });

            // Set up event listeners
            angular.element($window).on('resize', handleWindowResize);
            scope.$on('$viewContentLoaded', function(){ 
              if (isBannerActive()) {
                setTimeout(applySpacerHeight, 0); 
              }
            });
            scope.$on('$stateChangeSuccess', function(){ 
              if (isBannerActive()) {
                setTimeout(applySpacerHeight, 0); 
              }
            });
            scope.$on('$destroy', cleanup);
          }
        };
      }]);
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('uniqueEmployeeId', function ($q, $timeout, employeeService) {
            return {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    ctrl.$asyncValidators.uniqueEmployeeId = function(modelValue, viewValue) {

                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return $q.resolve();
                        }

                        var def = $q.defer();

                        $timeout(function() {
                            // Mock a delayed response
                            return employeeService.checkEmployeeOfficeIdValidity(modelValue).then(function (data) {
                                if (data.isValid) {
                                    def.resolve();
                                } else {
                                    def.reject();
                                }
                            }, function (error) {
                                def.reject();
                            });

                        }, 1000);

                        return def.promise;
                    };
                }
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('upgradeBanner', function () {
            return {
                restrict: 'E',
                transclude: true,
                controller: 'UpgradePopupCtrl as dvm',
                scope:{
                    code:'='
                },
                template: '<ng-transclude ng-if="dvm.hasPermission"></ng-transclude>'+
                    '<div class="upgrade-wrap" ng-if="!dvm.hasPermission"> \
                               <ng-transclude></ng-transclude> \
                               <a href="#" ng-click="dvm.openUpgradeModal()"> \
                                   <span class="banner"> \
                                       <span class="label"> \
                                           UPGRADE \
                                       </span> \
                                   </span> \
                               </a> \
                           </div>',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('upgradeButton', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope:{
                    code:'@'
                },
                controller: 'UpgradePopupCtrl as dvm',
                template: '<ng-transclude ng-if="hasPermission"></ng-transclude>'+
                    '<div class="upgrade-button-wrap" ng-if="!hasPermission"> \
                               <ng-transclude></ng-transclude> \
                               <a href="#" ng-click="dvm.openUpgradeModal()"> \
                                   <span class="button"> \
                                       <span class="label"> \
                                           UPGRADE \
                                       </span> \
                                   </span> \
                               </a> \
                           </div>',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('upgradeLink', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope:{
                    code:'='
                },
                controller: 'UpgradePopupCtrl as dvm',
                template: '<ng-transclude ng-if="dvm.hasPermission"></ng-transclude>'+
                    '<div class="upgrade-link" ng-click="dvm.openUpgradeModal()" ng-if="!dvm.hasPermission" style="display: inline;"> \
                               <ng-transclude ng-if="!dvm.hasPermission""></ng-transclude> \
                           </div>',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('upgradeSpan', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope:{
                    code:'@'
                },
                controller: 'UpgradePopupCtrl as dvm',
                template: '<ng-transclude ng-if="dvm.hasPermission"></ng-transclude>'+
                    '<span ng-click="dvm.openUpgradeModal()" ng-if="!dvm.hasPermission"> \
                               <ng-transclude ng-if="!dvm.hasPermission""></ng-transclude> \
                           </span>',
            }
        })
})();
app.filter('abs', function() {
    return function(value) {
        return Math.abs(value);
    }
});
app.filter('numberOfKeys', function() {
    return function(object) {
        return Object.keys(object).length;
    }
});
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('LimitReachedModalCtrl', [
            '$uibModalInstance', '$uibModal', 'modalOptions', LimitReachedModalCtrl]);

    function LimitReachedModalCtrl($uibModalInstance, $uibModal, modalOptions) {
        var vm = this;

        vm.title = modalOptions.title || 'Employee Limit Reached';
        vm.limit = modalOptions.limit || 10;

        vm.maybeLater = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.upgrade = function () {
            $uibModalInstance.close('upgrade');
            $uibModal.open({
                templateUrl: 'app/pages/main/upgradePopup.html',
                controller: 'UpgradePopupModalCtrl as vm',
                size: 'lg',
                backdrop: 'static'
            });
        };
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('MainCtrl', ['$rootScope','employeeService', 'toastr', 'FCM','$scope','$state', MainCtrl]);


    /** @ngInject */
    function MainCtrl($rootScope,employeeService, toastr, FCM, $scope, $state) {
        // function messageHandler(data, notification) {
        //     console.log("inside message handler: data: " + JSON.stringify(data));
        //     console.log("inside message handler: notification: " + JSON.stringify(notification));
        //     toastr.info(data.shortMessage);
        //     //TODO customized toast
        // }
        function init(){
            $rootScope.pendingApproval = {
                "name": "pendingApprovals",
                "title": "Pending Approvals",
                "level": 0,
                "order": 170,
                "icon": "ion-android-checkmark-circle",
                "stateRef": "pendingApprovals",
                "code": null,
                "subMenu": null,
                "notification": 0,
            };
            employeeService.getPendingApprovalsOfEmployee().then(function (data) {
                $rootScope.pendingApproval.notification = data;
            });
            function getValue(){
                return window.localStorage.getItem('token');
            }

            $scope.$watch(getValue, function(newValue){
                if (!newValue){
                    $state.go('login');
                }
            });
            // FCM.setOnMessage(function (payload) {
            //     // console.log('FCM payload from main controller: ', JSON.stringify(payload, null, 2));
            //     console.log('FCM payload from main controller: ', JSON.stringify(payload));
            //     var data = payload.data;
            //     var notification = payload.notification;
            //     messageHandler(data, notification);
            // });

        }
        init();



        // $rootScope.loggedInUser = authService.getAllInformation();
        // if(authService.isAuthenticated()) {
        //     $rootScope.isLoginState = false;
        //     $state.go('dashboard');
        // }
        // $rootScope.isLoginState = true;
        // console.log("login page");
        //
        // $scope.login = function () {
        //     toastr.clear();
        //     console.log($scope.loginData.email);
        //     console.log($scope.loginData.password);
        //     authService
        //         .login($scope.loginData)
        //         .then(loginSuccess, loginFailed);
        // };
        //
        // var loginSuccess = function(){ showSuccessToast(); };
        // var loginFailed = function (message) { showErrorToast(message); };
        //
        //
        //
        // var showErrorToast = function (message) {
        //     toastr.error(message, 'Sign In Failed', {
        //         "autoDismiss": false,
        //         "positionClass": "toast-top-right",
        //         "type": "error",
        //         "timeOut": "5000",
        //         "extendedTimeOut": "2000",
        //         "allowHtml": false,
        //         "closeButton": false,
        //         "tapToDismiss": true,
        //         "progressBar": false,
        //         "newestOnTop": true,
        //         "maxOpened": 0,
        //         "preventDuplicates": false,
        //         "preventOpenDuplicates": false
        //     });
        // };
        //
        // var showSuccessToast = function(){
        //     toastr.success('Welcome to Inovace Client Panel!', 'Sign in success!', {
        //         "autoDismiss": false,
        //         "positionClass": "toast-top-right",
        //         "type": "success",
        //         "timeOut": "5000",
        //         "extendedTimeOut": "2000",
        //         "allowHtml": false,
        //         "closeButton": false,
        //         "tapToDismiss": true,
        //         "progressBar": false,
        //         "newestOnTop": true,
        //         "maxOpened": 0,
        //         "preventDuplicates": false,
        //         "preventOpenDuplicates": false
        //     })
        // };
    }


})();

(function () {
  'use strict';

  angular.module('InovaceClientApp.pages.main')
    .controller('UpgradePopupCtrl', ['$uibModal', '$q', '$scope', 'utilService', '$window', UpgradePopupCtrl]);

  /** @ngInject */
  function UpgradePopupCtrl($uibModal, $q, $scope, utilService,$window) {

    var vm = this;
    $scope.hasPermission = $scope.code != null ? utilService.hasPermission($scope.code) : "";
    vm.features = $window.localStorage.getItem('features');
    vm.hasPermission = $scope.code != null ? utilService.hasPermission($scope.code) : "";

    vm.openUpgradeModal = function (e) {
      $uibModal.open({
        templateUrl: 'app/pages/main/upgradePopup.html',
        size: 'lg',
        backdrop : 'static',
      });
    };

  }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('UpgradePopupModalCtrl', ['$uibModal', '$q', '$scope', 'utilService', 'versionService', 'moduleService','$window', UpgradePopupModalCtrl]);

    /** @ngInject */
    function UpgradePopupModalCtrl($uibModal, $q, $scope, utilService, versionService, moduleService,$window) {

        var vm = this;
        vm.stopEvent = stopEvent;
        vm.modules = [];
        vm.versions = [];
        vm.features = $window.localStorage.getItem('features');
        vm.hasPermission = $scope.code != null ? utilService.hasPermission($scope.code) : "";
        // console.log(JSON.stringify(vm.features));
        vm.onUpgradeNow = function () {
            // close the features popup first
            $scope.$dismiss('upgrade');

            // TODO: build the real subscriptionInfo from your context
            var subscriptionInfo = {
                memberName: vm.memberName,                 // supply real values
                subscriptionId: vm.subscriptionId,
                packageId: vm.selectedPackageId,
                packageName: vm.selectedPackageName,
                packageAmount: vm.selectedPackageAmount,
                duration: vm.selectedPackageDuration,
                packageStartDate: moment(),
                packageEndDate: moment().add(1, 'M'),
                updatedData: { packageId: vm.selectedPackageId, packageStartDate: +moment() }
            };

            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/membershipManagement/members/modals/upgradeSubscriptionModal/upgradeSubscriptionModal.html',
                size        : 'md',
                controller  : 'UpgradeSubscriptionModalCtrl',
                controllerAs: 'vm',
                backdrop    : 'static',
                resolve     : { subscriptionInfo: function () { return subscriptionInfo; } }
            });
        };

        function init() {
            var getVersions = function () {
                var id = 1;
                versionService.getVersions().then(function (data) {
                    vm.versions = data;
                    vm.features = vm.modules.map(function (module) {
                        var lite = vm.versions[0].modules.find(function (m) {
                            return m.id == module.id;
                        });

                        var pro = vm.versions[1].modules.find(function (m) {
                            return m.id == module.id;
                        });


                        var enterprise = vm.versions[2].modules.find(function (m) {
                            return m.id == module.id;
                        });

                        return {
                            "id"   : id++,
                            "title": module.name,
                            "groupTitle": false,
                            "lite": lite !== undefined ? "✓" : "✕",
                            "pro": pro !== undefined ? "✓" : "✕",
                            "enterprise": enterprise !== undefined ? "✓" : "✕",
                        };
                    });
                    $window.localStorage.setItem('features',JSON.stringify(vm.features));
                }, function (error) {

                });
            };

            var getModules = function () {
                moduleService.getModules().then(function (data) {
                    vm.modules = data;
                    getVersions();
                }, function (error) {

                });
            };
            getModules();
        }
        init();

        function stopEvent($event) {
            $event.stopPropagation();
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .run([
            '$transitions', 'utilService', 'employeeService', 'LimitReachedModal', 'CREATE_EMPLOYEE_GUARD',
            function ($transitions, utilService, employeeService, LimitReachedModal, CREATE_EMPLOYEE_GUARD) {
                $transitions.onBefore({ to: CREATE_EMPLOYEE_GUARD.stateName }, function () {
                    if (!utilService.hasPermission(CREATE_EMPLOYEE_GUARD.moduleCode)) return true;
                    return employeeService.isOverEmployeeLimit(CREATE_EMPLOYEE_GUARD.limit)
                        .then(function (over) {
                            if (over) {
                                LimitReachedModal.open({ limit: CREATE_EMPLOYEE_GUARD.limit, title: 'Employee Limit Reached' });
                                return false;
                            }
                            return true;
                        })
                        .catch(function () {
                            LimitReachedModal.open({ limit: CREATE_EMPLOYEE_GUARD.limit, title: 'Employee Limit Check Failed' });
                            return false;
                        });
                });

            }
        ]);
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .factory('LimitReachedModal', ['$uibModal', function ($uibModal) {

            function open(opts) {
                opts = opts || {};
                return $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    windowClass: 'limit-reached-modal',
                    templateUrl: 'app/pages/main/limitReachedModal.html',
                    controller: 'LimitReachedModalCtrl',
                    controllerAs: 'vm',
                    resolve: {
                        modalOptions: function () { return opts; }
                    }
                }).result;
            }

            return { open: open };
        }]);

})();

(function () {

    'use strict';

    function generalSettingsService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getReportSettingsOfAnOffice = function () {
            var defer = $q.defer();
            $http.get(API.generalSettings.officeReportSettings)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
        self.getLinemanagerSettingsOfAnOffice = function () {
            var defer = $q.defer();
            $http.get(API.generalSettings.officeLinemanagerEnrollmentSettings)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.officeFiscalYearInfo = function () {
            var defer = $q.defer();
            $http.get(API.generalSettings.officeFiscalYearInfo)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


    }

    app.service('generalSettingsService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', generalSettingsService]);

})();
(function(){

    'use strict';

    function accessAreaService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllAccessAreas = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.accessArea.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.accessAreas);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.createAccessArea = function (data) {
            var defer = $q.defer();

            $http.post(API.accessArea.all,data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.accessAreas);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.deleteAccessArea = function (accessAreaId) {
            var defer = $q.defer();

            $http.post(API.accessArea.delete + accessAreaId)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.accessAreas);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.updateAccessArea = function (accessAreaId, data) {
            var defer = $q.defer();

            $http.post(API.accessArea.update + accessAreaId, data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.accessAreas);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

    }

    app.service('accessAreaService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', accessAreaService]);

})();
(function(){

    'use strict';

    function appointmentService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.createAppointment = function (data) {
            var defer = $q.defer();
            var url = API.appointment.create;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getAvailableVisitors = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.appointment.availableVisitors)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.visitors);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getVisitorsOfToday = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.appointment.visitorsOfToday, {params: params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getAppointmentInfo = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.appointment.getAppointmentInfo+params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.updateAppointmentInfo = function(appointmentId,data) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.post(API.appointment.updateAppointment+appointmentId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


    }

    app.service('appointmentService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', appointmentService]);

})();
(function () {

    'use strict';

    function appointmentLogService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getAllAppointments = function (searchParams) {
            var defer = $q.defer();
            $http.get(API.appointmentLog.all, {
                params : searchParams
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.cancelAppointment = function (id) {
            var defer = $q.defer();
            //console.log(searchParams.searchKeyVisitor)
            //console.log(params.visitorName)
            $http.post(API.appointmentLog.cancel + id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.searchVisitor = function (keyword) {
            var defer = $q.defer();
            $http.get(API.visitors.search + "?keyword=" + keyword)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

    }

    app.service('appointmentLogService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', appointmentLogService]);

})();
(function(){

    'use strict';

    function assignRoleService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllEmployeeRoles = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.assignRole.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employeeWithRoleList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.assignRole = function (data) {
            var defer = $q.defer();

            $http.post(API.assignRole.all,data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.employeeWithRoleList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.deleteEmployeeRole = function (employeeId) {
            var defer = $q.defer();

            $http.post(API.assignRole.delete + employeeId)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.employeeWithRoleList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.updateEmployeeRole = function (data) {
            var defer = $q.defer();

            $http.post(API.assignRole.update, data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.employeeWithRoleList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

    }

    app.service('assignRoleService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', assignRoleService]);

})();
(function () {

    'use strict';

    function attendanceService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getAttendance = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilter;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    attendanceStatus: params.attendanceStatus,
                    reportType: params.reportType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        self.getIndividualAttendance = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getIndividualReport;
            // console.log(params.employeeId);
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    employeeId: params.employeeId,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        self.getDailyAttendanceSummary = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilterDailySummary;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    reportType: params.reportType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        self.getDailyAbsentReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilterDailyAbsent;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    reportType: params.reportType,
                    absentType: params.absentType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getMonthlyAbsentReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilterMonthlyAbsent;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    reportType: params.reportType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        self.getLeaveHistoryReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilterLeaveHistory;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    leaveCategoryId: params.leaveCategoryId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order,
                    employeeBeforeEndTime: params.employeeBeforeEndTime,
                    approvalStatus : params.leaveApprovalStatus
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getLeaveBalanceReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getLeaveBalance;
            // console.log(params.year)
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    leaveCategoryId: params.leaveCategoryId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order,
                    employeeBeforeEndTime: params.employeeBeforeEndTime,
                    year: params.year,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.uploadRemainingLeaveBalanceExcel = function (file, params) {
            var defer = $q.defer();
            var url = API.attendance.uploadRemainingLeaveBalanceExcelFile;
            var formData = new FormData();
            formData.append("file", file);
            $http({
                method: 'POST',
                url: String(url),
                headers: {'Content-Type': undefined},
                data: formData,
                params: params,
                transformRequest: function (data, headersGetter) {
                    return data;
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };
        self.downloadSampleExcel = function (params) {
            var url = API.attendance.downloadSampleExcelFile;
            url = url + "?from=" + params.from + "&to=" + params.to;
            url = url + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("leaveCategoryId", params.leaveCategoryId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            url = url + "&pageNumber=" + params.pageNumber;
            url = url + "&employeeBeforeEndTime=" + true;
            url = url + "&perPage=" + params.perPage;
            url = url + "&sortKey=" + params.sortKey;
            url = url + "&order=" + params.order;
            url = url + '&token=' + authService.getLoggedInToken();
            return url;
        };


        function getParamsObject(params) {
            return {
                from: params.from,
                to: params.to,
                designationId: params.designationId,
                departmentId: params.departmentId,
                subDepartmentId: params.subDepartmentId,
                shiftGroupId: params.shiftGroupId,
                genderId: params.genderId,
                companyId: params.companyId,
                officeId: params.officeId,
                employmentTypeId: params.employmentTypeId,
                employeeId: params.employeeId,
                employeeName: params.employeeName,
                lineManagerId: params.lineManagerId,
                workplaceId: params.workplaceId,
                hrManagerId: params.hrManagerId,
                subsidiaryId: params.subsidiaryId,
                status: params.status,
                deviceId: params.deviceId,
                fetchUnregisteredOnly: params.fetchUnregisteredOnly,
                pageNumber: params.pageNumber,
                siteIds: params.siteIds,
                perPage: params.perPage,
                sortKey: params.sortKey,
                order: params.order,
                lunchFilter: params.lunchFilter,
                dinnerFilter: params.dinnerFilter,
            }
        }

        self.getPunchReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getPunchReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getUnrecognisedLogs = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getUnrecognisedLogs;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getMobilePunchReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getMobilePunchReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getLocationTrackReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getLocationTrackReport;
            if(!params.from || params.from < 0 || !params.to || params.to <0 || params.to <params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if(status == RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data.message);
            });
            return defer.promise;
        }

        self.getServerRoomOccupancyReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getServerOccupancyReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getserverRoomOccupancyReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getServerRoomOccupancyReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null|| params.sortKey == ''  ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey );
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };

        self.getSitAttendanceReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getSiteAttendanceReportUrl;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    deviceId: params.deviceId,
                    fetchUnregisteredOnly: params.fetchUnregisteredOnly,
                    pageNumber: params.pageNumber,
                    siteIds: params.siteIds,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order,
                    isPresent : params.isPresent
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getSiteAttendanceReportUrlExcel = function (params){
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getSiteAttendanceReportUrlExcelUrl;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("siteIds", params.siteIds)
                + buildURLFromArray("isPresent", params.isPresent)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            params.sortKey = !params.sortKey || params.sortKey == null|| params.sortKey == ''  ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey );
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        }


        self.getSiteAttendanceReportPdf = function (params) {
            var defer = $q.defer();
            var pdfUrl = API.attendance.getSiteAttendanceReportUrlPdfUrl;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("siteIds", params.siteIds)
                + buildURLFromArray("isPresent", params.isPresent)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            //console.log("PDF URL IS : " + pdfUrl);
            return pdfUrl;
        };

        self.getPandemicReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getPandemicReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: Number(params.from),
                    to: Number(params.to),
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        self.getMonthlyTimesheetApproval = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getMonthlyTimesheetApproval;
            if (!params.year || params.year < 0 || !params.month || params.month < 0) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    year: params.year,
                    month: params.month,
                    lineManagerId: params.lineManagerId,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getLeaveLateAbsentReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.leaveLateAbsent;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    subDepartmentId: params.subDepartmentId,
                    departmentId: params.departmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId == null ? null : params.employeeId,
                    employeeName: params.employeeName == null ? null : params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    leaveCategoryId: params.leaveCategoryId,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order,
                    reportType: params.reportType
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getWorkingHourReportPdfUrl = function (params) {
            var defer = $q.defer();
            var pdfUrl = API.attendance.getWorkingHourPdf;
            // if (params.reportType == "workingHour") {
            //     pdfUrl = API.attendance.getWorkingHourExcel;
            // } else {
            //     pdfUrl = API.attendance.getExcel;
            // }
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                pdfUrl = pdfUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            pdfUrl = pdfUrl + ("&sortKey=" + params.sortKey);
            pdfUrl = pdfUrl + ("&order=" + params.order);
            pdfUrl = pdfUrl + ("&perPage=" + params.perPage);
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + pdfUrl);
            return pdfUrl;
        };

        self.getExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            if (params.reportType == "workingHour") {
                excelUrl = API.attendance.getWorkingHourExcel;
            } else {
                excelUrl = API.attendance.getExcel;
            }
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("subsidiaryId", params.subsidiaryId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };

        self.getExcelAllPagesUrl = function (params) {
            var defer = $q.defer();
            var excelUrlAllPages = "";
            excelUrlAllPages = API.attendance.getExcelAllPages;
            console.log(excelUrlAllPages)
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrlAllPages = excelUrlAllPages + "?from=" + params.from + "&to=" + params.to;
            excelUrlAllPages = excelUrlAllPages + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrlAllPages = excelUrlAllPages + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrlAllPages = excelUrlAllPages + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrlAllPages = excelUrlAllPages + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrlAllPages = excelUrlAllPages + ("&sortKey=" + params.sortKey);
            excelUrlAllPages = excelUrlAllPages + ("&order=" + params.order);
            excelUrlAllPages = excelUrlAllPages + ("&perPage=" + params.perPage);
            excelUrlAllPages = excelUrlAllPages + ("&pageNumber=" + params.pageNumber);
            excelUrlAllPages = excelUrlAllPages + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrlAllPages;
        };

        self.getAllLogsExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getPunchReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("deviceId", params.deviceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };
        self.getMonthlyDiningReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getMonthlyDiningReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("deviceId", params.deviceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };
        self.getMonthlyDiningReportPdfUrl = function (params) {
            var defer = $q.defer();
            var pdfUrl = "";
            pdfUrl = API.attendance.getMonthlyDiningReportPdf;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("deviceId", params.deviceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                pdfUrl = pdfUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            pdfUrl = pdfUrl + ("&sortKey=" + params.sortKey);
            pdfUrl = pdfUrl + ("&order=" + params.order);
            pdfUrl = pdfUrl + ("&perPage=" + params.perPage);
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            // console.log("PDF URL IS : " + pdfUrl);
            return pdfUrl;
        };

        self.getDiningReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getDailyDiningReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("deviceId", params.deviceId)
                + buildURLFromArray("status", params.status)
                + "&lunchFilter=" + params.lunchFilter
                + "&dinnerFilter=" + params.dinnerFilter;
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };

        self.getDiningReportPdfUrl = function (params) {
            var defer = $q.defer();
            var pdfUrl = "";
            pdfUrl = API.attendance.getDailyDiningReportPdf;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("deviceId", params.deviceId)
                + buildURLFromArray("status", params.status)
                + "&lunchFilter=" + params.lunchFilter
                + "&dinnerFilter=" + params.dinnerFilter;
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                pdfUrl = pdfUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            pdfUrl = pdfUrl + ("&sortKey=" + params.sortKey);
            pdfUrl = pdfUrl + ("&order=" + params.order);
            pdfUrl = pdfUrl + ("&perPage=" + params.perPage);
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }

        self.getDetailedDiningReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getDetailedDiningReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("deviceId", params.deviceId)
                + buildURLFromArray("status", params.status)
                + "&lunchFilter=" + params.lunchFilter
                + "&dinnerFilter=" + params.dinnerFilter;
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };

        self.getUnrecognisedLogReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getUnrecognisedLogReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            excelUrl = excelUrl + "&fetchUnregisteredOnly=" + params.fetchUnregisteredOnly;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };

        self.getMobilePunchReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getMobilePunchReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };

        self.getLocationTrackingReportExcel = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getLocationTrackingReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };


        self.getPdfUrl = function (params) {
            var defer = $q.defer();
            var pdfUrl = API.attendance.getPdf;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                pdfUrl = pdfUrl + "&reportType=" + params.reportType;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            //console.log("PDF URL IS : " + pdfUrl);
            return pdfUrl;
        };

        self.getLateReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.lateReportPdf;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) return ("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftId", params.shiftId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                pdfUrl = pdfUrl + "&reportType=" + params.reportType;
            // console.log(params)
            pdfUrl = pdfUrl + "&pageNumber=" + 0;
            pdfUrl = pdfUrl + "&perPage=" + 100;
            pdfUrl = pdfUrl + "&sortKey=name";
            pdfUrl = pdfUrl + "&order=asc";
            // console.log("EXCEL URL IS : " + pdfUrl);

            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        };


        self.getLeaveLateAbsentReportExcelUrl = function (params) {
            var excelUrl = API.attendance.leaveLateAbsentExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) return ("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftId", params.shiftId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray(( "leaveLateAbsentType", params.leaveLateAbsentType));
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            // console.log(params)
            excelUrl = excelUrl + "&pageNumber=" + 0;
            excelUrl = excelUrl + "&perPage=" + 100;
            excelUrl = excelUrl + "&sortKey=name";
            excelUrl = excelUrl + "&order=asc";
            // console.log("EXCEL URL IS : " + excelUrl);

            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        };

        self.getMonthlyReportExcelUrl = function (params) {
            //console.log("Params from front")
            //console.log(params.lineManagerId)
            var defer = $q.defer();
            var excelUrl = API.attendance.getMonthlyReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            //console.log(excelUrl);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        };

        self.getMonthlyReportPdfUrlOld = function (params) {
            var pdfUrl = API.attendance.getMonthlyReportPdf;
            return addSearchParamsToPdfUrl(pdfUrl, params);
        };

        self.getMonthlyVerticalReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.getMonthlyVerticalReportPdf;
            return addSearchParamsToPdfUrl(pdfUrl, params);
        }

        function addSearchParamsToPdfUrl(pdfUrl, params) {
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            pdfUrl = pdfUrl + ("&sortKey=" + params.sortKey);
            pdfUrl = pdfUrl + ("&order=" + params.order);
            pdfUrl = pdfUrl + ("&perPage=" + params.perPage);
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            pdfUrl = pdfUrl + '&type=' + params.reportType + '&token=' + authService.getLoggedInToken();
            // console.log(pdfUrl)
            return pdfUrl;
        }

        self.getProfileExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = API.attendance.getProfileAttendanceExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftId", params.shiftId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            // if (employeeName)
            //     excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        };

        self.getAttendanceByEmployee = function (from, to, employeeId) {
            var defer = $q.defer();
            var url = API.attendance.getByFilter;
            if (!from || from < 0 || !to || to < 0 || to < from) defer.reject("invalid search criteria");
            url = url + "/" + employeeId + "?from=" + from + "&to=" + to;
            //console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.getDetailedBothTypeAttendanceLog = function (params) {
            var defer = $q.defer();
            params.start = params.start.format('x');
            params.end = params.end.format('x');
            $http.get(API.attendance.detailedBoth + params.employeeId, {
                params: params
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        };

        self.getDetailedBothTypeAttendanceLogExcelReportUrl = function (params) {
            params.start = params.start.format('x');
            params.end = params.end.format('x');
            var url = API.attendance.detailedBothExcel + params.employeeId;
            url += "?start=" + params.start;
            url += "&end=" + params.end;
            url += "&count=" + 2000;
            url += "&page=" + params.page;
            url += "&token=" + authService.getLoggedInToken()
            return url;
        };


        self.saveManualEntryForBothTypeAttendance = function (data, employeeId) {
            var defer = $q.defer();
            $http.post(API.attendance.manualEntryForBothTypeAttendance + employeeId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        };

        self.createManualEntry = function (data) {
            var defer = $q.defer();
            $http.post(API.attendance.createManualEntry, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        };

        self.applyForManualEntry = function (data) {
            var defer = $q.defer();
            $http.post(API.attendance.createManualEntry, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        };

        self.createMissingPunch = function (data) {
            var defer = $q.defer();
            //console.log("POST request to " + API.attendance.createMissingPunch + " Post data " + JSON.stringify(data));
            $http.post(API.attendance.createMissingPunch, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        }

        self.getLateAttendanceHistory = function (employeeId, startDate, endDate) {
            var defer = $q.defer();

            $http.get(API.attendance.getLateAttendanceHistory + employeeId + '?startDate=' + startDate + '&endDate=' + endDate)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.lateAttendanceHistoryList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        }

        self.editManualEntry = function (data, applicationId) {
            var defer = $q.defer();
            $http.post(API.attendance.createManualEntry + applicationId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        };

        self.getManualEntryReport = function (params) {
            var defer = $q.defer();
            $http.get(API.attendance.getManualEntryReport, {
                params: {
                    employeeId: params.employeeId,
                    from: params.from,
                    to: params.to,
                    type: params.type,
                    page: params.page,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;
        }

        self.getManualEntryReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getManualEntryReportExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) return ("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + "&page=" + params.page;
            excelUrl = excelUrl + "&type=" + params.type;
            excelUrl = excelUrl + "&employeeId=" + params.employeeId;

            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;

        }

        self.deleteAttendanceLogEntry = function (employeeId, attendanceLogId) {
            var defer = $q.defer();
            var url = API.attendance.deleteAttendanceLogEntry + employeeId + "/" + attendanceLogId;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }


        self.getDailyReportExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = API.attendance.getDailyReportExcel;

            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            // if (params.employeeName)
            //     excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + ("&reportType=" + params.reportType);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        }
        self.getDailyReportAllPagesExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = API.attendance.getDailyReportExcelAllPages;

            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            // if (params.employeeName)
            //     excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + ("&reportType=" + params.reportType);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        }
        self.getDailyReportPdfUrl = function (params) {
            var defer = $q.defer();
            var pdfUrl = API.attendance.getDailyReportPdf;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            // if (params.employeeName)
            //     pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                pdfUrl = pdfUrl + "&reportType=" + params.reportType;
            pdfUrl = pdfUrl + ("&sortKey=" + params.sortKey);
            pdfUrl = pdfUrl + ("&order=" + params.order);
            pdfUrl = pdfUrl + ("&perPage=" + params.perPage);
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            pdfUrl = pdfUrl + ("&reportType=" + params.reportType);
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            //console.log("PDF URL IS : " + pdfUrl);
            return pdfUrl;
        }
        self.getDailyLateReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilterDailyLate;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    reportType: params.reportType,
                    absentType: params.absentType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        self.getDailyLateReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getDailyLateReportExcel;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to + "&reportType=" + params.reportType;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getDailyLateReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.getDailyLateReportPdf;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to + "&reportType=" + params.reportType;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
            pdfUrl = pdfUrl + "&perPage=" + params.perPage;
            pdfUrl = pdfUrl + "&sortKey=" + params.sortKey;
            pdfUrl = pdfUrl + "&order=" + params.order;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            // console.log(pdfUrl)
            return pdfUrl;
        }
        self.getDailyAbsentReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getDailyAbsentReportExcel;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&reportType=3";
            excelUrl = excelUrl + "&absentType=1";
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getDailyAbsentReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.getDailyAbsentReportPdf;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
            pdfUrl = pdfUrl + "&perPage=" + params.perPage;
            pdfUrl = pdfUrl + "&reportType=3";
            pdfUrl = pdfUrl + "&absentType=1";
            pdfUrl = pdfUrl + "&sortKey=" + params.sortKey;
            pdfUrl = pdfUrl + "&order=" + params.order;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            // console.log(pdfUrl)
            return pdfUrl;
        }
        self.getMonthlyAbsentReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getMonthlyAbsentReportExcel;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&reportType=3";
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getMonthlyAbsentReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.getMonthlyAbsentReportPdf;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
            pdfUrl = pdfUrl + "&perPage=" + params.perPage;
            pdfUrl = pdfUrl + "&reportType=3";
            pdfUrl = pdfUrl + "&sortKey=" + params.sortKey;
            pdfUrl = pdfUrl + "&order=" + params.order;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }

        self.getMonthlyReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getMonthlyReportExcelV5;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getDetailedMonthlyReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.getDetailedMonthlyReportPdfV5;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
            pdfUrl = pdfUrl + "&perPage=" + params.perPage;
            pdfUrl = pdfUrl + "&sortKey=" + params.sortKey;
            pdfUrl = pdfUrl + "&order=" + params.order;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }

        self.getDetailedMonthlyReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getDetailedMonthlyReportExcelV5;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getDetailedMonthlyReportExcelUrlAllPages = function (params) {
            var excelUrl = API.attendance.getDetailedMonthlyReportExcelAllPages;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getMonthlyReportPdfUrl = function (params) {
            var pdfUrl = API.attendance.getMonthlyReportPdfV5;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
            pdfUrl = pdfUrl + "&perPage=" + params.perPage;
            pdfUrl = pdfUrl + "&sortKey=" + params.sortKey;
            pdfUrl = pdfUrl + "&order=" + params.order;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }

        self.getLeaveBalanceReportExcelUrl = function (params) {
            var excelUrl = API.attendance.getLeaveBalanceReportExcel;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("leaveCategoryId", params.leaveCategoryId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            // excelUrl = excelUrl + "&employeeBeforeEndTime=" + params.employeeBeforeEndTime;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + "&year=" + params.year;

            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;

        }
        self.getLeaveHistoryReportExcelUrl = function (params) {
            return setLeaveHistoryUrlAndParam(params, API.attendance.getLeaveHistoryReportExcel)
        }
        self.getLeaveHistoryReportPdfUrl = function (params) {
            return setLeaveHistoryUrlAndParam(params, API.attendance.getLeaveHistoryReportPdf)
        }

        function setLeaveHistoryUrlAndParam(params, url) {
            var pdfUrl = url;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("leaveCategoryId", params.leaveCategoryId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if(params.leaveApprovalStatus!==undefined)
                pdfUrl = pdfUrl + "&approvalStatus=" + params.leaveApprovalStatus;
            pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
            pdfUrl = pdfUrl + "&employeeBeforeEndTime=" + params.employeeBeforeEndTime;
            pdfUrl = pdfUrl + "&perPage=" + params.perPage;
            pdfUrl = pdfUrl + "&sortKey=" + params.sortKey;
            pdfUrl = pdfUrl + "&order=" + params.order;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }
        self.getIndividualMonthlyAttendancePdfUrl = function (params, allowAllDownload) {
            var pdfUrl = API.attendance.getIndividualMonthlyAttendancePdf;
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to + "&pageNumber=" + params.pageNumber + "&perPage=" + params.perPage + "&employeeId=" + params.employeeId + "&unpaged=" + allowAllDownload
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }
        self.getIndividualMonthlyAttendanceExcelUrl = function (params, allowAllDownload) {
            var excelUrl = API.attendance.getIndividualMonthlyAttendanceExcel;
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to + "&pageNumber=" + params.pageNumber + "&perPage=" + params.perPage + "&employeeId=" + params.employeeId + "&unpaged=" + allowAllDownload;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }

        self.getDailyDiningReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getDailyDiningReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getMonthlyDiningReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getMonthlyDiningReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };
        
        self.getDetailedDiningReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getDetailedDiningReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.getLocationDeviationReport = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getLocationDeviation;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            $http.get(url, {
                params: getParamsObject(params)
            }).success(function (data, status) {
                if (status === RESPONSE_CODE.success) defer.resolve(data);
                else defer.reject(data && data.message);
            })
                .error(function (data) { defer.reject(data); });
            return defer.promise;
        };

        self.getLocationDeviationExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = "";
            excelUrl = API.attendance.getLocationDeviationExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };

        self.getLocationDeviationExcelAllPagesUrl = function (params) {
            var defer = $q.defer();
            var excelUrlAllPages = "";
            excelUrlAllPages = API.attendance.getLocationDeviationExcelAllPages;
            console.log(excelUrlAllPages)
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrlAllPages = excelUrlAllPages + "?from=" + params.from + "&to=" + params.to;
            excelUrlAllPages = excelUrlAllPages + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("subDepartmentId", params.subDepartmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status)
                + buildURLFromArray("attendanceStatus", params.attendanceStatus);
            if (params.employeeId && params.employeeId > 0)
                excelUrlAllPages = excelUrlAllPages + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrlAllPages = excelUrlAllPages + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrlAllPages = excelUrlAllPages + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null || params.sortKey == '' ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrlAllPages = excelUrlAllPages + ("&sortKey=" + params.sortKey);
            excelUrlAllPages = excelUrlAllPages + ("&order=" + params.order);
            excelUrlAllPages = excelUrlAllPages + ("&perPage=" + params.perPage);
            excelUrlAllPages = excelUrlAllPages + ("&pageNumber=" + params.pageNumber);
            excelUrlAllPages = excelUrlAllPages + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrlAllPages;
        };



//     self.getLocationDeviationReport = function (params) {
//         var defer = $q.defer();
//         var url = API.attendance.getLocationDeviation;
//         if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) {
//             defer.reject("invalid search criteria"); return defer.promise;
//         }
//         // reuse your standard param builder so filters work the same as Detailed Attendance
//         $http.get(url, { params: getParamsObject(params) })
//             .success(function (data, status) {
//                 if (status === RESPONSE_CODE.success) defer.resolve(data);
//                 else defer.reject(data && data.message);
//             })
//             .error(function (data) { defer.reject(data); });
//         return defer.promise;
//     };
//
// // Current Page (XLSX) — Spring (optional if you expose the endpoint)
//     self.getLocationDeviationExcelUrl = function (params) {
//         var excelUrl = API.attendance.getLocationDeviationExcel;
//         if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) return null;
//
//         excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
//         excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
//             + buildURLFromArray("employmentTypeId", params.employmentTypeId)
//             + buildURLFromArray("departmentId", params.departmentId)
//             + buildURLFromArray("subDepartmentId", params.subDepartmentId)
//             + buildURLFromArray("shiftGroupId", params.shiftGroupId)
//             + buildURLFromArray("genderId", params.genderId)
//             + buildURLFromArray("companyId", params.companyId)
//             + buildURLFromArray("officeId", params.officeId)
//             + buildURLFromArray("lineManagerId", params.lineManagerId)
//             + buildURLFromArray("hrManagerId", params.hrManagerId)
//             + buildURLFromArray("workplaceId", params.workplaceId)
//             + buildURLFromArray("status", params.status)
//             + buildURLFromArray("employeeId", params.employeeId)
//             + buildURLFromArray("employeeName", params.employeeName)
//             + buildURLFromArray("siteIds", params.siteIds);
//
//         params.sortKey = !params.sortKey ? 'empOfficeId' : params.sortKey;
//         params.order   = !params.order   ? 'asc'        : params.order;
//         excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
//         excelUrl = excelUrl + ("&order="   + params.order);
//         excelUrl = excelUrl + ("&perPage=" + params.perPage);
//         excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
//         excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
//
//         return excelUrl;
//     };
//
// // All Pages (XLSX) — Flask via Spring forwarder
//     self.getLocationDeviationExcelAllPagesUrl = function (params) {
//         var excelUrl = API.attendance.getLocationDeviationExcelAllPages;
//         if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) return null;
//
//         excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
//         excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
//             + buildURLFromArray("employmentTypeId", params.employmentTypeId)
//             + buildURLFromArray("departmentId", params.departmentId)
//             + buildURLFromArray("subDepartmentId", params.subDepartmentId)
//             + buildURLFromArray("shiftGroupId", params.shiftGroupId)
//             + buildURLFromArray("genderId", params.genderId)
//             + buildURLFromArray("companyId", params.companyId)
//             + buildURLFromArray("officeId", params.officeId)
//             + buildURLFromArray("lineManagerId", params.lineManagerId)
//             + buildURLFromArray("hrManagerId", params.hrManagerId)
//             + buildURLFromArray("workplaceId", params.workplaceId)
//             + buildURLFromArray("status", params.status)
//             + buildURLFromArray("employeeId", params.employeeId)
//             + buildURLFromArray("employeeName", params.employeeName)
//             + buildURLFromArray("siteIds", params.siteIds);
//
//         params.sortKey = !params.sortKey ? 'empOfficeId' : params.sortKey;
//         params.order   = !params.order   ? 'asc'        : params.order;
//         excelUrl = excelUrl + ("&sortKey=" + params.sortKey);
//         excelUrl = excelUrl + ("&order="   + params.order);
//         excelUrl = excelUrl + ("&perPage=" + params.perPage);
//         excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
//         excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
//
//         return excelUrl;
//     };

// current page JSON
        self.getMonthlyAIAnalysis = function (params) {
            var defer = $q.defer();
            var url = API.attendance.getByFilter + '/monthly-ai-analysis';
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) {
                defer.reject("invalid search criteria");
                return defer.promise;
            }

            $http.get(url, {
                params: {
                    from: params.from,
                    to: params.to
                }
            }).then(function (response) {
                defer.resolve(response.data);
            }, function (data) {
                defer.reject(data);
            });
            return defer.promise;
        };

    }


    app.service('attendanceService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', attendanceService]);

})();

(function () {

    'use strict';

    function authService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, FCM, analyticsService, INACTIVITY_DURATION, INACTIVITY_LOGOUT_DISABLED_OFFICE_IDS) {

        var self = this;
        var visitorManagementRoles = ['visitorManagementAdmin','visitorManagementReceptionist'];
        function loginHandler(data, headers, deviceId) {
            self.setLoggedInToken(data.token);
            self.setRefreshToken(data.refreshToken);
            self.setUserInfo(data.employee);
            self.saveMyOfficeInformation(data.employee.office);
            self.setDeviceId(deviceId);
            // $rootScope.$on('connect-socket');
        };

        function inactivityTime () {

            var office = self.getMyOfficeInformation();
            if(INACTIVITY_LOGOUT_DISABLED_OFFICE_IDS.includes(office.id)) return;

            var time;

            window.addEventListener('load', resetTimer, true);
            var events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
            events.forEach(function(name) {
                document.addEventListener(name, resetTimer, true);
            });

            function logout() {
                self.logout();
                events.forEach(function(name) {
                    document.removeEventListener(name, resetTimer, true);
                });
                alert("You were logged out due to inactivity. Please login again.")
            }

            // Timing is litte bit inaccurate, but performance friendly
            function resetTimer() {
                clearTimeout(time);
                time = setTimeout(logout, INACTIVITY_DURATION);
            }
        }

        self.fakeLogin = function () {
            self.setLoggedInToken("very nice token");
        };

        function firebaseLogin(deviceId) {
            FCM.requestPermission()
                .then(function () {
                    console.log('FCM: Notification permission granted.');
                    // TODO(developer): Retrieve an Instance ID token for use with FCM.
                    return FCM.getToken();
                })
                .then(function (firebaseToken) {
                    if (firebaseToken) {
                        // console.log("FCMToken & deviceId: ", firebaseToken, deviceId);
                        var data = {
                            'firebaseToken': firebaseToken,
                            'deviceId': deviceId,
                            'deviceType': 'WEB'
                        };
                        $http.post(API.firebase.signin, data)
                            .success(function (data, status, headers, config) {
                                console.log("Firebase Login Response from inovace server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                                // if (status === RESPONSE_CODE.success) {
                                    // loginHandler(data, headers, deviceId);
                                    // $state.go('dashboard');
                                // }
                                // else {
                                //     defer.reject(data.message ? data.message : "");
                                // }
                            })
                            .error(function (data, status, headers, config) {
                                if (status == -1) {
                                    defer.reject(null);
                                } else {
                                    //console.log("Login Response from server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                                    defer.reject(data.message ? data.message : "");
                                }
                            });
                        /**
                         * FCMSupport true: ["Chrome: 50+", "Firefox: 44+", "Opera Mobile: 37+"] && User allowed notification
                         * */
                        // $localStorage.FCMSupport = firebaseToken;
                    }
                }, function (data, status) {
                    /**
                     * FCMSupport false: !["Chrome: 50+", "Firefox: 44+", "Opera Mobile: 37+"] || User NOT allowed notification
                     * */
                    console.error("Error FCM login: ", data, status);
                })
                .catch(function (err) {
                    $localStorage.FCMSupport = false;
                    console.log('FCM Unable to get permission to notify.', err);
                });
        }

        self.login = function (data) {
            var defer = $q.defer();
            var deviceId = self.uuidv4();
            data['deviceId'] = deviceId;
            //console.log("posting " + JSON.stringify(data) + " to url : " + API.auth.signin);
            $http.post(API.auth.signin, data)
                .success(function (data, status, headers, config) {
                    //console.log("Login Response from server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                    if (status === RESPONSE_CODE.success) {
                        loginHandler(data, headers, deviceId);
                        // Disabled auto-logout due to inactivity
                        // inactivityTime();
                        if(firebase.messaging.isSupported()) firebaseLogin(deviceId);
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message ? data.message : "");
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        //console.log("Login Response from server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.uuidv4 = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };

        // self.loginWithLinkedIn = function(provider){
        //
        //     var defer = $q.defer();
        //     $auth.authenticate(provider).then(function(userData){
        //         loginHandler(userData.data.data);
        //         $state.go('home');
        //     });
        //     return defer.promise;
        // };

        self.logout = function () {
            var user = self.getLoggedInUser();

            var analyticsId = analyticsService.getAnalyticsId();
            gtag('event', "logout_successful", {
                'send_to': analyticsId,
                'page_title': 'Tipsoi - Logout',
                'page_location'  : window.location.href,
                'companyName' : user.office.company.name?user.office.company.name:"-",
                'officeName' : user.office.name?user.office.name:"-",
                'employeeName': user.name? user.name:"-",
                'employeeRole': user.roles? user.roles:"-",
                'employeeEmail': user.email? user.email:"-",

            });

            $http.post(API.auth.signout, {
                'deviceId': self.getDeviceId()
            }).then(function () {
                self.clearSession();
                $state.go('login');
            }, function () {
                self.clearSession();
                $state.go('login');
            });
        };


        self.setUserInfo = function (userInfo) {
            userInfo.roles = [];
            if(userInfo.isGroupAdmin) userInfo.roles.push('groupAdmin')
            if(userInfo.isCompanyAdmin) userInfo.roles.push('companyAdmin')
            if(userInfo.isAdmin) userInfo.roles.push('admin')
            if(userInfo.isHrManager) userInfo.roles.push('hrManager')
            if(userInfo.isLineManager) userInfo.roles.push('lineManager')
            if(userInfo.isPayrollApprover) userInfo.roles.push('payrollApprover')
            if(userInfo.isPayrollManager) userInfo.roles.push('payrollManager')
            if(userInfo.isVisitorManagementAdmin) userInfo.roles.push('visitorManagementAdmin')
            if(userInfo.isSiteManagementAdmin) userInfo.roles.push('siteManagementAdmin')
            if(userInfo.isSiteManagementManager) userInfo.roles.push('siteManagementManager')
            if(userInfo.isVisitorManagementReceptionist) userInfo.roles.push('visitorManagementReceptionist')
            if(userInfo.isParkingOperationsManager) userInfo.roles.push('parkingOperationManager')
            if(userInfo.roles.every(function (item) {
                return !visitorManagementRoles.includes(item);
            })){
                userInfo.roles.push('visitorManagementEmployee');
            }
            $rootScope.loggedInUser = userInfo;
            $window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
        };

        self.getOfficeName = function () {
            var user = self.getLoggedInUser();
            if (user.isCompanyAdmin) return user.office.company.clientPanelTitle;
            return user.office.clientPanelTitle;
        };

        self.getOfficeLogoUrl = function () {
            var user = self.getLoggedInUser();
            return user.office.logoUrl;
        };

        self.getOfficeLogoUrl2 = function () {
            var user = self.getLoggedInUser();
            return user.office.logoUrl2;
        };

        self.getOfficeLogoUrl3 = function () {
            var user = self.getLoggedInUser();
            return user.office.logoUrl3;
        };

        self.isAdmin = function () {
            if (!self) return false;
            var user = self.getLoggedInUser();
            if (!user) return false;
            return user.isAdmin || user.isCompanyAdmin || user.isHrManager || user.isGroupAdmin;
        };

        self.isLineManager = function () {
            if (!self) return false;
            var user = self.getLoggedInUser();
            if (!user) return false;
            return user.isLineManager;
        };

        self.setLoggedInToken = function (token) {
            $window.localStorage.setItem('token', token);
        };

        self.setDeviceId = function (deviceId) {
            $window.localStorage.setItem('deviceId', deviceId);
        };

        self.setRefreshToken = function (token) {
            $window.localStorage.setItem('refresh-token', token);
        };

        self.getLoggedInId = function () {
            return self.getAllInformation().id;
        };

        self.getLoggedInToken = function () {
            return $window.localStorage.getItem('token');
        };

        self.getDeviceId = function () {
            return $window.localStorage.getItem('deviceId');
        };

        self.getRefreshToken = function () {
            return $window.localStorage.getItem('refresh-token');
        };

        self.getLoggedInUser = function () {
            return self.getAllInformation();
        };

        self.updateAField = function (fieldName, value) {
            var userInfo = self.getAllInformation();
            userInfo[fieldName] = value;
            self.setUserInfo(userInfo);
        };

        self.updateUserInfo = function (data) {
            var userInfo = self.getAllInformation();
            angular.extend(userInfo, data);
            self.setUserInfo(userInfo);
        };

        self.updateUserDetailedInfo = function (data) {
            var userInfo = self.getAllInformation();
            angular.extend(userInfo.employeeDetails, data);
            self.setUserInfo(userInfo);
        };

        self.addDocumentToUserInfo = function (employeeDocument) {
            var userInfo = self.getAllInformation();
            userInfo.documents.push(employeeDocument);
            self.setUserInfo(userInfo);
        };

        self.addAddressToUserInfo = function (address) {
            var userInfo = self.getAllInformation();
            // userInfo.addresses.push(address);
            self.setUserInfo(userInfo);
        };

        self.getAllInformation = function () {

            return JSON.parse($window.localStorage.getItem('userInfo')) || {};
        };

        self.isAuthenticated = function () {
            return !!$window.localStorage.getItem('token');
        };

        self.clearSession = function () {
            $window.localStorage.clear();
        };

        self.getPermittedModules = function () {
            return self.getAllInformation().modules;
        };

        self.saveMyOfficeInformation = function (office) {
            self.myOffice = office;
            $window.localStorage.setItem('myOffice', JSON.stringify(office));
        };

        self.getMyOfficeInformation = function () {
            if (self && self.myOffice) return self.myOffice;
            return JSON.parse($window.localStorage.getItem('myOffice')) || {};
        };
        self.isEmployeeOnly = function () {
            var user =  self.getLoggedInUser()
            return !(user.isAdmin || user.isHrManager || user.isLineManager || user.isCompanyAdmin || user.isGroupAdmin)
        };

        self.isGeneralEmployeeOrLineManager = function () {
            var user =  self.getLoggedInUser()
            return !(user.isAdmin || user.isHrManager || user.isCompanyAdmin || user.isGroupAdmin)
        };

        self.subsidiaryName = function () {
            var user =  self.getLoggedInUser()
            if(user.subsidiaryName){
                return user.subsidiaryName;
            }
        }
    }

    app.service('authService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'FCM', 'analyticsService', 'INACTIVITY_DURATION', 'INACTIVITY_LOGOUT_DISABLED_OFFICE_IDS', authService]);

})();

(function () {
    'use strict';
    function bankManagementService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;


        self.getAllBanks = function () {
            var defer = $q.defer();
            var url = API.bankManagement.getAllBanks;

            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getAllBranches = function () {
            var defer = $q.defer();
            var url = API.bankManagement.getAllBranches;

            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.createNewBank = function (formData){
            var defer = $q.defer();
            var url = API.bankManagement.createNewBank;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateBank = function (formData){
            var defer = $q.defer();
            var url = API.bankManagement.updateBank;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.createNewBranch = function (formData){
            var defer = $q.defer();
            var url = API.bankManagement.createNewBranch;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateBranch = function (formData){
            var defer = $q.defer();
            var url = API.bankManagement.updateBranch;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getAdviceLetterDownloadUrl = function (record) {
            var url = API.bankManagement.downloadAdviceLetter;
            return url + "?bankId=" + record.bankId + "&monthlySalaryId=" + record.monthlySalaryId + "&token=" + authService.getLoggedInToken();
        };
        self.saveBankPaymentAdviceEditorData = function (bankId,data){
            var defer = $q.defer();
            var url = API.bankManagement.saveBankPaymentAdviceEditorData + bankId;
            $http.post(url,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };
        self.getBankPaymentAdviceEditorData = function (bankId){
                var defer = $q.defer();
                var url = API.bankManagement.getBankPaymentAdviceEditorData+bankId;

                $http.get(url).success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                }).error(function (data, status, headers, config) {
                    defer.reject(data);
                });

                return defer.promise;

            }


    }

    app.service('bankManagementService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', bankManagementService]);
})();
(function(){

    'use strict';

    function companyService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllCompanies = function(loadFromServer) {
            var defer = $q.defer();
            var companyList = getCompanyList();
            if(loadFromServer === true || !companyList || !companyList.length) {
                // console.log("get request to url : " + API.company.all);
                $http.get(API.company.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            saveLocally(data);
                            defer.resolve(data.companyList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else {
                defer.resolve(companyList);
            }
            return defer.promise;
        };

        self.getCompany = function(loadFromServer,companyId) {
            var defer = $q.defer();
            var company = null;
            if(loadFromServer === true) {
                // console.log("get request to url : " + API.company.all+companyId);
                $http.get(API.company.all+companyId)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.company);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else {
                defer.resolve(company);
            }
            return defer.promise;
        };

        self.createCompany = function (data) {
            var defer = $q.defer();
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ API.company.all);

            $http.post(API.company.all,data)
                .success(function(responseData, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        self.getAllCompanies(true).then(function (companyList)
                        {
                            defer.resolve(companyList);
                        }, function () {
                            defer.resolve(getCompanyList());
                        });
                    }
                    else {
                        defer.resolve(getCompanyList());
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;


        };

        self.updateCompanyInfo = function (data,companyId) {
            var defer = $q.defer();
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ API.company.all + companyId);

            $http.post(API.company.all + companyId,data)
                .success(function(responseData, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        self.getAllCompanies(true).then(function (companyList)
                        {
                            defer.resolve(companyList);
                        }, function () {
                            defer.resolve(getCompanyList());
                        });
                    }
                    else {
                        defer.resolve(getCompanyList());
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;


        };

        function saveLocally(data) {
            $window.localStorage.setItem('companyList', JSON.stringify(data.companyList)) ;
        }

        function getCompanyList(){
            return JSON.parse($window.localStorage.getItem('companyList')) || {};
        }



    }
    app.service('companyService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', companyService]);

})();
(function () {

    'use strict';

    function dashboardService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, $timeout) {

        var self = this;

        var dummyData = {
            'dashboard': {
                'totalEmployee': 100,
                'present': 82,
                'absent': 18,
                'onTime': 62,
                'late': 20,
                'departments': [
                    {
                        'id': 1,
                        'name': 'Software Engineering',
                        'data': [10, 2, 2, 38],
                        'totalEmployee': 52,
                        'present': 48,
                        'absent': 2,
                        'onTime': 38,
                        'late': 2
                    },
                    {
                        'id': 2,
                        'name': 'Hardware Engineering',
                        'data': [13, 1, 2, 4],
                        'totalEmployee': 20,
                        'present': 17,
                        'absent': 2,
                        'onTime': 4,
                        'late': 13
                    }, {
                        'id': 3,
                        'name': 'Test Engineering',
                        'data': [2, 0, 1, 7],
                        'totalEmployee': 10,
                        'present': 20,
                        'absent': 2,
                        'onTime': 18,
                        'late': 2
                    }
                ]
            }
        };

        self.getOverallSummaryAndDepartmentAttendance = function (params) {
            var defer = $q.defer();
            var url = API.dashboard.getOverallAndDepartmentWiseAttendance;

            $http.get(url, {
                params: {
                    from: params.attDateInMillis,
                    to: params.attDateInMillis + (24 * 60 * 60 * 1000 - 1),
                    subsidiaryId: params.subsidiaryIds,
                    employmentTypeId: params.employmentTypeIds,
                    workplaceId: params.workplaceIds
                }
            })
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getOverallAndOfficeWiseAttendance = function () {
            var defer = $q.defer();
            var url = API.dashboard.getOverallAndOfficeWiseAttendance;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAttendanceFeed = function () {
            var defer = $q.defer();
            var url = API.dashboard.getAttendanceFeed;
            //console.log("getAttendanceFeed : get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.attendanceFeedEntryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getTopFiveLates = function(){
            var defer = $q.defer();
            var url = API.dashboard.getTopFiveLate;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.lateResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getTopFiveLeastLates = function(){
            var defer = $q.defer();
            var url = API.dashboard.getTopFiveLeastLate;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.lateResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getCompanyAttendanceFeed = function () {
            var defer = $q.defer();
            var url = API.dashboard.getCompanyAttendanceFeed;
            //console.log("getAttendanceFeed : get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.attendanceFeedEntryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length <=0 ) return "";
            var url = key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.getDashboardDataWithFilter = function (filterData) {
            var defer = $q.defer();
            var url = API.dashboard.getDataWithFilter;
            if (filterData.date) url = url + "?date=" + filterData.date;
            if (filterData.shift) url = url + "?shift=" + filterData.shifts.toString();
            //console.log("get request to url : " + url);
            $http.get(url)
                .success(function (responseData, status, headers, config) {
                    if (status > 0 && status === 200) {
                        defer.resolve(responseData); //TODO response.dashboard
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (responseData, status, headers, config) {
                    defer.reject(responseData.message);
                });
        };

        self.getOverAllCounts = function () {
            var dashboardData = self.getFullDashboardData(false);
            var clone = Object.assign({}, dashboardData);
            delete clone.departments;
            return clone;
        };

        self.getDepartmentWiseCounts = function () {
            var dashboardData = self.getFullDashboardData(false);
            return dashboardData.departments;
        };

        //TODO by default, whenever anyone comes to dashboard page, the default dashboard data is provided.
        //TODO If they search via filter, that data will not be stored and will be lost as soon as they switch to another state.


        self.getOverallAndCompanyWiseAttendance = function () {
            var defer = $q.defer();
            var url = API.groupDashboard.getOverAllAndCompanyWiseAttendance;
            // console.log("Get request to " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getGroupAttendanceFeed = function () {
            var defer = $q.defer();
            var url = API.groupDashboard.getAttendanceFeed;
            // console.log("getAttendanceFeed : get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.attendanceFeedEntryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getCompanyTopFiveAbsents = function(){
            var defer = $q.defer();
            var url = API.groupDashboard.getTopFiveAbsents;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.absents);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getCompanyTopFiveLeastAbsents = function(){
            var defer = $q.defer();
            var url = API.groupDashboard.getTopFiveLeastAbsents;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.absents);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getCompanyList = function(){
            var defer = $q.defer();
            var url = API.groupDashboard.getCompanyList;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.companies);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getSubscriptionStatus = function () {
            var defer = $q.defer();
            var url = API.dashboard.getSubscriptionStatus;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getOccupancy = function () {
            var defer = $q.defer();
            var url = API.dashboard.occupancy;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getOccupancyExcelReport = function () {
            var defer = $q.defer();
            $http.get(API.dashboard.occupancyReportExcel, {
                responseType : 'blob'})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve({data:data, headers:config});
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getLateFeed = function (params) {
            var defer = $q.defer();
            var url = API.dashboard.lateFeed;

            var httpConfig = {};
            if (params) {
                httpConfig.params = {
                    from: params.attDateInMillis,
                    to: params.attDateInMillis + (24 * 60 * 60 * 1000 - 1),
                    subsidiaryId: params.subsidiaryIds,
                    employmentTypeId: params.employmentTypeIds,
                    workplaceId: params.workplaceIds
                };
            }
            $http.get(url, httpConfig)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data) {
                    defer.reject(data && data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getLeaveFeed = function (params) {
            var defer = $q.defer();
            var url = API.dashboard.leaveFeed;

            var httpConfig = {};

            if (params) {
                httpConfig.params = {
                    from: params.attDateInMillis,
                    to: params.attDateInMillis + (24 * 60 * 60 * 1000 - 1),
                    subsidiaryId: params.subsidiaryIds,
                    employmentTypeId: params.employmentTypeIds,
                    workplaceId: params.workplaceIds
                };
            }
            $http.get(url, httpConfig)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data) {
                    defer.reject(data && data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getOnTimeFeed = function () {
            var defer = $q.defer();
            var url = API.dashboard.onTimeFeed;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getBestAttendanceFeed = function () {
            var defer = $q.defer();
            var url = API.dashboard.bestAttendancesFeed;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getTodayBirthdays = function () {
            var defer = $q.defer();
            var url = API.dashboard.birthday;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data && data.message ? data.message : "Failed to retrieve today's birthdays.");
                });

            return defer.promise;
        };
    }

    app.service('dashboardService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', '$timeout', dashboardService]);

})();
(function () {

    'use strict';

    function departmentService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllDepartments = function (includeInactive) {
            var defer = $q.defer();
            var url = API.department.all + "?includeInactive=" + (includeInactive == true ? includeInactive : false);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.departmentList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createDepartment = function (data) {
            var defer = $q.defer();
            $http.post(API.department.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.department);
                    } else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateDepartmentInfo = function (data, departmentId) {
            var defer = $q.defer();
            $http.post(API.department.list + departmentId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.department);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


    }

    app.service('departmentService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', departmentService]);

})();
(function () {

    'use strict';

    function designationService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllDesignations = function () {
            var defer = $q.defer();
            $http.get(API.designation.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.designationList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createDesignation = function (data) {
            var defer = $q.defer();

            $http.post(API.designation.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.designation);
                    } else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateDesignationInfo = function (data, designationId) {
            var defer = $q.defer();
            $http.post(API.designation.all + designationId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.designation);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


    }

    app.service('designationService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', designationService]);

})();
(function(){

    'use strict';

    function deviceService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getAllDevices = function (officeId) {
            var defer = $q.defer();
            officeId = officeId == undefined?'':officeId;
            //console.log("get request to url : " + API.device.getAll+"?officeId="+officeId);
            $http.get(API.device.getAll+"?officeId="+officeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.devices);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllScheduledAllocations = function (searchString, perPage, pageNo) {
            var defer = $q.defer();
            $http.get(API.device.getAllScheduledAllocations+"?search=" + searchString + "&per_page=" + perPage + "&page_no=" + pageNo)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllDevicesWithEnrolmentFeature = function (officeId) {
            var defer = $q.defer();
            officeId = officeId == undefined?'':officeId;
            // console.log("get request to url : " + API.device.getAllWithEnrolmentFeature+"?officeId="+officeId);
            $http.get(API.device.getAllWithEnrolmentFeature+"?officeId="+officeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.devices);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.allocateEmployee = function (urlParams) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.allocate+urlParams.deviceId+'/'+urlParams.personId+'/'+urlParams.action);
            $http.post(API.device.allocate+urlParams.deviceId+'/'+urlParams.personId+'/'+urlParams.action)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.allocateOrRevokeEmployees = function (request) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.allocate+urlParams.deviceId+'/'+urlParams.personId+'/'+urlParams.action);
            $http.post(API.device.allocateEmployee,request)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
        self.allocateOrRevokeEmployeesToAccessArea = function (request) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.allocate+urlParams.deviceId+'/'+urlParams.personId+'/'+urlParams.action);
            $http.post(API.device.allocateOrRevokeEmployeeToAccessArea,request)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.allocateEmployeeBatch = function (data, deviceId) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.batchAllocate + deviceId );
            $http.post(API.device.batchAllocate + deviceId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.revokeEmployeeBatch = function (data, deviceId) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.batchRevoke + deviceId );
            $http.post(API.device.batchRevoke + deviceId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.allocateEmployeeBatchToManyDevices = function (data) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.batchAllocate + deviceId );
            $http.post(API.device.allocateBatchToManyDevice,data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllocationsInDevice = function (deviceId) {
            var defer = $q.defer();
            //console.log("get request to url : " + API.device.getAllocations+deviceId);
            $http.get(API.device.getAllocations+deviceId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.allocations);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getDeviceDetails = function (deviceId) {
            var defer = $q.defer();
            //console.log("get request to url : " + API.device.getAll+deviceId);
            $http.get(API.device.getAll+deviceId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.device);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllocatedAndUnallocatedInADevice = function (params) {
            var defer = $q.defer();
            var url = API.device.getAllocatedAnUnallocated;
            // console.log("get request to url : " + API.device.getAllocatedAnUnallocated+deviceId);
            $http.get(url, {params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.allocateTemporarily = function (data,deviceId) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.temporarilyAllocate + deviceId );
            $http.post(API.device.temporarilyAllocate + deviceId,data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getDevicesOfEmployee = function (employeeIdentifier) {
            var defer = $q.defer();
            //console.log("get request to url : " + API.device.employeeAllocations+employeeIdentifier);
            $http.get(API.device.employeeAllocations+employeeIdentifier)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.generalDeviceList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getTemporaryAllocationsHistory = function (employeeId,params){
          var defer = $q.defer();

          $http.get(API.temporaryPermissions.getTemporaryPermissionsHistory + employeeId,{params:params})
              .success(function (data){
                  defer.resolve(data);
              })
              .error(function (data){
                  defer.reject(data.message);
              })
            return defer.promise;
        }

        self.stopEnrolmentOfADevice = function (deviceId) {
            var defer = $q.defer();
            //console.log("post request to url : " + API.device.stopEnrolment+deviceId);
            $http.get(API.device.stopEnrolment+deviceId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.startEnrolmentOfADevice = function (deviceId) {
            var defer = $q.defer();
            //console.log("post request to url : " + API.device.startEnrolment+deviceId);
            $http.get(API.device.startEnrolment+deviceId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.startPersonEnrolmentOfADevice = function (data) {
            var defer = $q.defer();
            console.log("post request to url : " + API.device.personEnrolmentStart);
            $http.post(API.device.personEnrolmentStart,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }


        self.getEnrolmentStatsOfDevice = function (deviceId,employeeId) {
            var defer = $q.defer();
            // console.log("GET request to url : " + API.device.enrolmentStats+deviceId);
            $http.get(API.device.enrolmentStats+"?deviceId="+deviceId+"&employeeId="+employeeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.updateDeviceInformation = function (deviceId, data) {
            var defer = $q.defer();
            var url = API.device.updateDevice + deviceId;

            $http.put(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.devices);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.allocateEveryone = function () {
            var defer = $q.defer();
            var url = API.device.allocateEveryone;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getTemporaryAllocationsInADevice = function (params){
            var defer = $q.defer();
            var url = API.device.getTemporaryPermissions;

            $http.get(url,{params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        }

        self.cancelOrRevokeTemporaryAllocations = function (requestObject){
            var defer = $q.defer();
            var url = API.temporaryPermissions.cancelOrRevoke;
            $http.post(url,requestObject)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        }
        self.allocateMultipleTemporarily = function (data) {
            var defer = $q.defer();
            //console.log("post request to url: " + API.device.temporarilyAllocate + deviceId );
            $http.post(API.device.temporarilyAllocateMultiple ,data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

    }
    app.service('deviceService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', deviceService]);

})();
(function () {

    'use strict';

    function employeeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                             message, authService) {

        var self = this;

        self.deleteEmployee = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.delete, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
        self.resignEmployee = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.resign, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.rehireEmployee = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.rehire, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createEmployee = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.create, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
        self.getAllEmployees = function () {
            var defer = $q.defer();
            //console.log("get request to url : " + API.employee.all);
            $http.get(API.employee.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getFilteredEmployees = function (searchParams) {
            var defer = $q.defer();
            var url = API.employee.all;
            var params = {
                companyId     : searchParams.companyId == null || searchParams.companyId.length == 0 ? [] : searchParams.companyId,
                officeId      : searchParams.officeId == null || searchParams.officeId.length == 0 ? [] : searchParams.officeId,
                departmentId  : searchParams.departmentId == null || searchParams.departmentId.length == 0 ? [] : searchParams.departmentId,
                subDepartmentId: searchParams.subDepartmentId == null || searchParams.subDepartmentId.length == 0 ? [] : searchParams.subDepartmentId,
                designationId : searchParams.designationId == null || searchParams.designationId.length == 0 ? [] : searchParams.designationId,
                shiftId       : searchParams.shiftId == null || searchParams.shiftId.length == 0 ? [] : searchParams.shiftId,
                shiftGroupId  : searchParams.shiftGroupId == null || searchParams.shiftGroupId.length == 0 ? [] : searchParams.shiftGroupId,
                employmentTypeId  : searchParams.employmentTypeId == null || searchParams.employmentTypeId.length == 0 ? [] : searchParams.employmentTypeId,
                genderId      : searchParams.genderId == null || searchParams.genderId.length == 0 ? [] : searchParams.genderId,
                status        : searchParams.status == null || searchParams.status.length == 0 ? [] : searchParams.status,
                workplaceId   : searchParams.workplaceId == null || searchParams.workplaceId.length == 0 ? [] : searchParams.workplaceId,
                lineManagerId   : searchParams.lineManagerIds == null || searchParams.lineManagerIds.length == 0 ? [] : searchParams.lineManagerIds,
                subsidiaryId  : searchParams.subsidiaryId == null || searchParams.subsidiaryId.length == 0 ? [] : searchParams.subsidiaryId,
                perPage       : searchParams.perPage,
                pageNumber    : searchParams.pageNumber,
                sortKey       : searchParams.sortKey,
                order         : searchParams.order,
                selectAll     : searchParams.selectAll,
                employeeName    :searchParams.searchKeyEmployee==null||searchParams.searchKeyEmployee==""?null:searchParams.searchKeyEmployee,
                mobilePunchStatus : searchParams.mobilePunchStatus == null || searchParams.mobilePunchStatus.length == 0 ? [] : searchParams.mobilePunchStatus,
            };
            if (searchParams.employeeName)
                params.employeeName = searchParams.employeeName;
            if(!!searchParams.employeeOfficeId && searchParams.employeeOfficeId.trim().length > 0)
                params.employeeOfficeId = searchParams.employeeOfficeId.trim();
            if(!!searchParams.centralServerPeopleId && searchParams.centralServerPeopleId.trim().length > 0)
                params.centralServerPeopleId = searchParams.centralServerPeopleId.trim();

            $http.get(url,{
                params : params
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.getFilteredEmployeeNames = function (params) {
            var defer = $q.defer();
            var url = API.employee.getFilteredEmployeeNames;
            var queryParams = {
                officeId            : params.officeIdList == null || params.officeIdList == undefined || params.officeIdList.length == 0 ? [] : params.officeIdList,
                status              : params.status == null || params.status.length == 0 ? [] : params.status,
                excludedEmployeeIds : params.excludedEmployeeIds == null || params.excludedEmployeeIds.length == 0 ? [] : params.excludedEmployeeIds
            };
            if(params.onlyLineManagers)
                queryParams.onlyLineManagers = true;
            if(params.onlyHrManagers){
                queryParams.onlyHrManagers = true;
            }
            if(params.onlyPayrollEnabled) {
                queryParams.onlyPayrollEnabled = true;
            }
            $http.get(url,{
                params :queryParams
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getFilteredEmployeeNamesPost = function (params) {
            var defer = $q.defer();
            var url = API.employee.getFilteredEmployeeNames;
            var queryParams = {
                officeId            : params.officeIdList == null || params.officeIdList == undefined || params.officeIdList.length == 0 ? [] : params.officeIdList,
                status              : params.status == null || params.status.length == 0 ? [] : params.status,
                excludedEmployeeIds : params.excludedEmployeeIds == null || params.excludedEmployeeIds.length == 0 ? [] : params.excludedEmployeeIds,
                lineManagerId       : params.lineManagerId == null ? null : params.lineManagerId,
            };
            if(params.onlyLineManagers)
                queryParams.onlyLineManagers = true;
            if(params.onlyHrManagers){
                queryParams.onlyHrManagers = true;
            }
            if(params.onlyPayrollEnabled) {
                queryParams.onlyPayrollEnabled = true;
            }

            $http.post(url, queryParams)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getProfile = function (employeeId) {
            var defer = $q.defer();
            $http.get(API.employee.getProfile + (employeeId ? employeeId : ''))
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message);
                });
            return defer.promise;
        };

        self.getManualEntryHistoryOfEmployee = function (params,employeeId) {
            var defer = $q.defer();
            $http.get(API.manualEntry.getManualEntryHistory + (employeeId ? employeeId : ''),{params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message);
                });
            return defer.promise;
        };

        self.getEmployeeDetails = function (id) {
            var defer = $q.defer();
            $http.get(API.employee.getDetailsInfo + id)
                .success(function(data, status){
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employeeDetails);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function(err){
                    defer.reject(data.message);
                });
            return defer.promise;
        };

        self.getEmployeeAddresses = function (id) {
            var defer = $q.defer();
            $http.get(API.employee.getAddressListOfEmployee.prefix + id + API.employee.getAddressListOfEmployee.suffix)
                .success(function(data, status){
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.addressList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function(err){
                    defer.reject(data.message);
                });
            return defer.promise;
        };

        self.findById = function (id) {
            var defer = $q.defer();
            var data = {
                userId: id
            };
            $http.post(API.user.findById, data)
                .success(function (results) {
                    if (results.response_code === RESPONSE_CODE.success) {

                        defer.resolve(results.data);
                    }
                    else if (results.response_code === RESPONSE_CODE.error) {
                        defer.resolve(null);
                    }

                }).error(function (data) {
                defer.reject(data.message ? data.message : "");
            });
            return defer.promise;
        };

        self.updateBasicInfo = function (data, employeeId) {

            var defer = $q.defer();
            //console.log("posting " + JSON.stringify(data) + " to url : " + API.employee.updateBasicInfo + employeeId);
            $http.post(API.employee.updateBasicInfo + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };
        self.changeEmployeeSite = function (data, employeeId) {

            var defer = $q.defer();
            //console.log("posting " + JSON.stringify(data) + " to url : " + API.employee.updateBasicInfo + employeeId);
            $http.post(API.employee.changeEmployeeSite + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.batchAssignLineManager = function (data) {

            var defer = $q.defer();
            $http.post(API.employee.updateLineManager, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.batchAssignShiftGroup = function (data, shiftGroupId) {

            var defer = $q.defer();
            $http.post(API.employee.updateBatchShiftGroup + shiftGroupId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.batchAssignHrManager = function (data) {

            var defer = $q.defer();
            //console.log("posting " + JSON.stringify(data) + " to url : " + API.employee.updateBasicInfo + employeeId);
            $http.post(API.employee.updateHrManager, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.updateAddress = function (data, employeeId, addressId) {

            var defer = $q.defer();
            $http.post(API.employee.updateAddress.prefix + employeeId + API.employee.updateAddress.suffix + addressId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {

                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.changeManagerOrAdminRole = function (data, employeeId) {

            var defer = $q.defer();
            var url = API.employee.updateManagerOrAdminRole.prefix + employeeId + API.employee.updateManagerOrAdminRole.suffix;
            // console.log("posting " + JSON.stringify(data) + " to url : " + url);
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.getShiftAssignmentStatus = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.getShiftAssignmentStatus.prefix + employeeId + API.employee.getShiftAssignmentStatus.suffix;

            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data["can_assign_shift"]);
                    } else {
                        defer.reject("Failed to get shift assignment status");
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject("Failed to get shift assignment status");
                });

            return defer.promise;
        };


        self.toggleLineManagerShiftAssignment = function (data, employeeId) {
            // todo
            var defer = $q.defer();
            var url = API.employee.toggleLineManagerShiftManagement.prefix + employeeId + API.employee.toggleLineManagerShiftManagement.suffix;

            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.updateReportPosition = function (data, employeeId) {

            var defer = $q.defer();
            var url = API.employee.updateReportPosition.prefix + employeeId + API.employee.updateReportPosition.suffix;
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.updatePassword = function (data, employeeId, isEmployee) {
            var defer = $q.defer();
            var url = '';
            isEmployee ? url = API.employee.updatePasswordEmployee + employeeId : url = API.employee.updatePassword + employeeId;
            // console.log("posting " + JSON.stringify(data) + " to url : " + url);
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    console.log(data, status, headers, config);
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.uploadProfilePicture = function (file, employeeId) {

            var defer = $q.defer();
            //console.log("posting to url : " + API.employee.uploadProfilePicture + employeeId);
            var formData = new FormData();
            formData.append('file', file);
            $http.post(API.employee.uploadProfilePicture + employeeId, formData, {
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular.identity,
            }).success(function (responseData, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    if (authService.getLoggedInId() === employeeId) {
                        authService.updateUserInfo(data);
                    }
                    defer.resolve();
                }
                else {
                    defer.reject(responseData.message);
                }
            })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.uploadDocument = function (description, documentType, file, userId) {
            var defer = $q.defer();
            var url = API.employee.uploadDocument + userId+'/document/';
            //console.log("posting to url : " + url);
            var requestJSON = {};
            requestJSON.description = description;
            requestJSON.type = documentType;
            var formData = new FormData();
            formData.append("file", file);
            formData.append("request", JSON.stringify(requestJSON));
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetterFunction) {
                    return data;
                }

            }).success(function (response, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    // if (authService.getLoggedInId() == userId) {
                    //     authService.addDocumentToUserInfo(response.documentList);
                    // }
                    defer.resolve(response.documentList);
                }
                else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, headers, config) {
                if (status == -1) {
                    defer.reject(null);
                } else {
                    defer.reject(data.message ? data.message : "");
                }
            });
            return defer.promise;
        };

        self.removeEmployeeProfilePicture = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.removeProfilePicture + employeeId;
            //console.log("Post request to url : " + url);
            $http.post(url)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() == employeeId) {
                            authService.updateUserInfo({'employeePicture': null});
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                }).error(function (data, status, headers, config) {
                if (status == -1) {
                    defer.reject(null);
                } else {
                    defer.reject(data.message ? data.message : "");
                }
            });
            return defer.promise;
        };

        self.createAddress = function (data, employeeId) {
            var defer = $q.defer();
            var url = API.employee.createAddress.prefix + employeeId + API.employee.createAddress.suffix;
            //console.log("posting " + JSON.stringify(data) + " to url : " + url);
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.addAddressToUserInfo(responseData.address);
                        }
                        defer.resolve(responseData.address);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.deleteAddress = function (id) {
            var defer = $q.defer();
            var url = API.employee.deleteAddress+id;
            //console.log("posting " + JSON.stringify(data) + " to url : " + url);
            $http.post(url)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.updateEmployeeDetailedInfo = function (data, employeeId) {

            var defer = $q.defer();
            //console.log("posting " + JSON.stringify(data) + " to url : " + API.employee.updateDetailsInfo + employeeId);
            $http.post(API.employee.updateDetailsInfo + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        // if (authService.getLoggedInId() === employeeId) {
                        //     authService.updateUserDetailedInfo(data);
                        // }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.getEmployeesAssignedToWeeklyOffDaysPolicy = function(weeklyOffDaysPolicyId) {
            var defer = $q.defer();
            //console.log("Get request to url : " + API.employee.employeesAssignedToWeeklyOffDaysPolicy+weeklyOffDaysPolicyId);
            $http.get(API.employee.employeesAssignedToWeeklyOffDaysPolicy+weeklyOffDaysPolicyId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.setCompanyAdmin = function (data, employeeId) {

            var defer = $q.defer();
            //console.log("posting " + JSON.stringify(data) + " to url : " + API.employee.setCompanyAdmin + employeeId);
            $http.post(API.employee.setCompanyAdmin + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        // if (authService.getLoggedInId() === employeeId) {
                        //     authService.updateUserDetailedInfo(data);
                        // }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.includeInAttendanceReport = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.includeInAttendanceReport, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.batchCreateEmployee = function (excelFile) {
            var defer = $q.defer();
            var url = API.employee.batchCreate;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.message);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                console.error(JSON.stringify(data));
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.transferEmployees = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.transferEmployees, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getEmployeeEducationHistories = function (employeeId) {
            var defer = $q.defer();
            var url = API.educationHistory.getAll;
            url = url + employeeId + '/education-history';
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getEmployeeDocuments = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.getEmployeeDocuments+employeeId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.documentList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.updateEducationHistory = function (history) {
            var defer = $q.defer();
            $http.post(API.educationHistory.update+history.id, history)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.createEducationHistory = function (employeeId,history) {
            var defer = $q.defer();

            var url = API.educationHistory.getAll;
            url = url + employeeId + '/education-history';
            $http.post(url, history)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.deleteEducationHistory = function (history) {
            var defer = $q.defer();
            var url = API.educationHistory.delete+history.id;
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.educationHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getEmployeeEmploymentHistories = function (employeeId) {
            var defer = $q.defer();
            var url = API.employmentHistory.getAll.prefix + employeeId + API.employmentHistory.getAll.suffix;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.updateEmploymentHistory = function (history) {
            var defer = $q.defer();
            $http.post(API.employmentHistory.update+history.id, history)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.deleteEmploymentHistory = function (history) {
            var defer = $q.defer();
            var url = API.employmentHistory.delete+history.id;
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createEmploymentHistory = function (employeeId,history) {
            var defer = $q.defer();
            var url = API.employmentHistory.getAll.prefix + employeeId + API.employmentHistory.getAll.suffix;
            $http.post(url, history)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentHistoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.changeStatus = function(employeeId, status) {
            var defer = $q.defer();
            var url = API.employee.base + employeeId + "/status/" + status;
            $http.post(url,{})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.updateBatchDepartment = function (batchEmployees, departmentId) {
            var defer = $q.defer();
            $http.post(API.employee.updateBatchDepartment + departmentId, batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.updateBatchSubDepartment = function (batchEmployees, subDepartmentId) {
            var defer = $q.defer();
            $http.post(API.employee.updateBatchSubDepartment + subDepartmentId, batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateBatchSubsidiary = function (batchEmployees, subsidiaryId) {
            var defer = $q.defer();
            $http.post(API.employee.updateBatchSubsidiary + subsidiaryId, batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getManualEntries = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.manualEntry+ employeeId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.manualEntryResponseList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getManualEntriesForApprover = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.manualEntryApprover;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.manualEntryApplications);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.approveManualEntryApplication = function (data, applicationId) {
            var defer = $q.defer();
            var url = API.employee.manualEntryApprove+ applicationId;
            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.manualEntryApplications);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.rejectManualEntryApplication = function (data, applicationId) {
            var defer = $q.defer();
            var url = API.employee.manualEntryReject+ applicationId;
            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.manualEntryApplications);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateBatchDesignation = function (batchEmployees, designationId) {
            var defer = $q.defer();
            var url = API.employee.updateBatchDesignation+designationId;
            $http.post(url,batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                        //console.log(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteEmployeeDocument = function (documentId) {
            var defer = $q.defer();
            var url = API.employee.deleteEmployeeDocument+documentId;
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.documentList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.searchByName = function (text) {
            var defer = $q.defer();
            $http.get(API.employee.search, { params : { 'text' : text } })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employees);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.searchByNameOrId = function (text) {
            var defer = $q.defer();
            $http.get(API.employee.pageTopSearch, { params : { 'text' : text } })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employees);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllProjectsOfAnEmployee = function (empId) {
            var defer = $q.defer();
            $http.get(API.employee.getAllProjectsOfAnEmployee + empId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.projectDedicationList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.saveProjectDedicationForAnEmployee = function (empId, projectDedicationList) {
            var defer = $q.defer();
            $http.post(API.employee.updateProjectDedicationOfAnEmployee.prefix + empId + API.employee.updateProjectDedicationOfAnEmployee.suffix, { 'projectDedicationList': projectDedicationList })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.projectDedicationList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getPendingApprovalsOfEmployee = function () {
            var defer = $q.defer();
            $http.get(API.employee.getPendingApprovalsCount)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.count);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getPaginatedManualEntryList = function (params) {
            var defer = $q.defer();
            $http.get(API.manualEntry.paginated,{params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }
        self.getAllLeavesOfAnEmployee = function (params,employeeId){
            var defer = $q.defer();
            $http.get(API.leaveManagement.getAllLeaveLogs + employeeId,{params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getCurrentAndPreviousLeaveApplicationData = function (leaveLogId){
            var defer = $q.defer();
            $http.get(API.leaveManagement.currentAndUpdatedLeaveApplicationDetails + leaveLogId)
                .success(function(data, status){
                    if (status === RESPONSE_CODE.success){
                        defer.resolve(data);
                    }
                });
            return defer.promise;
        }

        self.getEnrolmentInformation = function () {
            var defer = $q.defer();
            $http.get(API.employee.getEnrolmentInformation)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.updateBatchEmploymentType = function (data,employmentTypeId) {
            var defer = $q.defer();
            $http.post(API.employee.updateBatchEmploymentType+ employmentTypeId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.cancelManualEntryApplication = function (applicationId) {
            var defer = $q.defer();
            $http.post(API.employee.cancelManualEntryLog+ applicationId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.syncThirdPartyEmployees = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.syncThirdParty,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.responseMap);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.syncAllThirdPartyEmployees = function () {
            var defer = $q.defer();
            $http.post(API.employee.syncThirdPartyAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.responseMap);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getEmployeeInformationList = function (idList) {
            var defer = $q.defer();
            $http.get(API.employee.getInformation+"?idList="+idList.join(','))
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }



        self.getExcelUrl = function (searchParams) {
            var excelUrl = API.employee.exportAsExcel;
            excelUrl += "perPage=" + searchParams.perPage + "&pageNumber=" + searchParams.pageNumber;
            excelUrl += buildURLFromObject("sortKey", searchParams.sortKey)
                        + buildURLFromObject("order", searchParams.order)
                        + buildURLFromObject("selectAll", searchParams.selectAll)
                        + buildURLFromObject("companyId", searchParams.companyId)
                        + buildURLFromObject("officeId", searchParams.officeId)
                        + buildURLFromObject("departmentId", searchParams.departmentId)
                        + buildURLFromObject("designationId", searchParams.designationId)
                        + buildURLFromObject("shiftId", searchParams.shiftId)
                        + buildURLFromObject("shiftGroupId", searchParams.shiftGroupId)
                        + buildURLFromObject("genderId", searchParams.genderId)
                        + buildURLFromObject("status", searchParams.status)
                        + buildURLFromObject("workplaceId", searchParams.workplaceId)
                        + buildURLFromObject("employmentTypeId", searchParams.employmentTypeId)
                        + buildURLFromObject("subDepartmentId", searchParams.subDepartmentId)
                        + buildURLFromObject("subsidiaryId", searchParams.subsidiaryId)
                        + buildURLFromObject("lineManagerId", searchParams.lineManagerId)
                        + buildURLFromObject("employeeName", searchParams.employeeName);
            excelUrl += "&token=" + authService.getLoggedInToken();

            return excelUrl;

        };

        function buildURLFromObject(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.getManualEntryExcelUrl = function (params) {
            var defer = $q.defer();
            var excelUrl = API.manualEntry.excelUrl;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if (params.reportType)
                excelUrl = excelUrl + "&reportType=" + params.reportType;
            params.sortKey = !params.sortKey || params.sortKey == null|| params.sortKey == ''  ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey );
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            // console.log("EXCEL URL IS : " + excelUrl);
            return excelUrl;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.verifyEmployeePayrollSetupExcel = function (excelFile) {
            var defer = $q.defer();
            var url = API.employee.verifyEmployeePayrollSetupExcel;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.verifyEmployeeBatchCreateExcel = function (excelFile) {
            var defer = $q.defer();
            var url = API.employee.verifyBatchCreateExcel;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.uploadEmployeeBatchCreateExcel = function (excelFile) {
            var defer = $q.defer();
            var url = API.employee.submitBatchCreateExcel;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.uploadEmployeePayrollSetupExcel = function (excelFile) {
            var defer = $q.defer();
            var url = API.employee.submitEmployeePayrollSetupExcel;
            var formData = new FormData();
            formData.append("file", excelFile);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.getBatchCreateExcelUrl = function () {
            return API.employee.batchCreateExcelDownload + "?token=" + authService.getLoggedInToken();
        }

        self.checkEmployeeOfficeIdValidity = function (employeeOfficeId) {
            var defer = $q.defer();
            var params = {
                employeeOfficeId: employeeOfficeId
            };
            //console.log("get request to url : " + API.employee.all);
            $http.get(API.employee.checkEmployeeOfficeIdValidity, {params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getManualEntryApprovalSystem = function () {
            var url = API.manualEntry.getApprovalSystem;
            return $http.get(url)
                .then(function (response) {
                    if (response.status === RESPONSE_CODE.success) {
                        return response.data;
                    } else {
                        throw new Error(response.data.message);
                    }
                })
                .catch(function (error) {
                    throw new Error(error.data.message ? error.data.message : "");
                });
        }

        self.setManualEntryApprovalSystem = function (isSingleLeaveApproverAllowed) {
            var url = API.manualEntry.setApprovalSystem;
            return $http.post(url, isSingleLeaveApproverAllowed)
                .then(function (response) {
                    if (response.status === RESPONSE_CODE.success) {
                        return response.data;
                    } else {
                        throw new Error(response.data.message);
                    }
                })
                .catch(function (error) {
                    throw new Error(error.data.message ? error.data.message : "");
                });
        }

        self.getActiveEmployeeCount = function () {
            var params = {
                perPage: 1,
                pageNumber: 0,
                status: [1],
                selectAll: false
            };
            return self.getFilteredEmployees(params).then(function (res) {
                return res.total || 0;
            });
        };

        self.isOverEmployeeLimit = function (limit) {
            return self.getActiveEmployeeCount().then(function (n) {
                return n >= limit;
            });
        };

        self.getSubsidiaryAdminEmployees = function () {
            var defer = $q.defer();
            $http.get(API.employee.subsidiaryAdmin)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.adminList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateEmployeeProfile = function (employeeId, data) {
            var defer = $q.defer();
            $http.post(API.employee.updateBasicInfo + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
    }

    app.service('employeeService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', employeeService]);

})();

(function () {

    'use strict';

    function employmentTypeService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,utilService) {

        var self = this;

        self.getAllEmploymentTypes = function () {
            var defer = $q.defer();
            $http.get(API.employmentType.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentTypeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createEmploymentType = function (data) {
            var defer = $q.defer();
            $http.post(API.employmentType.all, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentType);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.editEmploymentType = function (data, id) {
            var defer = $q.defer();
            $http.post(API.employmentType.all + id, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employmentType);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };




    }

    app.service('employmentTypeService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE','utilService', employmentTypeService]);

})();
(function(){

    'use strict';

    function enrolmentService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.enrolEmployee = function (employeeDetails) {
            var defer = $q.defer();
            var url = API.employee.enrolEmployee + employeeDetails.employeeId + '?hand=' + employeeDetails.hand + '&finger=' + employeeDetails.finger;
            var formData = new FormData();
            formData.append("file", employeeDetails.file);
            // console.log("POST request to url : " + url);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.data);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                console.error(JSON.stringify(data));
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.getFingers = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.enrol.getFingers + employeeId;
            // console.log("Get request to url : " +url);
            $http.get(url).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.employeeFingerResponses);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                console.error(JSON.stringify(data));
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.deleteEnrolments = function (employeeId,data) {
            var defer = $q.defer();
            var url = API.employee.enrol.deleteFinger+employeeId;

            // console.log("POST request to url : " + url);
            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject();
                });

            return defer.promise;
        };

        self.getTemporaryEnrolments = function () {
            var defer = $q.defer();
            var url = API.employee.enrol.getTemporaryEnrolments;
            $http.get(url).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.temporaryEnrolments);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                defer.reject(data.message);
            });

            return defer.promise;
        };

        self.enrollFromTemporary = function (data) {
            var defer = $q.defer();
            var url = API.employee.enrol.enrollFromTemporary;
            $http.post(url,data).success(function (response, status) {
                if (status === 200) {
                    defer.resolve(response.temporaryEnrolments);
                } else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, header, config) {
                console.error(JSON.stringify(data));
                defer.reject(data.message);
            });

            return defer.promise;
        };
    }

    app.service('enrolmentService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', enrolmentService]);
})();
(function(){

    'use strict';

    function externalSyncService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.syncEmployeesBBL = function (dateRange) {
            var defer = $q.defer();
            //console.log("POST request to url : " + API.holiday);
            $http.post(API.externalSync.syncEmployeesBBL, dateRange)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }
    app.service('externalSyncService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', externalSyncService]);

})();
(function () {

    'use strict';
    function geoFencingService($window, $http, $q, API, RESPONSE_CODE) {

        var self = this;


        self.getFilteredGeoFencingAllowEmployees = function (searchParams) {
            var defer = $q.defer();
            var url = API.geoFencing.all;
            var params = {
                companyId     : searchParams.companyId == null || searchParams.companyId.length == 0 ? [] : searchParams.companyId,
                officeId      : searchParams.officeId == null || searchParams.officeId.length == 0 ? [] : searchParams.officeId,
                departmentId  : searchParams.departmentId == null || searchParams.departmentId.length == 0 ? [] : searchParams.departmentId,
                subDepartmentId: searchParams.subDepartmentId == null || searchParams.subDepartmentId.length == 0 ? [] : searchParams.subDepartmentId,
                designationId : searchParams.designationId == null || searchParams.designationId.length == 0 ? [] : searchParams.designationId,
                shiftId       : searchParams.shiftId == null || searchParams.shiftId.length == 0 ? [] : searchParams.shiftId,
                shiftGroupId  : searchParams.shiftGroupId == null || searchParams.shiftGroupId.length == 0 ? [] : searchParams.shiftGroupId,
                employmentTypeId  : searchParams.employmentTypeId == null || searchParams.employmentTypeId.length == 0 ? [] : searchParams.employmentTypeId,
                genderId      : searchParams.genderId == null || searchParams.genderId.length == 0 ? [] : searchParams.genderId,
                status        : searchParams.status == null || searchParams.status.length == 0 ? [] : searchParams.status,
                workplaceId   : searchParams.workplaceId == null || searchParams.workplaceId.length == 0 ? [] : searchParams.workplaceId,
                subsidiaryId  : searchParams.subsidiaryId == null || searchParams.subsidiaryId.length == 0 ? [] : searchParams.subsidiaryId,
                perPage       : searchParams.perPage,
                pageNumber    : searchParams.pageNumber,
                sortKey       : searchParams.sortKey,
                order         : searchParams.order,
                selectAll     : searchParams.selectAll,
                employeeName    :searchParams.searchKeyEmployee==null||searchParams.searchKeyEmployee==""?null:searchParams.searchKeyEmployee,
                mobilePunchStatus: searchParams.mobilePunchStatus == null || searchParams.mobilePunchStatus.length == 0 ? [] : searchParams.mobilePunchStatus,
                geoFencingStatus : searchParams.geoFencingStatus == null || searchParams.geoFencingStatus.length == 0 ? [] : searchParams.geoFencingStatus,
            };
            if (searchParams.employeeName)
                params.employeeName = searchParams.employeeName;
            if(!!searchParams.employeeOfficeId && searchParams.employeeOfficeId.trim().length > 0)
                params.employeeOfficeId = searchParams.employeeOfficeId.trim();
            if(!!searchParams.centralServerPeopleId && searchParams.centralServerPeopleId.trim().length > 0)
                params.centralServerPeopleId = searchParams.centralServerPeopleId.trim();
            $http.get(url,{
                params : params
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.activateOrDeactivateGeoFencingPermission = function (data) {
            var defer = $q.defer();
            console.log(data);
            $http.post(API.geoFencing.updateGeoFencingPermission,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getExcel = function (params) {
            var defer = $q.defer();
            $http.get(API.geoFencing.getExcel, {
                params : params,
                responseType : 'blob'})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve({data:data,headers:config});
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


    }

    app.service('geoFencingService', ['$window', '$http', '$q', 'API', 'RESPONSE_CODE', geoFencingService]);

})();

(function(){

    'use strict';

    function holidayService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllHolidays = function() {
            var defer = $q.defer();
            //console.log("get request to url : " + API.holiday.all);
            $http.get(API.holiday.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.holidayList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });

            return defer.promise;
        };

        self.createHoliday=function (data) {
            var defer = $q.defer();
            //console.log("POST request to url : " + API.holiday);
            $http.post(API.holiday.create,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.holiday);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateHoliday=function (holidayId,data) {
            var defer = $q.defer();
            //console.log("POST request to url : " + API.holiday.create);
            $http.post(API.holiday.create+holidayId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.holiday);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


    }
    app.service('holidayService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', holidayService]);

})();
(function () {

        'use strict';

        function lateApprovalManagementService($http, $q, API, RESPONSE_CODE) {
            var self = this;

            self.applyForLateApproval = function (employeeId, data) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.applyForLateApproval + employeeId;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.rejectLateApprovalRequest = function (data, lateApprovalLogId) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.rejectLateApprovalRequest + lateApprovalLogId;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.lateApprovalApplications);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;

            };

            self.acceptLateApprovalRequest = function (data, lateApprovalLogId) {
                var defer = $q.defer();
                //console.log("post request to url : " + API.leaveManagement.approveLeave + leaveLogId);
                $http.post(API.lateApprovalManagement.acceptLateApprovalRequest + lateApprovalLogId, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.lateApprovalApplications);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;

            };

            self.setLateApproverForBatchEmployee = function (data) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.setLateFirstApproverBatch;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.setManualEntryApproverForBatchEmployee = function (data) {
                var defer = $q.defer();
                var url = API.manualEntryApprovalManagement.setManualEntryApproverBatch;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getAllLateApprovalApplicationsOfAnEmployee = function(employeeId) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.getAllLateApprovalApplications+employeeId;
                //console.log("get request to url : " + url);
                $http.get(url)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.lateApprovalApplications);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getLateAttendanceRecordsOfAnEmployee = function(employeeId) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.getLateAttendanceRecordsOfAnEmployee + employeeId;
                $http.get(url)
                    .success(function (data, status, header, config) {
                        if(status === RESPONSE_CODE.success){
                            defer.resolve(data.lateAttendanceRecords);
                        }
                        else{
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getPendingLateApprovalLogsOfAnEmployee = function(employeeId) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.getPendingLateApprovalLogsOfAnEmployee + employeeId;
                $http.get(url)
                    .success(function (data, status, header, config) {
                        if(status === RESPONSE_CODE.success){
                            defer.resolve(data.lateLogList);
                        }
                        else{
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.cancelLateLog = function (latelogId) {
                var defer = $q.defer();
                var url = API.lateApprovalManagement.cancelLateApproval + latelogId;
                $http.post(url)
                    .success(function (data, status, header, config) {
                        if(status === RESPONSE_CODE.success){
                            defer.resolve();
                        }
                        else{
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            }

            self.getLateApprovalSystem = function () {
                var url = API.lateApprovalManagement.getApprovalSystem;
                return $http.get(url)
                    .then(function (response) {
                        // console.log(response)
                        if (response.status === RESPONSE_CODE.success) {
                            return response.data;
                        } else {
                            throw new Error(response.data.message);
                        }
                    })
                    .catch(function (error) {
                        throw new Error(error.data.message ? error.data.message : "");
                    });
            }

            self.setLateApprovalSystem = function (isSingleLateApproverAllowed) {
                var url = API.lateApprovalManagement.setApprovalSystem;
                return $http.post(url, isSingleLateApproverAllowed)
                    .then(function (response) {
                        // console.log(response)
                        if (response.status === RESPONSE_CODE.success) {
                            return response.data;
                        } else {
                            throw new Error(response.data.message);
                        }
                    })
                    .catch(function (error) {
                        throw new Error(error.data.message ? error.data.message : "");
                    });
            }
        }
        app.service('lateApprovalManagementService', ['$http', '$q', 'API', 'RESPONSE_CODE', lateApprovalManagementService]);
    }
)();

(function(){

    'use strict';

    function leaveCategoryService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllLeaveCategories = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.leaveCategory.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leaveCategoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createLeaveCategory = function (data) {
            var defer = $q.defer();
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ API.leaveCategory.all);

            $http.post(API.leaveCategory.all,data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.leaveCategory);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                        defer.reject(data.message);
                });
            return defer.promise;


        };

        self.updateLeaveCategory = function (data,leaveCategoryId) {
            var defer = $q.defer();
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ API.leaveCategory.all+leaveCategoryId);

            $http.post( API.leaveCategory.all + leaveCategoryId, data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;


        };
    }
    app.service('leaveCategoryService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', leaveCategoryService]);

})();
(function(){

    'use strict';

    function leaveCategoryPolicyConfigurationService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.createNewConfiguration = function (leavePolicyId, data) {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.create + leavePolicyId;
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ url);

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getAllConfigurations = function () {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.all;

            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicyToCategoryConfigs);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllConfigurationsOfAPolicy = function (leavePolicyId) {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.policywiseConfigurations + leavePolicyId;

            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.policywiseCategoryConfigs);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteLeaveCategoryPolicyConfiguration = function (leaveCategoryPolicyConfigId) {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.delete + leaveCategoryPolicyConfigId;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });

            return defer.promise;
        };

        self.updateLeaveCategoryPolicyConfiguration = function (leaveCategoryPolicyConfigId, data) {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.update + leaveCategoryPolicyConfigId;
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ url);

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });

            return defer.promise;
        };

        self.addNewConfigurationToExistingPolicy = function (leavePolicyId, data) {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.addNewToExistingPolicy + leavePolicyId;
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ url);

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });

            return defer.promise;
        };

        self.deleteAllCategoryConfigurationsOfAPolicy = function (leavePolicyId) {
            var defer = $q.defer();
            var url = API.leaveCategoryPolicyConfiguration.deleteByPolicy + leavePolicyId;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.leavePolicyToCategoryConfigs);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });

            return defer.promise;
        };

    }
    app.service('leaveCategoryPolicyConfigurationService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', leaveCategoryPolicyConfigurationService]);

})();

(function () {

        'use strict';

        function leaveManagementService($http, $q, API, RESPONSE_CODE) {
            var self = this;

            self.getLeaveApprovalSystem = function () {
                var url = API.leaveManagement.getApprovalSystem;
                return $http.get(url)
                    .then(function (response) {
                        // console.log(response)
                        if (response.status === RESPONSE_CODE.success) {
                            return response.data;
                        } else {
                            throw new Error(response.data.message);
                        }
                    })
                    .catch(function (error) {
                        throw new Error(error.data.message ? error.data.message : "");
                    });
            }

            self.setLeaveApprovalSystem = function (isSingleLeaveApproverAllowed) {
                var url = API.leaveManagement.setApprovalSystem;
                return $http.post(url, isSingleLeaveApproverAllowed)
                    .then(function (response) {
                        // console.log(response)
                        if (response.status === RESPONSE_CODE.success) {
                            return response.data;
                        } else {
                            throw new Error(response.data.message);
                        }
                    })
                    .catch(function (error) {
                        throw new Error(error.data.message ? error.data.message : "");
                    });
            }

            self.getSequentialLeaveApprovalSystem = function () {
                var url = API.leaveManagement.getSequentialLeaveApprovalSystem;
                return $http.get(url)
                    .then(function (response) {
                        if (response.status === RESPONSE_CODE.success) {
                            return response.data;
                        } else {
                            throw new Error(response.data.message);
                        }
                    })
            }

            self.applyForLeave = function (employeeId, request,file) {
                var defer = $q.defer();
                var url = API.leaveManagement.applyForLeave + employeeId;
                //console.log("post request to url : " + url);

                var formData = new FormData();
                formData.append("file",file);
                formData.append("postBody",JSON.stringify(request));
                $http({
                    method: 'POST',
                    url: String(url),
                    headers: {'Content-Type': undefined},
                    data: formData,
                    transformRequest: function (data, headersGetter) {
                        return data;
                    }
                }).success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.applyForLeaveAdjustment = function (leaveLogId,request,file){
                var defer = $q.defer();
                var url = API.leaveManagement.adjustLeaveApplication + leaveLogId;
                //console.log("post request to url : " + url);

                var formData = new FormData();
                formData.append("file",file);
                formData.append("postBody",JSON.stringify(request));
                $http({
                    method: 'POST',
                    url: String(url),
                    headers: {'Content-Type': undefined},
                    data: formData,
                    transformRequest: function (data, headersGetter) {
                        return data;
                    }
                }).success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            }

                self.cancelLeaveApplication = function (data, leaveLogId) {
                    var defer = $q.defer();
                    var url = API.leaveManagement.cancelLeaveApplication + leaveLogId;
                    // console.log("post request to url : " + url);
                    $http.post(url, data)
                        .success(function (data, status, headers, config) {
                            if (status === RESPONSE_CODE.success) {
                                defer.resolve(data);
                            }
                            else {
                                defer.reject(data.message);
                            }
                        })
                        .error(function (data, status, headers, config) {
                            defer.reject(data.message ? data.message : "");
                        });
                    return defer.promise;
                }

            self.rejectLeave = function (data, leaveLogId) {
                var defer = $q.defer();
                var url = API.leaveManagement.rejectLeave + leaveLogId;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.leaveApplications);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;

            };

            self.approveLeave = function (data, leaveLogId) {
                var defer = $q.defer();
                //console.log("post request to url : " + API.leaveManagement.approveLeave + leaveLogId);
                $http.post(API.leaveManagement.approveLeave + leaveLogId, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.leaveApplications);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;

            };

            self.setLeaveApproverForBatchEmployee = function (data) {
                var defer = $q.defer();
                var url = API.leaveManagement.setLeaveFirstApproverBatch;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.isEmployeeEligibleForLeave = function (employeeId) {
                var defer = $q.defer();
                var url = API.leaveManagement.isEmployeeEligibleForLeave + employeeId;
                //console.log("Get request to get employee leave eligibility to url : " + url);
                $http.get(url)
                    .success(function (data, status) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getAllLeaveApplicationsOfAnEmployee = function(employeeId, params) {
                var defer = $q.defer();
                var url = API.leaveManagement.getAllLeaveApplications+employeeId;
                // console.log("get request to url : " + url);
                $http.get(url, params)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.leaveLogList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getAllLeaveApplicationsOfAnEmployeeInFiscalYear = function(employeeId, params) {
                var defer = $q.defer();
                var url = API.leaveManagement.getAllLeaveApplicationsInFiscalYear+employeeId;
                // console.log("get request to url : " + url);
                $http.get(url, params)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.leaveLogList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.applyForHalfDayLeave = function (employeeId, data) {
                var defer = $q.defer();
                var url = API.leaveManagement.applyForHalfDayLeave + employeeId;
                //console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.approveHalfDayLeave = function (applicationId, data) {
                var defer = $q.defer();
                var url = API.leaveManagement.approveOrRejectHalfDayLeave + applicationId;
                // console.log("post request to url : " + url);
                $http.post(url, data)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.updateLeave = function (leaveLogId, request,file) {
                var defer = $q.defer();
                var url = API.leaveManagement.updateLeaveLog + leaveLogId;
                //console.log("post request to url : " + url);

                var formData = new FormData();
                formData.append("file",file);
                formData.append("postBody",JSON.stringify(request));
                $http({
                    method: 'POST',
                    url: String(url),
                    headers: {'Content-Type': undefined},
                    data: formData,
                    transformRequest: function (data, headersGetter) {
                        return data;
                    }
                }).success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.cancelLeaveLog = function (leaveLogId) {
                var defer = $q.defer();
                var url = API.leaveManagement.cancelLeaveLog + leaveLogId;
                // console.log("post request to url : " + url);
                $http.post(url)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getApplicationDetails = function(leaveLogId) {
                var defer = $q.defer();
                var url = API.leaveManagement.getApplicationDetails + leaveLogId;
                // console.log("get request to url : " + url);
                $http.get(url)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getAcceptedLeaveLogs = function(employeeId) {
                var defer = $q.defer();
                var url = API.leaveManagement.getAcceptedLeaveLogs + employeeId;
                // console.log("get request to url : " + url);
                $http.get(url)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.leaveLogList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };

            self.getLeaveLogList=  function(params) {
                var defer = $q.defer();
                var url = API.leaveManagement.getLeaveHistory;
                // console.log("get request to url : " + url);
                $http.get(url,{params:params})
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
                return defer.promise;
            };
        }



        app.service('leaveManagementService', ['$http', '$q', 'API', 'RESPONSE_CODE', leaveManagementService]);
    }
)();

(function(){

    'use strict';

    function leavePolicyService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.createLeavePolicy = function (data) {
            var defer = $q.defer();
            var url = API.leavePolicy.all;
            // console.log('Trying to post ' + JSON.stringify(data) +' to '+ url);

            $http.post(url,data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.leavePolicies);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.deleteLeavePolicy = function (leavePolicyId) {
            var defer = $q.defer();
            var url = API.leavePolicy.delete + leavePolicyId;
            // console.log('Trying to post to '+ url);

            $http.post(url)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.leavePolicy);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getAllLeavePolicies = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leavePolicy.all);
            $http.get(API.leavePolicy.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicies);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getLeavePolicyById = function(leavePolicyId) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leavePolicy.all+leavePolicyId);
            $http.get(API.leavePolicy.all+leavePolicyId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicy);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateLeavePolicyName = function(leavePolicyId, data) {
            var defer = $q.defer();
            // console.log("POST request to url : " + API.leavePolicy.updateName+leavePolicyId);
            $http.post(API.leavePolicy.updateName+leavePolicyId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicy);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateBatchLeavePolicy = function (batchEmployees, leavePolicyId) {
            var defer = $q.defer();
            $http.post(API.leavePolicy.updateBatchLeavePolicy+leavePolicyId,batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteLeavePolicy = function(leavePolicyId,data) {
            var defer = $q.defer();
            // console.log("POST request to url : " + API.leavePolicy.delete+leavePolicyId);
            $http.post(API.leavePolicy.delete+leavePolicyId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicies);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.addLeaveCategoryToLeavePolicy = function(leavePolicyId, data) {
            var defer = $q.defer();
            var url = API.leavePolicy.addLeaveCategoryToLeavePolicy.prefix+leavePolicyId+API.leavePolicy.addLeaveCategoryToLeavePolicy.suffix;
            // console.log("POST request to url : " + url);
            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicy.leavePerCategories);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateLeavePolicyPerCategory = function(leavePerCategoryId,data) {
            var defer = $q.defer();
            var url = API.leavePolicy.updatePolicyPerCategory.prefix+leavePerCategoryId+API.leavePolicy.updatePolicyPerCategory.suffix;
            // console.log("POST request to url : " + url);
            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicy);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deletePolicyPerCategory = function(leavePerCategoryId) {
            var defer = $q.defer();
            var url = API.leavePolicy.deleteLeavePerCategory.prefix+leavePerCategoryId+API.leavePolicy.deleteLeavePerCategory.suffix;
            // console.log("POST request to url : " + url);
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicy);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.batchCarryOn = function(data) {
            var defer = $q.defer();
            var url = API.leavePolicy.batchCarryOn;
            // console.log("POST request to url : " + url);
            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getLeavePolicyOfEmployee = function (employeeId) {
            var defer = $q.defer();
            var url = API.leavePolicy.employeeLeavePolicy+employeeId;
            // console.log("GET request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getAllAssignableLeavePolicies = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leavePolicy.all);
            $http.get(API.leavePolicy.list)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leavePolicies);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
    }
    app.service('leavePolicyService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', leavePolicyService]);

})();

(function(){

    'use strict';

    function loanManagementService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getLoanSummaryOfOffice = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.loanManagement.loanSummaryOfOffice)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getAllLoansOfOffice = function(data) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.loanManagement.getAllLoan, {params:data})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getInstallmentsOfLoan = function(id) {
            var defer = $q.defer();
            $http.get(API.loanManagement.getInstallmentsOfLoan+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getProfileWithLoanInfo = function(employeeId) {
            var defer = $q.defer();
            $http.get(API.loanManagement.getProfileWithLoanInfo + employeeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.addNewLoanForAnEmployee = function (data) {
            var defer = $q.defer();
            $http.post(API.loanManagement.addNewLoanForAnEmployee , data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicleTypeList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.editCurrentLoan = function (data) {
            var defer = $q.defer();
            $http.post(API.loanManagement.editCurrentLoanOfAnEmployee, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicleTypeList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.deferLoan = function (params) {
            var defer = $q.defer();
            $http.post(API.loanManagement.deferALoan , params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.settleLoan = function (data) {
            var defer = $q.defer();
            $http.post(API.loanManagement.settleALoan , data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.getLoanAdvSalaryDetailsReportExcel = function (params){
            var excelUrl = API.loanManagement.loanAdvSalaryDetailsReport+params+'?';
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;

        }


    }

    app.service('loanManagementService', ['authService','$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', loanManagementService]);

})();
(function () {

    'use strict';
    function locationTrackingAccessSettingService($window, $http, $q, API, RESPONSE_CODE) {

        var self = this;


        self.getFilteredLocationTrackingAllowEmployees = function (searchParams) {
            var defer = $q.defer();
            var url = API.locationTrackingAccess.all;
            var params = {
                companyId     : searchParams.companyId == null || searchParams.companyId.length == 0 ? [] : searchParams.companyId,
                officeId      : searchParams.officeId == null || searchParams.officeId.length == 0 ? [] : searchParams.officeId,
                departmentId  : searchParams.departmentId == null || searchParams.departmentId.length == 0 ? [] : searchParams.departmentId,
                subDepartmentId: searchParams.subDepartmentId == null || searchParams.subDepartmentId.length == 0 ? [] : searchParams.subDepartmentId,
                designationId : searchParams.designationId == null || searchParams.designationId.length == 0 ? [] : searchParams.designationId,
                shiftId       : searchParams.shiftId == null || searchParams.shiftId.length == 0 ? [] : searchParams.shiftId,
                shiftGroupId  : searchParams.shiftGroupId == null || searchParams.shiftGroupId.length == 0 ? [] : searchParams.shiftGroupId,
                employmentTypeId  : searchParams.employmentTypeId == null || searchParams.employmentTypeId.length == 0 ? [] : searchParams.employmentTypeId,
                genderId      : searchParams.genderId == null || searchParams.genderId.length == 0 ? [] : searchParams.genderId,
                status        : searchParams.status == null || searchParams.status.length == 0 ? [] : searchParams.status,
                workplaceId   : searchParams.workplaceId == null || searchParams.workplaceId.length == 0 ? [] : searchParams.workplaceId,
                subsidiaryId  : searchParams.subsidiaryId == null || searchParams.subsidiaryId.length == 0 ? [] : searchParams.subsidiaryId,
                perPage       : searchParams.perPage,
                pageNumber    : searchParams.pageNumber,
                sortKey       : searchParams.sortKey,
                order         : searchParams.order,
                selectAll     : searchParams.selectAll,
                employeeName    :searchParams.searchKeyEmployee==null||searchParams.searchKeyEmployee==""?null:searchParams.searchKeyEmployee,
                locationTrackingAccessStatus : searchParams.locationTrackingAccessStatus == null || searchParams.locationTrackingAccessStatus.length == 0 ? [] : searchParams.locationTrackingAccessStatus,
            };
            if (searchParams.employeeName)
                params.employeeName = searchParams.employeeName;
            if(!!searchParams.employeeOfficeId && searchParams.employeeOfficeId.trim().length > 0)
                params.employeeOfficeId = searchParams.employeeOfficeId.trim();
            if(!!searchParams.centralServerPeopleId && searchParams.centralServerPeopleId.trim().length > 0)
                params.centralServerPeopleId = searchParams.centralServerPeopleId.trim();
            $http.get(url,{
                params : params
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.activateOrDeactivateLocationTrackingPermission = function (data) {
            var defer = $q.defer();
            console.log(data);
            $http.post(API.locationTrackingAccess.updateLocationTrackingPermission,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getExcel = function (params) {
            var defer = $q.defer();
            $http.get(API.locationTrackingAccess.getExcel, {
                params : params,
                responseType : 'blob'})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve({data:data,headers:config});
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


    }

    app.service('locationTrackingAccessSettingService', ['$window', '$http', '$q', 'API', 'RESPONSE_CODE', locationTrackingAccessSettingService]);

})();

(function () {

    'use strict';

    function membershipManagementService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, toastrService, utilService) {

        var self = this;

        self.getAllPackages = function () {
            var defer = $q.defer();
            $http.get(API.membershipManagement.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.membershipPackageList);
                    } else if(status === RESPONSE_CODE.rfid_duplicate){
                        toastrService.showErrorToastr("RFID already exists")
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createOrEditPackage = function (params) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.createOrEditPackage, params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.deletePackage = function (id) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.deletePackage + id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.getAllDashboardResponse = function () {
            var defer = $q.defer();
            $http.get(API.membershipManagement.dashboardAllAttendance)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getTotalVisitTodayResponse = function () {
            var defer = $q.defer();
            $http.get(API.membershipManagement.dashboardTotalVisitToday)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getDashboardBirthdayFeed = function () {
            var defer = $q.defer();
            $http.get(API.membershipManagement.dashboardBirthday)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getAttendanceFeed = function () {
            var defer = $q.defer();
            $http.get(API.membershipManagement.dashboardAttendanceFeed)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getAllActiveMembers = function (params) {
            var defer = $q.defer();
            $http.get(API.membershipManagement.members.active, {params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getAllInfoOfAMember = function (subscriptionId) {
            var defer = $q.defer();
            $http.get(API.membershipManagement.members.getInfoOfAMember +subscriptionId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.renewMember = function (id) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.members.renew + id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.addNewMember = function (params) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.members.createNewMember, params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.updateMember = function (id, params) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.members.update + id, params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }else if(status === RESPONSE_CODE.rfid_duplicate){
                        toastrService.showErrorToastr("RFID already exists")
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.fileUpload = function (formData) {
            var defer = $q.defer();
            $http({
                url: API.membershipManagement.members.uploadFile,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetterFunction) {
                    return data;
                }

            }).success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.upgradeSubscription = function (id, params) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.members.upgradeSubscription+id, params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.deleteMember = function (id) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.members.delete + id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.fileRemove = function (id) {
            var defer = $q.defer();
            $http.post(API.membershipManagement.members.removeFile + id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
    }

    app.service('membershipManagementService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'toastrService', 'utilService', membershipManagementService]);

})();
(function () {

    'use strict';

    function membershipReportService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getDailyReport = function (searchParams) {
            var defer = $q.defer();
            $http.get(API.membershipManagement.report.dailyReport,{params:searchParams})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }
        self.getDailyReportExcelFile = function (params) {
            var defer = $q.defer();
            var excelUrl = API.membershipManagement.report.dailyReportExcel;
            excelUrl = excelUrl + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("date", params.date)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("startTime", params.startTime)
                + buildURLFromArray("membershipPackageIds", params.membershipPackageIds)




            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;

            // return defer.promise;
        };
        self.getMonthlyReport = function (searchParams) {
            var defer = $q.defer();
            $http.get(API.membershipManagement.report.monthly,{params:searchParams})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getMonthlyReportExcelFile = function (params) {
            var defer = $q.defer();
            var excelUrl = API.membershipManagement.report.monthlyReportExcel;
            excelUrl = excelUrl + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("date", params.date)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("from", params.from)
                + buildURLFromArray("to", params.to)
                + buildURLFromArray("membershipPackageIds", params.membershipPackageIds)



            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;

            // return defer.promise;
        };
        self.subscriptionReport = function (searchParams) {
            var defer = $q.defer();
            $http.get(API.membershipManagement.report.subscription,{params:searchParams})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getSubscriptionReportExcelFile = function (params) {
            var defer = $q.defer();
            var excelUrl = API.membershipManagement.report.subscriptionReportExcel;
            excelUrl = excelUrl + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("date", params.date)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("from", params.from)
                + buildURLFromArray("to", params.to)
                + buildURLFromArray("membershipPackageIds", params.membershipPackageIds)



            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;

            // return defer.promise;
        };


    }

    app.service('membershipReportService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', membershipReportService]);

})();
(function () {

    'use strict';
    function mobilePunchService($window, $http, $q, API, RESPONSE_CODE) {

        var self = this;

        self.activateOrDeactivateMobilePunchPermission = function (data) {
            var defer = $q.defer();
            $http.post(API.mobilePunch.updatePermission,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getExcel = function (params) {
            var defer = $q.defer();
            $http.get(API.mobilePunch.getExcel, {
                params : params,
                responseType : 'blob'})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve({data:data,headers:config});
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


    }

    app.service('mobilePunchService', ['$window', '$http', '$q', 'API', 'RESPONSE_CODE', mobilePunchService]);

})();

(function () {

  'use strict';
  function moduleService($window, $http, $q, API, RESPONSE_CODE) {

    var self = this;
    self.getModules = function () {
      var defer = $q.defer();

      var cachedModules = JSON.parse($window.localStorage.getItem('moduleList')) || {};

      if (!cachedModules || !cachedModules.length) {

        $http.get(API.modules.list)
          .success(function (data, status, headers, config) {
            if (status === RESPONSE_CODE.success) {
              $window.localStorage.setItem('moduleList',JSON.stringify(data.modules));
              defer.resolve(data.modules);
            } else {
              defer.reject(data.message);
            }
          })
          .error(function (data, status, headers, config) {
            defer.reject(data.message ? data.message : "");
          });
      } else {
        defer.resolve(cachedModules);
      }

      return defer.promise;
    };
  }

  app.service('moduleService', ['$window', '$http', '$q', 'API', 'RESPONSE_CODE', moduleService]);

})();

(function () {

    'use strict';

    function monthlyTimeSheetApproverService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;


        self.getMonthlyTimesheetApprovalsOfHr = function (year) {
            var defer = $q.defer();
            var url = API.monthlyTimesheetApproval.getHrApplications;
            if (!year || year < 0 ) defer.reject("invalid search criteria");
            $http.get(url, {
                params: {
                    year: year,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.approveOrRejectTimeSheet = function (applicationId,data) {
            var defer = $q.defer();
            var url = API.monthlyTimesheetApproval.approve+applicationId;
            $http.post(url,data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        }
    }

    app.service('monthlyTimeSheetApproverService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', monthlyTimeSheetApproverService]);

})();
(function(){

    'use strict';

    function myVisitorProfileService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;
        self.getAllVisitors = function(page,count,keyword) {
            var defer = $q.defer();
            var params={
                page:page,
                count:count,
                keyword:keyword,
            }
            $http.get(API.visitors.all,{
                params:params,
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getUpcomingVisitors = function(page,count,keyword) {
            //var defer = $q.defer();
            var defer = $q.defer();
            var params={
                page:page,
                count:count,
                keyword:keyword,
            }
            //console.log(keyword);
            $http.get(API.visitors.upcoming,{
                params:params,
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {

                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.getBlockedVisitors = function(page,count,keyword) {
            //var defer = $q.defer();
            var defer = $q.defer();
            var params={
                page:page,
                count:count,
                keyword:keyword,
            }
            //console.log(keyword);
            $http.get(API.visitors.blocked,{
                params:params,
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {

                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getVisitorInfo = function(id) {
            var defer = $q.defer();

            $http.get(API.visitors.oneInfo+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        //self.visitorToShow.visitorInfo=data;
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateVisitorInfo = function(id, data) {
            var defer = $q.defer();

            $http.post(API.visitors.visitorUpdate+id, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        //self.visitorToShow.visitorInfo=data;
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getVisitorHistory = function(id) {
            var defer = $q.defer();
            $http.get(API.visitors.visitorHistory+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.lastVisits);

                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getUpcomingVisit = function (id,page) {
            var defer = $q.defer();
            $http.get(API.visitors.upcomingVisit+id+"?page="+page)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        };
        // self.getKeyBasedVisit = function () {
        //     var defer = $q.defer();
        //     $http.get(API.visitors.upcomingVisit+id+"?page="+page)
        //         .success(function (data, status, headers, config) {
        //             if (status === RESPONSE_CODE.success) {
        //                 console.log(data);
        //                 defer.resolve(data);
        //             }
        //             else {
        //                 defer.reject(data.message);
        //             }
        //         })
        //         .error(function (data, status, headers, config) {
        //             defer.reject(data.message ? data.message : "");
        //         });
        //     return defer.promise;
        //
        // };
        self.blockVisitor = function (id) {
            var defer = $q.defer();

            var requestData = {
                visitorId:id,
            };
            $http.post(API.visitors.block,requestData)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        };
        self.UnblockVisitor = function (id) {
            var defer = $q.defer();

            var requestData = {
                visitorId:id,
            };
            $http.post(API.visitors.unblock,requestData)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        };

    }

    app.service('myVisitorProfileService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', myVisitorProfileService]);

})();
(function () {

    'use strict';

    function notificationService($http, $q, $rootScope, API, RESPONSE_CODE) {
        var self = this;

        self.getAllNotifications = function (pageNumber, perPage) {
            var defer = $q.defer();
            $http.get(API.notification.getAllNotifications, {
                params: {
                    'pageNumber': pageNumber,
                    'perPage': perPage
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.markAllAsRead = function () {
            var defer = $q.defer();
            $http.post(API.notification.markAllAsRead, {})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.markAsRead = function (data) {
            var defer = $q.defer();
            $http.post(API.notification.markAsRead, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.updateBatchNotificationSettings = function (data) {
            var defer = $q.defer();
            $http.post(API.notification.updateBatchNotificationSettings, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }
        self.getNotificationSettingsByEmployeeId = function (employeeId, notificationGroup) {
            var defer = $q.defer();
            $http.get(API.notification.getNotificationsSettingsByEmpId + employeeId, {
                params: {
                    notificationGroup: notificationGroup
                }
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
        self.getAllNotificationSettingsByEmployeeIdAndNotificationsGroup = function (employeeId, notificationGroupIds) {
            var defer = $q.defer();
            $http.get(API.notification.getNotificationsSettingsByEmpIdAndNotificationGroups + employeeId, {
                params: {
                    notificationGroupIds: notificationGroupIds
                }
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
        self.getEmployeeListByFilter = function (params) {
            var defer = $q.defer();
            var url = API.notification.getAllEmployee;
            $http.get(url, {
                params: {
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    subDepartmentId: params.subDepartmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    subsidiaryId: params.subsidiaryId,
                    status: params.status,
                    reportType: params.reportType,
                    absentType: params.absentType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    notificationStatus: params.notificationStatus
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        }

        self.getNotificationSummary = function () {
            var defer = $q.defer();
            $http.get(API.notification.getNotificationSummary)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
        self.getEmpployeeListByNotificationGroup = function (notificationGroup) {
            var defer = $q.defer();
            $http.get(API.notification.getEmployeeListByNotificationGroup + notificationGroup)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
        self.updateBatchNotificationSettingsByEmployeeId = function (data, employeeId) {
            var defer = $q.defer();
            $http.post(API.notification.updateBatchNotificationSettingsByEmployeeId+employeeId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }


    }

    app.service('notificationService', ['$http', '$q', '$rootScope', 'API', 'RESPONSE_CODE', notificationService]);

})();
(function(){

    'use strict';

    function officeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService, authService){

        var self = this;

        self.getAllOffices = function(loadFromServer) {
            var defer = $q.defer();
            var officeList = getOfficesFromLocalStorage();
            if(loadFromServer || utilService.isEmptyArray(officeList)) {
                $http.get(API.office.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            setOfficesInLocalStorage(data.officeList);
                            defer.resolve(data.officeList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message);
                    });
            } else {
                defer.resolve(officeList);
            }
            return defer.promise;
        };

        self.getOffice = function(loadFromServer,officeId) {
            var defer = $q.defer();
            if(loadFromServer || utilService.isEmptyArray(officeList)) {
                self.getAllOffices().then(function(){
                    for(var i = 0; i < self.offices.length ; i++){
                        if(self.offices[i].id == officeId){
                            return defer.resolve(self.offices[i]);
                        }
                    }
                }, function () {
                    return defer.reject();
                })
            } else {
                for(var i = 0; i < self.offices.length ; i++){
                    if(self.offices[i].id == officeId){
                        return defer.resolve(self.offices[i]);
                    }
                }
            }
            return defer.promise;
        };

        self.updateOfficeInfo = function (data,officeId) {
            var defer = $q.defer();

            $http.post(API.office.all + officeId,data)
                .success(function(responseData, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                       defer.resolve(responseData);
                       setOfficesInLocalStorage(responseData.officeList);
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;


        };

        self.getCompanyOffices = function(loadFromServer,companyId)
        {
            var defer = $q.defer();

            var url = API.office.companyOffices+ "?companyId=" + companyId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                        setOfficesInLocalStorage(data.officeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;

        };

        // TODO local cache
        self.getOfficesFromCompanyIdArray = function(loadFromServer,companyIdArray)
        {
            var defer = $q.defer();

            var url = API.office.companyOffices;
            var urlQuery = buildURLFromArray("companyId", companyIdArray);
            if(urlQuery) url = url + "?" + urlQuery
            //console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                        setOfficesInLocalStorage(data.officeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : " ");
                });

            return defer.promise;

        };

        function setOfficesInLocalStorage(data) {
            self.offices = data;
            $window.localStorage.setItem('offices', JSON.stringify(data));
        }

        function getOfficesFromLocalStorage() {
            if(!utilService.isEmptyArray(self.offices)) return self.offices;
            var o = $window.localStorage.getItem('offices');
            self.offices =  o ? JSON.parse(o) : [];
            return self.offices;
        }

        function addNewOfficeInLocalStorage(office) {
            var offices = getOfficesFromLocalStorage();
            if (utilService.isEmptyArray(offices)) offices = [];
            offices.push(office);
            setOfficesInLocalStorage(office);
        }

        function updateOfficeInLocalStorage(office) {
            var offices = getOfficesFromLocalStorage();
            if (utilService.isEmptyArray(offices)) {
                addNewOfficeInLocalStorage(office);
            } else {
                for (var i = 0; i < offices.length; i++) {
                    if (offices[i].id === office.id) {
                        offices[i] = office;
                    }
                }
                setOfficesInLocalStorage(depts);
            }
        }

        self.getOfficeNameById = function (officeId){
            var offices = getOfficesFromLocalStorage();
            if(!offices || !(offices instanceof Array) || offices.length == 0){
                var myOffice = authService.getMyOfficeInformation();
                if(myOffice.id === officeId) return myOffice.name;
            }
            var office = offices.find(function (office) {
                return office.id === officeId;
            });
            return !office ? "" : office.name;
        };

        function buildURLFromArray(key, valueArray) {
            if(!key || !valueArray) return "";
            var url = "&"+key+"=";
            if(valueArray.constructor === Array){
                url = url + valueArray.join(",");
            } else{
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

    }
    app.service('officeService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService','authService', officeService]);

})();
(function(){

    'use strict';

    function overtimeService(authService,$http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getOvertime = function(params) {
            var defer = $q.defer();
            var url = API.overtime.report;
            if(!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            var queryParams = {
                params:{
                    from             : params.from,
                    to               : params.to,
                    subsidiaryId     : params.subsidiaryId,
                    designationId    : params.designationId,
                    departmentId     : params.departmentId,
                    shiftGroupId     : params.shiftGroupId,
                    genderId         : params.genderId,
                    companyId        : params.companyId,
                    workplaceId      : params.workplaceId,
                    officeId         : params.officeId,
                    employmentTypeId : params.employmentTypeId,
                    employeeId       : params.employeeId,
                    employeeName     : params.employeeName,
                    lineManagerId    : params.lineManagerId,
                    pageNumber       : params.pageNumber,
                    perPage          : params.perPage,
                    sortKey          : params.sortKey,
                    order            : params.order
                }
            };
            // console.log("get request to url : " + url);
            $http.get(url,queryParams)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getOvertimeReportPdf = function (params){
            var pdfUrl = API.overtime.overtimeReportPdf;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            pdfUrl = pdfUrl + "?from=" + params.from + "&to=" + params.to;
            pdfUrl = pdfUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId);
            if (params.employeeId && params.employeeId > 0)
                pdfUrl = pdfUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                pdfUrl = pdfUrl + "&employeeName=" + params.employeeName;
            params.sortKey = !params.sortKey || params.sortKey == null|| params.sortKey == ''  ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            pdfUrl = pdfUrl + ("&sortKey=" + params.sortKey );
            pdfUrl = pdfUrl + ("&order=" + params.order);
            pdfUrl = pdfUrl + ("&perPage=" + params.perPage);
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        };

        self.getOvertimeReportExcel = function (params){
            var excelUrl = API.overtime.excelReport;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            params.sortKey = !params.sortKey || params.sortKey == null|| params.sortKey == ''  ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey );
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        };

        self.getMonthlyOvertimeReportExcel = function (params){
            var excelUrl = API.overtime.monthlyOvertimeExcel;
            if (!params.from || params.from < 0 || !params.to || params.to < 0 || params.to < params.from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from=" + params.from + "&to=" + params.to;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("shiftId", params.shiftId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId);
            if (params.employeeId && params.employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + params.employeeId;
            if (params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            params.sortKey = !params.sortKey || params.sortKey == null|| params.sortKey == ''  ? 'empOfficeId' : params.sortKey;
            params.order = !params.order || params.order == null || params.order == '' ? 'asc' : params.order;
            excelUrl = excelUrl + ("&sortKey=" + params.sortKey );
            excelUrl = excelUrl + ("&order=" + params.order);
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl+'&token='+authService.getLoggedInToken();
            return excelUrl;
        };

        self.getProfileOvertimeExcelUrl = function (from, to, designationIdList, departmentIdList, shiftIdList, employeeId, employeeName, companyIdList, officeIdList){
            var excelUrl = API.overtime.getProfileOvertimeExcel;
            if(!from || from < 0 || !to || to <0 || to < from) defer.reject("invalid search criteria");
            excelUrl = excelUrl + "?from="+from+"&to="+to;
            excelUrl = excelUrl + buildURLFromArray("designationId", designationIdList) + buildURLFromArray("departmentId" , departmentIdList) + buildURLFromArray("shiftId", shiftIdList) + buildURLFromArray("companyId", companyIdList) + buildURLFromArray("officeId", officeIdList);
            if(employeeId && employeeId > 0)
                excelUrl = excelUrl + "&employeeId=" + employeeId;
            if(employeeName)
                excelUrl = excelUrl + "&employeeName=" + employeeName;
            excelUrl = excelUrl+'&token='+authService.getLoggedInToken();
            return excelUrl;
        };

        self.changeOvertimeStatus = function (data) {
            var defer = $q.defer();
            // console.log("Post request to url : " + API.overtime.changeStatus);
            $http.post(API.overtime.changeStatus,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if(!key || !valueArray || valueArray.length < 1) return "";
            var url = "&"+key+"=";
            if(valueArray.constructor === Array){
                url = url + valueArray.join(",");
            } else{
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.updateApprovedOvertime = function (summaryId,data) {
            var defer = $q.defer();
            // console.log("Post request to url : " + API.overtime.updateApprovedOvertime+summaryId);
            $http.post(API.overtime.updateApprovedOvertime+summaryId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

        self.getPendingOvertimesCount = function () {
            var defer = $q.defer();
            // console.log("get request to url : " + API.overtime.getPendingOvertimeCount);
            $http.get(API.overtime.getPendingOvertimeCount)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.count);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

    }
    app.service('overtimeService', ['authService','$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', overtimeService]);

})();
(function () {

    'use strict';

    function parkingManagementService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllBillSetup = function () {
            var defer = $q.defer();
            $http.get(API.parkingManagement.billSetup.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicleTypeList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getNearbyVehicle = function () {
            var defer = $q.defer();
            $http.get(API.parkingManagement.nearbyVehicle)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicles);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getNearbyVehicleDetails = function (params) {
            var defer = $q.defer();
            $http.get(API.parkingManagement.nearbyVehicleDetails, {params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicle);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getNearbyVehicleExit = function () {
            var defer = $q.defer();
            $http.get(API.parkingManagement.nearbyVehicleExit)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.exitVehicles);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.postDeleteBillSetup = function (data) {
            var defer = $q.defer();
            $http.post(API.parkingManagement.billSetup.delete + data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicleTypeList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.postCreateBillSetup = function (data) {
            var defer = $q.defer();
            $http.post(API.parkingManagement.billSetup.all, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.vehicleTypeList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.postUpdateBillSetup = function (data) {
            var defer = $q.defer();
            $http.post(API.parkingManagement.billSetup.update, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getAllVehicleInfo = function (searchParams) {
            var defer = $q.defer();
            $http.get(API.parkingManagement.vehicle.getAll, {
                params: {
                    pageNumber: searchParams.pageNumber,
                    perPage: searchParams.perPage,
                    keyword: searchParams.keyword
                }
            })
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };
        self.createOrUpdateVehicleInformation = function (formData) {
            var defer = $q.defer();
            var url = API.parkingManagement.vehicle.save;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data);
                });
            return defer.promise;
        };
        self.deleteVehicleInformation = function (id) {
            var defer = $q.defer();
            var url = API.parkingManagement.vehicle.delete + id;
            $http.post(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };
        self.getAllParkingSlot = function () {
            var defer = $q.defer();
            $http.get(API.parkingManagement.parkingSlot.getAll)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };
        self.createOrUpdateParkingSlotSetup = function (formData) {
            var defer = $q.defer();
            var url = API.parkingManagement.parkingSlot.save;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };
        self.deleteParkingSlotSetup = function (id) {
            var defer = $q.defer();
            var url = API.parkingManagement.parkingSlot.delete + id;
            $http.post(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.entryVehicle = function (data) {
            var defer = $q.defer();
            $http.post(API.parkingManagement.entryVehicle, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getLiveFeed = function () {
            var defer = $q.defer();
            $http.get(API.parkingManagement.liveFeed)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.parkingDashboardList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getEnteredVehicle = function (params) {
            var defer = $q.defer();
            $http.get(API.parkingManagement.enteredVehicle, {params: params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.parkingDashboardList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getParkingDetails = function (summaryId) {
            var defer = $q.defer();
            $http.get(API.parkingManagement.summaryDetails + summaryId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.exitVehicle = function (data) {
            var defer = $q.defer();
            $http.post(API.parkingManagement.exitVehicle, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.exitWithoutPrint = function (data) {
            var defer = $q.defer();
            $http.post(API.parkingManagement.exitWithoutPrint, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getDailyParkingReportInfo = function (params) {
            var defer = $q.defer();
            $http.get(API.parkingManagement.dailyReport, {params: params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getMonthlyParkingReportInfo = function (params) {
            // console.log(params)
            var defer = $q.defer();
            $http.get(API.parkingManagement.monthlyReport, {params: params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.searchVehicleWithNumber = function (keyword) {
            var defer = $q.defer();
            $http.get(API.parkingManagement.vehicle.searchVehicle + '?keyword='+ keyword)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getMonthlyParkingReportPdfUrl = function (params, allowAllDownload) {
            var pdfUrl = API.parkingManagement.monthlyReportPdf;
            if (!params.startDateInMillis || params.startDateInMillis < 0 || !params.endDateInMillis || params.endDateInMillis < 0 || params.endDateInMillis < params.startDateInMillis) return ("invalid search criteria");
            pdfUrl = pdfUrl + "?startDateInMillis=" + params.startDateInMillis + "&endDateInMillis=" + params.endDateInMillis + "&pageNumber=" + params.pageNumber + "&perPage=" + params.perPage + "&unpaged=" + allowAllDownload;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        };
        self.getMonthlyParkingReportExcelUrl = function (params, allowAllDownload) {
            var excelUrl = API.parkingManagement.monthlyReportExcel;
            if (!params.startDateInMillis || params.startDateInMillis < 0 || !params.endDateInMillis || params.endDateInMillis < 0 || params.endDateInMillis < params.startDateInMillis) return ("invalid search criteria");
            excelUrl = excelUrl + "?startDateInMillis=" + params.startDateInMillis + "&endDateInMillis=" + params.endDateInMillis + "&pageNumber=" + params.pageNumber + "&perPage=" + params.perPage + "&unpaged=" + allowAllDownload;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        };

        self.getSlotInfo = function () {
            var defer = $q.defer();
            $http.get(API.parkingManagement.slotInfo)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getDailyParkingReportPdfUrl = function (params, allowAllDownload) {
            var pdfUrl = API.parkingManagement.dailyReportPdfURL;
            pdfUrl = pdfUrl + "?dateInMillis=" + params.dateInMillis + "&pageNumber=" + params.pageNumber + "&count=" + params.count + "&keyword=" + params.keyword + "&unpaged=" + allowAllDownload;
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        }
        self.getDailyParkingReportExcelUrl = function (params, allowAllDownload) {
            var excelUrl = API.parkingManagement.dailyExcelURL;
            excelUrl = excelUrl + "?dateInMillis=" + params.dateInMillis + "&pageNumber=" + params.pageNumber + "&count=" + params.count + "&keyword=" + params.keyword + "&unpaged=" + allowAllDownload
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }


    }

    app.service('parkingManagementService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', parkingManagementService]);

})();
(function () {
    'use strict';
    function payrollManagementService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getProcessedSalaries = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getProcessedSalaries;

            $http.get(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getUnprocessedSalaries = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getUnprocessedSalaries;

            $http.get(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.generateSalary = function (data) {
            var defer = $q.defer();
            var url = API.payrollManagement.generateSalary;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getSalarySummary = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getSalarySummary;

            $http.get(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getEmployeeInfoWithSalary = function (employeeId) {
            var defer = $q.defer();
            var url = API.payrollManagement.getEmployeeInfoWithSalary + employeeId;

            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };
        self.getProfilePaymentDetails=function (employeeId,params){
            var defer = $q.defer();
            var url= API.payrollManagement.getProfilePaymentDetails+employeeId;

            $http.get(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };
        self.postProfilePaymentDetails=function (employeeId,data){
            var defer = $q.defer();
            var url= API.payrollManagement.postProfilePaymentDetails+employeeId;
            $http.post(url,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.generateSalaryCertificate = function (employeeId, params) {
            var defer = $q.defer();
            var url = API.payrollManagement.generateSalaryCertificate + employeeId;

            $http.get(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.updateSalaryDetails = function (data){
            var defer = $q.defer();
            var url = API.payrollManagement.updateSalaryDetails;

            $http.post(url,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };

        self.processSalary = function (data){
            var defer = $q.defer();
            var url = API.payrollManagement.processSalary;

            $http.post(url,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.undoSalary = function (data){
            var defer = $q.defer();
            var url = API.payrollManagement.undoSalary;

            $http.post(url,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.sendSalaryForApproval = function (monthlySalaryId){
            var defer = $q.defer();
            var url = API.payrollManagement.sendForApproval + monthlySalaryId;
            $http.post(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.getCertificateDocUrl = function (employeeId, signatoryEmployeeId) {
            return API.payrollManagement.downloadSalaryCertificate + employeeId + "?signatoryEmployeeId=" + signatoryEmployeeId + "&token=" + authService.getLoggedInToken();
        }


        self.approveSalary = function (salarySummaryId){
            var defer = $q.defer();
            var url = API.payrollManagement.approveSalary + salarySummaryId;
            $http.post(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.rollbackSalary = function (data){
            var defer = $q.defer();
            var url = API.payrollManagement.rollbackSalary;
            $http.post(url,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.paySalary = function (monthlySalaryId){
            var defer = $q.defer();
            var url = API.payrollManagement.paySalary+monthlySalaryId;
            $http.post(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.getSalaryLog = function (monthlySalaryLogId){
            var defer = $q.defer();
            var url = API.payrollManagement.salaryLog + monthlySalaryLogId;
            $http.get(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        }

        self.getExcelUrl = function (monthlySalarySummary,searchKeyword){
            var excelUrl = API.payrollManagement.downloadSalaryReport
                +"?month="+monthlySalarySummary.month
                +"&year="+monthlySalarySummary.year
                +"&keyword="+ (searchKeyword? searchKeyword:"");
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getEmployeeAdditionalPayComponents = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getEmpAddPayComponent;

            $http.get(url, {
                params: {
                    salaryProcessType: params.salaryProcessType,
                    fromMonth: params.fromMonth,
                    fromYear: params.fromYear,
                    toMonth: params.toMonth,
                    toYear: params.toYear,
                    componentIds: params.componentIds,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    status: params.status,
                    reportType: params.reportType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.uploadAdditionalComponentExcel = function (file, request) {
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.uploadAdditionalComponentExcelFile;
            var formData = new FormData();
            formData.append("file", file);
            formData.append("postBody",JSON.stringify(request));
            $http({
                method: 'POST',
                url: String(url),
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetter) {
                    return data;
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.downloadAdditionalComponentSample = function () {
            return API.additionalPayrollComponents.downloadAdditionalComponentSampleExcel+ '?token=' + authService.getLoggedInToken();
        };

        self.uploadLeaveApplyCalculationExcel = function (file, request) {
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.uploadLeaveApplyCalculationExcelFile;
            var formData = new FormData();
            formData.append("file", file);
            formData.append("postBody",JSON.stringify(request));
            $http({
                method: 'POST',
                url: String(url),
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetter) {
                    return data;
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.downloadLeaveApplyCalculationSample = function () {
            return API.additionalPayrollComponents.downloadLeaveApplySampleExcel + '?token=' + authService.getLoggedInToken();
        };

        self.getAbsentLwpComponents = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getAbsentLwpComponent;
            $http.get(url, {
                params: {
                    salaryProcessType: params.salaryProcessType,
                    salaryMonth: params.salaryMonth,
                    salaryYear: params.salaryYear,
                    componentIds: params.componentIds,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    status: params.status,
                    reportType: params.reportType,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                    order: params.order
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.saveLeaveWithoutPayDataForASingleEmployee = function (data){
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.addLeaveWithoutPay;
            $http.post(url, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateLeaveWithoutPayDataForSingleEmployee = function (data){
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.updateLeaveWithoutPay;
            $http.post(url, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.createAdditionalComponentForEmployee = function (formData){
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.createAdditionalForEmployee;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateAdditionalComponentForEmployee = function (formData){
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.updateAdditionalForEmployee;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };
        self.deleteSingleAdditionalComponent = function (data) {
            var defer = $q.defer();
            var url = API.additionalPayrollComponents.deleteSingAdditional;
            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };
        self.getMonthOnMonthComparison = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getMonthOnMonthComparison;
            $http.get(url, {
                params: {
                    salaryProcessType: params.salaryProcessType,
                    salaryMonth: params.salaryMonth,
                    salaryYear: params.salaryYear,
                    comparisonMonth: params.comparisonMonth,
                    comparisonYear: params.comparisonYear,
                    componentIds: params.componentIds,
                    designationId: params.designationId,
                    departmentId: params.departmentId,
                    shiftGroupId: params.shiftGroupId,
                    genderId: params.genderId,
                    companyId: params.companyId,
                    officeId: params.officeId,
                    employmentTypeId: params.employmentTypeId,
                    employeeId: params.employeeId,
                    employeeName: params.employeeName,
                    lineManagerId: params.lineManagerId,
                    workplaceId: params.workplaceId,
                    hrManagerId: params.hrManagerId,
                    pageNumber: params.pageNumber,
                    perPage: params.perPage,
                    sortKey: params.sortKey,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getBankPaymentAdviceSummary = function (params) {
            var defer = $q.defer();
            var url = API.payrollManagement.getBankAdviceSummary;
            $http.get(url,params)
                .success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };
        self.getBankPaymentAdviceForSelectedMonth = function (params,bankId, monthlySalaryId) {
            var defer = $q.defer();
            var url = API.payrollManagement.getBankPaymentAdviceDetails + bankId +'/'+ monthlySalaryId;
            $http.get(url, {params : params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.updateIndividualBankPayment = function (updatedData){
            var defer = $q.defer();
            var url = API.payrollManagement.updateIndividualBankPayment;
            $http.post(url, updatedData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getBankPaymentExcelUrlForSelectedMonth = function (bankId, monthlySalaryId, params) {
            var excelUrl = API.payrollManagement.getBankPaymentAdviceDetails + bankId + "/" + monthlySalaryId + "/excel?";

            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            if(params.employeeName)
                excelUrl = excelUrl + "&employeeName=" + params.employeeName;
            if(params.minAmount)
                excelUrl = excelUrl + "&minAmount=" + params.minAmount;
            if(params.maxAmount)
                excelUrl =excelUrl + "&maxAmount=" + params.maxAmount;
            excelUrl = excelUrl + ("&perPage=" + params.perPage);
            excelUrl = excelUrl + ("&pageNumber=" + params.pageNumber);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }
    }

    app.service('payrollManagementService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', payrollManagementService]);
})();
(function () {
    'use strict';
    function payrollSettingsService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.createPayrollSettings = function (data){
            var defer = $q.defer();
            $http.post(API.payrollManagement.createPayrollSettings, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };

        self.updatePayrollSettings = function (data){
            var defer = $q.defer();
            $http.post(API.payrollManagement.updatePayrollSettings, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getPayrollSettingsStatus = function (){
            var defer = $q.defer();
            $http.get(API.payrollManagement.getPayrollSettingsStatus)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getPayrollSettingsData = function (){
            var defer = $q.defer();
            $http.get(API.payrollManagement.getPayrollSettingsData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getPayrollComponentData = function (componentId){
            var defer = $q.defer();
            $http.get(API.payrollManagement.getPayrollSettingsData + componentId)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.updatePayrollComponentData = function (componentId, params){
            var defer = $q.defer();
            $http.post(API.payrollManagement.getPayrollSettingsData + componentId, params)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.createPayrollComponentData = function (params){
            var defer = $q.defer();
            $http.post(API.payrollManagement.createPayrollComponent, params)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getSalaryManagementList = function (params){
            var defer = $q.defer();
            $http.get(API.payrollManagement.getSalaryManagementList, {params:params})
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getEmployeePayrollComponents = function (employeeId){
            var defer = $q.defer();
            $http.get(API.payrollManagement.getEmployeePayrollComponents + employeeId)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.setupEmployeePayrollComponents = function (data){
            var defer = $q.defer();
            $http.post(API.payrollManagement.setupEmployeePayrollComponents,data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getSampleExcelUrl = function () {
            return API.payrollManagement.getSampleExcelFile + "?token=" + authService.getLoggedInToken();
        }
        self.getPayrollSettingsByComponentTypeAndStatus = function (types, status){
            var defer = $q.defer();
            $http.get(API.payrollManagement.getPayrollSettingsByComTypeAndStatus,{
                params: {
                    componentTypes: types,
                    componentStatus: status,
                }
            })
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getEmployeePayslipInformation = function (employeeId, month, year) {
            var defer = $q.defer();
            $http.get(API.payrollManagement.getPayslipData, {
                params : {
                    employeeId : employeeId,
                    month      : month,
                    year       : year
                }
            }).success(function (data, status) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data);
                }
            });
            return defer.promise;
        }
    }

    app.service('payrollSettingsService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', payrollSettingsService]);
    })();
(function(){

    'use strict';

    function productService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.createProduct = function (data) {
            var defer = $q.defer();
            var url = API.project.createProduct;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.editProduct = function (data) {
            var defer = $q.defer();
            var url = API.project.editProduct;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getProductsOfOffice = function(params) {
            var defer = $q.defer();
            $http.get(API.project.getAllProducts, {params: params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getSimplifiedProductList = function() {
            var defer = $q.defer();
            $http.get(API.project.simplifiedProductList)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.deleteProduct = function(id) {
            var defer = $q.defer();
            $http.post(API.project.deleteProduct + id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


    }

    app.service('productService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', productService]);

})();
(function(){

    'use strict';

    function productSegmentService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;


        self.getProductSegmentsOfOffice = function() {
            var defer = $q.defer();
            $http.get(API.project.getAllProductSegments)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createProductSegment = function (data) {
            var defer = $q.defer();
            var url = API.project.createProductSegment;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };


    }

    app.service('productSegmentService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', productSegmentService]);

})();
(function () {

    'use strict';

    function projectService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getProject = function (projectId) {
            var defer = $q.defer();
            $http.get(API.project.all + projectId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        setProjectsInLocalStorage(data.projectWork);
                        defer.resolve(data.projectWork);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllProjects = function (loadFromServer) {
            var defer = $q.defer();
            var projectWorkList = getProjectsFromLocalStorage();
            if (loadFromServer || utilService.isEmptyArray(projectWorkList)) {
                $http.get(API.project.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            setProjectsInLocalStorage(data.projectWorkList);
                            defer.resolve(data.projectWorkList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else {
                defer.resolve(projectWorkList);
            }
            return defer.promise;
        };

        self.getFilteredProjectList = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.project.filtered, {params : params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getProjectList = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.project.simple)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllEmployees = function (projectId) {
            var defer = $q.defer();
            $http.get(API.project.all + 'employees/' + projectId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        setProjectsInLocalStorage(data.employees);
                        defer.resolve(data.employees);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getGanttChartData = function (chartType, data) {
            var defer = $q.defer()
            var url = API.project.all;
            if (chartType === 'employee') url = url + 'gantt-chart-employee' + '?employeeId=' + data.employeeId;
            else url = url + 'gantt-chart-project' + '?projectWorkId=' + data.projectWorkId;
            if(data.status != null) url = url + buildURLFromArray('status', data.status);
            if(data.startDate != null) url = url + '&startDate=' + data.startDate;
            if(data.endDate != null) url = url + '&endDate=' + data.endDate;
            $http.get(url).success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getWorkHourReportData = function (data) {
            var defer = $q.defer()
            var url = API.project.all + 'work-hour-project/';
            url = url + '?projectWorkId=' + data.projectWorkId;
            if(data.startDate != null) url = url + '&startDate=' + data.startDate;
            if(data.endDate != null) url = url + '&endDate=' + data.endDate;
            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data.report);
                }
                else {
                    defer.reject(data.message);
                }
            })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getMonthlyDedicationReport = function (data) {
            var defer = $q.defer()
            var url = API.project.all + 'monthly-dedication/';
            url = url + '?startDate=' + data.startDate;
            url = url + '&endDate=' + data.endDate;
            if(data.projectWorkId != null) url = url + buildURLFromArray('projectWorkId', data.projectWorkId);
            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data.report);
                }
                else {
                    defer.reject(data.message);
                }
            })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createProjectForTDH = function (data) {
            var defer = $q.defer();

            $http.post(API.project.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        addNewProjectInLocalStorage(responseData.projectWork);
                        defer.resolve(getProjectsFromLocalStorage());
                    } else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.createProject = function (data) {
            var defer = $q.defer();

            $http.post(API.project.create, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateProject = function (data) {
            var defer = $q.defer();

            $http.post(API.project.update, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateProjectInfo = function (data, project) {
            var defer = $q.defer();
            $http.post(API.project.all + project.id + '/update', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateProjectInLocalStorage(project);
                        defer.resolve();
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.addEmployeesToProject = function (data, projectId) {
            var defer = $q.defer();
            $http.post(API.project.all + projectId + '/add-employee', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateProjectInLocalStorage(responseData.projectWork);
                        defer.resolve(responseData.projectWork);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.removeEmployeeFromProject = function (projectId, employeeId) {
            var defer = $q.defer();
            $http.post(API.project.all + projectId + '/removeEmployee/' + employeeId)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.deleteTdhProject = function (project) {
            var defer = $q.defer();
            $http.post(API.project.deleteTdhProject  + project.id)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        project.status = -1;
                        updateProjectInLocalStorage(project);
                        defer.resolve(getProjectsFromLocalStorage());
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.deleteProject = function (projectId) {
            var defer = $q.defer();

            $http.post(API.project.delete + projectId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllProjectTypes = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.project.types.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createProjectType = function (data) {
            var defer = $q.defer();
            var url = API.project.types.create;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };



        function setProjectsInLocalStorage(data) {
            $window.localStorage.setItem('projects', JSON.stringify(data));
        }

        function getProjectsFromLocalStorage() {
            var d = $window.localStorage.getItem('projects');
            return d ? JSON.parse(d) : [];
        }

        function addNewProjectInLocalStorage(project) {
            var projs = getProjectsFromLocalStorage();
            if (utilService.isEmptyArray(projs)) projs = [];
            projs.push(project);
            setProjectsInLocalStorage(projs);
        }

        function updateProjectInLocalStorage(project) {
            var projs = getProjectsFromLocalStorage();
            if (utilService.isEmptyArray(projs)) {
                if(project.status != -1){
                    addNewProjectInLocalStorage(project);
                }
            } else {
                for (var i = 0; i < projs.length; i++) {
                    if (projs[i].id === project.id) {
                        if(project.status === -1){
                            projs.splice(i,1);
                        } else{
                            projs[i] = project;
                        }
                    }
                }
                setProjectsInLocalStorage(projs);
            }
        }

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

    }

    app.service('projectService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', projectService]);

})();
(function(){

    'use strict';

    function projectClientService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, authService){

        var self = this;

        self.getAllOrganisationTypes = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.projectClient.organisationType.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.allOrganisationTypes);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllProjectClients = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.projectClient.all, {params : params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getSimplifiedProjectClientList = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.projectClient.simplifiedList)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createOrganisationType = function (data) {
            var defer = $q.defer();
            var url = API.projectClient.organisationType.create;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.createProjectClient = function (formData) {
            var defer = $q.defer();
            var url = API.projectClient.create;

            $http.post(url, formData).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.updateProjectClient = function (formData) {
            var defer = $q.defer();
            var url = API.projectClient.update;

            $http.post(url, formData).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.deleteProjectClient = function (clientId) {
            var defer = $q.defer();
            var url = API.projectClient.delete + clientId;

            $http.post(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

    }

    app.service('projectClientService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE','authService', projectClientService]);

})();
(function(){

    'use strict';

    function projectIssuesService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.createIssue = function (request, file) {
            var defer = $q.defer();
            var url = API.projectIssues.create;

            var formData = new FormData();
            formData.append("file", file);
            formData.append("postBody", JSON.stringify(request));

            $http({
                method: 'POST',
                url: String(url),
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetter) {
                    return data;
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.updateIssue = function (request, file) {
            var defer = $q.defer();
            var url = API.projectIssues.update;

            var formData = new FormData();
            formData.append("file", file);
            formData.append("postBody", JSON.stringify(request));

            $http({
                method: 'POST',
                url: String(url),
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetter) {
                    return data;
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getFilteredIssueList = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.projectIssues.search, {params : params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getFilteredIssueCreators = function(params) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.projectIssues.creators, {params : params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getIssueDetails = function(issueId) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.projectIssues.details + issueId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getAllIssueLogs = function(issueId) {
            var defer = $q.defer();
            var url = API.projectIssues.allLogs + "?issueId=" + issueId;
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateIssueLog = function(data) {
            var defer = $q.defer();
            var url = API.projectIssues.updateLog;
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.removeCreator = function(employeeId) {
            var defer = $q.defer();
            var url = API.projectIssues.removeCreator + employeeId;
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.addIssueCreator = function (employeeId) {
            var defer = $q.defer();
            var url = API.projectIssues.addCreator + employeeId;
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

    }

    app.service('projectIssuesService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', projectIssuesService]);

})();
(function () {
    'use strict';
    function providentFundService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getPFMemberList = function (params) {
            var defer = $q.defer();
            var url = API.providentFund.getMemberList;

            $http.get(url, {params:params}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getPFMemberDetails = function (params) {
            var defer = $q.defer();
            var url = API.providentFund.getPFMemberDetails;

            $http.get(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.addPFMember = function (data) {
            var defer = $q.defer();
            var url = API.providentFund.addPFMember;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getPFStatementOfAnEmployee = function (id,params) {
            var defer = $q.defer();
            var url = API.providentFund.getPFStatement + id;

            $http.get(url, {params:params}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getPFAccountYear = function (params) {
            var defer = $q.defer();
            var url = API.providentFund.getPFAccountYear;

            $http.get(url, {params:params}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getPFAccountManagementSummary = function () {
            var defer = $q.defer();
            var url = API.providentFund.getPFAccountSummary;

            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getPFMemberAccountDetails = function (id, params) {
            var defer = $q.defer();
            var url = API.providentFund.getPFMemberAccountDetails + id + '/summary';

            $http.get(url, {params:params}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getInterestUploadStatus = function (id) {
            var defer = $q.defer();
            var url = API.providentFund.getUploadInterestStatus + id;

            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.uploadInterest = function (id,data) {
            var defer = $q.defer();
            var url = API.providentFund.uploadInterest + id;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };
        self.closeAccountingYear = function (id) {
            var defer = $q.defer();
            var url = API.providentFund.closeAccountingYear + id;

            $http.post(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getYearlyAccountDetails = function (accountId, params) {
            var defer = $q.defer();
            var url = API.providentFund.getYearlyAccountDetails + accountId;

            $http.get(url, {params:params}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getAccountingYear = function () {
            var defer = $q.defer();
            var url = API.providentFund.getAccountingYear;

            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.savePaymentDuringTheYear = function (params) {
            var defer = $q.defer();
            var url = API.providentFund.uploadSeparationPayment;

            $http.post(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.saveForfeitureForTheYear = function (params) {
            var defer = $q.defer();
            var url = API.providentFund.uploadForfeitedAmount;

            $http.post(url, params).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getStatementPdf = function (params, id) {
            var pdfUrl = API.providentFund.getStatementPdf + id+"?";
            if(params.from)
                pdfUrl = pdfUrl + "&from=" + params.from;
            if(params.to)
                pdfUrl =pdfUrl + "&to=" + params.to;
            pdfUrl = pdfUrl + ("&perPage=0");
            pdfUrl = pdfUrl + ("&pageNumber=" + params.pageNumber);
            pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();

            return pdfUrl;
        };

        self.getPFMemberExcel = function (params) {
            var excelUrl = API.providentFund.getPFMemberExcel;

            excelUrl = excelUrl + ("?searchKey=" + params.searchKey);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };

        self.getAccountManagementExcel = function (id) {
            var excelUrl = API.providentFund.getAccountManagementExcel;

            excelUrl = excelUrl + ("?yearlyAccountId=" + id);
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();

            return excelUrl;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }
    }

    app.service('providentFundService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', providentFundService]);
})();
(function(){

    'use strict';

    function remainingLeaveService($http, $q, API, RESPONSE_CODE){
        var self = this;

        self.getAllRemainingLeavesOfEmployee = function(employeeId, year) {
            var defer = $q.defer();
            var url = API.remainingLeaves.employeeRemainingLeaves + employeeId;
            if(year!= null && year!=undefined)
                url = url + "?year="+year;
            // console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllRemainingLeavesOfEmployeeInFiscalYear = function(employeeId, fiscalYearStartDate, fiscalYearEndDate) {
            var defer = $q.defer();
            var url = API.remainingLeaves.employeeRemainingLeavesInFiscalYear + employeeId;
            if(fiscalYearStartDate!= null && fiscalYearStartDate !=undefined && fiscalYearEndDate != null && fiscalYearEndDate != undefined)
                url = url + "?fiscalYearStartDate="+fiscalYearStartDate + "&fiscalYearEndDate="+fiscalYearEndDate;
            // console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getApproversLeaves = function(employeeId) {
            var defer = $q.defer();
            var url = API.remainingLeaves.approversLeaves+employeeId;
            // console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leaveApplications);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getPendingHalfDayApprovals = function (employeeId) {
            var defer = $q.defer();
            var url = API.leaveManagement.getHalfDayApplicationsOfApprover+employeeId;
            // console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.leaveApplications);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        }

        self.getAvailableExchangeLeaveDates = function (employeeId, year) {
            var defer = $q.defer();
            var url = API.remainingLeaves.exchangeLeave+employeeId+"/"+year;
            // console.log("get request to url : " + url);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;

        }

        self.getDistinctLeaveBalanceDateRanges = function () {
            var defer = $q.defer();
            var url = API.remainingLeaves.getDistinctDateRange;
            $http.get(url)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data) {
                    defer.reject(data.message ? data.message : "Error fetching date ranges");
                });
            return defer.promise;
        };
    }



    app.service('remainingLeaveService', ['$http', '$q', 'API', 'RESPONSE_CODE', remainingLeaveService]);

})();
(function () {

    'use strict';

    function rosterService($http, $q, API, authService, RESPONSE_CODE) {

        var self = this;

        self.getBasicRoster = function () {
            var defer = $q.defer();
            $http.get(API.roster.getBasic)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.rosters);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAdvancedRoster = function (employeeId, shiftGroupIdArray) {
            var defer = $q.defer();
            var params = {
                employeeId    : employeeId,
                shiftGroupId     : shiftGroupIdArray == null || shiftGroupIdArray.length == 0 ? [] : shiftGroupIdArray
            };
            $http.get(API.roster.advanced,{
                params : params
            })
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.roster);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


        self.updateRosterBasic = function (data) {
            var defer = $q.defer();
            $http.post(API.roster.updateBasic, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.updateRosterAdvanced = function (data) {
            var defer = $q.defer();
            $http.post(API.roster.advanced, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.rosterList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.getProfileRoster = function (params) {
            var defer = $q.defer();
            $http.get(API.roster.profile, {
                params:params
            }).success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.getNextShiftChange = function (params) {
            var defer = $q.defer();
            var url = API.roster.getNextShiftChange + "?shiftGroupId=" + params.shiftGroupId + "&currentShiftId=" + params.currentShiftId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.nextShiftInfo);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getShiftTimingOfADayForAShiftGroup = function (params){
            var defer = $q.defer();
            var url = API.roster.getShiftTiming;
            $http.get(url,{params:params})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getLatestOffday = function (params) {
            var defer = $q.defer();
            var url = API.roster.getLatestOffday + "?shiftGroupId=" + params.shiftGroupId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.latestOffdayInfo);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.downloadRoster = function(startDate, endDate) {
            var excelUrl = API.roster.downloadRoster + "?startDate=" + startDate + "&endDate=" + endDate + "&token=" + authService.getLoggedInToken();
            return excelUrl;
        };

    }

    app.service('rosterService', ['$http', '$q', 'API', 'authService', 'RESPONSE_CODE', rosterService]);

})();
(function () {
    'use strict';

    function salaryReportService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.getSalaryComparisonOfTwoMonths = function (searchParams) {
            var defer = $q.defer();
            $http.get(API.payrollManagement.salaryComparison, {
                params: searchParams
            })
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };
        self.createOrUpdateMonthOnMonthComparisonRemarks = function (formData) {
            var defer = $q.defer();
            var url = API.payrollManagement.saveMonthOnMonthComparisonRemarks;
            $http.post(url, formData)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.message);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getMonthOnMonthComparisonReportExcelUrl = function (params) {
            var excelUrl = API.payrollManagement.getMonthOnMonthComparisonReportExcel;
            excelUrl = excelUrl + "?salaryProcessType=" + params.salaryProcessType
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("componentIds", params.componentIds)
                + buildURLFromArray("status", params.status);
            excelUrl = excelUrl + "&salaryMonth=" + params.salaryMonth;
            excelUrl = excelUrl + "&salaryYear=" + params.salaryYear;
            excelUrl = excelUrl + "&comparisonMonth=" + params.comparisonMonth;
            excelUrl = excelUrl + "&comparisonYear=" + params.comparisonYear;
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&perPage=" + params.perPage;
            excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
        self.getSalaryComparisonSummaryExcelUrl = function (params) {
            var excelUrl = API.payrollManagement.salaryComparisonExcelUrl;
            excelUrl = excelUrl + "?comparisonMonth=" + params.comparisonMonth + "&comparisonYear=" + params.comparisonYear+"&salaryMonth=" +params.salaryMonth +"&salaryYear=" +params.salaryYear;
            excelUrl = excelUrl + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("employmentTypeId", params.employmentTypeId)
                + buildURLFromArray("employeeName", params.employeeName)
                + buildURLFromArray("designationId", params.designationId)
                + buildURLFromArray("departmentId", params.departmentId)
                + buildURLFromArray("shiftGroupId", params.shiftGroupId)
                + buildURLFromArray("genderId", params.genderId)
                + buildURLFromArray("companyId", params.companyId)
                + buildURLFromArray("officeId", params.officeId)
                + buildURLFromArray("lineManagerId", params.lineManagerId)
                + buildURLFromArray("hrManagerId", params.hrManagerId)
                + buildURLFromArray("workplaceId", params.workplaceId)
                + buildURLFromArray("status", params.status);
            // excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            // excelUrl = excelUrl + "&perPage=" + params.perPage;
            // excelUrl = excelUrl + "&sortKey=" + params.sortKey;
            // excelUrl = excelUrl + "&order=" + params.order;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        }
    }

    app.service('salaryReportService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', salaryReportService]);
})();
(function () {

    'use strict';

    function scheduledEmployeeCreateService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                             message, authService) {

        var self = this;
        self.getAll = function () {
            var defer = $q.defer();
            // console.log("get request to url : " + API.scheduledEmployeeCreateRequest.getAll);
            $http.get(API.scheduledEmployeeCreateRequest.getAll)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.requestList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.retry = function (requestId) {
            var defer = $q.defer();
            // console.log("get request to url : " + API.scheduledEmployeeCreateRequest.retry + requestId);
            $http.post(API.scheduledEmployeeCreateRequest.retry + requestId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }
    }
    app.service('scheduledEmployeeCreateService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', scheduledEmployeeCreateService]);

})();
(function () {

    'use strict';

    function shiftService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getAllShifts = function (loadFromServer) {
            var defer = $q.defer();
            $http.get(API.shift.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllShiftsForDashboard = function (loadFromServer) {
            var defer = $q.defer();
            $http.get(API.shift.getAllForDashboard)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getShiftList = function () {
            var defer = $q.defer();
            $http.get(API.shift.list)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateShiftInfo = function (data, shiftId) {
            var defer = $q.defer();

            $http.post(API.shift.all + shiftId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.shiftList)
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message);
                });
            return defer.promise;
        };

        self.updateBatchShift = function (batchEmployees, shiftId) {
            var defer = $q.defer();
            $http.post(API.shift.updateBatchShift + shiftId, batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createNewShift = function (data) {
            var defer = $q.defer();
            $http.post(API.shift.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.shiftList);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getCurrentShift = function () {
            var defer = $q.defer();
            $http.get(API.shift.getCurrentShift)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shift);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

    }

    app.service('shiftService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', shiftService]);

})();

(function () {

    'use strict';

    function shiftGroupService($http, $q, $window, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllShiftGroups = function (loadFromServer) {
            var defer = $q.defer();
            // var shiftGroupList = getShiftGroupListFromLocalStorage();
            // if (loadFromServer || utilService.isEmptyArray(shiftGroupList)) {
                $http.get(API.shiftGroup.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            // setShiftGroupListInLocalStorage(data.shiftGroupList);
                            defer.resolve(data.shiftGroupList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            // } else {
            //     defer.resolve(shiftGroupList);
            // }
            return defer.promise;
        };

        self.getAllActiveShiftGroups = function (loadFromServer) {
            var defer = $q.defer();
            self.getAllShiftGroups(loadFromServer).then(function (typeList) {
                defer.resolve(typeList.filter(function (et) {
                    return et.status == 1;
                }));
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        };


        self.createShiftGroup = function (data) {
            var defer = $q.defer();
            $http.post(API.shiftGroup.create, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftGroup);
                        addNewShiftGroupInLocalStorage(data.shiftGroup);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.updateShiftGroup = function (data, id) {
            var defer = $q.defer();
            $http.post(API.shiftGroup.all + id, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shiftGroup);
                        updateShiftGroupInLocalStorage(data.shiftGroup);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.deleteShiftGroup = function (id) {
            var defer = $q.defer();
            $http.post(API.shiftGroup.delete.prefix + id + API.shiftGroup.delete.suffix, {})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                        deleteShiftGroupInLocalStorage(id);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };


        function setShiftGroupListInLocalStorage(data) {
            $window.localStorage.setItem('shiftGroupList', JSON.stringify(data));
        }

        function getShiftGroupListFromLocalStorage() {
            var d = $window.localStorage.getItem('shiftGroupList');
            return d ? JSON.parse(d) : [];
        }

        function addNewShiftGroupInLocalStorage(shiftGroup) {
            var shiftGroups = getShiftGroupListFromLocalStorage();
            if (utilService.isEmptyArray(shiftGroups)) shiftGroups = [];
            shiftGroups.push(shiftGroup);
            setShiftGroupListInLocalStorage(shiftGroups);
        }

        function updateShiftGroupInLocalStorage(shiftGroup) {
            var shiftGroups = getShiftGroupListFromLocalStorage();
            if (utilService.isEmptyArray(shiftGroups)) {
                addNewShiftGroupInLocalStorage(shiftGroup);
            } else {
                for (var i = 0; i < shiftGroups.length; i++) {
                    if (shiftGroups[i].id === shiftGroup.id) {
                        shiftGroups[i] = shiftGroup;
                    }
                }
                setShiftGroupListInLocalStorage(shiftGroups);
            }
        }

        function deleteShiftGroupInLocalStorage(id) {
            var shiftGroups = getShiftGroupListFromLocalStorage();
            if (utilService.isEmptyArray(shiftGroups)) return;
            for (var i = 0; i < shiftGroups.length; i++) {
                if (shiftGroups[i].id === id) {
                    shiftGroups.splice(i,1);
                    setShiftGroupListInLocalStorage(shiftGroups);
                    return ;
                }
            }
        }

        self.getAllDynamicShiftGroups = function () {
            var defer = $q.defer();
            $http.get(API.dynamicShiftGroup.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.dynamicShiftGroups);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createDynamicShiftGroups = function (data) {
            var defer = $q.defer();
            $http.post(API.dynamicShiftGroup.create,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.dynamicShiftGroups);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.updateDynamicShiftGroups = function (shiftGroupId,data) {
            var defer = $q.defer();
            $http.post(API.dynamicShiftGroup.update + shiftGroupId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.dynamicShiftGroups);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }

    app.service('shiftGroupService', ['$http', '$q', '$window', 'API', 'RESPONSE_CODE', 'utilService', shiftGroupService]);

})();
(function () {

    'use strict';

    function shiftnService($http, $q, $window, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllShifts = function (loadFromServer) {
            var defer = $q.defer();
            var shiftList = getShiftListFromLocalStorage();
            if (loadFromServer || utilService.isEmptyArray(shiftList)) {
                $http.get(API.shiftn.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            if (!utilService.isEmptyArray(data.shiftList)) setShiftListInLocalStorage(data.shiftList);
                            defer.resolve(data.shiftList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else {
                defer.resolve(shiftList);
            }
            return defer.promise;
        };

        self.getAllActiveShifts = function (loadFromServer) {
            var defer = $q.defer();
            self.getAllShifts(loadFromServer).then(function (typeList) {
                defer.resolve(typeList.filter(function (et) {
                    return et.status == 1;
                }));
            }, function (error) {
                defer.reject(error);
            });
            return defer.promise;
        };


        self.createShift = function (data) {
            var defer = $q.defer();
            $http.post(API.shiftn.create, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shift);
                        addNewShiftInLocalStorage(data.shift);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.updateShift = function (data, id) {
            var defer = $q.defer();
            $http.post(API.shiftn.all + id, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.shift);
                        updateShiftInLocalStorage(data.shift);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.deleteShift = function (id) {
            var defer = $q.defer();
            $http.post(API.shiftn.delete.prefix + id + API.shiftn.delete.suffix, {})
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                        deleteShiftInLocalStorage(id);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };


        function setShiftListInLocalStorage(data) {
            $window.localStorage.setItem('shiftList', JSON.stringify(data));
        }

        function getShiftListFromLocalStorage() {
            var d = $window.localStorage.getItem('shiftList');
            return d && d !== undefined ? JSON.parse(d) : [];
        }

        function addNewShiftInLocalStorage(shift) {
            var shifts = getShiftListFromLocalStorage();
            if (utilService.isEmptyArray(shifts)) shifts = [];
            shifts.push(shift);
            setShiftListInLocalStorage(shifts);
        }

        function updateShiftInLocalStorage(shift) {
            var shifts = getShiftListFromLocalStorage();
            if (utilService.isEmptyArray(shifts)) {
                addNewShiftInLocalStorage(shift);
            } else {
                for (var i = 0; i < shifts.length; i++) {
                    if (shifts[i].id === shift.id) {
                        shifts[i] = shift;
                    }
                }
                setShiftListInLocalStorage(shifts);
            }
        }

        function deleteShiftInLocalStorage(id) {
            var shifts = getShiftListFromLocalStorage();
            if (utilService.isEmptyArray(shifts)) return;
            for (var i = 0; i < shifts.length; i++) {
                if (shifts[i].id === id) {
                    shifts = shifts.splice(i,1);
                    setShiftListInLocalStorage(shifts);
                    return ;
                }
            }
        }

    }

    app.service('shiftnService', ['$http', '$q', '$window', 'API', 'RESPONSE_CODE', 'utilService', shiftnService]);

})();
(function () {
    'use strict';
    function siteManagementService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {

        var self = this;

        self.getAllSitesInformation = function (params) {
            var defer = $q.defer();
            var url = API.siteManagement.allSiteData;
            $http.get(url, {
                params: {
                    page: params.pageNumber,
                    count: params.perPage,
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };
        self.getAllSites = function () {
            var defer = $q.defer();
            var url = API.siteManagement.allSiteData;
            $http.get(url, {
                params: {
                    page: 0,
                    count: 0
                }
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getAllPieChartData = function (params) {
            var defer = $q.defer();
            var url = API.siteManagement.getDashboardSummary;
            $http.get(url,{params: {siteIds : params}}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getBarchartDataForASite = function (params) {
            var defer = $q.defer();
            var url = API.siteManagement.getBarchartDataOfASite;
            $http.get(url,{params: {page:params.page,count: params.count,siteId:params.siteId}}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getMostlyPresentEmployeesData = function (params) {
            var defer = $q.defer();
            var url = API.siteManagement.getMostlyPresentEmployees;
            $http.get(url,{params: {siteIds : params}}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };
        self.getMostlyOnTimeEmployeesData = function (params) {
            var defer = $q.defer();
            var url = API.siteManagement.getMostlyOnTimeEmployees;
            $http.get(url, {params: params}).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.getTopActiveSitesData = function () {
            var defer = $q.defer();
            var url = API.siteManagement.getTopActiveSites;
            $http.get(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            });

            return defer.promise;
        };

        self.createNewSite = function (data){
            var defer = $q.defer();
            $http.post(API.siteManagement.createNewSite, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };

        self.updateSite = function (data,siteId){
            var defer = $q.defer();
            $http.post(API.siteManagement.updateSite + siteId, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };

        self.deleteSite = function (siteId){
            var defer = $q.defer();
            $http.post(API.siteManagement.deleteSite + siteId)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };

        self.getDetailsOfOneSite = function (siteId) {
            var defer = $q.defer();
            $http.get(API.siteManagement.getDetailsOfOneSite + siteId)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getAvailableSiteManagers = function () {
            var defer = $q.defer();
            $http.get(API.siteManagement.getSiteManagers)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.saveSiteManagementRoles = function (data) {
            var defer = $q.defer();
            $http.post(API.siteManagement.assignRole.save, data)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;

        };
        self.deleteSiteManagementRoles = function (userId,roleType) {
            var defer = $q.defer();
            $http.post(API.siteManagement.assignRole.delete+userId+"/"+roleType)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                }).error(function (data, status, headers, config) {
                defer.reject(data);
            });
            return defer.promise;
        };

        self.addEmployeesToSite = function (employeeList,siteId){
            var defer = $q.defer();
            $http.post(API.siteManagement.addEmployeeToSite + siteId, employeeList)
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;

        };

        self.getSiteSummaryReportInfo = function (params){
            var defer = $q.defer();
            $http.get(API.siteManagement.siteSummaryReport, {params:params})
                .success(function (data, status) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data);
                    }
                });
            return defer.promise;
        }

        self.getSiteSummaryReportExcelUrl = function (params, allowAllDownload) {
            var defer = $q.defer();
            var excelUrl = API.siteManagement.siteSummaryReportExcel+"?startTimeOfDay="+params.startTimeOfDay;
            excelUrl = excelUrl + "&pageNumber=" + params.pageNumber;
            excelUrl = excelUrl + "&count=" + params.count;
            excelUrl = excelUrl + "&keyword=" + params.keyword;
            excelUrl = excelUrl + "&unpaged=" + allowAllDownload;
            excelUrl = excelUrl + '&token=' + authService.getLoggedInToken();
            return excelUrl;
        };

        self.getSiteSummaryReportPdf = function (params, allowAllDownload) {
            var defer = $q.defer();
            var pdfUrl = API.siteManagement.siteSummaryReportPdf+"?startTimeOfDay="+params.startTimeOfDay;
                pdfUrl = pdfUrl + "&pageNumber=" + params.pageNumber;
                pdfUrl = pdfUrl + "&count=" + params.count;
                pdfUrl = pdfUrl + "&keyword=" + params.keyword;
                pdfUrl = pdfUrl + "&unpaged=" + allowAllDownload;
                pdfUrl = pdfUrl + '&token=' + authService.getLoggedInToken();
            return pdfUrl;
        };



    }

    app.service('siteManagementService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', siteManagementService]);
})();
(function () {

    'use strict';

    function smsService($http, $q, $window, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getApplicableEmployeeList = function () {
            var defer = $q.defer();
            $http.get(API.sms.getEmployee)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employeeSmsListUnitList);
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.sendSms = function (data) {
            var defer = $q.defer();
            $http.post(API.sms.send,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

    }

    app.service('smsService', ['$http', '$q', '$window', 'API', 'RESPONSE_CODE', 'utilService', smsService]);

})();
(function() {
    'use strict';

    function specialDayService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE) {
        var self = this;

        // Get all special days
        self.getAllSpecialDays = function() {
            var defer = $q.defer();
            $http.get(API.specialDay.all)
                .then(function(response) {
                    if (response.status === RESPONSE_CODE.success) {
                        var specialDays = response.data.specialDayList.map(function(specialDay) {
                            specialDay.startDate = new Date(specialDay.startDate);
                            specialDay.endDate = new Date(specialDay.endDate);
                            return specialDay;
                        });
                        defer.resolve(specialDays);
                    } else {
                        defer.reject(response.data.message);
                    }
                })
                .catch(function(error) {
                    defer.reject(error.data && error.data.message ? error.data.message : "Error fetching special days");
                });

            return defer.promise;
        };
        // Create a new special day
        self.createSpecialDay = function(data) {
            var defer = $q.defer();
            $http.post(API.specialDay.create, data)
                .then(function(response) {
                    if (response.status === RESPONSE_CODE.success) {
                        defer.resolve(response.data);
                    } else {
                        defer.reject(response.data.message);
                    }
                })
                .catch(function(error) {
                    defer.reject(error.data && error.data.message ? error.data.message : "Error creating special day");
                });

            return defer.promise;
        };

        // Update an existing special day
        self.updateSpecialDay = function(specialDayId, data) {
            var defer = $q.defer();
            $http.post(API.specialDay.update + specialDayId, data) // Use post or PATCH based on your backend implementation
                .then(function(response) {
                    if (response.status === RESPONSE_CODE.success) {
                        defer.resolve(response.data);
                    } else {
                        defer.reject(response.data.message);
                    }
                })
                .catch(function(error) {
                    defer.reject(error.data && error.data.message ? error.data.message : "Error updating special day");
                });

            return defer.promise;
        };

        // Delete a special day
        self.deleteSpecialDay = function(specialDayId) {
            var defer = $q.defer();
            $http.delete(API.specialDay.delete + specialDayId)
                .then(function(response) {
                    if (response.status === RESPONSE_CODE.success) {
                        defer.resolve(response.data.message);
                    } else {
                        defer.reject(response.data.message);
                    }
                })
                .catch(function(error) {
                    defer.reject(error.data && error.data.message ? error.data.message : "Error deleting special day");
                });

            return defer.promise;
        };
    }

    // Register the service with the app
    app.service('specialDayService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', specialDayService]);

})();
(function () {

    'use strict';

    function subDepartmentService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllSubDepartments = function (includeInactive) {
            var defer = $q.defer();
            var url = API.subDepartment.all + "?includeInactive=" + (includeInactive == true ? includeInactive : false);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.subDepartmentList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createSubDepartment = function (data) {
            var defer = $q.defer();
            $http.post(API.subDepartment.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.subDepartment);
                    } else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateSubDepartmentInfo = function (data, subDepartmentId) {
            var defer = $q.defer();
            $http.post(API.subDepartment.list + subDepartmentId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.subDepartment);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


    }

    app.service('subDepartmentService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', subDepartmentService]);

})();
(function () {
  'use strict';
  function subscriptionGateService($http, $q, API, $rootScope) {


    var DAY_MS = 24 * 60 * 60 * 1000;
    var BEARER = '';


    var vm = {
      billing_duedate: null,
      billing_duedate_ms: null,
      billing_url: null,
      last_payment_ms: null,
      is_billing_auto_inactive_enabled: null,
      current_time_ms: null
    };


    var service = {
      refresh: refresh,
      getBillingUrl: getBillingUrl,
      getLastPaymentDate: getLastPaymentDate,
       getBillingDueDate: getBillingDueDate,//
      status: {}
    };


    function parseToMillis(val) {
      if (val == null) return null;
      if (typeof val === 'number' && isFinite(val)) return val;
      if (typeof val !== 'string') return null;

      var asUtc = Date.parse(val.replace(' ', 'T') + 'Z');
      if (!isNaN(asUtc)) return asUtc;
      var asLocal = Date.parse(val.replace(' ', 'T'));
      return isNaN(asLocal) ? null : asLocal;
    }

    function fetchBillingInfo() {
      return $http.get(API.office.getBillingInfo, { headers: { Authorization: 'Bearer ' + BEARER } })
        .then(function (resp) {
          var data = (resp && resp.data) || {};
          var deu = data.billingDeuDate || data.billingDueDate || null;
          vm.billing_duedate = deu || null;
          vm.billing_duedate_ms = data.billingDeuDateMillis || null;
          vm.billing_url = data.billingInvoiceUrl || null;
          var last = data.lastBillPaymentDate || data.lastPaymentDate || null;
          vm.last_payment_ms = parseToMillis(last);
          vm.is_billing_auto_inactive_enabled = data.isBillingAutoInactiveEnabled || null;
          vm.current_time_ms = data.currentTimeInMillis || null;
          $rootScope.lastBillPaymentDate = vm.last_payment_ms;
          return vm.billing_duedate_ms;
        })


        .catch(function () {
          vm.billing_duedate = null;
          vm.billing_duedate_ms = null;
          vm.billing_url = null;
          vm.last_payment_ms = null;
          vm.is_billing_auto_inactive_enabled = null;
          vm.current_time_ms = null;
          $rootScope.lastBillPaymentDate = null;
          return null;
        });
    }


    function getBillingUrl() { return vm.billing_url || null; }
    function getLastPaymentDate() { return vm.last_payment_ms || null; }
    function getBillingDueDate() {return vm.billing_duedate_ms;}
    function computeStatus(dueMs) {
      var now = vm.current_time_ms;
      var status = { warn7Days:false, warn3Days:false, isExpired:false, isPastGracePeriodDays:false, isExpiredPriority:false, daysBeforeExpiry:null };
      if (dueMs == null) return status;
      var diff = dueMs - now;

      // Check if auto-inactive is disabled (0) for priority expired logic
      var isAutoInactiveEnabled = vm.is_billing_auto_inactive_enabled === 1;

      if (diff < -8 * DAY_MS) {
        if (isAutoInactiveEnabled) {
          status.isPastGracePeriodDays = true;
        } else {
          status.isExpiredPriority = true;
        }
        status.daysBeforeExpiry = 0;
      } else if (diff < 0) {
        if (isAutoInactiveEnabled) {
          status.isExpired = true;
        } else {
          status.isExpiredPriority = true;
        }
        status.daysBeforeExpiry = 0;
      } else if (diff < 3 * DAY_MS) {
        status.warn3Days = true;
        status.daysBeforeExpiry = Math.ceil(diff / DAY_MS);
      } else if (diff < 7 * DAY_MS) {
        status.warn7Days = true;
        status.daysBeforeExpiry = Math.ceil(diff / DAY_MS);
      } else {
        //status.isExpiredPriority = true;
      }
      return status;
    }
    function refresh() {
      var d = $q.defer();
      fetchBillingInfo().then(function (dueMs) {
        var status = computeStatus(dueMs);
        if (window.angular && angular.copy) {
          angular.copy(status, service.status);
        } else {
          service.status = status;
        }
        $rootScope.subscriptionStatus = status;
        d.resolve(status);
      }, function () {
        var fallback = { warn7Days:false, warn3Days:false, isExpired:false, isPastGracePeriodDays:false, isExpiredPriority:false, daysBeforeExpiry:null };
        if (window.angular && angular.copy) {
          angular.copy(fallback, service.status);
        } else {
          service.status = fallback;
        }
        $rootScope.subscriptionStatus = fallback;
        d.resolve(fallback);
      });
      return d.promise;
    }
    return service;
  }
  app.service('subscriptionGateService', [
    '$http', '$q', 'API', '$rootScope',
    subscriptionGateService
  ]);
})();

(function () {

    'use strict';

    function subsidiaryService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getAllSubsidiaries = function () {
            var defer = $q.defer();
            var url = API.subsidiary.all;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.subsidiaries);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createSubsidiary = function (data) {
            var defer = $q.defer();
            $http.post(API.subsidiary.create, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        // API returns data directly at root level, not nested under 'subsidiary'
                        // Response: { message: "Success", name: "test", id: 12, externalSyncId: "2222", ... }
                        defer.resolve(responseData);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateSubsidiaryInfo = function (data, subsidiaryId) {
            var defer = $q.defer();
            $http.post(API.subsidiary.update + '/' + subsidiaryId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        // API returns data directly at root level
                        defer.resolve(responseData);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

    }

    app.service('subsidiaryService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', subsidiaryService]);

})();


(function () {

    'use strict';

    function taskService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;


        self.getTask = function (taskId) {
            var defer = $q.defer();
            $http.get(API.task.all + taskId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.task);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllTasksWithFilters = function (employeeId, projectWorkId) {
            var defer = $q.defer();
            var url = API.task.all + 'allTasks/';
            if (employeeId != null) url = url + '?employeeId=' + employeeId;
            if(projectWorkId != null) url = url + '?projectWorkId=' + projectWorkId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.taskList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getTimeSheetReportOfAnEmployee = function (data) {
            var defer = $q.defer();
            var baseUrl = API.task.all + 'timeSheet';
            baseUrl = baseUrl + '?employeeId=' + data.employeeId;
            if (data.projectWorkId != null) baseUrl = baseUrl + '&projectWorkId=' + data.projectWorkId;
            if (data.taskId != null) baseUrl = baseUrl + '&taskId=' + data.taskId;
            if (data.perPage != null) baseUrl = baseUrl + '&perPage=' + data.perPage;
            if (data.pageNo != null) baseUrl = baseUrl + '&pageNo=' + data.pageNo;
            if (data.startDate != null) baseUrl = baseUrl + '&startDate=' + data.startDate;
            if (data.endDate != null) baseUrl = baseUrl + '&endDate=' + data.endDate;
            $http.get(baseUrl)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getTimeSheetReportOfADay = function(data) {
            var defer = $q.defer();
            var baseUrl = API.task.all + 'perDayTimeSheet';
            // console.log(data);
            baseUrl = baseUrl + '?date=' + data.date;
            if (data.projectWorkId != null) baseUrl = baseUrl + buildURLFromArray('projectWorkId', data.projectWorkId);
            if (data.taskId != null) baseUrl = baseUrl + buildURLFromArray('taskId', data.taskId);
            if (data.employeeId != null) baseUrl = baseUrl + buildURLFromArray('employeeId', data.employeeId);
            if (data.teamId != null) baseUrl = baseUrl + buildURLFromArray('teamId', data.teamId);
            if (data.perPage != null) baseUrl = baseUrl + '&perPage=' + data.perPage;
            if (data.pageNo != null) baseUrl = baseUrl + '&pageNo=' + data.pageNo;
            // console.log(baseUrl);
            $http.get(baseUrl)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getProjectDedicationReportOfAnEmployee = function(employeeId, startTime, endTime) {
            var defer = $q.defer();
            var baseUrl = API.task.all + 'projectDedication/' + employeeId + '?startTime=' + startTime + '&endTime=' + endTime;
            $http.get(baseUrl)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.projectDedicationReportList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getExcelUrlForProjectDedication = function (employeeId, startTime, endTime) {
            return API.task.all + 'projectDedicationExcel/'
                                + employeeId
                                + '?startTime='
                                + startTime
                                + '&endTime='
                                + endTime
                                + '&token='
                                + authService.getLoggedInToken();
        }

        self.timeSheetEntry = function (data) {
            var defer = $q.defer();

            $http.post(API.task.all + 'timeSheet', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.getAllTasks = function (loadFromServer, data) {
            var defer = $q.defer();
            var taskList = getTasksFromLocalStorage();
            var url = API.task.all;
            url+='?startDate=' + data.startDate;
            url+='&endDate=' + data.endDate;
            if (data.perPage != null) url += '&perPage=' + data.perPage;
            if (data.pageNo != null) url += '&pageNo=' + data.pageNo;
            if (data.projectWorkId != null) url += '&projectWorkId=' + data.projectWorkId;
            if (data.employeeId != null) url += '&employeeId=' + data.employeeId;
            if (data.status != null) url += '&status=' + data.status;
            if (loadFromServer || utilService.isEmptyArray(taskList)) {
                $http.get(url)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            setTasksInLocalStorage(data.taskList);
                            defer.resolve(data);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else {
                defer.resolve(taskList);
            }
            return defer.promise;
        };

        self.createTask = function (data) {
            var defer = $q.defer();

            $http.post(API.task.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        addNewTaskInLocalStorage(responseData.task);
                        defer.resolve(getTasksFromLocalStorage());
                    } else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.removeEmployeeFromTask = function (taskId, employeeId) {
            var defer = $q.defer();
            $http.post(API.task.all + taskId + '/removeEmployee/' + employeeId)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.deleteTask = function (task) {
            var defer = $q.defer();
            $http.post(API.task.all + 'delete/' + task.id)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateTaskInLocalStorage(task);
                        defer.resolve(getTasksFromLocalStorage());
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.updateTaskInfo = function (data, task) {
            var defer = $q.defer();
            $http.post(API.task.all + task.id + '/update', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateTaskInLocalStorage(task);
                        defer.resolve();
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.addEmployeesToTask = function (data, taskId) {
            var defer = $q.defer();
            $http.post(API.task.all + taskId + '/add-employee', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateTaskInLocalStorage(responseData.task);
                        defer.resolve(responseData.task);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.updateTaskStatus = function (taskId, status) {
            var defer = $q.defer();
            var data = {
                'status' : status
            }
            $http.post(API.task.all + taskId + '/status', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        function setTasksInLocalStorage(data) {
            $window.localStorage.setItem('tasks', JSON.stringify(data));
        }

        function getTasksFromLocalStorage() {
            var d = $window.localStorage.getItem('tasks');
            return d ? JSON.parse(d) : [];
        }

        function addNewTaskInLocalStorage(task) {
            var projs = getTasksFromLocalStorage();
            if (utilService.isEmptyArray(projs)) projs = [];
            projs.push(task);
            setTasksInLocalStorage(projs);
        }

        function updateTaskInLocalStorage(task) {
            var projs = getTasksFromLocalStorage();
            if (utilService.isEmptyArray(projs)) {
                if(task.status != -1){
                    addNewTaskInLocalStorage(task);
                }
            } else {
                for (var i = 0; i < projs.length; i++) {
                    if (projs[i].id === task.id) {
                        if(task.status === -1){
                            projs.splice(i,1);
                        } else{
                            projs[i] = task;
                        }
                    }
                }
                setTasksInLocalStorage(projs);
            }
        }

        self.getExcelUrlForPerDayTimeSheetReport = function(data) {
            var baseUrl = API.task.all + 'perDayTimeSheetExcel';
            if (data.perPage != null) baseUrl = baseUrl + '?perPage=' + data.perPage;
            if (data.pageNo != null) baseUrl = baseUrl + '&pageNo=' + data.pageNo;
            if (data.date != null) baseUrl = baseUrl + '&date=' + data.date;
            if (data.projectWorkId != null) baseUrl = baseUrl + buildURLFromArray('projectWorkId', data.projectWorkId);
            if (data.taskId != null) baseUrl = baseUrl + buildURLFromArray('taskId', data.taskId);
            if (data.employeeId != null) baseUrl = baseUrl + buildURLFromArray('employeeId', data.employeeId);
            if (data.teamId != null) baseUrl = baseUrl + buildURLFromArray('teamId', data.teamId);
            baseUrl = baseUrl + '&token=' + authService.getLoggedInToken();
            return baseUrl;
        }

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }
    }


    app.service('taskService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', taskService]);

})();
(function () {

    'use strict';

    function teamService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;

        self.getTeam = function (TeamId) {
            var defer = $q.defer();
            $http.get(API.team.all + TeamId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        setTeamsInLocalStorage(data.team);
                        defer.resolve(data.team);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllTeams = function (loadFromServer) {
            var defer = $q.defer();
            var teamList = getTeamsFromLocalStorage();
            if (loadFromServer || utilService.isEmptyArray(teamList)) {
                $http.get(API.team.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            setTeamsInLocalStorage(data.teamList);
                            defer.resolve(data.teamList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else {
                defer.resolve(teamList);
            }
            return defer.promise;
        };

        self.createTeam = function (data) {
            var defer = $q.defer();

            $http.post(API.team.all, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        addNewTeamInLocalStorage(responseData.team);
                        defer.resolve(getTeamsFromLocalStorage());
                    } else {
                        defer.reject();
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message);
                    }
                });
            return defer.promise;
        };

        self.updateTeamInfo = function (data, TeamId) {
            var defer = $q.defer();
            $http.post(API.team.all + TeamId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateTeamInLocalStorage(data);
                        defer.resolve(responseData.team);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.addEmployeesToTeam = function(data, teamId){
            var defer = $q.defer();
            $http.post(API.team.all + teamId + '/add-employee', data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateTeamInLocalStorage(responseData.team);
                        defer.resolve(responseData.team);
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.removeEmployeeFromTeam = function (TeamId, employeeId) {
            var defer = $q.defer();
            $http.post(API.team.all + TeamId + '/removeEmployee/' + employeeId)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.deleteTeam = function (team) {
            var defer = $q.defer();
            $http.post(API.team.all + 'delete/' + team.id)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        team.status = -1;
                        updateTeamInLocalStorage(team);
                        defer.resolve(getTeamsFromLocalStorage());
                    } else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };



        function setTeamsInLocalStorage(data) {
            $window.localStorage.setItem('teams', JSON.stringify(data));
        }

        function getTeamsFromLocalStorage() {
            var d = $window.localStorage.getItem('teams');
            return d ? JSON.parse(d) : [];
        }

        function addNewTeamInLocalStorage(Team) {
            var projs = getTeamsFromLocalStorage();
            if (utilService.isEmptyArray(projs)) projs = [];
            projs.push(Team);
            setTeamsInLocalStorage(projs);
        }

        function updateTeamInLocalStorage(Team) {
            var projs = getTeamsFromLocalStorage();
            if (utilService.isEmptyArray(projs)) {
                if(Team.status !== -1){
                    addNewTeamInLocalStorage(Team);
                }
            } else {
                for (var i = 0; i < projs.length; i++) {
                    if (projs[i].id === Team.id) {
                        if(Team.status === -1){
                            projs.splice(i,1);
                        } else{
                            projs[i] = Team;
                        }
                    }
                }
                setTeamsInLocalStorage(projs);
            }
        }

    }

    app.service('teamService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE', 'utilService', teamService]);

})();
(function () {

  'use strict';
  function versionService($window, $http, $q, API, RESPONSE_CODE) {
    var self = this;
    self.getVersions = function () {
      var defer = $q.defer();

      var cachedVersions = JSON.parse($window.localStorage.getItem('versionList')) || {};

      if (!cachedVersions || !cachedVersions.length) {

        $http.get(API.versions.list)
          .success(function (data, status, headers, config) {
            if (status === RESPONSE_CODE.success) {
              $window.localStorage.setItem('versionList',JSON.stringify(data.versions));
              defer.resolve(data.versions);
            } else {
              defer.reject(data.message);
            }
          })
          .error(function (data, status, headers, config) {
            defer.reject(data.message ? data.message : "");
          });
      } else {
        defer.resolve(cachedVersions);
      }

      return defer.promise;
    };
  }

  app.service('versionService', ['$window', '$http', '$q', 'API', 'RESPONSE_CODE', versionService]);

})();

(function(){

    'use strict';

    function visitHistoryService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllCheckOut = function(searchParams) {
            var defer = $q.defer();

            var params = {
                officeId      : searchParams.officeId == null || searchParams.officeId.length == 0 ? [] : searchParams.officeId,
                count       : 5,
                page    : searchParams.selectedPage,
                selectAll     : searchParams.selectAll,
                // from          : searchParams.from,
                // to            : searchParams.to,
                keyword:searchParams.searchKeyword,
                visitorCategoryId:searchParams.selectedVisitorCategoriesId,
                visitorName:searchParams.searchKeyVisitor==""||searchParams.searchKeyVisitor==null?null:searchParams.searchKeyVisitor,
                mobilePunchStatus : searchParams.mobilePunchStatus == null || searchParams.mobilePunchStatus.length == 0 ? [] : searchParams.mobilePunchStatus,
            };
            $http.get(API.visitHistory.allCheckOut,{
                params:params
            })
            .success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                }
                else {
                    defer.reject(data.message);
                }
            })
            .error(function (data, status, headers, config) {
                defer.reject(data.message ? data.message : "");
            });

            return defer.promise;
        };
        self.getCheckOutInfo = function(id) {
            var defer = $q.defer();
            $http.get(API.visitHistory.checkOutInfo+id)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        console.log(data)
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.checkInVisitor = function (data) {
            var defer = $q.defer();
            var url = API.visitHistory.checkIn;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };
        self.checkOutVisit = function (data) {
            var defer = $q.defer();

            $http.post(API.visitHistory.checkOutVisitor+data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.createAppointmentAndCheckInVisitor = function (data) {
            var defer = $q.defer();
            var url = API.visitHistory.createAppointmentAndCheckIn;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

    }

    app.service('visitHistoryService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', visitHistoryService]);

})();
(function(){

    'use strict';

    function visitPurposeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllVisitPurpose = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.visitPurpose.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.visitPurposeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.createVisitPurpose = function (data) {
            var defer = $q.defer();

            $http.post(API.visitPurpose.all,data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.visitPurposeList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.deleteVisitPurpose = function (visitPurposeId) {
            var defer = $q.defer();

            $http.post(API.visitPurpose.delete + visitPurposeId)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.visitPurposeList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.updateVisitPurpose = function (visitPurposeId, data) {
            var defer = $q.defer();

            $http.post(API.visitPurpose.update + visitPurposeId, data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.visitPurposeList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

    }

    app.service('visitPurposeService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', visitPurposeService]);

})();
(function(){

    'use strict';

    function visitorAccessAreaService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllAccessAreas = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.visitorAccessArea.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.accessAreas);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


    }

    app.service('visitorAccessAreaService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', visitorAccessAreaService]);

})();
(function(){

    'use strict';

    function visitorCardService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, authService){

        var self = this;

        self.getAllCards = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.visitorCard.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.cards);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createVisitorCard = function (data) {
            var defer = $q.defer();
            var url = API.visitorCard.create;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.createVisitorCardBatch = function (data) {
            var defer = $q.defer();
            var url = API.visitorCard.batch;
            var formData = new FormData();
            formData.append("file", data);
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData
            }).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.updateVisitorCard = function (data) {
            var defer = $q.defer();
            var url = API.visitorCard.edit;

            $http.post(url, data).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.downloadVisitorCardSample = function () {
            return API.visitorCard.downloadSample+ '?token=' + authService.getLoggedInToken();
        };

        self.deleteVisitorCard = function (cardId) {
            var defer = $q.defer();
            var url = API.visitorCard.delete + cardId;

            $http.post(url).success(function (data, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    defer.resolve(data);
                } else {
                    defer.reject(data.message);
                }
            }).error(function (data, status, headers, config) {
                defer.reject(data);
            })

            return defer.promise;
        };

        self.getAvailableCards = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.visitorCard.availableCards)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.cards);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

    }

    app.service('visitorCardService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE','authService', visitorCardService]);

})();
(function(){

    'use strict';

    function visitorCategoryService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE){

        var self = this;

        self.getAllVisitorCategories = function() {
            var defer = $q.defer();
            // console.log("get request to url : " + API.leaveCategory.all);
            $http.get(API.visitorCategory.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.visitorCategoryList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


        self.createVisitorCategory = function (data) {
            var defer = $q.defer();

            $http.post(API.visitorCategory.all,data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.visitorCategoryList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.deleteVisitorCategory = function (visitorCategoryId) {
            var defer = $q.defer();

            $http.post(API.visitorCategory.delete + visitorCategoryId)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.visitorCategoryList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

        self.updateVisitorCategory = function (visitorCategoryId, data) {
            var defer = $q.defer();

            $http.post(API.visitorCategory.update + visitorCategoryId, data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        defer.resolve(data.visitorCategoryList);
                    }else {
                        defer.reject(data.message);
                    }
                })
                .error(function(data, status, headers, config){
                    defer.reject(data.message);
                });
            return defer.promise;

        };

    }

    app.service('visitorCategoryService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', visitorCategoryService]);

})();
(function(){

    'use strict';

    function weeklyOffDaysService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, utilService) {

        var self = this;
        self.getAllWeeklyOffDayPolicies = function(loadFromServer) {
            var defer = $q.defer();
            var weeklyOffdayPolicies = getWeeklyOffdayPoliciesFromLocalStorage();
            if(loadFromServer || utilService.isEmptyArray(weeklyOffdayPolicies)) {
                // console.log("get request to url : " + API.weeklyOffDaysPolicy.all);
                $http.get(API.weeklyOffDaysPolicy.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.weeklyOffDaysPolicyList);
                            setWeeklyOffdayPoliciesInLocalStorage(data.weeklyOffDaysPolicyList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });
            } else  {
                defer.resolve(weeklyOffdayPolicies);
            }
            return defer.promise;
        };

        self.updateWeeklyPolicy = function (policyId,postData) {
            var defer = $q.defer();
            $http.post(API.weeklyOffDaysPolicy.update + policyId, postData)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        updateWeeklyOffdayPolicyInLocalStorage(responseData.weeklyOffDaysPolicy);
                        defer.resolve(getWeeklyOffdayPoliciesFromLocalStorage());
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.createWeeklyOffDaysPolicy = function (data) {
            var defer = $q.defer();

            // console.log("Post request to url : " + API.weeklyOffDaysPolicy.all+ "with data " +data);
            $http.post(API.weeklyOffDaysPolicy.all,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        addNewWeeklyOffdayPolicyInLocalStorage(data.weeklyOffDaysPolicy);
                        defer.resolve(getWeeklyOffdayPoliciesFromLocalStorage());
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };
        self.updateBatchWeeklyOffDaysPolicyPolicy = function (batchEmployees, weeklyOffDaysPolicyId) {
            var defer = $q.defer();
            $http.post(API.weeklyOffDaysPolicy.updateBatchWeeklyOffDaysPolicy + weeklyOffDaysPolicyId, batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employees);
                        console.log(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        function setWeeklyOffdayPoliciesInLocalStorage(data) {
            $window.localStorage.setItem('weeklyOffdayPolicies', JSON.stringify(data));
        }

        function getWeeklyOffdayPoliciesFromLocalStorage() {
            var d = $window.localStorage.getItem('weeklyOffdayPolicies');
            return d ? JSON.parse(d) : [];
        }

        function addNewWeeklyOffdayPolicyInLocalStorage(weeklyOffdayPolicy) {
            var weeklyOffdayPolicies = getWeeklyOffdayPoliciesFromLocalStorage();
            if (utilService.isEmptyArray(weeklyOffdayPolicies)) weeklyOffdayPolicies = [];
            weeklyOffdayPolicies.push(weeklyOffdayPolicy);
            setWeeklyOffdayPoliciesInLocalStorage(weeklyOffdayPolicies);
        }

        function updateWeeklyOffdayPolicyInLocalStorage(weeklyOffdayPolicy) {
            var weeklyOffdayPolicies = getWeeklyOffdayPoliciesFromLocalStorage();
            if (utilService.isEmptyArray(weeklyOffdayPolicies)) {
                addNewWeeklyOffdayPolicyInLocalStorage(weeklyOffdayPolicy);
            } else {
                for (var i = 0; i < weeklyOffdayPolicies.length; i++) {
                    if (weeklyOffdayPolicies[i].id === weeklyOffdayPolicy.id) {
                        weeklyOffdayPolicies[i] = weeklyOffdayPolicy;
                    }
                }
                setWeeklyOffdayPoliciesInLocalStorage(weeklyOffdayPolicies);
            }
        }
    }

    app.service('weeklyOffDaysService', ['authService','$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE','utilService', weeklyOffDaysService]);

})();
(function () {

    'use strict';

    function workplaceService(authService, $http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,utilService) {

        var self = this;

        self.getAllWorkplaces = function (loadFromServer) {
            var defer = $q.defer();
                $http.get(API.workplace.all)
                    .success(function (data, status, headers, config) {
                        if (status === RESPONSE_CODE.success) {
                            defer.resolve(data.workplaceList);
                        }
                        else {
                            defer.reject(data.message);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        defer.reject(data.message ? data.message : "");
                    });

            return defer.promise;
        };

        self.createWorkplace = function (data) {
            var defer = $q.defer();
            $http.post(API.workplace.all, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.workplace);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.updateWorkplace = function (data, id) {
            var defer = $q.defer();
            $http.post(API.workplace.all + id, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.workplace);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;

        };

        self.updateBatchWorkplace = function (batchEmployees, workplaceId) {
            var defer = $q.defer();
            $http.post(API.workplace.updateBatchWorkplace+workplaceId,batchEmployees)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };


    }

    app.service('workplaceService', ['authService', '$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE','utilService', workplaceService]);

})();
// Intercepts response errors

app.config(authInterceptorConfig);

/* @ngInject*/
function authInterceptorConfig($httpProvider) {
    $httpProvider.interceptors.push("authInterceptor");
}

app.factory("authInterceptor", authInterceptor);

/* @ngInject */
function authInterceptor($q, $injector, $location, API, $window, $rootScope, $state) {
    var inflightAuthRequest = null;

    var self = this;

    var factory = {
        // request: request,
        responseError: responseError,
    };

    self.forceLogout = function () {
        $injector.get('$http').post(API.auth.signout, {
            'deviceId':  $window.localStorage.getItem('deviceId')
        }).then(function () {
            $window.localStorage.clear();
            $state.go('login');
        }, function () {
            $window.localStorage.clear();
            $state.go('login');
        });
        $rootScope.$emit("unauthorized");
    }

    return factory;

    function responseError(response) {
        if (
            response.data.message === "Expired JWT token" &&
            response.status === 401
        ) {
            function uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                  var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                  return v.toString(16);
                });
            }
            // console.log("intercepting 401 response", response);
            var deferred = $q.defer();
            if (!inflightAuthRequest) {
                // Refresh token request
                inflightAuthRequest = $injector
                    .get("$http")
                    .post(API.auth.refresh,
                        {
                            refreshToken: $window.localStorage.getItem("refresh-token"),
                            userId: JSON.parse($window.localStorage.getItem("userInfo")).id
                        },
                        {
                            headers: {
                                "ETag": uuidv4(),
                            }
                        }
                    );
            }
            inflightAuthRequest.then(
                function (r) {
                    inflightAuthRequest = null;
                    if (!!r.data.token && !!r.data.refreshToken) {
                        // console.log("got new token!");
                        $window.localStorage.setItem("token", r.data.token);
                        $window.localStorage.setItem(
                            "refresh-token",
                            r.data.refreshToken
                        );

                        // Re-run the original request with new token
                        $injector
                            .get("$http")(response.config)
                            .then(
                                function (resp) {
                                    deferred.resolve(resp);
                                },
                                function (resp) {
                                    // Previous request still failed with new token
                                    self.forceLogout();
                                    return $q.reject(response);
                                }
                            );
                    } else {
                        // Something went wrong at the server side, redirect to login
                        self.forceLogout();
                        deferred.reject();
                    }
                },
                function (response) {
                    // Refresh token is invalid, redirect to login
                    inflightAuthRequest = null;
                    self.forceLogout();
                    deferred.reject();
                    return;
                }
            );
            return deferred.promise;
        } 

        else if(response.status === 401 || response.status === 403){
            $rootScope.$emit("unauthorized");
            return $q.reject(response);
        }

        return response || $q.when(response);
    }
}

(function(){

    'use strict';

    function dateService(stringService){

        var self = this;

        self.getDateTime = function(date){

            if(!date) return stringService.EMPTY;
            return moment(new Date(date)).format('DD MMMM YYYY');
        };

        self.getDateTimeFromNow = function(date){

            if(!date) return stringService.EMPTY;
            return moment(new Date(date)).fromNow();
        };

    }

    app.service('dateService', ['stringService', dateService]);

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .provider('FCM', firebaseServiceProvider);

    function firebaseServiceProvider() {
        var msg;
        var firebaseConfig = {
            apiKey: "AIzaSyDT9picd95vcNRCYXlXYJHK49ILDrQyxlo",
            authDomain: "tipsoi-hrm.firebaseapp.com",
            projectId: "tipsoi-hrm",
            storageBucket: "tipsoi-hrm.appspot.com",
            messagingSenderId: "643383191543",
            appId: "1:643383191543:web:927672afdc349fd8a470f2"
        };

        this.init = function () {
            // console.log("FCM Provider code: init method");
            firebase.initializeApp(firebaseConfig);
            msg = firebase.messaging();
            msg.usePublicVapidKey('BOWzjc1uz6hYPyQ7_HA9hC8PlTM7LcC16XahlOiOwpQu3kCAy_KNx6L8UpmwISSJN7BzzilIwAuYvrogE-SbKOU');
        };

        /** @ngInject */
        this.$get = function () {
            return new _factory();

            function _factory() {

                this.requestPermission = function () {
                    console.log("FCM Provider code: requestPermission method");
                    return msg.requestPermission();
                };

                this.getToken = function () {
                    console.log("FCM Provider code: getToken method");
                    return msg.getToken();
                };

                this.setOnMessage = function (callback) {
                    msg.onMessage(callback);
                };
            }
        }
    }
})();

(function(){

    'use strict';

    function httpInterceptor($window, $q, $rootScope,$injector){
        var unicodeRegex = /(?![\u00b0])[^\x00-\x7F]+/;
        function uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        }
        this.request = function(config){
            config.headers['ETag'] = uuidv4();
            var token = $window.localStorage.getItem('token');
            if (token){
                config.headers['Authorization'] = 'Bearer ' + token;
                config.headers['officeId'] = JSON.parse($window.localStorage.getItem('myOffice')).id;
                config.headers['employeeId'] = JSON.parse($window.localStorage.getItem('userInfo')).id;
                if(!!$window.localStorage.getItem('deviceId'))
                    config.headers['deviceId'] = $window.localStorage.getItem('deviceId');
            }

            var canceler = $q.defer();
            config.timeout = canceler.promise;
            if(config.data){
                var values = Object.values(config.data);
                values.forEach(function(v){
                    if(v == null || v == '') return;
                    else if (Array.isArray(v)){
                        v.forEach(function(value){
                           if(unicodeRegex.test(value)){
                               $injector.get('toastr').error('Only English inputs are allowed');
                               canceler.resolve(config);
                           }
                        });
                        return;
                    }
                    if(unicodeRegex.test(v)){
                        $injector.get('toastr').error('Only English inputs are allowed');
                        canceler.resolve(config);
                    }
                })
            }
            // var deviceId = $window.localStorage.getItem('deviceId');
            // if (deviceId){
            //     config.headers['deviceId'] = deviceId;
            // }
            return config;
        };
    }

    app.service('httpInterceptor', ['$window', '$q', '$rootScope','$injector', httpInterceptor]);
})();

(function(){

    'use strict';

    function message($rootScope, toastr){

        var self = this;

        self.success = {
            CATEGORY_ADDED: {
                title:'Category Added',
                success: true
            },
            CATEGORY_DELETED: {
                title:'Category deleted',
                success: true
            },
            FRIEND_REQUEST_SENT:{
                title:'Friend request sent',
                success: true
            },
            POST_ADDED:{
                title:'New post added',
                success: true
            },
            SETTINGS_SAVED:{
                title:'Settings saved',
                success: true
            }
        };

        self.error = {
            GENERAL:{
                title:'Something went wrong',
                success: false
            }
        };

        self.info = {
            CATEGORY_DELETE_CONFIRMATION:{
                title: 'Are you sure to Delete this category?'
            }
        };

        $rootScope.$on('toast-message', function(event, message){
            if(message.success){
                toastr.success(message.title);
            }
            else toastr.error(message.title);
        });
    }

    app.service('message', ['$rootScope', 'toastr', message]);

})();
(function () {
    "use strict";

    // function to check for invalid password and show appropriate error message to the user
    // @param pattern: the pattern to check for
    // @return: true if the password is INVALID, false if the password is VALID
    // Valid password must have at least
    //    - 1 capital letter
    //    - 1 small letter
    //    - 1 number
    //    - 1 symbol (!@#$%^&*)
    //    - No characters other than the above-mentioned
    //    - At least length of 8 characters
    //    - No more than 2 consecutive characters
    //    - No common passwords or common words in dictionary
    //    - No mail, name or id in or similar to password (substr and levenshtein distance)

    function passwordValidatorService($http) {

        var self = this;

        var commonPassword = []
        var schema = {
            length: 8,
            capital: 1,
            small: 1,
            numeric: 1,
            symbol: 1,
            consecutiveChar: 2,
        }

        $http.get('assets/blocked_pass.txt').then(function (response) {
            commonPassword = response.data.split('\n');
        }, function (error) {
            console.log(error);
        });

        self.cap = /(.*?[A-Z]){1,}/;
        self.small = /(.*?[a-z]){1,}/;
        self.numeric = /(.*?[0-9]){1,}/;
        self.symbol = /(.*?[!@#$%/&*]){1,}/;
        self.inv_symbols = /[^A-Za-z0-9!@#$%/&*]/;
        self.consecutiveChar = /.*?(.)\1{2}.*/;
        self.length = function checkLength(password) {
            return password === undefined || password === null || password.length < schema.length;
        }

        self.getStrengthInfo = function (password, empInfo) {
            var score = self.passwordScore(password, empInfo);

            if (score > 130) {
                return {text: 'Strong', class: 'text-success'};
            }
            else if (score > 110) {
                return {text: 'Good', class: 'text-info'};
            }
            else if (score > 90) {
                return {text: 'Weak', class: 'text-muted'};
            }
            else if (score > 0) {
                return {text: 'Poor', class: 'text-warning'};
            }
            else {
                return {text: 'Unacceptable', class: 'text-danger'};
            }
        }

        self.getPasswordSchemaInfo = function () { return schema; }


        self.validatePasswordFunction = function (pattern, password, empInfo) {
            if (password === undefined || password === null || password === "") {
                if (
                    pattern === "length" ||
                    pattern === "capital" ||
                    pattern === "small" ||
                    pattern === "numeric" ||
                    pattern === "symbol"
                ) {
                    return true;
                }
            }

            switch (pattern) {

                // True: does not match all the requirements
                case "all":
                    return (self.validatePasswordFunction("capital", password)
                        || self.validatePasswordFunction("small", password)
                        || self.validatePasswordFunction("numeric", password)
                        || self.validatePasswordFunction("symbol", password)
                        || self.validatePasswordFunction("length", password)
                        || self.validatePasswordFunction("invalidSymbol", password)
                        || self.validatePasswordFunction("consecutiveChar", password)
                        || self.validatePasswordFunction("commonPassword", password)
                        || self.validatePasswordFunction("user", password, empInfo)
                    );

                // True: Does not have capital letters
                case "capital":
                    return !self.cap.test(password);

                // True: Does not have small letters
                case "small":
                    return !self.small.test(password);

                // True: Does not have numbers
                case "numeric":
                    return !self.numeric.test(password);

                // True: Does not have symbols
                case "symbol":
                    return !self.symbol.test(password);

                // True: Does not have length of 8
                case "length":
                    return self.length(password)

                // True: Password has invalid symbols
                case "invalidSymbol":
                    return self.inv_symbols.test(password);

                // True: Password has consecutive more than 2 characters
                case "consecutiveChar":
                    return self.consecutiveChar.test(password);

                // True: Password is a common password or a common word
                case "commonPassword":
                    return commonPassword.includes(password);

                // True: Password contains user info
                case "user":
                    return self.check(password, empInfo);

                // Passed wrong pattern
                default:
                    throw new Error("Invalid pattern");
            }
        };

        self.seps = [' ', '_', '-', '@'];

        self.check = function (password, empInfo) {
            if (!Array.isArray(empInfo) || empInfo.length === 0 || password === null || password === undefined) return false;

            for (var i = 0; i < empInfo.length; i++) {
                if (empInfo[i] === null || empInfo[i] === undefined || empInfo[i] === "") continue;

                if (self.isSimilar(password, String(empInfo[i]))) {
                    // console.log('full string matched with ', empInfo[i], ' ', parts[k], ' with password: ', password);
                    return true;
                }

                for (var j = 0; j < self.seps.length; j++) {
                    var parts = self.process(empInfo[i], self.seps[j]);
                    for (var k = 0; k < parts.length; k++) {
                        if (self.isSimilar(password, parts[k])) {
                            // console.log('matched with ', empInfo[i], ' ', parts[k], ' with password: ', password);
                            return true;
                        }
                    }
                }
            }

            return false;
        }

        self.process = function (text, sep) {
            return String(text).toLowerCase().split(sep);
        }

        // Checks similarity with levenshtein distance
        self.isSimilar = function (s1, s2) {
            var longer = s1;
            var shorter = s2;
            if (s1.length < s2.length) {
                longer = s2;
                shorter = s1;
            }
            var longerLength = longer.length;
            if (longerLength === 0) {
                return 1.0;
            }
            var score = (longerLength - self.editDistance(longer, shorter)) / parseFloat(longerLength);
            var includeRes = (s1.length > s2.length ? s1.includes(s2) : s2.includes(s1)) && s1.length > 3 && s2.length > 3;
            return includeRes || (score > 0.8);
        }


        self.editDistance = function (s1, s2) {
            s1 = s1.toLowerCase();
            s2 = s2.toLowerCase();

            var costs = new Array();
            for (var i = 0; i <= s1.length; i++) {
                var lastValue = i;
                for (var j = 0; j <= s2.length; j++) {
                    if (i === 0) costs[j] = j; else {
                        if (j > 0) {
                            var newValue = costs[j - 1];
                            if (s1.charAt(i - 1) !== s2.charAt(j - 1)) newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                            costs[j - 1] = lastValue;
                            lastValue = newValue;
                        }
                    }
                }
                if (i > 0) costs[s2.length] = lastValue;
            }
            return costs[s2.length];
        }

        self.passwordScore = function (password, empInfo) {
            if(self.validatePasswordFunction('all', password, empInfo)) return 0;

            // R = 26 + 26 + 10 + 8 (Uppercase + Lowercase + Digits + Symbols)
            // log2(R) = 6.129283016944966
            // Entropy = L * log2(R)
            return password.length * 6.129283016944966;
        }
    }



    app.service("passwordValidatorService", ['$http', passwordValidatorService]);
})();

(function (){
    'use Strict'


    function webcamService () {
        var webcam = {};
        webcam.isTurnOn = false;
        webcam.patData = null;
        var _video = null;
        var _stream = null;
        webcam.patOpts = {x: 0, y: 0, w: 25, h: 25};
        webcam.channel = {
            videoHeight: 200,
            videoWidth: 400,
            video: null
        };
        webcam.webcamError = false;

        var getVideoData = function getVideoData(x, y, w, h) {
            var hiddenCanvas = document.createElement('canvas');
            hiddenCanvas.width = _video.width;
            hiddenCanvas.height = _video.height;
            var ctx = hiddenCanvas.getContext('2d');
            ctx.drawImage(_video, 0, 0, _video.width, _video.height);
            return ctx.getImageData(x, y, w, h);
        };

        var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
            webcam.snapshotData = imgBase64;
        };

        webcam.makeSnapshot = function() {
            if (_video) {
                var patCanvas = document.querySelector('#snapshot');
                if (!patCanvas) return;

                patCanvas.width = _video.width;
                patCanvas.height = _video.height;
                var ctxPat = patCanvas.getContext('2d');

                var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
                ctxPat.putImageData(idata, 0, 0);
                var data = patCanvas.toDataURL();
                sendSnapshotToServer(data);
                webcam.patData = idata;
                webcam.onSuccess(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
                return data;
                // webcam.turnOff();
            }
        };

        webcam.onSuccess = function () {
            _video = webcam.channel.video;
            webcam.patOpts.w = _video.width;
            webcam.patOpts.h = _video.height;
            webcam.isTurnOn = true;
        };

        webcam.onStream = function (stream) {
            activeStream = stream;
            return activeStream;
        };

        webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
            window.location.href = dataURL;
        };

        webcam.onError = function (err) {
            webcam.webcamError = err;
        };

        webcam.turnOff = function () {
            webcam.isTurnOn = false;
            if (activeStream && activeStream.getVideoTracks) {
                var checker = typeof activeStream.getVideoTracks === 'function';
                if (checker) {
                    return activeStream.getVideoTracks()[0].stop();
                }
                return false;
            }
            return false;
        };

        var service = {
            webcam: webcam
        };
        return service;
    }
    app.service('webcamService', webcamService);

})();

(function () {

    'use strict';

    function analyticsService(ANALYTICS_CONSTANT) {
        var self = this;
        // var localhostAnalyticsId = 'G-8BWV5GM2DE';
        // var analyticsId = 'G-2JMNQ44BH2';
        // if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === 'test.clients.inovacetech.com') {
        //     analyticsId = localhostAnalyticsId;
        // }
        var analyticsId = self.getAnalyticsId;
        self.sendData = function (prefixUrl, title, additionalUrl, identifier, action) {
            if (prefixUrl === ANALYTICS_CONSTANT.excelUrl) {
                title = document.title + " - Download Excel"
            } else if (prefixUrl === ANALYTICS_CONSTANT.pdfUrl) {
                title = document.title + " - Download Pdf"
            } else if (prefixUrl === ANALYTICS_CONSTANT.search) {
                title = document.title + " - Search"
            } else if (prefixUrl === ANALYTICS_CONSTANT.sort) {
                title = document.title + " - Sort"
            } else if (prefixUrl === ANALYTICS_CONSTANT.select) {
                title = document.title + " - Select"
            }
            // console.log(title)
            // console.log(window.location.href + '/' + prefixUrl + '/' + additionalUrl)
            gtag('event', "page_view", {
                'send_to': analyticsId,
                'page_title': title,
                'page_location': prefixUrl ? window.location.href + '/' + prefixUrl + '/' + additionalUrl : window.location.href,
                'event_identifier': identifier,
                'event_action': action

            });
            // gtag('set',{'user':'risalat'})

        }

        self.getAnalyticsId = function (){
            var analyticsId = ANALYTICS_CONSTANT.mainAnalyticsId;
            if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === 'test.clients.inovacetech.com') {
                analyticsId = ANALYTICS_CONSTANT.testAnalyticsId;
            }

            return analyticsId;
        }


    }

    app.service('analyticsService', ['ANALYTICS_CONSTANT', analyticsService]);

})();

(function(){

    'use strict';

    function toastrService(toastr) {

        var self = this;

        self.showSuccessToastr = function (text,header,timeOut){
            toastr.success(!text ? 'Successfully done!': text, !header ? 'Success': header, {
                autoDismiss : true,
                closeButton : true,
                timeOut: !timeOut ? 5000 : timeOut,
            });
        }

        self.showInfoToastr = function (text,header,timeOut){
            toastr.info(!text ? 'Not available yet!': text, !header ? 'Info': header, {
                autoDismiss : true,
                closeButton : true,
                timeOut: !timeOut ? 0 : timeOut,
            });
        }

        self.showErrorToastr = function (text,header,timeOut){
            toastr.error(!text ? 'Operation failed!': text, !header ? 'Failed': header, {
                autoDismiss : false,
                closeButton : true,
                timeOut: !timeOut ? 0 : timeOut,
            });
        }
        self.showPleaseWaitToastr = function (text,header,timeOut){
            toastr.info(!text ? 'Please wait for a while': text, !header ? 'Wait': header, {
                autoDismiss : false,
                closeButton : true,
                timeOut: !timeOut ? 0 : timeOut,
            });
        }
        self.clearPreviousToastr = function (){
            toastr.clear();
        }


    }
    app.service('toastrService',['toastr',toastrService]);

})();
/*
    toastrService.clearPreviousToastr();
    toastrService.showSuccessToastr
    toastrService.showErrorToastr
    toastrService.showInfoToastr
*/
(function(){

    'use strict';

    function utilService(authService, toastr, REPORT_SETTINGS) {

        var self = this;
        var rowsPerPage = 50;

        var PAYROLL_TYPE_GROSS_DRIVEN = 1;
        var PAYROLL_TYPE_BASIC_DRIVEN = 2;
        var COMPONENT_CATEGORY_ADDITIVE = 1;
        var COMPONENT_CATEGORY_DEDUCTIVE = -1;
        var COMPONENT_TYPE_BASIC = 1;
        var VALUE_DETERMINER_GROSS = 1;
        var VALUE_DETERMINER_BASIC = 2;
        var VALUE_TYPE_PERCENTAGE = 1;
        var VALUE_TYPE_FIXED_AMOUNT = 2;
        var VALUE_TYPE_VARIABLE = 3;
        var GROUP_TYPE_MASTER = 1;
        var GROUP_TYPE_ADDITIONAL = 2;

        var DEFAULT_BASIC_VALUE = 10000;
        var DEFAULT_GROSS_VALUE = 20000;

        self.setRowsPerPage = function (value) {
            rowsPerPage = Number(value);
            // console.log(rowsPerPage);
        };

        self.getPieChartLegendConfig = function (){
            return {
                position: 'right',
                marginRight: 100,
                autoMargins: false,
            };
        }

        self.getPieChartDefs = function (){
            return {
                filter: [
                    {
                        id: 'shadow',
                        width: '200%',
                        height: '200%',
                        feOffset: {
                            result: 'offOut',
                            in: 'SourceAlpha',
                            dx: 0,
                            dy: 0
                        },
                        feGaussianBlur: {
                            result: 'blurOut',
                            in: 'offOut',
                            stdDeviation: 5
                        },
                        feBlend: {
                            in: 'SourceGraphic',
                            in2: 'blurOut',
                            mode: 'normal'
                        }
                    }
                ]
            };
        }

        self.getPieChartResponsiveProperty = function (){
            return {
                enabled: true,
                rules: [
                    // at 900px wide, we hide legend
                    {
                        // maxWidth: 900,
                        overrides: {
                            legend: {
                                enabled: false
                            }
                        }
                    },

                    // at 200 px we hide value axis labels altogether
                    // {
                    //     maxWidth: 200,
                    //     overrides: {
                    //         valueAxes: {
                    //             labelsEnabled: false
                    //         },
                    //         marginTop: 30,
                    //         marginBottom: 30,
                    //         marginLeft: 30,
                    //         marginRight: 30
                    //     }
                    // }
                ]
            };
        }

        self.getRowsPerPage = function () {
            return rowsPerPage;
        };

        var daysOfWeek = {
            0: "Sunday",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday"
        };

        self.getDayName = function (day){
            if(day == 1) return 'Mon';
            if(day == 2) return 'Tue';
            if(day == 3) return 'Wed';
            if(day == 4) return 'Thu';
            if(day == 5) return 'Fri';
            if(day == 6) return 'Sat';
            if(day == 0) return 'Sun';
        };

        self.getMonthName = function (month) {
            if(month == 1) return 'January';
            if(month == 2) return 'February';
            if(month == 3) return 'March';
            if(month == 4) return 'April';
            if(month == 5) return 'May';
            if(month == 6) return 'June';
            if(month == 7) return 'July';
            if(month == 8) return 'August';
            if(month == 9) return 'September';
            if(month == 10) return 'October';
            if(month == 11) return 'November';
            if(month == 12) return 'December';
        };



        self.getMonthLength = function (month) {
            if(month == 1 || month == 3 || month == 5  || month == 7 || month == 8 || month == 10 || month == 12 ) return 31;
            if(month == 2) {
                if(moment().isLeapYear()) return 29;
                return 28;
            }
            return 30;
        };

        self.getAllDatesOfAMonth = function (month, year) {
            var result = {};
            result.monthNumber = month;
            result.monthName = self.getMonthName(month);
            result.dates = [];
            result.days = [];
            var length = self.getMonthLength(month);
            var firstDay = moment(new Date(year, month-1, 1)).day();
            for ( var i = 1; i <= length; i++){
                result.dates.push(i);
                result.days.push(firstDay % 7);
                firstDay++;
            }
            return result;
        };

        self.checkIfValidDateRange = function (startDate, endDate) {
            return dayjs(Number(endDate)).isSameOrAfter(dayjs(Number(startDate)));
        };

        self.checkIfFutureDate = function (targetDate){
            return moment(targetDate).isAfter(moment().format("YYYY-MM-DD"));
        };

        self.checkSameDate = function (fromDate, toDate){
            return !fromDate.isSame(toDate, 'date');
        };

        self.checkIfDatesEmpty = function(startDate, endDate) {
            if (!startDate || !endDate)
                return true
            else
                return false;
        };

        self.isDateEmpty = function (date) {
            if(!date)
                return false;
            return true;
        };

        self.isTimeInCurrentYear = function (time) {
            return dayjs(Number(time)).year() ===  dayjs().year();
        };

        self.isDateInSameYear = function (startDate, endDate){
            return dayjs(Number(startDate)).year() === dayjs(Number(endDate)).year();
        }

        self.isDateEmpty = function (date) {
            return date === null;
        };

        self.createInputModelFromString = function (string) {
            var multiSelectInputModel = [];
            for (var i = 0; i < 7; i++) {
                if (string.charAt(i) === '1') {
                    multiSelectInputModel.push({name: daysOfWeek[i], value: i, isSelected: true})
                }
                else {
                    multiSelectInputModel.push({name: daysOfWeek[i], value: i, isSelected: false})
                }
            }
            return multiSelectInputModel;
        };

        self.getFormattedString = function (multiSelectInputModel) {
            var stringToPost = '';
            for (var i = 0; i < 7; i++) {
                multiSelectInputModel[i].isSelected === true ? stringToPost += '1' : stringToPost += '0';
            }
            return stringToPost;
        };

        self.getDateObjectFromShiftTimeString = function (s) {
            return new moment(s, ["hh:mm a"]);
        };

        self.getPaginationInfo = function (data) {
            if(data.selectedPage+1 == data.numberOfButtons.length)
                return (data.allData.length - data.showingData.length)+1 + " to " + data.allData.length;
            else {
                if(data.selectedPage == 0)
                    return  1  + " to " + data.showRows;
                else
                    return data.selectedPage * data.showRows + 1 + " to " + (data.selectedPage+1) * data.showRows;
            }
        }

        self.hasPermission = function (module) {
            if(!module) return false;
            var permittedModules = authService.getPermittedModules();
            if(!permittedModules || permittedModules.length === 0) return false;
            if(Array.isArray(module)){
                return module.every(function (i) {
                    return permittedModules.includes(i.toString());
                });
            }
            return permittedModules.includes(module.toString());
        };

        // new business logic to support multiple module codes
        self.hasAnyPermission = function (modules) {

            if (!modules || !Array.isArray(modules) || modules.length === 0) return false;
            var permittedModules = authService.getPermittedModules() || [];

            var isNotifPermission = modules.some(function (m) {
                return permittedModules.indexOf(m.toString()) !== -1;
            });

            //console.log("inside util.service.js--->hasAnyPermission---> modules--> " + modules + " isNotifPermission " + isNotifPermission);
            return modules.some(function (m) {
                return permittedModules.indexOf(m.toString()) !== -1;
            });
        }

            self.canLineManagerAssignShiftGroup = function canLineManagerAssignShiftGroup() {
            if(authService.getLoggedInUser().isAdmin || authService.getLoggedInUser().isHrManager)
                return true;
            return (authService.getLoggedInUser().isLineManager && self.hasPermission('5009'));
        }

        self.isEmptyArray = function(arr){
            return !(arr && Array.isArray(arr) && arr.length > 0);
        };

        self.invertColor = function (hex, bw) {
            if (hex.indexOf('#') === 0) {
                hex = hex.slice(1);
            }
            // convert 3-digit hex to 6-digits.
            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            if (hex.length !== 6) {
                throw new Error('Invalid HEX color.');
            }
            var r = parseInt(hex.slice(0, 2), 16),
                g = parseInt(hex.slice(2, 4), 16),
                b = parseInt(hex.slice(4, 6), 16);
            if (bw) {
                // http://stackoverflow.com/a/3943023/112731
                return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                    ? '#000000'
                    : '#FFFFFF';
            }
            // invert color components
            r = (255 - r).toString(16);
            g = (255 - g).toString(16);
            b = (255 - b).toString(16);
            // pad each with zeros and return
            return "#" + padZero(r) + padZero(g) + padZero(b);
        };

        self.getRandomColor = function (){
            return "#000000".replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);});
        };

        self.getAdjustedDifference = function (start,end) {
            var startTime = moment(start,'x');
            var endTime = moment(end,'x');
            if(start > end){
                endTime.add(1,'d');
                // console.log("Start time " + startTime.format('x'));
                // console.log("end time " + endTime.format('x'));
                return (endTime.format('x') - startTime.format('x'));
            }else {
                return endTime.format('x')-startTime.format('x');
            }
        }


        self.isValidShiftSetting = function (shiftTimes){
            var today = Number(moment().set({hour:0,minute:0,second:0,millisecond:0}).format('x'));
            var startTime = today + shiftTimes.startTime;
            var lateStartAfter = startTime + shiftTimes.lateOffsetFromStartTime;
            var endTime = startTime + shiftTimes.workHour;
            var earlyExitBefore = startTime + shiftTimes.earlyExitOffsetFromStartTime;
            var halfDayEnds = startTime + shiftTimes.firstHalfDuration;
            var breakTimeEnds = startTime + shiftTimes.firstHalfDuration+shiftTimes.breakDuration;
            // console.log('startTime is ' + startTime);
            // console.log('lateStartAfter is ' + lateStartAfter);
            // console.log('endTime is ' + endTime);
            // console.log('earlyExitBefore is ' + earlyExitBefore);
            // console.log('halfDayEnds is ' + halfDayEnds);
            // console.log('halfDayEnds is ' + halfDayEnds);
            if(lateStartAfter > endTime || lateStartAfter < startTime){
                toastr.error('Late start time has to be within start and end time');
                return false;
            }
            if(earlyExitBefore > endTime || earlyExitBefore < startTime){
                toastr.error('Early exit time has to be within start and end time');
                return false;
            }
            if(halfDayEnds > endTime || halfDayEnds < startTime){
                toastr.error('First half end time has to be within start and end time');
                return false;
            }
            if(breakTimeEnds >= endTime || breakTimeEnds < startTime){
                toastr.error('Break time has to be within start and end time');
                return false;
            }
            return true;
        }

        self.getMinimumDate = function (){
            var minDay = dayjs();
            minDay = minDay.subtract(REPORT_SETTINGS.viewMonthLimit, 'month').startOf('month');
            return minDay;
        }

        self.getDatePickerRanges = function (){
            return {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract( 1,'days'), moment().subtract( 1,'days')],
                'Last 7 days': [moment().subtract(7,'days'), moment()],
                'Last 30 days': [moment().subtract( 30,'days'), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        }

         self.getEmployeePayrollComponentsWithValue = function (officeSettings,salary){
            officeSettings.components = officeSettings.components.filter(function (data) {
                return data.group == GROUP_TYPE_MASTER;
            });

            var basicAndGrossData = getBasicAndGrossSalary(officeSettings,salary);
            var employeePayrollComponents = [];
            var payrollType = officeSettings.payrollType;
            officeSettings.components.forEach(function (data){
                var componentData = {
                    id                       : data.id,
                    name                     : data.name,
                    isBasic                  : data.isBasic,
                    officePayrollComponentId : data.id,
                    category                 : data.category,
                    type                     : data.type,
                    valueType                : data.valueType,
                    value                    : data.value,
                    status                   : 1,
                    group                    : data.group,
                    valueDeterminer          : data.valueDeterminer,
                    isEditable               : payrollType === PAYROLL_TYPE_BASIC_DRIVEN ? (data.valueType === VALUE_TYPE_FIXED_AMOUNT || data.valueType === VALUE_TYPE_VARIABLE) : (data.valueType === VALUE_TYPE_FIXED_AMOUNT || (data.valueType === VALUE_TYPE_VARIABLE && data.type !== COMPONENT_TYPE_BASIC)),
                    inclusiveToGross         : data.inclusiveToGross
                }
                if(componentData.type == COMPONENT_TYPE_BASIC ) return ;


                if(data.valueType == VALUE_TYPE_FIXED_AMOUNT) {
                    componentData.amount = data.amount ? data.amount : data.value;
                } else if(data.valueType == VALUE_TYPE_PERCENTAGE) {
                    var salaryToMultiplyWith = null;
                    if(data.valueDeterminer == VALUE_DETERMINER_BASIC)
                        salaryToMultiplyWith = basicAndGrossData.basicSalary;
                    else
                        salaryToMultiplyWith = basicAndGrossData.grossSalary;
                    componentData.amount = Number(Number((data.value / 100.0) * salaryToMultiplyWith).toFixed(2));
                }
                employeePayrollComponents.push(componentData);
            });
            basicAndGrossData.payrollComponents = employeePayrollComponents;

            return basicAndGrossData;
        }

        function getBasicAndGrossSalary (officeSettings,salary){
            if(!salary){
                return  {grossSalary : 0, basicSalary : 0}
            }
            var basicSalary = 0.0;
            var grossSalary = 0.0;
            var basicCoefficient = 1.0;
            var grossCoefficient = 1.0;
            var fixedAmount = 0.0;
            officeSettings.components.forEach( function (component){
                var valueToCalculateWith = component.value;
                if(component.type == COMPONENT_TYPE_BASIC  || !component.inclusiveToGross || component.category == COMPONENT_CATEGORY_DEDUCTIVE) return ;
                if(component.valueType == VALUE_TYPE_PERCENTAGE) {
                    if(component.category == COMPONENT_CATEGORY_ADDITIVE) {
                        if(component.valueDeterminer == VALUE_DETERMINER_GROSS) {
                            grossCoefficient = grossCoefficient + (-1 * component.value / 100.0);
                        } else if(component.valueDeterminer == VALUE_DETERMINER_BASIC) {
                            basicCoefficient = basicCoefficient + (component.value / 100.0);
                        }
                    }
                    // else if(component.type == COMPONENT_TYPE_DEDUCTIVE) {
                    //     if(component.valueDeterminer == VALUE_DETERMINER_GROSS) {
                    //         grossCoefficient = grossCoefficient + (component.value / 100.0);
                    //     } else if(component.valueDeterminer == VALUE_DETERMINER_BASIC) {
                    //         basicCoefficient = basicCoefficient + (-1 * component.value / 100.0);
                    //     }
                    // }
                } else if(component.valueType == VALUE_TYPE_FIXED_AMOUNT) {
                    if(component.category == COMPONENT_CATEGORY_ADDITIVE) {
                        fixedAmount = fixedAmount + valueToCalculateWith;
                    }
                    // else if(component.type == COMPONENT_TYPE_DEDUCTIVE) {
                    //     fixedAmount = fixedAmount + (-1 * valueToCalculateWith);
                    // }
                }
            })

            if(officeSettings.payrollType == PAYROLL_TYPE_GROSS_DRIVEN) {
                grossSalary = Math.round(salary);
                basicSalary = Number(Number((grossCoefficient * grossSalary - fixedAmount) / basicCoefficient).toFixed(2));
            } else if(officeSettings.payrollType == PAYROLL_TYPE_BASIC_DRIVEN) {
                basicSalary = Math.round(salary);
                grossSalary = Math.round(Number(((basicCoefficient * basicSalary + fixedAmount) / grossCoefficient).toFixed(2)));
            }
            return {grossSalary : grossSalary, basicSalary :  basicSalary}
        }

        self.hasRolePermission = function (userRoles,rolesThatArePermitted){
            for (var i = 0; i < userRoles.length; i++) {
                if(rolesThatArePermitted.includes(userRoles[i])){
                    return true;
                }
            }
            return false;
        }

        self.findDateRangeIndexContainingToday = function (dateRangeList) {
            if (!dateRangeList || dateRangeList.length === 0) {
                return -1;
            }

            var today = moment().startOf('day');

            for (var i = 0; i < dateRangeList.length; i++) {
                var dateRange = dateRangeList[i];
                var dates = dateRange.split(" - ");
                var startMoment = moment(dates[0], "MMM YYYY").startOf('month');
                var endMoment = moment(dates[1], "MMM YYYY").endOf('month');

                if (today.isBetween(startMoment, endMoment, null, '[]')) {
                    return i;
                }
            }

            return 0;
        }

        self.isValidEmail = function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        self.isObjectEmpty = function(obj) {
            if(!obj) return false;
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    return false;
                }
            }
            return true;
        }

    }
    app.service('utilService',['authService','toastr', 'REPORT_SETTINGS', utilService]);

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
'use strict';

(function (angular) {
  // Create all modules and define dependencies to make sure they exist
  // and are loaded in the correct order to satisfy dependency injection
  // before all nested files are concatenated by Gulp

  // Config
  angular.module('ui.carousel.config', []).value('ui.carousel.config', {
    debug: true
  });

  // Modules
  angular.module('ui.carousel.providers', []);
  angular.module('ui.carousel.controllers', []);
  angular.module('ui.carousel.directives', []);
  angular.module('ui.carousel', ['ui.carousel.config', 'ui.carousel.directives', 'ui.carousel.controllers', 'ui.carousel.providers']);
})(angular);
'use strict';

/**
 * angular-ui-carousel
 * for example:
 * length = 8, show = 4, scroll = 3, current = 0
 *          ---------
 *          |       |
 *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
 *          |       |
 *          ---------
 * rectangle is visible for users
 */
angular.module('ui.carousel.controllers').controller('CarouselController', ['$scope', '$element', '$timeout', '$q', 'Carousel', '$window', function ($scope, $element, $timeout, $q, Carousel, $window) {
  var _this = this;

  /**
   * Initial carousel
   *
   * Mirgate to angularjs 1.6
   * @see https://docs.angularjs.org/guide/migration#commit-bcd0d4
   */
  this.$onInit = function () {
    _this.initOptions();
    _this.initRanges();
    _this.setProps();
    _this.setupInfinite();
  };

  /**
   * Init option based on directive config
   */
  this.initOptions = function () {
    _this.options = angular.extend({}, Carousel.getOptions());

    // TODO customize attribute from directive
    if (_this.initialSlide !== undefined) {
      _this.options.initialSlide = _this.initialSlide;
    }
    if (_this.fade !== undefined) {
      _this.options.fade = _this.fade;
    }
    if (_this.autoplay !== undefined) {
      _this.options.autoplay = _this.autoplay;
    }
    if (_this.autoplaySpeed !== undefined) {
      _this.options.autoplaySpeed = _this.autoplaySpeed;
    }
    if (_this.cssEase !== undefined) {
      _this.options.cssEase = _this.cssEase;
    }
    if (_this.speed !== undefined) {
      _this.options.speed = _this.speed;
    }
    if (_this.infinite !== undefined) {
      _this.options.infinite = _this.infinite;
    }
    if (_this.arrows !== undefined) {
      _this.options.arrows = _this.arrows;
    }
    if (_this.dots !== undefined) {
      _this.options.dots = _this.dots;
    }
    if (_this.visiblePrev !== undefined) {
      _this.options.visiblePrev = _this.visiblePrev;
    }
    if (_this.visibleNext !== undefined) {
      _this.options.visibleNext = _this.visibleNext;
    }

    // TODO write more options for fade mode
    // In fade mode we have to setting slides-to-show and slides-to-scroll
    // to 1 slide
    if (_this.options.fade) {
      _this.options.slidesToShow = 1;
      _this.options.slidesToScroll = 1;
    } else {
      if (_this.show) {
        _this.options.slidesToShow = _this.show;
      }
      if (_this.scroll) {
        _this.options.slidesToScroll = _this.scroll;
      }
    }
  };

  /**
   * init variables, slides, ..
   */
  this.initRanges = function () {
    if (!_this.slides) {
      _this.slides = [];
    }

    _this.isCarouselReady = false;
    _this.isTrackMoving = false;
    _this.track = $element.find('.track');
    _this.width = 1; // Fake width
    _this.currentSlide = _this.options.initialSlide;
    _this.trackStyle = {};
    _this.slideStyle = {};

    _this.isVisibleDots = false;
    _this.isVisiblePrev = _this.options.visiblePrev;
    _this.isVisibleNext = _this.options.visibleNext;

    _this.isClickablePrev = false;
    _this.isClickableNext = false;

    _this.animType = null;
    _this.transformType = null;
    _this.transitionType = null;
  };

  /**
   * Init UI and carousel track
   */
  this.initUI = function () {
    _this.width = $element[0].clientWidth;

    // Update track width first
    _this.initTrack();

    // Then item style
    $timeout(function () {
      _this.updateItemStyle();
    }, 200);
  };
  var next ;
  /**
   * update common style for each carousel item
   */
  this.updateItemStyle = function () {
    _this.itemWidth = _this.width / _this.options.slidesToShow;
    _this.slideStyle = {
      'width': _this.itemWidth + 'px'
    };
      next();
  };

  /**
   * init carousel track
   * also make Carousel is Ready
   */
  this.initTrack = function () {
    var itemWidth = _this.width / _this.options.slidesToShow;
    var trackWidth = itemWidth * _this.slidesInTrack.length;

    _this.trackStyle.width = trackWidth + 'px';

    _this.slideHandler(_this.currentSlide).finally(function () {
      _this.isCarouselReady = true;

      if (!_this.options.fade) {
        _this.refreshTrackStyle();
      }

      // onInit callback
      if (_this.onInit) {
        _this.onInit();
      }
    }).catch(function () {
      // Catch err
    });
  };

  /**
   * @see https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L680
   *
   * Sync slide to place it should be
   * for example:
   * - 9 total, 3 show, 3 scroll, current 1
   *   => next index = 3 (previous index counted = 0)
   *
   * and scroll to next page:
   * - 6 total, 1 show, 1 scroll, current 0 => next index = 1
   * - 9 total, 3 show, 3 scroll, current 1 => next index = 3
   * - 9 total, 3 show, 3 scroll, current 3 => next index = 6
   * - 9 total, 3 show, 3 scroll, current 8 => next index = 3
   * - 8 total, 4 show, 3 scroll, current 1 => next index = 4
   */
  this.next = function () {
    if (!_this.isClickableNext) {
      return false;
    }

    var indexOffset = _this.getIndexOffset();
    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : indexOffset;

    _this.slideHandler(_this.currentSlide + slideOffset).catch(function () {
      // Catch err
    });
  };

  next = this.next;

  /**
   * move to previous slide
   * same calculate with next
   * @see next function
   */
  this.prev = function () {
    if (!_this.isClickablePrev) {
      return false;
    }

    var indexOffset = _this.getIndexOffset();
    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : _this.options.slidesToShow - indexOffset;

    _this.slideHandler(_this.currentSlide - slideOffset).catch(function () {
      // Catch err
    });
  };

  /**
   * Get index offset
   */
  this.getIndexOffset = function () {
    var scrollOffset = _this.slides.length % _this.options.slidesToScroll !== 0;
    var indexOffset = scrollOffset ? 0 : (_this.slides.length - _this.currentSlide) % _this.options.slidesToScroll;

    return indexOffset;
  };

  /**
   * move to page
   * @params int page
   * Page counter from 0 (start = 0)
   */
  this.movePage = function (page) {
    var target = _this.options.slidesToScroll * page;
    _this.slideHandler(target).catch(function () {
      // Catch err
    });
  };

  /**
   * hanlder carousel
   * @description move carousel to correct page
   *
   * @params int index
   */
  this.slideHandler = function (index) {
    // TODO prevent when slides not exists
    if (!_this.slides) {
      return $q.reject('Carousel not fully setup');
    }

    // TODO Prevent when track is moving
    if (_this.isTrackMoving) {
      return $q.reject('Track is moving');
    }

    var len = _this.slides.length;
    var show = _this.options.slidesToShow;

    if (len <= show) {
      _this.correctTrack();
      return $q.reject('Length of slides smaller than slides to show');
    }

    // We need target to destination
    // and a anim slide to translate track
    //
    // anim = animSlide (which we use to move)
    // target = targetSlide
    var anim = index;
    var target = null;

    if (anim < 0) {
      if (len % _this.options.slidesToScroll !== 0) {
        target = len - len % _this.options.slidesToScroll;
      } else {
        target = len + anim;
      }
    } else if (anim >= len) {
      if (len % _this.options.slidesToScroll !== 0) {
        target = 0;
      } else {
        target = anim - len;
      }
    } else {
      target = anim;
    }

    if (_this.onBeforeChange) {
      // @see https://docs.angularjs.org/guide/directive
      _this.onBeforeChange({ currentSlide: _this.currentSlide, target: target });
    }

    // Fade handler
    if (_this.options.fade) {
      _this.currentSlide = target;

      // XXX
      // afterChange method
      // fire after faded
      // Should be revised
      $timeout(function () {
        _this.autoplayTrack();

        if (_this.onAfterChange) {
          _this.onAfterChange({ currentSlide: _this.currentSlide });
        }
      }, _this.options.speed);
      return $q.when('Handler fade');
    }

    // No-fade handler
    var itemWidth = _this.width / _this.options.slidesToShow;
    var left = -1 * target * itemWidth;
    if (_this.options.infinite) {
      left = -1 * (anim + show) * itemWidth;
    }

    _this.isTrackMoving = true;
    return _this.moveTrack(left).then(function () {
      _this.isTrackMoving = false;
      _this.currentSlide = target;
      _this.autoplayTrack();

      if (target !== anim) {
        _this.correctTrack();
      }

      if (!_this.options.infinite) {
        if (_this.currentSlide === 0) {
          _this.isClickablePrev = false;
          _this.isClickableNext = true;
        } else if (_this.currentSlide === _this.slidesInTrack.length - _this.options.slidesToShow) {
          _this.isClickableNext = false;
          _this.isClickablePrev = true;
        } else {
          _this.isClickablePrev = true;
          _this.isClickableNext = true;
        }
      }

      // XXX
      // afterChange method
      // fire after 200ms wakeup and correct track
      // Should be revised
      $timeout(function () {
        if (_this.onAfterChange) {
          _this.onAfterChange({ currentSlide: _this.currentSlide });
        }
      }, 200);
    });
  };

  /**
   * moveTrack
   * move track to left position using css3 translate
   * for example left: -1000px
   */
  this.moveTrack = function (left) {
    var deferred = $q.defer();
    if (_this.options.vertical === false) {
      _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0px, 0px)';
    } else {
      _this.trackStyle[_this.animType] = 'translate3d(0px, ' + left + 'px, 0px)';
    }

    $timeout(function () {
      deferred.resolve('Track moved');
    }, _this.options.speed);

    return deferred.promise;
  };

  /**
   * correctTrack
   * @description correct track after move to animSlide we have to move track
   * to exactly its position
   */
  this.correctTrack = function () {
    if (_this.options.infinite) {
      (function () {
        var left = 0;
        if (_this.slides.length > _this.options.slidesToShow) {
          left = -1 * (_this.currentSlide + _this.options.slidesToShow) * _this.itemWidth;
        }

        // Move without anim
        _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + 0 + 'ms ' + _this.options.cssEase;

        _this.isTrackMoving = true;
        $timeout(function () {
          _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0, 0px)';

          // Revert animation
          $timeout(function () {
            _this.refreshTrackStyle();
            _this.isTrackMoving = false;
          }, 200);
        });
      })();
    }
  };

  /**
   * Refresh track style
   */
  this.refreshTrackStyle = function () {
    _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + _this.options.speed + 'ms ' + _this.options.cssEase;
  };

  /**
   * autoplay track
   * @description autoplay = true
   */
  this.autoplayTrack = function () {
    if (_this.options.autoplay) {
      if (_this.timeout) {
        $timeout.cancel(_this.timeout);
      }

      _this.timeout = $timeout(function () {
        _this.next();

        $timeout.cancel(_this.timeout);
        _this.timeout = null;
      }, _this.options.autoplaySpeed);
    }
  };

  this.getSlideStyle = function (index) {
    var style = _this.slideStyle;
    if (_this.options.fade) {
      var left = -1 * index * _this.itemWidth;
      var uniqueStyle = {
        position: 'relative',
        top: '0px',
        left: left + 'px',
        'z-index': index === _this.currentSlide ? 10 : 9,
        opacity: index === _this.currentSlide ? 1 : 0
      };

      if (index >= _this.currentSlide - 1 && index <= _this.currentSlide + 1) {
        uniqueStyle.transition = 'opacity 250ms linear';
      }

      style = angular.extend(style, uniqueStyle);
    }

    return style;
  };

  /**
   * setupInfinite
   * To make carouse infinite we need close number of slidesToShow elements to
   * previous elements and to after elements
   *
   * length = 8, show = 4, scroll = 3, current = 0
   *          ---------
   *          |       |
   *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
   *          |       |
   *          ---------
   */
  this.setupInfinite = function () {
    // Clone
    var len = _this.slides.length;
    var show = _this.options.slidesToShow;

    var tmpTrack = angular.copy(_this.slides);

    if (_this.options.infinite && _this.options.fade === false) {
      if (len > show) {
        var number = show;
        for (var i = 0; i < number; i++) {
          tmpTrack.push(angular.copy(_this.slides[i]));
        }
        for (var _i = len - 1; _i >= len - show; _i--) {
          tmpTrack.unshift(angular.copy(_this.slides[_i]));
        }
      }
    }

    _this.slidesInTrack = tmpTrack;
  };

  /**
   * get number of dosts
   *
   * @return Array
   */
  this.getDots = function () {
    if (!_this.slides) {
      return [];
    }

    var dots = Math.ceil(_this.slides.length / _this.options.slidesToScroll);

    var res = [];
    for (var i = 0; i < dots; i++) {
      res.push(i);
    }
    return res;
  };

  /**
   * set carousel property
   *
   * - animType
   * - transformType
   * - transitionType
   */
  this.setProps = function () {
    var bodyStyle = document.body.style;

    /* eslint-disable */
    if (bodyStyle.OTransform !== undefined) {
      _this.animType = 'OTransform';
      _this.transformType = '-o-transform';
      _this.transitionType = 'OTransition';
    }
    if (bodyStyle.MozTransform !== undefined) {
      _this.animType = 'MozTransform';
      _this.transformType = '-moz-transform';
      _this.transitionType = 'MozTransition';
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _this.animType = 'webkitTransform';
      _this.transformType = '-webkit-transform';
      _this.transitionType = 'webkitTransition';
    }
    if (bodyStyle.msTransform !== undefined) {
      _this.animType = 'msTransform';
      _this.transformType = '-ms-transform';
      _this.transitionType = 'msTransition';
    }
    if (bodyStyle.transform !== undefined && _this.animType !== false) {
      _this.animType = 'transform';
      _this.transformType = 'transform';
      _this.transitionType = 'transition';
    }
    /* eslint-enable */

    _this.transformsEnabled = true;
  };

  /**
   * Refresh carousel
   */
  this.refreshCarousel = function () {
    if (_this.slides && _this.slides.length && _this.slides.length > _this.options.slidesToShow) {
      _this.isVisibleDots = _this.slides && _this.slides.length && _this.slides.length < 10;
      _this.isVisiblePrev = true;
      _this.isVisibleNext = true;
      _this.isClickablePrev = true;
      _this.isClickableNext = true;
    } else {
      _this.isVisibleDots = false;
      _this.isVisiblePrev = _this.options.visiblePrev || false;
      _this.isVisibleNext = _this.options.visibleNext || false;
      _this.isClickablePrev = false;
      _this.isClickableNext = false;
    }

    // Re-init UI
    _this.initUI();
  };

  /**
   * refresh model
   */
  $scope.$watchCollection('ctrl.slides', function (slides) {
    if (!slides) {
      return;
    }

    // Init carousel
    if (_this.currentSlide > slides.length - 1) {
      _this.currentSlide = slides.length - 1;
    }

    _this.setupInfinite();
    _this.refreshCarousel();
  });

  $scope.$watch('ctrl.show', function (nVal, oVal) {
        if(nVal !== oVal) {
            _this.options.slidesToShow = nVal;

            if (_this.options.slidesToScroll > nVal) {
                _this.options.slidesToScroll = nVal;
            }

            _this.refreshCarousel();
        }
    });

  $scope.$watch('ctrl.autoplay', function (nVal, oVal) {
      _this.options.autoplay = nVal;
      if(nVal){
        _this.autoplayTrack();
      } else {
          $timeout.cancel(_this.timeout);
      }
    });

  /**
   * update when resize
   *
   * @see https://github.com/mihnsen/ui-carousel/issues/10
   * @author tarkant
   */
  // angular.element($window).on('resize', this.refreshCarousel);
  //   $scope.$on('$viewContentLoaded', function (event) {
  //     console.log("calling next from inside ui-carousel");
  //     this.next;
  //   });
  //   $window.onload(function () {
  //           console.log("calling next onload from inside ui-carousel");
  //           this.next;
  //   });

  /**
   * cleanup when done
   *
   * @see https://github.com/mihnsen/ui-carousel/issues/10
   * @author tarkant
   */
  $scope.$on('$destroy', function () {
    angular.element($window).off('resize');
  });

  // Prior to v1.5, we need to call `$onInit()` manually.
  // (Bindings will always be pre-assigned in these versions.)
  if (angular.version.major === 1 && angular.version.minor < 5) {
    this.$onInit();
  }
}]);
'use strict';

angular.module('ui.carousel.directives').directive('uiCarousel', ['$compile', '$templateCache', '$sce', function ($compile, $templateCache, $sce) {

  return { restrict: 'AE',
    bindToController: true,
    scope: {
      name: '=?',
      slides: '=',
      show: '=?slidesToShow',
      scroll: '=?slidesToScroll',
      classes: '@',
      fade: '=?',
      onChange: '=?',
      disableArrow: '=?',
      autoplay: '=',
      autoplaySpeed: '=?',
      cssEase: '=?',
      speed: '=?',
      infinite: '=?',
      arrows: '=?',
      dots: '=?',
      initialSlide: '=?',
      visibleNext: '=?',
      visiblePrev: '=?',

      // Method
      onBeforeChange: '&',
      onAfterChange: '&',
      onInit: '&'
    },
    link: function link($scope, el) {
      var template = angular.element($templateCache.get('ui-carousel/carousel.template.html'));

      // dynamic injections to override the inner layers' components
      var injectComponentMap = {
        'carousel-item': '.carousel-item',
        'carousel-prev': '.carousel-prev',
        'carousel-next': '.carousel-next'
      };

      var templateInstance = template.clone();
      angular.forEach(injectComponentMap, function (innerSelector, outerSelector) {
        var outerElement = el[0].querySelector(outerSelector);
        if (outerElement) {
          angular.element(templateInstance[0].querySelector(innerSelector)).html(outerElement.innerHTML);
        }
      });

      var compiledElement = $compile(templateInstance)($scope);
      el.addClass('ui-carousel').html('').append(compiledElement);
    },


    controller: 'CarouselController',
    controllerAs: 'ctrl'
  };
}]);
'use strict';

angular.module('ui.carousel.providers').provider('Carousel', function () {
  var _this = this;

  this.options = {
    // Init like Slick carousel
    // XXX Should be revised
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    dots: false,

    easing: 'linear',
    fade: false,
    infinite: true,
    initialSlide: 0,

    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,

    visiblePrev: false,
    visibleNext: false,

    // Not available right now
    draggable: true,

    lazyLoad: 'ondemand',

    swipe: true,
    swipeToSlide: false,
    touchMove: true,

    vertical: false,
    verticalSwiping: false
  };
  this.$get = [function () {
    return {
      setOptions: function setOptions(options) {
        _this.options = angular.extend(_this.options, options);
      },
      getOptions: function getOptions() {
        return _this.options;
      }
    };
  }];
});
'use strict';

(function (module) {
  try {
    module = angular.module('ui.carousel');
  } catch (e) {
    module = angular.module('ui.carousel', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('ui-carousel/carousel.template.html', '<div class="carousel-wrapper" ng-show="ctrl.isCarouselReady"><div class="track-wrapper"><div class="track" ng-style="ctrl.trackStyle"><div class="slide" ng-repeat="item in ctrl.slidesInTrack track by $index" ng-style="ctrl.getSlideStyle($index)"><div class="carousel-item"></div></div></div></div><div class="carousel-prev" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisiblePrev &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickablePrev}" ng-click="ctrl.prev()"><button class="carousel-btn"><i class="ui-icon-prev"></i></button></div><div class="carousel-next" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisibleNext &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickableNext}" ng-click="ctrl.next()"><button class="carousel-btn"><i class="ui-icon-next"></i></button></div><ul class="carousel-dots" ng-show="ctrl.isVisibleDots &amp;&amp; ctrl.options.dots"><li ng-repeat="dot in ctrl.getDots()" ng-class="{ \'carousel-active\': dot == ctrl.currentSlide/ctrl.options.slidesToScroll }" ng-click="ctrl.movePage(dot)"><button>{{ dot }}</button></li></ul></div>');
  }]);
})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static',
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.auth.logout')
        .controller('LogoutCtrl', ['authService', LogoutCtrl]);

    /** @ngInject */
    function LogoutCtrl(authService) {
        authService.logout();

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('reportFilter', function () {
            return {
                restrict: 'E',
                // transclude: true,
                controller: 'ReportFilterDirectiveCtrl as vm',
                scope : {
                    hide                        : "=",
                    searchMethod                : "=",
                    type                        : "@",
                    excelUrl                    : "=",
                    excelUrlAllPages            : "=",
                    excelUrlAllData             : "=",
                    pdfUrl                      : "=",
                    verticalPdfUrl              : "=",
                    showFilters                 : "=",
                    isDataLoaded                : "=",
                    selectedPage                : "=",
                    hideDownload                : "=",
                    hidePrint                   : "=",
                    hideSortBy                  : "=",
                    timesheetApprovalStatusHtml : "=",
                    timesheetApplicationId      : "=",
                    showTimesheetApprovalButton : "=",
                    subtract                    : "=",
                    config                      : "<",
                    checkedAttendanceStatus     : "="
                },
                templateUrl: 'app/pages/directives/attendanceReportFilters/filters.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('ReportFilterDirectiveCtrl',
            ['$q', '$scope', '$state', 'editableOptions', 'editableThemes', 'departmentService', 'subDepartmentService', 'shiftGroupService', 'designationService', 'employmentTypeService', 'officeService', 'authService', 'workplaceService', 'employeeService', 'dashboardService', 'toastr', 'utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS', 'ATTENDANCE_STATUS', 'deviceService', 'leaveCategoryService', 'siteManagementService', 'membershipManagementService', 'toastrService', 'generalSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', 'BANGABHABAN_OFFICE_ID', 'REPORT_SETTINGS', '$uibModal', 'GP_CLIENT_OFFICE_IDS', 'DINING_OPTIONS', 'LEAVE_APPROVAL_STATUS', 'MODULES', 'subsidiaryService', 'remainingLeaveService', ReportFilterDirectiveCtrl]);

    /** @ngInject */
    function ReportFilterDirectiveCtrl($q, $scope, $state, editableOptions, editableThemes, departmentService, subDepartmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService, employeeService, dashboardService, toastr, utilService, $timeout, _, GENDER, EMPLOYEE_STATUS, ATTENDANCE_STATUS, deviceService, leaveCategoryService, siteManagementService, membershipManagementService, toastrService, generalSettingsService, analyticsService, ANALYTICS_CONSTANT, BANGABHABAN_OFFICE_ID, REPORT_SETTINGS, $uibModal, GP_CLIENT_OFFICE_IDS, DINING_OPTIONS, LEAVE_APPROVAL_STATUS, MODULES, subsidiaryService, remainingLeaveService) {
        var vm = this;

        vm.allowAllDownload = false;

        vm.maxRows = 0;
        vm.rowsPerPageOption = [
            {value: 10},
            {value: 50},
            {value: 100},
            {value: 500},
            {value: 1000},
            {value: 2000}
        ]
        vm.selectedRowsPerPage = vm.rowsPerPageOption[1]
        var loggedInUser = authService.getLoggedInUser();
        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.isGroupAdmin = loggedInUser.isGroupAdmin;
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.maxDateForDailyReport = new Date();
        vm.filterConfig = $scope.config;
        vm.hide = {
            departmentFilter: getFilterHideValue('departmentFilter'),
            designationFilter: getFilterHideValue('designationFilter'),
            shiftGroupFilter: getFilterHideValue('shiftGroupFilter'),
            genderFilter: getFilterHideValue('genderFilter'),
            employmentTypeFilter: getFilterHideValue('employmentTypeFilter'),
            workplaceFilter: getFilterHideValue('workplaceFilter')
        };

        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.lunchFilterOptions = angular.copy(DINING_OPTIONS);
        vm.dinnerFilterOptions = angular.copy(DINING_OPTIONS);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.searchFilter = "";
        vm.officeList = [];
        vm.departmentList = [];
        vm.subDepartmentList = [];
        vm.designationList = [];
        vm.workplaceList = [];
        vm.shiftGroupList = [];
        vm.companyList = [];
        vm.packageList = [];
        vm.subsidiaryList = [];
        vm.genderList = angular.copy(GENDER);
        vm.statusList = angular.copy(EMPLOYEE_STATUS);
        vm.attendanceStatusList = angular.copy(ATTENDANCE_STATUS);
        vm.allDevice = [];
        vm.leaveCategoryList = [];
        vm.leaveApprovalStatusList = angular.copy(LEAVE_APPROVAL_STATUS);
        vm.selectedDevice = [];
        vm.employmentTypeList = [];
        vm.search = {};
        vm.search.packageList = [];
        vm.datePicker = {};
        vm.datePicker.date = null;
        vm.datePicker.options = null;
        vm.datePicker.ranges = null;
        vm.singleDatePicker = {};
        vm.singleDatePicker.options = null;
        vm.search.searchName = "";
        vm.search.selectedDepartmentList = [];
        vm.search.selectedSubDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedEmploymentTypeList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedGenderList = [];
        vm.search.selectedStatusList = [];
        vm.search.leaveApprovalStatus = [];
        vm.search.selectedAttendanceStatusList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedLineManagerList = [];
        vm.search.selectedHrManagerList = [];
        vm.search.selectedLeaveCategoryList = [];
        vm.search.selectedSitesList = [];
        vm.search.selectedSubsidiaryList = [];
        vm.search.departmentList = [];
        vm.search.subDepartmentList = [];
        vm.search.designationList = [];
        vm.search.employmentTypeList = [];
        vm.search.shiftGroupList = [];
        vm.search.genderList = GENDER;
        vm.search.statusList = EMPLOYEE_STATUS;
        vm.search.workplaceList = [];
        vm.search.lineManagerList = [];
        vm.search.hrManagerList = [];
        vm.search.officeList = [];
        vm.search.leaveCategoryList = [];
        vm.search.allSitesList = [];
        vm.search.subsidiaryList = [];
        vm.search.lunchFilerOption = -1;
        vm.search.dinnerFilterOption = -1;
        vm.presentAbsentList = [];
        vm.showFilters = false;
        vm.isCompanyAdmin = false;
        vm.selectedYear = new Date();
        vm.showLineManagerFilter = loggedInUser.isHrManager || loggedInUser.isAdmin;
        vm.checkedAttendanceStatus = $scope.checkedAttendanceStatus;
        vm.monthList = [{id: 0, name: 'January'}, {id: 1, name: 'February'}, {id: 2, name: 'March'}, {
            id: 3,
            name: 'April'
        }, {id: 4, name: 'May'}, {id: 5, name: 'June'},
            {id: 6, name: 'July'}, {id: 7, name: 'August'}, {id: 8, name: 'September'}, {
                id: 9,
                name: 'October'
            }, {id: 10, name: 'November'}, {id: 11, name: 'December'}];
        // vm.selectedMonth = [];
        vm.selectedMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.yearList = [];
        // vm.selectedYear = [];
        vm.selectedMonthDisplay = "";
        vm.memberSortKey = {
            'ID': {value: 'memberId', order: 'asc', selected: false},
            'Name': {value: 'name', order: 'asc', selected: false},
            'Package': {value: 'packageName', order: 'asc', selected: false},
            'Near Expiry': {value: 'nearExpiry', order: 'asc', selected: false},
        }
        if (loggedInUser.officeId === BANGABHABAN_OFFICE_ID.id) {
            vm.sortKeys = {
                'Report Position': {value: 'reportPosition', order: 'asc', selected: true},
                'ID': {value: 'empOfficeId', order: 'asc', selected: false},
                'Name': {value: 'empName', order: 'asc', selected: false},
                'Section': {value: 'departmentName', order: 'asc', selected: false},
                'Designation': {value: 'designationName', order: 'asc', selected: false},
                'Employment Type': {value: 'employmentTypeName', order: 'asc', selected: false},
                'Shift Group': {value: 'shiftGroupName', order: 'asc', selected: false},
                'Workplace': {value: 'workplaceName', order: 'asc', selected: false},
            };
        } else {
            vm.sortKeys = {
                'Report Position': {value: 'reportPosition', order: 'asc', selected: true},
                'ID': {value: 'empOfficeId', order: 'asc', selected: false},
                'Name': {value: 'empName', order: 'asc', selected: false},
                'Department': {value: 'departmentName', order: 'asc', selected: false},
                'Designation': {value: 'designationName', order: 'asc', selected: false},
                'Employment Type': {value: 'employmentTypeName', order: 'asc', selected: false},
                'Shift Group': {value: 'shiftGroupName', order: 'asc', selected: false},
                'Workplace': {value: 'workplaceName', order: 'asc', selected: false},

            };
        }


        // vm.presentAbsentList = angular.copy(PRESENT_ABSENT_FILTER);
        vm.selectedPresentAbsentFilter = "All";
        vm.isPresent = null;
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.stateName = $state.current.name;

        vm.monthPicker = {};
        vm.monthPicker.opened = false;
        vm.monthPicker.format = "MMMM yyyy";
        vm.monthPicker.options = {
            datepickerMode: 'month',
            minDate: vm.isGpClient ? new Date(new Date().getFullYear(), new Date().getMonth(), 1) : angular.copy(vm.minDate),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.selectedMonth1 = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.monthPicker1 = {};
        vm.monthPicker1.opened = false;
        vm.monthPicker1.format = "MMMM yyyy";
        vm.monthPicker1.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode: 'month',
            maxMode: 'year',
        };
        vm.selectedMonth2 = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.monthPicker2 = {};
        vm.monthPicker2.opened = false;
        vm.monthPicker2.format = "MMMM yyyy";
        vm.monthPicker2.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.timePicker = {};

        // maxDate : vm.appointment.date.endOf('day'),

        vm.yearPicker = {};
        vm.yearPicker.opened = false;
        vm.yearPicker.format = "yyyy";
        vm.yearPicker.options = {
            datepickerMode: 'year',
            minDate: vm.isGpClient ? new Date() : angular.copy(vm.minDate),
            maxDate: new Date(),
            minMode: 'year',
            maxMode: 'year'
        };

        vm.dateRangeList = [];
        vm.search.selectedDateRange = "";

        function getFilterHideValue(value) {
            if (vm.isGroupAdmin)
                return true;
            if ($scope.hide != null) {
                if ($scope.hide.includes(value))
                    return true;
            }
            return false;
        }

        vm.searchAttendance = searchAttendance;
        vm.populateFilterModels = populateFilterModels;
        vm.populateOfficeFilter = populateOfficeFilter;
        vm.populateSubsidiaryFilter = populateSubsidiaryFilter;
        vm.updateSortKey = updateSortKey;
        vm.updateMemberSortKey = updateMemberSortKey;
        vm.openMonthPicker = openMonthPicker;
        vm.openYearPicker = openYearPicker;
        vm.exportAsExcel = exportAsExcel;
        vm.exportAsPdf = exportAsPdf;
        vm.getAllOnEmptySearchKeyword = getAllOnEmptySearchKeyword;
        vm.openMonthPicker1 = openMonthPicker1;
        vm.openMonthPicker2 = openMonthPicker2;
        vm.handleRowPerPageSelection = handleRowPerPageSelection;
        vm.searchByNameOrId = searchByNameOrId;
        vm.checkIfBangaBhabanEmployee = checkIfBangaBhabanEmployee;

        function handleRowPerPageSelection() {
            utilService.setRowsPerPage(vm.selectedRowsPerPage.value);
            vm.searchAttendance();
        }

        function checkIfBangaBhabanEmployee() {
            return authService.getLoggedInUser().officeId === BANGABHABAN_OFFICE_ID.id;
        }

        function init() {
            if (vm.checkedAttendanceStatus) {
                vm.attendanceStatusList.forEach(function (status) {
                    if (status.id === vm.checkedAttendanceStatus)
                        status.ticked = true
                })
            }
            // vm.attendanceStatusList[vm.checkedAttendanceStatus-1].ticked = true;

            if (vm.stateName === 'attendanceReport.allLogs') {
                vm.rowsPerPageOption.push({value: 5000});
            }
            generalSettingsService.getReportSettingsOfAnOffice().then(function (response) {
                vm.allowAllDownload = response.allowAllDownload;
                vm.maxRows = response.maxRows;
                if (!vm.allowAllDownload && vm.maxRows > 0 && vm.stateName != 'attendanceReport.allLogs') {
                    vm.rowsPerPageOption.push({value: vm.maxRows});
                }
            });
            if (vm.rowsPerPage !== 50 || vm.rowsPerPage !== 100 || vm.rowsPerPage !== 500 || vm.rowsPerPage !== 1000) {
                vm.rowsPerPage = 50;
                utilService.setRowsPerPage(vm.rowsPerPage);
            }
            membershipManagementService.getAllPackages().then(function (data) {
                vm.packageList = data;
            }, function (error) {
                toastrService.showErrorToastr('Failed to fetch data: ' + error, '', '5000');
            });
            //Setting status filter to active
            vm.search.selectedStatusList.push({id: 1});
            //Duration reports
            vm.datePicker.date = getInitialFromAndToDate();
            vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
            vm.datePicker.options = {
                applyClass: 'btn-green',
                timePicker: vm.stateName === 'attendanceReport.allLogs',
                timePicker24Hour: false,
                minDate: vm.isGpClient ? new moment() : angular.copy(vm.minDate),
                maxDate: new moment(),
                eventHandlers: {
                    'apply.daterangepicker': searchAttendance
                },
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    // format: "YYYY-MM-DD", //will give you 2017-01-06
                    format: (vm.stateName === 'attendanceReport.allLogs') ? 'DD-MMM-YYYY hh:mm A' : "D MMM YYYY", //will give you 6-Jan-17
                    //format: "D-MMMM-YY", //will give you 6-January-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                    'Last 7 days': [moment().subtract('days', 7), moment()],
                    'Last 30 days': [moment().subtract('days', 30), moment()],
                    'This month': [moment().startOf('month'), moment().endOf('month')]
                }
            };
            vm.selectedTime = moment().startOf('day');
            vm.timePicker.options = {
                singleDatePicker: true,
                startDate: moment().startOf('day'),
                endDate: moment().startOf('day'),
                minDate: moment().startOf('day'),
                maxDate: moment().endOf('day'),
                timePicker: true,
                timePicker24Hour: false,
                eventHandlers: {
                    'apply.daterangepicker': searchAttendance,
                },
                locale: {
                    format: 'hh:mm A'
                }
            };
            // vm.timePicker.options = {
            //     singleDatePicker : true,
            //     date:{
            //         startDate : moment().startOf('day'),
            //         endDate : moment().endOf('day'),
            //     },
            //     minDate : moment().startOf('day'),
            //     maxDate : moment().endOf('day'),
            //     timePicker : true,
            //     timePicker24Hour : false,
            //     eventHandlers : {
            //         'apply.daterangepicker': searchAttendance,
            //     },
            //     locale : {
            //         format : 'hh:mm A'
            //     }
            // };
            vm.singleDatePicker.options = {
                singleDatePicker: true,
                timePicker24Hour: false,
                minDate: vm.isGpClient ? new moment() : angular.copy(vm.minDate),
                eventHandlers: {
                    'apply.daterangepicker': searchAttendance,
                },
                locale: {
                    format: "D MMM YYYY",
                }
            };

            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            //Monthly weekly reports
            if ($scope.type == 'monthly') {
                var year = new Date().getFullYear();
                vm.attendanceOfYear = year;
                vm.yearList.push(
                    // {id: year - 2, ticked: false},
                    {id: year - 1, ticked: false}, {
                        id: year,
                        ticked: true
                    });
                vm.yearList = _.orderBy(vm.yearList, ['id'], ['desc']);
                // vm.selectedYear.push({id: year});
                // tickCurrentMonth();
                vm.selectedMonthDisplay = getCurrentMonthInString();
            }
            if ($scope.type == 'weekly') {
                vm.datePicker.date = moment().subtract(6, 'day');
            }
            if ($scope.type == 'daily') {
                vm.datePicker.date = moment();
            }

            departmentService.getAllDepartments().then(function (departmentList) {
                vm.departmentList = sortCollectionByName(mapOfficeNameIntoList(departmentList));
                vm.search.departmentList = angular.copy(vm.departmentList);
//                if ($state.current.name == 'attendanceReport.departmentReport' && !loggedInUser.isCompanyAdmin) {
//                    makeDepartmentSelected();
//                    searchAttendance();
//                }

            }, function (message) {
            });

            subDepartmentService.getAllSubDepartments().then(function (subDepartmentList) {
                vm.subDepartmentList = sortCollectionByName(mapOfficeNameIntoList(subDepartmentList));
                vm.search.subDepartmentList = angular.copy(vm.subDepartmentList);
//                if ($state.current.name == 'attendanceReport.departmentReport' && !loggedInUser.isCompanyAdmin) {
//                    searchAttendance();
//                }

            }, function (message) {
            });
            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = sortCollectionByName(mapOfficeNameIntoList(designationList));
                vm.search.designationList = angular.copy(vm.designationList);
            }, function (message) {
            });

            shiftGroupService.getAllShiftGroups(true).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(mapshiftGroupOfficeNameIntoList(shiftGroupList));
                vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            }, function (message) {
            });
            if (vm.isCompanyAdmin || vm.isGroupAdmin) {
                officeService.getAllOffices(true).then(function (officeList) {
                    vm.officeList = angular.copy(officeList);
                    vm.search.officeList = angular.copy(officeList);
                    if ($state.current.name == 'attendanceReport.detailedAttendanceReport' && $state.params.officeId) {
                        vm.search.selectedOfficeList = [];
                        for (var i = 0; i < vm.search.officeList.length; i++) {
                            if (vm.search.officeList[i].id == $state.params.officeId) {
                                vm.search.officeList[i].ticked = true;
                                vm.search.selectedOfficeList.push({id: vm.search.officeList[i].id, ticked: true});
                                break;
                            }
                        }
                    }
                });
            }
            if (vm.isGroupAdmin) {
                dashboardService.getCompanyList().then(function (data) {
                    vm.companyList = data;
                })
            }

            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.employmentTypeList = sortCollectionByName(mapOfficeNameIntoList(employmentTypeList));
                vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            }, function (message) {
                console.error("Failed to fetch designation category list : " + message);
            });

            workplaceService.getAllWorkplaces().then(function (data) {
                vm.workplaceList = sortCollectionByName(mapOfficeNameIntoList(data));
                vm.search.workplaceList = angular.copy(vm.workplaceList);
            }, function (message) {
                console.error("Failed to fetch workplace list: " + message);
            });

            if(vm.isSubsidiaryModuleEnabled){
                subsidiaryService.getAllSubsidiaries().then(function (subsidiaryList) {
                    vm.subsidiaryList = sortCollectionByName(subsidiaryList);
                    vm.search.subsidiaryList = angular.copy(vm.subsidiaryList);

                    // Auto-select subsidiary for admin users with subsidiaryId
                    if (loggedInUser.isAdmin && loggedInUser.subsidiaryId != null) {
                        vm.search.selectedSubsidiaryList = [{id: loggedInUser.subsidiaryId}];
                        // Use timeout to ensure other lists are loaded before filtering
                        $timeout(function() {
                            console.log("Auto-triggering subsidiary filter for admin user");
                            populateSubsidiaryFilter();
                        }, 500);
                    }
                }, function (error) {
                    console.error("Failed to fetch subsidiary list: " + error);
                });
            }

            employeeService.getFilteredEmployeeNames({
                officeIdList: loggedInUser.office.id,
                status: 1,
                onlyLineManagers: true
            }).then(function (data) {
                vm.search.lineManagerList = data.employees;
            }, function (message) {

            });

            employeeService.getFilteredEmployeeNames({
                officeIdList: loggedInUser.office.id,
                status: 1,
                onlyHrManagers: true
            }).then(function (data) {
                vm.search.hrManagerList = data.employees;
            }, function (message) {

            });

            deviceService.getAllDevices().then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    data[i]["label"] = data[i]["identifier"] + " - " + data[i]["location"];
                }
                vm.devices = data;
                vm.allDevice = angular.copy(vm.devices);
            }, function (error) {
                console.error("Could not fetch device list : " + error);
            });

            leaveCategoryService.getAllLeaveCategories().then(function (leaveCategoryList) {
                vm.leaveCategoryList = sortCollectionByName(mapOfficeNameIntoList(leaveCategoryList));
                vm.search.leaveCategoryList = angular.copy(vm.leaveCategoryList);
            }, function (message) {
            });

            var params = {
                pageNumber: 0,
                perPage: 0,
            }
            siteManagementService.getAllSitesInformation(params).then(function (data) {
                vm.sitesInfoList = sortCollectionByName(mapOfficeNameIntoList(data.siteList));
                vm.search.allSitesList = angular.copy(vm.sitesInfoList);
            }, function (error) {
                console.error("Could not fetch device list : " + error);
            });

            // $timeout(function () {
            //     searchAttendance();
            // }, 500);
        };

        init();
        $scope.$watch('vm.datePicker.date', function (newVal) {
            if (newVal != null && $scope.type == 'daily' && vm.datePicker.date.startDate == null) {
                vm.timePicker.options.startDate = vm.datePicker.date.startOf('day');
                vm.timePicker.options.endDate = vm.datePicker.date.startOf('day');
                vm.timePicker.options.minDate = angular.copy(vm.datePicker.date).startOf('day');
                vm.timePicker.options.maxDate = angular.copy(vm.datePicker.date).endOf('day');
                vm.selectedTime = angular.copy(vm.datePicker.date).startOf('day');
            }
        });

        function fetchDateRanges() {
            if (vm.dateRangeList && vm.dateRangeList.length > 0) {
                return $q.when({ dateRanges: vm.dateRangeList });
            }
            return remainingLeaveService.getDistinctLeaveBalanceDateRanges().then(function (data) {
                vm.dateRangeList = data.dateRanges;
                if (vm.dateRangeList.length > 0 && !vm.search.selectedDateRange) {
                    var index = utilService.findDateRangeIndexContainingToday(vm.dateRangeList);
                    vm.search.selectedDateRange = vm.dateRangeList[index];
                }
                return data;
            });
        }
        function tickCurrentMonth() {
            var d = new moment().format("MMMM");
            for (var i = 0; i < vm.monthList.length; i++) {
                if (vm.monthList[i].name.toLowerCase() === d.toLowerCase()) {
                    vm.monthList[i].ticked = true;
                    // vm.selectedMonth.push({id: vm.monthList[i].id});
                    break;
                }
            }

        }

        function mapOfficeNameIntoList(objectList) {
            if (vm.isCompanyAdmin) {
                return objectList.map(function (object) {
                    object.officeName = officeService.getOfficeNameById(object.officeId);
                    return object;
                });
            }
            return objectList;
        }

        function mapshiftGroupOfficeNameIntoList(objectList) {
            if (vm.isCompanyAdmin) {
                return objectList.map(function (object) {
                    object.officeName = officeService.getOfficeNameById(object.officeId);
                    object.officeId = object.officeId;
                    return object;
                });
            }
            return objectList;
        }


        function makeDepartmentSelected() {
            if ($state.params.departmentId) {
                // console.log("$state.params: " + JSON.stringify($state.params));
                vm.search.selectedDepartmentList = [];
                for (var i = 0; i < vm.search.departmentList.length; i++) {
                    if (vm.search.departmentList[i].id == $state.params.departmentId) {
                        vm.search.departmentList[i].ticked = true;
                        vm.search.selectedDepartmentList.push({id: vm.departmentList[i].id, ticked: true});
                        break;
                    }
                }
            } else if (loggedInUser.departmentId) {
                vm.search.selectedDepartmentList = [];
                for (var i = 0; i < vm.search.departmentList.length; i++) {
                    if (vm.search.departmentList[i].id == loggedInUser.departmentId) {
                        vm.search.departmentList[i].ticked = true;
                        vm.search.selectedDepartmentList.push({id: vm.departmentList[i].id, ticked: true});
                        break;
                    }
                }
            }
            // console.log("vm.search.selectedDepartmentList : " + JSON.stringify(vm.search.selectedDepartmentList));
        }

        function getInitialFromAndToDate() {
            var start;
            if ($scope.subtract == null)
                start = vm.isGpClient ? moment().startOf('day') : moment().startOf('day').subtract(3, 'day');
            else
                start = vm.isGpClient ? moment().startOf('day') : moment().startOf('day').subtract($scope.subtract, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        vm.resetLeaveApprovalStatus = function() {
            vm.search.leaveApprovalStatus = []; 
            searchAttendance();
          }


        function searchAttendance() {
            var sortKeyAndOrder = getSortKeyAndOrder();

            // 1. Initialize your base parameters
            var attendanceSearchParameters = {
                designationId: vm.search.selectedDesignationList.map(getId),
                departmentId: vm.search.selectedDepartmentList.map(getId),
                subDepartmentId: vm.search.selectedSubDepartmentList.map(getId),
                shiftGroupId: vm.search.selectedShiftGroupList.map(getId),
                genderId: vm.search.selectedGenderList.map(getId),
                employeeName: vm.search.searchName,
                companyId: (vm.isCompanyAdmin || vm.isGroupAdmin) ? vm.search.selectedCompanyList.map(getId) : [authService.getMyOfficeInformation().companyId],
                officeId: (vm.isCompanyAdmin || vm.isGroupAdmin) ? vm.search.selectedOfficeList.map(getId) : [authService.getLoggedInUser().office.id],
                employmentTypeId: vm.search.selectedEmploymentTypeList.map(getId),
                workplaceId: vm.search.selectedWorkplaceList.map(getId),
                lineManagerId: vm.search.selectedLineManagerList.map(getId),
                hrManagerId: vm.search.selectedHrManagerList.map(getId),
                subsidiaryId: vm.search.selectedSubsidiaryList.map(getId),
                status: vm.search.selectedStatusList.map(getId),
                attendanceStatus: vm.search.selectedAttendanceStatusList.map(getId),
                leaveCategoryId: vm.search.selectedLeaveCategoryList.map(getId),
                siteIds: vm.search.selectedSitesList.map(getId),
                pageNumber: 0,
                perPage: utilService.getRowsPerPage(),
                sortKey: sortKeyAndOrder.key,
                order: sortKeyAndOrder.order,
                isPresent: vm.isPresent,
                startTime: vm.selectedTime.valueOf(),
                date: Number(moment(vm.datePicker.date.valueOf()).startOf('day').format('x')),
                membershipPackageIds: vm.search.packageList.map(getId),
                month1: Number(moment(vm.selectedMonth1.valueOf()).startOf('month').format('x')),
                month2: Number(moment(vm.selectedMonth2.valueOf()).endOf('month').format('x')),
                lunchFilter: vm.search.lunchFilerOption.length ? vm.search.lunchFilerOption[0].id : -1,
                dinnerFilter: vm.search.dinnerFilterOption.length ? vm.search.dinnerFilterOption[0].id : -1,
                leaveApprovalStatus: vm.search.leaveApprovalStatus.map(getId)
            };

            // 2. Start a Promise chain. $q.when() creates a promise that is already resolved.
            var processingPromise = $q.when(true);

            if (!$scope.type) {
                attendanceSearchParameters.from = vm.datePicker.date.startDate.valueOf();
                attendanceSearchParameters.to = vm.datePicker.date.endDate.valueOf();
            } else if ($scope.type === 'monthly') {
                if (vm.selectedMonth != null) {
                    var selectedTime = moment().year(vm.selectedMonth.getFullYear()).month(vm.selectedMonth.getMonth());
                    attendanceSearchParameters.from = Number(getStartOfMonthFromMomentInMillis(selectedTime));
                    attendanceSearchParameters.to = Number(getEndOfMonthFromMomentInMillis(selectedTime));
                    attendanceSearchParameters.year = vm.selectedMonth.getFullYear();
                    attendanceSearchParameters.month = vm.selectedMonth.getMonth();
                } else {
                    return toastr.error("Please select month and year");
                }
            } else if ($scope.type === 'weekly') {
                attendanceSearchParameters.from = Number(getStartTimeOfWeekInMillis());
                attendanceSearchParameters.to = Number(getEndTimeOfWeekInMillis());
            } else if ($scope.type === 'daily') {
                attendanceSearchParameters.from = Number(moment(vm.datePicker.date.valueOf()).startOf('day').format('x'));
                attendanceSearchParameters.to = Number(moment(vm.datePicker.date.valueOf()).endOf('day').format('x'));
            } else if ($scope.type === 'yearly') {
                var selectedFirstMonth = moment().year(vm.selectedYear.getFullYear()).month(0);
                var selectedLastMonth = moment().year(vm.selectedYear.getFullYear()).month(11);
                attendanceSearchParameters.from = Number(getStartOfYearFromMomentInMillis(selectedFirstMonth));
                attendanceSearchParameters.to = Number(getEndOfYearFromMomentInMillis(selectedLastMonth));
                attendanceSearchParameters.year = vm.selectedYear.getFullYear();
            } else if ($scope.type === 'fiscalYearly') {
                // 3. Update the chain by assigning the API call to it
                processingPromise = fetchDateRanges().then(function() {
                    var dates = vm.search.selectedDateRange.split(" - ");
                    var fromStr = dates[0].trim().charAt(0).toUpperCase() + dates[0].trim().slice(1);
                    var toStr = dates[1].trim().charAt(0).toUpperCase() + dates[1].trim().slice(1);

                    attendanceSearchParameters.from = moment(fromStr, "MMM YYYY").startOf('month').startOf('day').valueOf();
                    attendanceSearchParameters.to = moment(toStr, "MMM YYYY").endOf('month').endOf('day').millisecond(0).valueOf();
                    attendanceSearchParameters.selectedDateRange = vm.search.selectedDateRange;
                });
            }

            // 4. This block ALWAYS runs after the logic above finishes (even the async part)
            processingPromise.then(function() {
                if (vm.stateName == 'attendanceReport.allLogs') {
                    attendanceSearchParameters.deviceId = vm.selectedDevice.map(getId);
                }

                // Final execution: This is now safe because the promise has resolved!
                $scope.searchMethod(attendanceSearchParameters);
            });
        }

        function getId(object) {
            return object.id;
        }

        function getStartOfMonthFromMomentInMillis(d) {
            return d.startOf('month').format('x');
        }

        function getEndOfMonthFromMomentInMillis(d) {
            return d.endOf('month').format('x');
        }

        function getStartOfYearFromMomentInMillis(d) {
            return d.startOf('year').format('x');
        }

        function getEndOfYearFromMomentInMillis(d) {
            return d.endOf('year').format('x');
        }

        function getCurrentMonthInString() {
            var d = new moment().format("MMMM");
            return d;
        }

        function getStartTimeOfWeekInMillis() {
            return vm.datePicker.date.startOf('day').format('x');
        }

        function getEndTimeOfWeekInMillis() {
            return new moment(vm.datePicker.date.valueOf()).add(6, 'd').endOf('day').format('x');
        }

        function populateFilterModels() {
            var selectedOfficeIds = vm.search.selectedOfficeList.map(function (office) {
                return office.id;
            });
            if (selectedOfficeIds.length === 0) {
                clearFilters();
            } else {
                if (vm.isGroupAdmin) {
                    var applicableCompanyIds = vm.search.selectedOfficeList.map(function (office) {
                        return office.companyId;
                    });
                    vm.search.selectedCompanyList = [];
                    for (var i = 0; i < vm.companyList.length; i++) {
                        vm.companyList[i].ticked = false;
                        if (applicableCompanyIds.includes(vm.companyList[i].id)) {
                            vm.companyList[i].ticked = true;
                            vm.search.selectedCompanyList.push({id: vm.companyList[i].id});
                        }
                    }

                }
                vm.search.departmentList = filterByOfficeId(vm.departmentList, selectedOfficeIds);
                vm.search.designationList = filterByOfficeId(vm.designationList, selectedOfficeIds);
                vm.search.shiftGroupList = filterByOfficeId(vm.shiftGroupList, selectedOfficeIds);
                vm.search.workplaceList = filterByOfficeId(vm.workplaceList, selectedOfficeIds);
                vm.search.employmentTypeList = filterByOfficeId(vm.employmentTypeList, selectedOfficeIds);
            }
        }

        function clearFilters() {
            vm.search.departmentList = angular.copy(vm.departmentList);
            vm.search.designationList = angular.copy(vm.designationList);
            vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            vm.search.workplaceList = angular.copy(vm.workplaceList);
            vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            vm.search.selectedDepartmentList = [];
            vm.search.selectedSubDepartmentList = [];
            vm.search.selectedDesignationList = [];
            vm.search.selectedShiftGroupList = [];
            vm.search.selectedWorkplaceList = [];
            vm.search.selectedEmploymentTypeList = [];
        }

        function populateOfficeFilter() {
            var selectedCompanyIds = vm.search.selectedCompanyList.map(function (company) {
                return company.id;
            });
            if (selectedCompanyIds.length === 0) {
                vm.search.officeList = [];
            } else {
                vm.search.officeList = filterByCompanyId(vm.officeList, selectedCompanyIds);
            }
        }

        function populateSubsidiaryFilter() {

            // Use $timeout to ensure the output-model is updated by the directive first
            // This is especially important for on-reset and on-clear events
            $timeout(function() {
                var selectedSubsidiaryIds = vm.search.selectedSubsidiaryList.map(function (subsidiary) {
                    return subsidiary.id;
                });

                if (selectedSubsidiaryIds.length === 0) {
                    clearSubsidiaryFilters();
                } else {
                    vm.search.departmentList = filterBySubsidiaryId(vm.departmentList, selectedSubsidiaryIds);
                    vm.search.designationList = filterBySubsidiaryId(vm.designationList, selectedSubsidiaryIds);
                    vm.search.shiftGroupList = filterBySubsidiaryId(vm.shiftGroupList, selectedSubsidiaryIds);
                    vm.search.workplaceList = filterBySubsidiaryId(vm.workplaceList, selectedSubsidiaryIds);
                    vm.search.employmentTypeList = filterBySubsidiaryId(vm.employmentTypeList, selectedSubsidiaryIds);

                }
            }, 0);
        }

        function clearSubsidiaryFilters() {
            vm.search.departmentList = angular.copy(vm.departmentList);
            vm.search.designationList = angular.copy(vm.designationList);
            vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            vm.search.workplaceList = angular.copy(vm.workplaceList);
            vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            vm.search.selectedDepartmentList = [];
            vm.search.selectedSubDepartmentList = [];
            vm.search.selectedDesignationList = [];
            vm.search.selectedShiftGroupList = [];
            vm.search.selectedWorkplaceList = [];
            vm.search.selectedEmploymentTypeList = [];
        }

        function filterByOfficeId(modelArray, officeIds) {
            return modelArray.filter(function (model) {
                return officeIds.includes(model.officeId);
            })
        }


        function filterByCompanyId(modelArray, companyIds) {
            return modelArray.filter(function (model) {
                return companyIds.includes(model.companyId);
            })
        }

        function filterBySubsidiaryId(modelArray, subsidiaryIds) {
            if (!modelArray || modelArray.length === 0) {
                return [];
            }

            // Log first item structure to understand data
            if (modelArray.length > 0) {
            }

            var filtered = modelArray.filter(function (model) {
                return subsidiaryIds.includes(model.subsidiaryId);
            });
            return filtered;
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection, function (item) {
                return item.name.toLowerCase();
            }, ['asc']);
        }

        function updateMemberSortKey(key) {
            if (vm.memberSortKey[key].selected) {
                vm.memberSortKey[key].order = vm.memberSortKey[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.memberSortKey);
                keys.forEach(function (keyName) {
                    // console.log(vm.sortKeys[keyName]);
                    vm.memberSortKey[keyName].selected = false;
                    vm.memberSortKey[keyName].order = 'asc';
                });
                vm.memberSortKey[key].selected = true;
            }
            vm.sortKeys = vm.memberSortKey;
            searchAttendance();
        }

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    // console.log(vm.sortKeys[keyName]);
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            searchAttendance();
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for (var i = 0; i < keys.length; i++) {
                if (vm.sortKeys[keys[i]].selected == true) {
                    return {key: vm.sortKeys[keys[i]].value, order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function openMonthPicker() {
            vm.monthPicker.opened = true;
        }

        function openMonthPicker1() {
            vm.monthPicker1.opened = true;
        }

        function openMonthPicker2() {
            vm.monthPicker2.opened = true;
        }

        function openYearPicker() {
            vm.yearPicker.opened = true;
        }

        $scope.reportPrint = function () {
            $scope.$emit("printEvent");
        }

        $scope.openTimeSheetApproveModal = function (applicationId) {
            $scope.$emit("approveTimesheet", applicationId);
        }

        function isDownloadMonthLimitExceeded() {
            // var minDate = moment().subtract(REPORT_SETTINGS.downloadMonthLimit, 'month').startOf('month');
            if (!$scope.type) {
                return vm.datePicker.date.endDate.diff(vm.datePicker.date.startDate, 'months', true) > REPORT_SETTINGS.downloadMonthLimit;
                // return minDate.diff(vm.datePicker.date.startDate) > 0;
            } else if ($scope.type === 'monthly') {
                return false;
                // return minDate.diff(new moment(vm.selectedMonth)) > 0;
            } else if ($scope.type === 'daily') {
                return false;
                // return minDate.diff(vm.datePicker.date) > 0;
            } else if ($scope.type === 'yearly') {
                return false;
            }
        }

        function openDownloadWarningModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/modals/reportDownloadWarningModal/reportDownloadWarning.modal.html',
                size: 'md',
                controller: 'ReportDownloadWarningModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
            }).result.then(function () {
            });
        }

        function exportAsExcel(pages) {
            if (isDownloadMonthLimitExceeded()) {
                return openDownloadWarningModal();
            }
            if(pages === "all") {
                if ($scope.excelUrlAllPages != null && $scope.excelUrlAllPages.trim() !== "") {
                    var deferred = $q.defer();
                    var url = $scope.excelUrlAllPages;
                    if (vm.allowAllDownload) {
                        url += "&unpaged=true";
                    }
                    analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel);
                    setTimeout(function () {
                        window.open(url, '_blank', '');
                        deferred.resolve();
                    }, 0);

                    return deferred.promise;
                }
            }
            else{
                if ($scope.excelUrl != null && $scope.excelUrl.trim() !== "") {
                    var deferred = $q.defer();
                    var url = $scope.excelUrl;
                    if (vm.allowAllDownload) {
                        url += "&unpaged=true";
                    }
                    analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel);
                    setTimeout(function () {
                        window.open(url, '_blank', '');
                        deferred.resolve();
                    }, 0);

                    return deferred.promise;
                }
            }
        }

        function exportAsPdf(orientation) {
            if (isDownloadMonthLimitExceeded()) {
                return openDownloadWarningModal();
            }

            if (orientation === "H") {
                if ($scope.pdfUrl != null && $scope.pdfUrl.trim() !== "") {
                    var url = $scope.pdfUrl
                    if (vm.allowAllDownload) {
                        url += "&unpaged=true";
                    }
                    window.open(url, '_blank', '');
                    analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf)
                }
            } else if (orientation === "V") {
                if ($scope.verticalPdfUrl != null && $scope.verticalPdfUrl.trim() !== "") {
                    var url = $scope.verticalPdfUrl
                    if (vm.allowAllDownload) {
                        url += "&unpaged=true";
                    }
                    window.open(url, '_blank', '');
                    analyticsService.sendData(ANALYTICS_CONSTANT.verticalPdfUrl, document.title + ' - Download Vertical PDF', '', 'Download  Vertical PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadVerticalPdf)
                }
            }
        }

        function getAllOnEmptySearchKeyword() {
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search)
            if (vm.search.searchName === "" || vm.search.searchName.length === 0) searchAttendance();
        }

        $scope.$watch('vm.monthPicker1.opened', function (newVal, oldVal) {
            if (!newVal && vm.filterConfig.monthRangePicker != null && vm.filterConfig.monthRangePicker.show == true) {
                searchAttendance();
            }
        })
        $scope.$watch('vm.monthPicker2.opened', function (newVal, oldVal) {
            if (!newVal && vm.filterConfig.monthRangePicker != null && vm.filterConfig.monthRangePicker.show == true) {
                searchAttendance();
            }
        })
        $scope.$watch('vm.monthPicker.opened', function (newVal, oldVal) {
            if (!newVal) {
                searchAttendance();
            }
        })

        if ($state.current.name === 'attendanceReport.leaveBalanceReport' || $state.current.name === 'leave.uploadLeaveBalance') {
            var isInitialLoad = true;
            $scope.$watch('vm.yearPicker.opened', function (newVal, oldVal) {
                if (!isInitialLoad && !newVal) {
                    searchAttendance();
                }
                if (isInitialLoad) {
                    isInitialLoad = false;
                }
            });
        }

        function searchByNameOrId() {
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            searchAttendance();
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('paginationDirective', function () {
            return {
                restrict: 'E',
                // transclude: true,
                controller: 'PaginationDirectiveCtrl as vm',
                scope : {
                    numberOfPages   : '=',
                    numberOfButtons : '=',
                    selectedPage    : '=',
                    total           : '=',
                    isDataLoaded    : '=',
                    searchMethod    : '=',
                    notFoundText    : '=',
                    hideNoDataMessage: '=',
                },
                templateUrl: 'app/pages/directives/attendanceReportPaginationDirective/paginationDirective.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('PaginationDirectiveCtrl',
            ['$scope','utilService', PaginationDirectiveCtrl]);

    /** @ngInject */
    function PaginationDirectiveCtrl($scope,utilService) {
        var vm = this;
        $scope.rowsPerPage = utilService.getRowsPerPage();
        vm.shouldShowPaginationButton = shouldShowPaginationButton;
        vm.reduceSelectedPaginationPage = reduceSelectedPaginationPage;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.goToPage = goToPage;

        vm.notFoundText = $scope.notFoundText == null ? 'noAttendanceFound' : $scope.notFoundText;

        function shouldShowPaginationButton(index) {
            return $scope.selectedPage <= 2 ? index <= 5 :
                ($scope.selectedPage <= $scope.numberOfButtons.length && $scope.selectedPage > $scope.numberOfButtons.length - 6 ?
                    index > $scope.numberOfButtons.length - 7 :
                    index >= $scope.selectedPage - 2 && index <= $scope.selectedPage + 3);
        }
        function reduceSelectedPaginationPage() {
            if($scope.selectedPage != 0 ){
                $scope.searchMethod('prev');
            };

        }

        function goToPage(page) {
            $scope.searchMethod(page);
        }

        function increaseSelectedPaginationPage() {
            if($scope.selectedPage != $scope.numberOfButtons.length - 1) {
                $scope.searchMethod('next');
            };
        }

    }

})();

angular.module('InovaceClientApp.pages.main')
    .directive('birthdayPopUp', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/pages/directives/birthdayPopUp/birthdayPopUp.html',
            scope: {
                data: '=',
                onClose: '&'
            },
            controller: 'birthdayPopUpDirectiveCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    });

angular
    .module('InovaceClientApp.pages.main')
    .controller('birthdayPopUpDirectiveCtrl', ['$scope', function ($scope) {

        var vm = this;

        vm.totalBirthdays = 0;

        // Watch async data safely
        $scope.$watch(
            function () {
                return vm.data;
            },
            function (newVal) {
                if (newVal) {
                    vm.totalBirthdays = newVal.length;
                    console.log("directive data:", vm.totalBirthdays);
                }
            }
        );

        vm.closePopup = function () {
            vm.onClose(); // ✅ clean, safe, reusable
        };
    }]);

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('dailyTable', function () {
            function link(scope,element,attributes) {
                scope.$on('$destroy',function (event) {
                    scope = null;
                })
            }
            return {
                restrict: 'E',
                controller: 'dailyAttendanceTableDirectiveCtrl as vm',
                scope:{
                    allAttendanceData   : "=",
                    dateList            : "=",
                    numberOfPages       : "=",
                    numberOfButtons     : "=",
                    selectedPage        : "=",
                    isDataLoaded        : "=",
                    rowsPerPage         : "=",
                    offset              : "=",
                    excelUrl            : "=",
                    pdfUrl              : "=",
                    showImage           : "=",
                    startOfDayList      : "=",
                    dailySummary        : "=",
                    showLineManager     : "="
                },
                link:link,
                templateUrl: 'app/pages/directives/dailyAttendanceTable/dailyAttendanceTable.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('dailyAttendanceTableDirectiveCtrl',
            ['$scope','attendanceService', 'authService','$document','_', 'utilService', 'MODULES',dailyAttendanceTableDirectiveCtrl]);

    /** @ngInject */
    function dailyAttendanceTableDirectiveCtrl($scope, attendanceService, authService,$document,_,utilService, MODULES) {

        var vm  = this;
        var loggedInUser = authService.getLoggedInUser();
        $scope.rows = {};
        $scope.rows.perPage = $scope.rowsPerPage;

        vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
        vm.isGroupAdmin = loggedInUser.isGroupAdmin;
        vm.hasPermission = utilService.hasPermission;
        vm.showSummary = utilService.hasPermission('4013');
        vm.showTotalHours = utilService.hasPermission('4014');
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        $scope.$on('$destroy',function (event) {
            $scope = null;
        });


        vm.getRowsPerPage = getRowsPerPage;
        vm.getDateList = getDateList;

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }

        function getDateList() {
            return $scope.dateList;
        }




        // function exportToPdf  () {
        //     var table = angular.element( $document[0].querySelector('#attendanceTable')).html();
        //     var mywindow = window.open('', 'new div', 'height=400,width=600');
        //
        //     mywindow.document.write('<html><head><title>Attendance Report</title>');
        //
        //     mywindow.document.write('<script src="../bower_components/angular/angular.js"></script>')
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css" />');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-select/dist/css/bootstrap-select.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-tagsinput/dist/bootstrap-tagsinput.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/main.css" />');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/styles.css"  >');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/angular-ui-switch/angular-ui-switch.css" />');
        //
        //     mywindow.document.write('</head><body><table id = "printTable" class="table" style="color: black!important;background-color: white!important;">');
        //     mywindow.document.write(table);
        //     mywindow.document.write('</table></body></html>');
        //
        //     mywindow.document.close();
        //     setTimeout(function(){mywindow.print();
        //         mywindow.close()},2000);
        //
        // };

        function exportToPdf() {
            var printContents = document.getElementById("attendanceDiv").innerHTML;
            var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
            popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 3mm;} table{border-collapse: collapse; border-spacing: 2px;} thead {display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
            popupWin.document.close();
            popupWin.print();
        }

        $scope.$on("printReport", function () {
            var printContents = document.getElementById("attendanceDiv").innerHTML;
            var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
            //popupWin.document.open();
            popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 3mm;} .list-avatar{border-radius: 50%;height: 30px;width: 30px;float: left;margin-top: 2px;} table{border-collapse: collapse; border-spacing: 2px;} thead {display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
            popupWin.document.close();
            popupWin.print();
        });

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('detailedTable', function () {
            function link(scope,element,attributes) {
                scope.$on('$destroy',function (event) {
                    scope = null;
                })
            }
            return {
                restrict: 'E',
                controller: 'DetailedAttendanceTableDirectiveCtrl as vm',
                scope:{
                    allAttendanceData   : "=",
                    dateList            : "=",
                    numberOfPages       : "=",
                    numberOfButtons     : "=",
                    selectedPage        : "=",
                    isDataLoaded        : "=",
                    rowsPerPage         : "=",
                    offset              : "=",
                    excelUrl            : "=",
                    pdfUrl              : "=",
                    showImage           : "=",
                    startOfDayList      : "=",
                    showLineManager     : "="
                },
                link:link,
                templateUrl: 'app/pages/directives/detailedAttendanceTable/detailedAttendanceTable.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('DetailedAttendanceTableDirectiveCtrl',
            ['$scope','attendanceService', 'authService','$document','_', 'utilService', 'MODULES',DetailedAttendanceTableDirectiveCtrl]);

    /** @ngInject */
    function DetailedAttendanceTableDirectiveCtrl($scope, attendanceService, authService,$document,_,utilService, MODULES) {

        var vm  = this;
        var loggedInUser = authService.getLoggedInUser();
        $scope.rows = {};
        $scope.rows.perPage = $scope.rowsPerPage;

        vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
        vm.isGroupAdmin = loggedInUser.isGroupAdmin;
        vm.hasPermission = utilService.hasPermission;
        vm.showSummary = utilService.hasPermission('4013');
        vm.showTotalHours = utilService.hasPermission('4014');
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);


        $scope.$on('$destroy',function (event) {
            $scope = null;
        });


        vm.getRowsPerPage = getRowsPerPage;
        vm.getDateList = getDateList;

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }

        function getDateList() {
            return $scope.dateList;
        }




        // function exportToPdf  () {
        //     var table = angular.element( $document[0].querySelector('#attendanceTable')).html();
        //     var mywindow = window.open('', 'new div', 'height=400,width=600');
        //
        //     mywindow.document.write('<html><head><title>Attendance Report</title>');
        //
        //     mywindow.document.write('<script src="../bower_components/angular/angular.js"></script>')
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css" />');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-select/dist/css/bootstrap-select.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-tagsinput/dist/bootstrap-tagsinput.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/main.css" />');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/styles.css"  >');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/angular-ui-switch/angular-ui-switch.css" />');
        //
        //     mywindow.document.write('</head><body><table id = "printTable" class="table" style="color: black!important;background-color: white!important;">');
        //     mywindow.document.write(table);
        //     mywindow.document.write('</table></body></html>');
        //
        //     mywindow.document.close();
        //     setTimeout(function(){mywindow.print();
        //         mywindow.close()},2000);
        //
        // };

        function exportToPdf() {
            var printContents = document.getElementById("attendanceDiv").innerHTML;
            var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
            popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 3mm;} table{border-collapse: collapse; border-spacing: 2px;} thead {display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
            popupWin.document.close();
            popupWin.print();
        }

        $scope.$on("printReport", function () {
            var printContents = document.getElementById("attendanceDiv").innerHTML;
            var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
            //popupWin.document.open();
            popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 3mm;} .list-avatar{border-radius: 50%;height: 30px;width: 30px;float: left;margin-top: 2px;} table{border-collapse: collapse; border-spacing: 2px;} thead {display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
            popupWin.document.close();
            popupWin.print();
        });

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('employeePictureAndInformation', function () {
            function link(scope,element,attributes) {
                scope.$on('$destroy',function (event) {
                    scope = null;
                })
            }
            return {
                restrict: 'E',
                scope: {
                    name            : "=",
                    pictureUrl      : "=",
                    departmentName  : "=",
                    designationName : "=",
                    id              : "=",
                    isClickable     : "=",
                    isNameChanged   : "=",
                    isDesignationChanged : "=",
                    isDepartmentChanged : "="
                },
                link:link,
                templateUrl: 'app/pages/directives/employeePictureAndInformationDirective/employeePictureAndInformation.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('EmployeeTypeAheadSearchCtrl',
            ['$scope', 'employeeService', EmployeeTypeAheadSearchCtrl]);

    /** @ngInject */
    function EmployeeTypeAheadSearchCtrl($scope, employeeService) {
        var vm = this;
        vm.selectEmployee = selectEmployee;

        $scope.searchEmployee = function (keyword) {
            return employeeService.searchByName(keyword.trim()).then(function (data) {
                return data;
            })
        };

        function selectEmployee(item) {
            if($scope.selectedEmployee)
                $scope.selectedEmployee = item;
            if($scope.selectMethod){
                $scope.selectMethod(item);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('employeeTypeAheadSearch', function () {
            return {
                restrict : 'E',
                // transclude: true,
                controller  : 'EmployeeTypeAheadSearchCtrl as vm',
                scope       : {
                    keyword          : '=',
                    isRequired       : '=',
                    showLabel        : '=',
                    selectMethod     : '=',
                    selectedEmployee : '=',
                    isHostSelection  : '=',
                },
                templateUrl : 'app/pages/directives/employeeTypeAheadSearch/employeeSearch.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('LeaveLateAbsentTableDirectiveCtrl',
            ['$scope','attendanceService', 'authService','$document','_', 'utilService',LeaveLateAbsentTableDirectiveCtrl]);

    /** @ngInject */
    function LeaveLateAbsentTableDirectiveCtrl($scope, attendanceService, authService,$document,_,utilService) {

        var vm  = this;

        $scope.rows = {};
        $scope.rows.perPage = $scope.rowsPerPage;

        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        vm.hasPermission = utilService.hasPermission;
        vm.showSummary = utilService.hasPermission('4013');
        vm.showTotalHours = utilService.hasPermission('4014');

        // vm.rowIndex = null;
        // vm.parentRowIndex = null;
        // vm.childRowIndex = null;

        vm.prepareDataForPagination = prepareDataForPagination;
        vm.reduceSelectedPaginationPage= reduceSelectedPaginationPage;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.getPaginationInfo = getPaginationInfo;

        // vm.parentRowIndexChange = parentRowIndexChange;
        // vm.childRowIndexChange = childRowIndexChange;


        vm.sortingMethods = {
            sortById : sortById,
            sortByName : sortByName,
            sortByDepartmentHierarchy : sortByDepartmentHierarchy,
            sortByDesignationHierarchy : sortByDesignationHierarchy,
            sortByShiftName : sortByShiftName

        };

        vm.paginateData = paginateData;
        vm.getDateList = getDateList;
        vm.shouldShowPaginationButton = shouldShowPaginationButton;

        function getDateList() {
            return $scope.dateList;
        }

        function prepareDataForPagination () {
            $scope.numberOfPages = Math.ceil($scope.allAttendanceData.length / parseInt($scope.rows.perPage));
            $scope.numberOfButtons = Array($scope.numberOfPages).fill(1);
            $scope.selectedPaginationPage = 0;
            paginateData(0);
        };


        var sortStatus = {
            key: "employeeIdentifier",
            order: "ascending"
        };

        function paginateData (index) {
            $scope.offset = index * parseInt($scope.rows.perPage);
            $scope.selectedPage = index;
        };

        function sortById() {
            if (sortStatus.key == "employeeIdentifier" && sortStatus.order == "ascending") {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, 'employeeIdentifier').reverse();
                paginateData($scope.selectedPage);
                sortStatus.key = "employeeIdentifier";
                sortStatus.order = "descending";
            } else {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, 'employeeIdentifier');
                paginateData($scope.selectedPage);
                sortStatus.key = "employeeIdentifier";
                sortStatus.order = "ascending";
            }
        }

        function sortByName() {
            if (sortStatus.key == "employeeName" && sortStatus.order == "ascending") {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, [function (employee) {
                    return employee.employeeName.toLowerCase();
                }]).reverse();
                paginateData($scope.selectedPage);
                sortStatus.key = "employeeName";
                sortStatus.order = "descending";
            } else {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, [function (employee) {
                    return employee.employeeName.toLowerCase();
                },['asc']]);
                paginateData($scope.selectedPage);
                sortStatus.key = "employeeName";
                sortStatus.order = "ascending";
            }
        }

        function sortByDepartmentHierarchy() {
            if (sortStatus.key ==="departmentHierarchy" && sortStatus.order === "ascending") {
                $scope.allAttendanceData = $scope.allAttendanceData.sort(function(a, b) {
                    return (a.departmentHierarchy===null)-(b.departmentHierarchy===null) || -(a.departmentHierarchy>b.departmentHierarchy)||+(a.departmentHierarchy<b.departmentHierarchy);
                });

                paginateData($scope.selectedPage);
                sortStatus.key = "departmentHierarchy";
                sortStatus.order = "descending";
            } else {
                $scope.allAttendanceData = $scope.allAttendanceData.sort(function (a,b) {
                    return (a.departmentHierarchy===null)-(b.departmentHierarchy===null) || +(a.departmentHierarchy>b.departmentHierarchy)||-(a.departmentHierarchy<b.departmentHierarchy);

                });
                paginateData($scope.selectedPage);
                sortStatus.key = "departmentHierarchy";
                sortStatus.order = "ascending";
            }
        }

        function sortByDesignationHierarchy() {
            if (sortStatus.key == "designationHierarchy" && sortStatus.order == "ascending") {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, 'designationHierarchy').reverse();
                paginateData($scope.selectedPage);
                sortStatus.key = "designationHierarchy";
                sortStatus.order = "descending";
            } else {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, 'designationHierarchy');
                paginateData($scope.selectedPage);
                sortStatus.key = "designationHierarchy";
                sortStatus.order = "ascending";
            }
        }

        function sortByShiftName() {
            if (sortStatus.key == "shiftName" && sortStatus.order == "ascending") {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, 'shiftName').reverse();
                paginateData($scope.selectedPage);
                sortStatus.key = "shiftName";
                sortStatus.order = "descending";
            } else {
                $scope.allAttendanceData = _.sortBy($scope.allAttendanceData, 'shiftName');
                paginateData($scope.selectedPage);
                sortStatus.key = "shiftName";
                sortStatus.order = "ascending";
            }
        }

        function reduceSelectedPaginationPage() {
            $scope.selectedPage = $scope.selectedPage === 0 ? 0 : $scope.selectedPage - 1;
            $scope.offset = $scope.offset * parseInt($scope.rows.perPage);
        }

        function increaseSelectedPaginationPage() {
            $scope.selectedPage = $scope.selectedPage === vm.numberOfButtons.length - 1 ? $scope.selectedPage : $scope.selectedPage +1;
            vm.offset = $scope.selectedPage * parseInt($scope.rows.perPage);
        }

        // function exportToPdf  () {
        //     var table = angular.element( $document[0].querySelector('#attendanceTable')).html();
        //     var mywindow = window.open('', 'new div', 'height=400,width=600');
        //
        //     mywindow.document.write('<html><head><title>Attendance Report</title>');
        //
        //     mywindow.document.write('<script src="../bower_components/angular/angular.js"></script>')
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css" />');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-select/dist/css/bootstrap-select.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-tagsinput/dist/bootstrap-tagsinput.css"/>');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/main.css" />');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/styles.css"  >');
        //     mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/angular-ui-switch/angular-ui-switch.css" />');
        //
        //     mywindow.document.write('</head><body><table id = "printTable" class="table" style="color: black!important;background-color: white!important;">');
        //     mywindow.document.write(table);
        //     mywindow.document.write('</table></body></html>');
        //
        //     mywindow.document.close();
        //     setTimeout(function(){mywindow.print();
        //         mywindow.close()},2000);
        //
        // };


        function shouldShowPaginationButton(index) {
            return $scope.selectedPage <= 2 ? index <= 5 :
                ($scope.selectedPage <= $scope.numberOfButtons.length && $scope.selectedPage > $scope.numberOfButtons.length - 6 ?
                    index > $scope.numberOfButtons.length - 7 :
                    index >= $scope.selectedPaginationPage - 2 && index <= $scope.selectedPage + 3);
        }


        function getPaginationInfo() {
            if($scope.offset + parseInt($scope.rows.perPage) >= $scope.allAttendanceData.length){
                return $scope.allAttendanceData.length;
            }else {
                return $scope.offset + parseInt($scope.rows.perPage);
            }
        }
        function parentRowIndexChange(rowIndex){
            vm.childRowIndex = vm.parentRowIndex = rowIndex % 2;
        }
        function childRowIndexChange(childLength, rowIndex, change){
            if(change === 1 ) {
                vm.childRowIndex = vm.childRowIndex === 0 ? 1 : 0;
                if( childLength - 1 === rowIndex )
                    vm.childRowIndex = vm.parentRowIndex;
            }
            return vm.childRowIndex;
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('leaveLateAbsentTable', function () {
            return {
                restrict: 'E',
                controller: 'LeaveLateAbsentTableDirectiveCtrl as vm',
                scope:{
                    allAttendanceData   : "=",
                    numberOfPages       : "=",
                    numberOfButtons     : "=",
                    selectedPage        : "=",
                    isDataLoaded        : "=",
                    rowsPerPage         : "=",
                    offset              : "=",
                    excelUrl            : "=",
                    type                : "@",
                },
                templateUrl: 'app/pages/directives/leaveLateAbsentTable/leaveLateAbsentTable.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('locationDeviationTable', function () {
            function link(scope) {
                scope.$on('$destroy', function () { scope = null; });
            }
            return {
                restrict: 'E',
                controller: 'LocationDeviationTableDirectiveCtrl as vm',
                scope: {
                    allAttendanceData: "=",
                    dateList: "=",
                    selectedPage: "=",
                    isDataLoaded: "=",
                    startOfDayList: "=",
                    showImage: "=",
                    showLineManager: "="
                },
                link: link,
                templateUrl: 'app/pages/directives/locationDeviationTable/locationDeviationTable.html'
            };
        });
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('LocationDeviationTableDirectiveCtrl',
            ['$scope','authService','utilService', function ($scope, authService, utilService) {
                var vm = this;
                $scope.rows = {};
                $scope.rows.perPage = $scope.rowsPerPage;

                vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
                vm.isGroupAdmin   = authService.getLoggedInUser().isGroupAdmin;
                vm.hasPermission  = utilService.hasPermission;

                vm.getRowsPerPage = function () { return Number(utilService.getRowsPerPage()); };
                vm.getDateList    = function () { return $scope.dateList; };

                $scope.$on('$destroy', function () { $scope = null; });
            }]);
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('memberPictureAndInformation', function () {
            function link(scope,element,attributes) {
                scope.$on('$destroy',function (event) {
                    scope = null;
                })
            }
            return {
                restrict: 'E',
                scope: {
                    name            : "=",
                    pictureUrl      : "=",
                    mobileNumber    : "=",
                    id              : "=",
                    package         : "=",
                },
                link:link,
                templateUrl: 'app/pages/directives/memberPictureAndInformationDirective/memberPictureAndInformation.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('MonthlyReportDirectiveCtrl',
            ['$uibModal','authService','attendanceService','_','departmentService','officeService','toastr','designationService','employmentTypeService','monthlyTimeSheetApproverService','$q','utilService','GENDER', '$scope','$state','$sce', 'MODULES',MonthlyReportDirectiveCtrl]);
    /** @ngInject */
    function MonthlyReportDirectiveCtrl($uibModal,authService,attendanceService,_,departmentService,officeService,toastr,designationService,employmentTypeService,monthlyTimeSheetApproverService,$q,utilService, GENDER, $scope,$state,$sce, MODULES) {

        var vm  = this;
        var loggedInUser = authService.getLoggedInUser();

        $scope.rows = {};
        $scope.rows.perPage = $scope.rowsPerPage;
        vm.state = $state.current.title
        vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
        vm.isGroupAdmin = loggedInUser.isGroupAdmin;
        vm.hasPermission = utilService.hasPermission;
        vm.showSummary = utilService.hasPermission('4013');
        vm.showTotalHours = utilService.hasPermission('4014');
        vm.showAIInsights = utilService.hasPermission('4027');
        vm.loggedInUser = loggedInUser;
        vm.currentYear = new Date().getFullYear();
        vm.currentMonth = new Date().getMonth()+1;
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        vm.openTimeSheetApproveModal = openTimeSheetApproveModal;
        vm.getDateList = getDateList;
        vm.getRowsPerPage = getRowsPerPage;

        // Initialize AI Insights state
        $scope.showAiInsights = false;

        // Modal functions
        $scope.showAiModal = false;

        $scope.openAIInsightsModal = function() {
            $scope.showAiModal = true;
        };

        $scope.closeAIInsightsModal = function() {
            $scope.showAiModal = false;
        };

        // Format AI analysis text with proper HTML formatting
        $scope.formatAIText = function(text) {
            if (!text) return '';

            var formattedText = text
                // Convert **bold** to HTML strong tags
                .replace(/\*\*(.*?)\*\*/g, '<strong style="color: #2c3e50; font-weight: 600;">$1</strong>')
                // Make "Action Item:" bold
                .replace(/Action Item:/g, '<strong>Action Item:</strong>')
                // Convert section headers (lines with ** at start and end)
                .replace(/^\*\*(.*?)\*\*$/gm, '<h5 style="color: #34495e; font-weight: 700; margin: 20px 0 10px 0; border-bottom: 2px solid #3498db; padding-bottom: 5px;">$1</h5>')
                // Convert bullet points starting with *
                .replace(/^\* (.*?)$/gm, '<div style="margin: 8px 0; padding-left: 20px; position: relative;"><span style="position: absolute; left: 0; color: #3498db; font-weight: bold;">•</span>$1</div>')
                // Convert numbered lists
                .replace(/^(\d+)\. (.*?)$/gm, '<div style="margin: 8px 0; padding-left: 25px; position: relative;"><span style="position: absolute; left: 0; color: #3498db; font-weight: bold;">$1.</span>$2</div>')
                // Add spacing between sections
                .replace(/\n\n/g, '<br><br>')
                // Convert single line breaks
                .replace(/\n/g, '<br>');

            return $sce.trustAsHtml(formattedText);
        };


        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }

        function getDateList() {
            return $scope.dateList;
        }

        $scope.$on("printReport", function () {
            var printContents = document.getElementById("attMonthlyReport").innerHTML;
            var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
            popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 3mm;} table{border-collapse: collapse; border-spacing: 2px;} thead {display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
            popupWin.document.close();
            popupWin.print();
        });

        function openTimeSheetApproveModal(applicationId) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/directives/monthlyAttendanceTable/monthlyTimeSheetModals/approve.modal.html',
                size : 'md',
                controller : 'ApproveMonthlyTimeSheetModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    applicationId : function () {
                        return applicationId;
                    }
                }
            }).result.then(function () {
                $scope.findTimesheetApproval();
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('monthlyTable', function () {
            return {
                restrict: 'E',
                controller: 'MonthlyReportDirectiveCtrl as vm',
                scope:{
                    allAttendanceData       : "=",
                    dateList                : "=",
                    numberOfPages           : "=",
                    numberOfButtons         : "=",
                    selectedPage            : "=",
                    isDataLoaded            : "=",
                    rowsPerPage             : "=",
                    excelUrl                : "=",
                    pdfUrl                  : "=",
                    showImage               : "=",
                    selectedYear            : "=",
                    selectedMonth           : "=",
                    timesheetApproval       : "=",
                    findTimesheetApproval   : "=",
                    time                    : "=",
                    type                    : '@',
                    startOfDayList          : "=",
                    overallSummary          : "=",
                    detailedView            : "=",
                    showLineManager         : "=",
                    aiAnalysis              : "=",
                    aiAnalysisLoading       : "="
                },
                templateUrl: 'app/pages/directives/monthlyAttendanceTable/monthlyReportDirective.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('payrollFilter', function () {
            return {
                restrict : 'E',
                // transclude: true,
                controller  : 'PayrollFilterDirectiveCtrl as vm',
                scope       : {
                    hide                        : "=",
                    searchMethod                : "=",
                    type                        : "@",
                    success                     : "=",
                    excelUrl                    : "=",
                    pdfUrl                      : "=",
                    verticalPdfUrl              : "=",
                    showFilters                 : "=",
                    isDataLoaded                : "=",
                    selectedPage                : "=",
                    hideDownload                : "=",
                    hidePrint                   : "=",
                    hideSortBy                  : "=",
                    timesheetApprovalStatusHtml : "=",
                    timesheetApplicationId      : "=",
                    showTimesheetApprovalButton : "=",
                    subtract                    : "=",
                    config                      : "<",
                    addBtnName                  : "@",
                    addBtnSref                  : "@",
                    addBtnAction                : "=",
                    uploadBtnName               : "@",
                    downloadDemoExcelBtnName    : "@",
                    downloadDemoExcelBtnSref    : "@",
                    uploadBtnSref               : "@",
                    deleteBtnActive             : "=",
                    excelUploadMethod           : "=",
                    downloadDemoExcelBtnUrl     : "="
                },
                templateUrl : 'app/pages/directives/payrollFilter/filters.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('PayrollFilterDirectiveCtrl',
            ['$scope', '$state','$stateParams', 'editableOptions', 'editableThemes', 'payrollSettingsService', 'departmentService', 'shiftGroupService', 'designationService', 'employmentTypeService', 'officeService', 'authService', 'workplaceService', 'employeeService', 'dashboardService', 'toastr', 'utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS', 'analyticsService', 'ANALYTICS_CONSTANT', PayrollFilterDirectiveCtrl]);

    /** @ngInject */
    function PayrollFilterDirectiveCtrl($scope, $state,$stateParams, editableOptions, editableThemes, payrollSettingsService, departmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService, employeeService, dashboardService, toastr, utilService, $timeout, _, GENDER, EMPLOYEE_STATUS, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        var loggedInUser = authService.getLoggedInUser();
        vm.isGroupAdmin = loggedInUser.isGroupAdmin;
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.maxDateForDailyReport = new Date();
        vm.hide = {
            departmentFilter: getFilterHideValue('departmentFilter'),
            designationFilter: getFilterHideValue('designationFilter'),
            shiftGroupFilter: getFilterHideValue('shiftGroupFilter'),
            genderFilter: getFilterHideValue('genderFilter'),
            employmentTypeFilter: getFilterHideValue('employmentTypeFilter'),
            workplaceFilter: getFilterHideValue('workplaceFilter')
        };

        vm.searchFilter = "";
        vm.officeList = [];
        vm.departmentList = [];
        vm.componentList = [];
        vm.absenceTypeList = [];
        vm.designationList = [];
        vm.workplaceList = [];
        vm.shiftGroupList = [];
        vm.companyList = [];
        vm.genderList = angular.copy(GENDER);
        vm.statusList = angular.copy(EMPLOYEE_STATUS);
        vm.allDevice = [];
        vm.selectedDevice = [];
        vm.employmentTypeList = [];
        vm.search = {};
        vm.search.searchName = "";
        vm.search.minAmount = null;
        vm.search.maxAmount = null;
        vm.search.selectedComponentList = [];
        vm.search.selectedAbsenceTypeList = [];
        vm.search.selectedDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedEmploymentTypeList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedGenderList = [];
        vm.search.selectedStatusList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedLineManagerList = [];
        vm.search.selectedHrManagerList = [];
        vm.search.componentList = [];
        vm.search.absenceTypeList = [];
        vm.search.departmentList = [];
        vm.search.designationList = [];
        vm.search.employmentTypeList = [];
        vm.search.shiftGroupList = [];
        vm.search.genderList = GENDER;
        vm.search.statusList = EMPLOYEE_STATUS;
        vm.search.workplaceList = [];
        vm.search.lineManagerList = [];
        vm.search.hrManagerList = [];
        vm.search.officeList = [];
        vm.showFilters = false;
        vm.isCompanyAdmin = false;
        vm.showLineManagerFilter = loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager;
        vm.monthList = [{id: 0, name: 'January'}, {id: 1, name: 'February'}, {id: 2, name: 'March'}, {
            id: 3,
            name: 'April'
        }, {id: 4, name: 'May'}, {id: 5, name: 'June'},
            {id: 6, name: 'July'}, {id: 7, name: 'August'}, {id: 8, name: 'September'}, {
                id: 9,
                name: 'October'
            }, {id: 10, name: 'November'}, {id: 11, name: 'December'}];
        // vm.selectedMonth = [];
        vm.selectedMonthFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.selectedMonthTo = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.selectedMonthSalary = new Date(new Date().getFullYear(), new Date().getMonth()-1, 1);
        vm.selectedMonthComparison = new Date(new Date().getFullYear(), new Date().getMonth()-2, 1);
        vm.yearList = [];
        // vm.selectedYear = [];
        vm.selectedMonthDisplay = "";
        vm.sortKeys = {
            'Report Position': {value: 'reportPosition', order: 'asc', selected: true},
            'ID': {value: 'empOfficeId', order: 'asc', selected: false},
            'Name': {value: 'empName', order: 'asc', selected: false},
            'Department': {value: 'departmentName', order: 'asc', selected: false},
            'Designation': {value: 'designationName', order: 'asc', selected: false},
            'Employment Type': {value: 'employmentTypeName', order: 'asc', selected: false},
            'Shift Group': {value: 'shiftGroupName', order: 'asc', selected: false},
            'Workplace': {value: 'workplaceName', order: 'asc', selected: false},


        };
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.stateName = $state.current.name;

        vm.monthPickerFrom = {};
        vm.monthPickerFrom.opened = false;
        vm.monthPickerFrom.format = "MMM yyyy";
        vm.monthPickerFrom.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.monthPickerTo = {};
        vm.monthPickerTo.opened = false;
        vm.monthPickerTo.format = "MMM yyyy";
        vm.monthPickerTo.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.monthPickerSalary = {};
        vm.monthPickerSalary.opened = false;
        vm.monthPickerSalary.format = "MMM yyyy";
        vm.monthPickerSalary.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.monthPickerComparison = {};
        vm.monthPickerComparison.opened = false;
        vm.monthPickerComparison.format = "MMM yyyy";
        vm.monthPickerComparison.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode: 'month',
            maxMode: 'year'
        };

        function getFilterHideValue(value) {
            if (vm.isGroupAdmin)
                return true;
            if ($scope.hide != null) {
                if ($scope.hide.includes(value))
                    return true;
            }
            return false;
        }

        vm.searchSalaryProcess = searchSalaryProcess;
        vm.populateFilterModels = populateFilterModels;
        vm.populateOfficeFilter = populateOfficeFilter;
        vm.populateComponentFilter = populateComponentFilter;
        vm.populateAbsentTypeComponentFilter = populateAbsentTypeComponentFilter;
        vm.updateSortKey = updateSortKey;
        vm.openmonthPickerFrom = openmonthPickerFrom;
        vm.openmonthPickerTo = openmonthPickerTo;
        vm.openmonthPickerSalary = openmonthPickerSalary;
        vm.openmonthPickerComparison = openmonthPickerComparison;
        vm.exportAsExcel = exportAsExcel;
        vm.exportAsPdf = exportAsPdf;
        vm.getAllOnEmptySearchKeyword = getAllOnEmptySearchKeyword;
        vm.excelUploadMethod = $scope.excelUploadMethod;
        vm.downloadSampleExcel = downloadSampleExcel;
        vm.addNewComponent = addNewComponent;
        vm.searchByNameOrId = searchByNameOrId;

        function init() {
            //Setting status filter to active
            vm.search.selectedStatusList.push({id: 1});
            vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;

            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            // For component
            payrollSettingsService.getPayrollSettingsByComponentTypeAndStatus([5,6,7], [1,0]).then(function (data) {
                vm.componentList = sortCollectionByName(data.officePayrollComponents);
                vm.search.componentList = angular.copy(vm.componentList);
            }, function (message) {
            });
            // for absenceType
            payrollSettingsService.getPayrollSettingsByComponentTypeAndStatus([8, 9], [1,0]).then(function (data) {
                vm.absenceTypeList = sortCollectionByName(data.officePayrollComponents);
                vm.search.absenceTypeList = angular.copy(vm.absenceTypeList);
            }, function (message) {
            });
            departmentService.getAllDepartments().then(function (departmentList) {
                vm.departmentList = sortCollectionByName(mapOfficeNameIntoList(departmentList));
                vm.search.departmentList = angular.copy(vm.departmentList);
            }, function (message) {
            });

            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = sortCollectionByName(mapOfficeNameIntoList(designationList));
                vm.search.designationList = angular.copy(vm.designationList);
            }, function (message) {
            });

            shiftGroupService.getAllShiftGroups(true).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(mapshiftGroupOfficeNameIntoList(shiftGroupList));
                vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            }, function (message) {
            });
            if (vm.isCompanyAdmin || vm.isGroupAdmin) {
                officeService.getAllOffices(true).then(function (officeList) {
                    vm.officeList = angular.copy(officeList);
                    vm.search.officeList = angular.copy(officeList);
                    if ($state.current.name == 'attendanceReport.detailedAttendanceReport' && $state.params.officeId) {
                        vm.search.selectedOfficeList = [];
                        for (var i = 0; i < vm.search.officeList.length; i++) {
                            if (vm.search.officeList[i].id == $state.params.officeId) {
                                vm.search.officeList[i].ticked = true;
                                vm.search.selectedOfficeList.push({id: vm.search.officeList[i].id, ticked: true});
                                break;
                            }
                        }
                    }
                });
            }
            if (vm.isGroupAdmin) {
                dashboardService.getCompanyList().then(function (data) {
                    vm.companyList = data;
                })
            }

            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.employmentTypeList = sortCollectionByName(mapOfficeNameIntoList(employmentTypeList));
                vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            }, function (message) {
                console.error("Failed to fetch designation category list : " + message);
            });

            workplaceService.getAllWorkplaces().then(function (data) {
                vm.workplaceList = sortCollectionByName(mapOfficeNameIntoList(data));
                vm.search.workplaceList = angular.copy(vm.workplaceList);
            }, function (message) {
                console.error("Failed to fetch workplace list: " + message);
            });

            employeeService.getFilteredEmployeeNames({
                officeIdList: loggedInUser.office.id,
                status: 1,
                onlyLineManagers: true
            }).then(function (data) {
                vm.search.lineManagerList = data.employees;
            }, function (message) {

            });

            employeeService.getFilteredEmployeeNames({
                officeIdList: loggedInUser.office.id,
                status: 1,
                onlyHrManagers: true
            }).then(function (data) {
                vm.search.hrManagerList = data.employees;
            }, function (message) {

            });

            searchSalaryProcess()

        };

        init();

        function mapOfficeNameIntoList(objectList) {
            if (vm.isCompanyAdmin) {
                return objectList.map(function (object) {
                    object.officeName = officeService.getOfficeNameById(object.officeId);
                    return object;
                });
            }
            return objectList;
        }


        function mapshiftGroupOfficeNameIntoList(objectList) {
            if (vm.isCompanyAdmin) {
                return objectList.map(function (object) {
                    object.officeName = officeService.getOfficeNameById(object.officeId);
                    object.officeId = object.officeId;
                    return object;
                });
            }
            return objectList;
        }

        function searchSalaryProcess() {
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search)
            utilService.setRowsPerPage(vm.rowsPerPage);
            var sortKeyAndOrder = getSortKeyAndOrder();
            var searchParameters =
                {
                    designationId: vm.search.selectedDesignationList.map(getId),
                    departmentId: vm.search.selectedDepartmentList.map(getId),
                    shiftGroupId: vm.search.selectedShiftGroupList.map(getId),
                    genderId: vm.search.selectedGenderList.map(getId),
                    employeeName: vm.search.searchName,
                    minAmount: vm.search.minAmount,
                    maxAmount: vm.search.maxAmount,
                    companyId: (vm.isCompanyAdmin || vm.isGroupAdmin) ? vm.search.selectedCompanyList.map(getId) : [authService.getMyOfficeInformation().companyId],
                    officeId: (vm.isCompanyAdmin || vm.isGroupAdmin) ? vm.search.selectedOfficeList.map(getId) : [authService.getLoggedInUser().office.id],
                    employmentTypeId: vm.search.selectedEmploymentTypeList.map(getId),
                    workplaceId: vm.search.selectedWorkplaceList.map(getId),
                    lineManagerId: vm.search.selectedLineManagerList.map(getId),
                    hrManagerId: vm.search.selectedHrManagerList.map(getId),
                    status: vm.search.selectedStatusList.map(getId),
                    pageNumber: 0,
                    perPage: utilService.getRowsPerPage(),
                    sortKey: sortKeyAndOrder.key,
                    order: sortKeyAndOrder.order
                };

            if ($scope.type === "absentLwp") {
                searchParameters.componentIds = vm.search.selectedAbsenceTypeList.map(getId)
            } else if ($scope.type === "additional") {
                searchParameters.componentIds = vm.search.selectedComponentList.map(getId)
            }
            if (vm.selectedMonthFrom != null) {
                searchParameters.fromYear = vm.selectedMonthFrom.getFullYear();
                searchParameters.fromMonth = vm.selectedMonthFrom.getMonth() + 1;
            } else {
                return toastr.error("Please select month and year");
            }
            if (vm.selectedMonthTo != null) {
                searchParameters.toYear = vm.selectedMonthTo.getFullYear();
                searchParameters.toMonth = vm.selectedMonthTo.getMonth() + 1;
            } else {
                return toastr.error("Please select month and year");
            }
            if (vm.selectedMonthSalary != null) {
                searchParameters.salaryYear = vm.selectedMonthSalary.getFullYear();
                searchParameters.salaryMonth = vm.selectedMonthSalary.getMonth() + 1;
                if ($scope.config.monthYearPickerComparison.disable){
                    vm.selectedMonthComparison = new Date( vm.selectedMonthSalary.getFullYear(), vm.selectedMonthSalary.getMonth() -1, 1);
                }

            } else {
                return toastr.error("Please select month and year");
            }
            if (vm.selectedMonthComparison != null) {
                searchParameters.comparisonYear = vm.selectedMonthComparison.getFullYear();
                searchParameters.comparisonMonth = vm.selectedMonthComparison.getMonth() + 1;
            } else {
                return toastr.error("Please select month and year");
            }
            $scope.searchMethod(searchParameters);
        }

        function getId(object) {
            return object.id;
        }

        function getCurrentMonthInString() {
            var d = new moment().format("MMMM");
            return d;
        }

        function populateFilterModels() {
            var selectedOfficeIds = vm.search.selectedOfficeList.map(function (office) {
                return office.id;
            });
            if (selectedOfficeIds.length === 0) {
                clearFilters();
            } else {
                if (vm.isGroupAdmin) {
                    var applicableCompanyIds = vm.search.selectedOfficeList.map(function (office) {
                        return office.companyId;
                    });
                    vm.search.selectedCompanyList = [];
                    for (var i = 0; i < vm.companyList.length; i++) {
                        vm.companyList[i].ticked = false;
                        if (applicableCompanyIds.includes(vm.companyList[i].id)) {
                            vm.companyList[i].ticked = true;
                            vm.search.selectedCompanyList.push({id: vm.companyList[i].id});
                        }
                    }

                }
                vm.search.departmentList = filterByOfficeId(vm.departmentList, selectedOfficeIds);
                vm.search.designationList = filterByOfficeId(vm.designationList, selectedOfficeIds);
                vm.search.shiftGroupList = filterByOfficeId(vm.shiftGroupList, selectedOfficeIds);
                vm.search.workplaceList = filterByOfficeId(vm.workplaceList, selectedOfficeIds);
                vm.search.employmentTypeList = filterByOfficeId(vm.employmentTypeList, selectedOfficeIds);
            }
        }

        function clearFilters() {
            vm.search.departmentList = angular.copy(vm.departmentList);
            vm.search.designationList = angular.copy(vm.designationList);
            vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            vm.search.workplaceList = angular.copy(vm.workplaceList);
            vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            vm.search.selectedDepartmentList = [];
            vm.search.selectedDesignationList = [];
            vm.search.selectedShiftGroupList = [];
            vm.search.selectedWorkplaceList = [];
            vm.search.selectedEmploymentTypeList = [];
        }

        function populateOfficeFilter() {
            var selectedCompanyIds = vm.search.selectedCompanyList.map(function (company) {
                return company.id;
            });
            if (selectedCompanyIds.length === 0) {
                vm.search.officeList = [];
            } else {
                vm.search.officeList = filterByCompanyId(vm.officeList, selectedCompanyIds);
            }
        }

        function populateComponentFilter() {
            var selectedComponentIds = vm.search.selectedComponentList.map(function (component) {
                return component.id;
            });
            if (selectedComponentIds.length === 0) {
                vm.search.componentList = [];
            } else {
                vm.search.componentList = filterByComponentId(vm.componentList, selectedComponentIds);
            }
        }

        function populateAbsentTypeComponentFilter() {
            var selectedAbsenceTypeComponentIds = vm.search.selectedAbsenceTypeList.map(function (component) {
                return component.id;
            });
            if (selectedAbsenceTypeComponentIds.length === 0) {
                vm.search.absenceTypeList = [];
            } else {
                vm.search.absenceTypeList = filterByComponentId(vm.absenceTypeList, selectedAbsenceTypeComponentIds);
            }
        }


        function filterByOfficeId(modelArray, officeIds) {
            return modelArray.filter(function (model) {
                return officeIds.includes(model.officeId);
            })
        }


        function filterByCompanyId(modelArray, companyIds) {
            return modelArray.filter(function (model) {
                return companyIds.includes(model.companyId);
            })
        }

        function filterByComponentId(modelArray, componentIds) {
            return modelArray.filter(function (model) {
                return componentIds.includes(model.id);
            })
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection, function (item) {
                return item.name.toLowerCase();
            }, ['asc']);
        }

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            searchSalaryProcess();
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for (var i = 0; i < keys.length; i++) {
                if (vm.sortKeys[keys[i]].selected == true) {
                    return {key: vm.sortKeys[keys[i]].value, order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function openmonthPickerFrom() {
            vm.monthPickerFrom.opened = true;
        }

        function openmonthPickerTo() {
            vm.monthPickerTo.opened = true;
        }

        function openmonthPickerSalary() {
            vm.monthPickerSalary.opened = true;
        }

        function openmonthPickerComparison() {
            vm.monthPickerComparison.opened = true;
        }

        $scope.reportPrint = function () {
            $scope.$emit("printEvent");
        }

        $scope.openTimeSheetApproveModal = function (applicationId) {
            $scope.$emit("approveTimesheet", applicationId);
        }

        function exportAsExcel() {
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Excel In ', ANALYTICS_CONSTANT.downloadExcel)
            if ($scope.excelUrl != null && $scope.excelUrl.trim() !== "") {
                window.open($scope.excelUrl, '_blank', '');
            }
        }

        function exportAsPdf(orientation) {
            if (orientation === "H") {
                if ($scope.pdfUrl != null && $scope.pdfUrl.trim() !== "") {
                    var url = $scope.pdfUrl + "&sortKey=" + getSortKeyAndOrder().key + "&order=" + getSortKeyAndOrder().order + "&pageNumber=" + $scope.selectedPage + "&perPage=" + vm.rowsPerPage;
                    window.open(url, '_blank', '');
                }
            } else if (orientation === "V") {
                if ($scope.verticalPdfUrl != null && $scope.verticalPdfUrl.trim() !== "") {
                    window.open($scope.verticalPdfUrl, '_blank', '');
                }
            }
        }

        function downloadSampleExcel() {
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Sample Excel', ANALYTICS_CONSTANT.downloadExcel)
            window.open($scope.downloadDemoExcelBtnUrl, '_blank', '');
        }

        function getAllOnEmptySearchKeyword() {
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search)
            if (vm.search.searchName === "" || vm.search.searchName.length === 0) searchSalaryProcess();
            if (vm.search.minAmount === 0 || vm.search.minAmount === null) searchSalaryProcess();
            if (vm.search.maxAmount === 0 || vm.search.maxAmount === null) searchSalaryProcess();
        }

        $scope.$watch('vm.monthPickerFrom.opened', function (newVal, oldVal) {
            if (!newVal && $scope.success) {
                searchSalaryProcess();
            }
        });
        $scope.$watch('vm.monthPickerTo.opened', function (newVal, oldVal) {
            if (!newVal  && $scope.success) searchSalaryProcess();
        })
        $scope.$watch('vm.monthPickerSalary.opened', function (newVal, oldVal) {
            if (!newVal && $scope.success) searchSalaryProcess();
        });

        $scope.$watch('vm.monthPickerComparison.opened', function (newVal, oldVal) {
            if (!newVal  && $scope.success) searchSalaryProcess();
        });

        function addNewComponent() {
            $scope.addBtnAction();
        }

        function searchByNameOrId(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search)
            searchSalaryProcess();
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main')
        .controller('SearchPageTopCtrl',
            ['$scope', 'employeeService', SearchPageTopCtrl]);

    /** @ngInject */
    function SearchPageTopCtrl($scope, employeeService) {
        var vm = this;
        vm.selectEmployee = selectEmployee;
        vm.resultFound = false;
        vm.isExistKeyword = false;

        $scope.searchEmployee = function (keyword) {
            vm.isExistKeyword = true;
            return employeeService.searchByNameOrId(keyword.trim()).then(function (data) {
                if (data.length > 0)
                    vm.resultFound = true;
                else
                    vm.resultFound = false
                return data;
            })
        };

        function selectEmployee(item) {
            if ($scope.selectedEmployee)
                $scope.selectedEmployee = item;
            if ($scope.selectMethod) {
                $scope.selectMethod(item);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('searchPageTop', function () {
            return {
                restrict : 'E',
                // transclude: true,
                controller  : 'SearchPageTopCtrl as vm',
                scope       : {
                    keyword          : '=',
                    isRequired       : '=',
                    showLabel        : '=',
                    selectMethod     : '=',
                    selectedEmployee : '=',
                    isHostSelection  : '=',
                },
                templateUrl : 'app/pages/directives/searchPageTop/searchPageTop.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('vehicleInfoDirective', function () {
            function link(scope,element,attributes) {
                scope.$on('$destroy',function (event) {
                    scope = null;
                })
            }
            return {
                restrict: 'E',
                scope: {
                    vehicleNumber   : "=",
                    vehicleType     : "="
                },
                link:link,
                templateUrl: 'app/pages/directives/vehicleInfoDirective/vehicleInfoDirective.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .directive('visitorPictureAndInformation', function () {
            function link(scope,element,attributes) {
                scope.$on('$destroy',function (event) {
                    scope = null;
                })
            }
            return {
                restrict: 'E',
                scope: {
                    name            : "=",
                    pictureUrl      : "=",
                    visitPurpose    : "=",
                    companyName     : "=",
                    id              : "=",
                    isClickable     : "=",
                    isNameChanged   : "=",
                    isCompanyNameChanged : "=",
                    isVisitPurposeChanged : "="
                },
                link:link,
                templateUrl: 'app/pages/directives/visitorPictureAndInformation/visitorPictureAndInformation.html',
            }
        })
})();
(function () {
  'use strict';

  angular
    .module('InovaceClientApp.pages.main.billing')
    .controller('BillingCtrl', [
      '$scope', '$window', '$rootScope', 'subscriptionGateService', 'authService',
      function ($scope, $window, $rootScope, subscriptionGateService, authService) {

        // 1) External payment URL
        $scope.externalUrl = (subscriptionGateService && subscriptionGateService.getBillingUrl
                                 ? subscriptionGateService.getBillingUrl()
                                 : null);

        $scope.payUrl = (subscriptionGateService && subscriptionGateService.paymentUrl) || $scope.externalUrl;

        // 2) Live subscription status
        $scope.status = (subscriptionGateService && subscriptionGateService.status) || {};

        // 3) Last payment date (ms since epoch)
        $scope.lastPaymentDate = (subscriptionGateService && subscriptionGateService.getLastPaymentDate
                                   ? subscriptionGateService.getLastPaymentDate()
                                   : null);

        // 4) Billing due date (ms since epoch)
        $scope.dueDateMs = (subscriptionGateService && subscriptionGateService.getBillingDueDate
                                   ? subscriptionGateService.getBillingDueDate()
                                   : null);

        // 5) User privilege functions
        $scope.getUser = function() {
          return $rootScope.loggedInUser ||
                 (authService && authService.getLoggedInUser && authService.getLoggedInUser()) ||
                 {};
        };

        $scope.isPrivileged = function() {
          var u = $scope.getUser();
          return !!(u.isAdmin || u.isHrManager);
        };

        // keep status in sync if the service updates in-place
        $scope.$watch(function () { return subscriptionGateService.status; }, function (s) {
          $scope.status = s || {};
        }, true);

        // sync last payment date when service updates
        $scope.$watch(function () {
          return subscriptionGateService.getLastPaymentDate
                 ? subscriptionGateService.getLastPaymentDate()
                 : null;
        }, function (v) {
          $scope.lastPaymentDate = v;
        });

        // sync due date when service updates
        $scope.$watch(function () {
          return subscriptionGateService.getBillingDueDate
                 ? subscriptionGateService.getBillingDueDate()
                 : null;
        }, function (v) {
          $scope.dueDateMs = v;
        });

        // (optional) merge rootScope status
        $scope.$watch(function () { return $rootScope.subscriptionStatus; }, function (s) {
          if (s) angular.extend($scope.status, s);
        }, true);

        // 6) button behavior (new tab + security) - only for privileged users
        $scope.payNow = function ($event) {
          if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
          }
          // Only allow privileged users to click
          if (!$scope.isPrivileged()) {
            return;
          }
          var url = $scope.payUrl || $scope.externalUrl;
          var win = $window.open(url, '_blank');
          if (win) { try { win.opener = null; } catch (e) {} }
        };

//        if (subscriptionGateService && subscriptionGateService.refresh) {
//          subscriptionGateService.refresh();
//        }
      }
    ]);
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.companies')
        .controller('CompaniesCtrl', ['$uibModal','companyService', CompaniesCtrl]);

    /** @ngInject */
    function CompaniesCtrl($uibModal,companyService) {

        var vm = this;

        vm.allCompanies = null;

        vm.openCompanyEditModal = openCompanyEditModal;
        vm.openCompanyCreateModal = openCompanyCreateModal;

        init();

        function init() {
            getAllCompanies();
        }

        function getAllCompanies() {
            companyService.getAllCompanies(true).then(onCompanyFetchSuccess, onCompanyFetchFailure);
        }

        function onCompanyFetchSuccess(data) {
            vm.allCompanies = data;
        }

        function onCompanyFetchFailure(message) {
            console.error('Company Fetching failed error: ' + message);
        }

        function openCompanyCreateModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/companies/createCompany/createCompany.modal.html',
                size: 'sm',
                controller : 'CreateCompanyModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function(updatedCompanyList) {
                vm.allCompanies = updatedCompanyList;
            }, function() {
                console.error("failed to create company");
            });
        }

        function openCompanyEditModal(id, name) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/companies/editCompany/editCompany.modal.html',
                size:'sm',
                controller : 'EditCompanyModalCtrl',
                controllerAs : "vm",
                backdrop : 'static',
                resolve : {
                    name : function () {
                        return name;
                    },
                    cId: function () {
                        return id;
                    }
                }
            }).result.then(function(updatedCompanyList) {
                vm.allCompanies = updatedCompanyList;
            }, function() {
                console.error("company edit failed");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('DashboardCtrl', [
            '$scope', '$interval', '$timeout', '$window',
            'authService', '_', 'dashboardService', 'holidayService',
            'workplaceService', 'employmentTypeService', 'subsidiaryService',
            'toastrService', 'specialDayService', '$q', 'utilService',
            'GP_CLIENT_OFFICE_IDS', '$translate', 'GBPL_CLIENT_OFFICE_IDS',
            DashboardCtrl
        ]);

    /** @ngInject */
    function DashboardCtrl(
        $scope, $interval, $timeout, $window,
        authService, _, dashboardService, holidayService,
        workplaceService, employmentTypeService, subsidiaryService,
        toastrService, specialDayService, $q, utilService,
        GP_CLIENT_OFFICE_IDS, $translate, GBPL_CLIENT_OFFICE_IDS
    ) {
        var loggedInUser = authService.getLoggedInUser();

        // ------ Bindable variables and methods ------//
        var vm = this;
        var specialDaysPromise = null;

        vm.todayBirthdays = [];
        vm.shouldShowBirthdayPopUp = false;
        function getSpecialDays() {
            if (!specialDaysPromise) {
                specialDaysPromise = specialDayService.getAllSpecialDays();
            }
            return specialDaysPromise;
        }

        vm.hasCarouselPermission = utilService.hasPermission([1002, 1003]);
        vm.isDashboardDataReady = {
            'attendanceSummary': false,
            'departmentAttendance': false,
            'attendanceFeed': false,
            'calendar': false
        };
        vm.subscription = {
            isExpired: false,
            isAboutToBeExpired: false,
            daysBeforeExpiry: 365
        };

        vm.modal = vm.modal || {};
        vm.modal.newEvent = vm.modal.newEvent || {};
        vm.modal.newEvent.startDate = moment();   // default date in picker
        vm.hasSubsidiaryActivated = utilService.hasPermission('9013');
        vm.isSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId!==null
        vm.datePickerOptions = {
            singleDatePicker: true,
            startDate: moment(),
            maxDate: moment(),
            autoApply: true,
            locale: {
                format: 'DD-MMM-YYYY'
            }
        };

        vm.showFilterPanel = false;

        // multi-select models
        vm.search = {
            selectedEmploymentTypes: [],
            selectedSubsidiaries: [],
            selectedWorkplaces: []
        };

        vm.employeeCategories = [];
        vm.companies = [];
        vm.workplaces = [];

        vm.openDatePicker = openDatePicker;
        vm.toggleFilterPanel = toggleFilterPanel;
        vm.clearFilters = clearFilters;
        vm.applyFilters = applyFilters;
        vm.onSubsidiaryChange = onSubsidiaryChange;
        vm.notifyFilterChange = notifyFilterChange;

        vm.modules = authService.getPermittedModules();
        vm.currentTime = "";
        vm.showMobile = false;
        vm.isGroupAdmin = loggedInUser.isGroupAdmin;
        vm.isAdmin = loggedInUser.isAdmin;

        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.isGBPLClient = GBPL_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);

        // ✅ default filter params (first load: today, no filters)
        vm.filterParams = {
            attDateInMillis: moment().startOf('day').valueOf(),
            employmentTypeIds: [],
            subsidiaryIds: [],
            workplaceIds: []
        };

        init();
        var promise = $interval(function () {
            specialDaysPromise = null;
            init();
        }, 30000);

        function init() {
            //initializing which view to load
            if ($window.innerWidth < 700) {
                vm.showMobile = true;
            }

            var d = new Date();
            vm.currentTime = moment(d).format('dddd, DD/MM/YYYY');

            vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
            vm.isGroupAdmin = loggedInUser.isGroupAdmin;

            if(vm.hasSubsidiaryActivated) {
                getAllWorkplaces();
                getAllEmploymentTypes();
                if(!vm.isSubsidiaryAdmin) {
                    getAllSubsidiaries();
                }
            }

            var promises = [];
            promises.push(fetchAttendanceFeed());
            promises.push(fetchDataForCalendar());
            promises.push(fetchDataForSpecialDays());
            promises.push(fetchSubscriptionStatus());
            promises.push(fetchTodayBirthdays());
            $q.all(promises).then(function () {
                setPanelTitle();
                return fetchOverallAndCompanyWiseAttendance();
            }).finally(function () {
                notifyFilterChange();
            });
        }

        $scope.$watch(
            function () {
                return vm.modal.newEvent.startDate;
            },
            function (newVal, oldVal) {
                if (!newVal || newVal === oldVal) {
                    return;
                }
                vm.filterParams = vm.filterParams || {};
                vm.filterParams.attDateInMillis = moment(newVal).startOf('day').valueOf();
                fetchOverallAndCompanyWiseAttendance();
                notifyFilterChange();
            }
        );

        function openDatePicker() {
            vm.isDatePickerOpen = true;
        }

        function toggleFilterPanel() {
            vm.showFilterPanel = !vm.showFilterPanel;
        }

        function clearFilters() {
            vm.search.selectedEmploymentTypes = [];
            vm.search.selectedSubsidiaries = [];
            vm.search.selectedWorkplaces = [];

            // reset filter params to default (today, no filters)
            vm.filterParams = {
                attDateInMillis: moment().startOf('day').valueOf(),
                employmentTypeIds: [],
                subsidiaryIds: [],
                workplaceIds: []
            };

            fetchOverallAndCompanyWiseAttendance();
            notifyFilterChange();
        }

        function applyFilters() {
            function extractIds(list) {
                return (list && list.length)
                    ? list.map(function (item) { return item.id; })
                    : [];
            }

            var selectedDate = vm.modal.newEvent.startDate || moment();

            vm.filterParams = {
                attDateInMillis: moment(selectedDate).startOf('day').valueOf(),
                employmentTypeIds: extractIds(vm.search.selectedEmploymentTypes),
                subsidiaryIds: extractIds(vm.search.selectedSubsidiaries),
                workplaceIds: extractIds(vm.search.selectedWorkplaces)
            };
            fetchOverallAndCompanyWiseAttendance();
            notifyFilterChange();

            vm.showFilterPanel = false;
        }

        function fetchOverallAndCompanyWiseAttendance() {
            if (vm.isGroupAdmin) {
                return dashboardService.getOverallAndCompanyWiseAttendance()
                    .then(
                        onOverallSummaryAndOfficeAttendanceDataLoadingFinished,
                        onOverallSummaryAndDepartmentAttendanceDataLoadingFailure
                    );
            } else if (vm.isCompanyAdmin) {
                return dashboardService.getOverallAndOfficeWiseAttendance()
                    .then(
                        onOverallSummaryAndOfficeAttendanceDataLoadingFinished,
                        onOverallSummaryAndDepartmentAttendanceDataLoadingFailure
                    );
            } else {
                return dashboardService.getOverallSummaryAndDepartmentAttendance(vm.filterParams)
                    .then(
                        onOverallSummaryAndDepartmentAttendanceDataLoadingFinished,
                        onOverallSummaryAndDepartmentAttendanceDataLoadingFailure
                    );
            }
        }

        function fetchAttendanceFeed() {
            if (vm.isGroupAdmin) {
                return dashboardService.getGroupAttendanceFeed()
                    .then(onAttendanceFeedLoadingFinished, onAttendanceFeedLoadingFailure);
            } else if (vm.isCompanyAdmin) {
                return dashboardService.getCompanyAttendanceFeed()
                    .then(onAttendanceFeedLoadingFinished, onAttendanceFeedLoadingFailure);
            } else {
                return dashboardService.getAttendanceFeed()
                    .then(onAttendanceFeedLoadingFinished, onAttendanceFeedLoadingFailure);
            }
        }

        function getAllWorkplaces() {
            workplaceService.getAllWorkplaces(true).then(function (data) {
                vm.allWorkplaceList = sortCollectionByName(data);
                vm.workplaceList = angular.copy(vm.allWorkplaceList);
                if (vm.isSubsidiaryAdmin) {
                    var userSubsidiaryId = loggedInUser.subsidiaryId;
                    vm.workplaceList = vm.allWorkplaceList.filter(function (item) {
                        return item.subsidiaryId === userSubsidiaryId;
                    });
                }
            });
        }

        function getAllEmploymentTypes() {
            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.allEmploymentTypeList = sortCollectionByName(employmentTypeList); // full list
                vm.employmentTypeList = angular.copy(vm.allEmploymentTypeList);      // used by dropdown

                if (vm.isSubsidiaryAdmin) {
                    var userSubsidiaryId = loggedInUser.subsidiaryId;

                    vm.employmentTypeList = vm.allEmploymentTypeList.filter(function (item) {
                        return item.subsidiaryId === userSubsidiaryId || item.subsidiaryId == null;
                    });
                }
                if(vm.filterParams.employmentTypeIds.length === 0 && vm.filterParams.subsidiaryIds.length === 0 && vm.filterParams.workplaceIds.length === 0) {
                    vm.employmentTypeList.forEach(function (item) {
                        if (item.name === 'Management') {
                            item.ticked = true;
                            vm.filterParams.employmentTypeIds.push(item.id);
                        }
                    });
                }
            }, function (message) {
                toastrService.showErrorToastr(
                    "Failed to fetch designation category list : " + message,
                    "",
                    5000
                );
                console.error("Failed to fetch designation category list : " + message);
            });
        }

        function onSubsidiaryChange() {
            var selectedSubsidiaryIds = (vm.search.selectedSubsidiaries || [])
                .map(function (s) { return s.id; });

            if (!selectedSubsidiaryIds.length) {
                vm.workplaceList = angular.copy(vm.allWorkplaceList);
                vm.employmentTypeList = angular.copy(vm.allEmploymentTypeList);

                vm.search.selectedWorkplaces = [];
                vm.search.selectedEmploymentTypes = [];

                vm.workplaceList.forEach(function (item) { item.ticked = false; });
                vm.employmentTypeList.forEach(function (item) { item.ticked = false; });

                return;
            }

            vm.workplaceList = vm.allWorkplaceList.filter(function (w) {
                return w.subsidiaryId &&
                    selectedSubsidiaryIds.indexOf(w.subsidiaryId) !== -1;
            });

            vm.employmentTypeList = vm.allEmploymentTypeList.filter(function (e) {
                return e.subsidiaryId &&
                    selectedSubsidiaryIds.indexOf(e.subsidiaryId) !== -1;
            });
            vm.search.selectedWorkplaces = [];
            vm.search.selectedEmploymentTypes = [];

            vm.workplaceList.forEach(function (item) { item.ticked = false; });
            vm.employmentTypeList.forEach(function (item) { item.ticked = false; });
        }


        function getAllSubsidiaries() {
            subsidiaryService.getAllSubsidiaries().then(function (data) {
                vm.allSubsidiaries = sortCollectionByName(data);
                vm.filteredSubsidiaries = angular.copy(vm.allSubsidiaries);
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                console.error('Subsidiary Fetching failed error: ' + message);
            });
        }

        function setPanelTitle() {
            if (vm.isGroupAdmin) {
                vm.panelTitle = "companyWiseAttendance";
            } else if (vm.isCompanyAdmin) {
                vm.panelTitle = "officeWiseAttendance";
            } else {
                vm.panelTitle = "departmentWiseAttendance";
            }
        }

        function fetchDataForCalendar() {

            return $q.all([
                holidayService.getAllHolidays(),
                getSpecialDays()
            ]).then(function (results) {
                var holidayList = results[0];
                var specialDayList = results[1];

                vm.isDashboardDataReady.calendar = true;

                var weeklyOffDaysPolicy = authService.getAllInformation().weeklyOffDaysPolicy;

                $timeout(function () {
                    $scope.$broadcast("dashboard-calendar-data-loaded", {
                        "holidayList": holidayList,
                        "specialDayList": specialDayList,
                        "weeklyOffdays": !weeklyOffDaysPolicy ? '0000000' : weeklyOffDaysPolicy.offDays
                    });
                }, 100);
            }, function (message) {
                console.error("Failed to fetch calendar data: " + message);
                vm.isDashboardDataReady.calendar = false;
            });
        }


        function fetchDataForSpecialDays() {
            return getSpecialDays().then(function (specialDayList) {
                vm.isDashboardDataReady.calendar = true;
                var weeklyOffDaysPolicy = authService.getAllInformation().weeklyOffDaysPolicy;

                $timeout(function () {
                    $scope.$broadcast("dashboard-special-day-data-loaded", {
                        "specialDayList": specialDayList,
                        "weeklyOffdays": !weeklyOffDaysPolicy ? '0000000' : weeklyOffDaysPolicy.offDays
                    });
                }, 100);
            }, function (message) {
                console.error("Failed to fetch special day data: " + message);
                vm.isDashboardDataReady.calendar = false;
            });
        }



        function onAttendanceFeedLoadingFinished(attendanceFeed) {
            vm.isDashboardDataReady.attendanceFeed = true;
            $timeout(function () {
                $scope.$broadcast("dashboard-attendance-feed-data-loaded", attendanceFeed);
            }, 200);
        }

        function onAttendanceFeedLoadingFailure(message) {
            console.error("Failed to load attendance feed : " + message);
            vm.isDashboardDataReady.attendanceSummary = false;
        }

        function onOverallSummaryAndOfficeAttendanceDataLoadingFinished(overallSummaryAndOfficeAttendanceData) {
            vm.isDashboardDataReady.attendanceSummary = true;
            vm.isDashboardDataReady.departmentAttendance =
                overallSummaryAndOfficeAttendanceData.offices &&
                overallSummaryAndOfficeAttendanceData.offices.length > 0;

            $timeout(function () {
                $scope.$broadcast(
                    "dashboard-attendance-summary-data-loaded",
                    buildAttendanceSummaryData(overallSummaryAndOfficeAttendanceData)
                );
                $scope.$broadcast(
                    "dashboard-department-attendance-data-loaded",
                    overallSummaryAndOfficeAttendanceData.offices
                );
            }, 200);

        }

        function onOverallSummaryAndDepartmentAttendanceDataLoadingFinished(overallSummaryAndDepartmentAttendanceData) {
            vm.isDashboardDataReady.attendanceSummary = true;
            vm.isDashboardDataReady.departmentAttendance =
                overallSummaryAndDepartmentAttendanceData.departments &&
                overallSummaryAndDepartmentAttendanceData.departments.length > 0;

            $timeout(function () {
                $scope.$broadcast(
                    "dashboard-attendance-summary-data-loaded",
                    buildAttendanceSummaryData(overallSummaryAndDepartmentAttendanceData)
                );
                $scope.$broadcast(
                    "dashboard-department-attendance-data-loaded",
                    overallSummaryAndDepartmentAttendanceData.departments
                );
            }, 200);
        }

        function notifyFilterChange() {
            $timeout(function () {
                $scope.$broadcast('dashboard-filter-params-changed', angular.copy(vm.filterParams));
            }, 0);
        }


        function onOverallSummaryAndDepartmentAttendanceDataLoadingFailure(message) {
            console.error("Failed to fetch overall pei chart group data for dashboard. : " + message);
            vm.isDashboardDataReady.attendanceSummary = true;
            vm.isDashboardDataReady.departmentAttendance = true;
        }

        function buildAttendanceSummaryData(data) {
            return {
                'totalEmployee': data.totalEmployee,
                'present': data.present,
                'absent': data.absent,
                'onTime': data.onTime,
                'late': data.late,
                'expectedWorkingEmployees': data.expectedWorkingEmployees
            };
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection, function (item) {
                return item.name.toLowerCase();
            }, ['asc']);
        }

        function fetchSubscriptionStatus() {
            if (vm.isAdmin || vm.isGroupAdmin || vm.isCompanyAdmin) {
                return dashboardService.getSubscriptionStatus().then(function (data) {
                    vm.subscription.isExpired = data.isExpired;
                    vm.subscription.isAboutToBeExpired = data.isAboutToBeExpired;
                    vm.subscription.daysBeforeExpiry = data.daysBeforeExpiry;
                });
            } else return;
        }

        function fetchTodayBirthdays() {
            return dashboardService.getTodayBirthdays()
                .then(function (result) {
                    vm.todayBirthdays = result.birthdayEmployees || [];
                    vm.shouldShowBirthdayPopUp =
                        result.showPopUp === true && vm.todayBirthdays.length > 0;
                })
                .catch(function (error) {
                    console.error("Error fetching today's birthdays:", error);
                    vm.todayBirthdays = [];
                    vm.shouldShowBirthdayPopUp = false;
                });
        }

        function handleTabSwitching(){
            if (document.hidden) {
                $interval.cancel(promise);
            } else {
                if (!angular.isDefined(promise)) {
                    promise = $interval(function () {
                        init();
                    }, 30000);
                }
            }
        }

        function removeEventListener(event) {
            if (angular.isDefined(promise)) {
                $interval.cancel(promise);
            }
        }

        document.addEventListener("visibilitychange", handleTabSwitching);

        $scope.$on('$destroy', function () {
            document.removeEventListener("visibilitychange", removeEventListener());
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.notifications')
        .controller('NotificationsCtrl',
            ['$scope', 'toastr', 'authService', 'notificationService', NotificationsCtrl]);

    /** @ngInject */
    function NotificationsCtrl($scope, toastr, authService, notificationService) {
        var vm  = this;
        vm.employeeId = authService.getLoggedInId();
        vm.notifications = [];
        vm.total = 0;
        vm.totalPages = 0;
        vm.totalUnseenNotifications = 0;
        vm.currentPage = 0;
        vm.showLoadMoreBtn = true;
        vm.displayCount = 10;


        vm.displayTime = displayTime;
        vm.loadMore = loadMore;

        function init() {
            fetchNotificationData(vm.currentPage, vm.displayCount);
        }

        function fetchNotificationData(pageNumber, perPage) {
            notificationService.getAllNotifications(pageNumber, perPage).then(function (data) {
                vm.total = data.total;
                vm.totalPages = data.totalPages;
                data.notifications.forEach(function (element) {
                    vm.notifications.push(element);
                });
                vm.totalUnseenNotifications = data.totalUnseenNotifications;
                vm.showLoadMoreBtn = vm.notifications.length !== vm.total;
                markSomeAsRead(data.notifications.map(function (element) {
                    return element.id;
                }));
            });
        }

        init();

        function loadMore(){
            if(!(vm.currentPage < vm.totalPages-1)) return;
            fetchNotificationData(++vm.currentPage, vm.displayCount);
        }

        function displayTime(millis){
            return moment(millis).format('DD MMM YYYY h:mm A ');
        }

        function markSomeAsRead(notificationIdList) {
            var data = {
                notificationIdList : notificationIdList
            };
            notificationService.markAsRead(data).then(function (data) {
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.offices')
        .controller('OfficesCtrl', ['$scope','$uibModal','officeService','$state','$stateParams','companyService', 'toastr',OfficesCtrl]);

    /** @ngInject */
    function OfficesCtrl($scope,$uibModal,officeService,$state,$stateParams,toastr) {

        $scope.allOffices = null;

        officeService.getAllOffices(true).then(function (data) {
            $scope.allOffices = data;
        },function (message) {
            toastr.error('Failed to fetch office list from server : '+message);
        });

        $scope.updateName = function (data,id) {
            return officeService.updateOfficeInfo({name: data},id);
        };
        $scope.updateLocation = function (data,id) {
            return officeService.updateOfficeInfo({location: data},id);
        };
        $scope.updateOfficeType = function (data,id) {
            return officeService.updateOfficeInfo({officeType: data},id);
        };
        $scope.updateDescription = function (data,id) {
            return officeService.updateOfficeInfo({description: data},id);
        };

        $scope.office = null;
        var officeId = $stateParams.officeId;
        var onOfficeFetchSuccess = function (data) {
            $scope.office = data;

        };
        var onOfficeFetchFailure = function (message) {
            console.log('Office Fetching failed error: '+message);
        };

        officeService.getOffice(true,officeId).then(onOfficeFetchSuccess,onOfficeFetchFailure);
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('PendingApprovalsCtrl', ['$uibModal','authService','leaveManagementService', 'remainingLeaveService', 'toastrService', 'lateApprovalManagementService','employeeService','monthlyTimeSheetApproverService','overtimeService','$rootScope','$sce', 'analyticsService', 'ANALYTICS_CONSTANT', 'INOVACE_OFFICEID', PendingApprovalsCtrl]);

    /** @ngInject */
    function PendingApprovalsCtrl($uibModal,authService, leaveManagementService, remainingLeaveService, toastrService, lateApprovalManagementService,employeeService,monthlyTimeSheetApproverService,overtimeService,$rootScope,$sce, analyticsService, ANALYTICS_CONSTANT, INOVACE_OFFICEID) {

        var vm = this;

        var loggedInUser = authService.getLoggedInUser();


        vm.isLeaveApproveDataLoaded = false;
        vm.isLateApprovalDataLoaded = false;
        vm.isManualEntryApplicationDataLoaded = false;
        vm.istimeSheetDataLoaded = false;
        vm.leaveApplications = [];
        vm.lateApprovalApplications = [];
        vm.manualEntryApplications = [];
        vm.timeSheetApprovals = [];
        vm.overtimeApprovalsCount = 0;
        vm.isHrManager = loggedInUser.isHrManager;
        vm.isAdminOrHrManager = authService.getLoggedInUser().isHrManager || authService.getLoggedInUser().isAdmin;
        vm.isInovace = authService.getLoggedInUser().officeId === INOVACE_OFFICEID;
        // vm.monthList = [ '','January','February','March','April','May','June','July','August','September','October','November','December'];
        vm.monthList = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        vm.disableApproveRejectForLeave = false;
        vm.analyticsViewDetails = analyticsViewDetails;
        vm.openLeaveApproveModal = openLeaveApproveModal;
        vm.openLeaveRejectModal = openLeaveRejectModal;
        vm.openLateRequestApproveModal = openLateRequestApproveModal;
        vm.openLateRequestRejectModal = openLateRequestRejectModal;
        vm.openManualEntryRejectModal = openManualEntryRejectModal;
        vm.openManualEntryApproveModal = openManualEntryApproveModal;
        vm.openTimeSheetApproveModal = openTimeSheetApproveModal;
        vm.openTimeSheetRejectModal = openTimeSheetRejectModal;
        var approverId = authService.getLoggedInId();

        init();

        function init() {
            remainingLeaveService.getApproversLeaves(approverId).then(function(leaveApplications){
                vm.leaveApplications = leaveApplications;
                vm.isLeaveApproveDataLoaded = true;
            },function (error) {
                toastrService.showErrorToastr("Failed to fetch pending leave applications : " + error, "", 5000);
                console.error("Failed to fetch pending leave applications : " + error);
            });

            lateApprovalManagementService.getAllLateApprovalApplicationsOfAnEmployee(approverId).then(function(lateApprovalApplications){
                vm.lateApprovalApplications = lateApprovalApplications;
                vm.isLateApprovalDataLoaded = true;
            },function (error) {
                toastrService.showErrorToastr("Failed to fetch pending late approval applications : " + error, "", 5000);
                console.error("Failed to fetch pending late approval applications : " + error);
            });
            employeeService.getManualEntriesForApprover(approverId).then(function (data) {
                vm.manualEntryApplications = data;
                // console.log(JSON.stringify(data));
                vm.isManualEntryApplicationDataLoaded = true;
            });
            if(vm.isHrManager){
                monthlyTimeSheetApproverService.getMonthlyTimesheetApprovalsOfHr(new Date().getFullYear()).then(function (data) {
                    vm.timeSheetApprovals = data.applicationsList;
                    vm.istimeSheetDataLoaded = true;
                });
            }
            if(vm.isAdminOrHrManager){
                overtimeService.getPendingOvertimesCount().then(function (data) {
                    vm.overtimeApprovalsCount = data;
                });
            }
        }

        function openLeaveApproveModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/pendingApprovals/approveModal/approve.modal.html',
                size: 'md',
                controller : 'ApproveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveRejectForLeave = true;
                leaveManagementService.approveLeave({
                    approverComment : comment
                }, application.leaveLogId).then(function(leaveApplications){
                    vm.leaveApplications = leaveApplications;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Leave application approved.");
                    vm.disableApproveRejectForLeave = false;
                },function (error) {
                    vm.disableApproveRejectForLeave = false;
                    console.error("Failed to approve pending leave applications : " + error);
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to approve leave application. Please try again later.", "", 5000);
                });
            })
        }

        function getPendingApprovalsAndUpdateSidebar() {
            employeeService.getPendingApprovalsOfEmployee().then(function (count) {
                $rootScope.pendingApproval.notification = count;
            })
        }

        function openLateRequestApproveModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/pendingApprovals/approveModal/approve.modal.html',
                size: 'md',
                controller : 'ApproveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveRejectForLate = true;
                lateApprovalManagementService.acceptLateApprovalRequest({
                    approverComment : comment
                }, application.lateApprovalLogId).then(function(lateApprovalApplications){
                    vm.lateApprovalApplications = lateApprovalApplications;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Late approval successful.");
                },function (error) {
                    console.error("Failed to approve pending late approval applications : " + error);
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to approve late approval application. Please try again later.","",5000);
                }).finally(function (){
                    vm.disableApproveRejectForLate = false;
                });
            })
        }


        function openLeaveRejectModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/rejectModal/rejectLeave.modal.html',
                size : 'md',
                controller : 'RejectLeaveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveRejectForLeave = true;
                leaveManagementService.rejectLeave({
                    approverComment : comment
                }, application.leaveLogId).then(function(leaveApplications){
                    vm.leaveApplications = leaveApplications;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Leave application rejected.");
                    vm.disableApproveRejectForLeave = false;
                },function (error) {
                    vm.disableApproveRejectForLeave = false;
                    console.error("Failed to reject pending leave applications : " + error);
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to reject leave application. Please try again later.", "", 5000);
                });
            });
        }

        function openLateRequestRejectModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/rejectModal/rejectLeave.modal.html',
                size : 'md',
                controller : 'RejectLeaveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveRejectForLate = true;
                lateApprovalManagementService.rejectLateApprovalRequest({
                    approverComment : comment
                }, application.lateApprovalLogId).then(function(lateApprovalApplications){
                    vm.lateApprovalApplications = lateApprovalApplications;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Late approval request rejected.");
                },function (error) {
                    console.error("Failed to reject pending late approval applications : " + error);
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to reject late approval application. Please try again later.", "", 5000);
                }).finally(function (){
                    vm.disableApproveRejectForLeave = false;
                });
            });
        }

        function openManualEntryRejectModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/rejectModal/rejectLeave.modal.html',
                size : 'md',
                controller : 'RejectLeaveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveRejectForME = true;
                employeeService.rejectManualEntryApplication({
                    comment : comment
                }, application.manualEntryId).then(function(data){
                    vm.manualEntryApplications = data;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Manual entry approval request rejected.");
                },function (error) {
                    console.error("Failed to reject pending manual entry approval applications : " + error);
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to reject manual entry approval application. Please try again later.", "", 5000);
                }).finally(function (){
                    vm.disableApproveRejectForME = false;
                });
            });
        }

        function openManualEntryApproveModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/pendingApprovals/approveModal/approve.modal.html',
                size: 'md',
                controller : 'ApproveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveRejectForME = true;
                employeeService.approveManualEntryApplication({
                    comment : comment
                }, application.manualEntryId).then(function(data){
                    vm.manualEntryApplications = data;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Manual entry application approved.");
                },function (error) {
                    console.error("Failed to approve pending manual entry applications : " + error);
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to approve manual entry application. Please try again later.", "", 5000);
                }).finally(function (){
                    vm.disableApproveRejectForME = false;
                });
            })
        }

        function openTimeSheetApproveModal(applicationId,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/monthlyTimeSheetModals/approve.modal.html',
                size : 'md',
                controller : 'ApproveMonthlyTimeSheetModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    applicationId : function () {
                        return applicationId;
                    }
                }
            }).result.then(function () {
                vm.timeSheetApprovals.splice(index,1);
            });
        }

        function openTimeSheetRejectModal(applicationId,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/monthlyTimeSheetModals/reject.modal.html',
                size : 'md',
                controller : 'RejectMonthlyTimeSheetModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    applicationId : function () {
                        return applicationId;
                    }
                }
            }).result.then(function () {
                vm.timeSheetApprovals.splice(index,1);
            });
        }

        function analyticsViewDetails(){
            analyticsService.sendData(ANALYTICS_CONSTANT.viewDetails, document.title + ' - View Details', '', 'View Details In' + document.title, ANALYTICS_CONSTANT.viewDetails)

        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService', '$location', '$anchorScroll', 'toastr', 'utilService','generalSettingsService', ProfileCtrl]);

    /** @ngInject */
    function ProfileCtrl($scope, $stateParams, $state, $timeout, authService, employeeService, $location, $anchorScroll, toastr, utilService, generalSettingsService) {

        var vm = this;
        $state.current.title = "Profile";
        var loggedInUser = authService.getLoggedInUser();
        if(!$stateParams.employeeId) {
            console.warn("no $stateParams.employeeId found. Redirecting to self profile");
            $state.go('.', { employeeId : loggedInUser.id } );
        } else {
            if(!loggedInUser.isCompanyAdmin && !loggedInUser.isAdmin && !loggedInUser.isHrManager && !loggedInUser.isLineManager && loggedInUser.id != $stateParams.employeeId) {
                console.warn("A non admin is trying to access another employee's profile. Redirecting to self profile");
                $state.go('.', { employeeId : loggedInUser.id } );
            }
        }

        vm.user = null;
        vm.waitForLoading = true;
        vm.isEnrolTabActive = false;
        vm.requestorIsAdmin = loggedInUser.isAdmin || loggedInUser.isCompanyAdmin || loggedInUser.isHrManager;
        vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
        vm.isPayrollManager = loggedInUser.isPayrollManager;
        vm.isPayrollApprover = loggedInUser.isPayrollApprover;
        vm.activeTab = 0;
        vm.isEmployeeAllowedOvertime = null;
        vm.isLineManagerPermitted = false;
        vm.isProjectManagementEnabled = (utilService.hasPermission("10001") || utilService.hasPermission("100011"));
        vm.isThisLineManagerAllowedShiftManagement = null;


        vm.onProfileInfoTabSelect = onProfileInfoTabSelect;
        vm.onAttendanceTabSelect = onAttendanceTabSelect;
        vm.onLeaveTabSelect = onLeaveTabSelect;
        vm.onEnrollTabSelect = onEnrollTabSelect;
        vm.onDevicePermissionsTabSelect = onDevicePermissionsTabSelect;
        vm.onOvertimeTabSelect = onOvertimeTabSelect;
        vm.onRosterTabSelect = onRosterTabSelect;
        vm.onPendingApprovalsTabSelect = onPendingApprovalsTabSelect;
        vm.onTimeSheetReportTabSelect = onTimeSheetReportTabSelect;
        vm.onPayrollTabSelect = onPayrollTabSelect;
        init();

        function onProfileInfoTabSelect() {

        }

        function onLeaveTabSelect() {
            $scope.$broadcast("leave-tab-select");
        }

        function onDevicePermissionsTabSelect() {
            $scope.$broadcast("device-permission-tab-select");
        }

        function onEnrollTabSelect() {
            $scope.$broadcast("enroll-tab-select");
        }

        function onOvertimeTabSelect() {
            $scope.$broadcast("overtime-tab-select");
        }

        function onAttendanceTabSelect() {
            $scope.$broadcast("attendance-tab-select");
        }

        function onRosterTabSelect() {
            $scope.$broadcast("roster-tab-select");
        }

        function onPendingApprovalsTabSelect() {
            $scope.$broadcast("pending-approvals-tab-select");
        }

        function onTimeSheetReportTabSelect() {
            $scope.$broadcast("timeSheet-report-tab-select");
        }
        function onPayrollTabSelect() {
            $scope.$broadcast("payroll-tab-select");
        }

        function switchToTabIfApplicable() {
            var showTab = $stateParams.showTab;
            if(showTab && showTab == 'enrolment')
                vm.activeTab = 3;
            if(showTab && showTab == 'attendance') {
                onAttendanceTabSelect();
                vm.activeTab = 1;
            }
            if(showTab && showTab == 'leave' ){
                onLeaveTabSelect();
                vm.activeTab = 2;
            }
        }

        function init() {
            var employeeId = $stateParams.employeeId;
            if(!employeeId || (!vm.requestorIsAdmin && !loggedInUser.isLineManager) ) {
                employeeId = authService.getLoggedInId();
                vm.user = authService.getLoggedInUser();
                vm.isEmployeeAllowedOvertime = !(vm.user.allowOvertime === null || vm.user.allowOvertime === false);
                $timeout(function () {
                    $state.current.title = "Profile of " + vm.user.name;
                    vm.waitForLoading = false;
                    $scope.$broadcast("profile-info-loaded", vm.user);
                    $scope.$broadcast("profile-pic-loaded", {
                        'userId' : vm.user.id,
                        'profilePicURL' : vm.user.employeePictureUrl,
                        'officeId' : vm.user.officeId
                    });
                    switchToTabIfApplicable();
                }, 3000);
            } else {
                employeeService.getProfile(employeeId).then(function (data) {
                    if (employeeId === authService.getLoggedInId()) authService.setUserInfo(data.employee);
                    $timeout(function () {
                        vm.user = data.employee;
                        vm.isEmployeeAllowedOvertime = !(vm.user.allowOvertime === null || vm.user.allowOvertime === false);
                        $timeout(function () {
                            $state.current.title = "Profile of " + vm.user.name;
                            vm.waitForLoading = false;
                            $scope.$broadcast("profile-info-loaded", data.employee);
                            $scope.$broadcast("profile-pic-loaded", {
                                'userId' : vm.user.id,
                                'profilePicURL' : vm.user.employeePictureUrl,
                                'officeId' : vm.user.officeId
                            });
                            switchToTabIfApplicable();
                        }, 3000);
                    });
                }, function (message) {
                    toastr.error("Profile details fetch failure. Error message : " + message);
                });
            }
            employeeService.getShiftAssignmentStatus(authService.getLoggedInUser().id).then(function(data) {
                    $scope.isThisLineManagerAllowedShiftManagement = data;
                    if(authService.getLoggedInUser().isAdmin || authService.getLoggedInUser().isCompanyAdmin || authService.getLoggedInUser().isHrManager){
                        $scope.isThisLineManagerAllowedShiftManagement = true;
                    }
                },
                function(error) {
                    console.error('Error:', error);
                });

            $scope.$on("profile-updated", function (event, change) {
                vm.user = buildWholeUserDataFromChange(vm.user, change, employeeId);
                $timeout(function () {
                    $scope.$broadcast("profile-info-loaded", vm.user);
                }, 1000);
            });

            $scope.$on("profile-action-switch-to-enrol-tab", function (event) {
                vm.activeTab = 3;
            });

            $scope.$on('leave-management-apply',function () {
                $scope.$broadcast('leave-management-open-apply-modal');
            });

            $scope.$on('overtime-status-changed',function (event,data) {
                vm.isEmployeeAllowedOvertime = data;
            });

            $scope.$on('employee-status-changed',function (event,data) {
                vm.user.status = data;
                $timeout(function () {
                    $scope.$broadcast("profile-info-loaded", vm.user);
                }, 1000);
            });

            $scope.$on('late-approval-management-apply',function () {
                $scope.$broadcast('late-approval-management-open-apply-modal');
            });

            if(loggedInUser.isLineManager){
                generalSettingsService.getLinemanagerSettingsOfAnOffice().then(function (response) {
                    vm.isLineManagerPermitted = response.isAllowed;
                });
            }

            onEnrollTabSelect();
        }

        function buildWholeUserDataFromChange(user, change, employeeId) {
            if(change.key.valueOf() === "employeeDetails".valueOf()){
                if(change.subkey){
                    if(!user.employeeDetails) user.employeeDetails = {};
                    user.employeeDetails[change.subkey] = change.value;
                } else {
                    employeeService.getProfile(employeeId).then(function (data) {
                        return data.employee;
                    }, function (message) {
                        console.error("Failed to load profile : " + message);
                    });
                }
            } else if(change.key.valueOf() === "documents".valueOf()){
                if(change.type.valueOf() === "new".valueOf()){
                    user.documents.push(change.value);
                } else if(change.type.valueOf() === "modified".valueOf()) {
                    user.documents = updateArrayWithModifiedEntry(user.documents, change.value);
                } else {
                    console.warn("Probable wrong implementation in ProfileCtrl");
                    employeeService.getProfile(employeeId).then(function (data) {
                        return data.employee;
                    }, function (message) {
                        console.error("Failed to load profile : " + message);
                    });
                }
            }  else if(change.key.valueOf() === "addresses".valueOf()){
                if(change.type) {
                    if(change.type.valueOf() === "new".valueOf()){
                        if(!user.addresses) user.addresses = [];
                        user.addresses.push(change.value);
                    } else if(change.type.valueOf() === "modified".valueOf()) {
                        user.addresses = updateArrayWithModifiedEntry(user.addresses, change.value);
                    } else {
                        console.warn("Probable wrong implementation in ProfileCtrl");
                        employeeService.getProfile(employeeId).then(function (data) {
                            return data.employee;
                        }, function (message) {
                            console.error("Failed to load profile : " + message);
                        });
                    }
                } else {
                    user.addresses = change.value;
                }

            } else if(change.key.valueOf() === "isProjectManager".valueOf()) {
                if(change.value) {
                    user.employeeRoles.push('PROJECT_MANAGER');
                } else {
                    user.employeeRoles = user.employeeRoles.filter(function (role) {
                        return role !== 'PROJECT_MANAGER';
                    });
                }

            } else {
                user[change.key] = change.value;
            }
            return user;
        }

        function updateArrayWithModifiedEntry (array, obj) {
            for(var i = 0 ;i<array.length;i++){
                if(array[i].id===obj.id){
                    array[i] = obj;
                    return array;
                }
            }
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.sms')
        .controller('SmsCtrl',
            ['$scope','smsService', 'toastr','$uibModal',SmsCtrl]);

    /** @ngInject */
    function SmsCtrl($scope, smsService, toastr,$uibModal) {
        var vm  = this;

        vm.employeeList = [];
        vm.selectedEmployeeList = [];
        vm.sms = "";

        vm.openConfirmModal = openConfirmModal;

        function init() {
            smsService.getApplicableEmployeeList().then(function (data) {
                vm.employeeList = _.sortBy(data, function (employee){
                   return employee.name.toLowerCase();
                });
            },function (error) {
                console.log(error);
            })
        }

        init();

        function openConfirmModal() {
            if(!vm.selectedEmployeeList.length >0)
                return toastr.error("Please select employees");
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/sms/confirmModal/confirmSmsSend.html',
                size         : 'md',
                controller   : 'SmsConfirmModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function () {
                sendSms();
            }, function (error) {
                // console.error(" not created : " + error);
            });
        }
        
        function sendSms() {
            if(vm.sms == null || vm.sms.length > 160){
                return toastr.error("Sms can not be longer than 160 characters");
            }
            var data = {
                employeeIdList : vm.selectedEmployeeList.map(function (e) {
                    return e.employeeId;
                }),
                sms : vm.sms
            };

            smsService.sendSms(data).then(function (success) {
                toastr.success("SMS sent");
            },function (error) {
                toastr.error("Meesage not sent");
            });

        }
    }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, $element, $rootScope, utilService, authService, baSidebarService, SIDEBAR_ITEMS) {
    var loggedInUser = authService.getLoggedInUser();
    var permittedModules = (authService.getPermittedModules() || []).map(String);

    $scope.hasPermission = utilService.hasPermission;
    $scope.hasAnyPermission = utilService.hasAnyPermission;
    var sidebarMenuItems = null;
    sidebarMenuItems = angular.copy(SIDEBAR_ITEMS)
    $scope.menuItems = null;
    $scope.collapseItems = []
    sidebarMenuItems = sidebarMenuItems.map(function (sidebarItem) {
      sidebarItem = toggleSidebarItemProperties(sidebarItem);
      return sidebarItem;
    });

    $scope.menuItems = sidebarMenuItems;
    showNotificationsIfAvailable();


    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
    function toggleSidebarItemProperties(sidebarItem) {

      //console.log("inside toggleSidebarItemProperties --> sidebarItem " + sidebarItem.);

      if (sidebarItem.subMenu)
        sidebarItem.subMenu = sidebarItem.subMenu.map(function (sidebarSubItem) {
          return toggleSidebarItemProperties(sidebarSubItem)
        });
      if (!sidebarItem.code || (!sidebarItem.roles || sidebarItem.roles.length == 0)) {
        sidebarItem.show = true;
        //console.log(sidebarItem)
      }

      // new business logic for multiple codes
      if (sidebarItem.code) {
        //console.log(sidebarItem.code);
        if (Array.isArray(sidebarItem.code)) {
          //console.log("inside BaSidebarCtrl.js--->new business logic--->Array.isArrray --> " + sidebarItem.code );

          if (!utilService.hasAnyPermission(sidebarItem.code)) {
            var is9011 = utilService.hasAnyPermission(sidebarItem.code);
            //console.log("inside hasAnyPermission if block is9011 ---> " + is9011);
            sidebarItem.show = false;
            sidebarItem.grey = true;

          }
        } else {
          if (!utilService.hasPermission(sidebarItem.code)) {
            sidebarItem.show = false;
            sidebarItem.grey = true;
            //console.log(sidebarItem.code);
            if (sidebarItem.code === '9011') {
              //console.log("yes 9011 disabled");
              sidebarItem.grey = true;
              sidebarItem.show = true; // Keep visible but grey
            }
          }
        }
      }

      // >>> NEW: if moduleId 9011 not permitted, disable (grey) the item
      // if (sidebarItem.moduleId != null &&
      //     permittedModules.indexOf(String(sidebarItem.moduleId)) === -1) {
      //     sidebarItem.grey = true;         // disable
      //
      //     // change only the route target; keep visible
      //     if (sidebarItem.stateRef) sidebarItem.stateRef = 'dashboard.attendanceDashboard';
      //     if (sidebarItem.stateref) sidebarItem.stateref = 'dashboard.attendanceDashboard'; // for lowercase variant
      //     // (keep show as-is so it stays visible but disabled)
      //     return sidebarItem;
      // }
      // <<< NEW END

      if (sidebarItem.roles && sidebarItem.roles.length > 0) {
        if (sidebarItem.grey == true) {
          // console.log("inside BaSidebarCtrl.js--->if (sidebarItem.roles && sidebarItem.roles.length > 0)"
          //     + " is code is grey? " + sidebarItem.code + " === " + sidebarItem.grey + ""
          //     + " is show true ?? " + sidebarItem.show);
          return sidebarItem;
        }
        if (sidebarItem.code) {
          if (sidebarItem.code == '9013') {
            // Only show Subsidiaries if module 9013 is enabled AND user is admin with no subsidiaryId
            var hasNoSubsidiary = !loggedInUser.subsidiaryId || loggedInUser.subsidiaryId === null || loggedInUser.subsidiaryId === undefined;
            var hasModule9013Permission = utilService.hasPermission('9013');
            sidebarItem.show = hasModule9013Permission && loggedInUser.isAdmin && hasNoSubsidiary;
            return sidebarItem;
          }
          else sidebarItem.show = utilService.hasRolePermission(loggedInUser.employeeRoles, sidebarItem.roles) && utilService.hasPermission(sidebarItem.code);

        }
        if (sidebarItem.code) {
          var sh = utilService.hasRolePermission(loggedInUser.employeeRoles, sidebarItem.roles) && (utilService.hasPermission(sidebarItem.code) || utilService.hasAnyPermission(sidebarItem.code));
          //console.log("inside second if sh?? for code " + sidebarItem.code + " and sh?? === " + sh);
          sidebarItem.show = utilService.hasRolePermission(loggedInUser.employeeRoles, sidebarItem.roles) && (utilService.hasPermission(sidebarItem.code) || utilService.hasAnyPermission(sidebarItem.code));
          //console.log("what is sidebarItem.code === " + sidebarItem.code);
          // if (sidebarItem.code === '4015A,4015') {
          //   if (sidebarItem.stateRef) sidebarItem.stateRef = 'attendanceReport.dailyReport';
          // }
          if (Array.isArray(sidebarItem.code) && (sidebarItem.code.indexOf('4015') !== -1 || sidebarItem.code.indexOf('4015A') !== -1)) {
            // if (sidebarItem.stateRef) sidebarItem.stateRef = 'attendanceReport.dailyReport';
            // angular.element(document.body).injector().get('$state').go('attendanceReport.dailyReport')
          }
        }
        else {
          //console.log("inside second if else condition -- sh?? for code " + sidebarItem.code + " and sh?? === " + sh);
          //console.log(sidebarItem);
          if (sidebarItem.name === 'Settings') {
            //console.log("9011");
            var sh = utilService.hasRolePermission(loggedInUser.employeeRoles, sidebarItem.roles);
            //console.log("sh value: " + sh);
            //console.log(sidebarItem.subMenu);
          }
          sidebarItem.show = utilService.hasRolePermission(loggedInUser.employeeRoles, sidebarItem.roles);
        }
      }
      return sidebarItem;
    }
    // $scope.prevItem = ""
    // $scope.collapseSidebar = function (event){
    //   var item = event.target
    //   console.log(item)
    //   item.parentElement.classList.toggle("ba-sidebar-item-expanded")
    //   if($scope.prevItem  && $scope.prevItem !== item){
    //     $scope.prevItem.parentElement.classList.remove('ba-sidebar-item-expanded');
    //   }
    //   if (item !== $scope.prevItem) {
    //     $scope.prevItem = item;
    //   }
    // }
    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };
    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });

    function showNotificationsIfAvailable() {
      var found = $scope.menuItems.find(function (item) {
        return item.title == "pendingApprovals"
      })
      if (found == -1 || found == null || found == undefined) {
        $scope.menuItems.unshift($rootScope.pendingApproval);
      } else {
        found.notification = $rootScope.pendingApproval.notification;
      }
    }

    $scope.$on('$destroy', function (data) {
      sidebarMenuItems = null;
      $scope.menuItems = null;
      loggedInUser = null;
    })
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 110;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          // console.log("window resizing 1");
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 110;
        }
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };
        /** @ngInject */
        this.$get = function ($state, layoutSizes, $rootScope) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function (item) {
                        return item.level == 0;
                    });

                    menuItems.forEach(function (item) {
                        var children = states.filter(function (child) {
                            return child.level == 1 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    // remove profile from menu if the logged in person is admin
                    if( ($rootScope.loggedInUser.isAdmin && $rootScope.loggedInUser.isAdmin === true) || ($rootScope.loggedInUser.isCompanyAdmin && $rootScope.loggedInUser.isAdmin === true) ){
                        staticMenuItems.splice(staticMenuItems.findIndex(function (item) {
                            if(item.name === "profile") return true;
                        }));
                    }

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {

                    return $state.get()
                        .filter(function (s) {
                            if ($rootScope.loggedInUser.isGroupAdmin){
                                if(s.groupAdminPermitted && s.groupAdminPermitted == true)
                                    return s.sidebarMeta
                                else
                                    return false
                            }
                            if ($rootScope.loggedInUser.isCompanyAdmin && $rootScope.loggedInUser.isCompanyAdmin === true) {
                                if(s.name === 'settings' || s.name === 'leave' || s.name === 'devices'){
                                    return false;
                                } else {
                                    return s.sidebarMeta;
                                }
                            }
                            if( ($rootScope.loggedInUser.isAdmin && $rootScope.loggedInUser.isAdmin === true) || $rootScope.loggedInUser.isHrManager && $rootScope.loggedInUser.isHrManager === true){
                                if(s.payrollManagerPermitted && s.payrollApproverPermitted){
                                    if($rootScope.loggedInUser.isPayrollManager || $rootScope.loggedInUser.isPayrollApprover )
                                        return true;
                                }
                                if (s.payrollManagerPermitted){
                                    if($rootScope.loggedInUser.isPayrollManager) return s.sidebarMeta;
                                    else return false;
                                }
                                if (s.payrollApproverPermitted){
                                    if($rootScope.loggedInUser.isPayrollApprover) return s.sidebarMeta;
                                    else return false;
                                }
                                if(s.name === 'profile' || s.name === 'officeDetails' || (s.name === 'sms' && $rootScope.loggedInUser.office.id != 279)){
                                    return false;
                                } else {
                                    return s.sidebarMeta;
                                }
                            }
                            if ($rootScope.loggedInUser.isLineManager && $rootScope.loggedInUser.isLineManager === true && s.lineManagerPermitted && s.lineManagerPermitted === true) return s.sidebarMeta;
                            if (s.generalUserPermitted && s.generalUserPermitted === true) return s.sidebarMeta;

                            if (s.siteManagementAdminPermitted && s.siteManagementManagerPermitted){
                                if($rootScope.loggedInUser.isSiteManagementAdmin || $rootScope.loggedInUser.isSiteManagementManager) return s.sidebarMeta;
                                else return false;
                            }

                            // if (s.siteManagementManagerPermitted){
                            //     if($rootScope.loggedInUser.siteManagementAdmin) return s.sidebarMeta;
                            //     else return false;
                            // }

                            if(s.payrollManagerPermitted && s.payrollApproverPermitted){
                                if($rootScope.loggedInUser.isPayrollManager || $rootScope.loggedInUser.isPayrollApprover ) {
                                    return s.sidebarMeta;
                                }

                            }
                            if (s.payrollManagerPermitted){
                                if($rootScope.loggedInUser.isPayrollManager) return s.sidebarMeta;
                                else return false;
                            }
                            if (s.payrollApproverPermitted){
                                if($rootScope.loggedInUser.isPayrollApprover) return s.sidebarMeta;
                                else return false;
                            }

                            return false;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                                code: (s.data!= null && s.data.code != null )? s.data.code : null
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };


    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {

      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };
      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      function collapseAllSubItems(expandedItem, children) {
        for(var j = 0; j < children.length; j++) {
          if (children[j].tagName === 'UL' && expandedItem !== $element[0].parentElement.parentElement) {
              children[j].style.display = 'none';
              expandedItem.classList.remove('ba-sidebar-item-expanded');
          }
        }
      }

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();

        var allExpandedItems = angular.element(document.getElementsByClassName('al-sidebar-list-item'));
        for (var i = 0; i < allExpandedItems.length; i++) {
          if (allExpandedItems[i] !== $element[0]) {
            // allExpandedItems[i].classList.remove('ba-sidebar-item-expanded');
            // allExpandedItems[i].children[0].style.display = 'none';

            var children = allExpandedItems[i].children
            collapseAllSubItems(allExpandedItems[i], children);
          }
        }

        var allExpandedSubItems = angular.element(document.getElementsByClassName('ba-sidebar-sublist-item'));
        for (var i = 0; i < allExpandedSubItems.length; i++) {
          if (allExpandedSubItems[i] !== $element[0]) {
            allExpandedSubItems[i].classList.remove('ba-sidebar-item-expanded');
            // allExpandedItems[i].children[0].style.display = 'none';

            var children = allExpandedSubItems[i].children
            collapseAllSubItems(allExpandedSubItems[i], children);
          }
        }
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function () {
    app.constant('SIDEBAR_ITEMS',[
        {
            "name"     : "Dashboard",
            "title"    : "dashboard",
            "level"    : 0,
            "order"    : 25,
            "icon"     : "ion-android-home",
            "code"     : null,
            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER'],
            "grey"     : false,
            "subMenu" : [
                {
                    "name"     : "Attendance Dashboard",
                    "stateRef" : "dashboard.attendanceDashboard",
                    "title"    : "Attendance",
                    "level"    : 1,
                    "order"    : 26,
                    "icon"     : "ion-android-home",
                    "code"     : null,
                    "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER'],
                    "moduleId" : 11,
                    "grey"     : false,
                },
                {
                    "name"     : "Occupancy Dashboard",
                    "stateRef" : "dashboard.occupancyDashboard",
                    "title"    : "Occupancy",
                    "level"    : 1,
                    "order"    : 27,
                    "icon"     : "ion-android-home",
                    "code"     : '1008',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
            ]
        },
        {
            "name"     : "Reports",
            "title"    : "Reports",
            "level"    : 0,
            "order"    : 30,
            "icon"     : 'ion-clipboard',
            "code"     : null,
            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
            "grey"     : false,
            "subMenu" : [
                {
                    "name"     : "AttendanceReport",
                    "title"    : "attendanceReport",
                    "level"    : 1,
                    "order"    : 30,
                    "icon"     : 'ion-clipboard',
                    "code"     : null,
                    "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Individual Attendance",
                            "stateRef" : "attendanceReport.individualAttendanceReport",
                            "title"    : "Individual Attendance",
                            "grey"     : false,
                        },
                        {
                            "name"     : "Detailed Attendance",
                            "stateRef" : "attendanceReport.detailedAttendanceReport",
                            "title"    : "detailedAttendanceReport",
                            "level"    : 2,
                            "order"    : 31,
                            "code"     : null,
                            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "moduleId" : 4,
                            "grey"     : false,
                        },
                        {
                            "name"     : "Department Report",
                            "stateRef" : "attendanceReport.departmentReport",
                            "title"    : "departmentReport",
                            "level"    : 2,
                            "order"    : 32,
                            "code"     : '4016',
                            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "moduleId" : 4,
                            "grey"     : false,
                        },
                        {
                            "name"     : "Monthly Report",
                            "stateRef" : "attendanceReport.monthlyReport",
                            "title"    : "monthlyReport",
                            "level"    : 2,
                            "order"    : 33,
                            "code"     : '4015',
                            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Detailed Monthly Report",
                            "stateRef" : "attendanceReport.detailedMonthlyReport",
                            "title"    : "detailedMonthlyReport",
                            "level"    : 2,
                            "order"    : 33,
                            "code"     : '4015',
                            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Daily Report",
                            "stateRef" : "attendanceReport.dailyReport",
                            "title"    : "dailyReport",
                            "level"    : 2,
                            "order"    : 34,
                            "code"     : ["4015A", "4015"],
                            "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name": 'Location Deviation Report',
                            "stateRef": 'attendanceReport.locationDeviationReport',
                            "title"    : "locationDeviationReport",
                            "level"    : 2,
                            "order"    : 35,
                            "code"     : '4026',
                            "roles"    : ['GROUP_ADMIN','COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "moduleId" : 4,
                            "grey"     : false,
                        },
                        // {
                        //     "name"     : "Site Attendance Report",
                        //     "stateRef" : "attendanceReport.siteAttendanceReport",
                        //     "title"    : "Site Attendance",
                        //     "level" : 2,
                        //     "order" : 35,
                        //     "code"     : '12001',
                        //     "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                        //     "grey"     : false,
                        // },
                        // {
                        //     "name"     : "Site Summary Report",
                        //     "stateRef" : "attendanceReport.siteSummaryReport",
                        //     "title"    : "siteSummaryReport",
                        //     "level"    : 2,
                        //     "order"    : 35,
                        //     "code"     : '12001',
                        //     "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                        //     "grey"     : false,
                        // },
                        {
                            "name"     : "Pandemic Report",
                            "stateRef" : "attendanceReport.pandemicReport",
                            "title"    : "pandemicReport",
                            "level"    : 1,
                            "order"    : 39,
                            "code"     : '10002',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "moduleId" : null,
                            "grey"     : false,
                        },
                    ]
                },
                {
                    "name"     : "Leave Report",
                    "stateRef" : "attendanceReport.leaveReport",
                    "title"    : "leaveReport",
                    "level"    : 1,
                    "order"    : 35,
                    "code"     : '4018',
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : 6,
                    "grey"     : false,
                    "subMenu"  : [
                        // {
                        //     "name"     : "Leave Balance Report",
                        //     "stateRef" : "attendanceReport.leaveBalanceReport",
                        //     "title"    : "leaveBalanceReport",
                        //     "roles"    : ['ADMIN'],
                        //     "grey"     : false,
                        // },
                        {
                            "name"     : "Leave History Report",
                            "stateRef" : "attendanceReport.leaveHistoryReport",
                            "title"    : "leaveHistoryReport",
                            "roles"    : ['ADMIN', 'HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Leave Balance Report",
                            "stateRef" : "attendanceReport.leaveBalanceReport",
                            "title"    : "leaveBalanceReport",
                            "roles"    : ['ADMIN', 'HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                    ]
                },
                {
                    "name"     : "Absent Report",
                    "title"    : "absentReport",
                    "level"    : 1,
                    "order"    : 36,
                    "code"     : null,
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Daily Absent Report",
                            "stateRef" : "attendanceReport.dailyAbsentReport",
                            "title"    : "dailyAbsentReport",
                            "level"    : 2,
                            "order"    : 37,
                            "code"     : '4017',
                            "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Absent Summary Report",
                            "stateRef" : "attendanceReport.monthlyAbsentReport",
                            "title"    : "monthlyAbsentReport",
                            "level"    : 2,
                            "order"    : 39,
                            "code"     : '4017',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                    ]
                },
                {
                    "name"     : "Dining Report",
                    "title"    : "diningReport",
                    "level"    : 1,
                    "order"    : 36,
                    "code"     : '4025',
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Daily Report",
                            "stateRef" : "attendanceReport.dailyDiningReport",
                            "title"    : "dailyDiningReport",
                            "level"    : 2,
                            "order"    : 40,
                            "code"     : '4025',
                            "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Monthly Report",
                            "stateRef" : "attendanceReport.monthlyDiningReport",
                            "title"    : "monthlyDiningReport",
                            "level"    : 2,
                            "order"    : 41,
                            "code"     : '4025',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Detailed Report",
                            "stateRef" : "attendanceReport.detailedDiningReport",
                            "title"    : "detailedDiningReport",
                            "level"    : 2,
                            "order"    : 42,
                            "code"     : '4025',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                    ]
                },
                {
                    "name"     : "Late Report",
                    "stateRef" : "attendanceReport.lateReport",
                    "title"    : "lateReport",
                    "level"    : 1,
                    "order"    : 37,
                    "code"     : '4017',
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : 5,
                    "grey"     : false,
                },
                {
                    "name"     : "Daily Late Report",
                    "stateRef" : "attendanceReport.dailyLateReport",
                    "title"    : "Daily Late Report",
                    "level"    : 1,
                    "order"    : 37,
                    "code"     : '4017',
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : 5,
                    "grey"     : false,
                },
                {
                    "name"     : "Working Hour Report",
                    "stateRef" : "attendanceReport.workingHourReport",
                    "title"    : "workingHourReport",
                    "level"    : 1,
                    "order"    : 38,
                    "code"     : '4016',
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : 10,
                    "grey"     : false,
                },
                {
                    "name"     : "Field Visit Report",
                    "stateRef" : "attendanceReport.fieldVisitReport",
                    "title"    : "fieldVisitReport",
                    "level"    : 1,
                    "order"    : 40,
                    "code"     : null,
                    "roles"    : ['ADMIN', 'HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "All Logs",
                    "stateRef" : "attendanceReport.allLogs",
                    "title"    : "All Logs",
                    "level"    : 1,
                    "order"    : 41,
                    "code"     : '4023',
                    "roles"    : ['ADMIN', 'HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },

                {
                    "name"     : "Salary Report",
                    "title"    : "Salary Report",
                    "level"    : 1,
                    "order"    : 36,
                    "code"     : '10003',
                    "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Salary Comparison Summary",
                            "stateRef" : "attendanceReport.salaryComparisonSummary",
                            "title"    : "salaryComparisonSummary.title",
                            "level"    : 2,
                            "order"    : 37,
                            "code"     : '10003',
                            "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Month On Month Comparison Summary",
                            "stateRef" : "attendanceReport.monthOnMonthSalaryComparison",
                            "title"    : "monthOnMonthComparison",
                            "level"    : 2,
                            "order"    : 37,
                            "code"     : '10003',
                            "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                            "grey"     : false,
                        }
                    ]
                },
                {
                    "name"     : "Mobile Punch Report",
                    "stateRef" : "attendanceReport.mobilePunchReport",
                    "title"    : "Mobile Punch Report",
                    "level"    : 1,
                    "order"    : 42,
                    "code"     : '9006',
                    "roles"    : ['ADMIN', 'HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Location Tracking Report",
                    "stateRef" : "attendanceReport.locationTrackingReport",
                    "title"    : "Location Tracking Report",
                    "level"    : 1,
                    "order"    : 42,
                    "code"     : '9007',
                    "roles"    : ['ADMIN', 'HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Unauthorised Logs",
                    "stateRef" : "attendanceReport.unrecognisedLogs",
                    "title"    : "Unauthorized Logs",
                    "level"    : 1,
                    "order"    : 43,
                    "code"     : '4023',
                    "roles"    : ['ADMIN', 'HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Occupancy Report",
                    "stateRef" : "attendanceReport.serverRoomOccupancyReport",
                    "title"    : "Occupancy Report",
                    "level"    : 1,
                    "order"    : 44,
                    "code"     : '4024',
                    "roles"    : ['ADMIN', 'HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
            ]
        },
        {
            "name"     : "Employees",
            "title"    : "employees",
            "level"    : 0,
            "order"    : 70,
            "icon"     : 'ion-person-stalker',
            "code"     : '2001',
            "stateref" : 'employees',
            "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
            "grey"     : false,
            "subMenu" : [
                {
                    "name"     : "Manage Employees",
                    "stateRef" : "employees.manageEmployees",
                    "title"    : "manageEmployees",
                    "level"    : 1,
                    "order"    : 72,
                    "code"     : null,
                    "roles"    : ['COMPANY_ADMIN','ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "moduleId" : 14,
                    "grey"     : false,
                },
                {
                    "name"     : "Create Employee",
                    "stateRef" : "createEmployee",
                    "title"    : "Create Employee",
                    "level"    : 1,
                    "order"    : 73,
                    "code"     : null,
                    "moduleId" : 14,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Create Batch",
                    "stateRef" : "employees.batchCreateEmployees",
                    "title"    : "createBatch",
                    "level"    : 1,
                    "order"    : 74,
                    "code"     : null,
                    "moduleId" : 16,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Sync External",
                    "stateRef" : "employees.syncExternal",
                    "title"    : "Sync External",
                    "level"    : 1,
                    "order"    : 75,
                    "code"     : '10000',
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Field Visit",
                    "stateRef" : "employees.fieldVisit",
                    "title"    : "Field Visit",
                    "level"    : 1,
                    "order"    : 76,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                }

            ]
        },
        {
            "name"     : "Settings",
            "title"    : "settings",
            "stateRef" : "settings",
            "level"    : 0,
            "order"    : 80,
            "icon"     : 'ion-settings',
            "code"     : null,
            "roles"    : ['ADMIN','HR_MANAGER'],
            "grey"     : false,
            "subMenu"  : [
                {
                    "name"     : "Subsidiaries",
                    "stateRef" : "settings.subsidiaries",
                    "title"    : "Subsidiaries",
                    "level"    : 1,
                    "order"    : 81,
                    "code"     : '9013',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Designations",
                    "stateRef" : "settings.designations",
                    "title"    : "designations",
                    "level"    : 1,
                    "order"    : 81,
                    "code"     : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Employment Type",
                    "stateRef" : "settings.employmentType",
                    "title"    : "employmentTypes",
                    "level"    : 1,
                    "order"    : 82,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Department",
                    "stateRef" : "settings.departments",
                    "title"    : "departments",
                    "level"    : 1,
                    "order"    : 83,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Sub Department",
                    "stateRef" : "settings.subDepartments",
                    "title"    : "subDepartments",
                    "level"    : 1,
                    "order"    : 83,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Workplace",
                    "stateRef" : "settings.workplaces",
                    "title"    : "workplaces",
                    "level"    : 1,
                    "order"    : 84,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Holidays",
                    "stateRef" : "settings.holidays",
                    "title"    : "holidays",
                    "level"    : 1,
                    "order"    : 85,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    name: "Special Days",
                    stateRef: "settings.specialDays",
                    title: "Special Days",
                    level: 1,
                    order: 86,
                    code: null,
                    moduleId: null,
                    roles: ['ADMIN', 'HR_MANAGER'],
                    grey: false,
                },


                {
                    "name"     : "Mobile Attendance",
                    "title"    : "Mobile Attendance",
                    "roles"    : ['ADMIN', 'HR_MANAGER'],
                    "grey"     : false,
                    "subMenu"  :[
                        {
                            "name"     : "Mobile Punch",
                            "stateRef" : "settings.mobilePunch",
                            "title"    : "Mobile Punch",
                            "level"    : 2,
                            "order"    : 86,
                            "code"     : '9006',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Geo Fencing",
                            "stateRef" : "settings.geofencing",
                            "title"    : "Geo Fencing",
                            "level"    : 2,
                            "order"    : 87,
                            "code"     : '9009',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Location Tracking",
                            "stateRef" : "settings.locationTrackingAccessSettings",
                            "title"    : "Location Tracking",
                            "level"    : 2,
                            "order"    : 88,
                            "code"     : '9007',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                        // {
                        //     "name"     : "Bank Payment Advice",
                        //     "stateRef" : "payroll.bankPaymentAdvice",
                        //     "title"    : "Bank Payment Advice",
                        //     "roles"    : ['PAYROLL_MANAGER'],
                        //     "grey"     : false,
                        // },
                    ]
                },

                {
                    "name"     : "Notification",
                    "stateRef" : "settings.notification",
                    "title"    : "Notification",
                    "level"    : 1,
                    "order"    : 86,
                    "moduleId" : null,
                    "code"     : "9011",
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Access Area",
                    "stateRef" : "settings.accessArea",
                    "title"    : "Access Area",
                    "level"    : 1,
                    "order"    : 87,
                    "code"     : '11001',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : 4,
                    "grey"     : false
                },
                {
                    "name"     : "Approvals",
                    "stateRef" : "settings.approvals",
                    "title"    : "Approvals",
                    "level"    : 1,
                    "order"    : 88,
                    "code"     : '6015',
                    "moduleId" : 122,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                }


            ]
        },
        {
            "name"     : "Shift Management",
            "title"    : "shiftManagement",
            "stateRef" : "shiftManagement",
            "level"    : 0,
            "order"    : 90,
            "icon"     : 'ion-clock',
            "code"     : null,
            "roles"    : ['ADMIN','HR_MANAGER'],
            "grey"     : false,
            "subMenu"  : [
                {
                    "name"     : "Shifts",
                    "stateRef" : "shiftManagement.shifts",
                    "title"    : "Shifts",
                    "level"    : 1,
                    "order"    : 91,
                    "code"     : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Shift Groups",
                    "stateRef" : "shiftManagement.shiftGroups",
                    "title"    : "shiftGroups",
                    "level"    : 1,
                    "order"    : 92,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Roster",
                    "stateRef" : "shiftManagement.roster",
                    "title"    : "roster",
                    "level"    : 1,
                    "order"    : 93,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Dynamic Shift Groups",
                    "stateRef" : "shiftManagement.dynamicShiftGroups",
                    "title"    : "dynamicShiftGroups",
                    "level"    : 1,
                    "order"    : 94,
                    "code"     : '10004',
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                }
            ]
        },
        {
            "name"     : "Leave",
            "title"    : "Leave",
            "stateRef" : "leave",
            "level"    : 0,
            "order"    : 100,
            "icon"     : 'ion-ios-minus-outline',
            "code"     : null,
            "roles"    : ['ADMIN','HR_MANAGER'],
            "grey"     : false,
            "subMenu"  : [
                {
                    "name"     : "Leave Policy",
                    "stateRef" : "leave.leavePolicy",
                    "title"    : "leavePolicy",
                    "level"    : 1,
                    "order"    : 101,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Leave Categories",
                    "stateRef" : "leave.leaveCategory",
                    "title"    : "leaveCategories",
                    "level"    : 1,
                    "order"    : 102,
                    "code"     : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                },

                {
                    "name"     : "Configuration",
                    "stateRef" : "leave.leaveCategoryPolicyConfiguration",
                    "title"    : "Configuration",
                    "level"    : 1,
                    "order"    : 103,
                    "code"     : null,
                    "moduleId" : 17,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Apply Leave",
                    "stateRef" : "leave.applyLeaveForOthers",
                    "title"    : "Apply Leave",
                    "level"    : 1,
                    "order"    : 104,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Upload Leave Balance",
                    "stateRef" : "leave.uploadLeaveBalance",
                    "title"    : "Upload Leave Balance",
                    "level"    : 1,
                    "order"    : 106,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                }
            ]
        },
        {
            "name"     : "Pending Approvals",
            "title"    : "pendingApprovals",
            "stateRef" : "pendingApprovals",
            "level"    : 0,
            "order"    : 120,
            "icon"     : 'ion-android-checkmark-circle',
            "code"     : null,
            "roles"    : null,
            "grey"     : false,
        },
        {
            "name"     : "Devices",
            "title"    : "Devices",
            "stateRef" : "devices",
            "level"    : 0,
            "order"    : 130,
            "icon"     : 'ion-ipod',
            "code"     : null,
            "roles"    : ['ADMIN','HR_MANAGER'],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "deviceList",
                    "stateRef" : "devices.devicesList",
                    "title"    : "deviceList",
                    "level"    : 1,
                    "order"    : 131,
                    "code"     : null,
                    "moduleId" : 12,
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                },
            ],
        },
        {
            "name"     : "Overtime Menu",
            "title"    : "overtimeMenu",
            "stateRef" : "overtime",
            "level"    : 0,
            "order"    : 140,
            "icon"     : 'ion-clock',
            "code"     : null,
            "roles"    : ['ADMIN','HR_MANAGER','LINE_MANAGER'],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Overtime Monthly Summary",
                    "stateRef" : "overtime.monthlyOvertimeSummary",
                    "title"    : "overtimeMonthlySummary",
                    "level"    : 1,
                    "order"    : 141,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Overtime Allocator",
                    "stateRef" : "overtime.allocator",
                    "title"    : "overtimeAllocator",
                    "level"    : 1,
                    "order"    : 141,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Overtime Report",
                    "stateRef" : "overtime.report",
                    "title"    : "overtimeReport",
                    "level"    : 1,
                    "order"    : 141,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['ADMIN','HR_MANAGER','LINE_MANAGER'],
                    "grey"     : false,
                },
            ],
        },
        // Project management sidebar menu for the clients without issue-tracker module
        {
            "name"     : "Project Management",
            "title"    : "projectManagement",
            "stateRef" : "projectManagement",
            "level"    : 0,
            "order"    : 160,
            "icon"     : 'ion-settings',
            "code"     : '10001',
            "roles"    : [],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Projects",
                    "stateRef" : "projectManagement.projects",
                    "title"    : "Projects",
                    "level"    : 1,
                    "order"    : 161,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Tasks",
                    "stateRef" : "projectManagement.tasks",
                    "title"    : "Tasks",
                    "level"    : 1,
                    "order"    : 163,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false
                },
                {
                    "name"     : "Teams",
                    "stateRef" : "projectManagement.teams",
                    "title"    : "Teams",
                    "level"    : 1,
                    "order"    : 164,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Timesheet Report",
                    "stateRef" : "projectManagement.perDayTimeSheetReport",
                    "title"    : "Timesheet Report",
                    "level"    : 1,
                    "order"    : 165,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Work Hour Report",
                    "stateRef" : "projectManagement.projectWorkHourReport",
                    "title"    : "Work Hour Report",
                    "level"    : 1,
                    "order"    : 166,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Monthly Dedication",
                    "stateRef" : "projectManagement.monthlyProjectDedicationReport",
                    "title"    : "Monthly Dedication",
                    "level"    : 1,
                    "order"    : 167,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Gantt Chart Projects",
                    "stateRef" : "projectManagement.projectGanttChart",
                    "title"    : "Gantt Chart Projects",
                    "level"    : 1,
                    "order"    : 168,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Gantt Chart People",
                    "stateRef" : "projectManagement.peopleGanttChart",
                    "title"    : "Gantt Chart People",
                    "level"    : 1,
                    "order"    : 169,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                }
            ],
        },
        // Project management sidebar menu for the clients with issue-tracker module, they will see all options from project management with issue-tracker
        {
            "name"     : "Project Management",
            "title"    : "projectManagement",
            "stateRef" : "projectManagement",
            "level"    : 0,
            "order"    : 160,
            "icon"     : 'ion-settings',
            "code"     : '100011',
            "roles"    : [],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Projects",
                    "stateRef" : "projectManagement.projects",
                    "title"    : "Projects",
                    "level"    : 1,
                    "order"    : 161,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['GENERAL_USER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Clients",
                    "stateRef" : "projectManagement.clients",
                    "title"    : "Clients",
                    "level"    : 1,
                    "order"    : 162,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['GENERAL_USER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Tasks",
                    "stateRef" : "projectManagement.tasks",
                    "title"    : "Tasks",
                    "level"    : 1,
                    "order"    : 163,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false
                },
                {
                    "name"     : "Teams",
                    "stateRef" : "projectManagement.teams",
                    "title"    : "Teams",
                    "level"    : 1,
                    "order"    : 164,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Timesheet Report",
                    "stateRef" : "projectManagement.perDayTimeSheetReport",
                    "title"    : "Timesheet Report",
                    "level"    : 1,
                    "order"    : 165,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Work Hour Report",
                    "stateRef" : "projectManagement.projectWorkHourReport",
                    "title"    : "Work Hour Report",
                    "level"    : 1,
                    "order"    : 166,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Monthly Dedication",
                    "stateRef" : "projectManagement.monthlyProjectDedicationReport",
                    "title"    : "Monthly Dedication",
                    "level"    : 1,
                    "order"    : 167,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Gantt Chart Projects",
                    "stateRef" : "projectManagement.projectGanttChart",
                    "title"    : "Gantt Chart Projects",
                    "level"    : 1,
                    "order"    : 168,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Gantt Chart People",
                    "stateRef" : "projectManagement.peopleGanttChart",
                    "title"    : "Gantt Chart People",
                    "level"    : 1,
                    "order"    : 169,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['PROJECT_MANAGER', 'LINE_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Products",
                    "stateRef" : "projectManagement.products",
                    "title"    : "Products",
                    "level"    : 1,
                    "order"    : 170,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['GENERAL_USER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Issue Tracker",
                    "stateRef" : "projectManagement.projectIssues",
                    "title"    : "Issue Tracker",
                    "level"    : 1,
                    "order"    : 171,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['GENERAL_USER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Issue Creators",
                    "stateRef" : "projectManagement.issueCreators",
                    "title"    : "Issue Creators",
                    "level"    : 1,
                    "order"    : 172,
                    "code"     : null,
                    "moduleId" : null,
                    "roles"    : ['GENERAL_USER'],
                    "grey"     : false,
                }
            ],
        },
        {
            "name"     : "Payroll Menu",
            "title"    : "Payroll",
            "stateRef" : "payroll",
            "level"    : 0,
            "order"    : 180,
            "icon"     : 'ion-cash',
            "code"     : '10003',
            "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Payroll Settings",
                    "stateRef" : "payroll.payrollSettings",
                    "title"    : "Payroll Settings",
                    "level"    : 1,
                    "order"    : 181,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Monthly Salary Process",
                    "title"    : "Monthly Salary Process",
                    "roles"    : ['PAYROLL_MANAGER'],
                    "grey"     : false,
                    "subMenu"  :[
                        {
                            "name"     : "Additional Salary Component",
                            "stateRef" : "payroll.salaryComponentUpload",
                            "title"    : "Additional Component",
                            "roles"    : ['PAYROLL_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Absent/Leave Without Pay",
                            "stateRef" : "payroll.absentOrLeaveWithoutPay",
                            "title"    : "Absent/LWP",
                            "roles"    : ['PAYROLL_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Bank Payment Advice",
                            "stateRef" : "payroll.bankPaymentAdvice",
                            "title"    : "Bank Payment Advice",
                            "roles"    : ['PAYROLL_MANAGER'],
                            "grey"     : false,
                        },
                    ]
                },
                {
                    "name"     : "Salary Management",
                    "stateRef" : "payroll.salaryManagement",
                    "title"    : "Salary Management",
                    "level"    : 1,
                    "order"    : 181,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_MANAGER'],
                    "grey"     : false,
                },
                {
                    "name"     : "View/Generate Salary",
                    "stateRef" : "payroll.viewOrGenerateSalary",
                    "title"    : "View/Generate Salary",
                    "level"    : 1,
                    "order"    : 141,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_MANAGER'],
                    "hide"     : true,
                    "grey"     : false,
                },
                {
                    "name"     : "Loan Management",
                    "stateRef" : "payroll.loanManagement",
                    "title"    : "Loan Management",
                    "level"    : 1,
                    "order"    : 141,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_MANAGER'],
                    "hide"     : true,
                    "grey"     : false,
                },
                {
                    "name"     : "View/Approve Salary",
                    "stateRef" : "payroll.viewOrGenerateSalary",
                    "title"    : "View/Approve Salary",
                    "level"    : 1,
                    "order"    : 142,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_APPROVER'],
                    "hide"     : true,
                    "grey"     : false,
                },
                {
                    "name"     : "Salary Certificate",
                    "stateRef" : "payroll.salaryCertificate",
                    "title"    : "Salary Certificate",
                    "level"    : 1,
                    "order"    : 143,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Payslip",
                    "stateRef" : "payroll.payslip",
                    "title"    : "Payslip",
                    "level"    : 1,
                    "order"    : 144,
                    "code"     : '10003',
                    "moduleId" : null,
                    "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                    "grey"     : false,
                },
                {
                    "name"     : "Bank Settings",
                    "title"    : "Bank Settings",
                    "roles"    : ['PAYROLL_MANAGER', 'PAYROLL_APPROVER'],
                    "grey"     : false,
                    "subMenu"  :[
                        {
                            "name"     : "Mange Banks",
                            "stateRef" : "payroll.manageBanks",
                            "title"    : "Manage Banks",
                            "level"    : 1,
                            "order"    : 145,
                            "code"     : '10003',
                            "moduleId" : null,
                            "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                            "grey"     : false,
                        },
                        // {
                        //     "name"     : "Bank Payment Advice",
                        //     "stateRef" : "payroll.bankPaymentAdviceEditor",
                        //     "title"    : "Bank Payment Advice Editor",
                        //     "level"    : 1,
                        //     "order"    : 147,
                        //     "code"     : '10003',
                        //     "moduleId" : null,
                        //     "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                        //     "grey"     : false,
                        // },
                        {
                            "name"     : "Mange Branches",
                            "stateRef" : "payroll.manageBranches",
                            "title"    : "Manage Branches",
                            "level"    : 1,
                            "order"    : 146,
                            "code"     : '10003',
                            "moduleId" : null,
                            "roles"    : ['PAYROLL_MANAGER','PAYROLL_APPROVER'],
                            "grey"     : false,
                        }
                    ]
                },
                {
                    "name"     : "Provident Fund",
                    "title"    : "Provident Fund",
                    "roles"    : ['PAYROLL_MANAGER'],
                    "grey"     : false,
                    "subMenu"  :[
                        {
                            "name"     : "PF Member",
                            "stateRef" : "payroll.providentFundMember",
                            "title"    : "PF Member",
                            "roles"    : ['PAYROLL_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "PF Statement",
                            "stateRef" : "payroll.providentFundStatement",
                            "title"    : "PF Statement",
                            "roles"    : ['PAYROLL_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "PF Account Management",
                            "stateRef" : "payroll.providentFundAccountManagement",
                            "title"    : "PF Account Management",
                            "roles"    : ['PAYROLL_MANAGER'],
                            "grey"     : false,
                        },
                    ]
                },
            ],
        },
        {
            "name"     : "Visitor Management System",
            "title"    : "Visitor Management",
            "stateRef" : "visitorManagement",
            "level"    : 0,
            "order"    : 182,
            "icon"     : 'ion-clipboard',
            "code"     : '11001',
            "roles"    : [],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Create New Appointment",
                    "stateRef" : "visitorManagement.createAppointment",
                    "title"    : "Create New Appointment",
                    "level"    : 1,
                    "order"    : 183,
                    "code"     : '11001',
                    "roles"    : ['VISITOR_MANAGEMENT_EMPLOYEE','VISITOR_MANAGEMENT_ADMIN'],
                    "moduleId" : 4,
                    "grey"     : false
                },

                {
                    "name"     : "Reception",
                    "stateRef" : "visitorManagement.reception",
                    "title"    : "Reception",
                    "level"    : 1,
                    "order"    : 200,
                    "code"     : '11001',
                    "roles"    : ['VISITOR_MANAGEMENT_RECEPTIONIST'],
                    "moduleId" : 4,
                    "grey"     : false
                },
                {
                    "name"     : "Visitor Profiles",
                    "stateRef" : "visitorManagement.visitorProfile",
                    "title"    : "Visitor Profiles",
                    "level"    : 1,
                    "order"    : 195,
                    "code"     : '11001',
                    "roles"    : ['VISITOR_MANAGEMENT_ADMIN'],
                    "moduleId" : 4,
                    "grey"     : false,
                },
                {
                    "name"     : "My Visitor Profile",
                    "stateRef" : "visitorManagement.visitorProfile",
                    "title"    : "My Visitor Profile",
                    "level"    : 1,
                    "order"    : 195,
                    "code"     : '11001',
                    "roles"    : ['VISITOR_MANAGEMENT_EMPLOYEE'],
                    "moduleId" : 4,
                    "grey"     : false,
                },
                {
                    "name"     : "Appointment Log",
                    "stateRef" : "visitorManagement.appointmentLog",
                    "title"    : "Appointment Log",
                    "level"    : 1,
                    "order"    : 196,
                    "code"     : '11001',
                    "roles"    : ['VISITOR_MANAGEMENT_ADMIN','VISITOR_MANAGEMENT_EMPLOYEE'],
                    "moduleId" : 4,
                    "grey"     : false,
                },
                {
                    "name"     : "Settings",
                    "title"    : "Settings",
                    "level"    : 1,
                    "order"    : 186,
                    "code"     : '11001',
                    "moduleId" : null,
                    "roles"    : ['VISITOR_MANAGEMENT_ADMIN'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Visitor Category",
                            "stateRef" : "visitorManagement.visitorCategory",
                            "title"    : "Visitor Category",
                            "level"    : 2,
                            "order"    : 187,
                            "code"     : '11001',
                            "roles"    : ['VISITOR_MANAGEMENT_ADMIN'],
                            "moduleId" : 4,
                            "grey"     : false
                        },
                        {
                            "name"     : "Visit Purpose",
                            "stateRef" : "visitorManagement.visitPurpose",
                            "title"    : "Visit Purpose",
                            "level"    : 2,
                            "order"    : 188,
                            "code"     : '11001',
                            "roles"    : ['VISITOR_MANAGEMENT_ADMIN'],
                            "moduleId" : 4,
                            "grey"     : false
                        },
                        {
                            "name"     : "Manage Card",
                            "stateRef" : "visitorManagement.manageCard",
                            "title"    : "Manage Card",
                            "level"    : 2,
                            "order"    : 191,
                            "code"     : '11001',
                            "roles"    : ['VISITOR_MANAGEMENT_ADMIN'],
                            "moduleId" : 4,
                            "grey"     : false
                        },
                        {
                            "name"     : "Assign Role",
                            "stateRef" : "visitorManagement.assignRole",
                            "title"    : "Assign Role",
                            "level"    : 2,
                            "order"    : 192,
                            "code"     : '11001',
                            "roles"    : ['VISITOR_MANAGEMENT_ADMIN'],
                            "moduleId" : 4,
                            "grey"     : false,
                        },
                    ]
                },
            ],
        },
        {
            "name"     : "Parking Management System",
            "title"    : "Parking Management",
            "stateRef" : "parkingManagement",
            "level"    : 0,
            "order"    : 250,
            "icon"     : 'ion-android-car',
            "code"     : '11101',
            "roles"    : ['ADMIN','HR_MANAGER','PARKING_OPERATIONS_MANAGER'],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Live Feed and Dashboard",
                    "stateRef" : "parkingManagement.liveFeedAndDashboard",
                    "title"    : "Live Feed & Dashboard",
                    "level"    : 1,
                    "order"    : 251,
                    "code"     : '11101',
                    "roles"    : ['ADMIN','HR_MANAGER','PARKING_OPERATIONS_MANAGER'],
                    "grey"     : false
                },
                {
                    "name"     : "Vehicles",
                    "stateRef" : "parkingManagement.vehicles",
                    "title"    : "Vehicles",
                    "level"    : 1,
                    "order"    : 252,
                    "code"     : '11101',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false
                },
                {
                    "name"     : "Parking Report",
                    "title"    : "Parking Report",
                    "level"    : 1,
                    "order"    : 42,
                    "code"     : '11101',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Daily Report",
                            "stateRef" : "parkingManagement.dailyParkingReport",
                            "title"    : "Daily Report",
                            "level"    : 2,
                            "order"    : 43,
                            "code"     : '11101',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Monthly Report",
                            "stateRef" : "parkingManagement.monthlyParkingReport",
                            "title"    : "Monthly Report",
                            "level"    : 2,
                            "order"    : 44,
                            "code"     : '11101',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "grey"     : false,
                        }
                    ]
                },
                {
                    "name"     : "Settings",
                    "title"    : "Settings",
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name": "Bill Setup",
                            "stateRef": "parkingManagement.billSetup",
                            "title": "Bill Setup",
                            "level": 1,
                            "order": 253,
                            "code": '11101',
                            "roles": ['ADMIN','HR_MANAGER'],
                            "grey": false,
                        },
                        {
                            "name": "Parking Slot Setup",
                            "stateRef": "parkingManagement.parkingSlotSetup",
                            "title": "Parking Slot Setup",
                            "level": 1,
                            "order": 254,
                            "code": '11101',
                            "roles": ['ADMIN','HR_MANAGER'],
                            "grey": false,
                        }
                    ]
                },
            ],
        },
        {
            "name"     : "Site Management",
            "title"    : "Site Management",
            "stateRef" : "siteManagement",
            "level"    : 0,
            "order"    : 230,
            "icon"     : 'ion-ios-location',
            "code"     : '12001',
            "roles"    : ['SITE_MANAGEMENT_ADMIN','SITE_MANAGEMENT_MANAGER'],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Dashboard",
                    "stateRef" : "siteManagement.siteManagementDashboard",
                    "title"    : "Dashboard",
                    "level"    : 1,
                    "order"    : 231,
                    "code"     : '',
                    "roles"    : ['SITE_MANAGEMENT_ADMIN','SITE_MANAGEMENT_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false
                },
                {
                    "name"     : "Manage Sites",
                    "stateRef" : "siteManagement.manageSites",
                    "title"    : "Manage Site",
                    "level"    : 1,
                    "order"    : 232,
                    "code"     : '12001',
                    "roles"    : ['SITE_MANAGEMENT_ADMIN'],
                    "moduleId" : null,
                    "grey"     : false,
                },
                {
                    "name"     : "Reports",
                    "title"    : "Reports",
                    "roles"    : ['SITE_MANAGEMENT_ADMIN'],
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Site Attendance Report",
                            "stateRef" : "siteManagement.siteAttendanceReport",
                            "title"    : "Site Attendance",
                            "level"    : 2,
                            "order"    : 35,
                            "code"     : '12001',
                            "roles"    : ['SITE_MANAGEMENT_ADMIN'],
                            "grey"     : false,
                        },
                        {
                            "name"     : "Site Summary Report",
                            "stateRef" : "siteManagement.siteSummaryReport",
                            "title"    : "siteSummaryReport",
                            "level"    : 2,
                            "order"    : 35,
                            "code"     : '12001',
                            "roles"    : ['SITE_MANAGEMENT_ADMIN'],
                            "grey"     : false,
                        },
                    ]
                },
            ],
        },
        {
            "name"     : "Membership Management",
            "title"    : "Membership Management",
            "stateRef" : "membershipManagement",
            "level"    : 0,
            "order"    : 231,
            "icon"     : 'ion-ios-people',
            "code"     : '13001',
            "roles"    : ['ADMIN','HR_MANAGER'],
            "grey"     : false,
            "subMenu"  :[
                {
                    "name"     : "Dashboard",
                    "stateRef" : "membershipManagement.membershipDashboard",
                    "title"    : "Dashboard",
                    "level"    : 1,
                    "order"    : 231,
                    "code"     : '13001',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false
                },
                {
                    "name"     : "Members",
                    "stateRef" : "membershipManagement.members",
                    "title"    : "Members",
                    "level"    : 1,
                    "order"    : 231,
                    "code"     : '13001',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false
                },
                {
                    "name"     : "Settings",
                    "stateRef" : "membershipManagement.membershipSettings",
                    "title"    : "Settings",
                    "level"    : 1,
                    "order"    : 231,
                    "code"     : '13001',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false
                },
                {
                    "name"     : "Membership Report",
                    "stateRef" : "membershipManagement.members",
                    "title"    : "Membership Report",
                    "level"    : 1,
                    "order"    : 231,
                    "code"     : '13001',
                    "roles"    : ['ADMIN','HR_MANAGER'],
                    "moduleId" : null,
                    "grey"     : false,
                    "subMenu"  : [
                        {
                            "name"     : "Daily Report",
                            "stateRef" : "membershipManagement.dailyReport",
                            "title"    : "Daily Report",
                            "level"    : 2,
                            "order"    : 231,
                            "code"     : '13001',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "moduleId" : null,
                            "grey"     : false
                        },
                        {
                            "name"     : "Monthly Report",
                            "stateRef" : "membershipManagement.monthlyReport",
                            "title"    : "Monthly Report",
                            "level"    : 2,
                            "order"    : 231,
                            "code"     : '13001',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "moduleId" : null,
                            "grey"     : false
                        },
                        {
                            "name"     : "Subscription Report",
                            "stateRef" : "membershipManagement.subscriptionReport",
                            "title"    : "Subscription Report",
                            "level"    : 2,
                            "order"    : 231,
                            "code"     : '13001',
                            "roles"    : ['ADMIN','HR_MANAGER'],
                            "moduleId" : null,
                            "grey"     : false
                        },
                    ]
                },
            ]
        },
        {
            "name"     : "Billing",
            "title"    : "Billing",
            "stateRef" : "billing",
            "level"    : 0,
            "order"    : 232,
            "icon"     : "ion-cash",
            "code"     : null,
            "roles"    : ["ADMIN","HR_MANAGER"],
            "grey"     : false
        }
    ]);
    app.run(['SIDEBAR_ITEMS', '$rootScope', 'subscriptionGateService', function (SIDEBAR_ITEMS, $rootScope, subscriptionGateService) {
        var ORIGINAL = angular.copy(SIDEBAR_ITEMS);
        function toBool(v) {
            if (typeof v === 'string') {
                var s = v.trim().toLowerCase();
                if (s === 'true' || s === '1' || s === 'yes') return true;
                if (s === 'false' || s === '0' || s === 'no' || s === '' || s === 'null' || s === 'undefined') return false;
            }
            return !!v;
        }
        function isBillingItem(item) {
            return item && (item.stateRef === 'billing' || item.name === 'Billing' || item.title === 'Billing');
        }
        function findBillingFromOriginal() {
            for (var i = 0; i < ORIGINAL.length; i++) {
                if (isBillingItem(ORIGINAL[i])) return ORIGINAL[i];
            }
            return null;
        }
        function replaceArrayContents(target, items) {
            target.length = 0;
            Array.prototype.push.apply(target, items);
        }

        function showOnlyBilling() {
            var billing = findBillingFromOriginal();
            if (!billing) {
                restoreFull();
                return;
            }
            replaceArrayContents(SIDEBAR_ITEMS, [ angular.copy(billing) ]);
        }

        function restoreFull() {
            replaceArrayContents(SIDEBAR_ITEMS, angular.copy(ORIGINAL));
        }

        function applyFromStatus() {
            var st = $rootScope.subscriptionStatus || {};
            var on = toBool(st.isPastGracePeriodDays);
            if (on) { showOnlyBilling(); }
            else { restoreFull(); }
        }
        restoreFull();
//        subscriptionGateService.refresh()
//            .then(applyFromStatus, restoreFull)
//            .finally(applyFromStatus);
        $rootScope.$watch(
            function () { return $rootScope.subscriptionStatus && $rootScope.subscriptionStatus.isPastGracePeriodDays; },
            function () { applyFromStatus(); }
        );
    }]);
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function () {
    'use strict';
    angular
        .module('BlurAdmin.theme.components')
        .controller('ContentTopController', ['$state', '$uibModal', 'VIDEO_URLS', ContentTopController]);

    /** @ngInject */
    function ContentTopController($state, $uibModal, VIDEO_URLS) {
        var vm = this;
        // vm.showTutorial = false;

        vm.openTutorialViewModal = openTutorialViewModal;

        // function init() {
        //     console.log(VIDEO_URLS[$state.current.moduleId].title.length);
        //     if($state.current.moduleId && $state.current.moduleId != null && $state.current.moduleId > 0 && VIDEO_URLS[$state.current.moduleId].title.length > 0)
        //         vm.showTutorial = true;
        // }

        function openTutorialViewModal(moduleId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/theme/components/contentTop/tutorialModal/tutorialView.modal.html',
                controller : 'TutorialViewModalController',
                controllerAs : 'vm',
                backdrop : 'static',
                size: "lg",
                resolve : {
                    moduleId: function () {
                        return moduleId;
                    }
                }
            }).result.then(function (device) {

            });
        }

        // init();
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state,authService) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
          $scope.moduleId = $state.current.moduleId;
          if(authService.getLoggedInUser().isPayrollApprover){
            if($state.current.name == "payroll.viewOrGenerateSalary"){
              $scope.activePageTitle = "View/Approve Salary";
            }
          }
        });
      }
    };
  }

})();
//
//
// /**
//  * @author v.lugovksy
//  * created on 16.12.2015
//  */
// (function () {
//     'use strict';
//
//     angular.module('BlurAdmin.theme.components')
//         .controller('MsgCenterCtrl', MsgCenterCtrl);
//
//     /** @ngInject */
//     function MsgCenterCtrl($scope, $rootScope, $sce, notificationService,$timeout,toastr, $state) {
//         $scope.hasNotificationModule = !!$rootScope.hasNotificationModule;
//
//         // Optional: if you recompute permissions later, listen and update:
//         $scope.$on('permissions:updated', function () {
//             $scope.hasNotificationModule = !!$rootScope.hasNotificationModule;
//         });
//
//         var vm = this;
//         vm.ago = ago;
//         vm.displayTime = displayTime;
//         vm.markAllAsRead = markAllAsRead;
//         vm.markAsRead= markAsRead;
//         vm.clickedOnBell = clickedOnBell;
//         vm.fetchMethod = fetchNotificationData;
//         vm.seeAllNotifications = seeAllNotifications;
//
//         var timer;
//         vm.isOpen = false;
//         vm.total = 0;
//         vm.totalPages = 0;
//         vm.totalUnseenNotifications = 0;
//
//         // FCM.setOnMessage(function (payload) {
//         //   console.log(payload)
//         //   console.log('FCM payload from Message controller: ', JSON.stringify(payload));
//         //   var data = payload.data;
//         //   var notification = payload.notification;
//         //   messageHandler(data, notification);
//         // });
//
//         function messageHandler(data, notification) {
//             // console.log("inside message handler: data: " + JSON.stringify(data));
//             // console.log("inside message handler: notification: " + JSON.stringify(notification));
//             toastr.info(data.shortMessage);
//             //TODO customized toast
//             // vm.notifications.unshift({
//             //   generatorEmpPicURL      : data.imageUrl,
//             //   shortMessage            : data.shortMessage,
//             //   notificationId          : data.notificationId
//             // });
//             vm.totalUnseenNotifications++;
//
//         }
//
//         function fetchNotificationData() {
//             notificationService.getAllNotifications(0, 10).then(function (data) {
//                 vm.total = data.total;
//                 vm.totalPages = data.totalPages;
//                 vm.notifications = data.notifications;
//                 vm.totalUnseenNotifications = data.totalUnseenNotifications;
//             })
//         }
//
//         function clickedOnBell(){
//             if (!$scope.hasNotificationModule) return;
//             if(!vm.isOpen){
//                 vm.isOpen = true;
//                 fetchNotificationData();
//                 timer = $timeout(function () {
//                     markAllAsRead();
//                 },5000);
//             }
//             else {
//                 vm.isOpen = false;
//                 $timeout.cancel(timer);
//                 timer = null;
//                 console.log("timeout cancelled");
//             }
//         }
//
//         fetchNotificationData();
//
//         function markAllAsRead() {
//             notificationService.markAllAsRead().then(function (data) {
//                 vm.totalUnseenNotifications = 0;
//             }, function (err) {
//                 console.error(err);
//             })
//         }
//
//         function markAsRead(notification) {
//             console.log(notification);
//         }
//
//         function seeAllNotifications() {
//             fetchNotificationData();
//             $state.go('notifications');
//         }
//
//         function ago(millis){
//             return moment(millis).fromNow();
//         }
//
//         function displayTime(millis){
//             return moment(millis).format('DD MMM YYYY h:mm A ');
//         }
//
//         $scope.getMessage = function(msg) {
//             var text = msg.template;
//             if (msg.userId || msg.userId === 0) {
//                 text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
//             }
//             return $sce.trustAsHtml(text);
//         };
//     }
// })();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce, notificationService, $timeout, toastr, $state, authService) {
    var vm = this;

    // NEW: compute locally; do NOT rely on $rootScope
    var permittedModules = (authService.getPermittedModules() || []).map(String);
    vm.hasNotificationModule = permittedModules.indexOf('9011') !== -1;

    vm.ago = ago;
    vm.displayTime = displayTime;
    vm.markAllAsRead = markAllAsRead;
    vm.markAsRead= markAsRead;
    vm.toggleDropdown = toggleDropdown;
    vm.fetchMethod = fetchNotificationData;
    vm.seeAllNotifications = seeAllNotifications;

    var timer;
    vm.total = 0;
    vm.totalPages = 0;
    vm.totalUnseenNotifications = 0;

    function messageHandler(data, notification) {
      toastr.info(data.shortMessage);
      vm.totalUnseenNotifications++;
    }

    function fetchNotificationData() {
      notificationService.getAllNotifications(0, 10).then(function (data) {
        vm.total = data.total;
        vm.totalPages = data.totalPages;
        vm.notifications = data.notifications;
        vm.totalUnseenNotifications = data.totalUnseenNotifications;
      });
    }

    function toggleDropdown(open){
      if (!vm.hasNotificationModule) return; // ignore when disabled
      if (open) {
        fetchNotificationData();
        timer = $timeout(function () { markAllAsRead(); }, 5000);
      } else {
        if (timer) {
          $timeout.cancel(timer);
          timer = null;
        }
      }
    }

    fetchNotificationData();

    function markAllAsRead() {
      notificationService.markAllAsRead().then(function () {
        vm.totalUnseenNotifications = 0;
      }, function (err) {
        console.error(err);
      });
    }

    function markAsRead(notification) {
      console.log(notification);
    }

    function seeAllNotifications() {
      fetchNotificationData();
      $state.go('notifications');
    }

    function ago(millis){ return moment(millis).fromNow(); }
    function displayTime(millis){ return moment(millis).format('DD MMM YYYY h:mm A '); }

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl as vm'
    };
  }

})();
(function () {
  'use strict';
  angular
      .module('BlurAdmin.theme.components')
      .controller('PageTopController', ['$scope', 'authService', '$state', '$timeout', 'BANGABHABAN_OFFICE_ID', PageTopController]);

  /** @ngInject */
  function PageTopController($scope, authService, $state, $timeout, BANGABHABAN_OFFICE_ID) {
      $scope.officeName = authService.getOfficeName();
      $scope.officeLogoUrl = authService.getOfficeLogoUrl();
      $scope.officeLogoUrl2 = authService.getOfficeLogoUrl2();
      $scope.officeLogoUrl3 = authService.getOfficeLogoUrl3();
      $scope.subsidiaryName = authService.subsidiaryName();
      $scope.employeeId = null;
      $scope.searchText = null;
      var loggedInUser = authService.getLoggedInUser();
      $scope.isBangabhabanEmployee = loggedInUser.officeId === BANGABHABAN_OFFICE_ID.id;
      $scope.searchAllowed = (loggedInUser.isAdmin || loggedInUser.isHrManager || loggedInUser.isLineManager || loggedInUser.isCompanyAdmin ) && !loggedInUser.isGroupAdmin;
      $scope.logout = function () {
          authService.logout();
      };
      $scope.searchKeyword = null;
      $scope.searchByEmployeeId = function (selectedEmployee) {
          $scope.employeeId = selectedEmployee.id;
          $scope.searchText = selectedEmployee.name;

          $scope.goToProfile(selectedEmployee.id)
      }
      $scope.goToProfile = function (id) {
          if ($state.current.name == 'profile') {
              $timeout(function () {
                  $state.go('.', {employeeId: id}, {reload: true});
              }, 100);
          } else {
              $timeout(function () {
                  $state.go('profile', {
                      'employeeId': id
                  });
              }, 200);
          }
      }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', ['authService', pageTop]);

  /** @ngInject */
  function pageTop(authService) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopController'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
        'use strict';

        angular.module('InovaceClientApp')
            .controller('SearchEmployeeCtrl', ['$timeout', 'employeeService', '$state','analyticsService', 'ANALYTICS_CONSTANT', SearchEmployeeCtrl]);

        /** @ngInject */
        function SearchEmployeeCtrl($timeout, employeeService, $state, analyticsService, ANALYTICS_CONSTANT) {
            var vm = this;
            vm.employees = [];
            vm.searchText = "";
            vm.focus = false;
            vm.fetching = false;
            var timer;
            vm.search = function () {
                vm.searchText = vm.searchText.trim();
                if (!vm.searchText) {
                    vm.fetching = false;
                    vm.employees = [];
                    return;
                }
                if (timer) $timeout.cancel(timer);
                timer = $timeout(function () {
                    vm.fetching = true;
                    employeeService.searchByName(vm.searchText).then(function (employees) {
                        vm.employees = employees;
                        vm.fetching = false;
                    })
                }, 300);
            };

            vm.goToProfile = function (id) {
                if ($state.current.name == 'profile') {
                    $timeout(function () {
                        analyticsService.sendData(ANALYTICS_CONSTANT.profileSearch,'Tipsoi HRM - Profile Search','','Profile Search In '+document.title, ANALYTICS_CONSTANT.profileSearch);
                        $state.go('.', {employeeId: id}, {reload: true});
                    }, 100);
                } else {
                    $timeout(function () {
                        $state.go('profile', {
                            'employeeId': id
                        });
                    }, 200);
                }
            }
        }
    })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('InovaceClientApp')
      .directive('searchEmployee', searchEmployee);

  /** @ngInject */
  function searchEmployee() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/searchEmployee/searchEmployee.html',
      controller: 'SearchEmployeeCtrl as vm'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.auth.login')
        .controller('LoginCtrl', ['$scope', '$state', '$timeout', '$uibModal', 'authService', 'payrollSettingsService', 'utilService', 'toastr','GENDER','employeeService','analyticsService','$window','BANGABHABAN_OFFICE_ID','$translate', LoginCtrl]);

    /** @ngInject */
    function LoginCtrl($scope, $state, $timeout, $uibModal, authService,payrollSettingsService, utilService,  toastr,GENDER,employeeService,analyticsService,$window,BANGABHABAN_OFFICE_ID,$translate) {


        var fake = false;
        $scope.slidesToShow = 2;
        $scope.autoplay = true;
        $scope.slider = [
            {
                image : '../assets/img/slide_01.png',
                text1 : 'নির্ভুল, সহজতর এবং সময়সাশ্রয়ী ',
                text2 : 'ব্যবস্থাপনায় টিপসই HRM'
            },
            {
                image: '../assets/img/slide_02.png',
                text1  :'GEO-Location Based',
                text2  : 'Smart Attendance System'
            }
        ]
        $scope.showErrorBlock = 0;
        $scope.errorMessage = null;
        if(authService.isAuthenticated()) {
            $state.go('dashboard.attendanceDashboard');
        }

        $scope.login = function () {
            toastr.clear();
            authService
                .login($scope.loginData)
                .then(loginSuccess, loginFailed);
        };

        var loginFailed = function (message) {
            showErrorToast(message);
            // $scope.errorMessage = message;
            // $scope.showErrorBlock = 1;
            // $timeout(function (){ $scope.showErrorBlock = 2}, 3000);
        };
        var loginSuccess = function () {
            // showSuccessToast();
            var user = authService.getLoggedInUser();
            //checking if the user is of bangabhaban
            if(user.officeId === BANGABHABAN_OFFICE_ID.id)
                $translate.use('en_modified');
            else
                $translate.use('en');

            var userPersonalInfo;
            employeeService.getEmployeeDetails(user.id).then(function (empDetails) {
                var analyticsId = analyticsService.getAnalyticsId();
                userPersonalInfo = empDetails;
                // console.log(userPersonalInfo)
                // console.log()

                gtag('event', "login_successful", {
                    'send_to': analyticsId,
                    'page_title': 'Tipsoi - Login',
                    'page_location': window.location.href,
                    'companyName': user.office.company.name ? user.office.company.name : "-",
                    'officeName': user.office.name ? user.office.name : "-",
                    'employeeName': user.name ? user.name : "-",
                    'employeeRole': user.roles ? user.roles : "-",
                    'employeeEmail': user.email ? user.email : "-",
                    'employeePhone': user.phoneMobile ? user.phoneMobile : "-",
                    'employeeGender': !!user.gender ? GENDER[user.gender - 1].name : "-",
                    'employeeAge': user.dateOfBirth ? Math.floor((Date.now() - userPersonalInfo.dateOfBirth) / 31556952000) : "-",
                });
                gtag('event', "employeeInfo- " + user.id, {
                    'send_to': analyticsId,
                    'companyName': user.office.company.name ? user.office.company.name : "-",
                    'officeName': user.office.name ? user.office.name : "-",
                    'employeeName': user.name ? user.name : "-",
                    'employeeRole': user.roles ? user.roles : "-",
                    'employeeEmail': user.email ? user.email : "-",
                    'employeePhone': user.phoneMobile ? user.phoneMobile : "-",
                    'employeeGender': !!user.gender ? GENDER[user.gender - 1].name : "-",
                    'employeeAge': user.dateOfBirth ? Math.floor((Date.now() - userPersonalInfo.dateOfBirth) / 31556952000) : "-",
                });
            }, function (err) {
                console.error(err);
            })


            // console.log(user)

            if(utilService.hasPermission('10003')){
                if(user.isPayrollManager == true || user.isPayrollApprover == true) {
                    payrollSettingsService.getPayrollSettingsStatus().then(function (data){
                        if(!data.isSettingsAvailable){
                            openPayrollNotifierModal();
                        }
                    });
                }
            }
            if($state.params.prevState != null  && $state.params.prevState != '')
                $state.go($state.params.prevState);
            else
                $state.go('dashboard.attendanceDashboard');
        };

        function openPayrollNotifierModal(){
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/auth/login/payrollActivationNotifierModal/payrollActivationNotifierModal.html',
                size: 'md',
                controller: 'PayrollActivationNotifierModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            });
        }

        var showErrorToast = function (message) {
            toastr.error(message, 'Sign In Failed', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": 0,
                "extendedTimeOut": 0,
                "allowHtml": false,
                "closeButton": true,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        };

        var showSuccessToast = function(){
            toastr.success('Welcome to Inovace Client Panel!', 'Sign in success!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "success",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        };

        function getValue(){
            return window.localStorage.getItem('token');
        }

        $scope.$watch(getValue, function(newValue,oldValue){
            if (oldValue != newValue){
                $window.location.reload();
            }
        });
    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('ApproveMonthlyTimeSheetModalCtrl', ['$uibModalInstance','toastr','monthlyTimeSheetApproverService','applicationId', ApproveMonthlyTimeSheetModalCtrl]);

    /** @ngInject */
    function ApproveMonthlyTimeSheetModalCtrl($uibModalInstance,toastr,monthlyTimeSheetApproverService,applicationId) {
        var vm = this;
        vm.approve = approve;
        function approve() {
            monthlyTimeSheetApproverService.approveOrRejectTimeSheet(applicationId,{status:1}).then(function (data) {
                toastr.success("Approval successful");
                $uibModalInstance.close(data);
            },function (error) {
                toastr.error("Could not approve time sheet");
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('RejectMonthlyTimeSheetModalCtrl', ['$uibModalInstance','toastr','monthlyTimeSheetApproverService','applicationId', RejectMonthlyTimeSheetModalCtrl]);

    /** @ngInject */
    function RejectMonthlyTimeSheetModalCtrl($uibModalInstance,toastr,monthlyTimeSheetApproverService,applicationId) {
        var vm = this;
        vm.reject = reject;
        // console.log("application id " + applicationId)
        function reject() {
            monthlyTimeSheetApproverService.approveOrRejectTimeSheet(applicationId,{status:2}).then(function (data) {
                toastr.success("Rejection successful");
                $uibModalInstance.close(data);
            },function (error) {
                toastr.error("Could not reject time sheet");
            })
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.absentReport')
        .controller('AbsentReportCtrl',
            ['authService', 'attendanceService', 'MODULES', 'utilService', 'toastr', AbsentReportCtrl]);

    /** @ngInject */
    function AbsentReportCtrl(authService, attendanceService, MODULES, utilService, toastr) {

        var vm  = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.dateList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.type = "absents";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;


        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false,
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible: true
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };



        function search(searchParams) {
            resetVariables();
            vm.fromTime = new Date(searchParams.from);
            searchParams.reportType = 3;
            attendanceService.getLeaveLateAbsentReport(searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getLeaveLateAbsentReportExcelUrl(searchParams);
                vm.allAttendanceData = data.leaveLateAbsentPerDayList;
                vm.isDataLoaded = true;
                vm.numberOfPages = Math.ceil(vm.allAttendanceData.length/ parseInt(vm.numberOfRows));
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = 0;
                vm.offset = 0;
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });
        }

        function resetVariables() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = [];
            vm.dateList = [];
            vm.numberOfPages = 0;
            vm.offset = 0;
            vm.excelUrl = "";
            vm.selectedPage = 0;
            vm.numberOfButtons = 0;
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.allLogs')
        .controller('AllLogsCtrl',
            ['$scope','$state','editableOptions','editableThemes','departmentService','shiftGroupService','designationService','employmentTypeService','officeService','authService','workplaceService','employeeService','dashboardService', 'toastrService','utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS','attendanceService', '$sce', 'analyticsService', 'ANALYTICS_CONSTANT', AllLogsCtrl]);

    /** @ngInject */
    function AllLogsCtrl($scope, $state, editableOptions, editableThemes, departmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService,employeeService,dashboardService, toastrService,utilService, $timeout, _, GENDER, EMPLOYEE_STATUS,attendanceService, $sce, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.search = search;
        vm.getHoursMin = getHoursMin;
        vm.getRowsPerPage = getRowsPerPage;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.rowsPerPage = 10;
        vm.selectedPage = 0;
        vm.total = 0;
        vm.data = [];
        vm.searchParams = {};
        vm.employeeInformationMap = {};
        vm.dateWiseLocationRowspans = [];
        vm.dateWiseLocationReports = [];
        vm.reportTable = null;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : true
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getPunchReport(vm.searchParams).then(function (data) {
                vm.data = data;                
                vm.excelUrl = attendanceService.getAllLogsExcelUrl(vm.searchParams);
                vm.allAttendanceData = [];
                vm.dateRowspan = {};
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error,'', 5000);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = null;
            vm.dateList = [];
            // vm.isDataLoaded = true;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.status = null;
            vm.searchParams.order = "desc";
        }

        function getHoursMin(attTime){
            return dayjs(attTime).format('hh:mm A');
        }

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyLateReport')
        .controller('DailyLateReportCtrl',
            ['authService', 'attendanceService', 'utilService', '$stateParams', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', DailyLateReportCtrl]);

    /** @ngInject */
    function DailyLateReportCtrl(authService, attendanceService, utilService, $stateParams, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;


        vm.search = search;


        var loggedInUser = authService.getLoggedInUser();
        vm.attDateInMillis = $stateParams.attDateInMillis;
        vm.employmentTypeIds = $stateParams.employmentTypeIds;
        vm.subsidiaryIds = $stateParams.subsidiaryIds;
        vm.workplaceIds = $stateParams.workplaceIds;
        vm.allDailyLateData = [];
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.isDataLoaded = true;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.type = "absents";
        vm.loggedInUser = loggedInUser;
        vm.from = new Date();
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.getRowsPerPage = getRowsPerPage;
        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker: {
                show: false,
                collapsible: false
            },
            singleDatePicker: {
                show: true,
            },
            monthYearPicker: {
                show: false
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: false
            },
            subDepartmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter: {
                show: false,
                collapsible: false
            },
            deviceFilter: {
                show: false
            },
            leaveCategoryFilter: {
                show: false
            },
            pdfDownloadButton: {
                show: true,
                multipleOrientation: false
            },
            excelDownloadButton: {
                show: true
            },
            sortKey: {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function getRowsPerPage() {
            return Number(utilService.getRowsPerPage());
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            if($stateParams.attDateInMillis){
                vm.searchParams.from = vm.attDateInMillis;
                vm.searchParams.to = vm.attDateInMillis + (24 * 60 * 60 * 1000 - 1);
            }
            if($stateParams.employmentTypeIds){
                vm.searchParams.employmentTypeId = vm.employmentTypeIds;
            }
            if($stateParams.subsidiaryIds){
                vm.searchParams.subsidiaryId = vm.subsidiaryIds;
            }
            if($stateParams.workplaceIds){
                vm.searchParams.workplaceId = vm.workplaceIds;
            }
            vm.fromTime = new Date(searchParams.from);
            vm.searchParams.reportType = 5;
            console.log('Daily Late Report Search Params:', vm.searchParams);
            attendanceService.getDailyLateReport(vm.searchParams).then(function (data) {
                vm.allDailyLateData = data;
                vm.excelUrl = attendanceService.getDailyLateReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getDailyLateReportPdfUrl(vm.searchParams);
                // vm.totalAbsent = data.totalAbsent;
                // vm.totalLossHour = data.totalLossHour;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.totalLossHour = data.totalLossHour;
                vm.totalAbsent = data.totalAbsent;
                vm.totalEmployee = data.totalEmployee;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.date = data.date

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = 'daily';
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyReport')
        .controller('DailyReportCtrl',
            ['authService', 'attendanceService', '$scope','$stateParams', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', DailyReportCtrl]);

    /** @ngInject */
    function DailyReportCtrl(authService, attendanceService, $scope,$stateParams, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.checkedAttendanceStatus = $stateParams.checkedAttendanceStatus;
        vm.attDateInMillis = $stateParams.attDateInMillis;
        vm.employmentTypeIds = $stateParams.employmentTypeIds;
        vm.subsidiaryIds = $stateParams.subsidiaryIds;
        vm.workplaceIds = $stateParams.workplaceIds;
        vm.allAttendanceData = [];
        vm.rowsPerPage = 50;
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.dailySummary = {};
        vm.showLineManager = false;
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
            },
            singleDatePicker: {
              show: true,
              collapsible: false
            },
            monthYearPicker : {
                show : false,
                // collapsible : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : true
            },
            attendanceStatusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true,
                multiPage: true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);

            if($stateParams.checkedAttendanceStatus){
                vm.searchParams.attendanceStatus[0] = vm.checkedAttendanceStatus;
            }
            if($stateParams.attDateInMillis){
                vm.searchParams.from = vm.attDateInMillis;
                vm.searchParams.to = vm.attDateInMillis + (24 * 60 * 60 * 1000 - 1);
            }
            if($stateParams.employmentTypeIds){
                vm.searchParams.employmentTypeId = vm.employmentTypeIds;
            }
            if($stateParams.subsidiaryIds){
                vm.searchParams.subsidiaryId = vm.subsidiaryIds;
            }
            if($stateParams.workplaceIds){
                vm.searchParams.workplaceId = vm.workplaceIds;
            }

            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                // vm.excelUrl = attendanceService.getExcelUrl(vm.searchParams);
                vm.excelUrl = attendanceService.getDailyReportExcelUrl(vm.searchParams);
                vm.excelUrlAllPages = attendanceService.getDailyReportAllPagesExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getPdfUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getDailyReportPdfUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.startOfDayList = data.startOfDayList;
                vm.dateList = data.dates;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.showLineManager = data.showLineManager;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
            attendanceService.getDailyAttendanceSummary(vm.searchParams).then(function (data) {
                vm.dailySummary = data
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = 'daily';
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.departmentReport')
        .controller('DepartmentReportCtrl',
            ['attendanceService', '$scope', 'toastrService', '$stateParams', 'authService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', DepartmentReportCtrl]);

    /** @ngInject */
    function DepartmentReportCtrl(attendanceService, $scope, toastrService, $stateParams, authService, analyticsService, ANALYTICS_CONSTANT, MODULES) {
        var vm = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.departmentId = $stateParams.departmentId;
        vm.attDateInMillis = $stateParams.attDateInMillis;
        vm.employmentTypeIds = $stateParams.employmentTypeIds;
        vm.subsidiaryIds = $stateParams.subsidiaryIds;
        vm.workplaceIds = $stateParams.workplaceIds;
        vm.dateList = [];
        vm.isDataLoaded = false;
        vm.startOfDayList = [];
        vm.offset = 0;
        vm.excelUrl = "";
        vm.total = 0;
        vm.showLineManager = false;
        vm.searchParams = {};
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : true
            },
            attendanceStatusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            if($stateParams.departmentId){
                vm.searchParams.departmentId = vm.departmentId;
            }
            if($stateParams.attDateInMillis){
                vm.searchParams.from = vm.attDateInMillis;
                vm.searchParams.to = vm.attDateInMillis + (24 * 60 * 60 * 1000 - 1);
            }
            if($stateParams.employmentTypeIds){
                vm.searchParams.employmentTypeId = vm.employmentTypeIds;
            }
            if($stateParams.subsidiaryIds){
                vm.searchParams.subsidiaryId = vm.subsidiaryIds;
            }
            if($stateParams.workplaceIds){
                vm.searchParams.workplaceId = vm.workplaceIds;
            }
            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getExcelUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.startOfDayList = data.startOfDayList;
                vm.dateList = data.dates;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.showLineManager = data.showLineManager;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "department";
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedAttendanceReport')
        .controller('AttendanceReportPageCtrl',
            ['attendanceService','$scope','toastr', 'authService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', AttendanceReportPageCtrl]);

    /** @ngInject */
    function AttendanceReportPageCtrl(attendanceService, $scope, toastr, authService, analyticsService, ANALYTICS_CONSTANT, MODULES) {
        var vm = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.excelUrlAllPages = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : true
            },
            attendanceStatusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true,
                multiPage: true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getExcelUrl(vm.searchParams);
                vm.excelUrlAllPages = attendanceService.getExcelAllPagesUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.dateList = data.dates;
                vm.startOfDayList = data.startOfDayList;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.showLineManager = data.showLineManager;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = null;
            vm.dateList = [];
            // vm.isDataLoaded = true;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "detailed";
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedAttendanceReport')
        .controller('AttendanceReportRootCtrl',
            ['$window', AttendanceReportRootCtrl]);

    /** @ngInject */
    function AttendanceReportRootCtrl($window) {
        var vm = this;

        vm.showMobile = null;
        
        function init() {
           vm.showMobile = $window.innerWidth < 700 ;
        }
        init();
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedAttendanceReport')
        .controller('AttendanceReportTableCtrl',
            ['$scope','attendanceService', 'authService','$document','_', 'utilService', 'toastr', AttendanceReportTableCtrl]);

    /** @ngInject */
    function AttendanceReportTableCtrl($scope, attendanceService, authService, $document, _, utilService, toastr) {

        var vm  = this;

        vm.numberOfPages = null;
        vm.allData = {};
        vm.allData.showRows = 100;
        vm.allData.allAttendanceData = null;
        vm.selectedPaginationPage = 0;
        vm.dateList = null;
        vm.excelUrl = null;
        vm.isDataLoaded = null;
        vm.isFilterVisible = false;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        vm.hasPermission = utilService.hasPermission;
        vm.showSummary = utilService.hasPermission('4013');
        vm.showTotalHours = utilService.hasPermission('4014');
        vm.showLineManager = false;
        
        vm.reduceSelectedPaginationPage= reduceSelectedPaginationPage;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.showHideFilters = showHideFilters;

        vm.sortingMethods = {
            sortById : sortById,
            sortByName : sortByName,
            sortByDepartmentHierarchy : sortByDepartmentHierarchy,
            sortByDesignationHierarchy : sortByDesignationHierarchy,
            sortByShiftName : sortByShiftName

        };

        vm.prepareDataForPagination = prepareDataForPagination;
        vm.paginateData = paginateData;
        vm.exportToPdf = exportToPdf;
        vm.getPaginationInfo = getPaginationInfo;

        var sortStatus = {
            key: "employeeIdentifier",
            order: "ascending"
        };
        $scope.$on('attendanceReport-attendance-with-default-filters-loaded', function (event, date) {
            vm.isDataLoaded = false;
            attendanceService.getAttendance(date.startDate.valueOf(), date.endDate.valueOf(), null, null, null, null, null, null, [authService.getLoggedInUser().office.company.id], vm.isCompanyAdmin? null: [authService.getLoggedInUser().office.id]).then(function (responseData) {
                vm.isDataLoaded = true;
                vm.excelUrl = attendanceService.getExcelUrl(date.startDate.valueOf(), date.endDate.valueOf(), null,null, null, null, null, null, null, vm.isCompanyAdmin? null:[authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id]);
                vm.dateList = responseData.dates;
                vm.allData.allAttendanceData = responseData.attendance;
                vm.showLineManager = responseData.showLineManager;
                vm.prepareDataForPagination();
            }, function (message) {
                toastr.error("Cannot fetch attendance from server : " + message);
            });
        });

        $scope.$on('attendanceReport-search-attendance', function (event, attendanceSearchParameters) {
            var params = attendanceSearchParameters;
            vm.isDataLoaded = false;
            attendanceService.getAttendance(params.from, params.to, params.designations, params.departments, params.shifts, params.genders,
                params.id, params.name, params.companies, params.offices,params.employmentTypes,params.workplaces)
                .then(function (responseData) {
                    vm.isDataLoaded = true;
                    setDataToTable(responseData.dates, responseData.attendance);
                    vm.showLineManager = responseData.showLineManager;
                    vm.excelUrl = attendanceService.getExcelUrl(params.from, params.to, params.designations,params.employmentTypes, params.departments, params.shifts, params.genders, params.id, params.name, params.companies, params.offices);
                    }, function (message) {
                    toastr.error("Cannot fetch attendance from server : " + message);
                });
        });

        function getPaginationInfo() {
            var data = {
                selectedPage : vm.selectedPaginationPage,
                numberOfButtons : vm.numberOfButtons,
                allData : vm.allData.allAttendanceData,
                showingData : vm.attendanceList,
                showRows : vm.allData.showRows
            };

            return utilService.getPaginationInfo(data);
        }
        
        function showHideFilters() {
            vm.isFilterVisible = !vm.isFilterVisible;
            $scope.$emit('attendanceReport-show-filter', vm.isFilterVisible);
        }

        function setDataToTable  (dates, attendance) {
            vm.dateList = dates;
            vm.allData.allAttendanceData = attendance;
            vm.prepareDataForPagination();
        };

        function prepareDataForPagination () {
            vm.attendanceList = vm.allData.allAttendanceData.slice(0, parseInt(vm.allData.showRows));
            vm.numberOfPages = Math.ceil(_.size(vm.allData.allAttendanceData) / parseInt(vm.allData.showRows));
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.selectedPaginationPage = 0;
        };

        function paginateData (index) {
            vm.attendanceList = vm.allData.allAttendanceData.slice(index * parseInt(vm.allData.showRows), index * parseInt(vm.allData.showRows) + parseInt(vm.allData.showRows));
            vm.selectedPaginationPage = index;
        };

        function sortById() {
            if (sortStatus.key == "employeeIdentifier" && sortStatus.order == "ascending") {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, 'employeeIdentifier').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeIdentifier";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, 'employeeIdentifier');
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeIdentifier";
                sortStatus.order = "ascending";
            }
        }

        function sortByName() {
            if (sortStatus.key == "employeeName" && sortStatus.order == "ascending") {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, [function (employee) {
                    return employee.employeeName.toLowerCase();
                }]).reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeName";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, [function (employee) {
                    return employee.employeeName.toLowerCase();
                },['asc']]);
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeName";
                sortStatus.order = "ascending";
            }
        }

        function sortByDepartmentHierarchy() {
            if (sortStatus.key ==="departmentHierarchy" && sortStatus.order === "ascending") {
                vm.allData.allAttendanceData = vm.allData.allAttendanceData.sort(function(a, b) {
                    return (a.departmentHierarchy===null)-(b.departmentHierarchy===null) || -(a.departmentHierarchy>b.departmentHierarchy)||+(a.departmentHierarchy<b.departmentHierarchy);
                });

                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "departmentHierarchy";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = vm.allData.allAttendanceData.sort(function (a,b) {
                    return (a.departmentHierarchy===null)-(b.departmentHierarchy===null) || +(a.departmentHierarchy>b.departmentHierarchy)||-(a.departmentHierarchy<b.departmentHierarchy);

                });
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "departmentHierarchy";
                sortStatus.order = "ascending";
            }
        }

        function sortByDesignationHierarchy() {
            if (sortStatus.key == "designationHierarchy" && sortStatus.order == "ascending") {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, 'designationHierarchy').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "designationHierarchy";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, 'designationHierarchy');
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "designationHierarchy";
                sortStatus.order = "ascending";
            }
        }

        function sortByShiftName() {
            if (sortStatus.key == "shiftName" && sortStatus.order == "ascending") {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, 'shiftName').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "shiftName";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, 'shiftName');
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "shiftName";
                sortStatus.order = "ascending";
            }
        }

        function reduceSelectedPaginationPage() {
            vm.selectedPaginationPage = vm.selectedPaginationPage === 0 ? 0 : vm.selectedPaginationPage - 1;
            paginateData(vm.selectedPaginationPage);
        }

        function increaseSelectedPaginationPage() {
            vm.selectedPaginationPage = vm.selectedPaginationPage === vm.numberOfButtons.length - 1 ? vm.selectedPaginationPage : vm.selectedPaginationPage +1;
            paginateData(vm.selectedPaginationPage);
        }

        function exportToPdf  () {
            var table = angular.element( $document[0].querySelector('#attendanceTable')).html();
            var mywindow = window.open('', 'new div', 'height=400,width=600');

            mywindow.document.write('<html><head><title>Attendance Report</title>');

            mywindow.document.write('<script src="../bower_components/angular/angular.js"></script>')
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css" />');
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-select/dist/css/bootstrap-select.css"/>');
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css"/>');
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/bootstrap-tagsinput/dist/bootstrap-tagsinput.css"/>');
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/main.css" />');
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="app/styles.css"  >');
            mywindow.document.write('<link rel="stylesheet" type="text/css" href="../bower_components/angular-ui-switch/angular-ui-switch.css" />');

            mywindow.document.write('</head><body><table id = "printTable" class="table" style="color: black!important;background-color: white!important;">');
            mywindow.document.write(table);
            mywindow.document.write('</table></body></html>');

            mywindow.document.close();
            setTimeout(function(){mywindow.print();
                mywindow.close()},2000);

        };

    }

})();

/*
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes.
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 *
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module( 'InovaceClientApp.pages.main.attendanceReport' ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict:
            'AE',

        scope:
            {
                // models
                inputModel      : '=',
                outputModel     : '=',
                // settings based on attribute
                isDisabled      : '=',
                // callbacks
                onClear         : '&',
                onClose         : '&',
                onSearchChange  : '&',
                onItemClick     : '&',
                onOpen          : '&',
                onReset         : '&',
                onSelectAll     : '&',
                onSelectNone    : '&',
                newInputMethod  : '=',
                showAddModel    : '=',

                // i18n
                translation     : '='
            },

        /*
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */

        templateUrl:
            'isteven-multi-select.htm',

        link: function ( $scope, element, attrs ) {

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };
            $scope.tabIndex         = 0;
            $scope.lang             = {};
            // $scope.helperStatus     = {
            //     add     : true,
            //     all     : true,
            //     none    : true,
            //     reset   : true,
            //     filter  : true
            // };
            // console.log($scope.showAddModel)
            if($scope.showAddModel){
                $scope.helperStatus     = {
                    add     : true,
                    all     : true,
                    none    : true,
                    reset   : true,
                    filter  : true
                };
            }
            else{
                $scope.helperStatus     = {
                    add     : false,
                    all     : true,
                    none    : true,
                    reset   : true,
                    filter  : true
                };
            }
            var
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }

                    // if it's data
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {

                        // If we set the search-key attribute, we use this loop.
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if (
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if (
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }
                        }

                        if ( gotData === true ) {
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined'
                            && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }

                $scope.filteredModel.reverse();
                if($scope.showAddModel && $scope.inputModel != null ) $scope.helperStatus.add = true;
                else $scope.helperStatus.add = false;

                $timeout( function() {

                    $scope.getFormElements();

                    // Callback: on filter change
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];
                                }
                            }
                        });

                        $scope.onSearchChange({
                            data:
                                {
                                    keyword: $scope.inputLabel.labelFilter,
                                    result: filterObj
                                }
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated.
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {
                formElements = [];

                var
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];

                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset) {
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {
                        // Get helper - search and clear button.
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {
                        // Get helper - search and clear button.
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }

                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter && !$scope.helperStatus.add ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[]
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }
            }

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true;
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false;
                return true;
            }

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {
                    return false;
                }

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }

                var index = $scope.filteredModel.indexOf( item );

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }

                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index )
                        {
                            break;
                        }

                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {

                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1;
                            }
                            nestLevel = nestLevel + 1;
                        }

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;

                            // cek if all are ticked or not
                            if ( tempArr.length > 0 && nestLevel === 0 ) {

                                var allTicked = true;

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // if data
                        else {
                            tempArr.push( $scope.filteredModel[ i ] );
                        }
                    }
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {

                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;
                        }
                        for( i=0 ; i < $scope.inputModel.length ; i++) {
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;
                        }

                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;
                    }

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];
                }

                // we execute the callback function here
                clickedItem = angular.copy( item );
                if ( clickedItem !== null ) {
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;
                    }, 0 );
                }

                $scope.refreshOutputModel();
                $scope.refreshButton();

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;

                // Set focus on the hidden checkbox
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );
                }
            }

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {

                $scope.outputModel  = [];
                var
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {
                    outputProps = attrs.outputProperties.split(' ');
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if (
                            typeof value !== 'undefined'
                            && typeof value[ attrs.groupProperty ] === 'undefined'
                            && value[ $scope.tickProperty ] === true
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {
                                if ( outputProps.indexOf( key1 ) > -1 ) {
                                    tempObj[ key1 ] = value1;
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];
                        }
                    });
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if (
                            typeof value !== 'undefined'
                            && typeof value[ attrs.groupProperty ] === 'undefined'
                            && value[ $scope.tickProperty ] === true
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];
                        }
                    });
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';
                var ctr                 = 0;

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }

                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {
                            if ( ctr < tempMaxLabels ) {
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {

                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {
                    return true;
                }
                else {
                    if ( $scope.isDisabled === true ) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {

                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );
                var label   = '';

                angular.forEach( temp, function( value, key ) {
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ];
                    }, item ));
                });

                if ( type.toUpperCase() === 'BUTTONLABEL' ) {
                    return label;
                }
                return $sce.trustAsHtml( label );
            }

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {

                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect
                // His version is awesome if you need a more simple multi-select approach.

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {

                    angular.element( checkBoxLayer ).removeClass( 'show' );
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                }
                // open
                else
                {
                    // clear filter
                    $scope.inputLabel.labelFilter = '';
                    $scope.updateFilter();

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );

                    // Attach change event listener on the input filter.
                    // We need this because ng-change is apparently not an event listener.
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );

                    // to get the initial tab index, depending on how many helper elements we have.
                    // priority is to always focus it on the input filter
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];

                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }

                    // focus on the filter element on open.
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {
                        element[ 0 ].querySelector( '.inputFilter' ).focus();
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {
                        if ( !$scope.isDisabled ) {
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }
                        }
                    }
                    element.children().children()[ 0 ].style.opacity = 1;

                    // open callback
                    $scope.onOpen();
                }
            }

            // handle clicks outside the button / multi select layer
            element.children().children()[ 0 ].style.opacity = .7;

            $scope.externalClickListener = function( e ) {

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }
                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );

                // close callback
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
                element.children().children()[ 0 ].style.opacity = 1;

            }

            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ADD':
                        $scope.newInputMethod($scope.inputLabel.labelFilter);
                        $scope.inputLabel.labelFilter = '';
                        break;

                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onSelectAll();
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onSelectNone();
                        break;
                    case 'RESET':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                var temp = value[ $scope.indexProperty ];
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onReset();
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();
                        break;
                    case 'FILTER':
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:
                }
            }

            // just to create a random variable name
            function genRandomString( length ) {
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                    temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) {

                var key = e.keyCode ? e.keyCode : e.which;
                var isNavigationKey = false;

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }


                // next element ( tab, down & right key )
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {

                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex;
                    $scope.tabIndex++;
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1;
                    }
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;
                        }
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }
                }

                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) {
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex;
                    $scope.tabIndex--;
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }
                    }
                }

                if ( isNavigationKey === true ) {

                    e.preventDefault();

                    // set focus on the checkbox
                    formElements[ $scope.tabIndex ].focus();
                    var actEl = document.activeElement;

                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    }
                }

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;

            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;

            // set orientation css
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );
            }

            // some flags for easier checking
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {
                    if (
                        typeof attrs.helperElements !== 'undefined'
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to.
            $scope.icon        = {};
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon

            // configurable button labels
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );
            }
            else {
                $scope.lang.addNew       = $sce.trustAsHtml( '&nbsp;&nbsp;Add New' );
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'Please Select';
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );

            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/

            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8
            $scope.$watch( 'inputModel' , function( newVal ) {
                if ( newVal ) {
                    $scope.refreshOutputModel();
                    $scope.refreshButton();
                }
            }, true );

            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();
                    $scope.refreshOutputModel();
                    $scope.refreshButton();
                }
            });

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {
                $scope.isDisabled = newVal;
            });

            // this is for touch enabled devices. We don't want to hide checkboxes on scroll.
            var onTouchStart = function( e ) {
                $scope.$apply( function() {
                    $scope.scrolled = false;
                });
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) {
                $scope.$apply( function() {
                    $scope.scrolled = true;
                });
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
                angular.element( document ).unbind( 'touchstart', onTouchStart);
                angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template =
        '<span class="multiSelect inlineBlock">' +
        // main button
        '<button id="{{directiveId}}" type="button"' +
        'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
        'ng-bind-html="varButtonLabel"' +
        'ng-disabled="disable-button"' +
        'class="btn-text-overflow"' +
        'style="white-space: nowrap">' +
        '</button>' +
        // overlay layer
        '<div class="checkboxLayer">' +
        // container of the helper elements
        '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset || helperStatus.add ">' +
        // container of the first 3 buttons, select all, none and reset
        '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset || helperStatus.add">' +

        '<button type="button" class="helperButton"' +
        'ng-disabled="!inputLabel.labelFilter || inputLabel.labelFilter.length < 1"' +
        'ng-if="helperStatus.add"' +
        'ng-click="select( \'add\', $event );">' +
        'Add New' +
        '</button>'+
        // select all
        '<button type="button" class="helperButton"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.all"' +
        'ng-click="select( \'all\', $event );"' +
        'ng-bind-html="lang.selectAll">' +
        '</button>'+
        // select none
        '<button type="button" class="helperButton"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.none"' +
        'ng-click="select( \'none\', $event );"' +
        'ng-bind-html="lang.selectNone">' +
        '</button>'+
        // reset
        '<button type="button" class="helperButton reset"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.reset"' +
        'ng-click="select( \'reset\', $event );"' +
        'ng-bind-html="lang.reset">'+
        '</button>' +
        '</div>' +
        // the search box
        '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
        // textfield
        '<input placeholder="{{lang.search}}" type="text"' +
        'ng-click="select( \'filter\', $event )" '+
        'ng-model="inputLabel.labelFilter" '+
        'ng-change="searchChanged()" class="inputFilter"'+
        '/>'+
        // clear button
        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
        '</div> '+
        '</div> '+
        // selection items
        '<div class="checkBoxContainer">'+
        '<div '+
        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
        'ng-click="syncItems( item, $event, $index );" '+
        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
        // this is the spacing for grouped items
        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+
        '</div>  '+
        '<div class="acol">'+
        '<label>'+
        // input, so that it can accept focus on keyboard click
        '<input class="checkbox focusable" type="checkbox" '+
        'ng-disabled="itemIsDisabled( item )" '+
        'ng-checked="item[ tickProperty ]" '+
        'ng-click="syncItems( item, $event, $index )" />'+
        // item label using ng-bind-hteml
        '<span '+
        'ng-class="{disabled:itemIsDisabled( item )}" '+
        'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
        '</span>'+
        '</label>'+
        '</div>'+
        // the tick/check mark
        '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
        '</div>'+
        '</div>'+
        '</div>'+
        '</span>';
    $templateCache.put( 'isteven-multi-select.htm' , template );
}]);
/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport')
        .directive('selectpicker', selectpicker);

    /** @ngInject */
    function selectpicker() {
        return {
            restrict: 'A',
            require: '?ngOptions',
            priority: 1500, // make priority bigger than ngOptions and ngRepeat
            link: {
                pre: function(scope, elem, attrs) {
                    elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
                },
                post: function(scope, elem, attrs) {
                    function refresh() {
                        elem.selectpicker('refresh');
                    }

                    if (attrs.ngModel) {
                        scope.$watch(attrs.ngModel, refresh);
                    }

                    if (attrs.ngDisabled) {
                        scope.$watch(attrs.ngDisabled, refresh);
                    }

                    elem.selectpicker({ dropupAuto: false, hideDisabled: true });
                }
            }
        };
    }


})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedMonthlyReport')
        .controller('DetailedMonthlyReportCtrl',
            ['authService','attendanceService','utilService','$scope', '$sce', '$uibModal', 'toastr', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', DetailedMonthlyReportCtrl]);

    /** @ngInject */
    function DetailedMonthlyReportCtrl(authService,attendanceService,utilService,$scope, $sce, $uibModal, toastr, analyticsService, ANALYTICS_CONSTANT, MODULES) {
        var vm = this;

        vm.search = search;
        vm.findTimesheetApproval = findTimesheetApproval;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.rowsPerPage = 50;
        vm.total = null;
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.verticalPdfUrl = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.selectedYear = 0;
        vm.selectedMonth = 0;
        vm.timesheetApproval = [];
        vm.searchParams = {};
        vm.timesheetApprovalStatusHtml = "";
        vm.timesheetApplicationId = null;
        vm.showTimesheetApprovalButton = false;
        vm.overallSummary = null;
        vm.showLineManager = false;
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : true,
                collapsible : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : true
            },
            attendanceStatusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: true
            },
            excelDownloadButton : {
                show : true,
                multiPage: true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };


        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.fromTime = new Date(vm.searchParams.from);
            vm.searchParams.type = 0;
            vm.searchParams.reportType = 0;
            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getDetailedMonthlyReportExcelUrl(vm.searchParams);
                vm.excelUrlAllPages = attendanceService.getDetailedMonthlyReportExcelUrlAllPages(vm.searchParams);
                vm.pdfUrl = attendanceService.getDetailedMonthlyReportPdfUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getMonthlyReportPdfUrlOld(vm.searchParams);
                vm.verticalPdfUrl = attendanceService.getMonthlyVerticalReportPdfUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.dateList = data.dateAndDay;
                vm.monthYear = data.monthYear;
                vm.startOfDayList = data.startOfDayList;
                vm.overallSummary = data.summary;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
                vm.showLineManager = data.showLineManager;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });
            // searchParams.month = searchParams.month + 1;
            if(searchParams.year)
                vm.selectedYear = searchParams.year;
            if(searchParams.month)
                vm.selectedMonth = searchParams.month;
            if(vm.loggedInUser.isLineManager){
                searchParams.lineManagerId = vm.loggedInUser.id;
            }

            if((vm.loggedInUser.isLineManager || vm.loggedInUser.isHrManager || vm.loggedInUser.isAdmin) && searchParams.month < new Date().getMonth()+1) {
                attendanceService.getMonthlyTimesheetApproval(searchParams).then(function (data) {
                    vm.timesheetApproval = data.applicationsList;
                    determineTimesheetApprovalStatus();
                });
            }
        }
        function findTimesheetApproval() {
            var searchParams =
            {
                year: vm.selectedYear,
                month: vm.selectedMonth,
            }
            if(vm.loggedInUser.isLineManager){
                searchParams.lineManagerId = vm.loggedInUser.id;
            }
            if((vm.loggedInUser.isLineManager || vm.loggedInUser.isHrManager || vm.loggedInUser.isAdmin) && searchParams.month < new Date().getMonth()+1) {
                attendanceService.getMonthlyTimesheetApproval(searchParams).then(function (data) {
                    vm.timesheetApproval = data.applicationsList;
                    determineTimesheetApprovalStatus();
                }, function (message) {
                    console.log(message);
                });
            }
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "monthly";
        }

        function determineTimesheetApprovalStatus(){
            if(vm.selectedMonth >= new Date().getMonth() || vm.timesheetApproval.length === 0) return;
            if(vm.loggedInUser.isLineManager){
                if(vm.timesheetApproval[0].lineManagerApprovalStatus == 1){
                    vm.timesheetApprovalStatusHtml = "<span class=\"text-success\"><i class=\"ion-ios-timer-outline\"></i>&nbsp;Timesheet Approved</span>\n";
                } else{
                    vm.showTimesheetApprovalButton = true;
                    if(vm.timesheetApproval[0].lineManagerApprovalStatus == 0){
                        vm.timesheetApprovalStatusHtml = "<span><i class=\"ion-android-checkbox-outline-blank\"></i>&nbsp;Pending Approval</span>";
                    } else if(vm.timesheetApproval[0].lineManagerApprovalStatus == 2){
                        vm.timesheetApprovalStatusHtml = "<span><i class=\"ion-android-checkbox-outline-blank\"></i>&nbsp;Reapprove</span>";
                    }
                }
            } else if(vm.loggedInUser.isHrManager || vm.loggedInUser.isAdmin){
                if(vm.timesheetApproval[0].status == 1)
                    vm.timesheetApprovalStatusHtml = "<span class=\"text-success\"><i class=\"ion-ios-timer-outline\"></i>&nbsp;Timesheet Approved</span>\n";
                else if(vm.timesheetApproval[0].status == 0)
                    vm.timesheetApprovalStatusHtml = "<span class=\"text-danger\"><i class=\"ion-ios-timer-outline\"></i>&nbsp;Approval Pending</span>\n";
            }
            vm.timesheetApplicationId = vm.timesheetApproval[0].id;
            vm.timesheetApprovalStatusHtml = $sce.trustAsHtml(vm.timesheetApprovalStatusHtml);
        }

        function openTimeSheetApproveModal(applicationId) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/directives/monthlyAttendanceTable/monthlyTimeSheetModals/approve.modal.html',
                size : 'md',
                controller : 'ApproveMonthlyTimeSheetModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    applicationId : function () {
                        return applicationId;
                    }
                }
            }).result.then(function () {
                findTimesheetApproval();
            });
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });

        $scope.$on("approveTimesheet", function (event, applicationId) {
            openTimeSheetApproveModal(applicationId);
        });

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.fieldVisitReport')
        .controller('FieldVisitReportCtrl',
            ['employeeService', '$scope', 'toastrService','$sce', 'authService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', FieldVisitReportCtrl]);

    /** @ngInject */
    function FieldVisitReportCtrl(employeeService, $scope, toastrService,$sce, authService, analyticsService, ANALYTICS_CONSTANT, MODULES) {
        var vm = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.dateList = [];
        vm.isDataLoaded = false;
        vm.startOfDayList = [];
        vm.offset = 0;
        vm.excelUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.searchParams.applicationStatus = [0,1,2,3];
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.changeApplicationStatus = changeApplicationStatus;

        function changeApplicationStatus(val){
            vm.searchParams.applicationStatus = val;
            search(0);
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.searchParams.manualEntryType = [3];
            employeeService.getPaginatedManualEntryList(vm.searchParams).then(function (data) {
                vm.excelUrl = employeeService.getManualEntryExcelUrl(vm.searchParams);
                vm.excelUrl = vm.excelUrl + "&manualEntryType=3";
                vm.excelUrl = vm.excelUrl + "&applicationStatus="+vm.searchParams.applicationStatus.join(',');
                vm.fieldVisitData = data.manualEntries;
                vm.fieldVisitData = _.map(data.manualEntries,function (manualEntry) {
                    manualEntry.firstApproverApprovalDisplayString = $sce.trustAsHtml(manualEntry.firstApproverApprovalDisplayString);
                    manualEntry.secondApproverApprovalDisplayString = $sce.trustAsHtml(manualEntry.secondApproverApprovalDisplayString );
                    return manualEntry;
                });
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.page;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                var a = vm.searchParams.applicationStatus;
                vm.searchParams = searchParams;
                vm.searchParams.applicationStatus = a;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }

        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.individualAttendanceReport')
        .controller('IndividualAttendanceReportCtrl',
            ['$state', '$timeout', 'authService', 'utilService', 'attendanceService', 'employeeService', '$scope', 'toastrService', 'generalSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', 'REPORT_SETTINGS', '$uibModal', 'GP_CLIENT_OFFICE_IDS', IndividualAttendanceReportCtrl]);

    /** @ngInject */
    function IndividualAttendanceReportCtrl($state, $timeout, authService, utilService, attendanceService, employeeService, $scope, toastrService, generalSettingsService, analyticsService, ANALYTICS_CONSTANT, REPORT_SETTINGS, $uibModal, GP_CLIENT_OFFICE_IDS) {

        var vm = this;
        vm.searchText = "";
        vm.focus = false;
        var loggedInUser = authService.getLoggedInUser();
        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.allAttendanceData = [];
        vm.searchKeyword = null;
        utilService.setRowsPerPage(31);
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.searchParams.pageNumber = 0;

        vm.searchParams.employeeId = loggedInUser.id;
        vm.individualSummary = {};
        vm.selectedMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.monthPicker = {};
        vm.monthPicker.opened = false;
        vm.monthPicker.format = "MMMM yyyy";
        var currentDate = new Date();
        vm.monthPicker.options = {
            datepickerMode: 'month',
            minDate: vm.isGpClient ? new Date(currentDate.getFullYear(), currentDate.getMonth(), 1) : new Date(new Date().setMonth(currentDate.getMonth() - REPORT_SETTINGS.viewMonthLimit, 1)),
            maxDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.allowAllDownload = false;

        vm.search = search;
        vm.exportAsPdf = exportAsPdf;
        vm.exportAsExcel = exportAsExcel;
        vm.openMonthPicker = openMonthPicker;
        function init(){
            generalSettingsService.getReportSettingsOfAnOffice().then(function (response) {
                vm.allowAllDownload = response.allowAllDownload;
            });
            search();
        }
        init();


        vm.searchByEmployeeId = function (selectedEmployee) {
            vm.searchParams.employeeId = selectedEmployee.id;
            vm.searchText = selectedEmployee.name;
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            search();
        }


        function openMonthPicker() {
            vm.monthPicker.opened = true;
        }

        function getStartOfMonthFromMomentInMillis(d) {
            return d.startOf('month').format('x');
        }

        function getEndOfMonthFromMomentInMillis(d) {
            return d.endOf('month').format('x');
        }

        $scope.$watch('vm.monthPicker.opened', function (newVal, oldVal) {
            if (!newVal) {
                search();
            }
        })


        function search(searchParams) {
            utilService.setRowsPerPage(vm.rowsPerPage)
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            if (vm.selectedMonth != null) {
                var selectedTime = moment().year(vm.selectedMonth.getFullYear()).month(vm.selectedMonth.getMonth());
                vm.searchParams.from = Number(getStartOfMonthFromMomentInMillis(selectedTime));
                vm.searchParams.to = Number(getEndOfMonthFromMomentInMillis(selectedTime));

                if (vm.searchParams.to > new Date().valueOf()) {
                    var date = new Date();
                    vm.searchParams.to = new Date().setHours(date.getHours(), 0, 0, 0).valueOf();
                }
            } else {
                return toastrService.showErrorToastr('Please select month and year:', '', 5000);
            }

            vm.searchParams.perPage = vm.rowsPerPage;

            attendanceService.getIndividualAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getIndividualMonthlyAttendanceExcelUrl(vm.searchParams, vm.allowAllDownload);
                vm.pdfUrl = attendanceService.getIndividualMonthlyAttendancePdfUrl(vm.searchParams, vm.allowAllDownload);

                vm.allAttendanceData = data.attendanceReportRows;
                vm.isDataLoaded = true;
                vm.total = data.total;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.reportTime = data.reportTime;
                vm.individualSummary = data.summary;
                if (vm.individualSummary.allowOvertime == true) {
                    vm.overtimeStatus = "Overtime Allowed";
                } else {
                    vm.overtimeStatus = "Overtime Not Allowed";
                }


                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                } else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function exportAsExcel() {
            // if(isDownloadMonthLimitExceeded()) {
            //     return openDownloadWarningModal();
            // }

            if (vm.excelUrl != null && vm.excelUrl.trim() !== "") {

                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel)

            }
        }

        function exportAsPdf() {
            // if(isDownloadMonthLimitExceeded()) {
            //     return openDownloadWarningModal();
            // }

            if (vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
                window.open(vm.pdfUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf)

            }
        }

        function isDownloadMonthLimitExceeded() {
            var downloadMinDate = new Date(new Date().setMonth(currentDate.getMonth() - REPORT_SETTINGS.downloadMonthLimit, 1));
            downloadMinDate.setHours(0, 0, 0, 0);
            return vm.selectedMonth < downloadMinDate;
        }

        function openDownloadWarningModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/reportDownloadWarningModal/reportDownloadWarning.modal.html',
                size         : 'md',
                controller   : 'ReportDownloadWarningModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
            }).result.then(function () {});
        }


    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.lateReport')
        .controller('LateReportCtrl',
            ['authService', 'attendanceService','utilService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', LateReportCtrl]);

    /** @ngInject */
    function LateReportCtrl(authService, attendanceService, utilService, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;

        vm.search = search;

        vm.allAttendanceData = [];
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.dateList = [];
        vm.isDataLoaded = false;
        vm.numberOfPages = 0;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.type = "lates";
        var loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false,
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false,
                collapsible : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };


        function search(searchParams) {
            resetVariables();
            vm.fromTime = new Date(searchParams.from);
            searchParams.reportType = 2;
            attendanceService.getLeaveLateAbsentReport(searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getLeaveLateAbsentReportExcelUrl(searchParams);
                vm.pdfUrl = attendanceService.getLateReportPdfUrl(searchParams);
                vm.allAttendanceData = data.leaveLateAbsentPerDayList;
                vm.isDataLoaded = true;
                vm.numberOfPages = Math.ceil(vm.allAttendanceData.length/ parseInt(vm.numberOfRows));
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = 0;
                vm.offset = 0;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function resetVariables() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = [];
            vm.dateList = [];
            vm.numberOfPages = 0;
            vm.offset = 0;
            vm.excelUrl = "";
            vm.selectedPage = 0;
            vm.numberOfButtons = 0;
        }



    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.leaveReport')
        .controller('LeaveReportCtrl',
            ['authService', 'attendanceService','utilService', 'toastrService', 'MODULES', LeaveReportCtrl]);

    /** @ngInject */
    function LeaveReportCtrl(authService, attendanceService, utilService, toastrService, MODULES) {
        var vm = this;

        vm.search = search;

        vm.allAttendanceData = [];
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.dateList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.type = "leaves";
        var loggedInUser = authService.getLoggedInUser();
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.fromTime = new Date();

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false,
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : true
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false,
                collapsible : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            resetVariables();
            vm.fromTime = new Date(searchParams.from);
            searchParams.reportType = 1;
            attendanceService.getLeaveLateAbsentReport(searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getLeaveLateAbsentReportExcelUrl(searchParams);
                vm.allAttendanceData = data.leaveLateAbsentPerDayList;
                vm.isDataLoaded = true;
                vm.numberOfPages = Math.ceil(vm.allAttendanceData.length/ parseInt(vm.numberOfRows));
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = 0;
                vm.offset = 0;
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, "", 5000);
            });
        }

        function resetVariables() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = [];
            vm.dateList = [];
            vm.numberOfPages = 0;
            vm.offset = 0;
            vm.excelUrl = "";
            vm.selectedPage = 0;
            vm.numberOfButtons = 0;
        }


    }

})();


(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.locationDeviationReport')
        .controller('LocationDeviationReportCtrl',
            ['attendanceService', '$scope', 'toastr', 'authService', LocationDeviationReportCtrl]);

    /** @ngInject */
    function LocationDeviationReportCtrl(attendanceService, $scope, toastr, authService) {
        var vm = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.excelUrlAllPages = "";
        vm.total = 0;
        vm.numberOfPages = 0;
        vm.numberOfButtons = [];
        vm.selectedPage = 0;
        vm.showLineManager = false;
        vm.filterConfig = {
            companyFilter: { show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin },
            officeFilter: { show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin },
            dateRangePicker: { show: true, collapsible: false },
            singleDatePicker: { show: false },
            monthYearPicker: { show: false },
            departmentFilter: { show: !loggedInUser.isGroupAdmin, collapsible: true },
            subDepartmentFilter: { show: !loggedInUser.isGroupAdmin, collapsible: true },
            designationFilter: { show: !loggedInUser.isGroupAdmin },
            shiftGroupFilter: { show: !loggedInUser.isGroupAdmin },
            genderFilter: { show: !loggedInUser.isGroupAdmin },
            employmentTypeFilter: { show: !loggedInUser.isGroupAdmin },
            workplaceFilter: { show: !loggedInUser.isGroupAdmin },
            lineManagerFilter: { show: false },
            hrManagerFilter: { show: false },
            statusFilter: { show: true, collapsible: true },
            attendanceStatusFilter: { show: false, collapsible: false },
            deviceFilter: { show: false },
            leaveCategoryFilter: { show: false },
            pdfDownloadButton: { show: false, multipleOrientation: false },
            excelDownloadButton: { show: true, multiPage: true },
            sortKey: { show: true },
            leaveStatusFilter: { show: false, collapsible: false }
        };

        vm.searchParams = {};

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getLocationDeviationReport(vm.searchParams).then(function (res) {
                vm.excelUrl = attendanceService.getLocationDeviationExcelUrl(vm.searchParams);
                vm.excelUrlAllPages = attendanceService.getLocationDeviationExcelAllPagesUrl(vm.searchParams);
                var payload = (res && res.data) ? res.data : res;
                buildViewModel(payload);

                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error && (error.message || error));
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = [];
            vm.dateList = [];
            vm.startOfDayList = [];
            vm.numberOfPages = 0;
            vm.total = 0;
            vm.numberOfButtons = [];
            vm.selectedPage = 0;
        }

        function modifyParams(searchParams) {
            if (typeof searchParams === 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams === 'prev') { vm.searchParams.pageNumber--; }
                else if (searchParams === 'next') { vm.searchParams.pageNumber++; }
                else if (!isNaN(searchParams)) { vm.searchParams.pageNumber = searchParams; }
            }
            vm.searchParams.reportType = "detailed";
        }

        function buildViewModel(api) {
            if (!api || !api.employeeLocationDeviationDataList) {
                return;
            }

            var keyMap = {};
            for (var i = 0; i < api.employeeLocationDeviationDataList.length; i++) {
                var emp = api.employeeLocationDeviationDataList[i];
                var m = (emp && emp.perDayLocationDeviationDataMap) ? emp.perDayLocationDeviationDataMap : {};
                for (var k in m) {
                    if (m.hasOwnProperty(k)) {
                        keyMap[Number(k)] = true;
                    }
                }
            }

            var startOfDays = Object.keys(keyMap).map(function (x) { return Number(x); })
                .sort(function (a, b) { return a - b; });

            vm.startOfDayList = startOfDays;

            vm.dateList = [];
            for (var dIdx = 0; dIdx < startOfDays.length; dIdx++) {
                vm.dateList.push(formatYMD(startOfDays[dIdx]));
            }

            vm.total = api.total || api.employeeLocationDeviationDataList.length || 0;
            vm.numberOfPages = api.totalPages || 1;

            vm.numberOfButtons = [];
            for (var nb = 0; nb < vm.numberOfPages; nb++) { vm.numberOfButtons.push(1); }

            vm.selectedPage = api.currentPage || 0;

            vm.allAttendanceData = [];
            for (var e = 0; e < api.employeeLocationDeviationDataList.length; e++) {
                var raw = api.employeeLocationDeviationDataList[e];
                var info = raw.employeeInformation || {};
                var perDay = raw.perDayLocationDeviationDataMap || {};

                var attendance = {};
                for (var s = 0; s < startOfDays.length; s++) {
                    var sod = startOfDays[s];
                    var day = perDay[sod];

                    if (!day) {
                        attendance[sod] = { isPresent: false };
                    } else {
                        var fe = splitLocationTime(day.firstEntryLocationAndTime);
                        var le = splitLocationTime(day.lastExitLocationAndTime);

                        var otherPunchesArr = [];
                        if (day.punchInOtherLocationAndTime && day.punchInOtherLocationAndTime.length) {
                            for (var p = 0; p < day.punchInOtherLocationAndTime.length; p++) {
                                var sp = splitLocationTime(day.punchInOtherLocationAndTime[p]);
                                otherPunchesArr.push({
                                    location: sp.location || '',
                                    time:     sp.time || ''
                                });
                            }
                        }

                        attendance[sod] = {
                            isPresent: true,
                            firstLoggedTime: fe.time || '',
                            lastLoggedTime:  le.time || '',
                            otherPunches: otherPunchesArr,
                            firstLocation:  fe.location || '',
                            lastLocation:   le.location || ''
                        };
                    }
                }

                vm.allAttendanceData.push({
                    employeeId: info.id,
                    employeeOfficeId: info.employeeOfficeId,
                    employeeName: info.name,
                    departmentName: info.departmentName,
                    designationName: info.designationName,
                    employmentTypeName: info.employmentTypeName,
                    shiftGroupName: info.shiftGroupName,
                    shiftStartTime: info.shiftStartTime,
                    shiftEndTime: info.shiftEndTime,
                    workplaceName: info.workplaceName,
                    attendance: attendance
                });
            }
        }

        function splitLocationTime(str) {
            if (!str || typeof str !== 'string') return { location: '', time: '' };
            var s = trimStr(str);

            var m = s.match(/^(.*?)[\s]*[-–—][\s]*(\d{1,2}:\d{2}\s?(AM|PM))$/i);
            if (m && m[1]) {
                return { location: trimStr(m[1]), time: trimStr(m[2]) };
            }

            var lastDash = Math.max(s.lastIndexOf('-'), s.lastIndexOf('–'), s.lastIndexOf('—'));
            if (lastDash === -1) {
                return { location: s, time: '' };
            }
            return {
                location: trimStr(s.substring(0, lastDash)),
                time:     trimStr(s.substring(lastDash + 1))
            };
        }


        function formatYMD(ms) {
            try {
                var d = new Date(Number(ms));
                var dd = pad2(d.getDate());
                var monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                var mon = monthNames[d.getMonth()];
                var yyyy = d.getFullYear();
                return dd + ' ' + mon + ' ' + yyyy;
            } catch (e) {
                return String(ms);
            }
        }

        function pad2(n) {
            n = Number(n);
            return (n < 10 ? '0' + n : '' + n);
        }

        function trimStr(s) {
            return (s && s.replace) ? s.replace(/^\s+|\s+$/g, '') : s;
        }

        $scope.$on("printEvent", function () { $scope.$broadcast("printReport"); });
    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.locationTrackingReport')
        .controller('LocationTrackingReportCtrl',
            ['$scope', '$state', 'authService', 'toastrService', 'attendanceService', 'utilService', '$sce', '$compile', '$uibModal', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', LocationTrackingReportCtrl]);

    /** @ngInject */
    function LocationTrackingReportCtrl($scope, $state, authService, toastrService, attendanceService, utilService, $sce, $compile, $uibModal, analyticsService, ANALYTICS_CONSTANT, MODULES) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.excelUrl = "";
        vm.total = 0;
        var startOfDay = 0, endOfDay = 0;
        vm.searchParams = {};
        vm.getRowsPerPage = getRowsPerPage;
        vm.showImg = showImg;
        vm.showMap = showMap;
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        vm.filterConfig = {
            companyFilter        : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter         : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker      : {
                show        : false,
                collapsible : false
            },
            singleDatePicker     : {
                show : true
            },
            monthYearPicker      : {
                show : false
            },
            departmentFilter     : {
                show        : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter    : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter     : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter         : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter      : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter    : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter      : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter         : {
                show        : true,
                collapsible : false
            },
            deviceFilter         : {
                show : false
            },
            leaveCategoryFilter  : {
                show : false
            },
            pdfDownloadButton    : {
                show                : false,
                multipleOrientation : false
            },
            excelDownloadButton  : {
                show : true
            },
            sortKey: {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };
        vm.search = search;
        function getRowsPerPage() {
            return Number(utilService.getRowsPerPage());
        }

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            // vm.searchParams.perPage = 789;
            startOfDay = searchParams.from;
            endOfDay =searchParams.to;
            attendanceService.getLocationTrackReport(vm.searchParams).then(function (data){
                vm.excelUrl = attendanceService.getLocationTrackingReportExcel(vm.searchParams);
                vm.locationTrackReport = data;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;  
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.date = data.date;
                vm.dateInMilliSecond = data.selectedDateInMilliSecond;

            }, function (error) {
                vm.isDataLoaded = false;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = null;
            vm.dateList = [];
            // vm.isDataLoaded = true;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function showImg(locationName, pictureUrl, exitPictureUrl, entryTime, exitTime) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/attendanceReport/mobilePunchReport/modal/showLocationImg.modal.html',
                size         : 'md',
                controller   : 'ShowLocationImgModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    imageInfo : function () {
                        return {
                            locationName : locationName,
                            pictureUrl   : pictureUrl,
                            exitPictureUrl   : exitPictureUrl,
                            entryTime   : entryTime,
                            exitTime   : exitTime
                        }
                    }
                }
            }).result.then(function (formData) {

            });
        }

        function showMap(locations, name, id,officeId, startTime, endTime, totalWorkingHour, date, dateInMilliSecond, perPage, pageNumber) {
            var employeeInfo={
                locations: locations,
                employeeName:name,
                employeeId: id,
                officeId: officeId,
                employeeStartTime: startTime,
                employeeEndTime: endTime,
                employeeTotalWorkingHour: totalWorkingHour,
                currentDate: date,
                currentDateInMilliSecond: dateInMilliSecond,
                perPage: perPage,
                pageNumber: pageNumber,
                startDay: startOfDay,
                endDay: endOfDay
            };
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/attendanceReport/locationTrackingReport/modal/showMultipleLocationMap.modal.html',
                size         : 'lg',
                controller   : 'ShowMultipleLocationMapModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    employeeLocations : function () {
                        return employeeInfo;
                    }
                }
            }).result.then(function (formData) {
        
            });
        }        

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.mobilePunchReport')
        .controller('MobilePunchReportCtrl',
            ['$scope', '$state', 'authService', 'toastrService', 'attendanceService', '$sce', '$compile', '$uibModal', 'analyticsService', 'ANALYTICS_CONSTANT', MobilePunchReportCtrl]);

    /** @ngInject */
    function MobilePunchReportCtrl($scope, $state, authService, toastrService, attendanceService, $sce, $compile, $uibModal, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        var loggedInUser = authService.getLoggedInUser();
        vm.excelUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.reportTable = null;

        vm.showImg = showImg;
        vm.showMap = showMap;

        vm.filterConfig = {
            companyFilter        : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter         : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker      : {
                show        : true,
                collapsible : false
            },
            singleDatePicker     : {
                show : false,
            },
            monthYearPicker      : {
                show : false
            },
            departmentFilter     : {
                show        : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter    : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter     : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter         : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter      : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter    : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter      : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter         : {
                show        : true,
                collapsible : false
            },
            deviceFilter         : {
                show : false
            },
            leaveCategoryFilter  : {
                show : false
            },
            pdfDownloadButton    : {
                show                : false,
                multipleOrientation : false
            },
            excelDownloadButton  : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.search = search;

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getMobilePunchReport(vm.searchParams).then(function (data) {
                vm.reportTable = $compile(data.reportTable)($scope);
                vm.excelUrl = attendanceService.getMobilePunchReportExcelUrl(vm.searchParams);
                vm.allAttendanceData = [];
                vm.dateRowspan = {};
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;  
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                if (vm.total > 0) {
                    angular.element(document.getElementById('mobilePunchReport')).empty();
                    angular.element(document.getElementById('mobilePunchReport')).append(vm.reportTable);
                }
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = null;
            vm.dateList = [];
            // vm.isDataLoaded = true;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function showImg(locationName, pictureUrl, exitPictureUrl, entryTime, exitTime) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/attendanceReport/mobilePunchReport/modal/showLocationImg.modal.html',
                size         : 'md',
                controller   : 'ShowLocationImgModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    imageInfo : function () {
                        return {
                            locationName : locationName,
                            pictureUrl   : pictureUrl,
                            exitPictureUrl   : exitPictureUrl,
                            entryTime   : entryTime,
                            exitTime   : exitTime
                        }
                    }
                }
            }).result.then(function (formData) {

            });
        }

        function showMap(lat, long, locationName) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/attendanceReport/mobilePunchReport/modal/showLocationMap.modal.html',
                size         : 'md',
                controller   : 'ShowLocationMapModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    mobilePunch : function () {
                        return {
                            latitude   : lat,
                            longitude  : long,
                            locationName : locationName,
                        }
                    }
                }
            }).result.then(function (formData) {

            });
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthlyReport')
        .controller('MonthlyReportCtrl',
            ['authService','attendanceService','utilService','$scope', '$sce', '$uibModal', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', MonthlyReportCtrl]);

    /** @ngInject */
    function MonthlyReportCtrl(authService,attendanceService,utilService,$scope, $sce, $uibModal, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.search = search;
        vm.findTimesheetApproval = findTimesheetApproval;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.rowsPerPage = 50;
        vm.total = null;
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.verticalPdfUrl = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.selectedYear = 0;
        vm.selectedMonth = 0;
        vm.timesheetApproval = [];
        vm.searchParams = {};
        vm.timesheetApprovalStatusHtml = "";
        vm.timesheetApplicationId = null;
        vm.showTimesheetApprovalButton = false;
        vm.overallSummary = null;
        vm.showLineManager = false;
        vm.aiAnalysis = null;
        vm.showAiInsights = false;
        vm.aiAnalysisLoading = false;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible: false

            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false,
                collapsible : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : loggedInUser.isAdmin
            },
            statusFilter : {
                show : true,
                collapsible : true
            },
            attendanceStatusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.fromTime = new Date(vm.searchParams.from);
            vm.searchParams.type = 0;
            vm.searchParams.reportType = "monthly";
            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getMonthlyReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getMonthlyReportPdfUrl(vm.searchParams);
                // vm.verticalPdfUrl = attendanceService.getMonthlyVerticalReportPdfUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.dateList = data.dates;
                vm.monthYear =  data.monthYear;
                vm.startOfDayList = data.startOfDayList;
                vm.overallSummary = data.summary;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
                vm.showLineManager = data.showLineManager;
                $scope.$broadcast("refreshFixedColumns");

                // Load AI analysis separately for better performance (only if module 4027 is enabled)
                if(utilService.hasPermission('4027')) {
                    loadAIAnalysis(vm.searchParams);
                }

                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
            // searchParams.month = searchParams.month + 1;
            if(searchParams.year)
                vm.selectedYear = searchParams.year;
            if(searchParams.month)
                vm.selectedMonth = searchParams.month;
            if(vm.loggedInUser.isLineManager){
                searchParams.lineManagerId = vm.loggedInUser.id;
            }

            if((vm.loggedInUser.isLineManager || vm.loggedInUser.isHrManager || vm.loggedInUser.isAdmin) && searchParams.month < new Date().getMonth()+1) {
                attendanceService.getMonthlyTimesheetApproval(searchParams).then(function (data) {
                    vm.timesheetApproval = data.applicationsList;
                    determineTimesheetApprovalStatus();
                });
            }
        }
        function loadAIAnalysis(searchParams) {
            if (searchParams.reportType === "monthly") {
                vm.aiAnalysisLoading = true;

                // Use the dedicated AI analysis endpoint
                attendanceService.getMonthlyAIAnalysis(searchParams).then(function (aiData) {
                    vm.aiAnalysis = aiData;
                    vm.aiAnalysisLoading = false;
                }, function (error) {
                    vm.aiAnalysisLoading = false;
                    vm.aiAnalysis = {
                        analysisAvailable: false,
                        errorMessage: "Failed to load AI analysis: " + error
                    };
                });
            }
        }

        function findTimesheetApproval() {
            var searchParams =
            {
                year: vm.selectedYear,
                month: vm.selectedMonth,
            }
            if(vm.loggedInUser.isLineManager){
                searchParams.lineManagerId = vm.loggedInUser.id;
            }
            if((vm.loggedInUser.isLineManager || vm.loggedInUser.isHrManager || vm.loggedInUser.isAdmin) && searchParams.month < new Date().getMonth()+1) {
                attendanceService.getMonthlyTimesheetApproval(searchParams).then(function (data) {
                    vm.timesheetApproval = data.applicationsList;
                    determineTimesheetApprovalStatus();
                }, function (message) {
                    console.log(message);
                });
            }
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "monthly";
        }

        function determineTimesheetApprovalStatus(){
            if(vm.selectedMonth >= new Date().getMonth() || vm.timesheetApproval.length === 0) return;
            if(vm.loggedInUser.isLineManager){
                if(vm.timesheetApproval[0].lineManagerApprovalStatus == 1){
                    vm.timesheetApprovalStatusHtml = "<span class=\"text-success\"><i class=\"ion-ios-timer-outline\"></i>&nbsp;Timesheet Approved</span>\n";
                } else{
                    vm.showTimesheetApprovalButton = true;
                    if(vm.timesheetApproval[0].lineManagerApprovalStatus == 0){
                        vm.timesheetApprovalStatusHtml = "<span><i class=\"ion-android-checkbox-outline-blank\"></i>&nbsp;Pending Approval</span>";
                    } else if(vm.timesheetApproval[0].lineManagerApprovalStatus == 2){
                        vm.timesheetApprovalStatusHtml = "<span><i class=\"ion-android-checkbox-outline-blank\"></i>&nbsp;Reapprove</span>";
                    }
                }
            } else if(vm.loggedInUser.isHrManager || vm.loggedInUser.isAdmin){
                if(vm.timesheetApproval[0].status == 1)
                    vm.timesheetApprovalStatusHtml = "<span class=\"text-success\"><i class=\"ion-ios-timer-outline\"></i>&nbsp;Timesheet Approved</span>\n";
                else if(vm.timesheetApproval[0].status == 0)
                    vm.timesheetApprovalStatusHtml = "<span class=\"text-danger\"><i class=\"ion-ios-timer-outline\"></i>&nbsp;Approval Pending</span>\n";
            }
            vm.timesheetApplicationId = vm.timesheetApproval[0].id;
            vm.timesheetApprovalStatusHtml = $sce.trustAsHtml(vm.timesheetApprovalStatusHtml);
        }

        function openTimeSheetApproveModal(applicationId) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/directives/monthlyAttendanceTable/monthlyTimeSheetModals/approve.modal.html',
                size : 'md',
                controller : 'ApproveMonthlyTimeSheetModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    applicationId : function () {
                        return applicationId;
                    }
                }
            }).result.then(function () {
                findTimesheetApproval();
            });
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });

        $scope.$on("approveTimesheet", function (event, applicationId) {
            openTimeSheetApproveModal(applicationId);
        });

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.pandemicReport')
        .controller('PandemicReportCtrl',
            ['attendanceService', '$scope', 'toastrService', 'authService', 'analyticsService', 'ANALYTICS_CONSTANT', PandemicReportCtrl]);

    /** @ngInject */
    function PandemicReportCtrl(attendanceService, $scope, toastrService, authService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.search = search;

        var loggedInUser = authService.getLoggedInUser();
        vm.allAttendanceData = [];
        vm.dateList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.currentDate = new Date();
        vm.rowIndex = null;
        vm.parentRowIndex = null;
        vm.childRowIndex = null;
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: true,
                collapsible : false
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : false
            },
            sortKey : {
                show: true
            },
            rowsPerPage :{
                hide: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.parentRowIndexChange = parentRowIndexChange;
        vm.childRowIndexChange = childRowIndexChange;

        function parentRowIndexChange(rowIndex){
            vm.childRowIndex = vm.parentRowIndex = rowIndex % 2;
        }
        function childRowIndexChange(childLength, rowIndex, change){
            if(change === 1 ) {
                vm.childRowIndex = vm.childRowIndex === 0 ? 1 : 0;
                if( childLength - 1 === rowIndex )
                    vm.childRowIndex = vm.parentRowIndex;
            }
            return vm.childRowIndex;
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            vm.currentDate = new Date(searchParams.from);
            modifyParams(searchParams);
            attendanceService.getPandemicReport(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getExcelUrl(vm.searchParams);
                vm.allAttendanceData = data.employeeResponseList;
                vm.dateList = data.dates;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "department";
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.serverRoomOccupancyReport')
        .controller('ServerRoomOccupancyReportCtrl',
            ['$scope','$state', 'toastr','attendanceService', 'authService', '$sce', 'analyticsService', 'ANALYTICS_CONSTANT', ServerRoomOccupancyReportCtrl]);

    /** @ngInject */
    function ServerRoomOccupancyReportCtrl($scope, $state, toastr, attendanceService, authService, $sce, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.excelUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.reportTable = [];
        vm.subtract = 0;
        vm.isDataLoaded = false;

        var loggedInUser = authService.getLoggedInUser();
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: true,
                collapsible : false
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : false,
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };


        vm.search = search;

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            vm.searchParams.sortKey = null;
            // vm.searchParams.to = 1577901540000;
            // vm.searchParams.from = 1577815200000;
            attendanceService.getServerRoomOccupancyReport(vm.searchParams).then(function (data) {
                vm.reportTable = $sce.trustAsHtml(data.reportTable);
                vm.excelUrl = attendanceService.getserverRoomOccupancyReportExcelUrl(vm.searchParams);
                vm.allAttendanceData = [];
                vm.dateRowspan = {};
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.allAttendanceData = null;
            vm.dateList = [];
            // vm.isDataLoaded = true;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }


    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.shiftReport')
        .controller('ShiftReportCtrl',
            ['authService','attendanceService', '$scope', 'toastr', ShiftReportCtrl]);

    /** @ngInject */
    function ShiftReportCtrl(authService, attendanceService, $scope, toastr) {

        var vm = this;

        vm.search = search;

        vm.allAttendanceData = [];
        vm.rowsPerPage = 50;
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.showLineManager = false;

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getExcelUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.dateList = data.dates;
                vm.startOfDayList = data.startOfDayList;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.showLineManager = data.showLineManager;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "shift";
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.siteAttendanceReport')
        .controller('SiteAttendanceReportCtrl',
            ['attendanceService', '$scope', 'toastr', 'toastrService', 'authService', 'utilService','$uibModal', SiteAttendanceReportCtrl]);

    /** @ngInject */
    function SiteAttendanceReportCtrl(attendanceService, $scope, toastr, toastrService, authService, utilService,$uibModal) {
        var vm = this;

        vm.total = 0;
        vm.searchParams = {};
        vm.reportTable = null;
        vm.subtract = 0;
        vm.employeeList = [];
        vm.rowsPerPage = 10;
        vm.isDataLoaded = false;
        vm.totalAbsent = null;
        vm.totalPresent = null;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.subtract = 0;
        vm.siteInPictureUrl = "";
        vm.siteOutPictureUrl = "";


        vm.getRowsPerPage = getRowsPerPage;
        vm.openLocationMap = openLocationMap;
        vm.openEntryExitImage=openEntryExitImage;

        var loggedInUser = authService.getLoggedInUser();

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: true,
                collapsible : false
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                // show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
                show : false
            },
            hrManagerFilter : {
                // show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
                show : false

            },
            statusFilter : {
                show : false,
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: false
            },
            allSitesFilterFilter:{
                show: true
            },
            presentAbsentFilter:{
                show:true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.search = search;

        function search(searchParams) {
            // makeEverythingEmpty();
            modifyParams(searchParams);
            vm.searchParams.sortKey = null;
            vm.isDataLoaded = false;
            // vm.searchParams.isPresent=true;
            attendanceService.getSitAttendanceReport(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getSiteAttendanceReportUrlExcel(vm.searchParams);
                vm.pdfUrl = attendanceService.getSiteAttendanceReportPdf(vm.searchParams);
                vm.employeeList = data.employeeList;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
                vm.totalPresent = data.totalPresent;
                vm.totalAbsent = data.totalAbsent;
                vm.isPresent = data.isPresent;
                vm.siteInPictureUrl = data.siteInPictureUrl;
                vm.siteOutPictureUrl = data.siteOutPictureUrl;

            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }
        function openLocationMap($index,siteInfo) {

            // console.log('hello')
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/attendanceReport/siteAttendanceReport/location/location.modal.html',
                size : 'md',
                controller : 'ReportSiteAttendanceLocationModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {
                        return siteInfo
                    }},
                controllerAs : 'vm',
            }).result.then(function () {

            },function (message) {
                console.error("Map closed ." );
            });
        }
        function openEntryExitImage($index,employee,imageCategory) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/attendanceReport/siteAttendanceReport/entryImage/entryExitImage.modal.html',
                size : 'md',
                controller : 'ReportSiteAttendanceEntryExitImageModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {

                        return  {'data':employee,'imageCategory':imageCategory};
                    }},


                controllerAs : 'vm',

            }).result.then(function () {

            },function (message) {
                console.error("Image Closed. " );
            });
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.siteSummaryReport')
        .controller('SiteSummaryReportCtrl', ['authService', 'utilService', '$scope','$uibModal', 'toastrService','siteManagementService', 'generalSettingsService','analyticsService', 'ANALYTICS_CONSTANT', SiteSummaryReportCtrl]);

    /** @ngInject */
        function SiteSummaryReportCtrl(authService, utilService, $scope,$uibModal, toastrService,siteManagementService, generalSettingsService,analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDataLoaded = true;
        vm.allsSitesSummaryReportData = [];
        vm.excelUrl = '';
        vm.pdfUrl = '';
        vm.searchParams = {};
        vm.searchKeyword = ''
        vm.rowsPerPage = 10;
        vm.selectedPage = 0;
        vm.singleDatePicker = {};
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.maxDateForDailyReport = new Date();

        vm.singleDatePicker.date = moment().startOf("day");
        vm.singleDatePicker.options = {
            singleDatePicker:true,
            timePicker24Hour : false,
            eventHandlers : {
                'apply.daterangepicker': getSiteByNameOrAddress,
            },
            locale: {
                format: "D MMM YYYY",
            }
        };
        vm.allowAllDownload = false;
        vm.maxRows = 0;
        vm.rowsPerPageOption = [
            { value: 10},
            { value: 50},
            { value: 100},
            { value: 500},
            { value: 1000},
            { value: 2000},
        ]
        vm.selectedRowsPerPage = vm.rowsPerPageOption[1]

        vm.getSiteSummaryInfo = getSiteSummaryInfo;
        vm.getSiteByNameOrAddress = getSiteByNameOrAddress;
        vm.exportAsExcel = exportAsExcel;
        vm.exportAsPdf   = exportAsPdf;
        vm.openLocationMap = openLocationMap;
        vm.handleRowPerPageSelection = handleRowPerPageSelection;

        function init(){
            getSiteSummaryInfo();
            generalSettingsService.getReportSettingsOfAnOffice().then(function (response) {
                vm.allowAllDownload = response.allowAllDownload;
                vm.maxRows = response.maxRows;
                if (!vm.allowAllDownload && vm.maxRows > 0){
                    vm.rowsPerPageOption.push({value: vm.maxRows});
                }
            });
        }
        init()
        function getSiteByNameOrAddress(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            getSiteSummaryInfo()
        }
        function handleRowPerPageSelection() {
            utilService.setRowsPerPage(vm.selectedRowsPerPage.value);
            vm.getSiteSummaryInfo();
        }
        function getSiteSummaryInfo(searchParams){
            modifyParams(searchParams);

            vm.searchParams.startTimeOfDay= vm.singleDatePicker.date.valueOf();
            vm.searchParams.count         = vm.rowsPerPage;
            vm.searchParams.keyword       = vm.searchKeyword;
            vm.isDataLoaded = false;
            siteManagementService.getSiteSummaryReportInfo(vm.searchParams).then(function (data) {
                vm.allSitesSummaryReportData = data;
                vm.siteSummaryList = data.siteSummaryList;
                vm.isDataLoaded = true;
                vm.date = data.date
                vm.excelUrl = siteManagementService.getSiteSummaryReportExcelUrl(vm.searchParams, vm.allowAllDownload);
                vm.pdfUrl = siteManagementService.getSiteSummaryReportPdf(vm.searchParams, vm.allowAllDownload);
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.totalSite;
                vm.success = true
                console.log(data)
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                console.log(error)
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
                else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function exportAsExcel() {
            if(vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel)
            }
        }
        function exportAsPdf() {
            if(vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
                window.open(vm.pdfUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf)
            }
        }

        function openLocationMap($index, site) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/attendanceReport/siteSummaryReport/location/location.modal.html',
                size : 'md',
                controller : 'ReportLocationModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {
                        return site
                    }},
                controllerAs : 'vm',
            }).result.then(function () {

            },function (message) {
                console.error("Failed to delete Site - " + message);
            });
        }

        }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.unrecognisedLogs')
        .controller('UnrecognisedLogsCtrl',
            ['$scope','$state','editableOptions','editableThemes','departmentService','shiftGroupService','designationService','employmentTypeService','officeService','authService','workplaceService','employeeService','dashboardService', 'toastrService','utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS','attendanceService', '$sce', 'analyticsService', 'ANALYTICS_CONSTANT', UnrecognisedLogsCtrl]);

    /** @ngInject */
    function UnrecognisedLogsCtrl($scope, $state, editableOptions, editableThemes, departmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService,employeeService,dashboardService, toastrService,utilService, $timeout, _, GENDER, EMPLOYEE_STATUS,attendanceService, $sce, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        var loggedInUser = authService.getLoggedInUser();
        vm.excelUrl = "";
        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.total = 0;
        vm.selectedPage = 0;
        vm.searchParams = {};
        vm.isDataLoaded = false;
        vm.unrecognisedLogs = null;
        vm.fetchUnregisteredOnly = false;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.search = search;
        vm.toggleUnregisteredOnlyFilterAndSearch = toggleUnregisteredOnlyFilterAndSearch;

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            getUnrecognisedLogs();
            // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
                vm.searchParams.fetchUnregisteredOnly = vm.fetchUnregisteredOnly;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function getUnrecognisedLogs() {
            attendanceService.getUnrecognisedLogs(vm.searchParams).then(function (data) {
                vm.isDataLoaded = true;
                vm.unrecognisedLogs = data.logs;
                vm.total = data.totalRecords;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.excelUrl = attendanceService.getUnrecognisedLogReportExcelUrl(vm.searchParams);
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not fetch unrecognised logs: " + error, "", 5000);
            });
        }

        function toggleUnregisteredOnlyFilterAndSearch() {
            analyticsService.sendData(ANALYTICS_CONSTANT.view,document.title + ' - View','','View In'+document.title, ANALYTICS_CONSTANT.view)
            vm.fetchUnregisteredOnly = !vm.fetchUnregisteredOnly;
            search(vm.searchParams);
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.unrecognisedLogs = {};
            vm.numberOfPages = 0;
            vm.total = 0;
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.weeklyReport')
        .controller('WeeklyReportCtrl',
            ['authService', 'attendanceService', '$scope',WeeklyReportCtrl]);

    /** @ngInject */
    function WeeklyReportCtrl(authService, attendanceService, $scope) {
        var vm = this;

        vm.search = search;

        vm.allAttendanceData = [];
        vm.numberOfRows = 100;
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.searchParams = {};
        vm.selectedPage = 0;


        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.fromTime = new Date(vm.searchParams.from);
            vm.type = 1;
            vm.searchParams.reportType = 0;
            attendanceService.getAttendance(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getMonthlyReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getMonthlyReportPdfUrl(vm.searchParams);
                vm.allAttendanceData = data.attendance;
                vm.dateList = data.dates;
                vm.startOfDayList = data.startOfDayList;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
            })
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "weekly";
        }

        $scope.$on("printEvent", function () {
            $scope.$broadcast("printReport");
        });


    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.workingHourReport')
        .controller('WorkingHourReportCtrl',
            ['authService', 'attendanceService', '$stateParams', 'toastrService', '$q','utilService','GENDER', '$scope', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES',WorkingHourReportCtrl]);

    /** @ngInject */
    function WorkingHourReportCtrl(authService, attendanceService, $stateParams, toastrService, $q, utilService, GENDER, $scope, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;

        var loggedInUser = authService.getLoggedInUser();
        vm.showFilters = false;
        vm.isDataLoaded = false;
        vm.showRows = 100;
        vm.allAttendanceData = [];
        vm.dateList = [];
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.total = 0;
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.searchParams = {};
        vm.showLineManager = false;
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        vm.showSummary = utilService.hasPermission('4013');
        vm.showTotalHours = utilService.hasPermission('4014');

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false,
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : true,
                collapsible: false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false,
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.searchAttendance = searchAttendance;

        init();

        function init() {
            var loggedInUser = authService.getLoggedInUser();
            vm.isCompanyAdmin = loggedInUser.isCompanyAdmin;
        }

        function searchAttendance(searchParams) {
            getAttendanceAndPopulateTable(searchParams);
        }

        function getAttendanceAndPopulateTable(searchParams) {
            vm.rowsPerPage = utilService.getRowsPerPage();
            vm.isDataLoaded = false;
            vm.searchParams.reportType = "workingHour";
            modifyParams(searchParams);
            attendanceService.getAttendance(vm.searchParams).then(function (responseData) {
                vm.isDataLoaded = true;
                vm.dateList = responseData.dates;
                vm.excelUrl = attendanceService.getExcelUrl(vm.searchParams);
                vm.pdfUrl  =  attendanceService.getWorkingHourReportPdfUrl(vm.searchParams);
                vm.startOfDayList = responseData.startOfDayList;
                vm.allAttendanceData = responseData.attendance;
                vm.numberOfPages = responseData.totalPages;
                vm.total = responseData.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = responseData.currentPage;
                vm.showLineManager = responseData.showLineManager;
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (message) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Cannot fetch attendance from server : " + message, "", 5000);
            })
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        $scope.$on("printEvent", function () {
            var printContents = document.getElementById("attendanceDiv").innerHTML;
            var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
            popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 3mm;} table{border-collapse: collapse; border-spacing: 2px;} thead {display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
            popupWin.document.close();
            popupWin.print();
        });

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.companies')
        .controller('CompanyDetailsCtrl', ['$uibModal','$stateParams','authService','officeService', CompanyDetailsCtrl]);

    /** @ngInject */
    function CompanyDetailsCtrl($uibModal,$stateParams,authService,officeService) {

        var vm = this;

        vm.data ={};
        vm.data.offices = null;

        vm.getCompanyOfficesByIdSuccess = getCompanyOfficesByIdSuccess;
        vm.getCompanyOfficesByIdFailure = getCompanyOfficesByIdFailure;
        vm.openOfficeCreateModal = openOfficeCreateModal;
        vm.openOfficeEditModal = openOfficeEditModal;

        function init() {
            getAllOffices();
        }

        init();

        function getAllOffices() {
            officeService.getAllOffices().then(getCompanyOfficesByIdSuccess, getCompanyOfficesByIdFailure);
        }

        function getCompanyOfficesByIdSuccess(data) {
            vm.data.offices = data;
        }

        function getCompanyOfficesByIdFailure(message) {
            console.error('Office Fetching failed error: '+message);
        }

        function openOfficeCreateModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/companies/createOffice/createOffice.modal.html',
                size:'lg',
                controller : 'CreateOfficeModalCtrl',
                controllerAs : "vm",
                backdrop : 'static',
                resolve : {companyId : function() {return authService.getLoggedInUser().office.company.id }}
            }).result.then(function(data) {
                vm.data.offices = data.officeList;
            }, function() {
                console.error("failed to create office");
            });
        }

        function openOfficeEditModal(office) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/companies/editOffice/editOffice.modal.html',
                size:'lg',
                controller : 'EditOfficeModalCtrl',
                controllerAs : "vm",
                backdrop : 'static',
                resolve : {office : function() {
                    office.companyId = $stateParams.companyId;
                    return office;
                }}
            }).result.then(function(data) {
                vm.data.offices = data.officeList;
            }, function() {
                console.error("failed to edit office");
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.companies')
        .controller('CreateCompanyModalCtrl', ['companyService', '$uibModalInstance',  CreateCompanyModalCtrl]);

    /** @ngInject */
    function CreateCompanyModalCtrl(companyService,$uibModalInstance) {

        var vm = this;
        vm.name = null;
        vm.createCompany = createCompany;

        function createCompany(name) {
            var data =
                {
                    'name' : name,
                    'status':1
                };
            companyService.createCompany(data).then(createSuccessCallback,createFailureCallback);
        }

        function createSuccessCallback(companyList) {
            $uibModalInstance.close(companyList);
        }

        function createFailureCallback(error) {
            console.error('creation failed because ' + error);
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.companies')
        .controller('CreateOfficeModalCtrl', ['officeService','$state', '$uibModalInstance', 'companyId',  CreateOfficeModalCtrl]);

    /** @ngInject */
    function CreateOfficeModalCtrl(officeService, $state,$uibModalInstance, companyId) {

        var vm = this;

        vm.companyId = companyId;
        vm.createModalData = {};
        vm.createModalData.description = null;
        vm.createModalData.location = null;
        vm.createModalData.name = null;
        vm.createModalData.officeType = null;

        vm.createOffice = createOffice;

        function createOffice() {

            var data =
                {
                    "companyId": vm.companyId,
                    "description": vm.createModalData.description,
                    "location": vm.createModalData.location,
                    "name": vm.createModalData.name,
                    "officeType": vm.createModalData.officeType,
                    "status": 1
                };

            officeService.createOffice(data).then(onOfficeCreateSuccess,onOfficeCreateFailure);
        }

        function onOfficeCreateSuccess(officeList) {
            $uibModalInstance.close(officeList);
        }

        function onOfficeCreateFailure(error) {
            console.log('creation failed because ' + error);
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.companies')
        .controller('EditCompanyModalCtrl', ['companyService', '$uibModalInstance', 'name','toastr','cId', EditCompanyModalCtrl]);

    /** @ngInject */
    function EditCompanyModalCtrl(companyService,$uibModalInstance, name,toastr, cId) {

        var vm = this;

        vm.name = name;
        vm.cId = cId;

        vm.updateName = updateName;

        function updateName(name) {
            var data = {
                'name': name,
                'status':1
            };
            companyService.updateCompanyInfo(data, vm.cId).then(updateSuccessCallback, updateFailureCallback);
        }

        function updateSuccessCallback(companyList) {
            $uibModalInstance.close(companyList);
        }

        function updateFailureCallback(error) {
            console.error('update failed because ' + error);
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.companies')
        .controller('EditOfficeModalCtrl', ['officeService','$state', '$uibModalInstance', 'office', EditOfficeModalCtrl]);

    /** @ngInject */
    function EditOfficeModalCtrl(officeService,$state,$uibModalInstance, office) {

        var vm = this;

        vm.office = office;

        vm.updateOfficeDetails = updateOfficeDetails;

        function updateOfficeDetails() {
            var data = {
                'name' : vm.office.name,
                'location' : vm.office.location,
                'description' :vm.office.description,
                'officeType' : vm.office.officeType,
            };
            officeService.updateOfficeInfo(data,vm.office.id,vm.office.company.id).then(onOfficeUpdateSuccess,onOfficeUpdateFailure);
        }

        function onOfficeUpdateSuccess(data) {
            $uibModalInstance.close(data);
        }

        function onOfficeUpdateFailure(error) {
            console.log('update failed because ' + error);
        }
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('AttendanceFeedCtrl', AttendanceFeedCtrl);

    /** @ngInject */
    function AttendanceFeedCtrl($scope, $filter, $state, authService,utilService,BANGABHABAN_OFFICE_ID) {

        var vm = this;
        vm.attendanceFeed = [];
        vm.goToProfile = goToProfile;
        vm.hasPermission = utilService.hasPermission;

        vm.isBangabhabanEmployee = (authService.getLoggedInUser().officeId === BANGABHABAN_OFFICE_ID.id);

        var defaultPicture = $filter('appImage')('theme/no-photo.png');
        vm.defaultPicture = $filter('appImage')('theme/no-photo.png');

        $scope.$on("dashboard-attendance-feed-data-loaded", function (event, data) {
            buildFeedFromData(data);
        });


        function buildFeedFromData(data) {
            vm.attendanceFeed = [];
            if (data && Array.isArray(data) && data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    vm.attendanceFeed.push({
                        'employeeId' : data[i].employeeId,
                        'name': data[i].name,
                        'profilePicURL': data[i].profilePicURL ? data[i].profilePicURL : defaultPicture,
                        'time': data[i].displayTime,
                        'ago': data[i].ago,
                        'text': buildText(data[i]),
                        'manualEntryText' : getEntryType(data[i]),
                        'isLate' : data[i].isLate,
                        'lateBy' : data[i].lateBy + " late",
                        'isManual' : data[i].isManual,
                        'accepted' : data[i].accepted,
                        'temperature' : data[i].temperature,
                        'hasMask' : data[i].hasMask,
                        'type' : data[i].punchType,
                        'deviceLocation' : data[i].deviceLocation,
                        'deviceIdentifier' : data[i].deviceIdentifier,
                    });
                }
            } else if(data && Array.isArray(data) && data.length == 0){
                vm.attendanceFeed.push({
                    'employeeId' : "empty",
                    'name': "Looks like no one is present",
                    'profilePicURL':"assets/img/app/exclamation.jpg",
                    'time': "",
                    'ago': "",
                    'text':"",
                    'isLate' :false,
                    'lateBy' : ""
                });
            } else {
                console.error("Attendance feed : invalid data : " + JSON.stringify(data));
            }
        }

        function buildText(entry) {
            var fingerprintOrRFID = "Fingerprint";
            if (entry.punchType === 2)
                fingerprintOrRFID = "RFID card";
            else if( entry.punchType == 3)
                fingerprintOrRFID = "Manual Entry"
            else if(entry.punchType == 4)
                fingerprintOrRFID = "Missing punch";
            else if(entry.punchType == 5)
                fingerprintOrRFID = "Manual Entry, Field visit";
            else if(entry.punchType == 6)
                fingerprintOrRFID = "Mobile punch";
            else if(entry.punchType == 7)
                fingerprintOrRFID = "Face ";
            else if(entry.punchType == 8)
                fingerprintOrRFID = "Picture Attendance";
            var inOutBoth = "punched";
            // if(entry.inOutOrBoth === 1) inOutBoth = inOutBoth + " in";
            // else if(entry.inOutOrBoth === 2) inOutBoth = inOutBoth + " in";
            // var officeLocation = authService.getLoggedInUser().isCompanyAdmin || authService.getLoggedInUser().isGroupAdmin ? "of "+ entry.officeName + " " : "";
            // return officeLocation  + " By " + fingerprintOrRFID + ".";
            return fingerprintOrRFID;
        }

        function getEntryType(entry) {
            var fingerprintOrRFID = "";
            if (entry.punchType === 2)
                fingerprintOrRFID = "RFID card";
            else if( entry.punchType == 3)
                fingerprintOrRFID = "Manual Entry"
            else if(entry.punchType == 4)
                fingerprintOrRFID = "Missing Punch";
            else if(entry.punchType == 5)
                fingerprintOrRFID = "Field Visit";
            else if(entry.punchType == 6)
                fingerprintOrRFID = "App Punch";
            else
                fingerprintOrRFID = "Fingerprint";

            return fingerprintOrRFID;
        }

        function goToProfile(employeeId) {
            $state.go('profile', {'employeeId' : employeeId});
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .directive('attendanceFeed', attendanceFeed);

    /** @ngInject */
    function attendanceFeed() {
        return {
            restrict: 'E',
            controller: 'AttendanceFeedCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/pages/main/dashboard/attendanceFeed/attendanceFeed.html'
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

    /** @ngInject */
    function DashboardCalendarCtrl(baConfig, $scope, $timeout,utilService) {
        var dashboardColors = baConfig.colors.dashboard;
        $scope.hasPermission = utilService.hasPermission;

        $scope.$on("dashboard-calendar-data-loaded", function (event, data) {
            var eventList = [];

            // Build holiday data
            if (data && data.holidayList && Array.isArray(data.holidayList) && data.holidayList.length > 0) {
                eventList = eventList.concat(buildHolidayData(data.holidayList));
            }

            // Build special day data
            if (data && data.specialDayList && Array.isArray(data.specialDayList) && data.specialDayList.length > 0) {
                eventList = eventList.concat(buildSpecialDayData(data.specialDayList));
            }

            var weeklyOffDayArray = createOffDaysArray(data.weeklyOffdays);

            $timeout(function () {
                $('#calendar').fullCalendar({
                    header: {
                        left: 'today prev,next',
                        center: 'title',
                        right: 'month,agendaWeek,agendaDay'
                    },
                    dayRender: function (date, cell) {
                        if (weeklyOffDayArray.length > 0 && weeklyOffDayArray.includes(date.day())) {
                            cell.css("background-color", '#cdf4dc');
                        }
                    },
                    firstDay: (weeklyOffDayArray && Array.isArray(weeklyOffDayArray) && weeklyOffDayArray.length > 0) ? ((weeklyOffDayArray[weeklyOffDayArray.length - 1] + 1) % 7) : 0,
                    defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                    selectable: false,
                    selectHelper: false,
                    editable: false,
                   // eventLimit: true, // allow "more" link when too many events
                    eventLimit:2,
                    events: eventList,
                    contentHeight: 200
                });
            });
        });
            function buildHolidayData(holidayList) {
            var holidays = [];
            angular.forEach(holidayList, function (holiday) {
                holidays.push({
                    title: holiday.description,
                    start: moment(holiday.holidayDate).format("YYYY-MM-DD").toString(),
                    end: moment(holiday.holidayDate).format("YYYY-MM-DD").toString(),
                    color: dashboardColors.blueStone
                });
            });

            return holidays;
        }

        function buildSpecialDayData(specialDayList) {
            var specialDays = [];
            angular.forEach(specialDayList, function (item) {
                var specialDay = item.specialDay;
                if (specialDay) {
                    // Convert the start and end dates to moment objects
                    var startDate = moment(specialDay.startDate);
                    var endDate = moment(specialDay.endDate);

                    // Loop through each day in the range and create an event for each day
                    for (var date = moment(startDate); date.isSameOrBefore(endDate); date.add(1, 'days')) {
                        specialDays.push({
                            title: specialDay.title,
                            start: date.format("YYYY-MM-DD"),
                            color: '#9736AA' // You can use any desired color here
                        });
                    }
                }
            });

            return specialDays;
        }

        function createOffDaysArray(offDaysString) {
            var offDayArrays = [];
            for (var i = 0; i < 7; i++) {
                if (offDaysString.charAt(i) === '1') {
                    offDayArrays.push(i);
                }
            }
            return offDayArrays;
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .directive('dashboardCalendar', dashboardCalendar);

    /** @ngInject */
    function dashboardCalendar() {
        return {
            restrict: 'E',
            controller: 'DashboardCalendarCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/pages/main/dashboard/calendar/dashboardCalendar.html'
        };
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('DashboardDepartmentAttendanceCtrl', DashboardDepartmentAttendanceCtrl);

    /** @ngInject */
    function DashboardDepartmentAttendanceCtrl(authService,$state,$scope, $timeout, baConfig,$interval) {

        var vm = this;
        vm.index = 0;
        vm.slidesToShow = 2;
        vm.autoplay = false;

        // Updated labels to separate Special Day
        var labels = ["Late", "On Leave", "Absent", "On Time", "Holiday/Day Off", "Special Day"];

        // Updated color for "Special Day"
        var colours = ['#e1be47', '#91b723', '#E65759', '#299d91', '#b8b8b8', '#9736AA'];

        var isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;

        $scope.filterParams = {
            attDateInMillis: null,
            employmentTypeIds: [],
            subsidiaryIds: [],
            workplaceIds: []
        };
        $scope.$on('dashboard-filter-params-changed', function (event, params) {
            $scope.filterParams = angular.copy(params || {});
        });
        // Updated vm.labelsAndColors to include "Special Day" as a separate entity
        vm.labelsAndColors = [{
            colour: colours[0],
            label: labels[0]  // Late
        }, {
            colour: colours[1],
            label: labels[1]  // On Leave
        }, {
            colour: colours[2],
            label: labels[2]  // Absent
        }, {
            colour: colours[3],
            label: labels[3]  // On Time
        }, {
            colour: colours[4],
            label: labels[4]  // Holiday/Day Off
        }, {
            colour: colours[5],
            label: labels[5]  // Special Day
        }];

        var options = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: false,
                position: 'bottom',
                labels: {
                    fontColor: baConfig.colors.defaultText
                }
            },
            'onClick' : function (evt, item) {
                var id = Number(item[0]._chart.canvas.id.split('-')[1]);
                var baseParams = {
                    attDateInMillis: $scope.filterParams.attDateInMillis,
                    employmentTypeIds: $scope.filterParams.employmentTypeIds,
                    subsidiaryIds: $scope.filterParams.subsidiaryIds,
                    workplaceIds: $scope.filterParams.workplaceIds
                };
                if(id) {
                    if(isCompanyAdmin) {
                        $state.go('attendanceReport.detailedAttendanceReport',{ officeId : id  } );
                    } else {
                        $state.go('attendanceReport.departmentReport', angular.extend({}, baseParams, { departmentId : id  } ));
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 60
        };

        // Event handler for department attendance data loaded
        $scope.$on("dashboard-department-attendance-data-loaded", function (event, data) {
            for (var i = 0; i < data.length; i++) {
                data[i].colours = colours;  // Assign updated colors
                data[i].labels = labels;    // Assign updated labels
                data[i].options = options;  // Chart options setup
                data[i].options.titles = [];
                data[i].options.titles[0] = {
                    "text": data[i].data.name,
                    'size': 15,
                    "bold": false
                };
                data[i].labels = labels;
            }
            $timeout(function () {
                vm.departments = data;
                vm.slidesToShow = vm.departments.length === 1 ? 1 : 2;  // Set the number of slides to show
            });

            $timeout(function () {
                vm.autoplay = true;  // Start autoplay after 5 seconds
            }, 5000);
        });

        // Initialize variables
        vm.departments = [];
        $scope.slides = [];
        $scope.myInterval = 5000;
        $scope.noWrapSlides = false;
        $scope.active = 0;
        var slides = $scope.slides = [];
        var currIndex = 0;
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('PieChartCtrl', PieChartCtrl);

    /** @ngInject */
    function PieChartCtrl($element, layoutPaths, baConfig) {
        var layoutColors = baConfig.colors;
        var id = $element[0].getAttribute('id');
        var pieChart = AmCharts.makeChart(id, {
            type: 'pie',
            titles : [{
                "text" : "Software Engineering Department",
                'size' : 15,
                "bold" : false
            }],
            startDuration: 0,
            theme: 'blur',
            addClassNames: true,
            color: layoutColors.defaultText,
            labelTickColor: layoutColors.borderDark,
            legend: {
                position: 'right',
                marginRight: 100,
                autoMargins: false,
            },
            innerRadius: '50%',
            defs: {
                filter: [
                    {
                        id: 'shadow',
                        width: '200%',
                        height: '200%',
                        feOffset: {
                            result: 'offOut',
                            in: 'SourceAlpha',
                            dx: 0,
                            dy: 0
                        },
                        feGaussianBlur: {
                            result: 'blurOut',
                            in: 'offOut',
                            stdDeviation: 5
                        },
                        feBlend: {
                            in: 'SourceGraphic',
                            in2: 'blurOut',
                            mode: 'normal'
                        }
                    }
                ]
            },
            dataProvider: [
                {
                    country: 'Lithuania',
                    litres: 501.9
                },
                {
                    country: 'Czech Republic',
                    litres: 301.9
                },
                {
                    country: 'Ireland',
                    litres: 201.1
                },
                {
                    country: 'Germany',
                    litres: 165.8
                },
                {
                    country: 'Australia',
                    litres: 139.9
                },
                {
                    country: 'Austria',
                    litres: 128.3
                },
                {
                    country: 'UK',
                    litres: 99
                },
                {
                    country: 'Belgium',
                    litres: 60
                }
            ],
            valueField: 'litres',
            titleField: 'country',
            export: {
                enabled: true
            },
            creditsPosition: 'bottom-left',

            autoMargins: false,
            marginTop: 30,
            alpha: 0.8,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            pullOutRadius: 0,
            pathToImages: layoutPaths.images.amChart,
            responsive: {
                enabled: true,
                rules: [
// at 900px wide, we hide legend
                    {
                        maxWidth: 900,
                        overrides: {
                            legend: {
                                enabled: false
                            }
                        }
                    },

// at 200 px we hide value axis labels altogether
                    {
                        maxWidth: 200,
                        overrides: {
                            valueAxes: {
                                labelsEnabled: false
                            },
                            marginTop: 30,
                            marginBottom: 30,
                            marginLeft: 30,
                            marginRight: 30
                        }
                    }
                ]
            }
        });

        pieChart.addListener('init', handleInit);

        pieChart.addListener('rollOverSlice', function (e) {
            handleRollOver(e);
        });

        function handleInit() {
            pieChart.legend.addListener('rollOverItem', handleRollOver);
        }

        function handleRollOver(e) {
            var wedge = e.dataItem.wedge.node;
            wedge.parentNode.appendChild(wedge);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('LateFeedCtrl', [
            'authService', '$filter', 'utilService', 'dashboardService', '$scope', 'BANGABHABAN_OFFICE_ID',
            LateFeedCtrl
        ]);

    /** @ngInject */
    function LateFeedCtrl(authService, $filter, utilService, dashboardService, $scope, BANGABHABAN_OFFICE_ID) {

        var vm = this;
        vm.isDataLoaded = false;
        vm.lateList = [];
        vm.hasPermission = utilService.hasPermission;
        vm.isGroupAdmin = authService.getLoggedInUser().isGroupAdmin;
        vm.isBangabhabanEmployee = false;

        function checkIfBangaBhabanEmployee() {
            if (authService.getLoggedInUser().officeId === BANGABHABAN_OFFICE_ID.id) {
                vm.isBangabhabanEmployee = true;
            }
        }

        function loadLateFeed(filterParams) {
            vm.isDataLoaded = false;

            if (vm.isBangabhabanEmployee) {
                dashboardService.getOnTimeFeed().then(function (data) {
                    vm.lateList = data.entries;
                    vm.isDataLoaded = true;
                }, function () {
                    vm.isDataLoaded = true;
                });
                return;
            }

            dashboardService.getLateFeed(filterParams).then(function (data) {
                vm.lateList = data.entries;
                vm.isDataLoaded = true;
            }, function () {
                vm.isDataLoaded = true;
            });
        }

        function init() {
            checkIfBangaBhabanEmployee();
            var deregister = $scope.$on('dashboard-filter-params-changed', function (event, filterParams) {
                loadLateFeed(filterParams);
            });

            $scope.$on('$destroy', deregister);
        }

        init();
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('LeastLateCtrl', ['authService','$filter','utilService', 'dashboardService','$scope', LeastLateCtrl]);

    /** @ngInject */
    function LeastLateCtrl(authService, $filter, utilService, dashboardService, $scope) {

        var vm = this;
        vm.lateList = [];
        vm.defaultPictureUrl = $filter('appImage')('theme/no-photo.png');
        vm.hasPermission = utilService.hasPermission;
        vm.isGroupAdmin = authService.getLoggedInUser().isGroupAdmin;
        vm.getPictureUrl = getPictureUrl;

        function init() {
            // if(!vm.isGroupAdmin){
            //     dashboardService.getTopFiveLeastLates().then(function (data) {
            //         vm.lateList = data;
            //     });
            // }
            // else {
            //     dashboardService.getCompanyTopFiveLeastAbsents().then(function (data) {
            //         vm.lateList = data;
            //     })
            // }
            $scope.$on("dashboard-least-late-data-loaded", function (event,data) {
                vm.lateList = data.leastLates;
            })
        }

        function getPictureUrl(lateResponse) {
            if(lateResponse.pictureUrl == null || lateResponse.pictureUrl == '' ){
                return "assets/img/theme/no-photo.png";
            }else {
                return lateResponse.pictureUrl;
            }
        }


        init();
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('LeaveFeedCtrl', [
            'authService', '$filter', 'utilService', 'dashboardService', '$scope', 'BANGABHABAN_OFFICE_ID',
            LeaveFeedCtrl
        ]);

    /** @ngInject */
    function LeaveFeedCtrl(authService, $filter, utilService, dashboardService, $scope, BANGABHABAN_OFFICE_ID) {

        var vm = this;
        vm.isDataLoaded = false;
        vm.leaveList = [];
        vm.defaultPictureUrl = $filter('appImage')('theme/no-photo.png');
        vm.getPictureUrl = getPictureUrl;
        vm.hasPermission = utilService.hasPermission;
        vm.isGroupAdmin = authService.getLoggedInUser().isGroupAdmin;
        vm.isBangabhabanEmployee = false;

        function checkIfBangaBhabanEmployee() {
            if (authService.getLoggedInUser().officeId === BANGABHABAN_OFFICE_ID.id) {
                vm.isBangabhabanEmployee = true;
            }
        }

        function loadLeaveFeed(filterParams) {
            vm.isDataLoaded = false;

            if (vm.isBangabhabanEmployee) {
                dashboardService.getBestAttendanceFeed().then(function (data) {
                    vm.leaveList = data.entries;
                    vm.isDataLoaded = true;
                }, function () {
                    vm.isDataLoaded = true;
                });
                return;
            }
            dashboardService.getLeaveFeed(filterParams).then(function (data) {
                vm.leaveList = data.entries;
                vm.isDataLoaded = true;
            }, function () {
                vm.isDataLoaded = true;
            });
        }

        function init() {
            checkIfBangaBhabanEmployee();

            var deregister = $scope.$on('dashboard-filter-params-changed', function (event, filterParams) {
                loadLeaveFeed(filterParams);
            });

            $scope.$on('$destroy', deregister);
        }

        init();

        function getPictureUrl(feedEntry) {
            if (!feedEntry.pictureUrl) {
                return "assets/img/theme/no-photo.png";
            } else {
                return feedEntry.pictureUrl;
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('OccupancyDashboardCtrl',['$scope','$interval',  OccupancyDashboardCtrl]);

    /** @ngInject */
    function OccupancyDashboardCtrl($scope,$interval) {

        var vm = this;
        vm.currentTime = new Date();
        var interval = $interval(function (){
            vm.currentTime = new Date();
        },1000)

        $scope.$on('$destroy',function (event) {
            if(angular.isDefined(interval)){
                $interval.cancel(interval);
            }
        })
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

    DashboardPieChartCtrl.$inject = ['$scope', '$timeout', '$state', 'baConfig', 'baUtil','utilService'];

    /** @ngInject */
    function DashboardPieChartCtrl($scope, $timeout, $state, baConfig, baUtil,utilService) {
        var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
        $scope.hasPermission = utilService.hasPermission;

        $scope.filterParams = {
            attDateInMillis: null,
            employmentTypeIds: [],
            subsidiaryIds: [],
            workplaceIds: []
        };
        $scope.$on('dashboard-filter-params-changed', function (event, params) {
            $scope.filterParams = angular.copy(params || {});
        });

        $scope.$on("dashboard-attendance-summary-data-loaded", function (event, data) {
            //console.log("dashboard-attendance-summary-data-loaded event received. data : " + JSON.stringify(data));
            $timeout(function () {
               $scope.easypiecharts.charts[0].stats = data.present;
               $scope.easypiecharts.charts[1].stats = data.absent;
               $scope.easypiecharts.charts[2].stats = data.onTime;
               $scope.easypiecharts.charts[3].stats = data.late;

               $scope.easypiecharts.charts[0].percent = data.totalEmployee > 0 ? Math.round(( (data.present * 1.0)/ (data.totalEmployee * 1.0) ) * 100) : 0;
               $scope.easypiecharts.charts[1].percent = data.expectedWorkingEmployees > 0 ? Math.round(( (data.absent * 1.0)/ (data.expectedWorkingEmployees * 1.0) ) * 100) : 0;
               $scope.easypiecharts.charts[2].percent = data.totalEmployee > 0 ? Math.round(( (data.onTime * 1.0)/ (data.totalEmployee*1.0) ) * 100) : 0;
               $scope.easypiecharts.charts[3].percent = data.totalEmployee > 0 ? Math.round(( (data.late * 1.0)/ (data.totalEmployee*1.0) ) * 100) : 0;
            });
        });
        $scope.easypiecharts = {};
        $scope.easypiecharts.charts = [{
            color: pieColor,
            description: 'dashboardPresent',
            stats: 0,
            icon: 'person',
            percent: 0,
            options:getOption("#00a392"),
        }, {
            color: pieColor,
            description: 'dashboardAbsent',
            stats: 0,
            icon: 'absent',
            percent: 0,
            options:getOption("#ff2e4b")
        }, {
            color: pieColor,
            description: 'dashboardOntime',
            // stats: $scope.dashboardData.onTime,
            stats: 0,
            icon: 'ontime',
            percent: 0,
            options:getOption("#00c1aa")
        }, {
            color: pieColor,
            description: 'dashboardLate',
            stats: 0,
            icon: 'late',
            percent: 0,
            options:getOption("#f7b900")
        }
        ];

        function getOption(color){
            return {
                easing: 'easeOutBounce',
                onStep: function (from, to, percent) {
                    $(this.el).find('.percent').text(Math.round(percent));
                },
                barColor: color,
                trackColor: pieColor,
                size: 64,
                scaleLength: 0,
                animation: 2000,
                lineWidth: 6,
                lineCap: 'round'
            }
        }
        $scope.redirectToReport = redirectToReport
        function redirectToReport(index){
            var baseParams = {
                attDateInMillis: $scope.filterParams.attDateInMillis,
                employmentTypeIds: $scope.filterParams.employmentTypeIds,
                subsidiaryIds: $scope.filterParams.subsidiaryIds,
                workplaceIds: $scope.filterParams.workplaceIds
            };
            if (index === 0) {
                $state.go('attendanceReport.dailyReport', angular.extend({}, baseParams, {
                    checkedAttendanceStatus: 1
                }));
            } else if (index === 1) {
                $state.go('attendanceReport.dailyAbsentReport', baseParams);
            } else if (index === 2) {
                $state.go('attendanceReport.dailyReport', angular.extend({}, baseParams, {
                    checkedAttendanceStatus: 5
                }));
            } else {
                $state.go('attendanceReport.dailyLateReport', baseParams);
            }

        }

        // $scope.easypiecharts.options = {
        //     easing: 'easeOutBounce',
        //     onStep: function (from, to, percent) {
        //         $(this.el).find('.percent').text(Math.round(percent));
        //     },
        //     // barColor: chart.attr('rel'),
        //     barColor: pieColor,
        //     trackColor: 'rgba(0,0,0,0)',
        //     size: 64,
        //     scaleLength: 0,
        //     animation: 2000,
        //     lineWidth: 6,
        //     lineCap: 'round'
        // };


    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('InovaceClientApp.pages.main.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/main/dashboard/overallLinearPieChartGroup/dashboardPieChart.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices.allocationHistory');
    app.controller('AllocationHistoryCtrl',['$q','authService','deviceService','officeService','_','toastr','utilService', '$uibModal', AllocationHistoryCtrl]);

    /** @ngInject */
    function AllocationHistoryCtrl($q,authService,deviceService,officeService,_,toastr,utilService, $uibModal) {
        var vm = this;

        vm.rowsPerPage = 100;
        vm.searchString = "";
        vm.allScheduledAllocations = null;
        vm.pageButtons = [];

        vm.getScheduledAllocations = getScheduledAllocations;


        function init() {
            getScheduledAllocations("", vm.rowsPerPage, 1);
        }

        init();

        function getScheduledAllocations(searchString, perPage, pageNo) {
            deviceService.getAllScheduledAllocations(searchString, perPage, pageNo).then(function (data) {
                vm.allScheduledAllocations = data;
                var startPage = vm.allScheduledAllocations.pageNo-2 <= 0? 1 : vm.allScheduledAllocations.pageNo-2;
                var endPage = Math.min(vm.allScheduledAllocations.totalPage, startPage+4);
                vm.pageButtons.length = 0;
                for (var i = startPage; i <= endPage; i++) {
                    vm.pageButtons.push(i);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('DeviceCtrl',['$q','authService','deviceService','officeService','_','toastrService','utilService', '$uibModal', '$scope', DeviceCtrl]);

    /** @ngInject */
    function DeviceCtrl($q,authService,deviceService,officeService,_,toastrService,utilService, $uibModal, $scope) {

        var vm = this;

        vm.isCompanyAdmin = false;
        vm.companyId = null;
        vm.showFilters = false;
        vm.allDevices = null;
        vm.paginatedDevices = null;
        vm.numberOfPages = null;
        vm.numberOfButtons = null;
        vm.selectedPage = 0;
        vm.rowsPerPage = "10";
        vm.devicesToShow = null;
        vm.phoneNumber = null;
        vm.identifier = null;
        vm.location = null;
        vm.officeList = [];
        vm.selectedOfficeList = [];
        vm.loggedInUser = null;
        vm.isDataLoaded = false;
        vm.loggedInUserOfficeId = null;

        vm.sortKeys = {
            'Location': {value: 'location', order: 'asc', selected: true},
            'Identifier': {value: 'identifier', order: 'asc', selected: false},
            'Last Communication': {value: 'lastCommunicationAt', order: 'asc', selected: false}
        };

        vm.paginateData = paginateData;
        vm.makeChunks = makeChunks;
        vm.searchDevice = searchDevice;
        vm.reduceSelectedPaginationPage = reduceSelectedPaginationPage;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.changeRowsToDisplay = changeRowsToDisplay;
        vm.getDevicesByOfficeId = getDevicesByOfficeId;
        vm.toggleEnrolmentMode = toggleEnrolmentMode;
        vm.getPaginationInformation = getPaginationInformation;
        vm.openEditDeviceModal = openEditDeviceModal;
        vm.openAllocateAllToAllDevicesConfirmationModal = openAllocateAllToAllDevicesConfirmationModal;
        vm.updateSortKey = updateSortKey;

        function init() {
            vm.loggedInUser = authService.getLoggedInUser();
            vm.isCompanyAdmin = vm.loggedInUser.isCompanyAdmin;
            vm.companyId = vm.loggedInUser.office.company.id;
            vm.loggedInUserOfficeId = vm.loggedInUser.officeId;
            if(vm.isCompanyAdmin){
                officeService.getCompanyOffices(true,vm.companyId).then(function (data) {
                    vm.officeList = data.officeList;
                    makeOfficeSelected();
                    getDeviceListByOfficeId(vm.selectedOfficeList[0].id);
                });
            }else{
                getDeviceListByOfficeId(vm.loggedInUser.office.id);
            }

            vm.showFilters = false;
            resetFilterInputs();
        }

        init();

        function getPaginationInformation() {
            var data = {
                selectedPage : vm.selectedPage,
                numberOfButtons : vm.numberOfButtons,
                allData : vm.allDevices,
                showingData : vm.devicesToShow,
                showRows : vm.rowsPerPage
            };
            return utilService.getPaginationInfo(data);
        }

        function paginateData(index) {
            vm.devicesToShow = vm.paginatedDevices[index];
            vm.selectedPage = index;
        }

        function makeChunks(deviceList) {
            vm.numberOfPages = !deviceList ? Math.ceil(_.size(vm.allDevices) / parseInt(vm.rowsPerPage))
                :Math.ceil(_.size(deviceList) / parseInt(vm.rowsPerPage)) ;
            vm.paginatedDevices = !deviceList ? _.chunk(vm.allDevices,vm.rowsPerPage) : _.chunk(deviceList,vm.rowsPerPage) ;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.devicesToShow = vm.paginatedDevices[0];
            vm.selectedPage = 0;
            vm.isDataLoaded = true;
            $scope.$broadcast("refreshFixedColumns");
        }

        function changeRowsToDisplay() {
            vm.paginatedDevices = _.flatten(vm.paginatedDevices);
            vm.numberOfPages = Math.ceil(_.size(vm.paginatedDevices) / parseInt(vm.rowsPerPage)) ;
            vm.paginatedDevices = _.chunk(vm.paginatedDevices, parseInt(vm.rowsPerPage));
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.devicesToShow = vm.paginatedDevices[0];
            vm.selectedPage = 0;
        }

        function searchDevice() {
            var filteredDeviceList = _.filter(vm.allDevices,function (item) {
                return item.phoneNumber.startsWith(vm.phoneNumber) && item.identifier.startsWith(vm.identifier)
                    && item.location.toLowerCase().startsWith(vm.location.toLowerCase());
            });
            makeChunks(filteredDeviceList);
        }

        function makeOfficeSelected() {
            for(var i = 0 ; i < vm.officeList.length;i++){
                if(vm.officeList[i].id == vm.loggedInUser.office.id){
                    vm.officeList[i].ticked = true;
                    vm.selectedOfficeList.push(vm.officeList[i]);
                }
            }
        }

        function getDevicesByOfficeId() {
            getDeviceListByOfficeId(vm.selectedOfficeList[0].id);
        }

        function getDeviceListByOfficeId(officeId) {
            vm.isDataLoaded = false;
            vm.allDevices = null;
            deviceService.getAllDevices(officeId).then(function (data) {
                $scope.$broadcast("refreshFixedColumns");
                vm.allDevices = data;
                makeChunks(vm.allDevices);
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not fetch device list", "", 5000);
            });
        }

        function reduceSelectedPaginationPage() {
            vm.selectedPage = vm.selectedPage === 0 ? 0 : vm.selectedPage - 1;
            paginateData(vm.selectedPage);
        }

        function increaseSelectedPaginationPage() {
            vm.selectedPage = vm.selectedPage === vm.numberOfButtons.length - 1 ? vm.selectedPage : vm.selectedPage +1;
            paginateData(vm.selectedPage);
        }

        function toggleEnrolmentMode(device,start) {
            if(start){
                deviceService.startEnrolmentOfADevice(device.id).then(function (data) {
                    toastrService.showSuccessToastr("Started enrolment mode");
                },function (error) {
                    toastrService.showErrorToastr("Failed to start enrolment mode " + error, "", 5000);
                })
            }else {
                deviceService.stopEnrolmentOfADevice(device.id).then(function () {
                    toastrService.showSuccessToastr("Stopped enrolment mode");
                },function (error) {
                    toastrService.showErrorToastr("Failed to stop enrolment mode. " +error, "", 5000);
                })
            }
        }

        function openEditDeviceModal(device){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/devices/devicesList/edit/editDevice.modal.html',
                controller : 'EditDeviceModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    device: function () {
                        return angular.copy(device);
                    }
                }
            }).result.then(function (device) {
                vm.allDevices = vm.allDevices.map(function(d){
                    if(d.id === device.id) {
                        return device;
                    } else return d;
                });
                makeChunks(vm.allDevices);
            });
        }

        function openAllocateAllToAllDevicesConfirmationModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/devices/devicesList/modals/allocateAll.modal.html',
                backdrop : 'static',
            }).result.then(function (device) {
                vm.isDataLoaded = false;
                allocateEveryone();
            });
        }

        function allocateEveryone() {
            deviceService.allocateEveryone().then(function () {
                toastrService.clearPreviousToastr();
                vm.isDataLoaded = true;
                toastrService.showSuccessToastr("Allocated Successfully. Please wait sometime for the allocation process to finish");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Allocation Failed", "", 5000);
            })
        }

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order === 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            sortDeviceList(vm.sortKeys[key]);
            searchDevice();
        }

        function sortDeviceList(sortKey) {
            vm.allDevices = _.sortBy(vm.allDevices, sortKey.value);
            if(sortKey.order === 'desc')
                vm.allDevices.reverse();
        }

        function resetFilterInputs() {
            vm.phoneNumber = '';
            vm.identifier = '';
            vm.location = '';
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.batchCreateEmployees')
        .controller('BatchCreateEmployeesCtrl', ['$scope','$window',BatchCreateEmployeesCtrl]);

    /** @ngInject */
    function BatchCreateEmployeesCtrl($scope,$window) {

        var vm = this;
        vm.onSwitchToHistoryTab = onSwitchToHistoryTab;

        function onSwitchToHistoryTab () {
            $scope.$broadcast('switchedToHistoryTab');
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.fieldVisit')
        .controller('EmployeeFieldVisitCtrl', ['employeeService','authService', 'toastrService','departmentService','designationService','workplaceService','shiftGroupService','GENDER','EMPLOYEE_STATUS','_','$sce','$uibModal', EmployeeFieldVisitCtrl]);

    /** @ngInject */
    function EmployeeFieldVisitCtrl(employeeService,authService, toastrService, departmentService,designationService,workplaceService,shiftGroupService, GENDER,EMPLOYEE_STATUS,_,$sce,$uibModal) {

        var vm = this;

        vm.showDiv = false;
        vm.selectedPaginationPage = 0;
        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.fieldVisitData = [];
        vm.isDataLoaded = false;
        vm.selectedRowIndex = null;
        vm.isRowSelected = false;
        vm.isAnyRowSelected = false;

        vm.departmentList = [];
        vm.designationList = [];
        vm.shiftList = [];
        vm.shiftGroupList = [];
        vm.companyList = [];
        vm.officeList = [];
        vm.workplaceList = [];
        vm.genderList = GENDER;
        vm.employeeStatusList = EMPLOYEE_STATUS;

        vm.search = {};
        vm.search.selectedCompanyList = [];
        vm.search.selectedDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedShiftList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedGenderList = [];
        vm.selectedApplicationType = [0,1,2,3];

        vm.employeeToShow = {
            'id' : '0025',
            'name' : 'Khalid Musa Sagar',
            'pictureUrl' : 'https://inovace-client-dev.s3.ap-southeast-1.amazonaws.com/profilepic-2509-Md.KhalidMusaSagar-31672123mm-1621767173.jpeg',
            'departmentName' : 'R&D',
            'designationName' : 'Software Team  Manager',
            'employeeType' : 'Full Time',
            'shift' : 'Regular'
        }

        vm.searchFieldVisit = searchFieldVisit;
        vm.setSelectedApplicationTypes = setSelectedApplicationTypes;
        vm.openCancelManualEntryModal = openCancelManualEntryModal;
        vm.getFieldVisits = getFieldVisits;
        vm.showEmployeeInfoInTheRightColumn = showEmployeeInfoInTheRightColumn;

        function init(){
            getAllDepartments();
            getAllDesignations();
            getAllShiftGroups();
            getAllWorkplaces();
            searchFieldVisit();
        }
        init();

        function openCancelManualEntryModal(manualEntryApplication) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/pendingApprovals/manual/cancel/manualEntryCancelModal.html',
                size : 'md',
                controller : 'ManualEntryCancelModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    manualEntryApplicationId : function () {
                        return manualEntryApplication.id;
                    },
                    manualEntryType : function (){
                        return 'fieldVisit';
                    }
                }
            }).result.then(function () {
                searchFieldVisit();
            });
        }


        function getAllWorkplaces() {
            workplaceService.getAllWorkplaces(true).then(function (data) {
                vm.workplaceList = data;
                vm.workplaceList = sortCollectionByName(vm.workplaceList);
            })
        }

        function getAllDesignations(){
            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = designationList;
                vm.designationList = sortCollectionByName(vm.designationList);
            }, function (message) {
            });
        }

        function getAllShiftGroups() {
            shiftGroupService.getAllShiftGroups(false).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(shiftGroupList);
            }, function (err) {
                toastrService.showErrorToastr("Failed to fetch shift groups: " + err, "", 5000);
                console.error("Failed to fetch shift groups");
            });
        }


        function getAllDepartments() {
            departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
        }

        function onGetAllDepartmentsSuccess(departmentList) {
            vm.departmentList =  sortCollectionByName(departmentList);
        }

        function onGetAllDepartmentsFailure(message) {
            toastrService.showErrorToastr("Failed to fetch department list : " + message, "", 5000);
            console.error("Failed to fetch department list : " + message);
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function getSelectedEmployeeProfile(id){
            employeeService.getProfile(id).then(function (data){
                vm.employeeToShow = data.employee;
                vm.isEmployeeInfoLoaded = true;
            });
        }

        function getFieldVisits(){
            searchFieldVisit();
        }
        function showEmployeeInfoInTheRightColumn(index, id, openEditSection){
            vm.isRowSelected = true;
            vm.isEmployeeInfoLoaded = false;
            getSelectedEmployeeProfile(id);
            vm.selectedRowIndex = index;
            vm.selectedRow = vm.fieldVisitData[index];
            vm.isAnyRowSelected = true;
            // if(openEditSection)
            //     openEditMode();

        }


        function searchFieldVisit(query){
            resetSelectionData();
            if(query && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var params = getSearchParams();
            vm.isDataLoaded = false;
            vm.fieldVisitData = [];
            employeeService.getPaginatedManualEntryList(params).then(function (data){
                vm.fieldVisitData = _.map(data.manualEntries,function (manualEntry) {
                    manualEntry.firstApproverApprovalDisplayString = $sce.trustAsHtml(manualEntry.firstApproverApprovalDisplayString);
                    manualEntry.secondApproverApprovalDisplayString = $sce.trustAsHtml(manualEntry.secondApproverApprovalDisplayString );
                    manualEntry.sameDateRange = manualEntry.startDate == manualEntry.endDate;
                    return manualEntry;
                })
                preparePaginationInfo(data.total,data.totalPages);
                vm.isDataLoaded = true;
            });
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfButtons.length-1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage-1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != vm.numberOfButtons.length ? vm.selectedPaginationPage + 1 : vm.numberOfButtons.length;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function preparePaginationInfo(total, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.total = total;
        }

        function getSearchParams() {
            return {
                officeId          : authService.getLoggedInUser().officeId,
                employeeName      : vm.searchKeyword,
                designationId     : getIdArrayFromMultiSelectOutput(vm.search.selectedDesignationList, 'id'),
                departmentId      : getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'),
                shiftGroupId      : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftGroupList, 'id'),
                workplaceId       : getIdArrayFromMultiSelectOutput(vm.search.selectedWorkplaceList, 'id'),
                genderId          : getIdArrayFromMultiSelectOutput(vm.search.selectedGenderList, 'id'),
                status            : getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList, 'id'),
                perPage           : 10,
                pageNumber        : vm.selectedPaginationPage,
                applicationStatus : vm.selectedApplicationType,
                manualEntryType   : [3],

            };
        }
        function getIdArrayFromMultiSelectOutput(array, keyToExtract) {
            if (!array || array.length == 0) return null;
            var returnArray = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }

        function setSelectedApplicationTypes(data){
            vm.isAnyRowSelected = false;
            vm.selectedApplicationType = data;
            vm.fieldVisitData = [];
            vm.selectedPaginationPage = 0;
            searchFieldVisit();
        }
        function resetSelectionData(){
            vm.isRowSelected = false;
            vm.selectedRow = null;
            vm.isAnyRowSelected = false;
            vm.selectedRow = 0;
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.manageEmployees')
        .controller('EmployeesCtrl', ['$scope', 'editableOptions', 'editableThemes', '_', 'employeeService','designationService', 'departmentService', 'subDepartmentService', 'shiftService', 'shiftGroupService','companyService', 'MODULES', 'officeService', 'authService', 'toastrService', '$state', 'aclLevel','workplaceService','employmentTypeService', 'utilService', 'EMPLOYEE_STATUS', 'GENDER', 'analyticsService', 'ANALYTICS_CONSTANT', 'BANGABHABAN_OFFICE_ID', 'subsidiaryService', EmployeesCtrl]);

    /** @ngInject */
    function EmployeesCtrl($scope, editableOptions, editableThemes, _, employeeService,designationService, departmentService, subDepartmentService, shiftService, shiftGroupService, companyService, MODULES, officeService, authService, toastrService, $state, aclLevel,workplaceService, employmentTypeService, utilService, EMPLOYEE_STATUS, GENDER, analyticsService, ANALYTICS_CONSTANT,BANGABHABAN_OFFICE_ID, subsidiaryService) {

        var vm = this;

        vm.allEmployees = null;
        vm.checkbox = {};
        vm.checkbox.isAnySelected = false;
        vm.checkbox.isAllSelected = false;
        vm.showDiv = false;
        vm.isEmployeeListLoaded = null;
        vm.rowsToShow = 100;
        vm.showEnrolmentStatus = false;
        vm.selectedPaginationPage = 0;
        vm.canLineManagerAssignShiftGroup = null;
        vm.viewSubsidiaryFilter = false;

        vm.departmentList = [];
        vm.subDepartmentList = [];
        vm.designationList = [];
        vm.shiftList = [];
        vm.shiftGroupList = [];
        vm.employmentTypeList = [];
        vm.companyList = [];
        vm.officeList = [];
        vm.workplaceList = [];
        vm.genderList = angular.copy(GENDER);
        vm.employeeStatusList = angular.copy(EMPLOYEE_STATUS);
        vm.lineManagerList = [];
        vm.subsidiaryList = [];
        vm.enrolmentStatus = [];
        vm.apiCallSuccessful = false;
        vm.search = {};
        vm.search.searchName = "";
        vm.search.selectedDepartmentList = [];
        vm.search.selectedSubDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedShiftList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedEmploymentTypeList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedGenderList = [];
        vm.search.selectedemployeeStatusList = [{ id: 1}];
        vm.search.selectedLineManagerList = [];
        vm.search.selectedSubsidiaryList = [];
        vm.search.searchEmployeeOfficeId = "";
        vm.search.searchCentralServerPeopleId = "";
        var loggedInuser = authService.getLoggedInUser();
        vm.isCompanyAdmin = loggedInuser.isCompanyAdmin;
        vm.isLineManager = loggedInuser.isLineManager && !loggedInuser.isAdmin;
        vm.viewSubsidiaryFilter = loggedInuser['modules'].includes(MODULES.SUBSIDIARY) && loggedInuser.isAdmin && loggedInuser.subsidiaryId == null;
        vm.isHrManager = loggedInuser.isHrManager;
        vm.isAdmin = loggedInuser.isAdmin;
        vm.total = 0;
        vm.excelUrl = "";
        if(loggedInuser.officeId === BANGABHABAN_OFFICE_ID.id){
            vm.sortKeys = {
                'Report Position' : {value : 'reportPosition', order:'asc', selected : true},
                'ID'              : {value : 'employeeOfficeId', order : 'asc', selected : false},
                'Name'            : {value : 'empName', order : 'asc', selected : false},
                'Section'      : {value : 'departmentName', order : 'asc', selected : false},
                'Designation'     : {value : 'designationName', order : 'asc', selected : false},
                'Shift Group'     : {value : 'shiftGroupName', order : 'asc', selected : false},
                'Workplace'       : {value : 'workplaceName', order : 'asc', selected : false},
                'Employment Type' : {value : 'employmentTypeName', order : 'asc', selected : false},

            };
        }
       else {
            vm.sortKeys = {
                'Report Position' : {value : 'reportPosition', order:'asc', selected : true},
                'ID'              : {value : 'employeeOfficeId', order : 'asc', selected : false},
                'Name'            : {value : 'empName', order : 'asc', selected : false},
                'Department'      : {value : 'departmentName', order : 'asc', selected : false},
                'Designation'     : {value : 'designationName', order : 'asc', selected : false},
                'Shift Group'     : {value : 'shiftGroupName', order : 'asc', selected : false},
                'Workplace'       : {value : 'workplaceName', order : 'asc', selected : false},
                'Employment Type' : {value : 'employmentTypeName', order : 'asc', selected : false},

            };
        }

        vm.hasPermission = hasPermission;
        vm.getStatusInText = getStatusInText;
        vm.searchEmployees = searchEmployees;
        vm.preparePaginationInfo = preparePaginationInfo;
        vm.search.onCompanyChange = onCompanyChange;
        vm.toggleAll = toggleAll;
        vm.optionToggled = optionToggled;
        vm.filterEmployees = filterEmployees;
        vm.sortBy = sortBy;
        vm.getLastProfilePicture = getLastProfilePicture;
        vm.getPaginationInfo = getPaginationInfo;
        vm.toggleShowEnrolmentInformation = toggleShowEnrolmentInformation;
        vm.selectAllAndGoToEmployeeActions = selectAllAndGoToEmployeeActions;
        vm.updateSortKey = updateSortKey;
        vm.createEmployeeAnalytics = createEmployeeAnalytics;
        vm.downloadExcelAnalytics = downloadExcelAnalytics;

        var sortStatus = {
            key   : null,
            order : null,
        };

        init();

        function sortBy(sortKey) {
            if(sortStatus.key != sortKey) {
                sortStatus = {
                    key   : sortKey,
                    order : 'asc'
                }
            } else {
                sortStatus.order = sortStatus.order == 'asc' ? 'desc' : 'asc';
            }
            vm.selectedPaginationPage = 0;
            searchEmployees();
        }

        function init() {
            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            getAllDepartments();
            getAllSubDepartments();
            // getAllShifts();
            getAllShiftGroups();
            // getAllCompanies();
            getAllWorkplaces();
            getAllDesignations();
            getAllEmploymentTypes();
            if(vm.viewSubsidiaryFilter) {
                getAllSubsidiaries();
            }
            if (vm.isCompanyAdmin) {
                getAllOffices();
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0});
            }
            else if (vm.isLineManager) {
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0});
            }
            employeeService.getEnrolmentInformation().then(function (data) {
                vm.enrolmentStatus = data.people;
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0,status:getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList,'id')});
            }, function (error) {
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0});
            })
            employeeService.getFilteredEmployeeNames({
                officeIdList: loggedInuser.office.id,
                status: 1,
                onlyLineManagers: true
            }).then(function (data) {
                vm.lineManagerList = data.employees;
            }, function (message) {

            });
            if(vm.isCompanyAdmin || vm.isHrManager || vm.isAdmin){
                vm.canLineManagerAssignShiftGroup = true;
            }
            else if(vm.isLineManager){
                if(utilService.canLineManagerAssignShiftGroup()){
                    employeeService.getShiftAssignmentStatus(authService.getLoggedInUser().id).then(function(data) {
                            vm.canLineManagerAssignShiftGroup = data;
                        },
                        function(error) {
                            console.error('Error:', error);
                        });
                }
                else
                    vm.canLineManagerAssignShiftGroup = false;
            }
        }

        // function canLineManagerAssignShiftGroup() {
        //     if (authService.getLoggedInUser().isLineManager && hasPermission('5009')) {
        //         vm.canLineManagerAssignShiftGroup = true;
        //     }
        // }

        function hasPermission(module) {
            return utilService.hasPermission(module);
        }

        function getPaginationInfo() {
            var str = (vm.selectedPaginationPage * vm.rowsToShow + 1) + " to ";
            str+= (vm.selectedPaginationPage+1) * vm.rowsToShow > vm.total ? vm.total : (vm.selectedPaginationPage+1) * vm.rowsToShow;
            return str;
        }

        function getAllDepartments() {
            departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
        }

        function onGetAllDepartmentsSuccess(departmentList) {
            vm.departmentList =  sortCollectionByName(departmentList);
        }

        function onGetAllDepartmentsFailure(message) {
            toastrService.showErrorToastr("Failed to fetch department list : " + message, "", 5000);
            console.error("Failed to fetch department list : " + message);
        }

        function getAllSubDepartments() {
            subDepartmentService.getAllSubDepartments().then(onGetAllSubDepartmentsSuccess, onGetAllSubDepartmentsFailure);
        }

        function onGetAllSubDepartmentsSuccess(subDepartmentList) {
            vm.subDepartmentList =  sortCollectionByName(subDepartmentList);
        }

        function onGetAllSubDepartmentsFailure(message) {
            toastrService.showErrorToastr("Failed to fetch sub department list : " + message, "", 5000);
            console.error("Failed to fetch sub department list : " + message);
        }

        function getAllShiftGroups() {
            shiftGroupService.getAllShiftGroups(false).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(shiftGroupList);
            }, function (err) {
                toastrService.showErrorToastr("Failed to fetch shift groups", "", 5000);
                console.error("Failed to fetch shift groups");
            });
        }

        function getAllOffices() {
            officeService.getAllOffices(true).then(function (data) {
                vm.officeList = sortCollectionByName(data);
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch office list " + error, "", 5000);
            })
        }

        function getAllEmploymentTypes(){
            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.employmentTypeList = sortCollectionByName(employmentTypeList);
                // vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            }, function (message) {
                toastrService.showErrorToastr("Failed to fetch designation category list : " + message, "", 5000);
                console.error("Failed to fetch designation category list : " + message);
            });
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfPages - 1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage - 1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage < vm.numberOfPages - 1 ? vm.selectedPaginationPage + 1 : vm.numberOfPages - 1;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function selectAllAndGoToEmployeeActions() {
            var params = getSearchParams();
            params.selectAll = true;
            employeeService.getFilteredEmployees(params).then(function (data) {
                $state.go('employeeActions', {
                    selectedEmployees    : data.employeeIds,
                    allSelected          : true,
                    notSelectedEmployees : []
                });
            });
        }

        function searchEmployees(query) {
            vm.apiCallSuccessful = false;

            if(query && typeof query.pageNumber !== 'undefined' && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var searchParams = getSearchParams();
            if (aclLevel.value == 'office') {
                searchParams.companyId = [authService.getLoggedInUser().office.company.id];
                getAllEmployees(searchParams);
            } else {
                searchParams.companyId = getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id');
                getAllEmployees(searchParams);
            }
            // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

        }

        function getAllEmployees(searchParams) {
            vm.isEmployeeListLoaded = false;
            employeeService.getFilteredEmployees(searchParams).then(onEmployeeFetchSuccess, onEmployeeFetchFailure).finally(function (){
                vm.apiCallSuccessful = true;
            });
            vm.excelUrl = employeeService.getExcelUrl(searchParams);
        }

        function getSearchParams() {
            var sortKeyAndOrder = getSortKeyAndOrder();
            var subsidiaryId;

            // If viewSubsidiaryFilter is false and user has subsidiaryId, use it
            if (!vm.viewSubsidiaryFilter && loggedInuser.subsidiaryId != null) {
                subsidiaryId = [loggedInuser.subsidiaryId];
            } else {
                subsidiaryId = getIdArrayFromMultiSelectOutput(vm.search.selectedSubsidiaryList, 'id');
            }

            return {
                officeId         : getIdArrayFromMultiSelectOutput(vm.search.selectedOfficeList, 'id'),
                departmentId     : getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'),
                subDepartmentId  : getIdArrayFromMultiSelectOutput(vm.search.selectedSubDepartmentList, 'id'),
                designationId    : getIdArrayFromMultiSelectOutput(vm.search.selectedDesignationList, 'id'),
                shiftId          : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftList, 'id'),
                shiftGroupId     : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftGroupList, 'id'),
                employmentTypeId : getIdArrayFromMultiSelectOutput(vm.search.selectedEmploymentTypeList, 'id'),
                genderId         : getIdArrayFromMultiSelectOutput(vm.search.selectedGenderList, 'id'),
                employeeName     : vm.search.searchName.toString(),
                status           : getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList, 'id'),
                workplaceId      : getIdArrayFromMultiSelectOutput(vm.search.selectedWorkplaceList, 'id'),
                lineManagerIds    : getIdArrayFromMultiSelectOutput(vm.search.selectedLineManagerList, 'id'),
                subsidiaryId     : subsidiaryId,
                employeeOfficeId : vm.search.searchEmployeeOfficeId.toString(),
                centralServerPeopleId : vm.search.searchCentralServerPeopleId.toString(),
                perPage          : vm.rowsToShow,
                pageNumber       : vm.selectedPaginationPage,
                sortKey          : sortKeyAndOrder.key,
                order            : sortKeyAndOrder.order
            };
        }

        function onEmployeeFetchSuccess(data) {
            vm.allEmployees = data.employees;
            for (var i = 0; i < vm.allEmployees.length; i++) {
                vm.allEmployees[i].selected = false;
                var enrolmentInfo = vm.enrolmentStatus[vm.allEmployees[i].centralServerId]
                if(!vm.isCompanyAdmin && !vm.isGroupAdmin && enrolmentInfo){
                    vm.allEmployees[i].totalFingerprints = enrolmentInfo.totalFingerprints;
                    vm.allEmployees[i].rfid = enrolmentInfo.rfid;
                }
            }
            vm.isEmployeeListLoaded = true;

            preparePaginationInfo(data.total,data.totalPages);

            // $scope.$broadcast("refreshFixedColumns");
        }

        function onEmployeeFetchFailure(message) {
            toastrService.showErrorToastr("Failed to fetch employee list, error message : " + message, "", 5000);
            console.error("Failed to fetch employee list, error message : " + message);
        }

        function preparePaginationInfo(total, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.total = total;
        }

        function onCompanyChange() {
            getOfficesFromCompanyIdArray();
        }

        function getOfficesFromCompanyIdArray() {
            officeService.getOfficesFromCompanyIdArray(false, getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id')).then(onGetOfficesFromCompanyIdArraySuccess, onGetOfficesFromCompanyIdArrayFailure);
        }

        function onGetOfficesFromCompanyIdArraySuccess(data) {
            vm.officeList = data.officeList;
            for (var j = 0; j < vm.officeList.length; j++) {
                var office = vm.officeList[j];
                if (office.id == authService.getLoggedInUser().office.id) {
                    office.ticked = true;
                }
            }
        }

        function onGetOfficesFromCompanyIdArrayFailure(message) {
            toastrService.showErrorToastr("Failed to fetch office names : " + message, "", 5000);
            console.error("Failed to fetch office names : " + message);
        }

        function getIdArrayFromMultiSelectOutput(array, keyToExtract) {
            if (!array || array.length == 0) return null;
            var returnArray = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }

        /*
              Radio button toggle functions
         */

        function toggleAll() {
            if (vm.checkbox.isAllSelected) {
                analyticsService.sendData(ANALYTICS_CONSTANT.selectAllUrl, document.title + ' - ' + ANALYTICS_CONSTANT.selectAllTitle, '', 'Select All in' + document.title, ANALYTICS_CONSTANT.selectAllTitle);

                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = true;

                });
            }
            else
                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = false;
                });
            checkIfAnySelected();
        }

        function optionToggled() {
            vm.checkbox.isAllSelected = vm.allEmployees.every(function (itm) {
                return itm.selected === true;
            });
            checkIfAnySelected();
        }

        function checkIfAnySelected() {
            for (var i = 0; i < vm.allEmployees.length; i++) {
                if (vm.allEmployees[i].selected) {
                    vm.checkbox.isAnySelected = true;
                    return;
                }
            }
            vm.checkbox.isAnySelected = false;
        }

        function selectAllAndGoTo() {

        }

        function filterEmployees() {
            analyticsService.sendData(ANALYTICS_CONSTANT.employeeAction, document.title + ' - Employee Action', '', 'Click Employee Action In' + document.title, ANALYTICS_CONSTANT.employeeAction)

            vm.isEmployeeListLoaded = false;
            var selectedEmployees = [], notSelectedEmployees = [];
            var selectedEmployeeIds = new Set();
            angular.forEach(vm.allEmployees, function (employee, key) {
                if (employee.selected) {
                    selectedEmployees.push(employee);
                    selectedEmployeeIds.add(employee.id);
                }
            });
            // employeeService.getFilteredEmployees({
            //     companyId  : [authService.getLoggedInUser().office.company.id],
            //     officeId   : [authService.getLoggedInUser().office.id],
            //     perPage    : 2000,
            //     pageNumber : 0
            // }).then(function (data) {
            //     vm.allEmployees = data.employees;
            //     angular.forEach(vm.allEmployees, function (employee) {
            //         if (!selectedEmployeeIds.has(employee.id)) notSelectedEmployees.push(employee);
            //     });
            //     $state.go('employeeActions', {
            //         selectedEmployees    : selectedEmployees,
            //         notSelectedEmployees : notSelectedEmployees
            //     });
            // }, function (error) {
            //     toastr.error("Failed to fetch employee information");
            //     console.error("Failed to fetch all employees : " + error);
            // });
            $state.go('employeeActions', {
                selectedEmployees    : selectedEmployees,
                notSelectedEmployees : notSelectedEmployees
            });
        }

        function getStatusInText(status) {
            if (status === -1) return "Archived";
            else if (status === 0) return "Inactive";
            else if (status === 1) return "Active";
            else if (status === 2) return "Terminated";
            else if (status === 3) return "Resigned";
            else if (status === 4) return "Transferred";
        }

        


        function getLastProfilePicture(employee) {
            return employee.employeePictures.filter(function (data) {
                return data.status == 1;
            })
        }


        function getAllWorkplaces() {
            workplaceService.getAllWorkplaces(true).then(function (data) {
                vm.workplaceList = data;
                vm.workplaceList = sortCollectionByName(vm.workplaceList);
            })
        }

        function getAllDesignations(){
            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = designationList;
                vm.designationList = sortCollectionByName(vm.designationList);
            }, function (message) {
            });
        }

        function getAllSubsidiaries() {
            subsidiaryService.getAllSubsidiaries(true).then(function (subsidiaryList) {
                vm.subsidiaryList = sortCollectionByName(subsidiaryList);
            }, function (message) {
                // toastrService.showErrorToastr("Failed to fetch subsidiary list : " + message, "", 5000);
                console.error("Failed to fetch subsidiary list : " + message);
            });
        }

        function toggleShowEnrolmentInformation() {
            analyticsService.sendData(ANALYTICS_CONSTANT.enrolment, document.title + " - Enrolment", '', 'Employee Enrolment In' + document.title, ANALYTICS_CONSTANT.enrolment)

            vm.showEnrolmentStatus = !vm.showEnrolmentStatus;
        }


        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function updateSortKey(key) {
            if(vm.sortKeys[key].selected){
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc'? 'desc' : 'asc';
            }else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function(keyName){
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            analyticsService.sendData(ANALYTICS_CONSTANT.sort, '', '', 'Sort In' + document.title, ANALYTICS_CONSTANT.sort)

            searchEmployees();
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for(var i = 0 ; i < keys.length ; i++){
                if(vm.sortKeys[keys[i]].selected == true ){
                    return {key :  vm.sortKeys[keys[i]].value , order: vm.sortKeys[keys[i]].order}
                }
            }
        }
        function createEmployeeAnalytics(){
            analyticsService.sendData(ANALYTICS_CONSTANT.createEmployeeUrl, document.title + " - " + ANALYTICS_CONSTANT.createEmployeeTitle, '', 'Create Employee In' + document.title, ANALYTICS_CONSTANT.createEmployeeTitle)
        }
        function downloadExcelAnalytics(){
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Manage Employee Excel', ANALYTICS_CONSTANT.downloadExcel)
        }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.employees')
        .directive('selectpicker', selectpicker);

    /** @ngInject */
    function selectpicker() {
        return {
            restrict: 'A',
            require: '?ngOptions',
            priority: 1500, // make priority bigger than ngOptions and ngRepeat
            link: {
                pre: function(scope, elem, attrs) {
                    elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
                },
                post: function(scope, elem, attrs) {
                    function refresh() {
                        elem.selectpicker('refresh');
                    }

                    if (attrs.ngModel) {
                        scope.$watch(attrs.ngModel, refresh);
                    }

                    if (attrs.ngDisabled) {
                        scope.$watch(attrs.ngDisabled, refresh);
                    }

                    elem.selectpicker({ dropupAuto: false, hideDisabled: true });
                }
            }
        };
    }


})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.syncExternal')
        .controller('SyncExternalCtrl', ['employeeService', 'toastrService', 'GENDER', 'authService', 'externalSyncService', SyncExternalCtrl]);

    /** @ngInject */
    function SyncExternalCtrl(employeeService, toastrService, GENDER, authService, externalSyncService) {

        var vm = this;

        vm.ids = "";
        vm.responseMap = null;
        vm.loggedInUser = authService.getLoggedInUser();
        vm.isDataLoaded = true;

        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            applyClass: 'btn-green',
            maxDate : moment(),
            timePicker : false,
            timePicker24Hour : false,
            locale : {
                applyLabel: "Apply",
                fromLabel: "From",
                format : 'DD MMM YYYY',
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        vm.syncEmployees = syncEmployees;
        vm.syncAll = syncAll;
        vm.syncEmployeesBBL = syncEmployeesBBL;


        function syncEmployees() {
            var data =  {thirdPartyIdList:vm.ids.replace(/\s*,\s*/g, ",")}
            employeeService.syncThirdPartyEmployees(data).then(function (responseData) {
                vm.responseMap = responseData;
            },function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }

        function syncAll(){
            employeeService.syncAllThirdPartyEmployees().then(function () {
                toastrService.showSuccessToastr("Sync process started");
            },function (error) {
                toastrService.showErrorToastr("Error:" + error, "" ,5000);
            })
        }

        function syncEmployeesBBL() {
            vm.isDataLoaded = false;
            var dateRange = {
                startDate : vm.datePicker.date.startDate.format('x'),
                endDate : vm.datePicker.date.endDate.format('x')
            };

            externalSyncService.syncEmployeesBBL(dateRange).then(function (data) {
                toastrService.showSuccessToastr("Sync process completed");
            }, function (error) {
                toastrService.showErrorToastr("Error:" + error, "" ,5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getInitialFromAndToDate() {
            return {
                'startDate': moment().startOf('day').subtract(1, 'day'),
                'endDate': moment().endOf('day')
            };
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.leave.applyLeaveForOthers')
        .controller('ApplyLeaveForOthersCtrl', ['$scope','$stateParams', '$uibModal', 'authService','remainingLeaveService', 'leaveManagementService', 'toastrService','$sce','_','employeeService', 'analyticsService', 'ANALYTICS_CONSTANT', ApplyLeaveForOthersCtrl]);

    /** @ngInject */
    function ApplyLeaveForOthersCtrl($scope,$stateParams,$uibModal,authService,remainingLeaveService,leaveManagementService,toastrService,$sce,_,employeeService, analyticsService, ANALYTICS_CONSTANT){

        var vm = this;

        var employeeId = 54375;
        vm.earnedLeaveEnabledCategoryIds = [];
        vm.availableCategoryIds = [];
        vm.searchKeyword = null;

        vm.loadDataForSelectedYear = loadDataForSelectedYear;
        vm.setSelectedLeaveApplicationStatuses = setSelectedLeaveApplicationStatuses;
        vm.searchLeaveApplicationRecord = searchLeaveApplicationRecord;
        vm.showDetailedLeaveInfoInTheRightColumn = showDetailedLeaveInfoInTheRightColumn;
        vm.prepareOpenAdjustModal = prepareOpenAdjustModal;
        vm.openCancelModal = openCancelModal;
        vm.getCurrentAndPreviousLeaveApplicationData = getCurrentAndPreviousLeaveApplicationData;
        vm.openApplyForLeaveModal = openApplyForLeaveModal;
        vm.isEligibleForModification = isEligibleForModification;
        vm.analyticsApplyLeave = analyticsApplyLeave;
        vm.searchByNameOrId = searchByNameOrId;


        function init() {
            vm.remainingLeavesList = null;
            vm.leaveList = null;
            vm.selectedYear = new Date().getFullYear();
            vm.isRemainingLeaveDataLoaded = true;
            vm.isDataLoaded = false;
            vm.isRowSelected = false;
            vm.isAdjustDataLoded = false;
            vm.selectedRow = 0;
            vm.selectedLeaveApplicationStatuses = [0,1,2,3];
            vm.allLeaveApplicationData = [];
            vm.numberOfPages = 0;
            vm.numberOfButtons = 0;
            vm.selectedPaginationPage = 0;
            vm.selectedLeaveApplication = null;
            //second API call data (current and previous leave data)
            vm.currentAndPreviousLeaveApplicationData =  null;
            var employeeId = null;

            // loadDataForSelectedYear();
            searchLeaveApplicationRecord();
        }
        init();
        resetSelectionData();
        // when user will go to the next page, all value should be reset
        function resetSelectionData(){
            vm.selectedLeaveApplication = null;
            vm.isRowSelected = false;
            vm.selectedRow = 0;
        }


        function showDetailedLeaveInfoInTheRightColumn(selectedRow){
            analyticsService.sendData(ANALYTICS_CONSTANT.showDetailedView, document.title + ' - Show Detailed View', '', 'Show Detailed View Of An Employee In' + document.title, ANALYTICS_CONSTANT.showDetailedView)
            vm.isAdjustDataLoded = true;
            vm.isRowSelected = true;
            vm.currentAndPreviousLeaveApplicationData =  null;
            vm.selectedLeaveApplication = null;
            vm.selectedLeaveApplication = angular.copy(vm.allLeaveApplicationData.leaveLogList[selectedRow]);
            vm.selectedLeaveApplication.firstApprovalDisplayString = $sce.trustAsHtml(vm.selectedLeaveApplication.firstApprovalDisplayString);
            vm.selectedLeaveApplication.secondApprovalDisplayString = $sce.trustAsHtml(vm.selectedLeaveApplication.secondApprovalDisplayString);
            vm.selectedRow = selectedRow;
            employeeId = vm.selectedLeaveApplication.employeeId;
            return loadDataForSelectedYear();
        }

        function setSelectedLeaveApplicationStatuses(data){
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search)
            resetSelectionData();
            vm.selectedLeaveApplicationStatuses  = data;
            vm.leaveApplicationData = [];
            vm.selectedPaginationPage = 0;
            searchLeaveApplicationRecord();
        }

        function searchLeaveApplicationRecord(query){
            resetSelectionData();
            if(query && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var params = getRequestParams();
            vm.isDataLoaded = false;
            vm.allLeaveApplicationData = [];
            vm.leaveApplicationData = [];
            leaveManagementService.getLeaveLogList(params).then(function (data){
                vm.allLeaveApplicationData = data;
                preparePaginationInfo(data.totalRecords, data.totalPages);
                vm.isDataLoaded = true;
            });
        }

        function getRequestParams() {
            return {
                page: vm.selectedPaginationPage,
                status: vm.selectedLeaveApplicationStatuses,
                keyword:!vm.searchKeyword ? '' : vm.searchKeyword,
                count:8
            }
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfButtons.length-1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage-1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage < vm.numberOfPages - 1 ? vm.selectedPaginationPage + 1 : vm.numberOfPages - 1;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function preparePaginationInfo(totalRecords, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.totalRecords = totalRecords;
        }

        //Updated & Previous Details API call
        function getCurrentAndPreviousLeaveApplicationData(leaveLogId){
            employeeService.getCurrentAndPreviousLeaveApplicationData(leaveLogId).then(function (data){
                vm.currentAndPreviousLeaveApplicationData = data;
                vm.isAdjustDataLoded = true;
                vm.isRowSelected = true;
            },function (error){
                vm.isRowSelected = true;
            })

        }

        function prepareOpenAdjustModal(index){
            if(vm.selectedLeaveApplication == null ||
                (vm.allLeaveApplicationData.leaveLogList[index].id != vm.selectedLeaveApplication.id)  ){
                showDetailedLeaveInfoInTheRightColumn(index).then(function (){
                    openAdjustModal(index);
                });
            }else
                openAdjustModal(index);
        }

        //For Adjust modal
        function openAdjustModal(index) {
            toastrService.clearPreviousToastr();
            if(!vm.availableCategoryIds.includes(vm.allLeaveApplicationData.leaveLogList[index].categoryId))
                return toastrService.showInfoToastr("Employees current leave policy does not have this category anymore");
            if(vm.allLeaveApplicationData.leaveLogList[index].type == 2)
                return toastrService.showInfoToastr("Adjusting Half Day Leaves is not supported yet. Please try again later");
            if(vm.earnedLeaveEnabledCategoryIds.includes(vm.allLeaveApplicationData.leaveLogList[index].categoryId))
                return toastrService.showInfoToastr("Adjusting leaves of " + vm.allLeaveApplicationData.leaveLogList[index].categoryName + " category is not supported yet. Please try again later");
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/leave-adjust/leaveAdjust.modal.html',
                size: 'lg',
                controller: 'LeaveAdjustModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    leaveInfo: function() {
                        return {
                            leaveCategoryList : vm.remainingLeavesList,
                            leaveLogInfo :  vm.allLeaveApplicationData.leaveLogList[index]
                        }
                    }
                }
            }).result.then(function (data){
                init();
            });
        }

        //For Cancel Modal
        function openCancelModal(index) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/leave-cancel/leaveCancel.modal.html',
                size: 'lg',
                controller: 'LeaveCancelModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    updatedLeaveInfo : function (){
                        return{
                            leaveLogInfo :  vm.allLeaveApplicationData.leaveLogList[index]
                        }
                    }
                }
            }).result.then(function (data){
                init();
            });
        }

        function loadDataForSelectedYear() {
            vm.isRemainingLeaveDataLoaded = false;
            return remainingLeaveService.getAllRemainingLeavesOfEmployee(employeeId,vm.selectedYear).then(function (data) {
                vm.isRemainingLeaveDataLoaded = true;
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
                vm.earnedLeaveEnabledCategoryIds = vm.remainingLeavesList.reduce(function (filtered, remainingLeaveRecord) {
                    if(remainingLeaveRecord.leaveCategoryPolicyConfig.earnedLeaveCriteria !== 0) filtered.push(remainingLeaveRecord.leaveCategoryId);
                    return filtered;
                }, []);
                vm.availableCategoryIds = vm.remainingLeavesList.map(function (remainingLeaveRecord) {
                    return remainingLeaveRecord.leaveCategoryId;
                });

            },function (error) {
                toastrService.showErrorToastr("Could not fetch because " +error, "", 5000);
            });
        }

        function createEventWatchers() {
            $scope.$on('leave-management-open-apply-modal', openApplyForLeaveModal);
            $scope.$on('leave-tab-select',init);
        }

        createEventWatchers();

        // function getDataAndOpenModal() {
        //     employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
        //     remainingLeaveService.getAllRemainingLeavesOfEmployee(employeeId).then(function (remainingLeavesList) {
        //         vm.remainingLeavesList = remainingLeavesList;
        //         openApplyForLeaveModal();
        //     },function (error) {
        //         toastr.error("Could not fetch because " +error);
        //     });
        // }

        function openApplyForLeaveModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/apply/applyForLeave.modal.html',
                size: 'lg',
                controller: 'ApplyForLeaveModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    leaveCategoryList: function () {
                        return mapLeaveCategories();
                    },
                    employeeId: function () {
                        return employeeId;
                    }
                }
            }).result.then(function (data) {
                toastrService.clearPreviousToastr();
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
                vm.leaveList = data.leaveLogList;
                init();
                toastrService.showSuccessToastr("Leave application placed.");
            });

        }
        function mapLeaveCategories() {
            var leaveCategoryList =[];
            if(!vm.remainingLeavesList){
                return toastrService.showErrorToastr("Leave policy not set");
            }
            for(var i = 0 ; i < vm.remainingLeavesList.length;i++) {
                if(vm.remainingLeavesList[i].remainingLeaveCount && vm.remainingLeavesList[i].remainingLeaveCount > 0)
                    leaveCategoryList.push(vm.remainingLeavesList[i].leaveCategory);
            }
            return leaveCategoryList;
        }


        function isEligibleForModification(leaveCategoryId) {
            return vm.availableCategoryIds.includes(leaveCategoryId);
        }

        function analyticsApplyLeave(){
            analyticsService.sendData(ANALYTICS_CONSTANT.applyLeave, document.title + ' - Apply Leave', '', 'Apply Leave In' + document.title, ANALYTICS_CONSTANT.applyLeave)
        }
        function searchByNameOrId(){
            searchLeaveApplicationRecord();
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)


        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveCategory')
    app.controller('LeaveCategoryCtrl', ['$scope','leaveCategoryService','$uibModal','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',LeaveCategoryCtrl]);

    /** @ngInject */
    function LeaveCategoryCtrl($scope, leaveCategoryService,$uibModal,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.leaveCategory = {};
        vm.leaveCategory.leaveCategoryList = null;
        vm.create = {};
        vm.create.createLeaveCategoryName = null;
        vm.leaveCategoryToEdit = null;
        var analyticsCreateTitle = 'Create Leave Category Modal';
        var analyticsCreateUrl = 'create-leave-category';
        var analyticsEditTitle= 'Edit Leave Category Modal';
        var analyticsEditUrl = 'edit-leave-category';
        var analyticsDeleteTitle = 'Delete Leave Category Modal';
        var analyticsDeleteUrl = 'delete-leave-category';

        vm.openDeleteLeaveCategoryModal = openDeleteLeaveCategoryModal;
        vm.openCreateLeaveCategoryModal = openCreateLeaveCategoryModal;
        vm.openEditLeaveCategoryModal = openEditLeaveCategoryModal;

        function init() {
            leaveCategoryService.getAllLeaveCategories().then(onLeaveCategoryListFetchSuccess, onLeaveCategoryListFetchFailure);
        }

        init();

        function onLeaveCategoryListFetchSuccess (leaveCategoryList) {
            vm.leaveCategory.leaveCategoryList = leaveCategoryList;
            vm.isDataLoaded = true;
            $scope.$broadcast("refreshFixedColumns");
        }

        function onLeaveCategoryListFetchFailure (error) {
            toastrService.showErrorToastr('Could not fetch all leave category : ' + error, '', 5000);
            console.log(error);
        }

        function openCreateLeaveCategoryModal () {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Leave Category In' + document.title, ANALYTICS_CONSTANT.open)
            toastrService.clearPreviousToastr();
            vm.createLeaveCategoryModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leaveCategory/leaveCategoryModals/createLeaveCategory.modal.html',
                size: 'md',
                controller:'LeaveCategoryEditModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                {
                    categoryToChange:function () {
                        return {};
                    }
                }
            }).result.then(onLeaveCategoryCreateSuccess);
        }

        function onLeaveCategoryCreateSuccess(leaveCategory) {
            toastrService.clearPreviousToastr();
            vm.leaveCategory.leaveCategoryList.push(leaveCategory);
            toastrService.showSuccessToastr("Leave Category created");
        }

        function openEditLeaveCategoryModal (leaveCategory,index) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Leave Category In' + document.title, ANALYTICS_CONSTANT.open)
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leaveCategory/leaveCategoryModals/updateLeaveCategory.modal.html',
                size: 'md',
                controller:'LeaveCategoryEditModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                        categoryToChange:function () {
                            return leaveCategory;
                        }
                    }
            }).result.then(function(leaveCategory) {
                    toastrService.clearPreviousToastr();
                    vm.leaveCategory.leaveCategoryList[index] = leaveCategory;
                    toastrService.showSuccessToastr("Leave Category updated");
                });
        }

        function openDeleteLeaveCategoryModal (leaveCategory,index) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Leave Category In' + document.title, ANALYTICS_CONSTANT.open)
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leaveCategory/leaveCategoryModals/deleteLeaveCategory.modal.html',
                size: 'md',
                controller:'LeaveCategoryEditModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        categoryToChange:function () {
                            return leaveCategory;
                        }
                    }
            }).result.then(function leaveCategoryDeleteSuccess() {
                vm.leaveCategory.leaveCategoryList.splice(index,1);
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveCategoryPolicyConfiguration')
    app.controller('LeaveCategoryPolicyConfigurationCtrl', ['$scope', 'leaveCategoryPolicyConfigurationService', 'leavePolicyService', '$uibModal', 'toastrService', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', LeaveCategoryPolicyConfigurationCtrl]);

    /** @ngInject */
    function LeaveCategoryPolicyConfigurationCtrl($scope, leaveCategoryPolicyConfigurationService, leavePolicyService, $uibModal, toastrService, $q, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.enabled = 'Enabled';
        vm.disabled = 'Disabled';
        vm.leavePolicyToCategoryConfigs = null;
        vm.isDataLoaded = false;

        vm.openDeleteConfigurationModal = openDeleteConfigurationModal;
        vm.analyticsCreateConfiguration = analyticsCreateConfiguration;
        vm.analyticsEditConfiguration = analyticsEditConfiguration;
        init();

        function init() {
            var promises = [];
            promises.push(getAllConfigurations());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                });
        }

        function getAllConfigurations() {
            return leaveCategoryPolicyConfigurationService.getAllConfigurations().then(function (data) {
                vm.leavePolicyToCategoryConfigs = data;

                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                toastrService.showErrorToastr("could not load leave category-policy configurations " + error, "", 5000);
            });
        }

        function openDeleteConfigurationModal(policyToCategoryConfig,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leaveCategoryPolicyConfiguration/delete/modals/deleteLeaveCategoryPolicyConfiguration.modal.html',
                size: 'md',
                controller:'DeleteConfigurationModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    policyToCategoryConfig:function () {
                        return policyToCategoryConfig;
                    }
                }
            }).result.then(function (data) {
                toastrService.clearPreviousToastr();
                vm.leavePolicyToCategoryConfigs = data;
                toastrService.showSuccessToastr("Leave category-policy configuration deleted");
            });
        }
        function analyticsCreateConfiguration(){
            analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create Leave Configuration', '', 'Create Leave Configuration In' + document.title, ANALYTICS_CONSTANT.create)
        }
        function analyticsEditConfiguration(){
            analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit Leave Configuration', '', 'Edit Leave Configuration In' + document.title, ANALYTICS_CONSTANT.edit)
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leavePolicy')
       app.controller('LeavePolicyCtrl', ['$scope','leavePolicyService','$uibModal','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',LeavePolicyCtrl]);

    /** @ngInject */
    function LeavePolicyCtrl($scope, leavePolicyService,$uibModal,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.leavePolicy = {};
        vm.leavePolicy.leavePolicyList = null;
        var analyticsCreateTitle = 'Create Leave Category Policy Modal';
        var analyticsCreateUrl = 'create-leave-category-policy';
        var analyticsDeleteTitle = 'Delete Leave Category Policy Modal';
        var analyticsDeleteUrl = 'delete-leave-category-policy';
        var analyticsEditTitle= 'Edit Leave Category Policy Modal';
        var analyticsEditUrl = 'edit-leave-category-policy';
        vm.openCreateLeavePolicyModal = openCreateLeavePolicyModal;
        vm.openDeleteLeavePolicyModal = openDeleteLeavePolicyModal;
        vm.openEditLeavePolicyModal = openEditLeavePolicyModal;

        function init() {
            leavePolicyService.getAllLeavePolicies().then(function (leavePolicyList) {
                vm.leavePolicy.leavePolicyList = leavePolicyList;
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            },function (error) {
                toastrService.showErrorToastr("Could not fetch leave policies - " + error, "", 5000);
            });
        }

        init();

        function openCreateLeavePolicyModal () {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Leave Category Policy In' + document.title, ANALYTICS_CONSTANT.open)
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leavePolicy/leavePolicyModals/createLeavePolicy.modal.html',
                size: 'md',
                controller:'LeavePolicyCreateUpdateDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        leavePolicy:function () {
                            return null;
                        }
                    }

            }).result.then(function (allLeavePolicies) {
                toastrService.clearPreviousToastr();
                vm.leavePolicy.leavePolicyList = allLeavePolicies;
                toastrService.showSuccessToastr('Leave Policy Created');
            });
        }

        function openDeleteLeavePolicyModal(leavePolicy,index) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Leave Category Policy In' + document.title, ANALYTICS_CONSTANT.open)
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leavePolicy/leavePolicyModals/deleteLeavePolicyModal.modal.html',
                size: 'md',
                controller:'LeavePolicyCreateUpdateDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    leavePolicy:function () {
                            return leavePolicy;
                        }
                    }
            }).result.then(function (allLeavePolicies) {
                toastrService.clearPreviousToastr();
                //console.log("allLeavePolicies : "+allLeavePolicies);
                vm.leavePolicy.leavePolicyList = allLeavePolicies;
                toastrService.showSuccessToastr("Leave policy Deleted!!!");
            });
        }

        function openEditLeavePolicyModal(leavePolicy, index) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Leave Category Policy In' + document.title, ANALYTICS_CONSTANT.open)
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leavePolicy/leavePolicyModals/editLeavePolicy.modal.html',
                size: 'md',
                controller:'LeavePolicyCreateUpdateDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        leavePolicy:function () {
                            return leavePolicy;
                        }
                    }

            }).result.then(function (data) {
                toastrService.clearPreviousToastr();
                vm.leavePolicy.leavePolicyList[index] = data;
                toastrService.showSuccessToastr('Leave Policy Updated');
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.uploadLeaveBalance')
        .controller('UploadLeaveBalanceCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'authService', 'utilService', 'employeeService', 'toastrService', 'attendanceService', 'analyticsService', 'ANALYTICS_CONSTANT', UploadLeaveBalanceCtrl]);

    /** @ngInject */
    function UploadLeaveBalanceCtrl($scope, $stateParams, $state, $timeout, $uibModal, authService, utilService, employeeService, toastrService, attendanceService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        utilService.setRowsPerPage(10);
        vm.isDataLoaded = false;
        vm.showSpiner = false;
        vm.offset = 0;
        vm.selectedPage = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";

        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker: {
                show: false,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker: {
                show: false
            },
            yearPicker: {
                show: false
            },
            fiscalYearFilter: {
                show: true
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter: {
                show: false,
                collapsible: true
            },
            deviceFilter: {
                show: false
            },
            leaveCategoryFilter: {
                show: false
            },
            pdfDownloadButton: {
                show: false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : false
            }
        };
        vm.analyticsUploadExcel=analyticsUploadExcel;
        vm.search = search;
        vm.uploadSelectedExcelFile = uploadSelectedExcelFile;
        vm.downloadSampleExcel = downloadSampleExcel;
        vm.getRowsPerPage = getRowsPerPage;

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }


        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.selectedFiscalYear = vm.searchParams.selectedDateRange.replace('-', 'to');
            vm.from = vm.searchParams.from;
            vm.to = vm.searchParams.to;
            attendanceService.getLeaveBalanceReport(vm.searchParams).then(function (data) {
                vm.allLeaveBalanceData = data.responseForAllEmployees;
                // vm.excelUrl = attendanceService.getLeaveHistoryReportExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getLeaveHistoryReportPdfUrl(vm.searchParams);
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;

                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function uploadSelectedExcelFile($file) {

            vm.showSpiner = true;
            var params = {
                fiscalYearStartDate : vm.from,
                fiscalYearEndDate : vm.to,
            }
            console.log(params);
            if($file == null) return;
            attendanceService.uploadRemainingLeaveBalanceExcel($file, params).then(function (data) {
                vm.excelUploadResponse = data;
                vm.showSpiner = false;
                search(vm.searchParams)
                toastrService.showSuccessToastr("File upload successful");
                openExcelUploadModal();
                }, function (error) {
                vm.showSpiner = false;
                toastrService.showErrorToastr(error, "", 5000);
            });

        }

        function downloadSampleExcel() {
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Leave Balance Excel', ANALYTICS_CONSTANT.downloadExcel)
            window.open(attendanceService.downloadSampleExcel(vm.searchParams),'_blank', '');
        }

        function openExcelUploadModal() {
            // toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/uploadLeaveBalance/modal/excelModal.html',
                size: 'md',
                controller: 'ExcelModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    responseInfo : function (){
                        return vm.excelUploadResponse;
                    }
                }
            }).result.then(function (data){

            });
        }

        function analyticsUploadExcel(){
            analyticsService.sendData(ANALYTICS_CONSTANT.uploadExcel, document.title + ' - Upload Excel', '', 'Upload Leave Balance Excel', ANALYTICS_CONSTANT.uploadExcel)

        }


    }
})();
(function () {
    'use strict';
  
    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('MembersCtrl', ['$scope', '$stateParams', '$state','employeeService', '$uibModal', 'authService','utilService', 'toastrService', '$q', 'membershipManagementService','analyticsService', 'ANALYTICS_CONSTANT', MembersCtrl]);

    function MembersCtrl($scope, $stateParams, $state,employeeService, $uibModal, authService,utilService, toastrService, $q, membershipManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        var loggedInUser = authService.getLoggedInUser();

        vm.showMemberType = 1;
        vm.isDataLoaded = false;
        vm.memberInfoLoaded = false;
        vm.isAnyRowSelected = false;
        vm.isEditBtnClicked = false;
        vm.selectedRow = null;
        vm.selectedEmployeeId = null;
        vm.searchParams = {};
        vm.searchParams.pageNumber = 0;
        vm.searchParams.perPage = 10;
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        vm.searchKey = '';

        vm.setSelectedMemberTypeActive = setSelectedApplicationTypeActive;
        vm.setSelectedMemberTypeExpireSoon = setSelectedApplicationTypeExpireSoon;
        vm.setSelectedMemberTypeExpired = setSelectedApplicationTypeExpired;
        vm.showMemberInfoInTheRightColumn = showMemberInfoInTheRightColumn;
        // vm.showMemberEditInfoInTheRightColumn = showMemberEditInfoInTheRightColumn;
        vm.editPressed = editPressed;
        vm.openRenewalMembershipModal = openRenewalMembershipModal;
        vm.openDeleteMemberModal = openDeleteMemberModal;
        vm.renewMember = renewMember;
        vm.searchByName = searchByName;
        vm.search = search;

        function init(){
            vm.searchParams.pageNumber  = 0;
            vm.searchParams.perPage  = utilService.getRowsPerPage();
            search();
        }
        init();

        function searchByName(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            search()
        }

        function setSelectedApplicationTypeActive (){
            vm.showMemberType = 1;
            resetValue();
            init();
        }

        function setSelectedApplicationTypeExpireSoon() {
            vm.showMemberType = 2;
            resetValue();
            init();
        }

        function setSelectedApplicationTypeExpired() {
            vm.showMemberType = 3;
            resetValue();
            init();
        }

        function showMemberInfoInTheRightColumn(index,id){
            vm.memberInfoLoaded = false;
            vm.selectedRowIndex = index;
            vm.selectedEmployeeId = id;
            vm.isAnyRowSelected = true;
            vm.isEditBtnClicked = false;

            fetchAllDataOfTheSelectedEmployee(id);
        }

        function editPressed(index){
            vm.index = index;
            vm.isAnyRowSelected = true;
            vm.isEditBtnClicked = true;
            vm.selectedRow = vm.memberList[index];

        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            utilService.setRowsPerPage( vm.rowsPerPage)
            vm.searchParams.perPage = vm.rowsPerPage;
            vm.searchParams.subscriptionType = vm.showMemberType;
            vm.searchParams.employeeName = vm.searchKey;
            vm.searchParams.officeId = loggedInUser.officeId;
            modifyParams(searchParams)
            membershipManagementService.getAllActiveMembers(vm.searchParams).then(function (data) {
                vm.allMembers = data.memberList;
                vm.total = data.total;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function openDeleteMemberModal(name, id){
            vm.memberToBeDeleted = id;
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/membershipManagement/members/delete/deleteMember.modal.html',
                size : 'md',
                controller : 'DeleteMemberModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {memberName : function () {
                        return {name:name, id: id}
                    }}
            }).result.then(function () {
                init()
                });
        }

        function openSuccessRenewalModal(memberName){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/membershipManagement/members/modals/successModal/renewalSuccessful.Modal.html',
                size        : 'md',
                controller  : 'RenewalSuccessfulModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    memberInfo:function () {
                        return memberName;
                    }
                }
            }).result.then(function (){
                init();
            });
        }

        function openRenewalMembershipModal(memberInfo){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/membershipManagement/members/modals/renewMembershipModal/renewalMembership.modal.html',
                size        : 'md',
                controller  : 'RenewalMembershipModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    membershipRenewalInfo:function () {
                        return memberInfo;
                    }
                }
            }).result.then(function (){
            });
        }

        function resetValue(){
            vm.isAnyRowSelected = false;
            vm.isEditBtnClicked = false;
            vm.memberInfoLoaded = false;
        }

        function renewMember(name, id){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/membershipManagement/members/modals/renewModal/renew.modal.html',
                size        : 'md',
                controller  : 'RenewModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    memberName:function () {
                        return {name:name,id:id};
                    }
                }
            }).result.then(function (){
                // membershipManagementService.renewMember(id).then(function (){
                //     openSuccessRenewalModal(name);
                // },function (error){
                //     toastrService.showErrorToastr('Failed: ' + error, '', 5000);
                // });
                init()
            });
        }

        function fetchAllDataOfTheSelectedEmployee(employeeId){
            membershipManagementService.getAllInfoOfAMember(employeeId).then(function (data){
                vm.memberInfo = data;
                vm.memberInfoLoaded = true;
            },function (error){
                toastrService.showErrorToastr("Failed to fetch data: " + error, "", 5000);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipDashboard')
        .controller('MembershipDashboardCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_','membershipManagementService', MembershipDashboardCtrl]);


    function MembershipDashboardCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _,membershipManagementService) {
        var vm = this;
        vm.myInterval = 500;
        vm.noWrapSlides = false;
        vm.active = 0;
        vm.mostActiveMembers=[];
        vm.notComingForTooLongMembers=[];
        vm.soonToBeExpiredMembers=[];
        vm.isAttendanceDataLoaded=false;
        vm.attendanceDashboard=[];
        vm.isDataloaded=false;
        vm.isBirthdayDataLoaded=false;
        vm.birthday=[];
        vm.today = moment().format("DD MMMM YYYY");


        function init(){

            membershipManagementService.getAllDashboardResponse().then(onDashboardLeftListsFetchSuccess,onListFetchFailure);
            membershipManagementService.getAttendanceFeed().then(onDashboardAttendanceFeedSuccess,onDashboardAttendanceFeedFailure);
            membershipManagementService.getDashboardBirthdayFeed().then(dashboardBirthdayListFetchSuccess,dashboardBirthdayListFetchFailure);
        }
        init();


        function dashboardBirthdayListFetchFailure(err){

        }
        function dashboardBirthdayListFetchSuccess(data){
            vm.birthday=data.employeeList;
            vm.isBirthdayDataLoaded=true;
        }
        function onDashboardAttendanceFeedSuccess(data){
            vm.attendanceDashboard=data.attendanceFeedEntryList
            vm.isAttendanceDataLoaded=true;
        }
        function onDashboardAttendanceFeedFailure(){

        }
        function onDashboardLeftListsFetchSuccess(data){
            vm.mostActiveMembers=data.mostActiveMembers;
            vm.notComingForTooLongMembers=data.notComingForToLongMembers;
            vm.soonToBeExpiredMembers=data.soonToBeExpiredMembers;
            vm.isDataloaded=true;
        }

        function onListFetchFailure(){

        }

    }
})();
(function () {
    'use strict';
  
    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipSettings')
        .controller('MembershipsSettingsCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_','membershipManagementService', MembershipsSettingsCtrl]);


    function MembershipsSettingsCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _,membershipManagementService) {
        var vm = this;

        vm.isDataLoaded = false;
        vm.allPackageList = [];


        vm.openDeletePackageModal = openDeletePackageModal;

        function init(){
            vm.isDataLoaded = false;
            membershipManagementService.getAllPackages().then(function (data){
                vm.allPackageList = data;
                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");

            },function (error){
                toastrService.showErrorToastr('Failed to fetch data: ' + error, '', '5000');
            });
        }
        init();

        function openDeletePackageModal(id,name){
                toastrService.clearPreviousToastr();
                var params = {
                    id : id,
                    name : name
                }
                $uibModal.open({
                    animation : true,
                    templateUrl : 'app/pages/main/membershipManagement/membershipSettings/delete/deletePackage.modal.html',
                    size : 'md',
                    controller : 'DeletePackageModalCtrl',
                    controllerAs : 'vm',
                    backdrop : 'static',
                    resolve : {packageName : function () {
                            return params;
                        }}
                }).result.then(function () {
                    init();
                })
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('GeneralConfirmationModalCtrl', [ '$uibModalInstance', 'toastrService', 'confirmationMsg', GeneralConfirmationModalCtrl]);

    /** @ngInject */
    function GeneralConfirmationModalCtrl($uibModalInstance, toastrService, confirmationMsg) {
        var vm = this;
        vm.confirmationText=confirmationMsg;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main')
        .controller('ReportDownloadWarningModalCtrl', [ '$uibModalInstance', 'toastrService', ReportDownloadWarningModalCtrl]);

    /** @ngInject */
    function ReportDownloadWarningModalCtrl($uibModalInstance, toastrService) {
        var vm = this;

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.overtime.manageOvertime')
        .controller('ManageOvertimeCtrl', ['editableOptions','editableThemes','_','employeeService','departmentService','shiftService','$uibModal','officeService', 'authService', 'toastrService','$state','aclLevel', 'utilService',ManageOvertimeCtrl]);

    /** @ngInject */
    function ManageOvertimeCtrl(editableOptions,editableThemes,_,employeeService,departmentService,shiftService,$uibModal,officeService, authService, toastrService,$state,aclLevel,utilService) {

        var vm = this;

        vm.allEmployees = null;
        vm.checkbox = {};
        vm.checkbox.isAnySelected = false;
        vm.checkbox.isAllSelected = false;
        vm.showDiv = false;
        vm.isEmployeeListLoaded = null;
        vm.rowsToShow = 100;

        vm.departmentList = [];
        vm.shiftList = [];
        vm.companyList = [];
        vm.officeList = [];

        vm.search = {};
        vm.search.searchName = "";
        vm.search.selectedDepartmentList = [];
        vm.search.selectedShiftList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];

        vm.getStatusInText = getStatusInText;
        vm.searchEmployees = searchEmployees;
        vm.prepareDataForPagination = prepareDataForPagination;
        vm.paginateData = paginateData;
        vm.reduceSelectedPaginationPage = reduceSelectedPaginationPage;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.toggleAll = toggleAll;
        vm.optionToggled = optionToggled;
        vm.filterEmployees = filterEmployees;
        vm.openAllowModal = openAllowModal;
        vm.openDisallowModal = openDisallowModal;
        vm.getPaginationInfo = getPaginationInfo;

        vm.sortingMethods = {
            sortById : sortById,
            sortByName : sortByName,
            sortByDepartmentName : sortByDepartmentName,
            sortByShiftName : sortByShiftName,
            sortByDesignationHierarchy : sortByDesignationHierarchy,

        };

        var sortStatus = {
            key : "id",
            order : "ascending"
        };

        init();

        function init() {
            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            getAllDepartments();
            getAllShifts();
            getAllEmployees([authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id]);
        }

        function getPaginationInfo() {
            var data = {
                selectedPage : vm.selectedPaginationPage,
                numberOfButtons : vm.numberOfButtons,
                allData : vm.allEmployees,
                showingData : vm.employeeList,
                showRows : vm.rowsToShow
            };
            return utilService.getPaginationInfo(data);
        }

        function getAllDepartments() {
            departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
        }

        function onGetAllDepartmentsSuccess(departmentList) {
            vm.departmentList = departmentList;
        }

        function onGetAllDepartmentsFailure(message) {
            toastrService.showErrorToastr("Failed to fetch department list : " + message, "", 5000);
            console.error("Failed to fetch department list : " + message);
        }

        function getAllShifts() {
            shiftService.getAllShifts(false).then(onGetAllShiftsSuccess, onGetAllShiftsFailure);
        }

        function onGetAllShiftsSuccess(shiftList) {
            vm.shiftList = shiftList;
        }

        function onGetAllShiftsFailure(message) {
            toastrService.showErrorToastr("Failed to fetch shift list : " + message, "", 5000);
            console.error("Failed to fetch shift list : " + message);
        }

        function searchEmployees() {
            if(aclLevel.value == 'office')
                getAllEmployees([authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id], getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'), getIdArrayFromMultiSelectOutput(vm.search.selectedShiftList, 'id'), vm.search.searchName);
            else
                getAllEmployees(getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id'), getIdArrayFromMultiSelectOutput(vm.search.selectedOfficeList, 'id'), getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'), getIdArrayFromMultiSelectOutput(vm.search.selectedShiftList, 'id'), vm.search.searchName);
        }

        function getAllEmployees(companies, offices, departments, shifts, name) {
            vm.isEmployeeListLoaded = false;
            employeeService.getFilteredEmployees(companies, offices, departments, shifts, name).then(onEmployeeFetchSuccess, onEmployeeFetchFailure);
        }

        function onEmployeeFetchSuccess(data) {
            vm.isEmployeeListLoaded = true;
            vm.allEmployees = data.employees;
            for (var i = 0 ; i < vm.allEmployees.length ; i ++) {
                vm.allEmployees[i].selected = false;
            }
            prepareDataForPagination();
        }

        function onEmployeeFetchFailure (message) {
            toastrService.showErrorToastr("Failed to fetch employee list, error message : " + message, "", 5000);
            console.error("Failed to fetch employee list, error message : " + message);
        }

        function prepareDataForPagination () {
            vm.employeeList = vm.allEmployees.slice(0, parseInt(vm.rowsToShow));
            vm.numberOfPages = Math.ceil(_.size(vm.allEmployees) / parseInt(vm.rowsToShow));
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.selectedPaginationPage = 0;
        }
        function paginateData (index) {
            vm.employeeList = vm.allEmployees.slice(index * parseInt(vm.rowsToShow), index * parseInt(vm.rowsToShow) + parseInt(vm.rowsToShow));
            vm.selectedPaginationPage = index;
        }

        function reduceSelectedPaginationPage() {
            vm.selectedPaginationPage = vm.selectedPaginationPage === 0 ? 0 : vm.selectedPaginationPage - 1;
        }

        function increaseSelectedPaginationPage() {
            vm.selectedPaginationPage = vm.selectedPaginationPage === vm.numberOfButtons.length - 1 ? vm.selectedPaginationPage : vm.selectedPaginationPage +1;
        }

        function onCompanyChange() {
            getOfficesFromCompanyIdArray();
        }

        function getOfficesFromCompanyIdArray() {
            officeService.getOfficesFromCompanyIdArray(false, getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id')).then(onGetOfficesFromCompanyIdArraySuccess, onGetOfficesFromCompanyIdArrayFailure);
        }

        function onGetOfficesFromCompanyIdArraySuccess(data) {
            vm.officeList = data.officeList;
            for(var j = 0; j<vm.officeList.length;j++){
                var office = vm.officeList[j];
                if(office.id == authService.getLoggedInUser().office.id){
                    office.ticked = true;
                }
            }
        }

        function onGetOfficesFromCompanyIdArrayFailure(message) {
            toastrService.showErrorToastr("Failed to fetch office names : "+message, "", 5000);
            console.error("Failed to fetch office names : "+message);
        }

        function getIdArrayFromMultiSelectOutput(array, keyToExtract) {
            if(!array || array.length == 0) return null;
            var returnArray = [];
            for(var i=0; i < array.length; i++){
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }

        function toggleAll() {
            if(vm.checkbox.isAllSelected)
                angular.forEach(vm.employeeList, function(itm){ itm.selected = true; });
            else
                angular.forEach(vm.employeeList, function(itm){ itm.selected = false; });
            checkIfAnySelected();
        }

        function optionToggled(){
            vm.checkbox.isAllSelected = vm.employeeList.every(function(itm)
            {
                return itm.selected===true;
            });
            checkIfAnySelected();
        }

        function checkIfAnySelected() {
            for(var i = 0 ; i< vm.employeeList.length ; i++){
                if(vm.employeeList[i].selected) {
                    vm.checkbox.isAnySelected = true;
                    return;
                }
            }
            vm.checkbox.isAnySelected = false;
        }

        function filterEmployees() {
            var selectedEmployeeIds = [];
            angular.forEach(vm.employeeList, function (employee, key) {
                if(employee.selected) {
                    selectedEmployeeIds.push(employee.id);
                }
            });
            return selectedEmployeeIds;

        }

        function getStatusInText(status) {
            if(status === 0) return "Inactive";
            if(status === 1) return "Active";
            if(status === -1) return "Archived";
        }

        function sortById() {
            if (sortStatus.key == "employeeIdentifier" && sortStatus.order == "ascending") {
                vm.allEmployees = _.sortBy(vm.allEmployees, 'employeeIdentifier').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeIdentifier";
                sortStatus.order = "descending";
            } else {
                vm.attendanceList = _.sortBy(vm.attendanceList, 'employeeIdentifier');
                sortStatus.key = "employeeIdentifier";
                sortStatus.order = "ascending";
            }
        }

        function sortByName() {
            if (sortStatus.key == "employeeName" && sortStatus.order == "ascending") {
                vm.allEmployees = _.sortBy(vm.allEmployees, function (employee) {
                    return employee.name.toLowerCase();
                }).reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeName";
                sortStatus.order = "descending";
            } else {
                vm.allEmployees = _.sortBy(vm.allEmployees, function (employee) {
                    return employee.name.toLowerCase();
                });
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "employeeName";
                sortStatus.order = "ascending";
            }
        }

        function sortByDepartmentName() {
            if (sortStatus.key == "departmentName" && sortStatus.order == "ascending") {
                vm.allEmployees = _.sortBy(vm.allEmployees, 'department.name').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "departmentName";
                sortStatus.order = "descending";
            } else {
                vm.allEmployees = _.sortBy(vm.allEmployees, 'department.name');
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "departmentName";
                sortStatus.order = "ascending";
            }
        }

        function sortByDesignationName() {
            if (sortStatus.key == "designationName" && sortStatus.order == "ascending") {
                vm.allData.allAttendanceData = _.sortBy(vm.attendanceList, 'designationName').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "designationName";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = _.sortBy(vm.attendanceList, 'designationName');
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "designationName";
                sortStatus.order = "ascending";
            }
        }

        function sortByDesignationHierarchy() {
            if (sortStatus.key == "designationHierarchy" && sortStatus.order == "ascending") {
                vm.allData.allAttendanceData =_.sortBy(vm.allData.allAttendanceData, function (attendance) {
                    return attendance.designationHierarchy;
                }).reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "designationHierarchy";
                sortStatus.order = "descending";
            } else {
                vm.allData.allAttendanceData = _.sortBy(vm.allData.allAttendanceData, function (attendance) {
                    return attendance.designationHierarchy;
                });
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "designationHierarchy";
                sortStatus.order = "ascending";
            }
        }

        function sortByShiftName() {
            if (sortStatus.key == "shiftName" && sortStatus.order == "ascending") {
                vm.allEmployees= _.sortBy(vm.allEmployees, 'shiftName').reverse();
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "shiftName";
                sortStatus.order = "descending";
            } else {
                vm.allEmployees = _.sortBy(vm.allEmployees, 'shiftName');
                paginateData(vm.selectedPaginationPage);
                sortStatus.key = "shiftName";
                sortStatus.order = "ascending";
            }
        }

        function openAllowModal() {
            toastrService.clearPreviousToastr();
            var selectedEmployeeIds = filterEmployees();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/overtime/manageOvertime/allow/allowOvertime.modal.html',
                size : 'md',
                controller : 'AllowOvertimeCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve:{
                    selectedEmployeeIds:function () {
                        return selectedEmployeeIds;
                    }
                }
            }).result.then(function (data) {
                vm.employeeList.forEach(function (employee) {
                    if(selectedEmployeeIds.includes(employee.id)){
                        employee.allowOvertime = true;
                    }
                    prepareDataForPagination();
                });
            });
        }

        function openDisallowModal() {
            toastrService.clearPreviousToastr();
            var selectedEmployeeIds = filterEmployees();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/overtime/manageOvertime/disallow/disallowOvertime.modal.html',
                size : 'md',
                controller : 'DisallowOvertimeCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve:{
                    selectedEmployeeIds:function () {
                        return selectedEmployeeIds;
                    }
                }
            }).result.then(function (data) {
                    vm.employeeList.forEach(function (employee) {
                    if(selectedEmployeeIds.includes(employee.id)){
                        employee.allowOvertime = false;
                    }
                });
                prepareDataForPagination();
                toastrService.showSuccessToastr("Overtime Disallowed!");
            });
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.overtime.monthlyOvertimeSummary')
        .controller('MonthlyOvertimeSummaryCtrl',
            ['authService', 'overtimeService', '_', 'departmentService', 'officeService', 'toastrService', 'designationService', 'employmentTypeService', '$q', 'utilService', 'GENDER', '$scope', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES',MonthlyOvertimeSummaryCtrl]);

    /** @ngInject */
    function MonthlyOvertimeSummaryCtrl(authService, overtimeService, _, departmentService, officeService, toastrService, designationService, employmentTypeServices, $q, utilService, GENDER, $scope, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm  = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.numberOfPages = null;
        vm.attendanceList = [];
        vm.dateList = [];
        vm.selectedPaginationPage = 0;
        vm.dateList = null;
        vm.excelUrl = null;
        vm.isDataLoaded = null;
        vm.isFilterVisible = false;
        vm.searchParams = {};
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        vm.getCurrentMonthInString = getCurrentMonthInString;
        vm.search = search;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : true
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : loggedInUser.isAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            excelDownloadButton : {
                show : true
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            sortKey: {
                show: true
            }
        };


        function search(params) {
            vm.isDataLoaded = false;
            modifyParams(params);
            overtimeService.getOvertime(vm.searchParams)
                .then(function (responseData) {
                    vm.isDataLoaded = true;
                    vm.dateList = responseData.dates;
                    vm.startOfDayList = responseData.startOfDayList;
                    vm.excelUrl = overtimeService.getMonthlyOvertimeReportExcel(vm.searchParams);
                    vm.attendanceList = responseData.perEmployeeOvertimeReportList;
                    vm.numberOfPages = responseData.totalPages;
                    vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                    vm.selectedPage = responseData.currentPage;
                    vm.total = responseData.total;

                    $scope.$broadcast("refreshFixedColumns");
                }, function (message) {
                    vm.isDataLoaded = true;
                    toastrService.showErrorToastr("Cannot fetch attendance from server : " + message, "", 5000);
                });
        }


        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "overtime";
        }

        function getCurrentMonthInString() {
            var d = new moment().format("MMMM");
            return d;
        }

        function logSelectedMonth() {
            // console.log(vm.selectedMonth);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.liveFeedAndDashboard')
        .controller('LiveFeedAndDashboardCtrl', ['$scope','$interval', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'parkingManagementService', '$q', '_','analyticsService', 'ANALYTICS_CONSTANT', LiveFeedAndDashboardCtrl]);

    /** @ngInject */
    function LiveFeedAndDashboardCtrl($scope, $interval, $stateParams, $state, $uibModal, authService, toastrService, parkingManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDataLoaded = false;
        vm.searchKeyword = null;
        vm.parkingInfo = [];
        vm.enteredVehicleList = [];
        vm.parkingInfoList = [];
        vm.refreshEnabled = false;

        vm.removeVehicle = removeVehicle;
        vm.refreshNearbyExitVehicle = getAllNearbyExitVehicle;
        vm.getEnteredVehicleData = getEnteredVehicleData;
        vm.searchByVehicleDriverOwner = searchByVehicleDriverOwner;

        function init(){
            getLiveFeedData();
            getEnteredVehicleData();
            getSlotData();
            getAllNearbyExitVehicle();
        }
        init();

        var promise;
        promise = $interval(function (){
            getAllNearbyExitVehicle();
        },10000);


        function getLiveFeedData(){
            vm.isDataLoaded = false;
            parkingManagementService.getLiveFeed().then(function (data){
                vm.parkingInfoList = data;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function searchByVehicleDriverOwner(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            getEnteredVehicleData();
        }

        function  getEnteredVehicleData(){
            vm.isDataLoaded = false;
            var params = {"keyword": vm.searchKeyword};
            parkingManagementService.getEnteredVehicle(params).then(function (data){
                vm.enteredVehicleList = data;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getSlotData(){
            vm.isDataLoaded = false;
            parkingManagementService.getSlotInfo().then(function (data){
                vm.slotInfo = data;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getAllNearbyExitVehicle() {
            // vm.isDataLoaded = false;
            vm.refreshEnabled = true;

            parkingManagementService.getNearbyVehicleExit().then(function (data){
                vm.foundNearbyList = data;
                vm.refreshEnabled = false;
                // vm.vehicleTypeAndBillsList = angular.copy(vm.allVehicleTypesAndBills);
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function removeVehicle(index){
            vm.foundNearbyList.splice(index,1);
        }

        function removeEventListener(event){
            if(angular.isDefined(promise)){
                $interval.cancel(promise);
            }
        }

        $scope.$on('$destroy',function (){
            document.removeEventListener("visibilitychange",removeEventListener());
        })
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.parkingSlotSetup')
        .controller('ParkingSlotSetCtrl', ['$scope', '$stateParams', '$state', 'employeeService', "parkingManagementService", '$uibModal', 'authService', 'toastrService', 'bankManagementService', '$q', '_', ParkingSlotSetCtrl]);

    /** @ngInject */
    function ParkingSlotSetCtrl($scope, $stateParams, $state, employeeService, parkingManagementService, $uibModal, authService, toastrService, bankManagementService, $q, _) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isAnyRowSelected = false;
        vm.isEditBtnClicked = false;
        vm.selectedRowIndex = null;
        vm.allData = [];
        vm.selectedRow = null;
        vm.isDataLoaded = false;
        vm.selectedOwner = [];
        vm.searchParams = {}
        vm.searchParams.pageNumber = 0
        vm.searchParams.perPage = 10
        vm.ownerDropDownList = []
        vm.openDeleteModal = openDeleteModal
        vm.openEditModal = openEditModal


        function init() {
            search()
        }

        init();

        function openEditModal(data) {

            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/parkingManagement/parkingSlotSetup/edit/editModal.html',
                size: 'md',
                controller: 'EditParkingSlotSetupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    data: function () {
                        return  angular.copy(data);
                    }
                }
            }).result.then(function (data) {
                if (data === "Success") {
                    search()
                }
            }, function () {

            });
        }
        function openDeleteModal(data) {

            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/parkingManagement/parkingSlotSetup/delete/deleteModal.html',
                size: 'md',
                controller: 'DeleteParkingSlotSetupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    data: function () {
                        return {
                            id: data.id
                        };
                    }
                }
            }).result.then(function (data) {
                if (data === "Success") {
                    search()
                }
            }, function () {

            });
        }

        function search() {
            vm.isDataLoaded = false;
            parkingManagementService.getAllParkingSlot().then(function (data) {
                vm.allData = data.parkingSlotList;
                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });

        }

        vm.update = update

        function update() {
            // console.log(vm.selectedRow)
            var data = {
                id: vm.selectedRow.id,
                vehicleNumber: vm.selectedRow.vehicleNumber,
                employeePhoneNumber: vm.selectedRow.employeePhoneNumber,
                vehicleTypeId: vm.selectedRow.vehicleTypeId,
                color: vm.selectedRow.color,
                brand: vm.selectedRow.brand,
                model: vm.selectedRow.model,
                ownerId: vm.selectedRow.ownerId,
                driverName: vm.selectedRow.driverName,
                driverMobileNumber: vm.selectedRow.driverMobileNumber,
                officeId: vm.selectedRow.officeId
            }
            parkingManagementService.createOrUpdateVehicleInformation(data)
                .then(function (response) {
                    if (response === 'Success') {
                        toastrService.showSuccessToastr("Update Successful", "", 5000);
                    } else
                        toastrService.showErrorToastr("", "", 5000);

                })

        }

        vm.cancelEdit = cancelEdit

        function cancelEdit() {
            vm.isAnyRowSelected = false
            vm.isEditBtnClicked = false
            vm.selectedRow = []
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.vehicles')
        .controller('VehiclesCtrl', ['$scope', '$stateParams', '$state','employeeService', "parkingManagementService", '$uibModal', 'authService', 'toastrService', 'bankManagementService', '$q', '_', 'analyticsService', 'ANALYTICS_CONSTANT', VehiclesCtrl]);

    /** @ngInject */
    function VehiclesCtrl($scope, $stateParams, $state,employeeService, parkingManagementService, $uibModal, authService, toastrService, bankManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isAnyRowSelected = false;
        vm.isEditBtnClicked = false;
        vm.selectedRowIndex = null;
        vm.allData = [];
        vm.selectedRow = null;
        vm.isDataLoaded = false;
        vm.selectedOwner = [];
        vm.searchParams = {}
        vm.searchParams.pageNumber = 0
        vm.searchParams.perPage = 10
        vm.ownerDropDownList = []
        vm.vehicleTypes = []

        vm.showOwnerInfoInTheRightColumn = showOwnerInfoInTheRightColumn
        vm.showOwnerEditInfoInTheRightColumn = showOwnerEditInfoInTheRightColumn
        vm.openDeleteModal = openDeleteModal
        vm.search = search
        vm.searchByNameOrId = searchByNameOrId;


        function init() {
           /* employeeService.getFilteredEmployees({status: 1}).then(function (data){
                vm.employees = angular.copy(data.employees);
                generateOwnerSelectionOptions();
            });*/
            parkingManagementService.getAllBillSetup().then(function (data) {
                vm.vehicleTypes = data
            });
            $q.all([search()]).then(function () {
                if(vm.index != null) {
                    vm.isAnyRowSelected = true
                    vm.isEditBtnClicked = false;
                    vm.selectedRow = vm.allData[vm.index];
                }
            });
            search()
        }

        init();
/*
        function generateOwnerSelectionOptions() {
            vm.employees.forEach(function (employee) {
                var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                if(employee.pictureUrl != null && employee.pictureUrl !== "") {
                    pictureElement = "<img src='" + employee.pictureUrl + "' />";
                }
                var designationNameElement = "";
                var departmentNameElement = "";
                if(employee.designationName != null && employee.designationName !== "") {
                    designationNameElement = "<span>" + employee.designationName + "</span>";
                }
                if(employee.departmentName != null && employee.departmentName !== "") {
                    departmentNameElement = "<span>" + employee.departmentName + "</span>";
                    if(designationNameElement.length > 0)
                        departmentNameElement = ", " + departmentNameElement;
                }

                var optionTemplate = "<div class='flex-container text-left width-95'>" +
                    "<div class='with-round-bg mb-0'>" +
                    pictureElement +
                    "</div>" +
                    "<div class='profile-info'>" +
                    "<span>" + employee.name + "</span>" +
                    "<div class='font-12 info-bg'>" +
                    "<small>" +
                    designationNameElement + departmentNameElement +
                    "</small>" +
                    "</div>" +
                    "</div>" +
                    "</div>";

                var obj = {
                    id: employee.id,
                    name: employee.name,
                    label: optionTemplate,
                    employeeOfficeId: employee.employeeOfficeId,
                    ticked: false
                };
                vm.ownerDropDownList.push(obj);
            });

        }
        vm.selectOwner = selectOwner

        function selectOwner(){
            // console.log(vm.selectedOwner[0]["id"])
            console.log(vm.allData.filter(value => {
                return value.employee.employeeId === vm.selectedOwner[0]["id"]
            }))

        }*/

        function showOwnerInfoInTheRightColumn(index) {
            vm.index = index;
            vm.isAnyRowSelected = true
            vm.isEditBtnClicked = false
            vm.selectedRow = vm.allData[index];
            vm.vehicleNumber = angular.copy(vm.allData[index].vehicleNumber);
        }

        function showOwnerEditInfoInTheRightColumn(index) {
            vm.isAnyRowSelected = true
            vm.isEditBtnClicked = true
            vm.selectedRow = vm.allData[index];
            vm.vehicleNumber = angular.copy(vm.allData[index].vehicleNumber);
            // vm.ownerDropDownList = vm.ownerDropDownList.map(obj =>
            //     obj.id === vm.allData[index].employee.employeeId ? { ...obj, ticked: true } : obj
            // );
            // vm.selectedOwner.push({'id':vm.allData[index].employee.employeeId});
        }

        function openDeleteModal(data) {

            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/parkingManagement/vehicles/delete/deleteModal.html',
                size: 'md',
                controller: 'DeleteVehicleOwnerModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    data: function () {
                        return {
                            id: data.id,
                            vehicleNumber: data.vehicleNumber
                        };
                    }
                }
            }).result.then(function (data) {
                if (data==="Success"){
                    search()
                }
            }, function () {

            });
        }

        function searchByNameOrId(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            search();
        }

        function search(searchParams) {
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            vm.allData = [];
            return parkingManagementService.getAllVehicleInfo(vm.searchParams).then(function (data) {
                vm.allData = data.vehicles;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });

        }
        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = 'daily';
        }
        vm.update = update

        function update(){
            // console.log(vm.selectedRow)
            if(!vm.vehicleNumber)
                return toastrService.showErrorToastr('Vehicle number can not be empty');
            var data = {
                id: vm.selectedRow.id,
                vehicleNumber:vm.vehicleNumber,
                vehicleTypeId: vm.selectedRow.vehicleTypeId,
                color:vm.selectedRow.color,
                brand:vm.selectedRow.brand,
                model:vm.selectedRow.model,
                ownerId: vm.selectedRow.ownerId,
                driverName:vm.selectedRow.driverName,
                driverMobileNumber:vm.selectedRow.driverMobileNumber,
                officeId:vm.selectedRow.officeId
            }
            parkingManagementService.createOrUpdateVehicleInformation(data)
                .then(function (response){
                    if (response === 'Success'){
                        analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit', '', 'Update Vehicle In' + document.title, ANALYTICS_CONSTANT.edit)
                        toastrService.showSuccessToastr("Update Successful", "", 5000);
                        init();
                        vm.isEditBtnClicked = false;

                    }
                    else
                        toastrService.showErrorToastr("","",5000);

            })

        }
        vm.cancelEdit = cancelEdit
        function cancelEdit(){
            vm.isAnyRowSelected = false
            vm.isEditBtnClicked = false
            vm.selectedRow = []
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryComparison')
        .controller('ComparisonReportCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService', 'toastrService','salaryReportService', ComparisonReportCtrl]);

    /** @ngInject */
    function ComparisonReportCtrl($scope, $stateParams, $state, $timeout, authService, employeeService, toastrService,salaryReportService) {
        var vm = this;
        vm.objectOfSalaryComponents={};

        init();
        function init(){
            var params = {
                month1              :9,
                month2              :2,
                year1               :2021,
                year2               :2021,
            }
            salaryReportService.getSalaryComparisonOfTwoMonths(params).then(function(data){
                vm.objectOfSalaryComponents=data.idToSalaryComparisonMap;
                console.log(vm.objectOfSalaryComponents);
            },function (err){
                console.log(err);
            })
        }

        /************/
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.loanManagement')
        .controller('LoanManagementCtrl', ['$scope', '$stateParams', '$uibModal', '$state', '$timeout', 'authService', 'employeeService', 'toastrService', 'payrollManagementService', 'MONTH_NAMES_SHORT', 'utilService', 'LOAN_TYPE', '$q', 'loanManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', LoanManagementCtrl]);

    /** @ngInject */
    function LoanManagementCtrl($scope, $stateParams, $uibModal, $state, $timeout, authService, employeeService, toastrService, payrollManagementService, MONTH_NAMES_SHORT, utilService, LOAN_TYPE, $q, loanManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.loanType = angular.copy(LOAN_TYPE);
        vm.selectedLoanType = 2;
        vm.isFirstDataLoaded = false;
        vm.isDataLoaded = false;
        vm.isLoanInstallmentsDataLoaded = false;
        vm.isRowSelected = false;
        vm.panelTitle = 'Loan Management'
        vm.totalLoanAmountOfOffice = null;
        vm.totalRemainingLoanOfOffice = null;
        vm.loanStatus = 1;
        vm.allLoanList = [];
        vm.selectedLoanToShow = null;
        vm.totalLoans = 0;
        vm.totalPage = 0;
        vm.numberOfButtons = Array(vm.totalPage).fill(1);
        vm.rowsPerPage = 0;
        vm.pageNumber = 0;
        vm.keyWord = null;
        vm.isSelectedLoanSettled = false;
        vm.monthNames = angular.copy(MONTH_NAMES_SHORT);
        vm.selectedRow = null;
        vm.excelUrl = "";


        vm.deferLoan = deferLoan;
        vm.earlySettlement = earlySettlement;
        vm.switchTab = switchTab;
        vm.getLoanPageSpecifiedData = getLoanPageSpecifiedData;
        vm.loanRowSelect = loanRowSelect;
        vm.searchWithKeyLoan = searchWithKeyLoan;
        vm.exportAsExcel = exportAsExcel;

        init();

        function init() {
            vm.isFirstDataLoaded = false;
            vm.isRowSelected = false;
            vm.selectedLoanToShow = null;
            preparePagination();
            $q.all([getLoanSummary(), getAllLoansOfOffice()]).then(function () {

            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isFirstDataLoaded = true;
            });

        }

        function loanRowSelect(index) {
            vm.isRowSelected = true;
            vm.isLoanInstallmentsDataLoaded = false;
            vm.selectedRow = index;
            vm.selectedLoanToShow = {
                employeeName: vm.allLoanList[index].employeeName,
                departmentName: vm.allLoanList[index].departmentName,
                designationName: vm.allLoanList[index].designationName,
                employeePictureUrl: vm.allLoanList[index].employeePictureUrl,
                installmentCount: vm.allLoanList[index].instalmentCount,
                paidAmount: vm.allLoanList[index].paidAmount,
                remainingAmount: vm.allLoanList[index].remainingAmount,
                disbursedAt: vm.allLoanList[index].disbursedAt,
                requestedAt: vm.allLoanList[index].requestedAt,
                typeText: vm.allLoanList[index].typeText,
                amount: vm.allLoanList[index].amount,
                remarks: vm.allLoanList[index].remarks,
                isEditable: vm.allLoanList[index].isEditable,
                loanInstallments: [],
            }
            // console.log(vm.selectedLoanToShow)
            vm.excelUrl = loanManagementService.getLoanAdvSalaryDetailsReportExcel(vm.allLoanList[index].id);
            // console.log(vm.excelUrl);
            loadLoanInstallmentData(vm.allLoanList[index].id);
        }

        function searchWithKeyLoan() {
            analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In '+document.title, ANALYTICS_CONSTANT.search);
            preparePagination();
            getAllLoansOfOffice();
        }

        function loadLoanInstallmentData(id) {
            vm.isSelectedLoanSettled = false;
            vm.isLoanInstallmentsDataLoaded = false;
            return loanManagementService.getInstallmentsOfLoan(id).then(function (data) {
                // console.log(data);
                vm.selectedLoanToShow.loanInstallments = data.instalments;
                // console.log(vm.selectedLoanToShow);
                // console.log(data);
                vm.selectedLoanToShow.remarks = data.remarks ? data.remarks : vm.selectedLoanToShow.remarks;
                vm.isLoanInstallmentsDataLoaded = true;
                data.instalments.forEach(function (elem) {
                    if (elem.status === 3)
                        vm.isSelectedLoanSettled = true;
                })

                $scope.$broadcast("refreshFixedColumns");
            }, function (err) {
                toastrService.showErrorToastr("Could not get data.", "", 5000)

                // console.log(err)
            })
        }

        function preparePagination(totalPage, selectedPage, total) {
            vm.rowsPerPage = utilService.setRowsPerPage(10);
            vm.rowsPerPage = utilService.getRowsPerPage();
            vm.pageNumber = selectedPage == null ? 0 : selectedPage;
            vm.totalPage = totalPage == null ? 0 : totalPage;
            vm.totalLoans = total == null ? 0 : total;
            vm.numberOfButtons = Array(vm.totalPage).fill(1);
        }

        function getLoanPageSpecifiedData(params) {
            if (params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            getAllLoansOfOffice();
        }

        function modifyParams(searchParams) {
            if (searchParams == 'prev') {
                vm.pageNumber = vm.pageNumber == 0 ? 0 : vm.pageNumber - 1;
            } else if (searchParams == 'next') {
                vm.pageNumber = vm.pageNumber == vm.totalPage ? vm.pageNumber : vm.pageNumber + 1;
            } else if (!isNaN(searchParams)) {
                vm.pageNumber = searchParams;
            }
        }

        function getLoanSummary() {
            return loanManagementService.getLoanSummaryOfOffice().then(function (data) {
                vm.totalLoanAmountOfOffice = data.totalAmount;
                vm.totalRemainingLoanOfOffice = data.remainingAmount;
                // console.log(data)
            }, function (err) {
                toastrService.showErrorToastr("Could not get data.", "", 5000)
                // console.log(err)
            })
        }

        function switchTab(status) {
            if (status == vm.loanStatus)
                return;
            vm.loanStatus = status;
            preparePagination();
            getAllLoansOfOffice();
        }

        function prepareParams() {
            var params = {
                keyword: vm.keyWord,
                status: vm.loanStatus,
                pageNumber: vm.pageNumber,
                perPage: vm.rowsPerPage,
            }
            return params;
        }

        function getAllLoansOfOffice() {
            vm.isDataLoaded = false;
            return loanManagementService.getAllLoansOfOffice(prepareParams()).then(function (data) {
                vm.isDataLoaded = true;
                vm.allLoanList = data.loans;
                preparePagination(data.numberOfPages, data.currentPage, data.total);
            }, function (err) {
                toastrService.showErrorToastr("Could not get data.", "", 5000)
            })
        }

        function deferLoan(index) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/loanManagement/modals/deferLoanModal.html',
                size: 'md',
                controller: 'DeferLoanModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve:
                    {
                        loanToDefer: function () {
                            return vm.allLoanList[index];
                        }
                    }
            }).result.then(function () {
                loadLoanInstallmentData(vm.allLoanList[vm.selectedRow].id);
            });
        }

        function earlySettlement(index) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/loanManagement/modals/earlySettlement.modal.html',
                size: 'md',
                controller: 'EarlySettlementCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve:
                    {
                        loanToSettle: function () {
                            return vm.allLoanList[index];
                        },
                        loanInstallments: function () {
                            return vm.selectedLoanToShow.loanInstallments;
                        }
                    }
            }).result.then(function () {
                init();
            });
        }

        function exportAsExcel() {
            if (vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Loan Management Excel', ANALYTICS_CONSTANT.downloadExcel)
                window.open(vm.excelUrl, '_blank', '');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.payrollSettings')
        .controller('PayrollSettingsCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService', 'toastrService','payrollSettingsService', 'VALUE_TYPE', 'analyticsService', 'ANALYTICS_CONSTANT', PayrollSettingsCtrl]);

    /** @ngInject */
    function PayrollSettingsCtrl($scope, $stateParams, $state, $timeout, authService, employeeService, toastrService,payrollSettingsService, VALUE_TYPE, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.selectedPayrollType = null;
        vm.selectedComponent = null;
        vm.selectedVlueType = null;
        vm.selectedPercentage = null;
        vm.selectedValue = null;
        vm.selectedStatus = null;
        vm.isUpdateSettingsBtnClicked = false;
        vm.isCreateSettingsBtnClicked = false;
        // vm.analyticsEditPayrollComponent =analyticsEditPayrollComponent;
        // vm.analyticsAddNewComponent =analyticsAddNewComponent;
        vm.addNewRow = addNewRow;
        vm.createPayrollSettings = createPayrollSettings;
        vm.updatePayrollSettings = updatePayrollSettings;
        vm.editPayrollSettings = editPayrollSettings;
        vm.showCreatePayrollSettingsSection = showCreatePayrollSettingsSection;

        vm.selectedPayrollType = 1;
        vm.isPayrollSettingsAvailable = false;
        vm.openPayrollCreateSection = false;
        vm.showEditPage = false;
        vm.isDataLoaded = false;
        vm.payrollType = [{name:'Gross Salary Driven', value: 1},{name:'Basic Salary Driven', value: 2}];
        vm.categories = [{name:'Additive',value:1}, {name:'Deductive',value:-1}];
        vm.componentType = [{name:'Basic Pay', value:1},{name:'Allowance', value:2},{name:'Additional', value:3}];
        vm.valueTypes = angular.copy(VALUE_TYPE);
        vm.valueDeterminer = [{name:'Gross Salary',value:1},{name:'Basic Salary',value:2}];
        vm.status = [{name:'Inactive',value:0},{name:'Active',value:1}];
        vm.payrollSettingsData = [];
        vm.dummyPayrollSettingsData = [
            {
                name : 'Basic Salary',
                nameEditable : false,
                type : 1,
                category : 1,
                group : 1,
                valueType : 3,
                value : 0,
                status : 1,
                valueDeterminer : 0,
                paymentMode : 1,
                inclusiveToGross : true,
                isConfirmationBenefit : true,
                installment : 1,
                code : 'BASIC',
                hasDistribution : false
            },
            {
                name : 'House Rent Allowance',
                nameEditable : false,
                type : 2,
                category : 1,
                group : 1,
                valueType : 1,
                value : 25,
                status : 1,
                valueDeterminer : 2,
                paymentMode : 1,
                inclusiveToGross : true,
                isConfirmationBenefit : true,
                installment : 1,
                code : "HOUSE_RENT",
                hasDistribution : false
            },
            {
                name : 'Conveyance Allowance',
                nameEditable : false,
                type : 2,
                category : 1,
                group : 1,
                valueType : 1,
                value : 5,
                status : 1,
                valueDeterminer : 2,
                paymentMode : 1,
                inclusiveToGross : true,
                isConfirmationBenefit : true,
                installment : 1,
                code : "CONVEYANCE",
                hasDistribution : false
            },
            {
                name : 'Medical Allowance',
                nameEditable : false,
                type : 2,
                category : 1,
                group : 1,
                valueType : 1,
                value : 20,
                status : 1,
                valueDeterminer : 2,
                paymentMode : 1,
                inclusiveToGross : true,
                isConfirmationBenefit : true,
                installment : 1,
                code : "MED",
                hasDistribution : false
            },
            {
                name : 'Provident Fund',
                nameEditable : false,
                type : 3,
                category : -1,
                group : 1,
                valueType : 1,
                value : 10,
                status : 1,
                valueDeterminer : 2,
                paymentMode : 1,
                inclusiveToGross : false,
                isConfirmationBenefit : true,
                installment : 1,
                code : "PF",
                hasDistribution : false
            },
            {
                name : 'Income Tax',
                nameEditable : false,
                type : 10,
                category : -1,
                group : 1,
                valueType : 2,
                value : 500,
                status : 0,
                valueDeterminer : 0,
                paymentMode : 1,
                inclusiveToGross : false,
                isConfirmationBenefit : true,
                installment : 1,
                code : "TAX",
                hasDistribution : false
            },
            {
                name : 'Arrear Salary',
                nameEditable : false,
                type : 7,
                category : 1,
                group : 2,
                valueType : 3,
                value : 0,
                status : 1,
                valueDeterminer : 0,
                paymentMode : 1,
                inclusiveToGross : false,
                isConfirmationBenefit : true,
                installment : 1,
                code : "ARREARS",
                hasDistribution : false
            }
        ];



        function init(){
            getPayrollSettingsStatus();
        }
        init();

        function getPayrollSettingsStatus(){
            payrollSettingsService.getPayrollSettingsStatus().then(function (data){
                vm.isDataLoaded = true;
                vm.isPayrollSettingsAvailable = data.isSettingsAvailable;
                if(vm.isPayrollSettingsAvailable)
                    getPayrollSettingsData();

            });
        };

        function getPayrollSettingsData(){
            payrollSettingsService.getPayrollSettingsData().then(function (data){
                vm.selectedPayrollType = data.payrollSettings.payrollType;
                vm.payrollSettingsData = data.officePayrollComponents;
                vm.payrollSettingsId = data.payrollSettings.id;
                vm.numberOfPages = data.numberOfPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
                vm.isPayrollSettingsAvailable = true;
            });
        }

        function createPayrollSettings(){
            vm.isCreateSettingsBtnClicked = true;
            var data ={
                payrollType : vm.selectedPayrollType,
                components : vm.payrollSettingsData
            };
            if(!isPayrollSettingsValid(data)){
                vm.isCreateSettingsBtnClicked = false;
                return;
            }
            vm.isDataLoaded = false;
            payrollSettingsService.createPayrollSettings(data).then(function (){
                toastrService.showSuccessToastr("Payroll settings create successfully");
                getPayrollSettingsData();
                vm.isCreateSettingsBtnClicked = false;
                vm.showEditPage = false;
            }, function (error) {
                toastrService.showErrorToastr("Could not create payroll setting: " + error, "", 5000);
            });

        }

        function isPayrollSettingsValid(data){
            toastrService.clearPreviousToastr();
            var existingNames = [];
            for (var i = 0; i < data.components.length; i++) {
                if(existingNames.includes(data.components[i].name)){
                    toastrService.showErrorToastr("Components can not have the same name");
                    return false;
                }
                if(data.components[i].value < 0 ){
                    toastrService.showErrorToastr("Component value can not be negative");
                    return false;
                }
                if(data.components[i].valueType == 1 && data.components[i].value > 100){
                    toastrService.showErrorToastr("Components with percentage value type must have a value of less than 100.")
                    return false;
                }
                if(data.components[i].name == ''){
                    toastrService.showErrorToastr("Components name can not be empty.")
                    return false;
                }
                existingNames.push(data.components[i].name);
            }
            return true;
        }

        function editPayrollSettings (){
            vm.showEditPage = true;
        }

        function updatePayrollSettings(){
            // vm.isDataLoaded = false;
            vm.isUpdateSettingsBtnClicked = true;
            var data = {
                payrollType : vm.selectedPayrollType,
                components : vm.payrollSettingsData
            };
            if(!isPayrollSettingsValid(data)){
                vm.isUpdateSettingsBtnClicked = false;
                return;
            }
            payrollSettingsService.updatePayrollSettings(data).then(function (){
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Payroll settings update successfully");
                getPayrollSettingsData();
                vm.isUpdateSettingsBtnClicked = false;
                // vm.isDataLoaded = true;
                vm.showEditPage = false;
            },function (error) {
                toastrService.showErrorToastr("Update failed" + error, "", 5000);
            });

        }

        function showCreatePayrollSettingsSection(){
            vm.payrollSettingsData = vm.dummyPayrollSettingsData;
            vm.openPayrollCreateSection = true;
        }

        function addNewRow(){
            var rowToBeAdded = {
                name : 'New Component',
                nameEditable : true,
                type : 2,
                category : 1,
                valueType : 2,
                value : 2000,
                status : 1,
                valueDeterminer: 2,
                paymentMode : 1,
                inclusiveToGross : false,
                isConfirmationBenefit : true,
                installment : 1,
                code : "",
                hasDistribution : false
            };
            vm.payrollSettingsData.push(rowToBeAdded);

        }

        // function analyticsAddNewComponent(){
        //     analyticsService.sendData(ANALYTICS_CONSTANT.addNewComponent, document.title + ' - Add New Component', '', 'Add New Component In' + document.title, ANALYTICS_CONSTANT.addNewComponent)
        // }

        // function analyticsEditPayrollComponent(){
        //     analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit Component', '', 'Edit Component In' + document.title, ANALYTICS_CONSTANT.edit)
        // }
        /************/
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.payslip')
        .controller('PayslipCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService','payrollSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', PayslipCtrl]);

    /** @ngInject */
    function PayslipCtrl($scope, $stateParams, $state, $timeout,$uibModal, authService, employeeService, toastrService,payrollSettingsService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();


        vm.isDataLoaded = true;

        vm.selectedMonth = new Date();
        vm.monthPickerSalary = {};
        vm.monthPickerSalary.opened = false;
        vm.monthPickerSalary.format = "MMM yyyy";
        vm.employeeInformation = null;
        vm.employeeSalary = null;
        vm.monthlySalary = null;
        vm.salaryBreakDown = null;
        vm.keyword = "";

        vm.monthPickerSalary.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            // maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };


        vm.openMonthPickerSalary = openMonthPickerSalary;
        vm.getTotalSalary = getTotalSalary;
        vm.getTotalDeduction = getTotalDeduction;
        vm.searchByNameId = searchByNameId;

        function openMonthPickerSalary() {
            vm.monthPickerSalary.opened = true;
        }

        function searchByNameId(item){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            searchEmployee(item);
        }

        function getTotalSalary(){
            var sum = 0;
            if(vm.salaryBreakDown && vm.salaryBreakDown.components){
                // console.log(vm.salaryBreakDown.components)
                vm.salaryBreakDown.components.filter(function (data) {
                    return data.category == 1;
                }).forEach(function (c) {
                    sum += c.amount;
                })
            }
            return sum;
        }

        function getTotalDeduction(){
            var sum = 0;
            if(vm.salaryBreakDown && vm.salaryBreakDown.components){
                vm.salaryBreakDown.components.filter(function (data) {
                    return data.category == -1;
                }).forEach(function (c) {
                    sum += c.amount;
                })
            }
            return Math.abs(sum);
        }

        function searchEmployee(item){
            var employeeId = null;
            if(item){
                employeeId = item.id;
            }else{
                if(vm.employeeInformation == null){
                    employeeId = loggedInUser.id;
                }else {
                    employeeId = vm.employeeInformation.id;
                }
            }
            var date = angular.copy(vm.selectedMonth);
            vm.isDataLoaded = false;
            payrollSettingsService.getEmployeePayslipInformation(employeeId, date.getMonth()+1,date.getFullYear()).then(function (data){
                vm.employeeInformation = data.employeeInfo;
                vm.employeeSalary = data.employeeSalary;
                vm.monthlySalary = data.employeeMonthlySalary;
                if(vm.monthlySalary && vm.monthlySalary.updatedBreakdown != null)
                    vm.salaryBreakDown = JSON.parse(vm.monthlySalary.updatedBreakdown)
                vm.isDataLoaded = true;
            });
        }
        searchEmployee();

        $scope.$watch('vm.monthPickerSalary.opened',function(newVal, oldVal){
            if(!newVal) searchEmployee();
        })
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryCertificate')
        .controller('SalaryCertificateCtrl', ['$q', 'employeeService', 'toastrService', 'payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', SalaryCertificateCtrl]);

    /** @ngInject */
    function SalaryCertificateCtrl($q, employeeService, toastrService, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.employeeList = [];
        vm.signatoryList = [];
        vm.selectedEmployee = [];
        vm.selectedSignatory = [];
        vm.isEmployeeSelected = false;
        vm.isSignatorySelected = false;
        vm.isSignatoryInfoLoaded = false;
        vm.employeeToShow = null;
        vm.signatoryToShow = null;
        vm.showCertificate = false;
        vm.certificate = null;
        vm.isDataLoaded = false;
        vm.isCertificateLoaded = false;
        vm.docUrl = "";

        vm.analyticsDownloadDoc = analyticsDownloadDoc;
        vm.onEmployeeSelect = onEmployeeSelect;
        vm.onSignatorySelect = onSignatorySelect;
        vm.onReset = onReset;
        vm.generateSalaryCertificate = generateSalaryCertificate;
        vm.printCertificate = printCertificate;

        function init(){
            $q.all([
                getPayrollEnabledEmployees(),
                getEmployeesForSignatoryList()
            ]).then(function () {
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error);
            });

        }
        init();

        function getPayrollEnabledEmployees() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[],onlyPayrollEnabled:true}).then(function (data){
                vm.employeeList = angular.copy(data.employees);
            });
        }

        function getEmployeesForSignatoryList() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.signatoryList = angular.copy(data.employees);
            });
        }

        function onEmployeeSelect(){
            vm.isEmployeeSelected = true;
            vm.isEmployeeInfoLoaded = false;
            if(vm.selectedEmployee.length == 0) return;
            vm.employeeToShow = null;
            getEmployeeInfoWithSalary();
        }

        function onSignatorySelect(){
            vm.isSignatorySelected = true;
            vm.isSignatoryInfoLoaded = false;
            if(vm.selectedSignatory.length == 0) return;
            vm.signatoryToShow = null;
            getSignatoryProfile();
        }

        function getSignatoryProfile(){
            employeeService.getProfile(vm.selectedSignatory[0].id).then(function (data){
                vm.signatoryToShow = data.employee;
                vm.isSignatoryInfoLoaded = true;
            });
        }

        function onReset(){
            vm.isEmployeeSelected = false;
            vm.employeeToShow = null;
        }

        function getEmployeeInfoWithSalary() {
            payrollManagementService.getEmployeeInfoWithSalary(vm.selectedEmployee[0].id).then(function (data) {
                vm.employeeToShow = data;
                vm.isEmployeeInfoLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee details: " + error, "", 5000);
            });
        }

        function generateSalaryCertificate() {
            toastrService.clearPreviousToastr();
            if(vm.selectedEmployee.length == 0)
                return toastrService.showErrorToastr("You haven't selected any employee");
            if(vm.selectedSignatory.length == 0)
                return toastrService.showErrorToastr("You haven't selected any signatory");
            if(Number(vm.selectedEmployee[0].id) === Number(vm.selectedSignatory[0].id))
                return toastrService.showErrorToastr("Target employee and the signatory can not be the same person");

            var params = {
                params : {
                    signatoryEmployeeId : Number(vm.selectedSignatory[0].id)
                }
            };
            vm.showCertificate = true;

            payrollManagementService.generateSalaryCertificate(Number(vm.selectedEmployee[0].id), params).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.generateReport, document.title + ' - Generate', '', 'Generate Report In' + document.title, ANALYTICS_CONSTANT.generateReport)
                vm.certificate = data.certificate;
                vm.isCertificateLoaded = true;
                vm.docUrl = payrollManagementService.getCertificateDocUrl(Number(vm.selectedEmployee[0].id), Number(vm.selectedSignatory[0].id));
            }, function (error) {
                vm.showCertificate = false;
                vm.isCertificateLoaded = false;
                toastrService.showErrorToastr("Couldn't fetch salary certificate: " + error, "", 5000);
            });
        }

        function printCertificate() {
            analyticsService.sendData(ANALYTICS_CONSTANT.print, document.title + ' - Print', '', 'Print In' + document.title, ANALYTICS_CONSTANT.print)
            if(vm.isCertificateLoaded) {
                var printContents = document.getElementById("salary-certificate").innerHTML;
                var popupWin = window.open('', '_blank', 'width=900,height=600,top=100,left=100,visible=none');
                //popupWin.document.open();
                popupWin.document.write('<html><head><style>@page{ size: auto A4 landscape; margin: 25.4mm;} .text-center{text-align: center;} table{border-collapse: collapse; border-spacing: 2px;} thead{display: table-header-group;} td{font-size: 12px; padding: 2px;  border: 1px solid gainsboro;} .table-header{font-weight: bold;} .table-header td{padding: 8px 2px; color: #209e91; background-color: #f3f3f3;}.table-header a{text-decoration: none; color: #209e91;} .not-print{display: none;} .only-print{display: inline;}</style><body>' + printContents + '</body></html>');
                popupWin.document.close();
                popupWin.print();
            }
        }
        function analyticsDownloadDoc(){
            analyticsService.sendData(ANALYTICS_CONSTANT.download, document.title + ' - Download Doc', '', 'Download Doc In' + document.title, ANALYTICS_CONSTANT.download)

        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryManagement')
        .controller('SalaryManagementCtrl', ['$state', '$scope', 'employeeService','payrollSettingsService', 'toastrService','bankManagementService', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', SalaryManagementCtrl]);

    /** @ngInject */
    function SalaryManagementCtrl($state, $scope, employeeService, payrollSettingsService, toastrService,bankManagementService, utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.PAYROLL_TYPE_GROSS_DRIVEN = 1;
        vm.PAYROLL_TYPE_BASIC_DRIVEN = 2;
        var PAYROLL_TYPE_GROSS_DRIVEN = 1;
        var PAYROLL_TYPE_BASIC_DRIVEN = 2;

        var COMPONENT_TYPE_BASIC = 1;

        var VALUE_TYPE_FIXED_AMOUNT = 2;
        var VALUE_TYPE_VARIABLE = 3;

        vm.grossSalary = 0;
        vm.basicSalary = 0;
        vm.isEligilbeForSalaryManagement = false;
        vm.isAnyRowSelected = false;
        vm.selectedRowIndex = null;
        vm.selectedRow = null;
        vm.isDataLoaded = false;
        vm.isEmployeePayrollComponentsLoaded = false;
        vm.selectedTab = 'allEmployees';
        vm.employeesDataData = [];
        vm.selectedRowData = [];
        vm.employeePayrollComponents = [];
        vm.bankList = [];
        vm.bankInfo = [];
        vm.paymentModes = [{name:'Bank',value:1}, {name:'Cash',value:2},{name:'Cheque',value:3},{name: 'Bank and Cash', value : 4}];
        vm.officePayrollSettings = null;
        vm.paymentMode = null;
        vm.isEditBtnClicked = false;

        vm.searchKeyword = "";
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        utilService.setRowsPerPage(vm.rowsPerPage);
        vm.numberOfPages = null;
        vm.numberOfButtons = null;
        vm.total = null;
        vm.file = null;

        vm.recalculateGrossSalary = false;
        vm.recalculateBasicSalary = false;

        vm.paymentMode = null;
        vm.bankName = null;
        vm.routingNumber = null;
        vm.accountNumber = null;

        vm.sampleExcelUrl = payrollSettingsService.getSampleExcelUrl();
        vm.file = null;

        vm.savingSalary = false;
        vm.analyticsDownloadSample = analyticsDownloadSample;
        vm.showEmployeeInfoInTheRightColumn = showEmployeeInfoInTheRightColumn;
        vm.openEditMode = openEditMode;
        vm.saveEmployeeInfo = saveEmployeeInfo;
        vm.fetchSalaryManagementData = fetchSalaryManagementData;
        vm.switchTab = switchTab;
        vm.syncPayrollComponentValues = syncPayrollComponentValues;
        vm.verifySelectedExcelFile = verifySelectedExcelFile;
        vm.setupEmployeeSalary = setupEmployeeSalary;
        vm.getTotalSalary = getTotalSalary;
        vm.searchByNameOrId = searchByNameOrId;

        vm.employees = [];
        vm.selectedRowData = {
            'id' : '0025',
            'name' : 'Khalid Musa Sagar',
            'pictureUrl' : 'https://inovace-client-dev.s3.ap-southeast-1.amazonaws.com/profilepic-2509-Md.KhalidMusaSagar-31672123mm-1621767173.jpeg',
            'departmentName' : 'R&D',
            'designationName' : 'Software Team  Manager',
            'employeeType' : 'Full Time',
            'shift' : 'Regular'
        }

        var officePayrollSettingsIdToSettingsMap = {};


        function init(){
            getBankBranchesList();
            fetchSalaryManagementData();
            payrollSettingsService.getPayrollSettingsData().then(function (data){
                vm.officePayrollSettings = data.payrollSettings;
            });
        }

        init();

        function getBankBranchesList(){
            bankManagementService.getAllBranches().then(function (data){
                vm.bankList = data.branchList.filter(function (bank) {
                    return bank.branchStatus == 1;
                })
            })
        }

        function populateOfficePayrollSettingsToIdMap (){
            officePayrollSettingsIdToSettingsMap = {};
            vm.officePayrollSettings.components.forEach(function (data){
                officePayrollSettingsIdToSettingsMap[data.id] = data;
            });

        }

        function syncPayrollComponentValues(){
            var response = utilService.getEmployeePayrollComponentsWithValue(getEmployeePayrollComponentParameters(),getApplicableSalaryValue());
            vm.employeePayrollComponents = response.payrollComponents;
            vm.basicSalary = response.basicSalary;
            vm.grossSalary = response.grossSalary;

        }

        function switchTab(tabName){
            vm.selectedTab = tabName;

            resetSelectionData();
            fetchSalaryManagementData();
        }

        function fetchSalaryManagementData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            params = getRequestParameters();
            vm.isDataLoaded = false;
            payrollSettingsService.getSalaryManagementList(params).then(function (data){
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                resetSelectionData();
                vm.employees = data.employees;
                vm.numberOfPages = data.numberOfPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
            },function (error){
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not get salary management list: " + error, "", 5000);
            })
        }

        function getApplicableSalaryValue(){
            if(vm.officePayrollSettings.payrollType === PAYROLL_TYPE_GROSS_DRIVEN){
                 return vm.grossSalary;
            }else {
                return vm.basicSalary;
            }
        }

        function resetSelectionData(){
            vm.selectedPage = 0;
            vm.isAnyRowSelected = false;
            vm.selectedRowIndex = null;
            vm.selectedRow = null;
        }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.selectedPage = vm.selectedPage == 0? 0 : vm.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.selectedPage = vm.selectedPage == vm.numberOfPages ? vm.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.selectedPage = searchParams;
            }
        }

        function setupEmployeeSalary(index){
            vm.basicSalary = 20000;
            vm.grossSalary = 20000;
            showEmployeeInfoInTheRightColumn(index,true);
        }

        function formatExistingPayrollComponents(data){
            var dataToSendToUtils =   {
                payrollType : vm.officePayrollSettings.payrollType,
            }
            var components = data.employeePayrollComponents.map(function (data) {
                var officePayrollSettings = officePayrollSettingsIdToSettingsMap[data.payrollComponentId];
                return {
                    id                       : officePayrollSettings.id,
                    name                     : officePayrollSettings.name,
                    isBasic                  : officePayrollSettings.isBasic,
                    officePayrollComponentId : officePayrollSettings.id,
                    category                 : officePayrollSettings.category,
                    type                     : officePayrollSettings.type,
                    valueType                : officePayrollSettings.valueType,
                    value                    : officePayrollSettings.value,
                    status                   : 1,
                    group                    : officePayrollSettings.group,
                    valueDeterminer          : officePayrollSettings.valueDeterminer,
                    isEditable               : (vm.officePayrollSettings.payrollType === PAYROLL_TYPE_BASIC_DRIVEN ? (officePayrollSettings.valueType === VALUE_TYPE_FIXED_AMOUNT || officePayrollSettings.valueType === VALUE_TYPE_VARIABLE) : (officePayrollSettings.valueType === VALUE_TYPE_FIXED_AMOUNT || (officePayrollSettings.valueType === VALUE_TYPE_VARIABLE && officePayrollSettings.type !== COMPONENT_TYPE_BASIC))),
                    inclusiveToGross         : officePayrollSettings.inclusiveToGross,
                    amount                   : data.amount,
                }
            });

            var salary = 0;
            if(dataToSendToUtils.payrollType === PAYROLL_TYPE_BASIC_DRIVEN){
                var basicComponent = components.find(function (data) {
                    return data.isBasic;
                });
                salary = basicComponent.amount;
            }else {
                components.forEach(function (data) {
                    if(data.inclusiveToGross)
                        salary += (data.amount * data.category);
                })
            }
            dataToSendToUtils.components = components;
            var response = utilService.getEmployeePayrollComponentsWithValue(dataToSendToUtils,salary);
            vm.employeePayrollComponents = response.payrollComponents;
            vm.grossSalary = response.grossSalary;
            vm.basicSalary = response.basicSalary;
        }

        function showEmployeeInfoInTheRightColumn(index,shouldOpenEditMode){
            vm.isAnyRowSelected = true;
            vm.selectedRowIndex = index;
            vm.recalculateGrossSalary = false;
            vm.selectedRow = vm.employees[index];
            vm.isEmployeePayrollComponentsLoaded = false;
            vm.isEditBtnClicked = false;
            vm.employeePayrollComponents = [];
            vm.officePayrollSettings = null;
            payrollSettingsService.getEmployeePayrollComponents(vm.selectedRow.id).then(function (data){
                vm.officePayrollSettings = data.officeSettings;
                populateOfficePayrollSettingsToIdMap();
                vm.bankInfo = data.bankInformation;
                setBankInformation(data.bankInformation)
                if(data.employeePayrollComponents.length > 0){
                    formatExistingPayrollComponents(data);
                }
                if(shouldOpenEditMode){
                    openEditMode();
                }
            },function (error){
                toastrService.showErrorToastr("Failed to load office payroll settings " + error, "", 5000);
            }).finally(function () {
                vm.isEmployeePayrollComponentsLoaded = true;
            });

        }

        function setBankInformation(data){
            vm.paymentMode   = data.paymentMode;
            vm.bankId        = data.bankId;
            vm.routingNumber = data.routingNumber;
            vm.accountNumber = data.accountNumber;
        }

        function getTotalSalary(){
            var sum = 0;
            vm.employeePayrollComponents.forEach(function (data) {
                if(!isNaN(data.amount)){
                    sum += (data.amount * data.category);
                }
            });
            sum += vm.basicSalary;

            return sum;
        }

        // function getEmployeePayrollComponentsAndSalary(data){
        //     if(data.)
        // }

        function setupEmployeeAndOfficePayrollComponents(salary){
            var response = utilService.getEmployeePayrollComponentsWithValue(getEmployeePayrollComponentParameters(), salary);
            vm.employeePayrollComponents = response.payrollComponents;
            vm.grossSalary = response.grossSalary;
            vm.basicSalary = response.basicSalary;
        }

        function getEmployeePayrollComponentParameters(){
            var components = [];
            var data =   {
                payrollType : vm.officePayrollSettings.payrollType,
            }
            if(vm.employeePayrollComponents.length > 0)
                components = vm.employeePayrollComponents;
            else
                components = vm.officePayrollSettings.components;
            data.components = components;
            return data;
        }

        function openEditMode(){
            analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit Employee Info', '', 'Edit Employee Info' + document.title, ANALYTICS_CONSTANT.edit)
            vm.isEditBtnClicked = true;
            var salary = getApplicableSalaryValue();
            setupEmployeeAndOfficePayrollComponents(salary);

        }

        function getBasicComponentOfPayroll(){
            return vm.officePayrollSettings.components.find(function (data) {
                return data.isBasic;
            })
        }

        function saveEmployeeInfo (){
            toastrService.clearPreviousToastr();
            if(vm.routingNumber){
                if(isNaN(vm.routingNumber)){
                    return toastrService.showErrorToastr("Routing Number needs to be numeric");
                }
            }
            if(vm.accountNumber){
                if(isNaN(vm.accountNumber)){
                    return toastrService.showErrorToastr("Account Number needs to be numeric");
                }
            }
            if(vm.paymentMode === 1 || vm.paymentMode === 4) {
                if(vm.accountNumber == null || vm.bankId == null || vm.routingNumber == null)
                    return toastrService.showErrorToastr("Incomplete bank information");
            }
            vm.savingSalary = true;
            var filteredComponents = vm.employeePayrollComponents.map(function (data) {
                return {
                    officePayrollComponentId : data.id,
                    name                     : data.name,
                    amount                   : data.amount != null ? data.amount : 0.00
                }
            });
            var basicComponent = getBasicComponentOfPayroll();
            filteredComponents.unshift({
                officePayrollComponentId : basicComponent.id,
                name                     : basicComponent.name,
                amount                   : vm.basicSalary
            });
            if(!isValidComponentList(filteredComponents)) return;
            var requestObject = {
                employeeId    : vm.selectedRow.id,
                components    : filteredComponents,
                paymentMode   : vm.paymentMode,
                accountName   : "",
                accountNumber : vm.accountNumber,
                bankId        : vm.bankId,
                routingNumber : vm.routingNumber,
                basicSalary   : vm.basicSalary,
                grossSalary   : vm.grossSalary,
            }
            payrollSettingsService.setupEmployeePayrollComponents(requestObject).then(function (){
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save Employee Info', '', 'Save Employee Info In ' + document.title, ANALYTICS_CONSTANT.save)
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Payroll Information Saved");
                vm.isEditBtnClicked = false;
                vm.savingSalary = false;
                fetchUpdatedSalaryManagementData();
            },function (){
                vm.savingSalary = false;
            });
        }
        function fetchUpdatedSalaryManagementData(){
            var params = getRequestParameters();
            vm.isDataLoaded = false;
            payrollSettingsService.getSalaryManagementList(params).then(function (data){
                vm.employees = data.employees;
                vm.numberOfPages = data.numberOfPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
            })
            payrollSettingsService.getEmployeePayrollComponents(vm.selectedRow.id).then(function (data){
                vm.employeePayrollComponents = data.employeePayrollComponents;
                vm.officePayrollSettings = data.officeSettings;
                populateOfficePayrollSettingsToIdMap();
                setupEmployeeAndOfficePayrollComponents();
                vm.bankInfo = data.bankInformation;
            });
        }

        function isValidComponentList(components){
            for (var i = 0; i < components.length ; i++) {
                if(components[i].amount < 0 ){
                    toastrService.showErrorToastr("Component can not have a negative value");
                    return false;
                }
            }
            return true;
        }

        function getRequestParameters(){
            var params =   {
                pageNumber   : vm.selectedPage,
                perPage      : vm.rowsPerPage,
                keyword      : vm.searchKeyword
            }
            if(vm.selectedTab == 'allEmployees')
                params.payrollActive = null;
            else
                params.payrollActive = vm.selectedTab == 'payrollActive';
            return params;
        }

        function verifySelectedExcelFile() {
            if(vm.file == null) {
                // return toastr.error("You haven't selected any file.");
                return;
            }

            $state.go('payroll.batchUpload', {file: vm.file, payrollType : Number(vm.officePayrollSettings.payrollType)});

        }

        function analyticsDownloadSample(){
            analyticsService.sendData(ANALYTICS_CONSTANT.download, document.title + ' - Download Payroll Upload File', '', 'Download Payroll Upload File In ' + document.title, ANALYTICS_CONSTANT.download)
        }

        function searchByNameOrId(){
            fetchSalaryManagementData();
            analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search);
        }


    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('ViewOrGenerateSalaryCtrl', ['$scope', '$stateParams','$uibModal','$state', '$timeout', 'authService', 'employeeService', 'toastrService', 'payrollManagementService', 'MONTH_NAMES','utilService', 'analyticsService', 'ANALYTICS_CONSTANT', ViewOrGenerateSalaryCtrl]);

    /** @ngInject */
    function ViewOrGenerateSalaryCtrl($scope, $stateParams, $uibModal, $state, $timeout, authService, employeeService, toastrService, payrollManagementService, MONTH_NAMES,utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var user = authService.getLoggedInUser();
        vm.isDataLoaded = true;
        vm.isSalaryGenerated = false;
        vm.hasGenerationStarted = false;
        vm.selectedMonth = new Date(new Date().getFullYear(), new Date().getMonth() -1, 1);
        vm.panelTitle = "";
        vm.salarySummary = null;
        vm.searchKeyword = "";
        vm.isAnyRowSelected = false;
        vm.selectedRowIndex = null;
        vm.selectedRow = null;
        vm.isEditBtnClicked = false;
        vm.isSaveBtnClicked = false;
        vm.isEdited = false;

        vm.selectedTab = 'processedSalary';
        vm.searchKeyword = "";
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        utilService.setRowsPerPage(vm.rowsPerPage);
        vm.numberOfPages = null;
        vm.numberOfButtons = null;
        vm.total = null;

        vm.showReport = false;

        vm.monthPicker = {};
        vm.monthPicker.opened = false;
        vm.monthPicker.format = "MMM yyyy";
        vm.monthPicker.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            maxDate : new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode : 'month',
            maxMode : 'year'
        };

        vm.isPayrollManager = user.isPayrollManager;
        vm.isPayrollApprover = user.isPayrollApprover;

        vm.excelUrl = "";
        vm.sumData = {};

        vm.openMonthPicker = openMonthPicker;
        vm.getProcessedSalaries = getProcessedSalaries;
        vm.getUnprocessedSalaries = getUnprocessedSalaries;
        vm.showEmployeeInfoInTheRightColumn = showEmployeeInfoInTheRightColumn;
        vm.getSalaries = getSalaries;
        vm.switchTab = switchTab;
        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.optionToggled = optionToggled;
        vm.getSalarySummary = getSalarySummary;
        vm.openEditMode = openEditMode;
        vm.getUpdatedGrossSalary = getUpdatedGrossSalary;
        vm.getUpdatedTotalSalary = getUpdatedTotalSalary;
        vm.getTotalDeductedAmount = getTotalDeductedAmount;
        vm.getTotalPayableAmount = getTotalPayableAmount;
        vm.compareCalculatedAndUpdatedAmount = compareCalculatedAndUpdatedAmount;
        vm.undoSalary = undoSalary;
        vm.processSalary = processSalary;
        vm.saveChanges = saveChanges;
        vm.sendSalaryForApprovalModal = sendSalaryForApprovalModal;
        vm.approveSalary = approveSalary;
        vm.rollbackSalary = rollbackSalary;
        vm.paySalary = paySalary;
        vm.salaryLog = salaryLog;
        vm.processSalaryForOneEmployee = processSalaryForOneEmployee;
        vm.downloadExcel = downloadExcel;
        vm.generateSalary = generateSalary;
        vm.openSalaryEditSection = openSalaryEditSection;
        vm.getAbsCalculatedAmount = getAbsCalculatedAmount;

        getSalarySummary();


        function getMonthlyGrossSalary(){
            var salary = 0;
            for (var i = 0; i < vm.selectedRow.components.length ; i++) {
                if(vm.selectedRow.components[i].type == 1)
                    salary += vm.selectedRow.components[i].calculatedAmount;
            }
            return salary;
        }

        function getMonthlyTotalSalary(){
            return getMonthlyGrossSalary();
        }

        function getMonthlyTotalDeduction(){
            var salary = 0;
            for (var i = 0; i < vm.selectedRow.components.length ; i++) {
                if(vm.selectedRow.components[i].type == -1)
                    salary+=vm.selectedRow.components[i].calculatedAmount;
            }
            return Math.abs(salary);
        }

        function populateOriginalSumData(){
            vm.sumData.monthlyGrossSalary = getMonthlyGrossSalary();
            vm.sumData.monthlyTotalSalary = getMonthlyTotalSalary();
            vm.sumData.monthlyTotalDeduction = getMonthlyTotalDeduction();
            vm.sumData.monthlyNetPayable = vm.sumData.monthlyTotalSalary - vm.sumData.monthlyTotalDeduction;
        }

        function openMonthPicker() {
            vm.monthPicker.opened = true;
            vm.hasGenerationStarted = false;
        }

        $scope.$watch('vm.monthPicker.opened',function(newVal, oldVal){
           if(!newVal) getSalarySummary();
        })

        function getSalaries() {
            analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search)
            if(vm.selectedTab === 'processedSalary')
                getProcessedSalaries();
            else
                getUnprocessedSalaries();
        }

        function switchTab(tabName){
            vm.selectedTab = tabName;
            resetSelectionData();
            vm.selectedPage = 0;
            if(vm.selectedTab ==='processedSalary')
                getProcessedSalaries()
            else
                getUnprocessedSalaries();
        }


        function getProcessedSalaries(params) {
            if(params != undefined && params != null) {
                modifyParams(params);
            }
             params = getParams();

            vm.isDataLoaded = false;
            payrollManagementService.getProcessedSalaries(params).then(function (data) {
                // analyticsService.sendData(ANALYTICS_CONSTANT.viewSalaryReport, document.title + ' - View Salary Report', '', 'View Salary Report In' + document.title, ANALYTICS_CONSTANT.viewSalaryReport)
                resetSelectionData();
                vm.employeeInfo = data.employeeSalaries;
                setPagination(data);
                vm.isDataLoaded = true;
                vm.showReport = true;
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not generate salary: " + error, "", 5000);
            });
        }

        function getUnprocessedSalaries(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            params = getParams();

            vm.isDataLoaded = false;
            vm.hasGenerationStarted = false;
            payrollManagementService.getUnprocessedSalaries(params).then(function (data) {
                resetSelectionData();
                vm.employeeInfo = data.employeeSalaries;
                setPagination(data);
                vm.isDataLoaded = true;
                vm.showReport = true;
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not generate salary: " + error, "", 5000);
            });

        }

        function openSalaryEditSection(index){
            showEmployeeInfoInTheRightColumn(index,true);
        }

        function showEmployeeInfoInTheRightColumn(index, openEditSection){
            if(vm.selectedRow != null && vm.selectedRow.isEditedNow && !vm.selectedRow.isBothAmountEqual){
                amountComparisonModal(index);
                return;
            }
            columnInitialization(index);
            if(openEditSection)
                openEditMode();
        }

        function columnInitialization(index){
            vm.isEditBtnClicked = false;
            vm.selectedRowIndex = index;
            vm.selectedRow = vm.employeeInfo[index];
            makeAbsValueFromDeductiveComponentsNegativeValue();
            populateOriginalSumData();
            vm.isAnyRowSelected = true;
            vm.isEdited = vm.selectedRow.isEdited;
            vm.selectedRow.isEditedNow = false;
        }

        function openEditMode(){
            vm.isEditBtnClicked = !vm.isEditBtnClicked;
        }

        function undoSalary(){
            undoSalaryModal();
        }

        function processSalary(){
            processSalaryModal();
        }

        function generateSalary() {
            analyticsService.sendData(ANALYTICS_CONSTANT.generateSalary, document.title + ' - Generate Salary', '', 'Generate Salary In' + document.title, ANALYTICS_CONSTANT.generateSalary)
            var data = {
                month : vm.selectedMonth.getMonth() + 1,
                year : vm.selectedMonth.getFullYear()
            };
            vm.isDataLoaded = false;
            payrollManagementService.generateSalary(data).then(function (data) {
                toastrService.showSuccessToastr("Salary generation started");
                vm.isDataLoaded = true;
                vm.hasGenerationStarted = true;
            }, function (error) {
                vm.isDataLoaded = true;
                vm.hasGenerationStarted = false;
                toastrService.showErrorToastr("Could not generate salary: " + error, "", 5000);
            });
        }

        function getSalarySummary() {
            var params = {
                params : {
                    month : vm.selectedMonth.getMonth() + 1,
                    year : vm.selectedMonth.getFullYear()
                }
            };

            vm.isDataLoaded = false;
            vm.hasGenerationStarted = false;

            payrollManagementService.getSalarySummary(params).then(function (data) {

                vm.salarySummary = data;
                vm.isSalaryGenerated = data.isGenerated;
                if(vm.isSalaryGenerated) {
                    vm.salarySummary.monthName = vm.salarySummary.monthName.slice(0,3);
                    vm.panelTitle = "Salary for the month of " + MONTH_NAMES[vm.selectedMonth.getMonth()]  + " " + vm.selectedMonth.getFullYear() + " - " + (vm.salarySummary.status == 1 ? 'Pending For Approval' : vm.salarySummary.statusText);
                }
            }, function (error) {
                toastrService.showErrorToastr("Could not get salary summary: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function saveChanges(){
            vm.isSaveBtnClicked = true;
            var salaryComponents = vm.selectedRow.components.map(function (data){
                return{
                    payrollComponentId: data.id,
                    name : data.name,
                    updatedAmount : data.updatedAmount,
                    category: data.category
                }
            })
            var data = {
                employeeId : vm.selectedRow.employee.id,
                employeeMonthlySalaryId : vm.selectedRow.monthlySalaryId,
                salaryComponents : salaryComponents,
                remarks : vm.remarks
            }
            payrollManagementService.updateSalaryDetails(data).then(function (data){
                toastrService.showSuccessToastr("Salary update successfully");
                vm.isEditBtnClicked = !vm.isEditBtnClicked;
                vm.isEdited = true;
                vm.isSaveBtnClicked = false;
                vm.isDataLoaded = false;
                vm.selectedRow.isBothAmountEqual = true;
                //Recall the Processed salary API
                var params = getParams();

                payrollManagementService.getProcessedSalaries(params).then(function (data) {
                    vm.employeeInfo = data.employeeSalaries;
                    setPagination(data);
                    vm.isDataLoaded = true;
                    vm.showReport = true;
                    getSalarySummary();
                });

            }, function (error){
                toastrService.showErrorToastr("Could not update salary:" + error, "", 5000);
                vm.isEdited =false;
                vm.isSaveBtnClicked = false;
            });

        }

        function checkOrUncheckAll() {
            if(vm.allSelected === false){
                vm.employeeInfo.forEach(function (allocations) {
                    allocations.isSelected = false;
                });
            }
            else{
                vm.employeeInfo.forEach(function (allocations) {
                    allocations.isSelected = true;
                });
            }
        }

        function optionToggled() {
            vm.allSelected = vm.employeeInfo.every(function (itm) {
                return itm.isSelected === true;
            });
        }

        function resetSelectionData(){
            vm.allSelected = false;
            vm.isAnyRowSelected = false;
            vm.isEditBtnClicked = false;
            vm.selectedRowIndex = null;
            vm.selectedRow = null;
        }

        function setPagination(data){
            vm.numberOfPages = data.totalPages;
            vm.total = data.totalRecords;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.selectedPage = data.currentPage;
        }

        function getParams(){
            return {
                params : {
                    month : vm.selectedMonth.getMonth() + 1,
                    year : vm.selectedMonth.getFullYear(),
                    pageNumber : vm.selectedPage,
                    keyword : vm.searchKeyword,
                    perPage : 10
                }
            }
        }
        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.selectedPage = vm.selectedPage == 0? 0 : vm.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.selectedPage = vm.selectedPage == vm.numberOfPages ? vm.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.selectedPage = searchParams;
            }
        }

        function getUpdatedGrossSalary(){
            var ac = 0;
            var addictiveComponents;

            addictiveComponents = vm.selectedRow.components.filter(function (component){
                if(component.inclusiveToGross)
                    return component;
            })

            addictiveComponents.forEach(function (item){
                ac += item.updatedAmount;
            })
            return ac;
        }
        function getUpdatedTotalSalary(){
            var ac = 0;
            var addictiveComponents;

            addictiveComponents = vm.selectedRow.components.filter(function (component){
                if(component.inclusiveToGross  || (!component.inclusiveToGross && component.category === 1 ))
                    return component;
            })

            addictiveComponents.forEach(function (item){
                ac += item.updatedAmount;
            })
            return ac;
        }

        function getTotalDeductedAmount(){
            var total = 0;
            var deductedComponents;

            deductedComponents = vm.selectedRow.components.filter(function (component){
                if(component.category === -1)
                    return component;
            })

            if(deductedComponents.length === 0) return Math.abs(total);

            deductedComponents.forEach(function (component){
                total += component.updatedAmount;
            });

            return Math.abs(total);
        }

        function makeAbsValueFromDeductiveComponentsNegativeValue(){
            vm.selectedRow.components = vm.selectedRow.components.map(function (component){
                if(component.category === -1){
                    component.updatedAmount = Math.abs(component.updatedAmount);
                }
                return component;
            })
        }

       function getAbsCalculatedAmount(amount){
          return Math.abs(amount);
       }

        function getTotalPayableAmount(){
            return getUpdatedTotalSalary() - getTotalDeductedAmount()
        }

        function compareCalculatedAndUpdatedAmount(){
            vm.selectedRow.isEditedNow = true;
            vm.selectedRow.isBothAmountEqual = true;
            vm.selectedRow.components.forEach(function (component){
               if(component.calculatedAmount !== component.updatedAmount){
                  vm.selectedRow.isBothAmountEqual = false;
                  return;
               }

            })
        }

        function amountComparisonModal(index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/amountComparisonModal/amountComparisonModal.html',
                size: 'md',
                controller: 'AmountComparisonModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                }
            }).result.then(function (){
                vm.selectedRow = null;
                showEmployeeInfoInTheRightColumn(index);
            });
        }

        function undoSalaryModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/undoSalaryModal/undoSalaryModal.html',
                size: 'md',
                controller: 'UndoSalaryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    allInfo : function (){

                        return {
                            'employeeInfo': vm.employeeInfo,
                            'isAllSelected': vm.allSelected,
                            'officeMonthlySalaryId' : vm.salarySummary
                        }
                    }
                }
            }).result.then(function (data){
                if(vm.selectedTab == 'processedSalary'){
                    getProcessedSalaries();
                }else {
                    getUnprocessedSalaries();
                }
                getSalarySummary();
            });
        }

        function processSalaryModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/processSalaryModal/processSalaryModal.html',
                size: 'md',
                controller: 'ProcessSalaryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    allInfo : function (){

                        return {
                            'employeeInfo': vm.employeeInfo,
                            'isAllSelected': vm.allSelected,
                            'officeMonthlySalaryId' : vm.salarySummary
                        }
                    }
                }
            }).result.then(function (data){
                if(vm.selectedTab == 'processedSalary'){
                    getProcessedSalaries();
                }else {
                    getUnprocessedSalaries();
                }
                getSalarySummary();
            });
        }

        function sendSalaryForApprovalModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/sendForApprovalModal/sendSalaryForApprovalModal.html',
                size: 'md',
                controller: 'SendSalaryForApprovalModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    salarySummary : function (){
                        return vm.salarySummary;
                    }
                }
            }).result.then(function (data){
                getSalarySummary();
            });
        }

        function approveSalary(){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/approveSalaryModal/approveSalaryModal.html',
                size: 'md',
                controller: 'ApproveSalaryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    salarySummary : function (){
                        return vm.salarySummary;
                    }
                }
            }).result.then(function (data){
                getSalarySummary();
            });
        }

        function rollbackSalary(){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/rollbackSalaryModal/rollbackSalaryModal.html',
                size: 'md',
                controller: 'RollbackSalaryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    salarySummary : function (){

                        return vm.salarySummary;
                    }
                }
            }).result.then(function (data){
                getSalarySummary();
            });
        }

        function salaryLog(){

            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/salaryLogModal/salaryLogModal.html',
                size: 'lg',
                controller: 'SalaryLogModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    salarySummary : function (){

                        return vm.salarySummary;
                    }
                }
            }).result.then(function (data){
                getSalarySummary();
            },function (dismiss){

            });
        }

        function paySalary(){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/paySalaryModal/paySalaryModal.html',
                size: 'md',
                controller: 'PaySalaryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    salarySummary : function (){
                        return vm.salarySummary;
                    }
                }
            }).result.then(function (data){
                getSalarySummary();
            });
        }

        function processSalaryForOneEmployee(index){
            vm.isAllSelected = false;
            vm.employeeInfo = vm.employeeInfo.map(function (data){
                data.isSelected = false;
                return data;
            });
            vm.employeeInfo[index].isSelected = true;
            processSalary();
        }

        function downloadExcel(){
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Excel In ', ANALYTICS_CONSTANT.downloadExcel)
            window.open(payrollManagementService.getExcelUrl(vm.salarySummary), '_blank', '');
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('ApproveModalCtrl', ['$uibModalInstance', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', ApproveModalCtrl]);

    /** @ngInject */
    function ApproveModalCtrl($uibModalInstance, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.comment = null;
        var analyticsApproveTitle = 'Approve Pending Approval';
        var analyticsApproveUrl = 'approve-pending-approval';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsApproveTitle, analyticsApproveUrl, 'Approve Pending In' + document.title, ANALYTICS_CONSTANT.open);


        vm.submit = submit;

        function submit() {
            // if(vm.comment == null || vm.comment == "")
            //     return toastrService.showErrorToastr("Please give a comment");
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsApproveTitle + ' - Approve', analyticsApproveUrl + '/approve', 'Approve Pending Approval In' + document.title, ANALYTICS_CONSTANT.approve)
            $uibModalInstance.close(vm.comment);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('LeaveApplicationDetailsCtrl', ['$q', '$uibModal', 'authService', 'leaveManagementService', 'remainingLeaveService', 'toastrService', '$state', 'employeeService', '$stateParams', LeaveApplicationDetailsCtrl]);

    /** @ngInject */
    function LeaveApplicationDetailsCtrl($q, $uibModal, authService, leaveManagementService, remainingLeaveService, toastrService, $state, employeeService, $stateParams) {

        var vm = this;

        // var loggedInUser = authService.getLoggedInUser();
        //
        //
        // var approverId = authService.getLoggedInId();
        vm.leaveLogId = $stateParams.leaveLogId;
        vm.applicantId = $stateParams.applicantId;
        vm.applicantName = $stateParams.applicantName;
        vm.applicationDetails = null;
        vm.remainingLeavesList = null;
        vm.employeeProfile = null;
        vm.acceptedLeaveLogs = null;
        vm.allDataLoaded = false;
        vm.attachedFileName = "N/A";
        vm.previousLog = null;
        vm.currentLog = null;
        vm.disableApproveReject = false;

        vm.openLeaveApproveModal = openLeaveApproveModal;
        vm.openLeaveRejectModal = openLeaveRejectModal;

        init();

        function init() {
            if(!vm.leaveLogId || !vm.applicantId) {
                $state.go('pendingApprovals');
                return;
            }
            $q.all([
                getApplicationDetails(),
                getEmployeeProfile(),
                getAllRemainingLeavesOfApplicant(),
                getAcceptedLeaveLogsOfApplicant()
            ]).then(function () {
                vm.allDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }


        function getApplicationDetails() {
            return leaveManagementService.getApplicationDetails(vm.leaveLogId).then(function (data) {
                vm.applicationDetails = data;
                setAttachedFileName();
                vm.previousLog = getPreviousLog();
                vm.currentLog = getCurrentLog();
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch application details: " + error, "", 5000);
            });
        }

        function getEmployeeProfile() {
            return employeeService.getProfile(vm.applicantId).then(function (data){
                vm.employeeProfile = data.employee;
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch employee's basic information: " + error, "", 5000);
            });
        }

        function getAllRemainingLeavesOfApplicant() {
            return remainingLeaveService.getAllRemainingLeavesOfEmployee(vm.applicantId, new Date().getFullYear()).then(function (data) {
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch employee's remaining leave data: " + error, "", 5000);
            });
        }

        function getAcceptedLeaveLogsOfApplicant() {
            return leaveManagementService.getAcceptedLeaveLogs(vm.applicantId).then(function (data) {
                vm.acceptedLeaveLogs = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch employee's accepted leave data: " + error, "", 5000);
            });
        }

        function setAttachedFileName() {
            if(vm.applicationDetails.fileUrl != null && vm.applicationDetails.fileUrl !== "") {
                vm.attachedFileName = vm.applicationDetails.fileUrl.substring(vm.applicationDetails.fileUrl.lastIndexOf('/') + 1);
            }
        }

        function getPreviousLog() {
            if(vm.applicationDetails.previousVersionStartDate == null) return;
            return {
                categoryName : vm.applicationDetails.previousVersionCategoryName,
                startDate : vm.applicationDetails.previousVersionStartDate,
                endDate : vm.applicationDetails.previousVersionEndDate,
                numberOfDays : vm.applicationDetails.previousVersionNumberOfDays,
                reason : vm.applicationDetails.previousVersionReason,
                leaveType : vm.applicationDetails.previousVersionType,
                leaveTypeName: vm.applicationDetails.previousVersionTypeName
            };
        }

        function getCurrentLog() {
            return {
                categoryName : vm.applicationDetails.currentVersionCategoryName,
                startDate : vm.applicationDetails.currentVersionStartDate,
                endDate : vm.applicationDetails.currentVersionEndDate,
                numberOfDays : vm.applicationDetails.currentVersionNumberOfDays,
                reason : vm.applicationDetails.currentVersionReason,
                leaveType : vm.applicationDetails.currentVersionType,
                leaveTypeName: vm.applicationDetails.currentVersionTypeName,
                leaveHalfName: vm.applicationDetails.currentVersionLeaveHalfName
            };
        }

        function openLeaveApproveModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/pendingApprovals/approveModal/approve.modal.html',
                size: 'md',
                controller : 'ApproveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveReject = true;
                leaveManagementService.approveLeave({
                    approverComment : comment
                }, vm.leaveLogId).then(function(data){
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Leave application approved.");
                    $state.go('pendingApprovals');
                },function (error) {
                    vm.disableApproveReject = false;
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to approve leave application. Please try again later.", "", 5000);
                });
            })
        }

        function openLeaveRejectModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/rejectModal/rejectLeave.modal.html',
                size : 'md',
                controller : 'RejectLeaveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                vm.disableApproveReject = true;
                leaveManagementService.rejectLeave({
                    approverComment : comment
                }, vm.leaveLogId).then(function(data){
                    toastrService.clearPreviousToastr();
                    toastrService.showSuccessToastr("Leave application rejected.");
                    $state.go('pendingApprovals');
                },function (error) {
                    vm.disableApproveReject = false;
                    toastrService.clearPreviousToastr();
                    toastrService.showErrorToastr("Failed to reject leave application. Please try again later.", "",5000);
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('ApproveManualEntryModalCtrl', ['$uibModalInstance','toastrService','employeeService','manualEntryApplication', ApproveManualEntryModalCtrl]);

    /** @ngInject */
    function ApproveManualEntryModalCtrl($uibModalInstance,toastrService,employeeService,manualEntryApplication) {
        var vm = this;
        vm.approve = approve;
        function approve() {
            employeeService.approveManualEntryApplication(manualEntryApplication.manualEntryId).then(function (data) {
                toastrService.showSuccessToastr("Approval successful");
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not approve manual entry: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('RejectManualEntryModalCtrl', ['$uibModalInstance','toastrService','employeeService','manualEntryApplication', RejectManualEntryModalCtrl]);

    /** @ngInject */
    function RejectManualEntryModalCtrl($uibModalInstance,toastrService,employeeService,manualEntryApplication) {
        var vm = this;
        vm.reject = reject;
        function reject() {
            employeeService.rejectManualEntryApplication(manualEntryApplication.manualEntryId).then(function (data) {
                toastrService.showSuccessToastr("Rejection successful");
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not reject manual entry: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('ApproveMonthlyTimeSheetModalCtrl', ['$uibModalInstance','toastrService','monthlyTimeSheetApproverService','applicationId', ApproveMonthlyTimeSheetModalCtrl]);

    /** @ngInject */
    function ApproveMonthlyTimeSheetModalCtrl($uibModalInstance,toastrService,monthlyTimeSheetApproverService,applicationId) {
        var vm = this;
        vm.approve = approve;
        function approve() {
            monthlyTimeSheetApproverService.approveOrRejectTimeSheet(applicationId,{status:1}).then(function (data) {
                toastrService.showSuccessToastr("Approval successful");
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not approve time sheet: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('RejectMonthlyTimeSheetModalCtrl', ['$uibModalInstance','toastrService','monthlyTimeSheetApproverService','applicationId', RejectMonthlyTimeSheetModalCtrl]);

    /** @ngInject */
    function RejectMonthlyTimeSheetModalCtrl($uibModalInstance,toastrService,monthlyTimeSheetApproverService,applicationId) {
        var vm = this;
        vm.reject = reject;
        
        function reject() {
            monthlyTimeSheetApproverService.approveOrRejectTimeSheet(applicationId,{status:2}).then(function (data) {
                toastrService.showSuccessToastr("Rejection successful");
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not reject time sheet: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DevicePermissionsCtrl', ['authService', 'deviceService','$scope','toastrService','utilService','accessAreaService', 'analyticsService', 'ANALYTICS_CONSTANT', 'generalSettingsService', DevicePermissionsCtrl]);

    /** @ngInject */
    function DevicePermissionsCtrl(authService, deviceService, $scope, toastrService,utilService,accessAreaService, analyticsService, ANALYTICS_CONSTANT, generalSettingsService) {

        var vm = this;

        vm.deviceListForAllocation = [];
        vm.deviceListForTemporaryPermission = [];
        vm.deviceListForRevoke = [];
        vm.accessAreaListToAllocate=[];
        vm.selectedAccessAreaListToAllocate=[];
        vm.accessAreaListToRevoke=[];
        vm.selectedAccessAreaListToRevoke=[]
        vm.selectedDevices = [];
        vm.employeeIdentifier = null;
        vm.employee = {};
        vm.allcation = {};
        vm.allocationDatePicker = {};
        vm.allocationDatePicker.fromTime = new moment();
        vm.allocationDatePicker.toTime = new moment();
        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.temporarySelectedDevice = [];
        vm.isDeviceTabVisible = false;
        vm.allocatedDeviceList = [];
        vm.temporaryAllocationHistoryData = [];
        vm.allocationDatePicker.options = {
            singleDatePicker : true,
            startDate : moment(),
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }
        };
        vm.temporaryAllocationHistoryData = [];
        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.total = 0;
        vm.isDataLoaded = false;
        vm.isAllocatedDeviceDataLoaded=false;
        vm.rowsPerPage = 10;
        utilService.setRowsPerPage(10);

        vm.saveTemporaryAllocation = saveTemporaryAllocation;
        vm.openCalendarFromTime = openCalendarFromTime;
        vm.openCalendarToTime = openCalendarToTime;
        vm.allocateEmployee = allocateEmployee;
        vm.revokeEmployee = revokeEmployee;
        vm.getTemporaryAllocationHistoriesOfAnEmployee = getTemporaryAllocationHistoriesOfAnEmployee;
        vm.allocateEmployeeToAccessArea=allocateEmployeeToAccessArea
        vm.revokeEmployeeFromAccessArea=revokeEmployeeFromAccessArea;

        function init() {
            vm.selectedPage = 0;
            vm.isDeviceTabVisible = authService.isAdmin();
            if(authService.isLineManager()){
                generalSettingsService.getLinemanagerSettingsOfAnOffice().then(function (response) {
                    vm.isDeviceTabVisible = response.isAllowed;
                    loadDeviceData();
                });
            }else{
               loadDeviceData();
            }

        }
        function loadDeviceData(){
            if(!vm.isDeviceTabVisible) return ;
            getDevicesOfEmployee();
            getAccessAreas();
            deviceService.getAllDevices().then(function (devices) {
                devices = addLabelAndLocation(devices);
                vm.deviceListForAllocation = angular.copy(devices);
                vm.deviceListForTemporaryPermission = angular.copy(devices);
                //console.log(JSON.stringify(devices));
            },function () {
                toastrService.showErrorToastr('Could not fetch devices list', "", 5000);
            });
            getTemporaryAllocationHistoriesOfAnEmployee();
        }
        function revokeEmployeeFromAccessArea(){
            toastrService.clearPreviousToastr();
            if(vm.employeeId === null ||  vm.selectedAccessAreaListToRevoke.length <= 0 || !vm.selectedAccessAreaListToRevoke){
                toastrService.showErrorToastr("Please select an access area");
                return;
            }
            var request = {
                "employeeIdList" : [vm.employeeId],
                "accessAreaId" : vm.selectedAccessAreaListToRevoke[0].id,
                "action" : "revoke"
            };
            deviceService.allocateOrRevokeEmployeesToAccessArea(request).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.devicePermissions, document.title + ' - Device Permissions - Revoke User To Access Area', 'revoke-access-area', 'Device Permission Revoke  Access Area In' + document.title, 'revoke')
                toastrService.showSuccessToastr("Revocation successful");
                getDevicesOfEmployee();
            },function (error) {
                toastrService.showErrorToastr("Could not allocate. " + error.message, "", 5000);
            })
        }
        function allocateEmployeeToAccessArea(){
            toastrService.clearPreviousToastr();
            if(vm.employeeId === null ||  vm.selectedAccessAreaListToAllocate.length <= 0 || !vm.selectedAccessAreaListToAllocate){
                toastrService.showErrorToastr("Please select an access area");
                return;
            }
            var request = {
                "employeeIdList" : [vm.employeeId],
                "accessAreaId" : vm.selectedAccessAreaListToAllocate[0].id,
                "action" : "allocate"
            };
            deviceService.allocateOrRevokeEmployeesToAccessArea(request).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.devicePermissions, document.title + ' - Device Permissions - Allocate User To Access Area', 'allocate-access-area', 'Device Permission Allocate  Access Area In' + document.title, 'allocate')
                toastrService.showSuccessToastr("Allocation successful");
                getDevicesOfEmployee();
            },function (error) {
                toastrService.showErrorToastr("Could not allocate. " + error.message, "", 5000);
            })
        }
        function getAccessAreas(){
            accessAreaService.getAllAccessAreas().then(function (accessAreas){
                vm.accessAreaListToAllocate = angular.copy(accessAreas);
                vm.accessAreaListToRevoke = angular.copy(accessAreas);
            }, function (error){
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }
        function createEventWatchers() {
            $scope.$on("device-permission-tab-select",init);
            $scope.$on("profile-info-loaded",function (event,employee) {
                vm.employeeId = employee.id;
                vm.employee = employee;
            });
        }

        createEventWatchers();

        function addLabelAndLocation(devices){
            for(var i=0; i<devices.length; i++){
                devices[i]["label"] = devices[i]["identifier"] + " - " + devices[i]["location"];
            }
            return devices;
        }

        function getDevicesOfEmployee() {
            vm.isAllocatedDeviceDataLoaded=false
            deviceService.getDevicesOfEmployee(vm.employeeId).then(function (data) {
                vm.allocatedDeviceList = data;
                vm.deviceListForRevoke = addLabelAndLocation(data);
                vm.isAllocatedDeviceDataLoaded=true;
            },function (error) {
                vm.allocatedDeviceList = [];
                toastrService.showErrorToastr("Could not fetch allocations of employee because " + error, "", 5000);
                 console.error("Could not fetch allocations of employee because " + error);
            })
        }

        function allocateEmployee() {
            toastrService.clearPreviousToastr();
            if(vm.employeeId === null ||  vm.selectedDevices.length <= 0 || !vm.selectedDevices){
                toastrService.showErrorToastr("Please select a device");
                return;
            }
            var request = {
                "employeeIdList" : [vm.employeeId],
                "deviceIdList" : vm.selectedDevices.map( function (d){return d.id}),
                "action" : "allocate"
            };
            deviceService.allocateOrRevokeEmployees(request).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.devicePermissions, document.title + ' - Device Permissions - Allocate User To Device', 'allocate-device', 'Device Permission Allocate  Device In' + document.title, 'allocate')
                toastrService.showSuccessToastr("Allocation successful");
                getDevicesOfEmployee();
            },function (error) {
                toastrService.showErrorToastr("Could not allocate. " + error.message, "", 5000);
            })
        }

        function revokeEmployee() {
            toastrService.clearPreviousToastr();
            if(vm.employeeId === null ||  vm.selectedDevices.length <= 0 || !vm.selectedDevices){
                toastrService.showErrorToastr("Please select a device");
                return;
            }
            var request = {
                "employeeIdList" : [vm.employeeId],
                "deviceIdList" : vm.selectedDevices.map( function (d){return d.id}),
                "action" : "revoke"
            };
            deviceService.allocateOrRevokeEmployees(request).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.devicePermissions, document.title + ' - Device Permissions - Revoke User To Device', 'revoke-device', 'Device Permission Revoke Device In' + document.title, 'revoke')
                toastrService.showSuccessToastr("Revocation successful");
                getDevicesOfEmployee();
                // console.log(data);
            },function (error) {
                toastrService.showErrorToastr("Could not allocate. " + error.message, "", 5000);
            })
        }

        function openCalendarFromTime (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenFrom = true;
        }

        function openCalendarToTime (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenTo = true;
        }

        function saveTemporaryAllocation() {
            toastrService.clearPreviousToastr();
            if(vm.temporarySelectedDevice.length < 1)
                return toastrService.showErrorToastr("Select a device");
            if(vm.allocationDatePicker.fromTime === null || vm.allocationDatePicker.toTime === null )
                return toastrService.showErrorToastr("Times cannot be empty");
            if(vm.allocationDatePicker.fromTime > vm.allocationDatePicker.toTime)
                return toastrService.showErrorToastr("Start time can not be after end time");

            var deviceIds=vm.temporarySelectedDevice.map(function (v){
                return v.id;
            })
            var data = {
                'employeeIdList': [vm.employeeId],
                "timeOfAllocation" : vm.allocationDatePicker.fromTime.format('x'),
                "timeOfRevoke" : vm.allocationDatePicker.toTime.format('x'),
                "deviceIds":deviceIds
            };

            deviceService.allocateMultipleTemporarily(data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.devicePermissions, document.title + ' - Device Permissions - Save Temporary Permissions', 'save-temporary-permissions', 'Save Temporary Permissions In ' + document.title, ANALYTICS_CONSTANT.save)
                toastrService.showSuccessToastr("Allocation successful");
            },function () {
                toastrService.showErrorToastr("Could not allocate employee", "", 5000);
            })

        }

        function getTemporaryAllocationHistoriesOfAnEmployee(params) {
            vm.temporaryAllocationsHistoryData = [];
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            var queryParams = getRequestParameters();
            vm.isDataLoaded = false;
            deviceService.getTemporaryAllocationsHistory(vm.employeeId,queryParams).then(function (data){
                vm.isDataLoaded = true;
                vm.temporaryAllocationHistoryData = data.temporaryAllocations;
                vm.numberOfPages = data.totalPages;
                vm.total = data.totalRecords;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Couldn't fetch device allocation details: " + error,"", 5000);
            });
        }

        function getRequestParameters(){
            return {
                pageNumber : vm.selectedPage,
                perPage    : 10,
            }
        }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.selectedPage = vm.selectedPage == 0? 0 : vm.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.selectedPage = vm.selectedPage == vm.numberOfPages ? vm.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.selectedPage = searchParams;
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EnrolCtrl', ['authService', '$scope','$stateParams','$uibModal','toastrService', 'enrolmentService','employeeService','deviceService','$interval','$sce', 'analyticsService', 'ANALYTICS_CONSTANT', 'generalSettingsService', EnrolCtrl]);


    /** @ngInject */
    function EnrolCtrl(authService,$scope, $stateParams, $uibModal, toastrService, enrolmentService,employeeService,deviceService,$interval,$sce, analyticsService, ANALYTICS_CONSTANT, generalSettingsService) {

        var vm = this;
        vm.enrolEmployee = {};
        vm.enrolledFingers = {};
        vm.employeeId = null;
        vm.employee = {};
        vm.allSelected = false;
        vm.enrolmentList = [];
        vm.selectedEnrolmentList = [];
        vm.deviceList = [];
        vm.selectedDeviceList = [];
        vm.selectedDevice = [];
        vm.running = false;
        vm.from = "";
        vm.to = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.isEnrolTabVisible = false;
        vm.enrolmentPermitted = false;
        vm.fingerPrints = {
            'left' : {
                'thumb'  : {hand : 'left', finger : 'thumb', enrolled : false},
                'index'  : {hand : 'left', finger : 'index', enrolled : false},
                'middle' : {hand : 'left', finger : 'middle',enrolled : false},
                'ring'   : {hand : 'left', finger : 'ring',  enrolled : false},
                'pinky'  : {hand : 'left', finger : 'pinky', enrolled : false},
            },
            'right':{
                'thumb'  : {hand : 'right', finger : 'thumb', enrolled : false },
                'index'  : {hand : 'right', finger : 'index', enrolled : false },
                'middle' : {hand : 'right', finger : 'middle',enrolled : false },
                'ring'   : {hand : 'right', finger : 'ring',  enrolled : false },
                'pinky'  : {hand : 'right', finger : 'pinky', enrolled : false},
            }
        };
        vm.hands = [{name:'Left',value:'left'}, {name:'Right',value:'right'}];
        vm.fingers = [{name:'Thumb',value:'thumb'}, {name:'Index',value:'index'}, {name:'Middle',value:'middle'}, {name:'Ring',value:'ring'}, {name:'Pinky',value:'pinky'}];
        vm.selectedHand = '';
        vm.selectedFinger = '';
        vm.numberOfEnroledFingers = 0;
        vm.enrolMode = false;
        vm.enrolmentStarted = false;
        vm.messageBox = '';

        vm.poll = undefined;

        vm.openDeleteModal = openDeleteModal;
        vm.register = register;
        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.startPersonEnrolmentOfDevice = startPersonEnrolmentOfDevice;
        vm.enrolNewFinger = enrolNewFinger;
        vm.getEnroledFingers = getEnroledFingers;
        vm.stopEnrolmentOfDevice = stopEnrolmentOfDevice;
        vm.getEnrolmentStatsOfDevice = getEnrolmentStatsOfDevice;
        vm.decideEnrolmentOrDelete = decideEnrolmentOrDelete;
        vm.onDeviceSelect = onDeviceSelect;
        vm.showStartButton = showStartButton;

        function showStartButton(){
            return (vm.enrolMode && !vm.enrolmentStarted && vm.selectedDevice.length > 0 && vm.selectedHand != '' && vm.selectedFinger != '');
        }

        function enrolNewFinger(){
            analyticsService.sendData(ANALYTICS_CONSTANT.enrol, document.title + ' - Enrol - Enroll Finger', 'enrol-finger', 'Enrol finger In' + document.title, ANALYTICS_CONSTANT.enrol)

            vm.enrolMode = true;
            vm.selectedHand = '';
            vm.selectedFinger = '';
            if(vm.selectedDevice.length == 0){

                vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Please Select a Device on which you want to enrol fingerprint.</h3>")
            }
        }

        function onDeviceSelect(){
            if(vm.selectedDevice.length == 0)
                vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Please Select a Device on which you want to enrol fingerprint.</h3>")
            else{
                if(vm.selectedFinger == '' || vm.selectedHand == '')
                    vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Select a finger by clicking on the fingers from the picture.</h3>")
                else
                    vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Click Start to start enrolment</h3>")
            }

        }

        function decideEnrolmentOrDelete(hand,finger) {
            if(vm.enrolmentStarted) return;
            if(vm.fingerPrints[hand][finger].enrolled == true){
                openDeleteModal(hand,finger); return;
            }
            if(!vm.enrolMode) return ;
            vm.selectedHand = hand;
            vm.selectedFinger = finger;
            resetAllOtherSelections();

            vm.fingerPrints[vm.selectedHand][vm.selectedFinger].enrolling=true;
            if(vm.selectedDevice.length == 0)
                vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Please Select a Device on which you want to enrol fingerprint.</h3>");
            else
                vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Click <i>Start</i> to start enrolment</h3>");

            // vm.fingerPrints[vm.selectedHand][vm.selectedFinger].className='blink';
        }

        function resetAllOtherSelections(){
           vm.hands.forEach(function (hand){
               vm.fingers.forEach(function (finger){
                   vm.fingerPrints[hand.value][finger.value].enrolling = false;
               })
           })
        }

        function mapToVisualModel(data){
            for (var i = 0; i < data.length ; i++) {
                var enrolment = data[i];
                vm.fingerPrints[enrolment.hand][enrolment.finger].enrolled = true;
                vm.fingerPrints[enrolment.hand][enrolment.finger].className = '';
            }
        }

        $scope.$on("profile-info-loaded", function (event, userData) {
            vm.employeeId = userData.id;
            vm.employee = userData;
        });

        function init() {
            vm.isEnrolTabVisible = authService.isAdmin();
            vm.enrolmentPermitted = vm.loggedInUser.isAdmin || vm.loggedInUser.isHrManager;
            if(vm.loggedInUser.isLineManager){
                generalSettingsService.getLinemanagerSettingsOfAnOffice().then(function (response) {
                    vm.isEnrolTabVisible = response.isAllowed;
                    vm.enrolmentPermitted = response.isAllowed;
                    loadEnrollmentData();
                });
            }else{
                loadEnrollmentData();
            }
        }

        function loadEnrollmentData(){
            if(vm.enrolmentPermitted){
                vm.enrolMode = false;
                vm.selectedHand = '';
                vm.selectedFinger = '';
                vm.selectedDevice = [];
                getEnroledFingers(vm.employeeId == null ? $stateParams.employeeId : vm.employeeId);
                getAllDevicesWithEnrolmentFeature();
            }
        }

        $scope.$on("enroll-tab-select", init);

        function register () {
            toastrService.clearPreviousToastr();
            if (vm.enrolEmployee.file == null && vm.selectedEnrolmentList.size == 0 ) {
                return toastrService.showErrorToastr("Please select a file.");
            }
            if(vm.enrolEmployee.file != null && vm.selectedEnrolmentList.size > 0)
                return toastrService.showErrorToastr("Please select only one option");
            vm.enrolEmployee.employeeId = $stateParams.employeeId;

            if(vm.enrolEmployee.file != null){
                enrolmentService.enrolEmployee(vm.enrolEmployee).then(function (data) {
                    toastrService.showSuccessToastr("Employee enrolment successful");
                }, function (errorMessage) {
                    toastrService.showErrorToastr("Could not enrol employee : " + errorMessage, "", 5000);
                });
            }else {
                var data = {
                    hand : vm.enrolEmployee.hand,
                    finger: vm.enrolEmployee.finger,
                    templateId:vm.selectedEnrolmentList[0].id,
                    employeeId:vm.employeeId == null ? $stateParams.employeeId : vm.employeeId
                };
                enrolmentService.enrollFromTemporary(data).then(function (data) {
                    toastrService.showSuccessToastr("Enrolment successful");
                    vm.selectedEnrolmentList = [];
                    vm.enrolmentList = data;
                },function (error) {
                    toastrService.showErrorToastr("Could not enrol employee: " + error, "", 5000);
                })
            }

        }

        function getEnroledFingers(employeeId) {
            resetAllOtherSelections();
            enrolmentService.getFingers(employeeId).then(function (data) {
                vm.numberOfEnroledFingers = data.length;
                // resetAllOtherSelections();
                if(vm.enrolMode == false){
                    if(vm.numberOfEnroledFingers == 0){
                        vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>No fingerprint enroled. To enroll new fingerprint, click on <i>Enrol Finger</i>.</h3>")
                    }
                    if(vm.numberOfEnroledFingers == 1){
                        vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>1 fingerprint enroled. It is marked as green below. To enroll new fingerprint, click on <i>Enrol Finger</i>.</h3>")
                    }
                    if(vm.numberOfEnroledFingers > 1){
                        vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>"+ vm.numberOfEnroledFingers +" fingerprints enroled. They are marked as green below. To enrol new fingerprint, click on <i>Enrol Finger</i>.</h3>")
                    }

                    // vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>" + (vm.numberOfEnroledFingers == 0 ? "No" : vm.numberOfEnroledFingers) + " fingerprint enroled. They are marked as green. To enrol a new finger click Enrol Finger.</h3>");
                }

                mapToVisualModel(data);
                // getEnrolmentStatsOfDevice();
            });
        }


        function openDeleteModal(hand,finger) {
            toastrService.clearPreviousToastr();
            var data = {
                hand : hand,
                finger: finger,
            }
            if(data.hand == null || data.hand == '' || data.finger == null || data.finger == '' ){
                toastrService.showErrorToastr("Please select hand and finger first");
                return;
            }
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/enrol/delete/deleteEnrolment.modal.html',
                size : 'md',
                controller : 'DeleteEnrolmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    enrolments : function () {
                        return data;
                },employeeId:function () {
                    return vm.employeeId == null? $stateParams.employeeId : vm.employeeId
                }}
            }).result.then(function () {
                // getEnroledFingers(vm.employeeId == null? $stateParams.employeeId : vm.employeeId);
                vm.fingerPrints[hand][finger].enrolled  = false;
                vm.fingerPrints[hand][finger].enrolling = false;
            })
        }

        function checkOrUncheckAll() {
            if(vm.allSelected === false){
              angular.forEach(vm.enrolledFingers,function (item) {
                  item.selected = true;
              });
              vm.allSelected = true;
            }else{
                vm.enrolledFingers.forEach(function (item) {
                    item.selected = false;
                });
                vm.allSelected = false;
            }
        }

        function getAllDevicesWithEnrolmentFeature() {
            deviceService.getAllDevicesWithEnrolmentFeature().then(function (data) {
                for(var i=0; i<data.length; i++){
                    data[i]["label"] = data[i]["identifier"] + " - " + data[i]["location"];
                }
                vm.deviceList = data;
            });
        }

        function startPersonEnrolmentOfDevice() {
            toastrService.clearPreviousToastr();
            if(vm.selectedDevice.length == 0){
                return toastrService.showErrorToastr("Please select a device")
            }
            if(vm.selectedHand == '' || vm.selectedFinger == '')
                return toastrService.showErrorToastr("Please select a finger");
            var data = {
                deviceId   : vm.selectedDevice[0].id,
                employeeId : vm.employeeId == null ? $stateParams.employeeId : vm.employeeId,
                hand       : vm.selectedHand,
                finger     : vm.selectedFinger
            }

            deviceService.startPersonEnrolmentOfADevice(data).then(function () {
                vm.enrolmentStarted = true;
                vm.fingerPrints[vm.selectedHand][vm.selectedFinger].className = 'blink';
                vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Enrolment started. Please follow device instructions</h3>");
                toastrService.showSuccessToastr('Enrolment Started');
                startPolling();
            },function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }

        function stopEnrolmentOfDevice() {
            toastrService.clearPreviousToastr();
            if(vm.selectedDevice.length == 0){
                return toastrService.showErrorToastr("Please select a device");
            }
            deviceService.stopEnrolmentOfADevice(vm.selectedDevice[0].id).then(function () {
                toastrService.showSuccessToastr("Enrolment stopped");
                vm.fingerPrints[vm.selectedHand][vm.selectedFinger].enrolling = false;
                vm.running = false;
                vm.enrolmentStarted = false;
                stop();
                getEnroledFingers(vm.employeeId);
            },function (error) {
                toastrService.showErrorToastr("Could not stop enrolment: " + error, "", 5000);
            })
        }


        // starts the interval
        function startPolling() {
            // stops any running interval to avoid two intervals running at the same time
            if(vm.poll != undefined)
                $interval.cancel(vm.poll);
            // store the interval promise
            vm.poll = $interval(getEnrolmentStatsOfDevice, 10000);
        };

        // stops the interval
        function stop() {
            // if(vm.poll != undefined)
            $interval.cancel(vm.poll);
            vm.poll = undefined;
        };

        function showSuccessMessage(){
            vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Enrolment successfully completed.To enrol another finger, click on another finger.</h3>");
            vm.enrolmentStarted = false;
            vm.fingerPrints[vm.selectedHand][vm.selectedFinger].enrolled = true;
            vm.fingerPrints[vm.selectedHand][vm.selectedFinger].enrolling = false;
            vm.selectedHand = '';
            vm.selectedFinger = '';
            getEnroledFingers(vm.employeeId);
        }

        function showErrorMessage(){
            vm.messageBox = $sce.trustAsHtml("<h3 class='blink-thrice'>Enrolment failed. Please try again</h3>");
            vm.enrolmentStarted = false;
            vm.fingerPrints[vm.selectedHand][vm.selectedFinger].enrolled = false;
            vm.fingerPrints[vm.selectedHand][vm.selectedFinger].enrolling = true;
            getEnroledFingers(vm.employeeId);
            stop();
        }

        function decidePollStopOrContinue(data){
            if(data.running == false){
                if(data.success == true){
                    stop();
                    showSuccessMessage();
                }else if(data.success == false){
                    stop();
                    showErrorMessage();
                }
            }else {
                if(data.person_id != vm.employeeId){
                    stop();
                    showSuccessMessage();
                    // getEnroledFingers(vm.employeeId);
                }
            }
            vm.running = data.running;
            vm.from = data.from;
            vm.to = data.to;
        }

        function getEnrolmentStatsOfDevice() {
            if(vm.selectedDevice.length > 0){
                deviceService.getEnrolmentStatsOfDevice(vm.selectedDevice[0].id,vm.employeeId).then(function (data) {
                    decidePollStopOrContinue(data);
                },function (error){
                    stop();
                });
            }
        }

        vm.$onDestroy = function (){
            stop();
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('LateApprovalManagementCtrl', ['$scope','$stateParams', '$uibModal', 'authService', 'lateApprovalManagementService', 'toastrService', LateApprovalManagementCtrl]);

    /** @ngInject */
    function LateApprovalManagementCtrl($scope, $stateParams, $uibModal, authService, lateApprovalManagementService, toastrService) {

        var vm = this;

        // vm.remainingLateApprovalsList = null;
        // vm.leaveList = null;

        var employeeId = null;

        function init() {
            employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
        }

        function createEventWatchers() {
            $scope.$on('late-approval-management-open-apply-modal', getDataAndOpenModal);
            // $scope.$on('leave-tab-select',init);
        }

        createEventWatchers();

        function getDataAndOpenModal() {
            employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
            openApplyModal();
            // remainingLateApprovalService.getAllRemainingLateApprovalsOfEmployee(employeeId).then(function (remainingLateApprovalsList) {
            //     vm.remainingLateApprovalsList = remainingLateApprovalsList;
            //     openApplyModal();
            // },function (error) {
            //     toastr.error("Could not fetch because " +error);
            // });
        }

        function openApplyModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/late-approval/apply/applyForLateApproval.modal.html',
                size: 'lg',
                controller: 'ApplyForLateApprovalModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    // leaveCategoryList: function () {
                    //     return mapLateApprovalCategories();
                    // },
                    employeeId: function () {
                        return employeeId;
                    }
                }
            }).result.then(function (data) {
                // vm.remainingLateApprovalsList = data.employeeRemainingLateApprovalList;
                // vm.leaveList = data.leaveLogList;
                toastrService.showSuccessToastr("Late Approval application placed.");
            });

        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileOvertimeTableCtrl', ['authService','$scope','overtimeService','$stateParams','_','toastrService',ProfileOvertimeTableCtrl]);

    /** @ngInject */
    function ProfileOvertimeTableCtrl(authService,$scope,overtimeService,$stateParams,_,toastrService) {
        var vm = this;
        vm.allAttendanceData = null;
        vm.attendancedatePicker = {};
        vm.attendancedatePicker.date = getInitialFromAndToDate();
        vm.attendances = null;
        vm.dateList = null;
        vm.numberOfButtons = null;
        vm.excelUrl = null;
        vm.employeeName = null;

        vm.getAttendanceTableData = getAttendanceTableData;
        vm.showChunks = showChunks;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.reduceSelectedPaginationPage = reduceSelectedPaginationPage;

        function init() {
            vm.attendancedatePicker.option = getDatePickerOptions();
            getAttendanceTableData();

        }

        function createEventWatchers() {
            $scope.$on('overtime-tab-select',init);
        }

        createEventWatchers();

        function getInitialFromAndToDate () {
            return {
                'startDate': moment().subtract(10,'days'),
                'endDate': moment()
            };
        }

        function getAttendanceTableData() {
            overtimeService.getOvertime(vm.attendancedatePicker.date.startDate.valueOf(), vm.attendancedatePicker.date.endDate.valueOf(), [], [], [],[], $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId(), [], [], [])
                .then(function (data) {
                    vm.excelUrl = overtimeService.getProfileOvertimeExcelUrl(vm.attendancedatePicker.date.startDate.valueOf(), vm.attendancedatePicker.date.endDate.valueOf(), [], [], [], $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId(), [], [], []);
                    vm.allAttendanceData = _.chunk(data.perEmployeeOvertimeReportList[0].perDayOvertimeDetailsList,10);
                    vm.attendances = vm.allAttendanceData[0];
                    vm.summary = data.perEmployeeOvertimeReportList[0].summary;
                    vm.employeeName = data.perEmployeeOvertimeReportList[0].employeeName;
                    vm.numberOfButtons = Array(vm.allAttendanceData.length).fill(1);
                    vm.selectedPage = 0;
                },function () {
                    toastrService.showErrorToastr("Failed to fetch attendance list", "", 5000);
                });
        }

        function showChunks(index) {
            vm.attendances = vm.allAttendanceData[index];
            vm.selectedPage = index;
        }

        function reduceSelectedPaginationPage() {
            vm.selectedPage = vm.selectedPage  === 0 ? 0 : vm.selectedPage - 1;
            showChunks(vm.selectedPage);
        }

        function increaseSelectedPaginationPage() {
            vm.selectedPaginationPage = vm.selectedPaginationPage === vm.numberOfButtons.length - 1 ? vm.selectedPaginationPage : vm.selectedPaginationPage +1;
            showChunks(vm.selectedPage);
        }

        function getDatePickerOptions() {
            return {
                applyClass: 'btn-green',
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "D-MMM-YY", //will give you 6-Jan-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                    'Last 7 days': [moment().subtract('days', 7), moment()],
                    'Last 30 days': [moment().subtract('days', 30), moment()],
                    'This month': [moment().startOf('month'), moment().endOf('month')]
                }
            };
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('PayrollCtrl', ['$scope', '$q', 'payrollManagementService','payrollSettingsService', 'authService', '$stateParams', 'toastrService', 'bankManagementService', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', PayrollCtrl]);

    /** @ngInject */
    function PayrollCtrl($q, $scope, payrollManagementService,payrollSettingsService, authService, $stateParams, toastrService, bankManagementService, utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.employeeId = $stateParams.employeeId;
        vm.paymentModeList = [{name: 'Bank', value: 0}, {name: 'Cash', amount: 30, value: 1}, {
            name: 'Bank & Cash',
            value: 2
        }, {name: 'Cheque', value: 3}];


        // vm.payroll
        vm.isDataLoaded = false;

        vm.bankName = "";
        vm.grossSalary = 0;
        vm.accountNumber = "";
        vm.routingNumber = "";
        vm.bankPayment = 0;
        vm.cashPayment = 0;
        vm.paymentMode = "";

        vm.postPaymentDetails = postPaymentDetails;

        function init(){
            getBankBranchesList();
            payrollManagementService.getProfilePaymentDetails(vm.employeeId).then(function (data) {
                vm.paymentMode = data.paymentMode;
                vm.paymentModeInString = data.paymentMode;
                vm.bankId      = data.bankId;
                vm.bankName     = data.bankName;
                vm.routingNumber = data.routingNumber;
                vm.grossSalary = data.grossSalary;
                vm.accountNumber = data.accountNumber;
                vm.bankPayment = data.bankPayment;
                vm.cashPayment = data.cashPayment;
            }, function (error) {
                toastrService.showErrorToastr("Failed to get data" + error, '', 5000);
            })

        }
        init();

        function getBankBranchesList(){
            bankManagementService.getAllBranches().then(function (data){
                vm.bankList = data.branchList.filter(function (bank) {
                    return bank.branchStatus == 1;
                })
            })
        }

        payrollSettingsService.getEmployeePayrollComponents(vm.employeeId).then(function (data) {
            vm.salaryDetails=data.employeePayrollComponents;
        }, function (error) {
            toastrService.showErrorToastr("Failed to get data" + error, '', 5000);
        })

        function postPaymentDetails() {
            if (vm.paymentMode == null)
                return toastrService.showErrorToastr("Payment Mode can not be empty");

            var data = {
                employeeId: vm.employeeId,
                paymentMode: vm.paymentMode,
                grossSalary: vm.grossSalary,
                bankPayment: vm.bankPayment,
                cashPayment: vm.cashPayment,
                bankId: vm.bankId,
                accountNumber: vm.accountNumber,
                routingNumber: vm.routingNumber,
            };

            payrollManagementService.postProfilePaymentDetails(vm.employeeId, data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.payroll, document.title + ' - Payroll - Save', 'save', 'Payroll Save In ' + document.title, ANALYTICS_CONSTANT.save)
                toastrService.showSuccessToastr("Save was successful");
                init();
            }, function (error) {
                toastrService.showErrorToastr("Failed to save" + error, '', 5000);
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfilePendingApprovalsCtrl', ['$uibModal','authService','leaveManagementService', 'remainingLeaveService', 'toastrService', 'lateApprovalManagementService','employeeService','$rootScope','$sce','$scope','_','$stateParams','analyticsService', 'ANALYTICS_CONSTANT', ProfilePendingApprovalsCtrl]);

    /** @ngInject */
    function ProfilePendingApprovalsCtrl($uibModal,authService, leaveManagementService, remainingLeaveService, toastrService, lateApprovalManagementService,employeeService,$rootScope,$sce,$scope,_,$stateParams,analyticsService,ANALYTICS_CONSTANT) {

        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        var analyticsTitle = 'Profile - Pending Approval';
        var analyticsUrl = 'pending-approval';
        vm.leaveApplications = [];
        vm.lateApprovalApplications = [];
        vm.manualEntryApplications = [];
        vm.timeSheetApprovals = [];
        vm.isHrManager = loggedInUser.isHrManager;
        vm.isDataLoaded=false;
        vm.isLateApprovalDataLoaded = false;
        vm.isLeaveApprovalDataLoaded = false;
        vm.isManualEntryDataLoaded = false;

        vm.openLeaveRejectModal = openLeaveRejectModal;
        vm.openLeaveEditModal = openLeaveEditModal;
        vm.openLeaveCancelModal = openLeaveCancelModal;
        vm.openLateCancelModal = openLateCancelModal;
        vm.openCancelManualEntryModal = openCancelManualEntryModal;
        vm.openEditManualEntryModal = openEditManualEntryModal;

        var employeeId = $stateParams.employeeId;

        createEventWatchers();

        function createEventWatchers() {
            $scope.$on("pending-approvals-tab-select",init);
        }

        function init() {
            getPendingLeaveApplicationsOfEmployee();
            getPendingLateApplicationsOfEmployee();
            getManualEntriesOfEmployee();
            // analyticsService.sendData(ANALYTICS_CONSTANT.tab, analyticsTitle, analyticsUrl, 'Pending Approval Tab', ANALYTICS_CONSTANT.open)
        }
        function getManualEntriesOfEmployee() {
            employeeService.getManualEntries(employeeId).then(function (data) {
                vm.manualEntryApplications = _.filter(data,function (application) {
                    return application.status == 0
                });
                vm.manualEntryApplications = _.map(vm.manualEntryApplications,function (application) {
                    application.firstManualEntryApprovalDisplayString = $sce.trustAsHtml(application.firstManualEntryApprovalDisplayString);
                    application.secondManualEntryApprovalDisplayString = $sce.trustAsHtml(application.secondManualEntryApprovalDisplayString );
                    return application;
                })
                vm.isManualEntryDataLoaded = true;
            });
        }
        function getPendingLateApplicationsOfEmployee() {
            lateApprovalManagementService.getPendingLateApprovalLogsOfAnEmployee(employeeId).then(function(lateApprovalApplications){
                vm.lateApprovalApplications = _.filter(lateApprovalApplications,function (application) {
                    return application.status == 0
                });
                vm.lateApprovalApplications = _.map(vm.lateApprovalApplications,function (late) {
                    late.firstApprovalDisplayString = $sce.trustAsHtml(late.firstApprovalDisplayString);
                    late.secondApprovalDisplayString = $sce.trustAsHtml(late.secondApprovalDisplayString );
                    return late;
                })
            },function (error) {
                toastrService.showErrorToastr("Failed to fetch pending late approval applications : " + error, "", 5000);
                console.error("Failed to fetch pending late approval applications : " + error);
            }).finally(function (){
                vm.isLateApprovalDataLoaded = true;
            });
        }

        function getPendingLeaveApplicationsOfEmployee() {
            leaveManagementService.getAllLeaveApplicationsOfAnEmployee(employeeId).then(function(leaveApplications){
                vm.leaveApplications = _.filter(leaveApplications,function (application) {
                    return application.status == 0
                });
                vm.leaveApplications = _.map(vm.leaveApplications,function (leave) {
                    leave.firstApprovalDisplayString = $sce.trustAsHtml(leave.firstApprovalDisplayString);
                    leave.secondApprovalDisplayString = $sce.trustAsHtml(leave.secondApprovalDisplayString );
                    return leave;
                })
            },function (error) {
                toastrService.showErrorToastr("Failed to fetch pending leave applications : " + error,"", 5000);
                console.error("Failed to fetch pending leave applications : " + error);
            });
        }

        function openLeaveRejectModal(application) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/pendingApprovals/rejectModal/rejectLeave.modal.html',
                size : 'md',
                controller : 'RejectLeaveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (comment) {
                leaveManagementService.rejectLeave({
                    approverComment : comment
                }, application.leaveLogId).then(function(leaveApplications){
                    vm.leaveApplications = leaveApplications;
                    getPendingApprovalsAndUpdateSidebar();
                    toastrService.showSuccessToastr("Leave application rejected.");
                },function (error) {
                    console.error("Failed to reject pending leave applications : " + error);
                    toastrService.showErrorToastr("Failed to reject leave application. Please try again later.", "", 5000);
                });
            });
        }

        function openLeaveEditModal(leaveLog) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/pendingApprovals/leave/edit/editLeaveModal.html',
                size : 'lg',
                controller : 'EditLeaveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    leaveLog : function () {
                        return leaveLog;
                    },
                    employeeId : function () {
                        return employeeId;
                    }
                }
            }).result.then(function () {
               getPendingLeaveApplicationsOfEmployee();
            });
        }

        function openLeaveCancelModal(leaveLog) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/pendingApprovals/leave/cancel/cancelLeaveLog.modal.html',
                size : 'lg',
                controller : 'CancelLeaveLogCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    leaveLogId : function () {
                        return leaveLog.id;
                    }
                }
            }).result.then(function () {
                getPendingLeaveApplicationsOfEmployee();
            });
        }

        function openLateCancelModal(lateLog) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/pendingApprovals/late/cancelLateLog.modal.html',
                size : 'md',
                controller : 'LateCancelModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    lateLogId : function () {
                        return lateLog.id;
                    }
                }
            }).result.then(function () {
                getPendingLateApplicationsOfEmployee();
            });
        }

        function openCancelManualEntryModal(manualEntryApplication) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/pendingApprovals/manual/cancel/manualEntryCancelModal.html',
                size : 'md',
                controller : 'ManualEntryCancelModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    manualEntryApplicationId : function () {
                        return manualEntryApplication.id;
                    },
                    manualEntryType : function (){
                        return '';
                    }
                }
            }).result.then(function () {
                getManualEntriesOfEmployee();
            });
        }

        function openEditManualEntryModal(manualEntryApplication) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/pendingApprovals/manual/edit/editManualEntry.modal.html',
                size : 'md',
                controller : 'EditManualEntryModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    application : function () {
                        return manualEntryApplication;
                    },
                    userId : function () {
                        return employeeId;
                    }
                }
            }).result.then(function () {
                getManualEntriesOfEmployee();
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('PerEmployeeTimeSheetReportCtrl', ['$scope', 'projectService', 'taskService','authService','$stateParams','toastrService', 'utilService', PerEmployeeTimeSheetReportCtrl]);

    /** @ngInject */
    function PerEmployeeTimeSheetReportCtrl($scope, projectService, taskService, authService, $stateParams, toastrService, utilService) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.report = null;
        vm.dates = [];
        vm.pageNo = 1;
        vm.perPage = 20;
        vm.totalPages = null;
        vm.showFilters = true;
        vm.showTimesheetReport = utilService.hasPermission("10001") || utilService.hasPermission("100011");

        vm.allProjects = [];
        vm.selectedProject = null;

        vm.allTasks = [];
        vm.selectedTask = null;

        vm.minDate = new Date(utilService.getMinimumDate());
        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            applyClass: 'btn-success',
            minDate: vm.minDate,
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                // format: "D/MMM/YY", //will give you 6-Jan-17
                format: "DD-MM-YYYY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        vm.pageButtons = [];
        vm.totalData = 0;

        vm.getAllTasks = getAllTasks;
        vm.getReport = getReport;
        vm.toggleShowFilters = toggleShowFilters;
        vm.getData = getData;

        var loggedInUser = authService.getLoggedInUser();

        function init() {
            console.log("timesheet report tab select");
            getData(vm.perPage, vm.pageNo);
            getAllProjects();
        }

        $scope.$on("timeSheet-report-tab-select", init);


        function getData(perPage, pageNo) {
            vm.isDataLoaded = false;
            var employeeId = $stateParams.employeeId == null ?  loggedInUser.id : $stateParams.employeeId;
            var projectId = (vm.selectedProject != null && vm.selectedProject[0] != null) ?vm.selectedProject[0].id : null;
            var taskId = (vm.selectedTask != null && vm.selectedTask[0] != null) ?vm.selectedTask[0].id : null;
            var data = {
                employeeId : employeeId,
                perPage : perPage,
                pageNo : pageNo,
                projectWorkId : projectId,
                taskId : taskId,
                startDate: moment(vm.datePicker.date.startDate).format('x'),
                endDate: moment(vm.datePicker.date.endDate).format('x')
            };

            taskService.getTimeSheetReportOfAnEmployee(data).then(function (responseData) {
                vm.report = responseData.timeSheetReport;
                vm.dates = responseData.dates;
                vm.pageNo = responseData.pageNo;
                vm.totalPages = responseData.totalPages;
                vm.isDataLoaded = true;

                vm.perPage = perPage;
                vm.totalData = Object.keys(vm.report).length;
                var startPage = vm.pageNo-2 <= 0 ? 1 : vm.pageNo-2;
                var endPage = Math.min(vm.totalPages, startPage+4);
                vm.pageButtons.length = 0;
                for (var i = startPage; i <= endPage; i++) {
                    vm.pageButtons.push(i);
                }
            })
        }

        function getAllTasks() {
            var projectId = vm.selectedProject[0].id;
            taskService.getAllTasksWithFilters(null, projectId).then(function (data) {
                vm.allTasks = data;
            },function (message) {
                toastrService.showErrorToastr('Task Fetching failed error: ' + message, "", 5000);
            });
        }

        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: ' + message, "", 5000);
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(3, 'day');
            var end = moment().endOf('day');
            // vm.datePicker.startDate = start;
            // vm.datePicker.endDate = end;
            return {
                'startDate': start,
                'endDate': end
            };
        }

        function getReport() {
            getData(vm.perPage, vm.pageNo);
        }

        function toggleShowFilters() {
            vm.showFilters = !vm.showFilters;
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileRosterCtrl', ['$scope','rosterService','authService','$stateParams','toastr',ProfileRosterCtrl]);

    /** @ngInject */
    function ProfileRosterCtrl($scope,rosterService,authService,$stateParams,toastr) {
        var vm = this;

        var loggedInUser = authService.getLoggedInUser();
        vm.date = new Date();
        vm.rosters = [];
        vm.isDataLoaded=false;

        vm.increaseOrDecreaseMonth = increaseOrDecreaseMonth;

        function init() {
            $scope.$on("roster-tab-select",function () {
                getData();
            })
        }

        function getData() {
            vm.isDataLoaded=false;
            rosterService.getProfileRoster({
                year : vm.date.getFullYear(),
                month : vm.date.getMonth()+1,
                employeeId : $stateParams.employeeId == null ?  loggedInUser.id : $stateParams.employeeId
            }).then(function (data) {
                vm.rosters = data.rosters;
                vm.isDataLoaded=true;
            })
        }

        function increaseOrDecreaseMonth(command) {
            vm.date = new Date(vm.date);
            if(command == 'increase')
                vm.date = vm.date.setMonth(vm.date.getMonth()+1);
            else
                vm.date = vm.date.setMonth(vm.date.getMonth()-1);
            vm.date = new Date(vm.date);
            getData();
        }

        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.clients')
        .controller('ClientsCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'moment', 'utilService', 'projectClientService', 'employeeService', 'analyticsService', 'ANALYTICS_CONSTANT', ClientsCtrl]);


    function ClientsCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, moment, utilService, projectClientService, employeeService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isProjectManager = loggedInUser.employeeRoles.includes('PROJECT_MANAGER');
        vm.showFilterDiv = false;
        vm.organisationTypes = [];
        vm.employeeList = [];
        vm.isDataLoaded = false;

        vm.search = {};
        vm.search.selectedOrganisationTypes = [];
        vm.search.selectedEmployees = [];
        vm.search.keyword = null;
        vm.sortKeys = {
            'Client Name': {value: 'clientName', order: 'asc', selected: true},
            'Organisation Type': {value: 'organisationTypeName', order: 'asc', selected: false},
            'K.A.M.': {value: 'kamName', order: 'asc', selected: false}
        };

        vm.clients = [];

        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        vm.total = 0;

        vm.searchParams = {};
        vm.searchParams.organisationTypeId = [];
        vm.searchParams.kamId = [];
        vm.searchParams.keyword = "";
        vm.searchParams.sortKey = "";
        vm.searchParams.order = "asc";
        vm.searchParams.perPage = vm.rowsPerPage;
        vm.searchParams.pageNumber = 0;

        vm.search = search;
        vm.goToEditClientPage = goToEditClientPage;
        vm.openDeleteModal = openDeleteModal;
        vm.setParamsAndSearch = setParamsAndSearch;
        vm.updateSortKey = updateSortKey;
        vm.goToClientCreationPage = goToClientCreationPage;
        vm.searchFromTheBeginningOfPagination = searchFromTheBeginningOfPagination;

        function init() {
            var promises = [];
            promises.push(getAllOrganisationTypes());
            promises.push(getFilteredEmployeeNames());
            $q.all(promises)
                .then(function () {
                    utilService.setRowsPerPage(vm.rowsPerPage);
                    vm.isDataLoaded = true;
                    searchFromTheBeginningOfPagination();
                    // search();
                });
        }

        function search(searchParams) {
            modifyParams(searchParams);
            vm.isDataLoaded = false;
            projectClientService.getAllProjectClients(vm.searchParams).then(function (data) {
                vm.clients = data.clients;
                preparePagination(data.totalPages, data.pageNumber, data.totalRecords);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch client list: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getAllOrganisationTypes() {
            return projectClientService.getAllOrganisationTypes().then(function (data) {
                vm.organisationTypes = data;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch organisation types: " + error, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        init();

        function goToEditClientPage(clientDetails) {
            analyticsEditClient();
            $state.go("projectManagement.editProjectClient", {clientDetails : clientDetails});
        }

        function openDeleteModal(item) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/projectManagement/clients/delete/deleteClient.modal.html',
                size: 'md',
                controller : 'DeleteClientModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    clientDetails: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function () {
                searchFromTheBeginningOfPagination();
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for (var i = 0; i < keys.length; i++) {
                if (vm.sortKeys[keys[i]].selected == true) {
                    return {key: vm.sortKeys[keys[i]].value, order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function setParamsAndSearch() {
            var sortKeyAndOrder = getSortKeyAndOrder();
            vm.searchParams.organisationTypeId = !!vm.search.selectedOrganisationTypes && vm.search.selectedOrganisationTypes.length > 0 ? vm.search.selectedOrganisationTypes.map(getId) : [];
            vm.searchParams.kamId = !!vm.search.selectedEmployees && vm.search.selectedEmployees.length > 0 ? vm.search.selectedEmployees.map(getId) : [];
            vm.searchParams.keyword = vm.search.keyword;
            vm.searchParams.pageNumber = vm.selectedPage;
            vm.searchParams.sortKey = sortKeyAndOrder.key;
            vm.searchParams.order = sortKeyAndOrder.order;
            analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In' + document.title, ANALYTICS_CONSTANT.search);
            search(vm.searchParams);
        }

        function getId(object) {
            return object.id;
        }

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            searchFromTheBeginningOfPagination();
        }

        function searchFromTheBeginningOfPagination(){
            preparePagination();
            setParamsAndSearch();
        }

        function preparePagination(totalPage, selectedPage, total) {
            vm.rowsPerPage = utilService.getRowsPerPage();
            vm.selectedPage = selectedPage == null ? 0 : selectedPage;
            vm.numberOfPages = totalPage == null ? 0 : totalPage;
            vm.total = total == null ? 0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }

        function analyticsCreateClient() {
            analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create Clients', '', 'Create Clients In' + document.title, ANALYTICS_CONSTANT.create)
        }

        function analyticsEditClient(){
            analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit Client Information', '', 'Edit Client In' + document.title, ANALYTICS_CONSTANT.edit)
        }

        function goToClientCreationPage() {
            $state.go("projectManagement.createProjectClient");
            analyticsCreateClient();
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.issueCreators')
        .controller('IssueCreatorsCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'projectIssuesService', 'moment', 'utilService', 'ISSUE_PRIORITIES', 'ISSUE_STATUSES', 'projectService', 'employeeService', 'productService', IssueCreatorsCtrl]);


    function IssueCreatorsCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, projectIssuesService, moment, utilService, ISSUE_PRIORITIES, ISSUE_STATUSES, projectService, employeeService, productService) {
        var vm = this;
        vm.loggedInUser = authService.getLoggedInUser();
        vm.isProjectManager = vm.loggedInUser.employeeRoles.includes('PROJECT_MANAGER');
        vm.employees = [];
        vm.searchKeyword = null;
        vm.isDataLoaded = false;
        vm.creators = [];

        vm.search = {};
        vm.search.keyword = null;

        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        vm.total = 0;

        vm.searchParams = {};
        vm.searchParams.keyword = "";
        vm.searchParams.perPage = vm.rowsPerPage;
        vm.searchParams.pageNumber = 0;

        vm.search = search;
        vm.openCreateModal = openCreateModal;
        vm.openDeleteModal = openDeleteModal;
        vm.searchFromTheBeginningOfPagination = searchFromTheBeginningOfPagination;




        function init() {
            var promises = [];
            promises.push(getFilteredEmployeeNames());

            $q.all(promises).then(function () {
                utilService.setRowsPerPage(vm.rowsPerPage);
                vm.isDataLoaded = true;
                searchFromTheBeginningOfPagination();
            });
        }

        init();



        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.employees = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function search(searchParams) {
            modifyParams(searchParams);
            vm.isDataLoaded = false;
            projectIssuesService.getFilteredIssueCreators(vm.searchParams).then(function (data) {
                vm.creators = data.issueCreators;
                preparePagination(data.totalPages, data.pageNumber, data.totalRecords);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch issue creator list: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/projectManagement/issueCreators/modals/createIssueCreator.modal.html',
                size         : 'md',
                controller   : 'CreateIssueCreatorModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    employees : function () {
                        return  vm.employees;
                    }
                }
            }).result.then(function () {
                vm.isDataLoaded = false;
                init();
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function setParamsAndSearch() {
            vm.searchParams.keyword = vm.search.keyword;
            vm.searchParams.pageNumber = vm.selectedPage;
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In' + document.title, ANALYTICS_CONSTANT.search);
            search(vm.searchParams);
        }

        function preparePagination(totalPage, selectedPage, total) {
            vm.rowsPerPage = utilService.getRowsPerPage();
            vm.selectedPage = selectedPage == null ? 0 : selectedPage;
            vm.numberOfPages = totalPage == null ? 0 : totalPage;
            vm.total = total == null ? 0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }

        function searchFromTheBeginningOfPagination(){
            preparePagination();
            setParamsAndSearch();
        }

        function openDeleteModal(employee) {
            var confirmationText = "Are you sure you want to remove this privilege from " + employee.employeeName +"?";
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                removeCreator(employee);
            });
        }

        function removeCreator(employee) {
            vm.isDataLoaded = false;
            projectIssuesService.removeCreator(employee.employeeId).then(function (data) {
                toastrService.showSuccessToastr("Successfully removed " + employee.employeeName + " from the issue creator list");
                init();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't remove " + employee.employeeName + " from the issue creator list: " + error, "", 5000);
                vm.isDataLoaded = true;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
        .controller('MonthlyProjectDedicationReportCtrl', ['$scope', 'projectService', 'authService','$stateParams','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',MonthlyProjectDedicationReportCtrl]);

    /** @ngInject */
    function MonthlyProjectDedicationReportCtrl($scope, projectService, authService, $stateParams, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.showFilters = true;
        vm.isDataLoaded = true;
        vm.isReportLoaded = false;
        vm.allProjects = [];
        vm.selectedProjects = [];
        vm.monthList = [{id: 0, name: 'January'}, {id: 1, name: 'February'}, {id: 2, name: 'March'}, {
            id: 3,
            name: 'April'
        }, {id: 4, name: 'May'}, {id: 5, name: 'June'},
            {id: 6, name: 'July'}, {id: 7, name: 'August'}, {id: 8, name: 'September'}, {
                id: 9,
                name: 'October'
            }, {id: 10, name: 'November'}, {id: 11, name: 'December'}];
        vm.selectedMonth = [];
        vm.yearList = [];
        vm.selectedYear = [];
        vm.selectedMonthDisplay = "";
        vm.report = [];

        vm.getReport = getReport;

        function init() {
            yearMonthInit();
            getAllProjects();
        }

        function getReport() {
            vm.isDataLoaded = false;
            vm.isReportLoaded = false;
            var projectWorkId = vm.selectedProject.map(function (project) { return project.id });
            var selectedTime = moment().year(vm.selectedYear[0].id).month(vm.selectedMonth[0].id)
            var data = {
                projectWorkId : projectWorkId,
                startDate: Number(getStartOfMonthFromMomentInMillis(selectedTime)),
                endDate: Number(getEndOfMonthFromMomentInMillis(selectedTime))
            }
            projectService.getMonthlyDedicationReport(data).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                vm.report = data;
                vm.isDataLoaded = true;
                vm.isReportLoaded = true;
            },function (message) {
                toastrService.showErrorToastr('Monthly dedication report fetching error: '+message, "", 5000);
                console.error('Monthly dedication report fetching error: '+message);
                vm.isDataLoaded = true;
            });

        }
        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
                console.error('Project Fetching failed error: '+message);
            });
        }

        function yearMonthInit() {
            var year = new Date().getFullYear();
            vm.attendanceOfYear = year;
            vm.yearList.push({id: year - 2, ticked: false}, {id: year - 1, ticked: false}, {
                id: year,
                ticked: true
            });
            vm.yearList = _.orderBy(vm.yearList, ['id'], ['desc']);
            vm.selectedYear.push({id: year});
            tickCurrentMonth();
            vm.selectedMonthDisplay = getCurrentMonthInString();
        }

        function tickCurrentMonth() {
            var d = new moment().format("MMMM");
            for (var i = 0; i < vm.monthList.length; i++) {
                if (vm.monthList[i].name.toLowerCase() === d.toLowerCase()) {
                    vm.monthList[i].ticked = true;
                    vm.selectedMonth.push({id: vm.monthList[i].id});
                    break;
                }
            }
        }

        function getCurrentMonthInString() {
            var d = new moment().format("MMMM");
            return d;
        }

        function getStartOfMonthFromMomentInMillis(d) {
            return d.startOf('month').format('x');
        }

        function getEndOfMonthFromMomentInMillis(d) {
            return d.endOf('month').format('x');
        }

        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
        .controller('PeopleGanttChartReportCtrl', ['$scope', '$uibModal', 'projectService', 'taskService', 'teamService', 'employeeService', 'authService','$stateParams','toastrService', 'TASK_STATUS', 'analyticsService', 'ANALYTICS_CONSTANT', PeopleGanttChartReportCtrl]);

    /** @ngInject */
    function PeopleGanttChartReportCtrl($scope, $uibModal, projectService, taskService, teamService, employeeService, authService, $stateParams, toastrService, TASK_STATUS, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.showFilters = true;


        vm.allEmployees = [];
        vm.selectedEmployee = [];

        vm.getGanttChartReportData = getGanttChartReportData;
        vm.openCreateTaskModal = openCreateTaskModal;

        vm.dates = [];
        vm.tasks = [];
        vm.indexOfToday = -1;

        vm.statusList = TASK_STATUS;
        vm.selectedStatus = [];

        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            applyClass: 'btn-green',
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                // format: "D/MMM/YY", //will give you 6-Jan-17
                format: "DD-MMM-YYYY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        function init() {
            getAllEmployees();
            getGanttChartReportData();
        }

        function getGanttChartReportData() {
            vm.isDataLoaded = false;
            clearPreviousData();
            var employeeId = (vm.selectedEmployee != null && vm.selectedEmployee[0] != null) ? vm.selectedEmployee[0].id : null;
            if (employeeId == null) {
                vm.isDataLoaded = true;
                return;
            }
            var status = vm.selectedStatus.map(function (element) {
                return element.id;
            });
            var data = {
                employeeId : employeeId,
                status : status,
                startDate: moment(vm.datePicker.date.startDate).format('x'),
                endDate: moment(vm.datePicker.date.endDate).format('x')
            }
            projectService.getGanttChartData('employee', data).then(function (responseData) {
                analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                vm.isDataLoaded = true;
                vm.dates = responseData.dates;
                vm.tasks = responseData.tasks;
                vm.indexOfToday = responseData.indexOfToday;
            }, function (error) {
                vm.isDataLoaded = true;
            });
        }

        function clearPreviousData() {
            vm.dates = [];
            vm.tasks = [];
            vm.indexOfToday = -1;
        }

        function getAllEmployees() {
            employeeService.getFilteredEmployeeNames(true).then(function (data) {
                vm.allEmployees = _.sortBy(data.employees, function (employee){
                    return employee.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Employee Fetching failed error: '+message, "", 5000);
                console.error('Employee Fetching failed error: '+message);
            });
        }

        function openCreateTaskModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/tasks/createTask/createTask.modal.html',
                size : 'lg',
                controller : 'CreateTaskModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (taskList) {
                getGanttChartReportData();
            }, function (message) {
                console.error(message);
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(7, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
        .controller('TimeSheetReportCtrl', ['$scope', 'projectService', 'taskService', 'teamService', 'employeeService', 'authService','$stateParams','toastr', 'analyticsService', 'ANALYTICS_CONSTANT',TimeSheetReportCtrl]);

    /** @ngInject */
    function TimeSheetReportCtrl($scope, projectService, taskService, teamService, employeeService, authService, $stateParams, toastr, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.report = null;
        vm.dates = [];
        vm.pageNo = 1;
        vm.perPage = 20;
        vm.totalPages = null;
        vm.showFilters = true;
        vm.excelUrl = "";

        vm.allProjects = [];
        vm.selectedProjects = [];

        vm.allTasks = [];
        vm.selectedTasks = [];

        vm.allTeams = [];
        vm.selectedTeams = [];

        vm.employees = [];
        vm.selectedEmployees = [];

        vm.date = moment();

        vm.pageButtons = [];
        vm.totalData = 0;
        vm.analyticsDownloadExcel = analyticsDownloadExcel;
        vm.getAllTasks = getAllTasks;
        vm.getReport = getReport;
        vm.toggleShowFilters = toggleShowFilters;
        vm.getData = getData;
        vm.searchReport = searchReport;


        function init() {
            getData(vm.perPage, vm.pageNo);
            getAllProjects();
            getAllTeams();
            getAllEmployees();
        }

        function getData(perPage, pageNo) {
            vm.isDataLoaded = false;
            // var projectId = (vm.selectedProject != null && vm.selectedProject[0] != null) ?vm.selectedProject[0].id : null;
            // var taskId = (vm.selectedTask != null && vm.selectedTask[0] != null) ?vm.selectedTask[0].id : null;
            var projectId = vm.selectedProjects.map(function (element) {
                return element.id;
            });
            var taskId = vm.selectedTasks.map(function (element) {
                return element.id;
            });
            var teamId = vm.selectedTeams.map(function (element) {
                return element.id;
            });
            var employeeId = vm.selectedEmployees.map(function (element) {
                return element.id;
            });
            var data = {
                perPage : perPage,
                pageNo : pageNo,
                projectWorkId : projectId,
                taskId : taskId,
                teamId : teamId,
                employeeId : employeeId,
                date: moment(vm.date).format('x'),
            }
            vm.excelUrl = taskService.getExcelUrlForPerDayTimeSheetReport(data);
            taskService.getTimeSheetReportOfADay(data).then(function (responseData) {
                // console.log('testing')
                vm.report = responseData.timeSheetReport;
                vm.dates = responseData.dates;
                vm.pageNo = responseData.pageNo;
                vm.totalPages = responseData.totalPages;
                vm.isDataLoaded = true;

                vm.perPage = perPage;
                vm.totalData = Object.keys(vm.report).length;
                var startPage = vm.pageNo-2 <= 0? 1 : vm.pageNo-2;
                var endPage = Math.min(vm.totalPages, startPage+4);
                vm.pageButtons.length = 0;
                for (var i = startPage; i <= endPage; i++) {
                    vm.pageButtons.push(i);
                }
            })
        }

        function getAllTasks() {
            // var projectId = vm.selectedProject[0].id;
            var projectId = vm.selectedProjects.map(function (element) {
                return element.id;
            });
            projectId = projectId[0];
            taskService.getAllTasksWithFilters(null, projectId).then(function (data) {

                vm.allTasks = data;
            },function (message) {
                console.error('Task Fetching failed error: '+message);
            });
        }

        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {

                vm.allProjects = _.sortBy(data,function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                console.error('Project Fetching failed error: '+message);
            });
        }

        function getAllTeams() {
            teamService.getAllTeams(true).then(function (data) {
                vm.allTeams = _.sortBy(data, function (team){
                    return team.name.toLowerCase();
                });
            },function (message) {
                console.error('Team Fetching failed error: '+message);
            });
        }

        function getAllEmployees() {
            employeeService.getFilteredEmployeeNames(true).then(function (data) {
                vm.employees = _.sortBy(data.employees, function (employee){
                    return employee.name.toLowerCase();
                });
            },function (message) {
                console.error('Employee Fetching failed error: '+message);
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(3, 'day');
            var end = moment().endOf('day');
            // vm.datePicker.startDate = start;
            // vm.datePicker.endDate = end;
            return {
                'startDate': start,
                'endDate': end
            };
        }

        function getReport() {
            getData(vm.perPage, vm.pageNo);
        }

        function toggleShowFilters() {
            vm.showFilters = !vm.showFilters;

        }
        function analyticsDownloadExcel(){
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Excel', ANALYTICS_CONSTANT.downloadExcel)
        }
        function searchReport(){
            getReport();
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search);

        }
        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.products')
        .controller('ProductsCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'productService', 'moment', 'utilService', 'productSegmentService', 'employeeService', 'analyticsService', 'ANALYTICS_CONSTANT', ProductsCtrl]);


    function ProductsCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, productService, moment, utilService, productSegmentService, employeeService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isProjectManager = loggedInUser.employeeRoles.includes('PROJECT_MANAGER');
        vm.allEntries = [];
        vm.search = {};
        vm.search = {};
        vm.search.perPage = utilService.setRowsPerPage(10);
        vm.search.segmentList = [];
        vm.search.ownerList = [];
        vm.search.selectedOwnerList = [];
        vm.search.selectedSegmentList = [];
        vm.search.productSearchKey = null;
        vm.isDataLoaded = false;
        vm.rowsPerPage = 0
        vm.pageNumber = 0
        vm.numberOfPages = 0;
        vm.total = 0;
        vm.numberOfButtons = [];
        vm.sortKeys = {
            'Product Name': {value: 'productName', order: 'asc', selected: true},
            'Owner Name': {value: 'ownerName', order: 'asc', selected: false},
            'Segment Name': {value: 'segmentName', order: 'asc', selected: false}
        }

        vm.getProductPageSpecifiedData = getProductPageSpecifiedData;
        vm.searchProductListOfOffice = searchProductListOfOffice;
        vm.updateSortKey = updateSortKey;
        vm.searchFromTheBeginingOfPagination = searchFromTheBeginingOfPagination;
        vm.createProductSegment = createProductSegment;
        vm.deleteCreateProductModal = deleteCreateProductModal;
        vm.goToProductCreationPage = goToProductCreationPage;
        vm.goToProductEditPage = goToProductEditPage;

        function init() {
            searchFromTheBeginingOfPagination();
            getAllProductSegementsOfOffice();
            getAllEmployeesOfOffice();
        }

        init();

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            searchFromTheBeginingOfPagination();
        }

        function searchFromTheBeginingOfPagination(inSearch){
            if(inSearch)
                analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In' + document.title, ANALYTICS_CONSTANT.search);
            preparePagination();
            searchProductListOfOffice(vm.search);
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for (var i = 0; i < keys.length; i++) {
                if (vm.sortKeys[keys[i]].selected == true) {
                    return {key: vm.sortKeys[keys[i]].value, order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function getAllEmployeesOfOffice() {
            employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.search.ownerList = angular.copy(data.employees);
            }, function (err) {
                toastrService.showErrorToastr('Failed to load owner data ' + err);
            })
        }

        function getAllProductSegementsOfOffice() {
            productSegmentService.getProductSegmentsOfOffice().then(function (data) {
                vm.search.segmentList = angular.copy(data.allProductSegments);
            }, function (err) {
                toastrService.showErrorToastr('Failed to load product segment data ' + err);
            })
        }

        function preparePagination(totalPage, selectedPage, total) {

            vm.search.perPage = utilService.getRowsPerPage();
            vm.search.pageNumber = selectedPage == null ? 0 : selectedPage;
            vm.numberOfPages = totalPage == null ? 0 : totalPage;
            vm.total = total == null ? 0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }

        function getProductPageSpecifiedData(params) {
            if (params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            searchProductListOfOffice(vm.search);
        }

        function modifyParams(search) {
            if (search == 'prev') {
                vm.search.pageNumber = vm.search.pageNumber == 0 ? 0 : vm.search.pageNumber - 1;
            } else if (search == 'next') {
                vm.search.pageNumber = vm.search.pageNumber == vm.totalPage ? vm.search.pageNumber : vm.search.pageNumber + 1;
            } else if (!isNaN(search)) {
                vm.search.pageNumber = search;
            }
        }

        function deleteCreateProductModal(index){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/projectManagement/products/modals/deleteProductModal.html',
                size        : 'md',
                controller  : 'DeleteProductModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     :
                    {
                        productToDelete:function () {
                            return  vm.allEntries[index].id;
                        }
                    }
            }).result.then(function (){
                searchFromTheBeginingOfPagination();
            });
        }

        function searchProductListOfOffice(searchParams) {
            vm.isDataLoaded = false;
            var sortKeyAndOrder = getSortKeyAndOrder();
            var params = {
                perPage: searchParams.perPage,
                pageNumber: searchParams.pageNumber,
                productSearchKey: searchParams.searchName == "" || searchParams.searchName == null ? null : searchParams.searchName,
                productSegmentIds: searchParams.selectedSegmentList.map(function (val) {
                    return val['id'];
                }),
                ownerIds: searchParams.selectedOwnerList.map(function (val) {
                    return val['id'];
                }),
                sortKey: sortKeyAndOrder ? sortKeyAndOrder.key : null,
                order: sortKeyAndOrder ? sortKeyAndOrder.order : null,
            };
            productService.getProductsOfOffice(params).then(function (data) {
                vm.isDataLoaded = true;
                vm.allEntries = data.products;
                preparePagination(data.totalPages, data.selectedPage, data.total);
            }, function () {

            })
        }

        function createProductSegment(data){
            productSegmentService.createProductSegment({name:data}).then(function (){
                toastrService.showSuccessToastr('Created Product Segment Successfully');
                getAllProductSegementsOfOffice();
            }, function (err){
                toastrService.showErrorToastr('Error occured while creating a new product segment '+err)
            })

        }

        function analyticsCreateProduct() {
            analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create Product', '', 'Create Product In' + document.title, ANALYTICS_CONSTANT.create)
        }

        function analyticsEditProduct(){
            analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit Product Information', '', 'Edit Product In' + document.title, ANALYTICS_CONSTANT.edit)
        }

        function goToProductCreationPage() {
            $state.go("projectManagement.createProduct");
            analyticsCreateProduct();
        }

        function goToProductEditPage(product) {
            $state.go("projectManagement.editProduct", {productToEdit : product});
            analyticsEditProduct();
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
        .controller('PeopleListModalCtrl', ['$uibModalInstance','taskService', 'task', 'toastr', PeopleListModalCtrl]);

    /** @ngInject */
    function PeopleListModalCtrl($uibModalInstance,taskService, task, toastr) {

        var vm = this;
        vm.task = {};
        vm.task = task;
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
        .controller('ProjectGanttChartReportCtrl', ['$scope', '$uibModal', 'projectService', 'taskService', 'teamService', 'employeeService', 'authService','$stateParams','toastr', 'TASK_STATUS', 'analyticsService', 'ANALYTICS_CONSTANT', ProjectGanttChartReportCtrl]);

    /** @ngInject */
    function ProjectGanttChartReportCtrl($scope, $uibModal, projectService, taskService, teamService, employeeService, authService, $stateParams, toastr, TASK_STATUS, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.showFilters = true;


        vm.allProjects = [];
        vm.selectedProject = [];

        vm.showPeopleList = showPeopleList;
        vm.getGanttChartReportData = getGanttChartReportData;
        vm.openCreateTaskModal = openCreateTaskModal;

        vm.dates = [];
        vm.tasks = [];
        vm.indexOfToday = -1;

        vm.statusList = TASK_STATUS;
        vm.selectedStatus = [];

        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            applyClass: 'btn-green',
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                format: "D-MMM-YYYY", //will give you 6-Jan-17
                // format: "D-MMMM-YY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        function init() {
            getAllProjects();
            getGanttChartReportData();
        }

        function getGanttChartReportData() {
            vm.isDataLoaded = false;
            clearPreviousData();
            var projectId = (vm.selectedProject != null && vm.selectedProject[0] != null) ?vm.selectedProject[0].id : null;
            if (projectId == null) {
                vm.isDataLoaded = true;
                return;
            }
            var status = vm.selectedStatus.map(function (element) {
                return element.id;
            });
            var data = {
                projectWorkId : projectId,
                status : status,
                startDate: moment(vm.datePicker.date.startDate).format('x'),
                endDate: moment(vm.datePicker.date.endDate).format('x')
            }
            projectService.getGanttChartData('project', data).then(function (responseData) {
                analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                vm.isDataLoaded = true;
                vm.dates = responseData.dates;
                vm.tasks = responseData.tasks;
                vm.indexOfToday = responseData.indexOfToday;
            }, function (error) {
                vm.isDataLoaded = true;
            });
        }

        function clearPreviousData() {
            vm.dates = [];
            vm.tasks = [];
            vm.indexOfToday = -1;
        }

        function showPeopleList(task) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/projectGanttChart/peopleList.modal.html',
                size : 'md',
                controller : 'PeopleListModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {task : function () {
                        return task;
                    }}
            });
        }

        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                console.error('Project Fetching failed error: '+message);
            });
        }

        function openCreateTaskModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/tasks/createTask/createTask.modal.html',
                size : 'lg',
                controller : 'CreateTaskModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (taskList) {
                getGanttChartReportData();
            }, function (message) {
                console.error("Failed to create task - " + message);
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(7, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projectIssues')
        .controller('ProjectIssuesCtrl', ['$scope', '$rootScope', '$location', '$window', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'projectIssuesService', 'moment', 'utilService', 'ISSUE_PRIORITIES', 'ISSUE_STATUSES', 'projectService', 'employeeService', 'productService', ProjectIssuesCtrl]);

    // console.log("I am from ProjectIssuesCtrl")
    function ProjectIssuesCtrl($scope, $rootScope, $location, $window,  $stateParams, $state, $uibModal, authService, toastrService, $q, _, projectIssuesService, moment, utilService, ISSUE_PRIORITIES, ISSUE_STATUSES, projectService, employeeService, productService) {
        var vm = this;
        vm.isBackButtonClicked = false
        vm.loggedInUser = authService.getLoggedInUser();
        vm.isDataLoaded = false;
        vm.showFilterDiv = false;
        vm.enableCreateButton = vm.loggedInUser.employeeRoles.includes('ISSUE_CREATOR');
        vm.allEntries = [];
        vm.issueList = []

        vm.datePicker = {};
        vm.datePicker.date = {
            startDate : moment().subtract(1, 'months'),
            endDate : moment()
        };
        vm.datePicker.options = {
            locale: {
                format: 'D MMM YYYY', //will give you 6-Jan-17
            },
            minDate: moment(new Date(utilService.getMinimumDate()))
        };


        vm.search = {};
        vm.projects = [];
        vm.search.selectedProjects = [];
        vm.products = [];
        vm.search.selectedProducts = [];
        vm.employees = [];
        vm.submitters = [];
        vm.assignees = [];
        vm.search.selectedSubmitters = [];
        vm.search.selectedAssignees = [];
        vm.statusList = angular.copy(ISSUE_STATUSES);
        vm.search.selectedStatusList = [];
        vm.priorityList = angular.copy(ISSUE_PRIORITIES);
        vm.search.selectedPriorities = [];
        vm.search.keyword = null;

        vm.sortKeys = {
            'Issue Date': {value: 'issueDate', order: 'desc', selected: true},
            'Project Name': {value: 'projectName', order: 'asc', selected: false},
            'Product Name': {value: 'productName', order: 'asc', selected: false},
            'Submitted By': {value: 'submittedBy', order: 'asc', selected: false},
            'Allocated To': {value: 'allocatedTo', order: 'asc', selected: false},
            'Status': {value: 'status', order: 'asc', selected: false},
            'Priority': {value: 'priority', order: 'asc', selected: false}
        };

        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        vm.total = 0;

        vm.searchParams = {};
        vm.searchParams.from = vm.datePicker.date.startDate.format('x');
        vm.searchParams.to = vm.datePicker.date.endDate.format('x');
        vm.searchParams.projectId = [];
        vm.searchParams.productId = [];
        vm.searchParams.submitterId = [];
        vm.searchParams.assigneeId = [];
        vm.searchParams.status = [];
        vm.searchParams.priority = [];
        vm.searchParams.keyword = "";
        vm.searchParams.sortKey = "";
        vm.searchParams.order = "asc";
        vm.searchParams.perPage = vm.rowsPerPage;
        vm.searchParams.pageNumber = 0;


        vm.setParamsAndSearch = setParamsAndSearch;
        vm.goToCreateIssuePage = goToCreateIssuePage;
        vm.updateSortKey = updateSortKey;
        vm.goToEditIssuePage = goToEditIssuePage;
        vm.goToViewIssuePage = goToViewIssuePage;
        vm.search = search;
        vm.searchFromTheBeginningOfPagination = searchFromTheBeginningOfPagination;


        function init() {
            var promises = [];
            promises.push(getFilteredEmployeeNames());
            promises.push(getAllProjects());
            promises.push(getProducts());

            $q.all(promises).then(function () {
                utilService.setRowsPerPage(vm.rowsPerPage);
                vm.isDataLoaded = true;

                if(vm.isBackButtonClicked)
                    showPrevFilterResult()
                else
                    searchFromTheBeginningOfPagination();
            });
        }

        init();

        function showPrevFilterResult(){
            var filterDropDown = JSON.parse(sessionStorage.getItem('filterDropDown'));
            var filterDate = JSON.parse(sessionStorage.getItem('filterDate'));
            var otherPageParams = JSON.parse(sessionStorage.getItem('otherPageParams'));

            if(!utilService.isObjectEmpty(filterDropDown)) setFilterDetails(filterDropDown);
            if(!utilService.isObjectEmpty(otherPageParams)) setOtherPageParams(otherPageParams);
            if(!utilService.isObjectEmpty(filterDate)) setFilterDate(filterDate);

            searchFromTheBeginningOfPagination();
        }

        function setFilterDetails(filterDropDown){
            vm.showFilterDiv = true;

            loadDropDownSelections('submitters', filterDropDown.selectedSubmitters, 'selectedSubmitters');
            loadDropDownSelections('assignees', filterDropDown.selectedAssignees, 'selectedAssignees');
            loadDropDownSelections('priorityList', filterDropDown.selectedPriorities, 'selectedPriorities');
            loadDropDownSelections('projects', filterDropDown.selectedProjects, 'selectedProjects');
            loadDropDownSelections('products', filterDropDown.selectedProducts, 'selectedProducts');
            loadDropDownSelections('statusList', filterDropDown.selectedStatusList, 'selectedStatusList');
        }

        function setFilterDate(filterDate){
            vm.datePicker.date.startDate = moment(filterDate.startDate)
            vm.datePicker.date.endDate = moment(filterDate.endDate)
        }

        function setOtherPageParams(otherPageParams){
            var sortKey = otherPageParams.sortKey;
            var order = otherPageParams.order;

            vm.search.keyword = !!otherPageParams.keyword ? otherPageParams.keyword : "";
            vm.selectedPage = !!otherPageParams.selectedPage ? otherPageParams.selectedPage : vm.selectedPage;
            vm.rowsPerPage = !!otherPageParams.rowsPerPage ? otherPageParams.rowsPerPage : vm.rowsPerPage;

            if(!!sortKey || !!order) {
                Object.keys(vm.sortKeys).forEach(function (key){
                    if(vm.sortKeys[key].value == sortKey){
                        vm.sortKeys[key].selected = true;
                        vm.sortKeys[key].order = order;
                    }
                    else {
                        vm.sortKeys[key].selected = false;
                    }
                })
            }
        }

        function loadDropDownSelections(inputModel, dropDownDetail, outputModel){
            vm.search[outputModel] = dropDownDetail;
            var ids = dropDownDetail.map(getId)
            var inputModelHash = {};

            vm[inputModel].forEach(function(a, i){
                inputModelHash[a.id] = i;
            });

            ids.forEach(function(id){
                vm[inputModel][inputModelHash[id]].ticked = true;
            })
        }


        $window.onpopstate = function(event) {
            if($location.url() === '/project-management/issues'){
                vm.isBackButtonClicked = true
            }
        };

        function preparePagination(totalPage, selectedPage, total) {
            vm.rowsPerPage = utilService.getRowsPerPage();
            vm.selectedPage = selectedPage == null ? 0 : selectedPage;
            vm.numberOfPages = totalPage == null ? 0 : totalPage;
            vm.total = total == null ? 0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function getAllProjects() {
            projectService.getProjectList().then(function (data) {
                vm.projects = data.projects;
            }, function (message) {
                toastrService.showErrorToastr("Couldn't fetch project list: " + message, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.employees = data.employees;
                vm.submitters = angular.copy(vm.employees);
                vm.assignees = angular.copy(vm.employees);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function getProducts() {
            return productService.getSimplifiedProductList().then(function (data) {
                vm.products = data.products;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch product list: " + error, "", 5000);
            });
        }

        function search(searchParams) {
            modifyParams(searchParams);
            vm.isDataLoaded = false;
            projectIssuesService.getFilteredIssueList(vm.searchParams).then(function (data) {
                vm.issueList = data.issues;
                preparePagination(data.totalPages, data.pageNumber, data.totalRecords);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch issue list: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function setParamsAndSearch() {
            var sortKeyAndOrder = getSortKeyAndOrder();
            vm.searchParams.from = vm.datePicker.date.startDate.format('x');
            vm.searchParams.to = vm.datePicker.date.endDate.format('x');
            vm.searchParams.projectId = !!vm.search.selectedProjects && vm.search.selectedProjects.length > 0 ? vm.search.selectedProjects.map(getId) : [];
            vm.searchParams.productId = !!vm.search.selectedProducts && vm.search.selectedProducts.length > 0 ? vm.search.selectedProducts.map(getId) : [];
            vm.searchParams.submitterId = !!vm.search.selectedSubmitters && vm.search.selectedSubmitters.length > 0 ? vm.search.selectedSubmitters.map(getId) : [];
            vm.searchParams.assigneeId = !!vm.search.selectedAssignees && vm.search.selectedAssignees.length > 0 ? vm.search.selectedAssignees.map(getId) : [];
            vm.searchParams.status = !!vm.search.selectedStatusList && vm.search.selectedStatusList.length > 0 ? vm.search.selectedStatusList.map(getId) : [];
            vm.searchParams.priority = !!vm.search.selectedPriorities && vm.search.selectedPriorities.length > 0 ? vm.search.selectedPriorities.map(getId) : [];
            vm.searchParams.keyword = vm.search.keyword;
            vm.searchParams.pageNumber = vm.selectedPage;
            vm.searchParams.sortKey = sortKeyAndOrder.key;
            vm.searchParams.order = sortKeyAndOrder.order;
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In' + document.title, ANALYTICS_CONSTANT.search);
            search(vm.searchParams);
            vm.isBackButtonClicked = false
        }

        function searchFromTheBeginningOfPagination() {
            preparePagination();
            setParamsAndSearch();
        }

        function analyticsCreateIssue() {

        }

        function goToCreateIssuePage() {
            analyticsCreateIssue();
            $state.go("projectManagement.createIssue");
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for (var i = 0; i < keys.length; i++) {
                if (vm.sortKeys[keys[i]].selected == true) {
                    return {key: vm.sortKeys[keys[i]].value, order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            searchFromTheBeginningOfPagination();
        }


        function goToEditIssuePage(issue) {
            if(vm.loggedInUser.id !== issue.submitterId) return;
            saveFilterDetails();
            $state.go("projectManagement.editIssue", {issueDetails : issue});
        }

        function goToViewIssuePage(issue) {
            saveFilterDetails();
            $state.go("projectManagement.viewIssue", {issueDetails: issue});
        }

        function saveFilterDetails(){
            //var sortKeyAndOrder = getSortKeyAndOrder();

            var filterDropDown = {
                selectedAssignees: vm.search.selectedAssignees,
                selectedSubmitters: vm.search.selectedSubmitters,
                selectedPriorities: vm.search.selectedPriorities,
                selectedProjects: vm.search.selectedProjects,
                selectedProducts: vm.search.selectedProducts,
                selectedStatusList: vm.search.selectedStatusList,
            }

            var filterDate = {
                startDate: Number(vm.datePicker.date.startDate.format('x')),
                endDate: Number(vm.datePicker.date.endDate.format('x'))
            }

            var otherPageParams = {
                keyword: vm.search.keyword,
                selectedPage: vm.selectedPage,
                rowsPerPage: vm.rowsPerPage,
                sortKey: vm.searchParams.sortKey,
                order: vm.searchParams.order
            }

            sessionStorage.setItem('filterDropDown', JSON.stringify(filterDropDown))
            sessionStorage.setItem('filterDate', JSON.stringify(filterDate))
            sessionStorage.setItem('otherPageParams', JSON.stringify(otherPageParams));

        }

        function getId(object) {
            return object.id;
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
        .controller('ProjectWorkHourReportCtrl', ['$scope', 'projectService', 'authService','$stateParams','toastr', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',ProjectWorkHourReportCtrl]);

    /** @ngInject */
    function ProjectWorkHourReportCtrl($scope, projectService, authService, $stateParams, toastr, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.showFilters = true;
        vm.isDataLoaded = false;
        vm.isReportLoaded = false;
        vm.allProjects = [];
        vm.selectedProject = {};
        vm.report = [];

        vm.getReport = getReport;

        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            applyClass: 'btn-green',
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                // format: "D/MMM/YY", //will give you 6-Jan-17
                format: "D-MMM-YYYY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        function init() {
            getAllProjects();
        }

        function getReport() {
            if(vm.selectedProject.length===0){
                toastrService.showErrorToastr('Please Select A Project','',5000);
                return;
            }
            vm.isDataLoaded = false;
            vm.isReportLoaded = false;
            var projectWorkId = vm.selectedProject[0].id;
            var data = {
                projectWorkId : projectWorkId,
                startDate: moment(vm.datePicker.date.startDate).format('x'),
                endDate: moment(vm.datePicker.date.endDate).format('x')
            }
            projectService.getWorkHourReportData(data).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                vm.report = data;
                vm.isDataLoaded = true;
                vm.isReportLoaded = true;
            },function (message) {
                console.error('Project work hour report fetching error: '+message);
                vm.isDataLoaded = true;
            });

        }
        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
                vm.isDataLoaded = true
            },function (message) {
                console.error('Project Fetching failed error: '+message);
                vm.isDataLoaded = true
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(7, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('ProjectsCtrl', ['$q', '$scope', '$state', 'authService', '$uibModal', 'projectService', 'toastrService', 'TDH_OFFICE_ID', 'employeeService', 'utilService', 'projectClientService', 'productService', ProjectsCtrl]);

    /** @ngInject */
    function ProjectsCtrl($q, $scope, $state, authService, $uibModal, projectService, toastrService, TDH_OFFICE_ID, employeeService, utilService, projectClientService, productService) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.allProjects = [];
        vm.loggedInUser = authService.getLoggedInUser();
        vm.isProjectManager = vm.loggedInUser.employeeRoles.includes('PROJECT_MANAGER');

        vm.showFilterDiv = false;

        vm.search = {};
        vm.projectTypes = [];
        vm.search.selectedProjectTypes = [];
        vm.products = [];
        vm.search.selectedProducts = [];
        vm.clients = [];
        vm.search.selectedClients = [];
        vm.employees = [];
        vm.search.selectedEmployees = [];
        vm.search.keyword = null;

        vm.sortKeys = {
            'Project Name': {value: 'projectName', order: 'asc', selected: true},
            'Products': {value: 'productName', order: 'asc', selected: false},
            'Project Types': {value: 'projectType', order: 'asc', selected: false},
            'Client Name': {value: 'clientName', order: 'asc', selected: false},
            'K.A.M.': {value: 'ownerName', order: 'asc', selected: false},
            'Start Date': {value: 'startTime', order: 'asc', selected: false},
            'Due Date': {value: 'dueDate', order: 'asc', selected: false},
            'End Date': {value: 'endDate', order: 'asc', selected: false},
            'No. of Issues': {value: 'issueCount', order: 'asc', selected: false}
        };

        vm.numberOfPages = 0;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.rowsPerPage = 10;
        vm.total = 0;

        vm.searchParams = {};
        vm.searchParams.projectTypeId = [];
        vm.searchParams.productId = [];
        vm.searchParams.clientId = [];
        vm.searchParams.ownerId = [];
        vm.searchParams.keyword = "";
        vm.searchParams.sortKey = "";
        vm.searchParams.order = "asc";
        vm.searchParams.perPage = vm.rowsPerPage;
        vm.searchParams.pageNumber = 0;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.loadPartial = loadPartial;
        vm.goToEditProjectPage = goToEditProjectPage;
        vm.setParamsAndSearch = setParamsAndSearch;
        vm.goToProjectCreationPage = goToProjectCreationPage;
        vm.search = search;
        vm.updateSortKey = updateSortKey;
        vm.searchFromTheBeginningOfPagination = searchFromTheBeginningOfPagination;

        init();

        function init() {
            if(vm.loggedInUser.officeId === TDH_OFFICE_ID) {
                getAllProjectsForTDH();
                return;
            }

            var promises = [];
            promises.push(getFilteredEmployeeNames());
            promises.push(getProjectTypes());
            promises.push(getClients());
            promises.push(getProducts());

            $q.all(promises)
                .then(function () {
                    utilService.setRowsPerPage(vm.rowsPerPage);
                    vm.isDataLoaded = true;
                    searchFromTheBeginningOfPagination();
                });
        }

        function setParamsAndSearch() {
            var sortKeyAndOrder = getSortKeyAndOrder();
            vm.searchParams.projectTypeId = !!vm.search.selectedProjectTypes && vm.search.selectedProjectTypes.length > 0 ? vm.search.selectedProjectTypes.map(getId) : [];
            vm.searchParams.productId = !!vm.search.selectedProducts && vm.search.selectedProducts.length > 0 ? vm.search.selectedProducts.map(getId) : [];
            vm.searchParams.clientId = !!vm.search.selectedClients && vm.search.selectedClients.length > 0 ? vm.search.selectedClients.map(getId) : [];
            vm.searchParams.ownerId = !!vm.search.selectedEmployees && vm.search.selectedEmployees.length > 0 ? vm.search.selectedEmployees.map(getId) : [];
            vm.searchParams.keyword = vm.search.keyword;
            vm.searchParams.pageNumber = vm.selectedPage;
            vm.searchParams.sortKey = sortKeyAndOrder.key;
            vm.searchParams.order = sortKeyAndOrder.order;
            // analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In' + document.title, ANALYTICS_CONSTANT.search);
            search(vm.searchParams);
        }

        function search(searchParams) {
            modifyParams(searchParams);
            vm.isDataLoaded = false;
            projectService.getFilteredProjectList(vm.searchParams).then(function (data) {
                vm.allProjects = data.projectWorkList;
                preparePagination(data.totalPages, data.pageNumber, data.totalRecords);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch project list: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getAllProjectsForTDH() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = data;
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
                console.error('Project Fetching failed error: '+message);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/projects/modals/createProject.modal.html',
                size : 'md',
                controller : 'CreateProjectModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (projectList) {
                vm.allProjects = projectList;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to create project - " + message, "", 5000);
            });
        }

        function openEditModal(item) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/projects/editProject/editProject.modal.html',
                size : 'md',
                controller : 'EditProjectModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    project : function () {
                        return angular.copy(item);
                    }}
            }).result.then(function (projectList) {
                vm.allProjects = projectList;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to update project - " + message, "", 5000);
            });
        }

        function openDeleteModal(item) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/projects/deleteProject/deleteProject.modal.html',
                size : 'md',
                controller : 'DeleteProjectModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {project : function () {
                        return item;
                    }}
            }).result.then(function (projectList) {
                if(vm.loggedInUser.officeId === TDH_OFFICE_ID) {
                    vm.allProjects = projectList;
                    return;
                }
                searchFromTheBeginningOfPagination();
            }, function (message) {
                // toastrService.showErrorToastr("Failed to delete project - " + message, "", 5000);
            });
        }

        function loadPartial() {
            if(vm.loggedInUser.officeId === TDH_OFFICE_ID)
                return "app/pages/main/projectManagement/projects/partials/projects.tdh.html";
            else
                return "app/pages/main/projectManagement/projects/partials/projects.regular.html";
        }

        function goToEditProjectPage(project) {
            $state.go("projectManagement.editProject", {projectDetails : project});
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employees = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function getProjectTypes() {
            return projectService.getAllProjectTypes().then(function (data) {
                vm.projectTypes = data.allProjectTypes;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch project type list: " + error, "", 5000);
            });
        }

        function getProducts() {
            return productService.getSimplifiedProductList().then(function (data) {
                vm.products = data.products;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch product list: " + error, "", 5000);
            });
        }

        function getClients() {
            return projectClientService.getSimplifiedProjectClientList().then(function (data) {
                vm.clients = data.clients;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch client list: " + error, "", 5000);
            });
        }

        function searchFromTheBeginningOfPagination(){
            preparePagination();
            setParamsAndSearch();
        }

        function preparePagination(totalPage, selectedPage, total) {
            vm.rowsPerPage = utilService.getRowsPerPage();
            vm.selectedPage = selectedPage == null ? 0 : selectedPage;
            vm.numberOfPages = totalPage == null ? 0 : totalPage;
            vm.total = total == null ? 0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for (var i = 0; i < keys.length; i++) {
                if (vm.sortKeys[keys[i]].selected == true) {
                    return {key: vm.sortKeys[keys[i]].value, order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function updateSortKey(key) {
            if (vm.sortKeys[key].selected) {
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc' ? 'desc' : 'asc';
            } else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function (keyName) {
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            searchFromTheBeginningOfPagination();
        }

        function getId(object) {
            return object.id;
        }

        function analyticsCreateProject() {

        }

        function goToProjectCreationPage() {
            $state.go("projectManagement.createProject");
            analyticsCreateProject();
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.tasks')
        .controller('TasksCtrl', ['$scope','authService','$uibModal', 'projectService', 'taskService', 'toastrService', 'TASK_STATUS', TasksCtrl]);

    /** @ngInject */
    function TasksCtrl($scope, authService,$uibModal, projectService, taskService, toastrService, TASK_STATUS) {

        var vm = this;

        vm.allTasks = [];
        vm.pageNo = 1;
        vm.perPage = 50;
        vm.totalPages = null;

        vm.pageButtons = [];
        vm.totalData = 0;

        vm.allProjects = [];
        vm.selectedProject = null;

        vm.statusList = TASK_STATUS
        vm.selectedStatus = null;

        vm.showFilters = false;
        vm.isDataLoaded = false;

        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            applyClass: 'btn-green',
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                // format: "D/MMM/YY", //will give you 6-Jan-17
                format: "D-MMM-YYYY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        vm.getAllTasks = getAllTasks;
        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            getAllProjects();
            getAllTasks();
        }

        function getAllTasks() {
            vm.isDataLoaded = false;
            var projectId = (vm.selectedProject != null && vm.selectedProject[0] != null) ?vm.selectedProject[0].id : null;
            var status = (vm.selectedStatus != null && vm.selectedStatus[0] != null) ?vm.selectedStatus[0].id : null;

            var data = {
                perPage : vm.perPage,
                pageNo : vm.pageNo,
                projectWorkId : projectId,
                status : status,
                startDate: moment(vm.datePicker.date.startDate).format('x'),
                endDate: moment(vm.datePicker.date.endDate).format('x')
            }
            taskService.getAllTasks(true, data).then(function (data) {
                vm.allTasks = data.taskList;
                vm.pageNo = data.pageNo;
                vm.perPage = data.perPage;
                vm.totalPages = data.totalPages;
                vm.isDataLoaded = true;

                vm.totalData = Object.keys(vm.allTasks).length;
                var startPage = vm.pageNo-2 <= 0? 1 : vm.pageNo-2;
                var endPage = Math.min(vm.totalPages, startPage+4);
                vm.pageButtons.length = 0;
                for (var i = startPage; i <= endPage; i++) {
                    vm.pageButtons.push(i);
                }
                $scope.$broadcast("refreshFixedColumns");
            },function (message){
                toastrService.showErrorToastr('Task Fetching failed error: '+message, "", 5000);
                console.error('Task Fetching failed error: '+message);
            });
        }

        function getAllProjects(){
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/tasks/createTask/createTask.modal.html',
                size : 'md',
                controller : 'CreateTaskModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (taskList) {
                vm.allTasks = taskList;
                vm.totalData = Object.keys(vm.allTasks).length;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to create task - " + message, "", 5000);
            });
        }

        function openEditModal(item) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/tasks/editTask/editTask.modal.html',
                size : 'md',
                controller : 'EditTaskModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    task : function () {
                        return angular.copy(item);
                    }}
            }).result.then(function (taskList) {
                vm.allTasks = taskList;
                vm.totalData = Object.keys(vm.allTasks).length;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to update task - " + message);
            });
        }

        function openDeleteModal(item) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/tasks/deleteTask/deleteTask.modal.html',
                size : 'md',
                controller : 'DeleteTaskModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {task : function () {
                        return item;
                    }}
            }).result.then(function (taskList) {
                vm.allTasks = taskList;
                vm.totalData = Object.keys(vm.allTasks).length;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to delete department - " + message);
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(7, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('TeamsCtrl', ['$scope','authService','$uibModal','teamService', 'toastrService', TeamsCtrl]);

    /** @ngInject */
    function TeamsCtrl($scope,authService,$uibModal,teamService, toastrService) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.allTeams = [];

        vm.openCreateModal = openCreateModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            getAllTeams();
        }

        function getAllTeams() {
            teamService.getAllTeams(true).then(function (data) {
                vm.allTeams = data;
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            },function (message) {
                toastrService.showErrorToastr('Team Fetching failed error: '+message, "", 5000);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/teams/createTeam/createTeam.modal.html',
                size : 'md',
                controller : 'CreateTeamModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (teamList) {
                vm.allTeams = teamList;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to create project - " + message, "", 5000);
            });
        }

        function openDeleteModal(item) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/projectManagement/teams/deleteTeam/deleteTeam.modal.html',
                size : 'md',
                controller : 'DeleteTeamModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {team : function () {
                        return item;
                    }}
            }).result.then(function (teamList) {
                vm.allTeams = teamList;
            }, function (message) {
                // toastrService.showErrorToastr("Failed to delete team - " + message, "", 5000);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.accessArea')
        .controller('AccessAreaCtrl', ['$scope','accessAreaService','$uibModal', 'toastrService', '_', AccessAreaCtrl]);

    /** @ngInject */
    function AccessAreaCtrl($scope,accessAreaService,$uibModal, toastrService, _) {

        var vm = this;

        vm.accessAreas = null;
        vm.isDataLoaded = false;
        // vm.create = {};
        // vm.create.createLeaveCategoryName = null;
        // vm.leaveCategoryToEdit = null;

        vm.openCreateAccessAreaModal = openCreateAccessAreaModal;
        vm.openDeleteAccessAreaModal = openDeleteAccessAreaModal;
        vm.openUpdateAccessAreaModal = openUpdateAccessAreaModal;

        function init(){
            accessAreaService.getAllAccessAreas().then(onAccessAreaListFetchSuccess, onAccessAreaListFetchFailure)
        }

        init();

        function onAccessAreaListFetchSuccess(accessAreas){
            vm.isDataLoaded = true;
            vm.accessAreas = accessAreas;
            $scope.$broadcast("refreshFixedColumns");
        }

        function onAccessAreaListFetchFailure(error){
            toastrService.showErrorToastr("Error: " + error, "", 5000);
            console.error(error);
        }

        function openCreateAccessAreaModal () {
            toastrService.clearPreviousToastr();
            vm.accessAreaModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/accessArea/accessAreaModals/createAccessArea.modal.html',
                size: 'md',
                controller:'AccessAreaCreateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
            }).result.then(onAccessAreaListFetchSuccess);
        }

        function openDeleteAccessAreaModal (accessArea, index) {
            toastrService.clearPreviousToastr();
            vm.accessAreaModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/accessArea/accessAreaModals/deleteAccessArea.modal.html',
                size: 'md',
                controller:'AccessAreaDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        accessAreaToChange:function () {
                            return accessArea;
                        }
                    }
            }).result.then(function accessAreaDeleteSuccess() {
                vm.accessAreas.splice(index,1);
            });
        }

        function openUpdateAccessAreaModal (accessArea, index) {
            toastrService.clearPreviousToastr();
            vm.accessAreaModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/accessArea/accessAreaModals/updateAccessArea.modal.html',
                size: 'md',
                controller:'AccessAreaUpdateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        accessAreaToChange:function () {
                            return angular.copy(accessArea);
                        }
                    }
            }).result.then(function(accessAreas) {
                vm.accessAreas = accessAreas;
                toastrService.showSuccessToastr("Access area name Updated");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.approvals')
        .controller('ApprovalsCtrl', ['$q', 'employeeService', 'lateApprovalManagementService', 'leaveManagementService', 'authService', '$scope', '$uibModal', 'toastrService', '_', ApprovalsCtrl]);

    /** @ngInject */
    function ApprovalsCtrl($q, employeeService, lateApprovalManagementService, leaveManagementService, authService, $scope, $uibModal, toastrService, _) {
        var vm = this;
        var isSingleLeaveApproverAllowed;
        var isSingleLateApproverAllowed;
        var isSingleManualEntryApproverAllowed;
        vm.isDataLoaded = false;

        if (!vm.isDataLoaded) {
            init().then(function() {
            });
        }

        function init() {
            var deferred = $q.defer();
            if (vm.isDataLoaded === false) {
                $q.all([
                    leaveManagementService.getLeaveApprovalSystem(),
                    lateApprovalManagementService.getLateApprovalSystem(),
                    employeeService.getManualEntryApprovalSystem()
                ]).then(function(responses) {
                    isSingleLeaveApproverAllowed = responses[0];
                    isSingleLateApproverAllowed = responses[1];
                    isSingleManualEntryApproverAllowed = responses[2];
                    vm.boxes = [
                        { title: 'Leave Approval', isSingle: isSingleLeaveApproverAllowed, infoData: "You can configure Approval Process for leave approvals in the Leave Configuration page" },
                        { title: 'Late Approval', isSingle: isSingleLateApproverAllowed },
                        { title: 'Manual Entry Approval', isSingle: isSingleManualEntryApproverAllowed }
                    ];
                    vm.isDataLoaded = true;
                    deferred.resolve();
                }).catch(function(error) {
                    toastrService.showErrorToastr("Error fetching data. Please try again.");
                    deferred.reject(error);
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        vm.onCheckboxChange = function(box) {
            box.isSingle = !box.isSingle;
            if(box.title === 'Leave Approval') {
                leaveManagementService.setLeaveApprovalSystem(box.isSingle)
                    .then(function (response) {
                        toastrService.showSuccessToastr("Approval System updated successfully.");
                    })
                    .catch(function (error) {
                        toastrService.showErrorToastr("Approval System could not be updated. Please try again.");
                    });
            }
            else if(box.title === 'Late Approval') {
                lateApprovalManagementService.setLateApprovalSystem(box.isSingle)
                    .then(function (response) {
                        toastrService.showSuccessToastr("Approval System updated successfully.");
                    })
                    .catch(function (error) {
                        toastrService.showErrorToastr("Approval System could not be updated. Please try again.");
                    });
            }
            else if(box.title === 'Manual Entry Approval') {
                employeeService.setManualEntryApprovalSystem(box.isSingle)
                    .then(function (response) {
                        toastrService.showSuccessToastr("Approval System updated successfully.");
                    })
                    .catch(function (error) {
                        toastrService.showErrorToastr("Approval System could not be updated. Please try again.");
                    });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.departments')
        .controller('DepartmentsCtrl', ['$scope', 'authService','$uibModal','departmentService', 'toastrService', '_', DepartmentsCtrl]);

    /** @ngInject */
    function DepartmentsCtrl($scope, authService,$uibModal,departmentService, toastrService, _) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.allDepartments = [];
        vm.allOffices  =[];
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        
        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            getAllDepartments();
        }

        function getAllDepartments() {
            departmentService.getAllDepartments(true).then(function (data) {
                vm.allDepartments = sortCollectionByName(data);
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            },function (message) {
                console.error('Dept Fetching failed error: '+message);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/departments/createDepartment/createDepartment.modal.html',
                size : 'md',
                controller : 'CreateDepartmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (department) {
                vm.allDepartments.push(department);
            }, function (message) {
                // console.error("Failed to create department - " + message);
            });
        }
        
        function openEditModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/departments/editDepartment/editDepartment.modal.html',
                size : 'md',
                controller : 'EditDepartmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    department : function () {
                        return angular.copy(item);
                }}
            }).result.then(function (department) {
                vm.allDepartments[index] = department;
            }, function (message) {
                // console.error("Failed to update department - " + message);
            });
        }

        function openDeleteModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/departments/deleteDepartment/deleteDepartment.modal.html',
                size : 'md',
                controller : 'DeleteDepartmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {department : function () {
                        return item;
                    }}
            }).result.then(function (department) {
                vm.allDepartments.splice(index,1);
            }, function (message) {
                // console.error("Failed to delete department - " + message);
            });
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.designations')
        .controller('DesignationsCtrl', ['$scope','authService', '$uibModal', 'designationService', 'toastrService',DesignationsCtrl]);

    /** @ngInject */
    function DesignationsCtrl($scope,authService, $uibModal, designationService, toastrService) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.designations = {};
        vm.designations.allDesignations = null;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        vm.maxNumberToLoad = 100;
        vm.searchText="";

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.loadMore = loadMore;

        function loadMore() {
            vm.maxNumberToLoad+=100;
        }

        init();

        function init() {
            designationService.getAllDesignations().then(function onDesignationsFetchSuccess(data) {
                vm.designations.allDesignations = data;
                // vm.designations.allDesignations = _.orderBy(data, ['name'], ['asc']);
                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");
            }, function onDesignationFetchFailure(message) {
                toastrService.showErrorToastr('Failed to fetch all designations : ' + message,'',5000);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/designations/createDesignation/createDesignation.modal.html',
                size: 'md',
                controller: 'CreateDesignationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            }).result.then(function (designation) {
                vm.designations.allDesignations.push(designation);
            }, function (error) {
                // console.error("Designation not created : " + error);
            });
        }

        function openEditModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/designations/editDesignation/editDesignation.modal.html',
                size: 'md',
                controller: 'EditDesignationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    designation: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (designationList) {
                vm.designations.allDesignations[index] = designationList;
            }, function (error) {
                // console.error("Failed to edit designation : " + error);
            });
        }

        function openDeleteModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/designations/deleteDesignation/deleteDesignation.modal.html',
                size: 'md',
                controller: 'DeleteDesignationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    designation: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (designation) {
                vm.designations.allDesignations.splice(index,1);
            }, function (error) {
                // console.error("Failed to delete designation : " + error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.employmentType')
        .controller('EmploymentTypeCtrl',['$scope', 'authService','$uibModal','employmentTypeService','toastrService', EmploymentTypeCtrl]);

    /** @ngInject */
    function EmploymentTypeCtrl($scope, authService,$uibModal,employmentTypeService,toastrService) {

        var vm = this;

        vm.employmentTypeList = [];
        vm.isDataLoaded = false;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            employmentTypeService.getAllEmploymentTypes().then(onEmploymentCategoriesFetchSuccess, onEmploymentCategoriesFetchFailure);
        }

        function onEmploymentCategoriesFetchSuccess(data) {
            vm.employmentTypeList = data;
            vm.isDataLoaded = true;

            $scope.$broadcast("refreshFixedColumns");
        }

        function onEmploymentCategoriesFetchFailure(message) {
            toastrService.showErrorToastr('Failed to fetch employment types : ' + message, '', 5000);
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/employmentType/create/createEmploymentType.modal.html',
                size : 'md',
                controller : 'CreateEmploymentTypeModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (employmentType) {
                vm.employmentTypeList.push(employmentType);
            }, function (error) {
                if(error) console.error("Employment type not created : " + error);
            });
        }

        function openEditModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/employmentType/edit/editEmploymentType.modal.html',
                size : 'md',
                controller : 'EditEmploymentTypeModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {employmentType : function () {
                    return angular.copy(item);
                }}
            }).result.then(function (employmentType) {
                vm.employmentTypeList[index] = employmentType;
            }, function (error) {
                if(error) console.error("Failed to edit employmentType : " + error);
            });
        }

        function openDeleteModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/employmentType/delete/deleteEmploymentType.modal.html',
                size : 'md',
                controller : 'DeleteEmploymentTypeModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {employmentType : function () {
                    return angular.copy(item);
                }}
            }).result.then(function () {
                vm.employmentTypeList.splice(index,1);
            }, function (error) {
                if(error) console.error("Failed to delete designation : " + error);
            });
        }
    }

})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.holidays')
        .controller('HolidayCtrl',['$scope','calendarConfig','holidayService','authService','toastrService','$location','$anchorScroll','$timeout', HolidayCtrl]);

    function HolidayCtrl($scope,calendarConfig,holidayService,authService,toastrService,$location,$anchorScroll,$timeout) {
        var vm = this;

        vm.offDaysString = null;
        vm.off = {} ;
        vm.off.offDaysArray = [];
        vm.calendarView = null;
        vm.viewDate = new Date();
        vm.newEventAdded = false;
        vm.events = [];
        vm.cellIsOpen = false;

        vm.cellModifier = cellModifier;
        vm.goToSection = goToSection;
        vm.toggle = toggle;
        vm.timespanClicked = timespanClicked;

        function init () {

            vm.calendarView = 'month';
            vm.offDaysString = !authService.getAllInformation().weeklyOffDaysPolicy? '0000000':authService.getAllInformation().weeklyOffDaysPolicy.offDays;
            if(!vm.offDaysString )
                vm.offDaysString = '0000000';
            createOffDaysArray();
            getStartDayOfWeek();
            holidayService.getAllHolidays().then(onHolidayFetchSuccess,onHolidayFetchFailure);
        }

        init();

        function createOffDaysArray  () {
            for (var i = 0; i < 7; i++) {
                if (vm.offDaysString.charAt(i) === '1') {
                    vm.off.offDaysArray.push(i);
                }
            }
        }

        function getStartDayOfWeek() {
            var startDayOfWeek = (vm.off.offDaysArray && Array.isArray(vm.off.offDaysArray) && vm.off.offDaysArray.length>0)
                ? ((vm.off.offDaysArray[vm.off.offDaysArray.length-1]+1)%7) : 0;
            moment.locale('en_gb', {
                week : {
                    dow : startDayOfWeek // Monday = 1 is the first day of the week
                }
            });
        }

        function cellModifier(cell) {
            cell.isWeekend = false;
            if(vm.off.offDaysArray.length > 0 && vm.off.offDaysArray.includes(cell.date.day()))
            {
                cell.isWeekend = true;
                cell.cssClass = 'weekly-off-day';
            }
        }

        function onHolidayFetchSuccess (data) {
            $scope.HolidayDaysData = data;
            $scope.$broadcast('holiday-data-loaded', data);
            angular.forEach(data, function (value,key) {
                vm.events.push
                (
                    {
                        id:value.id,
                        title: value.description,
                        startsAt: new Date(value.holidayDate),
                        color: calendarConfig.colorTypes.info,
                        allDay:true
                    }
                );
            });
        }

        function onHolidayFetchFailure (error) {
            toastrService.showErrorToastr("Fetching failed : " + error, '', 5000);
        }

        function goToSection  (data) {
            $timeout(function () {
                $location.hash(data)
                $anchorScroll();
            })
        }

        function toggle ($event, field, event) {
            $event.preventDefault();
            $event.stopPropagation();
            event[field] = !event[field];
        }

        function timespanClicked (date, cell) {
            if (vm.calendarView === 'month') {
                if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = date;
                }
            } else if (vm.calendarView === 'year') {
                if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = date;
                }
            }
        }

        //update local list on new holiday creation
        $scope.$on("calendar-holiday-created", function(event,data){
            formatEventAndAddToCalendar(data);
            toastrService.showSuccessToastr("Event successfully added");
        });

        function formatEventAndAddToCalendar (event) {
            var data = {
                id:event.id,
                title: event.description,
                startsAt: new Date(event.holidayDate),
                color: calendarConfig.colorTypes.info,
                allDay:true
            };
            vm.events.push(data);
        }

        //remove event from local on delete
        $scope.$on("calendar-holiday-deleted", function(event,index){
           vm.events.splice(index,1);
            toastrService.showSuccessToastr("Event deleted");
        });

        //update event on local on update
        $scope.$on('calendar-holiday-updated',function (event,data) {
            var holiday = {
                title: data.data.description,
                startsAt: new Date(data.data.holidayDate),
                color: calendarConfig.colorTypes.info,
                allDay:true
            };
            vm.events[data.index] = holiday;
            toastrService.showSuccessToastr("Holiday update successful")
        });
    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.holidays')
        .controller('HolidayTableCtrl',['$scope','holidayService','toastrService', '$uibModal', HolidayTableCtrl]);

    function HolidayTableCtrl($scope,holidayService, toastrService, $uibModal) {
        var vm = this;

        vm.events = [];
        vm.eventToCreate = null;
        vm.eventToDelete = null;

        vm.openCreateModal = openCreateModal;
        vm.openDeleteModal = openDeleteModal;
        vm.openUpdateModal = openUpdateModal;
        $scope.$on('holiday-data-loaded', function (event, data) {
            onHolidayFetchSuccess(data);
        });
        function init() {
            if ($scope.HolidayDaysData) {
                onHolidayFetchSuccess($scope.HolidayDaysData);
            }
        }

        init();

        function onHolidayFetchSuccess (data) {
            vm.events = data;
            $scope.$broadcast("refreshFixedColumns");
        }

        function onHolidayFetchFailure (error) {
            console.error(error);
        }
        
        function openCreateModal () {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/holidays/holidayModals/createHoliday.modal.html',
                controller: 'HolidayCreateModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            }).result.then(function (data) {
                toastrService.clearPreviousToastr();
                    vm.events.push(data);
                    $scope.$emit("calendar-holiday-created",data);
                });
        }

        function openDeleteModal(event,index) {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/holidays/holidayModals/deleteHoliday.modal.html',
                controller: 'HolidayDeleteModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    holidayToDelete: function () { return event }
                }
            }).result.then(function (event) {
                toastrService.clearPreviousToastr();
                vm.events.splice(index,1);
                $scope.$emit("calendar-holiday-deleted",{event:event,index:index});
            });
        }

        function openUpdateModal(event,index) {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/holidays/holidayModals/updateHoliday.modal.html',
                controller: 'HolidayUpdateModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    holidayToUpdate: function () { return event; }
                }
            }).result.then(function (data) {
                toastrService.clearPreviousToastr();
                vm.events[index] = data;
                $scope.$emit("calendar-holiday-updated",{data:data,index:index});
            });
        }

    }


})();
'use strict';
angular
    .module('mwl.calendar')
    .constant('calendarConfig', {
        allDateFormats: {
            angular: {
                date: {
                    hour: 'ha',
                    day: 'd MMM',
                    month: 'MMMM',
                    weekDay: 'EEEE',
                    time: 'HH:mm',
                    datetime: 'MMM d, h:mm a'
                },
                title: {
                    day: 'EEEE d MMMM, yyyy',
                    week: 'Week {week} of {year}',
                    month: 'MMMM yyyy',
                    year: 'yyyy'
                }
            },
            moment: {
                date: {
                    hour: 'ha',
                    day: 'D MMM',
                    month: 'MMMM',
                    weekDay: 'dddd',
                    time: 'hh:mm a',
                    datetime: 'MMM D, h:mm a'
                },
                title: {
                    day: 'dddd D MMMM, YYYY',
                    week: 'Week {week} of {year}',
                    month: 'MMMM YYYY',
                    year: 'YYYY'
                }
            }
        },
        get dateFormats() {
            return this.allDateFormats[this.dateFormatter].date;
        },
        get titleFormats() {
            return this.allDateFormats[this.dateFormatter].title;
        },
        dateFormatter: 'moment',
        showTimesOnWeekView: false,
        displayAllMonthEvents: false,
        i18nStrings: {
            weekNumber: 'Week {week}'
        },
        templates: {},
        colorTypes: {
            info: {
                primary: '#1e90ff',
                secondary: '#d1e8ff'
            },
            important: {
                primary: '#ad2121',
                secondary: '#fae3e3'
            },
            warning: {
                primary: '#e3bc08',
                secondary: '#fdf1ba'
            },
            inverse: {
                primary: '#1b1b1b',
                secondary: '#c1c1c1'
            },
            special: {
                primary: '#800080',
                secondary: '#ffe6ff'
            },
            success: {
                primary: '#006400',
                secondary: '#caffca'
            }
        }
    });
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.notification')
        .controller('NotificationCtrl', ['$scope', 'authService', 'utilService', "notificationGroups", 'notificationService', '$uibModal', 'toastrService', 'notificationSettingsMap', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', 'subsidiaryService', '$timeout', NotificationCtrl]);

    /** @ngInject */
    function NotificationCtrl($scope, authService, utilService, notificationGroups, notificationService, $uibModal, toastrService, notificationSettingsMap, analyticsService, ANALYTICS_CONSTANT, MODULES, subsidiaryService, $timeout) {

        var vm = this;
        vm.selectSomething = [];
        vm.isDataLoaded = false;
        vm.isEmployeeLoadedByNotifiGroup = false
        vm.isAnyRowSelected = false;
        vm.selectedRow = null;
        vm.selectedTab = 'all-employee';
        vm.removeFilter = false;
        vm.selectedEmployee = {};
        vm.selectedEmployeeNotificationSettingsList = [];
        vm.notificationGroups = angular.copy(notificationGroups);
        if (!utilService.hasPermission('9008')) {
            vm.notificationGroups = vm.notificationGroups.filter(function (group) {
                return group.value !== 300; // 300 = First Punch of This Day Notification
            });
        }
        vm.notificationEdit = false
        vm.notificationSettingsList = []
        vm.isNotificationGroupRowSelected = false;
        vm.selectedNotificationGroup = [];
        vm.selectedEmployeeNameList = [];
        vm.selectedNotificationGroupValue = null
        vm.searchKeyword = null;
        vm.notificationGroupSearchKey = null
        vm.selectedPage = 0;
        vm.lastIndex = 10;
        vm.allSelected = false;
        vm.isSettingNotification = false;
        vm.setNotificationForAllEmployeeBtnClicked = false;
        vm.setNotificationForSelectedEmployeeBtnClicked = false;
        vm.isAnyEmployeeSelected = false;
        vm.selectNotificationStatus = [{ type: "All" }, { type: "Active" }, { type: "Inactive" }];
        vm.whenToCheckAbsent = null;
        vm.whenToCheckEarlyExit = null;
        vm.whenToCheckAbsentDropdown = [{ name: 'At Start', value: 'at_start' }, { name: '30 min before start', value: '30_min_before_start' }, { name: '30 min after start', value: '30_min_after_start' }, { name: 'At End', value: 'at_end' }]
        vm.whenToCheckEarlyExitDropdown = [{ name: 'At Shift End', value: 'at_shift_end' }];
        vm.selectedNotificationStatus = 'All'

        vm.showDummyModel = true;
        vm.employeeListForNotificationGroupTab = []
        vm.notificationGroupTableHeaderMessage = ""

        vm.showSetNotificationMsg = false;
        vm.showSetNotificationPageInRightSide = false;
        vm.activeSetNotificationBtn = false;
        vm.activeSetNotificationForAllBtn = true;
        vm.notificationSettingsMap = angular.copy(notificationSettingsMap);

        var loggedInUser = authService.getLoggedInUser();

        // Subsidiary module flags
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSuperAdmin = loggedInUser.isAdmin && !vm.isSubsidiaryModuleEnabled;
        vm.isSubsidiaryAdmin = loggedInUser.isAdmin && vm.isSubsidiaryModuleEnabled && loggedInUser.subsidiaryId != null;
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;


        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker: {
                show: false,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker: {
                show: false
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            subsidiaryFilter: {
                show: vm.subsidiaryView
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter: {
                show: true,
                collapsible: true
            },
            deviceFilter: {
                show: false
            },
            leaveCategoryFilter: {
                show: false
            },
            pdfDownloadButton: {
                show: false,
                multipleOrientation: false
            },
            excelDownloadButton: {
                show: false
            },
            sortKey: {
                show: false
            },
            rowsPerPage: { hide: true },
            searchName: { hide: true }

        };
        var selfCheckBoxes = []
        var lineManagerCheckBoxes = []
        var hrCheckBoxes = []

        vm.search = search;
        vm.searchNotificationGroup = searchNotificationGroup;
        vm.changeTab = changeTab;
        vm.showNotificationInfoInTheRightColumn = showNotificationInfoInTheRightColumn;
        vm.showNotificationGroupDetailsInTheRightColumn = showNotificationGroupDetailsInTheRightColumn;
        vm.getDetailsOfSearchedEmployee = getDetailsOfSearchedEmployee;
        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.optionToggled = optionToggled;
        vm.setNotificationForAllEmployee = setNotificationForAllEmployee;
        vm.setNotificationForSelectedEmployee = setNotificationForSelectedEmployee;
        vm.getSettingsValue = getSettingsValue
        vm.searchNotificationGroupByNameAndId = searchNotificationGroupByNameAndId
        vm.turnOffNotificationEmployeeIdAndNotificationGroup = turnOffNotificationEmployeeIdAndNotificationGroup
        vm.saveNotificationSettings = saveNotificationSettings;
        vm.cancelNotificationSetting = cancelNotificationSetting;
        vm.updateNotificationSettingsBatchByEmployeeId = updateNotificationSettingsBatchByEmployeeId
        vm.resetAllCheckedItem = resetAllCheckedItem
        vm.openConfiramtionModal = openConfirmationModal;
        function init() {
            utilService.setRowsPerPage(10);
            resetAllCheckedItem()
        }

        init();

        vm.rowsPerPage = utilService.getRowsPerPage();

        function resetAllCheckedItem() {
            selfCheckBoxes = [
                { valueIndex: 1, id: 'selfSmsCheckBox', labelText: 'employeeActions.notification.typeSMS', value: false },
                {
                    valueIndex: 2,
                    id: 'selfEmailCheckBox',
                    labelText: 'employeeActions.notification.typeEmail',
                    value: false
                },
                {
                    valueIndex: 3,
                    id: 'selfPushCheckbox',
                    labelText: 'employeeActions.notification.typePush',
                    value: false
                },
            ];
            lineManagerCheckBoxes = [
                { valueIndex: 1, id: 'lmSMSCheckbox', labelText: 'employeeActions.notification.typeSMS', value: false },
                {
                    valueIndex: 2,
                    id: 'lmEmailCheckBox',
                    labelText: 'employeeActions.notification.typeEmail',
                    value: false
                },
                { valueIndex: 3, id: 'lmPushCheckbox', labelText: 'employeeActions.notification.typePush', value: false },
            ];
            hrCheckBoxes = [
                { valueIndex: 1, id: 'hrSMSCheckbox', labelText: 'employeeActions.notification.typeSMS', value: false },
                {
                    valueIndex: 2,
                    id: 'hrEmailCheckBox',
                    labelText: 'employeeActions.notification.typeEmail',
                    value: false
                },
                { valueIndex: 3, id: 'hrPushCheckbox', labelText: 'employeeActions.notification.typePush', value: false },
            ];
            vm.selfCheckBoxes = selfCheckBoxes;
            vm.lineManagerCheckBoxes = lineManagerCheckBoxes;
            vm.hrCheckBoxes = hrCheckBoxes;
        }

        function showNotificationInfoInTheRightColumn(index, employeeId) {
            resetAllSelectedValue()
            vm.selectedEmployeeNameList = [];
            vm.showSetNotificationMsg = false;
            vm.showSetNotificationPageInRightSide = false;
            vm.isAnyRowSelected = true;
            vm.selectedRow = index;
            vm.showDummyModel = false;
            vm.selectedEmployee = vm.employeeList[index]
            vm.isNotificationLoaded = false
            notificationService.getAllNotificationSettingsByEmployeeIdAndNotificationsGroup(employeeId, [100, 300, 400, 900]).then(function (response) {
                vm.notificationSettingsList = response.notificationSettingsResponseList
                checkedNotificationForSelectedEmployee(vm.notificationSettingsList)
                vm.isNotificationLoaded = true
            }, function (error) {
                vm.isNotificationLoaded = true
                toastrService.showErrorToastr(error);
            })
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.searchParams.notificationStatus = vm.selectedNotificationStatus;
            vm.searchParams.perPage = 10;

            // If subsidiary admin, automatically include subsidiaryId
            if (vm.isSubsidiaryAdmin && loggedInUser.subsidiaryId) {
                vm.searchParams.subsidiaryId = [loggedInUser.subsidiaryId];
                console.log("Notification - Subsidiary Admin: Auto-setting subsidiaryId to", vm.searchParams.subsidiaryId);
            }

            console.log("Notification - Search params:", vm.searchParams);

            notificationService.getEmployeeListByFilter(vm.searchParams).then(function (data) {
                vm.employeeList = data.employees;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = vm.searchParams.pageNumber
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function checkedNotificationForSelectedEmployee(notificationSettingsList) {
            vm.selectedEmployeeNotificationSettingsList = []
            notificationGroups.filter(function (v) {
                // Filter out group 300 (First Punch) if module 9008 is not available
                if (!utilService.hasPermission('9008') && v.value === 300) {
                    return false;
                }
                return v.disabled === false
            }).forEach(function (notificationGroup) {
                var notificationSettings = notificationSettingsList.find(function (v) {
                    return (v.notificationGroup === notificationGroup.value)
                })
                resetAllCheckedItem()
                if (notificationSettings !== undefined) {
                    var notificationTypes = JSON.parse(notificationSettings.notificationTypes)
                    var selfCheckedItems = notificationTypes[1];
                    selfCheckedItems.map(function (v, i) {
                        selfCheckBoxes[v - 1].value = true
                    })
                    var lineManagerCheckedItems = notificationTypes[2];
                    lineManagerCheckedItems.map(function (v, i) {
                        lineManagerCheckBoxes[v - 1].value = true
                    })
                    var hrCheckedItems = notificationTypes[3];
                    hrCheckedItems.map(function (v, i) {
                        hrCheckBoxes[v - 1].value = true
                    })
                    vm.selectedEmployeeNotificationSettingsList.push({
                        name: notificationGroup.name,
                        notificationGroup: notificationGroup.value,
                        on: true,
                        selfCheckBoxes: selfCheckBoxes,
                        lineManagerCheckBoxes: lineManagerCheckBoxes,
                        hrCheckBoxes: hrCheckBoxes,
                        notificationConfiguration: makeNotificationConfigString(JSON.parse(notificationSettings.settings)),
                        settingsValue: getSelectedEmployeeSettingsValue(JSON.parse(notificationSettings.settings))
                    })
                } else {
                    vm.selectedEmployeeNotificationSettingsList.push({
                        name: notificationGroup.name,
                        notificationGroup: notificationGroup.value,
                        on: false,
                        selfCheckBoxes: selfCheckBoxes,
                        lineManagerCheckBoxes: lineManagerCheckBoxes,
                        hrCheckBoxes: hrCheckBoxes,
                        notificationConfiguration: "",
                        settingsValue: null
                    })
                }

            })


        }

        function makeNotificationConfigString(settings) {
            if (settings === null) return ""
            var keys = Object.keys(settings)
            var string = ''
            keys.forEach(function (key, i) {
                var settingsText = vm.notificationSettingsMap[key]
                var settingsValue = vm.notificationSettingsMap[settings[key]] ? vm.notificationSettingsMap[settings[key]] : settings[key]

                // string += key + " - " + settings[key]
                string += settingsText + " - " + settingsValue

                if (i !== keys.length - 1)
                    string += ", "
            }
            )
            return string
        }

        function getSelectedEmployeeSettingsValue(settings) {
            if (settings === null) return {
                value: ""
            }
            var keys = Object.keys(settings)
            if (keys[0] === "min_before_shift_start") {
                return Number(settings[keys[0]])
            }
            return {
                value: settings[keys[0]]
            }
        }

        function updateNotificationSettingsBatchByEmployeeId() {
            var data = []

            /*   if (!isRecipientSelectedForIndividualEmployee(vm.selectedEmployeeNotificationSettingsList)) {
                   return toastrService.showErrorToastr("Please select recipient");
               }*/
            var error = false
            vm.selectedEmployeeNotificationSettingsList.forEach(function (v) {
                var setting = addExtraNotificationSettingsToPostDataForIndividualEmployee(v.notificationGroup, v.settingsValue, v.on)
                if (typeof setting === "undefined" && v.on) {
                    error = true;
                    return;
                }
                data.push({
                    notificationGroup: v.notificationGroup,
                    off: !v.on,
                    notificationTypes: {
                        1: getNotificationValuesFromModels(v.selfCheckBoxes),
                        2: getNotificationValuesFromModels(v.lineManagerCheckBoxes),
                        3: getNotificationValuesFromModels(v.hrCheckBoxes)
                    },
                    settings: setting
                })

            })
            if (!error) {
                notificationService.updateBatchNotificationSettingsByEmployeeId(data, vm.selectedEmployee.id).then(function (response) {

                    vm.notificationEdit = false;
                    showNotificationInfoInTheRightColumn(vm.selectedRow, vm.selectedEmployee.id)
                    search()
                    if (response.errorList.length > 0) {
                        response.errorList;
                        toastrService.clearPreviousToastr();
                        openErrorModal(response.errorList);
                    }
                    else
                        toastrService.showSuccessToastr("Notification Settings updated");
                }, function (e) {
                    return toastrService.showErrorToastr("Failed to update notification settings - " + e, "", 5000);
                })
            }

        }

        function changeTab(selectedTab) {
            resetAllSelectedValue()
            vm.selectedTab = selectedTab;
            if (selectedTab === 'all-employee')
                search();
            if (vm.selectedTab === 'notification-group') {
                vm.removeFilter = true;
                searchNotificationGroup()
            } else vm.removeFilter = false;
        }

        function resetAllSelectedValue() {
            vm.showSetNotificationMsg = false;
            vm.showSetNotificationPageInRightSide = false;
            vm.selectedPage = 0;
            vm.isAnyRowSelected = false;
            vm.selectedRow = null;
            vm.showDummyModel = true;
            vm.allSelected = false;
            vm.employeeList.forEach(function (employee) {
                employee.isSelected = false;
            });
            vm.isSettingNotification = false;
            vm.setNotificationForAllEmployeeBtnClicked = false;
            vm.setNotificationForSelectedEmployeeBtnClicked = false;
            vm.notificationEdit = false
        }


        function showNotificationGroupDetailsInTheRightColumn(index, notificationGroup) {
            resetAllCheckedItem()
            vm.selectedNotificationGroupValue = notificationGroup
            vm.isAnyRowSelected = true;
            vm.selectedRow = index;
            vm.showDummyModel = false;
            vm.isEmployeeLoadedByNotifiGroup = false

            // Set column header based on notification group
            if (notificationGroup === 100) {
                vm.notificationGroupTableHeaderMessage = 'Minutes Before Shift'
            } else if (notificationGroup === 400) {
                vm.notificationGroupTableHeaderMessage = 'When to Check Absent'
            } else if (notificationGroup === 900) {
                vm.notificationGroupTableHeaderMessage = 'When to Check Early Exit'
            } else {
                vm.notificationGroupTableHeaderMessage = 'Status'
            }

            notificationService.getEmpployeeListByNotificationGroup(notificationGroup).then(function (response) {
                vm.employeeListForNotificationGroupTab = response.employees
                vm.employeeListForNotificationGroupTabForSearch = response.employees
                vm.isEmployeeLoadedByNotifiGroup = true

                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                toastrService.showErrorToastr(error);
            })
        }

        function searchNotificationGroup(searchParams) {
            vm.isDataLoaded = false;
            nextPage(searchParams);
            var groupList = angular.copy(vm.notificationGroups);
            notificationService.getNotificationSummary().then(function (response) {
                groupList.forEach(function (v, i) {
                    var totalEmployee = response.notificationGroupTotalEmployeeMap[v.value]
                    if (totalEmployee !== undefined) {
                        groupList[i].totalEmployee = totalEmployee;
                    } else groupList[i].totalEmployee = '-'
                })
            }, function (error) {
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            })
            vm.firstIndex = vm.rowsPerPage * vm.selectedPage
            vm.notificationGroupList = groupList.slice(vm.firstIndex, vm.firstIndex + vm.rowsPerPage);
            vm.notificationGroupListForSearch = angular.copy(vm.notificationGroupList)
            vm.isDataLoaded = true;
            vm.numberOfPages = Math.ceil(groupList.length / vm.rowsPerPage);
            vm.total = groupList.length;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }

        function searchNotificationGroupByNameAndId() {
            vm.notificationGroupList = vm.notificationGroupListForSearch.filter(function (v) {
                return v.name.toLocaleLowerCase().match(vm.notificationGroupSearchKey.toLocaleLowerCase()) !== null ||
                    String(v.value).toLocaleLowerCase().match(vm.notificationGroupSearchKey.toLocaleLowerCase()) !== null
            })
        }

        function getSettingsValue(settings) {
            // For notification groups that don't require settings (like First Punch - 300)
            // show 'Enabled' instead of 'Not Set'
            var groupsWithoutSettings = [200, 300, 500, 501, 502, 600, 601, 602, 700, 701, 702, 800, 801, 802];

            if (settings == null || settings === undefined || settings === '') {
                // Check if current group requires settings
                if (groupsWithoutSettings.indexOf(vm.selectedNotificationGroupValue) !== -1) {
                    return 'Enabled'
                }
                return 'Not Set'
            }
            try {
                var settingsObject = JSON.parse(settings)
                var keys = Object.keys(settingsObject)
                if (keys.length === 0) {
                    if (groupsWithoutSettings.indexOf(vm.selectedNotificationGroupValue) !== -1) {
                        return 'Enabled'
                    }
                    return 'Not Set'
                }
                var string = vm.notificationSettingsMap[settingsObject[keys[0]]] ? vm.notificationSettingsMap[settingsObject[keys[0]]] : settingsObject[keys[0]]
                return string
            } catch (e) {
                if (groupsWithoutSettings.indexOf(vm.selectedNotificationGroupValue) !== -1) {
                    return 'Enabled'
                }
                return 'Not Set'
            }
        }

        function nextPage(searchParams) {
            if (searchParams == 'prev') {
                vm.selectedPage--;
            } else if (searchParams == 'next') {
                vm.selectedPage++;
            } else if (!isNaN(searchParams)) {
                vm.selectedPage = searchParams;
            }
        }

        function getDetailsOfSearchedEmployee() {
            vm.employeeListForNotificationGroupTab = vm.employeeListForNotificationGroupTabForSearch.filter(function (v) {
                return v.name.toLocaleLowerCase().match(vm.searchKeyword.toLocaleLowerCase()) !== null ||
                    v.employeeOfficeId.toLocaleLowerCase().match(vm.searchKeyword.toLocaleLowerCase()) !== null
            })
        }

        function checkOrUncheckAll() {
            vm.isAnyRowSelected = false;
            vm.selectedEmployeeNameList = [];
            vm.selectedEmployeeIds = []
            vm.activeSetNotificationBtn = false;
            if (vm.allSelected === false) {
                vm.showSetNotificationPageInRightSide = false;
                vm.employeeList.forEach(function (employee) {
                    employee.isSelected = false;
                    vm.setNotificationForAllEmployeeBtnClicked = false;
                    vm.showDummyModel = true;
                });
            } else {
                analyticsService.sendData(ANALYTICS_CONSTANT.selectAllUrl, document.title + ' - Select All', '', 'Select All In' + document.title, ANALYTICS_CONSTANT.selectAllTitle);
                vm.employeeList.forEach(function (employee) {
                    employee.isSelected = true;
                    vm.showDummyModel = false;
                    vm.showSetNotificationMsg = false;
                    vm.selectedEmployeeIds.push(employee.id)
                    vm.selectedEmployeeNameList.push(employee.name)
                    vm.setNotificationForAllEmployeeBtnClicked = true;
                    vm.showSetNotificationPageInRightSide = true;
                });
            }
        }

        function optionToggled() {
            vm.isAnyRowSelected = false;
            vm.setNotificationForAllEmployeeBtnClicked = false;
            vm.showSetNotificationPageInRightSide = false;
            vm.activeSetNotificationBtn = true;
            vm.allSelected = isAllEmployeeSelected();
            if (vm.allSelected) {
                vm.activeSetNotificationBtn = false;
                vm.showSetNotificationPageInRightSide = true
                vm.showSetNotificationMsg = false;
                vm.setNotificationForAllEmployeeBtnClicked = true;
                vm.setNotificationForSelectedEmployeeBtnClicked = false
            }

            checkIfAnySelected();
        }

        function isAllEmployeeSelected() {
            return vm.employeeList.every(function (employee) {
                return employee.isSelected === true;
            });
        }

        function checkIfAnySelected() {
            vm.selectedEmployeeNameList = [];
            vm.isAnyEmployeeSelected = false;
            vm.showDummyModel = true;
            vm.showSetNotificationMsg = false;
            vm.activeSetNotificationBtn = false;
            for (var i = 0; i < vm.employeeList.length; i++) {
                if (vm.employeeList[i].isSelected) {
                    vm.isAnyEmployeeSelected = true;
                    vm.showSetNotificationMsg = true;
                    vm.activeSetNotificationBtn = true
                    vm.showDummyModel = false;
                    vm.selectedEmployeeNameList.push(vm.employeeList[i].name)
                }
            }

        }

        function setNotificationForAllEmployee() {
            analyticsService.sendData(ANALYTICS_CONSTANT.notificationForAll, document.title + ' - Notification For All', '', 'Notification For All In' + document.title, ANALYTICS_CONSTANT.notificationForAll);
            vm.notificationGroups = angular.copy(notificationGroups);
            if (!utilService.hasPermission('9008')) {
                vm.notificationGroups = vm.notificationGroups.filter(function (group) {
                    return group.value !== 300; // 300 = First Punch of This Day Notification
                });
            }
            vm.isAnyRowSelected = false;
            vm.activeSetNotificationBtn = false;
            vm.showSetNotificationMsg = false;
            vm.showSetNotificationPageInRightSide = true;
            vm.isAnyRowSelected = false
            vm.allSelected = true;
            vm.employeeList.forEach(function (employee) {
                employee.isSelected = true;
            });
            vm.showDummyModel = false;
            vm.isSettingNotification = true;
            vm.setNotificationForAllEmployeeBtnClicked = true;
            filterEmployees();
        }

        function setNotificationForSelectedEmployee() {
            vm.notificationGroups = angular.copy(notificationGroups);
            if (!utilService.hasPermission('9008')) {
                vm.notificationGroups = vm.notificationGroups.filter(function (group) {
                    return group.value !== 300;
                });
            }
            vm.selectedNotificationGroup = [];
            resetAllCheckedItem()
            vm.activeSetNotificationBtn = false;
            vm.showSetNotificationMsg = false;
            vm.showSetNotificationPageInRightSide = true;
            vm.isAnyRowSelected = false
            vm.isSettingNotification = true;
            vm.setNotificationForSelectedEmployeeBtnClicked = true;
            filterEmployees();
        }

        function filterEmployees() {
            vm.selectedEmployeeNameList = [];
            vm.selectedEmployeeIds = [];
            vm.employeeList.forEach(function (emp) {
                if (emp.isSelected) {
                    vm.selectedEmployeeIds.push(emp.id)
                    vm.selectedEmployeeNameList.push(emp.name)
                }
            })
        }
        function openConfirmationModal(employeeId, employeeName) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/notification/confirmationModal/confirmationModal.html',
                size: 'md',
                controller: 'NotificationConfirmationModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve:
                {
                    employeeName: function () {
                        return employeeName;
                    }
                }
            }).result.then(function () {
                turnOffNotificationEmployeeIdAndNotificationGroup(employeeId);
            });
        }
        function turnOffNotificationEmployeeIdAndNotificationGroup(employeeId) {
            //openConfirmationModal(employeeName);
            var data = {
                employeeIdList: [employeeId],
                notificationGroup: vm.selectedNotificationGroupValue,
                off: true
            }
            notificationService.updateBatchNotificationSettings(data).then(function () {
                vm.employeeListForNotificationGroupTab = vm.employeeListForNotificationGroupTab.filter(function (v) {
                    return v.id !== employeeId
                })
                vm.employeeListForNotificationGroupTabForSearch = angular.copy(vm.employeeListForNotificationGroupTab)
                searchNotificationGroup()
                return toastrService.showSuccessToastr("Turn off Notification Successful.");
            }, function (e) {
                return toastrService.showErrorToastr("Failed to turn of notification for: " + e, "", 5000);
            })
        }

        function saveNotificationSettings() {
            analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save Notification Settings', '', 'Save Notification Settings In' + document.title, ANALYTICS_CONSTANT.save);
            toastrService.clearPreviousToastr();
            var data = {};
            data = {
                employeeIdList: vm.selectedEmployeeIds,
                notificationGroup: vm.selectedNotificationGroup[0].value,
                notificationTypes: {
                    1: getNotificationValuesFromModels(vm.selfCheckBoxes),
                    2: getNotificationValuesFromModels(vm.lineManagerCheckBoxes),
                    3: getNotificationValuesFromModels(vm.hrCheckBoxes)
                },
                settings: {},
                off: false,
                allEmployeeSelected: vm.allSelected,
                isRecipientSelected: isRecipientSelected()
            };

            if (doesThisNotificationGroupNeedConfiguration()) {
                addExtraNotificationSettingsToPostData(data)
                if (_.isEmpty(data.settings) && isRecipientSelected()) return;
            }
            // if (!isRecipientSelected()) {
            //     return toastrService.showErrorToastr("Please select recipient");
            // }
            vm.isDataSaving = true
            notificationService.updateBatchNotificationSettings(data).then(function (response) {
                vm.isDataEdited = false
                vm.isDataSaving = false
                vm.officeTimeNotifyBeforeStartTime = null
                vm.whenToCheckAbsent = null;
                vm.whenToCheckEarlyExit = null;
                if (response.errorList.length > 0) {
                    toastrService.clearPreviousToastr();
                    openErrorModal(response.errorList);
                }
                else
                    toastrService.showSuccessToastr("Notification Settings updated");
            }, function (e) {
                vm.isDataEdited = false
                vm.isDataSaving = false
                return toastrService.showErrorToastr("Failed to update notification settings - " + e, "", 5000);
            })
        }

        function getNotificationValuesFromModels(modelArray) {
            return modelArray.filter(function (m) {
                return m.value;
            }).map(function (m) {
                return m.valueIndex;
            });
        }

        function doesThisNotificationGroupNeedConfiguration() {
            if (!isRecipientSelected()) return false;
            if (vm.selectedNotificationGroup && vm.selectedNotificationGroup.length > 0) {
                if (vm.selectedNotificationGroup[0].value === 100 || vm.selectedNotificationGroup[0].value === 400 || vm.selectedNotificationGroup[0].value === 900) return true;
            }
            return false;
        }

        function addExtraNotificationSettingsToPostData(data) {
            toastrService.clearPreviousToastr();
            if (data.notificationGroup == 100) {
                if (vm.officeTimeNotifyBeforeStartTime == null) {
                    return toastrService.showErrorToastr("Please set how many minutes before shift time")
                }
                if (vm.officeTimeNotifyBeforeStartTime < 0 || vm.officeTimeNotifyBeforeStartTime > 59)
                    return toastrService.showErrorToastr("Notification time must be between 1 and 59 minutes");
                data.settings = {
                    'min_before_shift_start': vm.officeTimeNotifyBeforeStartTime
                }
            }
            if (data.notificationGroup == 400) {
                if (vm.whenToCheckAbsent == null) {
                    return toastrService.showErrorToastr('Please select when to check absent setting from dropdown.');
                }
                data.settings = {
                    'when_to_check_absent': vm.whenToCheckAbsent.value
                }
            }
            if (data.notificationGroup == 900) {
                if (vm.whenToCheckEarlyExit == null) {
                    return toastrService.showErrorToastr('Please select when to check early exit from dropdown')
                }
                data.settings = {
                    'when_to_check_early_exit': vm.whenToCheckEarlyExit.value
                }
            }
            return data;
        }

        function addExtraNotificationSettingsToPostDataForIndividualEmployee(notificationGroup, settingsValue, on) {
            // toastrService.clearPreviousToastr();

            if (on) {
                if (notificationGroup === 100) {
                    if (settingsValue == null) {
                        toastrService.showErrorToastr("Please set how many minutes before shift time", "", 5000)
                        return
                    }
                    if (settingsValue < 0 || settingsValue > 59) {
                        toastrService.showErrorToastr("Notification time must be between 1 and 59 minutes");
                        return
                    }

                    return {
                        'min_before_shift_start': settingsValue
                    }
                }
                if (notificationGroup === 400) {
                    if (settingsValue == null) {
                        toastrService.showErrorToastr('Please select when to check absent setting from dropdown.');
                        return
                    }
                    return {
                        'when_to_check_absent': settingsValue.value
                    }
                }
                if (notificationGroup === 900) {
                    if (settingsValue == null) {
                        toastrService.showErrorToastr('Please select when to check early exit from dropdown')
                        return
                    }
                    return {
                        'when_to_check_early_exit': settingsValue.value
                    }
                }
                return {};
            }

        }

        function isRecipientSelected() {
            var isNotSelected = function (o) {
                return o.value == false;
            }
            if (vm.selfCheckBoxes.every(isNotSelected) && vm.lineManagerCheckBoxes.every(isNotSelected) && vm.hrCheckBoxes.every(isNotSelected)) {
                return false;
            }
            return true;
        }

        function isRecipientSelectedForIndividualEmployee(data) {
            var isNotSelected = function (o) {
                return o.value == false;
            }
            data.forEach(function (v) {
                if (v.selfCheckBoxes.every(isNotSelected) && v.lineManagerCheckBoxes.every(isNotSelected) && v.hrCheckBoxes.every(isNotSelected)) {
                    return false;
                }
                return true;
            })

        }

        function cancelNotificationSetting() {
            vm.allSelected = false;
            vm.employeeList.forEach(function (employee) {
                employee.isSelected = false;
            });
            vm.showDummyModel = true;
            vm.isSettingNotification = false;
            vm.setNotificationForAllEmployeeBtnClicked = false;
            vm.setNotificationForSelectedEmployeeBtnClicked = false;
        }

        function openErrorModal(errorList) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/notification/errorModal/errorModal.html',
                size: 'md',
                controller: 'ErrorModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    errorList: function () {
                        return errorList;
                    }
                }
            });
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.shifts')
        .controller('ShiftCtrl', ['authService','$uibModal','shiftService','toastr',ShiftCtrl]);

    /** @ngInject */
    function ShiftCtrl(authService,$uibModal,shiftService,toastr) {
        var vm = this;

        vm.allShifts = null;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        function init() {
            shiftService.getShiftList(true).then(function (shiftList) {
                vm.allShifts = shiftList;
            },function (message) {
                console.error('Fetching failed error: '+ message);
            });
        }

        init();

        function openCreateModal() {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/shifts/create/createShift.modal.html',
                size: 'lg',
                controller:'ShiftCreateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
            }).result.then(function (shiftList) {
                vm.allShifts = shiftList;
                toastr.success("Shift created");
            });
        }

        function openEditModal(item) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/shifts/edit/editShift.modal.html',
                size: 'lg',
                controller:'ShiftEditModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    shiftToEdit: function () {
                        return item;
                    }
                }
            }).result.then(function (shiftList) {
                vm.allShifts = shiftList;
                toastr.success("Shift edited");
            });
        }

        function openDeleteModal(item) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/shifts/delete/deleteShift.modal.html',
                size: 'lg',
                controller:'ShiftDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    shiftToDelete: function () {
                        return item;
                    }
                }
            }).result.then(function (shiftList) {
                vm.allShifts = shiftList;
                toastr.success("Shift deleted");
            });
        }

    }

})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.specialDays')
        .controller('SpecialDayCtrl', ['$scope', 'calendarConfig', 'specialDayService', 'authService', 'toastrService', '$location', '$anchorScroll', '$timeout', SpecialDayCtrl]);

    function SpecialDayCtrl($scope, calendarConfig, specialDayService, authService, toastrService, $location, $anchorScroll, $timeout) {
        var vm = this;

        vm.offDaysString = null;
        vm.off = {};
        vm.off.offDaysArray = [];
        vm.calendarView = 'month';
        vm.viewDate = new Date();
        vm.newEventAdded = false;
        vm.events = [];
        vm.cellIsOpen = false;

        vm.cellModifier = cellModifier;
        vm.goToSection = goToSection;
        vm.toggle = toggle;
        vm.timespanClicked = timespanClicked;

        function init() {
            vm.offDaysString = !authService.getAllInformation().weeklyOffDaysPolicy ? '0000000' : authService.getAllInformation().weeklyOffDaysPolicy.offDays;
            if (!vm.offDaysString) vm.offDaysString = '0000000';
            createOffDaysArray();
            getStartDayOfWeek();
            fetchSpecialDays(); // Fetch the special days initially
        }

        function fetchSpecialDays() {
            specialDayService.getAllSpecialDays().then(onSpecialDayFetchSuccess, onSpecialDayFetchFailure);
        }

        function createOffDaysArray() {
            for (var i = 0; i < 7; i++) {
                if (vm.offDaysString.charAt(i) === '1') {
                    vm.off.offDaysArray.push(i);
                }
            }
        }

        function getStartDayOfWeek() {
            var startDayOfWeek = (vm.off.offDaysArray && Array.isArray(vm.off.offDaysArray) && vm.off.offDaysArray.length > 0)
                ? ((vm.off.offDaysArray[vm.off.offDaysArray.length - 1] + 1) % 7) : 0;
            moment.locale('en_gb', {
                week: {
                    dow: startDayOfWeek // Monday = 1 is the first day of the week
                }
            });
        }

        function cellModifier(cell) {
            cell.isWeekend = false;
            if (vm.off.offDaysArray.length > 0 && vm.off.offDaysArray.includes(cell.date.day())) {
                cell.isWeekend = true;
                cell.cssClass = 'weekly-off-day';
            }
        }

        function onSpecialDayFetchSuccess(data) {
            if (!Array.isArray(data)) {
                // Handle cases where only a single special day object is passed
                data = [data];
            }
            $scope.specialDaysData = data;
            $scope.$broadcast('special-days-updated', data);

            vm.events = []; // Clear existing events

            angular.forEach(data, function (value) {
                vm.events.push({
                    id: value.specialDay.id,
                    title: value.specialDay.title,
                    startsAt: new Date(value.specialDay.startDate),
                    endsAt: value.specialDay.endDate ? new Date(value.specialDay.endDate) : new Date(value.specialDay.startDate),
                    color: calendarConfig.colorTypes.special, // Set the special day color
                    allDay: true
                });
            });
        }

        function onSpecialDayFetchFailure(error) {
            toastrService.showErrorToastr("Fetching failed: " + error, '', 5000);
        }

        function goToSection(data) {
            $timeout(function () {
                $location.hash(data);
                $anchorScroll();
            });
        }

        function toggle($event, field, event) {
            $event.preventDefault();
            $event.stopPropagation();
            event[field] = !event[field];
        }

        function timespanClicked(date, cell) {
            if (vm.calendarView === 'month') {
                if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = date;
                }
            } else if (vm.calendarView === 'year') {
                if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = date;
                }
            }
        }

        // Update local list on new special day creation
        $scope.$on("calendar-special-day-created", function () {
            fetchSpecialDays();
            toastrService.showSuccessToastr("Special Day successfully created");
        });

        // Remove event from local on delete
        $scope.$on("calendar-special-day-deleted", function () {
            fetchSpecialDays();
            toastrService.showSuccessToastr("Special Day successfully deleted");
        });

        // Update event locally on update
        $scope.$on('calendar-special-day-updated', function () {
            fetchSpecialDays();
            toastrService.showSuccessToastr("Special Day successfully updated");
        });

        init();
    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.specialDays')
        .controller('SpecialDayTableCtrl', ['$scope', 'specialDayService', 'toastrService', '$uibModal', SpecialDayTableCtrl]);

    function SpecialDayTableCtrl($scope, specialDayService, toastrService, $uibModal) {
        var vm = this;

        vm.events = [];
        vm.eventToCreate = null;
        vm.eventToDelete = null;

        // Functions bound to the controller
        vm.openCreateModal = openCreateModal;
        vm.openDeleteModal = openDeleteModal;
        vm.openUpdateModal = openUpdateModal;
        vm.toggleExpand = toggleExpand;

        $scope.$on('special-days-updated', function (event, data) {
            onSpecialDayFetchSuccess(data);
        });

        // Initialize the controller by loading special days
        function init() {

            if ($scope.specialDaysData) {
                onSpecialDayFetchSuccess($scope.specialDaysData);
            }
        }

        init();

        // Fetch all special days from the service
        function loadSpecialDays() {
            // vm.isDataLoaded = false;
            // specialDayService.getAllSpecialDays().then(onSpecialDayFetchSuccess, onSpecialDayFetchFailure).finally(function () {
            //     vm.isDataLoaded = true;
            // });
        }

        // Handle successful fetching of special days
        function onSpecialDayFetchSuccess(data) {
            if (!data || !Array.isArray(data)) {
                toastrService.showErrorToastr("Invalid data format received from server.");
                return;
            }

            // Map the events and ensure proper handling of nested "specialDay"
            vm.events = data.map(function(event) {
                // Ensure event and event.specialDay exist and have a valid ID
                if (!event || !event.specialDay || !event.specialDay.id) {
                    toastrService.showErrorToastr("Invalid event data received.");
                    return null;
                }

                // Ensure startDate and endDate are properly converted to Date objects
                event.specialDay.startDate = event.specialDay.startDate ? new Date(event.specialDay.startDate) : null;
                event.specialDay.endDate = event.specialDay.endDate ? new Date(event.specialDay.endDate) : null;
                event.isExpanded = false; // Initialize the expanded state to false
                return event.specialDay;   // Return the correctly mapped special day object
            }).filter(Boolean); // Filter out invalid entries

            $scope.$broadcast("refreshFixedColumns");
        }

        // Handle failure in fetching special days
        function onSpecialDayFetchFailure(error) {
            toastrService.showErrorToastr("Error fetching special days: " + error);
        }

        // Toggle the expand state of a row to show/hide all workplaces
        function toggleExpand(index) {
            vm.events[index].isExpanded = !vm.events[index].isExpanded;
        }

        // Open the modal for creating a new special day
        function openCreateModal() {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/specialDays/specialDayModals/createSpecialDay.modal.html',
                controller: 'SpecialDayCreateModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
            }).result.then(function () {
                toastrService.clearPreviousToastr();
                loadSpecialDays(); // Refresh the list of special days
                $scope.$emit("calendar-special-day-created");
            });
        }

        // Open the modal for deleting a special day
        function openDeleteModal(event, index) {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/specialDays/specialDayModals/deleteSpecialDay.modal.html',
                controller: 'SpecialDayDeleteModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    specialDayToDelete: function () { return event; }
                }
            }).result.then(function () {
                toastrService.clearPreviousToastr();
                vm.events.splice(index, 1); // Remove from the table
                $scope.$emit("calendar-special-day-deleted", event.id); // Emit the event to notify the calendar
            });
        }

        // Open the modal for updating a special day
        function openUpdateModal(event, index) {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/specialDays/specialDayModals/updateSpecialDay.modal.html',
                controller: 'SpecialDayUpdateModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    specialDayToUpdate: function () { return event; }
                }
            }).result.then(function () {
                toastrService.clearPreviousToastr();
                loadSpecialDays(); // Refresh the list of special days
                $scope.$emit('calendar-special-day-updated');
            })
        }
    }
})();
angular
    .module('mwl.calendar')
    .constant('calendarConfig', {
        allDateFormats: {
            angular: {
                date: {
                    hour: 'ha',
                    day: 'd MMM',
                    month: 'MMMM',
                    weekDay: 'EEEE',
                    time: 'HH:mm',
                    datetime: 'MMM d, h:mm a'
                },
                title: {
                    day: 'EEEE d MMMM, yyyy',
                    week: 'Week {week} of {year}',
                    month: 'MMMM yyyy',
                    year: 'yyyy'
                }
            },
            moment: {
                date: {
                    hour: 'ha',
                    day: 'D MMM',
                    month: 'MMMM',
                    weekDay: 'dddd',
                    time: 'hh:mm a',
                    datetime: 'MMM D, h:mm a'
                },
                title: {
                    day: 'dddd D MMMM, YYYY',
                    week: 'Week {week} of {year}',
                    month: 'MMMM YYYY',
                    year: 'YYYY'
                }
            }
        },
        dateFormatter: 'moment',
        showTimesOnWeekView: false,
        displayAllMonthEvents: false,
        colorTypes: {
            info: {
                primary: '#1e90ff',
                secondary: '#d1e8ff'
            },
            important: {
                primary: '#ad2121',
                secondary: '#fae3e3'
            },
            warning: {
                primary: '#e3bc08',
                secondary: '#fdf1ba'
            },
            special: {
                primary: '#800080',
                secondary: '#ffe6ff'
            },
            success: {
                primary: '#006400',
                secondary: '#caffca'
            }
        }
    });

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.subDepartments')
        .controller('SubDepartmentsCtrl', ['$scope','authService','$uibModal','subDepartmentService', 'toastrService', '_', SubDepartmentsCtrl]);

    /** @ngInject */
    function SubDepartmentsCtrl($scope,authService,$uibModal,subDepartmentService, toastrService, _) {

        var vm = this;

        vm.allSubDepartments = [];
        vm.allOffices  =[];
        vm.isDataLoaded = false;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            getAllSubDepartments();
        }

        function getAllSubDepartments() {
            subDepartmentService.getAllSubDepartments(true).then(function (data) {
                vm.allSubDepartments = sortCollectionByName(data);
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            },function (message) {
                console.error('Dept Fetching failed error: '+message);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/subDepartments/createSubDepartment/createSubDepartment.modal.html',
                size : 'md',
                controller : 'CreateSubDepartmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (subDepartment) {
                vm.allSubDepartments.push(subDepartment);
            }, function (message) {
                // console.error("Failed to create sub department - " + message);
            });
        }

        function openEditModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/subDepartments/editSubDepartment/editSubDepartment.modal.html',
                size : 'md',
                controller : 'EditSubDepartmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    subDepartment : function () {
                        return angular.copy(item);
                    }}
            }).result.then(function (subDepartment) {
                vm.allSubDepartments[index] = subDepartment;
            }, function (message) {
                // console.error("Failed to update sub department - " + message);
            });
        }

        function openDeleteModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/subDepartments/deleteSubDepartment/deleteSubDepartment.modal.html',
                size : 'md',
                controller : 'DeleteSubDepartmentModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {subDepartment : function () {
                        return item;
                    }}
            }).result.then(function (subDepartment) {
                vm.allSubDepartments.splice(index,1);
            }, function (message) {
                // console.error("Failed to delete sub department - " + message);
            });
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.susidiaries')
        .controller('SubsidiariesCtrl', ['$scope', 'authService','$uibModal','subsidiaryService', 'toastrService', '_', 'MODULES',SubsidiariesCtrl]);

    /** @ngInject */
    function SubsidiariesCtrl($scope, authService,$uibModal,subsidiaryService, toastrService, _, MODULES) {

        var vm = this;
        var loggedUser = authService.getLoggedInUser();

        vm.isDataLoaded = false;
        vm.allSubsidiaries = [];
        vm.filteredSubsidiaries = [];
        vm.isCompanyAdmin = loggedUser.isCompanyAdmin;
        vm.searchText = '';
        vm.canSubsidiaryDelete = loggedUser['modules'].includes(MODULES.SUBSIDIARY) && loggedUser.isAdmin && loggedUser.subsidiaryId == null;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.filterSubsidiaries = filterSubsidiaries;

        init();

        function init() {
            getAllSubsidiaries();
        }

        function getAllSubsidiaries() {
            subsidiaryService.getAllSubsidiaries().then(function (data) {
                vm.allSubsidiaries = sortCollectionByName(data);
                vm.filteredSubsidiaries = angular.copy(vm.allSubsidiaries);
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            },function (message) {
                console.error('Subsidiary Fetching failed error: '+message);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/subsidiary/createSubsidiary/createSubsidiary.modal.html',
                size : 'md',
                controller : 'CreateSubsidiaryModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (subsidiary) {
                // Refresh the entire list to ensure office object and all data is properly loaded
                getAllSubsidiaries();
            }, function (message) {
                // console.error("Failed to create subsidiary - " + message);
            });
        }

        function openEditModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/subsidiary/editSubsidiary/editSubsidiary.modal.html',
                size : 'md',
                controller : 'EditSubsidiaryModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    subsidiary : function () {
                        return angular.copy(item);
                }}
            }).result.then(function (subsidiary) {
                // Refresh the entire list to ensure all data is properly loaded
                getAllSubsidiaries();
            }, function (message) {
                // console.error("Failed to update subsidiary - " + message);
            });
        }

        function openDeleteModal(item,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/settings/subsidiary/deleteSubsidiary/deleteSubsidiary.modal.html',
                size : 'md',
                controller : 'DeleteSubsidiaryModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {subsidiary : function () {
                        return item;
                    }}
            }).result.then(function (subsidiary) {
                // Refresh the entire list after deletion
                getAllSubsidiaries();
            }, function (message) {
                // console.error("Failed to delete subsidiary - " + message);
            });
        }

        function filterSubsidiaries() {
            var searchText = vm.searchText.toLowerCase();

            if (!searchText) {
                vm.filteredSubsidiaries = angular.copy(vm.allSubsidiaries);
            } else {
                vm.filteredSubsidiaries = vm.allSubsidiaries.filter(function(subsidiary) {
                    return (subsidiary.name && subsidiary.name.toLowerCase().indexOf(searchText) !== -1) ||
                           (subsidiary.externalSyncId && subsidiary.externalSyncId.toLowerCase().indexOf(searchText) !== -1) ||
                           (subsidiary.employeeName && subsidiary.employeeName.toLowerCase().indexOf(searchText) !== -1);
                });
            }
        }

        function sortCollectionByName(collection) {
            // Filter out null/undefined items and items without name
            var validItems = _.filter(collection, function(item) {
                return item && item.name;
            });

            return _.orderBy(validItems, function (item) {
                return item.name.toLowerCase();
            }, ['asc']);
        }
    }

})();


(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.weeklyOffDayPolicy')
    app.controller('WeeklyOffDaysPolicyCtrl', ['weeklyOffDaysService','authService','$uibModal','toastr',WeeklyOffDaysPolicyCtrl]);

    /** @ngInject */
    function WeeklyOffDaysPolicyCtrl(weeklyOffDaysService,authService,$uibModal,toastr) {
        var vm = this;

        vm.policy = {};
        vm.policy.weeklyOffDaysPolicyList = null;
        vm.modal = {};
        vm.daysOfWeek = {
            0: "Sunday",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday"
        };
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.getDaysFromString = getDaysFromString;
        vm.openAssignedEmployeesModal = openAssignedEmployeesModal;

        function init() {
            weeklyOffDaysService.getAllWeeklyOffDayPolicies().then(onListFetchSuccess, onListFetchFailure);
        }

        init();

        function onListFetchSuccess (weeklyOffDaysPolicyList) {
            vm.policy.weeklyOffDaysPolicyList = weeklyOffDaysPolicyList;
        }

        function onListFetchFailure (error) {
            console.error(error);
        }

        function openCreateModal() {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/weeklyOffDayPolicy/create/createWeeklyOffDaysPolicy.modal.html',
                size: 'md',
                controller:'CreateWeeklyOffDaysPolicyModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
            }).result.then(function (weeklyOffDaysPolicyList) {
                vm.policy.weeklyOffDaysPolicyList = weeklyOffDaysPolicyList;
                toastr.success("Policy created");
            });
        }

        function openEditModal(policy) {
           $uibModal.open({
                templateUrl: 'app/pages/main/settings/weeklyOffDayPolicy/update/updateWeeklyOffDaysPolicy.modal.html',
                size: 'md',
                controller:'UpdateWeeklyOffDaysPolicyModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    policyToEdit: function () {
                        return policy;
                    }
                }
            }).result.then(function (weeklyOffDaysPolicyList) {
                vm.policy.weeklyOffDaysPolicyList = weeklyOffDaysPolicyList;
                toastr.success("Update successful");
            });
        }

        function openDeleteModal(policy,index) {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/weeklyOffDayPolicy/delete/deleteWeeklyOffDaysPolicy.modal.html',
                size: 'md',
                controller:'DeleteWeeklyOffDaysPolicyModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    policyToDelete: function () {
                        return policy;
                    }
                }
            }).result.then(function (weeklyOffDaysPolicyList) {
                vm.policy.weeklyOffDaysPolicyList.splice(index,1);
                toastr.success("Delete successful");
            });
        }

        function openAssignedEmployeesModal(policy) {
            $uibModal.open({
                templateUrl: 'app/pages/main/settings/weeklyOffDayPolicy/viewAssignedEmployees/viewAssignedEmployees.modal.html',
                size: 'md',
                controller:'ViewAssignedEmployeesModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    policyId: function () {
                        return policy.id;
                    }
                }
            });
        }

        //transform string from DaysOfWeek Array to english day names. Used to show day names in front
        function getDaysFromString(string) {
            var resultString = ' ';
            for (var i = 0; i < string.length; i++) {
                if (string.charAt(i) === '1') {
                    resultString = resultString + vm.daysOfWeek[i] + ' ';
                }
            }
            return resultString;
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.workplaces')
        .controller('WorkplaceCtrl', ['$scope', 'authService', '$uibModal', 'workplaceService','toastrService', WorkplaceCtrl]);

    /** @ngInject */
    function WorkplaceCtrl($scope, authService, $uibModal, workplaceService,toastrService) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.workplaces = {};
        vm.workplaces.allworkplaces = null;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            workplaceService.getAllWorkplaces().then(function(data) {
                vm.workplaces.allworkplaces = data;
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                toastrService.showErrorToastr('Failed to fetch all workplaces : ' + message, '', 5000);
            });
        }


        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/workplace/createWorkplace/createWorkplace.modal.html',
                size: 'md',
                controller: 'CreateWorkplaceModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            }).result.then(function (workplace) {
                vm.workplaces.allworkplaces.push(workplace);
            }, function (error) {
                // console.error("Workplace not created : " + error);
            });
        }

        function openEditModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/workplace/editWorkplace/editWorkplace.modal.html',
                size: 'md',
                controller: 'EditWorkplaceModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    workplace: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (workplace) {
                vm.workplaces.allworkplaces[index] = workplace;
            }, function (error) {
                // console.error("Failed to edit workplace : " + error);
            });
        }

        function openDeleteModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/settings/workplace/deleteWorkplace/deleteWorkplace.modal.html',
                size: 'md',
                controller: 'DeleteWorkplaceModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    workplace: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (workplace) {
                vm.workplaces.allworkplaces.splice(index, 1);
            }, function (error) {
                // console.error("Failed to delete designation : " + error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.dynamicShiftGroups')
        .controller('DynamicShiftGroupsCtrl', ['$scope','authService', '$uibModal', 'shiftGroupService', 'toastrService', DynamicShiftGroupsCtrl]);

    /** @ngInject */
    function DynamicShiftGroupsCtrl($scope, authService, $uibModal, shiftGroupService, toastrService) {

        var vm = this;

        vm.shiftGroupList = [];
        vm.isDataLoaded = false;
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        vm.dayToNameMap = {
            '6' : 'Saturday',
            '7' : 'Sunday',
            '1' : 'Monday',
            '2' : 'Tuesday',
            '3' : 'Wednesday',
            '4' : 'Thursday',
            '5' : 'Friday',
        }

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            shiftGroupService.getAllDynamicShiftGroups().then(function (data) {
                vm.shiftGroupList = data;
                for(var i = 0 ; i< vm.shiftGroupList.length;i++){
                    addOffDayDisplayStringAndShiftNamesIntoShiftGroupList();
                }
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                toastrService.showErrorToastr('Failed to fetch all shift group : ' + message, '', 5000);
            });
        }

        function addOffDayDisplayStringAndShiftNamesIntoShiftGroupList(){
            for(var i = 0 ; i< vm.shiftGroupList.length;i++){
                vm.shiftGroupList[i].defaultOffDaysDisplay = getNameOfDayStringFromDefaultOffDayString(vm.shiftGroupList[i]);
                vm.shiftGroupList[i].shiftNames = vm.shiftGroupList[i].shifts.map(function (shift){
                    return shift.shiftName;
                }).join(',');
            }
        }

        function getNameOfDayStringFromDefaultOffDayString(shiftGroup){
            var defaultOffDays = shiftGroup.defaultOffDays;
            if(defaultOffDays == null || defaultOffDays == "") return '';
            defaultOffDays = defaultOffDays.split(',');
            var returnString = "";
            defaultOffDays = defaultOffDays.map(function (day){
                return vm.dayToNameMap[day];
            }).join(',');
            return defaultOffDays;
        }


        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/dynamicShiftGroups/createShiftGroup/createDynamicShiftGroup.modal.html',
                size: 'md',
                controller: 'CreateDynamicShiftGroupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            }).result.then(function (shiftGroup) {
                init();
            }, function (error) {
                if(error != null && typeof error !== 'undefined')
                    toastr.error("Shift Group not created : " + error);
            });
        }

        function openEditModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/dynamicShiftGroups/editShiftGroup/editShiftGroup.modal.html',
                size: 'md',
                controller: 'EditDynamicShiftGroupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    shiftGroup: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (shiftGroup) {
                init()
            }, function (error) {
                if(error != null && typeof error !== 'undefined')
                    toastr.error("Failed to edit shift group : " + error);
            });
        }

        function openDeleteModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/dynamicShiftGroups/deleteShiftGroup/deleteDynamicShiftGroup.modal.html',
                size: 'md',
                controller: 'DeleteDynamicShiftGroupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    shiftGroup: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function () {
                vm.shiftGroupList.splice(index, 1);
            }, function (error) {
                if(error != null && typeof error !== 'undefined')
                    console.error("Failed to delete shift group : " + error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.roster')
        .controller('RosterCtrl', ['$scope', 'toastr', '$uibModal', 'rosterService', 'shiftGroupService', 'shiftnService', 'utilService', 'authService', 'analyticsService', 'ANALYTICS_CONSTANT', RosterCtrl]);

    /** @ngInject */
    function RosterCtrl($scope, toastr, $uibModal, rosterService, shiftGroupService, shiftnService, utilService, authService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.activeTab = 0;
        vm.basicViewRosters = [];
        vm.advancedRosters = [];
        vm.advancedRostersBackup = [];
        vm.days = [];
        vm.year = moment().year();
        vm.now = moment().valueOf();
        vm.shiftGroups = [];
        vm.shifts = [];
        vm.shiftIdToInitialMap = {};
        vm.shiftIdToColorMap = {};
        vm.changesToSave = {};
        vm.officeId = authService.getLoggedInUser().office.id;
        vm.isDataLoaded = false;

        vm.onBasicViewTabSelect = onBasicViewTabSelect;
        vm.onAdvancedViewTabSelect = onAdvancedViewTabSelect;
        vm.buildShiftInfo = buildShiftInfo;
        vm.buildTime = buildTime;
        vm.openEditBasicModal = openEditBasicModal;
        vm.getMonthName = utilService.getMonthName;
        vm.getDayName = utilService.getDayName;
        vm.openCellChangeModal = openCellChangeModal;
        vm.openRepeatModal = openRepeatModal;
        vm.reset = reset;
        vm.saveChanges = saveChanges;
        vm.getNextShiftChange = getNextShiftChange;
        vm.getLatestOffday = getLatestOffday;
        vm.openDownloadRosterModal = openDownloadRosterModal

        // onBasicViewTabSelect();

        function onBasicViewTabSelect() {
            analyticsService.sendData(ANALYTICS_CONSTANT.basicView, document.title + ' - Basic View', '', 'Basic View In' + document.title, ANALYTICS_CONSTANT.basicView);
            vm.activeTab = 0;
            fetchBasicData();
        }

        function fetchBasicData() {
            rosterService.getBasicRoster().then(function (data) {
                vm.basicViewRosters = data;
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                console.error("Failed to fetch rosters: " + error);
            })
        }

        function getAdvancedRoster() {
            rosterService.getAdvancedRoster().then(function (data) {
                vm.advancedRosters = data;
                vm.advancedRostersBackup = angular.copy(vm.advancedRosters);

                // Identify months and years from data
                var monthYearPairs = [];
                var tempMap = {};

                angular.forEach(vm.advancedRosters, function (monthsData, groupId) {
                    angular.forEach(monthsData, function (rosterList, monthNum) {
                        if (rosterList && rosterList.length > 0) {
                            var year = rosterList[0].year;
                            var key = year + '-' + monthNum;
                            if (!tempMap[key]) {
                                tempMap[key] = true;
                                monthYearPairs.push({ month: parseInt(monthNum), year: year });
                            }
                        }
                    });
                });

                // Sort chronologically
                monthYearPairs.sort(function (a, b) {
                    if (a.year !== b.year) return a.year - b.year;
                    return a.month - b.month;
                });

                // Rebuild vm.days
                vm.days = [];
                if (monthYearPairs.length > 0) {
                    angular.forEach(monthYearPairs, function (pair) {
                        var monthObj = utilService.getAllDatesOfAMonth(pair.month, pair.year);
                        monthObj.year = pair.year;
                        vm.days.push(monthObj);
                    });
                } else {
                    // Fallback to current year if no data
                    for (var i = 1; i <= 12; i++) {
                        var monthObj = utilService.getAllDatesOfAMonth(i, vm.year);
                        monthObj.year = vm.year;
                        vm.days.push(monthObj);
                    }
                }

            }, function (error) {
                console.error("Failed to fetch rosters: " + error);
            })
        }

        function fetchShiftGroups() {
            shiftGroupService.getAllShiftGroups().then(function (data) {
                vm.shiftGroups = data;
            }, function (error) {
                console.error("Failed to fetch rosters: " + error);
            })
        }

        function fetchShifts() {
            shiftnService.getAllShifts().then(function (data) {
                vm.shifts = data;
                for (var i = 0; i < vm.shifts.length; i++) {
                    vm.shiftIdToInitialMap[vm.shifts[i].id] = vm.shifts[i].initial;
                    vm.shiftIdToColorMap[vm.shifts[i].id] = {
                        'background': vm.shifts[i].color,
                        'font': utilService.invertColor(vm.shifts[i].color, true)
                    };
                }
                vm.shifts.push({
                    'id': -1,
                    'name': 'Off Day',
                    'initial': 'O',
                    'color': '#00004F',
                    'displayName': 'Off Day',
                    'isOffday': true,
                    'status': 1
                });
                vm.shiftIdToInitialMap[-1] = 'O';
                vm.shiftIdToColorMap[-1] = {
                    'background': '#00004F',
                    'font': '#FFFFFF'
                };
            }, function (error) {
                console.error("Failed to fetch rosters: " + error);
            })
        }

        function reset() {
            vm.advancedRosters = angular.copy(vm.advancedRostersBackup);
            vm.changesToSave = [];
        }

        function onAdvancedViewTabSelect() {
            analyticsService.sendData(ANALYTICS_CONSTANT.advancedView, document.title + ' - Advanced View', '', 'Advanced View In' + document.title, ANALYTICS_CONSTANT.advancedView);
            vm.activeTab = 1;
            if (!vm.shiftGroups || !vm.shiftGroups.length) fetchShiftGroups();
            if (!vm.shifts || !vm.shifts.length) fetchShifts();
            getAdvancedRoster();
        }

        function buildShiftInfo(shiftName, startTime, endTime) {
            return shiftName + " ( " + moment(startTime).format('h:mm A') + " - " + moment(endTime).format('h:mm A') + " )";
        }

        function buildTime(time) {
            if (time == 0)
                return "No change";
            var targetDay = moment(time);
            var today = moment();
            var count = targetDay.diff(today.startOf('day'), 'days');
            return targetDay.format('dddd DD-MMM-YYYY') + " ( After " + count + (count > 1 ? " days )" : " day )");
        }

        function openEditBasicModal(item, index) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/roster/basicView/editBasic/editBasicRoster.modal.html',
                size: 'md',
                controller: 'EditBasicRosterModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    rosterItem: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function () {
                fetchBasicData();
            }, function (error) {

            });
        }

        function openCellChangeModal(shiftGroupId, monthNumber, roster, index) {
            if (roster.rosterDate <= vm.now) {
                return toastr.error("You can only modify future days of the roster");
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/roster/advancedView/cellShiftChange/cellShiftChange.modal.html',
                size: 'md',
                controller: 'CellShiftChangeModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    shifts: function () {
                        return angular.copy(vm.shifts);
                    }
                }
            }).result.then(function (data) {
                if (data.shiftId != -1)
                    vm.advancedRosters[shiftGroupId][monthNumber][index].shiftId = data.shiftId;
                vm.advancedRosters[shiftGroupId][monthNumber][index].isOffday = data.isOffday;
                trackChanges(vm.advancedRosters[shiftGroupId][monthNumber][index]);
            }, function (error) {
                console.error("Failed to edit roster: " + error);
            });
        }

        function openRepeatModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/roster/advancedView/repeat/repeat.modal.html',
                size: 'md',
                controller: 'RepeatShiftChangeModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    shiftGroups: function () {
                        return angular.copy(vm.shiftGroups);
                    }
                }
            }).result.then(function (repeatData) {
                repeatFromSelectedData(repeatData);
            }, function (error) {
                console.error("Failed to edit roster: " + error);
            });
        }

        function trackChanges(newRoster) {
            vm.changesToSave[newRoster.id] = {
                'rosterId': newRoster.id,
                'shiftId': newRoster.shiftId,
                'isOffday': newRoster.isOffday ? 1 : 0
            };
        }

        function repeatFromSelectedData(selectedData) {
            var shiftGroupData = vm.advancedRosters[selectedData.shiftGroupId];
            var sourceData = buildSourceData(shiftGroupData, selectedData.copyFromMonth, selectedData.copyFromDay, selectedData.copyToMonth, selectedData.copyToDay);
            if (utilService.isEmptyArray(sourceData)) return;
            var sourceDataLength = sourceData.length;
            var copyIndex = 0;
            for (var month = selectedData.pasteFromMonth; month <= selectedData.pasteToMonth; month++) {
                var dataForThisMonth = shiftGroupData[month];
                if (month == selectedData.pasteToMonth) {
                    if (month == selectedData.pasteFromMonth) {
                        // paste into pasteFromDay to pasteToDay
                        for (var day = selectedData.pasteFromDay - 1; day < selectedData.pasteToDay; day++) {
                            dataForThisMonth[day].shiftId = sourceData[copyIndex].shiftId;
                            dataForThisMonth[day].isOffday = sourceData[copyIndex].isOffday;
                            copyIndex = (copyIndex + 1) % sourceDataLength;
                            trackChanges(dataForThisMonth[day]);
                        }
                    } else {
                        // paste into 1 to pasteToDay
                        for (var day = 0; day < selectedData.pasteToDay; day++) {
                            dataForThisMonth[day].shiftId = sourceData[copyIndex].shiftId;
                            dataForThisMonth[day].isOffday = sourceData[copyIndex].isOffday;
                            copyIndex = (copyIndex + 1) % sourceDataLength;
                            trackChanges(dataForThisMonth[day]);
                        }
                    }
                } else if (month == selectedData.pasteFromMonth) {
                    if (month == selectedData.pasteToMonth) {
                        // paste into pasteFromDay to pasteToDay
                        for (var day = selectedData.pasteFromDay - 1; day < selectedData.pasteToDay; day++) {
                            dataForThisMonth[day].shiftId = sourceData[copyIndex].shiftId;
                            dataForThisMonth[day].isOffday = sourceData[copyIndex].isOffday;
                            copyIndex = (copyIndex + 1) % sourceDataLength;
                            trackChanges(dataForThisMonth[day]);
                        }
                    } else {
                        // paste into pasteFromDay to end day of this month
                        var monthLength = utilService.getMonthLength(month);
                        for (var day = selectedData.pasteFromDay - 1; day < monthLength; day++) {
                            dataForThisMonth[day].shiftId = sourceData[copyIndex].shiftId;
                            dataForThisMonth[day].isOffday = sourceData[copyIndex].isOffday;
                            copyIndex = (copyIndex + 1) % sourceDataLength;
                            trackChanges(dataForThisMonth[day]);
                        }
                    }
                } else {
                    // paste into 1 to end of this month
                    var monthLength = utilService.getMonthLength(month);
                    for (var day = 0; day < monthLength; day++) {
                        dataForThisMonth[day].shiftId = sourceData[copyIndex].shiftId;
                        dataForThisMonth[day].isOffday = sourceData[copyIndex].isOffday;
                        copyIndex = (copyIndex + 1) % sourceDataLength;
                        trackChanges(dataForThisMonth[day]);
                    }
                }
                shiftGroupData[month] = dataForThisMonth;
            }
            vm.advancedRosters[selectedData.shiftGroupId] = shiftGroupData;
        }

        function buildSourceData(shiftGroupData, copyFromMonth, copyFromDay, copyToMonth, copyToDay) {
            var sourceData = [];
            for (var month = copyFromMonth; month <= copyToMonth; month++) {
                var dataForThisMonth = shiftGroupData[month];
                if (month == copyToMonth) {
                    if (month == copyFromMonth) {
                        // copy from copyFromDay to copyToDay
                        for (var day = copyFromDay - 1; day < copyToDay; day++) {
                            sourceData.push(dataForThisMonth[day]);
                        }
                    } else {
                        // copy from 1 to copyToDay
                        for (var day = 0; day < copyToDay; day++) {
                            sourceData.push(dataForThisMonth[day]);
                        }
                    }
                } else if (month == copyFromMonth) {
                    if (month == copyToMonth) {
                        // copy from copyFromDay to copyToDay
                        for (var day = copyFromDay - 1; day < copyToDay; day++) {
                            sourceData.push(dataForThisMonth[day]);
                        }
                    } else {
                        // copy from copyFromDay to end day of this month
                        for (var day = copyFromDay - 1; day < utilService.getMonthLength(month); day++) {
                            sourceData.push(dataForThisMonth[day]);
                        }
                    }
                } else {
                    // copy from 1 to end of this month
                    for (var day = 0; day < utilService.getMonthLength(month); day++) {
                        sourceData.push(dataForThisMonth[day]);
                    }
                }
            }
            return sourceData;
        }

        function saveChanges() {
            if (!vm.changesToSave) return;
            rosterService.updateRosterAdvanced({ 'change': Object.values(vm.changesToSave) }).then(function () {
                getAdvancedRoster();
                toastr.success("Updated advanced roster successfully.");
            }, function (err) {
                console.error("Failed to update advanced roster: " + err);
            });
        }

        function getNextShiftChange(shiftGroupId, currentShiftId) {
            var params = {
                'shiftGroupId': shiftGroupId,
                'currentShiftId': currentShiftId
            };
            rosterService.getNextShiftChange(params).then(function (data) {
                var el = document.getElementById("next-shift-change-" + shiftGroupId);
                el.innerHTML = buildTime(data.nextChange) + ' <span style="color:#12c4ff"><em>' + (data.changeShiftName == null ? '' : data.changeShiftName) + '</em></span>';
            }, function (err) {
                console.error("Failed to get next shift change info: " + err);
            });
        }

        function getLatestOffday(shiftGroupId) {
            var params = {
                'shiftGroupId': shiftGroupId
            };
            rosterService.getLatestOffday(params).then(function (data) {
                var el = document.getElementById("latest-offday-" + shiftGroupId);
                el.innerHTML = buildTime(data.nextOffday);
            }, function (err) {
                console.error("Failed to get latest offday info: " + err);
            });
        }

        function openDownloadRosterModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/roster/modal/downloadRoster.modal.html',
                size: 'md',
                controller: 'DownloadRosterModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
            }).result.then(function () {

            }, function (error) {
                // console.error("Workplace not created : " + error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shiftGroups')
        .controller('ShiftGroupsCtrl', ['$scope','authService', '$uibModal','toastrService', 'shiftGroupService', ShiftGroupsCtrl]);

    /** @ngInject */
    function ShiftGroupsCtrl($scope, authService, $uibModal, toastrService, shiftGroupService) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.shiftGroupList = [];
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        vm.dayToNameMap = {
            '6' : 'Saturday',
            '7' : 'Sunday',
            '1' : 'Monday',
            '2' : 'Tuesday',
            '3' : 'Wednesday',
            '4' : 'Thursday',
            '5' : 'Friday',
        }

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;

        init();

        function init() {
            shiftGroupService.getAllShiftGroups().then(function (data) {
                vm.shiftGroupList = data;
                for(var i = 0 ; i< vm.shiftGroupList.length;i++){
                    vm.shiftGroupList[i].defaultOffDaysDisplay = getNameOfDayStringFromDefaultOffDayString(vm.shiftGroupList[i]);
                }
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                toastrService.showErrorToastr('Failed to fetch all shift group : ' + message, '', 5000);
            });
        }

        function getNameOfDayStringFromDefaultOffDayString(shiftGroup){
            var defaultOffDays = shiftGroup.defaultOffDays;
            if(defaultOffDays == null || defaultOffDays == "") return '';
            defaultOffDays = defaultOffDays.split(',');
            var returnString = "";
            defaultOffDays = defaultOffDays.map(function (day){
                return vm.dayToNameMap[day];
            }).join(',');
            return defaultOffDays;
        }


        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/shiftGroups/createShiftGroup/createShiftGroup.modal.html',
                size: 'md',
                controller: 'CreateShiftGroupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            }).result.then(function (shiftGroup) {
                shiftGroup.defaultOffDaysDisplay = getNameOfDayStringFromDefaultOffDayString(shiftGroup);
                vm.shiftGroupList.push(shiftGroup);
            }, function (error) {
                if(error != null && typeof error !== 'undefined')
                    console.error("Shift Group not created : " + error);
            });
        }

        function openEditModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/shiftGroups/editShiftGroup/editShiftGroup.modal.html',
                size: 'md',
                controller: 'EditShiftGroupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    shiftGroup: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (shiftGroup) {
                shiftGroup.defaultOffDaysDisplay = getNameOfDayStringFromDefaultOffDayString(shiftGroup);
                vm.shiftGroupList[index] = shiftGroup;
            }, function (error) {
                if(error != null && typeof error !== 'undefined')
                    console.error("Failed to edit shift group : " + error);
            });
        }

        function openDeleteModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/shiftGroups/deleteShiftGroup/deleteShiftGroup.modal.html',
                size: 'md',
                controller: 'DeleteShiftGroupModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    shiftGroup: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function () {
                vm.shiftGroupList.splice(index, 1);
            }, function (error) {
                if(error != null && typeof error !== 'undefined')
                    console.error("Failed to delete shift group : " + error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shifts')
        .controller('ShiftsCtrl', ['$scope','authService', '$uibModal', 'shiftnService', 'officeService','toastrService', 'utilService' , ShiftsCtrl]);

    /** @ngInject */
    function ShiftsCtrl($scope, authService, $uibModal, shiftnService, officeService,toastrService, utilService) {

        var vm = this;
        var today = new Date().setHours(0,0,0,0);

        vm.isDataLoaded = false;
        vm.shiftList = [];
        vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
        vm.officeList = [];

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.getOfficeName = getOfficeName;
        vm.viewStartTime = viewStartTime;
        vm.viewOtherTimes = viewOtherTimes;
        vm.viewBreakTimeEnds = viewBreakTimeEnds;

        init();

        function init() {
            if(vm.isCompanyAdmin) {
                officeService.getAllOffices().then(function(data){
                    vm.officeList = data;
                });
            }
            getAllShifts()

        }

        function getAllShifts(){
            shiftnService.getAllShifts(true).then(function (data){
                vm.shiftList = data;
                vm.isDataLoaded = true;

                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                toastrService.showErrorToastr('Failed to fetch all shifts : ' + message, '', 5000);
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/shifts/createShift/createShift.modal.html',
                size: 'md',
                controller: 'CreateShiftModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
            }).result.then(function (shift) {
                getAllShifts();
            }, function (error) {
                // console.error("Shift not created : " + error);
            });
        }

        function openEditModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/shifts/editShift/editShift.modal.html',
                size: 'md',
                controller: 'EditShiftModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    shift: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (shift) {
                getAllShifts();
            }, function (error) {
                // console.error("Failed to edit shift : " + error);
            });
        }

        function openDeleteModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/shiftManagement/shifts/deleteShift/deleteShift.modal.html',
                size: 'md',
                controller: 'DeleteShiftModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    shift: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function () {
                getAllShifts();
            }, function (error) {
                // console.error("Failed to delete shift : " + error);
            });
        }

        function getOfficeName(officeId) {
            if(utilService.isEmptyArray(vm.officeList)) return '';
            for(var i =0; i< vm.officeList.length ; i ++){
                if(officeId == vm.officeList[i].id) return vm.officeList[i].name;
            }
        }

        function viewStartTime(startTime) {
            return new moment(today+startTime).format('hh : mm a');
        }

        function viewOtherTimes(startTime, time) {
            return new moment(today+startTime+time).format('hh : mm a');
        }

        function viewBreakTimeEnds(startTime, halfTimeDuration, breakDuration){
            return new moment(today+startTime+halfTimeDuration+breakDuration).format('hh : mm a');
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.manageSites')
        .controller('ManageSitesCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService', ManageSitesCtrl]);

    /** @ngInject */
    function ManageSitesCtrl($scope, $stateParams, $state, $timeout,$uibModal,utilService, authService, employeeService, toastrService,siteManagementService) {
        var vm = this;

        vm.isDataLoaded = false;
        vm.searchParams = {};
        vm.rowsPerPage = 10;


        vm.openDeleteModal = openDeleteModal;
        vm.search=search;

        function init(){
            vm.searchParams.pageNumber  = 0;
            vm.searchParams.perPage  = utilService.getRowsPerPage();
            search()
        }
        init();

        function search(searchParams) {
            vm.isDataLoaded = false;
            utilService.setRowsPerPage( vm.rowsPerPage)
            vm.searchParams.perPage=vm.rowsPerPage;
            modifyParams(searchParams)
            siteManagementService.getAllSitesInformation(vm.searchParams).then(function (data) {
                vm.allSitesInformation = data.siteList;
                vm.total=data.totalSites;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.pageNumber;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function openDeleteModal($index, siteId) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/siteManagement/manageSites/delete/deleteSite.modal.html',
                size : 'md',
                controller : 'DeleteSiteModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {
                        return {
                           id: siteId
                        }
                    }},
                controllerAs : 'vm',
            }).result.then(function () {
                init();
            }, function (message) {
                // console.error("Failed to delete Site - " + message, '', 5000);
            });
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('SiteManagementDashboardCtrl', ['$scope','$q', '$stateParams', '$state', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService','siteManagementService', SiteManagementDashboardCtrl]);

    /** @ngInject */
    function SiteManagementDashboardCtrl($scope,$q, $stateParams, $state, $timeout,$uibModal, authService, employeeService, toastrService,siteManagementService) {
        var vm = this;

        var d = new Date();
        vm.currentTime = moment(d).format('dddd, DD/MM/YYYY');
        vm.allSitesList = [];
        vm.selectedSite = [];
        vm.selectedSiteId = null;
        var user = authService.getLoggedInUser();
        vm.isSiteAdmin = user.isSiteManagementAdmin;
        vm.isSiteManager = user.isSiteManagementManager;
        vm.mostlyPresentEmployeeList = []
        vm.mostlyPresentDataLoaded = false;
        vm.mostlyOnTimeDataLoaded = false;

        vm.search = search;


        function init(){
            $q.all([getAllSites()]).then(function () {
                getPieChartData();
                if(vm.isSiteAdmin) getTopActiveSitesData();
                getMostlyPresentEmployeesData();
                if(vm.isSiteManager) getMostlyOnTimeEmployeesData();
            });

        }
        init();

        function search(){
            vm.selectedSiteId = vm.selectedSite[0].id;
            $scope.$broadcast("selected-site-id",  vm.selectedSiteId);
            getPieChartData();
            getMostlyPresentEmployeesData();
            getMostlyOnTimeEmployeesData();

        }

        function getAllSites(){
            var params = {
                pageNumber: 0,
                perPage:0
            }
            return siteManagementService.getAllSitesInformation(params).then(function (data){
                vm.allSitesList = data.siteList;

            },function (error) {
                console.error("Could not fetch device list : " + error);
            });
        }

        function getPieChartData(){
            if(vm.selectedSite.length == 0){
                vm.siteIds = [];
                vm.allSitesList.forEach(function (site){
                    vm.siteIds.push(site.id);
                });
            }else vm.siteId = vm.selectedSiteId;

            if(vm.isSiteAdmin && vm.selectedSite.length == 0){
                siteManagementService.getAllPieChartData(vm.siteIds).then(function (data){
                    vm.allPieChartData = data;
                    $scope.$broadcast("site-attendance-summary-data-loaded",  vm.allPieChartData);

                },function (error) {
                    console.error("Could not fetch device list : " + error);
                });
            }
            if(vm.isSiteManager || vm.selectedSite.length !== 0){
                siteManagementService.getAllPieChartData(vm.siteId).then(function (data){
                    vm.allPieChartData = data;
                    $scope.$broadcast("site-attendance-summary-data-loaded",  vm.allPieChartData);

                },function (error) {
                    console.error("Could not fetch device list : " + error);
                });
            }
        }

        function getTopActiveSitesData(){
            vm.isTopActiveDataLoaded = false;
            siteManagementService.getTopActiveSitesData().then(function (data){
                vm.topActiveSites = data.activeSiteList;
                vm.isTopActiveDataLoaded = true;
                },function (error) {
                console.error("Could not fetch device list : " + error);
            });
        }

        function getMostlyPresentEmployeesData(){
            if(vm.isSiteAdmin && vm.selectedSite.length == 0){
                vm.mostlyPresentDataLoaded = false;
                siteManagementService.getMostlyPresentEmployeesData(vm.siteIds).then(function (data){
                    vm.mostlyPresentEmployeeList = data.mostlyPresentEmployees;

                },function (error) {
                    console.error("Could not fetch device list : " + error);
                }).finally(function (){
                    vm.mostlyPresentDataLoaded = true;
                });
            }
            if(vm.isSiteManager || vm.selectedSite.length !== 0){
                vm.mostlyPresentDataLoaded = false;
                siteManagementService.getMostlyPresentEmployeesData(vm.siteId).then(function (data){
                    vm.mostlyPresentEmployeeList = data.mostlyPresentEmployees;

                },function (error) {
                    console.error("Could not fetch device list : " + error);
                }).finally(function(){
                    vm.mostlyPresentDataLoaded=true;
                });
            }
        }

        function getMostlyOnTimeEmployeesData(){
            var params = {
                siteId: vm.siteId
            }
            vm.mostlyOnTimeDataLoaded = false;
            siteManagementService.getMostlyOnTimeEmployeesData(params).then(function (data){
                vm.mostlyOnTimeEmployeeList = data.mostlyOnTimeEmployees;

            },function (error) {
                console.error("Could not fetch device list : " + error);
            }).finally(function(){
                vm.mostlyOnTimeDataLoaded = true;
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.sms')
        .controller('SmsConfirmModalCtrl',
            ['$scope','smsService', 'toastr','$uibModalInstance',SmsConfirmModalCtrl]);

    /** @ngInject */
    function SmsConfirmModalCtrl($scope, smsService, toastr,$uibModalInstance) {
        var vm  = this;

        vm.confirm = confirm;
        function confirm() {
            $uibModalInstance.close();
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
        .controller('AppointmentLogCtrl', ['appointmentLogService','departmentService','visitorCategoryService','$uibModal','utilService','authService','toastrService', '_','$state', '$scope', AppointmentLogCtrl]);

    /** @ngInject */
    function AppointmentLogCtrl(appointmentLogService,departmentService,visitorCategoryService,$uibModal,utilService, authService, toastrService, _,$state, $scope) {
        var vm = this;
        vm.isVisitorManagementAdmin = authService.getLoggedInUser().roles.includes('visitorManagementAdmin');
        vm.appointmentList = [];
        vm.selectedAppointments = [];
        vm.allDepartmentList = [];
        vm.filterParams = {};
        vm.showAppointmentType = 1;
        vm.filterParams.appointmentLogType=1;
        vm.isFilterVisible = false;
        vm.isDataLoaded = false;
        vm.currentDay = new Date().getTime();
        vm.startTimeOfDay=moment().startOf('day');
        vm.filterParams.selectedDepartments = [];
        vm.filterParams.selectedDepartmentsId = [];
        vm.filterParams.selectedVisitorCategories = [];
        vm.filterParams.selectedVisitorCategoryId = [];
        vm.filterParams.searchKeyEmployee = "";
        vm.filterParams.searchKeyVisitor = "";
        vm.visitorCategoriesList = [];
        vm.filterParams.pageNumber = 0;
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.rowsPerPage = utilService.setRowsPerPage(10);
        vm.filterParams.numberOfPages = 1;
        vm.numberOfButtons = Array(vm.filterParams.numberOfPages).fill(1);
        vm.filterParams.selectedPage = 0;
        vm.total = 10;
        vm.selectedVisitorCategories = [];
        vm.millisInADay = 86400000;
        vm.dates = {}
        vm.allStatusList=[
            {
                'code':1,
                'label':'Active'
            },
            {
                'code':0,
                'label':'Missed'
            },
            {
                'code':3,
                'label':'Completed'
            },
            {
                'code':4,
                'label':'Cancelled'
            },
        ]
        vm.filterParams.selectedStatus=[]
        vm.openCancelAppointmentModal = openCancelAppointmentModal;
        vm.dates.options = {
            startDate : moment().startOf('day'),
            endDate   : moment().endOf('day'),
            minDate   : moment().startOf('day'),
            maxDate   : moment().endOf('day'),
            timePicker : false,
            timePicker24Hour : false,
            locale : {
                format : 'DD MMM YYYY'
            }
        };

        vm.makeFilterVisible = makeFilterVisible;
        vm.setSelectedAppointmentTypeToShow = setSelectedAppointmentTypeToShow;
        vm.searchFilteredAppointments = searchFilteredAppointments;
        vm.getAppointmentPageSpecifiedData = getAppointmentPageSpecifiedData;
        vm.openEdit = openEdit;
        vm.setVisitorSearchKeyword = setVisitorSearchKeyword;

        init();
        function setSelectedAppointmentTypeToShow(type){
            if(vm.showAppointmentType != type){
                vm.showAppointmentType = type;
                vm.filterParams.appointmentLogType=type;
                if(vm.filterParams.selectedStatus.length!=0){
                    var temp = vm.allStatusList.find(function (elem){
                        return elem.code==vm.filterParams.selectedStatus[0].code
                    })
                    temp['ticked']=false;
                }
                vm.filterParams.selectedStatus.splice(0,1);
                // if(vm.filterParams.selectedStatus.length!=0){
                //     console.log(vm.filterParams.selectedStatus)
                //     var temp = vm.allStatusList.find(function (elem){
                //         return elem.code==vm.filterParams.selectedStatus[0].code
                //     })
                //     temp['ticked']=false;
                //     vm.filterParams.selectedStatus={};
                //     //vm.filterParams.selectedStatus.ticked=false;
                // }
                vm.filterParams.selectedPage = 0;
                if(vm.showAppointmentType == 1){
                    vm.dates.options.startDate = moment().startOf('day');
                    vm.dates.options.endDate = moment().endOf('day');
                    vm.dates.options.minDate = moment().startOf('day');
                    vm.dates.options.maxDate = moment().endOf('day');
                }
                else if(vm.showAppointmentType == 2){
                    vm.dates.options.startDate = moment().add(1,'days').startOf('day');
                    vm.dates.options.endDate = moment().add(1,'years');
                    vm.dates.options.minDate = moment().add(1,'days').startOf('day');
                    vm.dates.options.maxDate = moment().add(1,'years');
                }
                else if(vm.showAppointmentType == 3){
                    vm.dates.options.startDate = moment().subtract(1,'months');
                    vm.dates.options.endDate = moment().subtract(1,'day').endOf('day');
                    vm.dates.options.minDate = moment().subtract(1,'years');
                    vm.dates.options.maxDate = moment().subtract(1,'day');
                }
                searchFilteredAppointments();
            }

        }
        function openEdit(data){
            // console.log(data.visitorId);
            $state.go('visitorManagement.editAppointment', {
                    //visitorId    : data.visitorId,
                    appointmentId: data.appointmentId,
                }
            );
        }
        function openCancelAppointmentModal(id){
            toastrService.clearPreviousToastr();
           //console.log("Entered")
           $uibModal.open({
               animation   : true,
               templateUrl : 'app/pages/main/visitorManagement/appointmentLog/appointmentLogModal/appointmentCancelModal.html',
               size        : 'md',
               controller  : 'AppointmentCancelModalCtrl',
               controllerAs: 'vm',
               backdrop : 'static',
               resolve     :
                    {
                        appointmentToCancel:function () {
                            return id;
                        }
                    }
            }).result.then(function (){
                onAppointmentCancelSuccess();
            });
        }
        function onAppointmentCancelSuccess(){
            searchFilteredAppointments()
        }
        function searchFilteredAppointments(){
            vm.filterParams.selectedDepartmentsId = vm.filterParams.selectedDepartments.map(function (m){
                return m['id'];
            })
            vm.filterParams.selectedVisitorCategoriesId = vm.filterParams.selectedVisitorCategories.map(function (m){
                return m['id'];
            })
            if(vm.showAppointmentType == 3){
                vm.filterParams.from = vm.dates.options.startDate.format("x")//.subtract(1,'years');
                vm.filterParams.to=moment().format("x");
            }
            else
                vm.filterParams.from = vm.dates.options.startDate.format("x");
            if(vm.showAppointmentType != 3)
                vm.filterParams.to = vm.dates.options.endDate.format("x");
            vm.isDataLoaded = false;
            appointmentLogService.getAllAppointments(getParams(vm.filterParams)).then(onListFetchSuccess,onListFetchFailure);
        }
        function getParams(searchParams){
            // console.log(searchParams.selectedStatus);
            if(searchParams.selectedStatus.length!=0){
                // console.log(searchParams.selectedStatus[0].code)
            }
            var params = {
                officeId           : searchParams.officeId == null || searchParams.officeId.length == 0 ? [] : searchParams.officeId,
                status             : searchParams.status == null || searchParams.status.length == 0 ? [] : searchParams.status,
                workplaceId        : searchParams.workplaceId == null || searchParams.workplaceId.length == 0 ? [] : searchParams.workplaceId,
                perPage            : 10,
                pageNumber         : searchParams.selectedPage,
                selectAll          : searchParams.selectAll,
                from               : searchParams.from,
                to                 : searchParams.to,
                departmentId       : searchParams.selectedDepartmentsId,
                visitorCategoryId  : searchParams.selectedVisitorCategoriesId,
                employeeName       : searchParams.searchKeyEmployee == "" || searchParams.searchKeyEmployee == null ? null : searchParams.searchKeyEmployee,
                visitorName        : searchParams.searchKeyVisitor == "" || searchParams.searchKeyVisitor == null ? null : searchParams.searchKeyVisitor,
                mobilePunchStatus  : searchParams.mobilePunchStatus == null || searchParams.mobilePunchStatus.length == 0 ? [] : searchParams.mobilePunchStatus,
                appointmentLogType : searchParams.appointmentLogType,
                statusCode          : searchParams.selectedStatus.length==0 || searchParams.selectedStatus == null ? null:searchParams.selectedStatus[0].code
            };
            if(!vm.isVisitorManagementAdmin){
                params.hostId = authService.getLoggedInUser().id;
            }
            return params;
        }
        function makeFilterVisible(){
            vm.isFilterVisible = !vm.isFilterVisible;
        }
        function init(){
            vm.filterParams.from = vm.dates.options.startDate.format("x");
            vm.filterParams.to = vm.dates.options.endDate.format("x");
            if(vm.isVisitorManagementAdmin)
                getAllDepartments();
            getAllVisitorCategories();
            getTodayAppointments()
        }
        function getAllVisitorCategories(){
            visitorCategoryService.getAllVisitorCategories().then(function(data){
                vm.visitorCategoriesList = data;
            },function(error){
                toastrService.showErrorToastr("Could not visitor categories: " + error, "", 5000);
            })
        }
        function getAllDepartments(){
            departmentService.getAllDepartments(false).then(function(data){
                vm.allDepartmentList = data;
            },function(error){
                toastrService.showErrorToastr("Could not fetch departments: " + error, "", 5000);
            })
        }
        function getAppointmentPageSpecifiedData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            searchFilteredAppointments();
        }
        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.filterParams.selectedPage = vm.filterParams.selectedPage == 0? 0 : vm.filterParams.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.filterParams.selectedPage = vm.filterParams.selectedPage == vm.filterParams.numberOfPages ? vm.filterParams.selectedPage : vm.filterParams.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.filterParams.selectedPage = searchParams;
            }
        }
        function getTodayAppointments(){
            appointmentLogService.getAllAppointments(getParams(vm.filterParams)).then(onListFetchSuccess,onListFetchFailure);
        }
        function onListFetchSuccess(data){

            vm.isDataLoaded = true;
            vm.appointmentList = data.appointmentLogList;
            vm.filterParams.numberOfPages = data.totalPages;
            vm.numberOfButtons = Array(vm.filterParams.numberOfPages).fill(1);
            vm.total = data.total;
            $scope.$broadcast("refreshFixedColumns");

        }
        function onListFetchFailure(error){
            toastrService.showErrorToastr("Could not fetch the list: " + error, "", 5000);
        }

        $scope.searchVisitor = function (keyword) {
            return appointmentLogService.searchVisitor(keyword.trim()).then(function (data) {
                return data.visitors;
            })
        };

        function setVisitorSearchKeyword(item) {
            vm.filterParams.searchKeyVisitor = item.name;
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.createAppointment')
        .controller('CreateAppointmentCtrl', [ '$stateParams','toastrService', 'visitorCategoryService', 'BLOOD_GROUP', 'employeeService', '$scope', 'visitPurposeService', 'visitorAccessAreaService', 'APPOINTMENT_REPETITION_TYPES', 'APPOINTMENT_INVITATION_TYPES', 'appointmentService', '$uibModal', 'webcamService', '$q','authService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateAppointmentCtrl]);

    /** @ngInject */
    function CreateAppointmentCtrl($stateParams,toastrService, visitorCategoryService, BLOOD_GROUP, employeeService, $scope, visitPurposeService, visitorAccessAreaService, APPOINTMENT_REPETITION_TYPES, APPOINTMENT_INVITATION_TYPES, appointmentService, $uibModal, webcamService, $q, authService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.toggleAdvanced = toggleAdvanced;
        vm.addVisitor = addVisitor;
        vm.removeVisitor = removeVisitor;
        vm.goToNextState = goToNextState;
        vm.selectRepetitionType = selectRepetitionType;
        vm.selectInvitationType = selectInvitationType;
        vm.invalidAppointmentForm = invalidAppointmentForm;
        vm.confirmAppointment = confirmAppointment;
        vm.setVisitorInputs = setVisitorInputs;
        vm.openPhotoCaptureModal = openPhotoCaptureModal;
        vm.goToBackState=goToBackState;

        init();

        function initialiseVariables() {
            vm.currentState = "visitorInformationEntry";
            vm.notAdminDefaultName = authService.getLoggedInUser().name;
            vm.isVisitorManagementAdmin = authService.getLoggedInUser().roles.includes('visitorManagementAdmin');
            // vm.currentState = "hostInformationEntry";
            vm.isDataLoaded = false;
            vm.visitor = initialiseVisitor();
            vm.visitorCategories = [];
            vm.visitors = [];
            vm.bloodGroups = angular.copy(BLOOD_GROUP);
            vm.showAdvancedInputs = false;
            vm.createVisitorForm = null;
            vm.host = {};
            vm.hosts = [];
            vm.createAppointmentForm = null;
            vm.employees = [];
            vm.selectedHost = {};
            vm.hostDropDownList = [];
            vm.datePicker = {};
            vm.appointment = {};
            vm.appointment.date = moment();
            vm.appointment.entryTime = vm.appointment.date;
            vm.appointment.exitTime = vm.appointment.date;
            if (!vm.isVisitorManagementAdmin) {
                vm.selectedHost = {
                    id: authService.getLoggedInUser().id,
                    name: authService.getLoggedInUser().name
                }
            }
            vm.datePicker.options = {
                singleDatePicker : true,
                startDate : moment(),
                minDate : moment(),
                timePicker : false,
                timePicker24Hour : false,
                locale : {
                    format : 'DD MMM YYYY'
                }
            };
            vm.timePicker = {};
            // maxDate : vm.appointment.date.endOf('day'),
            vm.timePicker.options = {
                singleDatePicker : true,
                startDate : moment(),
                endDate : moment(),
                minDate : angular.copy(vm.appointment.date).startOf('day'),
                maxDate : angular.copy(vm.appointment.date).endOf('day'),
                timePicker : true,
                timePicker24Hour : false,
                locale : {
                    format : 'hh:mm A'
                }
            };
            vm.visitPurposes = null;
            vm.selectedVisitPurposeId = [];
            vm.accessAreas = null;
            vm.selectedAccessAreaId = [];
            vm.repetitionTypes = angular.copy(APPOINTMENT_REPETITION_TYPES);
            vm.selectedRepetitionType = 0;
            vm.repetitionTypeDropDownLabel = "";
            vm.invitationTypes = angular.copy(APPOINTMENT_INVITATION_TYPES);
            vm.selectedInvitationType = null;
            vm.invitationTypeDropDownLabel = "";

            vm.existingVisitors = [];
            vm.searchParams={}
            vm.channel = webcamService.webcam.channel;
        }

        function init() {
            initialiseVariables();
            $q.all([
                getExistingVisitors(),
                getVisitorCategories(),
                // getEmployeesForHostSelectionList(),
                getAllVisitPurpose(),
                getAllAccessAreas()
            ]).then(function () {
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }
        vm.searchByEmployeeId = function (selectedEmployee) {
            vm.searchParams.employeeId = selectedEmployee.id;
            vm.searchText = selectedEmployee.name;
        }

        function getVisitorCategories() {
            return visitorCategoryService.getAllVisitorCategories().then(function (data) {
                vm.visitorCategories = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load visitor categories", "", 5000);
            });
        }

        function initialiseVisitor() {
            if($stateParams.visitor != null) return $stateParams.visitor;
            return resetVisitor();

        }
        function resetVisitor(){
            return {
                id: null,
                name: null,
                mobile: null,
                email: null,
                categoryId: null,
                address: null,
                organisationName: null,
                organisationBranch: null,
                organisationAddress: null,
                emergencyContactName: null,
                emergencyContactMobile: null,
                nidNumber: null,
                bloodGroup: null,
                pictureUrl: null,
                pictureUpdated: false,
                status: 1,
            };
        }
        function toggleAdvanced() {
            analyticsService.sendData(ANALYTICS_CONSTANT.advancedOption, document.title + ' - Advanced Option', '', 'Advanced Option In' + document.title, ANALYTICS_CONSTANT.advancedOption);
            vm.showAdvancedInputs = !vm.showAdvancedInputs;
        }

        function addVisitor() {
            toastrService.clearPreviousToastr();
            if(vm.visitor.mobile == null)
                return toastrService.showErrorToastr("Mobile number is required");
            if(vm.visitor.name == null)
                return toastrService.showErrorToastr("Visitor name is required");
            if(vm.visitor.categoryId == null)
                return toastrService.showErrorToastr("Visitor category is required");
            vm.visitors.push(vm.visitor);
            vm.visitor = resetVisitor();
            vm.createVisitorForm.$setPristine();
            vm.createVisitorForm.$setUntouched();
        }

        function removeVisitor(index) {
            vm.visitors.splice(index, 1);
        }

        function isVisitorValid(visitor){
            if(visitor.mobile != null && visitor.status != 2){
                return true;
            }
            return false;
        }
        function goToBackState(){
            if(vm.currentState==="hostInformationEntry"){
                vm.currentState = "visitorInformationEntry"
                vm.visitor=initialiseVisitor();
                // vm.visitors.pop();
            }
        }
        function goToNextState() {
            analyticsService.sendData(ANALYTICS_CONSTANT.next, document.title + ' - Next', '', 'Next In' + document.title, ANALYTICS_CONSTANT.next);
            if(vm.currentState === "visitorInformationEntry") {
                var validVisitors=true
                if(!vm.createVisitorForm.$valid && vm.visitors.length===0){
                    validVisitors=false;
                }else if(vm.createVisitorForm.$valid){
                    vm.visitors.push(vm.visitor);
                }
                vm.visitors.forEach(function (elem){
                    if(!isVisitorValid(elem)){
                        validVisitors=false
                    }
                })
                if(validVisitors){
                    vm.currentState = "hostInformationEntry";
                }
            }
        }

        function getEmployeesForHostSelectionList() {
            if(!vm.isVisitorManagementAdmin){
                vm.employees = [angular.copy(authService.getLoggedInUser())];
                vm.employees.forEach(function (employee) {
                    var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                    if(employee.employeePictureUrl != null && employee.employeePictureUrl !== "") {
                        pictureElement = "<img src='" + employee.employeePictureUrl + "' />";
                    }
                    var designationNameElement = "";
                    var departmentNameElement = "";
                    if(employee.designation != null && employee.designation.name != null && employee.designation.name !== "") {
                        designationNameElement = "<span>" + employee.designation.name + "</span>";
                    }
                    if(employee.department != null && employee.department.name != null && employee.department.name !== "") {
                        departmentNameElement = "<span>" + employee.department.name + "</span>";
                        if(designationNameElement.length > 0)
                            departmentNameElement = ", " + departmentNameElement;
                    }

                    var optionTemplate = "<div class='flex-container text-left width-95'>" +
                        "<div class='with-round-bg mb-0'>" +
                        pictureElement +
                        "</div>" +
                        "<div class='profile-info'>" +
                        "<span>" + employee.name + "</span>" +
                        "<div class='font-12 info-bg'>" +
                        "<small>" +
                        designationNameElement + departmentNameElement +
                        "</small>" +
                        "</div>" +
                        "</div>" +
                        "</div>";

                    var obj = {
                        id: employee.id,
                        name: employee.name,
                        label: optionTemplate,
                        employeeOfficeId: employee.employeeOfficeId,
                        ticked: false
                    };
                    vm.hostDropDownList.push(obj);
                    vm.selectedHost.push({'id':obj.id});
                    vm.hostDropDownList[0]['ticked']=true;
                });
                return $q.defer().resolve(null);
            }
            return employeeService.getFilteredEmployees({status: 1}).then(function (data){
                vm.employees = angular.copy(data.employees);
                generateHostSelectionOptions();
            });


        }

        function generateHostSelectionOptions() {
            vm.employees.forEach(function (employee) {
                var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                if(employee.pictureUrl != null && employee.pictureUrl !== "") {
                    pictureElement = "<img src='" + employee.pictureUrl + "' />";
                }
                var designationNameElement = "";
                var departmentNameElement = "";
                if(employee.designationName != null && employee.designationName !== "") {
                    designationNameElement = "<span>" + employee.designationName + "</span>";
                }
                if(employee.departmentName != null && employee.departmentName !== "") {
                    departmentNameElement = "<span>" + employee.departmentName + "</span>";
                    if(designationNameElement.length > 0)
                        departmentNameElement = ", " + departmentNameElement;
                }

                var optionTemplate = "<div class='flex-container text-left width-95'>" +
                    "<div class='with-round-bg mb-0'>" +
                    pictureElement +
                    "</div>" +
                    "<div class='profile-info'>" +
                    "<span>" + employee.name + "</span>" +
                    "<div class='font-12 info-bg'>" +
                    "<small>" +
                    designationNameElement + departmentNameElement +
                    "</small>" +
                    "</div>" +
                    "</div>" +
                    "</div>";

                var obj = {
                    id: employee.id,
                    name: employee.name,
                    label: optionTemplate,
                    employeeOfficeId: employee.employeeOfficeId,
                    ticked: false
                };
                vm.hostDropDownList.push(obj);
            });

        }

        function getAllVisitPurpose() {
            return visitPurposeService.getAllVisitPurpose().then(function (data) {
                vm.visitPurposes = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get visit purpose list: " + error, "", 5000);
            });
        }

        function getAllAccessAreas() {
            return visitorAccessAreaService.getAllAccessAreas().then(function (data) {
                vm.accessAreas = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get visitor access area: " + error, "", 5000);
            });
        }

        function selectRepetitionType(index) {
            vm.selectedRepetitionType = vm.repetitionTypes[index].id;
            if(index !== 0) vm.repetitionTypeDropDownLabel = "- " + vm.repetitionTypes[index].name;
            else vm.repetitionTypeDropDownLabel = "";
        }

        function selectInvitationType(index) {
            vm.selectedInvitationType = vm.invitationTypes[index].id;
            vm.invitationTypeDropDownLabel = "- " + vm.invitationTypes[index].name;
            // else vm.invitationTypeDropDownLabel = "";
        }

        $scope.$watch('vm.appointment.date', function () {
            vm.timePicker.options.startDate = vm.appointment.date;
            vm.timePicker.options.endDate = vm.appointment.date;
            vm.timePicker.options.minDate = angular.copy(vm.appointment.date).startOf('day');
            vm.timePicker.options.maxDate = angular.copy(vm.appointment.date).endOf('day');
            vm.appointment.entryTime=angular.copy(vm.appointment.date);
            vm.appointment.exitTime=angular.copy(vm.appointment.date);
        });

        function invalidAppointmentForm() {
            if(vm.createAppointmentForm.$invalid) return true;
            if(vm.visitors.length === 0) return true;
            if(vm.selectedHost.length === 0) return true;
            if(vm.selectedAccessAreaId.length === 0) return true;
            if(vm.selectedVisitPurposeId.length === 0) return true;
            return false;
        }

        function confirmAppointment() {
            var data = {
                appointmentDate : angular.copy(vm.appointment.date).startOf('day').format('x'),
                entryTime : vm.appointment.entryTime.format('x'),
                exitTime : vm.appointment.exitTime.format('x'),
                hostId : vm.selectedHost.id,
                visitPurposeId : vm.selectedVisitPurposeId[0].id,
                accessAreaId : vm.selectedAccessAreaId[0].id,
                repetitionType : vm.selectedRepetitionType,
                invitationType : vm.selectedInvitationType,
                visitors : vm.visitors
            }
            vm.isDataLoaded = false;
            appointmentService.createAppointment(data).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create', '', 'Create Appointment In' + document.title, ANALYTICS_CONSTANT.create);
                resetForm();
                openSuccessModal();
            }, function (error) {
                vm.isDataLoaded=true;
                toastrService.showErrorToastr("Could not create appointment: " + error, "", 5000);
            });
        }

        function resetForm() {
            if(vm.createVisitorForm != null && typeof vm.createVisitorForm !== 'undefined') {
                vm.createVisitorForm.$setPristine();
                vm.createVisitorForm.$setUntouched();
            }
            if(vm.createAppointmentForm != null && typeof vm.createAppointmentForm !== 'undefined') {
                vm.createAppointmentForm.$setPristine();
                vm.createAppointmentForm.$setUntouched();
            }
            init();
        }

        function getExistingVisitors() {
            return appointmentService.getAvailableVisitors().then(function (data) {
                vm.existingVisitors = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get existing visitors: " + error, "", 5000);
            });
        }

        function setVisitorInputs(item) {
            if(item.status==2){
                toastrService.showErrorToastr("This Visitor Is Blocked")
                vm.visitor=resetVisitor();
                return;
            }
            vm.visitor.id = item.id;
            vm.visitor.name = item.name;
            vm.visitor.email = item.email;
            vm.visitor.categoryId = item.visitorCategoryId;
            vm.visitor.address = item.address;
            vm.visitor.organisationName = item.organisationName;
            vm.visitor.organisationBranch = item.organisationBranch;
            vm.visitor.organisationAddress = item.organisationAddress;
            vm.visitor.emergencyContactName = item.emergencyContactName;
            vm.visitor.emergencyContactMobile = item.emergencyContactMobile;
            vm.visitor.nidNumber = item.nidNumber;
            vm.visitor.bloodGroup = item.bloodGroup;
            if(item.status!=null){
                vm.visitor.status=item.status;
            }
            if(!vm.visitor.pictureUpdated && vm.visitor.pictureUrl == null) vm.visitor.pictureUrl = item.pictureUrl;
        }

        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/modals/success.modal.html',
                size: 'md',
                controller : 'SuccessModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'visitorManagement.successModal.appointmentCreationSuccessMsg';
                    }
                }
            }).result.then(function () {

            });
        }

        function openPhotoCaptureModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/createAppointment/modals/capturePhoto.modal.html',
                size: 'md',
                controller : 'CapturePhotoModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (imgDataUrl) {
                if(imgDataUrl != null) {
                    vm.visitor.pictureUrl = imgDataUrl;
                    vm.visitor.pictureUpdated = true;
                }
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.editAppointment')
        .controller('EditAppointmentCtrl', [ 'myVisitorProfileService','$stateParams','toastrService', 'visitorCategoryService', 'BLOOD_GROUP', 'employeeService', '$scope', 'visitPurposeService', 'visitorAccessAreaService', 'APPOINTMENT_REPETITION_TYPES', 'APPOINTMENT_INVITATION_TYPES', 'appointmentService', '$uibModal', 'webcamService', '$q','$state','authService', 'analyticsService', 'ANALYTICS_CONSTANT', EditAppointmentCtrl]);

    /** @ngInject */
    function EditAppointmentCtrl(myVisitorProfileService,$stateParams,toastrService, visitorCategoryService, BLOOD_GROUP, employeeService, $scope, visitPurposeService, visitorAccessAreaService, APPOINTMENT_REPETITION_TYPES, APPOINTMENT_INVITATION_TYPES, appointmentService, $uibModal, webcamService, $q, $state, authService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;


        vm.toggleAdvanced = toggleAdvanced;
        vm.addVisitor = addVisitor;
        vm.removeVisitor = removeVisitor;
        vm.goToNextState = goToNextState;
        vm.selectRepetitionType = selectRepetitionType;
        vm.selectInvitationType = selectInvitationType;
        vm.invalidAppointmentForm = invalidAppointmentForm;
        vm.confirmAppointment = confirmAppointment;
        vm.setVisitorInputs = setVisitorInputs;
        vm.openPhotoCaptureModal = openPhotoCaptureModal;
        var tempTime;
        vm.isLoadedForTheFirstTime=true;
        init();

        function initialiseVariables() {
            vm.currentState = "visitorInformationEntry";
            vm.notAdminDefaultName = authService.getLoggedInUser().name;
            vm.isVisitorManagementAdmin = authService.getLoggedInUser().roles.includes('visitorManagementAdmin');
            // vm.currentState = "hostInformationEntry";
            vm.isDataLoaded = false;
            vm.visitorData={};
            vm.visitor ={}
            vm.visitorCategories = [];
            vm.visitors = [];
            vm.bloodGroups = angular.copy(BLOOD_GROUP);
            vm.showAdvancedInputs = false;
            vm.createVisitorForm = null;
            vm.host = {};
            vm.hosts = [];
            vm.createAppointmentForm = null;
            vm.employees = [];
            vm.selectedHost = {};
            vm.hostDropDownList = [];
            vm.datePicker = {};
            vm.appointment = {};
            vm.appointment.date = moment();
            vm.appointment.entryTime =angular.copy(vm.appointment.date) ;
            vm.appointment.exitTime = angular.copy(vm.appointment.date);
            vm.datePicker.options = {
                singleDatePicker : true,
                startDate : moment(),
                minDate : moment(),
                timePicker : false,
                timePicker24Hour : false,
                locale : {
                    format : 'DD MMM YYYY'
                }
            };
            vm.timePicker = {};
            // maxDate : vm.appointment.date.endOf('day'),
            vm.timePicker.options = {
                singleDatePicker : true,
                startDate : moment(),
                endDate : moment(),
                minDate : angular.copy(vm.appointment.date).startOf('day'),
                maxDate : angular.copy(vm.appointment.date).endOf('day'),
                timePicker : true,
                timePicker24Hour : false,
                locale : {
                    format : 'hh:mm A'
                }
            };
            vm.visitPurposes = null;
            vm.selectedVisitPurposeId = [];
            vm.accessAreas = null;
            vm.selectedAccessAreaId = [];
            vm.repetitionTypes = angular.copy(APPOINTMENT_REPETITION_TYPES);
            vm.selectedRepetitionType = 0;
            vm.repetitionTypeDropDownLabel = "";
            vm.invitationTypes = angular.copy(APPOINTMENT_INVITATION_TYPES);
            vm.selectedInvitationType = null;
            vm.invitationTypeDropDownLabel = "";

            vm.existingVisitors = [];
            vm.searchParams = {};
            vm.channel = webcamService.webcam.channel;

            if (!vm.isVisitorManagementAdmin) {
                vm.selectedHost = {
                    id: authService.getLoggedInUser().id,
                    name: authService.getLoggedInUser().name
                }
            }
        }

        function init() {
            if($stateParams.appointmentId == null) $state.go('visitorManagement.appointmentLog');
            initialiseVariables(),
            $q.all([
                getExistingVisitors(),
                getVisitorCategories(),
                // getEmployeesForHostSelectionList(),
                getAllVisitPurpose(),
                getAllAccessAreas(),
            ]).then(function () {
                initialiseVisitor()
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function getVisitorCategories() {
            return visitorCategoryService.getAllVisitorCategories().then(function (data) {
                vm.visitorCategories = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load visitor categories", "", 5000);
            });
        }
        vm.searchByEmployeeId = function (selectedEmployee) {
            // console.log(selectedEmployee)
            vm.searchParams.employeeId = selectedEmployee.id;
            vm.searchText = selectedEmployee.name;
        }
        function initialiseVisitor() {
            $q.all([
                //getVisitorInfo($stateParams.visitorId),
                getAppointmentInfo($stateParams.appointmentId)
            ]).then(function () {
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });

            //return resetVisitor();

        }
        function getAppointmentInfo(appointmentId){
           return appointmentService.getAppointmentInfo(appointmentId).then(onAppointmentInfoFetchSuccess,onAppointmentInfoFetchFailure)
        }
        function onAppointmentInfoFetchSuccess(data){
            // console.log(data)
            var tempVisitors=[];
            tempVisitors= data.appointment.visitors.map(function (m){
                return {
                    id: m.visitorId,
                    name: m.visitorName,
                    mobile: m.visitorMobile,
                    email: m.visitorEmail,
                    categoryId: m.visitorCategoryId,
                    address: m.visitorAddress,
                    organisationName: m.visitorOrganisationName,
                    organisationBranch: m.visitorOrganisationBranch,
                    organisationAddress: m.visitorOrganisationAddress,
                    emergencyContactName: m.visitorEmergencyContactName,
                    emergencyContactMobile: m.visitorEmergencyContactNumber,
                    nidNumber: m.visitorNidNumber,
                    bloodGroup: m.visitorBloodGroup,
                    pictureUrl: m.visitorPictureUrl,
                    pictureUpdated: false
                }
            })
            vm.visitors=tempVisitors
            if(vm.isVisitorManagementAdmin){
                vm.selectedHost={
                    id:data.appointment.hostId,
                    name:data.appointment.hostName
                };
                vm.searchKeyword = data.appointment.hostName;

                //console.log(visitorData.visitorProfile.hostId)
                var tempHost=vm.hostDropDownList.find(function(elem){
                    return elem.id==data.appointment.hostId;
                })
                // tempHost['ticked']=true;
            }
            var tempArea=vm.accessAreas.find(function(elem){
                return elem.id==data.appointment.accessAreaId;
            })
            tempArea['ticked']=true;
            vm.selectedAccessAreaId.push({'id':data.appointment.accessAreaId});
            var tempPurpose=vm.visitPurposes.find(function(elem){
                return elem.id==data.appointment.visitPurposeId;
            })
            tempPurpose['ticked']=true;
            vm.selectedVisitPurposeId.push({'id':data.appointment.visitPurposeId});
            vm.appointment.date=moment(data.appointment.dateInMillis)
            tempTime=data.appointment.dateInMillis;
            vm.appointment.entryTime=moment(data.appointment.entryTime)
            vm.appointment.exitTime=moment(data.appointment.exitTime)
            // console.log(vm.appointment.entryTime)
            // console.log(data.appointment)
        }
        function onAppointmentInfoFetchFailure(){

        }
        // function getVisitorInfo(id){
        //     return myVisitorProfileService.getVisitorInfo(id).then(onVisitorInfoFetchSuccess,onVisitorInfoFetchFailure)
        // }
        // function onVisitorInfoFetchSuccess(visitorData){
        //     //vm.visitorData=visitorData;
        //
        //     addExistingVisitor(vm.visitor);
        //     vm.visitor={
        //         id: 2,
        //         name: visitorData.visitorProfile.name,
        //         mobile: visitorData.visitorProfile.mobile,
        //         email: visitorData.visitorProfile.email,
        //         categoryId: visitorData.visitorProfile.visitorCategoryId,
        //         address: visitorData.visitorProfile.address,
        //         organisationName: visitorData.visitorProfile.organisationName,
        //         organisationBranch: visitorData.visitorProfile.organisationBranch,
        //         organisationAddress: visitorData.visitorProfile.organisationAddress,
        //         emergencyContactName: visitorData.visitorProfile.emergencyContactName,
        //         emergencyContactMobile: visitorData.visitorProfile.emergencyContactNumber,
        //         nidNumber: visitorData.visitorProfile.nidNumber,
        //         bloodGroup: visitorData.visitorProfile.bloodGroup,
        //         pictureUrl: visitorData.visitorProfile.pictureUrl,
        //         pictureUpdated: false
        //     }
        //     addExistingVisitor(vm.visitor);
        //    // addExistingVisitor(vm.visitor);
        //
        //     //console.log(vm.visitor)
        // }
        function onVisitorInfoFetchFailure(){

        }
        function resetVisitor(){
            //console.log("Entered")
            return {
                id: null,
                name: null,
                mobile: null,
                email: null,
                categoryId: null,
                address: null,
                organisationName: null,
                organisationBranch: null,
                organisationAddress: null,
                emergencyContactName: null,
                emergencyContactMobile: null,
                nidNumber: null,
                bloodGroup: null,
                pictureUrl: null,
                pictureUpdated: false
            };
        }
        function toggleAdvanced() {
            analyticsService.sendData(ANALYTICS_CONSTANT.advancedOption, document.title + ' - Advanced Option', '', 'Advanced Option In' + document.title, ANALYTICS_CONSTANT.advancedOption);
            vm.showAdvancedInputs = !vm.showAdvancedInputs;
        }

        function addVisitor() {
            toastrService.clearPreviousToastr();
            if(vm.visitor.mobile == null)
                return toastrService.showErrorToastr("Mobile number is required");
            if(vm.visitor.name == null)
                return toastrService.showErrorToastr("Visitor name is required");
            if(vm.visitor.categoryId == null)
                return toastrService.showErrorToastr("Visitor category is required");
            vm.visitors.push(vm.visitor);
            vm.visitor = resetVisitor();
            vm.createVisitorForm.$setPristine();
            vm.createVisitorForm.$setUntouched();
        }
        function addExistingVisitor(visitor) {
            toastrService.clearPreviousToastr();
            if(visitor.mobile == null)
                return toastrService.showErrorToastr("Mobile number is required");
            if(visitor.name == null)
                return toastrService.showErrorToastr("Visitor name is required");
            if(visitor.categoryId == null)
                return toastrService.showErrorToastr("Visitor category is required");
            vm.visitors.push(visitor);
            // console.log(vm.visitors)
            //vm.createVisitorForm.$setPristine();
            //vm.createVisitorForm.$setUntouched();
        }
        function removeVisitor(index) {
            vm.visitors.splice(index, 1);
        }

        function goToNextState() {
            analyticsService.sendData(ANALYTICS_CONSTANT.next, document.title + ' - Next', '', 'Next In' + document.title, ANALYTICS_CONSTANT.next);
            if(vm.currentState === "visitorInformationEntry") {
                if(vm.createVisitorForm.$valid)
                    vm.visitors.push(vm.visitor);
                vm.currentState = "hostInformationEntry"
            }
        }

        function getEmployeesForHostSelectionList() {
            if(!vm.isVisitorManagementAdmin){
                //console.log($q.defer().resolve(null))
                // console.log(authService.getLoggedInUser());
                vm.employees = [angular.copy(authService.getLoggedInUser())];
                vm.employees.forEach(function (employee) {
                    var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                    if(employee.employeePictureUrl != null && employee.employeePictureUrl !== "") {
                        pictureElement = "<img src='" + employee.employeePictureUrl + "' />";
                    }
                    var designationNameElement = "";
                    var departmentNameElement = "";
                    if(employee.designation != null && employee.designation.name != null && employee.designation.name !== "") {
                        designationNameElement = "<span>" + employee.designation.name + "</span>";
                    }
                    if(employee.department != null && employee.department.name != null && employee.department.name !== "") {
                        departmentNameElement = "<span>" + employee.department.name + "</span>";
                        if(designationNameElement.length > 0)
                            departmentNameElement = ", " + departmentNameElement;
                    }

                    var optionTemplate = "<div class='flex-container text-left width-95'>" +
                        "<div class='with-round-bg mb-0'>" +
                        pictureElement +
                        "</div>" +
                        "<div class='profile-info'>" +
                        "<span>" + employee.name + "</span>" +
                        "<div class='font-12 info-bg'>" +
                        "<small>" +
                        designationNameElement + departmentNameElement +
                        "</small>" +
                        "</div>" +
                        "</div>" +
                        "</div>";

                    var obj = {
                        id: employee.id,
                        name: employee.name,
                        label: optionTemplate,
                        employeeOfficeId: employee.employeeOfficeId,
                        ticked: false
                    };
                    vm.hostDropDownList.push(obj);
                    vm.selectedHost.push({'id':obj.id});
                    //console.log(visitorData.visitorProfile.hostId)
                    vm.hostDropDownList[0]['ticked']=true;
                });
                return $q.defer().resolve(null);
            }
            return employeeService.getFilteredEmployees({status: 1}).then(function (data){
                vm.employees = angular.copy(data.employees);
                generateHostSelectionOptions();
            });
        }

        function generateHostSelectionOptions() {
            vm.employees.forEach(function (employee) {
                var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                if(employee.pictureUrl != null && employee.pictureUrl !== "") {
                    pictureElement = "<img src='" + employee.pictureUrl + "' />";
                }
                var designationNameElement = "";
                var departmentNameElement = "";
                if(employee.designationName != null && employee.designationName !== "") {
                    designationNameElement = "<span>" + employee.designationName + "</span>";
                }
                if(employee.departmentName != null && employee.departmentName !== "") {
                    departmentNameElement = "<span>" + employee.departmentName + "</span>";
                    if(designationNameElement.length > 0)
                        departmentNameElement = ", " + departmentNameElement;
                }

                var optionTemplate = "<div class='flex-container text-left width-95'>" +
                    "<div class='with-round-bg mb-0'>" +
                    pictureElement +
                    "</div>" +
                    "<div class='profile-info'>" +
                    "<span>" + employee.name + "</span>" +
                    "<div class='font-12 info-bg'>" +
                    "<small>" +
                    designationNameElement + departmentNameElement +
                    "</small>" +
                    "</div>" +
                    "</div>" +
                    "</div>";

                var obj = {
                    id: employee.id,
                    name: employee.name,
                    label: optionTemplate,
                    employeeOfficeId: employee.employeeOfficeId,
                    ticked: false
                };
                vm.hostDropDownList.push(obj);
            });
        }

        function getAllVisitPurpose() {
            return visitPurposeService.getAllVisitPurpose().then(function (data) {
                vm.visitPurposes = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get visit purpose list: " + error, "", 5000);
            });
        }

        function getAllAccessAreas() {
            return visitorAccessAreaService.getAllAccessAreas().then(function (data) {
                vm.accessAreas = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get visitor access area: " + error, "", 5000);
            });
        }

        function selectRepetitionType(index) {
            vm.selectedRepetitionType = vm.repetitionTypes[index].id;
            if(index !== 0) vm.repetitionTypeDropDownLabel = "- " + vm.repetitionTypes[index].name;
            else vm.repetitionTypeDropDownLabel = "";
        }

        function selectInvitationType(index) {
            vm.selectedInvitationType = vm.invitationTypes[index].id;
            vm.invitationTypeDropDownLabel = "- " + vm.invitationTypes[index].name;
            // else vm.invitationTypeDropDownLabel = "";
        }

        $scope.$watch('vm.appointment.date', function () {
            if(tempTime==vm.appointment.date.format('x')){
                return;
            }else{
                vm.timePicker.options.startDate = vm.appointment.date;
                vm.timePicker.options.endDate = vm.appointment.date;
                vm.timePicker.options.minDate = angular.copy(vm.appointment.date).startOf('day');
                vm.timePicker.options.maxDate = angular.copy(vm.appointment.date).endOf('day');
                vm.appointment.entryTime=angular.copy(vm.appointment.date);
                vm.appointment.exitTime=angular.copy(vm.appointment.date);
            }


        });

        function invalidAppointmentForm() {
            if(vm.createAppointmentForm.$invalid) return true;
            if(vm.visitors.length === 0) return true;
            if(vm.selectedHost.length === 0) return true;
            if(vm.selectedAccessAreaId.length === 0) return true;
            if(vm.selectedVisitPurposeId.length === 0) return true;
            return false;
        }

        function confirmAppointment() {
            //console.log(vm.appointment.entryTime)
            var data = {
                appointmentDate : angular.copy(vm.appointment.date).startOf('day').format('x'),
                entryTime : vm.appointment.entryTime.format('x'),
                exitTime : vm.appointment.exitTime.format('x'),
                hostId : vm.selectedHost.id,
                visitPurposeId : vm.selectedVisitPurposeId[0].id,
                accessAreaId : vm.selectedAccessAreaId[0].id,
                repetitionType : vm.selectedRepetitionType,
                invitationType : vm.selectedInvitationType,
                visitors : vm.visitors
            }

            vm.isDataLoaded = false;
            appointmentService.updateAppointmentInfo($stateParams.appointmentId,data).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Create', '', 'Create Appointment In' + document.title, ANALYTICS_CONSTANT.edit);
                resetForm();
                openSuccessModal();
            }, function (error) {
                toastrService.showErrorToastr("Could not create appointment: " + error, "", 5000);
                resetForm();
            });
        }

        function resetForm() {
            if(vm.createVisitorForm != null && typeof vm.createVisitorForm !== 'undefined') {
                vm.createVisitorForm.$setPristine();
                vm.createVisitorForm.$setUntouched();
            }
            if(vm.createAppointmentForm != null && typeof vm.createAppointmentForm !== 'undefined') {
                vm.createAppointmentForm.$setPristine();
                vm.createAppointmentForm.$setUntouched();
            }
            init();
        }

        function getExistingVisitors() {
            return appointmentService.getAvailableVisitors().then(function (data) {
                vm.existingVisitors = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get existing visitors: " + error, "", 5000);
            });
        }

        function setVisitorInputs(item) {
            if(item.status==2){
                toastrService.showErrorToastr("This Visitor Is Blocked")
                vm.visitor=resetVisitor();
                return;
            }
            vm.visitor.id = item.id;
            vm.visitor.name = item.name;
            vm.visitor.email = item.email;
            vm.visitor.categoryId = item.visitorCategoryId;
            vm.visitor.address = item.address;
            vm.visitor.organisationName = item.organisationName;
            vm.visitor.organisationBranch = item.organisationBranch;
            vm.visitor.organisationAddress = item.organisationAddress;
            vm.visitor.emergencyContactName = item.emergencyContactName;
            vm.visitor.emergencyContactMobile = item.emergencyContactMobile;
            vm.visitor.nidNumber = item.nidNumber;
            vm.visitor.bloodGroup = item.bloodGroup;
            if(!vm.visitor.pictureUpdated && vm.visitor.pictureUrl == null) vm.visitor.pictureUrl = item.pictureUrl;
        }

        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/modals/success.modal.html',
                size: 'md',
                controller : 'SuccessModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'visitorManagement.successModal.editSuccess';
                    }
                }
            }).result.then(function () {
                $state.go('visitorManagement.appointmentLog');
            });
        }

        function openPhotoCaptureModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/createAppointment/modals/capturePhoto.modal.html',
                size: 'md',
                controller : 'CapturePhotoModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (imgDataUrl) {
                if(imgDataUrl != null) {
                    vm.visitor.pictureUrl = imgDataUrl;
                    vm.visitor.pictureUpdated = true;
                }
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
        .controller('SuccessModalCtrl', [ '$uibModalInstance', 'toastrService', 'successMsg', SuccessModalCtrl]);

    /** @ngInject */
    function SuccessModalCtrl($uibModalInstance, toastrService, successMsg) {
        var vm = this;

        vm.successMsg = successMsg;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
        .controller('MyVisitorProfileCtrl', ['myVisitorProfileService','utilService','visitorCategoryService','$uibModal','$q','toastrService', '_','$scope','$state', 'analyticsService', 'ANALYTICS_CONSTANT', MyVisitorProfileCtrl]);

    /** @ngInject */
    function MyVisitorProfileCtrl(myVisitorProfileService, utilService, visitorCategoryService,$uibModal,$q, toastrService, _,$scope,$state, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isDataLoaded = false;
        vm.isVisitorInfoLoaded = false;
        vm.showAllVisitorToggle = 1;
        vm.isAnyRowSelected = false;
        vm.selectedRowIndex = null;
        vm.pageNumber = 0;
        vm.count = 10;
        vm.numberOfPages = 1;
        vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        vm.selectedPage = 0;
        vm.total = 10;
        vm.pageOfUpcomingVisit = 0;
        vm.numberOfPageOfUpcomingVisit = 0;
        vm.rowsPerPage = utilService.setRowsPerPage(10);
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.indexToShow = 1;
        vm.visitorCreatedBy = {};
        vm.visitorCategoryNameToShow = null;
        vm.visitorProfileList = [];
        vm.visitorToShow = {};
        vm.visitorToShow.visitorInfo  =  {};
        vm.visitorToShow.lastVisits = [];
        vm.visitorToShow.upcomingVisit = {};
        vm.searchKeyWord = null;
        vm.isEditPressed = false;
        vm.visitorCategoryList  =  null;

        vm.setSelectedApplicationTypeBlocked=setSelectedApplicationTypeBlocked;
        vm.openCancelAppointmentModal = openCancelAppointmentModal;
        vm.editPressed = editPressed;
        vm.setSelectedApplicationTypeAll = setSelectedApplicationTypeAll;
        vm.setSelectedApplicationTypeUpcoming = setSelectedApplicationTypeUpcoming;
        vm.showVisitorInfoInTheRightColumn = showVisitorInfoInTheRightColumn;
        vm.getVisitorPageSpecifiedData = getVisitorPageSpecifiedData;
        vm.getRightColumnInfo = getRightColumnInfo;
        vm.getPageSpecifiedUpcomingVisit = getPageSpecifiedUpcomingVisit;
        vm.openBlockVisitorModal = openBlockVisitorModal;
        vm.openUnBlockVisitorModal = openUnBlockVisitorModal;
        vm.updateVisitorInfo = updateVisitorInfo;
        vm.getVisitorBasedOnKeyWord = getVisitorBasedOnKeyWord;
        vm.openEdit=openEdit;
        vm.cancelUpdateVisitorInfo=cancelUpdateVisitorInfo;
        init();
        function setSelectedApplicationTypeAll(){
            if(vm.showAllVisitorToggle !== 2){
                vm.showAllVisitorToggle = 2;
                vm.selectedPage = 0;
                getAllVisitors();
            }

        }
        vm.changeState = function (){
            $state.go('visitorManagement.createAppointment',{
                    visitor: getVisitorInfoToSendToAppointment(),
                }
            );
        };
        function openEdit(visitorId,appointmentId){
            $state.go('visitorManagement.editAppointment', {
                    appointmentId: appointmentId,
                }
            );
        }
        function getPageSpecifiedUpcomingVisit(operation){
            if(vm.pageOfUpcomingVisit < vm.numberOfPageOfUpcomingVisit-1 && operation==='increase'){
                vm.pageOfUpcomingVisit++;
                vm.isVisitorInfoLoaded = false;
                getUpcomingVisits(vm.visitorToShow.visitorInfo.id, vm.pageOfUpcomingVisit);
            }
            if(vm.pageOfUpcomingVisit > 0 && operation==='decrease'){
                vm.pageOfUpcomingVisit--;
                vm.isVisitorInfoLoaded = false;
                getUpcomingVisits(vm.visitorToShow.visitorInfo.id, vm.pageOfUpcomingVisit);
            }
        }
        function setSelectedApplicationTypeUpcoming(){
            if(vm.showAllVisitorToggle !== 1){
                vm.showAllVisitorToggle = 1;
                vm.selectedPage=0;
                getUpcomingVisitors();
            }
        }

        //getting blocked visitors
        function setSelectedApplicationTypeBlocked(){
            if(vm.showAllVisitorToggle !== 3){
                vm.showAllVisitorToggle = 3;
                vm.selectedPage=0;
                getBlockedVisitors();
            }
        }
        function getBlockedVisitors(){
            vm.isDataLoaded=false;
            myVisitorProfileService.getBlockedVisitors(vm.selectedPage,vm.count,vm.searchKeyWord).then(onVisitorListFetchSuccess,onVisitorListFetchFailure);
        }


        function openUnBlockVisitorModal(id){
            toastrService.clearPreviousToastr();
            vm.createLeaveCatagoryModal=$uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/myVisitorProfile/modals/unBlockVisitorModal.html',
                size: 'md',
                controller:'UnblockVisitorModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        visitorToUnBlock:function () {
                            return id;
                        }
                    }
            }).result.then(function (){
                onVisitorBlockedSuccess();
            });
        }
        function openBlockVisitorModal(id){
            toastrService.clearPreviousToastr();
            vm.createLeaveCatagoryModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/myVisitorProfile/modals/blockVisitorModal.html',
                size: 'md',
                controller:'BlockVisitorModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        visitorToBlock:function () {
                            return id;
                        }
                    }
            }).result.then(function (){
                onVisitorBlockedSuccess();
            });
        }
        function init(){
            getUpcomingVisitors();
        }
        function getVisitorBasedOnKeyWord(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search);
            if(vm.showAllVisitorToggle == 1){
                vm.selectedPage=0;
                getUpcomingVisitors();
            }
            else if(vm.showAllVisitorToggle == 2){
                vm.selectedPage=0;
                getAllVisitors();
            }
            else if(vm.showAllVisitorToggle == 3){
                vm.selectedPage=0;
                getAllVisitors();
            }
        }
        function onVisitorBlockedSuccess(){
            if(vm.showAllVisitorToggle == 1){
                getUpcomingVisitors();
            }
            else if(vm.showAllVisitorToggle == 2){
                getAllVisitors();
            }
            else if(vm.showAllVisitorToggle == 3){
                getAllVisitors();
            }
        }

        function editPressed(index, visitorId){
            visitorCategoryService.getAllVisitorCategories().then(function(data) {
                onVisitorCategoryListFetchSuccess(data);
                showVisitorInfoInTheRightColumn(index, visitorId);
                vm.isEditPressed = true;
            }, onVisitorCategoryListFetchFailure);
            // if(vm.isAnyRowSelected == false)
        }

        function onVisitorCategoryListFetchSuccess(visitorCategoryList){
            vm.visitorCategoryList = visitorCategoryList;
        }

        function onVisitorCategoryListFetchFailure(error){
            toastrService.showErrorToastr('Error: ' + error, '', 5000);
        }
        function showVisitorInfoInTheRightColumn(index, visitorId){
            vm.isAnyRowSelected = true;
            vm.selectedRowIndex = index;
            vm.isEditPressed = false;
            vm.isVisitorInfoLoaded = false;
            vm.pageOfUpcomingVisit = 0;
            vm.numberOfPageOfUpcomingVisit = 0;
            vm.getRightColumnInfo(visitorId);

        }
        function openCancelAppointmentModal(id){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/appointmentLog/appointmentLogModal/appointmentCancelModal.html',
                size: 'md',
                controller:'AppointmentCancelModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        appointmentToCancel:function () {
                            return id;
                        }
                    }
            }).result.then(function (){
                onAppointmentCancelSuccess();
            });
        }
        function onAppointmentCancelSuccess(){
            showVisitorInfoInTheRightColumn(vm.selectedRowIndex,vm.visitorToShow.visitorInfo.id)
        }
        function getRightColumnInfo(id){
            if(id)
                $q.all([getUpcomingVisits(id,vm.pageOfUpcomingVisit),getVisitorInfo(id),getVisitorHistory(id)]).then(function () {
                    vm.isVisitorInfoLoaded = true;
                }, function (error) {
                    toastrService.showErrorToastr("Error: " + error, "", 5000);
                });
            else{
                vm.isVisitorInfoLoaded = true;
            }
        }
        function getVisitorInfo(id){
            return myVisitorProfileService.getVisitorInfo(id).then(onVisitorInfoFetchSuccess,onVisitorInfoFetchFailure)
        }
        function updateVisitorInfo(id){
            toastrService.clearPreviousToastr();
            if(vm.visitorToShow.visitorInfo.visitorCategoryId == null)
                toastrService.showErrorToastr("Please select a category");
            else{
                var data = {
                    name                  : vm.visitorToShow.visitorInfo.name,
                    mobile                : vm.visitorToShow.visitorInfo.mobile,
                    email                 : vm.visitorToShow.visitorInfo.email,
                    visitorCategoryId     : vm.visitorToShow.visitorInfo.visitorCategoryId,
                    address               : vm.visitorToShow.visitorInfo.address,
                    organisationName      : vm.visitorToShow.visitorInfo.organisationName,
                    emergencyContactName  : vm.visitorToShow.visitorInfo.emergencyContactName,
                    emergencyContactNumber: vm.visitorToShow.visitorInfo.emergencyContactNumber,
                }
                return myVisitorProfileService.updateVisitorInfo(id, data).then(onVisitorUpdateFetchSuccess,onVisitorInfoFetchFailure);
            }
        }
        function cancelUpdateVisitorInfo(){
            vm.isEditPressed = false;
        }
        function getUpcomingVisitors(){
            vm.isDataLoaded = false;

            myVisitorProfileService.getUpcomingVisitors(vm.selectedPage,vm.count,vm.searchKeyWord).then(onVisitorListFetchSuccess,onVisitorListFetchFailure);
        }
        function getAllVisitors(){
            vm.isDataLoaded = false;
            myVisitorProfileService.getAllVisitors(vm.selectedPage,vm.count,vm.searchKeyWord).then(onVisitorListFetchSuccess,onVisitorListFetchFailure);
        }
        function onVisitorInfoFetchFailure(error){
            toastrService.showErrorToastr("Info Fetch Failed: " + error, "", 5000);
            console.error("Info Fetch Failed");
        }
        function onVisitorInfoFetchSuccess(data){
            vm.visitorToShow.visitorInfo = data.visitorProfile;
            vm.visitorCreatedBy = data.visitorProfile.createdBy;
            vm.visitorCategoryNameToShow = data.visitorProfile.visitorCategoryName;

        }
        function onVisitorUpdateFetchSuccess(data){
            analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit', '', 'Edit Visitor Profile In' + document.title, ANALYTICS_CONSTANT.edit);
            vm.isEditPressed = false;
            vm.visitorToShow.visitorInfo = data.visitorProfile;
            vm.visitorCreatedBy = data.visitorProfile.createdBy;
            vm.visitorCategoryNameToShow = data.visitorProfile.visitorCategoryName;
            toastrService.showSuccessToastr("Visitor profile updated successfully");
        }
        function onVisitorListFetchSuccess(data){
            vm.visitorProfileList = data.visitorList;
            vm.numberOfPages = data.totalPages;
            vm.total = data.total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.isDataLoaded = true;
        }
        function onVisitorListFetchFailure(){
        }

        function getVisitorPageSpecifiedData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            if(vm.showAllVisitorToggle == 1){
                getUpcomingVisitors();
            }
            else if(vm.showAllVisitorToggle == 2){
                getAllVisitors();
            }
            else if(vm.showAllVisitorToggle == 3){
                getBlockedVisitors();
            }
        }
        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.selectedPage = vm.selectedPage == 0? 0 : vm.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.selectedPage = vm.selectedPage == vm.numberOfPages ? vm.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.selectedPage = searchParams;
            }
        }
        function getUpcomingVisits(visitorId,page){
            return myVisitorProfileService.getUpcomingVisit(visitorId,page).then(function(data){
                vm.visitorToShow.upcomingVisit = data.upcomingVisit;
                vm.numberOfPageOfUpcomingVisit = data.totalPages;

            },function (err){
                toastrService.showErrorToastr("Error: " + err, "", 5000);
                console.error(err);
            });
        }
        function getVisitorHistory(visitorId){
            return myVisitorProfileService.getVisitorHistory(visitorId).then(onVisitorHistoryFetchSuccess,onVisitorHistoryFetchFailure);

        }
        function getVisitorInfoToSendToAppointment(){
            var visitorToSend = {
                id                    : vm.visitorToShow.visitorInfo.id,
                name                  : vm.visitorToShow.visitorInfo.name,
                mobile                : vm.visitorToShow.visitorInfo.mobile,
                email                 : vm.visitorToShow.visitorInfo.email,
                categoryId            : vm.visitorToShow.visitorInfo.visitorCategoryId,
                address               : vm.visitorToShow.visitorInfo.address,
                organisationName      : vm.visitorToShow.visitorInfo.organisationName,
                organisationBranch    : null,
                organisationAddress   : null,
                emergencyContactName  : vm.visitorToShow.visitorInfo.emergencyContactName,
                emergencyContactMobile: vm.visitorToShow.visitorInfo.emergencyContactNumber,
                nidNumber             : null,
                bloodGroup            : null,
                pictureUrl            : vm.visitorToShow.visitorInfo.visitorPictureUrl,
                pictureUpdated        : false
            }
            return visitorToSend;
        }
        function onVisitorHistoryFetchSuccess(data){
            vm.visitorToShow.lastVisits = data;
        }
        function onVisitorHistoryFetchFailure(data){
            toastrService.showErrorToastr("Failed to Fetch History", "", 5000);
            console.error("Failed to Fetch History");
        }
    }

})();

(function(){
    'use strict';

    angular
        .module('InovaceClientApp.pages.main.visitorManagement.myVisitorProfile',[])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('visitorManagement.visitorProfile', {
                url: '/my-visitor-profile',
                views : {
                    'visitorManagement' : {
                        templateUrl:'app/pages/main/visitorManagement/myVisitorProfile/myVisitorProfile.html',
                        controller : 'MyVisitorProfileCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'My Visitor Profile',
                roles: ['GENERAL_USER'],
                // generalUserPermitted : true,
                analyticsTitle:'My Visitor Profile',
                analyticsHeaderTitle:'Visitor Management',
                sidebarMeta: {
                    order: 195
                },
                data :{code: '11001'},
            })
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.reception')
        .controller('ReceptionCtrl', [ 'toastrService', 'visitorCategoryService', 'BLOOD_GROUP', 'employeeService', '$scope', 'visitPurposeService', 'visitorAccessAreaService', 'APPOINTMENT_REPETITION_TYPES', 'APPOINTMENT_INVITATION_TYPES', 'appointmentService', '$uibModal', ReceptionCtrl]);

    /** @ngInject */
    function ReceptionCtrl(toastrService, visitorCategoryService, BLOOD_GROUP, employeeService, $scope, visitPurposeService, visitorAccessAreaService, APPOINTMENT_REPETITION_TYPES, APPOINTMENT_INVITATION_TYPES, appointmentService, $uibModal) {
        var vm = this;

        init();
        function init() {

        }
        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/modals/success.modal.html',
                size: 'md',
                controller : 'SuccessModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return '';
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';
    angular
        .module('BlurAdmin.theme.components')
        .controller('TutorialViewModalController', ['$scope', 'authService', '$uibModalInstance', 'moduleId', 'VIDEO_URLS', '$sce', TutorialViewModalController]);

    /** @ngInject */
    function TutorialViewModalController($scope, authService, $uibModalInstance, moduleId, VIDEO_URLS, $sce) {
        var vm = this;

        vm.title = "";
        vm.src = "";

        vm.hasTutorial = hasTutorial;

        vm.closeModal = closeModal;
        vm.getSrc = getSrc;

        function hasTutorial() {
            if(!moduleId || !VIDEO_URLS[moduleId].title || VIDEO_URLS[moduleId].title == null || VIDEO_URLS[moduleId].title == 0){
                return false;
            } else{
                vm.title = VIDEO_URLS[moduleId].title;
                vm.src = VIDEO_URLS[moduleId].src;
                return true;
            }
        }


       function getSrc(src) {
            return $sce.trustAsResourceUrl(src);
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.auth')
        .controller('PayrollActivationNotifierModalCtrl', ['$scope', '$stateParams', '$state', '$timeout','$uibModalInstance', 'authService', 'employeeService', 'toastr', 'payrollManagementService','utilService', PayrollActivationNotifierModalCtrl]);

    /** @ngInject */
    function PayrollActivationNotifierModalCtrl($scope, $stateParams, $state, $timeout, $uibModalInstance, authService, employeeService, toastr, payrollManagementService,utilService) {
        var vm = this;
        vm.goToPayrollSettingsPage = goToPayrollSettingsPage;

        function goToPayrollSettingsPage (){
            $uibModalInstance.close();
            $state.go('payroll.payrollSettings');
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('LeaveManagementCtrl', ['$scope','$stateParams', '$uibModal', 'authService','remainingLeaveService', 'generalSettingsService', 'leaveManagementService', 'utilService', 'toastrService','$sce','_','employeeService', LeaveManagementCtrl]);

    /** @ngInject */
    function LeaveManagementCtrl($scope, $stateParams, $uibModal, authService, remainingLeaveService, generalSettingsService, leaveManagementService, utilService, toastrService,$sce,_,employeeService) {

        var vm = this;
        vm.isLeaveAllowed = null;

        var employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
        vm.earnedLeaveEnabledCategoryIds = [];
        vm.availableCategoryIds = [];
        vm.increaseOrDecreaseMonth = increaseOrDecreaseMonth;
        vm.loadDataForSelectedYear = loadDataForSelectedYear;
        vm.fetchDateRanges = fetchDateRanges;
        vm.setSelectedLeaveApplicationStatuses = setSelectedLeaveApplicationStatuses;
        vm.getAllLeavesOfAnEmployee = getAllLeavesOfAnEmployee;
        vm.searchLeaveApplicationRecord = searchLeaveApplicationRecord;
        vm.showDetailedLeaveInfoInTheRightColumn = showDetailedLeaveInfoInTheRightColumn;
        vm.openAdjustModal = openAdjustModal;
        vm.openCancelModal = openCancelModal;
        vm.getCurrentAndPreviousLeaveApplicationData = getCurrentAndPreviousLeaveApplicationData;
        vm.openApplyForLeaveModal = openApplyForLeaveModal;
        vm.isEligibleForModification = isEligibleForModification;

        function initializeVariables(){
            vm.remainingLeavesList = null;
            vm.leaveList = null;
            vm.selectedYear = new Date().getFullYear();
            vm.isRemainingLeaveDataLoaded = false;
            vm.isDataLoaded = false;
            vm.isRowSelected = false;
            vm.isAdjustDataLoded = false;
            vm.selectedRow = 0;
            vm.selectedLeaveApplicationStatuses = [0,1,2,3];
            vm.allLeaveApplicationData = [];
            vm.numberOfPages = 0;
            vm.numberOfButtons = 0;
            vm.selectedPaginationPage = 0;
            vm.selectedLeaveApplication = null;
            vm.currentAndPreviousLeaveApplicationData =  null;
            var employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
            if (vm.isLeaveAllowed == null) checkLeaveEligibility();

            // Initialize with default values first
            vm.dateRangeList = [];
            vm.selectedDateRange = null;
            vm.fiscalYearStartDate = null;
            vm.fiscalYearEndDate = null;
            vm.selectedFiscalYear = '';
        }

        function getTakenAndRemainingLeaveData(){
            loadDataForSelectedYear();
            getAllLeaveApplicationsOfAnEmployee();
            searchLeaveApplicationRecord();
        }
        function init() {
            initializeVariables();
            fetchDateRanges().then(function() {
                getTakenAndRemainingLeaveData();
            });
        }

        initialStage();
        // when user will go to the next page, all value should be reset
        function initialStage(){
            vm.currentAndPreviousLeaveApplicationData = null
            vm.selectedLeaveApplication = null;
            vm.isRowSelected = false;
            vm.selectedRow = 0;
        }

        function increaseOrDecreaseMonth(command) {
            var currentIndex = vm.dateRangeList.indexOf(vm.selectedDateRange);

            if (command === 'increase' && currentIndex > 0) {
                vm.selectedDateRange = vm.dateRangeList[currentIndex - 1];
            } else if (command === 'decrease' && currentIndex < vm.dateRangeList.length - 1) {
                vm.selectedDateRange = vm.dateRangeList[currentIndex + 1];
            } else {
                return; // No more ranges to navigate
            }
            parseSelectedDateRange();
            getTakenAndRemainingLeaveData();
        }
        function showDetailedLeaveInfoInTheRightColumn(selectedRow, id){
            vm.isAdjustDataLoded = true;
            vm.isRowSelected = true;
            vm.currentAndPreviousLeaveApplicationData =  null;
            vm.selectedLeaveApplication = null;
            vm.selectedLeaveApplication = angular.copy(vm.allLeaveApplicationData.leaveLogList[selectedRow]);
            vm.selectedLeaveApplication.firstApprovalDisplayString = $sce.trustAsHtml(vm.selectedLeaveApplication.firstApprovalDisplayString);
            vm.selectedLeaveApplication.secondApprovalDisplayString = $sce.trustAsHtml(vm.selectedLeaveApplication.secondApprovalDisplayString);
            vm.selectedLeaveApplication.firstApprovalComment = $sce.trustAsHtml(vm.selectedLeaveApplication.firstApprovalComment || "No Comment");
            vm.selectedLeaveApplication.secondApprovalComment = $sce.trustAsHtml(vm.selectedLeaveApplication.secondApprovalComment || "No Comment");
            vm.selectedRow = selectedRow;
            if(vm.selectedLeaveApplication.applicationEventType == 2){
                vm.isAdjustDataLoded = false;
                getCurrentAndPreviousLeaveApplicationData(vm.selectedLeaveApplication.id);
            }


        }

        function setSelectedLeaveApplicationStatuses(data){
            initialStage();

            vm.selectedLeaveApplicationStatuses  = data;
            vm.leaveApplicationData = [];
            vm.selectedPaginationPage = 0;
            searchLeaveApplicationRecord();
        }

        function searchLeaveApplicationRecord(query){
            initialStage();

            if(query && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var params = getAllLeavesOfAnEmployee();
            vm.isDataLoaded = false;
            vm.allLeaveApplicationData = [];
            vm.leaveApplicationData = [];
            employeeService.getAllLeavesOfAnEmployee(params, employeeId).then(function (data){
                vm.allLeaveApplicationData = data;
                preparePaginationInfo(data.totalRecords, data.totalPages);
                vm.isDataLoaded = true;
            });
        }

        function getAllLeavesOfAnEmployee() {
            return {
                page: vm.selectedPaginationPage,
                status: vm.selectedLeaveApplicationStatuses,
                count:8
            }
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfButtons.length-1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage-1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage < vm.numberOfPages - 1 ? vm.selectedPaginationPage + 1 : vm.numberOfPages - 1;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function preparePaginationInfo(totalRecords, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.totalRecords = totalRecords;
        }

        //Updated & Previous Details API call
        function getCurrentAndPreviousLeaveApplicationData(leaveLogId){
             employeeService.getCurrentAndPreviousLeaveApplicationData(leaveLogId).then(function (data){
                 vm.currentAndPreviousLeaveApplicationData = data;
                 vm.isAdjustDataLoded = true;
                 vm.isRowSelected = true;
             },function (error){
                 vm.isRowSelected = true;
             })

        }

        //For Adjust modal
        function openAdjustModal(index) {
            toastrService.clearPreviousToastr();
            // if(vm.currentAndPreviousLeaveApplicationData.id != vm.allLeaveApplicationData.leaveLogList[index].id)
            //     showDetailedLeaveInfoInTheRightColumn(index);
            // if(!vm.currentAndPreviousLeaveApplicationData)
            //     return toastr.error("Please select a row first")
            if(vm.allLeaveApplicationData.leaveLogList[index].type === 2)
                return toastrService.showInfoToastr("Adjusting Half Day Leaves is not supported yet. Please try again later",'', 5000);
            if(vm.earnedLeaveEnabledCategoryIds.includes(vm.allLeaveApplicationData.leaveLogList[index].categoryId))
                return toastrService.showInfoToastr("Adjusting leaves of " + vm.allLeaveApplicationData.leaveLogList[index].categoryName +
                    " category is not supported yet. Please try again later", '', 5000);
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/leave-adjust/leaveAdjust.modal.html',
                size: 'lg',
                controller: 'LeaveAdjustModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                     leaveInfo: function() {
                         return {
                             leaveCategoryList : vm.remainingLeavesList,
                             leaveLogInfo :  vm.allLeaveApplicationData.leaveLogList[index]
                         }
                     }
                }
            }).result.then(function (data){
                init();
            });
        }

        //For Cancel Modal
        function openCancelModal(index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/leave-cancel/leaveCancel.modal.html',
                size: 'lg',
                controller: 'LeaveCancelModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    updatedLeaveInfo : function (){
                        return{
                           leaveLogInfo :  vm.allLeaveApplicationData.leaveLogList[index]
                        }
                    }
                }
            }).result.then(function (data){
                init();
            });
        }


        //************** Previous Code ****************
        function getAllLeaveApplicationsOfAnEmployee() {
            var params = null;
            if(vm.fiscalYearStartDate && vm.fiscalYearEndDate){
                params = {
                    params : {
                        fiscalYearStartDate : vm.fiscalYearStartDate,
                        fiscalYearEndDate : vm.fiscalYearEndDate
                    }
                };
            }
            leaveManagementService.getAllLeaveApplicationsOfAnEmployeeInFiscalYear(employeeId, params).then(function (leaveList) {
                vm.leaveList = leaveList;
                vm.leaveList = _.map(leaveList,function (leave) {
                    leave.firstApprovalDisplayString = $sce.trustAsHtml(leave.firstApprovalDisplayString);
                    leave.secondApprovalDisplayString = $sce.trustAsHtml(leave.secondApprovalDisplayString );
                    return leave;
                })
            });
        }


        function loadDataForSelectedYear() {
            vm.isRemainingLeaveDataLoaded = false;

            parseSelectedDateRange();
            remainingLeaveService.getAllRemainingLeavesOfEmployeeInFiscalYear(employeeId, vm.fiscalYearStartDate, vm.fiscalYearEndDate).then(function (data) {
                vm.isRemainingLeaveDataLoaded = true;
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
                vm.earnedLeaveEnabledCategoryIds = vm.remainingLeavesList.reduce(function (filtered, remainingLeaveRecord) {
                    if(remainingLeaveRecord.leaveCategoryPolicyConfig.earnedLeaveCriteria !== 0) filtered.push(remainingLeaveRecord.leaveCategoryId);
                    return filtered;
                }, []);
                vm.availableCategoryIds = vm.remainingLeavesList.map(function (remainingLeaveRecord) {
                    return remainingLeaveRecord.leaveCategoryId;
                });
            },function (error) {
                toastrService.showErrorToastr("Could not fetch because " + error, "", 5000);
            });
        }

        function fetchDateRanges() {
            return remainingLeaveService.getDistinctLeaveBalanceDateRanges().then(function (data) {
                vm.dateRangeList = data.dateRanges;
                if (vm.dateRangeList.length > 0) {
                    var index = utilService.findDateRangeIndexContainingToday(vm.dateRangeList);
                    vm.selectedDateRange = vm.dateRangeList[index];
                    parseSelectedDateRange();
                }
                return data;
            }, function (error) {
                console.error("Failed to fetch date ranges: " + error);
            });
        }

        function parseSelectedDateRange() {
            if (!vm.selectedDateRange) return;

            var dates = vm.selectedDateRange.split(" - ");
            // Convert to numbers for API compatibility
            vm.fiscalYearStartDate = moment(dates[0], "MMM YYYY").startOf('month').valueOf();
            vm.fiscalYearEndDate = moment(dates[1], "MMM YYYY").endOf('month').milliseconds(0).valueOf();

            vm.selectedFiscalYear = formatFiscalYearRange(vm.fiscalYearStartDate, vm.fiscalYearEndDate);
        }

        function formatFiscalYearRange(startTs, endTs) {
            var start = new Date(startTs);
            var end = new Date(endTs);
            var startMonth = start.toLocaleString('en-US', { month: 'long' });
            var startYear = start.getFullYear();
            var endMonth = end.toLocaleString('en-US', { month: 'long' });
            var endYear = end.getFullYear();
            return startMonth + " " + startYear + " to " + endMonth + " " + endYear;
        }

        function createEventWatchers() {
            $scope.$on('leave-management-open-apply-modal', openApplyForLeaveModal);
            $scope.$on('leave-tab-select',init);
        }

        createEventWatchers();

        // function getDataAndOpenModal() {
        //     employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
        //     remainingLeaveService.getAllRemainingLeavesOfEmployee(employeeId).then(function (remainingLeavesList) {
        //         vm.remainingLeavesList = remainingLeavesList;
        //         openApplyForLeaveModal();
        //     },function (error) {
        //         toastr.error("Could not fetch because " +error);
        //     });
        // }

        function openApplyForLeaveModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/apply/applyForLeave.modal.html',
                size: 'lg',
                controller: 'ApplyForLeaveModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    employeeId: function () {
                        return employeeId;
                    }
                }
            }).result.then(function (data) {
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
                vm.leaveList = data.leaveLogList;
                init();
                toastrService.showSuccessToastr("Leave application placed.");
            });

        }

        function checkLeaveEligibility() {
            leaveManagementService
                .isEmployeeEligibleForLeave(employeeId)
                .then(function (data) {
                    vm.isLeaveAllowed = data.isEmployeeEligibleForLeave;
                }, function (error) {
                    console.error("Failed to fetch employee leave eligibility : " + error);
                });
        }

        function isEligibleForModification(leaveCategoryId) {
            return vm.availableCategoryIds.includes(leaveCategoryId);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.pendingApprovals')
        .controller('RejectLeaveModalCtrl', ['$uibModalInstance', 'toastrService','analyticsService', 'ANALYTICS_CONSTANT', RejectLeaveModalCtrl]);

    /** @ngInject */
    function RejectLeaveModalCtrl($uibModalInstance, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.comment = null;

        vm.submit = submit;
        var analyticsRejectTitle = 'Reject Pending Approval';
        var analyticsRejectUrl = 'reject-pending-approval';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsRejectTitle, analyticsRejectUrl, 'Reject Pending In' + document.title, ANALYTICS_CONSTANT.open);

        function submit() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsRejectTitle + ' - Reject', analyticsRejectUrl + '/reject', 'Reject Pending Approval In' + document.title, ANALYTICS_CONSTANT.reject)
            if(vm.comment == null || vm.comment == "")
                return toastrService.showErrorToastr("Please give a comment");
            $uibModalInstance.close(vm.comment);
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.absentReport')
        .controller('DailyAbsentReportCtrl',
            ['authService', 'attendanceService', 'utilService', '$stateParams', 'toastrService','analyticsService','ANALYTICS_CONSTANT', 'MODULES', DailyAbsentReportCtrl]);

    /** @ngInject */
    function DailyAbsentReportCtrl(authService, attendanceService, utilService, $stateParams, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;

        vm.search = search;


        var loggedInUser = authService.getLoggedInUser();
        vm.attDateInMillis = $stateParams.attDateInMillis;
        vm.employmentTypeIds = $stateParams.employmentTypeIds;
        vm.subsidiaryIds = $stateParams.subsidiaryIds;
        vm.workplaceIds = $stateParams.workplaceIds;
        vm.allAttendanceData = [];
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.type = "absents";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.getRowsPerPage = getRowsPerPage;
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: true,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            if($stateParams.attDateInMillis){
                vm.searchParams.from = vm.attDateInMillis;
                vm.searchParams.to = vm.attDateInMillis + (24 * 60 * 60 * 1000 - 1);
            }
            if($stateParams.employmentTypeIds){
                vm.searchParams.employmentTypeId = vm.employmentTypeIds;
            }
            if($stateParams.subsidiaryIds){
                vm.searchParams.subsidiaryId = vm.subsidiaryIds;
            }
            if($stateParams.workplaceIds){
                vm.searchParams.workplaceId = vm.workplaceIds;
            }
            vm.fromTime = new Date(searchParams.from);
            vm.searchParams.reportType = 3;
            vm.searchParams.absentType = 1;
            attendanceService.getDailyAbsentReport(vm.searchParams).then(function (data) {
                vm.allAbsentData = data.absentResponseForAllEmployees;
                vm.excelUrl = attendanceService.getDailyAbsentReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getDailyAbsentReportPdfUrl(vm.searchParams);
                vm.totalAbsent = data.totalAbsent;
                vm.totalLossHour = data.totalLossHour;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.totalEmployee = data.totalEmployee;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.date = data.date

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = 'daily';
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.absentReport')
        .controller('MonthlyAbsentReportCtrl',
            ['authService', 'attendanceService', 'utilService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', MonthlyAbsentReportCtrl]);

    /** @ngInject */
    function MonthlyAbsentReportCtrl(authService, attendanceService, utilService, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;

        vm.search = search;


        var loggedInUser = authService.getLoggedInUser();
        vm.allAbsnetData = [];
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.type = "absents";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.fromTime = new Date();
        vm.getRowsPerPage = getRowsPerPage;
        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter : {
                show : true,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function getRowsPerPage() {
            return Number(utilService.getRowsPerPage());
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.fromTime = new Date(searchParams.from);
            attendanceService.getMonthlyAbsentReport(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getMonthlyAbsentReportExcelUrl(searchParams);
                vm.pdfUrl = attendanceService.getMonthlyAbsentReportPdfUrl(vm.searchParams);
                vm.allAbsentData = data.absent;
                vm.officeName = data.officeName;
                vm.officeLogoUrl = data.officeLogoUrl;
                vm.startDate = data.startDate;
                vm.endDate = data.endDate;
                vm.totalAbsentDay = data.totalAbsentDay;
                vm.totalWorkingHourLoss = data.totalWorkingHourLoss;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.totalEmployee = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.date = data.monthYear;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "monthly";
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.dailyDiningReport')
        .controller('DailyDiningReportCtrl',
            ['$scope','$state','editableOptions','editableThemes','departmentService','shiftGroupService','designationService','employmentTypeService','officeService','authService','workplaceService','employeeService','dashboardService', 'toastrService','utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS','attendanceService', '$sce', 'analyticsService', 'ANALYTICS_CONSTANT', DailyDiningReportCtrl]);

    /** @ngInject */
    function DailyDiningReportCtrl($scope, $state, editableOptions, editableThemes, departmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService,employeeService,dashboardService, toastrService,utilService, $timeout, _, GENDER, EMPLOYEE_STATUS,attendanceService, $sce, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.search = search;
        var loggedInUser = authService.getLoggedInUser();
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.selectedPage = 0;
        vm.reportTable = null;
        vm.totalLunch = 0;
        vm.totalDinner = 0;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: true,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            lunchFilter: {
                show: true,
            },
            dinnerFilter: {
                show: true,
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : true
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.getMealText = function (meal) {
            switch (meal) {
                case 0:
                    return 'No';
                case 1:
                    return 'Yes';
                case 2:
                    return 'Mismatch';
            }
        }

        vm.getMealColor = function (meal) {
            switch (meal) {
                case 0:
                    return 'redText';
                case 1:
                    return 'greenText';
                case 2:
                    return 'orchid-text';
            }
        }

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getDailyDiningReport(vm.searchParams).then(function (data) {
                vm.reportTable = data.dailyDiningReport;
                vm.excelUrl = attendanceService.getDiningReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getDiningReportPdfUrl(vm.searchParams);
                vm.isDataLoaded = true;
                vm.totalLunch = data.totalLunch;
                vm.totalDinner = data.totalDinner;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error,'', 5000);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.reportTable = null;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.detailedDiningReport')
        .controller('DetailedDiningReportCtrl',
            ['$scope','$state','editableOptions','editableThemes','departmentService','shiftGroupService','designationService','employmentTypeService','officeService','authService','workplaceService','employeeService','dashboardService', 'toastrService','utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS','attendanceService', '$sce', 'analyticsService', 'ANALYTICS_CONSTANT', DetailedDiningReportCtrl]);

    /** @ngInject */
    function DetailedDiningReportCtrl($scope, $state, editableOptions, editableThemes, departmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService,employeeService,dashboardService, toastrService,utilService, $timeout, _, GENDER, EMPLOYEE_STATUS,attendanceService, $sce, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.search = search;
        var loggedInUser = authService.getLoggedInUser();
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.selectedPage = 0;
        vm.reportTable = null;
        vm.totalLunch = 0;
        vm.totalDinner = 0;
        vm.dateList = [];
        vm.mealArraySize = 0;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            lunchFilter: {
                show: true,
            },
            dinnerFilter: {
                show: true,
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getDetailedDiningReport(vm.searchParams).then(function (data) {
                vm.reportTable = data.detailedDiningReport;
                vm.excelUrl = attendanceService.getDetailedDiningReportExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getDiningReportPdfUrl(vm.searchParams);
                // vm.excelUrl = '#'
                vm.pdfUrl = '#'
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.dateList = data.dateList;
                vm.mealArraySize = vm.dateList.length * 2;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error,'', 5000);
            });
        }

        vm.getMealText = function (meal) {
            switch (meal) {
                case 0:
                    return 'No';
                case 1:
                    return 'Yes';
                case 2:
                    return 'Mismatch';
            }
        }

        vm.getMealColor = function (meal) {
            switch (meal) {
                case 0:
                    return 'redText';
                case 1:
                    return 'greenText';
                case 2:
                    return 'orchid-text';
            }
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.reportTable = null;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthlyDiningReport')
        .controller('MonthlyDiningReportCtrl',
            ['$scope','$state','editableOptions','editableThemes','departmentService','shiftGroupService','designationService','employmentTypeService','officeService','authService','workplaceService','employeeService','dashboardService', 'toastrService','utilService', '$timeout', '_', 'GENDER', 'EMPLOYEE_STATUS','attendanceService', '$sce', 'analyticsService', 'ANALYTICS_CONSTANT', MonthlyDiningReportCtrl]);

    /** @ngInject */
    function MonthlyDiningReportCtrl($scope, $state, editableOptions, editableThemes, departmentService, shiftGroupService, designationService, employmentTypeService, officeService, authService, workplaceService,employeeService,dashboardService, toastrService,utilService, $timeout, _, GENDER, EMPLOYEE_STATUS,attendanceService, $sce, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.search = search;
        var loggedInUser = authService.getLoggedInUser();
        vm.startOfDayList = [];
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.total = 0;
        vm.searchParams = {};
        vm.reportTable = null;
        vm.totalLunch = 0;
        vm.totalDinner = 0;

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : true
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : true
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        function search(searchParams) {
            makeEverythingEmpty();
            modifyParams(searchParams);
            attendanceService.getMonthlyDiningReport(vm.searchParams).then(function (data) {
                vm.reportTable = data.monthlyDiningReport;
                vm.excelUrl = attendanceService.getMonthlyDiningReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getMonthlyDiningReportPdfUrl(vm.searchParams);
                vm.isDataLoaded = true;
                vm.totalLunch = data.totalLunch;
                vm.totalDinner = data.totalDinner;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error,'', 5000);
            });
        }

        function makeEverythingEmpty() {
            vm.isDataLoaded = false;
            vm.reportTable = null;
            vm.numberOfPages = 0;
            vm.total = 0;
            // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            // vm.selectedPage = data.currentPage;
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.leaveBalanceReport')
        .controller('LeaveBalanceReportCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'authService','utilService', 'employeeService', 'toastrService','attendanceService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', LeaveBalanceReportCtrl]);

    /** @ngInject */
    function LeaveBalanceReportCtrl($scope, $stateParams, $state, $timeout,$uibModal, authService,utilService, employeeService, toastrService,attendanceService, analyticsService, ANALYTICS_CONSTANT, MODULES) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        utilService.setRowsPerPage(10);
        vm.isDataLoaded = false;
        vm.showSpiner = false;
        vm.offset = 0;
        vm.rowsPerPage = 10;
        vm.selectedPage = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.showReportTime = new Date();
        vm.showReportTime = vm.showReportTime.getFullYear()
        vm.searchParams = {}
        vm.showLineManager = false;
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker: {
                show: false,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker: {
                show: false
            },
            yearPicker: {
                show: true
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter: {
                show: false,
                collapsible: false
            },
            deviceFilter: {
                show: false
            },
            leaveCategoryFilter: {
                show: false
            },
            pdfDownloadButton: {
                show: false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };

        vm.search = search;
        vm.uploadSelectedExcelFile = uploadSelectedExcelFile;
        vm.downloadSampleExcel = downloadSampleExcel;


        function search(searchParams) {
            if(!!searchParams.year) vm.selectedYear = searchParams.year;
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.searchParams.year= Number(vm.selectedYear);
            attendanceService.getLeaveBalanceReport(vm.searchParams).then(function (data) {
                vm.allLeaveBalanceData = data.responseForAllEmployees;
                vm.excelUrl = attendanceService.getLeaveBalanceReportExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getLeaveHistoryReportPdfUrl(vm.searchParams);
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                if(vm.allLeaveBalanceData===null) vm.total=0;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.showReportTime = data.monthYear;
                vm.showLineManager = data.showLineManager;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function uploadSelectedExcelFile($file) {
            vm.showSpiner = true;
            var params = {
                year : vm.selectedYear
            }
            if($file == null) return;
            attendanceService.uploadRemainingLeaveBalanceExcel($file, params).then(function (data) {
                vm.excelUploadResponse = data;
                vm.showSpiner = false;
                search(vm.searchParams)
                toastrService.showSuccessToastr("File upload successful");
                openExcelUploadModal();
            }, function (error) {
                vm.showSpiner = false;
                toastrService.showErrorToastr(error, "", 5000);
            });

        }

        function downloadSampleExcel() {
            window.open(attendanceService.downloadSampleExcel(vm.searchParams, vm.selectedYear),'_blank', '');
        }

        function openExcelUploadModal() {
            // toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/uploadLeaveBalance/modal/excelModal.html',
                size: 'md',
                controller: 'ExcelModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    responseInfo : function (){
                        return vm.excelUploadResponse;
                    }
                }
            }).result.then(function (data){

            });
        }


    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.leaveHistoryReport')
        .controller('LeaveHistoryReportCtrl',
            ['authService', 'attendanceService', 'utilService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', LeaveHistoryReportCtrl]);

    /** @ngInject */
    function LeaveHistoryReportCtrl(authService, attendanceService, utilService, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm = this;

        vm.search = search;


        var loggedInUser = authService.getLoggedInUser();
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.type = "absents";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.fromTime = new Date();
        vm.showLineManager = false;
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.subsidiaryView = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.getRowsPerPage = getRowsPerPage;
        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker: {
                show: false,
                collapsible: false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker: {
                show: true,
                collapsible: false
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            subDepartmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : vm.subsidiaryView
            },
            statusFilter: {
                show: true,
                collapsible: true
            },
            leaveStatusFilter: {
                show: true,
                collapsible: false
            },
            deviceFilter: {
                show: false
            },
            leaveCategoryFilter: {
                show: true
            },
            pdfDownloadButton: {
                show: true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: true
            }
        };

        vm.getStatusColor = function(approvalStatus){
            switch (approvalStatus) {
                case 0:
                    return 'text-warning';
                case 1:
                    return 'text-success';
                case 2:
                    return 'text-danger';
                default:
                    return '';
            }
        }
        vm.getStatusText = function(approvalStatus){
            switch (approvalStatus) {
                case 0:
                    return 'Pending';
                case 1:
                    return 'Approved';
                case 2:
                    return 'Rejected';
                default:
                    return 'Unknown';
            }
        };

        function getRowsPerPage() {
            return Number(utilService.getRowsPerPage());
        }

        function search(searchParams) {
            vm.isDataLoaded = false;
            modifyParams(searchParams);
            vm.fromTime = new Date(searchParams.from);
            vm.searchParams.employeeBeforeEndTime = true;
            attendanceService.getLeaveHistoryReport(vm.searchParams).then(function (data) {
                vm.allLeaveHistory = data.responseForAllEmployees;
                vm.excelUrl = attendanceService.getLeaveHistoryReportExcelUrl(vm.searchParams);
                vm.pdfUrl = attendanceService.getLeaveHistoryReportPdfUrl(vm.searchParams);
                vm.totalEmployee = data.totalEmployee;
                vm.totalApprovedStatus = data.totalApprovedStatus;
                vm.totalLeaveDays = data.totalLeaveDays;
                vm.totalLossHour = data.totalLossHour;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.monthYear = data.monthYear;
                vm.showLineManager = data.showLineManager;
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.mobilePunchReport')
        .controller('ShowLocationImgModalCtrl', [ '$uibModalInstance', 'imageInfo', ShowLocationImgModalCtrl]);

    /** @ngInject */
    function ShowLocationImgModalCtrl($uibModalInstance, imageInfo) {
        var vm = this;

        vm.locationName = imageInfo.locationName;
        vm.imgSrc = imageInfo.pictureUrl;
        vm.exitImgSrc = imageInfo.exitPictureUrl;
        vm.entryTime = imageInfo.entryTime;
        vm.exitTime = imageInfo.exitTime;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.locationTrackingReport')
        .controller('ShowMultipleLocationMapModalCtrl', ShowMultipleLocationMapModalCtrl);

    /** @ngInject */
    function ShowMultipleLocationMapModalCtrl($scope, $q, $sce, $stateParams, $state, API, $timeout, $uibModal, $uibModalInstance, utilService, authService, employeeService, attendanceService, analyticsService, ANALYTICS_CONSTANT, toastrService, siteManagementService, employeeLocations) {
        var vm = this;
        vm.FIVEMINUTE = 1000 * 60 * 5;

        if (employeeLocations) {
            vm.locations = employeeLocations.locations;
            vm.employeeName = employeeLocations.employeeName;
            vm.employeeId = employeeLocations.employeeId;
            vm.officeId = employeeLocations.officeId;
            vm.employeeStartTime = employeeLocations.employeeStartTime;
            vm.employeeEndTime = employeeLocations.employeeEndTime;
            vm.employeeTotalworkingHour = employeeLocations.employeeTotalWorkingHour;
            vm.currentDate = employeeLocations.currentDate;
            vm.currentDateInMilliSecond = employeeLocations.currentDateInMilliSecond;
            vm.pageNumber = employeeLocations.pageNumber;
            vm.perPage = employeeLocations.perPage;
            vm.startDay = employeeLocations.startDay;
            vm.endDay = employeeLocations.endDay;
        } else {


        }
        var filterStartTime = new Date(vm.currentDateInMilliSecond);
        filterStartTime.setHours(0, 1, 0, 0);
        vm.filterStartTime = filterStartTime;

        var filterEndTime = new Date(vm.currentDateInMilliSecond);
        filterEndTime.setHours(23, 59, 0, 0);
        vm.filterEndTime = filterEndTime;

        vm.loggedInUser = authService.getLoggedInUser();
        vm.companyId = vm.loggedInUser.office.company.id;
        vm.excelUrl = "";
        vm.searchParams = {};
        vm.mapKey = API.googleApiKey;
        vm.showMarker = false;
        var map;
        var markers = [];
        var polyline;


        vm.exportAsExcel = exportAsExcel;
        vm.searchByTime = searchByTime;
        vm.changeShowMarker = changeShowMarker;

        vm.currentDateMoment = moment(vm.currentDateInMilliSecond);

        vm.startDatePicker = {
            options: {
                singleDatePicker: true,
                autoApply: true,
                showDropdowns: true,
                maxDate: moment(),
                locale: {
                    format: 'DD MMM YYYY'
                }
            }
        };
        vm.onDateChange = onDateChange;

        function onDateChange() {
            // force the selected date to be 00:00:00 (midnight)
            vm.currentDateMoment.startOf('day');
            vm.currentDateInMilliSecond = vm.currentDateMoment.valueOf();

            var filterStartTime = new Date(vm.currentDateInMilliSecond);
            filterStartTime.setHours(0, 0, 0, 0);
            vm.filterStartTime = filterStartTime;

            var filterEndTime = new Date(vm.currentDateInMilliSecond);
            filterEndTime.setHours(23, 59, 59, 999);
            vm.filterEndTime = filterEndTime;

            console.log('Corrected date changed:', vm.currentDateMoment.format());

            fetchLocationDataForSelectedDate();
        }

        $scope.$watch(function () {
            return vm.currentDateMoment;
        }, function (newVal, oldVal) {
            if (newVal !== oldVal) {
                vm.onDateChange();
            }
        });

        function fetchLocationDataForSelectedDate() {
            var fetchParams = {
                companyId: vm.companyId,
                officeId: vm.officeId,
                employeeName: vm.employeeName,
                employeeId: vm.employeeId,
                from: vm.filterStartTime.getTime(),
                to: vm.filterEndTime.getTime(),
                perPage: 50,
                pageNumber: 0,
                sortKey: 'reportPosition',
                order: 'asc',
                status: 1,
                dinnerFilter: -1,
                lunchFilter: -1
            };

            attendanceService.getLocationTrackReport(fetchParams).then(function (data) {
                vm.locations = [];

                for (var empId in data.employeeLocationTrackingResponseMap) {
                    if (data.employeeLocationTrackingResponseMap.hasOwnProperty(empId)) {
                        var empData = data.employeeLocationTrackingResponseMap[empId];
                        vm.locations = empData.employeeLocationDetailsResponse || [];
                        vm.employeeStartTime = empData.startTime;
                        vm.employeeEndTime = empData.endTime;
                        vm.employeeTotalworkingHour = empData.totalWorkingTime;
                        break;
                    }
                }

                vm.currentDate = data.date;
                vm.currentDateInMilliSecond = data.selectedDateInMilliSecond;
                initMap(vm.locations);
            }, function (error) {
                toastrService.showErrorToastr("Failed to fetch data for selected date");
            });
        }

        function exportAsExcel() {
            vm.searchParams.employeeId = vm.employeeId;
            vm.searchParams.from = vm.startDay;
            vm.searchParams.to = vm.endDay;
            vm.searchParams.perPage = vm.locations.length;
            vm.searchParams.pageNumber = vm.pageNumber;
            vm.searchParams.companyId = vm.companyId;
            vm.searchParams.officeId = vm.officeId;
            vm.excelUrl = attendanceService.getLocationTrackingReportExcel(vm.searchParams);

            if (vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                var deferred = $q.defer();
                var url = vm.excelUrl;
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ', ANALYTICS_CONSTANT.downloadExcel);
                setTimeout(function () {
                    window.open(url, '_blank', '');
                    deferred.resolve();
                }, 0);

                return deferred.promise;
            }
        }

        function searchByTime() {
            var startMillis = vm.filterStartTime.getTime();
            var endMillis = vm.filterEndTime.getTime();

            vm.filteredLocations = vm.locations.filter(function (loc) {
                if (loc.endTime === null) {
                    return loc.startTime >= startMillis && loc.startTime <= endMillis;
                }
                return loc.startTime >= startMillis && loc.endTime <= endMillis;
            });

            if (vm.filteredLocations.length > 0) {
                initMap(vm.filteredLocations);
            } else {
                //toastrService.showErrorToastr('No location data found in selected time range');
            }
        }

        function changeShowMarker(){
            //vm.showMarker = !vm.showMarker;
            //console.log(vm.showMarker);
            if (vm.locations.length > 0) {
                drawMarker(vm.locations);
            }
        }

        function initMap(locationsToRender) {
            if (!document.getElementById('map')) {
                return;
            }
            if (!locationsToRender || locationsToRender.length === 0) {
                return;
            }
            if (!map) {
                map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 10,
                    center: {lat: locationsToRender[0].latitude, lng: locationsToRender[0].longitude}
                });
            }

            // Clear existing markers and polyline
            markers.forEach(function (marker) {
                marker.setMap(null);
            });
            markers = [];

            if (polyline) {
                polyline.setMap(null);
                polyline = null;
            }
            // Math.abs(location.startTime - location.endTime) > vm.FIVEMINUTE
            var locationBounds = new google.maps.LatLngBounds();
            var locationList = [];
            // console.log(locationsToRender);
            locationsToRender.forEach(function (location, index) {
                var isFirst = index === 0;
                var isLast = index === locationsToRender.length - 1;

                var position = {lat: location.latitude, lng: location.longitude};
                var iconUrl = '';
                var iconSize = 30;
                var shouldShow = false;

                if (isFirst) {
                    iconUrl = '../assets/img/theme/icon/mapPin/Start-2.png';
                    iconSize = 50;
                    shouldShow = true;
                } else if (isLast) {
                    iconUrl = '../assets/img/theme/icon/mapPin/End-2.png';
                    iconSize = 50;
                    shouldShow = true;
                } else if (!!location.startTime && !isNaN(location.startTime) && !!location.endTime && !isNaN(location.endTime)) {
                    if(Math.abs(location.endTime - location.startTime) > (5*60*1000)) {
                        iconUrl = '../assets/img/theme/icon/mapPin/Middle-3.png';
                        iconSize = 40;
                        shouldShow = true;
                    }else if(vm.showMarker){
                        iconUrl = '../assets/img/theme/icon/mapPin/Middle-4.png';
                        shouldShow = true;
                    }
                }else if(location.endTime==undefined){
                    if(vm.showMarker){
                        iconUrl = '../assets/img/theme/icon/mapPin/Middle-4.png';
                        shouldShow = true;
                    }
                }

                if(shouldShow) {
                    var marker = new google.maps.Marker({
                        position: position,
                        map: map,
                        title: location.locationName,
                        icon: {
                            url: iconUrl,
                            scaledSize: new google.maps.Size(iconSize, iconSize)
                        }
                    });
                    var infoWindowContent = location.locationName=="" ? '' : '<strong>' + location.locationName + '</strong><br>';
                    if (location.locationStartTime !== "--") {
                        infoWindowContent += location.locationStartTime;
                    }
                    if (location.locationEndTime !== "--") {
                        infoWindowContent += ' - ' + location.locationEndTime;
                    }
                    var infoWindow = new google.maps.InfoWindow({content: infoWindowContent});
                    marker.addListener('mouseover', function () {
                        infoWindow.open(map, marker);
                    });
                    marker.addListener('mouseout', function () {
                        infoWindow.close();
                    });
                    //console.log(marker);
                    markers.push(marker);
                }
                locationBounds.extend(position);
                locationList.push(position);
            });

            map.fitBounds(locationBounds);
            // console.log(locationList);
            polyline = new google.maps.Polyline({
                path: locationList,
                geodesic: true,
                strokeColor: '#5681cf',
                strokeOpacity: 1.0,
                strokeWeight: 4,
                icons: [{
                    icon: {
                        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        scale: 2,
                        strokeColor: '#5681cf'
                    },
                    offset: '100%',
                    repeat: '200px'
                }]
            });
            polyline.setMap(map);
        }

        function drawMarker(locationsToRender) {
            // Clear existing markers and polyline
            markers.forEach(function (marker) {
                marker.setMap(null);
            });
            markers = [];

            // Math.abs(location.startTime - location.endTime) > vm.FIVEMINUTE
            var locationBounds = new google.maps.LatLngBounds();
            var locationList = [];
            // console.log(locationsToRender);
            locationsToRender.forEach(function (location, index) {
                var isFirst = index === 0;
                var isLast = index === locationsToRender.length - 1;
                var position = {lat: location.latitude, lng: location.longitude};
                var iconUrl = '';
                var iconSize = 30;
                var shouldShow = false;

                if (isFirst) {
                    iconUrl = '../assets/img/theme/icon/mapPin/Start-2.png';
                    iconSize = 50;
                    shouldShow = true;
                } else if (isLast) {
                    iconUrl = '../assets/img/theme/icon/mapPin/End-2.png';
                    iconSize = 50;
                    shouldShow = true;
                } else if (!!location.startTime && !isNaN(location.startTime) && !!location.endTime && !isNaN(location.endTime)) {
                    if(Math.abs(location.endTime - location.startTime) > (5*60*1000)) {
                        iconUrl = '../assets/img/theme/icon/mapPin/Middle-3.png';
                        iconSize = 40;
                        shouldShow = true;
                    }else if(vm.showMarker){
                        iconUrl = '../assets/img/theme/icon/mapPin/Middle-4.png';
                        shouldShow = true;
                    }
                }else if(location.endTime==undefined){
                    if(vm.showMarker){
                        iconUrl = '../assets/img/theme/icon/mapPin/Middle-4.png';
                        shouldShow = true;
                    }
                }

                if(shouldShow) {
                    var marker = new google.maps.Marker({
                        position: position,
                        map: map,
                        title: location.locationName,
                        icon: {
                            url: iconUrl,
                            scaledSize: new google.maps.Size(iconSize, iconSize)
                        }
                    });
                    var infoWindowContent = location.locationName=="" ? '' : '<strong>' + location.locationName + '</strong><br>';
                    if (location.locationStartTime !== "--") {
                        infoWindowContent += location.locationStartTime;
                    }
                    if (location.locationEndTime !== "--") {
                        infoWindowContent += ' - ' + location.locationEndTime;
                    }
                    var infoWindow = new google.maps.InfoWindow({content: infoWindowContent});
                    marker.addListener('mouseover', function () {
                        infoWindow.open(map, marker);
                    });
                    marker.addListener('mouseout', function () {
                        infoWindow.close();
                    });
                    //console.log(marker);
                    markers.push(marker);
                }
                locationBounds.extend(position);
                locationList.push(position);
            });
            //map.fitBounds(locationBounds);
        }


        function loadGoogleMapsAPI(callback) {
            if (window.google && window.google.maps) {
                callback();
            } else {
                var script = document.createElement('script');
                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + vm.mapKey;
                script.async = true;
                script.defer = true;
                script.onload = callback;
                document.head.appendChild(script);
            }
        }

        $timeout(function () {
            loadGoogleMapsAPI(function () {
                initMap(vm.locations); // full list at first
            });
        }, 0);

    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.mobilePunchReport')
        .controller('ShowLocationImgModalCtrl', [ '$uibModalInstance', 'imageInfo', ShowLocationImgModalCtrl]);

    /** @ngInject */
    function ShowLocationImgModalCtrl($uibModalInstance, imageInfo) {
        var vm = this;

        vm.locationName = imageInfo.locationName;
        vm.imgSrc = imageInfo.pictureUrl;
        vm.exitImgSrc = imageInfo.exitPictureUrl;
        vm.entryTime = imageInfo.entryTime;
        vm.exitTime = imageInfo.exitTime;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.mobilePunchReport')
        .controller('ShowLocationMapModalCtrl', ['$scope', "$sce", '$stateParams', '$state', "API", '$timeout', '$uibModal', '$uibModalInstance', 'utilService', 'authService', 'employeeService', 'toastrService', 'siteManagementService', 'mobilePunch', ShowLocationMapModalCtrl]);

    /** @ngInject */
    function ShowLocationMapModalCtrl($scope, $sce, $stateParams, $state, API, $timeout, $uibModal, $uibModalInstance, utilService, authService, employeeService, toastrService, siteManagementService, mobilePunch) {
        var vm = this;
        vm.mobilePunch = mobilePunch;
        vm.mapKey = API.googleApiKey;
        vm.mapUrl = $sce.trustAsResourceUrl("https://www.google.com/maps/embed/v1/place?key=" + vm.mapKey + "&center=" + vm.mobilePunch.latitude + "," + vm.mobilePunch.longitude + "&q=" + vm.mobilePunch.latitude + "," + vm.mobilePunch.longitude)

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.individualSalaryComparison')
        .controller('IndividualSalaryComparison',
            ['authService', 'attendanceService', 'utilService', 'toastrService', IndividualSalaryComparison]);

    /** @ngInject */
    function IndividualSalaryComparison(authService, attendanceService, utilService, toastrService) {
        var vm = this;

        vm.isDataLoaded = true;

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.salaryComparisonSummary')
        .controller('SalaryComparisonSummaryCtrl',
            ['$scope','authService', 'MONTH_NAMES_SHORT', 'attendanceService', 'utilService','salaryReportService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', SalaryComparisonSummaryCtrl]);

    /** @ngInject */
    function SalaryComparisonSummaryCtrl($scope,authService,MONTH_NAMES_SHORT, attendanceService, utilService,salaryReportService, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isDataLoaded = true;
        vm.search=search;
        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter: {
                show: true
            },
            deviceFilter: {
                show: false
            },
            componentFilter: {
                show: false,
            },
            absenceTypeFilter: {
                show: false,
            },
            monthYearPickerFrom: {
                show: false
            },
            monthYearPickerTo: {
                show: false
            },
            monthYearPickerSalary: {
                show: true
            },
            monthYearPickerComparison: {
                show: true,
                disable: false
            },
            excelDownloadButton: {
                show: true,
            },
            pdfDownloadButton: {
                show: false,
            },
            addButton: {
                show: false,
            },
            uploadButton: {
                show: false,
            },
            downloadDemoExcelButton: {
                show: false,
            },
            downloadBankAdviceLetterButton: {
                show: false,
            },
            deleteButton: {
                show: false,
            },
            sortKey: {
                show: false
            },
            rowPerPage: {
                show: false
            },
            searchByNameIdRfid: {
                show: false
            },
            filterByNetPayment: {
                show: false
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };


        vm.objectOfSalaryComponents = [];
        vm.monthPickerSalary = {};
        vm.monthPickerSalary.opened = false;
        vm.monthPickerSalary.format = "MMM yyyy";
        vm.monthPickerSalary.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };
        vm.monthPickerComparison = {};
        vm.monthPickerComparison.opened = false;
        vm.monthPickerComparison.format = "MMM yyyy";
        vm.monthPickerComparison.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };
        vm.isDataLoaded = false;

        // vm.openMonthPickerSalary = openMonthPickerSalary;
        // vm.openMonthPickerComparison = openMonthPickerComparison;




        function search(searchParams) {
            // console.log(searchParams)
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            vm.searchParams.salaryProcessType = "processed";
            vm.selectedMonth = MONTH_NAMES_SHORT[searchParams.salaryMonth-1]
            vm.selectedMonthComparison = MONTH_NAMES_SHORT[searchParams.comparisonMonth-1]
            vm.selectedYear=searchParams.salaryYear
            vm.selectedYearComparison=searchParams.comparisonYear
            salaryReportService.getSalaryComparisonOfTwoMonths(vm.searchParams).then(function (data) {
                // console.log(data)
                vm.allData=data;
                vm.excelUrl = salaryReportService.getSalaryComparisonSummaryExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getDetailedMonthlyReportPdfUrl(vm.searchParams);
                // vm.verticalPdfUrl = attendanceService.getMonthlyVerticalReportPdfUrl(vm.searchParams);
                // vm.employeeInfo = data.employeeSalaries;
                // vm.componentIds = data.componentIds;
                vm.isDataLoaded = true;
                // vm.numberOfPages = data.totalPages;
                // vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                // vm.selectedPage = data.currentPage;
                // vm.total = data.totalRecords;
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });

        }
        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.attendanceReport.monthOnMonthSalaryComparison')
        .controller('MonthOnMonthSalaryComparison',
            ['$scope', 'authService', 'MONTH_NAMES_SHORT', 'payrollManagementService', 'salaryReportService', 'attendanceService', 'utilService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', MonthOnMonthSalaryComparison]);

    /** @ngInject */
    function MonthOnMonthSalaryComparison($scope, authService, MONTH_NAMES_SHORT, payrollManagementService, salaryReportService, attendanceService, utilService, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDataLoaded = true;
        vm.showRemarksInputField = -1
        vm.showRemarksInput = showRemarksInput
        vm.remarksMap = []
        var loggedInUser = authService.getLoggedInUser();
        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter: {
                show: true
            },
            deviceFilter: {
                show: false
            },
            componentFilter: {
                show: false,
            },
            absenceTypeFilter: {
                show: false,
            },
            monthYearPickerFrom: {
                show: false
            },
            monthYearPickerTo: {
                show: false
            },
            monthYearPickerSalary: {
                show: true
            },
            monthYearPickerComparison: {
                show: true,
                disable: true
            },
            excelDownloadButton: {
                show: true,
            },
            pdfDownloadButton: {
                show: false,
            },
            addButton: {
                show: false,
            },
            uploadButton: {
                show: false,
            },
            downloadDemoExcelButton: {
                show: false,
            },
            downloadBankAdviceLetterButton: {
                show: false,
            },
            deleteButton: {
                show: false,
            },
            sortKey: {
                show: false
            },
            rowPerPage: {
                show: true
            },
            searchByNameIdRfid: {
                show: true
            },
            filterByNetPayment: {
                show: false
            },
            leaveStatusFilter: {
                show: false,
                collapsible: false
            }
        };
        vm.searchParams = {};
        vm.isAnyRowSelected = false;
        vm.selectedRowIndex = null;
        vm.selectedRow = null;
        vm.allData = []
        vm.search = search;
        vm.success = false

        vm.showComparisonDetailsInTheRightColumn = showComparisonDetailsInTheRightColumn;
        vm.removeInputField = removeInputField;

        function search(searchParams) {
            vm.isAnyRowSelected = false
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            vm.searchParams.salaryProcessType = "processed";
            vm.salaryMonthName = MONTH_NAMES_SHORT[searchParams.salaryMonth - 1]
            vm.comparisonMonthName = MONTH_NAMES_SHORT[searchParams.comparisonMonth - 1]
            payrollManagementService.getMonthOnMonthComparison(vm.searchParams).then(function (data) {
                vm.excelUrl = salaryReportService.getMonthOnMonthComparisonReportExcelUrl(vm.searchParams);
                vm.employeeInfo = data.employeeSalaries;
                vm.remarksMap = data.empIdToComponentIdAndRemarksMap;
                vm.componentIds = data.componentIds;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.totalRecords;
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        vm.totalSalary = 0;
        vm.totalComparisonSalary = 0;

        function showComparisonDetailsInTheRightColumn(index) {
            vm.selectedRow = vm.employeeInfo[index];
            vm.selectedRowIndex = index;
            vm.isAnyRowSelected = true;
        }

        vm.getAbsCalculatedAmount = getAbsCalculatedAmount;

        function getAbsCalculatedAmount(amount) {
            return Math.abs(amount.toFixed(2));
        }

        vm.createOrUpdateRemarks = createOrUpdateRemarks

        function createOrUpdateRemarks(event, id, empId, componentId) {
            var data = {
                id: id,
                employeeId: empId,
                componentId: componentId,
                salaryMonth: vm.searchParams.salaryMonth,
                salaryYear: vm.searchParams.salaryYear,
                comparisonMonth: vm.searchParams.comparisonMonth,
                comparisonYear: vm.searchParams.comparisonYear,
                remarks: event.target.value
            }
            salaryReportService.createOrUpdateMonthOnMonthComparisonRemarks(data).then(function (response) {
                toastrService.showSuccessToastr("Remarks Saved Successful", "", 5000);
                angular.element(document.querySelector(vm.prevBtnId)).removeClass("d-none")
                $(event.target).addClass("d-none")
            },function (err){
                toastrService.showErrorToastr("Error:" + err, "", 5000);
                console.error(err);
            })
        }

        /*function showRemarksInput(empId, componentId) {
            Object.values(vm.remarksMap[empId]).forEach(function (v) {
                if (v.componentId !== componentId) {
                    vm.remarksMap[empId][v.componentId].isOpen = false;

                }
            });
            vm.remarksMap[empId][componentId].isOpen = true
        }*/
        vm.prevId = "#aaaaaaaaaaa"
        vm.prevBtnId = "#bbbbbbbbbb"

        function showRemarksInput(btnId, inputId) {
            var prevBtn = angular.element(document.querySelector(vm.prevBtnId))
            var currentBtn = angular.element(document.querySelector(btnId))
            currentBtn.addClass('d-none')
            if (vm.prevBtnId !==btnId){
                prevBtn.removeClass('d-none')
            }
            var prevInput = angular.element(document.querySelector(vm.prevId))
            var currentInput = angular.element(document.querySelector(inputId))
            prevInput.addClass('d-none')
            currentInput.removeClass('d-none')
            vm.prevId = inputId
            vm.prevBtnId = btnId
        }

        // function removeInputField(btnId,inputId){
        //     var inputId = angular.element(document.querySelector(inputId))
        //     inputId.addClass('d-none')
        //     var currentBtn = angular.element(document.querySelector(btnId))
        //     currentBtn.removeClass('d-none');
        // }
        function removeInputField(btnId,inputId){
            var inputId = angular.element(document.querySelector(inputId))
            inputId.addClass('d-none')
            var currentBtn = angular.element(document.querySelector(btnId))
            currentBtn.removeClass('d-none');
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.siteAttendanceReport')
        .controller('ReportSiteAttendanceLocationModalCtrl', ['$scope', "$sce", '$stateParams', '$state', "API", '$timeout', '$uibModal', '$uibModalInstance', 'utilService', 'authService', 'employeeService', 'toastrService', 'siteManagementService', 'siteInfo', ReportSiteAttendanceLocationModalCtrl]);

    /** @ngInject */
    function ReportSiteAttendanceLocationModalCtrl($scope, $sce, $stateParams, $state, API, $timeout, $uibModal, $uibModalInstance, utilService, authService, employeeService, toastrService, siteManagementService, siteInfo) {
        var vm = this;
        vm.siteInfo = siteInfo;
        vm.mapKey = API.googleApiKey

        vm.mapUrl = $sce.trustAsResourceUrl("https://www.google.com/maps/embed/v1/place?key=" + vm.mapKey + "&center=" + vm.siteInfo.siteLatitude + "," + vm.siteInfo.siteLongitude + "&q=" + vm.siteInfo.siteLatitude + "," + vm.siteInfo.siteLongitude)

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.siteAttendanceReport')
        .controller('ReportSiteAttendanceEntryExitImageModalCtrl', ['$scope',"$sce", '$stateParams', '$state',"API", '$timeout', '$uibModal','$uibModalInstance','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService','siteInfo', ReportSiteAttendanceEntryExitImageModalCtrl]);

    /** @ngInject */
    function ReportSiteAttendanceEntryExitImageModalCtrl($scope,$sce, $stateParams, $state,API, $timeout,$uibModal,$uibModalInstance,utilService, authService, employeeService, toastrService,siteManagementService,siteInfo) {
        var vm = this;
        vm.siteInfo = siteInfo['data'];

        vm.imageCategory=siteInfo['imageCategory'];

        vm.entryImageUrl=vm.siteInfo.siteInPictureUrl;
        vm.exitImageUrl=vm.siteInfo.siteOutPictureUrl;


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.attendanceReport.siteSummaryReport')
        .controller('ReportLocationModalCtrl', ['$scope',"$sce", '$stateParams', '$state',"API", '$timeout', '$uibModal','$uibModalInstance','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService','siteInfo', ReportLocationModalCtrl]);

    /** @ngInject */
    function ReportLocationModalCtrl($scope,$sce, $stateParams, $state,API, $timeout,$uibModal,$uibModalInstance,utilService, authService, employeeService, toastrService,siteManagementService,siteInfo) {
        var vm = this;

        vm.siteInfo = siteInfo;
        vm.mapKey = API.googleApiKey
        vm.mapUrl = $sce.trustAsResourceUrl("https://www.google.com/maps/embed/v1/place?key="+vm.mapKey+"&center="+vm.siteInfo.latitude+","+vm.siteInfo.longitude+"&q="+vm.siteInfo.latitude+","+vm.siteInfo.longitude)
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('OccupancyPieChartCtrl', ['$scope','$element', 'layoutPaths', 'baConfig','utilService','dashboardService','$interval', OccupancyPieChartCtrl]);

    /** @ngInject */
    function OccupancyPieChartCtrl($scope,$element, layoutPaths, baConfig,utilService,dashboardService,$interval) {
        var layoutColors = baConfig.colors;
        $scope.occupied = null;
        $scope.outside = null;

        getOccupancyDataAndDrawPieChart();
        var promise = $interval(function (){
            getOccupancyDataAndDrawPieChart();
        },60000)
        var pieChart = null;


        function getOccupancyDataAndDrawPieChart(){
            dashboardService.getOccupancy().then(function (data){
                // console.log("Attendance data loaded");
                $scope.occupied = data.occupied;
                $scope.outside = data.outside;
                if(pieChart != null){
                    pieChart.clear();
                    pieChart = null;
                }
                pieChart = AmCharts.makeChart('occupancyPieChart', {
                    type: 'pie',
                    startDuration: .2,
                    startEffect : 'easeInSine',
                    startRadius : '50',
                    theme: 'blur',
                    addClassNames: true,
                    labelText:"[[value]]",
                    labelRadius:-50,
                    fontSize:50,
                    color: "#f1f3f5",
                    labelTickColor: layoutColors.borderDark,
                    legend: utilService.getPieChartLegendConfig(),
                    innerRadius: '40%',
                    defs: utilService.getPieChartDefs(),
                    dataProvider: [
                        {
                            people: 'Occupied',
                            number: data.occupied,
                            color : '#209e91'
                        },
                        {
                            people: 'Outside',
                            number: data.outside,
                            color : '#e85656',
                        },

                    ],
                    valueField: 'number',
                    titleField: 'people',
                    colorField: 'color',
                    export: {
                        enabled: true
                    },
                    // creditsPosition: 'bottom-left',

                    autoMargins: false,
                    marginTop: 10,
                    alpha: 0.8,
                    marginBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                    pullOutRadius: '10%',
                    pathToImages: layoutPaths.images.amChart,
                    responsive: utilService.getPieChartResponsiveProperty()
                });
                pieChart.balloon.fontSize = 12;
                pieChart.animateAgain();
            })

        }

        $scope.$on('$destroy',function (event) {
            $interval.cancel(promise);
        });


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.dashboard')
        .controller('AttendancePieChartCtrl', ['$scope','$element', 'layoutPaths', 'baConfig','utilService','dashboardService','$interval', 'toastr','analyticsService','ANALYTICS_CONSTANT', AttendancePieChartCtrl]);

    /** @ngInject */
    function AttendancePieChartCtrl($scope, $element, layoutPaths, baConfig, utilService, dashboardService, $interval, toastr, analyticsService,ANALYTICS_CONSTANT) {
        var layoutColors = baConfig.colors;
        $scope.employmentTypes = null;
        $scope.totalOccupied = null;
        $scope.colours = ['#d81b60',
                            '#455a64',
                            '#7b1fa2',
                            '#303f9f',
                            '#00838f',
                            '#00695c',
                            '#33691e',
                            '#827717',
                            '#8d6e63',
                            '#757575',
                            '#d32f2f',
                            '#3e2723',
                            '#0277bd',
                            '#bf360c',
                            '#263238'
    ];

        getOccupancyDataAndDrawPieChart();
        var promise = $interval(function (){
            getOccupancyDataAndDrawPieChart();
        },60000)
        var pieChart = null;

        function getOccupancyDataAndDrawPieChart(){
            if(pieChart != null){
                pieChart.clear();
                pieChart = null;
            }
            dashboardService.getOccupancy().then(function (data){
                $scope.employmentTypes = data.employmentTypeWiseOccupancies;
                $scope.totalOccupied = data.totalOccupied;
                pieChart = AmCharts.makeChart('attendancePieChart', {
                    type: 'pie',
                    startDuration: .2,
                    startEffect : 'easeInSine',
                    startRadius : '50',
                    theme: 'blur',
                    addClassNames: true,
                    labelText:"[[value]]",
                    labelRadius:-50,
                    fontSize:40,
                    color: "#f1f3f5",
                    labelTickColor: layoutColors.borderDark,
                    legend: utilService.getPieChartLegendConfig(),
                    innerRadius: '60%',
                    defs: utilService.getPieChartDefs(),
                    dataProvider: getChartDataProvider(),
                    valueField: 'number',
                    titleField: 'people',
                    colorField: 'color',
                    export: {
                        enabled: true
                    },
                    // creditsPosition: 'bottom-left',

                    autoMargins: false,
                    marginTop: 10,
                    alpha: 1.0,
                    marginBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                    pullOutRadius: '10%',
                    pathToImages: layoutPaths.images.amChart,
                    responsive: utilService.getPieChartResponsiveProperty()
                });
                pieChart.balloon.fontSize = 12;
                pieChart.animateAgain();
            })
        }

        function getChartDataProvider() {
            while($scope.employmentTypes.length > $scope.colours.length) {
                $scope.colours.push(utilService.getRandomColor());
            }

            return $scope.employmentTypes.map(function (item, index) {
                return {
                    people: item.employmentTypeName,
                    number: item.occupied,
                    color : $scope.colours[index]
                };
            })
        }

        $scope.$on('$destroy',function (event) {
            $interval.cancel(promise);
        });

        $scope.downloadExcel = function () {
            dashboardService.getOccupancyExcelReport().then(function (response){
                var blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel"
                })
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'occupancy-report-'+ moment().format('DD-MM-YYYY') +'.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Occupancy Dashboard Excel', ANALYTICS_CONSTANT.downloadExcel)
            }, function(error) {
                toastr.error("Could not download excel: " + error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('EditDeviceModalCtrl',['$uibModalInstance', '$scope','authService', 'deviceService', 'workplaceService','officeService', '_', 'toastrService', 'utilService', 'device', 'analyticsService', 'ANALYTICS_CONSTANT', EditDeviceModalCtrl]);

    /** @ngInject */
    function EditDeviceModalCtrl($uibModalInstance, $scope, authService, deviceService, workplaceService, officeService, _, toastrService, utilService, device, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isEditing = false;
        vm.device = device;
        vm.workplaces = [];
        vm.selectedWorkplace = [];
        vm.isDataLoaded = false;

        var analyticsEditTitle = 'Edit Device Info';
        var analyticsEditUrl = 'edit-device-info';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Device Info In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateDeviceInformation = updateDeviceInformation;
        vm.onWorkplaceChanged = onWorkplaceChanged;

        init();

        function init() {
            workplaceService.getAllWorkplaces().then(function (data) {
                vm.workplaces = (data || []).map(function (w) {
                    return {
                        id: w.id,
                        name: w.name,
                        ticked: vm.device.workplaceId != null && w.id === vm.device.workplaceId
                    };
                });

                if (vm.device.workplaceId != null) {
                    var match = vm.workplaces.find(function (w) { return w.id === vm.device.workplaceId; });
                    if (match) {
                        vm.selectedWorkplace = [{ id: match.id, name: match.name }];
                    }
                } else {
                    vm.selectedWorkplace = [];
                }

                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                toastrService.showErrorToastr('Failed to fetch all workplaces : ' + message, '', 5000);
            });
        }

        function onWorkplaceChanged() {
            var sel = (vm.selectedWorkplace && vm.selectedWorkplace[0]) || null;
            vm.device.workplaceId   = sel ? sel.id   : null;
            vm.device.workplaceName = sel ? sel.name : null;
        }

        function updateDeviceInformation() {
            onWorkplaceChanged();

            var data = {
                description: vm.device.description,
                location: vm.device.location,
                workplaceId: vm.device.workplaceId || null,
                workplaceName: vm.device.workplaceName || null
            };

            vm.isEditing = true;
            deviceService.updateDeviceInformation(vm.device.id, data)
                .then(function () {
                    vm.device.description   = data.description;
                    vm.device.location      = data.location;
                    vm.device.workplaceId   = data.workplaceId;
                    vm.device.workplaceName = data.workplaceName;

                    $uibModalInstance.close(vm.device);
                    toastrService.showSuccessToastr("Device information updated.");
                }, function (error) {
                    toastrService.showErrorToastr("Could not update device information because " + error, "", 5000);
                })
                .finally(function () { vm.isEditing = false; });
        }
    }
})();
// (function () {
//     'use strict';
//
//     angular.module('InovaceClientApp.pages.main.devices')
//         .controller('SelectWorkplaceModalCtrl', SelectWorkplaceModalCtrl);
//
//     /** @ngInject */
//     function SelectWorkplaceModalCtrl($uibModalInstance, workplaceService, _, initialSelection, RESPONSE_CODE) {
//         var vm = this;
//
//         vm.query     = '';
//         vm.all       = [];
//         vm.filtered  = [];
//         vm.selected  = null;
//
//         vm.filter  = filter;
//         vm.select  = select;
//         vm.confirm = confirm;
//
//         activate();
//
//         function activate() {
//             // Your service does not use the flag; pass anything (e.g., true) or omit.
//             workplaceService.getAllWorkplaces(true).then(function (list) {
//                 vm.all = list || [];
//                 vm.filtered = vm.all;
//
//                 if (initialSelection && initialSelection.workplaceId) {
//                     var found = _.find(vm.all, { id: initialSelection.workplaceId });
//                     if (found) vm.selected = found;
//                 }
//             }, function () {
//                 vm.all = [];
//                 vm.filtered = [];
//             });
//         }
//
//         function filter() {
//             var q = (vm.query || '').toLowerCase();
//             vm.filtered = !q ? vm.all : _.filter(vm.all, function (w) {
//                 return (w.name || '').toLowerCase().indexOf(q) !== -1 ||
//                     ('' + w.id).indexOf(q) !== -1;
//             });
//         }
//
//         function select(w) {
//             vm.selected = w;
//         }
//
//         function confirm() {
//             $uibModalInstance.close(vm.selected);
//         }
//     }
// })();

// (function () {
//     'use strict';
//
//     angular.module('InovaceClientApp.pages.main.devices')
//         .controller('SelectWorkplaceModalCtrl', SelectWorkplaceModalCtrl);
//
//     /** @ngInject */
//     function SelectWorkplaceModalCtrl($scope, workplaceService, _) {
//         // Parent edit modal controller is "vm" on $parent
//         var parent = $scope.$parent && $scope.$parent.vm;
//
//         var vmLocal = this;     // will be referenced as "wp" from the template
//         vmLocal.query = '';
//         vmLocal.all = [];
//         vmLocal.filtered = [];
//         vmLocal.highlightIndex = -1;
//
//         vmLocal.filter = filter;
//         vmLocal.choose = choose;
//         vmLocal.onKey  = onKey;
//
//         activate();
//
//         function activate() {
//             workplaceService.getAllWorkplaces(true).then(function (list) {
//                 vmLocal.all = list || [];
//                 vmLocal.filtered = vmLocal.all;
//
//                 // Preselect if parent already has a workplaceId
//                 if (parent && parent.device && parent.device.workplaceId) {
//                     var found = _.find(vmLocal.all, { id: parent.device.workplaceId });
//                     if (found) {
//                         // not selecting here—parent shows current value in the input already
//                     }
//                 }
//             }, function () {
//                 vmLocal.all = [];
//                 vmLocal.filtered = [];
//             });
//         }
//
//         function filter() {
//             var q = (vmLocal.query || '').toLowerCase();
//             vmLocal.filtered = !q ? vmLocal.all : _.filter(vmLocal.all, function (w) {
//                 return (w.name || '').toLowerCase().indexOf(q) !== -1 ||
//                     ('' + w.id).indexOf(q) !== -1;
//             });
//             vmLocal.highlightIndex = vmLocal.filtered.length ? 0 : -1;
//         }
//
//         function choose(w) {
//             // Immediately set on parent and hide dropdown
//             if (parent && parent.applySelectedWorkplace) {
//                 parent.applySelectedWorkplace(w);
//             }
//         }
//
//         // Keyboard support (optional)
//         function onKey(e) {
//             if (!vmLocal.filtered || !vmLocal.filtered.length) return;
//
//             var max = vmLocal.filtered.length - 1;
//
//             if (e.key === 'ArrowDown') {
//                 e.preventDefault();
//                 vmLocal.highlightIndex = vmLocal.highlightIndex < max ? vmLocal.highlightIndex + 1 : 0;
//             } else if (e.key === 'ArrowUp') {
//                 e.preventDefault();
//                 vmLocal.highlightIndex = vmLocal.highlightIndex > 0 ? vmLocal.highlightIndex - 1 : max;
//             } else if (e.key === 'Enter') {
//                 e.preventDefault();
//                 if (vmLocal.highlightIndex >= 0) {
//                     choose(vmLocal.filtered[vmLocal.highlightIndex]);
//                 }
//             } else if (e.key === 'Escape') {
//                 if (parent) parent.showWorkplaceDropdown = false;
//             }
//         }
//     }
// })();


(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
        .controller('SelectWorkplaceModalCtrl', SelectWorkplaceModalCtrl);

    /** @ngInject */
    function SelectWorkplaceModalCtrl($scope, workplaceService, _) {
        // Parent edit modal controller is "vm" on $parent
        var parent = $scope.$parent && $scope.$parent.vm;

        var vmLocal = this; // referenced as "wp" in template
        vmLocal.query = '';
        vmLocal.all = [];
        vmLocal.filtered = [];
        vmLocal.highlightIndex = -1;

        vmLocal.filter = filter;
        vmLocal.choose = choose;
        vmLocal.onKey  = onKey;
        vmLocal.setInteracting = setInteracting;

        activate();

        function activate() {
            workplaceService.getAllWorkplaces(true).then(function (list) {
                vmLocal.all = list || [];
                vmLocal.filtered = vmLocal.all;
                if (parent && parent.device && parent.device.workplaceId) {
                    var found = _.find(vmLocal.all, { id: parent.device.workplaceId });
                    if (found) { /* no-op; input shows current value */ }
                }
            }, function () {
                vmLocal.all = [];
                vmLocal.filtered = [];
            });
        }

        function filter() {
            var q = (vmLocal.query || '').toLowerCase();
            vmLocal.filtered = !q ? vmLocal.all : _.filter(vmLocal.all, function (w) {
                return (w.name || '').toLowerCase().indexOf(q) !== -1 ||
                    ('' + w.id).indexOf(q) !== -1;
            });
            vmLocal.highlightIndex = vmLocal.filtered.length ? 0 : -1;
        }

        function choose(w) {
            if (parent && parent.applySelectedWorkplace) {
                parent.applySelectedWorkplace(w);
            }
            setInteracting(false);
        }

        function onKey(e) {
            if (!vmLocal.filtered || !vmLocal.filtered.length) return;
            var max = vmLocal.filtered.length - 1;
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                vmLocal.highlightIndex = vmLocal.highlightIndex < max ? vmLocal.highlightIndex + 1 : 0;
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                vmLocal.highlightIndex = vmLocal.highlightIndex > 0 ? vmLocal.highlightIndex - 1 : max;
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (vmLocal.highlightIndex >= 0) choose(vmLocal.filtered[vmLocal.highlightIndex]);
            } else if (e.key === 'Escape') {
                setInteracting(false);
                if (parent) parent.showWorkplaceDropdown = false;
            }
        }

        function setInteracting(state) {
            if (parent) parent.isInteractingWithDropdown = !!state;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.batchCreateEmployees')
        .controller('BatchCreateCtrl', ['$state', '$window','employeeService','scheduledEmployeeCreateService','toastrService', 'payrollSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT',BatchCreateCtrl]);

    /** @ngInject */
    function BatchCreateCtrl($state, $window, employeeService, scheduledEmployeeCreateService, toastrService, payrollSettingsService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.requests = [];
        vm.batchCreateExcelUrl = employeeService.getBatchCreateExcelUrl();
        vm.file = null;
        vm.officePayrollSettings = null;

        vm.redirectToDownloadSamplePage = redirectToDownloadSamplePage;
        vm.batchCreateEmployees = batchCreateEmployees;
        vm.verifySelectedExcelFile = verifySelectedExcelFile;
        vm.analyticsDownloadSample = analyticsDownloadSample;
        function init() {
            getOfficePayrollSettings();
        }

        init();

        function redirectToDownloadSamplePage() {
            $window.open ("https://docs.google.com/spreadsheets/d/1kTDwyDyywdLtx1dDi2IQ0RT-GnqwePXNsjutQLKEojM/edit?usp=sharing",'_blank');
        }

        function batchCreateEmployees() {
            toastrService.clearPreviousToastr();
            if (vm.file == null) {
                toastrService.showErrorToastr("File not selected or size limit exceeded.");
                return;
            }
            employeeService.batchCreateEmployee(vm.file).then(function (data) {
                toastrService.showSuccessToastr("Employee batch create request successful");
            }, function (errorMessage) {
                console.error(errorMessage);
                toastrService.showErrorToastr("Could not perform batch create request employee : " + errorMessage, "", 5000);
            });
        }

        function verifySelectedExcelFile() {
            if(vm.file == null) {
                // return toastr.error("You haven't selected any file.");
                return;
            }

            $state.go('employees.verifyBatchCreate', {file: vm.file, payrollAvailable: (vm.officePayrollSettings != null), payrollType : (vm.officePayrollSettings != null ? Number(vm.officePayrollSettings.payrollType) : 0)});

        }

        function getOfficePayrollSettings() {
            payrollSettingsService.getPayrollSettingsData().then(function (data){
                vm.officePayrollSettings = data.payrollSettings;
            });
        }
        function analyticsDownloadSample(){
            analyticsService.sendData(ANALYTICS_CONSTANT.downloadSample, document.title + ' - Download Sample', '', 'Download Sample In' + document.title, ANALYTICS_CONSTANT.downloadSample)

        }



    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.batchCreateEmployees')
        .controller('HistoryCtrl', ['$scope','scheduledEmployeeCreateService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', 'authService'
            ,HistoryCtrl]);

    /** @ngInject */
    function HistoryCtrl($scope,scheduledEmployeeCreateService,toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES, authService) {

        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;

        vm.requests = [];

        vm.retry = retry;
        vm.getDisabled = getDisabled;

        function init() {
            $scope.$on('switchedToHistoryTab',getHistory);
            getHistory();
        }

        init();

        function getHistory() {
            scheduledEmployeeCreateService.getAll().then(function (data) {
                vm.requests = data;
                $scope.$broadcast("refreshFixedColumns");
            })
        }

        function retry(index,id) {
            analyticsService.sendData('history/' + ANALYTICS_CONSTANT.retry, document.title + ' - History - Retry Action', '', 'Retry action In' + document.title, ANALYTICS_CONSTANT.retry)

            scheduledEmployeeCreateService.retry(id).then(function () {
                vm.requests[index].status = 1;
            },function (error) {
               toastrService.showErrorToastr("Could not create employee: " + error, "", 5000);
            });
        }

        function getDisabled(request) {
            return request.status !== -1;
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.employees.batchCreateEmployees')
        .controller('UploadConfirmationCtrl', ['$scope', '$state', '$stateParams', 'employeeService', 'payrollSettingsService', 'utilService', 'CREATE_EMPLOYEE_GUARD', 'LimitReachedModal', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT','MODULES', 'authService',UploadConfirmationCtrl]);

    /** @ngInject */
    function UploadConfirmationCtrl($scope, $state, $stateParams, employeeService, payrollSettingsService, utilService, CREATE_EMPLOYEE_GUARD, LimitReachedModal, toastrService, analyticsService, ANALYTICS_CONSTANT,MODULES, authService) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isSubsidiaryModuleEnabled = loggedInUser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;
        vm.isVerificationDone = false;
        vm.colSpan = 12;
        vm.uploadFile = uploadFile;
        vm.getTooltipText = getTooltipText;
        // vm.getTooltipText = getTooltipText;
        validate();


        function validate() {
            if(!$stateParams.file) {
                $state.go('employees.batchCreateEmployees');
                return;
            }
            init();
        }

        function init() {
            vm.file = $stateParams.file;
            vm.payrollType = $stateParams.payrollType;
            vm.payrollAvailable = $stateParams.payrollAvailable;
            vm.existingEmployees = null;
            vm.newEmployees = null;
            vm.hasError = false;
            if(vm.payrollAvailable) vm.colSpan = 17;
            verifySelectedExcelFile();
        }

        function uploadFile() {
            toastrService.clearPreviousToastr();
            if(vm.file == null) {
                return toastrService.showErrorToastr("You haven't selected any file.");
            }
            if (vm.hasError) {
                return toastrService.showErrorToastr("The provided excel file needs correction.");
            }

            var enforce = utilService.hasPermission(CREATE_EMPLOYEE_GUARD.moduleCode);
            var toAdd = Array.isArray(vm.newEmployees) ? vm.newEmployees.length : 0;
            if (!enforce) {
                vm.isVerificationDone = false;
                return employeeService.uploadEmployeeBatchCreateExcel(vm.file).then(onSuccess, onError);
            }

            return employeeService.getActiveEmployeeCount()
                .then(function (current) {
                    var limit = CREATE_EMPLOYEE_GUARD.limit;
                    var projected = current + toAdd;

                    if (projected > limit) {
                        LimitReachedModal.open({ limit: limit, title: 'Employee Limit Reached' });
                        return;
                    }
                    vm.isVerificationDone = false;
                    return employeeService.uploadEmployeeBatchCreateExcel(vm.file).then(onSuccess, onError);
                })
                .catch(function () {
                    LimitReachedModal.open({ limit: CREATE_EMPLOYEE_GUARD.limit, title: 'Employee Limit Check Failed' });
                });

            function onSuccess(data) {
                analyticsService.sendData(
                    ANALYTICS_CONSTANT.uploadExcel,
                    document.title + ' - Upload Excel',
                    '',
                    'Upload Excel In' + document.title,
                    ANALYTICS_CONSTANT.uploadExcel
                );
                toastrService.showSuccessToastr("Employee batch operation successful");
                $state.go('employees.batchCreateEmployees');
            }

            function onError(errorMessage) {
                vm.isVerificationDone = true;
                toastrService.showErrorToastr("Could not perform batch create/update request : " + errorMessage, "");
            }
        }

        function verifySelectedExcelFile() {
            employeeService.verifyEmployeeBatchCreateExcel(vm.file).then(function (data) {
                vm.existingEmployees = data.existingEmployees;
                vm.newEmployees = data.newEmployees;
                vm.hasError = data.hasError;

                // Ensure hasError is set for each employee row
                if (vm.existingEmployees) {
                    vm.existingEmployees.forEach(function(employee) {
                        if (!employee.hasOwnProperty('hasError') && employee.row && employee.row.errorMessages && employee.row.errorMessages.length > 0) {
                            employee.hasError = true;
                        }
                    });
                }
                if (vm.newEmployees) {
                    vm.newEmployees.forEach(function(employee) {
                        if (!employee.hasOwnProperty('hasError') && employee.row && employee.row.errorMessages && employee.row.errorMessages.length > 0) {
                            employee.hasError = true;
                        }
                    });
                }

                vm.isVerificationDone = true;
                $scope.$broadcast("refreshFixedColumns");
                toastrService.showSuccessToastr("Verification completed for the provided excel file");

            }, function (errorMessage) {
                toastrService.showErrorToastr("Could not verify the provided file: " + errorMessage, "");
                $state.go('employees.batchCreateEmployees');
            });

        }

        function getTooltipText(errorMessages) {
            if (!errorMessages || !Array.isArray(errorMessages) || errorMessages.length === 0) {
                return "";
            }
            var errors = "";
            errorMessages.forEach(function (errorMessage){
                if(errors.length === 0) errors += errorMessage;
                else errors += ", " + errorMessage;
           });
            errors += ".";
            return errors;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.fieldVisit')
        .controller('ApplyFieldVisitCtrl', ['employeeService', 'toastrService','attendanceService','utilService','rosterService', 'analyticsService', 'ANALYTICS_CONSTANT', ApplyFieldVisitCtrl]);

    /** @ngInject */
    function ApplyFieldVisitCtrl(employeeService, toastrService,attendanceService,utilService,rosterService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.ids = "";
        vm.approvalNeededFromApprover = 0;
        vm.buttonName = "Submit";

        vm.isdataLoaded = false;
        vm.isEmployeeSelected = false;

        vm.fieldVisitDatePicker = {};
        vm.fieldVisitDatePicker.date = getInitialFromAndToDate();
        vm.fieldVisitEntryTime = new Date(new Date().setHours(9, 0, 0, 0));
        vm.fieldVisitExitTime = new Date(new Date().setHours(17, 0, 0, 0));
        vm.isSubmitting = false;
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.fieldVisitDatePicker.options = {
            // maxDate: moment(),
            minDate : vm.minDate,
            applyClass: 'btn-success',
            locale : {
                applyLabel: "Apply",
                fromLabel: "From",
                format: 'DD-MMM-YYYY', //will give you 6-Jan-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
            },
            eventHandlers : {
                'apply.daterangepicker': getShiftData,
                'hide.daterangepicker' : getShiftData
            },
            ranges: utilService.getDatePickerRanges()
        }
        vm.lastFiveFieldVisitData = [];
        vm.employeeList = [];
        vm.selectedEmployee = [];
        vm.manualEntryList = null;
        vm.isShiftDataLoaded = true;

        vm.employeeToShow = {
            'id' : '0025',
            'name' : 'Khalid Musa Sagar',
            'pictureUrl' : 'https://inovace-client-dev.s3.ap-southeast-1.amazonaws.com/profilepic-2509-Md.KhalidMusaSagar-31672123mm-1621767173.jpeg',
            'departmentName' : 'R&D',
            'designationName' : 'Software Team  Manager',
            'employeeType' : 'Full Time',
            'shift' : 'Regular'
        };

        vm.applyForFieldVisit = applyForFieldVisit;
        vm.onEmployeeSelect = onEmployeeSelect;
        vm.onReset = onReset;

        function getInitialFromAndToDate() {
            return {
                'startDate': moment(),
                'endDate': moment()
            };
        }


        function init(){
            employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            });
        }

        function onReset(){
            vm.employeeToShow = null;
            vm.fieldVisitEntryTime = new Date(new Date().setHours(9, 0, 0, 0));
        }

        function onEmployeeSelect(){
            vm.isEmployeeSelected = true;
            if(vm.selectedEmployee.length == 0) return;
            vm.employeeToShow = null;
            employeeService.getProfile(vm.selectedEmployee[0].id).then(function (data){
                vm.employeeToShow = data.employee;
                getShiftData();
            });
            employeeService.getManualEntryHistoryOfEmployee({type:3},vm.selectedEmployee[0].id).then(function (data){
                vm.lastFiveFieldVisitData = data.manualEntryResponseList;
                vm.isdataLoaded = true;
            })
        }

        init();

        function getShiftData(ev,picker){
            if(vm.employeeToShow != null){
                vm.isShiftDataLoaded = false;
                var givenDay = angular.copy(moment(vm.fieldVisitDatePicker.date.startDate)).format('x');
                rosterService
                    .getShiftTimingOfADayForAShiftGroup({shiftGroupId:vm.employeeToShow.shiftGroupId,startTimeOfDay:givenDay})
                    .then(function (data){
                        vm.fieldVisitEntryTime = new Date(data.startTime);
                        vm.fieldVisitExitTime = new Date(data.endTime);
                        vm.isShiftDataLoaded = true;
                    });
            }

        }

        function changeButtonName(){
            vm.buttonName = "Submit";
        }

        function applyForFieldVisit(){
            toastrService.clearPreviousToastr();
            if(vm.selectedEmployee.length == 0 )
                return toastrService.showErrorToastr("Please select an employee");
            if(!vm.reason)
                return toastrService.showErrorToastr("Reason cannot be empty");
            if(!vm.area)
                return toastrService.showErrorToastr("Area cannot be empty");
            if(vm.fieldVisitEntryTime == null || vm.fieldVisitExitTime == null)
                return toastrService.showErrorToastr("Please select valid from and to times");
            var startDate = new dayjs(Number(vm.fieldVisitDatePicker.date.startDate.format('x')));
            var endDate = new dayjs(Number(vm.fieldVisitDatePicker.date.endDate.format('x')));
            var startTime = new dayjs(Number(vm.fieldVisitDatePicker.date.startDate.format('x'))).hour(Number(vm.fieldVisitEntryTime.getHours())).minute(Number(vm.fieldVisitEntryTime.getMinutes())).second(0);
            var endTime = new dayjs(Number(vm.fieldVisitDatePicker.date.startDate.format('x'))).hour(Number(vm.fieldVisitExitTime.getHours())).minute(Number(vm.fieldVisitExitTime.getMinutes())).second(0);

            var data = {
                employeeId: vm.selectedEmployee[0].id,
                startDate: startDate.startOf('day').valueOf(),
                endDate: endDate.startOf('day').valueOf(),
                entryTime: startTime.valueOf(),
                exitTime: endTime.valueOf(),
                reason: vm.reason,
                type: 3,
                area : vm.area,
                forceApproval: !vm.approvalNeededFromApprover
            };
            vm.buttonName = "Please Wait.."
            vm.isSubmitting = true;
            attendanceService.createManualEntry(data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.apply, document.title  + ' - Apply',  '', 'Apply Field Visit In' + document.title, ANALYTICS_CONSTANT.apply);
                vm.isSubmitting = false;
                toastrService.showSuccessToastr("Manual entry applied");
                changeButtonName();
                vm.isdataLoaded = false;
                employeeService.getManualEntryHistoryOfEmployee({type:3},vm.selectedEmployee[0].id).then(function (data){
                    vm.lastFiveFieldVisitData = data.manualEntryResponseList;
                    vm.isdataLoaded = true;
                });
            },function (error) {
                vm.isSubmitting = false;
                toastrService.showErrorToastr("Could not create manual entry " + error, "", 5000);
                changeButtonName();
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.manageEmployees')
        .controller('EmployeeActionsCtrl', ['_', 'designationService', 'shiftService', 'shiftGroupService', 'departmentService', 'leavePolicyService', 'weeklyOffDaysService',
            'deviceService', 'toastrService', '$stateParams','$state', 'leaveManagementService','$uibModal', 'authService', 'officeService',
            'employeeService', 'lateApprovalManagementService','workplaceService','leaveCategoryService','employmentTypeService',
            'overtimeService','manageEmployeeComponents', 'manageEmployeeComponentsForLineManager', 'notificationGroups','notificationService','siteManagementService','subDepartmentService','accessAreaService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES','$scope', 'BANGABHABAN_OFFICE_ID', 'LINE_MANAGER_MODULE', 'utilService', 'subsidiaryService', EmployeeActionsCtrl]);

    /** @ngInject */
    function EmployeeActionsCtrl(_, designationService, shiftService, shiftGroupService, departmentService, leavePolicyService, weeklyOffDaysService, deviceService, toastrService, $stateParams,$state,
                                 leaveManagementService,$uibModal, authService, officeService, employeeService, lateApprovalManagementService, workplaceService,leaveCategoryService,employmentTypeService,
                                 overtimeService,manageEmployeeComponents, manageEmployeeComponentsForLineManager,notificationGroups, notificationService,siteManagementService,subDepartmentService,accessAreaService, analyticsService, ANALYTICS_CONSTANT, MODULES, $scope, BANGABHABAN_OFFICE_ID, LINE_MANAGER_MODULE, utilService, subsidiaryService) {

        var vm = this;

        vm.allSelected = $stateParams.allSelected;
        vm.select = {};
        vm.select.selectedEmployees = $stateParams.selectedEmployees;
        vm.select.notSelectedEmployees = $stateParams.notSelectedEmployees;
        vm.select.firstLeaveApprovers = [];
        vm.select.secondLeaveApprovers = [];
        vm.select.firstLateApprovers = [];
        vm.select.secondLateApprovers = [];
        vm.select.firstManualEntryApprovers = [];
        vm.select.secondManualEntryApprovers = [];
        vm.select.multiselectEmployees = [];
        vm.select.selectedDesignation = [];
        vm.select.selectedLeavePolicy = null;
        vm.select.selectedSite = [];
        vm.select.selectedSubsidiary = null;

        vm.select.hrManager = [];
        vm.select.lineManager = [];
        vm.select.hrManagerInput = [];
        vm.select.lineManagerInput = [];

        vm.select.leaveCategoryFrom = [];
        vm.select.leaveCategoryTo = [];
        vm.select.selectedLeaveCategoryFrom = [];
        vm.select.selectedLeaveCategoryTo = [];
        vm.select.notificationGroup = angular.copy(notificationGroups);
        vm.select.selectedNotificationGroup = [];
        vm.fromYear = new Date().getFullYear();
        vm.toYear = new Date().getFullYear();
        vm.maxLeaves = 0;

        vm.accessAreaListToAllocate=[];
        vm.accessAreaListToRevoke=[];
        vm.selectedAccessAreaListToAllocate=[];
        vm.selectedAccessAreaListToRevoke=[];

        vm.leavePolicy = {};
        vm.leavePolicy.leavePolicyList = null;
        vm.designation = {};
        vm.designation.designationList = null;
        vm.shift = {};
        vm.shift.shiftList = null;
        vm.shift.shiftGroupList = null;
        vm.department = {};
        vm.department.departmentList = null;
        vm.subDepartment = {};
        vm.subDepartment.subDepartmentList = null;
        vm.subsidiary = {};
        vm.subsidiary.subsidiaryList = null;
        vm.site = {};
        vm.site.siteList = {};
        vm.weeklyOffDaysPolicy = {};
        vm.weeklyOffDaysPolicy.weeklyOffDaysPolicyList = null;
        vm.devices = [];
        vm.devicesForBatchAllocation = [];
        vm.devicesForBatchRevoke = [];
        vm.selectedDevice = null;
        vm.selectedDevicesForAllocation = [];
        vm.selectedDevicesForRevoke = [];
        vm.datePicker = {};
        vm.datePicker.fromTime = new moment();
        vm.datePicker.toTime = new moment();
        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.temporarySelectedDevice = [];
        vm.selectedFirstApprover = [];
        vm.selectedSecondApprover = [];
        vm.selectedFirstLateApprover = [];
        vm.selectedSecondLateApprover = [];

        vm.selectedFirstManualEntryApprover = [];
        vm.selectedSecondManualEntryApprover = [];

        vm.isCompanyAdmin = false;
        vm.officeList = [];
        vm.selectedOffice = [];
        vm.workplaceList = [];
        vm.selectedWorkplace = [];
        vm.employmentTypeList = [];
        vm.selectedEmploymentTypeList = [];
        var loggedInuser = authService.getLoggedInUser();
        vm.isSubsidiaryModuleActivate = loggedInuser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiarySuperAdmin = loggedInuser['modules'].includes(MODULES.SUBSIDIARY) && loggedInuser.isAdmin && loggedInuser.subsidiaryId === null;
        vm.isSubsidiaryAdmin = loggedInuser['modules'].includes(MODULES.SUBSIDIARY) && loggedInuser.isAdmin && loggedInuser.subsidiaryId !== null;
        vm.uiComponents = initialiseUiComponents();
        vm.selectedUiComponents = [];
        vm.uiComponentsToShow = [];
        vm.isApproversListInitialized = false;
        vm.loadingTableData = false;
        // Line manager activation 2017
        // --- NEW: Line Manager module gate (code '2017')
                vm.canAssignLineManager = false;
                try {
                       var _mods = authService.getPermittedModules() || [];
                       // normalize to strings (e.g., [2017] or ['2017']) and check
                            vm.canAssignLineManager = utilService.hasPermission(LINE_MANAGER_MODULE); // for testing don't use 2017

                    } catch (e) {
                        vm.canAssignLineManager = false; // fail closed
                    }
                // If not permitted, hide the option from the Select Actions input list
                    if (!vm.canAssignLineManager && Array.isArray(vm.uiComponents)) {
                        vm.uiComponents = vm.uiComponents.filter(function (c) { return c.value !== 'assignLineManager'; });
                    }

        // Line manager activation ends





        //Notification Stuff

        vm.selfCheckBoxes = [
            {valueIndex:1, id : 'selfSmsCheckBox', labelText:'employeeActions.notification.typeSMS', value:false},
            {valueIndex:2, id : 'selfEmailCheckBox', labelText:'employeeActions.notification.typeEmail', value:false},
            {valueIndex:3, id : 'selfPushCheckbox', labelText:'employeeActions.notification.typePush', value:false},
        ];
        vm.lineManagerCheckBoxes = [
            {valueIndex:1,id : 'lmSMSCheckbox',labelText:'employeeActions.notification.typeSMS', value:false},
            {valueIndex:2,id : 'lmEmailCheckBox',labelText:'employeeActions.notification.typeEmail',value:false},
            {valueIndex:3,id : 'lmPushCheckbox',labelText:'employeeActions.notification.typePush',value:false},
        ];
        vm.hrCheckBoxes = [
            {valueIndex:1,id : 'hrSMSCheckbox',labelText:'employeeActions.notification.typeSMS', value:false},
            {valueIndex:2,id : 'hrEmailCheckBox',labelText:'employeeActions.notification.typeEmail',value:false},
            {valueIndex:3,id : 'hrPushCheckbox',labelText:'employeeActions.notification.typePush',value:false},
        ];

        vm.notificationsOn = false;
        vm.officeTimeNotifyBeforeStartTime = null;
        vm.whenToCheckAbsent = null;
        vm.whenToCheckAbsentDropdown = [ {name : 'At Start',value : 'at_start'},{name : '30 min before start', value:'30_min_before_start'}, {name: '30 min after start', value: '30_min_after_start'}, {name : 'At End',value:'at_end'}]
        vm.whenToCheckEarlyExit = null;
        vm.whenToCheckEarlyExitDropdown = [{name : 'At Shift End',value :'at_shift_end'}];

        vm.datePicker.options = {
            singleDatePicker : true,
            startDate : moment(),
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }
        };

        vm.allocateEmployeeToAccessArea=allocateEmployeeToAccessArea;
        vm.revokeEmployeeFromAccessArea=revokeEmployeeFromAccessArea;

        vm.saveTemporaryAllocation = saveTemporaryAllocation;
        vm.openCalendarFromTime = openCalendarFromTime;
        vm.openCalendarToTime = openCalendarToTime;

        vm.populateTableFromMultiSelect = populateTableFromMultiSelect;
        vm.removeEmployeeFromTable = removeEmployeeFromTable;
        vm.assignBatchLeavePolicy = assignBatchLeavePolicy;
        vm.assignToSite = assignToSite;
        vm.assignBatchDesignation = assignBatchDesignation;
        vm.assignBatchShift = assignBatchShift;
        vm.assignBatchShiftGroup = assignBatchShiftGroup;
        vm.assignBatchDepartment = assignBatchDepartment;
        vm.assignBatchSubDepartment = assignBatchSubDepartment;
        vm.assignBatchSubsidiary = assignBatchSubsidiary;
        vm.assignBatchWeeklyOffDaysPolicy = assignBatchWeeklyOffDaysPolicy;
        vm.allocateToDevice = allocateToDevice;
        vm.assignBatchFirstLeaveApprover = assignBatchFirstLeaveApprover;
        vm.assignBatchSecondLeaveApprover = assignBatchSecondLeaveApprover;
        vm.assignBatchIncludeInAttendanceReport=assignBatchIncludeInAttendanceReport;

        vm.assignBatchFirstLateApprover = assignBatchFirstLateApprover;
        vm.assignBatchSecondLateApprover = assignBatchSecondLateApprover;

        vm.assignBatchFirstManualEntryApprover = assignBatchFirstManualEntryApprover;
        vm.assignBatchSecondManualEntryApprover = assignBatchSecondManualEntryApprover;

        vm.assignBatchLineManager = assignBatchLineManager;
        vm.assignBatchHrManager = assignBatchHrManager;
        vm.updateBatchEmploymentType = updateBatchEmploymentType;

        vm.openDeleteModal = openDeleteModal;
        vm.transferEmployees = transferEmployees;
        vm.updateBatchWorkplace = updateBatchWorkplace;
        vm.batchLeaveCarryOn = batchLeaveCarryOn;
        vm.allowOrDisallowOverTime = allowOrDisallowOverTime;
        vm.syncThirdParty = syncThirdParty;
        vm.doesThisNotificationGroupNeedConfiguration = doesThisNotificationGroupNeedConfiguration;
        vm.refreshUiComponents = refreshUiComponents;
        vm.saveNotificationSettings = saveNotificationSettings;
        vm.logSelectedEmployees = function (){
            // console.log(vm.select.multiselectEmployees)
        }
        var toLowerCase = function (data){
            return data.name.toLowerCase();
        }
        function init() {
            if(!vm.allSelected) {
                if(!$stateParams.selectedEmployees || !$stateParams.notSelectedEmployees)
                    return $state.go('employees.manageEmployees');
            }
            leavePolicyService.getAllAssignableLeavePolicies().then(function (leavePolicyList) {
                vm.leavePolicy.leavePolicyList = _.orderBy(leavePolicyList,toLowerCase);
            }, function (error) {
                console.error(error);
            });
            designationService.getAllDesignations().then(function (designationList) {
                vm.designation.designationList = _.orderBy(designationList,toLowerCase);
            }, function (error) {
                console.error(error);
            });
            shiftGroupService.getAllShiftGroups().then(function (shiftGroupList) {
                vm.shift.shiftGroupList = _.orderBy(shiftGroupList,toLowerCase);
            }, function (error) {
                console.error(error);
            });
            departmentService.getAllDepartments().then(function (departmentList) {
                vm.department.departmentList = _.orderBy(departmentList,toLowerCase)
            }, function (error) {
                console.error(error);
            });
            subDepartmentService.getAllSubDepartments().then(function (subDepartmentList) {
                // console.log(subDepartmentList);
                vm.subDepartment.subDepartmentList = _.orderBy(subDepartmentList,toLowerCase)
            }, function (error) {
                console.error(error);
            });
            if(vm.isSubsidiarySuperAdmin) {
                subsidiaryService.getAllSubsidiaries().then(function (subsidiaryList) {
                    vm.subsidiary.subsidiaryList = _.orderBy(subsidiaryList, toLowerCase);
                }, function (error) {
                    console.error(error);
                });
            }
            siteManagementService.getAllSites().then(function (siteList) {
                vm.site.siteList = _.orderBy(siteList.siteList,toLowerCase)
            }, function (error) {
                console.error(error);
            });
            // weeklyOffDaysService.getAllWeeklyOffDayPolicies().then(function (weeklyOffDaysPolicyList) {
            //     vm.weeklyOffDaysPolicy.weeklyOffDaysPolicyList = weeklyOffDaysPolicyList;
            // }, function (error) {
            //     console.error(error);
            // });
            //Get all access areas
            accessAreaService.getAllAccessAreas().then(function (accessAreas){
                vm.accessAreaListToAllocate = angular.copy(accessAreas);
                vm.accessAreaListToRevoke = angular.copy(accessAreas);
            }, function (error){
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
            deviceService.getAllDevices().then(function (data) {
                for(var i=0; i<data.length; i++){
                    data[i]["label"] = data[i]["identifier"] + " - " + data[i]["location"];
                }
                vm.devices = data;
                vm.devicesForBatchAllocation = angular.copy(vm.devices);
                vm.devicesForBatchRevoke = angular.copy(vm.devices);
            }, function (error) {
                console.error("Could not fetch device list : " + error);
            });

            workplaceService.getAllWorkplaces().then(function (data) {
                vm.workplaceList = _.orderBy(data,toLowerCase);
                vm.workplaceList.unshift({id:-1,name:'Not Set'});
            },function (error) {
                console.error("Could not fetch workplaces");
            });
            employmentTypeService.getAllEmploymentTypes().then(function (data) {
                vm.employmentTypeList = _.orderBy(data,toLowerCase);
            },function (error) {
                console.error("Could not fetch employment type list");
            });
            leaveCategoryService.getAllLeaveCategories().then(function (data) {
                vm.select.leaveCategoryFrom = angular.copy(data);
                vm.select.leaveCategoryTo = angular.copy(data);
            })

            vm.isCompanyAdmin = authService.getLoggedInUser().isCompanyAdmin;
            if(vm.isCompanyAdmin){
                officeService.getAllOffices().then(function (data) {
                    vm.officeList = data;
                }, function (error) {
                    console.error("Could not fetch office list" + error);
                });
            }

            initializeApproverLists();
        }

        init();

        function initializeApproverLists() {
            var selectedEmployeeIds = vm.select.selectedEmployees.map(function (employee){
                return employee.id;
            })
            var queryParams = {
                status              : [1],
                excludedEmployeeIds : selectedEmployeeIds,
                lineManagerId       : authService.getLoggedInUser().isLineManager ? authService.getLoggedInUser().id : null,
            };
            employeeService.getFilteredEmployeeNamesPost(queryParams).then(function (data){
                vm.select.notSelectedEmployees = angular.copy(data.employees);
                vm.select.notSelectedEmployeesForHrManager = angular.copy(data.employees);
                vm.select.notSelectedEmployeesForLineManager = angular.copy(data.employees);
                vm.select.firstLeaveApprovers = angular.copy(vm.select.notSelectedEmployees);
                vm.select.secondLeaveApprovers = angular.copy(vm.select.notSelectedEmployees);
                vm.select.firstLateApprovers = angular.copy(vm.select.notSelectedEmployees);
                vm.select.secondLateApprovers = angular.copy(vm.select.notSelectedEmployees);
                vm.select.firstManualEntryApprovers = angular.copy(vm.select.notSelectedEmployees);
                vm.select.secondManualEntryApprovers = angular.copy(vm.select.notSelectedEmployees);
                vm.select.hrManagerInput = vm.select.notSelectedEmployeesForHrManager.filter(function (e){
                    return e.isHrManager;
                })
                vm.select.lineManagerInput = vm.select.notSelectedEmployeesForLineManager.filter(function (e){
                    return e.isLineManager;
                });
                vm.isApproversListInitialized = true;
            })
            $scope.$broadcast("refreshFixedColumns");
        }
        function allocateEmployeeToAccessArea(){
            toastrService.clearPreviousToastr();
            //console.log($stateParams.selectedEmployees);
            if( vm.selectedAccessAreaListToAllocate.length <= 0 || !vm.selectedAccessAreaListToAllocate){
                toastrService.showErrorToastr("Please select an access area");
                return;
            }
            var request = {
                "employeeIdList" : vm.select.selectedEmployees.map(function (v){return v.id}),
                "accessAreaId" : vm.selectedAccessAreaListToAllocate[0].id,
                "action" : "allocate"
            };
            deviceService.allocateOrRevokeEmployeesToAccessArea(request).then(function (data) {
                analyticsService.sendData('allocate-employee-acces-area',document.title + ' - Allocate Employee','','Allocate Employee To Access Area In '+document.title, ANALYTICS_CONSTANT.allocate)
                toastrService.showSuccessToastr("Allocation successful");
                //getDevicesOfEmployee();
            },function (error) {
                toastrService.showErrorToastr("Could not allocate. " + error.message, "", 5000);
            })
        }
        function revokeEmployeeFromAccessArea(){
            toastrService.clearPreviousToastr();
            if(vm.selectedAccessAreaListToRevoke.length <= 0 || !vm.selectedAccessAreaListToRevoke){
                toastrService.showErrorToastr("Please select an access area");
                return;
            }
            var request = {
                "employeeIdList" : vm.select.selectedEmployees.map(function (v){return v.id}),
                "accessAreaId" : vm.selectedAccessAreaListToRevoke[0].id,
                "action" : "revoke"
            };
            deviceService.allocateOrRevokeEmployeesToAccessArea(request).then(function (data) {
                analyticsService.sendData('revoke-employee-access-area',document.title + ' - Revoke Employee','','Revoke Employee To Access Area In '+document.title, ANALYTICS_CONSTANT.revoke)
                toastrService.showSuccessToastr("Revocation successful");
                //getDevicesOfEmployee();
            },function (error) {
                toastrService.showErrorToastr("Could not allocate. " + error.message, "", 5000);
            })
        }

        function populateTableFromMultiSelect() {
            toastrService.clearPreviousToastr();
            if(vm.select.multiselectEmployees.length == 0)
                return toastrService.showErrorToastr("Please select an employee to add");
            vm.loadingTableData = true;
            employeeService.getEmployeeInformationList(vm.select.multiselectEmployees.map(function (data){
                return data.id;
            })).then(function (responseData){
                // console.log(responseData);
                vm.select.selectedEmployees.push.apply(vm.select.selectedEmployees, responseData.employeeList);
                angular.forEach(vm.select.multiselectEmployees, function (el) {
                    vm.select.notSelectedEmployees = _.reject(vm.select.notSelectedEmployees, function (employee) {
                        return employee.id == el.id;
                    });
                });
                initializeApproverLists();
                vm.loadingTableData = false;
            });
            analyticsService.sendData(ANALYTICS_CONSTANT.select, '', '', 'Select Employee In' + document.title, ANALYTICS_CONSTANT.select)

        }

        function removeEmployeeFromTable(employee) {
            vm.select.selectedEmployees = _.reject(vm.select.selectedEmployees, function (el) {
                return el.id == employee.id;
            });
            vm.select.notSelectedEmployees.push(employee);
            initializeApproverLists();
        }

        function assignBatchLeavePolicy() {
            toastrService.clearPreviousToastr();
            var batchEmployees = {
                employeeIdList: []
            };
            if(vm.select.selectedLeavePolicy == null)
                return toastrService.showErrorToastr("Please select a leave policy");
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            leavePolicyService.updateBatchLeavePolicy(batchEmployees, vm.select.selectedLeavePolicy.id).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                // vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                //     e.leavePolicyId = vm.select.selectedLeavePolicy.id;
                //     e.leavePolicyName = vm.select.selectedLeavePolicy.name;
                //     return e;
                // });
                analyticsService.sendData('assign-batch-leave-policy',document.title + ' - Assign Batch Leave Policy','','Assign Batch Leave Policy In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Leave policy assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign leave policy", "", 5000);
            });
        }

        function assignToSite(){
            toastrService.clearPreviousToastr();
            if(vm.select.selectedSite == null || !vm.select.selectedSite.id )
                return toastrService.showErrorToastr('Please select a site');
            var batchEmployees = {
                employeeIds: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIds.push(employee.id);
            });

            siteManagementService.addEmployeesToSite(batchEmployees,vm.select.selectedSite.id).then(function (){
                analyticsService.sendData('assign-employees-to-site',document.title + ' - Assign Employees To Site','','Assign Employees To Site In '+document.title, ANALYTICS_CONSTANT.assign)
                toastrService.showSuccessToastr("Site assigned");
            },function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign site", "", 5000);
            });
        }

        function assignBatchDesignation() {
            toastrService.clearPreviousToastr();
            if(vm.select.selectedDesignation == null || !vm.select.selectedDesignation.id )
                return toastrService.showErrorToastr('Please select a designation');
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            employeeService.updateBatchDesignation(batchEmployees, vm.select.selectedDesignation.id).then(function (data) {
                vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                    e.designationId = vm.select.selectedDesignation.id;
                    e.designationName = vm.select.selectedDesignation.name;
                    return e;
                });
                analyticsService.sendData('assign-batch-designation',document.title + ' - Assign Batch Designation','','Assign Batch Designation In '+document.title, ANALYTICS_CONSTANT.assign)
                toastrService.showSuccessToastr("Designation assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign designation", "", 5000);
            })
        }

        function assignBatchShift() {
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            shiftService.updateBatchShift(batchEmployees, vm.select.selectedShift.id).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                    e.shiftId = vm.select.selectedShift.id;
                    e.shiftName = vm.select.selectedShift.name;
                    return e;
                });
                toastrService.showSuccessToastr("Shift assigned");
                analyticsService.sendData('assign-batch-shift',document.title + ' - Assign Batch Shift','','Assign Batch Shift In '+document.title, ANALYTICS_CONSTANT.assign)

            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign shift", "", 5000);
            })
        }

        function assignBatchShiftGroup() {
            toastrService.clearPreviousToastr();
            if(vm.select.selectedShiftGroup == null || !vm.select.selectedShiftGroup.id)
                return toastrService.showErrorToastr('Please select a shift group');
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            employeeService.batchAssignShiftGroup(batchEmployees, vm.select.selectedShiftGroup.id).then(function (data) {
                vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                    e.shiftGroupId = vm.select.selectedShiftGroup.id;
                    e.shiftGroupName = vm.select.selectedShiftGroup.name;
                    return e;
                });
                analyticsService.sendData('assign-batch-shift-group',document.title + ' - Assign Batch Shift Group','','Assign Batch Shift Group In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Shift Group assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign shift group", "", 5000);
            })
        }

        function assignBatchDepartment() {
            toastrService.clearPreviousToastr();
            if(vm.select.selectedDepartment == null || !vm.select.selectedDepartment.id)
                return toastrService.showErrorToastr('Please select a department');
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            employeeService.updateBatchDepartment(batchEmployees, vm.select.selectedDepartment.id).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                    e.departmentId = vm.select.selectedDepartment.id;
                    e.departmentName = vm.select.selectedDepartment.name;
                    return e;
                });
                analyticsService.sendData('assign-batch-department',document.title + ' - Assign Batch Department','','Assign Batch Department In '+document.title, ANALYTICS_CONSTANT.assign)
                toastrService.showSuccessToastr("Department assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign department", "", 5000);
            });
        }

        function assignBatchSubDepartment(){
            toastrService.clearPreviousToastr();
            if(vm.select.selectedSubDepartment == null || !vm.select.selectedSubDepartment.id )
                return toastrService.showErrorToastr('Please select a Sub Department');
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            // console.log(batchEmployees);

            employeeService.updateBatchSubDepartment(batchEmployees, vm.select.selectedSubDepartment.id).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                // console.log('Sub');
                // console.log(vm.select.selectedSubDepartment.id);
                // console.log(vm.select.selectedSubDepartment.name);
                vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                    e.subDepartmentId = vm.select.selectedSubDepartment.id;
                    e.subDepartmentName = vm.select.selectedSubDepartment.name;
                    return e;
                });
                analyticsService.sendData('assign-batch-sub-department',document.title + ' - Assign Batch Sub Department','','Assign Batch Sub Department In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Sub Department assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign Sub Department", "", 5000);
            });
        }

        function assignBatchSubsidiary(){
            toastrService.clearPreviousToastr();
            if(vm.select.selectedSubsidiary == null || !vm.select.selectedSubsidiary.id )
                return toastrService.showErrorToastr('Please select a Subsidiary');
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });

            employeeService.updateBatchSubsidiary(batchEmployees, vm.select.selectedSubsidiary.id).then(function (data) {
                vm.select.selectedEmployees = vm.select.selectedEmployees.map(function(e){
                    e.subsidiaryId = vm.select.selectedSubsidiary.id;
                    e.subsidiaryName = vm.select.selectedSubsidiary.name;
                    return e;
                });
                analyticsService.sendData('assign-batch-subsidiary',document.title + ' - Assign Batch Subsidiary','','Assign Batch Subsidiary In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Subsidiary assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign Subsidiary", "", 5000);
            });
        }

        function assignBatchWeeklyOffDaysPolicy() {
            var batchEmployees = {
                employeeIdList: []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            weeklyOffDaysService.updateBatchWeeklyOffDaysPolicyPolicy(batchEmployees, vm.select.selectedWeeklyOffDaysPolicy.id).then(function (data) {
                // vm.select.selectedEmployees = data;
                analyticsService.sendData('assign-batch-weekly-off-day',document.title + ' - Assign Batch Weekly Off Day','','Assign Batch Weekly Off Day In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Weekly Off Days Policy assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Could not assign weekly off days policy", "", 5000)
            });
        }

        function assignBatchFirstLeaveApprover(){
            toastrService.clearPreviousToastr();
            if(vm.selectedFirstApprover.length == 0)
                return toastrService.showErrorToastr("Please select a leave approver");
            var requestBody = {
                employeeIdList: [],
                firstApproverId: vm.selectedFirstApprover[0].id
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                requestBody.employeeIdList.push(employee.id);
            });
            leaveManagementService.setLeaveApproverForBatchEmployee(requestBody).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                analyticsService.sendData('assign-batch-first-leave-approver',document.title + ' - Assign Batch First Leave Approver','','Assign Batch First Leave Approver '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("First leave approver assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Failed to assign first leave approver : " + error, "", 5000);
            });
        }

        function assignBatchSecondLeaveApprover(){
            toastrService.clearPreviousToastr();
            if(vm.selectedSecondApprover.length == 0)
                return toastrService.showErrorToastr("Please select a leave approver");
            var requestBody = {
                employeeIdList: [],
                secondApproverId: vm.selectedSecondApprover[0].id
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                requestBody.employeeIdList.push(employee.id);
            });
            leaveManagementService.setLeaveApproverForBatchEmployee(requestBody).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                toastrService.showSuccessToastr("Second leave approver assigned");
                analyticsService.sendData('assign-batch-second-leave-approver',document.title + ' - Assign Batch Second Leave Approver','','Assign Batch Second Leave Approver '+document.title, ANALYTICS_CONSTANT.assign)

            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Failed to assign second leave approver : " + error, "", 5000);
            });
        }

        function assignBatchFirstLateApprover(){
            toastrService.clearPreviousToastr();
            if(vm.selectedFirstLateApprover.length == 0)
                return toastrService.showErrorToastr("Please select a late approver");
            var requestBody = {
                employeeIdList: [],
                firstLateApproverId: vm.selectedFirstLateApprover[0].id
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                requestBody.employeeIdList.push(employee.id);
            });
            lateApprovalManagementService.setLateApproverForBatchEmployee(requestBody).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                toastrService.showSuccessToastr("First late approver assigned");
                analyticsService.sendData('assign-batch-first-late-approver',document.title + ' - Assign Batch First Late Approver','','Assign Batch First Late Approver '+document.title, ANALYTICS_CONSTANT.assign)

            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Failed to assign first late approver : " + error, "", 5000);
            });
        }

        function assignBatchSecondLateApprover(){
            toastrService.clearPreviousToastr();
            if(vm.selectedSecondLateApprover.length == 0)
                return toastrService.showErrorToastr("Please select a late approver");
            var requestBody = {
                employeeIdList: [],
                secondLateApproverId: vm.selectedSecondLateApprover[0].id
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                requestBody.employeeIdList.push(employee.id);
            });
            lateApprovalManagementService.setLateApproverForBatchEmployee(requestBody).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                analyticsService.sendData('assign-batch-second-late-approver',document.title + ' - Assign Batch Second Late Approver','','Assign Batch Second Late Approver '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Second late approver assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Failed to assign second late approver : " + error, "", 5000);
            });
        }

        function assignBatchFirstManualEntryApprover(){
            toastrService.clearPreviousToastr();
            if(vm.selectedFirstManualEntryApprover.length == 0)
                return toastrService.showErrorToastr("Please select a manual entry approver");
            var requestBody = {
                employeeIdList: [],
                firstManualEntryApproverId: vm.selectedFirstManualEntryApprover[0].id
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                requestBody.employeeIdList.push(employee.id);
            });
            lateApprovalManagementService.setManualEntryApproverForBatchEmployee(requestBody).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                analyticsService.sendData('assign-batch-first-manual-entry-approver',document.title + ' - Assign Batch First Manual Entry Approver','','Assign Batch First Manual Entry Approver '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("First manual entry approver assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Failed to assign first manual entry approver : " + error, "", 5000);
            });
        }

        function assignBatchSecondManualEntryApprover(){
            toastrService.clearPreviousToastr();
            if(vm.selectedSecondManualEntryApprover.length == 0)
                return toastrService.showErrorToastr("Please select a manual entry approver");
            var requestBody = {
                employeeIdList: [],
                secondManualEntryApproverId: vm.selectedSecondManualEntryApprover[0].id
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                requestBody.employeeIdList.push(employee.id);
            });
            lateApprovalManagementService.setManualEntryApproverForBatchEmployee(requestBody).then(function (data) {
                // vm.select.selectedEmployees = data.employees;
                analyticsService.sendData('assign-batch-second-manual-entry-approver',document.title + ' - Assign Batch Second Manual Entry Approver','','Assign Batch Second Manual Entry Approver '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Second manual entry approver assigned");
            }, function (error) {
                console.error(error);
                toastrService.showErrorToastr("Failed to assign second manual entry approver : " + error, "", 5000);
            });
        }

        function assignBatchLineManager() {
                        if (!vm.canAssignLineManager) {
                                // Hard guard to prevent accidental/forced use
                                   return toastrService.showErrorToastr("Line Manager module is not activated for your account");
                           }

            toastrService.clearPreviousToastr();
            if(vm.select.lineManager.length == 0){
                return toastrService.showErrorToastr("Please select a line manager");
            }
            var data = {
                employeeIdList: vm.select.selectedEmployees.map(function (employee) {
                    return employee.id;
                }),
                lineManagerId : vm.select.lineManager[0].id,
            };
            employeeService.batchAssignLineManager(data).then(function (employees) {
                // vm.select.selectedEmployees = employees;
                analyticsService.sendData('assign-batch-line-manager',document.title + ' - Assign Batch Line Manager','','Assign Batch Line Manager In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Line manager assigned");
            },function (error) {
                toastrService.showErrorToastr("Could not update line manager", "", 5000);
            })
        }

        function assignBatchHrManager() {
            toastrService.clearPreviousToastr();
            if(vm.select.hrManager.length == 0){
                return toastrService.showErrorToastr("Please select an HR Manager");
            }
            var data = {
                employeeIdList: vm.select.selectedEmployees.map(function (employee) {
                    return employee.id;
                }),
                hrManagerId : vm.select.hrManager[0].id,
            };
            employeeService.batchAssignHrManager(data).then(function (employees) {
                // vm.select.selectedEmployees = employees;
                analyticsService.sendData('assign-batch-hr-manager',document.title + ' - Assign Batch HR Manager','','Assign Batch HR Manager In '+document.title, ANALYTICS_CONSTANT.assign)

                toastrService.showSuccessToastr("Hr manager assigned");
            },function (error) {
                toastrService.showErrorToastr("Could not update line manager", "", 5000);
            })
        }

        function assignBatchIncludeInAttendanceReport(includeInAttendanceReport) {
            toastrService.clearPreviousToastr();
            var data = {
                employeeIds: vm.select.selectedEmployees.map(function (employee) {
                    return employee.id;
                }),
                includeInAttendanceReport: includeInAttendanceReport
            };
            employeeService.includeInAttendanceReport(data).then(function () {
                if(includeInAttendanceReport) analyticsService.sendData('include-in-attendance-report',document.title + ' - Include In Attendance Report','','Include In Attendance Report In '+document.title, ANALYTICS_CONSTANT.include)
                else analyticsService.sendData('exclude-in-attendance-report',document.title + ' - Exclude In Attendance Report','','Exclude In Attendance Report in '+document.title, ANALYTICS_CONSTANT.exclude)

                toastrService.showSuccessToastr(includeInAttendanceReport === true ? "Included " + 'selected users' +" successfully." : "Removed " + 'selected users' +" successfully.");
            }, function (response) {
                toastrService.showErrorToastr("Failed to update inclusion status. " + response.message);
            });
        }

        function allocateToDevice(action) {
            toastrService.clearPreviousToastr();
            var data = mapDataForBatchAllocate(action);
            if(data.deviceIdList == null || data.deviceIdList.length == 0)
                return toastrService.showErrorToastr("Please select a device");
            deviceService.allocateEmployeeBatchToManyDevices(data).then(function () {
                toastrService.showSuccessToastr("Operation successfully started");
                analyticsService.sendData('allocate-device',document.title + ' - Allocate Device','','Allocate Device In'+document.title, ANALYTICS_CONSTANT.allocate)
            }, function (error) {
                toastrService.showErrorToastr("Could not "+ action + " employees " + error, "", 5000)
            });
        }

        function mapDataForBatchAllocate(action) {
            var empIdList = vm.select.selectedEmployees.map(function (employee) {
                return employee.id;
            });
            var deviceIdList;
            if (action === "allocate"){
                deviceIdList = vm.selectedDevicesForAllocation.map(function (device) {
                    return device.id;
                });
            }else if (action === "revoke"){
                deviceIdList = vm.selectedDevicesForRevoke.map(function (device) {
                    return device.id;
                });
            }

            return {
                'employeeIdList' : empIdList,
                'deviceIdList'   : deviceIdList,
                'action'         : action
            };
        }

        function mapDataForBatchTemporaryAllocation() {
            var empIdList = vm.select.selectedEmployees.map(function (employee) {
                return employee.id;
            });
            return {
                'employeeIdList': empIdList,
                "timeOfAllocation": vm.datePicker.fromTime.format('x'),
                "timeOfRevoke": vm.datePicker.toTime.format('x')
            };
        }

        function openCalendarFromTime(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenFrom = true;
        }

        function openCalendarToTime(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenTo = true;
        }

        function saveTemporaryAllocation() {
            toastrService.clearPreviousToastr();
            if (vm.temporarySelectedDevice.length < 1)
                return toastrService.showErrorToastr("Select a device");
            if (vm.datePicker.fromTime === null || vm.datePicker.toTime === null)
                return toastrService.showErrorToastr("Times cannot be empty");
            if (vm.datePicker.fromTime > vm.datePicker.toTime)
                return toastrService.showErrorToastr("Start time can not be after end time");

            var data = mapDataForBatchTemporaryAllocation();

            deviceService.allocateTemporarily(data, vm.temporarySelectedDevice[0].id).then(function () {
                analyticsService.sendData('temporary-allocation',document.title + ' - Temporary Allocation','','Temporary Allocation in '+document.title, ANALYTICS_CONSTANT.allocate)
                toastrService.showSuccessToastr("Allocation request saved.");
            }, function () {
                toastrService.showErrorToastr("Could not allocate employee", "", 5000);
            });
        }

        function openDeleteModal() {
            toastrService.clearPreviousToastr();
            var data = [];
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                data.push(employee.id);
            });
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/employees/manage/actions/deleteEmployeeModal/deleteEmployeeModal.html',
                size: 'md',
                controller: 'DeleteEmployeeModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    idList: function () {
                        return data;
                    }
                }
            }).result.then(function () {
                toastrService.showSuccessToastr("Employees successfully deleted");
                $state.go('employees.manageEmployees');
            },function () {

            });
        }

        function transferEmployees() {
            toastrService.clearPreviousToastr();
            if(vm.selectedOffice.length != 1){
                return toastrService.showErrorToastr("Please select an office first");
            }
            var data = {
                "employeeIdList": vm.select.selectedEmployees.map(function (employee) {
                    return employee.id;
                }),
                "transferToOfficeId": vm.selectedOffice[0].id
            };

            employeeService.transferEmployees(data).then(function () {
                analyticsService.sendData('transfer-employee',document.title + ' - Transfer Employee','','Transfer Employee In'+document.title, ANALYTICS_CONSTANT.transfer)
                toastrService.showSuccessToastr("Transfer successful");
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });

        }

        function updateBatchWorkplace() {
            toastrService.clearPreviousToastr();
            if(vm.selectedWorkplace.length == 0){
                return toastrService.showErrorToastr("Please select a workplace")
            }
            var data = {
                employeeIdList : vm.select.selectedEmployees.map(function (employee) {
                    return employee.id
                })
            };
            workplaceService.updateBatchWorkplace(data,vm.selectedWorkplace[0].id).then(function (responseData) {
                analyticsService.sendData('update-batch-workplace',document.title + ' - Update Batch Workplace','','Update Batch Workplace In'+document.title, ANALYTICS_CONSTANT.update)
                // vm.select.selectedEmployees = responseData;
                toastrService.showSuccessToastr("Updated workplace");
            },function (error) {
                toastrService.showErrorToastr("Could not update " + error, "", 5000);
            });

        }

        function updateBatchEmploymentType() {
            toastrService.clearPreviousToastr();
            if(vm.selectedEmploymentTypeList.length == 0){
                return toastrService.showErrorToastr("Please select an employment type");
            }
            var data = {
                employeeIdList : vm.select.selectedEmployees.map(function (employee) {
                    return employee.id
                })
            };
            employeeService.updateBatchEmploymentType(data,vm.selectedEmploymentTypeList[0].id).then(function (responseData) {
                analyticsService.sendData('update-batch-employment-type',document.title + ' - Update Batch Employment Type','','Update Batch Employment Type In '+document.title, ANALYTICS_CONSTANT.update)
                // vm.select.selectedEmployees = responseData;
                toastrService.showSuccessToastr("Updated employment type");
            },function (error) {
                toastrService.showErrorToastr("Could not update " + error, "", 5000);
            });

        }


        function batchLeaveCarryOn() {
            toastrService.clearPreviousToastr();
            if(vm.select.selectedLeaveCategoryFrom.length == 0 || vm.select.selectedLeaveCategoryTo.length == 0)
                toastrService.showErrorToastr("Please select both categories");
            if(vm.fromYear == null || vm.fromYear == '' || vm.toYear == null || vm.toYear == "")
                toastrService.showErrorToastr("Please input both from and to years");
            if(vm.fromYear == vm.toYear)
                toastrService.showErrorToastr("From and to year cannot be the same");
            var data = {
                employeeIdList      : vm.select.selectedEmployees.map(function (employee) {
                    return employee.id;
                }),
                leaveCategoryIdFrom : vm.select.selectedLeaveCategoryFrom[0].id,
                leaveCategoryIdTo   : vm.select.selectedLeaveCategoryTo[0].id,
                fromYear            : vm.fromYear,
                toYear              : vm.toYear,
                maxNumberOfLeaves   : vm.maxLeaves
            };
            leavePolicyService.batchCarryOn(data).then(function () {
                analyticsService.sendData('batch-carry-on',document.title + ' - Batch Carry Leave','','Batch Carry Leave In'+document.title, ANALYTICS_CONSTANT.update)
                toastrService.showSuccessToastr("Successful")
            },function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }

        function allowOrDisallowOverTime(s) {
            var data = {
                employeeIdList : vm.select.selectedEmployees.map(function (employee) {
                    return employee.id;
                }),
                allowOvertime : s
            };

            overtimeService.changeOvertimeStatus(data).then(function (responseData) {
                analyticsService.sendData('change-overtime-status',document.title + ' - Change Overtime Status','','Change Overtime Status In'+document.title, ANALYTICS_CONSTANT.change)
                toastrService.showSuccessToastr("Changed overtime status for selected employees.");
            },function (error) {
                toastrService.showErrorToastr("Could not allow overtime", "", 5000);
            })
        }

        function refreshUiComponents() {
            // console.log("refreshUiComponents");
            vm.uiComponentsToShow = [];
            vm.uiComponentsToShow = vm.selectedUiComponents.map(function (d) {
                return d.value;
            })
                            // Ensure LM section never shows when module is off
                            if (!vm.canAssignLineManager) {
                                vm.uiComponentsToShow = vm.uiComponentsToShow.filter(function (v) { return v !== 'assignLineManager'; });
                                // also scrub any stale selection object
                                    if (Array.isArray(vm.selectedUiComponents)) {
                                        vm.selectedUiComponents = vm.selectedUiComponents.filter(function (c) { return c.value !== 'assignLineManager'; });
                                    }
                            }
            // console.log(vm.selectedUiComponents);
        }

        function initialiseUiComponents() {
            if(authService.getLoggedInUser().officeId !== BANGABHABAN_OFFICE_ID.id) {
                if (authService.getLoggedInUser().isLineManager) { // todo add food panda office id here
                    return angular.copy(manageEmployeeComponentsForLineManager)
                }
                var componentsList =  angular.copy(manageEmployeeComponents);
                if (vm.isSubsidiarySuperAdmin) {
                    componentsList.push({
                        name: 'Assign Subsidiary',
                        value: 'assignSubsidiary'
                    });
                }
                return componentsList;
            }
            else {
                var temp = angular.copy(manageEmployeeComponents);
                temp.forEach(function (item) {
                    if(item.value.localeCompare("assignDepartment") === 0)
                        item.name = "Assign Section";
                    if(item.value.localeCompare("assignSubDepartment") === 0)
                        item.name = "Assign Sub Section";
                    if(item.value.localeCompare("assignLineManager") === 0)
                        item.name = "Assign Section Officer";
                });
                return temp;
            }
        }


        function syncThirdParty() {
            var employeeOfficeIds = vm.select.selectedEmployees.map(function (employee) {
                return employee.employeeOfficeId;
            });
            var data =  {thirdPartyIdList:employeeOfficeIds.join(',')}
            employeeService.syncThirdPartyEmployees(data).then(function (responseData) {
                analyticsService.sendData('sync-external',document.title + ' - Sync External','','Sync External In '+document.title, ANALYTICS_CONSTANT.update)
                vm.responseMap = responseData;
                // console.log(vm.responseMap);
            },function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }

        function doesThisNotificationGroupNeedConfiguration(){
            if(vm.select.selectedNotificationGroup && vm.select.selectedNotificationGroup.length > 0){
                if(vm.select.selectedNotificationGroup[0].value===100 || vm.select.selectedNotificationGroup[0].value===400 || vm.select.selectedNotificationGroup[0].value===900) return true;
            }
            return false;
        }

        function isRecipientSelected(){
            var isNotSelected  = function (o) {
                return o.value == false;
            }
            if(vm.selfCheckBoxes.every(isNotSelected) && vm.lineManagerCheckBoxes.every(isNotSelected) && vm.hrCheckBoxes.every(isNotSelected)){
                return false;
            }
            return true;
        }

        function saveNotificationSettings() {
            analyticsService.sendData(ANALYTICS_CONSTANT.save, '', '', 'Save action In' + document.title, ANALYTICS_CONSTANT.save)

            toastrService.clearPreviousToastr();
            if(vm.select.selectedNotificationGroup.length == 0)
                return toastrService.showErrorToastr("Please select notification group first");
            var data = {};
            if(vm.notificationsOn){
                data = {
                    employeeIdList : vm.select.selectedEmployees.map(function (e) {
                        return e.id;
                    }),
                    notificationGroup : vm.select.selectedNotificationGroup[0].value,
                    notificationTypes : {
                        1 : getNotificationValuesFromModels(vm.selfCheckBoxes),
                        2 : getNotificationValuesFromModels(vm.lineManagerCheckBoxes),
                        3 : getNotificationValuesFromModels(vm.hrCheckBoxes)
                    },
                    settings : {},
                    off : false
                };
                if(doesThisNotificationGroupNeedConfiguration()){
                    addExtraNotificationSettingsToPostData(data)
                    if(_.isEmpty(data.settings)) return;
                }
            }
            else {
                data = {
                    employeeIdList : vm.select.selectedEmployees.map(function (e) {
                        return e.id;
                    }),
                    notificationGroup : vm.select.selectedNotificationGroup[0].value,
                    off : true
                }
            }
            if(!isRecipientSelected()){
                return toastrService.showErrorToastr("Please select recipient");
            }
            notificationService.updateBatchNotificationSettings(data).then(function () {
                analyticsService.sendData('update-notification-settings',document.title + ' - Update Notification Settings','','Update Notification Settings In '+document.title, ANALYTICS_CONSTANT.update)
                return toastrService.showSuccessToastr("Notification Settings updated");
            }, function (e) {
                console.error(e);
                return toastrService.showErrorToastr("Failed to update notification settings - " + e, "", 5000);
            })
        }

        function getNotificationValuesFromModels(modelArray) {
            return modelArray.filter(function (m) {
                return m.value;
            }).map(function (m) {
                return m.valueIndex;
            });
        }

        function addExtraNotificationSettingsToPostData(data) {
            toastrService.clearPreviousToastr();
            if(data.notificationGroup == 100){
                if(vm.officeTimeNotifyBeforeStartTime == null){
                   return toastrService.showErrorToastr("Please set how many minutes before shift time")
                }
                if(vm.officeTimeNotifyBeforeStartTime < 0 || vm.officeTimeNotifyBeforeStartTime > 59 )
                    return toastrService.showErrorToastr("Notification time must be between 1 and 59 minutes");
                data.settings = {
                    'min_before_shift_start' : vm.officeTimeNotifyBeforeStartTime
                }
            }
            if(data.notificationGroup == 400 ){
                if(vm.whenToCheckAbsent == null){
                    return toastrService.showErrorToastr('Please select when to check absent setting from dropdown.');
                }
                data.settings = {
                    'when_to_check_absent' : vm.whenToCheckAbsent.value
                }
            }
            if(data.notificationGroup == 900){
                if(vm.whenToCheckEarlyExit == null){
                    return toastrService.showErrorToastr('Please select when to check early exit from dropdown')
                }
                data.settings = {
                    'when_to_check_early_exit' : vm.whenToCheckEarlyExit.value
                }
            }
            return data;
        }
    }
})();


(function () {
  'use strict';
  angular
      .module('InovaceClientApp.pages.main.employees.manageEmployees')
      .controller('EmployeeCreateCtrl',
          ['authService','employeeService','departmentService','subDepartmentService','shiftService','shiftGroupService','workplaceService','employmentTypeService','designationService', 'leavePolicyService', 'utilService', 'weeklyOffDaysService','$state','toastrService', 'MODULES', 'GENDER','_', 'analyticsService', 'ANALYTICS_CONSTANT', 'passwordValidatorService', 'subsidiaryService', EmployeeCreateCtrl]);

  /** @ngInject */
  function EmployeeCreateCtrl(authService,employeeService,departmentService,subDepartmentService,shiftService,shiftGroupService,workplaceService,employmentTypeService,designationService, leavePolicyService, utilService, weeklyOffDaysService,$state,toastrService,MODULES, GENDER,_, analyticsService, ANALYTICS_CONSTANT, passwordValidatorService, subsidiaryService) {

      var vm = this;

      var loggedUser = authService.getLoggedInUser();
      vm.isOpen = false;
      vm.isOpenRes = false;
      vm.endDateEnabled = false;
      vm.showAdvanceOption = false;
      vm.isSubsidiaryActivatedAndNotSubsidiaryAdmin = loggedUser['modules'].includes(MODULES.SUBSIDIARY) && loggedUser.isAdmin && loggedUser.subsidiaryId == null;
      vm.create = {};
      vm.create.name = null;
      vm.create.employeeOfficeId = null;
      vm.create.email = null;
      vm.create.department = null;
      vm.create.subDepartment = null;
      vm.create.shift = null;
      vm.create.shiftGroup = null;
      vm.create.employmentType = null;
      vm.create.workplace = null;
      vm.create.gender = 1;
      vm.create.designation = null;
      vm.create.leavePolicy = null;
      vm.create.weeklyOffday = null;
      vm.create.dateOfJoin = null;
      vm.create.dateOfResignation = null;
      vm.create.password = null;
      vm.create.confirmPassword = null;
      vm.create.reportPosition = 1;
      vm.create.identifier = null;
      vm.create.rfid = null;
      vm.create.personId3rdPartyDevice = null;
      vm.create.primaryDisplayText = null;
      vm.create.secondaryDisplayText = null;
      vm.create.company = null;
      vm.create.office = null;
      vm.create.subsidiary = null;
      vm.create.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      vm.create.passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/; // not used

      vm.create.shiftList = null;
      vm.create.shiftGroupList = null;
      vm.create.genderList = GENDER;
      vm.create.designationList = null;
      vm.create.departmentList = null;
      vm.create.subDepartmentList = null;
      vm.create.workplaceList = null;
      vm.create.employmentTypeList = null;
      vm.create.leavePolicyList = null;
      vm.create.weeklyOffDaysPolicyList = null;
      vm.create.subsidiaryList = null;
      vm.passStrengthClass = 'text-danger';
      vm.passStrengthText = 'Poor';
      vm.passSchemaInfo = passwordValidatorService.getPasswordSchemaInfo();

      vm.create.createEmployeeForm = {};

      vm.checkPasswordValidation=checkPasswordValidation;
      vm.createEmployee = createEmployee;
      vm.openCalendar = openCalendar;
      vm.isEmployeeOfficeIdValid = isEmployeeOfficeIdValid;
      vm.toggleAdvanceOption = toggleAdvanceOption;

      init();

      function init() {
          getAllDepartments();
          getAllSubDepartments();
          getAllShiftGroups();
          getAllWorkplaces();
          getAllEmploymentTypes();
          getAllDesignations();
          getAllLeavePolicy();
          if(vm.isSubsidiaryActivatedAndNotSubsidiaryAdmin) {
              getAllSubsidiaries();
          }
      }

        function checkPasswordValidation(pattern){
            var similarChecks = [
                vm.name,
                vm.employeeOfficeId,
                vm.email,
                vm.rfid,
                vm.employeeIdentifier,
                vm.create.name,
                vm.create.employeeOfficeId,
                vm.create.email,
                vm.create.rfid,
                vm.create.employeeIdentifier
            ];

            var value = passwordValidatorService.getStrengthInfo(vm.create.password, similarChecks);

            vm.passStrengthText = value.text;
            vm.passStrengthClass = value.class;

            return passwordValidatorService.validatePasswordFunction(pattern, vm.create.password, similarChecks);
        }

      function getAllEmploymentTypes() {
          employmentTypeService.getAllEmploymentTypes().then(onGetAllEmploymentTypesSuccess, onGetAllEmploymentTypesFailure);
      }

      function onGetAllEmploymentTypesSuccess(employmentTypeList) {
          vm.create.employmentTypeList = sortCollectionByName(employmentTypeList);
      }

      function onGetAllEmploymentTypesFailure(message) {
          toastrService.showErrorToastr("Failed to fetch employmentTypeList: " + message, "", 5000);
          console.error("Failed to fetch employmentTypeList: " + message);
      }

      function getAllWorkplaces() {
          workplaceService.getAllWorkplaces(false).then(onGetAllWorkplacesSuccess, onGetAllWorkplacesFailure);
      }

      function onGetAllWorkplacesSuccess(workplaceList) {
          vm.create.workplaceList = sortCollectionByName(workplaceList);
      }

      function onGetAllWorkplacesFailure(message) {
          toastrService.showErrorToastr("Failed to fetch workplace list : " + message, "", 5000);
          console.error("Failed to fetch workplace list : " + message);
      }

      function getAllDepartments() {
          departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
      }

      function onGetAllDepartmentsSuccess(departmentList) {
          vm.create.departmentList = sortCollectionByName(departmentList);
      }

      function onGetAllDepartmentsFailure(message) {
          toastrService.showErrorToastr("Failed to fetch department list : " + message, "", 5000);
          console.error("Failed to fetch department list : " + message);
      }

      function getAllSubDepartments() {
          subDepartmentService.getAllSubDepartments().then(onGetAllSubDepartmentsSuccess, onGetAllSubDepartmentsFailure);
      }

      function onGetAllSubDepartmentsSuccess(subDepartmentList) {
          vm.create.subDepartmentList =  sortCollectionByName(subDepartmentList);
      }

      function onGetAllSubDepartmentsFailure(message) {
          toastrService.showErrorToastr("Failed to fetch sub department list : " + message, "", 5000);
          console.error("Failed to fetch sub department list : " + message);
      }


      function getAllShiftGroups() {
          shiftGroupService.getAllShiftGroups(false).then(function (shiftGroupList) {
              vm.create.shiftGroupList = sortCollectionByName(shiftGroupList);
              vm.create.shiftGroup = shiftGroupList.find(function (s) {
                  return s.isDefault == true;
              }).id;
          }, function (err) {
              toastrService.showErrorToastr("Failed to fetch shift groups : " + err, "", 5000);
          });
      }

      function onGetAllShiftsSuccess(shiftList) {
          vm.create.shiftList = shiftList;
      }

      function onGetAllShiftsFailure(message) {
          toastrService.showErrorToastr("Failed to fetch shift list : " + message, "", 5000);
      }

      function getAllDesignations() {
          designationService.getAllDesignations().then(onGetAllDesignationsSuccess, onGetAllDesignationsFailure);
      }

      function onGetAllDesignationsSuccess(designationList) {
          vm.create.designationList = sortCollectionByName(designationList);
      }

      function onGetAllDesignationsFailure(message) {
          toastrService.showErrorToastr("Failed to fetch designation list : " + message, "", 5000);
      }

      function getAllLeavePolicy() {
          leavePolicyService.getAllAssignableLeavePolicies().then(function (leavePolicyList) {
              if(leavePolicyList.length > 0) {
                  vm.create.leavePolicyList = _.orderBy(leavePolicyList,['name']);
                  vm.create.leavePolicy = vm.create.leavePolicyList[0].id;
              }
          }, function (error) {
              console.error(error);
          });
      }

      function getAllSubsidiaries() {
          subsidiaryService.getAllSubsidiaries().then(onGetAllSubsidiariesSuccess, onGetAllSubsidiariesFailure);
      }

      function onGetAllSubsidiariesSuccess(subsidiaryList) {
          vm.create.subsidiaryList = sortCollectionByName(subsidiaryList);
      }

      function onGetAllSubsidiariesFailure(message) {
          toastrService.showErrorToastr("Failed to fetch subsidiary list : " + message, "", 5000);
          console.error("Failed to fetch subsidiary list : " + message);
      }



      function createEmployee() {
          toastrService.clearPreviousToastr();
          vm.isEmployeeCreating = true;
          validateForm();
      }

      function validateForm() {
          if(!vm.create.passwordPattern.test(vm.create.password)){
              vm.isEmployeeCreating = false;
              return toastrService.showErrorToastr("Password does not have required characters");
          }
          if(vm.create.primaryDisplayText){
              if(vm.create.primaryDisplayText.length > 10){
                  vm.isEmployeeCreating = false;
                  return toastrService.showErrorToastr("Primary display text can not be longer than 10 characters");
              }
          }
          if(vm.create.secondaryDisplayText){
              if(vm.create.secondaryDisplayText.length > 10){
                  vm.isEmployeeCreating = false;
                  return toastrService.showErrorToastr("Secondary display text can not be longer than 10 characters");
              }
          }
          if(vm.create.password != vm.create.confirmPassword){
              vm.isEmployeeCreating = false;
              return toastrService.showErrorToastr("Password and Confirm passwords don't match");
          }
          // Validate subsidiary if required
          if(vm.isSubsidiaryActivatedAndNotSubsidiaryAdmin && !vm.create.subsidiary){
              vm.isEmployeeCreating = false;
              return toastrService.showErrorToastr("Subsidiary is required");
          }
          employeeService.checkEmployeeOfficeIdValidity(vm.create.employeeOfficeId).then(function (data) {
              if(data.isValid) {
                  analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create Employee', '', 'Create Employee In' + document.title, ANALYTICS_CONSTANT.create)
                  submitForm();
              } else {
                  vm.isEmployeeCreating = false;
                  return toastrService.showErrorToastr("Employee ID is already in use");
              }
          });
      }

      function submitForm() {
          var data =
              {
                  "departmentId": vm.create.department,
                  "subDepartmentId": vm.create.subDepartment,
                  "designationId": vm.create.designation,
                  "email": vm.create.email,
                  "employeeIdentifier": vm.create.identifier,
                  "name": vm.create.name,
                  "password": vm.create.password,
                  "reportPosition": vm.create.reportPosition,
                  "shiftId": vm.create.shift,
                  "shiftGroupId": vm.create.shiftGroup,
                  "leavePolicyId": vm.create.leavePolicy,
                  "weeklyOffDayPolicyId": vm.create.weeklyOffday,
                  "gender": vm.create.gender,
                  "rfid":vm.create.rfid,
                  "personId3rdPartyDevice": vm.create.personId3rdPartyDevice,
                  "primaryDisplayText":vm.create.primaryDisplayText,
                  "secondaryDisplayText":vm.create.secondaryDisplayText,
                  "employeeOfficeId" : vm.create.employeeOfficeId,
                  "workplaceId": vm.create.workplace,
                  "dateOfJoin": vm.create.dateOfJoin ? vm.create.dateOfJoin.valueOf() : null,
                  "dateOfResignation": vm.create.dateOfResignation ? vm.create.dateOfResignation.valueOf() : null,
                  "employmentTypeId": vm.create.employmentType,
                  "subsidiaryId": vm.create.subsidiary
              };

          employeeService.createEmployee(data).then(onEmployeeCreateSuccess, onEmployeeCreateFailure);

      }

      function onEmployeeCreateSuccess(data) {
          toastrService.clearPreviousToastr();
          toastrService.showSuccessToastr("Employee creation successful");
          vm.isEmployeeCreating = false;
          $state.go('profile',{employeeId:data.id});
      }

      function onEmployeeCreateFailure(error) {
          vm.isEmployeeCreating = false;
          toastrService.showErrorToastr("Failed to create employee : " + JSON.stringify(error), "", 5000);
          console.error(error);
      }

      function openCalendar (e) {
          e.preventDefault();
          e.stopPropagation();
          vm.isOpen = true;
      }

      function sortCollectionByName(collection) {
          return _.orderBy(collection,function (item) {
              return item.name.toLowerCase();
          },['asc']);
      }

      function isEmployeeOfficeIdValid() {
      //    vm.create.employeeOfficeId
          return employeeService.checkEmployeeOfficeIdValidity(vm.create.employeeOfficeId).then(function (data) {
              return data.isValid;
          });
      }

      function toggleAdvanceOption(){
          analyticsService.sendData(ANALYTICS_CONSTANT.advancedOption, document.title + ' - Advanced Option', '', 'Advanced Option click In' + document.title, ANALYTICS_CONSTANT.advancedOption)

          vm.showAdvanceOption = !vm.showAdvanceOption;
      }
  }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.leave.applyLeaveForOthers')
        .controller('ApplyLeaveForEmployeesCtrl', ['$scope', '$stateParams', '$uibModal', 'authService', 'remainingLeaveService', 'leaveManagementService', 'toastrService', '$sce', '_', 'employeeService', 'utilService', ApplyLeaveForEmployeesCtrl]);

    /** @ngInject */
    function ApplyLeaveForEmployeesCtrl($scope, $stateParams, $uibModal, authService, remainingLeaveService, leaveManagementService, toastrService, $sce, _, employeeService, utilService) {

        var vm = this;
        vm.employeeList = [];
        // vm.selectedCategory = null;
        vm.selectedTypeId = "";
        vm.selectedHalfId = 1;
        vm.reason = null;
        vm.isChecked = null;
        vm.uploadedFile = null;
        vm.isEmployeeSelected = false;
        vm.isRemainingLeaveDataLoaded = true;
        vm.isEmployeeInfoLoaded = false;
        vm.employeeToShow = null;
        vm.lastFiveLeavedata = null;
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.selectedLeaveHalf = "1";
        vm.earnedLeaveEnabledCategoryIds = [];
        vm.availableExchangeLeaveDates = [];
        vm.selectedDayForExchangeLeave = [];
        vm.selectedEarnedLeaveType = null;
        vm.selectedCategoryPolicyConfig = null;

        vm.dateRangeList = [];
        vm.selectedDateRange = null;

        vm.fiscalYearStartDate = null;
        vm.fiscalYearEndDate = null;

        vm.leaveDateRangePicker = {};
        vm.leaveDateRangePicker.date = getInitialFromAndToDate();
        vm.leaveDateRangePicker.options = {
            minDate : vm.minDate,
            locale : {
                format : 'DD MMM YYYY'
            },
            eventHandlers : {
                'apply.daterangepicker': modifyRemainingLeavesToShow,
                'hide.daterangepicker' : modifyRemainingLeavesToShow,
                'cancel.daterangepicker' : resetRemainingLeavesToShow,
            }
        }
        vm.leaveSingleDatePicker = {};
        vm.leaveSingleDatePicker.date = moment();
        vm.leaveSingleDatePicker.options = {
            singleDatePicker:true,
            minDate:vm.minDate,
            locale:{
                format:'DD MMM YYYY'
            },
            eventHandlers : {
                'apply.daterangepicker': modifyRemainingLeavesToShow,
                'hide.daterangepicker' : modifyRemainingLeavesToShow,
                'cancel.daterangepicker' : resetRemainingLeavesToShow,
            }
        }

        vm.isSingleDatePickerModeEnabled = false;
        vm.selectedYear = new Date();
        vm.yearPicker = {};
        vm.yearPicker.opened = false;
        vm.yearPicker.format = "yyyy";
        vm.yearPicker.options = {
            datepickerMode: 'year',
            minDate: new Date(2019,12,1),
            maxDate: new Date(),
            minMode: 'year',
            maxMode: 'year'
        };
        vm.openYearPicker = openYearPicker;

        vm.onEmployeeSelect = onEmployeeSelect;
        vm.modifyRemainingLeavesToShow = modifyRemainingLeavesToShow;
        vm.resetRemainingLeavesToShow = resetRemainingLeavesToShow;
        vm.getAcceptedLeaveLogsOfApplicant = getAcceptedLeaveLogsOfApplicant;
        vm.checkFormValidity = checkFormValidity;
        vm.onReset = onReset;

        function openYearPicker() {
            vm.yearPicker.opened = true;
        }
        function resetRemainingLeavesToShow(){
            vm.remainingLeaveListToShow = angular.copy(vm.remainingLeavesList);
            determineEarnedLeaveTypeAndShowUI();
        }

        function modifyRemainingLeavesToShow(){
            resetRemainingLeavesToShow();
            for (var i = 0; i < vm.remainingLeaveListToShow.length ; i++) {
                if(vm.remainingLeaveListToShow[i].leaveCategoryId == vm.selectedCategoryPolicyConfig.leaveCategoryId){
                    var numberOfDays = getNumberOfDays();
                    vm.remainingLeaveListToShow[i].used += numberOfDays ;
                    vm.remainingLeaveListToShow[i].remainingLeaveCount =  vm.remainingLeaveListToShow[i].remainingLeaveCount - numberOfDays < 0 ? 0 : vm.remainingLeaveListToShow[i].remainingLeaveCount - numberOfDays;
                }
            }
        }

        function init() {
            employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.employeeList = data.employees;
            });
            fetchDateRanges();
        }
        init();

        function onReset(){
            vm.isEmployeeSelected = false;
            vm.employeeToShow = null;
            vm.lastFiveLeavedata = null;
        }

        function fetchDateRanges() {
            remainingLeaveService.getDistinctLeaveBalanceDateRanges().then(function (data) {
                vm.dateRangeList = data.dateRanges;
                if (vm.dateRangeList.length > 0) {
                    var index = utilService.findDateRangeIndexContainingToday(vm.dateRangeList);
                    vm.selectedDateRange = vm.dateRangeList[index];
                }
            });
        }

        function onEmployeeSelect(){
            vm.isEmployeeSelected = true;
            vm.isEmployeeInfoLoaded = false;
            if(vm.selectedEmployee.length == 0) return;
            vm.employeeToShow = null;
            var promises = [];
            loadDataForSelectedYear();
            getEmployeeProfile();
            getAcceptedLeaveLogsOfApplicant();
        }

        function getEmployeeProfile(){
            employeeService.getProfile(vm.selectedEmployee[0].id).then(function (data){
                vm.employeeToShow = data.employee;
                vm.isEmployeeInfoLoaded = true;
            });
        }

        function getAcceptedLeaveLogsOfApplicant() {
            return leaveManagementService.getAcceptedLeaveLogs(vm.selectedEmployee[0].id).then(function (data) {
                vm.lastFiveLeavedata = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch employee's accepted leave data: " + error, "", 5000);
            });
        }


        function getNumberOfDays(){
            if(Number(vm.selectedTypeId) === 1 && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria === 0) {
                var startDate = vm.leaveDateRangePicker.date.startDate.startOf('day');
                var endDate = vm.leaveDateRangePicker.date.endDate.startOf('day');
                return endDate.diff(startDate,'days') + 1;
            } else if(vm.selectedCategoryPolicyConfig.earnedLeaveCriteria > 0) {
                var startDate = vm.leaveSingleDatePicker.date.startOf('day');
                var endDate = vm.leaveSingleDatePicker.date.startOf('day');
                return endDate.diff(startDate,'days') + 1;
            }
            return .5;

        }

        function loadDataForSelectedYear() {
            vm.isRemainingLeaveDataLoaded = false;
            if (vm.selectedEmployee === undefined || !vm.selectedDateRange) return;
            var dates = vm.selectedDateRange.split(" - ");
            var startMoment = moment(dates[0], "MMM YYYY").startOf('month');
            var endMoment = moment(dates[1], "MMM YYYY").endOf('month');
            // Store these on vm so getLeaveInfo can access them
            vm.fiscalYearStartDate = startMoment.valueOf();
            vm.fiscalYearEndDate = endMoment.milliseconds(0).valueOf();
            var year = startMoment.year();

            // Update date picker options
            vm.leaveDateRangePicker.options.maxDate = endMoment.toDate();
            vm.leaveSingleDatePicker.options.maxDate = endMoment.toDate();

            return remainingLeaveService.getAllRemainingLeavesOfEmployeeInFiscalYear(
                vm.selectedEmployee[0].id,
                vm.fiscalYearStartDate,
                vm.fiscalYearEndDate
            ).then(function (data) {
                vm.isRemainingLeaveDataLoaded = true;
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
                vm.remainingLeaveListToShow = angular.copy(data.employeeRemainingLeaveList);
                getAvailableExchangeLeaveDates(vm.selectedEmployee[0].id, year);
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch: " + error, "", 5000);
            });
        }


        function getLeaveInfo(){
            var data;
            var leaveTypeId = Number(angular.copy(vm.selectedTypeId));
            var leaveHalf = Number(angular.copy(vm.selectedLeaveHalf));

            data = {
                categoryId    : vm.selectedCategoryPolicyConfig.leaveCategoryId,
                leaveType     : leaveTypeId,
                reason        : angular.copy(vm.reason),
                numberOfDays  : getNumberOfDays(),
                forceApproval : !vm.isChecked,
                file          : vm.uploadedFile,
                selectedLeaveHalf : (leaveTypeId === 1) ? null : leaveHalf,
                fiscalYearStartDate: vm.fiscalYearStartDate,
                fiscalYearEndDate: vm.fiscalYearEndDate
            }
            var dateRange = angular.copy(vm.leaveDateRangePicker.date);
            if(leaveTypeId === 1 && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria === 0) {
                dateRange = angular.copy(vm.leaveDateRangePicker.date);
                dateRange = { startDate : dateRange.startDate.startOf('day'), endDate : dateRange.endDate.startOf('day')};
            } else if(leaveTypeId === 2) {
                dateRange = angular.copy(vm.leaveSingleDatePicker.date);
                dateRange = { startDate : dateRange, endDate : dateRange};
            } else if(vm.selectedCategoryPolicyConfig.earnedLeaveCriteria > 0) {
                dateRange = angular.copy(vm.leaveSingleDatePicker.date);
                dateRange = { startDate : dateRange, endDate : dateRange};
                data.leaveTakenAgainst = vm.selectedDayForExchangeLeave[0].startOfApplicableDay;
            }

            data.dateRange = dateRange;
            for (var i = 0; i < vm.remainingLeavesList.length; i++) {
                if(vm.remainingLeavesList[i].leaveCategoryId === vm.selectedCategoryPolicyConfig.leaveCategoryId){
                    data.categoryName = vm.remainingLeavesList[i].leaveCategoryPolicyConfig.leaveCategory.name;
                    break;
                }
            }
            return data;
        }

        function openLeaveApplyModal(){
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/applyLeaveForOthers/applyLeaveForEmployees/adminLeaveApplyModal/adminLeaveApply.modal.html',
                size: 'lg',
                controller: 'AdminLeaveApplyModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve : {
                    employeeInfo: function() {
                        return angular.copy(vm.employeeToShow);
                    },
                    leaveInfo : function (){
                        return getLeaveInfo();
                    }
                },

            }).result.then(function (data){
                init();
            });
        }

        function checkFormValidity() {
            toastrService.clearPreviousToastr();
            if(!vm.employeeToShow)
                return toastrService.showErrorToastr("Please select an employee");
            if(!vm.reason)
                return toastrService.showErrorToastr("Reason cannot be empty");
            if(vm.selectedCategoryPolicyConfig === null || vm.selectedCategoryPolicyConfig === '')
                return toastrService.showErrorToastr("Select a leave category");
            // if(vm.earnedLeaveEnabledCategoryIds.includes(vm.selectedCategoryPolicyConfig.leaveCategoryId)) return toastr.info("Only user can apply leave from earned leave enabled criteria");

            if(Number(vm.selectedTypeId) === 2) {
                if(Number(vm.selectedLeaveHalf) !== 1 && Number(vm.selectedLeaveHalf) !==2 )
                    return toastrService.showErrorToastr("Select a half");
                /*if(!utilService.isTimeInCurrentYear(vm.leaveSingleDatePicker.date.format('x')))
                    return toastrService.showErrorToastr("Time is not in current year");*/
            }
            if(Number(vm.selectedTypeId) === 1 && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria === 0) {
                if(!utilService.checkIfValidDateRange(vm.leaveDateRangePicker.date.startDate, vm.leaveDateRangePicker.date.endDate))
                    return toastrService.showErrorToastr("Start day can not be before end date");
                // if(!utilService.isTimeInCurrentYear(vm.leaveDateRangePicker.date.startDate.format('x'))|| !utilService.isTimeInCurrentYear(vm.leaveDateRangePicker.date.endDate.format('x')))
                //     return toastrService.showErrorToastr("Time is not in current year");
            }
            if(vm.selectedCategoryPolicyConfig.earnedLeaveCriteria > 0) {
                if(vm.selectedDayForExchangeLeave.length === 0)
                    return toastrService.showErrorToastr("Must select a date from available days");
                // if(!utilService.isTimeInCurrentYear(vm.leaveSingleDatePicker.date.format('x')))
                //     return toastrService.showErrorToastr("Time is not in current year");
            }
            openLeaveApplyModal();
        }

        function getInitialFromAndToDate() {
            return {
                'startDate': moment(),
                'endDate': moment()
            };
        }

        function getAvailableExchangeLeaveDates(employeeId, year) {
            remainingLeaveService.getAvailableExchangeLeaveDates(employeeId, year).then(function (data){
                vm.availableExchangeLeaveDates = data.dateList;
            }, function (error) {

            });
        }

        function determineEarnedLeaveTypeAndShowUI(){
            if(Number(vm.selectedCategoryPolicyConfig.pastDateSelectionLimit) > -1) {
                vm.leaveDateRangePicker.options.minDate = vm.leaveSingleDatePicker.options.minDate = vm.minDate = moment().startOf('day').subtract(Number(vm.selectedCategoryPolicyConfig.pastDateSelectionLimit), "days");
            } else {
                vm.leaveDateRangePicker.options.minDate = vm.leaveSingleDatePicker.options.minDate = vm.minDate = moment().startOf("day");
            }
            if(vm.selectedCategoryPolicyConfig.earnedLeaveCriteria === 1){
                vm.selectedTypeId = "1";
                vm.isSingleDatePickerModeEnabled = true;
                // vm.isRemainingLeaveDataLoaded = false;
            }else {
                vm.isSingleDatePickerModeEnabled = (Number(vm.selectedTypeId) === 2);
                // vm.selectedTypeId = null;
                // vm.isRemainingLeaveDataLoaded = true;
            }
        }
        $scope.$watch('vm.selectedDateRange', function (newVal) {
            if (newVal) {
                var dates = newVal.split(" - ");
                var startMoment = moment(dates[0], "MMM YYYY");
                var endMoment = moment(dates[1], "MMM YYYY").endOf('month').milliseconds(0);
                var today = moment().startOf('day');
                if (today.isBetween(startMoment, endMoment, null, '[]')) {
                    vm.leaveDateRangePicker.date = {
                        startDate: today.clone(),
                        endDate: today.clone()
                    };
                    vm.leaveSingleDatePicker.date = today.clone();
                } else {
                    vm.leaveDateRangePicker.date = {
                        startDate: startMoment.clone(),
                        endDate: startMoment.clone()
                    };
                    vm.leaveSingleDatePicker.date = startMoment.clone();
                }

                if (vm.isEmployeeSelected) {
                    loadDataForSelectedYear();
                }
            }
        });


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveCategory')
    app.controller('LeaveCategoryEditModalCtrl', ['leaveCategoryService','authService','$uibModalInstance','toastrService','categoryToChange', 'analyticsService', 'ANALYTICS_CONSTANT',LeaveCategoryEditModalCtrl]);

    /** @ngInject */
    function LeaveCategoryEditModalCtrl(leaveCategoryService,authService,$uibModalInstance,toastrService,categoryToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.isDeleting = false;
        vm.isEditing = false;
        vm.create = {};
        vm.create.createLeaveCategoryName = null;
        vm.categoryToChange = null;
        var analyticsCreateTitle = 'Create Leave Category Modal';
        var analyticsCreateUrl = 'create-leave-category';
        var analyticsEditTitle= 'Edit Leave Category Modal';
        var analyticsEditUrl = 'edit-leave-category';
        var analyticsDeleteTitle = 'Delete Leave Category Modal';
        var analyticsDeleteUrl = 'delete-leave-category';

        vm.createLeaveCategory = createLeaveCategory;
        vm.updateLeaveCategoryName = updateLeaveCategoryName;
        vm.deleteLeaveCategory = deleteLeaveCategory;

        function init() {
            vm.categoryToChange = categoryToChange;
        }

        init();

        function createLeaveCategory () {
            if(!vm.create.createLeaveCategoryName){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Leave category name cannot be empty");
            }
            vm.isCreating = true;
            leaveCategoryService.createLeaveCategory({
                    name:vm.create.createLeaveCategoryName,
                    officeId:authService.getAllInformation().office.id,
                    status:1}).then
            (onLeaveCategoryCreateSuccess, onLeaveCategoryCreateFailure).finally(function () {
                vm.isCreating = false;
            });
        }

        function onLeaveCategoryCreateSuccess(leaveCategory) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Leave Category In' + document.title, ANALYTICS_CONSTANT.create)
            $uibModalInstance.close(leaveCategory);
        }

        function onLeaveCategoryCreateFailure(error) {
            toastrService.showErrorToastr("Could not create: " + error, "", 5000);
        }

        function updateLeaveCategoryName (leaveCategoryId,data) {
            if(!data){
                vm.isEditing = false;
                return  toastrService.showErrorToastr("Leave category name cannot be empty");
            }
            vm.isEditing = true;
            leaveCategoryService.updateLeaveCategory({name:data},leaveCategoryId)
                .then(onLeaveCategoryNameUpdateSuccess,onLeaveCategoryNameUpdateFailure)
                .finally(function () {
                    vm.isEditing = false;
                });
        }

        function onLeaveCategoryNameUpdateSuccess(data) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Leave Category In' + document.title, ANALYTICS_CONSTANT.edit)
            $uibModalInstance.close(data.leaveCategory);
        }

        function onLeaveCategoryNameUpdateFailure(error) {
            toastrService.showErrorToastr("Could not update: " + error, "", 5000);
        }
        
        function deleteLeaveCategory(leaveCategoryId) {
            vm.isDeleting = true;
            leaveCategoryService.updateLeaveCategory({status:-1},leaveCategoryId)
                .then(onLeaveCategoryDeleteSuccess,onLeaveCategoryDeleteFailure)
                .finally(function () {
                    vm.isDeleting = false;
                });
        }

        function onLeaveCategoryDeleteSuccess() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Leave Category In' + document.title, ANALYTICS_CONSTANT.delete)
            toastrService.showSuccessToastr("Leave Category Deleted");
            $uibModalInstance.close();
        }

        function onLeaveCategoryDeleteFailure(error) {
            toastrService.showErrorToastr("Could not delete: " + error, "", 5000);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveCategoryPolicyConfiguration')
    app.controller('CreateConfigurationCtrl', ['leaveCategoryPolicyConfigurationService', 'leaveManagementService', '$scope', 'leavePolicyService', 'leaveCategoryService', '$uibModal', 'toastrService', '$q', 'LEAVE_CARRY_TYPES', 'EARNED_LEAVE_CRITERIA', 'EARNED_LEAVE_CAP_TYPES', 'EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST', 'NUM_OF_DAYS_IN_EACH_TIME_WINDOW', 'LEAVE_APPLICABILITY_TYPE', 'analyticsService', 'ANALYTICS_CONSTANT', CreateConfigurationCtrl]);

    /** @ngInject */
    function CreateConfigurationCtrl(leaveCategoryPolicyConfigurationService, leaveManagementService, $scope,  leavePolicyService, leaveCategoryService, $uibModal, toastrService, $q, LEAVE_CARRY_TYPES, EARNED_LEAVE_CRITERIA, EARNED_LEAVE_CAP_TYPES, EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST, NUM_OF_DAYS_IN_EACH_TIME_WINDOW, LEAVE_APPLICABILITY_TYPE, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {}
        vm.create.leavePolicyId = null;
        vm.create.curConfigIndex = 1;
        vm.create.configForms = [
            {
                leaveCategoryId : null,
                totalDays : 0,
                consecutiveDays : 0,
                monthlyRestriction : 0,
                fileUploadCondition : 0,
                maxCarry : 0,
                countOffdays : false,
                carryType : 0,
                pastDateSelectionEnabled : true,
                pastDateSelectionLimit : 30,
                earnedLeaveEnabled : false,
                earnedLeaveCriteria : null,
                maxEarnedLeaveCount : 0,
                perDayEarnedLeaveRequiredHours : 0,
                earnedLeaveCapType : 0,
                earnedLeaveCapAmount : 0,
                expiryTimeWindowAmount : 0,
                expiryTimeWindowType : 0,
                applicability : 0,
                eligibleAfter : null,
                proRataEnabled : false,
                maxAvailTimes: null,
                isSingleLeaveApproverAllowed: false,
                isLeaveApproveSequential: false
            }
        ];

        vm.create.carryTypeList = LEAVE_CARRY_TYPES;
        vm.create.earnedLeaveCriteriaList = EARNED_LEAVE_CRITERIA;
        vm.create.earnedLeaveCapTypeList = EARNED_LEAVE_CAP_TYPES;
        vm.create.expiryTimeWindowTypeList = EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST;
        vm.create.applicabilityType = LEAVE_APPLICABILITY_TYPE;

        vm.leavePolicy = {};
        vm.leavePolicy.leavePolicyList = null;
        vm.leaveCategory = {};
        vm.leaveCategory.leaveCategoryList = null;

        vm.isSingleLeaveApproverAllowed = null;
        vm.isSequentialLeaveApproverAllowed = null;

        vm.create.createCofigurationForm = {};

        vm.isDataLoaded = false;

        vm.showEarnedLeaveInputFields = true;


        vm.addNewCategoryConfigForm = addNewCategoryConfigForm;
        vm.removeCategoryConfigForm = removeCategoryConfigForm;
        vm.checkFormValidity = checkFormValidity;
        vm.toggleVisibilityAndChangeValuesOfEarnedLeaveFields = toggleVisibilityAndChangeValuesOfEarnedLeaveFields;

        init();

        function init() {
            var promises = [];
            promises.push(getAllLeavePolicies());
            promises.push(getAllLeaveCategories());
            promises.push(getIsSingleLeaveApproverAllowed());
            promises.push(getIsSequentialLeaveApproverAllowed());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                });
        }

        function getAllLeavePolicies() {
            return leavePolicyService.getAllLeavePolicies().then(function (leavePolicyList) {
                vm.leavePolicy.leavePolicyList = _.sortBy(leavePolicyList, function (leavePolicy){
                    return leavePolicy.name.toLowerCase();
                });
            },function (error) {
                toastrService.showErrorToastr("Could not load leave policies " + error, "", 5000)
            });
        }

        function getAllLeaveCategories() {
            return leaveCategoryService.getAllLeaveCategories().then(function (leaveCategoryList) {
                vm.leaveCategory.leaveCategoryList = _.sortBy(leaveCategoryList, function (leaveCategory){
                    return leaveCategory.name.toLowerCase();
                });
            },function (error) {
                toastrService.showErrorToastr("Could not load leave categories " + error, "", 5000);
            });
        }

        function createNewConfiguration() {
            vm.isCreating = true;
            toastrService.clearPreviousToastr();
            vm.create.configForms.forEach(function (configForm) {
                if(!configForm.earnedLeaveEnabled) configForm.earnedLeaveCriteria = 0;
                if(!configForm.pastDateSelectionEnabled) configForm.pastDateSelectionLimit = -1;
                if(configForm.isSingleLeaveApproverAllowed) configForm.isLeaveApproveSequential = false;
            });
            var formData = vm.create.configForms;
            var leavePolicyId = vm.create.leavePolicyId;

            leaveCategoryPolicyConfigurationService.createNewConfiguration(leavePolicyId, formData)
                .then(function () {
                    toastrService.showSuccessToastr("New configuration added successfully");
                }, function (error) {
                    toastrService.showErrorToastr("Could not create new configuration " + error, "", 5000);
                }).finally(function () {
                    vm.isCreating = false;
                });
        }

        function checkFormValidity() {
            var isValidForm = true;
            vm.create.configForms.forEach(function (configForm) {
                if(configForm.earnedLeaveEnabled) {
                    var calculationPeriod = configForm.earnedLeaveCapAmount * NUM_OF_DAYS_IN_EACH_TIME_WINDOW[configForm.earnedLeaveCapType];
                    var validityPeriod = configForm.expiryTimeWindowAmount * NUM_OF_DAYS_IN_EACH_TIME_WINDOW[configForm.expiryTimeWindowType];
                    if(validityPeriod > calculationPeriod) {
                        isValidForm = false;
                        vm.isCreating = false;
                        return toastrService.showErrorToastr("Earned leave validity period should not be greater than calculation period");
                    }
                }
                if(configForm.maxAvailTimes === 0){
                    vm.isCreating = false;
                    return toastrService.showErrorToastr("Max Avail Times value can't be 0");
                }
            });

            if(isValidForm) createNewConfiguration();
        }

        function addNewCategoryConfigForm() {
            var configForm = {
                leaveCategoryId : null,
                totalDays : 0,
                consecutiveDays : 0,
                monthlyRestriction : 0,
                fileUploadCondition : 0,
                maxCarry : 0,
                countOffdays : false,
                carryType : 0,
                pastDateSelectionEnabled : true,
                pastDateSelectionLimit : 30,
                earnedLeaveEnabled : false,
                earnedLeaveCriteria : null,
                maxEarnedLeaveCount : 0,
                perDayEarnedLeaveRequiredHours : 0,
                earnedLeaveCapType : 0,
                earnedLeaveCapAmount : 0,
                expiryTimeWindowAmount : 0,
                expiryTimeWindowType : 0,
                applicability : 0,
                eligibleAfter : null,
                proRataEnabled : false,
                maxAvailTimes: null,
                isSingleLeaveApproverAllowed: false,
                isLeaveApproveSequential: false
            };

            vm.create.configForms.push(configForm);
        }

        function removeCategoryConfigForm(index) {
            vm.create.configForms.splice(index, 1);
        }

        function toggleVisibilityAndChangeValuesOfEarnedLeaveFields(index) {
            if(!vm.create.configForms[index].earnedLeaveEnabled) {
                resetEarnedLeaveFields(index);
            }
            vm.showEarnedLeaveInputFields = !vm.showEarnedLeaveInputFields;
        }

        function resetEarnedLeaveFields(index) {
            vm.create.configForms[index].earnedLeaveCriteria = null;
            vm.create.configForms[index].maxEarnedLeaveCount = 0;
            vm.create.configForms[index].perDayEarnedLeaveRequiredHours = 0;
            vm.create.configForms[index].earnedLeaveCapType = 0;
            vm.create.configForms[index].earnedLeaveCapAmount = 0;
            vm.create.configForms[index].expiryTimeWindowAmount = 0;
            vm.create.configForms[index].expiryTimeWindowType = 0;
        }

        function getIsSingleLeaveApproverAllowed() {
            return leaveManagementService.getLeaveApprovalSystem().then(function (data) {
                vm.isSingleLeaveApproverAllowed = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load leave approval system " + error, "", 5000);
            });
        }
        function getIsSequentialLeaveApproverAllowed() {
            return leaveManagementService.getSequentialLeaveApprovalSystem().then(function (data) {
                vm.isSequentialLeaveApproverAllowed = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load leave approval system " + error, "", 5000);
            });
        }

        function updateSequentialApproval() {
            vm.create.configForms.forEach(function(configForm) {
                if (configForm.isSingleLeaveApproverAllowed) {
                    configForm.isLeaveApproveSequential = false;
                }
            });
        }

        $scope.$watch('vm.create.configForms', function() {
            updateSequentialApproval();
        }, true);
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveCategoryPolicyConfiguration')
    app.controller('EditConfigurationCtrl', ['leaveCategoryPolicyConfigurationService', 'leaveManagementService', '$scope', 'leavePolicyService', 'leaveCategoryService', '$uibModal', 'toastrService', '$q', 'LEAVE_CARRY_TYPES', 'EARNED_LEAVE_CRITERIA', 'EARNED_LEAVE_CAP_TYPES', 'EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST', 'NUM_OF_DAYS_IN_EACH_TIME_WINDOW', 'LEAVE_APPLICABILITY_TYPE', '$stateParams', 'analyticsService', 'ANALYTICS_CONSTANT', EditConfigurationCtrl]);

    /** @ngInject */
    function EditConfigurationCtrl(leaveCategoryPolicyConfigurationService, leaveManagementService, $scope, leavePolicyService, leaveCategoryService, $uibModal, toastrService, $q, LEAVE_CARRY_TYPES, EARNED_LEAVE_CRITERIA, EARNED_LEAVE_CAP_TYPES, EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST, NUM_OF_DAYS_IN_EACH_TIME_WINDOW, LEAVE_APPLICABILITY_TYPE, $stateParams, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.edit = {};
        vm.isValidField = {};
        vm.edit.configForms = [];

        vm.edit.carryTypeList = LEAVE_CARRY_TYPES;
        vm.edit.earnedLeaveCriteriaList = EARNED_LEAVE_CRITERIA;
        vm.edit.earnedLeaveCapTypeList = EARNED_LEAVE_CAP_TYPES;
        vm.edit.expiryTimeWindowTypeList = EARNED_LEAVE_EXPIRY_TIME_WINDOW_LIST;
        vm.edit.applicabilityType = LEAVE_APPLICABILITY_TYPE;

        vm.leaveCategory = {};
        vm.leaveCategory.leaveCategoryList = null;

        vm.isSingleLeaveApproverAllowed = null;
        vm.isSequentialLeaveApproverAllowed = null;

        vm.isDataLoaded = false;
        vm.showEarnedLeaveInputFields = true;
        var leavePolicyId = null;
        vm.openDeleteCategoryFromConfigurationModal = openDeleteCategoryFromConfigurationModal;
        vm.addNewCategoryConfigForm = addNewCategoryConfigForm;
        vm.checkFormValidity = checkFormValidity;
        vm.toggleVisibilityAndChangeValuesOfEarnedLeaveFields = toggleVisibilityAndChangeValuesOfEarnedLeaveFields;

        init();

        function init() {
            leavePolicyId = $stateParams.leavePolicyId;
            var promises = [];
            promises.push(getAllConfigurationsOfAPolicy());
            promises.push(getAllLeaveCategories());
            promises.push(getIsSingleLeaveApproverAllowed());
            promises.push(getIsSequentialLeaveApproverAllowed());
            $q.all(promises)
                .then(function () {
                    initializeFormFields();
                    vm.isDataLoaded = true;
                });
        }

        vm.validateField = function (value, fieldName) {
            vm.isValidField[fieldName] = validateDoubleField(value);
        };

        function validateDoubleField(value) {
            if (value === null || value === undefined) {
                return true; // Null or undefined values are allowed
            }
            // Allow only whole numbers or .5 values
            var fractionalPart = value - Math.floor(value);
            return fractionalPart === 0 || fractionalPart === 0.5;
        }
        function getAllConfigurationsOfAPolicy() {
            return leaveCategoryPolicyConfigurationService.getAllConfigurationsOfAPolicy(leavePolicyId).then(function (data) {
                vm.leavePolicyToCategoryConfigs = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load leave category-policy configurations " + error, "", 5000);
            });
        }

        function getAllLeaveCategories() {
            return leaveCategoryService.getAllLeaveCategories().then(function (leaveCategoryList) {
                vm.leaveCategory.leaveCategoryList = leaveCategoryList;
            },function (error) {
                toastrService.showErrorToastr("could not load leave categories " + error, "", 5000);
            });
        }

        function getIsSingleLeaveApproverAllowed() {
            return leaveManagementService.getLeaveApprovalSystem().then(function (data) {
                vm.isSingleLeaveApproverAllowed = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load leave approval system " + error, "", 5000);
            });
        }
        function getIsSequentialLeaveApproverAllowed() {
            return leaveManagementService.getSequentialLeaveApprovalSystem().then(function (data) {
                vm.isSequentialLeaveApproverAllowed = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load leave approval system " + error, "", 5000);
            });
        }

        function initializeFormFields() {
            vm.leavePolicyToCategoryConfigs.configs.forEach(function (config) {
                var configForm = {
                    id : config.id,
                    leaveCategoryId : config.leaveCategoryId,
                    totalDays : config.totalDays,
                    consecutiveDays : config.consecutiveDays,
                    monthlyRestriction : config.monthlyRestriction,
                    fileUploadCondition : config.fileUploadCondition,
                    maxCarry : config.maxCarry,
                    countOffdays : config.countOffdays,
                    carryType : config.carryType,
                    pastDateSelectionEnabled : (!!config.pastDateSelectionLimit && config.pastDateSelectionLimit > -1),
                    pastDateSelectionLimit : (!!config.pastDateSelectionLimit && config.pastDateSelectionLimit > -1) ? config.pastDateSelectionLimit : null,
                    earnedLeaveEnabled : (config.earnedLeaveCriteria !== 0),
                    earnedLeaveCriteria : (config.earnedLeaveCriteria === 0) ? null : config.earnedLeaveCriteria,
                    maxEarnedLeaveCount : config.maxEarnedLeaveCount,
                    perDayEarnedLeaveRequiredHours : config.perDayEarnedLeaveRequiredHours,
                    earnedLeaveCapType : config.earnedLeaveCapType,
                    earnedLeaveCapAmount : config.earnedLeaveCapAmount,
                    expiryTimeWindowAmount : config.expiryTimeWindowAmount,
                    expiryTimeWindowType : config.expiryTimeWindowType,
                    applicability : config.applicability,
                    eligibleAfter : config.eligibleAfter,
                    proRataEnabled : config.proRataEnabled,
                    maxAvailTimes: config.maxAvailTimes,
                    isSingleLeaveApproverAllowed: config.isSingleLeaveApproverAllowed,
                    isLeaveApproveSequential: config.isLeaveApproveSequential
                };
                vm.edit.configForms.push(configForm);
                if(configForm.earnedLeaveEnabled) vm.showEarnedLeaveInputFields = false;
            });
        }

        function openDeleteCategoryFromConfigurationModal(index, leaveCategoryPolicyConfigId) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/leave/leaveCategoryPolicyConfiguration/delete/modals/deleteCategoryFromConfiguration.modal.html',
                size: 'md',
                backdrop : 'static',
            }).result.then(function () {
                if(leaveCategoryPolicyConfigId != 0) {
                    deleteLeaveCategoryPolicyConfiguration(leaveCategoryPolicyConfigId);
                } else {
                    removeCategoryConfigForm(index);
                }
            });
        }

        function deleteLeaveCategoryPolicyConfiguration(leaveCategoryPolicyConfigId) {
            toastrService.clearPreviousToastr();
            vm.isDataLoaded = false;
            leaveCategoryPolicyConfigurationService.deleteLeaveCategoryPolicyConfiguration(leaveCategoryPolicyConfigId).then(function (data) {
                vm.leavePolicyToCategoryConfigs.configs = vm.leavePolicyToCategoryConfigs.configs.filter(function (config) {
                    return config.id !== leaveCategoryPolicyConfigId;
                });
                vm.edit.configForms = [];
                vm.showEarnedLeaveInputFields = true;
                initializeFormFields();
                vm.isDataLoaded = true;
                toastrService.showSuccessToastr("Configuration deleted successfully");
            }, function (error) {
                toastrService.showErrorToastr("Could not delete configuration " + error, "", 5000);
            });
        }

        function checkFormValidity(index, leaveCategoryPolicyConfigId) {
            var isFormValid = Object.values(vm.isValidField).every(Boolean);
            if (!isFormValid) {
                toastrService.showErrorToastr("Fields must be whole numbers or end in 0.5 Please correct highlighted fields.");
                return;
            }

            var calculationPeriod = vm.edit.configForms[index].earnedLeaveCapAmount * NUM_OF_DAYS_IN_EACH_TIME_WINDOW[vm.edit.configForms[index].earnedLeaveCapType];
            var validityPeriod = vm.edit.configForms[index].expiryTimeWindowAmount * NUM_OF_DAYS_IN_EACH_TIME_WINDOW[vm.edit.configForms[index].expiryTimeWindowType];
            if(vm.edit.configForms[index].earnedLeaveEnabled && validityPeriod > calculationPeriod) {
                vm.isEditing = false;
                return  toastrService.showErrorToastr("Earned leave validity period should not be greater than calculation period");
            }
            if(vm.edit.configForms[index].maxAvailTimes === 0){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Max Avail Times value can't be 0");
            }

            updateCategoryPolicyConfiguration(index, leaveCategoryPolicyConfigId);
        }

        function updateCategoryPolicyConfiguration(index, leaveCategoryPolicyConfigId) {
            if(leaveCategoryPolicyConfigId !== 0 ) {
                updateExistingConfiguration(index, leaveCategoryPolicyConfigId);
            } else {
                addNewCategoryConfigurationToPolicy(index);
            }
        }

        function updateExistingConfiguration(index, leaveCategoryPolicyConfigId) {
            vm.isEditing = true;
            toastrService.clearPreviousToastr();
            vm.isDataLoaded = false;
            var formData = {
                leavePolicyId: leavePolicyId,
                leaveCategoryId: vm.edit.configForms[index].leaveCategoryId,
                totalDays : vm.edit.configForms[index].totalDays,
                consecutiveDays : vm.edit.configForms[index].consecutiveDays,
                monthlyRestriction : vm.edit.configForms[index].monthlyRestriction,
                fileUploadCondition : vm.edit.configForms[index].fileUploadCondition,
                maxCarry : vm.edit.configForms[index].maxCarry,
                countOffdays : vm.edit.configForms[index].countOffdays,
                carryType : vm.edit.configForms[index].carryType,
                pastDateSelectionLimit : vm.edit.configForms[index].pastDateSelectionEnabled ? vm.edit.configForms[index].pastDateSelectionLimit : -1,
                earnedLeaveEnabled : vm.edit.configForms[index].earnedLeaveEnabled,
                earnedLeaveCriteria : (vm.edit.configForms[index].earnedLeaveEnabled) ? vm.edit.configForms[index].earnedLeaveCriteria : 0,
                maxEarnedLeaveCount : vm.edit.configForms[index].maxEarnedLeaveCount,
                perDayEarnedLeaveRequiredHours : vm.edit.configForms[index].perDayEarnedLeaveRequiredHours,
                earnedLeaveCapType : vm.edit.configForms[index].earnedLeaveCapType,
                earnedLeaveCapAmount : vm.edit.configForms[index].earnedLeaveCapAmount,
                expiryTimeWindowAmount : vm.edit.configForms[index].expiryTimeWindowAmount,
                expiryTimeWindowType : vm.edit.configForms[index].expiryTimeWindowType,
                applicability : vm.edit.configForms[index].applicability,
                eligibleAfter : vm.edit.configForms[index].eligibleAfter,
                proRataEnabled : vm.edit.configForms[index].proRataEnabled,
                maxAvailTimes: vm.edit.configForms[index].maxAvailTimes,
                isSingleLeaveApproverAllowed: vm.edit.configForms[index].isSingleLeaveApproverAllowed,
                isLeaveApproveSequential: vm.edit.configForms[index].isLeaveApproveSequential
            };

            leaveCategoryPolicyConfigurationService.updateLeaveCategoryPolicyConfiguration(leaveCategoryPolicyConfigId, formData)
                .then(function (data) {
                    vm.isDataLoaded = true;
                    toastrService.showSuccessToastr("Configuration updated successfully");
                },function (error) {
                    vm.isDataLoaded = true;
                    toastrService.showErrorToastr("Could not update leave configuration: " + error, "", 5000);
                }).finally(function () {
                    vm.isEditing = false;
                });
        }

        function addNewCategoryConfigurationToPolicy(index) {
            toastrService.clearPreviousToastr();
            vm.isDataLoaded = false;
            var formData = {
                leaveCategoryId: vm.edit.configForms[index].leaveCategoryId,
                totalDays : vm.edit.configForms[index].totalDays,
                consecutiveDays : vm.edit.configForms[index].consecutiveDays,
                monthlyRestriction : vm.edit.configForms[index].monthlyRestriction,
                fileUploadCondition : vm.edit.configForms[index].fileUploadCondition,
                maxCarry : vm.edit.configForms[index].maxCarry,
                countOffdays : vm.edit.configForms[index].countOffdays,
                carryType : vm.edit.configForms[index].carryType,
                pastDateSelectionLimit : vm.edit.configForms[index].pastDateSelectionEnabled ? vm.edit.configForms[index].pastDateSelectionLimit : -1,
                earnedLeaveEnabled : vm.edit.configForms[index].earnedLeaveEnabled,
                earnedLeaveCriteria : (vm.edit.configForms[index].earnedLeaveEnabled) ? vm.edit.configForms[index].earnedLeaveCriteria : 0,
                maxEarnedLeaveCount : vm.edit.configForms[index].maxEarnedLeaveCount,
                perDayEarnedLeaveRequiredHours : vm.edit.configForms[index].perDayEarnedLeaveRequiredHours,
                earnedLeaveCapType : vm.edit.configForms[index].earnedLeaveCapType,
                earnedLeaveCapAmount : vm.edit.configForms[index].earnedLeaveCapAmount,
                expiryTimeWindowAmount : vm.edit.configForms[index].expiryTimeWindowAmount,
                expiryTimeWindowType : vm.edit.configForms[index].expiryTimeWindowType,
                applicability : vm.edit.configForms[index].applicability,
                eligibleAfter : vm.edit.configForms[index].eligibleAfter,
                proRataEnabled : vm.edit.configForms[index].proRataEnabled,
                maxAvailTimes: vm.edit.configForms[index].maxAvailTimes
            };

            leaveCategoryPolicyConfigurationService.addNewConfigurationToExistingPolicy(leavePolicyId, formData)
                .then(function () {
                    vm.isDataLoaded = true;
                    toastrService.showSuccessToastr("New configuration added successfully to this policy");
                }, function (error) {
                    vm.isDataLoaded = true;
                    toastrService.showErrorToastr("Could not add new configuration: " + error, "", 5000);
                });
        }

        function removeCategoryConfigForm(index) {
            vm.edit.configForms.splice(index, 1);
            reevaluateEarnedLeaveInputFieldsVisibilityState();
        }

        function reevaluateEarnedLeaveInputFieldsVisibilityState() {
            vm.showEarnedLeaveInputFields = true;
            vm.edit.configForms.forEach(function (configForm) {
                if(configForm.earnedLeaveEnabled) vm.showEarnedLeaveInputFields = false;
            });
        }

        function addNewCategoryConfigForm() {
            var configForm = {
                id : 0,
                leaveCategoryId : null,
                totalDays : 0,
                consecutiveDays : 0,
                monthlyRestriction : 0,
                fileUploadCondition : 0,
                maxCarry : 0,
                countOffdays : false,
                carryType : 0,
                pastDateSelectionEnabled : true,
                pastDateSelectionLimit : 30,
                earnedLeaveEnabled : false,
                earnedLeaveCriteria : null,
                maxEarnedLeaveCount : 0,
                perDayEarnedLeaveRequiredHours : 0,
                earnedLeaveCapType : 0,
                earnedLeaveCapAmount : 0,
                expiryTimeWindowAmount : 0,
                expiryTimeWindowType : 0,
                applicability : 0,
                eligibleAfter : null,
                proRataEnabled : false,
                maxAvailTimes: null,
                isSingleLeaveApproverAllowed: false,
                isLeaveApproveSequential: false
            };

            vm.edit.configForms.push(configForm);
        }

        function toggleVisibilityAndChangeValuesOfEarnedLeaveFields(index) {
            if(!vm.edit.configForms[index].earnedLeaveEnabled) {
                resetEarnedLeaveFields(index);
            }
            vm.showEarnedLeaveInputFields = !vm.showEarnedLeaveInputFields;
        }

        function resetEarnedLeaveFields(index) {
            vm.edit.configForms[index].earnedLeaveCriteria = null;
            vm.edit.configForms[index].maxEarnedLeaveCount = 0;
            vm.edit.configForms[index].perDayEarnedLeaveRequiredHours = 0;
            vm.edit.configForms[index].earnedLeaveCapType = 0;
            vm.edit.configForms[index].earnedLeaveCapAmount = 0;
            vm.edit.configForms[index].expiryTimeWindowAmount = 0;
            vm.edit.configForms[index].expiryTimeWindowType = 0;
        }

        function updateSequentialApproval() {
            vm.edit.configForms.forEach(function(configForm) {
                if (configForm.isSingleLeaveApproverAllowed) {
                    configForm.isLeaveApproveSequential = false;
                }
            });
        }

        $scope.$watch('vm.edit.configForms', function() {
            updateSequentialApproval();
        }, true);

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leavePolicy')
    app.controller('LeavePolicyCreateUpdateDeleteModalCtrl', ['leavePolicyService','authService','$uibModal','$uibModalInstance','toastrService','leavePolicy', 'analyticsService', 'ANALYTICS_CONSTANT',LeavePolicyCreateUpdateDeleteModalCtrl]);

    /** @ngInject */
    function LeavePolicyCreateUpdateDeleteModalCtrl(leavePolicyService,authService,$uibModal,$uibModalInstance,toastrService,leavePolicy, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.create = {};
        vm.create.createLeavePolicyName = null;
        vm.leavePolicy = leavePolicy;

        vm.edit = {};
        vm.edit.leavePolicyName = null;
        var analyticsCreateTitle = 'Create Leave Category Policy Modal';
        var analyticsCreateUrl = 'create-leave-category-policy';
        var analyticsDeleteTitle = 'Delete Leave Category Policy Modal';
        var analyticsDeleteUrl = 'delete-leave-category-policy';
        var analyticsEditTitle= 'Edit Leave Category Policy Modal';
        var analyticsEditUrl = 'edit-leave-category-policy';
        vm.deleteLeavePolicy = deleteLeavePolicy;
        vm.createLeavePolicy = createLeavePolicy;
        vm.editLeavePolicy = editLeavePolicy;

        function init() {
            vm.leavePolicy = leavePolicy;
            if(leavePolicy != null) vm.edit.leavePolicyName = vm.leavePolicy.name;
        }

        init();

        function deleteLeavePolicy() {
            vm.isDeleting = true;
            leavePolicyService.deleteLeavePolicy(vm.leavePolicy.id)
                .then(function (allLeavePolicies) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Leave Category Policy In' + document.title, ANALYTICS_CONSTANT.delete)
                    //console.log("allLeavePolicies :::: "+allLeavePolicies);
                    $uibModalInstance.close(allLeavePolicies);
                }, function (error) {
                    toastrService.showErrorToastr('Can not delete leave policy: '+ error, '', 5000);
                }).finally(function () {
                vm.isDeleting = true;
            });
            /*leavePolicyService.deleteLeavePolicy(vm.leavePolicy.id,{status:-1})
                .then(function () {
                    leavePolicyService.deleteLeavePolicy(vm.leavePolicy.id)
                        .then(function (allLeavePolicies) {
                            $uibModalInstance.close(allLeavePolicies);
                        }, function (error) {
                            toastr.error("Could not delete leave policy because error " + error);
                        });
                    $uibModalInstance.close();
                },function () {
                    toastr.error("Could not delete delete Leave Policy");
                });*/
        }

        vm.isCreating = false;
        function createLeavePolicy () {
            if(!vm.create.createLeavePolicyName) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            vm.isCreating = true;
            leavePolicyService.createLeavePolicy({
                name:vm.create.createLeavePolicyName,
                officeId:authService.getAllInformation().office.id,
                status:1})
                .then(function (allLeavePolicies) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Leave Category Policy In' + document.title, ANALYTICS_CONSTANT.create)
                    $uibModalInstance.close(allLeavePolicies);
                }, function (error) {
                    toastrService.showErrorToastr('Can not create leave policy: '+ error, '', 5000);
                }).finally(function(){
                    vm.isCreating = false;
                });
        }

        vm.isEditing = false;
        function editLeavePolicy() {
            if(!vm.edit.leavePolicyName) {
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }

            var data = {
                name : vm.edit.leavePolicyName
            }

            vm.isEditing = true;
            leavePolicyService.updateLeavePolicyName(vm.leavePolicy.id, data)
                .then(function (data) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Leave Category Policy In' + document.title, ANALYTICS_CONSTANT.edit)
                    $uibModalInstance.close(data);
                }, function (error) {
                    toastrService.showErrorToastr("Policy name can not be updated - " + error, "", 5000);
                }).finally(function(){
                    vm.isEditing = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.uploadLeaveBalance')
        .controller('ExcelModalCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'toastrService','attendanceService','responseInfo', 'analyticsService', 'ANALYTICS_CONSTANT', ExcelModalCtrl]);

    /** @ngInject */
    function ExcelModalCtrl($scope, $stateParams, $state, $timeout,$uibModal, toastrService,attendanceService,responseInfo, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.showErrorBlock = false;
        vm.responseInfo = responseInfo;
        var analyticsViewErrorTitle ='View Error Modal';
        var analyticsViewErrorUrl = 'view-error'
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsViewErrorTitle, analyticsViewErrorUrl, 'View Error In' + document.title, ANALYTICS_CONSTANT.open)
        vm.showError = showError;

        function showError(){
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsViewErrorTitle + ' - View', analyticsViewErrorUrl + '/view', 'View Error In' + document.title, ANALYTICS_CONSTANT.view)

            vm.showErrorBlock = true;
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('CreateMemberCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'utilService', 'authService', '$q', 'membershipManagementService', 'deviceService', 'toastrService', 'GENDER', 'analyticsService', 'ANALYTICS_CONSTANT', CreateMemberCtrl]);

    /** @ngInject */
    function CreateMemberCtrl($scope, $stateParams, $state, $timeout, $uibModal, utilService, authService, $q, membershipManagementService, deviceService, toastrService, GENDER, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isCreating = false;
        vm.isDataLoaded = false;
        vm.memberName = null;
        vm.memberId = null;
        vm.memberEmail = null;
        vm.memberMobileNumber = null;
        vm.selectedGender = null;
        vm.dateOfBirth = null;
        vm.memberNidNumber = null;
        vm.presentAddress = null;
        vm.selectedPackage = null;
        vm.packageStartDate = moment();
        vm.packageEndDate = moment();
        vm.memberRfid = null;
        vm.file = null;

        vm.genderList = angular.copy(GENDER);
        vm.allPackageData = [];
        vm.isDeviceTabVisible = authService.isAdmin();
        vm.deviceList = [];
        vm.uploadedFiles = [];
        vm.documentUrls = [];

        vm.datePickerOptions = {
            singleDatePicker: true,
            startDate: moment(),
            autoApply: true,
            locale: {
                format: 'DD-MMM-YYYY'
            }
        };
        vm.datePicker = {};
        vm.datePicker.opened = false;
        vm.datePicker.format = "dd MMMM yyyy";
        vm.datePicker.options = {
            datepickerMode: 'day',
            maxDate: new Date(),
            minMode: 'day',
            maxMode: 'year'
        };
        vm.joiningDate = moment();
        vm.file = null

        vm.createNewMember = createNewMember;
        vm.uploadFiles = uploadFiles;
        vm.removeFile = removeFile;
        vm.setPackageEndDate = setPackageEndDate;
        vm.getDataOfSelectedPackage = getDataOfSelectedPackage;
        vm.openDatePicker = openDatePicker;

        function init() {
            $q.all([getPackageList(), getDeviceList()]).then(function () {
                vm.isDataLoaded = true;
            });
        }

        init();

        function openDatePicker() {
            vm.datePicker.opened = true;
        }

        function getPackageList() {
            return membershipManagementService.getAllPackages().then(function (data) {
                vm.allPackageData = data;
            }, function (error) {
                toastrService.showErrorToastr('Failed to fetch data: ' + error, '', '5000');
            });
        }

        function getDeviceList() {
            if (!vm.isDeviceTabVisible) return;
            return deviceService.getAllDevices().then(function (devices) {
                devices = addLabelAndLocation(devices);
                vm.deviceList = angular.copy(devices);
            }, function () {
                toastrService.showErrorToastr('Could not fetch devices list', "", 5000);
            });
        }

        function createNewMember() {
            toastrService.clearPreviousToastr();
            if (!vm.memberName)
                return toastrService.showErrorToastr("Name can't be empty");
            else if (!vm.memberId)
                return toastrService.showErrorToastr("Member id can't be empty");
            else if (!isValidEmail(vm.memberEmail))
                return toastrService.showErrorToastr("Please insert a correct email id")
            else if (!vm.selectedGender)
                return toastrService.showErrorToastr("Please select gender");
            else if (!vm.memberMobileNumber)
                return toastrService.showErrorToastr("Mobile number can't be empty");
            else if (vm.memberMobileNumber.length > 11)
                return toastrService.showErrorToastr("Mobile number can't be more than 11 digits");
            else if (!vm.memberNidNumber)
                return toastrService.showErrorToastr("NID can't be empty");
            else if (vm.memberNidNumber.length > 15)
                return toastrService.showErrorToastr("NID can't be more than 15 digits");
            else if (!vm.presentAddress)
                return toastrService.showErrorToastr("Address can't be empty");
            else if (!vm.memberRfid)
                return toastrService.showErrorToastr("RFID can't be empty");
            else if (vm.memberRfid.length > 10)
                return toastrService.showErrorToastr("RFID length can't be greater than 10");
            else if (!vm.selectedDevice)
                return toastrService.showErrorToastr("Please select device");
            else if (!vm.selectedPackage)
                return toastrService.showErrorToastr("Please select any package");
            else if (vm.dateOfBirth === null)
                return toastrService.showErrorToastr("Please select date of birth");

            vm.isCreating = true;
            var params = {
                name: vm.memberName,
                employeeOfficeId: vm.memberId,
                email: vm.memberEmail,
                gender: vm.selectedGender,
                mobileNumber: vm.memberMobileNumber,
                dateOfBirth: Number(moment(vm.dateOfBirth.valueOf()).format('x')),
                dateOfJoin: Number(vm.joiningDate.format('x')),
                nid: vm.memberNidNumber,
                address: vm.presentAddress,
                rfid: vm.memberRfid,
                deviceIds: vm.selectedDevice.map(function (device) {
                    return device.id
                }),
                packageId: vm.selectedPackage,
                paidAmount: vm.selectedPackageData.price,
                packageStartDate: Number(vm.packageStartDate.format('x')),
                documentUrls: vm.documentUrls,
            }
            membershipManagementService.addNewMember(params).then(function () {
                vm.isCreating = false;
                analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create', '' , 'Create Member In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.showSuccessToastr('New member created!', '', 5000);
                $state.go('membershipManagement.members');
            }, function (error) {
                vm.isCreating = false;
                toastrService.showErrorToastr('Failed to create: ' + error, '', '', 5000);
            });

        }

        function uploadFiles() {
            var formData = new FormData();
            formData.append("file", vm.file);

            membershipManagementService.fileUpload(formData).then(function (response) {
                analyticsService.sendData(ANALYTICS_CONSTANT.upload, document.title + ' - Upload', '', 'Upload In' + document.title, ANALYTICS_CONSTANT.upload)
                vm.uploadedFiles.push(vm.file);
                vm.documentUrls.push({fileName: response.fileName, fileUrl: response.url});
            }, function (error) {
                toastrService.showErrorToastr('Failed: ' + error, '', 5000);
            });

        }

        function removeFile(index) {
            vm.uploadedFiles.splice(index, 1);
        }

        function addLabelAndLocation(devices) {
            for (var i = 0; i < devices.length; i++) {
                devices[i]["label"] = devices[i]["identifier"] + " - " + devices[i]["location"];
            }
            return devices;
        }

        function getDataOfSelectedPackage() {
            vm.selectedPackageData = [];
            vm.selectedPackageData = vm.allPackageData.find(function (p) {
                return p.id == vm.selectedPackage;
            });
            setPackageEndDate();
        }

        function setPackageEndDate() {
            if (vm.selectedPackageData.durationType == 0)
                vm.packageEndDate = moment(vm.packageStartDate).add(vm.selectedPackageData.durationNumber, 'd');
            if (vm.selectedPackageData.durationType == 1)
                vm.packageEndDate = moment(vm.packageStartDate).add(vm.selectedPackageData.durationNumber, 'M');
            if (vm.selectedPackageData.durationType == 2)
                vm.packageEndDate = moment(vm.packageStartDate).add(vm.selectedPackageData.durationNumber, 'y');
        }

        $scope.$watch('vm.packageStartDate', function () {
            if (vm.selectedPackage)
                setPackageEndDate();
        });

        function isValidEmail(email) {
            if (!email)
                return false;
            else if (email) {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('DeleteMemberModalCtrl', ['$scope', '$stateParams', '$state', '$uibModal','$uibModalInstance', 'authService', 'toastrService', '$q','membershipManagementService','memberName', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteMemberModalCtrl]);

    function DeleteMemberModalCtrl($scope, $stateParams, $state, $uibModal,$uibModalInstance, authService, toastrService, $q,membershipManagementService,memberName, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.memberName = memberName;

        var analyticsDeleteTitle = 'Delete Member Modal';
        var analyticsDeleteUrl = 'delete-member';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Department In' + document.title, ANALYTICS_CONSTANT.open)
        vm.isCreating = false;
        vm.deleteMember = deleteMember;

        function deleteMember() {
            vm.isCreating = true;
            membershipManagementService.deleteMember(vm.memberName.id).then(function (){
                var analyticsDeleteTitle = 'Delete Member Modal';
                var analyticsDeleteUrl = 'delete-member';
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Department In' + document.title, ANALYTICS_CONSTANT.delete)
                toastrService.showSuccessToastr('Member delete successful');
                $state.go('membershipManagement.members');
            }
        , function (message) {
            toastrService.showErrorToastr("Failed to delete member - " + message,"",5000);
        }).finally(function (){
                vm.isCreating = false;
                $uibModalInstance.close();
            })

        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('EditMemberCtrl', ['$scope','$q','$stateParams', '$state', '$window', '$uibModal','utilService', 'authService','deviceService','toastrService','GENDER','membershipManagementService','analyticsService', 'ANALYTICS_CONSTANT', EditMemberCtrl]);

    function EditMemberCtrl($scope,$q, $stateParams, $state, $window,$uibModal,utilService, authService,deviceService, toastrService,GENDER,membershipManagementService,analyticsService,ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isCreating = false;
        vm.isDataLoaded = false;
        vm.subscriptionId = $stateParams.memberId;

        vm.isDeviceTabVisible = authService.isAdmin();
        vm.genderList = angular.copy(GENDER);

        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.removeFile = removeFile;
        vm.uploadFiles = uploadFiles;
        vm.openDocumentModal = openDocumentModal;
        vm.updateMemberInfo = updateMemberInfo;

        function init(){
            $q.all([getDetailsOfAMember(),getDeviceList()]).then(function (){
                if(vm.memberInfo.deviceIds){
                    vm.memberInfo.deviceIds.forEach(function (deviceId){
                        vm.deviceList.filter(function (device){
                            return device.id === deviceId
                        }).forEach(function (d){
                            d.ticked = true;
                        })
                    })
                }
                vm.isDataLoaded = true;
            });
        }
        init();

        function getDetailsOfAMember(){
           return  membershipManagementService.getAllInfoOfAMember(vm.subscriptionId).then(function (data){
               vm.memberInfo = data;
               vm.memberInfo.joiningDateInMillis = moment(vm.memberInfo.joiningDateInMillis);
               vm.memberInfo.packageStartDateInMillis = moment(vm.memberInfo.packageStartDateInMillis);
               vm.memberInfo.packageEndDateInMillis = moment(vm.memberInfo.packageEndDateInMillis);
               vm.memberInfo.dateOfBirthInMillis = moment(vm.memberInfo.dateOfBirthInMillis);
            },function (error){
                toastrService.showErrorToastr("Failed to fetch data: " + error, "", 5000);
            });
        }
        function getDeviceList(){
            if(!vm.isDeviceTabVisible) return ;
            return deviceService.getAllDevices().then(function (devices) {
                devices = addLabelAndLocation(devices);
                vm.deviceList = angular.copy(devices);
            },function () {
                toastrService.showErrorToastr('Could not fetch devices list', "", 5000);
            });
        }

        function updateMemberInfo() {
            toastrService.clearPreviousToastr();
            if(!vm.memberInfo.employeeName)
                return toastrService.showErrorToastr("Name can't be empty");
            else if(!vm.memberInfo.memberId)
                return toastrService.showErrorToastr("Member id can't be empty");
            else if(!isValidEmail(vm.memberInfo.email))
                return toastrService.showErrorToastr("Please insert a correct email id")
            else if(!vm.memberInfo.genderId)
                return toastrService.showErrorToastr("Please select gender");
            else if(!vm.memberInfo.mobileNumber)
                return toastrService.showErrorToastr("Mobile number can't be empty");
            else if(vm.memberInfo.mobileNumber.length > 11)
                return toastrService.showErrorToastr("Mobile number can't be more than 11 digits");
            else if(!vm.memberInfo.nid)
                return toastrService.showErrorToastr("NID can't be empty");
            else if(vm.memberInfo.nid.length > 15)
                return toastrService.showErrorToastr("NID can't be more than 15 digits");
            else if(!vm.memberInfo.address)
                return toastrService.showErrorToastr("Address can't be empty");
            else if(!vm.memberInfo.rfid)
                return toastrService.showErrorToastr("RFID can't be empty");
            else if(vm.memberInfo.rfid.length > 10)
                return toastrService.showErrorToastr("RFID length can't be greater than 10");
            else if(!vm.memberInfo.deviceIds)
                return toastrService.showErrorToastr("Please select device");
            vm.isCreating = true;
            var params = {
                name: vm.memberInfo.employeeName,
                employeeOfficeId: vm.memberInfo.memberId,
                email: vm.memberInfo.email,
                gender: vm.memberInfo.genderId,
                mobileNumber: vm.memberInfo.mobileNumber,
                dateOfBirth: Number(vm.memberInfo.dateOfBirthInMillis.format('x')),
                dateOfJoin: Number(vm.memberInfo.joiningDateInMillis.format('x')),
                nid: vm.memberInfo.nid,
                address: vm.memberInfo.address,
                rfid: vm.memberInfo.rfid,
                deviceIds: vm.memberInfo.deviceIds.map(function (device){return device.id}),
                documentUrls: vm.memberInfo.documentUrls,
            }
            membershipManagementService.updateMember(vm.subscriptionId, params).then(function (){
                vm.isCreating = false;
                analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit', '', 'Edit Member In' + document.title, ANALYTICS_CONSTANT.edit)
                toastrService.showSuccessToastr('Update Successful', '', 5000);
                $state.go('membershipManagement.members');
            },function (error){
                vm.isCreating = false;
                toastrService.showErrorToastr('Failed: ' + error, '', 5000);
            });
        }

        function removeFile(id,index,fileName){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/membershipManagement/members/edit/confirmationModal/confirmation.modal.html',
                size : 'md',
                controller : 'MembersConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {fileName : function () {
                        return fileName;
                    }}
            }).result.then(function () {
                if(id != null && index != null){
                    membershipManagementService.fileRemove(id).then(function (){
                        vm.memberInfo.documentUrls.splice(index,1);
                    });
                }
                else
                    vm.memberInfo.documentUrls.splice(index,1);
            });
        }

        function openDocumentModal(file){
            toastrService.clearPreviousToastr();
            if(file.fileUrl.includes('.png') || file.fileUrl.includes('.jpeg')){
                $uibModal.open({
                    animation : true,
                    templateUrl : 'app/pages/main/membershipManagement/members/edit/documentModal/openDocument.modal.html',
                    size : 'md',
                    controller : 'OpenDocumentModalCtrl',
                    controllerAs : 'vm',
                    backdrop : 'static',
                    resolve : {fileInfo : function () {
                            return file;
                        }}
                }).result.then(function () {
                });
            }
            else
                $window.open(file.fileUrl, '_blank');
        }

        function addLabelAndLocation(devices){
            for(var i=0; i<devices.length; i++){
                devices[i]["label"] = devices[i]["identifier"] + " - " + devices[i]["location"];
            }
            return devices;
        }

        function uploadFiles(){
            var formData = new FormData();
            formData.append("file", vm.file);

            membershipManagementService.fileUpload(formData).then(function (response){
                analyticsService.sendData(ANALYTICS_CONSTANT.upload, document.title + ' - Upload', '', 'Upload In' + document.title, ANALYTICS_CONSTANT.upload)
                vm.memberInfo.documentUrls.push({fileName:response.fileName,fileUrl:response.url,fileId:null});
            },function (error){
                toastrService.showErrorToastr('Failed: ' + error, '', 5000);
            });

        }
        function isValidEmail(email){
            if(!email)
                return false;
            else if(email){
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('UpgradePackageCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal','utilService', 'authService', 'employeeService', 'toastrService','membershipManagementService', UpgradePackageCtrl]);

    function UpgradePackageCtrl($scope, $stateParams, $state, $timeout,$uibModal,utilService, authService, employeeService, toastrService,membershipManagementService) {
        var vm = this;

        vm.subscriptionId = $stateParams.subscriptionId;
        vm.memberName = $stateParams.memberName;
        vm.genderList = ["Male","Female", "other"];
        vm.allPackageData = [];
        vm.selectedPackage = null;
        vm.uploadedFiles = [];
        vm.packageStartDate = moment();
        vm.packageEndDate = moment();
        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };
        vm.params = {
            packageId: null,
            packageStartDate: null,
        }
        vm.joiningDate = moment();
        vm.getDataOfSelectedPackage = getDataOfSelectedPackage;
        vm.upgradeSubscription = upgradeSubscription
        init();
        function init() {
            membershipManagementService.getAllPackages().then(function (data) {
                vm.allPackageData = data;
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr('Failed to fetch data: ' + error, '', '5000');
            });
        }

        function upgradeSubscription(){
            if(!vm.params.packageId)
                return toastrService.showErrorToastr("Please Select A Package", "", "5000");
            /*else if(!vm.params.paidAmount)
                return toastrService.showErrorToastr("Please Enter Paid Amount", "", "5000");*/
            else if(!vm.params.packageStartDate)
                return toastrService.showErrorToastr("Please Select Package Start Date", "", "5000");

            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/membershipManagement/members/modals/upgradeSubscriptionModal/upgradeSubscriptionModal.html',
                size        : 'md',
                controller  : 'UpgradeSubscriptionModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    subscriptionInfo:function () {
                        return {
                            memberName: vm.memberName,
                            subscriptionId: vm.subscriptionId,
                            packageId: vm.params.packageId,
                            packageName: vm.selectedPackageData.name,
                            packageAmount: vm.selectedPackageData.price,
                            duration: vm.selectedPackageData.duration,
                            packageStartDate: vm.packageStartDate,
                            packageEndDate: vm.packageEndDate,
                            updatedData : vm.params
                        }
                    }
                }
            }).result.then(function (){
                // console.log("Success");
            });
        }
        function getDataOfSelectedPackage(){
            vm.params.packageId = vm.selectedPackage;
            vm.selectedPackageData = [];
            vm.selectedPackageData = vm.allPackageData.find(function (p){
                return p.id == vm.selectedPackage;
            });
            setPackageEndDate();
        }
        function setPackageEndDate(){
            if(vm.selectedPackageData.durationType == 0)
                vm.packageEndDate = moment(vm.packageStartDate).add(vm.selectedPackageData.durationNumber, 'd');
            if(vm.selectedPackageData.durationType == 1)
                vm.packageEndDate = moment(vm.packageStartDate).add(vm.selectedPackageData.durationNumber, 'M');
            if(vm.selectedPackageData.durationType == 2)
                vm.packageEndDate = moment(vm.packageStartDate).add(vm.selectedPackageData.durationNumber, 'y');
        }
        $scope.$watch('vm.packageStartDate', function () {
            vm.params.packageStartDate = Number(vm.packageStartDate.format('x'))
            if(vm.selectedPackage){
                setPackageEndDate();
            }
        });

        vm.openRenewalMembershipModal = openRenewalMembershipModal;


        function openRenewalMembershipModal(memberName){

        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipSettings')
        .controller('CreatePackageCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q','membershipManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', CreatePackageCtrl]);

    function CreatePackageCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q,membershipManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.packagerName = null;
        vm.noOfMonths = null;
        vm.isCreating = false;
        vm.packageDurationList = [
            {name:'Day',value:0},{name:'Month',value:1},{name:'Year',value:2}
        ];
        vm.selectedDuration = null;
        vm.packagePrice = null;

        vm.createPackage = createPackage;

        function createPackage(){
            if(!vm.packagerName)
                return toastrService.showErrorToastr("Package name can't be empty");
            else if(vm.selectedDuration === null)
                return toastrService.showErrorToastr("Please select a duration of the package");
            else if(!vm.noOfMonths)
                return toastrService.showErrorToastr("Number of months can't be empty");
            else if(!vm.packagePrice)
                return toastrService.showErrorToastr("Please set a price for the package");
            vm.isCreating = true;

            var params = {
                name: vm.packagerName,
                durationType: vm.selectedDuration,
                durationNumber: vm.noOfMonths,
                price: vm.packagePrice,
                status: 1,
            };
            membershipManagementService.createOrEditPackage(params).then(function (){
                vm.isCreating = false;
                analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create', '', 'Create Package In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.showSuccessToastr('Package Create Successful', '', 5000);
                $state.go('membershipManagement.membershipSettings');

            },function (error){
                vm.isCreating = false;
                toastrService.showErrorToastr('Error: ' + error, '', '5000');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipSettings')
        .controller('DeletePackageModalCtrl', ['$scope', '$stateParams', '$state', '$uibModal','$uibModalInstance', 'authService', 'toastrService', '$q','membershipManagementService','packageName', 'analyticsService', 'ANALYTICS_CONSTANT', DeletePackageModalCtrl]);

    function DeletePackageModalCtrl($scope, $stateParams, $state, $uibModal,$uibModalInstance, authService, toastrService, $q,membershipManagementService,packageName, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isCreating = false;
        vm.packageName = packageName;

        var analyticsDeleteTitle = 'Delete Package Modal';
        var analyticsDeleteUrl = 'delete-package';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Package In' + document.title, ANALYTICS_CONSTANT.open)

        vm.deletePackage = deletePackage;

        function deletePackage() {
            vm.isCreating = true;
            membershipManagementService.deletePackage(vm.packageName.id).then(function (){
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Department In' + document.title, ANALYTICS_CONSTANT.delete)
                    toastrService.showSuccessToastr('Package delete successful');
                    $state.go('membershipManagement.membershipSettings');
            }
            , function (message) {
                console.error("Failed to delete member settings - " + message,"",5000);
            }).finally(function (){
                vm.isCreating = false;
                $uibModalInstance.close();
            })
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipSettings')
        .controller('EditPackageCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q','membershipManagementService','analyticsService', 'ANALYTICS_CONSTANT', EditPackageCtrl]);

    function EditPackageCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q,membershipManagementService,analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
         vm.packageInfo = $stateParams.packageInfo;
        vm.isCreating = false;
        vm.packageDurationList = [
            {name:'Day',value:0},{name:'Month',value:1},{name:'Year',value:2}
        ];

        vm.editPackage = editPackage;

         if(!vm.packageInfo)
             $state.go('membershipManagement.membershipSettings')

        function editPackage(){

            if(!vm.packageInfo.name)
                return toastrService.showErrorToastr("Package name can't be empty");
            else if(!vm.packageInfo.durationType && vm.packageInfo.durationType !== 0)
                return toastrService.showErrorToastr("Please select a duration of the package");
            else if(!vm.packageInfo.durationNumber)
                return toastrService.showErrorToastr("Number of months can't be empty");
            else if(!vm.packageInfo.price)
                return toastrService.showErrorToastr("Please set a price for the package");
            vm.isCreating = true;
            var params = {
                id: vm.packageInfo.id,
                name: vm.packageInfo.name,
                durationType: vm.packageInfo.durationType,
                durationNumber: vm.packageInfo.durationNumber,
                price: vm.packageInfo.price,
                status: 1,
            };
            membershipManagementService.createOrEditPackage(params).then(function (){
                vm.isCreating = false;
                analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit', '', 'Edit Package In' + document.title, ANALYTICS_CONSTANT.edit)
                toastrService.showSuccessToastr('Package edit successful', '', 5000);
                $state.go('membershipManagement.membershipSettings');

            },function (error){
                vm.isCreating = false;
                toastrService.showErrorToastr('Error: ' + error, '', '5000');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.dailyReport')
        .controller('MembershipDailyReportCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_','membershipReportService','moment','utilService', MembershipDailyReportCtrl]);


    function MembershipDailyReportCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, membershipReportService,moment,utilService) {
        var vm = this;
        var loggedInUser=authService.getLoggedInUser();
        vm.allEntries=[];
        vm.searchParams={};
        vm.titleDate=moment().format('DD MMMM  YYYY');
        vm.searchParams.perPage = utilService.setRowsPerPage(10);
        vm.searchParams.startTime=Number(moment().startOf('day').format('x'));
        vm.searchParams.date=Number(moment().startOf('day').format('x'));
        vm.isDataLoaded=false;
        vm.rowsPerPage = 0
        vm.rowsPerPage = 0
        vm.pageNumber =0
        vm.numberOfPages = 0;
        vm.total = 0
        vm.numberOfButtons = []
        vm.excelUrl=getDailyReportExcel();
        vm.filterConfig = {
            singleDatePicker: {
                show: true,
            },
            timePicker: {
                show: true,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : false,
                collapsible : false
            },
            subDepartmentFilter : {
                show : false,
                collapsible : true
            },
            designationFilter : {
                show : false
            },
            shiftGroupFilter : {
                show :false
            },
            genderFilter : {
                show : true
            },
            packageFilter : {
                show : true
            },
            employmentTypeFilter : {
                show : false
            },
            workplaceFilter : {
                show : false
            },
            lineManagerFilter : {
                show : false
            },
            hrManagerFilter : {
                show : false
            },
            statusFilter : {
                show : false,
                collapsible : true
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : false,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            memberSortKey : {
                show: true
            }
        };

        vm.getReportPageSpecifiedData=getReportPageSpecifiedData;
        vm.searchMembershipDailyReport=searchMembershipDailyReport;
        function init(){
            preparePagination();
            searchMembershipDailyReport(vm.searchParams);
        }
        init();
        function preparePagination(totalPage,selectedPage,total){
            vm.searchParams.perPage = utilService.getRowsPerPage();
            vm.searchParams.pageNumber = selectedPage==null? 0: selectedPage;
            vm.numberOfPages = totalPage==null? 0: totalPage;
            vm.total = total==null?0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }
        function getReportPageSpecifiedData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            searchMembershipDailyReport(vm.searchParams);
        }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.searchParams.pageNumber = vm.searchParams.pageNumber == 0? 0 : vm.pageNumber - 1;
            }else if(searchParams == 'next') {
                vm.searchParams.pageNumber = vm.searchParams.pageNumber == vm.totalPage ? vm.pageNumber : vm.pageNumber + 1;
            }else if(!isNaN(searchParams)){
                vm.searchParams.pageNumber = searchParams;
            }
        }
        function getDailyReportExcel(){
            vm.excelUrl=membershipReportService.getDailyReportExcelFile(vm.searchParams)
        }

        function searchMembershipDailyReport(searchParams) {
            vm.isDataLoaded = false;
            membershipReportService.getDailyReport(searchParams).then(function (data) {
                vm.allEntries = data.memberList;
                vm.isDataLoaded = true;
                vm.totalMember = data.totalMember;
                vm.totalAbsent = data.totalAbsent;
                vm.totalPresent = data.totalPresent;
                vm.totalHours = data.totalHour
                vm.titleDate = data.date;
                preparePagination(data.totalPages, data.currentPage, data.total)
                vm.searchParams = searchParams;
                getDailyReportExcel()
                $scope.$broadcast("refreshFixedColumns");

            }, function () {

            })

        };
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.subscriptionReport')
        .controller('SubscriptionReportCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_','membershipReportService','moment','utilService', SubscriptionReportCtrl]);


    function SubscriptionReportCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _,membershipReportService,moment,utilService) {
        var vm = this;
        //var loggedInUser=authService.getLoggedInUser();
        vm.allEntries=[];
        vm.searchParams={};
        vm.searchParams.perPage = utilService.setRowsPerPage(10);
        vm.titleDate=moment().format('MMMM  YYYY');
        vm.searchParams.from=moment().startOf('month').valueOf();
        vm.searchParams.to=moment().endOf('month').valueOf();
        vm.isDataLoaded=false;
        vm.rowsPerPage = 0
        vm.rowsPerPage = 0
        vm.pageNumber =0
        vm.numberOfPages = 0;
        vm.total = 0
        vm.numberOfButtons = []
        vm.excelUrl=getSubscriptionReportExcel();
        vm.filterConfig = {
            singleDatePicker: {
                show: false,
            },
            timePicker: {
                show: false,
            },
            monthYearPicker : {
                show : true
            },
            departmentFilter : {
                show : false,
                collapsible : false
            },
            subDepartmentFilter : {
                show : false,
                collapsible : true
            },
            designationFilter : {
                show : false
            },
            shiftGroupFilter : {
                show :false
            },
            genderFilter : {
                show : true
            },
            packageFilter : {
                show : true
            },
            excelDownloadButton : {
                show : true
            },
            memberSortKey : {
                show: true
            }
        };

        vm.getReportPageSpecifiedData=getReportPageSpecifiedData;
        vm.searchMembershipSubscriptionReport=searchMembershipSubscriptionReport;
        function init(){
            preparePagination();
            searchMembershipSubscriptionReport(vm.searchParams);
        }
        init();
        function preparePagination(totalPage,selectedPage,total){
            vm.searchParams.perPage = utilService.setRowsPerPage(10);
            vm.searchParams.perPage = utilService.getRowsPerPage();
            vm.searchParams.pageNumber = selectedPage==null? 0: selectedPage;
            vm.numberOfPages = totalPage==null? 0: totalPage;
            vm.total = total==null?0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }
        function getReportPageSpecifiedData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            searchMembershipSubscriptionReport(vm.searchParams);
        }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.searchParams.pageNumber = vm.searchParams.pageNumber == 0? 0 : vm.searchParams.pageNumber - 1;
            }else if(searchParams == 'next') {
                vm.searchParams.pageNumber = vm.searchParams.pageNumber == vm.totalPage ? vm.pageNumber : vm.pageNumber + 1;
            }else if(!isNaN(searchParams)){
                vm.searchParams.pageNumber = searchParams;
            }
        }
        function getSubscriptionReportExcel(){
            vm.excelUrl=membershipReportService.getSubscriptionReportExcelFile(vm.searchParams)
        }
        function searchMembershipSubscriptionReport(searchParams){
            searchParams.from=moment(searchParams.from).startOf('month').valueOf();
            searchParams.to=moment(searchParams.from).endOf('month').valueOf();
            vm.isDataLoaded=false;

            membershipReportService.subscriptionReport(searchParams).then(function (data){
                $scope.$broadcast("refreshFixedColumns");
                vm.allEntries=data.memberList;
                vm.isDataLoaded=true;
                vm.totalMember=data.totalMember;
                vm.totalAbsent=data.totalAbsent;
                vm.totalPresent=data.totalPresent;
                vm.totalHours=data.totalHour
                vm.titleDate=data.date;
                preparePagination(data.totalPages,data.currentPage,data.total)
                vm.searchParams=searchParams;
                getSubscriptionReportExcel()
            },function(){

            })

        };


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.monthlyReport')
        .controller('MembershipMonthlyReportCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_','membershipReportService','moment','utilService', MembershipMonthlyReportCtrl]);


    function MembershipMonthlyReportCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _,membershipReportService,moment,utilService) {
        var vm = this;
        var loggedInUser=authService.getLoggedInUser();
        vm.allEntries=[];
        vm.searchParams={};
        vm.titleDate=moment().format('MMMM  YYYY');
        vm.searchParams={};
        vm.searchParams.perPage = utilService.setRowsPerPage(10);
        vm.searchParams.from=moment().startOf('month').valueOf();
        vm.searchParams.to=moment().endOf('month').valueOf();
        vm.isDataLoaded=false;
        vm.rowsPerPage = 0
        vm.pageNumber =0
        vm.numberOfPages = 0;
        vm.total = 0
        vm.numberOfButtons = []
        vm.excelUrl=getMonthlyReportExcel();
        vm.filterConfig = {
            singleDatePicker: {
                show: false,
            },
            timePicker: {
                show: false,
            },
            monthRangePicker : {
                show : true
            },
            departmentFilter : {
                show : false,
                collapsible : false
            },
            subDepartmentFilter : {
                show : false,
                collapsible : true
            },
            designationFilter : {
                show : false
            },
            shiftGroupFilter : {
                show :false
            },
            genderFilter : {
                show : true
            },
            packageFilter : {
                show : true
            },
            excelDownloadButton : {
                show : true
            },
            memberSortKey : {
                show: true
            }
        };

        vm.getReportPageSpecifiedData=getReportPageSpecifiedData;
        vm.searchMembershipMonthlyReport=searchMembershipMonthlyReport;
        function init(){
            preparePagination();
            searchMembershipMonthlyReport(vm.searchParams);
        }
        init();
        function preparePagination(totalPage,selectedPage,total){

            vm.searchParams.perPage = utilService.getRowsPerPage();
            vm.searchParams.pageNumber = selectedPage==null? 0: selectedPage;
            vm.numberOfPages = totalPage==null? 0: totalPage;
            vm.total = total==null?0 : total;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        }
        function getReportPageSpecifiedData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            searchMembershipMonthlyReport(vm.searchParams);
        }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.searchParams.pageNumber = vm.searchParams.pageNumber == 0? 0 : vm.pageNumber - 1;
            }else if(searchParams == 'next') {
                vm.searchParams.pageNumber = vm.searchParams.pageNumber == vm.totalPage ? vm.pageNumber : vm.pageNumber + 1;
            }else if(!isNaN(searchParams)){
                vm.searchParams.pageNumber = searchParams;
            }
        }
        function getMonthlyReportExcel(){
            vm.excelUrl=membershipReportService.getMonthlyReportExcelFile(vm.searchParams)
        }
        function searchMembershipMonthlyReport(searchParams){
            //console.log('Hello World')
            if(searchParams.month1!=null&&searchParams.month2!=null){
                searchParams.from=searchParams.month1;
                searchParams.to=searchParams.month2;
            }
            vm.isDataLoaded=false;

            membershipReportService.getMonthlyReport(searchParams).then(function (data){
                vm.allEntries=data.members;
                vm.isDataLoaded=true;
                vm.totalMember=data.totalMember;
                vm.totalAbsent=data.totalAbsent;
                vm.totalPresent=data.totalPresent;
                vm.totalHours=data.totalHour
                vm.titleDate=data.date;
                preparePagination(data.totalPages,data.currentPage,data.total)
                vm.searchParams=searchParams;
                getMonthlyReportExcel()
                $scope.$broadcast("refreshFixedColumns");

            },function(){

            })

        };


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.overtime.manageOvertime')
        .controller(
            'AllowOvertimeCtrl', ['$uibModalInstance','overtimeService','selectedEmployeeIds','toastrService', AllowOvertimeCtrl]);

    /** @ngInject */
    function AllowOvertimeCtrl($uibModalInstance,overtimeService,selectedEmployeeIds,toastrService) {

        var vm = this;

        vm.selectedEmployeeIds = null;

        vm.allowOvertime = allowOvertime;

        function init() {
            vm.selectedEmployeeIds = selectedEmployeeIds;
        }
        init();

        function allowOvertime() {
            var data = {
                allowOvertime:true,
                employeeIdList: vm.selectedEmployeeIds
            };

            overtimeService.changeOvertimeStatus(data).then(function (data) {
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Changed overtime status for selected employees.");
                $uibModalInstance.close();
            },function (error) {
                toastrService.showErrorToastr("Could not allow overtime: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.overtime.manageOvertime')
        .controller('DisallowOvertimeCtrl', ['$uibModalInstance','overtimeService','selectedEmployeeIds','toastrService', DisallowOvertimeCtrl]);

    /** @ngInject */
    function DisallowOvertimeCtrl($uibModalInstance,overtimeService,selectedEmployeeIds,toastrService) {

        var vm = this;
        vm.selectedEmployeeIds = [];
        vm.disallowOvertime = disallowOvertime;

        function init() {
            vm.selectedEmployeeIds = selectedEmployeeIds;
        }

        init();

        function disallowOvertime() {
            var data = {
                allowOvertime:false,
                employeeIdList: vm.selectedEmployeeIds
            };

            overtimeService.changeOvertimeStatus(data).then(function (data) {
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Changed overtime status for selected employees.");
                $uibModalInstance.close();
            },function (error) {
                toastrService.showErrorToastr("Could not disallow overtime: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.employmentType')
        .controller('ApproveOvertimeModalCtrl', ['$uibModalInstance','authService','overtimeService','summary','employeeSummary','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', ApproveOvertimeModalCtrl]);

    /** @ngInject */
    function ApproveOvertimeModalCtrl($uibModalInstance,authService,overtimeService,summary,employeeSummary,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.time = null;

        var analyticsEditTitle= 'Approve Overtime Modal';
        var analyticsEditUrl= 'approve-overtime';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsEditTitle,analyticsEditUrl,'Approve Overtime In'+document.title, ANALYTICS_CONSTANT.open)

        vm.approveOvertime= approveOvertime;

        var pattern = /[0-9]{2}:[0-9]{2}/;

        function approveOvertime() {
            toastrService.clearPreviousToastr();
            vm.time = vm.time.replace(/\s/g,"");
            if(!vm.time || vm.time == '')
                return toastrService.showErrorToastr("Time cannot be empty");
            if(!vm.time.match(pattern))
                return toastrService.showErrorToastr("Please write the time in specified format hh:mm ");
            var hoursAndMinutes = vm.time.trim().split(":");
            var hours = hoursAndMinutes[0];
            var minutes = hoursAndMinutes[1];
            var data = {
                "hours"    : hours,
                "minutes" : minutes,
            };
            var hoursAndMinutesInMinutes = (Number(hours) * 60) + Number(minutes);
            overtimeService.updateApprovedOvertime(summary.summaryId, data).then(function () {
                employeeSummary.summary.totalApprovedOvertimeInMinutes = Number(employeeSummary.summary.totalApprovedOvertimeInMinutes);
                employeeSummary.summary.totalApprovedOvertimeInMinutes -= summary.approvedOvertimeInMinutes;
                var totalApprovedTime = employeeSummary.summary.totalApprovedOvertimeInMinutes;
                totalApprovedTime += hoursAndMinutesInMinutes;
                summary.approvedOvertimeInMinutes=hoursAndMinutesInMinutes;
                summary.approvedOvertime = Math.floor((hoursAndMinutesInMinutes) / 60) + "h " + hoursAndMinutesInMinutes % 60 + "m";
                employeeSummary.summary.totalApprovedOvertimeInMinutes = totalApprovedTime;
                employeeSummary.summary.totalApprovedOvertime= Math.floor(totalApprovedTime / 60 )+ "h " + totalApprovedTime % 60 + "m";
                $uibModalInstance.close();
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl,document.title+ ' - Approve Overtime','','Save Changes In'+document.title, ANALYTICS_CONSTANT.approve)
            }, function (error) {
                toastrService.showErrorToastr("Could not update: " + error, "", 5000);
            });
        }


    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.overtime.overtimeAllocator')
        .controller('OvertimeAllocatorTableCtrl',
            ['$scope','overtimeService', 'authService','$document','_', 'utilService','$uibModal', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', OvertimeAllocatorTableCtrl]);

    /** @ngInject */
    function OvertimeAllocatorTableCtrl($scope, overtimeService, authService,$document,_,utilService,$uibModal, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm  = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.numberOfPages = null;
        vm.attendanceList = [];
        vm.dateList = [];
        vm.selectedPaginationPage = 0;
        vm.dateList = null;
        vm.excelUrl = null;
        vm.pdfUrl = null;
        vm.isDataLoaded = null;
        vm.isFilterVisible = false;
        vm.searchParams = {};
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : loggedInUser.isAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            sortKey: {
            show: true
        }
            // excelDownloadButton : {
            //     show : true
            // },
            // pdfDownloadButton : {
            //     show : true,
            //     multipleOrientation: false
            // }
        };


        vm.openApproveOvertimeModal = openApproveOvertimeModal;
        // vm.exportAsPdf = exportAsPdf;
        vm.search = search;


        // function search (params) {
        //     vm.isDataLoaded = false;
        //     overtimeService.getOvertime(date.startDate.valueOf(), date.endDate.valueOf(), null,null, null, null, null, null, [authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id]).then(function (responseData) {
        //         vm.isDataLoaded = true;
        //         vm.excelUrl = overtimeService.getOvertimeReportExcel(date.startDate.valueOf(), date.endDate.valueOf(), null, null, null, null, null, [authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id]);
        //         vm.dateList = responseData.dates;
        //         vm.allData.overtimeData = responseData.perEmployeeOvertimeReportList;
        //         vm.prepareDataForPagination();
        //     }, function (message) {
        //         console.error("Cannot fetch attendance from server : " + message);
        //     });
        // };

        function search(params) {
            vm.isDataLoaded = false;
            modifyParams(params);
            overtimeService.getOvertime(vm.searchParams)
                .then(function (responseData) {
                    // vm.pdfUrl = overtimeService.getOvertimeReportPdf(vm.searchParams);

                    vm.isDataLoaded = true;
                    vm.dateList = responseData.dates;
                    vm.startOfDayList = responseData.startOfDayList;
                    // vm.excelUrl = overtimeService.getOvertimeReportExcel(vm.searchParams);
                    vm.attendanceList = responseData.perEmployeeOvertimeReportList;
                    vm.numberOfPages = responseData.totalPages;
                    vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                    vm.selectedPage = responseData.currentPage;
                    vm.total = responseData.total;

                    $scope.$broadcast("refreshFixedColumns");
                }, function (message) {
                    vm.isDataLoaded = true;
                    toastrService.showErrorToastr("Cannot fetch attendance from server : " + message, "", 5000);
                });
        };

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "overtime";
        }

        function openApproveOvertimeModal($index,attendance,employeeSummary) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/overtime/overtimeAllocator/approve/approveOvertime.modal.html',
                size : 'md',
                controller : 'ApproveOvertimeModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    summary : function () {
                        return attendance;
                    },
                    employeeSummary : function () {
                        return employeeSummary;
                    }
                }
            }).result.then(function (employmentType) {
                // vm.employmentTypeList.push(employmentType);
            });
        }
        // function exportAsPdf() {
        //     if (vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
        //         window.open(vm.pdfUrl, '_blank', '');
        //     }
        // }

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.overtime.overtimeReport')
        .controller('OvertimeReportTableCtrl',
            ['$scope','overtimeService', 'authService','$document','_', 'utilService','$uibModal', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES',OvertimeReportTableCtrl]);

    /** @ngInject */
    function OvertimeReportTableCtrl($scope, overtimeService, authService,$document,_,utilService,$uibModal, toastrService, analyticsService, ANALYTICS_CONSTANT, MODULES) {

        var vm  = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.numberOfPages = null;
        vm.attendanceList = [];
        vm.dateList = [];
        vm.selectedPaginationPage = 0;
        vm.dateList = null;
        vm.excelUrl = null;
        vm.pdfUrl = null;
        vm.isDataLoaded = null;
        vm.isFilterVisible = false;
        vm.searchParams = {};
        vm.isNotSubsidiaryAdmin = loggedInUser.isAdmin && loggedInUser.subsidiaryId == null && loggedInUser['modules'].includes(MODULES.SUBSIDIARY);

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : true,
                collapsible : false
            },
            singleDatePicker: {
                show: false,
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            subsidiaryFilter : {
                show : loggedInUser.isAdmin
            },
            statusFilter : {
                show : false,
                collapsible : false
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            excelDownloadButton : {
                show : true
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            sortKey: {
                show: true
            }
        };


        // vm.openApproveOvertimeModal = openApproveOvertimeModal;
        // vm.exportAsPdf = exportAsPdf;
        vm.search = search;


        // function search (params) {
        //     vm.isDataLoaded = false;
        //     overtimeService.getOvertime(date.startDate.valueOf(), date.endDate.valueOf(), null,null, null, null, null, null, [authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id]).then(function (responseData) {
        //         vm.isDataLoaded = true;
        //         vm.excelUrl = overtimeService.getOvertimeReportExcel(date.startDate.valueOf(), date.endDate.valueOf(), null, null, null, null, null, [authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id]);
        //         vm.dateList = responseData.dates;
        //         vm.allData.overtimeData = responseData.perEmployeeOvertimeReportList;
        //         vm.prepareDataForPagination();
        //     }, function (message) {
        //         console.error("Cannot fetch attendance from server : " + message);
        //     });
        // };

        function search(params) {
            vm.isDataLoaded = false;
            modifyParams(params);
            overtimeService.getOvertime(vm.searchParams)
                .then(function (responseData) {
                    vm.pdfUrl = overtimeService.getOvertimeReportPdf(vm.searchParams);

                    vm.isDataLoaded = true;
                    vm.dateList = responseData.dates;
                    vm.startOfDayList = responseData.startOfDayList;
                    vm.excelUrl = overtimeService.getOvertimeReportExcel(vm.searchParams);
                    vm.attendanceList = responseData.perEmployeeOvertimeReportList;
                    vm.numberOfPages = responseData.totalPages;
                    vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                    vm.selectedPage = responseData.currentPage;
                    vm.total = responseData.total;

                    $scope.$broadcast("refreshFixedColumns");
                }, function (message) {
                    vm.isDataLoaded = true;
                    toastrService.showErrorToastr("Cannot fetch attendance from server : " + message, "", 5000);
                });
        };

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
            vm.searchParams.reportType = "overtime";
        }

        // function openApproveOvertimeModal($index,attendance,employeeSummary) {
        //     toastrService.clearPreviousToastr();
        //     $uibModal.open({
        //         animation : true,
        //         templateUrl : 'app/pages/main/overtime/overtimeAllocator/approve/approveOvertime.modal.html',
        //         size : 'md',
        //         controller : 'ApproveOvertimeModalCtrl',
        //         controllerAs : 'vm',
        //         resolve : {
        //             summary : function () {
        //                 return attendance;
        //             },
        //             employeeSummary : function () {
        //                 return employeeSummary;
        //             }
        //         }
        //     }).result.then(function (employmentType) {
        //         // vm.employmentTypeList.push(employmentType);
        //     }, function (error) {
        //         toastrService.showErrorToastr("Employment type not created : " + error, "" , 5000);
        //         console.error("Employment type not created : " + error);
        //     });
        // }
        // function exportAsPdf() {
        //     if (vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
        //         window.open(vm.pdfUrl, '_blank', '');
        //     }
        // }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.liveFeedAndDashboard')
        .controller('EnterVehicleCtrl', ['$scope','$interval', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'parkingManagementService', '$q', '_','analyticsService', 'ANALYTICS_CONSTANT', EnterVehicleCtrl]);

    /** @ngInject */
    function EnterVehicleCtrl($scope, $interval, $stateParams, $state, $uibModal, authService, toastrService, parkingManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDataLoaded = true;
        vm.formFillupType = 'manual'
        vm.selectedVehicleType = null;
        vm.baseFare = null;
        vm.parkingType = 2;
        vm.allVehicleTypesAndBills = [];
        vm.entryTime = moment().format("hh:mm a");
        vm.foundNearbyList = [];
        vm.isFree = false;
        vm.refreshEnabled = false;

        vm.removeVehicle = removeVehicle;
        vm.getBaseFareForSelectedVehicle = getBaseFareForSelectedVehicle;
        vm.saveVehicle = saveVehicle;
        vm.setVehicleSearchKeyword = setVehicleSearchKeyword;
        vm.nearbyVehicle = nearbyVehicle;
        vm.refreshNearbyEntryVehicle = getAllNearbyVehicle;


        function init(){
            getAllNearbyVehicle();
            getAllVehicleTypesAndBills();
        }
        init();

        var promise;
        promise = $interval(function (){
            getAllNearbyVehicle();
        },10000);


        function getAllVehicleTypesAndBills() {
            vm.isDataLoaded = false;
            parkingManagementService.getAllBillSetup().then(function (data){
                vm.allVehicleTypesAndBills = data;
                vm.vehicleTypeAndBillsList = angular.copy(vm.allVehicleTypesAndBills);
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getAllNearbyVehicle() {
            // vm.isDataLoaded = false;
            vm.refreshEnabled = true;
            parkingManagementService.getNearbyVehicle().then(function (data){
                vm.foundNearbyList = data;
                vm.refreshEnabled = false;
                // vm.vehicleTypeAndBillsList = angular.copy(vm.allVehicleTypesAndBills);
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function nearbyVehicle(vehicle){
            vm.vehicleNumber = vehicle.vehicleNumber;
            vm.hexData = vehicle.hexData;
            var vehicleNumberParam = {
                keyword: vehicle.vehicleNumber
            }
            parkingManagementService.getNearbyVehicleDetails(vehicleNumberParam).then(function (data){
                if(data.id != null)
                    setVehicleSearchKeyword(data);
            });
        }

         function getBaseFareForSelectedVehicle(){
             vm.baseFare = vm.vehicleTypeAndBillsList.find(function (item){
                 return item.id === vm.selectedVehicleType
             });
         }

         function saveVehicle(){
            toastrService.clearPreviousToastr();
            if(!vm.vehicleNumber)
                return toastrService.showErrorToastr("Vehicle number can't be empty");
            else if(!vm.selectedVehicleType)
                return toastrService.showErrorToastr("Please select a vehicle");
            // else if(!vm.driverName)
            //     return toastrService.showErrorToastr("Driver name can't be empty");
            // else if(!vm.driverMobileNumber)
            //     return toastrService.showErrorToastr("Driver mobile number can't be empty");
            // else if(!vm.ownerName)
            //     return toastrService.showErrorToastr("Owner can't be empty");
            // else if(!vm.ownerMobileNumber)
            //     return toastrService.showErrorToastr("Owner mobile number can't be empty");

            var params = {
                vehicleNumber : vm.vehicleNumber,
                vehicleTypeId : vm.selectedVehicleType,
                driverName : vm.driverName,
                driverMobileNumber: vm.driverMobileNumber,
                ownerName: vm.ownerName,
                companyName: vm.companyName,
                ownerMobileNumber : vm.ownerMobileNumber,
                parkingType : vm.parkingType,
                entryTime : moment().valueOf(),
                hexData : vm.hexData,
                isPaid : !vm.isFree,
            }
             vm.isDataLoaded = false;
             parkingManagementService.entryVehicle(params).then(function (){
                 analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Entry Vehicle', '', 'Entry Vehicle In' + document.title, ANALYTICS_CONSTANT.create)
                 toastrService.showSuccessToastr('Entry Vehicle Successful');
                 $state.go('parkingManagement.liveFeedAndDashboard');
             }, function (error) {
                 toastrService.showErrorToastr("Error: " + error, "", 5000);
             }).finally(function () {
                 vm.isDataLoaded = true;
             });
        }

        function removeVehicle(index){
            vm.foundNearbyList.splice(index,1);
        }

        $scope.searchVehicle = function (keyword) {
            return parkingManagementService.searchVehicleWithNumber(keyword.trim()).then(function (data) {
                vm.allVehiclesList = data.vehicles
                return data.vehicles;
            })
        };

        function setVehicleSearchKeyword(item) {
            vm.formFillupType = 'fromSuggestion'
            vm.vehicleNumber = item.vehicleNumber;
            vm.selectedVehicleType = item.vehicleTypeId;
            vm.selectedVehicleName = item.vehicleTypeName;
            vm.driverName = item.driverName;
            vm.driverMobileNumber = (item.driverMobileNumber);
            vm.ownerName = item.employee.employeeName;
            vm.ownerMobileNumber = (item.employee.employeePhoneMobile);
            vm.companyName = item.companyName;
            vm.parkingType = 1;
            vm.baseFare = item.baseFare;
        }

        function removeEventListener(event){
            if(angular.isDefined(promise)){
                $interval.cancel(promise);
            }
        }

        $scope.$on('$destroy',function (){
            document.removeEventListener("visibilitychange",removeEventListener());
        })
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.liveFeedAndDashboard')
        .controller('ExitVehicleCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'parkingManagementService', '$q', '_','analyticsService', 'ANALYTICS_CONSTANT', ExitVehicleCtrl]);

    /** @ngInject */
    function ExitVehicleCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, parkingManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        var id = $stateParams.summaryId;

        var loggedInUser = authService.getLoggedInUser();
        vm.isParkingOperationsManager = loggedInUser.isParkingOperationsManager;

        vm.isDataLoaded = false;
        vm.parkingDetails = {};
        vm.parkingDetails.id = id;

        vm.openPrintSlipModal = openPrintSlipModal;


        function init(){
            getParkingDetails();
        }
        init();

        function getParkingDetails() {
            vm.isDataLoaded = false;
            parkingManagementService.getParkingDetails(id).then(function (data){
                vm.parkingDetails = data;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function openPrintSlipModal(){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/parkingManagement/liveFeedAndDashboard/exitVehicle/printSlipModal/printSlip.modal.html',
                size : 'md',
                controller : 'PrintSlipModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    printSlipInfo : function () {
                        return angular.copy(vm.parkingDetails);
                    }
                }
            }).result.then(function () {

            }, function (message) {

            });

        }
    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.parkingManagement.dailyParkingReport')
        .controller('DailyParkingReportCtrl',['authService','attendanceService','utilService','$scope', '$sce', '$uibModal', 'toastrService','parkingManagementService', 'generalSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', '$state', DailyParkingReportCtrl]);

    /** @ngInject */
    function DailyParkingReportCtrl(authService,attendanceService,utilService,$scope, $sce, $uibModal, toastrService,parkingManagementService, generalSettingsService, analyticsService, ANALYTICS_CONSTANT, $state) {
        var vm = this;

        vm.isDataLoaded = false;
        vm.excelUrl = '';
        vm.pdfUrl = '';
        vm.searchParams = {};
        vm.searchKeyword= ""
        vm.rowsPerPage = 10;
        vm.selectedPage = 0;
        vm.singleDatePicker = {};
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.maxDateForDailyReport = new Date();

        vm.singleDatePicker.date = moment().startOf("day");
        vm.singleDatePicker.options = {
            singleDatePicker:true,
            timePicker24Hour : false,
            eventHandlers : {
                'apply.daterangepicker': searchByDate,
            },
            locale: {
                format: "D MMM YYYY",
            }
        };

        vm.sortKeys = {
            'Vehicle Number'  : {value : 'vehicleNumber', order:'asc', selected : false},
            'Entry Time'      : {value : 'entryTime', order : 'asc', selected : false},
            'Exit Time'       : {value : 'exitTime', order : 'desc', selected : true},
            'Time Spent'      : {value : 'timeSpent', order : 'asc', selected : false},
            'Amount'          : {value : 'amount', order : 'asc', selected : false},
        };
        vm.allowAllDownload = false;
        vm.maxRows = 0;
        vm.rowsPerPageOption = [
            { value: 10},
            { value: 50},
            { value: 100},
            { value: 500},
            { value: 1000},
            { value: 2000}
        ]
        vm.selectedRowsPerPage = vm.rowsPerPageOption[1];
        vm.stateName = $state.current.name;

        vm.getDailyParkingInfo = getDailyParkingInfo;
        vm.SearchByNameOrVehicleNumber = SearchByNameOrVehicleNumber;
        vm.searchByDate = searchByDate;
        vm.updateSortKey = updateSortKey;
        vm.exportAsExcel = exportAsExcel;
        vm.exportAsPdf   = exportAsPdf;
        vm.handleRowPerPageSelection = handleRowPerPageSelection;

        function handleRowPerPageSelection() {
            utilService.setRowsPerPage(vm.selectedRowsPerPage.value);
            vm.getDailyParkingInfo();
        }

        function init(){
            getDailyParkingInfo();
            if (vm.stateName === 'parkingManagement.dailyParkingReport'){
                vm.rowsPerPageOption.push({value: 5000});
            }
            generalSettingsService.getReportSettingsOfAnOffice().then(function (response) {
                vm.allowAllDownload = response.allowAllDownload;
                vm.maxRows = response.maxRows;
                if (!vm.allowAllDownload && vm.maxRows > 0){
                    vm.rowsPerPageOption.push({value: vm.maxRows});
                }
            });
        }
        init()
        function searchByDate(){
            getDailyParkingInfo()
        }
        function SearchByNameOrVehicleNumber(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            getDailyParkingInfo()
        }
        function getDailyParkingInfo(searchParams){
            modifyParams(searchParams);
            var sortKeyAndOrder = getSortKeyAndOrder();
            utilService.setRowsPerPage(vm.rowsPerPage);
            vm.searchParams.dateInMillis  = vm.singleDatePicker.date.valueOf();
            vm.searchParams.count         = vm.rowsPerPage;
            vm.searchParams.keyword       = vm.searchKeyword;
            vm.searchParams.sortKey       = sortKeyAndOrder.key;

            vm.isDataLoaded = false;
            parkingManagementService.getDailyParkingReportInfo(vm.searchParams).then(function (data) {
                vm.allParkingData = data;
                vm.dailyParkingReportList = data.parkingDailyReports
                vm.isDataLoaded = true;
                vm.excelUrl = parkingManagementService.getDailyParkingReportExcelUrl(vm.searchParams, vm.allowAllDownload);
                vm.pdfUrl = parkingManagementService.getDailyParkingReportPdfUrl(vm.searchParams, vm.allowAllDownload);
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.totalParking;
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                console.log(error)
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
                else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function updateSortKey(key) {
            if(vm.sortKeys[key].selected){
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc'? 'desc' : 'asc';
            }else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function(keyName){
                    // console.log(vm.sortKeys[keyName]);
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            getDailyParkingInfo();
        }
        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for(var i = 0 ; i < keys.length ; i++){
                if(vm.sortKeys[keys[i]].selected == true){
                    return {key :  vm.sortKeys[keys[i]].value , order: vm.sortKeys[keys[i]].order}
                }
            }
        }

        function exportAsExcel() {
            if(vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                // var url = $scope.excelUrl + "&sortKey=" + getSortKeyAndOrder().key + "&order=" + getSortKeyAndOrder().order + "&pageNumber=" + $scope.selectedPage + "&perPage=" + vm.rowsPerPage;
                // window.open(url, '_blank', '');
                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel)
            }
        }
        function exportAsPdf() {
            if(vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
                window.open(vm.pdfUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf)
            }
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.parkingManagement.dailyParkingReport')
        .controller('MonthlyParkingReportCtrl', ['authService', 'utilService', '$scope', '$sce', '$uibModal', 'toastrService', 'parkingManagementService', 'generalSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', MonthlyParkingReportCtrl]);

    /** @ngInject */
    function MonthlyParkingReportCtrl(authService, utilService, $scope, $sce, $uibModal, toastrService, parkingManagementService, generalSettingsService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDataLoaded = false;
        vm.searchParams = {};
        vm.rowsPerPage = 31;
        vm.selectedPage = 0;
        vm.singleDatePicker = {};
        vm.singleDatePicker.date = null;
        vm.singleDatePicker.options = null;
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.maxDateForDailyReport = new Date();
        vm.pdfUrl = ''
        vm.excelUrl = ''
        vm.selectedMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.monthPicker = {};
        vm.monthPicker.opened = false;
        vm.monthPicker.format = "MMMM yyyy";
        vm.monthPicker.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode: 'month',
            maxMode: 'year'
        };
        vm.allowAllDownload = false;

        vm.getMonthlyParkingInfo = getMonthlyParkingInfo;
        vm.exportAsPdf = exportAsPdf
        vm.exportAsExcel = exportAsExcel
        vm.openMonthPicker = openMonthPicker;

        function init(){
            generalSettingsService.getReportSettingsOfAnOffice().then(function (response) {
                vm.allowAllDownload = response.allowAllDownload;
            });
        }
        init();

        function openMonthPicker() {
            vm.monthPicker.opened = true;
        }

        function getMonthlyParkingInfo(searchParams) {
            modifyParams(searchParams);
            utilService.setRowsPerPage(vm.rowsPerPage);
            vm.searchParams.perPage= vm.rowsPerPage
            if (vm.selectedMonth != null) {
                var selectedTime = moment().year(vm.selectedMonth.getFullYear()).month(vm.selectedMonth.getMonth());
                vm.searchParams.startDateInMillis = Number(getStartOfMonthFromMomentInMillis(selectedTime));
                vm.searchParams.endDateInMillis = Number(getEndOfMonthFromMomentInMillis(selectedTime));
                if (vm.searchParams.endDateInMillis > new Date().valueOf()) {
                    var date = new Date();
                    vm.searchParams.endDateInMillis = new Date().setHours(date.getHours(), 0, 0, 0).valueOf();
                }
            } else {
                return toastr.error("Please select month and year");
            }
            vm.isDataLoaded = false;
            parkingManagementService.getMonthlyParkingReportInfo(vm.searchParams).then(function (data) {
                vm.monthlyParkingReportList = data.parkingMonthlyReports;
                vm.monthlyParkingSummary = data.summary;
                vm.pdfUrl = parkingManagementService.getMonthlyParkingReportPdfUrl(vm.searchParams, vm.allowAllDownload)
                vm.excelUrl = parkingManagementService.getMonthlyParkingReportExcelUrl(vm.searchParams, vm.allowAllDownload)
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
                else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function exportAsPdf() {
            if (vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
                window.open(vm.pdfUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf)
            }
        }

        function exportAsExcel() {
            if (vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel)
            }
        }

        function getStartOfMonthFromMomentInMillis(d) {
            return d.startOf('month').format('x');
        }

        function getEndOfMonthFromMomentInMillis(d) {
            return d.endOf('month').format('x');
        }

        $scope.$watch('vm.monthPicker.opened', function (newVal, oldVal) {
            if (!newVal) {
                getMonthlyParkingInfo();
            }
        })
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.parkingSlotSetup')
        .controller('CreateParkingSlotSetupCtrl', ['$scope', '$stateParams', '$state', "parkingManagementService", '$timeout', '$uibModal', 'authService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateParkingSlotSetupCtrl]);

    /** @ngInject */
    function CreateParkingSlotSetupCtrl($scope, $stateParams, $state, parkingManagementService, $timeout, $uibModal, authService, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDataLoaded = true;
        var loggedInuser = authService.getLoggedInUser();

        vm.formData = {
            numberOfSlot:null,
        }

        vm.submitForm = submitForm
        function submitForm(valid) {
          if (valid){
              vm.formData.officeId = loggedInuser.officeId
              parkingManagementService.createOrUpdateParkingSlotSetup(vm.formData)
                  .then(function (response){
                      if (response === 'Success'){
                          analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create',
                              '','Create Parking Slot In'+document.title, ANALYTICS_CONSTANT.create)
                          openSuccessModal()
                      }
                      else
                          toastrService.showErrorToastr("","",5000);

                  })
          }
        }
        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/payrollSettings/modals/success.modal.html',
                size: 'md',
                controller: 'SuccessModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'You have successfully create parking slot to your system';
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.parkingSlotSetup')
        .controller('DeleteParkingSlotSetupModalCtrl', ['$uibModalInstance', 'data', "$stateParams", 'toastrService', 'parkingManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteParkingSlotSetupModalCtrl]);

    /** @ngInject */
    function DeleteParkingSlotSetupModalCtrl($uibModalInstance, data, $stateParams, toastrService, parkingManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.vehicleNumber = data.vehicleNumber;

        var analyticsDeleteTitle = 'Delete Slot Modal';
        var analyticsDeleteUrl = 'delete-slot';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl,
            'Delete Slot In' + document.title, ANALYTICS_CONSTANT.open)

        vm.delete = deleteData;

        function deleteData() {
            parkingManagementService.deleteParkingSlotSetup(data.id).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete',
                    analyticsDeleteUrl + '/delete', 'Delete Slot In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close(data);
                toastrService.showSuccessToastr("Delete Successful");
            },function (error) {
                toastrService.showErrorToastr("Could not delete Slot: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.parkingSlotSetup')
        .controller('EditParkingSlotSetupModalCtrl', ['$uibModalInstance', 'data', "$stateParams", 'toastrService', 'parkingManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', EditParkingSlotSetupModalCtrl]);

    /** @ngInject */
    function EditParkingSlotSetupModalCtrl($uibModalInstance, data, $stateParams, toastrService, parkingManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.data = data;

        vm.edit = editData;

        function editData() {
            var formData = {
                id: vm.data.id,
                numberOfSlot: vm.data.numberOfSlot,
                officeId: vm.data.officeId,
            }
            parkingManagementService.createOrUpdateParkingSlotSetup(formData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit',
                    '', 'Update Slot In' + document.title, ANALYTICS_CONSTANT.edit)
                $uibModalInstance.close(data);
                toastrService.showSuccessToastr("Update Successful");
            },function (error) {
                toastrService.showErrorToastr("Could not update Slot: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.billSetup')
        .controller('BillSetupCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'parkingManagementService', '$q', '_', BillSetupCtrl]);

    /** @ngInject */
    function BillSetupCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, parkingManagementService, $q, _) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.vehicleTypeList = null;
        vm.openDeleteBillSetupModal = openDeleteBillSetupModal;
        function init(){
            parkingManagementService.getAllBillSetup().then(onBillSetupListFetchSuccess, onBillSetupListFetchFailure);
        }

        init();

        function onBillSetupListFetchSuccess(vehicleTypeList){
            vm.vehicleTypeList = vehicleTypeList;
            $scope.$broadcast("refreshFixedColumns");

        }

        function onBillSetupListFetchFailure(error){
            console.log(error);
        }

        function openDeleteBillSetupModal (vehicleType) {
            toastrService.clearPreviousToastr();
            vm.deleteBillSetupModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/parkingManagement/settings/billSetup/billSetupDeleteModal/deleteBillSetup.model.html',
                size: 'md',
                controller:'DeleteBillSetupModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        vehicleTypeToChange:function () {
                            return vehicleType;
                        }
                    }
            }).result.then(function vehicleTypeDeleteSuccess() {
                init();
            });
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll')
        .controller('SuccessModalCtrl', [ '$uibModalInstance', 'toastrService', 'successMsg', SuccessModalCtrl]);

    /** @ngInject */
    function SuccessModalCtrl($uibModalInstance, toastrService, successMsg) {
        var vm = this;

        vm.successMsg = successMsg;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.vehicles')
        .controller('CreateVehicleCtrl', ['$scope', '$stateParams', '$state', "parkingManagementService", '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', CreateVehicleCtrl]);

    /** @ngInject */
    function CreateVehicleCtrl($scope, $stateParams, $state, parkingManagementService, $timeout, $uibModal, authService, employeeService, toastrService,  $q, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDataLoaded = true;
        vm.selectedOwner = [];
        vm.ownerDropDownList = [];
        vm.vehicleTypes = [];
        var loggedInuser = authService.getLoggedInUser();

        function init() {
            employeeService.getFilteredEmployees({status: 1, perPage: 300, pageNumber: 0}).then(function (data) {
                vm.employees = angular.copy(data.employees);
                generateOwnerSelectionOptions();
            });
            parkingManagementService.getAllBillSetup().then(function (data) {
                vm.vehicleTypes = data
            });

        }

        init();

        function generateOwnerSelectionOptions() {
            vm.employees.forEach(function (employee) {
                var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                if (employee.pictureUrl != null && employee.pictureUrl !== "") {
                    pictureElement = "<img src='" + employee.pictureUrl + "' />";
                }
                var designationNameElement = "";
                var departmentNameElement = "";
                if (employee.designationName != null && employee.designationName !== "") {
                    designationNameElement = "<span>" + employee.designationName + "</span>";
                }
                if (employee.departmentName != null && employee.departmentName !== "") {
                    departmentNameElement = "<span>" + employee.departmentName + "</span>";
                    if (designationNameElement.length > 0)
                        departmentNameElement = ", " + departmentNameElement;
                }

                var optionTemplate = "<div class='flex-container text-left width-95'>" +
                    "<div class='with-round-bg mb-0'>" +
                    pictureElement +
                    "</div>" +
                    "<div class='profile-info'>" +
                    "<span>" + employee.name + "</span>" +
                    "<div class='font-12 info-bg'>" +
                    "<small>" +
                    designationNameElement + departmentNameElement +
                    "</small>" +
                    "</div>" +
                    "</div>" +
                    "</div>";

                var obj = {
                    id: employee.id,
                    name: employee.name,
                    label: optionTemplate,
                    employeeOfficeId: employee.employeeOfficeId,
                    ticked: false
                };
                vm.ownerDropDownList.push(obj);
            });

        }

        // vm.selectOwner = selectOwner

        /*
                    function selectOwner(){
                        // console.log(vm.selectedOwner[0]["id"])
                        console.log(vm.allData.filter(value => {
                            return value.employee.employeeId === vm.selectedOwner[0]["id"]
                        }))

                    }
        */


        /*function openConfirmationModal(formData) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/modal/confirmation.modal.html',
                size: 'md',
                controller: 'ConfirmationModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    confirmationMsg: function () {
                        return {
                            confirmationText: 'Do you want to upload the ',
                            componentName: getSelectedComponentName(vm.selectedComponent)
                        }
                    }
                }
            }).result.then(function () {
                submitForm(formData);
            });
        }*/


        vm.formData = {
            vehicleNumber: null,
            employeePhoneNumber: null,
            vehicleTypeId: null,
            color: "",
            brand: "",
            model: "",
            ownerId: null,
            driverName: "",
            driverMobileNumber: "",
            companyName: "",
            officeId: loggedInuser.officeId
        }
        vm.submitForm = submitForm

        function submitForm(valid) {
            if (valid) {
                vm.formData.officeId = loggedInuser.officeId
                parkingManagementService.createOrUpdateVehicleInformation(vm.formData)
                    .then(function (response) {
                        if (response === 'Success') {
                            analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create', '', 'Create Vehicle In' + document.title, ANALYTICS_CONSTANT.create)
                            openSuccessModal(vm.formData.vehicleNumber)
                        } else
                            toastrService.showErrorToastr("", "", 5000);
                    },function (error) {
                        toastrService.showErrorToastr('Error:' + error, '', 5000);
                    })
            }
        }

        vm.setField = setField
        vm.employeesPhoneNumber = ''

        function setField() {
            var employee = vm.employees.find(function (e) {
                return e.id === vm.selectedOwner[0].id
            })
            vm.formData.ownerId = vm.selectedOwner[0].id
            vm.formData.employeePhoneNumber = employee.phoneMobile
            vm.employeesPhoneNumber = employee.phoneMobile
            vm.formData.email = employee.email

        }

        function openSuccessModal(vehicleNumber) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/payrollSettings/modals/success.modal.html',
                size: 'md',
                controller: 'SuccessModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'You have successfully register ' + vehicleNumber + ' to your system';
                    }
                }
            }).result.then(function () {
                $state.go('parkingManagement.vehicles');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteVehicleOwnerModalCtrl', ['$uibModalInstance', 'data', "$stateParams", 'toastrService', 'parkingManagementService','analyticsService', 'ANALYTICS_CONSTANT', DeleteVehicleOwnerModalCtrl]);

    /** @ngInject */
    function DeleteVehicleOwnerModalCtrl($uibModalInstance, data, $stateParams, toastrService, parkingManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.vehicleNumber = data.vehicleNumber;

        var analyticsDeleteTitle = 'Delete Vehicle Modal';
        var analyticsDeleteUrl = 'delete-vehicle';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Vehicle In' + document.title, ANALYTICS_CONSTANT.open)

        vm.delete = deleteData;

        function deleteData() {
            parkingManagementService.deleteVehicleInformation(data.id).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Vehicle In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close(data);
                toastrService.showSuccessToastr("Delete Successful");
            },function (error) {
                toastrService.showErrorToastr("Could not delete vehicle: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll')
        .controller('SuccessModalCtrl', [ '$uibModalInstance', 'toastrService', 'successMsg', SuccessModalCtrl]);

    /** @ngInject */
    function SuccessModalCtrl($uibModalInstance, toastrService, successMsg) {
        var vm = this;

        vm.successMsg = successMsg;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBanks')
        .controller('ManageBanksCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'bankManagementService', '$q', '_', ManageBanksCtrl]);

    /** @ngInject */
    function ManageBanksCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, bankManagementService, $q, _) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.isDataLoaded = false;
        vm.searchText = "";

        vm.banks = [];
        vm.bankBranches = [];

        vm.openAddNewBankModal = openAddNewBankModal;
        vm.openBankEditModal = openBankEditModal;
        // vm.goToLetterEditorPage = goToLetterEditorPage;

        init();

        function init() {
            vm.banks = [];
            $q.all([
                getAllBanks()
            ]).then(function () {
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function getAllBanks() {
            return bankManagementService.getAllBanks().then(function (data) {
                vm.banks = _.orderBy(data.banks, ["name"], ["asc"]);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch bank list: " + error, "", 5000);
            });
        }


        function openAddNewBankModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/bankSettings/bankManagement/modals/createBank/createBank.modal.html',
                size: 'md',
                controller : 'CreateBankModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (result) {
                createNewBank(result.data);
            });
        }


        function createNewBank(data) {
            vm.isDataLoaded = false;
            bankManagementService.createNewBank(data).then(function (data) {
                toastrService.showSuccessToastr("New bank added successfully.");
                init();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't add new bank: " + error, "", 5000);
                vm.isDataLoaded = true;
            });
        }

        function openBankEditModal(data) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/bankSettings/bankManagement/modals/editBank/editBank.modal.html',
                size: 'md',
                controller : 'EditBankModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    bankDetails: function () {
                        return angular.copy(data);
                    }
                }
            }).result.then(function (data) {
                updateBank(data);
            });
        }

        function updateBank(data) {
            vm.isDataLoaded = false;
            bankManagementService.updateBank(data).then(function (data) {
                toastrService.showSuccessToastr("Bank updated successfully.");
                init();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update bank: " + error, "", 5000);
                vm.isDataLoaded = true;
            });
        }

        // function goToLetterEditorPage(bankId) {
        //     $state.go("payroll.bankPaymentAdviceEditor", {bankId:bankId});
        //     // console.log(bankId);
        // }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBranches')
        .controller('ManageBranchesCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'bankManagementService', '$q', '_', ManageBranchesCtrl]);

    /** @ngInject */
    function ManageBranchesCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, bankManagementService, $q, _) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.isDataLoaded = false;
        vm.searchText = "";

        vm.banks = [];
        vm.bankBranches = [];

        vm.openAddNewBranchModal = openAddNewBranchModal;
        vm.openBranchEditModal = openBranchEditModal;

        init();

        function init() {
            vm.banks = [];
            vm.bankBranches = [];
            $q.all([
                getAllBanks(),
                getAllBranches()
            ]).then(function () {
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function getAllBanks() {
            return bankManagementService.getAllBanks().then(function (data) {
                vm.banks = _.orderBy(data.banks, ["name"], ["asc"]);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch bank list: " + error, "", 5000);
            });
        }

        function getAllBranches() {
            vm.isDataLoaded = false;
            return bankManagementService.getAllBranches().then(function (data) {
                vm.bankBranches = _.orderBy(data.branchList, ["bankName", "branchName"], ["asc", "asc"]);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch branch list: " + error, "", 5000);
            });
        }


        function openAddNewBranchModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/bankSettings/branchManagement/modals/createBranch/createBranch.modal.html',
                size: 'md',
                controller : 'CreateBranchModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    banks: function () {
                        return angular.copy(vm.banks);
                    }
                }
            }).result.then(function (result) {
                createNewBranch(result);
            });
        }

        function createNewBranch(data) {
            vm.isDataLoaded = false;
            bankManagementService.createNewBranch(data).then(function (data) {
                toastrService.showSuccessToastr("New branch added successfully.");
                init();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't add new branch: " + error, "", 5000);
                vm.isDataLoaded = true;
            });
        }

        function openBranchEditModal(data) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/bankSettings/branchManagement/modals/editBranch/editBranch.modal.html',
                size: 'md',
                controller : 'EditBranchModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    branchDetails : function () {
                        return angular.copy(data);
                    }
                }
            }).result.then(function (data) {
                updateBranch(data);
            });
        }

        function updateBranch(data) {
            vm.isDataLoaded = false;
            bankManagementService.updateBranch(data).then(function (data) {
                toastrService.showSuccessToastr("Branch updated successfully.");
                init();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update branch: " + error, "", 5000);
                vm.isDataLoaded = true;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.loanManagement')
        .controller('AddNewLoanOrSalaryAdvanceTypeCtrl', ['$scope', '$stateParams','$uibModal','$state', '$timeout', 'authService', 'employeeService', 'toastrService', 'loanManagementService', 'MONTH_NAMES','LOAN_TYPE','utilService', 'analyticsService', 'ANALYTICS_CONSTANT', AddNewLoanOrSalaryAdvanceTypeCtrl]);

    /** @ngInject */
    function AddNewLoanOrSalaryAdvanceTypeCtrl($scope, $stateParams, $uibModal, $state, $timeout, authService, employeeService, toastrService, loanManagementService, MONTH_NAMES,LOAN_TYPE,utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.selectedLoanType = $stateParams.selectedLoanType;
        vm.isDataLoaded = true;
        vm.searchKeyword = null;
        vm.loanType = angular.copy(LOAN_TYPE);
        vm.noOfInstallment = 20;
        vm.selectedMonth = new Date();
        vm.startingMonthOfInstallment = new Date();
        vm.previousLoanAmount="";
        //

        vm.datePickerOptions = {
            singleDatePicker : true,
            // startDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };
        vm.monthPickerInstallment = {};
        vm.monthPickerInstallment.opened = false;
        vm.monthPickerInstallment.format = "MMM yyyy";

        vm.monthPickerInstallment.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            // maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };

        vm.loanRequestDate = moment();
        vm.loanDisburseDate = moment();
        vm.loanAmount = null;

        var analyticsCreateTitle = 'Add New Loan or Advance Salary';
        var analyticsCreateUrl = 'add-new-loan-or-advance-salary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl,
            'Add New Loan or Advance Salary In' + document.title, ANALYTICS_CONSTANT.open)

        vm.openMonthPickerInstallment = openMonthPickerInstallment;
        vm.saveLoanOrSalaryAdvanceType = saveLoanOrSalaryAdvanceType;
        vm.getEmployeeProfileWithLoanInfo = getEmployeeProfileWithLoanInfo;

        init()
        function init(){
            if($stateParams.selectedLoanType==null){
                vm.selectedLoanType=2;
            }
        }
        function openMonthPickerInstallment() {
            vm.monthPickerInstallment.opened = true;
        }

        function saveLoanOrSalaryAdvanceType(){
            // console.log(vm.selectedLoanType)
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/loanManagement/loanOrSalaryAdvanceInput/modal/loanOrSalaryAdvance.modal.html',
                size: 'md',
                controller:'LoanOrSalaryAdvanceModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    loanData: function () {
                        return {
                            employeeName: vm.selectedEmployee.name,
                            // loanType: vm.loanType.find(function (item){return item.value == vm.selectedLoanType})
                            loanType: vm.selectedLoanType
                        };
                    }
                }
            }).result.then(function () {
                saveLoanOfAnEmployee();
            });
        }
        function saveLoanOfAnEmployee(){

            var params = {
                employeeId: vm.selectedEmployee.employeeId,
                type: vm.selectedLoanType,
                requestedAt: vm.loanRequestDate.format('x'),
                disbursedAt: vm.loanDisburseDate.format('x'),
                amount: vm.loanAmount,
                instalmentCount: vm.noOfInstallment,
                emiStartMonth: vm.startingMonthOfInstallment.getMonth() + 1,
                emiStartYear: vm.startingMonthOfInstallment.getFullYear(),
                remarks:vm.remarks,
            }

            loanManagementService.addNewLoanForAnEmployee(params).then(function (data){
                var analyticsSaveTitle = 'Save Loan/Advanced Salary Input Modal';
                var analyticsSaveUrl = 'save-loan-or-advanced-salary'
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSaveTitle + ' - Yes', analyticsSaveUrl + '/yes', 'Save Loan/Advanced Salary Input In' + document.title, ANALYTICS_CONSTANT.yes)

                toastrService.showSuccessToastr("Loan added successfully", "", 5000);
                return $state.go('payroll.loanManagement');
            },function (error){
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }

        function getEmployeeProfileWithLoanInfo(selectedEmployee) {
            vm.isDataLoaded = false;
            return loanManagementService.getProfileWithLoanInfo(selectedEmployee.id).then(function (data){
                vm.selectedEmployee = data;
                vm.previousLoanAmount = data.loanAmount != null ? data.loanAmount.toLocaleString() : "";
                // vm.previousLoanAmount = data
                // console.log(data)
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee data, " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.loanManagement')
    app.controller('DeferLoanModalCtrl', ['appointmentLogService', 'authService', '$uibModalInstance', 'toastrService', 'loanToDefer','loanManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', DeferLoanModalCtrl]);

    /** @ngInject */
    function DeferLoanModalCtrl(appointmentLogService, authService, $uibModalInstance, toastrService, loanToDefer, loanManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.loanToDefer=loanToDefer;
        vm.deferLoanBy=null;
        var analyticsDeferLoanUrl = 'defer-loan';
        var analyticsDeferLoanTitle = 'Defer Loan Modal';
        vm.deferLoan = deferLoan;
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeferLoanTitle, analyticsDeferLoanUrl, 'Defer Loan In ' + document.title, ANALYTICS_CONSTANT.open)
        function deferLoan(){
            if(vm.deferLoanBy==null|| vm.deferLoanBy==0)
                return;
            var params={
                loanId:loanToDefer.id,
                monthsDeferBy:vm.deferLoanBy==null?0:vm.deferLoanBy
            }
            loanManagementService.deferLoan(params).then(function(data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeferLoanTitle + ' - Yes', analyticsDeferLoanUrl + '/yes', 'Defer Loan In ' + document.title, ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr('Loan Defered Successfully By '+ vm.deferLoanBy+' month(s)')
                $uibModalInstance.close();
            },function(err){
                toasterService.showErrorToastr('Error Occured : '+err)
            })

        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.loanManagement')
    app.controller('EarlySettlementCtrl', ['authService', '$uibModalInstance', 'toastrService', 'loanToSettle', 'loanInstallments', 'loanManagementService', 'LOAN_PAYMENT_MODES', 'analyticsService', 'ANALYTICS_CONSTANT', EarlySettlementCtrl]);

    /** @ngInject */
    function EarlySettlementCtrl(authService, $uibModalInstance, toastrService, loanToSettle, loanInstallments, loanManagementService, LOAN_PAYMENT_MODES, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.loanToSettle = loanToSettle;
        vm.loanPaymentModes = angular.copy(LOAN_PAYMENT_MODES);
        vm.settleBalance = 0;
        vm.settleMonths = 0;
        vm.remarks = null;
        vm.loanInstallments = loanInstallments;
        vm.selectedPaymentMode = 1;
        var analyticsSettleLoanUrl = 'settle-loan';
        var analyticsSettleLoanTitle = 'Settle Loan Early Modal';
        vm.settleLoan = settleLoan;
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSettleLoanTitle, analyticsSettleLoanUrl, 'Settle Loan Early In ' + document.title, ANALYTICS_CONSTANT.open)

        init();

        function init() {
            vm.loanInstallments.forEach(function (elem) {
                if (elem.status == 0) {
                    vm.settleBalance += elem.emiAmount;
                    vm.settleMonths++;
                }
            })
        }

        function prepareParams() {
            var data = {
                loanId: vm.loanToSettle.id,
                remarks: vm.remarks,
                paymentMode: Number(vm.selectedPaymentMode)
            }
            return data;
        }

        function settleLoan() {
            loanManagementService.settleLoan(prepareParams()).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSettleLoanTitle + ' - Yes', analyticsSettleLoanUrl + '/yes', 'Settle Loan Early In ' + document.title, ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr('Loan Settled Successfully')
                $uibModalInstance.close();
            }, function (err) {
                toasterService.showErrorToastr('Error Occured : ' + err)
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.absentOrLeaveWithoutPay')
        .controller('AbsentOrLeaveWithoutPayCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService','$uibModal', "utilService", 'toastrService', 'payrollSettingsService','payrollManagementService', 'MONTH_NAMES', '$window', 'attendanceService', 'analyticsService', 'ANALYTICS_CONSTANT', AbsentOrLeaveWithoutPayCtrl]);

    /** @ngInject */
    function AbsentOrLeaveWithoutPayCtrl($scope, $stateParams, $state, $timeout, authService, employeeService,$uibModal, utilService, toastrService, payrollSettingsService, payrollManagementService, MONTH_NAMES, $window, attendanceService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.search = search;
        vm.allEmployeeData = [];
        vm.rowsPerPage = 50;
        vm.total = null;
        vm.isDataLoaded = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.searchParams = {};
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.deleteBtnActive = false
        var uploadParams = {};
        vm.getRowsPerPage = getRowsPerPage;
        vm.openDeleteModal = openDeleteModal;
        vm.uploadSelectedExcelFile = uploadSelectedExcelFile;
        vm.downloadSampleExcelFile = payrollManagementService.downloadLeaveApplyCalculationSample();
        vm.editComponent = editComponent;
        vm.goToAddNewPage = goToAddNewPage;

        function getRowsPerPage() {
            return Number(utilService.getRowsPerPage());
        }

        var loggedInUser = authService.getLoggedInUser();

        vm.allSelected = false;
        vm.employeeInfo= [];
        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin || loggedInUser.isLineManager) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter: {
                show: true
            },
            deviceFilter: {
                show: false
            },
            componentFilter: {
                show: false,
            },
            absenceTypeFilter: {
                show: true,
            },
            monthYearPickerFrom: {
                show: false
            },
            monthYearPickerTo: {
                show: false
            },
            monthYearPickerSalary: {
                show: true
            },
            monthYearPickerComparison: {
                show: false
            },
            excelDownloadButton: {
                show: false,
            },
            pdfDownloadButton: {
                show: false,
            },
            addButton: {
                show: true,
            },
            uploadButton: {
                show: true,
            },
            downloadDemoExcelButton: {
                show: true,
            },
            downloadBankAdviceLetterButton: {
                show: false,
            },
            deleteButton: {
                show: false,
            },
            sortKey: {
                show: true
            },
            rowPerPage: {
                show: true
            },
            searchByNameIdRfid: {
                show: true
            },
            filterByNetPayment: {
                show: false
            }
        };
        vm.success = false

        function search(searchParams) {
            uploadParams = searchParams;
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            vm.searchParams.salaryProcessType = "absentLwp";
            vm.monthName = MONTH_NAMES[searchParams.salaryMonth-1]
            payrollManagementService.getAbsentLwpComponents(vm.searchParams).then(function (data) {
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
                vm.excelUrl = attendanceService.getDetailedMonthlyReportExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getDetailedMonthlyReportPdfUrl(vm.searchParams);
                // vm.verticalPdfUrl = attendanceService.getMonthlyVerticalReportPdfUrl(vm.searchParams);
                vm.allEmployeeData = data.components;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.optionToggled = optionToggled;

        function checkOrUncheckAll() {
            if(vm.allSelected === false){
                vm.employeeInfo.forEach(function (allocations) {
                    allocations.isSelected = false;
                });
            }
            else{
                vm.employeeInfo.forEach(function (allocations) {
                    allocations.isSelected = true;
                });
            }
        }

        function optionToggled() {
            vm.allSelected = vm.employeeInfo.every(function (itm) {
                return itm.isSelected === true;
            });
        }
        function openDeleteModal(employeeId, componentId, searchParam) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/delete/deleteModal.html',
                size: 'md',
                controller: 'DeleteAbsentLeaveComPModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    empData: function () {
                        return {
                            employeeId: employeeId,
                            additionalComponentId: componentId,
                            startMonth : searchParam.salaryMonth,
                            endMonth : searchParam.salaryMonth,
                            startYear : searchParam.salaryYear,
                            endYear : searchParam.salaryYear,
                        };
                    }
                }
            }).result.then(function (data) {
                search(vm.searchParams);
            },function () {

            });
        }

        function excelUploadRequest(params){
            return {
                month: params.salaryMonth,
                year: params.salaryYear,
                componentId: params.componentIds[0],
            }
        }

        function uploadSelectedExcelFile($file) {
            toastrService.clearPreviousToastr();
            var parameters = excelUploadRequest(uploadParams);
            if(!parameters.componentId)
                return toastrService.showErrorToastr("Please select a component");
            if($file == null) return ;
            payrollManagementService.uploadLeaveApplyCalculationExcel($file, excelUploadRequest(uploadParams)).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.uploadExcel, document.title + ' - Upload Excel', '', 'Upload Excel In' + document.title, ANALYTICS_CONSTANT.uploadExcel)
                toastrService.showSuccessToastr("Absent/Leave Without Pay created successfully")
                search(uploadParams);
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });

        }

        function editComponent(item) {
            var absenceTypeComponent = {
                employeeId : item.employeeId,
                componentId : item.componentId,
                numberOfDays : item.days,
                remarks : item.remarkList[0],
                salaryMonth : vm.searchParams.salaryMonth,
                salaryYear : vm.searchParams.salaryYear
            };
            $state.go("payroll.absentTypeForIndividualEmployeeUpdate", {absenceTypeComponent : absenceTypeComponent});
        }

        function goToAddNewPage() {
            // analyticsService.sendData(ANALYTICS_CONSTANT.addNewComponent, document.title + ' - Add New Absent Type For Individual Employee', '', 'Add New Component For Individual Employee In' + document.title, ANALYTICS_CONSTANT.addNewComponent)
            var initialSelection = {
                salaryMonth : vm.searchParams.salaryMonth,
                salaryYear : vm.searchParams.salaryYear
            };

            $state.go("payroll.absentTypeInputForIndividualEmployee", {initialSelection : initialSelection});
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryComponentUpload')
        .controller('SalaryComponentUploadCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService','$uibModal', 'utilService', 'toastrService', 'payrollSettingsService', 'payrollManagementService','MONTH_NAMES', '$window', 'analyticsService', 'ANALYTICS_CONSTANT', SalaryComponentUploadCtrl]);

    /** @ngInject */
    function SalaryComponentUploadCtrl($scope, $stateParams, $state, $timeout, authService, employeeService, $uibModal, utilService, toastrService, payrollSettingsService, payrollManagementService, MONTH_NAMES, $window, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.search = search;
        vm.isDataLoaded = true;
        vm.allEmployeeData = [];
        vm.rowsPerPage = 50;
        vm.total = null;
        vm.isDataLoaded = false;
        vm.allSelected = false;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.searchParams = {};
        vm.numberOfRows = utilService.getRowsPerPage();
        vm.file = null;
        var uploadParams = {};
        vm.deleteBtnActive = false

        vm.getRowsPerPage = getRowsPerPage;
        vm.checkOrUncheckAll =checkOrUncheckAll;
        vm.optionToggled = optionToggled;
        vm.openDeleteModal = openDeleteModal;
        vm.editComponent = editComponent;
        vm.uploadSelectedExcelFile = uploadSelectedExcelFile;
        vm.downloadSampleExcelFile = payrollManagementService.downloadAdditionalComponentSample();
        vm.goToAddNewPage = goToAddNewPage;


        function getRowsPerPage() {
            return Number(utilService.getRowsPerPage());
        }

        vm.filterConfig = {
            companyFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter: {
                show: loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            departmentFilter: {
                show: !loggedInUser.isGroupAdmin,
                collapsible: true
            },
            designationFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            genderFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            workplaceFilter: {
                show: !loggedInUser.isGroupAdmin
            },
            lineManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            hrManagerFilter: {
                show: (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter: {
                show: true
            },
            componentFilter: {
                show: true,
            },
            absenceTypeFilter: {
                show: false,
            },
            monthYearPickerFrom: {
                show: true
            },
            monthYearPickerTo: {
                show: true
            },
            monthYearPickerSalary: {
                show: false
            },
            monthYearPickerComparison: {
                show: false
            },
            excelDownloadButton: {
                show: false,
            },
            pdfDownloadButton: {
                show: false,
            },
            addButton: {
                show: true,
            },
            uploadButton: {
                show: true,
            },
            downloadDemoExcelButton: {
                show: true,
            },
            downloadBankAdviceLetterButton: {
                show: false,
            },
            deleteButton: {
                show: false,
            },
            sortKey: {
                show: true
            },
            rowPerPage: {
                show: true
            },
            searchByNameIdRfid: {
                show: true
            },
            filterByNetPayment: {
                show: false
            }
        };
        vm.success = false

        function search(searchParams) {
            uploadParams = searchParams;
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            vm.searchParams.salaryProcessType = "additional"
            payrollManagementService.getEmployeeAdditionalPayComponents(vm.searchParams).then(function (data) {
                // analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)

                // vm.excelUrl = attendanceService.getDetailedMonthlyReportExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getDetailedMonthlyReportPdfUrl(vm.searchParams);
                // vm.verticalPdfUrl = attendanceService.getMonthlyVerticalReportPdfUrl(vm.searchParams);
                vm.allEmployeeData = data.components;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.total;
                vm.fromMonthName = MONTH_NAMES[searchParams.fromMonth-1]
                vm.toMonthName = MONTH_NAMES[searchParams.toMonth-1]
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
                // console.log()
            }, function (error) {
                vm.isDataLoaded = true;
                toastr.error(error);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function checkOrUncheckAll() {
            if(vm.allSelected === false){
                vm.allEmployeeData.forEach(function (allocations) {
                    allocations.isSelected = false;
                });
            }
            else{
                vm.allEmployeeData.forEach(function (allocations) {
                    allocations.isSelected = true;
                });
            }
        }

        function optionToggled() {
            vm.allSelected = vm.allEmployeeData.every(function (itm) {
                return itm.isSelected === true;
            });
        }

        function editComponent(item) {
            var additionalComponent = {
                employeeId : item.employeeId,
                componentId : item.componentId,
                amount : item.amount,
                remarks : item.remarkList[0],
                startMonth : vm.searchParams.fromMonth,
                startYear : vm.searchParams.fromYear,
                endMonth : vm.searchParams.toMonth,
                endYear : vm.searchParams.toYear
            };

            $state.go("payroll.individualAdditionalSalaryComponentUpdate", {additionalComponent : additionalComponent});
        }

        function excelUploadRequest(params){
            return {
                fromMonth: params.fromMonth,
                fromYear: params.fromYear,
                toMonth: params.toMonth,
                toYear: params.toYear,
                componentId: params.componentIds[0],
            }
        }

        function uploadSelectedExcelFile($file) {
            var parameters = excelUploadRequest(uploadParams);
            if(!parameters.componentId)
                return toastrService.showErrorToastr("Please select a component");
            if($file == null) return;
            payrollManagementService.uploadAdditionalComponentExcel($file, parameters).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.uploadExcel, document.title + ' - Upload Excel', '', 'Upload Excel In' + document.title, ANALYTICS_CONSTANT.uploadExcel)
                toastrService.showSuccessToastr("Additional Payroll Component created successfully");
                search(uploadParams);
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr(error, "", 5000);
            });

        }

        function openDeleteModal(employeeId, componentId, searchParam) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/delete/deleteModal.html',
                size: 'md',
                controller: 'DeleteAdditionalPayCompModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    empData: function () {
                        return {
                            employeeId: employeeId,
                            additionalComponentId: componentId,
                            startMonth : searchParam.fromMonth,
                            endMonth : searchParam.toMonth,
                            startYear : searchParam.fromYear,
                            endYear : searchParam.toYear,
                        };
                    }
                }
            }).result.then(function (data) {
                search(uploadParams);
            },function () {

            });
        }

        function goToAddNewPage() {
            // analyticsService.sendData(ANALYTICS_CONSTANT.addNewComponent, document.title + ' - Add New Component For Individual Employee', '', 'Add New Component For Individual Employee In' + document.title, ANALYTICS_CONSTANT.addNewComponent)
            var initialSelection = {
                startMonth : vm.searchParams.fromMonth,
                startYear : vm.searchParams.fromYear,
                endMonth : vm.searchParams.toMonth,
                endYear : vm.searchParams.toYear
            };

            $state.go("payroll.individualAdditionalSalaryComponent", {initialSelection : initialSelection});
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.bankPaymentAdvice')
        .controller('BankPaymentAdviceCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService', 'toastrService', 'payrollSettingsService', 'payrollManagementService', 'MONTH_NAMES', 'bankManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', BankPaymentAdviceCtrl]);

    /** @ngInject */
    function BankPaymentAdviceCtrl($scope, $stateParams, $state, $timeout, authService, employeeService, toastrService, payrollSettingsService, payrollManagementService, MONTH_NAMES, bankManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.selectedMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
        vm.isApproved = false;
        vm.notYetApprovedText = "";
        vm.lastMonthText = "";

        vm.bankAdviceList = [];
        vm.salarySummary = null;
        vm.panelTitle = "Bank Payment Advice for ";
        vm.isSalaryGenerated = false;
        vm.isDataLoaded = false;

        vm.salaryMonthPicker = {};
        vm.salaryMonthPicker.opened = false;
        vm.salaryMonthPicker.format = "MMM yyyy";
        vm.salaryMonthPicker.options = {
            datepickerMode : 'month',
            minDate        : new Date(2019, 12, 1),
            maxDate        : new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode        : 'month',
            maxMode        : 'year'
        };

        vm.openSalaryMonthPicker = openSalaryMonthPicker;
        vm.viewPreviousHistory = viewPreviousHistory;
        vm.downloadAdviceLetter = downloadAdviceLetter;

        function openSalaryMonthPicker() {
            vm.salaryMonthPicker.opened = true;
        }

        function viewPreviousHistory() {
            vm.selectedMonth = new Date(vm.selectedMonth.getFullYear(), vm.selectedMonth.getMonth() - 1, 1);
            getSalarySummary();
        }

        $scope.$watch('vm.salaryMonthPicker.opened',function(newVal, oldVal){
            if(!newVal) getSalarySummary();
        })

        function getSalarySummary() {
            var params = {
                params : {
                    month : vm.selectedMonth.getMonth() + 1,
                    year  : vm.selectedMonth.getFullYear()
                }
            };
            vm.panelTitle = "Bank payment advice for " + MONTH_NAMES[vm.selectedMonth.getMonth()] + " " + vm.selectedMonth.getFullYear();
            vm.isDataLoaded = false;
            vm.notYetApprovedText = "";
            vm.lastMonthText = "";

            payrollManagementService.getSalarySummary(params).then(function (data) {
                vm.salarySummary = data;
                vm.isSalaryGenerated = data.isGenerated;
                if(vm.isSalaryGenerated) {
                    vm.isApproved = vm.salarySummary.status >= 2;
                }
                if(!vm.isApproved) {
                    vm.notYetApprovedText = "Salary for " + MONTH_NAMES[vm.selectedMonth.getMonth()] + " " + vm.selectedMonth.getFullYear() + " is not approved yet."
                    vm.lastMonthText = MONTH_NAMES[vm.selectedMonth.getMonth() - 1] + " " + vm.selectedMonth.getFullYear();
                }else {
                    payrollManagementService.getBankPaymentAdviceSummary(params).then(function (data) {
                        vm.bankAdviceList = data.summary;
                    })
                }

            }, function (error) {
                toastrService.showErrorToastr("Could not get salary summary: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function downloadAdviceLetter(item) {
            analyticsService.sendData(ANALYTICS_CONSTANT.download, document.title + ' - Download Forwarding Letter', '', 'Download Forwarding Lettr In ', ANALYTICS_CONSTANT.download)
            window.open(bankManagementService.getAdviceLetterDownloadUrl(item), '_blank', '');
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.payrollSettings')
        .controller('EditPayrollComponentsCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'COMPONENT_TYPE', 'COMPONENT_CATEGORY', 'COMPONENT_GROUP', 'PARENT_COMPONENT', 'VALUE_TYPE', 'PAYMENT_MODE', 'authService', 'employeeService', 'toastrService','payrollSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', EditPayrollComponentsCtrl]);

    /** @ngInject */
    function EditPayrollComponentsCtrl($scope, $stateParams, $state, $timeout,$uibModal, COMPONENT_TYPE, COMPONENT_CATEGORY, COMPONENT_GROUP, PARENT_COMPONENT, VALUE_TYPE, PAYMENT_MODE, authService, employeeService, toastrService,payrollSettingsService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.componentDistribution = null;
        vm.officePayrollComponent = []
        vm.componentDistributionList = [];
        vm.associatedComponent = {}
        vm.status = false;

        vm.componentType = angular.copy(COMPONENT_TYPE);
        vm.componentCategory = angular.copy(COMPONENT_CATEGORY);
        vm.componentGroup = angular.copy(COMPONENT_GROUP);
        vm.componentGroup = angular.copy(COMPONENT_GROUP);
        vm.parentComponent = angular.copy(PARENT_COMPONENT);
        vm.valueType = angular.copy(VALUE_TYPE);
        vm.paymentMode = angular.copy(PAYMENT_MODE);
        vm.options = [
            {value : true, name : "Yes"},
            {value : false, name : "No"},
        ]

        vm.addNewRow = addNewRow;
        vm.saveComponentSettings = updatePayrollComponent;
        vm.deleteDistributionComponent = deleteDistributionComponent;

        function init(){
            getPayrollComponentData($stateParams.componentId);
            getPayrollSettingsData();
        }
        init();

        vm.componentDistribution = vm.officePayrollComponent.group === 2;

        function getPayrollSettingsData(){
            payrollSettingsService.getPayrollSettingsData().then(function (data){
                vm.payrollComponentName = data.officePayrollComponents;
            });
        }

        function getPayrollComponentData(componentId){
            payrollSettingsService.getPayrollComponentData(componentId).then(function (data){
                populateData(data);
            });
        }

        function populateData(data){
            vm.officePayrollComponent = data.officePayrollComponent;
            vm.componentDistributionList = vm.officePayrollComponent.componentDistributionList;
            vm.associatedComponent = vm.officePayrollComponent.componentDistributionList.associatedComponent;
            vm.componentDistribution = vm.officePayrollComponent.group == 2;
            vm.status = vm.officePayrollComponent.status == 1;
        }

        function updatePayrollComponent(){
            toastrService.clearPreviousToastr();
            var componentList = [];
            var existingList = [];
            var duplicate = false;
            vm.componentDistributionList.forEach(function (c){
                componentList.push({associatedComponentId: c.associatedComponentId, dayCount: c.dayCount});
                if(existingList.includes(c.associatedComponentId)){
                    toastrService.showErrorToastr("Duplicate component cannot exist");
                    duplicate = true;
                }else
                    existingList.push(c.associatedComponentId);
            });

            if(vm.officePayrollComponent.name == null)
                return toastrService.showErrorToastr("Name cannot be empty");
            else if(vm.officePayrollComponent.category == null)
                return toastrService.showErrorToastr("Category cannot be empty");
            else if(vm.officePayrollComponent.type == null)
                return toastrService.showErrorToastr("Type cannot be empty");
            else if(vm.officePayrollComponent.group == null)
                return toastrService.showErrorToastr("Group cannot be empty");
            else if(vm.officePayrollComponent.valueType == 1 && (vm.officePayrollComponent.value > 100 || vm.officePayrollComponent.value < 0))
                return toastrService.showErrorToastr("Calculation Percentage has to be between 0 and 100");
            else if(vm.officePayrollComponent.valueType == 2 && vm.officePayrollComponent.value < 0)
                return toastrService.showErrorToastr("Fixed amount cannot be negative");
            else if(vm.officePayrollComponent.code == null)
                return toastrService.showErrorToastr("Code cannot be empty");
            else if(vm.officePayrollComponent.inclusiveToGross == true && (vm.officePayrollComponent.group != 1 || vm.officePayrollComponent.category != 1))
                return toastrService.showErrorToastr("To consider in gross salary calculation Group has to be Master and Category has to be Additive");
            else if(vm.officePayrollComponent.valueDeterminer == null)
                return toastrService.showErrorToastr("ValueDeterminer cannot be empty");
            else if(vm.officePayrollComponent.isConfirmationBenefit == null)
                return toastrService.showErrorToastr("isConfirmationBenefit cannot be empty");
            else if(vm.officePayrollComponent.paymentMode == null)
                return toastrService.showErrorToastr("paymentMode cannot be empty");
            else if(vm.officePayrollComponent.installment == null)
                return toastrService.showErrorToastr("installment cannot be empty");
            else if(vm.officePayrollComponent.nameEditable == null)
                return toastrService.showErrorToastr("nameEditable cannot be empty");
            else{
                //basic pay

                if (vm.officePayrollComponent.type === 1) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Basic Pay Category must be Additive");
                    if (vm.officePayrollComponent.group !== 1)
                        return toastrService.showErrorToastr("Basic Pay Group must be Master");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Basic Pay Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    if (vm.officePayrollComponent.inclusiveToGross !== true)
                        return toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Basic Pay Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Basic Pay Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.componentDistribution!=false)toastrService.showErrorToastr("Basic Pay has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //allowance
                else if (vm.officePayrollComponent.type === 2) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Allowance Category must be Additive");
                    // if ( vm.officePayrollComponent.group!=1)toastrService.showErrorToastr("Basic Pay Group must be Master");
                    // if(vm.officePayrollComponent.paymentMode!=1)toastrService.showErrorToastr("Basic Pay Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    // if(vm.officePayrollComponent.valueType!=3)toastrService.showErrorToastr("Basic Pay Value Type must be variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Allowance Installment must be 1");
                    // if(vm.officePayrollComponent.valueDeterminer!=0)toastrService.showErrorToastr("Allowance Parent component must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Allowance has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //long term benefit
                else if (vm.officePayrollComponent.type === 3) {
                    if (vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Long Term Benefit Category must be Deductive");
                    // if ( vm.officePayrollComponent.group!=1)toastrService.showErrorToastr("Basic Pay Group must be Master");
                    // if(vm.officePayrollComponent.paymentMode!=1)toastrService.showErrorToastr("Long Term Benefit Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 1)
                        return toastrService.showErrorToastr("Long Term Benefit Value Type must be Percentage");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Long Term Benefit Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer === 0)
                        return toastrService.showErrorToastr("Long Term Benefit Parent Component can not be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Long Term Benefit has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //non cash benefit
                else if (vm.officePayrollComponent.type === 4) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Non Cash Benefit Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Non Cash Benefit Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Non Cash Benefit Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Non Cash Benefit Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== null)
                        return toastrService.showErrorToastr("Non Cash Benefit Installment is not applicable");
                    // if(vm.officePayrollComponent.valueDeterminer!=0)toastrService.showErrorToastr("Basic Pay Value Determiner must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Non Cash Benefit has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //additional
                else if (vm.officePayrollComponent.type === 5) {
                    // if(vm.officePayrollComponent.category!= 1)toastrService.showErrorToastr("Basic Pay Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Additional Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Additional Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Additional Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Additional Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Additional Parent Component must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Additional has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //bonus
                else if (vm.officePayrollComponent.type === 6) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Bonus Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Bonus Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 2)
                        return toastrService.showErrorToastr("Bonus Payment Mode must be Yearly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType === 2)
                        return toastrService.showErrorToastr("Bonus Value Type can not be Fixed");
                    // if(vm.officePayrollComponent.installment=!1) toastrService.showErrorToastr("Basic Pay Installment must be 1");
                    // if(vm.officePayrollComponent.valueDeterminer!=0)toastrService.showErrorToastr("Basic Pay Value Determiner must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Bonus has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //arrears
                else if (vm.officePayrollComponent.type === 7) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Arrears Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Arrears Pay Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Arrears Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Arrears Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Arrears Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Arrears Parent Component must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Basic Pay has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //lwp deduction
                else if (vm.officePayrollComponent.type === 8) {
                    if (vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("LWP Deduction Category must be Deductive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("LWP Deduciton Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("LWP Deduction Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("LWP Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("LWP Deduction Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("LWP Deduction Parent Component must be None");
                    if (componentList.length === 0)
                        return toastrService.showErrorToastr("LWP Deduction must have Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //absent deduction
                else if (vm.officePayrollComponent.type === 9) {
                    if (vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Absent Deduction Category must be Deductive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Absent Deduction Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Absent Deduction Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Absent Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Absent Deduction Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Absent Deduction Parent Component must be be None");
                    if (componentList.length === 0 )
                        return toastrService.showErrorToastr("Absent Deduction must have Distribution");


                    // if(vm.officePayrollComponent.hasDistribution!=true)return toastrService.showErrorToastr("Absent Deduction Must Have Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }

                //Income Tax Deduction
                else if(vm.officePayrollComponent.type === 10){
                    if(vm.officePayrollComponent.category != -1)
                        return toastrService.showErrorToastr("Income Tax Deduction Category must be Deductive");
                    if(vm.officePayrollComponent.group !== 1)
                        return toastrService.showErrorToastr("Income Tax Deduction Group must be Master");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Income Tax Deduction Payment Mode must be Monthly");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Income Tax Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Income Tax Deduction Installment must be 1");
                    if (componentList.length !== 0 )
                        return toastrService.showErrorToastr("Income Tax Deduction has no Distribution");
                    if(vm.officePayrollComponent.inclusiveToGross===true)toastrService.showErrorToastr("Income Tax Deduction can not be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Income Tax Deduction Parent Component must be be None");

                }

                //Loan Deduction
                else if(vm.officePayrollComponent.type === 11){
                    if(vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Loan deduction Category must be Deductive");
                    if(vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Loan deduction Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Loan Deduction Payment Mode must be Monthly");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Loan Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Loan Deduction Installment must be 1");
                    if (componentList.length !== 0 )
                        return toastrService.showErrorToastr("Loan Deduction has no Distribution");
                    if(vm.officePayrollComponent.inclusiveToGross===true)toastrService.showErrorToastr("Loan Deduction can not be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Loan Deduction Parent Component must be be None");

                }
                if(!duplicate){
                    var request = {
                        name: vm.officePayrollComponent.name,
                        category: vm.officePayrollComponent.category,
                        type: vm.officePayrollComponent.type,
                        group: vm.officePayrollComponent.group,
                        valueType: vm.officePayrollComponent.valueType,
                        value: vm.officePayrollComponent.value,
                        code: vm.officePayrollComponent.code,
                        status: vm.status? 1 : 0,
                        inclusiveToGross: vm.officePayrollComponent.inclusiveToGross,
                        valueDeterminer: vm.officePayrollComponent.valueDeterminer,
                        isConfirmationBenefit: vm.officePayrollComponent.isConfirmationBenefit,
                        paymentMode: vm.officePayrollComponent.paymentMode,
                        installment: vm.officePayrollComponent.installment,
                        nameEditable: vm.officePayrollComponent.nameEditable,
                        componentDistributionList: componentList
                    };
                    if(request.value==null) request.value=0.0;
                    // console.log(request)
                    payrollSettingsService.updatePayrollComponentData($stateParams.componentId, request).then(function (data){
                        analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save Settings', '', 'Save Settings In ' + document.title, ANALYTICS_CONSTANT.save)
                        init();
                        toastrService.showSuccessToastr("Saved Successfully");
                        // saveComponentSettings();
                        // populateData(data);
                        $state.go('payroll.payrollSettings');
                    }, function (){
                        toastrService.showErrorToastr("Failed to Save Component Setting", "", 5000);
                    })
                }
            }
        }

        function deleteDistributionComponent (component, index) {
            vm.componentDistributionList.splice(index, 1);
        }

        function addNewRow(){
            var rowToBeAdded = {
                associatedComponentId:null,
                dayCount: null,
                isAddable: true
            };
            vm.componentDistributionList.push(rowToBeAdded);
        }
        function saveComponentSettings(){
            openSuccessModal();
        }
        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/payrollSettings/modals/success.modal.html',
                size: 'md',
                controller : 'SuccessModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'salaryComponentSettings.successMessage';
                    }
                }
            }).result.then(function () {

            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll')
        .controller('SuccessModalCtrl', [ '$uibModalInstance', 'toastrService', 'successMsg', SuccessModalCtrl]);

    /** @ngInject */
    function SuccessModalCtrl($uibModalInstance, toastrService, successMsg) {
        var vm = this;

        vm.successMsg = successMsg;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.payrollSettings')
        .controller('SalaryComponentSettingsCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'COMPONENT_TYPE', 'COMPONENT_CATEGORY', 'COMPONENT_GROUP', 'PARENT_COMPONENT', 'VALUE_TYPE', 'PAYMENT_MODE', 'authService', 'employeeService', 'toastrService', 'payrollSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', SalaryComponentSettingsCtrl]);

    /** @ngInject */
    function SalaryComponentSettingsCtrl($scope, $stateParams, $state, $timeout, $uibModal, COMPONENT_TYPE, COMPONENT_CATEGORY, COMPONENT_GROUP, PARENT_COMPONENT, VALUE_TYPE, PAYMENT_MODE, authService, employeeService, toastrService, payrollSettingsService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.componentDistribution = null;
        vm.officePayrollComponent = []
        vm.componentDistributionList = [];
        vm.associatedComponent = {}
        vm.status = true;

        vm.componentType = angular.copy(COMPONENT_TYPE);
        vm.componentCategory = angular.copy(COMPONENT_CATEGORY);
        vm.componentGroup = angular.copy(COMPONENT_GROUP);
        vm.componentGroup = angular.copy(COMPONENT_GROUP);
        vm.parentComponent = angular.copy(PARENT_COMPONENT);
        vm.valueType = angular.copy(VALUE_TYPE);
        vm.officePayrollSettings = null;

        vm.paymentMode = angular.copy(PAYMENT_MODE);
        vm.options = [
            {value: true, name: "Yes"},
            {value: false, name: "No"},
        ]

        vm.addNewRow = addNewRow;
        vm.saveComponentSettings = updatePayrollComponent;
        vm.deleteDistributionComponent = deleteDistributionComponent;

        function init() {
            getPayrollSettingsData();
        }
        init();

        vm.componentDistribution = vm.officePayrollComponent.group === 2;

        function getPayrollSettingsData() {
            payrollSettingsService.getPayrollSettingsData().then(function (data) {
                // console.log(data);
                vm.payrollComponentName = data.officePayrollComponents;
                vm.officePayrollSettings = data.payrollSettings;
            });
        }

        function updatePayrollComponent() {
            toastrService.clearPreviousToastr();
            var componentList = [];
            var existingList = [];
            var duplicate = false;
            vm.componentDistributionList.forEach(function (c) {
                componentList.push({associatedComponentId: c.associatedComponentId, dayCount: c.dayCount});
                if (existingList.includes(c.associatedComponentId)) {
                    toastrService.showErrorToastr("Duplicate component cannot exist");
                    duplicate = true;
                } else
                    existingList.push(c.associatedComponentId);
            });
            if (vm.officePayrollComponent.name == null)
                return toastrService.showErrorToastr("Name cannot be empty");
            else if (vm.officePayrollComponent.code == null)
                return toastrService.showErrorToastr("Code cannot be empty");
            else if (vm.officePayrollComponent.category == null)
                return toastrService.showErrorToastr("Category cannot be empty");
            else if (vm.officePayrollComponent.type == null)
                return toastrService.showErrorToastr("Type cannot be empty");
            else if (vm.officePayrollComponent.group == null)
                return toastrService.showErrorToastr("Group cannot be empty");
            else if (vm.officePayrollComponent.valueType == 1 && (vm.officePayrollComponent.value > 100 || vm.officePayrollComponent.value < 0))
                return toastrService.showErrorToastr("Calculation Percentage has to be between 0 and 100");
            else if (vm.officePayrollComponent.valueType == 2 && vm.officePayrollComponent.value < 0)
                return toastrService.showErrorToastr("Fixed amount cannot be negative");
            else if (vm.officePayrollComponent.inclusiveToGross == true && (vm.officePayrollComponent.group != 1 || vm.officePayrollComponent.category != 1))
                return toastrService.showErrorToastr("To consider in gross salary calculation Group has to be Master and Category has to be Additive");
            else if (vm.officePayrollComponent.valueDeterminer == null)
                return toastrService.showErrorToastr("ValueDeterminer cannot be empty");
            else if (vm.officePayrollComponent.isConfirmationBenefit == null)
                return toastrService.showErrorToastr("isConfirmationBenefit cannot be empty");
            else if (vm.officePayrollComponent.paymentMode == null)
                return toastrService.showErrorToastr("paymentMode cannot be empty");
                // else if(vm.officePayrollComponent.installment == null)
                //     toastrService.showErrorToastr("installment cannot be empty")

            //basic pay
            else {
                if (vm.officePayrollComponent.type === 1) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Basic Pay Category must be Additive");
                    if (vm.officePayrollComponent.group !== 1)
                        return toastrService.showErrorToastr("Basic Pay Group must be Master");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Basic Pay Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    if (vm.officePayrollComponent.inclusiveToGross !== true)
                        return toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Basic Pay Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Basic Pay Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.componentDistribution!=false)toastrService.showErrorToastr("Basic Pay has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //allowance
                else if (vm.officePayrollComponent.type === 2) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Allowance Category must be Additive");
                    // if ( vm.officePayrollComponent.group!=1)toastrService.showErrorToastr("Basic Pay Group must be Master");
                    // if(vm.officePayrollComponent.paymentMode!=1)toastrService.showErrorToastr("Basic Pay Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    // if(vm.officePayrollComponent.valueType!=3)toastrService.showErrorToastr("Basic Pay Value Type must be variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Allowance Installment must be 1");
                    // if(vm.officePayrollComponent.valueDeterminer!=0)toastrService.showErrorToastr("Allowance Parent component must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Allowance has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //long term benefit
                else if (vm.officePayrollComponent.type === 3) {
                    if (vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Long Term Benefit Category must be Deductive");
                    // if ( vm.officePayrollComponent.group!=1)toastrService.showErrorToastr("Basic Pay Group must be Master");
                    // if(vm.officePayrollComponent.paymentMode!=1)toastrService.showErrorToastr("Long Term Benefit Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 1)
                        return toastrService.showErrorToastr("Long Term Benefit Value Type must be Percentage");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Long Term Benefit Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer === 0)
                        return toastrService.showErrorToastr("Long Term Benefit Parent Component can not be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Long Term Benefit has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //non cash benefit
                else if (vm.officePayrollComponent.type === 4) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Non Cash Benefit Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Non Cash Benefit Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Non Cash Benefit Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Non Cash Benefit Value Type must be Variable");
                    if (vm.officePayrollComponent.installment != null)
                        return toastrService.showErrorToastr("Non Cash Benefit Installment is not applicable");
                    // if(vm.officePayrollComponent.valueDeterminer!=0)toastrService.showErrorToastr("Basic Pay Value Determiner must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Non Cash Benefit has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //additional
                else if (vm.officePayrollComponent.type === 5) {
                    // if(vm.officePayrollComponent.category!= 1)toastrService.showErrorToastr("Basic Pay Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Additional Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Additional Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Additional Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Additional Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Additional Parent Component must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Additional has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //bonus
                else if (vm.officePayrollComponent.type === 6) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Bonus Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Bonus Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 2)
                        return toastrService.showErrorToastr("Bonus Payment Mode must be Yearly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType === 2)
                        return toastrService.showErrorToastr("Bonus Value Type can not be Fixed");
                    // if(vm.officePayrollComponent.installment=!1) toastrService.showErrorToastr("Basic Pay Installment must be 1");
                    // if(vm.officePayrollComponent.valueDeterminer!=0)toastrService.showErrorToastr("Basic Pay Value Determiner must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Bonus has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //arrears
                else if (vm.officePayrollComponent.type === 7) {
                    if (vm.officePayrollComponent.category !== 1)
                        return toastrService.showErrorToastr("Arrears Category must be Additive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Arrears Pay Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Arrears Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Arrears Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Arrears Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Arrears Parent Component must be None");
                    // if(vm.officePayrollComponent.hasDistribution!=false)toastrService.showErrorToastr("Basic Pay has no Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //lwp deduction
                else if (vm.officePayrollComponent.type === 8) {
                    if (vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("LWP Deduction Category must be Deductive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("LWP Deduciton Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("LWP Deduction Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("LWP Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("LWP Deduction Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("LWP Deduction Parent Component must be None");
                    if (componentList.length === 0)
                        return toastrService.showErrorToastr("LWP Deduction must have Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }
                //absent deduction
                else if (vm.officePayrollComponent.type === 9) {
                    if (vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Absent Deduction Category must be Deductive");
                    if (vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Absent Deduction Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Absent Deduction Payment Mode must be Monthly");
                    // if (vm.officePayrollComponent.parentComponent!=0) toastrService.showErrorToastr("Basic Pay Parent Component must be None");
                    // if(vm.officePayrollComponent.inclusiveToGross!=true)toastrService.showErrorToastr("Basic Pay must be Inclusive To Gross");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Absent Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Absent Deduction Installment must be 1");
                    if (vm.officePayrollComponent.valueDeterminer !== 0)
                        return toastrService.showErrorToastr("Absent Deduction Parent Component must be be None");
                    if (componentList.length === 0 )
                        return toastrService.showErrorToastr("Absent Deduction must have Distribution");

                    // if(vm.officePayrollComponent.hasDistribution!=true)return toastrService.showErrorToastr("Absent Deduction Must Have Distribution");
                    // if(vm.officePayrollComponent.nameEditable!=false)toastrService.showErrorToastr("Basic Pay Name is not editable");
                }

                //Income Tax Deduction
                else if(vm.officePayrollComponent.type === 10){
                    if(vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Income Tax Category must be Deductive");
                    if(vm.officePayrollComponent.group !== 1)
                        return toastrService.showErrorToastr("Income Tax Group must be Master");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Income Tax Payment Mode must be Monthly");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Income Tax Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Income Tax Installment must be 1");
                    if (componentList.length !== 0 )
                        return toastrService.showErrorToastr("Income Tax has no Distribution");
                    if(vm.officePayrollComponent.inclusiveToGross===true)toastrService.showErrorToastr("Income Tax can not be Inclusive To Gross");

                }

                //Loan Deduction
                else if(vm.officePayrollComponent.type === 11){
                    if(vm.officePayrollComponent.category !== -1)
                        return toastrService.showErrorToastr("Loan deduction Category must be Deductive");
                    if(vm.officePayrollComponent.group !== 2)
                        return toastrService.showErrorToastr("Loan deduction Group must be Additional");
                    if (vm.officePayrollComponent.paymentMode !== 1)
                        return toastrService.showErrorToastr("Loan Deduction Payment Mode must be Monthly");
                    if (vm.officePayrollComponent.valueType !== 3)
                        return toastrService.showErrorToastr("Loan Deduction Value Type must be Variable");
                    if (vm.officePayrollComponent.installment !== 1)
                        return toastrService.showErrorToastr("Loan Deduction Installment must be 1");
                    if (componentList.length !== 0 )
                        return toastrService.showErrorToastr("Loan Deduction has no Distribution");
                    if(vm.officePayrollComponent.inclusiveToGross===true)toastrService.showErrorToastr("Loan Deduction can not be Inclusive To Gross");

                }
                if (!duplicate) {
                    var request = {
                        // payrollSettingsId: Number($stateParams.settingsId),
                        payrollSettingsId:vm.officePayrollSettings.id,
                        name: vm.officePayrollComponent.name,
                        category: vm.officePayrollComponent.category,
                        type: vm.officePayrollComponent.type,
                        group: vm.officePayrollComponent.group,
                        valueType: vm.officePayrollComponent.valueType,
                        value:vm.officePayrollComponent.value,
                        // value:(vm.officePayrollComponent.value==null) ? 1:vm.officePayrollComponent.value,
                        code: vm.officePayrollComponent.code,
                        status: vm.status ? 1 : 0,
                        inclusiveToGross: vm.officePayrollComponent.inclusiveToGross,
                        valueDeterminer: vm.officePayrollComponent.valueDeterminer,
                        isConfirmationBenefit: vm.officePayrollComponent.isConfirmationBenefit,
                        paymentMode: vm.officePayrollComponent.paymentMode,
                        installment: vm.officePayrollComponent.installment,
                        nameEditable: true,
                        componentDistributionList: componentList,
                    };
                    // console.log(request);
                    if (request.value==null) request.value=0.0;
                    payrollSettingsService.createPayrollComponentData(request).then(function (data) {
                        analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save Settings', '', 'Save Settings In' + document.title, ANALYTICS_CONSTANT.save)
                        init();
                        toastrService.showSuccessToastr("Created New Component Successfully");
                        $state.go('payroll.payrollSettings');
                    }, function () {
                        toastrService.showErrorToastr("Failed to create new component", '', 5000);
                    })
                }
            }
        }

        function deleteDistributionComponent(component, index) {
            vm.componentDistributionList.splice(index, 1);
        }

        function addNewRow() {
            var rowToBeAdded = {
                associatedComponentId: null,
                dayCount: null,
                isAddable: true
            };
            vm.componentDistributionList.push(rowToBeAdded);
        }

        function saveComponentSettings() {
            openSuccessModal();
        }

        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/payrollSettings/modals/success.modal.html',
                size: 'md',
                controller: 'SuccessModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'salaryComponentSettings.successMessage';
                    }
                }
            }).result.then(function () {

            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundMember')
        .controller('ProvidentFundMemberCtrl', ['$q','$scope','$uibModal','utilService', 'employeeService', 'toastrService', 'providentFundService', 'analyticsService', 'ANALYTICS_CONSTANT', ProvidentFundMemberCtrl]);

    /** @ngInject */
    function ProvidentFundMemberCtrl($q, $scope, $uibModal, utilService, employeeService, toastrService, providentFundService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.selectedTab = "active";
        vm.isDataLoaded = false;
        vm.isAnyRowSelected = false;

        vm.rowsPerPage = 10;
        utilService.setRowsPerPage(vm.rowsPerPage)
        vm.searchParams = {};
        vm.searchParams.perPage = 10;
        vm.selectedPage = 0;
        vm.searchKeyword = '';

        vm.switchTab = switchTab;
        vm.searchByNameId = searchByNameId;
        vm.showMemberInfoInTheRightColumn = showMemberInfoInTheRightColumn;
        vm.openAddPFMemberModal = openAddPFMemberModal;
        vm.exportAsExcel = exportAsExcel;
        vm.getPFMembers = getPFMembers;

        function switchTab(tabName){
            vm.selectedTab = tabName;
            vm.isAnyRowSelected = false;
            init();
        }

        function init(){
            vm.searchParams.pageNumber = 0;
            vm.searchParams.perPage  = utilService.getRowsPerPage();
            getPFMembers();
        }
        init();

        function searchByNameId(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            getPFMembers();
        }

        function getPFMembers(searchParams) {
            resetRowSelection();
            vm.isDataLoaded = false;
            vm.searchParams.status = getStatus();
            vm.searchParams.searchKey = vm.searchKeyword;
            modifyParams(searchParams)
            providentFundService.getPFMemberList(vm.searchParams).then(function (data) {
                vm.allPFMembers = data.memberList;
                vm.excelUrl = providentFundService.getPFMemberExcel(vm.searchParams);
                vm.total = data.total;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function getStatus() {
            if (vm.selectedTab == 'active') {
                return 1;
            } else if (vm.selectedTab == 'pending') {
                return 2;
            } else
                return 0;
        }

        function showMemberInfoInTheRightColumn(index, memberInfo){
            vm.selectedRowIndex = index;
            vm.isAnyRowSelected = true;
            vm.member = memberInfo;

        }

        function openAddPFMemberModal(member){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/payroll/providentFund/providentFundMember/modal/addPFMember.modal.html',
                size        : 'md',
                controller  : 'AddPFMemberModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    memberInfo:function () {
                        return member;
                    }
                }
            }).result.then(function (){
                vm.selectedTab = "active";
                init();
            });
        }

        function resetRowSelection(){
            vm.isAnyRowSelected = false;
            vm.selectedRowIndex = null;
        }

        function exportAsExcel(){
            if(vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel)
            }
        }



    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundStatement')
        .controller('ProvidentFundStatementCtrl', ['$q','$scope','utilService', 'authService', 'toastrService', 'providentFundService', 'analyticsService', 'ANALYTICS_CONSTANT', ProvidentFundStatementCtrl]);

    /** @ngInject */
    function ProvidentFundStatementCtrl($q,$scope,utilService, authService, toastrService, providentFundService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();


        vm.isDataLoaded = true;
        vm.employeeId = null;
        vm.pdfUrl = '';
        vm.searchParams = {};
        vm.rowsPerPage = 12;

        utilService.setRowsPerPage(vm.rowsPerPage);
        vm.searchParams.pageNumber = 0;
        vm.searchParams.perPage  = utilService.getRowsPerPage();

        vm.selectedMonthTo = new Date();
        vm.employeeId = loggedInUser.id;
        vm.monthPickerFrom = {};
        vm.monthPickerFrom.opened = false;
        vm.monthPickerFrom.format = "MMM yyyy";
        vm.monthPickerFrom.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            maxDate: vm.selectedMonthTo,
            minMode: 'month',
            maxMode: 'year'
        };
        vm.monthPickerTo = {};
        vm.monthPickerTo.opened = false;
        vm.monthPickerTo.format = "MMM yyyy";
        vm.monthPickerTo.options = {
            datepickerMode: 'month',
            minDate: new Date(2019, 12, 1),
            minMode: 'month',
            maxMode: 'year'
        };


        vm.exportAsPdf = exportAsPdf;
        vm.openMonthPickerFrom = openMonthPickerFrom;
        vm.openMonthPickerTo = openMonthPickerTo;
        vm.searchByEmployee = searchByEmployee;
        vm.getPFStatement = getPFStatement;
        vm.getTotalContribution = getTotalContribution;

        function init(){
            providentFundService.getAccountingYear().then(function (data) {
                vm.accountingYear = data;
                vm.selectedMonthFrom = new Date(vm.accountingYear.startDate);
                getPFStatement();
            }, function (error) {
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });
        }
        init();

        function getPFStatement(searchParams){
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            vm.searchParams.from = vm.selectedMonthFrom.getTime();
            vm.searchParams.to = vm.selectedMonthTo.getTime();
            providentFundService.getPFStatementOfAnEmployee(vm.employeeId, vm.searchParams).then(function (data) {
                vm.pfStatement = data;
                vm.pfStatementOfEmployee = data.memberInfo.employeeInfo;
                vm.pdfUrl = providentFundService.getStatementPdf(vm.searchParams, vm.employeeId);
                vm.total = data.totalElement;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });

        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function searchByEmployee(employee){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            vm.employeeId = employee.id;
            getPFStatement()
        }

        function exportAsPdf() {
            if(vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
                window.open(vm.pdfUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf)
            }
        }

        function openMonthPickerFrom() {
            vm.monthPickerFrom.opened = true;
        }

        function openMonthPickerTo() {
            vm.monthPickerTo.opened = true;
        }

        function getTotalContribution(data){
            var total = 0;
           return  total = data.memberContribution + data.memberInterest + data.companyContribution + data.companyInterest;
        }

        $scope.$watch('vm.monthPickerFrom.opened', function (newVal, oldVal) {
            if (!newVal && oldVal) {
                getPFStatement();
            }
        });
        $scope.$watch('vm.monthPickerTo.opened', function (newVal, oldVal) {
            if (!newVal && oldVal) {
                vm.selectedMonthFrom = new Date(vm.selectedMonthTo.getFullYear()-1, vm.selectedMonthTo.getMonth(), vm.selectedMonthTo.getDate());
                vm.monthPickerFrom.options.maxDate = vm.selectedMonthTo;
                getPFStatement();
            }
        })

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundAccountManagement')
        .controller('ProvidentFundAccountManagementCtrl', ['$q','$uibModal','authService', 'employeeService', 'toastrService', 'providentFundService', ProvidentFundAccountManagementCtrl]);

    /** @ngInject */
    function ProvidentFundAccountManagementCtrl($q,$uibModal,authService, employeeService, toastrService, providentFundService) {
        var vm = this;
        vm.isDataLoaded = false;

        function init(){
            providentFundService.getAccountingYear().then(function (data) {
                vm.accountingYear = data;
            }, function (error) {
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });
            getPFAccountManagementSummaryData();
        }
        init();

        function getPFAccountManagementSummaryData(){
            vm.isDataLoaded = false;
            providentFundService.getPFAccountManagementSummary().then(function (data){
                vm.pfAccountSummmaryData = data.accounts;
                vm.isDataLoaded = true;
            }, function (error){
                toastrService.showErrorToastr('Error: '+ error, '', 5000);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryManagement')
        .controller('BatchUploadConfirmationCtrl', ['$scope', '$state', '$stateParams', 'employeeService', 'payrollSettingsService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', BatchUploadConfirmationCtrl]);

    /** @ngInject */
    function BatchUploadConfirmationCtrl($scope, $state, $stateParams, employeeService, payrollSettingsService, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isVerificationDone = false;

        vm.uploadFile = uploadFile;
        vm.getTooltipText = getTooltipText;

        validate();


        function validate() {
            if(!$stateParams.file) {
                $state.go('payroll.salaryManagement');
                return;
            }
            init();
        }

        function init() {
            vm.file = $stateParams.file;
            vm.payrollType = $stateParams.payrollType;
            vm.existingEmployees = null;
            vm.newEmployees = null;
            vm.hasError = false;
            verifySelectedExcelFile();
        }

        function uploadFile() {
            toastrService.clearPreviousToastr();
            if(vm.file == null) {
                return toastrService.showErrorToastr("You haven't selected any file.");
            }

            if(vm.hasError) {
                return toastrService.showErrorToastr("The provided excel file needs correction.");
            }
            vm.isVerificationDone = false;

            employeeService.uploadEmployeePayrollSetupExcel(vm.file).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.upload, document.title + ' - Upload', '', 'Upload In ' + document.title, ANALYTICS_CONSTANT.upload)
                toastrService.showSuccessToastr("File upload successful");
                $state.go('payroll.salaryManagement');
            }, function (errorMessage) {
                vm.isVerificationDone = true;
                toastrService.showErrorToastr("Could not perform batch create/update request : " + errorMessage, "", 5000);
            });
        }

        function verifySelectedExcelFile() {
            employeeService.verifyEmployeePayrollSetupExcel(vm.file).then(function (data) {
                vm.existingEmployees =data.existingEmployees;
                vm.newEmployees = data.newEmployees;
                vm.hasError = data.hasError;
                vm.isVerificationDone = true;
                toastrService.showSuccessToastr("Verification completed for the provided excel file");
            }, function (errorMessage) {
                toastrService.showErrorToastr("Could not verify the provided file: " + errorMessage, "", 5000);
                $state.go('payroll.salaryManagement');
            });

        }

        function getTooltipText(errorMessages) {
            var errors = "";
            errorMessages.forEach(function (errorMessage){
                if(errors.length === 0) errors += errorMessage;
                else errors += ", " + errorMessage;
            });
            errors += ".";
            return errors;
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DetailedAttendanceLogCtrl', ['authService', '$scope', '$stateParams', '$uibModal', 'attendanceService', 'employeeService', 'toastrService','utilService', 'analyticsService', 'ANALYTICS_CONSTANT', 'REPORT_SETTINGS', 'GP_CLIENT_OFFICE_IDS', DetailedAttendanceLogCtrl]);

    /** @ngInject */
    function DetailedAttendanceLogCtrl(authService, $scope, $stateParams, $uibModal, attendanceService, employeeService, toastrService,utilService, analyticsService, ANALYTICS_CONSTANT, REPORT_SETTINGS, GP_CLIENT_OFFICE_IDS) {

        var vm = this;

        var loggedInUser = authService.getLoggedInUser();
        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.bothTypeAttendance = {};
        vm.employeeName = null;
        vm.excelUrl = null;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.isManualEntryEnabled = authService.isAdmin();
        vm.enableDeletePunch = (authService.isAdmin() || authService.isLineManager());
        vm.datePicker = {};
        vm.datePicker.startDate = vm.isGpClient ? moment().startOf('day') : moment().subtract(1,'days').startOf('day');
        vm.datePicker.endDate = moment().endOf('day');
        vm.datePicker.options =  {
            minDate: vm.isGpClient ? new moment() : new Date(utilService.getMinimumDate()),
            maxDate: new moment(),
            applyClass: 'btn-success',
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                format: 'DD-MMM-YYYY', //will give you 6-Jan-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
            },
            ranges: utilService.getDatePickerRanges()
        };
        vm.isDataLoaded = false;
        vm.exportAsExcel=exportAsExcel;
        vm.openManualEntryModal = openManualEntryModal;
        vm.reduceSelectedPaginationPage = reduceSelectedPaginationPage;
        vm.increaseSelectedPaginationPage = increaseSelectedPaginationPage;
        vm.getPunchType = getPunchType;
        vm.isManualEntry = isManualEntry;
        vm.getApprovalStatus = getApprovalStatus;
        vm.getEntryType = getEntryType;
        vm.getHoursMin = getHoursMin;
        vm.getBothTypeAttendanceLog = getBothTypeAttendanceLog;
        vm.openDeletePunchModal = openDeletePunchModal;
        vm.getPageOfAttendanceLog = getPageOfAttendanceLog;

        var employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();

        function init(){
            getBothTypeAttendanceLog(0);
        }


        $scope.$on("attendance-tab-select", init);

        $scope.$on("profile-info-loaded", function (event, userData) {
            vm.employeeName = userData.name;
        });

        function openManualEntryModal () {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/attendance/detailsAttendanceLog/manualEntry/manualEntry.modal.html',
                controller : 'ManualEntryModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve : {
                    userId : function () {
                        return employeeId;
                    }
                }
            }).result.then(function () {
                getBothTypeAttendanceLog();
            }, function () {
                console.log("Profile picture upload modal dismissed.");
            });
        }

        function getParams(pageNumber){
            vm.selectedPage = pageNumber;
            return {
                employeeId : employeeId,
                page       : vm.selectedPage,
                count      : 50,
                start      : dayjs(vm.datePicker.startDate).startOf('day'),
                end        : dayjs(vm.datePicker.endDate).endOf('day'),
            }
        }

        function getBothTypeAttendanceLog (pageNumber) {
            toastrService.clearPreviousToastr();
            var params = getParams(pageNumber);
            if(params.end.diff(params.start,'days') > 31){
                return toastrService.showErrorToastr('Start and End date difference can not be more than 30 days');
            }
            vm.isDataLoaded = false;
            attendanceService.getDetailedBothTypeAttendanceLog(Object.assign({},params)).then(function (data) {
                vm.excelUrl = attendanceService.getDetailedBothTypeAttendanceLogExcelReportUrl(params);
                vm.bothTypeAttendance = data.attendances;
                vm.numberOfButtons = Array(data.totalPages).fill(1);
                vm.isDataLoaded = true;
                $scope.$broadcast("refreshFixedColumns");
            }, function (message) {
                vm.isDataLoaded = true;
                // toastrService.showErrorToastr("Failed to fetch detailed attendance log. " + message, "", 5000);
                console.error("Failed to fetch detailed attendance log. " + message);
            });
        }

        function reduceSelectedPaginationPage() {
            vm.selectedPage = vm.selectedPage === 0 ? 0 : vm.selectedPage - 1;
            getBothTypeAttendanceLog(vm.selectedPage);
        }

        function increaseSelectedPaginationPage() {
            vm.selectedPage = vm.selectedPage === vm.numberOfButtons.length - 1 ? vm.selectedPage : vm.selectedPage +1;
            getBothTypeAttendanceLog(vm.selectedPage);
        }

        function getPageOfAttendanceLog(pageIndex) {
            if(vm.selectedPage === pageIndex) return;
            vm.selectedPage = pageIndex;
            getBothTypeAttendanceLog(vm.selectedPage);
        }

        function getPunchType(punchType) {
            if(punchType == 1) return "Fingerprint";
            if(punchType == 2) return "RFID Card";
            if(punchType == 3) return "Manual Entry";
            if(punchType == 4) return "Manual Entry";
            if(punchType == 6) return "Mobile Punch";
            if(punchType == 7) return "Face";
        }

        function isManualEntry(punchType){
            return punchType == 3 || punchType == 4 || punchType == 5;
        }

        function getApprovalStatus(approvalStatus){
            if(approvalStatus == 1) return "Pending";
            if(approvalStatus == 2) return "Approved";
            if(approvalStatus == 3) return "Rejected";
        }

        function getEntryType(entryType){
            if(entryType == 1) return "In";
            if(entryType == 2) return "Out";
            if(entryType == 3) return "Generic";
            if(entryType == 4) return "Access";
        }

        function getHoursMin(attTime){
           return dayjs(attTime).format('hh:mm A');
        }

        function openDeletePunchModal(attendanceLogEntry, dateIndex, entryIndex) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/attendance/detailsAttendanceLog/deletePunch/deletePunch.modal.html',
                size: 'md',
                backdrop : 'static',
            }).result.then(function () {
                deleteAttendanceLogEntry(attendanceLogEntry, dateIndex, entryIndex);
            });
        }

        function deleteAttendanceLogEntry(attendanceLogEntry, dateIndex, entryIndex) {
            toastrService.clearPreviousToastr();
            vm.isDataLoaded = false;
            attendanceService.deleteAttendanceLogEntry(attendanceLogEntry.employeeId, attendanceLogEntry.id)
                .then(function (data) {
                    vm.bothTypeAttendance[dateIndex].entries[entryIndex] = data.entry;
                    vm.isDataLoaded = true;
                    toastrService.showSuccessToastr("Attendance log entry deleted");
                }, function (error) {
                    vm.isDataLoaded = true;
                    toastrService.showErrorToastr("could not delete attendance log entry " + error, "", 5000);
                });
        }

        function analyticsDownloadAll(){
            analyticsService.sendData(ANALYTICS_CONSTANT.attendanceReport, document.title + ' - Attendance Report - Detailed Log - Download All', 'detailed-log/download-all', 'Download Detailed Log Of Attendance Report  In' + document.title, ANALYTICS_CONSTANT.download);
        }

        function exportAsExcel() {
            if(isDownloadMonthLimitExceeded()) {
                return openDownloadWarningModal();
            }
            window.open(vm.excelUrl, '_blank', '');
            analyticsDownloadAll();
        }

        function isDownloadMonthLimitExceeded() {
            // var minDate = moment().subtract(REPORT_SETTINGS.downloadMonthLimit, 'month').startOf('month');
            // return minDate.diff(vm.datePicker.startDate) > 0;
            return vm.datePicker.endDate.diff(vm.datePicker.startDate, 'months', true) > REPORT_SETTINGS.downloadMonthLimit;
        }

        function openDownloadWarningModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/reportDownloadWarningModal/reportDownloadWarning.modal.html',
                size         : 'md',
                controller   : 'ReportDownloadWarningModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
            }).result.then(function () {});
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileAttendanceChartCtrl', ['authService', '$scope', '$stateParams', 'attendanceService', 'baConfig', 'layoutPaths', 'toastrService','utilService', 'GP_CLIENT_OFFICE_IDS', ProfileAttendanceChartCtrl]);

    /** @ngInject */
    function ProfileAttendanceChartCtrl(authService, $scope, $stateParams, attendanceService, baConfig, layoutPaths, toastrService,utilService, GP_CLIENT_OFFICE_IDS) {
        var vm = this;
        vm.isDataReady = false;
        vm.user = null;
        var loggedInUser = authService.getLoggedInUser();
        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.attendancedatePicker = {};
        vm.attendancedatePicker.date = getInitialFromAndToDate();
        vm.attendancedatePicker.options = getDatePickerOptions();
        vm.searchAttendance = searchAttendance;
        vm.employeeName = null;
        var chart = null;
        var employeeId = null;


        function init () {
            employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
            employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
            searchAttendance();
        }

        $scope.$on("attendance-tab-select", init);

        function searchAttendance () {
            attendanceService.getAttendanceByEmployee(vm.attendancedatePicker.date.startDate.valueOf(), vm.attendancedatePicker.date.endDate.valueOf(), employeeId)
                .then(function (response) {
                    vm.employeeName = response.name;
                    for(var i = 0; i < response.attendanceSummary.length; i++){
                        response.attendanceSummary[i].date = dayjs(response.attendanceSummary[i].date, 'DD.MM.YYYY').format("DD MMM");
                    }
                    chart = AmCharts.makeChart("zoomAxisChart", getChartOptions(response.attendanceSummary), 100);
                    chart.dataProvider = response.attendanceSummary;
                    chart.validateData(response.attendanceSummary, false);
                    if (response.attendanceSummary && response.attendanceSummary.length) vm.isDataReady = true;
                }, function (message) {
                    console.error("failed to fetch attendance data for employee : " + employeeId + ", message : " + message);
                    toastrService.showErrorToastr("Failed to fetch attendance chart for employee : " + employeeId + ", message : " + message, "", 5000);
                });
        }

        $scope.openCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            $scope.modal.calendar.isOpen = true;
        };

        function getChartOptions (data) {
            var layoutColors = baConfig.colors;
            return {
                "type": "serial",
                "fontFamily":"'Open Sans', sans-serif",
                "theme": "none",
                "color": layoutColors.defaultText,
                "dataDateFormat": "DD MMM",
                "precision": 2,
                "valueAxes": [{
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v1",
                    "title": "Hours Worked",
                    "position": "left",
                    "autoGridCount": true,
                    "minimum": 0,
                    "labelFunction": function (value) {
                        return "" + Math.round(value) + "";
                    }
                }],
                "graphs": [
                    {
                        "id": "g3",
                        color: layoutColors.defaultText,
                        "valueAxis": "v1",
                        "lineColor": layoutColors.primaryLight,
                        "fillColors": layoutColors.primaryLight,
                        "fillAlphas": 0.8,
                        "lineAlpha": 0.8,
                        "type": "column",
                        "title": "Expected Hours",
                        "valueField": "expectedHours",
                        "clustered": false,
                        "columnWidth": 0.5,
                        "lineColorField": layoutColors.defaultText,
                        "legendValueText": "[[value]]",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    {
                        "id": "g4",
                        "valueAxis": "v1",
                        color: layoutColors.defaultText,
                        "lineColor": layoutColors.primary,
                        "fillColors": layoutColors.primary,
                        "fillAlphas": 0.9,
                        "lineAlpha": 0.9,
                        "type": "column",
                        "title": "Hours Worked",
                        "valueField": "hoursWorked",
                        "clustered": false,
                        "columnWidth": 0.3,
                        "legendValueText": "[[value]]M",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    { //Red Curve
                        "id": "g1",
                        "valueAxis": "v1",
                        "bullet": "round",
                        "bulletBorderAlpha": 1,
                        "bulletColor": layoutColors.defaultText,
                        color: layoutColors.defaultText,
                        "bulletSize": 5,
                        "hideBulletsCount": 50,
                        "lineThickness": 2,
                        "lineColor": layoutColors.danger,
                        "type": "smoothedLine",
                        "title": "Hours Worked",
                        "useLineColorForBulletBorder": true,
                        "valueField": "hoursWorked"
                        // "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    }
                ],
                "chartScrollbar": {
                    "graph": "g1",
                    "oppositeAxis": false,
                    "offset": 30,
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    scrollbarHeight: 50,
                    backgroundAlpha: 0,
                    selectedBackgroundAlpha: 0.05,
                    selectedBackgroundColor: layoutColors.defaultText,
                    graphFillAlpha: 0,
                    autoGridCount: true,
                    selectedGraphFillAlpha: 0,
                    graphLineAlpha: 0.2,
                    selectedGraphLineColor: layoutColors.defaultText,
                    selectedGraphLineAlpha: 1
                },
                "chartCursor": {
                    "pan": true,
                    "cursorColor": layoutColors.danger,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 0,
                    "valueLineAlpha": 0.2
                },
                "categoryField": "date",
                "categoryAxis": {
                    "axisColor": layoutColors.defaultText,
                    "color": layoutColors.defaultText,
                    "gridColor": layoutColors.defaultText,
                    "parseDates": false,
                    "dashLength": 1,
                    "minorGridEnabled": true,
                },
                "legend": {
                    "useGraphSettings": true,
                    "position": "top",
                    "color": layoutColors.defaultText
                },
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "export": {
                    "enabled": true
                },
                "dataProvider": data,
                pathToImages: layoutPaths.images.amChart

            };
        }

        function getDatePickerOptions() {
            return {
                minDate : vm.isGpClient ? new moment() : angular.copy(vm.minDate),
                maxDate : new moment(),
                applyClass: 'btn-success',
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "DD-MMM-YYYY", //will give you 6-Jan-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: utilService.getDatePickerRanges()
            };
        }

        function getInitialFromAndToDate () {
            return {
                'startDate': vm.isGpClient ? new moment() : moment().subtract('days',15),
                'endDate': moment()
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('FieldVisitProfileCtrl', ['authService', '$scope', '$stateParams', 'attendanceService', 'employeeService', 'baConfig', 'layoutPaths', 'toastrService','utilService','API', 'GP_CLIENT_OFFICE_IDS', FieldVisitProfileCtrl]);

    /** @ngInject */
    function FieldVisitProfileCtrl(authService, $scope, $stateParams, attendanceService, employeeService, baConfig, layoutPaths, toastrService,utilService,API, GP_CLIENT_OFFICE_IDS) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.isDataReady = false;
        vm.user = null;
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.attendancedatePicker = {};
        vm.attendancedatePicker.date = getInitialFromAndToDate();
        vm.attendancedatePicker.options = getDatePickerOptions();
        vm.searchAttendance = searchAttendance;
        vm.employeeName = null;
        vm.type = 3;
        vm.manualEntryData = [];
        vm.currentPage = 0;
        vm.totalPages = 0;
        vm.total = 0;
        vm.numberOfButtons = 0;
        utilService.setRowsPerPage(10);
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.params = {};
        var employeeId = null;

        function init () {
            employeeId = $stateParams.employeeId ? $stateParams.employeeId : authService.getLoggedInId();
            vm.params = {
                employeeId : employeeId,
                from       : vm.attendancedatePicker.date.startDate.valueOf(),
                to         : vm.attendancedatePicker.date.endDate.valueOf(),
                type       : 3,
                page       : vm.currentPage
            };
            vm.excelUrl = attendanceService.getManualEntryReportExcelUrl(vm.params);
            searchAttendance();
        }

        $scope.$on("attendance-tab-select", init);

        $scope.$on("profile-info-loaded", function (event, userData) {
            vm.employeeName = userData.name;
        });


        function searchAttendance (searchParams) {
            vm.isDataReady = false;
            vm.params.from = vm.attendancedatePicker.date.startDate.valueOf();
            vm.params.to = vm.attendancedatePicker.date.endDate.valueOf();
            modifyParams(searchParams);
            attendanceService.getManualEntryReport(vm.params)
                .then(function (response) {
                    vm.manualEntryData = response.manualEntries;
                    vm.currentPage = response.page;
                    vm.total = response.total;
                    vm.totalPages = response.totalPages;
                    vm.numberOfButtons = Array(response.totalPages).fill(1);
                    vm.excelUrl = attendanceService.getManualEntryReportExcelUrl(vm.params);
                }, function (message) {
                    toastrService.showErrorToastr("Failed to fetch attendance chart for employee : " + employeeId + ", message : " + message, "", 5000);
                }).finally(function () {
                    vm.isDataReady = true;
            });
        }

        function modifyParams(searchParams) {
            if(searchParams == null) return;
            if(searchParams == 'prev'){
                vm.params.page--;
            }else if(searchParams == 'next') {
                vm.params.page++;
            }else if(!isNaN(searchParams)){
                vm.params.page = searchParams;
            }
        }

        $scope.openCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            $scope.modal.calendar.isOpen = true;
        };

        function getDatePickerOptions() {
            return {
                applyClass: 'btn-success',
                minDate: vm.isGpClient ? new moment() : angular.copy(vm.minDate),
                maxDate: new moment(),
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "DD-MMM-YYYY", //will give you 6-Jan-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: utilService.getDatePickerRanges()
            };
        }

        function getInitialFromAndToDate () {
            return {
                'startDate': vm.isGpClient ? moment().startOf('day') : moment().startOf('day').subtract(4,'days'),
                'endDate': moment().endOf('day')
            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ManualEntryListCtrl', ['$scope', 'employeeService', '$stateParams', ManualEntryListCtrl]);

    /** @ngInject */
    function ManualEntryListCtrl($scope,employeeService,$stateParams) {

        var vm = this;
        vm.isDataLoaded = false;
        vm.manualEntryList = [];

        function init() {
            employeeService.getManualEntries($stateParams.employeeId).then(function (data) {
                vm.manualEntryList = data;

                $scope.$broadcast("refreshFixedColumns");
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        $scope.$on("attendance-tab-select", init);
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.departments')
        .controller('DeleteEnrolmentModalCtrl', ['$uibModalInstance','enrolmentService','enrolments','employeeId','toastr', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteEnrolmentModalCtrl]);

    /** @ngInject */
    function DeleteEnrolmentModalCtrl($uibModalInstance,enrolmentService, enrolments,employeeId,toastr, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Delete Enrolment Modal';
        var analyticsDeleteUrl = 'delete-enrolment';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsDeleteTitle,analyticsDeleteUrl,'Delete Enrolment In '+document.title, ANALYTICS_CONSTANT.open)
        vm.enrolmentsToDelete = null;
        vm.deleteEnrolments = deleteEnrolments;

        function init() {
            vm.enrolmentsToDelete = enrolments;
        }

        init();

        function deleteEnrolments() {
           var data = {
                "fingerprints":[{
                    hand:enrolments.hand,
                    finger:enrolments.finger
                }]
            };


           enrolmentService.deleteEnrolments(employeeId,data).then(function () {
               analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsDeleteTitle+ ' - Delete', analyticsDeleteUrl+'/delete','Delete enrolment In'+document.title, ANALYTICS_CONSTANT.delete)
               toastr.success("Delete Successful");
               $uibModalInstance.close();
           },function () {
               toastr.error("Could not delete");
           });

        }


    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileAttendanceTableCtrl', ['$scope','authService','attendanceService','$stateParams','_','toastrService','utilService','$location','$anchorScroll','$timeout', 'analyticsService', 'ANALYTICS_CONSTANT', 'REPORT_SETTINGS', '$uibModal', 'GP_CLIENT_OFFICE_IDS', ProfileAttendanceTableCtrl]);

    /** @ngInject */
    function ProfileAttendanceTableCtrl($scope,authService,attendanceService,$stateParams,_,toastrService,utilService, $location, $anchorScroll, $timeout, analyticsService, ANALYTICS_CONSTANT, REPORT_SETTINGS, $uibModal, GP_CLIENT_OFFICE_IDS) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isGpClient = GP_CLIENT_OFFICE_IDS.includes(loggedInUser.officeId);
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.allAttendanceData = null;
        vm.attendancedatePicker = {};
        vm.attendancedatePicker.date = getInitialFromAndToDate();
        vm.attendances = null;
        vm.dateList = null;
        vm.startOfDayList = [];
        vm.numberOfButtons = null;
        vm.excelUrl = null;
        vm.lateAttendanceHistoryList = [];


        vm.exportAsExcel = exportAsExcel;
        vm.getAttendanceTableData = getAttendanceTableData;
        vm.showChunks = showChunks;
        vm.getLateHistoryTableData = getLateHistoryTableData;


        function init() {
            if($stateParams.scrollTo && $stateParams.scrollTo == 'attendance'){
                $timeout(function(){
                    $location.hash('attendance');
                    $anchorScroll();
                }, 300);
            }
            vm.attendancedatePicker.options = getDatePickerOptions();
            vm.excelUrl = attendanceService.getProfileExcelUrl(getSearchParams());
            getAttendanceTableData();
        }

        function getSearchParams() {
            return {
                from        : dayjs(vm.attendancedatePicker.date.startDate).startOf('day').format('x'),
                to          : vm.attendancedatePicker.date.endDate.valueOf(),
                employeeId  : $stateParams.employeeId,
                pageNumber  : 0,
                perPage     : 1,
                sortKey     : "shiftGroupName",
                order       : "asc"
            };
        }
        
        function createEventWatchers() {
            $scope.$on("attendance-tab-select",init);
        }

        createEventWatchers();

        function getInitialFromAndToDate () {
            return {
                'startDate': vm.isGpClient ? moment().startOf('day') : moment().subtract(10,'days'),
                'endDate': moment()
            };
        }

        function getAttendanceTableData() {
            attendanceService.getAttendance(getSearchParams())
                .then(function (data) {
                    var unprocessedData = data.attendance[0].attendance;
                    var dataToChunk = [];
                    angular.forEach(unprocessedData, function (v,k){
                        dataToChunk.push(v);
                    })
                    dataToChunk = _.orderBy(dataToChunk,['startTimeOfThisDayInMillis'], ['desc']);
                    vm.allAttendanceData = _.chunk(dataToChunk,10);
                    vm.attendances = vm.allAttendanceData[0];
                    vm.startOfDayList = data.startOfDayList;
                    vm.summary = data.attendance[0].summary;
                    vm.numberOfButtons = Array(vm.allAttendanceData.length).fill(1);
                    vm.selectedPage = 0;
                    vm.excelUrl = attendanceService.getProfileExcelUrl(getSearchParams());
                },function () {
                    toastrService.showErrorToastr("Failed to fetch attendance list", "", 5000);
                });
            getLateHistoryTableData();
        }

        function getLateHistoryTableData(){
            attendanceService.getLateAttendanceHistory($stateParams.employeeId, vm.attendancedatePicker.date.startDate.valueOf(), vm.attendancedatePicker.date.endDate.valueOf())
                .then(function (lateAttendanceHistoryList) {
                    vm.lateAttendanceHistoryList = lateAttendanceHistoryList;
                }, function (error) {
                    toastrService.showErrorToastr("Failed to fetch late attendance history " + error, "", 5000);
                });
        }

        function showChunks(index) {
            vm.attendances = vm.allAttendanceData[index];
            vm.selectedPage = index;
        }

        function getDatePickerOptions() {
            return {
                minDate : vm.isGpClient ? new moment() : angular.copy(vm.minDate),
                maxDate : new moment(),
                applyClass: 'btn-success',
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "DD-MMM-YYYY", //will give you 6-Jan-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: utilService.getDatePickerRanges()
            };
        }

        function analyticsExcel(){
            analyticsService.sendData(ANALYTICS_CONSTANT.attendanceReport, document.title + ' - Attendance Report - Attendance Table - Download Excel', 'attendance-table/download-excel', 'Download Attendance Table Excel Of Attendance Report In' + document.title, ANALYTICS_CONSTANT.download)
        }

        function exportAsExcel() {
            if(isDownloadMonthLimitExceeded()) {
                return openDownloadWarningModal();
            }
            window.open(vm.excelUrl, '_blank', '');
            analyticsExcel();
        }

        function isDownloadMonthLimitExceeded() {
            // var minDate = moment().subtract(REPORT_SETTINGS.downloadMonthLimit, 'month').startOf('month');
            // return minDate.diff(vm.attendancedatePicker.date.startDate) > 0;
            return vm.attendancedatePicker.date.endDate.diff(vm.attendancedatePicker.date.startDate, 'months', true) > REPORT_SETTINGS.downloadMonthLimit;
        }

        function openDownloadWarningModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/reportDownloadWarningModal/reportDownloadWarning.modal.html',
                size         : 'md',
                controller   : 'ReportDownloadWarningModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
            }).result.then(function () {});
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ApplyForLateApprovalModalCtrl', ['employeeService','$stateParams','$uibModalInstance','authService','utilService', 'toastrService','lateApprovalManagementService', 'employeeId', 'analyticsService', 'ANALYTICS_CONSTANT', ApplyForLateApprovalModalCtrl]);

    /** @ngInject */
    function ApplyForLateApprovalModalCtrl(employeeService,$stateParams,$uibModalInstance, authService, utilService, toastrService,lateApprovalManagementService,employeeId, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Apply For Late Modal';
        var analyticsModalUrl = 'apply-for-late';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Apply For Late In' + document.title, ANALYTICS_CONSTANT.open);
        vm.reason = null;
        vm.lateAttendanceRecords = null;
        vm.select = {};
        vm.select.lateAttendanceDates = [];
        vm.select.selectedDate = null;

        var ONE_HOUR = 1000 * 3600;
        var ONE_MINUTE = 60 * 1000;

        vm.applyForLateApproval = applyForLateApproval;
        vm.extractDatesFromRecords = extractDatesFromRecords;

        function init() {
            vm.select.selectedDate = new Date();

            lateApprovalManagementService.getLateAttendanceRecordsOfAnEmployee(employeeId).then(function(lateAttendanceRecords){
                vm.lateAttendanceRecords = lateAttendanceRecords;
                extractDatesFromRecords();
            }, function (error) {
                toastrService.showErrorToastr("Failed to fetch pending leave applications : " + error, "", 5000);
                console.error("Failed to fetch pending leave applications : " + error);
            });
        }

        init();

        function applyForLateApproval() {
            toastrService.clearPreviousToastr();
            if(!vm.reason)
                return toastrService.showErrorToastr("Reason cannot be empty");
            if(!vm.select.selectedDate || vm.select.selectedDate.length === 0)
                return toastrService.showErrorToastr("Please select a date");
            if(utilService.checkIfFutureDate(vm.select.selectedDate))
                return toastrService.showErrorToastr("Late approval application can not be applied for future dates");
            var data = {
                    attendanceDate: new Date(vm.select.selectedDate[0].id).valueOf(),
                    reason : vm.reason
                };
            lateApprovalManagementService.applyForLateApproval(employeeId,data).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Apply', analyticsModalUrl + '/apply', 'Apply For Late In' + document.title, ANALYTICS_CONSTANT.apply);
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not apply for late approval because " + error, "", 5000);
                $uibModalInstance.dismiss();
            });
        }

        function extractDatesFromRecords(){
            for(var i=0; i<vm.lateAttendanceRecords.length; i++){
                var option = {
                    id: new Date(vm.lateAttendanceRecords[i]["attDateInMilliseconds"]).toDateString(),
                    name: new Date(vm.lateAttendanceRecords[i]["attDateInMilliseconds"]).toDateString()
                };
                option.name = option.name
                    +'&nbsp;&nbsp;'
                    + dayjs(vm.lateAttendanceRecords[i].entryTimeInMillis).format('hh:mm A')
                    +'&nbsp;&nbsp;'
                    +'<span style="color:red">'+transLateMillisToTimeString(vm.lateAttendanceRecords[i].lateByMillis) +'</span>';
                vm.select.lateAttendanceDates.push(option);
            }
        }

        function transLateMillisToTimeString(time){
            var hours = Math.floor(time / (1000 * 60 * 60)) + "h";
            time = Math.floor(time % (1000 * 60 * 60));

            var minutes = Math.floor(time / (1000 * 60)) + "m";
            time = (time % (1000 * 60));

            var seconds = (time / 1000) + "s";

            return hours + minutes;
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('LateCancelModalCtrl', ['lateApprovalManagementService','$uibModalInstance','toastrService','lateLogId', 'analyticsService', 'ANALYTICS_CONSTANT', LateCancelModalCtrl]);

    /** @ngInject */
    function LateCancelModalCtrl(lateApprovalManagementService,$uibModalInstance,toastrService,lateLogId, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Pending Approvals - Late Cancel Modal';
        var analyticsDeleteUrl = 'pending-approvals/late-cancel';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Cancel Late Pending Approval In' + document.title, ANALYTICS_CONSTANT.open);

        vm.cancelLate = cancelLate;

        function cancelLate() {
            lateApprovalManagementService.cancelLateLog(lateLogId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Cancel', analyticsDeleteUrl + '/cancel', 'Cancel Late Pending Approval In' + document.title, ANALYTICS_CONSTANT.cancel)
                toastrService.showSuccessToastr("Cancelled Successfully");
                $uibModalInstance.close()
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('NotificationSettingsCtrl', ["$scope", 'notificationGroups', 'notificationService', 'taskService', '$stateParams', '$uibModal', 'authService', 'toastrService', NotificationSettingsCtrl]);

    /** @ngInject */
    function NotificationSettingsCtrl($scope, notificationGroups, notificationService, taskService, $stateParams, $uibModal, authService, toastrService) {

        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.userId = $stateParams.employeeId ? $stateParams.employeeId : loggedInUser.id;
        vm.notificationSettings = {}
        vm.select = {}
        vm.select.notificationGroups = angular.copy(notificationGroups);
        vm.select.selectedNotificationGroups = [];
        vm.notificationsOn = false;
        vm.selfCheckBoxes = []
        vm.lineManagerCheckBoxes = []
        vm.hrCheckBoxes = []
        vm.isDataLoaded = false
        vm.isDataEdited = false
        vm.isDataSaving = false
        vm.officeTimeNotifyBeforeStartTime = null;
        vm.whenToCheckAbsent = null;
        vm.whenToCheckAbsentDropdown = [ {name : 'At Start',value : 'at_start'},{name : '30 min before start', value:'30_min_before_start'}, {name: '30 min after start', value: '30_min_after_start'}, {name : 'At End',value:'at_end'}]
        vm.whenToCheckEarlyExit = null;
        vm.whenToCheckEarlyExitDropdown = [{name : 'At Shift End',value :'at_shift_end'}];
        vm.getNotificationSettings = getNotificationSettings
        vm.saveNotificationSettings = saveNotificationSettings;
        vm.handleSelectNotificationGroup = handleSelectNotificationGroup
        vm.handleNotificationOnOffButton = handleNotificationOnOffButton
        function init() {
            vm.select.notificationGroups[0].ticked = true
            vm.select.selectedNotificationGroups = [{
                value: vm.select.notificationGroups[0].value
            }]
            getNotificationSettings()
        }

        init()

        function resetAllCheckedItem() {
            vm.selfCheckBoxes = [
                {valueIndex: 1, id: 'selfSmsCheckBox', labelText: 'employeeActions.notification.typeSMS', value: false},
                {
                    valueIndex: 2,
                    id: 'selfEmailCheckBox',
                    labelText: 'employeeActions.notification.typeEmail',
                    value: false
                },
                {
                    valueIndex: 3,
                    id: 'selfPushCheckbox',
                    labelText: 'employeeActions.notification.typePush',
                    value: false
                },
            ];
            vm.lineManagerCheckBoxes = [
                {valueIndex: 1, id: 'lmSMSCheckbox', labelText: 'employeeActions.notification.typeSMS', value: false},
                {
                    valueIndex: 2,
                    id: 'lmEmailCheckBox',
                    labelText: 'employeeActions.notification.typeEmail',
                    value: false
                },
                {valueIndex: 3, id: 'lmPushCheckbox', labelText: 'employeeActions.notification.typePush', value: false},
            ];
            vm.hrCheckBoxes = [
                {valueIndex: 1, id: 'hrSMSCheckbox', labelText: 'employeeActions.notification.typeSMS', value: false},
                {
                    valueIndex: 2,
                    id: 'hrEmailCheckBox',
                    labelText: 'employeeActions.notification.typeEmail',
                    value: false
                },
                {valueIndex: 3, id: 'hrPushCheckbox', labelText: 'employeeActions.notification.typePush', value: false},
            ];
        }

        function handleSelectNotificationGroup(){
            getNotificationSettings()
            vm.isDataEdited =  false
        }

        function handleNotificationOnOffButton(){
            if (!vm.notificationsOn){
                vm.isDataEdited = false
                saveNotificationSettings()
                resetAllCheckedItem()
            }
        }

        function getNotificationSettings() {
            vm.isDataLoaded = false
            notificationService.getNotificationSettingsByEmployeeId(vm.userId, vm.select.selectedNotificationGroups[0].value).then(function (data) {
                    vm.notificationSettings = data
                    resetAllCheckedItem()
                    checkedNotification(JSON.parse(data.notificationTypes))
                    vm.isDataLoaded = true
                    vm.isDataFound = true
                    vm.notificationsOn = true
                },
                function (error) {
                    vm.isDataLoaded = true
                    vm.isDataFound = false
                    vm.notificationsOn = false
                    resetAllCheckedItem()
                    // toastrService.showErrorToastr('Error: ' + error, '', 5000);
                })
        }

        function checkedNotification(notificationTypes) {
            var selfCheckedItems = notificationTypes[1];
            selfCheckedItems.map(function (v, i) {
                vm.selfCheckBoxes[v - 1].value = true
            })
            var lineManagerCheckedItems = notificationTypes[2];
            lineManagerCheckedItems.map(function (v, i) {
                vm.lineManagerCheckBoxes[v - 1].value = true
            })
            var hrCheckedItems = notificationTypes[3];
            hrCheckedItems.map(function (v, i) {
                vm.hrCheckBoxes[v - 1].value = true
            })

        }

        function saveNotificationSettings() {
            toastrService.clearPreviousToastr();
            if (vm.select.selectedNotificationGroups.length === 0)
                return toastrService.showErrorToastr("Please select notification group first");
            var data = {};
            if (vm.notificationsOn) {
                data = {
                    employeeIdList: [vm.userId],
                    notificationGroup: vm.select.selectedNotificationGroups[0].value,
                    notificationTypes: {
                        1: getNotificationValuesFromModels(vm.selfCheckBoxes),
                        2: getNotificationValuesFromModels(vm.lineManagerCheckBoxes),
                        3: getNotificationValuesFromModels(vm.hrCheckBoxes)
                    },
                    settings: {},
                    off: false
                };
                if (doesThisNotificationGroupNeedConfiguration()) {
                    addExtraNotificationSettingsToPostData(data)
                    if (_.isEmpty(data.settings)) return;
                }
            } else {
                data = {
                    employeeIdList: [vm.userId],
                    notificationGroup: vm.select.selectedNotificationGroups[0].value,
                    off: true
                }
            }
            if (!isRecipientSelected()) {
                return toastrService.showErrorToastr("Please select recipient");
            }
            vm.isDataSaving = true
            notificationService.updateBatchNotificationSettings(data).then(function () {
                vm.isDataEdited = false
                vm.isDataSaving =  false
                vm.officeTimeNotifyBeforeStartTime = null
                vm.whenToCheckAbsent = null;
                vm.whenToCheckEarlyExit = null;
                return toastrService.showSuccessToastr("Notification Settings updated");
            }, function (e) {
                console.error(e);
                vm.isDataEdited = false
                vm.isDataSaving =  false
                return toastrService.showErrorToastr("Failed to update notification settings - " + e, "", 5000);
            })
        }
        function getNotificationValuesFromModels(modelArray) {
            return modelArray.filter(function (m) {
                return m.value;
            }).map(function (m) {
                return m.valueIndex;
            });
        }
        function doesThisNotificationGroupNeedConfiguration(){
            if(vm.select.selectedNotificationGroups && vm.select.selectedNotificationGroups.length > 0){
                if(vm.select.selectedNotificationGroups[0].value===100 || vm.select.selectedNotificationGroups[0].value===400 || vm.select.selectedNotificationGroups[0].value===900) return true;
            }
            return false;
        }
        function addExtraNotificationSettingsToPostData(data) {
            toastrService.clearPreviousToastr();
            if(data.notificationGroup == 100){
                if(vm.officeTimeNotifyBeforeStartTime == null){
                    return toastrService.showErrorToastr("Please set how many minutes before shift time")
                }
                if(vm.officeTimeNotifyBeforeStartTime < 0 || vm.officeTimeNotifyBeforeStartTime > 59 )
                    return toastrService.showErrorToastr("Notification time must be between 1 and 59 minutes");
                data.settings = {
                    'min_before_shift_start' : vm.officeTimeNotifyBeforeStartTime
                }
            }
            if(data.notificationGroup == 400 ){
                if(vm.whenToCheckAbsent == null){
                    return toastrService.showErrorToastr('Please select when to check absent setting from dropdown.');
                }
                data.settings = {
                    'when_to_check_absent' : vm.whenToCheckAbsent.value
                }
            }
            if(data.notificationGroup == 900){
                if(vm.whenToCheckEarlyExit == null){
                    return toastrService.showErrorToastr('Please select when to check early exit from dropdown')
                }
                data.settings = {
                    'when_to_check_early_exit' : vm.whenToCheckEarlyExit.value
                }
            }
            return data;
        }
        function isRecipientSelected(){
            var isNotSelected  = function (o) {
                return o.value == false;
            }
            if(vm.selfCheckBoxes.every(isNotSelected) && vm.lineManagerCheckBoxes.every(isNotSelected) && vm.hrCheckBoxes.every(isNotSelected)){
                return false;
            }
            return true;
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileActionCtrl', ['MODULES', '$stateParams','$scope', '$uibModal', 'authService', 'leaveManagementService', 'toastrService', '$state', 'imageNotResize', 'utilService', 'lateApprovalManagementService','employeeService','BANGABHABAN_OFFICE_ID', ProfileActionCtrl]);

    /** @ngInject */
    function ProfileActionCtrl(MODULES, $stateParams, $scope, $uibModal, authService, leaveManagementService, toastrService, $state, imageNotResize, utilService, lateApprovalManagementService,employeeService,BANGABHABAN_OFFICE_ID) {
        var vm = this;
        var isLeaveAllowed = false;
        var loggedInUser = authService.getLoggedInUser();
        var employeeId = $stateParams.employeeId && loggedInUser.isAdmin ? $stateParams.employeeId : loggedInUser.id;
        vm.isThisLineManagerAllowedShiftManagement = null;

        vm.isBangabhabanEmployee = (authService.getLoggedInUser().officeId === BANGABHABAN_OFFICE_ID.id);



        vm.profileActions = {};

        vm.isEmployeeAllowedOvertime = null;
        vm.openSetAdminModal = openSetAdminModal;
        vm.showProfilePictureUploadModal = showProfilePictureUploadModal;
        vm.openUploadDocumentModal = openUploadDocumentModal;
        vm.openManualEntryModal = openManualEntryModal;
        vm.openAddAddressModal = openAddAddressModal;
        vm.enrolFingerprint = enrolFingerprint;
        vm.openApplyForLeaveModal = openApplyForLeaveModal;
        vm.openOvertimeConfirmationModal = openOvertimeConfirmationModal;
        vm.openIncludeInAttendanceReportModal = openIncludeInAttendanceReportModal;
        vm.openChangeStatusModal = openChangeStatusModal;
        vm.openDeleteModal = openDeleteModal;
        vm.openResignEmployeeModal = openResignEmployeeModal;
        vm.openApplyForLateApprovalModal = openApplyForLateApprovalModal;
        vm.openApplyForHalfDayLeaveModal = openApplyForHalfDayLeaveModal;
        vm.openTimeSheetEntryModal = openTimeSheetEntryModal;




        function init() {
            leaveManagementService
                .isEmployeeEligibleForLeave(employeeId)
                .then(function (data) {
                    isLeaveAllowed = data.isEmployeeEligibleForLeave;
                    if(typeof vm.profileActions.applyForLeave !== 'undefined') vm.profileActions.applyForLeave.isVisible = isLeaveAllowed;
                }, function (error) {
                    toastrService.showErrorToastr("Failed to fetch employee leave eligibility : " + error, "", 5000);
                    console.error("Failed to fetch employee leave eligibility : " + error);
                });
            employeeService.getShiftAssignmentStatus(employeeId)
                .then(function(data) {
                    vm.isThisLineManagerAllowedShiftManagement = data;
                })
                .catch(function(error) {
                    console.error('Error:', error);
                });



            $scope.$on("profile-info-loaded", function (event, userData) {
                vm.user = userData;
                vm.isEmployeeAllowedOvertime = userData.allowOvertime;
                vm.user.isLeaveAllowed = isLeaveAllowed;
                vm.profileActions={};
                if(authService.getLoggedInId() === vm.user.id) {
                    vm.profileActions.myTasks = {
                        name: 'My Tasks',
                        icon: 'ion-hammer',
                        willBeSelected: false,
                        isVisible: (utilService.hasPermission("10001") || utilService.hasPermission("100011")) && vm.user.status === 1,
                        code: null,
                        modalOpenerMethod: openMyTasksModal
                    };
                }
                vm.profileActions.timesheetEntry = {
                    name: 'Timesheet entry',
                    icon: 'ion-ios-clock',
                    willBeSelected: false,
                    isVisible: (utilService.hasPermission("10001") || utilService.hasPermission("100011"))  && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openTimeSheetEntryModal
                };
                vm.profileActions.addTask = {
                    name: 'Add task',
                    icon: 'ion-hammer',
                    willBeSelected: false,
                    isVisible: (utilService.hasPermission("10001") || utilService.hasPermission("100011"))  && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openCreateTaskModal
                };
                vm.profileActions.applyForLeave = {
                    name: 'profileActions.applyForLeave',
                    icon: 'ion-ios-rainy',
                    willBeSelected: false,
                    isVisible: isLeaveAllowed  && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openApplyForLeaveModal
                };
                vm.profileActions.applyForLateApproval = {
                    name: 'profileActions.applyForLateApproval',
                    icon: 'ion-ios-rainy',
                    willBeSelected: false,
                    isVisible: vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openApplyForLateApprovalModal
                };
                // vm.profileActions.push({
                //     name: 'Change Password',
                //     icon: 'ion-android-refresh',
                //     willBeSelected: false,
                //     isVisible: true,
                //     code: null,
                //     modalOpenerMethod: function () {
                //         $scope.$parent.$broadcast("show-change-password-tab");
                //     }
                // });
                vm.profileActions.manualEntry = {
                    name: 'profileActions.manualEntry',
                    icon: 'ion-man',
                    willBeSelected: false,
                    isVisible: vm.user.status === 1,
                    code: 3001,
                    modalOpenerMethod: openManualEntryModal
                };
                vm.profileActions.enrolFingerprint = {
                    name: 'profileActions.enrolFingerprint',
                    icon: 'ion-ios-paw',
                    willBeSelected: false,
                    isVisible: (vm.user.isAdmin || vm.user.isHrManager || loggedInUser.isCompanyAdmin)  && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: enrolFingerprint
                };
                // vm.profileActions.push({
                //     name: 'Upload Profile Picture',
                //     icon: 'ion-android-camera',
                //     willBeSelected: false,
                //     isVisible: true,
                //     code: 2004,
                //     modalOpenerMethod: showProfilePictureUploadModal
                // });
                // vm.profileActions.push({
                //     name: 'Upload Document',
                //     icon: 'ion-android-attach',
                //     willBeSelected: false,
                //     isVisible: true,
                //     code: null,
                //     modalOpenerMethod: openUploadDocumentModal
                // });
                // vm.profileActions.push({
                //     name: 'Add Address',
                //     icon: 'ion-ios-list',
                //     willBeSelected: false,
                //     isVisible: true,
                //     code: null,
                //     modalOpenerMethod: openAddAddressModal
                // });
                vm.profileActions.adminRole = {
                    name: vm.user.isAdmin ? 'profileActions.removeAdminRole' : 'profileActions.setAsAdmin',
                    icon: 'ion-bonfire',
                    willBeSelected: vm.user.isAdmin,
                    isVisible: (loggedInUser.isAdmin || loggedInUser.isCompanyAdmin) && vm.user.status === 1,
                    code: 2015,
                    modalOpenerMethod: openSetAdminModal
                };
                vm.profileActions.hrManagerRole = {
                    name: vm.user.isHrManager ? 'profileActions.removeHrManagerRole' : 'profileActions.setAsHrManager',
                    icon: 'ion-fireball',
                    willBeSelected: vm.user.isHrManager,
                    isVisible: (loggedInUser.isAdmin || loggedInUser.isCompanyAdmin) && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openSetHrManagerModal
                };

                vm.profileActions.subsidiaryAdminRole = {
                    name: vm.user.isAdmin ? 'profileActions.removeSubsidiaryAdminRole' : 'profileActions.setAsSubsidiaryAdmin',
                    icon: 'ion-bonfire',
                    willBeSelected: vm.user.isAdmin,
                    isVisible: loggedInUser['modules'].includes(MODULES.SUBSIDIARY) && vm.user.status === 1 && loggedInUser.isAdmin && loggedInUser.subsidiaryId == null,
                    code: 9013,
                    modalOpenerMethod: openSetAdminModal
                };

                vm.profileActions.lineManagerRole = {
                    name: vm.user.isLineManager ? 'profileActions.removeLineManagerRole' : 'profileActions.setAsLineManager',
                    icon: 'ion-fireball',
                    willBeSelected: vm.user.isLineManager,
                    isVisible:(loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager) && vm.user.status === 1,
                    // NEW: mark this action with the module code and gate it
                    code: 2017,
                    // NEW: only disable "Set as Line Manager" when permission is absent
                    isDisabled: (!vm.user.isLineManager) && !utilService.hasPermission('2017'),
                    // NEW: if disabled, clicking opens the Upgrade popup; else proceed as usual
                    modalOpenerMethod: ((!vm.user.isLineManager) && !utilService.hasPermission('2017'))
                    ? openUpgradeForLineManager
                        : openSetLineManagerModal
                };
                if(vm.user.status === 1 && vm.user.isLineManager) {
                    vm.profileActions.lineManagerShiftAssignment = {
                        name: vm.isThisLineManagerAllowedShiftManagement ? 'profileActions.disallowLineManagerShiftManagement' : 'profileActions.allowLineManagerShiftManagement',
                        icon: 'ion-fireball',
                        willBeSelected: !!vm.isThisLineManagerAllowedShiftManagement,
                        isVisible: loggedInUser.isAdmin && vm.user.status === 1 && vm.user.isLineManager,
                        code: 5009,
                        modalOpenerMethod: openAllowShiftManagementModal
                    };
                }
                vm.profileActions.siteManagerRole = {
                    name: vm.user.isSiteManagementManager ? 'profileActions.removeSiteManagerRole' : 'profileActions.setAsSiteManager',
                    icon: 'ion-fireball',
                    willBeSelected: vm.user.isSiteManagementManager,
                    isVisible: (loggedInUser['modules'].includes(MODULES.SITE_MANAGEMENT) && (loggedInUser.isSiteManagementAdmin || loggedInUser.isLineManager || loggedInUser.isAdmin || loggedInUser.isHrManager)) && vm.user.status === 1,
                    code: MODULES.SITE_MANAGEMENT,
                    modalOpenerMethod: openSetSiteManagerModal
                };
                vm.profileActions.siteAdminRole = {
                    name: vm.user.isSiteManagementAdmin ? 'profileActions.removeSiteAdminRole' : 'profileActions.setAsSiteAdmin',
                    icon: 'ion-fireball',
                    willBeSelected: vm.user.isSiteManagementAdmin,
                    isVisible: (loggedInUser['modules'].includes(MODULES.SITE_MANAGEMENT) && (loggedInUser.isSiteManagementAdmin || loggedInUser.isLineManager || loggedInUser.isAdmin || loggedInUser.isHrManager)) && vm.user.status === 1,
                    code: MODULES.SITE_MANAGEMENT,
                    modalOpenerMethod: openSetSiteAdminModal
                };
                vm.profileActions.projectManagerRole = {
                    name: vm.user.employeeRoles.includes('PROJECT_MANAGER') ? 'profileActions.removeProjectManagerRole' : 'profileActions.setAsProjectManager',
                    icon: 'ion-fireball',
                    willBeSelected: vm.user.employeeRoles.includes('PROJECT_MANAGER'),
                    isVisible: (loggedInUser['modules'].includes(MODULES.PROJECT_MANAGEMENT) || loggedInUser['modules'].includes(MODULES.ISSUE_TRACKER)) && (loggedInUser.isAdmin || loggedInUser.isHrManager) && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openSetProjectManagerModal
                };
                vm.profileActions.changeOvertimeStatus = {
                    name: vm.user.allowOvertime ? 'profileActions.disallowOvertime' : 'profileActions.allowOvertime',
                    icon: 'ion-ios-timer-outline',
                    willBeSelected: vm.user.allowOvertime,
                    isVisible: (loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager) && vm.user.status === 1,
                    code: null,
                    modalOpenerMethod: openOvertimeConfirmationModal
                };
                vm.profileActions.includeInAttendanceReport = {
                    name: vm.user.includeInAttendanceReport ? 'profileActions.excludeFromAttendanceReport' : 'profileActions.includeInAttendanceReport',
                    icon: 'ion-ios-checkmark',
                    willBeSelected: vm.user.includeInAttendanceReport,
                    isVisible:( loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager) && vm.user.status === 1,
                    code: 3007,
                    modalOpenerMethod: openIncludeInAttendanceReportModal
                };
                vm.profileActions.changeStatus = {
                    name: vm.user.status === 1 ? 'profileActions.makeEmployeeStatusInactive' : 'profileActions.makeEmployeeStatusActive',
                    icon: vm.user.status === 1 ? 'ion-thumbsdown' : 'ion-thumbsup',
                    willBeSelected: vm.user.status !== 1,
                    isVisible: (loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager) && (vm.user.status === 0 || vm.user.status == 1),
                    code: null,
                    modalOpenerMethod: openChangeStatusModal
                };
                vm.profileActions.resignEmployee = {
                    name: 'profileActions.resignEmployee',
                    icon: 'ion-android-walk',
                    willBeSelected: false,
                    isVisible: (loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager) && (vm.user.status === 0 || vm.user.status === 1),
                    code: 2012,
                    modalOpenerMethod: openResignEmployeeModal
                };
                vm.profileActions.rehireEmployee = {
                    name: 'profileActions.rehireEmployee',
                    icon: 'ion-android-walk',
                    willBeSelected: false,
                    isVisible: (loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager) && (vm.user.status === 2 || vm.user.status === 3),
                    code: null,
                    modalOpenerMethod: openRehireEmployeeModal
                };
                vm.profileActions.deleteEmployee = {
                    name: 'profileActions.deleteEmployee',
                    icon: 'ion-android-delete',
                    willBeSelected: false,
                    isVisible: loggedInUser.isCompanyAdmin || loggedInUser.isAdmin || loggedInUser.isHrManager,
                    code: null,
                    modalOpenerMethod: openDeleteModal
                };
                vm.profileActions.syncEmployee = {
                    name: 'profileActions.syncEmployee',
                    icon: 'ion-android-sync',
                    willBeSelected: false,
                    isVisible: (loggedInUser.isCompanyAdmin||loggedInUser.isAdmin) && vm.user.status === 1,
                    code: 10000,
                    modalOpenerMethod: syncEmployee
                };
            });
        }

        init();

                // NEW: tiny helper to open the Upgrade popup for Line Manager module (2017)
                    function openUpgradeForLineManager() {
                            $uibModal.open({
                                    animation: true,
                                    templateUrl: 'app/pages/main/upgradePopup.html',
                                    controller: 'UpgradePopupModalCtrl',
                                    controllerAs: 'vm',
                                    size: 'lg',
                                    backdrop: 'static'
                            });
                        }

        function getShiftAssignmentStatus(employeeId) {
            return employeeService.getShiftAssignmentStatus(employeeId);
        }

        function setAdminAvailable() {
            return loggedInUser.isAdmin && utilService.hasPermission('2015');
        }

        function includeInAttendanceReportAvailable() {
            return (loggedInUser.isAdmin || loggedInUser.isCompanyAdmin) && utilService.hasPermission('3007');
        }

        function resignEmployeeAvailable() {
            if (loggedInUser.isAdmin || loggedInUser.isCompanyAdmin || loggedInUser.isHrManager) {
                return utilService.hasPermission('2012');
            }
            return false;
        }

        function manualEntryAvailable() {
            if (loggedInUser.isAdmin) {
                return utilService.hasPermission('3001');
            } else {
                return utilService.hasPermission('3002');
            }
        }

        function openMyTasksModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/myTasks/myTasks.modal.html',
                controller: 'MyTasksModalCtrl',
                size: 'lg',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    },
                }
            })
        }

        function openTimeSheetEntryModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/timeSheetEntry/timeSheetEntry.modal.html',
                controller: 'TimeSheetEntryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    },
                }
            })
        }

        function openCreateTaskModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/createTask/createTask.modal.html',
                size : 'md',
                controller: 'CreateTaskFromProfileModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    },
                }
            })
        }

        function openSetAdminModal() {
            toastrService.clearPreviousToastr();
            if (!setAdminAvailable()) return;
            if (authService.getLoggedInUser().id == vm.user.id){
                return toastrService.showErrorToastr("Cannot change own admin status");
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeManagerOrAdminRole/changeManagerOrAdminRole.modal.html',
                controller: 'ChangeManagerOrAdminRoleModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentValue: function () {
                        return vm.user.isAdmin;
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'isAdmin';
                    },
                    roleText: function () {
                        return 'Admin';
                    }
                }
            }).result.then(function (isAdmin) {
                vm.user.isAdmin = isAdmin;
                if (authService.getLoggedInId() == vm.user.id) {
                    authService.updateUserInfo({'isAdmin': isAdmin});
                }
                $scope.$emit("profile-updated", {key: "isAdmin", value: isAdmin});
            });
        }

        function openSetHrManagerModal() {
            // TODO check if this module is allowed or not
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeManagerOrAdminRole/changeManagerOrAdminRole.modal.html',
                controller: 'ChangeManagerOrAdminRoleModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentValue: function () {
                        return vm.user.isHrManager;
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'isHrManager';
                    },
                    roleText: function () {
                        return 'HR Manager';
                    }
                }
            }).result.then(function (newVal) {
                vm.user.isHrManager = newVal;
                if (authService.getLoggedInId() == vm.user.id) {
                    authService.updateUserInfo({'isHrManager': newVal});
                }
                $scope.$emit("profile-updated", {key: "isHrManager", value: newVal});
            });
        }

        function openSetLineManagerModal() {
            // TODO check if this module is allowed or not
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeManagerOrAdminRole/changeManagerOrAdminRole.modal.html',
                controller: 'ChangeManagerOrAdminRoleModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentValue: function () {
                        return vm.user.isLineManager;
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'isLineManager';
                    },
                    roleText: function () {
                        if(vm.isBangabhabanEmployee)
                            return 'Section Officer';
                        else
                            return 'Line Manager'
                    }
                }
            }).result.then(function (newVal) {
                vm.user.isLineManager = newVal;
                if (authService.getLoggedInId() == vm.user.id) {
                    authService.updateUserInfo({'isLineManager': newVal});
                }
                $scope.$emit("profile-updated", {key: "isLineManager", value: newVal});
            });
        }

        function openAllowShiftManagementModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/allowLineManagerShiftManagement/allowLineManagerShiftManagement.modal.html',
                controller: 'AllowLineManagerShiftManagement',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    },
                    currentValue: function () {
                        return getShiftAssignmentStatus(vm.user.id);
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'can_assign_shift';
                    },
                    roleText: function () {
                            return 'Assign Shifts to Employees Under Them';
                    }
                }
            }).result.then(function (newVal) {
                vm.isThisLineManagerAllowedShiftManagement = newVal;
                vm.profileActions.lineManagerShiftAssignment.willBeSelected = !vm.profileActions.lineManagerShiftAssignment.willBeSelected;
                vm.profileActions.lineManagerShiftAssignment.name = vm.isThisLineManagerAllowedShiftManagement ? 'profileActions.disallowLineManagerShiftManagement' : 'profileActions.allowLineManagerShiftManagement';

            });
        }
        function openSetSiteManagerModal() {
            // TODO check if this module is allowed or not
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeSiteManagerRole/changeSiteManagerRole.modal.html',
                controller: 'ChangeSiteManagerRoleModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentValue: function () {
                        return vm.user.isSiteManagementManager;
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'isSiteManagementManager';
                    },
                    roleText: function () {
                        return 'Site Management Manager';
                    }
                }
            }).result.then(function (newVal) {
                vm.user.isSiteManagementManager = newVal;
                if (authService.getLoggedInId() == vm.user.id) {
                    // authService.updateUserInfo({'isLineManager': newVal});
                }
                $scope.$emit("profile-updated", {key: "isSiteManagementManager", value: newVal});
            });
        }

        function openSetSiteAdminModal() {
            // TODO check if this module is allowed or not
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeSiteAdminRole/changeSiteAdminRole.modal.html',
                controller: 'ChangeSiteAdminRoleModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentValue: function () {
                        return vm.user.isSiteManagementAdmin;
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'isSiteManagementAdmin';
                    },
                    roleText: function () {
                        return 'Site Management Admin';
                    }
                }
            }).result.then(function (newVal) {
                vm.user.isSiteManagementAdmin = newVal;
                if (authService.getLoggedInId() == vm.user.id) {
                    // authService.updateUserInfo({'isLineManager': newVal});
                }
                $scope.$emit("profile-updated", {key: "isSiteManagementAdmin", value: newVal});
            });
        }

        function openSetProjectManagerModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeManagerOrAdminRole/changeManagerOrAdminRole.modal.html',
                controller: 'ChangeManagerOrAdminRoleModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentValue: function () {
                        return vm.user.employeeRoles.includes('PROJECT_MANAGER');
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    userName: function () {
                        return vm.user.name;
                    },
                    role: function (){
                        return 'isProjectManager';
                    },
                    roleText: function () {
                        return 'Project Manager';
                    }
                }
            }).result.then(function (newVal) {
                $scope.$emit("profile-updated", {key: "isProjectManager", value: newVal});
            });
        }

        function showProfilePictureUploadModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicUploadModal/profilePicUpload.modal.html',
                controller: 'ProfilePicUploadModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentProfilePicURL: function () {
                        return vm.user.employeePictureUrl == null || vm.user.employeePictureUrl == "" ? null : vm.user.employeePictureUrl;
                    },
                    userId: function () {
                        return vm.user.id;
                    },
                    resizeImage: function () {
                        //return vm.user.office.id != uapOfficeId;
                        return imageNotResize.indexOf(vm.user.office.id) == -1 ? true : false;
                    }
                }
            }).result.then(function (employeePicture) {
                vm.user.employeePicture = employeePicture;
                if (authService.getLoggedInId() == vm.user.id) {
                    authService.updateUserInfo({'employeePicture': employeePicture});
                }
                $scope.$emit("profile-updated", {key: "employeePicture", value: employeePicture});
                vm.noPicture = false;
            }, function () {
                console.log("Profile picture upload modal dismissed.");
            });
        }

        function openUploadDocumentModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/documentUpload/documentUpload.modal.html',
                controller: 'DocumentUploadModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    }
                }
            }).result.then(function (document) {
                $scope.$emit("profile-updated", {"key": "documents", "type": "new", "value": document});
            }, function () {
                console.log("Document upload modal dismissed.");
            });
        }

        function openManualEntryModal() {
            toastrService.clearPreviousToastr();
            if (!manualEntryAvailable())
                return;
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/attendance/detailsAttendanceLog/manualEntry/manualEntry.modal.html',
                controller: 'ManualEntryModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    }
                }
            });
        }

        function openAddAddressModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/addAddress/addAddress.action.modal.html',
                controller: 'AddAddressModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    },
                    currentAddress: function () {
                        return vm.user.addresses;
                    }
                }
            }).result.then(function (address) {
                $scope.$emit("profile-updated", {"key": "addresses", "type": "new", "value": address});
            }, function () {
                console.log("Address upload modal dismissed.");
            });

        }

        function openOvertimeConfirmationModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/overtime/overtimeConfirmation.modal.html',
                controller: 'OvertimeConfirmationCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    overtimeStatus: function () {
                        return vm.isEmployeeAllowedOvertime;
                    },
                    employeeId: function () {
                        return vm.user.id;
                    }
                }
            }).result.then(function () {
                vm.isEmployeeAllowedOvertime = !vm.isEmployeeAllowedOvertime;
                vm.profileActions.changeOvertimeStatus.willBeSelected = !vm.profileActions.changeOvertimeStatus.willBeSelected;
                vm.profileActions.changeOvertimeStatus.name = vm.profileActions.changeOvertimeStatus.willBeSelected === true ? "Allowed Overtime " : "Disallowed Overtime";
                $scope.$emit("overtime-status-changed", vm.isEmployeeAllowedOvertime);
                toastrService.showSuccessToastr("Overtime status changed");
            });

        }

        function openIncludeInAttendanceReportModal() {
            toastrService.clearPreviousToastr();
            if (!includeInAttendanceReportAvailable()) return;
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/includeInAttendanceReport/includeInAttendanceReport.modal.html',
                controller: 'IncludeInAttendanceReportCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    user: function () {
                        return vm.user;
                    },
                    loggedInUser: function () {
                        return authService.getLoggedInUser()
                    }
                }

            }).result.then(function () {

                vm.profileActions.includeInAttendanceReport.willBeSelected = !vm.profileActions.includeInAttendanceReport.willBeSelected;
                vm.profileActions.includeInAttendanceReport.name = vm.profileActions.includeInAttendanceReport.willBeSelected ? 'Included in Attendance' : 'Excluded from Attendance';
                vm.user.includeInAttendanceReport = !vm.user.includeInAttendanceReport;
            });
        }

        function enrolFingerprint() {
            $scope.$emit("profile-action-switch-to-enrol-tab");
        }

        function openApplyForLeaveModal() {
            $scope.$emit('leave-management-apply');
        }

        function openChangeStatusModal() {
            toastrService.clearPreviousToastr();
            if (authService.getLoggedInId() == vm.user.id) {
                return toastrService.showErrorToastr("Cannot change status of ownself");
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/changeStatusModal/changeStatusModal.html',
                size: 'md',
                controller: 'ChangeStatusModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    empId: function () {
                        return vm.user.id
                    },
                    empName: function () {
                        return vm.user.name
                    },
                    changeStatusTo: function () {
                        return vm.user.status === 1 ? 0 : 1;
                    }
                }
            }).result.then(function (changeStatusTo) {
                $scope.$emit("employee-status-changed", changeStatusTo);
            }, function () {
            });
        }

        function syncEmployee() {
            employeeService.syncThirdPartyEmployees({thirdPartyIdList:vm.user.employeeOfficeId.toString()}).then(function (responseData) {
                toastrService.showSuccessToastr('Sync complete');
                var idFoundFromResponse = responseData[vm.user.employeeOfficeId].employeeId;
                if(vm.user.id != idFoundFromResponse)
                    $state.go('profile',{employeeId: idFoundFromResponse});
                else
                    $state.go($state.current,{employeeId : idFoundFromResponse},{reload : true});
            },function (error) {
                toastrService.showErrorToastr('Error: ' + error, "", 5000);
            })
        }

        function openDeleteModal() {
            toastrService.clearPreviousToastr();
            if (authService.getLoggedInId() == vm.user.id) {
                return toastrService.showErrorToastr("Cannot delete ownself");
            }
            var data = [vm.user.id];
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/employees/manage/actions/deleteEmployeeModal/deleteEmployeeModal.html',
                size: 'md',
                controller: 'DeleteEmployeeModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    idList: function () {
                        return data;
                    }
                }
            }).result.then(function () {
                toastrService.showSuccessToastr("Employee successfully deleted");
                $state.go('employees.manageEmployees');
            }, function () {

            });
        }

        function openResignEmployeeModal() {
            toastrService.clearPreviousToastr();
            if (!resignEmployeeAvailable()) return;
            if (authService.getLoggedInId() == vm.user.id) {
                return toastrService.showErrorToastr("Cannot resign ownself");
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/resignEmployee/ResignEmployee.action.modal.html',
                controller: 'ResignEmployeeModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    }
                }
            }).result.then(function () {
                $state.go('employees.manageEmployees');
            }, function () {

            });

        }

        function openRehireEmployeeModal() {
            toastrService.clearPreviousToastr();
            if (!resignEmployeeAvailable()) return;
            if (authService.getLoggedInId() == vm.user.id) {
                return toastrService.showErrorToastr("Cannot rehire ownself");
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/rehireEmployee/RehireEmployee.action.modal.html',
                controller: 'RehireEmployeeModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    }
                }
            }).result.then(function () {
                $state.go('employees.manageEmployees');
                // $state.go('profile', {'employeeId' : vm.user.id});
                // location.reload();
            }, function () {

            });

        }

        function openApplyForLateApprovalModal() {
            toastrService.clearPreviousToastr();
            var data = vm.user.id;
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/late-approval/apply/applyForLateApproval.modal.html',
                size: 'md',
                controller: 'ApplyForLateApprovalModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    employeeId: function () {
                        return data;
                    }
                }
            }).result.then(function () {
                toastrService.showSuccessToastr("Application successful.");
            }, function () {
            });
        }

        function openApplyForHalfDayLeaveModal() {
            toastrService.clearPreviousToastr();
            var data = vm.user.id;
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/leave/halfDay/apply/applyForHalfDayLeave.html',
                size: 'md',
                controller: 'ApplyForHalfDayLeaveModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    employeeId: function () {
                        return data;
                    }
                }
            }).result.then(function () {
                toastrService.showSuccessToastr("Applilcation successful.");
            }, function () {

            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DocumentsCtrl', ['employeeService','$scope','$stateParams','$uibModal','authService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DocumentsCtrl]);

    /** @ngInject */
    function DocumentsCtrl(employeeService,$scope,$stateParams,$uibModal,authService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isDataLoaded = false;
        var loggedInUser = authService.getLoggedInUser();
        var isAdmin = authService.isAdmin();
        var userId = $stateParams.employeeId && (isAdmin || loggedInUser.isLineManager)? $stateParams.employeeId : loggedInUser.id;
        vm.documentList = [];
        vm.isGeneralEmployee = authService.isEmployeeOnly();
        vm.isGeneralEmployeeOrLineManager = authService.isGeneralEmployeeOrLineManager();


        vm.analyticsDownloadUrl = analyticsDownloadUrl;
        vm.openDeleteModal = openDeleteModal;
        vm.openCreateModal = openCreateModal;

        function analyticsDownloadUrl(){
            analyticsService.sendData(ANALYTICS_CONSTANT.employeeDocuments, 'Employee Documents - Download', 'download', 'Download In' + document.title, ANALYTICS_CONSTANT.download)
        }

        function init() {
            employeeService.getEmployeeDocuments(userId).then(function (data) {
                vm.documentList = data;
                vm.isDataLoaded = true;
            },function (error) {
                toastrService.showErrorToastr("Could not fetch education histories:" + error, "", 5000);
            })
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/documentUpload/documentUpload.modal.html',
                controller: 'DocumentUploadModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return userId;
                    }
                }
            }).result.then(function (documents) {
                vm.documentList = documents;
            }, function () {
                console.log("Document upload modal dismissed.");
            });
        }
        
        function openDeleteModal(documentId) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/document/delete/deleteModal.html',
                size: 'md',
                controller: 'DeleteDocumentModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    documentId: function () {
                        return documentId;
                    }
                }
            }).result.then(function (data) {
                vm.documentList = data;
            },function () {

            });
        }
        init();
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfileDetailsAccordionCtrl', ['$filter', '$anchorScroll', 'authService', '$scope', '$location', '$q', '$timeout', 'employeeService','BLOOD_GROUP', 'toastrService','utilService', ProfileDetailsAccordionCtrl]);

    /** @ngInject */
    function ProfileDetailsAccordionCtrl($filter, $anchorScroll, authService, $scope, $location, $q, $timeout, employeeService, BLOOD_GROUP, toastrService,utilService) {
        var vm = this;
        vm.user = null;
        vm.isAdmin = authService.isAdmin();
        vm.hasPermission = utilService.hasPermission;
        var officeId = authService.getLoggedInUser().office.id;
        var loggedInUser = authService.getLoggedInUser();
        vm.isGeneralEmployeeOrLineManager = authService.isGeneralEmployeeOrLineManager();
        vm.canEditPermission = false;
        init();

        $scope.$on("profile-info-loaded", function (event, userData) {
            vm.user = userData;
            vm.isDataReady = true;
            vm.canEditPermission = !(vm.user.id !== loggedInUser.id && vm.isGeneralEmployeeOrLineManager)

        });

        function init() {
            vm.profileTabs = [
                {
                    name: 'General Information',
                    isActive : true,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[0].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'general');
                    }
                },
                {
                    name: 'Approver Information',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[1].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'approver');
                    }
                },
                {
                    name: 'Personal & Contact Info',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[2].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'personal');
                    }
                },
                {
                    name: 'Address',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[3].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'address');
                    }
                },
                {
                    name: 'Change Password',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[4].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'changePass');
                    }
                },
                {
                    name: 'Documents',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[5].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'documents');
                    }
                },
                {
                    name: 'Employment History',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[6].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'employment');
                    }
                },
                {
                    name: 'Education History',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[7].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'education');
                    }
                },
                {
                    name: 'Employee Documents',
                    isActive : false,
                    isVisible: true,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[8].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'documents');
                    }
                },
                {
                    name: 'Project Dedication',
                    isActive : false,
                    isVisible: officeId == 116,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[9].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'project');
                    }
                },
                {
                    name: 'Project Dedication',
                    isActive : false,
                    isVisible: officeId !== 116 && (utilService.hasPermission("10001") || utilService.hasPermission("100011")),
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[10].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'project-work');
                    }
                },
                {
                    name: 'Notification Settings',
                    isActive : false,
                    isVisible: vm.isAdmin,
                    action: function () {
                        allTabsReset();
                        vm.profileTabs[11].isActive = true;
                        $scope.$parent.$broadcast("profile-info-tab-change", 'notification-settings');
                    }
                }
            ];

        }
        function allTabsReset()
        {
            for(var i=0; i<vm.profileTabs.length; i++) vm.profileTabs[i].isActive = false;
        }

        $scope.$on("show-change-password-tab", function () {
            allTabsReset();
            vm.profileTabs[4].isActive = true;
        });
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EmploymentHistoryCtrl', ['employeeService', '$scope', '$stateParams', '$uibModal', 'authService', 'toastrService', EmploymentHistoryCtrl]);

    /** @ngInject */
    function EmploymentHistoryCtrl(employeeService, $scope, $stateParams, $uibModal, authService, toastrService) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        var userId = $stateParams.employeeId;
        vm.userId = userId;
        vm.isEmploymentHistoryLoaded = false;
        vm.employmentHistoryList = [];
        vm.isGeneralEmployee = authService.isEmployeeOnly();
        vm.isGeneralEmployeeOrLineManager = authService.isGeneralEmployeeOrLineManager();


        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.openCreateModal = openCreateModal;

        init();

        function init() {
            $scope.$on("open-employment-add-modal", function (event, data) {
                openCreateModal();
            });

            employeeService.getEmployeeEmploymentHistories(vm.userId).then(function (data) {
                vm.employmentHistoryList = data;
                vm.isEmploymentHistoryLoaded = true;

            }, function (error) {
                toastrService.showErrorToastr("Could not fetch employment histories", "", 5000);
            });

        }

        function openEditModal(history) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/employment/editModal/edit.modal.html',
                size: 'md',
                controller: 'EditEmploymentModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                userId: userId,
                resolve: {
                    history: function () {
                        return history;
                    }
                }
            }).result.then(function (data) {
                vm.employmentHistoryList = data;
            }, function () {

            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/employment/createModal/create.modal.html',
                size: 'md',
                controller: 'CreateEmploymentModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return userId;
                    }
                }
            }).result.then(function (data) {
                vm.employmentHistoryList = data;
            }, function () {

            });
        }

        function openDeleteModal(history) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/employment/deleteModal/delete.modal.html',
                size: 'md',
                controller: 'DeleteEmploymentModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                userId: userId,
                resolve: {
                    history: function () {
                        return history;
                    }
                }
            }).result.then(function (data) {
                vm.employmentHistoryList = data;
            }, function () {

            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EducationHistoryCtrl', ['employeeService', '$scope', '$stateParams', '$uibModal', 'authService', 'toastrService', EducationHistoryCtrl]);

    /** @ngInject */
    function EducationHistoryCtrl(employeeService, $scope, $stateParams, $uibModal, authService, toastrService) {

        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        var isAdmin = authService.isAdmin();
        var userId = $stateParams.employeeId;
        vm.isEducationHistoryLoaded = false;
        vm.educationHistoryList = [];
        vm.isGeneralEmployee = authService.isEmployeeOnly();
        vm.isGeneralEmployeeOrLineManager = authService.isGeneralEmployeeOrLineManager();

        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.openCreateModal = openCreateModal;


        function init() {
            $scope.$on("open-education-add-modal", function (event, data) {
                openCreateModal();
            });

            employeeService.getEmployeeEducationHistories(userId).then(function (data) {
                vm.educationHistoryList = data;
                vm.isEducationHistoryLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Could not fetch education histories: " + error, "", 5000);
            });
        }

        function openEditModal(history) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/education/editModal/edit.modal.html',
                size: 'md',
                controller: 'EditEducationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                userId: userId,
                resolve: {
                    history: function () {
                        return history;
                    }
                }
            }).result.then(function (data) {
                vm.educationHistoryList = data;
            }, function () {

            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/education/createModal/create.modal.html',
                size: 'md',
                controller: 'CreateEducationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return userId;
                    }
                }
            }).result.then(function (data) {
                vm.educationHistoryList = data;
            }, function () {

            });
        }

        function openDeleteModal(history) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/education/deleteModal/delete.modal.html',
                size: 'md',
                controller: 'DeleteEducationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                userId: userId,
                resolve: {
                    history: function () {
                        return history;
                    }
                }
            }).result.then(function (data) {
                vm.educationHistoryList = data;
            }, function () {

            });
        }

        init();
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('GeneralInfoCtrl', ['MODULES', '$filter', '$scope', '$q', '$uibModal', 'authService',  'departmentService', 'subDepartmentService', 'designationService','siteManagementService', 'employeeService', 'shiftService', 'shiftGroupService', 'leavePolicyService','weeklyOffDaysService', 'leaveManagementService','GENDER','BLOOD_GROUP','utilService', 'toastrService', 'lateApprovalManagementService','workplaceService','employmentTypeService','subsidiaryService','_', 'analyticsService', 'ANALYTICS_CONSTANT', 'passwordValidatorService', 'LINE_MANAGER_MODULE',GeneralInfoCtrl]);

    /** @ngInject */
    function GeneralInfoCtrl(MODULES, $filter, $scope, $q, $uibModal, authService,  departmentService,subDepartmentService, designationService,siteManagementService, employeeService, shiftService, shiftGroupService, leavePolicyService, weeklyOffDaysService, leaveManagementService,GENDER,BLOOD_GROUP,utilService,toastrService, lateApprovalManagementService,workplaceService,employmentTypeService,subsidiaryService,_, analyticsService, ANALYTICS_CONSTANT, passwordValidatorService, LINE_MANAGER_MODULE) {
        var vm = this;
        vm.user = null;
        vm.firstLeaveApprover = [];
        vm.secondLeaveApprover = [];
        vm.firstLateApprover = [];
        vm.secondLateApprover = [];
        vm.firstManualEntryApprover = [];
        vm.secondManualEntryApprover = [];
        vm.canLineManagerAssignShiftGroup = utilService.canLineManagerAssignShiftGroup();

        vm.hasPermission = utilService.hasPermission;
        vm.designationList = [];
        vm.siteList=[];
        vm.departmentList = [];
        vm.subDepartmentList = [];
        vm.employmentTypeList = [];
        vm.shiftList = [];
        vm.shiftGroupList = [];
        vm.genderList = GENDER;
        vm.leavePolicyList = [];
        vm.workplaceList = [];
        vm.subsidiaryList = [];
        vm.weeklyOffDaysPolicyList = [];
        vm.selectedEmployees = [];
        vm.allEmployees = [];
        vm.allFirstLeaveApprover = [];
        vm.allSecondLeaveApprover = [];
        vm.hrManagerEmployees = [];
        vm.lineManagerEmployees = [];
        vm.siteMap={};
        vm.isDataReady = null;
        vm.isAddressDataLoaded = false;

        // Storage for all unfiltered lists (for subsidiary filtering)
        vm.allDesignationList = [];
        vm.allDepartmentList = [];
        vm.allEmploymentTypeList = [];
        vm.allShiftGroupList = [];
        vm.allWorkplaceList = [];

                // NEW: Line Manager (2017) permission gate
                    vm.canAssignLineManager = utilService.hasPermission(LINE_MANAGER_MODULE); // don't use 2017 during test
                vm.openUpgradeForLineManager = openUpgradeForLineManager;

        vm.showDepartment = showDepartment;
        vm.showSubDepartment = showSubDepartment;
        vm.showDesignation = showDesignation;
        vm.showEmploymentType = showEmploymentType;
        vm.showWorkplace = showWorkplace;
        vm.showShift = showShift;
        vm.showShiftGroup = showShiftGroup;
        vm.showGender = showGender;
        vm.showLeavePolicy = showLeavePolicy;
        vm.showWeeklyOffdayPolicy = showWeeklyOffdayPolicy;
        vm.updateName = updateName;
        vm.updateEmail = updateEmail;
        vm.updateDesignation = updateDesignation;
        vm.updateEmploymentType = updateEmploymentType;
        vm.updateWorkplace = updateWorkplace;
        vm.updateSubsidiary = updateSubsidiary;
        vm.showSubsidiary = showSubsidiary;
        vm.updateDepartment = updateDepartment;
        vm.updateSubDepartment = updateSubDepartment;
        vm.updateShift = updateShift;
        vm.updateShiftGroup = updateShiftGroup;
        vm.updateGender = updateGender;
        vm.updateLeavePolicy = updateLeavePolicy;
        vm.updateWeeklyOffdayPolicy = updateWeeklyOffdayPolicy;
        vm.updateFirstLeaveApprover = updateFirstLeaveApprover;
        vm.updateSecondLeaveApprover = updateSecondLeaveApprover;
        vm.updatePrimaryText = updatePrimaryText;
        vm.updateSecondaryText = updateSecondaryText;
        vm.updateRfid = updateRfid;
        vm.updateReportPosition = updateReportPosition;
        vm.updateEmployeeOfficeId = updateEmployeeOfficeId;
        vm.updateIdentifier = updateIdentifier;
        vm.updateFirstLateApprover = updateFirstLateApprover;
        vm.updateSecondLateApprover = updateSecondLateApprover;

        // Manual Entry approver Informations start
        vm.updateFirstManualEntryApprover = updateFirstManualEntryApprover;
        vm.updateSecondManualEntryApprover = updateSecondManualEntryApprover;
        // Manual Entry approver information ends

        vm.showLineManager = showLineManager;
        vm.showHrManager = showHrManager;
        vm.openAddAddressModal = openAddAddressModal;
        vm.openDeleteAddressModal = openDeleteAddressModal;
        vm.updateLineManager = updateLineManager;
        vm.updateHrManager = updateHrManager;
        vm.updateSite=updateSite;
        var loggedInuser = authService.getLoggedInUser();
        vm.isAdmin = authService.isAdmin();
        vm.isChangedPasswordOpen = false;
        vm.changePass = {};
        vm.changePass.passwordText = null;
        vm.changePass.confirmPasswordText = null;
        vm.bloodGroupList = BLOOD_GROUP;
        vm.addressTypeList = {};
        vm.addressTypeList.list = [{
            type: 'Permanent',
            value: 1
        }, {
            type: 'Present',
            value: 2
        }
        ];
        vm.isSubsidiaryActivated = loggedInuser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSubsidiaryAdmin = vm.isSubsidiaryActivated && loggedInuser.isAdmin && loggedInuser.subsidiaryId != null;
        vm.isSuperAdmin = vm.isSubsidiaryActivated && loggedInuser.isAdmin && loggedInuser.subsidiaryId == null;
        vm.opened = {};
        vm.updatePasswordFunction = updatePasswordFunction;
        vm.updateFathersName = updateFathersName;
        vm.updateMothersName = updateMothersName;
        vm.updatePhoneOffice = updatePhoneOffice;
        vm.updateNidNumber = updateNidNumber;
        vm.showBloodGroup = showBloodGroup;
        vm.updateBloodGroup = updateBloodGroup;
        vm.updatePhoneHome = updatePhoneHome;
        vm.updatePhoneMobile = updatePhoneMobile;
        vm.updateEducationHistory = updateEducationHistory;
        vm.updateEmploymentHistory = updateEmploymentHistory;
        vm.open = open;
        vm.updateDateOfBirth = updateDateOfBirth;
        vm.updateDateOfJoin = updateDateOfJoin;
        vm.updateDateOfResignation = updateDateOfResignation;
        vm.updateAddress = updateAddress;
        vm.showSite=showSite;
        vm.checkPasswordValidation=checkPasswordValidation;
        vm.blockedPasses = [];
        vm.passStrengthClass = 'text-danger';
        vm.passStrengthText = 'Poor';
        vm.passSchemaInfo = passwordValidatorService.getPasswordSchemaInfo();
        vm.needOldPass = true;
        vm.oldPass = null;

        vm.adminOnly = vm.isAdmin;
        vm.lineManagerAndUp = vm.isAdmin || loggedInuser.isLineManager;
        vm.everyone = true;
        vm.isSiteEnabled = loggedInuser['modules'].includes(MODULES.SITE_MANAGEMENT);
        vm.passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
        vm.isGeneralEmployee = authService.isEmployeeOnly();
        vm.isGeneralEmployeeOrLineManager = authService.isGeneralEmployeeOrLineManager();
        vm.canThisLineManagerAssignShiftGroup = false;

        $scope.$on("profile-info-loaded", function (event, userData) {
            vm.user = userData;

            vm.blockedPasses = [vm.user.id, vm.user.name, vm.user.email, vm.user.employeeIdentifier, vm.user.rfid, loggedInuser.id, loggedInuser.name, loggedInuser.email, loggedInuser.employeeIdentifier, loggedInuser.rfid];
            vm.isThisLineManagerAllowedShiftManagement = $scope.isThisLineManagerAllowedShiftManagement;
            if(utilService.canLineManagerAssignShiftGroup() && vm.isThisLineManagerAllowedShiftManagement)
                vm.canThisLineManagerAssignShiftGroup = true;
            vm.isDataReady = true;
            vm.isSameUser = loggedInuser.id === vm.user.id
            vm.needOldPass = vm.isSameUser ? true : !vm.isAdmin;
            if (!vm.isGeneralEmployee) getAllEmployeeNames();
            if (vm.user.employeeDetails && vm.user.employeeDetails.dateOfBirth) vm.user.employeeDetails.dateOfBirthDisplay = new Date(vm.user.employeeDetails.dateOfBirth);

            // Apply subsidiary filtering if user has subsidiaryId
            if (vm.user.subsidiaryId && loggedInuser['modules'].includes(MODULES.SUBSIDIARY) && loggedInuser.isAdmin && loggedInuser.subsidiaryId == null) {

                filterDataBySubsidiary(vm.user.subsidiaryId);
            } else {
                //console.log("User does NOT have subsidiaryId - no filtering applied");
            }
        });

        // function canLineManagerAssignShiftGroup() {
        //     if (authService.getLoggedInUser().isLineManager && utilService.hasPermission('5009')) {
        //         vm.canLineManagerAssignShiftGroup = true;
        //     }
        //     console.log(vm.canLineManagerAssignShiftGroup);
        // }

        // Filter lists based on subsidiaryId
        function filterDataBySubsidiary(subsidiaryId) {
            if (!subsidiaryId || subsidiaryId === -1 || subsidiaryId === null) {
                return; // No filtering needed
            }

            // Filter designation list
            if (vm.allDesignationList && vm.allDesignationList.length > 0) {
                vm.designationList = vm.allDesignationList.filter(function(designation) {
                    return designation.subsidiaryId === subsidiaryId || designation.id === 0;
                });
            }

            // Filter department list
            if (vm.allDepartmentList && vm.allDepartmentList.length > 0) {
                vm.departmentList = vm.allDepartmentList.filter(function(department) {
                    return  department.subsidiaryId === subsidiaryId || department.id === 0;
                });
            }

            // Filter shift group list
            if (vm.allShiftGroupList && vm.allShiftGroupList.length > 0) {
                vm.shiftGroupList = vm.allShiftGroupList.filter(function(shiftGroup) {
                    return shiftGroup.subsidiaryId === subsidiaryId;
                });
            }

            // Filter employment type list
            if (vm.allEmploymentTypeList && vm.allEmploymentTypeList.length > 0) {
                vm.employmentTypeList = vm.allEmploymentTypeList.filter(function(employmentType) {
                    return  employmentType.subsidiaryId === subsidiaryId || employmentType.id === 0;
                });
            }

            // Filter workplace list
            if (vm.allWorkplaceList && vm.allWorkplaceList.length > 0) {
                vm.workplaceList = vm.allWorkplaceList.filter(function(workplace) {
                    return workplace.subsidiaryId === subsidiaryId || workplace.id === -1;
                });
            }
        }

        // Load all data and store in "all" variables for filtering
        function loadAllData() {
            designationService.getAllDesignations().then(function (designationList) {
                vm.allDesignationList = _.sortBy(designationList,[function (designation) { return designation.name.toLowerCase(); }]);
                vm.allDesignationList.unshift({ id: 0, name: 'Not Set' });
                vm.designationList = angular.copy(vm.allDesignationList);

                // Apply filtering if user has subsidiaryId
                if (vm.user && vm.user.subsidiaryId && loggedInuser['modules'].includes(MODULES.SUBSIDIARY) && loggedInuser.isAdmin && loggedInuser.subsidiaryId == null) {

                    vm.designationList = vm.allDesignationList.filter(function(designation) {
                        return designation.subsidiaryId === vm.user.subsidiaryId || designation.id === 0;
                    });
                } else {
                    // console.log("No filtering - vm.user:", !!vm.user, "subsidiaryId:", vm.user ? vm.user.subsidiaryId : 'N/A');
                }
            }, function (message) {
                // console.error("failed to load designation list : " + message);
            });

            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.allEmploymentTypeList = _.sortBy(employmentTypeList,[function (employmentType) { return employmentType.name.toLowerCase(); }]);
                vm.allEmploymentTypeList.unshift({ id: 0, name: 'Not Set' });
                vm.employmentTypeList = angular.copy(vm.allEmploymentTypeList);

                // Apply filtering if user has subsidiaryId
                if (vm.user && vm.user.subsidiaryId) {
                    vm.employmentTypeList = vm.allEmploymentTypeList.filter(function(employmentType) {
                        return employmentType.subsidiaryId === vm.user.subsidiaryId || employmentType.id === 0;
                    });
                }
            }, function (message) {
                // console.error("failed to load employment type list : " + message);
            });

            departmentService.getAllDepartments().then(function (departmentList) {
                vm.allDepartmentList = _.sortBy(departmentList,[function(department) { return department.name.toLowerCase(); }]);
                vm.allDepartmentList.unshift({ id: 0, name: 'Not Set' });
                vm.departmentList = angular.copy(vm.allDepartmentList);

                // Apply filtering if user has subsidiaryId
                if (vm.user && vm.user.subsidiaryId) {
                    vm.departmentList = vm.allDepartmentList.filter(function(department) {
                        return department.subsidiaryId === vm.user.subsidiaryId || department.id === 0;
                    });
                }
            }, function (message) {
                // console.error("failed to load departmentList : " + message);
            });

            subDepartmentService.getAllSubDepartments().then(function (subDepartmentList) {
                vm.subDepartmentList = _.sortBy(subDepartmentList,[function(subDepartment) { return subDepartment.name.toLowerCase(); }]);
                vm.subDepartmentList.unshift({ id: 0, name: 'Not Set' });
            }, function (message) {
                // console.error("failed to load subDepartmentList : " + message);
            });

            shiftGroupService.getAllShiftGroups().then(function (shiftGroupList) {
                vm.allShiftGroupList = _.sortBy(shiftGroupList,[function(shiftGroup) { return shiftGroup.name.toLowerCase(); }]);
                vm.shiftGroupList = angular.copy(vm.allShiftGroupList);

                // Apply filtering if user has subsidiaryId
                if (vm.user && vm.user.subsidiaryId) {
                    vm.shiftGroupList = vm.allShiftGroupList.filter(function(shiftGroup) {
                        return shiftGroup.subsidiaryId === vm.user.subsidiaryId;
                    });
                }
            }, function (message) {
                // console.error("failed to load shift groups : " + message);
            });

            leavePolicyService.getAllLeavePolicies().then(function (leavePolicyList) {
                vm.leavePolicyList = _.sortBy(leavePolicyList,[function(leavePolicy) { return leavePolicy.name.toLowerCase(); }]);
            }, function (error) {
                console.error(error);
            });

            workplaceService.getAllWorkplaces().then(function (workplaceList) {
                vm.allWorkplaceList = _.sortBy(workplaceList,[function(workplace) { return workplace.name.toLowerCase(); }]);
                vm.allWorkplaceList.unshift({id:-1,name:"Not Set"});
                vm.workplaceList = angular.copy(vm.allWorkplaceList);

                // Apply filtering if user has subsidiaryId
                if (vm.user && vm.user.subsidiaryId) {
                    vm.workplaceList = vm.allWorkplaceList.filter(function(workplace) {
                        return workplace.subsidiaryId === vm.user.subsidiaryId || workplace.id === -1;
                    });
                }
            }, function (error) {
                // console.log(error);
            });

            if(vm.isSubsidiaryActivated) {
                subsidiaryService.getAllSubsidiaries().then(function (subsidiaries) {
                    vm.subsidiaryList = _.sortBy(subsidiaries, [function(subsidiary) { return subsidiary.name.toLowerCase(); }]);
                    vm.subsidiaryList.unshift({id:-1,name:"Not Set"})
                }, function (error) {
                    // console.error("Failed to load subsidiaries: " + error);
                });
            }
        }

        function init() {
            if (!vm.isGeneralEmployee ) {
                loadAllData();
            }

            siteManagementService.getAllSites().then(function (siteList) {
                vm.siteList = _.sortBy(siteList,[function (site) { return site.siteList; }]);
                vm.siteList = vm.siteList[1];
            }, function (message) {
                console.error("failed to load site list : " + message);
            });

            vm.profileTabsContent = {
                'general': true,
                'approver': false,
                'personal': false,
                'address': false,
                'changePass': false,
                'documents': false,
                'employment': false,
                'education': false,
                'document': false,
                'project': false,
                'project-work' : false,
                'notification-settings' : false
            };
        }

        $scope.$on('profile-info-tab-change', function (event, tab) {
            if (tab && typeof vm.profileTabsContent[tab] !== 'undefined') {
                allTabsContentReset();
                vm.profileTabsContent[tab] = true;
            }
            if (tab === 'personal') {
                if (!vm.user.employeeDetails) {
                    employeeService.getEmployeeDetails(vm.user.id).then(function (empDetails) {
                        vm.user.employeeDetails = empDetails;
                        if (!!vm.user.employeeDetails && !!vm.user.employeeDetails.dateOfBirth) vm.user.employeeDetails.dateOfBirthDisplay = new Date(vm.user.employeeDetails.dateOfBirth);
                        // $scope.$emit("profile-updated", {key: "employeeDetails", value: empDetails});
                    }, function (err) {
                        console.error(err);
                    });
                }
            } else if (tab === 'address') {
                if (!vm.user.addresses) {
                    employeeService.getEmployeeAddresses(vm.user.id).then(function (addressList) {
                        vm.user.addresses = addressList;
                        vm.isAddressDataLoaded = true;
                        $scope.$emit("profile-updated", {key: "addresses", value: addressList});
                    }, function (err) {
                        console.error(err);
                    });
                }
            }
        });
        $scope.$on("change-password-action-clicked", function () {
            $location.hash('passwordReset');
            vm.isChangedPasswordOpen = !vm.isChangedPasswordOpen;
            $anchorScroll();
            $location.hash('');
        });
        $scope.$on("open-add-address-modal", function (event, userData) {
            openAddAddressModal();
        });

        init();

                // NEW: Open upgrade modal when LM module is not permitted
                    function openUpgradeForLineManager() {
                           $uibModal.open({
                                    animation: true,
                                    templateUrl: 'app/pages/main/upgradePopup.html',
                                    controller: 'UpgradePopupModalCtrl',
                                    controllerAs: 'vm',
                                    size: 'lg',
                                    backdrop: 'static'
                            });
                        }

        function checkPasswordValidation(pattern){
            var value = passwordValidatorService.getStrengthInfo(vm.changePass.passwordText, vm.blockedPasses);
            vm.passStrengthText = value.text;
            vm.passStrengthClass = value.class;

            return passwordValidatorService.validatePasswordFunction(pattern, vm.changePass.passwordText, vm.blockedPasses);
        }

        function allTabsContentReset() {
            vm.profileTabsContent = {
                'general': false,
                'approver': false,
                'personal': false,
                'address': false,
                'changePass': false,
                'documents': false,
                'employment': false,
                'education': false,
                'project': false,
                'project-work': false,
                'notification-settings' : false
            }
        }

        function getAllEmployeeNames() {
            if (!utilService.isEmptyArray(vm.allEmployees)) return;
            var params = {
                officeId: [loggedInuser.office.id],
                status: [1],
                excludedEmployeeIds: [vm.user.id]
            };
            employeeService.getFilteredEmployeeNames(params).then(function (data) {
                // vm.allEmployees = data.employees;
                vm.allEmployees = _.sortBy(data.employees,[function(employee) { return employee.name.toLowerCase(); }]);
                vm.allEmployees.unshift({id: -1, name: "Not Assigned"});
                vm.allFirstLeaveApprover = angular.copy(vm.allEmployees);
                vm.allSecondLeaveApprover = angular.copy(vm.allEmployees);
                vm.allFirstLateApprover = angular.copy(vm.allEmployees);
                vm.allSecondLateApprover = angular.copy(vm.allEmployees);
                vm.allFirstManualEntryApprover = angular.copy(vm.allEmployees);
                vm.allSecondManualEntryApprover = angular.copy(vm.allEmployees);

                //Preselect first leave approver
                if(vm.user.firstApproverId){
                    vm.allFirstLeaveApprover.find(function (emp){
                    if(emp.id === vm.user.firstApproverId)
                        emp.ticked = true
                    })
                }else vm.allFirstLeaveApprover[0].ticked = true

                //Preselect second leave approver
                if(vm.user.secondApproverId){
                    vm.allSecondLeaveApprover.find(function (emp){
                        if(emp.id === vm.user.secondApproverId)
                            emp.ticked = true
                    })
                }else vm.allSecondLeaveApprover[0].ticked = true

                //Preselect first late approver
                if(vm.user.firstLateApproverId){
                    vm.allFirstLateApprover.find(function (emp){
                        if(emp.id === vm.user.firstLateApproverId)
                            emp.ticked = true
                    })
                }else vm.allFirstLateApprover[0].ticked = true

                //Preselect second late approver
                if(vm.user.secondLateApproverId){
                    vm.allSecondLateApprover.find(function (emp){
                        if(emp.id === vm.user.secondLateApproverId)
                            emp.ticked = true
                    })
                }else vm.allSecondLateApprover[0].ticked = true

                //Preselect first manual entry approver
                if(vm.user.firstManualEntryApproverId){
                    vm.allFirstManualEntryApprover.find(function (emp){
                        if(emp.id === vm.user.firstManualEntryApproverId)
                            emp.ticked = true
                    })
                }else vm.allFirstManualEntryApprover[0].ticked = true

                //Preselect second manual entry approver
                if(vm.user.secondManualEntryApproverId){
                    vm.allSecondManualEntryApprover.find(function (emp){
                        if(emp.id === vm.user.secondManualEntryApproverId)
                            emp.ticked = true
                    })
                }else vm.allSecondManualEntryApprover[0].ticked = true


                vm.hrManagerEmployees = vm.allEmployees.filter(function (e) {
                    return e.isHrManager
                });
                vm.lineManagerEmployees = vm.allEmployees.filter(function (e) {
                    return e.isLineManager
                });
                vm.lineManagerEmployees.unshift({id: -1, name: "Not Assigned"});
                vm.hrManagerEmployees.unshift({id: -1, name: "Not Assigned"});
            }, function (error) {
                toastrService.showErrorToastr("Failed to fetch employee information: " + error, "", 5000);
                // console.error("Failed to fetch all employees : " + error);
            });
        }


        function showDepartment() {
            if (!vm.user) return 'No Data';
            var selected = [];

            if (Array.isArray(vm.departmentList)) {
                selected = vm.departmentList.filter(function(item) {
                    return item.id === (!!vm.user.department ? vm.user.department.id : -1);
                });
            }
            return (!!vm.user.department && selected && selected.length) ? selected[0].name : 'Not Set';
        }
        function showSubDepartment() {
            if (!vm.user || !Array.isArray(vm.subDepartmentList)) return 'No Data';
            var selected = vm.subDepartmentList.filter(function(item) {
              return item.id === (!!vm.user.subDepartment ? vm.user.subDepartment.id : -1);
            });
            return (!!vm.user.subDepartment && selected.length > 0) ? selected[0].name : 'Not Set';
          }
          
          function showDesignation() {
            if (!vm.user || !Array.isArray(vm.designationList)) return 'No Data';
            var selected = vm.designationList.filter(function(item) {
              return item.id === (!!vm.user.designation ? vm.user.designation.id : -1);
            });
            return (!!vm.user.designation && selected.length > 0) ? selected[0].name : 'Not Set';
          }
          
        function showSite() {
            for (var key in vm.siteList){
                vm.siteMap[vm.siteList[key].id]=vm.siteList[key].name
            }
            if (!vm.user) return 'No Data';
            // var selected = $filter('filter')(vm.siteMap, {id: vm.user.siteId ? vm.user.siteId : -1});
            return (!!vm.user.siteId) ? vm.siteMap[vm.user.siteId] : 'Not Set';
        }

        function showEmploymentType() {
            if (!vm.user || !vm.user.employmentTypeId) return 'Not Set';
            var selected = vm.employmentTypeList.find(function (employmentType) {
                return employmentType.id == vm.user.employmentTypeId;
            });
            if(selected) return selected.name;
            return 'Not Set';
            // var selected = $filter('filter')(vm.designationList, {id: vm.user.designation ? vm.user.designation.id : -1});
            // return (vm.user.designation && selected && selected.length) ? selected[0].name : 'Not Set';
        }

        function showWorkplace() {
            if (!vm.user || !Array.isArray(vm.workplaceList)) return 'No Data';
            var selected = vm.workplaceList.filter(function(item) {
              return item.id === (!!vm.user.workplace ? vm.user.workplace.id : -1);
            });
            return (!!vm.user.workplace && selected.length > 0) ? selected[0].name : 'Not Set';
          }
          
          function showSubsidiary() {
            if (!vm.user || !Array.isArray(vm.subsidiaryList)) return 'No Data';
            var subsidiaryId = vm.user.subsidiary ? vm.user.subsidiary.id : (vm.user.subsidiaryId ? vm.user.subsidiaryId : -1);
            var selected = vm.subsidiaryList.filter(function(item) {
              return item.id === subsidiaryId;
            });
            return (selected && selected.length > 0) ? selected[0].name : 'Not Set';
          }

          function showShift() {
            if (!vm.user || !Array.isArray(vm.shiftList)) return 'No Data';
            var selected = vm.shiftList.filter(function(item) {
              return item.id === (!!vm.user.shift ? vm.user.shift.id : -1);
            });
            return (!!vm.user.shift && selected.length > 0) ? selected[0].name : 'Not Set';
          }
          
          function showShiftGroup() {
            if (!vm.user || !Array.isArray(vm.shiftGroupList)) return 'No Data';
            var selected = vm.shiftGroupList.filter(function(item) {
              return item.id === (!!vm.user.shiftGroupId ? vm.user.shiftGroupId : -1);
            });
            return (!!vm.user.shiftGroupId && selected.length > 0) ? selected[0].name : 'Not Set';
          }

          function showGender() {
            if (!vm.user || !Array.isArray(vm.genderList)) return 'No Data';
            var selected = vm.genderList.filter(function(item) {
              return item.id === (!!vm.user.gender ? vm.user.gender : -1);
            });
            return (!!vm.user.gender && selected.length > 0) ? selected[0].name : 'Not Set';
          }

          function showLeavePolicy() {
            if (!vm.user || !Array.isArray(vm.leavePolicyList)) return 'No Data';
            var selected = vm.leavePolicyList.filter(function(item) {
              return item.id === (!!vm.user.leavePolicyId ? vm.user.leavePolicyId : -1);
            });
            return (!!vm.user.leavePolicyId && selected.length > 0) ? selected[0].name : 'Not Assigned';
          }

          function showWeeklyOffdayPolicy() {
            if (!vm.user || !Array.isArray(vm.weeklyOffDaysPolicyList)) return 'No Data';
            if (vm.user.weeklyOffDaysPolicy != null) {
              var selected = vm.weeklyOffDaysPolicyList.filter(function(item) {
                return item.id === (!!vm.user.weeklyOffDaysPolicy.id ? vm.user.weeklyOffDaysPolicy.id : -1);
              });
              return (vm.user.weeklyOffDaysPolicy != null && selected.length > 0) ? selected[0].name : 'Not Assigned';
            } else {
              return 'Not Assigned';
            }
          }

          function showLineManager() {
            if (!vm.user || !Array.isArray(vm.allEmployees)) return 'No Data';
            var selected = vm.allEmployees.filter(function(item) {
              return item.id === (!!vm.user.lineManagerId ? vm.user.lineManagerId : -1);
            });
            return (!!vm.user.lineManagerId && selected.length > 0) ? selected[0].name : 'Not Assigned';
          }

          function showHrManager() {
            if (!vm.user || !Array.isArray(vm.allEmployees)) return 'No Data';
            var selected = vm.allEmployees.filter(function(item) {
              return item.id === (!!vm.user.hrManagerId ? vm.user.hrManagerId : -1);
            });
            return (!!vm.user.hrManagerId && selected.length > 0) ? selected[0].name : 'Not Assigned';
          }

        function updateName(data) {
            if (!data) return 'Name cannot be empty.';
            var defer = $q.defer();
            employeeService.updateBasicInfo({name: data}, vm.user.id).then(function (response) {
                vm.user.name = data;
                $scope.$emit("profile-updated", {key: "name", value: data});
                toastrService.showSuccessToastr("Name updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not Update Name", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateLineManager(data) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({lineManagerId: data}, vm.user.id).then(function (response) {
                vm.user.lineManagerId = data == -1 ? null : data;
                $scope.$emit("profile-updated", {key: "lineManagerId", value: data == -1 ? null : data});
                toastrService.showSuccessToastr("Line Manager updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not assign Line Manager", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateHrManager(data) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({hrManagerId: data}, vm.user.id).then(function (response) {
                vm.user.hrManagerId = data == -1 ? null : data
                $scope.$emit("profile-updated", {key: "hrManagerId", value: data == -1 ? null : data});
                toastrService.showSuccessToastr("HR Manager updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update HR Manager", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }


        function updateEmail(data) {
            if (!data) return 'Email cannot be empty.';
            if (!isValidEmail(data)) return 'Invalid email address';
            var defer = $q.defer();
            employeeService.updateBasicInfo({email: data}, vm.user.id).then(function (response) {
                vm.user.email = response.email;
                $scope.$emit("profile-updated", {key: "email", value: data});
                toastrService.showSuccessToastr("Email updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update Email", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updatePrimaryText(data) {
            if (data.length > 10 || data.length === 0)
                return "Primary text can not be longer than 10 characters or empty";
            var defer = $q.defer();
            employeeService.updateBasicInfo({primaryDisplayText: data}, vm.user.id).then(function (response) {
                vm.user.primaryDisplayText = data;
                $scope.$emit("profile-updated", {key: "primaryDisplayText", value: data});
                toastrService.showSuccessToastr("Primary text updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update Primary text", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateReportPosition(data) {
            if (!data || !isNormalInteger(data))
                return "Report Position needs to be positive number";
            var defer = $q.defer();
            employeeService.updateReportPosition({reportPosition: data}, vm.user.id).then(function (response) {
                vm.user.reportPosition = data;
                $scope.$emit("profile-updated", {key: "reportPosition", value: data});
                toastrService.showSuccessToastr("Report position updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update report position", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateIdentifier(data) {
            if (data == null || data.length == 0)
                return toastrService.showErrorToastr('Identifier cannot be empty');
            var defer = $q.defer();
            employeeService.updateBasicInfo({employeeIdentifier: data}, vm.user.id).then(function (response) {
                vm.user.employeeIdentifier = data;
                $scope.$emit("profile-updated", {key: "employeeIdentifier", value: data});
                toastrService.showSuccessToastr("Identifier updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update identifier")
                defer.reject(message);
            });
        }

        function isNormalInteger(str) {
            var n = Math.floor(Number(str));
            return n !== Infinity && String(n) === str && n > 0;
        }

        function updateSecondaryText(data) {
            if (data.length > 10 || data.length === 0)
                return "Secondary text can not be longer than 10 characters or empty";
            var defer = $q.defer();
            employeeService.updateBasicInfo({secondaryDisplayText: data}, vm.user.id).then(function (response) {
                vm.user.secondaryDisplayText = data;
                $scope.$emit("profile-updated", {key: "secondaryDisplayText", value: data});
                toastrService.showSuccessToastr("Secondary text updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update secondary text", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateRfid(data) {
            if (data != "") {
                if (data.length != 10)
                    return "Rfid must be 10 digits";
            }
            var defer = $q.defer();
            employeeService.updateBasicInfo({rfid: data}, vm.user.id).then(function (response) {
                vm.user.rfid = data;
                $scope.$emit("profile-updated", {key: "rfid", value: data});
                toastrService.showSuccessToastr("RFID updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update RFID", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function isValidEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function updateDesignation(designationId) {
            var defer = $q.defer();
            var idToSend = designationId === null ? null : designationId;
            employeeService.updateBasicInfo({ 'designationId': idToSend }, vm.user.id)
                .then(function (response) {
                    var selectedDesignation = findObjectByIdFromArray(designationId, vm.designationList);
                    $scope.$emit("profile-updated", { key: "designation", value: selectedDesignation });
                    vm.user.designation = selectedDesignation;
                    toastrService.showSuccessToastr("Designation updated successfully");
                    defer.resolve(response);
                }, function (message) {
                    toastrService.showErrorToastr("Could not update designation", "", 5000);
                    defer.reject(message);
                });
            return defer.promise;
        }
        function updateSite(siteId) {
            var defer = $q.defer();
            employeeService.changeEmployeeSite({'siteId': siteId}, vm.user.id).then(function (response) {
                // var selectedSite = findObjectByIdFromArray(siteId, vm.siteList);
                // $scope.$emit("profile-updated", {key: "designation", value: selectedDesignation});
                // vm.user.siteId = selectedDesignation;
                toastrService.showSuccessToastr("Site updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update site", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateEmploymentType(employmentTypeId) {
            var defer = $q.defer();
            var idToSend = employmentTypeId === null ? null : employmentTypeId;
            employeeService.updateBasicInfo({'employmentTypeId': idToSend}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {key: "employmentTypeId", value: employmentTypeId});
                vm.user.employmentTypeId = employmentTypeId;
                toastrService.showSuccessToastr("Employment type updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update employment type", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateWorkplace(workplaceId) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'workplaceId': workplaceId}, vm.user.id).then(function (response) {
                var selectedWorkplace = findObjectByIdFromArray(workplaceId, vm.workplaceList);
                $scope.$emit("profile-updated", {key: "workplace", value: selectedWorkplace});
                vm.user.workplace = selectedWorkplace;
                toastrService.showSuccessToastr("Workplace updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update workplace", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateSubsidiary(subsidiaryId) {
            var defer = $q.defer();
            var idToSend = subsidiaryId === -1 ? null : subsidiaryId;
            employeeService.updateBasicInfo({'subsidiaryId': idToSend}, vm.user.id).then(function (response) {
                var selectedSubsidiary = findObjectByIdFromArray(subsidiaryId, vm.subsidiaryList);
                $scope.$emit("profile-updated", {key: "subsidiary", value: selectedSubsidiary});
                vm.user.subsidiary = selectedSubsidiary;
                vm.user.subsidiaryId = idToSend;

                // Reload and filter data after subsidiary update
                loadAllData();

                toastrService.showSuccessToastr("Subsidiary updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update subsidiary", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }


        function updateEmployeeOfficeId(employeeOfficeId) {
            var defer = $q.defer();

            if(vm.user.employeeOfficeId.toLowerCase().localeCompare(employeeOfficeId.toLowerCase()) === 0) {
                defer.resolve();
                return defer.promise;
            }

            employeeService.checkEmployeeOfficeIdValidity(employeeOfficeId).then(function (data) {
                if (data.isValid) {
                    employeeService.updateBasicInfo({'employeeOfficeId': employeeOfficeId}, vm.user.id).then(function (response) {
                        vm.user.employeeOfficeId = employeeOfficeId;
                        $scope.$emit("profile-updated", {key: "employeeOfficeId", value: employeeOfficeId});
                        toastrService.showSuccessToastr("Employee ID updated successfully");
                        defer.resolve(response);
                    }, function (message) {
                        toastrService.showErrorToastr("Could not update employee ID", "", 5000);
                        defer.reject(message);
                    });
                } else {
                    defer.reject("ID is already in use");
                }
            }, function (error) {
                defer.reject("Couldn't verify ID, please try later");
            });

            return defer.promise;
        }

        function updateDepartment(departmentId) {
            var defer = $q.defer();
            var idToSend = departmentId === null ? null : departmentId;
            employeeService.updateBasicInfo({'departmentId': idToSend}, vm.user.id).then(function (response) {
                var selectedDepartment = findObjectByIdFromArray(departmentId, vm.departmentList);
                $scope.$emit("profile-updated", {key: "department", value: selectedDepartment});
                vm.user.department = selectedDepartment;
                toastrService.showSuccessToastr("Department updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update department", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }
        function updateSubDepartment(subDepartmentId) {
            var defer = $q.defer();
            var idToSend = subDepartmentId === null ? null : subDepartmentId;
            employeeService.updateBasicInfo({'subDepartmentId': idToSend}, vm.user.id).then(function (response) {
                var selectedSubDepartment = findObjectByIdFromArray(subDepartmentId, vm.subDepartmentList);
                $scope.$emit("profile-updated", {key: "subDepartment", value: selectedSubDepartment});
                vm.user.subDepartment = selectedSubDepartment;
                toastrService.showSuccessToastr("Sub Department updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update sub-department", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateShift(shiftId) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'shiftId': shiftId}, vm.user.id).then(function (response) {
                var selectedShift = findObjectByIdFromArray(shiftId, vm.shiftList);
                $scope.$emit("profile-updated", {key: "shift", value: selectedShift});
                vm.user.shift = selectedShift;
                toastrService.showSuccessToastr("Shift updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update shift", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateShiftGroup (shiftGroupId) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'shiftGroupId': shiftGroupId}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { key : "shiftGroupId", value : shiftGroupId});
                vm.user.shiftGroupId = shiftGroupId;
                toastrService.showSuccessToastr("Shift group updated successfully");
                defer.resolve(response);
            }, function(message){
                toastrService.showErrorToastr("Could not update shift group", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }
        function updateGender(data) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({gender: data}, vm.user.id).then(function (response) {
                vm.user.gender = data;
                $scope.$emit("profile-updated", {key: "gender", value: data});
                toastrService.showSuccessToastr("Gender updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update gender", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateLeavePolicy(leavePolicyId) {
            var defer = $q.defer();
            var batchEmployees = {employeeIdList: []};
            batchEmployees.employeeIdList.push(vm.user.id);
            leavePolicyService.updateBatchLeavePolicy(batchEmployees, leavePolicyId).then(function (data) {
                vm.user.leavePolicyId = leavePolicyId;
                toastrService.showSuccessToastr("Leave policy update successfully");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Could not update leave policy", "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateWeeklyOffdayPolicy(weeklyOffdayPolicyId) {
            var defer = $q.defer();
            var batchEmployees = {employeeIdList: []};
            batchEmployees.employeeIdList.push(vm.user.id);
            weeklyOffDaysService.updateBatchWeeklyOffDaysPolicyPolicy(batchEmployees, weeklyOffdayPolicyId).then(function (data) {
                var selectedWeeklyOffdayPolicy = findObjectByIdFromArray(weeklyOffdayPolicyId, vm.weeklyOffDaysPolicyList);
                $scope.$emit("profile-updated", {key: "weeklyOffDaysPolicy", value: selectedWeeklyOffdayPolicy});
                toastrService.showSuccessToastr("Weekly offday policy updated successfully");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Could not update weekly offday policy");
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateFirstLeaveApprover() {
            toastrService.clearPreviousToastr()
            var defer = $q.defer();
            var firstApproverId = vm.firstLeaveApprover[0].id
            var requestBody = {
                employeeIdList: [],
                firstApproverId : firstApproverId
            };
            requestBody.employeeIdList.push(vm.user.id);
            leaveManagementService.setLeaveApproverForBatchEmployee(requestBody).then(function (data) {
                vm.user.firstApproverId = firstApproverId;
                if(firstApproverId !== -1)
                    toastrService.showSuccessToastr("First leave approver assigned");
                else
                    toastrService.showSuccessToastr("First leave approver removed");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update first leave approver : " + error, "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateSecondLeaveApprover() {
            toastrService.clearPreviousToastr()
            var defer = $q.defer();
            var secondApproverId = vm.secondLeaveApprover[0].id
            var requestBody = {
                employeeIdList: [],
                secondApproverId: secondApproverId
            };
            requestBody.employeeIdList.push(vm.user.id);
            leaveManagementService.setLeaveApproverForBatchEmployee(requestBody).then(function (data) {
                vm.user.secondApproverId = secondApproverId;
                if(secondApproverId !== -1)
                    toastrService.showSuccessToastr("Second leave approver assigned");
                else
                    toastrService.showSuccessToastr("Second leave approver removed");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update second leave approver : " + error, "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function findObjectByIdFromArray(id, array) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].id === id) return array[i];
            }
        }

        //////Profile Tabs function
        function showBloodGroup() {
            if (!vm.user) return 'No Data';
            var selected = $filter('filter')(vm.bloodGroupList, {id: vm.user.employeeDetails && vm.user.employeeDetails.bloodGroup ? vm.user.employeeDetails.bloodGroup : -1});
            return (!!vm.user.employeeDetails && !!vm.user.employeeDetails.bloodGroup && selected.length>0) ? selected[0].name : 'Not Set';
        }

        function updatePasswordFunction() {
            toastrService.clearPreviousToastr();
            if (!vm.changePass.passwordText || !vm.changePass.confirmPasswordText) return;

            if (vm.changePass.passwordText.localeCompare(vm.changePass.confirmPasswordText) != '0')
                return toastrService.showErrorToastr("Passwords don't match","",5000);

            if (vm.needOldPass && !vm.oldPass) return toastrService.showErrorToastr("Please provide your current password","",5000);

            if (vm.oldPass == vm.changePass.passwordText) return toastrService.showErrorToastr("New password can not be same as old password","",5000);

            var data = {
                password: vm.changePass.passwordText,
                confirmPassword: vm.changePass.confirmPasswordText
            };

            if (vm.needOldPass) {
                data['oldPassword'] = vm.oldPass;
            }

            employeeService.updatePassword(data, vm.user.id, vm.needOldPass)
                .then(function () {
                        analyticsService.sendData(
                            ANALYTICS_CONSTANT.changePassword,
                            document.title + ' - Change Password - Submit',
                            'submit',
                            'Change Password In' + document.title,
                            ANALYTICS_CONSTANT.submit
                        );
                        toastrService.showSuccessToastr("Password Changed");
                    },
                    function (error) {
                        toastrService.showErrorToastr(error, "", 5000);
                });
        }

        function updateFathersName(data) {
            if (!data) return 'Fathers Name can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({fatherName: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "fatherName", "value": data});
                toastrService.showSuccessToastr("Father name updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update father name", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateMothersName(data) {
            if (!data) return 'Mothers Name can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({motherName: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "motherName", "value": data});
                toastrService.showSuccessToastr("Mother name Updated")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update mother name", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updatePhoneOffice(data) {
            if (!data) return 'Office Phone can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({phoneOffice: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "phoneOffice", "value": data});
                toastrService.showSuccessToastr("Office phone number updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update office phone number", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateNidNumber(data) {
            if (!data) return 'National ID can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({nid: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "nid", "value": data});
                toastrService.showSuccessToastr("NID number updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update NID number", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateBloodGroup(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({bloodGroup: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "bloodGroup", "value": data});
                toastrService.showSuccessToastr("Blood group updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update blood group", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }


        function updatePhoneHome(data) {
            if (!data) return 'Home phone can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({phoneHome: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "phoneHome", "value": data});
                toastrService.showSuccessToastr("Home phone number updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update home phone", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updatePhoneMobile(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({phoneMobile: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {"key": "employeeDetails", "subkey": "phoneMobile", "value": data});
                toastrService.showSuccessToastr("Personal phone number updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update personal phone", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }


        function updateEducationHistory(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({educationHistory: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {
                    "key": "employeeDetails",
                    "subkey": "educationHistory",
                    "value": data
                });
                toastrService.showSuccessToastr("Education history updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update education history", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateEmploymentHistory(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({employmentHistory: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {
                    "key": "employeeDetails",
                    "subkey": "employmentHistory",
                    "value": data
                });
                toastrService.showSuccessToastr("Employment history updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update employment history", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }


        function open($event, elementOpened) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.opened[elementOpened] = !vm.opened[elementOpened];
        }

        function updateDateOfBirth(data) {
            if (!data) return 'Date of birth can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({dateOfBirth: data.getTime()}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {
                    "key": "employeeDetails",
                    "subkey": "dateOfBirth",
                    "value": data.getTime()
                });
                toastrService.showSuccessToastr("Date of birth updated successfully")
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update date of birth", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateDateOfJoin(data) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'dateOfJoin': new Date(data).valueOf()}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {key: "dateOfJoin", value: response.dateOfJoin});
                vm.user.dateOfJoin = response.dateOfJoin;
                toastrService.showSuccessToastr("Joining date updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update joining date", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateDateOfResignation(data) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'dateOfResignation': new Date(data).valueOf()}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", {key: "dateOfResignation", value: response.dateOfResignation});
                vm.user.dateOfResignation = response.dateOfResignation;
                toastrService.showSuccessToastr("End date updated successfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update end date", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateFirstManualEntryApprover() {
            toastrService.clearPreviousToastr()
            var defer = $q.defer();
            var firstManualEntryApproverId = vm.firstManualEntryApprover[0].id
            var requestBody = {
                employeeIdList: [],
                firstManualEntryApproverId: firstManualEntryApproverId
            };
            requestBody.employeeIdList.push(vm.user.id);
            lateApprovalManagementService.setManualEntryApproverForBatchEmployee(requestBody).then(function (data) {
                vm.user.firstManualEntryApproverId = firstManualEntryApproverId;
                if(firstManualEntryApproverId !== -1)
                    toastrService.showSuccessToastr("First manual entry approver assigned");
                else
                    toastrService.showSuccessToastr("First manual entry approver removed");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update first manual entry approver : " + error, "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateSecondManualEntryApprover() {
            toastrService.clearPreviousToastr()
            var defer = $q.defer();
            var secondManualEntryApproverId = vm.secondManualEntryApprover[0].id
            var requestBody = {
                employeeIdList: [],
                secondManualEntryApproverId: secondManualEntryApproverId
            };
            requestBody.employeeIdList.push(vm.user.id);
            lateApprovalManagementService.setManualEntryApproverForBatchEmployee(requestBody).then(function (data) {
                vm.user.secondManualEntryApproverId = secondManualEntryApproverId;
                if(secondManualEntryApproverId !== -1)
                    toastrService.showSuccessToastr("Second manual entry approver assigned");
                else
                    toastrService.showSuccessToastr("Second manual entry approver removed");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update second manual entry approver : " + error, "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateFirstLateApprover() {
            toastrService.clearPreviousToastr()
            var defer = $q.defer();
            var firstLateApproverId = vm.firstLateApprover[0].id
            var requestBody = {
                employeeIdList: [],
                firstLateApproverId: firstLateApproverId
            };
            requestBody.employeeIdList.push(vm.user.id);
            lateApprovalManagementService.setLateApproverForBatchEmployee(requestBody).then(function (data) {
                vm.user.firstLateApproverId = firstLateApproverId;
                if(firstLateApproverId !== -1)
                    toastrService.showSuccessToastr("First late approver assigned");
                else
                    toastrService.showSuccessToastr("First late approver removed");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update first late approver : " + error, "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function updateSecondLateApprover() {
            toastrService.clearPreviousToastr()
            var defer = $q.defer();
            var secondLateApproverId = vm.secondLateApprover[0].id;
            var requestBody = {
                employeeIdList: [],
                secondLateApproverId: secondLateApproverId
            };
            requestBody.employeeIdList.push(vm.user.id);
            lateApprovalManagementService.setLateApproverForBatchEmployee(requestBody).then(function (data) {
                vm.user.secondLateApproverId = secondLateApproverId;
                if(secondLateApproverId !== -1)
                    toastrService.showSuccessToastr("Second late approver assigned");
                else
                    toastrService.showSuccessToastr("Second late approver removed");
                defer.resolve(data);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update second late approver : " + error, "", 5000);
                defer.reject(error);
            });
            return defer.promise;
        }

        function openAddAddressModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/addAddress/addAddress.action.modal.html',
                controller: 'AddAddressModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    userId: function () {
                        return vm.user.id;
                    },
                    currentAddress: function () {
                        return vm.user.addresses;
                    }
                }
            }).result.then(function (address) {
                $scope.$emit("profile-updated", {"key": "addresses", "type": "new", "value": address});
            }, function () {
                // console.log("Address upload modal dismissed.");
            });
        }

        function openDeleteAddressModal(address,index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/deleteAddress/deleteAddress.html',
                controller: 'DeleteAddressModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentAddress: function () {
                        return address
                    },
                }
            }).result.then(function () {
                vm.user.addresses.splice(index,1);
            }, function () {
                // console.log("Address upload modal dismissed.");
            });
        }

        function updateAddress(data, addressId) {
            var defer = $q.defer();
            employeeService.updateAddress(data, vm.user.id, addressId).then(function (response) {
                $scope.$emit("profile-updated", {"key": "addresses", "type": "modified", "value": response.address});
                toastrService.showSuccessToastr("Address update succesfully");
                defer.resolve(response);
            }, function (message) {
                toastrService.showErrorToastr("Could not update address", "", 5000);
                defer.reject(message);
            });
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProjectDedicationCtrl', ['employeeService', '$stateParams', '$uibModal', 'authService', 'toastrService', ProjectDedicationCtrl]);

    /** @ngInject */
    function ProjectDedicationCtrl(employeeService, $stateParams, $uibModal, authService, toastrService) {

        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        var isAdmin = authService.isAdmin();
        var userId = $stateParams.employeeId && (isAdmin || loggedInUser.isLineManager) ? $stateParams.employeeId : loggedInUser.id;

        vm.projectDedicationList = [];
        vm.update = update;
        vm.save = save;
        vm.sum = sum;

        init();

        function init() {
            employeeService.getAllProjectsOfAnEmployee(userId).then(function (projectDedicationList) {
                vm.projectDedicationList = projectDedicationList;
            }, function (err) {
                console.error(err);
            })
        }

        function update(projectDedication) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/projectDedication/updateProjectDedicationModal/update.modal.html',
                controller: 'UpdateProjectDedicationModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    dedication: function () {
                        return projectDedication.dedicationPercentage;
                    }
                }
            }).result.then(function (dedication) {
                for (var i = 0; i < vm.projectDedicationList.length; i++) {
                    if (vm.projectDedicationList[i].id == projectDedication.id) {
                        vm.projectDedicationList[i].dedicationPercentage = dedication;
                        return;
                    }
                }
            });
        }

        function save() {
            var total = 0;
            for (var i = 0; i < vm.projectDedicationList.length; i++) {
                total = total + vm.projectDedicationList[i].dedicationPercentage;
            }
            if (total > 100.0) {
                return toastrService.showErrorToastr("Total is more than 100");
            } else {
                employeeService.saveProjectDedicationForAnEmployee(userId, vm.projectDedicationList).then(function (projectDedicationList) {
                    vm.projectDedicationList = projectDedicationList;
                }, function (err) {
                    toastrService.showErrorToastr("Failed to update project dedication: " + err, "", 5000);
                })
            }
        }

        function sum() {
            return vm.projectDedicationList.reduce(function(sum,b){
                return sum + b.dedicationPercentage;
            },0);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProjectWorkDedicationCtrl', ['employeeService', 'taskService', '$stateParams', '$uibModal', 'authService', 'toastr', 'analyticsService', 'ANALYTICS_CONSTANT', ProjectWorkDedicationCtrl]);

    /** @ngInject */
    function ProjectWorkDedicationCtrl(employeeService, taskService, $stateParams, $uibModal, authService, toastr, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        var userId = $stateParams.employeeId ? $stateParams.employeeId : loggedInUser.id;
        vm.report = [];
        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.datePicker.options = {
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                format: 'DD-MMM-YYYY',
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                // format: "D/MMM/YY", //will give you 6-Jan-17
                // format: "DD-MMMM-YY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };
        vm.excelUrl = null;
        vm.isDataLoaded=false;
        vm.searchByDateRange = searchByDateRange;
        vm.getData = getData;

        init();

        function init() {
            var startDate = moment(vm.datePicker.date.startDate).format('x');
            var endDate = moment(vm.datePicker.date.endDate).format('x');
            vm.excelUrl = taskService.getExcelUrlForProjectDedication(userId, startDate, endDate);
            vm.isDataLoaded=false;
            taskService.getProjectDedicationReportOfAnEmployee(userId, startDate, endDate).then(function (report) {
                vm.report = report;
                vm.isDataLoaded=true;
            }, function (err) {
                console.error(err);
            })
        }

        function getData() {
            init();
        }
        function searchByDateRange(){
            analyticsService.sendData(ANALYTICS_CONSTANT.projectDedication, document.title + ' - Project Dedication - Search', 'search', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            init();
        }
        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(3, 'day');
            var end = moment().endOf('day');

            return {
                'startDate': start,
                'endDate': end
            };
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.clients')
        .controller('CreateProjectClientCtrl', ['$state', 'employeeService', 'toastrService', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', 'projectClientService', '$uibModal', CreateProjectClientCtrl]);

    /** @ngInject */
    function CreateProjectClientCtrl($state, employeeService, toastrService, $q, analyticsService, ANALYTICS_CONSTANT, projectClientService, $uibModal) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.organisationTypes = [];
        vm.employeeList = [];
        vm.createClientForm = null;
        vm.isCreating = false;

        vm.clientName = null;
        vm.contactName = null;
        vm.contactDesignation = null;
        vm.contactNumber = null;
        vm.contactEmail = null;
        vm.selectedEmployee = [];
        vm.selectedOrganisationType = [];
        vm.invalidKamSelection = false;

        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.isInvalidForm = isInvalidForm;
        vm.createOrganisationType = createOrganisationType;
        vm.openConfirmationModal = openConfirmationModal;

        function init() {
            var promises = [];
            promises.push(getAllOrganisationTypes());
            promises.push(getFilteredEmployeeNames());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                });
        }

        init();

        function getAllOrganisationTypes() {
            return projectClientService.getAllOrganisationTypes().then(function (data) {
                vm.organisationTypes = data;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch organisation types: " + error, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function openConfirmationModal() {
            var confirmationText = "Are you sure you want to create a new client?";
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                submitForm();
            });
        }

        function submitForm() {
            var formData = {
                name : vm.clientName.trim(),
                organisationTypeId : vm.selectedOrganisationType[0].id,
                kamId : vm.selectedEmployee[0].id,
                contactName : vm.contactName.trim(),
                contactDesignation : !!vm.contactDesignation ? vm.contactDesignation.trim() : null,
                contactNumber : vm.contactNumber.trim(),
                contactEmail : vm.contactEmail.trim()
            };

            vm.isCreating = true;
            projectClientService.createProjectClient(formData).then(function (data) {
                toastrService.showSuccessToastr("Client created successfully");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't create client: " + error, "", 5000);
            }).finally(function () {
                vm.isCreating = false;
                cancelCurrentOperation();
            });
        }

        function isInvalidForm() {
            if(vm.selectedEmployee == null || vm.selectedEmployee.length === 0) return true;
            if(vm.selectedOrganisationType == null || vm.selectedOrganisationType.length === 0) return true;
        }

        function cancelCurrentOperation() {
            $state.go("projectManagement.clients");
        }

        function createOrganisationType(data) {
            projectClientService.createOrganisationType({name: data.trim()}).then(function (data) {
                toastrService.showSuccessToastr('Created Organisation Type Successfully');
                getAllOrganisationTypes();
            }, function (error) {
                toastrService.showErrorToastr('Failed to create organisation type: ' + error);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.clients')
        .controller('DeleteClientModalCtrl', [ '$uibModalInstance', 'toastrService', 'clientDetails', 'analyticsService', 'ANALYTICS_CONSTANT', 'projectClientService', DeleteClientModalCtrl]);

    /** @ngInject */
    function DeleteClientModalCtrl($uibModalInstance, toastrService, clientDetails, analyticsService, ANALYTICS_CONSTANT, projectClientService) {
        var vm = this;

        // var analyticsDeleteTitle = 'Delete Project Client Modal';
        // var analyticsDeleteUrl = 'delete-project-client';
        // analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Visitor Card In' + document.title, ANALYTICS_CONSTANT.open);
        vm.isDeleting = false;
        vm.clientDetails = clientDetails;

        var analyticsDeleteTitle = 'Delete Client Modal';
        var analyticsDeleteUrl = 'delete-project-client';

        vm.deleteClient = deleteClient;

        function deleteClient() {
            vm.isDeleting = true;
            projectClientService.deleteProjectClient(vm.clientDetails.clientId).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Client In' + document.title, ANALYTICS_CONSTANT.delete)
                toastrService.showSuccessToastr("Client deleted successfully");
                $uibModalInstance.close();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't delete client: " + error, "", 5000);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.clients')
        .controller('EditProjectClientCtrl', ['$stateParams', '$state', 'employeeService', 'toastrService', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', 'projectClientService', EditProjectClientCtrl]);

    /** @ngInject */
    function EditProjectClientCtrl($stateParams, $state, employeeService, toastrService, $q, analyticsService, ANALYTICS_CONSTANT, projectClientService) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.organisationTypes = [];
        vm.employeeList = [];
        vm.editClientForm = null;
        vm.isUpdating = false;

        vm.clientDetails = $stateParams.clientDetails;
        vm.selectedEmployee = [];
        vm.selectedOrganisationType = [];

        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.isInvalidForm = isInvalidForm;
        vm.submitForm = submitForm;
        vm.createOrganisationType = createOrganisationType;

        function init() {
            if(vm.clientDetails == null || vm.clientDetails.clientId == null) return cancelCurrentOperation();
            var promises = [];
            promises.push(getAllOrganisationTypes());
            promises.push(getFilteredEmployeeNames());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                    initialiseForm();
                });
        }

        init();
        function initialiseForm() {
            vm.clientId = vm.clientDetails.clientId;
            vm.clientName = vm.clientDetails.clientName;
            vm.contactName = vm.clientDetails.contactName;
            vm.contactDesignation = vm.clientDetails.contactDesignation;
            vm.contactNumber = vm.clientDetails.contactNumber;
            vm.contactEmail = vm.clientDetails.contactEmail;
            vm.employeeList.forEach(function (item) {
                item.ticked = (item.id === vm.clientDetails.kamId);
            });
            vm.organisationTypes.forEach(function (item) {
                item.ticked = (item.id === vm.clientDetails.organisationTypeId);
            });
        }
        function getAllOrganisationTypes() {
            return projectClientService.getAllOrganisationTypes().then(function (data) {
                vm.organisationTypes = data;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch organisation types: " + error, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function submitForm() {
            var formData = {
                clientId : vm.clientId,
                name : vm.clientName.trim(),
                organisationTypeId : vm.selectedOrganisationType[0].id,
                kamId : vm.selectedEmployee[0].id,
                contactName : vm.contactName.trim(),
                contactDesignation : !!vm.contactDesignation ? vm.contactDesignation.trim() : null,
                contactNumber : vm.contactNumber.trim(),
                contactEmail : vm.contactEmail.trim()
            };

            vm.isUpdating = true;
            projectClientService.updateProjectClient(formData).then(function (data) {
                toastrService.showSuccessToastr("Client updated successfully");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update client: " + error, "", 5000);
            }).finally(function () {
                vm.isUpdating = false;
                cancelCurrentOperation();
            });
        }

        function isInvalidForm() {
            if(vm.selectedEmployee == null || vm.selectedEmployee.length === 0) return true;
            if(vm.selectedOrganisationType == null || vm.selectedOrganisationType.length === 0) return true;
        }

        function cancelCurrentOperation() {
            $state.go("projectManagement.clients");
        }

        function createOrganisationType(data) {
            projectClientService.createOrganisationType({name: data.trim()}).then(function (data) {
                toastrService.showSuccessToastr('Created Organisation Type Successfully');
                getAllOrganisationTypes();
            }, function (error) {
                toastrService.showErrorToastr('Failed to create organisation type: ' + error);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.issueCreators')
        .controller('CreateIssueCreatorModalCtrl', [ '$uibModalInstance', 'toastrService', 'projectIssuesService', 'employees', CreateIssueCreatorModalCtrl]);

    /** @ngInject */
    function CreateIssueCreatorModalCtrl($uibModalInstance, toastrService, projectIssuesService, employees) {
        var vm = this;
        vm.employees = angular.copy(employees);
        vm.selectedEmployee = [];
        vm.isCreating = false;

        vm.isInvalidSelection = isInvalidSelection;
        vm.addIssueCreator = addIssueCreator;

        function isInvalidSelection() {
            if(vm.selectedEmployee == null || vm.selectedEmployee.length === 0) return true;
        }

        function addIssueCreator() {
            vm.isCreating = true;
            projectIssuesService.addIssueCreator(vm.selectedEmployee[0].id).then(function (data) {
                toastrService.showSuccessToastr("New issue creator added successfully");
                $uibModalInstance.close();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't add new issue creator: " + error, "", 5000);
                vm.isCreating = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.products')
        .controller('CreateProductCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'productService', 'moment', 'utilService', 'productSegmentService', 'employeeService', CreateProductCtrl]);


    function CreateProductCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, productService, moment, utilService, productSegmentService, employeeService) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.allEntries = [];
        vm.createProductForm = {};
        vm.createProductForm.segmentList = [];
        vm.createProductForm.ownerList = [];
        vm.createProductForm.selectedOwnerList = [];
        vm.createProductForm.selectedSegmentList = [];
        vm.createProductForm.productName = '';
        vm.createProductForm.description = null;
        vm.isDataLoaded = false;
        vm.isCreating = false;



        vm.checkFormaValidation = checkFormaValidation;
        vm.createProductSegment = createProductSegment;
        vm.openConfirmationModal = openConfirmationModal;

        function init() {
            $q.all([
                getAllProductSegementsOfOffice(),
                getAllEmployeesOfOffice()
            ]).then(function (data){
                vm.isDataLoaded = true;
            }, function (err){

            })
            //TODO apply promise.all
        }

        init();

        function checkFormaValidation(){
            if(vm.createProductForm.selectedSegmentList.length == 0 || vm.createProductForm.selectedOwnerList.length == 0){
                return false;
            }
            else return true;
        }
        function getAllEmployeesOfOffice() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.createProductForm.ownerList = angular.copy(data.employees);
            }, function (err) {
                toastrService.showErrorToastr('Failed to load owner data ' + err);
            })
        }

        function getAllProductSegementsOfOffice() {
            return productSegmentService.getProductSegmentsOfOffice().then(function (data) {
                vm.createProductForm.segmentList = angular.copy(data.allProductSegments);
            }, function (err) {
                toastrService.showErrorToastr('Failed to load product segment data ' + err);
            })
        }

        function openConfirmationModal() {
            var confirmationText = "Are you sure you want to create a new product?";
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                createProduct();
            });
        }

        function createProduct(){
            var data = {
                name : vm.createProductForm.productName,
                productSegmentId : vm.createProductForm.selectedSegmentList[0].id,
                ownerId : vm.createProductForm.selectedOwnerList[0].id,
                description : vm.createProductForm.description
            }
            vm.isCreating = true;
            productService.createProduct(data).then(function(data){
                toastrService.showSuccessToastr('Successfully Created Product')
                $state.go('projectManagement.products')
            },function (err){
                toastrService.showErrorToastr('Could not Create Product : '+err)
            }).finally(function () {
                vm.isCreating = false;
            });
        }

        function createProductSegment(data){
            productSegmentService.createProductSegment({name:data}).then(function (){
                toastrService.showSuccessToastr('Created Product Segment Successfully');
                getAllProductSegementsOfOffice();
            }, function (err){
                toastrService.showErrorToastr('Error occured while creating a new product segment '+err)
            });

        }




    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
    app.controller('DeleteProductModalCtrl', ['$uibModalInstance', 'toastrService', 'productToDelete', 'analyticsService', 'ANALYTICS_CONSTANT', 'productService', DeleteProductModalCtrl]);

    /** @ngInject */
    function DeleteProductModalCtrl( $uibModalInstance, toastrService, productToDelete, analyticsService, ANALYTICS_CONSTANT, productService) {

        var vm = this;

        vm.productToDelete = angular.copy(productToDelete);
        console.log(productToDelete)


        vm.productDelete = productDelete;

        function productDelete(id) {
            productService.deleteProduct(id).then(function (){
                toastrService.showSuccessToastr('Successfully deleted the product');
                $uibModalInstance.close();
            }, function (){

            })
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.products')
        .controller('EditProductCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'productService', 'moment', 'utilService', 'productSegmentService', 'employeeService', EditProductCtrl]);


    function EditProductCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, productService, moment, utilService, productSegmentService, employeeService) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.allEntries = [];
        vm.editProductForm = {};
        vm.editProductForm.segmentList = [];
        vm.editProductForm.ownerList = [];
        vm.editProductForm.selectedOwnerList = [];
        vm.editProductForm.selectedSegmentList = [];
        vm.editProductForm.productName = '';
        vm.editProductForm.description = null;
        vm.isDataLoaded = false;
        vm.productToEdit = $stateParams.productToEdit;


        vm.checkFormaValidation = checkFormaValidation;
        vm.editProduct = editProduct;
        vm.createProductSegment = createProductSegment;

        function init() {
            if(!$stateParams.productToEdit)
                $state.go('projectManagement.products');
            else{
                $q.all([
                    getAllProductSegementsOfOffice(),
                    getAllEmployeesOfOffice()
                ]).then(function (data){
                    initializeVariables();
                    vm.isDataLoaded = true;
                }, function (err){

                })
            }
        }

        init();

        function initializeVariables(){
            vm.productToEdit = $stateParams.productToEdit;
            vm.editProductForm.productName = vm.productToEdit.name;
            vm.editProductForm.description = vm.productToEdit.description;
            var tempOwner = vm.editProductForm.ownerList.find(function (v){
                return v.id === vm.productToEdit.ownerId;
            })
            tempOwner['ticked'] = true;
            vm.editProductForm.selectedOwnerList.push({'id': vm.productToEdit.ownerId});
            var tempSegment = vm.editProductForm.segmentList.find(function (v){
                return v.id === vm.productToEdit.segmentId;
            })
            tempSegment['ticked'] = true;
            vm.editProductForm.selectedSegmentList.push({'id': vm.productToEdit.segmentId});

        }

        function checkFormaValidation(){
            if(vm.editProductForm.selectedSegmentList.length == 0 || vm.editProductForm.selectedOwnerList.length == 0){
                return false;
            }
            else return true;
        }
        function getAllEmployeesOfOffice() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.editProductForm.ownerList = angular.copy(data.employees);
            }, function (err) {
                toastrService.showErrorToastr('Failed to load owner data ' + err);
            })
        }

        function getAllProductSegementsOfOffice() {
            return productSegmentService.getProductSegmentsOfOffice().then(function (data) {
                vm.editProductForm.segmentList = angular.copy(data.allProductSegments);
            }, function (err) {
                toastrService.showErrorToastr('Failed to load product segment data ' + err);
            })
        }


        function editProduct(){
            var data = {
                id : vm.productToEdit.id,
                name : vm.editProductForm.productName,
                productSegmentId : vm.editProductForm.selectedSegmentList[0].id,
                ownerId : vm.editProductForm.selectedOwnerList[0].id,
                description : vm.editProductForm.description
            }
            productService.editProduct(data).then(function(data){
                toastrService.showSuccessToastr('Product updated successfully')
                $state.go('projectManagement.products')
            },function (err){
                toastrService.showErrorToastr('Product update failed: ' + err)
            })
        }

        function createProductSegment(data){
            productSegmentService.createProductSegment({name:data}).then(function (){
                toastrService.showSuccessToastr('Created Product Segment Successfully');
                getAllProductSegementsOfOffice();
            }, function (err){
                toastrService.showErrorToastr('Error occurred while creating a new product segment ' +  err)
            })

        }




    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projectIssues')
        .controller('CreateIssueCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'projectService', 'projectIssuesService', 'moment', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', 'employeeService', 'ISSUE_PRIORITIES', 'ISSUE_STATUSES', CreateIssueCtrl]);


    function CreateIssueCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, projectService, projectIssuesService, moment, utilService, analyticsService, ANALYTICS_CONSTANT, employeeService, ISSUE_PRIORITIES, ISSUE_STATUSES) {
        var vm = this;

        vm.loggedInUser = authService.getLoggedInUser();
        vm.isDataLoaded = false;
        vm.isCreating = false;
        vm.createIssueForm = null;
        vm.create = {};
        vm.create.projectName = null;
        vm.create.projectRefCode = null;
        vm.create.priority = null;
        vm.create.supportDoc = null;
        vm.create.description = null;
        vm.create.allocateTo = [];
        vm.create.submittedBy = null;
        vm.create.entryDateTime = moment();

        vm.allProjects = [];
        vm.employeeList = [];
        vm.priorityList = angular.copy(ISSUE_PRIORITIES);
        vm.statusList = angular.copy(ISSUE_STATUSES);
        vm.selectedProject = [];
        vm.selectedPriority = null;
        vm.selectedStatus = null;

        vm.issueDateTimePicker = {};
        vm.issueDateTimePicker.date = moment();
        vm.issueDateTimePicker.options = {
            singleDatePicker: true,
            minDate: moment().startOf('day').subtract(1, "years"),
            timePicker: true,
            timePicker24Hour: false,
            locale: {
                format: 'DD MMM YYYY hh:mm A'
            }
        };

        vm.entryDateTimePicker = {};
        vm.entryDateTimePicker.date = moment();
        vm.entryDateTimePicker.options = {
            singleDatePicker: true,
            minDate: moment().startOf('day').subtract(1, "years"),
            timePicker: true,
            timePicker24Hour: false,
            locale: {
                format: 'DD MMM YYYY hh:mm A'
            }
        };

        var analyticsCreateTitle = 'Create Issue';
        var analyticsCreateUrl = 'create-issue';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Task In' + document.title, ANALYTICS_CONSTANT.open);


        vm.openConfirmationModal = openConfirmationModal;
        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.isInvalidForm = isInvalidForm;


        init();

        function init() {
            if(!vm.loggedInUser.employeeRoles.includes('ISSUE_CREATOR'))
                return cancelCurrentOperation();
            var promises = [];
            promises.push(getAllProjects());
            promises.push(getFilteredEmployeeNames());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                });
        }

        function getAllProjects() {
            projectService.getProjectList().then(function (data) {
                vm.allProjects = data.projects;
            }, function (message) {
                toastrService.showErrorToastr("Couldn't fetch project list: " + message, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function openConfirmationModal() {
            var confirmationText = "Are you sure you want to create a new issue? Please check the issue before creating.";
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                createIssue();
            });
        }

        function createIssue() {
            toastrService.clearPreviousToastr();

            var data = {
                    issueProjectId: vm.selectedProject[0].id,
                    priority: Number(vm.selectedPriority),
                    description: !!vm.create.description ? vm.create.description.trim() : null,
                    allocatedTo: vm.create.allocateTo[0].id,
                    status: Number(vm.selectedStatus),
                    issueDate: Number(vm.issueDateTimePicker.date.format('x'))
            };

            vm.isCreating = true;
            projectIssuesService.createIssue(data, vm.create.supportDoc).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create Issue', analyticsCreateUrl + '/create', 'Create Issue In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.showSuccessToastr("Successfully created issue.");
                $state.go('projectManagement.projectIssues');
            }, function (error) {
                toastrService.showErrorToastr("Failed to create issue - " + error, "", 5000);
            }).finally(function () {
                vm.isCreating = false;
            });
        }

        function isInvalidForm() {
            if(vm.selectedProject == null || vm.selectedProject.length === 0) return true;
            if (vm.create.allocateTo == null || vm.create.allocateTo.length === 0) return true;
        }

        function cancelCurrentOperation() {
            $state.go("projectManagement.projectIssues");
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projectIssues')
        .controller('EditIssueCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'projectService', 'projectIssuesService', 'moment', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', 'employeeService', 'ISSUE_PRIORITIES', 'ISSUE_STATUSES', EditIssueCtrl]);


    function EditIssueCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, projectService, projectIssuesService, moment, utilService, analyticsService, ANALYTICS_CONSTANT, employeeService, ISSUE_PRIORITIES, ISSUE_STATUSES) {
        var vm = this;

        vm.loggedInUser = authService.getLoggedInUser();
        vm.issue = $stateParams.issueDetails;

        vm.isDataLoaded = false;
        vm.isUpdating = false;
        vm.editIssueForm = null;
        vm.edit = {};
        vm.edit.projectName = null;
        vm.edit.projectRefCode = null;
        vm.edit.priority = null;
        vm.edit.supportDoc = null;
        vm.edit.description = null;
        vm.edit.allocateTo = [];
        vm.edit.submittedBy = null;
        vm.edit.entryDateTime = moment();

        vm.allProjects = [];
        vm.employeeList = [];
        vm.priorityList = angular.copy(ISSUE_PRIORITIES);
        vm.statusList = angular.copy(ISSUE_STATUSES);
        vm.selectedProject = [];
        vm.selectedPriority = null;
        vm.selectedStatus = null;

        vm.issueDateTimePicker = {};
        vm.issueDateTimePicker.date = moment();
        vm.issueDateTimePicker.options = {
            singleDatePicker: true,
            minDate: moment().startOf('day').subtract(1, "years"),
            timePicker: true,
            timePicker24Hour: false,
            locale: {
                format: 'DD MMM YYYY hh:mm A'
            }
        };

        vm.entryDateTimePicker = {};
        vm.entryDateTimePicker.date = moment();
        vm.entryDateTimePicker.options = {
            singleDatePicker: true,
            minDate: moment().startOf('day').subtract(1, "years"),
            timePicker: true,
            timePicker24Hour: false,
            locale: {
                format: 'DD MMM YYYY hh:mm A'
            }
        };

        var analyticsCreateTitle = 'Edit Issue';
        var analyticsCreateUrl = 'edit-issue';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Edit Issue In' + document.title, ANALYTICS_CONSTANT.open);


        vm.openConfirmationModal = openConfirmationModal;
        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.isInvalidForm = isInvalidForm;


        init();

        function init() {
            if(vm.issue == null || vm.issue.id == null) return cancelCurrentOperation();
            var promises = [];
            promises.push(getAllProjects());
            promises.push(getFilteredEmployeeNames());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                    initialiseForm();
                });
        }

        function getAllProjects() {
            projectService.getProjectList().then(function (data) {
                vm.allProjects = data.projects;
            }, function (message) {
                toastrService.showErrorToastr("Couldn't fetch project list: " + message, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function openConfirmationModal() {
            var confirmationText = "Are you sure you want to update this issue? Please check the issue before saving.";
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                updateIssue();
            });
        }

        function updateIssue() {
            toastrService.clearPreviousToastr();

            var data = {
                issueId: vm.issue.id,
                issueProjectId: vm.selectedProject[0].id,
                priority: !!vm.selectedPriority ? Number(vm.selectedPriority) : null,
                description: !!vm.edit.description ? vm.edit.description.trim() : null,
                allocatedTo: !!vm.edit.allocateTo && vm.edit.allocateTo.length > 0 ? vm.edit.allocateTo[0].id : null,
                status: !!vm.selectedStatus ? Number(vm.selectedStatus) : null,
                issueDate: !!vm.issueDateTimePicker.date ? Number(vm.issueDateTimePicker.date.format('x')) : null
            };

            vm.isUpdating = true;
            projectIssuesService.updateIssue(data, vm.edit.supportDoc).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Edit Issue', analyticsCreateUrl + '/edit', 'Edit Issue In' + document.title, ANALYTICS_CONSTANT.edit)
                toastrService.showSuccessToastr("Successfully updated issue.");
                $state.go('projectManagement.projectIssues');
            }, function (error) {
                toastrService.showErrorToastr("Failed to update issue: " + error, "", 5000);
            }).finally(function () {
                vm.isUpdating = false;
            });
        }

        function isInvalidForm() {
            if(vm.selectedProject == null || vm.selectedProject.length === 0) return true;
            if (vm.edit.allocateTo == null || vm.edit.allocateTo.length === 0) return true;
        }

        function cancelCurrentOperation() {
            $state.go("projectManagement.projectIssues");
        }

        function initialiseForm() {

            vm.edit.description = vm.issue.description;
            vm.employeeList.forEach(function (item) {
                item.ticked = (item.id === vm.issue.assigneeId);
            });
            vm.issueDateTimePicker.date = moment(vm.issue.issueDate);
            vm.edit.entryDateTime = moment();

            vm.allProjects.forEach(function (item) {
                item.ticked = (item.id === vm.issue.projectId);
            });

            vm.selectedPriority = vm.issue.priority;
            vm.selectedStatus = vm.issue.status;
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projectIssues')
        .controller('ViewIssueCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', '$q', '_', 'projectIssuesService', 'moment', 'utilService', 'employeeService', 'ISSUE_STATUSES', '$sce', ViewIssueCtrl]);


    function ViewIssueCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, $q, _, projectIssuesService, moment, utilService, employeeService, ISSUE_STATUSES, $sce) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.issue = $stateParams.issueDetails
        vm.updateLogEnabled = false;
        vm.updateWindowVisible = false;
        vm.isDataLoaded = false;
        vm.issueLogs = [];
        vm.attachedFileName = "N/A";

        vm.employees = [];
        vm.selectedAssignee = [];
        vm.statusList = angular.copy(ISSUE_STATUSES);
        vm.selectedStatus = null;
        vm.remarks = null;

        vm.isUpdating = false;

        vm.showUpdateWindow = showUpdateWindow;
        vm.submitOrShowConfirmationModal = submitOrShowConfirmationModal;

        function init() {
            if(vm.issue == null || vm.issue.id == null) return cancelCurrentOperation();
            vm.updateWindowVisible = false;
            var promises = [];
            promises.push(getFilteredEmployeeNames());
            promises.push(getAllIssueLogs());

            $q.all(promises).then(function () {
                vm.isDataLoaded = true;
                setAttachedFileName();
                vm.updateLogEnabled = vm.issue.assigneeId === loggedInUser.id && vm.issue.status !== 4;
            });

        }

        init();

        function cancelCurrentOperation() {
            $state.go("projectManagement.projectIssues");
        }

        function showUpdateWindow() {
            vm.updateWindowVisible = true;
        }

        function resetFormFields() {
            vm.selectedAssignee = [];
            vm.selectedStatus = null;
            vm.remarks = null;
        }

        function getAllIssueLogs() {
            return projectIssuesService.getAllIssueLogs(vm.issue.id).then(function (data) {
                vm.issueLogs = data.logs;
                if(vm.issueLogs.length > 0) {
                    vm.issueLogs.forEach(function (item) {
                        item.logText = $sce.trustAsHtml(item.logText);
                    });
                }
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch logs: " + error, "", 5000);
            });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status: 1, excludedEmployeeIds: []}).then(function (data) {
                vm.employees = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function setAttachedFileName() {
            if(vm.issue.documentUrl != null && vm.issue.documentUrl !== "") {
                vm.attachedFileName = vm.issue.documentUrl.substring(vm.issue.documentUrl.lastIndexOf('/') + 1);
            }
        }

        function updateIssueLog() {
            if(vm.selectedAssignee.length === 0 && !vm.selectedStatus && !vm.remarks) return;
            var formData = {
                issueId : vm.issue.id
            };
            if(!!vm.selectedAssignee && vm.selectedAssignee.length > 0)
                formData.transferTo = vm.selectedAssignee[0].id;
            if(!!vm.selectedStatus)
                formData.status = Number(vm.selectedStatus);
            if(!!vm.remarks)
                formData.remarks = vm.remarks;

            vm.isUpdating = true;
            projectIssuesService.updateIssueLog(formData).then(function (data) {
                toastrService.showSuccessToastr("Successfully updated issue log.");
                refreshData();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update issue log: " + error, "", 5000);
            }).finally(function () {
                vm.isUpdating = false;
            });
        }

        function refreshData() {
            vm.isDataLoaded = false;
            resetFormFields();
            projectIssuesService.getIssueDetails(vm.issue.id).then(function (data) {
                vm.issue = data.issue;
                init();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't get issue details: " + error, "", 5000);
            });
        }

        function submitOrShowConfirmationModal() {
            if(!!vm.selectedStatus && Number(vm.selectedStatus === 4)) {
                openConfirmationModalOnIssueClose();
            } else {
                updateIssueLog();
            }
        }

        function openConfirmationModalOnIssueClose() {
            var confirmationText = 'Are you sure you want to <em class="red-text">Close</em> the issue? Please verify that the issue is solved before closing the issue.';
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                updateIssueLog();
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('CreateProjectCtrl', ['$scope', '$state', 'employeeService', 'toastrService', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', 'projectService','projectClientService', 'productService', '$uibModal', CreateProjectCtrl]);

    /** @ngInject */
    function CreateProjectCtrl($scope, $state, employeeService, toastrService, $q, analyticsService, ANALYTICS_CONSTANT, projectService, projectClientService, productService, $uibModal) {
        var vm = this;
        vm.isDataLoaded = false;
        vm.employeeList = [];
        vm.projectTypes = [];
        vm.clients = [];
        vm.products = [];
        vm.createProjectForm = null;
        vm.isCreating = false;

        vm.projectName = null;
        vm.selectedProjectType = [];
        vm.selectedEmployee = [];
        vm.selectedClient = [];
        vm.selectedProduct = [];
        vm.referenceCode = null;

        vm.startDatePicker = {};
        vm.startDatePicker.date = moment().startOf('day');
        vm.startDatePicker.options = {
            singleDatePicker : true,
            startDate : moment(),
            minDate : moment().startOf('day').subtract(1, "years"),
            timePicker : false,
            timePicker24Hour : false,
            locale : {
                format : 'DD MMM YYYY'
            }
        };

        vm.dueDatePicker = {};
        vm.dueDatePicker.date = angular.copy(vm.startDatePicker.date);
        vm.dueDatePicker.options = {
            singleDatePicker : true,
            startDate : moment(),
            minDate : angular.copy(vm.startDatePicker.date),
            timePicker : false,
            timePicker24Hour : false,
            locale : {
                format : 'DD MMM YYYY'
            }
        };



        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.createProjectType = createProjectType;
        vm.isInvalidForm = isInvalidForm;
        vm.openConfirmationModal = openConfirmationModal;

        function init() {
            var promises = [];
            promises.push(getProjectTypes());
            promises.push(getFilteredEmployeeNames());
            promises.push(getClients());
            promises.push(getProducts());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                });
        }

        init();



        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function openConfirmationModal() {
            var confirmationText = "Are you sure you want to create a new project?";
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                submitForm();
            });
        }

        function submitForm() {
            var formData = {
                name : vm.projectName.trim(),
                referenceCode : vm.referenceCode.trim(),
                projectTypeId : vm.selectedProjectType[0].id,
                productId : vm.selectedProduct[0].id,
                ownerId : vm.selectedEmployee[0].id,
                projectClientId : vm.selectedClient[0].id,
                startTime : vm.startDatePicker.date.format('x'),
                dueDate : vm.dueDatePicker.date.format('x')
            };
            vm.isCreating = true;

            projectService.createProject(formData).then(function (data) {
                toastrService.showSuccessToastr("Project created successfully");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't create project: " + error, "", 5000);
            }).finally(function () {
                vm.isCreating = false;
                cancelCurrentOperation();
            });
        }

        function isInvalidForm() {
            if(vm.selectedEmployee == null || vm.selectedEmployee.length === 0) return true;
            if(vm.selectedProjectType == null || vm.selectedProjectType.length === 0) return true;
            if(vm.selectedClient == null || vm.selectedClient.length === 0) return true;
            if(vm.selectedProduct == null || vm.selectedProduct.length === 0) return true;
            if(vm.dueDatePicker.date.isBefore(vm.startDatePicker.date, 'day')) return true;
        }

        function cancelCurrentOperation() {
            $state.go("projectManagement.projects");
        }

        function getProjectTypes() {
            return projectService.getAllProjectTypes().then(function (data) {
                vm.projectTypes = data.allProjectTypes;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch project type list: " + error, "", 5000);
            });
        }

        function createProjectType(data) {
            projectService.createProjectType({name: data.trim()}).then(function (data) {
                toastrService.showSuccessToastr('Created Project Type Successfully');
                getProjectTypes();
            }, function (error) {
                toastrService.showErrorToastr('Failed to create project type: ' + error);
            });
        }

        function getClients() {
            return projectClientService.getSimplifiedProjectClientList().then(function (data) {
                vm.clients = data.clients;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch client list: " + error, "", 5000);
            });
        }

        function getProducts() {
            return productService.getSimplifiedProductList().then(function (data) {
                vm.products = data.products;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch product list: " + error, "", 5000);
            });
        }

        $scope.$watch('vm.startDatePicker.date', function () {
            vm.dueDatePicker.options.minDate = angular.copy(vm.startDatePicker.date);
            vm.dueDatePicker.date = angular.copy(vm.startDatePicker.date);
        });

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('DeleteProjectModalCtrl', ['$uibModalInstance','projectService', 'project', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', 'TDH_OFFICE_ID', DeleteProjectModalCtrl]);

    /** @ngInject */
    function DeleteProjectModalCtrl($uibModalInstance,projectService, project, toastrService, analyticsService, ANALYTICS_CONSTANT, TDH_OFFICE_ID) {

        var vm = this;

        vm.isDeleting = false;
        vm.project = {};
        vm.project = project;
        var analyticsDeleteTitle = 'Delete Projects Modal';
        var analyticsDeleteUrl = 'delete-projects';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Projects In' + document.title, ANALYTICS_CONSTANT.open);
        vm.deleteProject = deleteProject;

        function deleteProject() {
            vm.isDeleting = true;
            if(vm.project.officeId === TDH_OFFICE_ID) {
                projectService.deleteTdhProject(vm.project).then(function (projectList) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Projects In' + document.title, ANALYTICS_CONSTANT.delete);
                    toastrService.showSuccessToastr("Project deleted successfully!");
                    $uibModalInstance.close(projectList);
                }, function (message) {
                    toastrService.showErrorToastr("Failed to delete project - " + message, "", 5000);
                    $uibModalInstance.dismiss(message);
                }).finally(function () {
                    vm.isDeleting = false;
                });
            } else {
                projectService.deleteProject(vm.project.id).then(function (data) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Projects In' + document.title, ANALYTICS_CONSTANT.delete);
                    toastrService.showSuccessToastr("Project deleted successfully!");
                    $uibModalInstance.close();
                }, function (error) {
                    toastrService.showErrorToastr("Failed to delete project - " + error, "", 5000);
                    $uibModalInstance.dismiss(error);
                }).finally(function () {
                    vm.isDeleting = false;
                });
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('CreateProjectModalCtrl', ['$uibModalInstance','authService','projectService', 'teamService', 'employeeService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateProjectModalCtrl]);

    /** @ngInject */
    function CreateProjectModalCtrl( $uibModalInstance,authService,projectService, teamService, employeeService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.name = null;
        vm.create.description = null;
        vm.create.employeeIdList = [];
        vm.create.selectedTeam = null;
        vm.create.startTime = moment();
        vm.create.endTime = moment();

        vm.employees = [];
        var analyticsCreateTitle = 'Create Projects Modal';
        var analyticsCreateUrl = 'create-projects';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Projects In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createProject = createProject;

        init();

        function init() {
            employeeService.getFilteredEmployeeNames(true).then(function (data) {
                vm.employees = data.employees;
                getAllTeams()
            },function (message) {
                toastrService.showErrorToastr('Employee Fetching failed error: '+message, "", 5000);
            });
        }

        function createProject() {
            var employeeIdList = vm.create.employeeIdList.map(function (element) {
                return element.id;
            });
            if(!vm.create.name){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            var teamId = null;
            if (vm.create.selectedTeam != null) teamId = vm.create.selectedTeam[0] != null? vm.create.selectedTeam[0].id : null;
            var data =
                {
                    'name' : vm.create.name,
                    'description': vm.create.description,
                    'startTime' : vm.create.startTime.valueOf(),
                    'endTime' : vm.create.endTime.valueOf(),
                    'employeeIdList' : employeeIdList,
                    'teamId' : teamId
                };
            vm.isCreating = true;
            projectService.createProjectForTDH(data).then(function (projectList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Projects In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Project created!");
                $uibModalInstance.close(projectList);
            },function (error) {
                toastrService.showErrorToastr("Failed to create project - " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }

        function getAllTeams() {
            teamService.getAllTeams(true).then(function (data) {
                vm.allTeams = _.sortBy(data, function (team){
                    return team.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Team Fetching failed error: '+message, "", 5000);
                console.error('Team Fetching failed error: '+message);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.tasks')
        .controller('CreateTaskModalCtrl', ['$uibModalInstance','authService','projectService', 'taskService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateTaskModalCtrl]);

    /** @ngInject */
    function CreateTaskModalCtrl($uibModalInstance,authService,projectService, taskService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.name = null;
        vm.create.description = null;
        vm.create.employeeIdList = [];
        vm.create.projectWorkId = null;
        vm.create.startTime = moment();
        vm.create.endTime = moment();

        vm.allProjects = [];
        vm.employeeList = [];

        vm.selectedProject = null;
        var analyticsCreateTitle = 'Create Task';
        var analyticsCreateUrl = 'create-task';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Task In' + document.title, ANALYTICS_CONSTANT.open);
        vm.createTask = createTask;
        // vm.populateEmployeeIdList = populateEmployeeIdList;
        vm.populateEmployeeList = populateEmployeeList;
        init();

        function init() {
            getAllProjects();
        }

        function getAllProjects(){
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
            });
        }

        function populateEmployeeList(){
            vm.selectedProject = vm.selectedProject[0];
            projectService.getAllEmployees(vm.selectedProject.id).then(function (data) {
                vm.employeeList = data;
            },function (message) {
                toastrService.showErrorToastr('Employee fetching failed error: '+message, "", 5000);
            });
        }

        function createTask(){
            toastrService.clearPreviousToastr();
            if(!vm.create.name){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            if (!vm.selectedProject.id){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please select a project");
            }
            var employeeIdList = vm.create.employeeIdList.map(function (element) {
                return element.id;
            });
            var data =
                {
                    'name' : vm.create.name,
                    'description': vm.create.description,
                    'startTime' : vm.create.startTime.valueOf(),
                    'endTime' : vm.create.endTime.valueOf(),
                    'employeeIdList' : employeeIdList,
                    'projectWorkId' : vm.selectedProject.id,
                    'status' : 1
                };
            vm.isCreating = true;
            taskService.createTask(data).then(function (taskList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create Task', analyticsCreateUrl + '/create', 'Create Task In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.showSuccessToastr("Task created.");
                $uibModalInstance.close(taskList);
            },function (error) {
                toastrService.showErrorToastr("Failed to create task - " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.tasks')
        .controller('DeleteTaskModalCtrl', ['$uibModalInstance','taskService', 'task', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteTaskModalCtrl]);

    /** @ngInject */
    function DeleteTaskModalCtrl($uibModalInstance,taskService, task, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.task = {};
        vm.task = task;
        var analyticsDeleteTitle = 'Delete Task Modal';
        var analyticsDeleteUrl = 'delete-task';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Task In' + document.title, ANALYTICS_CONSTANT.open);
        vm.deleteTask = deleteTask;

        function deleteTask() {
            vm.isDeleting = true;
            vm.task.status = -1
            taskService.deleteTask(vm.task).then(function (taskList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete Task', analyticsDeleteUrl + '/delete', 'Delete Task In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Task deleted!");
                $uibModalInstance.close(taskList);
            }, function (message) {
                toastrService.showErrorToastr("Failed to delete task - " + message, "", 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('EditTaskCtrl', ['authService', '$stateParams', '$uibModal', 'taskService', 'employeeService', 'projectService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',EditTaskCtrl]);

    /** @ngInject */
    function EditTaskCtrl(authService, $stateParams, $uibModal, taskService, employeeService, projectService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.taskId = null;
        vm.task = null;
        vm.employees = [];
        vm.employeeIdList = [];
        vm.enabled = false;
        vm.isDataLoaded = false;
        vm.taskId = $stateParams.taskId;

        // vm.datePickerOptions = {
        //     singleDatePicker : true,
        //     autoApply : true,
        //     locale : {
        //         format : 'DD-MMM-YYYY'
        //     }
        // };


        vm.updateTaskDetails = updateTaskDetails;
        vm.addEmployeesToTask = addEmployeesToTask;
        vm.openConfirmationModal = openConfirmationModal;

        init();

        function init() {
            vm.isDataLoaded = false;
            taskService.getTask(vm.taskId).then(function (data) {
                vm.task = data;
                vm.task.startTime = moment(data.startTime);
                vm.task.endTime = moment(data.endTime);
                vm.enabled = vm.task.status === 2;
                projectService.getAllEmployees(vm.task.projectWorkId).then(function (data) {
                    vm.employees = data;
                    vm.isDataLoaded = true;
                },function (message) {
                    toastrService.showErrorToastr('Employee fetching failed: '+message, "", 5000);
                });
            },function (message) {
                toastrService.showErrorToastr('Task fetching error: '+message, "", 5000);
            });

            // employeeService.getFilteredEmployeeNames(true).then(function (data) {
            //     vm.employees = data.employees;
            // },function (message) {
            //     console.error('Employee Fetching failed error: '+message);
            // });
            // vm.employees.filter(function (employee) {
            //     return !isEmployeeInTask(employee.id);
            // });

        }

        function isEmployeeInTask(employeeId) {
            vm.task.employees.forEach(function (employee) {
                if (employeeId === employee.id) return true;
            });
            return false;
        }


        function updateTaskDetails() {
            toastrService.clearPreviousToastr();
            if(!vm.task.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            var data = {
                'name' : vm.task.name,
                'description': vm.task.description,
                'startTime' : vm.task.startTime.startOf('day').valueOf(),
                'endTime' : vm.task.endTime.endOf('day').valueOf(),
                'status' : vm.enabled? 2 : 1,
            };
            vm.isEditing = true;
            taskService.updateTaskInfo(data, vm.task).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save Changes', '', 'Save Changes In' + document.title, ANALYTICS_CONSTANT.save)
                toastrService.showSuccessToastr("Task updated.");
                init();
            }, function (message) {
                toastrService.showErrorToastr("Failed to update task - " + message, "", 5000);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function addEmployeesToTask() {
            var employeeIdList = vm.employeeIdList.map(function (element) {
                return element.id;
            });
            var data = {
                employeeIdList : employeeIdList
            }
            taskService.addEmployeesToTask(data, vm.task.id).then(function (task) {
                analyticsService.sendData(ANALYTICS_CONSTANT.add, document.title + ' - Add People', '', 'Add People In' + document.title, ANALYTICS_CONSTANT.add)
                toastrService.showSuccessToastr("People added.");
                vm.task = task;
                vm.task.startTime = moment(task.startTime);
                vm.task.endTime = moment(task.endTime);
            }, function (message) {
                toastrService.showErrorToastr("Failed to add people - " + message, "", 5000);
            });

            resetEmployeeSelectionList();
        }

        function openConfirmationModal(teamMember) {
            var confirmationText = 'Do you want to remove <em class="text-highlight">' +  teamMember.name + '</em> from the task?';
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                removeEmployeeFromTask(teamMember.id);
            });
        }

        function removeEmployeeFromTask(employeeId) {
            taskService.removeEmployeeFromTask(vm.task.id, employeeId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.remove, document.title + ' - Remove People', '', 'Remove People In' + document.title, ANALYTICS_CONSTANT.remove)
                toastrService.showSuccessToastr("Employee removed");
                vm.task.employees = vm.task.employees.filter(function (employee) {
                    return employee.id !== employeeId;
                });
            }, function (message) {
                toastrService.showErrorToastr("Failed to update task - " + message, "", 5000);
            });
        }

        function resetEmployeeSelectionList() {
            vm.employeeIdList = [];
            vm.employees.forEach(function (item) {
                item.ticked = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('CreateTeamModalCtrl', ['$uibModalInstance','authService','teamService', 'employeeService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateTeamModalCtrl]);

    /** @ngInject */
    function CreateTeamModalCtrl( $uibModalInstance,authService,teamService, employeeService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.name = null;
        vm.create.description = null;
        vm.create.employeeIdList = [];

        vm.employees = [];
        var analyticsCreateTitle = 'Create Team Modal';
        var analyticsCreateUrl = 'create-team-category';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Team In' + document.title, ANALYTICS_CONSTANT.open);
        vm.createTeam = createTeam;

        init();

        function init() {
            employeeService.getFilteredEmployeeNames(true).then(function (data) {
                vm.employees = data.employees;
            },function (message) {
                toastrService.showErrorToastr('Employee Fetching failed error: '+message, "", 5000);
            });
        }

        function createTeam() {
            toastrService.clearPreviousToastr();
            var employeeIdList = vm.create.employeeIdList.map(function (element) {
                return element.id;
            });

            if(!vm.create.name){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            if(employeeIdList.length === 0){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please add at least one employee to the team");
            }
            var data = {
                    'name' : vm.create.name,
                    'description': vm.create.description,
                    'employeeIdList' : employeeIdList
                };
            vm.isCreating = true;
            teamService.createTeam(data).then(function (teamList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create Team', analyticsCreateUrl + '/create', 'Create Team In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.showSuccessToastr("Team created.");
                $uibModalInstance.close(teamList);
            },function (error) {
                toastrService.showErrorToastr("Failed to create team - " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.teams')
        .controller('DeleteTeamModalCtrl', ['$uibModalInstance','teamService', 'team', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteTeamModalCtrl]);

    /** @ngInject */
    function DeleteTeamModalCtrl($uibModalInstance,teamService, team, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.team = {};
        vm.team = team;
        var analyticsDeleteTitle = 'Delete Team';
        var analyticsDeleteUrl = 'delete-team';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Team In' + document.title, ANALYTICS_CONSTANT.open);
        vm.deleteTeam = deleteTeam;

        function deleteTeam() {
            vm.isDeleting = true;
            teamService.deleteTeam(vm.team).then(function (teamList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete Team', analyticsDeleteUrl + '/delete', 'Delete Team In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Team deleted!");
                $uibModalInstance.close(teamList);
            }, function (message) {
                toastrService.showErrorToastr("Failed to delete team - " + message, "", 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('EditTeamCtrl', ['authService', '$stateParams','$uibModal', 'teamService', 'employeeService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', EditTeamCtrl]);

    /** @ngInject */
    function EditTeamCtrl(authService, $stateParams, $uibModal, teamService, employeeService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDataLoaded = false;
        vm.isEditing = false;
        vm.teamId = null;
        vm.team = null;
        vm.employees = [];
        vm.employeeIdList = [];
        vm.enabled = false;

        vm.updateTeamDetails = updateTeamDetails;
        vm.openConfirmationModal = openConfirmationModal;
        vm.addEmployeesToTeam = addEmployeesToTeam;


        init();

        function init() {

            vm.teamId = $stateParams.teamId;
            teamService.getTeam(vm.teamId).then(function (data) {
                vm.team = data;
                vm.isDataLoaded = true;
                vm.enabled = (vm.team.status === 1);
            },function (message) {
                toastrService.showErrorToastr('Team Fetching failed error: '+message, "", 5000);
            });

            employeeService.getFilteredEmployeeNames(true).then(function (data) {
                vm.employees = data.employees;
            },function (message) {
                toastrService.showErrorToastr('Employee Fetching failed error: '+message, "", 5000);
            });
            // vm.employees.filter(function (employee) {
            //     return !isEmployeeInTeam(employee.id);
            // });
        }

        function isEmployeeInTeam(employeeId) {
            vm.team.employees.forEach(function (employee) {
                if (employeeId === employee.id) return true;
            });
            return false;
        }


        function updateTeamDetails() {
            if(!vm.team.name){
                vm.isEditing = false
                return toastrService.showErrorToastr("Name can not be empty");
            }
            var data = {
                'name' : vm.team.name,
                'status' : vm.enabled ? 1 : 0,
                'description': vm.team.description
            };
            vm.isEditing = true;
            teamService.updateTeamInfo(data, vm.team.id).then(function (team) {
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save Changes', '', 'Save Changes In' + document.title, ANALYTICS_CONSTANT.save);
                toastrService.showSuccessToastr("Team updated.");
                vm.team = team;
            }, function (message) {
                toastrService.showErrorToastr("Failed to update team - " + message, "", 5000);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function addEmployeesToTeam() {
            var employeeIdList = vm.employeeIdList.map(function (element) {
                return element.id;
            });
            if(employeeIdList.length === 0)
                return toastrService.showErrorToastr("No employee selected");
            var data = {
                employeeIdList : employeeIdList
            }

            teamService.addEmployeesToTeam(data, vm.team.id).then(function (team) {
                analyticsService.sendData(ANALYTICS_CONSTANT.add, document.title + ' - Add People', '', 'Add People In ' + document.title, ANALYTICS_CONSTANT.add);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Employee added");
                vm.team = team;
            }, function (message) {
                toastrService.showErrorToastr("Failed to add people - " + message, "", 5000);
            });

            resetEmployeeSelectionList();
        }

        function openConfirmationModal(teamMember) {
            var confirmationText = 'Do you want to remove <em class="text-highlight"> ' + teamMember.name + '</em> from the team?';
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                removeEmployeeFromTeam(teamMember.id);
            });
        }

        function removeEmployeeFromTeam(employeeId) {
            teamService.removeEmployeeFromTeam(vm.team.id, employeeId).then(function (team) {
                analyticsService.sendData(ANALYTICS_CONSTANT.remove, document.title + ' - Remove People', '', 'Remove People In' + document.title, ANALYTICS_CONSTANT.remove);
                toastrService.showSuccessToastr("Employee removed");
                vm.team.employees = vm.team.employees.filter(function (employee) {
                    return employee.id !== employeeId;
                });
            }, function (message) {
                toastrService.showErrorToastr("Failed to remove employee - " + message);
            });
        }

        function resetEmployeeSelectionList() {
            vm.employeeIdList = [];
            vm.employees.forEach(function (item) {
                item.ticked = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.accessArea')
    app.controller('AccessAreaCreateModalCtrl', ['accessAreaService','authService','$uibModalInstance','toastrService', 'deviceService', 'analyticsService', 'ANALYTICS_CONSTANT',AccessAreaCreateModalCtrl]);

    /** @ngInject */
    function AccessAreaCreateModalCtrl(accessAreaService,authService,$uibModalInstance,toastrService, deviceService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.createAccessAreaName = null;
        vm.create.createAccessAreaCode = null;
        vm.categoryToChange = null;
        vm.allDevice = [];
        vm.selectedDevice = [];
        var loggedInUser = authService.getLoggedInUser();
        var analyticsCreateTitle = 'Create New Access Area Modal';
        var analyticsCreateUrl = 'create-new-access-area';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create New Access Area In' + document.title, ANALYTICS_CONSTANT.open);


        vm.createAccessArea = createAccessArea;
        // vm.deleteAccessAreaName = deleteAccessAreaName;

        function init() {
            // vm.categoryToChange = categoryToChange;
            deviceService.getAllDevices(loggedInUser.officeId).then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    data[i]["label"] = data[i]["identifier"] + " - " + data[i]["location"];
                }
                vm.devices = data;
                vm.allDevice = angular.copy(vm.devices);
            }, function (error) {
                console.error("Could not fetch device list : " + error);
            });
        }

        init();

        function createAccessArea () {
            toastrService.clearPreviousToastr();
            if(vm.create.createAccessAreaName === null){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Access area name cannot be empty");
            }
            if(vm.create.createAccessAreaCode === null){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Access area code cannot be empty");
            }

            vm.isCreating = true;
            accessAreaService.createAccessArea({
                name:vm.create.createAccessAreaName,
                code:vm.create.createAccessAreaCode,
                deviceIds: vm.selectedDevice.map(function (device) {return device.id}),
                officeId:authService.getAllInformation().office.id,
                createdBy:authService.getAllInformation().id,
            }).then(onAccessAreaCreateSuccess, onAccessAreaCreateFailure).finally(function () {
                vm.isCreating = false;
            });
        }

        function onAccessAreaCreateSuccess(accessAreas) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create New Access Area In' + document.title, ANALYTICS_CONSTANT.create);
            toastrService.showSuccessToastr("Access Area Created Successfully")
            $uibModalInstance.close(accessAreas);
        }

        function onAccessAreaCreateFailure(error) {
            toastrService.showErrorToastr("Error; " + error, "", 5000);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.accessArea')
    app.controller('AccessAreaDeleteModalCtrl', ['accessAreaService','authService','$uibModalInstance','toastrService','accessAreaToChange', 'analyticsService', 'ANALYTICS_CONSTANT',AccessAreaDeleteModalCtrl]);

    /** @ngInject */
    function AccessAreaDeleteModalCtrl(accessAreaService,authService,$uibModalInstance,toastrService,accessAreaToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.accessAreaToChange = null;
        var analyticsDeleteTitle = 'Delete Access Area Modal';
        var analyticsDeleteUrl = 'delete-access-area';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Access Area In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteAccessAreaName = deleteAccessAreaName;

        function init() {
            vm.accessAreaToChange = accessAreaToChange;
        }

        init();

        function deleteAccessAreaName(accessAreaId) {
            vm.isDeleting = true;
            accessAreaService.deleteAccessArea(accessAreaId).then(onAccessAreaDeleteSuccess,onAccessAreaDeleteFailure).
            finally(function () {
                vm.isDeleting = false;
            });
        }

        function onAccessAreaDeleteSuccess() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Access Area In' + document.title, ANALYTICS_CONSTANT.delete);
            $uibModalInstance.close();
            toastrService.showSuccessToastr("Access Area Deleted");
        }

        function onAccessAreaDeleteFailure(error) {
            toastrService.showErrorToastr("Could not delete: " + error, "", 5000);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.accessArea')
    app.controller('AccessAreaUpdateModalCtrl', ['accessAreaService','authService','$uibModalInstance','toastrService','accessAreaToChange', 'deviceService', 'analyticsService', 'ANALYTICS_CONSTANT',AccessAreaUpdateModalCtrl]);

    /** @ngInject */
    function AccessAreaUpdateModalCtrl(accessAreaService,authService,$uibModalInstance,toastrService, accessAreaToChange, deviceService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.accessAreaToChange = null;
        vm.allDevice = [];
        vm.selectedDevice = [];
        var analyticsEditTitle = 'Edit Access Area Modal';
        var analyticsEditUrl = 'edit-access-area';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Access Area In' + document.title, ANALYTICS_CONSTANT.open);

        var loggedInUser = authService.getLoggedInUser();

        vm.updateAccessAreaName = updateAccessAreaName;

        function init() {
            vm.accessAreaToChange = accessAreaToChange;
            deviceService.getAllDevices(loggedInUser.officeId).then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    data[i]["label"] = data[i]["identifier"] + " - " + data[i]["location"];
                }
                vm.devices = data;
                vm.allDevice = angular.copy(vm.devices);
                var accessAreaDevices = vm.accessAreaToChange.deviceAccessAreaList.map(function (area){
                    return area.deviceId;
                })
                vm.selectedDevice = vm.allDevice.forEach(function (device){
                    if(accessAreaDevices.includes(device.id)) device.ticked = true
                });

            }, function (error) {
                console.error("Could not fetch device list : " + error);
            });
         }

        init();

        function updateAccessAreaName () {
            toastrService.clearPreviousToastr();
            if(!vm.accessAreaToChange.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Access Area name cannot be empty")
            }

            if(!vm.accessAreaToChange.code){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Access Area code cannot be empty")
            }

            vm.isEditing = true;
            accessAreaService.updateAccessArea(vm.accessAreaToChange.id, {
                name:vm.accessAreaToChange.name,
                code:vm.accessAreaToChange.code,
                deviceIds: vm.selectedDevice.map(function (device) {return device.id})
            }).then(onAccessAreaNameUpdateSuccess,onAccessAreaNameUpdateFailure).finally(function () {
                vm.isEditing = false;
            });
        }

        function onAccessAreaNameUpdateSuccess(data) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Access Area In' + document.title, ANALYTICS_CONSTANT.edit);
            $uibModalInstance.close(data);
        }

        function onAccessAreaNameUpdateFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.departments')
        .controller('CreateDepartmentModalCtrl', ['$uibModalInstance','authService','departmentService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateDepartmentModalCtrl]);

    /** @ngInject */
    function CreateDepartmentModalCtrl( $uibModalInstance,authService,departmentService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.name = null;
        vm.create.status = null;
        vm.create.hierarchy = null;

        var analyticsCreateTitle = 'Create Department Modal';
        var analyticsCreateUrl = 'create-department';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Designation In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createDepartment = createDepartment;

        function createDepartment() {
            toastrService.clearPreviousToastr();
            if(!vm.create.name || vm.create.name > 50){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Length of name must be between 1 and 50 characters")
            }
            if(!vm.create.hierarchy){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please add hierarchy value")
            }
            var data =
                {
                    'name' : vm.create.name,
                    'officeId' : authService.getLoggedInUser().office.id,
                    'hierarchy': vm.create.hierarchy
                };
            vm.isCreating = true;
            departmentService.createDepartment(data).then(function (departmentList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Department In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.showSuccessToastr("Department created successfully")
                $uibModalInstance.close(departmentList);
            },function (error) {
                toastrService.showErrorToastr("Failed to create department - " + error, '', 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.departments')
        .controller('DeleteDepartmentModalCtrl', ['$uibModalInstance','departmentService', 'department', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteDepartmentModalCtrl]);

    /** @ngInject */
    function DeleteDepartmentModalCtrl($uibModalInstance,departmentService, department, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.department = {};
        vm.department = department;

        var analyticsDeleteTitle = 'Delete Department Modal';
        var analyticsDeleteUrl = 'delete-department';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Department In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteDepartment = deleteDepartment;

        function deleteDepartment() {
            vm.isDeleting = true;
            var data = {
                'status' : -1
            };
            departmentService.updateDepartmentInfo(data, vm.department.id).then(function (departmentList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Department In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Department deleted successfully");
                $uibModalInstance.close(departmentList);
            }, function (message) {
                toastrService.showErrorToastr("Failed to delete department - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.settings.departments')
        .controller('DepartmentDetailsCtrl', ['_','employeeService', 'authService', 'toastr','$stateParams', DepartmentDetailsCtrl]);

    /** @ngInject */
    function DepartmentDetailsCtrl(_,employeeService, authService, toastr,$stateParams) {

        var vm = this;

        vm.showFilters = null;
        vm.employeeList = null;
        vm.employeeListToShow = null;
        vm.isEmployeeListLoaded = null;
        vm.employeeName = null;
        vm.sortingMethods = {
            sortByName : sortByName,
            sortByDepartmentName : sortByDepartmentName,
            sortByShiftName : sortByShiftName,
            sortByDesignationName : sortByDesignationName,
            sortByHierarchy : sortByHierarchy,

        };
        vm.getStatusInText = getStatusInText;
        vm.searchDevice = searchDevice;

        var sortStatus = {
            key : "name",
            order : "ascending"
        };

        function init() {
            vm.isEmployeeListLoaded = false;
            getAllEmployees([authService.getLoggedInUser().office.company.id], [authService.getLoggedInUser().office.id],[$stateParams.departmentId]);
        }
        init();

        function getAllEmployees(companies, offices, departments, shifts, name) {
            employeeService.getFilteredEmployees(companies, offices, departments, shifts, name).then(onEmployeeFetchSuccess, onEmployeeFetchFailure);
        }

        function onEmployeeFetchSuccess(data) {
            vm.isEmployeeListLoaded = true;
            vm.employeeList = data.employees;
            vm.employeeListToShow = data.employees;
        }

        function onEmployeeFetchFailure() {
            vm.isEmployeeListLoaded = true;
            toastr.error('Could not fetch employee list');
        }

        function sortByName() {
            if(sortStatus.key === "name" && sortStatus.order === "ascending") {
                vm.employeeList.sort(function (a,b) {
                   return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                });
                sortStatus.key = "name";
                sortStatus.order = "descending";
            } else {
                vm.employeeList.sort(function (a,b) {
                    return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                }).reverse();
                sortStatus.key = "name";
                sortStatus.order = "ascending";
            }
        }
        function sortByDepartmentName() {
            if(sortStatus.key == "departmentName" && sortStatus.order == "ascending") {
                vm.employeeList = _.sortBy(vm.employeeList,function (emp) {
                    return emp.department.name;
                }).reverse();
                sortStatus.key = "departmentName";
                sortStatus.order = "descending";
            } else {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.department.name;
                });
                sortStatus.key = "departmentName";
                sortStatus.order = "ascending";
            }
        }

        function getStatusInText(status) {
            if(status === 0) return "Inactive";
            if(status === 1) return "Active";
            if(status === -1) return "Archived";
        }

        function sortByShiftName() {
            if(sortStatus.key == "shiftName" && sortStatus.order == "ascending") {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.shift.name;
                });
                vm.employeeList = vm.employeeList.reverse();
                sortStatus.key = "shiftName";
                sortStatus.order = "descending";
            } else {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.shift.name;
                });
                sortStatus.key = "shiftName";
                sortStatus.order = "ascending";
            }
        }

        function sortByDesignationName() {
            if(sortStatus.key == "designationName" && sortStatus.order == "ascending") {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.designation.name;
                }).reverse();
                sortStatus.key = "designationName";
                sortStatus.order = "descending";
            } else {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.designation.name;
                });
                sortStatus.key = "designationName";
                sortStatus.order = "ascending";
            }
        }

        function sortByHierarchy() {
            if(sortStatus.key == "hierarchyOrder" && sortStatus.order == "ascending") {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.designation.hierarchy;
                }).reverse();
                sortStatus.key = "hierarchyOrder";
                sortStatus.order = "descending";
            } else {
                vm.employeeList = _.sortBy(vm.employeeList, function (emp) {
                    return emp.designation.hierarchy;
                });
                sortStatus.key = "hierarchyOrder";
                sortStatus.order = "ascending";
            }
        }

        function searchDevice() {
            var filteredEmployeeList = _.filter(vm.employeeList,function (item) {
                return item.name.startsWith(vm.employeeName);
            });
            vm.employeeListToShow = filteredEmployeeList;
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.departments')
        .controller('EditDepartmentModalCtrl', ['authService', '$uibModalInstance','departmentService', 'officeService', 'department', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', EditDepartmentModalCtrl]);

    /** @ngInject */
    function EditDepartmentModalCtrl(authService, $uibModalInstance,departmentService, officeService, department,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.department = {};
        vm.department = department;

        var analyticsEditTitle = 'Edit Department Modal';
        var analyticsEditUrl = 'edit-department'
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Department In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateDepartmentDetails = updateDepartmentDetails;

        init();

        function init() {
            vm.department.enabled = vm.department.status === 1;
        }

        function updateDepartmentDetails() {
            toastrService.clearPreviousToastr();
            var data = {
                'name' : vm.department.name,
                'status' : vm.department.enabled? 1 : 0,
                'hierarchy': vm.department.hierarchy
            };
            if(!vm.department.name || vm.department.name.length > 50){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Length of name must be between 1 and 50 characters")
            }
            vm.isEditing = true;
            departmentService.updateDepartmentInfo(data, vm.department.id).then(function (department) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Department In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.showSuccessToastr("Department updated successfully");
                $uibModalInstance.close(department);
            }, function (message) {
                toastrService.showErrorToastr("Failed to update department - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isEditing = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.designations')
        .controller('CreateDesignationModalCtrl', ['$uibModalInstance', 'authService', 'designationService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateDesignationModalCtrl]);

    /** @ngInject */
    function CreateDesignationModalCtrl($uibModalInstance, authService, designationService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isCreating = false;
        vm.create = {};
        vm.create.cHierarchy = null;
        vm.create.cName = null;
        var analyticsCreateUrl = "create-designation";
        var analyticsCreateTitle = "Create Designation Modal";
        vm.createNewDesignation = createNewDesignation;
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Designation In' + document.title, ANALYTICS_CONSTANT.open);

        function createNewDesignation() {

            toastrService.clearPreviousToastr();
            if(vm.create.cName === null){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            if(vm.create.cHierarchy === null){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please add hierarchy value")
            }

            var data = {
                "hierarchy": vm.create.cHierarchy,
                "name": vm.create.cName,
                "officeId": authService.getAllInformation().office.id,
                "status": 1,
            };

            vm.isCreating = true;
            designationService.createDesignation(data).then(function createSuccessCallback(designation) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Designation In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Designation Created successfully");
                $uibModalInstance.close(designation);
            }, function createFailureCallback(error) {
                toastrService.showErrorToastr("Failed to create designation: " + error,'',5000);
                $uibModalInstance.dismiss(error);
            }).final(function () {
                vm.isCreating = false;
            });
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.designations')
        .controller('DeleteDesignationModalCtrl', ['$uibModalInstance', 'designationService', 'designation', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteDesignationModalCtrl]);

    /** @ngInject */
    function DeleteDesignationModalCtrl($uibModalInstance, designationService, designation, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isDeleting = false;
        vm.designation = designation;
        vm.deleteDesignation = deleteDesignation;
        var analyticsDeleteUrl = "delete-designation";
        var analyticsDeleteTitle = "Delete Designation Modal";
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Designation In' + document.title, ANALYTICS_CONSTANT.open);

        function deleteDesignation() {
            vm.isDeleting = true;
            var data = {
                'status': -1
            };
            designationService.updateDesignationInfo(data, vm.designation.id).then(function updateSuccessCallback(designationList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Designation In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Designation deleted");
                $uibModalInstance.close(designationList);
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to delete designation: " + error, '',5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.designations')
        .controller('EditDesignationModalCtrl', ['$uibModalInstance', 'designationService', 'toastrService', 'designation', 'analyticsService', 'ANALYTICS_CONSTANT', EditDesignationModalCtrl]);

    /** @ngInject */
    function EditDesignationModalCtrl($uibModalInstance, designationService, toastrService, designation, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isEditing = false;
        vm.designation = designation;
        var analyticsEditUrl="edit-designation";
        var analyticsEditTitle="Edit Designation Modal";
        vm.updateDesignationDetails = updateDesignationDetails;

        function init() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Designation In' + document.title, ANALYTICS_CONSTANT.open);

            vm.designation.enabled = vm.designation.status === 1;
        }

        init();

        function updateDesignationDetails() {
            toastrService.clearPreviousToastr();
            if(!vm.designation.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            if(!vm.designation.hierarchy){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Please add hierarchy value")
            }
            var data = {
                'name': vm.designation.name,
                'hierarchy': vm.designation.hierarchy,
                // 'status': vm.designation.enabled ? 1 : 0,
                'status': 1,
            };
            vm.isEditing = true;
            designationService.updateDesignationInfo(data, vm.designation.id).then(function updateSuccessCallback(designationList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Designation In' + document.title, ANALYTICS_CONSTANT.edit)
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Designation Updated");
                $uibModalInstance.close(designationList);
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to update designation: " + error,'',5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isEditing = false;
            });


        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.employmentType')
        .controller('DeleteEmploymentTypeModalCtrl', ['$uibModalInstance','employmentTypeService','employmentType', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteEmploymentTypeModalCtrl]);

    /** @ngInject */
    function DeleteEmploymentTypeModalCtrl($uibModalInstance,employmentTypeService,employmentType, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isDeleting = false;
        vm.employmentType = {};
        var analyticsDeleteTitle = 'Delete Employment Type Modal';
        var analyticsDeleteUrl = 'delete-employment-type';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Employment Type  In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteEmploymentType = deleteEmploymentType;

        function init() {
            vm.employmentType = employmentType;
        }

        init();

        function deleteEmploymentType() {
            vm.isDeleting = true;
            var data = {
                "status": -1,
            };
            employmentTypeService.editEmploymentType(data,employmentType.id).then(deleteSuccessCallback,createFailureCallback);
        }

        function deleteSuccessCallback(employmentType) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Employment Type In' + document.title, ANALYTICS_CONSTANT.delete);
            toastrService.showSuccessToastr("Employment Type deleted!");
            vm.isDeleting = false;
            $uibModalInstance.close(employmentType);
        }

        function createFailureCallback(error) {
            toastrService.showErrorToastr("Failed to delete Employment Type: " + error, '', 5000);
            vm.isDeleting = false;
            $uibModalInstance.dismiss(error);
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.employmentType')
        .controller('CreateEmploymentTypeModalCtrl', ['$uibModalInstance','authService','employmentTypeService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateEmploymentTypeModalCtrl]);

    /** @ngInject */
    function CreateEmploymentTypeModalCtrl($uibModalInstance,authService,employmentTypeService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isCreating = false;
        vm.name = null;
        vm.createEmploymentType = createEmploymentType;
        var analyticsCreateTitle = 'Create Employment Type Modal';
        var analyticsCreateUrl = 'create-employment-type';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Employment Type In' + document.title, ANALYTICS_CONSTANT.open);
        function createEmploymentType() {
            if(vm.name === null){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name cannot be empty");
            }
            var data = {
                "name": vm.name,
                "officeId" : authService.getAllInformation().office.id,
                "status" : 1,
            };
            vm.isCreating = true;
            employmentTypeService.createEmploymentType(data).then(createSuccessCallback,createFailureCallback);
        }

        function createSuccessCallback(employmentType) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Employment Type In' + document.title, ANALYTICS_CONSTANT.create);
            toastrService.showSuccessToastr("New Employment Type Created successfully");
            vm.isCreating = false;
            $uibModalInstance.close(employmentType);
        }

        function createFailureCallback(error) {
            toastrService.showErrorToastr("Failed to create New Employment Type: " + error, '', 5000);
            vm.isCreating = false;
            $uibModalInstance.dismiss(error);
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.employmentType')
        .controller('EditEmploymentTypeModalCtrl', ['$uibModalInstance','authService','employmentTypeService','toastrService','employmentType', 'analyticsService', 'ANALYTICS_CONSTANT', EditEmploymentTypeModalCtrl]);

    /** @ngInject */
    function EditEmploymentTypeModalCtrl($uibModalInstance,authService,employmentTypeService,toastrService,employmentType, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isEditing = false;
        vm.name = employmentType.name;

        vm.editEmploymentType = editEmploymentType;

        var analyticsEditTitle = 'Edit Employment Type Modal';
        var analyticsEditUrl = 'edit-employment-type';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Employment Type In' + document.title, ANALYTICS_CONSTANT.open);
        function editEmploymentType() {
            if(!vm.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name cannot be empty");
            }
            var data = {
                "name": vm.name,
            };
            vm.isEditing = true;
            employmentTypeService.editEmploymentType(data,employmentType.id).then(createSuccessCallback,createFailureCallback);
        }

        function createSuccessCallback(employmentType) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Employment Type In' + document.title, ANALYTICS_CONSTANT.edit);
            toastrService.showSuccessToastr("Employment Type updated.");
            vm.isEditing = false;
            $uibModalInstance.close(employmentType);
        }

        function createFailureCallback(error) {
            toastrService.showErrorToastr("Failed to update Employment Type: " + error, '', 5000);
            vm.isEditing = false;
            $uibModalInstance.dismiss(error);
        }
    }

})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.holidays')
        .controller('HolidayCreateModalCtrl',['holidayService','$uibModalInstance','toastrService','authService','utilService', 'analyticsService', 'ANALYTICS_CONSTANT',HolidayCreateModalCtrl]);

    function HolidayCreateModalCtrl(holidayService,$uibModalInstance,toastrService,authService,utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isCreating = false;
        vm.modal = {};
        vm.modal.newEvent = {};
        vm.modal.newEvent.description = null;
        vm.modal.newEvent.startDate = null;
        vm.modal.newEvent.isOpenStart = null;
        var analyticsAddTitle = 'Add New Holiday Modal';
        var analyticsAddUrl = 'add-holiday';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsAddTitle, analyticsAddUrl, 'Add New Holiday In' + document.title, ANALYTICS_CONSTANT.open);

        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.saveHoliday = saveHoliday;
        vm.openStart = openStart;

        function init() {
            vm.modal.newEvent.startDate = moment();
        }

        init();

        function openStart () {
            vm.modal.newEvent.isOpenStart = true;
        }

        function saveHoliday (event) {
            toastrService.clearPreviousToastr();
            if(vm.modal.newEvent.description === null){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Description can not be empty");
            }
            if(utilService.isDateEmpty(event.startDate)) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Date cannot be empty");

            }
            if(!utilService.isTimeInCurrentYear(event.startDate.format('x'))) {
                vm.isCreating = false;
                return toastrService.showErrorToastr('Date not within current year');

            }
            var data =
                {
                    description: event.description,
                    holidayDate: event.startDate.format('x'),
                    officeId : authService.getAllInformation().office.id,
                };
            vm.isCreating = true;
            holidayService.createHoliday(data).then(function (event) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsAddTitle + ' - Add', analyticsAddUrl + '/add', 'Add New Holiday In' + document.title, ANALYTICS_CONSTANT.add);
                    $uibModalInstance.close(event);
                },function (error) {
                    toastrService.showErrorToastr("Could not create Holiday:" + error, '', 5000);
                }).finally(function () {
                    vm.isCreating = false;
                });
        }

    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.holidays')
        .controller('HolidayDeleteModalCtrl',['holidayService','$uibModalInstance','toastrService','holidayToDelete', 'analyticsService', 'ANALYTICS_CONSTANT',HolidayDeleteModalCtrl]);

    function HolidayDeleteModalCtrl(holidayService,$uibModalInstance,toastrService,holidayToDelete, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDeleting = false;
        vm.holidayToDelete = null;

        vm.deleteHoliday = deleteHoliday;

        var analyticsDeleteTitle = 'Delete Holiday Modal';
        var analyticsDeleteUrl = 'delete-holiday';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Holiday In' + document.title, ANALYTICS_CONSTANT.open);

        function init() {
            vm.holidayToDelete = holidayToDelete;
        }

        init();

        function deleteHoliday (event) {
            vm.isDeleting = true;
            holidayService.updateHoliday(event.id,{status:-1}).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Holiday In' + document.title, ANALYTICS_CONSTANT.delete);
                $uibModalInstance.close()
            },function (error) {
                toastrService.showErrorToastr('Failed to delete holiday: '+ error, '', 5000);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }

    }
})();
(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.holidays')
        .controller('HolidayUpdateModalCtrl',['$uibModalInstance','holidayService','toastrService','utilService', 'holidayToUpdate', 'analyticsService', 'ANALYTICS_CONSTANT',HolidayUpdateModalCtrl]);

    function HolidayUpdateModalCtrl($uibModalInstance,holidayService,toastrService,utilService,holidayToUpdate, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isEditing = false;
        vm.modal = {};
        vm.modal.eventToChange = null;
        vm.eventDate = moment();
        vm.datePickerOptions = {
            singleDatePicker : true,
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };
        var analyticsUpdateTitle = 'Edit Holiday Modal';
        var analyticsUpdateUrl = 'edit-holiday';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsUpdateTitle, analyticsUpdateUrl, 'Edit Holiday In' + document.title, ANALYTICS_CONSTANT.open);


        vm.openStart = openStart;
        vm.openEnd = openEnd;
        vm.updateHoliday = updateHoliday;

        function init() {
            vm.modal.eventToChange = angular.copy(holidayToUpdate);
            vm.eventDate = new moment(vm.modal.eventToChange.holidayDate);
            // vm.datePickerOptions.startDate = vm.eventDate;
            // console.log(vm.modal.eventToChange);
        }

        init();

        function openStart () {
            vm.modal.eventToChange.isOpenStart = true;
        }

        function openEnd () {
            vm.modal.eventToChange.isOpenEnd = true;
        }

        function updateHoliday () {
            toastrService.clearPreviousToastr();
            vm.modal.eventToChange.holidayDate = vm.eventDate.startOf('day').format('x');

            if(!vm.modal.eventToChange.description){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Description can not be empty");
            }
            if(utilService.isDateEmpty(vm.modal.eventToChange.holidayDate)) {
                vm.isEditing = false;
                return toastrService.showErrorToastr("Date cannot be empty");

            }
            if(!utilService.isTimeInCurrentYear(vm.modal.eventToChange.holidayDate)) {
                vm.isEditing = false;
                return toastrService.showErrorToastr('Date not within current year');

            }

            var data = {
                    description: vm.modal.eventToChange.description,
                    holidayDate: vm.modal.eventToChange.holidayDate
            };
            vm.isEditing = true;
            holidayService.updateHoliday( vm.modal.eventToChange.id,data).then(function (eventFromApi) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsUpdateTitle + ' - Edit', analyticsUpdateUrl + '/edit', 'Edit Holiday In' + document.title, ANALYTICS_CONSTANT.edit);
                $uibModalInstance.close(eventFromApi);
            },function (error) {
                return toastrService.showErrorToastr("Holiday could not be updated: " + error, '', 5000);
            }).finally(function () {
                vm.isEditing = false;
            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.manageEmployees')
        .controller('GeoFencingSettingCtrl', ['$scope', 'toastrService', '$uibModal', 'editableOptions', 'editableThemes', '_', 'employeeService', 'geoFencingService', 'designationService', 'departmentService', 'shiftService', 'shiftGroupService','companyService', 'officeService', 'authService', 'toastr', '$state', 'aclLevel','workplaceService','employmentTypeService','mobilePunchService', 'utilService', 'EMPLOYEE_STATUS', 'GENDER', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', 'subsidiaryService', '$timeout', GeoFencingSettingCtrl]);

    /** @ngInject */
    function GeoFencingSettingCtrl($scope, toastrService, $uibModal, editableOptions, editableThemes, _, employeeService, geoFencingService, designationService, departmentService, shiftService, shiftGroupService, companyService, officeService, authService, toastr, $state, aclLevel,workplaceService, employmentTypeService,mobilePunchService, utilService, EMPLOYEE_STATUS, GENDER, analyticsService, ANALYTICS_CONSTANT, MODULES, subsidiaryService, $timeout) {

        var vm = this;

        vm.allEmployees = null;
        vm.checkbox = {};
        vm.checkbox.isAnySelected = false;
        vm.checkbox.isAllSelected = false;
        vm.showDiv = false;
        vm.isEmployeeListLoaded = null;
        vm.rowsToShow = 100;
        vm.showEnrolmentStatus = false;
        vm.selectedPaginationPage = 0;
        vm.mobileStatus = true;

        vm.departmentList = [];
        vm.designationList = [];
        vm.shiftList = [];
        vm.shiftGroupList = [];
        vm.employmentTypeList = [];
        vm.companyList = [];
        vm.officeList = [];
        vm.workplaceList = [];
        vm.subsidiaryList = [];
        vm.genderList = GENDER;
        vm.employeeStatusList = EMPLOYEE_STATUS;
        vm.enrolmentStatus = [];
        vm.availableGeoFencingStatusList = [{name :'Active', value:true}, {name : 'Inactive', value : false}];

        vm.search = {};
        vm.search.searchName = "";
        vm.search.departmentList = [];
        vm.search.designationList = [];
        vm.search.shiftGroupList = [];
        vm.search.employmentTypeList = [];
        vm.search.workplaceList = [];
        vm.search.subsidiaryList = [];
        vm.search.selectedSubsidiaryList = [];
        vm.search.selectedDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedShiftList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedEmploymentTypeList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedGenderList = [];
        vm.search.selectedemployeeStatusList = [{ id: 1}];
        vm.search.selectedGeoFencingStatusList = [];
        var loggedInuser = authService.getLoggedInUser();
        vm.isCompanyAdmin = loggedInuser.isCompanyAdmin;
        vm.isLineManager = loggedInuser.isLineManager && !loggedInuser.isAdmin;
        vm.isSubsidiaryModuleEnabled = loggedInuser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSuperAdmin = loggedInuser.isAdmin && !vm.isSubsidiaryModuleEnabled;
        vm.isSubsidiaryAdmin = loggedInuser.isAdmin && vm.isSubsidiaryModuleEnabled && loggedInuser.subsidiaryId != null;
        vm.subsidiaryView = loggedInuser.isAdmin && loggedInuser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;

        vm.total = 0;
        vm.excelUrl = "";

        vm.sortKeys = {
            'Report Position' : {value : 'reportPosition', order:'asc', selected : false},
            'ID'              : {value : 'employeeOfficeId', order : 'asc', selected : true},
            'Name'            : {value : 'empName', order : 'asc', selected : false},
            'Department'      : {value : 'departmentName', order : 'asc', selected : false},
            'Designation'     : {value : 'designationName', order : 'asc', selected : false},
            'Shift Group'     : {value : 'shiftGroupName', order : 'asc', selected : false},
            'Workplace'       : {value : 'workplaceName', order : 'asc', selected : false},
            'Employment Type' : {value : 'employmentTypeName', order : 'asc', selected : false},

        };

        vm.hasPermission = hasPermission;
        vm.getStatusInText = getStatusInText;
        vm.searchEmployees = searchEmployees;
        vm.preparePaginationInfo = preparePaginationInfo;
        vm.search.onCompanyChange = onCompanyChange;
        vm.populateSubsidiaryFilter = populateSubsidiaryFilter;
        vm.toggleAll = toggleAll;
        vm.optionToggled = optionToggled;
        vm.sortBy = sortBy;
        vm.getPaginationInfo = getPaginationInfo;
        vm.toggleShowEnrolmentInformation = toggleShowEnrolmentInformation;
        vm.selectAllAndGoToEmployeeActions = selectAllAndGoToEmployeeActions;
        vm.updateSortKey = updateSortKey;
        vm.activateOrDeactivateAll = activateOrDeactivateAll;
        vm.downloadExcel = downloadExcel;
        vm.openConfirmationModal = openConfirmationModal;
        var sortStatus = {
            key   : null,
            order : null,
        };

        init();

        function sortBy(sortKey) {
            if(sortStatus.key != sortKey) {
                sortStatus = {
                    key   : sortKey,
                    order : 'asc'
                }
            } else {
                sortStatus.order = sortStatus.order == 'asc' ? 'desc' : 'asc';
            }
            vm.selectedPaginationPage = 0;
            searchEmployees();
        }

        function downloadExcel(){
            var requestParams = getSearchParams();
            geoFencingService.getExcel(requestParams).then(function (response){
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Geo Fencing Settings Excel', ANALYTICS_CONSTANT.downloadExcel);
                var blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel"
                })
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Geo fencing Status Report '+ moment().format('DD-MM-YYYY') +'.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();

            });
        }

        function activateOrDeactivateAll(requestStatus){
            if (requestStatus) analyticsService.sendData(ANALYTICS_CONSTANT.activateAll, document.title + ' - Activate All', '', 'Activate All In' + document.title, ANALYTICS_CONSTANT.activateAll);
            else analyticsService.sendData(ANALYTICS_CONSTANT.deactivateAll, document.title + ' - Deactivate All', '', 'Deactivate All In' + document.title, ANALYTICS_CONSTANT.deactivateAll);
            var selectedEmployeeIds = getSelectedEmployees();
            var requestParams = getSearchParams();
            var data = {
                params: requestParams,
                employeeIds : selectedEmployeeIds,
                requestStatus : requestStatus
            }
            vm.isEmployeeListLoaded = false;
            geoFencingService.activateOrDeactivateGeoFencingPermission(data).then(function (responseData){
                if (requestStatus) toastrService.showSuccessToastr('Successfully Activated');
                else toastrService.showSuccessToastr('Successfully Deactivated');
                vm.checkbox.isAnySelected = false;
                vm.checkbox.isAllSelected = false;
                searchEmployees();
            });

        }

        function init() {
            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            getAllDepartments();
            // getAllShifts();
            getAllShiftGroups();
            // getAllCompanies();
            getAllWorkplaces();
            getAllDesignations();
            getAllEmploymentTypes();
            if (vm.isSubsidiaryModuleEnabled) {
                getAllSubsidiaries();
            }
            if (vm.isCompanyAdmin) {
                getAllOffices();
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0, mobilePunchStatus : vm.mobileStatus, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            }
            employeeService.getEnrolmentInformation().then(function (data) {
                vm.enrolmentStatus = data.people;
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0,status:getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList,'id'), mobilePunchStatus : vm.mobileStatus, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            }, function (error) {
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0, mobilePunchStatus : vm.mobileStatus, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            })

        }

        function hasPermission(module) {
            return utilService.hasPermission(module);
        }

        function getPaginationInfo() {
            var str = (vm.selectedPaginationPage * vm.rowsToShow + 1) + " to ";
            str+= (vm.selectedPaginationPage+1) * vm.rowsToShow > vm.total ? vm.total : (vm.selectedPaginationPage+1) * vm.rowsToShow;
            return str;
        }

        function getAllDepartments() {
            departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
        }

        function onGetAllDepartmentsSuccess(departmentList) {
            vm.departmentList =  sortCollectionByName(departmentList);
            vm.search.departmentList = angular.copy(vm.departmentList);
        }

        function onGetAllDepartmentsFailure(message) {
            console.error("Failed to fetch department list : " + message);
        }

        function getAllShiftGroups() {
            shiftGroupService.getAllShiftGroups(false).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(shiftGroupList);
                vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            }, function (err) {
                console.error("Failed to fetch shift groups");
            });
        }

        function getAllOffices() {
            officeService.getAllOffices(true).then(function (data) {
                vm.officeList = sortCollectionByName(data);
            }, function (error) {
                toastr.error("Could not fetch office list " + error);
            })
        }

        function getAllEmploymentTypes(){
            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.employmentTypeList = sortCollectionByName(employmentTypeList);
                vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            }, function (message) {
                console.error("Failed to fetch designation category list : " + message);
            });
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfPages - 1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage - 1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage < vm.numberOfPages - 1 ? vm.selectedPaginationPage + 1 : vm.numberOfPages - 1;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function selectAllAndGoToEmployeeActions() {
            var params = getSearchParams();
            params.selectAll = true;
            employeeService.getFilteredEmployees(params).then(function (data) {
                $state.go('employeeActions', {
                    selectedEmployees    : data.employeeIds,
                    allSelected          : true,
                    notSelectedEmployees : []
                });
            });
        }

        function searchEmployees(query) {
            if(query && typeof query.pageNumber !== 'undefined' && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var searchParams = getSearchParams();
            // console.log(getSearchParams());
            if (aclLevel.value == 'office') {
                searchParams.companyId = [authService.getLoggedInUser().office.company.id];
                getAllEmployees(searchParams);
            } else {
                searchParams.companyId = getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id');
                getAllEmployees(searchParams);
            }
        }

        function getAllEmployees(searchParams) {
            vm.isEmployeeListLoaded = false;
            geoFencingService.getFilteredGeoFencingAllowEmployees(searchParams).then(onEmployeeFetchSuccess, onEmployeeFetchFailure);
            vm.excelUrl = employeeService.getExcelUrl(searchParams);
        }

        function getSearchParams() {
            var sortKeyAndOrder = getSortKeyAndOrder();
            var data = {
                officeId          : getIdArrayFromMultiSelectOutput(vm.search.selectedOfficeList, 'id'),
                departmentId      : getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'),
                designationId     : getIdArrayFromMultiSelectOutput(vm.search.selectedDesignationList, 'id'),
                shiftId           : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftList, 'id'),
                shiftGroupId      : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftGroupList, 'id'),
                employmentTypeId  : getIdArrayFromMultiSelectOutput(vm.search.selectedEmploymentTypeList, 'id'),
                genderId          : getIdArrayFromMultiSelectOutput(vm.search.selectedGenderList, 'id'),
                employeeName      : vm.search.searchName.toString(),
                status            : getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList, 'id'),
                workplaceId       : getIdArrayFromMultiSelectOutput(vm.search.selectedWorkplaceList, 'id'),
                subsidiaryId      : getIdArrayFromMultiSelectOutput(vm.search.selectedSubsidiaryList, 'id'),
                perPage           : vm.rowsToShow,
                pageNumber        : vm.selectedPaginationPage,
                sortKey           : sortKeyAndOrder.key,
                order             : sortKeyAndOrder.order,
                mobilePunchStatus : [true],
                geoFencingStatus  : getIdArrayFromMultiSelectOutput(vm.search.selectedGeoFencingStatusList, 'value'),
            };
            if(!data.officeId){
                data.officeId = [loggedInuser.officeId];
            }
            // If subsidiary admin, automatically include subsidiaryId
            if (vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId) {
                data.subsidiaryId = [loggedInuser.subsidiaryId];
            }
            return data;
        }

        function onEmployeeFetchSuccess(data) {
            vm.allEmployees = data.employees;
            for (var i = 0; i < vm.allEmployees.length; i++) {
                vm.allEmployees[i].selected = false;
                var enrolmentInfo = vm.enrolmentStatus[vm.allEmployees[i].centralServerId]
                if(!vm.isCompanyAdmin && !vm.isGroupAdmin && enrolmentInfo){
                    vm.allEmployees[i].totalFingerprints = enrolmentInfo.totalFingerprints;
                    vm.allEmployees[i].rfid = enrolmentInfo.rfid;
                }
            }
            vm.isEmployeeListLoaded = true;
            preparePaginationInfo(data.total,data.totalPages);

            // $scope.$broadcast("refreshFixedColumns");
        }

        function onEmployeeFetchFailure(message) {
            toastr.error("Failed to fetch employee list, error message : " + message);
            console.error("Failed to fetch employee list, error message : " + message);
        }

        function preparePaginationInfo(total, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.total = total;
        }

        function onCompanyChange() {
            getOfficesFromCompanyIdArray();
        }

        function getOfficesFromCompanyIdArray() {
            officeService.getOfficesFromCompanyIdArray(false, getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id')).then(onGetOfficesFromCompanyIdArraySuccess, onGetOfficesFromCompanyIdArrayFailure);
        }

        function onGetOfficesFromCompanyIdArraySuccess(data) {
            vm.officeList = data.officeList;
            for (var j = 0; j < vm.officeList.length; j++) {
                var office = vm.officeList[j];
                if (office.id == authService.getLoggedInUser().office.id) {
                    office.ticked = true;
                }
            }
        }

        function onGetOfficesFromCompanyIdArrayFailure(message) {
            console.error("Failed to fetch office names : " + message);
        }

        function getIdArrayFromMultiSelectOutput(array, keyToExtract) {
            if (!array || array.length == 0) return null;
            var returnArray = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }

        /*
              Radio button toggle functions
         */

        function toggleAll() {
            if (vm.checkbox.isAllSelected){
                analyticsService.sendData(ANALYTICS_CONSTANT.selectAllUrl, document.title + ' - Select All', '', 'Select All In' + document.title, ANALYTICS_CONSTANT.selectAllTitle);

                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = true;
                });}
            else
                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = false;
                });
            checkIfAnySelected();
        }

        function optionToggled() {
            vm.checkbox.isAllSelected = vm.allEmployees.every(function (itm) {
                return itm.selected === true;
            });
            checkIfAnySelected();
        }

        function checkIfAnySelected() {
            for (var i = 0; i < vm.allEmployees.length; i++) {
                if (vm.allEmployees[i].selected) {
                    vm.checkbox.isAnySelected = true;
                    return;
                }
            }
            vm.checkbox.isAnySelected = false;
        }

        function getSelectedEmployees() {
            var selectedEmployeeIds = [];
            angular.forEach(vm.allEmployees, function (employee, key) {
                if (employee.selected) {
                    selectedEmployeeIds.push(employee.id);
                }
            });
            return selectedEmployeeIds;
        }

        function getStatusInText(status) {
            if (status === -1) return "Archived";
            else if (status === 0) return "Inactive";
            else if (status === 1) return "Active";
            else if (status === 2) return "Terminated";
            else if (status === 3) return "Resigned";
            else if (status === 4) return "Transferred";
        }

        function getAllWorkplaces() {
            workplaceService.getAllWorkplaces(true).then(function (data) {
                vm.workplaceList = data;
                vm.workplaceList = sortCollectionByName(vm.workplaceList);
                vm.search.workplaceList = angular.copy(vm.workplaceList);
            })
        }

        function getAllDesignations(){
            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = designationList;
                vm.designationList = sortCollectionByName(vm.designationList);
                vm.search.designationList = angular.copy(vm.designationList);
            }, function (message) {
            });
        }

        function toggleShowEnrolmentInformation() {
            vm.showEnrolmentStatus = !vm.showEnrolmentStatus;
        }

        function getAllSubsidiaries() {
            subsidiaryService.getAllSubsidiaries().then(function (subsidiaryList) {
                vm.subsidiaryList = sortCollectionByName(subsidiaryList);
                vm.search.subsidiaryList = angular.copy(vm.subsidiaryList);

                // Auto-select subsidiary for admin users with subsidiaryId
                if (loggedInuser.isAdmin && loggedInuser.subsidiaryId != null) {
                    vm.search.selectedSubsidiaryList = [{id: loggedInuser.subsidiaryId}];
                    // Use timeout to ensure other lists are loaded before filtering
                    $timeout(function() {
                        populateSubsidiaryFilter();
                    }, 500);
                }
            }, function (error) {
                console.error("Failed to fetch subsidiary list: " + error);
            });
        }

        function populateSubsidiaryFilter() {
            // Use $timeout to ensure the output-model is updated by the directive first
            // This is especially important for on-reset and on-clear events
            $timeout(function() {
                var selectedSubsidiaryIds = vm.search.selectedSubsidiaryList.map(function (subsidiary) {
                    return subsidiary.id;
                });

                if (selectedSubsidiaryIds.length === 0) {
                    clearSubsidiaryFilters();
                } else {
                    vm.search.departmentList = filterBySubsidiaryId(vm.departmentList, selectedSubsidiaryIds);
                    vm.search.designationList = filterBySubsidiaryId(vm.designationList, selectedSubsidiaryIds);
                    vm.search.shiftGroupList = filterBySubsidiaryId(vm.shiftGroupList, selectedSubsidiaryIds);
                    vm.search.workplaceList = filterBySubsidiaryId(vm.workplaceList, selectedSubsidiaryIds);
                    vm.search.employmentTypeList = filterBySubsidiaryId(vm.employmentTypeList, selectedSubsidiaryIds);
                }
            }, 0);
        }

        function clearSubsidiaryFilters() {
            vm.search.departmentList = angular.copy(vm.departmentList);
            vm.search.designationList = angular.copy(vm.designationList);
            vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            vm.search.workplaceList = angular.copy(vm.workplaceList);
            vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            vm.search.selectedDepartmentList = [];
            vm.search.selectedDesignationList = [];
            vm.search.selectedShiftGroupList = [];
            vm.search.selectedWorkplaceList = [];
            vm.search.selectedEmploymentTypeList = [];
        }

        function filterBySubsidiaryId(modelArray, subsidiaryIds) {
            if (!modelArray || modelArray.length === 0) {
                return [];
            }

            return modelArray.filter(function (model) {
                return subsidiaryIds.includes(model.subsidiaryId);
            });
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function updateSortKey(key) {
            if(vm.sortKeys[key].selected){
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc'? 'desc' : 'asc';
            }else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function(keyName){
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            analyticsService.sendData(ANALYTICS_CONSTANT.sort, '', '', 'Sort In' + document.title, ANALYTICS_CONSTANT.sort);

            searchEmployees();
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for(var i = 0 ; i < keys.length ; i++){
                if(vm.sortKeys[keys[i]].selected == true ){
                    return {key :  vm.sortKeys[keys[i]].value , order: vm.sortKeys[keys[i]].order}
                }
            }
        }
        function openConfirmationModal(confirmationText, type) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText
                    }
                }
            }).result.then(function () {
                if (type === "activate"){
                    vm.activateOrDeactivateAll(true)
                }else if (type === "deactivate"){
                    vm.activateOrDeactivateAll(false)
                }
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.settings.locationTrackingAccessSettings')
        .controller('LocationTrackingAccessSettingsCtrl', ['$scope', 'toastrService', '$uibModal', 'editableOptions', 'editableThemes', '_', 'employeeService', 'locationTrackingAccessSettingService', 'designationService', 'departmentService', 'shiftService', 'shiftGroupService','companyService', 'officeService', 'authService', 'toastr', '$state', 'aclLevel','workplaceService','employmentTypeService','mobilePunchService', 'utilService', 'EMPLOYEE_STATUS', 'GENDER', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', 'subsidiaryService', '$timeout', LocationTrackingAccessSettingsCtrl]);

    /** @ngInject */
    function LocationTrackingAccessSettingsCtrl($scope, toastrService, $uibModal, editableOptions, editableThemes, _, employeeService, locationTrackingAccessSettingService, designationService, departmentService, shiftService, shiftGroupService, companyService, officeService, authService, toastr, $state, aclLevel,workplaceService, employmentTypeService,mobilePunchService, utilService, EMPLOYEE_STATUS, GENDER, analyticsService, ANALYTICS_CONSTANT, MODULES, subsidiaryService, $timeout) {

        var vm = this;

        vm.allEmployees = null;
        vm.checkbox = {};
        vm.checkbox.isAnySelected = false;
        vm.checkbox.isAllSelected = false;
        vm.showDiv = false;
        vm.isEmployeeListLoaded = null;
        vm.rowsToShow = 100;
        vm.showEnrolmentStatus = false;
        vm.selectedPaginationPage = 0;
        vm.mobileStatus = true;

        vm.departmentList = [];
        vm.designationList = [];
        vm.shiftList = [];
        vm.shiftGroupList = [];
        vm.employmentTypeList = [];
        vm.companyList = [];
        vm.officeList = [];
        vm.workplaceList = [];
        vm.genderList = GENDER;
        vm.employeeStatusList = EMPLOYEE_STATUS;
        vm.enrolmentStatus = [];
        vm.availableLocationTrackingStatusList = [{name :'Active', value:true}, {name : 'Inactive', value : false}];

        vm.search = {};
        vm.search.searchName = "";
        vm.search.departmentList = [];
        vm.search.designationList = [];
        vm.search.shiftGroupList = [];
        vm.search.employmentTypeList = [];
        vm.search.workplaceList = [];
        vm.search.selectedDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedShiftList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedEmploymentTypeList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedGenderList = [];
        vm.search.selectedemployeeStatusList = [{ id: 1}];
        vm.search.selectedLocationTrackingAccessStatusList = [];
        vm.search.subsidiaryList = [];
        vm.search.selectedSubsidiaryList = [];
        var loggedInuser = authService.getLoggedInUser();
        vm.isCompanyAdmin = loggedInuser.isCompanyAdmin;
        vm.isLineManager = loggedInuser.isLineManager && !loggedInuser.isAdmin;
        vm.isSubsidiaryModuleEnabled = loggedInuser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSuperAdmin = loggedInuser.isAdmin && !vm.isSubsidiaryModuleEnabled;
        vm.isSubsidiaryAdmin = loggedInuser.isAdmin && vm.isSubsidiaryModuleEnabled && loggedInuser.subsidiaryId != null;
        vm.subsidiaryView = loggedInuser.isAdmin && loggedInuser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;

        vm.total = 0;
        vm.excelUrl = "";

        vm.sortKeys = {
            'Report Position' : {value : 'reportPosition', order:'asc', selected : false},
            'ID'              : {value : 'employeeOfficeId', order : 'asc', selected : true},
            'Name'            : {value : 'empName', order : 'asc', selected : false},
            'Department'      : {value : 'departmentName', order : 'asc', selected : false},
            'Designation'     : {value : 'designationName', order : 'asc', selected : false},
            'Shift Group'     : {value : 'shiftGroupName', order : 'asc', selected : false},
            'Workplace'       : {value : 'workplaceName', order : 'asc', selected : false},
            'Employment Type' : {value : 'employmentTypeName', order : 'asc', selected : false},

        };

        vm.hasPermission = hasPermission;
        vm.getStatusInText = getStatusInText;
        vm.searchEmployees = searchEmployees;
        vm.preparePaginationInfo = preparePaginationInfo;
        vm.search.onCompanyChange = onCompanyChange;
        vm.populateSubsidiaryFilter = populateSubsidiaryFilter;
        vm.toggleAll = toggleAll;
        vm.optionToggled = optionToggled;
        vm.sortBy = sortBy;
        vm.getPaginationInfo = getPaginationInfo;
        vm.toggleShowEnrolmentInformation = toggleShowEnrolmentInformation;
        vm.selectAllAndGoToEmployeeActions = selectAllAndGoToEmployeeActions;
        vm.updateSortKey = updateSortKey;
        vm.activateOrDeactivateAll = activateOrDeactivateAll;
        vm.downloadExcel = downloadExcel;
        vm.openConfirmationModal = openConfirmationModal;
        var sortStatus = {
            key   : null,
            order : null,
        };

        init();

        function sortBy(sortKey) {
            if(sortStatus.key != sortKey) {
                sortStatus = {
                    key   : sortKey,
                    order : 'asc'
                }
            } else {
                sortStatus.order = sortStatus.order == 'asc' ? 'desc' : 'asc';
            }
            vm.selectedPaginationPage = 0;
            searchEmployees();
        }

        function downloadExcel(){
            var requestParams = getSearchParams();
            locationTrackingAccessSettingService.getExcel(requestParams).then(function (response){
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Location Tracking Access Settings Excel', ANALYTICS_CONSTANT.downloadExcel);
                var blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel"
                })
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Geo fencing Status Report '+ moment().format('DD-MM-YYYY') +'.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();

            });
        }

        function activateOrDeactivateAll(requestStatus){
            if (requestStatus) analyticsService.sendData(ANALYTICS_CONSTANT.activateAll, document.title + ' - Activate All', '', 'Activate All In' + document.title, ANALYTICS_CONSTANT.activateAll);
            else analyticsService.sendData(ANALYTICS_CONSTANT.deactivateAll, document.title + ' - Deactivate All', '', 'Deactivate All In' + document.title, ANALYTICS_CONSTANT.deactivateAll);
            var selectedEmployeeIds = getSelectedEmployees();
            var requestParams = getSearchParams();
            var data = {
                params: requestParams,
                employeeIds : selectedEmployeeIds,
                requestStatus : requestStatus
            }
            vm.isEmployeeListLoaded = false;
            locationTrackingAccessSettingService.activateOrDeactivateLocationTrackingPermission(data).then(function (responseData){
                if (requestStatus) toastrService.showSuccessToastr('Successfully Activated');
                else toastrService.showSuccessToastr('Successfully Deactivated');
                vm.checkbox.isAnySelected = false;
                vm.checkbox.isAllSelected = false;
                searchEmployees();
            });

        }

        function init() {
            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            getAllDepartments();
            // getAllShifts();
            getAllShiftGroups();
            // getAllCompanies();
            getAllWorkplaces();
            getAllDesignations();
            getAllEmploymentTypes();
            if (vm.isSubsidiaryModuleEnabled) {
                getAllSubsidiaries();
            }
            if (vm.isCompanyAdmin) {
                getAllOffices();
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0, mobilePunchStatus : vm.mobileStatus, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            }
            employeeService.getEnrolmentInformation().then(function (data) {
                vm.enrolmentStatus = data.people;
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0,status:getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList,'id'), mobilePunchStatus : vm.mobileStatus, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            }, function (error) {
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0, mobilePunchStatus : vm.mobileStatus, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            })

        }

        function hasPermission(module) {
            return utilService.hasPermission(module);
        }

        function getPaginationInfo() {
            var str = (vm.selectedPaginationPage * vm.rowsToShow + 1) + " to ";
            str+= (vm.selectedPaginationPage+1) * vm.rowsToShow > vm.total ? vm.total : (vm.selectedPaginationPage+1) * vm.rowsToShow;
            return str;
        }

        function getAllDepartments() {
            departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
        }

        function onGetAllDepartmentsSuccess(departmentList) {
            vm.departmentList =  sortCollectionByName(departmentList);
        }

        function onGetAllDepartmentsFailure(message) {
            console.error("Failed to fetch department list : " + message);
        }

        function getAllShiftGroups() {
            shiftGroupService.getAllShiftGroups(false).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(shiftGroupList);
            }, function (err) {
                console.error("Failed to fetch shift groups");
            });
        }

        function getAllOffices() {
            officeService.getAllOffices(true).then(function (data) {
                vm.officeList = sortCollectionByName(data);
            }, function (error) {
                toastr.error("Could not fetch office list " + error);
            })
        }

        function getAllEmploymentTypes(){
            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.employmentTypeList = sortCollectionByName(employmentTypeList);
                vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            }, function (message) {
                console.error("Failed to fetch designation category list : " + message);
            });
        }

        function getAllSubsidiaries() {
            subsidiaryService.getAllSubsidiaries().then(function (subsidiaryList) {
                vm.subsidiaryList = sortCollectionByName(subsidiaryList);
                vm.search.subsidiaryList = angular.copy(vm.subsidiaryList);

                // Auto-select subsidiary for admin users with subsidiaryId
                if (loggedInuser.isAdmin && loggedInuser.subsidiaryId != null) {
                    vm.search.selectedSubsidiaryList = [{id: loggedInuser.subsidiaryId}];
                    // Use timeout to ensure other lists are loaded before filtering
                    $timeout(function() {
                        console.log("Auto-triggering subsidiary filter for subsidiary admin user");
                        populateSubsidiaryFilter();
                    }, 500);
                }
            }, function (error) {
                console.error("Failed to fetch subsidiary list: " + error);
            });
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfPages - 1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage - 1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage < vm.numberOfPages - 1 ? vm.selectedPaginationPage + 1 : vm.numberOfPages - 1;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function selectAllAndGoToEmployeeActions() {
            var params = getSearchParams();
            params.selectAll = true;
            employeeService.getFilteredEmployees(params).then(function (data) {
                $state.go('employeeActions', {
                    selectedEmployees    : data.employeeIds,
                    allSelected          : true,
                    notSelectedEmployees : []
                });
            });
        }

        function searchEmployees(query) {
            if(query && typeof query.pageNumber !== 'undefined' && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var searchParams = getSearchParams();
            // console.log(getSearchParams());
            if (aclLevel.value == 'office') {
                searchParams.companyId = [authService.getLoggedInUser().office.company.id];
                getAllEmployees(searchParams);
            } else {
                searchParams.companyId = getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id');
                getAllEmployees(searchParams);
            }
        }

        function getAllEmployees(searchParams) {
            vm.isEmployeeListLoaded = false;
            locationTrackingAccessSettingService.getFilteredLocationTrackingAllowEmployees(searchParams).then(onEmployeeFetchSuccess, onEmployeeFetchFailure);
            vm.excelUrl = employeeService.getExcelUrl(searchParams);
        }

        function getSearchParams() {
            var sortKeyAndOrder = getSortKeyAndOrder();


            var subsidiaryId = getIdArrayFromMultiSelectOutput(vm.search.selectedSubsidiaryList, 'id');

            var data = {
                officeId          : getIdArrayFromMultiSelectOutput(vm.search.selectedOfficeList, 'id'),
                departmentId      : getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'),
                designationId     : getIdArrayFromMultiSelectOutput(vm.search.selectedDesignationList, 'id'),
                shiftId           : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftList, 'id'),
                shiftGroupId      : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftGroupList, 'id'),
                employmentTypeId  : getIdArrayFromMultiSelectOutput(vm.search.selectedEmploymentTypeList, 'id'),
                genderId          : getIdArrayFromMultiSelectOutput(vm.search.selectedGenderList, 'id'),
                employeeName      : vm.search.searchName.toString(),
                status            : getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList, 'id'),
                workplaceId       : getIdArrayFromMultiSelectOutput(vm.search.selectedWorkplaceList, 'id'),
                subsidiaryId      : subsidiaryId,
                perPage           : vm.rowsToShow,
                pageNumber        : vm.selectedPaginationPage,
                sortKey           : sortKeyAndOrder.key,
                order             : sortKeyAndOrder.order,
                locationTrackingAccessStatus  : getIdArrayFromMultiSelectOutput(vm.search.selectedLocationTrackingAccessStatusList, 'value'),
            };
            if(!data.officeId){
                data.officeId = [loggedInuser.officeId];
            }
            // If subsidiary admin, automatically include subsidiaryId
            if (vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId) {
                data.subsidiaryId = [loggedInuser.subsidiaryId];
            }
            return data;
        }

        function onEmployeeFetchSuccess(data) {
            vm.allEmployees = data.employees;
            for (var i = 0; i < vm.allEmployees.length; i++) {
                vm.allEmployees[i].selected = false;
                var enrolmentInfo = vm.enrolmentStatus[vm.allEmployees[i].centralServerId]
                if(!vm.isCompanyAdmin && !vm.isGroupAdmin && enrolmentInfo){
                    vm.allEmployees[i].totalFingerprints = enrolmentInfo.totalFingerprints;
                    vm.allEmployees[i].rfid = enrolmentInfo.rfid;
                }
            }
            vm.isEmployeeListLoaded = true;
            preparePaginationInfo(data.total,data.totalPages);

            // $scope.$broadcast("refreshFixedColumns");
        }

        function onEmployeeFetchFailure(message) {
            toastr.error("Failed to fetch employee list, error message : " + message);
            console.error("Failed to fetch employee list, error message : " + message);
        }

        function preparePaginationInfo(total, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.total = total;
        }

        function onCompanyChange() {
            getOfficesFromCompanyIdArray();
        }

        function getOfficesFromCompanyIdArray() {
            officeService.getOfficesFromCompanyIdArray(false, getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id')).then(onGetOfficesFromCompanyIdArraySuccess, onGetOfficesFromCompanyIdArrayFailure);
        }

        function onGetOfficesFromCompanyIdArraySuccess(data) {
            vm.officeList = data.officeList;
            for (var j = 0; j < vm.officeList.length; j++) {
                var office = vm.officeList[j];
                if (office.id == authService.getLoggedInUser().office.id) {
                    office.ticked = true;
                }
            }
        }

        function onGetOfficesFromCompanyIdArrayFailure(message) {
            console.error("Failed to fetch office names : " + message);
        }

        function getIdArrayFromMultiSelectOutput(array, keyToExtract) {
            if (!array || array.length == 0) return null;
            var returnArray = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }

        /*
              Radio button toggle functions
         */

        function toggleAll() {
            if (vm.checkbox.isAllSelected){
                analyticsService.sendData(ANALYTICS_CONSTANT.selectAllUrl, document.title + ' - Select All', '', 'Select All In' + document.title, ANALYTICS_CONSTANT.selectAllTitle);

                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = true;
                });}
            else
                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = false;
                });
            checkIfAnySelected();
        }

        function optionToggled() {
            vm.checkbox.isAllSelected = vm.allEmployees.every(function (itm) {
                return itm.selected === true;
            });
            checkIfAnySelected();
        }

        function checkIfAnySelected() {
            for (var i = 0; i < vm.allEmployees.length; i++) {
                if (vm.allEmployees[i].selected) {
                    vm.checkbox.isAnySelected = true;
                    return;
                }
            }
            vm.checkbox.isAnySelected = false;
        }

        function getSelectedEmployees() {
            var selectedEmployeeIds = [];
            angular.forEach(vm.allEmployees, function (employee, key) {
                if (employee.selected) {
                    selectedEmployeeIds.push(employee.id);
                }
            });
            return selectedEmployeeIds;
        }

        function getStatusInText(status) {
            if (status === -1) return "Archived";
            else if (status === 0) return "Inactive";
            else if (status === 1) return "Active";
            else if (status === 2) return "Terminated";
            else if (status === 3) return "Resigned";
            else if (status === 4) return "Transferred";
        }

        function getAllWorkplaces() {
            workplaceService.getAllWorkplaces(true).then(function (data) {
                vm.workplaceList = data;
                vm.workplaceList = sortCollectionByName(vm.workplaceList);
            })
        }

        function getAllDesignations(){
            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = designationList;
                vm.designationList = sortCollectionByName(vm.designationList);
                vm.search.designationList = angular.copy(vm.designationList);
            }, function (message) {
            });
        }

        function toggleShowEnrolmentInformation() {
            vm.showEnrolmentStatus = !vm.showEnrolmentStatus;
        }

        function populateSubsidiaryFilter() {
            // Use $timeout to ensure the output-model is updated by the directive first
            // This is especially important for on-reset and on-clear events
            $timeout(function() {
                var selectedSubsidiaryIds = vm.search.selectedSubsidiaryList.map(function (subsidiary) {
                    return subsidiary.id;
                });

                if (selectedSubsidiaryIds.length === 0) {
                    clearSubsidiaryFilters();
                } else {
                    vm.search.departmentList = filterBySubsidiaryId(vm.departmentList, selectedSubsidiaryIds);
                    vm.search.designationList = filterBySubsidiaryId(vm.designationList, selectedSubsidiaryIds);
                    vm.search.shiftGroupList = filterBySubsidiaryId(vm.shiftGroupList, selectedSubsidiaryIds);
                    vm.search.workplaceList = filterBySubsidiaryId(vm.workplaceList, selectedSubsidiaryIds);
                    vm.search.employmentTypeList = filterBySubsidiaryId(vm.employmentTypeList, selectedSubsidiaryIds);
                }
            }, 0);
        }

        function clearSubsidiaryFilters() {
            vm.search.departmentList = angular.copy(vm.departmentList);
            vm.search.designationList = angular.copy(vm.designationList);
            vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            vm.search.workplaceList = angular.copy(vm.workplaceList);
            vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            vm.search.selectedDepartmentList = [];
            vm.search.selectedDesignationList = [];
            vm.search.selectedShiftGroupList = [];
            vm.search.selectedWorkplaceList = [];
            vm.search.selectedEmploymentTypeList = [];
        }

        function filterBySubsidiaryId(modelArray, subsidiaryIds) {
            if (!modelArray || modelArray.length === 0) {
                return [];
            }

            var filtered = modelArray.filter(function (model) {
                return subsidiaryIds.includes(model.subsidiaryId);
            });
            return filtered;
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function updateSortKey(key) {
            if(vm.sortKeys[key].selected){
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc'? 'desc' : 'asc';
            }else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function(keyName){
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            analyticsService.sendData(ANALYTICS_CONSTANT.sort, '', '', 'Sort In' + document.title, ANALYTICS_CONSTANT.sort);

            searchEmployees();
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for(var i = 0 ; i < keys.length ; i++){
                if(vm.sortKeys[keys[i]].selected == true ){
                    return {key :  vm.sortKeys[keys[i]].value , order: vm.sortKeys[keys[i]].order}
                }
            }
        }
        function openConfirmationModal(confirmationText, type) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText
                    }
                }
            }).result.then(function () {
                if (type === "activate"){
                    vm.activateOrDeactivateAll(true)
                }else if (type === "deactivate"){
                    vm.activateOrDeactivateAll(false)
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.notification')
        .controller('NotificationConfirmationModalCtrl', [ '$uibModalInstance', 'toastrService', 'employeeName', NotificationConfirmationModalCtrl]);

    /** @ngInject */
    function NotificationConfirmationModalCtrl($uibModalInstance, toastrService, employeeName) {
        var vm = this;
        vm.employeeName=employeeName;

    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.employees.manageEmployees')
        .controller('MobilePunchSettingsCtrl', ['$scope', 'toastrService', '$uibModal', 'editableOptions', 'editableThemes', '_', 'employeeService','designationService', 'departmentService', 'shiftService', 'shiftGroupService','companyService', 'officeService', 'authService', 'toastr', '$state', 'aclLevel','workplaceService','employmentTypeService','mobilePunchService', 'utilService', 'EMPLOYEE_STATUS', 'GENDER', 'analyticsService', 'ANALYTICS_CONSTANT', 'MODULES', 'subsidiaryService', '$timeout', MobilePunchSettingsCtrl]);

    /** @ngInject */
    function MobilePunchSettingsCtrl($scope, toastrService, $uibModal, editableOptions, editableThemes, _, employeeService,designationService, departmentService, shiftService, shiftGroupService, companyService, officeService, authService, toastr, $state, aclLevel,workplaceService, employmentTypeService,mobilePunchService, utilService, EMPLOYEE_STATUS, GENDER, analyticsService, ANALYTICS_CONSTANT, MODULES, subsidiaryService, $timeout) {

        var vm = this;

        vm.allEmployees = null;
        vm.checkbox = {};
        vm.checkbox.isAnySelected = false;
        vm.checkbox.isAllSelected = false;
        vm.showDiv = false;
        vm.isEmployeeListLoaded = null;
        vm.rowsToShow = 100;
        vm.showEnrolmentStatus = false;
        vm.selectedPaginationPage = 0;

        vm.departmentList = [];
        vm.designationList = [];
        vm.shiftList = [];
        vm.shiftGroupList = [];
        vm.employmentTypeList = [];
        vm.companyList = [];
        vm.officeList = [];
        vm.workplaceList = [];
        vm.subsidiaryList = [];
        vm.genderList = GENDER;
        vm.employeeStatusList = EMPLOYEE_STATUS;
        vm.enrolmentStatus = [];
        vm.availableMobilePunchStatusList = [{name :'Active', value:true}, {name : 'Inactive', value : false}];

        vm.search = {};
        vm.search.searchName = "";
        vm.search.departmentList = [];
        vm.search.designationList = [];
        vm.search.shiftGroupList = [];
        vm.search.employmentTypeList = [];
        vm.search.workplaceList = [];
        vm.search.selectedDepartmentList = [];
        vm.search.selectedDesignationList = [];
        vm.search.selectedShiftList = [];
        vm.search.selectedShiftGroupList = [];
        vm.search.selectedEmploymentTypeList = [];
        vm.search.selectedCompanyList = [];
        vm.search.selectedOfficeList = [];
        vm.search.selectedWorkplaceList = [];
        vm.search.selectedGenderList = [];
        vm.search.selectedemployeeStatusList = [{ id: 1}];
        vm.search.selectedMobilePunchStatusList = [];
        vm.search.subsidiaryList = [];
        vm.search.selectedSubsidiaryList = [];

        var loggedInuser = authService.getLoggedInUser();
        vm.isCompanyAdmin = loggedInuser.isCompanyAdmin;
        vm.isLineManager = loggedInuser.isLineManager && !loggedInuser.isAdmin;
        vm.isSubsidiaryModuleEnabled = loggedInuser['modules'].includes(MODULES.SUBSIDIARY);
        vm.isSuperAdmin = loggedInuser.isAdmin && !vm.isSubsidiaryModuleEnabled;
        vm.isSubsidiaryAdmin = loggedInuser.isAdmin && vm.isSubsidiaryModuleEnabled && loggedInuser.subsidiaryId != null;
        vm.subsidiaryView = loggedInuser.isAdmin && loggedInuser.subsidiaryId == null && vm.isSubsidiaryModuleEnabled;


        vm.total = 0;
        vm.excelUrl = "";

        vm.sortKeys = {
            'Report Position' : {value : 'reportPosition', order:'asc', selected : false},
            'ID'              : {value : 'employeeOfficeId', order : 'asc', selected : true},
            'Name'            : {value : 'empName', order : 'asc', selected : false},
            'Department'      : {value : 'departmentName', order : 'asc', selected : false},
            'Designation'     : {value : 'designationName', order : 'asc', selected : false},
            'Shift Group'     : {value : 'shiftGroupName', order : 'asc', selected : false},
            'Workplace'       : {value : 'workplaceName', order : 'asc', selected : false},
            'Employment Type' : {value : 'employmentTypeName', order : 'asc', selected : false},

        };

        vm.hasPermission = hasPermission;
        vm.getStatusInText = getStatusInText;
        vm.searchEmployees = searchEmployees;
        vm.preparePaginationInfo = preparePaginationInfo;
        vm.search.onCompanyChange = onCompanyChange;
        vm.populateSubsidiaryFilter = populateSubsidiaryFilter;
        vm.toggleAll = toggleAll;
        vm.optionToggled = optionToggled;
        vm.sortBy = sortBy;
        vm.getPaginationInfo = getPaginationInfo;
        vm.toggleShowEnrolmentInformation = toggleShowEnrolmentInformation;
        vm.selectAllAndGoToEmployeeActions = selectAllAndGoToEmployeeActions;
        vm.updateSortKey = updateSortKey;
        vm.activateOrDeactivateAll = activateOrDeactivateAll;
        vm.downloadExcel = downloadExcel;
        vm.openConfirmationModal = openConfirmationModal;
        var sortStatus = {
            key   : null,
            order : null,
        };

        init();

        function sortBy(sortKey) {
            if(sortStatus.key != sortKey) {
                sortStatus = {
                    key   : sortKey,
                    order : 'asc'
                }
            } else {
                sortStatus.order = sortStatus.order == 'asc' ? 'desc' : 'asc';
            }
            vm.selectedPaginationPage = 0;
            searchEmployees();
        }

        function downloadExcel(){
            var requestParams = getSearchParams();
            mobilePunchService.getExcel(requestParams).then(function (response){
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download Mobile Punch Settings Excel', ANALYTICS_CONSTANT.downloadExcel);
                var blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel"
                })
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Mobile Punch Status Report '+ moment().format('DD-MM-YYYY') +'.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();

            });
        }

        function activateOrDeactivateAll(requestStatus){
            if (requestStatus) analyticsService.sendData(ANALYTICS_CONSTANT.activateAll, document.title + ' - Activate All', '', 'Activate All In' + document.title, ANALYTICS_CONSTANT.activateAll);
            else analyticsService.sendData(ANALYTICS_CONSTANT.deactivateAll, document.title + ' - Deactivate All', '', 'Deactivate All In' + document.title, ANALYTICS_CONSTANT.deactivateAll);
            var selectedEmployeeIds = getSelectedEmployees();
            var requestParams = getSearchParams();
            var data = {
                params: requestParams,
                employeeIds : selectedEmployeeIds,
                requestStatus : requestStatus
            }

            vm.isEmployeeListLoaded = false;
            mobilePunchService.activateOrDeactivateMobilePunchPermission(data).then(function (responseData){
                if (requestStatus) toastrService.showSuccessToastr('Successfully Activated');
                else toastrService.showSuccessToastr('Successfully Deactivated');
                vm.checkbox.isAnySelected = false;
                vm.checkbox.isAllSelected = false;
                searchEmployees();
            });

        }

        function init() {
            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

            getAllDepartments();
            // getAllShifts();
            getAllShiftGroups();
            // getAllCompanies();
            getAllWorkplaces();
            getAllDesignations();
            getAllEmploymentTypes();
            if (vm.isSubsidiaryModuleEnabled) {
                getAllSubsidiaries();
            }
            if (vm.isCompanyAdmin) {
                getAllOffices();
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            }
            employeeService.getEnrolmentInformation().then(function (data) {
                vm.enrolmentStatus = data.people;
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0,status:getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList,'id'), subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            }, function (error) {
                getAllEmployees({perPage:vm.rowsToShow,pageNumber:0, subsidiaryId: vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId ? [loggedInuser.subsidiaryId] : null});
            })

        }

        function hasPermission(module) {
            return utilService.hasPermission(module);
        }

        function getPaginationInfo() {
            var str = (vm.selectedPaginationPage * vm.rowsToShow + 1) + " to ";
            str+= (vm.selectedPaginationPage+1) * vm.rowsToShow > vm.total ? vm.total : (vm.selectedPaginationPage+1) * vm.rowsToShow;
            return str;
        }

        function getAllDepartments() {
            departmentService.getAllDepartments().then(onGetAllDepartmentsSuccess, onGetAllDepartmentsFailure);
        }

        function onGetAllDepartmentsSuccess(departmentList) {
            vm.departmentList =  sortCollectionByName(departmentList);
        }

        function onGetAllDepartmentsFailure(message) {
            console.error("Failed to fetch department list : " + message);
        }

        function getAllShiftGroups() {
            shiftGroupService.getAllShiftGroups(false).then(function (shiftGroupList) {
                vm.shiftGroupList = sortCollectionByName(shiftGroupList);
            }, function (err) {
                console.error("Failed to fetch shift groups");
            });
        }

        function getAllOffices() {
            officeService.getAllOffices(true).then(function (data) {
                vm.officeList = sortCollectionByName(data);
            }, function (error) {
                toastr.error("Could not fetch office list " + error);
            })
        }

        function getAllEmploymentTypes(){
            employmentTypeService.getAllEmploymentTypes().then(function (employmentTypeList) {
                vm.employmentTypeList = sortCollectionByName(employmentTypeList);
                vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            }, function (message) {
            }, function (message) {
                console.error("Failed to fetch designation category list : " + message);
            });
        }

        function setSelectedPaginationPage(query) {
            if(query.pageNumber == 'first')
                vm.selectedPaginationPage = 0;
            else if(query.pageNumber == 'last')
                vm.selectedPaginationPage = vm.numberOfPages - 1;
            else if (query.pageNumber == 'reduce'){
                vm.selectedPaginationPage = vm.selectedPaginationPage != 0 ? vm.selectedPaginationPage - 1: 0;
            }else if(query.pageNumber == 'increase'){
                vm.selectedPaginationPage = vm.selectedPaginationPage < vm.numberOfPages - 1 ? vm.selectedPaginationPage + 1 : vm.numberOfPages - 1;
            }else if(query.pageNumber == 'reset'){
                vm.selectedPaginationPage = 0;
            }
            else {
                vm.selectedPaginationPage = query.pageNumber;
            }
        }

        function selectAllAndGoToEmployeeActions() {
            var params = getSearchParams();
            params.selectAll = true;
            employeeService.getFilteredEmployees(params).then(function (data) {
                $state.go('employeeActions', {
                    selectedEmployees    : data.employeeIds,
                    allSelected          : true,
                    notSelectedEmployees : []
                });
            });
        }

        function searchEmployees(query) {
            if(query && typeof query.pageNumber !== 'undefined' && query.pageNumber != null){
                setSelectedPaginationPage(query);
            }
            var searchParams = getSearchParams();
            // console.log(getSearchParams());
            if (aclLevel.value == 'office') {
                searchParams.companyId = [authService.getLoggedInUser().office.company.id];
                getAllEmployees(searchParams);
            } else {
                searchParams.companyId = getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id');
                getAllEmployees(searchParams);
            }
        }

        function getAllEmployees(searchParams) {
            vm.isEmployeeListLoaded = false;
            employeeService.getFilteredEmployees(searchParams).then(onEmployeeFetchSuccess, onEmployeeFetchFailure);
            vm.excelUrl = employeeService.getExcelUrl(searchParams);
        }

        function getSearchParams() {
            var sortKeyAndOrder = getSortKeyAndOrder();

            console.log("=== Mobile Punch getSearchParams Debug ===");
            console.log("vm.search.selectedSubsidiaryList:", vm.search.selectedSubsidiaryList);
            console.log("vm.isSubsidiaryAdmin:", vm.isSubsidiaryAdmin);
            console.log("loggedInuser.subsidiaryId:", loggedInuser.subsidiaryId);

            var data = {
                officeId          : getIdArrayFromMultiSelectOutput(vm.search.selectedOfficeList, 'id'),
                departmentId      : getIdArrayFromMultiSelectOutput(vm.search.selectedDepartmentList, 'id'),
                designationId     : getIdArrayFromMultiSelectOutput(vm.search.selectedDesignationList, 'id'),
                shiftId           : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftList, 'id'),
                shiftGroupId      : getIdArrayFromMultiSelectOutput(vm.search.selectedShiftGroupList, 'id'),
                employmentTypeId  : getIdArrayFromMultiSelectOutput(vm.search.selectedEmploymentTypeList, 'id'),
                genderId          : getIdArrayFromMultiSelectOutput(vm.search.selectedGenderList, 'id'),
                employeeName      : vm.search.searchName.toString(),
                status            : getIdArrayFromMultiSelectOutput(vm.search.selectedemployeeStatusList, 'id'),
                workplaceId       : getIdArrayFromMultiSelectOutput(vm.search.selectedWorkplaceList, 'id'),
                subsidiaryId      : getIdArrayFromMultiSelectOutput(vm.search.selectedSubsidiaryList, 'id'),
                perPage           : vm.rowsToShow,
                pageNumber        : vm.selectedPaginationPage,
                sortKey           : sortKeyAndOrder.key,
                order             : sortKeyAndOrder.order,
                mobilePunchStatus : getIdArrayFromMultiSelectOutput(vm.search.selectedMobilePunchStatusList, 'value'),
            };
            if(!data.officeId){
                data.officeId = [loggedInuser.officeId];
            }
            // If subsidiary admin, automatically include subsidiaryId
            if (vm.isSubsidiaryAdmin && loggedInuser.subsidiaryId) {
                data.subsidiaryId = [loggedInuser.subsidiaryId];
                console.log("Subsidiary Admin: Auto-setting subsidiaryId to", data.subsidiaryId);
            }

            console.log("Final subsidiaryId:", data.subsidiaryId);
            console.log("Final data object:", data);
            console.log("==========================================");

            return data;
        }

        function onEmployeeFetchSuccess(data) {
            vm.allEmployees = data.employees;
            for (var i = 0; i < vm.allEmployees.length; i++) {
                vm.allEmployees[i].selected = false;
                var enrolmentInfo = vm.enrolmentStatus[vm.allEmployees[i].centralServerId]
                if(!vm.isCompanyAdmin && !vm.isGroupAdmin && enrolmentInfo){
                    vm.allEmployees[i].totalFingerprints = enrolmentInfo.totalFingerprints;
                    vm.allEmployees[i].rfid = enrolmentInfo.rfid;
                }
            }
            vm.isEmployeeListLoaded = true;
            preparePaginationInfo(data.total,data.totalPages);

            // $scope.$broadcast("refreshFixedColumns");
        }

        function onEmployeeFetchFailure(message) {
            toastr.error("Failed to fetch employee list, error message : " + message);
            console.error("Failed to fetch employee list, error message : " + message);
        }

        function preparePaginationInfo(total, totalPages) {
            vm.numberOfPages = totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.total = total;
        }

        function onCompanyChange() {
            getOfficesFromCompanyIdArray();
        }

        function getOfficesFromCompanyIdArray() {
            officeService.getOfficesFromCompanyIdArray(false, getIdArrayFromMultiSelectOutput(vm.search.selectedCompanyList, 'id')).then(onGetOfficesFromCompanyIdArraySuccess, onGetOfficesFromCompanyIdArrayFailure);
        }

        function onGetOfficesFromCompanyIdArraySuccess(data) {
            vm.officeList = data.officeList;
            for (var j = 0; j < vm.officeList.length; j++) {
                var office = vm.officeList[j];
                if (office.id == authService.getLoggedInUser().office.id) {
                    office.ticked = true;
                }
            }
        }

        function onGetOfficesFromCompanyIdArrayFailure(message) {
            console.error("Failed to fetch office names : " + message);
        }

        function getIdArrayFromMultiSelectOutput(array, keyToExtract) {
            if (!array || array.length == 0) return null;
            var returnArray = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }

        /*
              Radio button toggle functions
         */

        function toggleAll() {
            if (vm.checkbox.isAllSelected){
                analyticsService.sendData(ANALYTICS_CONSTANT.selectAllUrl, document.title + ' - Select All', '', 'Select All In' + document.title, ANALYTICS_CONSTANT.selectAllTitle);

            angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = true;
                });}
            else
                angular.forEach(vm.allEmployees, function (itm) {
                    itm.selected = false;
                });
            checkIfAnySelected();
        }

        function optionToggled() {
            vm.checkbox.isAllSelected = vm.allEmployees.every(function (itm) {
                return itm.selected === true;
            });
            checkIfAnySelected();
        }

        function checkIfAnySelected() {
            for (var i = 0; i < vm.allEmployees.length; i++) {
                if (vm.allEmployees[i].selected) {
                    vm.checkbox.isAnySelected = true;
                    return;
                }
            }
            vm.checkbox.isAnySelected = false;
        }

        function getSelectedEmployees() {
            var selectedEmployeeIds = [];
            angular.forEach(vm.allEmployees, function (employee, key) {
                if (employee.selected) {
                    selectedEmployeeIds.push(employee.id);
                }
            });
            return selectedEmployeeIds;
        }

        function getStatusInText(status) {
            if (status === -1) return "Archived";
            else if (status === 0) return "Inactive";
            else if (status === 1) return "Active";
            else if (status === 2) return "Terminated";
            else if (status === 3) return "Resigned";
            else if (status === 4) return "Transferred";
        }

        function getAllWorkplaces() {
            workplaceService.getAllWorkplaces(true).then(function (data) {
                vm.workplaceList = data;
                vm.workplaceList = sortCollectionByName(vm.workplaceList);
                vm.search.workplaceList = angular.copy(vm.workplaceList);
            })
        }

        function getAllDesignations(){
            designationService.getAllDesignations().then(function (designationList) {
                vm.designationList = designationList;
                vm.designationList = sortCollectionByName(vm.designationList);
                vm.search.designationList = angular.copy(vm.designationList);
            }, function (message) {
            });
        }

        function toggleShowEnrolmentInformation() {
            vm.showEnrolmentStatus = !vm.showEnrolmentStatus;
        }

        function getAllSubsidiaries() {
            subsidiaryService.getAllSubsidiaries().then(function (subsidiaryList) {
                vm.subsidiaryList = sortCollectionByName(subsidiaryList);
                vm.search.subsidiaryList = angular.copy(vm.subsidiaryList);

                // Auto-select subsidiary for admin users with subsidiaryId
                if (loggedInuser.isAdmin && loggedInuser.subsidiaryId != null) {
                    vm.search.selectedSubsidiaryList = [{id: loggedInuser.subsidiaryId}];
                    // Use timeout to ensure other lists are loaded before filtering
                    $timeout(function() {
                        populateSubsidiaryFilter();
                    }, 500);
                }
            }, function (error) {
                console.error("Failed to fetch subsidiary list: " + error);
            });
        }

        function populateSubsidiaryFilter() {
            // Use $timeout to ensure the output-model is updated by the directive first
            // This is especially important for on-reset and on-clear events
            $timeout(function() {
                var selectedSubsidiaryIds = vm.search.selectedSubsidiaryList.map(function (subsidiary) {
                    return subsidiary.id;
                });

                if (selectedSubsidiaryIds.length === 0) {
                    clearSubsidiaryFilters();
                } else {
                    vm.search.departmentList = filterBySubsidiaryId(vm.departmentList, selectedSubsidiaryIds);
                    vm.search.designationList = filterBySubsidiaryId(vm.designationList, selectedSubsidiaryIds);
                    vm.search.shiftGroupList = filterBySubsidiaryId(vm.shiftGroupList, selectedSubsidiaryIds);
                    vm.search.workplaceList = filterBySubsidiaryId(vm.workplaceList, selectedSubsidiaryIds);
                    vm.search.employmentTypeList = filterBySubsidiaryId(vm.employmentTypeList, selectedSubsidiaryIds);
                }
            }, 0);
        }

        function clearSubsidiaryFilters() {
            vm.search.departmentList = angular.copy(vm.departmentList);
            vm.search.designationList = angular.copy(vm.designationList);
            vm.search.shiftGroupList = angular.copy(vm.shiftGroupList);
            vm.search.workplaceList = angular.copy(vm.workplaceList);
            vm.search.employmentTypeList = angular.copy(vm.employmentTypeList);
            vm.search.selectedDepartmentList = [];
            vm.search.selectedDesignationList = [];
            vm.search.selectedShiftGroupList = [];
            vm.search.selectedWorkplaceList = [];
            vm.search.selectedEmploymentTypeList = [];
        }

        function filterBySubsidiaryId(modelArray, subsidiaryIds) {
            if (!modelArray || modelArray.length === 0) {
                return [];
            }

            return modelArray.filter(function (model) {
                return subsidiaryIds.includes(model.subsidiaryId);
            });
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function updateSortKey(key) {
            if(vm.sortKeys[key].selected){
                vm.sortKeys[key].order = vm.sortKeys[key].order == 'asc'? 'desc' : 'asc';
            }else {
                var keys = Object.keys(vm.sortKeys);
                keys.forEach(function(keyName){
                    vm.sortKeys[keyName].selected = false;
                    vm.sortKeys[keyName].order = 'asc';
                });
                vm.sortKeys[key].selected = true;
            }
            analyticsService.sendData(ANALYTICS_CONSTANT.sort, '', '', 'Sort In' + document.title, ANALYTICS_CONSTANT.sort);

            searchEmployees();
        }

        function getSortKeyAndOrder() {
            var keys = Object.keys(vm.sortKeys);
            for(var i = 0 ; i < keys.length ; i++){
                if(vm.sortKeys[keys[i]].selected == true ){
                    return {key :  vm.sortKeys[keys[i]].value , order: vm.sortKeys[keys[i]].order}
                }
            }
        }
        function openConfirmationModal(confirmationText, type) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText
                    }
                }
            }).result.then(function () {
                if (type === "activate"){
                    vm.activateOrDeactivateAll(true)
                }else if (type === "deactivate"){
                    vm.activateOrDeactivateAll(false)
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.notification')
        .controller('ErrorModalCtrl', [ '$uibModalInstance', 'toastrService', 'errorList', ErrorModalCtrl]);

    /** @ngInject */
    function ErrorModalCtrl($uibModalInstance, toastrService, errorList) {
        var vm = this;

        vm.errorList = errorList;

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.shifts')
        .controller('ShiftCreateModalCtrl', ['$uibModalInstance','shiftService','authService','utilService','toastr',ShiftCreateModalCtrl]);

    /** @ngInject */
    function ShiftCreateModalCtrl($uibModalInstance,shiftService,authService,utilService,toastr) {
        var vm = this;

        vm.cShift = {};
        vm.cShift.name = null;
        vm.cShift.enabled = null;
        vm.cShift.cShiftTimepickers = {};
        vm.cShift.cShiftTimepickers.startTime = null;
        vm.cShift.cShiftTimepickers.endTime = null;
        vm.cShift.cShiftTimepickers.lateAfter = null;
        vm.cShift.cShiftTimepickers.earlyExit = null;
        vm.cShift.cShiftTimepickers.firstHalfEnds = null;
        vm.cShift.cShiftTimepickers.secondHalfStarts = null;
        vm.cShift.cShiftTimepickers.earlyExit = null;
        vm.cShift.isMidnightCrossing = false;
        vm.cShift.disableLate = false;
        vm.hstep = null;
        vm.mstep = null;
        vm.options = null;
        vm.ismeridian = null;

        vm.hasPermission = hasPermission;
        vm.createNewShift = createNewShift;

        function init() {
            vm.cShift.enabled = true;
            vm.cShift.cShiftTimepickers.startTime = new Date();
            vm.cShift.cShiftTimepickers.endTime = new Date();
            vm.cShift.cShiftTimepickers.lateAfter = new Date();
            vm.cShift.cShiftTimepickers.earlyExit = new Date();
            // vm.cShift.cShiftTimepickers.firstHalfEnds = new Date();
            // vm.cShift.cShiftTimepickers.secondHalfStarts = new Date();


            vm.hstep = 1;
            vm.mstep = 15;
            vm.options = {
                hstep: [1, 2, 3],
                mstep: [1, 5, 10, 15, 25, 30]
            };
            vm.ismeridian = true;
        }

        init();

        function createNewShift () {
            if(!vm.cShift.name) {
                toastr.error("Name cannot be empty");
                return;
            }
            if(vm.cShift.cShiftTimepickers.firstHalfEnds != null){
                if(vm.cShift.cShiftTimepickers.secondHalfStarts == null)
                    return toastr.error("Please select both the break times");
            }
            if(vm.cShift.cShiftTimepickers.secondHalfStarts != null){
                if(vm.cShift.cShiftTimepickers.firstHalfEnds == null)
                    return toastr.error("Please select both the break times");
            }
            if(vm.cShift.cShiftTimepickers.firstHalfEnds != null && vm.cShift.cShiftTimepickers.secondHalfStarts != null){
                if(!(vm.cShift.cShiftTimepickers.firstHalfEnds > vm.cShift.cShiftTimepickers.startTime
                    && vm.cShift.cShiftTimepickers.firstHalfEnds < vm.cShift.cShiftTimepickers.endTime))
                    return toastr.error("Please select valid break times");
                else if(
                    !(vm.cShift.cShiftTimepickers.secondHalfStarts > vm.cShift.cShiftTimepickers.firstHalfEnds
                        && vm.cShift.cShiftTimepickers.secondHalfStarts < vm.cShift.cShiftTimepickers.endTime))
                    return toastr.error("Please select valid break times");
            }
            var data = {
                    'name':vm.cShift.name,
                    'startTime': moment(vm.cShift.cShiftTimepickers.startTime).format('hh:mm A'),
                    'endTime': moment(vm.cShift.cShiftTimepickers.endTime).format('hh:mm A'),
                    'lateCountStartTime':moment(vm.cShift.cShiftTimepickers.lateAfter).format('hh:mm A'),
                    'earlyCountEndTime':moment(vm.cShift.cShiftTimepickers.earlyExit).format('hh:mm A'),
                    'firstHalfEnds' : vm.cShift.cShiftTimepickers.firstHalfEnds == null? null : moment(vm.cShift.cShiftTimepickers.firstHalfEnds).format('hh:mm A'),
                    'secondHalfStarts' : vm.cShift.cShiftTimepickers.secondHalfStarts == null? null : moment(vm.cShift.cShiftTimepickers.secondHalfStarts).format('hh:mm A'),
                    "officeId" : authService.getAllInformation().office.id,
                    'status': vm.cShift.enabled ? 1 : 0,
                    'isMidnightCrossing' : vm.cShift.isMidnightCrossing,
                    'disableLate' : vm.cShift.disableLate
            };
            shiftService.createNewShift(data).then(function (shiftList) {
                $uibModalInstance.close(shiftList);
            },function (error) {
                toastr.error(error);
            });
        }

        function hasPermission (data){
            return utilService.hasPermission(data);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.shifts')
        .controller('ShiftEditModalCtrl', ['$uibModalInstance','shiftService','toastr','utilService','authService','shiftToEdit',ShiftEditModalCtrl]);

    /** @ngInject */
    function ShiftEditModalCtrl($uibModalInstance,shiftService,toastr,utilService,authService,shiftToEdit) {
        var vm = this;

        vm.enabled = null;
        vm.timepicker = {};
        vm.timepicker.startTime = null;
        vm.timepicker.endTime = null;
        vm.timepicker.lateAfter = null;
        vm.timepicker.earlyBefore = null;
        vm.timepicker.firstHalfEnds = null;
        vm.timepicker.secondHalfEnds = null;
        vm.hstep = null;
        vm.mstep = null;
        vm.options = null;
        vm.ismeridian = null;

        vm.updateShiftDetails = updateShiftDetails;
        vm.hasPermission = utilService.hasPermission;

        function init() {
            vm.shift = shiftToEdit;
            vm.enabled = shiftToEdit.status === 1 ;
            vm.timepicker = {};
            vm.timepicker.startTime = utilService.getDateObjectFromShiftTimeString(vm.shift.startTime);
            vm.timepicker.endTime = utilService.getDateObjectFromShiftTimeString(vm.shift.endTime);
            vm.timepicker.lateAfter = utilService.getDateObjectFromShiftTimeString(vm.shift.lateCountStartTime);
            vm.timepicker.earlyBefore = utilService.getDateObjectFromShiftTimeString(vm.shift.earlyCountEndTime);
            vm.timepicker.firstHalfEnds = vm.shift.firstHalfEnds == null ? null : utilService.getDateObjectFromShiftTimeString(vm.shift.firstHalfEnds);
            vm.timepicker.secondHalfStarts = vm.shift.secondHalfStarts == null ? null : utilService.getDateObjectFromShiftTimeString(vm.shift.secondHalfStarts);
            vm.hstep = 1;
            vm.mstep = 15;
            vm.options = {
                hstep: [1, 2, 3],
                mstep: [1, 5, 10, 15, 25, 30]
            };
            vm.ismeridian = true;
        }

        init();

        function updateShiftDetails() {

            if(vm.timepicker.firstHalfEnds != null){
                if(vm.timepicker.secondHalfStarts == null)
                    return toastr.error("Please select both the break times");
            }
            if(vm.timepicker.secondHalfStarts != null){
                if(vm.timepicker.firstHalfEnds == null)
                    return toastr.error("Please select both the break times");
            }
            if(vm.timepicker.firstHalfEnds != null && vm.timepicker.secondHalfStarts != null){
                if(!(vm.timepicker.firstHalfEnds > vm.timepicker.startTime
                    && vm.timepicker.firstHalfEnds < vm.timepicker.endTime))
                    return toastr.error("Please select valid break times");
                else if(
                    !(vm.timepicker.secondHalfStarts > vm.timepicker.firstHalfEnds
                        && vm.timepicker.secondHalfStarts < vm.timepicker.endTime))
                    return toastr.error("Please select valid break times");
            }
            var data =
                {
                    'id':vm.shift.id,
                    'name':vm.shift.name,
                    'startTime': moment(vm.timepicker.startTime).format('hh:mm A'),
                    'endTime': moment(vm.timepicker.endTime).format('hh:mm A'),
                    'lateCountStartTime':moment(vm.timepicker.lateAfter).format('hh:mm A'),
                    'earlyCountEndTime':moment(vm.timepicker.earlyBefore).format('hh:mm A'),
                    'status': vm.enabled ? 1:0,
                    'officeId' : authService.getAllInformation().office.id,
                    'isMidnightCrossing' : vm.shift.isMidnightCrossing,
                    'firstHalfEnds' : vm.timepicker.firstHalfEnds  == null ? null : moment(vm.timepicker.firstHalfEnds).format('hh:mm A'),
                    'secondHalfStarts' : vm.timepicker.secondHalfStarts  == null ? null : moment(vm.timepicker.secondHalfStarts).format('hh:mm A'),
                    'disableLate' : vm.shift.disableLate
                };
            shiftService.updateShiftInfo(data,vm.shift.id).then(function (shiftList) {
                $uibModalInstance.close(shiftList);
            },function (error) {
                toastr.error(error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.shifts')
        .controller('ShiftDeleteModalCtrl', ['$uibModalInstance','shiftService','toastr','shiftToDelete',ShiftDeleteModalCtrl]);

    /** @ngInject */
    function ShiftDeleteModalCtrl($uibModalInstance,shiftService,toastr,shiftToDelete) {
        var vm = this;

        vm.shiftToDelete = null;

        vm.deleteShift = deleteShift;

        function init() {
            vm.shiftToDelete = shiftToDelete;
        }

        init();

        function deleteShift() {
           var data = {
                status: -1
            };
            shiftService.updateShiftInfo(data,vm.shiftToDelete.id).then(function (shiftList) {
                $uibModalInstance.close(shiftList);
            },function (error) {
                toastr.error(error);
            });
        }
    }

})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.specialDays')
        .controller('SpecialDayCreateModalCtrl', ['specialDayService', '$uibModalInstance', 'toastrService', 'authService', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', 'workplaceService', SpecialDayCreateModalCtrl]);

    function SpecialDayCreateModalCtrl(specialDayService, $uibModalInstance, toastrService, authService, utilService, analyticsService, ANALYTICS_CONSTANT, workplaceService) {
        var vm = this;

        vm.isCreating = false;
        vm.modal = {};
        vm.modal.newEvent = {
            title: '',
            workplaceIds: [],
            isOpenStart: null
        };
        vm.workplaces = [];

        // Date picker configuration
        vm.datePickerOptions = {
            locale: {
                format: 'DD-MMM-YYYY',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel'
            },
            autoApply: false, // Shows Apply/Cancel buttons
            opens: 'right', // Controls where the date picker opens (can be 'left', 'right', 'center')
            showDropdowns: true, // Allows selecting months and years
            timePicker: false, // Ensures no time picker
            timePicker24Hour: false, // 24-hour time picker is not needed
            ranges: { // Preset ranges like "Today", "Yesterday", etc.
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            linkedCalendars: true, // This ensures the two calendars are linked for easy range selection
            alwaysShowCalendars: true, // Ensures the calendar is always visible
            startDate: moment().startOf('month'), // Default start date
            endDate: moment(), // Default end date

        };



        // Initialize date picker with default dates
        vm.attendancedatePicker = {
            date: {
                startDate: moment().startOf('day'),
                endDate: moment().startOf('day').add(0, 'days')
            },
            options: vm.datePickerOptions
        };

        vm.saveSpecialDay = saveSpecialDay;
        vm.openStart = openStart;

        // Fetch workplaces on initialization
        function init() {
            fetchWorkplaces();
        }

        function fetchWorkplaces() {
            workplaceService.getAllWorkplaces().then(function (data) {

                vm.workplaces = data; // Assign fetched workplaces to vm.workplaces
            }, function (error) {
                toastrService.showErrorToastr('Failed to fetch workplaces: ' + error, '', 5000);
            });
        }

        init();

        function openStart() {
            vm.modal.newEvent.isOpenStart = true;
        }

        function saveSpecialDay(event) {
            toastrService.clearPreviousToastr();

            // Validate date range
            if (!vm.attendancedatePicker.date.startDate || !vm.attendancedatePicker.date.endDate) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Date range cannot be empty");
            }

            if (vm.modal.newEvent.workplaceIds.length === 0) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("At least one workplace must be selected");
            }

            var startDateTimestamp = vm.attendancedatePicker.date.startDate.valueOf();
            var endDateTimestamp = vm.attendancedatePicker.date.endDate.valueOf();

            var data = {
                startDate: startDateTimestamp,
                endDate: endDateTimestamp,
                title: vm.modal.newEvent.title,
                workplaces: vm.modal.newEvent.workplaceIds.map(function (w) { return w.id; }),
                status: event.status // optional
            };
            vm.isCreating = true;

            specialDayService.createSpecialDay(data)
                .then(function (response) {
                    $uibModalInstance.close(response);
                }, function (error) {
                    toastrService.showErrorToastr("Could not create Special Day: " + error, '', 5000);
                })
                .finally(function () {
                    vm.isCreating = false;
                });
        }
    }
})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.specialDays')
        .controller('SpecialDayDeleteModalCtrl', ['specialDayService', '$uibModalInstance', 'toastrService', 'specialDayToDelete', 'analyticsService', 'ANALYTICS_CONSTANT', SpecialDayDeleteModalCtrl]);

    function SpecialDayDeleteModalCtrl(specialDayService, $uibModalInstance, toastrService, specialDayToDelete, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDeleting = false;
        vm.specialDayToDelete = angular.copy(specialDayToDelete);

        vm.deleteSpecialDay = deleteSpecialDay;

        function init() {
            // Initialization logic if needed
        }

        init();

        function deleteSpecialDay() {
            vm.isDeleting = true;

            specialDayService.updateSpecialDay(vm.specialDayToDelete.id, {
                id: vm.specialDayToDelete.id,
                status: -1 // Marking as deleted by setting status to -1
            })
                .then(function () {
                    $uibModalInstance.close();
                })
                .catch(function (error) {
                    toastrService.showErrorToastr('Failed to delete special day: ' + error, '', 5000);
                })
                .finally(function () {
                    vm.isDeleting = false;
                });
        }

        }
})();

(function () {
    'use strict';
    angular.module('InovaceClientApp.pages.main.settings.specialDays')
        .controller('SpecialDayUpdateModalCtrl', ['$uibModalInstance', 'specialDayService', 'toastrService', 'utilService', 'specialDayToUpdate', 'analyticsService', 'ANALYTICS_CONSTANT', 'workplaceService', SpecialDayUpdateModalCtrl]);

    function SpecialDayUpdateModalCtrl($uibModalInstance, specialDayService, toastrService, utilService, specialDayToUpdate, analyticsService, ANALYTICS_CONSTANT, workplaceService) {
        var vm = this;

        vm.isEditing = false;
        vm.modal = {};
        vm.modal.eventToChange = angular.copy(specialDayToUpdate);
        vm.workplaces = [];

        // Set up date picker options and initialize dates
        vm.datePickerOptions = {
            locale: {
                format: 'DD-MMM-YYYY',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel'
            },
            autoApply: false, // Shows Apply/Cancel buttons
            opens: 'right', // Controls where the date picker opens (can be 'left', 'right', 'center')
            showDropdowns: true, // Allows selecting months and years
            timePicker: false, // Ensures no time picker
            timePicker24Hour: false, // 24-hour time picker is not needed
            ranges: { // Preset ranges like "Today", "Yesterday", etc.
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            linkedCalendars: true, // This ensures the two calendars are linked for easy range selection
            alwaysShowCalendars: true, // Ensures the calendar is always visible
            startDate: moment().startOf('month'), // Default start date
            endDate: moment(), // Default end date

        };
        // Initialize date picker with the event's current dates
        vm.attendancedatePicker = {
            date: {
                startDate: vm.modal.eventToChange.startDate ? moment(vm.modal.eventToChange.startDate) : moment(),
                endDate: vm.modal.eventToChange.endDate ? moment(vm.modal.eventToChange.endDate) : moment().add(1, 'days')
            },
            options: vm.datePickerOptions
        };

        vm.updateSpecialDay = updateSpecialDay;

        function init() {
            fetchWorkplaces(); // Fetch workplaces on initialization

            if (vm.attendancedatePicker.date.startDate.isValid() && vm.attendancedatePicker.date.endDate.isValid()) {
                vm.modal.eventToChange.startDate = vm.attendancedatePicker.date.startDate.toISOString();
                vm.modal.eventToChange.endDate = vm.attendancedatePicker.date.endDate.toISOString();
            } else {
                toastrService.showErrorToastr("Invalid date format detected.");
            }
        }

        function fetchWorkplaces() {
            workplaceService.getAllWorkplaces().then(function (data) {
                vm.workplaces = data; // Assign fetched workplaces to vm.workplaces

                // Mark selected workplaces as ticked
                vm.workplaces.forEach(function(workplace) {
                    workplace.ticked = vm.modal.eventToChange.workplaces.some(function(w) {
                        return w.id === workplace.id;
                    });
                });

            }, function (error) {
                toastrService.showErrorToastr('Failed to fetch workplaces: ' + error, '', 5000);
            });
        }

        init();

        function updateSpecialDay() {
            toastrService.clearPreviousToastr();

            if (!vm.modal.eventToChange.title) {
                vm.isEditing = false;
                return toastrService.showErrorToastr("Title cannot be empty");
            }

            if (!vm.attendancedatePicker.date.startDate.isValid() || !vm.attendancedatePicker.date.endDate.isValid()) {
                vm.isEditing = false;
                return toastrService.showErrorToastr("Date range cannot be empty or invalid");
            }

            if (vm.workplaces.filter(function (w) { return w.ticked; }).length === 0) {
                vm.isEditing = false;
                return toastrService.showErrorToastr("At least one workplace must be selected");
            }

            // Prepare the data for submission
            var startDateTimestamp = vm.attendancedatePicker.date.startDate.valueOf();
            var endDateTimestamp = vm.attendancedatePicker.date.endDate.valueOf();

            var data = {
                title: vm.modal.eventToChange.title,
                startDate: startDateTimestamp,
                endDate: endDateTimestamp,
                workplaces: vm.workplaces.filter(function (w) { return w.ticked; }).map(function (w) { return w.id; })
            };

            vm.isEditing = true;
            specialDayService.updateSpecialDay(vm.modal.eventToChange.id, data)
                .then(function (response) {
                    $uibModalInstance.close(response);
                }, function (error) {
                    toastrService.showErrorToastr("Could not update Special Day: " + error, '', 5000);
                })
                .finally(function () {
                    vm.isEditing = false;
                });


        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.subDepartments')
        .controller('CreateSubDepartmentModalCtrl', ['$uibModalInstance','authService','subDepartmentService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateSubDepartmentModalCtrl]);

    /** @ngInject */
    function CreateSubDepartmentModalCtrl( $uibModalInstance,authService,subDepartmentService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.name = null;
        vm.create.status = null;
        vm.create.hierarchy = null;
        var analyticsCreateTitle = 'Create Sub Department Modal';
        var analyticsCreateUrl = 'create-sub-department';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Sub-Department In' + document.title, ANALYTICS_CONSTANT.open);
        vm.createSubDepartment = createSubDepartment;

        function createSubDepartment() {
            toastrService.clearPreviousToastr();
            if(!vm.create.name || vm.create.name > 50){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Length of name must be between 1 and 50 characters")
            }
            if(!vm.create.hierarchy){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please add hierarchy value")
            }
            var data =
                {
                    'name' : vm.create.name,
                    'officeId' : authService.getLoggedInUser().office.id,
                    'hierarchy': vm.create.hierarchy
                };
            vm.isCreating = true;
            subDepartmentService.createSubDepartment(data).then(function (subDepartmentList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Sub Department In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Sub Department created successfully")
                $uibModalInstance.close(subDepartmentList);
            },function (error) {
                toastrService.showErrorToastr("Failed to create sub department - " + error, '', 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.subDepartments')
        .controller('DeleteSubDepartmentModalCtrl', ['$uibModalInstance','subDepartmentService', 'subDepartment', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteSubDepartmentModalCtrl]);

    /** @ngInject */
    function DeleteSubDepartmentModalCtrl($uibModalInstance,subDepartmentService, subDepartment, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.subDepartment = {};
        vm.subDepartment = subDepartment;
        var analyticsDeleteTitle = 'Delete Sub Department Modal';
        var analyticsDeleteUrl = 'delete-sub-department'
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Sub Department In' + document.title, ANALYTICS_CONSTANT.open);
        vm.deleteSubDepartment = deleteSubDepartment;

        function deleteSubDepartment() {
            vm.isDeleting = true;
            var data = {
                'status' : -1
            };
            subDepartmentService.updateSubDepartmentInfo(data, vm.subDepartment.id).then(function (subDepartmentList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Sub Department In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Sub department deleted successfully");
                $uibModalInstance.close(subDepartmentList);
            }, function (message) {
                toastrService.showErrorToastr("Failed to delete sub department - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.susidiaries')
        .controller('CreateSubsidiaryModalCtrl', ['$uibModalInstance','authService','subsidiaryService','employeeService','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateSubsidiaryModalCtrl]);

    /** @ngInject */
    function CreateSubsidiaryModalCtrl( $uibModalInstance,authService,subsidiaryService,employeeService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.name = null;
        vm.create.subsidiaryExternalSyncId = null;
        vm.create.selectedEmployees = []; // Changed to array for multi-select
        vm.create.enabled = true; // Default to active

        vm.employees = [];
        vm.isLoadingEmployees = false;

        var analyticsCreateTitle = 'Create Subsidiary Modal';
        var analyticsCreateUrl = 'create-subsidiary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Subsidiary In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createSubsidiary = createSubsidiary;

        // Load subsidiary admin employees
        loadEmployees();

        function loadEmployees() {
            vm.isLoadingEmployees = true;
            employeeService.getSubsidiaryAdminEmployees().then(function (employees) {
                vm.employees = employees;
            }, function (error) {
                console.error('Failed to load employees:', error);
                toastrService.showErrorToastr("Failed to load employees - " + error);
            }).finally(function () {
                vm.isLoadingEmployees = false;
            });
        }

        function createSubsidiary() {
            toastrService.clearPreviousToastr();
            
            // Validate name is required
            if(!vm.create.name || vm.create.name.trim() === ''){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name is required")
            }

            if(vm.create.name.length > 255){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name must not exceed 255 characters")
            }

            // Check if subsidiaryExternalSyncId is provided and validate length
            if(vm.create.subsidiaryExternalSyncId && vm.create.subsidiaryExternalSyncId.length > 255){
                vm.isCreating = false;
                return toastrService.showErrorToastr("External sync ID must not exceed 255 characters")
            }
            
            var data = {
                'name' : vm.create.name,
                'subsidiaryExternalSyncId' : vm.create.subsidiaryExternalSyncId,
                'officeId' : authService.getLoggedInUser().office.id,
                'status' : vm.create.enabled ? 1 : 0
            };
            
            vm.isCreating = true;
            subsidiaryService.createSubsidiary(data).then(function (subsidiary) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Subsidiary In' + document.title, ANALYTICS_CONSTANT.create);

                // Check if subsidiary object and id exist
                if (!subsidiary || !subsidiary.id) {
                    toastrService.showSuccessToastr("Subsidiary created successfully");
                    $uibModalInstance.close(subsidiary);
                    vm.isCreating = false;
                    return;
                }


                // If employees are selected, update each employee profile with subsidiaryId
                // Check if selectedEmployees is a valid array with items
                if (vm.create.selectedEmployees &&
                    Array.isArray(vm.create.selectedEmployees) &&
                    vm.create.selectedEmployees.length > 0) {


                    // Update all selected employees
                    var employeeUpdatePromises = vm.create.selectedEmployees.map(function(employee) {
                        if (employee && employee.empId) {
                            var employeeData = {
                                subsidiaryId: parseInt(subsidiary.id)
                            };
                            return employeeService.updateEmployeeProfile(employee.empId, employeeData);
                        }
                    });

                    // Wait for all employee updates to complete
                    Promise.all(employeeUpdatePromises).then(function (responses) {
                        toastrService.showSuccessToastr("Subsidiary created and " + vm.create.selectedEmployees.length + " employee(s) updated successfully");
                        $uibModalInstance.close(subsidiary);
                        vm.isCreating = false;
                    }).catch(function (error) {
                        console.error('Some employee updates failed:', error);
                        toastrService.showWarningToastr("Subsidiary created but some employee updates failed - " + error, '', 5000);
                        $uibModalInstance.close(subsidiary);
                        vm.isCreating = false;
                    });
                } else {
                    toastrService.showSuccessToastr("Subsidiary created successfully");
                    $uibModalInstance.close(subsidiary);
                    vm.isCreating = false;
                }
            },function (error) {
                console.error('Failed to create subsidiary:', error);
                toastrService.showErrorToastr("Failed to create subsidiary - " + error, '', 5000);
                $uibModalInstance.dismiss(error);
                vm.isCreating = false;
            });
        }
    }

})();


(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.subDepartments')
        .controller('EditSubDepartmentModalCtrl', ['authService', '$uibModalInstance','subDepartmentService', 'officeService', 'subDepartment', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',EditSubDepartmentModalCtrl]);

    /** @ngInject */
    function EditSubDepartmentModalCtrl(authService, $uibModalInstance,subDepartmentService, officeService, subDepartment,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.subDepartment = {};
        vm.subDepartment = subDepartment;
        var analyticsEditTitle = 'Edit Sub Department Modal';
        var analyticsEditUrl = 'edit-sub-department';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Sub Department In' + document.title, ANALYTICS_CONSTANT.open);
        vm.updateSubDepartmentDetails = updateSubDepartmentDetails;

        init();

        function init() {
            vm.subDepartment.enabled = vm.subDepartment.status === 1;
        }

        function updateSubDepartmentDetails() {
            toastrService.clearPreviousToastr();
            var data = {
                'name' : vm.subDepartment.name,
                'status' : vm.subDepartment.enabled? 1 : 0,
                'hierarchy': vm.subDepartment.hierarchy
            };
            if(!vm.subDepartment.name || vm.subDepartment.name.length > 50){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Length of name must be between 1 and 50 characters")
            }
            vm.isEditing = true;
            subDepartmentService.updateSubDepartmentInfo(data, vm.subDepartment.id).then(function (subDepartment) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Sub Department In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.showSuccessToastr("Sub department updated successfully");
                $uibModalInstance.close(subDepartment);
            }, function (message) {
                toastrService.showErrorToastr("Failed to update sub department - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isEditing = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.susidiaries')
        .controller('DeleteSubsidiaryModalCtrl', ['$uibModalInstance','subsidiaryService', 'subsidiary', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteSubsidiaryModalCtrl]);

    /** @ngInject */
    function DeleteSubsidiaryModalCtrl($uibModalInstance,subsidiaryService, subsidiary, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.subsidiary = {};
        vm.subsidiary = subsidiary;

        var analyticsDeleteTitle = 'Delete Subsidiary Modal';
        var analyticsDeleteUrl = 'delete-subsidiary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Subsidiary In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteSubsidiary = deleteSubsidiary;

        function deleteSubsidiary() {
            vm.isDeleting = true;
            var data = {
                'status' : -1,
                "name": vm.subsidiary.name,
                'subsidiaryAdminId': vm.subsidiary.employeeId,
            };
            subsidiaryService.updateSubsidiaryInfo(data, vm.subsidiary.id).then(function (subsidiary) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Subsidiary In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Subsidiary deleted successfully");
                $uibModalInstance.close(subsidiary);
            }, function (message) {
                toastrService.showErrorToastr("Failed to delete subsidiary - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
            }).finally(function () {
                vm.isDeleting = false;
            });
        }
    }

})();


(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.susidiaries')
        .controller('EditSubsidiaryModalCtrl', ['authService', '$uibModalInstance','subsidiaryService', 'officeService', 'employeeService', 'subsidiary', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', EditSubsidiaryModalCtrl]);

    /** @ngInject */
    function EditSubsidiaryModalCtrl(authService, $uibModalInstance,subsidiaryService, officeService, employeeService, subsidiary,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.subsidiary = {};
        vm.subsidiary = subsidiary;
        vm.employees = [];
        vm.isLoadingEmployees = false;
        vm.subsidiary.selectedEmployees = [];
        vm.previousEmployeeId = null; // Store the original employee ID

        var analyticsEditTitle = 'Edit Subsidiary Modal';
        var analyticsEditUrl = 'edit-subsidiary'
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Subsidiary In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateSubsidiaryDetails = updateSubsidiaryDetails;

        init();

        function init() {
            vm.subsidiary.enabled = vm.subsidiary.status === 1;
            // Store the original employee ID for later comparison
            vm.previousEmployeeId = vm.subsidiary.employeeId || null;
            loadEmployees();
        }

        function loadEmployees() {
            vm.isLoadingEmployees = true;
            employeeService.getSubsidiaryAdminEmployees().then(function (employees) {
                vm.employees = employees;

                // If subsidiary has an employeeId, pre-select that employee
                if (vm.subsidiary.employeeId) {
                    var selectedEmployee = vm.employees.find(function(emp) {
                        return emp.empId === vm.subsidiary.employeeId;
                    });

                    if (selectedEmployee) {
                        selectedEmployee.ticked = true;
                        vm.subsidiary.selectedEmployees = [selectedEmployee];
                    }
                }
            }, function (error) {
                console.error('Failed to load employees:', error);
                toastrService.showErrorToastr("Failed to load employees - " + error);
            }).finally(function () {
                vm.isLoadingEmployees = false;
            });
        }

        function updateSubsidiaryDetails() {
            toastrService.clearPreviousToastr();
            
            // Validate name is required
            if(!vm.subsidiary.name || vm.subsidiary.name.trim() === ''){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name is required")
            }

            if(vm.subsidiary.name.length > 255){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name must not exceed 255 characters")
            }
            
            var data = {
                'name' : vm.subsidiary.name,
                'subsidiaryExternalSyncId' : vm.subsidiary.externalSyncId,
                'status' : vm.subsidiary.enabled? 1 : 0
            };
            
            vm.isEditing = true;
            subsidiaryService.updateSubsidiaryInfo(data, vm.subsidiary.id).then(function (subsidiary) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Subsidiary In' + document.title, ANALYTICS_CONSTANT.edit);

                // Get the new employee ID (if any)
                var newEmployeeId = null;
                if (vm.subsidiary.selectedEmployees &&
                    Array.isArray(vm.subsidiary.selectedEmployees) &&
                    vm.subsidiary.selectedEmployees.length > 0) {
                    var selectedEmployee = vm.subsidiary.selectedEmployees[0];
                    if (selectedEmployee && selectedEmployee.empId) {
                        newEmployeeId = selectedEmployee.empId;
                    }
                }

                // Check if employee assignment has changed
                var employeeChanged = vm.previousEmployeeId !== newEmployeeId;

                if (employeeChanged && newEmployeeId) {
                    // Employee has been changed or newly assigned
                    var employeeData = {
                        subsidiaryId: parseInt(vm.subsidiary.id),
                        previousEmployeeId: vm.previousEmployeeId ? parseInt(vm.previousEmployeeId) : null,
                        newEmployeeId: parseInt(newEmployeeId)
                    };

                    employeeService.updateEmployeeProfile(newEmployeeId, employeeData).then(function() {
                        toastrService.showSuccessToastr("Subsidiary and admin updated successfully");
                        $uibModalInstance.close(subsidiary);
                    }, function(error) {
                        console.error('Failed to update employee:', error);
                        toastrService.showWarningToastr("Subsidiary updated but failed to assign admin - " + error, '', 5000);
                        $uibModalInstance.close(subsidiary);
                    }).finally(function() {
                        vm.isEditing = false;
                    });
                } else if (employeeChanged && !newEmployeeId && vm.previousEmployeeId) {
                    // Employee has been removed (previous employee existed but now none selected)
                    // Update the previous employee to remove subsidiary assignment
                    var removeEmployeeData = {
                        subsidiaryId: null,
                        previousEmployeeId: parseInt(vm.previousEmployeeId),
                        newEmployeeId: null
                    };

                    employeeService.updateEmployeeProfile(vm.previousEmployeeId, removeEmployeeData).then(function() {
                        toastrService.showSuccessToastr("Subsidiary updated and admin removed successfully");
                        $uibModalInstance.close(subsidiary);
                    }, function(error) {
                        console.error('Failed to remove employee:', error);
                        toastrService.showWarningToastr("Subsidiary updated but failed to remove admin - " + error, '', 5000);
                        $uibModalInstance.close(subsidiary);
                    }).finally(function() {
                        vm.isEditing = false;
                    });
                } else {
                    // No employee change
                    toastrService.showSuccessToastr("Subsidiary updated successfully");
                    $uibModalInstance.close(subsidiary);
                    vm.isEditing = false;
                }
            }, function (message) {
                toastrService.showErrorToastr("Failed to update subsidiary - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
                vm.isEditing = false;
            });
        }
    }

})();


(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.weeklyOffDayPolicy')
    app.controller('CreateWeeklyOffDaysPolicyModalCtrl', ['weeklyOffDaysService','authService','$uibModalInstance','toastr','utilService',CreateWeeklyOffDaysPolicyModalCtrl]);

    /** @ngInject */
    function CreateWeeklyOffDaysPolicyModalCtrl(weeklyOffDaysService,authService,$uibModalInstance,toastr,utilService) {
        var vm = this;

        vm.modal = {};
        vm.modal.newPolicyName = null;
        vm.multiSelectInputModel = [];

        vm.createPolicy = createPolicy;

        function init() {
            vm.multiSelectInputModel = utilService.createInputModelFromString('0000000');
        }

        init();

        function createPolicy () {
            var data =
                {
                    name: vm.modal.newPolicyName,
                    offDays: utilService.getFormattedString(vm.multiSelectInputModel),
                    status: 1,
                    officeId:authService.getLoggedInUser().office.id,
                };
            weeklyOffDaysService.createWeeklyOffDaysPolicy(data).then(onPolicyCreateSuccess,onPolicyCreateFailure);
        }

        function onPolicyCreateSuccess (weeklyOffDaysPolicyList) {
           $uibModalInstance.close(weeklyOffDaysPolicyList);
        }

        function onPolicyCreateFailure(error) {
            toastr.error(error);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.weeklyOffDayPolicy')
    app.controller('DeleteWeeklyOffDaysPolicyModalCtrl', ['weeklyOffDaysService','$uibModalInstance','toastr','policyToDelete',DeleteWeeklyOffDaysPolicyModalCtrl]);

    /** @ngInject */
    function DeleteWeeklyOffDaysPolicyModalCtrl(weeklyOffDaysService,$uibModalInstance,toastr,policyToDelete) {
        var vm = this;

        vm.policyToDelete = null;
        vm.deletePolicy = deletePolicy;

        function init() {
            vm.policyToDelete = policyToDelete;
        }

        init();

        function deletePolicy(policyId) {
            weeklyOffDaysService.updateWeeklyPolicy(policyId, {status:-1}).then(onDeleteSuccess,onDeleteFailure);
        }

        function onDeleteSuccess(weeklyOffDaysPolicyList) {
            $uibModalInstance.close(weeklyOffDaysPolicyList)
        }

        function onDeleteFailure(error) {
            toastr.error(error);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.weeklyOffDayPolicy')
    app.controller('UpdateWeeklyOffDaysPolicyModalCtrl', ['weeklyOffDaysService','$uibModalInstance','toastr','utilService','policyToEdit',UpdateWeeklyOffDaysPolicyModalCtrl]);

    /** @ngInject */
    function UpdateWeeklyOffDaysPolicyModalCtrl(weeklyOffDaysService,$uibModalInstance,toastr,utilService,policyToEdit) {
        var vm = this;

        vm.modal={};
        vm.modal.multiSelectOutputModel =[];
        vm.multiSelectInputModel = [];
        vm.policyToEdit = null;

        vm.updatePolicy = updatePolicy;

        function init() {
            vm.policyToEdit = policyToEdit;
            vm.multiSelectInputModel = utilService.createInputModelFromString(vm.policyToEdit.offDays);
        }

        init();

        function updatePolicy () {
            var data =
                {
                    name: vm.policyToEdit.name,
                    offDays: utilService.getFormattedString(vm.multiSelectInputModel)
                };
            weeklyOffDaysService.updateWeeklyPolicy(vm.policyToEdit.id, data).then(onPolicyUpdateSuccess,onPolicyUpdateFailure);
        }

        function onPolicyUpdateSuccess (weeklyOffDaysPolicyList) {
            $uibModalInstance.close(weeklyOffDaysPolicyList);
        }

        function onPolicyUpdateFailure (error) {
            toastr.error("Update Failed " + error);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.weeklyOffDayPolicy')
    app.controller('ViewAssignedEmployeesModalCtrl', ['employeeService','toastr','policyId',ViewAssignedEmployeesModalCtrl]);

    /** @ngInject */
    function ViewAssignedEmployeesModalCtrl(employeeService,toastr,policyId) {
        var vm = this;

        vm.employeeList = null;

        vm.getEmployees = getAssignedEmployees;

        function init() {
            getAssignedEmployees(policyId);
        }
        init();

        function getAssignedEmployees(policyId) {
            employeeService.getEmployeesAssignedToWeeklyOffDaysPolicy(policyId).then(onEmployeeListFetchSuccess,onEmployeeListFetchFailure);
        }

        function onEmployeeListFetchSuccess(employees) {
            vm.employeeList = employees;
        }

        function onEmployeeListFetchFailure(error) {
            toastr.error("Could not fetch list "+error);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.workplaces')
        .controller('CreateWorkplaceModalCtrl', ['$uibModalInstance', 'API', '$timeout', 'authService', 'workplaceService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', '$scope', CreateWorkplaceModalCtrl]);

    /** @ngInject */
    function CreateWorkplaceModalCtrl($uibModalInstance, API, $timeout, authService, workplaceService, toastrService, analyticsService, ANALYTICS_CONSTANT, $scope) {
        var vm = this;

        vm.isCreating = false;
        vm.create = {};
        vm.create.cName = null;
        vm.create.cLat = null;
        vm.create.cLong = null;
        vm.create.locationName = null;
        vm.mapKey = API.googleApiKey;
        var map;
        var marker;
        var autocomplete;
        var analyticsCreateTitle = 'Create Workplace';
        var analyticsCreateUrl = 'create-workplace';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Workplace In' + document.title, ANALYTICS_CONSTANT.open);
        vm.createNewWorkplace = createNewWorkplace;

        function initMap() {
            map = new google.maps.Map(document.getElementById('map'), {
                center: { lat: 23.7278384, lng: 90.4105624 },
                zoom: 12
            });
            marker = new google.maps.Marker({
                position: { lat: 23.7278384, lng: 90.4105624 },
                map: map,
                draggable: true
            });
            google.maps.event.addListener(marker, 'dragend', function () {
                var position = marker.getPosition();
                vm.create.cLat = position.lat();
                vm.create.cLong = position.lng();
                $scope.$apply();
                geocodeLatLng(position);
            });
            initAutocomplete();
        }

        function geocodeLatLng(position) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: position }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    vm.create.locationName = results[0].formatted_address;
                    $scope.$apply();
                }
            });
        }


        function initAutocomplete() {
            var input = document.getElementById('locationName');
            autocomplete = new google.maps.places.Autocomplete(input, {
                types: ['establishment', 'geocode'],
                fields: ['geometry', 'name', 'formatted_address'],
            });

            // Listen for place selection
            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();
                if (!place.geometry) {
                    toastrService.showErrorToastr('Location not found');
                    return;
                }

                map.setCenter(place.geometry.location);
                marker.setPosition(place.geometry.location);
                vm.create.cLat = place.geometry.location.lat();
                vm.create.cLong = place.geometry.location.lng();
                vm.create.locationName = place.name;
                $scope.$apply();
            });
        }



        function createNewWorkplace() {
            if (vm.create.cName === null) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            var data = {
                "name": vm.create.cName,
                "officeId": authService.getAllInformation().office.id,
                "latValue": vm.create.cLat,
                "longValue": vm.create.cLong,
            };
            vm.isCreating = true;
            console.log(data);
            workplaceService.createWorkplace(data).then(function createSuccessCallback(workplaceList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Workplace In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.showSuccessToastr("Workplace Created.");
                $uibModalInstance.close(workplaceList);
            }, function createFailureCallback(error) {
                toastrService.showErrorToastr("Failed to create Workplace: " + error, '', 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        };

        function loadGoogleMapsAPI(callback) {
            if (window.google && window.google.maps) {
                callback();
            } else {
                var script = document.createElement('script');
                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + vm.mapKey + '&libraries=places';
                script.async = true;
                script.defer = true;
                script.onload = callback;
                document.head.appendChild(script);
            }
        }

        $timeout(function () {
            loadGoogleMapsAPI(initMap);
        }, 0);
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.workplaces')
        .controller('DeleteWorkplaceModalCtrl', ['$uibModalInstance', 'workplaceService', 'workplace', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteWorkplaceModalCtrl]);

    /** @ngInject */
    function DeleteWorkplaceModalCtrl($uibModalInstance, workplaceService, workplace,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.workplace = workplace;
        var analyticsDeleteTitle = 'Delete Workplace';
        var analyticsDeleteUrl = 'delete-workplace';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Workplace In' + document.title, ANALYTICS_CONSTANT.open);
        vm.deleteWorkplace = deleteWorkplace;

        function deleteWorkplace() {
            vm.isDeleting = true;

            var data = {
                'status': -1
            };

            workplaceService.updateWorkplace(data, vm.workplace.id).then(function updateSuccessCallback(workplace) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Workplace In' + document.title, ANALYTICS_CONSTANT.delete);
                $uibModalInstance.close(workplace);
                toastrService.showSuccessToastr("Workplace deleted successfully.");
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to delete Workplace: " + error,'',5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isDeleting = false;
            });


        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.workplaces')
        .controller('EditWorkplaceModalCtrl', ['$uibModalInstance', 'API', '$timeout', 'workplaceService', 'toastrService', 'workplace', 'analyticsService', 'ANALYTICS_CONSTANT', '$scope', EditWorkplaceModalCtrl]);

    /** @ngInject */
    function EditWorkplaceModalCtrl($uibModalInstance, API, $timeout, workplaceService, toastrService, workplace, analyticsService, ANALYTICS_CONSTANT, $scope) {

        var vm = this;

        vm.isEditing = false;
        vm.workplace = angular.copy(workplace);
        vm.employmentTypeList = [];
        vm.selectedEmploymentType = [];
        vm.locationName = null;
        vm.mapKey = API.googleApiKey;
        var map;
        var marker;
        var autocomplete;
        var analyticsEditTitle = 'Edit Workplace';
        var analyticsEditUrl = 'edit-workplace';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Workplace In' + document.title, ANALYTICS_CONSTANT.open);
        vm.updateWorkplace = updateWorkplace;

        function initMap() {
            vm.workplace.enabled = vm.workplace.status === 1;
            map = new google.maps.Map(document.getElementById('map'), {
                center: { lat: vm.workplace.latValue, lng: vm.workplace.longValue },
                zoom: 12
            });
            marker = new google.maps.Marker({
                position: { lat: vm.workplace.latValue, lng: vm.workplace.longValue },
                map: map,
                draggable: true
            });

            // Populate location name based on coordinates
            geocodeLatLng(marker.getPosition());

            google.maps.event.addListener(marker, 'dragend', function () {
                var position = marker.getPosition();
                vm.workplace.latValue = position.lat();
                vm.workplace.longValue = position.lng();
                $scope.$apply();
                geocodeLatLng(position);
            });

            initAutocomplete();
        }


        function geocodeLatLng(position) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: position }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    vm.locationName = results[0].formatted_address;
                    $scope.$apply();
                }
            });
        }


        function initAutocomplete() {
            var input = document.getElementById('locationName');
            autocomplete = new google.maps.places.Autocomplete(input, {
                types: ['establishment', 'geocode'],
                fields: ['geometry', 'name', 'formatted_address'],
            });

            // Listen for place selection
            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();
                if (!place.geometry) {
                    toastrService.showErrorToastr('Location not found');
                    return;
                }

                map.setCenter(place.geometry.location);
                marker.setPosition(place.geometry.location);
                vm.workplace.latValue = place.geometry.location.lat();
                vm.workplace.longValue = place.geometry.location.lng();
                vm.locationName = place.name;
                $scope.$apply();
            });
        }

        function updateWorkplace() {
            if(!vm.workplace.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            var data = {
                'name'      : vm.workplace.name,
                'status'    : vm.workplace.enabled ? 1 : 0,
                'latValue'  : vm.workplace.latValue,
                'longValue' : vm.workplace.longValue,
            };
            vm.isEditing = true;
            workplaceService.updateWorkplace(data, vm.workplace.id).then(function updateSuccessCallback(workplace) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Workplace In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.showSuccessToastr("Workplace updated successfully");
                $uibModalInstance.close(workplace);
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to update Workplace: " + error,'',5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function loadGoogleMapsAPI(callback) {
            if (window.google && window.google.maps) {
                callback();
            } else {
                var script = document.createElement('script');
                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + vm.mapKey + '&libraries=places';
                script.async = true;
                script.defer = true;
                script.onload = callback;
                document.head.appendChild(script);
            }
        }

        $timeout(function () {
            loadGoogleMapsAPI(initMap);
        }, 0);
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.dynamicShiftGroups')
        .controller('DeleteDynamicShiftGroupModalCtrl', ['$uibModalInstance', 'shiftGroupService', 'shiftGroup', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteDynamicShiftGroupModalCtrl]);

    /** @ngInject */
    function DeleteDynamicShiftGroupModalCtrl($uibModalInstance, shiftGroupService, shiftGroup,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.shiftGroup = shiftGroup;
        var analyticsDeleteTitle = 'Delete Dynamic Shift Group Modal';
        var analyticsDeleteUrl = 'delete-dynamic-shift-group';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Dynamic Shift Group In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteShiftGroup = deleteShiftGroup;

        function deleteShiftGroup() {
            vm.isDeleting = true;
            shiftGroupService.deleteShiftGroup(vm.shiftGroup.shiftGroupId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Dynamic Shift Group In' + document.title, ANALYTICS_CONSTANT.delete);
                $uibModalInstance.close();
                toastrService.showSuccessToastr("Deleted Shift Group.");
            }, function (error) {
                toastrService.showErrorToastr("Failed to delete Shift Group: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isDeleting = false;
            });


        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shiftGroups')
        .controller('CreateDynamicShiftGroupModalCtrl', ['$uibModalInstance', 'authService', 'shiftGroupService','shiftnService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateDynamicShiftGroupModalCtrl]);

    /** @ngInject */
    function CreateDynamicShiftGroupModalCtrl($uibModalInstance, authService, shiftGroupService, shiftnService, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isCreating = false;
        vm.name = null;
        vm.offDayList = [
            {name : 'Saturday', value : '6', selected : false},
            {name : 'Sunday', value : '7', selected : false},
            {name : 'Monday', value : '1', selected : false},
            {name : 'Tuesday', value : '2', selected : false},
            {name : 'Wednesday', value : '3', selected : false},
            {name : 'Thursday', value : '4', selected : false},
            {name : 'Friday', value : '5', selected : true},
        ];
        vm.selectedOffdays = [];
        vm.shiftList = [];
        vm.selectedShiftList = [];
        var analyticsCreateTitle = 'Create Dynamic Shift Group Modal';
        var analyticsCreateUrl = 'create-dynamic-shift-group';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Dynamic Shift Group In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createNewShiftGroup = createNewShiftGroup;

        function init(){
            shiftnService.getAllShifts(true).then(function (data){
                vm.shiftList = data;
            });
        }
        init();
        function createNewShiftGroup() {
            toastrService.clearPreviousToastr();
            var data = {
                "name"      : vm.name
            };
            var offDays = vm.selectedOffdays.length === 0 ? '' : vm.selectedOffdays.map(function (o){return o.value;}).join(',');
            data.defaultOffDays = offDays;
            data.shiftIds = vm.selectedShiftList.map(function (shift) {
                return shift.id;
            })
            if(!vm.name){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            if(data.shiftIds.length === 0){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please select at least one shift.");
            }
            vm.isCreating = true;
            shiftGroupService.createDynamicShiftGroups(data).then(function (shiftGroup) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Dynamic Shift Group In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Shift Group Created.");
                $uibModalInstance.close(shiftGroup);
            }, function (error) {
                toastrService.showErrorToastr("Failed to create Shift Group: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shiftGroups')
        .controller('EditDynamicShiftGroupModalCtrl', ['$uibModalInstance', 'shiftGroupService', 'toastrService', 'shiftGroup','shiftnService', 'analyticsService', 'ANALYTICS_CONSTANT', EditDynamicShiftGroupModalCtrl]);

    /** @ngInject */
    function EditDynamicShiftGroupModalCtrl($uibModalInstance, shiftGroupService, toastrService, shiftGroup, shiftnService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.offDayList = [
            {name : 'Saturday', value : '6', selected : false},
            {name : 'Sunday', value : '7', selected : false},
            {name : 'Monday', value : '1', selected : false},
            {name : 'Tuesday', value : '2', selected : false},
            {name : 'Wednesday', value : '3', selected : false},
            {name : 'Thursday', value : '4', selected : false},
            {name : 'Friday', value : '5', selected : false},
        ];

        vm.shiftGroup = shiftGroup;
        vm.selectedOffdays = [];
        vm.shiftList = [];
        vm.selectedShiftList = [];
        vm.updateShiftGroup = updateShiftGroup;
        var analyticsEditTitle = 'Edit Dynamic Shift Group Modal';
        var analyticsEditUrl = 'edit-dynamic-shift-group';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Dynamic Shift Group In' + document.title, ANALYTICS_CONSTANT.open);

        populateSelectedOffDays();

        function init() {
            shiftnService.getAllShifts().then(function (data){
                vm.shiftList = data;
                populateSelectedShifts();
            })
        }
        init();
            function updateShiftGroup() {
            toastrService.clearPreviousToastr();
            var data = {
                'name'      : vm.shiftGroup.shiftGroupName
            };
            var shiftIds = vm.selectedShiftList.map(function (shiftId) {
                return shiftId.id;
            });
            if(!vm.shiftGroup.shiftGroupName){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            if(shiftIds.length == 0){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Please select at least one shift");
            }
            var offDays = vm.selectedOffdays.length == 0 ? '':vm.selectedOffdays.map(function (o){return o.value;}).join(',');
            data.defaultOffDays = offDays;
            data.shiftIds = shiftIds;
            vm.isEditing = true;
            shiftGroupService.updateDynamicShiftGroups(vm.shiftGroup.shiftGroupId, data).then(function (shiftGroup) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Dynamic Shift Group In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Shift Group updated.");
                $uibModalInstance.close(shiftGroup);
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to update Shift Group: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function populateSelectedOffDays(){
            var offDays = vm.shiftGroup.defaultOffDays;
            if(offDays == null || offDays == '') return ;
            var offDaysArray = offDays.split(',');

            if(offDaysArray.length == 1){
                for(var i = 0; i < vm.offDayList.length;i++){
                    if(vm.offDayList[i].value == offDays[0]){
                        vm.offDayList[i].selected = true;
                        vm.selectedOffdays.push({value:vm.offDayList[i].value});
                    }
                }
            }
            else{
                for(var i = 0; i < vm.offDayList.length;i++){
                    if(offDaysArray.includes(vm.offDayList[i].value)){
                        vm.offDayList[i].selected = true;
                        vm.selectedOffdays.push({value:vm.offDayList[i].value});
                    }
                }
            }

        }

        function populateSelectedShifts() {
            var shiftGroupShiftIdList = vm.shiftGroup.shifts.map(function (data) {
                return data.shiftId;
            })
            vm.shiftList.forEach(function (shift) {
                if(shiftGroupShiftIdList.includes(shift.id)){
                    shift.selected = true;
                    vm.selectedShiftList.push({id: shift.shiftId});
                }
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.roster')
        .controller('DownloadRosterModalCtrl', ['$scope', '$uibModalInstance','rosterService','authService','toastrService', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', DownloadRosterModalCtrl]);

    /** @ngInject */
    function DownloadRosterModalCtrl($scope, $uibModalInstance,rosterService, authService,toastrService, utilService ,analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDownload = false;
        vm.modal = {};
        vm.modal.newEvent = {};
        vm.excelUrl = ""
        vm.modal.newEvent.date = getInitialFromAndToDate();
        var today = new Date();
        vm.minDate = new Date(today.getFullYear()-1, today.getMonth(), 1);
        vm.maxDate = new Date(today.getFullYear(), 11, 31)
        vm.modal.newEvent.option = {
            minDate : vm.minDate,
            maxDate : vm.maxDate,
            applyClass: 'btn-success',
            locale : {
                applyLabel: "Apply",
                fromLabel: "From",
                format: 'D MMM YYYY', //will give you 6 Jan 2017
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
            },
            ranges: utilService.getDatePickerRanges()
        }
        vm.modal.newEvent.isOpenStart = null;

        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };
        //
         vm.downloadEmployeeRoster = downloadEmployeeRoster;

        function getInitialFromAndToDate() {
            return {
                'startDate': moment(),
                'endDate': moment().add(1, 'days')
            };
        }

        function init() {
            vm.modal.newEvent.date = getInitialFromAndToDate();
        }

        init();

        $scope.$watch('vm.modal.newEvent.date', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                var startDate = newValue.startDate;
                var endDate = newValue.endDate;
            }
        }, true);

        function openStart () {
            vm.modal.newEvent.isOpenStart = true;
        }

        function downloadEmployeeRoster() {
            // Access the latest start and end dates
            var startDate = moment(vm.modal.newEvent.date.startDate).valueOf();
            var endDate = moment(vm.modal.newEvent.date.endDate).valueOf();

            vm.excelUrl = rosterService.downloadRoster(startDate, endDate)
            if (vm.excelUrl != null && vm.excelUrl.trim() !== "") {

                window.open(vm.excelUrl, '_blank', '');
                vm.isDownload = true
            }
            if(vm.isDownload) {
                toastrService.showSuccessToastr("Excel Downloaded");
                $uibModalInstance.close();  // Close the modal
            } else {
                toastrService.showErrorToastr("Excel not Downloaded");
            }

        }



    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shiftGroups')
        .controller('CreateShiftGroupModalCtrl', ['$uibModalInstance', 'authService', 'shiftGroupService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateShiftGroupModalCtrl]);

    /** @ngInject */
    function CreateShiftGroupModalCtrl($uibModalInstance, authService, shiftGroupService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.name = null;
        vm.offDayList = [
            {name : 'Saturday', value : '6', selected : false},
            {name : 'Sunday', value : '7', selected : false},
            {name : 'Monday', value : '1', selected : false},
            {name : 'Tuesday', value : '2', selected : false},
            {name : 'Wednesday', value : '3', selected : false},
            {name : 'Thursday', value : '4', selected : false},
            {name : 'Friday', value : '5', selected : true},
        ];
        vm.selectedOffdays = [];
        var analyticsCreateTitle = 'Create Shift Group Modal';
        var analyticsCreateUrl = 'create-shift-group';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create New Shift Group In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createNewShiftGroup = createNewShiftGroup;

        function createNewShiftGroup() {
            toastrService.clearPreviousToastr();
            var data = {
                "name"      : vm.name
            };
            var offDays = vm.selectedOffdays.length == 0 ? '':vm.selectedOffdays.map(function (o){return o.value;}).join(',');
            data.defaultOffDays = offDays;

            if(!vm.name){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name Can't be empty");
            }

            vm.isCreating = true;
            shiftGroupService.createShiftGroup(data).then(function (shiftGroup) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create New Shift Group In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Shift Group Created.");
                $uibModalInstance.close(shiftGroup);
            }, function (error) {
                toastrService.showErrorToastr("Failed to create Shift Group: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shiftGroups')
        .controller('EditShiftGroupModalCtrl', ['$uibModalInstance', 'shiftGroupService', 'toastrService', 'shiftGroup', 'analyticsService', 'ANALYTICS_CONSTANT', EditShiftGroupModalCtrl]);

    /** @ngInject */
    function EditShiftGroupModalCtrl($uibModalInstance, shiftGroupService, toastrService, shiftGroup, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.offDayList = [
            {name : 'Saturday', value : '6', selected : false},
            {name : 'Sunday', value : '7', selected : false},
            {name : 'Monday', value : '1', selected : false},
            {name : 'Tuesday', value : '2', selected : false},
            {name : 'Wednesday', value : '3', selected : false},
            {name : 'Thursday', value : '4', selected : false},
            {name : 'Friday', value : '5', selected : false},
        ];
        var analyticsEditTitle = 'Edit Shift Group Modal';
        var analyticsEditUrl = 'edit-shift-group';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Shift Group In' + document.title, ANALYTICS_CONSTANT.open);

        vm.shiftGroup = shiftGroup;
        vm.selectedOffdays = [];
        vm.updateShiftGroup = updateShiftGroup;
        populateSelectedOffDays();

        function updateShiftGroup() {
            toastrService.clearPreviousToastr();
            var data = {
                'name'      : vm.shiftGroup.name
            };
            var offDays = vm.selectedOffdays.length == 0 ? '':vm.selectedOffdays.map(function (o){return o.value;}).join(',');
            data.defaultOffDays = offDays;

            if(!vm.shiftGroup.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }

            vm.isEditing = true;
            shiftGroupService.updateShiftGroup(data, vm.shiftGroup.id).then(function (shiftGroup) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Shift Group In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Shift Group updated.");
                $uibModalInstance.close(shiftGroup);
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to update Shift Group: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function populateSelectedOffDays(){
            var offDays = vm.shiftGroup.defaultOffDays;
            if(offDays == null || offDays == '') return ;
            var offDaysArray = offDays.split(',');

            if(offDaysArray.length == 1){
                for(var i = 0; i < vm.offDayList.length;i++){
                    if(vm.offDayList[i].value == offDays[0]){
                        vm.offDayList[i].selected = true;
                        vm.selectedOffdays.push({value:vm.offDayList[i].value});
                    }
                }
            }
            else{
                for(var i = 0; i < vm.offDayList.length;i++){
                    if(offDaysArray.includes(vm.offDayList[i].value)){
                        vm.offDayList[i].selected = true;
                        vm.selectedOffdays.push({value:vm.offDayList[i].value});
                    }
                }
            }

        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shiftGroups')
        .controller('DeleteShiftGroupModalCtrl', ['$uibModalInstance', 'shiftGroupService', 'shiftGroup', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteShiftGroupModalCtrl]);

    /** @ngInject */
    function DeleteShiftGroupModalCtrl($uibModalInstance, shiftGroupService, shiftGroup,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.shiftGroup = shiftGroup;
        var analyticsDeleteTitle = 'Delete Shift Group Modal';
        var analyticsDeleteUrl = 'delete-shift-group';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Shift Group In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteShiftGroup = deleteShiftGroup;

        function deleteShiftGroup() {
            vm.isDeleting = true;
            shiftGroupService.deleteShiftGroup(vm.shiftGroup.id).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Shift Group In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Deleted Shift Group.");
                $uibModalInstance.close();
            }, function (error) {
                toastrService.showErrorToastr("Failed to delete Shift Group: " + error);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isDeleting = false;
            });


        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shifts')
        .controller('CreateShiftModalCtrl', ['$uibModalInstance', 'authService', 'shiftnService','utilService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateShiftModalCtrl]);

    /** @ngInject */
    function CreateShiftModalCtrl($uibModalInstance, authService, shiftnService,utilService, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isCreating = false;
        vm.hourStep = 1;
        vm.minStep = 15;
        vm.isMeridian = true;

        vm.color = '#FF0000';
        vm.pickColor = false;

        vm.name = '';
        vm.initial = '';
        vm.startTime= new Date().setHours(8,0,0,0);
        vm.endTime= new Date().setHours(17,0,0,0);
        vm.lateStartAfter= new Date().setHours(8,15,0,0);
        vm.earlyExitBefore= new Date().setHours(16,45,0,0);
        vm.halfDayEnds= new Date().setHours(13,0,0,0);
        vm.breakTimeEnds= new Date().setHours(14,0,0,0);
        vm.firstHalfAbsentEnabled = false;
        var analyticsCreateTitle = 'Create Shift Modal';
        var analyticsCreateUrl = 'create-shift';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create New Shift In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createNewShift = createNewShift;
        function createNewShift() {
            toastrService.clearPreviousToastr();
            var moments = getFormattedMoments();
            var data = {
                "name"      : vm.name,
                "startTime"  : utilService.getAdjustedDifference(moments.today,moments.startTime),
                "workHour"  : utilService.getAdjustedDifference(moments.startTime,moments.endTime),
                "lateOffsetFromStartTime"  : utilService.getAdjustedDifference(moments.startTime,moments.lateStartAfter),
                "earlyExitOffsetFromStartTime"  : utilService.getAdjustedDifference(moments.startTime,moments.earlyExitBefore),
                "firstHalfDuration"  : utilService.getAdjustedDifference(moments.startTime,moments.halfDayEnds),
                "breakDuration" : utilService.getAdjustedDifference(moments.halfDayEnds,moments.breakTimeEnds),
                'color': vm.color,
                'initial': vm.initial,
                'firstHalfAbsentEnabled' : vm.firstHalfAbsentEnabled
            };

            if(!vm.name){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            if(!utilService.isValidShiftSetting(data)){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Please provide proper shift settings");
            }

            var startTime = new Date().setHours(0,0,0,0);
            startTime+=data.startTime;
            var endTime = new Date().setHours(0,0,0,0);
            endTime+=data.startTime+data.workHour;

            if(new Date(startTime).getDate() != new Date(endTime).getDate() && !utilService.hasPermission('5004')){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Night shifts are not allowed in this package");
            }

            vm.isCreating = true;
            shiftnService.createShift(data).then(function (shift) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create New Shift In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Shift Created.");
                $uibModalInstance.close(shift);
            }, function (error) {
                toastrService.showErrorToastr("Failed to create Shift: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isCreating = false;
            });
        }

        function getFormattedMoments(){
            var today = moment(new Date()).hour(0).minute(0).second(0).millisecond(0);
            var data = {
                today : today.format('x'),
                startTime : moment(vm.startTime).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).second(0).format('x'),
                endTime : moment(vm.endTime).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).second(0).format('x'),
                lateStartAfter : moment(vm.lateStartAfter).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
                earlyExitBefore : moment(vm.earlyExitBefore).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
                halfDayEnds : moment(vm.halfDayEnds).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
                breakTimeEnds : moment(vm.breakTimeEnds).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
            }

            return data;
        }


    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shifts')
        .controller('DeleteShiftModalCtrl', ['$uibModalInstance', 'shiftnService', 'shift', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteShiftModalCtrl]);

    /** @ngInject */
    function DeleteShiftModalCtrl($uibModalInstance, shiftnService, shift,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDeleting = false;
        vm.shift = shift;
        var analyticsDeleteTitle = 'Delete Shift Modal';
        var analyticsDeleteUrl = 'delete-shift';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Shift In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteShift = deleteShift;

        function deleteShift() {
            vm.isDeleting = true;
            shiftnService.deleteShift(vm.shift.id).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Shift In' + document.title, ANALYTICS_CONSTANT.delete);
                $uibModalInstance.close();
                toastrService.showSuccessToastr("Shift deleted.");
            }, function updateFailureCallback(error) {
                toastrService.showErrorToastr("Failed to delete Shift: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isDeleting = false;
            });


        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.shifts')
        .controller('EditShiftModalCtrl', ['$uibModalInstance', 'shiftnService', 'toastrService','utilService', 'shift', 'analyticsService', 'ANALYTICS_CONSTANT', EditShiftModalCtrl]);

    /** @ngInject */
    function EditShiftModalCtrl($uibModalInstance, shiftnService, toastrService,utilService, shift, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing
        vm.hourStep = 1;
        vm.minStep = 15;
        vm.isMeridian = true;
        var today = new Date().setHours(0,0,0,0);
        vm.name = shift.name;
        vm.startTime = today + shift.startTime;
        vm.endTime= vm.startTime + shift.workHour;
        vm.lateStartAfter= vm.startTime + shift.lateOffsetFromStartTime;
        vm.earlyExitBefore= vm.startTime + shift.earlyExitOffsetFromStartTime;
        vm.halfDayEnds= vm.startTime + shift.firstHalfDuration;
        vm.breakTimeEnds= vm.halfDayEnds + shift.breakDuration;
        vm.firstHalfAbsentEnabled = shift.firstHalfAbsentEnabled;
        vm.color = shift.color;
        vm.initial= shift.initial;
        var analyticsEditTitle = 'Edit Shift Modal';
        var analyticsEditUrl = 'edit-shift';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Shift In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateShift = updateShift;
        function updateShift() {
            var moments = getFormattedMoments();
            var data = {
                "name"      : vm.name,
                "startTime"  : utilService.getAdjustedDifference(moments.today,moments.startTime),
                "workHour"  : utilService.getAdjustedDifference(moments.startTime,moments.endTime),
                "lateOffsetFromStartTime"  : utilService.getAdjustedDifference(moments.startTime,moments.lateStartAfter),
                "earlyExitOffsetFromStartTime"  : utilService.getAdjustedDifference(moments.startTime,moments.earlyExitBefore),
                "firstHalfDuration"  : utilService.getAdjustedDifference(moments.startTime,moments.halfDayEnds),
                "breakDuration" : utilService.getAdjustedDifference(moments.halfDayEnds,moments.breakTimeEnds),
                'color': vm.color,
                'initial': vm.initial,
                'firstHalfAbsentEnabled' : vm.firstHalfAbsentEnabled
            };

            toastrService.clearPreviousToastr();
            if(!vm.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can't be empty");
            }
            if(!utilService.isValidShiftSetting(data)){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Please provide proper shift settings");
            }

            var startTime = new Date().setHours(0,0,0,0);
            startTime+=data.startTime;
            var endTime = new Date().setHours(0,0,0,0);
            endTime+=data.startTime+data.workHour;

            if(new Date(startTime).getDate() != new Date(endTime).getDate() && !utilService.hasPermission('5004')){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Night shifts are not allowed in this package");
            }

            vm.isEditing = true;
            shiftnService.updateShift(data, shift.id).then(function (shift) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Shift In ' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Shift Updated.");
                $uibModalInstance.close(shift);
            }, function (error) {
                toastrService.showErrorToastr("Failed to update Shift: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function getFormattedMoments(){
            var today = moment(new Date()).hour(0).minute(0).second(0).millisecond(0);
            var data = {
               today : today.format('x'),
               startTime : moment(vm.startTime).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
               endTime : moment(vm.endTime).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
               lateStartAfter : moment(vm.lateStartAfter).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
               earlyExitBefore : moment(vm.earlyExitBefore).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
               halfDayEnds : moment(vm.halfDayEnds).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
               breakTimeEnds : moment(vm.breakTimeEnds).year(today.year()).month(today.month()).dayOfYear(today.dayOfYear()).format('x'),
           }
           return data;
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.manageSites')
        .controller('DeleteSiteModalCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal','$uibModalInstance','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService','siteInfo','analyticsService', 'ANALYTICS_CONSTANT', DeleteSiteModalCtrl]);

    /** @ngInject */
    function DeleteSiteModalCtrl($scope, $stateParams, $state, $timeout,$uibModal,$uibModalInstance,utilService, authService, employeeService, toastrService,siteManagementService,siteInfo,analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isCreating = false;
        vm.siteId = siteInfo.id;

        var analyticsDeleteTitle = 'Delete Site Modal';
        var analyticsDeleteUrl = 'delete-site';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl,
            'Delete Site In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteSite = deleteSite;


        function deleteSite() {
            vm.isCreating = true;
            siteManagementService.deleteSite(vm.siteId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete',
                    analyticsDeleteUrl + '/delete', 'Delete Site In' + document.title, ANALYTICS_CONSTANT.delete);
                toastrService.showSuccessToastr("Site deleted successfully");
                $uibModalInstance.close();
                vm.isCreating = false;
            }, function (message) {
                vm.isCreating = false;
                toastrService.showErrorToastr("Failed to delete department - " + message, '', 5000);
                $uibModalInstance.dismiss(message);
            });
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.manageSites')
        .controller('CreateSitesCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService','analyticsService', 'ANALYTICS_CONSTANT', CreateSitesCtrl]);

    /** @ngInject */
    function CreateSitesCtrl($scope, $stateParams, $state, $timeout,$uibModal,utilService, authService, employeeService, toastrService,siteManagementService,analyticsService,ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isCreating = false;
        vm.siteName = null;
        vm.siteAddress = null;
        vm.siteLatitude = null;
        vm.siteLongitude = null;
        vm.siteManagerList = [];
        vm.selectedSiteManager = [];

        var analyticsCreateTitle= 'Create Site Page';


        vm.createNewSite = createNewSite;

        function init(){
            siteManagementService.getAvailableSiteManagers().then(function (data){
                vm.siteManagerList = data.managers;
            });
        }
        init();

        function createNewSite() {
            vm.isCreating = true;
            toastrService.clearPreviousToastr();
            if(!vm.siteName){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can not be empty");}
            else if(!vm.siteAddress){
                vm.isCreating = false;
                return toastrService.showErrorToastr("Address can not be empty");}
            else if(!vm.siteLatitude) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Latitude can not be empty");
            }
            else if(!vm.siteLongitude) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Longitude can not be empty");
            }
            else if(!vm.selectedSiteManager) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Select a site  manager");
            }
            var data = {
                    'name' : vm.siteName,
                    'location': vm.siteAddress,
                    'latitude': vm.siteLatitude,
                    'longitude': vm.siteLongitude,
                    'managerId' : vm.selectedSiteManager[0].id,
                };
            siteManagementService.createNewSite(data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - ' + analyticsCreateTitle + ' - Create',
                    '', 'Create Site In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.showSuccessToastr("Site created!");
                vm.isCreating = false;
                resetAllFields();
                $state.go('siteManagement.manageSites');
            },function (error) {
                vm.isCreating = false;
                toastrService.showErrorToastr("Failed to create project - " + error, "", 5000);
            });
        }

        function resetAllFields(){
            vm.siteName = null;
            vm.siteAddress = null;
            vm.siteLatitude = null;
            vm.siteLongitude = null;
            vm.selectedSiteManager = [];
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.manageSites')
        .controller('ViewSitesCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal','utilService', 'authService', 'employeeService', 'toastrService','$q','siteManagementService','analyticsService', 'ANALYTICS_CONSTANT', ViewSitesCtrl]);

    /** @ngInject */
    function ViewSitesCtrl($scope, $stateParams, $state, $timeout,$uibModal,utilService, authService, employeeService, toastrService,$q,siteManagementService,analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.isCreating = false;
        vm.isDataLoaded = false;
        vm.siteInfo = {};
        vm.selectedSiteManager = [];
        vm.siteId =  $stateParams.siteId;
        vm.siteManagerListParams=[];
        vm.isEditable = false;


        vm.updateSite = updateSite;
        vm.makeEditable = makeEditable;

        function init(){

                getDetailsOfOneSite(vm.siteId).then(function(){
                    getAvailableSiteManager();
                });

        }
        init();

        function getAvailableSiteManager(){
            siteManagementService.getAvailableSiteManagers().then(function (data){
                vm.siteManagerList = data.managers;
                var params={
                    "id":vm.siteInfo.managerId,
                    "name":vm.siteInfo.managerName,
                    "ticked":true
                };

                vm.siteManagerList.push(params);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch available site manager " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }
        function getDetailsOfOneSite(siteId){
            return siteManagementService.getDetailsOfOneSite(siteId).then(function (data){
                vm.siteInfo = data.site;
                vm.siteEmployeeList = vm.siteInfo.employeeList;
                // getAllEmployees();
            });
        }

        function makeEditable(){
            vm.isEditable = !vm.isEditable;
        }

        function updateSite() {
            vm.isCreating = true;
            toastrService.clearPreviousToastr();
            if(!vm.siteInfo.name) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            else if(!vm.siteInfo.location) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Address can not be empty");
            }
            else if(!vm.siteInfo.latitude) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Latitude can not be empty");
            }
            else if(!vm.siteInfo.longitude) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Longitude can not be empty");
            }
            else if(!vm.selectedSiteManager) {
                vm.isCreating = false;
                return toastrService.showErrorToastr("Select a site  manager");
            }
            var data = {
                'name' : vm.siteInfo.name,
                'location': vm.siteInfo.location,
                'latitude': vm.siteInfo.latitude,
                'longitude': vm.siteInfo.longitude,
                'managerId' : vm.selectedSiteManager[0].id,
            };
            siteManagementService.updateSite(data, vm.siteId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit',
                    '', 'Edit Site In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.showSuccessToastr("Site updated!");
                init();
                $state.go('siteManagement.manageSites');
                vm.isCreating = false;

            },function (error) {
                vm.isCreating = false;
                toastrService.showErrorToastr("Failed to update site - " + error, "", 5000);
            });
        }



    }
})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.siteManagement.siteAttendanceReport')
        .controller('SiteAttendanceReportCtrl',
            ['attendanceService', '$scope', 'toastr', 'toastrService', 'authService', 'utilService','$uibModal', SiteAttendanceReportCtrl]);

    /** @ngInject */
    function SiteAttendanceReportCtrl(attendanceService, $scope, toastr, toastrService, authService, utilService,$uibModal) {
        var vm = this;

        vm.total = 0;
        vm.searchParams = {};
        vm.reportTable = null;
        vm.subtract = 0;
        vm.employeeList = [];
        vm.rowsPerPage = 10;
        vm.isDataLoaded = false;
        vm.totalAbsent = null;
        vm.totalPresent = null;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.subtract = 0;
        vm.siteInPictureUrl = "";
        vm.siteOutPictureUrl = "";


        vm.getRowsPerPage = getRowsPerPage;
        vm.openLocationMap = openLocationMap;
        vm.openEntryExitImage=openEntryExitImage;

        var loggedInUser = authService.getLoggedInUser();

        vm.filterConfig = {
            companyFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            dateRangePicker : {
                show : false,
                collapsible : false
            },
            singleDatePicker: {
                show: true,
                collapsible : false
            },
            monthYearPicker : {
                show : false
            },
            departmentFilter : {
                show : !loggedInUser.isGroupAdmin,
                collapsible : true
            },
            designationFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter : {
                // show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
                show : false
            },
            hrManagerFilter : {
                // show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
                show : false

            },
            statusFilter : {
                show : false,
            },
            deviceFilter : {
                show : false
            },
            leaveCategoryFilter : {
                show : false
            },
            pdfDownloadButton : {
                show : true,
                multipleOrientation: false
            },
            excelDownloadButton : {
                show : true
            },
            sortKey : {
                show: false
            },
            allSitesFilterFilter:{
                show: true
            },
            presentAbsentFilter:{
                show:true
            }
        };

        vm.search = search;

        function search(searchParams) {
            // makeEverythingEmpty();
            modifyParams(searchParams);
            vm.searchParams.sortKey = null;
            vm.isDataLoaded = false;
            attendanceService.getSitAttendanceReport(vm.searchParams).then(function (data) {
                vm.excelUrl = attendanceService.getSiteAttendanceReportUrlExcel(vm.searchParams);
                vm.pdfUrl = attendanceService.getSiteAttendanceReportPdf(vm.searchParams);
                vm.employeeList = data.employeeList;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
                vm.totalPresent = data.totalPresent;
                vm.totalAbsent = data.totalAbsent;
                vm.isPresent = data.isPresent;
                vm.siteInPictureUrl = data.siteInPictureUrl;
                vm.siteOutPictureUrl = data.siteOutPictureUrl;

            }, function (error) {
                vm.isDataLoaded = true;
                vm.totalPresent = 0;
                vm.totalAbsent = 0;
                toastr.error(error);
            });
        }

        function modifyParams(searchParams) {
            if(typeof searchParams == 'object'){
                vm.searchParams = searchParams;
            }else {
                if(searchParams == 'prev'){
                    vm.searchParams.pageNumber--;
                }else if(searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                }else if(!isNaN(searchParams)){
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function getRowsPerPage(){
            return Number(utilService.getRowsPerPage());
        }
        function openLocationMap($index,employee) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/siteManagement/siteManagementReports/siteAttendanceReport/location/location.modal.html',
                size : 'md',
                controller : 'SiteAttendanceLocationModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {
                        return employee
                    }},
                controllerAs : 'vm',
            }).result.then(function () {

            },function (message) {
                console.error("Map closed ." );
            });
        }
        function openEntryExitImage($index,employee,imageCategory) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/siteManagement/siteManagementReports/siteAttendanceReport/entryImage/entryExitImage.modal.html',
                size : 'md',
                controller : 'SiteAttendanceEntryExitImageModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {

                        return  {'data':employee,'imageCategory':imageCategory};
                    }},


                controllerAs : 'vm',

            }).result.then(function () {

            },function (message) {
                console.error("Image Closed. " );
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
    app.controller('AppointmentCancelModalCtrl', ['appointmentLogService', 'authService', '$uibModalInstance', 'toastr', 'appointmentToCancel', 'analyticsService', 'ANALYTICS_CONSTANT', AppointmentCancelModalCtrl]);

    /** @ngInject */
    function AppointmentCancelModalCtrl(appointmentLogService, authService, $uibModalInstance, toastr, appointmentToCancel, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.delete = {};
        vm.appointmentToCancel = angular.copy(appointmentToCancel);

        var analyticsDeleteTitle = 'Cancel Appointment Modal';
        var analyticsDeleteUrl = 'cancel-appointment';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Department In' + document.title, ANALYTICS_CONSTANT.open);

        vm.cancelAppointment = cancelAppointment;

        //console.log("Entered")
        function cancelAppointment(id) {
            appointmentLogService.cancelAppointment(id).then(onAppointmentCancelSuccess, onAppointmentCancelFailure);
        }

        function onAppointmentCancelSuccess() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/cancel', 'Delete Department In' + document.title, ANALYTICS_CONSTANT.cancel);
            $uibModalInstance.close();
        }

        function onAppointmentCancelFailure(error) {
            toastr.error(error);
        }
    }

})();
(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.siteManagement.siteSummaryReport')
        .controller('SiteSummaryReportCtrl', ['authService', 'utilService', '$scope','$uibModal', 'toastrService','siteManagementService', 'generalSettingsService', 'analyticsService', 'ANALYTICS_CONSTANT', SiteSummaryReportCtrl]);

    /** @ngInject */
        function SiteSummaryReportCtrl(authService, utilService, $scope,$uibModal, toastrService,siteManagementService, generalSettingsService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isDataLoaded = true;
        vm.allsSitesSummaryReportData = [];
        vm.excelUrl = '';
        vm.pdfUrl = '';
        vm.searchParams = {};
        vm.searchKeyword = ''
        vm.rowsPerPage = 10;
        vm.selectedPage = 0;
        vm.singleDatePicker = {};
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.maxDateForDailyReport = new Date();

        vm.singleDatePicker.date = moment().startOf("day");
        vm.singleDatePicker.options = {
            singleDatePicker:true,
            timePicker24Hour : false,
            eventHandlers : {
                'apply.daterangepicker': searchByDate,
            },
            locale: {
                format: "D MMM YYYY",
            }
        };
        vm.allowAllDownload = false;
        vm.maxRows = 0;
        vm.rowsPerPageOption = [
            { value: 10},
            { value: 50},
            { value: 100},
            { value: 500},
            { value: 1000},
            { value: 2000},
        ]
        vm.selectedRowsPerPage = vm.rowsPerPageOption[1]

        vm.getSiteSummaryInfo = getSiteSummaryInfo;
        vm.searchByDate = searchByDate;
        vm.getSiteByNameOrAddress = getSiteByNameOrAddress;
        vm.exportAsExcel = exportAsExcel;
        vm.exportAsPdf   = exportAsPdf;
        vm.openLocationMap = openLocationMap;
        vm.handleRowPerPageSelection = handleRowPerPageSelection;

        function init(){
            getSiteSummaryInfo();
            generalSettingsService.getReportSettingsOfAnOffice().then(function (response) {
                vm.allowAllDownload = response.allowAllDownload;
                vm.maxRows = response.maxRows;
                if (!vm.allowAllDownload && vm.maxRows > 0){
                    vm.rowsPerPageOption.push({value: vm.maxRows});
                }
            });
        }
        init()

        function searchByDate(){
            getSiteSummaryInfo();
        }
        function getSiteByNameOrAddress(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search);
            getSiteSummaryInfo()
        }
        function handleRowPerPageSelection() {
            utilService.setRowsPerPage(vm.selectedRowsPerPage.value);
            vm.getSiteSummaryInfo();
        }
        function getSiteSummaryInfo(searchParams){
            modifyParams(searchParams);

            vm.searchParams.startTimeOfDay= vm.singleDatePicker.date.valueOf();
            vm.searchParams.count         = vm.rowsPerPage;
            vm.searchParams.keyword       = vm.searchKeyword;
            vm.isDataLoaded = false;
            siteManagementService.getSiteSummaryReportInfo(vm.searchParams).then(function (data) {
                vm.allSitesSummaryReportData = data;
                vm.siteSummaryList = data.siteSummaryList;
                vm.isDataLoaded = true;
                vm.date = data.date
                vm.excelUrl = siteManagementService.getSiteSummaryReportExcelUrl(vm.searchParams, vm.allowAllDownload);
                vm.pdfUrl = siteManagementService.getSiteSummaryReportPdf(vm.searchParams, vm.allowAllDownload);
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.total = data.totalSite;
                vm.success = true
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                // console.log(error)
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
                else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function exportAsExcel() {
            if(vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel);
            }
        }
        function exportAsPdf() {
            if(vm.pdfUrl != null && vm.pdfUrl.trim() !== "") {
                window.open(vm.pdfUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.pdfUrl, '', '', 'Download  PDF ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadPdf);
            }
        }

        function openLocationMap($index, site) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/siteManagement/siteManagementReports/siteSummaryReport/location/location.modal.html',
                size : 'md',
                controller : 'LocationModalCtrl',
                backdrop : 'static',
                resolve : {
                    siteInfo : function () {
                        return site
                    }},
                controllerAs : 'vm',
            }).result.then(function () {

            },function (message) {
                console.error("Failed to delete Site - " + message);
            });
        }

        }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.createAppointment')
        .controller('CapturePhotoModalCtrl', [ '$uibModalInstance', 'toastrService', 'webcamService','$scope', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', CapturePhotoModalCtrl]);

    /** @ngInject */
    function CapturePhotoModalCtrl($uibModalInstance, toastrService, webcamService, $scope, $q, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.channel = webcamService.webcam.channel;
        vm.showCamera = true;
        vm.imgDataUrl = "";
        vm.imgFile = null;
        vm.showUploadedImage = false;
        $scope.inputImage = null;

        var analyticsCreateTitle = 'Capture Photo Modal';
        var analyticsCreateUrl = 'capture-photo';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Capture Photo In' + document.title, ANALYTICS_CONSTANT.open);


        vm.onWebcamError = onWebcamError;
        vm.onWebcamSuccess = onWebcamSuccess;
        vm.onStream = onStream;
        vm.downloadSnapshot = downloadSnapshot;
        vm.makeSnapshot = makeSnapshot;
        vm.submit = submit;
        vm.fileSelected = fileSelected;

        function onWebcamError(error) {
            vm.showCamera = false;
            webcamService.webcam.onError(error);
            webcamService.webcam.error = error;
        }

        function onWebcamSuccess() {
            webcamService.webcam.onSuccess();
        }


        function downloadSnapshot(dataURL) {
            webcamService.webcam.downloadSnapshot(dataURL);
        }

        function onStream(stream) {
            webcamService.webcam.onStream(stream);
        }

        function makeSnapshot() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Take Picture', analyticsCreateUrl + '/take-picture', 'Take Picture In' + document.title, ANALYTICS_CONSTANT.takePicture);
            $scope.inputImage = webcamService.webcam.makeSnapshot();
        }

        function submit() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Submit Picture', analyticsCreateUrl + '/submit-picture', 'Submit Picture In' + document.title, ANALYTICS_CONSTANT.submit);
            $uibModalInstance.close(vm.imgDataUrl);
        }

        function fileSelected(file) {
            if(file != null) {
                getFileBuffer(file).then(function (response) {
                    $scope.inputImage = response;
                    vm.showUploadedImage = true;
                }, function (error) {
                    vm.vm.showUploadedImage = false;
                });
            } else {
                vm.imgDataUrl = "";
                vm.showUploadedImage = false;
            }
        }

        function getFileBuffer(file) {
            var deferred = new $q.defer();
            var reader = new FileReader();
            reader.onloadend = function(e) {
                deferred.resolve(e.target.result);
            };
            reader.onerror = function(e) {
                deferred.reject(e.target.error);
            };
            reader.readAsDataURL(file);
            return deferred.promise;
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
    app.controller('BlockVisitorModalCtrl', ['myVisitorProfileService','authService','$uibModalInstance','toastrService','visitorToBlock', 'analyticsService', 'ANALYTICS_CONSTANT', BlockVisitorModalCtrl]);

    /** @ngInject */
    function BlockVisitorModalCtrl(myVisitorProfileService,authService,$uibModalInstance,toastrService,visitorToBlock, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.delete = {};
        // var loggedInUser=u authService.getAllInformation();
        vm.visitorToBlock = angular.copy(visitorToBlock);

        var analyticsDeleteTitle = 'Block Visitor Modal';
        var analyticsDeleteUrl = 'block-visitor';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Block Visitor In' + document.title, ANALYTICS_CONSTANT.open);

        vm.blockVisitor= blockVisitor;

        function blockVisitor (id) {
            myVisitorProfileService.blockVisitor(id).then(onBlockingVisitorSuccess, onBlockingVisitorFailure);
        }

        function onBlockingVisitorSuccess(visitorList) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsDeleteTitle+ ' - Block', analyticsDeleteUrl+'/block','Block Visitor In'+document.title, ANALYTICS_CONSTANT.block);
            $uibModalInstance.close(visitorList);
        }

        function onBlockingVisitorFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
    app.controller('UnblockVisitorModalCtrl', ['myVisitorProfileService','authService','$uibModalInstance','toastrService','visitorToUnBlock', 'analyticsService', 'ANALYTICS_CONSTANT',UnblockVisitorModalCtrl]);

    /** @ngInject */
    function UnblockVisitorModalCtrl(myVisitorProfileService,authService,$uibModalInstance,toastrService,visitorToUnBlock, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.delete = {};
        // var loggedInUser=u authService.getAllInformation();
        vm.visitorToUnBlock = angular.copy(visitorToUnBlock);

        var analyticsDeleteTitle = 'Unblock Visitor Modal';
        var analyticsDeleteUrl = 'unblock-visitor';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Unblock Visitor In' + document.title, ANALYTICS_CONSTANT.open);

        vm.UnblockVisitor= UnblockVisitor;

        function UnblockVisitor (id) {
            myVisitorProfileService.UnblockVisitor(id).then(onUnblockedSuccess, onUnblockedFailure);
        }

        function onUnblockedSuccess(visitorList) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Unblock', analyticsDeleteUrl + '/unblock', 'Unblock Visitor In' + document.title, ANALYTICS_CONSTANT.unblock);
            $uibModalInstance.close(visitorList);
        }

        function onUnblockedFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "",5000);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.assignRole')
        .controller('AssignRoleCtrl', ['$scope','assignRoleService','$uibModal', 'toastrService', '_', AssignRoleCtrl]);

    /** @ngInject */
    function AssignRoleCtrl($scope, assignRoleService,$uibModal, toastrService, _) {

        var vm = this;

        // vm.searchText = "";
        vm.employeeRoleList = [];
        vm.isDataLoaded = false;
        // vm.create = {};
        // vm.create.createLeaveCategoryName = null;
        // vm.leaveCategoryToEdit = null;

        vm.openAssignRoleModal = openAssignRoleModal;
        vm.openDeleteRoleModal = openDeleteRoleModal;
        vm.openEditModalRoleModal = openEditModalRoleModal;

        function init(){
            assignRoleService.getAllEmployeeRoles().then(onEmployeeRoleListFetchSuccess, onEmployeeRoleListFetchFailure).finally(function (){
                vm.isDataLoaded = true;
            })
            $scope.$broadcast("refreshFixedColumns");
        }

        init();

        function onEmployeeRoleListFetchSuccess(visitorCategoryList){
            vm.employeeRoleList = visitorCategoryList;
        }

        function onEmployeeRoleListFetchFailure(error){
            console.error(error);
        }

        function openAssignRoleModal () {
            toastrService.clearPreviousToastr();
            vm.assignRoleModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/assignRole/modals/assign.modal.html',
                size: 'md',
                controller:'AssignRoleCreateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
            }).result.then(onEmployeeRoleListFetchSuccess);
        }

        function openDeleteRoleModal (employeeRole, index) {
            toastrService.clearPreviousToastr();
            vm.deleteRoleModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/assignRole/modals/delete.modal.html',
                size: 'md',
                controller:'EmployeeRoleDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        roleToDelete:function () {
                            return employeeRole;
                        }
                    }
            }).result.then(function employeeRoleDeleteSuccess() {
                vm.employeeRoleList.splice(index,1);
            });
        }

        function openEditModalRoleModal (employeeRole, index) {
            toastrService.clearPreviousToastr();
            vm.createLeaveCategoryModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/assignRole/modals/update.modal.html',
                size: 'md',
                controller:'EmployeeRoleUpdateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        selectedEmployee:function () {
                            return angular.copy(employeeRole);
                        }
                    }
            }).result.then(function(employeeRoleList) {
                vm.employeeRoleList = employeeRoleList;
                toastrService.showSuccessToastr("Employee Role updated");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.manageCard')
        .controller('ManageCardCtrl', ['$scope', 'toastrService', '$window', 'visitorCardService', '$uibModal', 'analyticsService', 'ANALYTICS_CONSTANT', ManageCardCtrl]);

    /** @ngInject */
    function ManageCardCtrl($scope, toastrService, $window, visitorCardService, $uibModal, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.searchText = "";
        vm.visitorCards = null;
        vm.isDataLoaded = false;
        vm.file = null;

        vm.openCreateModal = openCreateModal;
        vm.openEditModal = openEditModal;
        vm.openDeleteModal = openDeleteModal;
        vm.verifySelectedExcelFile = verifySelectedExcelFile;
        vm.downloadSampleExcelFile = downloadSampleExcelFile;

        init();

        function init() {
            getAllCards();
        }
        function getAllCards() {
            vm.isDataLoaded = false;
            visitorCardService.getAllCards().then(function (data) {
                vm.visitorCards = data;
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch visitor cards: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function openCreateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/manageCard/modals/create.modal.html',
                size: 'md',
                controller : 'CreateModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',

            }).result.then(function (data) {
                getAllCards();
                //createVisitorCard(data);
            });
        }

        function createVisitorCard(data) {
            toastrService.clearPreviousToastr();
            vm.isDataLoaded = false;
            visitorCardService.createVisitorCard(data).then(function (data) {
                toastrService.showSuccessToastr("Visitor card creation successful");
                getAllCards();
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not create visitor card: " + error, "", 5000);
            });
        }

        function openEditModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/manageCard/modals/edit.modal.html',
                size: 'md',
                controller : 'EditModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    visitorCard: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function (formData) {
                updateVisitorCard(formData, index);
            });
        }

        function updateVisitorCard(formData, index) {
            vm.isDataLoaded = false;
            visitorCardService.updateVisitorCard(formData).then(function (data) {
                var analyticsEditTitle = 'Edit Visitor Card Modal';
                var analyticsEditUrl = 'edit-visitor-card';
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Visitor Card In' + document.title, ANALYTICS_CONSTANT.edit);
                updateListItem(index, formData);
            }, function (error) {
                toastrService.showErrorToastr("Could not save changes: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function updateListItem(index, updatedItem) {
            vm.visitorCards[index].rfid = updatedItem.rfid;
            vm.visitorCards[index].code = updatedItem.code;
            vm.visitorCards[index].status = updatedItem.status;
        }

        function openDeleteModal(item, index) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/manageCard/modals/delete.modal.html',
                size: 'md',
                controller : 'DeleteModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    visitorCard: function () {
                        return angular.copy(item);
                    }
                }
            }).result.then(function () {
                deleteVisitorCard(item, index);
            });
        }

        function deleteVisitorCard(item, index) {
            vm.isDataLoaded = false;
            visitorCardService.deleteVisitorCard(item.id).then(function (data) {
                var analyticsDeleteTitle = 'Delete Visitor Card Modal';
                var analyticsDeleteUrl = 'delete-visitor-card';
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Visitor Card In' + document.title, ANALYTICS_CONSTANT.delete);
                vm.visitorCards.splice(index, 1);
                toastrService.showSuccessToastr("Card deleted successfully");
            }, function (error) {
                toastrService.showErrorToastr("Could not delete card: " + error,"", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function downloadSampleExcelFile(){
            analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl,'','','Download Sample Excel IN',ANALYTICS_CONSTANT.downloadExcel);
            $window.open (visitorCardService.downloadVisitorCardSample(),'_blank');
        }

        function verifySelectedExcelFile() {
            if(vm.file == null) {
                // return toastr.error("You haven't selected any file.");
                return;
            }

            visitorCardService.createVisitorCardBatch(vm.file).then(function (data) {
                if(data.validation != null || data.duplicate != null){
                    data.validation.forEach(function (i){
                        toastr.error(i.error);
                    });
                    data.duplicate.forEach(function (i){
                        toastr.error(i.error);
                    });
                }
                else{
                    analyticsService.sendData(ANALYTICS_CONSTANT.upload,document.title + ' - Upload Sample Excel','','Upload Sample Excel In'+document.title, ANALYTICS_CONSTANT.upload)
                    toastrService.showSuccessToastr("Visitor card creation successful")
                    getAllCards();
                }
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not create visitor card: " + error, "", 5000);
            });

        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitPurpose')
        .controller('VisitPurposeCtrl', ['$scope', 'visitPurposeService','$uibModal', 'toastrService', '_', VisitPurposeCtrl]);

    /** @ngInject */
    function VisitPurposeCtrl($scope, visitPurposeService,$uibModal, toastrService, _) {

        var vm = this;
        vm.visitPurposeList=[];
        vm.visitPurpose = {};
        vm.isDataLoaded=false;


        vm.openCreateVisitPurposeModal = openCreateVisitPurposeModal;
        vm.openDeleteVisitPurposeModal = openDeleteVisitPurposeModal;
        vm.openUpdateVisitPurposeModal = openUpdateVisitPurposeModal;

        function init(){
            vm.isDataLoaded=false;
            visitPurposeService.getAllVisitPurpose().then(onVisitPurposeListFetchSuccess, onVisitPurposeListFetchFailure)
            $scope.$broadcast("refreshFixedColumns");
        }

        init();

        function onVisitPurposeListFetchSuccess(visitPurposeList){
            vm.visitPurposeList = visitPurposeList;
            vm.isDataLoaded=true;
        }

        function onVisitPurposeListFetchFailure(error){
            console.log(error);
        }
        function openCreateVisitPurposeModal(){
            toastrService.clearPreviousToastr();
            vm.createLeaveCatagoryModal=$uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurposeModals/createVisitPurpose.modal.html',
                size: 'md',
                controller:'VisitPurposeCreateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
            }).result.then(onVisitPurposeListFetchSuccess);
        }

        function openDeleteVisitPurposeModal(visitPurposeToDelete,index){
            toastrService.clearPreviousToastr();
            //console.log(visitPurposeToDelete);
            vm.createLeaveCatagoryModal=$uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurposeModals/deleteVisitPurpose.modal.html',
                size: 'md',
                controller:'VisitPurposeModalDeleteCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        purposeToChange:function () {
                            return visitPurposeToDelete;
                        }
                    }
            }).result.then(function (){
                onVisitPurposeDeleteSuccess(index);
            });
        }
        function onVisitPurposeDeleteSuccess(index){
            toastrService.clearPreviousToastr();
            vm.visitPurposeList.splice(index,1);
            toastrService.showSuccessToastr("Visit Purpose Deleted");
        }

        function openUpdateVisitPurposeModal(visitPurposeToUpdate,index){
            toastrService.clearPreviousToastr();
            //console.log(visitPurposeToUpdate);
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurposeModals/updateVisitPurpose.modal.html',
                size: 'md',
                controller:'VisitPurposeUpdateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        purposeToChange:function () {
                            return angular.copy(visitPurposeToUpdate);
                        }
                    }
            }).result.then(function (visitPurposeList){
                onVisitPurposeUpdateSuccess(visitPurposeList,index);
            });
        }
        function onVisitPurposeUpdateSuccess(visitPurposeList,index){
            toastrService.clearPreviousToastr();
            vm.visitPurposeList = visitPurposeList;
            toastrService.showSuccessToastr("Visit Purpose Updated");
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitorCategory')
        .controller('VisitorCategoryCtrl', ['$scope', 'visitorCategoryService','$uibModal', 'toastrService', '_', 'analyticsService', 'ANALYTICS_CONSTANT', VisitorCategoryCtrl]);

    /** @ngInject */
    function VisitorCategoryCtrl($scope, visitorCategoryService,$uibModal, toastrService, _, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.visitorCategoryList = null;
        vm.isDataLoaded = false;
        // vm.create = {};
        // vm.create.createLeaveCategoryName = null;
        // vm.leaveCategoryToEdit = null;

        vm.openCreateVisitorCategoryModal = openCreateVisitorCategoryModal;
        vm.openDeleteVisitorCategoryModal = openDeleteVisitorCategoryModal;
        vm.openUpdateVisitorCategoryModal = openUpdateVisitorCategoryModal;

        function init(){
            visitorCategoryService.getAllVisitorCategories().then(onVisitorCategoryListFetchSuccess, onVisitorCategoryListFetchFailure)
            $scope.$broadcast("refreshFixedColumns");
        }

        init();

        function onVisitorCategoryListFetchSuccess(visitorCategoryList){
            vm.isDataLoaded = true;
            vm.visitorCategoryList = visitorCategoryList;
        }

        function onVisitorCategoryListFetchFailure(error){
            vm.isDataLoaded = true;
            // console.log(error);
        }

        function openCreateVisitorCategoryModal () {
            toastrService.clearPreviousToastr();
            vm.createLeaveCategoryModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategoryModals/createVisitorCategory.modal.html',
                size: 'md',
                controller:'VisitorCategoryCreateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
            }).result.then(onVisitorCategoryListFetchSuccess);
        }

        function openDeleteVisitorCategoryModal (visitorCategory, index) {
            toastrService.clearPreviousToastr();
            vm.createLeaveCategoryModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategoryModals/deleteVisitorCategory.modal.html',
                size: 'md',
                controller:'VisitorCategoryDeleteModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        categoryToChange:function () {
                            return visitorCategory;
                        }
                    }
            }).result.then(function leaveCategoryDeleteSuccess() {
                vm.visitorCategoryList.splice(index,1);
            });
        }

        function openUpdateVisitorCategoryModal (visitorCategory, index) {
            toastrService.clearPreviousToastr();
            vm.createLeaveCategoryModal = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategoryModals/updateVisitorCategory.modal.html',
                size: 'md',
                controller:'VisitorCategoryUpdateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve:
                    {
                        categoryToChange:function () {
                            return angular.copy(visitorCategory);
                        }
                    }
            }).result.then(function(visitorCategoryList) {
                // console.log(visitorCategoryList)
                vm.visitorCategoryList = visitorCategoryList;
                var analyticsEditTitle = 'Edit Visitor Category Modal';
                var analyticsEditUrl = 'edit-visitor-category';
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Visitor Category In' + document.title, ANALYTICS_CONSTANT.edit);
                toastrService.showSuccessToastr("Visitor Category updated");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('LeaveAdjustModalCtrl', ['employeeService','$stateParams','$uibModalInstance','authService','utilService', 'toastrService','leaveManagementService','leaveInfo', 'analyticsService', 'ANALYTICS_CONSTANT', LeaveAdjustModalCtrl]);

    /** @ngInject */
    function LeaveAdjustModalCtrl(employeeService,$stateParams,$uibModalInstance, authService, utilService, toastrService,leaveManagementService,leaveInfo, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        var analyticsModalTitle = 'Leave - Leave Adjust Modal';
        var analyticsModalUrl = 'leave/leave-adjust';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Leave Adjust Modal In' + document.title, ANALYTICS_CONSTANT.open);

        vm.isAdjustModalDataLoaded = false;
        vm.leaveInfoDetails = null;
        vm.categoryList = getAllNonEarnedLeaveCategoryBalances();
        vm.leaveLog = leaveInfo.leaveLogInfo;
        vm.selectedLeaveCategoryId = null;
        vm.selectedLeaveType = null;
        vm.showConfirmation = false;
        vm.numberOfDays = 0;
        vm.file = '';
        vm.reason = null;
        vm.isYesBtnClicked = false;

        vm.leaveDatePicker = {};
        vm.leaveDatePicker.options = {};
        vm.leaveDatePicker.date = {};
        vm.leaveDatePicker.options = {
            minDate : vm.minDate,
            locale : {
                format : 'DD-MMM-YYYY'
            },
            eventHandlers : {
                'apply.daterangepicker': getNumberOfDays,
                'hide.daterangepicker' : getNumberOfDays
            }
        }
        vm.confirmLeaveAdjustment = confirmLeaveAdjustment;
        vm.saveLeaveAdjustment = saveLeaveAdjustment;
        vm.setMinimumApplicableDate = setMinimumApplicableDate;

        function confirmLeaveAdjustment(){
            vm.showConfirmation = isValidInput();
        }

        function isValidInput() {
            toastrService.clearPreviousToastr();
            if(!vm.selectedLeaveCategoryId) {
                toastrService.showErrorToastr("Please select a category");
                return false;
            }
            if(!hasChangesInAdjustmentRequest()) {
                toastrService.showErrorToastr("Leave Category/Date Range is same as the previously applied one");
                return false;
            }
            return true;
        }

        function hasChangesInAdjustmentRequest() {
            if(vm.selectedLeaveCategoryId === vm.leaveLog.categoryId
                && Number(vm.leaveDatePicker.date.startDate.format('x')) === vm.leaveLog.startDate
                && Number(vm.leaveDatePicker.date.endDate.format('x')) === vm.leaveLog.endDate)
                return false;
            return true;
        }

        function saveLeaveAdjustment(){
            vm.isYesBtnClicked = true;
            var data = {
                leaveCategoryId : vm.selectedLeaveCategoryId,
                startDate : vm.leaveDatePicker.date.startDate.format('x'),
                endDate : vm.leaveDatePicker.date.endDate.format('x'),
                reason : vm.reason,
                employeeIdentifier :'',
                isHalfDay : false,
            }
            leaveManagementService.applyForLeaveAdjustment(vm.leaveLog.id, data, vm.file).then(function (data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Adjust', analyticsModalUrl + '/adjust', 'Adjust Leave In Leave ' + document.title, ANALYTICS_CONSTANT.edit)
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Leave adjustment application submitted successfully");
                $uibModalInstance.close();
            },function (error){
                toastrService.showErrorToastr("Leave application adjustment failed"  + error, "", 5000);
                $uibModalInstance.close();
                });
        }

        function init() {
            employeeService.getCurrentAndPreviousLeaveApplicationData(vm.leaveLog.id).then(function (data){
                vm.leaveInfoDetails = data;
                vm.reason = angular.copy(vm.leaveInfoDetails.currentVersionReason);
                var leaveCategoryToBeSelected = vm.categoryList.find(function (data){
                    return data.leaveCategoryId === vm.leaveInfoDetails.currentVersionCategoryId;
                });
                vm.selectedLeaveCategoryId = !leaveCategoryToBeSelected? null : leaveCategoryToBeSelected.leaveCategoryId;                // vm.selectedLeaveCategory = vm.leaveInfoDetails.currentVersionCategoryName;
                vm.selectedLeaveType = vm.leaveInfoDetails.currentVersionTypeName;
                vm.numberOfDays = vm.leaveInfoDetails.currentVersionNumberOfDays;
                vm.selectedLeaveType = vm.leaveInfoDetails.currentVersionTypeName;
                vm.leaveDatePicker.date = getInitialFromAndToDate();
                vm.isAdjustModalDataLoaded = true;
                setMinimumApplicableDate();
            },function (error){

            });
        }

        init();


        function getInitialFromAndToDate() {
            return {
                'startDate': vm.leaveInfoDetails.currentVersionStartDate == null ? moment() : moment(vm.leaveInfoDetails.currentVersionStartDate, 'x'),
                'endDate': vm.leaveInfoDetails.currentVersionEndDate == null ? moment(): moment(vm.leaveInfoDetails.currentVersionEndDate, 'x')
            };
        }
        function getNumberOfDays(){
            var startDate = moment(vm.leaveDatePicker.date.startDate).startOf('day');
            var endDate = moment(vm.leaveDatePicker.date.endDate).endOf('day');
            vm.numberOfDays = endDate.diff(startDate,'days')+1;

        }

        function getAllNonEarnedLeaveCategoryBalances() {
            return leaveInfo.leaveCategoryList.filter(function (leaveCategoryBalance) {
                return leaveCategoryBalance.leaveCategoryPolicyConfig.earnedLeaveCriteria === 0;
            })
        }

        function setMinimumApplicableDate() {
            var creationDate = new moment(vm.leaveInfoDetails.creationDate).startOf("day");
            var selectedCategoryPolicyConfig = vm.categoryList.find(function (item) {
                return item.leaveCategoryId === vm.selectedLeaveCategoryId;
            }).leaveCategoryPolicyConfig;

            if(Number(selectedCategoryPolicyConfig.pastDateSelectionLimit) > -1) {
                vm.leaveDatePicker.options.minDate = vm.minDate = creationDate.subtract(Number(selectedCategoryPolicyConfig.pastDateSelectionLimit), "days");
            } else {
                vm.leaveDatePicker.options.minDate = vm.minDate = creationDate.startOf("day");
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('LeaveCancelModalCtrl', ['employeeService','$stateParams','$uibModalInstance','authService','utilService','leaveManagementService', 'toastrService','updatedLeaveInfo', 'analyticsService', 'ANALYTICS_CONSTANT', LeaveCancelModalCtrl]);

    /** @ngInject */
    function LeaveCancelModalCtrl(employeeService, $stateParams, $uibModalInstance, authService, utilService,leaveManagementService, toastrService,updatedLeaveInfo, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Leave - Leave Cancel Modal';
        var analyticsModalUrl = 'leave/leave-cancel';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Leave Cancel Modal In' + document.title, ANALYTICS_CONSTANT.open);
        vm.reasonOfCancellation = '';
        vm.updatedLeaveInfo = [];
        vm.leaveLogId = updatedLeaveInfo.leaveLogInfo.id;
        vm.showConfirmation = false;
        vm.isCancelModalDataLoaded = false;
        vm.isYesButtonClicked = false;

        vm.confirmCancelConformation = confirmCancelConformation;
        vm.cancelLeaveApplication = cancelLeaveApplication;

        function init() {
            employeeService.getCurrentAndPreviousLeaveApplicationData(vm.leaveLogId).then(function (data){
                vm.updatedLeaveInfo = data;
                vm.isCancelModalDataLoaded = true;
            })
        }
        init();

        function cancelLeaveApplication() {
            vm.isYesButtonClicked = true;
           leaveManagementService.cancelLeaveApplication({cancellationReason: vm.reasonOfCancellation}, vm.leaveLogId).then(function (data){
               analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Cancel', analyticsModalUrl + '/cancel', 'Cancel Leave In Leave ' + document.title, ANALYTICS_CONSTANT.delete)
               toastrService.clearPreviousToastr();
               toastrService.showSuccessToastr("Leave Application Cancelled Successfully!");
               $uibModalInstance.close();
           },function (error){
               toastrService.showErrorToastr("Leave Cancellation Failed!", "", 5000);
               $uibModalInstance.close();
           });
        }

        function confirmCancelConformation(){
            vm.showConfirmation = true;

        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ApplyForLeaveModalCtrl', ['$scope', 'employeeService', '$stateParams', '$uibModalInstance', 'authService', 'utilService', 'toastrService', 'leaveManagementService', 'employeeId', 'remainingLeaveService','analyticsService','ANALYTICS_CONSTANT', ApplyForLeaveModalCtrl]);

    /** @ngInject */
    function ApplyForLeaveModalCtrl($scope, employeeService, $stateParams, $uibModalInstance, authService, utilService, toastrService, leaveManagementService, employeeId, remainingLeaveService,analyticsService,ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Apply For Leave Modal';
        var analyticsModalUrl = 'apply-for-leave';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Apply For Leave In' + document.title, ANALYTICS_CONSTANT.open);
        vm.datePicker = {};
        vm.datePicker.options = {};
        vm.datePicker.date = getInitialFromAndToDate();
        vm.reason = null;
        vm.selectedCategoryPolicyConfig = null;
        vm.leaveCategoryList = null;
        vm.selectedTypeId = "";
        vm.selectedLeaveHalf = null;
        vm.leaveDate = moment();
        vm.file = null;
        vm.remainingLeavesList = [];
        vm.isRemainingLeaveDataLoaded = false;
        vm.selectedEarnedLeaveType = null;
        vm.availableExchangeLeaveDates = [];
        vm.selectedDayForExchangeLeave = [];
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.isSubmitRequestPending = false;
        vm.dateRangeList = [];
        vm.selectedDateRange = null;
        vm.fiscalYearStartDate = null;
        vm.fiscalYearEndDate = null;
        vm.selectedYear = new Date();
        vm.yearPicker = {};
        vm.yearPicker.opened = false;
        vm.yearPicker.format = "yyyy";
        vm.yearPicker.options = {
            datepickerMode: 'year',
            minDate: new Date(2019,12,1),
            maxDate: new Date(),
            minMode: 'year',
            maxMode: 'year'
        };
        vm.openYearPicker = openYearPicker;
        vm.applyForLeave = applyForLeave;
        vm.openCalendar = openCalendar;
        vm.determineEarnedLeaveTypeAndShowUI = determineEarnedLeaveTypeAndShowUI;
        vm.isApplyButtonEnabled = isApplyButtonEnabled;

        function openYearPicker() {
            vm.yearPicker.opened = true;
        }
        $scope.$watch('vm.selectedDateRange', function (newVal) {
            if (newVal) {
                vm.isRemainingLeaveDataLoaded = false;
                vm.remainingLeavesList = [];
                var dates = newVal.split(" - ");

                vm.fiscalYearStartDate = moment(dates[0], "MMM YYYY").startOf('month');
                vm.fiscalYearEndDate = moment(dates[1], "MMM YYYY").endOf('month').milliseconds(0);
                var startMoment = vm.fiscalYearStartDate.clone();
                var endMoment = vm.fiscalYearEndDate.clone();
                var today = moment().startOf('day');
                if (today.isBetween(startMoment, endMoment, null, '[]')) {
                    vm.datePicker.date = {
                        startDate: today.clone(),
                        endDate: today.clone()
                    };
                } else {
                    vm.datePicker.date = {
                        startDate: startMoment.clone(),
                        endDate: startMoment.clone()
                    };
                }
                vm.selectedCategoryPolicyConfig = null;
                getRemainingLeaveList();
            }
        });
        function init() {
            vm.datePicker.options = {
                locale: { format: 'DD-MMM-YYYY' },
                minDate: vm.minDate
            };
            fetchDateRanges();
        }

        function fetchDateRanges() {
            remainingLeaveService.getDistinctLeaveBalanceDateRanges().then(function (data) {
                vm.dateRangeList = data.dateRanges;
                if (vm.dateRangeList.length > 0) {
                    var index = utilService.findDateRangeIndexContainingToday(vm.dateRangeList);
                    vm.selectedDateRange = vm.dateRangeList[index];
                }
            });
        }

        function getRemainingLeaveList() {
            if (!vm.selectedDateRange) return;

            remainingLeaveService.getAllRemainingLeavesOfEmployeeInFiscalYear(employeeId, vm.fiscalYearStartDate, vm.fiscalYearEndDate).then(function (data) {
                vm.isRemainingLeaveDataLoaded = true;
                vm.remainingLeavesList = data.employeeRemainingLeaveList;
                if (!vm.remainingLeavesList) {
                    toastrService.showErrorToastr("Leave policy not set");
                    $uibModalInstance.dismiss();
                }
            });
        }
        init();

        function determineEarnedLeaveTypeAndShowUI() {
            if(Number(vm.selectedCategoryPolicyConfig.pastDateSelectionLimit) > -1) {
                vm.datePicker.options.minDate = vm.minDate = moment().startOf('day').subtract(Number(vm.selectedCategoryPolicyConfig.pastDateSelectionLimit), "days");
            } else {
                vm.datePicker.options.minDate = vm.minDate = moment().startOf("day");
            }
            if (Number(vm.selectedCategoryPolicyConfig.earnedLeaveCriteria) === 1) {
                vm.selectedEarnedLeaveType = 1;
                vm.isRemainingLeaveDataLoaded = false;

                var startYear = moment(vm.selectedDateRange.split(" - ")[0], "MMM YYYY").year();

                remainingLeaveService.getAvailableExchangeLeaveDates(employeeId, startYear).then(function (data) {
                    vm.availableExchangeLeaveDates = data.dateList;
                });
            } else {
                vm.selectedEarnedLeaveType = null;
                vm.isRemainingLeaveDataLoaded = true;
            }
        }

        function applyForLeave() {
            toastrService.clearPreviousToastr();
            vm.isSubmitRequestPending = true;

            if (!vm.selectedCategoryPolicyConfig) {
                vm.isSubmitRequestPending = false;
                return toastrService.showErrorToastr("Select a leave category");
            }
            if (vm.reason === null) {
                vm.isSubmitRequestPending = false;
                return toastrService.showErrorToastr("Reason cannot be empty");
            }
            if (authService.getLoggedInUser().id !== parseInt(employeeId) && !authService.isAdmin()) {
                vm.isSubmitRequestPending = false;
                return toastrService.showErrorToastr("Users can only apply for leave for themselves");
            }
            if (Number(vm.selectedTypeId) === 2 && (Number(vm.selectedLeaveHalf) !== 1 && Number(vm.selectedLeaveHalf) !== 2)) {
                vm.isSubmitRequestPending = false;
                return toastrService.showErrorToastr("Select a half");
            }
            var data = {};
            if (Number(vm.selectedTypeId) === 1) {
                data = {
                    fiscalYearStartDate: vm.fiscalYearStartDate.startOf('month').valueOf(),
                    fiscalYearEndDate: vm.fiscalYearEndDate.endOf('month').milliseconds(0).valueOf(),
                    startDate: vm.datePicker.date.startDate.format('x'),
                    endDate: vm.datePicker.date.endDate.format('x'),
                    leaveCategoryId: vm.selectedCategoryPolicyConfig.leaveCategoryId,
                    reason: vm.reason,
                    leaveTakenAgainst: !!!vm.selectedDayForExchangeLeave[0] ? null : vm.selectedDayForExchangeLeave[0].startOfApplicableDay,
                    isHalfDay: false
                };

                if (!utilService.checkIfValidDateRange(vm.datePicker.date.startDate, vm.datePicker.date.endDate)) {
                    vm.isSubmitRequestPending = false;
                    return toastrService.showErrorToastr("Start day can not be before end date");
                }
                if (!utilService.isDateInSameYear(data.startDate, data.endDate)) {
                    vm.isSubmitRequestPending = false;
                    return toastrService.showErrorToastr("Start date and end date are not in the same year");
                }
            }
            if (Number(vm.selectedTypeId) === 2) {
                data = {
                    fiscalYearStartDate: vm.fiscalYearStartDate.startOf('month').valueOf(),
                    fiscalYearEndDate: vm.fiscalYearEndDate.endOf('month').milliseconds(0).valueOf(),
                    startDate: vm.leaveDate.format('x'),
                    endDate: vm.leaveDate.format('x'),
                    leaveCategoryId: vm.selectedCategoryPolicyConfig.leaveCategoryId,
                    reason: vm.reason,
                    leaveTakenAgainst: !!!vm.selectedDayForExchangeLeave[0] ? null : vm.selectedDayForExchangeLeave[0].startOfApplicableDay,
                    leaveHalf: vm.selectedLeaveHalf,
                    isHalfDay: true
                };
            }

            if (vm.selectedCategoryPolicyConfig.earnedLeaveCriteria > 0) {
                data.startDate = vm.leaveDate.format('x');
                data.endDate = vm.leaveDate.format('x');
            }

            console.log("request data to apply for leave: ", data);
            leaveManagementService.applyForLeave(employeeId, data, vm.file).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Apply', analyticsModalUrl + '/apply', 'Apply For Leave In' + document.title, ANALYTICS_CONSTANT.apply)
                vm.isSubmitRequestPending = false;
                $uibModalInstance.close(data);
            }, function (error) {
                vm.isSubmitRequestPending = false;
                toastrService.showErrorToastr("Could not apply for leave because " + error, "", 5000);
            });
        }

        function openCalendar(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function showErrorToast(errorMsg) {
            vm.isSubmitRequestPending = false;
            toastr.error(errorMsg);
        }

        function getInitialFromAndToDate() {
            return {
                'startDate': moment(),
                'endDate': moment()
            };
        }

        function isApplyButtonEnabled(){
            if(vm.isSubmitRequestPending) return true;
            if(!vm.selectedCategoryPolicyConfig) return !vm.isSubmitRequestPending && true;
            if(vm.reason === null || vm.reason === "") return !vm.isSubmitRequestPending && true;
            if(Number(vm.selectedTypeId) === 2 && (Number(vm.selectedLeaveHalf) !== 1 && Number(vm.selectedLeaveHalf) !== 2)) return !vm.isSubmitRequestPending && true;
            if(vm.selectedTypeId == null || vm.selectedTypeId === "") return !vm.isSubmitRequestPending && true;
            return !vm.isSubmitRequestPending && false;
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('DeviceAllocationsCtrl',['$scope','$uibModal','toastrService','_', DeviceAllocationsCtrl]);

    /** @ngInject */
    function DeviceAllocationsCtrl($scope,$uibModal,toastrService,_) {

        var vm = this;
        vm.device = null;
        vm.isAllSelected = false;
        vm.showFilters = false;
        vm.name="";
        vm.shift="";
        vm.department="";
        vm.allocationsToShow = [];
        vm.isDataLoaded = false;

        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.openDeleteModal = openDeleteModal;
        vm.searchAllocations = searchAllocations;

        function init() {
            $scope.$on("device-allocations-loaded",function (event,data) {
               vm.device = data.device;
               vm.allocations = data.allocations;
               vm.allocationsToShow = data.allocations;
               vm.name="";
               vm.shift="";
               vm.department="";
               vm.isDataLoaded = true;
            });
        }

        init();

        function searchAllocations() {
            vm.allocationsToShow = _.filter(vm.allocations,function (item) {
                return (item.name!= null && item.name.toLowerCase().startsWith(vm.name.toLowerCase())) &&
                    (item.departmentName != null && item.departmentName.toLowerCase().startsWith(vm.department.toLowerCase()));
            });
        }

        function checkOrUncheckAll() {
            if(vm.isAllSelected === false){
                vm.allocations.forEach(function (allocations) {
                    allocations.isSelected = true;
                });
                vm.isAllSelected = true;
            }
            else{
                vm.allocations.forEach(function (allocations) {
                    allocations.isSelected = false;
                });
                vm.isAllSelected = false;
            }
        }

        function openDeleteModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/devices/devicesList/allocations/allocated/delete/deleteAllocation.modal.html',
                size: 'lg',
                controller:'DeleteAllocationCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    allocationsToDelete: function(){
                        return getSelectedAllocations()
                    },
                    deviceId: function () {
                        return vm.device.id;
                    }
                }
            }).result.then(function () {
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Allocation successfully deleted");
                $scope.$emit("refresh-allocation-data");
            });
        }

        function getSelectedAllocations() {
            return vm.allocations.filter(function (item) {
                return item.isSelected;
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('AllocationsRootCtrl',['deviceService','$stateParams','$scope','toastrService','utilService', 'analyticsService', 'ANALYTICS_CONSTANT', AllocationsRootCtrl]);

    /** @ngInject */
    function AllocationsRootCtrl(deviceService,$stateParams,$scope,toastrService,utilService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.device = null;
        vm.isAllSelected = false;
        vm.isAnyRowSelected = false;
        vm.selectedRow = 0;
        vm.isDataLoaded = false;
        vm.selectedTemporaryAllocationStatuses = [];
        vm.allTemporaryAllocationData = [];
        vm.selectedTab = 'allocated';
        vm.allocationsData = [];
        vm.searchKeyword = "";
        vm.numberOfPages  = 0;
        vm.numberOfButtons = 0;
        vm.selectedPage = 0;
        vm.total = 0;
        vm.isDataLoaded = false;
        vm.rowsPerPage = 10;
        utilService.setRowsPerPage(10);
        vm.currentDate = new Date().getTime();
        vm.selectedRowObject = null;

        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.changeTab = changeTab;
        vm.showUnallocatedTable = showUnallocatedTable;
        vm.getAllocatedAndUnallocatedInADevice = getAllocatedAndUnallocatedInADevice;
        vm.fetchTemporaryAllocationsData = fetchTemporaryAllocationsData;
        vm.showAllocationInfoInTheRightColumn = showAllocationInfoInTheRightColumn;
        vm.optionToggled = optionToggled;
        vm.allocateSelectedEmployees = allocateSelectedEmployees;
        vm.revokeSelectedEmployees = revokeSelectedEmployees;
        vm.determineTabAndFetchData = determineTabAndFetchData;
        vm.revokeOrCancelTemporaryPermissions = revokeOrCancelTemporaryPermissions;
        vm.revokeOrCancelTemporaryPermission = revokeOrCancelTemporaryPermission;
        vm.revokeSingleEmployee = revokeSingleEmployee;
        vm.allocateSingleEmployee = allocateSingleEmployee;
        vm.searchByNameOrId = searchByNameOrId;

        function init() {
            deviceService.getDeviceDetails($stateParams.deviceId).then(function (data){
                vm.device = data;
            });
            determineTabAndFetchData();
        }

        function determineTabAndFetchData(){
            if(vm.selectedTab == 'allocated' || vm.selectedTab == 'unallocated'){
                getAllocatedAndUnallocatedInADevice();
            } else if(vm.selectedTab == 'temporary'){
                fetchTemporaryAllocationsData();
            }
        }

        init();

        function getAllocatedAndUnallocatedInADevice(params) {
            vm.allocationsData = [];
            resetSelectionData();
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            var queryParams = getRequestParameters();
            queryParams.tabName = vm.selectedTab;
            vm.isDataLoaded = false;
            deviceService.getAllocatedAndUnallocatedInADevice(queryParams).then(function (data){
                vm.isDataLoaded = true;
                vm.allocationsData = data.employees;
                vm.numberOfPages = data.totalPages;
                vm.total = data.totalRecords;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Couldn't fetch device allocation details: " + error, "", 5000);
            });
        }

        function revokeOrCancelTemporaryPermissions(){
            if(vm.allocationsData.every(function (data){
                return !data.isSelected;
            })) return toastrService.showErrorToastr("Please select an allocation");
            var requestData = {
                allocationIdsToBeRevoked   : [],
                allocationIdsToBeCancelled : [],
            }
            var selectedAllocationsData = getSelectedRecords();
            selectedAllocationsData.forEach(function (allocation){
                if(allocation.allocationStatus == 'upcoming')
                    requestData.allocationIdsToBeCancelled.push(allocation.allocationId);
                else
                    requestData.allocationIdsToBeRevoked.push(allocation.allocationId);
            });

            vm.isDataLoaded = false;
            deviceService.cancelOrRevokeTemporaryAllocations(requestData).then(function (){
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Successfully revoked")
                fetchTemporaryAllocationsData();
            },function (error){
                toastrService.showErrorToastr("Could not revoke: " + error, "", 5000);
                vm.isDataLoaded = true;
            })
        }
        function revokeOrCancelTemporaryPermission(index){
            var allocationData = angular.copy(vm.allocationsData[index]);
            var requestData = {
                allocationIdsToBeRevoked   : [],
                allocationIdsToBeCancelled : [],
            }
            if(allocationData.allocationStatus == 'upcoming')
                requestData.allocationIdsToBeCancelled.push(allocationData.allocationId);
            else
                requestData.allocationIdsToBeRevoked.push(allocationData.allocationId);
            deviceService.cancelOrRevokeTemporaryAllocations(requestData).then(function (){
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Successfully revoked");
                fetchTemporaryAllocationsData();
            },function (error){
                toastrService.showErrorToastr("Could not revoke: " + error, "", 5000);
                vm.isDataLoaded = true;
            })
        }

        function checkOrUncheckAll() {
            if(vm.allSelected === false){
                vm.allocationsData.forEach(function (allocations) {
                    allocations.isSelected = false;
                });
            }
            else{
                vm.allocationsData.forEach(function (allocations) {
                    allocations.isSelected = true;
                });
            }
        }

        function optionToggled() {
            vm.allSelected = vm.allocationsData.every(function (itm) {
                return itm.isSelected === true;
            });
        }

        // function checkIfAnySelected() {
        //     for (var i = 0; i < vm.allocationsData.length; i++) {
        //         if (vm.allocationsData[i].selected) {
        //             vm.isAnySelected = true;
        //             return;
        //         }
        //     }
        //     vm.isAnySelected = false;
        // }

        function changeTab(tab){
            vm.selectedTab = tab;
            vm.selectedPage = 0;
            resetSelectionData();
            if(vm.selectedTab == 'allocated' || vm.selectedTab == 'unallocated'){
                getAllocatedAndUnallocatedInADevice();
            } else if(vm.selectedTab == 'temporary'){
                fetchTemporaryAllocationsData();
            }
        }

        function showUnallocatedTable(value){
            resetSelectionData();
            // vm.selectedLeaveApplicationStatuses  = data;
            // vm.leaveApplicationData = [];
            // vm.selectedPaginationPage = 0;
            // searchLeaveApplicationRecord();

            vm.isThisBtnClicked = value;
        }

        function fetchTemporaryAllocationsData(params){
            resetSelectionData();
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            var queryParams = getRequestParameters();
            vm.isDataLoaded = false;
            deviceService.getTemporaryAllocationsInADevice(queryParams).then(function (data){
                vm.allocationsData = data.allocationResponses;
                vm.numberOfPages = data.numberOfPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = data.currentPage;
                vm.isDataLoaded = true;
            },function (error){
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Couldn't fetch temporary allocation details: " + error, "", 5000);
            })
        }

        function getRequestParameters(){
            return   {
                deviceId     : Number($stateParams.deviceId),
                pageNumber   : vm.selectedPage,
                perPage      : vm.rowsPerPage,
                keyword      : vm.searchKeyword
            }
        }

        function showAllocationInfoInTheRightColumn(selectedRow){
            vm.isAnyRowSelected = true;
            vm.selectedRow = selectedRow;
            vm.selectedRowObject = angular.copy(vm.allocationsData[selectedRow]);
        }
        function resetSelectionData(){
            vm.isAnyRowSelected = false;
            vm.allSelected = false;
        }

        // function makeEverythingEmpty() {
        //     vm.isDataLoaded = false;
        //     vm.numberOfPages = 0;
        //     vm.total = 0;
        //     vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        //     vm.selectedPage = data.currentPage;
        // }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.selectedPage = vm.selectedPage == 0? 0 : vm.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.selectedPage = vm.selectedPage == vm.numberOfPages ? vm.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.selectedPage = searchParams;
            }
        }

        function allocateSelectedEmployees() {
            if(!isAnyoneSelected())
                return toastrService.showErrorToastr("No employee is selected");
            vm.isDataLoaded = false;
            var selectedAllocationsData = getSelectedRecords();

            var data = {
                employeeIdList : selectedAllocationsData.flatMap(function (item) { return item.id;})
            };

            deviceService.allocateEmployeeBatch(data, Number($stateParams.deviceId)).then(function () {
                toastrService.clearPreviousToastr();
                vm.isDataLoaded = true;
                toastrService.showSuccessToastr("Allocation successful");
                analyticsService.sendData(ANALYTICS_CONSTANT.devices,document.title + ' - Revoke Device','','Revoke Device In '+document.title, ANALYTICS_CONSTANT.revoke)
                getAllocatedAndUnallocatedInADevice();
            },function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Allocation failed: " + error, "", 5000);
                deselectAllRecords();
            });
        }

        function revokeSelectedEmployees() {
            if(!isAnyoneSelected())
                return toastrService.showErrorToastr("No employee is selected");
            vm.isDataLoaded = false;
            var selectedAllocationsData = getSelectedRecords();

            var data = {
                employeeIds : selectedAllocationsData.flatMap(function (item) { return item.id;}),
                temporaryAllocationIds : selectedAllocationsData.reduce(function (filtered, allocationDetails) {
                    if(allocationDetails.isTemporary === true) filtered.push(allocationDetails.allocationId);
                    return filtered;
                }, [])
            };

            deviceService.revokeEmployeeBatch(data, Number($stateParams.deviceId)).then(function () {
                toastrService.clearPreviousToastr();
                vm.isDataLoaded = true;
                toastrService.showSuccessToastr("Revocation successful");
                analyticsService.sendData(ANALYTICS_CONSTANT.devices,document.title + ' - Allocate Device','','Allocate Device In '+document.title, ANALYTICS_CONSTANT.allocate)
                getAllocatedAndUnallocatedInADevice();
            },function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Revocation failed: " + error, "", 5000);
                deselectAllRecords();
            });
        }

        function isAnyoneSelected() {
            return vm.allocationsData.some(function (itm) {
                return itm.isSelected === true;
            });
        }

        function getSelectedRecords() {
            return vm.allocationsData.filter(function (data){
                return data.isSelected;
            });
        }

        function revokeSingleEmployee(allocationDetails) {
            deselectAllRecords();
            allocationDetails.isSelected = true;
            revokeSelectedEmployees();
        }

        function allocateSingleEmployee(allocationDetails) {
            deselectAllRecords();
            allocationDetails.isSelected = true;
            allocateSelectedEmployees();
        }

        function deselectAllRecords() {
            vm.allocationsData.forEach(function (item) {
                item.isSelected = false;
            });
            resetSelectionData();
        }

        function searchByNameOrId(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search,'','','Search In'+document.title, ANALYTICS_CONSTANT.search);
            determineTabAndFetchData();
        }

    }


})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('UnAllocatedCtrl',['$scope','$uibModal','toastrService','_', UnAllocatedCtrl]);

    /** @ngInject */
    function UnAllocatedCtrl($scope,$uibModal,toastrService,_) {

        var vm = this;
        vm.device = null;
        vm.isAllSelected = false;
        vm.showFilters = false;
        vm.unallocatedEmployees = [];
        vm.unallocatedEmployeesToShow = [];
        vm.department = "";
        vm.shift = "";
        vm.name = "";
        vm.isDataLoaded = false;

        vm.checkOrUncheckAll = checkOrUncheckAll;
        vm.openAllocateModal = openAllocateModal;
        vm.searchAllocations = searchAllocations;

        function init() {
            $scope.$on("device-allocations-loaded",function (event,data) {
                vm.department = "";
                vm.shift = "";
                vm.name = "";
                vm.device = data.device;
                vm.unallocatedEmployees = data.unAllocated;
                vm.unallocatedEmployeesToShow = data.unAllocated;
                vm.isDataLoaded = true;
            });
        }

        init();



        function searchAllocations() {
            vm.unallocatedEmployeesToShow = _.filter(vm.unallocatedEmployees,function (item) {
                return (item.name!= null && item.name.toLowerCase().startsWith(vm.name.toLowerCase())) &&
                    (item.departmentName != null && item.departmentName.toLowerCase().startsWith(vm.department.toLowerCase()));
            });
        }

        function checkOrUncheckAll() {
            if(vm.isAllSelected === false){
                vm.unallocatedEmployeesToShow.forEach(function (allocations) {
                    allocations.isSelected = true;
                });
                vm.isAllSelected = true;
            }
            else{
                vm.unallocatedEmployeesToShow.forEach(function (allocations) {
                    allocations.isSelected = false;
                });
                vm.isAllSelected = false;
            }
        }

        function openAllocateModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/devices/devicesList/allocations/unAllocated/allocate/allocate.modal.html',
                size: 'lg',
                controller:'AllocateModalCtrl',
                controllerAs:'vm',
                backdrop : 'static',
                resolve: {
                    personsToAllocate: function(){
                        return getSelectedAllocations()
                    },
                    deviceId: function () {
                        return vm.device.id;
                    }
                }
            }).result.then(function () {
                toastrService.clearPreviousToastr();
                toastrService.showSuccessToastr("Allocated successfully");
                $scope.$emit("refresh-allocation-data");
            });
        }

        function getSelectedAllocations() {
            return vm.unallocatedEmployeesToShow.filter(function (item) {
                return item.isSelected;
            })
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('InovaceClientApp.pages.main.leave.applyLeaveForOthers')
        .controller('AdminLeaveApplyModalCtrl', ['$scope','$timeout','$stateParams', '$uibModal', 'authService','remainingLeaveService', 'leaveManagementService', 'toastrService','$sce','_','employeeService','employeeInfo','leaveInfo', '$uibModalInstance','$state', 'analyticsService', 'ANALYTICS_CONSTANT', AdminLeaveApplyModalCtrl]);

    /** @ngInject */
    function AdminLeaveApplyModalCtrl($scope,$timeout,$stateParams, $uibModal, authService, remainingLeaveService, leaveManagementService, toastrService, $sce, _, employeeService, employeeInfo, leaveInfo, $uibModalInstance,$state, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.leaveInfo = leaveInfo;
        vm.employeeToShow = employeeInfo;
        vm.isConfirmBtnClicked = false;
        vm.confirmLeaveApplication = confirmLeaveApplication;
        var analyticsApplyTitle = 'Apply Leave';
        var analyticsApplyUrl = 'apply-leave';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsApplyTitle, analyticsApplyUrl, 'Apply Leave In' + document.title, ANALYTICS_CONSTANT.open)

        function confirmLeaveApplication() {
            vm.isConfirmBtnClicked = true;
            applyForLeave();
        }

        function applyForLeave() {
            toastrService.clearPreviousToastr();
            var data = {};

            var baseData = {
                leaveCategoryId: vm.leaveInfo.categoryId,
                reason: vm.leaveInfo.reason,
                forceApproval: vm.leaveInfo.forceApproval,
                fiscalYearStartDate: vm.leaveInfo.fiscalYearStartDate,
                fiscalYearEndDate: vm.leaveInfo.fiscalYearEndDate
            };
            if (vm.leaveInfo.leaveType === 1) {
                data = angular.extend(baseData, {
                    startDate: vm.leaveInfo.dateRange.startDate.valueOf(),
                    endDate: vm.leaveInfo.dateRange.endDate.valueOf(),
                    isHalfDay: false
                });
                if (vm.leaveInfo.leaveTakenAgainst !== null) data.leaveTakenAgainst = vm.leaveInfo.leaveTakenAgainst;
            }

            if (vm.leaveInfo.leaveType === 2) {
                data = angular.extend(baseData, {
                    startDate: vm.leaveInfo.dateRange.startDate.valueOf(),
                    endDate: vm.leaveInfo.dateRange.endDate.valueOf(),
                    leaveHalf: vm.leaveInfo.selectedLeaveHalf,
                    isHalfDay: true
                });
            }

            leaveManagementService.applyForLeave(vm.employeeToShow.id, data, vm.leaveInfo.file).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsApplyTitle + ' - Apply', analyticsApplyUrl + '/apply', 'Apply Leave In' + document.title, ANALYTICS_CONSTANT.apply)
                toastrService.showSuccessToastr("Leave application submitted successfully");
                $state.go('leave.applyLeaveForOthers');
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Leave application submission failed " + error, "", 5000);
                vm.isConfirmBtnClicked = false;
                //$timeout($uibModalInstance.close(data),4000);

                // showErrorToast("Could not apply for leave because " + error);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.employees.manageEmployees')
        .controller('DeleteEmployeeModalCtrl', ['$uibModalInstance','employeeService','idList','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteEmployeeModalCtrl]);

    /** @ngInject */
    function DeleteEmployeeModalCtrl($uibModalInstance,employeeService,idList,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsTitle =document.title + ' - Delete Employee Modal'
        var analyticsUrl ='delete-employee'
        vm.idList = null;
        vm.isEmployeeDeleting = false;
        vm.deleteEmployees = deleteEmployees;

        function init() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, analyticsTitle, analyticsUrl, 'Delete Employee In' + document.title, ANALYTICS_CONSTANT.open)

            vm.idList = idList;
        }

        init();

        function deleteEmployees() {
            vm.isEmployeeDeleting = true;
            var data = {
                "employeeIdList":vm.idList
            };
            employeeService.deleteEmployee(data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, analyticsTitle + ' - ' + ANALYTICS_CONSTANT.delete, analyticsUrl + "/delete", 'Delete Employee In' + document.title, ANALYTICS_CONSTANT.delete)
                vm.isEmployeeDeleting = false;
                $uibModalInstance.close();
            },function (error) {
                vm.isEmployeeDeleting = false;
                toastrService.showErrorToastr("Could not delete", "", 5000);
            });

        }


    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.leave.leaveCategoryPolicyConfiguration')
    app.controller('DeleteConfigurationModalCtrl', ['leaveCategoryPolicyConfigurationService', '$uibModal', '$uibModalInstance', 'toastrService', 'policyToCategoryConfig', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteConfigurationModalCtrl]);

    /** @ngInject */
    function DeleteConfigurationModalCtrl(leaveCategoryPolicyConfigurationService, $uibModal, $uibModalInstance, toastrService, policyToCategoryConfig, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.isDeleting = false;
        vm.policyToCategoryConfig = policyToCategoryConfig;

        vm.deleteAllLeavePolicyToCategoryConfigurations = deleteAllLeavePolicyToCategoryConfigurations;

        var analyticsDeleteTitle = 'Delete Leave Configuration Modal';
        var analyticsDeleteUrl = 'delete-leave-configuration';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Leave Configuration In' + document.title, ANALYTICS_CONSTANT.open)

        function deleteAllLeavePolicyToCategoryConfigurations() {
            vm.isDeleting = true;
            leaveCategoryPolicyConfigurationService.deleteAllCategoryConfigurationsOfAPolicy(vm.policyToCategoryConfig.leavePolicyId)
                .then(function (data) {
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Leave Configuration In' + document.title, ANALYTICS_CONSTANT.delete)
                    $uibModalInstance.close(data);
                }, function (error) {
                    toastrService.showErrorToastr("could not delete configuration " + error, "", 5000);
                }).finally(function () {
                    vm.isDeleting = false;
                });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('MembersConfirmationModalCtrl', ['$scope', '$stateParams', '$state', '$uibModal','$uibModalInstance', 'authService', 'toastrService', '$q','membershipManagementService','fileName', MembersConfirmationModalCtrl]);

    function MembersConfirmationModalCtrl($scope, $stateParams, $state, $uibModal,$uibModalInstance, authService, toastrService, $q,membershipManagementService,fileName) {
        var vm = this;

        vm.fileName = fileName;

        vm.remove = remove;

        function remove() {
            $uibModalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('RenewModalCtrl', ['$scope', '$stateParams', '$state', '$uibModal','$uibModalInstance', 'authService', 'toastrService', '$q','membershipManagementService','memberName', 'analyticsService', 'ANALYTICS_CONSTANT', RenewModalCtrl]);

    function RenewModalCtrl($scope, $stateParams, $state, $uibModal,$uibModalInstance, authService, toastrService, $q,membershipManagementService,memberName, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsModalTitle = 'Renew Package Modal';
        var analyticsModalUrl = 'renew-package';
        vm.memberName = memberName;
        vm.renewMember = renewMember;
        vm.isCreating = false;
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle,analyticsModalUrl,'Renew Package In'+document.title, ANALYTICS_CONSTANT.open)
        function renewMember() {
            vm.isCreating = true;
            membershipManagementService.renewMember(vm.memberName.id).then(function (){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle+ ' - Renew', analyticsModalUrl+'/renew','Renew Package In '+document.title, ANALYTICS_CONSTANT.create)
                openSuccessRenewalModal(vm.memberName.name);
            },function (error){
                toastrService.showErrorToastr('Failed: ' + error, '', 5000);
            }).finally(function (){
                vm.isCreating = false;
                $uibModalInstance.close();
            });
        }

        function openSuccessRenewalModal(memberName){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/membershipManagement/members/modals/successModal/renewalSuccessful.Modal.html',
                size        : 'md',
                controller  : 'RenewalSuccessfulModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    memberInfo:function () {
                        return memberName;
                    }
                }
            })
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
        .controller('OpenDocumentModalCtrl', ['$scope','$sce', '$stateParams', '$state', '$uibModal','$uibModalInstance', 'authService', 'toastrService', '$q','membershipManagementService','fileInfo', OpenDocumentModalCtrl]);

    function OpenDocumentModalCtrl($scope,$sce, $stateParams, $state, $uibModal,$uibModalInstance, authService, toastrService, $q,membershipManagementService,fileInfo) {
        var vm = this;

        vm.uploadedDocument = fileInfo;

        vm.remove = remove;

        function remove() {
            $uibModalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement')
    app.controller('RenewalSuccessfulModalCtrl', ['appointmentLogService', 'authService', '$uibModalInstance', 'toastr','memberInfo', 'analyticsService', 'ANALYTICS_CONSTANT', RenewalSuccessfulModalCtrl]);

    /** @ngInject */
    function RenewalSuccessfulModalCtrl(appointmentLogService, authService, $uibModalInstance, toastr,memberInfo, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Renew Package Modal';
        var analyticsModalUrl = 'renew-package';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle,analyticsModalUrl,'Renew Package In'+document.title, ANALYTICS_CONSTANT.open)

        vm.memberInfo = memberInfo;

        vm.successRenewal = successRenewal;

        function successRenewal(){
            analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle+ ' - Renew', analyticsModalUrl+'/renew','Renew Package In '+document.title, ANALYTICS_CONSTANT.create)
            $uibModalInstance.close();
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.members')
    app.controller('UpgradeSubscriptionModalCtrl', ["$state", 'appointmentLogService', 'authService', '$uibModalInstance', 'toastrService', 'subscriptionInfo', 'membershipManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', UpgradeSubscriptionModalCtrl]);

    /** @ngInject */
    function UpgradeSubscriptionModalCtrl($state,appointmentLogService, authService, $uibModalInstance, toastrService, subscriptionInfo, membershipManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isCreating = false;
        var analyticsModalTitle = 'Upgrade Package Modal';
        var analyticsModalUrl = 'upgrade-package';
        vm.subscriptionInfo = angular.copy(subscriptionInfo);
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle,analyticsModalUrl,'Upgrade Package In '+document.title, ANALYTICS_CONSTANT.open)
        vm.upgradeSubscription = upgradeSubscription;
        function upgradeSubscription(){
            vm.isCreating = true;
            membershipManagementService.upgradeSubscription(vm.subscriptionInfo.subscriptionId, vm.subscriptionInfo.updatedData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle+ ' - Upgrade', analyticsModalUrl+'/upgrade','Upgrade Package In'+document.title, ANALYTICS_CONSTANT.edit)
                toastrService.showSuccessToastr("Subscription Upgraded Successfully", "", "5000");
                $uibModalInstance.close();
                $state.go('membershipManagement.members');
            }, function (error) {
                toastrService.showErrorToastr(error, '', '5000');
                $uibModalInstance.dismiss(message);
            }).finally(function (){
                vm.isCreating = false;
            });
        }

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipDashboard')
        .directive('listEmployee', function () {
            return {
                restrict: 'E',
                controller: 'ListEmployeeFeedCtrl as vm',
                scope:{
                    allEmployeeData   : "=",
                    isDataLoaded      : "=",
                    showDays          : "=",
                    liveFeed          : "=",
                    attendanceFeed    : "="
                },
                templateUrl: 'app/pages/main/membershipManagement/membershipDashboard/partials/ListEmployeeFeed/listEmployeeFeed.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipDashboard')
        .controller('ListEmployeeFeedCtrl', ['$scope', 'authService','$filter','utilService', 'dashboardService', ListEmployeeFeedCtrl]);

    /** @ngInject */
    function ListEmployeeFeedCtrl($scope, authService, $filter, utilService, dashboardService) {

        var vm = this;
        // vm.isDataLoaded = false;
        vm.lateList = [];
        vm.hasPermission = utilService.hasPermission;
        vm.isGroupAdmin = authService.getLoggedInUser().isGroupAdmin;
        vm.allEmployeeData=$scope.allEmployeeData;
        vm.isAtttendanceFeed=$scope.attendanceFeed;
        function init() {
            // dashboardService.getLateFeed().then(function (data){
            //    vm.lateList = data.entries;
            //    vm.isDataLoaded = true;
            // },function (){
            //     vm.isDataLoaded = true;
            // })
        }
        init();
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.membershipManagement.membershipDashboard')
        .controller('MembershipDashboardPieChartCtrl', MembershipDashboardPieChartCtrl);

    MembershipDashboardPieChartCtrl.$inject = ['$scope', '$timeout', 'baConfig',"membershipManagementService"];

    /** @ngInject */
    function MembershipDashboardPieChartCtrl($scope, $timeout, baConfig, membershipManagementService) {
        var vm = this;
        var labels = ["Member Inside", "Member Left"];
        var colours = ['#17b7a6', '#f7b217'];
        vm.totalVisitTodayData={};
        vm.isDataloaded=false;
        vm.labelsAndColors = [{
            colour: colours[0],
            label: labels[0]
        }, {
            colour: colours[1],
            label: labels[1]
        }];

        var options = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: false,
                position: 'bottom',
                labels: {
                    fontColor: baConfig.colors.defaultText
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            cutoutPercentage: 60
        };
        vm.data = {
            data:[50,20],
            total: 70,
            colours:colours,
            options : options,
            labels: labels,
        }
        vm.data.options.titles = [];
        vm.data.options.titles={
            "text" : "Total",
            'size' : 15,
            "bold" : false
        };
        vm.data.labels = labels;
        init()
        function init(){
            membershipManagementService.getTotalVisitTodayResponse().then(onDashboardTotalVisitFetchSuccess,onListFetchFailure);
        }
        function onDashboardTotalVisitFetchSuccess(responseData) {
            vm.data.data = [responseData.totalMemberInsideToday, responseData.totalMemberLeftToday];
            vm.data.total = responseData.totalMemberVisitedToday
            vm.isDataloaded = true;
        }
        function onListFetchFailure(){
            vm.isDataloaded = true;
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.settings.subDepartments')
        .controller('PrintSlipModalCtrl', ['$state','$uibModalInstance','authService','printSlipInfo','toastrService', 'parkingManagementService','analyticsService', 'ANALYTICS_CONSTANT', PrintSlipModalCtrl]);

    /** @ngInject */
    function PrintSlipModalCtrl($state, $uibModalInstance,authService,printSlipInfo,toastrService, parkingManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.officeLogoUrl = null;
        vm.parkingDetails = printSlipInfo;
        vm.parkingDetails.date = moment(new Date()).format("DD/MM/YYYY");
        vm.parkingDetails.exitTime = moment().format("hh:mm a");
        vm.exitVehicle = exitVehicle;
        vm.exitVehicleWithoutPrint = exitVehicleWithoutPrint;
        var user = authService.getLoggedInUser();

        vm.officeLogoUrl = user.office.logoUrl;

        function setParameters(){
            return {
                parkingSummaryId : vm.parkingDetails.id,
                amount : vm.parkingDetails.amount
            }
        }

        var analyticsDeleteTitle= 'Exit Vehicle Receipt';
        var analyticsDeleteUrl = 'exit-vehicle-receipt';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Exit Vehicle Receipt In' + document.title, ANALYTICS_CONSTANT.open)


        function exitVehicle(){

            if(vm.parkingDetails.amount === null)
                return toastrService.showErrorToastr("Amount can not empty")

            var params = setParameters();

            parkingManagementService.exitVehicle(params).then(function (){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Print', analyticsDeleteUrl + '/print', 'Exit Vehicle Receipt Print In' + document.title, ANALYTICS_CONSTANT.delete)
                toastrService.showSuccessToastr('Exit Successful');
                $state.go('parkingManagement.liveFeedAndDashboard');
                $uibModalInstance.close();
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });

        }

        function exitVehicleWithoutPrint(){

            if(vm.parkingDetails.amount === null)
                return toastrService.showErrorToastr("Amount can not empty")

            var params = setParameters();

            parkingManagementService.exitWithoutPrint(params).then(function (){
                toastrService.showSuccessToastr('Exit Successful');
                $state.go('parkingManagement.liveFeedAndDashboard');
                $uibModalInstance.close();
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });

        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.billSetup')
    app.controller('DeleteBillSetupModalCtrl', ['parkingManagementService','authService','$uibModalInstance','toastrService','vehicleTypeToChange', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteBillSetupModalCtrl]);

    /** @ngInject */
    function DeleteBillSetupModalCtrl(parkingManagementService,authService,$uibModalInstance,toastrService,vehicleTypeToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.vehicleTypeToChange = null;

        var analyticsDeleteTitle = 'Delete Bill Modal';
        var analyticsDeleteUrl = 'delete-bill';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl,
            'Delete Bill In' + document.title, ANALYTICS_CONSTANT.open)

        vm.deleteBillSetup = deleteBillSetup;

        function init() {
            vm.vehicleTypeToChange = vehicleTypeToChange;
        }

        init();

        function deleteBillSetup(vehicleTypeId) {
            parkingManagementService.postDeleteBillSetup(vehicleTypeId).then(onBillSetupDeleteSuccess,onBillSetupDeleteFailure)
        }

        function onBillSetupDeleteSuccess() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete',
                analyticsDeleteUrl + '/delete', 'Delete Bill In' + document.title, ANALYTICS_CONSTANT.delete)
            $uibModalInstance.close();
            toastrService.showSuccessToastr("Bill Setup Deleted");
        }

        function onBillSetupDeleteFailure(error) {
            toastrService.showErrorToastr("Could not delete: " + error, "", 5000);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.billSetup')
        .controller('CreateBillSetupCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'parkingManagementService', '$q', '_','analyticsService', 'ANALYTICS_CONSTANT', CreateBillSetupCtrl]);

    /** @ngInject */
    function CreateBillSetupCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, parkingManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.type = null;
        vm.baseFare = null;
        vm.baseHour = null;
        vm.hourlyFare = null;

        vm.createNewBillSetup = createNewBillSetup;
        function createNewBillSetup(valid){
            if (valid){
                toastrService.clearPreviousToastr();
                if(vm.type == null || vm.type == "") return toastrService.showErrorToastr("Bill type cannot be empty")
                if(vm.baseFare == null || vm.baseFare === "") return toastrService.showErrorToastr("Base Fare cannot be empty")
                if(vm.baseHour == null || vm.baseHour === "") return toastrService.showErrorToastr("Base Hour cannot be empty")
                if(vm.hourlyFare == null || vm.hourlyFare === "") return toastrService.showErrorToastr("Hourly Fare cannot be empty")
                var data = {
                    type: vm.type,
                    baseFare: vm.baseFare,
                    baseHour: vm.baseHour,
                    hourlyFare: vm.hourlyFare
                }

                parkingManagementService.postCreateBillSetup(data).then(function () {
                    analyticsService.sendData(ANALYTICS_CONSTANT.create, document.title + ' - Create',
                        '', 'Create New Bill In' + document.title, ANALYTICS_CONSTANT.create)
                    toastrService.showSuccessToastr("Bill type created successfully");
                    $state.go('parkingManagement.billSetup');
                });
            }

        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.parkingManagement.billSetup')
        .controller('UpdateBillSetupCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'parkingManagementService', '$q', '_', 'analyticsService', 'ANALYTICS_CONSTANT', UpdateBillSetupCtrl]);

    /** @ngInject */
    function UpdateBillSetupCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, parkingManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.type = $stateParams.vehicleType.type;
        vm.baseFare = $stateParams.vehicleType.baseFare;
        vm.baseHour = $stateParams.vehicleType.baseHour;
        vm.hourlyFare = $stateParams.vehicleType.hourlyFare;

        vm.updateBillSetupCtrl = updateBillSetupCtrl;

        function updateBillSetupCtrl(){
            toastrService.clearPreviousToastr();
            if(vm.type == null || vm.type == "") return toastrService.showErrorToastr("Bill type cannot be empty")
            if(vm.baseFare == null || vm.baseFare === "") return toastrService.showErrorToastr("Base Fare cannot be empty")
            if(vm.baseHour == null || vm.baseHour === "") return toastrService.showErrorToastr("Base Hour cannot be empty")
            if(vm.hourlyFare == null || vm.hourlyFare === "") return toastrService.showErrorToastr("Hourly Fare cannot be empty")
            var data = {
                id: $stateParams.vehicleType.id,
                type: vm.type,
                baseFare: vm.baseFare,
                baseHour: vm.baseHour,
                hourlyFare: vm.hourlyFare
            }

            parkingManagementService.postUpdateBillSetup(data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Update',
                    '', 'Update Bill Setup In' + document.title, ANALYTICS_CONSTANT.edit)
                toastrService.showSuccessToastr("Bill type updated successfully");
                $state.go('parkingManagement.billSetup');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBanks')
        .controller('BankPaymentAdviceEditorCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'authService', 'toastrService', 'bankManagementService', '$q', '_', 'analyticsService', 'ANALYTICS_CONSTANT', BankPaymentAdviceEditorCtrl]);

    /** @ngInject */
    function BankPaymentAdviceEditorCtrl($scope, $stateParams, $state, $uibModal, authService, toastrService, bankManagementService, $q, _, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();
        vm.isDataLoaded = false;
        vm.bankId = $stateParams.bankId;

        var toolbarOptions = [
            ['bold', 'underline'],
            // [{'indent': '-1'}, {'indent': '+1'}],
            [{'size' : ['small', false, 'large', 'huge']}],
            [{align : ''}, {align : 'center'}, {align : 'right'}],
        ];


        function init() {
            if (!vm.bankId || isNaN(vm.bankId) || vm.bankId <= 0) {
                $state.go('payroll.manageBanks');
                return;
            }
            vm.editor = new Quill("#editor", {
                modules : {toolbar : toolbarOptions},
                theme   : 'snow',
            });

            bankManagementService.getBankPaymentAdviceEditorData(vm.bankId).then(function (data) {
                vm.initialContent = data;

                var strToJson = JSON.parse(vm.initialContent.adviceLetterFormat);


                vm.editor.setContents(strToJson.ops);
            }, function (error) {
                toastrService.showErrorToastr("Editor Data is not loaded successfully");
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        angular.element(document).ready(function () {
            init();
        });


        vm.isDataLoaded = false;
        // vm.contents=editor.getContents()
        vm.submit = submit;


        vm.clearAll = clearAll;
        vm.addVariable = addVariable;

        function submit() {
            vm.contents = vm.editor.getContents();
            // quillGetHTML(vm.contents);
            var data = {
                adviceLetterFormat : JSON.stringify(vm.contents)
            }


            bankManagementService.saveBankPaymentAdviceEditorData(vm.bankId, data).then(function (data) {
                toastrService.showSuccessToastr("Editor Data Saved successfully");
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save', '', 'Save In' + document.title, ANALYTICS_CONSTANT.saveUrl)

            }, function (error) {
                toastrService.showErrorToastr("Editor Data Could Not Saved successfully");
            });


        }


        function addVariable(variableName) {
            var range = vm.editor.getSelection();

            vm.editor.insertText(range.index, variableName);
        }

        function clearAll() {
            vm.editor.setContents([]);
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.loanManagement')
        .controller('LoanOrSalaryAdvanceModalCtrl', ['$scope', '$stateParams', '$uibModalInstance', '$state', '$timeout', 'authService', 'employeeService', 'toastrService', 'MONTH_NAMES', 'LOAN_TYPE', 'loanData', 'utilService', 'analyticsService', 'ANALYTICS_CONSTANT', LoanOrSalaryAdvanceModalCtrl]);

    /** @ngInject */
    function LoanOrSalaryAdvanceModalCtrl($scope, $stateParams, $uibModalInstance, $state, $timeout, authService, employeeService, toastrService, MONTH_NAMES, LOAN_TYPE, loanData, utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.employeeName = loanData.employeeName;
        vm.settingsName = LOAN_TYPE[loanData.loanType - 1].name;
        vm.closeModal = closeModal;
        var analyticsSaveTitle = 'Save Loan/Advanced Salary Input Modal';
        var analyticsSaveUrl = 'save-loan-or-advanced-salary'
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSaveTitle, analyticsSaveUrl, 'Save Loan/Advanced Salary Input In' + document.title, ANALYTICS_CONSTANT.open)

        function closeModal() {
            $uibModalInstance.close();
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteAbsentLeaveComPModalCtrl', ['$uibModalInstance','empData','toastrService','payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteAbsentLeaveComPModalCtrl]);

    /** @ngInject */
    function DeleteAbsentLeaveComPModalCtrl($uibModalInstance,empData, toastrService, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Delete Absent Leave Component Modal';
        var analyticsDeleteUrl = 'delete-absent-leave-component';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Absent Leave Component In' + document.title, ANALYTICS_CONSTANT.open)

        vm.delete = deleteData;

        function deleteData() {
            payrollManagementService.deleteSingleAdditionalComponent(empData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Absent Leave Component In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close(data);
                toastrService.showSuccessToastr("Delete Additional Component Successful");
            },function (error) {
                toastrService.showErrorToastr("Could not delete document: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteAdditionalPayCompModalCtrl', ['$uibModalInstance','empData','toastrService','payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteAdditionalPayCompModalCtrl]);

    /** @ngInject */
    function DeleteAdditionalPayCompModalCtrl($uibModalInstance,empData, toastrService, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Delete Additional Component Modal';
        var analyticsDeleteUrl = 'delete-additional-component';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Additional Component In' + document.title, ANALYTICS_CONSTANT.open)

        vm.delete = deleteData;

        function deleteData() {
            payrollManagementService.deleteSingleAdditionalComponent(empData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Additional Component In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close(data);
                toastrService.showSuccessToastr("Delete Additional Component Successful");
            },function (error) {
                toastrService.showErrorToastr("Could not delete document: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.bankPaymentAdvice')
        .controller('IndividualBankPaymentAdviceCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'utilService', 'employeeService', 'toastrService', 'payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', IndividualBankPaymentAdviceCtrl]);

    /** @ngInject */
    function IndividualBankPaymentAdviceCtrl($scope, $stateParams, $state, $timeout, authService, utilService, employeeService, toastrService, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var loggedInUser = authService.getLoggedInUser();

        vm.isDataLoaded = false;
        vm.bankId = $stateParams.bankId;
        vm.monthlySalaryId = $stateParams.monthlySalaryId;
        vm.isUpdating = false;
        vm.selectedRowForUpdate = null;

        vm.rowsPerPage = 50;
        vm.total = null;
        vm.offset = 0;
        vm.excelUrl = "";
        vm.pdfUrl = "";
        vm.loggedInUser = authService.getLoggedInUser();
        vm.searchParams = {};

        vm.search = search;
        vm.openUpdateState = openUpdateState;
        vm.saveUpdate = saveUpdate;
        vm.recalculateNetPayment = recalculateNetPayment;

        vm.filterConfig = {
            companyFilter                  : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            officeFilter                   : {
                show : loggedInUser.isCompanyAdmin || loggedInUser.isGroupAdmin
            },
            departmentFilter               : {
                show        : !loggedInUser.isGroupAdmin,
                collapsible : false
            },
            designationFilter              : {
                show : !loggedInUser.isGroupAdmin
            },
            shiftGroupFilter               : {
                show : !loggedInUser.isGroupAdmin
            },
            genderFilter                   : {
                show : !loggedInUser.isGroupAdmin
            },
            employmentTypeFilter           : {
                show : !loggedInUser.isGroupAdmin
            },
            workplaceFilter                : {
                show : !loggedInUser.isGroupAdmin
            },
            lineManagerFilter              : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            hrManagerFilter                : {
                show : (loggedInUser.isHrManager || loggedInUser.isAdmin) && !vm.isGroupAdmin
            },
            statusFilter                   : {
                show : false
            },
            componentFilter                : {
                show : false,
            },
            absenceTypeFilter              : {
                show : false,
            },
            monthYearPickerFrom            : {
                show : false
            },
            monthYearPickerTo              : {
                show : false
            },
            monthYearPickerSalary          : {
                show : false
            },
            monthYearPickerComparison      : {
                show : false
            },
            excelDownloadButton            : {
                show : true,
            },
            pdfDownloadButton              : {
                show : false,
            },
            addButton                      : {
                show : false,
            },
            uploadButton                   : {
                show : false,
            },
            downloadDemoExcelButton        : {
                show : false,
            },
            downloadBankAdviceLetterButton : {
                show : false,
            },
            deleteButton                   : {
                show : false,
            },
            sortKey                        : {
                show : false
            },
            rowPerPage                     : {
                show : false
            },
            searchByNameIdRfid             : {
                show      : true,
                showLabel : true
            },
            filterByNetPayment             : {
                show : true
            }
        };

        function search(searchParams) {
            modifyParams(searchParams)
            vm.isDataLoaded = false;
            payrollManagementService.getBankPaymentAdviceForSelectedMonth(vm.searchParams, vm.bankId, vm.monthlySalaryId).then(function (data) {
                // vm.excelUrl = attendanceService.getDetailedMonthlyReportExcelUrl(vm.searchParams);
                // vm.pdfUrl = attendanceService.getDetailedMonthlyReportPdfUrl(vm.searchParams);
                vm.bankPaymentAdviceList = data.payments;
                vm.isDataLoaded = true;
                vm.numberOfPages = data.totalPages;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                vm.selectedPage = 0;
                vm.total = data.totalRecords;
                vm.excelUrl = payrollManagementService.getBankPaymentExcelUrlForSelectedMonth(vm.bankId, vm.monthlySalaryId, vm.searchParams);
                $scope.$broadcast("refreshFixedColumns");
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }
            }
        }

        function openUpdateState(index) {
            analyticsService.sendData(ANALYTICS_CONSTANT.edit, document.title + ' - Edit Action', '', 'Edit In' + document.title, ANALYTICS_CONSTANT.edit)
            vm.bankPaymentAdviceList[index].updateState = true;
        }

        function recalculateNetPayment(selectedRow) {
            vm.bankPaymentAdviceList[selectedRow].cashPayment = vm.bankPaymentAdviceList[selectedRow].netPayment - vm.bankPaymentAdviceList[selectedRow].bankPayment;
        }

        function saveUpdate(updatedData) {
            analyticsService.sendData(ANALYTICS_CONSTANT.update, document.title + ' - Update Action', '', 'Update In' + document.title, ANALYTICS_CONSTANT.update)
            if (updatedData.bankPayment > updatedData.netPayment)
                return toastrService.showErrorToastr('Bank payment can not be greater than net payment');
            else if (updatedData.cashPayment > updatedData.netPayment)
                return toastrService.showErrorToastr('Cash payment can not be greater than net payment');
            else if (updatedData.bankPayment < 0)
                return toastrService.showErrorToastr('Bank payment can not be negative');
            else if (updatedData.cashPayment < 0)
                return toastrService.showErrorToastr('Cash payment can not be negative');
            var data = {
                paymentId   : updatedData.bankPaymentId,
                bankPayment : updatedData.bankPayment
            }
            payrollManagementService.updateIndividualBankPayment(data).then(function () {
                toastrService.showSuccessToastr('Update Successful!');
                search();
            }, function (error) {
                toastrService.showErrorToastr('Error:' + error, '', 5000);
            });
        }


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.loanManagement')
        .controller('EditLoanOrSalaryDetailsCtrl', ['$scope', '$stateParams','$uibModal','$state', '$timeout', 'authService', 'employeeService', 'toastrService', 'loanManagementService', 'MONTH_NAMES','LOAN_TYPE','utilService', EditLoanOrSalaryDetailsCtrl]);

    /** @ngInject */
    function EditLoanOrSalaryDetailsCtrl($scope, $stateParams, $uibModal, $state, $timeout, authService, employeeService, toastrService, loanManagementService, MONTH_NAMES,LOAN_TYPE,utilService) {
        var vm = this;

        vm.isDataLoaded = false;
        vm.loanType = angular.copy(LOAN_TYPE);
        if($stateParams.employeeInfo==null){
            $state.go('payroll.loanManagement')
            return;
        }
        vm.selectedEmployeeInfo = $stateParams.employeeInfo;
        vm.selectedEmployeeInfo.requestedAt = moment(vm.selectedEmployeeInfo.requestedAt);
        vm.selectedEmployeeInfo.disbursedAt = moment(vm.selectedEmployeeInfo.disbursedAt);
        vm.selectedLoanType = vm.selectedEmployeeInfo.type;
        // console.log(vm.selectedEmployeeInfo)
        vm.selectedMonth = new Date(vm.selectedEmployeeInfo.startYear,vm.selectedEmployeeInfo.startMonth-1,1);

        vm.datePickerOptions = {
            singleDatePicker : true,
            // startDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };
        vm.monthPickerInstallment = {};
        vm.monthPickerInstallment.opened = false;
        vm.monthPickerInstallment.format = "MMM yyyy";

        vm.monthPickerInstallment.options = {
            datepickerMode : 'month',
            minDate : new Date(vm.selectedEmployeeInfo.startYear, vm.selectedEmployeeInfo.startMonth, 1),
            // maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };

        vm.openMonthPickerInstallment = openMonthPickerInstallment;
        vm.editCurrentLoan = editCurrentLoan;

        function init(){
            if(!vm.selectedEmployeeInfo)$state.go('payroll.loanManagement');

            loanManagementService.getProfileWithLoanInfo(vm.selectedEmployeeInfo.employeeId).then(function (data){
                vm.previousLoanInfo = data;
                vm.previousLoan=data.loanAmount.toLocaleString();
                vm.previousRemainingLoan = data.remainingAmount.toLocaleString();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee data, " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }
        init();

        function openMonthPickerInstallment() {
            vm.monthPickerInstallment.opened = true;
        }

        function editCurrentLoan(){
            var params = {
                loanId: vm.selectedEmployeeInfo.id,
                type: vm.selectedEmployeeInfo.type,
                requestedAt: Number(vm.selectedEmployeeInfo.requestedAt.format('x')),
                disbursedAt: Number(vm.selectedEmployeeInfo.disbursedAt.format('x')),
                amount: vm.selectedEmployeeInfo.amount,
                instalmentCount: vm.selectedEmployeeInfo.instalmentCount,
                emiStartMonth: vm.selectedMonth.getMonth() + 1,
                emiStartYear: vm.selectedMonth.getFullYear(),
                remarks:vm.remarks,
            }
            loanManagementService.editCurrentLoan(params).then(function (data){
                toastrService.showSuccessToastr("Edit Loan Successful", "", 5000);
                $state.go('payroll.loanManagement');
            },function (error){
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            })
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundMember')
        .controller('AddPFMemberModalCtrl', ['$q','$uibModalInstance', 'employeeService', 'toastrService','memberInfo','providentFundService', 'analyticsService', 'ANALYTICS_CONSTANT', AddPFMemberModalCtrl]);

    /** @ngInject */
    function AddPFMemberModalCtrl($q,$uibModalInstance, employeeService, toastrService,memberInfo,providentFundService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.memberInfo = memberInfo.employeeInfo;
        vm.addMemberBtnClicked = false;
        vm.remarks = '';
        vm.membershipStartDate = moment();

        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            maxDate : moment(),
            autoApply : true,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        var analyticsCreateTitle = 'Add PF Member Modal';
        var analyticsCreateUrl = 'add-pf-member';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Add PF Member In' + document.title, ANALYTICS_CONSTANT.add)

        vm.addPFMember = addPFMember;

        function addPFMember(){
            toastrService.clearPreviousToastr();
            vm.addMemberBtnClicked = true;

            var data = {
                employeeId : vm.memberInfo.id,
                membershipDate : vm.membershipStartDate.format('x'),
                remarks : vm.remarks
            };
            providentFundService.addPFMember(data).then(function(response){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Add', analyticsCreateUrl + '/add', 'Add PF Member In' + document.title, ANALYTICS_CONSTANT.add)
                toastrService.showSuccessToastr('Successfully added member');
                vm.addMemberBtnClicked = false;
                $uibModalInstance.close();
            },function(error){
                toastrService.showErrorToastr('Error:' + error, '', 5000);
                vm.addMemberBtnClicked = false;
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundAccountManagement')
        .controller('ProvidentFundAccountDetailsCtrl', ['$scope','$state','$stateParams','$q','$uibModal', 'utilService', 'toastrService', 'providentFundService', 'analyticsService', 'ANALYTICS_CONSTANT', ProvidentFundAccountDetailsCtrl]);

    /** @ngInject */
    function ProvidentFundAccountDetailsCtrl($scope,$state, $stateParams, $q,$uibModal, utilService, toastrService, providentFundService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.employeeId = null;
        vm.pfAccountInfo = $stateParams.pfAccountInfo;

        if (!vm.pfAccountInfo) {
           $state.go("payroll.providentFundAccountManagement")
        }
        vm.selectedTab = "active";
        vm.isDataLoaded = false;
        vm.isRightSideDataLoaded = false;
        vm.selectedRowIndex = null;
        vm.isAnyRowSelected = false;
        vm.searchParams = {};
        vm.rowsPerPage = 10;
        vm.searchParams.pageNumber = 0;
        utilService.setRowsPerPage(vm.rowsPerPage);
        vm.searchParams.perPage  = utilService.getRowsPerPage();

        vm.selectedPage = 0;
        vm.searchKeyword = '';

        vm.paymentDuringTheYearClicked = false;
        vm.forfeitureForTheYearCLicked = false;

        vm.yearPickerFrom = {};
        vm.yearPickerFrom.opened = false;
        vm.yearPickerFrom.format = "yyyy";
        vm.yearPickerFrom.options = {
            datepickerMode : 'year',
            minDate : new Date(2020,1,1),
            maxDate : new Date(),
            minMode : 'year',
            maxMode : 'year'
        };
        vm.yearPickerTo = {};
        vm.yearPickerTo.opened = false;
        vm.yearPickerTo.format = "yyyy";
        vm.yearPickerTo.options = {
            datepickerMode : 'year',
            minDate : new Date(2020,1,1),
            maxDate : new Date(),
            minMode : 'year',
            maxMode : 'year'
        };



        vm.switchTab = switchTab;
        vm.openYearPickerFrom = openYearPickerFrom;
        vm.openYearPickerTo = openYearPickerTo;
        vm.openClosePFAccountingYearModal = openClosePFAccountingYearModal;
        vm.openUploadInterestModal = openUploadInterestModal;
        vm.showMemberInfoInTheRightColumn = showMemberInfoInTheRightColumn;
        vm.searchByNameId = searchByNameId;
        vm.exportAsExcel = exportAsExcel;
        vm.getDifference = getDifference;
        vm.savePaymentDuringTheYear = savePaymentDuringTheYear;
        vm.saveForfeitureForTheYear = saveForfeitureForTheYear;
        vm.getYearlyAccountDetailsOfAnOffice = getYearlyAccountDetailsOfAnOffice;

        function init(){
             getYearlyAccountDetailsOfAnOffice();
             if(vm.pfAccountInfo){
                 getAccountYearById()
             }
        }
        init();

        function searchByNameId(){
            analyticsService.sendData(ANALYTICS_CONSTANT.search, '', '', 'Search In' + document.title, ANALYTICS_CONSTANT.search)
            getYearlyAccountDetailsOfAnOffice();
        }

        function getYearlyAccountDetailsOfAnOffice(searchParams){
            if(vm.pfAccountInfo){
                resetSelectedRowValue();
                vm.isDataLoaded = false;
                vm.searchParams.keyword = vm.searchKeyword;
                vm.searchParams.status = getStatus();
                modifyParams(searchParams);
                providentFundService.getYearlyAccountDetails(vm.pfAccountInfo.accountId, vm.searchParams).then(function(data){
                    vm.yearlyAccountDetails = data.employees;
                    vm.excelUrl = providentFundService.getAccountManagementExcel(vm.pfAccountInfo.accountId);
                    vm.total = data.totalRecords;
                    vm.numberOfPages = data.totalPages;
                    vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
                    vm.selectedPage = data.currentPage;
                    vm.isDataLoaded = true;
                    $scope.$broadcast("refreshFixedColumns");
                },function (error) {
                    toastrService.showErrorToastr('Error: ' + error, '', 5000);
                    vm.isDataLoaded = true;
                });
            }
        }

        function modifyParams(searchParams) {
            if (typeof searchParams == 'object') {
                vm.searchParams = searchParams;
            } else {
                if (searchParams == 'prev') {
                    vm.searchParams.pageNumber--;
                } else if (searchParams == 'next') {
                    vm.searchParams.pageNumber++;
                } else if (!isNaN(searchParams)) {
                    vm.searchParams.pageNumber = searchParams;
                }else if (!searchParams) {
                    vm.searchParams.pageNumber = 0;
                }
            }
        }

        function getAccountYearById(){
            providentFundService.getInterestUploadStatus(vm.pfAccountInfo.accountId).then(function(data){
                vm.accountingYear = data.accountingYear;
                vm.accountInfo = data;
                vm.isInterestUploaded = data.interestUploaded;
                vm.selectedYearFrom = new Date(vm.accountInfo.startDate);
                vm.selectedYearTo = new Date(vm.accountInfo.endDate);
            })
        }

        function switchTab(tabName){
            vm.selectedTab = tabName;
            getYearlyAccountDetailsOfAnOffice();
        }

        function showMemberInfoInTheRightColumn(index, employeeId){
            vm.employeeId = employeeId;
            vm.params= {
                yearlyAccountId : vm.pfAccountInfo.accountId
            }

            if (employeeId){
                vm.selectedRowIndex = index;
                vm.isAnyRowSelected = true;
                getAccountDetails(employeeId,vm.params);
            } else
                toastrService.showErrorToastr('Employee Id is not available', '', 5000);
        }

        function getAccountDetails(employeeId,params){
            vm.paymentDuringTheYearClicked = false;
            vm.forfeitureForTheYearCLicked = false;
            vm.isRightSideDataLoaded = false;
            providentFundService.getPFMemberAccountDetails(employeeId,params).then(function (data){
                vm.pfLoanDetails = data;
                vm.memberDetails = data.memberInfo;
                vm.pfDetails = data.openingBalance;
                vm.contributionDuringYear = data.contributionDuringTheYear;
                vm.isRightSideDataLoaded = true;

            },function (error){
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            });
        }

        function exportAsExcel(){
            if(vm.excelUrl != null && vm.excelUrl.trim() !== "") {
                window.open(vm.excelUrl, '_blank', '');
                analyticsService.sendData(ANALYTICS_CONSTANT.excelUrl, '', '', 'Download  Excel ' + $scope.vm.stateName, ANALYTICS_CONSTANT.downloadExcel)
            }
        }

        function openYearPickerFrom() {
            vm.yearPickerFrom.opened = true;
        }

        function openYearPickerTo() {
            vm.yearPickerTo.opened = true;
        }

        function getStatus(){
            if(vm.selectedTab == 'active')
                return 1;
            else
                return 0;
        }

        function getDifference(value1,value2){
            return Math.abs(value1 - value2);
        }

        function resetSelectedRowValue(){
            vm.selectedRowIndex = null;
            vm.isAnyRowSelected = false;
        }

        function savePaymentDuringTheYear(){
            var params = {
                employeeId : vm.memberDetails.employeeInfo.id,
                separationPayment : vm.memberDetails.separationPayment,
                forfeitedAmount : vm.memberDetails.forfeiture
            }
            providentFundService.savePaymentDuringTheYear(params).then(function(){
                toastrService.showSuccessToastr('Separation Payment upload successfully', '', 5000);
                getAccountDetails(vm.employeeId,vm.params);
            },function(error){
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            })
        }

        function saveForfeitureForTheYear(){
            var params = {
                employeeId : vm.memberDetails.employeeInfo.id,
                separationPayment : vm.memberDetails.separationPayment,
                forfeitedAmount : vm.memberDetails.forfeiture
            }
            providentFundService.saveForfeitureForTheYear(params).then(function(){
                toastrService.showSuccessToastr('Forfeited amount upload successfully', '', 5000);
                getAccountDetails(vm.employeeId,vm.params);
            },function(error){
                toastrService.showErrorToastr('Error: ' + error, '', 5000);
            })
        }

        function openClosePFAccountingYearModal(memberInfo){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/payroll/providentFund/providentFundAccountManagement/modals/closePFAccountingYearModal/closePFAccountingYear.modal.html',
                size        : 'md',
                controller  : 'ClosePFAccountingYearModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    accountInfo:function () {
                        return{
                            accountYear: vm.pfAccountInfo.accountingYear,
                            accountId: vm.pfAccountInfo.accountId
                        }
                    }
                }
            }).result.then(function (){
                vm.pfAccountInfo.isClosed = true
            });
        }

        function openUploadInterestModal(){
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/payroll/providentFund/providentFundAccountManagement/modals/uploadInterestYear/uploadInterest.modal.html',
                size        : 'md',
                controller  : 'UploadInterestModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    accountInfo:function () {
                        return{
                            accountYear: vm.pfAccountInfo.accountingYear,
                            accountId: vm.pfAccountInfo.accountId
                        }
                    }
                }
            }).result.then(function (){
                // getAccountDetails(vm.employeeId,vm.params);
                vm.isAnyRowSelected = false;
                getAccountYearById();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ManualEntryModalCtrl', ['$uibModalInstance', 'attendanceService', 'toastrService', 'deviceService','authService','utilService','userId', 'analyticsService','$scope', 'ANALYTICS_CONSTANT', ManualEntryModalCtrl]);

    /** @ngInject */
    function ManualEntryModalCtrl($uibModalInstance, attendanceService, toastrService,deviceService,authService,utilService, userId, analyticsService, $scope, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Manual Entry Modal';
        var analyticsModalUrl = 'manual-entry';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Manual Entry In' + document.title, ANALYTICS_CONSTANT.open);
        vm.allocatedDeviceList = [];
        vm.selectedDevice = [];
        vm.isOpen = false;
        vm.selectedType = "";
        vm.reason = "";
        vm.manualEntryFrom = moment();
        vm.manualEntryTo = moment();
        vm.missingPunchTime = moment();
        vm.manualEntryFromIsOpen =false;
        vm.manualEntryToIsOpen = false;
        vm.missingPunchTimeIsOpen = false;
        vm.fieldVisitDatePicker = {};
        vm.fieldVisitDatePicker.date = getInitialFromAndToDate();
        vm.fieldVisitDatePicker.options = {};
        vm.fieldVisitEntryTime = new Date(new Date().setHours(9, 0, 0, 0));
        vm.fieldVisitExitTime = new Date(new Date().setHours(17, 0, 0, 0));
        vm.area = null;
        vm.saveManualEntry = saveManualEntry;
        vm.saveMissingPunch = saveMissingPunch;
        vm.saveFieldVisit = saveFieldVisit;
        vm.saveButtonText = "Save Manual Entry";
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.entryDatePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            maxDate: moment(),                 
            minDate : vm.minDate,
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }            
        };


        vm.exitDatePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            maxDate: moment(),
            minDate : vm.minDate,
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }
        };

        $scope.$watch('vm.manualEntryFrom', function(){

            vm.exitDatePickerOptions.startDate = angular.copy(vm.manualEntryFrom);
            vm.exitDatePickerOptions.maxDate = angular.copy(vm.manualEntryFrom).add(24, 'hours');
            vm.exitDatePickerOptions.minDate = angular.copy(vm.manualEntryFrom);
            vm.manualEntryTo = angular.copy(vm.manualEntryFrom).add(24, 'hours');
            if(vm.exitDatePickerOptions.maxDate > moment()) {
                vm.exitDatePickerOptions.maxDate = moment();
                vm.exitDatePickerOptions.startDate = moment();
                vm.manualEntryTo = moment();
            }                        
        });

        vm.fieldVisitDatePicker.options = {
            minDate : vm.minDate,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        }

        vm.missingPunchDatePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            maxDate: moment(),                 
            minDate : vm.minDate,
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }            
        };

        function init() {
            vm.isOpen = false;
            getDevicesOfEmployee();
            resetButtonText();
        }

        function resetButtonText(){
            vm.saveButtonText = "Save Manual Entry";
        }

        function getDevicesOfEmployee() {
            deviceService.getDevicesOfEmployee(userId).then(function (data) {
                populateDeviceListDropdown(data);

            },function (error) {
                vm.allocatedDeviceList = [];
                return toastrService.showErrorToastr("Could not fetch allocations of employee because " + error, "", 5000);
            })
        }
        
        function saveMissingPunch() {
            toastrService.clearPreviousToastr();
            if(vm.selectedDevice.length == 0)
                return toastrService.showErrorToastr("Please select a device");
            if(vm.reason === null)
                return toastrService.showErrorToastr("Reason can not be empty");
            var data = {
                deviceId:vm.selectedDevice[0].id,
                employeeId : userId,
                entryTime : vm.missingPunchTime.format('x'),
                reason: vm.reason,
                type : 2
            };
            vm.saveButtonText = "Please wait ...";
            attendanceService.createManualEntry(data).then(function () {
                resetButtonText();
                toastrService.showSuccessToastr("Manual entry applied");
                $uibModalInstance.close();
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Save Missing Punch', analyticsModalUrl + '/save-missing-punch', 'Save Missing Punch In' + document.title, ANALYTICS_CONSTANT.save)

            },function (error) {
                resetButtonText();
                toastrService.showErrorToastr("Could not create manual entry " + error, "", 5000);
                // $uibModalInstance.dismiss();
            });
        }

        function saveManualEntry() {
            toastrService.clearPreviousToastr();
            if (vm.reason == null || vm.reason == '')
                return toastrService.showErrorToastr("Please enter reason");
            if (vm.manualEntryFrom == null || vm.manualEntryTo == null)
                return toastrService.showErrorToastr("Please select both entry and exit time");
            if (vm.manualEntryFrom >= vm.manualEntryTo)
                return toastrService.showErrorToastr("Entry time cannot be after exit time");
            // if (utilService.checkSameDate(vm.manualEntryFrom, vm.manualEntryTo))
            //     return toastrService.showErrorToastr("Entry time and exit time must be in the same day")
            var data = {
                employeeId: userId,
                entryTime: vm.manualEntryFrom.format('x'),
                exitTime: vm.manualEntryTo.format('x'),
                reason: vm.reason,
                type : 1
            };
            vm.saveButtonText = "Please wait ...";
            attendanceService.createManualEntry(data).then(function () {
                resetButtonText();
                toastrService.showSuccessToastr("Manual entry applied");
                $uibModalInstance.close();
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Save Manual Entry', analyticsModalUrl + '/save-manual-entry', 'Save Manual Entry In' + document.title, ANALYTICS_CONSTANT.save)

            },function (error) {
                resetButtonText();
                toastrService.showErrorToastr("Could not create manual entry " + error, "", 5000);
                // $uibModalInstance.dismiss();
            });
        }

        function saveFieldVisit() {
            toastrService.clearPreviousToastr();
            if(!vm.reason)
                return toastrService.showErrorToastr("Reason cannot be empty");
            if(!vm.area)
                return toastrService.showErrorToastr("Area cannot be empty");
            if(vm.fieldVisitEntryTime == null || vm.fieldVisitExitTime == null)
                return toastrService.showErrorToastr("Please select valid from and to times");
            var startDate = new dayjs(Number(vm.fieldVisitDatePicker.date.startDate.format('x')));
            var endDate = new dayjs(Number(vm.fieldVisitDatePicker.date.endDate.format('x')));
            var startTime = new dayjs(Number(vm.fieldVisitDatePicker.date.startDate.format('x'))).hour(Number(vm.fieldVisitEntryTime.getHours())).minute(Number(vm.fieldVisitEntryTime.getMinutes())).second(0);
            var endTime = new dayjs(Number(vm.fieldVisitDatePicker.date.startDate.format('x'))).hour(Number(vm.fieldVisitExitTime.getHours())).minute(Number(vm.fieldVisitExitTime.getMinutes())).second(0);

            var data = {
                employeeId: userId,
                startDate: startDate.startOf('day').valueOf(),
                endDate: endDate.startOf('day').valueOf(),
                entryTime: startTime.valueOf(),
                exitTime: endTime.valueOf(),
                reason: vm.reason,
                type: 3,
                area : vm.area,
                forceApproval: false
            };

            vm.saveButtonText = "Please wait ...";
            attendanceService.createManualEntry(data).then(function () {
                resetButtonText();
                toastrService.showSuccessToastr("Manual entry applied");
                $uibModalInstance.close();
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Save Field Visit', analyticsModalUrl + '/save-field-visit', 'Save Field Visit In' + document.title, ANALYTICS_CONSTANT.save)

            },function (error) {
                resetButtonText();
                toastrService.showErrorToastr("Could not create manual entry " + error, "", 5000);
                // $uibModalInstance.dismiss();
            });
        }

        function populateDeviceListDropdown(deviceList){
            for(var i =0; i<deviceList.length; i++){
                var display = {
                    label: (deviceList[i].identifier +' - '+ deviceList[i].location).toString(),
                    identifier: deviceList[i].identifier,
                    id: deviceList[i].id
                };
                vm.allocatedDeviceList.push(display);
            }

        }

        

        function getInitialFromAndToDate() {
            return {
                'startDate': moment(),
                'endDate': moment()
            };
        }

        init();
        

    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('CancelLeaveLogCtrl', ['leaveManagementService','$uibModalInstance','toastrService','leaveLogId', 'analyticsService', 'ANALYTICS_CONSTANT', CancelLeaveLogCtrl]);

    /** @ngInject */
    function CancelLeaveLogCtrl(leaveManagementService,$uibModalInstance,toastrService,leaveLogId, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Pending Approvals - Cancel Leave Log Modal';
        var analyticsDeleteUrl = 'pending-approvals/cancel-leave-log';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Cancel Leave Log Pending Approval In' + document.title, ANALYTICS_CONSTANT.open);
        vm.cancelLeave = cancelLeave;

        function cancelLeave() {
            leaveManagementService.cancelLeaveLog(leaveLogId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Cancel', analyticsDeleteUrl + '/cancel', 'Cancel Leave Log Pending Approval In' + document.title, ANALYTICS_CONSTANT.cancel)
                toastrService.showSuccessToastr("Cancelled Successfully");
                $uibModalInstance.close()
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ManualEntryCancelModalCtrl', ['employeeService','$uibModalInstance','toastrService','manualEntryApplicationId','manualEntryType', 'analyticsService', 'ANALYTICS_CONSTANT', ManualEntryCancelModalCtrl]);

    /** @ngInject */
    function ManualEntryCancelModalCtrl(employeeService,$uibModalInstance,toastrService,manualEntryApplicationId,manualEntryType, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isCreating  = false;
        vm.manualEntryType = manualEntryType;
        var analyticsDeleteTitle = 'Pending Approvals - Manual Entry Cancel Modal';
        var analyticsDeleteUrl = 'pending-approvals/cancel-manual-entry';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Cancel Manual Entry Pending Approval In ' + document.title, ANALYTICS_CONSTANT.open);
        vm.cancelManualEntryApplication = cancelManualEntryApplication;

        function cancelManualEntryApplication() {
            vm.isCreating  = true;

            employeeService.cancelManualEntryApplication(manualEntryApplicationId).then(function () {
                vm.isCreating = false;
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Cancel', analyticsDeleteUrl + '/cancel', 'Cancel Manual Entry Pending Approval In ' + document.title, ANALYTICS_CONSTANT.delete)
                toastrService.showSuccessToastr("Cancelled Successfully");
                $uibModalInstance.close()
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EditLeaveModalCtrl', ['employeeService','$stateParams','$uibModalInstance','authService','utilService', 'toastrService','leaveManagementService', 'employeeId','remainingLeaveService','leaveLog','leavePolicyService', 'analyticsService', 'ANALYTICS_CONSTANT', EditLeaveModalCtrl]);

    /** @ngInject */
    function EditLeaveModalCtrl(employeeService,$stateParams,$uibModalInstance, authService, utilService, toastrService,leaveManagementService,employeeId,remainingLeaveService,leaveLog,leavePolicyService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.datePicker = {};
        vm.datePicker.options =  {};
        vm.datePicker.date = {};
        vm.reason = null;
        vm.selectedCategory = null;
        vm.leaveCategoryList = null;
        vm.selectedTypeId = "";
        vm.selctedLeaveHalf = null;
        vm.leaveDate = new Date();
        vm.file = null;
        vm.remainingLeavesList = [];
        vm.isRemainingLeaveDataLoaded = false;
        var analyticsEditTitle = 'Pending Approvals - Edit Leave Log Modal';
        var analyticsEditUrl = 'pending-approvals/edit-leave-log';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Leave Log Pending Approval In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateLeaveApplication = updateLeaveApplication;
        vm.openCalendar = openCalendar;

        function init() {
            vm.datePicker.options = {
                applyClass: 'btn-green',
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    format: "D/MMM/YY", //will give you 6-Jan-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                }
            };
            vm.datePicker.date.startDate = new Date(leaveLog.startDate);
            vm.datePicker.date.endDate = new Date(leaveLog.endDate);
            vm.leaveDate = new Date(leaveLog.startDate);
            vm.reason = leaveLog.reason;
            remainingLeaveService.getAllRemainingLeavesOfEmployee(employeeId,new Date().getFullYear()).then(function (remainingLeavesList) {
                vm.isRemainingLeaveDataLoaded = true;
                vm.remainingLeavesList = remainingLeavesList;
            });
            leavePolicyService.getLeavePolicyOfEmployee(employeeId).then(function (data) {
                vm.leaveCategoryList = data.leavePolicy.leavePerCategories.map(function (p) {
                    return p.leaveCategory;
                });
                vm.selectedCategory = vm.leaveCategoryList.find(function (category) {
                    return category.id == leaveLog.categoryId;
                })
            });
            vm.selectedTypeId = angular.copy(leaveLog.type).toString();
        }

        init();

        function updateLeaveApplication() {
            toastrService.clearPreviousToastr();
            if(vm.reason === null)
                return toastrService.showErrorToastr("Reason cannot be empty");
            if(vm.selectedCategory == null && vm.selectedCategory==='')
                return toastrService.showErrorToastr("Select a leave category");
            if(authService.getLoggedInUser().id !== parseInt(employeeId) && !authService.isAdmin())
                return toastrService.showErrorToastr("Users can only apply for leave for themselves");
            if(vm.selectedTypeId == 2 && (vm.selctedLeaveHalf != 1 || vm.selctedLeaveHalf!=2))
                var data = {};
            if(vm.selectedTypeId == 1){
                data = {
                    startDate:vm.datePicker.date.startDate.valueOf() ,
                    endDate: vm.datePicker.date.endDate.valueOf(),
                    leaveCategoryId : vm.selectedCategory.id,
                    reason : vm.reason,
                };
                if(!utilService.checkIfValidDateRange(vm.datePicker.date.startDate,vm.datePicker.date.endDate))
                    return toastrService.showErrorToastr("Start day can not be before end date");
                if(!utilService.isTimeInCurrentYear(data.startDate)|| !utilService.isTimeInCurrentYear(data.endDate))
                    return toastrService.showErrorToastr("Times not in current year");
            }
            if(vm.selectedTypeId == 2){
                data = {
                    startDate:vm.leaveDate.valueOf() ,
                    endDate:null ,
                    leaveCategoryId : vm.selectedCategory.id,
                    reason : vm.reason,
                    leaveHalf : vm.selctedLeaveHalf
                };
            }

            leaveManagementService.updateLeave(leaveLog.id,data,vm.file).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Leave Log Pending Approval In' + document.title, ANALYTICS_CONSTANT.edit)
                $uibModalInstance.close();
            },function (error) {
                toastrService.showErrorToastr("Could not apply for leave because " + error);
            });
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EditManualEntryModalCtrl', ['$uibModalInstance', 'attendanceService', 'toastrService', 'deviceService','authService','userId','application', 'analyticsService', 'ANALYTICS_CONSTANT', EditManualEntryModalCtrl]);

    /** @ngInject */
    function EditManualEntryModalCtrl($uibModalInstance, attendanceService, toastrService,deviceService,authService, userId,application, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.allocatedDeviceList = [];
        vm.selectedDevice = [];
        vm.isOpen = false;
        vm.selectedType = application.typeText.split(" ")[0].toLowerCase();
        vm.reason = application.reason;

        vm.manualEntryFrom = moment(application.entryTime,'x');
        vm.manualEntryTo = moment(application.exitTime, 'x');
        vm.missingPunchTime = moment(application.entryTime,'x');
        vm.manualEntryFromIsOpen =false;
        vm.manualEntryToIsOpen = false;
        vm.missingPunchTimeIsOpen = false;
        vm.fieldVisitDate = moment(application.entryTime,'x');
        vm.fieldVisitEntryTime = new Date(application.entryTime);
        vm.fieldVisitExitTime = new Date(application.exitTime);

        vm.datePickerOptions = {
            singleDatePicker : true,
            //startDate : moment(),
            maxDate: moment(),
            minDate : vm.minDate,
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }
        };

        vm.fieldVisitDatePickerOptions = {
            singleDatePicker : true,
            //startDate : moment(),
            maxDate: moment(),
            minDate : vm.minDate,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        }
        var analyticsEditTitle = 'Pending Approvals - Edit Manual Entry Modal';
        var analyticsEditUrl = 'pending-approvals/edit-manual-entry';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Manual Entry Pending Approval In' + document.title, ANALYTICS_CONSTANT.open);

        vm.saveManualEntry = saveManualEntry;
        vm.saveMissingPunch = saveMissingPunch;
        vm.saveFieldVisit = saveFieldVisit;

        vm.saveButtonText = "Save Manual Entry";

        function init() {
            vm.isOpen = false;
            getDevicesOfEmployee();
            resetButtonText();

        }

        function resetButtonText(){
            vm.saveButtonText = "Save Manual Entry";
        }

        function getDevicesOfEmployee() {
            deviceService.getDevicesOfEmployee(userId).then(function (data) {
                populateDeviceListInEditDropdown(data);
            },function (error) {
                vm.allocatedDeviceList = [];
                toastrService.showErrorToastr("Could not fetch allocations of employee because " + error, "", 5000);
                 console.error("Could not fetch allocations of employee because " + error);
            })
        }

        function saveMissingPunch() {
            toastrService.clearPreviousToastr();
            if(vm.selectedDevice.length == 0)
                return toastrService.showErrorToastr("Please select a device");
            var data = {
                deviceId:vm.selectedDevice[0].id,
                employeeId : userId,
                entryTime : vm.missingPunchTime.format('x'),
                reason: vm.reason,
                type : 2
            };
            vm.saveButtonText = "Please wait ...";
            attendanceService.editManualEntry(data,application.id).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit Missing Punch', analyticsEditUrl + '/edit-missing-punch', 'Edit Missing Punch Pending Approval In ' + document.title, ANALYTICS_CONSTANT.edit)
                resetButtonText();
                toastrService.showSuccessToastr("Manual entry applied");
                $uibModalInstance.close();
            },function (error) {
                resetButtonText();
                toastrService.showErrorToastr("Could not create manual entry " + error, "", 5000);
                $uibModalInstance.dismiss();
            });
        }

        function saveManualEntry() {
            toastrService.clearPreviousToastr();
            if (vm.reason == null || vm.reason == '')
                return toastrService.showErrorToastr("Please enter reason");
            if (vm.manualEntryFrom == null || vm.manualEntryTo == null)
                return toastrService.showErrorToastr("Please select both entry and exit time");
            if (vm.manualEntryFrom >= vm.manualEntryTo)
                return toastrService.showErrorToastr("Entry time cannot be after exit time");
            var data = {
                employeeId: userId,
                entryTime: vm.manualEntryFrom.format('x'),
                exitTime: vm.manualEntryTo.format('x'),
                reason: vm.reason,
                type : 1
            };
            vm.saveButtonText = "Please wait ...";
            attendanceService.editManualEntry(data,application.id).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit Manual Entry', analyticsEditUrl + '/edit-manual-entry', 'Edit Manual Entry Pending Approval In ' + document.title, ANALYTICS_CONSTANT.edit)
                resetButtonText();
                toastrService.showSuccessToastr("Manual entry applied");
                $uibModalInstance.close();
            },function (error) {
                resetButtonText();
                toastrService.showErrorToastr("Could not create manual entry " + error ,"", 5000);
                $uibModalInstance.dismiss();
            });
        }

        function saveFieldVisit() {
            toastrService.clearPreviousToastr();
            if(!vm.reason) return toastrService.showErrorToastr("Reason cannot be empty");
            var startTime = new moment(vm.fieldVisitDate);
            var endTime = new moment(vm.fieldVisitDate);
            startTime.set({hour:vm.fieldVisitEntryTime.getHours(),minute:vm.fieldVisitEntryTime.getMinutes()});
            endTime.set({hour:vm.fieldVisitExitTime.getHours(),minute:vm.fieldVisitExitTime.getMinutes()})
            var data = {
                employeeId: userId,
                entryTime: startTime.format('x'),
                exitTime: endTime.format('x'),
                reason: vm.reason,
                type: 3
            };
            vm.saveButtonText = "Please wait ...";
            attendanceService.editManualEntry(data,application.id).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit Field Visit', analyticsEditUrl + '/edit-field-visit', 'Edit Field Visit Pending Approval In ' + document.title, ANALYTICS_CONSTANT.edit)
                resetButtonText();
                toastrService.showSuccessToastr("Manual entry applied");
                $uibModalInstance.close();
            },function (error) {
                resetButtonText();
                toastrService.showErrorToastr("Could not create manual entry " + error, "", 5000);
                $uibModalInstance.dismiss();
            });
        }
        function populateDeviceListInEditDropdown(deviceList){
            for(var i =0; i<deviceList.length; i++){
                var display = {
                    label: (deviceList[i].identifier +' - '+ deviceList[i].location).toString(),
                    identifier: deviceList[i].identifier,
                    id: deviceList[i].id,
                    ticked: (application.deviceId === deviceList[i].id)
                };
                vm.allocatedDeviceList.push(display);
            }
        }
        init();

    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('AddAddressModalCtrl', ['$uibModalInstance', 'employeeService', 'toastrService', 'userId', 'currentAddress', 'analyticsService', 'ANALYTICS_CONSTANT', AddAddressModalCtrl]);

    /** @ngInject */
    function AddAddressModalCtrl($uibModalInstance, employeeService, toastrService, userId, currentAddress, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsCreateTitle = 'Address - Add Address Modal';
        var analyticsCreateUrl = 'address/add-address';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Add Address In' + document.title, ANALYTICS_CONSTANT.open);
        vm.isAddressTypeAlreadyProvided = isAddressTypeAlreadyProvided;
        vm.addAddress = addAddress;

        function isAddressTypeAlreadyProvided (addressType) {
            if(!currentAddress || currentAddress.length <= 0) return false;
          for (var i = 0 ; i < currentAddress.length ; i++){
              if(addressType === currentAddress[i].type) {
                  return true;
              }
          }
          return false;
        }


        function addAddress(address, thana, district, type) {
            var data = {
                    "type": type,
                    "address": address,
                    "thana": thana,
                    "district": district
            };
            employeeService.createAddress(data,userId).then(function (address) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Add', analyticsCreateUrl + '/add', 'Add Address In' + document.title, ANALYTICS_CONSTANT.create);
                $uibModalInstance.close(address);
                toastrService.showSuccessToastr("New address added.");
            }, function (message) {
                // if (response.status > 0) {
                $uibModalInstance.dismiss("Failed to add new address." + message);
                console.error("Failed to add new address : " + message);
                toastrService.showErrorToastr("Failed to add new address. " + message, "", 5000);
                // }
            });
        };
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('AllowLineManagerShiftManagement', ['$uibModalInstance', 'currentValue', 'employeeService', 'toastrService', 'userId', 'userName', 'role', 'roleText', 'analyticsService', 'ANALYTICS_CONSTANT', AllowLineManagerShiftManagement]);

    /** @ngInject */
    function AllowLineManagerShiftManagement($uibModalInstance, currentValue, employeeService, toastrService, userId, userName, role, roleText, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Change ' + roleText + ' Modal';
        var analyticsModalUrl = 'change-' + roleText.toLowerCase().replace(' ', '-') + '-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Change ' + roleText + ' Role In' + document.title, ANALYTICS_CONSTANT.open);
        vm.currentValue = currentValue;
        vm.name = userName;
        vm.roleText = roleText;
        vm.userId = userId;
        vm.updateLineManagerRole = updateLineManagerRole;

        function updateLineManagerRole (newVal) {
            var data = {};
            data[role] = newVal;
            data["linemanager_id"] = vm.userId;
            return employeeService.toggleLineManagerShiftAssignment(data, userId).then(function () {
                $uibModalInstance.close(newVal);
                if(newVal){
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set ' + roleText, analyticsModalUrl + '/set', 'Set ' + roleText + " " + document.title, ANALYTICS_CONSTANT.set)
                }
                else{
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove ' + roleText, analyticsModalUrl + '/remove', 'Remove ' + roleText + " " + document.title, ANALYTICS_CONSTANT.remove)
                }
                toastrService.showSuccessToastr(newVal ? "Successfully made " + userName + " " + roleText + "." : "Successfully Removed " + userName +" from " + roleText + ".");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss();
                    console.error("Failed to update role: " + response.message);
                    toastrService.showErrorToastr("Failed to change role status. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ChangeSiteAdminRoleModalCtrl', ['$uibModalInstance', 'currentValue', 'siteManagementService', 'toastrService', 'userId', 'userName', 'role', 'roleText', 'analyticsService', 'ANALYTICS_CONSTANT', ChangeSiteAdminRoleModalCtrl]);

    /** @ngInject */
    function ChangeSiteAdminRoleModalCtrl($uibModalInstance, currentValue, siteManagementService, toastrService, userId, userName, role, roleText, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Change Site Admin Role Modal';
        var analyticsModalUrl = 'change-site-admin-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Change Site Admin Role In' + document.title, ANALYTICS_CONSTANT.open);
        vm.currentValue = currentValue;
        vm.name = userName;
        vm.roleText = roleText;
        vm.updateRole = updateRole;

        function updateRole (newVal) {
            if (newVal){
                var data = {
                    "employeeId":userId,
                    "isSiteAdmin":true
                }
                siteManagementService.saveSiteManagementRoles(data).then(function (response){
                    $uibModalInstance.close(newVal);
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set', analyticsModalUrl + '/set', 'Set Site Admin Role In' + document.title, ANALYTICS_CONSTANT.set)
                    toastrService.showSuccessToastr("Successfully made " + userName + " " + roleText + ".");
                },function (error){
                    console.log(error);
                    if (error) {
                        $uibModalInstance.dismiss();
                        console.error("Failed to update role: " + error);
                        toastrService.showErrorToastr("Failed to change role status. " + error);
                    }
                })
            }
            else {
                siteManagementService.deleteSiteManagementRoles(userId, 1).then(function (response){
                    $uibModalInstance.close();
                    toastrService.showSuccessToastr("Successfully removed " + userName + " from " + roleText + ".");
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove', analyticsModalUrl + '/remove', 'Remove Site Admin Role In' + document.title, ANALYTICS_CONSTANT.remove)


                    // console.log(response.message)
                },function (error){
                    // console.log(error)
                    // console.error("Failed to update role: " + error.message);
                    toastrService.showErrorToastr("Failed to change role status. " + error);
                    $uibModalInstance.dismiss();
                })
            }

            /*employeeService.changeManagerOrAdminRole(data, userId).then(function () {
                $uibModalInstance.close(newVal);
                toastrService.showSuccessToastr(newVal ? "Successfully made " + userName + roleText + "." : "Successfully Removed " + userName +" from " + roleText + ".");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss();
                    console.error("Failed to update role: " + response.message);
                    toastrService.showErrorToastr("Failed to change role status. " + response.message);
                }
            });*/
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ChangeSiteManagerRoleModalCtrl', ['$uibModalInstance', 'currentValue', 'siteManagementService', 'toastrService', 'userId', 'userName', 'role', 'roleText', 'analyticsService', 'ANALYTICS_CONSTANT', ChangeSiteManagerRoleModalCtrl]);

    /** @ngInject */
    function ChangeSiteManagerRoleModalCtrl($uibModalInstance, currentValue, siteManagementService, toastrService, userId, userName, role, roleText, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Change Site Manager Role Modal';
        var analyticsModalUrl = 'change-site-manager-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Change Site Manager Role In' + document.title, ANALYTICS_CONSTANT.open);
        vm.currentValue = currentValue;
        vm.name = userName;
        vm.roleText = roleText;
        vm.updateRole = updateRole;

        function updateRole (newVal) {
            if (newVal){
                var data = {
                    "employeeId":userId,
                    "isSiteManager":true
                }
                siteManagementService.saveSiteManagementRoles(data).then(function (response){
                    $uibModalInstance.close(newVal);
                    toastrService.showSuccessToastr("Successfully made " + userName + " " + roleText + ".");
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set', analyticsModalUrl + '/set', 'Set Site Manager Role In' + document.title, ANALYTICS_CONSTANT.set)

                },function (error){
                    if (error) {
                        $uibModalInstance.dismiss();
                        console.error("Failed to update role: " + error);
                        toastrService.showErrorToastr("Failed to change role status. " + error);
                    }
                })
            }
            else {
                siteManagementService.deleteSiteManagementRoles(userId, 2).then(function (response){
                    $uibModalInstance.close();
                    // console.log(response.message)
                    toastrService.showSuccessToastr("Successfully removed " + userName + " from " + roleText + ".");
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove', analyticsModalUrl + '/remove', 'Remove Site Manager Role In' + document.title, ANALYTICS_CONSTANT.remove)

                },function (error){
                        // console.log(error)
                        // console.error("Failed to update role: " + error.message);
                        toastrService.showErrorToastr("Failed to change role status. " + error);
                        $uibModalInstance.dismiss();
                })
            }

            /*employeeService.changeManagerOrAdminRole(data, userId).then(function () {
                $uibModalInstance.close(newVal);
                toastrService.showSuccessToastr(newVal ? "Successfully made " + userName + roleText + "." : "Successfully Removed " + userName +" from " + roleText + ".");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss();
                    console.error("Failed to update role: " + response.message);
                    toastrService.showErrorToastr("Failed to change role status. " + response.message);
                }
            });*/
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ChangeManagerOrAdminRoleModalCtrl', ['$uibModalInstance', 'currentValue', 'employeeService', 'toastrService', 'userId', 'userName', 'role', 'roleText', 'analyticsService', 'ANALYTICS_CONSTANT', ChangeManagerOrAdminRoleModalCtrl]);

    /** @ngInject */
    function ChangeManagerOrAdminRoleModalCtrl($uibModalInstance, currentValue, employeeService, toastrService, userId, userName, role, roleText, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Change ' + roleText + ' Modal';
        var analyticsModalUrl = 'change-' + roleText.toLowerCase().replace(' ', '-') + '-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Change ' + roleText + ' Role In' + document.title, ANALYTICS_CONSTANT.open);
        vm.currentValue = currentValue;
        vm.name = userName;
        vm.roleText = roleText;
        vm.updateRole = updateRole;

        function updateRole (newVal) {
            var data = {};
            data[role] = newVal;
            return employeeService.changeManagerOrAdminRole(data, userId).then(function () {
                $uibModalInstance.close(newVal);
                if(newVal){
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set ' + roleText, analyticsModalUrl + '/set', 'Set ' + roleText + " " + document.title, ANALYTICS_CONSTANT.set)
                }
                else{
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove ' + roleText, analyticsModalUrl + '/remove', 'Remove ' + roleText + " " + document.title, ANALYTICS_CONSTANT.remove)
                }
                // newVal ? analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set ' + roleText, analyticsModalUrl + '/set', 'Set ' + roleText + " " + document.title, ANALYTICS_CONSTANT.set) : analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove ' + roleText, analyticsModalUrl + '/remove', 'Remove ' + roleText + " " + document.title, ANALYTICS_CONSTANT.remove)
                toastrService.showSuccessToastr(newVal ? "Successfully made " + userName + " " + roleText + "." : "Successfully Removed " + userName +" from " + roleText + ".");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss();
                    console.error("Failed to update role: " + response.message);
                    toastrService.showErrorToastr("Failed to change role status. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ChangeStatusModalCtrl', ['$uibModalInstance', 'employeeService', 'empId', 'empName', 'changeStatusTo', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', ChangeStatusModalCtrl]);

    /** @ngInject */
    function ChangeStatusModalCtrl($uibModalInstance, employeeService, empId, empName, changeStatusTo, toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Change Employee Status Modal';
        var analyticsModalUrl = 'change-employee-status';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Change Employee Status In' + document.title, ANALYTICS_CONSTANT.open);
        vm.empId = null;
        vm.empName = null;
        vm.changeStatusTo = null;
        vm.changeStatusToText = null;
        vm.changeStatus = changeStatus;

        function init() {
            vm.empId = empId;
            vm.empName = empName;
            vm.changeStatusTo = changeStatusTo;
            vm.changeStatusToText = vm.changeStatusTo === 1 ? "Active" : "Inactive";
        }

        init();

        function changeStatus() {
            return employeeService.changeStatus(vm.empId, changeStatusTo)
                .then(function () {
                    if(vm.changeStatusTo === 1 ){
                        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Active', analyticsModalUrl + '/active', 'Active Employee Status In' + document.title, ANALYTICS_CONSTANT.change);
                    }
                    else{
                        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Inactive', analyticsModalUrl + '/inactive', 'Inactive Employee Status In ' + document.title, ANALYTICS_CONSTANT.change);
                    }
                    // vm.changeStatusTo === 1 ? analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Active', analyticsModalUrl + '/active', 'Active Employee Status In' + document.title, ANALYTICS_CONSTANT.change) : analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Inactive', analyticsModalUrl + '/inactive', 'Inactive Employee Status In ' + document.title, ANALYTICS_CONSTANT.change)
                    toastrService.showSuccessToastr("Status changed successfully");
                    return $uibModalInstance.close(changeStatusTo);
                }, function (error) {
                    toastrService.showErrorToastr("Could not change status: " + error, "", 5000 );
                    return $uibModalInstance.dismiss();
                });
        }


    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.tasks')
        .controller('CreateTaskFromProfileModalCtrl', ['$uibModalInstance','authService','projectService', 'taskService','utilService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateTaskFromProfileModalCtrl]);

    /** @ngInject */
    function CreateTaskFromProfileModalCtrl($uibModalInstance,authService,projectService, taskService,utilService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Add Task Modal';
        var analyticsModalUrl = 'add-task';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Add Task In' + document.title, ANALYTICS_CONSTANT.open);
        vm.create = {};
        vm.create.name = null;
        vm.create.description = null;
        vm.create.employeeIdList = [];
        vm.create.projectWorkId = null;
        vm.create.startTime = moment();
        vm.create.endTime = moment();

        vm.allProjects = [];
        vm.employeeList = [];

        vm.selectedProject = null;

        vm.minDate = new Date(utilService.getMinimumDate());
        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            minDate : vm.minDate,
            timePicker : false,
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.createTask = createTask;

        init();

        function init() {
            getAllProjects();
        }

        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
                console.error('Project Fetching failed error: '+message);
            });
        }

        function createTask() {
            toastrService.clearPreviousToastr();
            if(vm.create.name === null)
                return toastrService.showErrorToastr("Please add a name");
            vm.selectedProject = vm.selectedProject[0];
            if (vm.selectedProject.id == null)
                return toastrService.showErrorToastr("Please select a project");
            var data =
                {
                    'name' : vm.create.name,
                    'description': vm.create.description,
                    'startTime' : vm.create.startTime.valueOf(),
                    'endTime' : vm.create.endTime.valueOf(),
                    'employeeIdList' : [],
                    'projectWorkId' : vm.selectedProject.id,
                    'status' : 1
                };
            taskService.createTask(data).then(function (taskList) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Add', analyticsModalUrl + '/add', 'Add Task In' + document.title, ANALYTICS_CONSTANT.add)
                toastrService.showSuccessToastr("Task created.");
                $uibModalInstance.close(taskList);
            },function (error) {
                toastrService.showErrorToastr("Failed to create task - " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteAddressModalCtrl', ['$uibModalInstance', 'employeeService', 'toastrService', 'currentAddress', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteAddressModalCtrl]);

    /** @ngInject */
    function DeleteAddressModalCtrl($uibModalInstance, employeeService, toastrService, currentAddress, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.deleteAddress = deleteAddress;
        var analyticsDeleteTitle = 'Address - Delete Address Modal';
        var analyticsDeleteUrl = 'address/delete-address';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Address In' + document.title, ANALYTICS_CONSTANT.open);
        function deleteAddress() {
            employeeService.deleteAddress(currentAddress.id).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Address In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close();
                toastrService.showSuccessToastr("Address deleted.");
            }, function (message) {
                toastrService.showErrorToastr("Failed to add new address. " + message, "", 5000);
            });
        };
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DocumentUploadModalCtrl', ['$uibModalInstance', 'employeeService', 'toastrService', 'userId', 'analyticsService', 'ANALYTICS_CONSTANT', DocumentUploadModalCtrl]);

    /** @ngInject */
    function DocumentUploadModalCtrl($uibModalInstance, employeeService, toastrService, userId, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsCreateTitle = 'Employee Documents - Upload Employee Documents Modal';
        var analyticsCreateUrl = 'employee-documents/upload-employee-documents';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Upload Employee Documents In' + document.title, ANALYTICS_CONSTANT.open);

        vm.uploadDocument = uploadDocument;

        function uploadDocument (description, documentType, file) {
            toastrService.clearPreviousToastr();
            if(!documentType)
                return toastrService.showErrorToastr("Please enter a document type");
            if(!description)
                return toastrService.showErrorToastr("Please enter a description");
            if(!file)
                return toastrService.showErrorToastr("File not selected or size limit exceeded.");
            employeeService.uploadDocument(description, documentType, file, userId).then(function (document) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Upload', analyticsCreateUrl + '/upload', 'Upload Employee Documents In' + document.title, ANALYTICS_CONSTANT.upload)
                $uibModalInstance.close(document);
                toastrService.showSuccessToastr("Document Uploaded");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload document. " + response.message);
                    console.error("Failed to upload document: " + response.message);
                    toastrService.showErrorToastr("Failed to upload document. " + response.message, "", 5000);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('MyTasksModalCtrl', ['$uibModalInstance', 'userId', 'authService', 'projectService', 'taskService', 'toastrService','utilService', 'TASK_STATUS', MyTasksModalCtrl]);

    /** @ngInject */
    function MyTasksModalCtrl($uibModalInstance,userId,authService,projectService,taskService,toastrService,utilService, TASK_STATUS) {

        var vm = this;

        vm.allTasks = [];
        vm.taskStatus = [];
        vm.pageNo = 1;
        vm.perPage = 50;
        vm.totalPages = null;
        vm.pageButtons = [];
        vm.totalData = 0;

        vm.allProjects = [];
        vm.selectedProject = null;

        vm.statusList = TASK_STATUS;
        vm.selectedStatus = null;

        vm.showFilters = true;
        vm.isDataLoaded = false;

        vm.datePicker = {};
        vm.datePicker.date = getInitialFromAndToDate();

        vm.minDate = new Date(utilService.getMinimumDate());
        vm.datePicker.options = {
            applyClass: 'btn-green',
            minDate: vm.minDate,
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                // format: "YYYY-MM-DD", //will give you 2017-01-06
                // format: "D/MMM/YY", //will give you 6-Jan-17
                format: "DD-MMMM-YYYY", //will give you 6-January-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        vm.getAllTasks = getAllTasks;
        vm.updateTaskStatus = updateTaskStatus;

        init();

        function init() {
            getAllProjects();
            getAllTasks();
        }

        function getAllTasks() {
            vm.isDataLoaded = false;
            var projectId = (vm.selectedProject != null && vm.selectedProject[0] != null) ?vm.selectedProject[0].id : null;
            var status = (vm.selectedStatus != null && vm.selectedStatus[0] != null) ?vm.selectedStatus[0].id : null;

            var data = {
                perPage : vm.perPage,
                pageNo : vm.pageNo,
                projectWorkId : projectId,
                status : status,
                employeeId : userId,
                startDate: moment(vm.datePicker.date.startDate).format('x'),
                endDate: moment(vm.datePicker.date.endDate).format('x')
            }
            taskService.getAllTasks(true, data).then(function (data) {
                vm.allTasks = data.taskList;
                vm.pageNo = data.pageNo;
                vm.perPage = data.perPage;
                vm.totalPages = data.totalPages;
                vm.taskStatus = vm.allTasks.map(function (task) {
                    return {'status' : task.status === 2};
                });
                vm.isDataLoaded = true;

                vm.totalData = Object.keys(vm.allTasks).length;
                var startPage = vm.pageNo-2 <= 0? 1 : vm.pageNo-2;
                var endPage = Math.min(vm.totalPages, startPage+4);
                vm.pageButtons.length = 0;
                for (var i = startPage; i <= endPage; i++) {
                    vm.pageButtons.push(i);
                }
            },function (message) {
                toastrService.showErrorToastr('Task Fetching failed error: '+message, "", 5000);
                console.error('Task Fetching failed error: '+message);
            });
        }

        function getAllProjects() {
            projectService.getAllProjects(true).then(function (data) {
                vm.allProjects = _.sortBy(data, function (project){
                    return project.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
                console.error('Project Fetching failed error: '+message);
            });
        }

        function getInitialFromAndToDate() {
            var start = moment().startOf('day').subtract(7, 'day');
            var end = moment().endOf('day');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        function updateTaskStatus(taskId, status) {
            toastrService.clearPreviousToastr();
            status = status? 2 : 1;
            taskService.updateTaskStatus(taskId, status).then(function (data) {
                toastrService.showSuccessToastr('Task status updated.');
            },function (message) {
                toastrService.showErrorToastr('Task status not updated.');
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('IncludeInAttendanceReportCtrl', ['$uibModalInstance', 'employeeService', 'toastrService','user','loggedInUser', 'analyticsService', 'ANALYTICS_CONSTANT', IncludeInAttendanceReportCtrl]);

    /** @ngInject */
    function IncludeInAttendanceReportCtrl($uibModalInstance, employeeService, toastrService,user,loggedInUser, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.user = user;
        vm.included = vm.user.includeInAttendanceReport;
        vm.loggedInUser = loggedInUser;
        var analyticsModalTitle = 'Include In Attendance Report Modal';
        var analyticsModalUrl = 'include-in-attendance-report';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Include In Attendance Report In' + document.title, ANALYTICS_CONSTANT.open);

        vm.changeInclusionStatus = changeInclusionStatus;

        function changeInclusionStatus (includeInAttendanceReport) {
            employeeService.includeInAttendanceReport({includeInAttendanceReport: includeInAttendanceReport,employeeIds:[vm.user.id]}).then(function () {
                if(includeInAttendanceReport){
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Include', analyticsModalUrl + '/include', 'Include In Attendance Report In' + document.title, ANALYTICS_CONSTANT.include);
                }
                else{
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Exclude', analyticsModalUrl + '/Exclude', 'Exclude In Attendance Report In' + document.title, ANALYTICS_CONSTANT.include)
                }
                // includeInAttendanceReport ? analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Include', analyticsModalUrl + '/include', 'Include In Attendance Report In' + document.title, ANALYTICS_CONSTANT.include) : analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Exclude', analyticsModalUrl + '/Exclude', 'Exclude In Attendance Report In' + document.title, ANALYTICS_CONSTANT.include)
                toastrService.showSuccessToastr(includeInAttendanceReport === true ? "Included " + vm.user.name +" successfully." : "Removed " + vm.user.name +" successfully.");
                $uibModalInstance.close();
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to update inclusion status. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('OvertimeConfirmationCtrl', ['$uibModalInstance','overtimeService','overtimeStatus','employeeId','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', OvertimeConfirmationCtrl]);

    /** @ngInject */
    function OvertimeConfirmationCtrl($uibModalInstance,overtimeService,overtimeStatus,employeeId,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        var analyticsModalTitle = 'Allow Overtime Modal';
        var analyticsModalUrl = 'allow-overtime';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Allow Overtime In' + document.title, ANALYTICS_CONSTANT.open);
        vm.employeeId = null;
        vm.overtimeStatus = null;

        vm.changeOvertimeStatus = changeOvertimeStatus;

        function init() {
            vm.employeeId = employeeId;
            vm.overtimeStatus = overtimeStatus;
        }
        init();

        function changeOvertimeStatus() {
            var data = {
                allowOvertime:!vm.overtimeStatus,
                employeeIdList: [vm.employeeId]
            };
            overtimeService.changeOvertimeStatus(data).then(function () {
                if(data.allowOvertime){
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Allow', analyticsModalUrl + '/allow', 'Allow Overtime In' + document.title, ANALYTICS_CONSTANT.confirm);
                }
                else{
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Disallow', analyticsModalUrl + '/disallow', 'Disallow Overtime In' + document.title, ANALYTICS_CONSTANT.confirm);
                }
                // data.allowOvertime ? analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Allow', analyticsModalUrl + '/allow', 'Allow Overtime In' + document.title, ANALYTICS_CONSTANT.confirm) : analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Disallow', analyticsModalUrl + '/disallow', 'Disallow Overtime In' + document.title, ANALYTICS_CONSTANT.confirm);
                $uibModalInstance.close();
            },function (error) {
                toastrService.showErrorToastr("Could not change overtime status :" + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('RehireEmployeeModalCtrl', ['$uibModalInstance', 'authService', 'employeeService', 'toastrService', 'userId', 'analyticsService', 'ANALYTICS_CONSTANT', RehireEmployeeModalCtrl]);

    /** @ngInject */
    function RehireEmployeeModalCtrl($uibModalInstance, authService, employeeService, toastrService, userId, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Rehire Employee Modal';
        var analyticsModalUrl = 'Rehire-employee';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Rehire Employee In ' + document.title, ANALYTICS_CONSTANT.open);
        vm.confirmBtnClicked = false;
        vm.employeeStatus = null;
        vm.statusRemark = "";
        vm.dateOfResignation = moment();
        vm.isOpenStart = null;
        vm.loggedInUser = null;

        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.openStart = openStart;
        vm.rehireEmployee = rehireEmployee;

        function init() {
            vm.loggedInUser = authService.getLoggedInUser();
        }
        init();

        function openStart () {
            vm.isOpenStart = true;
        }

        function rehireEmployee() {
            toastrService.clearPreviousToastr();
            // if(!vm.employeeStatus)
            //     return toastrService.showErrorToastr("Please select employee status");
            vm.confirmBtnClicked = true;
            var data = {
                    "employeeId": userId,
                    // "status": vm.employeeStatus,
                    // "statusRemark": vm.statusRemark,
                    // "dateOfResignation": vm.dateOfResignation.format('x'),
                    // "statusChangedBy": vm.loggedInUser.id
            };
            employeeService.rehireEmployee(data, userId).then(function (address) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Rehire', analyticsModalUrl + '/rehire', 'Rehired Employee In' + document.title, ANALYTICS_CONSTANT.confirm)
                vm.confirmBtnClicked = false;
                $uibModalInstance.close(address);
                toastrService.showSuccessToastr("Employee rehired.");
            }, function (response) {
                vm.confirmBtnClicked = false;
                $uibModalInstance.dismiss("Failed to rehire employee." + response);
                console.error("Failed to rehire employee : " + response);
                toastrService.showErrorToastr("Failed to rehire employee. " + response, "", 5000);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ResignEmployeeModalCtrl', ['$uibModalInstance', 'authService', 'employeeService', 'toastrService', 'userId','RESIGN_STATUS', 'analyticsService', 'ANALYTICS_CONSTANT', ResignEmployeeModalCtrl]);

    /** @ngInject */
    function ResignEmployeeModalCtrl($uibModalInstance, authService, employeeService, toastrService, userId, RESIGN_STATUS, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Resign Employee Modal';
        var analyticsModalUrl = 'resign-employee';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Resign Employee In ' + document.title, ANALYTICS_CONSTANT.open);
        vm.confirmBtnClicked = false;
        vm.employeeStatus = null;
        vm.employeeStatusList = RESIGN_STATUS;
        vm.statusRemark = "";
        vm.dateOfResignation = moment();
        vm.isOpenStart = null;
        vm.loggedInUser = null;

        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.openStart = openStart;
        vm.resignEmployee = resignEmployee;

        function init() {
            vm.loggedInUser = authService.getLoggedInUser();
        }
        init();

        function openStart () {
            vm.isOpenStart = true;
        }

        function resignEmployee() {
            toastrService.clearPreviousToastr();
            if(!vm.employeeStatus)
                return toastrService.showErrorToastr("Please select employee status");
            vm.confirmBtnClicked = true;
            var data = {
                    "employeeId": userId,
                    "status": vm.employeeStatus,
                    "statusRemark": vm.statusRemark,
                    "dateOfResignation": vm.dateOfResignation.format('x'),
                    "statusChangedBy": vm.loggedInUser.id
            };
            employeeService.resignEmployee(data, userId).then(function (address) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Resign', analyticsModalUrl + '/resign', 'Resign Employee In' + document.title, ANALYTICS_CONSTANT.confirm)
                vm.confirmBtnClicked = false;
                $uibModalInstance.close(address);
                toastrService.showSuccessToastr("Employee resigned.");
            }, function (response) {
                vm.confirmBtnClicked = false;
                $uibModalInstance.dismiss("Failed to resign employee." + response);
                console.error("Failed to resign employee : " + response);
                toastrService.showErrorToastr("Failed to resign employee. " + response, "", 5000);
            });
        };
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('SetCompanyAdminCtrl', ['$uibModalInstance', 'employeeService', 'toastrService','user','loggedInUser', 'analyticsService', 'ANALYTICS_CONSTANT', SetCompanyAdminCtrl]);

    /** @ngInject */
    function SetCompanyAdminCtrl($uibModalInstance, employeeService, toastrService,user,loggedInUser, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Change Company Admin Role Modal';
        var analyticsModalUrl = 'change-company-admin-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Change Company Admin Role In' + document.title, ANALYTICS_CONSTANT.open);
        vm.user = user;
        vm.isCompanyAdmin = vm.user.isCompanyAdmin;
        vm.loggedInUser = loggedInUser;
        vm.setCompanyAdmin = setCompanyAdmin;

        function setCompanyAdmin (isCompanyAdmin) {
            toastrService.clearPreviousToastr();
            if(vm.user.id === vm.loggedInUser.id)
                return  toastrService.showErrorToastr("Cannot change own company admin status");
            employeeService.setCompanyAdmin({isCompanyAdmin: isCompanyAdmin}, vm.user.id).then(function () {
                $uibModalInstance.close();
                toastrService.showSuccessToastr(isCompanyAdmin ? "Made " + vm.user.name +" an admin successfully." : "Removed " + vm.user.name +" from admin successfully.");
                if(isCompanyAdmin){
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set', analyticsModalUrl + '/set', 'Set Company Admin Role In' + document.title, ANALYTICS_CONSTANT.set);
                }
                else{
                    analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove', analyticsModalUrl + '/remove', 'Remove Company Admin Role In' + document.title, ANALYTICS_CONSTANT.remove);
                }
                // isCompanyAdmin ? analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Set', analyticsModalUrl + '/set', 'Set Company Admin Role In' + document.title, ANALYTICS_CONSTANT.set) : analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Remove', analyticsModalUrl + '/remove', 'Remove Company Admin Role In' + document.title, ANALYTICS_CONSTANT.remove)
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to update isCompanyAdmin. " + response.message);
                    console.error("Failed to update isCompanyAdmin: " + response.message);
                    toastrService.showErrorToastr("Failed to change company admin status. " + response.message, "", 5000);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('TimeSheetEntryModalCtrl', ['$uibModalInstance', 'userId', 'authService', 'taskService', 'toastrService','utilService', 'analyticsService', 'ANALYTICS_CONSTANT', TimeSheetEntryModalCtrl]);

    /** @ngInject */
    function TimeSheetEntryModalCtrl($uibModalInstance,userId, authService, taskService,toastrService,utilService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsModalTitle = 'Timesheet Entry Modal';
        var analyticsModalUrl = 'timesheet-entry';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Timesheet Entry In' + document.title, ANALYTICS_CONSTANT.open);
        vm.create = {};
        vm.create.name = null;
        vm.create.description = null;
        // vm.create.startTime = new Date(moment().format('D-MMM-YYYY hh:mm A'));
        vm.create.startTime = moment();
        vm.create.endTime = moment();
        vm.allTasks = [];
        vm.selectedTask = null;
        vm.openStartTimeModal = false;
        vm.openEndTimeModal = false;
        vm.minDate = new Date(utilService.getMinimumDate());
        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            minDate : vm.minDate,
            timePicker : true,
            timePicker24Hour : false,
            locale : {
                format : 'DD-MMM-YYYY hh:mm A'
            }
        };
        vm.enterTimeSheet = enterTimeSheet;

        init();

        function init() {
            getAllTasksOfAnEmployee();
        }

        function getAllTasksOfAnEmployee() {
            taskService.getAllTasksWithFilters(userId).then(function (data) {
                vm.allTasks = _.sortBy(data, function(task){
                  return task.name.toLowerCase();
                });
            },function (message) {
                toastrService.showErrorToastr('Task fetching failed error: '+message, "", 5000);
                console.error('Task fetching failed error: '+message);
            });
        }

        function enterTimeSheet() {
            toastrService.clearPreviousToastr();
            if (vm.selectedTask[0] == null)
                return toastrService.showErrorToastr("Please select a task");
            var data =
                {
                    'startTime' : moment(vm.create.startTime).format('x'),
                    'endTime' : moment(vm.create.endTime).format('x'),
                    'employeeId' : userId,
                    'taskId' : vm.selectedTask[0].id,
                    'description' : vm.create.description
                };

            taskService.timeSheetEntry(data).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Create', analyticsModalUrl + '/create', 'Create Timesheet Entry In' + document.title, ANALYTICS_CONSTANT.create)
                toastrService.showSuccessToastr("Timesheet entry added");
                $uibModalInstance.close();
            },function (error) {
                toastrService.showErrorToastr("Failed to add timesheet entry: " + error, "", 5000);
                $uibModalInstance.dismiss(error);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteDocumentModalCtrl', ['employeeService','$uibModalInstance','documentId','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteDocumentModalCtrl]);

    /** @ngInject */
    function DeleteDocumentModalCtrl(employeeService,$uibModalInstance,documentId,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Employee Documents - Delete Employee Documents Modal';
        var analyticsDeleteUrl = 'employee-documents/delete-employee-documents';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Employee Documents In' + document.title, ANALYTICS_CONSTANT.open);
        vm.delete = deleteDocument;

        function deleteDocument() {
            employeeService.deleteEmployeeDocument(documentId).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Employee Documents In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not delete document: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('CreateEmploymentModalCtrl', ['employeeService','$stateParams','$uibModalInstance', 'toastrService', 'userId', 'analyticsService', 'ANALYTICS_CONSTANT', CreateEmploymentModalCtrl]);

    /** @ngInject */
    function CreateEmploymentModalCtrl(employeeService,$stateParams,$uibModalInstance, toastrService, userId, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var employeeId = userId;
        var analyticsCreateTitle = 'Employment History - Create Employment History Modal';
        var analyticsCreateUrl = 'employment-history/create-employment-history';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Employment History' + document.title, ANALYTICS_CONSTANT.open);

        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.history = {
            companyName     : "",
            companyBusiness : "",
            designation     : "",
            department      : "",
            responsibilities: "",
            startDateObject : moment(),
            endDateObject   : moment(),
            companyLocation : ""

        };
        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.createHistory  = createHistory;

        function createHistory() {
            toastrService.clearPreviousToastr();
            if(vm.history.companyName == ''
                || vm.history.companyBusiness == ''
                || vm.history.department == ''
                || vm.history.responsibilities == ''
                || vm.history.year == ''
                || vm.history.companyLocation == ''
        )
                return toastrService.showErrorToastr("Please fill all the fields");
            if(vm.history.endDateObject < vm.history.startDateObject)
                return toastrService.showErrorToastr("Employment start date must be before employment end date");

            vm.history.employmentStart = moment(vm.history.startDateObject).format('x');
            vm.history.employmentEnd = moment(vm.history.endDateObject).format('x');

            employeeService.createEmploymentHistory(employeeId,vm.history).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Employment History In' + document.title, ANALYTICS_CONSTANT.create)

                $uibModalInstance.close(data);
            },function () {
                toastrService.showErrorToastr("Could not create.", "", 5000)
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteEmploymentModalCtrl', ['employeeService','$uibModalInstance', 'toastrService','history', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteEmploymentModalCtrl]);

    /** @ngInject */
    function DeleteEmploymentModalCtrl(employeeService,$uibModalInstance, toastrService, history, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Delete Employment History Modal';
        var analyticsDeleteUrl = 'delete-employment-history';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Employment History In' + document.title, ANALYTICS_CONSTANT.open);
        vm.history = angular.copy(history);
        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.history.startDateObject = moment(vm.history.employmentStart);
        vm.history.endDateObject = moment(vm.history.employmentEnd);
        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.deleteHistory = deleteHistory;




        function deleteHistory() {
            employeeService.deleteEmploymentHistory(vm.history).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Employment History In' + document.title, ANALYTICS_CONSTANT.delete);
                $uibModalInstance.close(data);
            },function () {
                toastrService.showErrorToastr("Could not delete.", "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EditEmploymentModalCtrl', ['employeeService','$uibModalInstance', 'toastrService','history', 'analyticsService', 'ANALYTICS_CONSTANT', EditEmploymentModalCtrl]);

    /** @ngInject */
    function EditEmploymentModalCtrl(employeeService,$uibModalInstance, toastrService, history, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsEditTitle = 'Employment History - Edit Employment History Modal';
        var analyticsEditUrl = ' employment-history/edit-employment-history';

        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit employment History In' + document.title, ANALYTICS_CONSTANT.open);
        vm.history = angular.copy(history);
        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.history.startDateObject = moment(vm.history.employmentStart);
        vm.history.endDateObject = moment(vm.history.employmentEnd);
        vm.datePickerOptions = {
            singleDatePicker : true,
            startDate : moment(),
            locale : {
                format : 'DD-MMM-YYYY'
            }
        };

        vm.updateHistory = updateHistory;

        
        function updateHistory() {
            toastrService.clearPreviousToastr();
            if(vm.history.endDateObject < vm.history.startDateObject)
                return toastrService.showErrorToastr("Employment start date must be before employment end date");
            vm.history.employmentStart = moment(vm.history.startDateObject).format('x');
            vm.history.employmentEnd = moment(vm.history.endDateObject).format('x');
            employeeService.updateEmploymentHistory(vm.history).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Employment History In' + document.title, ANALYTICS_CONSTANT.edit)
                $uibModalInstance.close(data);
            },function () {
                toastrService.showErrorToastr("Could not update.", "", 5000);
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('CreateEducationModalCtrl', ['employeeService','$stateParams','$uibModalInstance', 'toastrService', 'userId', 'analyticsService', 'ANALYTICS_CONSTANT',CreateEducationModalCtrl]);

    /** @ngInject */
    function CreateEducationModalCtrl(employeeService,$stateParams,$uibModalInstance, toastrService, userId, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsCreateTitle = 'Education History - Create Education History Modal';
        var analyticsCreateUrl = 'education-history/create-education-history';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Education History In' + document.title, ANALYTICS_CONSTANT.open);
        var employeeId = userId;

        vm.history = {
            board       : "",
            grade       : "",
            institution : "",
            name        : "",
            year        : ""

        };

        vm.createHistory  = createHistory;

        function createHistory() {
            toastrService.clearPreviousToastr();
            if(vm.history.board == ''
                || vm.history.grade == ''
                || vm.history.institution == ''
                || vm.history.name == ''
                || vm.history.year == '')
                return toastrService.showErrorToastr("Please fill all the fields");
            employeeService.createEducationHistory(employeeId,vm.history).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Education History In' + document.title, ANALYTICS_CONSTANT.create)
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not create: " + error, "", 5000);
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('DeleteEducationModalCtrl', ['employeeService','$uibModalInstance', 'toastrService','history', 'analyticsService', 'ANALYTICS_CONSTANT',DeleteEducationModalCtrl]);

    /** @ngInject */
    function DeleteEducationModalCtrl(employeeService,$uibModalInstance, toastrService,history, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsDeleteTitle = 'Education History - Delete Education History Modal';
        var analyticsDeleteUrl = 'education-history/delete-education-history';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Education History In' + document.title, ANALYTICS_CONSTANT.open);

        vm.history = angular.copy(history);

        vm.deleteHistory = deleteHistory;


        function deleteHistory() {
            employeeService.deleteEducationHistory(vm.history).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Education History In' + document.title, ANALYTICS_CONSTANT.delete)
                $uibModalInstance.close(data);
            },function () {
                toastrService.showErrorToastr("Could not delete.");
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('EditEducationModalCtrl', ['employeeService','$uibModalInstance', 'toastrService','history', 'analyticsService', 'ANALYTICS_CONSTANT',EditEducationModalCtrl]);

    /** @ngInject */
    function EditEducationModalCtrl(employeeService,$uibModalInstance, toastrService,history, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        var analyticsEditTitle = 'Education History - Edit Education History Modal';
        var analyticsEditUrl = 'education-history/edit-education-history';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Education History In' + document.title, ANALYTICS_CONSTANT.open);
        vm.history = angular.copy(history);

        vm.updateHistory = updateHistory;

        function updateHistory() {
            employeeService.updateEducationHistory(vm.history).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Education History In' + document.title, ANALYTICS_CONSTANT.edit)
                $uibModalInstance.close(data);
            },function (error) {
                toastrService.showErrorToastr("Could not update: " + error , "", 5000);
            })
        }


    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfilePicCtrl', ['$filter', '$scope', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService','imageNotResize','utilService', ProfilePicCtrl]);

    /** @ngInject */
    function ProfilePicCtrl($filter, $scope, $timeout, $uibModal, authService, employeeService, toastrService,imageNotResize,utilService) {
        var vm = this;
        vm.userId = null;
        vm.currentProfilePicURL = null;
        vm.defaultPicture = null;
        vm.isDataReady = null;
        vm.resizeImage = false;
        vm.hasPermission = utilService.hasPermission;
        vm.imageSource = imageSource;
        vm.showProfilePictureUploadModal = showProfilePictureUploadModal;
        vm.openRemoveConfirmationModal = openRemoveConfirmationModal;
        vm.isEmployeeOnly = authService.isEmployeeOnly();

        function init () {
            vm.defaultPicture = $filter('appImage')('theme/no-photo.png');
            $scope.$on("profile-pic-loaded", function (event, userData) {
                // console.log("on profile-pic-loaded userdata : "+JSON.stringify(userData));
                $timeout(function () {
                    vm.userId = userData.userId;
                    //vm.resizeImage = userData.officeId != uapOfficeId;
                    vm.resizeImage = imageNotResize.indexOf(userData.officeId)==-1 ? true : false;
                    vm.currentProfilePicURL = userData.profilePicURL ;
                    if (vm.currentProfilePicURL==null) vm.noPicture = true;
                    vm.isDataReady = true;
                });
            });
        }

        init();

        function imageSource() {
            if(vm.isDataReady){
                if (vm.currentProfilePicURL==null) return vm.defaultPicture;
                return vm.currentProfilePicURL;
            }
            return vm.defaultPicture;
        }

        function showProfilePictureUploadModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicUploadModal/profilePicUpload.modal.html',
                controller: 'ProfilePicUploadModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve: {
                    currentProfilePicURL: function () {
                        return imageSource();
                    },
                    userId: function () {
                        return vm.userId;
                    },
                    resizeImage: function () {
                        return vm.resizeImage;
                    }
                }
            }).result.then(function (url) {
                vm.currentProfilePicURL = url;
                if (authService.getLoggedInId() == vm.userId) {
                    authService.updateUserInfo({'employeePictureUrl': url});
                }
                //console.log(url);
                $scope.$emit("profile-updated", { key : "employeePictureUrl", value : url});
                vm.noPicture = false;
            }, function () {
                console.log("Profile picture upload modal dismissed.");
            });
        }

        function openRemoveConfirmationModal () {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicRemoveModal/profilePicRemove.modal.html',
                controller : 'ProfilePicRemoveModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve:{
                    employeeId: function () {
                        return vm.userId;
                    }
                }
            }).result.then(function () {
                vm.noPicture = true;
                vm.currentProfilePicURL = null;
                toastrService.showSuccessToastr("Profile picture removed.");
            });

        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('UpdateProjectDedicationModalCtrl', ['$uibModalInstance', 'dedication',UpdateProjectDedicationModalCtrl]);

    /** @ngInject */
    function UpdateProjectDedicationModalCtrl($uibModalInstance,dedication) {

        var vm = this;
        vm.dedication = dedication;
        vm.update = update;

        function update() {
            $uibModalInstance.close(vm.dedication);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement')
    app.controller('CreateProductModalCtrl', [CreateProductModalCtrl]);

    /** @ngInject */
    function CreateProductModalCtrl() {

        var vm = this;
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('EditProjectCtrl', ['$state', 'authService', '$stateParams', '$uibModal', '$scope', 'projectService', 'employeeService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', '$q', 'projectClientService', 'productService', EditProjectCtrl]);

    /** @ngInject */
    function EditProjectCtrl($state, authService, $stateParams, $uibModal, $scope, projectService, employeeService, toastrService, analyticsService, ANALYTICS_CONSTANT, $q, projectClientService, productService) {

        var vm = this;

        vm.isUpdating = false;
        vm.isDataLoaded = false;
        vm.projectDetails = $stateParams.projectDetails;
        vm.employeeList = [];
        vm.projectTypes = [];
        vm.clients = [];
        vm.products = [];
        vm.editProjectForm = null;

        vm.projectId = null;
        vm.projectName = null;
        vm.selectedProjectType = [];
        vm.selectedEmployee = [];
        vm.selectedClient = [];
        vm.selectedProduct = [];
        vm.referenceCode = null;

        vm.startDatePicker = {};
        vm.startDatePicker.date = moment().startOf('day');
        vm.startDatePicker.options = {
            singleDatePicker : true,
            startDate : moment(),
            minDate : moment().startOf('day').subtract(1, "years"),
            timePicker : false,
            timePicker24Hour : false,
            locale : {
                format : 'DD MMM YYYY'
            }
        };

        vm.dueDatePicker = {};
        vm.dueDatePicker.date = angular.copy(vm.startDatePicker.date);
        vm.dueDatePicker.options = {
            singleDatePicker : true,
            startDate : moment(),
            minDate : angular.copy(vm.startDatePicker.date),
            timePicker : false,
            timePicker24Hour : false,
            locale : {
                format : 'DD MMM YYYY'
            }
        };

        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.createProjectType = createProjectType;
        vm.isInvalidForm = isInvalidForm;
        vm.submitForm = submitForm;

        init();

        function init() {
            if(vm.projectDetails == null || vm.projectDetails.id == null) return cancelCurrentOperation();
            var promises = [];
            promises.push(getProjectTypes());
            promises.push(getFilteredEmployeeNames());
            promises.push(getClients());
            promises.push(getProducts());
            $q.all(promises)
                .then(function () {
                    vm.isDataLoaded = true;
                    initialiseForm();
                });
        }

        function getFilteredEmployeeNames() {
            return employeeService.getFilteredEmployeeNames({status:1, excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee list: " + error, "", 5000);
            });
        }

        function cancelCurrentOperation() {
            $state.go("projectManagement.projects");
        }

        function initialiseForm() {
            vm.projectId = vm.projectDetails.id;
            vm.projectName = vm.projectDetails.name;
            vm.referenceCode = vm.projectDetails.referenceCode;

            vm.projectTypes.forEach(function (item) {
                item.ticked = (item.id === vm.projectDetails.projectTypeId);
            });
            vm.employeeList.forEach(function (item) {
                item.ticked = (item.id === vm.projectDetails.ownerId);
            });
            vm.clients.forEach(function (item) {
                item.ticked = (item.id === vm.projectDetails.clientId);
            });
            vm.products.forEach(function (item) {
                item.ticked = (item.id === vm.projectDetails.productId);
            });

            vm.startDatePicker.date = moment(vm.projectDetails.startTime);
            vm.dueDatePicker.date = !!vm.projectDetails.dueDate ? moment(vm.projectDetails.dueDate) :  angular.copy(vm.startDatePicker.date);
        }

        function isInvalidForm() {
            if(vm.selectedEmployee == null || vm.selectedEmployee.length === 0) return true;
            if(vm.selectedProjectType == null || vm.selectedProjectType.length === 0) return true;
            if(vm.selectedClient == null || vm.selectedClient.length === 0) return true;
            if(vm.selectedProduct == null || vm.selectedProduct.length === 0) return true;
            if(vm.dueDatePicker.date.isBefore(vm.startDatePicker.date, 'day')) return true;
        }

        function submitForm() {
            var formData = {
                projectWorkId : vm.projectId,
                name : vm.projectName.trim(),
                referenceCode : vm.referenceCode.trim(),
                projectTypeId : vm.selectedProjectType[0].id,
                productId : vm.selectedProduct[0].id,
                ownerId : vm.selectedEmployee[0].id,
                projectClientId : vm.selectedClient[0].id,
                startTime : vm.startDatePicker.date.format('x'),
                dueDate : vm.dueDatePicker.date.format('x')
            };
            vm.isUpdating = true;

            projectService.updateProject(formData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save', '', 'Save Changes In' + document.title, ANALYTICS_CONSTANT.save);
                toastrService.showSuccessToastr("Project updated successfully");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update project: " + error, "", 5000);
            }).finally(function () {
                vm.isUpdating = false;
                cancelCurrentOperation();
            });
        }

        function getProjectTypes() {
            return projectService.getAllProjectTypes().then(function (data) {
                vm.projectTypes = data.allProjectTypes;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch project type list: " + error, "", 5000);
            });
        }

        function getClients() {
            return projectClientService.getSimplifiedProjectClientList().then(function (data) {
                vm.clients = data.clients;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch client list: " + error, "", 5000);
            });
        }

        function getProducts() {
            return productService.getSimplifiedProductList().then(function (data) {
                vm.products = data.products;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch product list: " + error, "", 5000);
            });
        }

        function createProjectType(data) {
            projectService.createProjectType({name: data.trim()}).then(function (data) {
                toastrService.showSuccessToastr('Created Project Type Successfully');
                getProjectTypes();
            }, function (error) {
                toastrService.showErrorToastr('Failed to create project type: ' + error);
            });
        }

        $scope.$watch('vm.startDatePicker.date', function () {
            vm.dueDatePicker.options.minDate = angular.copy(vm.startDatePicker.date);
        });

    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.projectManagement.projects')
        .controller('EditTdhProjectCtrl', ['authService', '$stateParams', '$uibModal', 'projectService', 'employeeService', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT',EditTdhProjectCtrl]);

    /** @ngInject */
    function EditTdhProjectCtrl(authService, $stateParams, $uibModal, projectService, employeeService,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.projectId = null;
        vm.project = null;
        vm.employees = [];
        vm.employeeIdList = [];
        vm.enabled = false;
        vm.isDataLoaded = false;
        vm.projectId = $stateParams.projectId;


        vm.updateProjectDetails = updateProjectDetails;
        vm.addEmployeesToProject = addEmployeesToProject;
        vm.openConfirmationModal = openConfirmationModal;

        init();

        function init() {
            vm.isDataLoaded = false;
            projectService.getProject(vm.projectId).then(function (data) {
                vm.project = data;
                vm.project.startTime = moment(data.startTime);
                vm.project.endTime = moment(data.endTime);
                vm.enabled = vm.project.status === 1;
                employeeService.getFilteredEmployeeNames(true).then(function (data) {
                    vm.employees = data.employees;
                    vm.isDataLoaded = true;
                },function (message) {
                    toastrService.showErrorToastr('Employee Fetching failed error: '+message, "", 5000);
                });
            },function (message) {
                toastrService.showErrorToastr('Project Fetching failed error: '+message, "", 5000);
            });

            // employeeService.getFilteredEmployeeNames(true).then(function (data) {
            //     vm.employees = data.employees;
            // },function (message) {
            //     toastrService.showErrorToastr('Employee Fetching failed error: '+message, "", 5000);
            // });
            // vm.employees.filter(function (employee) {
            //     return !isEmployeeInProject(employee.id);
            // });
        }

        function isEmployeeInProject(employeeId) {
            vm.project.employees.forEach(function (employee) {
                if (employeeId === employee.id) return true;
            });
            return false;
        }


        function updateProjectDetails() {
            toastrService.clearPreviousToastr();
            if(!vm.project.name){
                vm.isEditing = false;
                return toastrService.showErrorToastr("Name can not be empty");
            }
            var data = {
                'name' : vm.project.name,
                'startTime' : vm.project.startTime.valueOf(),
                'endTime' : vm.project.endTime.valueOf(),
                'status' : vm.enabled ? 1 : 0,
                'description': vm.project.description,
            };
            vm.project.status = data.status;
            vm.isEditing = true;
            projectService.updateProjectInfo(data, vm.project).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save', '', 'Save Changes In' + document.title, ANALYTICS_CONSTANT.save)
                toastrService.showSuccessToastr("Project updated.");
                init();
            }, function (message) {
                toastrService.showErrorToastr("Failed to update project - " + message, "", 5000);
            }).finally(function () {
                vm.isEditing = false;
            });
        }

        function addEmployeesToProject() {
            analyticsService.sendData(ANALYTICS_CONSTANT.add, document.title + ' - Add People', '', 'Add People In' + document.title, ANALYTICS_CONSTANT.add)
            var employeeIdList = vm.employeeIdList.map(function (element) {
                return element.id;
            });
            var data = {
                employeeIdList : employeeIdList
            }
            projectService.addEmployeesToProject(data, vm.project.id).then(function (project) {
                toastrService.showSuccessToastr("People added.");
                vm.project = project;
                vm.project.startTime = moment(project.startTime);
                vm.project.endTime = moment(project.endTime);
            }, function (message) {
                toastrService.showErrorToastr("Failed to add people - " + message, "", 5000);
            });

            resetEmployeeSelectionList();
        }

        function openConfirmationModal(teamMember) {
            var confirmationText = 'Do you want to remove <em class="text-highlight"> ' + teamMember.name + '</em> from the project?';
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/modals/generalConfirmationModal/confirmationModal.html',
                size         : 'md',
                controller   : 'GeneralConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop     : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return  confirmationText;
                    }
                }
            }).result.then(function () {
                removeEmployeeFromProject(teamMember.id);
            });
        }

        function removeEmployeeFromProject(employeeId) {
            projectService.removeEmployeeFromProject(vm.project.id, employeeId).then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.remove, document.title + ' - Remove People', '', 'Remove People In' + document.title, ANALYTICS_CONSTANT.remove)
                toastrService.showSuccessToastr("Employee removed");
                vm.project.employees = vm.project.employees.filter(function (employee) {
                    return employee.id !== employeeId;
                });
            }, function (message) {
                toastrService.showErrorToastr("Failed to update project - " + message, "", 5000);
            });
        }

        function resetEmployeeSelectionList() {
            vm.employeeIdList = [];
            vm.employees.forEach(function (item) {
                item.ticked = false;
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.roster')
        .controller('EditBasicRosterModalCtrl', ['$uibModalInstance','authService', 'rosterService', 'toastrService', 'rosterItem', 'shiftnService', 'analyticsService', 'ANALYTICS_CONSTANT', EditBasicRosterModalCtrl]);

    /** @ngInject */
    function EditBasicRosterModalCtrl($uibModalInstance,authService, rosterService, toastrService, rosterItem, shiftnService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.isEditing = false;
        vm.rosterItem = rosterItem;
        vm.changeDate = false;
        vm.shiftList = [];
        vm.selectedShifts = [];
        vm.officeId = authService.getLoggedInUser().officeId;
        var analyticsEditTitle = 'Edit Basic Roster Modal';
        var analyticsEditUrl = 'edit-basic-roster';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Basic Roster In' + document.title, ANALYTICS_CONSTANT.open);

        vm.days = [{
            'name': 'Friday',
            'value': 5,
            'ticked': true
        },{
            'name': 'Saturday',
            'value': 6
        },{
            'name': 'Sunday',
            'value': 7
        },{
            'name': 'Monday',
            'value': 1
        },{
            'name': 'Tuesday',
            'value': 2
        },{
            'name': 'Wednesday',
            'value': 3
        },{
            'name': 'Thursday',
            'value': 4
        }];
        vm.selectedOffdays = [];

        vm.effectiveDatePicker = {};
        vm.effectiveDatePicker.date = moment().add(1,'days');
        vm.effectiveDatePicker.options = {
            singleDatePicker: true,
            timePicker: false,
            startDate: angular.copy(vm.effectiveDatePicker.date),
            minDate: moment().subtract(1, 'months'),
            maxDate: moment().endOf('year'),
            locale:{
                applyLabel: "Apply",
                cancelLabel: 'Cancel',
                format:'D MMM YYYY'
            },
        };


        vm.updateBasicRoster = updateBasicRoster;
        vm.buildShiftInfo = buildShiftInfo;

        init();

        function init(){
            shiftnService.getAllShifts().then(function(data){
                vm.shiftList = data;
                var now = moment().startOf('day');
                vm.shiftList = vm.shiftList.filter(function(s){
                    return s.status == 1 ;
                }).map(function(s){
                    s.displayName = buildShiftInfo(s.name, (now + s.startTime), (now + s.startTime+s.workHour));
                    if(s.isDefault) s.ticked = true;
                    return s;
                });
            },function (err) {
                toastrService.showErrorToastr("Failed to fetch shifts: " + err, "", 5000);
            })
        }

        function updateBasicRoster() {
            vm.isEditing = true;
            rosterService.updateRosterBasic({
                'shiftGroupId' : rosterItem.shiftGroupId,
                'shiftId' : vm.selectedShifts[0].id,
                'offdays' : vm.selectedOffdays.map(function(o){ return o.value}),
                'effectiveDate' : vm.effectiveDatePicker.date.startOf('day').format('x')
            }).then(function(){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Basic Roster In' + document.title, ANALYTICS_CONSTANT.edit);

                toastrService.showSuccessToastr("Roster updated.");
                $uibModalInstance.close();
            },function(error){
                toastrService.showErrorToastr("Failed to update roster: " + error, "", 5000);
                $uibModalInstance.dismiss("Failed to update roster: " + error);
            }).finally(function(){
                vm.isEditing = false;
            });
        }

        function buildShiftInfo(shiftName, startTime, endTime) {
            return shiftName + " ( " + moment(startTime).format('h:mm A') + " - " + moment(endTime).format('h:mm A') + " )";
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.roster')
        .controller('RepeatShiftChangeModalCtrl', ['$uibModalInstance', 'authService', 'shiftnService', 'toastrService', 'shiftGroups', 'utilService', RepeatShiftChangeModalCtrl ]);

    /** @ngInject */
    function RepeatShiftChangeModalCtrl($uibModalInstance, authService, shiftnService, toastrService, shiftGroups, utilService) {
        var vm = this;
        vm.thisYear = moment().year();
        vm.months = buildMonthsArray();
        vm.shiftGroups = shiftGroups;
        vm.selectedShiftGroups = [];

        vm.selected = {};
        vm.selected.shiftGroupId = 1;
        vm.selected.copyFromMonth = 1;
        vm.selected.copyFromDay = 1;
        vm.selected.copyToMonth = 1;
        vm.selected.copyToDay = 1;
        vm.selected.pasteFromMonth = 1;
        vm.selected.pasteFromDay = 1;
        vm.selected.pasteToMonth = 1;
        vm.selected.pasteToDay = 1;

        vm.copyDatePicker = {};
        vm.copyDatePicker.date = {
            'startDate': moment().add(1,'days'),
            'endDate': moment().add(7, 'days')
        };
        vm.copyDatePicker.options = {
            applyClass: 'btn-green',
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                format: "D/MMM/YY", //will give you 6-Jan-17
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                'Last 7 days': [moment().subtract('days', 7), moment()],
                'Last 30 days': [moment().subtract('days', 30), moment()],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            }
        };

        vm.pasteDatePicker = {};
        vm.pasteDatePicker.date = {
            'startDate': moment().add(1,'days'),
            'endDate': moment().endOf('year')
        };
        vm.pasteDatePicker.options = vm.copyDatePicker.options;

        vm.minDate = moment().add(1,'days');
        vm.maxDate = moment().endOf('year');

        vm.repeatAndClose = repeatAndClose;

        function repeatAndClose () {
            if(utilService.isEmptyArray(vm.selectedShiftGroups))
                return toastrService.showErrorToastr("Please select a shift group");

            vm.selected.shiftGroupId = vm.selectedShiftGroups[0].id;
            vm.selected.copyFromMonth = vm.copyDatePicker.date.startDate.month() + 1;
            vm.selected.copyToMonth = vm.copyDatePicker.date.endDate.month() + 1;
            vm.selected.pasteFromMonth = vm.pasteDatePicker.date.startDate.month() + 1;
            vm.selected.pasteToMonth = vm.pasteDatePicker.date.endDate.month() + 1;
            vm.selected.copyFromDay = vm.copyDatePicker.date.startDate.date();
            vm.selected.copyToDay = vm.copyDatePicker.date.endDate.date();
            vm.selected.pasteFromDay = vm.pasteDatePicker.date.startDate.date();
            vm.selected.pasteToDay = vm.pasteDatePicker.date.endDate.date();
            $uibModalInstance.close(vm.selected);
        }

        function buildMonthsArray(){
            var m = [];
            for(var i =1; i <= 12; i++){
                var month = {};
                month.number = i;
                month.name = utilService.getMonthName(i);
                month.days = utilService.getAllDatesOfAMonth(i,vm.thisYear);
                m.push(month);
            }
            return m;
        }


    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.shiftManagement.roster')
        .controller('CellShiftChangeModalCtrl', ['$uibModalInstance', 'shifts', CellShiftChangeModalCtrl]);

    /** @ngInject */
    function CellShiftChangeModalCtrl($uibModalInstance, shifts) {

        var vm = this;
        vm.shiftList = shifts;
        vm.selectedShifts = [];
        vm.changeCell = changeCell;
        init();

        function init() {
            var now = moment().startOf('day');
            vm.shiftList = vm.shiftList.filter(function (s) {
                return s.status == 1;
            }).map(function (s) {
                if(!s.isOffday) {
                    s.displayName = buildShiftInfo(s.name, (now + s.startTime), (now + s.startTime + s.workHour));
                    if (s.isDefault) s.ticked = true;
                }
                return s;
            });
        }

        function changeCell() {
            $uibModalInstance.close({shiftId : vm.selectedShifts[0].id, isOffday : vm.selectedShifts[0].id == -1});
        }

        function buildShiftInfo(shiftName, startTime, endTime) {
            return shiftName + " ( " + moment(startTime).format('h:mm A') + " - " + moment(endTime).format('h:mm A') + " )";
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .directive('listEmployeeFeed', function () {
            return {
                restrict: 'E',
                controller: 'ListEmployeeFeedCtrl as vm',
                scope:{
                    allEmployeeData   : "=",
                    isDataLoaded      : "=",
                    type              : "@",
                    isAdmin           : "="
                },
                templateUrl: 'app/pages/main/siteManagement/siteManagementDashboard/partials/ListEmployeeFeed/listEmployeeFeed.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('ListEmployeeFeedCtrl', ['$scope', 'authService','$filter','utilService', 'dashboardService', ListEmployeeFeedCtrl]);

    /** @ngInject */
    function ListEmployeeFeedCtrl($scope, authService, $filter, utilService, dashboardService) {

        var vm = this;
        // vm.isDataLoaded = false;
        vm.lateList = [];
        vm.hasPermission = utilService.hasPermission;
        vm.isGroupAdmin = authService.getLoggedInUser().isGroupAdmin;
        vm.allEmployeeData=$scope.allEmployeeData;

        function init() {
            // dashboardService.getLateFeed().then(function (data){
            //    vm.lateList = data.entries;
            //    vm.isDataLoaded = true;
            // },function (){
            //     vm.isDataLoaded = true;
            // })
        }
        init();
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('TopActiveSitesCtrl', ['authService','$filter','utilService', 'dashboardService','$scope', TopActiveSitesCtrl]);

    /** @ngInject */
    function TopActiveSitesCtrl(authService, $filter, utilService, dashboardService, $scope) {

        var vm = this;
        vm.isDataLoaded = false;
        vm.lateList = [];
        vm.hasPermission = utilService.hasPermission;
        vm.isGroupAdmin = authService.getLoggedInUser().isGroupAdmin;


        function init() {
            // dashboardService.getLateFeed().then(function (data){
            //    vm.lateList = data.entries;
            //    vm.isDataLoaded = true;
            // },function (){
            //     vm.isDataLoaded = true;
            // })
            // console.log($scope.allSitesData)
        }
        init();
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .directive('topActiveSites', function () {
            return {
                restrict: 'E',
                controller: 'TopActiveSitesCtrl as vm',
                scope:{
                    allSitesData      : "=",
                    isDataLoaded      : "=",
                },
                templateUrl: 'app/pages/main/siteManagement/siteManagementDashboard/partials/TopActiveSites/topActiveSites.html',
            }
        })
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('SiteBarChartCtrl', ['authService', '$scope', '$stateParams', 'attendanceService', 'baConfig', 'layoutPaths', 'toastrService','utilService','siteManagementService', SiteBarChartCtrl]);

    /** @ngInject */
    function SiteBarChartCtrl(authService, $scope, $stateParams, attendanceService, baConfig, layoutPaths, toastrService,utilService,siteManagementService) {
        var vm = this;

        vm.isDataReady = false;
        vm.user = null;
        vm.searchAttendance = searchAttendance;
        vm.employeeName = null;
        var chart = null;
        var employeeId = null;
        vm.params = {};

        vm.params.startTimeOfDay = moment().startOf('day').format('x');
        vm.params.pageNumber = 0;
        vm.params.count = 10;
        vm.params.keyword = '';

        vm.handelPaginatedData = handelPaginatedData;


        function init () {
            searchAttendance();
        }
        init();

        function searchAttendance () {
            siteManagementService.getSiteSummaryReportInfo(vm.params).then(function (response) {
                    vm.totalPages = response.totalPages;
                    vm.pageNumber = response.currentPage;
                    chart = AmCharts.makeChart("zoomAxisChart", getChartOptions(response.siteSummaryList), 100);
                    chart.dataProvider = response.siteSummaryList;
                    chart.validateData(response.siteSummaryList, false);

                    if (response.siteSummaryList && response.siteSummaryList.length) vm.isDataReady = true;

                }, function (message) {
                    console.error("Failed to fetch site data");
                    toastrService.showErrorToastr("Failed to fetch site data :" + message, "", 5000);
                });
        }
        function handelPaginatedData(searchParams){
            modifyParams(searchParams)
            if(vm.params.pageNumber < vm.totalPages)
                searchAttendance();
            else return toastrService.showErrorToastr('No data left', '', 5000)
        }

        function modifyParams(searchParams) {
            if(searchParams == 'next')
                vm.params.pageNumber++;

            if(searchParams == 'prev')
                vm.params.pageNumber--;
        }


        function getChartOptions (data) {
            var layoutColors = baConfig.colors;
            return {
                "type": "serial",
                "theme": "none",
                "color": layoutColors.defaultText,
                // "dataDateFormat": "DD MMM",
                // 'siteName' : data.siteName,
                "minSelectedTime":20,
                "precision": 2,
                "autoResize" : true,
                "valueAxes": [{
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v1",
                    "title": "Number of Employees",
                    "position": "left",
                    "autoGridCount": true,
                    "minimum": 0,
                    "labelFunction": function (value) {
                        return "" + Math.round(value) + "";
                    }
                }],
                "graphs": [
                    {
                        "id": "g3",
                        color: layoutColors.defaultText,
                        "valueAxis": "v1",
                        "lineColor": layoutColors.primaryLight,
                        "fillColors": layoutColors.primaryLight,
                        "fillAlphas": 0.8,
                        "lineAlpha": 0.8,
                        "type": "column",
                        "title": "Expected Attendance",
                        "valueField": "expectedEmployees",
                        "clustered": false,
                        "columnWidth": 0.5,
                        "lineColorField": layoutColors.defaultText,
                        "legendValueText": "[[value]]",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    {
                        "id": "g4",
                        "valueAxis": "v1",
                        color: layoutColors.defaultText,
                        "lineColor": layoutColors.primary,
                        "fillColors": layoutColors.primary,
                        "fillAlphas": 0.9,
                        "lineAlpha": 0.9,
                        "type": "column",
                        "title": "Actual Attendance",
                        "valueField": "present",
                        "clustered": false,
                        "columnWidth": 0.3,
                        "legendValueText": "[[value]]M",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    { //Red Curve
                        "id": "g1",
                        "valueAxis": "v1",
                        "bullet": "round",
                        "bulletBorderAlpha": 1,
                        "bulletColor": layoutColors.defaultText,
                        color: layoutColors.defaultText,
                        "bulletSize": 5,
                        "hideBulletsCount": 50,
                        "lineThickness": 2,
                        "lineColor": layoutColors.danger,
                        "type": "smoothedLine",
                        "title": "Actual Attendance ",
                        "useLineColorForBulletBorder": true,
                        "valueField": "present"
                        // "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    }
                ],
                "chartScrollbar": {
                    "graph": "g1",
                    "oppositeAxis": false,
                    "offset": 30,
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    // scrollbarHeight: 50,
                    enabled: false,
                    backgroundAlpha: 0,
                    selectedBackgroundAlpha: 0.05,
                    selectedBackgroundColor: layoutColors.defaultText,
                    graphFillAlpha: 0,
                    autoGridCount: true,
                    selectedGraphFillAlpha: 0,
                    graphLineAlpha: 0.2,
                    selectedGraphLineColor: layoutColors.defaultText,
                    selectedGraphLineAlpha: 1,
                },
                "chartCursor": {
                    "pan": true,
                    "cursorColor": layoutColors.danger,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 0,
                    "valueLineAlpha": 0.2
                },
                "categoryField": "name",
                "categoryAxis": {
                    "axisColor": layoutColors.defaultText,
                    "color": layoutColors.defaultText,
                    "gridColor": layoutColors.defaultText,
                    "parseDates": false,
                    "dashLength": 1,
                    "minorGridEnabled": true
                },
                // "legend": {
                //     "useGraphSettings": false,
                //     "position": "top",
                //     "color": layoutColors.defaultText
                // },
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "export": {
                    "enabled": true
                },
                "dataProvider": data,
                pathToImages: layoutPaths.images.amChart

            };
        }
    }
})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('SiteBarChartForManagerCtrl', ['authService', '$scope', '$stateParams', 'attendanceService', 'baConfig', 'layoutPaths', 'toastrService','utilService','siteManagementService', SiteBarChartForManagerCtrl]);

    /** @ngInject */
    function SiteBarChartForManagerCtrl(authService, $scope, $stateParams, attendanceService, baConfig, layoutPaths, toastrService,utilService,siteManagementService) {
        var vm = this;

        vm.isDataReady = false;
        vm.showSpinner = true;
        vm.user = null;
        vm.searchAttendance = searchAttendance;
        vm.employeeName = null;
        var chart = null;
        var employeeId = null;

        vm.params = {
            page : 1,
            count: 30
        };

        vm.handelPaginatedData = handelPaginatedData;


        function init () {
            searchAttendance();
        }
        init();

        function searchAttendance () {
            siteManagementService.getBarchartDataForASite(vm.params).then(function (response) {
                chart = AmCharts.makeChart("zoomAxisChart", getChartOptions(response.siteDateAttendances), 100);
                chart.dataProvider = response.siteDateAttendances;
                chart.validateData(response.siteDateAttendances, false);
                if (response.siteDateAttendances && response.siteDateAttendances.length) {
                    vm.isDataReady = true
                }
                vm.showSpinner = false;

            }, function (message) {
                vm.showSpinner = false;
                console.error("Failed to fetch site data");
                toastrService.showErrorToastr("Failed to fetch site data :" + message, "", 5000);
            });
        }
        function handelPaginatedData(searchParams){
            modifyParams(searchParams)
            // if(vm.params.page < vm.totalPages)
            searchAttendance();
            // else return toastrService.showErrorToastr('No data left', '', 5000)
        }

        function modifyParams(searchParams) {
            if(searchParams == 'next')
                vm.params.page++;

            if(searchParams == 'prev')
                vm.params.page--;
        }


        function getChartOptions (data) {
            var layoutColors = baConfig.colors;
            return {
                "type": "serial",
                "theme": "none",
                "color": layoutColors.defaultText,
                // "dataDateFormat": "DD MMM",
                // 'siteName' : data.siteName,
                "minSelectedTime":10,
                "precision": 2,
                "autoResize" : true,
                "valueAxes": [{
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v1",
                    "title": "Number of Employees",
                    "position": "left",
                    "autoGridCount": true,
                    "minimum": 0,
                    "labelFunction": function (value) {
                        return "" + Math.round(value) + "";
                    }
                }],
                "graphs": [
                    {
                        "id": "g3",
                        color: layoutColors.defaultText,
                        "valueAxis": "v1",
                        "lineColor": layoutColors.primaryLight,
                        "fillColors": layoutColors.primaryLight,
                        "fillAlphas": 0.8,
                        "lineAlpha": 0.8,
                        "type": "column",
                        "title": "Expected Attendance",
                        "valueField": "expected",
                        "clustered": false,
                        "columnWidth": 0.5,
                        "lineColorField": layoutColors.defaultText,
                        "legendValueText": "[[value]]",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    {
                        "id": "g4",
                        "valueAxis": "v1",
                        color: layoutColors.defaultText,
                        "lineColor": layoutColors.primary,
                        "fillColors": layoutColors.primary,
                        "fillAlphas": 0.9,
                        "lineAlpha": 0.9,
                        "type": "column",
                        "title": "Actual Attendance",
                        "valueField": "actual",
                        "clustered": false,
                        "columnWidth": 0.3,
                        "legendValueText": "[[value]]M",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    { //Red Curve
                        "id": "g1",
                        "valueAxis": "v1",
                        "bullet": "round",
                        "bulletBorderAlpha": 1,
                        "bulletColor": layoutColors.defaultText,
                        color: layoutColors.defaultText,
                        "bulletSize": 5,
                        "hideBulletsCount": 50,
                        "lineThickness": 2,
                        "lineColor": layoutColors.danger,
                        "type": "smoothedLine",
                        "title": "Actual Attendance ",
                        "useLineColorForBulletBorder": true,
                        "valueField": "actual"
                        // "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    }
                ],
                "chartScrollbar": {
                    "graph": "g1",
                    "oppositeAxis": false,
                    "offset": 30,
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    // scrollbarHeight: 1,
                    enabled: false,
                    backgroundAlpha: 0,
                    selectedBackgroundAlpha: 0.05,
                    selectedBackgroundColor: layoutColors.defaultText,
                    graphFillAlpha: 0,
                    autoGridCount: true,
                    selectedGraphFillAlpha: 0,
                    graphLineAlpha: 0.2,
                    selectedGraphLineColor: layoutColors.defaultText,
                    selectedGraphLineAlpha: 1,
                },
                "chartCursor": {
                    "pan": true,
                    "cursorColor": layoutColors.danger,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 0,
                    "valueLineAlpha": 0.2
                },
                "categoryField": "dateInString",
                "categoryAxis": {
                    "axisColor": layoutColors.defaultText,
                    "color": layoutColors.defaultText,
                    "gridColor": layoutColors.defaultText,
                    "parseDates": false,
                    "dashLength": 1,
                    "minorGridEnabled": true,
                    "labelRotation": 45,
                },
                // "legend": {
                //     "useGraphSettings": true,
                //     "position": "top",
                //     "color": layoutColors.defaultText
                // },
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "export": {
                    "enabled": true
                },
                "dataProvider": data,
                pathToImages: layoutPaths.images.amChart

            };
        }
    }
})();


(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('SiteBarIndividualSiteChartCtrl', ['authService', '$scope', '$stateParams', 'attendanceService', 'baConfig', 'layoutPaths', 'toastrService','utilService','siteManagementService', SiteBarIndividualSiteChartCtrl]);

    /** @ngInject */
    function SiteBarIndividualSiteChartCtrl(authService, $scope, $stateParams, attendanceService, baConfig, layoutPaths, toastrService,utilService,siteManagementService) {
        var vm = this;

        vm.isDataReady = false;
        vm.user = null;
        vm.searchAttendance = searchAttendance;
        vm.employeeName = null;
        var chart = null;
        var employeeId = null;


        vm.params = {};

        $scope.$on("selected-site-id", function (event, data) {
            vm.params.page = 1;
            vm.params.count = 30;
            vm.params.siteId = data;
            searchAttendance();
        });


        vm.handelPaginatedData = handelPaginatedData;


        function searchAttendance () {
            siteManagementService.getBarchartDataForASite(vm.params).then(function (response) {
                vm.isDataReady = false;
                chart = AmCharts.makeChart("zoomAxisChart", getChartOptions(response.siteDateAttendances), 100);
                chart.dataProvider = response.siteDateAttendances;
                chart.validateData(response.siteDateAttendances, false);

                if (response.siteDateAttendances && response.siteDateAttendances.length) vm.isDataReady = true;

            }, function (message) {
                console.error("Failed to fetch site data");
                toastrService.showErrorToastr("Failed to fetch site data :" + message, "", 5000);
            });
        }
        function handelPaginatedData(searchParams){
            modifyParams(searchParams)
            // if(vm.params.page < vm.totalPages)
            searchAttendance();
            // else return toastrService.showErrorToastr('No data left', '', 5000)
        }

        function modifyParams(searchParams) {
            if(searchParams == 'next')
                vm.params.page++;

            if(searchParams == 'prev')
                vm.params.page--;
        }


        function getChartOptions (data) {
            var layoutColors = baConfig.colors;
            return {
                "type": "serial",
                "theme": "none",
                "color": layoutColors.defaultText,
                // "dataDateFormat": "DD MMM",
                // 'siteName' : data.siteName,
                "minSelectedTime":10,
                "precision": 2,
                "autoResize" : true,
                "valueAxes": [{
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v1",
                    "title": "Number of Employees",
                    "position": "left",
                    "autoGridCount": true,
                    "minimum": 0,
                    "labelFunction": function (value) {
                        return "" + Math.round(value) + "";
                    }
                }],
                "graphs": [
                    {
                        "id": "g3",
                        color: layoutColors.defaultText,
                        "valueAxis": "v1",
                        "lineColor": layoutColors.primaryLight,
                        "fillColors": layoutColors.primaryLight,
                        "fillAlphas": 0.8,
                        "lineAlpha": 0.8,
                        "type": "column",
                        "title": "Expected Attendance",
                        "valueField": "expected",
                        "clustered": false,
                        "columnWidth": 0.5,
                        "lineColorField": layoutColors.defaultText,
                        "legendValueText": "[[value]]",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    {
                        "id": "g4",
                        "valueAxis": "v1",
                        color: layoutColors.defaultText,
                        "lineColor": layoutColors.primary,
                        "fillColors": layoutColors.primary,
                        "fillAlphas": 0.9,
                        "lineAlpha": 0.9,
                        "type": "column",
                        "title": "Actual Attendance",
                        "valueField": "actual",
                        "clustered": false,
                        "columnWidth": 0.3,
                        "legendValueText": "[[value]]M",
                        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    },
                    { //Red Curve
                        "id": "g1",
                        "valueAxis": "v1",
                        "bullet": "round",
                        "bulletBorderAlpha": 1,
                        "bulletColor": layoutColors.defaultText,
                        color: layoutColors.defaultText,
                        "bulletSize": 5,
                        "hideBulletsCount": 50,
                        "lineThickness": 2,
                        "lineColor": layoutColors.danger,
                        "type": "smoothedLine",
                        "title": "Actual Attendance ",
                        "useLineColorForBulletBorder": true,
                        "valueField": "actual"
                        // "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                    }
                ],
                "chartScrollbar": {
                    "graph": "g1",
                    "oppositeAxis": false,
                    "offset": 30,
                    gridAlpha: 0,
                    color: layoutColors.defaultText,
                    // scrollbarHeight: 50,
                    enabled: false,
                    backgroundAlpha: 0,
                    selectedBackgroundAlpha: 0.05,
                    selectedBackgroundColor: layoutColors.defaultText,
                    graphFillAlpha: 0,
                    autoGridCount: true,
                    selectedGraphFillAlpha: 0,
                    graphLineAlpha: 0.2,
                    selectedGraphLineColor: layoutColors.defaultText,
                    selectedGraphLineAlpha: 1,
                },
                "chartCursor": {
                    "pan": true,
                    "cursorColor": layoutColors.danger,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 0,
                    "valueLineAlpha": 0.2
                },
                "categoryField": "dateInString",
                "categoryAxis": {
                    "axisColor": layoutColors.defaultText,
                    "color": layoutColors.defaultText,
                    "gridColor": layoutColors.defaultText,
                    "parseDates": false,
                    "dashLength": 1,
                    "minorGridEnabled": true,
                    "labelRotation": 45,

                },
                // "legend": {
                //     "useGraphSettings": true,
                //     "position": "top",
                //     "color": layoutColors.defaultText
                // },
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "export": {
                    "enabled": true
                },
                "dataProvider": data,
                pathToImages: layoutPaths.images.amChart

            };
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteManagementDashboard')
        .controller('siteManagementPieChartCtrl', siteManagementPieChartCtrl);

    siteManagementPieChartCtrl.$inject = ['$scope', '$timeout', 'baConfig', 'baUtil','utilService'];

    /** @ngInject */
    function siteManagementPieChartCtrl($scope, $timeout, baConfig, baUtil,utilService) {
        var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
        $scope.hasPermission = utilService.hasPermission;
        $scope.$on("site-attendance-summary-data-loaded", function (event, data) {
            // console.log("site-attendance-summary-data-loaded. data : " + JSON.stringify(data));
            $timeout(function () {
                // $scope.easypiecharts.charts[0].stats = 0;
                $scope.easypiecharts.charts[0].stats = data.present;
                $scope.easypiecharts.charts[1].stats = data.absent;
                $scope.easypiecharts.charts[2].stats = data.onTime;
                $scope.easypiecharts.charts[3].stats = data.late;

                // $scope.easypiecharts.charts[0].percent = 99 > 0 ? Math.round(( (50 * 1.0)/ (99 * 1.0) ) * 100) : 0;
                $scope.easypiecharts.charts[0].percent = data.expectedEmployees > 0 ? Math.round(( (data.present * 1.0)/ (data.expectedEmployees * 1.0) ) * 100) : 0;
                $scope.easypiecharts.charts[1].percent = data.expectedEmployees > 0 ? Math.round(( (data.absent * 1.0)/ (data.expectedEmployees * 1.0) ) * 100) : 0;
                $scope.easypiecharts.charts[2].percent = data.expectedEmployees > 0 ? Math.round(( (data.onTime * 1.0)/ (data.expectedEmployees*1.0) ) * 100) : 0;
                $scope.easypiecharts.charts[3].percent = data.expectedEmployees > 0 ? Math.round(( (data.late * 1.0)/ (data.expectedEmployees*1.0) ) * 100) : 0;
            });
            $scope.easypiecharts = {};
            $scope.easypiecharts.charts = [{
                color: "#1475b7",
                description: 'dashboardPresent',
                // stats: $scope.dashboardData.present,
                stats: 0,
                icon: 'person',
                // percent: $scope.dashboardData.totalEmployee > 0 ? (($scope.dashboardData.present/$scope.dashboardData.totalEmployee) * 100) : 0,
                percent: data.present,
                options:getOption("#7899f0")
            }, {
                color: pieColor,
                description: 'dashboardAbsent',
                stats: 0,
                icon: 'absent',
                percent: data.present,
                // stats: $scope.dashboardData.absent,
                // icon: 'absent',
                // percent:  $scope.dashboardData.totalEmployee > 0 ? (($scope.dashboardData.absent/$scope.dashboardData.totalEmployee) * 100) : 0
                options:getOption("#ff2e4b")
            }, {
                color: pieColor,
                description: 'dashboardOntime',
                // stats: $scope.dashboardData.onTime,
                stats: 0,
                icon: 'ontime',
                percent: data.present,
                // percent: $scope.dashboardData.present > 0 ? (($scope.dashboardData.onTime/$scope.dashboardData.present) * 100) : 0
                options:getOption("#00c1aa")
            }, {
                color: pieColor,
                description: 'dashboardLate',
                // stats: $scope.dashboardData.late,
                stats: 0,
                icon: 'late',
                // percent: $scope.dashboardData.present > 0 ? (($scope.dashboardData.late/$scope.dashboardData.present) * 100) : 0
                percent: data.present,
                options:getOption("#f7b900")
            }
            ];
        });

        function getOption(color){
            return {
                easing: 'easeOutBounce',
                onStep: function (from, to, percent) {
                    $(this.el).find('.percent').text(Math.round(percent));
                },
                // barColor: chart.attr('rel'),
                barColor: color,
                trackColor:pieColor,
                size: 64,
                scaleLength: 0,
                animation: 2000,
                lineWidth: 6,
                lineCap: 'round'
            }
        }

        /*$scope.easypiecharts.options = {
            easing: 'easeOutBounce',
            onStep: function (from, to, percent) {
                $(this.el).find('.percent').text(Math.round(percent));
            },
            // barColor: chart.attr('rel'),
            barColor: '#2C3E50',
            trackColor: 'rgba(0,0,0,0)',
            size: 64,
            scaleLength: 0,
            animation: 2000,
            lineWidth: 6,
            lineCap: 'round'
        };*/
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteAttendanceReport')
        .controller('SiteAttendanceEntryExitImageModalCtrl', ['$scope',"$sce", '$stateParams', '$state',"API", '$timeout', '$uibModal','$uibModalInstance','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService','siteInfo', SiteAttendanceEntryExitImageModalCtrl]);

    /** @ngInject */
    function SiteAttendanceEntryExitImageModalCtrl($scope,$sce, $stateParams, $state,API, $timeout,$uibModal,$uibModalInstance,utilService, authService, employeeService, toastrService,siteManagementService,siteInfo) {
        var vm = this;
        vm.siteInfo = siteInfo['data'];

        vm.imageCategory=siteInfo['imageCategory'];

        vm.entryImageUrl=vm.siteInfo.siteInPictureUrl;
        vm.exitImageUrl=vm.siteInfo.siteOutPictureUrl;


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteAttendanceReport')
        .controller('SiteAttendanceLocationModalCtrl', ['$scope', "$sce", '$stateParams', '$state', "API", '$timeout', '$uibModal', '$uibModalInstance', 'utilService', 'authService', 'employeeService', 'toastrService', 'siteManagementService', 'siteInfo', SiteAttendanceLocationModalCtrl]);

    /** @ngInject */
    function SiteAttendanceLocationModalCtrl($scope, $sce, $stateParams, $state, API, $timeout, $uibModal, $uibModalInstance, utilService, authService, employeeService, toastrService, siteManagementService, siteInfo) {
        var vm = this;
        vm.siteInfo = siteInfo;
        vm.mapKey = API.googleApiKey

        vm.mapUrl = $sce.trustAsResourceUrl("https://www.google.com/maps/embed/v1/place?key=" + vm.mapKey + "&center=" + vm.siteInfo.siteLatitude + "," + vm.siteInfo.siteLongitude + "&q=" + vm.siteInfo.siteLatitude + "," + vm.siteInfo.siteLongitude)

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.reception')
        .controller('CheckInCtrl', ['$rootScope','$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'API', 'toastrService', 'appointmentService', 'VISITOR_QUESTIONS', 'visitorCardService', 'visitHistoryService', '$q', 'employeeService', 'visitorCategoryService', 'visitorAccessAreaService', 'visitPurposeService', CheckInCtrl]);

    /** @ngInject */
    function CheckInCtrl($rootScope,$scope, $stateParams, $state, $timeout, $uibModal, API, toastrService, appointmentService, VISITOR_QUESTIONS, visitorCardService, visitHistoryService, $q, employeeService, visitorCategoryService, visitorAccessAreaService, visitPurposeService) {
        var vm = this;

        vm.selectedTab = "newAppointment";
        vm.searchKeyword = "";
        vm.numberOfPages = 0;
        vm.selectedPage = 0;
        vm.total = 0;
        vm.rowsPerPage = 6;
        vm.isDataLoaded = false;
        vm.visitors = [];
        vm.selectedVisitor = null;
        // vm.receptionistName = authService.getLoggedInUser().name;
        vm.numberOfButtons = null;
        vm.pageState = "inputAppointmentInfo";
        vm.checkAllQuestions = false;
        vm.questions = angular.copy(VISITOR_QUESTIONS);
        vm.availableCards = [];
        vm.selectedCard = [];
        vm.carriedItem = initialiseItem();
        vm.carriedItems = [];

        vm.createAppointmentForm = null;
        vm.existingVisitors = [];
        vm.employees = [];
        vm.hostDropDownList = [];
        vm.selectedHost = {};
        vm.visitor = null;
        vm.visitorCategories = [];
        vm.accessAreas = [];
        vm.selectedAccessAreaId = null;
        vm.visitPurposes = [];
        vm.selectedVisitPurposeId = null;
        vm.searchParams = {};



        vm.switchTab = switchTab;
        vm.getVisitorsOfToday = getVisitorsOfToday;
        vm.selectVisitorForCheckingIn = selectVisitorForCheckingIn;
        vm.getFilteredVisitorList = getFilteredVisitorList;
        vm.toggleAllCheckboxes = toggleAllCheckboxes;
        vm.goToVisitorItemPage = goToVisitorItemPage;
        vm.goToVisitorListPage = goToVisitorListPage;
        vm.addItem = addItem;
        vm.openCheckInConfirmationModal = openCheckInConfirmationModal;
        vm.cancelCurrentOperation = cancelCurrentOperation;
        vm.setVisitorInputs = setVisitorInputs;
        vm.getAllOnEmptySearchKeyword = getAllOnEmptySearchKeyword;
        // vm.checkStatus= checkStatus;
        vm.goToNewAppointmentTab = goToNewAppointmentTab;
        vm.openPhotoCaptureModal = openPhotoCaptureModal;

        function init(){
            initiateNewAppointmentPage();
        }
        init();
        vm.searchByEmployeeId = function (selectedEmployee) {
            vm.searchParams.employeeId = selectedEmployee.id;
            vm.searchText = selectedEmployee.name;
        }
        function switchTab(tabName){
            vm.selectedTab = tabName;
            resetPaginationData();
            resetVariables();
            if(tabName === "preRegisteredAppointment") {
                getVisitorsOfToday();
                vm.pageState = "showVisitorList";
            } else if(tabName === "newAppointment") {
                vm.pageState = "inputAppointmentInfo";
                initiateNewAppointmentPage();
            }
        }

        function initiateNewAppointmentPage() {
            vm.isDataLoaded = false;
            $q.all([
                getVisitorCategories(),
                getExistingVisitors(),
                getAllAccessAreas(),
                getAllVisitPurpose()
            ]).then(function () {
                vm.isDataLoaded = true;
                vm.visitor = initialiseVisitor();
            }, function (error) {
                toastr.error("Error: " + error);
            });
        }
        function checkStatus(status){
            if(status ===2 ){
                toastrService.showErrorToastr("Selected visitor is blocked","",5000);
            }
        }

        function getVisitorCategories() {
            return visitorCategoryService.getAllVisitorCategories().then(function (data) {
                vm.visitorCategories = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not load visitor categories", "", 5000);
            });
        }

        function getExistingVisitors() {
            return appointmentService.getAvailableVisitors().then(function (data) {
                vm.existingVisitors = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get existing visitors: " + error, "", 5000);
            });
        }

        function getEmployeesForHostSelectionList() {
            return employeeService.getFilteredEmployees({status: 1}).then(function (data){
                vm.employees = angular.copy(data.employees);
                generateHostSelectionOptions();
            });
        }

        function generateHostSelectionOptions() {
            vm.employees.forEach(function (employee) {
                var pictureElement = "<img src='../assets/img/theme/no-avatar.png' />";
                if(employee.pictureUrl != null && employee.pictureUrl !== "") {
                    pictureElement = "<img src='" + employee.pictureUrl + "' />";
                }
                var designationNameElement = "";
                var departmentNameElement = "";
                if(employee.designationName != null && employee.designationName !== "") {
                    designationNameElement = "<span>" + employee.designationName + "</span>";
                }
                if(employee.departmentName != null && employee.departmentName !== "") {
                    departmentNameElement = "<span>" + employee.departmentName + "</span>";
                    if(designationNameElement.length > 0)
                        departmentNameElement = ", " + departmentNameElement;
                }

                var optionTemplate = "<div class='flex-container text-left width-95'>" +
                    "<div class='with-round-bg mb-0'>" +
                    pictureElement +
                    "</div>" +
                    "<div class='profile-info'>" +
                    "<span>" + employee.name + "</span>" +
                    "<div class='font-12 info-bg'>" +
                    "<small>" +
                    designationNameElement + departmentNameElement +
                    "</small>" +
                    "</div>" +
                    "</div>" +
                    "</div>";

                var obj = {
                    id: employee.id,
                    name: employee.name,
                    label: optionTemplate,
                    employeeOfficeId: employee.employeeOfficeId,
                    ticked: false
                };
                vm.hostDropDownList.push(obj);
            });
        }

        function getAllAccessAreas() {
            return visitorAccessAreaService.getAllAccessAreas().then(function (data) {
                vm.accessAreas = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get visitor access area: " + error, "", 5000);
            });
        }

        function getAllVisitPurpose() {
            return visitPurposeService.getAllVisitPurpose().then(function (data) {
                vm.visitPurposes = data;
            }, function (error) {
                toastrService.showErrorToastr("Could not get visit purpose list: " + error, "", 5000);
            });
        }

        function initialiseVisitor() {
            return {
                id: null,
                name: null,
                mobile: null,
                categoryId: null,
                organisationName: null
            };
        }

        function getVisitorsOfToday(params) {
            vm.isDataLoaded = false;
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            params = getRequestParameters();
            appointmentService.getVisitorsOfToday(params).then(function (data) {
                vm.visitors = data.visitors;
                vm.selectedPage = data.currentPage;
                vm.numberOfPages = data.numberOfPages;
                vm.total = data.total;
                vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            }, function (error) {
                toastrService.showErrorToastr("Could not get today's visitor list: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function selectVisitorForCheckingIn(item) {

            vm.selectedVisitor = item;
            vm.pageState = "showAppointmentInfo";
            vm.questions = angular.copy(VISITOR_QUESTIONS);
             // checkStatus(vm.selectedVisitor.status);
        }

        function getFilteredVisitorList() {
            getVisitorsOfToday(vm.perPage, 0);
        }

        function getAllOnEmptySearchKeyword() {
            if(vm.searchKeyword === "" || vm.searchKeyword.length === 0) getVisitorsOfToday(vm.perPage, 0);
        }


        function getRequestParameters(){
            return {
                pageNumber   : vm.selectedPage,
                perPage      : vm.rowsPerPage,
                keyword      : vm.searchKeyword
            };
        }

        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.selectedPage = vm.selectedPage == 0? 0 : vm.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.selectedPage = vm.selectedPage == vm.numberOfPages ? vm.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.selectedPage = searchParams;
            }
        }

        function resetPaginationData() {
            vm.searchKeyword = "";
            vm.numberOfPages = 0;
            vm.selectedPage = 0;
            vm.total = 0;
            vm.numberOfButtons = null;
        }

        function toggleAllCheckboxes() {
            vm.questions.forEach(function (item) {
               item.value = vm.checkAllQuestions;
            });
        }

        function goToVisitorItemPage() {
            vm.pageState = "assignCardToVisitor";
            getAvailableCards();
        }

        function cancelCurrentOperation() {
            resetVariables();
            if(vm.selectedTab === "preRegisteredAppointment") {
                goToVisitorListPage();
            } else if(vm.selectedTab === "newAppointment") {
                initiateNewAppointmentPage();
            }
        }

        function goToVisitorListPage() {
            resetPaginationData();
            getVisitorsOfToday();
            vm.pageState = "showVisitorList";
        }

        function resetVariables() {
            if(vm.selectedTab === "newAppointment" && vm.createAppointmentForm != null) {
                vm.createAppointmentForm.$setPristine();
                vm.createAppointmentForm.$setUntouched();
            }

            vm.availableCards = [];
            vm.selectedCard = [];
            vm.carriedItems = [];
            vm.carriedItem = initialiseItem();
            vm.selectedVisitor = null;
            vm.searchKeyword=null;

            vm.createAppointmentForm = null;
            vm.existingVisitors = [];
            vm.employees = [];
            vm.hostDropDownList = [];
            vm.selectedHost = {};
            vm.visitor = null;
            vm.visitorCategories = [];
            vm.accessAreas = [];
            vm.selectedAccessAreaId = null;
            vm.visitPurposes = [];
            vm.selectedVisitPurposeId = null;
        }

        function getAvailableCards() {
            vm.isDataLoaded = false;
            visitorCardService.getAvailableCards().then(function (data) {
                vm.availableCards = data;
                vm.availableCards.forEach(function (item) {
                    item.label = item.code + ' - ' + item.rfid;
                });
            }, function (error) {
                toastrService.showErrorToastr("Could not get available cards: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function addItem() {
            toastrService.clearPreviousToastr();
            if(vm.carriedItem.quantity == null || Number(vm.carriedItem.quantity) <= 0 || isNaN(vm.carriedItem.quantity))
                return toastrService.showErrorToastr("Invalid item quantity");
            if(vm.carriedItem.name == null || vm.carriedItem.name.trim() === "")
                return toastrService.showErrorToastr("Item name can not be empty");
            vm.carriedItems.push(angular.copy(vm.carriedItem));
            vm.carriedItem = initialiseItem();
        }

        function initialiseItem() {
            return {
                name: null,
                description: null,
                quantity: null
            };
        }

        function openCheckInConfirmationModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/reception/partials/checkIn/modals/checkInConfirmation.modal.html',
                size: 'md',
                controller : 'CheckInConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    visitorName: function () {
                        return (vm.selectedTab === "preRegisteredAppointment") ? vm.selectedVisitor.visitorName : vm.visitor.name;
                    }
                }
            }).result.then(function () {
                if(vm.selectedTab === "preRegisteredAppointment") {
                    checkInVisitor();
                } else if(vm.selectedTab === "newAppointment") {
                    createAppointmentAndCheckInVisitor();
                }
            });
        }

        function checkInVisitor() {
            var data = {
                appointmentId: vm.selectedVisitor.appointmentId,
                visitorId: vm.selectedVisitor.visitorId,
                visitorCardId: vm.selectedCard[0].id,
                questionnaires: JSON.stringify(vm.questions),
                carriedItems: vm.carriedItems
            };
            vm.isDataLoaded = false;

            visitHistoryService.checkInVisitor(data).then(function (data) {
                $rootScope.$broadcast('visitorManagment.VisitorCheckedIn',1);
                vm.selectedHost={};
                openSuccessModal();
            }, function (error) {
                    toastrService.showErrorToastr("Could not check-in visitor: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
                goToVisitorListPage();
            });
        }

        function setVisitorInputs(item) {
            vm.visitor.id = item.id;
            vm.visitor.name = item.name;
            vm.visitor.categoryId = item.visitorCategoryId;
            vm.visitor.organisationName = item.organisationName;
            if(!vm.visitor.pictureUpdated && vm.visitor.pictureUrl == null) vm.visitor.pictureUrl = item.pictureUrl;
        }

        function createAppointmentAndCheckInVisitor() {
            var data = {
                visitor: vm.visitor,
                visitPurposeId: vm.selectedVisitPurposeId,
                hostId: vm.selectedHost.id,
                accessAreaId: vm.selectedAccessAreaId,
                visitorCardId: vm.selectedCard[0].id,
                questionnaires: JSON.stringify(vm.questions),
                carriedItems: vm.carriedItems
            };

            vm.isDataLoaded = false;

            visitHistoryService.createAppointmentAndCheckInVisitor(data).then(function (data) {
                $rootScope.$broadcast('visitorManagment.VisitorCheckedIn',1);
                vm.selectedHost={};
                openSuccessModal();
            }, function (error) {
                if(error =='409 Conflict')
                    toastrService.showErrorToastr("RFID already assigned, please try with another one", "", 5000)
                else
                    toastrService.showErrorToastr("Could not check-in visitor: " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
                resetVariables();
                vm.pageState = "inputAppointmentInfo";
                initiateNewAppointmentPage();
            });
        }

        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/modals/success.modal.html',
                size: 'md',
                controller : 'SuccessModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'visitorManagement.successModal.checkInSuccessMsg';
                    }
                }
            }).result.then(function () {

            });
        }

        function goToNewAppointmentTab(){
            vm.selectedTab = 'newAppointment';
            vm.pageState = 'inputAppointmentInfo';
        }

        function openPhotoCaptureModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/visitorManagement/createAppointment/modals/capturePhoto.modal.html',
                size: 'md',
                controller : 'CapturePhotoModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
            }).result.then(function (imgDataUrl) {
                if(imgDataUrl != null) {
                    vm.visitor.pictureUrl = imgDataUrl;
                    vm.visitor.pictureUpdated = true;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.siteManagement.siteSummaryReport')
        .controller('LocationModalCtrl', ['$scope',"$sce", '$stateParams', '$state',"API", '$timeout', '$uibModal','$uibModalInstance','utilService', 'authService', 'employeeService', 'toastrService','siteManagementService','siteInfo', LocationModalCtrl]);

    /** @ngInject */
    function LocationModalCtrl($scope,$sce, $stateParams, $state,API, $timeout,$uibModal,$uibModalInstance,utilService, authService, employeeService, toastrService,siteManagementService,siteInfo) {
        var vm = this;

        vm.siteInfo = siteInfo;
        vm.mapKey = API.googleApiKey
        vm.mapUrl = $sce.trustAsResourceUrl("https://www.google.com/maps/embed/v1/place?key="+vm.mapKey+"&center="+vm.siteInfo.latitude+","+vm.siteInfo.longitude+"&q="+vm.siteInfo.latitude+","+vm.siteInfo.longitude)
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.reception')
        .controller('CheckOutCtrl', ['$scope', '$stateParams', '$state', '$timeout', 'authService', 'employeeService', 'toastrService', '$uibModal','utilService','visitHistoryService', CheckOutCtrl]);

    /** @ngInject */
    function CheckOutCtrl($scope, $stateParams, $state, $timeout, authService, employeeService, toastrService, $uibModal,utilService,visitHistoryService) {
        var vm = this;
        vm.filterParams = {};
        vm.checkedInTotal = 0;
        vm.checkedOutTotal = 0;
        vm.onPremiseTotal = 0;
        vm.pageNumber = 0;
        vm.rowsPerPage = utilService.getRowsPerPage();
        vm.rowsPerPage = utilService.setRowsPerPage(5);
        vm.numberOfPages = 1;
        vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
        vm.filterParams.selectedPage = 0;
        vm.total = 10;
        vm.isAnyProfileSelected = false;
        vm.isDataLoaded = false;
        vm.checkOutToShow = {};
        vm.searchKeyword = null;
        vm.isCheckOutModalOpened = false;
        vm.disableCheckOutButton  =  false;
        vm.showProfile = showProfile;
        vm.hideProfile = hideProfile;
        vm.getPageSpecifiedData = getPageSpecifiedData;
        vm.getCheckhOutInfo = getCheckOutInfo;
        vm.getPageSpecifiedCheckOuts = getPageSpecifiedCheckOuts;
        vm.openCheckOutModal = openCheckOutModal;
        vm.getAllOnEmptySearchKeyword = getAllOnEmptySearchKeyword;

        function showProfile(data){
            vm.isDataLoaded = true;
            vm.checkOutToShow = data;
        }
        function hideProfile(){
            vm.isAnyProfileSelected = false;
        }
        init();
        function init(){
            getPageSpecifiedCheckOuts();
        }
        function getPageSpecifiedData(params){
            if(params != undefined && params != null) {
                modifyParams(params);
            }
            vm.isDataLoaded = false;
            getPageSpecifiedCheckOuts()
        }
        function openCheckOutModal(id){
            toastrService.clearPreviousToastr();
            vm.isCheckOutModalOpened = true
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/visitorManagement/reception/partials/checkOut/checkOutProfile/checkOutModal.html',
                size        : 'md',
                controller  : 'CheckOutModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     :
                    {
                        visitToCheckOutId:function () {
                            return id;
                        }
                    }
            }).result.then(function (){
                checkOutVisitor(id);
            },function (){
                vm.isCheckOutModalOpened=false;
            }).catch (function(err){
                console.log(err);
            });
        }
        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation   : true,
                templateUrl : 'app/pages/main/visitorManagement/modals/success.modal.html',
                size        : 'md',
                controller  : 'SuccessModalCtrl',
                controllerAs: 'vm',
                backdrop : 'static',
                resolve     : {
                    successMsg: function () {
                        return 'visitorManagement.successModal.checkOutSuccessMsg';
                    }
                }
            }).result.then(function () {

            });
        }
        function checkOutVisitor(id){
            vm.checkOutToShow = {};
            vm.isCheckOutModalOpened = false
            vm.isDataLoaded = false;
            hideProfile();
            vm.disableCheckOutButton = true;
            visitHistoryService.checkOutVisit(id).then(onCheckOutSuccess,onCheckOutFailure)
        }
        function onCheckOutSuccess(){
            openSuccessModal()
            getPageSpecifiedCheckOuts();

        }
        function onCheckOutFailure(){
            toastrService.showErrorToastr("Visitor check-out unsuccessful", "", 5000);
        }
        function modifyParams(searchParams) {
            if(searchParams == 'prev'){
                vm.filterParams.selectedPage = vm.filterParams.selectedPage == 0? 0 : vm.filterParams.selectedPage - 1;
            }else if(searchParams == 'next') {
                vm.filterParams.selectedPage = vm.filterParams.selectedPage == vm.numberOfPages ? vm.filterParams.selectedPage : vm.selectedPage + 1;
            }else if(!isNaN(searchParams)){
                vm.filterParams.selectedPage = searchParams;
            }
        }
        $scope.$on('visitorManagment.VisitorCheckedIn',function(data){
            getPageSpecifiedCheckOuts();
        });
        function getPageSpecifiedCheckOuts(){
            vm.filterParams.searchKeyword=vm.searchKeyword;
            vm.isDataLoaded = false;
            hideProfile();
            visitHistoryService.getAllCheckOut(vm.filterParams).then(onListFetchSuccess,onListFetchFailure)
        }

        function getAllOnEmptySearchKeyword() {
            if(vm.searchKeyword === "" || vm.searchKeyword.length === 0) getPageSpecifiedCheckOuts();
        }

        function getCheckOutInfo(id){
            vm.checkOutToShow = {};
            vm.isDataLoaded = false;
            vm.isAnyProfileSelected = true;
            visitHistoryService.getCheckOutInfo(id).then(onDataFetchSuccess,onDataFetchFailure)
        }
        function onDataFetchSuccess(data){
           showProfile(data);
        }
        function onDataFetchFailure(error){
            toastrService.showErrorToastr("Failed to fetch data: " + error,"", 5000);
            console.error("Failed to fetch data");
        }

        function onListFetchSuccess(data){
            vm.isDataLoaded = true;
            vm.totalCheckOuts = data.checkOutList;
            vm.numberOfPages = data.totalPages;
            vm.numberOfButtons = Array(vm.numberOfPages).fill(1);
            vm.checkedInTotal = data.checkedIn;
            vm.checkedOutTotal = data.checkedOut;
            vm.onPremiseTotal = data.onPremise;
            vm.total = data.checkedIn;
        }
        function onListFetchFailure(error){
            toastrService.showErrorToastr("Failed to fetch list: " + error,"", 5000);
            console.error('Failed');
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.assignRole')
    app.controller('AssignRoleCreateModalCtrl', ['assignRoleService','employeeService','authService','$uibModalInstance','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', AssignRoleCreateModalCtrl]);

    /** @ngInject */
    function AssignRoleCreateModalCtrl(assignRoleService,employeeService,authService,$uibModalInstance,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.employeeList = null;
        vm.roleList = [
            {name : 'Admin', value : 'VISITOR_MANAGEMENT_ADMIN', selected : false},
            {name : 'Receptionist', value : 'VISITOR_MANAGEMENT_RECEPTIONIST', selected : false},
        ];
        vm.selectedEmployee = null;
        vm.selectedRole = null;
        vm.isCreating = false;

        var analyticsCreateTitle = 'Create Role Modal';
        var analyticsCreateUrl = 'create-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Role In' + document.title, ANALYTICS_CONSTANT.open);

        vm.assignEmployeeRole = assignEmployeeRole;

        function init() {
            employeeService.getFilteredEmployeeNames({status:1,excludedEmployeeIds:[]}).then(function (data){
                vm.employeeList = data.employees;
            });
        }

        init();

        function assignEmployeeRole () {
            toastrService.clearPreviousToastr();
            if(vm.selectedEmployee.length === 0)
                return toastrService.showErrorToastr("Please select an employee")
            if(vm.selectedRole.length === 0)
                return toastrService.showErrorToastr("Please select a role")
            vm.isCreating = true;
            assignRoleService.assignRole({employeeId:vm.selectedEmployee[0].id, role:vm.selectedRole[0].value})
                .then(assignEmployeeRoleSuccess,assignEmployeeRoleFailure).finally(function (){
                    vm.isCreating = false;
            })
        }

        function assignEmployeeRoleSuccess(data) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Role In' + document.title, ANALYTICS_CONSTANT.create);
            toastrService.showSuccessToastr("Employee is successfully assigned to a role")
            $uibModalInstance.close(data);
        }

        function assignEmployeeRoleFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.assignRole')
    app.controller('EmployeeRoleDeleteModalCtrl', ['assignRoleService','authService','$uibModalInstance','toastrService','roleToDelete', 'analyticsService', 'ANALYTICS_CONSTANT', EmployeeRoleDeleteModalCtrl]);

    /** @ngInject */
    function EmployeeRoleDeleteModalCtrl(assignRoleService,authService,$uibModalInstance,toastrService,roleToDelete, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.roleToDelete = null;
        vm.isCreating = false;

        var analyticsDeleteTitle = 'Delete Role Modal';
        var analyticsDeleteUrl = 'delete-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Role In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteEmployeeRole = deleteEmployeeRole;

        function init() {
            vm.roleToDelete = roleToDelete;
        }

        init();

        function deleteEmployeeRole(employeeId) {
            vm.isCreating = true;
            assignRoleService.deleteEmployeeRole(employeeId).then(onEmployeeRoleDeleteSuccess,onEmployeeRoleDeleteFailure).finally(function (){
                vm.isCreating = false;
            })
        }

        function onEmployeeRoleDeleteSuccess() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Role In' + document.title, ANALYTICS_CONSTANT.delete);
            $uibModalInstance.close();
            toastrService.showSuccessToastr("Employee Role Deleted");
        }

        function onEmployeeRoleDeleteFailure(error) {
            toastrService.showErrorToastr("Could not delete: " + error, "", 5000);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitorCategory')
    app.controller('EmployeeRoleUpdateModalCtrl', ['assignRoleService','authService','$uibModalInstance','toastrService','selectedEmployee', 'analyticsService', 'ANALYTICS_CONSTANT', EmployeeRoleUpdateModalCtrl]);

    /** @ngInject */
    function EmployeeRoleUpdateModalCtrl(assignRoleService,authService,$uibModalInstance,toastrService,selectedEmployee, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.roleList = [
            {name : 'Admin', value : 'VISITOR_MANAGEMENT_ADMIN', selected : false},
            {name : 'Receptionist', value : 'VISITOR_MANAGEMENT_RECEPTIONIST', selected : false},
        ];
        vm.selectedEmployee = null;
        vm.selectedRole = [];
        vm.isCreating = false;

        var analyticsEditTitle = 'Edit Role Modal';
        var analyticsEditUrl = 'edit-role';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Role In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateEmployeeRole = updateEmployeeRole;

        function init() {
            vm.selectedEmployee = selectedEmployee;
            var initialRole = getRoleFromName(vm.selectedEmployee.roleList[0]);
            vm.selectedRole.push({"value" : initialRole.value});
            initialRole.selected = true;
        }

        init();

        function updateEmployeeRole () {
            toastrService.clearPreviousToastr();
            if(!vm.selectedRole)
                return toastrService.showErrorToastr("Please select a role")
            vm.isCreating = true;
            assignRoleService.updateEmployeeRole({employeeId:vm.selectedEmployee.id, role:vm.selectedRole[0].value})
                .then(onEmployeeRoleUpdateSuccess,onEmployeeRoleUpdateFailure).finally(function (){
                    vm.isCreating = false;
            })
        }

        function getRoleFromName(roleName) {
            return vm.roleList.find(function (role) {
                return role.name === roleName;
            });
        }

        function onEmployeeRoleUpdateSuccess(data) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Role In' + document.title, ANALYTICS_CONSTANT.edit);
            $uibModalInstance.close(data);
        }

        function onEmployeeRoleUpdateFailure(error) {
            toastr.error(error);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.manageCard')
        .controller('CreateModalCtrl', [ '$uibModalInstance', 'toastrService','visitorCardService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateModalCtrl]);

    /** @ngInject */
    function CreateModalCtrl($uibModalInstance, toastrService,visitorCardService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.rfid = null;
        vm.code = null;
        vm.isCreating  = false;
        var analyticsCreateTitle = 'Create Visitor Card Modal';
        var analyticsCreateUrl = 'create-visitor-card';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Visitor Card In' + document.title, ANALYTICS_CONSTANT.open);

        vm.submit = submit;

        function submit() {
            toastrService.clearPreviousToastr();
            if(vm.rfid == null || vm.rfid == "") return toastrService.showErrorToastr("RFID is empty");
            if(vm.rfid != null && vm.rfid.length > 10) return toastrService.showErrorToastr("RFID is too long");
            if(vm.code == null || vm.code == "") return toastrService.showErrorToastr("Short code is empty");
            var data = {
                code: vm.code,
                rfid: vm.rfid
            };
            createVisitorCard(data)
        }
        function createVisitorCard(data) {
            toastrService.clearPreviousToastr();
            vm.isDataLoaded = false;
            vm.isCreating = true;
            visitorCardService.createVisitorCard(data).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Visitor Card In' + document.title, ANALYTICS_CONSTANT.create);
                toastrService.showSuccessToastr("Visitor card creation successful");
                $uibModalInstance.close(data);
            }, function (error) {
                vm.isDataLoaded = true;
                toastrService.showErrorToastr("Could not create visitor card: " + error, "", 5000);
            }).finally(function (){
                vm.isCreating = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.manageCard')
        .controller('DeleteModalCtrl', [ '$uibModalInstance', 'toastrService', 'visitorCard', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteModalCtrl]);

    /** @ngInject */
    function DeleteModalCtrl($uibModalInstance, toastrService, visitorCard, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        var analyticsDeleteTitle = 'Delete Visitor Card Modal';
        var analyticsDeleteUrl = 'delete-visitor-card';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Visitor Card In' + document.title, ANALYTICS_CONSTANT.open);

        vm.card = visitorCard;
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.manageCard')
        .controller('EditModalCtrl', [ '$uibModalInstance', 'toastrService', 'visitorCard', 'analyticsService', 'ANALYTICS_CONSTANT', EditModalCtrl]);

    /** @ngInject */
    function EditModalCtrl($uibModalInstance, toastrService, visitorCard , analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.card = visitorCard;
        vm.card.status = false;
        var analyticsEditTitle = 'Edit Visitor Card Modal';
        var analyticsEditUrl = 'edit-visitor-card';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Visitor Card In' + document.title, ANALYTICS_CONSTANT.open);

        vm.submit = submit;

        function submit() {
            if(vm.card.rfid != null && vm.card.rfid.length > 10) return toastrService.showErrorToastr("RFID is too long");

            var data = {
                id: vm.card.id,
                code: vm.card.code,
                rfid: vm.card.rfid,
                status: vm.card.status ? 1 : 0
            };
            $uibModalInstance.close(data);
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitPurpose')
    app.controller('VisitPurposeCreateModalCtrl', ['visitPurposeService','authService','$uibModalInstance','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', VisitPurposeCreateModalCtrl]);

    /** @ngInject */
    function VisitPurposeCreateModalCtrl(visitPurposeService,authService,$uibModalInstance,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.create = {};
        vm.create.createVisitPurposeName = null;
        vm.isCreating = false;
        var loggedInUser= authService.getAllInformation();

        var analyticsCreateTitle = 'Create Visit Purpose Modal';
        var analyticsCreateUrl = 'create-visit-purpose';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Visit Purpose In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createVisitPurpose= createVisitPurpose;

        function createVisitPurpose () {
            toastrService.clearPreviousToastr();
            if(vm.create.createVisitPurposeName === null)
                return toastrService.showErrorToastr("Visitor purpose name cannot be empty");
            vm.isCreating = true;
            visitPurposeService.createVisitPurpose({
                text:vm.create.createVisitPurposeName,
                officeId:loggedInUser.office.id,
                createdBy:loggedInUser.id,
            }).then(onVisitPurposeCreateSuccess, onVisitPurposeCreateFailure).finally(function (){
                vm.isCreating = false;
            });
        }

        function onVisitPurposeCreateSuccess(visitPurposeList) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Visit Purpose In' + document.title, ANALYTICS_CONSTANT.create);
            toastrService.showSuccessToastr("Visit purpose Created Successfully");
            $uibModalInstance.close(visitPurposeList);
        }

        function onVisitPurposeCreateFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitPurpose')
    app.controller('VisitPurposeModalDeleteCtrl', ['visitPurposeService','authService','$uibModalInstance','toastrService','purposeToChange', 'analyticsService', 'ANALYTICS_CONSTANT', VisitPurposeModalDeleteCtrl]);

    /** @ngInject */
    function VisitPurposeModalDeleteCtrl(visitPurposeService,authService,$uibModalInstance,toastrService,purposeToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.delete = {};
       // var loggedInUser=u authService.getAllInformation();
        vm.purposeToChange = angular.copy(purposeToChange);
        vm.isCreating = false;
        var analyticsDeleteTitle = 'Delete Visit Purpose Modal';
        var analyticsDeleteUrl = 'delete-visit-purpose';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Visit Purpose In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteVisitPurpose= deleteVisitPurpose;

        function deleteVisitPurpose (purposeToChangeId) {
            vm.isCreating = true;
            visitPurposeService.deleteVisitPurpose(purposeToChangeId).then(onVisitPurposeDeleteSuccess, onVisitPurposeDeleteFailure).finally(function (){
                vm.isCreating = false;
            });
        }

        function onVisitPurposeDeleteSuccess(visitPurposeList) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Visit Purpose In' + document.title, ANALYTICS_CONSTANT.delete);
            $uibModalInstance.close(visitPurposeList);
        }

        function onVisitPurposeDeleteFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitPurpose')
    app.controller('VisitPurposeUpdateModalCtrl', ['visitPurposeService','authService','$uibModalInstance','toastrService','purposeToChange', 'analyticsService', 'ANALYTICS_CONSTANT', VisitPurposeUpdateModalCtrl]);

    /** @ngInject */
    function VisitPurposeUpdateModalCtrl(visitPurposeService,authService,$uibModalInstance,toastrService,purposeToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.update = {};
        vm.purposeToChange = angular.copy(purposeToChange);
        vm.isCreating = false;
        var analyticsEditTitle = 'Edit Visit Purpose Modal';
        var analyticsEditUrl = 'edit-visit-purpose';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Visit Purpose In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateVisitPurpose= updateVisitPurpose;

        function updateVisitPurpose (purposeToChangeId) {
            vm.isCreating = true;
            visitPurposeService.updateVisitPurpose(purposeToChangeId,{text:vm.purposeToChange.text})
                .then(onVisitPurposeUpdateSuccess, onVisitPurposeUpdateFailure).finally(function (){
                    vm.isCreating = false;
            });
        }

        function onVisitPurposeUpdateSuccess(visitPurposeList) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Visit Purpose In' + document.title, ANALYTICS_CONSTANT.edit);
            $uibModalInstance.close(visitPurposeList);
        }

        function onVisitPurposeUpdateFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitorCategory')
    app.controller('VisitorCategoryCreateModalCtrl', ['visitorCategoryService','authService','$uibModalInstance','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', VisitorCategoryCreateModalCtrl]);

    /** @ngInject */
    function VisitorCategoryCreateModalCtrl(visitorCategoryService,authService,$uibModalInstance,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isCreating = false;
        vm.create = {};
        vm.create.createVistorCategoryName = null;
        vm.categoryToChange = null;

        var analyticsCreateTitle = 'Create Visitor Category Modal';
        var analyticsCreateUrl = 'create-visitor-category';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Create Visitor Category In' + document.title, ANALYTICS_CONSTANT.open);

        vm.createVisitorCategory = createVisitorCategory;
        // vm.deleteVisitorCategoryName = deleteVisitorCategoryName;

        function init() {
            // vm.categoryToChange = categoryToChange;
        }

        init();

        function createVisitorCategory () {
            toastrService.clearPreviousToastr();
            if(vm.create.createVistorCategoryName === null)
                return toastrService.showErrorToastr("Visitor category name cannot be empty");
            vm.isCreating = true;
            visitorCategoryService.createVisitorCategory({
                name:vm.create.createVistorCategoryName,
                officeId:authService.getAllInformation().office.id,
                createdBy:authService.getAllInformation().id,
                }).then(onVisitorCategoryCreateSuccess, onVisitorCategoryCreateFailure).finally(function (){
                    vm.isCreating = false;
            });
        }

        function onVisitorCategoryCreateSuccess(visitorCategory) {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Create', analyticsCreateUrl + '/create', 'Create Visitor Category In' + document.title, ANALYTICS_CONSTANT.create);
            toastrService.showSuccessToastr("Visitor Category Created Successfully")
            $uibModalInstance.close(visitorCategory);
        }

        function onVisitorCategoryCreateFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitorCategory')
    app.controller('VisitorCategoryDeleteModalCtrl', ['visitorCategoryService','authService','$uibModalInstance','toastrService','categoryToChange', 'analyticsService', 'ANALYTICS_CONSTANT', VisitorCategoryDeleteModalCtrl]);

    /** @ngInject */
    function VisitorCategoryDeleteModalCtrl(visitorCategoryService,authService,$uibModalInstance,toastrService,categoryToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.create = {};
        vm.create.createVistorCategoryName = null;
        vm.categoryToChange = null;
        vm.isCreating = false;

        var analyticsDeleteTitle = 'Delete Visitor Category Modal';
        var analyticsDeleteUrl = 'delete-visitor-category';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle, analyticsDeleteUrl, 'Delete Visitor Category In' + document.title, ANALYTICS_CONSTANT.open);

        vm.deleteVisitorCategoryName = deleteVisitorCategoryName;

        function init() {
            vm.categoryToChange = categoryToChange;
        }

        init();

        function deleteVisitorCategoryName(visitorCategoryId) {
            vm.isCreating = true;
            visitorCategoryService.deleteVisitorCategory(visitorCategoryId).then(onVisitorCategoryDeleteSuccess,onVisitorCategoryDeleteFailure).finally(function (){
                vm.isCreating = false;
            })
        }

        function onVisitorCategoryDeleteSuccess() {
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsDeleteTitle + ' - Delete', analyticsDeleteUrl + '/delete', 'Delete Visitor Category In' + document.title, ANALYTICS_CONSTANT.delete);
            $uibModalInstance.close();
            toastrService.showSuccessToastr("Visitor Category Deleted");
        }

        function onVisitorCategoryDeleteFailure(error) {
            toastrService.showErrorToastr("Could not delete: " + error, "", 5000);
        }

    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.visitorCategory')
    app.controller('VisitorCategoryUpdateModalCtrl', ['visitorCategoryService','authService','$uibModalInstance','toastrService','categoryToChange', 'analyticsService', 'ANALYTICS_CONSTANT', VisitorCategoryUpdateModalCtrl]);

    /** @ngInject */
    function VisitorCategoryUpdateModalCtrl(visitorCategoryService,authService,$uibModalInstance,toastrService,categoryToChange, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;
        vm.isCreating = false;
        vm.categoryToChange = null;

        var analyticsEditTitle = 'Edit Visitor Category Modal';
        var analyticsEditUrl = 'edit-visitor-category';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Visitor Category In' + document.title, ANALYTICS_CONSTANT.open);

        vm.updateVisitorCategoryName = updateVisitorCategoryName;

        function init() {
            vm.categoryToChange = categoryToChange;
        }

        init();

        function updateVisitorCategoryName () {
            if(!vm.categoryToChange.name)
                return toastrService.showErrorToastr("Visitor Category name cannot be empty")
            vm.isCreating = true;
            visitorCategoryService.updateVisitorCategory(vm.categoryToChange.id, {name:vm.categoryToChange.name})
                .then(onVisitorCategoryNameUpdateSuccess,onVisitorCategoryNameUpdateFailure).finally(function (){
                    vm.isCreating = false;
            })
        }

        function onVisitorCategoryNameUpdateSuccess(data) {
            $uibModalInstance.close(data);
        }

        function onVisitorCategoryNameUpdateFailure(error) {
            toastr.error(error);
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('DeleteAllocationCtrl',['deviceService','$uibModalInstance','allocationsToDelete','deviceId','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', DeleteAllocationCtrl]);

    /** @ngInject */
    function DeleteAllocationCtrl(deviceService,$uibModalInstance,allocationsToDelete,deviceId,toastrService, analyticsService, ANALYTICS_CONSTANT) {

         var vm = this;

         vm.allocationsToDelete = null;
         vm.deviceId = null;
        var analyticsModalTitle= 'Revoke Allocation Device Modal';
        var analyticsModalUrl = 'revoke-allocation-device';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle,analyticsModalUrl,'Revoke Allocation Device In '+document.title, ANALYTICS_CONSTANT.open)
         vm.deleteAllocations = deleteAllocations;

         function init() {
             vm.allocationsToDelete = allocationsToDelete;
             vm.deviceId = deviceId;
         }
         init();

         function deleteAllocations() {
            var data = {"employeeIdList":mapDataForBatchRevoke()};
            if(data === null || data.length === 0 ){
                toastrService.showErrorToastr("Please select an allocation first");
            }
            deviceService.allocateEmployeeBatch(data,vm.deviceId, "revoke").then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle+ ' - Revoke Allocation',analyticsModalUrl+ '/revoke','Revoke Allocation Device In '+document.title, ANALYTICS_CONSTANT.delete)

                $uibModalInstance.close();
            },function () {
                toastrService.showErrorToastr("Could not revoke allocations", "", 5000);
            })
         }

        function mapDataForBatchRevoke() {
            // var data = vm.allocationsToDelete.map(function (allocation) {
            //     return {
            //         "employeeId" : allocation.id,
            //         "deviceId" : vm.deviceId,
            //         "action" : "revoke"
            //     };
            // });
            // return data;
            return vm.allocationsToDelete.map(function (allocation) {
                return allocation.id;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.devices')
    app.controller('AllocateModalCtrl',['deviceService','$uibModalInstance','personsToAllocate','deviceId','toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', AllocateModalCtrl]);

    /** @ngInject */
    function AllocateModalCtrl(deviceService,$uibModalInstance,personsToAllocate,deviceId,toastrService, analyticsService, ANALYTICS_CONSTANT) {

        var vm = this;

        vm.personsToAllocate = null;
        vm.deviceIdentifier = null;

        vm.allocate = allocate;
        var analyticsModalTitle= 'Allocate Device Modal';
        var analyticsModalUrl = 'allocate-device';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle,analyticsModalUrl,'Allocate Device In '+document.title, ANALYTICS_CONSTANT.open)
        function init() {
            vm.personsToAllocate = personsToAllocate;
            vm.deviceId = deviceId;
        }
        init();

        function allocate() {
            var data = {"employeeIdList":mapDataForBatchRevoke()};
            if(!data || data.length === 0 ){
                toastrService.showErrorToastr("Please select an allocation first");
            }
            deviceService.allocateEmployeeBatch(data,vm.deviceId, "allocate").then(function () {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal,document.title+' - '+analyticsModalTitle+ ' - Allocate',analyticsModalUrl+ '/allocate','Allocate Device In '+document.title, ANALYTICS_CONSTANT.create)
                $uibModalInstance.close();
            },function (error) {
                toastrService.showErrorToastr("Could not allocate: " + error, "", 5000);
            })
        }

        function mapDataForBatchRevoke() {
            // var data = vm.personsToAllocate.map(function (allocation) {
            //     return {
            //         "employeeId" : allocation.id,
            //         "deviceId" : vm.deviceId,
            //         "action" : "allocate"
            //     };
            // });
            // return data;
            return vm.personsToAllocate.map(function (allocation) {
                return allocation.id;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBanks')
        .controller('CreateBankModalCtrl', ['$uibModalInstance', 'toastrService', 'analyticsService', 'ANALYTICS_CONSTANT', CreateBankModalCtrl]);

    /** @ngInject */
    function CreateBankModalCtrl($uibModalInstance, toastrService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.name = null;
        vm.code = null;
        vm.accountName = null;
        vm.accountNumber = null;
        vm.accountAddress = null;
        vm.status = true;
        var analyticsAddTitle = 'Add New Bank Modal';
        var analyticsAddUrl = 'add-new-bank';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsAddTitle, analyticsAddUrl, 'Add New Bank In' + document.title, ANALYTICS_CONSTANT.open)

        vm.submit = submit;

        function submit() {
            toastrService.clearPreviousToastr();
            if (vm.name == null || vm.name == "") return toastrService.showErrorToastr("Bank name is empty", "", 2000);
            if (vm.code == null || vm.code == "") return toastrService.showErrorToastr("Bank code is empty", "", 2000);
            if (vm.accountName == null || vm.accountName == "") return toastrService.showErrorToastr("Company account name is empty", "", 2000);
            if (vm.accountNumber == null || vm.accountNumber == "") return toastrService.showErrorToastr("Company account number is empty", "", 2000);
            if (vm.accountAddress == null || vm.accountAddress == "") return toastrService.showErrorToastr("Address is empty", "", 2000);
            if (vm.status == null || vm.status == "") return toastrService.showErrorToastr("Bank status is not selected", "", 2000);
            var result = {
                data : {
                    status         : vm.status ? 1 : 0,
                    code           : vm.code,
                    name           : vm.name,
                    accountName    : vm.accountName,
                    accountNumber  : vm.accountNumber,
                    accountAddress : vm.accountAddress
                }
            };
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsAddTitle + ' - Add', analyticsAddUrl + '/add', 'Add New Bank In' + document.title, ANALYTICS_CONSTANT.add)
            $uibModalInstance.close(result);
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBanks')
        .controller('EditBankModalCtrl', ['$uibModalInstance', 'toastrService', 'bankDetails', 'analyticsService', 'ANALYTICS_CONSTANT', EditBankModalCtrl]);

    /** @ngInject */
    function EditBankModalCtrl($uibModalInstance, toastrService, bankDetails, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.bankDetails = bankDetails;
        vm.bankDetails.status = vm.bankDetails.status === 1;
        var analyticsEditTitle = 'Edit Bank Modal';
        var analyticsEditUrl = 'edit-bank';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Bank In' + document.title, ANALYTICS_CONSTANT.open)
        vm.submit = submit;
        // console.log(vm.code)
        function submit() {
            toastrService.clearPreviousToastr();
            if (vm.bankDetails.name == null || vm.bankDetails.name == "") return toastrService.showErrorToastr("Bank name is empty", "", 2000);
            if (vm.bankDetails.code == null || vm.bankDetails.code == "") return toastrService.showErrorToastr("Bank code is empty", "", 2000);
            if (vm.bankDetails.accountName == null || vm.bankDetails.accountName == "") return toastrService.showErrorToastr("Company account name is empty", "", 2000);
            if (vm.bankDetails.accountNumber == null || vm.bankDetails.accountNumber == "") return toastrService.showErrorToastr("Company account number is empty", "", 2000);
            if (vm.bankDetails.accountAddress == null || vm.bankDetails.accountAddress == "") return toastrService.showErrorToastr("Address is empty", "", 2000);
            if (vm.bankDetails.status == null || vm.bankDetails.status == "") return toastrService.showErrorToastr("Bank status is not selected", "", 2000);
            var data = {
                id             : vm.bankDetails.id,
                status         : vm.bankDetails.status ? 1 : 0,
                name           : vm.bankDetails.name,
                code           : vm.bankDetails.code,
                accountName    : vm.bankDetails.accountName,
                accountNumber  : vm.bankDetails.accountNumber,
                accountAddress : vm.bankDetails.accountAddress
            };
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Bank In' + document.title, ANALYTICS_CONSTANT.edit);
            $uibModalInstance.close(data);
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBranches')
        .controller('CreateBranchModalCtrl', ['$uibModalInstance', 'toastrService', 'banks', 'analyticsService', 'ANALYTICS_CONSTANT', CreateBranchModalCtrl]);

    /** @ngInject */
    function CreateBranchModalCtrl($uibModalInstance, toastrService, banks, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsCreateTitle = 'Add New Branch Modal';
        var analyticsCreateUrl = 'add-new-branch';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle, analyticsCreateUrl, 'Add New Branch In' + document.title, ANALYTICS_CONSTANT.open)
        vm.branchName = null;
        vm.routingNumber = null;
        vm.status = true;
        vm.banks = banks;

        vm.selectedBank = [];

        vm.submit = submit;

        function submit() {
            toastrService.clearPreviousToastr();
            if (vm.selectedBank.length === 0) return toastrService.showErrorToastr("No bank is selected", "", 2000);
            if (vm.branchName == null || vm.branchName == "") return toastrService.showErrorToastr("Bank name is empty", "", 2000);
            if (vm.routingNumber == null || vm.routingNumber == "") return toastrService.showErrorToastr("Routing Number is empty", "", 2000);
            if (vm.status == null || vm.status == "") return toastrService.showErrorToastr("Bank status is not selected", "", 2000);
            var data = {
                bankId        : vm.selectedBank[0].id,
                name          : vm.branchName,
                routingNumber : vm.routingNumber,
                status        : vm.status ? 1 : 0
            };
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsCreateTitle + ' - Add', analyticsCreateUrl + '/add', 'Add New Branch In' + document.title, ANALYTICS_CONSTANT.create)
            $uibModalInstance.close(data);
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.absentOrLeaveWithoutPay')
        .controller('AbsentTypeInputForIndividualCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService','payrollSettingsService','payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', AbsentTypeInputForIndividualCtrl]);

    /** @ngInject */
    function AbsentTypeInputForIndividualCtrl($scope, $stateParams, $state, $timeout, $uibModal, authService, employeeService, toastrService,payrollSettingsService, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.initialSelection = $stateParams.initialSelection;
        vm.searchKeyword = null;
        vm.absentType = [];
        vm.selectedAbsentType = null;
        vm.employeeData = {};
        vm.selectedMonth = new Date();
        vm.monthPickerSalary = {};
        vm.monthPickerSalary.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            // maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };
        vm.data = {
            days:0,
            remarks:""
        }

        vm.saveAbsentData = saveAbsentData;
        vm.fetchEmployeeInformation = fetchEmployeeInformation;
        vm.openMonthPickerSalary = openMonthPickerSalary;

        function saveAbsentData(){
            toastrService.clearPreviousToastr();
            if(!vm.selectedAbsentType) return  toastrService.showErrorToastr("Please select absent type")
            if(!vm.employeeData || !vm.employeeData.id) return  toastrService.showErrorToastr("Please select an employee")
            if(!vm.data.days) return  toastrService.showErrorToastr("Please set number of days.")
            if(!vm.data.remarks) return  toastrService.showErrorToastr("Please add remarks.")
            var data = {
                employeeId : vm.employeeData.id,
                componentId :  vm.selectedAbsentType,
                monthMillis : vm.selectedMonth.getTime(),
                numberOfDays : vm.data.days,
                remarks : vm.data.remarks
            }
            payrollManagementService.saveLeaveWithoutPayDataForASingleEmployee(data).then(function (response) {
                analyticsService.sendData(ANALYTICS_CONSTANT.saveUrl, document.title + ' - Save', '', 'Save In' + document.title, ANALYTICS_CONSTANT.save)
                toastrService.showSuccessToastr("Successful");
                $state.go('payroll.absentOrLeaveWithoutPay');
            })


        }

        function openMonthPickerSalary() {
            vm.monthPickerSalary.opened = true;
        }

        function fetchEmployeeInformation(data){
            employeeService.getProfile(data.id).then(function (responseData) {
                var employee = responseData.employee;
                vm.employeeData.employeeName = employee.name;
                vm.employeeData.id = employee.id;
                if(employee.designation){
                    vm.employeeData.designation = employee.designation.name;
                }
                if(employee.department){
                    vm.employeeData.department = employee.department.name;
                }
                if(employee.workplace){
                    vm.employeeData.workplace = employee.workplace.name;
                }
            });
        }

        function init(){
            if(vm.initialSelection != null) {
                vm.selectedMonth = new Date(vm.initialSelection.salaryYear, vm.initialSelection.salaryMonth - 1 ,1);
            }
            payrollSettingsService.getPayrollSettingsByComponentTypeAndStatus([8,9],[1]).then(function (data) {
                vm.absentType = data.officePayrollComponents;
            }, function (message) {
            });
        }

        init();

        function openSuccessModal() {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/payroll/payrollSettings/modals/success.modal.html',
                size: 'md',
                controller : 'SuccessModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve: {
                    successMsg: function () {
                        return 'Absent Data has been uploaded successfully.';
                    }
                }
            }).result.then(function () {

            });
        }



    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.manageBranches')
        .controller('EditBranchModalCtrl', ['$uibModalInstance', 'toastrService', 'branchDetails', 'analyticsService', 'ANALYTICS_CONSTANT', EditBranchModalCtrl]);

    /** @ngInject */
    function EditBranchModalCtrl($uibModalInstance, toastrService, branchDetails, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.branchDetails = branchDetails;
        vm.branchDetails.branchStatus = vm.branchDetails.branchStatus === 1;

        vm.selectedBank = [];
        var analyticsEditTitle = 'Edit Branch Modal';
        var analyticsEditUrl = 'edit-branch';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle, analyticsEditUrl, 'Edit Branch In' + document.title, ANALYTICS_CONSTANT.open)

        vm.submit = submit;

        function submit() {
            toastrService.clearPreviousToastr();
            if (vm.branchDetails.branchName == null || vm.branchName == "") return toastrService.showErrorToastr("Bank name is empty", "", 2000);
            if (vm.branchDetails.routingNumber == null || vm.routingNumber == "") return toastrService.showErrorToastr("Routing Number is empty", "", 2000);
            if (vm.branchDetails.branchStatus == null || vm.status == "") return toastrService.showErrorToastr("Bank status is not selected", "", 2000);
            var data = {
                id            : vm.branchDetails.branchId,
                name          : vm.branchDetails.branchName,
                routingNumber : vm.branchDetails.routingNumber,
                status        : vm.branchDetails.branchStatus ? 1 : 0
            };
            analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsEditTitle + ' - Edit', analyticsEditUrl + '/edit', 'Edit Branch In' + document.title, ANALYTICS_CONSTANT.edit);
            $uibModalInstance.close(data);
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.absentOrLeaveWithoutPay')
        .controller('AbsentOrLWPConfirmationModalCtrl', [ '$uibModalInstance', 'toastrService', 'confirmationMsg', 'analyticsService', 'ANALYTICS_CONSTANT', AbsentOrLWPConfirmationModalCtrl]);

    /** @ngInject */
    function AbsentOrLWPConfirmationModalCtrl($uibModalInstance, toastrService, confirmationMsg, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.confirmationMsg = confirmationMsg;
        var analyticsConfirmTitle = 'Confirmation Modal';
        var analyticsConfirmUrl = 'confirmation-modal';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsConfirmTitle, analyticsConfirmUrl, 'Confirmation Modal In' + document.title, ANALYTICS_CONSTANT.open)

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.absentOrLeaveWithoutPay')
        .controller('EditAbsenceTypeForIndividualCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService','payrollSettingsService','payrollManagementService', '$q', 'analyticsService', 'ANALYTICS_CONSTANT', EditAbsenceTypeForIndividualCtrl]);

    /** @ngInject */
    function EditAbsenceTypeForIndividualCtrl($scope, $stateParams, $state, $timeout, $uibModal, authService, employeeService, toastrService,payrollSettingsService, payrollManagementService, $q, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.targetComponent = $stateParams.absenceTypeComponent;
        vm.isDataLoaded = false;
        vm.absentType = [];
        vm.selectedAbsentType = null;
        vm.employeeData = {};
        vm.selectedMonth = new Date();
        vm.monthPickerSalary = {};
        vm.monthPickerSalary.options = {
            datepickerMode : 'month',
            minDate : new Date(2019, 12, 1),
            // maxDate : new Date(new Date().getFullYear(), new Date().getMonth() -1, 1),
            minMode : 'month',
            maxMode : 'year'
        };
        vm.data = {
            days:0,
            remarks:""
        }

        vm.saveAbsentData = saveAbsentData;
        vm.openMonthPickerSalary = openMonthPickerSalary;
        vm.openConfirmationModal = openConfirmationModal;
        vm.cancelCurrentOperation = cancelCurrentOperation;

        function saveAbsentData(){
            toastrService.clearPreviousToastr();
            if(!vm.selectedAbsentType) return  toastrService.showErrorToastr("Please select absent type")
            if(!vm.employeeData || !vm.employeeData.id) return  toastrService.showErrorToastr("Please select an employee")
            if(!vm.data.days) return  toastrService.showErrorToastr("Please set number of days.")
            if(!vm.data.remarks) return  toastrService.showErrorToastr("Please add remarks.")
            var formData = {
                employeeId : vm.employeeData.id,
                componentId :  vm.selectedAbsentType,
                monthMillis : vm.selectedMonth.getTime(),
                numberOfDays : vm.data.days,
                remarks : vm.data.remarks
            }
            openConfirmationModal(formData);
        }

        function openMonthPickerSalary() {
            vm.monthPickerSalary.opened = true;
        }

        function fetchEmployeeInformation(){
            employeeService.getProfile(vm.targetComponent.employeeId).then(function (responseData) {
                var employee = responseData.employee;
                vm.employeeData.employeeName = employee.name;
                vm.employeeData.id = employee.id;
                if(employee.designation){
                    vm.employeeData.designation = employee.designation.name;
                }
                if(employee.department){
                    vm.employeeData.department = employee.department.name;
                }
                if(employee.workplace){
                    vm.employeeData.workplace = employee.workplace.name;
                }
            });
        }

        function init(){
            if(vm.targetComponent == null || vm.targetComponent.employeeId == null) return cancelCurrentOperation();
            $q.all([
                getApplicableComponents(),
                fetchEmployeeInformation()
            ]).then(function () {
                vm.isDataLoaded = true;
                vm.selectedAbsentType = vm.targetComponent.componentId;
                vm.selectedMonth = new Date(vm.targetComponent.salaryYear, vm.targetComponent.salaryMonth - 1, 1);
                vm.data.days = vm.targetComponent.numberOfDays;
                vm.data.remarks = vm.targetComponent.remarks;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error,"",5000);
            });
        }

        init();

        function getApplicableComponents() {
            return payrollSettingsService.getPayrollSettingsByComponentTypeAndStatus([8,9],[1]).then(function (data) {
                vm.absentType = data.officePayrollComponents;
            }, function (message) {
                toastrService.showErrorToastr("Couldn't fetch components, " + message, "", 5000);
            });
        }

        function openConfirmationModal(formData) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentTypeInputForIndividualEmployee/modal/confirmation.modal.html',
                size         : 'md',
                controller   : 'AbsentOrLWPConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return {
                            confirmationText : 'Do you want to update the ',
                            componentName    : getSelectedComponentName(vm.selectedAbsentType)
                        }
                    }
                }
            }).result.then(function () {
                submitForm(formData);
            });
        }

        function submitForm(formData) {
            vm.isDataLoaded = false;
            payrollManagementService.updateLeaveWithoutPayDataForSingleEmployee(formData).then(function (response) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - Confirmation Modal - Yes', 'confirmation-modal/yes', 'Select Yes In Confirmation Modal' + document.title, ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Successful");
                cancelCurrentOperation();
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update component, " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getSelectedComponentName(componentId) {
            return vm.absentType.find(function (item) {
                return item.id === componentId;
            }).name;
        }

        function cancelCurrentOperation() {
            $state.go("payroll.absentOrLeaveWithoutPay");
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryComponentUpload')
        .controller('IndividualAdditionalSalaryComponentCtrl', ['$scope', '$stateParams', '$state', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastrService', 'payrollSettingsService', '$q', 'payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', IndividualAdditionalSalaryComponentCtrl]);

    /** @ngInject */
    function IndividualAdditionalSalaryComponentCtrl($scope, $stateParams, $state, $timeout, $uibModal, authService, employeeService, toastrService, payrollSettingsService, $q, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.initialSelection = $stateParams.initialSelection;
        vm.isDataLoaded = true;
        vm.searchKeyword = null;
        vm.createEmployeeComponentForm = null;
        vm.amount = 0;
        vm.remarks = '';

        vm.selectedEmployee = null;
        vm.componentList = [];
        vm.selectedComponent = null;
        vm.selectedStartMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        vm.selectedEndMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

        vm.additionalComponentTypes = [5, 6, 7];

        vm.startMonthPicker = {};
        vm.startMonthPicker.opened = false;
        vm.startMonthPicker.format = "MMMM yyyy";
        vm.startMonthPicker.options = {
            datepickerMode : 'month',
            minDate : new Date(2021, 0, 1),
            minMode : 'month',
            maxMode : 'year'
        };

        vm.endMonthPicker = {};
        vm.endMonthPicker.opened = false;
        vm.endMonthPicker.format = "MMMM yyyy";
        vm.endMonthPicker.options = {
            datepickerMode : 'month',
            minDate : new Date(2021, 0, 1),
            minMode : 'month',
            maxMode : 'year'
        };

        vm.saveAdditionalSalaryComponent = saveAdditionalSalaryComponent;
        vm.getEmployeeProfile = getEmployeeProfile;
        vm.openStartMonthPicker = openStartMonthPicker;
        vm.openEndMonthPicker = openEndMonthPicker;
        vm.invalidComponentForm = invalidComponentForm;
        vm.cancelCurrentOperation = cancelCurrentOperation;

        init();

        function init() {
            if(vm.initialSelection != null) {
                vm.selectedStartMonth = new Date(vm.initialSelection.startYear, vm.initialSelection.startMonth - 1, 1);
                vm.selectedEndMonth = new Date(vm.initialSelection.endYear, vm.initialSelection.endMonth - 1, 1);
            }
            $q.all([
                getAdditionalComponents()
            ]).then(function () {
                vm.isDataLoaded = true;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function saveAdditionalSalaryComponent() {
            var formData = {
                employeeId : vm.selectedEmployee.id,
                additionalComponentId : Number(vm.selectedComponent),
                amount : Number(vm.amount),
                remarks : vm.remarks,
                startMonth : vm.selectedStartMonth.getMonth() + 1,
                startYear : vm.selectedStartMonth.getFullYear(),
                endMonth : vm.selectedEndMonth.getMonth() + 1,
                endYear : vm.selectedEndMonth.getFullYear()
            };
            openConfirmationModal(formData);
        }

        function openConfirmationModal(formData) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/modal/confirmation.modal.html',
                size         : 'md',
                controller   : 'AdditionalComponentConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return {
                            confirmationText : 'Do you want to upload the ',
                            componentName    : getSelectedComponentName(vm.selectedComponent)
                        }
                    }
                }
            }).result.then(function () {
                submitForm(formData);
            });
        }

        function submitForm(formData) {
            vm.isDataLoaded = false;
            payrollManagementService.createAdditionalComponentForEmployee(formData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - Confirmation Modal - Yes', 'confirmation-modal/yes', 'Select Yes In Confirmation Modal' + document.title, ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Additional component added to employee payroll.");
                $state.go("payroll.salaryComponentUpload");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't create additional component to employee payroll, " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getAdditionalComponents() {
            return payrollSettingsService.getPayrollSettingsByComponentTypeAndStatus(vm.additionalComponentTypes, [1]).then(function (data) {
                vm.componentList = sortCollectionByName(data.officePayrollComponents);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch additional components, " + error, "", 5000);
            });
        }

        function getEmployeeProfile(selectedEmployee) {
            vm.isDataLoaded = false;
            return employeeService.getProfile(selectedEmployee.id).then(function (data){
                vm.selectedEmployee = data.employee;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee data, " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function openStartMonthPicker() {
            vm.startMonthPicker.opened = true;
        }

        function openEndMonthPicker() {
            vm.endMonthPicker.opened = true;
        }

        function invalidComponentForm() {
            if(vm.selectedEmployee == null) return true;
            if(vm.selectedComponent == null || vm.selectedComponent === 0) return true;
            if(vm.selectedEndMonth < vm.selectedStartMonth) return true;
            if(vm.amount == null || vm.amount <= 0) return true;
            if(vm.remarks == null || vm.remarks === "") return true;
        }

        function getSelectedComponentName(componentId) {
            return vm.componentList.find(function (item) {
                return item.id === componentId;
            }).name;
        }

        function cancelCurrentOperation() {
            $state.go("payroll.salaryComponentUpload");
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryComponentUpload')
        .controller('AdditionalComponentConfirmationModalCtrl', [ '$uibModalInstance', 'toastrService', 'confirmationMsg', 'analyticsService', 'ANALYTICS_CONSTANT', AdditionalComponentConfirmationModalCtrl]);

    /** @ngInject */
    function AdditionalComponentConfirmationModalCtrl($uibModalInstance, toastrService, confirmationMsg, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.confirmationMsg = confirmationMsg;
        var analyticsConfirmTitle = 'Confirmation Modal';
        var analyticsConfirmUrl = 'confirmation-modal';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsConfirmTitle, analyticsConfirmUrl, 'Confirmation Modal In' + document.title, ANALYTICS_CONSTANT.open)


    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.salaryComponentUpload')
        .controller('EditIndividualAdditionalSalaryComponentCtrl', ['$scope', '$stateParams', '$state', '$uibModal', 'employeeService', 'toastrService', 'payrollSettingsService', '$q', 'payrollManagementService', 'analyticsService', 'ANALYTICS_CONSTANT', EditIndividualAdditionalSalaryComponentCtrl]);

    /** @ngInject */
    function EditIndividualAdditionalSalaryComponentCtrl($scope, $stateParams, $state, $uibModal, employeeService, toastrService, payrollSettingsService, $q, payrollManagementService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.targetAdditionalComponent = $stateParams.additionalComponent;
        vm.isDataLoaded = false;
        vm.searchKeyword = null;
        vm.editEmployeeComponentForm = null;
        vm.amount = 0;
        vm.remarks = null;

        vm.selectedEmployee = null;
        vm.componentList = [];
        vm.selectedComponent = null;
        vm.selectedStartMonth = null;
        vm.selectedEndMonth = null;

        vm.additionalComponentTypes = [5, 6, 7];

        vm.startMonthPicker = {};
        vm.startMonthPicker.opened = false;
        vm.startMonthPicker.format = "MMMM yyyy";
        vm.startMonthPicker.options = {
            datepickerMode : 'month',
            minDate : new Date(2021, 1, 1),
            maxDate : new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode : 'month',
            maxMode : 'year'
        };

        vm.endMonthPicker = {};
        vm.endMonthPicker.opened = false;
        vm.endMonthPicker.format = "MMMM yyyy";
        vm.endMonthPicker.options = {
            datepickerMode : 'month',
            minDate : new Date(2021, 1, 1),
            maxDate : new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            minMode : 'month',
            maxMode : 'year'
        };



        vm.saveAdditionalSalaryComponent = saveAdditionalSalaryComponent;
        vm.openStartMonthPicker = openStartMonthPicker;
        vm.openEndMonthPicker = openEndMonthPicker;
        vm.invalidComponentForm = invalidComponentForm;
        vm.cancelCurrentOperation = cancelCurrentOperation;

        init();

        function init() {
            if(vm.targetAdditionalComponent == null || vm.targetAdditionalComponent.employeeId == null) return cancelCurrentOperation();
            $q.all([
                getAdditionalComponents(),
                getEmployeeProfile()
            ]).then(function () {
                vm.isDataLoaded = true;
                vm.amount = vm.targetAdditionalComponent.amount;
                vm.remarks = vm.targetAdditionalComponent.remarks;
                vm.selectedStartMonth = new Date(vm.targetAdditionalComponent.startYear, vm.targetAdditionalComponent.startMonth - 1, 1);
                vm.selectedEndMonth = new Date(vm.targetAdditionalComponent.endYear, vm.targetAdditionalComponent.endMonth - 1, 1);
                vm.selectedComponent = vm.targetAdditionalComponent.componentId;
            }, function (error) {
                toastrService.showErrorToastr("Error: " + error, "", 5000);
            });
        }

        function saveAdditionalSalaryComponent() {
            var formData = {
                employeeId : vm.selectedEmployee.id,
                additionalComponentId : Number(vm.selectedComponent),
                amount : Number(vm.amount),
                remarks : vm.remarks,
                startMonth : vm.selectedStartMonth.getMonth() + 1,
                startYear : vm.selectedStartMonth.getFullYear(),
                endMonth : vm.selectedEndMonth.getMonth() + 1,
                endYear : vm.selectedEndMonth.getFullYear()
            };
            openConfirmationModal(formData);
        }

        function openConfirmationModal(formData) {
            toastrService.clearPreviousToastr();
            $uibModal.open({
                animation    : true,
                templateUrl  : 'app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/modal/confirmation.modal.html',
                size         : 'md',
                controller   : 'AdditionalComponentConfirmationModalCtrl',
                controllerAs : 'vm',
                backdrop : 'static',
                resolve      : {
                    confirmationMsg : function () {
                        return {
                            confirmationText : 'Do you want to update the ',
                            componentName    : getSelectedComponentName(vm.selectedComponent)
                        }
                    }
                }
            }).result.then(function () {
                submitForm(formData);
            });
        }

        function submitForm(formData) {
            vm.isDataLoaded = false;
            payrollManagementService.updateAdditionalComponentForEmployee(formData).then(function (data) {
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - Confirmation Modal - Yes', 'confirmation-modal/yes', 'Select Yes In Confirmation Modal' + document.title, ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Successfully updated Additional component.");
                $state.go("payroll.salaryComponentUpload");
            }, function (error) {
                toastrService.showErrorToastr("Couldn't update additional component, " + error, "", 5000);
            }).finally(function () {
                vm.isDataLoaded = true;
            });
        }

        function getAdditionalComponents() {
            return payrollSettingsService.getPayrollSettingsByComponentTypeAndStatus(vm.additionalComponentTypes, [1]).then(function (data) {
                vm.componentList = sortCollectionByName(data.officePayrollComponents);
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch additional components, " + error, "", 5000);
            });
        }

        function getEmployeeProfile() {
            return employeeService.getProfile(vm.targetAdditionalComponent.employeeId).then(function (data){
                vm.selectedEmployee = data.employee;
            }, function (error) {
                toastrService.showErrorToastr("Couldn't fetch employee data, " + error, "", 5000);
            }).finally(function () {

            });
        }

        function sortCollectionByName(collection) {
            return _.orderBy(collection,function (item) {
                return item.name.toLowerCase();
            },['asc']);
        }

        function openStartMonthPicker() {
            vm.startMonthPicker.opened = true;
        }

        function openEndMonthPicker() {
            vm.endMonthPicker.opened = true;
        }

        function invalidComponentForm() {
            if(vm.selectedEmployee == null) return true;
            if(vm.selectedComponent == null || vm.selectedComponent === 0) return true;
            if(vm.selectedEndMonth < vm.selectedStartMonth) return true;
            if(vm.amount == null || vm.amount <= 0) return true;
            if(vm.remarks == null || vm.remarks === "") return true;
        }

        function getSelectedComponentName(componentId) {
            return vm.componentList.find(function (item) {
                return item.id === componentId;
            }).name;
        }

        function cancelCurrentOperation() {
            $state.go("payroll.salaryComponentUpload");
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundAccountManagement')
        .controller('ClosePFAccountingYearModalCtrl', ['$q','$uibModalInstance', 'employeeService', 'toastrService', 'providentFundService','accountInfo', 'analyticsService', 'ANALYTICS_CONSTANT', ClosePFAccountingYearModalCtrl]);

    /** @ngInject */
    function ClosePFAccountingYearModalCtrl($q,$uibModalInstance, employeeService, toastrService, providentFundService,accountInfo, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.yearlyAccountId = accountInfo.accountId;
        vm.accountYear = accountInfo.accountYear
        vm.yesBtnClicked = false;
        var analyticsModalTitle = 'Close Current Account Year Modal';
        var analyticsModalUrl = 'close-account-year';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Close Current Account Year In ' + document.title, ANALYTICS_CONSTANT.open);

        vm.closePFAccountingYear = closePFAccountingYear;

        function closePFAccountingYear() {
            vm.yesBtnClicked = true;
            providentFundService.closeAccountingYear(vm.yearlyAccountId).then(function (){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Close', analyticsModalUrl + '/close', 'Close Current Account Year In ' + document.title, ANALYTICS_CONSTANT.close);
                toastrService.showSuccessToastr('Accounting year closed successfully.');
                vm.yesBtnClicked = false;
                $uibModalInstance.close();
            },function (error){
                vm.yesBtnClicked = false;
                toastrService.showErrorToastr("error:" + error, "", 5000);
            })

        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.providentFundAccountManagement')
        .controller('UploadInterestModalCtrl', ['$q','$uibModalInstance', 'employeeService', 'toastrService', 'providentFundService','accountInfo', 'analyticsService', 'ANALYTICS_CONSTANT', UploadInterestModalCtrl]);

    /** @ngInject */
    function UploadInterestModalCtrl($q,$uibModalInstance, employeeService, toastrService, providentFundService,accountInfo, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.yesBtnClicked = false;
        vm.interestAmount = null;
        vm.yearlyAccountId = accountInfo.accountId;
        vm.accountYear = accountInfo.accountYear
        var analyticsModalTitle = 'Re-upload Interest Modal';
        var analyticsModalUrl = 'reupload-interest';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle, analyticsModalUrl, 'Reupload Interest In ' + document.title, ANALYTICS_CONSTANT.upload);

        vm.uploadInterest = uploadInterest;

        function uploadInterest() {
            if(!vm.interestAmount)
                return toastrService.showErrorToastr('Interest amount can not be empty');
            vm.yesBtnClicked = true;
            var params = {
                amount : vm.interestAmount
            }
            providentFundService.uploadInterest(vm.yearlyAccountId, params).then(function(){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsModalTitle + ' - Upload', analyticsModalUrl + '/upload', 'Close Current Account Year In ' + document.title, ANALYTICS_CONSTANT.upload);
                vm.yesBtnClicked = false;
                toastrService.showSuccessToastr('Interest Uploaded Successfully');
                $uibModalInstance.close();
            },function(error){
                toastrService.showErrorToastr('Error: '+ error, '', 5000);
                vm.yesBtnClicked = false;
            });

        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfilePicUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentProfilePicURL', 'toastrService', 'userId', 'Upload','resizeImage', ProfilePicUploadModalCtrl]);

    /** @ngInject */
    function ProfilePicUploadModalCtrl($filter, $uibModalInstance, API, currentProfilePicURL, toastrService, userId, Upload,resizeImage) {

        var vm = this;
        vm.defaultPicture = null;
        vm.currentProfilePicURL = null;
        vm.isFileSelected = false;
        vm.resizeImage = resizeImage;
        vm.fileSelected = fileSelected;
        vm.uploadProfilePicture = uploadProfilePicture;

        init();

        function init () {
            vm.currentProfilePicURL = currentProfilePicURL ? currentProfilePicURL : $filter('appImage')('theme/no-photo.png');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadProfilePicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.employee.uploadProfilePicture + userId,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data.url);
                    toastrService.showSuccessToastr("Profile picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload profile picture. " + response.message);
                    console.error("failed to upload profile picture : " + response.message);
                    toastrService.showErrorToastr("Failed to upload profile picture. " + response.message, "", 5000);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload profile picture. " + response.message);
                    console.error("failed to upload profile picture : " + response.message);
                    toastrService.showErrorToastr("Failed to upload profile picture. " + response.message, "", 5000);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.profile')
        .controller('ProfilePicRemoveModalCtrl', ['$uibModalInstance','employeeService','employeeId','toastrService', ProfilePicRemoveModalCtrl]);

    /** @ngInject */
    function ProfilePicRemoveModalCtrl($uibModalInstance,employeeService,employeeId,toastrService) {

        var vm = this;
        vm.userId = null;

        vm.removePicture = removePicture;

        function init() {
            vm.userId = employeeId;
        }
        init();

        function removePicture() {
            employeeService.removeEmployeeProfilePicture(vm.userId).then(function () {
                $uibModalInstance.close();
            }, function (message) {
                toastrService.showErrorToastr("Failed to remove profile picture : " + message, "", 5000);
                console.error("Failed to remove profile picture : " + message);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement.reception')
        .controller('CheckInConfirmationModalCtrl', [ '$uibModalInstance', 'toastrService', 'visitorName', CheckInConfirmationModalCtrl]);

    /** @ngInject */
    function CheckInConfirmationModalCtrl($uibModalInstance, toastrService, visitorName) {
        var vm = this;
        vm.visitorName = visitorName;
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.visitorManagement')
    app.controller('CheckOutModalCtrl', ['visitHistoryService','authService','$uibModalInstance','toastrService','visitToCheckOutId',CheckOutModalCtrl]);

    /** @ngInject */
    function CheckOutModalCtrl(visitHistoryService,authService,$uibModalInstance,toastrService,visitToCheckOutId) {

        var vm = this;

        vm.delete = {};
        // var loggedInUser=u authService.getAllInformation();
        vm.visitToCheckOutId = angular.copy(visitToCheckOutId);
        vm.isCheckOutClicked=false
        vm.checkOutVisit= checkOutVisit;
        //console.log(vm.visitToCheckOut)
        function checkOutVisit () {
            vm.checkOutVisit=true;

            //visitHistoryService.checkOutVisit(id).then(onCheckOutSuccess, onCheckOutFailure);
        }

        function onCheckOutSuccess() {
            vm.checkOutVisit=false;
            $uibModalInstance.close();
        }

        function onCheckOutFailure(error) {
            toastrService.showErrorToastr("Error: " + error, "", 5000);
        }
    }

})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('AmountComparisonModalCtrl', ['$scope', '$stateParams', '$state', '$timeout','$uibModalInstance', 'authService', 'employeeService', 'toastrService', 'payrollManagementService','utilService', 'analyticsService', 'ANALYTICS_CONSTANT', AmountComparisonModalCtrl]);

    /** @ngInject */
    function AmountComparisonModalCtrl($scope, $stateParams, $state, $timeout, $uibModalInstance, authService, employeeService, toastrService, payrollManagementService,utilService, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsSalaryLogTitle = 'Amount Comparison Modal';
        var analyticsSalaryLogUrl = 'amount-comparison';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Amount Comparison Modal', ANALYTICS_CONSTANT.open);
        vm.selectAnotherRow = selectAnotherRow;

        function selectAnotherRow(){
            $uibModalInstance.close();
        }

    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('ApproveSalaryModalCtrl', ['$uibModalInstance','toastrService', 'payrollManagementService','salarySummary', 'analyticsService', 'ANALYTICS_CONSTANT', ApproveSalaryModalCtrl]);

    /** @ngInject */
    function ApproveSalaryModalCtrl($uibModalInstance, toastrService, payrollManagementService,salarySummary, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsSalaryLogTitle = 'Approve Salary Modal';
        var analyticsSalaryLogUrl = 'approve-salary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Approve Salary Modal', ANALYTICS_CONSTANT.open);
        vm.approveSalary = approveSalary;
        function approveSalary(){
            payrollManagementService.approveSalary(salarySummary.id).then(function (data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle + ' - Yes', analyticsSalaryLogUrl + '/yes', 'Approve Salary Modal', ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Salary Approved successfully");
                $uibModalInstance.close();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('ProcessSalaryModalCtrl', ['$uibModalInstance', 'toastrService', 'payrollManagementService','allInfo', 'analyticsService', 'ANALYTICS_CONSTANT', ProcessSalaryModalCtrl]);

    /** @ngInject */
    function ProcessSalaryModalCtrl($uibModalInstance,toastrService, payrollManagementService,allInfo, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsSalaryLogTitle = 'Process Salary Modal';
        var analyticsSalaryLogUrl = 'process-salary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Process Salary Modal', ANALYTICS_CONSTANT.open);
        vm.employeeInfo = allInfo.employeeInfo;
        vm.isAllSelected = allInfo.isAllSelected;
        vm.officeMonthlySalaryId = allInfo.officeMonthlySalaryId.id;
        vm.errorEmployees = [];

        vm.processSalary = processSalary;

        vm.selectedEmployees = vm.employeeInfo.filter(function (employee){
            if(employee.isSelected === true)
                return employee;
        });

        function processSalary(){
            var data = {
                officeMonthlySalaryId : vm.officeMonthlySalaryId,
                employeeMonthlySalaryIds: vm.selectedEmployees.map(function (component){
                    return component.monthlySalaryId;
                }),
                selectionMode: vm.selectedEmployees.length === 0 ? 'all':'some'
            }

            payrollManagementService.processSalary(data).then(function (data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle + ' - Yes', analyticsSalaryLogUrl + '/yes', 'Process Salary Modal', ANALYTICS_CONSTANT.yes)
                if(data.employees.length == 0){
                    toastrService.showSuccessToastr("Salary Processed successfully");
                    $uibModalInstance.close();
                }
                else {
                    vm.errorEmployees = data.employees;
                    toastrService.showErrorToastr("Some employees could not be processed", "", 5000);
                }

            });
        }




    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('PaySalaryModalCtrl', ['$uibModalInstance','toastrService', 'payrollManagementService','salarySummary', 'analyticsService', 'ANALYTICS_CONSTANT', PaySalaryModalCtrl]);

    /** @ngInject */
    function PaySalaryModalCtrl($uibModalInstance, toastrService, payrollManagementService,salarySummary, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsPaySalaryTitle = 'Pay Salary Modal';
        var analyticsPaySalaryUrl = 'pay-salary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsPaySalaryTitle, analyticsPaySalaryUrl, 'Pay Salary In' + document.title, ANALYTICS_CONSTANT.open);

        vm.paySalary = paySalary;

        function paySalary(){
            payrollManagementService.paySalary(salarySummary.id).then(function (data){
                var analyticsPaySalaryTitle = 'Pay Salary Modal';
                var analyticsPaySalaryUrl = 'pay-salary';
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsPaySalaryTitle + ' - Yes', analyticsPaySalaryUrl + '/yes', 'Pay Salary In' + document.title, ANALYTICS_CONSTANT.yes);
                toastrService.showSuccessToastr("Salary Paid successfully");
                $uibModalInstance.close();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('RollbackSalaryModalCtrl', ['$scope','$uibModalInstance', 'toastrService', 'payrollManagementService','salarySummary', 'analyticsService', 'ANALYTICS_CONSTANT', RollbackSalaryModalCtrl]);

    /** @ngInject */
    function RollbackSalaryModalCtrl($scope, $uibModalInstance, toastrService, payrollManagementService,salarySummary, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        vm.reason = null;
        var analyticsSalaryLogTitle = 'Rollback Salary Modal';
        var analyticsSalaryLogUrl = 'rollback-salary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Rollback Salary Modal', ANALYTICS_CONSTANT.open);
        vm.rollbackSalary = rollbackSalary;

        function rollbackSalary(){
            var data = {
                officeMonthlySalaryId : salarySummary.id,
                remarks               : vm.reason
            }
            payrollManagementService.rollbackSalary(data).then(function (data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle + ' - Yes', analyticsSalaryLogUrl + '/yes', 'Rollback Salary Modal', ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Salary Rollback successful");
                $uibModalInstance.close();
            });
        }




    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('SalaryLogModalCtrl', ['$uibModalInstance', 'toastrService', 'payrollManagementService','salarySummary', 'analyticsService', 'ANALYTICS_CONSTANT', SalaryLogModalCtrl]);

    /** @ngInject */
    function SalaryLogModalCtrl($uibModalInstance, toastrService, payrollManagementService,salarySummary, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsSalaryLogTitle = 'Salary Log Modal';
        var analyticsSalaryLogUrl = 'salary-log';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Salary Log Modal', ANALYTICS_CONSTANT.open);
        vm.isDataLoaded = false;
        vm.salaryLog = null;

        function init(){
            payrollManagementService.getSalaryLog(salarySummary.id).then(function (data){
                vm.salaryLog = data;
                vm.isDataLoaded = true;
            })
        }

        init();
    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('UndoSalaryModalCtrl', ['$uibModalInstance', 'toastrService', 'payrollManagementService', 'MONTH_NAMES','utilService','allInfo', 'analyticsService', 'ANALYTICS_CONSTANT', UndoSalaryModalCtrl]);

    /** @ngInject */
    function UndoSalaryModalCtrl($uibModalInstance, toastrService, payrollManagementService, MONTH_NAMES,utilService,allInfo, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;
        var analyticsSalaryLogTitle = 'Undo Salary Modal';
        var analyticsSalaryLogUrl = 'undo-salary';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Undo Salary Modal', ANALYTICS_CONSTANT.open);

        vm.employeeInfo = allInfo.employeeInfo;
        vm.isAllSelected = allInfo.isAllSelected;
        vm.officeMonthlySalaryId = allInfo.officeMonthlySalaryId.id;

        vm.undoSalary = undoSalary;

        vm.selectedEmployees = vm.employeeInfo.filter(function (employee){
              if(employee.isSelected === true)
                  return employee;
        });

        function undoSalary(){
            var data = {
                officeMonthlySalaryId : vm.officeMonthlySalaryId,
                employeeMonthlySalaryIds: vm.selectedEmployees.map(function (component){
                    return component.monthlySalaryId;
                }),
                selectionMode: vm.selectedEmployees.length === 0 ? 'all':'some'
            }

            payrollManagementService.undoSalary(data).then(function (data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle + ' - Yes', analyticsSalaryLogUrl + '/yes', 'Undo Salary Modal-Yes', ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Salary undo successfully");
                $uibModalInstance.close();
            });
        }




    }
})();
(function () {
    'use strict';

    angular.module('InovaceClientApp.pages.main.payroll.viewOrGenerateSalary')
        .controller('SendSalaryForApprovalModalCtrl', ['$uibModalInstance', 'toastrService', 'payrollManagementService','salarySummary', 'analyticsService', 'ANALYTICS_CONSTANT', SendSalaryForApprovalModalCtrl]);

    /** @ngInject */
    function SendSalaryForApprovalModalCtrl($uibModalInstance, toastrService, payrollManagementService,salarySummary, analyticsService, ANALYTICS_CONSTANT) {
        var vm = this;

        vm.sendForApproval = sendForApproval;
        var analyticsSalaryLogTitle = 'Send Salary For Approval Modal';
        var analyticsSalaryLogUrl = 'send-salary-for-approval';
        analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle, analyticsSalaryLogUrl, 'Send Salary For Approval Modal', ANALYTICS_CONSTANT.open);
        function sendForApproval(){
            payrollManagementService.sendSalaryForApproval(salarySummary.id).then(function (data){
                analyticsService.sendData(ANALYTICS_CONSTANT.modal, document.title + ' - ' + analyticsSalaryLogTitle + ' - Yes', analyticsSalaryLogUrl + '/yes', 'Send Salary For Approval Modal', ANALYTICS_CONSTANT.yes)
                toastrService.showSuccessToastr("Salary Processes successfully");
                $uibModalInstance.close();
            });
        }
    }
})();
angular.module('InovaceClientApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/auth/auth.html','<main class="auth-main" ng-if="$pageFinishedLoading"><div ui-view="pub"></div></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/main/limitReachedModal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">Employee Limit Reached</h3><button type="button" class="close mt-negative-20" ng-click="vm.maybeLater()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p>Your current <b>Free Package</b> allows up to <b>{{ vm.limit }} Employees</b>.<br>To add more team members and unlock advanced features, please upgrade your plan.</p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="vm.maybeLater()">Maybe later</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.upgrade()">Upgrade Now</button></div></div></div></body>');
$templateCache.put('app/pages/main/main.html','<head><title>{{title | translate}} - Tipsoi HR Management</title></head><div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="app" autoscroll="true" autoscroll-body-top=""></div></div></div><back-top></back-top><div style="display: flex;flex-direction: row-reverse;margin-top: -20px;margin-right: 1%"><div><ul class="al-share"><li><a target="_blank" href="https://www.facebook.com/inovace360"><i class="socicon socicon-facebook"></i></a></li><li><a target="_blank" href="https://www.linkedin.com/company/inovace-technologies/"><i class="socicon socicon-linkedin"></i></a></li><li><a target="_blank" href="https://www.youtube.com/channel/UCGMczgS0tjiWy8AlzCnFLGQ"><i class="socicon socicon-youtube"></i></a></li></ul><div class="al-copy"><span>Created with <b><i class="fa fa-bolt" aria-hidden="true" style="color:gold; font-size: large;"></i></b> by</span> <a href="http://www.inovacetech.com">Inovace Technologies</a></div></div></div></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/main/upgradePopup.html','<div class="modal-content upgrade-popup" ng-controller="UpgradePopupModalCtrl as vm"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.upgradeForUnlockFeaturesHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table feature-table"><thead><tr><th class="text-black" translate="">{{\'profile.features\'}}</th><th class="bg-blue" translate="">{{\'profile.basic\'}}</th><th class="bg-danger" translate="">{{\'profile.intermediate\'}}</th><th class="bg-teal" translate="">{{\'profile.advanced\'}}</th></tr></thead><tbody><tr ng-repeat="feature in vm.features track by feature.id"><td class="group-title" colspan="4" ng-if="feature.groupTitle">{{ feature.title }}</td><td class="item-title" ng-if="!feature.groupTitle">{{ feature.title }}</td><td class="item-enabled" ng-if="!feature.groupTitle" ng-class="feature.lite === \'\u2713\'? \'text-success\':\'text-danger\'">{{ feature.lite }}</td><td class="item-enabled" ng-if="!feature.groupTitle" ng-class="feature.pro === \'\u2713\'? \'text-success\':\'text-danger\'">{{ feature.pro }}</td><td class="item-enabled" ng-if="!feature.groupTitle" ng-class="feature.enterprise === \'\u2713\'? \'text-success\':\'text-danger\'">{{ feature.enterprise }}</td></tr></tbody></table></div></div></div><div class="footer mt-20"><button class="btn btn-md border-btn" ng-click="$dismiss()"><span class="text-primary"></span>{{\'profile.maybeLaterButton\' | translate}}</button> <button class="btn btn-md btn-secondary" ng-click="vm.onUpgradeNow()" translate="">{{\'profile.upgradeNowButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/auth/login/login.html','<style>\n    .form-group > label {\n        color: black !important;\n    }\n\n    input:focus {\n        outline: none;\n    }\n\n    .left-image-div {\n        width: 66%;\n        float: left;\n        border-radius: 10px 0px 0px 10px;\n        text-align: center;\n        min-height: 520px;\n    }\n\n    .right-form-div {\n        width: 34%;\n        float: right;\n        padding: 30px;\n        text-align: left;\n        border-radius: 0px 10px 10px 0px;\n        background-color: #219E91;\n\n    }\n\n    .form-control:focus {\n        border-color: #219E91;\n        outline: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n    }\n\n    .login-card {\n        border-radius: 5px;\n        padding: 15px;\n        min-height: 460px;\n        background-color: #F6FFFE;\n        background-repeat: no-repeat;\n        background-position-y: 90%;\n        background-position-x: center;\n    }\n\n    .login-card img {\n        margin-top: 6%;\n        height: 110px;\n    }\n\n    .main-section {\n        margin: 0 auto;\n        background: #1C2B36;\n        min-height: 100vh;\n        font-family: Open Sans;\n    }\n\n    .main-row {\n        padding-top: 8%;\n        margin: 0px;\n    }\n\n    .section-style {\n        background: #219E91;\n        border-radius: 10px;\n        box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);\n    }\n\n\n    @media screen and (max-width: 1199px) {\n        .left-image-div {\n            width: 62%;\n        }\n\n        .right-form-div {\n            width: 38%;\n        }\n    }\n\n    @media screen and (max-width: 760px) {\n        .left-image-div {\n            width: 60%;\n        }\n\n        .right-form-div {\n            width: 40%;\n        }\n    }\n\n    @media screen and (max-width: 560px) {\n        .left-image-div {\n            width: 0%;\n        }\n\n        .left-image-div > img {\n            display: none;\n        }\n\n        .right-form-div {\n            width: 100%;\n        }\n\n        .right-form-div > div > img {\n            display: block;\n        }\n    }\n\n    #myCarousel {\n        margin-top: 10%;\n        padding-left: 20%;\n        padding-right: 15%;\n    }\n    #myCarousel img{\n        width: 90%;\n    }\n\n    .carousel-indicators {\n        position: absolute;\n        bottom: -30px;\n    }\n\n    .carousel-caption {\n        position: absolute;\n        bottom: -30px;\n        left: 0;\n        right: 0;\n    }\n\n    .carousel-indicators li, .carousel-indicators .active {\n        height: 6px;\n        width: 20px;\n        margin: 1px;\n    }\n\n    .login-email .form-control {\n        padding: 7px 3px 9px 33px;\n    }\n\n    .login-password .form-control {\n        padding: 7px 6px 9px 28px;\n    }\n\n    .email-icon-position, .password-icon-position {\n        position: absolute;\n        top: 8px;\n        left: 10px;\n    }\n    .carousel-dots li{\n        width: 30px;\n    }\n    .carousel-dots li button:before {\n        width: 30px;\n        height: 8px;\n        content: "";\n        opacity: 1;\n        border: 1px solid white;\n        border-radius: 10px;\n    }\n    .carousel-dots .carousel-active button:before{\n        background-color: white;\n    }\n    #myCarousel .item{\n        min-height: 300px;\n    }\n    @media screen and (max-width: 1200px) {\n        .left-image-div {\n            width: 62%;\n        }\n        .right-form-div {\n            width: 38%;\n        }\n        .carousel-caption > p{\n            font-size: 20px!important;\n        }\n    }\n    @media screen and (max-width: 992px) {\n        .left-image-div {\n            width: 55%;\n        }\n        .right-form-div {\n            width: 45%;\n        }\n        #myCarousel{\n            padding: 10% !important;\n            margin-top: 10% !important;\n        }\n        .carousel-caption > h3{\n            font-size: 20px!important;\n        }\n        .carousel-caption > p{\n            font-size: 18px!important;\n        }\n    }\n    @media screen and (max-width: 768px) {\n        .left-image-div {\n            width: 55%;\n        }\n        .right-form-div {\n            width: 45%;\n        }\n        #myCarousel {\n            padding: 7% !important;\n            margin-top: 20% !important;\n        }\n        .carousel-caption > p{\n            font-size: 16px!important;\n        }\n    }\n    @media screen and (max-width: 560px) {\n        .left-image-div {\n            width: 0%;\n            display: none;\n        }\n\n        .right-form-div {\n            width: 100%;\n\n        }\n        .right-form-div > div > img {\n            display: block;\n        }\n        .carousel-indicators li, .carousel-indicators .active {\n            display: none;\n        }\n        .section-style{\n            display: flex;\n            justify-content: center;\n        }\n    }\n\n</style><head><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js?v=1766962797023"></script></head><div class="main-section"><div class="container"><div class="row main-row"><div class="col-md-1 col-sm-0"></div><div class="col-md-10 col-sm-12"><div class="row section-style"><div class="left-image-div"><div id="myCarousel" class="carousel slide" data-ride="carousel"><ui-carousel slides="slider" slides-to-show="1" slides-to-scroll="1" initial-slide="1" autoplay="autoplay" autoplay-speed="2000" on-init="ctrl.next" class="text-center" disable-arrow="true" dots="true"><carousel-item><div class="position-relative item"><img src="{{item.image}}" alt="Geo Location"><div class="carousel-caption"><p class="font-25 text-bold mb-20 text-shadow-none">{{item.text1}}</p><p class="font-25 text-shadow-none">{{item.text2}}</p></div></div></carousel-item></ui-carousel></div></div><div class="right-form-div"><div class="login-card"><div class="row text-center"><img src="../assets/img/inHRM.png" alt="none found"></div><form class="mt-30 position-relative" ng-submit="login()" novalidate=""><div class="form-group"><label class="required" for="inputEmail3" translate="">emailOrEmployeeId</label><div class="position-relative login-email"><input type="text" class="form-control login" id="inputEmail3" placeholder="Enter your email or ID" ng-model="loginData.email" autocomplete="on"> <i class="email-icon-position ion-ios-email-outline font-21"></i></div></div><div class="form-group"><label class="required" for="inputPassword3" translate="">password</label><div class="position-relative login-password"><input type="password" class="form-control login" id="inputPassword3" placeholder="Enter your password" ng-model="loginData.password"> <i class="ion-ios-locked-outline password-icon-position font-19 top-6"></i></div></div><div class="form-group mt-30" align="center"><button type="submit" class="btn btn-md-with-icon btn-primary"><i class="ion-log-in"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.logInButton\'}}</span></button></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/directives/attendanceReportFilters/filters.html','<style>\n    .form-group {\n        margin-bottom: 10px !important;\n    }\n\n    .list-active > a {\n        background-color: #4A9B91;\n        color: white !important;\n    }\n\n    .list-active > a:hover {\n        background-color: #4A9B91;\n        color: #000 !important;\n    }\n\n    .font-13 {\n        font-size: 13px;\n    }\n\n    .padding-9-15 {\n        padding: 9px 15px !important;\n    }\n\n    .btn-md-with-icon i {\n        font-size: 17px;\n    }\n\n    .custom-select {\n        width: 90% !important;\n    }\n\n    .min-width-170 {\n        min-width: 170px;\n    }\n\n    .min-width-195 {\n        min-width: 195px;\n    }\n\n    .min-width-205 {\n        min-width: 205px;\n    }\n\n    .min-width-220 {\n        min-width: 220px;\n    }\n\n    #presentAbsent {\n        min-width: 160px;\n    }\n\n    .time-placement {\n        position: absolute;\n        top: -4px;\n        left: 0;\n    }\n    .clock-icon-placement{\n        position: absolute;\n        top: -8px;\n        right: 0px;\n    }\n\n    .time-picker-style img {\n        margin-right: 25px;\n    }\n\n    #lunchFilterList .checkboxLayer {\n        max-width: 170px;\n    }\n\n    #dinnerFilterList .checkboxLayer {\n        max-width: 170px;\n    }\n</style><div class="filter-div" ng-if="showFilters"><div class="row form-inline"><div class="form-group col-sm-3 col-xs-3" ng-if="config.subsidiaryFilter.show"><label class="filter-label" translate="">Subsidiary</label><div id="subsidiaryList" isteven-multi-select="" input-model="vm.search.subsidiaryList" output-model="vm.search.selectedSubsidiaryList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" on-item-click="vm.populateSubsidiaryFilter()" on-select-all="vm.populateSubsidiaryFilter()" on-select-none="vm.populateSubsidiaryFilter()" on-reset="vm.populateSubsidiaryFilter()" on-clear="vm.populateSubsidiaryFilter()"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.companyFilter.show"><label class="filter-label" translate="">filters.companies</label><div id="companyList" isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.populateOfficeFilter()" on-select-all="vm.populateOfficeFilter()" on-select-none="vm.populateOfficeFilter()" on-reset="vm.populateOfficeFilter()" on-clear="vm.populateOfficeFilter()" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.officeFilter.show"><label class="filter-label" translate="">filters.offices</label><div id="officeList" isteven-multi-select="" input-model="vm.search.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id companyId" on-item-click="vm.populateFilterModels()" on-select-all="vm.populateFilterModels()" on-select-none="vm.populateFilterModels()" on-reset="vm.populateFilterModels()" on-clear="vm.populateFilterModels()" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="type == null && config.dateRangePicker.show && config.dateRangePicker.collapsible"><label class="filter-label" translate="">date</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options" min="vm.minDate"><span class="date-position-left" ng-if="vm.stateName !== \'attendanceReport.allLogs\'">{{vm.datePicker.date.startDate.format("D MMM YYYY")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY")}}</span> <span class="date-position-left" ng-if="vm.stateName === \'attendanceReport.allLogs\'">{{vm.datePicker.date.startDate.format("D MMM YYYY hh:mm A")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY hh:mm A")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div ng-if="config.singleDatePicker.show && config.singleDatePicker.collapsible"><div class="form-group col-sm-3 col-xs-3" ng-if="type == \'weekly\' || type == \'daily\'"><label class="filter-label">{{type == \'weekly\' ? \'Start of Week\' : \'Date\'}}</label> <input date-range-picker="" class="form-control date-picker modified-input-box text-center" type="text" ng-model="vm.datePicker.date" options="{singleDatePicker:true}" min="vm.minDate" max="vm.maxDateForDailyReport"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.departmentFilter.show && config.departmentFilter.collapsible"><label class="filter-label" translate="">filters.departments</label><div id="departmentList" isteven-multi-select="" input-model="vm.search.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.subDepartmentFilter.show && config.subDepartmentFilter.collapsible"><label class="filter-label" translate="">filters.subDepartments</label><div id="subDepartmentList" isteven-multi-select="" input-model="vm.search.subDepartmentList" output-model="vm.search.selectedSubDepartmentList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.leaveCategoryFilter.show && config.leaveCategoryFilter.collapsible"><label class="filter-label" translate="">filters.leaveCategories</label><div id="leaveCategoryList" isteven-multi-select="" input-model="vm.search.leaveCategoryList" output-model="vm.search.selectedLeaveCategoryList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.designationFilter.show"><label class="filter-label" translate="">filters.designations</label><div id="designationList" isteven-multi-select="" input-model="vm.search.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.shiftGroupFilter.show"><label class="filter-label" translate="">filters.shiftGroups</label><div id="shiftGroupList" isteven-multi-select="" input-model="vm.search.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="{{vm.isCompanyAdmin ? \'officeName\':\'\'}} name" item-label="{{vm.isCompanyAdmin ? \'officeName\':\'\'}} name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.genderFilter.show"><label class="filter-label" translate="">filters.gender</label><div id="genderList" isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.packageFilter.show"><label class="filter-label" translate="">Package Filter</label><div id="packageList" isteven-multi-select="" input-model="vm.packageList" output-model="vm.search.packageList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.employmentTypeFilter.show"><label class="filter-label" translate="">filters.employmentType</label><div id="employmentTypeList" isteven-multi-select="" input-model="vm.search.employmentTypeList" output-model="vm.search.selectedEmploymentTypeList" button-label="officeName name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.workplaceFilter.show"><label class="filter-label" translate="">filters.workplaces</label><div id="workplaceList" isteven-multi-select="" input-model="vm.search.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.lineManagerFilter.show"><label class="filter-label" translate="">lineManager</label><div id="lineManagerList" isteven-multi-select="" input-model="vm.search.lineManagerList" output-model="vm.search.selectedLineManagerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.hrManagerFilter.show"><label class="filter-label" translate="">hrManager</label><div id="hrManagerList" isteven-multi-select="" input-model="vm.search.hrManagerList" output-model="vm.search.selectedHrManagerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.statusFilter.show && config.statusFilter.collapsible"><label class="filter-label" translate="">status</label><div id="statusList" isteven-multi-select="" input-model="vm.statusList" output-model="vm.search.selectedStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.attendanceStatusFilter.show && config.attendanceStatusFilter.collapsible"><label class="filter-label" translate="">Attendance Status</label><div id="attStatusList" isteven-multi-select="" input-model="vm.attendanceStatusList" output-model="vm.search.selectedAttendanceStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.deviceFilter.show"><label class="filter-label" translate="">select device</label><div isteven-multi-select="" input-model="vm.allDevice" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id"></div></div></div><div class="row form-inline"><div class="form-group col-sm-9 col-xs-3"></div><div class="col-sm-3 col-xs-3 my-12 d-flex justify-end"><button id="attendanceSearchButton" type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchByNameOrId()"><i class="ion-search"></i>{{\'search\' | translate}}</button></div></div></div><div class="row"><div class="col-md-12 filter-inline"><div class="partial-left"><div class="filter-inline-item" id="employeeNameSearchBox" ng-show="!config.searchName.hide"><div class="form-group has-feedback has-search placeholder-text-13"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control" type="text" placeholder="Search Employee by Name/ID/RFID" ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchByNameOrId() : vm.getAllOnEmptySearchKeyword()"></div></div><div class="filter-inline-item width-22 min-width-220" ng-if="type == null && config.dateRangePicker.show && !config.dateRangePicker.collapsible"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format("D MMM YYYY")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="filter-inline-item form-group width-18 min-width-170" ng-if="config.singleDatePicker.show && !config.singleDatePicker.collapsible"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.singleDatePicker.options" max="vm.maxDateForDailyReport"><span class="date-position-left">{{vm.datePicker.date.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group d-flex-space-between flex-row" ng-if="config.lunchFilter.show"><label for="lunchFilterList" class="mr-10"><strong translate="">Lunch</strong></label><div class="min-width-170" isteven-multi-select="" selection-mode="single" id="lunchFilterList" input-model="vm.lunchFilterOptions" output-model="vm.search.lunchFilerOption" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="" on-item-click="vm.searchAttendance()" translation="{ selectAll : \'\', selectNone : \'\', reset : \'\', search : \'\', nothingSelected : \'Any\' }"></div></div><div class="form-group d-flex-space-between flex-row" ng-if="config.dinnerFilter.show"><label for="dinnerFilterList" class="mr-10"><strong translate="">Dinner</strong></label><div class="min-width-170" isteven-multi-select="" selection-mode="single" id="dinnerFilterList" input-model="vm.dinnerFilterOptions" output-model="vm.search.dinnerFilterOption" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="" on-item-click="vm.searchAttendance()" translation="{ selectAll : \'\', selectNone : \'\', reset : \'\', search : \'\', nothingSelected : \'Any\' }"></div></div><div class="filter-inline-item form-group width-18 min-width-170" ng-if="config.timePicker.show"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.selectedTime" options="vm.timePicker.options" ng-change="vm.searchAttendance"><div class="position-relative"><span class="time-placement">{{vm.selectedTime.format("hh:mm A")}}</span> <i class="ion-clock font-20 clock-icon-placement"></i></div></div></div><div class="filter-inline-item table-cell-gap" ng-if="config.monthYearPicker.show"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPicker.format}}" datepicker-options="vm.monthPicker.options" ng-model="vm.selectedMonth" is-open="vm.monthPicker.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></div><div class="filter-inline-item table-cell-gap" ng-if="config.monthRangePicker.show"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPicker1.format}}" datepicker-options="vm.monthPicker1.options" ng-model="vm.selectedMonth1" is-open="vm.monthPicker1.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPicker1()"><i class="fa fa-calendar"></i></button></span></div></div><div class="filter-inline-item table-cell-gap" ng-if="config.monthRangePicker.show"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPicker2.format}}" datepicker-options="vm.monthPicker2.options" ng-model="vm.selectedMonth2" is-open="vm.monthPicker2.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPicker2()"><i class="fa fa-calendar"></i></button></span></div></div><div class="filter-inline-item table-cell-gap" ng-if="config.yearPicker.show"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.yearPicker.format}}" datepicker-options="vm.yearPicker.options" ng-model="vm.selectedYear" is-open="vm.yearPicker.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openYearPicker()"><i class="fa fa-calendar"></i></button></span></div></div><div class="filter-inline-item width-17 min-width-205" ng-if="config.statusFilter.show && !config.statusFilter.collapsible"><div class="row"><div class="col-sm-12"><div isteven-multi-select="" input-model="vm.statusList" output-model="vm.search.selectedStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Employee Status\', \'nothingSelected\' : \'Employee Status\' }"></div></div></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.attendanceStatusFilter.show && !config.attendanceStatusFilter.collapsible"><div id="attStatusList2" isteven-multi-select="" input-model="vm.attendanceStatusList" output-model="vm.search.selectedAttendanceStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Attendance Status\', \'nothingSelected\' : \'Attendance Status\' }"></div></div><div class="filter-inline-item width-20 min-width-195" ng-if="config.departmentFilter.show && !config.departmentFilter.collapsible && !vm.checkIfBangaBhabanEmployee()"><div class="row"><div class="col-sm-12" translate=""><div isteven-multi-select="" input-model="vm.search.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Department\', \'nothingSelected\' : \'Department\' }"></div></div></div></div><div class="filter-inline-item width-20 min-width-195" ng-if="config.departmentFilter.show && !config.departmentFilter.collapsible && vm.checkIfBangaBhabanEmployee()"><div class="row"><div class="col-sm-12" translate=""><div isteven-multi-select="" input-model="vm.search.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Section\', \'nothingSelected\' : \'Section\' }"></div></div></div></div><div class="filter-inline-item width-20 min-width-195" ng-if="config.subDepartmentFilter.show && !config.subDepartmentFilter.collapsible"><div class="row"><div class="col-sm-12"><div isteven-multi-select="" input-model="vm.search.subDepartmentList" output-model="vm.search.selectedSubDepartmentList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Sub Department\', \'nothingSelected\' : \'Sub Department\' }"></div></div></div></div><div class="filter-inline-item width-22 min-width-195" ng-if="config.leaveCategoryFilter.show"><div class="row"><div class="col-sm-12"><div isteven-multi-select="" input-model="vm.search.leaveCategoryList" output-model="vm.search.selectedLeaveCategoryList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Leave Category\', \'nothingSelected\' : \'Leave Category\' }"></div></div></div></div><div class="filter-inline-item width-22 min-width-195" ng-if="config.leaveStatusFilter.show"><div class="row"><div class="col-sm-12"><div isteven-multi-select="" input-model="vm.leaveApprovalStatusList" output-model="vm.search.leaveApprovalStatus" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single" helper-elements="reset" on-item-click="vm.searchAttendance()" on-reset="vm.resetLeaveApprovalStatus()" translation="{ \'reset\' : \'Reset\', \'nothingSelected\' : \'Leave Approval Status\' }"></div></div></div></div><div class="filter-inline-item width-15 min-width-195" ng-if="config.allSitesFilterFilter.show"><div class="row"><div class="col-sm-12"><div isteven-multi-select="" input-model="vm.search.allSitesList" output-model="vm.search.selectedSitesList" button-label="name" item-label="SiteName name" tick-property="ticked" output-properties="id" search-property="name" on-select-all="vm.searchAttendance()" on-select-none="vm.searchAttendance()" on-item-click="vm.searchAttendance()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Sites\', \'nothingSelected\' : \'All Sites\' }"></div></div></div></div><div id="presentAbsent" ng-if="config.presentAbsentFilter.show" class="width-12"><div class="custom-select"><select ng-model="vm.isPresent" ng-change="vm.searchAttendance()"><option value="true" ng-selected="vm.selectedPresentAbsentFilter==\'Present\'" translate="">{{\'Present\'}}</option><option value="false" ng-selected="vm.selectedPresentAbsentFilter==\'Absent\'" translate="">{{\'Absent\'}}</option><option value="" ng-selected="vm.selectedPresentAbsentFilter==\'All\'" translate="">{{\'All\'}}</option></select></div></div><div ng-if="config.sortKey.show"><div id="attendanceTableRowsPerPageDiv" class="filter-inline-item text-right min-height-33"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div><div ng-if="config.memberSortKey.show"><div id="memberSortDiv" class="filter-inline-item text-right min-height-33"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.memberSortKey" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateMemberSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div><div class="filter-inline-item width-22 min-width-210" ng-show="config.fiscalYearFilter.show"><div class="custom-select"><select ng-model="vm.search.selectedDateRange" ng-options="range for range in vm.dateRangeList" ng-change="vm.searchAttendance()"><option value="" disabled="">{{\'applyLeave.pleaseSelect\' | translate}}</option></select></div></div><div class="filter-inline-item"><div class="form-group d-flex-space-between" ng-show="!config.rowsPerPage.hide"><label for="rowsPerPageSelection"><strong translate="">rowsPerPage</strong></label><div class="custom-select"><select ng-model="vm.selectedRowsPerPage" ng-change="vm.handleRowPerPageSelection()" id="rowsPerPageSelection" ng-options="d.value for d in vm.rowsPerPageOption"></select></div></div></div></div><div class="partial-right"><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-if="config.excelDownloadButton.show && !config.excelDownloadButton.multiPage" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item btn-group" ng-if="config.excelDownloadButton.show && config.excelDownloadButton.multiPage"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md-with-icon btn-primary padding-7-12" uib-dropdown-toggle=""><img class="img-resize" src="../assets/img/Excel.png"> <span translate="">{{\'commonKeywords.excelButton\'}}</span>&nbsp; <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a ng-click="vm.exportAsExcel(\'\')" class="cursor-pointer">Current Page</a></li><li><a ng-click="vm.exportAsExcel(\'all\')" class="cursor-pointer">All Pages</a></li></ul></div></div><div class="filter-inline-item" ng-if="config.pdfDownloadButton.show && !config.pdfDownloadButton.multipleOrientation"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsPdf(\'H\')"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div><div class="filter-inline-item btn-group" ng-if="config.pdfDownloadButton.show && config.pdfDownloadButton.multipleOrientation"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md-with-icon btn-primary padding-7-12" uib-dropdown-toggle=""><img class="img-resize" src="../assets/img/PDF.png"> <span translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span>&nbsp; <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a ng-click="vm.exportAsPdf(\'H\')" class="cursor-pointer">Horizontal</a></li><li><a ng-click="vm.exportAsPdf(\'V\')" class="cursor-pointer">Vertical</a></li></ul></div></div></div></div><div class="row" ng-if="hideDownload != true"><div class="col-md-6 d-flex-gap-5"><div><button ng-if="showTimesheetApprovalButton && type == \'monthly\'" class="btn btn-md btn-default ml-25" ng-click="openTimeSheetApproveModal(timesheetApplicationId)" ng-bind-html="timesheetApprovalStatusHtml"></button></div><span ng-if="!showTimesheetApprovalButton && type == \'monthly\'" ng-bind-html="timesheetApprovalStatusHtml" class="ml-25"></span></div></div><div class="text-center mb-10" ng-show="!isDataLoaded" ng-if="hideDownload != true"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div>');
$templateCache.put('app/pages/directives/attendanceReportPaginationDirective/paginationDirective.html','<div class="text-center cursor-pointer" ng-if="total > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.goToPage(0)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()"><</a></li><li ng-repeat="n in numberOfButtons track by $index" ng-if="vm.shouldShowPaginationButton($index)" ng-class="(selectedPage==$index)? \'active\':\'\'"><a ng-click="vm.goToPage($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">></a></li><li class="page-item"><a class="page-link" ng-click="vm.goToPage(numberOfButtons.length-1)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="total > 0"><p><strong>{{\'showingPage\'|translate}} {{selectedPage +1}} {{\'outOf\'|translate}} {{numberOfButtons.length}} {{\'pages\'|translate}}.</strong></p><p><strong>{{\'showing\'|translate}} {{(selectedPage*rowsPerPage)+1}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{ (selectedPage+1) * rowsPerPage > total? total : (selectedPage+1) * rowsPerPage }} {{\'outOf\'|translate}} {{total}}</strong></p></div><div ng-if="isDataLoaded && total == 0 && !hideNoDataMessage"><p class="text-center mt-60"><strong translate="">{{vm.notFoundText}}</strong></p></div>');
$templateCache.put('app/pages/directives/dailyAttendanceTable/dailyAttendanceTable.html','<div ng-if="allAttendanceData.length > 0"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td><span translate="">totalEmployees</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalEmployee}}</span></div></td><td><span translate="">leave</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalLeave}}</span></div></td><td><span translate="">late</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalLateEntry}}</span></div></td><td><span translate="">dayOff</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalDayOff}}</span></div></td></tr><tr class="text-bold"><td><span translate="">present</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalPresent}}</span></div></td><td><span translate="">absent</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalAbsent}}</span></div></td><td><span translate="">earlyExit</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalEarlyExit}}</span></div></td><td><span translate="">noOutPunch</span></td><td class="col-stripe-dark"><div class="text-center"><span translate="">{{::dailySummary.totalNumberOfOutPunch}}</span></div></td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-left" rowspan="2" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" rowspan="2" ng-if="vm.isCompanyAdmin" translate="">office</th><th class="text-left" rowspan="2" translate="">workplace</th><th class="text-center" rowspan="2" ng-if="!vm.isGroupAdmin">{{\'commonKeywords.employmentType\' | translate}}</th><th class="text-left" rowspan="2" ng-if="::showLineManager" translate="">lineManager</th><th class="text-center" rowspan="2" ng-if="!vm.isGroupAdmin" translate="">shift</th><th class="text-center" rowspan="2" translate="">status</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">entry</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">exit</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">late</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">earlyExit</th><th class="text-center" rowspan="2" ng-if="vm.showTotalHours" translate="">{{\'commonKeywords.hours\' | translate}}</th><th class="text-center" rowspan="2" ng-if="vm.showTotalHours" translate="">otHours</th></tr><tbody><tr ng-repeat="employee in ::allAttendanceData track by employee.employeeId"><td class="text-center">{{(vm.getRowsPerPage() * selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="::employee.employeeName" picture-url="::employee.pictureURL" department-name="::employee.departmentName" designation-name="::employee.designationName" id="::employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isCompanyAdmin">{{::employee.officeName}}</td><td class="text-center" ng-if="vm.isNotSubsidiaryAdmin">{{::employee.subsidiaryName}}</td><td ng-class="employee.workplaceName === \'Not Set\'?\'color-999999 text-left\':\'text-left\'">{{::employee.workplaceName}}</td><td ng-if="!vm.isGroupAdmin" ng-class="employee.employmentTypeName === \'Not Set\'?\'color-999999 text-center\':\'text-center\'">{{::employee.employmentTypeName}}</td><td class="text-left" ng-if="::showLineManager"><employee-picture-and-information name="::employee.lineManagerName" picture-url="::employee.lineManagerPictureUrl" id="::employee.lineManagerId" is-clickable="false"></employee-picture-and-information></td><td class="text-center" ng-if="!vm.isGroupAdmin">{{::employee.shiftGroupName}}<br>{{::employee.shiftStartTime}} - {{::employee.shiftEndTime}}</td><td class="text-center" ng-repeat-start="startOfDay in startOfDayList"><div ng-if="employee.attendance[startOfDay] != undefined"><span ng-if="employee.attendance[startOfDay].statusText!=null" class="status-text" style="color: sienna;font-weight: bold">{{employee.attendance[startOfDay].statusText}}<br></span> <span ng-if="employee.attendance[startOfDay].entryManual && employee.attendance[startOfDay].logPunchType != 5" class="manual-text">Manual Entry<br></span> <span ng-if="employee.attendance[startOfDay].entryManual && employee.attendance[startOfDay].logPunchType == 5" class="manual-text">Field Visit<br></span><span ng-if="employee.attendance[startOfDay].isSpecialDay" class="green-text">Special Day<br></span><span ng-if="employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isSpecialDay" class="greenText">Holiday<br></span> <span ng-if="!employee.attendance[startOfDay].isHoliday && employee.attendance[startOfDay].isOffday && !employee.attendance[startOfDay].isSpecialDay" class="manual-text">Off Day<br></span> <span ng-if="employee.attendance[startOfDay].isLeave" class="manual-text">Leave ({{employee.attendance[startOfDay].leaveCategoryInitials}})<br></span> <span ng-if="employee.attendance[startOfDay].firstHalfAbsent" class="red-text">FH Absent<br></span> <span ng-if="(!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isLeave && !employee.attendance[startOfDay].isOffday)" class="redText text-center"><span ng-if="employee.attendance[startOfDay].isPresent && !employee.attendance[startOfDay].isLate" class="greenText">Present</span> <span ng-if="employee.attendance[startOfDay].isPresent && employee.attendance[startOfDay].isLate && !employee.attendance[startOfDay].isSpecialDay" class="red-text">Late<br><span ng-if="employee.attendance[startOfDay].isLateApprovalApplied && employee.attendance[startOfDay].lateApprovalStatus.length > 0" class="redText">{{employee.attendance[startOfDay].lateApprovalStatus}}</span></span> <span ng-if="!employee.attendance[startOfDay].shiftStarted" class="black-text">--</span> <span ng-if="!employee.attendance[startOfDay].isPresent && !employee.attendance[startOfDay].leaveAppliedButNotApproved && employee.attendance[startOfDay].shiftStarted" class="redText">Absent</span> <span ng-if="employee.attendance[startOfDay].leaveAppliedButNotApproved" class="orange-text">Leave approval pending</span></span></div></td><td class="text-center" ng-class="employee.attendance[startOfDay].isLate && (!employee.attendance[startOfDay].isSpecialDay &&!employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isLeave && !employee.attendance[startOfDay].isOffday) ? \'redText\':\'\'">{{::employee.attendance[startOfDay].firstLoggedTime}}</td><td class="text-center">{{::employee.attendance[startOfDay].lastLoggedTime}}</td><td class="text-center"><span ng-if="employee.attendance[startOfDay].isLate && (!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isLeave && !employee.attendance[startOfDay].isOffday )">{{::employee.attendance[startOfDay].lateBy}}</span></td><td ng-repeat-end="" class="text-center">{{::employee.attendance[startOfDay].earlyExitBy}}</td><td class="text-center" ng-if="vm.showTotalHours">{{::employee.summary.totalWorkingHour}}</td><td class="text-center" ng-if="vm.showTotalHours">{{::employee.summary.totalApprovedOvertime}}</td></tr></tbody></thead></table></div></div>');
$templateCache.put('app/pages/directives/detailedAttendanceTable/detailedAttendanceTable.html','<div ng-if="allAttendanceData.length > 0"><div class="horizontal-scroll report-container width-100 mt-10" fixed-column-table="" fixed-columns="3"><table class="table report-table ml-negative-1"><thead><tr><th class="text-center" rowspan="2">{{\'commonKeywords.sl\' | translate}}</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-center" rowspan="2" ng-if="vm.isNotSubsidiaryAdmin" translate="">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" rowspan="2" ng-if="vm.isCompanyAdmin">{{\'commonKeywords.office\' | translate}}</th><th class="text-center" rowspan="2" ng-if="!vm.isGroupAdmin" style="transform: none"><span>{{\'commonKeywords.employment\' | translate}} {{\'commonKeywords.type\' | translate}}</span></th><th class="text-left" rowspan="2" ng-if="::showLineManager" translate="">lineManager</th><th class="text-center" rowspan="2" ng-if="!vm.isGroupAdmin" translate="">shiftGroup</th><th class="text-left" rowspan="2" ng-if="vm.isGroupAdmin" translate="">company</th><th class="text-left" rowspan="2">{{\'commonKeywords.workplace\' | translate}}</th><th class="text-center" colspan="3" ng-repeat="date in ::dateList">{{::date}}</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">present</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">absent</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">leave</th><th class="text-center" rowspan="2" ng-if="vm.showSummary" translate="">late</th><th class="text-center" rowspan="2" ng-if="vm.showSummary"><span>{{\'commonKeywords.early\' | translate}} {{\'commonKeywords.exit\' | translate}}</span></th><th class="text-center" rowspan="2" ng-if="vm.showTotalHours"><span>{{\'commonKeywords.expected\' | translate}} {{\'commonKeywords.hours\' | translate}}</span></th><th class="text-center" rowspan="2" ng-if="vm.showTotalHours"><span>{{\'commonKeywords.actual\' | translate}} {{\'commonKeywords.hours\' | translate}}</span></th><th class="text-center" rowspan="2" ng-if="vm.showTotalHours"><span>{{\'commonKeywords.difference\' | translate}} {{\'commonKeywords.hours\' | translate}}</span></th><th class="text-center" rowspan="2" ng-if="vm.showTotalHours"><span>{{\'commonKeywords.average\' | translate}} {{\'commonKeywords.hours\' | translate}}</span></th></tr><tr class="skip-freeze"><th class="text-center pt-0" ng-repeat-start="date in ::dateList track by $index" translate="">entry</th><th class="text-center pt-0" translate="">exit</th><th class="text-center pt-0" ng-repeat-end="" translate="">hours</th></tr></thead><tbody><tr ng-repeat="employee in ::allAttendanceData track by employee.employeeId"><td class="text-center">{{(vm.getRowsPerPage() * selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="::employee.employeeName" picture-url="::employee.pictureURL" department-name="::employee.departmentName" designation-name="::employee.designationName" id="::employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isNotSubsidiaryAdmin" ng-class="employee.subsidiaryName == \'Not Set\'?\'color-999999\':\'text-center\'">{{::employee.subsidiaryName}}</td><td class="text-center" ng-if="vm.isCompanyAdmin" ng-class="employee.officeName == \'Not Set\'?\'color-999999\':\'text-center\'">{{::employee.officeName}}</td><td class="text-center" ng-if="!vm.isGroupAdmin" ng-class="employee.employmentTypeName == \'Not Set\'?\'color-999999\':\'text-center\'">{{::employee.employmentTypeName}}</td><td class="text-left" ng-if="::showLineManager"><employee-picture-and-information name="::employee.lineManagerName" picture-url="::employee.lineManagerPictureUrl" id="::employee.lineManagerId" is-clickable="false"></employee-picture-and-information></td><td class="text-center" ng-if="!vm.isGroupAdmin">{{::employee.shiftGroupName}}<br>{{::employee.shiftStartTime}} - {{::employee.shiftEndTime}}</td><td class="text-center" ng-if="vm.isGroupAdmin" ng-class="employee.companyName == \'Not Set\'?\'color-999999 text-center\':\'text-center\'">{{::employee.companyName}}</td><td class="text-left" ng-class="employee.workplaceName === \'Not Set\'?\'color-999999 text-left-important\':\'text-left-important\'">{{::employee.workplaceName}}</td><td class="text-center" ng-repeat-start="startOfDay in startOfDayList track by $index" ng-class="($index % 2 == 1 ? \'col-stripe-dark\' : \'col-stripe-light\')" colspan="{{employee.attendance[startOfDay].isPresent === true ? \'1\' : \'3\'}}"><div ng-if="employee.attendance[startOfDay] != undefined"><span ng-if="employee.attendance[startOfDay].isPresent" ng-class="{\'redText\': (employee.attendance[startOfDay].isLate && (!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isOffday && !employee.attendance[startOfDay].isLeave))}">{{::employee.attendance[startOfDay].firstLoggedTime}}{{(employee.attendance[startOfDay].isHalfDay && employee.attendance[startOfDay].leaveQuarter == 1) ? " H1" : ""}}<br></span> <span ng-if="employee.attendance[startOfDay].isSpecialDay" class="greenText" translate="">{{\'commonKeywords.specialDay\'}}<br></span> <span ng-if="employee.attendance[startOfDay].isPresent && employee.attendance[startOfDay].isLate && !employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isOffday && !employee.attendance[startOfDay].isLeave && employee.attendance[startOfDay].isLateApprovalApplied && employee.attendance[startOfDay].lateApprovalStatus.length > 0" class="redText">{{employee.attendance[startOfDay].lateApprovalStatus}}</span> <span ng-if="employee.attendance[startOfDay].statusText != null" class="status-text sienna-text text-bold">{{employee.attendance[startOfDay].statusText}}<br></span> <span ng-if="employee.attendance[startOfDay].entryManual && employee.attendance[startOfDay].logPunchType != 5" class="manual-text" translate="">{{\'commonKeywords.manualEntry\'}}<br></span> <span ng-if="employee.attendance[startOfDay].entryManual && employee.attendance[startOfDay].logPunchType == 5" class="manual-text" translate="">{{\'commonKeywords.fieldVisit\'}}<br></span> <span ng-if="employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isSpecialDay" class="greenText" translate="">{{\'commonKeywords.holiday\'}}<br></span> <span ng-if="!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && employee.attendance[startOfDay].isOffday" class="greenText" translate="">{{\'commonKeywords.offDay\'}}<br></span> <span ng-if="!employee.attendance[startOfDay].isSpecialDay && employee.attendance[startOfDay].isLeave" class="greenText">{{ \'commonKeywords.leave\' | translate }} {{\'(\' + employee.attendance[startOfDay].leaveCategoryInitials + \')\' }}<br></span> <span ng-if="!employee.attendance[startOfDay].isSpecialDay &&employee.attendance[startOfDay].firstHalfAbsent" class="red-text" translate="">{{\'commonKeywords.fhAbsent\'}}<br></span> <span ng-if="(!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isLeave && !employee.attendance[startOfDay].isOffday) && !employee.attendance[startOfDay].isPresent && !employee.attendance[startOfDay].leaveAppliedButNotApproved && employee.attendance[startOfDay].shiftStarted" class="redText text-center">Absent</span> <span ng-if="employee.attendance[startOfDay].leaveAppliedButNotApproved" class="orange-text text-center">Leave approval pending</span> <span ng-if="!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isOffDay && !employee.attendance[startOfDay].isLeave && !employee.attendance[startOfDay].shiftStarted && !employee.attendance[startOfDay].leaveAppliedButNotApproved" class="text-center">--</span></div><span class="orchid-text" ng-if="employee.attendance[startOfDay] == undefined" translate="">{{\'commonKeywords.mismatch\'}}</span></td><td class="text-center" ng-if="employee.attendance[startOfDay] != undefined && employee.attendance[startOfDay].isPresent" ng-class="($index % 2 == 1?\'col-stripe-dark\':\'col-stripe-light\')"><span ng-class="((employee.attendance[startOfDay].isEarly && (!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday &&!employee.attendance[startOfDay].isOffday && !employee.attendance[startOfDay].isLeave)) ? \'redText\' : \'\')">{{::employee.attendance[startOfDay].lastLoggedTime}}{{(employee.attendance[startOfDay].isHalfDay && employee.attendance[startOfDay].leaveQuarter == 2)? " H2":""}}</span> <span ng-if="employee.attendance[startOfDay].exitManual && employee.attendance[startOfDay].logPunchType!=5" class="manual-text"><br>Manual Entry</span> <span ng-if="employee.attendance[startOfDay].exitManual && employee.attendance[startOfDay].logPunchType==5" class="manual-text"><br>Field Visit</span></td><td class="text-center" ng-repeat-end="" ng-if="employee.attendance[startOfDay] != undefined && employee.attendance[startOfDay].isPresent" ng-class="($index % 2 == 1?\'col-stripe-dark\':\'col-stripe-light\')"><span ng-class="((employee.attendance[startOfDay].isInadequate &&(!employee.attendance[startOfDay].isSpecialDay && !employee.attendance[startOfDay].isHoliday && !employee.attendance[startOfDay].isOffDay && !employee.attendance[startOfDay].isLeave)) ? \'redText\' : \'\')">{{::employee.attendance[startOfDay].totalHour}}</span></td><td class="text-center" ng-if="vm.showSummary">{{::employee.summary.totalPresent}}</td><td class="text-center" ng-if="vm.showSummary">{{::employee.summary.totalAbsent}}</td><td class="text-center" ng-if="vm.showSummary">{{::employee.summary.totalLeave}}</td><td class="text-center" ng-if="vm.showSummary">{{::employee.summary.totalLateEntry}}</td><td class="text-center" ng-if="vm.showSummary">{{::employee.summary.totalEarlyExit}}</td><td class="text-center" ng-if="vm.showTotalHours">{{::employee.summary.totalExpectedWorkingHour}}</td><td class="text-center" ng-if="vm.showTotalHours">{{::employee.summary.totalWorkingHour}}</td><td class="text-center" ng-if="vm.showTotalHours"><span class="{{employee.summary.workingHourSign == \'-\' ? \'redText\':\'\' }}">{{::employee.summary.workingHourDifference}}</span></td><td class="text-center" ng-if="vm.showTotalHours">{{::employee.summary.averageWorkingHoursAndMinutes}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/directives/birthdayPopUp/birthdayPopUp.html','<style>\n    .birthday-overlay {\n        position: fixed;\n        inset: 0;\n        background: rgba(0,0,0,0.45);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 9999;\n    }\n\n    .birthday-card {\n        width: 520px;\n        max-height: 520px;\n        background: #fff;\n        border-radius: 5px;\n        box-shadow: 0 10px 40px rgba(0,0,0,0.25);\n        overflow: hidden;\n    }\n\n    .birthday-header {\n        background: #0f4c5c;\n        color: #fff;\n        padding: 12px 16px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .birthday-header .title {\n        font-weight: 600;\n        font-size: 14px;\n    }\n\n    .close-btn {\n        font-size: 20px;\n        cursor: pointer;\n    }\n\n    .birthday-body {\n        padding: 16px;\n    }\n\n    .employee-row {\n        display: flex;\n        align-items: center;\n        margin-bottom: 14px;\n    }\n\n    .employee-img {\n        width: 54px;\n        height: 54px;\n        border-radius: 50%;\n        border: 3px solid #2bbbad;\n        margin-right: 12px;\n    }\n\n    .employee-info {\n        flex: 1;\n    }\n\n    .employee-name {\n        font-size: 13px;\n        line-height: 1.3;\n    }\n\n    .employee-dept {\n        font-size: 12px;\n        color: #777;\n    }\n\n    .more-text {\n        font-size: 12px;\n        color: #555;\n        margin: 10px 0;\n    }\n\n    /* Button */\n    .actions {\n        display: flex;\n        justify-content: flex-end;\n    }\n\n    .btn-ok {\n        background: #0f4c5c;\n        color: #fff;\n        border: none;\n        padding: 6px 18px;\n        border-radius: 18px;\n        font-size: 12px;\n        cursor: pointer;\n    }\n    .employee-list {\n        max-height: 255px;\n        overflow-y: auto;\n        padding-right: 6px;\n    }\n\n</style><div class="birthday-overlay" ng-click="vm.closePopup()"><div class="birthday-card" ng-click="$event.stopPropagation()"><div class="birthday-header"><div class="title">\uD83C\uDF82 <span>TODAY\'S BIRTHDAYS</span></div><span class="close-btn" ng-click="vm.closePopup()">\xD7</span></div><div class="birthday-body"><div class="employee-list"><div class="employee-row" ng-repeat="employee in vm.data"><img ng-src="{{ employee.pictureUrl }}" class="employee-img"><div class="employee-info"><div class="employee-name"><strong>Happy Birthday,</strong><br><strong>{{ employee.employeeName }}</strong></div><div class="employee-dept">{{ employee.departmentName }}</div></div></div></div><div class="actions"><button class="btn-ok" ng-click="vm.closePopup()">OKAY</button></div></div></div></div>');
$templateCache.put('app/pages/directives/employeePictureAndInformationDirective/employeePictureAndInformation.html','<style>\n    small {\n        font-size: 100% !important;\n    }\n    .with-round-bg img {\n        width: 40px;\n        height: 40px;\n        object-fit: cover;\n    }\n</style><div class="flex-container text-left employee-info"><div class="with-round-bg mb-0"><img ng-if="!!pictureUrl" ng-src="{{pictureUrl}}"> <img ng-if="!pictureUrl" ng-src="../assets/img/theme/no-avatar.png"></div><div class="profile-info"><span ng-if="isClickable"><a class="clickable-profile" ui-sref="profile({employeeId : id})">{{name}}</a></span> <span class="section-header" ng-if="!isClickable">{{name}}</span><div class="font-12 info-bg default-text"><small><span ng-if="(designationName && designationName != \'N/A\') && (departmentName && departmentName != \'N/A\')"><span ng-class="{modified: isDesignationChanged}">{{designationName}}</span><span>,&nbsp;<span ng-class="{modified: isDepartmentChanged}">{{departmentName}}</span></span></span> <span ng-if="(designationName && designationName != \'N/A\') && (!departmentName || departmentName == \'N/A\')" ng-class="{modified: isDesignationChanged}">{{designationName}}</span> <span ng-if="(!designationName || designationName == \'N/A\') && (departmentName && departmentName != \'N/A\')"><span ng-class="{modified: isDepartmentChanged}">{{departmentName}}</span></span> <span ng-if="designationName == \'N/A\' && departmentName == \'N/A\'"><span translate="">{{\'commonKeywords.notSet\'}}</span></span></small></div></div></div>');
$templateCache.put('app/pages/directives/employeeTypeAheadSearch/employeeSearch.html','<script type="text/ng-template" id="employeeSuggestions.html"><a> <div class="d-flex-align-center text-left width-100"> <div class="with-round-bg mb-0"> <img ng-if="match.model.url != null && match.model.url.trim().length > 0" ng-src="{{match.model.url}}"> <img ng-if="match.model.url == null || match.model.url.trim() === \'\'" src="../assets/img/theme/no-avatar.png"> </div> <div class="profile-info"> <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span> <div class=\'font-12 info-bg\'> <!-- <small>{{ match.model.organisationName }}</small>--> </div> </div> </div> </a></script><div class="row"><div class="col-md-12"><div><label ng-if="showLabel" ng-class="{\'required\' : isRequired}" translate="">{{ \'filters.searchEmployee\' }}</label><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control form-control-text-input" ng-model="keyword" placeholder="{{isHostSelection? \'visitorManagement.createAppointment.searchHost\':\'filters.searchByNameID\' | translate}}" uib-typeahead="employee as employee.name for employee in searchEmployee($viewValue)" typeahead-template-url="employeeSuggestions.html" typeahead-on-select="vm.selectEmployee($item)"></div></div></div></div>');
$templateCache.put('app/pages/directives/leaveLateAbsentTable/leaveLateAbsentTable.html','<style>\n    td {\n        font-size: 14px;\n        padding: 0;\n        vertical-align: middle !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .report-table > tbody > tr > td {\n        font-size: 14px;\n    }\n    .odd-row{\n        background-color: #f9f9f9!important;\n    }\n    .even-row{\n        background-color: white!important;\n    }\n    .border-bottom-2{\n        border-bottom: 2px solid #e8e8e8 !important;\n    }\n</style><div><div class="text-center mb-10" ng-show="!isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="isDataLoaded"><div ng-if="!allAttendanceData.length > 0"><p class="text-center"><strong translate="">{{\'noAttendanceFound\'}}</strong></p></div><div ng-if="allAttendanceData.length > 0"><table class="table borderless-table odd-child-selector mt-20"><colgroup ng-if="type != \'lates\'"><col class="width-12"><col class="width-7"><col class="width-10"><col class="width-30"><col class="width-20"></colgroup><colgroup ng-if="type == \'lates\'"><col class="width-12"><col class="width-7"><col class="width-10"><col class="width-25"><col class="width-10"><col class="width-10"><col class="width-12"></colgroup><thead><tr><th class="text-center" translate="">date</th><th class="text-center" translate="">count</th><th class="text-center" translate="">id</th><th class="text-left" translate="">name</th><th class="text-center" translate="">shift</th><th class="text-center" ng-if="type == \'lates\'" translate="">entry</th><th class="text-center" ng-if="type == \'lates\'" translate="">late</th></tr></thead><tbody ng-repeat="data in allAttendanceData|limitTo:rows.perPage:offset" ng-class="{\'border-bottom-2\': data[type].length > 1}"><tr ng-if="data[type].length == 0"><td class="text-center" rowspan="1">{{data.dateInWords}}</td><td class="text-center" rowspan="1">0</td><td class="text-center color-999999" colspan="{{type == \'lates\'? 7:5}}" translate="">noData</td></tr><tr ng-if="data[type].length > 0"><td class="text-center" rowspan="{{data[type].length}}">{{data.dateInWords}}</td><td class="text-center" rowspan="{{data[type].length}}">{{data[type].length}}</td><td class="text-center">{{data[type][0].employeeOfficeId}}</td><td><employee-picture-and-information name="data[type][0].employeeName" picture-url="" department-name="data[type][0].departmentName" designation-name="!data[type][0].designationName ? \'N/A\':data[type][0].designationName" id="data[type][0].employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{data[type][0].shiftName}}</td><td ng-if="type == \'lates\'">{{data[type][0].entryTime}}</td><td ng-if="type == \'lates\'">{{data[type][0].lateBy}}</td></tr><tr ng-repeat="attendance in data[type]" ng-if="$index > 0" ng-class="{\'even-row\': $index % 2 == 1, \'odd-row\': $index % 2 == 0 }"><td class="text-center">{{attendance.employeeOfficeId}}</td><td><employee-picture-and-information name="attendance.employeeName" picture-url="" department-name="attendance.departmentName" designation-name="!attendance.designationName ? \'N/A\':attendance.designationName" id="attendance.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{attendance.shiftName}}</td><td class="text-center" ng-if="type == \'lates\'">{{attendance.entryTime}}</td><td class="text-center" ng-if="type == \'lates\'">{{attendance.lateBy}}</td></tr></tbody></table><div class="text-center"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.paginateData(0)" translate="">first</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()"><</a></li><li ng-repeat="n in numberOfButtons track by $index" ng-class="(selectedPage==$index)? \'active\':\'\'" ng-if="selectedPage <= 2 ? $index <= 5 : (selectedPage <= numberOfButtons.length && selectedPage > numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPage - 2 && $index <= vm.selectedPage + 3)"><a ng-click="vm.paginateData($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">></a></li><li class="page-item"><a class="page-link" ng-click="vm.paginateData(numberOfButtons.length-1)" translate="">last</a></li></ul></nav></div><div class="text-center mt-10"><p><strong>{{\'showingPage\'|translate}}{{selectedPage +1}} {{\'outOf\'|translate}} {{numberOfButtons.length}} {{\'pages\'|translate}}.</strong></p><p><strong>{{\'showing\'|translate}} {{vm.getPaginationInfo()}} {{\'outOf\'|translate}} {{allAttendanceData.length}}</strong></p></div></div></div></div>');
$templateCache.put('app/pages/directives/locationDeviationTable/locationDeviationTable.html','<style>\n    .report-table td {\n        height: auto;\n        white-space: normal;\n        vertical-align: top;\n        line-height: 1.25;\n        overflow: visible;\n    }\n    .punch-list { display: block; }\n    .punch-item { display: block; margin: 0; }\n    .text-left-important { text-align: left !important; }\n</style><div ng-if="allAttendanceData && allAttendanceData.length"><div class="horizontal-scroll report-container width-100 mt-10" fixed-column-table="" fixed-columns="6"><table class="table report-table ml-negative-1" id="attendanceTable"><thead><tr><th class="text-center" rowspan="2">{{\'commonKeywords.sl\' | translate}}</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-center" rowspan="2" ng-if="vm.isCompanyAdmin">{{\'commonKeywords.office\' | translate}}</th><th class="text-center" rowspan="2" ng-if="!vm.isGroupAdmin"><span>{{\'commonKeywords.employment\' | translate}} {{\'commonKeywords.type\' | translate}}</span></th><th class="text-left" rowspan="2" ng-if="::showLineManager" translate="">lineManager</th><th class="text-center" rowspan="2" ng-if="!vm.isGroupAdmin" translate="">shiftGroup</th><th class="text-left" rowspan="2" ng-if="vm.isGroupAdmin" translate="">company</th><th class="text-center" rowspan="2">{{\'commonKeywords.workplace\' | translate}}</th><th class="text-center" colspan="3" ng-repeat="date in ::dateList track by $index">{{::date}}</th></tr><tr class="skip-freeze"><th class="text-center pt-0" ng-repeat-start="date in ::dateList track by $index">First Entry Location</th><th class="text-center pt-0">Punch in Other Locations</th><th class="text-center pt-0" ng-repeat-end="">Last Exit Location</th></tr></thead><tbody><tr ng-repeat="employee in ::allAttendanceData track by employee.employeeId"><td class="text-center">{{(vm.getRowsPerPage() * selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId || \'\'}}</td><td class="text-left"><employee-picture-and-information name="::employee.employeeName" picture-url="::employee.pictureURL" department-name="::employee.departmentName" designation-name="::employee.designationName" id="::employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isCompanyAdmin" ng-class="employee.officeName == \'Not Set\'?\'color-999999\':\'text-center\'">{{::employee.officeName}}</td><td class="text-center" ng-if="!vm.isGroupAdmin" ng-class="(employee.employmentTypeName || employee.employmentType || employee.employeeType || (employee.employeeInformation && (employee.employeeInformation.employmentTypeName || employee.employeeInformation.employmentType || employee.employeeInformation.employeeType)) || \'Not Set\') == \'Not Set\' ? \'color-999999\' : \'text-center\'">{{ ::(employee.employmentTypeName || employee.employmentType || employee.employeeType || (employee.employeeInformation && (employee.employeeInformation.employmentTypeName || employee.employeeInformation.employmentType || employee.employeeInformation.employeeType)) || \'\u2014\') }}</td><td class="text-left" ng-if="::showLineManager"><employee-picture-and-information name="::employee.lineManagerName" picture-url="::employee.lineManagerPictureUrl" id="::employee.lineManagerId" is-clickable="false"></employee-picture-and-information></td><td class="text-center" ng-if="!vm.isGroupAdmin">{{::employee.shiftGroupName}}<br>{{::employee.shiftStartTime}} - {{::employee.shiftEndTime}}</td><td class="text-center" ng-if="vm.isGroupAdmin" ng-class="employee.companyName == \'Not Set\'?\'color-999999 text-center\':\'text-center\'">{{::employee.companyName}}</td><td class="text-center" ng-class="employee.workplaceName === \'Not Set\'?\'color-999999 text-left-important\':\'text-left-important\'">{{::employee.workplaceName}}</td><td class="text-center" ng-repeat-start="startOfDay in startOfDayList track by startOfDay" ng-init="att = employee.attendance[startOfDay]"><div ng-if="att && att.isPresent"><span ng-if="att.firstLocation && att.firstLoggedTime">{{::att.firstLocation}} \u2014 {{::att.firstLoggedTime}}</span> <span ng-if="att.firstLocation && !att.firstLoggedTime">{{::att.firstLocation}}</span> <span ng-if="!att.firstLocation && att.firstLoggedTime">{{::att.firstLoggedTime}}</span> <span ng-if="!att.firstLocation && !att.firstLoggedTime">--</span></div><div ng-if="!att || !att.isPresent">--</div></td><td class="text-center"><div ng-if="att && att.isPresent && att.otherPunches && att.otherPunches.length" class="punch-list"><div class="punch-item" ng-repeat="p in att.otherPunches track by $index"><span ng-if="p.location && p.time">{{::p.location}} \u2014 {{::p.time}}</span> <span ng-if="p.location && !p.time">{{::p.location}}</span> <span ng-if="!p.location && p.time">{{::p.time}}</span> <span ng-if="!p.location && !p.time">--</span></div></div><span ng-if="!att || !att.isPresent || !att.otherPunches || !att.otherPunches.length">--</span></td><td class="text-center" ng-repeat-end=""><div ng-if="att && att.isPresent"><span ng-if="att.lastLocation && att.lastLoggedTime">{{::att.lastLocation}} \u2014 {{::att.lastLoggedTime}}</span> <span ng-if="att.lastLocation && !att.lastLoggedTime">{{::att.lastLocation}}</span> <span ng-if="!att.lastLocation && att.lastLoggedTime">{{::att.lastLoggedTime}}</span> <span ng-if="!att.lastLocation && !att.lastLoggedTime">--</span></div><div ng-if="!att || !att.isPresent">--</div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/directives/memberPictureAndInformationDirective/memberPictureAndInformation.html','<style>\n    small {\n        font-size: 100% !important;\n    }\n</style><div class="d-flex-space-between"><div class="flex-container text-left employee-info" style="min-width: 300px"><div class="with-round-bg mb-0"><img ng-if="!!pictureUrl" ng-src="{{pictureUrl}}"> <img ng-if="!pictureUrl" ng-src="../assets/img/theme/no-avatar.png"></div><div class="profile-info"><span class="section-header2">{{name}} (ID: {{id}})</span><div class="font-12 info-bg color-22222"><small><span ng-if="(mobileNumber || mobileNumber == \'N/A\')"><span>{{mobileNumber}}</span></span></small></div></div></div><div class=""><div class="align-items-center mr-20 text-primary font-16 font-weight-500">{{package}}</div></div></div>');
$templateCache.put('app/pages/directives/monthlyAttendanceTable/monthlyReportDirective.html','<style>\n    .only-print {\n        display: none;\n    }\n    .float-right{\n        float: right;\n        font-size: 80%;\n    }\n    .margin{\n        margin-top: -15px;\n    }\n</style><div><div id="attMonthlyReport" ng-if="isDataLoaded"><div class="row margin"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">absentDays</td><td class="col-stripe-dark text-center">{{overallSummary.netAbsentCount}}</td><td translate="">leaveDays</td><td class="col-stripe-dark text-center">{{overallSummary.netLeaveCount}}</td></tr><tr class="text-bold"><td translate="">lateHours</td><td class="col-stripe-dark text-center">{{overallSummary.netLateTimeInHour}}</td><td translate="">overTimeHours</td><td class="col-stripe-dark text-center">{{overallSummary.netOtHoursOnly}}</td></tr></tbody></table></div></div><div ng-if="type === \'monthly\' && vm.showAIInsights" class="row" style="margin-top: 20px;"><div class="col-md-12"><button class="btn btn-secondary btn-lg" style="width: 100%; padding: 15px; font-size: 16px;" ng-click="openAIInsightsModal()"><i class="fa fa-brain" style="margin-right: 8px;"></i> View AI Insights <span ng-if="aiAnalysisLoading" style="margin-left: 10px;"><i class="fa fa-spinner fa-spin"></i></span></button></div></div><div ng-if="showAiModal" class="modal" style="display: flex !important; align-items: center !important; justify-content: center !important; z-index: 9999; background: rgba(0,0,0,0.5); position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important;" ng-click="closeAIInsightsModal()"><div class="modal-dialog modal-lg" style="max-width: 900px; margin: 0 !important; position: relative !important;" ng-click="$event.stopPropagation()"><div class="modal-content"><div class="modal-header" style="background: var(--color-secondary); color: white; border-bottom: none;"><button type="button" class="close" ng-click="closeAIInsightsModal()" style="color: white; opacity: 1; font-size: 24px;"><span>&times;</span></button><h4 class="modal-title" style="color: white;"><i class="fa fa-brain" style="margin-right: 8px;"></i> <strong>AI Insights - Monthly Attendance Analysis</strong></h4></div><div class="modal-body" style="max-height: 70vh; overflow-y: auto; padding: 30px;"><div ng-if="aiAnalysisLoading" style="text-align: center; color: #666; padding: 40px;"><i class="fa fa-spinner fa-spin" style="margin-right: 10px; font-size: 24px; color: var(--color-secondary);"></i><h5 style="margin-top: 15px; color: #666;">Generating AI insights for your monthly report...</h5><p style="color: #999;">This may take 20-30 seconds</p></div><div ng-if="aiAnalysis && aiAnalysis.analysisAvailable && !aiAnalysisLoading"><div style="line-height: 1.8; color: #333; font-size: 15px;" ng-bind-html="formatAIText(aiAnalysis.analysisText)"></div></div><div ng-if="!aiAnalysisLoading && aiAnalysis && !aiAnalysis.analysisAvailable && aiAnalysis.errorMessage" style="text-align: center; padding: 40px;"><div style="color: #721c24; padding: 20px; background: #f8d7da; border: 1px solid #f5c6cb; border-radius: 8px;"><i class="fa fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px;"></i><h5>AI Analysis Error</h5><p>{{aiAnalysis.errorMessage}}</p></div></div><div ng-if="!aiAnalysisLoading && !aiAnalysis" style="text-align: center; padding: 40px;"><div style="color: #666; font-style: italic;"><i class="fa fa-info-circle" style="font-size: 24px; margin-bottom: 10px; color: #999;"></i><h5>No AI Analysis Available</h5><p>AI analysis is not available for this report.</p></div></div></div><div class="modal-footer" style="border-top: 1px solid #eee; background: #f9f9f9;"><div ng-if="aiAnalysis && aiAnalysis.processingTimeMs" style="float: left; font-size: 12px; color: #999; margin-top: 8px;"><i class="fa fa-clock-o"></i> Analysis completed in {{aiAnalysis.processingTimeMs}}ms</div><button type="button" class="btn btn-default" ng-click="closeAIInsightsModal()">Close</button></div></div></div></div><div ng-if="isDataLoaded && allAttendanceData.length > 0" class="horizontal-scroll report-container mt-20 width-100" fixed-column-table="" fixed-columns="3"><table class="table report-table"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">employeeName</th><th class="text-left" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-left" translate="">workplace</th><th class="text-center" translate="">employeeType</th><th class="text-left" ng-if="::showLineManager" translate="">lineManager</th><th class="text-center" ng-if="vm.isCompanyAdmin">office</th><th class="text-center" ng-if="vm.isGroupAdmin" translate="">company</th><th class="text-center" ng-if="detailedView" ng-repeat="dateAndDay in ::dateList">{{::dateAndDay.date}}<br>{{::dateAndDay.day}}</th><th class="text-center" translate="">workingDays</th><th class="text-center" translate="">present</th><th class="text-center" translate="">absent</th><th class="text-center" translate="">leave</th><th class="text-center" translate="">offDays</th><th class="text-center" translate="">holidays</th><th class="text-center" translate="">Special Days</th><th class="text-center" translate="">late</th><th class="text-center" translate="">approvedLates</th><th ng-if="vm.state==\'monthlyReport\'" class="text-center" translate="">fieldVisits</th><th class="text-center" translate="">expectedHours</th><th class="text-center" translate="">workingHours</th><th class="text-center" translate="">difference</th><th class="text-center" translate="">otHours</th></tr></thead><tbody><tr ng-repeat="attendanceResponse in allAttendanceData"><td class="text-center">{{(vm.getRowsPerPage() * selectedPage) + $index + 1 }}</td><td class="text-center">{{attendanceResponse.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="::attendanceResponse.employeeName" picture-url="::attendanceResponse.pictureURL" department-name="::attendanceResponse.departmentName" designation-name="::attendanceResponse.designationName" id="::attendanceResponse.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isNotSubsidiaryAdmin">{{attendanceResponse.subsidiaryName}}</td><td ng-class="attendanceResponse.workplaceName===\'Not Set\'? \'color-999999 text-left\':\'text-left-important\'">{{::attendanceResponse.workplaceName}}</td><td ng-if="!vm.isGroupAdmin" class="text-center">{{::attendanceResponse.employmentTypeName}}</td><td class="text-left" ng-if="::showLineManager"><employee-picture-and-information name="::attendanceResponse.lineManagerName" picture-url="::attendanceResponse.lineManagerPictureUrl" id="::attendanceResponse.lineManagerId" is-clickable="false"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isCompanyAdmin">{{::attendanceResponse.officeName}}</td><td class="text-center" ng-if="vm.isGroupAdmin">{{::attendanceResponse.companyName}}</td><td class="text-center" ng-if="detailedView" ng-repeat="startOfDay in startOfDayList track by $index"><div ng-if="attendanceResponse.attendance[startOfDay] != undefined"><span ng-if="attendanceResponse.attendance[startOfDay].isSpecialDay" class="greenText">SD<br></span><span ng-if="attendanceResponse.attendance[startOfDay].statusText != null" class="status-text">{{attendanceResponse.attendance[startOfDay].statusText}}<br></span> <span ng-if="attendanceResponse.attendance[startOfDay].entryManual && attendanceResponse.attendance[startOfDay].logPunchType != 5" class="manual-text">ME<br></span> <span ng-if="attendanceResponse.attendance[startOfDay].entryManual && attendanceResponse.attendance[startOfDay].logPunchType == 5" class="manual-text">FV<br></span> <span ng-if="!attendanceResponse.attendance[startOfDay].isSpecialDay && attendanceResponse.attendance[startOfDay].isHoliday" class="greenText">H<br></span> <span ng-if="!attendanceResponse.attendance[startOfDay].isSpecialDay && !attendanceResponse.attendance[startOfDay].isHoliday && attendanceResponse.attendance[startOfDay].isOffday" class="manual-text">Of<br></span> <span ng-if="attendanceResponse.attendance[startOfDay].isLeave" class="manual-text">Lv<br></span> <span ng-if="(!attendanceResponse.attendance[startOfDay].isHoliday && !attendanceResponse.attendance[startOfDay].isOffday && attendanceResponse.attendance[startOfDay].firstHalfAbsent)" class="red-text">FHA<br></span> <span ng-if="(!attendanceResponse.attendance[startOfDay].isSpecialDay && !attendanceResponse.attendance[startOfDay].isHoliday && !attendanceResponse.attendance[startOfDay].isLeave && !attendanceResponse.attendance[startOfDay].isOffday)" class="redText text-center"><span ng-if="!attendanceResponse.attendance[startOfDay].isSpecialDay && attendanceResponse.attendance[startOfDay].isPresent && !attendanceResponse.attendance[startOfDay].isLate" class="greenText">P</span> <span ng-if="!attendanceResponse.attendance[startOfDay].isSpecialDay && attendanceResponse.attendance[startOfDay].isPresent && attendanceResponse.attendance[startOfDay].isLate" class="redText">L</span> <span ng-if="!attendanceResponse.attendance[startOfDay].isPresent" class="redText">A</span> <span ng-if="!attendanceResponse.attendance[startOfDay].isPresent && !attendanceResponse.attendance[startOfDay].shiftStarted" class="black-text">--</span> <span ng-if="!attendanceResponse.attendance[startOfDay].isPresent && attendanceResponse.attendance[startOfDay].leaveAppliedButNotApproved" class="orange-text">P.Lv</span></span></div></td><td class="text-center">{{::attendanceResponse.summary.totalApplicableDays}}</td><td class="text-center">{{::attendanceResponse.summary.totalPresent}}</td><td class="text-center">{{::attendanceResponse.summary.totalAbsent}}</td><td class="text-center">{{::attendanceResponse.summary.totalLeave}}</td><td class="text-center">{{::attendanceResponse.summary.totalWeeklyOffdays}}</td><td class="text-center">{{::attendanceResponse.summary.totalHolidays}}</td><td class="text-center">{{::attendanceResponse.summary.totalSpecialDays}}</td><td class="text-center">{{::attendanceResponse.summary.totalLateEntry}}</td><td class="text-center">{{::attendanceResponse.summary.totalApprovedLateApplication}}</td><td ng-if="vm.state==\'monthlyReport\'" class="text-center">{{::attendanceResponse.summary.totalFieldVisits}}</td><td class="text-center">{{::attendanceResponse.summary.totalExpectedWorkingHour}}</td><td class="text-center">{{::attendanceResponse.summary.totalWorkingHour}}m</td><td class="text-center">{{::attendanceResponse.summary.workingHourSign}} {{::attendanceResponse.summary.workingHourDifference}}</td><td class="text-center">{{::attendanceResponse.summary.totalApprovedOvertime}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/directives/payrollFilter/filters.html','<style>\n    .form-group {\n        margin-bottom: 10px !important;\n    }\n\n    .list-active > a {\n        background-color: #4A9B91;\n        color: white !important;\n    }\n\n    .list-active > a:hover {\n        background-color: #4A9B91;\n        color: #000 !important;\n    }\n\n    .font-13 {\n        font-size: 13px;\n    }\n\n    .padding-9-15 {\n        padding: 9px 15px !important;\n    }\n\n    .btn-md-with-icon i {\n        font-size: 17px;\n    }\n\n    .custom-select {\n        width: 90% !important;\n    }\n\n    .min-width-170 {\n        min-width: 170px;\n    }\n\n    .width-150 {\n        width: 170px;\n    }\n\n    .min-width-80 {\n        min-width: 80px;\n    }\n\n    .min-width-250 {\n        min-width: 250px;\n    }\n\n    .min-width-300 {\n        min-width: 300px;\n    }\n\n    .mb-0-important {\n        margin-bottom: 0 !important;\n    }\n</style><div class="filter-div" ng-if="showFilters"><div class="row form-inline"><div class="form-group col-sm-3 col-xs-3" ng-if="config.companyFilter.show"><label class="filter-label" translate="">filters.companies</label><div id="companyList" isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.populateOfficeFilter()" on-select-all="vm.populateOfficeFilter()" on-select-none="vm.populateOfficeFilter()" on-reset="vm.populateOfficeFilter()" on-clear="vm.populateOfficeFilter()" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.officeFilter.show"><label class="filter-label" translate="">filters.offices</label><div id="officeList" isteven-multi-select="" input-model="vm.search.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id companyId" on-item-click="vm.populateFilterModels()" on-select-all="vm.populateFilterModels()" on-select-none="vm.populateFilterModels()" on-reset="vm.populateFilterModels()" on-clear="vm.populateFilterModels()" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="type == null && config.dateRangePicker.show && config.dateRangePicker.collapsible"><label class="filter-label" translate="">date</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options" min="vm.minDate"><span class="date-position-left" ng-if="vm.stateName !== \'attendanceReport.allLogs\'">{{vm.datePicker.date.startDate.format("D MMM YYYY")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY")}}</span> <span class="date-position-left" ng-if="vm.stateName === \'attendanceReport.allLogs\'">{{vm.datePicker.date.startDate.format("D MMM YYYY hh:mm A")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY hh:mm A")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div ng-if="config.singleDatePicker.show && config.singleDatePicker.collapsible"><div class="form-group col-sm-3 col-xs-3" ng-if="type == \'weekly\' || type == \'daily\'"><label class="filter-label">{{type == \'weekly\' ? \'Start of Week\' : \'Date\'}}</label> <input date-range-picker="" class="form-control date-picker modified-input-box text-center" type="text" ng-model="vm.datePicker.date" options="{singleDatePicker:true}" min="vm.minDate" max="vm.maxDateForDailyReport"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.departmentFilter.show && config.departmentFilter.collapsible"><label class="filter-label" translate="">filters.departments</label><div id="departmentList" isteven-multi-select="" input-model="vm.search.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.designationFilter.show"><label class="filter-label" translate="">filters.designations</label><div id="designationList" isteven-multi-select="" input-model="vm.search.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.shiftGroupFilter.show"><label class="filter-label" translate="">filters.shiftGroups</label><div id="shiftGroupList" isteven-multi-select="" input-model="vm.search.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="{{vm.isCompanyAdmin ? \'officeName\':\'\'}} name" item-label="{{vm.isCompanyAdmin ? \'officeName\':\'\'}} name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.genderFilter.show"><label class="filter-label" translate="">filters.gender</label><div id="genderList" isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.employmentTypeFilter.show"><label class="filter-label" translate="">filters.employmentType</label><div id="employmentTypeList" isteven-multi-select="" input-model="vm.search.employmentTypeList" output-model="vm.search.selectedEmploymentTypeList" button-label="officeName name" item-label="officeName name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.workplaceFilter.show"><label class="filter-label" translate="">filters.workplaces</label><div id="workplaceList" isteven-multi-select="" input-model="vm.search.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.lineManagerFilter.show"><label class="filter-label" translate="">lineManager</label><div id="lineManagerList" isteven-multi-select="" input-model="vm.search.lineManagerList" output-model="vm.search.selectedLineManagerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.hrManagerFilter.show"><label class="filter-label" translate="">hrManager</label><div id="hrManagerList" isteven-multi-select="" input-model="vm.search.hrManagerList" output-model="vm.search.selectedHrManagerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="form-group col-sm-3 col-xs-3" ng-if="config.statusFilter.show"><label class="filter-label" translate="">status</label><div id="statusList" isteven-multi-select="" input-model="vm.statusList" output-model="vm.search.selectedStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div></div><div class="row form-inline"><div class="col-sm-9 cols-xs-3"></div><div class="col-sm-3 my-12 d-flex justify-end"><button id="attendanceSearchButton" type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchSalaryProcess()"><i class="ion-search"></i>{{\'search\' | translate}}</button></div></div></div><div class="row"><div class="col-md-12 mb-20"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-10 flex-wrap mt-10"><div class="float-left mt-negative-22" ng-if="config.componentFilter.show"><label class="text-capitalize" translate="">filters.component</label><div class="row"><div class="col-sm-12 width-20 min-width-250"><div isteven-multi-select="" selection-mode="single" input-model="vm.search.componentList" output-model="vm.search.selectedComponentList" button-label="name" item-label="componentName name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" on-select-all="vm.searchSalaryProcess()" on-select-none="vm.searchSalaryProcess()" on-item-click="vm.searchSalaryProcess()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search\', \'nothingSelected\' : \'Select a Component\' }"></div></div></div></div><div class="float-left mt-negative-22" ng-if="config.absenceTypeFilter.show"><label class="text-capitalize min-width-80" translate="">filters.absenceType</label><div class="row"><div class="col-sm-12 width-20 min-width-250"><div isteven-multi-select="" selection-mode="single" input-model="vm.search.absenceTypeList" output-model="vm.search.selectedAbsenceTypeList" button-label="name" item-label="absenceTypeName name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" on-select-all="vm.searchSalaryProcess()" on-select-none="vm.searchSalaryProcess()" on-item-click="vm.searchSalaryProcess()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search\', \'nothingSelected\' : \'Select a Absence Type\' }"></div></div></div></div><div class="filter-inline-item d-inline-block mt-negative-22" id="employeeNameSearchBox2" ng-if="config.searchByNameIdRfid.show && type===\'comparison\'"><label class="text-capitalize" translate="">filters.searchEmployee</label><div class="form-group has-feedback has-search placeholder-text-13"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control" type="text" placeholder="Search Employee by Name/ID" ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchSalaryProcess() : vm.getAllOnEmptySearchKeyword()"></div></div><div class="float-left mt-negative-22" ng-if="config.monthYearPickerFrom.show"><label class="text-capitalize" translate="">filters.from</label><div class="filter-inline-item"><div class="input-group mb-0 width-150 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerFrom.format}}" datepicker-options="vm.monthPickerFrom.options" ng-model="vm.selectedMonthFrom" is-open="vm.monthPickerFrom.opened" ng-change="vm.updateSalaryMonth()" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openmonthPickerFrom()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="float-left mt-negative-22" ng-if="config.monthYearPickerTo.show"><label class="text-capitalize" translate="">filters.to</label><div class="filter-inline-item"><div class="input-group mb-0 width-150 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerTo.format}}" datepicker-options="vm.monthPickerTo.options" ng-model="vm.selectedMonthTo" is-open="vm.monthPickerTo.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openmonthPickerTo()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="float-left mt-negative-22" ng-if="config.monthYearPickerSalary.show"><label class="text-capitalize" translate="">filters.salaryMonth</label><div class="filter-inline-item"><div class="input-group mb-0 width-150 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerSalary.format}}" datepicker-options="vm.monthPickerSalary.options" ng-model="vm.selectedMonthSalary" is-open="vm.monthPickerSalary.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openmonthPickerSalary()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="float-left mt-negative-22" ng-if="config.monthYearPickerComparison.show"><label class="text-capitalize" translate="">filters.comparisonMonth</label><div class="filter-inline-item"><div class="input-group width-150 mb-0 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerComparison.format}}" datepicker-options="vm.monthPickerComparison.options" ng-model="vm.selectedMonthComparison" is-open="vm.monthPickerComparison.opened" ng-required="false" show-button-bar="false" ng-disabled="config.monthYearPickerComparison.disable"> <span class="input-group-btn"><button ng-disabled="config.monthYearPickerComparison.disable" type="button" class="btn btn-default modified-input-box" ng-click="vm.openmonthPickerComparison()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="filter-inline-item" ng-if="config.uploadButton.show"><button class="btn btn-md-with-icon btn-primary padding-10-12 dropdown-toggle font-13" ngf-select="vm.excelUploadMethod($file)" ngf-multiple="false" ngf-accept="\'.xls,.xlsx\'"><span class="ml-negative-5" ng-if="config.uploadButton.show" translate="">{{uploadBtnName}}</span></button></div></div><div class="filter-inline mt-10"><div id="payrollTableRowsPerPageDiv" ng-if="config.sortKey.show" class="filter-inline-item d-flex-align-center text-right min-height-33 mr-10"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div><div class="filter-inline-item" ng-if="config.rowPerPage.show"><div class="form-group d-flex-space-between mb-0-important"><label for="rowsPerPageSelection"><strong translate="">rowsPerPage</strong></label><div class="custom-select"><select id="rowsPerPageSelection" ng-model="vm.rowsPerPage" ng-change="vm.searchSalaryProcess()"><option value="10" ng-selected="vm.rowsPerPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="50" ng-selected="vm.rowsPerPage==50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.rowsPerPage==100" translate="">{{\'commonKeywords.hundred\'}}</option><option value="500" ng-selected="vm.rowsPerPage==500" translate="">{{\'commonKeywords.fiveHundred\'}}</option><option value="1000" ng-selected="vm.rowsPerPage==1000" translate="">{{\'commonKeywords.thousand\'}}</option><option ng-show="vm.stateName === \'attendanceReport.allLogs\'" value="50000" ng-selected="vm.rowsPerPage==50000" translate="">{{\'commonKeywords.fiftyThousand\'}}</option><option ng-show="vm.stateName === \'attendanceReport.allLogs\'" value="500000" ng-selected="vm.rowsPerPage==500000" translate="">{{\'commonKeywords.fiveHundredThousand\'}}</option></select></div></div></div><div class="ml-10 filter-inline-item d-flex-align-end mb-10 mt-negative-1" ng-if="config.excelDownloadButton.show && type===\'comparison\'"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div></div></div></div></div><div class="row"><div class="col-md-12 filter-inline flex-wrap"><div class="d-flex-gap-10 flex-wrap"><div class="filter-inline-item d-inline-block" id="employeeNameSearchBox" ng-if="config.searchByNameIdRfid.show && type!=\'comparison\'"><label ng-if="config.searchByNameIdRfid.showLabel" class="filter-label" translate="">filters.searchEmployee</label><div class="form-group has-feedback has-search placeholder-text-13"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control" type="text" placeholder="Search Employee by Name/ID/RFID" ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchByNameOrId() : vm.getAllOnEmptySearchKeyword()"></div></div><div class="filter-inline-item" id="filterByNetPaySearchBox" ng-if="config.filterByNetPayment.show"><label class="filter-label" translate="">filters.filterByNetPayment</label><div class="d-flex-center-gap-10"><div class="form-group has-search width-150"><input class="form-control" type="number" placeholder="Min Amount" ng-model="vm.search.minAmount" ng-keyup="$event.keyCode == 13 && vm.searchByNameOrId()"></div><span class="d-flex-align-center mb-10">-</span><div class="form-group has-search width-150"><input class="form-control" type="number" placeholder="Max Amount" ng-model="vm.search.maxAmount" ng-keyup="$event.keyCode == 13 && vm.searchByNameOrId()"></div></div></div><div class="filter-inline-item d-flex-align-end mb-10" ng-if="config.addButton.show"><button ng-click="vm.addNewComponent()" class="btn btn-md-with-icon btn-primary padding-10-12 dropdown-toggle font-13 mb-5"><span class="ml-negative-5" translate="">{{addBtnName}}</span></button></div></div><div class="d-flex-gap-10 ml-8"><div class="filter-inline-item d-flex-align-end mb-10" ng-if="config.downloadBankAdviceLetterButton.show"><button class="btn btn-md-with-icon btn-primary padding-7-12 font-13"><img class="img-resize" src="../assets/img/Download.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.downloadBankAdviceLetter\'}}</span></button></div><div class="filter-inline-item d-flex-align-end mb-10" ng-if="config.excelDownloadButton.show && type!=\'comparison\'"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item d-flex-align-end mb-10" ng-if="config.pdfDownloadButton.show"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsPdf(\'H\')"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div><div class="filter-inline-item d-flex-align-end mb-10" ng-if="config.downloadDemoExcelButton.show"><button class="btn btn-md-with-icon border-btn padding-7-12 font-13 mb-3" ng-click="vm.downloadSampleExcel()"><img class="img-resize" src="../assets/img/Download.png"> <span class="ml-negative-5" translate="">{{downloadDemoExcelBtnName}}</span></button></div><div class="filter-inline-item d-flex-align-end mb-10" ng-if="config.deleteButton.show"><button ng-class="deleteBtnActive == true ? \'btn-danger\':\'btn-disable\'" class="btn btn-md-with-icon padding-9-12 dropdown-toggle font-13"><i class="ion-android-delete"></i> <span class="ml-negative-5 mt-negative-5" translate="">{{\'commonKeywords.deleteAllButton\'}}</span></button></div></div></div></div>');
$templateCache.put('app/pages/directives/searchPageTop/searchPageTop.html','<style>\n    .on-leave{\n        color:blue;\n    }\n    .on-holiday{\n        color: green\n    }\n    .on-specialDay{\n        color: green;\n    }\n\n    .on-fieldVisit{\n        color:blue;\n    }\n    .absent{\n        color:red\n    }\n    .late{\n        color:red;\n    }\n    .present{\n        color:green\n    }\n    .off-day{\n        color:blue;\n    }\n    .section-width{\n        min-width: 150px;\n    }\n    li{\n        list-style: none;\n    }\n    .search-top-dropdown-menu {\n        width: 243px;\n        left: 0px;\n    }\n    .top-bar-search-employee .active .status {\n        color: white!important;\n    }\n    .top-bar-search-employee .dropdown-menu > .active > a{\n        background: #209e91!important;\n    }\n    small{\n        font-size: 100%;\n    }\n</style><script type="text/ng-template" id="employeeSuggestionDetails.html"><a> <div class="d-flex-align-center text-left width-100 cursor-pointer"> <div class="with-round-bg mb-0"> <img ng-if="match.model.url.length > 0" ng-src="{{match.model.url}}"> <img ng-if="match.model.url == \'\' || match.model.url == null" src="../assets/img/theme/no-avatar.png"> </div> <div class="profile-info"> <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span> <div class=\'font-12 section-width\'> <small class="d-flex-space-between"> <span class="present status" ng-if="match.model.attendanceStatus == \'Present\'">{{match.model.attendanceStatus}}</span> <span class="absent status" ng-if="match.model.attendanceStatus == \'Absent\'">{{match.model.attendanceStatus}}</span> <span class="late status" ng-if="match.model.attendanceStatus == \'Late\'">{{match.model.attendanceStatus}}</span> <span class="on-specialDay status" ng-if="match.model.attendanceStatus == \'Special Day\'">{{match.model.attendanceStatus}}</span> <span class="on-holiday status" ng-if="match.model.attendanceStatus == \'Holiday\'">{{match.model.attendanceStatus}}</span> <span class="on-fieldVisit status" ng-if="match.model.attendanceStatus == \'Field Visit\'">{{match.model.attendanceStatus}}</span> <span class="on-leave status" ng-if="match.model.attendanceStatus == \'Leave\'">{{match.model.attendanceStatus}}</span> <span class="off-day status" ng-if="match.model.attendanceStatus == \'Off Day\'">{{match.model.attendanceStatus}}</span> <span class="status" ng-class="{\'late\':match.model.attendanceStatus == \'Late\'}">{{match.model.entryTime}}</span> </small> </div> </div> </div> </a></script><div class="row top-bar-search-employee"><div class="col-md-12"><li uib-dropdown=""><div uib-dropdown-toggle=""><div><label ng-if="showLabel" ng-class="{\'required\' : isRequired}" translate="">{{ \'filters.searchEmployee\'}}</label><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control form-control-text-input" ng-model="keyword" placeholder="{{isHostSelection? \'visitorManagement.createAppointment.searchHost\':\'filters.searchByNameID\' | translate}}" uib-typeahead="employee as employee.name for employee in searchEmployee($viewValue)" typeahead-template-url="employeeSuggestionDetails.html" typeahead-on-select="vm.selectEmployee($item)"></div></div></div><div ng-if="!vm.resultFound && vm.isExistKeyword" uib-dropdown-menu="" class="search-top-dropdown-menu"><span class="d-inline-block ml-15">No data found</span></div></li></div></div>');
$templateCache.put('app/pages/directives/vehicleInfoDirective/vehicleInfoDirective.html','<style>\n    small {\n        font-size: 100% !important;\n    }\n    .with-round-bg img{\n        background: #c7c7c7!important;\n    }\n</style><div class="flex-container text-left employee-info width-100"><div class="with-round-bg mb-0"><img ng-if="vehicleType == 1" ng-src="../assets/img/car.png"> <img ng-if="vehicleType == 2" ng-src="../assets/img/bike.png"></div><div class="profile-info"><span class="section-header">{{vehicleNumber}}</span></div></div>');
$templateCache.put('app/pages/directives/visitorPictureAndInformation/visitorPictureAndInformation.html','<style xmlns="http://www.w3.org/1999/html">\n    .with-round-bg img{\n        width: 40px;\n        margin-bottom: 0px\n    }\n    .clickable-profile{\n        color:white;\n    }\n    .info-bg{\n        color: #999\n    }\n    #profile-info{\n        margin-left: 2%;\n        min-width: 250px;\n    }\n</style><div class="flex-container text-left"><div class="with-round-bg mb-0"><img ng-if="!!pictureUrl" ng-src="{{pictureUrl}}"> <img ng-if="!pictureUrl" ng-src="../assets/img/theme/no-photo.png"></div><div id="profile-info"><span ng-if="isClickable"><a class="clickable-profile" ui-sref="profile({employeeId : id})">{{name}}</a></span> <span class="section-header" ng-if="!isClickable">{{name}}</span><div class="default-text"><small class="font-12"><span ng-if="(companyName && companyName != \'N/A\') && (visitPurpose && visitPurpose != \'N/A\')"><span ng-class="{modified: isCompanyNameChanged}">{{companyName}}</span><span><br><span ng-class="{modified: isVisitPurposeChanged}" class="visit-purpose-string-below">{{visitPurpose}}</span></span></span> <span ng-if="(companyName && companyName != \'N/A\') && (!visitPurpose || visitPurpose == \'N/A\')" ng-class="{modified: isCompanyNameChanged}">{{companyName}}</span> <span ng-if="(!companyName || companyName == \'N/A\') && (visitPurpose && visitPurpose != \'N/A\')"><span ng-class="{modified: isVisitPurposeChanged}">{{visitPurpose}}</span></span> <span ng-if="companyName == \'N/A\' && visitPurpose == \'N/A\'"><span translate="">{{\'commonKeywords.notSet\'}}</span></span></small></div></div></div>');
$templateCache.put('app/pages/main/companies/companies.html','<div ba-panel="" ba-panel-title="Companies" ba-panel-class="with-scroll"><button type="button" class="btn btn-info btn-with-icon" ng-click="vm.openCompanyCreateModal()"><i class="ion-android-checkmark-circle"></i><span translate="">{{\'companies.createCompany\'}}</span></button><br><br><div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th translate="">{{\'companies.companyTableHeader.id\'}}</th><th translate="">{{\'companies.name\'}}</th><th class="text-left" translate="">{{\'companies.companyTableHeader.actions\'}}</th></tr></thead><tbody><tr ng-repeat="company in vm.allCompanies" class="no-top-border"><td>{{$index+1}}</td><td><a ui-sref="companyDetails({ companyId : {{company.id}} } )" tooltips="" tooltip-template="{{\'companies.tooltipText1\' | translate}}">{{company.name}}</a></td><td class="text-left"><a class="actionIcons" tooltips="" tooltip-template="{{\'companies.tooltipText2\' | translate}}"><i class="ion-ios-compose-outline" ng-click="vm.openCompanyEditModal(company .id,company.name)"></i></a></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/billing/billing.html','<div ba-panel="" ba-panel-title="{{ \'billing\' }}" ba-panel-class="with-scroll" ng-controller="BillingCtrl"><style>\n        .subscription-plain-card{\n          padding: 18px;\n        }\n        .subscription-plain-msg{\n          background: #d7e8f6;\n          border-radius: 14px;\n          padding: 18px 22px;\n          text-align: center;\n          margin-bottom: 16px;\n          color: #21323b;\n          line-height: 1.45;\n          font-size: 15px;\n        }\n        .subscription-plain-card .big-btn{\n          display: block;\n          margin: 12px auto 8px;\n          min-width: 260px;\n          font-size: 28px;\n          line-height: 1.2;\n          padding: 10px 22px;\n        }\n        .subscription-plain-card .payment-meta{\n          text-align: center;\n          margin-top: 12px;\n          font-size: 12px;\n          color: #5f6b73;\n        }\n        .subscription-plain-card .payment-meta em{\n          font-style: italic;\n        }\n    </style><div class="subscription-plain-card" role="dialog" aria-modal="true"><div class="subscription-plain-msg"><div ng-if="isPrivileged()"><span ng-if="status.warn7Days && !status.isExpired && !status.warn3Days">Dear Client, Your Tipsoi HRM subscription is nearing its renewal date. Please renew your subscription and enjoy uninterrupted service.</span><span ng-if="status.warn3Days && !status.isExpired">Dear Client, Your Tipsoi HRM subscription is about to end. Please renew now and ensure seamless access to all features.</span><span ng-if="status.isExpired">Dear Client, Your Tipsoi HRM subscription has expired. Please renew now and reactivate your subscription. This panel will be deactivated soon.</span><span ng-if="status.isPastGracePeriodDays">Dear Client, Your Tipsoi HRM subscription has ended. To resume uninterrupted access to our services, please click below and renew your subscription at your earliest convenience.</span><span ng-if="status.isExpiredPriority">Dear Client, Your Tipsoi HRM subscription has expired on [{{ (dueDateMs | date:\'dd/MM/yyyy\') || \'notSet\' }}]. Click below to renew now and reactivate your subscription.</span><span ng-if="!status.warn7Days && !status.warn3Days && !status.isExpired && !status.isPastGracePeriodDays && !status.isExpiredPriority">Your subscription is active. No action needed right now.</span></div><div ng-if="!isPrivileged()"><span ng-if="status.isPastGracePeriodDays">Dear User, Your Tipsoi HRM subscription has ended. Please contact your administrator to renew the subscription and restore access to the services.</span><span ng-if="!status.isPastGracePeriodDays">Your subscription status is being managed by your administrator.</span></div></div><button type="button" class="btn btn-secondary big-btn" ng-click="payNow($event)" ng-if="isPrivileged()">Renew Subscription</button><div class="payment-meta" ng-if="isPrivileged()"><em>Previous Bill Paid On:<br>{{ (lastPaymentDate | date:\'dd/MM/yyyy\') || \'notSet\' }}<br>Status: {{ (status.isExpired || status.isPastGracePeriodDays) ? \'Pending\' : \'Active\' }}</em></div></div></div>');
$templateCache.put('app/pages/main/dashboard/dashboard-root.html','<birthday-pop-up ng-if="vm.shouldShowBirthdayPopUp" data="vm.todayBirthdays" on-close="vm.shouldShowBirthdayPopUp = false"></birthday-pop-up><div include-with-scope="app/pages/main/dashboard/dashboardTemplates/dashboardDesktop.html" ng-if="!vm.showMobile"></div><div include-with-scope="app/pages/main/dashboard/dashboardTemplates/dashboardMobile.html" ng-if="vm.showMobile"></div>');
$templateCache.put('app/pages/main/notifications/notifications.html','<div ba-panel="" ng-if="!vm.notifications || vm.notifications.length == 0"><p translate="">{{ \'notifications.noNotificationMsg\' }}</p></div><div ng-if="vm.notifications.length > 0"><div ba-panel="" ng-repeat="item in vm.notifications" ba-panel-title="{{ item.shortMessage }}"><div class="feed-message"><p ng-if="item.longMessage && item.longMessage.length >0">{{item.longMessage}}</p><div class="message-time"><div class="post-time">{{vm.displayTime(item.creationTime)}}</div></div></div></div><div ba-panel="" ng-if="vm.showLoadMoreBtn" class="text-center"><a href="" ng-click="vm.loadMore()" class="text-center">Load More...</a></div></div>');
$templateCache.put('app/pages/main/offices/officeDetails.html','<div ba-panel="" ba-panel-title="Office Details" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6 bottom mt-20"><label class="col-sm-3 control-label" translate="">{{\'offices.name\'}}</label> <a href="#" editable-text="office.name" onbeforesave="updateName($data,office.id)">{{ office.name || \'empty\'}}</a></div><div class="col-md-6 bottom mt-20"><label class="col-sm-3 control-label" translate="">{{\'offices.location\'}}</label> <a href="#" editable-textarea="office.location" onbeforesave="updateLocation($data,office.id)">{{ office.location || \'empty\'}}</a></div><div class="col-md-6 bottom" style="margin-top: 20px"><label class="col-sm-3 control-label" translate="">{{\'offices.officeType\'}}</label> <a href="#" editable-text="office.officeType" onbeforesave="updateOfficeType($data,office.id)"><strong ng-if="office.officeType == \'1\'" translate="">{{\'offices.corporate\'}}</strong></a></div><div class="col-md-6 bottom" style="margin-top: 20px"><label class="col-sm-3 control-label" translate="">{{\'offices.description\'}}</label><div class="popover-wrapper"><a href="#" editable-text="office.description" onbeforesave="updateDescription($data,office.id)">{{ office.description || \'empty\'}}</a></div></div></div><br><br><br><br><h3 class="panel-title" translate="">{{\'offices.attendanceChardHeading\'}}</h3><hr><div class="row" ng-controller="OfficeChartsCtrl"><div class="col-md-6"><div class="panel panel-default bootstrap-panel"><div class="panel-heading bg-white" translate="">{{\'offices.officeCharts\'}}</div><div class="panel-body"><canvas id="1" class="chart chart-doughnut" chart-options="options" chart-data="data" chart-labels="labels" chart-colors="colours"></canvas></div></div></div><div class="col-md-6"><div class="panel panel-default bootstrap-panel"><div class="panel-heading bg-white" translate="">{{\'offices.officeCharts\'}}</div><div class="panel-body"><canvas id="2" class="chart chart-doughnut" chart-options="options" chart-data="data" chart-labels="labels" chart-colors="colours"></canvas></div></div></div></div></div>');
$templateCache.put('app/pages/main/offices/offices.html','<div ba-panel="" ba-panel-title="Offices" ba-panel-class="with-scroll"><br><br><div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id" translate="">{{\'offices.officeTableHeader.hash\'}}</th><th><strong></strong></th><th><strong translate="">{{\'offices.officeTableHeader.location\'}}</strong></th><th><strong translate="">{{\'offices.officeTableHeader.officeType\'}}</strong></th><th><strong translate="">{{\'offices.officeTableHeader.Description\'}}</strong></th></tr></thead><tbody><tr ng-repeat="office in allOffices"><td class="table-id">{{office.id}}</td><td><a ui-sref="officeDetails({ officeId : {{office.id}} } )">{{office.name}}</a></td><td>{{office.location}}</td><td ng-if="office.officeType == \'1\'">{{\'offices.corporate\'}}</td><td>{{office.description}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/pendingApprovals.html','<style>\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n     .panel .panel-body{\n         min-height: 0px;\n     }\n    /*.table thead tr th {*/\n    /*    white-space: normal !important;*/\n    /*}*/\n    .scrollable-table {\n        max-height: 64vh;\n        overflow: auto;\n        position: relative;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'pendingApplicationApprovals.leave.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-13"><col class="width-8"><col class="width-10"><col class="width-3"><col class="width-15"><col class="width-9"><col class="width-5"><col class="width-6"><col class="width-13"><col class="width-18"></colgroup><thead><tr><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.name\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.category\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.timeline\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.days\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.reason\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.applicationType\' }}</th><th class=\'text-center"\' translate="">{{ \'pendingApplicationApprovals.tableHeader.leaveType\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.file\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.otherApprovalStatus\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isLeaveApproveDataLoaded" ng-repeat="application in vm.leaveApplications"><td class="text-left"><employee-picture-and-information name="application.employeeName" picture-url="application.employeeProfilePictureUrl" department-name="" designation-name="" id="application.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-left">{{application.categoryName}}</td><td class="text-center">{{application.startDateLong | date :\'d MMM yyyy\'}} <span ng-if="application.numberOfDays > 1"><br><span translate="">{{\'pendingApplicationApprovals.to\'}}</span><br>{{application.endDateLong | date :\'d MMM yyyy\'}}</span></td><td class="text-center">{{application.numberOfDays}}</td><td class="text-left">{{application.reason}}</td><td class="text-center">{{application.applicationEventTypeName}}</td><td class="text-center">{{application.type == 1 ? \'Full\' : \'Half\'}}</td><td class="text-center" ng-if="application.fileUrl != null && application.fileUrl != \'\'"><a ng-href="{{application.fileUrl}}" target="_self"><span translate="">{{\'commonKeywords.download\'}}</span></a></td><td class="text-center" ng-if="application.fileUrl == null || application.fileUrl ==\'\'"><em class="color-999999" translate="">{{\'commonKeywords.na\'}}</em></td><td class="text-left"><span ng-if="application.otherApproverName"><a ui-sref="profile({employeeId : application.otherApproverId})">{{application.otherApproverName}}</a><br><em>{{application.otherApproverStatus}}</em><br><span ng-if="application.otherApproverStatus !==\'Pending\'">{{application.otherApproverComment}}</span></span> <span ng-if="!application.otherApproverName" class="color-999999"><em>N/A</em></span></td><td class=\'text-center"\'><div class="d-flex-center-gap-10"><button class="btn btn-sm btn-primary" ng-disabled="vm.disableApproveRejectForLeave" ng-click="vm.openLeaveApproveModal(application)" translate="">{{ \'pendingApplicationApprovals.approveButton\' }}</button> <button class="btn btn-sm btn-danger" ng-disabled="vm.disableApproveRejectForLeave" ng-click="vm.openLeaveRejectModal(application)" translate="">{{ \'pendingApplicationApprovals.rejectButton\' }}</button> <button ui-sref="leaveApplicationDetails({leaveLogId: application.leaveLogId, applicantId: application.employeeId, applicantName: application.employeeName})" class="btn btn-sm-with-icon border-btn" ng-click="vm.analyticsViewDetails()"><i class="ion-search"></i><span class="pb-2">{{\'pendingApplicationApprovals.viewDetailsButton\' | translate}}</span></button></div></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isLeaveApproveDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><p class="text-center mt-10" ng-if="vm.isLeaveApproveDataLoaded && vm.leaveApplications.length == 0"><em translate="">{{ \'pendingApplicationApprovals.leave.noApplicationMsg\' }}</em></p></div></div></div><div ba-panel="" ba-panel-title="{{ \'pendingApplicationApprovals.late.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-15"><col class="width-9"><col class="width-9"><col class="width-9"><col class="width-21"><col class="width-20"><col class="width-13"></colgroup><thead><tr><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.date\' }}</th><th class="text-center" translate="">{{ \'entryTime\' }}</th><th class="text-center" translate="">{{ \'lateBy\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.reason\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.otherApprovalStatus\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isLateApprovalDataLoaded" ng-repeat="lateApprovalApplication in vm.lateApprovalApplications"><td class="text-left"><employee-picture-and-information name="lateApprovalApplication.employeeName" picture-url="lateApprovalApplication.employeeProfilePictureUrl" department-name="" designation-name="" id="lateApprovalApplication.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{lateApprovalApplication.attendanceTime | date:\'d MMM yyyy\'}}</td><td class="text-center">{{lateApprovalApplication.attendanceTime | date :\'hh:mm a\'}}</td><td class="text-center">{{lateApprovalApplication.lateBy}}</td><td class="text-left">{{lateApprovalApplication.reason}}</td><td class="text-left"><span ng-if="lateApprovalApplication.otherApproverName"><a ui-sref="profile({employeeId : application.otherApproverId})">{{lateApprovalApplication.otherApproverName}}</a><br><em>{{lateApprovalApplication.otherApproverStatus}}</em><br><span ng-if="lateApprovalApplication.otherApproverStatus !==\'Pending\'">{{lateApprovalApplication.otherApproverComment}}</span></span> <span ng-if="!lateApprovalApplication.otherApproverName" class="color-999999"><em>N/A</em></span></td><td class=\'text-center"\'><div class="d-flex-center-gap-10"><button class="btn btn-sm btn-primary" ng-click="vm.openLateRequestApproveModal(lateApprovalApplication)" ng-disabled="vm.disableApproveRejectForLate" translate="">{{ \'pendingApplicationApprovals.approveButton\' }}</button> <button class="btn btn-sm btn-danger" ng-click="vm.openLateRequestRejectModal(lateApprovalApplication)" ng-disabled="vm.disableApproveRejectForLate" translate="">{{ \'pendingApplicationApprovals.rejectButton\' }}</button></div></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isLateApprovalDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><p class="text-center mt-10" ng-if="vm.isLateApprovalDataLoaded && vm.lateApprovalApplications.length == 0"><em translate="">{{ \'pendingApplicationApprovals.late.noApplicationMsg\' }}</em></p></div></div></div><div ba-panel="" ba-panel-title="{{ \'pendingApplicationApprovals.manualEntry.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-13"><col class="width-10"><col class="width-7"><col class="width-7"><col class="width-10"><col class="width-23"><col class="width-13"><col class="width-13"></colgroup><thead><tr><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.date\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.entryTime\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.exitTime\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.type\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.reason\' }}</th><th class="text-left" translate="">{{ \'pendingApplicationApprovals.tableHeader.otherApprovalStatus\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isManualEntryApplicationDataLoaded" ng-repeat="manualEntryApplication in vm.manualEntryApplications"><td class="text-left"><employee-picture-and-information name="manualEntryApplication.employeeName" picture-url="manualEntryApplication.employeePicUrl" department-name="" designation-name="" id="manualEntryApplication.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{manualEntryApplication.startDateLong | date:\'d MMM yyyy\'}} <span ng-if="manualEntryApplication.numberOfDays > 1"><span ng-if="manualEntryApplication.type != 2"><br><span translate="">{{\'pendingApplicationApprovals.to\'}}</span><br>{{manualEntryApplication.endDateLong | date:\'d MMM yyyy\'}}</span></span></td><td class="text-center">{{manualEntryApplication.entryTime}}</td><td class="text-center" ng-if="manualEntryApplication.exitTime != null">{{manualEntryApplication.exitTime}}</td><td class="text-center color-999999" ng-if="manualEntryApplication.exitTime == null"><span translate="">{{\'commonKeywords.na\'}}</span></td><td class="text-center">{{manualEntryApplication.typeText}}</td><td class="text-left">{{manualEntryApplication.reason}}</td><td class="text-left"><span ng-if="manualEntryApplication.otherApproverName"><a>{{manualEntryApplication.otherApproverName}}</a><br><em>{{manualEntryApplication.otherApproverStatus}}</em><br><span ng-if="manualEntryApplication.otherApproverStatus !== \'Pending\'">{{manualEntryApplication.otherApproverComment}}</span></span> <span ng-if="!manualEntryApplication.otherApproverName" class="color-999999"><em>N/A</em></span></td><td class=\'text-center"\'><div class="d-flex-center-gap-10"><button class="btn btn-sm btn-primary" ng-click="vm.openManualEntryApproveModal(manualEntryApplication)" ng-disabled="vm.disableApproveRejectForME" translate="">{{ \'pendingApplicationApprovals.approveButton\' }}</button> <button class="btn btn-sm btn-danger" ng-click="vm.openManualEntryRejectModal(manualEntryApplication)" ng-disabled="vm.disableApproveRejectForME" translate="">{{ \'pendingApplicationApprovals.rejectButton\' }}</button></div></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isManualEntryApplicationDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><p class="text-center mt-10" ng-if="vm.isManualEntryApplicationDataLoaded && vm.manualEntryApplications.length == 0"><em translate="">{{ \'pendingApplicationApprovals.manualEntry.noApplicationMsg\' }}</em></p></div><div ba-panel="" ba-panel-title="{{ \'pendingApplicationApprovals.timeSheet.title\' | translate }}" ba-panel-class="with-scroll" ng-if="vm.isHrManager"><div class="row mb-20"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-15"><col class="width-15"><col class="width-25"><col class="width-25"><col class="width-13"></colgroup><thead><tr><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.year\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.month\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.lineManager\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.lineManagerApprovalStatus\' }}</th><th class="text-center" translate="">{{ \'pendingApplicationApprovals.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.istimeSheetDataLoaded" ng-repeat="application in vm.timeSheetApprovals track by application.id"><td class="text-center">{{application.year}}</td><td class="text-center">{{vm.monthList[application.month]}}</td><td class="text-center"><a ui-sref="profile({employeeId : {{application.lineManagerId}}})">{{application.lineManagerName}}</a></td><td class="text-center">{{application.lineManagerStatusText}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm btn-primary" ng-click="vm.openTimeSheetApproveModal(application.id,$index)" translate="">{{ \'pendingApplicationApprovals.approveButton\' }}</button> <button class="btn btn-sm btn-danger" ng-click="vm.openTimeSheetRejectModal(application.id,$index)" translate="">{{ \'pendingApplicationApprovals.rejectButton\' }}</button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.istimeSheetDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><p class="text-center mt-10" ng-if="vm.istimeSheetDataLoaded && vm.timeSheetApprovals.length == 0"><em translate="">{{ \'pendingApplicationApprovals.timeSheet.noApplicationMsg\' }}</em></p></div><div ba-panel="" ba-panel-title="{{ \'pendingApplicationApprovals.overtime.title\' | translate }}" ba-panel-class="with-scroll" ng-if="vm.isAdminOrHrManager && !vm.isInovace"><p class="red-text" ng-if="vm.overtimeApprovalsCount != 0"><b><em><span translate="">{{\'pendingApplicationApprovals.numberOfPendingApprovals\'}}</span> {{vm.overtimeApprovalsCount}} <span translate="">{{\'pendingApplicationApprovals.pending\'}}</span></em></b></p><p class="text-center mt-10" ng-if="vm.overtimeApprovalsCount === 0"><em translate="">{{ \'pendingApplicationApprovals.overtime.noApplicationMsg\' }}</em></p></div>');
$templateCache.put('app/pages/main/profile/profile.html','<div ng-show="vm.waitForLoading">Please wait while the profile is loading...</div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!vm.waitForLoading"><uib-tabset active="vm.activeTab"><uib-tab heading="Profile Information" index="0" select="vm.onProfileInfoTabSelect()"><div include-with-scope="app/pages/main/profile/profileInfo/profileInfo.html"></div></uib-tab><uib-tab heading="Attendance Report" index="1" select="vm.onAttendanceTabSelect()"><div include-with-scope="app/pages/main/profile/attendance/attendance-report.html"></div></uib-tab><uib-tab heading="Leave" index="2" select="vm.onLeaveTabSelect()"><div include-with-scope="app/pages/main/profile/leave/leave.html"></div></uib-tab><uib-tab heading="Enrol Employee" index="3" select="vm.onEnrollTabSelect()" ng-if="(vm.requestorIsAdmin && !vm.isCompanyAdmin) || vm.isLineManagerPermitted"><div include-with-scope="app/pages/main/profile/enrol/enrol.html"></div></uib-tab><uib-tab heading="Device Permissions" index="4" select="vm.onDevicePermissionsTabSelect()" ng-if="vm.requestorIsAdmin || vm.isLineManagerPermitted"><div include-with-scope="app/pages/main/profile/device-permissions/device-permissions.html"></div></uib-tab><uib-tab heading="Roster" select="vm.onRosterTabSelect()" index="5"><div include-with-scope="app/pages/main/profile/roster/roster.html"></div></uib-tab><uib-tab heading="Pending Approvals" index="6" select="vm.onPendingApprovalsTabSelect()"><div ng-controller="ProfilePendingApprovalsCtrl as vm" include-with-scope="app/pages/main/profile/pendingApprovals/pendingApprovals.html"></div></uib-tab><uib-tab ng-if="vm.isProjectManagementEnabled" heading="Timesheet Report" index="7" select="vm.onTimeSheetReportTabSelect()"><div include-with-scope="app/pages/main/profile/perEmployeeTimeSheetReport/report.html"></div></uib-tab><uib-tab ng-if="vm.isPayrollManager || vm.isPayrollApprover" heading="Payroll" index="8" select="vm.onPayrollTabSelect()"><div ng-controller="PayrollCtrl as vm" include-with-scope="app/pages/main/profile/payroll/payroll.html"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/main/sms/sms.html','<div ba-panel="" ba-panel-title="{{ \'sendSms.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-50"><div class="col-sm-2"><h4 class="text-right mt-10" translate="">{{ \'sendSms.employeeSelectLabel\' }}</h4></div><div class="col-sm-3 col-xs-6"><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployeeList" button-label="name" item-label="name" tick-property="ticked" output-properties="employeeId"></div></div><div class="col-sm-3 col-xs-6"><button class="btn btn-primary btn-block" ng-click="vm.openConfirmModal()" translate="">{{ \'sendSms.sendButton\' }}</button></div></div><div class="row mb-20"><div class="col-md-4"></div><div class="col-md-4"><h3 translate="">{{ \'sendSms.smsInputLabel\' }}</h3><br><textarea cols="30" ng-model="vm.sms" rows="10" maxlength="160"></textarea></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in menuItems" ng-if="item.show" class="al-sidebar-list-item" ng-class="{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item" id="{{\'sidebar-\'+$index}}"><a ng-mouseenter="hoverItem($event, item)" ng-if="!item.subMenu && !item.grey" ui-state="item.stateRef || \'\'" ng-href="{{(item.fixedHref ? item.fixedHref: \'\')}}" class="al-sidebar-list-link"><i class="{{ item.icon }}"></i> <span translate="">{{ item.title }}</span><div class="icon-div" ng-if="item.notification"><span class="sidebar-notification">{{item.notification}}</span></div></a><upgrade-link ng-if="!item.submenu && item.grey"><a ng-mouseenter="hoverItem($event, item)" ng-if="!item.subMenu && !item.grey" ui-state="item.stateRef || \'\'" ng-href="{{(item.fixedHref ? item.fixedHref: \'\')}}" class="al-sidebar-list-link"><i class="{{ item.icon }}"></i><span class="menu-item-disabled" translate="">{{ item.title }}</span></a></upgrade-link><a ng-mouseenter="hoverItem($event, item)" ng-if="item.subMenu && !item.grey" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ item.icon }}"></i><span translate="">{{ item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="item.subMenu"></b></a><upgrade-link style="cursor: pointer;"><a ng-if="item.subMenu && item.grey" ng-mouseenter="hoverItem($event, item)" class="al-sidebar-list-link"><i class="{{ item.icon }}"></i><span class="menu-item-disabled" translate="">{{ item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="item.subMenu"></b></a></upgrade-link><ul ng-if="item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in item.subMenu" ng-if="subitem.show !== false" ng-class="{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="{{(!subitem.grey && subitem.show !== false) ? \'selected\' : \'\'}}" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ subitem.title | translate}}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="subitem.subMenu"></b></a><ul ng-if="subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" class="al-sidebar-list-link"><upgrade-link ng-if="subSubitem.grey"><span class="menu-item-disabled">{{ subSubitem.title | translate }}</span></upgrade-link></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="subSubitem.show && !subSubitem.grey" ng-href="{{(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}"><i class="fa fa-angle-right" aria-hidden="true" style="color: #209e91;"></i> {{subSubitem.title| translate }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ subitem.title | translate}}</a> <a ng-mouseenter="hoverItem($event, item)" ng-if="!subitem.subMenu && !subitem.disabled" ui-state="subitem.stateRef || \'\'" ng-href="{{(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><i class="fa fa-angle-double-right" aria-hidden="true" style="color: #209e91;"></i><upgrade-link ng-if="subitem.grey"><span class="menu-item-disabled">{{ subitem.title | translate}}</span></upgrade-link><span ng-if="!subitem.grey">{{subitem.title | translate}}</span></a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle | translate }}</h1><ul class="breadcrumb al-breadcrumb mr-5"><li><a href="" ui-sref="dashboard">Home</a></li><li translate="">{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown="" auto-close="always" on-toggle="vm.toggleDropdown(open)"><a ng-if="vm.hasNotificationModule" href="" uib-dropdown-toggle=""><i class="fa fa-bell-o" style="font-size:20px"></i> <span ng-if="vm.totalUnseenNotifications">{{ vm.totalUnseenNotifications }}</span><div class="notification-ring"></div></a><a ng-if="!vm.hasNotificationModule" href="" ng-click="$event.preventDefault()"><i class="fa fa-bell-o bell-disabled" style="font-size:20px"></i></a><div ng-if="vm.hasNotificationModule" uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="" ng-click="vm.markAllAsRead()">Mark All as Read</a></div><div class="msg-list"><a style="cursor:default;" class="clearfix" ui-sref="profile({employeeId : msg.generatorEmpId})" ui-sref-opts="{reload: true}" ng-repeat="msg in vm.notifications"><div class="img-area"><img ng-src="../assets/img/theme/no-photo.png" ng-if="!msg.generatorEmpPicURL"> <img ng-src="{{ msg.generatorEmpPicURL }}" ng-if="msg.generatorEmpPicURL"></div><div class="msg-area"><div><div>{{ msg.shortMessage }}</div><span>{{ vm.displayTime(msg.creationTime) }} ( {{ vm.ago(msg.creationTime) }} )</span></div></div></a></div></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<head><meta name="viewport" content="width=device-width, initial-scale=1.0"><style>\n        @media screen and (min-width: 0px) and (max-width: 720px) {\n            #employeeName {\n            display: none;\n            }\n        }\n        .support-number{\n            color: white;\n            margin-top: 15px;\n        }\n        .office-logo {\n            height: 50px;\n            border-radius: 2px;\n        }\n        .page-top{\n            padding: 0 32px 0 8px;\n        }\n        .page-top-search .form-control {\n            background: transparent!important;\n            border: 1px solid rgba(253, 251, 251, 0.10);\n            color: white;\n            height: 35px!important;\n            width: 260px;\n        }\n        .page-top-search .dropdown-menu{\n            min-width: 260px;\n            padding: 10px 0px;\n        }\n        .page-top-search .form-control:focus {\n            border: 1px solid rgba(253, 251, 251, 0.30);\n        }\n        .page-top-search .form-control::placeholder {\n            color: white;\n        }\n        .page-top-search .glyphicon-search {\n            color: rgba(253, 251, 251, 0.80);\n        }\n        @media screen and (max-width: 1310px) {\n            .hide-number {\n                display: none;\n            }\n        }\n    </style></head><div class="page-top d-flex-space-between" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><div class="d-flex"><div><a ui-sref="dashboard.attendanceDashboard" class="al-logo clearfix"><img class="office-logo" ng-if="officeLogoUrl != null && officeLogoUrl !== \'\'" src="{{officeLogoUrl}}">&nbsp;<span>{{subsidiaryName ? subsidiaryName: officeName}}</span> Admin</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a></div><div class="placeholder-text-13 d-inline-block mt-15 ml-25 page-top-search" ng-if="searchAllowed"><search-page-top select-method="searchByEmployeeId" keyword="searchKeyword" show-label="false" is-required="false"></search-page-top></div></div><div class="user-profile"><div class="support-number hide-number"><span><i class="ion-android-call"></i></span> <span>+880 13133 59293</span></div><div><img class="office-logo" ng-if="officeLogoUrl2 != null && officeLogoUrl2 !== \'\'" src="{{officeLogoUrl2}}"> <img class="office-logo" ng-if="officeLogoUrl3 != null && officeLogoUrl2 !== \'\'" src="{{officeLogoUrl3}}"></div><div><msg-center></msg-center></div><div class="questions-section"><div class="row text-right"><a ui-sref="profile({employeeId: {{loggedInUser.id}}})" ui-sref-opts="{reload: true}">{{loggedInUser.name}}</a></div><div class="row text-right mt-5"><span class="badge text-normal" ng-if="loggedInUser.isAdmin">Admin</span> <span class="badge text-normal" ng-if="!isBangabhabanEmployee && loggedInUser.isLineManager">Line Manager</span> <span class="badge text-normal" ng-if="isBangabhabanEmployee && loggedInUser.isLineManager">Section Officer</span> <span class="badge text-normal" ng-if="loggedInUser.isHrManager">HR Manager</span> <span class="badge text-normal" ng-if="loggedInUser.isCompanyAdmin">Company Admin</span> <span class="badge text-normal" ng-if="loggedInUser.isGroupAdmin">Company Group Admin</span> <span class="badge text-normal" ng-if="loggedInUser.isParkingOperationsManager">Parking Operations Manager</span> <span class="badge text-normal" ng-if="loggedInUser.isPayrollApprover">Payroll Approver</span> <span class="badge text-normal" ng-if="loggedInUser.isPayrollManager">Payroll Manager</span> <span class="badge text-normal" ng-if="loggedInUser.isSiteManagementAdmin">Site Admin</span> <span class="badge text-normal" ng-if="loggedInUser.isSiteManagementManager">Site Manager</span> <span class="badge text-normal" ng-if="loggedInUser.isVisitorManagementAdmin">Visitor Management Admin</span> <span class="badge text-normal" ng-if="loggedInUser.isVisitorManagementReceptionist">Receptionist</span> <span class="badge text-normal" ng-if="loggedInUser.employeeRoles.includes(\'PROJECT_MANAGER\')">Project Manager</span> <span class="badge text-normal" ng-if="!loggedInUser.isCompanyAdmin && !loggedInUser.isAdmin && !loggedInUser.isLineManager && !loggedInUser.isHrManager && !loggedInUser.isGroupAdmin && !loggedInUser.isParkingOperationsManager && !loggedInUser.isPayrollApprover && !loggedInUser.isPayrollManager && !loggedInUser.isSiteManagementAdmin && !loggedInUser.isSiteManagementManager && !loggedInUser.isVisitorManagementAdmin && !loggedInUser.isVisitorManagementReceptionist">Employee</span></div></div><div class="al-user-profile mt-5" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="al-user-profile-name"><img ng-src="../assets/img/theme/no-photo.png" ng-if="loggedInUser.employeePictureUrl == null || loggedInUser.employeePictureUrl == \'\'"> <img ng-src="{{loggedInUser.employeePictureUrl}}" ng-if="loggedInUser.employeePictureUrl != null && loggedInUser.employeePictureUrl!=\'\'"></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li ng-if="!loggedInUser.isGroupAdmin"><a class="hideMedia" ui-sref="profile({employeeId: {{loggedInUser.id}}})" ui-sref-opts="{reload: true}"><i class="fa fa-user"></i>Profile</a></li><li class="cursor-pointer"><a ng-click="logout()" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/searchEmployee/searchEmployee.html','<ul class="search-employee-center clearfix"><li uib-dropdown=""><div class="search" uib-dropdown-toggle=""><i class="ion-ios-search-strong"></i> <input id="searchInput" type="text" placeholder="Search Employees ..." ng-change="vm.search()" ng-model="vm.searchText" ng-model-options="{debounce:500}" autocomplete="off" ng-focus="vm.focus = true" ng-blur="vm.focus = false"></div><div uib-dropdown-menu="" class="search-top-dropdown-menu"><div class="search-msg-list"><a href="" class="clearfix" ng-repeat="emp in vm.employees track by $index" ng-click="vm.goToProfile(emp.id)"><div class="img-area"><img ng-src="../assets/img/theme/no-photo.png" ng-if="!emp.url"> <img ng-src="{{emp.url}}" ng-if="emp.url"></div><div class="msg-area" ng-click="vm.goToProfile(emp.id)"><div><strong>{{emp.name}}</strong></div></div></a></div><a ng-if="vm.fetching" href="">Searching ...</a> <a ui-sref="employees.manageEmployees">See all Employees</a></div></li></ul>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/pages/auth/login/payrollActivationNotifierModal/payrollActivationNotifierModal.html','<div class="modal-content"><div class="modal-header text-left"></div><div class="modal-body"><div class="text-center"><h2><strong>Payroll is activated for this account.</strong></h2><p>&emsp;&emsp;Please go to payroll settings to set up your profile now.</p><br><br><button class="btn btn-primary text-capitalize" ng-click="vm.goToPayrollSettingsPage()">Go to payroll settings</button><br><br><u><a href="#" ng-click="$dismiss()"><span class="color-666666">Close</span></a></u></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/allLogs/allLogs.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="All Logs Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" selected-page="vm.selectedPage" config="vm.filterConfig"></report-filter></div></div><div ng-if="vm.isDataLoaded && vm.data.reportResponseList.length > 0" class="horizontal-scroll report-container mt-20" style="width: 100%; margin-top: 20px;" fixed-column-table=""><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">commonKeywords.dateAndTime</th><th class="text-center" translate="">device</th><th class="text-center" translate="">location</th><th class="text-center" translate="">employeeId</th><th class="text-left" translate="">employeeName</th><th class="text-center" translate="">punchType</th></tr><tbody><tr ng-repeat="employee in vm.data.reportResponseList"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.singleInOutResponse.time | date :\'d MMM yyyy h:mm a\'}}</td><td class="text-center">{{employee.singleInOutResponse.deviceIdentifier}}</td><td class="text-center">{{employee.location}}</td><td class="text-center">{{employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePicUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{employee.singleInOutResponse.inOutText}}</td></tr></tbody></thead></table></div><div class="mt-100"><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/dailyReport/dailyReport.html','<div ba-panel="" ba-panel-title="{{\'dailyReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" excel-url-all-pages="vm.excelUrlAllPages" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="daily" config="vm.filterConfig" checked-attendance-status="vm.checkedAttendanceStatus"></report-filter></div></div><daily-table ng-if="vm.isDataLoaded" all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" show-image="false" start-of-day-list="vm.startOfDayList" daily-summary="vm.dailySummary" show-line-manager="vm.showLineManager"></daily-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/attendanceReport/dailyLateReport/dailyLateReport.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table tbody tr td {\n        white-space: normal !important;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n    .table > thead > tr > th:last-child {\n        padding-right: 5px !important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'daily late Report of \' + vm.date|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="daily" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><div ng-if="vm.allDailyLateData== null || vm.allDailyLateData.lateResponseForAllEmployees== null || vm.allDailyLateData.lateResponseForAllEmployees.length<=0"><p class="text-center mt-60"><strong translate="">{{\'noAttendanceFound\'}}</strong></p></div><table class="table report-table report-table-font-14" ng-if="vm.allDailyLateData!== null && vm.allDailyLateData.lateResponseForAllEmployees !== null && vm.allDailyLateData.lateResponseForAllEmployees.length>0"><thead><tr><th class="text-center width-4" translate="">sl</th><th class="text-center width-6" translate="">id</th><th class="text-left width-16"><span translate="">name</span></th><th class="text-center" translate="" ng-if="vm.subsidiaryView">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" translate="">entry</th><th class="text-left width-8" translate="">lateBy</th><th class="text-center width-8"><span translate="">applicationStatus</span></th><th class="text-center"><span translate="">exit</span><br><span translate="">today</span></th><th class="text-center width-8"><span translate="">workingHours</span></th><th class="text-center width-8"><span translate="">totalLate</span><br><span translate="">thisMonth</span></th><th class="text-center width-8"><span translate="">totalLate</span><br><span translate="">InHours</span></th><th class="text-left width-16" translate="">lineManager</th></tr><tbody><tr ng-repeat="employee in vm.allDailyLateData.lateResponseForAllEmployees track by employee.employeeId"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="!employee.subsidiaryName ? \'color-999999\':\'text-center\'" ng-if="vm.subsidiaryView">{{employee.subsidiaryName ? employee.subsidiaryName : "Not Set" }}</td><td class="text-center">{{employee.entryTime}}</td><td class="text-left">{{employee.lateByInHour}}</td><td class="text-center"><span ng-class="{\'modified-orange\':employee.lateApprovalStatus==0,\'text-green\':employee.lateApprovalStatus==1,\'red-text\':employee.lateApprovalStatus==2,\'modified-red\':employee.lateApprovalStatus==3}">{{employee.lateApprovalStatusString}}</span></td><td class="text-center">{{employee.exitTime? employee.exitTime:\'-\'}}</td><td class="text-center">{{employee.hourSpent}}</td><td class="text-center">{{employee.totalLateThisMonth}}</td><td class="text-center">{{employee.totalLateTimeThisMonth}}</td><td class="text-left"><span ng-if="employee.lineManager.name == \'Not Set\'" ng-class="employee.lineManager.name ==\'Not Set\'?\'color-999999\':\'text-left\'">{{employee.lineManager.name}}</span><employee-picture-and-information ng-if="employee.lineManager.name != \'Not Set\'" name="employee.lineManager.name" picture-url="employee.lineManager.profilePicUrl" department-name="employee.lineManager.departmentName" designation-name="employee.lineManager. designationName" id="employee.lineManager.id"></employee-picture-and-information></td></tr></tbody></thead></table></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/departmentReport/departmentReport.html','<style>\n    td {\n        font-size:12px;\n        padding: 0;\n        vertical-align: middle!important;\n        text-align: center!important;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'departmentReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" excel-url="vm.excelUrl" config="vm.filterConfig"></report-filter></div></div><detailed-table ng-if="vm.isDataLoaded" all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" start-of-day-list="vm.startOfDayList" show-image="false" show-line-manager="vm.showLineManager"></detailed-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/attendanceReport/detailedMonthlyReport/detailedMonthlyReport.html','<div ba-panel="" ba-panel-title="{{\'detailedMonthlyReport\'|translate}} of {{vm.monthYear}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div class="mb-20"><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" type="monthly" excel-url="vm.excelUrl" excel-url-all-pages="vm.excelUrlAllPages" pdf-url="vm.pdfUrl" vertical-pdf-url="vm.verticalPdfUrl" timesheet-approval-status-html="vm.timesheetApprovalStatusHtml" timesheet-application-id="vm.timesheetApplicationId" show-timesheet-approval-button="vm.showTimesheetApprovalButton" config="vm.filterConfig"></report-filter></div><div><div><monthly-table all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" offset="vm.offset" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-year="vm.selectedYear" selected-month="vm.selectedMonth" timesheet-approval="vm.timesheetApproval" find-timesheet-approval="vm.findTimesheetApproval" selected-page="vm.selectedPage" time="vm.fromTime" type="monthly" start-of-day-list="vm.startOfDayList" overall-summary="vm.overallSummary" detailed-view="true" show-line-manager="vm.showLineManager"></monthly-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/detailed/attendance-page-root.html','<div include-with-scope="app/pages/main/attendanceReport/detailed/templates/attendance-report-desktop.html"></div>');
$templateCache.put('app/pages/main/attendanceReport/individualAttendanceReport/individualAttendanceReport.html','<style>\n    .search-width .has-search {\n        min-width: 250px;\n    }\n    .width-126 {\n        width: 126px;\n    }\n    .min-width-100 {\n        min-width: 100px;\n    }\n    .min-width-60 {\n        min-width: 60px;\n    }\n    .input-group {\n        margin-bottom: 0px;\n    }\n</style><div ba-panel="" ba-panel-title="Individual Attendance Report of {{vm.individualSummary.name}}, {{vm.reportTime}}" ba-panel-class="with-scroll"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-10 align-items-center"><div><employee-picture-and-information name="vm.individualSummary.name" picture-url="vm.individualSummary.profilePicUrl" department-name="vm.individualSummary.department" designation-name="!vm.individualSummary.designation ? \'N/A\':vm.individualSummary.designation" id="vm.searchParams.employeeId" is-clickable="true"></employee-picture-and-information><span class="d-inline-block font-12 ml-47 color-22222 font-weight-500 width-126">{{vm.overtimeStatus}}</span></div><div class="mt-15 placeholder-text-13 search-width"><employee-type-ahead-search select-method="vm.searchByEmployeeId" keyword="vm.searchKeyword" show-label="false" is-required="false"></employee-type-ahead-search></div><div class="filter-inline-item table-cell-gap"><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPicker.format}}" datepicker-options="vm.monthPicker.options" ng-model="vm.selectedMonth" is-open="vm.monthPicker.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></div><div class="d-flex-space-between"><label class="min-width-100 font-weight-600 pl-5" for="rowsPerPageSelection" translate="">rowsPerPage</label><div class="custom-select"><select id="rowsPerPageSelection" class="min-width-60" ng-model="vm.rowsPerPage" ng-change="vm.search()"><option value="10" ng-selected="vm.rowsPerPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.rowsPerPage==20" translate="">{{\'commonKeywords.twenty\'}}</option><option value="31" ng-selected="vm.rowsPerPage==31" translate="">{{\'commonKeywords.thirty_one\'}}</option></select></div></div></div><div class="d-flex-gap-10 margin-at-page-break"><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsPdf()"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="color-22222 font-weight-400"><td>Working Day</td><td class="col-stripe-dark text-center">{{vm.individualSummary.workingDays}}</td><td>Weekend/Day Off</td><td class="col-stripe-dark text-center">{{vm.individualSummary.offDay}}</td><td translate="">leave</td><td class="col-stripe-dark text-center">{{vm.individualSummary.leave}}</td><td translate="">late</td><td class="col-stripe-dark text-center">{{vm.individualSummary.lateEntry}}</td><td>Field Visit/Tours</td><td class="col-stripe-dark text-center">{{vm.individualSummary.fieldVisit}}</td><td>Actual Hours</td><td class="col-stripe-dark text-center">{{vm.individualSummary.actualHours}}</td></tr><tr class="color-22222 font-weight-400"><td>Present</td><td class="col-stripe-dark text-center">{{vm.individualSummary.present}}</td><td>Govt. Holiday</td><td class="col-stripe-dark text-center">{{vm.individualSummary.holidays}}</td><td>Special Days</td><td class="col-stripe-dark text-center">{{vm.individualSummary.specialDays}}</td><td>Absent</td><td class="col-stripe-dark text-center">{{vm.individualSummary.absent}}</td><td>Early Exit</td><td class="col-stripe-dark text-center">{{vm.individualSummary.earlyExit}}</td><td>Expected Hours</td><td class="col-stripe-dark text-center">{{vm.individualSummary.expectedHours}}</td><td>Average Hours</td><td class="col-stripe-dark text-center">{{vm.individualSummary.averageHours }}</td></tr></tbody></table></div></div><div ng-if="vm.isDataLoaded" class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table"><thead><tr><th class="text-center" rowspan="2" translate="">Date</th><th class="text-center" rowspan="2" translate="">Shift</th><th class="text-left" rowspan="2" translate="">Status</th><th class="text-center" rowspan="2" translate="">Entry</th><th class="text-center" rowspan="2" translate="">Exit</th><th class="text-center" rowspan="2" translate="">Late</th><th class="text-center" rowspan="2" translate="">Early Exit</th><th class="text-center" rowspan="2" translate="">Working Hours</th><th class="text-center" rowspan="2" translate="">OT Hours</th></tr><tbody><tr ng-repeat="date in vm.allAttendanceData"><td class="text-center">{{date.date }}</td><td class="text-center">{{date.shiftName == null ? "Not Set" : date.shiftName}}<br>{{date.shiftTiming}}</td><td class="text-left" ng-class="date.statusText === \'--\' ? \'blackText text-left\' : (date.statusText === \'Leave Approval Pending\' ? \'orange-text\' : (date.statusText === \'Absent\' || date.statusText.includes(\'Late\') || date.statusText === \'Early Exit\' ? \'redText text-left-important\' : (date.statusText === \'Present\' ? \'text-left-important\' : \'greenText text-left-important\')))">{{date.shiftStarted ? \'--\' : (date.statusText === \'On Leave\' ? date.statusText + \' (\' + date.leaveCatagory + \')\' : date.statusText)}}</td><td class="text-center">{{date.entryTime}}</td><td class="text-center">{{date.exitTime}}</td><td class="text-center">{{date.late}}</td><td class="text-center">{{date.earlyExit}}</td><td class="text-center">{{date.workingHours}}</td><td class="text-center">{{date.overtimeHours}}</td></tr></tbody></thead></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/attendanceReport/fieldVisitReport/fieldVisitReport.html','<style>\n    td {\n        font-size:12px;\n        padding: 0;\n        vertical-align: middle!important;\n        /*text-align: center!important;*/\n        overflow: hidden;\n        /*white-space: nowrap;*/\n    }\n    .btn-group.special{\n        min-height: 40px!important;\n    }\n    .row-height{\n        height: 38px;\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table tbody tr td {\n        white-space: normal !important;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'fieldVisitReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" excel-url="vm.excelUrl" hide-print="true" hide-sort-by="true" hide-download="true" config="vm.filterConfig"></report-filter></div></div><div class="row mt-10"><div class="col-md-12"><div class="btn-group special" role="group" aria-label="First group"><button type="button" ng-class="{\'selected-table-toggle-button\': vm.searchParams.applicationStatus.toString() == [0,1,2,3].toString()}" ng-click="vm.changeApplicationStatus([0,1,2,3])" class="btn btn-primary border-radius-0">{{\'fieldVisit.buttons.allFieldVisits\' | translate}}</button> <button type="button" ng-class="vm.searchParams.applicationStatus.toString() == [0].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.changeApplicationStatus([0])" class="btn btn-primary">{{\'fieldVisit.buttons.pendingFieldVisits\' | translate}}</button> <button type="button" ng-class="vm.searchParams.applicationStatus.toString() == [1].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.changeApplicationStatus([1])" class="btn btn-primary border-radius-0">{{\'fieldVisit.buttons.acceptedFieldVisits\' | translate}}</button></div></div></div><div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><table class="table report-table" ng-if="vm.fieldVisitData.length > 0 && vm.isDataLoaded"><colgroup><col class="width-5"><col class="width-10"><col class="width-13"><col class="width-8"><col class="width-8"><col class="width-15"><col class="width-15"><col class="width-7"><col class="width-19"></colgroup><thead class="row-height"><tr><th class="text-left width-22" translate="">{{\'fieldVisit.employeesTableHeader.employeeName\'}}</th><th class="text-left" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center width-7" translate="">{{\'fieldVisit.employeesTableHeader.dateRange\'}}</th><th class="text-left width-19" translate="">{{\'fieldVisit.applicationInfoTable.reason\'}}</th><th class="text-center" translate="">{{\'fieldVisit.applicationInfoTable.entry\'}}</th><th class="text-center" translate="">{{\'fieldVisit.applicationInfoTable.exit\'}}</th><th class="text-center" translate="">{{\'fieldVisit.applicationInfoTable.lineManagerStatus\'}}</th><th class="text-center" translate="">{{\'fieldVisit.applicationInfoTable.hrManagerStatus\'}}</th><th class="text-center" translate="">{{\'fieldVisit.employeesTableHeader.status\'}}</th><th class="text-left width-9" translate="">{{\'fieldVisit.applicationInfoTable.appliedBy\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.fieldVisitData"><td><employee-picture-and-information name="data.employeeName" picture-url="data.employeePictureUrl" department-name="data.departmentName" designation-name="!data.designationName ? \'N/A\':data.designationName" id="data.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isNotSubsidiaryAdmin">{{data.subsidiaryName}}</td><td class="text-center">{{data.startDate |date:\'dd-MM-yyyy\'}}<span ng-if="data.endDate !== data.startDate"><br><span translate="">{{\'pendingApplicationApprovals.to\'}}</span><br>{{data.endDate | date :\'dd-MM-yyyy\'}}</span></td><td class="text-left">{{data.reason}}</td><td class="text-center">{{data.entryTime | date:\'hh:mm a\'}}</td><td class="text-center">{{data.exitTime | date:\'hh:mm a\'}}</td><td class="text-center"><span>{{data.firstManualApproverName}}</span><br><span ng-if="!data.forceApproval" ng-bind-html="data.firstApproverApprovalDisplayString"></span> <span ng-if="data.forceApproval" class="blueviolet-text">{{\'fieldVisit.approvedByAdmin\' | translate}}</span></td><td class="text-center"><span>{{data.secondManualApproverName}}</span><br><span ng-if="!data.forceApproval" ng-bind-html="data.secondApproverApprovalDisplayString"></span> <span ng-if="data.forceApproval" class="blueviolet-text">{{\'fieldVisit.approvedByAdmin\' | translate}}</span></td><td ng-if="data.status==0" class="text-center modified-orange">{{ \'pending\' | translate}}</td><td ng-if="data.status==1" class="text-center green-text">{{ \'accepted\' | translate}}</td><td ng-if="data.status==2" class="text-center red-text">{{ \'rejected\' | translate}}</td><td ng-if="data.status==3" class="text-center red-text">{{ \'cancelled\' | translate}}</td><td class="text-left">{{data.requestorName}}</td></tr></tbody></table></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/attendanceReport/lateReport/lateReport.html','<style>\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'lateReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><report-filter search-method="vm.search" hide-download="true" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" show-filters="vm.showFilters" config="vm.filterConfig"></report-filter></div><leave-late-absent-table all-attendance-data="vm.allAttendanceData" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.numberOfRows" offset="vm.offset" type="lates"></leave-late-absent-table></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/leaveReport/leaveReport.html','<style>\n    .leave-table .border-bottom {\n        border-bottom: none!important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'leaveReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><report-filter search-method="vm.search" hide-download="true" show-filters="vm.showFilters" excel-url="vm.excelUrl" config="vm.filterConfig"></report-filter></div><div class="leave-table"><leave-late-absent-table all-attendance-data="vm.allAttendanceData" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.numberOfRows" offset="vm.offset" type="leaves"></leave-late-absent-table></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/locationTrackingReport/locationTrackingReport.html','<style>\n    .form-group {\n        margin-bottom: 10px !important;\n    }\n\n    .list-active>a {\n        background-color: #4A9B91;\n        color: white !important;\n    }\n\n    .list-active>a:hover {\n        background-color: #4A9B91;\n        color: #000 !important;\n    }\n\n    .fixed-height-row-table {\n        /*height: ;*/\n    }\n\n    .table-bordered thead tr th {\n        background: var(--color-secondary) !important;\n        color: white !important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Location Tracking Report \' + vm.date|translate}}<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="false" excel-url="vm.excelUrl" selected-page="vm.selectedPage" config="vm.filterConfig" type="daily"></report-filter><div class="report-container width-100 mt-5" fixed-column-table="" fixed-columns="3" ng-if="vm.isDataLoaded"><table class="table report-table"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-left" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-left" rowspan="2" translate="">Start Time</th><th class="text-center" rowspan="2" translate="">End Time</th><th class="text-center" rowspan="2" translate="">Total Hours</th><th class="text-center" rowspan="2" translate="">Location Data</th></tr><tbody><tr ng-repeat="employee in vm.locationTrackReport.employeeLocationTrackingResponseMap"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="::employee.employeeName" picture-url="::employee.pictureUrl" department-name="::employee.departmentName" designation-name="::employee.designationName" id="::employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isNotSubsidiaryAdmin">{{data.subsidiaryName}}</td><td class="text-left">{{employee.startTime | date:\'shortTime\'}}</td><td class="text-center">{{ employee.endTime ? (employee.endTime | date:\'shortTime\') : \'--\' }}</td><td class="text-center">{{employee.totalWorkingTime}}</td><td class="text-center"><a href="#" ng-click="vm.showMap(employee.employeeLocationDetailsResponse, employee.employeeName, employee.employeeId,employee.officeId, employee.startTime, employee.endTime, employee.totalWorkingTime, vm.date, vm.dateInMilliSecond, vm.numberOfPages, vm.selectedPage)">View</a></td></tr></tbody></thead></table></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/mobilePunchReport/mobilePunchReport.html','<style>\n    .form-group{\n        margin-bottom: 10px!important;\n    }\n    .list-active > a {\n        background-color: #4A9B91;\n        color:white!important;\n    }\n    .list-active>a:hover {\n        background-color: #4A9B91;\n        color: #000!important;\n    }\n    .fixed-height-row-table{\n        /*height: ;*/\n    }\n    .table-bordered thead tr th{\n        background: var(--color-secondary)!important;\n        color: white!important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Mobile Punch Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" selected-page="vm.selectedPage" config="vm.filterConfig"></report-filter><div class="row mt-20" ng-show="vm.isDataLoaded"><div id="mobilePunchReport" class="col-md-12 col-sm-12 col-xs-12"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/monthlyReport/monthlyReport.html','<div ba-panel="" ba-panel-title="{{\'monthlyReport\'|translate}} of {{vm.monthYear}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div class="mb-20"><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" timesheet-approval-status-html="vm.timesheetApprovalStatusHtml" timesheet-application-id="vm.timesheetApplicationId" show-timesheet-approval-button="vm.showTimesheetApprovalButton" config="vm.filterConfig"></report-filter></div><div><div><monthly-table all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" offset="vm.offset" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-year="vm.selectedYear" selected-month="vm.selectedMonth" timesheet-approval="vm.timesheetApproval" find-timesheet-approval="vm.findTimesheetApproval" selected-page="vm.selectedPage" time="vm.fromTime" type="monthly" start-of-day-list="vm.startOfDayList" overall-summary="vm.overallSummary" show-line-manager="vm.showLineManager" ai-analysis="vm.aiAnalysis" ai-analysis-loading="vm.aiAnalysisLoading"></monthly-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/pandemicReport/pandemicReport.html','<style>\n    .list-avatar{\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        float: left;\n        margin-top: 2px;\n    }\n    #pandemicReportTable{\n        white-space: nowrap !important;\n    }\n    #pandemicReportTable .headers2 td a{\n        color:white!important;\n    }\n    /*.odd-row{*/\n    /*    background-color: #f9f9f9!important;*/\n    /*}*/\n    /*.even-row{*/\n    /*    background-color: white!important;*/\n    /*}*/\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Pandemic Report<span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" hide-download="true" is-data-loaded="vm.isDataLoaded" type="daily" config="vm.filterConfig"></report-filter></div></div><h3 class="not-print text-center"><span ng-if="type ==\'monthly\'"><span translate="">monthlyAttendanceReport</span> ({{time | date: "MMMM" }}, {{ time | date: "yyyy" }})</span></h3><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br><br><br><br></div></div></div><div ng-if="vm.isDataLoaded"><div ng-if="vm.allAttendanceData.length <= 0 || vm.allAttendanceData == null"><p class="text-center mt-60"><strong translate="">{{\'noDataFound\'}}</strong></p></div><div ng-if="vm.isDataLoaded && vm.allAttendanceData.length > 0"><div class="horizontal-scroll report-container width-100" fixed-column-table="" fixed-columns="0"><table id="pandemicReportTable" class="table borderless-table even-child-selector"><thead><tr><th class="text-center"><a href="" ng-click="vm.sortingMethods.sortById()" translate="">sl</a></th><th class="text-center" translate="">id</th><th><a href="" ng-click="vm.sortingMethods.sortByName()" translate="">name</a></th><th class="text-center"><a href="" translate="">employmentType</a></th><th class="text-center"><a href="" ng-click="vm.sortingMethods.sortByShiftGroupName()" translate="">shiftGroup</a></th><th class="text-center" translate="">time</th><th class="text-center" translate="">mask</th><th class="text-center" translate="">temperature</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.allAttendanceData.length > 0" ng-repeat="response in vm.allAttendanceData"><tr><td class="text-center" rowspan="{{response.value.length == 0 ? \'1\' : response.value.length}}"><a ui-sref="profile({employeeId: {{response.key.employeeId}}})">{{$index+1}}</a></td><td class="text-center" rowspan="{{response.value.length == 0 ? \'1\' : response.value.length}}">{{response.key.employeeOfficeId}}</td><td rowspan="{{response.value.length == 0 ? \'1\' : response.value.length}}"><employee-picture-and-information name="response.key.employeeName" picture-url="response.key.pictureUrl" department-name="response.key.departmentName" designation-name="!response.key.designationName ? \'N/A\':response.key.designationName" id="response.key.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="response.key.employmentTypeName === null?\'color-999999\':\'text-center\'" rowspan="{{response.value.length == 0 ? \'1\' : response.value.length}}">{{response.key.employmentTypeName?response.key.employmentTypeName:\'Not Set\'}}</td><td class="text-center" rowspan="{{response.value.length == 0 ? \'1\' : response.value.length}}">{{response.key.shiftGroupName}}</td><td class="text-center color-999999" ng-if="response.value.length == 0" translate="">noData</td><td class="text-center color-999999" ng-if="response.value.length == 0" translate="">noData</td><td class="text-center color-999999" ng-if="response.value.length == 0" translate="">noData</td><td class="text-center" title="{{vm.childRowIndexChange(response.value.length,$index, 1)}}" ng-if="response.value.length > 0">{{response.value[0].attendanceTime | date : \'hh:mm a\'}}</td><td class="text-center" ng-if="response.value.length > 0"><span>{{response.value[0].hasMask == null ? \'No Data\' : response.value[0].hasMask == true ? \'Yes\' : \'No\'}}</span></td><td class="text-center" ng-if="response.value.length > 0"><span ng-class="response.value[0].temperature!= null && response.value[0].temperature > 37.5 ? \'redText\' : \'\'">{{response.value[0].temperature == null ? \'No Data\' : response.value[0].temperature}}</span></td></tr><tr ng-repeat="value in response.value" ng-if="response.value.length > 0 && $index > 0"><td class="text-center" title="{{response.value.length+\'-\'+$index+\'--\'+vm.parentRowIndex+\'---\'+vm.childRowIndex}}">{{value.attendanceTime | date : \'hh:mm:a \'}}</td><td class="text-center"><span>{{value.hasMask == null ? \'No Data\' : value.hasMask == true ? \'Yes\' : \'No\'}}</span></td><td class="text-center"><span ng-class="value.temperature!= null && value.temperature > 37.5 ? \'redText\' : \'\'">{{value.temperature == null ? \'No Data\' : value.temperature}}</span></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/serverRoomOccupancyReport/serverRoomOccupancyReport.html','<style>\n    .form-group{\n        margin-bottom: 10px!important;\n    }\n    .list-active > a {\n        background-color: #4A9B91;\n        color:white!important;\n    }\n    .list-active>a:hover {\n        background-color: #4A9B91;\n        color: #000!important;\n    }\n    .fixed-height-row-table{\n        /*height: ;*/\n    }\n    .table-bordered thead tr th{\n        background: var(--color-secondary)!important;\n        color: white!important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Occupancy Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" selected-page="vm.selectedPage" subtract="vm.subtract" type="daily" config="vm.filterConfig"></report-filter><div class="row mt-20" ng-if="vm.reportTable != null && vm.isDataLoaded && vm.total > 0"><div ng-bind-html="vm.reportTable" class="col-md-12 col-sm-12 col-xs-12"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/shiftReport/shiftReport.html','<style>\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'shiftReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" excel-url="vm.excelUrl"></report-filter></div></div><detailed-table ng-if="vm.isDataLoaded" all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" start-of-day-list="vm.startOfDayList" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" show-image="false" show-line-manager="vm.showLineManager"></detailed-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/attendanceReport/siteAttendanceReport/siteAttendanceReport.html','<style>\n    .site-attendance-report input::placeholder{\n        font-size: 13px;\n    }\n    .site-attendance-report #employeeNameSearchBox {\n        width: 290px!important;\n    }\n    .site-attendance-report #presentAbsent .custom-select{\n        width: 100%!important;\n    }\n\n</style><div class="row site-attendance-report"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'site report of \' + vm.date|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" subtract="vm.subtract" type="daily" hide-download="true" config="vm.filterConfig"></report-filter></div><div><div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">totalEmployees</td><td class="col-stripe-dark text-center">{{vm.total}}</td><td translate="">totalAbsent</td><td class="col-stripe-dark text-center">{{vm.totalAbsent}}</td><td translate="">totalPresent</td><td class="col-stripe-dark text-center">{{vm.totalPresent}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-center" rowspan="2" translate="">employeeType</th><th class="text-center" rowspan="2" translate="">shift</th><th class="text-left" rowspan="2" translate="">siteName</th><th class="text-center" rowspan="2" translate="">entry</th><th class="text-center" rowspan="2" translate="">exit</th><th class="text-left" rowspan="2" translate="">siteManager</th></tr><tbody><tr ng-repeat="employee in vm.employeeList" ng-show="vm.isDataLoaded"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.employeeDepartmentName" designation-name="employee.employeeDesignationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{employee.employmentTypeName}}</td><td class="text-center">{{employee.shiftName}}</td><td class="text-left"><img class="cursor-pointer" ng-click="vm.openLocationMap($index, employee)" src="../assets/img/location.png"> <span>{{employee.siteName}}</span></td><td class="text-center"><img class="cursor-pointer" ng-if="employee.entryTime" ng-click="vm.openEntryExitImage($index, employee,\'entry\')" src="../assets/img/image.png"> <span>{{employee.entryTime}}</span></td><td class="text-center"><img class="cursor-pointer" ng-if="employee.exitTime" ng-click="vm.openEntryExitImage($index, employee,\'exit\')" src="../assets/img/image.png"> <span>{{employee.exitTime}}</span></td><td class="text-left"><span ng-if="employee.manager.name == \'Not Set\'">{{employee.manager.name}}</span><employee-picture-and-information name="employee.manager.name" picture-url="employee.manager.pictureUrl" department-name="employee.manager.departmentName" designation-name="employee.manager.designationName" id="employee.manager.id" is-clickable="true"></employee-picture-and-information></td></tr></tbody></thead></table></div></div></div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-show="vm.employeeList.length === 0 && vm.isDataLoaded"><p class="text-center font-15"><em translate="">noDataFound</em></p></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" hide-no-data-message="true"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/siteSummaryReport/siteSummaryReport.html','<style>\n    .search-width{\n        width: 250px!important;\n    }\n    .min-width-170{\n        min-width: 170px;\n    }\n    .min-width-100{\n        min-width: 100px;\n    }\n    .width-140{\n        width: 140px;\n    }\n    #employeeNameSearchBox2 input::placeholder{\n        font-size: 13px;\n    }\n    .site-summary-report .table > thead > tr > th:last-child, .site-summary-report .table > tbody > tr > td:last-child {\n        padding-right: 5px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'All Site Report of \' + vm.date|translate}}"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-10 align-items-center"><div class="d-inline-block" id="employeeNameSearchBox2"><div class="has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control search-width" type="text" placeholder="Search Site by Name/Address" ng-model="vm.searchKeyword" ng-keyup="$event.keyCode === 13 && vm.getSiteByNameOrAddress()"></div></div><div class="filter-inline-item width-18 min-width-170"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-pointer d-block" ng-model="vm.singleDatePicker.date" options="vm.singleDatePicker.options" min="vm.minDate" max="vm.maxDateForDailyReport"><span class="date-position-left">{{vm.singleDatePicker.date.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="d-flex-space-between"><label class="min-width-100 font-weight-600" for="rowsPerPageSelection" translate="">rowsPerPage</label><div class="custom-select width-140"><select ng-model="vm.selectedRowsPerPage" ng-change="vm.handleRowPerPageSelection()" id="rowsPerPageSelection" ng-options="d.value for d in vm.rowsPerPageOption"><option ng-show="vm.stateName === \'attendanceReport.allLogs\'" value="50000" ng-selected="vm.rowsPerPage==50000" translate="">{{\'commonKeywords.fiftyThousand\'}}</option><option ng-show="vm.stateName === \'attendanceReport.allLogs\'" value="500000" ng-selected="vm.rowsPerPage==500000" translate="">{{\'commonKeywords.fiveHundredThousand\'}}</option></select></div></div></div><div class="d-flex-gap-10 margin-at-page-break"><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsPdf()"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">totalSites</td><td class="text-center col-stripe-dark">{{vm.allSitesSummaryReportData.totalSite}}</td><td translate="">present</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalPresent}}</td><td translate="">leave</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalLeave}}</td><td translate="">late</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalLate}}</td></tr><tr class="text-bold"><td translate="">totalEmployee</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalEmployee}}</td><td translate="">absent</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalAbsent}}</td><td translate="">onTime</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalOnTime}}</td><td translate="">earlyExit</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalEarlyExit}}</td></tr></tbody></table></div></div><div class="mt-15 site-summary-report"><table class="table borderless-table even-row-strip"><thead><tr><th class="text-center" translate="">sl</th><th class="text-left width-15" translate="">siteName</th><th class="text-left width-17" translate="">address</th><th class="text-center" translate="">totalEmployee</th><th class="text-center" translate="">present</th><th class="text-center" translate="">absent</th><th class="text-center" translate="">leave</th><th class="text-center" translate="">onTime</th><th class="text-center" translate="">late</th><th class="text-center" translate="">earlyExit</th><th class="text-left width-20" translate="">siteManager</th></tr><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="site in vm.siteSummaryList"><td class="text-center">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1 }}</td><td class="text-left"><img class="cursor-pointer" ng-click="vm.openLocationMap($index, site)" src="../assets/img/location.png"> <span>{{site.name}}</span></td><td class="text-left">{{site.location}}</td><td class="text-center">{{site.totalEmployee}}</td><td class="text-center">{{site.present}}</td><td class="text-center">{{site.absent}}</td><td class="text-center">{{site.leave}}</td><td class="text-center">{{site.onTime}}</td><td class="text-center">{{site.late}}</td><td class="text-center">{{site.earlyExit}}</td><td class="text-left"><employee-picture-and-information name="site.managerName" picture-url="site.managerPictureUrl" department-name="site.managerDepartmentName" designation-name="site.managerDesignationName" id="site.managerId" is-clickable="false"></employee-picture-and-information></td></tr></tbody></thead></table><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getDailyParkingInfo"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/unrecognisedLogs/unrecognisedLogs.html','<style>\n    .form-group{\n        margin-bottom: 10px!important;\n    }\n    .list-active > a {\n        background-color: #4A9B91;\n        color:white!important;\n    }\n    .list-active>a:hover {\n        background-color: #4A9B91;\n        color: #000!important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Unauthorised Logs Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" selected-page="vm.selectedPage" config="vm.filterConfig"></report-filter></div></div><div class="row mt-10" ng-if="vm.unrecognisedLogs != null && vm.isDataLoaded"><div class="col-md-2"><button ng-if="!vm.fetchUnregisteredOnly" type="button" class="btn btn-md btn-secondary" ng-click="vm.toggleUnregisteredOnlyFilterAndSearch()" translate="">viewOnlyUnknownPeopleLogs</button> <button ng-if="vm.fetchUnregisteredOnly" type="button" class="btn btn-md btn-secondary" ng-click="vm.toggleUnregisteredOnlyFilterAndSearch()" translate="">viewAllUnauthorisedLogs</button></div></div><div class="row mt-20" ng-if="vm.unrecognisedLogs != null && vm.isDataLoaded && vm.total > 0"><div class="col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll report-container" fixed-column-table="" fixed-columns="3"><table ng-show="vm.unrecognisedLogs.length > 0" class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">date</th><th class="text-center" translate="">id</th><th class="text-left" translate="">name</th><th class="text-left" translate="">designation</th><th class="text-left" translate="">department</th><th class="text-center" translate="">rfidCard</th><th class="text-center" translate="">time</th><th class="text-center" translate="">device</th><th class="text-center" translate="">inOut</th></tr></thead><tbody><tr ng-repeat="log in vm.unrecognisedLogs"><td class="text-center">{{log.logTime | date :\'d MMM yyyy\'}}</td><td class="text-center">{{(log.employee != null && log.employee.employeeOfficeId != null) ? log.employee.employeeOfficeId : "N/A"}}</td><td class="text-left">{{(log.employee != null && log.employee.name != null) ? log.employee.name : "Unknown"}}</td><td class="text-left" ng-class="(log.employee != null && log.employee.designationName != null) ? \'text-left\':\'color-999999\'">{{(log.employee != null && log.employee.designationName != null) ? log.employee.designationName : "N/A"}}</td><td class="text-left" ng-class="(log.employee != null && log.employee.departmentName != null) ? \'text-left\':\'color-999999\'">{{(log.employee != null && log.employee.departmentName != null) ? log.employee.departmentName : "N/A"}}</td><td class="text-center">{{(log.employee != null && log.employee.rfid != null && log.employee.rfid !== "") ? log.employee.rfid : log.usedRfid}}</td><td class="text-center">{{log.logTime | date :\'hh:mm a\'}}</td><td class="text-center">{{log.deviceIdentifier}}</td><td class="text-center">{{log.entryType}}</td></tr></tbody></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/weeklyReport/weeklyReport.html','<style>\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n    .thead-color {\n        color: #209e91;\n    }\n    .only-print {\n        display: none;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'weeklyReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div style="margin-bottom: 20px"><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" type="weekly" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl"></report-filter></div><div><div><monthly-table all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" is-data-loaded="vm.isDataLoaded" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" time="vm.fromTime" type="weekly" start-of-day-list="vm.startOfDayList"></monthly-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/directives/monthlyAttendanceTable/monthlyTimeSheetModals/approve.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Timesheet Confirmation</h4></div><div class="modal-body"><p>Are you sure you want to approve this time sheet?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.approve()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/directives/monthlyAttendanceTable/monthlyTimeSheetModals/reject.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Reject Timesheet Confirmation</span></div><div class="modal-body"><p>Are you sure you want to reject this application?</p><br></div><br><br><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.reject()">Submit</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">Cancel</button></div></div>');
$templateCache.put('app/pages/main/companies/companyDetails/companyDetails.html','<div ba-panel="" ba-panel-title="Offices" ba-panel-class="with-scroll"><table class="table table-striped"><thead><tr><th class="table-id" translate="">{{\'companies.companyDetailsTableHeader.hash\'}}</th><th translate="">{{\'companies.name\'}}</th><th translate="">{{\'companies.companyDetailsTableHeader.location\'}}</th><th translate="">{{\'companies.officeType\'}}</th><th translate="">{{\'companies.companyDetailsTableHeader.description\'}}</th><th translate="">{{\'companies.companyDetailsTableHeader.actions\'}}</th></tr></thead><tbody><tr ng-repeat="office in vm.data.offices"><td class="table-id">{{$index+1}}</td><td>{{office.name}}</td><td>{{office.location}}</td><td ng-if="office.officeType == \'1\'" translate="">{{\'companies.officeTypeName.corporate\'}}</td><td ng-if="office.officeType == \'2\'" translate="">{{\'companies.officeTypeName.factory\'}}</td><td ng-if="!office.officeType" translate="">{{\'companies.officeTypeName.noTypeDefined\'}}</td><td ng-if="office.description">{{office.description}}</td><td><a class="actionIcons" ng-click="vm.openOfficeEditModal(office)" tooltips="" tooltip-template="{{\'companies.tooltipText2\' | translate}}"><i class="ion-ios-compose-outline"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/attendanceReport/locationDeviationReport/locationDeviationReport.html','<div class="row" ng-controller="LocationDeviationReportCtrl as vm"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Location Deviation<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" excel-url="vm.excelUrl" excel-url-all-pages="vm.excelUrlAllPages" selected-page="vm.selectedPage" config="vm.filterConfig"></report-filter></div></div><location-deviation-table ng-if="vm.isDataLoaded" all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" start-of-day-list="vm.startOfDayList" show-image="true" show-line-manager="vm.showLineManager"></location-deviation-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/companies/createCompany/createCompany.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">{{\'companies.createCompany\'}}</h4></div><div class="modal-body"><div class="row form-group"><div class="col-md-2"><label for="name" class="mt-10"><strong translate="">{{\'companies.name\'}}</strong></label></div><div class="col-md-8"><input type="text" id="name" class="form-control" placeholder="{{\'companies.placeholderText\' | translate}}" ng-model="vm.name"></div></div></div><br><br><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createCompany(vm.name)" translate="">{{\'companies.saveChangesButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/companies/editCompany/editCompany.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">{{\'companies.editCompany\'}}</h4></div><div class="modal-body"><div class="row form-group"><div class="col-md-2"><label class="mt-10" for="name"><strong translate="">{{\'companies.name\'}}</strong></label></div><div class="col-md-10"><input type="text" id="name" class="form-control" placeholder="{{\'companies.placeholderText\' | translate}}" ng-model="vm.name"></div></div></div><br><br><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateName(vm.name)" translate="">{{\'companies.saveChangesButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/companies/createOffice/createOffice.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel" translate="">{{\'companies.createOfficeModal.createOffice\'}}</h4></div><div class="modal-body"><div class="row m-all-10"><div class="col-sm-6"><div class="form-group"><label for="inputLastName" translate="">{{\'companies.name\'}}</label> <input type="text" class="form-control" id="inputLastName" placeholder="{{\'companies.placeholderText\' | translate}}" ng-model="vm.createModalData.name"></div></div><div class="col-sm-6"><div class="form-group"><label for="officeType" translate="">{{\'companies.officeType\'}}</label><select id="officeType" class="form-control" name="Type" ng-model="vm.createModalData.officeType"><option value="" disabled="" selected="" translate="">{{\'companies.selectYourOption\'}}</option><option value="1" translate="">{{\'companies.officeTypeName.corporate\'}}</option><option value="2" translate="">{{\'companies.officeTypeName.factory\'}}</option></select></div></div></div><br><br><div class="row m-all-10"><div class="col-md-6"><div class="form-group"><label for="location" translate="">{{\'companies.location\'}}</label> <textarea id="location" class="form-control" placeholder="{{\'companies.createOfficeModal.placeholderTextLocation\' | translate}}" ng-model="vm.createModalData.location"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="description">{{\'companies.description\'}}</label> <textarea id="description" class="form-control" placeholder="{{\'companies.createOfficeModal.placeholderTextDescription\' | translate}}" ng-model="vm.createModalData.description"></textarea></div></div></div><br><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createOffice()" translate="">{{\'companies.createOfficeModal.createOfficeButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/companies/editOffice/editOffice.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Office</h4></div><div class="modal-body"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Name</label> <input type="text" class="form-control" ng-model="vm.office.name"></div></div><div class="col-sm-6"><div class="form-group"><label for="officeType">Office Type</label><select id="officeType" class="form-control" name="Type" ng-model="vm.office.officeType" placeholder="editOfficeType"><option value="" disabled="" selected="">Select your option</option><option value="1" ng-selected="vm.office.officeType ==\'1\'">Corporate</option><option value="2" ng-selected="vm.office.officeType ==\'2\'">Factory</option></select></div></div></div><br><br><div class="row"><div class="col-md-6"><div class="form-group"><label for="location">Location</label> <textarea id="location" class="form-control" ng-model="vm.office.location"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="description">Description</label> <textarea id="description" class="form-control" ng-model="vm.office.description"></textarea></div></div></div><br><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateOfficeDetails()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/dashboard/attendanceFeed/attendanceFeed.html','<style>\n    .animate-if.ng-enter {\n        opacity: 0;\n        transition: all .5s ease;\n    }\n    .animate-if.ng-enter-active {\n        opacity: 1;\n    }\n    .panel.semi-large-panel {\n        height: 1339px;\n    }\n    .attendance-feed{\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n    }\n    .text-message{\n        margin-left: 0px!important;\n    }\n    .width-100{\n        width: 100% !important;\n    }\n</style><upgrade-banner code="1004"><div><div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message animate-if border-color-light" ng-repeat="feed in vm.attendanceFeed" ng-if="vm.attendanceFeed.length > 0" ng-click="!(feed.employeeId != \'empty\') || vm.goToProfile(feed.employeeId)"><div class="attendance-feed"><div class="message-icon"><img class="photo-icon" ng-src="{{ ::feed.profilePicURL}}" ng-if="vm.hasPermission(\'1006\')"> <img class="photo-icon" ng-src="{{ vm.defaultPicture}}" ng-if="!vm.hasPermission(\'1006\')"></div><div class="text-block text-message width-100"><div class="message-header"><span class="author">{{ ::feed.name }}</span> <span ng-if="feed.temperature && feed.temperature < 37.6" class="pull-right green-text">{{::feed.temperature}} <span translate="">{{\'dashboardText.degreeCelsius\'}}</span></span> <span ng-if="feed.temperature && feed.temperature >= 37.6" class="pull-right red-text">{{::feed.temperature}} <span translate="">{{\'dashboardText.degreeCelsius\'}}</span></span></div><div class="message-content line-clamp"><span ng-if="vm.hasPermission(\'1005\')">{{::feed.text}}<span class="red-text font-10" ng-if="feed.isLate && !vm.isBangabhabanEmployee">&nbsp;({{feed.lateBy}})</span></span></div><div class="message-content line-clamp mt-2">{{feed.deviceLocation ? feed.deviceLocation : \'\' }} {{feed.deviceIdentifier? \'(\' +feed.deviceIdentifier+\')\' : \'\'}}</div><div class="message-time"><div class="post-time">{{::feed.time}}</div><div class="ago-time">{{::feed.ago}}</div></div></div></div></div></div></div></upgrade-banner>');
$templateCache.put('app/pages/main/dashboard/calendar/dashboardCalendar.html','<style>\n    .blurCalendar .fc-head {\n        color: #ffffff;\n        background-color: var(--color-secondary);\n    }\n    .fc-day-number{\n       opacity: 1;\n    }\n    .fc-unthemed td.fc-today {\n        background: var(--color-secondary-hover)!important;\n    }\n    .fc-today .fc-day-number {\n        color: white!important;\n        font-size: 15px;\n    }\n    .fc-basic-view .fc-day-number {\n        padding: 0 15px;\n    }\n</style><div><upgrade-banner code="1007"><div id="calendar" class="blurCalendar"></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/dashboard/dashboardTemplates/dashboardDesktop.html','<style>\n    @media (max-width: 1506px) {\n        .pie-charts .description {\n            font-size: 13px!important;\n            padding: 5px 0 0 18px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 16px!important;\n        }\n    }\n    @media (max-width: 1382px) {\n        .pie-charts .description {\n            font-size: 11px!important;\n            padding: 5px 0 0 16px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 15px!important;\n        }\n    }\n    @media (max-width: 1323px) {\n        .pie-charts .description {\n            font-size: 10px!important;\n            padding: 5px 0 0 14px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 13px!important;\n        }\n    }\n    @media (max-width: 1286px) {\n        .pie-charts .description {\n            font-size: 9px!important;\n            padding: 5px 0 0 14px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 12px!important;\n        }\n    }\n    @media (max-width: 1263px) {\n        .pie-charts .description {\n            font-size: 9px!important;\n            padding: 5px 0 0 3px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 12px!important;\n        }\n    }\n    @media (max-width: 1199px) {\n        .pie-charts .description {\n            font-size: 13px!important;\n            padding: 5px 0 0 15px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 16px!important;\n        }\n    }\n    @media (max-width: 856px) {\n        .pie-charts .description {\n            font-size: 11px!important;\n            padding: 5px 0 0 10px;\n        }\n        .pie-charts .description .description-stats {\n            font-size: 15px!important;\n        }\n    }\n    /* Wrapper looking like the old pill-style card */\n    .date-picker {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-radius: 20px;\n        padding: 6px 12px;\n        border: 1px solid #ddd;\n        background-color: #fff;\n        box-shadow: 0 1px 2px rgba(0,0,0,0.08);\n        height: 40px;\n    }\n\n    .date-position-left {\n        flex: 1;\n        text-align: left;\n        font-size: 14px;\n        color: #333;\n    }\n\n    .calender-icon-position {\n        margin-left: 8px;\n        font-size: 16px;\n        color: #d9534f; /* similar to the small red calendar icon look */\n    }\n\n    /* Optional: remove Bootstrap\'s default input look from form-control */\n    .date-picker.form-control {\n        box-shadow: none;\n        border-color: #ddd;\n    }\n\n\n    .attendance-settings-btn i {\n        font-size: 24px;\n    }\n\n    .attendance-filter-card {\n        background: #ffffff;              /* white background */\n        border-radius: 12px;              /* curved edges */\n        padding: 20px 25px;               /* inner spacing */\n        margin-top: 15px;                 /* spacing below the date picker */\n        box-shadow: 0 2px 6px rgba(0,0,0,0.08); /* soft shadow */\n    }\n\n    .attendance-filter-card .form-control {\n        border-radius: 10px;\n        height: 38px;\n    }\n\n    .border-btn {\n        border: 1px solid #ddd;\n        padding: 7px 16px;\n        border-radius: 8px;\n        margin-left: 8px;\n    }\n\n    .border-btn:hover {\n        background: #f8f8f8;\n    }\n\n    .apply-btn {\n        background: #1cb7a8 !important;\n        color: #fff !important;\n        border-radius: 8px;\n        padding: 8px 18px;\n        border: none;\n    }\n\n\n\n</style><div class="row mb-10" ng-if="!vm.hasSubsidiaryActivated"><div class="col-lg-5"><h3 id="currentTime">{{vm.currentTime}}</h3></div></div><div class="row mb-10 align-items-center" ng-if="vm.hasSubsidiaryActivated"><div class="col-lg-2 col-sm-12 d-flex align-items-center"><div date-range-picker="" class="form-control date-picker position-relative cursor-text" ng-model="vm.modal.newEvent.startDate" options="vm.datePickerOptions"><span class="date-position-left" ng-if="vm.modal.newEvent.startDate">{{ vm.modal.newEvent.startDate.format(\'dddd, DD/MM/YYYY\') }}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-lg-10 col-md-5 col-sm-12 text-right mt-2 mt-md-0"><button type="button" class="btn btn-default attendance-settings-btn" ng-click="vm.toggleFilterPanel()"><i class="fa fa-cog"></i></button></div></div><div class="row mb-15" ng-if="vm.hasSubsidiaryActivated" ng-show="vm.showFilterPanel"><div class="col-lg-12"><div class="attendance-filter-card"><div class="row"><div class="form-group col-md-4 mb-2" ng-if="!vm.isSubsidiaryAdmin"><label class="filter-label" translate="">{{ \'dashboardFilter.company\' }}</label><div isteven-multi-select="" input-model="vm.filteredSubsidiaries" output-model="vm.search.selectedSubsidiaries" button-label="name" item-label="name" tick-property="ticked" output-properties="id name" on-close="vm.onSubsidiaryChange()" on-item-click="vm.onSubsidiaryChange()"></div></div><div class="form-group col-md-4 mb-2"><label class="filter-label" translate="">{{ \'dashboardFilter.employeeCategory\' }}</label><div isteven-multi-select="" input-model="vm.employmentTypeList" output-model="vm.search.selectedEmploymentTypes" button-label="name" item-label="name" tick-property="ticked" output-properties="id name"></div></div><div class="form-group col-md-4 mb-2"><label class="filter-label" translate="">{{ \'dashboardFilter.workplace\' }}</label><div isteven-multi-select="" input-model="vm.workplaceList" output-model="vm.search.selectedWorkplaces" button-label="name" item-label="name" tick-property="ticked" output-properties="id name"></div></div></div><div class="text-right mt-20 mb-80"><button type="button" class="btn btn-md border-btn" ng-click="vm.clearFilters()">Clear</button> <button type="button" class="btn btn-md apply-btn" ng-click="vm.applyFilters()">Apply</button></div></div></div></div><div class="row"><div class="col-lg-12"><div ng-if="vm.subscription.isExpired && !vm.isGpClient && !vm.isGBPLClient" class="alert alert-danger color-a94442 font-weight-600 text-center"><span class="blink" translate="">{{\'dashboardText.warning\'}}</span></div><div ng-if="!vm.subscription.isExpired && vm.subscription.isAboutToBeExpired" class="alert alert-warning color-8a6d3b font-weight-600 text-center"><div class="blink"><span translate="">{{\'dashboardText.reminderTextPart1\'}}</span> {{vm.subscription.daysBeforeExpiry}} <span translate="">{{\'dashboardText.reminderTextPart2\'}}</span></div></div><div ng-if="vm.isGBPLClient" class="alert alert-danger color-a94442 font-weight-600 text-center"><span class="blink" translate="">{{\'dashboardText.warningForGBPLClients\'}}</span></div></div></div><div class="row"><div ng-if="!vm.hasCarouselPermission" class="col-lg-8" include-with-scope="app/pages/main/dashboard/dashboardTemplates/templates/withoutCarouselPermission.html"></div><div ng-if="vm.hasCarouselPermission" class="col-lg-8" include-with-scope="app/pages/main/dashboard/dashboardTemplates/templates/withCarouselPermission.html"></div><div id="attendanceFeed" class="col-lg-4"><div ng-if="vm.isDashboardDataReady.attendanceFeed"><div ba-panel="" ba-panel-title="{{\'attendanceFeed\' | translate}}" ba-panel-class="semi-large-panel with-scroll feed-panel"><attendance-feed></attendance-feed></div></div></div></div>');
$templateCache.put('app/pages/main/dashboard/dashboardTemplates/dashboardMobile.html','<div class="row mb-10"><div class="col-lg-5"><h3 id="currentTime" class="color-prime">{{vm.currentTime}}</h3></div></div><div class="row"><div class="col-lg-8"><div class="row"><div ng-if="vm.subscription.isExpired" class="alert alert-danger color-a94442 font-weight-600 text-center"><span class="blink" ng-if="!vm.isGpClient" translate="">{{\'dashboardText.warning\'}}</span> <span class="blink" ng-if="vm.isGpClient" translate="">{{\'dashboardText.warningForGPClients\'}}</span></div><div ng-if="!vm.subscription.isExpired && vm.subscription.isAboutToBeExpired" class="alert alert-warning color-8a6d3b font-weight-600 text-center"><div class="blink"><span translate="">{{\'dashboardText.reminderTextPart1\'}}</span> {{vm.subscription.daysBeforeExpiry}} <span translate="">{{\'dashboardText.reminderTextPart2\'}}</span></div></div></div><div class="row pl-15"><div ng-if="vm.isDashboardDataReady.attendanceSummary"><dashboard-pie-chart></dashboard-pie-chart></div></div><div class="row"><div ng-if="vm.isDashboardDataReady.departmentAttendance"><div ba-panel="" ba-panel-title="Department Attendance" ba-panel-class="semi-medium-panel"><div include-with-scope="app/pages/main/dashboard/departmentAttendance/departmentAttendance.dashboard.partial.html"></div></div></div></div><div class="row"><div id="attendanceFeed" class="col-lg-4"><div ng-if="vm.isDashboardDataReady.attendanceFeed"><div ba-panel="" ba-panel-title="Attendance Feed" ba-panel-class="semi-large-panel with-scroll feed-panel"><attendance-feed></attendance-feed></div></div></div><div ba-panel="" ba-panel-title="Calendar" ba-panel-class="medium-panel"><dashboard-calendar></dashboard-calendar></div></div></div></div>');
$templateCache.put('app/pages/main/dashboard/departmentAttendance/departmentAttendance.dashboard.partial.html','<style>\n    .chart-title {\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 100px;\n        text-align: center;\n        font-size: 11px;\n        word-wrap:break-word;\n    }\n    .carousel-prev, .carousel-next{\n        position: absolute;\n        top: 50%;\n        cursor: pointer;\n        padding: 5px;\n    }\n    .carousel-next{\n        right: 0;\n    }\n</style><div ng-controller="DashboardDepartmentAttendanceCtrl as vm" data-ride="carousel"><upgrade-banner code="[\'1002\',\'1003\']"><div ng-mouseenter="vm.autoplay = false" ng-mouseleave="vm.autoplay=true"><ui-carousel slides="vm.departments" slides-to-show="vm.slidesToShow" slides-to-scroll="1" initial-slide="1" autoplay="vm.autoplay" autoplay-speed="2000" on-init="ctrl.next" dots="true" class="text-center"><carousel-item><div class="position-relative"><span class="chart-title">{{item.name}}</span><canvas id="doughnut-{{item.id}}" class="chart chart-doughnut" chart-data="item.data" chart-options="item.options" chart-labels="item.labels" chart-colors="item.colours" height="200" width="200"></canvas></div></carousel-item><carousel-prev><i class="ion-chevron-left"></i></carousel-prev><carousel-next><i class="ion-chevron-right"></i></carousel-next></ui-carousel><div class="mt-50 text-center"><ul ng-repeat="labelAndColor in vm.labelsAndColors" class="pie-legend-ul"><li class="pie-legend-li"><span class="pie-legend-span" style="background-color: {{labelAndColor.colour}}"></span> <span class="d-inline-block ml-negative-12 mr-10">{{labelAndColor.label}}</span></li></ul></div></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/dashboard/departmentAttendance/pie-chart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/main/dashboard/lateFeed/lateFeed.html','<style>\n    .message-footer{\n        color: #555555;\n        font-size: 11px;\n    }\n    .late-feed{\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n    }\n    .feed-message .text-block{\n        padding:5px 20px 5px 10px;\n    }\n    .width-100{\n        width: 100% !important;\n    }\n</style><div class="row" ng-controller="LateFeedCtrl as vm" ng-if="!vm.isGroupAdmin"><div class="feed-message animate-if d-flex-align-center" ng-if="vm.isDataLoaded && vm.isBangabhabanEmployee" ng-repeat="feed in vm.lateList" ui-sref="profile({employeeId: feed.employeeId, showTab:\'attendance\', scrollTo: \'attendance\'})"><div class="message-icon"><img class="photo-icon" ng-if="feed.profilePicURL" ng-src="{{ ::feed.profilePicURL}}"> <img class="photo-icon" ng-if="feed.profilePicURL == null || feed.profilePicURL == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::feed.employeeName }}</span></div><div class="message-content line-clamp line-height-1_6"><span>{{::feed.departmentName}}</span><br><span><span translate="">{{\'dashboardText.lineManager\'}}</span> {{::feed.lineManagerName}}</span></div><div class="d-flex-space-between-wrap mt-5"><div class="message-footer"><span translate="">{{\'dashboardText.totalLates\'}}</span> {{::feed.shiftStartTimeInMillis | date: "hh:mm a"}}</div><div class="message-footer"><span translate="">{{\'dashboardText.time\'}}</span>&nbsp;{{::feed.entryTime}}</div></div></div></div><div class="feed-message animate-if" ng-if="vm.isDataLoaded && !vm.isBangabhabanEmployee" ng-repeat="feed in vm.lateList" ui-sref="profile({employeeId: feed.employeeId, showTab:\'attendance\', scrollTo: \'attendance\'})"><div class="late-feed"><div class="message-icon"><img class="photo-icon" ng-if="feed.profilePicURL" ng-src="{{ ::feed.profilePicURL}}"> <img class="photo-icon" ng-if="feed.profilePicURL == null || feed.profilePicURL == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="text-block text-message width-100"><div class="message-header"><span class="author">{{ ::feed.employeeName }}</span></div><div class="message-content line-clamp line-height-1_6"><span>{{::feed.departmentName}}</span><br><span><span translate="">{{\'dashboardText.lineManager\'}}</span> {{::feed.lineManagerName}}</span></div><div class="d-flex-space-between-wrap mt-5"><div class="message-footer"><span translate="">{{\'dashboardText.time\'}}</span>&nbsp;{{::feed.entryTime}} &nbsp; <span class="redText text-normal d-inline-block mt-negative-3">({{::feed.lateBy}} <span translate="">{{\'dashboardText.late\'}}</span>)</span></div><div class="message-footer"><span translate="">{{\'dashboardText.totalLates\'}}</span> {{::feed.currentMonthLateCount}}</div></div></div></div></div><div class="text-center mt-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div>');
$templateCache.put('app/pages/main/dashboard/leastLate/leastLate.html','<table class="table table-bordered" ng-controller="LeastLateCtrl as vm" ng-if="!vm.isGroupAdmin"><thead><th></th><th class="text-left" translate="">{{\'dashboardText.name\'}}</th><th class="text-center" translate="">{{\'dashboardText.late\'}}</th><th class="text-center" translate="">{{\'dashboardText.workingDays\'}}</th></thead><tbody><tr ng-repeat="lateResponse in vm.lateList"><td class="pt-6 pr-8 pb-7"><img class="list-avatar" ng-src="{{vm.getPictureUrl(lateResponse)}}" ng-if="vm.hasPermission(\'1006\')"> <img class="list-avatar" ng-src="{{ vm.defaultPictureUrl}}" ng-if="!vm.hasPermission(\'1006\')"></td><td class="text-left-important"><a ui-sref="profile({employeeId : {{lateResponse.employeeId}}})">{{lateResponse.name}}</a></td><td>{{lateResponse.lateDays}}</td><td>{{lateResponse.expectedDays}}</td></tr></tbody></table><table class="table table-bordered" ng-controller="LeastLateCtrl as vm" ng-if="vm.isGroupAdmin"><thead><th class="text-left" translate="">{{\'dashboardText.name\'}}</th><th class="text-center" translate="">{{\'dashboardText.total\'}}</th><th class="text-center" translate="">{{\'dashboardText.absent\'}}</th></thead><tbody><tr ng-repeat="lateResponse in vm.lateList"><td class="text-left-important">{{lateResponse.officeName}}</td><td class="text-left-important">{{lateResponse.totalEmployees}}</td><td>{{lateResponse.totalAbsents}}</td></tr></tbody></table>');
$templateCache.put('app/pages/main/dashboard/leaveFeed/leaveFeed.html','<style>\n    .message-footer{\n        color: #555555;\n        font-size: 11px;\n    }\n\n    .leave-feed{\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n    }\n    .feed-message .text-block{\n        padding:5px 20px 5px 10px;\n    }\n    .text-message{\n        width: 100%!important\n    }\n    .width-100{\n        width: 100% !important;\n    }\n    @media screen and (max-width: 1430px){\n        .text-resize{\n            font-size: 11px!important;\n            margin-left: 20%;\n        }\n    }\n    @media screen and (max-width: 1199px){\n        .text-resize{\n            font-size: 12px!important;\n        }\n    }\n</style><div class="row" ng-controller="LeaveFeedCtrl as vm" ng-if="!vm.isGroupAdmin"><div class="col-md-12" ng-if="!vm.isBangabhabanEmployee"><div ng-if="vm.isDataLoaded && vm.leaveList.length === 0"><em translate="">{{\'dashboardText.noOneIsOnLeaveText\'}}</em></div><div class="feed-message animate-if border-color-light" ng-if="vm.isDataLoaded" ng-repeat="feed in vm.leaveList" ui-sref="profile({employeeId: feed.employeeId, showTab:\'leave\'})"><div class="leave-feed"><div class="message-icon"><img class="photo-icon" ng-if="feed.profilePicURL" ng-src="{{ ::feed.profilePicURL}}"> <img class="photo-icon" ng-if="feed.profilePicURL == null || feed.profilePicURL == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="text-block text-message width-100"><div class="d-flex-space-between"><div class="message-header"><span class="author">{{ ::feed.employeeName }}</span></div><div class="message-header text-resize"><span ng-if="::feed.leaveCurrentStatus === \'Upcoming Leave\'" class="text-danger">{{::feed.leaveCurrentStatus}}</span> <span ng-if="::feed.leaveCurrentStatus !== \'Upcoming Leave\'" class="text-success">{{::feed.leaveCurrentStatus}}</span></div></div><div class="message-content line-clamp line-height-1_6"><span>{{::feed.departmentName}}</span><br><span><span translate="">{{\'dashboardText.lineManager\'}}</span> {{::feed.lineManagerName}}</span></div><div class="message-footer d-flex-space-between-wrap mt-5"><div ng-if="::feed.leaveType === 1"><span ng-if="feed.totalDays > 1" translate="">{{\'dashboardText.from\'}}</span> <span ng-if="feed.totalDays == 1" translate="">{{\'dashboardText.date\'}}</span>&nbsp;{{::feed.startDate | date : \'dd MMM yyyy\'}}&nbsp; <span ng-if="feed.totalDays > 1"><span translate="">{{\'dashboardText.toWithColon\'}}</span>{{::feed.endDate | date : \'dd MMM yyyy\'}}</span></div><div ng-if="::feed.leaveType === 2"><span translate="">{{\'dashboardText.date\'}}</span>&nbsp;{{::feed.startDate | date : \'dd MMM yyyy\'}}&nbsp;({{::feed.leaveHalfName}})</div><div><span translate="">{{\'dashboardText.total\'}}</span>&nbsp;-&nbsp;{{::feed.totalDays}} <span translate="">{{\'dashboardText.day\'}}</span><span ng-if="::feed.totalDays > 1"><span translate="">{{\'dashboardText.s\'}}</span></span></div></div></div></div></div><div class="text-center mt-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="col-md-12" ng-if="vm.isBangabhabanEmployee"><div ng-if="vm.isDataLoaded && vm.leaveList.length === 0"><em translate="">{{\'dashboardText.noOneIsOnLeaveText\'}}</em></div><div class="feed-message animate-if" ng-if="vm.isDataLoaded" ng-repeat="feed in vm.leaveList" ui-sref="profile({employeeId: feed.employeeId, showTab:\'leave\'})"><div class="d-flex-align-center"><div class="message-icon"><img class="photo-icon" ng-if="feed.profilePicURL" ng-src="{{ ::feed.profilePicURL}}"> <img class="photo-icon" ng-if="feed.profilePicURL == null || feed.profilePicURL == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="text-block text-message"><div class="d-flex-space-between"><div class="message-header"><span class="author">{{ ::feed.employeeName }}</span></div></div><div class="message-content line-clamp line-height-1_6"><span>{{::feed.departmentName}}</span><br><span><span translate="">{{\'dashboardText.lineManager\'}}</span> {{::feed.lineManagerName}}</span></div><div class="message-footer d-flex-space-between"><div><span translate="">{{\'dashboardText.totalPresent\'}}</span><span>{{::feed.totalPresentCount}}</span><span></span><span translate="">{{\'dashboardText.day\'}}</span><span ng-if="::feed.totalPresentCount > 1" translate="">{{\'dashboardText.s\'}}</span></div><div><span translate="">{{\'dashboardText.totalOnTime\'}}</span><span>{{::feed.onTimeCount}}</span><span></span><span translate="">{{\'dashboardText.day\'}}</span><span ng-if="::feed.onTimeCount > 1" translate="">{{\'dashboardText.s\'}}</span></div></div></div></div></div><div class="text-center mt-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div>');
$templateCache.put('app/pages/main/dashboard/occupancyDashboard/occupancyDashboard.html','<style>\n    .amcharts-chart-div a {\n        display: none !important;\n    }\n\n    /*.panel-full-screen {*/\n    /*    max-height: 80vh;*/\n    /*    position: relative;*/\n    /*}*/\n\n</style><div class="row mb-10"><div class="col-lg-6 text-left"><h1 translate="">{{\'dashboardText.occupancyDashboardHeading\'}}</h1></div><div class="col-lg-6 text-right"><h1 class="d-inline">{{vm.currentTime | date: \'hh:mm:ss a\'}}&nbsp;|&nbsp;{{vm.currentTime | date : \'EEE, dd MMMM yyyy\'}}</h1></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll full-screen"><div ng-controller="AttendancePieChartCtrl" include-with-scope="app/pages/main/dashboard/occupancyDashboard/attendancePieChart/attendancePieChart.html"></div></div></div></div>');
$templateCache.put('app/pages/main/dashboard/overallLinearPieChartGroup/dashboardPieChart.html','<style>\n  .pie-charts .panel > .panel-body {\n    min-height: initial;\n  }\n  .pie-charts .pie-chart-item-container .panel {\n    height: 104px;\n  }\n</style><div class="row pie-charts cursor-pointer"><div class="pie-chart-item-container" ng-repeat="chart in easypiecharts.charts" ng-if="hasPermission(\'1001\')" ng-click="redirectToReport($index)"><div ba-panel=""><div class="pie-chart-item"><div easypiechart="" options="chart.options" percent="chart.percent" class="chart"><span class="percent"></span></div><div class="description"><div>{{ chart.description | translate }}</div><div class="description-stats">{{ chart.stats }}</div></div></div></div></div></div>');
$templateCache.put('app/pages/main/devices/allocationHistory/allocationHistory.html','<style>\n    th {\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    td {\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .list-avatar {\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        margin-top: 2px;\n    }\n    .attendanceTable *{\n        font-size: 12px;\n    }\n    li  {\n        cursor: pointer;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'deviceAllocationHistory.title\' | translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-2 col-xs-2"></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{ \'deviceAllocationHistory.filters.search\' }}</label> <input class="form-control" type="text" placeholder="{{ \'deviceAllocationHistory.filters.searchInputPlaceholder\' | translate }}" ng-model="vm.searchString" ng-keyup="$event.keyCode == 13 ? vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, 1) : null" ng-change="vm.searchDevice()"></div><div class="form-group col-sm-4 col-xs-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="margin-top: 21px" ng-click="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, 1)"><i class="ion-search"></i>{{ \'deviceAllocationHistory.filters.search\' | translate }}</button></div><div class="form-group col-sm-2 col-xs-2"></div></div></div><div class="row"><div class="col-md-6 col-xs-0"></div><div id="attendanceTableRowsPerPageDiv" class="col-md-4 col-xs-6 text-right" style="margin-top: 10px"><span id="attendanceTableRowsPerPageSpan"><strong>Rows Per Page</strong></span></div><div class="col-md-2 col-xs-6"><select class="form-control" ng-model="vm.rowsPerPage" ng-change="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, 1)"><option value="20" ng-selected="vm.rowsPerPage == 20">20</option><option value="50" ng-selected="vm.rowsPerPage == 50">50</option><option value="100" ng-selected="vm.rowsPerPage == 100">100</option><option value="200" ng-selected="vm.rowsPerPage == 200">200</option></select></div></div><div class="attendanceDiv"><table class="table table-bordered attendanceTable" ng-if="vm.allScheduledAllocations.responseList.length > 0" style="margin-top: 20px;"><thead><tr class="headers2"><th>SL</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.image\' }}</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.name\' }}</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.device\' }}</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.location\' }}</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.action\' }}</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.date\' }}</th><th translate="">{{ \'deviceAllocationHistory.tableHeader.status\' }}</th></tr></thead><tbody><tr ng-repeat="scheduledAllocation in vm.allScheduledAllocations.responseList"><td>{{(vm.allScheduledAllocations.pageNo-1) * vm.rowsPerPage + $index+1}}</td><td style="text-align: center !important;"><img class="list-avatar" ng-show="scheduledAllocation.profilePictureUrl != null && scheduledAllocation.profilePictureUrl != \'\'" ng-src="{{scheduledAllocation.profilePictureUrl}}"> <img class="list-avatar" ng-show="scheduledAllocation.profilePictureUrl == null || scheduledAllocation.profilePictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td style="text-align: left!important;"><a ui-sref="profile({employeeId : {{scheduledAllocation.employeeId}}})">{{scheduledAllocation.employeeName}}</a></td><td><a ui-sref="devices.deviceDetails({deviceId:{{scheduledAllocation.deviceId}}})">{{scheduledAllocation.deviceIdentifier}}</a></td><td>{{scheduledAllocation.deviceLocation}}</td><td>{{scheduledAllocation.action}}</td><td>{{scheduledAllocation.date}}</td><td ng-if="scheduledAllocation.status==0" style="color:orange"><strong translate="">{{ \'deviceAllocationHistory.statusPending\' }}</strong></td><td ng-if="scheduledAllocation.status==-1" style="color:red"><strong translate="">{{ \'deviceAllocationHistory.statusFailed\' }}</strong></td><td ng-if="scheduledAllocation.status==1" style="color:green"><strong translate="">{{ \'deviceAllocationHistory.statusDone\' }}</strong></td></tr></tbody></table></div><div class="text-center" ng-if="vm.allScheduledAllocations.responseList.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, 1)">First</a></li><li class="page-item"><a class="page-link" ng-click="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, vm.allScheduledAllocations.pageNo-1 > 0? vm.allScheduledAllocations.pageNo-1 : 1)">&lt;</a></li><li ng-repeat="n in vm.pageButtons" ng-class="(vm.allScheduledAllocations.pageNo == n)? \'active\':\'\'"><a ng-click="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, n)">{{n}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, vm.allScheduledAllocations.pageNo+1 > vm.allScheduledAllocations.totalPage? vm.allScheduledAllocations.totalPage: vm.allScheduledAllocations.pageNo+1)">&gt;</a></li><li class="page-item"><a class="page-link" ng-click="vm.getScheduledAllocations(vm.searchString, vm.rowsPerPage, vm.allScheduledAllocations.totalPage)">Last</a></li></ul></nav></div><div class="text-center" style="margin-top: 10px" ng-if="vm.allScheduledAllocations.responseList.length > 0"><p><strong>Showing page {{vm.allScheduledAllocations.pageNo}} out of {{vm.allScheduledAllocations.totalPage}} pages.</strong></p></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/devices.html','<div ba-panel="" ba-panel-title="{{ \'deviceListPage.title\' | translate }} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate }} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{ \'deviceListPage.filters.location\' }}</label> <input class="form-control" type="text" placeholder="{{ \'deviceListPage.filters.locationInputPlaceholder\' | translate }}" ng-model="vm.location" ng-keyup="$event.keyCode == 13 ? vm.searchDevice() : null" ng-change="vm.searchDevice()"></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{ \'deviceListPage.filters.identifier\' }}</label> <input class="form-control" type="text" placeholder="{{ \'deviceListPage.filters.identifierInputPlaceholder\' | translate }}" ng-model="vm.identifier" ng-keyup="$event.keyCode == 13 ? vm.searchDevice() : null" ng-change="vm.searchDevice()"></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{ \'deviceListPage.filters.phoneNumber\' }}</label> <input class="form-control" type="text" placeholder="{{ \'deviceListPage.filters.phoneNumberInputPlaceholder\' | translate }}" ng-model="vm.phoneNumber" ng-keyup="$event.keyCode == 13 ? vm.searchDevice() : null" ng-change="vm.searchDevice()"></div></div></div><div class="row"><div class="col-md-offset-8 col-md-1 col-xs-4"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div><div id="attendanceTableRowsPerPageDiv" class="col-md-1 col-xs-4 text-right mt-10"><span id="attendanceTableRowsPerPageSpan"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span></div><div class="col-md-2 col-xs-4"><div class="custom-select"><select ng-model="vm.rowsPerPage" ng-change="vm.changeRowsToDisplay()"><option value="10" ng-selected="vm.rowsPerPage === \'10\'" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.rowsPerPage === \'20\'" translate="">{{\'commonKeywords.twenty\'}}</option><option value="50" ng-selected="vm.rowsPerPage === \'50\'" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.rowsPerPage === \'100\'" translate="">{{\'commonKeywords.hundred\'}}</option></select></div></div></div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-show="vm.isDataLoaded" class="mt-20 horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip" id="attendanceTable" ng-if="vm.devicesToShow.length > 0"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{ \'deviceListPage.tableHeader.identifier\' }}</th><th class="text-left" translate="">{{ \'deviceListPage.tableHeader.location\' }}</th><th class="text-left" translate="">{{ \'deviceListPage.tableHeader.workplace\' }}</th><th class="text-center" translate="">{{ \'deviceListPage.tableHeader.connectionStatus\' }}</th><th class="text-left" translate="">{{ \'deviceListPage.tableHeader.phoneNumber\' }}</th><th class="text-left" translate="">{{ \'deviceListPage.tableHeader.description\' }}</th><th class="text-center" translate="">{{ \'deviceListPage.tableHeader.type\' }}</th><th class="text-center" translate="">{{ \'deviceListPage.tableHeader.lastCommunication\' }}</th><th class="text-center width-7" translate="">{{ \'deviceListPage.tableHeader.action\' }}</th></tr></thead><tr ng-repeat="device in vm.devicesToShow"><td class="text-center">{{(vm.selectedPage * vm.rowsPerPage)+($index+1)}}</td><td class="text-center"><a ui-sref="devices.deviceDetails({deviceId:device.id})">{{device.identifier}}</a></td><td class="text-left">{{device.location}}</td><td class="text-left">{{ device.workplaceName || \'N/A\' }}</td><td class="text-center text-bold"><span ng-if="device.isOnline == null" translate="">{{ \'deviceListPage.statusNotAvailable\' }}</span> <span ng-if="device.isOnline != null && device.isOnline" class="text-success" translate="">{{ \'deviceListPage.statusConnected\' }}</span> <span ng-if="device.isOnline != null && !device.isOnline" class="text-danger" translate="">{{ \'deviceListPage.statusDisconnected\' }}</span></td><td class="text-left">{{device.phoneNumber}}</td><td class="text-left"><span ng-if="!!device.description">{{device.description}}</span> <span ng-if="!device.description">--</span></td><td class="text-center">{{device.type}}</td><td class="text-center"><span ng-if="!!device.lastCommunicationAt">{{device.lastCommunicationAt | date: \'dd MMM yyyy HH:mm:ss\'}}</span> <span ng-if="!device.lastCommunicationAt">--</span></td><td class="text-center"><button ng-click="vm.openEditDeviceModal(device)" class="btn btn-sm-with-icon btn-secondary"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button></td></tr></table></div><div class="text-center" ng-if="vm.devicesToShow.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.paginateData(0)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPage==$index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPage <= vm.numberOfButtons.length && vm.selectedPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPage - 2 && $index <= vm.selectedPage + 3)"><a ng-click="vm.paginateData($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">></a></li><li class="page-item"><a class="page-link" ng-click="vm.paginateData(vm.numberOfButtons.length-1)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div ng-if="vm.devicesToShow.length == 0 || vm.devicesToShow === undefined"><br><br><h3 class="text-center"><i>{{ \'deviceListPage.filters.notFoundText\' | translate }}</i></h3></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategory/leaveCategory.html','<div ba-panel="" ba-panel-title="{{ \'leaveCategorySettings.title\' | translate }}" ba-panel-class="with-scroll"><div ng-controller="LeaveCategoryCtrl as vm"><div class="row"><div class="col-md-12"><upgrade-button code="6004"><button class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateLeaveCategoryModal()"><i class="ion-android-checkmark-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'leaveCategorySettings.createButton\'}}</span></button></upgrade-button></div></div><div class="row"><div class="col-md-12 mb-20 mt-20"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-5"><col class="width-78"><col class="width-13"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'leaveCategorySettings.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'leaveCategorySettings.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="leaveCategory in vm.leaveCategory.leaveCategoryList"><td class="text-center">{{$index+1}}</td><td class="text-left">{{leaveCategory.name}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditLeaveCategoryModal(leaveCategory,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteLeaveCategoryModal(leaveCategory,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/leave/applyLeaveForOthers/applyLeaveForOthers.html','<style>\n    .dummy-modal-placement{\n        position: absolute;\n        top:42%;\n        left:15%;\n        width: 65%;\n    }\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 5px !important;\n    }\n    .leave-info-details{\n        height: calc(100vh - 268px);\n        overflow-y: auto;\n        width: 100%;\n        overflow-x: hidden;\n    }\n    @media screen and (max-width: 1127px) {\n        .dont-wrap-header{\n            font-size: 15px;\n        }\n    }\n    @media screen and (max-width: 991px) {\n        .dont-wrap-header{\n            font-size: 18px;\n        }\n    }\n</style><div ba-panel="" ba-panel-title="{{\'leaveApplyForOthers\' | translate}}"><div class="row"><div class="col-md-7 col-sm-12 col-lg-6"><div class="row mb-5"><div class="col-md-6"><div class="input-group"><input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.searchByNameOrId()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"> <span class="input-group-addon addon-right cursor-pointer"><i id="search-icon" ng-click="vm.searchByNameOrId()" class="ion-android-search"></i></span></div></div><div class="col-md-6"><button ui-sref="leave.applyLeaveForEmployees" class="btn btn-md-with-icon btn-primary pull-right" ng-click="vm.analyticsApplyLeave()"><i class="ion-ios-compose"></i><span class="pb-3" translate="">{{\'applyLeave.applyLeaveButton\'}}</span></button></div></div><div class="row"><div class="col-md-12"><div class="btn-group special" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedLeaveApplicationStatuses.toString() == [0,1,2,3]}" ng-click="vm.setSelectedLeaveApplicationStatuses([0,1,2,3])" translate="">{{\'applyLeave.allLeaves\'}}</button> <button type="button" class="btn btn-style dont-wrap-text" ng-class="vm.selectedLeaveApplicationStatuses.toString() == [0].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedLeaveApplicationStatuses([0])" translate="">{{\'applyLeave.pendingLeaves\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="vm.selectedLeaveApplicationStatuses.toString() == [1].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedLeaveApplicationStatuses([1])" translate="">{{\'applyLeave.approvedLeaves\'}}</button></div></div></div><div class="row"><div class="col-md-12"><table id="column-height" class="table borderless-table even-row-strip row-highlight" ng-if="vm.allLeaveApplicationData.totalRecords > 0 && vm.isDataLoaded"><colgroup><col class="width-35"><col class="width-19"><col class="width-19"><col class="width-12"><col class="width-13 p-all-0"></colgroup><thead><tr class="dont-wrap-text height-5-vh"><th class="text-left dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.employeeName\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.category\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.dateRange\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.status\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.action\'}}</th></tr></thead><tbody><tr class="text-center cursor-pointer height-7-vh" ng-if="vm.allLeaveApplicationData.totalRecords > 0" ng-class="{\'onClick\':vm.isRowSelected && vm.selectedRow == $index}" ng-repeat="data in vm.allLeaveApplicationData.leaveLogList"><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text text-left"><employee-picture-and-information name="data.employeeName" picture-url="data.employeeProfilePictureUrl" department-name="data.employeeDepartmentName" designation-name="data.employeeDesignationName" is-clickable="false"></employee-picture-and-information></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text text-left">{{data.categoryName}}</td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text">{{data.startDate | date:\'d MMM y\'}}<br><span ng-if="data.numberOfDays"><span translate="">{{\'commonKeywords.smallTo\'}}</span><br>{{data.endDate | date:\'d MMM y\'}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text" ng-if="data.status==0"><span class="text-warning">{{data.statusText}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text" ng-if="data.status==1"><span class="text-success">{{data.statusText}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text" ng-if="data.status==2"><span class="text-danger">{{data.statusText}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="dont-wrap-text" ng-if="data.status==3"><span class="">{{data.statusText}}</span></td><td class="dont-wrap-text pr-8-important"><div ng-if="data.applicationEventType != 3"><div class="mb-3" ng-if="data.applicationEventType == 1 && (data.status !==2 && data.status !==3)"><button class="btn btn-sm-with-icon btn-info" ng-click="vm.prepareOpenAdjustModal($index)"><i class="ion-android-options"></i><span class="pb-2" translate="">{{\'commonKeywords.adjust\'}}</span></button></div><div ng-if="(data.applicationEventType == 1 || data.applicationEventType== 2) && (data.status !==2 && data.status !==3)"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openCancelModal($index)"><i class="ion-android-delete"></i><span class="pb-2" translate="">{{\'commonKeywords.cancel\'}}</span></button></div></div><div ng-if="data.applicationEventType== 3"><span translate="">{{\'applyLeave.noActionAvailable\'}}</span></div></td></tr></tbody></table><div class="text-center mt-20" ng-if="vm.isDataLoaded && vm.allLeaveApplicationData.totalRecords == 0"><h4><em translate="">{{\'applyLeave.noResultsToBeShown\'}}</em></h4></div><div class="row align-items-center"><div class="col-md-12 col-sm-6" ng-if="!vm.allLeaveApplicationData.totalRecords > 0 && !vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.allLeaveApplicationData.totalRecords > 0 && vm.isDataLoaded"><div class="col md-6"><div class="text-center"><nav aria-label="Page navigation" class="cursor-pointer"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'first\'})"><span translate="">{{\'commonKeywords.first\'}}</span></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage == $index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:$index})">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'last\'})"><span translate="">{{\'commonKeywords.last\'}}</span></a></li></ul></nav></div></div></div></div></div></div><div class="col-md-5 col-sm-12 col-lg-6 position-relative"><div class="row mb-10"><div class="col-md-6 mb-0"><p class="dont-wrap-header pt-10 font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</p></div></div><div ng-if="vm.isRowSelected" class="mb-15 leave-info-details"><div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2"><employee-picture-and-information name="vm.selectedLeaveApplication.employeeName" picture-url="vm.selectedLeaveApplication.employeeProfilePictureUrl" department-name="vm.selectedLeaveApplication.employeeDepartmentName" designation-name="vm.selectedLeaveApplication.employeeDesignationName" id="vm.selectedLeaveApplication.employeeId" is-clickable="vm.selectedLeaveApplication.employeeStatus == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'applyLeave.leavePolicy\'}}</td><td class="color-22222">{{vm.selectedLeaveApplication.leavePolicyId ? vm.selectedLeaveApplication.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'applyLeave.employmentType\'}}</td><td class="color-22222">{{vm.selectedLeaveApplication.employeeEmploymentTypeId ? vm.selectedLeaveApplication.employeeEmployementTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-12"><p class="mt-20 mb-15 font-16 color-22222 font-weight-500" translate="">{{\'applyLeave.remainingLeavesHeading\'}}</p></div></div><div class="row"><div class="col-md-12 col-sm-12"><upgrade-banner code="6009"><div class="text-center align-self-start" ng-show="!vm.isRemainingLeaveDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-show="vm.isRemainingLeaveDataLoaded"><div><div class="text-center" ng-show="vm.remainingLeavesList.length === 0" translate="">{{\'profileLeave.noLeavePolicyOrApproverAssigned\'}}</div><table class="table table-bordered" ng-show="vm.remainingLeavesList.length > 0"><colgroup><col class="width-40"><col class="width-18"><col class="width-18"><col class="width-24"></colgroup><thead><tr class="th-bg"><th class="text-left" translate="">{{\'applyLeave.remainingLeaveTableHeader.category\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.total\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.used\'}}</th><th class="text-center" translate="">{{\'profileLeave.remainingLeaves\'}}</th></tr></thead><tbody><tr ng-repeat="remainingLeaves in vm.remainingLeavesList"><td>{{remainingLeaves.leaveCategoryPolicyConfig.leaveCategory.name}}</td><td class="text-center color-22222">{{remainingLeaves.total}}</td><td class="text-center color-22222">{{remainingLeaves.used}}</td><td class="text-center color-22222">{{remainingLeaves.remainingLeaveCount}}</td></tr></tbody></table></div></div></upgrade-banner></div></div><div class="row"><div class="col-md-12 col-sm-12"><div class="row"><div class="col-md-12"><p class="mt-20 mb-15 font-16 color-22222 font-weight-500" translate="">{{\'applyLeave.leaveApplicationInformation\'}}</p></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'applyLeave.leaveApplicationInformationTh.category\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.categoryName}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'applyLeave.leaveApplicationInformationTh.applicationType\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.applicationEventTypeName}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'applyLeave.leaveApplicationInformationTh.dateOfApplication\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.creationDate | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.dateRange\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.startDate | date:\'d MMM yyyy\'}} <span ng-if="vm.selectedLeaveApplication.numberOfDays > 1"><span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.selectedLeaveApplication.endDate | date:\'d MMM y\'}}</span><span ng-if="vm.selectedLeaveApplication.numberOfDays == 1">(<span class="greenText"><span translate="">{{\'commonKeywords.oneDay\'}}</span></span>)</span> <span ng-if="vm.selectedLeaveApplication.numberOfDays == .5">(<span class="greenText"><span translate="">{{\'commonKeywords.halfDay\'}}</span></span>)</span> <span ng-if="vm.selectedLeaveApplication.numberOfDays > 1">(<span class="greenText">{{vm.selectedLeaveApplication.numberOfDays +\' days\'}}</span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'applyLeave.leaveApplicationInformationTh.leaveType\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.typeName}}</td></tr><tr class="text-left dont-wrap-text" ng-if="vm.selectedLeaveApplication.type == 2"><td class="dont-wrap-text" translate="">{{\'applyLeave.leaveApplicationInformationTh.leaveHalf\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.leaveHalfName}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.reason\'}}</td><td class="dont-wrap-text color-22222"><span ng-if="!vm.selectedLeaveApplication.reason" translate="">{{\'commonKeywords.na\'}}</span> <span ng-if="vm.selectedLeaveApplication.reason">{{vm.selectedLeaveApplication.reason}}</span></td></tr><tr class="text-left dont-wrap-text" ng-if="!vm.selectedLeaveApplication.forceApproval"><td class="dont-wrap-text" translate="">{{\'commonKeywords.firstApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span>{{vm.selectedLeaveApplication.firstApproverName}}</span> <span ng-if="vm.selectedLeaveApplication.firstApproverId">(<span ng-bind-html="vm.selectedLeaveApplication.firstApprovalDisplayString"></span>)</span></td></tr><tr class="text-left dont-wrap-text" ng-if="!vm.selectedLeaveApplication.forceApproval"><td class="dont-wrap-text" translate="">{{\'commonKeywords.firstApproverComment\'}}</td><td class="dont-wrap-text color-22222"><span>{{!vm.selectedLeaveApplication.firstApprovalComment ? "No Comment": vm.selectedLeaveApplication.firstApprovalComment}}</span></td></tr><tr class="text-left dont-wrap-text" ng-if="!vm.selectedLeaveApplication.forceApproval"><td class="dont-wrap-text" translate="">{{\'commonKeywords.secondApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span>{{vm.selectedLeaveApplication.secondApproverName}}</span> <span ng-if="vm.selectedLeaveApplication.secondApproverId">(<span ng-bind-html="vm.selectedLeaveApplication.secondApprovalDisplayString"></span>)</span></td></tr><tr class="text-left dont-wrap-text" ng-if="!vm.selectedLeaveApplication.forceApproval"><td class="dont-wrap-text" translate="">{{\'commonKeywords.secondApproverComment\'}}</td><td class="dont-wrap-text color-22222"><span>{{!vm.selectedLeaveApplication.secondApprovalComment ? "No Comment": vm.selectedLeaveApplication.secondApprovalComment}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.appliedBy\'}}</td><td class="dont-wrap-text"><employee-picture-and-information name="vm.selectedLeaveApplication.nameOfAppliedBy" picture-url="vm.selectedLeaveApplication.applierProfilePictureUrl" department-name="vm.selectedLeaveApplication.applierDepartmentName" designation-name="vm.selectedLeaveApplication.applierDesignationName" is-clickable="false"></employee-picture-and-information></td></tr></tbody></table></div></div></div></div></div><div ng-if="!vm.isRowSelected" ng-class="{\'unselected\': vm.isRowSelected == false}"><div class="row mt-10"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationAdjust.html"></div></div><div class="row mt-40"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationAdjustDifferenceTable.html"></div></div></div><div class="row" ng-if="!vm.isRowSelected" include-with-scope="app/pages/main/profile/leave/partials/dummyModal.html"></div><div class="row align-items-center" ng-if="vm.isRowSelected && !vm.isAdjustDataLoded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/leave/leavePolicy/leavePolicy.html','<div ba-panel="" ba-panel-title="{{ \'leavePolicySettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><upgrade-button code="6003"><button class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateLeavePolicyModal()"><i class="ion-android-checkmark-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'leavePolicySettings.createButton\'}}</span></button></upgrade-button></div></div><br><div class="mb-20"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-5"><col class="width-78"><col class="width-13"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'leavePolicySettings.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'leavePolicySettings.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="leavepolicy in vm.leavePolicy.leavePolicyList"><td class="text-center">{{$index+1}}</td><td class="text-left">{{leavepolicy.name}}</td><td class="d-flex-center-gap-10"><button ng-click="vm.openEditLeavePolicyModal(leavepolicy, $index)" class="btn btn-sm-with-icon btn-secondary"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button ng-click="vm.openDeleteLeavePolicyModal(leavepolicy,$index)" class="btn btn-sm-with-icon btn-danger"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategoryPolicyConfiguration/leaveCategoryPolicyConfiguration.html','<style>\n    .table > tbody > tr > td:last-child {\n        padding-right: 8px !important;\n    }\n</style><div><div ba-panel="" ba-panel-title="{{ \'leaveCategoryPolicyConfigurations.title\' | translate }}" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><upgrade-button code="6003"><button class="btn btn-md-with-icon btn-primary" ui-sref="leave.createLeaveCategoryPolicyConfiguration()" ng-click="vm.analyticsCreateConfiguration()"><i class="ion-android-checkmark-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'leaveCategoryPolicyConfigurations.createButton\'}}</span></button></upgrade-button></div></div><div class="row mb-20 mt-15"><div class="col-sm-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-child-selector"><thead><tr><th class="text-center width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'leaveCategoryPolicyConfigurations.tableHeader.policy\' }}</th><th class="text-left" translate="">{{ \'leaveCategoryPolicyConfigurations.tableHeader.category\' }}</th><th class="text-center" translate="">{{ \'leaveCategoryPolicyConfigurations.tableHeader.numberOfLeaves\' }}</th><th class="text-center" translate="">{{ \'leaveCategoryPolicyConfigurations.tableHeader.earnedLeaveStatus\' }}</th><th class="text-center width-13" translate="">{{ \'leaveCategoryPolicyConfigurations.tableHeader.actions\' }}</th></tr></thead><tbody ng-show="vm.isDataLoaded" ng-repeat="policyToCategoryConfig in vm.leavePolicyToCategoryConfigs"><tr><td rowspan="{{policyToCategoryConfig.configs.length}}" class="text-center">{{$index+1}}</td><td rowspan="{{policyToCategoryConfig.configs.length}}" class="text-left">{{policyToCategoryConfig.leavePolicyName}}</td><td class="text-left">{{policyToCategoryConfig.configs[0].leaveCategoryName}}</td><td class="text-center"><span class="ml-8">{{policyToCategoryConfig.configs[0].totalDays}}</span></td><td class="text-center"><span>{{(policyToCategoryConfig.configs[0].earnedLeaveCriteria === 0) ? vm.disabled : vm.enabled }}</span></td><td rowspan="{{policyToCategoryConfig.configs.length}}"><div class="d-flex-center-gap-10"><button ui-sref="leave.configurationDetails({leavePolicyId:{{policyToCategoryConfig.leavePolicyId}}})" class="btn btn-sm-with-icon btn-secondary" ng-click="vm.analyticsEditConfiguration()"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button ng-click="vm.openDeleteConfigurationModal(policyToCategoryConfig, $index)" class="btn btn-sm-with-icon btn-danger"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div></td></tr><tr ng-repeat="config in policyToCategoryConfig.configs" ng-if="$index > 0"><td class="text-left">{{config.leaveCategoryName}}</td><td class="text-center"><span class="ml-8">{{config.totalDays}}</span></td><td class="text-center"><span>{{(config.earnedLeaveCriteria === 0) ? vm.disabled : vm.enabled}}</span></td></tr></tbody></table></div><div class="row" ng-show="!vm.isDataLoaded"><div class="col-sm-12"><div class="text-center mb-10"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/leave/uploadLeaveBalance/uploadLeaveBalance.html','<style>\n    .upload-full-screen-loader{\n        position: fixed;\n        top:0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.45);\n        z-index: 11;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .z-index{\n        z-index: 44;\n        color:black;\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n</style><div class="row"><div class="upload-full-screen-loader" ng-if="vm.showSpiner"><div class="text-center mb-10 z-index"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Remaining Leave Balance Of \' + vm.selectedFiscalYear}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.getRowsPerPage()" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="fiscalYearly" config="vm.filterConfig" hide-download="true"></report-filter></div><div class="d-flex-flex-start-gap-10"><div><button class="btn btn-md-with-icon btn-primary padding-5-12 font-13" ngf-select="vm.uploadSelectedExcelFile($file)" ngf-multiple="false" ngf-accept="\'.xls,.xlsx\'" ng-click="vm.analyticsUploadExcel()"><img src="../assets/img/Upload.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.uploadExcelButton\'}}</span></button></div><div><button class="btn btn-md-with-icon border-btn padding-6-12 font-13" ng-click="vm.downloadSampleExcel()"><img class="img-resize" src="../assets/img/Download.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.downloadExcelButton\'}}</span></button></div></div><div><div><div class="mt-20"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-child-selector"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-center width-7" translate="">id</th><th class="text-left width-20" translate="">employeeName</th><th class="text-center width-11" translate="">employmentType</th><th class="text-left width-10" translate="">leavePolicy</th><th class="text-left width-20" translate="">leaveType</th><th class="text-center width-7" translate="">entitled</th><th class="text-center width-7" translate="">Used</th><th class="text-center width-7" translate="">balance</th></tr><tbody ng-if="vm.isDataLoaded && vm.allLeaveBalanceData.length > 0" ng-repeat="employee in vm.allLeaveBalanceData"><tr><td class="text-center" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}" ng-class="employee.employmentTypeName == \'Not Set\'? \'color-999999 text-center\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-left" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}" ng-class="employee.leaveLeaveInfo.leavePolicyName == \'\' ?\'color-999999 text-left\':\'text-left\'">{{employee.leaveLeaveInfo.leavePolicyName == \'\' ? \'Not Set\' : employee.leaveLeaveInfo.leavePolicyName}}</td><td class="text-left border-left">{{employee.leaveLeaveInfo.leaveDataList[0].leaveCategoryName == null ? \'Not Set\': employee.leaveLeaveInfo.leaveDataList[0].leaveCategoryName}}</td><td class="text-center">{{employee.leaveLeaveInfo.leaveDataList[0].entitled == null ? \'Not Set\' : employee.leaveLeaveInfo.leaveDataList[0].entitled}}</td><td class="text-center">{{employee.leaveLeaveInfo.leaveDataList[0].used == null ? \'Not Set\' : employee.leaveLeaveInfo.leaveDataList[0].used}}</td><td class="text-center border-right">{{employee.leaveLeaveInfo.leaveDataList[0].balance == null ? \'Not Set\': employee.leaveLeaveInfo.leaveDataList[0].balance}}</td></tr><tr ng-repeat="remaining in employee.leaveLeaveInfo.leaveDataList" ng-if="$index > 0"><td class="text-left border-left border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.leaveCategoryName == null ? \'Not Set\' : remaining.leaveCategoryName}}</td><td class="text-center border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.entitled == null ? \'Not Set\' : remaining.entitled}}</td><td class="text-center border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.used == null ? \'Not Set\' : remaining.used}}</td><td class="text-center border-right border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.balance == null ? \'Not Set\' : remaining.balance}}</td></tr></tbody></thead></table></div></div><div ng-show="!vm.isDataLoaded" class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isDataLoaded && vm.allLeaveBalanceData.length < 1"><p class="text-center mt-10"><strong translate="">{{\'noDataFound\'}}</strong></p></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/employees/batchCreate/batchCreateEmployees.html','<div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><uib-tabset active="0"><uib-tab heading="{{ \'employeesBatchCreation.batchCreateTabHeader\' | translate }}" index="0" select="vm.onSwitchToHistoryTab()"><div include-with-scope="app/pages/main/employees/batchCreate/create/batchCreate.html"></div></uib-tab><uib-tab heading="{{ \'employeesBatchCreation.historyTabHeader\' | translate }}" index="1"><div include-with-scope="app/pages/main/employees/batchCreate/history/history.html"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/main/employees/fieldVisit/fieldVisit.html','<style>\n    .btn-modification{\n        font-size: 12px;\n        padding: 0 8px\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table tbody tr td {\n        white-space: normal !important;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'fieldVisitText\' | translate}}"><div class="filter-div" ng-if="vm.showDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-if="vm.isCompanyAdmin"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.offices\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15" ng-hide="true"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.company\' }}</label><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-hide="true"><label class="filter-label" ng-show="vm.search.selectedCompanyList.length > 0" translate="">{{ \'manageAllEmployees.filter.office\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.departments\' }}</label><div isteven-multi-select="" input-model="vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.designations\' }}</label><div isteven-multi-select="" input-model="vm.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.shiftGroups\' }}</label><div isteven-multi-select="" input-model="vm.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.gender\' }}</label><div isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.workplace\' }}</label><div isteven-multi-select="" input-model="vm.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.status\' }}</label><div isteven-multi-select="" input-model="vm.employeeStatusList" output-model="vm.search.selectedemployeeStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByName\' }}</label> <input class="form-control" type="text" placeholder="Employee name/ID/RFID..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div></div><div class="row form-inline"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-with-icon btn-block" ng-click="vm.searchFieldVisit()" translate=""><i class="ion-search"></i>{{ \'manageAllEmployees.filter.searchButton\' }}</button></div></div></div><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="form-group has-feedback has-search mb-15"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.getFieldVisits()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div><div class="col-md-6 text-right"><a ui-sref="employees.applyFieldVisit"><button class="btn btn-md-with-icon btn-primary"><i class="ion-ios-compose"></i> <span class="ml-negative-5 pb-3" translate="">{{\'fieldVisit.applyFieldVisitButton\'}}</span></button></a></div></div><div class="row"><div class="col-md-12"><div class="btn-group special" role="group" aria-label="First group"><button type="button" class="btn btn-style text-wrap border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedApplicationType.toString() == [0,1,2,3]}" ng-click="vm.setSelectedApplicationTypes([0,1,2,3])" translate="">{{\'fieldVisit.buttons.allFieldVisits\'}}</button> <button type="button" class="btn btn-style text-wrap" ng-class="vm.selectedApplicationType.toString() == [0].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedApplicationTypes([0])" translate="">{{\'fieldVisit.buttons.pendingFieldVisits\'}}</button> <button type="button" class="btn btn-style text-wrap border-radius-0" ng-class="vm.selectedApplicationType.toString() == [1].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedApplicationTypes([1])" translate="">{{\'fieldVisit.buttons.acceptedFieldVisits\'}}</button></div></div></div><div class="text-center" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-if="vm.isDataLoaded && vm.fieldVisitData.length == 0"><p><strong translate="">{{\'fieldVisit.noResultFoundText\'}}</strong></p></div><div class="row mb-20" ng-if="vm.fieldVisitData.length > 0"><div class="col-md-12"><table class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-38"><col class="width-24"><col class="width-22"><col class="width-16"></colgroup><thead><tr class="height-5-vh"><th class="text-center" translate="">{{\'fieldVisit.employeesTableHeader.employeeName\'}}</th><th class="text-center" translate="">{{\'fieldVisit.employeesTableHeader.dateRange\'}}</th><th class="text-center" translate="">{{\'fieldVisit.employeesTableHeader.status\'}}</th><th class="text-center" translate="">{{\'fieldVisit.employeesTableHeader.action\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.fieldVisitData" class="cursor-pointer" ng-class="{\'onClick\':vm.isRowSelected && vm.selectedRowIndex == $index}"><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index, data.employeeId)"><employee-picture-and-information name="data.employeeName" picture-url="data.employeePictureUrl" department-name="data.departmentName" designation-name="!data.designationName ? \'N/A\':data.designationName" id="data.id" is-clickable="false"></employee-picture-and-information></td><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index, data.employeeId)" ng-if="!data.sameDateRange">{{data.startDate |date:\'d MMM yyyy\'}}<br>{{\'commonKeywords.smallTo\' | translate}}<br>{{data.endDate |date:\'d MMM yyyy\'}}</td><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index, data.employeeId)" ng-if="data.sameDateRange">{{data.startDate |date:\'d MMM yyyy\'}}</td><td ng-if="data.status==0" class="text-center modified-orange" translate="">{{\'commonKeywords.pending\'}}</td><td ng-if="data.status==1" class="text-center modified-green" translate="">{{\'commonKeywords.accepted\'}}</td><td ng-if="data.status==2" class="text-center modified-red" translate="">{{\'commonKeywords.rejected\'}}</td><td ng-if="data.status==3" class="text-center modified-red" translate="">{{\'commonKeywords.cancelled\'}}</td><td class="text-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openCancelManualEntryModal(data)"><i class="ion-android-delete"></i><span class="pb-2" translate="">{{\'commonKeywords.cancelButton\'}}</span></button></td></tr></tbody></table><div class="text-center" ng-if="vm.fieldVisitData.length > 0"><nav aria-label="Page navigation" class="cursor-pointer"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchFieldVisit({pageNumber:\'first\'})" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchFieldVisit({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage == $index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a class="page-link" ng-click="vm.searchFieldVisit({pageNumber:$index})">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchFieldVisit({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchFieldVisit({pageNumber:\'last\'})" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.fieldVisitData.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPaginationPage +1}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p></div></div></div></div><div class="col-md-6"><div class="row mb-15"><div class="col-md-12 d-flex-space-between"><div class="mt-10"><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</p></div></div></div><div class="position-relative"><div ng-if="vm.isAnyRowSelected && vm.isEmployeeInfoLoaded"><div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-bg th-width"><td colspan="2"><employee-picture-and-information name="vm.employeeToShow.name" picture-url="vm.employeeToShow.employeePictureUrl" department-name="vm.employeeToShow.department.name" designation-name="!vm.employeeToShow.designation ? \'N/A\':vm.employeeToShow.designation.name" id="vm.employeeToShow.id" is-clickable="true"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td class="color-22222">{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td class="color-22222">{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.workplace\'}}</td><td class="color-22222">{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'fieldVisit.applicationInfoHeader\'}}</p></div><div class="col-md-12 mt-15"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.dateRange\'}}</td><td class="dont-wrap-text color-22222" ng-if="!vm.selectedRow.sameDateRange">{{vm.selectedRow.startDate |date:\'d MMM yyyy\'}}-{{vm.selectedRow.endDate |date:\'d MMM yyyy\'}}</td><td class="dont-wrap-text color-22222" ng-if="vm.selectedRow.sameDateRange">{{vm.selectedRow.startDate |date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.reason\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedRow.reason}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.entry\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedRow.entryTime | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.exit\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedRow.exitTime | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.location\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedRow.area}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.firstApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span ng-if="vm.selectedRow.firstManualEntryApproverId != null">{{vm.selectedRow.firstManualApproverName}} (<span ng-bind-html="vm.selectedRow.firstApproverApprovalDisplayString"></span>)</span> <span ng-if="vm.selectedRow.firstManualEntryApproverId == null">{{vm.selectedRow.firstManualApproverName}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.secondApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span ng-if="vm.selectedRow.secondManualEntryApproverId != null">{{vm.selectedRow.secondManualApproverName}} (<span ng-bind-html="vm.selectedRow.secondApproverApprovalDisplayString"></span>)</span> <span ng-if="vm.selectedRow.secondManualEntryApproverId == null">{{vm.selectedRow.secondManualApproverName}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.appliedBy\'}}</td><td class="dont-wrap-text"><employee-picture-and-information name="vm.selectedRow.appliedByName" picture-url="vm.selectedRow.appliedByPictureUrl" department-name="vm.selectedRow.appliedByDepartment" designation-name="vm.selectedRow.appliedByDesignation" is-clickable="true"></employee-picture-and-information></td></tr></tbody></table><div class="text-center align-self-start" ng-if="!vm.isEmployeeInfoLoaded && vm.isEmployeeSelected"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><div ng-if="vm.isAnyRowSelected && !vm.isEmployeeInfoLoaded"><div class="text-center align-self-start"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="row mt-15" ng-if="!vm.isAnyRowSelected" ng-class="{\'unselected\': vm.isAnyRowSelected == false}" include-with-scope="app/pages/main/employees/fieldVisit/partials/dummyTable.html"></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/employees/syncExternal/syncExternal.html','<div class="row"><div class="col-md-12" ng-if="vm.loggedInUser.officeId === 79 || vm.loggedInUser.officeId === 4064 || vm.loggedInUser.officeId === 4067 || vm.loggedInUser.officeId === 4074" include-with-scope="app/pages/main/employees/syncExternal/partials/syncExternalIDLC.html"></div><div class="col-md-12" ng-if="vm.loggedInUser.officeId === 375" include-with-scope="app/pages/main/employees/syncExternal/partials/syncExternalBBL.html"></div></div>');
$templateCache.put('app/pages/main/employees/manage/employees.html','<style>\n    .item-margin-bottom{\n        margin-bottom: 15px !important;\n    }\n    .padding{\n        padding: 10px 18px;\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table tbody tr td {\n        white-space: normal !important;\n    }\n    .scrollable-table {\n        max-height: 61vh;\n        overflow: auto;\n        position: relative;\n    }\n    .min-width-100{\n        min-width: 100px;\n    }\n</style><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'manageAllEmployees.title\' | translate}} <span ng-click=\'vm.showDiv = !vm.showDiv\' class=\'filter pull-right\' ng-if=\'vm.hasPermission(2002)\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showDiv\' class=\'fa fa-chevron-up\'></i> </span>"><div class="filter-div" ng-if="vm.showDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4 item-margin-bottom" ng-if="vm.isCompanyAdmin"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.offices\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom" ng-hide="true"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.company\' }}</label><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom" ng-hide="true"><label class="filter-label" ng-show="vm.search.selectedCompanyList.length > 0" translate="">{{ \'manageAllEmployees.filter.office\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom" ng-if="vm.viewSubsidiaryFilter"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.subsidiary\' }}</label><div isteven-multi-select="" input-model="vm.subsidiaryList" output-model="vm.search.selectedSubsidiaryList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.departments\' }}</label><div isteven-multi-select="" input-model="vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.subDepartments\' }}</label><div isteven-multi-select="" input-model="vm.subDepartmentList" output-model="vm.search.selectedSubDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.designations\' }}</label><div isteven-multi-select="" input-model="vm.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.shiftGroups\' }}</label><div isteven-multi-select="" input-model="vm.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.employmentType\' }}</label><div isteven-multi-select="" input-model="vm.employmentTypeList" output-model="vm.search.selectedEmploymentTypeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.gender\' }}</label><div isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.workplace\' }}</label><div isteven-multi-select="" input-model="vm.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.status\' }}</label><div isteven-multi-select="" input-model="vm.employeeStatusList" output-model="vm.search.selectedemployeeStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByName\' }}</label> <input class="form-control" type="text" placeholder="Employee name/ID/RFID..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div><div ng-if="vm.viewSubsidiaryFilter"><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchById\' }}</label> <input class="form-control" type="text" placeholder="Employee ID..." ng-model="vm.search.searchEmployeeOfficeId" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByCentralServerID\' }}</label> <input class="form-control" type="text" placeholder="Central Server ID..." ng-model="vm.search.searchCentralServerPeopleId" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">lineManager</label><div id="lineManagerList" isteven-multi-select="" input-model="vm.lineManagerList" output-model="vm.search.selectedLineManagerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div></div></div><div class="row form-inline" ng-if="!vm.viewSubsidiaryFilter"><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchById\' }}</label> <input class="form-control" type="text" placeholder="Employee ID..." ng-model="vm.search.searchEmployeeOfficeId" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByCentralServerID\' }}</label> <input class="form-control" type="text" placeholder="Central Server ID..." ng-model="vm.search.searchCentralServerPeopleId" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div><div class="form-group col-sm-4 col-xs-4 item-margin-bottom"><label class="filter-label" translate="">lineManager</label><div id="lineManagerList" isteven-multi-select="" input-model="vm.lineManagerList" output-model="vm.search.selectedLineManagerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div></div><div class="row form-inline"><div class="form-group col-sm-8 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><button type="button" class="btn btn-md btn-primary btn-block" ng-click="vm.searchEmployees()"><i class="ion-search"></i> <span translate="">{{ \'manageAllEmployees.filter.searchButton\' }}</span></button></div></div></div><div class="row"><div class="form-group col-md-6 col-sm-7 col-xs-7"><a ui-sref="createEmployee" ng-if="!vm.isLineManager"><button type="button" class="btn btn-md-with-icon btn-primary mt-2"><i class="ion-android-checkmark-circle"></i><span class="pb-2" translate="">{{\'manageAllEmployees.createEmployeeButton\'}}</span></button></a> <button type="button" class="btn btn-md-with-icon mt-2" ng-class="{\'btn-danger\' : vm.checkbox.isAnySelected, \'btn-disable\' : !vm.checkbox.isAnySelected}" ng-disabled="vm.checkbox.isAnySelected == false" ng-if="vm.canLineManagerAssignShiftGroup" ng-click="vm.filterEmployees()"><i class="ion-hammer"></i><span class="pb-2" translate="">{{\'manageAllEmployees.employeeActionButton\'}}</span></button> <button type="button" class="btn btn-md-with-icon btn-secondary mt-2" ng-click="vm.toggleShowEnrolmentInformation()" ng-if="!vm.isCompanyAdmin && !vm.isGroupAdmin && !vm.isLineManager"><i class="ion-android-hand"></i><span class="pb-2" translate="">{{\'manageAllEmployees.showEnrolmentButton\'}}</span></button> <button class="btn btn-md-with-icon btn-primary mt-2" ng-show="vm.isEmployeeListLoaded" ng-if="vm.canLineManagerAssignShiftGroup" ng-click="vm.selectAllAndGoToEmployeeActions()"><i class="ion-android-done-all"></i> <span class="ml-negative-5 pb-2" translate="">{{\'manageAllEmployees.selectAllButton\'}}</span></button></div><div class="col-md-6 col-sm-5 col-xs-5 text-right"><div class="d-flex-gap-20 justify-end"><div class="text-right mt-2"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-md-with-icon btn-secondary padding" uib-dropdown-toggle=""><span translate="">{{\'manageAllEmployees.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div><div class="d-flex-gap-5"><span class="text-nowrap mr-5 d-flex-align-center"><strong translate="">{{\'manageAllEmployees.rowPerPageInputLabel\'}}</strong></span><div class="custom-select min-width-100 mt-2"><select ng-disabled="!vm.apiCallSuccessful" ng-model="vm.rowsToShow" ng-change="vm.searchEmployees({pageNumber:\'reset\'})" ng-class="{\'cursor-disabled\' : !vm.apiCallSuccessful}"><option value="10" ng-selected="vm.rowsToShow == 10" translate="">{{\'manageAllEmployees.selectOption.rowPerPageValue_10\'}}</option><option value="50" ng-selected="vm.rowsToShow == 50" translate="">{{\'manageAllEmployees.selectOption.rowPerPageValue_50\'}}</option><option value="100" ng-selected="vm.rowsToShow == 100" translate="">{{\'manageAllEmployees.selectOption.rowPerPageValue_100\'}}</option><option value="1000" ng-selected="vm.rowsToShow == 1000" translate="">{{\'manageAllEmployees.selectOption.rowPerPageValue_1000\'}}</option></select></div></div><div class=""><a ng-href="{{vm.excelUrl}}" target="_self"><button class="btn btn-md-with-icon btn-primary padding-6-12 mt-1 mb-1" ng-show="vm.isEmployeeListLoaded" ng-click="vm.downloadExcelAnalytics()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></a></div></div></div></div><div class="text-center" ng-show="!vm.isEmployeeListLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-30" ng-if="vm.allEmployees.length == 0"><p><strong translate="">{{\'manageAllEmployees.emptyResultText\'}}</strong></p></div><div class="horizontal-scroll scrollable-table mt-5" fixed-column-table="" fixed-columns="0"><table class="table report-table report-table-font-14" ng-show="vm.isEmployeeListLoaded" ng-if="vm.allEmployees.length > 0"><thead><tr><th class="text-center check-uncheck-all width-4"><label class="checkbox-container"><input type="checkbox" ng-model="vm.checkbox.isAllSelected" ng-click="vm.toggleAll()"> <span ng-if="vm.canLineManagerAssignShiftGroup" class="custom-checkbox checkbox-position"></span></label></th><th class="text-center" ng-if="vm.canLineManagerAssignShiftGroup" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{ \'manageAllEmployees.employeeListTableHeader.id\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.name\' }}</th><th class="text-left" translate="" ng-if="vm.isCompanyAdmin">{{ \'manageAllEmployees.employeeListTableHeader.office\' }}</th><th class="text-left" translate="" ng-if="vm.viewSubsidiaryFilter">{{ \'manageAllEmployees.filter.subsidiary\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.shiftGroup\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.employmentType\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.workplace\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.lineManager\' }}</th><th class="text-center" translate="">{{ \'manageAllEmployees.employeeListTableHeader.status\' }}</th><th class="text-center" ng-if="vm.showEnrolmentStatus" translate="">{{ \'manageAllEmployees.employeeListTableHeader.fingerprints\' }}</th><th class="text-center" ng-if="vm.showEnrolmentStatus" translate="">{{ \'manageAllEmployees.employeeListTableHeader.rfid\' }}</th></tr></thead><tbody><tr ng-repeat="item in vm.allEmployees track by item.id"><td class="text-center"><label class="checkbox-container"><input type="checkbox" ng-model="item.selected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position" ng-if="vm.canLineManagerAssignShiftGroup"></span></label></td><td class="text-center" ng-if="vm.canLineManagerAssignShiftGroup">{{(vm.rowsToShow * vm.selectedPaginationPage)+($index+1)}}</td><td class="text-center">{{item.employeeOfficeId == null? " " : item.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="item.departmentName" designation-name="!item.designationName ? \'N/A\':item.designationName" id="item.id" is-clickable="true"></employee-picture-and-information></td><td class="text-left" ng-if="vm.isCompanyAdmin">{{item.officeName}}</td><td class="text-left" ng-if="vm.viewSubsidiaryFilter">{{item.subsidiaryName}}</td><td class="text-left">{{item.shiftGroupName}}</td><td class="text-left" ng-class="!item.employmentTypeName? \'color-999999 textleft\':\'text-left\'">{{item.employmentTypeName ? item.employmentTypeName : " Not Set "}}</td><td class="text-left" ng-class="!item.workplaceName? \'color-999999 textleft\':\'text-left\'">{{item.workplaceName ? item.workplaceName : " Not Set "}}</td><td class="text-left" ng-class="!item.lineManagerId? \'color-999999 textleft\':\'text-left\'"><a ui-sref="profile({employeeId : {{item.lineManagerId}}})" ng-if="item.lineManagerId">{{item.lineManagerName}}</a><span ng-if="!item.lineManagerId" translate="">{{\'commonKeywords.notset\'}}</span></td><td class="text-center">{{vm.getStatusInText(item.status)}}<br><i ng-if=\'(item.status!=1 || item.status!=4) && item.statusRemark!=null && item.statusRemark!=""\' class="fa fa-comment-o status-remark-color">{{item.statusRemark}}</i></td><td class="text-center" ng-if="vm.showEnrolmentStatus"><div class="d-flex-center-center-inherit" ng-if="item.totalFingerprints != 0 && item.totalFingerprints"><img width="25px" class="ml-5" src="../assets/img/favicon-32x32.png" alt=""> <span>{{item.totalFingerprints}}</span></div><div ng-if="item.totalFingerprints == 0 || !item.totalFingerprints"><a ui-sref="profile({employeeId : {{item.id}}, showTab:\'enrolment\'})"><img class="filter-gray" width="25px" src="../assets/img/favicon-32x32.png" alt=""></a></div></td><td ng-if="vm.showEnrolmentStatus">{{item.rfid}}<br><i ng-if=\'(item.status!=1 || item.status!=4) && item.statusRemark!=null && item.statusRemark!=""\' class="fa fa-comment-o status-remark-color">{{item.statusRemark}}</i></td></tr></tbody></table></div><br><br><div class="text-center" ng-if="vm.allEmployees.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'first\'})" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage==$index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a ng-click="vm.searchEmployees({pageNumber:$index})">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'last\'})" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.allEmployees.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPaginationPage +1}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p><p><strong><span translate="">{{\'commonKeywords.showing\'}}</span> {{vm.getPaginationInfo()}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.total}}</strong></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/members.html','<style>\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    /*.table tbody tr td {*/\n    /*    white-space: normal !important;*/\n    /*}*/\n    .table > thead > tr > th:last-child {\n        padding-right: 0 !important;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-right: 0 !important;\n    }\n</style><div ba-panel="" ba-panel-title="Members" ba-panel-class="with-scroll"><div class="row"><div class="col-md-7"><div class="row"><div class="col-md-6"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKey" ng-keydown="$event.keyCode === 13 ? vm.searchByName(): \'\'" placeholder="{{\'membershipManagement.members.searchInputPlaceholder\' | translate}}"></div></div></div><div class="row"><div class="col-md-12" include-with-scope="app/pages/main/membershipManagement/members/partials/membersTable.html"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" not-found-text="\'No data available\'"></pagination-directive></div><div class="col-md-5"><div class="row"><div class="col-md-12 mb-5"><div class="d-flex-space-between"><div class="color-22222 font-weight-500 font-16 mt-10">{{\'commonKeywords.memberInformationHeading\' | translate}}</div><button ui-sref="membershipManagement.createMember" class="btn btn-md btn-primary">{{\'membershipManagement.members.addNewMemberButton\' | translate}}</button></div></div></div><div ng-if="vm.isAnyRowSelected && !vm.isEditBtnClicked && vm.memberInfoLoaded" include-with-scope="app/pages/main/membershipManagement/members/partials/memberInfoTable.html"></div><div ng-if="vm.isAnyRowSelected && vm.isEditBtnClicked" include-with-scope="app/pages/main/membershipManagement/members/partials/editMemberInfo.html"></div><div class="row text-center" ng-if="vm.isAnyRowSelected && !vm.memberInfoLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="row position-relative" ng-if="!vm.isAnyRowSelected && !vm.memberInfoLoaded" ng-class="{\'unselected\': vm.isAnyRowSelected == false}"><div class="col-md-12" include-with-scope="app/pages/main/membershipManagement/members/partials/dummyTable.html"></div></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected && !vm.memberInfoLoaded"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipDashboard/membershipDashboard.html','<style>\n    .content-top {\n        display: none;\n    }\n    .title-panel .panel {\n        height: 100px !important;\n    }\n    .title-panel .panel-body {\n        min-height: 100px !important;\n    }\n    .birthday-carousel {\n        position: relative;\n    }\n    .birthday-carousel .carousel-prev .carousel-btn {\n        position: absolute;\n        top: -7px;\n        right: 20px !important;\n        left: inherit;\n        color: white;\n    }\n    .birthday-carousel .carousel-next .carousel-btn {\n        position: absolute;\n        top: -7px;\n        right: -10px !important;\n        left: inherit;\n        color: white;\n    }\n    .live-attendance-feed .panel-body {\n        max-height: 800px;\n    }\n    .live-attendance-feed .panel.semi-large-panel {\n        max-height: 870px;\n    }\n\n    @media (max-width: 1800px) {\n        .font-adjust-with-screen{\n            font-size: 30px!important;\n        }\n    }\n    @media (max-width: 1655px) {\n        .font-adjust-with-screen{\n            font-size: 28px!important;\n        }\n    }\n    @media (max-width: 1570px) {\n        .font-adjust-with-screen{\n            font-size: 26px!important;\n        }\n    }\n    @media (max-width: 1485px) {\n        .font-adjust-with-screen{\n            font-size: 23px!important;\n        }\n    }\n    @media (max-width: 1360px) {\n        .font-adjust-with-screen{\n            font-size: 21px!important;\n        }\n    }\n    @media (max-width: 1300px) {\n        .font-adjust-with-screen{\n            font-size: 19px!important;\n        }\n    }\n    @media (max-width: 1199px) {\n        .font-adjust-with-screen{\n            font-size: 30px!important;\n        }\n    }\n</style><div class="row mt-20"><div class="col-lg-8" style="height: 200px"><div class="row"><div class="col-md-12"><div class="title-panel" ba-panel=""><div class="row height-full"><section class="col-md-8 height-full d-flex-align-center font-30 font-adjust-with-screen"><strong class="mr-10">MEMBER</strong> DASHBOARD {{vm.today}}</section><section class="col-md-4" ng-if="vm.isBirthdayDataLoaded && vm.birthday.length > 0"><div class="pr-10 birthday-carousel"><div class="d-flex-gap-20 justify-end"><span>Birthday Today</span><div><i class="ion-chevron-left"></i> <i class="ion-chevron-right ml-25"></i></div></div><div class="" ng-if="vm.isBirthdayDataLoaded"><ui-carousel slides="vm.birthday" slides-to-show="1" slides-to-scroll="1" initial-slide="1" autoplay="true" autoplay-speed="5000" dots="false"><carousel-item><div class="d-flex-gap-10 justify-end mt-15"><img height="30px" src="../../../../../assets/img/birthday_icon.png" alt="Birthday icon"> <span class="ml-2 cursor-pointer" ui-sref="profile({employeeId : item.employeeId})">{{item.employeeName}}</span></div></carousel-item></ui-carousel></div></div></section></div></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title=\'{{"membershipManagement.dashboard.totalMemberVisitToday" | translate}}\' ba-panel-class="semi-medium-panel with-scroll pb-15"><div class="col-12 ml-30 mr-15" include-with-scope="app/pages/main/membershipManagement/membershipDashboard/partials/pieChart/membershipDashboardPieChart.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title=\'{{"membershipManagement.dashboard.mostActiveMembers" | translate}}\' ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.isDataloaded"><list-employee all-employee-data="vm.mostActiveMembers" is-data-loaded="true" show-days="true"></list-employee></div><div class="row text-center" ng-if="!vm.isDataloaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title=\'{{"membershipManagement.dashboard.soonToBeExpired" | translate}}\' ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.isDataloaded"><list-employee all-employee-data="vm.soonToBeExpiredMembers" is-data-loaded="true" type="most-present" is-admin="false" show-days="true"></list-employee></div><div class="row text-center" ng-if="!vm.isDataloaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title=\'{{"membershipManagement.dashboard.notComingToLong" | translate}}\' ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.isDataloaded"><list-employee all-employee-data="vm.notComingForTooLongMembers" is-data-loaded="true" show-days="true"></list-employee></div><div class="row text-center" ng-if="!vm.isDataloaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div><div class="col-lg-4 live-attendance-feed"><div ba-panel="" ba-panel-title="{{\'membershipManagement.dashboard.liveAttendanceFeed\' | translate}}" ba-panel-class="semi-large-panel with-scroll feed-panel"><div class="p-all-20" ng-if="vm.isAttendanceDataLoaded"><list-employee all-employee-data="vm.attendanceDashboard" is-data-loaded="true" attendance-feed="true" live-feed="true"></list-employee></div><div class="row text-center" ng-if="!vm.isAttendanceDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/modals/generalConfirmationModal/confirmationModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6"><span translate="">{{vm.confirmationText}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipSettings/membershipSettings.html','<div ba-panel="" ba-panel-title="{{ \'membershipManagement.settings.title\' | translate }}"><div class="row mb-20"><div class="col-md-12"><div><button type="button" class="btn btn-md-with-icon btn-primary" ui-sref="membershipManagement.create"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'membershipManagement.settings.createButton\' | translate }}</span></button></div><div class="horizontal-scroll scrollable-table mt-15" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{\'membershipManagement.settings.packageName\'}}</th><th class="text-left" translate="">{{\'membershipManagement.settings.packageDuration\'}}</th><th class="text-right" translate="">{{\'membershipManagement.settings.price\'}}</th><th class="text-center width-13" translate="">actions</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="package in vm.allPackageList" class=""><td class="text-center">{{$index+1}}</td><td class="text-left">{{package.name}}</td><td class="text-left">{{package.duration}}</td><td class="text-right">{{package.price}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="membershipManagement.edit({packageInfo:package, id:$index+1})"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeletePackageModal(package.id,package.name)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/modals/reportDownloadWarningModal/reportDownloadWarning.modal.html','<style>\n    img {\n        width: 30%;\n    }\n    #footer {\n        justify-content: center;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-flex-end"><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div><div class="text-center"><img src="../assets/img/download_warning.png" class="width-20" alt="none found"></div><br><br><p class="font-16 section-header text-center color-22222"><span translate="">{{\'downloadLimitWarningModal.warningText\'}}</span></p><p class="font-14 line-height-1_6 text-center"><span translate="">{{\'downloadLimitWarningModal.contactMessage\'}}</span></p></div><div class="footer" id="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()"><span translate="">{{\'commonKeywords.okayButton\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/overtime/manageOvertime/manageOvertime.html','<style>\n    th {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        color: #209e91!important;\n    }\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .text-left-important{\n        text-align: left!important;\n    }\n    .td-padding{\n        padding: 1px 8px 3px !important;\n    }\n</style><div ba-panel="" ba-panel-title="Manage Overtime <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-hide="true"><label class="filter-label" translate="">{{\'overtime.company\'}}</label><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div><div class="form-group col-sm-4 col-xs-4" ng-hide="true"><label class="filter-label" ng-show="vm.search.selectedCompanyList.length > 0" translate="">{{\'overtime.office\'}}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'overtime.departments\'}}</label><div isteven-multi-select="" input-model="vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'overtime.shifts\'}}</label><div isteven-multi-select="" input-model="vm.shiftList" output-model="vm.search.selectedShiftList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'overtime.searchByNameID\'}}</label> <input class="form-control" type="text" placeholder="{{\'overtime.searchByNameID\' | translate}}" ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div></div><div class="row form-inline mt-20 text-center"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchEmployees()"><i class="ion-search"></i><span translate="">{{\'overtime.searchButton\'}}</span></button></div></div></div><div class="row mb-20"><div class="form-group col-sm-6 col-xs-6 mb-0"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openAllowModal()" ng-show="vm.checkbox.isAnySelected"><i class="ion-hammer"></i> <span translate="">{{\'overtime.allowOvertimeButton\'}}</span></button> <button type="button" class="btn btn-md-with-icon btn-danger ml-10" ng-click="vm.openDisallowModal()" ng-show="vm.checkbox.isAnySelected"><i class="ion-hammer"></i> <span translate="">{{\'overtime.disallowOvertimeButton\'}}</span></button></div><div class="col-md-4 col-xs-4 text-right mt-10"><span><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span></div><div class="col-md-2 col-xs-2"><select class="form-control" ng-model="vm.rowsToShow" ng-change="vm.prepareDataForPagination()"><option value="10" ng-selected="vm.rowsToShow == 10" translate="">{{\'commonKeywords.ten\'}}</option><option value="50" ng-selected="vm.rowsToShow == 50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.rowsToShow == 100" translate="">{{\'commonKeywords.hundred\'}}</option><option value="1000" ng-selected="vm.rowsToShow == 1000" translate="">{{\'commonKeywords.thousand\'}}</option></select></div></div><div class="text-center" ng-show="!vm.isEmployeeListLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><table class="table table-bordered" st-table="smartTableData" st-safe-src="vm.employeeList" ng-show="vm.isEmployeeListLoaded"><thead><tr><th><input type="checkbox" ng-model="vm.checkbox.isAllSelected" ng-click="vm.toggleAll()"></th><th translate="">{{\'commonKeywords.sl\'}}</th><th><a class="color-prime" href="" translate="">{{\'overtime.image\'}}</a></th><th translate="">{{\'commonKeywords.id\'}}</th><th><a class="color-prime" href="" ng-click="vm.sortingMethods.sortByName()" translate="">{{\'overtime.name\'}}</a></th><th><a class="color-prime" href="" ng-click="vm.sortingMethods.sortByDepartmentName()" translate="">{{\'overtime.department\'}}</a></th><th><a class="color-prime" href="" ng-click="vm.sortingMethods.sortByShiftName()" translate="">{{\'overtime.shift\'}}</a></th><th><a class="color-prime" href="" ng-click="vm.sortingMethods.sortByDesignationHierarchy()" translate="">{{\'overtime.designation\'}}</a></th><th class="thead-color" translate="">{{\'overtime.overtimeStatus\'}}</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td><input type="checkbox" ng-model="item.selected" ng-change="vm.optionToggled()"></td><td>{{$index+1}}</td><td class="td-padding"><img class="list-avatar" ng-show="item.pictureUrl && item.pictureUrl.length > 0" ng-src="{{item.pictureUrl}}"> <img class="list-avatar" ng-show="!item.pictureUrl || item.pictureUrl.length == 0" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td>{{item.employeeOfficeId}}</td><td class="text-left-important"><a ui-sref="profile({employeeId : {{item.id}}})">{{item.name}}</a></td><td>{{item.departmentName}}</td><td>{{item.shiftName}}</td><td>{{item.designationName}}</td><td>{{item.allowOvertime === true ? \'Allowed\' : \'Not Allowed\'}}</td></tr></tbody></table><div class="text-center" ng-if="vm.employeeList.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.paginateData(0)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage == $index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a ng-click="vm.paginateData($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">></a></li><li class="page-item"><a class="page-link" ng-click="vm.paginateData(vm.numberOfButtons.length-1)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.employeeList.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPaginationPage +1}} <span translate="">{{\'commonKeywords.outOf\'}}</span>{{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p><p><strong><span translate="">{{\'commonKeywords.showing\'}}</span> {{vm.getPaginationInfo()}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.allEmployees.length}}</strong></p></div></div>');
$templateCache.put('app/pages/main/overtime/monthlyReport/monthlyOvertimeSummary.html','<style>\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'overtimeSummary.title\' | translate }} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate }} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div class="mb-20"><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" type="monthly" hide-print="true" excel-url="vm.excelUrl" config="vm.filterConfig" hide-download="true"></report-filter></div><div><div class="horizontal-scroll report-container" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{\'commonKeywords.id\'}}</th><th class="text-left" translate="">{{ \'overtimeSummary.tableHeader.name\' }}</th><th class="text-left" ng-if="vm.isNotSubsidiaryAdmin" translate="">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" translate="">{{ \'overtimeSummary.tableHeader.type\' }}</th><th class="text-center" translate="">{{ \'overtimeSummary.tableHeader.totalOvertime\' }}</th><th class="text-center width-10" translate="">{{ \'overtimeSummary.tableHeader.totalApproved\' }}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded && vm.attendanceList.length > 0" ng-repeat="attendanceResponse in vm.attendanceList"><td class="text-center">{{$index+1}}</td><td class="text-center">{{attendanceResponse.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="attendanceResponse.employeeName" picture-url="attendanceResponse.pictureURL" department-name="attendanceResponse.departmentName" designation-name="!attendanceResponse.designationName ? \'N/A\':attendanceResponse.designationName" id="attendanceResponse.employeeId" is-clickable="true"></employee-picture-and-information></td><td ng-if="vm.isNotSubsidiaryAdmin">{{attendanceResponse.subsidiaryName}}</td><td class="text-center">{{attendanceResponse.designationCategoryName}}</td><td class="text-center">{{attendanceResponse.summary.totalOvertime}}</td><td class="text-center">{{attendanceResponse.summary.totalApprovedOvertime}}</td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/parkingManagement/liveFeedAndDashboard/liveFeedAndDashboard.html','<style>\n   .panel-container .panel {\n       text-align: center;\n       height: 105px;\n       width: 32.5%;\n   }\n   .panel-container h2{\n       font-size: 22px!important;\n   }\n   .panel-container h1{\n       font-weight: 700;\n       font-size: 34px!important;\n   }\n   .d-flex-space-between{\n       display: flex;\n       justify-content: space-between;\n   }\n   hr {\n       margin-top: 10px;\n       margin-bottom: 10px;\n       border: 0;\n       border-top: 1px solid #f6f6f6;\n   }\n   .min-width-185{\n       min-width: 185px;\n   }\n   .legend-red{\n       height: 8px;\n       width: 25px;\n       border-radius: 35px;\n       background: var(--color-danger);\n   }\n   .legend-olivedrab{\n       height: 8px;\n       width: 25px;\n       border-radius: 35px;\n       background: #8fb523;\n   }\n   .parking-management .panel-full-screen{\n       height: 82vh;\n   }\n   .parking-dashboard-left .panel-full-screen{\n       height: calc( 82vh - 55.74px ) !important;\n   }\n   .section-min-height{\n       min-height: 350px;\n   }\n   .parking-dashboard-right .panel-heading{\n       padding: 22px 28px 32px 22px;\n   }\n   .found-nearby {\n       background: #f5f5f5;\n       padding: 15px 15px;\n   }\n   .item {\n       height: 35px;\n       width: 165px;\n       border-radius: 3px;\n       padding: 10px 15px;\n   }\n   .border-none{\n       border: none;\n   }\n   .parking-dashboard-right-2{\n       min-height: calc(100% - 60px)!important;\n       overflow-y: auto;\n   }\n   @media (max-width: 1586px) {\n       .readjust-text{\n           font-size: 16px!important;\n       }\n       .readjust-value{\n           font-size: 17px!important;\n       }\n   }\n   @media (max-width: 1586px) {\n       .readjust-text{\n           font-size: 15px!important;\n       }\n       .readjust-value{\n           font-size: 17px!important;\n       }\n   }\n   @media (max-width: 1525px) {\n       .readjust-text{\n           font-size: 14px!important;\n       }\n       .readjust-value{\n           font-size: 15px!important;\n       }\n   }\n   @media (max-width: 1470px) {\n       .readjust-text{\n           font-size: 13px!important;\n       }\n       .readjust-value{\n           font-size: 15px!important;\n       }\n   }\n   @media (max-width: 1470px) {\n       .readjust-text{\n           font-size: 12px!important;\n       }\n       .readjust-value{\n           font-size: 14px!important;\n       }\n   }\n   @media (max-width: 1358px) {\n       .readjust-text{\n           font-size: 11px!important;\n       }\n       .readjust-value{\n           font-size: 13px!important;\n       }\n   }\n   @media (max-width: 1301px) {\n       .readjust-text{\n           font-size: 17px!important;\n       }\n       .readjust-value{\n           font-size: 14px!important;\n       }\n   }\n   .table > thead > tr > th, .table > tbody > tr > th, .table > thead > tr > td, .table > tbody > tr > td {\n       padding: 8px;\n       line-height: 1.42857143;\n       vertical-align: top;\n       border-top: 1px solid #f5f5f5;\n   }\n   .panel.with-scroll > .panel-body{\n       box-shadow: 0 0, 0 -4px 19px #f5f5f5 inset, 0 0, 0 0;\n   }\n   .parking-dashboard-right .panel-body{\n       height: calc(100% - 98px)!important;\n   }\n</style><div class="row parking-management"><div class="col-md-6 parking-dashboard-left"><div><div class="bg-white d-flex-space-between pl-22 pr-28 pt-10 pb-6 border-bottom-1 animated zoomIn"><h3 class="panel-title">{{\'parkingManagement.liveFeed\' | translate}}</h3><button class="btn btn-md btn-primary" ui-sref="parkingManagement.enterVehicle"><span translate="">{{\'commonKeywords.entryVehicle\'}}</span></button></div><div ba-panel="" ba-panel-class="with-scroll panel-full-screen"><div class="panel-container d-flex-space-between"><div class="panel bg-black white-text"><div class="panel-body"><h3 class="text-uppercase readjust-text">{{\'parkingManagement.total\' | translate}}</h3><h1 class="readjust-value">{{vm.slotInfo.totalSlots}}</h1></div></div><div class="panel bg-8fb523 white-text"><div class="panel-body"><h3 class="text-uppercase readjust-text">{{\'parkingManagement.available\' | translate}}</h3><h1 class="readjust-value">{{vm.slotInfo.availableSlots}}</h1></div></div><div class="panel bg-danger white-text"><div class="panel-body"><h3 class="text-uppercase readjust-text">{{\'parkingManagement.occupied\' | translate}}</h3><h1 class="readjust-value">{{vm.slotInfo.occupiedSlots}}</h1></div></div></div><table class="table mt-20"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr><th class="text-left">Vehicle</th><th class="text-center">Entry</th><th class="text-center">Exit</th><th class="text-left">Duration</th></tr></thead><tbody><tr ng-repeat="parkingInfo in vm.parkingInfoList"><td><div class="min-width-185"><vehicle-info-directive vehicle-number="parkingInfo.vehicleNumber" vehicle-type="1"></vehicle-info-directive></div></td><td class="vertical-align-middle"><div class="text-center"><span class="text-primary font-12">{{parkingInfo.entryTime}}</span></div></td><td class="vertical-align-middle"><div ng-if="parkingInfo.exitTime" class="text-center"><span class="text-danger font-12">{{parkingInfo.exitTime}}</span></div></td><td class="vertical-align-middle"><div class="font-weight-500 text-left"><span ng-if="!parkingInfo.exitTime" class="font-12">{{parkingInfo.timeSpent}}</span> <span ng-if="!!parkingInfo.exitTime" class="font-12">{{parkingInfo.timeSpent}}</span></div></td></tr></tbody></table></div></div></div><div class="col-md-6 parking-dashboard-right"><div ba-panel="" ba-panel-title="{{\'parkingManagement.enteredVehicles\' | translate}}" ba-panel-class="with-scroll panel-full-screen parking-dashboard-right-2"><div class="row"><div class="col-md-12"><div class="found-nearby"><div class="d-flex-space-between"><label>{{\'parkingManagement.foundNearby\' | translate}}</label> <button type="button" aria-label="Refresh" class="border-none" ng-disabled="vm.refreshEnabled" ng-click="vm.refreshNearbyExitVehicle()"><em class="ion-loop font-20"></em></button></div><div class="d-flex-gap-10 flex-wrap"><div ng-repeat="nearby in vm.foundNearbyList"><div class="d-flex-space-between cursor-pointer bg-white item" ui-sref="parkingManagement.exitVehicle({summaryId:nearby.parkingSummaryId})"><span>{{nearby.vehicleNumber}}</span> <button type="button" class="close" ng-click="vm.removeVehicle($index)" aria-label="Close"><em class="ion-ios-close-empty sn-link-close font-26"></em></button></div></div></div></div></div></div><div class="row mt-10"><div class="col-md-12"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.searchByVehicleDriverOwner()" placeholder="{{\'commonKeywords.searchByParking\' | translate}}"></div></div></div><table class="table mt-20"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr><th class="text-left">Vehicle</th><th class="text-center">Entry</th><th class="text-right">Duration</th><th class="text-center">Action</th></tr></thead><tbody><tr ng-repeat="enteredVehicle in vm.enteredVehicleList"><td><div class="min-width-185"><vehicle-info-directive vehicle-number="enteredVehicle.vehicleNumber" vehicle-type="1"></vehicle-info-directive></div></td><td><div class="font-weight-500 mt-10 text-center"><span class="font-12">{{enteredVehicle.entryTime}}</span></div></td><td><div class="font-weight-500 mt-10 text-right"><span class="font-12">{{enteredVehicle.timeSpent}}</span></div></td><td class="text-center vertical-align-middle"><button class="btn btn-md btn-danger padding-8-12" ui-sref="parkingManagement.exitVehicle({summaryId:enteredVehicle.summaryId})"><span class="font-weight-500">{{\'commonKeywords.printAndExit\' | translate}}</span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingSlotSetup/parkingSlotSetup.html','<style>\n    .edit-btn-position{\n        position: absolute;\n        top:10px;\n        right: 23px;\n    }\n    .excel-link{\n        min-width: 230px;\n    }\n    .panel-placement{\n        top:140px;\n        left: 420px\n    }\n    @media (max-width: 1495px) {\n        .btn-responsive {\n            padding:3px 5px;\n            font-size:85%;\n            line-height: 1;\n            border-radius:3px;\n        }\n        .excel-link{\n            min-width: 180px;\n        }\n        .text-adjust{\n            font-size: 15px!important;\n            padding-top: 0px !important;\n        }\n    }\n    @media (max-width: 1277px) {\n        .btn-responsive {\n            padding:1px 2px;\n            font-size:75%;\n            line-height: 1.2;\n        }\n        .excel-link{\n            min-width: 180px;\n        }\n        .text-adjust{\n            font-size: 13px;\n            padding-top: 0px !important;\n        }\n    }\n    @media (max-width: 991px) {\n        .btn-responsive {\n            padding:6px 12px;\n            font-size:100%;\n            line-height: 1;\n        }\n        .excel-link{\n            min-width: 230px;\n        }\n        .text-adjust{\n            font-size: 14px;\n            padding-top: 3px !important;\n        }\n    }\n</style><div ba-panel="" ba-panel-title="Parking Slot Setup" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-6"><button class="btn btn-md-with-icon btn-primary padding-10-12" ui-sref="parkingManagement.parkingSlotSetupCreate"><span translate="">{{\'parkingManagement.parkingSlotSetup\'}}</span></button></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row mt-20" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="horizontal-scroll scrollable-table report-container" fixed-column-table="" fixed-columns="0"><table id="column-height" class="table borderless-table odd-row-strip row-highlight"><colgroup><col class="width-10"><col class="width-70"><col class="width-20"></colgroup><thead><tr class="row-height dont-wrap-text"><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'parkingManagement.numberOfSlot\'}}</th><th class="text-center dont-wrap-text" translate="">actions</th></tr></thead><tbody><tr ng-repeat="data in vm.allData" class="cursor-pointer"><td class="dont-wrap-text">{{$index+1}}</td><td class="dont-wrap-text text-left">{{data.numberOfSlot}}</td><td class="dont-wrap-text text-center"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(data)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(data)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/vehicles.html','<style>\n    .edit-btn-position{\n        position: absolute;\n        top:10px;\n        right: 23px;\n    }\n    .excel-link{\n        min-width: 230px;\n    }\n    .panel-placement{\n        top:140px;\n        left: 420px\n    }\n    @media (max-width: 1495px) {\n        .btn-responsive {\n            padding:3px 5px;\n            font-size:85%;\n            line-height: 1;\n            border-radius:3px;\n        }\n        .excel-link{\n            min-width: 180px;\n        }\n        .text-adjust{\n            font-size: 16px!important;\n            /*padding-top: 0px !important;*/\n        }\n    }\n    @media (max-width: 1277px) {\n        .btn-responsive {\n            padding:1px 2px;\n            font-size:75%;\n            line-height: 1.2;\n        }\n        .excel-link{\n            min-width: 180px;\n        }\n        .text-adjust{\n            font-size: 13px;\n            padding-top: 0px !important;\n        }\n    }\n    @media (max-width: 991px) {\n        .btn-responsive {\n            padding:6px 12px;\n            font-size:100%;\n            line-height: 1;\n        }\n        .excel-link{\n            min-width: 230px;\n        }\n        .text-adjust{\n            font-size: 14px;\n            padding-top: 3px !important;\n        }\n    }\n</style><div ba-panel="" ba-panel-title="Vehicles" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-6"><button class="btn btn-md-with-icon btn-primary padding-10-12" ui-sref="parkingManagement.create"><span translate="">{{\'parkingManagement.registerNewVehicles\'}}</span></button></div><div class="col-md-6"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchParams.keyword" ng-keydown="$event.keyCode === 13 ? vm.searchByNameOrId(): \'\'" placeholder="{{\'commonKeywords.searchVehicle\' | translate}}"></div></div></div><div class="row"><div class="col-md-12" include-with-scope="app/pages/main/parkingManagement/vehicles/partials/ownerTable.html"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" not-found-text="\'No data available\'"></pagination-directive></div><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="d-flex-space-between"><div><p class="text-adjust font-16 pr-10 mb-30 color-22222 font-weight-500 pt-10">{{\'commonKeywords.OwnerInformationHeading\' | translate}}</p></div></div></div></div><div ng-if="vm.isAnyRowSelected && !vm.isEditBtnClicked" include-with-scope="app/pages/main/parkingManagement/vehicles/partials/ownerInfoSection.html"></div><div ng-if="vm.isAnyRowSelected && vm.isEditBtnClicked" include-with-scope="app/pages/main/parkingManagement/vehicles/partials/editOwnerInfoSection.html"></div><div class="row position-relative" ng-if="!vm.isAnyRowSelected" ng-class="{\'unselected\': vm.isAnyRowSelected == false}"><div class="col-md-12" include-with-scope="app/pages/main/parkingManagement/vehicles/partials/dummyTable.html"></div></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/comparisonReport/comparisonReport.html','<style>\n    .list-avatar{\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        float: left;\n        margin-top: 2px;\n    }\n    #pandemicReportTable{\n        white-space: nowrap !important;\n    }\n    #pandemicReportTable .headers2 td a{\n        color:white!important;\n    }\n    /*.odd-row{*/\n    /*    background-color: #f9f9f9!important;*/\n    /*}*/\n    /*.even-row{*/\n    /*    background-color: white!important;*/\n    /*}*/\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Salary Summary<span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><table class="table borderless-table odd-row-strip row-highlight"><thead><tr><th class="text-left">Component</th><th class="text-center">Month1</th><th class="text-center">Month2</th><th class="text-right">Difference</th></tr></thead><tbody><tr ng-repeat="(key, value) in vm.objectOfSalaryComponents"><td class="text-left">{{value.name}}</td><td class="text-center">{{value.totalAmountOfMonth1}}</td><td class="text-center">{{value.totalAmountOfMonth1}}</td><td class="text-right">{{value.difference}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/loanManagement/loanManagement.html','<style>\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 5px !important;\n    }\n    .summery-table > .table > tbody > tr > td:last-child{\n        padding-right: 16px !important;\n    }\n    .summery-table{\n        font-size: 13px!important;\n    }\n    .min-width-150{\n        min-width: 150px!important;\n    }\n</style><div ba-panel="" ba-panel-title="{{vm.panelTitle}}"><div class="row"><div class="col-md-5 col-lg-6"><div class="row text-center" ng-if="!vm.isFirstDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isFirstDataLoaded"><div class="col-md-6"><div class="summery-table"><table class="table table-bordered"><colgroup><col class="width-60"><col class="width-40"></colgroup><tbody><tr><td class="text-left" translate="">{{\'loanManagement.totalLoanAmount\'}}</td><td class="text-right mr-15">{{vm.totalLoanAmountOfOffice | number:2}}</td></tr></tbody></table></div></div><div class="col-md-6"><div class="summery-table"><table class="table table-bordered"><colgroup><col class="width-60"><col class="width-40"></colgroup><tbody><tr><td class="text-left" translate="">{{\'loanManagement.totalRemainingLoan\'}}</td><td class="text-right mr-15">{{vm.totalRemainingLoanOfOffice | number:2}}</td></tr></tbody></table></div></div></div><br><div class="row" ng-if="vm.isFirstDataLoaded"><div class="col-md-6"><div class="row"><div class="col-md-10"><div class="form-group has-feedback has-search placeholder-text-13"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.keyWord" ng-keydown="$event.keyCode === 13 && vm.searchWithKeyLoan()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div></div></div><div class="col-md-6"><div class="d-flex-flex-end-20"><div class="d-flex-gap-10"><label class="mt-10 font-13 font-weight-500" translate="">type</label><div class="custom-select min-width-150"><select ng-options="v.value as v.name for v in vm.loanType" ng-model="vm.selectedLoanType"></select></div></div><div><button class="btn btn-md-with-icon btn-secondary" ui-sref="payroll.addNewLoanOrSalaryAdvanceType({selectedLoanType:vm.selectedLoanType})"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-3" translate="">{{\'commonKeywords.addNewButton\'}}</span></button></div></div></div></div><div class="row" ng-if="vm.isFirstDataLoaded"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0 text-uppercase" ng-class="{\'selected-table-toggle-button\': vm.loanStatus==1}" ng-click="vm.switchTab(1)" translate="">{{\'loanManagement.activeLoans\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0 text-uppercase" ng-class="{\'selected-table-toggle-button\': vm.loanStatus==2}" ng-click="vm.switchTab(2)" translate="">{{\'loanManagement.loanRecovered\'}}</button></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded && vm.isFirstDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row mb-20" ng-if="vm.isDataLoaded" include-with-scope="app/pages/main/payroll/loanManagement/partials/employeesTable.html"></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.totalPage" number-of-buttons="vm.numberOfButtons" selected-page="vm.pageNumber" total="vm.totalLoans" is-data-loaded="vm.isDataLoaded" search-method="vm.getLoanPageSpecifiedData" not-found-text="\'No data available\'"></pagination-directive><br><br></div><div class="col-md-5 col-lg-6"><div class="row" include-with-scope="app/pages/main/payroll/loanManagement/partials/loanDetails.html"></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/payrollSettings/payrollSettings.html','<div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div ng-if="vm.isDataLoaded"><div class="row" ng-if="!!vm.isPayrollSettingsAvailable && vm.showEditPage == false" include-with-scope="app/pages/main/payroll/payrollSettings/partials/viewPayrollComponents.html"></div><div class="row" ng-if="!vm.isPayrollSettingsAvailable" include-with-scope="app/pages/main/payroll/payrollSettings/partials/setUpPayrollComponents.html"></div><div class="row" ng-if="vm.showEditPage" include-with-scope="app/pages/main/payroll/payrollSettings/partials/editPayrollComponents.html"></div></div>');
$templateCache.put('app/pages/main/payroll/payslip/payslip.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Payslip of {{vm.employeeInformation.name | translate}}"><div class="d-flex-space-between"><div class="d-flex-gap-15"><div class="filter-inline-item d-inline-block" id="employeeNameSearchBox"><label translate="">searchEmployee</label><employee-type-ahead-search keyword="vm.keyword" select-method="vm.searchByNameId"></employee-type-ahead-search></div><div><label class="text-capitalize" translate="">filters.salaryMonth</label><div class="filter-inline-item"><div class="input-group mb-0 width-80 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerSalary.format}}" datepicker-options="vm.monthPickerSalary.options" ng-model="vm.selectedMonth" is-open="vm.monthPickerSalary.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPickerSalary()"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="d-flex-gap-10" ng-show="false"><div class="filter-inline-item d-flex-align-end mb-10"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item d-flex-align-end mb-10"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsPdf(\'H\')"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div ng-if="vm.salaryBreakDown != null && vm.isDataLoaded"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">employeeId</td><td class="col-stripe-dark">{{vm.employeeInformation.employeeOfficeId}}</td><td translate="">workplace</td><td class="col-stripe-dark">{{vm.employeeInformation.workplaceName}}</td></tr><tr class="text-bold"><td translate="">employeeName</td><td class="col-stripe-dark">{{vm.employeeInformation.name}}</td><td translate="">dateOfJoining</td><td class="col-stripe-dark">{{vm.employeeInformation.dateOfJoin | date:\'dd MMM yyyy\'}}</td></tr><tr class="text-bold"><td translate="">designation</td><td class="col-stripe-dark">{{vm.employeeInformation.designationName}}</td><td translate="">paymentMethod</td><td class="col-stripe-dark"><span ng-if="vm.employeeSalary.paymentMode == 1">Bank</span> <span ng-if="vm.employeeSalary.paymentMode == 2">Cash</span> <span ng-if="vm.employeeSalary.paymentMode == 3">Cheque</span> <span ng-if="vm.employeeSalary.paymentMode == 2">Cheque & Cash</span></td></tr><tr class="text-bold"><td translate="">department</td><td class="col-stripe-dark">{{vm.employeeInformation.departmentName}}</td><td translate="">Bank Name</td><td class="col-stripe-dark">{{vm.employeeSalary.bankName}}</td></tr><tr class="text-bold"><td translate="">employmentType</td><td class="col-stripe-dark">{{vm.employeeInformation.employmentTypeName}}</td><td translate="">routingNumber</td><td class="col-stripe-dark">{{vm.employeeSalary.routingNumber}}</td></tr></tbody></table></div></div><div class="mt-15"><div><table class="table borderless-table even-row-strip"><thead><tr><th class="" translate="">earnings</th><th class="text-right width-7" translate="">amountInBDT</th></tr></thead><tbody><tr ng-repeat="data in vm.salaryBreakDown.components | filter: {category:1}:true"><td>{{data.name}}</td><td class="text-right">{{data.amount}}</td></tr><tr class="bg-61C6E4 font-weight-500"><td>Total Salary</td><td class="text-right">{{vm.getTotalSalary()}}</td></tr></tbody></table><table class="table borderless-table odd-row-strip"><thead><tr><th class="" translate="">deduction</th><th class="text-right width-7" translate="">amountInBDT</th></tr></thead><tbody><tr ng-repeat="data in vm.salaryBreakDown.components | filter: {category:-1}"><td>{{data.name}}</td><td class="text-right">{{data.amount | abs}}</td></tr><tr class="bg-F19A9A font-weight-500"><td>Total Deduction</td><td class="text-right">{{vm.getTotalDeduction()}}</td></tr></tbody></table><table class="table borderless-table mb-20"><tbody class="font-weight-500"><tr class="bg-black"><td>Net Payable</td><td class="text-right width-7">{{vm.getTotalSalary() - vm.getTotalDeduction()}}</td></tr><tr class="bg-f8f8f8"><td>Bank Payment</td><td class="text-right width-7">{{vm.employeeSalary.bankPayment}}</td></tr><tr class="bg-d3d3d3"><td>Cash Payment</td><td class="text-right width-7">{{vm.employeeSalary.cashPayment}}</td></tr></tbody></table></div></div></div><div class="text-center mt-10" ng-if="vm.salaryBreakDown == null && vm.isDataLoaded"><i>Sorry No Data Found for Given Parameters.</i></div><div ng-show="!vm.isDataLoaded" class="text-center mb-10"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryManagement/salaryManagement.html','<style>\n    .edit-btn-position{\n        position: absolute;\n        top:10px;\n        right: 23px;\n    }\n    .excel-link{\n        min-width: 230px;\n    }\n    .panel-placement{\n        top:140px;\n        left: 420px\n    }\n    @media (max-width: 1495px) {\n        .btn-responsive {\n            padding:3px 5px;\n            font-size:85%;\n            line-height: 1;\n            border-radius:3px;\n        }\n        .excel-link{\n            min-width: 180px;\n        }\n        .text-adjust{\n            font-size: 15px!important;\n            padding-top: 0px !important;\n        }\n    }\n    @media (max-width: 1277px) {\n        .btn-responsive {\n            padding:1px 2px;\n            font-size:75%;\n            line-height: 1.2;\n        }\n        .excel-link{\n            min-width: 180px;\n        }\n        .text-adjust{\n            font-size: 13px;\n            padding-top: 0px !important;\n        }\n    }\n    @media (max-width: 991px) {\n        .btn-responsive {\n            padding:6px 12px;\n            font-size:100%;\n            line-height: 1;\n        }\n        .excel-link{\n            min-width: 230px;\n        }\n        .text-adjust{\n            font-size: 14px;\n            padding-top: 3px !important;\n        }\n    }\n</style><div ba-panel="" ba-panel-title="Salary Management" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.searchByNameOrId()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div></div><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'allEmployees\'}" ng-click="vm.switchTab(\'allEmployees\')" translate="">{{\'payrollManagement.allEmployee\'}}</button> <button type="button" class="btn btn-style dont-wrap-text" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'payrollActive\' }" ng-click="vm.switchTab(\'payrollActive\')" translate="">{{\'payrollManagement.payrollActive\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'payrollInactive\'}" ng-click="vm.switchTab(\'payrollInactive\')" translate="">{{\'payrollManagement.payrollInactive\'}}</button></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/payroll/salaryManagement/partials/employeesTable.html"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.fetchSalaryManagementData" not-found-text="\'No data available\'"></pagination-directive></div><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="d-flex-space-between"><div><h3 class="text-adjust pt-10 pr-10 mb-0">{{\'commonKeywords.employeeInformationHeading\' | translate}}</h3></div><div class="excel-link text-adjust pt-10 pr-15"><div class="mr-0 float-left height-33"><img src="../assets/img/Download.png"></div><div class="ml-0 mt-3"><a class="link-btn" ng-href="{{vm.sampleExcelUrl}}" target="_self" ng-click="vm.analyticsDownloadSample()"><span translate="">{{\'payrollManagement.downloadPayrollUploadFile\'}}</span></a></div></div><div><button class="btn btn-md-with-icon btn-primary padding-7-12" ngf-select="vm.verifySelectedExcelFile($file)" ng-model="vm.file" ngf-multiple="false" ngf-accept="\'.xls,.xlsx\'"><img src="../assets/img/Upload.png"> <span class="ml-negative-5" translate="">{{\'payrollManagement.uploadPayrollInformation\'}}</span></button></div></div></div></div><div ng-if="vm.isAnyRowSelected && !vm.isEditBtnClicked" include-with-scope="app/pages/main/payroll/salaryManagement/partials/employeeInfoSection.html"></div><div ng-if="vm.isAnyRowSelected && !!vm.isEditBtnClicked" include-with-scope="app/pages/main/payroll/salaryManagement/partials/editEmployeeInfoSection.html"></div><div class="row position-relative" ng-if="!vm.isAnyRowSelected" ng-class="{\'unselected\': vm.isAnyRowSelected == false}"><div class="col-md-12" include-with-scope="app/pages/main/payroll/salaryManagement/partials/dummyTable.html"></div></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div><div class="row" ng-if="vm.isEligilbeForSalaryManagement"><div class="col-md-5 panel-placement" ba-panel=""><div class="text-center"><h2 translate="">{{\'payrollManagement.noEmployeeInTheSystem\'}}</h2><br><p>&emsp;&emsp;<span translate="">{{\'payrollManagement.textLine1\'}}</span><br><br>&emsp;&emsp;&emsp;&emsp;&emsp;<span translate="">{{\'payrollManagement.textLine2\'}}</span></p><br><br><button class="btn btn-primary text-capitalize">{{\'payrollManagement.buttonText1\'}}</button><br><br><u><a href="#"><span class="text-capitalize" translate="">{{\'payrollManagement.buttonText2\'}}</span></a></u></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryCertificate/salaryCertificate.html','<style>\n    .panel-full-screen {\n        height: 76vh;\n        position: relative;\n    }\n    .panel-bottom {\n        position: absolute;\n        top: 90%;\n        right: 4%;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Generate Certificate" ba-panel-class="with-scroll panel-full-screen"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="mb-15"><h4 class="text-bold" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</h4></div><div><div class="row"><div class="col-md-12"><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'commonKeywords.employeeNameOrId\'}}</h6><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.onEmployeeSelect()" on-select-all="vm.onEmployeeSelect()" on-select-none="vm.onEmployeeSelect()" on-reset="vm.onReset()" on-clear="vm.onEmployeeSelect()" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><div class="row"><div class="col-md-6"><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'commonKeywords.designation\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded) ? vm.employeeToShow.employee.designation.name : "N/A"}}</p></div><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'commonKeywords.workplace\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded) ? vm.employeeToShow.employee.workplace.name : "N/A"}}</p></div><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'generalInfo.joiningDate\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded && vm.employeeToShow.employee.dateOfJoin != null ) ? (vm.employeeToShow.employee.dateOfJoin | date:\'dd MMM yyyy\') : "N/A"}}</p></div><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'salaryCertificate.totalPayment\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded) ? vm.employeeToShow.totalPayment : "N/A"}}</p></div></div><div class="col-md-6"><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'commonKeywords.department\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded) ? vm.employeeToShow.employee.department.name : "N/A"}}</p></div><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'commonKeywords.employmentType\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded) ? vm.employeeToShow.employee.employmentType.name : "N/A"}}</p></div><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'payrollManagement.grossSalary\'}}</h6><p class="black-text">{{(vm.isEmployeeInfoLoaded) ? vm.employeeToShow.grossSalary : "N/A"}}</p></div></div></div></div><br><div class="mb-15"><h4 class="text-bold" translate="">{{\'salaryCertificate.signatoryInformation\'}}</h4></div><div><div class="row"><div class="col-md-12"><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'salaryCertificate.signatoryNameOrId\'}}</h6><div isteven-multi-select="" input-model="vm.signatoryList" output-model="vm.selectedSignatory" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.onSignatorySelect()" on-select-all="vm.onSignatorySelect()" on-select-none="vm.onSignatorySelect()" on-reset="vm.onReset()" on-clear="vm.onSignatorySelect()" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><div class="row"><div class="col-md-6"><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'salaryCertificate.signatoryDesignation\'}}</h6><p class="black-text">{{(vm.isSignatoryInfoLoaded) ? vm.signatoryToShow.designation.name : "N/A"}}</p></div></div><div class="col-md-6"><div class="mb-20"><h6 class="text-uppercase" translate="">{{\'salaryCertificate.signatoryDepartment\'}}</h6><p class="black-text">{{(vm.isSignatoryInfoLoaded) ? vm.signatoryToShow.department.name : "N/A"}}</p></div></div></div></div></div></div><div class="row panel-bottom" ng-if="vm.isDataLoaded"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon btn-primary pull-right" ng-click="vm.generateSalaryCertificate()"><i class="ion-aperture"></i> <span class="ml-negative-5 pb-5" translate="">{{\'salaryCertificate.generateButton\'}}</span></button></div></div></div></div><div class="col-md-6" ng-if="vm.showCertificate"><div ba-panel="" ba-panel-class="with-scroll panel-full-screen"><div class="row d-flex-center-center-inherit" ng-if="!vm.isCertificateLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isCertificateLoaded"><div class="row"><div class="col-md-12"><div id="salary-certificate"><p>{{vm.certificate.generationDate | date:\'dd MMM yyyy\'}}</p><br><p class="text-center"><strong class="text-uppercase" translate="">{{\'salaryCertificate.toWhomItMayConcern\'}}</strong></p><br><p><span translate="">{{\'salaryCertificate.textPart1\'}}</span> {{vm.certificate.employeeName}} (<span translate="">{{\'salaryCertificate.employeeId\'}}</span> {{vm.certificate.employeeOfficeId}}), <span translate="">{{\'salaryCertificate.textPart2\'}}</span> {{vm.certificate.employmentTypeName}} <span translate="">{{\'salaryCertificate.textPart3\'}}</span> {{vm.certificate.officeName}}{{(vm.certificate.dateOfJoin != null ) ? " since " + (vm.employeeToShow.employee.dateOfJoin | date:\'dd MMMM yyyy\') : ""}}. <span translate="">{{\'salaryCertificate.textPart4\'}}</span> {{vm.certificate.designationName}} <span translate="">{{\'salaryCertificate.textPart5\'}}</span> {{vm.certificate.departmentName}}. <span translate="">{{\'salaryCertificate.textPart6\'}}</span></p><br><br><p><table class="table table-bordered width-60"><colgroup><col class="width-45"><col slass="width-55"></colgroup><tr><td translate="">{{\'payrollManagement.grossSalary\'}}</td><td>{{vm.certificate.grossSalary | number : 0}}</td></tr></table></p><p><table class="table table-bordered width-60"><colgroup><col class="width-45"><col slass="width-55"></colgroup><tr><td><strong translate="">{{\'salaryCertificate.totalPayment\'}}</strong></td><td><strong>{{vm.certificate.totalPayment | number : 0}}</strong></td></tr></table></p><br><br><br><br><p><span translate="">{{\'salaryCertificate.for\'}}</span> {{vm.certificate.officeName}}<br><br><br><br>{{vm.certificate.signatoryName}}<br>{{vm.certificate.signatoryDesignationName}}<br>{{vm.certificate.signatoryDepartmentName}}</p></div></div></div><div class="row panel-bottom"><div class="col-md-12"><div class="d-flex-row-reverse-wrap-5"><button type="button" class="btn btn-md-with-icon btn-secondary" ng-click="vm.printCertificate()"><i class="ion-android-print"></i><span class="pb-2" translate="">{{\'salaryCertificate.printButton\'}}</span></button> <a ng-href="{{vm.docUrl}}" target="_self"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.analyticsDownloadDoc()"><i class="ion-archive"></i><span class="pb-2" translate="">{{\'salaryCertificate.downloadDocButton\'}}</span></button></a></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/viewOrGenerateSalary.html','<div><div class="row" ng-if="vm.showReport === false" include-with-scope="app/pages/main/payroll/viewOrGenerateSalary/partials/generateSalary.html"></div><div class="row" ng-if="vm.showReport === true" include-with-scope="app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary.html"></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/leaveApplicationDetails/leaveApplicationDetails.html','<style>\n    .employee-name{\n        margin-left: 13px;\n        margin-top: 9px;\n    }\n</style><div><div ba-panel="" ba-panel-title="{{ (\'pendingApplicationApprovals.leaveApplicationDetails.title\' | translate) + vm.applicantName}}" ba-panel-class="with-scroll"><div ng-show="!vm.allDataLoaded" class="text-center mb-10"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-show="vm.allDataLoaded" class="row mb-20"><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="mt-negative-3"><p class="font-16 color-22222 font-weight-500" translate="">{{\'pendingApplicationApprovals.applicationDetails\'}}</p></div><div class="row"><div class="col-md-12"><div><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.applicationType\'}}</td><td class="text-left">{{vm.applicationDetails.applicationEventTypeName}}</td></tr><tr><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.leaveCategory\'}}</td><td class="text-left">{{vm.applicationDetails.categoryName}}</td></tr><tr ng-if="vm.applicationDetails.applicationEventType === 1"><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.applyDate\'}}</td><td class="text-left">{{vm.applicationDetails.creationDate | date : \'d MMM yyyy\'}}</td></tr><tr ng-if="vm.applicationDetails.applicationEventType === 1"><td class="text-left" translate="">{{\'commonKeywords.dateRange\'}}</td><td class="text-left">{{vm.currentLog.startDate | date : \'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.currentLog.endDate | date : \'d MMM yyyy\'}} <span ng-if="vm.currentLog.numberOfDays == 1">(<span class="greenText"><span translate="">{{\'commonKeywords.oneDay\'}}</span></span>)</span> <span ng-if="vm.currentLog.numberOfDays == .5">(<span class="greenText"><span translate="">{{\'commonKeywords.halfDay\'}}</span></span>)</span> <span ng-if="vm.currentLog.numberOfDays > 1">(<span class="greenText">{{vm.currentLog.numberOfDays +\' days\'}}</span>)</span></td></tr><tr ng-if="vm.applicationDetails.applicationEventType === 1"><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.leaveType\'}}</td><td class="text-left">{{vm.currentLog.leaveTypeName}}</td></tr><tr ng-if="vm.currentLog.leaveType === 2 && vm.applicationDetails.applicationEventType === 1"><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.leaveHalf\'}}</td><td class="text-left">{{vm.currentLog.leaveHalfName}}</td></tr><tr ng-if="vm.applicationDetails.applicationEventType === 1"><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.reasonOfLeave\'}}</td><td class="text-left">{{vm.currentLog.reason}}</td></tr><tr><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.otherApprovalStatus\'}}</td><td class="text-left">{{vm.applicationDetails.otherApproverName}} <span ng-if="vm.applicationDetails.otherApproverStatus != null && vm.applicationDetails.otherApproverStatus === 0" class="text-warning">({{vm.applicationDetails.otherApproverStatusText}})</span> <span ng-if="vm.applicationDetails.otherApproverStatus != null && vm.applicationDetails.otherApproverStatus === 1" class="text-success">({{vm.applicationDetails.otherApproverStatusText}})</span> <span ng-if="vm.applicationDetails.otherApproverStatus != null && vm.applicationDetails.otherApproverStatus === 2" class="text-danger">({{vm.applicationDetails.otherApproverStatusText}})</span></td></tr><tr><td class="text-left" translate="">{{\'commonKeywords.appliedBy\'}}</td><td class="text-left">{{vm.applicationDetails.nameOfAppliedBy}}</td></tr><tr><td class="text-left" translate="">{{\'commonKeywords.submittedFile\'}}</td><td class="text-left" ng-if="vm.applicationDetails.fileUrl != null && vm.applicationDetails.fileUrl !== \'\'"><a ng-href="{{vm.applicationDetails.fileUrl}}" target="_self">{{vm.attachedFileName}}</a></td><td class="text-left" ng-if="vm.applicationDetails.fileUrl == null || vm.applicationDetails.fileUrl === \'\'"><i>{{vm.attachedFileName}}</i></td></tr></tbody></table></div></div></div><div class="row mt-30" ng-if="vm.applicationDetails.applicationEventType !== 1"><div class="col-md-12"><div><table class="table table-bordered"><colgroup><col class="width-30"><col class="width-35"><col class="width-35"></colgroup><thead><tr><th class="headers2 text-left" translate="">{{\'commonKeywords.details\'}}</th><th class="headers2 text-center" translate="">{{\'commonKeywords.previous\'}}</th><th class="headers2 text-center" translate="">{{\'commonKeywords.updated\'}}</th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.leaveCategory\'}}</td><td class="text-center" ng-if="!vm.previousLog"><span translate="">{{\'pendingApplicationApprovals.noPreviousLog\'}}</span></td><td class="text-center" ng-if="vm.previousLog != null">{{vm.previousLog.categoryName}}</td><td class="text-center">{{vm.currentLog.categoryName}}</td></tr><tr><td class="text-left" translate="">{{\'commonKeywords.dateRange\'}}</td><td class="text-center" ng-if="!vm.previousLog"><span translate="">{{\'pendingApplicationApprovals.noPreviousLog\'}}</span></td><td class="text-center" ng-if="vm.previousLog != null">{{vm.previousLog.startDate | date : \'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.previousLog.endDate | date : \'d MMM yyyy\'}}</td><td class="text-center">{{vm.currentLog.startDate | date : \'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.currentLog.endDate | date : \'d MMM yyyy\'}}</td></tr><tr><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.numberOfDays\'}}</td><td class="text-center" ng-if="!vm.previousLog"><span translate="">{{\'pendingApplicationApprovals.noPreviousLog\'}}</span></td><td class="text-center" ng-if="vm.previousLog != null">{{vm.previousLog.numberOfDays}}</td><td class="text-center">{{vm.currentLog.numberOfDays}}</td></tr><tr><td class="text-left" translate="">{{\'pendingApplicationApprovals.applicationDetailsTableInfo.leaveType\'}}</td><td class="text-center" ng-if="!vm.previousLog"><span translate="">{{\'pendingApplicationApprovals.noPreviousLog\'}}</span></td><td class="text-center" ng-if="vm.previousLog != null">{{vm.previousLog.leaveTypeName}}</td><td class="text-center">{{vm.currentLog.leaveTypeName}}</td></tr><tr><td class="text-left" translate="">{{\'commonKeywords.reason\'}}</td><td class="text-center" ng-if="!vm.previousLog"><span translate="">{{\'pendingApplicationApprovals.noPreviousLog\'}}</span></td><td class="text-center" ng-if="vm.previousLog != null">{{vm.previousLog.reason}}</td><td class="text-center">{{vm.currentLog.reason}}</td></tr></tbody></table></div></div></div><div class="row mt-30"><div class="col-md-12 text-right"><button class="btn btn-md btn-width-85" ng-disabled="vm.disableApproveReject" ng-class="{\'btn-danger\' : !vm.disableApproveReject, \'btn-disable\' : vm.disableApproveReject}" ng-click="vm.openLeaveRejectModal()" translate="">{{ \'pendingApplicationApprovals.rejectButton\' }}</button> <button class="btn btn-md btn-width-85" ng-disabled="vm.disableApproveReject" ng-class="{\'btn-primary\' : !vm.disableApproveReject, \'btn-disable\' : vm.disableApproveReject}" ng-click="vm.openLeaveApproveModal()" translate="">{{ \'pendingApplicationApprovals.approveButton\' }}</button></div></div></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="mt-negative-3"><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</p></div><div><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width"><td colspan="2"><div class="flex-container text-left"><div class="with-round-bg mb-0"><img class="employee-img-style" ng-if="vm.employeeProfile.employeePictureUrl" ng-src="{{vm.employeeProfile.employeePictureUrl}}"> <img class="employee-img-style" ng-if="!vm.employeeProfile.employeePictureUrl" ng-src="../assets/img/theme/no-photo.png"></div><div class="employee-name"><strong><a ui-sref="profile({employeeId : vm.employeeProfile.id})">{{vm.employeeProfile.name}}</a></strong></div></div></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.designation\'}}</td><td>{{vm.employeeProfile.designation ? vm.employeeProfile.designation.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.department\'}}</td><td>{{vm.employeeProfile.department ? vm.employeeProfile.department.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.employeeProfile.shiftGroupName}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.employeeProfile.employmentType ? vm.employeeProfile.employmentType.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.workplace\'}}</td><td>{{vm.employeeProfile.workplace ? vm.employeeProfile.workplace.name : \'Not Set\'}}</td></tr></tbody></table></div></div></div><div class="row mt-20"><div class="col-md-12"><div><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.leaveBalance\'}}</p></div><div ng-show="vm.remainingLeavesList.length > 0"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-18"><col class="width-18"><col class="width-24"></colgroup><thead><tr class="bg-prime"><th class="text-left" translate="">{{\'commonKeywords.category\'}}</th><th class="text-center" translate="">{{\'commonKeywords.total\'}}</th><th class="text-center" translate="">{{\'commonKeywords.used\'}}</th><th class="text-center" translate="">{{\'commonKeywords.remaining\'}}</th></tr></thead><tbody><tr ng-repeat="remainingLeaves in vm.remainingLeavesList"><td class="text-left">{{remainingLeaves.leaveCategoryPolicyConfig.leaveCategory.name}}</td><td class="text-center">{{remainingLeaves.total}}</td><td class="text-center">{{remainingLeaves.used}}</td><td class="text-center">{{remainingLeaves.remainingLeaveCount}}</td></tr></tbody></table></div><div class="text-center" ng-if="vm.remainingLeavesList.length === 0"><p><em translate="">{{\'pendingApplicationApprovals.unavailableLeaveBalance\'}}</em></p></div></div></div><div class="row mt-20"><div class="col-md-12"><div><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.lastFiveLeaves\'}}</p></div><div ng-show="vm.acceptedLeaveLogs.length > 0"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-30"><col class="width-30"></colgroup><thead><tr class="bg-prime"><th class="text-left" translate="">{{\'commonKeywords.dateRange\'}}</th><th class="text-center" translate="">{{\'commonKeywords.numberOfDays\'}}</th><th class="text-center" translate="">{{\'commonKeywords.category\'}}</th></tr></thead><tbody><tr ng-repeat="acceptedLeave in vm.acceptedLeaveLogs"><td class="text-left">{{acceptedLeave.startDate | date : \'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{acceptedLeave.endDate | date : \'d MMM yyyy\'}}</td><td class="text-center">{{acceptedLeave.numberOfDays}}</td><td class="text-center">{{acceptedLeave.categoryName}}</td></tr></tbody></table></div><div class="text-center" ng-if="vm.acceptedLeaveLogs.length === 0"><p><em translate="">{{\'pendingApplicationApprovals.noLeaveTaken\'}}</em></p></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/approveModal/approve.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{ \'pendingApplicationApprovals.approvalModal.modalText\' }}</p><div class="row form-group"><div class="col-md-12"><label for="name" class="text-bold" translate="">{{ \'pendingApplicationApprovals.approvalModal.commentInputLabel\' }}</label> <textarea type="text" id="name" class="form-control" ng-model="vm.comment" placeholder="{{ \'pendingApplicationApprovals.approvalModal.commentInputPlaceholder\' | translate}}">\n            </textarea></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{\'commonKeywords.approveButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/manualEntryModals/approve.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{\'pendingApplicationApprovals.approveModal.text\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.approve()" translate="">{{\'commonKeywords.approveButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/manualEntryModals/reject.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{\'pendingApplicationApprovals.rejectModal.text\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.reject()" translate="">{{\'commonKeywords.rejectButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/monthlyTimeSheetModals/approve.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{ \'pendingApplicationApprovals.timeSheet.approvalModal.text\' }}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.approve()" translate="">{{\'commonKeywords.approveButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/monthlyTimeSheetModals/reject.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{ \'pendingApplicationApprovals.timeSheet.rejectionModal.text\' }}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.reject()" translate="">{{\'commonKeywords.rejectButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/pendingApprovals/rejectModal/rejectLeave.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{ \'pendingApplicationApprovals.rejectionModal.modalText\' }}</p><div class="row form-group"><div class="col-md-12"><label for="name" class="text-bold" translate="">{{ \'pendingApplicationApprovals.rejectionModal.commentInputLabel\' }}</label> <textarea type="text" id="name" class="form-control" ng-model="vm.comment" placeholder="{{ \'pendingApplicationApprovals.rejectionModal.commentInputPlaceholder\' | translate}}">\n            </textarea></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.submit()" translate="">{{\'commonKeywords.rejectButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/attendance/attendance-report.html','<style>\n    hr {\n        margin-top: 15px;\n        margin-bottom: 20px;\n        border: 0;\n        border-top: 1px solid #ddd;\n    }\n</style><div><div include-with-scope="app/pages/main/profile/attendance/attendanceChart/chart.attendance.partial.html"></div><div id="attendance" include-with-scope="app/pages/main/profile/attendance/table/table.partial.html"></div><div include-with-scope="app/pages/main/profile/attendance/detailsAttendanceLog/details.attendance.partial.html"></div><div include-with-scope="app/pages/main/profile/attendance/fieldVisit/ProfileFieldVisit.html"></div><div include-with-scope="app/pages/main/profile/attendance/manualEntryList/manualEntryList.html"></div></div>');
$templateCache.put('app/pages/main/profile/device-permissions/device-permissions.html','<style>\n    .all-labels label{\n        color:#555555;\n        font-size: 14px;\n    }\n    \n</style><div ng-controller="DevicePermissionsCtrl as vm"><div class="all-labels" ng-if="vm.isDeviceTabVisible"><h3 class="panel-title mt-20 mb-20">{{\'profileDevicePermissions.allocatedDevicesOf\'|translate}} {{vm.employee.name}}</h3><hr><div><table class="table report-table report-table-font-14"><colgroup><col class="width-7"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{\'profile.identifier\'}}</th><th class="text-center" translate="">{{\'profile.phoneNumber\'}}</th><th class="text-left" translate="">{{\'profile.description\'}}</th><th class="text-left" translate="">{{\'profile.location\'}}</th><th class="text-center" translate="">{{\'profile.type\'}}</th><th class="text-center" translate="">{{\'profile.RFIDStatus\'}}</th><th class="text-center" translate="">{{\'profile.FingerprintStatus\'}}</th><th class="text-center" translate="">{{\'profile.FaceStatus\'}}</th></tr></thead><tbody ng-if="vm.allocatedDeviceList.length > 0 && vm.isAllocatedDeviceDataLoaded"><tr ng-repeat="device in vm.allocatedDeviceList"><td class="text-center">{{$index+1}}</td><td class="text-center"><a ui-sref="deviceDetails({deviceId:device.id})">{{device.identifier}}</a></td><td class="text-center">{{device.phoneNumber}}</td><td class="text-left">{{device.description?device.description:\'--\'}}</td><td class="text-left">{{device.location}}</td><td class="text-center">{{device.type}}</td><td class="text-center capitalize-first" ng-class="{\'text-warning\': device.rfid_status.includes(\'pending\'), \'redText\': device.rfid_status.includes(\'syncing\'),\'greenText\': device.rfid_status.includes(\'synced\') }">{{ device.rfid_status?device.rfid_status: \'-\'}}</td><td class="text-center capitalize-first" ng-class="{\'text-warning\': device.fingerprint_status.includes(\'pending\'), \'redText\': device.fingerprint_status.includes(\'syncing\'),\'greenText\': device.fingerprint_status.includes(\'synced\') }">{{device.fingerprint_status?device.fingerprint_status: \'-\'}}</td><td class="text-center capitalize-first" ng-class="{\'text-warning\': device.face_status.includes(\'pending\'), \'redText\': device.face_status.includes(\'syncing\'),\'greenText\': device.face_status.includes(\'synced\') }">{{device.face_status?device.face_status: \'-\'}}</td></tr></tbody></table><div class="row text-center" ng-if="!vm.isAllocatedDeviceDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><h3 class="panel-title mt-20 mb-20">Temporary Permission History of {{vm.employee.name}}</h3><div><table class="table report-table report-table-font-14"><colgroup><col class="width-6"><col class="width-9"><col class="width-25"><col class="width-9"><col class="width-7"><col class="width-12 p-all-0"><col class="width-12 p-all-0"></colgroup><thead><tr><th class="text-center" translate="">{{\'profile.deviceId\'}}</th><th class="text-center" translate="">{{\'profile.phoneNumber\'}}</th><th class="text-left" translate="">{{\'profile.description\'}}</th><th class="text-left" translate="">{{\'profile.location\'}}</th><th class="text-center" translate="">{{\'profile.type\'}}</th><th class="text-center" translate="">{{\'profile.startDate\'}}</th><th class="text-center" translate="">{{\'profile.endDate\'}}</th></tr></thead><tbody ng-if="vm.temporaryAllocationHistoryData.length > 0 && vm.isDataLoaded"><tr ng-repeat="allocation in vm.temporaryAllocationHistoryData"><td class="text-center"><a ui-sref="deviceDetails({deviceId:device.id})">{{allocation.deviceIdentifier}}</a></td><td class="text-center">{{allocation.device.phoneNumber?allocation.device.phoneNumber:\'--\'}}</td><td class="text-left">{{allocation.device.description?allocation.device.description:\'--\'}}</td><td class="text-left">{{allocation.device.location}}</td><td class="text-center text-capitalize">{{allocation.device.type}}</td><td class="text-center">{{allocation.allocationTime | date:\'dd MMM yyyy (hh:mm a)\'}}</td><td class="text-center">{{allocation.revocationTime | date:\'dd MMM yyyy (hh:mm a)\'}}</td></tr></tbody></table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" not-found-text="\'No temporary allocations available\'" search-method="vm.getTemporaryAllocationHistoriesOfAnEmployee"></pagination-directive></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row text-center" ng-if="vm.allocatedDeviceList.length == 0"><i translate="">profileDevicePermissions.notAllocatedInDevice</i></div><div class="row mt-20 pt-20 bg-f0f0f0"><div class="col-md-6"><h4 class="panel-title with-line" translate="">profileDevicePermissions.allocateUserToDevice</h4><div class="mb-20"><div class="mt-10"><label translate="">{{\'profile.selectADevice\'}}</label></div><div class="col-md-10 open-on-top pl-0-important"><div isteven-multi-select="" input-model="vm.deviceListForAllocation" output-model="vm.selectedDevices" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier"></div></div><div><button id="allocateToDeviceButton" class="btn btn-md btn-primary" ng-click="vm.allocateEmployee()" translate="">{{\'profile.allocateButton\'}}</button></div></div></div><div class="col-md-6"><h4 class="panel-title with-line" translate="">profileDevicePermissions.revokeUserFromDevice</h4><div class="mb-20"><div class="mt-10"><label translate="">{{\'profile.selectADevice\'}}</label></div><div class="col-md-10 open-on-top pl-0-important"><div isteven-multi-select="" input-model="vm.deviceListForRevoke" output-model="vm.selectedDevices" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier"></div></div><div><button id="revokeFromDeviceButton" class="btn btn-md btn-danger" ng-click="vm.revokeEmployee()" translate="">{{\'profile.revokeButton\'}}</button></div></div></div></div><div class="row mt-20 pt-20 bg-f0f0f0"><div class="col-md-6"><h4 class="panel-title with-line" translate="">profileAccessAreaPermission.allocateUserToAccessArea</h4><div class="mb-20"><div class="mt-10"><label translate="">{{\'profileAccessAreaPermission.selectArea\'}}</label></div><div class="col-md-10 open-on-top pl-0-important"><div isteven-multi-select="" input-model="vm.accessAreaListToAllocate" output-model="vm.selectedAccessAreaListToAllocate" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div><button id="allocateEmployeeToAccessArea" class="btn btn-md btn-primary" ng-click="vm.allocateEmployeeToAccessArea()" translate="">{{\'profile.allocateButton\'}}</button></div></div></div><div class="col-md-6"><h4 class="panel-title with-line" translate="">profileAccessAreaPermission.revokeUserFromAccessArea</h4><div class="mb-20"><div class="mt-10"><label translate="">{{\'profileAccessAreaPermission.selectArea\'}}</label></div><div class="col-md-10 open-on-top pl-0-important"><div isteven-multi-select="" input-model="vm.accessAreaListToRevoke" output-model="vm.selectedAccessAreaListToRevoke" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div><button id="revokeFromAccessAreaButton" class="btn btn-md btn-danger" ng-click="vm.revokeEmployeeFromAccessArea()" translate="">{{\'profile.revokeButton\'}}</button></div></div></div></div><div class="row pt-20 bg-f0f0f0"></div><h3 class="panel-title mt-20 mb-20" translate="">profileDevicePermissions.temporaryPermissions</h3><div class="row"><div class="col-md-3"><label translate="">{{\'commonKeywords.from\'}}</label><div class="open-on-top"><div date-range-picker="" class="form-control date-picker text-center position-relative" autocomplete="off" ng-model="vm.allocationDatePicker.fromTime" options="vm.allocationDatePicker.options"><span class="date-position-left">{{vm.allocationDatePicker.fromTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="col-md-3"><label translate="">{{\'commonKeywords.to\'}}</label><div class="pl-0 open-on-top"><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.allocationDatePicker.toTime" options="vm.allocationDatePicker.options"><span class="date-position-left">{{vm.allocationDatePicker.toTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="col-md-3"><label translate="">{{\'profile.selectDevice\'}}</label><div class="pl-0 open-on-top"><div id="temporaryDevice" isteven-multi-select="" input-model="vm.deviceListForTemporaryPermission" output-model="vm.temporarySelectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier"></div></div></div><div class="col-md-3 mt-23 mb-55"><upgrade-button code="3008"><button class="btn btn-md btn-primary ml-30 mt-negative-3" ng-click="vm.saveTemporaryAllocation()" translate="">{{\'commonKeywords.saveButton\'}}</button></upgrade-button></div></div></div></div>');
$templateCache.put('app/pages/main/profile/enrol/enrol.html','<style>\n    .width-300-px{\n        width: 300px;\n    }\n    .width-100-px{\n        width: 100px;\n    }\n    .margin-left-41{\n        margin-left: 41%;\n    }\n    #messageDiv{\n        height: 60px;\n        padding-top: 22px;\n    }\n</style><div ng-controller="EnrolCtrl as vm"><div ng-if="vm.isEnrolTabVisible"><h3 class="panel-title with-line"><span translate="">{{\'profile.enrolEmployee\'}}</span> {{vm.employee.name}}</h3><div class="row"><div id="messageDiv" ng-if="vm.messageBox != null" ng-bind-html="vm.messageBox"></div></div><div class="row mb-50" ng-if="vm.enrolMode"><div class="d-inline-block width-300-px margin-left-41"><div class="position-relative p-0-15"><div translation="{selectAll : \'Select All\', selectNone : \'None\', reset : \'Reset\', search : \'Device Identifier/Location...\', nothingSelected : \'Select A Device\'}" ng-if="vm.enrolMode" id="enrollmentDevice" isteven-multi-select="" input-model="vm.deviceList" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier" selection-mode="single" on-open="vm.onDeviceSelect()" on-close="vm.onDeviceSelect()" on-item-click="vm.onDeviceSelect()" on-select-all="vm.onDeviceSelect()" on-select-none="vm.onDeviceSelect()" on-reset="vm.onDeviceSelect()" on-clear="vm.onDeviceSelect()"></div></div></div><div ng-if="(!vm.enrolmentStarted && vm.selectedDevice.length > 0 && vm.selectedHand != \'\' && vm.selectedFinger != \'\')" class="d-inline-block width-100-px"><button class="btn btn-md btn-primary btn-block" ng-click="vm.startPersonEnrolmentOfDevice()" translate="">{{\'profile.startButton\'}}</button></div><div class="d-inline-block width-100-px" ng-if="vm.enrolmentStarted"><button class="btn btn-md btn-danger btn-block" ng-click="vm.stopEnrolmentOfDevice()" translate="">{{\'profile.stopButton\'}}</button></div></div><div class="row text-center" ng-if="vm.enrolMode == false"><div><button id="enrolNewFinger" class="btn btn-md-with-icon btn-primary" ng-click="vm.enrolNewFinger()"><i class="ion-android-hand"></i> <span class="ml-negative-5 pb-2" translate="">{{\'profile.enrolFingerButton\'}}</span></button></div></div><div class="row"><div class="col-md-6" align="center"><div id="leftHand"><img id="{{finger.hand+\'-\'+finger.finger}}" ng-src="{{(\'../assets/img/enrol/\')+ (!finger.enrolled?(finger.enrolling ? finger.hand+\'_\'+finger.finger+\'_orange.png\':\'blank_finger.png\') : finger.hand+\'_\'+finger.finger+\'_green.png\') }}" ng-class="{\'blink\': (vm.selectedHand == finger.hand && vm.selectedFinger == finger.finger && vm.enrolmentStarted == true), \'fingerprint-border blink\' : (vm.selectedDevice.length > 0 && !finger.enrolled && vm.selectedHand == \'\' && vm.selectedFinger == \'\' )}" ng-click="vm.decideEnrolmentOrDelete(finger.hand,finger.finger)" ng-repeat="finger in vm.fingerPrints.left"></div></div><div class="col-md-6" align="center"><div id="rightHand"><img id="{{finger.hand+\'-\'+finger.finger}}" ng-src="{{(\'../assets/img/enrol/\')+ (!finger.enrolled?(finger.enrolling ? finger.hand+\'_\'+finger.finger+\'_orange.png\':\'blank_finger.png\') : finger.hand+\'_\'+finger.finger+\'_green.png\') }}" ng-class="{\'blink\': (vm.selectedHand == finger.hand && vm.selectedFinger == finger.finger && vm.enrolmentStarted == true), \'fingerprint-border blink\' : (vm.selectedDevice.length > 0 && !finger.enrolled && vm.selectedHand == \'\' && vm.selectedFinger == \'\' )}" ng-click="vm.decideEnrolmentOrDelete(finger.hand,finger.finger)" ng-repeat="finger in vm.fingerPrints.right" alt="..\'assets/img/enrol/blank_finger.png"></div></div></div><div class="row mt-20"><div class="col-md-6 text-center"><p translate="">{{\'profile.leftHand\'}}</p></div><div class="col-md-6 text-center"><p translate="">{{\'profile.rightHand\'}}</p></div></div></div></div>');
$templateCache.put('app/pages/main/profile/enrol/oldEnrol.html','<div class="col-md-4"><img class="fingerprint" src="../assets/img/fingerprint.png" alt="Fingerprint"></div><div class="col-md-8"><div class="row col-md-12"><div class="col-md-3"><h4 class="align" translate="">hand</h4></div><div class="col-md-9"><select class="form-control" ng-model="vm.enrolEmployee.hand"><option value="" selected="" disabled="" hidden="">{{\'profileEnrol.selectAHand\' |translate}}</option><option value="left" translate="">left</option><option value="right" translate="">right</option></select></div></div><div class="spaceTop row col-md-12"><div class="col-md-3"><h4 class="align">Finger</h4></div><div class="col-md-9"><select class="form-control" ng-model="vm.enrolEmployee.finger"><option value="" selected="" disabled="" hidden="">Select a finger</option><option value="thumb">{{\'profileEnrol.thumb\' |translate}}</option><option value="index">{{\'profileEnrol.index\'| translate}}</option><option value="middle">{{\'profileEnrol.middle\'|translate}}</option><option value="ring">{{\'profileEnrol.ring\'| translate}}</option><option value="pinky">{{\'profileEnrol.pinky\' | translate}}</option></select></div></div><div class="spaceTop row col-md-12"><div class="col-md-3"><h4 class="align" translate="">template</h4></div><div class="col-md-9"><div class="row"><div class="col-md-8"><input class="align" type="file" ngf-select="" ng-model="vm.enrolEmployee.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.fpt\'"></div></div></div><div class="col-md-9" style="margin-top: 10px;margin-bottom: 10px"><div class="text-center" style="margin-bottom: 10px"><span style="font-size: 20px;color: #aaaaaa" translate="">or</span></div><div class="text-center"><span><b>{{\'profileEnrol.chooseAFileFromServer\'|translate}}</b></span></div><div id="fileFromServer" isteven-multi-select="" input-model="vm.enrolmentList" output-model="vm.selectedEnrolmentList" button-label="device_identifier identifier" item-label="device_identifier identifier" tick-property="ticked" output-properties="id" selection-mode="single" style="margin-top: 10px"></div></div></div><div class="spaceTop row"><div class="col-md-3"></div><div class="col-md-9"><button class="btn btn-primary btn-block" style="margin-bottom: 10px;" ng-click="vm.register()" translate="">{{\'register\'|translate}}</button></div></div><div class="row"><div class="col-md-12" ng-show="vm.enrolledFingers.length > 0"><table class="table" style="margin-bottom: 20px;margin-top: 20px"><thead><th><input type="checkbox" ng-click="vm.checkOrUncheckAll()"></th><th><strong translate="">hand</strong></th><th><strong translate="">finger</strong></th></thead><tr ng-repeat="record in vm.enrolledFingers"><td><input type="checkbox" ng-checked="record.selected" ng-model="record.selected"></td><td class="text-capitalize">{{record.hand}}</td><td class="text-capitalize">{{record.finger}}</td></tr></table></div><div class="col-md-9 col-md-offset-3" style="margin-bottom: 40px" ng-show="vm.enrolledFingers.length > 0"><button class="btn btn-danger btn-block" ng-click="vm.openDeleteModal()" translate="">delete</button></div><div class="row text-center"><div class="col-md-9" ng-show="vm.enrolledFingers.length == 0" style="margin-bottom: 50px;margin-top: 30px"><strong>{{\'profileEnrol.noEnrolmentRecordFound\' | translate}}</strong></div></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/leave.html','<style>\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 7px !important;\n    }\n    .dummy-modal-placement{\n        position: absolute;\n        top:50%;\n        left:16%;\n    }\n</style><div ng-controller="LeaveManagementCtrl as vm"><h3 class="panel-title with-line">{{\'profile.leaveDetailsOf \'|translate}} {{vm.selectedFiscalYear}} <b><i class="ion-ios-arrow-right float-right font-30 cursor-pointer" ng-click="vm.increaseOrDecreaseMonth(\'increase\')"></i></b> <b class="float-right font-18">&nbsp; {{vm.selectedFiscalYear}}&nbsp;</b> <b><i class="ion-ios-arrow-left float-right font-30 cursor-pointer" ng-click="vm.increaseOrDecreaseMonth(\'decrease\')"></i></b></h3><div class="row"><div class="col-md-6 col-xs-12"><div class="row"><div class="col-md-12"><a><button class="btn btn-md-with-icon btn-primary" ng-disabled="!vm.isLeaveAllowed" ng-click="vm.openApplyForLeaveModal()"><i class="ion-ios-compose"></i> <span class="ml-negative-5 pb-3" translate="">{{\'profile.ApplyForLeaveButton\'}}</span></button></a></div></div></div><div class="col-md-6 col-xs-12 mt-25"><div class="row"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'profile.leaveBalanceHeading\'}}</p></div></div></div></div><div class="row"><div class="col-md-6 col-sm-12"><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedLeaveApplicationStatuses.toString() == [0,1,2,3]}" ng-click="vm.setSelectedLeaveApplicationStatuses([0,1,2,3])" translate="">{{\'applyLeave.allLeaves\'}}</button> <button type="button" class="btn btn-style dont-wrap-text" ng-class="vm.selectedLeaveApplicationStatuses.toString() == [0].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedLeaveApplicationStatuses([0])" translate="">{{\'applyLeave.pendingLeaves\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="vm.selectedLeaveApplicationStatuses.toString() == [1].toString() ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedLeaveApplicationStatuses([1])" translate="">{{\'applyLeave.approvedLeaves\'}}</button></div></div></div><div class="row"><div class="col-md-12"><table id="column-height" class="table borderless-table odd-row-strip row-highlight" ng-if="vm.allLeaveApplicationData.totalRecords > 0 && vm.isDataLoaded"><colgroup><col class="width-24"><col class="width-24"><col class="width-20"><col class="width-15"><col class="pl-0 pr-0 ml-0 mr-0"></colgroup><thead><tr class="dont-wrap-text height-5-vh"><th class="text-left dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.category\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'profile.applicationType\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.dateRange\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.status\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'applyLeave.applyLeaveTableHeader.action\'}}</th></tr></thead><tbody><tr class="row-height dont-wrap-text cursor-pointer" ng-if="vm.allLeaveApplicationData.totalRecords > 0" ng-class="{\'onClick\':vm.isRowSelected && vm.selectedRow == $index}" ng-repeat="data in vm.allLeaveApplicationData.leaveLogList"><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-left dont-wrap-text">{{data.categoryName}}</td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-center dont-wrap-text">{{data.applicationEventTypeName}}</td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-center dont-wrap-text">{{data.startDate | date:\'d MMM yyyy\'}}<br><span ng-if="data.numberOfDays > 1">{{\'commonKeywords.smallTo\' | translate}}<br>{{data.endDate | date:\'d MMM yyyy\'}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-center dont-wrap-text" ng-if="data.status==0"><span class="text-warning">{{data.statusText}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-center dont-wrap-text" ng-if="data.status==1"><span class="text-success">{{data.statusText}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-center dont-wrap-text" ng-if="data.status==2"><span class="text-danger">{{data.statusText}}</span></td><td ng-click="vm.showDetailedLeaveInfoInTheRightColumn($index,data.id)" class="text-center dont-wrap-text" ng-if="data.status==3"><span class="">{{data.statusText}}</span></td><td class="dont-wrap-text text-center"><div ng-if="vm.isEligibleForModification(data.categoryId)"><div class="mb-3" ng-if="data.applicationEventType == 1 && (data.status !==2 && data.status !==3)"><button class="btn btn-sm-with-icon btn-info" ng-click="vm.openAdjustModal($index)"><i class="ion-android-options"></i><span class="pb-2" translate="">{{\'commonKeywords.adjust\'}}</span></button></div><div ng-if="(data.applicationEventType == 1 || data.applicationEventType== 2) && (data.status !==2 && data.status !==3)"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openCancelModal($index)"><i class="ion-android-delete"></i><span class="pb-2" translate="">{{\'commonKeywords.cancel\'}}</span></button></div></div><div ng-if="!vm.isEligibleForModification(data.categoryId) || data.applicationEventType== 3"><span translate="">{{\'applyLeave.noActionAvailable\'}}</span></div></td></tr></tbody></table><div class="text-center mt-20" ng-if="vm.isDataLoaded && vm.allLeaveApplicationData.totalRecords == 0"><h4><em translate="">{{\'applyLeave.noResultsToBeShown\'}}</em></h4></div><div class="row align-items-center"><div class="col-md-12 col-sm-6" ng-if="!vm.allLeaveApplicationData.totalRecords > 0 && !vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.allLeaveApplicationData.totalRecords > 0 && vm.isDataLoaded"><div class="col md-6"><div class="text-center"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'first\'})" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage == $index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:$index})">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchLeaveApplicationRecord({pageNumber:\'last\'})" translate="">{{\'commonKeywords.first\'}}</a></li></ul></nav></div></div></div></div></div></div><div class="col-md-6 col-sm-12 position-relative"><div class="row"><div class="col-md-12 col-sm-12"><upgrade-banner code="6009"><div class="text-center align-self-start" ng-show="!vm.isRemainingLeaveDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-show="vm.isRemainingLeaveDataLoaded"><div><div class="text-center" ng-show="vm.remainingLeavesList.length === 0" translate="">{{\'profileLeave.noLeavePolicyOrApproverAssigned\'}}</div><table class="table table-bordered" ng-show="vm.remainingLeavesList.length > 0"><thead><tr class="th-bg"><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.category\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.total\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.used\'}}</th><th class="text-center" translate="">{{\'profileLeave.remainingLeaves\'}}</th></tr></thead><tbody><tr ng-repeat="remainingLeaves in vm.remainingLeavesList"><td>{{remainingLeaves.leaveCategoryPolicyConfig.leaveCategory.name}}</td><td class="text-center color-22222">{{remainingLeaves.total}}</td><td class="text-center color-22222">{{remainingLeaves.used}}</td><td class="text-center color-22222">{{remainingLeaves.remainingLeaveCount}}</td></tr></tbody></table></div></div></upgrade-banner></div></div><div class="position-relative" ng-if="(vm.selectedLeaveApplication.applicationEventType == 2) && vm.isAdjustDataLoded" ng-class="{\'unselected\': vm.isRowSelected == false}"><div class="row mt-10"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationAdjust.html"></div></div><div class="row mt-40"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationAdjustDifferenceTable.html"></div></div></div><div ng-if="!vm.isRowSelected" class="position-relative" ng-class="{\'unselected\': vm.isRowSelected == false}"><div class="row mt-10"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationAdjust.html"></div></div><div class="row mt-40"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationAdjustDifferenceTable.html"></div></div></div><div class="row" ng-if="(vm.selectedLeaveApplication.applicationEventType == 3 || vm.selectedLeaveApplication.applicationEventType == 1 )" ng-class="{\'unselected\': vm.isRowSelected == false}" style="position: relative"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/profile/leave/partials/leaveInformationApplyAndCancel.html"></div></div><div class="row" ng-if="!vm.isRowSelected" include-with-scope="app/pages/main/profile/leave/partials/dummyModal.html"></div><div class="row align-items-center" ng-if="vm.isRowSelected && !vm.isAdjustDataLoded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div><br><br></div>');
$templateCache.put('app/pages/main/profile/payroll/payroll.html','<div class="row"><div class="col-md-6 mb-30"><div class="pl-25 mb-20 bg-f8f8f8 mt-negative-15 pb-15"><h3 class="ml-15 pt-25 panel-title">{{\'profilePayroll.paymentDetails\' | translate}}</h3><hr class="mr-25"><form novalidate="" autocomplete="off"><div class="col-md-12 row mt-10"><div><div class="col-md-12 mb-10"><div class="form-group"><label translate="">{{\'profilePayroll.paymentMode\'}}</label><div class="custom-select"><select ng-model="vm.paymentMode" ng-options="item.name as item.name for item in vm.paymentModeList"></select></div></div><div class="row mt-10"><div class="col-md-4"><label translate="">{{\'profilePayroll.grossSalary\'}}</label> <input type="text" class="form-control" ng-model="vm.grossSalary"></div><div class="col-md-4" ng-if="vm.paymentMode==\'Bank\' || vm.paymentMode ==\'Bank & Cash\'|| vm.paymentMode==\'Cheque\'"><label translate="">{{\'profilePayroll.bankPayment\'}}</label> <input type="text" class="form-control" ng-model="vm.bankPayment"></div><div class="col-md-4" ng-if="vm.paymentMode==\'Cash\' || vm.paymentMode ==\'Bank & Cash\' || vm.paymentMode==\'Cheque\'"><label translate="">{{\'profilePayroll.cashPayment\'}}</label> <input type="text" class="form-control" ng-model="vm.cashPayment"></div></div><div class="row mt-10"><div class="col-md-6"><div class="form-group"><label translate="">{{\'profilePayroll.bankName\'}}</label><div class="custom-select"><select ng-model="vm.bankId" ng-options="item.bankId as item.bankName for item in vm.bankList"><option value="">Please Select</option></select></div></div></div><div class="col-md-6"><div class="col-md-12"><label translate="">{{\'profilePayroll.routingNumber\'}}</label><div class="custom-select"><select ng-model="vm.routingNumber" ng-options="item.routingNumber as item.routingNumber for item in vm.bankList | filter:{bankId:vm.bankId}"><option value="">Please Select</option></select></div></div></div></div><div class="row"><div class="col-md-12"><label translate="">{{\'profilePayroll.accountNumber\'}}</label> <input type="text" class="form-control" placeholder="Add Account Number" ng-model="vm.accountNumber"></div></div></div></div><div class="col-md-12 mt-20"><button type="button" class="btn btn-md-with-icon btn-primary pull-right" ng-click="vm.postPaymentDetails()"><span translate="">{{"commonKeywords.saveButton"}}</span></button></div></div><div class="row"></div></form></div><div class="pl-25 mt-20 bg-f8f8f8 pb-15"><div class="pt-15"><h3 class="ml-15 pt-15 panel-title">{{\'profilePayroll.salaryDetails\' | translate}}</h3><hr class="mr-25"></div><div class="pl-15 pr-45"><table class="table borderless-table even-row-strip"><colgroup><col class="width-78"><col class="width-22"></colgroup><thead><tr><th class="text-left" translate="">{{\'profilePayroll.salaryComponents\'}}</th><th class="text-center" translate="">{{\'profilePayroll.amount\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.salaryDetails" class="border-bottom-1"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.amount}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/main/profile/overtime/profile-overtime-table.html','<style>\n    @media only screen and (max-width: 414px) and (min-width:360px)  {\n\n        #profile-attendance-table-button{\n            margin-top: 5px!important;\n        }\n        #date-range-display{\n            text-align: left!important;\n        }\n    }\n</style><div ng-controller="ProfileOvertimeTableCtrl as vm"><h3 class="with-line" translate="">{{\'profile.overtimeReportOf\'}} {{vm.employeeName}}</h3><div class="row"><div class="col-xs-0 col-md-1"></div><div class="col-xs-12 col-md-3 ml-20 text-right pt-2" id="date-range-display"><h4 translate="">{{\'commonKeywords.dateRange\'}}</h4></div><div class="col-xs-12 col-md-4"><input date-range-picker="" class="form-control modified-input-box text-center" type="text" ng-model="vm.attendancedatePicker.date" options="vm.attendancedatePicker.options"></div><div class="col-xs-12 col-md-2" id="profile-attendance-table-button"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.getAttendanceTableData()"><i class="ion-search"></i><span translate="">{{\'commonKeywords.searchButton\'}}</span></button></div></div><br><br><div class="row text-right mb-20"><div class="col-md-12 col-xs-12"><a ng-href="{{vm.excelUrl}}" target="_self"><button class="btn btn-primary" id="exportToExcel"><i class="ion-clipboard"></i> <span translate="">{{\'commonKeywords.excelButton\'}}</span></button></a></div></div><table class="table table-bordered attendanceTable"><thead><th class="headers2" translate="">{{\'profile.date\'}}</th><th class="headers2" translate="">{{\'profile.overtime\'}}</th></thead><tbody><tr ng-repeat="attendance in vm.attendances"><td ng-class="($index % 2 == 0?\'present-shadow\':\'\')" translate="">{{attendance.date}}</td><td ng-class="($index % 2 == 0?\'present-shadow\':\'\')" translate="">{{attendance.overtime}}</td></tr><tr><td class="greenText" translate="">{{\'profile.total\'}}</td><td>{{vm.summary.totalOvertime}}</td></tr></tbody></table><br><div class="text-center" ng-if="vm.allAttendanceData.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.showChunks(0)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPage == $index)? \'active\':\'\'" ng-if="vm.selectedPage <= 2 ? $index <= 5 : (vm.selectedPage <= vm.numberOfButtons.length && vm.selectedPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPage - 2 && $index <= vm.selectedPage + 3)"><a ng-click="vm.showChunks($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">></a></li><li class="page-item"><a class="page-link" ng-click="vm.showChunks(vm.numberOfButtons.length-1)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.allAttendanceData.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPage +1}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p></div><br></div>');
$templateCache.put('app/pages/main/profile/pendingApprovals/pendingApprovals.html','<style>\n    .color-override span{\n        color:#EE9F18!important;\n    }\n</style><h3 class="panel-title with-line" translate="">profilePendingApprovals.pendingLateApprovalRequests</h3><div class="row"><div class="col-md-12"><div><table class="table borderless-table odd-row-strip"><colgroup><col class="width-10"><col class="width-6"><col class="width-6"><col class="width-18"><col class="width-15"><col class="width-15"><col class="width-10"><col class="width-10"></colgroup><thead><tr><th class="headers2 text-left" translate="">date</th><th class="headers2 text-center" translate="">entryTime</th><th class="headers2 text-center" translate="">lateBy</th><th class="headers2 text-left" translate="">reason</th><th class="headers2 text-center" translate="">approvalOne</th><th class="headers2 text-center" translate="">approvalTwo</th><th class="headers2 text-center" translate="">status</th><th class="headers2 text-center" translate="">action</th></tr></thead><tbody ng-if="vm.isLateApprovalDataLoaded && vm.lateApprovalApplications.length > 0"><tr ng-repeat="late in vm.lateApprovalApplications"><td class="text-left">{{late.attendanceDate | date:\'dd MMM yyyy\'}}<br></td><td class="text-center">{{late.attendanceTime | date:\'hh:mm a\'}}</td><td class="text-center">{{late.lateBy}}</td><td class="text-left">{{late.reason}}</td><td class="text-center">{{late.firstApproverName}}<br><span class="color-override" ng-bind-html="late.firstApprovalDisplayString"></span><br><em>{{late.firstApprovalComment}}</em></td><td class="text-center">{{late.secondApproverName}}<br><span class="color-override" ng-bind-html="late.secondApprovalDisplayString"></span><br><em>{{late.secondApprovalComment}}</em></td><td ng-if="late.status==0" class="text-center orange-text" translate="">pending</td><td ng-if="late.status==1" class="text-center green-text" translate="">accepted</td><td ng-if="late.status==2" class="text-center red-text" translate="">rejected</td><td ng-if="late.status==3" class="text-center deep-red-text" translate="">cancelled</td><td class="text-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openLateCancelModal(late)"><i class="ion-android-delete"></i><span class="pb-2" translate="">{{\'commonKeywords.cancelButton\'}}</span></button></td></tr></tbody></table></div><div ng-show="!vm.isLateApprovalDataLoaded" class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isLateApprovalDataLoaded && vm.lateApprovalApplications.length == 0"><p class="text-center mt-10" translate="">profilePendingApprovals.noLateRequests</p></div></div></div><h3 class="panel-title with-line" translate="">profilePendingApprovals.pendingManualEntryRequests</h3><div class="row mb-15"><div class="col-md-12"><div><table class="table borderless-table odd-row-strip"><colgroup><col class="width-11"><col class="width-7"><col class="width-7"><col class="width-20"><col class="width-10"><col class="width-15"><col class="width-15"><col class="width-10"></colgroup><thead><tr><th class="text-left" translate="">date</th><th class="text-center" translate="">entryTime</th><th class="text-center" translate="">exitTime</th><th class="text-left" translate="">reason</th><th class="text-left" translate="">type</th><th class="text-center" translate="">manualEntryFirstApprover</th><th class="text-center" translate="">manualEntrySecondApprover</th><th class="text-center" translate="">actions</th></tr></thead><tbody ng-if="vm.isManualEntryDataLoaded && vm.manualEntryApplications.length > 0"><tr ng-repeat="application in vm.manualEntryApplications"><td class="text-left">{{application.startDate | date :\'dd MMM yyyy\'}} <span ng-if="application.startDate !== application.endDate"><br><span translate="">{{\'commonKeywords.smallTo\'}}</span><br>{{application.endDate | date :\'dd MMM yyyy\' }}</span></td><td class="text-center">{{application.entryTime | date :\'hh:mm a\'}}</td><td class="text-center" ng-if="application.exitTime != null">{{application.exitTime | date :\'hh:mm a\'}}</td><td class="text-center" ng-if="!application.exitTime" translate="">{{\'--\'}}</td><td class="text-left">{{application.reason}}</td><td class="text-left">{{application.typeText}}</td><td class="text-center">{{application.firstManualEntryApproverName}}<br ng-if="application.firstManualEntryApproverName"><span ng-bind-html="application.firstManualEntryApprovalDisplayString"></span><br><em>{{application.firstManualEntryApproverComment}}</em></td><td class="text-center">{{application.secondManualEntryApproverName}}<br ng-if="application.secondManualEntryApproverName"><span ng-bind-html="application.secondManualEntryApprovalDisplayString"></span><br><em>{{application.secondManualEntryApproverComment}}</em></td><td class=\'text-center"\'><div class="d-flex-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-if="application.type !== 3" ng-click="vm.openEditManualEntryModal(application)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-disable" ng-if="application.type === 3" disabled="" ng-click="vm.openEditManualEntryModal(application)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openCancelManualEntryModal(application)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.cancelButton\'}}</span></button></div></td></tr></tbody></table></div><div ng-show="!vm.isManualEntryDataLoaded" class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isManualEntryDataLoaded && vm.manualEntryApplications.length == 0"><p class="text-center mt-10" translate="">profilePendingApprovals.noManualEntryRequests</p></div></div></div>');
$templateCache.put('app/pages/main/profile/perEmployeeTimeSheetReport/report.html','<style>\n    .panel .panel-body{\n        min-height: 400px;\n    }\n</style><div ng-controller="PerEmployeeTimeSheetReportCtrl as vm"><div class="row"><div class="col-md-12 col-xs-12 col-sm-12"><span ng-click="vm.toggleShowFilters()" class="filter pull-right" translate="">{{\'commonKeywords.filter\'}} <i class="fa fa-filter filter-width-20"></i> <i ng-if="!vm.showFilters" class="fa fa-chevron-down"></i> <i ng-if="vm.showFilters" class="fa fa-chevron-up"></i></span></div></div><div class="row"><div class="col-md-12 col-xs-12 col-sm-12"><div ng-show="vm.showFilters" class="filter-div"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-if="type == null"><label class="filter-label" translate="">date</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'commonKeywords.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" on-item-click="vm.getAllTasks()" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'commonKeywords.task\'}}</label><div isteven-multi-select="" input-model="vm.allTasks" output-model="vm.selectedTask" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><div class="row form-inline mt-10"><div class="form-group col-sm-2 col-xs-2 pull-right"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.getReport()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div></div></div><div class="row" ng-if="vm.showTimesheetReport"><div class="col-sm-12 col-md-12 col-xs-12"><div><div class="row mb-20"><div class="col-md-6"></div><div id="attendanceTableRowsPerPageDiv" class="col-md-4 text-right mt-10"><span id="attendanceTableRowsPerPageSpan"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span></div><div class="col-md-2"><div class="custom-select"><select ng-model="vm.perPage" ng-change="vm.getReport()"><option value="2" ng-selected="vm.perPage==2" translate="">{{\'commonKeywords.two\'}}</option><option value="5" ng-selected="vm.perPage==5" translate="">{{\'commonKeywords.five\'}}</option><option value="10" ng-selected="vm.perPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.perPage==20" translate="">{{\'commonKeywords.twenty\'}}</option><option value="50" ng-selected="vm.perPage==50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.perPage==100" translate="">{{\'commonKeywords.hundred\'}}</option></select></div></div></div><table class="table report-table report-table-font-14"><thead><tr><th translate="">date</th><th translate="">Project</th><th translate="">Task</th><th translate="">Start</th><th translate="">End</th><th translate="">Total Time</th><th translate="">Description</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat-start="date in vm.dates"><td rowspan="{{vm.report[date].length + 1}}">{{date}}</td></tr><tr ng-repeat="data in vm.report[date]" ng-repeat-end=""><td>{{data.projectWorkName}}</td><td>{{data.taskName}}</td><td>{{data.startTime}}</td><td>{{data.endTime}}</td><td>{{data.totalTime}}</td><td>{{data.description}}</td></tr></tbody></table><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center" ng-if="vm.totalData > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="cursor-pointer" ng-click="vm.getData(vm.perPage, 1)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="cursor-pointer" ng-click="vm.getScheduledAllocations(vm.perPage, vm.pageNo-1 > 0? vm.pageNo-1 : 1)">&lt;</a></li><li ng-repeat="n in vm.pageButtons" ng-class="(vm.pageNo == n)? \'active\':\'\'"><a ng-click="vm.getData(vm.perPage, n)">{{n}}</a></li><li class="page-item"><a class="cursor-pointer" ng-click="vm.getData(vm.perPage, vm.pageNo+1 > vm.totalPages? vm.totalPages: vm.pageNo+1)">&gt;</a></li><li class="page-item"><a class="cursor-pointer" ng-click="vm.getData(vm.perPage, vm.totalPages)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center" ng-if="vm.totalData === 0 && vm.isDataLoaded"><p class="mt-10 text-bold" translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</p></div><div class="text-center mt-10" ng-if="vm.totalData > 0"><p><strong>{{\'commonKeywords.showingPage\' | translate}} {{vm.pageNo}} <span>{{\'commonKeywords.outOf\' | translate}}</span> {{vm.totalPages}} <span>{{\'commonKeywords.pages\' | translate}}</span></strong></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/profileInfo.html','<div class="row"><div class="col-md-3"><div include-with-scope="app/pages/main/profile/profileInfo/details/details.partial.html"></div></div><div class="col-md-6 pr-0"><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/infoContainer.partial.html"></div></div><div class="col-md-3"><div include-with-scope="app/pages/main/profile/profileInfo/actions/actions.partial.html"></div></div></div>');
$templateCache.put('app/pages/main/profile/roster/roster.html','<style>\n    .scrollable-table {\n        max-height: 60vh;\n        overflow: auto;\n        position: relative;\n    }\n</style><div ng-controller="ProfileRosterCtrl as vm"><h3 class="panel-title with-line">{{\'profileRoster.timingDetailsOf \'|translate}} {{vm.date | date:\'MMMM\'}} {{vm.date | date:\'yyyy\'}} <b><i class="ion-ios-arrow-right float-right font-30 cursor-pointer" ng-click="vm.increaseOrDecreaseMonth(\'increase\')"></i></b> <b class="float-right font-18">&nbsp;{{vm.date | date:\'MMMM\'}} {{vm.date | date:\'yyyy\'}}&nbsp;</b> <b><i class="ion-ios-arrow-left float-right font-30 cursor-pointer" ng-click="vm.increaseOrDecreaseMonth(\'decrease\')"></i></b></h3><div class="row mb-20"><div class="col-md-6"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-left" translate="">date</th><th class="text-center" translate="">shift</th><th class="text-center" translate="">timing</th></tr></thead><tbody><tr ng-repeat="roster in vm.rosters" ng-if="vm.rosters.length > 0 && $index < 15 && vm.isDataLoaded"><td class="text-left">{{roster.day | date : "dd MMM yyyy(EEE)"}}</td><td ng-if="!roster.isOffDay" class="text-center">{{roster.shiftName}}</td><td ng-if="roster.isOffDay" class="text-center"><span class="green-text"><b translate="">{{\'profile.offDay\'}}</b></span></td><td class="text-center">{{roster.startTime | date :"shortTime"}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{roster.endTime | date :"shortTime"}}</td></tr></tbody></table></div><div class="text-center" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="col-md-6"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-left" translate="">date</th><th class="text-center" translate="">shift</th><th class="text-center" translate="">timing</th></tr></thead><tbody><tr ng-repeat="roster in vm.rosters" ng-if="vm.rosters.length > 0 && $index > 14 && vm.isDataLoaded"><td class="text-left">{{roster.day | date : "dd MMM yyyy(EEE)"}}</td><td ng-if="!roster.isOffDay" class="text-center">{{roster.shiftName}}</td><td ng-if="roster.isOffDay" class="text-center"><span class="green-text"><b translate="">{{\'profile.offDay\'}}</b></span></td><td class="text-center">{{roster.startTime | date :"shortTime"}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{roster.endTime | date :"shortTime"}}</td></tr></tbody></table></div><div class="text-center" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/profile/wage/wage.html','<h3 class="with-line">Wage Information</h3>');
$templateCache.put('app/pages/main/projectManagement/clients/clients.html','<style>\n    .item-margin-bottom{\n        margin-bottom: 15px !important;\n    }\n    .padding{\n        padding: 10px 18px;\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table tbody tr td {\n        white-space: normal !important;\n    }\n    .scrollable-table {\n        max-height: 61vh;\n        overflow: auto;\n        position: relative;\n    }\n    .min-width-100{\n        min-width: 100px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'projectClients.panelTitle\' | translate }} <span ng-click=\'vm.showFilterDiv = !vm.showFilterDiv\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilterDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilterDiv\' class=\'fa fa-chevron-up\'></i> </span>" class="position-relative"><div class="filter-div" ng-if="vm.showFilterDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projectClients.filter.organisationTypes\' }}</label><div isteven-multi-select="" input-model="vm.organisationTypes" output-model="vm.search.selectedOrganisationTypes" button-label="name" item-label="name" tick-property="ticked" output-properties="id" helper-elements="all filter none"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projectClients.filter.kams\' }}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.search.selectedEmployees" button-label="name" item-label="name" tick-property="ticked" output-properties="id" helper-elements="all filter none"></div></div></div><div class="row form-inline"><div class="form-group col-sm-9 col-xs-3"></div><div class="col-sm-3 col-xs-3 my-12 d-flex justify-end"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchFromTheBeginningOfPagination()"><i class="ion-search"></i><span translate="">{{ \'projectClients.searchButton\' }}</span></button></div></div></div><div class="row"><div class="col-md-8"><div class="d-flex-space-between d-flex-align-center"><div class="filter-inline-item width-100 d-flex-flex-start-gap-10"><div class="width-35"><div class="form-group has-feedback resize-placeholder"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.search.keyword" ng-keydown="$event.keyCode === 13 && vm.searchFromTheBeginningOfPagination()" placeholder="{{\'projectClients.filter.searchInputPlaceholder\' | translate}}"></div></div><div><div class="filter-inline-item text-right min-height-33"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div></div></div></div><div class="col-md-4 text-right"><div><button class="btn btn-md btn-primary" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-primary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.goToClientCreationPage()"><span class="ml-negative-5 pb-3" translate="">{{\'projectClients.createButton\'}}</span></button></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-left" translate="">{{\'projectClients.table.headers.clientName\'}}</th><th class="text-left" translate="">{{\'projectClients.table.headers.contactPerson\'}}</th><th class="text-center" translate="">{{\'projectClients.table.headers.contactNumber\'}}</th><th class="text-left" translate="">{{\'projectClients.table.headers.contactEmail\'}}</th><th class="text-center" translate="">{{\'projectClients.table.headers.type\'}}</th><th class="text-left" translate="">{{\'projectClients.table.headers.kam\'}}</th><th class="text-center" translate="">{{\'projectClients.table.headers.action\'}}</th></tr></thead><tbody ng-if="vm.clients.length > 0"><tr ng-repeat="client in vm.clients"><td class="text-center width-5">{{(vm.selectedPage * vm.rowsPerPage) + $index + 1}}</td><td class="text-left">{{client.clientName}}</td><td class="text-left"><div class="profile-info"><span class="section-header">{{client.contactName}}</span><div class="font-12 info-bg default-text"><small><span ng-if="(!!client.contactDesignation && client.contactDesignation !== \'N/A\')">{{client.contactDesignation}}</span></small></div></div></td><td class="text-center">{{client.contactNumber}}</td><td class="text-left">{{client.contactEmail}}</td><td class="text-center">{{client.organisationTypeName}}</td><td class="text-left"><employee-picture-and-information id="client.kamId" name="client.kamName" picture-url="client.kamProfilePicUrl" department-name="client.departmentOfKam" designation-name="client.designationOfKam" is-clickable="true"></employee-picture-and-information></td><td class="text-center"><div class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-secondary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.goToEditClientPage(client)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-danger\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.openDeleteModal(client)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></div></td></tr></tbody><tbody ng-if="vm.clients == null || vm.clients.length === 0"><tr><td class="text-center" colspan="8"><em translate="">{{\'projectClients.table.emptyBody\'}}</em></td></tr></tbody></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" not-found-text="\'No data available\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/issueCreators/issueCreators.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'projects.issueCreators.title\' | translate}}" ba-panel-class="with-scroll panel-full-screen"><div class="row"><div class="col-md-5"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.search.keyword" ng-keydown="$event.keyCode === 13 && vm.searchFromTheBeginningOfPagination()" placeholder="{{\'projects.issueCreators.searchInputPlaceholder\' | translate}}"></div></div><div class="col-md-7"><button class="btn btn-md pull-right" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-primary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.openCreateModal()"><span translate="">{{\'projects.issueCreators.createButton\'}}</span></button></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left width-70" translate="">{{\'projects.issueCreators.table.creator\'}}</th><th class="text-center width-25" translate="">{{\'projects.issueCreators.table.action\'}}</th></tr></thead><tbody ng-if="vm.creators.length > 0"><tr ng-repeat="item in vm.creators"><td class="text-center width-5">{{(vm.selectedPage * vm.rowsPerPage) + $index + 1}}</td><td class="text-left width-70"><employee-picture-and-information id="item.employeeId" name="item.employeeName" picture-url="item.pictureUrl" department-name="item.departmentName" designation-name="item.designationName" is-clickable="true"></employee-picture-and-information></td><td class="text-center width-25"><button class="btn btn-sm-with-icon btn-danger" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-danger\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.openDeleteModal(item)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></td></tr></tbody><tbody ng-if="vm.creators == null || vm.creators.length === 0"><tr><td class="text-center" colspan="3"><em translate="">{{\'projects.issueCreators.table.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" not-found-text="\'No data available\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/monthlyProjectDedication/report.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'Monthly Dedication\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="multiple"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.year\'}}</label><div id="yearList" isteven-multi-select="" input-model="vm.yearList" output-model="vm.selectedYear" button-label="id" item-label="id" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.month\'}}</label><div id="monthList" isteven-multi-select="" input-model="vm.monthList" output-model="vm.selectedMonth" button-label="name" item-label="name" tick-property="ticked" output-properties="id name" selection-mode="single"></div></div></div><div class="row d-flex-flex-end"><div class="form-group col-sm-2 col-xs-2"><button type="button" class="btn btn-md-with-icon btn-primary btn-block mt-30" ng-click="vm.getReport()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row mb-20"><div class="col-sm-12 col-md-12 col-xs-12"><div><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">{{\'timeSheetReport.project\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.picture\'}}</th><th class="text-left" translate="">{{\'timeSheetReport.name\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.projectDedication\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.hoursSpent\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.totalWorkHour\'}}</th></tr></thead><tbody ng-if="vm.isReportLoaded"><tr ng-repeat-start="(key,val) in vm.report"><td class="text-center" rowspan="{{val.length + 1}}">{{val[0].projectWorkName}}</td></tr><tr ng-repeat="data in val" ng-repeat-end=""><td class="text-center-important"><img class="list-avatar" ng-show="data.employee.pictureUrl != null && data.employee.pictureUrl != \'\'" ng-src="{{data.employee.pictureUrl}}"> <img class="list-avatar" ng-show="data.employee.pictureUrl == null || data.employee.pictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td class="text-left">{{data.employee.name}}</td><td class="text-center">{{data.dedication}}</td><td class="text-center">{{data.hoursWorked}}</td><td class="text-center">{{data.totalHours}}</td></tr></tbody></table><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center" ng-if="!vm.isReportLoaded && vm.isDataLoaded"><p class="text-bold mt-20"><em translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</em></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/peopleGanttChart/report.html','<style>\n    .list-avatar{\n        border-radius: 50%;\n        height: 23px;\n        width: 23px;\n        float: left;\n        border: 0.5px lightgrey solid;\n        margin-right: 1px;\n        cursor: pointer;\n    }\n    .list-avatar-last{\n        border-radius: 50%;\n        height: 23px;\n        width: 23px;\n        float: left;\n        background-color: #f1f1f1;\n        border: 0.5px lightgrey solid;\n        cursor: pointer;\n        text-align: center;\n    }\n    .bordered-table-cell {\n        border: 1px solid;\n    }\n    .task-done {\n        background-color: #b1ce4d;\n    }\n    .has-task-present {\n        background-color: #dfb81c;\n    }\n    .has-task-past {\n        background-color: #e85656;\n    }\n    .table > tbody > tr > td {\n        line-height: 8px;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-top: 0!important;\n        padding-bottom: 0!important;\n        text-align: center;\n    }\n    .white-link {\n        color: whitesmoke !important;\n    }\n    .overflow-x-auto{\n        overflow-x: auto\n    }\n     .panel .panel-body{\n         min-height: 450px;\n     }\n</style><div ba-panel="" ba-panel-title="{{\'Gantt Chart People\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline mt-5"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.people\'}}</label><div isteven-multi-select="" input-model="vm.allEmployees" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.date\'}}</label><div date-range-picker="" class="form-control date-picker text-center modified-input-box position-relative d-block cursor-text" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} - {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.status\'}}</label><div isteven-multi-select="" input-model="vm.statusList" output-model="vm.selectedStatus" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="multiple"></div></div></div><div class="row d-flex-flex-end"><div class="form-group col-sm-2 col-xs-4 mt-2"><button type="button" class="btn btn-md-with-icon btn-primary btn-block mt-20" ng-click="vm.getGanttChartReportData()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row mb-20"><div class="col-sm-12 col-md-12 col-xs-12"><div><button ng-click="vm.openCreateTaskModal()" class="btn btn-md btn-primary mb-10" translate="">{{\'timeSheetReport.addTaskButton\'}}</button><div class="overflow-x-auto"><table class="table table-header font-12"><thead><tr><th class="bordered-table-cell text-left">{{\'timeSheetReport.tasks\' | translate}}</th><th class="bordered-table-cell text-center" ng-repeat="date in vm.dates">{{date}}</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.dates.length > 0"><tr ng-repeat="task in vm.tasks"><td class="headers2"><a class="white-link" ui-sref="projectManagement.editTask({taskId : {{task.id}}})">{{task.name}}</a></td><td ng-repeat="date in vm.dates" ng-class="$index >= task.taskStartIndex && $index <= task.taskEndIndex? task.status == 2? \'task-done\' : (vm.indexOfToday >= 0 && $index < vm.indexOfToday)? \'has-task-past\' : \'has-task-present\' : \'\'"></td></tr></tbody></table><div class="text-center mb-0" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center" ng-if="vm.dates.length <= 0 && vm.isDataLoaded"><p class="text-bold mt-20"><em translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</em></p></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/perDayTimeSheetReport/report.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n    .btn-right{\n        margin-left: 112%;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'Timesheet Report\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProjects" button-label="name" on-item-click="vm.getAllTasks()" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.task\'}}</label><div isteven-multi-select="" input-model="vm.allTasks" output-model="vm.selectedTasks" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.team\'}}</label><div isteven-multi-select="" input-model="vm.allTeams" output-model="vm.selectedTeams" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div></div><div class="row form-inline mt-5"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.employee\'}}</label><div isteven-multi-select="" input-model="vm.employees" output-model="vm.selectedEmployees" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.date\'}}</label><div date-range-picker="" class="form-control date-picker text-center modified-input-box position-relative d-block cursor-text" ng-model="vm.date" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.date.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="form-group col-sm-2 col-xs-2"><button type="button" class="btn btn-md-with-icon btn-primary btn-block mt-23 btn-right" ng-click="vm.searchReport()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row mb-20"><div class="col-sm-12 col-md-12 col-xs-12"><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isDataLoaded"><div class="row mb-20"><div class="col-md-6"><a ng-href="{{vm.excelUrl}}" target="_self"><button class="btn btn-md-with-icon btn-primary padding-6-12" id="exportToExcel" ng-click="vm.analyticsDownloadExcel()"><img src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></a></div><div id="attendanceTableRowsPerPageDiv" class="col-md-4 text-right mt-10"><span id="attendanceTableRowsPerPageSpan"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span></div><div class="col-md-2"><div class="custom-select"><select ng-model="vm.perPage" ng-change="vm.getReport()"><option value="2" ng-selected="vm.perPage==2" translate="">{{\'commonKeywords.two\'}}</option><option value="5" ng-selected="vm.perPage==5" translate="">{{\'commonKeywords.five\'}}</option><option value="10" ng-selected="vm.perPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.perPage==20" translate="">{{\'commonKeywords.twenty\'}}</option><option value="50" ng-selected="vm.perPage==50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.perPage==100" translate="">{{\'commonKeywords.hundred\'}}</option></select></div></div></div><table class="table borderless-table even-child-selector"><thead><tr><th class="text-left" translate="">{{\'timeSheetReport.employee\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.project\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.task\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.team\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.start\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.end\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.totalTime\'}}</th><th class="text-left" translate="">{{\'timeSheetReport.description\'}}</th></tr></thead><tbody ng-repeat="(key,val) in vm.report"><tr><td class="text-left" rowspan="{{val.length + 1}}">{{val[0].employeeName}}</td></tr><tr ng-repeat="data in val"><td class="text-center">{{data.projectWorkName}}</td><td class="text-center">{{data.taskName}}</td><td class="text-center">{{data.teamName}}</td><td class="text-center">{{data.startTime}}</td><td class="text-center">{{data.endTime}}</td><td class="text-center">{{data.totalTime}}</td><td class="text-left">{{data.description}}</td></tr></tbody></table><div class="text-center" ng-if="vm.totalData > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item cursor-pointer"><a class="page-link" ng-click="vm.getData(vm.perPage, 1)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item cursor-pointer"><a class="page-link" ng-click="vm.getData(vm.perPage, vm.pageNo-1 > 0? vm.pageNo-1 : 1)">&lt;</a></li><li class="cursor-pointer" ng-repeat="n in vm.pageButtons" ng-class="(vm.pageNo == n)? \'active\':\'\'"><a ng-click="vm.getData(vm.perPage, n)">{{n}}</a></li><li class="page-item cursor-pointer"><a class="page-link" ng-click="vm.getData(vm.perPage, vm.pageNo+1 > vm.totalPages? vm.totalPages: vm.pageNo+1)">&gt;</a></li><li class="page-item cursor-pointer"><a class="page-link" ng-click="vm.getData(vm.perPage, vm.totalPages)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center" ng-if="vm.totalData === 0 && vm.isDataLoaded"><p class="mt-20 text-bold"><em translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</em></p></div><div class="text-center mt-10" ng-if="vm.totalData > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.pageNo}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.totalPages}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/products/products.html','<style>\n    .p-4{\n        padding: 5px;\n    }\n    .ellipis{\n        text-overflow:ellipsis;\n        overflow:hidden;\n        display: -webkit-box !important;\n        -webkit-line-clamp: 4;\n        -webkit-box-orient: vertical;\n        white-space: normal;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'projects.product.title\' | translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-3 col-xs-3"><label class="filter-label" translate="">projects.product.productSegment</label><div isteven-multi-select="" input-model="vm.search.segmentList" output-model="vm.search.selectedSegmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" show-add-model="false" new-input-method="vm.createProductSegment" helper-elements="all filter none" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Segment\' }"></div></div><div class="form-group col-sm-3 col-xs-3"><label class="filter-label" translate="">projects.product.productOwner</label><div isteven-multi-select="" input-model="vm.search.ownerList" output-model="vm.search.selectedOwnerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" helper-elements="all filter none" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Owner\' }"></div></div><div class="row form-inline"><div class="form-group col-sm-9 col-xs-3"></div><div class="col-sm-3 col-xs-3 my-12 d-flex justify-end"><button id="attendanceSearchButton" type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchProductListOfOffice(vm.search)"><i class="ion-search"></i>{{\'search\' | translate}}</button></div></div></div></div></div><div class="d-flex-space-between d-flex-align-center"><div class="filter-inline-item width-25 d-flex-flex-start-gap-10"><div><div class="form-group has-feedback has-search placeholder-text-13"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control" type="text" placeholder="Search Product by Name" ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchFromTheBeginingOfPagination(true) : \'\'"></div></div><div><div class="filter-inline-item text-right min-height-33"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary mb-15" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-primary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.goToProductCreationPage()"><span class="p-4" translate="">{{\'projects.product.createProduct\' | translate}}</span></button></div></div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><table class="table report-table" ng-if="vm.isDataLoaded"><colgroup><col class="width-5"><col class="width-10"><col class="width-10"><col class="width-40"><col class="width-10"><col class="width-10"></colgroup><thead class="row-height"><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{\'projects.product.table.productName\'}}</th><th class="text-center" translate="">{{\'projects.product.table.segment\'}}</th><th class="text-left" translate="">{{\'projects.product.table.description\'}}</th><th class="text-left" translate="">{{\'projects.product.table.owner\'}}</th><th class="text-center" translate="">{{\'projects.product.table.action\'}}</th></tr></thead><tbody ng-if="!!vm.allEntries && vm.allEntries.length > 0"><tr ng-repeat="data in vm.allEntries"><td class="text-center">{{($index+1) + vm.search.pageNumber*10}}</td><td class="text-left">{{data.name}}</td><td class="text-center">{{data.segmentName}}</td><td class="text-left"><span class="ellipis">{{data.description}}</span></td><td class="text-left"><employee-picture-and-information name="data.ownerName" picture-url="data.ownerPictureUrl" department-name="!data.ownerDepartmentName ? \'N/A\':data.ownerDepartmentName" designation-name="!data.ownerDesignationName ? \'N/A\':data.ownerDesignationName" id="data.ownerId" is-clickable="true"></employee-picture-and-information></td><td class="text-center red-text"><button class="btn btn-sm-with-icon btn-secondary" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-secondary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.goToProductEditPage(data)"><i class="ion-ios-compose-outline"></i><span class="pb-2" translate="">{{\'projects.product.table.edit\'}}</span></button> <button ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-danger\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.deleteCreateProductModal($index)" class="btn btn-sm-with-icon btn-danger"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody><tbody ng-if="!vm.allEntries || vm.allEntries.length === 0"><tr><td class="text-center" colspan="6"><em translate="">{{\'projects.product.table.emptyBody\'}}</em></td></tr></tbody></table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.search.pageNumber" rows-per-page="vm.searchParams.perPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getProductPageSpecifiedData" not-found-text="\'<em>No Data Found</em>\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectGanttChart/peopleList.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'timeSheetReport.peopleInHeading\' | translate}} {{vm.task.name}}</h4></div><div class="modal-body"><table class="table table-bordered font-12"><tbody><tr ng-repeat="item in vm.task.employees"><td class="text-center">{{$index+1}}</td><td class="text-center-important" style="text-align: center !important;"><img class="list-avatar" ng-show="item.pictureUrl != null && item.pictureUrl != \'\'" ng-src="{{item.pictureUrl}}"> <img class="list-avatar" ng-show="item.pictureUrl == null || item.pictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td class="text-center">{{item.name}}</td></tr></tbody></table></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectGanttChart/report.html','<style>\n    .list-avatar {\n        border-radius: 50%;\n        height: 23px;\n        width: 23px;\n        float: left;\n        border: 0.5px lightgrey solid;\n        margin-right: 1px;\n        cursor: pointer;\n    }\n    .list-avatar-last {\n        border-radius: 50%;\n        height: 23px;\n        width: 23px;\n        float: left;\n        background-color: #f1f1f1;\n        border: 0.5px lightgrey solid;\n        cursor: pointer;\n        text-align: center;\n    }\n    .bordered-table-cell {\n        border: 1px solid;\n    }\n    .task-done {\n        background-color: #b1ce4d;\n    }\n    .has-task-present {\n        background-color: #dfb81c;\n    }\n    .has-task-past {\n        background-color: #e85656;\n    }\n    .table > tbody > tr > td {\n        line-height: 8px;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n        text-align: center;\n    }\n    .white-link {\n        color: whitesmoke !important;\n    }\n    .overflow-x-auto{\n        overflow-x: auto\n    }\n     .panel .panel-body{\n         min-height: 450px;\n     }\n</style><div ba-panel="" ba-panel-title="{{\'Gantt Chart Projects\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline mt-5"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.date\'}}</label><div date-range-picker="" class="form-control date-picker text-center modified-input-box position-relative d-block cursor-text" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} - {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.status\'}}</label><div isteven-multi-select="" input-model="vm.statusList" output-model="vm.selectedStatus" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="multiple"></div></div></div><div class="row d-flex-flex-end"><div class="form-group col-sm-2 col-xs-2"><button type="button" class="btn btn-md-with-icon btn-primary btn-block mt-20" ng-click="vm.getGanttChartReportData()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row mb-20"><div class="col-sm-12 col-md-12 col-xs-12"><div><button ng-click="vm.openCreateTaskModal()" class="btn btn-md btn-primary mb-10" translate="">{{\'timeSheetReport.addTaskButton\'}}</button><div class="overflow-x-auto"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">{{\'timeSheetReport.tasks\'}}</th><th class="text-center" ng-repeat="date in vm.dates">{{date}}</th><th class="text-center">{{\'timeSheetReport.people\' | translate}}</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.dates.length > 0"><tr ng-repeat="task in vm.tasks"><td class="headers2"><a class="white-link" ui-sref="projectManagement.editTask({taskId : {{task.id}}})">{{task.name}}</a></td><td ng-repeat="date in vm.dates" ng-class="$index >= task.taskStartIndex && $index <= task.taskEndIndex? task.status == 2? \'task-done\' : (vm.indexOfToday >= 0 && $index < vm.indexOfToday)? \'has-task-past\' : \'has-task-present\' : \'\'"></td><td class="text-center-important"><div class="flex-container"><div ng-repeat="employee in task.employees"><img class="list-avatar" ng-show="$index >= 0 && $index <= 2 && employee.pictureUrl != null && employee.pictureUrl != \'\'" ng-src="{{employee.pictureUrl}}" title="{{employee.name}}" alt=\'{{employee.name}}"\'> <img class="list-avatar" ng-show="$index >= 0 && $index <= 2 && employee.pictureUrl != null && employee.pictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png" title="{{employee.name}}" alt=\'{{employee.name}}"\'></div><div ng-click="vm.showPeopleList(task)" ng-if="task.employees.length > 3" class="list-avatar-last"><div class="pt-7 font-10">+{{task.employees.length-3}}</div></div></div></td></tr></tbody></table><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center" ng-if="vm.dates.length <= 0 && vm.isDataLoaded"><p class="text-bold mt-20"><em translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</em></p></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectIssues/projectIssues.html','<style>\n    .p-4{\n        padding: 5px;\n    }\n    .project-issue-form-control{\n        height: 37px!important;\n        width: 100%!important;\n    }\n    .project-issue-date-position-left {\n        position: absolute;\n        top:9px;\n        left: 15px;\n    }\n    .project-issue-calender-icon-position{\n        position: absolute;\n        top: 11px;\n        right: 15px;\n        font-size: 14px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'projects.issues.title\' | translate}} <span ng-click=\'vm.showFilterDiv = !vm.showFilterDiv\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilterDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilterDiv\' class=\'fa fa-chevron-up\'></i> </span>"><div class="filter-div" ng-if="vm.showFilterDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.issueDate\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options" min="vm.minDate"><span class="date-position-left">{{vm.datePicker.date.startDate.format("D MMM YYYY")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.projectName\' }}</label><div isteven-multi-select="" input-model="vm.projects" output-model="vm.search.selectedProjects" helper-elements="all filter none" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.productName\' }}</label><div isteven-multi-select="" input-model="vm.products" output-model="vm.search.selectedProducts" helper-elements="all filter none" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.submittedBy\' }}</label><div isteven-multi-select="" input-model="vm.submitters" output-model="vm.search.selectedSubmitters" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" helper-elements="all filter none" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Please Select\' }"></div></div></div><div class="row form-inline mt-20"><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.allocateTo\' }}</label><div isteven-multi-select="" input-model="vm.assignees" output-model="vm.search.selectedAssignees" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" helper-elements="all filter none" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Please Select\' }"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.status\' }}</label><div isteven-multi-select="" input-model="vm.statusList" output-model="vm.search.selectedStatusList" button-label="text" item-label="text" tick-property="ticked" output-properties="id" search-property="text" helper-elements="all filter none"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.issues.priority\' }}</label><div isteven-multi-select="" input-model="vm.priorityList" output-model="vm.search.selectedPriorities" button-label="text" item-label="text" tick-property="ticked" output-properties="id" search-property="text" helper-elements="all filter none"></div></div></div><div class="row form-inline"><div class="form-group col-sm-9 col-xs-3"></div><div class="col-sm-3 col-xs-3 my-12 d-flex justify-end"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchFromTheBeginningOfPagination()"><i class="ion-search"></i><span translate="">{{ \'search\' }}</span></button></div></div></div><div class="row"><div class="col-md-8"><div class="d-flex-space-between d-flex-align-center"><div class="filter-inline-item width-100 d-flex-flex-start-gap-10"><div class="width-35"><div class="form-group has-feedback resize-placeholder"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.search.keyword" ng-keydown="$event.keyCode === 13 && vm.searchFromTheBeginningOfPagination()" placeholder="{{\'projects.issues.searchInputPlaceholder\' | translate}}"></div></div><div><div class="filter-inline-item text-right min-height-33"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div></div></div></div><div class="col-md-4 text-right"><div><button type="button" class="btn btn-md" ng-class="{\'btn-disable\' : !vm.enableCreateButton, \'btn-primary\' : vm.enableCreateButton}" ng-disabled="!vm.enableCreateButton" ng-click="vm.goToCreateIssuePage()"><span translate="">{{\'projects.issues.createButton\'}}</span></button></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{\'projects.issues.table.date\'}}</th><th class="text-left" translate="">{{\'projects.issues.table.projectName\'}}</th><th class="text-left" translate="">{{\'projects.issues.table.productName\'}}</th><th class="text-left" translate="">{{\'projects.issues.table.submittedBy\'}}</th><th class="text-center" translate="">{{\'projects.issues.table.ticketNo\'}}</th><th class="text-left" translate="">{{\'projects.issues.table.allocateTo\'}}</th><th class="text-center" translate="">{{\'projects.issues.table.status\'}}</th><th class="text-center" translate="">{{\'projects.issues.table.dateAndTime\'}}</th><th class="text-center" translate="">{{\'projects.issues.table.priority\'}}</th><th class="text-center" translate="">{{\'projects.issues.table.action\'}}</th></tr></thead><tbody ng-if="vm.issueList.length > 0"><tr ng-repeat="item in vm.issueList"><td class="text-center width-5">{{(vm.selectedPage * vm.rowsPerPage) + $index + 1}}</td><td class="text-center">{{item.issueDate | date : \'d MMM yyyy hh:mm a\'}}</td><td class="text-left"><span class="section-header">{{item.projectName}}</span></td><td class="text-left">{{item.productName}}</td><td class="text-left"><employee-picture-and-information id="item.submitterId" name="item.submitterName" picture-url="item.submitterProfilePicUrl" department-name="item.departmentOfSubmitter" designation-name="item.designationOfSubmitter" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{item.ticketCode}}</td><td class="text-left"><employee-picture-and-information id="item.assigneeId" name="item.assigneeName" picture-url="item.assigneeProfilePicUrl" department-name="item.departmentOfAssignee" designation-name="item.designationOfAssignee" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{item.statusText}}</td><td class="text-center">{{item.lastUpdatedAt | date : \'d MMM yyyy hh:mm a\'}}</td><td class="text-center" ng-if="item.priority === 1"><span class="section-header text-success" translate="">{{\'projects.issues.lowPriority\'}}</span></td><td class="text-center" ng-if="item.priority === 2"><span class="section-header text-warning" translate="">{{\'projects.issues.mediumPriority\'}}</span></td><td class="text-center" ng-if="item.priority === 3"><span class="section-header text-danger" translate="">{{\'projects.issues.highPriority\'}}</span></td><td class="text-center"><div class="d-flex-center-gap-10"><button ng-if="item.status !== 4" class="btn btn-sm-with-icon opacity-100" ng-class="{\'btn-disable\' : (vm.loggedInUser.id !== item.submitterId), \'btn-secondary\' : (vm.loggedInUser.id === item.submitterId)}" ng-disabled="vm.loggedInUser.id !== item.submitterId" ng-click="vm.goToEditIssuePage(item)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.goToViewIssuePage(item)"><i class="ion-ios-eye-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'projects.issues.table.view\'}}</span></button></div></td></tr></tbody><tbody ng-if="vm.issueList == null || vm.issueList.length === 0"><tr><td class="text-center" colspan="11"><em translate="">{{\'projects.issues.table.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" not-found-text="\'No data available\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectWorkHourReport/report.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n    .btn-right{\n        margin-left: 112%;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'Work Hour Report\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'timeSheetReport.date\'}}</label><div date-range-picker="" class="form-control date-picker text-center modified-input-box position-relative d-block cursor-text" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} - {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="form-group col-sm-2 col-xs-2"><button type="button" class="btn btn-md-with-icon btn-primary btn-block mt-22 btn-right" ng-class="{\'disabled\': vm.selectedProject.length === 0}" ng-click="vm.getReport()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row mb-20"><div class="col-sm-12 col-md-12 col-xs-12"><div><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">{{\'timeSheetReport.date\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.picture\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.name\'}}</th><th class="text-center" translate="">{{\'timeSheetReport.totalWorkHour\'}}</th></tr></thead><tbody ng-if="vm.isReportLoaded"><tr ng-repeat-start="(key,val) in vm.report"><td rowspan="{{val.length + 1}}">{{key}}</td></tr><tr ng-repeat="data in val" ng-repeat-end=""><td class="text-center-important"><img class="list-avatar" ng-show="data.employee.pictureUrl != null && data.employee.pictureUrl != \'\'" ng-src="{{data.employee.pictureUrl}}"> <img class="list-avatar" ng-show="data.employee.pictureUrl == null || data.employee.pictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td class="text-center">{{data.employee.name}}</td><td class="text-center">{{data.workHour}}</td></tr></tbody></table></div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-20" ng-if="vm.report.length == 0 && vm.isDataLoaded"><p class="text-bold"><em translate="">{{\'commonKeywords.dataNotFound\'}}</em></p></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/projects.html','<div class="row"><div class="col-md-12" ng-include="vm.loadPartial()"></div></div>');
$templateCache.put('app/pages/main/projectManagement/teams/teams.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'teams.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle pb-2"></i><span class="pb-2">{{\'teams.createButton\' | translate}}</span></button></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'teams.tableHeader.name\' }}</th><th class="text-left" translate="">{{ \'teams.tableHeader.description\' }}</th><th class="text-center" translate="">{{ \'teams.tableHeader.status\' }}</th><th class="text-center width-12" translate="">{{ \'teams.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.allTeams" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-left">{{item.description ? item.description : \'--\'}}</td><td ng-show="item.status==\'1\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusActive\' }}</td><td ng-show="item.status==\'0\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="projectManagement.editTeam({teamId : {{item.id}}})"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center mb-10"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/tasks/tasks.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'Tasks\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate}} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-if="type == null"><label class="filter-label" translate="">{{\'tasks.date\'}}</label><div date-range-picker="" class="form-control date-picker text-center modified-input-box position-relative d-block cursor-text" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} - {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'tasks.tableHeader.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'tasks.tableHeader.status\'}}</label><div isteven-multi-select="" input-model="vm.statusList" output-model="vm.selectedStatus" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><br><div class="row form-inline d-flex-flex-end"><div class="form-group col-sm-2 col-xs-2"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.getAllTasks()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row mb-20"><div class="col-md-12"><div><div class="row mb-20"><div class="col-md-6"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'tasks.createButton\' | translate}}</span></button></div><div id="attendanceTableRowsPerPageDiv" class="col-md-4 text-right mt-10"><span id="attendanceTableRowsPerPageSpan"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span></div><div class="col-md-2"><div class="custom-select"><select ng-model="vm.perPage" ng-change="vm.getAllTasks()"><option value="10" ng-selected="vm.perPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.perPage==20" translate="">{{\'commonKeywords.twenty\'}}</option><option value="50" ng-selected="vm.perPage==50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.perPage==100" translate="">{{\'commonKeywords.hundred\'}}</option></select></div></div></div></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'tasks.tableHeader.name\' }}</th><th class="text-left" translate="">{{ \'tasks.tableHeader.project\' }}</th><th class="text-center" translate="">{{ \'tasks.tableHeader.startTime\' }}</th><th class="text-center" translate="">{{ \'tasks.tableHeader.deadline\' }}</th><th class="text-left" translate="">{{ \'tasks.tableHeader.description\' }}</th><th class="text-center" translate="">{{ \'tasks.tableHeader.status\' }}</th><th class="text-center width-12" translate="">{{ \'tasks.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.totalData > 0"><tr ng-repeat="item in vm.allTasks" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-left">{{item.projectWorkName}}</td><td class="text-center">{{item.startTime | date : \'dd-MM-yyyy\'}}</td><td class="text-center">{{item.endTime | date : \'dd-MM-yyyy\'}}</td><td class="text-left">{{item.description ? item.description : \'--\'}}</td><td ng-show="item.status==\'1\'" class="text-center button-row" translate="">{{ \'tasks.statusTodo\' }}</td><td ng-show="item.status==\'0\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td ng-show="item.status==\'2\'" class="text-center button-row" translate="">{{ \'tasks.statusComplete\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="projectManagement.editTask({taskId : {{item.id}}})"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.totalData <= 0 && vm.isDataLoaded"><p><i translate="">{{commonKeywords.noDataFoundWithGivenFilters}}</i></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/accessArea/accessArea.html','<div ba-panel="" ba-panel-title="{{ \'visitorManagement.accessArea.title\' | translate }}" ba-panel-class="with-scroll"><div ng-controller="AccessAreaCtrl as vm"><div class="row d-flex-flex-start"><div class="col-md-3"><upgrade-button code="6004"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateAccessAreaModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'visitorManagement.accessArea.createButton\' | translate }}</span></button></upgrade-button></div></div><div class="row"><div class="col-md-12 mb-20 mt-10"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><colgroup><col class="width-5"><col class="width-70"><col class="width-15"><col class="width-10"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'visitorManagement.accessArea.tableHeader.accessAreas\' }}</th><th class="text-center" translate="">{{ \'visitorManagement.accessArea.tableHeader.code\' }}</th><th class="text-center" translate="">{{ \'visitorManagement.accessArea.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="accessAreas in vm.accessAreas"><td class="text-center">{{$index+1}}</td><td class="text-left">{{accessAreas.name}}</td><td class="text-center">{{accessAreas.code}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openUpdateAccessAreaModal(accessAreas, $index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteAccessAreaModal(accessAreas, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/approvals/approvals.html','<style>\n    .container {\n        display: inline-block;\n        width: 100%;\n        padding: 0 0 0 0;\n    }\n    .approval-box {\n        /*display: inline-block;*/\n        width: 100%;\n        border: 1px solid #ddd;\n        margin: 10px;\n        box-shadow: 5px 8px 8px 0 rgba(0,0,0,0.1);\n        padding: 15px 10px 15px 10px;\n        /*align-items: flex-start;*/\n        height: 160px;\n    }\n\n    i.active {\n        color: #209E91;\n    }\n\n    i.inactive {\n        color: #808080;\n    }\n    .header {\n        font-size: 18px;\n        color: #209E91;\n    }\n\n    .col {\n        width: 100%;\n    }\n    .bold-text {\n        font-weight: bold;\n    }\n    .form-check-label {\n        font-size: 15px;\n    }\n    .info-label {\n        font-size: 10px;\n        color: #808080;\n    }\n    .info-container {\n        display: inline-block;\n    }\n\n\n</style><div ba-panel="" ba-panel-title="{{ \'approvals.title\' | translate }}" ba-panel-class="with-scroll"><div class="row"><div class="text-center col-md-12" ng-if="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="col-md-4" ng-repeat="box in vm.boxes" ng-if="vm.isDataLoaded"><div class="approval-box"><div class="header">{{ box.title }}</div><hr><div><span class="bold-text">{{ \'approvals.approverSystem\' | translate }}<br><br></span></div><div class="toggle-container" ng-if="box.infoData"><div class="info-container"><i class="fa fa fa-info-circle"></i> <label class="info-label">{{ \'approvals.leaveInfo\' | translate }}</label></div></div><div class="toggle-container" ng-if="!box.infoData"><div class="form-check form-switch"><label class="form-check-label toggle-label">{{ \'approvals.singleApprover\' | translate }}&nbsp;&nbsp;</label> <i class="fa fa-toggle-on fa-2x" ng-class="{\'active\': !box.isSingle, \'fa-rotate-180\': box.isSingle}" ng-click="vm.onCheckboxChange(box)"></i> <label class="form-check-label toggle-label">&nbsp;&nbsp;{{ \'approvals.multipleApprover\' | translate }}</label></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/departments/departments.html','<div ba-panel="" ba-panel-title="{{ \'departmentSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><upgrade-button code="8001"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'departmentSettings.createButton\' | translate }}</span></button></upgrade-button></div><div class="horizontal-scroll scrollable-table mt-15" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'departmentSettings.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'departmentSettings.tableHeader.hierarchy\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'departmentSettings.tableHeader.officeName\' }}</th><th class="text-center" translate="">{{ \'departmentSettings.tableHeader.status\' }}</th><th class="text-center width-13" translate="">{{ \'departmentSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.allDepartments" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-center">{{item.hierarchy}}</td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.office.name}}</td><td class="text-center" ng-show="item.status==\'1\'" translate="">{{ \'commonKeywords.statusActive\' }}</td><td class="text-center" ng-show="item.status==\'0\'" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/designations/designations.html','<div ba-panel="" ba-panel-title="{{ \'designationSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-15"><div class="col-md-12"><div class="row"><div class="col-md-2"><upgrade-button code="8001"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'designationSettings.createButton\' | translate }}</span></button></upgrade-button></div><div class="col-md-4 col-md-offset-6"><div class="input-group"><input type="text" class="form-control" placeholder="Search ..." ng-model="vm.searchText"> <span class="input-group-addon addon-right"><i class="ion-android-search"></i></span></div></div></div><div class="row"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'designationSettings.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'designationSettings.tableHeader.hierarchy\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'designationSettings.tableHeader.officeName\' }}</th><th class="text-center width-12" translate="">{{ \'designationSettings.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="item in vm.designations.allDesignations | limitTo:vm.maxNumberToLoad|filter:{\'name\':vm.searchText}"><td class="text-center">{{$index+1}}</td><td class="text-left rowlinks" ng-click="">{{item.name}}</td><td class="text-center rowlinks">{{item.hierarchy}}</td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.office.name}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div><div class="row mt-20" ng-if="vm.designations.allDesignations.length > vm.maxNumberToLoad"><div class="col-md-4 col-md-offset-4"><button class="btn btn-md btn-primary btn-block" ng-click="vm.loadMore()"><i translate="">{{ \'designationSettings.loadButton\' }}</i></button></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/employmentType/employmentType.html','<div ba-panel="" ba-panel-title="{{ \'employmentTypeSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-15"><div class="col-md-12"><div><div><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'employmentTypeSettings.createButton\' | translate }}</span></button></div></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'employmentTypeSettings.tableHeader.name\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'employmentTypeSettings.tableHeader.officeName\' }}</th><th class="text-center" translate="">{{ \'employmentTypeSettings.tableHeader.status\' }}</th><th class="text-center width-13" translate="">{{ \'employmentTypeSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.employmentTypeList" ng-if="item.status!== -1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.office.name}}</td><td class="text-center" ng-if="item.status==\'1\'" translate="">{{ \'commonKeywords.statusActive\' }}</td><td class="text-center" ng-if="item.status==\'0\'" translate="">{{ \'commonKeywords.statusActive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/holidays/holidayTable.partial.html','<style>\n    .scrollable-table {\n        max-height: 45vh;\n        overflow: auto;\n        position: relative;\n    }\n</style><div ng-controller="HolidayTableCtrl as vm"><div class="d-flex-space-between"><div><span class="ml-5 font-18 color-22222 font-weight-400" id="event-editor" translate="">{{\'holidaySettings.editSectionHeader\'}}</span></div><div><button class="btn btn-md-with-icon btn-primary mr-5" ng-click="vm.openCreateModal()"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'holidaySettings.addButton\'}}</span></button></div></div><div class="mt-10"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip calendarEdit"><thead><tr><th class="text-center width-5" translate="">{{ \'commonKeywords.sl\' }}</th><th class="text-left" translate="">{{ \'holidaySettings.tableHeader.title\' }}</th><th class="text-center" translate="">{{ \'holidaySettings.tableHeader.date\' }}</th><th class="text-center width-13" translate="">{{ \'holidaySettings.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-repeat="event in vm.events"><td class="text-center">{{$index+1}}</td><td class="text-left">{{event.description}}</td><td class="text-center">{{event.holidayDate | date: "dd MMMM yyyy "}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openUpdateModal(event,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(event,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/settings/holidays/holidays.html','<style>\n    mwl-calendar .cal-day-today {\n        background-color: var(--color-secondary);\n        color: white;\n    }\n    mwl-calendar span[data-cal-date]{\n        opacity: .9;\n    }\n    mwl-calendar .cal-day-today span[data-cal-date]{\n        color: white;\n    }\n    .calender-top{\n        display: flex;\n        justify-content: space-between;\n    }\n    mwl-calendar .cal-event-list .event.pull-left {\n       margin-top: 0px;\n    }\n    mwl-calendar .cal-event-list .event{\n        background-color: var(--color-secondary) !important;\n    }\n    mwl-calendar .event{\n        background-color: var(--color-secondary) !important;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'holidaySettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8 col-md-offset-2 calender-top"><div class="btn-group"><button class="btn btn-md btn-secondary" mwl-date-modifier="" date="vm.viewDate" set-to-today="" ng-click="vm.cellIsOpen = false">{{ \'holidaySettings.todayButton\' | translate }}</button></div><div class="d-flex-center-gap-10"><button class="btn btn-md btn-primary" mwl-date-modifier="" date="vm.viewDate" decrement="vm.calendarView" ng-click="vm.cellIsOpen = false"><i class="ion-chevron-left"></i></button><h2 class="mt-10">{{ vm.calendarTitle }}</h2><button class="btn btn-md btn-primary" mwl-date-modifier="" date="vm.viewDate" increment="vm.calendarView" ng-click="vm.cellIsOpen = false"><i class="ion-chevron-right"></i></button></div><div class="btn-group"><label class="btn btn-md btn-secondary" ng-model="vm.calendarView" uib-btn-radio="\'year\'" ng-click="vm.cellIsOpen = false">{{ \'holidaySettings.yearRadioLabel\' | translate }}</label> <label class="btn btn-md btn-secondary" ng-model="vm.calendarView" uib-btn-radio="\'month\'" ng-click="vm.cellIsOpen = false">{{ \'holidaySettings.monthRadioLabel\' | translate }}</label></div></div></div><br><br><div class="row"><mwl-calendar events="vm.events" view="vm.calendarView" view-title="vm.calendarTitle" view-date="vm.viewDate" cell-is-open="vm.cellIsOpen" day-view-start="06:00" day-view-end="22:59" day-view-split="30" cell-auto-open-disabled="true" on-timespan-click="vm.timespanClicked(calendarDate, calendarCell)" cell-modifier="vm.cellModifier(calendarCell)" class="col-md-8 col-md-offset-2"></mwl-calendar></div><br><br><br><div class="mb-20" include-with-scope="app/pages/main/settings/holidays/holidayTable.partial.html"></div></div>');
$templateCache.put('app/pages/main/settings/notification/notification.html','<style>\n    .row-adjust {\n        line-height: 20px !important;\n    }\n\n    .label-style {\n        background: none;\n        border-radius: 4px;\n        font-size: 12px\n    }\n    .table > thead > tr > th{\n        white-space: normal!important;\n    }\n\n    .table > thead > tr > th:last-child {\n        padding-right: 5px !important;\n    }\n\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n\n    .table > thead > tr > th a {\n        color: #209e91 !important\n    }\n\n    .dummy-model-min-h {\n        min-height: calc(100vh - 360px);\n    }\n\n    .gap-20 {\n        gap: 20px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'notificationSettings.title\'|translate}} <span ng-if=\'!vm.removeFilter\' ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" config="vm.filterConfig" hide-download="true"></report-filter></div><div class="row mb-10" ng-if="vm.selectedTab === \'all-employee\'"><div class="col-md-6"><div class="row"><div class="col-md-7"><div class="filter-inline-item"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control" type="text" placeholder="Search Employee by Name/ID/RFID" ng-model="vm.searchParams.employeeName" ng-keyup="$event.keyCode == 13 ? vm.search():\'\'"></div></div></div><div class="col-md-3"><div class="custom-select"><select ng-model="vm.selectedNotificationStatus" ng-change="vm.search()" ng-options="v.type as v.type for v in vm.selectNotificationStatus" required=""></select></div></div></div></div><div class="col-md-6 d-flex-flex-end gap-20"><button type="button" class="btn btn-md btn-secondary" ng-class="{\'btn-disable\' : vm.setNotificationForAllEmployeeBtnClicked}" ng-disabled="vm.setNotificationForAllEmployeeBtnClicked" ng-click="vm.setNotificationForAllEmployee()" translate="">{{\'notificationSettings.setNotificationForAllEmployee\'}}</button> <button type="button" class="btn btn-md" ng-click="vm.setNotificationForSelectedEmployee()" ng-class="{\'btn-primary\' : vm.isAnyEmployeeSelected, \'btn-disable\' : !vm.activeSetNotificationBtn}" ng-disabled="!vm.activeSetNotificationBtn" translate="">{{\'notificationSettings.setNotification\'}}</button></div></div><div class="row" ng-if="vm.selectedTab === \'notification-group\'"><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="filter-inline-item"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control" type="text" placeholder="Search Notification Group" ng-model="vm.notificationGroupSearchKey" ng-keyup="$event.keyCode == 13 ? vm.searchNotificationGroupByNameAndId():\'\'"></div></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\':vm.selectedTab == \'all-employee\'}" ng-click="vm.changeTab(\'all-employee\')" translate="">{{\'notificationSettings.allEmployee\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\':vm.selectedTab == \'notification-group\'}" ng-click="vm.changeTab(\'notification-group\')" translate="">{{\'notificationSettings.notificationGroup\'}}</button></div></div></div><div class="row" ng-if="vm.selectedTab ==\'all-employee\' && vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/settings/notification/partials/employeeTable.html"></div></div><div class="row" ng-if="vm.selectedTab ==\'notification-group\' && vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/settings/notification/partials/notificationGroup.html"></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><div class="col-md-6 position-relative"><div ng-if="vm.isAnyRowSelected && vm.selectedTab ===\'all-employee\' && !vm.allSelected && (!vm.setNotificationForAllEmployeeBtnClicked || !vm.setNotificationForSelectedEmployeeBtnClicked)"><div class="row" include-with-scope="app/pages/main/settings/notification/partials/notificationDetailsSection.html"></div></div><div ng-if="vm.isAnyRowSelected && vm.selectedTab == \'notification-group\'"><div class="row" include-with-scope="app/pages/main/settings/notification/partials/notificationGroupDetails.html"></div></div><div ng-if="vm.selectedTab ===\'all-employee\' && vm.selectedEmployeeNameList.length !== 0 && !vm.showDummyModel"><div class="row mb-10"><div class="col-md-12"><div class="d-flex-flex-end color-22222 font-12 font-weight-500"><span><span class="color-555555">{{\'notificationSettings.selected\' | translate}}</span> <span ng-if="vm.selectedEmployeeNameList.length === 1">{{vm.selectedEmployeeNameList[0]}}</span> <span ng-if="vm.selectedEmployeeNameList.length === 2">{{vm.selectedEmployeeNameList[0]}} <span class="color-555555">{{\'notificationSettings.and\' | translate}}</span> {{vm.selectedEmployeeNameList[1]}}</span> <span ng-if="vm.selectedEmployeeNameList.length > 2 && !vm.setNotificationForAllEmployeeBtnClicked">{{vm.selectedEmployeeNameList[0]}}, {{vm.selectedEmployeeNameList[1]}} <span class="color-555555">{{\'notificationSettings.and\' | translate}}</span> {{vm.selectedEmployeeNameList.length - 2}} <span>{{vm.selectedEmployeeNameList.length - 2 == 1 ? \'other\' : \'others\'}}</span></span> <span ng-if="vm.selectedEmployeeNameList.length > 2 && !!vm.setNotificationForAllEmployeeBtnClicked">{{vm.selectedEmployeeNameList[0]}}, {{vm.selectedEmployeeNameList[1]}} <span class="color-555555">{{\'notificationSettings.and\' | translate}}</span> all {{\'notificationSettings.others\' | translate}}</span></span></div></div></div></div><div ng-if="vm.showSetNotificationMsg"><div class="row row-center"><div class="col-md-12"><div class="d-flex-justify-center-align-center"><p class="color-22222"><span class="d-flex-center" translate="">{{\'notificationSettings.nowPressSetNotification\'}}</span><br><span translate="">{{\'notificationSettings.toSelectNotificationForSelectedEmployees\'}}</span></p></div></div></div></div><div ng-if="vm.showSetNotificationPageInRightSide"><div class="row" include-with-scope="app/pages/main/settings/notification/partials/setNotificationForEmployees.html"></div></div><div class="row dummy-model-min-h ng-scope" ng-if="vm.showDummyModel && !vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/settings/notification/partials/dummyModel.html"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/shifts/shifts.html','<div ba-panel="" ba-panel-title="Shifts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><div><upgrade-link code="5003"><button type="button" class="btn btn-info btn-with-icon" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i>Create New Shift</button></upgrade-link></div><br><table class="table table-striped"><thead><tr><th class="table-id">ID</th><th>Shift Name</th><th>Start Time</th><th>End Time</th><th>Late After</th><th>Early Before</th><th ng-if="vm.isCompanyAdmin == true">Office Name</th><th>Status</th><th>Action</th></tr></thead><tbody><tr ng-repeat="item in vm.allShifts" ng-if="item.status != -1"><td class="table-id">{{$index+1}}</td><td>{{item.name}}</td><td>{{item.startTime}}</td><td>{{item.endTime}}</td><td>{{item.lateCountStartTime}}</td><td>{{item.earlyCountEndTime}}</td><td ng-if="vm.isCompanyAdmin == true">{{item.office.name}}</td><td ng-if="item.status==1">Active</td><td ng-if="item.status==0">Inactive</td><td ng-if="item.status==-1">Deleted</td><td class="button-row"><upgrade-link code="5002"><a class="actionIcons" href="" tooltips="" tooltip-template="Edit"><i class="ion-ios-compose-outline" ng-click="vm.openEditModal(item)"></i></a>&nbsp;&nbsp;</upgrade-link><a class="actionIcons" href="" tooltips="" tooltip-template="Delete"><i class="ion-android-delete" ng-click="vm.openDeleteModal(item)"></i></a></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/settings/specialDays/specialDayTable.partial.html','<style>\n    .table th, .table td {\n       \n        text-align: center; /* Centers text horizontally */\n      \n    }\n   \n    \n    .workplace-list {\n        text-align: center; /* Aligns text to the left within the list */\n       \n        padding-left: 0px; /* Adds some padding to the left */\n        \n       \n    }\n    </style><div ng-controller="SpecialDayTableCtrl as vm"><div class="d-flex-space-between"><div><span class="ml-5 font-18 color-22222 font-weight-400" id="event-editor" translate="">{{\'specialDaySettings.editSectionHeader\'}}</span></div><div><button class="btn btn-md-with-icon btn-primary mr-5" ng-click="vm.openCreateModal()"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'specialDaySettings.addButton\'}}</span></button></div></div><div class="mt-10"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip calendarEdit"><thead><tr><th class="text-center width-10" translate="">{{ \'commonKeywords.sl\' }}</th><th class="text-left width-20" style="max-width: 200px; word-wrap: break-word; white-space: normal;" translate="">{{ \'specialDaySettings.tableHeader.title\' }}</th><th class="workplaces-column width-30" translate="">{{ \'specialDaySettings.tableHeader.workplaces\' }}</th><th class="date-column width-20" translate="">{{ \'specialDaySettings.tableHeader.date\' }}</th><th class="text-center width-15" translate="">{{ \'specialDaySettings.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-repeat="event in vm.events"><td class="text-center">{{$index + 1}}</td><td class="title-column" style="max-width: 200px; word-wrap: break-word; white-space: normal;">{{event.title}}</td><td class="workplaces-column"><ul class="workplace-list"><li ng-repeat="workplace in event.workplaces">{{workplace.name}}</li></ul></td><td class="date-column">{{event.startDate | date: "dd MMM yyyy"}} - {{event.endDate | date: "dd MMM yyyy"}}</td><td class="text-center"><div class="horizontal-left"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openUpdateModal(event, $index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(event, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/settings/specialDays/specialDays.html','<style>\n    mwl-calendar .cal-day-today {\n        background-color: var(--color-secondary);\n        color: white;\n    }\n    mwl-calendar span[data-cal-date]{\n        opacity: .9;\n    }\n    mwl-calendar .cal-day-today span[data-cal-date]{\n        color: white;\n    }\n    .calendar-top{\n        display: flex;\n        justify-content: space-between;\n    }\n    mwl-calendar .cal-event-list .event.pull-left {\n       margin-top: 0px;\n    }\n    mwl-calendar .cal-event-list .event{\n        background-color: var(--color-secondary) !important;\n    }\n    mwl-calendar .event{\n        background-color: var(--color-secondary) !important;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'specialDaySettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8 col-md-offset-2 calendar-top"><div class="btn-group"><button class="btn btn-md btn-secondary" mwl-date-modifier="" date="vm.viewDate" set-to-today="" ng-click="vm.cellIsOpen = false">{{ \'specialDaySettings.todayButton\' | translate }}</button></div><div class="d-flex-center-gap-10"><button class="btn btn-md btn-primary" mwl-date-modifier="" date="vm.viewDate" decrement="vm.calendarView" ng-click="vm.cellIsOpen = false"><i class="ion-chevron-left"></i></button><h2 class="mt-10">{{ vm.calendarTitle }}</h2><button class="btn btn-md btn-primary" mwl-date-modifier="" date="vm.viewDate" increment="vm.calendarView" ng-click="vm.cellIsOpen = false"><i class="ion-chevron-right"></i></button></div><div class="btn-group"><label class="btn btn-md btn-secondary" ng-model="vm.calendarView" uib-btn-radio="\'year\'" ng-click="vm.cellIsOpen = false">{{ \'specialDaySettings.yearRadioLabel\' | translate }}</label> <label class="btn btn-md btn-secondary" ng-model="vm.calendarView" uib-btn-radio="\'month\'" ng-click="vm.cellIsOpen = false">{{ \'specialDaySettings.monthRadioLabel\' | translate }}</label></div></div></div><br><br><div class="row"><mwl-calendar events="vm.events" view="vm.calendarView" view-title="vm.calendarTitle" view-date="vm.viewDate" cell-is-open="vm.cellIsOpen" day-view-start="06:00" day-view-end="22:59" day-view-split="30" cell-auto-open-disabled="true" on-timespan-click="vm.timespanClicked(calendarDate, calendarCell)" cell-modifier="vm.cellModifier(calendarCell)" class="col-md-8 col-md-offset-2"></mwl-calendar></div><br><br><br><div class="mb-20" include-with-scope="app/pages/main/settings/specialDays/specialDayTable.partial.html"></div></div>');
$templateCache.put('app/pages/main/settings/subDepartments/subDepartments.html','<div ba-panel="" ba-panel-title="{{ \'subDepartmentSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><upgrade-button code="8001"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'subDepartmentSettings.createButton\' | translate }}</span></button></upgrade-button></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'subDepartmentSettings.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'subDepartmentSettings.tableHeader.hierarchy\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'subDepartmentSettings.tableHeader.officeName\' }}</th><th class="text-center" translate="">{{ \'subDepartmentSettings.tableHeader.status\' }}</th><th class="text-center width-13" translate="">{{ \'subDepartmentSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.allSubDepartments" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-center">{{item.hierarchy}}</td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.office.name}}</td><td class="text-center" ng-show="item.status==\'1\'" translate="">{{ \'commonKeywords.statusActive\' }}</td><td class="text-center" ng-show="item.status==\'0\'" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/weeklyOffDayPolicy/weeklyOffDayPolicy.html','<div ba-panel="" ba-panel-title="Weekly Off Day Policies" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><upgrade-link code="8003"><button type="button" class="btn btn-info btn-with-icon btn-block" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i> Create Policy</button></upgrade-link></div></div><table class="table table-striped" ng-if="vm.policy.weeklyOffDaysPolicyList"><thead><tr><td class="text-center" style="vertical-align: middle!important;"><strong>SL</strong></td><td class="text-center" style="vertical-align: middle!important;"><strong>Policy Name</strong></td><td class="text-center" style="vertical-align: middle!important;"><strong>Off Days</strong></td><td class="text-center" style="vertical-align: middle!important;" ng-if="vm.isCompanyAdmin == true"><strong>Office Name</strong></td><td><strong>Actions</strong></td></tr></thead><tr ng-repeat="policy in vm.policy.weeklyOffDaysPolicyList"><td class="text-center">{{$index + 1 }}</td><td class="text-center" style="vertical-align: middle!important;" ng-click="vm.openAssignedEmployeesModal(policy)"><a href="">{{policy.name}}</a></td><td class="text-center" style="vertical-align: middle!important;">{{vm.getDaysFromString(policy.offDays)}}</td><td class="text-center" style="vertical-align: middle!important;" ng-if="vm.isCompanyAdmin == true">{{policy.office.name}}</td><td class="button-row"><upgrade-link code="8003"><a class="actionIcons" href="" tooltips="" tooltip-template="Edit"><i class="ion-ios-compose-outline" ng-click="vm.openEditModal(policy)"></i></a>&nbsp;&nbsp;</upgrade-link><a class="actionIcons" href="" tooltips="" tooltip-template="Delete"><i class="ion-android-delete" ng-click="vm.openDeleteModal(policy,$index)"></i></a></td></tr></table><div ng-if="Array.isArray(vm.policy.weeklyOffDaysPolicylist) && !vm.policy.weeklyOffDaysPolicylist"><p>No weekly Off Days Policy found.</p></div></div>');
$templateCache.put('app/pages/main/settings/subsidiary/subsidiaries.html','<div ba-panel="" ba-panel-title="Subsidiaries" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div class="d-flex-space-between mb-15"><upgrade-button code="8001"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">Create Subsidiary</span></button></upgrade-button><div class="col-md-4 col-md-offset-6"><div class="input-group"><input type="text" class="form-control" placeholder="Search Subsidiary..." ng-model="vm.searchText" ng-change="vm.filterSubsidiaries()"> <span class="input-group-addon addon-right"><i class="ion-android-search"></i></span></div></div></div><div class="horizontal-scroll scrollable-table mt-15" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5">SL</th><th class="text-left">Subsidiary Name</th><th class="text-center">Subsidiary Admin</th><th class="text-center">Status</th><th class="text-center width-13">Actions</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.filteredSubsidiaries" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-center">{{item.employeeNames || \'-\'}}</td><td class="text-center button-row" ng-show="item.status==\'1\'">Active</td><td class="text-center button-row" ng-show="item.status==\'0\'">Inactive</td><td class="text-center button-row" ng-show="item.status==\'-1\'">Archive</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2">Edit</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-if="!vm.canSubsidiaryDelete" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2">Delete</span></button></td></tr><tr ng-if="vm.filteredSubsidiaries.length === 0"><td colspan="7" class="text-center"><p class="mt-20 mb-20">No subsidiaries found</p></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/workplace/workplace.html','<div ba-panel="" ba-panel-title="{{ \'workplaceSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><div><upgrade-button code="8001"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'workplaceSettings.createButton\' | translate }}</span></button></upgrade-button></div></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center table-id width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center table-id width-10" translate="">{{ \'workplaceSettings.tableHeader.dbUid\' }}</th><th class="text-left" translate="">{{ \'workplaceSettings.tableHeader.name\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'workplaceSettings.tableHeader.officeName\' }}</th><th class="text-left" translate="">{{ \'workplaceSettings.tableHeader.latitude\' }}</th><th class="text-left" translate="">{{ \'workplaceSettings.tableHeader.longitude\' }}</th><th class="text-center" translate="">{{ \'workplaceSettings.tableHeader.status\' }}</th><th class="text-center width-13" translate="">{{ \'workplaceSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.workplaces.allworkplaces" ng-if="item.status!== -1"><td class="text-center">{{$index+1}}</td><td class="text-center">{{item.id}}</td><td class="text-left">{{item.name}}</td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.office.name}}</td><td class="text-left">{{item.latValue}}</td><td class="text-left">{{item.longValue}}</td><td class="text-center" ng-if="item.status==\'1\'" translate="">{{ \'commonKeywords.statusActive\' }}</td><td class="text-center" ng-if="item.status==\'0\'" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/roster/roster.html','<div ng-show="vm.isDataLoaded"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel"><div class="pull-right"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.openDownloadRosterModal()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.downloadExcelButton\'}}</span></button></div><uib-tabset active="vm.activeTab"><uib-tab heading="{{ \'rosterSettings.basicViewTabLabel\' | translate }}" index="0" select="vm.onBasicViewTabSelect()"><div include-with-scope="app/pages/main/shiftManagement/roster/basicView/basicView.html"></div></uib-tab><uib-tab heading="{{ \'rosterSettings.advancedViewTabLabel\' | translate }}" index="1" select="vm.onAdvancedViewTabSelect()"><div include-with-scope="app/pages/main/shiftManagement/roster/advancedView/advancedView.html"></div></uib-tab></uib-tabset><div class="mb-20"></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/dynamicShiftGroups/dynamicShiftGroups.html','<div ba-panel="" ba-panel-title="{{ \'dynamicShiftGroupSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><div><upgrade-link code="5007"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i> <span class="ml-negative-5 pb-2">{{\'dynamicShiftGroupSettings.createButton\' | translate }}</span></button></upgrade-link></div></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'dynamicShiftGroupSettings.tableHeader.name\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'dynamicShiftGroupSettings.tableHeader.officeName\' }}</th><th class="text-left" translate="">{{ \'dynamicShiftGroupSettings.tableHeader.offDays\' }}</th><th class="text-left" translate="">{{ \'dynamicShiftGroupSettings.tableHeader.activeShifts\' }}</th><th class="text-center width-13" translate="">{{ \'dynamicShiftGroupSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.shiftGroupList" ng-if="item.status!== -1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.shiftGroupName}}</td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.officeName}}</td><td class="text-left">{{item.defaultOffDaysDisplay}}</td><td class="text-left">{{item.shiftNames}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/shiftGroups/shiftGroups.html','<div ba-panel="" ba-panel-title="{{ \'shiftGroupSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><div><upgrade-link code="5007"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'shiftGroupSettings.createButton\' | translate }}</span></button></upgrade-link></div></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'shiftGroupSettings.tableHeader.name\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'shiftGroupSettings.tableHeader.officeName\' }}</th><th class="text-center" translate="">{{ \'shiftGroupSettings.tableHeader.isDefault\' }}</th><th class="text-left" translate="">{{ \'shiftGroupSettings.tableHeader.offDays\' }}</th><th class="text-center" translate="">{{ \'shiftGroupSettings.tableHeader.status\' }}</th><th class="text-center width-13" translate="">{{ \'shiftGroupSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.shiftGroupList" ng-if="item.status!== -1"><td class="text-center width-4">{{$index+1}}</td><td class="text-left rowlinks" ng-click=""><a href="">{{item.name}}</a></td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{item.officeName}}</td><td class="text-center rowlinks" ng-click="">{{item.isDefault ? \'Yes\' : \'No\'}}</td><td class="text-left">{{item.defaultOffDaysDisplay}}</td><td ng-if="item.status==\'1\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusActive\' }}</td><td ng-if="item.status==\'0\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/shifts/shifts.html','<style>\n    .table-container .table > tbody > tr > td:last-child {\n        padding-right: 3px !important;\n    }\n    .padding-x-0{\n        padding-left: 0!important;\n        padding-right: 0!important;\n    }\n    .editable-bstime .well-small{\n        padding:5px;\n    }\n    .editable-bstime .editable-input input[type="text"] {\n        width: 40px;\n    }\n    .uib-timepicker tbody .uib-time .btn {\n        padding: 3px 2px!important;\n    }\n    .editable-input tbody tr{\n        height: 24px!important;\n    }\n    .table thead tr th {\n        white-space: normal !important;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'shiftSettings.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><div><upgrade-link code="[\'5003\',\'8001\']"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'shiftSettings.createButton\' | translate }}</span></button></upgrade-link></div></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'shiftSettings.tableHeader.name\' }}</th><th class="text-center" ng-if="vm.isCompanyAdmin == true" translate="">{{ \'shiftSettings.tableHeader.officeName\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.startTime\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.endTime\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.lateAfter\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.earlyExitBefore\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.firstHalfEndsAt\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.breakEndsAt\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.colour\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.isDefaultShift\' }}</th><th class="text-center" translate="">{{ \'shiftSettings.tableHeader.status\' }}</th><th class="text-center width-11" translate="">{{ \'shiftSettings.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.shiftList" ng-if="item.status!== -1"><td class="text-center">{{$index+1}}</td><td class="text-left rowlinks" ng-click=""><a href="">{{item.name}} ( {{item.initial}} )</a></td><td class="text-center" ng-if="vm.isCompanyAdmin == true">{{vm.getOfficeName(item.officeId)}}</td><td class="text-center">{{vm.viewStartTime(item.startTime)}}</td><td class="text-center">{{vm.viewOtherTimes(item.startTime, item.workHour)}}</td><td class="text-center">{{vm.viewOtherTimes(item.startTime, item.lateOffsetFromStartTime)}}</td><td class="text-center">{{vm.viewOtherTimes(item.startTime, item.earlyExitOffsetFromStartTime)}}</td><td class="text-center">{{vm.viewOtherTimes(item.startTime, item.firstHalfDuration)}}</td><td class="text-center">{{vm.viewBreakTimeEnds(item.startTime, item.firstHalfDuration, item.breakDuration)}}</td><td class="text-center"><div ng-style="{\'background-color\': item.color}" style="width: 20px;height:20px;margin: auto;"></div></td><td class="text-center">{{item.isDefault ? \'Yes\' : \'No\'}}</td><td class="text-center" ng-if="item.status==\'1\'" translate="">{{ \'commonKeywords.statusActive\' }}</td><td class="text-center" ng-if="item.status==\'0\'" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/manageSites/manageSites.html','<style>\n    .table thead tr th {\n        white-space: normal !important;\n    }\n\n    .table > thead > tr > th:last-child {\n        padding-right: 5px !important;\n    }\n\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n\n    .panel .panel-body {\n        min-height: 600px;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'siteManagement.siteManagementTitle\' | translate}}" ba-panel-class="with-scroll"><div class="row mt-10"><div class="col-md-12"><button class="btn btn-md-with-icon btn-primary" ui-sref="siteManagement.createSites"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-3" translate="">{{\'siteManagement.createSites\'}}</span></button></div></div><div class="row mt-20"><div class="col-md-12"><div class="horizontal-scroll scrollable-table report-container" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><thead><tr><th class="width-3 text-left" translate="">sl</th><th class="width-15 text-left" translate="">{{\'siteManagement.siteName\'}}</th><th class="width-15 text-left" translate="">address</th><th class="width-7 text-left" translate="">latitude</th><th class="text-left" translate="">longitude</th><th class="width-20 text-left" translate="">{{\'siteManagement.siteManager\'}}</th><th class="text-center" translate="">numberOfEmployees</th><th class="text-center" translate="">status</th><th class="text-center" translate="">actions</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.allSitesInformation.length > 0"><tr class="height-5-vh" ng-repeat="data in vm.allSitesInformation"><td class="text-left">{{$index+(vm.selectedPage*10)+1}}</td><td class="text-left">{{data.name}}</td><td class="text-left">{{data.location}}</td><td class="text-left">{{data.latitude}}</td><td class="text-left">{{data.longitude}}</td><td class="text-left"><employee-picture-and-information name="data.managerName" picture-url="data.managerPictureUrl == (null || \'Not Set\') ? null : data.managerPictureUrl" department-name="data.managerDepartmentName" designation-name="data.managerDesignationName" id="data.managerId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" translate="">{{data.numberOfEmployees}}</td><td class="text-center" translate=""><span>{{data.status === 1 ? \'Active\' : \'Inactive\'}}</span></td><td class="text-center"><div class="d-flex-center-gap-10 align-items-center"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="siteManagement.viewSites({siteId : data.id})"><i class="ion-eye"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.viewButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal($index,data.id)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div></td></tr></tbody></table></div><div ng-if="vm.isDataLoaded && !vm.allSitesInformation.length"><p class="mt-10 text-center font-15"><em translate="">noDataFound</em></p></div><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" hide-no-data-message="true"></pagination-directive></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/siteManagementDashboard.html','<style>\n    .padding-top-0 .panel-body{\n        padding: 0 22px 20px 22px!important;\n    }\n    .top-active .panel-body{\n        padding-top: 10px!important;\n    }\n</style><div class="row"><div class="col-md-6"><div class="text-left"><span>{{vm.currentTime}}</span></div></div><div class="col-md-6" ng-show="vm.isSiteAdmin"><div class="filter-inline-item"><div class="row"><div class="col-md-5 pull-right"><div isteven-multi-select="" input-model="vm.allSitesList" output-model="vm.selectedSite" button-label="name" item-label="SiteName name" tick-property="ticked" output-properties="id" search-property="name" on-select-all="vm.search()" on-select-none="vm.search()" on-item-click="vm.search()" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Sites\', \'nothingSelected\' : \'All Sites\' }"></div></div></div></div></div></div><div class="row mt-20"><div class="col-12 ml-30 mr-15" include-with-scope="app/pages/main/siteManagement/siteManagementDashboard/partials/pieChart/siteManagementPieChart.html"></div></div><div class="row mt-10" ng-if="vm.isSiteAdmin && vm.selectedSite.length === 0"><div class="col-12 ml-15 mr-15" include-with-scope="app/pages/main/siteManagement/siteManagementDashboard/partials/barChart/siteBarSiteChart.html"></div></div><div class="row mt-10" ng-if="vm.isSiteManager"><div class="col-12 ml-15 mr-15" include-with-scope="app/pages/main/siteManagement/siteManagementDashboard/partials/barChart/siteBarChartForManager.html"></div></div><div class="row mt-10" ng-if="vm.isSiteAdmin && vm.selectedSite.length !== 0"><div class="col-12 ml-15 mr-15" include-with-scope="app/pages/main/siteManagement/siteManagementDashboard/partials/barChart/siteBarIndividualSiteChart.html"></div></div><div class="row mt-10 ml-0 mr-0"><div class="col-md-6 pl-0 top-active" ng-show="vm.isSiteAdmin && vm.selectedSite.length == 0"><div ba-panel="" ba-panel-title="{{\'siteManagement.topActiveSites\' | translate}}" ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.isTopActiveDataLoaded"><top-active-sites all-sites-data="vm.topActiveSites" is-data-loaded="true"></top-active-sites></div><div class="text-center mt-10" ng-if="!vm.isTopActiveDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="col-md-6 pr-0 pl-1 padding-top-0" ng-show="vm.isSiteManager || vm.selectedSite.length !== 0"><div ba-panel="" ba-panel-title="{{\'siteManagement.mostlyOnTimeEmployee\' | translate}}" ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.mostlyOnTimeDataLoaded"><list-employee-feed all-employee-data="vm.mostlyOnTimeEmployeeList" is-data-loaded="true" type="most-on-time"></list-employee-feed></div><div class="text-center mt-10" ng-if="!vm.mostlyOnTimeDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="col-md-6 pr-0 padding-top-0" ng-show="vm.isSiteAdmin && vm.selectedSite.length == 0"><div ba-panel="" ba-panel-title=\'{{"siteManagement.mostlyPresentEmployee" | translate}}\' ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.mostlyPresentDataLoaded"><list-employee-feed all-employee-data="vm.mostlyPresentEmployeeList" is-data-loaded="true" type="most-present" is-admin="true"></list-employee-feed></div><div class="text-center mt-10" ng-if="!vm.mostlyPresentDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="col-md-6 pr-0 padding-top-0" ng-show="vm.isSiteManager || vm.selectedSite.length !== 0"><div ba-panel="" ba-panel-title=\'{{"siteManagement.mostlyPresentEmployee" | translate}}\' ba-panel-class="semi-medium-panel with-scroll pb-15"><div ng-if="vm.mostlyPresentDataLoaded"><list-employee-feed all-employee-data="vm.mostlyPresentEmployeeList" is-data-loaded="true" type="most-present" is-admin="false"></list-employee-feed></div><div class="text-center mt-10" ng-if="!vm.mostlyPresentDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/sms/confirmModal/confirmSmsSend.html','<body><div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{ \'sendSms.confirmationModal.title\' | translate }}</h4></div><div class="modal-body"><p translate="">{{ \'sendSms.confirmationModal.confirmationText\' }}</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.confirm()" translate="">{{ \'sendSms.sendButton\' }}</button></div></div></body>');
$templateCache.put('app/pages/main/visitorManagement/appointmentLog/appointmentLog.html','<style>\n    .btn-modification{\n        font-size: 12px;\n        padding: 0 8px\n    }\n    .appointment-log-height-div{\n        /*height: 90vh;*/\n        position: relative;\n    }\n    .appointment-log-form-control{\n        height: 38px!important;\n    }\n    .appointment-log-date-position-left {\n        position: absolute;\n        top:9px;\n        left: 15px;\n    }\n    .appointment-log-calender-icon-position{\n        position: absolute;\n        top: 11px;\n        right: 15px;\n        font-size: 14px;\n    }\n    .visitor-container #profile-info{\n        min-width: 190px!important;\n        white-space: normal!important;\n    }\n</style><script type="text/ng-template" id="visitorSuggestions.html"><a> <div class="d-flex-align-center text-left width-100"> <div class="with-round-bg mb-0"> <img ng-if="match.model.pictureUrl != null" ng-src="{{match.model.pictureUrl}}"> <img ng-if="match.model.pictureUrl == null" src="../assets/img/theme/no-avatar.png"> </div> <div class="profile-info"> <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span> <div class=\'font-12 info-bg\'> <small>{{ match.model.organisationName }}</small> </div> </div> <div class="ml-7" ng-if="match.model.status == 2"> <i class="fa fa fa-ban font-20 text-danger"></i> </div> </div> </a></script><div ba-panel="" ba-panel-title="{{\'Appointment Log\' | translate}} <span ng-click=\'vm.makeFilterVisible()\' class=\'filter pull-right\' ng-if=\'true\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.isFilterVisible\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.isFilterVisible\' class=\'fa fa-chevron-up\'></i> </span>"><div class="row"><div class="col-md-12"><div ng-if="vm.isFilterVisible" ng-animate="slide"><div ng-if="vm.isVisitorManagementAdmin"><div class="mb-20 d-flex-gap-10"><div class="width-33"><div><div date-range-picker="" class="form-control appointment-log-form-control date-picker text-center position-relative" ng-model="vm.dates.options" options="vm.dates.options"><span class="appointment-log-date-position-left">{{vm.dates.options.startDate.format("D MMM YYYY")}} - {{vm.dates.options.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar appointment-log-calender-icon-position"></i></div></div></div><div class="width-33"><input type="text" class="form-control appointment-log-form-control" ng-model="vm.filterParams.searchKeyEmployee" ng-keydown="$event.keyCode === 13 && vm.searchFilteredAppointments()" placeholder="{{\'Employee Name/Id\' | translate}}"></div><div class="width-33"><div class="appointment-log-height-div" isteven-multi-select="" input-model="vm.allDepartmentList" output-model="vm.filterParams.selectedDepartments" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Department\' }"></div></div></div><div class="mb-20 d-flex-gap-10"><div class="width-33"><div class="appointment-log-height-div" isteven-multi-select="" input-model="vm.allStatusList" output-model="vm.filterParams.selectedStatus" button-label="label" item-label="label" tick-property="ticked" output-properties="code" search-property="label" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Status\' }"></div></div><div class="width-33"><div class="appointment-log-height-div" isteven-multi-select="" input-model="vm.visitorCategoriesList" output-model="vm.filterParams.selectedVisitorCategories" button-label="name" item-label="name" tick-property="ticked" output-properties="id name" search-property="name" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Visitor Category\' }"></div></div><div class="width-33"><input type="text" class="form-control appointment-log-form-control" ng-model="vm.filterParams.searchKeyVisitor" placeholder="{{\'visitorManagement.myVisitorProfile.search\' | translate}}" uib-typeahead="visitor as visitor.name for visitor in searchVisitor($viewValue)" typeahead-template-url="visitorSuggestions.html" typeahead-on-select="vm.setVisitorSearchKeyword($item)"></div></div></div><div ng-if="!vm.isVisitorManagementAdmin"><div class="mb-20 d-flex-gap-10"><div class="width-20"><div><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.dates.options" options="vm.dates.options"><span class="appointment-log-date-position-left">{{vm.dates.options.startDate.format("D MMM YYYY")}} - {{vm.dates.options.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar appointment-log-calender-icon-position"></i></div></div></div><div class="width-20"><input type="text" class="appointment-log-form-control" ng-model="vm.filterParams.searchKeyVisitor" uib-typeahead="visitor as visitor.name for visitor in searchVisitor($viewValue)" typeahead-template-url="visitorSuggestions.html" typeahead-on-select="vm.setVisitorSearchKeyword($item)" placeholder="{{\'visitorManagement.myVisitorProfile.search\' | translate}}"></div></div></div><div class="d-flex-align-end mb-20"><div class="width-80"></div><div class="width-20"><button type="button" class="btn btn-md btn-primary btn-block" ng-click="vm.searchFilteredAppointments()"><i class="ion-search"></i> <span translate="">{{ \'manageAllEmployees.filter.searchButton\' }}</span></button></div></div></div><div class="row"><div class="col-md-12"><div class="btn-group special" role="group" aria-label="First group"><button type="button" class="btn btn-style text-wrap border-radius-0" ng-class="vm.showAppointmentType==1 ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedAppointmentTypeToShow(1)" translate="">{{\'Today\\\'s Appointments\'}}</button> <button type="button" class="btn btn-style text-wrap" ng-class="vm.showAppointmentType==2 ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedAppointmentTypeToShow(2)" translate="">{{\'Upcoming Appointments\'}}</button> <button type="button" class="btn btn-style text-wrap" ng-class="vm.showAppointmentType==3 ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedAppointmentTypeToShow(3)" translate="">{{\'Appointments History\'}}</button></div></div></div><div class="row mb-20" ng-if="vm.isDataLoaded && vm.appointmentList.length!=0"><div class="col-md-12"><div class="horizontal-scroll report-container width-100" fixed-column-table="" fixed-columns="3"><table class="table report-table odd-child-selector"><thead><tr><th class="text-center width-3" translate="">sl</th><th class="text-center width-10" translate="">date</th><th class="text-left" translate="">{{\'visitorManagement.visitorName\'}}</th><th class="text-left" ng-if="vm.isVisitorManagementAdmin" translate="">{{\'visitorManagement.hostName\'}}</th><th class="text-left" translate="">{{\'visitorManagement.visitorMobile\'}}</th><th class="text-left" translate="">{{\'visitorManagement.accessArea.title\'}}</th><th class="text-left" translate="">reason</th><th class="text-center" ng-if="vm.showAppointmentType==3" translate="">{{\'visitorManagement.checkIn\'}}</th><th class="text-center" ng-if="vm.showAppointmentType==3" translate="">{{\'visitorManagement.checkOut\'}}</th><th class="text-center" ng-if="vm.showAppointmentType!=3" translate="">entry</th><th class="text-center" ng-if="vm.showAppointmentType!=3" translate="">exit</th><th class="text-center" translate="">status</th><th class="text-center width-12" ng-if="vm.showAppointmentType!=3" translate="">actions</th></tr></thead><tbody><tr ng-repeat="data in vm.appointmentList" class=""><td class="text-center"><span class="pb-2" translate="">{{$index+(vm.filterParams.selectedPage*10)+1}}</span></td><td class="dont-wrap-text text-center"><span>{{data.dateInMillis | date: "d MMM yyyy" }}</span></td><td class="text-center visitor-container"><visitor-picture-and-information name="data.visitorName" picture-url="data.visitorPictureUrl" company-name="!data.visitorOrganizationName ? \'N/A\':data.visitorOrganizationName" is-clickable="false"></visitor-picture-and-information></td><td class="text-center" ng-if="vm.isVisitorManagementAdmin"><employee-picture-and-information name="data.hostName" picture-url="data.pictureUrl" department-name="data.departmentName" designation-name="!data.designationName ? \'N/A\':data.designationName" id="data.id" is-clickable="false"></employee-picture-and-information></td><td class="dont-wrap-text text-left"><span>{{data.visitorMobile}}</span></td><td class="dont-wrap-text text-left"><span>{{data.accessAreaName?data.accessAreaName:"N/A"}}</span></td><td class="dont-wrap-text text-left"><span>{{data.reason}}</span></td><td class="dont-wrap-text text-center"><span class="text-success" ng-if="vm.showAppointmentType==3">{{data.checkIn==null?\'--\':data.checkIn | date: "hh:mm a" }}</span> <span class="text-success" ng-if="vm.showAppointmentType != 3">{{data.entryTime | date: "hh:mm a" }}</span></td><td class="dont-wrap-text text-center"><span class="text-danger" ng-if="vm.showAppointmentType==3">{{data.checkOut==null?\'--\':data.checkOut | date: "hh:mm a" }}</span> <span class="text-danger" ng-if="vm.showAppointmentType!=3">{{data.exitTime | date: "hh:mm a" }}</span></td><td ng-if="data.status==\'Active\'" class="text-center">{{data.status}}</td><td ng-if="data.status==\'Missed\'" class="text-center"><span class="text-danger">{{data.status}}</span></td><td ng-if="data.status==\'Completed\'" class="text-center"><span class="green-text">{{data.status}}</span></td><td ng-if="data.status==\'Cancelled\'" class="text-center"><span class="text-danger">{{data.status}}</span></td><td class="text-center" ng-if="(data.entryTime >= vm.startTimeOfDay) && (vm.showAppointmentType!=3) && (data.status!=\'Cancelled\')"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEdit(data)"><i class="ion-ios-compose-outline"></i><span class="pb-2" translate="">{{\'visitorManagement.myVisitorProfile.visitorEdit\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openCancelAppointmentModal(data.appointmentId)"><i class="ion-ios-close-outline"></i><span class="pb-2" translate="">{{"Cancel"}}</span></button></td><td class="text-center" ng-if="((data.entryTime <= vm.startTimeOfDay) || (data.status == \'Cancelled\')) && (vm.showAppointmentType!=3)"><span>{{\'N/A\'}}</span></td></tr></tbody></table><div class="text-center" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-50" ng-if="vm.isDataLoaded && vm.appointmentList.length==0"><p><strong translate="">{{\'No results found matching your search/filter criteria\'}}</strong></p></div></div><pagination-directive ng-if="true" number-of-pages="vm.filterParams.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.filterParams.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getAppointmentPageSpecifiedData" not-found-text="\'No data available\'"></pagination-directive></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/createAppointment/createAppointment.html','<script type="text/ng-template" id="mobileNumberSuggestions.html"><a> <div class="d-flex-align-center text-left width-100"> <div class="with-round-bg mb-0"> <img ng-if="match.model.pictureUrl != null" ng-src="{{match.model.pictureUrl}}"> <img ng-if="match.model.pictureUrl == null" src="../assets/img/theme/no-avatar.png"> </div> <div class="profile-info"> <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span> </div> <div class="ml-7" ng-if="match.model.status == 2"> <i class="fa fa fa-ban font-20 text-danger"></i> </div> </div> <!-- <img ng-if="match.model.pictureUrl != null" ng-src="{{match.model.pictureUrl}}" width="20">--> <!-- <img ng-if="match.model.pictureUrl == null" src="../assets/img/theme/no-photo.png" width="20">--> <!-- <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span>--> </a></script><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Create New Appointment" ba-panel-class="with-scroll panel-full-screen"><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div ng-if="vm.currentState === \'visitorInformationEntry\'"><form name="vm.createVisitorForm" novalidate="" autocomplete="off"><div class="row mt-10"><p class="text-center mb-20"><strong translate="">{{ \'visitorManagement.createAppointment.visitorInformationEntry\' }}</strong></p><div class="col-md-6"><div class="form-group mb-10"><div class="flex-container text-left width-100"><div class="with-round-bg mb-0"><img ng-if="!vm.visitor.pictureUrl" src="../assets/img/theme/no-avatar.png"> <img ng-if="vm.visitor.pictureUrl" src="{{vm.visitor.pictureUrl}}"></div><div class="profile-info"><a class="link-btn" href="" ng-click="vm.openPhotoCaptureModal()" target="_self"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.uploadOrTakePhoto\' }}</span></a></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.visitorMobile.$invalid && vm.createVisitorForm.visitorMobile.$touched}"><input type="text" autocomplete="off" name="visitorMobile" class="form-control" ng-model="vm.visitor.mobile" placeholder="Mobile Number" uib-typeahead="visitor.mobile as visitor.name for visitor in vm.existingVisitors | filter:{mobile:$viewValue}" typeahead-template-url="mobileNumberSuggestions.html" typeahead-on-select="vm.setVisitorInputs($item)" tabindex="1" pattern="[0-9]{0,15}" required=""> <small class="text-danger" ng-if="vm.createVisitorForm.visitorMobile.$invalid && vm.createVisitorForm.visitorMobile.$touched">Mobile number must be a number(1-9)</small></div><div class="custom-select mb-15" ng-class="{\'has-error\': vm.createVisitorForm.visitorCategory.$invalid && vm.createVisitorForm.visitorCategory.$touched}"><select class="" name="visitorCategory" ng-model="vm.visitor.categoryId" ng-options="item.id as item.name for item in vm.visitorCategories" tabindex="4" required=""><option value="" class="placeholder" translate="">{{\'visitorManagement.createAppointment.selectCategory\'}}</option></select></div><div ng-if="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationName" tabindex="6" placeholder="Organisation Name"></div><div ng-show="vm.showAdvancedInputs" class="custom-select mb-15"><select ng-model="vm.visitor.bloodGroup" ng-options="item.id as item.name for item in vm.bloodGroups" tabindex="8"><option value="" class="placeholder" translate="">{{\'visitorManagement.createAppointment.selectBloodGroup\'}}</option></select></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.visitorName.$invalid && vm.createVisitorForm.visitorName.$touched}"><input type="text" class="form-control" name="visitorName" ng-model="vm.visitor.name" placeholder="Visitor Name" tabindex="2" required=""></div><div class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.email" tabindex="3" placeholder="Email"></div><div ng-if="!vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationName" tabindex="5" placeholder="Organisation Name"></div><div ng-show="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationBranch" tabindex="5" placeholder="Branch"></div><div ng-show="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.address" tabindex="7" placeholder="Address"></div><div ng-show="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.nidNumber" tabindex="9" placeholder="NID"></div></div></div><div ng-show="vm.showAdvancedInputs" class="row mt-10"><div class="col-md-6 text-left"><div class="form-group mb-0"><label translate="">{{\'visitorManagement.createAppointment.emergencyContactLabel\'}}</label></div></div></div><div ng-show="vm.showAdvancedInputs" class="row"><div class="col-md-6"><div class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.emergencyContactName" tabindex="10" placeholder="Contact Name"></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.emergencyContactMobile.$invalid && vm.createVisitorForm.emergencyContactMobile.$touched}"><input type="text" name="emergencyContactMobile" class="form-control" ng-model="vm.visitor.emergencyContactMobile" tabindex="11" pattern="[0-9]{0,15}" placeholder="Mobile Number"> <small class="text-danger" ng-if="vm.createVisitorForm.emergencyContactMobile.$invalid && vm.createVisitorForm.emergencyContactMobile.$touched">Mobile number must be a number(1-9)</small></div></div></div><div class="row"><div class="col-md-6"><a class="link-btn" href="" ng-click="vm.toggleAdvanced()" target="_self"><span ng-if="vm.showAdvancedInputs" class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.lessAdvancedButton\' }}</span> <span ng-if="!vm.showAdvancedInputs" class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.advancedButton\' }}</span></a></div><div class="col-md-6"><a class="link-btn pull-right" href="" ng-click="vm.addVisitor()" target="_self"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.addVisitorButton\' }}</span></a></div></div><div class="row mt-20" ng-show="vm.visitors.length > 0"><div class="col-md-12"><div class="tag-container gray-bg"><div class="tag-group" data-ng-repeat="visitor in vm.visitors"><div class="tag-item"><div class="info-with-avatar"><employee-picture-and-information name="visitor.name" picture-url="visitor.pictureUrl" department-name="" designation-name="" is-clickable="false"></employee-picture-and-information></div><div class="remove-tag"><i class="ion-close" ng-click="vm.removeVisitor($index)"></i></div></div></div></div></div></div><div class="row mt-20"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon pull-right" ng-disabled="vm.createVisitorForm.$invalid && vm.visitors.length === 0" ng-class="{\'btn-disable\' : (vm.createVisitorForm.$invalid && vm.visitors.length === 0), \'btn-secondary\' : (!vm.createVisitorForm.$invalid || vm.visitors.length > 0)}" ng-click="vm.goToNextState()"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.nextButton\' }}</span> <i class="fa fa-angle-double-right"></i></button></div></div></form></div><div ng-if="vm.currentState === \'hostInformationEntry\'"><form name="vm.createAppointmentForm" novalidate="" autocomplete="false"><div class="row mt-10"><p class="text-center"><strong translate="">{{ \'visitorManagement.createAppointment.confirmAppointment\' }}</strong></p><div class="col-md-12"><div class="form-group"><div class="mt-15" ng-if="vm.isVisitorManagementAdmin"><employee-type-ahead-search select-method="vm.searchByEmployeeId" keyword="vm.searchKeyword" show-label="false" is-required="false" selected-employee="vm.selectedHost" is-host-selection="true"></employee-type-ahead-search></div><div class="form-group has-feedback has-search mt-15" ng-if="!vm.isVisitorManagementAdmin"><input type="text" class="form-control form-control-text-input dark-bg ng-pristine ng-untouched ng-valid ng-not-empty" ng-model="vm.selectedHost.name" disabled="" readonly=""></div></div></div></div><div class="row"><div class="col-md-6"><div isteven-multi-select="" input-model="vm.accessAreas" output-model="vm.selectedAccessAreaId" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name code" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Reset\', \'search\' : \'Search By Name/Code...\', \'nothingSelected\' : \'Access Area\' }"></div></div><div class="col-md-6"><div isteven-multi-select="" input-model="vm.visitPurposes" output-model="vm.selectedVisitPurposeId" button-label="text" item-label="text" tick-property="ticked" output-properties="id" search-property="text" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Reset\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Purpose of Visit\' }"></div></div></div><div class="row mt-20"><div class="col-md-12"><div class="form-group"><label translate="">{{ \'visitorManagement.createAppointment.selectDate\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.appointment.date" options="vm.datePicker.options"><span>{{vm.appointment.date.format("DD MMM YYYY")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{ \'visitorManagement.createAppointment.entryTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.appointment.entryTime" options="vm.timePicker.options"><span>{{vm.appointment.entryTime.format("hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-clock-o"></i></span></div></div></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{ \'visitorManagement.createAppointment.exitTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.appointment.exitTime" options="vm.timePicker.options"><span>{{vm.appointment.exitTime.format("hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-clock-o"></i></span></div></div></div></div></div><div class="row" ng-show="vm.visitors.length > 0"><div class="col-md-12"><div class="gray-bg"><p class="text-center pt-15 mb-0" translate="">{{ \'visitorManagement.createAppointment.visitors\' }}</p><div class="tag-container"><div class="tag-group" data-ng-repeat="visitor in vm.visitors"><div class="tag-item"><div class="info-with-avatar"><employee-picture-and-information name="visitor.name" picture-url="visitor.pictureUrl" department-name="" designation-name="" is-clickable="false"></employee-picture-and-information></div><div class="remove-tag"><i class="ion-close" ng-click="vm.removeVisitor($index)"></i></div></div></div></div></div></div></div><div class="row mt-20"><div class="col-md-6"><div class="btn-group width-100" uib-dropdown="" keyboard-nav=""><button id="invitation-type" type="button" class="btn btn-md-with-icon dropdown-btn btn-block d-flex-space-between" uib-dropdown-toggle=""><div><i class="fa fa-paper-plane-o"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'visitorManagement.createAppointment.sendInvitation\' }}</span> <span class="ml-negative-5 pb-2">&nbsp;{{vm.invitationTypeDropDownLabel}}</span></div><span class="caret"></span></button><ul class="dropdown-menu gray-dropdown width-100" uib-dropdown-menu="" role="menu" aria-labelledby="invitation-type"><li role="menuitem" ng-repeat-start="invitationType in vm.invitationTypes"><a href="" ng-click="vm.selectInvitationType($index)" target="_self">{{ invitationType.name }}</a></li><li ng-repeat-end="" ng-if="$index < vm.invitationTypes.length - 1" class="divider" style="padding: 0px 20px;"></li></ul></div></div></div><div class="row mt-25"><div class="col-md-12 d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.goToBackState()" translate="">{{\'commonKeywords.backButton\'}}</button> <button type="button" class="btn btn-md-with-icon" ng-disabled="vm.invalidAppointmentForm()" ng-class="{\'btn-disable\' : vm.invalidAppointmentForm(), \'btn-secondary\' : !vm.invalidAppointmentForm()}" ng-click="vm.confirmAppointment()"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.confirmAppointment\' }}</span> <i class="fa fa-calendar-check-o"></i></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/editAppointment/editAppointment.html','<script type="text/ng-template" id="mobileNumberSuggestions.html"><a> <div class="d-flex-align-center text-left width-100"> <div class="with-round-bg mb-0"> <img ng-if="match.model.pictureUrl != null" ng-src="{{match.model.pictureUrl}}"> <img ng-if="match.model.pictureUrl == null" src="../assets/img/theme/no-avatar.png"> </div> <div class="profile-info"> <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span> </div> <div class="ml-7" ng-if="match.model.status == 2"> <i class="fa fa fa-ban font-20 text-danger"></i> </div> </div> <!-- <img ng-if="match.model.pictureUrl != null" ng-src="{{match.model.pictureUrl}}" width="20">--> <!-- <img ng-if="match.model.pictureUrl == null" src="../assets/img/theme/no-photo.png" width="20">--> <!-- <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span>--> </a></script><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Edit Appointment" ba-panel-class="with-scroll panel-full-screen"><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div ng-if="vm.currentState === \'visitorInformationEntry\'"><form name="vm.createVisitorForm" novalidate="" autocomplete="off"><div class="row mt-10"><p class="text-center mb-20"><strong translate="">{{ \'visitorManagement.createAppointment.visitorInformationEntry\' }}</strong></p><div class="col-md-6"><div class="form-group mb-10"><div class="flex-container text-left width-100"><div class="with-round-bg mb-0"><img src="../assets/img/theme/no-avatar.png"></div><div class="profile-info"><a class="link-btn" href="" ng-click="vm.openPhotoCaptureModal()" target="_self"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.uploadOrTakePhoto\' }}</span></a></div></div></div><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.visitorMobile.$invalid && vm.createVisitorForm.visitorMobile.$touched}"><input type="text" autocomplete="disabled" name="visitorMobile" class="form-control" ng-model="vm.visitor.mobile" placeholder="Mobile Number" uib-typeahead="visitor.mobile as visitor.name for visitor in vm.existingVisitors | filter:{mobile:$viewValue}" typeahead-template-url="mobileNumberSuggestions.html" typeahead-on-select="vm.setVisitorInputs($item)" tabindex="1" required=""></div><div class="custom-select mb-15" ng-class="{\'has-error\': vm.createVisitorForm.visitorCategory.$invalid && vm.createVisitorForm.visitorCategory.$touched}"><select class="" name="visitorCategory" ng-model="vm.visitor.categoryId" ng-options="item.id as item.name for item in vm.visitorCategories" tabindex="4" required=""><option value="" class="placeholder" translate="">{{\'visitorManagement.createAppointment.selectCategory\'}}</option></select></div><div ng-if="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationName" tabindex="6" placeholder="Organisation Name"></div><div ng-show="vm.showAdvancedInputs" class="custom-select mb-15"><select ng-model="vm.visitor.bloodGroup" ng-options="item.id as item.name for item in vm.bloodGroups" tabindex="8"><option value="" class="placeholder" translate="">{{\'visitorManagement.createAppointment.selectBloodGroup\'}}</option></select></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.visitorName.$invalid && vm.createVisitorForm.visitorName.$touched}"><input type="text" class="form-control" name="visitorName" ng-model="vm.visitor.name" placeholder="Visitor Name" tabindex="2" required=""></div><div class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.email" tabindex="3" placeholder="Email"></div><div ng-if="!vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationName" tabindex="5" placeholder="Organisation Name"></div><div ng-show="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationBranch" tabindex="5" placeholder="Branch"></div><div ng-show="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.address" tabindex="7" placeholder="Address"></div><div ng-show="vm.showAdvancedInputs" class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.nidNumber" tabindex="9" placeholder="NID"></div></div></div><div ng-show="vm.showAdvancedInputs" class="row mt-10"><div class="col-md-6 text-left"><div class="form-group mb-0"><label translate="">{{\'visitorManagement.createAppointment.emergencyContactLabel\'}}</label></div></div></div><div ng-show="vm.showAdvancedInputs" class="row"><div class="col-md-6"><div class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.emergencyContactName" tabindex="10" placeholder="Contact Name"></div></div><div class="col-md-6"><div class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.emergencyContactMobile" tabindex="11" placeholder="Mobile Number"></div></div></div><div class="row"><div class="col-md-6"><a class="link-btn" href="" ng-click="vm.toggleAdvanced()" target="_self"><span ng-if="vm.showAdvancedInputs" class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.lessAdvancedButton\' }}</span> <span ng-if="!vm.showAdvancedInputs" class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.advancedButton\' }}</span></a></div><div class="col-md-6"><a class="link-btn pull-right" href="" ng-click="vm.addVisitor()" target="_self"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.addVisitorButton\' }}</span></a></div></div><div class="row mt-20" ng-show="vm.visitors.length > 0"><div class="col-md-12"><div class="tag-container gray-bg"><div class="tag-group" data-ng-repeat="visitor in vm.visitors"><div class="tag-item"><div class="info-with-avatar"><employee-picture-and-information name="visitor.name" picture-url="visitor.pictureUrl" department-name="" designation-name="" is-clickable="false"></employee-picture-and-information></div><div class="remove-tag"><i class="ion-close" ng-click="vm.removeVisitor($index)"></i></div></div></div></div></div></div><div class="row mt-20"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon pull-right" ng-disabled="vm.createVisitorForm.$invalid && vm.visitors.length === 0" ng-class="{\'btn-disable\' : (vm.createVisitorForm.$invalid && vm.visitors.length === 0), \'btn-secondary\' : (!vm.createVisitorForm.$invalid || vm.visitors.length > 0)}" ng-click="vm.goToNextState()"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.nextButton\' }}</span> <i class="fa fa-angle-double-right"></i></button></div></div></form></div><div ng-if="vm.currentState === \'hostInformationEntry\'"><form name="vm.createAppointmentForm" novalidate="" autocomplete="false"><div class="row mt-10"><p class="text-center"><strong translate="">{{ \'visitorManagement.createAppointment.confirmAppointment\' }}</strong></p><div class="col-md-12"><div class="form-group"><p class="text-center" translate="">{{ \'visitorManagement.createAppointment.selectHost\' }}</p><div class="mt-15" ng-if="vm.isVisitorManagementAdmin"><employee-type-ahead-search select-method="vm.searchByEmployeeId" keyword="vm.searchKeyword" show-label="false" is-required="false" selected-employee="vm.selectedHost"></employee-type-ahead-search></div><div class="form-group has-feedback has-search mt-15" ng-if="!vm.isVisitorManagementAdmin"><input type="text" class="form-control form-control-text-input dark-bg ng-pristine ng-untouched ng-valid ng-not-empty" ng-model="vm.selectedHost.name" disabled="" readonly=""></div></div></div></div><div class="row"><div class="col-md-6"><div isteven-multi-select="" input-model="vm.accessAreas" output-model="vm.selectedAccessAreaId" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name code" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/Code...\', \'nothingSelected\' : \'Access Area\' }"></div></div><div class="col-md-6"><div isteven-multi-select="" input-model="vm.visitPurposes" output-model="vm.selectedVisitPurposeId" button-label="text" item-label="text" tick-property="ticked" output-properties="id" search-property="text" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Purpose of Visit\' }"></div></div></div><div class="row mt-20"><div class="col-md-12"><div class="form-group"><label translate="">{{ \'visitorManagement.createAppointment.selectDate\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.appointment.date" options="vm.datePicker.options"><span>{{vm.appointment.date.format("DD MMM YYYY")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label translate="">{{ \'visitorManagement.createAppointment.entryTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.appointment.entryTime" options="vm.timePicker.options"><span>{{vm.appointment.entryTime.format("hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-clock-o"></i></span></div></div></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{ \'visitorManagement.createAppointment.exitTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.appointment.exitTime" options="vm.timePicker.options"><span>{{vm.appointment.exitTime.format("hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-clock-o"></i></span></div></div></div></div></div><div class="row" ng-show="vm.visitors.length > 0"><div class="col-md-12"><div class="gray-bg"><p class="text-center pt-15 mb-0" translate="">{{ \'visitorManagement.createAppointment.visitors\' }}</p><div class="tag-container"><div class="tag-group" data-ng-repeat="visitor in vm.visitors"><div class="tag-item"><div class="info-with-avatar"><employee-picture-and-information name="visitor.name" picture-url="visitor.pictureUrl" department-name="" designation-name="" is-clickable="false"></employee-picture-and-information></div><div class="remove-tag"><i class="ion-close" ng-click="vm.removeVisitor($index)"></i></div></div></div></div></div></div></div><div class="row mt-20"><div class="col-md-6"></div><div class="col-md-6"><div class="btn-group width-100" uib-dropdown="" keyboard-nav=""><button id="invitation-type" type="button" class="btn btn-md-with-icon dropdown-btn btn-block d-flex-space-between" uib-dropdown-toggle=""><div><i class="fa fa-paper-plane-o"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'visitorManagement.createAppointment.sendInvitation\' }}</span> <span class="ml-negative-5 pb-2">&nbsp;{{vm.invitationTypeDropDownLabel}}</span></div><span class="caret"></span></button><ul class="dropdown-menu gray-dropdown width-100" uib-dropdown-menu="" role="menu" aria-labelledby="invitation-type"><li role="menuitem" ng-repeat-start="invitationType in vm.invitationTypes"><a href="" ng-click="vm.selectInvitationType($index)" target="_self">{{ invitationType.name }}</a></li><li ng-repeat-end="" ng-if="$index < vm.invitationTypes.length - 1" class="divider" style="padding: 0px 20px;"></li></ul></div></div></div><div class="row row mt-20"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon pull-right" ng-disabled="vm.invalidAppointmentForm()" ng-class="{\'btn-disable\' : vm.invalidAppointmentForm(), \'btn-secondary\' : !vm.invalidAppointmentForm()}" ng-click="vm.confirmAppointment()"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.confirmAppointment\' }}</span> <i class="fa fa-calendar-check-o"></i></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/modals/success.modal.html','<div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div class="col-md-12"><div class="text-center-important"><h2 class="color-prime" translate="">{{ \'visitorManagement.successModal.headerText\' }}</h2><p translate="">{{ vm.successMsg }}</p></div></div></div><div class="footer"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/reception.html','<div class="row"><div class="col-md-6" include-with-scope="app/pages/main/visitorManagement/reception/partials/checkIn/checkIn.html"></div><div class="col-md-6" include-with-scope="app/pages/main/visitorManagement/reception/partials/checkOut/checkOut.html"></div></div>');
$templateCache.put('app/pages/main/visitorManagement/myVisitorProfile/myVisitorProfile.html','<style>\n    .font-20 {\n        font-size: 20px!important;\n    }\n    .table > thead > tr > th:last-child {\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n    .section-min-width{\n        min-width: 172px;\n    }\n    .button-min-width{\n        min-width: 89px;\n        padding-right: 25px;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'visitorManagement.myVisitorProfile.title\' | translate}}"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="form-group has-feedback has-search mb-20"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyWord" ng-keydown="$event.keyCode === 13 && vm.getVisitorBasedOnKeyWord()" placeholder="{{\'visitorManagement.myVisitorProfile.search\' | translate}}"></div></div></div><div class="row"><div class="col-md-12"><div class="btn-group special" role="group" aria-label="First group"><button type="button" class="btn btn-style text-wrap border-radius-0" ng-class="vm.showAllVisitorToggle == 1 ?\'selected-table-toggle-button\': \'\'" ng-click="vm.setSelectedApplicationTypeUpcoming()" translate="">{{\'visitorManagement.myVisitorProfile.upComingVisitors\'}}</button> <button type="button" class="btn btn-style text-wrap" ng-class="vm.showAllVisitorToggle == 2 ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedApplicationTypeAll()" translate="">{{\'visitorManagement.myVisitorProfile.allVisitors\'}}</button> <button type="button" class="btn btn-style text-wrap border-radius-0" ng-class="vm.showAllVisitorToggle==3 ? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedApplicationTypeBlocked()" translate="">{{\'visitorManagement.myVisitorProfile.visitorsBlocked\'}}</button></div></div></div><div class="text-center" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-if="vm.isDataLoaded && vm.visitorProfileList.length == 0"><p><strong translate="">{{\'visitorManagement.myVisitorProfile.noResultFoundText\'}}</strong></p></div><div class="row mb-20" ng-if="vm.visitorProfileList.length > 0 && vm.isDataLoaded"><div class="col-md-12"><table class="table borderless-table odd-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-40"><col class="width-20"></colgroup><thead><tr class="height-5-vh"><th class="text-center" translate="">sl</th><th class="text-left" translate="">{{\'visitorManagement.myVisitorProfile.visitorNames\'}}</th><th class="text-center" translate="">{{\'visitorManagement.myVisitorProfile.actions\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.visitorProfileList" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}"><td class="text-center">{{($index+(vm.selectedPage*10))+1}}</td><td class="text-center" ng-click="vm.showVisitorInfoInTheRightColumn($index,data.id)"><div class="d-flex-gap-5"><div><visitor-picture-and-information name="data.name" picture-url="data.pictureUrl" visit-purpose="data.visitPurpose" company-name="!data.organisationName ? \'N/A\':data.organisationName" is-clickable="false"></visitor-picture-and-information></div><div class="d-flex-align-center" ng-if="data.status == 2"><i class="fa fa fa-ban font-20 text-danger"></i></div></div></td><td class="text-center section-min-width"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.editPressed($index, data.id)"><i class="ion-ios-compose-outline"></i><span class="pb-2" translate="">{{\'visitorManagement.myVisitorProfile.visitorEdit\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger button-min-width" ng-click="vm.openBlockVisitorModal(data.id)" ng-if="data.status!=2"><i class="fa fa fa-ban"></i><span class="pb-2" translate="">{{\'visitorManagement.myVisitorProfile.visitorBlock\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openUnBlockVisitorModal(data.id)" ng-if="data.status==2"><i class="fa fa fa-ban"></i><span class="pb-2" translate="">{{\'Unblock\'}}</span></button></td></tr></tbody></table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getVisitorPageSpecifiedData" not-found-text="\'No data available\'"></pagination-directive></div></div></div><div class="col-md-6"><div class="row mb-15"><div class="col-md-12 d-flex-space-between"><div class="mt-12"><p class="font-16 color-22222" translate="">{{\'visitorManagement.myVisitorProfile.visitorInfoTitle\'}}</p></div></div></div><div class="position-relative height-div-visitor-profile"><div ng-if="vm.isAnyRowSelected && vm.isVisitorInfoLoaded"><div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered mt-3"><colgroup><col class="width-30"><col class="width-50"></colgroup><tbody ng-if="!vm.isEditPressed"><tr class="text-center th-bg th-width"><td colspan="2"><div class="visitor-image-and-data-with-button"><div class="width-70"><visitor-picture-and-information name="vm.visitorToShow.visitorInfo.name" picture-url="vm.visitorToShow.visitorInfo.visitorPictureUrl" visit-purpose="vm.visitorToShow.visitorInfo.visitPurpose" company-name="!vm.visitorToShow.visitorInfo.organisationName ? \'N/A\':vm.visitorToShow.organisationName" is-clickable="false"></visitor-picture-and-information></div><div><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.changeState()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'visitorManagement.myVisitorProfile.createNewVisit\' | translate }}</span></button></div></div></td></tr><tr class="text-left"><td><span translate="">{{\'visitorManagement.myVisitorProfile.visitorMobile\'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.mobile != null ? vm.visitorToShow.visitorInfo.mobile:\'N/A\'}}</span></td><td><span translate="">{{\'visitorManagement.myVisitorProfile.visitorEmail\'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.email != null ?vm.visitorToShow.visitorInfo.email:\'N/A\'}}</span></td></tr><tr class="text-left"><td><span translate="">{{\'visitorManagement.myVisitorProfile.organization\'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.organisationName != null ? vm.visitorToShow.visitorInfo.organisationName:\'N/A\'}}</span></td><td><span translate="">{{\'visitorManagement.myVisitorProfile.address\'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.address != null ? vm.visitorToShow.visitorInfo.address:\'N/A\'}}</span></td></tr><tr class="text-left"><td><span translate="">{{\'Emergency Contact Name: \'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.emergencyContactName !=null ? vm.visitorToShow.visitorInfo.emergencyContactName:\'N/A\'}}</span></td><td><span translate="">{{\'Emergency Contact Mobile :\'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.emergencyContactNumber != null ? vm.visitorToShow.visitorInfo.emergencyContactNumber:\'N/A\'}}</span></td></tr><tr class="text-left"><td><span translate="">{{\'visitorManagement.myVisitorProfile.visitorCategory\'}}</span> <span class="dark-text" translate="">{{vm.visitorToShow.visitorInfo.visitorCategoryName}}</span></td><td><div class="visitor-created-by-text-document"><div class="width-30"><span translate="">{{\'visitorManagement.myVisitorProfile.createdBy\'}}</span></div><div class="width-70"><employee-picture-and-information name="vm.visitorToShow.visitorInfo.creatorName" picture-url="vm.visitorToShow.visitorInfo.creatorPictureUrl" department-name="vm.visitorToShow.visitorInfo.creatorDepartmentName" designation-name="!vm.visitorCreatedBy.designationName ? \'N/A\':vm.visitorCreatedBy.designationName" is-clickable="false"></employee-picture-and-information></div></div></td></tr></tbody><tbody ng-if="vm.isEditPressed"><tr class="text-center th-bg th-width"><td colspan="2"><div class="visitor-image-and-data-with-button"><div class="width-50"><div class="flex-container text-left"><div class="with-round-bg mb-0"><img ng-if="!!vm.visitorToShow.visitorInfo.visitorPictureUrl" ng-src="{{vm.visitorToShow.visitorInfo.visitorPictureUrl}}"> <img ng-if="!vm.visitorToShow.visitorInfo.visitorPictureUrl" ng-src="../assets/img/theme/no-photo.png"></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.name"></div></div></div><div><button type="button" class="btn border-btn" ng-click="vm.cancelUpdateVisitorInfo()"><span translate="">{{ \'commonKeywords.cancelButton\' }}</span></button> <button type="button" class="btn btn-primary" ng-click="vm.updateVisitorInfo(vm.visitorToShow.visitorInfo.id)"><span translate="">{{\'visitorManagement.myVisitorProfile.save\'}}</span></button></div></div></td></tr><tr class="text-left"><td><div class="mt-5"><strong><span translate="">{{\'visitorManagement.myVisitorProfile.visitorMobile\'}}</span></strong></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.mobile"></div></td><td><div class="mt-5"><strong><span translate="">{{\'visitorManagement.myVisitorProfile.visitorEmail\'}}</span></strong></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.email"></div></td></tr><tr class="text-left"><td><div class="mt-5"><strong><span translate="">{{\'visitorManagement.myVisitorProfile.organization\'}}</span></strong></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.organisationName"></div></td><td><div><strong><span translate="">{{\'visitorManagement.myVisitorProfile.address\'}}</span></strong></div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.address"></td></tr><tr class="text-left"><td><div class="mt-5"><strong><span translate="">{{\'Emergency Contact Name: \'}}</span></strong></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.emergencyContactName"></div></td><td><div class="mt-5"><strong><span translate="">{{\'Emergency Contact Mobile :\'}}</span></strong></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.emergencyContactNumber"></div></td></tr><tr class="text-left"><td><strong><span translate="">{{\'visitorManagement.myVisitorProfile.visitorCategory\'}}</span></strong><span translate="">{{vm.visitorToShow.visitorInfo.visitorCategoryNameToShow}}</span><div class="custom-select"><select ng-model="vm.visitorToShow.visitorInfo.visitorCategoryId" ng-options="visitorCategory.id as visitorCategory.name for visitorCategory in vm.visitorCategoryList"><option value="" selected="" translate=""></option></select></div></td><td><div class="mt-5"><strong><span translate="">{{\'Organisation Name :\'}}</span></strong></div><div><input class="form-control" ng-model="vm.visitorToShow.visitorInfo.organisationName"></div></td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-7 mt-15"><p translate="" class="text-center font-16 color-22222">{{\'visitorManagement.myVisitorProfile.last5Visits\'}}</p><table class="table table-bordered"><tbody><tr class="text-center th-bg th-width white-bg" ng-repeat="visit in vm.visitorToShow.lastVisits"><td colspan="2"><div class="visitor-image-and-data-with-button"><div class="width-70"><visitor-picture-and-information name="visit.hostName" picture-url="visit.pictureUrl" visit-purpose="visit.visitPurpose" company-name="!visit.designationName ? \'N/A\':visit.designationName" is-clickable="false"></visitor-picture-and-information></div><div class="font-12 text-right bold-time-show"><small><span>{{visit.entryTime | date: "hh:mm a" }}-</span> <span>{{visit.exitTime | date: "hh:mm a" }}</span><br><span>{{visit.dateInMillis | date: "d MMM yyyy" }}</span></small></div></div></td></tr><tr class="text-center th-bg th-width white-bg" ng-if="vm.isAnyRowSelected && vm.visitorToShow.lastVisits.length==0"><td colspan="2"><h6>{{\'visitorManagement.noPastVisit\' | translate}}</h6></td></tr></tbody></table></div><div class="col-md-5 mt-15"><div class="visitor-created-by-text-document"><i class="fa fa-angle-double-left cursor-pointer font-20" ng-click="vm.getPageSpecifiedUpcomingVisit(\'decrease\')"></i><h3 translate="" class="text-center">{{\'visitorManagement.myVisitorProfile.upcomingVisit\'}}</h3><i class="fa fa-angle-double-right cursor-pointer font-20" ng-click="vm.getPageSpecifiedUpcomingVisit(\'increase\')"></i></div><table class="table table-bordered"><colgroup><col class="width-40"></colgroup><tbody><tr class="text-center th-bg th-width white-bg" ng-if="vm.numberOfPageOfUpcomingVisit==0"><td colspan="2"><h6>{{\'visitorManagement.noUpcomingVisit\' | translate}}</h6></td></tr></tbody><tbody ng-if="vm.numberOfPageOfUpcomingVisit!=0"><tr class="text-left dont-wrap-text bold-time-show font-12"><td class="dont-wrap-text">{{vm.visitorToShow.upcomingVisit.dateInMillis | date: "d MMM yyyy"}}</td></tr><tr class="text-left dont-wrap-text bold-time-show font-12"><td class="dont-wrap-text"><span>{{vm.visitorToShow.upcomingVisit.entryTime | date: "hh:mm a" }}-</span> <span>{{vm.visitorToShow.upcomingVisit.exitTime | date: "hh:mm a" }}</span><br></td></tr><tr class="text-left dont-wrap-text bold-time-show font-12"><td class="dont-wrap-text"><span>{{(vm.visitorToShow.upcomingVisit.visitorAccessAreaName?vm.visitorToShow.upcomingVisit.visitorAccessAreaName:"Not Set")}}</span></td></tr><tr class="text-left dont-wrap-text bold-time-show font-12"><td class="dont-wrap-text"><span>{{vm.visitorToShow.upcomingVisit.reason}}</span></td></tr><tr class="text-left dont-wrap-text bold-time-show font-12"><td class="dont-wrap-text"><visitor-picture-and-information name="vm.visitorToShow.upcomingVisit.hostName" picture-url="vm.visitorToShow.upcomingVisit.pictureUrl" company-name="!vm.visitorToShow.upcomingVisit.designationName ? \'N/A\':vm.visitorToShow.upcomingVisit.designationName" is-clickable="false"></visitor-picture-and-information></td></tr></tbody></table><div class="d-flex-space-between" ng-if="vm.numberOfPageOfUpcomingVisit!=0"><div class="mt-35 mr-25 cursor-pointer"><a class="link-btn" ui-sref="visitorManagement.appointmentLog" ui-sref-active="active">View All</a></div><div class="d-flex-flex-end mt-20 ml-25"><button class="btn btn-sm-with-icon btn-secondary mr-10" ng-click="vm.openEdit(vm.visitorToShow.visitorInfo.id,vm.visitorToShow.upcomingVisit.appointmentId)"><i class="ion-ios-compose-outline"></i><span class="pb-2" translate="">{{\'visitorManagement.myVisitorProfile.visitorEdit\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openCancelAppointmentModal(vm.visitorToShow.upcomingVisit.appointmentId)"><i class="ion-ios-close-outline"></i><span class="pb-2" translate="">{{"Cancel"}}</span></button></div></div></div></div></div><div class="row mt-150" ng-if="vm.isAnyRowSelected && !vm.isVisitorInfoLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row mt-15" ng-if="!vm.isAnyRowSelected" ng-class="{\'unselected\': vm.isAnyRowSelected == false}" include-with-scope="app/pages/main/employees/fieldVisit/partials/dummyTable.html"></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/contentTop/tutorialModal/tutorialView.modal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{ vm.title }}</h4></div><div class="modal-body" style="padding-top:0; text-align: center;"><div ng-if="vm.hasTutorial()"><iframe width="800" height="450" src="{{vm.getSrc(vm.src)}}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><div ng-if="!vm.hasTutorial()"><span>No tutorial is available for this page</span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.closeModal()">Close</button></div></div>');
$templateCache.put('app/pages/main/attendanceReport/absentReport/absentReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'absentReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><report-filter search-method="vm.search" hide-download="true" show-filters="vm.showFilters" selected-page="vm.selectedPage" excel-url="vm.excelUrl" config="vm.filterConfig"></report-filter></div><leave-late-absent-table all-attendance-data="vm.allAttendanceData" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.numberOfRows" offset="vm.offset" type="absents"></leave-late-absent-table></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/workingHourReport/workingHourReport.html','<style>\n    td{\n        font-size:12px;\n        padding: 0;\n        vertical-align: middle!important;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n    .horizontal-scroll table thead tr a{\n        color: white!important;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'workingHourReport\'|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter search-method="vm.searchAttendance" show-filters="vm.showFilters" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" config="vm.filterConfig"></report-filter></div></div><div class="mt-20" ng-if="vm.isDataLoaded"><div class="horizontal-scroll report-container width-100" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14" ng-if="vm.allAttendanceData.length > 0"><thead><tr><th class="text-center table-id text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">name</th><th class="text-center" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" translate="">employmentType</th><th class="text-left" ng-if="vm.showLineManager" translate="">lineManager</th><th class="text-center" translate="">shiftGroup</th><th colspan="3" class="text-center" ng-repeat="date in vm.dateList">{{date}}</th><th ng-if="vm.showTotalHours" class="text-center" translate="">expectedWorkingHour</th><th ng-if="vm.showTotalHours" class="text-center" translate="">totalWorked</th><th ng-if="vm.showTotalHours" class="text-center" translate="">difference</th><th ng-if="vm.showTotalHours" class="text-center" translate="">averageWorkingHour</th></tr></thead><tr ng-repeat="employee in vm.allAttendanceData"><td class="text-center"><a ui-sref="profile({employeeId: {{employee.employeeId}}})">{{(vm.selectedPage * vm.rowsPerPage)+($index+1)}}</a></td><td class="text-center">{{employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.pictureURL" department-name="employee.departmentName" designation-name="!employee.designationName ? \'N/A\':employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="!employee.subsidiaryName ? \'color-999999\':\'text-center\'" ng-if="vm.isNotSubsidiaryAdmin">{{employee.subsidiaryName ? employee.subsidiaryName : "Not Set" }}</td><td class="text-center" ng-class="employee.employmentTypeName ==\'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-left" ng-if="vm.showLineManager"><employee-picture-and-information name="employee.lineManagerName" picture-url="employee.lineManagerPictureUrl" id="employee.lineManagerId" is-clickable="false"></employee-picture-and-information></td><td class="text-center">{{employee.shiftGroupName}}</td><td class="text-center" colspan="3" ng-repeat="startOfDay in vm.startOfDayList"><span ng-if="employee.attendance[startOfDay] != undefined">{{employee.attendance[startOfDay].totalHour}}</span> <span class="red-text" ng-if="employee.attendance[startOfDay] == undefined" translate="">{{\'commonKeywords.mismatch\'}}</span></td><td class="text-center" ng-if="vm.showTotalHours">{{employee.summary.totalExpectedWorkingHour}}</td><td class="text-center" ng-if="vm.showTotalHours">{{employee.summary.totalWorkingHour}}</td><td class="text-center" ng-if="vm.showTotalHours">{{employee.summary.workingHourDifference}}</td><td class="text-center" ng-class="employee.summary.averageWorkingHoursAndMinutes ==\'N/A\'?\'color-999999\':\'text-center\'" ng-if="vm.showTotalHours">{{employee.summary.averageWorkingHoursAndMinutes}}</td></tr></table></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.searchAttendance"></pagination-directive></div>');
$templateCache.put('app/pages/main/attendanceReport/detailed/templates/attendance-report-desktop.html','<div class="row" ng-controller="AttendanceReportPageCtrl as vm"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Detailed Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" excel-url="vm.excelUrl" excel-url-all-pages="vm.excelUrlAllPages" selected-page="vm.selectedPage" config="vm.filterConfig"></report-filter></div></div><detailed-table ng-if="vm.isDataLoaded" all-attendance-data="vm.allAttendanceData" date-list="vm.dateList" selected-page="vm.selectedPage" is-data-loaded="vm.isDataLoaded" start-of-day-list="vm.startOfDayList" show-image="true" show-line-manager="vm.showLineManager"></detailed-table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/detailed/templates/attendance-report-mobile.html','<div class="row" ng-controller="AttendanceReportPageCtrl as vm"><div class="col-md-12 col-sm-12"><div ba-panel=""><div class="row bottom mt-20"><div class="col-sm-12 col-xs-12"><h4 class="bottom" translate="">{{\'commonKeywords.name\'}}</h4><input class="form-control" type="text" placeholder="Employee name ..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchAttendance() : null"></div></div><div class="row bottom mt-20"><div class="col-sm-12 col-xs-12"><h4 class="bottom">{{\'commonKeywords.date\' | translate}}</h4><input date-range-picker="" class="form-control date-picker modified-input-box" type="text" ng-model="vm.datePicker.date" options="vm.datePicker.options"></div></div><div class="row bottom" ng-hide="true"><div class="col-sm-12 col-xs-12"><h4 class="bottom">{{\'commonKeywords.company\' | translate}}</h4><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div></div><div class="row bottom" ng-hide="true"><div class="col-sm-12 col-xs-12"><h4 class="bottom" ng-show="vm.search.selectedCompanyList.length > 0">{{\'commonKeywords.office\' | translate}}</h4><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div></div><div class="row bottom mt-10"><div class="col-sm-12 col-xs-12"><h4 class="bottom">{{\'commonKeywords.shifts\' | translate}}</h4><div isteven-multi-select="" input-model="vm.shiftList" output-model="vm.search.selectedShiftList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div></div><div class="row bottom"><div class="col-sm-12 col-xs-12"><h4 class="bottom">{{\'commonKeywords.departments\' | translate}}</h4><div isteven-multi-select="" input-model="vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div></div><div class="row mt-20 text-center"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.searchAttendance()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div><br><br><div include-with-scope="app/pages/main/attendanceReport/templates/attendancetable.html"></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/detailed/templates/attendancetable.html','<style xmlns="http://www.w3.org/1999/html">\n    td\n    {\n        font-size:12px;\n        padding: 0;\n        vertical-align: middle!important;\n        text-align: center!important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .list-avatar{\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        float: left;\n        margin-top: 2px;\n    }\n</style><div ng-controller="AttendanceReportTableCtrl as vm"><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-6"><a ng-href="{{vm.excelUrl}}" target="_self"><button class="btn btn-md-with-icon btn-primary" id="exportToExcel"><i class="ion-clipboard"></i>&nbsp;Excel</button></a></div><div id="attendanceTableRowsPerPageDiv" class="col-md-4 text-right" style="margin-top: 10px"><span id="attendanceTableRowsPerPageSpan"><strong>Rows Per Page</strong></span></div><div class="col-md-2"><select class="form-control" ng-model="vm.allData.showRows" ng-change="vm.prepareDataForPagination()"><option value="2" ng-selected="vm.allData.showRows==2">2</option><option value="5" ng-selected="vm.allData.showRows==5">5</option><option value="10" ng-selected="vm.allData.showRows==10">10</option><option value="20" ng-selected="vm.allData.showRows==20">20</option><option value="50" ng-selected="vm.allData.showRows==50">50</option><option value="100" ng-selected="vm.allData.showRows==100">100</option></select></div></div><div class="text-center" ng-show="!vm.isDataLoaded" style="margin-bottom: 10px"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="horizontal-scroll" style="width: 100%; margin-top: 20px;" id="attendanceDiv"><table class="table table-bordered attendanceTable" id="attendanceTable" style="border-spacing: 2px" ng-if="vm.allData.allAttendanceData.length > 0"><tr><td><a href="">Image</a></td><td style="text-align: center!important; vertical-align: middle!important;">ID</td><td style="text-align: left!important; vertical-align: middle!important;"><a href="" ng-click="vm.sortingMethods.sortByName()">Name</a></td><td style="text-align: left!important; vertical-align: middle!important;"><a href="" ng-click="vm.sortingMethods.sortByDepartmentHierarchy()">Department</a></td><td style="text-align: left!important; vertical-align: middle!important;"><a href="" ng-click="vm.sortingMethods.sortByDesignationHierarchy()">Designation</a></td><td style="text-align: center!important; vertical-align: middle!important;"><a href="">Employment Type</a></td><td style="text-align: center!important; vertical-align: middle!important;"><a href="" ng-click="vm.sortingMethods.sortByShiftName()">Shift</a></td><td style="text-align: center!important; vertical-align: middle!important;"><a href="">Workplace</a></td><td colspan="3" class="headers2" ng-repeat="date in vm.dateList" style="text-align: center!important; vertical-align: middle!important;">{{date}}</td><td ng-if="vm.showSummary" class="headers2">Present</td><td ng-if="vm.showSummary" class="headers2">Absent</td><td ng-if="vm.showSummary" class="headers2">Leave</td><td ng-if="vm.showSummary" class="headers2">Late</td><td ng-if="vm.showSummary" class="headers2">Early Exit</td><td ng-if="vm.showTotalHours" class="headers2">Expected</td><td ng-if="vm.showTotalHours" class="headers2">Actual</td><td ng-if="vm.showTotalHours" class="headers2">Average</td><td ng-if="vm.showTotalHours" class="headers2">Overtime</td></tr><tr><td class="emptyCell"></td><td class="emptyCell"></td><td class="emptyCell"></td><td class="emptyCell"></td><td class="emptyCell"></td><td class="emptyCell"></td><td class="emptyCell"></td><td class="emptyCell"></td><td class="headers2" ng-repeat-start="date in vm.dateList" style="text-align: center!important; vertical-align: middle!important;">entry</td><td class="headers2" style="text-align: center!important; vertical-align: middle!important;">exit</td><td class="headers2" ng-repeat-end="" style="text-align: center!important; vertical-align: middle!important;">hour</td><td ng-if="vm.showSummary"></td><td ng-if="vm.showSummary"></td><td ng-if="vm.showSummary"></td><td ng-if="vm.showSummary"></td><td ng-if="vm.showSummary"></td><td ng-if="vm.showTotalHours" class="headers2">Hours</td><td ng-if="vm.showTotalHours" class="headers2">Hours</td><td ng-if="vm.showTotalHours" class="headers2">Hours</td><td ng-if="vm.showTotalHours" class="headers2">Hours</td></tr><tr ng-repeat="employee in vm.attendanceList"><td style="padding: 1px 8px 3px;"><img class="list-avatar" ng-show="employee.pictureURL && vm.hasPermission(\'4003\')" ng-src="{{employee.pictureURL}}"> <img class="list-avatar" ng-show="!employee.pictureURL || !vm.hasPermission(\'4003\')" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td>{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td style="text-align: left !important;"><a ui-sref="profile({employeeId: {{employee.employeeId}}})">{{employee.employeeName}}</a></td><td style="text-align: left !important;">{{employee.departmentName}}</td><td style="text-align: left !important;">{{employee.designationName}}</td><td>{{employee.employmentTypeName}}</td><td>{{employee.shiftName}}</td><td>{{employee.workplaceName}}</td><td ng-repeat-start="attendance in employee.attendance" ng-class="($index % 2 == 0?\'present-shadow\':\'\')" colspan="{{attendance.isPresent===true ? \'1\':\'3\'}}"><span ng-if="attendance.isPresent" ng-class="((attendance.isLate && (!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isOffday && !attendance.isLeave)) ? \'redText\' : \'\')">{{attendance.firstLoggedTime}}{{(attendance.isHalfDay && attendance.leaveQuarter == 1) ? " H1" : ""}}<br></span> <span ng-if="attendance.entryManual && attendance.logPunchType != 5" class="manual-text">Manual Entry<br></span> <span ng-if="attendance.entryManual && attendance.logPunchType == 5" class="manual-text">Field Visit<br></span> <span ng-if="attendance.isHoliday" class="greenText">Holiday<br></span> <span id="offDaySpan" ng-if="!attendance.isSpecialDay && !attendance.isHoliday && attendance.isOffday" class="greenText">Off Day<br></span> <span ng-if="attendance.isSpecialDay" class="specialDayText">{{attendance.specialDayTitle}}<br></span> <span ng-if="attendance.isLeave" class="greenText">Leave<br></span> <span ng-if="(!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isLeave && !attendance.isOffday) && !attendance.isPresent" class="redText text-center">Absent</span></td><td ng-if="attendance.isPresent" ng-class="($index % 2 == 0 ? \'present-shadow\' : \'\')"><span ng-class="((attendance.isEarly && (!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isOffday && !attendance.isLeave)) ? \'redText\' : \'\')">{{attendance.lastLoggedTime}}{{(attendance.isHalfDay && attendance.leaveQuarter == 2) ? " H2" : ""}}</span> <span ng-if="attendance.exitManual && attendance.logPunchType!=5" class="manual-text"><br>Manual Entry</span> <span ng-if="attendance.exitManual && attendance.logPunchType==5" class="manual-text"><br>Field Visit</span></td><td ng-repeat-end="" ng-if="attendance.isPresent" ng-class="($index % 2 == 0 ? \'present-shadow\' : \'\')"><span ng-class="((attendance.isInadequate && (!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isOffday && !attendance.isLeave)) ? \'redText\' : \'\')">{{attendance.totalHour}}</span></td><td ng-if="vm.showSummary">{{employee.summary.totalPresent}}</td><td ng-if="vm.showSummary">{{employee.summary.totalAbsent}}</td><td ng-if="vm.showSummary">{{employee.summary.totalLeave}}</td><td ng-if="vm.showSummary">{{employee.summary.totalLateEntry}}</td><td ng-if="vm.showSummary">{{employee.summary.totalEarlyExit}}</td><td ng-if="vm.showTotalHours">{{employee.summary.totalExpectedWorkingHour}}</td><td ng-if="vm.showTotalHours">{{employee.summary.totalWorkingHour}}</td><td ng-if="vm.showTotalHours">{{employee.summary.averageWorkingHoursAndMinutes}}</td><td ng-if="vm.showTotalHours">{{employee.summary.totalOvertime}}</td></tr></table><div id="editor"></div></div><div class="text-center" ng-if="vm.allData.allAttendanceData.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.paginateData(0)">First</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage==$index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a ng-click="vm.paginateData($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">></a></li><li class="page-item"><a class="page-link" ng-click="vm.paginateData(vm.numberOfButtons.length-1)">Last</a></li></ul></nav></div><div class="text-center" style="margin-top: 10px" ng-if="vm.allData.allAttendanceData.length > 0"><p><strong>Showing page {{vm.selectedPaginationPage +1}} out of {{vm.numberOfButtons.length}} pages.</strong></p><p><strong>Showing {{vm.getPaginationInfo()}} out of {{vm.allData.allAttendanceData.length}}</strong></p></div><div ng-if="vm.allData.allAttendanceData != null && vm.allData.allAttendanceData.length == 0"><p class="text-center"><strong>Sorry no attendance data found within given limit</strong></p></div></div>');
$templateCache.put('app/pages/main/attendanceReport/diningReport/detailedDiningReport/detailedDiningReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Detailed Dining Report"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" config="vm.filterConfig"></report-filter></div></div><div class="row" ng-if="vm.reportTable != null && vm.isDataLoaded && vm.total >= 0"><div class="col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="5"><table class="table report-table report-table-font-14"><thead><tr><th rowspan="2" class="text-center" translate="">sl</th><th rowspan="2" class="text-center" translate="">id</th><th rowspan="2" class="text-center" translate="">name</th><th rowspan="2" class="text-center" translate="">employmentType</th><th rowspan="2" class="text-center" translate="">workplace</th><th colspan="2" class="text-center" ng-repeat="date in vm.dateList">{{date}}</th><th rowspan="2" class="text-center">Total Lunch</th><th rowspan="2" class="text-center">Total Dinner</th><th rowspan="2" class="text-center">Total Meals</th></tr><tr class="skip-freeze"><th class="text-center pt-0" ng-repeat="x in [].constructor(vm.mealArraySize) track by $index">{{($index % 2 == 0 ? "Lunch" : "Dinner")}}</th></tr><tbody><tr ng-repeat="employee in vm.reportTable track by $index"><td class="text-center">{{ (vm.selectedPage * vm.searchParams.perPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.name" picture-url="employee.pictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.id" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="employee.employmentTypeName === \'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-center">{{employee.workplaceName || \'--\'}}</td><td class="text-center" ng-repeat-start="date in vm.dateList" ng-class="($index % 2 == 1?\'col-stripe-dark\':\'col-stripe-light\')"><span ng-class="vm.getMealColor(employee.dateWithMealMap[date].hadLunch)">{{ vm.getMealText(employee.dateWithMealMap[date].hadLunch) }}</span></td><td class="text-center" ng-repeat-end="" ng-class="($index % 2 == 1?\'col-stripe-dark\':\'col-stripe-light\')"><span ng-class="vm.getMealColor(employee.dateWithMealMap[date].hadDinner)">{{ vm.getMealText(employee.dateWithMealMap[date].hadDinner) }}</span></td><th class="text-center vertical-align-middle">{{employee.totalLunch}}</th><th class="text-center vertical-align-middle">{{employee.totalDinner}}</th><th class="text-center vertical-align-middle">{{employee.totalMeal}}</th></tr></tbody></thead></table></div></div></div><div class="mt-50"><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/diningReport/monthlyDiningReport/monthlyDiningReport.html','<style>\n    .form-group{\n        margin-bottom: 10px!important;\n    }\n    .list-active > a {\n        background-color: #4A9B91;\n        color:white!important;\n    }\n    .list-active>a:hover {\n        background-color: #4A9B91;\n        color: #000!important;\n    }\n    .table-bordered thead tr th{\n        background: var(--color-secondary)!important;\n        color: white!important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Monthly Dining Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="monthly" config="vm.filterConfig"></report-filter></div></div><div class="row mt-20" ng-if="vm.reportTable != null && vm.isDataLoaded && vm.total >= 0"><div class="col-md-12 col-sm-12 col-xs-12"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><colgroup><col class="width-17"><col class="width-16"><col class="width-17"><col class="width-16"></colgroup><tbody><tr class="text-bold"><td translate="">totalLunch</td><td class="col-stripe-dark text-center">{{vm.totalLunch}}</td><td translate="">totalDinner</td><td class="col-stripe-dark text-center">{{vm.totalDinner}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">date</th><th class="text-center" translate="">day</th><th class="text-center" translate="">lunch</th><th class="text-center" translate="">dinner</th></tr><tbody><tr ng-repeat="perDay in vm.reportTable track by perDay.date"><td class="text-center">{{ (vm.selectedPage * vm.searchParams.perPage) + $index + 1 }}</td><td class="text-center">{{perDay.date}}</td><td class="text-center">{{perDay.day}}</td><td class="text-center">{{perDay.dailyTotalLunch}}</td><td class="text-center">{{perDay.dailyTotalDinner}}</td></tr></tbody></thead></table></div></div></div><div class="mt-50"><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/diningReport/dailyDiningReport/dailyDiningReport.html','<style>\n    .form-group{\n        margin-bottom: 10px!important;\n    }\n    .list-active > a {\n        background-color: #4A9B91;\n        color:white!important;\n    }\n    .list-active>a:hover {\n        background-color: #4A9B91;\n        color: #000!important;\n    }\n    .table-bordered thead tr th{\n        background: var(--color-secondary)!important;\n        color: white!important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Daily Dining Report<span ng-click=\'vm.showFilters = !vm.showFilters\' id=\'showFiltersButton\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" hide-print="true" hide-sort-by="true" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="daily" config="vm.filterConfig"></report-filter></div></div><div class="row mt-20" ng-if="vm.reportTable != null && vm.isDataLoaded && vm.total >= 0"><div class="col-md-12 col-sm-12 col-xs-12"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><colgroup><col class="width-17"><col class="width-16"><col class="width-17"><col class="width-16"></colgroup><tbody><tr class="text-bold"><td translate="">totalLunch</td><td class="col-stripe-dark text-center">{{vm.totalLunch}}</td><td translate="">totalDinner</td><td class="col-stripe-dark text-center">{{vm.totalDinner}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-center" translate="">name</th><th class="text-center" translate="">workplace</th><th class="text-center" translate="">employmentType</th><th class="text-center" translate="">lunch</th><th class="text-center" translate="">dinner</th></tr><tbody><tr ng-repeat="employee in vm.reportTable track by employee.id"><td class="text-center">{{ (vm.selectedPage * vm.searchParams.perPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-center">{{employee.name}}</td><td class="text-center">{{employee.workplaceName}}</td><td class="text-center" ng-class="employee.employmentTypeName === \'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-center" ng-class="vm.getMealColor(employee.hadLunch)">{{ vm.getMealText(employee.hadLunch) }}</td><td class="text-center" ng-class="vm.getMealColor(employee.hadDinner)">{{ vm.getMealText(employee.hadDinner) }}</td></tr></tbody></thead></table></div></div></div><div class="mt-50"><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/leaveReport/leaveBalanceReport/leaveBalanceReport.html','<style>\n    .remaining-leave-balance input::placeholder{\n        font-size: 13px;\n    }\n    .upload-full-screen-loader{\n        position: fixed;\n        top:0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.45);\n        z-index: 11;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .z-index{\n        z-index: 44;\n        color:black;\n    }\n</style><div class="row"><div class="upload-full-screen-loader" ng-if="vm.showSpiner"><div class="text-center mb-10 z-index"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Remaining Leave Balance As Of \'}} {{ vm.showReportTime }} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div class="remaining-leave-balance"><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="yearly" config="vm.filterConfig" hide-download="true"></report-filter></div><div><div><div class="text-center mt-40" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="mt-20" ng-if="vm.allLeaveBalanceData.length > 0 && vm.isDataLoaded"><div class="horizontal-scroll report-container width-100" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-child-selector"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-center width-7" translate="">id</th><th class="text-left width-21" translate="">employeeName</th><th class="text-center" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center width-11" translate="">employmentType</th><th class="text-left" ng-if="vm.showLineManager" translate="">lineManager</th><th class="text-left width-10" translate="">leavePolicy</th><th class="text-left" translate="">leaveType</th><th class="text-center" translate="">entitled</th><th class="text-center" translate="">Used</th><th class="text-center" translate="">balance</th></tr><tbody ng-if="vm.isDataLoaded && vm.allLeaveBalanceData.length > 0" ng-repeat="employee in vm.allLeaveBalanceData"><tr><td class="text-center" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1 }}</td><td class="text-center" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="!employee.subsidiaryName ? \'color-999999\':\'text-center\'" ng-if="vm.isNotSubsidiaryAdmin">{{employee.subsidiaryName ? employee.subsidiaryName : "Not Set" }}</td><td class="text-center border-color-light" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}" ng-class="employee.employmentTypeName ==\'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-left border-color-light" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}" ng-if="vm.showLineManager"><employee-picture-and-information name="employee.lineManager.name" picture-url="employee.lineManager.profilePicUrl" id="employee.lineManager.id" is-clickable="false"></employee-picture-and-information></td><td class="text-left border-color-light" rowspan="{{employee.leaveLeaveInfo.leaveDataList.length}}" ng-class="employee.leaveLeaveInfo.leavePolicyName ==\'\'?\'color-999999\':\'text-left\'">{{employee.leaveLeaveInfo.leavePolicyName == \'\' ? \'Not Set\' : employee.leaveLeaveInfo.leavePolicyName}}</td><td class="text-left border-left border-color-light">{{employee.leaveLeaveInfo.leaveDataList[0].leaveCategoryName == null ? \'Not Set\': employee.leaveLeaveInfo.leaveDataList[0].leaveCategoryName}}</td><td class="text-center border-color-light">{{employee.leaveLeaveInfo.leaveDataList[0].entitled == null ? \'Not Set\' : employee.leaveLeaveInfo.leaveDataList[0].entitled}}</td><td class="text-center border-color-light">{{employee.leaveLeaveInfo.leaveDataList[0].used == null ? \'Not Set\' : employee.leaveLeaveInfo.leaveDataList[0].used}}</td><td class="text-center border-right border-color-light">{{employee.leaveLeaveInfo.leaveDataList[0].balance == null ? \'Not Set\': employee.leaveLeaveInfo.leaveDataList[0].balance}}</td></tr><tr ng-repeat="remaining in employee.leaveLeaveInfo.leaveDataList" ng-if="$index > 0"><td class="text-left border-left border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.leaveCategoryName == null ? \'Not Set\' : remaining.leaveCategoryName}}</td><td class="text-center border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.entitled == null ? \'Not Set\' : remaining.entitled}}</td><td class="text-center border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.used == null ? \'Not Set\' : remaining.used}}</td><td class="text-center border-right border-color-light" ng-class="{\'border-top\':employee.leaveLeaveInfo.leaveDataList.length > 0}">{{remaining.balance == null ? \'Not Set\' : remaining.balance}}</td></tr></tbody></thead></table></div><div ng-show="!vm.isDataLoaded" class="text-center mb-10"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isDataLoaded && vm.allLeaveBalanceData.length < 1"><p class="text-center mt-10"><strong translate="">{{\'noDataFound\'}}</strong></p></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/leaveReport/leaveHistoryReport/leaveHistoryReport.html','<style>\n    .panel .panel-body{\n        min-height: 680px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Leave History Report Of \' + vm.monthYear}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter\' style=\'width:20px;\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="monthly" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div ng-if="vm.allLeaveHistory ==null || vm.allLeaveHistory.length <=0"><p class="text-center mt-60"><strong translate="">{{\'noDataFound\'}}</strong></p></div><div ng-if="vm.allLeaveHistory.length > 0"><div class="row mt-20"><div class="col-md-12"><table class="table overall-summary"><colgroup><col class="width-22"><col class="width-11"><col class="width-22"><col class="width-11"><col class="width-23"><col class="width-11"></colgroup><tbody><tr class="text-bold"><td translate="">totalEmployees</td><td class="col-stripe-dark text-center">{{vm.totalEmployee}}</td><td translate="">totalLeaveDays</td><td class="col-stripe-dark text-center">{{vm.totalLeaveDays}}</td><td translate="">totalWorkingHourLossForLeave</td><td class="col-stripe-dark text-center">{{vm.totalLossHour}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container mt-20" style="width: 100%; margin-top: 20px;" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-left" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" rowspan="2" translate="">employmentType</th><th class="text-left" rowspan="2" ng-if="vm.showLineManager" translate="">lineManager</th><th class="text-left" rowspan="2" translate="">leavePolicy</th><th class="text-left" rowspan="2" translate="">leaveCategory</th><th class="text-center" rowspan="2" translate="">from</th><th class="text-center" rowspan="2" translate="">to</th><th class="text-center" rowspan="2" translate="">days</th><th class="text-center" rowspan="2" translate="">leaveApprovalStatus</th><th class="text-left" rowspan="2" translate="">reason</th></tr><tbody><tr ng-repeat="employee in vm.allLeaveHistory"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-if="vm.isNotSubsidiaryAdmin">{{employee.subsidiaryName}}</td><td class="text-center" ng-class="employee.employmentTypeName ==\'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-left" ng-if="vm.showLineManager"><employee-picture-and-information name="employee.lineManager.name" picture-url="employee.lineManager.profilePicUrl" id="employee.lineManager.id" is-clickable="false"></employee-picture-and-information></td><td class="text-left">{{employee.leaveLeaveInfo.leavePolicyName}}</td><td class="text-left">{{employee.leaveLeaveInfo.leaveDataList[0].leaveCategoryName}}</td><td class="text-center">{{employee.leaveLeaveInfo.leaveDataList[0].from}}</td><td class="text-center">{{employee.leaveLeaveInfo.leaveDataList[0].to}}</td><td class="text-center">{{employee.leaveLeaveInfo.leaveDataList[0].days}}</td><td class="text-center" ng-class="vm.getStatusColor(employee.leaveLeaveInfo.leaveDataList[0].approvalStatus)">{{vm.getStatusText(employee.leaveLeaveInfo.leaveDataList[0].approvalStatus)}}</td><td class="text-left">{{employee.leaveLeaveInfo.leaveDataList[0].reason}}</td></tr></tbody></thead></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/locationTrackingReport/modal/showLocationImg.modal.html','<style>\n    .img-size{\n        height: 350px;\n        width: 100%;\n        object-fit: contain;\n        border: 1px solid  #4a4a4a;\n    }\n\n    .custom-column{\n        float:none;\n        margin:auto;\n    }\n\n</style><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div ng-class="{\'col-md-6 custom-column\': vm.imgSrc != \'null\' && vm.exitImgSrc == \'null\' , \'col-md-6\':vm.imgSrc != \'null\' && vm.exitImgSrc != \'null\'}"><div class="text-center-important"><span class="color-secondary font-16">{{ vm.entryTime }}</span></div><div class="text-center-important"><span class="color-prime font-16">{{ vm.locationName }}</span></div><div class="text-center mt-10"><img ng-src="{{vm.imgSrc}}" class="img-size"></div></div><div class="col-md-6" ng-if="vm.exitImgSrc != \'null\'"><div class="text-center-important"><span class="color-secondary font-16">{{ vm.exitTime }}</span></div><div class="text-center-important"><span class="color-prime font-16 nowrap">{{ vm.locationName }}</span></div><div class="text-center mt-10"><img class="img-size" ng-src="{{vm.exitImgSrc}}"></div></div></div><div class="footer"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/locationTrackingReport/modal/showMultipleLocationMap.modal.html','<style>\n.location-header {\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    color: var(--color-secondary) !important;\n    white-space: normal; \n    word-wrap: break-word; \n    overflow: hidden; \n    text-overflow: ellipsis; \n    flex-grow: 1; \n    padding-right: 30px; \n}\n\n    #map {\n        width: 100%;\n        height: 400px;\n    }\n\n    .time-info {\n        margin-top: 20px;\n        font-size: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .time-details {\n        margin-right: 24px;\n        font-size: 12px;\n        flex: 1;\n    }\n\n    .time-buttons .btn {\n        margin-left: 10px;\n    }\n\n    .modal-content {\n    position: relative;\n    max-width: 100%;\n    overflow: hidden;\n    }\n    .gm-style-iw-chr{\n        display: none;\n    }\n    .gm-style-iw-d{\n        padding-top: 10px;\n    }\n/*.d-flex-space-between {*/\n/*    display: flex;*/\n/*    justify-content: space-between;*/\n/*    align-items: center;*/\n/*    flex-wrap: nowrap; !* Prevent wrapping of the flex items *!*/\n/*    position: relative; !* Ensure this is the reference for absolute positioning *!*/\n/*}*/\n</style><div><div class="modal-body"><div><p class="text-uppercase location-header">Locations Tracking of {{ vm.employeeName }}</p><button type="button" class="close mt-negative-35" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="d-flex align-items-center gap-2 flex-wrap mb-0"><div class="form-group mb-0 mr-2"><div date-range-picker="" class="form-control form-control-sm date-picker text-center cursor-pointer d-flex align-items-center justify-content-center" ng-model="vm.currentDateMoment" options="vm.startDatePicker.options" ng-change="vm.onDateChange()" style="margin-top: 10px;"><span class="date-label-text">{{ vm.currentDateMoment && vm.currentDateMoment.format("D MMM YYYY") }}</span> <i class="fa fa-calendar calendar-icon-position ml-5"></i></div></div><div class="mb-0 mr-2"><uib-timepicker ng-model="vm.filterStartTime" hour-step="1" minute-step="1" show-meridian="true" show-spinners="false" class="form-control-sm"></uib-timepicker></div><div class="mb-0 mr-2"><uib-timepicker ng-model="vm.filterEndTime" hour-step="1" minute-step="1" show-meridian="true" show-spinners="false" class="form-control-sm"></uib-timepicker></div><div class="mb-0 mr-2"><button class="btn btn-sm btn-primary ml-2" ng-click="vm.searchByTime()"><i class="fa fa-search"></i> Search</button></div><div class="mb-0"><label class="text-normal checkbox-container ml-30" for="show-marker"><input type="checkbox" id="show-marker" ng-model="vm.showMarker" ng-change="vm.changeShowMarker()"> <span class="custom-checkbox"></span> <span class="ml-20">Show All Marker</span></label></div></div><hr><div id="map"></div><div class="time-info"><div class="time-details">Start Time: {{ vm.employeeStartTime | date:\'shortTime\' }} | End Time: {{ vm.employeeEndTime ? (vm.employeeEndTime | date:\'shortTime\') : \'--\' }} | Total Hour: {{ vm.employeeTotalworkingHour }}</div><div><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/mobilePunchReport/modal/showLocationImg.modal.html','<style>\n    .img-size{\n        height: 350px;\n        width: 100%;\n        object-fit: contain;\n        border: 1px solid  #4a4a4a;\n    }\n\n    .custom-column{\n        float:none;\n        margin:auto;\n    }\n\n</style><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div ng-class="{\'col-md-6 custom-column\': vm.imgSrc != \'null\' && vm.exitImgSrc == \'null\' , \'col-md-6\':vm.imgSrc != \'null\' && vm.exitImgSrc != \'null\'}"><div class="text-center-important"><span class="color-secondary font-16">{{ vm.entryTime }}</span></div><div class="text-center-important"><span class="color-prime font-16">{{ vm.locationName }}</span></div><div class="text-center mt-10"><img ng-src="{{vm.imgSrc}}" class="img-size"></div></div><div class="col-md-6" ng-if="vm.exitImgSrc != \'null\'"><div class="text-center-important"><span class="color-secondary font-16">{{ vm.exitTime }}</span></div><div class="text-center-important"><span class="color-prime font-16 nowrap">{{ vm.locationName }}</span></div><div class="text-center mt-10"><img class="img-size" ng-src="{{vm.exitImgSrc}}"></div></div></div><div class="footer"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/mobilePunchReport/modal/showLocationMap.modal.html','<style>\n    .location-header {\n        font-size: 18px !important;\n        font-weight: 600 !important;\n        color: var(--color-secondary) !important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><p class="text-uppercase location-header" translate="">{{vm.mobilePunch.locationName}}</p><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><iframe width="100%" height="500" style="border:0" loading="lazy" allowfullscreen="" src="{{vm.mapUrl}}"></iframe></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/individualSalaryComparison/individualSalaryComparison.html','<div ba-panel="" ba-panel-title="Salary Management" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/monthOnMonthSalaryComparison.html','<style>\n    .table > thead > tr > th:last-child {\n        padding-right: 10px !important;\n    }\n\n    .table > tbody > tr > td:last-child {\n        padding-right: 10px !important;\n    }\n\n    .summery-table .table > tbody > tr > td {\n        padding: 8px 1px !important;\n    }\n\n    .summery-table {\n        font-size: 13px !important;\n    }\n\n</style><div ba-panel="" ba-panel-title="{{\'monthOnMonthComparison\'|translate}} of {{vm.monthYear}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><payroll-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" success="vm.success" type="comparison" config="vm.filterConfig"></payroll-filter></div><div class=""><div class="row"><div class="col-md-7 col-lg-6"><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="(vm.employeeInfo.length <= 0 || vm.employeeInfo == null) && vm.isDataLoaded" class="d-flex-gap-10 justify-center flex-col align-items-center mt-40"><p class="gray-text">No Salary Information Found</p></div><div class="row" ng-if="vm.isDataLoaded && vm.employeeInfo.length > 0" include-with-scope="app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/employeesTable.html"></div><pagination-directive ng-if="vm.isDataLoaded && vm.employeeInfo.length > 0" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.selectedTab ===\'processedSalary\' ? vm.getProcessedSalaries : vm.getUnprocessedSalaries" not-found-text="\'No data available\'"></pagination-directive><br><br></div><div class="col-md-5 col-lg-6"><div class="d-flex-gap-10"><label class="text-capitalize mb-15 font-16 mt-negative-5" translate="">Month On Month Comparison Details</label></div><div class="row" ng-if="vm.isAnyRowSelected" include-with-scope="app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/viewSalary-partials/salaryComparisonDetailsTable.html"></div><div ng-if="!vm.isAnyRowSelected" class="position-relative" ng-class="{\'unselected\': vm.isAnyRowSelected == false}" include-with-scope="app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/viewSalary-partials/dummyTable.html"></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div><div class="row text-center" ng-if="vm.isAnyRowSelected && !vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/salaryComparisonSummary/salaryComparisonSummary.html','<style>\n    .striped{\n        background-color: #f9f9f9;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Salary Comparison Summary\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll"><div><payroll-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" success="vm.success" type="comparison" config="vm.filterConfig"></payroll-filter></div><div class="d-flex-space-between"><div class="d-flex-gap-10" ng-show="false"><div class="filter-inline-item d-flex-align-end mb-10"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item d-flex-align-end mb-10"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsPdf(\'H\')"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div class="mt-20 mb-30" ng-if="vm.isDataLoaded"><table class="table borderless-table odd-row-strip"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr class="dont-wrap-text height-4-vh"><th class="text-left" translate="">{{\'salaryComparisonSummary.component\'}}</th><th class="text-right">{{vm.selectedMonth}} {{vm.selectedYear}}</th><th class="text-right">{{vm.selectedMonthComparison}} {{ vm.selectedYearComparison }}</th><th class="text-right" translate="">{{\'salaryComparisonSummary.difference\'}}</th></tr></thead><tbody><tr ng-repeat="(key,value) in vm.allData.referenceAdditiveComponentName"><td class="text-left">{{value}}</td><td class="text-right">{{vm.allData.salaryMonthAdditiveComponentAmount[key] | number : (2)}}</td><td class="text-right">{{vm.allData.comparisonMonthAdditiveComponentAmount[key] | number : (2)}}</td><td class="text-right">{{vm.allData.differenceComponentAdditiveAmount[key] | number : (2)}}</td></tr><tr class="bg-61C6E4 white-text font-weight-500"><td class="text-left" translate="">totalSalary</td><td class="text-right">{{vm.allData.totalSalarySalaryMonth | number : (2)}}</td><td class="text-right">{{vm.allData.totalSalaryComparisonMonth | number : (2)}}</td><td class="text-right">{{vm.allData.totalSalaryDifference | number : (2)}}</td></tr></tbody><tbody><tr ng-repeat="(key,value) in vm.allData.referenceDeductiveComponentName"><td class="text-left">{{value}}</td><td class="text-right">{{vm.allData.salaryMonthDeductiveComponentAmount[key] | number : (2)}}</td><td class="text-right">{{vm.allData.comparisonMonthDeductiveComponentAmount[key] | number : (2)}}</td><td class="text-right">{{vm.allData.differenceComponentDeductiveAmount[key] | number : (2)}}</td></tr><tr class="bg-F19A9A white-text font-weight-500"><td class="text-left" translate="">totalDeduction</td><td class="text-right">{{vm.allData.totalDeductionSalaryMonth | number :(2)}}</td><td class="text-right">{{vm.allData.totalDeductionComparisonMonth | number :(2)}}</td><td class="text-right">{{vm.allData.totalDeductionDifference | number : (2)}}</td></tr></tbody></table><table class="table borderless-table even-row-strip mt-5"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><tbody><tr class="bg-black white-text font-weight-500"><td class="text-left" translate="">netPayable</td><td class="text-right">{{vm.allData.totalNetPayableSalaryMonth | number :(2)}}</td><td class="text-right">{{vm.allData.totalNetPayableComparisonMonth | number : (2)}}</td><td class="text-right">{{vm.allData.totalNetPayableDifference | number : (2)}}</td></tr></tbody></table><table class="table borderless-table even-row-strip mt-5"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><tbody><tr class="bg-dfdfdf font-weight-600 color-22222"><td class="text-left" translate="">numberOfEmployees</td><td class="text-right">{{vm.allData.totalEmployeeSalaryMonth}}</td><td class="text-right">{{vm.allData.totalEmployeeComparisonMonth}}</td><td class="text-right">{{vm.allData.totalEmployeeDifference}}</td></tr></tbody></table></div><div class="text-center" ng-if="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/siteAttendanceReport/entryImage/entryExitImage.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><b ng-if="vm.imageCategory==\'entry\'" class="text-uppercase location-header" translate="">Entry Image</b> <b ng-if="vm.imageCategory==\'exit\'" class="text-uppercase location-header" translate="">Exit Image</b> <button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><img ng-if="vm.imageCategory==\'entry\'" width="100%" height="500" src="{{vm.entryImageUrl}}"> <img ng-if="vm.imageCategory == \'exit\'" width="100%" height="500" src="{{vm.exitImageUrl}}"></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/siteAttendanceReport/location/location.modal.html','<style>\n    .location-header {\n        font-size: 18px !important;\n        font-weight: 600 !important;\n        color: var(--color-secondary) !important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><p class="text-uppercase location-header" translate="">{{vm.siteInfo.location}}</p><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><iframe width="100%" height="500" style="border:0" loading="lazy" allowfullscreen="" src="{{vm.mapUrl}}"></iframe></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/siteSummaryReport/location/location.modal.html','<style>\n    .location-header{\n       font-size: 18px!important;\n        font-weight: 600!important;\n        color: var(--color-secondary) !important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><p class="text-uppercase location-header" translate="">{{vm.siteInfo.location}}</p><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><iframe width="100%" height="500" style="border:0" loading="lazy" allowfullscreen="" src="{{vm.mapUrl}}"></iframe></div></div></div>');
$templateCache.put('app/pages/main/dashboard/dashboardTemplates/templates/withCarouselPermission.html','<div class="row ml-15"><div ng-if="vm.isDashboardDataReady.attendanceSummary"><dashboard-pie-chart></dashboard-pie-chart></div></div><div class="row ml-0 department-att-chart"><div ng-if="vm.isDashboardDataReady.departmentAttendance"><div ba-panel="" ba-panel-title="{{vm.panelTitle | translate }}" ba-panel-class="semi-medium-panel"><div include-with-scope="app/pages/main/dashboard/departmentAttendance/departmentAttendance.dashboard.partial.html"></div></div></div></div><div ng-if="!vm.isGroupAdmin" class="row ml-0"><div class="col-md-6 pl-0-important pr-7"><div ba-panel="" ba-panel-title="{{\'lateToday\' | translate}}" ba-panel-class="semi-medium-panel with-scroll"><div include-with-scope="app/pages/main/dashboard/lateFeed/lateFeed.html"></div></div></div><div class="col-md-6 pr-0-important pl-7"><div ba-panel="" ba-panel-title="{{\'onLeave\' | translate}}" ba-panel-class="semi-medium-panel with-scroll"><div include-with-scope="app/pages/main/dashboard/leaveFeed/leaveFeed.html"></div></div></div></div><div class="row ml-0"><div ba-panel="" ba-panel-title="{{\'calender\' | translate}}" ba-panel-class="medium-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/main/dashboard/dashboardTemplates/templates/withoutCarouselPermission.html','<div class="row pl-15"><div ng-if="vm.isDashboardDataReady.attendanceSummary"><dashboard-pie-chart></dashboard-pie-chart></div></div><div ng-if="!vm.isGroupAdmin" class="row ml-0"><div class="col-md-6 pl-0-important pr-7"><div ba-panel="" ba-panel-title="{{\'lateToday\' | translate}}" ba-panel-class="semi-medium-panel with-scroll"><div include-with-scope="app/pages/main/dashboard/lateFeed/lateFeed.html"></div></div></div><div class="col-md-6 pr-0-important pl-7"><div ba-panel="" ba-panel-title="{{\'onLeave\' | translate}}" ba-panel-class="semi-medium-panel with-scroll"><div include-with-scope="app/pages/main/dashboard/leaveFeed/leaveFeed.html"></div></div></div></div><div class="row ml-0"><div ng-if="vm.isDashboardDataReady.departmentAttendance"><div ba-panel="" ba-panel-title="{{vm.panelTitle}}" ba-panel-class="semi-medium-panel"><div include-with-scope="app/pages/main/dashboard/departmentAttendance/departmentAttendance.dashboard.partial.html"></div></div></div></div><div class="row ml-0"><div ba-panel="" ba-panel-title="{{\'calender\' | translate}}" ba-panel-class="medium-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/main/dashboard/occupancyDashboard/attendancePieChart/attendancePieChart.html','<style>\n    #attendancePieChart{\n        height: 700px;\n    }\n    .section-margin{\n        margin-top: -4vh;\n    }\n    .font-6vh{\n        font-size: 6vh;\n    }\n    .font-8vh{\n        font-size: 8vh;\n    }\n    .section-style{\n        color: white;\n        min-height:4vh;\n        max-height: 60vh;\n        font-size: 5vh;\n    }\n</style><div class="row"><div class="form-group col-sm-7 col-xs-7"><button class="btn btn-md-with-icon btn-primary padding-6-12" ng-click="downloadExcel()"><img src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div></div><div class="row d-flex-center-center-inherit"><div class="col-md-6"><div id="attendancePieChart" class="admin-chart"></div><div class="traffic-text section-margin"><div><p class="black-text mb-50 font-6vh" translate="">{{\'dashboardText.total\'}}</p></div><div><p class="black-text font-8vh"><strong>{{totalOccupied}}</strong></p></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-85"><col class="width-15"></colgroup><tbody><tr ng-repeat="data in employmentTypes" class="section-style" style="background-color: {{colours[$index]}}"><td class="pl-22-important"><strong>{{data.employmentTypeName}}</strong></td><td class="text-right pl-16-important"><strong>{{data.occupied}}</strong></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/main/dashboard/occupancyDashboard/occupancyPieChart/occupancyPieChart.html','<style>\n   #occupancyPieChart{\n       height: 450px;\n   }\n   .font-78{\n       font-size: 78px;\n   }\n</style><div id="occupancyPieChart" class="admin-chart"></div><div class="row"><div class="text-center" ng-if="occupied != null && outside != null"><h3 class="font-78"><span class="color-prime">{{!occupied ? 0 : occupied}}</span><span translate="">{{\'dashboardText.inside\'}}</span></h3><h3 class="font-78"><span class="text-danger">{{!outside ? 0 : outside}}</span><span translate="">{{\'dashboardText.outside\'}}</span></h3></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/edit/editDevice.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'deviceListPage.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="d-flex-gap-20"><label>{{ \'deviceListPage.editModal.identifierLabel\' | translate }}</label><p class="color-22222" translate="">{{vm.device.identifier}}</p></div><div class="d-flex-gap-20"><label>{{ \'deviceListPage.editModal.phoneNumberLabel\' | translate }}</label><p class="color-22222" translate="">{{vm.device.phoneNumber}}</p></div><div class="row mt-15"><div class="col-md-12"><label>{{ \'deviceListPage.editModal.descriptionInputLabel\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.device.description" placeholder="{{ \'deviceListPage.editModal.descriptionInputLabel\' | translate }}"></div></div><div class="row mt-15"><div class="col-md-12"><label>{{ \'deviceListPage.editModal.locationInputLabel\' | translate }}</label> <input type="text" class="form-control" ng-model="vm.device.location" placeholder="{{ \'deviceListPage.editModal.locationInputLabel\' | translate }}"></div></div><div class="row mt-15" ng-if="vm.isDataLoaded"><div class="col-md-12 form-group"><label>{{ \'deviceListPage.editModal.workplaceInputLabel\' | translate }}</label><div isteven-multi-select="" input-model="vm.workplaces" output-model="vm.selectedWorkplace" button-label="name" item-label="name" tick-property="ticked" selection-mode="single" on-close="vm.onWorkplaceChanged()" helper-elements="filter" search-property="name"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateDeviceInformation()"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/edit/selectWorkplace.modal.html','<style>\n    /* Neutral, readable active state */\n    .dropdown-panel .list-group-item.is-active {\n        background-color: #f0f0f0;\n        color: #333;\n        border-color: #ddd;\n    }\n    .dropdown-panel .list-group-item:hover {\n        background-color: #f7f7f7;\n    }\n</style><div class="workplace-dropdown" ng-show="vm.showWorkplaceDropdown" style="position: relative;"><div class="dropdown-panel" ng-mousedown="wp.setInteracting(true)" ng-mouseup="wp.setInteracting(false)" ng-mouseenter="wp.setInteracting(true)" ng-mouseleave="wp.setInteracting(false)" style="position:absolute; z-index: 1050; background:#fff; border:1px solid #ddd; border-radius:4px; width:100%; max-height:320px; overflow:auto; box-shadow:0 4px 16px rgba(0,0,0,0.1);"><div class="p-10"><input type="text" class="form-control" placeholder="Search workplaces..." ng-model="wp.query" ng-change="wp.filter()" ng-keydown="wp.onKey($event)" ng-focus="wp.setInteracting(true)" ng-blur="wp.setInteracting(false)"></div><ul class="list-group" style="margin-bottom:0;"><li class="list-group-item" ng-repeat="w in wp.filtered" ng-class="{\'is-active\': wp.highlightIndex === $index}" ng-mousedown="wp.choose(w)" style="cursor:pointer;"><div class="d-flex-space-between"><span>{{ w.name }}</span> <small class="text-muted">ID: {{ w.id }}</small></div></li><li class="list-group-item" ng-if="!wp.filtered.length"><em>No workplaces found.</em></li></ul></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/modals/allocateAll.modal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to allocate everyone to all devices?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategory/leaveCategoryModals/createLeaveCategory.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'leaveCategorySettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label for="name" class="required">{{ \'leaveCategorySettings.creationModal.nameInputLabel\' | translate }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'leaveCategorySettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.createLeaveCategoryName"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createLeaveCategory()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategory/leaveCategoryModals/deleteLeaveCategory.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{ \'leaveCategorySettings.deleteModal.confirmationText\' | translate }} <em>{{vm.categoryToChange.name}}</em> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteLeaveCategory(vm.categoryToChange.id)" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategory/leaveCategoryModals/updateLeaveCategory.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'leaveCategorySettings.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label for="name">{{ \'leaveCategorySettings.creationModal.nameInputLabel\' | translate }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'leaveCategorySettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.categoryToChange.name"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateLeaveCategoryName(vm.categoryToChange.id,vm.categoryToChange.name)" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/leave/applyLeaveForOthers/applyLeaveForEmployees/applyLeaveForEmployees.html','<style>\n    .left-column-border {\n        border: 2px solid #eeeeee;\n        background: #f5f5f5;\n    }\n\n    .dummy-modal-placement {\n        position: absolute;\n        top: 40%;\n        left: 20%;\n    }\n\n    .row-position {\n        padding-left: 3%;\n        padding-right: 3%;\n    }\n\n    .table > thead > tr > th:last-child {\n        padding-right: 5px !important;\n    }\n\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'leaveApplication\' | translate}}"><div class="row"><div class="col-md-6 mb-20"><div class="left-column-border mt-27"><div class="row row-position"><div class="col-md-12"><label class="form-label mt-20 required">{{\'commonKeywords.selectYear\' | translate}}</label><div class="custom-select"><select class="form-control" ng-model="vm.selectedDateRange" ng-options="range for range in vm.dateRangeList"><option value="" disabled="">{{\'applyLeave.pleaseSelect\' | translate}}</option></select></div></div></div><div class="row row-position"><div class="col-md-12"><label class="form-label required">{{\'commonKeywords.selectEmployee\' | translate}}</label><div class="form-group"><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.onEmployeeSelect()" on-select-all="vm.onEmployeeSelect()" on-select-none="vm.onEmployeeSelect()" on-reset="vm.onReset()" on-clear="vm.onEmployeeSelect()" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><div class="row row-position"><div class="col-md-12"><label class="form-label required">{{\'applyLeave.selectCategory\' | translate}}</label><div class="custom-select"><select ng-model="vm.selectedCategoryPolicyConfig" ng-options="remainingLeave.leaveCategoryPolicyConfig as remainingLeave.leaveCategoryPolicyConfig.leaveCategory.name for remainingLeave in vm.remainingLeavesList" ng-change="vm.resetRemainingLeavesToShow()"><option value="" selected="" translate="">{{\'applyLeave.pleaseSelect\'}}</option></select></div></div></div><div class="row row-position mt-15"><div class="col-md-12"><label class="form-label required">{{\'applyLeave.selectType\' | translate}}</label><div class="custom-select"><select ng-model="vm.selectedTypeId" ng-change="vm.resetRemainingLeavesToShow()"><option value="" selected="" translate="">{{\'applyLeave.pleaseSelect\'}}</option><option value="1" translate="">{{\'commonKeywords.full\'}}</option><option value="2" ng-disabled="vm.selectedCategoryPolicyConfig !== null && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria === 1" translate="">{{\'commonKeywords.half\'}}</option></select></div></div></div><div class="row row-position mt-15" ng-if="vm.selectedCategoryPolicyConfig.earnedLeaveCriteria === 1"><div class="col-md-12"><label class="form-label required">{{\'applyLeave.availableDays\' | translate}}</label><div id="availableDateList" isteven-multi-select="" input-model="vm.availableExchangeLeaveDates" output-model="vm.selectedDayForExchangeLeave" button-label="readableDate" item-label="readableDate" tick-property="ticked" disable-property="disabled" selection-mode="single"></div></div></div><div class="row row-position mt-15" ng-if="vm.selectedTypeId == 2"><div class="col-md-12"><label class="form-label mt-10 required">{{\'applyLeave.selectHalf\' | translate}}</label><div class="custom-select"><select ng-model="vm.selectedLeaveHalf"><option value="1" translate="">{{\'applyLeave.firstHalf\'}}</option><option value="2" translate="">{{\'applyLeave.secondHalf\'}}</option></select></div></div></div><div class="row row-position mt-15"><div class="col-md-12" ng-if="vm.isSingleDatePickerModeEnabled === false"><label class="form-label required"><span translate="">{{\'applyLeave.selectDate\'}}</span> <span ng-if="vm.isSingleDatePickerModeEnabled === false"><span translate="">{{\'applyLeave.range\'}}</span></span></label> <input date-range-picker="" class="form-control date-picker modified-input-box text-left" type="text" name="dateRange" ng-model="vm.leaveDateRangePicker.date" ng-disabled="!vm.selectedCategoryPolicyConfig || !vm.selectedTypeId" options="vm.leaveDateRangePicker.options" ng-change="vm.modifyRemainingLeavesToShow()" placeholder="{{\'applyLeave.pleaseSelect\' | translate}}" required=""></div><div class="col-md-12" ng-if="vm.isSingleDatePickerModeEnabled === true"><input date-range-picker="" class="form-control date-picker modified-input-box text-left" type="text" name="dateRange" ng-model="vm.leaveSingleDatePicker.date" ng-disabled="!vm.selectedCategoryPolicyConfig || !vm.selectedTypeId" options="vm.leaveSingleDatePicker.options" ng-change="vm.modifyRemainingLeavesToShow()" placeholder="{{\'applyLeave.pleaseSelect\' | translate}}" required=""></div></div><div class="row row-position mt-15"><div class="col-md-12"><label class="form-label required">{{\'commonKeywords.reason\' | translate}}</label> <textarea type="text" class="form-control" placeholder="{{\'applyLeave.placeholderTextForReason\' | translate}}" ng-model="vm.reason"></textarea></div></div><div class="row row-position mt-20"><div class="col-md-3"><label class="form-label">{{\'commonKeywords.uploadFile\' | translate}}</label></div><div class="col-md-9"><input type="file" class="form-control-file" ngf-select="" ng-model="vm.uploadedFile" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,.docx,.doc,j.pg,.jpeg,.png\'"></div></div><div class="row row-position mb-30 mt-15"><div class="mt-60"><div class="col-md-10 col-xs-9 text-right mt-5"><label class="text-normal checkbox-container" for="force-approve"><input type="checkbox" id="force-approve" ng-model="vm.isChecked"> <span class="custom-checkbox"></span> <span class="ml-30" translate="">{{\'fieldVisit.forceApproveText\'}}</span></label></div><div class="col-md-2 col-xs-3"><button type="button" class="btn btn-md btn-primary pull-right" ng-click="vm.checkFormValidity()" translate="">{{\'commonKeywords.applyButton\'}}</button></div></div></div></div></div><div class="col-md-6 position-relative mb-20"><div class="row"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</p></div></div><div ng-if="vm.isEmployeeSelected"><div class="row" ng-if="vm.isEmployeeSelected && vm.isEmployeeInfoLoaded"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2"><employee-picture-and-information name="vm.employeeToShow.name" picture-url="vm.employeeToShow.employeePictureUrl" department-name="vm.selectedLeaveApplication.employeeDepartmentName" designation-name="!vm.employeeToShow.designation ? \'N/A\':vm.employeeToShow.designation.name" id="vm.employeeToShow.id" is-clickable="vm.employeeToShow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'applyLeave.leavePolicy\'}}</td><td>{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'applyLeave.employmentType\'}}</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="text-center align-self-start" ng-if="!vm.isEmployeeInfoLoaded && vm.isEmployeeSelected"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="row mt-20" ng-if="vm.isEmployeeSelected && vm.isRemainingLeaveDataLoaded"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'applyLeave.remainingLeavesHeading\'}}</p></div></div><div class="row" ng-if="vm.isEmployeeSelected && vm.isRemainingLeaveDataLoaded"><div class="col-md-12 col-sm-12"><upgrade-banner code="6009"><div><div><div class="text-center" ng-if="vm.remainingLeaveListToShow.length === 0" translate="">{{\'profileLeave.noLeavePolicyOrApproverAssigned\'}}</div><table class="table table-bordered" ng-if="vm.remainingLeaveListToShow.length > 0"><colgroup><col class="width-40"><col class="width-18"><col class="width-18"><col class="width-24"></colgroup><thead><tr class="th-bg"><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.category\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.total\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.used\'}}</th><th class="text-center" translate="">{{\'profileLeave.remainingLeaves\'}}</th></tr></thead><tbody><tr ng-repeat="remainingLeaves in vm.remainingLeaveListToShow"><td class="text-left">{{remainingLeaves.leaveCategoryPolicyConfig.leaveCategory.name}}</td><td class="text-center">{{remainingLeaves.total}}</td><td class="text-center">{{remainingLeaves.used}}</td><td class="text-center">{{remainingLeaves.remainingLeaveCount}}</td></tr></tbody></table></div></div></upgrade-banner></div></div><div class="text-center align-self-start" ng-if="vm.isEmployeeSelected && !vm.isRemainingLeaveDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="row mt-20" ng-if="vm.isEmployeeSelected && vm.isEmployeeInfoLoaded"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'applyLeave.lastFiveLeavesHeading\'}}</p></div></div><div class="row" ng-if="vm.isEmployeeSelected && vm.isEmployeeInfoLoaded"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-20"><col class="width-28"><col class="width-17"><col class="width-35"></colgroup><thead><tr class="th-bg"><th class="text-left" translate="">{{\'commonKeywords.category\'}}</th><th class="text-center" translate="">{{\'commonKeywords.dateRange\'}}</th><th class="text-center" translate="">{{\'commonKeywords.numberOfDays\'}}</th><th class="text-left" translate="">{{\'commonKeywords.appliedBy\'}}</th></tr></thead><tbody><tr ng-if="vm.lastFiveLeavedata.length > 0" ng-repeat="data in vm.lastFiveLeavedata"><td class="text-left">{{data.categoryName}}</td><td class="text-center">{{data.startDate | date:\'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{data.endDate | date:\'d MMM yyyy\'}}</td><td class="text-center">{{data.numberOfDays}}</td><td class="text-left"><employee-picture-and-information name="data.nameOfAppliedBy" picture-url="data.applierProfilePictureUrl" department-name="!data.applierDepartmentId ? \'N/A\' : data.applierDepartmentName" designation-name="!data.applierDesignationId ? \'N/A\': data.applierDesignationName" is-clickable="false"></employee-picture-and-information></td></tr><tr ng-if="vm.lastFiveLeavedata.length === 0"><td colspan="4" class="text-center" translate="">{{\'applyLeave.noLeavesFound\'}}</td></tr></tbody></table></div></div><div class="text-center align-self-start" ng-if="!vm.isEmployeeInfoLoaded && vm.isEmployeeSelected"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="row" ng-if="!vm.isEmployeeSelected" ng-class="{\'unselected\': vm.isEmployeeSelected == false}" include-with-scope="app/pages/main/leave/applyLeaveForOthers/applyLeaveForEmployees/partial/dummyTable.html"></div><div class="row ng-scope" ng-if="!vm.isEmployeeSelected"><div include-with-scope="app/pages/main/employees/fieldVisit/apply/partials/dummyOverlay.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/leave/leavePolicy/leavePolicyModals/createLeavePolicy.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'leavePolicySettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label for="name" class="required">{{ \'leavePolicySettings.creationModal.nameInputLabel\' | translate }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'leavePolicySettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.createLeavePolicyName"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createLeavePolicy()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/leave/leavePolicy/leavePolicyModals/deleteLeaveCategoryFromPolicyModal.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span translate="">{{\'leaveCategoryPolicyConfigurations.deleteModal.title\'}}</span></div><div class="modal-body"><p class="font-16 line-height-1_5" translate="">{{\'leaveCategoryPolicyConfigurations.deleteModal.categoryDeleteConfirmationText\'}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="$close()" translate="">{{\'commonKeywords.yesButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/leave/leavePolicy/leavePolicyModals/deleteLeavePolicyModal.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6">{{ \'leavePolicySettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.leavePolicy.name}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span> {{ \'leavePolicySettings.deleteModal.confirmationTextExtension\' | translate }}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteLeavePolicy()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/leave/leavePolicy/leavePolicyModals/editLeavePolicy.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'leavePolicySettings.editLeavePolicy.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label for="name">{{ \'leavePolicySettings.editLeavePolicy.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'leavePolicySettings.editLeavePolicy.nameInputPlaceholder\' | translate }}" ng-model="vm.edit.leavePolicyName"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.editLeavePolicy()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategoryPolicyConfiguration/create/createConfiguration.html','<div ba-panel="" ba-panel-title="{{ \'leaveCategoryPolicyConfigurations.create.title\' | translate }}"><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isDataLoaded" class="mb-20"><form name="createConfigurationForm" novalidate="" autocomplete="false"><div class="row"><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': createConfigurationForm.leavePolicy.$invalid && createConfigurationForm.leavePolicy.$touched}"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.policyInputLabel\'}}</label><div class="custom-select"><select name="leavePolicy" ng-model="vm.create.leavePolicyId" ng-options="item.id as item.name for item in vm.leavePolicy.leavePolicyList" required=""><option value="" translate="">{{\'leaveCategoryPolicyConfigurations.selectPolicy\'}}</option></select></div><span ng-show="createConfigurationForm.leavePolicy.$invalid && createConfigurationForm.leavePolicy.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.policy\'}}</span></div></div></div><div data-ng-repeat="config in vm.create.configForms"><ng-form name="categoryConfigForm"><div class="row info-box info-box-top"><div class="col-sm-12"><div class="row"><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.leaveCategory.$invalid && categoryConfigForm.leaveCategory.$touched}"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.categoryInputLabel\'}}</label><div class="custom-select"><select id="{{\'leave-category-\' + $index}}" name="leaveCategory" ng-model="config.leaveCategoryId" ng-options="item.id as item.name for item in vm.leaveCategory.leaveCategoryList" required=""><option value="" translate="">{{\'leaveCategoryPolicyConfigurations.selectCategory\'}}</option></select></div><span ng-show="categoryConfigForm.leaveCategory.$invalid && categoryConfigForm.leaveCategory.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.category\'}}</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': categoryConfigForm.totalDays.$invalid && categoryConfigForm.totalDays.$touched}"><label class="required" for="{{\'total-days-\' + $index}}" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.totalDaysInputLabel\'}}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maximumAllowedLeaves\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.totalDays" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'total-days-\' + $index}}" name="totalDays" required="" min="1"> <span ng-show="categoryConfigForm.totalDays.$error.min" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.totalDays.invalid\' }}</span> <span ng-show="categoryConfigForm.totalDays.$invalid && categoryConfigForm.totalDays.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.totalDays.required\' }}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.consecutiveDays.$invalid && categoryConfigForm.consecutiveDays.$touched}"><label for="{{\'consecutive-days-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.consecutiveDaysInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.consecutiveDays\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.consecutiveDays" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'consecutive-days-\' + $index}}" name="consecutiveDays" min="0"> <span ng-show="categoryConfigForm.consecutiveDays.$invalid && categoryConfigForm.consecutiveDays.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\' }}</span></div><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.countOffdaysInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.countOfDaysAsLeaves\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'count-offdays-\' + $index}}" name="countOffdays" ng-model="config.countOffdays" type="checkbox"><span class="slider round"></span></label></div></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.monthlyRestriction.$invalid && categoryConfigForm.monthlyRestriction.$touched}"><label for="{{\'monthly-restriction-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.monthlyRestrictionInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maximumLeavesPerMonth\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.monthlyRestriction" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'monthly-restriction-\' + $index}}" name="monthlyRestriction" min="0"> <span ng-show="categoryConfigForm.monthlyRestriction.$invalid && categoryConfigForm.monthlyRestriction.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\' }}</span></div><div class="form-group"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.selectApplicability\'}}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.applicability\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="custom-select"><select name="applicability" ng-model="config.applicability" ng-options="item.id as item.name for item in vm.create.applicabilityType" required=""></select></div></div><div class="form-group"><label for="{{\'eligible-after-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.eligibleAfterJoiningDate\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.eligibleAfter\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.eligibleAfter" id="{{\'eligible-after-\' + $index}}" name="eligibleAfter" min="1"></div><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.proRataEnabledInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableProrata\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'pro-rata-enabled-\' + $index}}" name="proRataEnabled" ng-model="config.proRataEnabled" type="checkbox"> <span class="slider round"></span></label></div></div><div class="form-group"><label for="{{\'max-avail-times-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.maxAvailTimes\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maxAvailTimes\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.maxAvailTimes" id="{{\'max-avail-times-\' + $index}}" name="maxAvailTimes" min="1"></div></div><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.fileUploadCondition.$invalid && categoryConfigForm.fileUploadCondition.$touched}"><label for="{{\'file-upload-condition-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.fileUploadConditionInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.leavesToFileUpload\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.fileUploadCondition" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'file-upload-condition-\' + $index}}" name="fileUploadCondition" min="0"> <span ng-show="categoryConfigForm.fileUploadCondition.$invalid && categoryConfigForm.fileUploadCondition.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\' }}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.carryType.$invalid && categoryConfigForm.carryType.$touched}"><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.carryTypeInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.leaveCarryType\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="custom-select"><select id="{{\'carry-type-\' + $index}}" name="carryType" ng-model="config.carryType" ng-options="item.id as item.name for item in vm.create.carryTypeList"></select></div><span ng-show="categoryConfigForm.carryType.$invalid && categoryConfigForm.carryType.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\' }}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.maxCarry.$invalid && categoryConfigForm.maxCarry.$touched}"><label for="{{\'max-carry-\' + $index}}" ng-class="{\'required\' : config.carryType !== 0}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.maxCarryInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maximumLeavesToCarry\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="input-group"><input ng-disabled="config.carryType === 0" type="number" class="form-control" ng-model="config.maxCarry" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'max-carry-\' + $index}}" name="maxCarry" min="0" aria-describedby="carry-type-addon"> <span class="input-group-addon" id="carry-type-addon">{{config.carryType===2 ? \'%\' : \'Day(s)\'}}</span></div><span ng-show="categoryConfigForm.maxCarry.$invalid && categoryConfigForm.maxCarry.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\' }}</span></div><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.enablePastDateSelectionInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enablePastDateSelection\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'past-date-selection-enabled-\' + $index}}" name="pastDateSelectionEnabled" ng-model="config.pastDateSelectionEnabled" type="checkbox"><span class="slider round"></span></label></div></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.pastDateSelectionLimit.$invalid && categoryConfigForm.pastDateSelectionLimit.$touched}"><label for="{{\'past-date-selection-limit-\' + $index}}" ng-class="{\'required\' : config.pastDateSelectionEnabled}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.pastDateSelectionLimitInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.setPastDateSelectionLimit\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="input-group"><input ng-disabled="!config.pastDateSelectionEnabled" type="number" class="form-control" ng-model="config.pastDateSelectionLimit" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'past-date-selection-limit-\' + $index}}" name="pastDateSelectionLimit" min="0" ng-required="config.pastDateSelectionEnabled"> <span class="input-group-addon">Day(s)</span></div><span ng-show="categoryConfigForm.pastDateSelectionLimit.$error.min" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\' }}</span> <span ng-show="categoryConfigForm.pastDateSelectionLimit.$invalid && categoryConfigForm.pastDateSelectionLimit.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.create.errorMsg.required\' }}</span></div><div class="form-group" ng-if="vm.isSingleLeaveApproverAllowed"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.enableSingleLeaveApproverLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableSingleLeaveApprover\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'is-single-leave-approver-allowed-\' + $index}}" name="isSingleLeaveApproverAllowed" ng-model="config.isSingleLeaveApproverAllowed" type="checkbox"><span class="slider round"></span></label></div></div><div class="form-group" ng-if="vm.isSequentialLeaveApproverAllowed"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.enableSequentialLeaveApproverLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableSequentialLeaveApprover\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'is-sequential-approval-allowed-\' + $index}}" name="isLeaveApproveSequential" ng-model="config.isLeaveApproveSequential" type="checkbox"><span class="slider round"></span></label></div></div></div></div><div class="row" ng-show="vm.showEarnedLeaveInputFields || config.earnedLeaveEnabled"><div class="col-sm-6"><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.earnedLeaveEnabledInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableEarnedLeave\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'earned-leave-enabled-\' + $index}}" name="earnedLeaveEnabled" ng-model="config.earnedLeaveEnabled" ng-change="vm.toggleVisibilityAndChangeValuesOfEarnedLeaveFields($index)" type="checkbox"> <span class="slider round"></span></label></div></div></div></div><div class="row" ng-show="config.earnedLeaveEnabled"><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.earnedLeaveCriteria.$invalid && categoryConfigForm.earnedLeaveCriteria.$touched}"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.earnedLeaveCriteriaInputLabel\'}}</label><div class="custom-select"><select id="{{\'earned-leave-criteria-\' + $index}}" name="earnedLeaveCriteria" ng-model="config.earnedLeaveCriteria" ng-options="item.id as item.name for item in vm.create.earnedLeaveCriteriaList" ng-required="config.earnedLeaveEnabled"><option value="" translate="">{{\'leaveCategoryPolicyConfigurations.selectCriteria\'}}</option></select></div><span ng-show="categoryConfigForm.earnedLeaveCriteria.$invalid && categoryConfigForm.earnedLeaveCriteria.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.earnedLeaveCriteria\'}}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.maxEarnedLeavaCount.$invalid && categoryConfigForm.maxEarnedLeavaCount.$touched}"><label for="{{\'max-earned-leave-count-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.maxEarnedLeaveCountInputLabel\' }}</label> <input type="number" class="form-control" ng-model="config.maxEarnedLeaveCount" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'max-earned-leave-count-\' + $index}}" name="maxEarnedLeavaCount" min="0"> <span ng-show="categoryConfigForm.maxEarnedLeavaCount.$invalid && categoryConfigForm.maxEarnedLeavaCount.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\'}}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.perDayEarnedLeaveRequiredHours.$invalid && categoryConfigForm.perDayEarnedLeaveRequiredHours.$touched}"><label for="{{\'per-day-earned-leave-required-hours-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.perDayEarnedLeaveRequiredHoursInputLabel\' }}</label> <input type="number" class="form-control" ng-model="config.perDayEarnedLeaveRequiredHours" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'per-day-earned-leave-required-hours-\' + $index}}" name="perDayEarnedLeaveRequiredHours" min="0"> <span ng-show="categoryConfigForm.perDayEarnedLeaveRequiredHours.$invalid && categoryConfigForm.perDayEarnedLeaveRequiredHours.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\'}}</span></div></div><div class="col-sm-6"><div class="form-group"><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.earnedLeaveCapTypeInputLabel\' }}</label><div class="custom-select"><select id="{{\'earned-leave-cap-type-\' + $index}}" name="earnedLeaveCapType" ng-model="config.earnedLeaveCapType" ng-options="item.id as item.name for item in vm.create.earnedLeaveCapTypeList"></select></div></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.earnedLeaveCapAmount.$invalid && categoryConfigForm.earnedLeaveCapAmount.$touched}"><label for="{{\'earned-leave-cap-amount-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.earnedLeaveCapAmountInputLabel\' }}</label> <input type="number" class="form-control" ng-model="config.earnedLeaveCapAmount" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'earned-leave-cap-amount-\' + $index}}" name="earnedLeaveCapAmount" min="0"> <span ng-show="categoryConfigForm.earnedLeaveCapAmount.$invalid && categoryConfigForm.earnedLeaveCapAmount.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\'}}</span></div><div class="form-group"><label for="{{\'expiry-time-window-amount-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.expiryTimeWindowInputLabel\' }}</label><div class="row"><div class="col-sm-6" ng-class="{\'has-error\': categoryConfigForm.expiryTimeWindowAmount.$invalid && categoryConfigForm.expiryTimeWindowAmount.$touched}"><input type="number" class="form-control" ng-model="config.expiryTimeWindowAmount" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'expiry-time-window-amount-\' + $index}}" name="expiryTimeWindowAmount" min="0"> <span ng-show="categoryConfigForm.expiryTimeWindowAmount.$invalid && categoryConfigForm.expiryTimeWindowAmount.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.create.errorMsg.invalidInput\'}}</span></div><div class="col-sm-6"><div class="custom-select"><select id="{{\'expiry-time-window-type-\' + $index}}" name="expiryTimeWindowType" ng-model="config.expiryTimeWindowType" ng-options="item.id as item.name for item in vm.create.expiryTimeWindowTypeList"></select></div></div></div></div></div></div><div class="row" ng-if="$index > 0"><div class="col-sm-6"><button type="button" class="btn btn-md btn-danger" ng-click="vm.removeCategoryConfigForm($index)" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.removeButton\' }}</button></div></div></div></div></ng-form><br><br></div><div class="row"><div class="col-sm-6 flex-container"><button type="submit" class="btn btn-md-with-icon mr-10" ng-disabled="createConfigurationForm.$invalid" ng-class="{\'btn-disable\' : createConfigurationForm.$invalid, \'btn-primary\' : !createConfigurationForm.$invalid}" ng-click="vm.checkFormValidity()"><i class="ion-android-checkmark-circle"></i> <span ng-if="!vm.isCreating" class="ml-negative-5 pb-3">{{\'leaveCategoryPolicyConfigurations.create.form.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button> <button type="button" class="btn btn-md-with-icon btn-secondary" ng-click="vm.addNewCategoryConfigForm()"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-3" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.addMoreButton\'}}</span></button></div></div></form></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategoryPolicyConfiguration/edit/editConfiguration.html','<div><div ba-panel="" ba-panel-title="{{ \'leaveCategoryPolicyConfigurations.edit.title\' | translate }}"><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.isDataLoaded"><div class="row"><div class="col-sm-12"><div><p><span translate="">{{\'leaveCategoryPolicyConfigurations.leavePolicyName\'}}</span> <strong>{{vm.leavePolicyToCategoryConfigs.leavePolicyName}}</strong></p></div></div></div><form name="editConfigurationForm" novalidate="" autocomplete="off"><div data-ng-repeat="config in vm.edit.configForms"><ng-form name="categoryConfigForm"><div class="row info-box info-box-top"><div class="col-sm-12"><div class="row"><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.leaveCategoryId.$invalid && categoryConfigForm.leaveCategoryId.$touched}"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.edit.form.categoryInputLabel\'}}</label><div class="custom-select"><select id="{{\'leave-category-\' + $index}}" name="leaveCategoryId" ng-model="config.leaveCategoryId" ng-options="item.id as item.name for item in vm.leaveCategory.leaveCategoryList" required=""><option value="" translate="">{{\'leaveCategoryPolicyConfigurations.selectCategory\'}}</option></select></div><span ng-show="categoryConfigForm.leaveCategoryId.$invalid && categoryConfigForm.leaveCategoryId.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.edit.errorMsg.category\'}}</span></div><div class="form-group has-feedback" ng-class="{\'has-error\': categoryConfigForm.totalDays.$invalid && categoryConfigForm.totalDays.$touched}"><label class="required" for="{{\'total-days-\' + $index}}" translate="">{{\'leaveCategoryPolicyConfigurations.edit.form.totalDaysInputLabel\'}}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maximumAllowedLeaves\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.totalDays" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'total-days-\' + $index}}" name="totalDays" required="" min="1" ng-change="vm.validateField(config.totalDays, \'totalDays\')" ng-class="{\'has-error\': !vm.isValidField[\'totalDays\']}"> <span ng-show="categoryConfigForm.totalDays.$error.min" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.totalDays.invalid\' }}</span> <span ng-show="categoryConfigForm.totalDays.$invalid && categoryConfigForm.totalDays.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.totalDays.required\' }}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.consecutiveDays.$invalid && categoryConfigForm.consecutiveDays.$touched}"><label for="{{\'consecutive-days-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.consecutiveDaysInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.consecutiveDays\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.consecutiveDays" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'consecutive-days-\' + $index}}" name="consecutiveDays" ng-change="vm.validateField(config.consecutiveDays, \'consecutiveDays\')" ng-class="{\'has-error\': !vm.isValidField[\'consecutiveDays\']}"> <span ng-show="categoryConfigForm.consecutiveDays.$invalid && categoryConfigForm.consecutiveDays.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\' }}</span></div><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.countOffdaysInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.countOfDaysAsLeaves\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'count-offdays-\' + $index}}" name="countOffdays" ng-model="config.countOffdays" type="checkbox"> <span class="slider round"></span></label></div></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.monthlyRestriction.$invalid && categoryConfigForm.monthlyRestriction.$touched}"><label for="{{\'monthly-restriction-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.monthlyRestrictionInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maximumLeavesPerMonth\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.monthlyRestriction" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'monthly-restriction-\' + $index}}" name="monthlyRestriction" ng-change="vm.validateField(config.monthlyRestriction, \'monthlyRestriction\')" ng-class="{\'has-error\': !vm.isValidField[\'monthlyRestriction\']}"> <span ng-show="categoryConfigForm.monthlyRestriction.$invalid && categoryConfigForm.monthlyRestriction.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\' }}</span></div><div class="form-group"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.create.form.selectApplicability\'}}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.applicability\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="custom-select"><select name="applicability" ng-model="config.applicability" ng-options="item.id as item.name for item in vm.edit.applicabilityType" required=""></select></div></div><div class="form-group"><label for="{{\'eligible-after-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.eligibleAfterJoiningDate\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.eligibleAfter\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.eligibleAfter" id="{{\'eligible-after-\' + $index}}" name="eligibleAfter" min="1"></div><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.proRataEnabledInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableProrata\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'pro-rata-enabled-\' + $index}}" name="proRataEnabled" ng-model="config.proRataEnabled" type="checkbox"> <span class="slider round"></span></label></div></div><div class="form-group"><label for="{{\'max-avail-times-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.maxAvailTimes\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maxAvailTimes\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.maxAvailTimes" id="{{\'max-avail-times-\' + $index}}" name="maxAvailTimes" min="1"></div></div><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.fileUploadCondition.$invalid && categoryConfigForm.fileUploadCondition.$touched}"><label for="{{\'file-upload-condition-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.fileUploadConditionInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.leavesToFileUpload\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i> <input type="number" class="form-control" ng-model="config.fileUploadCondition" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'file-upload-condition-\' + $index}}" name="fileUploadCondition" ng-change="vm.validateField(config.fileUploadCondition, \'fileUploadCondition\')" ng-class="{\'has-error\': !vm.isValidField[\'fileUploadCondition\']}"> <span ng-show="categoryConfigForm.fileUploadCondition.$invalid && categoryConfigForm.fileUploadCondition.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\' }}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.carryType.$invalid && categoryConfigForm.carryType.$touched}"><label translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.carryTypeInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.leaveCarryType\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="custom-select"><select id="{{\'carry-type-\' + $index}}" name="carryType" ng-model="config.carryType" ng-options="item.id as item.name for item in vm.edit.carryTypeList"></select></div><span ng-show="categoryConfigForm.carryType.$invalid && categoryConfigForm.carryType.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\' }}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.maxCarry.$invalid && categoryConfigForm.maxCarry.$touched}"><label for="{{\'max-carry-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.maxCarryInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.maximumLeavesToCarry\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="input-group"><input ng-disabled="config.carryType === 0" type="number" class="form-control" ng-model="config.maxCarry" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'max-carry-\' + $index}}" name="maxCarry" aria-describedby="carry-type-addon" ng-change="vm.validateField(config.maxCarry, \'maxCarry\')" ng-class="{\'has-error\': !vm.isValidField[\'maxCarry\']}"> <span class="input-group-addon" id="carry-type-addon">{{config.carryType===2 ? \'%\' : \'Day(s)\'}}</span></div><span ng-show="categoryConfigForm.maxCarry.$invalid && categoryConfigForm.maxCarry.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\' }}</span></div><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.enablePastDateSelectionInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enablePastDateSelection\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'past-date-selection-enabled-\' + $index}}" name="pastDateSelectionEnabled" ng-model="config.pastDateSelectionEnabled" type="checkbox"><span class="slider round"></span></label></div></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.pastDateSelectionLimit.$invalid && categoryConfigForm.pastDateSelectionLimit.$touched}"><label for="{{\'past-date-selection-limit-\' + $index}}" ng-class="{\'required\' : config.pastDateSelectionEnabled}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.pastDateSelectionLimitInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.setPastDateSelectionLimit\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i><div class="input-group"><input ng-disabled="!config.pastDateSelectionEnabled" type="number" class="form-control" ng-model="config.pastDateSelectionLimit" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'past-date-selection-limit-\' + $index}}" name="pastDateSelectionLimit" min="0" ng-required="config.pastDateSelectionEnabled"> <span class="input-group-addon">Day(s)</span></div><span ng-show="categoryConfigForm.pastDateSelectionLimit.$error.min" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\' }}</span> <span ng-show="categoryConfigForm.pastDateSelectionLimit.$invalid && categoryConfigForm.pastDateSelectionLimit.$touched" class="help-block error-block basic-block" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.errorMsg.required\' }}</span></div><div class="form-group" ng-if="vm.isSingleLeaveApproverAllowed"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.enableSingleLeaveApproverLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableSingleLeaveApprover\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'is-single-leave-approver-allowed-\' + $index}}" name="isSingleLeaveApproverAllowed" ng-model="config.isSingleLeaveApproverAllowed" type="checkbox"><span class="slider round"></span></label></div></div><div class="form-group" ng-if="vm.isSequentialLeaveApproverAllowed"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.create.form.enableSequentialLeaveApproverLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableSequentialLeaveApprover\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'is-sequential-approval-allowed-\' + $index}}" name="isLeaveApproveSequential" ng-model="config.isLeaveApproveSequential" type="checkbox"><span class="slider round"></span></label></div></div></div></div><div class="row" ng-show="vm.showEarnedLeaveInputFields || config.earnedLeaveEnabled"><div class="col-sm-6"><div class="form-group"><div><label translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.earnedLeaveEnabledInputLabel\' }}</label> <i class="fa fa fa-info-circle font-12 ml-8" data-toggle="tooltip" uib-tooltip="{{\'leaveCategoryPolicyConfigurations.info.enableEarnedLeave\' | translate}}" tooltip-placement="bottom" tooltip-enable="true" tooltip-append-to-body="true"></i></div><div class="mt-5"><label class="custom-switch"><input id="{{\'earned-leave-enabled-\' + $index}}" name="config.earnedLeaveEnabled" ng-model="config.earnedLeaveEnabled" ng-change="vm.toggleVisibilityAndChangeValuesOfEarnedLeaveFields($index)" type="checkbox"> <span class="slider round"></span></label></div></div></div></div><div class="row" ng-show="config.earnedLeaveEnabled"><div class="col-sm-6"><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.earnedLeaveCriteria.$invalid && categoryConfigForm.earnedLeaveCriteria.$touched}"><label class="required" translate="">{{\'leaveCategoryPolicyConfigurations.edit.form.earnedLeaveCriteriaInputLabel\'}}</label><div class="custom-select"><select id="{{\'earned-leave-criteria-\' + $index}}" name="earnedLeaveCriteria" ng-model="config.earnedLeaveCriteria" ng-options="item.id as item.name for item in vm.edit.earnedLeaveCriteriaList" ng-required="config.earnedLeaveEnabled"><option value="" translate="">{{\'leaveCategoryPolicyConfigurations.selectCriteria\'}}</option></select></div><span ng-show="categoryConfigForm.earnedLeaveCriteria.$invalid && categoryConfigForm.earnedLeaveCriteria.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.edit.errorMsg.earnedLeaveCriteria\'}}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.maxEarnedLeavaCount.$invalid && categoryConfigForm.maxEarnedLeavaCount.$touched}"><label for="{{\'max-earned-leave-count-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.maxEarnedLeaveCountInputLabel\' }}</label> <input type="number" class="form-control" ng-model="config.maxEarnedLeaveCount" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'max-earned-leave-count-\' + $index}}" name="maxEarnedLeaveCount"> <span ng-show="categoryConfigForm.maxEarnedLeavaCount.$invalid && categoryConfigForm.maxEarnedLeavaCount.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\'}}</span></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.perDayEarnedLeaveRequiredHours.$invalid && categoryConfigForm.perDayEarnedLeaveRequiredHours.$touched}"><label for="{{\'per-day-earned-leave-required-hours-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.perDayEarnedLeaveRequiredHoursInputLabel\' }}</label> <input type="number" class="form-control" ng-model="config.perDayEarnedLeaveRequiredHours" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'per-day-earned-leave-required-hours-\' + $index}}" name="perDayEarnedLeaveRequiredHours"> <span ng-show="categoryConfigForm.perDayEarnedLeaveRequiredHours.$invalid && categoryConfigForm.perDayEarnedLeaveRequiredHours.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\'}}</span></div></div><div class="col-sm-6"><div class="form-group"><label translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.earnedLeaveCapTypeInputLabel\' }}</label><div class="custom-select"><select id="{{\'earned-leave-cap-type-\' + $index}}" name="earnedLeaveCapType" ng-model="config.earnedLeaveCapType" ng-options="item.id as item.name for item in vm.edit.earnedLeaveCapTypeList"></select></div></div><div class="form-group" ng-class="{\'has-error\': categoryConfigForm.earnedLeaveCapAmount.$invalid && categoryConfigForm.earnedLeaveCapAmount.$touched}"><label for="{{\'earned-leave-cap-amount-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.earnedLeaveCapAmountInputLabel\' }}</label> <input type="number" class="form-control" ng-model="config.earnedLeaveCapAmount" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'earned-leave-cap-amount-\' + $index}}" name="earnedLeaveCapAmount"> <span ng-show="categoryConfigForm.earnedLeaveCapAmount.$invalid && categoryConfigForm.earnedLeaveCapAmount.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\'}}</span></div><div class="form-group"><label for="{{\'expiry-time-window-\' + $index}}" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.expiryTimeWindowInputLabel\' }}</label><div class="row"><div class="col-sm-6" ng-class="{\'has-error\': categoryConfigForm.expiryTimeWindowAmount.$invalid && categoryConfigForm.expiryTimeWindowAmount.$touched}"><input type="number" class="form-control" ng-model="config.expiryTimeWindowAmount" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'expiry-time-window-\' + $index}}" name="expiryTimeWindowAmount"> <span ng-show="categoryConfigForm.expiryTimeWindowAmount.$invalid && categoryConfigForm.expiryTimeWindowAmount.$touched" class="help-block error-block basic-block" translate="">{{\'leaveCategoryPolicyConfigurations.edit.errorMsg.invalidInput\'}}</span></div><div class="col-sm-6"><div class="custom-select"><select class="form-control" id="{{\'expiry-time-window-type-\' + $index}}" name="expiryTimeWindowType" ng-model="config.expiryTimeWindowType" ng-options="item.id as item.name for item in vm.edit.expiryTimeWindowTypeList"></select></div></div></div></div></div></div><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-md btn-primary" ng-disabled="categoryConfigForm.$invalid" ng-click="vm.checkFormValidity($index, config.id)"><span ng-if="!vm.isEditing">{{ \'leaveCategoryPolicyConfigurations.edit.form.saveButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.openDeleteCategoryFromConfigurationModal($index, config.id)" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.removeButton\' }}</button></div></div></div></div></ng-form><br><br></div><div class="row mb-20"><div class="col-sm-6"><button type="button" class="btn btn-md btn-secondary" ng-click="vm.addNewCategoryConfigForm()" translate="">{{ \'leaveCategoryPolicyConfigurations.edit.form.addMoreButton\' }}</button></div></div></form></div></div></div>');
$templateCache.put('app/pages/main/leave/uploadLeaveBalance/modal/excelModal.html','<body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">Upload History</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16" ng-if="!vm.showErrorBlock">Successfully insert items <span>{{vm.responseInfo.insertedItems}}</span></p><div ng-if="vm.showErrorBlock"><ui ng-repeat="error in vm.responseInfo.error"><li class="mb-5 text-danger font-15">{{error}}</li></ui></div><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.closeButton\'}}</button> <button ng-if="vm.responseInfo.error.length > 0" type="button" class="btn btn-md btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.showError()" translate="">{{\'commonKeywords.viewErrorButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/employees/batchCreate/create/batchCreate.html','<div ng-controller="BatchCreateCtrl as vm"><h3 class="panel-title with-line" translate="">{{ \'employeesBatchCreation.employeeCreationGuidline\' }}</h3><ul class="line-height-1_8"><li translate="">{{\'employeesBatchCreation.employeeCreationGuidlineList.listItem_1\'}}</li><li translate="">{{\'employeesBatchCreation.employeeCreationGuidlineList.listItem_2\'}}</li><li translate="">{{\'employeesBatchCreation.employeeCreationGuidlineList.listItem_3\'}}</li><li translate="">{{\'employeesBatchCreation.employeeCreationGuidlineList.listItem_4\'}}</li><li class="red-text" translate="">{{\'employeesBatchCreation.employeeCreationGuidlineList.listItem_5\'}}</li><li translate="">{{\'employeesBatchCreation.employeeCreationGuidlineList.listItem_6\'}}</li></ul><h3 class="panel-title with-line" translate="">{{ \'employeesBatchCreation.downloadSample\' }}</h3><div class="row"><div class="col-md-4"><a ng-href="{{vm.batchCreateExcelUrl}}" target="_self"><button class="btn btn-md-with-icon btn-secondary padding-5-12" ng-click="vm.analyticsDownloadSample()"><img src="../assets/img/download_white.png"> <span class="ml-negative-5" translate="">{{\'employeesBatchCreation.downloadSample\'}}</span></button></a></div></div><h3 class="panel-title with-line" translate="">{{ \'employeesBatchCreation.uploadFile\' }}</h3><div class="row mb-20"><div class="col-md-3"><button class="btn btn-md-with-icon btn-primary padding-5-12" ngf-select="vm.verifySelectedExcelFile($file)" ng-model="vm.file" ngf-multiple="false" ngf-accept="\'.xls,.xlsx\'"><img src="../assets/img/Upload.png"> <span class="ml-negative-5" translate="">{{\'employeesBatchCreation.uploadButton\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/employees/batchCreate/history/history.html','<style>\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .scrollable-table {\n        max-height: 65vh;\n        overflow: auto;\n        position: relative;\n    }\n    button[disabled]{\n        opacity: initial!important;\n    }\n</style><div ng-controller="HistoryCtrl as vm"><h2 class="with-line color-prime mb-15" translate="">{{ \'employeesBatchCreation.batchCreationHistory\' }}</h2><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip mb-20" ng-if="vm.requests.length > 0"><thead><tr><th class="text-center width-10" translate="">{{ \'employeesBatchCreation.historyTableHeader.employeeOfficeId\' }}</th><th class="text-left" translate="">{{ \'employeesBatchCreation.historyTableHeader.name\' }}</th><th class="text-left" translate="">{{ \'employeesBatchCreation.historyTableHeader.email\' }}</th><th class="text-center" translate="">{{ \'employeesBatchCreation.historyTableHeader.reportPosition\' }}</th><th class="text-center" translate="">{{ \'employeesBatchCreation.historyTableHeader.rfid\' }}</th><th class="text-left" translate="">{{ \'employeesBatchCreation.historyTableHeader.primaryText\' }}</th><th class="text-left" translate="">{{ \'employeesBatchCreation.historyTableHeader.secondaryText\' }}</th><th class="text-left" ng-if="vm.isSubsidiaryAdmin" translate="">{{ \'employeesBatchCreation.historyTableHeader.subsidiaryName\' }}</th><th class="text-center" translate="">{{ \'employeesBatchCreation.historyTableHeader.status\' }}</th><th class="text-center" translate="">{{ \'employeesBatchCreation.historyTableHeader.action\' }}</th></tr></thead><tbody><tr ng-repeat="request in vm.requests"><td class="text-center">{{request.employeeOfficeId}}</td><td class="text-left">{{request.name}}</td><td class="text-left">{{request.email}}</td><td class="text-center">{{request.reportPosition}}</td><td class="text-center">{{request.rfid}}</td><td class="text-left">{{request.primaryText}}</td><td class="text-left">{{request.secondaryText}}</td><td class="text-left" ng-if="vm.isSubsidiaryAdmin">{{request.subsidiaryName}}</td><td class="text-center orange-text" ng-if="request.status==0">{{\'employeesBatchCreation.historyTableStatusColumnValues.pending\' | translate}}</td><td class="text-center red-text" ng-if="request.status==-1">{{\'employeesBatchCreation.historyTableStatusColumnValues.failed\' |translate}}</td><td class="text-center green-text" ng-if="request.status==1">{{\'employeesBatchCreation.historyTableStatusColumnValues.done\' | translate}}</td><td class="text-center pr-8-important"><button class="btn btn-sm btn-info" ng-disabled="vm.getDisabled(request)" ng-class="{\'btn-disable\' : vm.getDisabled(request), \'btn-secondary\' : !vm.getDisabled(request)}" ng-click="vm.retry($index,request.id)" translate="">{{\'employeesBatchCreation.retryButton\'}}</button></td></tr></tbody></table></div><div class="row text-center mb-20" ng-if="vm.requests.length == 0"><i translate="">{{ \'employeesBatchCreation.noHistory\' }}</i></div></div>');
$templateCache.put('app/pages/main/employees/batchCreate/uploadConfirmation/uploadConfirmation.html','<style>\n    .import-status-table {\n        max-height: 45vh;\n        overflow-y: auto;\n    }\n    .error {\n        background-color: rgba(232, 86, 86, 0.4) !important;\n        border-left: 4px solid #e85656 !important;\n    }\n    .error td {\n        color: #000 !important;\n        font-weight: 500;\n        background-color: rgba(232, 86, 86, 0.4) !important;\n    }\n    /* Override .modified styling within error rows */\n    .error td.modified {\n        color: #000 !important;\n        background-color: transparent !important;\n    }\n    .error:hover {\n        background-color: rgba(232, 86, 86, 0.5) !important;\n    }\n    .error:hover td {\n        background-color: rgba(232, 86, 86, 0.5) !important;\n    }\n    .panel-full-screen {\n        max-height: 80vh;\n        position: relative;\n        overflow-y: auto;\n    }\n    .batch-upload-confirmation-table > td, th {\n        text-overflow: ellipsis;\n    }\n    .td-break{\n        word-break: break-all;\n    }\n    td {\n        white-space: nowrap;\n    }\n    .table-header > thead > tr > td {\n        background-color: var(--color-secondary);\n        color:white;\n    }\n</style><div ba-panel="" ba-panel-title="Uploaded File Information" ba-panel-class="with-scroll panel-full-screen"><div class="row d-flex-center-center-inherit" ng-if="!vm.isVerificationDone"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isVerificationDone"><div class="row"><div class="col-md-12"><div><p class="text-warning text-uppercase" translate="">{{\'employeesBatchCreation.informationChanged\'}}</p><div class="horizontal-scroll import-status-table attendanceDiv width-100" fixed-column-table="" fixed-columns="4"><table class="table report-table batch-upload-confirmation-table table-header"><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.id\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.employeeName\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.email\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.reportPosition\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.rfid\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.primaryText\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.secondaryText\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.joiningDate\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.endDate\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.workplace\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.employmentType\'}}</th><th ng-if="vm.payrollAvailable" class="text-center">{{vm.payrollType === 1 ? "Gross " : "Basic "}} <span translate="">{{\'employeesBatchCreation.employeesTableHeader.salary\'}}</span></th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.paymentMethod\'}}</th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.bankName\'}}</th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.accountNumber\'}}</th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.routingNumber\'}}</th></tr></thead><tbody ng-if="vm.existingEmployees == null || vm.existingEmployees.length === 0"><tr><td colspan="{{vm.colSpan}}" class="text-center"><em translate="">{{\'employeesBatchCreation.employeesWithNoChangeText\'}}</em></td></tr></tbody><tbody ng-if="vm.existingEmployees != null && vm.existingEmployees.length > 0"><tr ng-repeat="employee in vm.existingEmployees" ng-class="{error : employee.hasError}" data-toggle="tooltip" uib-tooltip="{{vm.getTooltipText(employee.row.errorMessages)}}" tooltip-placement="top" tooltip-enable="employee.hasError" tooltip-append-to-body="true"><td class="text-center">{{$index+1}}</td><td class="text-center" ng-class="{modified: employee.isEmployeeOfficeIdChanged}">{{employee.row.employeeOfficeId}}</td><td class="text-center"><employee-picture-and-information name="employee.row.employeeName" picture-url="employee.pictureUrl" department-name="employee.row.departmentName" designation-name="employee.row.designationName" is-clickable="false" is-department-changed="employee.isDepartmentChanged" is-designation-changed="employee.isDesignationChanged"></employee-picture-and-information></td><td class="text-left td-break">{{employee.row.email}}</td><td class="text-center" ng-class="{modified: employee.isReportPositionChanged}">{{employee.row.reportPosition}}</td><td class="text-center" ng-class="{modified: employee.isRfidChanged}">{{employee.row.rfid}}</td><td class="text-center" ng-class="{modified: employee.isPrimaryTextChanged}">{{employee.row.primaryDisplayText}}</td><td class="text-center" ng-class="{modified: employee.isSecondaryTextChanged}">{{employee.row.secondaryDisplayText}}</td><td class="text-center" ng-class="{modified: employee.isDateOfJoinChanged}">{{employee.row.dateOfJoin | date:\'dd MMM yyyy\'}}</td><td class="text-center" ng-class="{modified: employee.isDateOfResignationChanged}">{{employee.row.dateOfResignation | date:\'dd MMM yyyy\'}}</td><td class="text-center" ng-class="{modified: employee.isWorkplaceChanged}">{{employee.row.workplaceName}}</td><td class="text-center" ng-class="{modified: employee.isEmploymentTypeChanged}">{{employee.row.employmentTypeName}}</td><td ng-if="vm.payrollAvailable" class="text-center" ng-class="{modified: employee.isSalaryChanged}">{{employee.row.salary}}</td><td ng-if="vm.payrollAvailable" class="text-center" ng-class="{modified: employee.isPaymentModeChanged}">{{employee.row.paymentMode}}</td><td ng-if="vm.payrollAvailable" class="text-center" ng-class="{modified: employee.isBankNameChanged}">{{employee.row.bankName}}</td><td ng-if="vm.payrollAvailable" class="text-center" ng-class="{modified: employee.isAccountNumberChanged}">{{employee.row.accountNumber}}</td><td ng-if="vm.payrollAvailable" class="text-center" ng-class="{modified: employee.isRoutingNumberChanged}">{{employee.row.routingNumber}}</td></tr></tbody></table></div></div></div></div><br><br><br><div class="row"><div class="col-md-12"><div><p class="text-success text-uppercase" translate="">{{\'employeesBatchCreation.newEmployee\'}}</p><div class="horizontal-scroll import-status-table attendanceDiv width-100" fixed-column-table="" fixed-columns="4"><table class="table report-table batch-upload-confirmation-table table-header"><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.id\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.employeeName\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.email\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.reportPosition\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.rfid\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.primaryText\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.secondaryText\'}}</th><th class="text-center" ng-if="vm.isSubsidiaryAdmin" translate="">{{ \'employeesBatchCreation.historyTableHeader.subsidiaryName\' }}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.joiningDate\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.endDate\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.workplace\'}}</th><th class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.employmentType\'}}</th><th ng-if="vm.payrollAvailable" class=\'text-center"\'>{{vm.payrollType === 1 ? "Gross " : "Basic "}} <span translate="">{{\'employeesBatchCreation.employeesTableHeader.salary\'}}</span></th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.paymentMethod\'}}</th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.bankName\'}}</th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.accountNumber\'}}</th><th ng-if="vm.payrollAvailable" class="text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.routingNumber\'}}</th></tr></thead><tbody ng-if="vm.newEmployees == null || vm.newEmployees.length === 0"><tr><td colspan="{{vm.colSpan}}" class="text-center"><em translate="">{{\'employeesBatchCreation.NoNewEmployees\'}}</em></td></tr></tbody><tbody ng-if="vm.newEmployees != null && vm.newEmployees.length > 0"><tr ng-repeat="employee in vm.newEmployees" ng-class="{error : employee.hasError}" data-toggle="tooltip" uib-tooltip="{{vm.getTooltipText(employee.row.errorMessages)}}" tooltip-placement="top" tooltip-enable="employee.hasError" tooltip-append-to-body="true"><td class="text-center">{{$index+1}}</td><td class="text-center">{{employee.row.employeeOfficeId}}</td><td class="text-center"><employee-picture-and-information name="employee.row.employeeName" picture-url="" department-name="employee.row.departmentName" designation-name="employee.row.designationName" is-clickable="false"></employee-picture-and-information></td><td class="text-left td-break">{{employee.row.email}}</td><td class="text-center">{{employee.row.reportPosition}}</td><td class="text-center">{{employee.row.rfid}}</td><td class="text-center">{{employee.row.primaryDisplayText}}</td><td class="text-center">{{employee.row.secondaryDisplayText}}</td><td class="text-center" ng-if="vm.isSubsidiaryAdmin">{{employee.row.subsidiaryName}}</td><td class="text-center">{{employee.row.dateOfJoin | date:\'dd MMM yyyy\'}}</td><td class="text-center">{{employee.row.dateOfResignation | date:\'dd MMM yyyy\'}}</td><td class="text-center">{{employee.row.workplaceName}}</td><td class="text-center">{{employee.row.employmentTypeName}}</td><td ng-if="vm.payrollAvailable" class="text-center">{{employee.row.salary}}</td><td ng-if="vm.payrollAvailable" class="text-center">{{employee.row.paymentMode}}</td><td ng-if="vm.payrollAvailable" class="text-center">{{employee.row.bankName}}</td><td ng-if="vm.payrollAvailable" class="text-center">{{employee.row.accountNumber}}</td><td ng-if="vm.payrollAvailable" class="text-center">{{employee.row.routingNumber}}</td></tr></tbody></table></div></div></div></div><br><br><br><div class="row"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md btn-danger" ui-sref="employees.batchCreateEmployees" translate="">{{\'employeesBatchCreation.cancelUploadButton\'}}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.uploadFile()" ng-disabled="vm.hasError" translate="">{{\'employeesBatchCreation.confirmButton\'}}</button></div></div></div></div></div>');
$templateCache.put('app/pages/main/employees/fieldVisit/apply/applyFieldVisit.html','<style>\n.section-border-bg{\n    border:2px solid #f7f7f7;\n    background:#f7f7f7;\n}\n.time-picker-label{\n    top: 50%;\n    transform: translateY(-50%);\n}\nhr {\n     margin-top: 12px;\n     margin-bottom: 12px;\n     border: 0;\n     border-top: 2px solid #eee;\n }\n.dummy-modal-placement{\n    position: absolute;\n    top:60%;\n    left:20%;\n}\n@media (max-width: 991px) {\n    .dummy-modal-placement{\n        position: absolute;\n        top:80%;\n        left:25%;\n    }\n}\n</style><div ba-panel="" ba-panel-title="Apply Field Visit" ba-panel-class="with-scroll"><div class="row mb-55"><div class="col-md-6 col-sm-12"><div class="row"><div class="col-md-12"><p class="text-left text-capitalize color-22222 font-weight-500 font-16">{{\'fieldVisit.applyNewFieldVisitHeadingText\' | translate}}</p></div></div><div class="row"><div class="col-md-12"><form name="applyFieldVisitForm" novalidate=""><div class="row section-border-bg bottom"><div class="col-md-12"><div class="row pt-15 pr-15"><div class="col-md-12"><label class="required" translate="">{{\'fieldVisit.selectEmployee\'}}</label><div class="form-group"><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.onEmployeeSelect()" on-select-all="vm.onEmployeeSelect()" on-select-none="vm.onEmployeeSelect()" on-reset="vm.onReset()" on-clear="vm.onEmployeeSelect()" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><hr><div class="row pr-15 pb-10 pt-10"><div class="col-md-12"><label class="required" translate="">{{\'fieldVisit.selectDateRange\'}}</label><div ng-class="{\'prevent-clicks\': vm.selectedEmployee.length === 0}"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.fieldVisitDatePicker.date" options="vm.fieldVisitDatePicker.options"><span class="date-position-left">{{vm.fieldVisitDatePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.fieldVisitDatePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div></div><hr><div class="row"><div class="ml-15 mt-10 mb-10"><label class="required">{{\'fieldVisit.selectTime\' | translate}}</label></div><div class="col-md-12 d-flex-space-between flex-wrap" ng-if="vm.isShiftDataLoaded"><div><div class="height-10-vh d-flex-flex-start"><div class="pt-42 pr-15"><span>{{\'commonKeywords.from\' | translate}}</span></div><div><div id="fieldVisitEntryTime" ng-model="vm.fieldVisitEntryTime" uib-timepicker=""></div></div></div></div><div class="pr-15"><div class="height-10-vh d-flex-flex-end"><div class="pt-42 pr-15"><span>{{\'commonKeywords.to\' | translate}}</span></div><div><div id="fieldVisitExitTime" ng-model="vm.fieldVisitExitTime" uib-timepicker=""></div></div></div></div></div></div><hr><div class="row" ng-if="!vm.isShiftDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="row pr-15 pt-10 pb-10"><div class="col-md-12"><label for="field-visit-reason" class="form-label font-15 required">{{\'commonKeywords.reason\' | translate}}</label> <textarea type="text" name="reason" id="field-visit-reason" class="form-control" placeholder="{{\'commonKeywords.placeholderTextForReason\' | translate}}" ng-model="vm.reason" required=""></textarea></div></div><hr><div class="row pr-15 pt-10 pb-10"><div class="col-md-12"><label class="font-15 required" for="field-visit-area">{{\'fieldVisit.area\' | translate}}</label> <input type="text" id="field-visit-area" class="form-control" placeholder="{{\'fieldVisit.placeholderTextForArea\' | translate}}" ng-model="vm.area"></div></div><hr><div class="row mb-35 d-flex-flex-end"><div class="mt-12 mr-35"><label class="text-normal checkbox-container" for="force-approve"><input type="checkbox" id="force-approve" ng-model="vm.approvalNeededFromApprover"> <span class="custom-checkbox"></span> <span class="ml-30" translate="">{{\'fieldVisit.forceApproveText\'}}</span></label></div><div class="mr-32"><button type="button" class="btn btn-md btn-primary" ng-disabled="vm.isSubmitting" ng-click="vm.applyForFieldVisit()">{{vm.buttonName}}</button></div></div></div></div></form></div></div></div><div class="col-md-6 position-relative"><div class="row"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</p></div></div><div class="position-relative" ng-if="vm.isEmployeeSelected && vm.isdataLoaded"><div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-bg th-width"><td colspan="2"><employee-picture-and-information name="vm.employeeToShow.name" picture-url="vm.employeeToShow.employeePictureUrl" department-name="vm.employeeToShow.department.name" designation-name="!vm.employeeToShow.designation ? \'N/A\':vm.employeeToShow.designation.name" id="vm.employeeToShow.id" is-clickable="vm.employeeToShow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.workplace\'}}</td><td>{{vm.employeeToShow.workplace ? vm.employeeToShow.workplace.name : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500" translate="">{{\'fieldVisit.lastFiveFieldVisitHeading\'}}</p></div><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-35"><col class="width-25"><col class="width-40"></colgroup><thead><tr class="text-left dont-wrap-text th-bg"><th class="text-lest" translate="">{{\'commonKeywords.location\'}}</th><th class="text-center" translate="">{{\'commonKeywords.dateRange\'}}</th><th class="text-center" translate="">{{\'commonKeywords.appliedBy\'}}</th></tr></thead><tbody><tr class="text-left dont-wrap-text" ng-repeat="data in vm.lastFiveFieldVisitData"><td class="dont-wrap-text">{{data.area}}</td><td class="dont-wrap-text">{{data.startDate |date:\'d MMM yyyy\'}} - {{data.endDate |date:\'d MMM yyyy\'}}</td><td class="dont-wrap-text"><employee-picture-and-information name="data.requestorName" picture-url="data.requestorProfilePicture" department-name="data.requestorDepartmentName" designation-name="data.requestorDesignationName" is-clickable="true"></employee-picture-and-information></td></tr></tbody></table></div></div></div><div class="row" ng-if="vm.isEmployeeSelected && !vm.isdataLoaded"><div class="col-md-12"><div class="text-center align-self-start"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="!vm.isEmployeeSelected" ng-class="{\'unselected\': vm.isEmployeeSelected == false}" include-with-scope="app/pages/main/employees/fieldVisit/apply/partials/dummyTable.html"></div><div class="row ng-scope" ng-if="!vm.isEmployeeSelected"><div include-with-scope="app/pages/main/employees/fieldVisit/apply/partials/dummyOverlay.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/employees/fieldVisit/partials/dummyTable.html','<div class="col-md-12"><div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-bg th-width"><td colspan="2"><employee-picture-and-information name="vm.employeeToShow.name" picture-url="vm.employeeToShow.pictureUrl" department-name="vm.selectedLeaveApplication.departmentName" designation-name="!vm.employeeToShow.designationName ? \'N/A\':vm.employeeToShow.designationName.name" id="vm.employeeToShow.id" is-clickable="vm.employeeToShow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.workplace\'}}</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-12"><h4 translate="">{{\'fieldVisit.applicationInfoHeader\'}}</h4></div><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.dateRange\'}}</td><td class="dont-wrap-text">{{vm.selectedRow.startDate |date:\'d MMM yyyy\'}}-{{vm.selectedRow.endDate |date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.reason\'}}</td><td class="dont-wrap-text">{{vm.selectedRow.reason}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.entry\'}}</td><td class="dont-wrap-text">{{vm.selectedRow.entryTime | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.exit\'}}</td><td class="dont-wrap-text">{{vm.selectedRow.exitTime | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.location\'}}</td><td class="dont-wrap-text">{{vm.selectedRow.area}}</td></tr><tr class="text-left dont-wrap-text" ng-if="vm.selectedRow.status === 0"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.hrManagerStatus\'}}</td><td class="dont-wrap-text"><span>{{vm.selectedRow.hrManagerName}}</span> <span ng-if="vm.selectedRow.hrManagerApprovalStatus === 1">(<span translate="">{{\'commonKeywords.approved\'}}</span>)</span> <span ng-if="vm.selectedRow.hrManagerApprovalStatus === 0">(<span translate="">{{\'commonKeywords.pending\'}}</span>)</span></td></tr><tr class="text-left dont-wrap-text" ng-if="vm.selectedRow.status === 0"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.lineManagerStatus\'}}</td><td class="dont-wrap-text"><span>{{vm.selectedRow.lineManagerName}}</span> <span ng-if="vm.selectedRow.lineManagerApprovalStatus === 1">(<span translate="">{{\'commonKeywords.approved\'}}</span>)</span> <span ng-if="vm.selectedRow.lineManagerApprovalStatus === 0">(<span translate="">{{\'commonKeywords.pending\'}}</span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'fieldVisit.applicationInfoTable.appliedBy\'}}</td><td class="dont-wrap-text"><employee-picture-and-information name="vm.selectedRow.appliedByName" picture-url="vm.selectedRow.appliedByPictureUrl" department-name="vm.selectedRow.appliedByDepartment" designation-name="vm.selectedRow.appliedByDesignation" is-clickable="true"></employee-picture-and-information></td></tr></tbody></table><div class="text-center align-self-start" ng-if="!vm.isEmployeeInfoLoaded && vm.isEmployeeSelected"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/employees/syncExternal/partials/syncExternalBBL.html','<div ba-panel="" ba-panel-title="Sync Employees" ba-panel-class="with-scroll"><h3 class="with-line" translate="">{{\'syncExternal.guidelinesTitle\'}}</h3><ul class="bottom line-height-1_8"><li translate="">{{\'syncExternal.guidelines.guideline_1\'}}</li><li translate="">{{\'syncExternal.guidelines.guideline_3\'}}</li></ul><br><br><div class="row mb-20 d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row mb-20" ng-if="vm.isDataLoaded"><div class="col-md-2"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format("D MMM YYYY")}} - {{vm.datePicker.date.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-2"><button class="btn btn-md-with-icon btn-primary" ng-click="vm.syncEmployeesBBL()"><i class="ion-android-sync"></i> <span class="ml-negative-5 pb-2" translate="">{{\'syncExternal.syncButton\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/employees/syncExternal/partials/syncExternalIDLC.html','<div ba-panel="" ba-panel-title="Sync Employees" ba-panel-class="with-scroll"><h3 class="with-line" translate="">{{\'syncExternal.guidelinesTitle\'}}</h3><ul class="bottom line-height-1_8"><li translate="">{{\'syncExternal.guidelines.guideline_1\'}}</li><li translate="">{{\'syncExternal.guidelines.guideline_2\'}}</li><li translate="">{{\'syncExternal.guidelines.guideline_3\'}}</li><li translate="">{{\'syncExternal.guidelines.guideline_4\'}}</li></ul><br><br><div class="form-horizontal bottom"><div class="form-group"><label class="control-label col-sm-2" for="id"><b translate="">{{\'syncExternal.inputIds\'}}</b></label><div class="col-sm-8"><input type="text" ng-model="vm.ids" class="form-control" id="id" placeholder="{{\'syncExternal.placeholderText \' | translate}}"></div><div class="col-sm-2 text-left"><button class="btn btn-md-with-icon btn-primary" ng-click="vm.syncEmployees()"><i class="ion-android-sync"></i> <span class="ml-negative-5 pb-2" translate="">{{\'syncExternal.syncButton\'}}</span></button></div></div></div><br><br><div><table class="table table-bordered mt-10 width-98" ng-if="vm.responseMap != null"><thead><tr><td class="text-center" translate="">{{\'syncExternal.tableHeader.id\'}}</td><td class="text-center" translate="">{{\'syncExternal.tableHeader.name\'}}</td><td class="text-center" translate="">{{\'syncExternal.tableHeader.status\'}}</td></tr></thead><tbody><tr ng-repeat="(key,value) in vm.responseMap"><td><a ui-sref="profile({employeeId : {{value.employeeId}}})">{{key}}</a></td><td>{{value.name}}</td><td>{{value.syncStatus}}</td></tr></tbody></table></div><div class="row mb-20"><div class="col-md-2"><button class="btn btn-md-with-icon btn-primary" ng-click="vm.syncAll()"><i class="ion-android-sync"></i> <span class="ml-negative-5 pb-2" translate="">{{\'syncExternal.syncAllButton\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/employees/manage/actions/employeeActions.html','<style>\n    .table > tbody > tr > td:last-child {\n        padding-right: 0px !important;\n    }\n\n    .carry-lv-sv-btn {\n        display: flex;\n        justify-content: end;\n        align-items: end;\n        height: 62px;\n    }\n    .employee-select-box .multiSelect > button {\n        z-index: 1;\n        max-height: 200px;\n        overflow: scroll;\n        padding: 0 14px;\n        background: white;\n        white-space: normal!important;\n    }\n    .employee-select-box .multiSelect .caret {\n        margin: 8px -4px 1px 12px !important;\n        position: initial;\n    }\n    .employee-list {\n        max-height: 300px !important;\n        margin-bottom: 20px;\n    }\n</style><div><div ba-panel="" ba-panel-title="{{ \'employeeActions.employeeList\' | translate }}" ng-animate="\'slide\'" class="mb-20"><div class="row m-all-0"><h4 class="text-uppercase mt-10"><strong translate="">{{\'employeeActions.employeeSelectionLabel\' }}</strong></h4><div class="row bottom" ng-if="vm.select.notSelectedEmployees && !vm.allSelected"><div class="col-md-6"><div class="d-flex-gap-10 employee-select-box"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.notSelectedEmployees" output-model="vm.select.multiselectEmployees" button-label="name" item-label="name" tick-property="ticked" on-item-click="vm.logSelectedEmployees()" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo all\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }" output-properties="id name"></div><button type="button" class="btn btn-md-with-icon btn-secondary" ng-click="vm.populateTableFromMultiSelect()"><i class="ion-checkmark-round"></i> <span class="pb-2" translate="">{{\'employeeActions.employeeSelectButton\'}}</span></button></div></div><br><br></div><div ng-if="!vm.allSelected" class="row col-md-12 m-all-0 p-all-0 horizontal-scroll scrollable-table employee-list" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip text-center mb-20" ng-if="(vm.select.selectedEmployees.length > 0 && !vm.loadingTableData)"><thead><tr><th class="text-left" translate="">{{ \'employeeActions.employeeTableHeader.name\' }}</th><th ng-if="vm.isCompanyAdmin" translate="">{{ \'employeeActions.employeeTableHeader.company\' }}</th><th ng-if="vm.isCompanyAdmin" translate="">{{ \'employeeActions.employeeTableHeader.office\' }}</th><th class="text-left" translate="">{{ \'employeeActions.employeeTableHeader.shiftGroup\' }}</th><th class="text-center width-13" translate="">{{ \'employeeActions.employeeTableHeader.action\' }}</th></tr></thead><tbody><tr class="border-bottom-1" ng-repeat="item in vm.select.selectedEmployees"><td class="text-left"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="item.departmentName" designation-name="!item.designationName ? \'N/A\':item.designationName" id="item.id" is-clickable="true"></employee-picture-and-information></td><td ng-if="vm.isCompanyAdmin">{{item.companyName}}</td><td ng-if="vm.isCompanyAdmin">{{item.officeName}}</td><td class="text-left">{{item.shiftGroupName}}</td><td class="d-flex-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.removeEmployeeFromTable(item)"><i class="ion-android-remove-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'employeeActions.removeButton\'}}</span></button></td></tr></tbody></table><h4 ng-if="(!vm.select.selectedEmployees || vm.select.selectedEmployees.length == 0)" translate="">{{\'employeeActions.noEmployeeSelected\'}}</h4><div class="text-center" ng-if="vm.loadingTableData"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div ng-if="vm.allSelected" class="text-center"><h6 translate="">{{\'employeeActions.onAllEmployeesSelected\'}}</h6><hr></div><div class="row bottom text-center" ng-if="!vm.isApproversListInitialized"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="row bottom" ng-if="vm.isApproversListInitialized"><div class="col-md-6"><h4 class="text-uppercase mt-10"><strong translate="">{{\'employeeActions.selectAction\' }}</strong></h4><div isteven-multi-select="" input-model="vm.uiComponents" output-model="vm.selectedUiComponents" output-properties="value" button-label="name" item-label="name" tick-property="ticked" disable-property="disabled" on-item-click="vm.refreshUiComponents()" on-close="vm.refreshUiComponents()"></div></div></div><div class="bg-gray-100 p-all-20 border-radius-5" ng-show="vm.selectedUiComponents.length"><div class="row bottom" ng-if="vm.uiComponentsToShow.includes(\'assignDepartment\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.department\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedDepartment" ng-options="d.name for d in vm.department.departmentList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectADepartment\'}}</option></select></div><button class="btn btn-md btn-primary text-center" ng-click="vm.assignBatchDepartment()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignSubDepartment\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.subDepartment\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedSubDepartment" ng-options="d.name for d in vm.subDepartment.subDepartmentList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectASubDepartment\'}}</option></select></div><button class="btn btn-md btn-primary text-center" ng-click="vm.assignBatchSubDepartment()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.isSubsidiarySuperAdmin && vm.uiComponentsToShow.includes(\'assignSubsidiary\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.subsidiary\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedSubsidiary" ng-options="s.name for s in vm.subsidiary.subsidiaryList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectASubsidiary\'}}</option></select></div><button class="btn btn-md btn-primary text-center" ng-click="vm.assignBatchSubsidiary()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'allocateToAccessArea\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'profileAccessAreaPermission.allocateUserToAccessArea\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0 open-on-top" isteven-multi-select="" input-model="vm.accessAreaListToAllocate" output-model="vm.selectedAccessAreaListToAllocate" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button id="allocateEmployeeToAccessArea" class="btn btn-md btn-primary" ng-click="vm.allocateEmployeeToAccessArea()" translate="">{{\'profile.allocateButton\'}}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'revokeFromAccessArea\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'profileAccessAreaPermission.revokeUserFromAccessArea\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0 open-on-top" isteven-multi-select="" input-model="vm.accessAreaListToRevoke" output-model="vm.selectedAccessAreaListToRevoke" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button id="revokeFromAccessAreaButton" class="btn btn-md btn-danger" ng-click="vm.revokeEmployeeFromAccessArea()" translate="">{{\'profile.revokeButton\'}}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignShiftGroup\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.shiftGroup\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedShiftGroup" ng-options="s.name for s in vm.shift.shiftGroupList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectAShiftGroup\'}}</option></select></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchShiftGroup()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignDesignation\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.designation\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedDesignation" ng-options="d.name for d in vm.designation.designationList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectADesignation\'}}</option></select></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchDesignation()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignLeavePolicy\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.leavePolicy\' }}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedLeavePolicy" ng-options="l.name for l in vm.leavePolicy.leavePolicyList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectALeavePolicy\'}}</option></select></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchLeavePolicy()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignToSite\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.assignToSite\' }}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select"><select ng-model="vm.select.selectedSite" ng-options="s.name for s in vm.site.siteList"><option value="" selected="" disabled="" hidden="" translate="">{{\'employeeActions.selectASite\'}}</option></select></div><button class="btn btn-md btn-primary" ng-click="vm.assignToSite()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignLeaveFirstApprover\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.leaveFirstApprover\'}}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.firstLeaveApprovers" output-model="vm.selectedFirstApprover" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchFirstLeaveApprover()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignLeaveSecondApprover\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.leaveSecondApprover\'}}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.secondLeaveApprovers" output-model="vm.selectedSecondApprover" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchSecondLeaveApprover()" translate="">{{ \'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignLateFirstApprover\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.lateFirstApprover\'}}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.firstLateApprovers" output-model="vm.selectedFirstLateApprover" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchFirstLateApprover()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignLateSecondApprover\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.lateSecondApprover\'}}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.secondLateApprovers" output-model="vm.selectedSecondLateApprover" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchSecondLateApprover()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignManualEntryFirstApprover\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'approverInformation.firstManualEntryApprover\'}}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.firstManualEntryApprovers" output-model="vm.selectedFirstManualEntryApprover" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchFirstManualEntryApprover()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignManualEntrySecondApprover\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{\'approverInformation.secondManualEntryApprover\'}}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.secondManualEntryApprovers" output-model="vm.selectedSecondManualEntryApprover" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchSecondManualEntryApprover()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.canAssignLineManager && vm.uiComponentsToShow.includes(\'assignLineManager\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.lineManager\' }}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.lineManagerInput" output-model="vm.select.lineManager" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchLineManager()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'assignHrManager\')"><h4 class="col-md-12 text-uppercase text-bold" translate="">{{ \'employeeActions.assignmentSectionTitle.hrManager\' }}</h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.select.hrManagerInput" output-model="vm.select.hrManager" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.assignBatchHrManager()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'includeInAttendanceReport\')"><h4 class="col-md-12 text-uppercase text-bold"><strong translate="">{{\'employeeActions.assignmentSectionTitle.includeInAttendanceReport\' }}</strong></h4><div class="col-md-5"><button class="btn btn-md btn-primary" ng-click="vm.assignBatchIncludeInAttendanceReport(true)" translate="">{{\'employeeActions.assignmentSectionTitle.includeInAttendanceReportBtn\' }}</button></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'excludeInAttendanceReport\')"><h4 class="col-md-12 text-uppercase text-bold"><strong translate="">{{\'employeeActions.assignmentSectionTitle.excludeInAttendanceReport\' }}</strong></h4><div class="col-md-5"><button class="btn btn-md btn-primary" ng-click="vm.assignBatchIncludeInAttendanceReport(false)" translate="">{{\'employeeActions.assignmentSectionTitle.excludeInAttendanceReportBtn\' }}</button></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'allocateToDevice\')"><h4 class="col-md-12 text-uppercase text-bold"><strong translate="">{{\'employeeActions.assignmentSectionTitle.allocateToDevice\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.devicesForBatchAllocation" output-model="vm.selectedDevicesForAllocation" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier"></div><button class="btn btn-md btn-primary" ng-click="vm.allocateToDevice(\'allocate\')" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'revokeFromDevice\')"><h4 class="col-md-12 text-uppercase text-bold"><strong translate="">{{\'employeeActions.assignmentSectionTitle.revokeFromDevice\' }}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.devicesForBatchRevoke" output-model="vm.selectedDevicesForRevoke" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier"></div><button class="btn btn-md btn-primary" ng-click="vm.allocateToDevice(\'revoke\')" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row mt-20" ng-if="vm.uiComponentsToShow.includes(\'temporaryPermissions\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{\'employeeActions.assignmentSectionTitle.temporaryPermissions\'}}</strong></h4><div class="col-md-3"><h4 translate="">{{ \'employeeActions.fromDateLabel\' }}</h4><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.datePicker.fromTime" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.datePicker.fromTime.format(\'DD-MMM-YYYY hh:mm\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="col-md-3"><h4 translate="">{{ \'employeeActions.toDateLabel\' }}</h4><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.datePicker.toTime" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.datePicker.toTime.format(\'DD-MMM-YYYY hh:mm\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div></div><div class="row bottom mt-10" ng-if="vm.uiComponentsToShow.includes(\'temporaryPermissions\')"><div class="col-md-6"><h4 translate="">{{ \'employeeActions.deviceLabel\' }}</h4><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.devices" output-model="vm.temporarySelectedDevice" button-label="identifier" item-label="identifier" tick-property="ticked" output-properties="id identifier" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.saveTemporaryAllocation()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'transferEmployees\') && vm.isCompanyAdmin"><h4 class="col-md-12 text-uppercase"><strong translate="">{{\'employeeActions.assignmentSectionTitle.employeeTransfer\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.selectedOffice" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.transferEmployees()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'updateWorkplace\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.updateWorkplace\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.workplaceList" output-model="vm.selectedWorkplace" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.updateBatchWorkplace()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'updateEmploymentType\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{\'employeeActions.assignmentSectionTitle.updateEmploymentType\'}}</strong></h4><div class="col-md-6"><div class="d-flex-gap-10"><div class="custom-select border-0" isteven-multi-select="" input-model="vm.employmentTypeList" output-model="vm.selectedEmploymentTypeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div><button class="btn btn-md btn-primary" ng-click="vm.updateBatchEmploymentType()" translate="">{{\'employeeActions.saveButton\' }}</button></div></div></div><div class="row bottom mt-20" ng-if="vm.uiComponentsToShow.includes(\'deleteEmployees\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.deleteEmployee\'}}</strong></h4><div class="col-md-6"><button class="btn btn-md btn-danger" ng-click="vm.openDeleteModal()" translate="">{{\'employeeActions.deleteButton\' }}</button></div></div><div class="row mt-20" ng-if="vm.uiComponentsToShow.includes(\'allowOvertime\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.overtime\'}}</strong></h4><div class="col-md-6 d-flex-gap-20"><button class="btn btn-md btn-primary" ng-click="vm.allowOrDisallowOverTime(\'true\')" translate="">{{\'employeeActions.allowButton\' }}</button> <button class="btn btn-md btn-danger" ng-click="vm.allowOrDisallowOverTime(\'false\')" translate="">{{\'employeeActions.disallowButton\' }}</button></div></div><div class="row mt-20" ng-if="vm.uiComponentsToShow.includes(\'carryLeaves\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{ \'employeeActions.assignmentSectionTitle.leaveCarry\'}}</strong></h4><div class="row bottom m-all-0"><div class="col-md-3"><h4 translate="">{{ \'employeeActions.fromDateLabel\' }}</h4><div isteven-multi-select="" input-model="vm.select.leaveCategoryFrom" output-model="vm.select.selectedLeaveCategoryFrom" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="col-md-3"><h4 translate="">{{ \'employeeActions.yearLabel\' }}</h4><input type="number" ng-model="vm.fromYear" class="form-control"></div></div><div class="row bottom m-all-0"><div class="col-md-3"><h4 translate="">{{ \'employeeActions.toDateLabel\' }}</h4><div isteven-multi-select="" input-model="vm.select.leaveCategoryTo" output-model="vm.select.selectedLeaveCategoryTo" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="col-md-3"><h4 translate="">{{ \'employeeActions.yearLabel\' }}</h4><input type="number" ng-model="vm.toYear" class="form-control"></div></div><div class="row bottom m-all-0"><div class="col-md-3"><h4 translate="">{{ \'employeeActions.maxNumberLabel\' }}</h4><input type="number" class="form-control" ng-model="vm.maxLeaves"></div><div class="col-md-3 text-right carry-lv-sv-btn"><button class="btn btn-md btn-primary" ng-click="vm.batchLeaveCarryOn()" translate="">{{\'employeeActions.submitButton\' }}</button></div></div></div><div class="row mt-20" ng-if="vm.uiComponentsToShow.includes(\'syncExternal\')"><h4 class="col-md-12 text-uppercase"><strong translate="">{{\'employeeActions.thirdPartySyncLabel\'}}</strong></h4><div class="col-md-6"><button class="btn btn-md btn-primary" ng-click="vm.syncThirdParty()" translate="">{{\'employeeActions.syncButton\'}}</button></div><br><br><div><table class="table table-bordered mt-10 width-98" ng-if="vm.responseMap != null"><thead><tr><td class="text-center" translate="">{{\'employeeActions.thirdPartySyncTableHeader.id\'}}</td><td class="text-center" translate="">{{\'employeeActions.thirdPartySyncTableHeader.name\'}}</td><td class="text-center" translate="">{{\'employeeActions.thirdPartySyncTableHeader.status\'}}</td></tr></thead><tbody><tr ng-repeat="(key,value) in vm.responseMap"><td><a ui-sref="profile({employeeId : {{value.employeeId}}})">{{key}}</a></td><td>{{value.name}}</td><td>{{value.syncStatus}}</td></tr></tbody></table></div></div><div class="mt-20" ng-if="vm.uiComponentsToShow.includes(\'notificationSettings\')"><div class="row"><h4 class="col-md-12 text-uppercase"><strong translate="">{{\'employeeActions.assignmentSectionTitle.notificationSettings\'}}</strong></h4></div><div class="row"><div class="col-md-6"><div class="d-flex-gap-20"><div class="custom-select border-0 open-on-top" isteven-multi-select="" input-model="vm.select.notificationGroup" output-model="vm.select.selectedNotificationGroup" button-label="name" item-label="name" tick-property="ticked" output-properties="value" selection-mode="single" disable-property="disabled" translation="{ \'reset\' : \'Reset\', \'search\' : \'Search...\', \'nothingSelected\' : \'Select Notification Group\' }"></div><div class="row min-width-100 text-right"><div class="col-xs-1 mt-10"><strong>{{ vm.notificationsOn ? \'On\' : \'Off\' }}</strong></div><div class="col-xs-8 mt-3"><label class="custom-switch mt-10"><input name="enabled" ng-model="vm.notificationsOn" type="checkbox"><span class="slider round"></span></label></div></div></div></div></div><div id="notificationRecipientsDiv" class="clearfix mt-20" ng-if="vm.notificationsOn"><h5 class="text-uppercase" translate="">{{ \'employeeActions.notification.selectRecipients\' }}</h5><div class="clearfix"><div class="col-md-3 mt-10"><span translate="">{{ \'employeeActions.notification.recipientSelf\'}}</span></div><div class="col-md-3"><div class="row m-all-0"><div class="col-md-4 mt-10" ng-repeat="checkbox in vm.selfCheckBoxes"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value"> <span>{{ checkbox.labelText | translate }}</span></label></div></div></div></div><div class="clearfix"><div class="col-md-3 mt-10"><span translate="">{{ \'employeeActions.notification.recipientLineManager\'}}</span></div><div class="col-md-3"><div class="row m-all-0"><div class="col-md-4 mt-10" ng-repeat="checkbox in vm.lineManagerCheckBoxes"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value"> <span>{{ checkbox.labelText | translate }}</span></label></div></div></div></div><div class="clearfix"><div class="col-md-3 mt-10"><span translate="">{{ \'employeeActions.notification.recipientHRManager\'}}</span></div><div class="col-md-3"><div class="row m-all-0"><div class="col-md-4 mt-10" ng-repeat="checkbox in vm.hrCheckBoxes"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value"> <span>{{ checkbox.labelText | translate }}</span></label></div></div></div></div></div><div class="row mt-20"><div class="col-md-6"><div ng-if="vm.doesThisNotificationGroupNeedConfiguration() && vm.notificationsOn"><h5 class="text-uppercase" translate="">{{ \'employeeActions.notification.moreSettings\' }}</h5><div id="notificationMoreSettingsDiv" class="clearfix pl-15 mt-20"><div class="clearfix" ng-if="vm.select.selectedNotificationGroup[0].value==100"><p class="input-group"><label for="minBeforeStart" translate="">{{ \'employeeActions.notification.officeTimeNotifyBeforeStartTime\' }}</label> <input id="minBeforeStart" ng-model="vm.officeTimeNotifyBeforeStartTime" type="number" class="form-control"></p></div><div class="clearfix" ng-if="vm.select.selectedNotificationGroup[0].value==400"><span translate="">{{ \'employeeActions.notification.whenToCheckAbsent\' }}</span><div class="custom-select mt-5"><select ng-model="vm.whenToCheckAbsent" ng-options="option.name for option in vm.whenToCheckAbsentDropdown"></select></div></div><div class="clearfix" ng-if="vm.select.selectedNotificationGroup[0].value==900"><span translate="">{{ \'employeeActions.notification.whenToCheckEarlyExit\' }}</span><div class="custom-select mt-5"><select ng-model="vm.whenToCheckEarlyExit" ng-options="option.name for option in vm.whenToCheckEarlyExitDropdown"></select></div></div></div></div><div class="row mt-10"><div class="text-right mr-20"><button class="btn btn-md btn-primary" ng-click="vm.saveNotificationSettings()" translate="">{{\'employeeActions.saveButton\'}}</button></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/employees/manage/create/createEmployee.html','<style>\n    .calender-icon-position{\n        position: absolute;\n        top:8px;\n        right: 30px;\n        font-size: 17px;\n    }\n    .validation .form-control:focus{\n        border: 1px solid #292929;\n    }\n    .validation .calender-position {\n        position: absolute;\n        top: 40px;\n        right: 30px;\n        font-size: 17px;\n    }\n    .calender-position-end-date{\n        position: absolute;\n        top:32px;\n        right: 30px;\n        font-size: 17px;\n    }\n</style><div><div ba-panel="" ba-panel-title="{{\'createEmployee.title\' | translate}}" ba-panel-class="with-scroll"><form name="vm.create.createEmployeeForm" novalidate="" autocomplete="false"><div class="validation"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.create.createEmployeeForm.name.$invalid && (vm.create.createEmployeeForm.name.$dirty || vm.create.createEmployeeForm.$submitted), \'has-success\': vm.create.createEmployeeForm.name.$valid}"><label class="required" for="name" translate="">{{ \'createEmployee.inputForm.name\' }}</label> <input type="text" class="form-control" ng-model="vm.create.name" placeholder="Name" id="name" name="name" required=""> <span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.name\' }}</span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-success\':vm.create.createEmployeeForm.employeeOfficeId.$dirty, \'has-error\': (vm.create.createEmployeeForm.employeeOfficeId.$invalid) && (vm.create.createEmployeeForm.employeeOfficeId.$dirty || vm.create.createEmployeeForm.$submitted)}"><label class="required" for="employeeOfficeId" translate="">{{ \'createEmployee.inputForm.employeeId\' }}</label> <input type="text" class="form-control" ng-model="vm.create.employeeOfficeId" placeholder="ID" id="employeeOfficeId" name="employeeOfficeId" required="" unique-employee-id=""> <span ng-show="vm.create.createEmployeeForm.employeeOfficeId.$error.required && vm.create.createEmployeeForm.employeeOfficeId.$touched" class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.emptyEmployeeId\' }}</span> <span class="help-block error-block basic-block" ng-show="vm.create.createEmployeeForm.employeeOfficeId.$error.uniqueEmployeeId" translate="">{{ \'createEmployee.errorMsg.usedEmployeeId\' }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': (vm.create.createEmployeeForm.email.$invalid && (vm.create.createEmployeeForm.email.$dirty || vm.create.createEmployeeForm.$submitted)), \'has-success\': vm.create.createEmployeeForm.email.$valid}"><label class="required" translate="">{{ \'createEmployee.inputForm.email\' }}</label> <input type="email" class="form-control" id="email" name="email" ng-model="vm.create.email" placeholder="Email" required="" ng-pattern="vm.create.emailPattern"> <span class="help-block error-block basic-block" translate="">{{(vm.create.createEmployeeForm.email.$error.email || vm.create.createEmployeeForm.email.$error.pattern) ? \'createEmployee.errorMsg.invalidEmail\' : \'createEmployee.errorMsg.emptyEmail\'}}</span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\':(vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'all\')) ||(vm.create.createEmployeeForm.password.$invalid && (vm.create.createEmployeeForm.password.$dirty || vm.create.createEmployeeForm.$submitted)), \'has-success\': vm.create.createEmployeeForm.password.$valid}"><label for="password" class="required" translate="">{{ \'createEmployee.inputForm.password\' }}</label> <input type="password" class="form-control" name="password" ng-model="vm.create.password" id="password" placeholder="Password" required="" readonly="" onfocus="this.removeAttribute(\'readonly\');"> <span ng-if="vm.create.password !== null"><span class="text-secondary">Password Strength:</span> <span class="{{ vm.passStrengthClass }}" translate="">{{ vm.passStrengthText }}</span></span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$invalid" translate="">{{ \'createEmployee.errorMsg.password\' }}</span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'capital\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.invalidCapital\'}}</span> {{vm.passSchemaInfo.capital}}</span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'numeric\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidNumber\'}}</span> {{vm.passSchemaInfo.numeric}}</span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'symbol\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.invalidSymbol\'}}</span></span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'length\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidLength\'}}</span> {{vm.passSchemaInfo.length}}</span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'small\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidSmall\'}}</span> {{vm.passSchemaInfo.small}}</span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'consecutiveChar\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.consecutiveChar\' }}</span> {{vm.passSchemaInfo.consecutiveChar}}</span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'commonPassword\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.commonPassword\' }}</span></span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'user\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.similarWithUserInfo\' }}</span></span> <span class="help-block error-block basic-block" ng-if="vm.create.createEmployeeForm.password.$touched && vm.checkPasswordValidation(\'invalidSymbol\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.invalidIllegalSymbol\'}}</span></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-success\': vm.create.gender !== null,\'has-error\': vm.create.gender == null}"><label class="required" translate="">{{ \'createEmployee.inputForm.gender\' }}</label><div class="custom-select"><select name="gender" ng-model="vm.create.gender" ng-options="item.id as item.name for item in vm.create.genderList" required=""><option value="" translate="">{{\'createEmployee.selectGender\'}}</option></select></div><span ng-if="vm.create.gender == null" class="help-block error-block basic-block" translate="">{{\'createEmployee.errorMsg.gender\'}}</span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.create.createEmployeeForm.confirmPassword.$invalid && (vm.create.createEmployeeForm.confirmPassword.$dirty || vm.create.createEmployeeForm.$submitted), \'has-success\': vm.create.createEmployeeForm.confirmPassword.$valid}"><label class="required" translate="">{{ \'createEmployee.inputForm.confirmPassword\' }}</label> <input type="password" class="form-control" name="confirmPassword" ng-model="vm.create.confirmPassword" placeholder="Type the password again" id="confirmPassword" required="" readonly="" onfocus="this.removeAttribute(\'readonly\');"> <span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.confirmPassword\' }}</span></div></div><div class="col-md-6" ng-if="vm.isSubsidiaryActivatedAndNotSubsidiaryAdmin"><div class="form-group" ng-class="{\'has-error\': vm.create.createEmployeeForm.subsidiary.$invalid && (vm.create.createEmployeeForm.subsidiary.$dirty || vm.create.createEmployeeForm.$submitted)}"><label class="required" translate="">{{\'employeeActions.assignmentSectionTitle.subsidiary\'}}</label><div class="custom-select"><select name="subsidiary" ng-model="vm.create.subsidiary" ng-options="item.id as item.name for item in vm.create.subsidiaryList" required=""><option value="" translate="">{{\'employeeActions.selectASubsidiary\'}}</option></select></div></div></div></div><div class="row"><div class="col-md-4 mt-10-mb-10"><button type="button" class="btn btn-md-with-icon btn-secondary position-relative" ng-click="vm.toggleAdvanceOption()"><span class="pb-2">{{\'commonKeywords.advanceOptionsButton\' | translate}}</span> <i ng-if="!vm.showAdvanceOption" class="ion-chevron-down ml-5"></i> <i ng-if="!!vm.showAdvanceOption" class="ion-chevron-up ml-5"></i></button></div></div><div ng-show="!!vm.showAdvanceOption"><div class="row"><div class="col-md-6"><label class="mt-10" translate="">{{ \'createEmployee.inputForm.startDate\' }}</label> <input type="text" class="form-control position-relative" name="startDate" datetime-picker="dd MMM yyyy" enable-time="false" ng-model="vm.create.dateOfJoin" is-open="vm.isOpen"> <i ng-click="vm.isOpen=true" class="fa fa-calendar calender-position"></i></div><div class="col-md-6"><div class="form-group"><label class="mt-10" translate="">{{ \'createEmployee.inputForm.workplace\' }}</label><div class="custom-select"><select ng-model="vm.create.workplace" ng-options="item.id as item.name for item in vm.create.workplaceList"><option value="" translate="">{{\'createEmployee.selectWorkplace\'}}</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="" translate="">{{ \'createEmployee.inputForm.designation\' }}</label><div class="custom-select"><select ng-model="vm.create.designation" ng-options="item.id as item.name for item in vm.create.designationList" id="designationSelect"><option value="" translate="">{{\'createEmployee.selectDesignation\'}}</option></select></div></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="" translate="">{{ \'createEmployee.inputForm.reportPosition\' }}</label> <input type="text" class="form-control" ng-model="vm.create.reportPosition" placeholder="Report Position"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="" translate="">{{ \'createEmployee.inputForm.department\' }}</label><div class="custom-select"><select ng-model="vm.create.department" ng-options="item.id as item.name for item in vm.create.departmentList"><option value="" translate="">{{\'createEmployee.selectDepartment\'}}</option></select></div><span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.department\' }}</span></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="" translate="">{{ \'createEmployee.inputForm.rfid\' }}</label> <input type="text" class="form-control" name="rfid" ng-model="vm.create.rfid" placeholder="RFID"></div></div></div><div class="row"><div class="col-md-6"><label class="" translate="">{{ \'createEmployee.inputForm.subDepartment\' }}</label><div class="custom-select"><select ng-model="vm.create.subDepartment" ng-options="item.id as item.name for item in vm.create.subDepartmentList" id="subDepartmentSelect"><option value="" translate="">{{\'createEmployee.selectSubDepartment\'}}</option></select></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="" translate="">{{ \'createEmployee.inputForm.primaryDisplayText\' }}</label> <span class="color-22222 font-12" translate="">{{ \'createEmployee.inputForm.maxTenChar\' }}</span> <input type="text" class="form-control" maxlength="10" ng-model="vm.create.primaryDisplayText" placeholder="Primary Display Text"> <span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.primaryDisplayText\' }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="" translate="">{{ \'createEmployee.inputForm.leavePolicy\' }}</label><div class="custom-select"><select id="leavePolicy" ng-model="vm.create.leavePolicy" ng-options="item.id as item.name for item in vm.create.leavePolicyList"><option value="" translate="">{{\'createEmployee.selectLeavePolicy\'}}</option></select></div></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="" translate="">{{ \'createEmployee.inputForm.secondaryDisplayText\' }}</label> <span class="color-22222 font-12" translate="">{{ \'createEmployee.inputForm.maxTenChar\' }}</span> <input type="text" class="form-control" maxlength="10" ng-model="vm.create.secondaryDisplayText" placeholder="Secondary Display Text"> <span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.secondaryDisplayText\' }}</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="" translate="">{{ \'createEmployee.inputForm.employmentType\' }}</label><div class="custom-select"><select ng-model="vm.create.employmentType" ng-options="item.id as item.name for item in vm.create.employmentTypeList"><option value="" translate="">{{\'createEmployee.selectEmploymentType\'}}</option></select></div><span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.employmentType\' }}</span></div></div><div class="col-md-6"><label class="" translate="">{{ \'createEmployee.inputForm.endDate\' }}</label> <label class="font-12">(Optional)</label> <input type="text" class="form-control" datetime-picker="dd MMM yyyy" enable-time="false" ng-model="vm.create.dateOfResignation" is-open="vm.isOpenRes"> <i ng-click="vm.isOpenRes=true" class="fa fa-calendar calender-position-end-date"></i></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="" translate="">{{ \'createEmployee.inputForm.shiftGroup\' }}</label><div class="custom-select"><select ng-model="vm.create.shiftGroup" ng-options="item.id as item.name for item in vm.create.shiftGroupList" required=""><option value="" translate="">{{\'createEmployee.selectShiftGroup\'}}</option></select></div><span class="help-block error-block basic-block" translate="">{{ \'createEmployee.errorMsg.shiftGroup\' }}</span></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="" translate="">PersonID 3rd party Device</label> <input type="text" class="form-control" name="personId3rdPartyDevice" ng-model="vm.create.personId3rdPartyDevice" placeholder="PersonID 3rd party Device"></div></div></div></div></div><div class="row pr-15 mb-20 mt-20 text-right"><button ng-disabled="vm.create.createEmployeeForm.$invalid || vm.checkPasswordValidation(\'all\')" type="submit" id="createEmployeeButton" class="btn btn-md-with-icon" ng-class="{\'btn-disable\' : vm.create.createEmployeeForm.$invalid || vm.checkPasswordValidation(\'all\'), \'btn-primary\' : !vm.create.createEmployeeForm.$invalid}" ng-click="vm.createEmployee()"><i class="ion-android-checkmark-circle"></i> <span ng-if="!vm.isEmployeeCreating" class="ml-negative-5 pb-2" translate="">{{\'createEmployee.createButton\'}}</span> <span ng-if="vm.isEmployeeCreating" class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.pleaseWait\'}}</span></button></div></form></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/create/createMember.html','<style>\n    .dark-bg{\n        background: #fcfcfc;\n    }\n    .height-30{\n        height: 30px;\n    }\n    .file-container{\n        min-width: 150px;\n        border-radius: 50px;\n        border: 1px solid #C8C8C8;\n        padding: 2px 5px 2px 15px;\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n    }\n    .input-style input{\n        background: #f5f5f5;\n        border: none!important;\n    }\n    .input-style input:focus{\n        background: transparent;\n    }\n    .input-style .form-control{\n        background: #f5f5f5;\n        border: none!important;\n        pointer-events: none!important;\n    }\n    .limit-text{\n        width: 100px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'membershipManagement.members.addNewMember\' | translate}}"><div id="create-site" class="" ng-if="vm.isDataLoaded"><div class="width-95 m-0-auto"><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.memberName"}}</label> <input type="text" placeholder="Enter Member Name" class="form-control" ng-model="vm.memberName"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.memberId"}}</label> <input type="text" placeholder="Enter a unique member id" class="form-control" ng-model="vm.memberId"></div></div><div class="row mt-15"><div class="col-md-6"><label class="" translate="">{{"membershipManagement.members.email"}}</label> <input type="email" placeholder="Enter member\'s email" class="form-control" ng-model="vm.memberEmail"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.mobile"}}</label> <input type="text" placeholder="Enter mobile number" class="form-control" ng-model="vm.memberMobileNumber"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.gender"}}</label><div class="custom-select"><select name="selectedGender" ng-model="vm.selectedGender" ng-options="v.id as v.name for v in vm.genderList" required=""><option value="" translate="">pleaseSelect</option></select></div></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.dateOfBirth"}}</label><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.datePicker.format}}" datepicker-options="vm.datePicker.options" ng-model="vm.dateOfBirth" is-open="vm.datePicker.opened" ng-required="false" show-button-bar="false" placeholder="{{vm.datePicker.format}}"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openDatePicker()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row mt-5"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.joiningDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.joiningDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.joiningDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.nid"}}</label> <input type="text" placeholder="Enter NID" class="form-control" ng-model="vm.memberNidNumber"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{"membershipManagement.members.presentAddress"}}</label> <input type="text" placeholder="Enter member\'s address" class="form-control" ng-model="vm.presentAddress"></div></div><div class="row mt-15"><div class="col-md-12 color-prime"><span class="color-prime font-weight-500" translate="">{{"membershipManagement.members.uploadDocument"}}</span></div></div><div class="row mt-15"><div class="col-md-12"><div class="d-flex-gap-10"><div ng-repeat="file in vm.uploadedFiles"><div class="file-container"><div class="d-flex-align-center"><span class="font-12 color-22222 limit-text">{{file.name}}</span></div><div class="cross-img"><img ng-click="vm.removeFile($index)" src="../assets/img/cross.png"></div></div></div></div></div></div><div class="row mt-10"><div class="col-md-12"><button class="btn btn-md-with-icon btn-secondary padding-5-12 font-13" ng-model="vm.file" ngf-select="vm.uploadFiles($file)" ngf-multiple="false" ngf-accept="\'.pdf,.png,.jpeg\'"><img src="../assets/img/Upload.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.uploadDocumentButton\'}}</span></button></div></div><div class="row mt-15"><div class="col-md-12 color-prime"><span class="color-prime font-weight-500" translate="">{{"membershipManagement.members.subscriptionInformation"}}</span></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.selectPackage"}}</label><div class="custom-select"><select name="selectedPackage" ng-change="vm.getDataOfSelectedPackage()" ng-model="vm.selectedPackage" ng-options="v.id as v.name for v in vm.allPackageData" required=""><option value="" translate="">pleaseSelect</option></select></div></div><div class="col-md-6 input-style"><label translate="">{{"membershipManagement.members.duration"}}</label> <input type="text" class="form-control bg-f5f5f5 prevent-clicks" ng-model="vm.selectedPackageData.duration"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.packageAmount"}}</label> <input type="number" class="form-control" ng-model="vm.selectedPackageData.price"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.packageStartDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.packageStartDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.packageStartDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row mt-15"><div class="col-md-6 input-style"><label class="required" translate="">{{"membershipManagement.members.packageEndDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative prevent-clicks" ng-model="vm.packageEndDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.packageEndDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.rfidCard"}}</label> <input type="text" placeholder="Enter RFID Card Number" class="form-control" ng-model="vm.memberRfid"></div></div><div class="row mt-15"><div class="col-md-6"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.selectAccessDevice"}}</label><div class="col-md-12 open-on-top pl-0 pr-0"><div isteven-multi-select="" input-model="vm.deviceList" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id"></div></div></div></div><div class="row mt-15"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="membershipManagement.members" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createNewMember()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.addNewMemberButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/delete/deleteMember.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'membershipManagement.members.doYouWantToDeleteMember\' | translate}} <em>{{vm.memberName.name}}</em>{{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteMember()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/edit/editMember.html','<style>\n    .dark-bg{\n        background: #fcfcfc;\n    }\n    .file-container{\n        height: 80px;\n        width: 150px;\n        border-radius: 3px;\n        border: 1px solid #C8C8C8;\n        background: #fbfbfb;\n        box-sizing: border-box;\n    }\n    .file-container .cross-img{\n        display: flex;\n        justify-content: end;\n        cursor: pointer;\n    }\n    .input-style input{\n        background: #f5f5f5;\n        border: none!important;\n    }\n    .input-style input:focus{\n        background: transparent;\n    }\n    .input-style .form-control{\n        background: #f5f5f5;\n        border: none!important;\n        pointer-events: none!important;\n    }\n    .limit-text{\n        width: 100px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'membershipManagement.members.editNewMember\' | translate}}"><div id="create-site" ng-if="vm.isDataLoaded"><div class="width-95 m-0-auto"><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.memberName"}}</label> <input type="text" class="form-control" ng-model="vm.memberInfo.employeeName"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.memberId"}}</label> <input type="text" class="form-control" ng-model="vm.memberInfo.memberId"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.email"}}</label> <input type="email" class="form-control" ng-model="vm.memberInfo.email"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.mobile"}}</label> <input type="text" class="form-control" ng-model="vm.memberInfo.mobileNumber"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.gender"}}</label><div class="custom-select"><select name="selectedGender" ng-model="vm.memberInfo.genderId" ng-options="v.id as v.name for v in vm.genderList" required=""><option value="" translate="">pleaseSelect</option></select></div></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.dateOfBirth"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.memberInfo.dateOfBirthInMillis" options="vm.datePickerOptions"><span class="date-position-left">{{vm.memberInfo.dateOfBirthInMillis.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.joiningDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.memberInfo.joiningDateInMillis" options="vm.datePickerOptions"><span class="date-position-left">{{vm.memberInfo.joiningDateInMillis.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.nid"}}</label> <input type="text" class="form-control" ng-model="vm.memberInfo.nid"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{"membershipManagement.members.presentAddress"}}</label> <input type="text" class="form-control" ng-model="vm.memberInfo.address"></div></div><div class="row mt-15"><div class="col-md-12 color-prime"><span class="color-prime font-weight-500" translate="">{{"membershipManagement.members.uploadDocument"}}</span></div></div><div class="row mt-15"><div class="col-md-12"><div class="d-flex-gap-10"><div ng-repeat="file in vm.memberInfo.documentUrls"><div class="file-container mt-15 mb-15"><div class="cross-img"><img ng-click="vm.removeFile(file.fileId,$index,file.fileName)" src="../assets/img/cross.png"></div><div class="d-flex-center mt-negative-5" ng-click="vm.openDocumentModal(file)"><img src="../assets/img/file.png"></div><div class="d-flex-center"><span class="font-12 mt-2 color-22222 limit-text">{{file.fileName}}</span></div></div></div><div class="d-flex-align-center"><button class="btn btn-md-with-icon btn-secondary padding-5-12 font-13" ng-model="vm.file" ngf-select="vm.uploadFiles($file)" ngf-multiple="false" ngf-accept="\'.pdf,.png,.jpeg\'"><img src="../assets/img/Upload.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.uploadDocumentButton\'}}</span></button></div></div></div></div><div class="row mt-15"><div class="col-md-12 color-prime"><span class="color-prime font-weight-500" translate="">{{"membershipManagement.members.subscriptionInformation"}}</span></div></div><div class="row mt-15"><div class="col-md-6 input-style"><label class="required" translate="">{{"membershipManagement.members.selectPackage"}}</label> <input type="text" class="form-control bg-f5f5f5" ng-model="vm.memberInfo.packageName"></div><div class="col-md-6 input-style"><label translate="">{{"membershipManagement.members.duration"}}</label> <input type="text" class="form-control bg-f5f5f5" ng-model="vm.memberInfo.packageDuration"></div></div><div class="row mt-15"><div class="col-md-6 input-style"><label class="required" translate="">{{"membershipManagement.members.packageAmount"}}</label> <input type="number" class="form-control bg-f5f5f5" ng-model="vm.memberInfo.packageAmount"></div><div class="col-md-6 input-style"><label class="required" translate="">{{"membershipManagement.members.packageStartDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative prevent-clicks" ng-model="vm.memberInfo.packageStartDateInMillis" options="vm.datePickerOptions"><span class="date-position-left">{{vm.memberInfo.packageStartDateInMillis.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row mt-15"><div class="col-md-6 input-style"><label class="required" translate="">{{"membershipManagement.members.packageEndDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative prevent-clicks" ng-model="vm.memberInfo.packageEndDateInMillis" options="vm.datePickerOptions"><span class="date-position-left">{{vm.memberInfo.packageEndDateInMillis.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.rfidCard"}}</label> <input type="text" class="form-control" ng-model="vm.memberInfo.rfid"></div></div><div class="row mt-15"><div class="col-md-6"></div><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.selectAccessDevice"}}</label><div class="col-md-12 open-on-top pl-0 pr-0"><div isteven-multi-select="" input-model="vm.deviceList" output-model="vm.memberInfo.deviceIds" button-label="label" item-label="label" tick-property="ticked" output-properties="id"></div></div></div></div><div class="row mt-20"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="membershipManagement.members" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateMemberInfo()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.saveButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/partials/dummyTable.html','<div class="row mt-5"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information><button ng-if="vm.selectedRow.salary" class="btn btn-primary edit-btn-position" ng-disabled="!vm.isEmployeePayrollComponentsLoaded" ng-click="vm.openEditMode()"><i class="ion-ios-compose-outline font-19 mr-3"></i> <span translate="">{{\'payrollManagement.editInformation\'}}</span></button></td></tr><tr class="text-left"><td translate="">{{\'membershipManagement.members.contactNumber\'}}</td><td>{{vm.selectedRow.shiftGroupName ? vm.selectedRow.shiftGroupName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'email\'}}</td><td>{{vm.selectedRow.employmentTypeName ? vm.selectedRow.employmentTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h5><strong translate="">{{\'commonKeywords.memberInformationHeading\'}}</strong></h5></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh bg-f8f8f8 font-14"><th class="text-left dont-wrap-text" translate="">{{\'payrollSettings.componentName\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.dummyAmount\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.value\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollSettings.percentageOf\'}}</th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'payrollManagement.basicSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.houseRentAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.conveyanceAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.medicalAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left font-weight-bold"><strong translate="">{{\'payrollManagement.grossSalary\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center"></td><td class="text-center"></td></tr></tbody></table><div class="row mt-30"><div class="col-md-12"><h5><strong translate="">{{\'payrollManagement.bankInformation\'}}</strong></h5></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.paymentMode\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankInfo.paymentMode ? \'Not Set\' : vm.bankInfo.paymentMode}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.bankName\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankName ? \'Not Set\' : vm.bankName}}</td></tr></table></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.routingNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.routingNumber ? \'Not Set\' : vm.routingNumber}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.accountNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.accountNumber ? \'Not Set\' : vm.accountNumber}}</td></tr></table></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/partials/editMemberInfo.html','<div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><member-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" mobile-number="vm.selectedRow.number" id="vm.selectedRow.id"></member-picture-and-information></td></tr><tr class="text-left"><td><div class="flex-container align-items-center"><span class="width-45">{{\'email\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.email"></div></td><td><div><span class="width-45">{{\'employeeDocuments.nid\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.nid"></div></td></tr><tr class="text-left bg-f8f8f8"><td><div><span class="width-45">{{\'personalAndContactInformation.dateOfBirth\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.dateOfBirth"></div></td><td><div><span class="width-45">{{\'generalInfo.gender\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.gender"></div></td></tr><tr class="text-left"><td><div><span class="width-45">{{\'generalInfo.joiningDate\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.joiningDate"></div></td><td><div><span class="width-45">{{\'address.address\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.address"></div></td></tr></tbody></table><div class="row mt-20"><div class="col-md-12"><h3>{{\'commonKeywords.subscriptionInformationHeading\' | translate}}</h3></div></div><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left"><td>{{\'membershipManagement.members.packageType\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.packageType}}</span></td><td>{{\'membershipManagement.members.duration\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.duration}}</span></td></tr><tr class="text-left bg-f8f8f8"><td>{{\'membershipManagement.members.packageStartDate\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.packageStartDate}}</span></td><td>{{\'membershipManagement.members.packageEndDate\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.packageEndDate}}</span></td></tr><tr class="text-left"><td style="border-bottom-style: hidden; border-left-style: hidden"><span class=""></span></td><td>{{\'membershipManagement.members.packageAmount\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.packageAmount}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/partials/memberInfoTable.html','<style>\n    .hide-border{\n        border-bottom-style: hidden;\n        border-left-style: hidden\n    }\n</style><div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><member-picture-and-information name="vm.memberInfo.employeeName" picture-url="vm.memberInfo.pictureUrl" mobile-number="vm.memberInfo.mobileNumber == null?\'Not Set\': vm.memberInfo.mobileNumber" id="vm.memberInfo.memberId" package="vm.memberInfo.packageName"></member-picture-and-information></td></tr><tr class="text-left"><td>{{\'email\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.email}}</span></td><td>{{\'employeeDocuments.nid\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.nid == null ? \'Not Set\' : vm.memberInfo.nid}}</span></td></tr><tr class="text-left bg-f8f8f8"><td>{{\'personalAndContactInformation.dateOfBirth\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.dateOfBirth == null ? \'Not Set\' : vm.memberInfo.dateOfBirth}}</span></td><td>{{\'generalInfo.gender\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.gender}}</span></td></tr><tr class="text-left"><td>{{\'generalInfo.joiningDate\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.joiningDate}}</span></td><td>{{\'address.address\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.address == null ? \'Not Set\': vm.memberInfo.address }}</span></td></tr></tbody></table><div class="row mt-20"><div class="col-md-12"><p class="color-22222 font-weight-500 font-16 mt-10 mb-15">{{\'commonKeywords.subscriptionInformationHeading\' | translate}}</p></div></div><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left"><td>{{\'membershipManagement.members.packageType\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.packageName}}</span></td><td>{{\'membershipManagement.members.duration\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.packageDuration}}</span></td></tr><tr class="text-left bg-f8f8f8"><td>{{\'membershipManagement.members.packageStartDate\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.packageStartDate}}</span></td><td>{{\'membershipManagement.members.packageEndDate\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.packageEndDate}}</span></td></tr><tr class="text-left"><td class="hide-border"><span class=""></span></td><td>{{\'membershipManagement.members.packageAmount\' | translate}}: <span class="color-22222 font-weight-400">{{vm.memberInfo.packageAmount}}</span></td></tr></tbody></table><div class="d-flex-flex-end-10 mt-250"><button type="button" class="btn border-btn-with-icon" ng-if="vm.showMemberType == 1" ng-click="vm.renewMember(vm.memberInfo.employeeName, vm.memberInfo.subscriptionId)"><i class="ion-android-sync"></i> <span translate="">{{\'membershipManagement.members.renewal\'}}</span></button> <button type="button" class="btn btn-md-with-icon btn-secondary" ui-sref="membershipManagement.upgrade({subscriptionId:vm.memberInfo.subscriptionId, memberName:vm.memberInfo.employeeName})"><i class="ion-upload"></i> <span translate="">{{\'membershipManagement.members.upgradePackage\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/partials/membersTable.html','<style>\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    /*.table tbody tr td {*/\n    /*    white-space: normal !important;*/\n    /*}*/\n    .table > thead > tr > th:last-child {\n        padding-right: 0 !important;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-right: 0 !important;\n    }\n    .min-width{\n        min-width: 150px;\n    }\n</style><div class="members-table"><div class="btn-group special" role="group" aria-label="First group"><button type="button" class="btn btn-style text-uppercase border-radius-0" ng-class="vm.showMemberType==1? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedMemberTypeActive()"><span class="text-uppercase">{{\'membershipManagement.members.active\' | translate}}</span></button> <button type="button" class="btn btn-style text-wrap" ng-class="vm.showMemberType == 2? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedMemberTypeExpireSoon()"><span class="text-uppercase">{{\'membershipManagement.members.expireSoon\' | translate}}</span></button> <button type="button" class="btn btn-style text-wrap border-radius-0" ng-class="vm.showMemberType == 3? \'selected-table-toggle-button\':\'\'" ng-click="vm.setSelectedMemberTypeExpired()"><span class="text-uppercase">{{\'membershipManagement.members.expired\' | translate}}</span></button></div><table id="column-height" class="table borderless-table odd-row-strip row-highlight"><thead><tr class="row-height"><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center width-9" translate="">{{\'commonKeywords.id\'}}</th><th class="text-left width-25" translate="">{{\'membershipManagement.members.memberName\'}}</th><th class="text-left width-11" translate="">{{\'membershipManagement.members.package\'}}</th><th class="text-center width-15" translate="">{{\'membershipManagement.members.contactNumber\'}}</th><th class="text-center width-13" ng-if="vm.showMemberType == 2" translate="">{{\'membershipManagement.members.expireDate\'}}</th><th class="text-center width-13" ng-if="vm.showMemberType == 3" translate="">{{\'membershipManagement.members.expiredDate\'}}</th><th class="text-center width-15" ng-if="vm.showMemberType == 1" translate="">{{\'actions\'}}</th><th class="text-center width-10" ng-if="vm.showMemberType !== 1" translate="">{{\'actions\'}}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="member in vm.allMembers" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}"><td class="text-center" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)">{{($index+(vm.selectedPage*10))+1}}</td><td class="text-center" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)">{{member.memberId}}</td><td class="text-left" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)"><employee-picture-and-information name="member.name" picture-url="member.pictureUrl" department-name="" designation-name="" id="member.memberId" is-clickable="false"></employee-picture-and-information></td><td class="text-left" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)">{{member.packageName}}</td><td class="text-center" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)">{{member.mobileNumber == null ? \'Not Set\' : member.mobileNumber}}</td><td class="text-center" ng-if="vm.showMemberType == 2" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)">{{member.expireDate}}</td><td class="text-center red-text" ng-if="vm.showMemberType == 3" ng-click="vm.showMemberInfoInTheRightColumn($index,member.id)"><span class="text-danger">{{member.expireDate}}</span></td><td class="text-center min-width" ng-if="vm.showMemberType == 1"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="membershipManagement.editMember({memberId:member.id})"><i class="ion-ios-compose-outline"></i><span class="pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteMemberModal(member.name,member.id)"><i class="ion-android-delete"></i><span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td><td class="text-center" ng-if="vm.showMemberType != 1"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.renewMember(member.name,member.id)"><i class="ion-android-sync"></i><span class="pb-2 font-weight-500" translate="">{{\'membershipManagement.members.renewal\'}}</span></button></td></tr></tbody></table><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/upgrade/upgradePackage.html','<style>\n    .dark-bg{\n        background: #fcfcfc;\n    }\n    .height{\n        height: 45vh;\n    }\n    .input-style input{\n        background: #f5f5f5;\n        border: none!important;\n    }\n    .input-style input:focus{\n        background: transparent;\n    }\n    .input-style .form-control{\n        background: #f5f5f5;\n        border: none!important;\n        pointer-events: none!important;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Upgrade"><div id="create-site" class=""><div class="width-95 m-0-auto"><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.selectPackage"}}</label><div class="custom-select"><select name="selectedPackage" ng-change="vm.getDataOfSelectedPackage()" ng-model="vm.selectedPackage" ng-options="v.id as v.name for v in vm.allPackageData" required=""><option value="" translate="">pleaseSelect</option></select></div></div><div class="col-md-6 input-style"><label translate="">{{"membershipManagement.members.duration"}}</label> <input type="text" class="form-control bg-f5f5f5 prevent-clicks" ng-model="vm.selectedPackageData.duration"></div></div><div class="row mt-10"><div class="col-md-12"><label class="required" translate="">{{"membershipManagement.members.packageAmount"}}</label> <input ng-model="vm.selectedPackageData.price" type="number" class="form-control bg-f5f5f5 prevent-clicks"></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{"membershipManagement.members.packageStartDate"}}</label><div ng-class="{\' prevent-clicks\': vm.selectedPackage === null}"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.packageStartDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.packageStartDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="col-md-6 input-style"><label class="required" translate="">{{"membershipManagement.members.packageEndDate"}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative prevent-clicks" ng-model="vm.packageEndDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.packageEndDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="height"></div><div class="row"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="membershipManagement.members" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.upgradeSubscription()" translate="">{{\'membershipManagement.members.upgradeSubscriptionButton\'}}</button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/reports/membershipDailyReport/membershipDailyReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Daily report of \' + vm.titleDate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.searchMembershipDailyReport" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="daily" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">totalMember</td><td class="col-stripe-dark text-center">{{vm.totalMember}}</td><td translate="">present</td><td class="col-stripe-dark text-center">{{vm.totalPresent}}</td><td translate="">absent</td><td class="col-stripe-dark text-center">{{vm.totalAbsent}}</td><td translate="">totalHour</td><td class="col-stripe-dark text-center">{{vm.totalHours}}</td></tr></tbody></table></div></div><div class="horizontal-scroll scrollable-table report-container width-100 mt-20" fixed-column-table="" fixed-columns="0"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">memberName</th><th class="text-center" rowspan="2" translate="">contactNumber</th><th class="text-left" rowspan="2" translate="">package</th><th class="text-center" rowspan="2" translate="">entry</th><th class="text-center" rowspan="2" translate="">exit</th><th class="text-center" rowspan="2" translate="">hour</th><th class="text-center" rowspan="2" translate="">expiryDate</th></tr><tbody ng-if="vm.allEntries.length !=0"><tr ng-repeat="employee in vm.allEntries track by employee.employeeId"><td class="text-center">{{(vm.searchParams.perPage * vm.searchParams.pageNumber) + $index + 1 }}</td><td class="text-center">{{employee.memberId}}</td><td class="text-left"><employee-picture-and-information name="employee.memberName" picture-url="employee.memberPictureUrl" department-name="employee.memberContactNumber" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{employee.memberContactNumber}}</td><td class="text-left">{{employee.packageName}}</td><td class="text-center">{{employee.entryTime}}</td><td class="text-center">{{employee.exitTime}}</td><td class="text-center">{{employee.hour}}</td><td class="text-center">{{employee.expireDate}}</td></tr></tbody></thead></table></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.searchParams.pageNumber" rows-per-page="vm.searchParams.perPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getReportPageSpecifiedData" not-found-text="\'<em>No Data Found</em>\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/reports/membershipMonthlyReport/membershipMonthlyReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Monthly report from \'}}<span>{{vm.searchParams.from| date: \'MMMM yyyy\'}}</span><span>{{\' to \'}}</span><span>{{vm.searchParams.to| date: \'MMMM yyyy\'}}</span> <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.searchMembershipMonthlyReport" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="daily" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div class="horizontal-scroll scrollable-table report-container width-100 mt-20" fixed-column-table="" fixed-columns="0"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">memberName</th><th class="text-center" translate="">contactNumber</th><th class="text-left" translate="">package</th><th class="text-center" translate="">present</th><th class="text-center" translate="">absent</th><th class="text-center" translate="">totalHourSpent</th><th class="text-center" translate="">expiryDate</th></tr><tbody><tr ng-repeat="employee in vm.allEntries track by employee.employeeId"><td class="text-center">{{(vm.searchParams.perPage * vm.searchParams.pageNumber) + $index + 1 }}</td><td class="text-center">{{employee.memberId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.pictureUrl" department-name="employee.contactNumber" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{employee.contactNumber}}</td><td class="text-left">{{employee.packageName}}</td><td class="text-center">{{employee.present==1?\'Present\':\'Absent\'}}</td><td class="text-center">{{employee.absent}}</td><td class="text-center">{{employee.totalHour}}</td><td class="text-center">{{employee.expireDate}}</td></tr></tbody></thead></table></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.searchParams.pageNumber" rows-per-page="vm.searchParams.perPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getReportPageSpecifiedData" not-found-text="\'<em>No Data Found</em>\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/reports/subscriptionReport/subscriptionReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Subscription Report of \'}}<span>{{vm.searchParams.from| date: \'MMMM yyyy\'}}</span> <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.searchMembershipSubscriptionReport" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="monthly" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div class="horizontal-scroll scrollable-table report-container width-100 mt-20" fixed-column-table="" fixed-columns="0"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">memberName</th><th class="text-center" translate="">contactNumber</th><th class="text-left" translate="">package</th><th class="text-right" translate="">packageAmount</th><th class="text-center" translate="">expiryDate</th></tr><tbody><tr ng-repeat="employee in vm.allEntries track by $index"><td class="text-center">{{(vm.searchParams.perPage * vm.searchParams.pageNumber) + $index + 1 }}</td><td class="text-center">{{employee.memberId}}</td><td class="text-left"><employee-picture-and-information name="employee.name" picture-url="employee.pictureUrl" department-name="employee.memberContactNumber" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{employee.mobileNumber}}</td><td class="text-left">{{employee.packageName}}</td><td class="text-right">{{employee.packageAmount}}</td><td class="text-center">{{employee.expireDateInMillis| date: "d MMM yyyy"}}</td></tr></tbody></thead></table></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.searchParams.pageNumber" rows-per-page="vm.searchParams.perPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getReportPageSpecifiedData" not-found-text="\'No Data Found\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipSettings/create/createPackage.html','<style>\n    .text-position{\n        position: absolute;\n        left: 28px;\n        top:33px;\n    }\n    .custom-padding .form-control{\n        padding: 12px 35px;\n    }\n    .height{\n        height: 48vh;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'membershipManagement.settings.createPackage\' | translate}}"><div><div class="row"><div class="col-md-12"><label class="required">{{\'membershipManagement.settings.packageName\' | translate}}</label><div class=""><input type="text" class="form-control" placeholder="Enter package name" ng-model="vm.packagerName"></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required">{{\'membershipManagement.settings.duration\' | translate}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.packageDurationList" ng-model="vm.selectedDuration"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6"><label class="required">{{\'membershipManagement.settings.noOfMonths\' | translate}}</label> <input type="number" class="form-control" placeholder="Enter number of months" ng-model="vm.noOfMonths"></div></div><div class="row mt-10"><div class="col-md-4 custom-padding"><label class="required">{{\'membershipManagement.settings.packagePrice\' | translate}}</label> <input type="number" class="form-control position-relative" ng-model="vm.packagePrice"> <span class="color-22222 text-position">Tk.</span></div></div><div class="height"></div><div class="row"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="membershipManagement.membershipSettings" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createPackage()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createPackageButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipSettings/delete/deletePackage.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'membershipManagement.settings.doYouWantToDeletePackage\' | translate}} <em>{{vm.packageName.name}}</em>{{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deletePackage()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipSettings/edit/editPackage.html','<style>\n    .text-position{\n        position: absolute;\n        left: 28px;\n        top:33px;\n    }\n    .custom-padding .form-control{\n        padding: 12px 35px;\n    }\n    .height{\n        height: 48vh;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'membershipManagement.settings.editPackage\' | translate}}"><div><div class="row"><div class="col-md-12"><label class="required">{{\'membershipManagement.settings.packageName\' | translate}}</label><div class=""><input type="text" class="form-control" ng-model="vm.packageInfo.name"></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required">{{\'membershipManagement.settings.duration\' | translate}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.packageDurationList" ng-model="vm.packageInfo.durationType"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6"><label class="required">{{\'membershipManagement.settings.noOfMonths\' | translate}}</label> <input type="number" class="form-control" placeholder="Enter number of months" ng-model="vm.packageInfo.durationNumber"></div></div><div class="row mt-10"><div class="col-md-4 custom-padding"><label class="required">{{\'membershipManagement.settings.packagePrice\' | translate}}</label> <input type="number" class="form-control position-relative" ng-model="vm.packageInfo.price"> <span class="color-22222 text-position">Tk.</span></div></div><div class="height"></div><div class="row"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="membershipManagement.membershipSettings" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.editPackage()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/overtime/manageOvertime/allow/allowOvertime.modal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span translate="">{{\'overtime.confirmation\'}}</span></div><div class="modal-body"><p translate="">{{\'overtime.allowOvertime\'}}</p></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="vm.allowOvertime()" translate="">{{\'commonKeywords.yesButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/overtime/manageOvertime/disallow/disallowOvertime.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span translate="">{{\'overtime.confirmation\'}}</span></div><div class="modal-body"><p translate="">{{\'overtime.disallowOvertime\'}}</p></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="vm.disallowOvertime()" translate="">{{\'commonKeywords.yesButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/overtime/overtimeAllocator/approve/approveOvertime.modal.html','<body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'overtimeDetailedReport.approvalModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><label translate="">{{ \'overtimeDetailedReport.approvalModal.overtimeInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'overtimeDetailedReport.approvalModal.overtimeInputPlaceholder\' | translate }}" ng-model="vm.time"></div><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.approveOvertime()" translate="">{{ \'overtimeDetailedReport.approvalModal.submitButton\' }}</button></div></div></body>');
$templateCache.put('app/pages/main/overtime/overtimeAllocator/table/overtimeAllocatorTable.html','<style>\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .width{\n        width: 50px;\n    }\n    .column-bg{\n        background-color: rgba(255,255,255,1)\n    }\n    .td-padding{\n        padding: 1px 8px 3px !important;\n    }\n    .td-width{\n        width: 25px\n    }\n    .text-left-important{\n        text-align: left!important;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'overtimeDetailedReport.title\' | translate }}<span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate }} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" hide-print="true" config="vm.filterConfig" hide-download="true"></report-filter></div></div><div class="mt-20"><div class="horizontal-scroll report-container" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left">{{\'overtimeDetailedReport.tableHeader.name\' | translate}}</th><th class="text-left" ng-if="vm.isNotSubsidiaryAdmin" translate="">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" translate="">{{ \'overtimeSummary.tableHeader.type\' }}</th><th class="text-left">{{\'overtimeDetailedReport.tableHeader.shiftGroup\' |translate}}</th><th class="text-left width-12" colspan="2" ng-repeat="date in vm.dateList">{{date}}</th><th class="text-center" translate="">{{\'overtimeDetailedReport.tableHeader.total\'}}</th><th class="text-center width-8" translate="">{{\'overtimeDetailedReport.tableHeader.approved\'}}</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.attendanceList.length>0"><tr ng-show="vm.isDataLoaded" ng-repeat="employee in vm.attendanceList"><td class="text-center">{{$index+1}}</td><td class="text-left-important"><employee-picture-and-information name="employee.employeeName" picture-url="employee.pictureURL" department-name="employee.departmentName" designation-name="!employee.designationName ? \'N/A\':employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td ng-if="vm.isNotSubsidiaryAdmin">{{employee.subsidiaryName}}</td><td class="text-center">{{employee.designationCategoryName}}</td><td class="text-left">{{employee.shiftGroupName}}</td><td class="td-width text-left" ng-repeat-start="startOfDay in vm.startOfDayList" ng-class="($index % 2 == 0?\'present-shadow\':\'\')"><span ng-if="employee.perDayOvertimeDetailsList[startOfDay] != undefined">{{employee.perDayOvertimeDetailsList[startOfDay].overtime}}</span> <span ng-if="employee.perDayOvertimeDetailsList[startOfDay] == undefined" translate="">{{\'commonKeywords.mismatch\'}}</span></td><td class="td-width text-left cursor-pointer" ng-repeat-end=""><span ng-if="employee.perDayOvertimeDetailsList[startOfDay] != undefined"><a ng-if="employee.perDayOvertimeDetailsList[startOfDay].approvedOvertime != \'-\'" ng-click="vm.openApproveOvertimeModal($index,employee.perDayOvertimeDetailsList[startOfDay],employee)">{{employee.perDayOvertimeDetailsList[startOfDay].approvedOvertime}}</a> <a ng-if="employee.perDayOvertimeDetailsList[startOfDay].approvedOvertime == \'-\'" ng-click="vm.openApproveOvertimeModal($index,employee.perDayOvertimeDetailsList[startOfDay],employee)"><i class="ion-compose"></i></a></span> <span ng-if="employee.perDayOvertimeDetailsList[startOfDay] == undefined" translate="">{{\'commonKeywords.mismatch\'}}</span></td><td class="text-center">{{employee.summary.totalOvertime}}</td><td class="text-center">{{employee.summary.totalApprovedOvertime}}</td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div id="editor"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/overtime/overtimeReport/table/overtimeReportTable.html','<style xmlns="http://www.w3.org/1999/html">\n    td {\n        font-size: 12px;\n        padding: 0;\n        vertical-align: middle !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .width{\n        width: 50px;\n    }\n    .column-bg{\n        background-color: rgba(255,255,255,1)\n    }\n    .td-padding{\n        padding: 1px 8px 3px !important;\n    }\n    .td-width{\n        width: 25px\n    }\n    .text-left-important{\n        text-align: left!important;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'overtimeDetailedReport.title\' | translate }}<span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> {{ \'commonKeywords.filterButton\' | translate }} <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" hide-print="true" config="vm.filterConfig" hide-download="true"></report-filter></div></div><div class="mt-20"><div class="horizontal-scroll report-container" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left">{{\'overtimeDetailedReport.tableHeader.name\' | translate}}</th><th class="text-left" ng-if="vm.isNotSubsidiaryAdmin" translate="">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" translate="">{{ \'overtimeSummary.tableHeader.type\' }}</th><th class="text-left">{{\'overtimeDetailedReport.tableHeader.shiftGroup\' |translate}}</th><th class="text-center width-10" ng-repeat="date in vm.startOfDayList">{{ date|date:\'dd EEE\' }}</th><th class="text-center" translate="">{{\'overtimeDetailedReport.tableHeader.total\'}}</th><th class="text-center width-8" translate="">{{\'overtimeDetailedReport.tableHeader.approved\'}}</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.attendanceList.length>0"><tr ng-show="vm.isDataLoaded" ng-repeat="employee in vm.attendanceList"><td class="text-center">{{$index+1}}</td><td class="text-left-important"><employee-picture-and-information name="employee.employeeName" picture-url="employee.pictureURL" department-name="employee.departmentName" designation-name="!employee.designationName ? \'N/A\':employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td ng-if="vm.isNotSubsidiaryAdmin">{{employee.subsidiaryName}}</td><td class="text-center">{{employee.designationCategoryName}}</td><td class="text-left">{{employee.shiftGroupName}}</td><td class="td-width text-center" ng-repeat="startOfDay in vm.startOfDayList" ng-class="($index % 2 == 0?\'present-shadow\':\'\')"><span ng-if="employee.perDayOvertimeDetailsList[startOfDay] != undefined">{{employee.perDayOvertimeDetailsList[startOfDay].overtime}}</span> <span ng-if="employee.perDayOvertimeDetailsList[startOfDay] == undefined" translate="">{{\'commonKeywords.mismatch\'}}</span></td><td class="text-center">{{employee.summary.totalOvertime}}</td><td class="text-center">{{employee.summary.totalApprovedOvertime}}</td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div id="editor"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div>');
$templateCache.put('app/pages/main/parkingManagement/liveFeedAndDashboard/enterVehicle/enterVehicle.html','<style>\n    .found-nearby {\n        background: #f5f5f5;\n        padding: 15px 15px;\n    }\n\n    .parking-type {\n        border:1px solid #C8C8C8;\n        border-radius: 3px;\n        padding: 5px 10px;\n    }\n\n    .right-margin {\n        margin-right: 20%;\n    }\n\n    .item {\n        height: 35px;\n        width: 165px;\n        border-radius: 3px;\n        padding: 10px 15px;\n    }\n\n    .tk-icon-position {\n        position: absolute;\n        right: 20px;\n        top: 28px;\n        opacity: 0.5;\n    }\n\n    .text-position {\n        position: absolute;\n        left: 28px;\n        top: 33px;\n    }\n\n    .custom-padding .form-control {\n        padding: 12px 35px;\n    }\n\n    .input-style input, .input-style select {\n        background: #f5f5f5!important;\n    }\n\n    .input-style input:focus,.input-style select:focus {\n        background: transparent;\n    }\n\n    .entry-vehicle .panel-full-screen {\n        height: 80vh;\n    }\n    .min-width-290{\n        min-width: 290px;\n    }\n    @media (max-width: 1566px) {\n        .margin-top-10{\n            margin-top: 10px;\n        }\n    }\n    .border-none{\n        border: none;\n    }\n</style><script type="text/ng-template" id="vehicleNumber.html"><a> <div class="d-flex-align-center text-left width-100"> <div class="profile-info"> <span ng-bind-html="match.model.vehicleNumber | uibTypeaheadHighlight:query"></span> </div> </div> </a></script><div class="row entry-vehicle" ng-if="vm.formFillupType === \'manual\'"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'parkingManagement.entryVehicle\' | translate}}" ba-panel-class="with-scroll panel-full-screen"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div class="row"><div class="col-md-12"><div class="found-nearby"><div class="d-flex-space-between"><label>{{\'parkingManagement.foundNearby\' | translate}}</label> <button type="button" aria-label="Refresh" class="border-none" ng-disabled="vm.refreshEnabled" ng-click="vm.refreshNearbyEntryVehicle()"><em class="ion-loop font-20"></em></button></div><div class="d-flex-gap-10 flex-wrap"><div ng-repeat="nearby in vm.foundNearbyList"><div class="d-flex-space-between cursor-pointer bg-white item" ng-click="vm.nearbyVehicle(nearby)"><span>{{nearby.vehicleNumber}}</span> <button type="button" class="close" ng-click="vm.removeVehicle($index)" aria-label="Close"><em class="ion-ios-close-empty sn-link-close font-26"></em></button></div></div></div></div></div></div><form name="vehicleEntryForm"><div class="row"><div class="col-md-12"><label class="required">{{\'parkingManagement.vehicleNumber\' | translate}}</label> <input type="text" class="form-control appointment-log-form-control" ng-model="vm.vehicleNumber" placeholder="Enter vehicle number" uib-typeahead="v as v.vehicleNumber for v in searchVehicle($viewValue)" typeahead-template-url="vehicleNumber.html" typeahead-on-select="vm.setVehicleSearchKeyword($item)"></div></div><div class="row mt-10"><div class="col-md-12"><label class="required">{{\'parkingManagement.vehicleType\' | translate}}</label><div class="custom-select"><select ng-options="v.id as v.type for v in vm.allVehicleTypesAndBills" ng-change="vm.getBaseFareForSelectedVehicle()" ng-model="vm.selectedVehicleType"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div></div><div class="row mt-10"><div class="col-md-6"><label>{{\'parkingManagement.driverName\' | translate}}</label> <input type="text" class="form-control" placeholder="Enter driver name" ng-model="vm.driverName"></div><div class="col-md-6 form-group"><label>{{\'parkingManagement.driverMobileNumber\' | translate}}</label> <input type="text" class="form-control" placeholder="Enter driver mobile number" ng-model="vm.driverMobileNumber" name="driverNumber" minlength="7" maxlength="11"></div></div><div class="row mt-10"><div class="col-md-6"><label>{{\'parkingManagement.ownerName\' | translate}}</label><div><input type="text" class="form-control" placeholder="Enter owner name" ng-model="vm.ownerName"></div></div><div class="col-md-6"><label>{{\'parkingManagement.ownerMobileNumber\' | translate}}</label><div><input type="text" class="form-control" placeholder="Enter owner mobile number" ng-model="vm.ownerMobileNumber" name="ownerNumber" minlength="7" maxlength="11"></div></div></div><div class="row mt-10"><div class="col-md-12"><label>{{\'parkingManagement.companyName\' | translate}}</label><div><input type="text" class="form-control" placeholder="Enter company name" ng-model="vm.companyName"></div></div></div><div class="d-flex-space-between flex-wrap mt-20"><div class="width-48 min-width-290 mr-10"><div class="parking-type"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-20 align-items-center"><div><label>{{\'parkingManagement.parkingType\' | translate}}</label></div><div class="d-flex-gap-20 align-items-center"><label class="radio-container"><span class="font-12 d-inline-block mt-8">Employee</span> <input type="radio" ng-model="vm.parkingType" value="1" name="radio"> <span class="custom-radio mt-5"></span></label> <label class="radio-container"><span class="font-12 d-inline-block mt-8">Visitor</span> <input type="radio" name="radio" ng-model="vm.parkingType" value="2"> <span class="custom-radio mt-5"></span></label></div></div></div></div></div><div class="width-48 min-width-290 margin-top-10"><div class="parking-type"><div class="right-margin height-36 flex-container align-items-center"><label translate="">{{ \'parkingManagement.paid\' }}</label> <label class="custom-switch shadow-lg ml-20 mr-20"><input id="enabled" name="enabled" ng-model="vm.isFree" type="checkbox"><span class="slider round"></span></label> <label translate="">{{\'parkingManagement.tollFree\'}}</label></div></div></div></div><div class="row mt-8"><div class="col-md-4 input-style"><label class="required">{{\'parkingManagement.entryTime\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control position-relative prevent-clicks" ng-model="vm.entryTime"> <img class="tk-icon-position" src="../assets/img/clock.png"></div></div><div class="col-md-4 input-style" ng-show="!vm.isFree"><label class="required">{{\'parkingManagement.baseFare\' | translate}}</label><div class="bg-f5f5f5 custom-padding"><input type="text" class="form-control position-relative prevent-clicks" ng-model="vm.baseFare.baseFare"></div><img class="tk-icon-position" src="../assets/img/tk.png"> <span class="color-22222 text-position">Tk.</span></div></div><div class="row mt-90"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md btn-gray" ui-sref="parkingManagement.liveFeedAndDashboard" translate="">{{ \'commonKeywords.backButton\' }}</button> <button ng-disabled="vehicleEntryForm.ownerNumber.$invalid" type="button" class="btn btn-md btn-primary" ng-click="vm.saveVehicle()" translate="">{{ \'commonKeywords.confirmEntryButton\' }}</button></div></div></div></form></div></div></div></div><div class="row entry-vehicle" ng-if="vm.formFillupType === \'fromSuggestion\'"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'parkingManagement.entryVehicle\' | translate}}" ba-panel-class="with-scroll panel-full-screen"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div class="row"><div class="col-md-12"><label class="required">{{\'parkingManagement.vehicleNumber\' | translate}}</label> <input type="text" class="form-control appointment-log-form-control bg-f5f5f5 prevent-clicks" ng-model="vm.vehicleNumber" placeholder="Enter vehicle number" uib-typeahead="v as v.vehicleNumber for v in searchVehicle($viewValue)" typeahead-template-url="vehicleNumber.html" typeahead-on-select="vm.setVehicleSearchKeyword($item)"></div></div><div class="row mt-10"><div class="col-md-12"><label class="required">{{\'parkingManagement.vehicleType\' | translate}}</label><div class="custom-select input-style bg-f5f5f5 prevent-clicks"><select><option value="">{{vm.selectedVehicleName}}</option></select></div></div></div><div class="row mt-10"><div class="col-md-6"><label>{{\'parkingManagement.driverName\' | translate}}</label> <input type="text" class="form-control" placeholder="Enter driver name" ng-model="vm.driverName"></div><div class="col-md-6"><label>{{\'parkingManagement.driverMobileNumber\' | translate}}</label> <input type="text" class="form-control" placeholder="Enter driver mobile number" ng-model="vm.driverMobileNumber"></div></div><div class="row mt-10 input-style"><div class="col-md-6"><label>{{\'parkingManagement.ownerName\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" placeholder="Enter owner name" ng-model="vm.ownerName"></div></div><div class="col-md-6"><label>{{\'parkingManagement.ownerMobileNumber\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" placeholder="Enter owner mobile number" ng-model="vm.ownerMobileNumber"></div></div></div><div class="row mt-10 input-style"><div class="col-md-12"><label>{{\'parkingManagement.companyName\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" placeholder="Enter company name" ng-model="vm.companyName"></div></div></div><div class="row mt-20"><div class="col-md-6"><div class="d-flex-gap-20 align-items-center"><div><label>{{\'parkingManagement.parkingType\' | translate}}</label></div><div class="d-flex-gap-20 align-items-center"><label class="radio-container"><span class="font-12 d-inline-block mt-8">Employee</span> <input type="radio" ng-model="vm.parkingType" value="1" name="radio"> <span class="custom-radio mt-5"></span></label></div></div></div></div><div class="row mt-8"><div class="col-md-4 input-style"><label class="required">{{\'parkingManagement.entryTime\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control position-relative prevent-clicks" ng-model="vm.entryTime"> <img class="tk-icon-position" src="../assets/img/clock.png"></div></div><div class="col-md-4 input-style" ng-if="vm.parkingType === 1"><label class="required">{{\'parkingManagement.baseFare\' | translate}}</label><div class="bg-f5f5f5 custom-padding"><input type="text" class="form-control position-relative prevent-clicks" ng-model="vm.baseFare"></div><img class="tk-icon-position" src="../assets/img/tk.png"> <span class="color-22222 text-position">Tk.</span></div></div><div class="row mt-60"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md btn-gray" ui-sref="parkingManagement.liveFeedAndDashboard" translate="">{{ \'commonKeywords.backButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.saveVehicle()" translate="">{{ \'commonKeywords.confirmEntryButton\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/liveFeedAndDashboard/exitVehicle/exitVehicle.html','<style>\n    .tk-icon-position{\n        position: absolute;\n        right: 20px;\n        top:28px;\n    }\n    .text-position{\n        position: absolute;\n        left: 28px;\n        top:33px;\n    }\n    .custom-padding .form-control{\n        padding: 12px 35px;\n    }\n    .input-style input, .input-style select{\n        background: #f5f5f5;\n    }\n    .input-style input:focus, .input-style select:focus{\n        background: transparent;\n    }\n\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'parkingManagement.exitVehicle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div class="row"><div class="col-md-12 input-style"><label class="required">{{\'parkingManagement.vehicleNumber\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.parkingDetails.vehicleNumber"></div></div></div><div class="row mt-10"><div class="col-md-12"><label class="required">{{\'parkingManagement.vehicleType\' | translate}}</label><div class="custom-select input-style bg-f5f5f5 prevent-clicks"><select name="" id=""><option value="">{{vm.parkingDetails.vehicleTypeName}}</option></select></div></div></div><div class="row mt-10 input-style"><div class="col-md-6"><label>{{\'parkingManagement.driverName\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.parkingDetails.driverName"></div></div><div class="col-md-6"><label>{{\'parkingManagement.driverMobileNumber\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.parkingDetails.driverMobileNumber"></div></div></div><div class="row mt-10 input-style"><div class="col-md-6"><label>{{\'parkingManagement.ownerName\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.parkingDetails.ownerName"></div></div><div class="col-md-6"><label>{{\'parkingManagement.ownerMobileNumber\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.parkingDetails.ownerMobileNumber"></div></div></div><div class="row mt-10 input-style"><div class="col-md-12"><label>{{\'parkingManagement.companyName\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.parkingDetails.companyName"></div></div></div><div class="row mt-20"><div class="col-md-6"><div class="d-flex-gap-20 align-items-center"><div><label>{{\'parkingManagement.parkingType\' | translate}}</label></div><div class="d-flex-gap-20 align-items-center"><label class="radio-container cursor-not-allowed" ng-if="vm.parkingDetails.parkingType == 1"><span class="font-12 d-inline-block mt-8">Employee</span> <input type="radio" ng-model="vm.parkingDetails.parkingType" value="1" name="radio"> <span class="custom-radio mt-5"></span></label> <label class="radio-container cursor-not-allowed" ng-if="vm.parkingDetails.parkingType == 2"><span class="font-12 d-inline-block mt-8">Visitor</span> <input type="radio" name="radio" ng-model="vm.parkingDetails.parkingType" value="2"> <span class="custom-radio mt-5"></span></label></div></div></div></div><div class="row mt-8"><div class="col-md-4 input-style"><label class="required">{{\'parkingManagement.entryTime\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control position-relative prevent-clicks" ng-model="vm.parkingDetails.entryTime"> <img class="tk-icon-position" src="../assets/img/clock.png"></div></div><div class="col-md-4 input-style"><label class="required">{{\'parkingManagement.timeSpent\' | translate}}</label><div class="bg-f5f5f5"><input type="text" class="form-control position-relative prevent-clicks" ng-model="vm.parkingDetails.timeSpent"></div><img class="tk-icon-position" src="../assets/img/sand_glass.png"></div><div class="col-md-4 custom-padding"><label class="required">{{\'parkingManagement.amount\' | translate}}</label> <input type="number" min="0" class="form-control position-relative" ng-class="vm.isParkingOperationsManager == true ? \'prevent-clicks bg-f5f5f5\': \'\'" ng-model="vm.parkingDetails.amount"> <img class="tk-icon-position" src="../assets/img/tk.png"> <span class="color-22222 text-position">Tk.</span></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md btn-gray" ui-sref="parkingManagement.liveFeedAndDashboard" translate="">{{ \'commonKeywords.backButton\' }}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.openPrintSlipModal()" translate="">{{ \'commonKeywords.exitVehicleAndPrintReceipt\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingReport/dailyReport/dailyParkingReport.html','<style>\n   .search-width{\n       width: 350px!important;\n   }\n   .min-width-170{\n       min-width: 170px;\n   }\n   .min-width-100{\n       min-width: 100px;\n   }\n   #employeeNameSearchBox2 input::placeholder{\n       font-size: 12px;\n   }\n   @media (max-width: 1290px) {\n       .margin-at-page-break{\n           margin-top: 10px;\n       }\n   }\n   @media (max-width: 1200px) {\n       .margin-at-page-break{\n           margin-top: 0;\n       }\n   }\n   .height-45{\n       height: 45px!important;\n   }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Parking Report of \' + vm.date|translate}}"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-10 align-items-center"><div class="d-inline-block" id="employeeNameSearchBox2"><div class="has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control search-width" type="text" placeholder="Search Vehicle by Owner Name/Vehicle Number" ng-model="vm.searchKeyword" ng-keyup="$event.keyCode === 13 && vm.SearchByNameOrVehicleNumber()"></div></div><div class="filter-inline-item width-18 min-width-170"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-pointer d-block" ng-model="vm.singleDatePicker.date" options="vm.singleDatePicker.options" min="vm.minDate" max="vm.maxDateForDailyReport"><span class="date-position-left">{{vm.singleDatePicker.date.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="d-flex-space-between"><label class="min-width-100 font-weight-600" for="rowsPerPageSelection" translate="">rowsPerPage</label><div class="custom-select"><select ng-model="vm.selectedRowsPerPage" ng-change="vm.handleRowPerPageSelection()" id="rowsPerPageSelection" ng-options="d.value for d in vm.rowsPerPageOption"></select></div></div><div id="attendanceTableRowsPerPageDiv" class="filter-inline-item text-right min-height-33 mr-20"><div class="btn-group mb-2" uib-dropdown="" dropdown-append-to-body=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div><div class="d-flex-gap-10 margin-at-page-break"><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsPdf()"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">{{\'parkingManagement.employeeParking\'}}</td><td class="col-stripe-dark text-center">{{vm.allParkingData.employeeParking}}</td><td translate="">{{\'parkingManagement.visitorParking\'}}</td><td class="col-stripe-dark text-center">{{vm.allParkingData.visitorParking}}</td><td translate="">{{\'parkingManagement.totalParking\'}}</td><td class="col-stripe-dark text-center">{{vm.allParkingData.totalParking}}</td><td translate="">{{\'parkingManagement.totalBill\'}}</td><td class="col-stripe-dark text-right">{{vm.allParkingData.totalBill}}</td></tr></tbody></table></div></div><div class="horizontal-scroll scrollable-table report-container mt-15" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><thead><tr><th class="text-center" translate="">sl</th><th class="text-left" translate="">vehicleNumber</th><th class="text-left" translate="">ownerName</th><th class="text-left" translate="">{{\'parkingManagement.companyName\'}}</th><th class="text-left" translate="">driverName</th><th class="text-left" translate="">driverMobileNumber</th><th class="text-left" translate="">parkingType</th><th class="text-center" translate="">entry</th><th class="text-center" translate="">exit</th><th class="text-center" translate="">totalHours</th><th class="text-right" translate="">billTk</th></tr><tbody ng-if="vm.isDataLoaded && vm.dailyParkingReportList.length > 0"><tr ng-repeat="data in vm.dailyParkingReportList" class="height-45"><td class="text-center">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1 }}</td><td class="text-left">{{data.vehicleNumber}}</td><td class="text-left">{{data.ownerName}}</td><td class="text-left">{{data.companyName}}</td><td class="text-left">{{data.driverName}}</td><td class="text-left">{{data.driverMobileNumber}}</td><td class="text-left">{{data.parkingTypeName}}</td><td class="text-center">{{data.entryTime}}</td><td class="text-center">{{data.exitTime}}</td><td class="text-center">{{data.timeSpent}}</td><td class="text-right">{{data.amount}}</td></tr></tbody></thead></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getDailyParkingInfo" not-found-text="\'No data available\'"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingReport/monthlyReport/monthlyParkingReport.html','<style>\n    .min-width-170 {\n        min-width: 170px;\n    }\n    .min-width-100 {\n        min-width: 100px;\n    }\n    .height-45 {\n        height: 45px !important;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Parking Report of \' + vm.date|translate}}"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-10 align-items-center"><div class="filter-inline-item width-18 min-width-170"><div class="input-group mb-0 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPicker.format}}" datepicker-options="vm.monthPicker.options" ng-model="vm.selectedMonth" is-open="vm.monthPicker.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></div><div class="d-flex-space-between"><label class="min-width-100 font-weight-600" for="rowsPerPageSelection" translate="">rowsPerPage</label><div class="custom-select min-width-100"><select id="rowsPerPageSelection" ng-model="vm.rowsPerPage" class="width-70" ng-change="vm.getMonthlyParkingInfo()"><option value="10" ng-selected="vm.rowsPerPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.rowsPerPage==20" translate="">{{\'commonKeywords.twenty\'}}</option><option value="31" ng-selected="vm.rowsPerPage==31" translate="">{{\'commonKeywords.thirty_one\'}}</option></select></div></div></div><div class="d-flex-gap-10 margin-at-page-break"><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsPdf()"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">{{\'parkingManagement.employeeParking\'}}</td><td class="col-stripe-dark text-center">{{vm.monthlyParkingSummary.totalEmployee}}</td><td translate="">{{\'parkingManagement.visitorParking\'}}</td><td class="col-stripe-dark text-center">{{vm.monthlyParkingSummary.totalVisitor}}</td><td translate="">{{\'parkingManagement.totalParking\'}}</td><td class="col-stripe-dark text-center">{{vm.monthlyParkingSummary.totalParking}}</td><td translate="">{{\'parkingManagement.totalBill\'}}</td><td class="col-stripe-dark text-right">{{vm.monthlyParkingSummary.totalBill}}</td></tr></tbody></table></div></div><div class="horizontal-scroll scrollable-table report-container mt-15" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">date</th><th class="text-center" translate="">employee</th><th class="text-center" translate="">visitor</th><th class="text-center" translate="">totalParking</th><th class="text-center" translate="">totalHour</th><th class="text-right" translate="">billTk</th></tr><tbody ng-if="vm.isDataLoaded && vm.monthlyParkingReportList.length > 0"><tr ng-repeat="data in vm.monthlyParkingReportList" class="height-45"><td class="text-center">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{data.date}}</td><td class="text-center">{{data.totalEmployee}}</td><td class="text-center">{{data.totalVisitor}}</td><td class="text-center">{{data.totalParking}}</td><td class="text-center">{{data.totalHour}}</td><td class="text-right">{{data.totalBill}}</td></tr></tbody></thead></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getMonthlyParkingInfo"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingSlotSetup/create/createParkingSlotSetup.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'parkingManagement.parkingSlotSetup\' | translate}}"><div><form name="parkingSlotSetupCreateForm" ng-submit="vm.submitForm(parkingSlotSetupCreateForm.$valid)" novalidate="" autocomplete="off"><div class="row mt-10"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': parkingSlotSetupCreateForm.numberOfSlot.$invalid && parkingSlotSetupCreateForm.numberOfSlot.$touched}"><label class="required" translate="">{{\'parkingManagement.numberOfSlot\'}}</label> <input ng-model="vm.formData.numberOfSlot" name="numberOfSlot" required="" type="number" class="form-control" placeholder="{{\'parkingManagement.enterNumberOfSlot\' | translate}}"> <span ng-show="parkingSlotSetupCreateForm.numberOfSlot.$invalid && parkingSlotSetupCreateForm.numberOfSlot.$touched" class="help-block error-block basic-block">This Field Required</span></div></div></div><div class="col-md-12 mt-30 text-end"><button ng-disabled="parkingSlotSetupCreateForm.numberOfSlot.$invalid" type="submit" class="btn btn-md-with-icon btn-primary padding-10-12"><span translate="">{{\'parkingManagement.createSlot\'}}</span></button></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingSlotSetup/delete/deleteModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p>Do you want to delete this slot from Parking SLot list?</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.delete()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingSlotSetup/edit/editModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'parkingManagement.updateSlot\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><form name="parkingSlotSetupCreateForm" ng-submit="vm.submitForm(parkingSlotSetupCreateForm.$valid)" novalidate="" autocomplete="off"><div class="row mt-10"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': parkingSlotSetupCreateForm.numberOfSlot.$invalid && parkingSlotSetupCreateForm.numberOfSlot.$touched}"><label class="required" translate="">{{\'parkingManagement.numberOfSlot\'}}</label> <input ng-model="vm.data.numberOfSlot" name="numberOfSlot" required="" type="number" class="form-control" placeholder="{{\'parkingManagement.enterNumberOfSlot\' | translate}}"> <span ng-show="parkingSlotSetupCreateForm.numberOfSlot.$invalid && parkingSlotSetupCreateForm.numberOfSlot.$touched" class="help-block error-block basic-block">This Field Required</span></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button ng-disabled="parkingSlotSetupCreateForm.numberOfSlot.$invalid" id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.edit()" translate="">{{\'update\'}}</button></div></form></div></div>');
$templateCache.put('app/pages/main/parkingManagement/parkingSlotSetup/modals/success.modal.html','<style>\n    img{\n        height: 53px;\n        width: 53px;\n    }\n    .mt-negative-10{\n        margin-top: -10px;\n    }\n    .color-33BB7B{\n        color: #33BB7B;\n    }\n    .footer-mt{\n        margin-top: 35px!important;\n    }\n    @media (min-width: 768px) {\n        .modal-dialog {\n            width: 475px;\n        }\n    }\n    .footer-mt{\n        margin-top: 25px!important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close mt-negative-20" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div class="col-md-12"><div class="text-center mt-negative-10 mb-10"><img src="../assets/img/Success.png"></div><div class="text-center-important"><h1 class="font-25 text-bold color-33BB7B mb-15" translate="">success</h1><p class="font-weight-500" translate="">{{ vm.successMsg }}</p></div></div></div><div class="footer footer-mt"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/settings/billSetup/billSetup.html','<div ba-panel="" ba-panel-title="{{ \'parkingManagement.billSetup\' | translate }}" ba-panel-class="with-scroll"><div><div class="row d-flex-flex-start"><div class="col-md-3"><upgrade-button code="6004"><button type="button" class="btn btn-md-with-icon btn-primary" ui-sref="parkingManagement.createBillSetup"><span class="pb-2">{{\'parkingManagement.createNewBill\' | translate }}</span></button></upgrade-button></div></div><div class="row mb-20"><div class="col-md-12"><div class="horizontal-scroll scrollable-table report-container mt-10" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><colgroup><col class="width-5"><col class="width-50"><col class="width-10"><col class="width-10"><col class="width-10"><col class="width-15"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="" translate="">{{ \'parkingManagement.billType\' }}</th><th class="text-right" translate="">{{ \'parkingManagement.baseFareTk\' }}</th><th class="text-right" translate="">{{ \'parkingManagement.baseHour\' }}</th><th class="text-right" translate="">{{ \'parkingManagement.hourlyFareTk\' }}</th><th class="text-center" translate="">actions</th></tr></thead><tbody><tr ng-repeat="vehicleType in vm.vehicleTypeList"><td class="text-center">{{$index+1}}</td><td class="">{{vehicleType.type}}</td><td class="text-right">{{vehicleType.baseFare}}</td><td class="text-right">{{vehicleType.baseHour}}</td><td class="text-right">{{vehicleType.hourlyFare}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="parkingManagement.updateBillSetup({vehicleType: vehicleType})"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteBillSetupModal(vehicleType)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/create/createVehicle.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'parkingManagement.registerNewVehicles\' | translate}}"><div><form name="vehicleCreateForm" ng-submit="vm.submitForm(vehicleCreateForm.$valid)" novalidate="" autocomplete="off"><div class="row mt-10"><div class="col-md-12"><h2 class="text-center gray-text">{{\'parkingManagement.ownerInformationEntry\' | translate}}</h2></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">{{\'parkingManagement.ownerName\'}}</label><div class="form-group"><div class="select-host" isteven-multi-select="" input-model="vm.ownerDropDownList" output-model="vm.selectedOwner" on-item-click="vm.setField()" button-label="label" item-label="label" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Reset\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Host\' }"></div></div></div></div><div class="row mt-10"><div class="col-md-6 form-group"><label translate="">{{\'parkingManagement.mobileNumber\'}}</label> <input ng-disabled="vm.employeesPhoneNumber.length >= 11" name="ownerNumber" ng-model="vm.formData.employeePhoneNumber" type="text" class="form-control" placeholder="{{\'parkingManagement.enterMobileNumber\' | translate}}"></div><div class="col-md-6"><label translate="">{{\'parkingManagement.email\'}}</label> <input disabled="" ng-model="vm.formData.email" type="email" class="form-control" placeholder="{{\'parkingManagement.enterEmail\' | translate}}"></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">{{\'parkingManagement.companyName\'}}</label> <input ng-model="vm.formData.companyName" type="text" class="form-control" placeholder="{{\'parkingManagement.enterCompanyName\' | translate}}"></div></div><div class="row mt-30"><div class="col-md-12"><h2 class="text-center gray-text">{{\'parkingManagement.vehicleInformationEntry\' | translate}}</h2></div></div><div class="row mt-10"><div class="col-md-12 form-group" ng-class="{\'has-error\': vehicleCreateForm.vehicleNumber.$invalid && vehicleCreateForm.vehicleNumber.$touched}"><label class="required" translate="">{{\'parkingManagement.vehicleNumber\'}}</label> <input ng-model="vm.formData.vehicleNumber" ng-disabled="vm.selectedOwner.length===0" type="text" class="form-control" placeholder="{{\'parkingManagement.enterVehicleNumber\' | translate}}" name="vehicleNumber" required=""> <span ng-show="vehicleCreateForm.vehicleNumber.$invalid && vehicleCreateForm.vehicleNumber.$touched" class="help-block error-block basic-block">Vehicle Number Required</span></div></div><div class="row mt-10"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vehicleCreateForm.selectedVehicleType.$invalid && vehicleCreateForm.selectedVehicleType.$touched}"><label class="required" translate="">{{\'parkingManagement.vehicleType\'}}</label><div class="custom-select"><select name="selectedVehicleType" ng-model="vm.formData.vehicleTypeId" ng-options="v.id as v.type for v in vm.vehicleTypes" required=""><option value="" translate="">{{\'parkingManagement.selectOrEnterType\'}}</option></select></div><span ng-show="vehicleCreateForm.selectedVehicleType.$invalid && vehicleCreateForm.selectedVehicleType.$touched" class="help-block error-block basic-block">Vehicle Type Required</span></div></div><div class="col-md-6"><label translate="">{{\'parkingManagement.color\'}}</label> <input ng-model="vm.formData.color" ng-disabled="vm.selectedOwner.length===0" type="text" class="form-control" placeholder="{{\'parkingManagement.selectColor\' | translate}}"></div></div><div class="row mt-10"><div class="col-md-6 form-group"><label translate="">{{\'parkingManagement.model\'}}</label> <input ng-model="vm.formData.model" ng-disabled="vm.selectedOwner.length===0" type="text" class="form-control" placeholder="{{\'parkingManagement.enterModel\' | translate}}" name="model"></div><div class="col-md-6 form-group"><label translate="">{{\'parkingManagement.brand\'}}</label> <input ng-model="vm.formData.brand" ng-disabled="vm.selectedOwner.length===0" type="text" class="form-control" name="brand" placeholder="{{\'parkingManagement.enterBrand\' | translate}}"></div></div><div class="row mt-30"><div class="col-md-12"><h2 class="text-center gray-text">{{\'parkingManagement.driverInformationEntry\' | translate}}</h2></div></div><div class="row mt-10"><div class="col-md-6 form-group"><label translate="">{{\'parkingManagement.driverName\'}}</label> <input ng-model="vm.formData.driverName" type="text" class="form-control" placeholder="{{\'parkingManagement.enterDriverName\' | translate}}" name="driverName"></div><div class="col-md-6 form-group"><label translate="">{{\'parkingManagement.mobileNumber\'}}</label> <input ng-model="vm.formData.driverMobileNumber" name="driverNumber" type="text" class="form-control" placeholder="{{\'parkingManagement.enterDriverMobileNo\' | translate}}" minlength="7" maxlength="11"></div><div class="col-md-12 mt-30 text-end"><button type="submit" class="btn btn-md-with-icon btn-primary padding-10-12" ng-disabled="vehicleCreateForm.$invalid"><span translate="">{{\'parkingManagement.confirmRegistration\'}}</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/delete/deleteModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p>Do you want to delete <strong>{{vm.vehicleNumber}}</strong> from vehicle list?</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.delete()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/modals/success.modal.html','<style>\n    img{\n        height: 53px;\n        width: 53px;\n    }\n    .mt-negative-10{\n        margin-top: -10px;\n    }\n    .color-33BB7B{\n        color: #33BB7B;\n    }\n    .footer-mt{\n        margin-top: 35px!important;\n    }\n    @media (min-width: 768px) {\n        .modal-dialog {\n            width: 475px;\n        }\n    }\n    .footer-mt{\n        margin-top: 25px!important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close mt-negative-20" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div class="col-md-12"><div class="text-center mt-negative-10 mb-10"><img src="../assets/img/Success.png"></div><div class="text-center-important"><h1 class="font-25 text-bold color-33BB7B mb-15" translate="">success</h1><p class="font-weight-500" translate="">{{ vm.successMsg }}</p></div></div></div><div class="footer footer-mt"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/partials/dummyTable.html','<div class="row mt-5"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information><button ng-if="vm.selectedRow.salary" class="btn btn-primary edit-btn-position" ng-disabled="!vm.isEmployeePayrollComponentsLoaded" ng-click="vm.openEditMode()"><i class="ion-ios-compose-outline font-19 mr-3"></i> <span translate="">{{\'payrollManagement.editInformation\'}}</span></button></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.selectedRow.shiftGroupName ? vm.selectedRow.shiftGroupName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.selectedRow.employmentTypeName ? vm.selectedRow.employmentTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h5><strong translate="">{{\'payrollManagement.payrollInformation\'}}</strong></h5></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh bg-f8f8f8 font-14"><th class="text-left dont-wrap-text" translate="">{{\'payrollSettings.componentName\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.dummyAmount\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.value\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollSettings.percentageOf\'}}</th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'payrollManagement.basicSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.houseRentAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.conveyanceAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.medicalAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left font-weight-bold"><strong translate="">{{\'payrollManagement.grossSalary\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center"></td><td class="text-center"></td></tr></tbody></table><div class="row mt-30"><div class="col-md-12"><h5><strong translate="">{{\'payrollManagement.bankInformation\'}}</strong></h5></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.paymentMode\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankInfo.paymentMode ? \'Not Set\' : vm.bankInfo.paymentMode}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.bankName\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankName ? \'Not Set\' : vm.bankName}}</td></tr></table></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.routingNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.routingNumber ? \'Not Set\' : vm.routingNumber}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.accountNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.accountNumber ? \'Not Set\' : vm.accountNumber}}</td></tr></table></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/partials/editOwnerInfoSection.html','<style>\n    @media (max-width: 991px) {\n        .spacing {\n            margin-top: 15px;\n        }\n    }\n    .driver-input{\n        outline: none;\n        border: 1px solid #c2c2c2;\n        padding: 5px;\n        display: flex;\n        background: white;\n    }\n    .driver-input input {\n        background: transparent;\n        width: 100%;\n        padding: 10px;\n        outline: none;\n        border: none;\n    }\n</style><div class="row mt-15"><div class="col-md-12"><table class="table table-bordered"></table><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.employee.employeeName" picture-url="vm.selectedRow.employee.profilePictureUrl"></employee-picture-and-information></td></tr><tr class="text-left"><td><div class="flex-container align-items-center"><span class="width-45">{{\'mobile\' | translate}}:</span> <input type="text" class="form-control bg-gray-200-i" ng-model="vm.selectedRow.employee.employeePhoneMobile" ng-disabled="vm.selectedRow.employee.employeePhoneMobile !==\'\'"></div></td><td><div class="flex-container align-items-center"><span class="width-45">{{\'email\' | translate}}:</span> <input disabled="" type="text" class="form-control bg-gray-200-i" ng-model="vm.selectedRow.employee.email"></div></td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500">{{\'parkingManagement.vehicleInformation\' | translate}}</p></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left"><td><div class="flex-container align-items-center"><span class="width-45">{{\'commonKeywords.vehicleNumber\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.vehicleNumber"></div></td><td><div class="d-flex-space-between"><span class="width-45 mb-5">{{\'parkingManagement.vehicleType\' | translate}}:</span><div class="custom-select"><select name="selectedVehicleType" ng-model="vm.selectedRow.vehicleTypeId" ng-options="v.id as v.type for v in vm.vehicleTypes" required=""></select></div></div></td></tr><tr class="text-left"><td><div class="flex-container align-items-center"><span class="width-45">{{\'parkingManagement.code\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.color"></div></td><td><div class="flex-container align-items-center"><span class="width-45">{{\'parkingManagement.model\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.model"></div></td></tr><tr class="text-left"><td><div class="flex-container align-items-center"><span class="width-45">{{\'parkingManagement.brand\' | translate}}:</span> <input type="text" class="form-control" ng-model="vm.selectedRow.brand"></div></td><td></td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500">{{\'parkingManagement.driverInformation\' | translate}}</p></div></div><div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><div class="driver-input"><img ng-src="../assets/img/theme/no-avatar.png"> <input class="" type="text" ng-model="vm.selectedRow.driverName"></div></td></tr><tr class="text-left"><td>{{\'parkingManagement.contactNumber\' | translate}}</td><td><input type="text" class="form-control" ng-model="vm.selectedRow.driverMobileNumber"></td></tr></tbody></table></div></div><div class="row mt-50"><div class="col-md-12 text-right"><button class="btn btn-md-with-icon padding-10" ng-click="vm.cancelEdit()"><span class="pb-2" translate="">{{\'parkingManagement.cancelButton\'}}</span></button> <button class="btn btn-md-with-icon btn-primary padding-5-10 ml-10" ng-click="vm.update()"><img src="../assets/img/Save.png"> <span class="pb-2" translate="">{{\'parkingManagement.saveButton\'}}</span></button></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/partials/ownerInfoSection.html','<div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.employee.employeeName" picture-url="vm.selectedRow.employee.profilePictureUrl"></employee-picture-and-information></td></tr><tr class="text-left"><td>{{\'mobile\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.employee.employeePhoneMobile}}</span></td><td>{{\'email\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.employee.email}}</span></td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500">{{\'parkingManagement.vehicleInformation\' | translate}}</p></div></div><div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left"><td>{{\'commonKeywords.vehicleNumber\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.vehicleNumber}}</span></td><td>{{\'parkingManagement.vehicleType\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.vehicleTypeName}}</span></td></tr><tr class="text-left"><td>{{\'parkingManagement.code\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.color}}</span></td><td>{{\'parkingManagement.model\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.model}}</span></td></tr><tr class="text-left"><td>{{\'parkingManagement.brand\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.brand}}</span></td><td>{{\'parkingManagement.companyName\' | translate}}: <span class="color-22222 font-weight-500">{{vm.selectedRow.companyName}}</span></td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><p class="font-16 color-22222 font-weight-500">{{\'parkingManagement.driverInformation\' | translate}}</p></div></div><div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.driverName"></employee-picture-and-information></td></tr><tr class="text-left"><td>{{\'parkingManagement.contactNumber\' | translate}}</td><td><span class="color-22222 font-weight-500">{{vm.selectedRow.driverMobileNumber}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/parkingManagement/vehicles/partials/ownerTable.html','<style>\n    .owner-table .table > thead > tr > th:last-child {\n        padding-right: 10px;\n    }\n    .owner-table .table > tbody > tr > td:last-child {\n        padding-right: 10px !important;\n    }\n</style><div class="owner-table"><table id="column-height" class="table report-table report-table-font-14 mt-5"><colgroup><col class="width-50"><col class="width-20"><col class="width-30"></colgroup><thead><tr class="row-height dont-wrap-text"><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.ownerName\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.vehicleNumber\'}}</th><th class="text-center dont-wrap-text width-10" translate="">{{\'commonKeywords.actions\'}}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="data in vm.allData" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}"><td class="dont-wrap-text" ng-click="vm.showOwnerInfoInTheRightColumn($index)"><employee-picture-and-information name="data.employee.employeeName" picture-url="data.employee.profilePictureUrl" is-clickable="false"></employee-picture-and-information></td><td class="dont-wrap-text text-left" ng-click="vm.showOwnerInfoInTheRightColumn($index)">{{data.vehicleNumber}}</td><td class="dont-wrap-text text-center"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.showOwnerEditInfoInTheRightColumn($index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(data)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/bankManagement/manageBanks.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Banks" ba-panel-class="with-scroll"><div class="row mb-15"><div class="col-md-12"><div class="row mb-15"><div class="col-md-8"><button type="button" class="btn btn-md btn-primary" ng-click="vm.openAddNewBankModal()">{{\'bankManagement.addNewBankBtn\' | translate }}</button></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-left" translate="">{{\'bankManagement.bankList.tableHeader.bankName\'}}</th><th class="text-left" translate="">{{\'bankManagement.bankList.tableHeader.code\'}}</th><th class="text-left" translate="">{{\'bankManagement.bankList.tableHeader.accountName\'}}</th><th class="text-center" translate="">{{\'bankManagement.bankList.tableHeader.accountNumber\'}}</th><th class="text-center width-13" translate="">{{\'bankManagement.bankList.tableHeader.status\'}}</th><th class="text-center width-13" translate="">{{\'bankManagement.bankList.tableHeader.actions\'}}</th></tr></thead><tbody ng-if="vm.banks.length > 0"><tr ng-repeat="record in vm.banks | filter:{\'name\':vm.searchText}"><td class="text-center">{{$index + 1}}</td><td class="text-left">{{record.name}}</td><td class="text-left">{{record.code}}</td><td class="text-left">{{record.accountName}}</td><td class="text-center">{{record.accountNumber}}</td><td class="text-center" ng-if="record.status === 1" translate="">{{\'commonKeywords.statusActive\'}}</td><td class="text-center" ng-if="record.status === 0" translate="">{{\'commonKeywords.statusInactive\'}}</td><td class="text-center"><div class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openBankEditModal(record)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-secondary" ui-sref="payroll.bankPaymentAdviceEditor({bankId:record.id})"><i class="ion-document-text"></i> <span class="ml-negative-5 pb-2" translate="">{{\'bankManagement.bankList.adviceLetterBtn\'}}</span></button></div></td></tr></tbody><tbody ng-if="vm.banks == null || vm.banks.length === 0"><tr><td class="text-center" colspan="6"><em translate="">{{\'bankManagement.bankList.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/branchManagement/manageBranches.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Branches" ba-panel-class="with-scroll"><div class="row mb-15"><div class="col-md-12"><div class="row mb-15"><div class="col-md-8"><button type="button" class="btn btn-md btn-primary" ng-click="vm.openAddNewBranchModal()">{{\'bankManagement.addNewBranchBtn\' | translate }}</button></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-left" translate="">{{\'bankManagement.branchList.tableHeader.bankName\'}}</th><th class="text-left" translate="">{{\'bankManagement.branchList.tableHeader.branchName\'}}</th><th class="text-center" translate="">{{\'bankManagement.branchList.tableHeader.routingNumber\'}}</th><th class="text-center width-13" translate="">{{\'bankManagement.branchList.tableHeader.status\'}}</th><th class="text-center width-13" translate="">{{\'bankManagement.branchList.tableHeader.action\'}}</th></tr></thead><tbody ng-if="vm.bankBranches.length > 0"><tr ng-repeat="record in vm.bankBranches | filter:{\'bankName\':vm.searchText}" class="border-bottom-1"><td class="text-center">{{$index + 1}}</td><td class="text-left">{{record.bankName}}</td><td class="text-left">{{record.branchName}}</td><td class="text-center">{{record.routingNumber}}</td><td class="text-center" ng-if="record.branchStatus === 1" translate="">{{\'commonKeywords.statusActive\'}}</td><td class="text-center" ng-if="record.branchStatus === 0" translate="">{{\'commonKeywords.statusInactive\'}}</td><td class="text-center"><div class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openBranchEditModal(record)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button></div></td></tr></tbody><tbody ng-if="vm.bankBranches == null || vm.bankBranches.length === 0"><tr><td class="text-center" colspan="6"><em translate="">{{\'bankManagement.branchList.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/loanManagement/loanOrSalaryAdvanceInput/addNewLoanOrSalaryAdvanceType.html','<style>\n    .custom-padding .form-control{\n        padding: 12px 35px;\n    }\n    .input-style input, .input-style select{\n        background: #f5f5f5;\n        border: none!important;\n    }\n    .input-style input:focus, .input-style select:focus{\n        background: transparent;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'loanManagement.loanOrSalaryAdvanceInputTitle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><employee-type-ahead-search select-method="vm.getEmployeeProfileWithLoanInfo" keyword="vm.searchKeyword" show-label="true" is-required="true"></employee-type-ahead-search><div class="row"><div class="col-md-12 input-style"><label translate="">employeeName</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.name"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">designation</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.designationName"></div></div><div class="col-md-6 input-style"><label translate="">department</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.departmentName"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">workplace</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.workplaceName"></div></div><div class="col-md-6 input-style"><label translate="">email</label><div class="bg-f5f5f5"><input type="email" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.email"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.previousLoanStatus\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.loanStatus"></div></div><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.previousLoanTaken\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.loanTakenMonth"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.loanAmount\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.previousLoanAmount"></div></div><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.expectedSettlementMonth\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployee.settlementMonth"></div></div></div><div class="row"><div class="col-md-12"><label class="mt-10 font-13 required" translate="">type</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.loanType" ng-model="vm.selectedLoanType"></select></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{ \'loanManagement.loanRequestDate\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.loanRequestDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.loanRequestDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required" translate="">{{ \'loanManagement.loanDisburseDate\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.loanDisburseDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.loanDisburseDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{\'loanManagement.loanAmount\'}}</label><div><input type="number" class="form-control" ng-model="vm.loanAmount"></div></div><div class="col-md-6"><label class="required" translate="">{{\'loanManagement.noOfInstallment\'}}</label><div><input type="number" class="form-control" ng-model="vm.noOfInstallment"></div></div></div><div class="row"><div class="col-md-12"><label class="text-capitalize required mt-10" translate="">{{\'loanManagement.installmentStartFrom\'}}</label><div class="filter-inline-item"><div class="input-group mb-0"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerInstallment.format}}" datepicker-options="vm.monthPickerInstallment.options" ng-model="vm.startingMonthOfInstallment" is-open="vm.monthPickerInstallment.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPickerInstallment()"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">remarks</label><div><input type="text" class="form-control" placeholder="Remarks" ng-model="vm.remarks"></div></div></div><div class="row mt-25"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="payroll.loanManagement" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.saveLoanOrSalaryAdvanceType()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/loanManagement/modals/deferLoanModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'profile.areYouSureHeading\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5"><span translate="">{{\'loanManagement.deferLoanQuestion\'}}</span> <span class="color-22222 font-weight-500">{{vm.loanToDefer.employeeName}}{{\'commonKeywords.questionMark\' | translate}}</span></p><div class="form-group mt-10"><label class="required" translate="">{{\'loanManagement.loanDeferMonth\'}}</label> <input type="number" class="form-control" ng-model="vm.deferLoanBy" placeholder="{{\'leaveCategoryPolicyConfigurations.placeholderText0\' | translate}}" id="{{\'total-days-\' + $index}}" name="totalDays" required="" min="1"></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'loanManagement.no\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.deferLoan()" translate="">{{\'loanManagement.yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/loanManagement/modals/earlySettlement.modal.html','<style>\n    .input-style input, .input-style select{\n        background: #f5f5f5;\n    }\n    .input-style input:focus, .input-style select:focus{\n        background: transparent;\n    }\n</style><body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'profile.areYouSureHeading\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5"><span>{{\'loanManagement.earlySettlementQuestion\' | translate}}<br><span class="font-weight-500 color-22222">{{vm.loanToSettle.employeeName}}</span><span translate="">{{\'commonKeywords.questionMark\' | translate}}</span></span></p><div class="row"><div class="col-md-12 input-style mt-10"><label translate="">{{\'loanManagement.loanBalance\'}}</label><div class="bg-f5f5f5"><input type="number" class="form-control" ng-model="vm.settleBalance" ng-disabled="true" readonly=""></div></div><div class="col-md-12 input-style mt-10"><label translate="">{{\'loanManagement.installmentMonths\'}}</label><div class="bg-f5f5f5"><input type="number" class="form-control" ng-model="vm.settleMonths" ng-disabled="true" readonly=""></div></div><div class="col-md-12 mt-10"><label class="required" translate="">{{\'loanManagement.paymentMode\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.loanPaymentModes" ng-model="vm.selectedPaymentMode"></select></div></div><div class="col-md-12 mt-10"><label translate="">remarks</label><div><input type="text" class="form-control" placeholder="Remarks" ng-model="vm.remarks"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.noButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.settleLoan()" translate="">{{ \'commonKeywords.yesButton\' }}</button></div></div></div></body>');
$templateCache.put('app/pages/main/payroll/loanManagement/partials/employeesTable.html','<style>\n    .edited{\n        border-radius:10px;\n        color:#222222;\n        font-weight: 500;\n        border:1px solid #DF871C;\n        float: right\n    }\n    .section-padding{\n        padding-top: 5%;\n    }\n    .process-btn{\n        font-size: 12px;\n        margin-right: 0px;\n        padding: 1px 6px;\n    }\n    .flex-0-1-100{\n        flex: 0 1 100%;\n    }\n    .flex-0-1-auto{\n        flex: 0 1 auto;\n    }\n    .border-bottom-1{\n        border-bottom: 1px solid #dfdfdf!important;\n    }\n</style><div class="col-md-12"><table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-13"><col class="width-39"><col class="width-15"><col class="width-15"><col class="width-12"></colgroup><thead><tr class="dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left check-uncheck-all dont-wrap-text"><label class="checkbox-container text-normal"><span class="ml-20"><span class="d-inline-block mt-2 white-text">{{\'commonKeywords.id\' | translate}}</span></span></label></th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'loanManagement.type\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'loanManagement.loanAmount\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'loanManagement.repaidAmount\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.allLoanList" class="cursor-pointer" ng-class="{\'is-selected\':vm.isRowSelected && vm.selectedRow == $index}" style="{{data.isEdited ? \'background-color:#E1ECEA\':\'\'}}" ng-click="vm.loanRowSelect($index)"><td class="text-center">{{$index + 1}}</td><td class="text-left">{{data.employeeOfficeId}}</td><td class="dont-wrap-text"><employee-picture-and-information name="data.employeeName" picture-url="data.employeePictureUrl" department-name="data.departmentName" designation-name="data.designationName" is-clickable="false"></employee-picture-and-information></td><td class="dont-wrap-text text-center">{{data.type==2?\'Loan\':\'Advance Salary\'}}</td><td class="dont-wrap-text text-right">{{data.paidAmount+data.remainingAmount | number:2}}</td><td class="dont-wrap-text text-right" ng-if="vm.salarySummary.status != 0 || vm.isPayrollApprover">{{data.paidAmount}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/payroll/loanManagement/partials/loanDetails.html','<style>\n    .th-bg-loan{\n        background: #e7e7e8;\n    }\n    .table-scroll table thead th{\n        background: #e7e7e8;\n    }\n    .table-scroll{\n        max-height: 40vh!important;\n    }\n</style><div ng-if="!vm.isRowSelected || (vm.isRowSelected && vm.isLoanInstallmentsDataLoaded)"><div class="row"><div class="col-md-12"><div class="d-flex-row-reverse-wrap-7 pr-15"><div><button class="btn btn-md-with-icon btn-primary padding-5-10 ml-10" ng-click="vm.exportAsExcel()"><img src="../assets/img/Excel.png"><span translate="">{{\'commonKeywords.downloadExcelButton\'}}</span></button></div><div><button class="btn btn-md-with-icon btn-secondary padding-10-12 ml-10" ng-click="vm.earlySettlement(vm.selectedRow)" ng-if="vm.isRowSelected && !vm.isSelectedLoanSettled"><span translate="">{{\'loanManagement.earlySettlement\'}}</span></button></div><div><button class="btn btn-md-with-icon btn-secondary padding-10-12 ml-10" ng-click="vm.deferLoan(vm.selectedRow)" ng-if="vm.isRowSelected && !vm.isSelectedLoanSettled"><span translate="">{{\'loanManagement.deferLoan\'}}</span></button></div></div></div></div><div class="row mt-31 ml-1"><div class="col-md-12"><h4><strong translate="">{{\'loanManagement.loanDetails\'}}</strong></h4></div></div><div ng-class="{\'unselected\': !vm.isRowSelected}"><div class="col-md-12 col-sm-12"><table class="table table-bordered mt-10"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-bg th-width position-relative"><td colspan="2"><div class="visitor-image-and-data-with-button"><div class="width-70"><employee-picture-and-information name="vm.selectedLoanToShow.employeeName" picture-url="vm.selectedLoanToShow.employeePictureUrl" department-name="vm.selectedLoanToShow.departmentName" designation-name="vm.selectedLoanToShow.designationName" is-clickable="false"></employee-picture-and-information></div><button class="btn btn-sm-with-icon btn-secondary" ui-sref="payroll.editLoanOrSalaryDetails({employeeInfo:vm.allLoanList[vm.selectedRow]})" ng-if="vm.selectedLoanToShow.isEditable"><i class="ion-ios-compose-outline"></i><span class="pb-2" translate="">{{\'visitorManagement.myVisitorProfile.visitorEdit\'}}</span></button></div></td></tr><tr class="text-left"><td><span translate="">{{\'loanManagement.loanRequestDate\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.requestedAt | date: "d MMM yyyy" }}</span></td><td><span translate="">{{\'loanManagement.loanDisburseDate\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.disbursedAt | date: "d MMM yyyy" }}</span></td></tr><tr class="text-left"><td><span translate="">{{\'loanManagement.loanAmountLoanDetails\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.amount | number:2}}</span></td><td><span translate="">{{\'loanManagement.noOfInstallment\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.installmentCount}}</span></td></tr><tr class="text-left"><td><span translate="">{{\'loanManagement.repaidAmountLoanDetails\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.paidAmount| number:2}}</span></td><td><span translate="">{{\'loanManagement.remainingAmount\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.remainingAmount| number:2}}</span></td></tr></tbody></table><div class="horizontal-scroll report-container table-scroll mt-10" fixed-column-table="" fixed-columns="0"><table class="table table-bordered mt-negative-1"><colgroup><col class="width-15"><col class="width-20"><col class="width-25"><col class="width-25"><col class="width-15"></colgroup><thead><tr class="text-center th-bg-loan th-width"><th class="text-center" translate="">{{\'loanManagement.emiNo\'}}</th><th class="text-center" translate="">{{\'loanManagement.month\'}}</th><th class="text-right" translate="">{{\'loanManagement.emiAmount\'}}</th><th class="text-right" translate="">{{\'loanManagement.loanBalance\'}}</th><th class="text-center" translate="">{{\'loanManagement.status\'}}</th></tr></thead><tbody><tr ng-repeat="installments in vm.selectedLoanToShow.loanInstallments" class="text-left"><td class="text-center">{{installments.emiNumber}}</td><td class="text-center"><span>{{vm.monthNames[installments.emiMonth-1]+\' \'}}</span>{{installments.emiYear}}</td><td class="text-right">{{installments.emiAmount}}</td><td class="text-right">{{installments.balance}}</td><td class="text-center">{{installments.statusText}}</td></tr></tbody></table></div><table class="table table-bordered mt-10" ng-if="vm.isLoanInstallmentsDataLoaded"><tbody><tr class="text-center th-width"><td class="text-left"><span translate="">{{\'loanManagement.remarks\'}}</span> <span class="dark-text">{{vm.selectedLoanToShow.remarks}}</span></td></tr></tbody></table></div></div></div><div class="row ng-scope" ng-if="!vm.isRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div><div class="row text-center" ng-if="vm.isRowSelected && !vm.isLoanInstallmentsDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentOrLeaveWithoutPay.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Absent/Leave without Pay For the month of \' + vm.monthName + \', \' + vm.searchParams.salaryYear}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class=""><div><payroll-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" add-btn-name="commonKeywords.addAbsenceTypeForIndividualEmpButton" add-btn-sref="payroll.absentTypeInputForIndividualEmployee" add-btn-action="vm.goToAddNewPage" upload-btn-name="upload" upload-btn-sref="" download-demo-excel-btn-name="commonKeywords.downloadAbsenceUpFileButton" download-demo-excel-btn-sref="" delete-btn-active="vm.deleteBtnActive" type="absentLwp" success="vm.success" config="vm.filterConfig" excel-upload-method="vm.uploadSelectedExcelFile" download-demo-excel-btn-url="vm.downloadSampleExcelFile"></payroll-filter></div><div><table class="table report-table"><thead class="disabled"><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">employeeName</th><th class="text-center" translate="">employeeType</th><th class="text-lefy" translate="">workplace</th><th class="text-left" translate="">{{\'payrollSettings.absenceType\'}}</th><th class="text-center" translate="">payrollSettings.days</th><th class="text-left" translate="">remarks</th><th class="text-center" translate="">actions</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="data in vm.allEmployeeData"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{data.employeeInfo.employeeOfficeId == null ? "" : data.employeeInfo.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="data.employeeInfo.employeeName" picture-url="data.employeeInfo.profilePictureUrl" department-name="data.employeeInfo.departmentName" designation-name="data.employeeInfo.designationName" id="data.employeeInfo.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="data.employeeInfo.employmentTypeName?\'text-center\':\'color-999999 text-center\'">{{data.employeeInfo.employmentTypeName?data.employeeInfo.employmentTypeName:\'Not Set\'}}</td><td class="text-left" ng-class="data.employeeInfo.workplaceName?\'text-left\':\'color-999999 text-left\'">{{data.employeeInfo.workplaceName?data.employeeInfo.workplaceName:\'Not Set\'}}</td><td class="text-left">{{data.componentName}}</td><td class="text-center">{{data.days}}</td><td class="text-left"><span ng-repeat="remark in data.remarkList">{{remark}}<br></span></td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.editComponent(data)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(data.employeeId, data.componentId, vm.searchParams)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table><div ng-if="vm.allEmployeeData.length <= 0 && vm.isDataLoaded" class="d-flex-gap-10 justify-center flex-col align-items-center mt-40"><img src="../assets/img/upload-62.png" alt="upload image"><p class="gray-text">No Absent/Leave without pays are yat uploaded for the month of <strong>{{vm.monthName}}, {{vm.searchParams.salaryYear}}</strong></p><p class="gray-text">You can add Absent/Leave without pays for individuals, or can upload an Excel file to load them in batch. Download the sample file to upload from Excel</p></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" hide-no-data-message="true"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/salaryComponentUpload.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Additional Salary Component Upload\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class=""><div><payroll-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" add-btn-name="commonKeywords.addNewComponentForIndividualEmpButton" add-btn-sref="payroll.individualAdditionalSalaryComponent" add-btn-action="vm.goToAddNewPage" upload-btn-name="upload" upload-btn-sref="" download-demo-excel-btn-name="commonKeywords.downloadComponentUpFileButton" download-demo-excel-btn-url="vm.downloadSampleExcelFile" delete-btn-active="vm.deleteBtnActive" type="additional" success="vm.success" config="vm.filterConfig" excel-upload-method="vm.uploadSelectedExcelFile"></payroll-filter></div><div><table class="table report-table"><thead class="disabled"><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">employeeName</th><th class="text-center" translate="">employeeType</th><th class="text-left" translate="">workplace</th><th class="text-left" translate="">{{\'payrollSettings.componentName\'}}</th><th class="text-right" translate="">{{\'payrollSettings.amount\'}}</th><th class="text-left" translate="">remarks</th><th class="text-center" translate="">actions</th></tr></thead><tbody ng-if="vm.allEmployeeData.length > 0 && vm.isDataLoaded"><tr ng-repeat="data in vm.allEmployeeData"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{data.employeeInfo.employeeOfficeId == null ? "" : data.employeeInfo.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="data.employeeInfo.employeeName" picture-url="data.employeeInfo.profilePictureUrl" department-name="data.employeeInfo.departmentName" designation-name="data.employeeInfo.designationName" id="data.employeeInfo.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="data.employeeInfo.employmentTypeName?\'text-center\':\'color-999999 text-center\'">{{data.employeeInfo.employmentTypeName?data.employeeInfo.employmentTypeName:\'Not Set\'}}</td><td class="text-left" ng-class="data.employeeInfo.workplaceName?\'text-left\':\'color-999999 text-left\'">{{data.employeeInfo.workplaceName?data.employeeInfo.workplaceName:\'Not Set\'}}</td><td class="text-leftr">{{data.componentName}}</td><td class="text-right">{{data.amount}}</td><td class="text-left"><span ng-repeat="remark in data.remarkList">{{remark}}<br></span></td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.editComponent(data)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(data.employeeId, data.componentId, vm.searchParams)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table><div ng-if="vm.allEmployeeData.length <= 0 && vm.isDataLoaded" class="d-flex-gap-10 justify-center flex-col align-items-center mt-40"><img src="../assets/img/upload-62.png" alt="upload image"><p class="gray-text">No additional salary component are yet uploaded for the month of <strong>{{vm.fromMonthName}}, {{vm.searchParams.fromYear}} - {{vm.toMonthName}}, {{vm.searchParams.toYear}}</strong></p><p class="gray-text">You can add additional component for individuals, or can upload an Excel file to load them in batch. Download the sample file to upload from Excel</p></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" hide-no-data-message="true"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/bankPaymentAdvice/bankPaymentAdvice.html','<style>\n.gray-row th{\n    background: #e0e0e0 !important;\n}\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{vm.panelTitle}}" ba-panel-class="with-scroll panel-full-screen"><div class="row"><div class="col-md-2"><label class="text-capitalize" translate="">{{\'bankPaymentAdvice.salaryMonth\'}}</label><div class="input-group mb-0 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.salaryMonthPicker.format}}" datepicker-options="vm.salaryMonthPicker.options" ng-model="vm.selectedMonth" is-open="vm.salaryMonthPicker.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openSalaryMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row mt-15" ng-if="vm.isDataLoaded"><div class="col-md-12"><table class="table borderless-table even-row-strip"><thead><tr ng-class="{\'gray-row\': vm.isApproved === false}"><th class="width-3 text-center" translate="">sl</th><th class="text-left" translate="">bankName</th><th class="text-center" translate="">numberOfEmployees</th><th class="text-right" translate="">netPayment</th><th class="text-right" translate="">bankPayment</th><th class="text-right" translate="">cashPayment</th><th class="width-7 text-center" translate="">actions</th></tr></thead><tbody ng-if="vm.isApproved"><tr ng-repeat="bankInfo in vm.bankAdviceList" class="border-bottom-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{bankInfo.bankName}}</td><td class="text-center">{{bankInfo.numberOfEmployees}}</td><td class="text-right">{{bankInfo.netPayment | number:(2)}}</td><td class="text-right">{{bankInfo.bankPayment | number:(2)}}</td><td class="text-right">{{bankInfo.cashPayment | number:(2)}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="payroll.individualBankPaymentAdvice({bankId: bankInfo.bankId, monthlySalaryId: bankInfo.monthlySalaryId})"><i class="ion-eye"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.viewButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.downloadAdviceLetter(bankInfo)"><i class="ion-android-download"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.downloadForwardingLetterButton\'}}</span></button></td></tr></tbody></table><div ng-if="vm.isApproved" class="row mb-300"></div><div class="row text-center mt-50 mb-200" ng-if="vm.isApproved === false"><div class="col-md-12"><h3 class="gray-text">{{vm.notYetApprovedText}}</h3><button type="button" ng-click="vm.viewPreviousHistory()" class="btn btn-md btn-primary mt-10">{{\'bankPaymentAdvice.viewPreviousButton\' | translate}}{{vm.lastMonthText}}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/payrollSettings/editPayrollComponent/editPayrollComponents.html','<style>\n    .section-border{\n        border: 1px solid #e8e8e8;\n    }\n    .section-bg{\n        background: #f3f3f3;\n    }\n    .section-bg-white{\n        background: white;\n    }\n    .section-margin-top{\n        margin-top: 15%;\n    }\n    .btn-position{\n        position: absolute;\n        right: 0;\n        top: 50px;\n    }\n    .borderless-input-field{\n        cursor: default;\n        border: none!important;\n        height: 20px!important;\n    }\n    .form-control[disabled]{\n        color: #555555!important;\n        cursor: default!important;\n    }\n    .footer-position{\n        position: absolute;\n        top: 250px;\n        right: 20px;\n    }\n    .section-min-height{\n        min-height: 450px;\n    }\n    @media (max-width: 984px) {\n        .section-min-height{\n            min-height: 200px;\n        }\n    }\n</style><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'salaryComponentSettings.componentPolicySettings\' | translate}}"><div class="row mb-25"><div class="col-md-6"><div class="col-md-12 section-border"><div class="row"><div class="col-md-6 mt-10"><label class="required" translate="">{{\'payrollSettings.componentCode\'}}</label> <input type="text" class="form-control" ng-model="vm.officePayrollComponent.code"></div><div class="col-md-6 mt-10"><label class="required" translate="">{{\'payrollSettings.componentName\'}}</label> <input type="text" class="form-control" ng-if="vm.nameEditable" ng-model="vm.officePayrollComponent.name"> <input type="text" class="form-control" ng-class="{\'dark-bg\':!vm.nameEditable}" ng-if="!vm.nameEditable" ng-model="vm.officePayrollComponent.name" ng-disabled="vm.officePayrollComponent.name"></div></div><div class="row"><div class="col-md-6 mt-15"><label class="required" translate="">{{\'payrollSettings.componentType\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.componentType" ng-model="vm.officePayrollComponent.type"></select></div></div><div class="col-md-6 mt-15"><label class="required" translate="">{{\'payrollSettings.componentCategory\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.componentCategory" ng-model="vm.officePayrollComponent.category"></select></div></div></div><div class="row"><div class="col-md-6 mt-15"><label class="required" translate="">{{\'salaryComponentSettings.componentGroup\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.componentGroup" ng-model="vm.officePayrollComponent.group"></select></div></div><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.parentComponent\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.parentComponent" ng-model="vm.officePayrollComponent.valueDeterminer"></select></div></div></div><div class="row"><div class="col-md-6 mt-15"><label translate="">{{\'payrollSettings.valueType\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.valueType" ng-model="vm.officePayrollComponent.valueType"></select></div></div><div class="col-md-6 mt-15"><label translate="" ng-if="vm.officePayrollComponent.valueType == 1">{{\'salaryComponentSettings.calculationPercentage\'}}</label> <label translate="" ng-if="vm.officePayrollComponent.valueType == 2">{{\'salaryComponentSettings.calculationFixedAmount\'}}</label> <input type="text" class="form-control" ng-model="vm.officePayrollComponent.value" ng-if="vm.officePayrollComponent.valueType != 3"></div></div><div class="row"><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.considerInGrossSalaryCalculation\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.options" ng-model="vm.officePayrollComponent.inclusiveToGross"></select></div></div><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.confirmationBenefit\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.options" ng-model="vm.officePayrollComponent.isConfirmationBenefit"></select></div></div></div><div class="row mt-15"><div class="col-md-6 mb-15"><label translate="">{{\'employeesBatchCreation.employeesTableHeader.paymentMethod\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.paymentMode" ng-model="vm.officePayrollComponent.paymentMode"></select></div></div><div class="col-md-6 mb-15"><label translate="">{{\'salaryComponentSettings.noOfTimeInstallment\'}}</label> <input type="text" class="form-control" ng-model="vm.officePayrollComponent.installment"></div></div><div class="col-md-12 mt-10 mb-15"><div class="row"><div class="col-md-8 pl-0"><span class="d-inline-block text-bold mb-3" translate="">inactive</span> <label class="custom-switch ml-20"><input name="enabled" ng-model="vm.status" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">active</strong></span></div></div></div></div></div><div class="col-md-6 mb-10"><div class="section-min-height"><div ng-if="vm.officePayrollComponent.group == 2"><div class="col-md-12 section-border section-bg"><div class="row mt-10"><div class="col-md-6"><label translate="">{{\'salaryComponentSettings.componentDistribution\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.options" ng-model="vm.componentDistribution"></select></div></div></div><div class="row mt-15"><div class="col-md-12"><div class="d-flex-space-between"><div><h4>{{\'salaryComponentSettings.componentInformationHeading\' | translate}}</h4></div><div><button class="btn btn-md-with-icon btn-secondary" ng-click="vm.addNewRow()"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-3" translate="">{{\'commonKeywords.addNewButton\'}}</span></button></div></div></div></div><div class="row mt-10 mb-20"><div class="col-md-12"><table class="table borderless-table section-bg-white"><thead><tr><th class="text-left">{{\'salaryComponentSettings.componentsToBeDistributed\' | translate}}</th><th class="text-center">{{\'salaryComponentSettings.noOfDays\' | translate}}</th><th class="text-center" translate="">{{ \'leaveCategorySettings.tableHeader.action\' }}</th></tr></thead><tbody ng-repeat="data in vm.componentDistributionList"><tr ng-if="!data.isAddable" class="border-bottom-1"><td class="text-left">{{data.associatedComponent.name}}</td><td class="text-center width-7">{{data.dayCount}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.deleteDistributionComponent(data, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr><tr ng-if="data.isAddable" class="border-bottom-1"><td class="text-left"><div class="custom-select"><select ng-options="v.id as v.name for v in vm.payrollComponentName" ng-model="data.associatedComponentId"></select></div></td><td class="text-center width-7"><input type="number" class="form-control" ng-disabled="!data.isAddable" ng-class="{\'borderless-input-field\':!data.isAddable}" ng-model="data.dayCount"></td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.deleteDistributionComponent(data, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div></div></div></div><div class="col-md-12"><div class="row"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="payroll.payrollSettings" translate="">{{ \'commonKeywords.closeButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.saveComponentSettings()" translate="">{{ \'commonKeywords.saveSettingButton\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/payrollSettings/modals/success.modal.html','<style>\n    img{\n        height: 53px;\n        width: 53px;\n    }\n    .mt-negative-10{\n        margin-top: -10px;\n    }\n    .color-33BB7B{\n        color: #33BB7B;\n    }\n    .footer-mt{\n        margin-top: 35px!important;\n    }\n    @media (min-width: 768px) {\n        .modal-dialog {\n            width: 475px;\n        }\n    }\n    .footer-mt{\n        margin-top: 25px!important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close mt-negative-20" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div class="col-md-12"><div class="text-center mt-negative-10 mb-10"><img src="../assets/img/Success.png"></div><div class="text-center-important"><h1 class="font-25 text-bold color-33BB7B mb-15" translate="">success</h1><p class="font-weight-500" translate="">{{ vm.successMsg }}</p></div></div></div><div class="footer footer-mt"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/payrollSettings/partials/setUpPayrollComponents.html','<style>\n    .section-style {\n        border:2px solid #f3f1f1;\n        background: #f8f8f8;\n        padding: 20px 20px;\n    }\n    .borderless tr td{\n        border: 0px !important;\n    }\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 5px !important;\n    }\n    .padding-on-select .custom-select select {\n        padding: 6px 15px!important;\n    }\n\n</style><div class="col-md-12 col-lg-9"><div ba-panel="" ba-panel-title="Set Up Payroll Components" class="mb-50"><div class="row" ng-if="!vm.openPayrollCreateSection"><div class="col-md-8 text-center"><h3 translate="">{{\'payrollSettings.dontHavePayrollSettingsHeading\'}}</h3></div><div class="col-md-4 text-right mb-23"><button class="btn btn-primary" ng-click="vm.showCreatePayrollSettingsSection()"><i class="ion-android-add-circle font-20 mr-3"></i> <span class="pb-2" translate="">{{\'payrollSettings.createPayrollSettingsButton\'}}</span></button></div></div><div class="section-style" ng-if="!!vm.openPayrollCreateSection"><div class="row"><div class="col-md-12"><h5 class="text-uppercase required" translate="">{{\'payrollSettings.selectPayrollType\'}}</h5><div class="custom-select"><select ng-options="v.value as v.name for v in vm.payrollType" ng-model="vm.selectedPayrollType"></select></div></div></div><div class="row mt-20"><div class="col-md-12"><table class="table borderless"><colgroup><col class="width-24"><col class="width-16"><col class="width-16"><col class="width-21"><col class="width-11"><col class="width-12"></colgroup><thead><tr class="row-height font-adjust height-5-vh"><th class="text-left text-uppercase required" translate="">{{\'payrollSettings.componentName\'}}</th><th class="text-left text-uppercase required" translate="">{{\'payrollSettings.componentCategory\'}}</th><th class="text-left text-uppercase required" translate="">{{\'payrollSettings.valueType\'}}</th><th class="text-left text-uppercase required" translate="">{{\'payrollSettings.percentageOf\'}}</th><th class="text-left text-uppercase required" translate="">{{\'payrollSettings.value\'}}</th><th class="text-left text-uppercase required" translate="">{{\'payrollSettings.status\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.payrollSettingsData" class="padding-on-select"><td class="text-left pl-0-important"><input type="text" class="form-control text-visible" ng-disabled="!data.nameEditable" ng-model="data.name"></td><td class="text-left"><div class="custom-select"><select ng-options="v.value as v.name for v in vm.categories" ng-model="data.category"></select></div></td><td class="text-left"><div class="custom-select"><select ng-options="v.value as v.name for v in vm.valueTypes" ng-model="data.valueType"></select></div></td><td class="text-left"><div ng-if="data.valueType === 1"><div class="custom-select"><select ng-options="v.value as v.name for v in vm.valueDeterminer" ng-model="data.valueDeterminer"></select></div></div><div ng-if="data.valueType !== 1"><div class="custom-select"><select ng-disabled="true" class="cursor-not-allowed"><option translate="">{{\'commonKeywords.na\'}}</option></select></div></div></td><td class="text-left"><input type="text" ng-if="data.valueType == 1" class="form-control" ng-model="data.value" percent-add=""> <input type="text" ng-if="data.valueType == 2" class="form-control" ng-model="data.value"> <input type="text" ng-if="data.valueType === 3" class="form-control" ng-model="data.value" readonly="" disabled=""></td><td class="text-left pr-0-important"><div class="custom-select"><select ng-options="v.value as v.name for v in vm.status" ng-model="data.status"></select></div></td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-12 text-right"><button class="btn btn-primary" ng-click="vm.addNewRow()"><i class="ion-android-add-circle font-21 mr-3"></i> <span class="ml-negative-5 pb-3" translate="">{{\'payrollSettings.addNewComponentButton\'}}</span></button></div></div><div class="row mt-150"><div class="col-md-12 text-right"><button class="btn btn-md btn-primary" ng-click="vm.createPayrollSettings()" ng-disabled="vm.isCreateSettingsBtnClicked" translate="">{{\'payrollSettings.saveSettingsButton\'}}</button></div></div></div><div class="row mt-50"><div class="col-md-12"></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/payrollSettings/partials/viewPayrollComponents.html','<style>\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 5px !important;\n    }\n    .panel .panel-body{\n        min-height: 750px;\n    }\n    .report-container {\n        max-height: 60vh;\n    }\n    .report-table > tbody > tr:nth-of-type(odd) {\n        background-color: #ffffff;\n    }\n</style><div ba-panel="" ba-panel-title="Payroll Components" class="col-md-12"><div class="row"><div class="col-md-12"><table class="table borderless-table"><tr class="height-5-vh"><td class="bg-f8f8f8"><strong class="font-15">{{vm.selectedPayrollType == 1 ? \'Gross Salary Driven\' : \'Basic Salary Driven\'}}</strong></td></tr></table></div></div><div class="row mt-10"><div class="col-md-12"><button class="btn btn-md-with-icon btn-primary" ui-sref="payroll.salaryComponentSettings({settingsId:vm.payrollSettingsId})"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-3" translate="">{{\'payrollSettings.addNewComponentButton\'}}</span></button></div></div><div class="row mt-20 mb-25"><div class="col-md-12 horizontal-scroll report-container" ng-if="vm.isDataLoaded" fixed-column-table="" fixed-columns="0"><table class="table report-table borderless-table even-row-strip"><thead><tr><th class="width-16 text-left" translate="">{{\'payrollSettings.componentName\'}}</th><th class="width-13 text-left" translate="">{{\'payrollSettings.componentType\'}}</th><th class="width-12 text-center" translate="">{{\'payrollSettings.componentCategory\'}}</th><th class="text-center" translate="">{{\'payrollSettings.valueType\'}}</th><th class="width-12 text-center" translate="">{{\'payrollSettings.percentageOf\'}}</th><th class="text-center" translate="">{{\'payrollSettings.value\'}}</th><th class="text-center" translate="">{{\'payrollSettings.status\'}}</th><th class="text-center" translate="">{{\'payrollSettings.action\'}}</th></tr></thead><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><tbody ng-if="!!vm.isDataLoaded"><tr class="height-5-vh" ng-repeat="data in vm.payrollSettingsData"><td class="text-left">{{data.name}}</td><td class="text-left"><span ng-if="data.type == 1">{{\'payrollSettings.basicPay\' |translate}}</span> <span ng-if="data.type == 2">{{\'payrollSettings.allowance\' | translate}}</span> <span ng-if="data.type == 3">{{\'payrollSettings.longTermBenefit\' | translate}}</span> <span ng-if="data.type == 4">{{\'payrollSettings.nonCashBenefit\' | translate}}</span> <span ng-if="data.type == 5">{{\'payrollSettings.additional\' | translate}}</span> <span ng-if="data.type == 6">{{\'payrollSettings.bonus\' | translate}}</span> <span ng-if="data.type == 7">{{\'payrollSettings.arrears\' | translate}}</span> <span ng-if="data.type == 8">{{\'payrollSettings.lwpDeduction\' | translate}}</span> <span ng-if="data.type == 9">{{\'payrollSettings.absentDeduction\' | translate}}</span> <span ng-if="data.type == 10">{{\'payrollSettings.incomeTaxDeduction\' | translate}}</span> <span ng-if="data.type == 11">{{\'payrollSettings.loanDeduction\' | translate}}</span></td><td class="text-center"><span ng-if="data.category == 1" translate="">{{\'payrollSettings.addition\'}}</span> <span ng-if="data.category == -1" translate="">{{\'payrollSettings.deduction\'}}</span></td><td class="text-center"><span ng-if="data.valueType == 1" translate="">{{\'payrollSettings.percentage\'}}</span> <span ng-if="data.valueType == 2" translate="">{{\'payrollSettings.fixed\'}}</span> <span ng-if="data.valueType == 3" translate="">{{\'payrollSettings.variable\'}}</span></td><td class="text-center"><span ng-if="data.valueDeterminer == 0" translate="">none</span> <span ng-if="data.valueDeterminer == 1" ng-class="data.valueType === 1 ?\'text-center\':\'color-999999 text-center\'">{{data.valueType === 1 ? \'Gross Salary\':\'N/A\'}}</span> <span ng-if="data.valueDeterminer == 2" ng-class="data.valueType === 1 ?\'text-center\':\'color-999999 text-center\'">{{data.valueType === 1 ? \'Basic Salary\':\'N/A\'}}</span></td><td ng-if="data.valueType !== 3" class="text-center">{{data.value}}{{data.valueType == 1 ? \'%\':\'\'}}</td><td ng-if="data.valueType == 3" class="text-center color-999999" translate="">na</td><td class="text-center"><span class="text-success" ng-if="data.status == \'1\'" translate="">{{\'payrollSettings.active\'}}</span> <span class="text-danger" ng-if="data.status == \'0\'" translate="">{{\'payrollSettings.inactive\'}}</span></td><td class="text-center width-7"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="payroll.editPayrollComponent({componentId: data.id})"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/payroll/payrollSettings/salaryComponentSettings/salaryComponentSettings.html','<style>\n    .section-border{\n        border: 1px solid #e8e8e8;\n    }\n    .section-bg{\n        background: #f3f3f3;\n    }\n    .section-bg-white{\n        background: white;\n    }\n    .btn-position{\n        position: absolute;\n        right: 0;\n        top: 50px;\n    }\n    .borderless-input-field{\n        cursor: default;\n        border: none!important;\n        height: 20px!important;\n    }\n    .form-control[disabled]{\n        color: #555555!important;\n        cursor: default!important;\n    }\n    .section-min-height{\n        min-height: 450px;\n    }\n    @media (max-width: 984px) {\n        .section-min-height{\n            min-height: 200px;\n        }\n    }\n</style><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'salaryComponentSettings.componentPolicySettings\' | translate}}"><div class="row mb-25"><div class="col-md-6"><div class="col-md-12 section-border"><div class="row"><div class="col-md-6 mt-10"><label class="required" translate="">{{\'payrollSettings.componentCode\'}}</label> <input type="text" class="form-control" placeholder="Enter component code" ng-model="vm.officePayrollComponent.code"></div><div class="col-md-6 mt-10"><label class="required" translate="">{{\'payrollSettings.componentName\'}}</label> <input type="text" class="form-control" placeholder="Enter component name" ng-model="vm.officePayrollComponent.name"></div></div><div class="row"><div class="col-md-6 mt-15"><label class="required" translate="">{{\'payrollSettings.componentType\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.componentType" ng-model="vm.officePayrollComponent.type"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6 mt-15"><label class="required" translate="">{{\'payrollSettings.componentCategory\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.componentCategory" ng-model="vm.officePayrollComponent.category"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div></div><div class="row"><div class="col-md-6 mt-15"><label class="required" translate="">{{\'salaryComponentSettings.componentGroup\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.componentGroup" ng-model="vm.officePayrollComponent.group"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.parentComponent\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.parentComponent" ng-model="vm.officePayrollComponent.valueDeterminer"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div></div><div class="row"><div class="col-md-6 mt-15"><label translate="">{{\'payrollSettings.valueType\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.valueType" ng-model="vm.officePayrollComponent.valueType"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6 mt-15" ng-if="vm.officePayrollComponent.valueType ==1 || vm.officePayrollComponent.valueType==2"><label translate="" ng-if="vm.officePayrollComponent.valueType == 1">{{\'salaryComponentSettings.calculationPercentage\'}}</label> <label translate="" ng-if="vm.officePayrollComponent.valueType == 2">{{\'salaryComponentSettings.calculationFixedAmount\'}}</label><input type="text" class="form-control" ng-model="vm.officePayrollComponent.value"></div></div><div class="row"><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.considerInGrossSalaryCalculation\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.options" ng-model="vm.officePayrollComponent.inclusiveToGross"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.confirmationBenefit\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.options" ng-model="vm.officePayrollComponent.isConfirmationBenefit"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div></div><div class="row mb-15"><div class="col-md-6 mt-15"><label translate="">{{\'employeesBatchCreation.employeesTableHeader.paymentMethod\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.paymentMode" ng-model="vm.officePayrollComponent.paymentMode"><option value="" disabled="">{{\'pleaseSelect\' | translate}}</option></select></div></div><div class="col-md-6 mt-15"><label translate="">{{\'salaryComponentSettings.noOfTimeInstallment\'}}</label> <input type="number" class="form-control" placeholder="Enter number" ng-model="vm.officePayrollComponent.installment"></div></div><div class="col-md-12 mt-10 mb-15"><div class="row"><div class="col-md-8 pl-0"><span class="d-inline-block text-bold mb-3" translate="">inactive</span> <label class="custom-switch ml-20"><input name="enabled" ng-model="vm.status" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">active</strong></span></div></div></div></div></div><div class="col-md-6 mb-10"><div class="section-min-height"><div ng-if="vm.officePayrollComponent.group == 2"><div class="col-md-12 section-border section-bg"><div class="row mt-10"><div class="col-md-6"><label translate="">{{\'salaryComponentSettings.componentDistribution\'}}</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.options" ng-model="vm.componentDistribution"></select></div></div></div><div class="row mt-15"><div class="col-md-12"><div class="d-flex-space-between"><div><h4>{{\'salaryComponentSettings.componentInformationHeading\' | translate}}</h4></div><div><button class="btn btn-md-with-icon btn-secondary" ng-click="vm.addNewRow()"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-3" translate="">{{\'commonKeywords.addNewButton\'}}</span></button></div></div></div></div><div class="row mt-10 mb-20"><div class="col-md-12"><table class="table borderless-table section-bg-white"><thead><tr><th class="text-left">{{\'salaryComponentSettings.componentsToBeDistributed\' | translate}}</th><th class="text-center">{{\'salaryComponentSettings.noOfDays\' | translate}}</th><th class="text-center" translate="">{{ \'leaveCategorySettings.tableHeader.action\' }}</th></tr></thead><tbody ng-repeat="data in vm.componentDistributionList"><tr ng-if="!data.isAddable" class="border-bottom-1"><td class="text-left">{{data.associatedComponent.name}}</td><td class="text-center width-7">{{data.dayCount}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.deleteDistributionComponent(data, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr><tr ng-if="data.isAddable" class="border-bottom-1"><td class="text-left"><div class="custom-select"><select ng-options="v.id as v.name for v in vm.payrollComponentName" ng-model="data.associatedComponentId"></select></div></td><td class="text-center width-7"><input type="number" class="form-control" ng-disabled="!data.isAddable" ng-class="{\'borderless-input-field\':!data.isAddable}" ng-model="data.dayCount"></td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.deleteDistributionComponent(data, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div></div></div></div></div><div class="col-md-12"><div class="row"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="payroll.payrollSettings" translate="">{{ \'commonKeywords.closeButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.saveComponentSettings()" translate="">{{ \'commonKeywords.saveSettingButton\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/providentFundAccountManagement.html','<style>\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table > thead > tr > th:last-child {\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-right: 5px !important;\n    }\n    .panel.with-scroll .panel-body {\n        height: calc(100vh - 250px);\n        overflow-y: auto;\n    }\n    .accounting-year-placement{\n        position: absolute;\n        top:2%;\n        right: 2%;\n        min-width: 150px;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'providentFund.pFAccountManagement\' | translate}}" ba-panel-class="with-scroll" class="col-md-12 position-relative"><div class="accounting-year-placement"><span class="font-weight-500 color-22222 font-15">Accounting Period: {{vm.accountingYear.accountStartMonthShort}} - {{vm.accountingYear.accountEndMonthShort}}</span></div><div class="row mt-20 mb-25"><div class="col-md-12"><table class="table borderless-table even-row-strip"><thead><tr class="height-45"><th class="text-center width-10" translate="">{{\'providentFund.accountingYear\'}}</th><th class="text-right" translate="">{{\'providentFund.openingBalance\'}}</th><th class="text-right" translate="">{{\'providentFund.contributionDuringTheYear\'}}</th><th class="text-right" translate="">{{\'providentFund.interestDuringTheYear\'}}</th><th class="text-right" translate="">{{\'providentFund.totalPFBalance\'}}</th><th class="text-center width-6" translate="">{{\'providentFund.action\'}}</th></tr></thead><tbody ng-if="vm.isDataLoaded && vm.pfAccountSummmaryData.length > 0"><tr class="border-bottom-1" ng-repeat="data in vm.pfAccountSummmaryData"><td class="text-center">{{data.accountingYear}}</td><td class="text-right">{{data.openingBalance | number:2}}</td><td class="text-right">{{data.totalContribution | number:2}}</td><td class="text-right" translate="">{{data.totalInterest | number:2}}</td><td class="text-right" translate=""><span>{{data.totalBalance | number:2}}</span></td><td class="text-center"><button class="btn btn-sm btn-secondary" ui-sref="payroll.providentFundAccountDetails({pfAccountInfo : data})"><span class="" translate="">{{\'commonKeywords.viewButton\'}}</span></button></td></tr></tbody></table><div ng-if="vm.isDataLoaded && !vm.pfAccountSummmaryData.length"><p class="mt-10 text-center font-15"><em translate="">noDataFound</em></p></div><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundMember/providentFundMember.html','<style>\n    .panel.with-scroll .panel-body {\n        height: calc(100vh - 190px);\n        overflow-y: auto;\n    }\n</style><div ba-panel="" ba-panel-title="PF Member" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.searchByNameId()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div></div><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'active\'}" ng-click="vm.switchTab(\'active\')" translate="">{{\'providentFund.active\'}}</button> <button type="button" class="btn btn-style dont-wrap-text" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'pending\' }" ng-click="vm.switchTab(\'pending\')" translate="">{{\'providentFund.pending\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'separated\'}" ng-click="vm.switchTab(\'separated\')" translate="">{{\'providentFund.separated\'}}</button></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/payroll/providentFund/providentFundMember/partials/employeesTable.html"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getPFMembers" not-found-text="\'No data available\'"></pagination-directive></div><div class="col-md-6"><div class="row"><div class="col-md-12"><div class="d-flex-space-between"><div><h3 class="text-adjust pt-10 pr-10 mb-0">{{\'providentFund.PFMemberDetails\' | translate}}</h3></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div></div></div></div><div ng-if="vm.isAnyRowSelected" include-with-scope="app/pages/main/payroll/providentFund/providentFundMember/partials/memberInfoSection.html"></div><div class="row position-relative" ng-if="!vm.isAnyRowSelected" ng-class="{\'unselected\': vm.isAnyRowSelected == false}"><div class="col-md-12" include-with-scope="app/pages/main/payroll/providentFund/providentFundMember/partials/dummyTable.html"></div></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundStatement/providentFundStatement.html','<style>\n    #employeeNameSearchBox input::placeholder{\n        font-size: 13px;\n    }\n    .pf-table tr{\n        height: 45px;\n    }\n\n    .table thead tr th {\n        white-space: normal !important;\n    }\n    .table > thead > tr > th:last-child {\n        padding-right: 7px !important;\n    }\n    .table > tbody> tr > td:last-child {\n        padding-right: 7px !important;\n    }\n    .accounting-year-placement{\n       position: absolute;\n        top:4%;\n        right:1%;\n        min-width: 150px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'providentFund.pfStatement\' | translate }}" class="position-relative"><div class="accounting-year-placement"><span class="font-weight-500 color-22222 font-15">Account Period: {{vm.accountingYear.accountStartMonthShort}} - {{vm.accountingYear.accountEndMonthShort}}</span></div><div class="d-flex-space-between"><div class="d-flex-gap-10"><div><span class="d-inline-block mb-5 color-22222 font-12" translate="">searchEmployee</span><div id="employeeNameSearchBox"><employee-type-ahead-search keyword="vm.keyword" select-method="vm.searchByEmployee"></employee-type-ahead-search></div></div><div><span class="d-inline-block mb-5 color-22222 font-12" translate="">from</span><div class="filter-inline-item"><div class="input-group mb-0 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerFrom.format}}" datepicker-options="vm.monthPickerFrom.options" ng-model="vm.selectedMonthFrom" is-open="vm.monthPickerFrom.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPickerFrom()"><i class="fa fa-calendar"></i></button></span></div></div></div><div><span class="d-inline-block mb-5 color-22222 font-12" translate="">to</span><div class="filter-inline-item"><div class="input-group mb-0 table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerTo.format}}" datepicker-options="vm.monthPickerTo.options" ng-model="vm.selectedMonthTo" is-open="vm.monthPickerTo.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPickerTo()"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="ml-20"><button class="btn btn-md-with-icon btn-primary padding-7-12 dropdown-toggle font-13" ng-click="vm.exportAsPdf()"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div><div><div class="row mt-10" ng-if="vm.isDataLoaded"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">employeeId</td><td class="col-stripe-dark">{{!vm.pfStatementOfEmployee.id ? \'Not set\' : vm.pfStatementOfEmployee.id}}</td><td translate="">employeeName</td><td class="col-stripe-dark">{{!vm.pfStatementOfEmployee.name ? \'Not set\' : vm.pfStatementOfEmployee.name}}</td><td translate="">joiningDate</td><td class="col-stripe-dark">{{!vm.pfStatementOfEmployee.dateOfJoinFormatted ? \'Not set\' : vm.pfStatementOfEmployee.dateOfJoinFormatted}}</td></tr><tr class="text-bold"><td translate="">membershipDate</td><td class="col-stripe-dark">{{!vm.pfStatement.memberInfo.membershipDate ? \'Not set\' : vm.pfStatement.memberInfo.membershipDate}}</td><td translate="">separationDate</td><td class="col-stripe-dark">{{!vm.pfStatement.memberInfo.separationDate ? \'Not set\' : vm.pfStatement.memberInfo.separationDate}}</td></tr></tbody></table></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="mt-15"><div><table class="table borderless-table even-row-strip pf-table"><thead><tr><th class="text-center" translate="">{{\'providentFund.month\'}}</th><th class="text-right" translate="">{{\'providentFund.membersSubscription\'}}</th><th class="text-right" translate="">{{\'providentFund.interestOnMembersSubscription\'}}</th><th class="text-right" translate="">{{\'providentFund.companysContribution\'}}</th><th class="text-right" translate="">{{\'providentFund.interestOnCompanysContribution\'}}</th><th class="text-right" translate="">{{\'providentFund.totalContribution\'}}</th><th class="text-right" translate="">{{\'providentFund.PFLoan\'}}</th><th class="text-right" translate="">{{\'providentFund.PFLoanRecovered\'}}</th><th class="text-right" translate="">{{\'providentFund.PFBalance\'}}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-if="vm.pfStatement.openingBalancePresent"><td class="text-center">Opening Balance</td><td class="text-right">{{vm.pfStatement.openingTotalSubscription | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalSubscriptionInterest | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalCompanyContribution | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalCompanyContributionInterest | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalContribution | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalPFLoan | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalPFLeanRecovered | number:2}}</td><td class="text-right">{{vm.pfStatement.openingTotalPFBalance | number:2}}</td></tr><tr ng-repeat="data in vm.pfStatement.statementList"><td class="text-center">{{data.monthYearInMillis | date:\'MMM yyyy\'}}</td><td class="text-right">{{data.memberContribution | number:2}}</td><td class="text-right">{{data.memberInterest | number:2}}</td><td class="text-right">{{data.companyContribution | number:2}}</td><td class="text-right">{{data.companyInterest | number:2}}</td><td class="text-right">{{vm.getTotalContribution(data) | number:2}}</td><td class="text-right">{{data.loanAmount | number:2}}</td><td class="text-right">{{data.recoveredLoanAmount | number:2}}</td><td class="text-right">{{data.balance | number:2}}</td></tr><tr style="background: #e0e0e0" class="font-weight-500 color-22222" ng-if="vm.pfStatement.statementList.length !== 0"><td class="text-center" translate="">total</td><td class="text-right">{{vm.pfStatement.totalSubscription | number:2}}</td><td class="text-right">{{vm.pfStatement.totalSubscriptionInterest | number:2}}</td><td class="text-right">{{vm.pfStatement.totalCompanyContribution | number:2}}</td><td class="text-right">{{vm.pfStatement.totalCompanyContributionInterest | number:2}}</td><td class="text-right">{{vm.pfStatement.totalContribution | number:2}}</td><td class="text-right">{{vm.pfStatement.totalPFLoan | number:2}}</td><td class="text-right">{{vm.pfStatement.totalPFLeanRecovered | number:2}}</td><td class="text-right">{{vm.pfStatement.totalPFBalance | number:2}}</td></tr></tbody></table><div ng-if="vm.isDataLoaded && vm.pfStatement.statementList.length == 0" class="mt-10 text-center"><span class="font-15"><em>No statement found</em></span></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getPFStatement" hide-no-data-message="true"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryManagement/batchUploadConfirmation/batchUploadConfirmation.html','<style>\n    .import-status-table {\n        max-height: 45vh;\n        overflow-y: auto;\n    }\n    .error {\n        background-color: rgba(232, 86, 86, 0.2);\n    }\n\n    .panel-full-screen {\n        max-height: 80vh;\n        position: relative;\n        overflow-y: auto;\n    }\n\n    .batch-upload-confirmation-table > td, th {\n        text-overflow: ellipsis;\n    }\n    .td-break{\n        word-break: break-all;\n    }\n\n</style><div ba-panel="" ba-panel-title="Uploaded File Information" ba-panel-class="with-scroll panel-full-screen"><div class="row d-flex-center-center-inherit" ng-if="!vm.isVerificationDone"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isVerificationDone"><div class="row"><div class="col-md-12"><div class="import-status-table"><p class="text-warning text-uppercase" translate="">{{\'employeesBatchCreation.informationChanged\'}}</p><div><table class="table table-bordered batch-upload-confirmation-table"><colgroup><col class="width-3"><col class="width-4"><col class="width-18"><col class="width-19"><col class="width-10"><col class="width-8"><col class="width-8"><col class="width-10"><col class="width-10"><col class="width-10"></colgroup><thead><tr><td class="headers2 text-center" translate="">{{\'commonKeywords.sl\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.id\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.employeeName\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.email\'}}</td><th class="headers2 text-center" translate="">{{\'payrollManagement.dateOfJoining\'}}</th><th class="headers2 text-center">{{vm.payrollType === 1 ? "Gross " : "Basic "}} <span translate="">{{\'employeesBatchCreation.employeesTableHeader.salary\'}}</span></th><td class="headers2 text-center dont-wrap-text" translate="">{{\'employeesBatchCreation.employeesTableHeader.paymentMethod\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.bankName\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.accountNumber\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.routingNumber\'}}</td></tr></thead><tbody ng-if="vm.existingEmployees == null || vm.existingEmployees.length === 0"><tr><td colspan="10" class="text-center"><em translate="">{{\'employeesBatchCreation.employeesWithNoChangeText\'}}</em></td></tr></tbody><tbody ng-if="vm.existingEmployees != null && vm.existingEmployees.length > 0"><tr ng-repeat="employee in vm.existingEmployees" ng-class="{error : employee.hasError}" data-toggle="tooltip" uib-tooltip="{{vm.getTooltipText(employee.row.errorMessages)}}" tooltip-placement="top" tooltip-enable="employee.hasError" tooltip-append-to-body="true"><td class="text-center">{{$index+1}}</td><td class="text-center" ng-class="{modified: employee.isEmployeeOfficeIdChanged}">{{employee.row.employeeOfficeId}}</td><td class="text-center"><employee-picture-and-information name="employee.row.employeeName" picture-url="employee.pictureUrl" department-name="employee.row.departmentName" designation-name="employee.row.designationName" is-clickable="false" is-department-changed="employee.isDepartmentChanged" is-designation-changed="employee.isDesignationChanged"></employee-picture-and-information></td><td class="text-left td-break">{{employee.row.email}}</td><td class="text-center" ng-class="{modified: employee.isDateOfJoinChanged}">{{employee.row.dateOfJoin | date:\'dd MMM yyyy\'}}</td><td class="text-center" ng-class="{modified: employee.isSalaryChanged}">{{employee.row.salary}}</td><td class="text-center" ng-class="{modified: employee.isPaymentModeChanged}">{{employee.row.paymentMode}}</td><td class="text-center" ng-class="{modified: employee.isBankNameChanged}">{{employee.row.bankName}}</td><td class="text-center" ng-class="{modified: employee.isAccountNumberChanged}">{{employee.row.accountNumber}}</td><td class="text-center" ng-class="{modified: employee.isRoutingNumberChanged}">{{employee.row.routingNumber}}</td></tr></tbody></table></div></div></div></div><br><br><br><div class="row"><div class="col-md-12"><div class="import-status-table"><p class="text-success text-uppercase" translate="">{{\'employeesBatchCreation.newEmployee\'}}</p><div><table class="table table-bordered batch-upload-confirmation-table"><colgroup><col class="width-3"><col class="width-4"><col class="width-18"><col class="width-19"><col class="width-10"><col class="width-8"><col class="width-8"><col class="width-10"><col class="width-10"><col class="width-10"></colgroup><thead><tr><td class="headers2 text-center" translate="">{{\'commonKeywords.sl\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.id\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.employeeName\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.email\'}}</td><th class="headers2 text-center" translate="">{{\'payrollManagement.dateOfJoining\'}}</th><th class="headers2 text-center">{{vm.payrollType === 1 ? "Gross " : "Basic "}} <span translate="">{{\'employeesBatchCreation.employeesTableHeader.salary\'}}</span></th><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.paymentMethod\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.bankName\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.accountNumber\'}}</td><td class="headers2 text-center" translate="">{{\'employeesBatchCreation.employeesTableHeader.routingNumber\'}}</td></tr></thead><tbody ng-if="vm.newEmployees == null || vm.newEmployees.length === 0"><tr><td colspan="10" class="text-center"><em translate="">{{\'employeesBatchCreation.NoNewEmployees\'}}</em></td></tr></tbody><tbody ng-if="vm.newEmployees != null && vm.newEmployees.length > 0"><tr ng-repeat="employee in vm.newEmployees" ng-class="{error : employee.hasError}" data-toggle="tooltip" uib-tooltip="{{vm.getTooltipText(employee.row.errorMessages)}}" tooltip-placement="top" tooltip-enable="employee.hasError" tooltip-append-to-body="true"><td class="text-center">{{$index+1}}</td><td class="text-center">{{employee.row.employeeOfficeId}}</td><td class="text-center"><employee-picture-and-information name="employee.row.employeeName" picture-url="" department-name="employee.row.departmentName" designation-name="employee.row.designationName" is-clickable="false"></employee-picture-and-information></td><td class="text-center">{{employee.row.email}}</td><td class="text-center">{{employee.row.dateOfJoin | date:\'dd MMM yyyy\'}}</td><td class="text-center">{{employee.row.salary}}</td><td class="text-center">{{employee.row.paymentMode}}</td><td class="text-center">{{employee.row.bankName}}</td><td class="text-center">{{employee.row.accountNumber}}</td><td class="text-center">{{employee.row.routingNumber}}</td></tr></tbody></table></div></div></div></div><br><br><br><div class="row"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-danger text-uppercase" ui-sref="payroll.salaryManagement" translate="">{{\'employeesBatchCreation.cancelUploadButton\'}}</button> <button type="button" class="btn btn-primary text-uppercase" ng-click="vm.uploadFile()" ng-disabled="vm.hasError" translate="">{{\'employeesBatchCreation.confirmButton\'}}</button></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryManagement/partials/dummyTable.html','<div class="row mt-5"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information><button ng-if="vm.selectedRow.salary" class="btn btn-primary edit-btn-position" ng-disabled="!vm.isEmployeePayrollComponentsLoaded" ng-click="vm.openEditMode()"><i class="ion-ios-compose-outline font-19 mr-3"></i> <span translate="">{{\'payrollManagement.editInformation\'}}</span></button></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.selectedRow.shiftGroupName ? vm.selectedRow.shiftGroupName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.selectedRow.employmentTypeName ? vm.selectedRow.employmentTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h5><strong translate="">{{\'payrollManagement.payrollInformation\'}}</strong></h5></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh bg-f8f8f8 font-14"><th class="text-left dont-wrap-text" translate="">{{\'payrollSettings.componentName\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.dummyAmount\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.value\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollSettings.percentageOf\'}}</th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'payrollManagement.basicSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.houseRentAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.conveyanceAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.medicalAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center" translate="">{{\'payrollManagement.fixed\'}}</td><td class="text-center" translate="">{{\'commonKeywords.na\'}}</td></tr><tr><td class="text-left font-weight-bold"><strong translate="">{{\'payrollManagement.grossSalary\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td><td class="text-center"></td><td class="text-center"></td></tr></tbody></table><div class="row mt-30"><div class="col-md-12"><h5><strong translate="">{{\'payrollManagement.bankInformation\'}}</strong></h5></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.paymentMode\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankInfo.paymentMode ? \'Not Set\' : vm.bankInfo.paymentMode}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.bankName\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankName ? \'Not Set\' : vm.bankName}}</td></tr></table></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.routingNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.routingNumber ? \'Not Set\' : vm.routingNumber}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.accountNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.accountNumber ? \'Not Set\' : vm.accountNumber}}</td></tr></table></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryManagement/partials/editEmployeeInfoSection.html','<style>\n    @media(max-width:991px){\n        .spacing{\n            margin-top: 15px;\n        }\n    }\n</style><div class="row mt-15"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td class="position-relative" colspan="2"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.selectedRow.shiftGroupName ? vm.selectedRow.shiftGroupName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.selectedRow.employmentTypeName ? vm.selectedRow.employmentTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h3>{{\'payrollManagement.payrollInformation\' | translate}}</h3></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr><td class="text-left">Basic Salary</td><td><input id="basic-salary" type="number" class="form-control" ng-model="vm.basicSalary" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()" ng-change="vm.recalculateBasicSalary = true" ng-disabled="vm.officePayrollSettings.payrollType == vm.PAYROLL_TYPE_GROSS_DRIVEN"> <label for="basic-salary" class="color-prime" ng-if="vm.recalculateBasicSalary">Press Enter to recalculate</label></td></tr><tr ng-repeat="data in vm.employeePayrollComponents | filter: {inclusiveToGross: true}" ng-if="data.type != -1"><td class="text-left"><span>{{data.name}}</span></td><td class="text-center text-left-important"><input type="number" class="form-control text-visible" ng-disabled="!data.isEditable" ng-model="data.amount" id="grossOrBasicInputField" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()"></td></tr><tr><td class="text-left">Gross Salary</td><td><input id="gross-salary" type="number" class="form-control" ng-model="vm.grossSalary" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()" ng-change="vm.recalculateGrossSalary = true" ng-disabled="vm.officePayrollSettings.payrollType == vm.PAYROLL_TYPE_BASIC_DRIVEN"> <label for="gross-salary" class="color-prime" ng-if="vm.recalculateGrossSalary">Press Enter to recalculate</label></td></tr><tr ng-repeat="data in vm.employeePayrollComponents | filter: {inclusiveToGross: false}"><td class="text-left"><span>{{data.name}}</span></td><td class="text-center text-left-important"><input type="number" class="form-control text-visible" ng-disabled="!data.isEditable" ng-model="data.amount" id="grossOrBasicInputFielx" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()"></td></tr><tr><td class="text-left">Total Salary</td><td>{{vm.getTotalSalary()}}</td></tr></tbody></table><div class="row mt-30"><div class="col-md-12"><h3>{{\'payrollManagement.bankInformation\' | translate}}</h3></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.paymentMode\'}}</p><div class="custom-select"><select ng-options="v.value as v.name for v in vm.paymentModes" ng-model="vm.paymentMode"></select></div></div><div class="col-md-6 spacing"><p translate="">{{\'payrollManagement.bankName\'}}</p><div class="custom-select"><select ng-options="b.bankId as b.bankName for b in vm.bankList" ng-model="vm.bankId"></select></div></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.routingNumber\'}}</p><div class="custom-select"><select ng-options="b.routingNumber as b.routingNumber for b in vm.bankList | filter:{bankId:vm.bankId}" ng-model="vm.routingNumber"></select></div></div><div class="col-md-6 spacing"><p translate="">{{\'payrollManagement.accountNumber\'}}</p><input type="text" class="form-control" ng-model="vm.accountNumber"></div></div><div class="row mt-30"><div class="col-md-12 text-right"><button class="btn btn-md-with-icon btn-primary padding-7-14" ng-disabled="vm.savingSalary" ng-click="vm.saveEmployeeInfo()"><img src="../assets/img/Save.png"> <span class="ml-negative-5 pb-2" translate="">{{\'payrollManagement.saveSetUp\'}}</span></button></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryManagement/partials/employeeInfoSection.html','<div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information><button ng-if="vm.selectedRow.salary" class="btn btn-md-with-icon btn-primary edit-btn-position" ng-disabled="!vm.isEmployeePayrollComponentsLoaded" ng-click="vm.openEditMode()"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'payrollManagement.editInformation\'}}</span></button></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.selectedRow.shiftGroupName ? vm.selectedRow.shiftGroupName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.selectedRow.employmentTypeName ? vm.selectedRow.employmentTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h3>{{\'payrollManagement.payrollInformation\' | translate}}</h3></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered" ng-if="vm.employeePayrollComponents.length > 0"><colgroup><col class="width-40"><col class="width-20"><col class="width-20"><col class="width-20"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh bg-f8f8f8 font-14"><th class="text-left dont-wrap-text" translate="">{{\'payrollSettings.componentName\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'payrollManagement.amount\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'payrollManagement.value\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollSettings.percentageOf\'}}</th></tr></thead><tbody><tr class="height-5-vh"><td class="text-left">Basic Salary</td><td class="text-right">{{vm.basicSalary | number:2}}</td><td class="text-center"></td><td class="text-center">Fixed</td></tr><tr class="height-5-vh" ng-repeat="data in vm.employeePayrollComponents | filter: {inclusiveToGross: true}"><td class="text-left">{{data.name}}</td><td class="text-right">{{data.amount | number : 2}}</td><td class="text-right"><span ng-if="data.valueType == 1">{{data.value}}<span translate="">{{\'payrollManagement.percentageSign\'}}</span></span> <span ng-if="data.valueType == 2" translate="">{{\'payrollManagement.fixed\'}}</span></td><td class="text-center"><span ng-if="data.valueDeterminer == 1">{{data.valueType !== 2 ? \'Gross Salary\':\'N/A\'}}</span> <span ng-if="data.valueDeterminer == 2">{{data.valueType !== 2 ? \'Basic Salary\':\'N/A\'}}</span></td></tr><tr class="height-5-vh text-bold"><td class="text-left">Gross Salary</td><td class="text-right">{{vm.grossSalary | number:2}}</td><td class="text-center"></td><td class="text-center"></td></tr><tr class="height-5-vh" ng-repeat="data in vm.employeePayrollComponents | filter: {inclusiveToGross: false}"><td class="text-left">{{data.name}}</td><td class="text-right"><span ng-if="data.category == -1">-</span>{{data.amount | number : 2}}</td><td class="text-right"><span ng-if="data.valueType == 1">{{data.value}}<span translate="">{{\'payrollManagement.percentageSign\'}}</span></span> <span ng-if="data.valueType == 2" translate="">{{\'payrollManagement.fixed\'}}</span></td><td class="text-center"><span ng-if="data.valueDeterminer == 1">{{data.valueType !== 2 ? \'Gross Salary\':\'N/A\'}}</span> <span ng-if="data.valueDeterminer == 2">{{data.valueType !== 2 ? \'Basic Salary\':\'N/A\'}}</span></td></tr><tr class="height-5-vh text-bold"><td class="text-left">Total Salary</td><td class="text-right">{{vm.getTotalSalary() | number:2}}</td><td class="text-right">{{vm.getTotalSalary() | number:2}}</td><td class="text-center"></td></tr></tbody></table><div class="row mt-20" ng-if="vm.employeePayrollComponents.length > 0"><div class="col-md-12"><h3>{{\'payrollManagement.bankInformation\' | translate}}</h3></div></div><div class="row mt-5" ng-if="vm.employeePayrollComponents.length > 0"><div class="col-md-6"><p translate="">{{\'payrollManagement.paymentMode\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankInfo.paymentModeName ? \'Not Set\' : vm.bankInfo.paymentModeName}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.bankName\'}}</p><table class="table table-bordered"><tr><td>{{!vm.bankInfo.bankName ? \'Not Set\' : vm.bankInfo.bankName}}</td></tr></table></div></div><div class="row mt-20" ng-if="vm.employeePayrollComponents.length > 0"><div class="col-md-6"><p translate="">{{\'payrollManagement.routingNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.routingNumber ? \'Not Set\' : vm.routingNumber}}</td></tr></table></div><div class="col-md-6"><p translate="">{{\'payrollManagement.accountNumber\'}}</p><table class="table table-bordered"><tr><td>{{!vm.accountNumber ? \'Not Set\' : vm.accountNumber}}</td></tr></table></div></div><div class="row text-center" ng-if="!vm.isEmployeePayrollComponentsLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="text-center mt-10" ng-if="vm.employeePayrollComponents.length == 0 && vm.isEmployeePayrollComponentsLoaded"><span><i translate="">{{\'payrollManagement.payrollInfoIsNotSetUp\'}}</i></span></div></div></div>');
$templateCache.put('app/pages/main/payroll/salaryManagement/partials/employeesTable.html','<table id="column-height" class="table borderless-table odd-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-15"><col class="width-44"><col class="width-15"><col class="width-20"></colgroup><thead><tr class="headers2 row-height dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.id\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.shiftGroup\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'payrollManagement.grossSalary\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.employees" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}"><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{$index + 1}}</td><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{data.employeeOfficeId}}</td><td class="dont-wrap-text" ng-click="vm.showEmployeeInfoInTheRightColumn($index)"><employee-picture-and-information name="data.name" picture-url="data.pictureUrl" department-name="data.departmentName" designation-name="data.designationName" is-clickable="false"></employee-picture-and-information></td><td class="dont-wrap-text text-left" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{data.shiftGroupName}}</td><td class="dont-wrap-text text-right"><a ng-if="!data.salary" class="cursor-pointer link-btn" ng-click="vm.setupEmployeeSalary($index)" translate="">{{\'payrollManagement.setUpNow\'}}</a> <span ng-if="data.salary" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{data.salary | number:0}}</span></td></tr></tbody></table>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/generateSalary.html','<style>\n    .panel-full-screen {\n        height: 76vh;\n    }\n    .btn-default{\n        height: 37px;\n        border-radius: 0px;\n    }\n    .ion-eye{\n        font-size: 18px!important;\n        padding-top: 3px!important;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Salary Generation" ba-panel-class="with-scroll panel-full-screen"><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tr class="text-left"><td translate="">{{\'viewOrGenerateSalary.salaryMonth\'}}</td><td><div class="input-group mb-0 position-relative table-cell-gap"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPicker.format}}" datepicker-options="vm.monthPicker.options" ng-model="vm.selectedMonth" is-open="vm.monthPicker.opened" ng-required="true" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></td></tr><tr ng-if="vm.isDataLoaded"><td translate="">{{\'viewOrGenerateSalary.salaryState\'}}</td><td ng-if="!vm.isSalaryGenerated">{{vm.isSalaryGenerated ? vm.salarySummary.statusText : \'Not Generated\'}}</td><td ng-if="vm.isSalaryGenerated">{{vm.salarySummary.statusText == \'Pending\' ? \'Pending for Approval\' : vm.salarySummary.statusText}}</td></tr></table></div></div><br><br><div class="row" ng-show="!vm.isSalaryGenerated && !vm.hasGenerationStarted && vm.isDataLoaded && !vm.isPayrollApprover"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon btn-secondary padding-4-12 pull-right" ng-disabled="vm.hasSalaryGenerationStarted" ng-click="vm.generateSalary()"><img src="../assets/img/process.png"><span translate="">{{\'viewOrGenerateSalary.generateSalary\'}}</span></button></div></div><div class="row" ng-show="vm.isSalaryGenerated"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon btn-secondary pull-right padding-7-15" ng-click="vm.getProcessedSalaries()"><i class="ion-eye"></i> <span class="ml-negative-5 pb-2" translate="">{{\'viewOrGenerateSalary.viewSalaryReport\'}}</span></button></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><br><br><br><div class="row" ng-show="vm.hasGenerationStarted"><div class="col-md-12"><div class="text-center"><p><em translate="">{{\'viewOrGenerateSalary.salaryGenerationText\'}}</em></p></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary.html','<style>\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 5px !important;\n    }\n    .summery-table .table > tbody > tr > td{\n        padding: 8px 1px!important;\n    }\n    .summery-table{\n        font-size: 13px!important;\n    }\n\n</style><div ba-panel="" ba-panel-title="{{vm.panelTitle}}" ba-panel-class="with-scroll"><div class="row"><div class="col-md-7 col-lg-6"><div class="row"><div class="col-md-6"><div class="summery-table"><table class="table table-bordered"><colgroup><col class="width-28"><col class="width-25"><col class="width-28"><col class="width-19"></colgroup><tbody><tr><td class="text-center" translate="">{{\'viewOrGenerateSalary.salaryMonth\'}}</td><td class="text-center"><span class="color-prime">{{vm.salarySummary.monthName}} {{vm.salarySummary.year}}</span> <i class="ion-android-calendar"></i></td><td class="text-center" translate="">{{\'viewOrGenerateSalary.salaryState\'}}</td><td class="text-center"><span class="color-2dacd1" ng-if="vm.salarySummary.status != 1">{{vm.salarySummary.statusText}}</span> <span ng-if="vm.salarySummary.status == 1" class="text-warning">{{vm.salarySummary.statusText}}</span></td></tr></tbody></table></div></div><div class="col-md-6"><div class="summery-table"><table class="table table-bordered"><colgroup><col class="width-31"><col class="width-10"><col class="width-37"><col class="width-22"></colgroup><tbody><tr><td class="text-center" translate="">{{\'viewOrGenerateSalary.totalEmployee\'}}</td><td class="text-center"><span class="color-prime">{{vm.salarySummary.totalEmployee}}</span></td><td class="text-center" translate="">{{\'viewOrGenerateSalary.totalNetPayable\'}}</td><td class="text-center"><span class="color-prime">{{vm.salarySummary.totalNetPayable | number:0}}</span></td></tr></tbody></table></div></div></div><br><div class="row"><div class="col-md-12"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.getSalaries()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div></div><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0 text-uppercase" ng-class="{\'selected-table-toggle-button\': vm.selectedTab === \'processedSalary\'}" ng-click="vm.switchTab(\'processedSalary\')" translate="">{{\'viewOrGenerateSalary.processedSalary\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0 text-uppercase" ng-class="{\'selected-table-toggle-button\': vm.selectedTab === \'unprocessedSalary\'}" ng-click="vm.switchTab(\'unprocessedSalary\')" translate="">{{\'viewOrGenerateSalary.unprocessedSalary\'}}</button></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded" include-with-scope="app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/employeesTable.html"></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.selectedTab ===\'processedSalary\' ? vm.getProcessedSalaries : vm.getUnprocessedSalaries" not-found-text="\'No data available\'"></pagination-directive><br><br></div><div class="col-md-5 col-lg-6"><div class="row"><div class="col-md-12"><div class="d-flex-row-reverse-wrap-7"><div ng-if="vm.isPayrollApprover && vm.salarySummary.status == 1"><button class="btn btn-md-with-icon btn-danger padding-5-10" ng-click="vm.rollbackSalary()"><img src="../assets/img/back_button.png"><span translate="">{{\'viewOrGenerateSalary.rollbackButton\'}}</span></button></div><div ng-if="vm.isPayrollApprover && vm.salarySummary.status == 1"><button class="btn btn-md-with-icon btn-secondary padding-5-10" ng-click="vm.approveSalary()"><img src="../assets/img/approve.png"><span translate="">{{\'viewOrGenerateSalary.approveButton\'}}</span></button></div><div ng-if="vm.salarySummary.status == 2 && vm.isPayrollManager"><button class="btn btn-md-with-icon btn-secondary padding-5-10" ng-click="vm.paySalary()"><img src="../assets/img/pay.png"> <span translate="">{{\'viewOrGenerateSalary.paySalaryButton\'}}</span></button></div><div ng-if="vm.salarySummary.status != 0"><button class="btn btn-md-with-icon btn-secondary padding-5-10" ng-click="vm.salaryLog()"><img src="../assets/img/log.png"> <span class="ml-negative-5" translate="">{{\'viewOrGenerateSalary.salaryLogButton\'}}</span></button></div><div ng-if="vm.salarySummary.status == 0 && vm.isPayrollManager" ng-click="vm.sendSalaryForApprovalModal()"><button class="btn btn-md-with-icon btn-secondary padding-5-10"><img src="../assets/img/send.png"><span translate="">{{\'viewOrGenerateSalary.sendForApprovalButton\'}}</span></button></div><div ng-if="vm.selectedTab === \'processedSalary\' && vm.salarySummary.status == 0 && vm.isPayrollManager"><button class="btn btn-md-with-icon btn-danger padding-5-10" ng-click="vm.undoSalary()"><img src="../assets/img/back_button.png"><span translate="">{{\'viewOrGenerateSalary.undoSalaryButton\'}}</span></button></div><div ng-if="vm.selectedTab === \'unprocessedSalary\' && vm.salarySummary.status == 0 && vm.isPayrollManager"><button class="btn btn-md-with-icon btn-info padding-5-10" ng-click="vm.processSalary()"><img src="../assets/img/process.png"><span translate="">{{\'viewOrGenerateSalary.processSalaryButton\'}}</span></button></div><div><button class="btn btn-md-with-icon btn-secondary padding-5-10" ng-click="vm.downloadExcel()"><img src="../assets/img/Excel.png"><span translate="">{{\'commonKeywords.downloadExcelButton\'}}</span></button></div></div></div></div><div class="row mt-20"><div class="col-md-12"><h4><strong translate="">{{\'viewOrGenerateSalary.salaryDetails\'}}</strong></h4></div></div><div class="row mt-15" ng-if="vm.isAnyRowSelected && !vm.isEditBtnClicked" include-with-scope="app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/salaryDetailsTable.html"></div><div ng-if="vm.isAnyRowSelected && vm.isEditBtnClicked" include-with-scope="app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/editSalaryDetailsTable.html"></div><div ng-if="!vm.isAnyRowSelected" class="position-relative" ng-class="{\'unselected\': vm.isAnyRowSelected == false}" include-with-scope="app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/dummyTable.html"></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div><div class="row text-center" ng-if="vm.isAnyRowSelected && !vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/attendance/attendanceChart/chart.attendance.partial.html','<style>\n    .attendance-chart{\n        overflow-y: auto;\n        /*height: 700px*/\n    }\n    .pt-23{\n        padding-top: 23px;\n    }\n</style><div class="position-relative"><upgrade-banner code="4022"><div class="attendance-chart" ng-controller="ProfileAttendanceChartCtrl as vm"><h3 class="panel-title mb-20">{{\'attendanceReportOf\' |translate}}&nbsp;{{vm.employeeName}}</h3><div class="bg-f1f2f1 pb-23 pt-23"><div class="row form-inline text-center"><div class="form-group col-sm-2 col-xs-6"></div><div class="form-group col-sm-2 col-xs-6 ml-20 text-right"><h4 class="padding-top-4">{{\'dateRange\' | translate}}</h4></div><div class="col-sm-3 col-xs-9"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.attendancedatePicker.date" options="vm.attendancedatePicker.options"><span class="date-position-left">{{vm.attendancedatePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.attendancedatePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group col-sm-2 col-xs-6 text-left"><button type="button" class="btn btn-md-with-icon btn-primary text-center vertical-align-middle mt-1" ng-click="vm.searchAttendance()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div><div class="form-group col-sm-3 col-xs-6"></div></div></div><div id="zoomAxisChart" class="admin-chart" ng-if="vm.isDataReady"></div><div class="text-center mt-20" ng-if="!vm.isDataReady"><span>{{\'noAttendanceFound\'|translate}}</span></div><br><br></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/profile/attendance/detailsAttendanceLog/both-type-attendance.html','<style>\n    .table > tbody > tr > td {\n        vertical-align: middle;\n    }\n    td {\n        width: 100px;\n        text-align: left;\n    }\n    .both-type-attendance-table{\n        overflow-y:auto;\n        /*height: 500px*/\n    }\n    .odd-row{\n        background-color: #f9f9f9!important;\n    }\n    .even-row{\n        background-color: white!important;\n    }\n    .border-bottom-2{\n        border-bottom: 2px solid #e8e8e8 !important;\n    }\n</style><div class="row position-relative ml-0 mr-0"><upgrade-banner code="4019"><div class="col-md-12"><div class="both-type-attendance-table"><table class="table borderless-table even-child-selector"><thead><tr><th class="text-center width-15" translate="">{{\'profile.date\'}}</th><th class="text-center width-10">{{\'time\'|translate}}</th><th class="text-center width-30">{{\'device\'|translate}}</th><th class="text-center width-10">{{\'entryType\'|translate}}</th><th class="text-center">{{\'manualEntryInfo\'|translate}}</th><th class="text-center" ng-show="vm.enableDeletePunch">{{\'action\'|translate}}</th></tr></thead><tbody ng-repeat="attendance in vm.bothTypeAttendance" ng-init="dateIndex = $index" class="border-bottom-2" ng-if="vm.isDataLoaded && vm.bothTypeAttendance.length > 0"><tr><td class="text-center" rowspan="{{attendance.entries.length}}">{{attendance.date}}</td><td class="text-center">{{vm.getHoursMin(attendance.entries[0].attendanceTime)}}</td><td class="text-center line-height-25" ng-if="!vm.isManualEntry(attendance.entries[0].punchType)">{{\'device\'|translate}}: {{attendance.entries[0].deviceIdentifier}}<br>Location: {{attendance.entries[0].location}}<br>Punch Type: {{vm.getPunchType(attendance.entries[0].punchType)}}</td><td class="text-center" ng-if="vm.isManualEntry(attendance.entries[0].punchType)">{{\'manualEntry\'|translate}}</td><td class="text-center">{{vm.getEntryType(attendance.entries[0].entryType)}}</td><td class="text-center" ng-if="!vm.isManualEntry(attendance.entries[0].punchType)">{{\'notApplicable\'|translate}}</td><td class="text-center line-height-25" ng-if="vm.isManualEntry(attendance.entries[0].punchType)">{{\'requestor\'|translate}}: <a ui-sref="profile({employeeId: {{attendance.entries[0].manualEntryGivenBy}}})">{{attendance.entries[0].manualEntryGiverName}}</a><br>{{\'reason\'|translate}}: {{attendance.entries[0].manualEntryReason}}<br>{{vm.getApprovalStatus(attendance.entries[0].approvalStatus)}}</td><td class="text-center" ng-show="vm.enableDeletePunch"><div class="d-flex-center" ng-if="!attendance.entries[0].isDeleted"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeletePunchModal(attendance.entries[0], $index, 0)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div><div ng-if="attendance.entries[0].isDeleted">Deleted at: {{attendance.entries[0].deletedAt | date:"dd-MMM-yyyy hh:mm a"}}<br>Deleted by: {{attendance.entries[0].nameOfDeletedBy}}</div></td></tr><tr ng-repeat="entries in attendance.entries" ng-if="$index>0" ng-class="{\'even-row\': $index % 2 == 1, \'odd-row\': $index % 2 == 0}"><td class="text-center">{{vm.getHoursMin(entries.attendanceTime)}}</td><td class="text-center line-height-25" ng-if="!vm.isManualEntry(entries.punchType)">{{\'device\'|translate}}: {{entries.deviceIdentifier}}<br>Location: {{entries.location}}<br>{{\'punchType\'|translate}}: {{vm.getPunchType(entries.punchType)}}</td><td class="text-center" ng-if="vm.isManualEntry(entries.punchType)">{{\'manualEntry\'|translate}}</td><td class="text-center">{{vm.getEntryType(entries.entryType)}}</td><td class="text-center" ng-if="!vm.isManualEntry(entries.punchType)">{{\'notApplicable\'|translate}}</td><td class="text-center line-height-25" ng-if="vm.isManualEntry(entries.punchType)">{{\'requestor\'|translate}}: <a ui-sref="profile({employeeId: {{entries.manualEntryGivenBy}}})">{{entries.manualEntryGiverName}}</a><br>{{\'reason\'|translate}}: {{entries.manualEntryReason}}<br>{{vm.getApprovalStatus(entries.approvalStatus)}}</td><td ng-show="vm.enableDeletePunch"><div class="d-flex-center" ng-if="!entries.isDeleted"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeletePunchModal(entries, dateIndex, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div><div ng-if="entries.isDeleted"><span translate="">{{\'profile.deletedAt\'}}</span> {{entries.deletedAt | date:"dd-MMM-yyyy hh:mm a"}}<br><span translate="">{{\'profile.deletedBy\'}}</span> {{entries.nameOfDeletedBy}}</div></td></tr></tbody></table><div class="text-center" ng-if="vm.bothTypeAttendance.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.getPageOfAttendanceLog(0)">{{\'first\'|translate}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.reduceSelectedPaginationPage()">&lt;</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPage==$index)? \'active\':\'\'" ng-if="vm.selectedPage <= 2 ? $index <= 5 : (vm.selectedPage <= vm.numberOfButtons.length && vm.selectedPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPage - 2 && $index <= vm.selectedPage + 3)"><a class="page-link" ng-click="vm.getPageOfAttendanceLog($index)">{{$index+1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.increaseSelectedPaginationPage()">&gt;</a></li><li class="page-item"><a class="page-link" ng-click="vm.getPageOfAttendanceLog(vm.numberOfButtons.length-1)">{{\'last\'|translate}}</a></li></ul></nav><div class="text-center mt-10" ng-if="vm.bothTypeAttendance.length > 0"><p><strong>{{\'showingPage\'|translate}} {{vm.selectedPage +1}} {{\'outOf\'|translate}} {{vm.numberOfButtons.length}} {{\'pages\'|translate}}.</strong></p></div></div><div class="text-center mb-10" ng-if="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/profile/attendance/detailsAttendanceLog/details.attendance.partial.html','<style>\n    .section-margin-top{\n        margin-top: 30px!important;\n    }\n    .btn-position-left{\n        position: absolute;\n        left: 17px;\n    }\n</style><div ng-controller="DetailedAttendanceLogCtrl as vm"><h3 class="panel-title section-margin-top mb-20">{{\'detailedAttendanceLogs\'|translate}}&nbsp;of {{vm.employeeName}}</h3><div class="bg-f1f2f1 pb-10 pt-25"><div class="row text-center position-relative"><div class="btn-position-left ml-10" ng-if="vm.isManualEntryEnabled"><button class="btn btn-md-with-icon btn-secondary" ng-click="vm.openManualEntryModal()"><i class="ion-android-add-circle"></i> <span class="ml-negative-5 pb-2">{{\'addNewManualEntry\'|translate}}</span></button></div><div class="form-group col-sm-2 col-xs-6"></div><div class="form-group col-sm-2 col-xs-6 ml-20 text-right"><h4 class="padding-top-4">{{\'dateRange\' | translate}}</h4></div><div class="form-group col-sm-3 col-xs-9 text-center"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.datePicker.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group col-sm-2 col-xs-6"><button type="button" class="btn btn-md-with-icon btn-primary mt-1" ng-click="vm.getBothTypeAttendanceLog(0)"><i class="ion-search"></i>{{\'search\'|translate}}</button></div><div class="btn-position mr-10"><button id="exportToExcelButton" type="button" ng-if="vm.excelUrl!=null && vm.excelUrl != \'\'" class="btn btn-md-with-icon btn-primary padding-6-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/download_white.png"> <span class="ml-negative-5" translate="">{{\'profile.downloadAllButton\'}}</span></button></div></div></div><div class="row mt-20"><div include-with-scope="app/pages/main/profile/attendance/detailsAttendanceLog/both-type-attendance.html"></div><div class="text-center mt-20" ng-if="vm.isDataLoaded && vm.bothTypeAttendance.length === 0"><p><em translate="">{{\'profile.noAttendanceLogsFound\'}}</em></p></div></div></div>');
$templateCache.put('app/pages/main/profile/attendance/fieldVisit/ProfileFieldVisit.html','<div ng-controller="FieldVisitProfileCtrl as vm"><h3 class="panel-title mt-15 mb-20">{{\'fieldVisitReportOf\' |translate}}&nbsp;{{vm.employeeName}}</h3><div class="bg-f1f2f1 pb-23 pt-25"><div class="row form-inline text-center"><div class="form-group col-sm-2 col-xs-6"></div><div class="form-group col-sm-2 col-xs-6 ml-20 text-right"><h4 class="padding-top-4">{{\'dateRange\' | translate}}</h4></div><div class="form-group col-sm-3 col-xs-9 text-center"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.attendancedatePicker.date" options="vm.attendancedatePicker.options"><span class="date-position-left">{{vm.attendancedatePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.attendancedatePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group col-sm-2 col-xs-6"><button type="button" class="btn btn-md-with-icon btn-primary mt-1" ng-click="vm.searchAttendance()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div><div class="form-group col-sm-3 col-xs-6"></div><div class="btn-position" ng-show="vm.isDataReady"><a ng-href="{{vm.excelUrl}}" target="_self"><button type="button" ng-if="vm.isDataReady && vm.manualEntryData.length > 0" class="btn btn-md-with-icon btn-primary bottom padding-7-15"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></a></div></div></div><div class="mt-15"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center" translate="">{{\'profile.date\'}}</th><th class="text-center" translate="">{{\'profile.reason\'}}</th><th class="text-center" translate="">{{\'profile.area\'}}</th><th class="text-center" translate="">{{\'profile.entry\'}}</th><th class="text-center" translate="">{{\'profile.exit\'}}</th><th class="text-center" translate="">{{\'profile.secondApproverStatus\'}}</th><th class="text-center" translate="">{{\'profile.firstApproverStatus\'}}</th><th class="text-center" translate="">{{\'profile.status\'}}</th></tr></thead><tbody><tr ng-repeat="manualEntry in vm.manualEntryData" ng-if="vm.isDataReady"><td class="text-center">{{manualEntry.entryTime | date : \'dd.MM.yyyy\'}}</td><td class="text-center">{{manualEntry.reason}}</td><td class="text-center">{{manualEntry.area}}</td><td class="text-center">{{manualEntry.entryTime | date : \'HH:mm a\'}}</td><td>{{manualEntry.exitTime | date : \'HH:mm a\'}}</td><td class="text-center">{{manualEntry.secondManualApproverName}}<br><span ng-if="manualEntry.secondManualApproverName != \'N/A\' && manualEntry.secondManualEntryApprovalStatus ==0" class="orange-text">{{ \'pending\' | translate}}</span> <span ng-if="manualEntry.secondManualEntryApprovalStatus==1 || (manualEntry.secondManualEntryApproverId == null && manualEntry.secondManualEntryApprovalStatus == null)" class="green-text">{{ \'accepted\' | translate}}</span> <span ng-if="manualEntry.secondManualEntryApprovalStatus==2" class="red-text">{{ \'rejected\' | translate}}</span><br><i ng-if="manualEntry.secondManualEntryApprovalComment">&#34;{{manualEntry.secondManualEntryApprovalComment}}&#34;</i></td><td class="text-center">{{manualEntry.firstManualApproverName}}<br><span ng-if="manualEntry.firstManualApproverName != \'N/A\' && manualEntry.firstManualEntryApprovalStatus ==0" class="orange-text">{{ \'pending\' | translate}}</span> <span ng-if="manualEntry.firstManualEntryApprovalStatus==1 || (manualEntry.firstManualEntryApproverId == null && manualEntry.firstManualEntryApprovalStatus == null)" class="green-text">{{ \'accepted\' | translate}}</span> <span ng-if="manualEntry.firstManualEntryApprovalStatus == 2" class="red-text">{{ \'rejected\' | translate}}</span><br><i ng-if="manualEntry.firstManualEntryApprovalComment">&#34;{{manualEntry.firstManualEntryApprovalComment}}&#34;</i></td><td class="text-center"><span ng-if="manualEntry.status==0" class="orange-text"><strong>{{ \'pending\' | translate}}</strong></span> <span ng-if="manualEntry.status==1" class="green-text"><strong>{{ \'accepted\' | translate}}</strong></span> <span ng-if="manualEntry.status==2" class="red-text"><strong>{{ \'rejected\' | translate}}</strong></span></td></tr></tbody></table><pagination-directive ng-if="vm.isDataReady" number-of-pages="vm.totalPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.currentPage" total="vm.total" is-data-loaded="vm.isDataReady" not-found-text="" search-method="vm.searchAttendance" hide-no-data-message="true"></pagination-directive><div class="text-center mb-10" ng-show="!vm.isDataReady"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-15 mb-20" ng-show="vm.isDataReady && vm.manualEntryData"><em>No data found</em></div></div></div>');
$templateCache.put('app/pages/main/profile/attendance/table/table.partial.html','<style>\n    .attendance-table{\n        overflow-y: auto;\n        /*height: 700px*/\n    }\n    @media only screen and (max-width: 414px) and (min-width: 360px) {\n        #profile-attendance-table-button {\n            margin-top: 5px !important;\n        }\n        #date-range-display {\n            text-align: left !important;\n        }\n    }\n    .btn-position{\n        position: absolute;\n        right: 17px;\n    }\n</style><div ng-controller="ProfileAttendanceTableCtrl as vm"><h3 class="panel-title section-margin-top mb-20" translate="">{{\'profile.attendanceTableHeading\'}}</h3><div class="bg-f1f2f1 pb-23 pt-25"><div class="row position-relative"><div class="col-xs-0 col-md-1"></div><div class="col-xs-12 col-md-3 mt-5 ml-20 text-right pt-2" id="date-range-display"><h4>{{\'dateRange\'|translate}}</h4></div><div class="col-xs-12 col-md-3"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.attendancedatePicker.date" options="vm.attendancedatePicker.options"><span class="date-position-left">{{vm.attendancedatePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.attendancedatePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-xs-12 col-md-2" id="profile-attendance-table-button"><button type="button" class="btn btn-md-with-icon btn-primary mt-1" ng-click="vm.getAttendanceTableData()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div><div class="btn-position mr-10"><upgrade-link code="4021"><button class="btn btn-md-with-icon btn-primary padding-7-14" id="exportToExcel" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span translate="">{{\'commonKeywords.excelButton\'}}</span></button></upgrade-link></div></div></div><br><div class="row position-relative"><upgrade-banner code="4020"><div class="col-md-12 attendance-table"><div><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-25">{{\'date\'|translate}}</th><th class="text-center width-25" translate="">{{\'commonKeywords.entry\'}}</th><th class="text-center width-25" translate="">{{\'commonKeywords.exit\'}}</th><th class="text-center width-25" translate="">{{\'profile.hours\'}}</th></tr></thead><tbody><tr ng-repeat="attendance in vm.attendances"><td class="text-center">{{attendance.date}}</td><td class="text-center" colspan="{{attendance.isPresent===true ? \'1\':\'3\'}}"><span ng-if="attendance.isPresent" ng-class="{\'redText\': attendance.isLate && (!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isLeave && !attendance.isOffday), \'orange-text\': attendance.isGracePeriod}">{{attendance.firstLoggedTime}}{{(attendance.isHalfDay && attendance.leaveQuarter == 1)? " H1":""}}<br></span> <span ng-if="attendance.isPresent && attendance.isLate && attendance.isLateApprovalApplied && attendance.lateApprovalStatus.length > 0" class="red-text">{{ attendance.lateApprovalStatus }}<br></span> <span ng-if="attendance.statusText!=null" class="status-text sienna-text text-bold">{{attendance.statusText}}<br></span> <span ng-if="attendance.entryManual && attendance.logPunchType != 5" class="manual-text" translate="">{{\'profile.manualEntry\'}}<br></span> <span ng-if="attendance.entryManual && attendance.logPunchType == 5" class="manual-text" translate="">{{\'profile.fieldVisit\'}}<br></span> <span ng-if="attendance.isSpecialDay" class="greenText" translate="">{{\'profile.specialDay\'}}<br></span> <span ng-if="!attendance.isSpecialDay && attendance.isHoliday" class="greenText" translate="">{{\'profile.holiday\'}}<br></span> <span id="offDaySpan" ng-if="!attendance.isSpecialDay && !attendance.isHoliday && attendance.isOffday" class="greenText" translate="">{{\'profile.offDay\'}}<br></span> <span ng-if="!attendance.isSpecialDay && attendance.isLeave" class="greenText" translate="">{{\'profile.leave\'}}<br></span> <span ng-if="(!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isLeave && !attendance.isOffday) && !attendance.isPresent" class="redText text-center" translate="">{{\'profile.absent\'}}</span></td><td class="text-center" ng-show="attendance.isPresent"><span ng-class="((attendance.isEarly && (!attendance.isSpecialDay && !attendance.isHoliday &&!attendance.isOffday && !attendance.isLeave)) ? \'redText\' : \'\')">{{attendance.lastLoggedTime}}{{(attendance.isHalfDay && attendance.leaveQuarter == 2)? " H2":""}}</span> <span ng-if="attendance.exitManual && attendance.logPunchType!=5" class="manual-text"><br><span translate="">{{\'profile.manualEntry\'}}</span></span> <span ng-if="attendance.exitManual && attendance.logPunchType==5" class="manual-text"><br><span translate="">{{\'profile.fieldVisit\'}}</span></span></td><td class="text-center" ng-show="attendance.isPresent"><span ng-class="((attendance.isInadequate &&(!attendance.isSpecialDay && !attendance.isHoliday && !attendance.isOffDay && !attendance.isLeave)) ? \'redText\' : \'\')">{{attendance.totalHour}}</span></td></tr></tbody></table></div><div class="text-center"><nav aria-label="Page navigation"><ul class="pagination"><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPage==$index)? \'active\':\'\'"><a class="page-link" ng-click="vm.showChunks($index)">{{$index+1}}</a></li></ul></nav></div><br><div><h3 class="panel-title section-margin-top mb-10" translate="">{{\'profile.lateEntriesHeading\'}}</h3><div class="bg-EEEEEE"><table class="table report-table report-table-font-14"><thead><tr><th class="headers2 text-center">{{\'date\'|translate}}</th><th class="headers2 text-center">{{\'entryTime\'|translate}}</th><th class="headers2 text-center">{{\'lateBy\'|translate}}</th><th class="headers2 text-left">{{\'reason\'|translate}}</th><th class="headers2 text-center">{{\'approvalOne\'|translate}}</th><th class="headers2 text-center">{{\'approvalTwo\'|translate}}</th><th class="headers2 text-center">{{\'status\'|translate}}</th></tr></thead><tbody><tr ng-if="vm.lateAttendanceHistoryList.length > 0" ng-repeat="lateHistory in vm.lateAttendanceHistoryList"><td class="text-center">{{lateHistory.attDateInMilliseconds | date:\'dd MMMM yyyy\'}}</td><td class="text-center">{{lateHistory.entryTimeInMillis | date:\'hh:mm a\'}}</td><td class="text-center">{{lateHistory.lateBy}}</td><td class="text-left"><span ng-if="lateHistory.reason">{{lateHistory.reason}}</span> <span ng-if="!lateHistory.reason" translate="">{{\'profile.dashDash\'}}</span></td><td class="text-center"><div ng-if="lateHistory.firstLateApproverName">{{lateHistory.firstLateApproverName}}<br><span ng-if="lateHistory.firstLateApproverStatus==0" class="orange-text">{{ \'pending\' | translate}}</span> <span ng-if="lateHistory.firstLateApproverStatus==1" class="green-text">{{\'accepted\' | translate}}</span> <span ng-if="lateHistory.firstLateApproverStatus==2" class="red-text">{{\'rejected\' | translate}}</span><br><i ng-if="lateHistory.firstLateApproverComment">&#34;{{lateHistory.firstLateApproverComment}}&#34;</i> <span ng-if="!lateHistory.firstLateApproverComment" translate="">{{\'profile.noComment\'}}</span></div><div ng-if="!lateHistory.firstLateApproverName" translate="">{{\'profile.dashDash\'}}</div></td><td class="text-center"><div ng-if="lateHistory.secondLateApproverName">{{lateHistory.secondLateApproverName}}<br><span ng-if="lateHistory.secondLateApproverStatus==0" class="orange-text">{{ \'pending\' | translate}}</span> <span ng-if="lateHistory.secondLateApproverStatus==1" class="green-text">{{\'accepted\' | translate}}</span> <span ng-if="lateHistory.secondLateApproverStatus==2" class="red-text">{{\'rejected\' | translate}}</span><br><i ng-if="lateHistory.secondLateApproverComment">&#34;{{lateHistory.secondLateApproverComment}}&#34;</i> <span ng-if="!lateHistory.secondLateApproverComment" translate="">{{\'profile.noComment\'}}</span></div><div ng-if="!lateHistory.secondLateApproverName" translate="">{{\'profile.dashDash\'}}</div></td><td class="text-center"><span ng-if="lateHistory.approvalStatus == null">{{\'profile.notApplied\' | translate}}</span> <span ng-if="lateHistory.approvalStatus==0" class="orange-text">{{\'pending\' | translate}}</span> <span ng-if="lateHistory.approvalStatus==1" class="green-text">{{\'accepted\' | translate}}</span> <span ng-if="lateHistory.approvalStatus==2" class="red-text">{{\'rejected\' | translate}}</span></td></tr><tr ng-if="vm.lateAttendanceHistoryList.length == 0"><td colspan="7" class="text-center"><em translate="">{{\'noLateEntriesFound\'}}</em></td></tr></tbody></table></div></div><br><div><h3 class="panel-title section-margin-top mb-10" translate="">{{\'profile.summaryHeading\'}}</h3><div><table class="table report-table report-table-font-14"><thead><tr><th class="headers2 text-center" translate="">{{\'profile.present\'}}</th><th class="headers2 text-center" translate="">{{\'profile.absent\'}}</th><th class="headers2 text-center" translate="">{{\'profile.late\'}}</th><th class="headers2 text-center" translate="">{{\'profile.approvedLates\'}}</th><th class="headers2 text-center" translate="">{{\'profile.earlyExit\'}}</th><th class="headers2 text-center" translate="">{{\'profile.leave\'}}</th><th class="headers2 text-center" translate="">{{\'profile.offDays\'}}</th><th class="headers2 text-center" translate="">{{\'profile.holidays\'}}</th><th class="headers2 text-center" translate="">{{\'profile.specialDays\'}}</th><th class="headers2 text-center" translate="">{{\'profile.expectedHours\'}}</th><th class="headers2 text-center" translate="">{{\'profile.actualHours\'}}</th></tr></thead><tbody><tr><td class="text-center">{{vm.summary.totalPresent}}</td><td class="text-center">{{vm.summary.totalAbsent}}</td><td class="text-center">{{vm.summary.totalLateEntry}}</td><td class="text-center">{{vm.summary.totalApprovedLateApplication}}</td><td class="text-center">{{vm.summary.totalEarlyExit}}</td><td class="text-center">{{vm.summary.totalLeave}}</td><td class="text-center">{{vm.summary.totalWeeklyOffdays}}</td><td class="text-center">{{vm.summary.totalHolidays}}</td><td class="text-center">{{vm.summary.totalSpecialDays}}</td><td class="text-center">{{vm.summary.totalExpectedWorkingHour}}</td><td class="text-center">{{vm.summary.totalWorkingHour}}</td></tr></tbody></table></div></div></div></upgrade-banner></div><br></div>');
$templateCache.put('app/pages/main/profile/attendance/manualEntryList/manualEntryList.html','<style>\n    .manual-entry-table{\n        overflow-y: auto;\n        /*height: 500px*/\n    }\n</style><div ng-controller="ManualEntryListCtrl as vm" class="mb-30"><h3 class="panel-title mb-20">{{\'manualEntry\'|translate}}</h3><div class="manual-entry-table"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip" ng-if="vm.manualEntryList.length > 0"><colgroup><col class="width-10"><col class="width-6"><col class="width-6"><col class="width-18"><col class="width-20"><col class="width-20"><col class="width-10"><col class="width-10"></colgroup><thead><tr><th class="text-center">{{\'timeLine\'|translate}}</th><th class="text-center">{{\'entryTime\'|translate}}</th><th class="text-center">{{\'exitTime\'|translate}}</th><th class="text-left">{{\'reason\'|translate}}</th><th class="text-center">{{\'secondApproval\'|translate}}</th><th class="text-center">{{\'firstApproval\'|translate}}</th><th class="text-center">{{\'type\'|translate}}</th><th class="text-center">{{\'status\'|translate}}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="manualEntry in vm.manualEntryList"><td class="text-center">{{manualEntry.startDate | date:\'dd MMM yyyy\'}} <span ng-if="manualEntry.type == 3 && (manualEntry.startDate != manualEntry.endDate)"><br>{{\'to\'|translate}}<br>{{manualEntry.endDate | date :\'dd MMMM yyyy\' }}</span></td><td class="text-center">{{manualEntry.entryTime | date :\'hh:mm a\'}}</td><td class="text-center" ng-if="manualEntry.exitTime != null">{{manualEntry.exitTime | date :\'hh:mm a\'}}</td><td class="text-center" ng-if="manualEntry.exitTime == null" translate="">{{\'commonKeywords.na\'}}</td><td class="text-left">{{manualEntry.reason}}</td><td class="text-center">{{manualEntry.secondManualEntryApproverName}}<br><span ng-if="manualEntry.secondManualEntryApprovalStatus == 0 && manualEntry.secondManualEntryApproverId != null" class="orange-text">{{ \'pending\' | translate}}</span> <span ng-if="manualEntry.secondManualEntryApprovalStatus == 0 && manualEntry.secondManualEntryApproverId == null"><em>{{ \'notApplicable\' | translate}}</em></span> <span ng-if="manualEntry.secondManualEntryApprovalStatus==1" class="green-text">{{ \'accepted\' | translate}}</span> <span ng-if="manualEntry.secondManualEntryApprovalStatus==2" class="red-text">{{ \'rejected\' | translate}}</span><br><em ng-if="manualEntry.secondManualEntryApproverComment">&#34;{{manualEntry.secondManualEntryApproverComment}}&#34;</em></td><td class="text-center">{{manualEntry.firstManualEntryApproverName}}<br><span ng-if="manualEntry.firstManualEntryApprovalStatus ==0 && manualEntry.firstManualEntryApproverId != null" class="orange-text">{{ \'pending\' | translate}}</span> <span ng-if="manualEntry.firstManualEntryApprovalStatus == 0 && manualEntry.firstManualEntryApproverId == null"><em>{{ \'notApplicable\' | translate}}</em></span> <span ng-if="manualEntry.firstManualEntryApprovalStatus==1 || manualEntry.firstManualEntryApproverId == null" class="green-text">{{ \'accepted\' | translate}}</span> <span ng-if="manualEntry.firstManualEntryApprovalStatus == 2" class="red-text">{{ \'rejected\' | translate}}</span><br><em ng-if="manualEntry.firstManualEntryApproverComment">&#34;{{manualEntry.firstManualEntryApproverComment}}&#34;</em></td><td ng-if="manualEntry.type==1" class="text-center">{{\'manualEntry\'|translate}}</td><td ng-if="manualEntry.type==2" class="text-center">{{\'missingPunch\'|translate}}</td><td ng-if="manualEntry.type==3" class="text-center">{{\'fieldVisitText\'|translate}}</td><td ng-if="manualEntry.status==0" class="text-center orange-text">{{ \'pending\' | translate}}</td><td ng-if="manualEntry.status==1" class="text-center green-text">{{ \'accepted\' | translate}}</td><td ng-if="manualEntry.status==2" class="text-center red-text">{{ \'rejected\' | translate}}</td><td ng-if="manualEntry.status==3" class="text-center red-text">{{ \'cancelled\' | translate}}</td></tr></tbody></table></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="text-center" ng-if="vm.isDataLoaded && vm.manualEntryList.length == 0"><i translate="">noManualEntryFound</i></div></div>');
$templateCache.put('app/pages/main/profile/enrol/delete/deleteEnrolment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">Do you want to delete the enrolment for {{vm.enrolmentsToDelete.hand}} hand {{vm.enrolmentsToDelete.finger}} finger?</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button id="deleteAddressButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteEnrolments()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/late-approval/apply/applyForLateApproval.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">applyForLateApproval</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div><label class="required" translate="">selectADate</label><div id="applyForLateDate" isteven-multi-select="" selection-mode="single" input-model="vm.select.lateAttendanceDates" output-model="vm.select.selectedDate" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="col mt-10"><label class="required" translate="">reason</label><div><textarea id="reason" class="form-control" placeholder="Write reason here" ng-model="vm.reason"></textarea></div></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button id="applyForLateApprovalModal" type="button" class="btn btn-md btn-secondary" ng-click="vm.applyForLateApproval()" translate="">apply</button></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/apply/applyForLeave.modal.html','<style>\n    textarea.form-control {\n        height: 37px;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'profile.applyForLeaveHeading\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="text-center mb-10" ng-show="!vm.isRemainingLeaveDataLoaded && (vm.selectedCategoryPolicyConfig == null || vm.selectedCategoryPolicyConfig.earnedLeaveCriteria == 0)"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="row bottom" ng-if="vm.selectedCategoryPolicyConfig == null || vm.selectedCategoryPolicyConfig.earnedLeaveCriteria == 0"><div class="col-md-12"><table class="table table-bordered" ng-if="vm.remainingLeavesList.length > 0"><thead><tr class="bg-prime"><th class="text-left" translate="">{{\'applyLeave.remainingLeaveTableHeader.category\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.total\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.used\'}}</th><th class="text-center" translate="">{{\'profileLeave.remainingLeaves\'}}</th></tr></thead><tbody><tr ng-repeat="remainingLeaves in vm.remainingLeavesList"><td class="text-left">{{remainingLeaves.leaveCategoryPolicyConfig.leaveCategory.name}}</td><td class="text-center">{{remainingLeaves.total}}</td><td class="text-center">{{remainingLeaves.used}}</td><td class="text-center">{{remainingLeaves.remainingLeaveCount}}</td></tr></tbody></table></div></div><div class="row" ng-show="vm.isRemainingLeaveDataLoaded || vm.selectedCategoryPolicyConfig != null"><div class="col-md-12 mb-negative-15"><div class="row mb-15"><div class="col-md-12"><label class="required" translate="">year</label></div><div class="col-md-12"><div class="custom-select"><select class="form-control" ng-model="vm.selectedDateRange" ng-options="range for range in vm.dateRangeList"><option value="" disabled="">{{\'applyLeave.pleaseSelect\' | translate}}</option></select></div></div></div><div class="row mb-15"><div class="col-md-12"><label class="required" translate="">leaveCategory</label></div><div class="col-md-12"><div class="custom-select"><select ng-model="vm.selectedCategoryPolicyConfig" ng-change="vm.determineEarnedLeaveTypeAndShowUI()" ng-options="remainingLeave.leaveCategoryPolicyConfig as remainingLeave.leaveCategoryPolicyConfig.leaveCategory.name for remainingLeave in vm.remainingLeavesList"><option value="" translate="">selectACategory</option></select></div></div></div><div class="row" ng-if="vm.selectedCategoryPolicyConfig != null"><div class="col-md-12"><label class="required" translate="">type</label></div><div class="col-md-12"><div class="custom-select"><select ng-model="vm.selectedTypeId"><option value="" selected="">Select A Type</option><option value="1" translate="">full</option><option value="2" ng-disabled="vm.selectedCategoryPolicyConfig != null && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria == 1" translate="">half</option></select></div></div></div><br><div ng-if="vm.selectedTypeId == 1 && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria == 0" include-with-scope="app/pages/main/profile/leave/apply/partials/fullDayLeave.html"></div><div ng-if="vm.selectedTypeId == 2 && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria == 0" include-with-scope="app/pages/main/profile/leave/apply/partials/halfDayLeave.html"></div><div ng-if="vm.selectedCategoryPolicyConfig != null && vm.selectedCategoryPolicyConfig.earnedLeaveCriteria == 1" include-with-scope="app/pages/main/profile/leave/apply/partials/exchangeLeavePartial.html"></div><br></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-disabled="vm.isApplyButtonEnabled()" ng-click="vm.applyForLeave()"><span ng-show="!vm.isSubmitRequestPending" translate="">apply</span> <span ng-show="vm.isSubmitRequestPending" translate="">pleaseWait</span></button></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/leave-adjust/leaveAdjust.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'profile.leaveAdjustment\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><table class="table table-bordered table-header" ng-if="vm.isAdjustModalDataLoaded"><colgroup><col class="width-33_33"><col class="width-33_33"><col class="width-33_33"></colgroup><thead><tr class="dont-wrap-text"><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.details\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.previous\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.updated\'}}</th></tr></thead><tbody class="padding-on-select"><tr class="dont-wrap-text"><td class="dont-wrap-text text-left" translate="">{{\'commonKeywords.category\'}}</td><td class="dont-wrap-text text-left"><span>{{vm.leaveInfoDetails.currentVersionCategoryName}}</span></td><td class="dont-wrap-text"><div class="custom-select"><select ng-model="vm.selectedLeaveCategoryId" ng-change="vm.setMinimumApplicableDate()" ng-options="remainingLeave.leaveCategoryId as remainingLeave.leaveCategoryPolicyConfig.leaveCategory.name for remainingLeave in vm.categoryList"></select></div></td></tr><tr class="dont-wrap-text"><td class="dont-wrap-text text-left" translate="">{{\'commonKeywords.dateRange\'}}</td><td class="dont-wrap-text text-left"><span ng-if="vm.leaveInfoDetails.currentVersionStartDate && vm.leaveInfoDetails.currentVersionEndDate">{{vm.leaveInfoDetails.currentVersionStartDate | date:\'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.leaveInfoDetails.currentVersionEndDate | date:\'d MMM yyyy\'}}</span> <span ng-if="!vm.leaveInfoDetails.currentVersionStartDate && !vm.leaveInfoDetails.currentVersionEndDate" translate="">{{\'commonKeywords.na\'}}</span></td><td class="dont-wrap-text"><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.leaveDatePicker.date" options="vm.leaveDatePicker.options"><span class="date-position-left">{{vm.leaveDatePicker.date.startDate.format("D MMM YYYY")}} {{\'commonKeywords.smallTo\' | translate}} {{vm.leaveDatePicker.date.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.numberOfDays\'}}</td><td class="dont-wrap-text" ng-if="vm.leaveInfoDetails.currentVersionNumberOfDays == null"><span translate="">{{\'commonKeywords.na\'}}</span></td><td class="dont-wrap-text" ng-if="vm.leaveInfoDetails.currentVersionNumberOfDays !== null"><span>{{vm.leaveInfoDetails.currentVersionNumberOfDays}}</span></td><td class="dont-wrap-text"><span>{{vm.numberOfDays}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.leaveType\'}}</td><td class="dont-wrap-text"><span>{{vm.leaveInfoDetails.currentVersionTypeName}}</span></td><td class="dont-wrap-text"><div class="custom-select"><select class="cursor-not-allowed" disabled="" ng-model="vm.selectedLeaveType"><option value="Full" translate="">{{\'profile.full\'}}</option><option value="Half" translate="">{{\'profile.half\'}}</option></select></div></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'profile.leaveReason\'}}</td><td class="dont-wrap-text"><span>{{vm.leaveInfoDetails.currentVersionReason}}</span></td><td class="dont-wrap-text text-left-important"><input type="text" class="form-control" ng-model="vm.reason"></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'profile.uploadAFile\'}}</td><td class="dont-wrap-text" ng-if="!vm.leaveInfoDetails.currentVersionFileUrl" translate="">{{\'profile.noFileSubmitted\'}}</td><td class="dont-wrap-text" ng-if="vm.leaveInfoDetails.currentVersionFileUrl">{{vm.leaveInfoDetails.currentVersionFileUrl}}</td><td class="dont-wrap-text text-center"><input class="ml-7" type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,.docx,.doc,j.pg,.jpeg,.png\'"></td></tr></tbody></table><div class="row align-items-center"><div class="col-md-12 col-sm-6" ng-if="! vm.isAdjustModalDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="mt-50"><div class="text-center" ng-if="vm.showConfirmation && !vm.isYesBtnClicked"><h4><span translate="">{{\'profile.areYouSureHeading\'}}</span></h4><h5 class="font-16"><span translate="">{{\'profile.notificationOrMessageSentHeading\'}}</span></h5></div><div class="text-center" ng-if="vm.showConfirmation && vm.isYesBtnClicked"><h4><span translate="">{{\'profile.pleaseWaitText\'}}</span></h4><h5 class="font-16"><span translate="">{{\'profile.yourApplicationBeingProcessed\'}}</span></h5></div><div class="d-flex-flex-end-10" ng-if="vm.showConfirmation"><button type="button" class="btn btn-md btn-primary" ng-click="vm.saveLeaveAdjustment()" ng-disabled="vm.isYesBtnClicked" translate="">{{\'commonKeywords.yesButton\'}}</button> <button type="button" class="btn btn-danger pull-right" ng-click="$dismiss()" ng-disabled="vm.isYesBtnClicked" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button></div><div class="d-flex-flex-end-10" ng-if="!vm.showConfirmation"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.confirmLeaveAdjustment()" translate="">{{\'commonKeywords.saveChangesButton\'}}</button></div></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/leave-cancel/leaveCancel.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.leaveCancellation\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><table class="table table-bordered table-header" ng-if="vm.isCancelModalDataLoaded"><colgroup><col class="width-40"><col class="width-40"></colgroup><thead><tr class="dont-wrap-text"><th class="text-left dont-wrap-text font-15" translate="">{{\'profile.details\'}}</th><th class="text-left dont-wrap-text font-15" translate="">{{\'profile.submittedInformation\'}}</th></tr></thead><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.category\'}}</td><td class="dont-wrap-text"><span>{{vm.updatedLeaveInfo.currentVersionCategoryName}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.dateRange\'}}</td><td class="dont-wrap-text"><span>{{vm.updatedLeaveInfo.currentVersionStartDate | date:\'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.updatedLeaveInfo.currentVersionEndDate | date:\'d MMM yyyy\'}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.numberOfDays\'}}</td><td class="dont-wrap-text"><span>{{vm.updatedLeaveInfo.currentVersionNumberOfDays}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.leaveType\'}}</td><td class="dont-wrap-text"><span>{{vm.updatedLeaveInfo.currentVersionTypeName}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.reason\'}}</td><td class="dont-wrap-text"><span>{{vm.updatedLeaveInfo.currentVersionReason}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text required" translate="">{{\'profile.reasonOfCancellation\'}}</td><td class="dont-wrap-text"><input type="text" class="form-control" placeholder="{{\'profile.reasonOfCancellationPlaceholder\' | translate}}" ng-model="vm.reasonOfCancellation"></td></tr></tbody></table><div class="row align-items-center"><div class="col-md-12 col-sm-6" ng-if="! vm.isCancelModalDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="mt-30"><div class="text-center" ng-if="vm.showConfirmation && ! vm.isYesButtonClicked"><h4><span translate="">{{\'profile.areYouSureHeading\'}}</span></h4><h5 class="font-16"><span translate="">{{\'profile.notificationOrMessageSentHeading\'}}</span></h5></div><div class="text-center" ng-if="vm.showConfirmation && vm.isYesButtonClicked"><h4><span translate="">{{\'profile.pleaseWaitText\'}}</span></h4><h5 class="font-16"><span translate="">{{\'profile.yourApplicationBeingProcessed\'}}</span></h5></div><div class="d-flex-flex-end-10" ng-if="vm.showConfirmation"><button type="button" class="btn btn-md btn-primary" ng-click="vm.cancelLeaveApplication()" ng-disabled="vm.isYesButtonClicked" translate="">{{\'commonKeywords.yesButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$dismiss()" ng-disabled="vm.isYesButtonClicked" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button></div><div class="d-flex-flex-end-10" ng-if="!vm.showConfirmation"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.confirmCancelConformation()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/partials/dummyModal.html','<style>\n    .modal-div{\n        height: 6vh;\n        margin-left:20px;\n        margin-right:20px;\n        border: 1px solid #edf0ee;\n        background:#edf0ee;\n    }\n    .dummy-btn{\n        height: 2vh;\n        width: 95%;\n    }\n    .top-btn{\n        margin-bottom:4%;\n        margin-top: 10%;\n    }\n    .bottom-btn{\n        margin-bottom:8%\n    }\n</style><div class="modal-content dummy-modal-placement col-md-8 col-sm-8"><div class="row"><div class="col-md-12"><h5 class="modal-title text-center mb-20 mt-30 color-prime" translate="">{{\'commonKeywords.dummyModalText\'}}</h5></div></div><div class="row modal-div mb-40"><div class="col-md-12 prevent-clicks"><div class="row"><div class="col-md-2 col-xs-2 pr-0"><img class="height-6-vh width-80 border-radius-35" ng-src="../assets/img/theme/no-photo.png"></div><div class="col-md-3 col-xs-3 pl-0"><div class="height-1_1-vh width-100 dummy-line1-bg border-radius-10 mt-15"></div><div class="height-0_6-vh width-80 dummy-line2-bg border-radius-10 mt-6"></div></div><div class="col-md-1 col-xs-1 pl-0"><div class="height-1_1-vh width-150 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pr-0"><div class="height-1_1-vh width-100 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pr-0"><div class="height-1_1-vh width-75 dummy-line1-bg border-radius-10 mt-15"></div><div class="height-0_6-vh width-60 dummy-line2-bg border-radius-10 mt-6"></div></div><div class="col-md-2 col-xs-2 pl-0"><button class="btn btn-info dummy-btn top-btn"></button> <button class="btn btn-danger dummy-btn bottom-btn"></button></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/partials/leaveInformationAdjust.html','<div><h3 class="mt-25" translate="">{{\'profile.leaveAdjustApplicationInfoHeading\'}}</h3></div><div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-33_33"><col class="width-66_67"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'profile.applyDate\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.creationDate | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.firstApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span>{{vm.selectedLeaveApplication.firstApproverName}}</span> <span ng-if="vm.selectedLeaveApplication.firstApproverId">(<span ng-bind-html="vm.selectedLeaveApplication.firstApprovalDisplayString"></span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.secondApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span>{{vm.selectedLeaveApplication.secondApproverName}}</span> <span ng-if="vm.selectedLeaveApplication.secondApproverId">(<span ng-bind-html="vm.selectedLeaveApplication.secondApprovalDisplayString"></span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.appliedBy\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.nameOfAppliedBy}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.submittedFile\'}}</td><td class="dont-wrap-text color-22222"><span ng-if="!vm.selectedLeaveApplication.fileUrl" translate="">{{\'commonKeywords.noFileSubmitted\'}}</span> <a ng-if="!!vm.selectedLeaveApplication.fileUrl" href="{{vm.selectedLeaveApplication.fileUrl}}" target="_self" translate="">{{\'commonKeywords.download\'}}</a></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/profile/leave/partials/leaveInformationAdjustDifferenceTable.html','<table class="table table-bordered"><colgroup><col class="width-33_33"><col class="width-33_33"><col class="width-33_33"></colgroup><thead><tr class="text-center dont-wrap-text th-bg"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.details\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.previous\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.updated\'}}</th></tr></thead><tbody><tr class="text-center dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.category\'}}</td><td class="dont-wrap-text"><span class="text-danger" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionCategoryName !== vm.currentAndPreviousLeaveApplicationData.currentVersionCategoryName">{{vm.currentAndPreviousLeaveApplicationData.previousVersionCategoryName}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionCategoryName == vm.currentAndPreviousLeaveApplicationData.currentVersionCategoryName">{{vm.currentAndPreviousLeaveApplicationData.previousVersionCategoryName}}</span></td><td class="dont-wrap-text"><span class="text-success" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionCategoryName !== vm.currentAndPreviousLeaveApplicationData.currentVersionCategoryName">{{vm.currentAndPreviousLeaveApplicationData.currentVersionCategoryName}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionCategoryName == vm.currentAndPreviousLeaveApplicationData.currentVersionCategoryName">{{vm.currentAndPreviousLeaveApplicationData.currentVersionCategoryName}}</span></td></tr><tr class="text-center dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.leaveDate\'}}</td><td class="dont-wrap-text"><span class="text-danger" ng-if="(vm.currentAndPreviousLeaveApplicationData.previousVersionStartDate != vm.currentAndPreviousLeaveApplicationData.currentVersionStartDate) ||(vm.currentAndPreviousLeaveApplicationData.previousVersionEndDate != vm.currentAndPreviousLeaveApplicationData.currentVersionEndDate)">{{vm.currentAndPreviousLeaveApplicationData.previousVersionStartDate | date: \'d MMM yyyy\'}} to {{vm.currentAndPreviousLeaveApplicationData.previousVersionEndDate | date: \'d MMM yyyy\'}}</span> <span ng-if="(vm.currentAndPreviousLeaveApplicationData.previousVersionStartDate == vm.currentAndPreviousLeaveApplicationData.currentVersionStartDate) &&(vm.currentAndPreviousLeaveApplicationData.previousVersionEndDate == vm.currentAndPreviousLeaveApplicationData.currentVersionEndDate)">{{vm.currentAndPreviousLeaveApplicationData.previousVersionStartDate | date: \'d MMM yyyy\'}} to {{vm.currentAndPreviousLeaveApplicationData.previousVersionEndDate | date: \'d MMM yyyy\'}}</span></td><td class="dont-wrap-text"><span class="text-success" ng-if="(vm.currentAndPreviousLeaveApplicationData.previousVersionStartDate != vm.currentAndPreviousLeaveApplicationData.currentVersionStartDate) ||(vm.currentAndPreviousLeaveApplicationData.previousVersionEndDate != vm.currentAndPreviousLeaveApplicationData.currentVersionEndDate)">{{vm.currentAndPreviousLeaveApplicationData.currentVersionStartDate | date: \'d MMM yyyy\'}} to {{vm.currentAndPreviousLeaveApplicationData.currentVersionEndDate | date: \'d MMM yyyy\'}}</span> <span ng-if="(vm.currentAndPreviousLeaveApplicationData.previousVersionStartDate == vm.currentAndPreviousLeaveApplicationData.currentVersionStartDate) &&(vm.currentAndPreviousLeaveApplicationData.previousVersionEndDate == vm.currentAndPreviousLeaveApplicationData.currentVersionEndDate)">{{vm.currentAndPreviousLeaveApplicationData.currentVersionStartDate | date: \'d MMM yyyy\'}} to {{vm.currentAndPreviousLeaveApplicationData.currentVersionEndDate | date: \'d MMM yyyy\'}}</span></td></tr><tr class="text-center dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.numberOfDays\'}}</td><td class="dont-wrap-text"><span class="text-danger" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionNumberOfDays !== vm.currentAndPreviousLeaveApplicationData.currentVersionNumberOfDays">{{vm.currentAndPreviousLeaveApplicationData.previousVersionNumberOfDays}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionNumberOfDays == vm.currentAndPreviousLeaveApplicationData.currentVersionNumberOfDays">{{vm.currentAndPreviousLeaveApplicationData.previousVersionNumberOfDays}}</span></td><td class="dont-wrap-text"><span class="text-success" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionNumberOfDays !== vm.currentAndPreviousLeaveApplicationData.currentVersionNumberOfDays">{{vm.currentAndPreviousLeaveApplicationData.currentVersionNumberOfDays}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionNumberOfDays == vm.currentAndPreviousLeaveApplicationData.currentVersionNumberOfDays">{{vm.currentAndPreviousLeaveApplicationData.currentVersionNumberOfDays}}</span></td></tr><tr class="text-center dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.leaveType\'}}</td><td class="dont-wrap-text"><span class="text-danger" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionTypeName !== vm.currentAndPreviousLeaveApplicationData.currentVersionTypeName">{{vm.currentAndPreviousLeaveApplicationData.previousVersionTypeName}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionTypeName == vm.currentAndPreviousLeaveApplicationData.currentVersionTypeName">{{vm.currentAndPreviousLeaveApplicationData.previousVersionTypeName}}</span></td><td class="dont-wrap-text"><span class="text-success" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionTypeName !== vm.currentAndPreviousLeaveApplicationData.currentVersionTypeName">{{vm.currentAndPreviousLeaveApplicationData.currentVersionTypeName}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionTypeName == vm.currentAndPreviousLeaveApplicationData.currentVersionTypeName">{{vm.currentAndPreviousLeaveApplicationData.currentVersionTypeName}}</span></td></tr><tr class="text-center dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.reason\'}}</td><td class="dont-wrap-text"><span class="text-danger" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionReason !== vm.currentAndPreviousLeaveApplicationData.currentVersionReason">{{vm.currentAndPreviousLeaveApplicationData.previousVersionReason}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionReason == vm.currentAndPreviousLeaveApplicationData.currentVersionReason">{{vm.currentAndPreviousLeaveApplicationData.previousVersionReason}}</span></td><td class="dont-wrap-text"><span class="text-success" ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionReason !== vm.currentAndPreviousLeaveApplicationData.currentVersionReason">{{vm.currentAndPreviousLeaveApplicationData.currentVersionReason}}</span> <span ng-if="vm.currentAndPreviousLeaveApplicationData.previousVersionReason == vm.currentAndPreviousLeaveApplicationData.currentVersionReason">{{vm.currentAndPreviousLeaveApplicationData.currentVersionReason}}</span></td></tr></tbody></table>');
$templateCache.put('app/pages/main/profile/leave/partials/leaveInformationApplyAndCancel.html','<div class="row"><div class="col-md-12"><div class="mt-40 mb-15 color-22222 font-16 font-weight-500"><span translate="">{{\'profile.leaveApplicationInfoHeading\'}}</span> {{vm.selectedLeaveApplication.applicationEventType == 3 ? \'Cancel\' : \'Apply\'}}</div></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-33_33"><col class="width-66_67"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.category\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.categoryName}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'profile.applyDate\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.creationDate | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.dateRange\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.startDate | date:\'d MMM yyyy\'}} <span ng-if="vm.selectedLeaveApplication.numberOfDays > 1"><span translate="">{{\'commonKeywords.smallTo\'}}</span> {{vm.selectedLeaveApplication.endDate | date:\'d MMM yyyy\'}}</span> <span ng-if="vm.selectedLeaveApplication.numberOfDays == 1">(<span class="greenText" translate="">{{\'commonKeywords.oneDay\'}}</span>)</span> <span ng-if="vm.selectedLeaveApplication.numberOfDays == .5">(<span class="greenText" translate="">{{\'commonKeywords.halfDay\'}}</span>)</span> <span ng-if="vm.selectedLeaveApplication.numberOfDays > 1">(<span class="greenText">{{vm.selectedLeaveApplication.numberOfDays +\' days\'}}</span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.leaveType\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.typeName}}</td></tr><tr class="text-left dont-wrap-text" ng-if="vm.selectedLeaveApplication.type == 2"><td class="dont-wrap-text" translate="">{{\'commonKeywords.leaveHalf\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.leaveHalfName}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.reason\'}}</td><td class="dont-wrap-text color-22222"><span ng-if="!vm.selectedLeaveApplication.reason" translate="">{{\'commonKeywords.na\'}}</span> <span ng-if="vm.selectedLeaveApplication.reason">{{vm.selectedLeaveApplication.reason}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.firstApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span>{{vm.selectedLeaveApplication.firstApproverName}}</span> <span ng-if="vm.selectedLeaveApplication.firstApproverId">(<span ng-bind-html="vm.selectedLeaveApplication.firstApprovalDisplayString"></span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.firstApproverComment\'}}</td><td class="dont-wrap-text color-22222"><span ng-bind-html="vm.selectedLeaveApplication.firstApprovalComment"></span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.secondApproverStatus\'}}</td><td class="dont-wrap-text color-22222"><span>{{vm.selectedLeaveApplication.secondApproverName}}</span> <span ng-if="vm.selectedLeaveApplication.secondApproverId">(<span ng-bind-html="vm.selectedLeaveApplication.secondApprovalDisplayString"></span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.secondApproverComment\'}}</td><td class="dont-wrap-text color-22222"><span>{{!vm.selectedLeaveApplication.secondApprovalComment ? "No Comment": vm.selectedLeaveApplication.secondApprovalComment}}</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.appliedBy\'}}</td><td class="dont-wrap-text color-22222">{{vm.selectedLeaveApplication.nameOfAppliedBy}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text" translate="">{{\'commonKeywords.submittedFile\'}}</td><td class="dont-wrap-text color-22222"><span ng-if="!vm.selectedLeaveApplication.fileUrl" translate="">{{\'commonKeywords.noFileSubmitted\'}}</span> <a ng-if="!!vm.selectedLeaveApplication.fileUrl" href="{{vm.selectedLeaveApplication.fileUrl}}" target="_self" translate="">{{\'commonKeywords.download\'}}</a></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/profile/pendingApprovals/late/cancelLateLog.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="font-16 line-height-1_5">Do you want to cancel the late application?</div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.cancelLate()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/NotificationSettings/notificationSettings.html','<style>\n\n    table thead {\n        background: #ededed;\n    }\n\n    .strip-table > thead > tr > th {\n        background-color: var(--color-secondary);\n        color: white;\n        border: none;\n    }\n\n    .strip-table tbody tr td {\n        border-top: none !important;\n        border-right: none !important;\n        border-bottom: none !important;\n        border-left: none !important;\n    }\n</style><div class="col-md-12 p-all-0" ng-controller="NotificationSettingsCtrl as vm"><h3 class="panel-title with-line" translate="">{{\'profile.notificationSettings\'}}</h3><div class="position-relative"><div class="row"><div class="col-md-8"><label translate="">{{\'employeeActions.notification.selectGroup\'}}</label><div class="form-group"><div class="open-on-bottom" isteven-multi-select="" input-model="vm.select.notificationGroups" output-model="vm.select.selectedNotificationGroups" button-label="name" item-label="name" tick-property="ticked" output-properties="value" selection-mode="single" disable-property="disabled" on-item-click="vm.handleSelectNotificationGroup()"></div></div></div><div class="col-md-4"><div class="row mt-25"><div class="col-md-1 mt-10 mr-5"><strong>{{ vm.notificationsOn? \'On\' : \'Off\' }}</strong></div><div class="col-md-8 mt-3"><label class="custom-switch mt-10"><input name="enabled" ng-change="vm.handleNotificationOnOffButton()" ng-model="vm.notificationsOn" type="checkbox"><span class="slider round"></span></label></div></div></div><div class="col-md-12"><table ng-if="vm.isDataLoaded && vm.notificationsOn" class="table report-table report-table-font-14 mt-5"><thead><tr><td class="text-left" translate="">{{\'employeeActions.notification.selectRecipients\'}}</td><td class="text-left" translate="">{{\'employeeActions.notification.sms\'}}</td><td class="text-left" translate="">{{\'employeeActions.notification.email\'}}</td><td class="text-left" translate="">{{\'employeeActions.notification.pushNotification\'}}</td></tr></thead><tbody><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientSelf\' }}</span></td><td class="text-left" ng-repeat="checkbox in vm.selfCheckBoxes"><input class="cursor-pointer" ng-change="vm.isDataEdited=true" type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value"> <label class="cursor-pointer" for="{{checkbox.id}}">{{ checkbox.labelText | translate }}</label></td></tr><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientLineManager\' }}</span></td><td class="text-left" ng-repeat="checkbox in vm.lineManagerCheckBoxes"><input class="cursor-pointer" ng-change="vm.isDataEdited=true" type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value"> <label class="cursor-pointer" for="{{checkbox.id}}">{{ checkbox.labelText | translate }}</label></td></tr><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientHRManager\' }}</span></td><td class="text-left" ng-repeat="checkbox in vm.hrCheckBoxes"><input class="cursor-pointer" ng-change="vm.isDataEdited=true" type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value"> <label class="cursor-pointer" for="{{checkbox.id}}">{{ checkbox.labelText | translate }}</label></td></tr></tbody></table></div></div><div class="row"><div class="col-md-12"><div class="mt-20" ng-show="vm.isDataEdited"><div class="clearfix" ng-if="vm.isDataLoaded && vm.isDataEdited && vm.notificationsOn"><div><h5 class="text-uppercase" translate="">{{ \'employeeActions.notification.moreSettings\' }}</h5></div><br><div class="clearfix" ng-if="vm.select.selectedNotificationGroups[0].value===100"><p class="input-group"><label for="minBeforeStart" translate="">{{ \'employeeActions.notification.officeTimeNotifyBeforeStartTime\' }}</label> <input min="0" max="59" placeholder="Enter time between 1 and 59 minutes" id="minBeforeStart" ng-model="vm.officeTimeNotifyBeforeStartTime" type="number" class="form-control"></p></div><div class="clearfix" ng-if="vm.select.selectedNotificationGroups[0].value==400"><div class="col-md-3 mt-10"><span translate="">{{ \'employeeActions.notification.whenToCheckAbsent\' }}</span></div><div class="col-md-9"><div class="custom-select"><select ng-model="vm.whenToCheckAbsent" ng-options="option.name for option in vm.whenToCheckAbsentDropdown"></select></div></div></div><div class="clearfix" ng-if="vm.select.selectedNotificationGroups[0].value==900"><div class="col-md-3 mt-10"><span translate="">{{ \'employeeActions.notification.whenToCheckEarlyExit\' }}</span></div><div class="col-md-9"><div class="custom-select"><select ng-model="vm.whenToCheckEarlyExit" ng-options="option.name for option in vm.whenToCheckEarlyExitDropdown"></select></div></div></div></div></div><div class="mt-20" ng-show="vm.isDataEdited"><div class="text-right mr-20"><button class="btn btn-md btn-primary" ng-click="vm.saveNotificationSettings()"><span ng-if="!vm.isDataSaving" translate="">{{\'employeeActions.saveButton\'}}</span> <i ng-if="vm.isDataSaving" class="fa fa-cog fa-spin fa-fw"></i></button></div></div><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div ng-if="!vm.notificationsOn && vm.isDataLoaded"><div class="text-center"><br><br><p>Notification settings not found for this Group. <b>Click</b> the button to On Notification for this user</p><br></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/actions.partial.html','<style>\n  .section-placement{\n      margin-left: -25px\n  }\n  a.sn-link{\n      margin-bottom: 1px;\n  }\n  a.sn-link--disabled { opacity: .25; cursor: not-allowed; }\n</style><div ng-controller="ProfileActionCtrl as vm"><h3 class="panel-title with-line" translate="">{{\'profile.actions\'}}</h3><div class="social-profiles row clearfix section-placement" ng-show="vm.profileActions.length!=0"><div class="col-sm-12" ng-repeat="item in vm.profileActions" ng-if="item.isVisible"><upgrade-link code="item.code" ng-if="item.code"><a ng-class="(item.willBeSelected ? \'sn-link connected\':\'sn-link\') + (item.isDisabled ? \' sn-link--disabled\' : \'\')" ng-click="item.modalOpenerMethod()" ng-attr-aria-disabled="{{item.isDisabled}}"><i class="socicon {{ item.icon }}"></i><span>{{item.name |translate}}</span></a></upgrade-link><a ng-class="(item.willBeSelected ? \'sn-link connected\':\'sn-link\') + (item.isDisabled ? \' sn-link--disabled\' : \'\')" ng-click="item.modalOpenerMethod()" ng-attr-aria-disabled="{{item.isDisabled}}" ng-if="!item.code"><i class="socicon {{ item.icon }}"></i><span>{{ item.name |translate}}</span></a></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/details/details.partial.html','<style>\n   .main-section{\n       background: #f6f6f6;\n       min-height: 815px;\n       margin-top: -15px;\n       margin-bottom: -15px;\n       padding-top: 37px\n   }\n</style><div class="row main-section" ng-controller="ProfileDetailsAccordionCtrl as vm"><div class="col-md-12"><div class="col-md-12" include-with-scope="app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePic.partial.html"></div></div><div class="col-md-12"><div class="row"><div class="col-sm-12 p-all-0"><a ng-class="vm.profileTabs[0].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[0].action()"><span>{{ vm.profileTabs[0].name }}</span></a></div><div class="col-sm-12 p-all-0"><a ng-class="vm.profileTabs[1].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[1].action()"><span>{{ vm.profileTabs[1].name }}</span></a></div><div class="col-sm-12 p-all-0"><a ng-class="vm.profileTabs[2].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[2].action()"><span>{{ vm.profileTabs[2].name }}</span></a></div><div class="col-sm-12 p-all-0"><a ng-class="vm.profileTabs[3].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[3].action()"><span>{{ vm.profileTabs[3].name }}</span></a></div><div class="col-sm-12 p-all-0" ng-if="vm.canEditPermission"><a ng-class="vm.profileTabs[4].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[4].action()"><span>{{ vm.profileTabs[4].name }}</span></a></div><div class="col-sm-12 p-all-0" style="padding: 0px;"><upgrade-link ng-if="!vm.hasPermission(\'2007\')"><a ng-class="vm.profileTabs[5].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[5].action()"><span>{{ vm.profileTabs[5].name }}</span></a></upgrade-link></div><div class="col-sm-12 p-all-0"><a ng-class="vm.profileTabs[6].isActive ? \'sn-tab active\':\'sn-tab\'" ng-click="vm.profileTabs[6].action()"><span>{{ vm.profileTabs[6].name }}</span></a></div><div class="col-sm-12 p-all-0"><upgrade-link code="2008"><a ng-class="vm.profileTabs[7].isActive ? \'sn-tab last active\':\'sn-tab last\'" ng-click="vm.profileTabs[7].action()"><span>{{ vm.profileTabs[7].name }}</span></a></upgrade-link></div><div class="col-sm-12 p-all-0"><a ng-class="vm.profileTabs[8].isActive ? \'sn-tab last active\':\'sn-tab last\'" ng-click="vm.profileTabs[8].action()"><span>{{ vm.profileTabs[8].name }}</span></a></div><div class="col-sm-12 p-all-0" ng-if="vm.profileTabs[9].isVisible"><a ng-class="vm.profileTabs[9].isActive ? \'sn-tab last active\':\'sn-tab last\'" ng-click="vm.profileTabs[9].action()"><span>{{ vm.profileTabs[9].name }}</span></a></div><div class="col-sm-12 p-all-0" ng-if="vm.profileTabs[10].isVisible && vm.canEditPermission"><a ng-class="vm.profileTabs[10].isActive ? \'sn-tab last active\':\'sn-tab last\'" ng-click="vm.profileTabs[10].action()"><span>{{ vm.profileTabs[10].name }}</span></a></div><div class="col-sm-12 p-all-0" ng-if="vm.profileTabs[11].isVisible"><a ng-class="vm.profileTabs[11].isActive ? \'sn-tab last active\':\'sn-tab last\'" ng-click="vm.profileTabs[11].action()"><span>{{ vm.profileTabs[11].name }}</span></a></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/document/documents.html','<div class="col-md-12 addressDiv p-all-0" ng-controller="DocumentsCtrl as vm"><h3 class="panel-title with-line">{{\'profile.documents\' | translate}} <i id="addDocumentButton" ng-if="!vm.isGeneralEmployeeOrLineManager" class="ion-android-add-circle pull-right font-30 cursor-pointer" ng-click="vm.openCreateModal()"></i></h3><div ng-if="vm.isDataLoaded && vm.documentList.length == 0" class="text-center"><em>{{\'employeeDocuments.notFound\'|translate}}</em></div><div class="row"><div class="col-md-12"><table class="table table-bordered table-header" id="addressTable" ng-repeat="document in vm.documentList" ng-if="vm.isDataLoaded && vm.documentList.length > 0"><colgroup><col class="width-30"><col class="width-35"><col class="width-20"><col class="width-15"></colgroup><thead><tr><th>{{\'type\'|translate}}</th><th class="text-left">{{\'description\'|translate}}</th><th class="text-center">{{\'link\'|translate}}</th><th class="text-center">{{\'remove\'|translate}}</th></tr></thead><tbody><tr><td><span ng-if="document.type==1">{{\'employeeDocuments.ssc\'|translate}}</span> <span ng-if="document.type==2">{{\'employeeDocuments.hsc\'|translate}}</span> <span ng-if="document.type==3">{{\'employeeDocuments.bachelors\'|translate}}</span> <span ng-if="document.type==4">{{\'employeeDocuments.passport\'|translate}}</span> <span ng-if="document.type==5">{{\'employeeDocuments.nid\'|translate}}</span> <span ng-if="document.type==6">{{\'employeeDocuments.cv\'|translate}}</span></td><td class="text-left">{{document.description}}</td><td class="text-center"><span><a ng-click="vm.analyticsDownloadUrl()" href="{{document.url}}" translate="">{{\'commonKeywords.download\'}}</a></span></td><td id="{{document.id}}Delete" class="text-center"><button class="btn btn-sm btn-danger" ng-disabled="vm.isGeneralEmployeeOrLineManager" ng-click="vm.openDeleteModal(document.id)">{{\'remove\'|translate}}</button></td></tr></tbody></table><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/education/educationHistory.html','<style>\n    .info-box {\n        padding-top: 12px;\n        padding-bottom: 8px;\n    }\n    .clickable-link{\n        color: #222222;\n    }\n    .clickable-link:hover{\n        cursor: pointer;\n        color: #209e91;\n    }\n</style><div ng-controller="EducationHistoryCtrl as vm"><div><h3 class="panel-title with-line">{{\'educationHistory.educationHistory\' | translate}} <i id="addEducationHistory" class="ion-android-add-circle pull-right font-30 cursor-pointer" ng-click="vm.openCreateModal()" ng-if="!vm.isGeneralEmployeeOrLineManager"></i></h3></div><div class="col-md-12 p-all-0"><div ng-if="vm.isEducationHistoryLoaded && vm.educationHistoryList.length == 0" class="text-center"><a ng-if="!vm.isGeneralEmployeeOrLineManager" class="page-link clickable-link" ng-click="vm.openCreateModal()"><em>{{\'educationHistory.notFound\' | translate}}</em></a> <span ng-if="vm.isGeneralEmployeeOrLineManager"><em>{{\'educationHistory.notFound\' | translate}}</em></span></div><div class="row" ng-repeat="history in vm.educationHistoryList" ng-if="vm.isEducationHistoryLoaded && vm.educationHistoryList.length > 0"><div class="col-md-12"><div class="d-flex-space-between mb-10 mt-20"><h3 class="mb-0">{{$index + 1 }}. {{history.name}}</h3><div ng-if="!vm.isGeneralEmployeeOrLineManager" class="d-flex-flex-end-10 align-items-center"><div><button id="{{history.id}}Edit" class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(history)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button></div><div><button id="{{history.id}}Delete" class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(history)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div></div></div><div class="col-md-12 info-box info-box-top"><label class="col-sm-4 control-label">{{\'educationHistory.institution\' | translate}}</label> <span>{{history.institution}}</span></div><div class="col-md-12 info-box info-box-top border-top-0"><label class="col-sm-4 control-label">{{\'educationHistory.board\' | translate}}</label> <span>{{history.board}}</span></div><div class="col-md-12 info-box info-box-top border-top-0"><label class="col-sm-4 control-label">{{\'educationHistory.year\' | translate}}</label> <span>{{history.year}}</span></div><div class="col-md-12 info-box info-box-top border-top-0"><label class="col-sm-4 control-label">{{\'educationHistory.grade\' | translate}}</label> <span>{{history.grade}}</span></div></div></div><div class="row text-center" ng-if="!vm.isEducationHistoryLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/employment/employmentHistory.html','<style>\n    .section-style{\n        white-space: pre;\n        height:83px;\n        overflow: auto;\n        margin-bottom: 0px\n    }\n    .clickable-link{\n        color: #222222;\n    }\n    .clickable-link:hover{\n        cursor: pointer;\n        color: #209e91;\n    }\n</style><div ng-controller="EmploymentHistoryCtrl as vm"><h3 class="panel-title with-line">{{\'employmentHistory.employmentHistory\' | translate}} <i class="ion-android-add-circle pull-right font-30 cursor-pointer" ng-if="!vm.isGeneralEmployeeOrLineManager" ng-click="vm.openCreateModal()" id="addEmploymentHistoryButton"></i></h3><div class="col-md-12"><div ng-if="vm.isEmploymentHistoryLoaded && vm.employmentHistoryList.length == 0" class="text-center"><a ng-if="!vm.isGeneralEmployeeOrLineManager" ng-click="vm.openCreateModal()" class="clickable-link"><em class="color">{{\'employmentHistory.notFound\' | translate}}</em></a> <span ng-if="vm.isGeneralEmployeeOrLineManager"><em class="color">{{\'employmentHistory.notFound\' | translate}}</em></span></div><div class="row m-all-0 mb-30" ng-repeat="history in vm.employmentHistoryList" ng-if="vm.isEmploymentHistoryLoaded && vm.employmentHistoryList.length > 0"><div class="row"><div class="col-md-8"><h4 class="color-444444">{{history.designation}}</h4><h5 class="color-999999">{{history.companyName}}</h5></div><div ng-if="!vm.isGeneralEmployeeOrLineManager" class="col-md-4 pt-25 d-flex-flex-end-10 mb-5"><button id="{{history.id}}editHistory" class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(history)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button id="{{history.id}}deleteHistoryButton" class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(history)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></div></div><div class="col-md-6"><div class="row"><div class="col-md-12 info-box info-box-top"><div class="col-md-12 bottom"><b>{{\'employmentHistory.companyBusiness\' | translate}}</b></div><div class="col-md-12">{{history.companyBusiness}}</div></div><div class="col-md-12 info-box"><div class="col-md-12 bottom"><b>{{\'location\' | translate}}</b></div><div class="col-md-12">{{history.companyLocation}}</div></div><div class="col-md-12 info-box"><div class="col-md-12 bottom"><b>{{\'department\' | translate}}</b></div><div class="col-md-12">{{history.department}}</div></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12 info-box info-box-top"><div class="col-md-6"><b>{{\'startDate\' | translate}}</b></div><div class="col-md-6 bottom">{{history.employmentStart | date :\'dd-MMM-yyyy\'}}</div><div class="col-md-6"><b>{{\'endDate\' | translate}}</b></div><div class="col-md-6">{{history.employmentEnd | date :\'dd-MMM-yyyy\'}}</div></div><div class="col-md-12 info-box"><div class="col-md-12 bottom"><b>{{\'responsibilities\' | translate}}</b></div><div class="col-md-12"><p class="section-style">{{history.responsibilities}}</p></div></div></div></div></div><div class="row text-center" ng-if="!vm.isEmploymentHistoryLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/address.accordion.partial.html','<div class="col-md-12 addressDiv p-all-0"><h3 class="panel-title with-line">{{\'address\'|translate}} <i class="ion-android-add-circle pull-right font-30 cursor-pointer" id="addAddressButton" ng-if="!vm.isGeneralEmployeeOrLineManager" ng-click="vm.openAddAddressModal()"></i></h3><p class="text-center" ng-if="vm.isAddressDataLoaded && vm.user.addresses.length == 0">{{\'address.noAddressFound\'|translate}}.</p><table class="table table-bordered" id="addressTable" ng-repeat="address in vm.user.addresses" ng-if="vm.isAddressDataLoaded && vm.user.addresses.length > 0"><colgroup><col class="width-20"><col class="width-80"></colgroup><tbody><tr class="border-0"><td class="border-0"><a href="#" editable-select="address.type" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-options="type.value as type.type for type in vm.addressTypeList.list" onbeforesave="vm.updateAddress({ \'type\' : $data } , address.id)"><span ng-if="address.type == 1">{{\'address.permanent\' | translate}}</span> <span ng-if="address.type == 2">{{\'address.present\' | translate}}</span> <span ng-if="address.type == 3">{{\'address.home\' | translate}}</span></a><div ng-if="vm.isGeneralEmployeeOrLineManager"><span ng-if="address.type == 1">{{\'address.permanent\' | translate}}</span> <span ng-if="address.type == 2">{{\'address.present\' | translate}}</span> <span ng-if="address.type == 3">{{\'address.home\' | translate}}</span></div></td><td class="text-right border-0">{{A}} <button ng-if="!vm.isGeneralEmployeeOrLineManager" id="deleteAddressButton" class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteAddressModal(address,$index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr><tr><td><strong class="customLabel">{{\'address.address\'|translate}}</strong></td><td><a href="#" editable-text="address.address" ng-if="!vm.isGeneralEmployeeOrLineManager" onbeforesave="vm.updateAddress({ \'address\' : $data } , address.id)">{{ address.address || \'empty\'}}</a> <span ng-if="vm.isGeneralEmployeeOrLineManager">{{ address.address || \'empty\'}}</span></td></tr><tr><td><strong class="customLabel">{{\'address.subDistrict\' | translate}}</strong></td><td><a href="#" editable-text="address.thana" ng-if="!vm.isGeneralEmployeeOrLineManager" onbeforesave="vm.updateAddress({ \'thana\' : $data } , address.id)">{{ address.thana|| \'empty\'}}</a> <span ng-if="vm.isGeneralEmployeeOrLineManager">{{ address.thana|| \'empty\'}}</span></td></tr><tr><td><strong class="customLabel">{{\'address.district\' | translate}}</strong></td><td><a href="#" editable-text="address.district" ng-if="!vm.isGeneralEmployeeOrLineManager" onbeforesave="vm.updateAddress({ \'district\' : $data } , address.id)">{{ address.district || \'empty\'}}</a> <span ng-if="vm.isGeneralEmployeeOrLineManager">{{ address.district || \'empty\'}}</span></td></tr></tbody></table><div class="row text-center" ng-if="!vm.isAddressDataLoaded"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/approverInfo.partial.html','<style>\n    .all-labels label{\n        color:#555555;\n        font-size: 14px;\n    }\n    .info-box {\n        padding-top: 12px;\n        padding-bottom: 8px;\n    }\n    .multiselect-modification .multiSelect > button {\n        color:#555555;\n        opacity: 1!important;\n    }\n    .multiselect-modification .multiSelect .helperButton{\n        display: none;\n    }\n</style><div class="all-labels"><h3 class="panel-title with-line" translate="">{{\'profile.approverInfoHeading\'}}</h3><div class="row multiselect-modification"><div class="col-md-12 p-all-0"><upgrade-banner code="[\'2014\']"><div class="col-md-12" ng-if="vm.isDataReady"><div class="col-md-12 info-box info-box-top"><label class="col-sm-4 control-label" ng-class="{\'mt-10\':!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser}">{{\'approverInformation.firstLeaveApprover\' | translate}}</label><upgrade-link code="2014"><div class="col-md-6" ng-if="!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser"><div isteven-multi-select="" input-model="vm.allFirstLeaveApprover" output-model="vm.firstLeaveApprover" on-item-click="vm.updateFirstLeaveApprover()" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single"></div></div></upgrade-link><div class="col-md-4" ng-if="vm.isGeneralEmployeeOrLineManager || vm.isSameUser"><span class="color-22222" translate="">{{ vm.user.firstApproverName === null ? \'notAssigned\' : vm.user.firstApproverName}}</span></div></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label" ng-class="{\'mt-10\':!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser}">{{ \'approverInformation.secondLeaveApprover\' | translate}}</label><upgrade-link code="2014"><div class="col-md-6" ng-if="!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser"><div isteven-multi-select="" input-model="vm.allSecondLeaveApprover" output-model="vm.secondLeaveApprover" on-item-click="vm.updateSecondLeaveApprover()" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" is-disabled="vm.user.firstApproverId === -1 || !vm.user.firstApproverId"></div></div></upgrade-link><div class="col-md-4" ng-if="vm.isGeneralEmployeeOrLineManager || vm.isSameUser"><span class="color-22222" translate="">{{ vm.user.secondApproverName === null ? \'notAssigned\' : vm.user.secondApproverName}}</span></div></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label" ng-class="{\'mt-10\':!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser}">{{ \'approverInformation.firstLateApprover\' | translate}}</label><upgrade-link code="2014"><div class="col-md-6" ng-if="!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser"><div isteven-multi-select="" input-model="vm.allFirstLateApprover" output-model="vm.firstLateApprover" on-item-click="vm.updateFirstLateApprover()" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single"></div></div></upgrade-link><div class="col-md-4" ng-if="vm.isGeneralEmployeeOrLineManager || vm.isSameUser"><span class="color-22222" translate="">{{ vm.user.firstLateApproverName === null ? \'notAssigned\' : vm.user.firstLateApproverName}}</span></div></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label" ng-class="{\'mt-10\':!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser}">{{ \'approverInformation.secondLateApprover\' | translate}}</label><upgrade-link code="2014"><div class="col-md-6" ng-if="!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser"><div isteven-multi-select="" input-model="vm.allSecondLateApprover" output-model="vm.secondLateApprover" on-item-click="vm.updateSecondLateApprover()" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" is-disabled="vm.user.firstLateApproverId === -1 || !vm.user.firstLateApproverId"></div></div></upgrade-link><div class="col-md-4" ng-if="vm.isGeneralEmployeeOrLineManager || vm.isSameUser"><span class="color-22222" translate="">{{ vm.user.secondLateApproverName === null ? \'notAssigned\' : vm.user.secondLateApproverName}}</span></div></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label" ng-class="{\'mt-10\':!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser}">{{ \'approverInformation.firstManualEntryApprover\' | translate}}</label><upgrade-link code="2014"><div class="col-md-6" ng-if="!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser"><div isteven-multi-select="" input-model="vm.allFirstManualEntryApprover" output-model="vm.firstManualEntryApprover" on-item-click="vm.updateFirstManualEntryApprover()" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single"></div></div></upgrade-link><div class="col-md-4" ng-if="vm.isGeneralEmployeeOrLineManager || vm.isSameUser"><span class="color-22222" translate="">{{ vm.user.firstManualEntryApproverName === null ? \'notAssigned\' : vm.user.firstManualEntryApproverName}}</span></div></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label" ng-class="{\'mt-10\':!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser}">{{ \'approverInformation.secondManualEntryApprover\' | translate}}</label><upgrade-link code="2014"><div class="col-md-6" ng-if="!vm.isGeneralEmployeeOrLineManager && !vm.isSameUser"><div isteven-multi-select="" input-model="vm.allSecondManualEntryApprover" output-model="vm.secondManualEntryApprover" on-item-click="vm.updateSecondManualEntryApprover()" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" is-disabled="vm.user.firstManualEntryApproverId === -1 || !vm.user.firstManualEntryApproverId"></div></div></upgrade-link><div class="col-md-4" ng-if="vm.isGeneralEmployeeOrLineManager || vm.isSameUser"><span class="color-22222" translate="">{{ vm.user.secondManualEntryApproverName === null ? \'notAssigned\' : vm.user.secondManualEntryApproverName}}</span></div></div></div></upgrade-banner></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/changePass.accordion.partial.html','<style>\n    .confirm-password .form-control, .latest-password .form-control{\n        padding: 9px 6px 9px 35px!important;\n    }\n    .password-icon-position{\n        position: absolute;\n        top:28px;\n        left: 15px;\n    }\n    .all-labels label{\n        color:#222222;\n        font-size: 14px;\n    }\n    .password-validation .form-control:focus{\n        border: 1px solid #292929;\n    }\n</style><div class="all-labels password-validation"><h3 class="panel-title with-line" translate="">{{\'profile.changePassword\'}}</h3><form name="password" novalidate=""><div class="col-md-8 mb-15" ng-if="vm.needOldPass"><label for="oldPassword" class="col-sm-8 control-label p-all-0">{{ \'Current Password\' }}</label><div class="position-relative confirm-password" ng-class="{\'has-success\':password.confirmPassword.$dirty && password.confirmPassword.$valid}"><input type="password" name="oldPassword" class="form-control" id="oldPassword" placeholder="Enter current password" autocomplete="disabled" ng-model="vm.oldPass" onfocus="this.removeAttribute(\'readonly\');" readonly="" required=""> <i class="ion-ios-locked-outline password-icon-position font-20"></i></div></div><div class="col-md-8 mb-15"><label for="inputPassword" class="col-sm-8 control-label p-all-0" id="profilePagePasswordLabel">{{\'changePassword.password\'|translate}}</label><div class="position-relative latest-password" ng-class="{\'has-success\':password.newPassword.$dirty && password.newPassword.$valid,\'has-error\':(password.newPassword.$touched && vm.checkPasswordValidation(\'all\'))}"><input type="password" name="newPassword" class="form-control" id="inputPassword" placeholder="Enter new password" autocomplete="disabled" ng-model="vm.changePass.passwordText" onfocus="this.removeAttribute(\'readonly\')" readonly="" required=""> <span ng-if="vm.changePass.passwordText !== null"><span class="text-secondary">Password Strength:</span> <span class="{{ vm.passStrengthClass }}" translate="">{{ vm.passStrengthText }}</span></span><span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'capital\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidCapital\'}}</span> {{vm.passSchemaInfo.capital}}</span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'small\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidSmall\'}}</span> {{vm.passSchemaInfo.small}}</span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'numeric\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidNumber\'}}</span> {{vm.passSchemaInfo.numeric}}</span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'symbol\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidSymbol\'}}</span> {{vm.passSchemaInfo.symbol}}</span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'length\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidLength\'}}</span> {{vm.passSchemaInfo.length}}</span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'invalidSymbol\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{\' \' + \'createEmployee.errorMsg.invalidIllegalSymbol\'}}</span></span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'consecutiveChar\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.consecutiveChar\' }}</span> {{vm.passSchemaInfo.consecutiveChar}}</span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'commonPassword\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.commonPassword\' }}</span></span> <span class="help-block error-block basic-block" ng-if="password.newPassword.$touched && vm.checkPasswordValidation(\'user\')"><b><i class="fa fa-times-circle" aria-hidden="true"></i></b> <span translate="">{{ \' \' + \'createEmployee.errorMsg.similarWithUserInfo\' }}</span></span> <i class="password-icon-position ion-ios-locked-outline font-20"></i></div></div><div class="col-md-8"><label for="inputConfirmPassword" class="col-sm-8 control-label p-all-0">{{\'changePassword.confirmPassword\'|translate}}</label><div class="position-relative confirm-password" ng-class="{\'has-success\':password.confirmPassword.$dirty && password.confirmPassword.$valid}"><input type="password" name="confirmPassword" class="form-control" id="inputConfirmPassword" placeholder="Confirm new password" autocomplete="disabled" ng-model="vm.changePass.confirmPasswordText" onfocus="this.removeAttribute(\'readonly\');" readonly="" required=""> <i class="ion-ios-locked-outline password-icon-position font-20"></i></div></div><div class="col-md-8 mt-30"><button ng-disabled="password.$invalid || vm.checkPasswordValidation(\'all\')" type="submit" ng-class="{\'btn-disable\' : password.$invalid, \'btn-primary\' : !password.$invalid}" id="createEmployeeButton" class="btn btn-md btn-primary" ng-click="vm.updatePasswordFunction()">{{\'submit\'|translate}}</button></div></form></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/generalInfo.partial.html','<style>\n    .all-labels label{\n        color:#555555;\n        font-size: 14px;\n    }\n    .general-info .form-control{\n        padding: 7px 10px;\n    }\n    .general-info .input-group-btn .btn-default{\n        margin-left: -41px;\n        border-radius: 0px;\n        height: 35px;\n        z-index: 55;\n    }\n    .general-info #employeeDateOfJoinField{\n        margin-top: 5px;\n        margin-bottom: 10px;\n    }\n    .general-info-end-date .input-group{\n        margin-top: 5px;\n        margin-bottom: 5px;\n    }\n\n    @media (min-width: 990px) {\n        .general-info .form-inline .form-group input {\n            width: 70%;\n        }\n    }\n    @media (min-width: 1300px) {\n        .general-info .form-inline .form-group input {\n            width: 80%;\n        }\n        .general-info .form-inline .input-group > .form-control{\n            width: 80%;\n        }\n        .general-info .input-group-btn .btn-default{\n            margin-left: -100px;\n        }\n    }\n    @media (min-width: 1462px) {\n        .general-info .form-inline .input-group > .form-control{\n            width: 80%;\n        }\n        .general-info .general-info .input-group-btn .btn-default{\n            margin-left: -100px;\n        }\n    }\n    @media (min-width: 1470px) {\n        .general-info .form-inline .form-group input {\n            width: 100%;\n        }\n        .general-info .form-inline .form-control {\n            width: 70%;\n        }\n        .general-info .form-inline .input-group > .form-control{\n            width: 80%;\n        }\n        .general-info .general-info .input-group-btn .btn-default{\n            margin-left: -100px;\n        }\n    }\n    @media (min-width: 1475px) {\n        .general-info .form-inline .input-group > .form-control{\n            width: 100%;\n        }\n        .general-info .input-group-btn .btn-default{\n            margin-left: -41px;\n        }\n    }\n    @media (min-width: 1640px) {\n        .general-info .form-inline .form-control {\n            width: 80%;\n        }\n    }\n    @media (min-width: 1780px) {\n        .general-info .form-inline .form-control {\n            width: 90%;\n        }\n    }\n    .info-box\n    {\n        padding-top: 12px;\n        padding-bottom: 8px;\n    }\n\n    .sn-link--disabled { opacity: .25; cursor: not-allowed; text-decoration: none; }\n\n\n</style><div><h3 class="panel-title with-line" translate="">{{\'profile.generalInfoHeading\'}}</h3><div class="row general-info"><div class="col-md-12 p-all-0 all-labels"><div class="col-md-12" ng-if="vm.isDataReady"><div class="col-md-12 info-box info-box-top"><label class="col-sm-4 control-label">{{\'generalInfo.name\'|translate}}</label><upgrade-link code="2003"><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.name || \'notSet\' | translate}}</span> <a id="employeeName" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" href="#" e-id="employeeNameField" editable-text="vm.user.name" onbeforesave="vm.updateName($data)">{{ vm.user.name || \'notSet\' | translate}}</a></upgrade-link></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.id\' | translate}}</label><upgade-link code="2003"><span class="color-22222" ng-if="vm.user.office.code != null && vm.user.office.code.trim().length > 0">{{vm.user.office.code}}-</span> <span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeOfficeId || \'notSet\' | translate}}</span> <a id="employeeOfficeId" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" e-id="employeeOfficeIdField" editable-text="vm.user.employeeOfficeId" onbeforesave="vm.updateEmployeeOfficeId($data)">{{ vm.user.employeeOfficeId || \'notSet\' | translate}}</a></upgade-link></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">PersonID 3rd party Device</label> <span class="color-22222">{{ vm.user.personId3rdPartyDevice || \'Not Set\'}}</span></div><div class="col-md-12 info-box" ng-if="vm.user.office.hasApiAccess && !vm.isGeneralEmployeeOrLineManager"><label class="col-sm-4 control-label">{{\'generalInfo.identifier\'|translate}}</label><upgade-link code="2003"><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeIdentifier || \'notSet\' | translate}}</span> <a id="employeeIdentifier" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" e-id="employeeIdentifierField" editable-text="vm.user.employeeIdentifier" onbeforesave="vm.updateIdentifier($data)">{{ vm.user.employeeIdentifier || \'notSet\' | translate}}</a></upgade-link></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.email\'|translate}}</label> <span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.email || \'notSet\' | translate}}</span> <a id="employeeEmail" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" e-id="employeeEmailField" editable-text="vm.user.email" onbeforesave="vm.updateEmail($data)">{{ vm.user.email || \'notSet\' | translate}}</a></div><div class="col-md-12 info-box" ng-if="vm.isSubsidiaryActivated"><label class="col-sm-4 control-label">{{\'manageAllEmployees.filter.subsidiary\'|translate}}</label><a id="employeeSubsidiary" href="#" e-id="employeeSubsidiaryField" editable-select="vm.user.subsidiaryId" e-ng-options="subsidiary.id as subsidiary.name for subsidiary in vm.subsidiaryList" onbeforesave="vm.updateSubsidiary($data)" ng-if="vm.isSuperAdmin">{{ vm.showSubsidiary() }}</a><span ng-if="!vm.isSuperAdmin" class="color-22222">{{ vm.showSubsidiary() }}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.department\'|translate}}</label><upgrade-link code="2003" ng-if="vm.departmentList && !vm.isGeneralEmployeeOrLineManager"><a id="employeeDepartment" href="#" e-id="employeeDepartmentField" editable-select="vm.user.department.id" e-ng-options="dept.id as dept.name for dept in vm.departmentList" onbeforesave="vm.updateDepartment($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showDepartment() }}</a></upgrade-link><span ng-if="!(vm.departmentList && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.department && vm.user.department.name ? vm.user.department.name :\'notAssigned\' | translate}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.subDepartment\'|translate}}</label><upgrade-link code="2003" ng-if="vm.subDepartmentList && !vm.isGeneralEmployeeOrLineManager"><a id="employeeSubDepartment" href="#" e-id="employeeSubDepartmentField" editable-select="vm.user.subDepartment.id" e-ng-options="dept.id as dept.name for dept in vm.subDepartmentList" onbeforesave="vm.updateSubDepartment($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showSubDepartment() }}</a></upgrade-link><span ng-if="!(vm.subDepartmentList && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.subDepartment && vm.user.subDepartment.name ? vm.user.subDepartment.name :\'notAssigned\' | translate}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.designation\'|translate}}</label><upgrade-link code="2003" ng-if="vm.designationList && !vm.isGeneralEmployeeOrLineManager"><a id="employeeDesignation" e-id="employeeDesignationField" href="#" editable-select="vm.user.designation.id" e-ng-options="desg.id as desg.name for desg in vm.designationList" onbeforesave="vm.updateDesignation($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showDesignation() }}</a></upgrade-link><span ng-if="!(vm.designationList && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.designation && vm.user.designation.name ? vm.user.designation.name :\'notAssigned\' | translate}}</span></div><div class="col-md-12 info-box" ng-if="vm.isSiteEnabled"><label class="col-sm-4 control-label">{{\'generalInfo.site\'|translate}}</label><upgrade-link code="12001" ng-if="!!vm.siteList && !vm.isGeneralEmployeeOrLineManager"><a id="employeeSite" e-id="employeeSiteField" href="#" editable-select="vm.user.siteId" e-ng-options="site.id as site.name for site in vm.siteList" onbeforesave="vm.updateSite($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showSite() }}</a></upgrade-link><span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{vm.showSite()}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.employmentType\'|translate}}</label><upgrade-link code="2003" ng-if="vm.employmentTypeList && !vm.isGeneralEmployeeOrLineManager"><a id="employmentType" e-id="employmentTypeField" href="#" editable-select="vm.user.employmentTypeId" e-ng-options="employmentType.id as employmentType.name for employmentType in vm.employmentTypeList" onbeforesave="vm.updateEmploymentType($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showEmploymentType() }}</a></upgrade-link><span ng-if="!(vm.employmentTypeList && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.employmentType && vm.user.employmentType.name ? vm.user.employmentType.name :\'notAssigned\' | translate}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.shiftGroup\'|translate}}</label><upgrade-link code="2005" ng-if="vm.shiftGroupList && !vm.isEmployeeOnly && vm.canThisLineManagerAssignShiftGroup"><a id="employeeShiftGroup" e-id="employeeShiftGroupId" href="#" editable-select="vm.user.shiftGroupId" e-ng-options="shiftGroup.id as shiftGroup.name for shiftGroup in vm.shiftGroupList" onbeforesave="vm.updateShiftGroup($data)" e-ng-disabled="!vm.canThisLineManagerAssignShiftGroup">{{ vm.showShiftGroup() }}</a></upgrade-link><span ng-if="!(vm.shiftList && !vm.isEmployeeOnly && vm.canThisLineManagerAssignShiftGroup)" class="color-22222">{{vm.user.shiftGroupName}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.gender\'|translate}}</label><upgrade-link code="2006"><span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{ vm.showGender() || \'notSet\' | translate}}</span> <a id="employeeGender" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" e-id="employeeGenderField" href="#" editable-select="vm.user.gender" e-ng-options="gender.id as gender.name for gender in vm.genderList" onbeforesave="vm.updateGender($data)">{{ vm.showGender() }}</a></upgrade-link></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.primaryText\'|translate}}</label> <span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{ vm.user.primaryDisplayText || \'notSet\' | translate}}</span> <a id="primaryDisplayText" e-id="primaryDisplayTextField" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" editable-text="vm.user.primaryDisplayText" onbeforesave="vm.updatePrimaryText($data)">{{ vm.user.primaryDisplayText || \'notSet\' | translate}}</a></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.secondaryText\'|translate}}</label> <span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{ vm.user.secondaryDisplayText || \'notSet\' | translate}}</span> <a id="secondaryDisplayText" e-id="secondaryDisplayTextField" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" editable-text="vm.user.secondaryDisplayText" onbeforesave="vm.updateSecondaryText($data)">{{ vm.user.secondaryDisplayText || \'notSet\' | translate}}</a></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.rfid\'|translate}}</label> <span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{ vm.user.rfid || \'notSet\' | translate}}</span> <a id="employeeRfid" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" e-id="employeeRfidField" editable-text="vm.user.rfid" onbeforesave="vm.updateRfid($data)">{{ vm.user.rfid || \'notSet\' | translate}}</a></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.reportPosition\'|translate}}</label> <span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{ vm.user.reportPosition || \'notSet\' | translate}}</span> <a id="employeeReportPosition" href="#" ng-if="!vm.isGeneralEmployeeOrLineManager" e-ng-disabled="!vm.lineManagerAndUp" e-id="employeeReportPositionField" editable-text="vm.user.reportPosition" onbeforesave="vm.updateReportPosition($data)">{{ vm.user.reportPosition || \'notSet\' | translate}}</a></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.leavePolicy\'|translate}}</label><upgrade-link code="2016" ng-if="vm.leavePolicyList && !vm.isGeneralEmployeeOrLineManager"><a id="employeeLeavePolicy" href="#" e-id="employeeLeavePolicyField" editable-select="vm.user.leavePolicyId" e-ng-options="leavePolicy.id as leavePolicy.name for leavePolicy in vm.leavePolicyList" onbeforesave="vm.updateLeavePolicy($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showLeavePolicy() }}</a></upgrade-link><span ng-if="!(vm.leavePolicyList && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.leavePolicyName ? vm.user.leavePolicyName :\'notAssigned\' | translate}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.joiningDate\'|translate}}</label> <span><span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{(vm.user.dateOfJoin | date:"dd/MM/yyyy") || \'notSet\' | translate}}</span><upgrade-link code="2009" ng-if="!vm.isGeneralEmployeeOrLineManager"><a id="employeeDateOfJoin" href="#" e-id="employeeDateOfJoinField" editable-bsdate="vm.user.dateOfJoin" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="dd-MMMM-yyyy" onbeforesave="vm.updateDateOfJoin($data)">{{(vm.user.dateOfJoin | date:"dd/MM/yyyy") || \'notSet\' | translate}}</a></upgrade-link></span></div><div class="col-md-12 info-box general-info-end-date"><label class="col-sm-4 control-label">{{\'generalInfo.endDate\'|translate}}</label> <span ng-if="vm.isGeneralEmployeeOrLineManager" class="color-22222">{{(vm.user.dateOfResignation | date:"dd/MM/yyyy") || \'notSet\' | translate}}</span> <span><upgrade-link code="2009" ng-if="!vm.isGeneralEmployeeOrLineManager"><a id="employeeDateOfResignation" href="#" e-id="employeeDateOfResignationField" editable-bsdate="vm.user.dateOfResignation" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="dd-MMMM-yyyy" onbeforesave="vm.updateDateOfResignation($data)">{{(vm.user.dateOfResignation | date:"dd/MM/yyyy") || \'notSet\' | translate}}</a></upgrade-link></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.workplace\'|translate}}</label><upgrade-link code="2003" ng-if="vm.workplaceList && !vm.isGeneralEmployeeOrLineManager"><a id="employeeWorkplace" href="#" e-id="employeeWorkplaceField" editable-select="vm.user.workplace.id" e-ng-options="workplace.id as workplace.name for workplace in vm.workplaceList" onbeforesave="vm.updateWorkplace($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager">{{ vm.showWorkplace() }}</a></upgrade-link><span ng-if="!(vm.workplaceList && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.workplace && vm.user.workplace.name ? vm.user.workplace.name :\'notAssigned\' | translate}}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.lineManager\'|translate}}</label><a id="employeeLineManager" href="#" e-id="employeeLineManagerField" editable-select="vm.user.lineManagerId" e-ng-options="employee.id as employee.name for employee in vm.lineManagerEmployees" onbeforesave="vm.updateLineManager($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" ng-if="vm.canAssignLineManager && vm.lineManagerEmployees && !vm.isGeneralEmployeeOrLineManager">{{ vm.showLineManager() }}</a><a id="employeeLineManagerDisabled" href="" class="sn-link--disabled" ng-if="!vm.canAssignLineManager && vm.lineManagerEmployees && !vm.isGeneralEmployeeOrLineManager" ng-click="vm.openUpgradeForLineManager()"><i class="ion-locked"></i> <span>{{ vm.showLineManager() }}</span></a><span ng-if="!(vm.lineManagerEmployees && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{ vm.user.lineManagerName ? vm.user.lineManagerName : \'notAssigned\' | translate }}</span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'generalInfo.hrManager\'|translate}}</label> <a id="employeeHrManager" href="#" e-id="employeeHrManagerField" editable-select="vm.user.hrManagerId" e-ng-options="employee.id as employee.name for employee in vm.hrManagerEmployees" onbeforesave="vm.updateHrManager($data)" e-ng-disabled="vm.isGeneralEmployeeOrLineManager" ng-if="vm.hrManagerEmployees && !vm.isGeneralEmployeeOrLineManager">{{ vm.showHrManager() }}</a> <span ng-if="!(vm.hrManagerEmployees && !vm.isGeneralEmployeeOrLineManager)" class="color-22222">{{vm.user.hrManagerName ? vm.user.hrManagerName :\'notAssigned\' | translate}}</span></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/infoContainer.partial.html','<style>\n    .form-control{\n        padding: 7px 10px!important;\n    }\n    .editable-buttons{\n        vertical-align: middle!important;\n    }\n    .editable-buttons .btn-primary{\n        border: var(--color-secondary)!important;\n        background: var(--color-secondary)!important;\n    }\n    .editable-buttons .btn-primary:hover{\n        background: var(--color-secondary-hover)!important;\n    }\n</style><div ng-controller="GeneralInfoCtrl as vm"><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'general\']"><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/generalInfo.partial.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'approver\']"><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/approverInfo.partial.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'personal\']"><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/personalInfo.accordion.partial.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'address\']"><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/address.accordion.partial.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'changePass\']"><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/changePass.accordion.partial.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'documents\']"><div include-with-scope="app/pages/main/profile/profileInfo/document/documents.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'employment\']"><div include-with-scope="app/pages/main/profile/profileInfo/employment/employmentHistory.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'education\']"><div include-with-scope="app/pages/main/profile/profileInfo/education/educationHistory.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'project\']"><div include-with-scope="app/pages/main/profile/profileInfo/projectDedication/projectDedication.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'project-work\']"><div include-with-scope="app/pages/main/profile/profileInfo/projectWorkDedication/projectWorkDedication.html"></div></div><div class="col-md-12 p-all-0" ng-if="vm.profileTabsContent[\'notification-settings\']"><div include-with-scope="app/pages/main/profile/profileInfo/NotificationSettings/notificationSettings.html"></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/personalInfo.accordion.partial.html','<style>\n    .all-labels label{\n        color:#555555;\n        font-size: 14px;\n    }\n    .info-box{\n        padding-top: 12px;\n        padding-bottom: 8px;\n    }\n</style><div><h3 class="panel-title with-line" translate="">{{\'profile.contactInfoHeading\'}}</h3><div class="row"><div class="col-md-12 p-all-0 all-labels"><div class="col-md-12"><div class="col-md-12 info-box info-box-top"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.fathersName\' | translate}}</label> <span><upgrade-link code="2006"><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeDetails.fatherName || \'notSet\' | translate}}</span> <a id="fatherName" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="fatherNameField" editable-text="vm.user.employeeDetails.fatherName" onbeforesave="vm.updateFathersName($data)">{{ vm.user.employeeDetails.fatherName || \'notSet\' | translate}}</a></upgrade-link></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.mothersName\' | translate}}</label> <span><upgrade-link code="2006"><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeDetails.motherName || \'notSet\' | translate}}</span> <a id="motherName" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="motherNameField" editable-text="vm.user.employeeDetails.motherName" onbeforesave="vm.updateMothersName($data)">{{vm.user.employeeDetails.motherName || \'notSet\' | translate}}</a></upgrade-link></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.bloodGroup\' | translate}}</label><upgrade-link code="2006"><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.showBloodGroup()}}</span> <a id="bloodGroup" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="bloodGroupField" editable-select="vm.user.employeeDetails.bloodGroup" e-ng-options="blood.id as blood.name for blood in vm.bloodGroupList" onbeforesave="vm.updateBloodGroup($data)">{{ vm.showBloodGroup() }}</a></upgrade-link></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.dateOfBirth\' | translate}}</label> <span><upgrade-link code="2006"><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ (vm.user.employeeDetails.dateOfBirthDisplay | date:"dd/MM/yyyy") || \'notSet\' | translate}}</span> <a id="dateOfBirth" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="dateOfBirthField" editable-bsdate="vm.user.employeeDetails.dateOfBirthDisplay" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="dd-MMMM-yyyy" onbeforesave="vm.updateDateOfBirth($data)">{{(vm.user.employeeDetails.dateOfBirthDisplay | date:"dd/MM/yyyy") || \'notSet\' | translate}}</a></upgrade-link></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.nationalId\' | translate}}</label> <span><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeDetails.nid || \'notSet\' | translate}}</span> <a id="nationalID" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="nationalIDField" editable-text="vm.user.employeeDetails.nid" onbeforesave="vm.updateNidNumber($data)">{{vm.user.employeeDetails.nid || \'notSet\' | translate}}</a></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.officePhone\' | translate}}</label> <span><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeDetails.phoneOffice || \'notSet\' | translate}}</span> <a id="officePhone" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="officePhoneField" editable-text="vm.user.employeeDetails.phoneOffice" onbeforesave="vm.updatePhoneOffice($data)">{{vm.user.employeeDetails.phoneOffice || \'notSet\' | translate}}</a></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.homePhone\' | translate}}</label> <span><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeDetails.phoneHome || \'notSet\' | translate}}</span> <a id="homePhone" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="homePhoneField" editable-text="vm.user.employeeDetails.phoneHome" onbeforesave="vm.updatePhoneHome($data)">{{vm.user.employeeDetails.phoneHome || \'notSet\' | translate}}</a></span></div><div class="col-md-12 info-box"><label class="col-sm-4 control-label">{{\'personalAndContactInformation.personalPhone\' | translate}}</label> <span><span class="color-22222" ng-if="vm.isGeneralEmployeeOrLineManager">{{ vm.user.employeeDetails.phoneMobile || \'notSet\' | translate}}</span> <a id="cellPhone" ng-if="!vm.isGeneralEmployeeOrLineManager" href="#" e-id="cellPhoneField" editable-text="vm.user.employeeDetails.phoneMobile" onbeforesave="vm.updatePhoneMobile($data)">{{vm.user.employeeDetails.phoneMobile || \'notSet\' | translate}}</a></span></div></div></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/projectDedication/projectDedication.html','<div class="col-md-12" style="padding: 0px;" ng-controller="ProjectDedicationCtrl as vm"><h3 class="panel-title with-line">Project Dedication</h3><table class="table table-bordered" id="addressTable"><thead><th>#</th><th>Project Name</th><th>Project Code</th><th>Dedication %</th><th class="text-center">Update</th></thead><tbody><tr ng-repeat="projectDedication in vm.projectDedicationList track by $index"><td>{{$index + 1}}</td><td>{{projectDedication.project.name}}</td><td>{{projectDedication.project.code}}</td><td>{{projectDedication.dedicationPercentage}} %</td><td class="text-center"><button class="btn btn-danger" ng-click="vm.update(projectDedication)">Update</button></td></tr><tr><td colspan="3">Total</td><td>{{vm.sum()}} %</td><td></td></tr></tbody></table><div style="text-align: right"><button class="btn btn-primary" ng-click="vm.save()">Save Changes</button></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/projectWorkDedication/projectWorkDedication.html','<style>\n    .table-style{\n        font-size:70%;\n        width:100%;\n        z-index:2;\n        overflow: scroll\n    }\n    .table-style tbody{\n        font-size:100% !important;\n    }\n    .odd-child-selector:nth-child(odd) {\n        background-color: #f9f9f9;\n    }\n    .strip-table > thead > tr > th {\n        background-color: var(--color-secondary);\n        color:white;\n        border: none;\n    }\n    .strip-table tbody tr td{\n        border-top:none!important;\n        border-right:none!important;\n        border-bottom:none!important;\n        border-left:none!important;\n    }\n</style><div class="col-md-12 p-all-0" ng-controller="ProjectWorkDedicationCtrl as vm"><h3 class="panel-title with-line" translate="">{{\'profile.projectDedication\'}}</h3><div class="position-relative"><div class="row"><div class="col-md-6 col-xs-6"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-xs-3 col-md-3"><button type="button" class="btn btn-md-with-icon btn-primary text-center vertical-align-middle" ng-click="vm.searchByDateRange()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div><div class="overflow-x-auto"><a ng-href="{{vm.excelUrl}}" target="_self"><button type="button" ng-click="vm.getData()" class="btn btn-md-with-icon btn-primary padding-7-13 mt-10"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></a><table class="table strip-table table-style" id="addressTable" ng-if="vm.isDataLoaded"><thead><tr><th class="text-left" translate="">{{\'commonKeywords.project\'}}</th><th class="text-left" translate="">{{\'profile.totalDedication\'}}</th><th class="text-left" translate="">{{\'profile.date\'}}</th><th class="text-left" translate="">{{\'profile.projectDedication\'}}</th><th class="text-left" translate="">{{\'commonKeywords.task\'}}</th><th class="text-left" translate="">{{\'profile.timeSpent\'}}</th><th class="text-left" translate="">{{\'profile.totalTime\'}}</th><th class="text-left" translate="">{{\'profile.taskDedication\'}}</th></tr></thead><tbody class="odd-child-selector"><tr class="text-left" ng-repeat-start="projectReport in vm.report"><td rowspan="{{projectReport.perTaskDedicationReportList.length + 1}}">{{projectReport.projectWorkName}}</td><td rowspan="{{projectReport.perTaskDedicationReportList.length + 1}}">{{projectReport.totalProjectDedication}}</td></tr><tr ng-repeat="data in projectReport.perTaskDedicationReportList" ng-repeat-end=""><td class="text-left">{{data.date}}</td><td class="text-left">{{data.projectDedication}}</td><td class="text-left">{{data.taskName}}</td><td class="text-left">{{data.totalTaskWorkHour}}</td><td class="text-left">{{data.totalWorkHour}}</td><td class="text-left">{{data.dedication}}</td></tr></tbody></table><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center" ng-if="vm.report.length === 0 && vm.isDataLoaded"><p class="mt-10 text-bold font-12" translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</p></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/clients/create/createProjectClient.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'projectClients.create.panelTitle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.createClientForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.createClientForm.clientName.$invalid && vm.createClientForm.clientName.$touched}"><label class="required" translate="">{{"projectClients.create.clientNameInputLabel"}}</label> <input type="text" name="clientName" class="form-control" ng-model="vm.clientName" placeholder="{{\'projectClients.create.clientNameInputLabel\' | translate}}" tabindex="1" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createClientForm.contactName.$invalid && vm.createClientForm.contactName.$touched}"><label class="required" translate="">{{"projectClients.create.contactNameInputLabel"}}</label> <input type="text" name="contactName" class="form-control" ng-model="vm.contactName" placeholder="{{\'projectClients.create.contactNameInputLabel\' | translate}}" tabindex="2" required=""></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{"projectClients.create.contactDesignationInputLabel"}}</label> <input type="text" name="contactDesignation" class="form-control" ng-model="vm.contactDesignation" placeholder="{{\'projectClients.create.contactDesignationInputLabel\' | translate}}" tabindex="3"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createClientForm.contactNumber.$invalid && vm.createClientForm.contactNumber.$touched}"><label class="required" translate="">{{"projectClients.create.contactNumberInputLabel"}}</label> <input type="text" name="contactNumber" class="form-control" ng-model="vm.contactNumber" placeholder="{{\'projectClients.create.contactNumberInputLabel\' | translate}}" tabindex="4" pattern="^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$" required=""></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createClientForm.contactEmail.$invalid && vm.createClientForm.contactEmail.$touched}"><label class="required" translate="">{{"projectClients.create.contactEmailInputLabel"}}</label> <input type="email" name="contactEmail" class="form-control" ng-model="vm.contactEmail" placeholder="{{\'projectClients.create.contactEmailInputLabel\' | translate}}" tabindex="5" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projectClients.create.kamInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projectClients.create.organisationTypeInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.organisationTypes" output-model="vm.selectedOrganisationType" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" show-add-model="true" new-input-method="vm.createOrganisationType" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Organisation Type...\', \'nothingSelected\' : \'Select Organisation Type\' }"></div></div></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidForm() || vm.createClientForm.$invalid || vm.isCreating" ng-class="{\'btn-disable\' : vm.isInvalidForm() || vm.createClientForm.$invalid || vm.isCreating, \'btn-primary\' : !(vm.isInvalidForm() || vm.createClientForm.$invalid || vm.isCreating)}" ng-click="vm.openConfirmationModal()" translate=""><span ng-if="!vm.isCreating" translate="">{{ \'projectClients.create.createClientButtonLabel\' }}</span> <span ng-if="vm.isCreating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/clients/delete/deleteClient.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'projectClients.delete.modalTitle\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16 line-height-1_3">{{ \'projectClients.delete.modalBodyText\' | translate }} <em>{{vm.clientDetails.clientName}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteClient()" ng-disabled="vm.isDeleting" ng-class="{\'btn-disable\' : vm.isDeleting}"><span ng-if="!vm.isDeleting" translate="">{{\'commonKeywords.deleteButton\'}}</span> <span ng-if="vm.isDeleting" translate="">{{\'commonKeywords.pleaseWait\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/clients/edit/editProjectClient.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'projectClients.edit.panelTitle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.editClientForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.editClientForm.clientName.$invalid && vm.editClientForm.clientName.$touched}"><label class="required" translate="">{{"projectClients.create.clientNameInputLabel"}}</label> <input type="text" name="clientName" class="form-control" ng-model="vm.clientName" placeholder="{{\'projectClients.create.clientNameInputLabel\' | translate}}" tabindex="1" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editClientForm.contactName.$invalid && vm.editClientForm.contactName.$touched}"><label class="required" translate="">{{"projectClients.create.contactNameInputLabel"}}</label> <input type="text" name="contactName" class="form-control" ng-model="vm.contactName" placeholder="{{\'projectClients.create.contactNameInputLabel\' | translate}}" tabindex="2" required=""></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{"projectClients.create.contactDesignationInputLabel"}}</label> <input type="text" name="contactDesignation" class="form-control" ng-model="vm.contactDesignation" placeholder="{{\'projectClients.create.contactDesignationInputLabel\' | translate}}" tabindex="3"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editClientForm.contactNumber.$invalid && vm.editClientForm.contactNumber.$touched}"><label class="required" translate="">{{"projectClients.create.contactNumberInputLabel"}}</label> <input type="text" name="contactNumber" class="form-control" ng-model="vm.contactNumber" placeholder="{{\'projectClients.create.contactNumberInputLabel\' | translate}}" tabindex="4" required=""></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editClientForm.contactEmail.$invalid && vm.editClientForm.contactEmail.$touched}"><label class="required" translate="">{{"projectClients.create.contactEmailInputLabel"}}</label> <input type="email" name="contactEmail" class="form-control" ng-model="vm.contactEmail" placeholder="{{\'projectClients.create.contactEmailInputLabel\' | translate}}" tabindex="5" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projectClients.create.kamInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projectClients.create.organisationTypeInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.organisationTypes" output-model="vm.selectedOrganisationType" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" show-add-model="true" new-input-method="vm.createOrganisationType" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Organisation Type...\', \'nothingSelected\' : \'Select Organisation Type\' }"></div></div></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidForm() || vm.editClientForm.$invalid || vm.isUpdating" ng-class="{\'btn-disable\' : vm.isInvalidForm() || vm.editClientForm.$invalid || vm.isUpdating, \'btn-primary\' : !(vm.isInvalidForm() || vm.editClientForm.$invalid || vm.isUpdating)}" ng-click="vm.submitForm()" translate=""><span ng-if="!vm.isUpdating" translate="">{{ \'commonKeywords.saveButton\' }}</span> <span ng-if="vm.isUpdating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/issueCreators/modals/createIssueCreator.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase panel-title" translate="">{{\'projects.issueCreators.createModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div class="form-group"><label translate="">{{\'projects.issueCreators.createModal.employeeInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.employees" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidSelection() || vm.isCreating" ng-class="{\'btn-disable\' : (vm.isInvalidSelection() || vm.isCreating), \'btn-primary\' : (!vm.isInvalidSelection() && !vm.isCreating)}" ng-click="vm.addIssueCreator()"><span ng-if="!vm.isCreating" translate="">{{ \'commonKeywords.createButton\' }}</span> <span ng-if="vm.isCreating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/products/createProduct/createProduct.html','<style>\n    .panel-bottom {\n        position: absolute;\n        top: 90%;\n        right: 4%;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Create New Product" ba-panel-class="with-scroll panel-full-screen"><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div><form name="createProductForm" novalidate="" autocomplete="off"><div class="row mt-10"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': createProductForm.productName.$invalid && createProductForm.productName.$touched}"><label class="required" translate="">projects.product.table.productName</label> <input type="text" autocomplete="off" name="productName" class="form-control" ng-model="vm.createProductForm.productName" placeholder="Product Name" required=""></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.visitorMobile.$invalid && vm.createVisitorForm.visitorMobile.$touched}"><label class="required" translate="">projects.product.segment</label><div isteven-multi-select="" input-model="vm.createProductForm.segmentList" output-model="vm.createProductForm.selectedSegmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" show-add-model="true" new-input-method="vm.createProductSegment" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Segment\' }"></div></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createVisitorForm.visitorMobile.$invalid && vm.createVisitorForm.visitorMobile.$touched}"><label class="required" translate="">projects.product.table.owner</label><div isteven-multi-select="" input-model="vm.createProductForm.ownerList" output-model="vm.createProductForm.selectedOwnerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Owner\' }"></div></div></div><div class="col-md-12"><label class="form-label">{{\'projects.product.table.description\' | translate}}</label> <textarea type="text" class="form-control" placeholder="{{\'projects.product.table.description\' | translate}}" ng-model="vm.createProductForm.description"></textarea></div></div><div class="row panel-bottom"><div class="col-md-12"><button type="button" class="btn btn-md pull-right" ng-disabled="createProductForm.$invalid || !vm.checkFormaValidation() || vm.isCreating" ng-class="{\'btn-disable\' : (createProductForm.$invalid || !vm.checkFormaValidation() || vm.isCreating), \'btn-primary\' : !(createProductForm.$invalid || !vm.checkFormaValidation() || vm.isCreating)}" ng-click="vm.openConfirmationModal()"><span ng-if="!vm.isCreating" translate="">{{ \'projects.product.createNewProduct\' }}</span> <span ng-if="vm.isCreating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button> <button type="button" class="btn btn-md border-btn btn-outline mb-15 mr-15 pull-right" ui-sref="projectManagement.products"><span translate="">{{ \'commonKeywords.cancel\' }}</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/products/editProduct/editProduct.html','<style>\n    .panel-bottom {\n        position: absolute;\n        top: 90%;\n        right: 4%;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'projects.product.editPanelTitle\' | translate }}" ba-panel-class="with-scroll panel-full-screen"><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div><form name="editProductForm" novalidate="" autocomplete="off"><div class="row mt-10"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': editProductForm.productName.$invalid && editProductForm.productName.$touched}"><label class="required" translate="">projects.product.table.productName</label> <input type="text" autocomplete="off" name="productName" class="form-control" ng-model="vm.editProductForm.productName" placeholder="Product Name" required=""></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editVisitorForm.visitorMobile.$invalid && vm.editVisitorForm.visitorMobile.$touched}"><label class="required" translate="">projects.product.segment</label><div isteven-multi-select="" input-model="vm.editProductForm.segmentList" output-model="vm.editProductForm.selectedSegmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" show-add-model="true" new-input-method="vm.createProductSegment" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Segment\' }"></div></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editVisitorForm.visitorMobile.$invalid && vm.editVisitorForm.visitorMobile.$touched}"><label class="required" translate="">projects.product.table.owner</label><div isteven-multi-select="" input-model="vm.editProductForm.ownerList" output-model="vm.editProductForm.selectedOwnerList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name\', \'nothingSelected\' : \'Select Owner\' }"></div></div></div><div class="col-md-12"><label class="form-label">{{\'projects.product.table.description\' | translate}}</label> <textarea type="text" class="form-control" placeholder="{{\'projects.product.table.description\' | translate}}" ng-model="vm.editProductForm.description"></textarea></div></div><div class="row panel-bottom"><div class="col-md-12"><button type="button" class="btn btn-md btn-primary mb-15 pull-right" ng-disabled="editProductForm.$invalid || !vm.checkFormaValidation()" ng-class="{\'btn-disable\' : (editProductForm.$invalid || !vm.checkFormaValidation())}" ng-click="vm.editProduct()"><span translate="">{{ \'commonKeywords.saveButton\' }}</span></button> <button type="button" class="btn btn-md border-btn btn-outline mb-15 mr-15 pull-right" ui-sref="projectManagement.products"><span translate="">{{ \'commonKeywords.cancel\' }}</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/products/modals/deleteProductModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_3"><span translate="">{{\'projects.product.deleteProductodalStatement\'}}</span> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.productDelete(vm.productToDelete)" translate="">{{\'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectIssues/createIssue/createIssue.html','<div class="row"><div class="col-md-6 col-sm-12"><div ba-panel="" ba-panel-title="{{\'projects.issue.addNewIssue\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.createIssueForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><div class="form-group" tabindex="1"><label class="required">{{\'projects.issue.projectName\' | translate}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id referenceCode" search-property="name referenceCode" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/Reference Code...\', \'nothingSelected\' : \'Select Project\' }"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projects.issue.projectRefNo\'}}</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedProject[0].referenceCode" readonly=""></div></div><div class="col-md-6"><div class="form-group" tabindex="2" ng-class="{\'has-error\': vm.createIssueForm.selectedPriority.$invalid && vm.createIssueForm.selectedPriority.$touched}"><label class="required" translate="">{{\'projects.issue.priority\' | translate}}</label><div class="custom-select"><select name="selectedPriority" ng-model="vm.selectedPriority" ng-options="item.value as item.text for item in vm.priorityList" required=""><option value="">{{\'projects.issue.priorityPlaceholder\' | translate}}</option></select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" tabindex="3"><label class="pt-15">{{\'projects.issue.uploadSupDoc\' | translate}}</label> <input type="file" ngf-select="" ng-model="vm.create.supportDoc" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf, .docx, .doc, .jpg, .jpeg, .png\'"></div></div></div><div class="row pt-15"><div class="col-md-12"><div class="form-group" tabindex="4"><label>{{\'projects.issue.description\' | translate}}</label> <textarea class="form-control" ng-model="vm.create.description" placeholder="{{\'projects.issue.description\' | translate}}" rows="3"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="5"><label class="required">{{\'projects.issue.allocateTo\' | translate}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.create.allocateTo" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div><div class="col-md-6"><div class="form-group" tabindex="6" ng-class="{\'has-error\': vm.createIssueForm.selectedStatus.$invalid && vm.createIssueForm.selectedStatus.$touched}"><label class="required">{{\'projects.issue.status\' | translate}}</label><div class="custom-select"><select name="selectedStatus" ng-model="vm.selectedStatus" ng-options="item.value as item.text for item in vm.statusList" required=""><option value="">{{\'projects.issue.statusPlaceholder\' | translate}}</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="7"><label class="required" translate="">{{ \'projects.issue.issueDateAndTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.issueDateTimePicker.date" options="vm.issueDateTimePicker.options"><span>{{vm.issueDateTimePicker.date.format("DD MMM YYYY hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{ \'projects.issue.entryDateAndTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker prevent-clicks bg-f5f5f5" ng-model="vm.entryDateTimePicker.date" options="vm.entryDateTimePicker.options"><span>{{vm.entryDateTimePicker.date.format("DD MMM YYYY hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projects.issue.submittedBy\'}}</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.loggedInUser.name" readonly=""></div></div></div><div class="row mt-50"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidForm() || vm.createIssueForm.$invalid || vm.isCreating" ng-class="{\'btn-disable\' : vm.isInvalidForm() || vm.createIssueForm.$invalid || vm.isCreating, \'btn-primary\' : !(vm.isInvalidForm() || vm.createIssueForm.$invalid || vm.isCreating)}" ng-click="vm.openConfirmationModal()" translate=""><span ng-if="!vm.isCreating" translate="">{{ \'commonKeywords.saveButton\' }}</span> <span ng-if="vm.isCreating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectIssues/editIssue/editIssue.html','<div class="row"><div class="col-md-6 col-sm-12"><div ba-panel="" ba-panel-title="{{(\'projects.issue.editIssue\' | translate) + \' \' + vm.issue.ticketCode}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.editIssueForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><div class="form-group" tabindex="1"><label class="required">{{\'projects.issue.projectName\' | translate}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id referenceCode" search-property="name referenceCode" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/Reference Code...\', \'nothingSelected\' : \'Select Project\' }"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projects.issue.projectRefNo\'}}</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedProject[0].referenceCode" readonly=""></div></div><div class="col-md-6"><div class="form-group" tabindex="2" ng-class="{\'has-error\': vm.editIssueForm.selectedPriority.$invalid && vm.editIssueForm.selectedPriority.$touched}"><label class="required" translate="">{{\'projects.issue.priority\' | translate}}</label><div class="custom-select"><select name="selectedPriority" ng-model="vm.selectedPriority" ng-options="item.value as item.text for item in vm.priorityList" required=""><option value="">{{\'projects.issue.priorityPlaceholder\' | translate}}</option></select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" tabindex="3"><label class="pt-15">{{\'projects.issue.uploadSupDoc\' | translate}}</label> <input type="file" ngf-select="" ng-model="vm.edit.supportDoc" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf, .docx, .doc, .jpg, .jpeg, .png\'"></div></div></div><div class="row pt-15"><div class="col-md-12"><div class="form-group" tabindex="4"><label>{{\'projects.issue.description\' | translate}}</label> <textarea class="form-control" ng-model="vm.edit.description" placeholder="{{\'projects.issue.description\' | translate}}" rows="3"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="5"><label class="required">{{\'projects.issue.allocateTo\' | translate}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.edit.allocateTo" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div><div class="col-md-6"><div class="form-group" tabindex="6" ng-class="{\'has-error\': vm.editIssueForm.selectedStatus.$invalid && vm.editIssueForm.selectedStatus.$touched}"><label class="required">{{\'projects.issue.status\' | translate}}</label><div class="custom-select"><select name="selectedStatus" ng-model="vm.selectedStatus" ng-options="item.value as item.text for item in vm.statusList" required=""><option value="">{{\'projects.issue.statusPlaceholder\' | translate}}</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="7"><label class="required" translate="">{{ \'projects.issue.issueDateAndTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.issueDateTimePicker.date" options="vm.issueDateTimePicker.options"><span>{{vm.issueDateTimePicker.date.format("DD MMM YYYY hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{ \'projects.issue.entryDateAndTime\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker prevent-clicks bg-f5f5f5" ng-model="vm.entryDateTimePicker.date" options="vm.entryDateTimePicker.options"><span>{{vm.entryDateTimePicker.date.format("DD MMM YYYY hh:mm A")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{\'projects.issue.submittedBy\'}}</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.loggedInUser.name" readonly=""></div></div></div><div class="row mt-50"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidForm() || vm.editIssueForm.$invalid || vm.isCreating" ng-class="{\'btn-disable\' : vm.isInvalidForm() || vm.editIssueForm.$invalid || vm.isCreating, \'btn-primary\' : !(vm.isInvalidForm() || vm.editIssueForm.$invalid || vm.isCreating)}" ng-click="vm.openConfirmationModal()" translate=""><span ng-if="!vm.isCreating" translate="">{{ \'commonKeywords.saveButton\' }}</span> <span ng-if="vm.isCreating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projectIssues/viewIssue/viewIssue.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'projects.issues.issueDetails\' | translate}}"><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-6 pl-0"><div><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left th-width th-bg"><td colspan="2" class="position-relative">{{\'projects.issue.productName\' | translate}}: <span class="section-header">{{vm.issue.productName}}</span></td></tr><tr class="text-left"><td>{{\'projects.issue.projectName\' | translate}}: <span class="section-header">{{vm.issue.projectName}}</span></td><td>{{\'projects.issue.issueDateAndTime\' | translate}}: <span class="section-header">{{(vm.issue.issueDate | date : \'d MMM yyyy hh:mm a\')}}</span></td></tr><tr class="text-left bg-f8f8f8"><td>{{\'projects.issue.ticketNo\' | translate}}: <span class="color-22222 font-weight-400"><span class="section-header">{{vm.issue.ticketCode}}</span></span></td><td>{{\'projects.issue.priority\' | translate}}: <span ng-if="vm.issue.priority === 1" class="section-header text-success" translate="">{{\'projects.issues.lowPriority\'}}</span> <span ng-if="vm.issue.priority === 2" class="section-header text-warning" translate="">{{\'projects.issues.mediumPriority\'}}</span> <span ng-if="vm.issue.priority === 3" class="section-header text-danger" translate="">{{\'projects.issues.highPriority\'}}</span></td></tr><tr class="text-left"><td>{{\'projects.issue.supportDoc\' | translate}}: <a ng-if="!!vm.issue.documentUrl && vm.issue.documentUrl !== \'\'" ng-href="{{vm.issue.documentUrl}}" target="_self">{{vm.attachedFileName}}</a> <span ng-if="!vm.issue.documentUrl || vm.issue.documentUrl === \'\'"><i>{{vm.attachedFileName}}</i></span></td><td>{{\'projects.issue.status\' | translate}}: <span class="section-header">{{vm.issue.statusText}}</span></td></tr><tr class="text-left th-width th-bg"><td colspan="2">{{\'projects.issue.submittedBy\' | translate}}: <span class="section-header">{{vm.issue.submitterName}}</span></td></tr><tr class="text-left"><td colspan="2" class="position-relative">{{\'projects.issue.description\' | translate}}: <span>{{vm.issue.description}}</span><br><br><br></td></tr></tbody></table></div><div class="col-md-6 pl-0 pt-25 pb-10"><h3>{{\'projects.issue.logInfo.title\' | translate}}</h3></div><div class="col-md-6 pr-0 pt-20 pb-10 text-right"><button class="btn btn-md-with-icon padding-4-12 pull-right" ng-disabled="!vm.updateLogEnabled" ng-click="vm.showUpdateWindow()" ng-class="{\'btn-disable\' : !vm.updateLogEnabled, \'btn-secondary\' : vm.updateLogEnabled}"><span class="p-all-5" translate="">{{\'projects.issue.logInfo.updateLogButton\'}}</span></button></div><div><table class="table table-bordered"><colgroup><col class="width-25"><col class="width-75"></colgroup><tbody><tr><td class="text-center text-bold" translate="">{{\'projects.issue.logInfo.timestamp\'}}</td><td class="text-left text-bold" translate="">{{\'projects.issue.logInfo.action\'}}</td></tr></tbody><tbody ng-if="!!vm.issueLogs && vm.issueLogs.length > 0"><tr ng-repeat="item in vm.issueLogs"><td class="text-center">{{item.actionTime | date : \'d MMM yyyy hh:mm a\'}}</td><td class="text-left"><span ng-bind-html="item.logText"></span></td></tr></tbody><tbody ng-if="vm.issueLogs == null || vm.issueLogs.length === 0"><tr><td class="text-center" colspan="2"><em translate="">{{\'projects.issue.logInfo.noLogsFound\'}}</em></td></tr></tbody></table></div></div><div ng-show="vm.updateWindowVisible" class="col-md-6 pt-20 pb-20 bg-f8f8f8"><h3 class="pb-10">{{\'projects.issue.logInfo.issueLogUpdateTitle\' | translate}}</h3><div class="form-group" ng-class="{\'prevent-clicks\' : vm.isUpdating}"><label>{{\'projects.issue.logInfo.transferTo\' | translate}}</label><div isteven-multi-select="" input-model="vm.employees" output-model="vm.selectedAssignee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select whom to transfer\' }"></div></div><div class="form-group" ng-class="{\'prevent-clicks\' : vm.isUpdating}"><label>{{\'projects.issue.logInfo.status\' | translate}}</label><div class="custom-select"><select name="selectedStatus" ng-disabled="vm.isUpdating" ng-model="vm.selectedStatus" ng-options="item.value as item.text for item in vm.statusList"><option value="">{{\'projects.issue.logInfo.statusPlaceholder\' | translate}}</option></select></div></div><div class="form-group" ng-class="{\'prevent-clicks\' : vm.isUpdating}"><label class="pt-15">{{\'projects.issue.logInfo.remarks\' | translate}}</label> <textarea class="form-control" ng-disabled="vm.isUpdating" ng-model="vm.remarks" placeholder="{{\'projects.issue.logInfo.remarksPlaceholder\' | translate}}" rows="3"></textarea></div><div class="row pt-20"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="projectManagement.projectIssues" translate="">{{ \'projects.issue.logInfo.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-click="vm.submitOrShowConfirmationModal()" ng-disabled="vm.isUpdating" ng-class="{\'btn-disable\' : vm.isUpdating, \'btn-secondary\' : !vm.isUpdating}"><span ng-if="!vm.isUpdating">{{ \'projects.issue.logInfo.updateButton\' | translate}}</span> <span ng-if="vm.isUpdating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/createProject/createProject.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'projects.create.panelTitle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.createProjectForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><div class="form-group" tabindex="1" ng-class="{\'has-error\': vm.createProjectForm.projectName.$invalid && vm.createProjectForm.projectName.$touched}"><label class="required" translate="">{{"projects.create.projectNameInputLabel"}}</label> <input type="text" name="projectName" class="form-control" ng-model="vm.projectName" placeholder="{{\'projects.create.projectNameInputLabel\' | translate}}" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="2"><label class="required" translate="">{{\'projects.create.projectTypeInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.projectTypes" output-model="vm.selectedProjectType" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" show-add-model="true" new-input-method="vm.createProjectType" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Project Type...\', \'nothingSelected\' : \'Select Project Type\' }"></div></div></div><div class="col-md-6"><div class="form-group" tabindex="3"><label class="required" translate="">{{\'projects.create.kamInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="4"><label class="required" translate="">{{\'projects.create.clientInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.clients" output-model="vm.selectedClient" button-label="name" item-label="name" tick-property="ticked" output-properties="id organisationType" search-property="name" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Select Client\' }"></div></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{\'projects.create.organisationTypeInputLabel\'}}</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedClient[0].organisationType" readonly=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="5"><label class="required" translate="">{{\'projects.create.productInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.products" output-model="vm.selectedProduct" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Select Product\' }"></div></div></div><div class="col-md-6"><div class="form-group" tabindex="6" ng-class="{\'has-error\': vm.createProjectForm.referenceCode.$invalid && vm.createProjectForm.referenceCode.$touched}"><label class="required" translate="">{{\'projects.create.referenceCodeInputLabel\'}}</label> <input type="text" name="referenceCode" class="form-control" ng-model="vm.referenceCode" placeholder="{{\'projects.create.referenceCodeInputLabel\' | translate}}" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{ \'projects.create.startDateInputLabel\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.startDatePicker.date" options="vm.startDatePicker.options"><span>{{vm.startDatePicker.date.format("DD MMM YYYY")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{ \'projects.create.dueDateInputLabel\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.dueDatePicker.date" options="vm.dueDatePicker.options"><span>{{vm.dueDatePicker.date.format("DD MMM YYYY")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidForm() || vm.createProjectForm.$invalid || vm.isCreating" ng-class="{\'btn-disable\' : vm.isInvalidForm() || vm.createProjectForm.$invalid || vm.isCreating, \'btn-primary\' : !(vm.isInvalidForm() || vm.createProjectForm.$invalid || vm.isCreating)}" ng-click="vm.openConfirmationModal()" translate=""><span ng-if="!vm.isCreating" translate="">{{ \'projects.create.createProjectButtonLabel\' }}</span> <span ng-if="vm.isCreating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/deleteProject/deleteProject.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6"><span translate="">{{\'projects.deleteModal.confirmationText2\'}}</span> <em class="color-22222 font-weight-400">{{vm.project.name}}</em> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteProject()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/modals/createProject.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'projects.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><div><label class="required" for="name" translate="">{{ \'projects.creationModal.nameInputLabel\' }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'projects.creationModal.nameInputPlaceholder\' | translate}}" ng-model="vm.create.name"></div><div class="mt-10"><label class="required" translate="">{{\'commonKeywords.startDate\'}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.create.startTime" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.create.startTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label class="required" translate=""><strong>{{\'commonKeywords.endDate\'}}</strong></label><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.create.endTime" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.create.endTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label translate="">{{\'projects.creationModal.addPeople\'}}</label><div isteven-multi-select="" input-model="vm.employees" output-model="vm.create.employeeIdList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div></div><div class="col-md-6"><div><label translate="">{{\'projects.creationModal.addTeam\'}}</label><div isteven-multi-select="" input-model="vm.allTeams" output-model="vm.create.selectedTeam" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single"></div></div><div class="mt-10"><label for="description" translate="">{{ \'projects.creationModal.descriptionInputLabel\' }}</label> <textarea id="description" class="form-control" placeholder="{{ \'projects.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.create.description"></textarea></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createProject()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/partials/projects.regular.html','<div ba-panel="" ba-panel-title="{{\'projects.title\' | translate }} <span ng-click=\'vm.showFilterDiv = !vm.showFilterDiv\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilterDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilterDiv\' class=\'fa fa-chevron-up\'></i> </span>" class="position-relative"><div class="filter-div" ng-if="vm.showFilterDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.filter.products\' }}</label><div isteven-multi-select="" input-model="vm.products" output-model="vm.search.selectedProducts" button-label="name" item-label="name" tick-property="ticked" output-properties="id" helper-elements="all filter none"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.filter.projectTypes\' }}</label><div isteven-multi-select="" input-model="vm.projectTypes" output-model="vm.search.selectedProjectTypes" button-label="name" item-label="name" tick-property="ticked" output-properties="id" helper-elements="all filter none"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.filter.clients\' }}</label><div isteven-multi-select="" input-model="vm.clients" output-model="vm.search.selectedClients" button-label="name" item-label="name" tick-property="ticked" output-properties="id" helper-elements="all filter none"></div></div><div class="form-group col-sm-3 col-xs-3 item-margin-bottom"><label class="filter-label" translate="">{{ \'projects.filter.kams\' }}</label><div isteven-multi-select="" input-model="vm.employees" output-model="vm.search.selectedEmployees" button-label="name" item-label="name" tick-property="ticked" output-properties="id" helper-elements="all filter none"></div></div></div><div class="row form-inline"><div class="form-group col-sm-9 col-xs-3"></div><div class="col-sm-3 col-xs-3 my-12 d-flex justify-end"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.searchFromTheBeginningOfPagination()"><i class="ion-search"></i><span translate="">{{ \'projects.searchButton\' }}</span></button></div></div></div><div class="row"><div class="col-md-8"><div class="d-flex-space-between d-flex-align-center"><div class="filter-inline-item width-100 d-flex-flex-start-gap-10"><div class="width-35"><div class="form-group has-feedback resize-placeholder"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.search.keyword" ng-keydown="$event.keyCode === 13 && vm.searchFromTheBeginningOfPagination()" placeholder="{{\'projects.filter.searchInputPlaceholder\' | translate}}"></div></div><div><div class="filter-inline-item text-right min-height-33"><div class="btn-group" uib-dropdown="" dropdown-append-to-bod=""><button ng-hide="hideSortBy == true" type="button" class="btn btn-md btn-secondary padding-all-10" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'" class="cursor-pointer"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div></div></div></div></div></div><div class="col-md-4 text-right"><div><button class="btn btn-md" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-primary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.goToProjectCreationPage()"><span class="ml-negative-5 pb-3" translate="">{{\'projects.createButton\'}}</span></button></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-center" translate="">{{\'projects.tableHeader.referenceCode\'}}</th><th class="text-left" translate="">{{\'projects.tableHeader.projectName\'}}</th><th class="text-left" translate="">{{\'projects.tableHeader.product\'}}</th><th class="text-left" translate="">{{\'projects.tableHeader.kam\'}}</th><th class="text-left" translate="">{{\'projects.tableHeader.clientName\'}}</th><th class="text-center" translate="">{{\'projects.tableHeader.projectType\'}}</th><th class="text-center" translate="">{{\'projects.tableHeader.startDate\'}}</th><th class="text-center" translate="">{{\'projects.tableHeader.dueDate\'}}</th><th class="text-center" translate="">{{\'projects.tableHeader.endDate\'}}</th><th class="text-center" translate="">{{\'projects.tableHeader.noOfIssues\'}}</th><th class="text-center" translate="">{{\'projects.tableHeader.actions\'}}</th></tr></thead><tbody ng-if="vm.allProjects.length > 0"><tr ng-repeat="project in vm.allProjects"><td class="text-center width-5">{{(vm.selectedPage * vm.rowsPerPage) + $index + 1}}</td><td class="text-center">{{project.referenceCode}}</td><td class="text-left"><span class="section-header">{{project.name}}</span></td><td class="text-left">{{project.productName}}</td><td class="text-left" ng-if="!!project.ownerId"><employee-picture-and-information id="project.ownerId" name="project.ownerName" picture-url="project.ownerProfilePicUrl" department-name="project.departmentOfOwner" designation-name="project.designationOfOwner" is-clickable="true"></employee-picture-and-information></td><td class="text-left" ng-if="!project.ownerId"><employee-picture-and-information id="" name="\'Not Set\'" picture-url="" department-name="" designation-name="" is-clickable="false"></employee-picture-and-information></td><td class="text-left">{{project.clientName}}</td><td class="text-center">{{project.projectTypeName}}</td><td class="text-center">{{project.startTime | date : \'d MMM yyyy\'}}</td><td class="text-center">{{project.dueDate | date : \'d MMM yyyy\'}}</td><td class="text-center">{{!!project.endTime ? (project.endTime | date : \'d MMM yyyy\') : "--"}}</td><td class="text-center">{{project.issueCount}}</td><td class="text-center"><div class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-secondary\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.goToEditProjectPage(project)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-class="{\'btn-disable\' : !vm.isProjectManager, \'btn-danger\' : vm.isProjectManager}" ng-disabled="!vm.isProjectManager" ng-click="vm.openDeleteModal(project)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></div></td></tr></tbody><tbody ng-if="vm.allProjects == null || vm.allProjects.length === 0"><tr><td class="text-center" colspan="12"><em translate="">{{\'projects.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" not-found-text="\'No data available\'"></pagination-directive></div>');
$templateCache.put('app/pages/main/projectManagement/projects/partials/projects.tdh.html','<style>\n    .panel .panel-body{\n        min-height: 450px;\n    }\n</style><div ba-panel="" ba-panel-title="{{ \'projects.title\' | translate }}" ba-panel-class="with-scroll"><div class="row mb-20"><div class="col-md-12"><div><upgrade-button code="10001"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'projects.createButton\' | translate}}</span></button></upgrade-button></div><div class="mt-15"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'projects.tableHeader.name\' }}</th><th class="text-center" translate="">{{ \'projects.tableHeader.startTime\' }}</th><th class="text-center" translate="">{{ \'projects.tableHeader.deadline\' }}</th><th class="text-left" translate="">{{ \'projects.tableHeader.description\' }}</th><th class="text-center" translate="">{{ \'projects.tableHeader.status\' }}</th><th class="text-center width-13" translate="">{{ \'projects.tableHeader.actions\' }}</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="item in vm.allProjects" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.name}}</td><td class="text-center">{{item.startTime | date : \'d MMM yyyy\'}}</td><td class="text-center">{{item.endTime | date : \'d MMM yyyy\'}}</td><td class="text-left">{{item.description ? item.description: \'--\'}}</td><td ng-show="item.status==\'1\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusActive\' }}</td><td ng-show="item.status==\'0\'" class="text-center button-row" translate="">{{ \'commonKeywords.statusInactive\' }}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ui-sref="projectManagement.editTdhProject({projectId : {{item.id}}})"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(item)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.deleteButton\'}}</span></button></td></tr></tbody></table></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center mb-10"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/teams/createTeam/createTeam.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'teams.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div><label class="required" for="name">{{ \'teams.creationModal.nameInputLabel\' |translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'teams.creationModal.nameInputPlaceholder\' | translate}}" ng-model="vm.create.name"></div><div class="mt-10"><label class="mt-10" for="description">{{ \'teams.creationModal.descriptionInputLabel\' | translate}}</label> <textarea id="description" class="form-control" placeholder="{{ \'teams.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.create.description"></textarea></div><div class="mt-10"><label class="required">{{\'projects.creationModal.addPeople\' | translate}}</label><div isteven-multi-select="" input-model="vm.employees" output-model="vm.create.employeeIdList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createTeam()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/teams/deleteTeam/deleteTeam.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5"><span translate="">{{\'teams.deleteModal.confirmationText2\'}}</span> <em>{{vm.team.name}}</em> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteTeam()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/teams/editTeam/editTeam.html','<style>\n    .scrollable-table {\n        max-height: 40vh;\n        overflow: auto;\n        position: relative;\n    }\n    .text-highlight{\n        color: #222222;\n        font-weight: 500;\n    }\n</style><div ba-panel="" ba-panel-title="Edit Team" ba-panel-class="with-scroll"><div class="row mb-20" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="row"><div class="col-md-6"><label for="name">{{ \'teams.editModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'teams.editModal.nameInputPlaceholder\' | translate}}" ng-model="vm.team.name"></div></div><div class="row mt-15"><div class="col-md-6"><label for="description" class="mt-10">{{ \'teams.creationModal.descriptionInputLabel\' | translate}}</label> <textarea id="description" class="form-control" placeholder="{{ \'teams.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.team.description"></textarea></div></div><div class="row mt-15"><div class="col-md-6"><label>{{\'projects.creationModal.addPeople\' | translate}}</label><div class="d-flex-gap-10"><div class="width-100" isteven-multi-select="" input-model="vm.employees" output-model="vm.employeeIdList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div><button type="button" class="btn btn-md btn-primary" ng-click="vm.addEmployeesToTeam()" translate="">{{\'projects.editModal.addButton\'}}</button></div></div></div><div class="row mt-20"><div class="col-md-2"><span class="font-14 color-22222 font-weight-500" translate="">{{\'commonKeywords.statusInactive\'}}</span> <label class="custom-switch ml-10 mr-10"><input name="enabled" ng-model="vm.enabled" type="checkbox"><span class="slider round"></span></label> <span class="font-14 color-22222 font-weight-500" translate="">{{\'commonKeywords.statusActive\'}}</span></div></div><div class="row mt-20"><div class="col-md-1"><button type="button" class="btn btn-md btn-primary" ng-click="vm.updateTeamDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div><div class="row"><div class="col-md-12 mt-30"><p class="font-18 color-22222 font-weight-500" translate="">{{\'teams.editModal.peopleInTheTeamHeading\'}}</p><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="table-id text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{\'projects.editModal.name\'}}</th><th class="text-center width-9" translate="">{{\'projects.editModal.action\'}}</th></tr></thead><tbody><tr ng-repeat="item in vm.team.employees" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="" designation-name="" id="item.id" is-clickable="true"></employee-picture-and-information></td><td class="text-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openConfirmationModal(item)"><i class="ion-android-remove-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.removeButton\'}}</span></button></td></tr></tbody></table></div></div></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center mb-10"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/tasks/createTask/createTask.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'tasks.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><div><label class="required" for="name">{{ \'tasks.creationModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'tasks.creationModal.nameInputPlaceholder\' | translate}}" ng-model="vm.create.name"></div><div class="mt-10"><label class="required">{{\'commonKeywords.startDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.create.startTime" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.create.startTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="mt-10"><label class="required">{{\'commonKeywords.endDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.create.endTime" options="{singleDatePicker:true}"><span class="date-position-left">{{vm.create.endTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div><div class="mt-10"><label>{{\'tasks.tableHeader.project\' | translate}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" on-item-click="vm.populateEmployeeList()" item-label="name" tick-property="ticked" output-properties="id name employees" selection-mode="single"></div></div></div><div class="col-md-6"><div><label>{{\'tasks.employees\' | translate}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.create.employeeIdList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div></div><div class="mt-10"><label for="description">{{ \'tasks.creationModal.descriptionInputLabel\' | translate}}</label> <textarea id="description" class="form-control" placeholder="{{ \'tasks.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.create.description"></textarea></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createTask()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/tasks/deleteTask/deleteTask.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6"><span translate="">{{\'tasks.deleteModal.confirmationText2\'}}</span> <em class="color-22222 font-weight-400">{{vm.task.name}}</em> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteTask()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/tasks/editTask/editTask.html','<style>\n    .scrollable-table {\n        max-height: 40vh;\n        overflow: auto;\n        position: relative;\n    }\n    .text-highlight{\n        color: #222222;\n        font-weight: 500;\n    }\n</style><div ba-panel="" ba-panel-title="Edit Task" ba-panel-class="with-scroll"><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="row"><div class="col-md-6"><label for="name">{{ \'tasks.editModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'tasks.editModal.nameInputPlaceholder\' | translate}}" ng-model="vm.task.name"></div></div><div class="row mt-15"><div class="col-md-6"><label>{{\'commonKeywords.startDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.task.startTime" options="{singleDatePicker:true,format:\'DD-MMM-YYYY\'}"><span class="date-position-left">{{vm.task.startTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div></div><div class="row mt-15"><div class="col-md-6"><label>{{\'commonKeywords.endDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.task.endTime" options="{singleDatePicker:true,format:\'DD-MMM-YYYY\'}"><span class="date-position-left">{{vm.task.endTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div></div><div class="row mt-15"><div class="col-md-6"><label for="description">{{ \'tasks.creationModal.descriptionInputLabel\' | translate}}</label> <textarea id="description" class="form-control" placeholder="{{ \'tasks.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.task.description"></textarea></div></div><div class="row mt-15"><div class="col-md-6"><label>{{\'projects.creationModal.addPeople\' | translate}}</label><div class="d-flex-gap-10"><div class="width-100" isteven-multi-select="" input-model="vm.employees" output-model="vm.employeeIdList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div><button type="button" class="btn btn-md btn-primary" ng-click="vm.addEmployeesToTask()" translate="">{{\'projects.editModal.addButton\'}}</button></div></div></div><div class="row mt-20"><div class="col-md-2"><span class="font-14 color-22222 font-weight-500" translate="">{{\'Todo\' }}</span> <label class="custom-switch ml-10 mr-10"><input name="enabled" ng-model="vm.enabled" type="checkbox"><span class="slider round"></span></label> <span class="font-14 color-22222 font-weight-500" translate="">{{\'Done\'}}</span></div></div><div class="row mt-20"><div class="col-md-1"><button type="button" class="btn btn-md btn-primary" ng-click="vm.updateTaskDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div><div class="row"><div class="col-md-12 mt-30"><p class="font-18 color-22222 font-weight-500" translate="">{{\'tasks.editModal.addPeopleHeading\'}}</p><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="table-id text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{\'projects.editModal.name\'}}</th><th class="text-center width-9" translate="">{{\'projects.editModal.action\'}}</th></tr></thead><tbody><tr ng-repeat="item in vm.task.employees" ng-if="item.status!=-1" class="border-bottom-1"><td class="text-center">{{$index+1}}</td><td class="text-left"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="" designation-name="" id="item.id" is-clickable="true"></employee-picture-and-information></td><td class="text-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openConfirmationModal(item)"><i class="ion-android-remove-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.removeButton\'}}</span></button></td></tr></tbody></table></div></div></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center mb-10"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/settings/accessArea/accessAreaModals/createAccessArea.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.accessArea.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10 required" translate="">{{ \'visitorManagement.accessArea.creationModal.nameInputLabel\'}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'visitorManagement.accessArea.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.createAccessAreaName"></div></div><div class="row"><div class="col-md-12 form-group"><label for="code" class="required" translate="">{{ \'visitorManagement.accessArea.creationModal.codeInputLabel\'}}</label> <input type="text" id="code" class="form-control" placeholder="{{ \'visitorManagement.accessArea.creationModal.codeInputPlaceholder\' | translate }}" ng-model="vm.create.createAccessAreaCode"></div></div><div class="row"><div class="col-md-12 form-group"><label class="filter-label" translate="">select device</label><div isteven-multi-select="" input-model="vm.allDevice" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createAccessArea()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/accessArea/accessAreaModals/deleteAccessArea.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.accessArea.deleteModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-14">{{ \'visitorManagement.accessArea.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.accessAreaToChange.name}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteAccessAreaName(vm.accessAreaToChange.id)" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/accessArea/accessAreaModals/updateAccessArea.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.accessArea.updateModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10" translate="">{{ \'visitorManagement.accessArea.creationModal.nameInputLabel\' }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'visitorManagement.accessArea.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.accessAreaToChange.name"></div></div><div class="row"><div class="col-md-12 form-group"><label for="name" translate="">{{ \'visitorManagement.accessArea.creationModal.codeInputLabel\' }}</label> <input type="text" id="code" class="form-control" placeholder="{{ \'visitorManagement.accessArea.creationModal.codeInputPlaceholder\' | translate }}" ng-model="vm.accessAreaToChange.code"></div></div><div class="row"><div class="col-md-12 form-group"><label class="filter-label" translate="">select device</label><div isteven-multi-select="" input-model="vm.allDevice" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateAccessAreaName(vm.accessAreaToChange.id,vm.accessAreaToChange.name)" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/departments/createDepartment/createDepartment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'departmentSettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" for="name" translate="">{{ \'departmentSettings.creationModal.nameInputLabel\' }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'departmentSettings.creationModal.nameInputPlaceholder\' | translate}}" ng-model="vm.create.name"></div></div><br><div class="row"><div class="col-md-12"><label class="required" for="name" translate="">{{ \'departmentSettings.creationModal.hierarchyInputLabel\' }}</label> <input type="number" class="form-control" placeholder="{{ \'departmentSettings.creationModal.hierarchyInputPlaceHolder\' | translate}}" ng-model="vm.create.hierarchy"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createDepartment()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/departments/deleteDepartment/deleteDepartment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'departmentSettings.deleteModal.confirmationText\' | translate}} <em class="color-22222 font-weight-400">{{vm.department.name}}</em>{{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteDepartment()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/departments/details/departmentDetails.html','<style xmlns="http://www.w3.org/1999/html">\n    .list-avatar{\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        float: left;\n        margin-top: 2px;\n    }\n</style><div ba-panel="" ba-panel-title="Department Details" ba-panel-class="with-scroll"><div class="row form-inline" style="margin-top: 10px;" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-4"><h4>Name</h4><input class="form-control" type="text" placeholder="Name ..." ng-model="vm.employeeName" ng-keyup="$event.keyCode == 13 ? vm.searchDevice() : null" ng-change="vm.searchDevice()"></div></div><br><div class="row"><div class="form-group col-sm-4 col-xs-6 col-md-6"></div><div class="form-group col-sm-4 col-xs-6 col-md-6 text-right" style="margin-bottom: 20px;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><i style="margin-right: 10px">{{vm.showFilters ? "Hide Filters" : "Show Filters"}}</i></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div></div><h3 class="with-line">Employee List</h3><br><br><div class="text-center" ng-show="!vm.isEmployeeListLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><table class="table" st-table="smartTableData" st-safe-src="vm.employeeListToShow" ng-show="vm.isEmployeeListLoaded"><thead><tr class="sortable"><th></th><th><a href="" ng-click="vm.sortingMethods.sortByName()">Name</a></th><th><a href="" ng-click="vm.sortingMethods.sortByDepartmentName()">Department</a></th><th><a href="" ng-click="vm.sortingMethods.sortByShiftName()">Shift</a></th><th><a href="" ng-click="vm.sortingMethods.sortByDesignationName()">Designation</a></th><th><a href="" ng-click="vm.sortingMethods.sortByHierarchy()">Hierarchy</a></th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td><img class="list-avatar" ng-show="item.employeePictures && item.employeePictures.length > 0" ng-src="{{item.employeePictures[0].employeeFile.url}}"> <img class="list-avatar" ng-show="!item.employeePictures || item.employeePictures.length == 0" ng-src="assets/img/theme/no-photo.png" alt="no picture"></td><td><a ui-sref="profile({employeeId : {{item.id}}})">{{item.name}}</a></td><td>{{item.department.name}}</td><td>{{item.shift.name}}</td><td>{{item.designation.name}}</td><td>{{item.designation.hierarchy}}</td><td>{{vm.getStatusInText(item.status)}}</td></tr></tbody></table><br><br></div>');
$templateCache.put('app/pages/main/settings/departments/editDepartment/editDepartment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'departmentSettings.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label for="name" class="editDepartmentFormLabel">{{ \'departmentSettings.creationModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" ng-model="vm.department.name"></div></div><br><div class="row"><div class="col-md-12"><label for="name">{{ \'departmentSettings.creationModal.hierarchyInputLabel\' | translate}}</label> <input type="number" class="form-control" placeholder="{{ \'departmentSettings.creationModal.hierarchyInputPlaceHolder\' | translate }}" ng-model="vm.department.hierarchy"></div></div><br><div class="row"><div class="col-md-12" id="editDepartmentDivs"><strong translate="">{{ \'departmentSettings.editModal.statusInputLabel\' }}</strong> <label class="custom-switch ml-20 mr-20"><input id="enabled" name="enabled" ng-model="vm.department.enabled" type="checkbox"><span class="slider round"></span></label> <strong translate="">{{ vm.department.enabled ? \'commonKeywords.statusActive\' : \'commonKeywords.statusInactive\' }}</strong></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateDepartmentDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/designations/createDesignation/createDesignation.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'designationSettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'designationSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'designationSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.cName"></div></div><br><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'designationSettings.creationModal.hierarchyInputLabel\' }}</label> <input type="number" class="form-control" placeholder="{{ \'designationSettings.creationModal.hierarchyInputPlaceHolder\' | translate }}" ng-model="vm.create.cHierarchy"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createNewDesignation()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'designationSettings.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/settings/designations/deleteDesignation/deleteDesignation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'designationSettings.deleteModal.confirmationText\' | translate}} <em class="color-22222 font-weight-400">{{vm.designation.name}}</em>{{\'commonKeywords.questionMark\'| translate}} {{ \'designationSettings.deleteModal.confirmationTextExtension\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteDesignation()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/designations/editDesignation/editDesignation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'designationSettings.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label translate="">{{ \'designationSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" ng-model="vm.designation.name"></div></div><br><div class="row"><div class="col-md-12"><label translate="">{{ \'designationSettings.creationModal.hierarchyInputLabel\' }}</label> <input type="number" class="form-control" placeholder="Hierarchy" ng-model="vm.designation.hierarchy"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateDesignationDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/employmentType/create/createEmploymentType.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'employmentTypeSettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'employmentTypeSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'employmentTypeSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.name"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createEmploymentType()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/settings/employmentType/delete/deleteEmploymentType.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close text-bold"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'employmentTypeSettings.deleteModal.confirmationText\' | translate}} <em class="color-22222 font-weight-400">{{vm.employmentType.name}}</em>{{\'commonKeywords.questionMark\'| translate}} {{ \'employmentTypeSettings.deleteModal.confirmationTextExtension\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteEmploymentType()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/employmentType/edit/editEmploymentType.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'employmentTypeSettings.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label translate="">{{ \'employmentTypeSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'employmentTypeSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.name"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.editEmploymentType()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/settings/mobileAttendance/geoFencing/geoFencing.html','<style>\n    th {\n        padding: 0;\n        vertical-align: middle !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    td {\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .mb-15 {\n        margin-bottom: 15px !important;\n    }\n\n    .report-container {\n        max-height: 61vh;\n        overflow: auto;\n        position: relative;\n    }\n</style><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Geo Fencing Access Settings <span ng-click=\'vm.showDiv = !vm.showDiv\' class=\'filter pull-right\' ng-if=\'vm.hasPermission(2002) && vm.hasPermission(9006) && vm.hasPermission(9009)\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showDiv\' class=\'fa fa-chevron-up\'></i> </span>"><div class="filter-div" ng-if="vm.showDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-if="vm.isCompanyAdmin"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.offices\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-if="vm.subsidiaryView"><label class="filter-label" translate="">Subsidiary</label><div id="subsidiaryList" isteven-multi-select="" input-model="vm.search.subsidiaryList" output-model="vm.search.selectedSubsidiaryList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" on-item-click="vm.populateSubsidiaryFilter()" on-select-all="vm.populateSubsidiaryFilter()" on-select-none="vm.populateSubsidiaryFilter()" on-reset="vm.populateSubsidiaryFilter()" on-clear="vm.populateSubsidiaryFilter()"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15" ng-hide="true"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.company\' }}</label><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-hide="true"><label class="filter-label" ng-show="vm.search.selectedCompanyList.length > 0" translate="">{{ \'manageAllEmployees.filter.office\'}}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.departments\' }}</label><div isteven-multi-select="" input-model="vm.search.departmentList.length > 0 ? vm.search.departmentList : vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.designations\' }}</label><div isteven-multi-select="" input-model="vm.search.designationList.length > 0 ? vm.search.designationList : vm.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.shiftGroups\' }}</label><div isteven-multi-select="" input-model="vm.search.shiftGroupList.length > 0 ? vm.search.shiftGroupList : vm.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.employmentType\'}}</label><div isteven-multi-select="" input-model="vm.search.employmentTypeList.length > 0 ? vm.search.employmentTypeList : vm.employmentTypeList" output-model="vm.search.selectedEmploymentTypeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.gender\' }}</label><div isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.workplace\' }}</label><div isteven-multi-select="" input-model="vm.search.workplaceList.length > 0 ? vm.search.workplaceList : vm.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.status\' }}</label><div isteven-multi-select="" input-model="vm.employeeStatusList" output-model="vm.search.selectedemployeeStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.geoFencingStatus\'}}</label><div isteven-multi-select="" input-model="vm.availableGeoFencingStatusList" output-model="vm.search.selectedGeoFencingStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="value"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByName\' }}</label> <input class="form-control" type="text" placeholder="Employee name/ID/RFID..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div></div><div class="row form-inline"><div class="form-group col-sm-8 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><button type="button" class="btn btn-md btn-primary btn-block" ng-click="vm.searchEmployees()" translate=""><i class="ion-search"></i>{{ \'manageAllEmployees.filter.searchButton\' }}</button></div></div></div><div class="row"><div class="form-group col-sm-7 col-xs-7"><button class="btn btn-md-with-icon btn-primary padding-5-13" ng-click="vm.downloadExcel()"><img src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button> <button class="btn btn-md-with-icon btn-secondary" ng-click="vm.openConfirmationModal(\'Do you want to continue this operation?\', \'activate\' )"><i class="ion-android-done-all"></i> <span class="ml-negative-5 pb-2">{{vm.checkbox.isAnySelected && !vm.checkbox.isAllSelected ? \'Activate Selected\' : \'Activate All\'}}</span></button> <button class="btn btn-md-with-icon btn-danger" ng-click="vm.openConfirmationModal(\'Do you want to continue this operation?\', \'deactivate\' )"><i class="ion-ios-undo"></i> <span class="ml-negative-5 pb-2">{{vm.checkbox.isAnySelected && !vm.checkbox.isAllSelected ? \'Deactivate Selected\' : \'Deactivate All\'}}</span></button></div><div class="col-md-5 col-xs-5 text-right"><div class="row"><div class="col-md-12"><div class="d-flex-gap-10 justify-end"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-md btn-secondary btn-resize" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div><span class="d-flex-align-center min-width-101"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span><div class="custom-select max-width-100"><select ng-class="{\'cursor-not-allowed\':!vm.isEmployeeListLoaded}" ng-disabled="!vm.isEmployeeListLoaded" ng-model="vm.rowsToShow" ng-change="vm.searchEmployees({pageNumber:\'reset\'})"><option value="10" ng-selected="vm.rowsToShow == 10" translate="">{{\'commonKeywords.ten\'}}</option><option value="50" ng-selected="vm.rowsToShow == 50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.rowsToShow == 100" translate="">{{\'commonKeywords.hundred\'}}</option><option value="1000" ng-selected="vm.rowsToShow == 1000" translate="">{{\'commonKeywords.thousand\'}}</option></select></div></div></div></div></div></div><div class="horizontal-scroll report-container"><table class="table report-table"><thead><tr><th class="width-3 text-center check-uncheck-all"><label class="checkbox-container"><input type="checkbox" ng-model="vm.checkbox.isAllSelected" ng-click="vm.toggleAll()"> <span class="custom-checkbox checkbox-position"></span></label></th><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center width-6" translate="">{{ \'manageAllEmployees.employeeListTableHeader.id\'}}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.name\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.workplace\'}}</th><th class="text-center width-8" translate="">{{\'commonKeywords.geoFencingStatus\'}}</th></tr></thead><tbody><tr ng-show="vm.isEmployeeListLoaded && vm.allEmployees.length > 0" ng-repeat="item in vm.allEmployees track by item.id" ng-class="{\'opacity-50\' : !item.isMobilePunchEnabled}"><td><label class="checkbox-container"><input type="checkbox" ng-model="item.selected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position"></span></label></td><td>{{(vm.rowsToShow * vm.selectedPaginationPage) + ($index + 1)}}</td><td>{{item.employeeOfficeId == null ? " " : item.employeeOfficeId}}</td><td class="text-left-important"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="item.departmentName" designation-name="!item.designationName ? \'N/A\':item.designationName" id="item.id" is-clickable="item.status === 1"></employee-picture-and-information></td><td class="text-left-important" ng-class="item.workplaceName?\'text-left-important\':\'color-999999 text-left\'">{{item.workplaceName ? item.workplaceName : " N/A"}}</td><td class="text-center" ng-class="item.isGeoFencingEnabled?\'text-green\':\'text-red\'">{{item.isGeoFencingEnabled ? \'Active\' : \'Inactive\' }}</td></tr></tbody></table></div><div class="text-center" ng-show="!vm.isEmployeeListLoaded"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-if="vm.allEmployees.length == 0"><p><strong translate="">{{\'manageAllEmployees.emptyResultText\'}}</strong></p></div><br><br><div class="text-center" ng-if="vm.allEmployees.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'first\'})" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage==$index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a ng-click="vm.searchEmployees({pageNumber:$index})">{{$index + 1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'last\'})" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.allEmployees.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPaginationPage + 1}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p><p><strong><span translate="">{{\'commonKeywords.showing\'}}</span> {{vm.getPaginationInfo()}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.total}}</strong></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/mobileAttendance/locationTrackingAccessSettings/locationTrackingAccessSettings.html','<style>\n  th {\n    padding: 0;\n    vertical-align: middle !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  td {\n    padding: 0;\n    vertical-align: middle !important;\n    text-align: center !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .mb-15 {\n    margin-bottom: 15px !important;\n  }\n\n  .report-container {\n    max-height: 61vh;\n    overflow: auto;\n    position: relative;\n  }\n</style><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Location Tracking Access Settings <span ng-click=\'vm.showDiv = !vm.showDiv\' class=\'filter pull-right\' ng-if=\'vm.hasPermission(2002) && vm.hasPermission(9009)\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showDiv\' class=\'fa fa-chevron-up\'></i> </span>"><div class="filter-div" ng-if="vm.showDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-if="vm.isCompanyAdmin"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.offices\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-if="vm.subsidiaryView"><label class="filter-label" translate="">Subsidiary</label><div id="subsidiaryList" isteven-multi-select="" input-model="vm.search.subsidiaryList" output-model="vm.search.selectedSubsidiaryList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" on-item-click="vm.populateSubsidiaryFilter()" on-select-all="vm.populateSubsidiaryFilter()" on-select-none="vm.populateSubsidiaryFilter()" on-reset="vm.populateSubsidiaryFilter()" on-clear="vm.populateSubsidiaryFilter()"></div></div><div class="form-group col-sm-4 col-xs-4" ng-hide="true"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.company\' }}</label><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-hide="true"><label class="filter-label" ng-show="vm.search.selectedCompanyList.length > 0" translate="">{{ \'manageAllEmployees.filter.office\'}}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.departments\' }}</label><div isteven-multi-select="" input-model="vm.search.departmentList.length > 0 ? vm.search.departmentList : vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.designations\' }}</label><div isteven-multi-select="" input-model="vm.search.designationList.length > 0 ? vm.search.designationList : vm.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.shiftGroups\' }}</label><div isteven-multi-select="" input-model="vm.search.shiftGroupList.length > 0 ? vm.search.shiftGroupList : vm.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.employmentType\'}}</label><div isteven-multi-select="" input-model="vm.employmentTypeList" output-model="vm.search.selectedEmploymentTypeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.gender\' }}</label><div isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.workplace\' }}</label><div isteven-multi-select="" input-model="vm.search.workplaceList.length > 0 ? vm.search.workplaceList : vm.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.status\' }}</label><div isteven-multi-select="" input-model="vm.employeeStatusList" output-model="vm.search.selectedemployeeStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.trackingStatus\'}}</label><div isteven-multi-select="" input-model="vm.availableLocationTrackingStatusList" output-model="vm.search.selectedLocationTrackingAccessStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="value"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByName\' }}</label> <input class="form-control" type="text" placeholder="Employee name/ID/RFID..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div></div><div class="row form-inline"><div class="form-group col-sm-8 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><button type="button" class="btn btn-md btn-primary btn-block" ng-click="vm.searchEmployees()" translate=""><i class="ion-search"></i>{{ \'manageAllEmployees.filter.searchButton\' }}</button></div></div></div><div class="row"><div class="form-group col-sm-7 col-xs-7"><button class="btn btn-md-with-icon btn-primary padding-5-13" ng-click="vm.downloadExcel()"><img src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button> <button class="btn btn-md-with-icon btn-secondary" ng-click="vm.openConfirmationModal(\'Do you want to continue this operation?\', \'activate\' )"><i class="ion-android-done-all"></i> <span class="ml-negative-5 pb-2">{{vm.checkbox.isAnySelected && !vm.checkbox.isAllSelected ? \'Activate Selected\' : \'Activate All\'}}</span></button> <button class="btn btn-md-with-icon btn-danger" ng-click="vm.openConfirmationModal(\'Do you want to continue this operation?\', \'deactivate\' )"><i class="ion-ios-undo"></i> <span class="ml-negative-5 pb-2">{{vm.checkbox.isAnySelected && !vm.checkbox.isAllSelected ? \'Deactivate Selected\' : \'Deactivate All\'}}</span></button></div><div class="col-md-5 col-xs-5 text-right"><div class="row"><div class="col-md-12"><div class="d-flex-gap-10 justify-end"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-md btn-secondary btn-resize" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div><span class="d-flex-align-center min-width-101"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span><div class="custom-select max-width-100"><select ng-class="{\'cursor-not-allowed\':!vm.isEmployeeListLoaded}" ng-disabled="!vm.isEmployeeListLoaded" ng-model="vm.rowsToShow" ng-change="vm.searchEmployees({pageNumber:\'reset\'})"><option value="10" ng-selected="vm.rowsToShow == 10" translate="">{{\'commonKeywords.ten\'}}</option><option value="50" ng-selected="vm.rowsToShow == 50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.rowsToShow == 100" translate="">{{\'commonKeywords.hundred\'}}</option><option value="1000" ng-selected="vm.rowsToShow == 1000" translate="">{{\'commonKeywords.thousand\'}}</option></select></div></div></div></div></div></div><div class="horizontal-scroll report-container"><table class="table report-table"><thead><tr><th class="width-3 text-center check-uncheck-all"><label class="checkbox-container"><input type="checkbox" ng-model="vm.checkbox.isAllSelected" ng-click="vm.toggleAll()"> <span class="custom-checkbox checkbox-position"></span></label></th><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center width-6" translate="">{{ \'manageAllEmployees.employeeListTableHeader.id\'}}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.name\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.workplace\'}}</th><th class="text-center width-8" translate="">{{\'commonKeywords.trackingStatus\'}}</th></tr></thead><tbody><tr ng-show="vm.isEmployeeListLoaded && vm.allEmployees.length > 0" ng-repeat="item in vm.allEmployees track by item.id" ng-class="{\'opacity-50\' : !item.isLocationTrackingEnabled}"><td><label class="checkbox-container"><input type="checkbox" ng-model="item.selected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position"></span></label></td><td>{{(vm.rowsToShow * vm.selectedPaginationPage) + ($index + 1)}}</td><td>{{item.employeeOfficeId == null ? " " : item.employeeOfficeId}}</td><td class="text-left-important"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="item.departmentName" designation-name="!item.designationName ? \'N/A\':item.designationName" id="item.id" is-clickable="item.status === 1"></employee-picture-and-information></td><td class="text-left-important" ng-class="item.workplaceName?\'text-left-important\':\'color-999999 text-left\'">{{item.workplaceName ? item.workplaceName : " N/A"}}</td><td class="text-center" ng-class="item.isLocationTrackingEnabled?\'text-green\':\'text-red\'">{{item.isLocationTrackingEnabled ? \'Active\' : \'Inactive\' }}</td></tr></tbody></table></div><div class="text-center" ng-show="!vm.isEmployeeListLoaded"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-if="vm.allEmployees.length == 0"><p><strong translate="">{{\'manageAllEmployees.emptyResultText\'}}</strong></p></div><br><br><div class="text-center" ng-if="vm.allEmployees.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'first\'})" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage==$index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a ng-click="vm.searchEmployees({pageNumber:$index})">{{$index + 1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'last\'})" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.allEmployees.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPaginationPage + 1}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p><p><strong><span translate="">{{\'commonKeywords.showing\'}}</span> {{vm.getPaginationInfo()}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.total}}</strong></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/mobileAttendance/mobilePunch/mobilePunch.html','<style>\n    th {\n        padding: 0;\n        vertical-align: middle !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    td {\n        padding: 0;\n        vertical-align: middle !important;\n        text-align: center !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .mb-15 {\n        margin-bottom: 15px !important;\n    }\n\n    .report-container {\n        max-height: 61vh;\n        overflow: auto;\n        position: relative;\n    }\n</style><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Mobile Punch Access Settings <span ng-click=\'vm.showDiv = !vm.showDiv\' class=\'filter pull-right\' ng-if=\'vm.hasPermission(2002)\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showDiv\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showDiv\' class=\'fa fa-chevron-up\'></i> </span>"><div class="filter-div" ng-if="vm.showDiv" ng-animate="\'slide\'"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4" ng-if="vm.isCompanyAdmin"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.offices\' }}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-if="vm.subsidiaryView"><label class="filter-label" translate="">Subsidiary</label><div id="subsidiaryList" isteven-multi-select="" input-model="vm.search.subsidiaryList" output-model="vm.search.selectedSubsidiaryList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" on-item-click="vm.populateSubsidiaryFilter()" on-select-all="vm.populateSubsidiaryFilter()" on-select-none="vm.populateSubsidiaryFilter()" on-reset="vm.populateSubsidiaryFilter()" on-clear="vm.populateSubsidiaryFilter()"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15" ng-hide="true"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.company\' }}</label><div isteven-multi-select="" input-model="vm.companyList" output-model="vm.search.selectedCompanyList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.search.onCompanyChange(data)"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15" ng-hide="true"><label class="filter-label" ng-show="vm.search.selectedCompanyList.length > 0" translate="">{{ \'manageAllEmployees.filter.office\'}}</label><div isteven-multi-select="" input-model="vm.officeList" output-model="vm.search.selectedOfficeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" ng-show="vm.search.selectedCompanyList.length > 0"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.departments\' }}</label><div isteven-multi-select="" input-model="vm.search.departmentList.length > 0 ? vm.search.departmentList : vm.departmentList" output-model="vm.search.selectedDepartmentList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.designations\' }}</label><div isteven-multi-select="" input-model="vm.search.designationList.length > 0 ? vm.search.designationList : vm.designationList" output-model="vm.search.selectedDesignationList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.shiftGroups\' }}</label><div isteven-multi-select="" input-model="vm.search.shiftGroupList.length > 0 ? vm.search.shiftGroupList : vm.shiftGroupList" output-model="vm.search.selectedShiftGroupList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.employmentType\'}}</label><div isteven-multi-select="" input-model="vm.search.employmentTypeList.length > 0 ? vm.search.employmentTypeList : vm.employmentTypeList" output-model="vm.search.selectedEmploymentTypeList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.gender\' }}</label><div isteven-multi-select="" input-model="vm.genderList" output-model="vm.search.selectedGenderList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.workplace\' }}</label><div isteven-multi-select="" input-model="vm.search.workplaceList.length > 0 ? vm.search.workplaceList : vm.workplaceList" output-model="vm.search.selectedWorkplaceList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.status\' }}</label><div isteven-multi-select="" input-model="vm.employeeStatusList" output-model="vm.search.selectedemployeeStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.mobilePunchStatus\'}}</label><div isteven-multi-select="" input-model="vm.availableMobilePunchStatusList" output-model="vm.search.selectedMobilePunchStatusList" button-label="name" item-label="name" tick-property="ticked" output-properties="value"></div></div><div class="form-group col-sm-4 col-xs-6 mb-15"><label class="filter-label" translate="">{{ \'manageAllEmployees.filter.searchByName\' }}</label> <input class="form-control" type="text" placeholder="Employee name/ID/RFID..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchEmployees() : null"></div></div><div class="row form-inline"><div class="form-group col-sm-8 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><button type="button" class="btn btn-md btn-primary btn-block" ng-click="vm.searchEmployees()" translate=""><i class="ion-search"></i>{{ \'manageAllEmployees.filter.searchButton\' }}</button></div></div></div><div class="row"><div class="form-group col-sm-7 col-xs-7"><button class="btn btn-md-with-icon btn-primary padding-5-13" ng-click="vm.downloadExcel()"><img src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button> <button class="btn btn-md-with-icon btn-secondary" ng-click="vm.openConfirmationModal(\'Do you want to continue this operation?\', \'activate\' )"><i class="ion-android-done-all"></i> <span class="ml-negative-5 pb-2">{{vm.checkbox.isAnySelected && !vm.checkbox.isAllSelected ? \'Activate Selected\' : \'Activate All\'}}</span></button> <button class="btn btn-md-with-icon btn-danger" ng-click="vm.openConfirmationModal(\'Do you want to continue this operation?\', \'deactivate\' )"><i class="ion-ios-undo"></i> <span class="ml-negative-5 pb-2">{{vm.checkbox.isAnySelected && !vm.checkbox.isAllSelected ? \'Deactivate Selected\' : \'Deactivate All\'}}</span></button></div><div class="col-md-5 col-xs-5 text-right"><div class="row"><div class="col-md-12"><div class="d-flex-gap-10 justify-end"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-md btn-secondary btn-resize" uib-dropdown-toggle=""><span translate="">{{\'commonKeywords.sortByButton\'}}</span>&nbsp;<span class="caret"></span></button><ul uib-dropdown-menu=""><li ng-repeat="(key,value) in vm.sortKeys" ng-class="value.selected == true ? \'list-active\':\'\'"><a ng-click="vm.updateSortKey(key)">{{key}} <span ng-if="value.selected">{{value.order == \'asc\' ? \'&#8593\' : \'&#8595\'}}</span></a></li></ul></div><span class="d-flex-align-center min-width-101"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span><div class="custom-select max-width-100"><select ng-class="{\'cursor-not-allowed\':!vm.isEmployeeListLoaded}" ng-disabled="!vm.isEmployeeListLoaded" ng-model="vm.rowsToShow" ng-change="vm.searchEmployees({pageNumber:\'reset\'})"><option value="10" ng-selected="vm.rowsToShow == 10" translate="">{{\'commonKeywords.ten\'}}</option><option value="50" ng-selected="vm.rowsToShow == 50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.rowsToShow == 100" translate="">{{\'commonKeywords.hundred\'}}</option><option value="1000" ng-selected="vm.rowsToShow == 1000" translate="">{{\'commonKeywords.thousand\'}}</option></select></div></div></div></div></div></div><div class="horizontal-scroll report-container"><table class="table report-table"><thead><tr><th class="width-3 text-center check-uncheck-all"><label class="checkbox-container"><input type="checkbox" ng-model="vm.checkbox.isAllSelected" ng-click="vm.toggleAll()"> <span class="custom-checkbox checkbox-position"></span></label></th><th class="text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center width-6" translate="">{{ \'manageAllEmployees.employeeListTableHeader.id\'}}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.name\' }}</th><th class="text-left" translate="">{{ \'manageAllEmployees.employeeListTableHeader.workplace\'}}</th><th class="text-center width-8" translate="">{{\'commonKeywords.punchStatus\'}}</th></tr></thead><tbody><tr ng-show="vm.isEmployeeListLoaded && vm.allEmployees.length > 0" ng-repeat="item in vm.allEmployees track by item.id" ng-class="{\'opacity-50\' : !item.isMobilePunchEnabled}"><td><label class="checkbox-container"><input type="checkbox" ng-model="item.selected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position"></span></label></td><td>{{(vm.rowsToShow * vm.selectedPaginationPage) + ($index + 1)}}</td><td>{{item.employeeOfficeId == null ? " " : item.employeeOfficeId}}</td><td class="text-left-important"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="item.departmentName" designation-name="!item.designationName ? \'N/A\':item.designationName" id="item.id" is-clickable="item.status === 1"></employee-picture-and-information></td><td class="text-left-important" ng-class="item.workplaceName?\'text-left-important\':\'color-999999 text-left\'">{{item.workplaceName ? item.workplaceName : " N/A"}}</td><td class="text-center" ng-class="item.isMobilePunchEnabled?\'text-green\':\'text-red\'">{{item.isMobilePunchEnabled ? \'Active\' : \'Inactive\' }}</td></tr></tbody></table></div><div class="text-center" ng-show="!vm.isEmployeeListLoaded"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-if="vm.allEmployees.length == 0"><p><strong translate="">{{\'manageAllEmployees.emptyResultText\'}}</strong></p></div><br><br><div class="text-center" ng-if="vm.allEmployees.length > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'first\'})" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'reduce\'})"><</a></li><li ng-repeat="n in vm.numberOfButtons track by $index" ng-class="(vm.selectedPaginationPage==$index)? \'active\':\'\'" ng-if="vm.selectedPaginationPage <= 2 ? $index <= 5 : (vm.selectedPaginationPage <= vm.numberOfButtons.length && vm.selectedPaginationPage > vm.numberOfButtons.length - 6 ? $index > vm.numberOfButtons.length - 7 : $index >= vm.selectedPaginationPage - 2 && $index <= vm.selectedPaginationPage + 3)"><a ng-click="vm.searchEmployees({pageNumber:$index})">{{$index + 1}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'increase\'})">></a></li><li class="page-item"><a class="page-link" ng-click="vm.searchEmployees({pageNumber:\'last\'})" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.allEmployees.length > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.selectedPaginationPage + 1}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.numberOfButtons.length}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p><p><strong><span translate="">{{\'commonKeywords.showing\'}}</span> {{vm.getPaginationInfo()}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.total}}</strong></p></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/holidays/holidayModals/createHoliday.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'holidaySettings.creationModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'holidaySettings.creationModal.titleInputLabel\' }}</label> <input type="text" class="form-control" ng-model="vm.modal.newEvent.description"></div></div><br><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'holidaySettings.creationModal.dateInputLabel\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.modal.newEvent.startDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.modal.newEvent.startDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><br><p>{{ \'holidaySettings.creationModal.confirmationText\' | translate}} {{vm.modal.newEvent.description}}{{\'commonKeywords.questionMark\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.saveHoliday(vm.modal.newEvent)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.confirmButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/holidays/holidayModals/deleteHoliday.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'holidaySettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.holidayToDelete.description}}</em>{{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteHoliday(vm.holidayToDelete)" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/holidays/holidayModals/updateHoliday.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'holidaySettings.editModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label translate="">{{\'holidaySettings.creationModal.titleInputLabel\'}}</label> <input type="text" class="form-control" ng-model="vm.modal.eventToChange.description"></div></div><br><div class="row"><div class="col-md-12"><label translate="">{{ \'holidaySettings.creationModal.dateInputLabel\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.eventDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.eventDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><br><p>{{ \'holidaySettings.editModal.confirmationText\' | translate}} {{vm.modal.eventToChange.description}}{{\'commonKeywords.questionMark\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateHoliday()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/notification/confirmationModal/confirmationModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6"><span translate="">{{vm.employeeName}}</span><span translate="">{{\'notificationSettings.removeFromNotification\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="$close()" translate="">{{\'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/settings/notification/errorModal/errorModal.html','<style>\n    .error-list {\n        max-height: 200px;\n        overflow-y: auto;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'notificationSettings.errorList\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="error-list"><ul ng-repeat="error in vm.errorList"><li>{{error}}</li></ul></div><div class="footer"><button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/settings/notification/partials/dummyModel.html','<style>\n    .modal-div{\n        height: 6vh;\n        margin-left:20px;\n        margin-right:20px;\n        border: 1px solid #edf0ee;\n        background:#edf0ee;\n    }\n    .dummy-btn{\n        height: 2vh;\n        width: 95%;\n    }\n    .top-btn{\n        margin-bottom:4%;\n        margin-top: 10%;\n    }\n    .bottom-btn{\n        margin-bottom:8%\n    }\n    .dummy-modal-placement2{\n        position: absolute;\n        top:35%;\n        left:15%;\n        width: 65%;\n    }\n</style><div class="modal-content dummy-modal-placement2"><div class="row"><div class="col-md-12"><h5 class="modal-title text-center mb-20 mt-30 color-prime font-weight-500" translate="">{{\'commonKeywords.dummyModalText\'}}</h5></div></div><div class="row modal-div mb-40"><div class="col-md-12 prevent-clicks"><div class="row d-flex-space-between mt-6"><div class="col-md-3 col-xs-3 pl-0 d-flex-align-center"><div class="height-1_1-vh width-100 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pl-0"><div class="height-1_1-vh width-150 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pr-0"><div class="height-1_1-vh width-100 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pr-0"><div class="height-1_1-vh width-75 dummy-line1-bg border-radius-10 mt-15"></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/settings/notification/partials/employeeTable.html','<style>\n    .color-gray{\n        color: #c5bebe;\n    }\n    .color-gray:hover{\n        color: #c5bebe;\n    }\n    table tr th.border-hidden {\n        border-left: hidden !important;\n        /*border-right:hidden !important;*/\n    }\n    table tbody tr td.border-hidden {\n        border-left: hidden !important;\n        border-right: hidden !important;\n    }\n</style><table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-5"><col class="width-5"><col class="width-10"><col class="width-37"><col class="width-23"><col class="width-20"></colgroup><thead><tr class="row-height height-5-vh"><th class="text-center check-uncheck-all"><label class="checkbox-container"><input type="checkbox" ng-model="vm.allSelected" ng-click="vm.checkOrUncheckAll()"> <span class="custom-checkbox checkbox-position"></span></label></th><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center" translate="">{{\'commonKeywords.id\'}}</th><th class="text-left" translate="">{{\'commonKeywords.name\'}}</th><th class="text-left" translate="">{{\'lineManager\'}}</th><th class="text-center" translate="">{{\'commonKeywords.notificationStatus\'}}</th></tr></thead><tbody><tr ng-repeat="employee in vm.employeeList" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRow == $index}"><td class="text-center"><label class="checkbox-container"><input type="checkbox" ng-model="employee.isSelected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position"></span></label></td><td class="text-center" ng-click="vm.showNotificationInfoInTheRightColumn($index, employee.employeeId)">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1 }}</td><td class="text-center" ng-click="vm.showNotificationInfoInTheRightColumn($index, employee.employeeId)">{{employee.employeeOfficeId}}</td><td class="dont-wrap-text" ng-click="vm.showNotificationInfoInTheRightColumn($index,employee.employeeId)"><employee-picture-and-information name="employee.name" picture-url="employee.pictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" is-clickable="false"></employee-picture-and-information></td><td class="border-hidden" ng-click="vm.showNotificationInfoInTheRightColumn($index,employee.employeeId)" ng-class="employee.lineManagerName === null ?\'color-999999 text-left\':\'text-left\'">{{employee.lineManagerName === null ? "Not-Set" : employee.lineManagerName}}</td><td class="p-all-0 text-center font-22" ng-click="vm.showNotificationInfoInTheRightColumn($index, employee.employeeId)"><i class="ion-android-notifications color-gray" ng-class="{\'color-prime\':employee.notificationStatus === true}"></i></td></tr></tbody></table><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive>');
$templateCache.put('app/pages/main/settings/notification/partials/notificationDetailsSection.html','<style>\n    .pr-25 {\n        padding-right: 25px !important;\n    }\n\n    .thead-gray {\n        background: #ededed;\n    }\n\n    .report-table > tbody > tr:nth-of-type(even) {\n        background-color: #f9f9f9;\n    }\n\n    .report-table > tbody > tr:nth-of-type(odd) {\n        background-color: white;\n    }\n\n    .full-screen {\n        height: calc(100vh - 220px);\n    }\n\n    .full-screen .panel {\n        box-shadow: none;\n        background: #f9f9f9;\n    }\n\n    .panel-full-screen {\n        height: 100%;\n        position: relative;\n    }\n\n    .full-screen .panel-body {\n        height: calc(100% - 20px);\n        overflow-y: auto;\n        overflow-x: hidden;\n        padding: 0;\n    }\n\n    .bg-gray-light {\n        background: #f9f9f9;\n    }\n    .notification-details .profile-info {\n        min-width: 300px!important;\n    }\n    .disabled-pointer-event{\n        pointer-events: none;\n        z-index: 0;\n        position: relative;\n        opacity: 0.50;\n    }\n    /*.disabled-pointer-event:before{\n        content: "";\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        z-index: 1;\n        background: rgba(0, 0, 0, 0.19);\n    }*/\n</style><div class="row text-center" ng-show="!vm.isNotificationLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-show="vm.isNotificationLoaded"><div ba-panel="" ba-panel-class="with-scroll panel-full-screen" class="full-screen"><div class="row p-x-15"><div class="col-md-12 m-0"><table class="table"><colgroup><col class="width-100"></colgroup><thead class="thead-gray"><tr class="text-center th-width"><td class="position-relative d-flex-space-between notification-details"><employee-picture-and-information name="vm.selectedEmployee.name" picture-url="vm.selectedEmployee.pictureUrl" department-name="vm.selectedEmployee.departmentName" designation-name="vm.selectedEmployee.designationName" id="vm.selectedEmployee.id" is-clickable="vm.selectedEmployee.status == 1"></employee-picture-and-information><div class="pr-25"><button ng-show="!vm.notificationEdit" class="btn btn-sm-with-icon btn-secondary" ng-click="vm.notificationEdit=true"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'notificationSettings.editButton\'}}</span></button></div></td></tr></thead></table></div></div><div class="p-x-20" ng-repeat="data in vm.selectedEmployeeNotificationSettingsList"><div class="row mt-20"><div class="col-md-8"><span class="mb-0 font-16 color-22222 font-weight-400 mt-5">{{data.name}}</span></div><div class="col-md-4 mt-3 d-flex-flex-end" ng-show="vm.notificationEdit"><div class="d-flex"><strong class="mr-5" translate="">off</strong> <label class="custom-switch"><input name="enabled" ng-change="vm.handleNotificationOnOffButton()" ng-model="data.on" type="checkbox"><span class="slider round"></span></label> <strong class="ml-5" translate="">on</strong></div></div></div><div class="row mt-5"><div class="col-md-12"><table class="table report-table even-child-selector report-table-font-14 mt-5" ng-class="{\'disabled-pointer-event\':!data.on && vm.notificationEdit}"><thead class="thead-gray"><tr><td class="text-left" translate="">{{\'employeeActions.notification.selectRecipients\'}}</td><td class="text-center" translate="">{{\'employeeActions.notification.sms\'}}</td><td class="text-center" translate="">{{\'employeeActions.notification.email\'}}</td><td class="text-center" translate="">{{\'employeeActions.notification.pushNotification\'}}</td></tr></thead><tbody><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientSelf\'}}</span></td><td class="text-center" ng-repeat="checkbox in data.selfCheckBoxes"><i ng-show="checkbox.value && !vm.notificationEdit" class="ion-ios-checkmark-outline font-20 text-primary"></i> <i ng-show="!checkbox.value && !vm.notificationEdit" class="font-18">-</i><div ng-show="vm.notificationEdit"><label class="checkbox-container text-normal"><input type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value" ng-change="vm.isDataEdited=true"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-25 default-text" translate="">{{ checkbox.labelText}}</span></label></div></td></tr><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientLineManager\'}}</span></td><td class="text-center" ng-repeat="checkbox in data.lineManagerCheckBoxes"><div ng-show="vm.notificationEdit"><label class="checkbox-container text-normal"><input type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value" ng-change="vm.isDataEdited=true"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-25 default-text" translate="">{{ checkbox.labelText}}</span></label></div><i ng-show="checkbox.value && !vm.notificationEdit" class="ion-ios-checkmark-outline font-20 text-primary"></i> <i ng-show="!checkbox.value && !vm.notificationEdit" class="font-18">-</i></td></tr><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientHRManager\'}}</span></td><td class="text-center" ng-repeat="checkbox in data.hrCheckBoxes"><div ng-show="vm.notificationEdit"><label class="checkbox-container text-normal"><input type="checkbox" id="{{checkbox.id}}" ng-model="checkbox.value" ng-change="vm.isDataEdited=true"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-25 default-text" translate="">{{ checkbox.labelText}}</span></label></div><i ng-show="checkbox.value && !vm.notificationEdit" class="ion-ios-checkmark-outline font-20 text-primary"></i> <i ng-show="!checkbox.value && !vm.notificationEdit" class="font-18">-</i></td></tr></tbody></table></div></div><h4 class="mt-10 mb-25">{{\'notificationSettings.notificationConfigurationHeading\' | translate}} <b class="color-prime">{{data.notificationConfiguration}}</b></h4><div class="clearfix mt-20 mb-20" ng-show="vm.notificationEdit"><div class="clearfix" ng-if="data.notificationGroup===100"><div class="col-md-5 mt-10"><span translate="">{{ \'employeeActions.notification.officeTimeNotifyBeforeStartTime\' }}</span></div><div class="col-md-7"><input min="0" max="59" placeholder="Enter time between 1 and 59 minutes" id="minBeforeStart" ng-model="data.settingsValue" type="number" class="form-control"></div></div><div class="clearfix" ng-if="data.notificationGroup===400"><div class="col-md-5 mt-10"><span translate="">{{ \'employeeActions.notification.whenToCheckAbsent\' }}</span></div><div class="col-md-7"><div class="custom-select"><select ng-model="data.settingsValue" ng-options="option.name for option in vm.whenToCheckAbsentDropdown"><option value="" disabled="" translate="">pleaseSelect</option></select></div></div></div><div class="clearfix" ng-if="data.notificationGroup===900"><div class="col-md-5 mt-10"><span translate="">{{ \'employeeActions.notification.whenToCheckEarlyExit\' }}</span></div><div class="col-md-7"><div class="custom-select"><select ng-model="data.settingsValue" ng-options="option.name for option in vm.whenToCheckEarlyExitDropdown"><option value="" disabled="" translate="">pleaseSelect</option></select></div></div></div></div></div></div><div class="p-x-20 d-flex-flex-end bg-gray-light pb-20" ng-show="vm.notificationEdit"><button class="btn border-btn btn-md" ng-click="vm.notificationEdit=false"><span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.cancelButton\'}}</span></button> <button class="btn btn-secondary btn-md ml-20" ng-click="vm.updateNotificationSettingsBatchByEmployeeId()"><span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.saveButton\'}}</span></button></div></div>');
$templateCache.put('app/pages/main/settings/notification/partials/notificationGroup.html','<table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-7"><col class="width-50"><col class="width-30"><col class="width-13"></colgroup><thead><tr class="row-height"><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{\'notificationSettings.notificationGroupName\'}}</th><th class="text-center" translate="">numberOfEmployees</th><th class="text-center" translate="">status</th></tr></thead><tbody><tr ng-repeat="data in vm.notificationGroupList" class="cursor-pointer border-bottom-1 height-45" ng-if="vm.isDataLoaded" ng-click="vm.showNotificationGroupDetailsInTheRightColumn($index,data.value)" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRow == $index,\'row-disable\':data.disabled}"><td class="text-center">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1}}</td><td class="text-left">{{data.name}}</td><td class="text-center">{{data.totalEmployee=="-"? "":data.totalEmployee}}</td><td class="text-center">{{data.disabled ? \'Inactive\':\'Active\'}}</td></tr></tbody></table><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.searchNotificationGroup" hide-no-data-message="true"></pagination-directive>');
$templateCache.put('app/pages/main/settings/notification/partials/notificationGroupDetails.html','<style>\n    .scrollable-table {\n        max-height: 486px;\n        overflow-y: auto;\n    }\n</style><div class="row text-center" ng-show="!vm.isEmployeeLoadedByNotifiGroup"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="col-md-12" ng-show="vm.isEmployeeLoadedByNotifiGroup"><div class="row"><div class="col-md-6"><div class="form-group has-feedback has-search mb-5"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.getDetailsOfSearchedEmployee()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div></div><div class="row"><div class="col-md-12 mt-negative-5 scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-center width-10" translate="">id</th><th class="text-left width-40" translate="">name</th><th class="text-center f-letter-capitalize width-25">{{vm.notificationGroupTableHeaderMessage}}</th><th class="text-center width-20" translate="">action</th></tr></thead><tbody><tr class="dont-wrap-text border-bottom-1" ng-repeat="employee in vm.employeeListForNotificationGroupTab"><td class="text-center">{{$index+1}}</td><td class="text-center">{{employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.name" picture-url="employee.pictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.id" is-clickable="employee.status == 1"></employee-picture-and-information></td><td class="text-center">{{vm.getSettingsValue(employee.notificationSettings)}}</td><td class="text-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openConfiramtionModal(employee.id,employee.name)"><i class="ion-android-notifications-off"></i> <span class="ml-negative-5 pb-2 font-weight-500" translate="">{{\'commonKeywords.turnOffButton\'}}</span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/main/settings/notification/partials/setNotificationForEmployees.html','<style>\n    .section-padding{\n        padding: 25px 25px;\n    }\n    .set-notification .table tr{\n        height: 40px;\n    }\n    .set-notification .borderless-table > thead > tr > th{\n        background: #ededed!important;\n        color: #222222!important;\n    }\n</style><div class="col-md-12"><div class="bg-fbfbfb"><div class="section-padding set-notification"><label class="font-15">{{notificationSettings.selectNotificationGroup | translate}}</label><div class="row"><div class="col-md-12 mt-10 mb-15"><div isteven-multi-select="" input-model="vm.notificationGroups" output-model="vm.selectedNotificationGroup" button-label="name" item-label="name" tick-property="ticked" output-properties="value" selection-mode="single" disable-property="disabled" on-item-click="vm.resetAllCheckedItem()"></div></div></div><div ng-if="vm.selectedNotificationGroup.length !== 0"><table class="table borderless-table even-row-strip mt-10"><thead><tr><th class="text-left" translate="">{{\'employeeActions.notification.selectRecipients\'}}</th><th class="text-center" translate="">{{\'employeeActions.notification.sms\'}}</th><th class="text-center" translate="">{{\'employeeActions.notification.email\'}}</th><th class="text-center" translate="">{{\'employeeActions.notification.pushNotification\'}}</th></tr></thead><tbody><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientSelf\'}}</span></td><td class="text-center" ng-repeat="checkbox in vm.selfCheckBoxes"><label class="checkbox-container text-normal"><input type="checkbox" ng-model="checkbox.value"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-25 default-text">{{ checkbox.labelText | translate }}</span></label></td></tr><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientLineManager\'}}</span></td><td class="text-center" ng-repeat="checkbox in vm.lineManagerCheckBoxes"><label class="checkbox-container text-normal"><input type="checkbox" ng-model="checkbox.value"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-25 default-text">{{ checkbox.labelText | translate }}</span></label></td></tr><tr><td class="text-left"><span translate="">{{ \'employeeActions.notification.recipientHRManager\'}}</span></td><td class="text-center" ng-repeat="checkbox in vm.hrCheckBoxes"><label class="checkbox-container text-normal"><input type="checkbox" ng-model="checkbox.value"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-25 default-text">{{ checkbox.labelText | translate }}</span></label></td></tr></tbody></table><div class="mt-15"><span class="color-22222 font-15">{{\'notificationSettings.notificationConfiguration\' | translate}}</span></div><div class="row mt-15" ng-if="vm.selectedNotificationGroup[0].value == 100"><div class="col-md-5 mt-10"><span class="color-22222 font-14" translate="">{{\'employeeActions.notification.officeTimeNotifyBeforeStartTime\'}}</span></div><div class="col-md-7"><input type="number" class="form-control" ng-model="vm.officeTimeNotifyBeforeStartTime"></div></div><div class="row mt-15" ng-if="vm.selectedNotificationGroup[0].value == 400"><div class="col-md-5 mt-10"><span class="color-22222 font-14" translate="">{{\'employeeActions.notification.whenToCheckAbsent\'}}</span></div><div class="col-md-7"><div class="custom-select"><select ng-model="vm.whenToCheckAbsent" ng-options="option.name for option in vm.whenToCheckAbsentDropdown"><option value="" disabled="" translate="">pleaseSelect</option></select></div></div></div><div class="row mt-15" ng-if="vm.selectedNotificationGroup[0].value == 900"><div class="col-md-5 mt-10"><span class="color-22222 font-14" translate="">{{\'employeeActions.notification.whenToCheckEarlyExit\'}}</span></div><div class="col-md-7"><div class="custom-select"><select ng-model="vm.whenToCheckEarlyExit" ng-options="option.name for option in vm.whenToCheckEarlyExitDropdown"><option value="" disabled="" translate="">pleaseSelect</option></select></div></div></div><div class="d-flex-flex-end mt-15"><button class="btn btn-md border-btn" ng-click="vm.cancelNotificationSetting()"><span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.cancelButton\'}}</span></button> <button class="btn btn-md btn-secondary ml-20" ng-click="vm.saveNotificationSettings()"><span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.saveButton\'}}</span></button></div></div></div></div><div ng-if="vm.selectedNotificationGroup.length !== 0" class="bg-white mt-15"><div class="d-flex-center"><p><span class="d-flex-center"><span translate="">{{\'notificationSettings.thePreviousNotificationSettings\'}}</span> <span class="color-22222 font-weight-600">&nbsp; <span>{{\'notificationSettings.erased\'| translate}}</span></span></span><br><span>{{\'notificationSettings.forThe\' | translate}}</span> <span class="color-22222 font-weight-600" translate="">{{\'notificationSettings.selectedEmployees\' | translate}}</span> <span translate="">{{\'notificationSettings.forThisNotificationGroup\' | translate}}</span></p></div></div></div>');
$templateCache.put('app/pages/main/settings/shifts/create/createShift.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Shift</h4></div><div class="modal-body" style="margin-left:10px"><div class="row"><div class="col-md-3" style="margin-top: 5px"><span><strong>Shift Name</strong></span></div><div class="col-md-3"><input type="text" class="form-control" placeholder="Insert Name" ng-model="vm.cShift.name"></div><div class="col-md-2" style="margin-top: 5px"><strong style="margin-left: 70px">Status</strong></div><div class="col-md-4"><switch id="enabled" name="enabled" ng-model="vm.cShift.enabled" class="green" style="margin-left: 20px"></switch><br><br><strong style="margin-left: 20px">{{ vm.cShift.enabled ? \'Active\' : \'Inactive\' }}</strong></div></div><br><br><br><div class="row"><div class="col-md-3" style="margin-top: 60px"><strong>Shift Timing</strong></div><div class="col-md-4"><strong style="margin-left: 40px;margin-bottom: 20px">From</strong><div uib-timepicker="" ng-model="vm.cShift.cShiftTimepickers.startTime" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div><div class="col-md-4"><strong style="margin-left: 70px;margin-bottom: 20px">To</strong><div uib-timepicker="" ng-model="vm.cShift.cShiftTimepickers.endTime" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div></div><div class="row" style="margin-top: 30px"><div class="col-md-3" style="margin-top: 60px"><strong>Early And Late</strong></div><div class="col-md-4"><strong style="margin-bottom: 20px">Late Count Starts From</strong><div uib-timepicker="" ng-model="vm.cShift.cShiftTimepickers.lateAfter" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div><div class="col-md-4"><strong style="margin-bottom: 20px">Early Exit Counted Before</strong><div uib-timepicker="" ng-model="vm.cShift.cShiftTimepickers.earlyExit" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div></div><div class="row" ng-if="vm.hasPermission(6012)"><div class="col-md-3" style="margin-top: 60px"><strong>Break Time</strong></div><div class="col-md-4"><strong style="margin-left: 40px;margin-bottom: 20px">From</strong><div uib-timepicker="" ng-model="vm.cShift.cShiftTimepickers.firstHalfEnds" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div><div class="col-md-4"><strong style="margin-left: 70px;margin-bottom: 20px">To</strong><div uib-timepicker="" ng-model="vm.cShift.cShiftTimepickers.secondHalfStarts" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" value="vm.cShift.disableLate" ng-model="vm.cShift.disableLate"> <span>Disable Late</span></label></div></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="vm.cShift.isMidnightCrossing" ng-model="vm.cShift.isMidnightCrossing"> <span>This shift crosses midnight (12am at night)</span></label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createNewShift()" style="margin-right: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/settings/shifts/delete/deleteShift.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete {{vm.shiftToDelete.name}} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-md" ng-click="vm.deleteShift()">Yes</button> <button type="button" class="btn btn-danger btn-md" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/settings/shifts/edit/editShift.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Shift</h4></div><div class="modal-body" style="margin-left: 10px"><div class="row"><div class="col-md-3" style="margin-top: 10px"><strong>Shift Name</strong></div><div class="col-md-3"><input type="text" class="form-control" ng-model="vm.shift.name"></div><div class="col-md-2" style="margin-top: 10px"><strong style="margin-left: 70px">Status</strong></div><div class="col-md-4"><switch id="enabled" name="enabled" ng-model="vm.enabled" class="green" style="margin-left: 20px"></switch><br><br><strong style="margin-left: 20px">{{ vm.enabled ? \'Active\' : \'Inactive\' }}</strong></div></div><br><br><br><div class="row"><div class="col-md-3" style="margin-top: 60px"><strong>Shift Timing</strong></div><div class="col-md-4"><strong style="margin-left: 40px;margin-bottom: 20px">From</strong><div uib-timepicker="" ng-model="vm.timepicker.startTime" ng-change="changed()" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div><div class="col-md-4"><strong style="margin-left: 70px;margin-bottom: 20px">To</strong><div uib-timepicker="" ng-model="vm.timepicker.endTime" ng-change="changed()" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div></div><div class="row" style="margin-top: 30px"><div class="col-md-3" style="margin-top: 60px"><strong>Early And Late</strong></div><div class="col-md-4"><strong style="margin-bottom: 20px">Late Count Starts From</strong><div uib-timepicker="" ng-model="vm.timepicker.lateAfter" ng-change="changed()" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div><div class="col-md-4"><strong style="margin-bottom: 20px">Early Exit Counted Before</strong><div uib-timepicker="" ng-model="vm.timepicker.earlyBefore" ng-change="changed()" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div></div><div class="row" ng-if="vm.hasPermission(6012)"><div class="col-md-3" style="margin-top: 60px"><strong>Break Time</strong></div><div class="col-md-4"><strong style="margin-left: 40px;margin-bottom: 20px">From</strong><div uib-timepicker="" ng-model="vm.timepicker.firstHalfEnds" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div><div class="col-md-4"><strong style="margin-left: 70px;margin-bottom: 20px">To</strong><div uib-timepicker="" ng-model="vm.timepicker.secondHalfStarts" hour-step="vm.hstep" minute-step="vm.mstep" show-meridian="vm.ismeridian"></div></div></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" value="vm.shift.disableLate" ng-model="vm.shift.disableLate"> <span>Disable Late</span></label></div></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="vm.shift.isMidnightCrossing" ng-model="vm.shift.isMidnightCrossing"> <span>This shift crosses midnight (12am at night)</span></label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateShiftDetails()" style="margin-right: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/settings/specialDays/specialDayModals/createSpecialDay.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'specialDaySettings.creationModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div class="form-group"><label class="required" translate="">{{ \'specialDaySettings.creationModal.titleInputLabel\' }}</label> <input type="text" class="form-control" ng-model="vm.modal.newEvent.title" required=""></div></div></div><div class="form-group"><label class="required" translate="">{{ \'specialDaySettings.creationModal.workplaceInputLabel\' }}</label><div isteven-multi-select="" input-model="vm.workplaces" output-model="vm.modal.newEvent.workplaceIds" button-label="name" item-label="name" tick-property="ticked" search-property="name" max-height="200px" helper-elements="all filter none"></div></div><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'specialDaySettings.creationModal.dateInputLabel\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.attendancedatePicker.date" options="vm.attendancedatePicker.options" min="vm.minDate"><span class="date-position-left">{{vm.attendancedatePicker.date.startDate.format("D MMM YYYY")}} - {{vm.attendancedatePicker.date.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row"><div class="col-md-12"><p>{{ \'specialDaySettings.creationModal.confirmationText\' | translate}} {{vm.modal.newEvent.description}}{{\'commonKeywords.questionMark\' | translate}}</p></div></div><div class="footer text-right"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.saveSpecialDay(vm.modal.newEvent)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.confirmButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/specialDays/specialDayModals/deleteSpecialDay.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'specialDaySettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.specialDayToDelete.title}}</em>{{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteSpecialDay(vm.specialDayToDelete)" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/specialDays/specialDayModals/updateSpecialDay.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'specialDaySettings.editModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div class="form-group"><label class="required" translate="">{{\'specialDaySettings.creationModal.titleInputLabel\'}}</label> <input type="text" class="form-control" ng-model="vm.modal.eventToChange.title" required=""></div></div></div><br><div class="form-group"><label class="required" translate="">{{ \'specialDaySettings.creationModal.workplaceInputLabel\' }}</label><div isteven-multi-select="" input-model="vm.workplaces" output-model="vm.modal.eventToChange.workplaceIds" button-label="name" item-label="name" tick-property="ticked" search-property="name" max-height="200px" helper-elements="all filter none"></div></div><br><div class="row"><div class="col-md-12"><div class="form-group"><label class="required" translate="">{{ \'specialDaySettings.creationModal.dateInputLabel\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.attendancedatePicker.date" options="vm.attendancedatePicker.options"><span class="date-position-left">{{vm.attendancedatePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.attendancedatePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div></div><br><p>{{ \'specialDaySettings.editModal.confirmationText\' | translate}} {{vm.modal.eventToChange.title}}{{\'commonKeywords.questionMark\' | translate}}</p><div class="footer text-right"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateSpecialDay()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/subDepartments/createSubDepartment/createSubDepartment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'subDepartmentSettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" for="name" translate="">{{ \'subDepartmentSettings.creationModal.nameInputLabel\' }}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'subDepartmentSettings.creationModal.nameInputPlaceholder\' | translate}}" ng-model="vm.create.name"></div></div><br><div class="row"><div class="col-md-12"><label class="required" for="name" translate="">{{ \'subDepartmentSettings.creationModal.hierarchyInputLabel\' }}</label> <input type="number" class="form-control" placeholder="{{ \'subDepartmentSettings.creationModal.hierarchyInputPlaceHolder\' | translate}}" ng-model="vm.create.hierarchy"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createSubDepartment()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/subDepartments/deleteSubDepartment/deleteSubDepartment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'subDepartmentSettings.deleteModal.confirmationText\' | translate}} <em class="color-22222 font-weight-400">{{vm.subDepartment.name}}</em>{{ \'subDepartmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteSubDepartment()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/subDepartments/editSubDepartment/editSubDepartment.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'subDepartmentSettings.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label for="name" class="editDepartmentFormLabel">{{ \'subDepartmentSettings.creationModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" ng-model="vm.subDepartment.name"></div></div><br><div class="row"><div class="col-md-12"><label for="name">{{ \'subDepartmentSettings.creationModal.hierarchyInputLabel\' | translate}}</label> <input type="number" class="form-control" placeholder="{{ \'subDepartmentSettings.creationModal.hierarchyInputPlaceHolder\' | translate }}" ng-model="vm.subDepartment.hierarchy"></div></div><br><div class="row"><div class="col-md-12" id="editDepartmentDivs"><strong translate="">{{ \'subDepartmentSettings.editModal.statusInputLabel\' }}</strong> <label class="custom-switch ml-20 mr-20"><input id="enabled" name="enabled" ng-model="vm.subDepartment.enabled" type="checkbox"><span class="slider round"></span></label> <strong translate="">{{ vm.subDepartment.enabled ? \'commonKeywords.statusActive\' : \'commonKeywords.statusInactive\' }}</strong></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateSubDepartmentDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/weeklyOffDayPolicy/create/createWeeklyOffDaysPolicy.modal.html','<div ba-panel="" ba-panel-title="Edit Policy" ba-panel-class="modal-scroll"><br><br><div class="row"><div class="col-md-3"><label>Name</label></div><div class="col-md-6"><input type="text" class="form-control" ng-model="vm.modal.newPolicyName"></div></div><br><br><div class="row"><div class="col-md-3"><label>Off Days</label></div><div class="col-md-6"><isteven-multi-select input-model="vm.multiSelectInputModel" output-model="vm.modal.multiSelectOutputModel" button-label="icon name" item-label="icon name maker" tick-property="isSelected" output-properties="name value isSelected"></isteven-multi-select></div></div><div class="row text-right" style="padding-top: 30px;"><button class="btn btn-primary" ng-click="vm.createPolicy()">Save</button></div></div>');
$templateCache.put('app/pages/main/settings/weeklyOffDayPolicy/delete/deleteWeeklyOffDaysPolicy.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete the Weekly Off Days Policy named {{vm.policyToDelete.name}} ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deletePolicy(vm.policyToDelete.id)">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/settings/weeklyOffDayPolicy/update/updateWeeklyOffDaysPolicy.modal.html','<div ba-panel="" ba-panel-title="Edit Policy" ba-panel-class="modal-scroll"><br><br><div class="row"><div class="col-md-3"><label>Name</label></div><div class="col-md-6"><input type="text" class="form-control" ng-model="vm.policyToEdit.name"></div></div><br><br><div class="row"><div class="col-md-3"><label>Off Days</label></div><div class="col-md-6"><isteven-multi-select input-model="vm.multiSelectInputModel" output-model="vm.modal.multiSelectOutputModel" button-label="icon name" item-label="icon name maker" tick-property="isSelected" output-properties="name value isSelected"></isteven-multi-select></div></div><div class="row text-right"><button class="btn btn-primary" ng-click="vm.updatePolicy()">Save</button></div></div>');
$templateCache.put('app/pages/main/settings/weeklyOffDayPolicy/viewAssignedEmployees/viewAssignedEmployees.modal.html','<div ba-panel="" ba-panel-title="Employee List" ba-panel-class="with-scroll"><table class="table table-striped"><thead><tr><td>Name</td><td>Department</td><td>Designation</td><td>Shift</td></tr></thead><tr ng-repeat="employee in vm.employeeList"><td><a ui-sref="profile({employeeId : {{employee.id}}})">{{employee.name}}</a></td><td>{{employee.department.name}}</td><td>{{employee.designation.name}}</td><td>{{employee.shift.name}}</td></tr></table><br><div class="row text-right"><button class="btn btn-danger" ng-click="$dismiss()">Close</button></div></div>');
$templateCache.put('app/pages/main/settings/subsidiary/createSubsidiary/createSubsidiary.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">Create Subsidiary</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" for="name">Subsidiary Name</label> <input type="text" id="name" class="form-control" placeholder="Enter subsidiary name" ng-model="vm.create.name"></div></div><div class="row mt-15"><div class="col-md-12"><label>Select Subsidiary Admin</label><div isteven-multi-select="" selection-mode="single" input-model="vm.employees" output-model="vm.create.selectedEmployees" button-label="empName" item-label="empName" tick-property="ticked" search-property="empName" max-height="200px" helper-elements="filter" translation="{search: \'Search...\', nothingSelected: \'Select Subsidiary Admin\'}"></div><small class="text-muted" ng-if="vm.isLoadingEmployees">Loading employees...</small></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createSubsidiary()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">Create</span> <span ng-if="vm.isCreating">Please Wait...</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/subsidiary/deleteSubsidiary/deleteSubsidiary.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><p class="font-14 line-height-1_6">{{ \'subsidiarySettings.deleteModal.confirmationText\' | translate}} <em class="color-22222 font-weight-400">{{vm.subsidiary.name}}</em>{{ \'subsidiarySettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteSubsidiary()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">Delete</span> <span ng-if="vm.isDeleting">Deleting...</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/subsidiary/editSubsidiary/editSubsidiary.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">Edit Subsidiary</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" for="name">Subsidiary Name</label> <input type="text" id="name" class="form-control" placeholder="Enter subsidiary name" ng-model="vm.subsidiary.name"></div></div><div class="row mt-15"><div class="col-md-12"><label>Select Subsidiary Admin</label><div isteven-multi-select="" selection-mode="single" input-model="vm.employees" output-model="vm.subsidiary.selectedEmployees" button-label="empName" item-label="empName" tick-property="ticked" search-property="empName" max-height="200px" helper-elements="filter" translation="{search: \'Search...\', nothingSelected: \'Select Subsidiary Admin\'}"></div><small class="text-muted" ng-if="vm.isLoadingEmployees">Loading employees...</small></div></div><div class="row mt-15"><div class="col-md-12" id="editSubsidiaryDivs"><strong>Status</strong> <label class="custom-switch ml-20 mr-20"><input id="enabled" name="enabled" ng-model="vm.subsidiary.enabled" type="checkbox"><span class="slider round"></span></label> <strong>{{ vm.subsidiary.enabled ? \'Active\' : \'Inactive\' }}</strong></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateSubsidiaryDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">Update</span> <span ng-if="vm.isEditing">Please Wait...</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/workplace/createWorkplace/createWorkplace.modal.html','<style>\n\n    .pac-container {\n        z-index: 1050 !important;  /* Set this value to be higher than your modal */\n        position: absolute !important;\n    }\n\n</style><body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'workplaceSettings.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'workplaceSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'workplaceSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.cName"></div></div><br><div class="row"><div class="col-md-12"><label translate="">Location Name</label> <input id="locationName" type="text" class="form-control" placeholder="Enter location name" ng-model="vm.create.locationName"></div></div><br><div class="row"><div class="col-md-12"><div id="map" style="height: 300px;"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createNewWorkplace()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/settings/workplace/deleteWorkplace/deleteWorkplace.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-14 line-height-1_6">{{ \'workplaceSettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.workplace.name}}</em> {{ \'departmentSettings.deleteModal.questionMark\' | translate}} {{ \'workplaceSettings.deleteModal.confirmationTextExtension\' | translate }}</p></div><div class="mt-50 d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteWorkplace()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/settings/workplace/editWorkplace/editWorkplace.modal.html','<style>\n\n    .pac-container {\n        z-index: 1050 !important;  /* Set this value to be higher than your modal */\n        position: absolute !important;\n    }\n\n</style><body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'workplaceSettings.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label translate="">{{ \'workplaceSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" ng-model="vm.workplace.name"></div></div><br><div class="row"><div class="col-md-12"><label translate="">Location Name</label> <input id="locationName" type="text" class="form-control" placeholder="Enter location name" ng-model="vm.locationName"></div></div><br><div class="row"><div class="col-md-12"><div id="map" style="height: 300px;"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateWorkplace()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/shiftManagement/roster/advancedView/advancedView.html','<style>\n    #section2 {\n        height: 800px;\n        overflow-y: scroll;\n        /*scroll-snap-type: y mandatory;*/\n        margin: 0 20px;\n    }\n\n    .table-container {\n        scroll-snap-align: center;\n        height: 100vh;\n    }\n\n    #section1 {\n        margin: 0 20px 20px 20px;\n        text-align: right;\n    }\n\n    #section2 div.row {\n        margin: 0 20px;\n    }\n\n    .td-1 {\n        width: 150px;\n    }\n\n    .td-2 {\n        width: 44px;\n        padding: 1px !important;\n        padding-right: 1px !important;\n    }\n\n    .off-day {\n        color: #FFFFFF;\n        background-color: #00004F;\n    }\n\n    .off-day i {\n        color: #FFFFFF;\n    }\n</style><div class="position-relative"><upgrade-banner code="[5006,5008]"><div id="section1" class="row"><span class="mt-10" ng-repeat="shift in vm.shifts" ng-style="{\'color\': shift.color}">{{shift.name}} <span ng-if="shift.id != -1">Shift</span> ({{shift.initial}})</span><div class="mt-5 mb-3"><button type="button" class="btn btn-md-with-icon btn-danger ml-10" ng-click="vm.reset()"><i class="ion-refresh"></i>{{ \'rosterSettings.resetButton\' | translate}}</button> <button type="button" class="btn btn-md-with-icon btn-warning" ng-click="vm.openRepeatModal()"><i class="ion-loop"></i>{{ \'rosterSettings.repeatButton\' | translate}}</button></div><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.saveChanges()"><i class="ion-upload"></i>{{ \'rosterSettings.saveButton\' | translate}}</button></div><div id="section2"><div class="table-container row" ng-repeat="month in vm.days"><h4>{{month.monthName}} {{month.year}}</h4><div class="horizontal-scroll report-container" fixed-column-table=""><table class="table report-table text-center"><thead><tr><th class="headers2" rowspan="2">Group Name</th><th ng-repeat="date in month.dates" class="headers2">{{date}}</th></tr><tr><th ng-repeat="day in month.days track by $index" class="headers2">{{vm.getDayName(day)}}</th></tr></thead><tbody><tr ng-repeat="sg in vm.shiftGroups"><td class="td-1 text-left">{{sg.name}}</td><td class="td-2" ng-repeat="roster in vm.advancedRosters[sg.id][month.monthNumber] track by $index"><div ng-style="{\'color\': vm.shiftIdToColorMap[roster.shiftId].font, \'background-color\': vm.shiftIdToColorMap[roster.shiftId].background}" ng-if="!roster.isOffday"><div>{{vm.shiftIdToInitialMap[roster.shiftId]}}</div><div><a href="javascript:void(0)" ng-click="vm.openCellChangeModal(sg.id, month.monthNumber, roster, $index)" ng-style="{\'color\': vm.shiftIdToColorMap[roster.shiftId].font}"><i class="ion-chevron-down"></i></a></div></div><div class="off-day" ng-if="roster.isOffday"><div>O</div><div><a href="javascript:void(0)" ng-click="vm.openCellChangeModal(sg.id, month.monthNumber, roster, $index)"><i class="ion-chevron-down"></i></a></div></div></td></tr></tbody></table></div><hr></div></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/shiftManagement/roster/basicView/basicView.html','<style>\n    .btn-padding{\n        padding: 8px 16px!important;\n    }\n</style><div class="row"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table even-row-strip"><colgroup><col class="width-4"><col class="width-20"><col class="width-20"><col class="width-24"><col class="width-24"><col class="width-8"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{ \'rosterSettings.tableHeader.shiftGroup\' }}</th><th class="text-left" translate="">{{ \'rosterSettings.tableHeader.currentRunningShift\' }}</th><th class="text-center" translate="">{{ \'rosterSettings.tableHeader.nextChange\' }}</th><th class="text-center" translate="">{{ \'rosterSettings.tableHeader.nextOffday\' }}</th><th class="text-center" translate="">{{ \'rosterSettings.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded" ng-repeat="item in vm.basicViewRosters"><td class="text-center">{{$index+1}}</td><td class="text-left">{{item.shiftGroupName}}</td><td class="text-left">{{vm.buildShiftInfo(item.shiftName, item.startTime, item.endTime)}}</td><td class="text-center" id="next-shift-change-{{item.shiftGroupId}}"><button type="button" class="btn btn-md btn-primary btn-padding" ng-click="vm.getNextShiftChange(item.shiftGroupId, item.shiftId)" translate="">{{\'rosterSettings.showChangeButton\'}}</button></td><td class="text-center" id="latest-offday-{{item.shiftGroupId}}"><button type="button" class="btn btn-md btn-primary btn-padding" ng-click="vm.getLatestOffday(item.shiftGroupId)" translate="">{{\'rosterSettings.showOffdayButton\'}}</button></td><td class="text-center"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditBasicModal(item,$index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button></td></tr></tbody></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/roster/modal/downloadRoster.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'rosterSettings.rosterDownload.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'profile.selectDateRange\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.modal.newEvent.date" options="vm.modal.newEvent.option"><span class="date-position-left">{{vm.modal.newEvent.date.startDate.format("D MMM YYYY")}} - {{vm.modal.newEvent.date.endDate.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.downloadEmployeeRoster()" ng-disabled="vm.isDownload"><span ng-if="!vm.isDownload">{{ \'rosterSettings.rosterDownload.download\' | translate}}</span> <span ng-if="vm.isDownload">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/shiftManagement/dynamicShiftGroups/createShiftGroup/createDynamicShiftGroup.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'dynamicShiftGroupSettings.creationModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'dynamicShiftGroupSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'dynamicShiftGroupSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.name"></div></div><br><div class="row"><div class="col-md-12"><label translate="">{{ \'dynamicShiftGroupSettings.creationModal.defaultOffDayLabel\'}}</label><div isteven-multi-select="" input-model="vm.offDayList" output-model="vm.selectedOffdays" button-label="name" item-label="name" tick-property="selected" output-properties="value" search-property="name"></div></div></div><br><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'dynamicShiftGroupSettings.creationModal.selectedShiftsLabel\'}}</label><div isteven-multi-select="" input-model="vm.shiftList" output-model="vm.selectedShiftList" button-label="name" item-label="name" tick-property="selected" output-properties="id" search-property="name"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createNewShiftGroup()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/shiftManagement/dynamicShiftGroups/deleteShiftGroup/deleteDynamicShiftGroup.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6">{{ \'dynamicShiftGroupSettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.shiftGroup.shiftGroupName}}</em>{{\'commonKeywords.questionMark\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteShiftGroup()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/dynamicShiftGroups/editShiftGroup/editShiftGroup.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'shiftGroupSettings.editModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label translate="">{{ \'shiftGroupSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" ng-model="vm.shiftGroup.shiftGroupName"></div></div><br><div class="row"><div class="col-md-12"><label translate="">{{ \'shiftGroupSettings.creationModal.defaultOffDayLabel\'}}</label><div isteven-multi-select="" input-model="vm.offDayList" output-model="vm.selectedOffdays" button-label="name" item-label="name" tick-property="selected" output-properties="value" search-property="name"></div></div></div><br><div class="row"><div class="col-md-12"><label translate="">{{ \'shiftGroupSettings.creationModal.shiftsLabel\'}}</label><div isteven-multi-select="" input-model="vm.shiftList" output-model="vm.selectedShiftList" button-label="name" item-label="name" tick-property="selected" output-properties="id" search-property="name"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateShiftGroup()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/shiftGroups/createShiftGroup/createShiftGroup.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'shiftGroupSettings.creationModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'shiftGroupSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'shiftGroupSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.name"></div></div><br><div class="row"><div class="col-md-12"><label class="required" translate="">{{ \'shiftGroupSettings.creationModal.defaultOffDayLabel\'}}</label><div isteven-multi-select="" input-model="vm.offDayList" output-model="vm.selectedOffdays" button-label="name" item-label="name" tick-property="selected" output-properties="value" search-property="name"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createNewShiftGroup()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/shiftManagement/shiftGroups/deleteShiftGroup/deleteShiftGroup.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6">{{ \'shiftGroupSettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.shiftGroup.name}}</em>{{\'commonKeywords.questionMark\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteShiftGroup()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/shiftGroups/editShiftGroup/editShiftGroup.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'shiftGroupSettings.editModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><label translate="">{{ \'shiftGroupSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" ng-model="vm.shiftGroup.name"></div></div><br><div class="row"><div class="col-md-12"><label translate="">{{ \'shiftGroupSettings.creationModal.defaultOffDayLabel\'}}</label><div isteven-multi-select="" input-model="vm.offDayList" output-model="vm.selectedOffdays" button-label="name" item-label="name" tick-property="selected" output-properties="value" search-property="name"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateShiftGroup()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/shifts/createShift/createShift.modal.html','<style>\n    .uib-time input {\n        width: 21px;\n        padding: 0;\n        height: 21px;\n        font-size: 10px;\n        font-weight: 600;\n    }\n    .uib-time > .btn-default{\n        padding: 0;\n        height: 21px;\n        width: 23px;\n        margin-left: 3px;\n        font-size: 10px;\n        font-weight: 600;\n        position: relative;\n        bottom: 1px;\n    }\n    .uib-separator{\n        font-weight:600;\n    }\n    .uib-increment > .btn-link, .uib-decrement > .btn-link{\n        padding:0;\n    }\n    .table tbody tr{\n        height: 4vh;\n    }\n</style><body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'shiftSettings.creationModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><div class="mb-15"><label class="required" translate="">{{ \'shiftSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'shiftSettings.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.name"></div></div><div class="col-md-6"><div class="mb-15"><label class="required" translate="">{{ \'shiftSettings.creationModal.initialInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{ \'shiftSettings.creationModal.initialInputPlaceholder\' | translate }}" ng-model="vm.initial" maxlength="1"></div></div></div><div class="row"><div class="col-md-12 table-container"><table class="table report-table report-table-font-14"><colgroup><col class="width-30"><col class="width-20"><col class="width-30"><col class="width-20"></colgroup><tbody><tr><td class="padding-x-0"><span class="required">{{\'shiftSettings.creationModal.startTimeInputLabel\' | translate}}</span></td><td class="text-right"><a class="mr-7" href="#" editable-bstime="vm.startTime" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.startTime | date:"hh:mm a") || \'empty\' }}</a></td><td><span class="required ml-7">{{ \'shiftSettings.creationModal.endTimeInputLabel\' | translate}}</span></td><td class="text-right padding-x-0"><a href="#" editable-bstime="vm.endTime" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.endTime | date:"hh:mm a") || \'empty\' }}</a></td></tr><tr><td class="padding-x-0"><span class="required">{{\'shiftSettings.creationModal.lateAfterInputLabel\' | translate}}</span></td><td class="text-right"><a class="mr-7" href="#" editable-bstime="vm.lateStartAfter" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.lateStartAfter | date:"hh:mm a") || \'empty\' }}</a></td><td><span class="required ml-7">{{\'shiftSettings.creationModal.earlyExitBeforeInputLabel\' | translate}}</span></td><td class="text-right padding-x-0"><a href="#" editable-bstime="vm.earlyExitBefore" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.earlyExitBefore | date:"hh:mm a") || \'empty\' }}</a></td></tr><tr><td class="padding-x-0"><span class="required">{{\'shiftSettings.creationModal.firstHalfEndsInputLabel\' | translate}}</span></td><td class="text-right"><a class="mr-7" href="#" editable-bstime="vm.halfDayEnds" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.halfDayEnds | date:"hh:mm a") || \'empty\' }}</a></td><td><span class="required ml-7">{{\'shiftSettings.creationModal.breakTimeEndsInputLabel\' | translate}}</span></td><td class="text-right padding-x-0"><a href="#" editable-bstime="vm.breakTimeEnds" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.breakTimeEnds | date:"hh:mm a") || \'empty\' }}</a></td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-6 mt-10"><span class="d-inline-block text-bold mb-3" translate="">{{\'shiftSettings.creationModal.firstHalfAbsentInputLabel\'}}</span><label class="custom-switch ml-20"><input name="enabled" ng-model="vm.firstHalfAbsentEnabled" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">{{ vm.firstHalfAbsentEnabled ? \'commonKeywords.statusActive\' : \'commonKeywords.statusInactive\' }}</strong></span></div><div class="col-md-6"><input ng-if="vm.pickColor" colorpicker="" colorpicker-position="right" colorpicker-with-input="true" colorpicker-close-on-selectng-model="vm.color" class="form-control" ng-model="vm.color" type="text" ng-style="{background:vm.color}"></div></div><div class="row mt-20"><div class="col-md-12"><span ng-if="!vm.pickColor"><i class="cancel-hover"><span translate="">{{\'shiftSettings.creationModal.shiftInfoText\'}}</span> <span class="redText" translate="">{{\'shiftSettings.creationModal.shiftColor\'}}</span><span translate="">{{\'shiftSettings.creationModal.colorChangeInfoText\'}}</span> <a href="" ng-click="vm.pickColor=true" translate="">{{\'shiftSettings.creationModal.colorChangeInfoLink\'}}</a></i></span></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createNewShift()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/shiftManagement/shifts/deleteShift/deleteShift.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6">{{ \'shiftSettings.deleteModal.confirmationText\' | translate }} <em class="color-22222 font-weight-400">{{vm.shift.name}}</em>{{\'commonKeywords.questionMark\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteShift()" ng-disabled="vm.isDeleting"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/shifts/editShift/editShift.modal.html','<style>\n    .uib-time input {\n        width: 21px;\n        padding: 0;\n        height: 21px;\n        font-size: 10px;\n        font-weight: 600;\n    }\n    .uib-time > .btn-default{\n        padding: 0;\n        height: 21px;\n        width: 23px;\n        margin-left: 3px;\n        font-size: 10px;\n        font-weight: 600;\n        position: relative;\n        bottom: 1px;\n    }\n    .uib-separator{\n        font-weight:600;\n    }\n    .uib-increment > .btn-link, .uib-decrement > .btn-link{\n        padding:0;\n    }\n</style><body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'shiftSettings.editModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6 pr-5"><div class="mb-15"><label translate="">{{ \'shiftSettings.creationModal.nameInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{\'commonPlaceholderText.insertName\' | translate}}" ng-model="vm.name"></div></div><div class="col-md-6"><div class="mb-15"><label translate="">{{ \'shiftSettings.creationModal.initialInputLabel\' }}</label> <input type="text" class="form-control" placeholder="{{\'commonPlaceholderText.insertInitial\' | translate}}" maxlength="1" ng-model="vm.initial"></div></div></div><div class="row"><div class="col-md-12 table-container"><table class="table report-table report-table-font-14"><colgroup><col class="width-30"><col class="width-20"><col class="width-30"><col class="width-20"></colgroup><tbody><tr><td class="padding-x-0"><span>{{\'shiftSettings.creationModal.startTimeInputLabel\' | translate}}</span></td><td class="text-right"><a href="#" editable-bstime="vm.startTime" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.startTime | date:"hh:mm a") || \'empty\' }}</a></td><td><span class="ml-7">{{ \'shiftSettings.creationModal.endTimeInputLabel\' | translate}}</span></td><td class="text-right padding-x-0"><a href="#" editable-bstime="vm.endTime" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.endTime | date:"hh:mm a") || \'empty\' }}</a></td></tr><tr><td class="padding-x-0"><span>{{\'shiftSettings.creationModal.lateAfterInputLabel\' | translate}}</span></td><td class="text-right"><a href="#" editable-bstime="vm.lateStartAfter" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.lateStartAfter | date:"hh:mm a") || \'empty\' }}</a></td><td><span class="ml-7">{{\'shiftSettings.creationModal.earlyExitBeforeInputLabel\' | translate}}</span></td><td class="text-right padding-x-0"><a href="#" editable-bstime="vm.earlyExitBefore" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.earlyExitBefore | date:"hh:mm a") || \'empty\' }}</a></td></tr><tr><td class="padding-x-0"><span>{{\'shiftSettings.creationModal.firstHalfEndsInputLabel\' | translate}}</span></td><td class="text-right"><a href="#" editable-bstime="vm.halfDayEnds" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.halfDayEnds | date:"hh:mm a") || \'empty\' }}</a></td><td><span class="ml-7">{{\'shiftSettings.creationModal.breakTimeEndsInputLabel\' | translate}}</span></td><td class="text-right padding-x-0"><a href="#" editable-bstime="vm.breakTimeEnds" e-show-meridian="vm.isMeridian" e-hour-step="vm.hourStep" e-minute-step="vm.minStep">{{ (vm.breakTimeEnds | date:"hh:mm a") || \'empty\' }}</a></td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-6 mt-30"><span class="text-bold" translate="">{{ \'shiftSettings.creationModal.firstHalfAbsentInputLabel\' }}</span><label class="custom-switch ml-20"><input id="enabled" name="enabled" ng-model="vm.firstHalfAbsentEnabled" type="checkbox"><span class="slider round"></span></label> <span class="ml-20 text-bold" translate="">{{ vm.firstHalfAbsentEnabled ? \'commonKeywords.statusActive\' : \'commonKeywords.statusInactive\' }}</span></div><div class="col-md-6"><label translate="">{{ \'shiftSettings.editModal.colourInputLabel\' }}</label> <input colorpicker="" colorpicker-position="right" colorpicker-with-input="true" colorpicker-close-on-selectng-model="vm.color" class="form-control" ng-model="vm.color" type="text" ng-style="{background:vm.color}"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateShift()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></body>');
$templateCache.put('app/pages/main/siteManagement/manageSites/create/createSites.html','<style>\n    .dark-bg{\n        background: #fcfcfc;\n    }\n    .height-30{\n        height: 30px;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'siteManagement.createSites\' | translate}}"><div id="create-site" class="dark-bg"><div class="width-95 m-0-auto"><div class="row"><div class="col-md-12 mt-20"><label class="required" translate="">{{\'siteManagement.siteName\' | translate}}</label> <input type="text" placeholder="Name" class="form-control" ng-model="vm.siteName"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{\'siteManagement.siteAddress\' | translate}}</label> <input type="text" placeholder="Site Address" class="form-control" ng-model="vm.siteAddress"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">latitude</label> <input type="number" placeholder="Latitude" class="form-control" ng-model="vm.siteLatitude"></div><div class="col-md-6"><label class="required" translate="">longitude</label> <input type="number" placeholder="Longitude" class="form-control" ng-model="vm.siteLongitude"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{\'siteManagement.assignSiteManager\' | translate}}</label><div class="form-group"><div isteven-multi-select="" input-model="vm.siteManagerList" output-model="vm.selectedSiteManager" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single"></div></div></div></div><div class="row mt-300"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="siteManagement.manageSites" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.createNewSite()"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createSiteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div><div class="row height-30"></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/manageSites/delete/deleteSite.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">Do you want to delete this site <span class="color-22222 font-weight-500">{{vm.siteInfo.name}}</span>?</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteSite()"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/manageSites/viewSites/viewSites.html','<style>\n    .dark-bg{\n        background: #fcfcfc;\n    }\n    .height-30{\n        height: 30px;\n    }\n</style><div ba-panel="" ba-panel-title="{{\'siteManagement.viewSites\' | translate}}"><div class="row"><div class="col-md-6"><div id="view-site" class="dark-bg" ng-if="!vm.isEditable"><div class="width-95 m-0-auto"><div class="row"><div class="col-md-12 mt-20"><label class="required" translate="">{{\'siteManagement.siteName\' | translate}}</label> <input type="text" placeholder="Name" class="form-control prevent-clicks" ng-model="vm.siteInfo.name"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{\'siteManagement.siteAddress\' | translate}}</label> <input type="text" placeholder="Site Address" class="form-control prevent-clicks" ng-model="vm.siteInfo.location"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">latitude</label> <input type="number" placeholder="Latitude" class="form-control prevent-clicks" ng-model="vm.siteInfo.latitude"></div><div class="col-md-6"><label class="required" translate="">longitude</label> <input type="number" placeholder="Longitude" class="form-control prevent-clicks" ng-model="vm.siteInfo.longitude"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">siteManager</label> <input type="text" placeholder="Site Manager" class="form-control prevent-clicks" ng-model="vm.siteInfo.managerName"></div></div><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="row mt-300"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="siteManagement.manageSites" translate="">{{ \'commonKeywords.backButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.makeEditable()" translate="">{{ \'commonKeywords.editSiteButton\' }}</button></div></div></div><div class="row height-30"></div></div></div><div class="dark-bg" ng-if="vm.isEditable"><div class="width-95 m-0-auto"><div class="row"><div class="col-md-12 mt-20"><label class="required" translate="">{{\'siteManagement.siteName\' | translate}}</label> <input type="text" placeholder="Name" class="form-control" ng-model="vm.siteInfo.name"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{\'siteManagement.siteAddress\' | translate}}</label> <input type="text" placeholder="Site Address" class="form-control" ng-model="vm.siteInfo.location"></div></div><div class="row mt-15"><div class="col-md-6"><label class="required" translate="">latitude</label> <input type="number" placeholder="Latitude" class="form-control" ng-model="vm.siteInfo.latitude"></div><div class="col-md-6"><label class="required" translate="">longitude</label> <input type="number" placeholder="Longitude" class="form-control" ng-model="vm.siteInfo.longitude"></div></div><div class="row mt-15"><div class="col-md-12"><label class="required" translate="">{{\'siteManagement.assignSiteManager\' | translate}}</label><div class="form-group" ng-if="vm.isDataLoaded"><div isteven-multi-select="" input-model="vm.siteManagerList" output-model="vm.selectedSiteManager" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single"></div></div></div></div><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="row mt-300"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.makeEditable()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.updateSite()"><span ng-if="!vm.isCreating">{{ \'commonKeywords.saveButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div><div class="row height-30"></div></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12"><table class="table borderless-table odd-row-strip table-header"><thead><tr><th class="text-left font-weight-500" translate="">employeeName</th></tr></thead><tbody><tr ng-if="vm.isDataLoaded && vm.siteEmployeeList.length > 0" ng-repeat="employee in vm.siteEmployeeList"><td class="text-left"><employee-picture-and-information name="employee.name" picture-url="employee.pictureUrl == (null || \'Not Set\') ? null : employee.pictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.id" is-clickable="false"></employee-picture-and-information></td></tr></tbody></table><div class="mt-15" ng-if="vm.isDataLoaded && vm.siteEmployeeList.length > 0"><span class="color-22222 font-weight-500">* Total {{vm.siteEmployeeList.length}} Employee Selected</span></div><div class="text-center mt-5" ng-if="vm.isDataLoaded && vm.siteEmployeeList.length === 0"><i>No Selected Employees Found in the Site</i></div><div ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementReports/siteAttendanceReport/siteAttendanceReport.html','<style>\n    .site-attendance-report input::placeholder{\n        font-size: 13px;\n    }\n    .site-attendance-report #employeeNameSearchBox {\n        width: 290px!important;\n    }\n    .site-attendance-report #presentAbsent .custom-select{\n        width: 100%!important;\n    }\n</style><div class="row site-attendance-report"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'site report of \' + vm.date|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" subtract="vm.subtract" type="daily" hide-download="true" config="vm.filterConfig"></report-filter></div><div><div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">totalEmployees</td><td class="col-stripe-dark text-center">{{vm.total}}</td><td translate="">totalAbsent</td><td class="col-stripe-dark text-center">{{vm.totalAbsent}}</td><td translate="">totalPresent</td><td class="col-stripe-dark text-center">{{vm.totalPresent}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3" ng-if="vm.employeeList.length != 0 && vm.isDataLoaded"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-center" rowspan="2" translate="">employeeType</th><th class="text-center" rowspan="2" translate="">shift</th><th class="text-left" rowspan="2" translate="">siteName</th><th class="text-center" rowspan="2" translate="">entry</th><th class="text-center" rowspan="2" translate="">exit</th><th class="text-left" rowspan="2" translate="">siteManager</th></tr><tbody><tr ng-repeat="employee in vm.employeeList" ng-show="vm.isDataLoaded"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl == (null || \'Not Set\') ? null : employee.profilePictureUrl" department-name="employee.employeeDepartmentName" designation-name="employee.employeeDesignationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center">{{employee.employmentTypeName}}</td><td class="text-center">{{employee.shiftName}}</td><td class="text-left"><img class="cursor-pointer" ng-click="vm.openLocationMap($index, employee)" src="../assets/img/location.png"> <span>{{employee.siteName}}</span></td><td class="text-center"><img class="cursor-pointer" ng-if="employee.siteInPictureUrl" ng-click="vm.openEntryExitImage($index, employee,\'entry\')" src="../assets/img/Image.png"> <span>{{employee.entryTime}}</span></td><td class="text-center"><img class="cursor-pointer" ng-if="employee.siteOutPictureUrl" ng-click="vm.openEntryExitImage($index, employee,\'exit\')" src="../assets/img/Image.png"> <span>{{employee.exitTime}}</span></td><td class="text-left"><span ng-if="employee.manager.name == \'Not Set\'">{{employee.manager.name}}</span><employee-picture-and-information name="employee.manager.name" picture-url="employee.manager.pictureUrl == (null || \'Not Set\') ? null : employee.manager.pictureUrl" department-name="employee.manager.departmentName" designation-name="employee.manager.designationName" id="employee.manager.id" is-clickable="true"></employee-picture-and-information></td></tr></tbody></thead></table></div></div></div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="text-center mt-10" ng-show="vm.employeeList.length === 0 && vm.isDataLoaded"><p class="text-center mt-60"><strong translate="">noDataFound</strong></p></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search" hide-no-data-message="true"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementReports/siteSummaryReport/siteSummaryReport.html','<style>\n    .search-width{\n        width: 250px!important;\n    }\n    .min-width-170{\n        min-width: 170px;\n    }\n    .min-width-100{\n        min-width: 100px;\n    }\n    .width-140{\n        width: 140px;\n    }\n    #employeeNameSearchBox2 input::placeholder{\n        font-size: 13px;\n    }\n    .site-summary-report .table > thead > tr > th:last-child, .site-summary-report .table > tbody > tr > td:last-child {\n        padding-right: 5px;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'All Site Report of \' + vm.date|translate}}"><div class="d-flex-space-between flex-wrap"><div class="d-flex-gap-10 align-items-center"><div class="d-inline-block" id="employeeNameSearchBox2"><div class="has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input class="form-control search-width" type="text" placeholder="Search Site by Name/Address" ng-model="vm.searchKeyword" ng-keyup="$event.keyCode === 13 && vm.getSiteByNameOrAddress()"></div></div><div class="filter-inline-item width-18 min-width-170"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-pointer d-block" ng-model="vm.singleDatePicker.date" options="vm.singleDatePicker.options" min="vm.minDate" max="vm.maxDateForDailyReport"><span class="date-position-left">{{vm.singleDatePicker.date.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="d-flex-space-between"><label class="min-width-100 font-weight-600" for="rowsPerPageSelection" translate="">rowsPerPage</label><div class="custom-select width-140"><select ng-model="vm.selectedRowsPerPage" ng-change="vm.handleRowPerPageSelection()" id="rowsPerPageSelection" ng-options="d.value for d in vm.rowsPerPageOption"></select></div></div></div><div class="d-flex-gap-10 margin-at-page-break"><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsPdf()"><img class="img-resize" src="../assets/img/PDF.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.exportAsPdfButton\'}}</span></button></div></div></div><div><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><tbody><tr class="text-bold"><td translate="">totalSites</td><td class="text-center col-stripe-dark">{{vm.allSitesSummaryReportData.totalSite}}</td><td translate="">present</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalPresent}}</td><td translate="">leave</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalLeave}}</td><td translate="">late</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalLate}}</td></tr><tr class="text-bold"><td translate="">totalEmployee</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalEmployee}}</td><td translate="">absent</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalAbsent}}</td><td translate="">onTime</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalOnTime}}</td><td translate="">earlyExit</td><td class="col-stripe-dark text-center">{{vm.allSitesSummaryReportData.totalEarlyExit}}</td></tr></tbody></table></div></div><div class="mt-15 site-summary-report horizontal-scroll scrollable-table report-container" fixed-column-table="" fixed-columns="0" ng-if="vm.siteSummaryList.length !=0 && vm.isDataLoaded"><table class="table borderless-table even-row-strip"><thead><tr><th class="text-center" translate="">sl</th><th class="text-left width-15" translate="">siteName</th><th class="text-left width-17" translate="">address</th><th class="text-center" translate="">totalEmployee</th><th class="text-center" translate="">present</th><th class="text-center" translate="">absent</th><th class="text-center" translate="">leave</th><th class="text-center" translate="">onTime</th><th class="text-center" translate="">late</th><th class="text-center" translate="">earlyExit</th><th class="text-left width-20" translate="">siteManager</th></tr><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="site in vm.siteSummaryList"><td class="text-center">{{(vm.rowsPerPage * vm.selectedPage) + $index + 1 }}</td><td class="text-left"><img class="cursor-pointer" ng-click="vm.openLocationMap($index, site)" src="../assets/img/location.png"> <span>{{site.name}}</span></td><td class="text-left">{{site.location}}</td><td class="text-center">{{site.totalEmployee}}</td><td class="text-center">{{site.present}}</td><td class="text-center">{{site.absent}}</td><td class="text-center">{{site.leave}}</td><td class="text-center">{{site.onTime}}</td><td class="text-center">{{site.late}}</td><td class="text-center">{{site.earlyExit}}</td><td class="text-left"><employee-picture-and-information name="site.managerName" picture-url="site.managerPictureUrl == (null || \'Not Set\') ? null: site.managerPictureUrl" department-name="site.managerDepartmentName" designation-name="site.managerDesignationName" id="site.managerId" is-clickable="false"></employee-picture-and-information></td></tr></tbody></thead></table></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getSiteSummaryInfo"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/appointmentLog/appointmentLogModal/appointmentCancelModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_3"><span translate="">{{\'Do you want to cancel this appointment\'}}</span> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.cancelAppointment(vm.appointmentToCancel)" translate="">{{\'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/createAppointment/modals/capturePhoto.modal.html','<div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div class="col-md-12"><div class="text-center"><h2 class="color-secondary" translate="">{{ \'visitorManagement.createAppointment.capturePhotoModal.header\' }}</h2><div class="row text-center" ng-if="vm.showCamera"><webcam channel="vm.channel" on-streaming="vm.onWebcamSuccess()" on-error="vm.onWebcamError(err)" on-stream="vm.onStream(stream)"></webcam></div><div class="row text-center mt-5" ng-if="vm.showCamera"><button class="btn btn-primary btn-sm" ng-click="vm.makeSnapshot()" translate="">{{ \'visitorManagement.createAppointment.capturePhotoModal.takePictureButton\' }}</button></div><div class="row text-center mt-5" ng-if="vm.showCamera"><canvas id="snapshot" class="d-none"></canvas></div><div ng-if="!vm.showUploadedImage"><ng-croppie ng-if="vm.showCamera && !!inputImage" src="inputImage" ng-model="vm.imgDataUrl" boundry="{w: 400, h: 225}" viewport="{w: 200, h: 200}" orientation="true" rotation="90" type="square"></ng-croppie></div></div></div><div class="col-md-12 text-center" ng-if="!vm.showCamera"><i translate="">{{ \'visitorManagement.createAppointment.capturePhotoModal.cameraUnavailableText\' }}</i></div><div class="col-md-12 text-center mt-10"><p>- or -</p></div><div class="col-md-12 text-center mt-5" ng-if="vm.showUploadedImage"><ng-croppie src="inputImage" ng-model="vm.imgDataUrl" boundry="{w: 400, h: 225}" viewport="{w: 200, h: 200}" orientation="true" rotation="90" type="square"></ng-croppie></div><div class="col-md-12 text-center"><button ngf-select="" ng-model="vm.imgFile" accept="image/*" type="button" class="btn btn-md border-btn" ngf-change="vm.fileSelected($file)" translate="">{{ \'visitorManagement.createAppointment.capturePhotoModal.fileUploadButton\' }}</button></div></div><div class="footer"><button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/myVisitorProfile/modals/blockVisitorModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_3"><span translate="">{{\'Do you want to block this visitor\'}}</span> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.blockVisitor(vm.visitorToBlock)" translate="">{{\'Block\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/myVisitorProfile/modals/unBlockVisitorModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_3"><span translate="">{{\'Do you want to unblock this visitor\'}}</span> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.UnblockVisitor(vm.visitorToUnBlock)" translate="">{{\'Unblock\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/assignRole/assignRole.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="ASSIGN ROLE" ba-panel-class="with-scroll"><div class="row mb-15"><div class="col-md-12"><div class="row"><div class="col-md-4"><button type="button" class="btn btn-md btn-primary" ng-click="vm.openAssignRoleModal()"><span class="pb-2">{{\'visitorManagement.assignRole.assignButton\' | translate }}</span></button></div><div class="col-md-4 col-md-offset-4"><div class="input-group"><input type="text" class="form-control" placeholder="Search ..." ng-model="vm.searchText"> <span class="input-group-addon addon-right"><i class="ion-android-search"></i></span></div></div></div><div class="row"><div ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0" ng-if="vm.isDataLoaded"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="" translate="">{{\'visitorManagement.assignRole.tableHeader.employeeName\'}}</th><th class="text-left" translate="">{{\'visitorManagement.assignRole.tableHeader.role\'}}</th><th class="text-center width-13" translate="">{{\'visitorManagement.assignRole.tableHeader.actions\'}}</th></tr></thead><tbody><tr ng-repeat="role in vm.employeeRoleList | filter:{\'code\':vm.searchText}" class=""><td class="text-center">{{$index + 1}}</td><td class=""><employee-picture-and-information name="role.name" picture-url="role.pictureUrl" department-name="role.departmentName" designation-name="!role.designationName ? \'N/A\':role.designationName" id="role.id" is-clickable="false"></employee-picture-and-information></td><td class="text-left" translate="">{{role.roleList.join(", ")}}</td><td class="text-center"><div class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModalRoleModal(role, $index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteRoleModal(role, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></div></td></tr></tbody><tbody ng-if="vm.employeeRoleList == null || vm.employeeRoleList.length === 0"><tr><td class="text-center" colspan="5"><em translate="">{{\'visitorManagement.visitorCard.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/manageCard/manageCard.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Card" ba-panel-class="with-scroll"><div class="row mb-15"><div class="col-md-12"><div class="row"><div class="col-md-8"><button type="button" class="btn btn-md-with-icon btn-primary padding-9-12" ng-click="vm.openCreateModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'visitorManagement.visitorCard.createButton\' | translate }}</span></button> <button type="button" class="btn btn-md-with-icon btn-secondary padding-5-10" ng-click="vm.downloadSampleExcelFile()"><img src="../assets/img/download_white.png"> <span class="ml-negative-5" translate="">{{\'visitorManagement.visitorCard.downloadButton\'}}</span></button> <button class="btn btn-md-with-icon btn-secondary padding-5-10" ngf-select="vm.verifySelectedExcelFile($file)" ng-model="vm.file" ngf-multiple="false" ngf-accept="\'.xls,.xlsx\'"><img src="../assets/img/Upload.png"> <span class="ml-negative-5" translate="">{{\'visitorManagement.visitorCard.uploadButton\'}}</span></button></div><div class="col-md-4"><div class="input-group"><input type="text" class="form-control" placeholder="Search ..." ng-model="vm.searchText"> <span class="input-group-addon addon-right"><i class="ion-android-search"></i></span></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center width-5" translate="">sl</th><th class="text-center" translate="">{{\'visitorManagement.visitorCard.tableHeader.shortCode\'}}</th><th class="text-center" translate="">{{\'visitorManagement.visitorCard.tableHeader.rfidNumber\'}}</th><th class="text-center" translate="">{{\'visitorManagement.visitorCard.tableHeader.status\'}}</th><th class="text-center width-13" translate="">{{\'visitorManagement.visitorCard.tableHeader.actions\'}}</th></tr></thead><tbody ng-if="vm.visitorCards.length > 0"><tr ng-repeat="card in vm.visitorCards | filter:{\'code\':vm.searchText}" class=""><td class="text-center">{{$index + 1}}</td><td class="text-center">{{card.code}}</td><td class="text-center">{{card.rfid}}</td><td class="text-center" ng-if="card.status === 1" translate="">{{\'commonKeywords.statusActive\'}}</td><td class="text-center" ng-if="card.status === 0" translate="">{{\'commonKeywords.statusInactive\'}}</td><td class="text-center"><div class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openEditModal(card, $index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteModal(card, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></div></td></tr></tbody><tbody ng-if="vm.visitorCards == null || vm.visitorCards.length === 0"><tr><td class="text-center" colspan="5"><em translate="">{{\'visitorManagement.visitorCard.emptyTableBody\'}}</em></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurpose.html','<div ba-panel="" ba-panel-title="{{ \'visitorManagement.visitPurpose.title\' | translate }}" ba-panel-class="with-scroll"><div ng-controller="VisitPurposeCtrl as vm"><div class="row d-flex-flex-start"><div class="col-md-3"><upgrade-button code="6004"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateVisitPurposeModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'visitorManagement.visitPurpose.createButton\' | translate }}</span></button></upgrade-button></div></div><div ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12 mb-20"><div class="horizontal-scroll scrollable-table mt-20" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><colgroup><col class="width-5"><col class="width-85"><col class="width-10"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="" translate="">{{ \'visitorManagement.visitPurpose.tableHeader.visitPurposes\' }}</th><th class="text-center width-15" translate="">{{ \'visitorManagement.visitPurpose.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-repeat="visitPurpose in vm.visitPurposeList" class=""><td class="text-center">{{$index+1}}</td><td class="">{{visitPurpose.text}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openUpdateVisitPurposeModal(visitPurpose, $index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteVisitPurposeModal(visitPurpose, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategory.html','<div ba-panel="" ba-panel-title="{{ \'visitorManagement.visitorCategory.tableHeader.visitorCategories\' | translate }}" ba-panel-class="with-scroll"><div ng-controller="VisitorCategoryCtrl as vm"><div class="row d-flex-flex-start"><div class="col-md-3"><upgrade-button code="6004"><button type="button" class="btn btn-md-with-icon btn-primary" ng-click="vm.openCreateVisitorCategoryModal()"><i class="ion-android-checkmark-circle"></i><span class="pb-2">{{\'visitorManagement.visitorCategory.createButton\' | translate }}</span></button></upgrade-button></div></div><div class="row mb-20"><div ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="col-md-12"><div class="horizontal-scroll scrollable-table mt-10" fixed-column-table="" fixed-columns="0" ng-if="vm.isDataLoaded"><table class="table borderless-table odd-row-strip"><colgroup><col class="width-5"><col class="width-85"><col class="width-10"></colgroup><thead><tr><th class="text-center" translate="">{{\'commonKeywords.sl\'}}</th><th class="" translate="">{{ \'visitorManagement.visitorCategory.tableHeader.visitorCategories\' }}</th><th class="text-center width-15" translate="">{{ \'visitorManagement.visitorCategory.tableHeader.actions\' }}</th></tr></thead><tbody><tr ng-repeat="visitorCategory in vm.visitorCategoryList" class=""><td class="text-center">{{$index+1}}</td><td class="">{{visitorCategory.name}}</td><td class="d-flex-center-gap-10"><button class="btn btn-sm-with-icon btn-secondary" ng-click="vm.openUpdateVisitorCategoryModal(visitorCategory, $index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.editButton\' }}</span></button> <button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openDeleteVisitorCategoryModal(visitorCategory, $index)"><i class="ion-android-delete"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'commonKeywords.deleteButton\' }}</span></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/absentReport/dailyAbsentReport/dailyAbsentReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'daily Absent Report of \' + vm.date|translate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" type="daily" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div ng-if="vm.allAbsentData ==null || vm.allAbsentData.length <=0"><p class="text-center mt-60"><strong translate="">{{\'noAttendanceFound\'}}</strong></p></div><div ng-if="vm.allAbsentData.length > 0"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><colgroup><col class="width-22"><col class="width-11"><col class="width-22"><col class="width-11"><col class="width-23"><col class="width-11"></colgroup><tbody><tr class="text-bold"><td translate="">totalEmployees</td><td class="col-stripe-dark text-center">{{vm.totalEmployee}}</td><td translate="">totalAbsent</td><td class="col-stripe-dark text-center">{{vm.totalAbsent}}</td><td translate="">totalWorkingHourLoss</td><td class="col-stripe-dark text-center">{{vm.totalLossHour}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">employeeName</th><th class="text-center" translate="" ng-if="vm.isNotSubsidiaryAdmin">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-left" rowspan="2" translate="">workplace</th><th class="text-center" rowspan="2" translate="">employeeType</th><th class="text-center" rowspan="2" translate="">shift</th><th class="text-center" rowspan="2" translate="">lastAbsent</th><th class="text-center" rowspan="2" translate="">last30dayAbsent</th><th class="text-left" rowspan="2" translate="">lineManager</th></tr><tbody><tr ng-repeat="employee in vm.allAbsentData track by employee.employeeId"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="!employee.subsidiaryName ? \'color-999999\':\'text-center\'" ng-if="vm.isNotSubsidiaryAdmin">{{employee.subsidiaryName ? employee.subsidiaryName : "Not Set" }}</td><td class="text-left" ng-class="employee.workplaceName ==\'Not Set\'?\'color-999999\':\'text-left\'">{{employee.workplaceName}}</td><td class="text-center" ng-class="employee.employmentTypeName ==\'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-center">{{employee.shiftName}}<br>{{employee.shiftStartTime}} - {{employee.shiftEndTime}}</td><td class="text-center">{{employee.lastAbsent | date :\'DD-MMM-YYYY\'}}</td><td class="text-center">{{employee.absentInLast30day}}</td><td class="text-left"><span ng-if="employee.lineManager.name == \'Not Set\'" ng-class="employee.lineManager.name ==\'Not Set\'?\'color-999999\':\'text-left\'">{{employee.lineManager.name}}</span><employee-picture-and-information ng-if="employee.lineManager.name != \'Not Set\'" name="employee.lineManager.name" picture-url="employee.lineManager.profilePicUrl" department-name="employee.lineManager.departmentName" designation-name="employee.lineManager. designationName" id="employee.lineManager.id"></employee-picture-and-information></td></tr></tbody></thead></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/absentReport/monthlyAbsentReport/monthlyAbsentReport.html','<div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Absent Summary Report from \' + vm.startDate + \' to \' + vm.endDate}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>"><div><report-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" vertical-pdf-url="vm.verticalPdfUrl" timesheet-approval-status-html="vm.timesheetApprovalStatusHtml" timesheet-application-id="vm.timesheetApplicationId" show-timesheet-approval-button="vm.showTimesheetApprovalButton" config="vm.filterConfig"></report-filter></div><div ng-if="vm.isDataLoaded"><div ng-if="vm.allAbsentData.length > 0"><div class="row mt-10"><div class="col-md-12"><table class="table overall-summary"><colgroup><col class="width-17"><col class="width-16"><col class="width-17"><col class="width-16"><col class="width-18"><col class="width-16"></colgroup><tbody><tr class="text-bold"><td translate="">totalEmployees</td><td class="col-stripe-dark text-center">{{vm.totalEmployee}}</td><td translate="">totalAbsentDays</td><td class="col-stripe-dark text-center">{{vm.totalAbsentDay}}</td><td><span translate="">totalWorkingHourLoss</span></td><td class="col-stripe-dark text-center">{{vm.totalWorkingHourLoss}}</td></tr></tbody></table></div></div><div class="horizontal-scroll report-container width-100 mt-20" fixed-column-table="" fixed-columns="3"><table class="table report-table report-table-font-14"><thead><tr><th class="text-center" rowspan="2" translate="">sl</th><th class="text-center" rowspan="2" translate="">id</th><th class="text-left" rowspan="2" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="text-center" translate="" ng-if="vm.subsidiaryView">{{\'manageAllEmployees.filter.subsidiary\'}}</th><th class="text-center" rowspan="2" translate="">{{\'commonKeywords.employmentType\'}}</th><th class="text-center" rowspan="2" translate="">shift</th><th class="text-center" rowspan="2" translate="">days</th><th class="text-center" rowspan="2" translate="">dates</th><th class="text-left" rowspan="2" translate="">lineManager</th></tr><tbody><tr ng-repeat="employee in vm.allAbsentData track by employee.employeeId"><td class="text-center">{{(vm.getRowsPerPage() * vm.selectedPage) + $index + 1 }}</td><td class="text-center">{{employee.employeeOfficeId == null ? "" : employee.employeeOfficeId}}</td><td class="text-left"><employee-picture-and-information name="employee.employeeName" picture-url="employee.profilePictureUrl" department-name="employee.departmentName" designation-name="employee.designationName" id="employee.employeeId" is-clickable="true"></employee-picture-and-information></td><td class="text-center" ng-class="!employee.subsidiaryName ? \'color-999999\':\'text-center\'" ng-if="vm.subsidiaryView">{{employee.subsidiaryName ? employee.subsidiaryName : "Not Set" }}</td><td class="text-center" ng-class="employee.employmentTypeName === \'Not Set\'?\'color-999999\':\'text-center\'">{{employee.employmentTypeName}}</td><td class="text-center"><span ng-repeat="absentDate in employee.absentDates">{{absentDate.shift}} ({{absentDate.shiftStartTime}} - {{absentDate.shiftEndTime}})<br></span></td><td class="text-center">{{employee.absentInMonth}}</td><td class="text-center"><span ng-repeat="absentDate in employee.absentDates">{{absentDate.date}}<br></span></td><td class="text-left"><span ng-if="employee.lineManager.name == \'Not Set\'" class="color-999999">{{employee.lineManager.name}}</span><employee-picture-and-information ng-if="employee.lineManager.name != \'Not Set\'" name="employee.lineManager.name" picture-url="employee.lineManager.profilePicUrl" department-name="employee.lineManager.departmentName" designation-name="employee.lineManager. designationName" id="employee.lineManager.id"></employee-picture-and-information></td></tr></tbody></thead></table></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.totalEmployee" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/individualSalaryComparison/partials/employeesTable.html','');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/employeesTable.html','<style>\n    .edited{\n        border-radius:10px;\n        color:#222222;\n        font-weight: 500;\n        border:1px solid #DF871C;\n        float: right\n    }\n    .section-padding{\n        padding-top: 5%;\n    }\n    .process-btn{\n        font-size: 12px;\n        margin-right: 0px;\n        padding: 1px 6px;\n    }\n    .flex-0-1-100{\n        flex: 0 1 100%;\n    }\n    .flex-0-1-auto{\n        flex: 0 1 auto;\n    }\n    .border-bottom-1{\n        border-bottom: 1px solid #dfdfdf!important;\n    }\n</style><div class="col-md-12 mt-25" fixed-column-table="" fixed-columns="0"><table id="column-height" class="table borderless-table even-row-strip row-highlight"><thead><tr class="dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'id\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'employeeName\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'totalSalary\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'totalDeduction\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'netPayment\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.employeeInfo" class="cursor-pointer" ng-class="{\'is-selected\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}" ng-click="vm.showComparisonDetailsInTheRightColumn($index)" style="{{data.isEdited ? \'background-color:#E1ECEA\':\'\'}}"><td class="text-center">{{$index + 1}}</td><td class="text-center">{{data.employee.employeeOfficeId}}</td><td class="dont-wrap-text"><div class="d-flex-space-between"><div class="flex-0-1-100"><employee-picture-and-information name="data.employee.name" picture-url="data.employee.pictureUrl" department-name="data.employee.departmentName" designation-name="data.employee.designationName" is-clickable="false"></employee-picture-and-information></div><div class="section-padding flex-0-1-auto" ng-if="data.isEdited"><span class="label label-primary label-style edited" translate="">{{\'viewOrGenerateSalary.edited\'}}</span></div></div></td><td class="dont-wrap-text text-right">{{data.totalSalary | number:0}}</td><td class="dont-wrap-text text-right">{{data.totalDeduction | number:0}}</td><td class="dont-wrap-text text-right">{{data.netPayableSalary | number:0}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/allocated/deviceAllocations.html','<div ng-controller="DeviceAllocationsCtrl as vm"><div class="row"><div class="form-group col-sm-12 text-right" style="margin-bottom: -20px;"><span ng-click="vm.showFilters = !vm.showFilters" class="filter pull-right" style="margin-top: -44px; color: white; cursor: pointer;">FILTER<i class="fa fa-filter" style="width:15px;"></i>&nbsp; <i ng-if="!vm.showFilters" class="fa fa-chevron-down"></i> <i ng-if="vm.showFilters" class="fa fa-chevron-up"></i></span></div></div><div class="row filter-div" ng-if="vm.showFilters" style="margin-top: -15px;"><div class="form-group col-sm-4 col-xs-4"><h4>Name</h4><input class="form-control" type="text" placeholder="Name..." ng-model="vm.name" ng-keyup="$event.keyCode == 13 ? vm.searchAllocations() : null" ng-change="vm.searchAllocations()"></div><div class="form-group col-sm-4 col-xs-4"><h4>Department</h4><input class="form-control" type="text" placeholder="Department..." ng-model="vm.department" ng-keyup="$event.keyCode == 13 ? vm.searchAllocations() : null" ng-change="vm.searchAllocations()"></div></div><div class="text-center" ng-show="!vm.isDataLoaded" style="margin-bottom: 10px"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-show="vm.isDataLoaded"><div class="row" style="margin-top: 20px" ng-if="vm.allocations.length > 0"><div class="col-md-3" style="margin-left:10px"><button class="btn btn-danger btn-block" ng-click="vm.openDeleteModal()">Revoke</button></div></div><br><br><table class="table table-striped" ng-show="vm.allocations.length > 0"><thead><th><input type="checkbox" ng-click="vm.checkOrUncheckAll()"></th><th>ID</th><th>Name</th><th>Department</th><th>RFID</th><th>Primary Text</th><th>Secondary Text</th></thead><tbody><tr ng-repeat="allocation in vm.allocationsToShow"><td><input type="checkbox" ng-model="allocation.isSelected"></td><td>{{$index+1}}</td><td><a ui-sref="profile({employeeId : {{allocation.id}}})">{{allocation.name}}</a></td><td>{{allocation.departmentName}}</td><td>{{allocation.rfid}}</td><td>{{allocation.primary_display_text}}</td><td>{{allocation.secondary_display_text}}</td></tr></tbody></table><div class="text-center" ng-show="vm.allocations.length == 0"><p><em>No allocations in this device!</em></p></div></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/root/allocationsRoot.html','<style>\n    .row-adjust{\n      line-height: 20px !important;\n    }\n    .label-style{\n        background:none;\n        border-radius:4px;\n        font-size: 12px\n    }\n    .table > thead > tr > th:last-child{\n        padding-right: 5px !important;\n    }\n    .table > tbody > tr > td:last-child{\n        padding-right: 5px !important;\n    }\n    .table > thead > tr > th a{\n       color:#209e91!important\n    }\n</style><div ba-panel="" ba-panel-title="{{vm.device.location}}({{vm.device.identifier}})"><div class="row"><div class="col-md-7"><div class="row mb-10"><div class="col-md-8"><div class="input-group"><input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.searchByNameOrId()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"> <span class="input-group-addon addon-right cursor-pointer" ng-click="vm.searchByNameOrId()"><i class="ion-android-search"></i></span></div></div><div class="col-md-4"><button class="btn btn-md btn-danger pull-right" ng-if="vm.selectedTab == \'allocated\'" ng-click="vm.revokeSelectedEmployees()" translate="">{{\'devices.revokeButton\'}}</button> <button class="btn btn-md btn-primary pull-right" ng-if="vm.selectedTab == \'unallocated\'" ng-click="vm.allocateSelectedEmployees()" translate="">{{\'devices.allocateButton\'}}</button> <button class="btn btn-md btn-danger pull-right" ng-if="vm.selectedTab == \'temporary\'" ng-click="vm.revokeOrCancelTemporaryPermissions()" translate="">{{\'devices.revokeButton\'}}</button></div></div><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\':vm.selectedTab == \'allocated\'}" ng-click="vm.changeTab(\'allocated\')" translate="">{{\'devices.allocatedButton\'}}</button> <button type="button" class="btn btn-style dont-wrap-text" ng-class="{\'selected-table-toggle-button\':vm.selectedTab == \'unallocated\'}" ng-click="vm.changeTab(\'unallocated\')" translate="">{{\'devices.unallocatedButton\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\':vm.selectedTab ==\'temporary\'}" ng-click="vm.changeTab(\'temporary\')" translate="">{{\'devices.temporaryAllocationButton\'}}</button></div></div></div><div class="row" ng-if="(vm.selectedTab == \'allocated\' || vm.selectedTab == \'unallocated\') && vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/allocatedAndUnallocatedTable.html"></div></div><div class="row" ng-if="vm.selectedTab ==\'temporary\' && vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/temporaryAllocation.html"></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><pagination-directive ng-if="vm.isDataLoaded && (vm.selectedTab == \'allocated\' || vm.selectedTab == \'unallocated\')" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getAllocatedAndUnallocatedInADevice" not-found-text="\'No allocation data available\'"></pagination-directive><pagination-directive ng-if="vm.isDataLoaded && vm.selectedTab == \'temporary\'" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" not-found-text="\'No temporary allocations available\'" search-method="vm.fetchTemporaryAllocationsData"></pagination-directive></div><div class="col-md-5 position-relative"><div ng-if="vm.isAnyRowSelected"><div class="row"><div class="col-md-12 mt-30"><p class="font-16 color-22222 font-weight-500" translate="">{{\'commonKeywords.employeeInformationHeading\'}}</p></div></div><div class="row mt-5"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><thead><tr class="dont-wrap-text th-width th-bg height-5-vh"><th class="dont-wrap-text" colspan="2"><employee-picture-and-information name="vm.selectedRowObject.name" picture-url="vm.selectedRowObject.pictureUrl" department-name="vm.selectedRowObject.departmentName" designation-name="vm.selectedRowObject.designationName" id="vm.selectedRowObject.id" is-clickable="vm.selectedRowObject.status == 1"></employee-picture-and-information></th></tr></thead><tbody><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.employeeId\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.employeeOfficeId}}</td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.employmentType\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.employmentTypeName}}</td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.shiftGroup\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.shiftGroupName}}</td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.rfid\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.rfid}}</td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.primaryText\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.primaryDisplayText}}</td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.secondaryText\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.secondaryDisplayText}}</td></tr><tr ng-if="vm.selectedRowObject.isTemporary && vm.selectedTab !== \'temporary\'" class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationStartDate\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.allocationStartDate | date:\'dd MMM yyyy (hh:mm a)\'}}</td></tr><tr ng-if="vm.selectedRowObject.isTemporary && vm.selectedTab !== \'temporary\'" class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationEndDate\'}}</td><td class="text-left dont-wrap-text row-adjust color-22222">{{vm.selectedRowObject.allocationEndDate | date:\'dd MMM yyyy (hh:mm a)\'}}</td></tr></tbody></table></div></div></div><div ng-if="vm.isAnyRowSelected && vm.selectedTab == \'temporary\'"><div class="row"><div class="col-md-12 mt-20"><h4 translate="">{{\'devices.temporaryAllocationInformationHeading\'}}</h4></div></div><div class="row mt-10"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationStartDate\'}}</td><td class="text-left dont-wrap-text row-adjust">{{vm.selectedRowObject.allocationStartDate | date:\'dd MMM yyyy (hh:mm a)\'}}</td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationEndDate\'}}</td><td class="text-left dont-wrap-text row-adjust">{{vm.selectedRowObject.allocationEndDate | date:\'dd MMM yyyy (hh:mm a)\'}}</td></tr></tbody></table></div></div></div><div ng-if="!vm.isAnyRowSelected" class="position-relative" ng-class="{\'unselected\': vm.isAnyRowSelected == false}"><div class="row mt-10"><div class="col-md-12 col-sm-12" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/temporaryAllocationInfoTable.html"></div></div></div><div class="row ng-scope" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/unAllocated/unAllocated.html','<div ng-controller="UnAllocatedCtrl as vm"><div class="row"><div class="form-group col-sm-12 text-right" style="margin-bottom: -20px;"><span ng-click="vm.showFilters = !vm.showFilters" class="filter pull-right" style="margin-top: -44px; color: white; cursor: pointer;">FILTER<i class="fa fa-filter" style="width:15px;"></i>&nbsp; <i ng-if="!vm.showFilters" class="fa fa-chevron-down"></i> <i ng-if="vm.showFilters" class="fa fa-chevron-up"></i></span></div></div><div class="row filter-div" ng-if="vm.showFilters" style="margin-top: -15px;"><div class="form-group col-sm-4 col-xs-4"><h4>Name</h4><input class="form-control" type="text" placeholder="Name..." ng-model="vm.name" ng-keyup="$event.keyCode == 13 ? vm.searchAllocations() : null" ng-change="vm.searchAllocations()"></div><div class="form-group col-sm-4 col-xs-4"><h4>Department</h4><input class="form-control" type="text" placeholder="Department..." ng-model="vm.department" ng-keyup="$event.keyCode == 13 ? vm.searchAllocations() : null" ng-change="vm.searchAllocations()"></div></div><div class="text-center" ng-show="!vm.isDataLoaded" style="margin-bottom: 10px"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-show="vm.isDataLoaded"><div class="row" style="margin-top: 20px"><div class="col-md-3" style="margin-left:10px"><button class="btn btn-primary btn-block" ng-click="vm.openAllocateModal()">Allocate</button></div></div><br><br><table class="table table-striped" ng-show="vm.unallocatedEmployees.length > 0"><thead><th><input type="checkbox" ng-click="vm.checkOrUncheckAll()"></th><th>ID</th><th>Name</th><th>Department</th><th>RFID</th><th>Primary Text</th><th>Secondary Text</th></thead><tbody><tr ng-repeat="allocation in vm.unallocatedEmployeesToShow"><td><input type="checkbox" ng-model="allocation.isSelected"></td><td>{{$index+1}}</td><td><a ui-sref="profile({employeeId : {{allocation.id}}})">{{allocation.name}}</a></td><td>{{allocation.departmentName}}</td><td>{{allocation.rfid}}</td><td>{{allocation.primary_display_text}}</td><td>{{allocation.secondary_display_text}}</td></tr></tbody></table><div class="text-center" ng-show="vm.allocations.length == 0"><p><em>No allocations in this device!</em></p></div></div></div>');
$templateCache.put('app/pages/main/leave/applyLeaveForOthers/applyLeaveForEmployees/adminLeaveApplyModal/adminLeaveApply.modal.html','<div class="modal-content"><div class="modal-body pb-15"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'profile.areYouSureHeading\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><table class="table table-bordered" style="margin-top: 1%"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center bg-prime" style="width:45px;"><td colspan="2"><div class="flex-container text-left"><div class="with-round-bg" style="margin-bottom: 0px;"><img ng-if="!!vm.employeeToShow.employeePictureUrl" ng-src="{{vm.employeeToShow.employeePictureUrl}}" style="width: 40px; margin-bottom: 0px;" alt=""> <img ng-if="!vm.employeeToShow.employeePictureUrl" ng-src="../assets/img/theme/no-photo.png" style="width: 40px; margin-bottom: 0px;" alt=""></div><div style="margin-left: 2%;"><span>{{vm.employeeToShow.name}}</span><div class="guru-overflow" style="font-size: 12px;color: darkgrey;">{{vm.employeeToShow.designation? vm.employeeToShow.designation.name : \'\' }} <span style="font-size: 12px;color: darkgrey;" ng-if="vm.employeeToShow.department != null">,&nbsp;{{vm.employeeToShow.department.name}}</span></div></div></div></td></tr><tr class="text-left"><td>Leave Policy</td><td>{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td>Employment Type</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-12 mt-20 mb-5"><h4>Leave Application Information</h4></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col style="width: 33.33%;"><col style="width: 67.66%;"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">Category</td><td class="dont-wrap-text">{{vm.leaveInfo.categoryName}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">Date Range</td><td class="dont-wrap-text">{{vm.leaveInfo.dateRange.startDate.format(\'x\') | date:\'d MMM yyyy\'}} to {{vm.leaveInfo.dateRange.endDate.format(\'x\') | date:\'d MMM yyyy\'}}<span ng-if="vm.leaveInfo.numberOfDays == 1">(<span class="greenText">1 day</span>)</span> <span ng-if="vm.leaveInfo.numberOfDays == .5">(<span class="greenText">Half day</span>)</span> <span ng-if="vm.leaveInfo.numberOfDays > 1">(<span class="greenText">{{vm.leaveInfo.numberOfDays +\' days\'}}</span>)</span></td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">Leave Type</td><td class="dont-wrap-text">{{vm.leaveInfo.leaveType == 1 ? \'Full\' : \'Half\' }}</td></tr><tr class="text-left dont-wrap-text" ng-if="vm.leaveInfo.leaveTakenAgainst != null"><td class="dont-wrap-text">Leave Taken Against</td><td class="dont-wrap-text">{{vm.leaveInfo.leaveTakenAgainst | date:\'d MMM yyyy\'}}</td></tr><tr class="text-left dont-wrap-text" ng-if="vm.leaveInfo.leaveType == 2"><td class="dont-wrap-text">Leave Half</td><td class="dont-wrap-text">{{vm.leaveInfo.selectedLeaveHalf == 1 ? \'First Half\' : \'Second Half\' }}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">Reason</td><td class="dont-wrap-text"><span>{{vm.leaveInfo.reason ? vm.leaveInfo.reason : \'N/A\'}}</span></td></tr></tbody></table></div></div><div class="row" ng-if="vm.leaveInfo.forceApproval && !vm.isConfirmBtnClicked"><div class="col-md-12 mt-10"><div style="margin-top: 1%;margin-bottom: 2%"><span><strong>This application does not require approver\u2019s approval.</strong></span></div></div></div><div class="footer"><div class="text-center" ng-if="vm.isConfirmBtnClicked"><h4><span>Please wait</span></h4><h5 style="font-size:16px"><span>Your application is being processed.</span></h5></div><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" aria-label="Close" ng-disabled="vm.isConfirmBtnClicked">Cancel</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.confirmLeaveApplication()" ng-disabled="vm.isConfirmBtnClicked">Confirm</button></div></div></div></div>');
$templateCache.put('app/pages/main/leave/applyLeaveForOthers/applyLeaveForEmployees/partial/dummyTable.html','<div class="row"><div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2"><employee-picture-and-information name="vm.employeeToShow.name" picture-url="vm.employeeToShow.employeePictureUrl" department-name="vm.selectedLeaveApplication.employeeDepartmentName" designation-name="!vm.employeeToShow.designation ? \'N/A\':vm.employeeToShow.designation.name" id="vm.employeeToShow.id" is-clickable="vm.employeeToShow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'applyLeave.leavePolicy\'}}</td><td>{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'applyLeave.employmentType\'}}</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20 mb-5"><div class="col-md-12"><h4 translate="">{{\'applyLeave.remainingLeavesHeading\'}}</h4></div></div><div class="row"><div class="col-md-12 col-sm-12"><div><div><div class="text-center" translate="">{{\'profileLeave.noLeavePolicyOrApproverAssigned\'}}</div><table class="table table-bordered"><thead><tr class="th-bg"><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.category\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.total\'}}</th><th class="text-center" translate="">{{\'applyLeave.remainingLeaveTableHeader.used\'}}</th><th class="text-center" translate="">{{\'profileLeave.remainingLeaves\'}}</th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'applyLeave.medicalLeave\'}}</td><td class="text-center"></td><td class="text-center"></td><td class="text-center"></td></tr><tr><td class="text-left" translate="">{{\'applyLeave.annualLeave\'}}</td><td class="text-center"></td><td class="text-center"></td><td class="text-center"></td></tr><tr><td class="text-left" translate="">{{\'applyLeave.casualLeave\'}}</td><td class="text-center"></td><td class="text-center"></td><td class="text-center"></td></tr></tbody></table></div></div></div></div><div class="row mt-20"><div class="col-md-12"><h4 translate="">{{\'applyLeave.lastFiveLeavesHeading\'}}</h4></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><thead><tr class="th-bg"><th class="text-left" translate="">{{\'commonKeywords.category\'}}</th><th class="text-center" translate="">{{\'commonKeywords.dateRange\'}}</th><th class="text-center" translate="">{{\'commonKeywords.numberOfDays\'}}</th><th class="text-left" translate="">{{\'commonKeywords.appliedBy\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.lastFiveLeavedata"><td class="text-left">{{data.categoryName}}</td><td class="text-center">{{data.startDate | date:\'d MMM yyyy\'}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> {{data.endDate | date:\'d MMM yyyy\'}}</td><td class="text-center">{{data.numberOfDays}}</td><td class="text-left"><employee-picture-and-information name="data.nameOfAppliedBy" picture-url="data.applierProfilePictureUrl" department-name="!data.applierDepartmentId ? \'N/A\' : data.applierDepartmentName" designation-name="!data.applierDesignationId ? \'N/A\': data.applierDesignationName" is-clickable="false"></employee-picture-and-information></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategoryPolicyConfiguration/delete/modals/deleteCategoryFromConfiguration.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'leaveCategoryPolicyConfigurations.deleteModal.title\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6">{{ \'leaveCategoryPolicyConfigurations.deleteModal.categoryDeleteConfirmationText\' | translate}} <span>{{\'commonKeywords.questionMark\' | translate}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="$close()">{{ \'commonKeywords.deleteButton\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/main/leave/leaveCategoryPolicyConfiguration/delete/modals/deleteLeaveCategoryPolicyConfiguration.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-14 line-height-1_6">{{ \'leaveCategoryPolicyConfigurations.deleteModal.confirmationText\' | translate }} <em>{{vm.policyToCategoryConfig.leavePolicyName}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span> {{ \'leaveCategoryPolicyConfigurations.deleteModal.confirmationTextExtension\' | translate }}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteAllLeavePolicyToCategoryConfigurations()"><span ng-if="!vm.isDeleting">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isDeleting">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/employees/fieldVisit/apply/partials/dummyOverlay.html','<style>\n    .main-body{\n        margin-bottom: 10%;\n        margin-top: 7%\n    }\n    .heading-section{\n        padding-right: 0px;\n        margin-top: 2%;\n        min-width: 80px\n    }\n    .section-body{\n        padding-left: 0px;\n        min-width: 80px\n    }\n\n</style><div class="modal-content dummy-modal-placement col-md-8 col-sm-6"><div class="row"><div class="col-md-12 mt-30"><h5 class="modal-title text-center color-prime" translate="">{{\'commonKeywords.dummyModalText2\'}}</h5></div></div><div ng-class="{\'blur-dummy-modal\': vm.isEmployeeSelected == false}" class="row modal-div main-body"><div class="col-md-12"><div class="row"><div class="col-md-4 col-sm-6 heading-section"><label class="form-label"><strong class="required" translate="">{{\'commonKeywords.selectEmployee\'}}</strong></label></div><div class="col-md-8 col-sm-6 prevent-clicks section-body"><div class="form-group"><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/employees/fieldVisit/apply/partials/dummyTable.html','<div class="col-md-12 col-sm-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-bg th-width"><td colspan="2"><employee-picture-and-information name="vm.employeeToShow.name" picture-url="vm.employeeToShow.pictureUrl" department-name="vm.employeeToShow.departmentName" designation-name="!vm.employeeToShow.designation ? \'N/A\':vm.employeeToShow.designationName" id="vm.employeeToShow.id" is-clickable="vm.employeeToShow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.employeeToShow.leavePolicyId ? vm.employeeToShow.leavePolicyName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.employeeToShow.employmentType.id ? vm.employeeToShow.employmentType.name : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.workplace\'}}</td><td>{{vm.employeeToShow.workplace ? vm.employeeToShow.workplace : \'Not Set\'}}</td></tr></tbody></table><div class="row mt-30"><div class="col-md-12"><h4 translate="">{{\'fieldVisit.lastFiveFieldVisitHeading\'}}</h4></div><table class="table table-bordered mt-15"><colgroup><col class="width-35"><col class="width-25"><col class="width-40"></colgroup><thead><tr class="text-left dont-wrap-text th-bg"><th class="text-lest" translate="">{{\'commonKeywords.location\'}}</th><th class="text-center" translate="">{{\'commonKeywords.dateRange\'}}</th><th class="text-center" translate="">{{\'commonKeywords.appliedBy\'}}</th></tr></thead><tbody><tr class="text-left dont-wrap-text" ng-repeat="data in vm.lastFiveFieldVisitData"><td class="dont-wrap-text">{{data.place}}</td><td class="dont-wrap-text">{{data.startDate |date:\'d MMM yyyy\'}} - {{data.endDate |date:\'d MMM yyyy\'}}</td><td class="dont-wrap-text"><employee-picture-and-information name="data.requestorName" picture-url="data.requestorProfilePicture" department-name="data.requestorDepartmentName" designation-name="data.requestorDesignationName" is-clickable="true"></employee-picture-and-information></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/employees/manage/actions/deleteEmployeeModal/deleteEmployeeModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5" translate="">{{ \'employeeActions.deleteModal.confirmationText\' }}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="employeeDeleteButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.deleteEmployees()"><span ng-if="!vm.isEmployeeDeleting" translate="">{{\'commonKeywords.confirmButton\'}}</span> <span ng-if="vm.isEmployeeDeleting" translate="">{{\'commonKeywords.pleaseWait\'}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/edit/confirmationModal/confirmation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'membershipManagement.members.doYouWantToRemoveFile\' | translate}} <em>{{vm.fileName}}</em>{{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.remove()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/edit/documentModal/openDocument.modal.html','<style>\n    .img-size{\n        width: 100%;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><span class="color-22222" translate="">{{vm.uploadedDocument.fileName}}</span> <button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><img class="img-size" src="{{vm.uploadedDocument.fileUrl}}" alt=""></div><div class="footer"><button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="$dismiss()" translate="">{{\'commonKeywords.okButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/modals/renewModal/renew.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'membershipManagement.members.doYouWantToRenewMembership\' | translate}} <em class="color-22222">{{vm.memberName.name}}</em> {{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.renewMember()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.yesButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/modals/successModal/renewalSuccessful.Modal.html','<style>\n    img{\n        height: 53px;\n        width: 53px;\n    }\n    .mt-negative-10{\n        margin-top: -10px;\n    }\n    .color-33BB7B{\n        color: #33BB7B;\n    }\n    .footer-mt{\n        margin-top: 35px!important;\n    }\n    @media (min-width: 768px) {\n        .modal-dialog {\n            width: 475px;\n        }\n    }\n    .footer-mt{\n        margin-top: 25px!important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="row"><div class="col-md-12"><div class="pull-right"><button type="button" class="close mt-negative-20" ng-click="$close()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="row"><div class="col-md-12"><div class="text-center mt-negative-10 mb-10"><img src="../assets/img/Success.png"></div><div class="text-center-important"><h1 class="font-25 text-bold color-33BB7B mb-15" translate="">success</h1><p class="font-weight-500" translate="">{{vm.memberInfo}} member renewal is successful!</p></div></div></div><div class="footer footer-mt"><button type="button" class="btn btn-md btn-secondary" ng-click="vm.successRenewal()" translate="">{{ \'commonKeywords.okButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/members/modals/upgradeSubscriptionModal/upgradeSubscriptionModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-warning" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'membershipManagement.members.doYouWantToUpgradeMember\' | translate}} <span class="color-22222 font-weight-500">{{vm.subscriptionInfo.memberName}}</span></p><table class="table table-bordered" ng-if="true"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">{{\'membershipManagement.members.package\' | translate}}: {{vm.subscriptionInfo.packageName}}</td><td class="dont-wrap-text">{{\'membershipManagement.members.duration\' | translate}}: {{vm.subscriptionInfo.duration}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">{{\'membershipManagement.members.packageAmount\' | translate}}: {{vm.subscriptionInfo.packageAmount}}</td></tr><tr class="text-left dont-wrap-text"><td class="dont-wrap-text">{{\'membershipManagement.members.packageStartDate\' | translate}}: {{vm.subscriptionInfo.packageStartDate.format(\'DD-MMM-YYYY\')}}</td><td class="dont-wrap-text">{{\'membershipManagement.members.packageEndDate\' | translate}}: {{vm.subscriptionInfo.packageEndDate.format(\'DD-MMM-YYYY\')}}</td></tr></tbody></table><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.upgradeSubscription()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'membershipManagement.members.confirmButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipDashboard/partials/ListEmployeeFeed/listEmployeeFeed.html','<style>\n\n    .mostly-present .feed-message .message-icon {\n        cursor: pointer;\n        width: 50px;\n        height: 50px;\n        float: left;\n        position: relative;\n        margin-left: inherit !important;\n    }\n\n    .mostly-present .feed-message .message-icon > img {\n        width: 50px;\n        height: 50px;\n        border-radius: 30px;\n        margin: 0 !important;\n        padding: 0 !important;\n    }\n\n</style><div class="mostly-present"><div class="feed-message animate-if border-color-light" ng-repeat="feed in vm.allEmployeeData" ui-sref="profile({employeeId: feed.employeeId, scrollTo: \'attendance\'})"><div class="d-flex-gap-10 align-items-center" ng-if="vm.isAtttendanceFeed==null || vm.isAtttendanceFeed==false"><div class="message-icon"><img class="photo-icon" ng-if="feed.profilePicUrl" ng-src="{{feed.profilePicUrl}}"> <img class="photo-icon" ng-if="feed.profilePicUrl == null || feed.profilePicUrl == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="width-full"><p class="section-header">{{feed.employeeName}}</p><span ng-show="showDays">{{feed.days}} Days</span><div ng-show="liveFeed" class="row"><div class="col-md-6"><div class="d-flex-gap-20"><img width="14px" src="assets/img/tipsoi_logo_mini.png" alt="punch-icon"><div><img width="20px" src="assets/img/clock.png" alt="clock-icon"> <span>{{feed.entryTime}}</span></div></div></div><div class="col-md-6"><div class="d-flex-flex-end">{{feed.howLong}}</div></div></div><div class="text-center mt-10" ng-show="!isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="d-flex-gap-10 align-items-center" ng-if="vm.isAtttendanceFeed!=null && vm.isAtttendanceFeed==true"><div class="message-icon"><img class="photo-icon" ng-if="feed.profilePicURL" ng-src="{{feed.profilePicURL}}"> <img class="photo-icon" ng-if="feed.profilePicURL == null || feed.profilePicURL == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="width-full"><p class="section-header">{{feed.name}}</p><span ng-show="showDays">{{feed.days}} Days</span><div ng-show="liveFeed" class="row"><div class="col-md-8"><div class="d-flex-gap-20"><img ng-if="feed.punchType === 1" height="17px" width="14px" src="assets/img/tipsoi_logo_mini.png" alt="punch-icon"> <img ng-if="feed.punchType === 2" height="17px" width="14px" src="assets/img/RFID_icon.png" alt="punch-icon"> <img ng-if="feed.punchType === 6" height="18px" width="18px" src="assets/img/face.png" alt="punch-icon"> <img ng-if="feed.punchType === 7" height="18px" width="18px" src="assets/img/face.png" alt="punch-icon"><div><img width="20px" src="assets/img/clock.png" alt="clock-icon"> <span>{{feed.displayTime}}</span></div></div></div><div class="col-md-4"><div class="d-flex-flex-end">{{feed.ago}}</div></div></div><div class="text-center mt-10" ng-show="!isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div></div>');
$templateCache.put('app/pages/main/membershipManagement/membershipDashboard/partials/pieChart/membershipDashboardPieChart.html','<style>\n    .chart {\n        height: 200px !important;\n    }\n    .chart-title {\n        font-size: 19px;\n        font-weight: 600;\n        position: absolute;\n        top: 70px;\n        text-align: center;\n        line-height: 32px;\n    }\n    .chart-title >span{\n        font-size: 30px;\n    }\n    .chart-label {\n        list-style: none;\n        display: flex;\n        gap: 15px;\n    }\n    .chart-label li > span{\n        border-radius: 10px;\n    }\n\n</style><div class="row" ng-controller="MembershipDashboardPieChartCtrl as vm"><div class="d-flex-center position-relative"><span class="chart-title">Total<br><span>{{vm.data.total}}</span></span><canvas id="doughnut-111" class="chart chart-doughnut" chart-data="vm.data.data" chart-options="vm.data.options" chart-labels="vm.data.labels" chart-colors="vm.data.colours"></canvas></div><div class="d-flex-center mt-40"><ul class="chart-label"><li ng-repeat="labelAndColor in vm.labelsAndColors" class=""><span class="pie-legend-span" style="background-color: {{labelAndColor.colour}}"></span>{{labelAndColor.label}}</li></ul></div></div>');
$templateCache.put('app/pages/main/parkingManagement/liveFeedAndDashboard/exitVehicle/printSlipModal/printSlip.modal.html','<style>\n    .printSlip .modal-dialog  {\n        width: 300px !important;\n    }\n</style><div class="printSlip"><div class="modal-content"><div class="modal-body"><br><div class="row"><div class="col-md-12"><h1 class="text-uppercase text-center">{{ \'parkingManagement.printSlip.parkingBill\' | translate }}</h1></div></div><div class="row"><div class="col-md-6"><div class="col-md-12 ml-30"><p class="text-left">{{\'date\'|translate}}</p><p class="text-left">{{\'parkingManagement.vehicleInformation\'|translate}}</p><p class="text-left">{{\'parkingManagement.printSlip.driverMobile\'|translate}}</p><p class="text-left">{{\'entryTime\'|translate}}</p><p class="text-left">{{\'exitTime\'|translate}}</p><p class="text-left">{{\'parkingManagement.printSlip.totalHourSpent\'|translate}}</p><p class="text-left" ng-if="vm.parkingDetails.baseFare > 0.0">{{\'parkingManagement.baseFare\'|translate}}</p><p class="text-left" ng-if="vm.parkingDetails.hourlyFare > 0.0">{{\'parkingManagement.printSlip.hoursFare\'|translate}}</p><p class="text-left">{{\'parkingManagement.printSlip.totalFare\'|translate}}</p></div></div><div class="col-md-6"><div class="col-md-12"><p class="text-left">: {{vm.parkingDetails.date}}</p><p class="text-left">: {{vm.parkingDetails.vehicleNumber}}</p><p class="text-left">: {{vm.parkingDetails.driverMobileNumber}}</p><p class="text-left">: {{vm.parkingDetails.entryTime}}</p><p class="text-left">: {{vm.parkingDetails.exitTime}}</p><p class="text-left">: {{vm.parkingDetails.timeSpent}}</p><p class="text-left" ng-if="vm.parkingDetails.baseFare > 0.0">: Tk {{vm.parkingDetails.baseFare}}</p><p class="text-left" ng-if="vm.parkingDetails.hourlyFare > 0.0">: Tk {{vm.parkingDetails.hourlyFare}}</p><p class="text-left">: Tk {{vm.parkingDetails.amount}}</p></div></div></div><div><h1 class="text-center" ng-if="vm.parkingDetails.amount > 0.0">PAID</h1></div><div class="row"><div class="col-md-12 text-center"><span>Powered by Inovace Technologies</span></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.exitVehicleWithoutPrint()" translate="">{{ \'commonKeywords.okButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.exitVehicle()" translate="">{{ \'commonKeywords.printButton\' }}</button></div></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/settings/billSetup/billSetupDeleteModal/deleteBillSetup.model.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.visitorCard.deleteModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16 line-height-1_3">{{ \'parkingManagement.deleteModal\' | translate }} <em>{{vm.vehicleTypeToChange.type}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteBillSetup(vm.vehicleTypeToChange.id)" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/parkingManagement/settings/billSetup/createBillSetup/createBillSetup.html','<style>\n    .tk-icon-position{\n        position: absolute;\n        right: 42px;\n        top:28px;\n    }\n</style><div class="row"><div class="col-md-6"><form name="createBillSetupForm" ng-submit="vm.createNewBillSetup(createBillSetupForm.$valid)" novalidate="" autocomplete="off"><div ba-panel="" ba-panel-title="{{\'parkingManagement.billSetupNew\' | translate}}" ba-panel-class="with-scroll panel-full-screen"><div class="col-mt-10" ng-class="{\'has-error\': createBillSetupForm.billType.$invalid && createBillSetupForm.billType.$touched}"><label class="required">{{\'parkingManagement.billType\' | translate}}</label> <input name="billType" required="" type="text" class="form-control" placeholder="Enter bill type" ng-model="vm.type"> <small ng-show="createBillSetupForm.billType.$invalid && createBillSetupForm.billType.$touched" class="red-text" translate="">{{"parkingManagement.requiredMessage"}}</small></div><div class="row mt-10"><div class="col-md-6" ng-class="{\'has-error\': createBillSetupForm.baseFare.$invalid && createBillSetupForm.baseFare.$touched}"><label class="required">{{\'parkingManagement.baseFareInTk\' | translate}}</label> <input name="baseFare" min="0" required="" type="number" class="form-control position-relative" placeholder="Enter base fare" ng-model="vm.baseFare"> <img class="tk-icon-position" src="../assets/img/tk.png"> <small ng-show="createBillSetupForm.baseFare.$invalid && createBillSetupForm.baseFare.$touched" class="red-text" translate="">{{"parkingManagement.createBillSetupErrorMassage"}}</small></div><div class="col-md-6" ng-class="{\'has-error\': createBillSetupForm.baseHoure.$invalid && createBillSetupForm.baseHoure.$touched}"><label class="required">{{\'parkingManagement.baseHour\' | translate}}</label> <input name="baseHoure" min="0" required="" type="number" class="form-control position-relative" placeholder="Enter base hour" ng-model="vm.baseHour"> <small ng-show="createBillSetupForm.baseHoure.$invalid && createBillSetupForm.baseHoure.$touched" class="red-text" translate="">{{"parkingManagement.createBillSetupErrorMassage"}}</small></div></div><div class="row mt-10"><div class="col-md-6" ng-class="{\'has-error\': createBillSetupForm.hourlyFare.$invalid && createBillSetupForm.hourlyFare.$touched}"><label class="required">{{\'parkingManagement.hourlyFareInTk\' | translate}}</label> <input name="hourlyFare" min="0" required="" type="number" class="form-control position-relative" placeholder="Enter hourly fare" ng-model="vm.hourlyFare"> <img class="tk-icon-position" src="../assets/img/tk.png"> <small ng-show="createBillSetupForm.hourlyFare.$invalid && createBillSetupForm.hourlyFare.$touched" class="red-text" translate="">{{"parkingManagement.createBillSetupErrorMassage"}}</small></div></div><div class="row panel-bottom"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="submit" class="btn btn-md btn-primary" ng-disabled="createBillSetupForm.$invalid" translate="">{{ \'parkingManagement.createNewBill\' }}</button></div></div></div></div></form></div></div>');
$templateCache.put('app/pages/main/parkingManagement/settings/billSetup/updateBillSetup/updateBillSetup.html','<style>\n    .tk-icon-position{\n        position: absolute;\n        right: 42px;\n        top:28px;\n        opacity: 0.5;\n    }\n\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'parkingManagement.updateNewBill\' | translate}}" ba-panel-class="with-scroll panel-full-screen"><div class="col-mt-10"><label class="required">{{\'parkingManagement.billType\' | translate}}</label> <input type="text" class="form-control" ng-model="vm.type"></div><div class="row mt-10"><div class="col-md-6"><label class="required">{{\'parkingManagement.baseFareInTk\' | translate}}</label> <input type="number" class="form-control position-relative" ng-model="vm.baseFare"> <img class="tk-icon-position" src="../assets/img/tk.png"></div><div class="col-md-6"><label class="required">{{\'parkingManagement.baseHour\' | translate}}</label> <input type="number" class="form-control position-relative" ng-model="vm.baseHour"></div></div><div class="row mt-10"><div class="col-md-6"><label class="required">{{\'parkingManagement.hourlyFareInTk\' | translate}}</label> <input type="number" class="form-control position-relative" ng-model="vm.hourlyFare"> <img class="tk-icon-position" src="../assets/img/tk.png"></div></div><div class="row panel-bottom"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md btn-primary" ng-click="vm.updateBillSetupCtrl()" translate="">{{ \'parkingManagement.updateNewBill\' }}</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/bankManagement/adviceLetterEditor/bankPaymentAdviceEditor.html','<div class="row mb-15"><div class="col-md-9"><div ba-panel="" ba-panel-title="Bank Payment Advice Editor" ba-panel-class="with-scroll"><div class="doc-a4-size"><div class="mb-15 d-flex-gap-5 flex-wrap"><button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{monthName}}\')" translate="">Month Name</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{transferAmount}}\')" translate="">Transfer Amount</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{companyAccountNo}}\')" translate="">Company Account No.</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{companyAccountName}}\')" translate="">Company Account Name</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{companyLocation}}\')" translate="">Company Location</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{salarySheet}}\')" translate="">Salary Sheet</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.addVariable(\'{{numberOfEmployees}}\')" translate="">Number Of Employees</button></div><div id="editor" class="doc-a4-size"></div><div class="row"><div class="col-md-12 mt-20 text-right"><button type="button" class="btn btn-md-with-icon btn-danger" ng-click="vm.clearAll()"><i class="ion-android-delete"></i> Clear All</button> <button type="button" class="btn btn-md-with-icon btn-secondary" ng-click="vm.submit()"><i class="ion-ios-compose-outline"></i> Save</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/loanManagement/loanOrSalaryAdvanceInput/modal/loanOrSalaryAdvance.modal.html','<body><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'profile.areYouSureHeading\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5"><span>{{\'loanManagement.doYouWantToSaveTheText\' | translate}} <span>{{vm.settingsName}}</span> for <span class="font-weight-500 color-22222">{{vm.employeeName}}?</span></span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.noButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.closeModal()" translate="">{{ \'commonKeywords.yesButton\' }}</button></div></div></div></body>');
$templateCache.put('app/pages/main/payroll/loanManagement/partials/editLoanOrSalaryDetails/editLoanOrSalaryDetails.html','<style>\n    .custom-padding .form-control{\n        padding: 12px 35px;\n    }\n    .input-style input, .input-style select{\n        background: #f5f5f5;\n        border: none!important;\n    }\n    .input-style input:focus, .input-style select:focus{\n        background: transparent;\n    }\n</style><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'loanManagement.editLoanOrAdvanceSalaryInputTitle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div class="row mt-10"><div class="col-md-12 input-style"><label translate="">employeeName</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployeeInfo.employeeName"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">designation</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployeeInfo.designationName"></div></div><div class="col-md-6 input-style"><label translate="">department</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.selectedEmployeeInfo.departmentName"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">workplace</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.previousLoanInfo.workplace"></div></div><div class="col-md-6 input-style"><label translate="">email</label><div class="bg-f5f5f5"><input type="email" class="form-control prevent-clicks" ng-model="vm.previousLoanInfo.email"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.loanAmount\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.previousLoan"></div></div><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.remainingAmount\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.previousRemainingLoan"></div></div></div><div class="row mt-10"><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.remainingInstallment\'}}</label><div class="bg-f5f5f5"><input type="number" class="form-control prevent-clicks" ng-model="vm.previousLoanInfo.remainingInstalmentCount"></div></div><div class="col-md-6 input-style"><label translate="">{{\'loanManagement.expectedSettlementMonth\'}}</label><div class="bg-f5f5f5"><input type="text" class="form-control prevent-clicks" ng-model="vm.previousLoanInfo.settlementMonth"></div></div></div><div class="row"><div class="col-md-12"><label class="mt-10 font-13 required" translate="">type</label><div class="custom-select"><select ng-options="v.value as v.name for v in vm.loanType" ng-model="vm.selectedEmployeeInfo.type"></select></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{ \'loanManagement.loanRequestDate\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.selectedEmployeeInfo.requestedAt" options="vm.datePickerOptions"><span class="date-position-left">{{vm.selectedEmployeeInfo.requestedAt.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required" translate="">{{ \'loanManagement.loanDisburseDate\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.selectedEmployeeInfo.disbursedAt" options="vm.datePickerOptions"><span class="date-position-left">{{vm.selectedEmployeeInfo.disbursedAt.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{\'loanManagement.loanAmount\'}}</label><div><input type="number" class="form-control" ng-model="vm.selectedEmployeeInfo.amount"></div></div><div class="col-md-6"><label class="required" translate="">{{\'loanManagement.noOfInstallment\'}}</label><div><input type="number" class="form-control" ng-model="vm.selectedEmployeeInfo.instalmentCount"></div></div></div><div class="row mt-10"><div class="col-md-12"><label class="text-capitalize required mt-10" translate="">{{\'loanManagement.installmentStartFrom\'}}</label><div class="filter-inline-item"><div class="input-group mb-0"><input type="text" class="form-control" uib-datepicker-popup="{{vm.monthPickerInstallment.format}}" datepicker-options="vm.monthPickerInstallment.options" ng-model="vm.selectedMonth" is-open="vm.monthPickerInstallment.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPickerInstallment()"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">remarks</label><div><input type="text" class="form-control" placeholder="Remarks" ng-model="vm.remarks"></div></div></div><div class="row mt-25"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="payroll.loanManagement" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.editCurrentLoan()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/delete/deleteModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{\'monthlySalaryProcess.deleteAdditionalComponent\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.delete()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/delete/deleteModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{\'monthlySalaryProcess.deleteAbsentLwpComponent\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.delete()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/bankPaymentAdvice/individualBankPaymentAdvice/individualBankPaymentAdvice.html','<style>\n    .input-control .form-control{\n        width: 80%;\n    }\n</style><div class="row"><div class="col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="{{\'Bank Payment Advice for Sep 2021 - Standard Bank\'}} <span ng-click=\'vm.showFilters = !vm.showFilters\' class=\'filter pull-right\'> Filter <i class=\'fa fa-filter filter-width-20\'></i> <i ng-if=\'!vm.showFilters\' class=\'fa fa-chevron-down\'></i> <i ng-if=\'vm.showFilters\' class=\'fa fa-chevron-up\'></i> </span>" ba-panel-class="with-scroll panel-full-screen"><div><payroll-filter show-filters="vm.showFilters" search-method="vm.search" is-data-loaded="vm.isDataLoaded" rows-per-page="vm.rowsPerPage" excel-url="vm.excelUrl" pdf-url="vm.pdfUrl" selected-page="vm.selectedPage" delete-btn-active="true" config="vm.filterConfig"></payroll-filter></div><div><table class="table borderless-table odd-row-strip"><thead><tr><th class="text-center" translate="">sl</th><th class="text-center" translate="">id</th><th class="text-left" translate="">employeeName</th><th class="text-center" translate="">employeeType</th><th class="text-center" translate="">accountNo</th><th class="text-right" translate="">netPayment</th><th class="width-13 text-right" translate="">bank</th><th class="width-13 text-right" translate="">cash</th><th class="text-center" translate="">action</th></tr></thead><tbody ng-if="vm.isDataLoaded"><tr ng-repeat="payment in vm.bankPaymentAdviceList" class="border-bottom-1"><td class="text-center">{{ $index + 1 }}</td><td class="text-center">{{payment.employeeId}}</td><td class="text-left"><employee-picture-and-information name="payment.employeeName" picture-url="payment.employeePictureUrl" department-name="payment.departmentName" designation-name="payment.designationName" id="payment.employeeId" is-clickable="false"></employee-picture-and-information></td><td class="text-center">{{payment.employmentTypeName}}</td><td class="text-center">{{payment.accountNumber}}</td><td class="text-right">{{payment.netPayment}}</td><td class="text-right" ng-if="!payment.updateState">{{payment.bankPayment}}</td><td ng-if="payment.updateState" class="input-control"><div class="text-right"><input type="number" class="form-control text-end" ng-model="payment.bankPayment" ng-click="" ng-change="vm.recalculateNetPayment($index)"></div></td><td ng-if="!payment.cashPayment" class="text-right">--</td><td ng-if="payment.cashPayment === 0" class="text-right">0</td><td ng-if="payment.cashPayment > 0" class="text-right">{{payment.cashPayment | number:(2)}}</td><td class="text-center"><button ng-if="!payment.updateState" class="btn btn-sm-with-icon btn-secondary" ng-disabled="payment.paymentMode !== 4" ng-class="{\'btn-disable\':payment.paymentMode !== 4}" ng-click="vm.openUpdateState($index)"><i class="ion-ios-compose-outline"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.editButton\'}}</span></button> <button ng-if="payment.updateState" class="btn btn-primary" ng-click="vm.saveUpdate(payment)"><span class="" translate="">{{\'commonKeywords.updateButton\'}}</span></button></td></tr></tbody></table><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" rows-per-page="vm.rowsPerPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.search"></pagination-directive></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/accountDetails/providentFundAccountDetails.html','<style>\n    .panel.with-scroll .panel-body {\n        height: calc(100vh - 200px);\n        overflow-y: auto;\n    }\n    .year-field::placeholder{\n        color: #0a0a0a;\n    }\n    .calender-icon {\n        position: absolute;\n        right: 0;\n        width: 37px;\n        z-index: 2;\n        border: none;\n        padding: 0;\n    }\n</style><div ba-panel="" ba-panel-title="PF Account Management - Accounting Year {{vm.accountingYear}}" ba-panel-class="with-scroll" class="position-relative"><div class="row"><div class="col-md-7"><div class="row"><div class="col-md-4"><span class="d-inline-block mb-5 color-22222 font-12" translate="">searchEmployee</span><div class="form-group has-feedback resize-placeholder"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.searchByNameId()" placeholder="{{\'commonKeywords.searchByNameId\' | translate}}"></div></div><div class="col-md-3"><span class="d-inline-block mb-5 color-22222 font-12" translate="">{{\'providentFund.accountingYear\'}}</span><div class="input-group prevent-clicks position-relative"><input type="text" class="form-control year-field" show-button-bar="false" placeholder="{{vm.accountingYear}}"> <button type="button" class="btn btn-default modified-input-box input-group-btn calender-icon" ng-click="vm.openYearPickerFrom()"><i class="fa fa-calendar"></i></button></div></div></div><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'active\'}" ng-click="vm.switchTab(\'active\')" translate="">{{\'providentFund.active\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'separated\'}" ng-click="vm.switchTab(\'separated\')" translate="">{{\'providentFund.separated\'}}</button></div></div></div><div class="row text-center" ng-if="!vm.isDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/payroll/providentFund/providentFundAccountManagement/partials/membersTable.html"></div></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getYearlyAccountDetailsOfAnOffice" not-found-text="\'No data available\'"></pagination-directive></div><div class="col-md-5"><div class="row"><div class="col-md-12"><div class="d-flex-flex-end-10 flex-wrap"><button type="button" class="btn btn-md" ng-if="!vm.pfAccountInfo.isClosed" ng-class="{\'btn-secondary\' : vm.isInterestUploaded, \'btn-disable\' : !vm.isInterestUploaded}" ng-disabled="!vm.isInterestUploaded" ng-click="vm.openClosePFAccountingYearModal()" translate="">{{ \'providentFund.closeCurrentAccountingYear\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-if="!vm.pfAccountInfo.isClosed" ng-click="vm.openUploadInterestModal()"><span ng-if="!vm.pfAccountInfo.isClosed && vm.isInterestUploaded">{{\'providentFund.reuploadInterest\' |translate}}</span> <span ng-if="!vm.pfAccountInfo.isClosed && !vm.isInterestUploaded">{{\'providentFund.uploadInterest\' |translate}}</span></button><div class="filter-inline-item"><button class="btn btn-md-with-icon btn-primary padding-6-10 dropdown-toggle font-13" ng-click="vm.exportAsExcel()"><img class="img-resize" src="../assets/img/Excel.png"> <span class="ml-negative-5" translate="">{{\'commonKeywords.excelButton\'}}</span></button></div></div></div></div><div><h3 class="text-adjust pt-10 pr-10 mb-5">{{\'providentFund.PFMemberDetails\' | translate}}</h3></div><div ng-if="vm.isAnyRowSelected" include-with-scope="app/pages/main/payroll/providentFund/providentFundAccountManagement/partials/memberInfoSection.html"></div><div class="row position-relative" ng-if="!vm.isAnyRowSelected" ng-class="{\'unselected\': vm.isAnyRowSelected == false}"><div class="col-md-12" include-with-scope="app/pages/main/payroll/providentFund/providentFundAccountManagement/partials/dummyTable.html"></div></div><div class="row" ng-if="!vm.isAnyRowSelected"><div class="row" include-with-scope="app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/partials/dummyTable.html','<div class="row mt-7"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left height-45"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'payrollManagement.joiningDate\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'payrollManagement.confirmationDate\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'payrollManagement.membershipDate\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'payrollManagement.pfMembershipTenure\'}}</td><td>Not Set</td></tr></tbody></table><table class="table table-bordered odd-row-strip row-highlight mt-20"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left height-45"><td translate="">{{\'payrollManagement.remarks\'}}</td><td>Not Set</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/partials/memberInfoSection.html','<style>\n    .member-info{\n        height: calc(100vh - 225px);\n        overflow-y: auto;\n        width: 100%;\n        overflow-x: hidden;\n    }\n    /*.member-info::-webkit-scrollbar {*/\n    /*    display: none;*/\n    /*}*/\n    .th-bg {\n        background: #efefef;\n    }\n    .ion-android-close, .ion-android-done{\n        font-size: 15px;\n        color: white;\n    }\n    .custom-style{\n        height: 25px;\n        width: 25px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .editable-field{\n        cursor: pointer;\n    }\n    .editable-field{\n        border-bottom: 2px dotted grey !important;\n    }\n    .editable-field:hover{\n        color: #2a6496;\n        border-bottom-color: #2a6496;\n    }\n</style><div class="member-info mt-7"><div ng-if="vm.isRightSideDataLoaded"><div class="row"><div class="col-md-12"><table class="table table-bordered odd-row-strip"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.memberDetails.employeeInfo.name" picture-url="vm.memberDetails.employeeInfo.pictureUrl" department-name="vm.memberDetails.employeeInfo.departmentName" designation-name="vm.memberDetails.employeeInfo.designationName" id="vm.memberDetails.employeeInfo.id" is-clickable="true"></employee-picture-and-information></td></tr><tr class="text-left height-45"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{!vm.memberDetails.employeeInfo.employmentTypeName ? \'Not Set\' : vm.memberDetails.employeeInfo.employmentTypeName}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.joiningDate\'}}</td><td>{{!vm.memberDetails.employeeInfo.dateOfJoinFormatted ? \'Not Set\' : vm.memberDetails.employeeInfo.dateOfJoinFormatted}}</td></tr><tr ng-if="vm.selectedTab == \'active\' || vm.selectedTab == \'separated\'" class="text-left height-45"><td translate="">{{\'providentFund.membershipDate\'}}</td><td>{{!vm.memberDetails.membershipDate ? \'Not Set\' : vm.memberDetails.membershipDate}}</td></tr><tr ng-if="vm.selectedTab == \'separated\'" class="text-left height-45"><td translate="">{{\'providentFund.separationDate\'}}</td><td>{{!vm.memberDetails.separationDate ? \'Not Set\' : vm.memberDetails.separationDate}}</td></tr><tr ng-if="vm.selectedTab == \'active\' || vm.selectedTab == \'separated\'" class="text-left height-45"><td translate="">{{\'providentFund.pfMembershipTenure\'}}</td><td>{{!vm.memberDetails.tenure ? \'Not Set\' : vm.memberDetails.tenure}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h3 class="font-weight-600">{{\'providentFund.pFDetails\' | translate}}</h3></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered odd-row-strip"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left th-width th-bg"><td colspan="2" class="position-relative font-weight-600" translate="">{{\'providentFund.openingBalance\'}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.membersSubscription\'}}</td><td>{{vm.pfDetails.subscription | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.interestOnMembersSubscription\'}}</td><td>{{vm.pfDetails.subscriptionInterest | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.companysContribution\'}}</td><td>{{vm.pfDetails.companyContribution | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.interestOnCompanysContribution\'}}</td><td>{{vm.pfDetails.companyContributionInterest | number:2}}</td></tr><tr class="text-left text-bold height-45"><td translate="">{{\'providentFund.totalOpeningBalance\'}}</td><td>{{vm.pfDetails.totalBalance | number:2}}</td></tr></tbody></table></div></div><div class="row mt-10"><div class="col-md-12"><table class="table table-bordered odd-row-strip"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left th-width th-bg"><td colspan="2" class="position-relative font-weight-600" translate="">{{\'providentFund.contributionDuringTheYear\'}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.membersSubscription\'}}</td><td>{{vm.contributionDuringYear.subscription | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.interestOnMembersSubscription\'}}</td><td>{{vm.contributionDuringYear.subscriptionInterest | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.companysContribution\'}}</td><td>{{vm.contributionDuringYear.companyContribution | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.interestOnCompanysContribution\'}}</td><td>{{vm.contributionDuringYear.companyContributionInterest | number:2}}</td></tr><tr class="text-left text-bold height-45"><td translate="">{{\'providentFund.totalContributionThisYear\'}}</td><td>{{vm.contributionDuringYear.totalBalance | number:2}}</td></tr></tbody></table></div></div><div class="row mt-10"><div class="col-md-12"><table class="table table-bordered odd-row-strip"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left th-width th-bg"><td colspan="2" class="position-relative"><div class="d-flex-space-between"><span class="font-weight-600">{{\'providentFund.pFLoan\' | translate}}</span></div></td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.loanAmount\'}}</td><td>{{vm.pfLoanDetails.loanAmount | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.loanRecovered\'}}</td><td>{{vm.pfLoanDetails.loanRecovered | number:2}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.remainingAmount\'}}</td><td>{{vm.pfLoanDetails.remainingLoan | number:2}}</td></tr></tbody></table></div></div><div class="row mt-10"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left th-width th-bg"><td class="position-relative font-weight-600" translate="">{{\'providentFund.totalPF\'}}</td><td class="position-relative font-weight-600">{{vm.pfLoanDetails.totalPF | number:2}}</td></tr></tbody></table></div></div><div ng-if="vm.selectedTab == \'separated\'"><div class="row mt-20"><div class="col-md-6">{{\'providentFund.paymentDuringTheYear\' | translate}}</div><div class="col-md-6" ng-show="!vm.paymentDuringTheYearClicked"><span class="editable-field" ng-click="vm.paymentDuringTheYearClicked = true"><em>{{vm.memberDetails.separationPayment | number:2}}</em></span></div><div class="col-md-6" ng-show="vm.paymentDuringTheYearClicked"><div class="d-flex-gap-10"><input type="number" class="form-control" ng-model="vm.memberDetails.separationPayment"><div class="d-flex-gap-5 align-center"><button type="button" class="btn btn-sm btn-secondary custom-style" ng-click="vm.savePaymentDuringTheYear()"><i class="ion-android-done"></i></button> <button type="button" class="btn btn-sm btn-danger custom-style" ng-click="vm.paymentDuringTheYearClicked = false"><i class="ion-android-close"></i></button></div></div></div></div><div class="row mt-20"><div class="col-md-6">{{\'providentFund.balanceAfterPayments\' | translate}}</div><div class="col-md-6">{{vm.memberDetails.balanceAfterSeparationPay | number:2}}</div></div><div class="row mt-20"><div class="col-md-6">{{\'providentFund.forfeitureForTheYear\' | translate}}</div><div class="col-md-6" ng-show="!vm.forfeitureForTheYearCLicked"><span class="editable-field" ng-click="vm.forfeitureForTheYearCLicked = true"><em>{{vm.memberDetails.forfeiture | number:2}}</em></span></div><div class="col-md-6" ng-show="vm.forfeitureForTheYearCLicked"><div class="d-flex-gap-10"><input type="number" class="form-control" ng-model="vm.memberDetails.forfeiture"><div class="d-flex-gap-5 align-center"><button type="button" class="btn btn-sm btn-secondary custom-style" ng-click="vm.saveForfeitureForTheYear()"><i class="ion-android-done"></i></button> <button type="button" class="btn btn-sm btn-danger custom-style" ng-click="vm.forfeitureForTheYearCLicked = false"><i class="ion-android-close"></i></button></div></div></div></div><div class="row mt-20"><div class="col-md-6">{{\'providentFund.balanceOnLastDate\' | translate}}</div><div class="col-md-6">{{vm.memberDetails.balanceOnLastDateOfTheYear | number:2}}</div></div></div></div><div class="row text-center" ng-if="!vm.isRightSideDataLoaded"><div class="col-md-12 col-sm-6"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/partials/membersTable.html','<style>\n    .table > thead > tr > th:last-child {\n        padding-right: 0 !important;\n    }\n    .table > tbody > tr > td:last-child {\n        padding-right: 0 !important;\n    }\n</style><table id="column-height" class="table borderless-table odd-row-strip row-highlight"><colgroup ng-if="vm.selectedTab == \'active\'"><col class="width-5"><col class="width-9"><col class="width-30"><col class="width-15"><col class="width-16"><col class="width-16"><col class="width-9"></colgroup><colgroup ng-if="vm.selectedTab == \'separated\'"><col class="width-5"><col class="width-8"><col class="width-25"><col class="width-9"><col class="width-14"><col class="width-15"><col class="width-15"><col class="width-8"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.id\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th ng-if="vm.selectedTab == \'active\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.openingBalance\'}}</th><th ng-if="vm.selectedTab == \'active\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.contributionDuringTheYear\'}}</th><th ng-if="vm.selectedTab == \'active\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.remainingLoanBalance\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'providentFund.totalPF\'}}</th><th ng-if="vm.selectedTab == \'separated\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.paymentDuringTheYear\'}}</th><th ng-if="vm.selectedTab == \'separated\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.balanceAfterTheYear\'}}</th><th ng-if="vm.selectedTab == \'separated\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.forfeitureForTheYear\'}}</th><th ng-if="vm.selectedTab == \'separated\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.balance\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.yearlyAccountDetails" class="cursor-pointer border-bottom-1" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}" ng-click="vm.showMemberInfoInTheRightColumn($index, data.employeeId)"><td class="text-center">{{$index+(vm.selectedPage*10)+1}}</td><td class="text-center">{{data.employeeOfficeId}}</td><td class="dont-wrap-text"><employee-picture-and-information name="!data.name ? \'Not Set\' : data.name" picture-url="data.profilePic" department-name="!data.departmentName ? \'Not Set\' : data.departmentName" designation-name="!data.designationName ? \'Not Set\' : data.designationName" is-clickable="false"></employee-picture-and-information></td><td ng-if="vm.selectedTab == \'active\'" class="dont-wrap-text text-center">{{data.openingBalance | number:2}}</td><td ng-if="vm.selectedTab == \'active\'" class="dont-wrap-text text-center">{{data.givenYearContribution | number:2}}</td><td ng-if="vm.selectedTab == \'active\'" class="dont-wrap-text text-center">{{data.remainingLoanAmount | number:2}}</td><td class="dont-wrap-text text-center">{{data.totalPfAmount | number:2}}</td><td ng-if="vm.selectedTab == \'separated\'" class="dont-wrap-text text-center">{{data.separationPayment | number:2}}</td><td ng-if="vm.selectedTab == \'separated\'" class="dont-wrap-text text-center">{{vm.getDifference(data.totalPfAmount, data.separationPayment) | number:2}}</td><td ng-if="vm.selectedTab == \'separated\'" class="dont-wrap-text text-center">{{data.forfeitedAmount | number:2}}</td><td ng-if="vm.selectedTab == \'separated\'" class="dont-wrap-text text-center">{{vm.getDifference(vm.getDifference(data.totalPfAmount,data.separationPayment),data.forfeitedAmount) | number:2}}</td></tr></tbody></table>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundMember/modal/addPFMember.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'providentFund.doYouWantToAdd\' | translate}} {{vm.memberInfo.name}} {{\'providentFund.asAPFMember\' | translate}}</p><p></p><label class="mt-10 required" translate="">{{ \'holidaySettings.creationModal.dateInputLabel\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.membershipStartDate" options="vm.datePickerOptions"><span class="date-position-left">{{vm.membershipStartDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div><label class="mt-10" translate="">remarks</label> <input type="text" class="form-control" placeholder="Remarks" ng-model="vm.remarks"></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.addPFMember()" translate="">{{vm.addMemberBtnClicked ? \'Please Wait..\' : \'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundMember/partials/dummyTable.html','<div class="row mt-15"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left height-45"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.joiningDate\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.confirmationDate\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.membershipDate\'}}</td><td>Not Set</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.pfMembershipTenure\'}}</td><td>Not Set</td></tr></tbody></table><table class="table table-bordered odd-row-strip row-highlight mt-20"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left height-45"><td translate="">{{\'providentFund.remarks\'}}</td><td>Not Set</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundMember/partials/editEmployeeInfoSection.html','<style>\n    @media(max-width:991px){\n        .spacing{\n            margin-top: 15px;\n        }\n    }\n</style><div class="row mt-15"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr class="text-center th-width th-bg"><td class="position-relative" colspan="2"><employee-picture-and-information name="vm.selectedRow.name" picture-url="vm.selectedRow.pictureUrl" department-name="vm.selectedRow.departmentName" designation-name="vm.selectedRow.designationName" id="vm.selectedRow.id" is-clickable="vm.selectedRow.status == 1"></employee-picture-and-information></td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.shiftGroup\'}}</td><td>{{vm.selectedRow.shiftGroupName ? vm.selectedRow.shiftGroupName : \'Not Set\'}}</td></tr><tr class="text-left"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.selectedRow.employmentTypeName ? vm.selectedRow.employmentTypeName : \'Not Set\'}}</td></tr></tbody></table></div></div><div class="row mt-20"><div class="col-md-12"><h3>{{\'providentFund.payrollInformation\' | translate}}</h3></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr><td class="text-left">Basic Salary</td><td><input type="number" class="form-control" ng-model="vm.basicSalary" ng-disabled="vm.officePayrollSettings.payrollType == vm.PAYROLL_TYPE_GROSS_DRIVEN"></td></tr><tr ng-repeat="data in vm.employeePayrollComponents | filter: {inclusiveToGross: true}" ng-if="data.type != -1"><td class="text-left"><span>{{data.name}}</span></td><td class="text-center text-left-important"><input type="number" class="form-control text-visible" ng-disabled="!data.isEditable" ng-model="data.amount" id="grossOrBasicInputField" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()"></td></tr><tr><td class="text-left">Gross Salary</td><td><input type="number" class="form-control" ng-model="vm.grossSalary" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()" ng-disabled="vm.officePayrollSettings.payrollType == vm.PAYROLL_TYPE_BASIC_DRIVEN"></td></tr><tr ng-repeat="data in vm.employeePayrollComponents | filter: {inclusiveToGross: false}"><td class="text-left"><span>{{data.name}}</span></td><td class="text-center text-left-important"><input type="number" class="form-control text-visible" ng-disabled="!data.isEditable" ng-model="data.amount" id="grossOrBasicInputFielx" ng-keydown="$event.keyCode === 13 && vm.syncPayrollComponentValues()"></td></tr><tr><td class="text-left">Total Salary</td><td>{{vm.getTotalSalary()}}</td></tr></tbody></table><div class="row mt-30"><div class="col-md-12"><h3>{{\'payrollManagement.bankInformation\' | translate}}</h3></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.paymentMode\'}}</p><div class="custom-select"><select ng-options="v.value as v.name for v in vm.paymentModes" ng-model="vm.paymentMode"></select></div></div><div class="col-md-6 spacing"><p translate="">{{\'payrollManagement.bankName\'}}</p><div class="custom-select"><select ng-options="b.bankId as b.bankName for b in vm.bankList" ng-model="vm.bankId"></select></div></div></div><div class="row mt-20"><div class="col-md-6"><p translate="">{{\'payrollManagement.routingNumber\'}}</p><div class="custom-select"><select ng-options="b.routingNumber as b.routingNumber for b in vm.bankList | filter:{bankId:vm.bankId}" ng-model="vm.routingNumber"></select></div></div><div class="col-md-6 spacing"><p translate="">{{\'payrollManagement.accountNumber\'}}</p><input type="text" class="form-control" ng-model="vm.accountNumber"></div></div><div class="row mt-30"><div class="col-md-12 text-right"><button class="btn btn-md-with-icon btn-primary padding-7-14" ng-disabled="vm.savingSalary" ng-click="vm.saveEmployeeInfo()"><img src="../assets/img/Save.png"> <span class="ml-negative-5 pb-2" translate="">{{\'payrollManagement.saveSetUp\'}}</span></button></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundMember/partials/employeesTable.html','<table id="column-height" class="table borderless-table odd-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-10"><col class="width-39"><col class="width-15"><col class="width-15"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.id\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'providentFund.joining\'}}</th><th ng-if="vm.selectedTab == \'active\' || vm.selectedTab == \'separated\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.membership\'}}</th><th ng-if="vm.selectedTab == \'pending\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.action\'}}</th><th ng-if="vm.selectedTab == \'separated\'" class="text-center dont-wrap-text" translate="">{{\'providentFund.separation\'}}</th></tr></thead><tbody><tr ng-repeat="member in vm.allPFMembers" class="cursor-pointer border-bottom-1" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}"><td class="text-center">{{($index+(vm.selectedPage*10))+1}}</td><td class="text-center" ng-click="vm.showMemberInfoInTheRightColumn($index, member)">{{member.employeeInfo.employeeOfficeId}}</td><td class="dont-wrap-text" ng-click="vm.showMemberInfoInTheRightColumn($index, member)"><employee-picture-and-information name="member.employeeInfo.name" picture-url="member.employeeInfo.pictureUrl" department-name="member.employeeInfo.departmentName" designation-name="member.employeeInfo.designationName" is-clickable="false"></employee-picture-and-information></td><td class="dont-wrap-text text-center" ng-click="vm.showMemberInfoInTheRightColumn($index, member)">{{member.employeeInfo.dateOfJoin==null?"Not Set":member.employeeInfo.dateOfJoin | date:\'dd MMM yyyy\'}}</td><td ng-if="vm.selectedTab == \'active\' || vm.selectedTab == \'separated\'" class="dont-wrap-text text-center" ng-click="vm.showMemberInfoInTheRightColumn($index, member)">{{member.membershipDate}}</td><td ng-if="vm.selectedTab == \'pending\'" class="dont-wrap-text text-center"><button class="btn btn-md-with-icon btn-secondary pull-right" ng-click="vm.openAddPFMemberModal(member)" translate="">{{\'providentFund.add\'}}</button></td><td ng-if="vm.selectedTab == \'separated\'" class="dont-wrap-text text-center">{{member.separationDate}}</td></tr></tbody></table>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundMember/partials/memberInfoSection.html','<style>\n    .th-bg {\n        background: #efefef;\n    }\n</style><div class="row mt-15"><div class="col-md-12"><table class="table table-bordered odd-row-strip row-highlight"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-width th-bg"><td colspan="2" class="position-relative"><employee-picture-and-information name="vm.member.employeeInfo.name" picture-url="vm.member.employeeInfo.pictureUrl" department-name="vm.member.employeeInfo.departmentName" designation-name="vm.member.employeeInfo.designationName" id="vm.member.employeeInfo.id" is-clickable="vm.member.employeeInfo.status == 1"></employee-picture-and-information></td></tr><tr class="text-left height-45"><td translate="">{{\'commonKeywords.employmentType\'}}</td><td>{{vm.member.employeeInfo.employmentTypeName == null ? \'Not Set\':vm.member.employeeInfo.employmentTypeName}}</td></tr><tr class="text-left height-45"><td translate="">{{\'providentFund.joiningDate\'}}</td><td>{{vm.member.employeeInfo.dateOfJoin == null ? \'Not Set\':vm.member.employeeInfo.dateOfJoin | date:\'dd MMM yyyy\'}}</td></tr><tr ng-if="vm.selectedTab == \'active\' || vm.selectedTab == \'separated\'" class="text-left height-45"><td translate="">{{\'providentFund.membershipDate\'}}</td><td>{{vm.member.membershipDate == null ? \'Not Set\':vm.member.membershipDate}}</td></tr><tr ng-if="vm.selectedTab == \'separated\'" class="text-left height-45"><td translate="">{{\'providentFund.separationDate\'}}</td><td>{{vm.member.separationDate == null ? \'Not Set\':vm.member.separationDate}}</td></tr><tr ng-if="vm.selectedTab == \'active\' || vm.selectedTab == \'separated\'" class="text-left height-45"><td translate="">{{\'providentFund.pfMembershipTenure\'}}</td><td>{{vm.member.tenure == null ? \'Not Set\':vm.member.tenure}}</td></tr></tbody></table><table class="table table-bordered odd-row-strip row-highlight mt-20" ng-if="vm.selectedTab !== \'pending\'"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-left height-45"><td translate="">{{\'providentFund.remarks\'}}</td><td>{{vm.member.remarks == null? \'Not Set\':vm.member.remarks}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/dummyTable.html','<div class="row mt-15"><div class="col-md-12"><table class="table table-no-borders bg-fbfbfb"><tr><td><employee-picture-and-information name="vm.selectedRow.employee.name" picture-url="vm.selectedRow.employee.pictureUrl" department-name="vm.selectedRow.employee.departmentName" designation-name="vm.selectedRow.employee.designationName" id="vm.selectedRow.employee.id" is-clickable=""></employee-picture-and-information></td></tr></table><table class="table table-bordered"><colgroup><col class="width-60"><col class="width-40"></colgroup><thead><tr class="bg-f1f2f1"><th class="text-left"><strong translate="">{{\'viewOrGenerateSalary.salaryComponent\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.amount\'}}</strong></th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'payrollManagement.basicSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.houseRentAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.conveyanceAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.medicalAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left"><strong translate="">{{\'viewOrGenerateSalary.monthlyGrossSalary\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr style="background: #61C6E4"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollSettings.deduction\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr style="background: #F19A9A"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left"><strong translate="">{{\'payrollManagement.netPayable\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/editSalaryDetailsTable.html','<div class="row"><div class="col-md-12"><table class="table table-no-borders bg-fbfbfb"><tr><td><employee-picture-and-information name="vm.selectedRow.employee.name" picture-url="vm.selectedRow.employee.pictureUrl" department-name="vm.selectedRow.employee.departmentName" designation-name="vm.selectedRow.employee.designationName" id="vm.selectedRow.employee.id" is-clickable="vm.selectedRow.employee.status == 1"></employee-picture-and-information></td></tr></table><table class="table table-bordered"><colgroup><col class="width-30"><col class="width-30"><col class="width-40"></colgroup><thead><tr class="bg-f1f2f1"><th class="text-left"><strong translate="">{{\'viewOrGenerateSalary.salaryComponent\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.calculatedAmount\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.updatedAmount\'}}</strong></th></tr></thead><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{inclusiveToGross: true}:true"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.calculatedAmount | number : 2}}</td><td class="text-center text-left-important"><input type="number" class="form-control" ng-model="data.updatedAmount" ng-change="vm.compareCalculatedAndUpdatedAmount()"></td></tr><tr><td class="text-left"><strong translate="">{{\'viewOrGenerateSalary.monthlyGrossSalary\'}}</strong></td><td class="text-center text-bold">{{vm.sumData.monthlyGrossSalary | number : 2}}</td><td class="text-left-important text-bold">{{vm.getUpdatedGrossSalary() | number : 2}}</td></tr></tbody><tbody ng-repeat="data in vm.selectedRow.components"><tr ng-if="data.inclusiveToGross === false && data.category === 1"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.calculatedAmount | number : 2}}</td><td class="text-center">{{data.updatedAmount | number : 2}}</td></tr></tbody><tbody><tr class="bg-61C6E4 font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-center">{{vm.sumData.monthlyTotalSalary | number : 2}}</td><td class="text-center">{{vm.getUpdatedTotalSalary() | number : 2}}</td></tr></tbody><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{category: -1}:true"><td class="text-left">{{data.name}}</td><td class="text-center">{{vm.getAbsCalculatedAmount(data.calculatedAmount) | number : 2}}</td><td class="text-left-important"><input type="number" class="form-control" ng-model="data.updatedAmount" ng-change="vm.compareCalculatedAndUpdatedAmount()"></td></tr></tbody><tbody><tr class="bg-F19A9A font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-center">{{vm.sumData.monthlyTotalDeduction | number : 2}}</td><td class="text-center">{{vm.getTotalDeductedAmount() | number : 2}}</td></tr><tr><td class="text-left"><strong translate="">{{\'payrollManagement.netPayable\'}}</strong></td><td class="text-center">{{vm.sumData.monthlyNetPayable | number : 2}}</td><td class="text-center">{{vm.getTotalPayableAmount() | number : 2}}</td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-12"><h5><strong class="text-uppercase required" translate="">{{\'viewOrGenerateSalary.remarks\'}}</strong></h5></div></div><div class="row"><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.remarks"></div><div class="col-md-3 text-right"><button class="btn btn-md-with-icon padding-7-14" ng-click="vm.saveChanges()" ng-class="{\'btn-disable\' : vm.isSaveBtnClicked, \'btn-primary\' : !vm.isSaveBtnClicked}" ng-disabled="vm.isSaveBtnClicked"><img src="../assets/img/Save.png"> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.saveChangesButton\'}}</span></button></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/employeesTable.html','<style>\n    .edited{\n        border-radius:10px;\n        color:#222222;\n        font-weight: 500;\n        border:1px solid #DF871C;\n        float: right\n    }\n    .section-padding{\n        padding-top: 5%;\n    }\n    .process-btn{\n        font-size: 12px;\n        margin-right: 0px;\n        padding: 1px 6px;\n    }\n    .flex-0-1-100{\n        flex: 0 1 100%;\n    }\n    .flex-0-1-auto{\n        flex: 0 1 auto;\n    }\n    .border-bottom-1{\n        border-bottom: 1px solid #dfdfdf!important;\n    }\n</style><div class="col-md-12"><table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-13"><col class="width-39"><col class="width-15"><col class="width-15"><col class="width-12"></colgroup><thead><tr class="dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left check-uncheck-all dont-wrap-text"><label class="checkbox-container text-normal"><input ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover" type="checkbox" ng-model="vm.allSelected" ng-click="vm.checkOrUncheckAll()"> <span class="custom-checkbox checkbox-position-th"></span> <span class="ml-20"><span class="d-inline-block mt-2 white-text">{{\'commonKeywords.id\' | translate}}</span></span></label></th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'payrollManagement.grossSalary\'}}</th><th class="text-right dont-wrap-text" translate="">{{\'payrollManagement.netPayable\'}}</th><th class="text-center dont-wrap-text" ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover" translate="">{{\'viewOrGenerateSalary.action\'}}</th><th class="text-left dont-wrap-text" ng-if="vm.salarySummary.status != 0 || vm.isPayrollApprover" translate="">{{\'viewOrGenerateSalary.remarks\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.employeeInfo" class="cursor-pointer" ng-class="{\'is-selected\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}" style="{{data.isEdited ? \'background-color:#E1ECEA\':\'\'}}"><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{$index + 1}}</td><td class="text-left" ng-click="vm.showEmployeeInfoInTheRightColumn($index)"><label class="checkbox-container text-normal"><input ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover" type="checkbox" ng-model="data.isSelected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-20 default-text" translate="">{{data.employee.employeeOfficeId}}</span></label></td><td class="dont-wrap-text" ng-click="vm.showEmployeeInfoInTheRightColumn($index)"><div class="d-flex-space-between"><div class="flex-0-1-100"><employee-picture-and-information name="data.employee.name" picture-url="data.employee.pictureUrl" department-name="data.employee.departmentName" designation-name="data.employee.designationName" is-clickable="false"></employee-picture-and-information></div><div class="section-padding flex-0-1-auto" ng-if="data.isEdited"><span class="label label-primary label-style edited" translate="">{{\'viewOrGenerateSalary.edited\'}}</span></div></div></td><td class="dont-wrap-text text-right" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{data.grossSalary | number:0}}</td><td class="dont-wrap-text text-right" ng-click="vm.showEmployeeInfoInTheRightColumn($index,data.id)">{{data.netPayableSalary | number:0}}</td><td class="dont-wrap-text text-center" ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover"><span ng-if="vm.selectedTab === \'processedSalary\'"><button class="btn btn-sm-with-icon btn-info" ng-click="vm.openSalaryEditSection($index)"><i class="ion-ios-compose-outline font-17"></i><span class="font-13 pb-2" translate="">{{\'viewOrGenerateSalary.editButton\'}}</span></button></span> <span ng-if="vm.selectedTab === \'unprocessedSalary\'"><button class="btn btn-sm-with-icon process-btn btn-info" ng-click="vm.processSalaryForOneEmployee($index)"><img class="img-resize" src="../assets/img/process.png"> <span class="ml-negative-5 pt-1" translate="">{{\'viewOrGenerateSalary.processButton\'}}</span></button></span></td><td class="dont-wrap-text text-left" ng-if="vm.salarySummary.status != 0 || vm.isPayrollApprover">{{::data.remarks}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/salaryDetailsTable.html','<div class="col-md-12"><table class="table table-no-borders bg-fbfbfb"><tr><td><employee-picture-and-information name="vm.selectedRow.employee.name" picture-url="vm.selectedRow.employee.pictureUrl" department-name="vm.selectedRow.employee.departmentName" designation-name="vm.selectedRow.employee.designationName" id="vm.selectedRow.employee.id" is-clickable="vm.selectedRow.employee.status == 1"></employee-picture-and-information></td></tr></table><table class="table table-bordered" ng-if="vm.isEdited === false"><colgroup><col class="width-60"><col class="width-40"></colgroup><thead><tr class="bg-f1f2f1"><th class="text-left"><strong translate="">{{\'viewOrGenerateSalary.salaryComponent\'}}</strong></th><th class="text-right"><strong translate="">{{\'viewOrGenerateSalary.amount\'}}</strong></th></tr></thead><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{inclusiveToGross: true}:true"><td class="text-left">{{data.name}}</td><td class="text-right">{{data.calculatedAmount | number : 2}}</td></tr><tr><td class="text-left"><strong translate="">{{\'viewOrGenerateSalary.monthlyGrossSalary\'}}</strong></td><td class="text-right"><strong>{{vm.selectedRow.grossSalary | number : 2}}</strong></td></tr></tbody><tbody ng-repeat="data in vm.selectedRow.components"><tr ng-if="data.inclusiveToGross === false && data.category === 1"><td class="text-left">{{data.name}}</td><td class="text-right">{{data.calculatedAmount | number : 2}}</td></tr></tbody><tbody><tr class="bg-61C6E4 font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-right">{{vm.selectedRow.totalSalary | number : 2}}</td></tr></tbody><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{category: -1}:true"><td class="text-left">{{data.name}}</td><td class="text-right">{{vm.getAbsCalculatedAmount(data.calculatedAmount) | number : 2}}</td></tr></tbody><tbody><tr class="bg-F19A9A font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-right">{{vm.getAbsCalculatedAmount(vm.selectedRow.totalDeduction) | number : 2}}</td></tr><tr><td class="text-left"><strong translate="">{{\'payrollManagement.netPayable\'}}</strong></td><td class="text-right"><strong>{{vm.getAbsCalculatedAmount(vm.selectedRow.netPayableSalary) | number : 2}}</strong></td></tr></tbody></table><table class="table table-bordered odd-row-strip" ng-if="vm.isEdited === true"><colgroup><col class="width-40"><col class="width-30"><col class="width-30"></colgroup><thead><tr class="bg-f1f2f1"><th class="text-left"><strong translate="">{{\'viewOrGenerateSalary.salaryComponent\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.calculatedAmount\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.updatedAmount\'}}</strong></th></tr></thead><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{inclusiveToGross: true}:true"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.calculatedAmount | number : 2}}</td><td class="text-center">{{data.updatedAmount | number : 2}}</td></tr><tr><td class="text-left"><strong translate="">{{\'viewOrGenerateSalary.monthlyGrossSalary\'}}</strong></td><td class="text-center"><strong>{{vm.sumData.monthlyGrossSalary | number : 2}}</strong></td><td class="text-center"><strong>{{vm.getUpdatedGrossSalary() | number : 2}}</strong></td></tr></tbody><tbody ng-repeat="data in vm.selectedRow.components"><tr ng-if="data.inclusiveToGross === false && data.category === 1"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.calculatedAmount | number : 2}}</td><td class="text-center">{{data.updatedAmount | number : 2}}</td></tr></tbody><tbody><tr class="bg-61C6E4 font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-center">{{vm.sumData.monthlyTotalSalary | number : 2}}</td><td class="text-center">{{vm.getUpdatedGrossSalary() | number : 2}}</td></tr></tbody><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{category: -1}:true"><td class="text-left">{{data.name}}</td><td class="text-center">{{vm.getAbsCalculatedAmount(data.calculatedAmount) | number : 2}}</td><td class="text-center">{{vm.getAbsCalculatedAmount(data.updatedAmount) | number : 2}}</td></tr><tr class="bg-F19A9A font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-center">{{vm.sumData.monthlyTotalDeduction | number : 2}}</td><td class="text-center">{{vm.getTotalDeductedAmount() | number : 2}}</td></tr><tr><td class="text-left"><strong translate="">{{\'payrollManagement.netPayable\'}}</strong></td><td class="text-center"><strong>{{vm.sumData.monthlyNetPayable | number : 2}}</strong></td><td class="text-center">{{vm.getTotalPayableAmount() | number : 2}}</td></tr></tbody></table><div class="mt-20" ng-if="vm.isEdited === true"><h4><strong class="text-uppercase" translate="">{{\'viewOrGenerateSalary.remarks\'}}</strong></h4><p>{{vm.remarks}}</p></div></div>');
$templateCache.put('app/pages/main/profile/attendance/detailsAttendanceLog/deletePunch/deletePunch.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span translate="">{{ \'profileAttendanceReport.punchDeleteModal.title\' }}</span></div><div class="modal-body"><p translate="">{{ \'profileAttendanceReport.punchDeleteModal.confirmationText\' }}?</p></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="$close()" translate="">{{ \'commonKeywords.yesButton\' }}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$dismiss()" translate="">{{ \'commonKeywords.noButton\' }}</button></div></div>');
$templateCache.put('app/pages/main/profile/attendance/detailsAttendanceLog/manualEntry/manualEntry.modal.html','<style>\n    .modified-font{\n        color: #292929;\n        font-size: 14px;\n    }\n    .manual-entry label{\n        font-size: 14px;\n    }\n    textarea.form-control {\n        height: 37px;\n    }\n</style><div class="modal-content"><div class="modal-body manual-entry"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.manualEntry\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row mb-10"><div class="col-md-12"><label class="required">{{\'profile.selectType\' | translate}}</label></div><div class="col-md-12"><div class="custom-select"><select id="manualEntryTypeSelect" ng-model="vm.selectedType"><option value="manual" translate="">{{\'profile.manualEntry\'}}</option><option value="missing" translate="">{{\'profile.missingPunch\'}}</option><option value="fieldVisit" translate="">{{\'profile.fieldVisit\'}}</option><option value="" disabled="" translate="">{{\'profile.selectType\'}}</option></select></div></div></div><div class="row form-group" ng-if="vm.selectedType == \'manual\'"><div class="col-md-12 mb-10"><label class="required">{{\'profile.entryTime\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.manualEntryFrom" options="vm.entryDatePickerOptions"><span class="date-position-left">{{vm.manualEntryFrom.format(\'DD-MMM-YYYY hh:mm a\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-12 mb-10"><label class="required">{{\'profile.exitTime\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.manualEntryTo" options="vm.exitDatePickerOptions"><span class="date-position-left">{{vm.manualEntryTo.format(\'DD-MMM-YYYY hh:mm a\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-12 mb-10"><label class="required">{{\'profile.reason\' | translate}}</label> <input id="manualreason" type="text" class="form-control" placeholder="{{\'profile.placeholderForReason\' | translate}}" ng-model="vm.reason"></div></div><div ng-if="vm.selectedType == \'missing\'"><div class="row mb-10"><div class="col-md-12"><label class="required">{{\'profile.selectADevice\' | translate}}</label><div id="device" isteven-multi-select="" input-model="vm.allocatedDeviceList" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier" selection-mode="single"></div></div></div><div class="row mb-10"><div class="col-md-12"><label class="required">{{\'profile.time\' | translate}}</label><div id="missingPunchTimePicker" date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.missingPunchTime" options="vm.missingPunchDatePickerOptions"><span class="date-position-left">{{vm.missingPunchTime.format(\'DD-MMM-YYYY hh:mm a\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row mb-10"><div class="col-md-12"><label class="mt-10 required">{{\'profile.reason\' | translate}}</label> <input type="text" id="missingreason" class="form-control" placeholder="{{\'profile.placeholderForReason\' | translate}}" ng-model="vm.reason"></div></div></div><div ng-if="vm.selectedType == \'fieldVisit\'"><div class="row mb-10"><div class="col-md-12 mb-10"><label class="mt-4 required">{{\'profile.selectDateRange\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.fieldVisitDatePicker.date" options="vm.fieldVisitDatePicker.options"><span class="date-position-left">{{vm.fieldVisitDatePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.fieldVisitDatePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><form novalidate=""><div class="row"><div class="col-md-12 mb-10"><label class="required">{{\'profile.selectTime\' | translate}}</label><div class="row"><div class="col-md-6 col-sm-12 col-xs-12"><div class="row time-picker-container"><div class="col-md-2 col-sm-4 col-xs-2 pt-42"><label class="modified-font">{{\'commonKeywords.from\' |translate}}</label></div><div class="col-md-10 col-sm-4 col-xs-2 pr-11" id="entryTime"><div ng-model="vm.fieldVisitEntryTime" uib-timepicker=""></div></div></div></div><div class="col-md-6 col-sm-12 col-xs-12 pr-0"><div class="row time-picker-container"><div class="col-md-2 col-sm-4 col-xs-2 pt-42"><label class="modified-font">{{\'commonKeywords.to\' | translate}}</label></div><div class="col-md-10 col-sm-4 col-xs-2" id="exitTime"><div ng-model="vm.fieldVisitExitTime" uib-timepicker=""></div></div></div></div></div></div></div></form><div class="row mb-10"><div class="col-md-12"><label class="required">{{\'profile.reason\' | translate}}</label> <textarea type="text" id="filedVisitReason" class="form-control" placeholder="{{\'profile.placeholderForReason\' | translate}}" ng-model="vm.reason"></textarea></div></div><div class="row mb-10"><div class="col-md-12"><label class="required">{{\'profile.area\' | translate}}</label> <input id="filedVisitArea" class="form-control" type="text" ng-model="vm.area"></div></div></div><div ng-show="vm.selectedType !== \'\'" class="footer mt-negative-5"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="saveManualEntryButton" ng-if="vm.selectedType == \'manual\'" type="button" class="btn btn-md btn-secondary" ng-click="vm.saveManualEntry()">{{vm.saveButtonText}}</button> <button id="saveMissingPunchButton" ng-if="vm.selectedType == \'missing\'" type="button" class="btn btn-md btn-secondary" ng-click="vm.saveMissingPunch()">{{vm.saveButtonText}}</button> <button id="saveFieldVisitButton" ng-if="vm.selectedType == \'fieldVisit\'" type="button" class="btn btn-md btn-secondary" ng-click="vm.saveFieldVisit()">{{vm.saveButtonText}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/apply/partials/exchangeLeavePartial.html','<div class="row"><div class="col-md-12"><label class="required" translate="">{{\'profile.availableDays\'}}</label></div><div class="col-md-12"><div id="departmentList" isteven-multi-select="" input-model="vm.availableExchangeLeaveDates" output-model="vm.selectedDayForExchangeLeave" button-label="readableDate" item-label="readableDate" tick-property="ticked" disable-property="disabled" selection-mode="single"></div></div></div><div class="row"><div class="col-md-12"><label class="required" translate="">{{\'profile.date\'}}</label></div><div class="col-md-12"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.leaveDate" options="{singleDatePicker:true,minDate:vm.minDate}"><span class="date-position-left">{{vm.leaveDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="row bottom"><div class="col-md-12"><label class="required" translate="">reason</label></div><div class="col-md-12"><textarea class="form-control" placeholder="{{\'profile.reasonOfCancellationPlaceholder\' | translate}}" ng-model="vm.reason"></textarea></div></div><div class="row"><div class="col-md-12"><label translate="">uploadFile</label></div><div class="col-md-12"><input type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,.docx,.doc,j.pg,.jpeg,.png\'"></div></div>');
$templateCache.put('app/pages/main/profile/leave/apply/partials/fullDayLeave.html','<div><div class="row"><div class="col-md-12"><label class="required" translate="">startAndEndDate</label></div><div class="col-md-12"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.datePicker.date" options="vm.datePicker.options"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><br><div class="row"><div class="col-md-12"><label class="required" translate="">reason</label></div><div class="col-md-12"><textarea class="form-control" row="2" placeholder="{{\'profile.reasonOfCancellationPlaceholder\' | translate}}" ng-model="vm.reason"></textarea></div></div><br><div class="row"><div class="col-md-12"><label translate="">uploadFile</label></div><div class="col-md-12"><input type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,.docx,.doc,j.pg,.jpeg,.png\'"></div></div></div>');
$templateCache.put('app/pages/main/profile/leave/apply/partials/halfDayLeave.html','<div ng-if="vm.selectedTypeId == 2"><div class="row"><div class="col-md-12"><label class="required" translate="">startDate</label></div><div class="col-md-12"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.leaveDate" options="{singleDatePicker:true,minDate:vm.minDate}"><span class="date-position-left">{{vm.leaveDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><br><div class="row"><div class="col-md-12"><label class="required" translate="">reason</label></div><div class="col-md-12"><textarea class="form-control" placeholder="{{\'profile.reasonOfCancellationPlaceholder\' | translate}}" ng-model="vm.reason"></textarea></div></div><br><div class="row mb-15"><div class="col-md-12"><label class="required" translate="">leaveHalf</label></div><div class="col-md-12"><div class="custom-select"><select ng-model="vm.selectedLeaveHalf"><option value="" translate="">selectALeaveHalf</option><option value="1" translate="">firstHalf</option><option value="2" translate="">secondHalf</option></select></div></div></div><div class="row"><div class="col-md-12"><label translate="">uploadFile</label></div><div class="col-md-12"><input type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,.docx,.doc,j.pg,.jpeg,.png\'"></div></div></div>');
$templateCache.put('app/pages/main/profile/pendingApprovals/leave/cancel/cancelLeaveLog.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="font-16 line-height-1_5">Do you want to cancel the leave application?</div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.cancelLeave()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/pendingApprovals/leave/edit/editLeaveModal.html','<div class="modal-content"><div class="modal-header"><h4 class="modal-title" translate="">profilePendingApprovals.editLeaveApplication</h4><hr class="mb-0"></div><div class="text-center mb-10" ng-show="!vm.isRemainingLeaveDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div class="row bottom"><div class="col-md-10 col-md-offset-1 p-all-20"><table class="table table-bordered" ng-if="vm.remainingLeavesList.length >0"><thead><tr><th class="table-header" translate="">category</th><th class="table-header" translate="">remainingLeave</th></tr></thead><tbody><tr ng-repeat="remainingLeaves in vm.remainingLeavesList"><td>{{remainingLeaves.leaveCategory.name}}</td><td>{{remainingLeaves.remainingLeaveCount}}</td></tr></tbody></table></div></div><div class="modal-body"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-3"><label translate="">type</label></div><div class="col-md-9"><select class="form-control" ng-model="vm.selectedTypeId"><option value="" translate="">selectAType</option><option value="1" translate="">full</option><option value="2" translate="">half</option></select></div></div><br><div ng-if="vm.selectedTypeId == 1"><div class="row"><div class="col-md-3"><label translate="">startAndEndDate</label></div><div class="col-md-9"><input date-range-picker="" class="form-control date-picker modified-input-box text-center" type="text" ng-model="vm.datePicker.date" options="vm.datePicker.options"></div></div><br><div class="row"><div class="col-md-3"><label translate="">reason</label></div><div class="col-md-9"><textarea class="form-control" placeholder="Write reason here" ng-model="vm.reason"></textarea></div></div><br><div class="row bottom"><div class="col-md-3"><label translate="">leaveCategory</label></div><div class="col-md-9"><select ng-model="vm.selectedCategory" class="form-control" ng-options="leaveCategory as leaveCategory.name for leaveCategory in vm.leaveCategoryList"><option value="" translate="">selectACategory</option></select></div></div><div class="row"><div class="col-md-3"><label translate="">uploadFile</label></div><div class="col-md-9"><input type="file" ngf-select="" ng-model="vm.file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,.docx,.doc,j.pg,.jpeg,.png\'"></div></div></div><div ng-if="vm.selectedTypeId == 2"><div class="row"><div class="col-md-3"><label translate="">startDate</label></div><div class="col-md-9"><input date-range-picker="" class="form-control date-picker modified-input-box text-center" single-date-picker="true" type="text" ng-model="vm.leaveDate" options="{singleDatePicker:true}"></div></div><br><div class="row"><div class="col-md-3"><label translate="">reason</label></div><div class="col-md-9"><textarea class="form-control" placeholder="Write reason here" ng-model="vm.reason"></textarea></div></div><br><div class="row"><div class="col-md-3"><label translate="">leaveCategory</label></div><div class="col-md-9"><select ng-model="vm.selectedCategory" ng-options="leaveCategory as leaveCategory.name for leaveCategory in vm.leaveCategoryList"><option value="" translate="">selectACategory</option></select></div></div><br><div class="row"><div class="col-md-3"><label translate="">leaveHalf</label></div><div class="col-md-9"><select ng-model="vm.selctedLeaveHalf"><option value="" translate="">selectALeaveHalf</option><option value="1" translate="">firstHalf</option><option value="2" translate="">secondHalf</option></select></div></div></div><br></div></div></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="vm.updateLeaveApplication()">Apply</button></div></div>');
$templateCache.put('app/pages/main/profile/pendingApprovals/manual/cancel/manualEntryCancelModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="font-16 line-height-1_5"><span ng-if="!vm.manualEntryType" translate="">profilePendingApprovals.cancelManualEntryConfirmation</span> <span ng-if="vm.manualEntryType == \'fieldVisit\'" translate="">profilePendingApprovals.cancelFieldVisitConfirmation</span></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.cancelManualEntryApplication()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/profile/pendingApprovals/manual/edit/editManualEntry.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">manualEntry</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row mt-negative-10"><div class="col-md-12"><div><label class="mt-10" translate="">selectAType</label><div class="custom-select"><select id="manualEntryTypeSelect" ng-model="vm.selectedType"><option value="manual" translate="">manualEntry</option><option value="missing" translate="">missingPunch</option><option value="field" translate="">fieldVisitText</option><option value="" disabled="" translate="">selectType</option></select></div></div><div class="mt-10" ng-if="vm.selectedType == \'manual\'"><div><label translate="">reason</label> <input type="text" id="manualreason" class="form-control" placeholder="{{\'commonKeywords.placeholderTextForReason\' | translate}}" ng-model="vm.reason"></div><div class="mt-10"><label translate="">entryTime</label><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.manualEntryFrom" options="vm.datePickerOptions"><span class="date-position-left">{{vm.manualEntryFrom.format(\'DD-MMM-YYYY hh:mm a\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label translate="">exitTime</label><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.manualEntryTo" options="vm.datePickerOptions"><span class="date-position-left">{{vm.manualEntryTo.format(\'DD-MMM-YYYY hh:mm a\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="mt-10" ng-if="vm.selectedType == \'missing\'"><div><label translate="">selectADevice</label><div id="editManualEntryDevice" isteven-multi-select="" input-model="vm.allocatedDeviceList" output-model="vm.selectedDevice" button-label="label" item-label="label" tick-property="ticked" output-properties="id identifier" selection-mode="single"></div></div><div class="mt-10"><label translate="">time</label><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.missingPunchTime" options="vm.datePickerOptions"><span class="date-position-left">{{vm.missingPunchTime.format(\'DD-MMM-YYYY hh:mm a\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label translate="">reason</label> <input type="text" id="missingreason" class="form-control" placeholder="{{\'commonKeywords.placeholderTextForReason\' | translate}}" ng-model="vm.reason"></div></div><div class="mt-10" ng-if="vm.selectedType == \'field\'"><div><label translate="">reason</label> <input type="text" id="filedVisitReason" class="form-control" placeholder="{{\'commonKeywords.placeholderTextForReason\' | translate}}" ng-model="vm.reason"></div><div class="mt-10"><label translate="">date</label><div date-range-picker="" class="form-control date-picker text-center position-relative" ng-model="vm.fieldVisitDate" options="vm.fieldVisitDatePickerOptions"><span class="date-position-left">{{vm.fieldVisitDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="row mt-10"><div class="col-md-12"><label>{{\'profile.selectTime\' | translate}}</label></div><div class="col-md-6"><div class="row"><div class="col-md-2 col-sm-4 col-xs-2 pt-42"><label>{{\'commonKeywords.from\' |translate}}</label></div><div class="col-md-10 col-sm-4 col-xs-2 pr-11" id="entryTime"><div ng-model="vm.fieldVisitEntryTime" uib-timepicker=""></div></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-2 col-sm-4 col-xs-2 pt-42"><label>{{\'commonKeywords.to\' | translate}}</label></div><div class="col-md-10 col-sm-4 col-xs-2" id="exitTime"><div ng-model="vm.fieldVisitExitTime" uib-timepicker=""></div></div></div></div></div></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button ng-if="vm.selectedType == \'manual\'" type="button" class="btn btn-md btn-secondary" ng-click="vm.saveManualEntry()">{{vm.saveButtonText}}</button> <button ng-if="vm.selectedType == \'missing\'" type="button" class="btn btn-md btn-secondary" ng-click="vm.saveMissingPunch()">{{vm.saveButtonText}}</button> <button ng-if="vm.selectedType == \'field\'" type="button" class="btn btn-md btn-secondary" ng-click="vm.saveFieldVisit()">{{vm.saveButtonText}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/addAddress/addAddress.action.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'address.addAddress\'|translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-sm-12"><div><label>{{\'type\'|translate}}</label><div class="custom-select"><select id="addressType" ng-model="type" placeholder="{{\'profile.placeholderForType\' | translate}}"><option value="">{{\'profile.pleaseSelect\' | translate}}</option><option value="1" ng-disabled="vm.isAddressTypeAlreadyProvided(1)">{{\'address.permanent\'|translate}}</option><option value="2" ng-disabled="vm.isAddressTypeAlreadyProvided(2)">{{\'address.present\'|translate}}</option><option value="3" ng-disabled="vm.isAddressTypeAlreadyProvided(3)">{{\'address.home\'|translate}}</option></select></div></div></div></div><div class="row mt-10"><div class="col-sm-12"><div><label>{{\'address.address\'|translate}}</label> <textarea id="address" class="form-control" ng-model="address" placeholder="{{\'profile.placeholderForAddress\' | translate}}"></textarea></div></div></div><div class="row mt-10"><div class="col-sm-12"><div><label>{{\'address.subDistrict\'|translate}}</label> <input id="thana" type="text" class="form-control" ng-model="thana" placeholder="{{\'profile.placeholderForThana\' | translate}}"></div></div></div><div class="row mt-10"><div class="col-sm-12"><div><label>{{\'address.district\'|translate}}</label> <input id="district" type="text" class="form-control" ng-model="district" placeholder="{{\'profile.placeholderForDistrict\' | translate}}"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.addAddress(address, thana, district, type)" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/allowLineManagerShiftManagement/allowLineManagerShiftManagement.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{vm.name}} <span translate="">{{\'profile.currently\'}}</span> <em class="color-prime" ng-if="vm.currentValue" translate="">{{\'profile.can\'}}</em> <em class="red-text" ng-if="!vm.currentValue" translate="">{{\'profile.canNot\'}}</em> {{vm.roleText}}.<br><span translate="">{{\'profile.areYouSureYouWantTo\'}}</span> <em class="red-text" ng-if="vm.currentValue" translate="">{{\'profile.revokeThisPrivilegeFrom\'}}</em> <em class="color-prime" ng-if="!vm.currentValue" translate="">{{\'profile.allowThisPrivilegeTo\'}}</em> {{vm.name}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p><span class="font-15" id="toggleRole" ng-if="(vm.roleText == \'HR Manager\' || vm.roleText == \'Line Manager\') && vm.currentValue"><br><p><span translate="">{{\'profile.revokingRoleHeadingPart1\'}}</span> {{vm.roleText}} <span translate="">{{\'profile.revokingRoleHeadingPart2\'}}</span> {{vm.roleText}}.</p></span><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.updateLineManagerRole(!vm.currentValue)" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/changeManagerOrAdminRole/changeManagerOrAdminRole.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{vm.name}} <span translate="">{{\'profile.currently\'}}</span> <em class="color-prime" ng-if="vm.currentValue" translate="">{{\'profile.is\'}}</em> <em class="red-text" ng-if="!vm.currentValue" translate="">{{\'profile.isNot\'}}</em> {{vm.roleText}}.<br><span translate="">{{\'profile.areYouSureYouWantTo\'}}</span> <em class="red-text" ng-if="vm.currentValue" translate="">{{\'profile.revokeThisPrivilegeFrom\'}}</em> <em class="color-prime" ng-if="!vm.currentValue" translate="">{{\'profile.allowThisPrivilegeTo\'}}</em> {{vm.name}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p><span class="font-15" id="toggleRole" ng-if="(vm.roleText == \'HR Manager\' || vm.roleText == \'Line Manager\') && vm.currentValue"><br><p><span translate="">{{\'profile.revokingRoleHeadingPart1\'}}</span> {{vm.roleText}} <span translate="">{{\'profile.revokingRoleHeadingPart2\'}}</span> {{vm.roleText}}.</p></span><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.updateRole(!vm.currentValue)" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/changeSiteAdminRole/changeSiteAdminRole.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{vm.name}} <span translate="">{{\'profile.currently\'}}</span> <em class="color-prime" ng-if="vm.currentValue" translate="">{{\'profile.is\'}}</em> <em class="red-text" ng-if="!vm.currentValue" translate="">{{\'profile.isNot\'}}</em> {{vm.roleText}}.<br><span translate="">{{\'profile.areYouSureYouWantTo\'}}</span> <em class="red-text" ng-if="vm.currentValue" translate="">{{\'profile.revokeThisPrivilegeFrom\'}}</em> <em class="color-prime" ng-if="!vm.currentValue" translate="">{{\'profile.allowThisPrivilegeTo\'}}</em> {{vm.name}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p><span class="font-15" id="toggleRole" ng-if="(vm.roleText == \'HR Manager\' || vm.roleText == \'Line Manager\') && vm.currentValue"><br><p><span translate="">{{\'profile.revokingRoleHeadingPart1\'}}</span> {{vm.roleText}} <span translate="">{{\'profile.revokingRoleHeadingPart2\'}}</span> {{vm.roleText}}.</p></span><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.updateRole(!vm.currentValue)" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/changeSiteManagerRole/changeSiteManagerRole.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{vm.name}} <span translate="">{{\'profile.currently\'}}</span> <em class="color-prime" ng-if="vm.currentValue" translate="">{{\'profile.is\'}}</em> <em class="red-text" ng-if="!vm.currentValue" translate="">{{\'profile.isNot\'}}</em> {{vm.roleText}}.<br><span translate="">{{\'profile.areYouSureYouWantTo\'}}</span> <em class="red-text" ng-if="vm.currentValue" translate="">{{\'profile.revokeThisPrivilegeFrom\'}}</em> <em class="color-prime" ng-if="!vm.currentValue" translate="">{{\'profile.allowThisPrivilegeTo\'}}</em> {{vm.name}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p><span class="font-15" id="toggleRole" ng-if="(vm.roleText == \'HR Manager\' || vm.roleText == \'Line Manager\') && vm.currentValue"><br><p><span translate="">{{\'profile.revokingRoleHeadingPart1\'}}</span> {{vm.roleText}} <span translate="">{{\'profile.revokingRoleHeadingPart2\'}}</span> {{vm.roleText}}.</p></span><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.updateRole(!vm.currentValue)" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/changeStatusModal/changeStatusModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'changeEmployeeStatus\'|translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'areYouSureYouWantToChangeStatusOf\'|translate}} {{vm.empName}} <span translate="">{{\'commonKeywords.smallTo\'}}</span> <span class="text-danger">{{vm.changeStatusToText}}{{\'commonKeywords.questionMark\' | translate}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.changeStatus()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/createTask/createTask.modal.html','<style>\n    textarea.form-control {\n        height: 106px;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'profile.addTask\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><div><label class="required" for="name">{{ \'tasks.creationModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'tasks.creationModal.nameInputPlaceholder\' | translate}}" ng-model="vm.create.name"></div><div class="mt-10"><label class="required" translate="">{{\'profile.startDate\'}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.create.startTime" options="vm.datePickerOptions" autocomplete="off"><span class="date-position-left">{{vm.create.startTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label class="required" translate="">{{\'profile.endDate\'}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.create.endTime" options="vm.datePickerOptions" autocomplete="off"><span class="date-position-left">{{vm.create.endTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="col-md-6"><div><label class="required" translate="">{{\'profile.project\'}}</label><div id="project" isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id name employees" selection-mode="single"></div></div><div class="mt-10"><label for="description" translate="">{{ \'tasks.creationModal.descriptionInputLabel\' }}</label> <textarea id="description" class="form-control" placeholder="{{ \'tasks.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.create.description"></textarea></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createTask()" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/deleteAddress/deleteAddress.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'profile.deleteAddressAcknowledgement\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button id="deleteAddressButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteAddress()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/documentUpload/documentUpload.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">documentUpload</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><form><div><label translate="">documentType</label><label class="text-danger">*</label><div class="custom-select"><select id="employeeDocumentType" ng-model="documentType"><option value="" translate="">{{\'profile.pleaseSelect\'}}</option><option value="1" translate="">employeeDocuments.ssc</option><option value="2" translate="">employeeDocuments.hsc</option><option value="3" translate="">employeeDocuments.bachelors</option><option value="4" translate="">employeeDocuments.passport</option><option value="5" translate="">employeeDocuments.nid</option><option value="6" translate="">employeeDocuments.cv</option></select></div></div><div class="mt-10"><label translate="">description</label><label class="text-danger">*</label> <textarea id="documentDescription" class="form-control" placeholder="{{\'profile.description\' | translate}}" ng-model="description"></textarea></div><div class="mt-10"><input id="employeeDocument" type="file" ngf-select="" ng-model="file" ngf-multiple="false" ngf-max-size="10MB" ngf-accept="\'.pdf,docx,doc\'"></div></form></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button id="uploadDocumentButton" class="btn btn-md btn-secondary" ng-click="vm.uploadDocument(description, documentType, file)" translate="">upload</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/includeInAttendanceReport/includeInAttendanceReport.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16">{{vm.user.name}} <span translate="">{{\'profile.isCurrently\'}}</span> <em class="color-prime" ng-if="vm.included" translate="">{{\'profile.includedInAttendanceReport\'}}</em> <em class="red-text" ng-if="!vm.included" translate="">{{\'profile.notIncludedInAttendanceReport\'}}</em><br><br><span translate="">{{\'profile.areYouSureYouWantTo\'}}</span> <em class="red-text" ng-if="vm.included">{{\'profile.exclude\' | translate}} {{vm.user.name}} <span class="red-text" translate="">{{\'commonKeywords.questionMark\'}}</span></em> <em class="color-prime" ng-if="!vm.included">{{\'profile.include\' | translate}} {{vm.user.name}} <span class="red-text" translate="">{{\'commonKeywords.questionMark\'}}</span></em></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.changeInclusionStatus(!vm.included)" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/myTasks/myTasks.modal.html','<style>\n    .btn-position{\n        position: absolute;\n        bottom: 20px;\n        right: 30px!important;\n    }\n    .filter:hover{\n        color: #209e91;\n    }\n</style><div class="modal-content"><div class="modal-body position-relative with-scroll"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'My tasks\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row mb-25"><div class="pull-right cursor-pointer" ng-click="vm.showFilters = !vm.showFilters"><span class="filter mr-20 upper-text">{{ \'commonKeywords.filterButton\' | translate}} <i class="fa fa-filter filter-width-20"></i> <i ng-if="!vm.showFilters" class="fa fa-chevron-down"></i> <i ng-if="vm.showFilters" class="fa fa-chevron-up"></i></span></div></div><div class="filter-div" ng-if="vm.showFilters"><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4 mt-4" ng-if="type == null"><label class="filter-label" translate="">date</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.datePicker.date" options="vm.datePicker.options" autocomplete="off"><span class="date-position-left">{{vm.datePicker.date.startDate.format(\'DD-MMM-YYYY\')}} {{\'commonKeywords.smallTo\' | translate}} {{vm.datePicker.date.endDate.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'profile.project\'}}</label><div isteven-multi-select="" input-model="vm.allProjects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label class="filter-label" translate="">{{\'profile.status\'}}</label><div isteven-multi-select="" input-model="vm.statusList" output-model="vm.selectedStatus" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><br><div class="row form-inline"><div class="form-group col-sm-4 col-xs-4 pull-right"><button type="button" class="btn btn-md-with-icon btn-primary btn-block" ng-click="vm.getAllTasks()"><i class="ion-search"></i>{{\'search\'|translate}}</button></div></div></div><div class="row"><div class="col-md-12"><div><div class="row mb-20"><div class="col-md-6"></div><div id="attendanceTableRowsPerPageDiv" class="col-md-4 text-right mt-10"><span id="attendanceTableRowsPerPageSpan"><strong translate="">{{\'commonKeywords.rowsPerPage\'}}</strong></span></div><div class="col-md-2"><div class="custom-select"><select ng-model="vm.perPage" ng-change="vm.getAllTasks()"><option value="10" ng-selected="vm.perPage==10" translate="">{{\'commonKeywords.ten\'}}</option><option value="20" ng-selected="vm.perPage==20" translate="">{{\'commonKeywords.twenty\'}}</option><option value="50" ng-selected="vm.perPage==50" translate="">{{\'commonKeywords.fifty\'}}</option><option value="100" ng-selected="vm.perPage==100" translate="">{{\'commonKeywords.hundred\'}}</option></select></div></div></div></div><div><div class="text-center mb-10" ng-show="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><div ng-if="vm.totalData <= 0 && vm.isDataLoaded"><p translate="">{{\'commonKeywords.noDataFoundWithGivenFilters\'}}</p></div><table ng-if="vm.isDataLoaded && vm.totalData > 0" class="table table-striped"><thead><tr><th class="table-id" translate="">{{\'commonKeywords.hash\'}}</th><th translate="">{{ \'tasks.tableHeader.name\' }}</th><th translate="">{{ \'tasks.tableHeader.project\' }}</th><th translate="">{{ \'tasks.tableHeader.startTime\' }}</th><th translate="">{{ \'tasks.tableHeader.deadline\' }}</th><th translate="">{{ \'tasks.tableHeader.description\' }}</th><th translate="">{{ \'tasks.tableHeader.status\' }}</th><th translate="">{{\'profile.updateStatus\'}}</th></tr></thead><tbody><tr ng-repeat="item in vm.allTasks" ng-if="item.status!=-1"><td class="text-left-important">{{$index+1}}</td><td class="text-left-important">{{item.name}}</td><td class="text-left-important">{{item.projectWorkName}}</td><td class="text-left-important">{{item.startTime | date : \'d MMM yyyy\'}}</td><td class="text-left-important">{{item.endTime | date : \'d MMM yyyy\'}}</td><td class="text-left-important">{{item.description}}</td><td class="text-left-important"><strong translate="">{{ vm.taskStatus[$index].status ? \'Done\' : \'Todo\' }}</strong></td><td class="text-left-important"><label class="custom-switch"><input ng-model="vm.taskStatus[$index].status" ng-change="vm.updateTaskStatus(item.id, vm.taskStatus[$index].status)" type="checkbox"> <span class="slider round"></span></label></td></tr></tbody></table><div class="text-center" ng-if="vm.totalData > 0"><nav aria-label="Page navigation"><ul class="pagination"><li class="page-item"><a class="page-link" ng-click="vm.getData(vm.perPage, 1)" translate="">{{\'commonKeywords.first\'}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.getData(vm.perPage, vm.pageNo-1 > 0? vm.pageNo-1 : 1)">&lt;</a></li><li ng-repeat="n in vm.pageButtons" ng-class="(vm.pageNo == n)? \'active\':\'\'"><a ng-click="vm.getData(vm.perPage, n)">{{n}}</a></li><li class="page-item"><a class="page-link" ng-click="vm.getData(vm.perPage, vm.pageNo+1 > vm.totalPages? vm.totalPages: vm.pageNo+1)">&gt;</a></li><li class="page-item"><a class="page-link" ng-click="vm.getData(vm.perPage, vm.totalPages)" translate="">{{\'commonKeywords.last\'}}</a></li></ul></nav></div><div class="text-center mt-10" ng-if="vm.totalData > 0"><p><strong><span translate="">{{\'commonKeywords.showingPage\'}}</span> {{vm.pageNo}} <span translate="">{{\'commonKeywords.outOf\'}}</span> {{vm.totalPages}} <span translate="">{{\'commonKeywords.pages\'}}</span></strong></p></div></div></div></div><div class="btn-position"><button type="button" class="btn btn-md btn-secondary" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/overtime/overtimeConfirmation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'areYouSureYouWantTo\'|translate}}<em class="red-text" ng-if="vm.overtimeStatus" translate="">{{\'profile.disallowOvertime\'}}</em> <em class="color-prime" ng-if="!vm.overtimeStatus" translate="">{{\'profile.allowOvertime\'}}</em> {{\'forTheEmployees\'|translate}} <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.changeOvertimeStatus()" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/rehireEmployee/RehireEmployee.action.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'employeeActions.rehireModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5" translate="">{{ \'employeeActions.rehireModal.confirmationText\' }}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.rehireEmployee()">{{vm.confirmBtnClicked ? \'Please wait..\' : \'Confirm\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/resignEmployee/ResignEmployee.action.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">employeeResignation</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div><label class="required" translate="">status</label><div class="custom-select"><select id="employeeStatus" ng-model="vm.employeeStatus" ng-options="item.id as item.name for item in vm.employeeStatusList" required=""><option value="" translate="">selectAType</option></select></div></div><div class="mt-10"><label translate="">remark</label> <textarea id="remark" class="form-control" ng-model="vm.statusRemark" placeholder="{{\'profile.placeholderForRemark\' | translate}}"></textarea></div><div class="mt-10"><label class="required" translate="">resignationDate</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.dateOfResignation" options="vm.datePickerOptions"><span class="date-position-left">{{vm.dateOfResignation.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md" ng-disabled="vm.confirmBtnClicked" ng-class="{\'btn-disable\': (vm.confirmBtnClicked), \'btn-secondary\': (!vm.confirmBtnClicked)}" ng-click="vm.resignEmployee()">{{vm.confirmBtnClicked ? \'Please wait..\' : \'Confirm\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/setCompanyAdmin/setCompanyAdmin.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-warning" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p>{{vm.user.name}} <span translate="">{{\'profile.isCurrently\'}}</span> <em class="color-prime" ng-if="vm.isCompanyAdmin" translate="">{{\'profile.isCompanyAdmin\'}}</em> <em class="red-text" ng-if="!vm.isCompanyAdmin" translate="">{{\'profile.notCompanyAdmin\'}}</em>.<br><br><span translate="">{{\'profile.areYouSureYouWantTo\'}}</span> <em class="red-text" ng-if="vm.isCompanyAdmin" translate="">{{\'profile.revokeCompanyAdminPrivilege\'}}</em> <em class="color-prime" ng-if="!vm.isCompanyAdmin" translate="">{{\'profile.allowCompanyAdminPrivilege\'}}</em> <span translate="">{{\'profile.of\'}}</span> {{vm.user.name}} <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.setCompanyAdmin(!vm.isCompanyAdmin)" translate="">{{\'commonKeywords.confirmButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/timeSheetEntry/timeSheetEntry.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'profile.timesheetEntry\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><label class="required">{{\'commonKeywords.task\' | translate}}</label><div id="task" isteven-multi-select="" input-model="vm.allTasks" output-model="vm.selectedTask" button-label="name" item-label="name" tick-property="ticked" output-properties="id name" selection-mode="single" search-property="name"></div></div><div class="col-md-6"><label class="required" for="description">{{\'profile.description\' | translate}}</label> <input type="text" id="description" class="form-control" placeholder="Enter description here" ng-model="vm.create.description"></div></div><div class="row mt-10"><div class="col-md-6"><label class="required">{{\'profile.startTime\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.create.startTime" options="vm.datePickerOptions"><span class="date-position-left">{{vm.create.startTime.format(\'DD-MMM-YYYY hh:mm A\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="col-md-6"><label class="required">{{\'profile.endTime\' |translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.create.endTime" options="vm.datePickerOptions"><span class="date-position-left">{{vm.create.endTime.format(\'DD-MMM-YYYY hh:mm A\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.enterTimeSheet()" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/document/delete/deleteModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p translate="">{{\'profile.deleteDocumentAcknowledgement\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.delete()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/education/createModal/create.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'educationHistory.createEducationHistory\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div><label class="required">{{\'educationHistory.degreeName\' | translate}}</label> <input id="historyName" class="form-control" placeholder="{{\'educationHistory.degreeName\' | translate}}" ng-model="vm.history.name"></div><div class="mt-10"><label class="required">{{\'educationHistory.institution\' | translate}}</label> <input id="historyInstitution" type="text" class="form-control" placeholder="{{\'educationHistory.institution\' | translate}}" ng-model="vm.history.institution"></div><div class="mt-10"><label class="required">{{\'educationHistory.board\' | translate}}</label> <input id="historyBoard" type="text" class="form-control" placeholder="{{\'educationHistory.board\' | translate}}" ng-model="vm.history.board"></div><div class="mt-10"><label class="required">{{\'educationHistory.year\' | translate}}</label> <input id="historyYear" type="text" class="form-control" placeholder="{{\'educationHistory.year\' | translate}}" ng-model="vm.history.year"></div><div class="mt-10"><label class="required">{{\'educationHistory.grade\' | translate}}</label> <input id="historyGrade" type="text" class="form-control" placeholder="{{\'educationHistory.grade\' | translate}}" ng-model="vm.history.grade"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createHistory()" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/education/deleteModal/delete.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'educationHistory.deleteConfirmation\'|translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteHistory()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/education/editModal/edit.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'educationHistory.editEducationHistory\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div><label>{{\'educationHistory.degreeName\' | translate}}</label> <input id="historyName" class="form-control" ng-model="vm.history.name"></div><div class="mt-10"><label>{{\'educationHistory.institution\' | translate}}</label> <input id="historyInstitution" type="text" class="form-control" ng-model="vm.history.institution"></div><div class="mt-10"><label>{{\'educationHistory.board\' | translate}}</label> <input id="historyBoard" type="text" class="form-control" ng-model="vm.history.board"></div><div class="mt-10"><label>{{\'educationHistory.year\' | translate}}</label> <input id="historyYear" type="text" class="form-control" ng-model="vm.history.year"></div><div class="mt-10"><label>{{\'educationHistory.grade\' | translate}}</label> <input id="historyGrade" type="text" class="form-control" ng-model="vm.history.grade"></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateHistory()" translate="">{{ \'commonKeywords.saveChangesButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/employment/createModal/create.modal.html','<style>\n    textarea.form-control {\n        height: 37px;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'employmentHistory.createEmploymentHistory\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><div><label class="required">{{\'employmentHistory.companyName\' | translate}}</label> <input id="companyName" class="form-control" placeholder="{{\'employmentHistory.companyName\'| translate}}" ng-model="vm.history.companyName"></div><div class="mt-10"><label class="required">{{\'startDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.history.startDateObject" options="vm.datePickerOptions"><span class="date-position-left">{{vm.history.startDateObject.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label class="required">{{\'department\' | translate}}</label> <input id="companyDepartment" type="text" class="form-control" placeholder="{{\'department\'| translate}}" ng-model="vm.history.department"></div><div class="mt-10"><label class="required">{{\'location\' | translate}}</label> <input id="companyLocation" type="text" class="form-control" placeholder="{{\'location\'| translate}}" ng-model="vm.history.companyLocation"></div></div><div class="col-md-6"><div><label class="required">{{\'employmentHistory.companyBusiness\' | translate}}</label> <input id="companyBusiness" type="text" class="form-control" placeholder="{{\'employmentHistory.companyBusiness\'| translate}}" ng-model="vm.history.companyBusiness"></div><div class="mt-10"><label class="required">{{\'endDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.history.endDateObject" options="vm.datePickerOptions"><span class="date-position-left">{{vm.history.endDateObject.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label class="required">{{\'designation\' | translate}}</label> <input id="companyDesignation" type="text" class="form-control" placeholder="{{\'designation\'| translate}}" ng-model="vm.history.designation"></div><div class="mt-10"><label>{{\'employmentHistory.responsibilities\' | translate}}</label> <textarea id="responsibilities" class="form-control" placeholder="{{\'employmentHistory.responsibilities\' | translate}}" ng-model="vm.history.responsibilities"></textarea></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createHistory()" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/employment/deleteModal/delete.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'deleteConfirmation\' | translate}}&nbsp;{{\'employmentHistory.employmentHistory\' | translate}} {{\'commonKeywords.questionMark\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.deleteHistory()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/employment/editModal/edit.modal.html','<style>\n    textarea.form-control {\n        height: 37px;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'employmentHistory.editEmploymentHistory\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-6"><div><label>{{\'employmentHistory.companyName\' | translate}}</label> <input id="historyCompanyName" class="form-control" ng-model="vm.history.companyName"></div><div class="mt-10"><label>{{\'startDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.history.startDateObject" options="vm.datePickerOptions"><span class="date-position-left">{{vm.history.startDateObject.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label>{{\'department\' | translate}}</label> <input id="historyDepartment" type="text" class="form-control" ng-model="vm.history.department"></div><div class="mt-10"><label>{{\'location\' | translate}}</label> <input type="text" id="companyLocation" class="form-control" ng-model="vm.history.companyLocation"></div></div><div class="col-md-6"><div><label>{{\'employmentHistory.companyBusiness\' | translate}}</label> <input id="companyBusiness" type="text" class="form-control" ng-model="vm.history.companyBusiness"></div><div class="mt-10"><label>{{\'endDate\' | translate}}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.history.endDateObject" options="vm.datePickerOptions"><span class="date-position-left">{{vm.history.endDateObject.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div><div class="mt-10"><label>{{\'designation\' | translate}}</label> <input id="historyDesignation" type="text" class="form-control" ng-model="vm.history.designation"></div><div class="mt-10"><label>{{\'employmentHistory.responsibilities\' | translate}}</label> <textarea id="historyResponsibilities" class="form-control" ng-model="vm.history.responsibilities"></textarea></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateHistory()" translate="">{{ \'commonKeywords.saveChangesButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePic.partial.html','<style>\n    .userpic a.change-userpic{\n        color:white;\n    }\n</style><div class="form-group row clearfix" ng-controller="ProfilePicCtrl as vm"><div><upgrade-banner code="2004"><div class="col-sm-12 text-center"><div class="userpic"><div class="userpic-wrapper"><img class="mr-0" ng-src="{{vm.imageSource()}}" ng-if="!vm.isEmployeeOnly" ng-click="vm.showProfilePictureUploadModal()"> <img class="mr-0 cursor-default" ng-src="{{vm.imageSource()}}" ng-if="vm.isEmployeeOnly"></div><i class="ion-ios-close-outline" ng-click="vm.openRemoveConfirmationModal()" ng-if="!vm.noPicture && !vm.isEmployeeOnly"></i> <a href="" class="change-userpic" ng-click="vm.showProfilePictureUploadModal()" ng-if="!vm.isEmployeeOnly" translate="">{{\'profile.changeProfilePicture\'}}</a></div></div></upgrade-banner></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/projectDedication/updateProjectDedicationModal/update.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span translate="">{{\'profile.updateProjectDedicationHeading\'}}</span></div><div class="modal-body"><div class="form-group"><label translate="">{{\'profile.dedicationPercentage\'}}</label> <input type="number" class="form-control" ng-model="vm.dedication" min="0"></div></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="vm.update()" translate="">{{\'profile.setPercentageButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button></div></div>');
$templateCache.put('app/pages/main/projectManagement/products/createProduct/createProductModal/createProductModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_3"><span translate="">{{\'projects.product.createProductModalStatement\'}}</span> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-primary" ng-click="$close()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/editProject/regular/editProject.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'projects.edit.panelTitle\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.editProjectForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><div class="form-group" tabindex="1" ng-class="{\'has-error\': vm.editProjectForm.projectName.$invalid && vm.editProjectForm.projectName.$touched}"><label class="required" translate="">{{"projects.create.projectNameInputLabel"}}</label> <input type="text" name="projectName" class="form-control" ng-model="vm.projectName" placeholder="{{\'projects.create.projectNameInputLabel\' | translate}}" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="2"><label class="required" translate="">{{\'projects.create.projectTypeInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.projectTypes" output-model="vm.selectedProjectType" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" show-add-model="true" new-input-method="vm.createProjectType" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Project Type...\', \'nothingSelected\' : \'Select Project Type\' }"></div></div></div><div class="col-md-6"><div class="form-group" tabindex="3"><label class="required" translate="">{{\'projects.create.kamInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name employeeOfficeId" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name/ID...\', \'nothingSelected\' : \'Select Employee\' }"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="4"><label class="required" translate="">{{\'projects.create.clientInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.clients" output-model="vm.selectedClient" button-label="name" item-label="name" tick-property="ticked" output-properties="id organisationType" search-property="name" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Select Client\' }"></div></div></div><div class="col-md-6"><div class="form-group"><label translate="">{{\'projects.create.organisationTypeInputLabel\'}}</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedClient[0].organisationType" readonly=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" tabindex="5"><label class="required" translate="">{{\'projects.create.productInputLabel\'}}</label><div isteven-multi-select="" input-model="vm.products" output-model="vm.selectedProduct" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Undo\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Select Product\' }"></div></div></div><div class="col-md-6"><div class="form-group" tabindex="6" ng-class="{\'has-error\': vm.editProjectForm.referenceCode.$invalid && vm.editProjectForm.referenceCode.$touched}"><label class="required" translate="">{{\'projects.create.referenceCodeInputLabel\'}}</label> <input type="text" name="referenceCode" class="form-control" ng-model="vm.referenceCode" placeholder="{{\'projects.create.referenceCodeInputLabel\' | translate}}" required=""></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{ \'projects.create.startDateInputLabel\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.startDatePicker.date" options="vm.startDatePicker.options"><span>{{vm.startDatePicker.date.format("DD MMM YYYY")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div><div class="col-md-6"><div class="form-group"><label class="required" translate="">{{ \'projects.create.dueDateInputLabel\' }}</label><div><div date-range-picker="" class="form-control appointment-date-picker" ng-model="vm.dueDatePicker.date" options="vm.dueDatePicker.options"><span>{{vm.dueDatePicker.date.format("DD MMM YYYY")}}</span> <span class="font-14">&nbsp;&nbsp;<i class="fa fa-calendar"></i></span></div></div></div></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.isInvalidForm() || vm.editProjectForm.$invalid || vm.isUpdating" ng-class="{\'btn-disable\' : vm.isInvalidForm() || vm.editProjectForm.$invalid || vm.isUpdating, \'btn-primary\' : !(vm.isInvalidForm() || vm.editProjectForm.$invalid || vm.isUpdating)}" ng-click="vm.submitForm()" translate=""><span ng-if="!vm.isUpdating" translate="">{{ \'commonKeywords.saveButton\' }}</span> <span ng-if="vm.isUpdating" translate="">{{ \'commonKeywords.pleaseWait\' }}</span></button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/projectManagement/projects/editProject/tdh/editProject.html','<style>\n    .scrollable-table {\n        max-height: 40vh;\n        overflow: auto;\n        position: relative;\n    }\n    .text-highlight{\n        color: #222222;\n        font-weight: 500;\n    }\n</style><div ba-panel="" ba-panel-title="Edit Project" ba-panel-class="with-scroll"><div class="row" ng-if="vm.isDataLoaded"><div class="col-md-12"><div class="row"><div class="col-md-6"><label for="name">{{ \'projects.editModal.nameInputLabel\' | translate}}</label> <input type="text" id="name" class="form-control" placeholder="{{\'projects.editModal.nameInputPlaceholder\' | translate}}" ng-model="vm.project.name"></div></div><div class="row"><div class="col-md-6 mt-15"><label>{{\'commonKeywords.startDate\' | translate}}</label><div class="form-group"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.project.startTime" options="{singleDatePicker:true,format:\'DD-MMM-YYYY\'}"><span class="date-position-left">{{vm.project.startTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div></div></div><div class="row"><div class="col-md-6"><label>{{\'commonKeywords.endDate\' | translate}}</label><div class="form-group"><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text" ng-model="vm.project.endTime" options="{singleDatePicker:true,format:\'DD-MMM-YYYY\'}"><span class="date-position-left">{{vm.project.endTime.format(\'DD-MMM-YYYY\')}}</span> <i class="fa fa-calendar calender-icon-position cursor-pointer"></i></div></div></div></div><div class="row"><div class="col-md-6"><label for="description">{{ \'projects.creationModal.descriptionInputLabel\' | translate}}</label> <textarea id="description" class="form-control" placeholder="{{ \'projects.creationModal.descriptionInputPlaceHolder\' | translate}}" ng-model="vm.project.description"></textarea></div></div><div class="row"><div class="col-md-6 mt-15"><label>{{\'projects.creationModal.addPeople\' | translate}}</label><div class="d-flex-gap-10"><div class="width-100" isteven-multi-select="" input-model="vm.employees" output-model="vm.employeeIdList" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name"></div><button type="button" class="btn btn-md btn-primary" ng-click="vm.addEmployeesToProject()" translate="">{{\'projects.editModal.addButton\'}}</button></div></div></div><div class="row"><div class="col-md-6 mt-15"><span class="font-14 color-22222 font-weight-500" translate="">{{\'commonKeywords.statusInactive\'}}</span> <label class="custom-switch ml-10 mt-12 mr-10"><input name="enabled" ng-model="vm.enabled" type="checkbox"><span class="slider round"></span></label> <span class="font-14 color-22222 font-weight-500" translate="">{{\'commonKeywords.statusActive\'}}</span></div></div><div class="row"><div class="col-md-1 mt-20"><button type="button" class="btn btn-md btn-primary" ng-click="vm.updateProjectDetails()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div><div class="row"><div class="col-md-12 mt-30"><p class="font-18 color-22222 font-weight-500" translate="">{{\'projects.editModal.peopleInTheProjectHeading\'}}</p><div class="horizontal-scroll scrollable-table" fixed-column-table="" fixed-columns="0"><table class="table borderless-table odd-row-strip"><thead><tr><th class="table-id text-center width-4" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left" translate="">{{\'projects.editModal.name\'}}</th><th class="text-center width-9" translate="">{{\'projects.editModal.action\'}}</th></tr></thead><tbody><tr ng-repeat="item in vm.project.employees" ng-if="item.status!=-1"><td class="text-center">{{$index+1}}</td><td class="text-left"><employee-picture-and-information name="item.name" picture-url="item.pictureUrl" department-name="" designation-name="" id="item.id" is-clickable="true"></employee-picture-and-information></td><td class="text-center"><button class="btn btn-sm-with-icon btn-danger" ng-click="vm.openConfirmationModal(item)"><i class="ion-android-remove-circle"></i> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.removeButton\'}}</span></button></td></tr></tbody></table></div></div></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center mb-10"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/shiftManagement/roster/advancedView/cellShiftChange/cellShiftChange.modal.html','<div class="modal-content"><div class="modal-header section-padding-bottom"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{ \'rosterSettings.cellShiftChangeModal.title\' | translate}}</h4></div><div class="modal-body section-padding-top"><div class="row"><div class="form-group form-group-margin" ng-if="vm.shiftList && vm.shiftList.length > 0"><label class="filter-label" translate="">{{ \'rosterSettings.editModal.shiftSelectLabel\' }}</label><div isteven-multi-select="" input-model="vm.shiftList" output-model="vm.selectedShifts" button-label="displayName" item-label="displayName" tick-property="ticked" output-properties="id" search-property="displayName" selection-mode="single"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="vm.changeCell()" translate="">{{ \'rosterSettings.cellShiftChangeModal.submitButton\' }}</button></div></div>');
$templateCache.put('app/pages/main/shiftManagement/roster/advancedView/repeat/repeat.modal.html','<style>\n    .padding-right-0{\n        padding-right: 0px;\n    }\n    .padding-all-0{\n        padding: 0px;\n    }\n    .date-picker-modification{\n        width: 100%;\n        font-size: 12px;\n        height: 34px;\n        text-align: center;\n        padding:0px\n    }\n\n</style><body><div class="modal-content"><div class="modal-header section-padding-bottom"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{ \'rosterSettings.repeatModal.title\' | translate}}<hr></h4></div><div class="modal-body section-padding-top"><div class="row"><div class="form-group form-group-margin" ng-if="vm.shiftGroups && vm.shiftGroups.length > 0"><label class="filter-label" translate="">{{ \'rosterSettings.repeatModal.shiftGroupSelectLabel\'}}</label><div isteven-multi-select="" input-model="vm.shiftGroups" output-model="vm.selectedShiftGroups" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single"></div></div></div><br><div class="row col-sm-12 bottom padding-right-0"><div class="col-sm-8"><label class="mt-10" translate="">{{ \'rosterSettings.repeatModal.copyLabel\'}}</label></div><div class="col-sm-4 padding-all-0"><input date-range-picker="" class="form-control date-picker date-picker-modification" type="text" ng-model="vm.copyDatePicker.date" options="vm.copyDatePicker.options" min="vm.minDate" max="vm.maxDate"></div></div><br><div class="row col-sm-12 bottom padding-right-0"><div class="col-sm-8"><label class="mt-10" translate="">{{ \'rosterSettings.repeatModal.pasteLabel\'}}</label></div><div class="col-sm-4 padding-all-0"><input date-range-picker="" class="form-control date-picker date-picker-modification" type="text" ng-model="vm.pasteDatePicker.date" options="vm.pasteDatePicker.options" min="vm.minDate" max="vm.maxDate"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-md btn-primary" ng-click="vm.repeatAndClose()" translate="">{{ \'rosterSettings.repeatModal.submitButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/shiftManagement/roster/basicView/editBasic/editBasicRoster.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'rosterSettings.editModal.title\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><div class="font-16 line-height-1_5"><span><i>{{ \'rosterSettings.editModal.warningText\' | translate }}</i></span></div></div></div><br><div class="row"><div class="col-md-12" ng-if="vm.shiftList && vm.shiftList.length > 0"><label class="filter-label" translate="">{{ \'rosterSettings.editModal.shiftSelectLabel\' }}</label><div isteven-multi-select="" input-model="vm.shiftList" output-model="vm.selectedShifts" button-label="displayName" item-label="displayName" tick-property="ticked" output-properties="id" search-property="displayName" selection-mode="single"></div></div></div><br><div class="row"><div class="col-md-12"><label class="filter-label" translate="">{{ \'rosterSettings.editModal.offdaySelectLabel\' }}</label><div isteven-multi-select="" input-model="vm.days" output-model="vm.selectedOffdays" button-label="name" item-label="name" tick-property="ticked" output-properties="value" search-property="name"></div></div></div><br><div class="row"><div class="col-md-12"><div><label class="filter-label" translate="">{{ \'rosterSettings.editModal.effectiveDateInputLabel\' }}</label><div date-range-picker="" class="form-control date-picker text-center position-relative cursor-text d-block" ng-model="vm.effectiveDatePicker.date" options="vm.effectiveDatePicker.options"><span class="date-position-left">{{vm.effectiveDatePicker.date.format("D MMM YYYY")}}</span> <i class="fa fa-calendar calender-icon-position"></i></div></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateBasicRoster()" ng-disabled="vm.isEditing"><span ng-if="!vm.isEditing">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isEditing">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/partials/ListEmployeeFeed/listEmployeeFeed.html','<style>\n    .mostly-present .message-footer{\n        color: #555555;\n        font-size: 11px;\n    }\n    .mostly-present .feed-message .message-icon > img{\n        border-radius: 30px;\n        width: 70%;\n        height: 70%;\n    }\n    .mostly-present .feed-message .text-block{\n        padding: 3px 20px 0px 0px!important;\n    }\n    .mostly-present .feed-message{\n        padding: 10px;\n    }\n    .mostly-present .feed-message .text-block.text-message{\n        min-height: 0px;\n    }\n</style><div class="row mostly-present"><div class="feed-message animate-if pl-0-important border-color-light" ng-repeat="feed in vm.allEmployeeData" ui-sref="profile({employeeId: feed.employeeId, scrollTo: \'attendance\'})"><div ng-if="!isAdmin"><div ng-if="isDataLoaded"><div class="message-icon"><img class="photo-icon" ng-if="feed.pictureUrl" ng-src="{{feed.pictureUrl}}"> <img class="photo-icon" ng-if="feed.pictureUrl == null || feed.pictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="text-block text-message mt-10"><div class=""><span class="font-14 mb-5 clickable-profile">{{feed.employeeName }}</span></div><div class="d-flex-space-between-wrap mt-5"><div class="message-footer"><div ng-if="type===\'most-on-time\'">{{feed.totalPresent}} Days On Time Out Of {{feed.totalExpected}} Days</div><div ng-if="type===\'most-present\'"><span>Present This Month:</span><b>{{feed.totalPresent}} Days Out Of {{feed.totalExpected}} Days</b></div></div></div></div></div><div class="text-center mt-10" ng-show="!isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div ng-if="!!isAdmin"><div ng-if="isDataLoaded"><div class="message-icon"><img class="photo-icon" ng-if="feed.pictureUrl" ng-src="{{feed.pictureUrl}}"> <img class="photo-icon" ng-if="feed.pictureUrl == null || feed.pictureUrl == \'\'" ng-src="assets/img/theme/no-photo.png"></div><div class="text-block text-message"><div class="d-flex-space-between"><div class="font-14 mb-5 clickable-profile ml-negative-5">{{feed.employeeName }}</div><div ng-if="type===\'most-present\'"><span class="color-555555">Present This Month:</span><b>{{feed.totalPresent}} Days Out Of {{feed.totalExpected}} Days</b></div></div><div><span class="font-weight-400 ml-negative-5">{{feed.siteLocation}}</span></div></div></div><div class="text-center mt-10" ng-show="!isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/partials/TopActiveSites/topActiveSites.html','<style>\n    .message-footer{\n        color: #555555;\n        font-size: 11px;\n        font-weight: 500;\n    }\n</style><div class="row"><div class="col-md-12"><div class="feed-message animate-if border-color-light" ng-if="isDataLoaded" ng-repeat="site in allSitesData"><div class="d-flex-space-between"><div><div class="font-14 color-22222 font-weight-600 mb-3">{{site.siteName }}</div><div class="author message-footer">Site Manager: <span class="color-22222">{{site.siteManagerName}}</span></div></div><div class="font-14">Attendance: {{site.present}}/{{site.expectedEmployees}}(<span class="color-22222 font-weight-500">{{site.percentage | number:2}}%</span>)</div></div></div><div class="text-center mt-10" ng-show="!isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/partials/barChart/siteBarChartForManager.html','<style>\n    .attendance-chart{\n        overflow-y: auto;\n        /*height: 700px*/\n    }\n    .attendance-chart .panel-body{\n        padding: 10px 22px!important;\n    }\n    .admin-chart{\n        height: 305px !important;\n    }\n    .content-middle{\n        height: 100%;\n        justify-content: center;\n        display: flex;\n        align-items: center;\n    }\n</style><div class="position-relative"><upgrade-banner code="4022"><div class="attendance-chart" ng-controller="SiteBarChartForManagerCtrl as vm"><div ba-panel="" ba-panel-title="Sites" ba-panel-class="semi-medium-panel with-scroll" class="position-relative"><div class="d-flex-space-between" ng-if="vm.isDataReady"><i class="ion-chevron-left cursor-pointer padding-all-10" ng-click="vm.handelPaginatedData(\'prev\')"></i><div id="zoomAxisChart" class="admin-chart" ng-if="vm.isDataReady"></div><i class="ion-chevron-right cursor-pointer padding-all-10" ng-click="vm.handelPaginatedData(\'next\')"></i><br><br></div><div class="row text-center" ng-if="vm.showSpinner"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div class="content-middle text-center" ng-if="!response.siteDateAttendances.length"><div class="text-center text-bold">{{"commonKeywords.dataNotFound"|translate}}</div></div></div><div class="d-flex-space-between site-management-legend-position animated zoomIn"><div class="d-flex-gap-20"><div class="d-flex-gap-10 align-center"><div class="legend-expected"></div><div><span class="color-22222 font-weight-400" translate="">{{\'siteManagement.expectedAttendance\'}}</span></div></div><div class="d-flex-gap-10 align-center"><div class="legend-actual"></div><div><span class="color-22222 font-weight-400" translate="">{{\'siteManagement.actualAttendance\'}}</span></div></div></div></div></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/partials/barChart/siteBarIndividualSiteChart.html','<style>\n    .attendance-chart{\n        overflow-y: auto;\n        /*height: 700px*/\n    }\n    .attendance-chart .panel-body{\n        padding: 10px 22px!important;\n    }\n    .admin-chart{\n        height: 305px !important;\n    }\n</style><div class="position-relative"><upgrade-banner code="4022"><div class="attendance-chart" ng-controller="SiteBarIndividualSiteChartCtrl as vm"><div ba-panel="" ba-panel-title="Sites" ba-panel-class="semi-medium-panel with-scroll"><div class="d-flex-space-between" ng-if="vm.isDataReady"><i class="ion-chevron-left cursor-pointer padding-all-10" ng-click="vm.handelPaginatedData(\'prev\')"></i><div id="zoomAxisChart" class="admin-chart" ng-if="vm.isDataReady"></div><i class="ion-chevron-right cursor-pointer padding-all-10" ng-click="vm.handelPaginatedData(\'next\')"></i><br><br></div><div class="row text-center" ng-if="!vm.isDataReady"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="d-flex-space-between site-management-legend-position animated zoomIn"><div class="d-flex-gap-20"><div class="d-flex-gap-10 align-center"><div class="legend-expected"></div><div><span class="color-22222 font-weight-400" translate="">{{\'siteManagement.expectedAttendance\'}}</span></div></div><div class="d-flex-gap-10 align-center"><div class="legend-actual"></div><div><span class="color-22222 font-weight-400" translate="">{{\'siteManagement.actualAttendance\'}}</span></div></div></div></div></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/partials/barChart/siteBarSiteChart.html','<style>\n    .attendance-chart{\n        overflow-y: auto;\n        /*height: 700px*/\n    }\n    .attendance-chart .panel-body{\n        padding: 10px 22px!important;\n    }\n    .admin-chart{\n        height: 305px !important;\n    }\n\n</style><div class="position-relative"><upgrade-banner code="4022"><div class="attendance-chart" ng-controller="SiteBarChartCtrl as vm"><div ba-panel="" ba-panel-title="Sites" ba-panel-class="semi-medium-panel with-scroll"><div class="d-flex-space-between" ng-if="vm.isDataReady"><i class="ion-chevron-left cursor-pointer padding-all-10" ng-click="vm.handelPaginatedData(\'prev\')"></i><div id="zoomAxisChart" class="admin-chart" ng-if="vm.isDataReady"></div><i class="ion-chevron-right cursor-pointer padding-all-10" ng-click="vm.handelPaginatedData(\'next\')"></i><br><br></div><div class="row text-center" ng-if="!vm.isDataReady"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="d-flex-space-between site-management-legend-position animated zoomIn"><div class="d-flex-gap-20"><div class="d-flex-gap-10 align-center"><div class="legend-expected"></div><div><span class="color-22222 font-weight-400" translate="">{{\'siteManagement.expectedAttendance\'}}</span></div></div><div class="d-flex-gap-10 align-center"><div class="legend-actual"></div><div><span class="color-22222 font-weight-400" translate="">{{\'siteManagement.actualAttendance\'}}</span></div></div></div></div></div></upgrade-banner></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementDashboard/partials/pieChart/siteManagementPieChart.html','<style>\n    .pie-charts-padding .panel-body{\n        padding-top: 13px!important;\n    }\n</style><div class="row pie-charts pie-charts-padding" ng-controller="siteManagementPieChartCtrl as vm"><div class="pie-chart-item-container" ng-repeat="chart in easypiecharts.charts" ng-if="hasPermission(\'1001\')"><div ba-panel=""><div class="pie-chart-item"><div easypiechart="" options="chart.options" percent="chart.percent" class="chart"><span class="percent"></span></div><div class="description"><div>{{ chart.description | translate }}</div><div class="description-stats">{{ chart.stats }}</div></div></div></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementReports/siteAttendanceReport/entryImage/entryExitImage.modal.html','<style>\n    img{\n        object-fit: contain!important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><b ng-if="vm.imageCategory==\'entry\'" class="text-uppercase location-header" translate="">Entry Image</b> <b ng-if="vm.imageCategory==\'exit\'" class="text-uppercase location-header" translate="">Exit Image</b> <button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><img ng-if="vm.imageCategory==\'entry\'" width="100%" height="500" src="{{vm.entryImageUrl}}"> <img ng-if="vm.imageCategory == \'exit\'" width="100%" height="500" src="{{vm.exitImageUrl}}"></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementReports/siteAttendanceReport/location/location.modal.html','<style>\n    .location-header {\n        font-size: 18px !important;\n        font-weight: 600 !important;\n        color: var(--color-secondary) !important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><p class="text-uppercase location-header" translate="">{{vm.siteInfo.siteName}}</p><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><iframe width="100%" height="500" style="border:0" loading="lazy" allowfullscreen="" src="{{vm.mapUrl}}"></iframe></div></div></div>');
$templateCache.put('app/pages/main/siteManagement/siteManagementReports/siteSummaryReport/location/location.modal.html','<style>\n    .location-header{\n       font-size: 18px!important;\n        font-weight: 600!important;\n        color: var(--color-secondary) !important;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><p class="text-uppercase location-header" translate="">{{vm.siteInfo.location}}</p><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><iframe width="100%" height="500" style="border:0" loading="lazy" allowfullscreen="" src="{{vm.mapUrl}}"></iframe></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkIn/checkIn.html','<div ng-controller="CheckInCtrl as vm"><div ba-panel="" ba-panel-title="Check In" ba-panel-class="with-scroll panel-full-screen"><div class="row"><div class="col-md-12"><div class="btn-group special width-100" role="group" aria-label="First group"><button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'preRegisteredAppointment\'}" ng-click="vm.switchTab(\'preRegisteredAppointment\')" translate="">{{\'visitorManagement.reception.checkIn.preRegisteredAppointment\'}}</button> <button type="button" class="btn btn-style dont-wrap-text border-radius-0" ng-class="{\'selected-table-toggle-button\': vm.selectedTab == \'newAppointment\' }" ng-click="vm.switchTab(\'newAppointment\')" translate="">{{\'visitorManagement.reception.checkIn.newAppointment\'}}</button></div></div></div><div class="row mt-20" ng-if="vm.selectedTab === \'preRegisteredAppointment\' && vm.pageState === \'showVisitorList\'"><div class="col-md-12"><div class="form-group has-feedback has-search"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.getFilteredVisitorList()" ng-keyup="vm.getAllOnEmptySearchKeyword()" placeholder="{{\'visitorManagement.reception.checkIn.searchInputPlaceholder\' | translate}}"></div></div></div><div class="row" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div class="row mt-20" ng-if="vm.selectedTab === \'preRegisteredAppointment\' && vm.isDataLoaded && vm.pageState === \'showVisitorList\'"><div class="col-md-12"><table class="table report-table"><tbody><tr ng-repeat-start="visitor in vm.visitors"><td><span class="text-primary">{{\'visitorManagement.reception.checkIn.visitorListTable.entry\' | translate}} {{ visitor.entryTime | date: "hh:mm a"}}</span></td><td><span class="text-danger">{{\'visitorManagement.reception.checkIn.visitorListTable.exit\' | translate}} {{ visitor.exitTime | date: "hh:mm a"}}</span></td></tr><tr ng-repeat-end="" class="clickable-row" ng-click="vm.selectVisitorForCheckingIn(visitor)"><td><div class="info-with-avatar"><employee-picture-and-information name="visitor.visitorName + \' (Visitor)\'" picture-url="visitor.visitorPictureUrl" department-name="" designation-name="visitor.visitorOrganisationName" is-clickable="false"></employee-picture-and-information></div></td><td><div class="info-with-avatar"><employee-picture-and-information name="visitor.hostName + \' (Host)\'" picture-url="visitor.hostPictureUrl" department-name="visitor.hostDepartmentName" designation-name="visitor.hostDesignationName" is-clickable="true" id="visitor.hostId"></employee-picture-and-information></div></td></tr></tbody></table></div><pagination-directive ng-if="vm.isDataLoaded" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getVisitorsOfToday" not-found-text="\'No data available\'"></pagination-directive></div><div class="row mt-20" ng-if="vm.selectedTab === \'preRegisteredAppointment\' && vm.pageState === \'showAppointmentInfo\'"><div class="col-md-12" include-with-scope="app/pages/main/visitorManagement/reception/partials/checkIn/preRegisteredVisitorInfo.html"></div></div><div class="row mt-20" ng-if="vm.pageState === \'assignCardToVisitor\'"><div class="col-md-12" include-with-scope="app/pages/main/visitorManagement/reception/partials/checkIn/visitorCardAssignment.html"></div></div><div class="row mt-20" ng-if="vm.selectedTab === \'newAppointment\' && vm.pageState === \'inputAppointmentInfo\'"><div class="col-md-12" include-with-scope="app/pages/main/visitorManagement/reception/partials/checkIn/newAppointment.html"></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkIn/newAppointment.html','<script type="text/ng-template" id="mobileNumberSuggestions.html"><a> <div class="flex-container text-left width-100"> <div class="with-round-bg mb-0"> <img ng-if="match.model.pictureUrl != null" ng-src="{{match.model.pictureUrl}}"> <img ng-if="match.model.pictureUrl == null" src="../assets/img/theme/no-avatar.png"> </div> <div class="profile-info"> <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span> </div> <div class="ml-7 pt-10" ng-if="match.model.status == 2"> <i class="fa fa fa-ban font-20 text-danger"></i> </div> </div> </a></script><div ng-if="vm.isDataLoaded"><form name="vm.createAppointmentForm" novalidate="" autocomplete="disabled"><div class="row"><div class="col-md-12"><p class="text-center mb-20 color-22222 font-16">{{ \'visitorManagement.createAppointment.visitorInformationEntry\' | translate }}</p></div></div><div class="row"><div class="col-md-12"><div class="form-group mb-10"><div class="flex-container text-left width-100"><div class="with-round-bg mb-0"><img ng-if="!vm.visitor.pictureUrl" src="../assets/img/theme/no-avatar.png"> <img ng-if="vm.visitor.pictureUrl" src="{{vm.visitor.pictureUrl}}"></div><div class="profile-info"><a class="link-btn" href="" ng-click="vm.openPhotoCaptureModal()" target="_self"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.uploadOrTakePhoto\' }}</span></a></div></div></div></div></div><div class="row mb-20"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createAppointmentForm.visitorMobile.$invalid && vm.createAppointmentForm.visitorMobile.$touched}"><input type="text" autocomplete="off" name="visitorMobile" class="form-control" ng-model="vm.visitor.mobile" placeholder="Mobile Number" uib-typeahead="visitor.mobile as visitor.name for visitor in vm.existingVisitors | filter:{mobile:$viewValue}" typeahead-template-url="mobileNumberSuggestions.html" typeahead-on-select="vm.setVisitorInputs($item)" tabindex="1" required=""></div><div class="custom-select mb-15" ng-class="{\'has-error\': vm.createAppointmentForm.accessArea.$invalid && vm.createAppointmentForm.accessArea.$touched}"><select name="accessArea" ng-model="vm.selectedAccessAreaId" ng-options="item.id as item.name for item in vm.accessAreas" tabindex="3" required=""><option value="" class="placeholder" disabled="" translate="">{{\'visitorManagement.reception.checkIn.newAppointmentForm.selectAccessAreaLabel\'}}</option></select></div><div class="form-group"><input type="text" class="form-control" ng-model="vm.visitor.organisationName" tabindex="5" placeholder="Organisation Name"></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createAppointmentForm.visitorName.$invalid && vm.createAppointmentForm.visitorName.$touched}"><input type="text" class="form-control" name="visitorName" ng-model="vm.visitor.name" placeholder="Visitor Name" tabindex="2" required=""></div><div class="custom-select mb-15" ng-class="{\'has-error\': vm.createAppointmentForm.visitorCategory.$invalid && vm.createAppointmentForm.visitorCategory.$touched}"><select name="visitorCategory" ng-model="vm.visitor.categoryId" ng-options="item.id as item.name for item in vm.visitorCategories" tabindex="4" required=""><option value="" class="placeholder" disabled="" translate="">{{\'visitorManagement.createAppointment.selectCategory\'}}</option></select></div><div class="custom-select mb-15" ng-class="{\'has-error\': vm.createAppointmentForm.visitPurpose.$invalid && vm.createAppointmentForm.visitPurpose.$touched}"><select name="visitPurpose" ng-model="vm.selectedVisitPurposeId" ng-options="item.id as item.text for item in vm.visitPurposes" tabindex="6" required=""><option value="" class="placeholder" disabled="" translate="">{{\'visitorManagement.reception.checkIn.newAppointmentForm.selectVisitPurposeLabel\'}}</option></select></div></div></div><div class="row"><div class="col-md-12"><p class="text-center mb-20 font-16 color-22222">{{ \'visitorManagement.reception.checkIn.newAppointmentForm.selectHostLabel\' | translate }}</p></div></div><div class="row"><div class="col-md-12"><div class="form-group"><div class=""><employee-type-ahead-search select-method="vm.searchByEmployeeId" keyword="vm.searchKeyword" show-label="false" is-required="false" selected-employee="vm.selectedHost"></employee-type-ahead-search><input type="text" name="selectedHost" ng-show="false" ng-model="vm.searchKeyword" required=""></div></div></div></div><div class="row"><div class="col-md-12"><p class="text-center mb-20 font-16 color-22222">{{ \'visitorManagement.reception.checkIn.questions.title\' | translate}}</p></div></div><div class="row"><div class="col-md-12"><div class="flex-container"><div class="ml-8"><label class="text-normal checkbox-container" for="check-all"><input type="checkbox" id="check-all" ng-model="vm.checkAllQuestions" ng-click="vm.toggleAllCheckboxes()"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="check-all" class="text-normal font-13">{{ \'visitorManagement.reception.checkIn.questions.checkAll\' | translate }}</label></div></div></div><div><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tr><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-0"><input type="checkbox" id="question-0" ng-model="vm.questions[0].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-0" class="text-normal font-13">{{ vm.questions[0].label }}</label></div></div></div></td><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-1"><input type="checkbox" id="question-1" ng-model="vm.questions[1].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-1" class="text-normal font-13">{{ vm.questions[1].label }}</label></div></div></div></td></tr><tr><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-2"><input type="checkbox" id="question-2" ng-model="vm.questions[2].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-2" class="text-normal font-13">{{ vm.questions[2].label }}</label></div></div></div></td><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-3"><input type="checkbox" id="question-3" ng-model="vm.questions[3].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-3" class="text-normal font-13">{{ vm.questions[3].label }}</label></div></div></div></td></tr></table></div></div></div><div class="row mt-35"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon btn-secondary pull-right" ng-disabled="vm.createAppointmentForm.$invalid" ng-class="{\'btn-disable\' : vm.createAppointmentForm.$invalid, \'btn-secondary\' : !vm.createAppointmentForm.$invalid}" ng-click="vm.goToVisitorItemPage()"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.nextButton\' }}</span> <i class="fa fa-angle-double-right"></i></button></div></div></form></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkIn/preRegisteredVisitorInfo.html','<div class="row"><div class="col-md-12"><p class="text-center mb-20 font-16 color-22222" translate="">{{ \'visitorManagement.myVisitorProfile.visitorInfoTitle\' }}</p></div></div><div class="row"><div class="col-md-12"><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tbody><tr class="text-center th-bg"><td class="border-0"><div class="info-with-avatar"><employee-picture-and-information name="vm.selectedVisitor.visitorName + \' (Visitor)\'" picture-url="vm.selectedVisitor.visitorPictureUrl" department-name="" designation-name="vm.selectedVisitor.visitorOrganisationName" is-clickable="false"></employee-picture-and-information></div></td><td class="border-0"><div class="info-with-avatar"><employee-picture-and-information name="vm.selectedVisitor.hostName + \' (Host)\'" picture-url="vm.selectedVisitor.hostPictureUrl" department-name="vm.selectedVisitor.hostDepartmentName" designation-name="vm.selectedVisitor.hostDesignationName" is-clickable="false"></employee-picture-and-information></div></td></tr><tr class="text-left"><td><span>{{\'visitorManagement.reception.checkIn.visitorInfo.mobileNumberLabel\' | translate }}{{vm.selectedVisitor.visitorMobile}}</span></td><td><span>{{\'visitorManagement.reception.checkIn.visitorInfo.categoryNameLabel\' | translate }}{{vm.selectedVisitor.visitorCategoryName}}</span></td></tr><tr class="text-left"><td><span>{{ \'visitorManagement.reception.checkIn.visitorInfo.accessAreaLabel\' | translate }}{{vm.selectedVisitor.accessAreaName}}</span></td><td><span>{{ \'visitorManagement.reception.checkIn.visitorInfo.reasonLabel\' | translate }}{{vm.selectedVisitor.visitPurposeText}}</span></td></tr><tr class="text-left"><td><span>{{ \'visitorManagement.reception.checkIn.visitorInfo.organisationNameLabel\' | translate }}{{vm.selectedVisitor.visitorOrganisationName}}</span></td><td><div class="d-flex-space-between"><span class="text-primary">{{ \'visitorManagement.reception.checkIn.visitorInfo.entryTimeLabel\' | translate }}{{vm.selectedVisitor.entryTime | date:\'hh:mm a\'}}</span> <span class="text-danger">{{ \'visitorManagement.reception.checkIn.visitorInfo.exitTimeLabel\' | translate }}{{vm.selectedVisitor.exitTime | date:\'hh:mm a\'}}</span></div></td></tr></tbody></table></div></div><div class="row mt-35"><div class="col-md-12"><p class="text-center mb-20 font-16 color-22222" translate="">{{ \'visitorManagement.reception.checkIn.questions.title\' }}</p></div></div><div class="row"><div class="col-md-12"><div class="flex-container"><div><label class="text-normal checkbox-container" for="check-all"><input type="checkbox" id="check-all" ng-model="vm.checkAllQuestions" ng-click="vm.toggleAllCheckboxes()"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="check-all" class="text-normal font-13">{{ \'visitorManagement.reception.checkIn.questions.checkAll\' | translate }}</label></div></div></div><div><table class="table table-bordered"><colgroup><col class="width-50"><col class="width-50"></colgroup><tr><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-0"><input type="checkbox" id="question-0" ng-model="vm.questions[0].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-0" class="text-normal font-13">{{ vm.questions[0].label }}</label></div></div></div></td><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-1"><input type="checkbox" id="question-1" ng-model="vm.questions[1].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-1" class="text-normal font-13">{{ vm.questions[1].label }}</label></div></div></div></td></tr><tr><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-2"><input type="checkbox" id="question-2" ng-model="vm.questions[2].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-2" class="text-normal font-13">{{ vm.questions[2].label }}</label></div></div></div></td><td><div class="flex-container"><div><label class="text-normal checkbox-container" for="question-3"><input type="checkbox" id="question-3" ng-model="vm.questions[3].value"> <span class="custom-checkbox"></span></label></div><div class="ml-30"><div class="pt-7"><label for="question-3" class="text-normal font-13">{{ vm.questions[3].label }}</label></div></div></div></td></tr></table></div></div></div><div class="row mt-35"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon btn-secondary pull-right" ng-click="vm.goToVisitorItemPage()"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.createAppointment.nextButton\' }}</span> <i class="fa fa-angle-double-right"></i></button> <button type="button" class="btn btn-md pull-right border-btn mr-10" ng-click="vm.cancelCurrentOperation()"><span translate="">{{ \'CANCEL\' }}</span></button></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkIn/visitorCardAssignment.html','<div ng-if="vm.isDataLoaded"><div class="row"><div class="col-md-12"><p class="text-center mb-20 font-16 color-22222">{{ \'visitorManagement.reception.checkIn.cardAssignment.cardSelectionLabel\' | translate }}</p></div></div><div class="row"><div class="col-md-12"><div isteven-multi-select="" input-model="vm.availableCards" output-model="vm.selectedCard" button-label="label" item-label="label" tick-property="ticked" output-properties="id" search-property="code rfid" selection-mode="single" translation="{ \'selectAll\' : \'Select all\', \'selectNone\' : \'Select none\', \'reset\' : \'Reset\', \'search\' : \'Search By Name...\', \'nothingSelected\' : \'Select Card\' }"></div></div></div><div class="row mt-35"><div class="col-md-12"><p class="text-center mb-20 font-16 color-22222">{{ \'visitorManagement.reception.checkIn.cardAssignment.itemInputSectionLabel\' | translate }}</p></div></div><div class="row" ng-form="items"><div class="col-md-4"><div class="form-group"><input class="form-control" type="text" ng-model="vm.carriedItem.name" placeholder="Item Name"></div></div><div class="col-md-4"><div class="form-group"><input class="form-control" type="text" ng-model="vm.carriedItem.description" placeholder="Details"></div></div><div class="col-md-4"><div class="form-group"><input class="form-control" type="number" ng-model="vm.carriedItem.quantity" placeholder="Quantity" min="1"></div></div></div><div class="row mt-10 mb-10"><div class="col-md-12"><a class="link-btn pull-right" href="" ng-click="vm.addItem()" target="_self"><span class="mr-5 pb-3" translate="">{{ \'visitorManagement.reception.checkIn.cardAssignment.itemAddLabel\' }}</span></a></div></div><div class="row mt-20"><div class="col-md-12"><table class="table table-bordered"><thead><tr><td class="th-bg border-0 text-left" translate="">{{ \'visitorManagement.reception.checkIn.cardAssignment.itemTable.nameColumnTitle\' }}</td><td class="th-bg border-0 text-center" translate="">{{ \'visitorManagement.reception.checkIn.cardAssignment.itemTable.descriptionColumnTitle\' }}</td><td class="th-bg border-0 text-center" translate="">{{ \'visitorManagement.reception.checkIn.cardAssignment.itemTable.quantityColumnTitle\' }}</td></tr></thead><tbody><tr ng-if="vm.carriedItems.length === 0"><td class="text-center" colspan="3"><em translate="">{{ \'visitorManagement.reception.checkIn.cardAssignment.itemTable.emptyTable\' }}</em></td></tr><tr ng-repeat="item in vm.carriedItems"><td class="text-left">{{ ($index + 1) + \'. \' + item.name}}</td><td class="text-center">{{item.description}}</td><td class="text-center">{{item.quantity + (item.quantity > 1 ? \'pcs\' : \'pc\')}}</td></tr></tbody></table></div></div><div class="row mt-35"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon btn-secondary pull-right" ng-disabled="vm.selectedCard.length === 0 || items.$invalid" ng-class="{\'btn-disable\' : vm.selectedCard.length === 0 || items.$invalid, \'btn-secondary\' : vm.selectedCard.length > 0}" ng-click="vm.openCheckInConfirmationModal()"><i class="fa fa-check-square-o"></i> <span class="ml-negative-5 pb-2" translate="">{{ \'visitorManagement.reception.checkIn.cardAssignment.checkInButton\' }}</span></button> <button type="button" class="btn btn-md pull-right border-btn mr-10" ng-click="vm.goToNewAppointmentTab()"><span translate="">{{ \'commonKeywords.cancelButton\' }}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkOut/checkOut.html','<style>\n    .background-checkout{\n        background: var(--color-primary)!important;\n    }\n    .background-activity{\n        background: #f7f7f7;\n        display: flex;\n        align-items: center;\n        height: 35px;\n    }\n    .directive-style .profile-info{\n       margin-left: 0;\n    }\n    .directive-style .flex-container{\n        gap: 3px;\n        margin-right: 10px;\n    }\n</style><div ng-controller="CheckOutCtrl as vm"><div ba-panel="" ba-panel-title="Check Out" ba-panel-class="with-scroll panel-full-screen"><div class="row"><div class="col-md-12"><div class="width-100"><div><table class="table report-table"><thead class="width-100"><tr class="height-5-vh d-flex-space-between width-100"><th class="text-center width-33 background-checkout text-success"><span>{{\'CHECKED IN : \'}}</span><span>{{vm.checkedInTotal}}</span></th><th class="text-center width-33_33 background-checkout text-danger"><span>{{\'CHECKED OUT : \'}}</span><span>{{vm.checkedOutTotal}}</span></th><th class="text-center width-33 background-checkout"><span class="limegreen-text">{{\'ON PREMISE : \'}}</span><span class="limegreen-text">{{vm.onPremiseTotal}}</span></th></tr></thead></table></div></div><div class="mt-20"><div class="form-group has-feedback has-search mb-20"><span class="glyphicon glyphicon-search form-control-feedback"></span> <input type="text" class="form-control" ng-model="vm.searchKeyword" ng-keydown="$event.keyCode === 13 && vm.getPageSpecifiedCheckOuts()" ng-keyup="vm.getAllOnEmptySearchKeyword()" placeholder="{{\'visitorManagement.reception.checkIn.searchCheckout\' | translate}}"></div></div><div><div class="text-center align-self-start" ng-if="!vm.isDataLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><div ng-if="!vm.isAnyProfileSelected && vm.isDataLoaded"><div ng-repeat="data in vm.totalCheckOuts"><div class="background-activity width-100 mb-20"><div class="width-40 text-center"><span>Card Code : {{ data.cardCode }}</span></div><div class="width-30"><span class="text-primary">Checked In : {{ data.checkInTime |date:\'hh:mm a\'}}</span></div><div class="width-30" ng-if="data.checkOutTime!=null"><span class="text-danger">Checked Out : {{ data.checkOutTime |date:\'hh:mm a\'}}</span></div></div><div class="d-flex-space-between mb-20 directive-style" ng-class="data.checkOutTime==null?\'cursor-pointer\':\'\'" ng-click="data.checkOutTime==null && vm.getCheckhOutInfo(data.id)"><div><div><visitor-picture-and-information name="data.visitorName+\' (Visitor)\'" picture-url="data.visitorPictureUrl" company-name="!data.visitorOrganisationName ? \'N/A\':data.visitorOrganisationName" is-clickable="false"></visitor-picture-and-information></div></div><div><employee-picture-and-information name="data.hostName+\' (Host)\'" picture-url="data.hostPictureUrl" department-name="data.departmentName ? \'N/A\':data.departmentName" designation-name="!data.designationName ? \'N/A\':data.designationName" id="data.id" is-clickable="false"></employee-picture-and-information></div></div></div><pagination-directive ng-if="true" number-of-pages="vm.numberOfPages" number-of-buttons="vm.numberOfButtons" selected-page="vm.filterParams.selectedPage" total="vm.total" is-data-loaded="vm.isDataLoaded" search-method="vm.getPageSpecifiedData" not-found-text="\'No data available\'"></pagination-directive></div><div ng-if="vm.isAnyProfileSelected && vm.isDataLoaded"><div class="col-md-12" include-with-scope="app/pages/main/visitorManagement/reception/partials/checkOut/checkOutProfile/checkOutProfile.html"></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/assignRole/modals/assign.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" id="myModalLabel">{{ \'visitorManagement.assignRole.creationModal.title\' | translate }}</h3><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="mb-10"><span class="required" translate="">{{ \'visitorManagement.assignRole.creationModal.selectEmployeeLabel\'}}</span></div><div class=""><div isteven-multi-select="" input-model="vm.employeeList" output-model="vm.selectedEmployee" button-label="name" item-label="name" tick-property="selected" output-properties="id" search-property="name" selection-mode="single"></div></div><div class="mt-10 mb-10"><span class="required" translate="">{{ \'visitorManagement.assignRole.creationModal.selectRoleLabel\'}}</span></div><div class=""><div isteven-multi-select="" input-model="vm.roleList" output-model="vm.selectedRole" button-label="name" item-label="name" tick-property="selected" output-properties="value" search-property="name" selection-mode="single"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.assignEmployeeRole()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'visitorManagement.assignRole.creationModal.assignButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/assignRole/modals/delete.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.assignRole.deleteModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16 line-height-1_3">{{ \'visitorManagement.assignRole.deleteModal.confirmationText\' | translate }}<em>{{vm.roleToDelete.roleList.join(", ")}}</em><span>{{ \'visitorManagement.assignRole.deleteModal.confirmationText2\' | translate}}{{vm.roleToDelete.name}}{{\'commonKeywords.questionMark\' | translate}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteEmployeeRole(vm.roleToDelete.id)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/assignRole/modals/update.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.assignRole.creationModal.title\' | translate }}</h3><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="mb-10 ml-10"><employee-picture-and-information name="vm.selectedEmployee.name" picture-url="vm.selectedEmployee.pictureUrl" department-name="vm.selectedEmployee.departmentName" designation-name="!vm.selectedEmployee.designationName ? \'N/A\':vm.selectedEmployee.designationName" id="vm.selectedEmployee.id" is-clickable="false"></employee-picture-and-information></div><div class="mt-10 mb-10"><span translate="">{{ \'visitorManagement.assignRole.creationModal.selectRoleLabel\'}}</span></div><div class=""><div isteven-multi-select="" input-model="vm.roleList" output-model="vm.selectedRole" button-label="name" item-label="name" tick-property="selected" output-properties="value" search-property="name" selection-mode="single"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateEmployeeRole()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'visitorManagement.assignRole.creationModal.assignButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/manageCard/modals/create.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.visitorCard.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="rfid" class="mt-10 required" translate="">{{ \'visitorManagement.visitorCard.creationModal.rfidInputLabel\'}}</label> <input type="text" id="rfid" class="form-control" placeholder="{{ \'visitorManagement.visitorCard.creationModal.rfidInputPlaceHolder\' | translate }}" ng-model="vm.rfid"></div></div><div class="row"><div class="col-md-12 form-group"><label for="code" class="mt-10 required" translate="">{{ \'visitorManagement.visitorCard.creationModal.codeInputLabel\'}}</label> <input type="text" id="code" class="form-control" placeholder="{{ \'visitorManagement.visitorCard.creationModal.codeInputPlaceHolder\' | translate }}" ng-model="vm.code"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/manageCard/modals/delete.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.visitorCard.deleteModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16 line-height-1_3">{{ \'visitorManagement.visitorCard.deleteModal.confirmationText\' | translate }} <em>{{vm.card.code}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="$close()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/manageCard/modals/edit.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.visitorCard.editModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="rfid" class="mt-10" translate="">{{ \'visitorManagement.visitorCard.editModal.rfidInputLabel\'}}</label> <input type="text" id="rfid" class="form-control" placeholder="{{ \'visitorManagement.visitorCard.editModal.rfidInputPlaceHolder\' | translate }}" ng-model="vm.card.rfid"></div></div><div class="row"><div class="col-md-12 form-group"><label for="code" class="mt-10" translate="">{{ \'visitorManagement.visitorCard.editModal.codeInputLabel\'}}</label> <input type="text" id="code" class="form-control" placeholder="{{ \'visitorManagement.visitorCard.editModal.codeInputPlaceHolder\' | translate }}" ng-model="vm.card.code"></div></div><div class="row"><div class="col-md-12 form-group mt-10"><div><label translate="">{{ \'visitorManagement.visitorCard.editModal.statusInputLabel\'}}</label></div><div><strong class="mr-10" translate="">{{ \'commonKeywords.statusInactive\' }}</strong> <label class="custom-switch mt-10 mr-10"><input name="enabled" ng-model="vm.card.status" type="checkbox"><span class="slider round"></span></label> <strong translate="">{{ \'commonKeywords.statusActive\' }}</strong></div></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{ \'commonKeywords.saveChangesButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurposeModals/createVisitPurpose.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.visitPurpose.creationModal.title\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="rfid" class="mt-10 required" translate="">{{ \'visitorManagement.visitPurpose.creationModal.nameInputLabel\'}}</label> <input type="text" id="rfid" class="form-control" placeholder="{{ \'visitorManagement.visitPurpose.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.createVisitPurposeName"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createVisitPurpose()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurposeModals/deleteVisitPurpose.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.visitorCard.deleteModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16 line-height-1_3">{{ \'visitorManagement.visitPurpose.deleteModal.confirmationText\' | translate }} <em>{{vm.purposeToChange.name}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteVisitPurpose(vm.purposeToChange.id)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitPurpose/visitPurposeModals/updateVisitPurpose.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.visitPurpose.updateModal.title\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="rfid" class="mt-10" translate="">{{ \'visitorManagement.visitPurpose.updateModal.nameInputLabel\'}}</label> <input type="text" id="rfid" class="form-control" placeholder="{{ \'visitorManagement.visitPurpose.updateModal.nameInputPlaceholder\' | translate}}" ng-model="vm.purposeToChange.text"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateVisitPurpose(vm.purposeToChange.id)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.saveChangesButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategoryModals/createVisitorCategory.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.visitorCategory.creationModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10 required" translate="">{{ \'visitorManagement.visitorCategory.creationModal.nameInputLabel\'}}</label> <input type="text" id="name" class="form-control" autocomplete="off" placeholder="{{ \'visitorManagement.visitorCategory.creationModal.nameInputPlaceholder\' | translate }}" ng-model="vm.create.createVistorCategoryName"></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.createVisitorCategory()" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'visitorManagement.visitorCategory.creationModal.createButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategoryModals/deleteVisitorCategory.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.visitorCategory.deleteModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><p class="font-16 line-height-1_3">{{ \'visitorManagement.visitorCategory.deleteModal.confirmationText\' | translate }} <em>{{vm.categoryToChange.name}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.deleteVisitorCategoryName(vm.categoryToChange.id)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'commonKeywords.deleteButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/visitorSettings/visitorCategory/visitorCategoryModals/updateVisitorCategory.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'visitorManagement.visitorCategory.updateModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10" translate="">{{ \'visitorManagement.visitorCategory.updateModal.nameInputLabel\' }}</label> <input type="text" id="name" class="form-control" autocomplete="off" placeholder="{{ \'visitorManagement.visitorCategory.updateModal.nameInputPlaceholder\' | translate }}" ng-model="vm.categoryToChange.name"></div><div class="modal-footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.updateVisitorCategoryName(vm.categoryToChange.id,vm.categoryToChange.name)" ng-disabled="vm.isCreating"><span ng-if="!vm.isCreating">{{ \'leaveCategorySettings.creationModal.submitButton\' | translate}}</span> <span ng-if="vm.isCreating">{{ \'commonKeywords.pleaseWait\' | translate}}</span></button></div></div></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/viewSalary-partials/dummyTable.html','<div class="row"><div class="col-md-12 blur-dummy-modal"><table class="table table-no-borders bg-fbfbfb"><tr><td><employee-picture-and-information name="vm.selectedRow.employee.name" picture-url="vm.selectedRow.employee.pictureUrl" department-name="vm.selectedRow.employee.departmentName" designation-name="vm.selectedRow.employee.designationName" id="vm.selectedRow.employee.id" is-clickable=""></employee-picture-and-information></td></tr></table><table class="table table-bordered"><colgroup><col class="width-60"><col class="width-40"></colgroup><thead><tr class="bg-f1f2f1"><th class="text-left"><strong translate="">{{\'viewOrGenerateSalary.salaryComponent\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.amount\'}}</strong></th></tr></thead><tbody><tr><td class="text-left" translate="">{{\'payrollManagement.basicSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.houseRentAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.conveyanceAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollManagement.medicalAllowance\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left"><strong translate="">{{\'viewOrGenerateSalary.monthlyGrossSalary\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr style="background: #61C6E4"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left" translate="">{{\'payrollSettings.deduction\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr style="background: #F19A9A"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr><tr><td class="text-left"><strong translate="">{{\'payrollManagement.netPayable\'}}</strong></td><td class="text-center" translate="">{{\'payrollManagement.dummyAmount\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/viewSalary-partials/editSalaryDetailsTable.html','<div class="row"><div class="col-md-12"><table class="table table-no-borders bg-fbfbfb"><tr><td><employee-picture-and-information name="vm.selectedRow.employee.name" picture-url="vm.selectedRow.employee.pictureUrl" department-name="vm.selectedRow.employee.departmentName" designation-name="vm.selectedRow.employee.designationName" id="vm.selectedRow.employee.id" is-clickable="vm.selectedRow.employee.status == 1"></employee-picture-and-information></td></tr></table><table class="table table-bordered"><colgroup><col class="width-30"><col class="width-30"><col class="width-40"></colgroup><thead><tr class="bg-f1f2f1"><th class="text-left"><strong translate="">{{\'viewOrGenerateSalary.salaryComponent\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.calculatedAmount\'}}</strong></th><th class="text-center"><strong translate="">{{\'viewOrGenerateSalary.updatedAmount\'}}</strong></th></tr></thead><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{inclusiveToGross: true}:true"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.calculatedAmount | number : 2}}</td><td class="text-center text-left-important"><input type="number" class="form-control" ng-model="data.updatedAmount" ng-change="vm.compareCalculatedAndUpdatedAmount()"></td></tr><tr><td class="text-left"><strong translate="">{{\'viewOrGenerateSalary.monthlyGrossSalary\'}}</strong></td><td class="text-center text-bold">{{vm.sumData.monthlyGrossSalary | number : 2}}</td><td class="text-left-important text-bold">{{vm.getUpdatedGrossSalary() | number : 2}}</td></tr></tbody><tbody ng-repeat="data in vm.selectedRow.components"><tr ng-if="data.inclusiveToGross === false && data.category === 1"><td class="text-left">{{data.name}}</td><td class="text-center">{{data.calculatedAmount | number : 2}}</td><td class="text-center">{{data.updatedAmount | number : 2}}</td></tr></tbody><tbody><tr class="bg-61C6E4 font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-center">{{vm.sumData.monthlyTotalSalary | number : 2}}</td><td class="text-center">{{vm.getUpdatedTotalSalary() | number : 2}}</td></tr></tbody><tbody><tr ng-repeat="data in vm.selectedRow.components | filter:{category: -1}:true"><td class="text-left">{{data.name}}</td><td class="text-center">{{vm.getAbsCalculatedAmount(data.calculatedAmount) | number : 2}}</td><td class="text-left-important"><input type="number" class="form-control" ng-model="data.updatedAmount" ng-change="vm.compareCalculatedAndUpdatedAmount()"></td></tr></tbody><tbody><tr class="bg-F19A9A font-weight-600"><td class="text-left" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-center">{{vm.sumData.monthlyTotalDeduction | number : 2}}</td><td class="text-center">{{vm.getTotalDeductedAmount() | number : 2}}</td></tr><tr><td class="text-left"><strong translate="">{{\'payrollManagement.netPayable\'}}</strong></td><td class="text-center">{{vm.sumData.monthlyNetPayable | number : 2}}</td><td class="text-center">{{vm.getTotalPayableAmount() | number : 2}}</td></tr></tbody></table></div></div><div class="row mt-30"><div class="col-md-12"><h5><strong class="text-uppercase required" translate="">{{\'viewOrGenerateSalary.remarks\'}}</strong></h5></div></div><div class="row"><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.remarks"></div><div class="col-md-3 text-right"><button class="btn btn-md-with-icon padding-7-14" ng-click="vm.saveChanges()" ng-class="{\'btn-disable\' : vm.isSaveBtnClicked, \'btn-primary\' : !vm.isSaveBtnClicked}" ng-disabled="vm.isSaveBtnClicked"><img src="../assets/img/Save.png"> <span class="ml-negative-5 pb-2" translate="">{{\'commonKeywords.saveChangesButton\'}}</span></button></div></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/viewSalary-partials/employeesTable.html','<style>\n    .edited{\n        border-radius:10px;\n        color:#222222;\n        font-weight: 500;\n        border:1px solid #DF871C;\n        float: right\n    }\n    .section-padding{\n        padding-top: 5%;\n    }\n    .process-btn{\n        font-size: 12px;\n        margin-right: 0px;\n        padding: 1px 6px;\n    }\n    .flex-0-1-100{\n        flex: 0 1 100%;\n    }\n    .flex-0-1-auto{\n        flex: 0 1 auto;\n    }\n    .border-bottom-1{\n        border-bottom: 1px solid #dfdfdf!important;\n    }\n</style><div class="col-md-12">sdfsn<table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-13"><col class="width-39"><col class="width-15"><col class="width-15"><col class="width-12"></colgroup><thead><tr class="dont-wrap-text height-5-vh"><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left check-uncheck-all dont-wrap-text"><label class="checkbox-container text-normal"><input ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover" type="checkbox" ng-model="vm.allSelected" ng-click="vm.checkOrUncheckAll()"> <span class="custom-checkbox checkbox-position-th"></span> <span class="ml-20"><span class="d-inline-block mt-2 white-text">{{\'commonKeywords.id\' | translate}}</span></span></label></th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.grossSalary\'}}</th><th class="text-center dont-wrap-text" translate="">{{\'payrollManagement.netPayable\'}}</th><th class="text-center dont-wrap-text" ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover" translate="">{{\'viewOrGenerateSalary.action\'}}</th><th class="text-center dont-wrap-text" ng-if="vm.salarySummary.status != 0 || vm.isPayrollApprover" translate="">{{\'viewOrGenerateSalary.remarks\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.employeeInfo" class="cursor-pointer border-bottom-1" ng-class="{\'is-selected\':vm.isAnyRowSelected && vm.selectedRowIndex == $index}" style="{{data.isEdited ? \'background-color:#E1ECEA\':\'\'}}"><td class="text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{$index + 1}}</td><td class="text-left" ng-click="vm.showEmployeeInfoInTheRightColumn($index)"><label class="checkbox-container text-normal"><input ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover" type="checkbox" ng-model="data.isSelected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position-tr"></span> <span class="ml-20 default-text" translate="">{{data.employee.employeeOfficeId}}</span></label></td><td class="dont-wrap-text" ng-click="vm.showEmployeeInfoInTheRightColumn($index)"><div class="d-flex-space-between"><div class="flex-0-1-100"><employee-picture-and-information name="data.employee.name" picture-url="data.employee.pictureUrl" department-name="data.employee.departmentName" designation-name="data.employee.designationName" is-clickable="false"></employee-picture-and-information></div><div class="section-padding flex-0-1-auto" ng-if="data.isEdited"><span class="label label-primary label-style edited" translate="">{{\'viewOrGenerateSalary.edited\'}}</span></div></div></td><td class="dont-wrap-text text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index)">{{data.grossSalary | number:0}}</td><td class="dont-wrap-text text-center" ng-click="vm.showEmployeeInfoInTheRightColumn($index,data.id)">{{data.netPayableSalary | number:0}}</td><td class="dont-wrap-text text-center" ng-if="vm.salarySummary.status == 0 && !vm.isPayrollApprover"><span ng-if="vm.selectedTab === \'processedSalary\'"><button class="btn btn-sm-with-icon btn-info" ng-click="vm.openSalaryEditSection($index)"><i class="ion-ios-compose-outline font-17"></i><span class="font-13 pb-2" translate="">{{\'viewOrGenerateSalary.editButton\'}}</span></button></span> <span ng-if="vm.selectedTab === \'unprocessedSalary\'"><button class="btn btn-sm-with-icon process-btn btn-info" ng-click="vm.processSalaryForOneEmployee($index)"><img class="img-resize" src="../assets/img/process.png"> <span class="ml-negative-5 pt-1" translate="">{{\'viewOrGenerateSalary.processButton\'}}</span></button></span></td><td class="dont-wrap-text text-center" ng-if="vm.salarySummary.status != 0 || vm.isPayrollApprover">{{::data.remarks}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/attendanceReport/salaryReport/monthOnMonthSalaryComparison/partials/viewSalary-partials/salaryComparisonDetailsTable.html','<style>\n    .remarks span {\n        border-bottom: 2px dashed #c7bebe;\n        padding-bottom: 1px;\n    }\n    .icon-position {\n        position: absolute;\n        top:5px;\n        right:10px;\n        font-size: 20px;\n    }\n</style><div class="col-md-12"><table class="table table-bordered bg-fbfbfb"><tr><td><employee-picture-and-information name="vm.selectedRow.employee.name" picture-url="vm.selectedRow.employee.pictureUrl" department-name="vm.selectedRow.employee.departmentName" designation-name="vm.selectedRow.employee.designationName" id="vm.selectedRow.employee.id" is-clickable="true"></employee-picture-and-information></td></tr></table><table class="table borderless-table"><colgroup><col class="width-40"><col class="width-60"></colgroup><tbody><tr><td class="text-left border-right"><span translate="">{{\'employeeType\'}}:</span> <span class="color-22222 font-weight-400">{{vm.selectedRow.employee.employmentTypeName}}</span></td><td class="text-left"><span translate="">{{\'workplace\'}}:</span> <span class="color-22222 font-weight-400">{{vm.selectedRow.employee.workplaceName}}</span></td></tr></tbody></table><table id="column-height" class="table mt-10 borderless-table even-row-strip row-highlight"><colgroup><col class="width-30"><col class="width-12"><col class="width-12"><col class="width-12"><col class="width-33"></colgroup><thead><tr class="dont-wrap-text height-5-vh"><th class="text-left dont-wrap-text" translate="">{{\'profilePayroll.salaryComponents\'}}</th><th class="text-right dont-wrap-text">{{vm.salaryMonthName}} {{vm.searchParams.salaryYear}}</th><th class="text-right dont-wrap-text">{{vm.comparisonMonthName}} {{vm.searchParams.comparisonYear}}</th><th class="text-right dont-wrap-text" translate="">{{\'differance\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'remarks\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.selectedRow.monthOnMonthComparisonAdditiveTable" class="cursor-pointer"><td class="text-left">{{data.componentName}}</td><td class="dont-wrap-text text-right">{{data.salaryMonthSalary | number: 2}}</td><td class="dont-wrap-text text-right">{{data.comparisonMonthSalary | number: 2}}</td><td class="dont-wrap-text text-right">{{data.salaryDifferance | number: 2}}</td><td class="dont-wrap-text text-left remarks"><span id="{{\'remarks-btn-\'+data.componentId}}" ng-click="vm.showRemarksInput(\'#remarks-btn-\'+data.componentId, \'#remarks-input-\'+data.componentId)" ng-if="!vm.remarksMap[vm.selectedRow.employee.id][data.componentId].isOpen">{{vm.remarksMap[vm.selectedRow.employee.id][data.componentId].remarks || \'remarksHere\' | translate}}</span><div id="{{\'remarks-input-\'+data.componentId}}" class="d-none position-relative"><input ng-blur="vm.removeInputField(\'#remarks-btn-\'+data.componentId,\'#remarks-input-\'+data.componentId); vm.createOrUpdateRemarks($event,vm.remarksMap[vm.selectedRow.employee.id][data.componentId].id,vm.selectedRow.employee.id, data.componentId)" ng-model="vm.remarksMap[vm.selectedRow.employee.id][data.componentId].remarks" ng-keyup="$event.keyCode == 13 ? vm.createOrUpdateRemarks($event,vm.remarksMap[vm.selectedRow.employee.id][data.componentId].id,vm.selectedRow.employee.id, data.componentId) : false" class="form-control" type="text" placeholder="Remarks Here"></div></td></tr></tbody><tbody><tr class="bg-61C6E4 font-weight-600"><td class="text-left width-30" translate="">{{\'viewOrGenerateSalary.totalSalary\'}}</td><td class="text-right width-12">{{vm.selectedRow.totalAdditiveSalary | number: 2}}</td><td class="text-right width-12">{{vm.selectedRow.totalAdditiveComparisonSalary | number: 2}}</td><td class="text-right width-12">{{vm.selectedRow.totalAdditiveDifferanceSalary | number: 2}}</td><td class="text-center width-33"></td></tr></tbody><tbody><tr ng-repeat="data in vm.selectedRow.monthOnMonthComparisonDeductiveTable" class="cursor-pointer border-bottom-1"><td class="text-left">{{data.componentName}}</td><td class="dont-wrap-text text-right">{{data.salaryMonthSalary | number: 2}}</td><td class="dont-wrap-text text-right">{{data.comparisonMonthSalary | number: 2}}</td><td class="dont-wrap-text text-right">{{data.salaryDifferance | number: 2}}</td><td class="dont-wrap-text text-left remarks"><span id="{{\'d-remarks-btn-\'+data.componentId}}" ng-click="vm.showRemarksInput(\'#d-remarks-btn-\'+data.componentId, \'#d-remarks-input-\'+data.componentId)">{{vm.remarksMap[vm.selectedRow.employee.id][data.componentId].remarks || \'remarksHere\' | translate}}</span><div id="{{\'d-remarks-input-\'+data.componentId}}" class="d-none position-relative"><input ng-blur="vm.removeInputField(\'#d-remarks-btn-\'+data.componentId, \'#d-remarks-input-\'+data.componentId); vm.createOrUpdateRemarks($event,vm.remarksMap[vm.selectedRow.employee.id][data.componentId].id,vm.selectedRow.employee.id, data.componentId)" ng-model="vm.remarksMap[vm.selectedRow.employee.id][data.componentId].remarks" ng-keyup="$event.keyCode == 13 ? vm.createOrUpdateRemarks($event,vm.remarksMap[vm.selectedRow.employee.id][data.componentId].id,vm.selectedRow.employee.id, data.componentId) : false" class="form-control lost-focus" type="text" placeholder="Remarks Here"></div></td></tr></tbody><tbody><tr class="bg-F19A9A font-weight-600"><td class="text-left width-30" translate="">{{\'viewOrGenerateSalary.totalDeduction\'}}</td><td class="text-right width-12">{{vm.selectedRow.totalDeductiveSalary | number: 2}}</td><td class="text-right width-12">{{vm.selectedRow.totalDeductiveComparisonSalary | number: 2}}</td><td class="text-right width-12">{{vm.selectedRow.totalDeductiveDifferanceSalary | number: 2}}</td><td class="text-center width-33"></td></tr></tbody></table><table class="table mt-10"><colgroup><col class="width-30"><col class="width-12"><col class="width-12"><col class="width-12"><col class="width-33"></colgroup><tbody><tr class="bg-black font-weight-600"><td class="text-left" translate="">{{\'payrollManagement.netPayable\'}}</td><td class="text-right">{{vm.getAbsCalculatedAmount(vm.selectedRow.netPayableSalary) | number: 2}}</td><td class="text-right">{{vm.getAbsCalculatedAmount(vm.selectedRow.netComparisonSalaryPayable) | number: 2}}</td><td class="text-right">{{vm.getAbsCalculatedAmount(vm.selectedRow.netDifferanceSalaryPayable) | number: 2}}</td><td class="text-center"></td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/allocated/delete/deleteAllocation.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to revoke selected allocations ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.deleteAllocations()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/unAllocated/allocate/allocate.modal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to allocate selected people ?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.allocate()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/root/partials/allocatedAndUnallocatedTable.html','<style>\n    .temporary{\n        color:#666666;\n        border:1px solid #209E91FF\n    }\n    .float-left,.float-right img{\n        border: 1.5px solid #e0e0e0\n    }\n    table tr th.border-hidden{\n        border-left:hidden !important;\n        /*border-right:hidden !important;*/\n    }\n    table tbody tr td.border-hidden{\n        border-left:hidden !important;\n        border-right:hidden !important;\n    }\n</style><table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-6"><col class="width-46"><col class="width-15"><col class="width-15"><col class="width-12 p-all-0"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh"><th class="text-center check-uncheck-all dont-wrap-text"><label class="checkbox-container"><input type="checkbox" ng-model="vm.allSelected" ng-click="vm.checkOrUncheckAll()"> <span class="custom-checkbox checkbox-position"></span></label></th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="border-hidden"></th><th class="border-hidden"></th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.action\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.allocationsData" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRow == $index}"><td class="text-center" ng-click="vm.showAllocationInfoInTheRightColumn($index,data.id)"><label class="checkbox-container"><input type="checkbox" ng-model="data.isSelected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position"></span></label></td><td class="text-center" ng-click="vm.showAllocationInfoInTheRightColumn($index,data.id)">{{$index + 1}}</td><td class="dont-wrap-text" ng-click="vm.showAllocationInfoInTheRightColumn($index,data.id)"><employee-picture-and-information name="data.name" picture-url="data.pictureUrl" department-name="data.departmentName" designation-name="data.designationName" is-clickable="false"></employee-picture-and-information></td><td class="border-hidden" ng-click="vm.showAllocationInfoInTheRightColumn($index,data.id)"><span ng-if="data.isTemporary" class="label label-primary label-style temporary" translate="">{{\'devices.temporary\'}}</span></td><td class="p-all-0" ng-click="vm.showAllocationInfoInTheRightColumn($index,data.id)"><div class="width-80"><div class="float-left"><img src="../assets/img/Fingerprint_icon.png" ng-if="data.totalFingerprints && data.totalFingerprints > 0"></div><div class="float-right"><img src="../assets/img/RFID_icon.png" ng-if="data.rfid && !!data.rfid"></div></div></td><td class="dont-wrap-text text-center pr-8-important"><button class="btn btn-sm btn-danger" ng-if="vm.selectedTab == \'allocated\'" ng-click="vm.revokeSingleEmployee(data)" translate="">{{\'devices.revokeButton\'}}</button> <button class="btn btn-sm btn-primary" ng-if="vm.selectedTab == \'unallocated\'" ng-click="vm.allocateSingleEmployee(data)" translate="">{{\'devices.allocateButton\'}}</button></td></tr></tbody></table>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/root/partials/dummyModel.html','<style>\n    .modal-div{\n        height: 6vh;\n        margin-left:20px;\n        margin-right:20px;\n        border: 1px solid #edf0ee;\n        background:#edf0ee;\n    }\n    .dummy-btn{\n        height: 2vh;\n        width: 95%;\n    }\n    .top-btn{\n        margin-bottom:4%;\n        margin-top: 10%;\n    }\n    .bottom-btn{\n        margin-bottom:8%\n    }\n    .dummy-modal-placement2{\n        position: absolute;\n        top:35%;\n        left:15%;\n        width: 65%;\n    }\n</style><div class="modal-content dummy-modal-placement2"><div class="row"><div class="col-md-12"><h5 class="modal-title text-center mb-20 mt-30 color-prime" translate="">{{\'commonKeywords.dummyModalText\'}}</h5></div></div><div class="row modal-div mb-40"><div class="col-md-12 prevent-clicks"><div class="row"><div class="col-md-2 col-xs-2 pr-0"><img class="height-6-vh width-80 border-radius-35" ng-src="../assets/img/theme/no-photo.png"></div><div class="col-md-3 col-xs-3 pl-0"><div class="height-1_1-vh width-100 dummy-line1-bg border-radius-10 mt-15"></div><div class="height-0_6-vh width-80 dummy-line2-bg border-radius-10 mt-6"></div></div><div class="col-md-1 col-xs-1 pl-0"><div class="height-1_1-vh width-150 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pr-0"><div class="height-1_1-vh width-100 dummy-line1-bg border-radius-10 mt-15"></div></div><div class="col-md-2 col-xs-2 pr-0"><div class="height-1_1-vh width-75 dummy-line1-bg border-radius-10 mt-15"></div><div class="height-0_6-vh width-60 dummy-line2-bg border-radius-10 mt-6"></div></div><div class="col-md-2 col-xs-2 pl-0"><button class="btn btn-info dummy-btn top-btn"></button> <button class="btn btn-danger dummy-btn bottom-btn"></button></div></div></div></div></div>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/root/partials/temporaryAllocation.html','<style>\n    .row-adjust{\n        line-height: 20px !important;\n    }\n    table tr th.border-hidden{\n        border-left:hidden !important;\n        /*border-right:hidden !important;*/\n    }\n    table tbody tr td.border-hidden{\n        border-left:hidden !important;\n        border-right:hidden !important;\n    }\n    .active{\n        color:#666666;\n        border:1px solid #209E91FF\n    }\n    .upcoming{\n        color:#666666;\n        border:1px solid #d1d1d1;\n    }\n    .inactive{\n        color:#666666;\n        border:1px solid #d20606;\n    }\n    .float-left,.float-right img{\n        border: 1.5px solid #e0e0e0\n    }\n    .disable{\n        cursor: not-allowed;\n    }\n    .disable input[type=\'checkbox\']:checked ~ .custom-checkbox {\n        background-color: var(--color-disable) !important;\n        border:1px solid var(--color-disable) !important;\n    }\n</style><table id="column-height" class="table borderless-table even-row-strip row-highlight"><colgroup><col class="width-6"><col class="width-6"><col class="width-44"><col class="width-15"><col class="width-17"><col class="width-12 p-all-0"></colgroup><thead><tr class="row-height dont-wrap-text height-5-vh"><th class="text-center check-uncheck-all dont-wrap-text"><label class="checkbox-container"><input type="checkbox" ng-model="vm.allSelected" ng-click="vm.checkOrUncheckAll()"> <span class="custom-checkbox checkbox-position"></span></label></th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.sl\'}}</th><th class="text-left dont-wrap-text" translate="">{{\'commonKeywords.employeeName\'}}</th><th class="border-hidden"></th><th class="border-hidden"></th><th class="text-center dont-wrap-text" translate="">{{\'commonKeywords.action\'}}</th></tr></thead><tbody><tr ng-repeat="data in vm.allocationsData" class="cursor-pointer" ng-class="{\'onClick\':vm.isAnyRowSelected && vm.selectedRow == $index}"><td class="text-center" ng-click="vm.showAllocationInfoInTheRightColumn($index)"><label class="checkbox-container" ng-class="{\'disable\':data.allocationStatus != \'upcoming\' && data.allocationStatus != \'active\'}"><input type="checkbox" ng-disabled="data.allocationStatus != \'upcoming\' && data.allocationStatus != \'active\'" ng-model="data.isSelected" ng-change="vm.optionToggled()"> <span class="custom-checkbox checkbox-position"></span></label></td><td class="text-center" ng-click="vm.showAllocationInfoInTheRightColumn($index)">{{data.employeeOfficeId}}</td><td class="dont-wrap-text" ng-click="vm.showAllocationInfoInTheRightColumn($index)"><employee-picture-and-information name="data.name" picture-url="data.pictureUrl" department-name="data.departmentName" designation-name="data.designationName" is-clickable="false"></employee-picture-and-information></td><td class="border-hidden" ng-click="vm.showAllocationInfoInTheRightColumn($index)"><span class="label label-primary label-style active" ng-if="data.allocationStatus == \'active\'" translate="">{{\'devices.active\'}}</span> <span class="label label-primary label-style upcoming" ng-if="data.allocationStatus == \'upcoming\'" translate="">{{\'devices.upcoming\'}}</span> <span class="label label-primary label-style inactive" ng-if="data.allocationStatus == \'inactive\'" translate="">{{\'devices.inactive\'}}</span></td><td ng-click="vm.showAllocationInfoInTheRightColumn($index)"><div class="width-80"><div class="float-left"><img src="../assets/img/Fingerprint_icon.png" ng-if="data.totalFingerprints && data.totalFingerprints > 0"></div><div class="float-right"><img src="../assets/img/RFID_icon.png" ng-if="data.rfid && !!data.rfid"></div></div></td><td class="dont-wrap-text text-center pr-8-important"><button class="btn btn-danger btn-modification text-uppercase" ng-click="vm.revokeOrCancelTemporaryPermission($index)" ng-if="data.allocationStatus == \'upcoming\'" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button class="btn btn-danger btn-modification text-uppercase" ng-click="vm.revokeOrCancelTemporaryPermission($index)" ng-if="data.allocationStatus == \'active\'" translate="">{{\'devices.revokeButton\'}}</button> <span class="text-capitalize" ng-if="data.allocationStatus != \'upcoming\' && data.allocationStatus != \'active\'"><em>{{data.allocationStatus}}</em></span></td></tr></tbody></table>');
$templateCache.put('app/pages/main/devices/devicesList/allocations/root/partials/temporaryAllocationInfoTable.html','<div class="row"><div class="col-md-12 mt-30"><h3 translate="">{{\'commonKeywords.employeeInformationHeading\'}}</h3></div></div><div class="row mt-5"><div class="col-md-12"><table class="table table-bordered"><thead><tr class="dont-wrap-text th-width th-bg height-5-vh"><th class="dont-wrap-text" colspan="2"><employee-picture-and-information name="vm.selectedRowObject.name" picture-url="vm.selectedRowObject.pictureUrl" department-name="vm.selectedRowObject.departmentName" designation-name="vm.selectedRowObject.designationName" id="vm.selectedRowObject.id" is-clickable="vm.selectedRowObject.status == 1"></employee-picture-and-information></th></tr></thead><tbody><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.employeeId\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.employmentType\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.shiftGroup\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.rfid\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.primaryText\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'commonKeywords.secondaryText\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationStartDate\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationEndDate\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr></tbody></table></div></div><div class="row"><div class="col-md-12 mt-20"><h4 translate="">{{\'devices.temporaryAllocationInformationHeading\'}}</h4></div></div><div class="row mt-10"><div class="col-md-12"><table class="table table-bordered"><tbody><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationStartDate\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr><tr class="dont-wrap-text"><td class="text-left dont-wrap-text row-adjust" translate="">{{\'devices.allocationEndDate\'}}</td><td class="text-left dont-wrap-text row-adjust"></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/bankManagement/modals/createBank/createBank.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'bankManagement.addNewBankModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10 required" translate="">{{ \'bankManagement.addNewBankModal.nameInputLabel\'}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'bankManagement.addNewBankModal.nameInputPlaceholder\' | translate }}" ng-model="vm.name"></div></div><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10 required" translate="">{{ \'bankManagement.addNewBankModal.codeInputLabel\'}}</label> <input type="text" id="code" class="form-control" placeholder="{{ \'bankManagement.addNewBankModal.codeInputPlaceholder\' | translate }}" ng-model="vm.code"></div></div><div class="row"><div class="col-md-12 form-group"><label for="accountName" class="mt-10 required" translate="">{{ \'bankManagement.addNewBankModal.accountNameInputLabel\'}}</label> <input type="text" id="accountName" class="form-control" placeholder="{{ \'bankManagement.addNewBankModal.accountNameInputPlaceholder\' | translate }}" ng-model="vm.accountName"></div></div><div class="row"><div class="col-md-12 form-group"><label for="accountNumber" class="mt-10 required" translate="">{{ \'bankManagement.addNewBankModal.accountNumberInputLabel\'}}</label> <input type="text" id="accountNumber" class="form-control" placeholder="{{ \'bankManagement.addNewBankModal.accountNumberInputPlaceholder\' | translate }}" ng-model="vm.accountNumber"></div></div><div class="row"><div class="col-md-12 form-group"><label for="address" class="mt-10 required" translate="">{{ \'bankManagement.addNewBankModal.addressInputLabel\'}}</label> <input type="text" id="address" class="form-control" placeholder="{{ \'bankManagement.addNewBankModal.addressInputPlaceholder\' | translate }}" ng-model="vm.accountAddress"></div></div><div class="row"><div class="col-md-12 form-group"><span class="d-inline-block text-bold mb-3" translate="">inactive</span> <label class="custom-switch ml-20"><input name="status" ng-model="vm.status" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">active</strong></span></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/bankManagement/modals/editBank/editBank.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'bankManagement.editBankModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10 required" translate="">{{ \'bankManagement.editBankModal.nameInputLabel\'}}</label> <input type="text" id="name" class="form-control" placeholder="{{ \'bankManagement.editBankModal.nameInputPlaceholder\' | translate }}" ng-model="vm.bankDetails.name"></div></div><div class="row"><div class="col-md-12 form-group"><label for="name" class="mt-10 required" translate="">{{ \'bankManagement.editBankModal.codeInputLabel\'}}</label> <input type="text" id="code" class="form-control" placeholder="{{ \'bankManagement.editBankModal.codeInputPlaceholder\' | translate }}" ng-model="vm.bankDetails.code"></div></div><div class="row"><div class="col-md-12 form-group"><label for="accountName" class="mt-10 required" translate="">{{ \'bankManagement.editBankModal.accountNameInputLabel\'}}</label> <input type="text" id="accountName" class="form-control" placeholder="{{ \'bankManagement.editBankModal.accountNameInputPlaceholder\' | translate }}" ng-model="vm.bankDetails.accountName"></div></div><div class="row"><div class="col-md-12 form-group"><label for="accountNumber" class="mt-10 required" translate="">{{ \'bankManagement.editBankModal.accountNumberInputLabel\'}}</label> <input type="text" id="accountNumber" class="form-control" placeholder="{{ \'bankManagement.editBankModal.accountNumberInputPlaceholder\' | translate }}" ng-model="vm.bankDetails.accountNumber"></div></div><div class="row"><div class="col-md-12 form-group"><label for="address" class="mt-10 required" translate="">{{ \'bankManagement.editBankModal.addressInputLabel\'}}</label> <input type="text" id="address" class="form-control" placeholder="{{ \'bankManagement.editBankModal.addressInputPlaceholder\' | translate }}" ng-model="vm.bankDetails.accountAddress"></div></div><div class="row"><div class="col-md-12 form-group"><span class="d-inline-block text-bold mb-3" translate="">inactive</span> <label class="custom-switch ml-20"><input name="status" ng-model="vm.bankDetails.status" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">active</strong></span></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/branchManagement/modals/createBranch/createBranch.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'bankManagement.addNewBranchModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="bankList" class="mt-10 required" translate="">{{ \'bankManagement.addNewBranchModal.bankNameInputLabel\'}}</label><div isteven-multi-select="" id="bankList" input-model="vm.banks" output-model="vm.selectedBank" button-label="name" item-label="name" tick-property="ticked" output-properties="id" search-property="name" selection-mode="single"></div></div></div><div class="row"><div class="col-md-12 form-group"><label for="branchName" class="mt-10 required" translate="">{{ \'bankManagement.addNewBranchModal.branchNameInputLabel\'}}</label> <input type="text" id="branchName" class="form-control" placeholder="{{ \'bankManagement.addNewBranchModal.branchNameInputPlaceholder\' | translate }}" ng-model="vm.branchName"></div></div><div class="row"><div class="col-md-12 form-group"><label for="routingNumber" class="mt-10 required" translate="">{{ \'bankManagement.addNewBranchModal.routingNumberInputLabel\'}}</label> <input type="text" id="routingNumber" class="form-control" placeholder="{{ \'bankManagement.addNewBranchModal.routingNumberInputPlaceholder\' | translate }}" ng-model="vm.routingNumber"></div></div><div class="row"><div class="col-md-12 form-group"><span class="d-inline-block text-bold mb-3" translate="">inactive</span> <label class="custom-switch ml-20"><input name="status" ng-model="vm.status" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">active</strong></span></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{ \'commonKeywords.createButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/bankSettings/branchManagement/modals/editBranch/editBranch.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{ \'bankManagement.editBranchModal.title\' | translate }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12 form-group"><label for="bankName" class="mt-10" translate="">{{ \'bankManagement.editBranchModal.bankNameInputLabel\'}}</label> <input id="bankName" type="text" class="form-control dark-bg" disabled="" ng-model="vm.branchDetails.bankName" readonly=""></div></div><div class="row"><div class="col-md-12 form-group"><label for="branchName" class="mt-10" translate="">{{ \'bankManagement.editBranchModal.branchNameInputLabel\'}}</label> <input type="text" id="branchName" class="form-control" placeholder="{{ \'bankManagement.editBranchModal.branchNameInputPlaceholder\' | translate }}" ng-model="vm.branchDetails.branchName"></div></div><div class="row"><div class="col-md-12 form-group"><label for="routingNumber" class="mt-10" translate="">{{ \'bankManagement.editBranchModal.routingNumberInputLabel\'}}</label> <input type="text" id="routingNumber" class="form-control" placeholder="{{ \'bankManagement.editBranchModal.routingNumberInputPlaceholder\' | translate }}" ng-model="vm.branchDetails.routingNumber"></div></div><div class="row"><div class="col-md-12 form-group"><span class="d-inline-block text-bold mb-3" translate="">inactive</span> <label class="custom-switch ml-20"><input name="status" ng-model="vm.branchDetails.branchStatus" type="checkbox"><span class="slider round"></span></label> <span class="d-inline-block mt-negative-3"><strong class="ml-20" translate="">active</strong></span></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.submit()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentTypeInputForIndividualEmployee/create/absentTypeInputForIndividual.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'monthlySalaryProcess.AbsenceTypeSalaryComponentHeading\' | translate}}"><div class="row"><div class="col-md-12"><employee-type-ahead-search keyword="vm.searchKeyword" select-method="vm.fetchEmployeeInformation"></employee-type-ahead-search></div></div><div class="row"><div class="col-md-12"><label translate="">employeeName</label> <input type="text" class="form-control" ng-disabled="vm.employeeData.employeeName" ng-class="{\'dark-bg\':vm.employeeData.employeeName}" ng-model="vm.employeeData.employeeName"></div></div><div class="row mt-10"><div class="col-md-6"><label translate="">designation</label> <input type="text" class="form-control" ng-disabled="vm.employeeData.employeeName" ng-class="{\'dark-bg\':vm.employeeData.designation}" ng-model="vm.employeeData.designation"></div><div class="col-md-6"><label translate="">department</label> <input type="text" class="form-control" ng-disabled="vm.employeeData.employeeName" ng-class="{\'dark-bg\':vm.employeeData.department}" ng-model="vm.employeeData.department"></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">workplace</label> <input type="text" class="form-control" ng-disabled="vm.employeeData.employeeName" ng-class="{\'dark-bg\':vm.employeeData.workplace}" ng-model="vm.employeeData.workplace"></div></div><div class="row mt-10"><div class="col-md-12"><label class="text-capitalize mt-10" translate="">filters.salaryMonth</label><div class="filter-inline-item"><div class="input-group mb-0 width-80"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" datepicker-options="vm.monthPickerSalary.options" ng-model="vm.selectedMonth" is-open="vm.monthPickerSalary.opened" ng-required="false" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openMonthPickerSalary()"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{\'monthlySalaryProcess.absenceType\'}}</label><div class="custom-select"><select ng-options="v.id as v.name for v in vm.absentType" ng-model="vm.selectedAbsentType"></select></div></div><div class="col-md-6"><label class="required" translate="">days</label> <input type="number" class="form-control" ng-model="vm.data.days"></div></div><div class="row mt-10"><div class="col-md-12"><label class="required" translate="">remarks</label> <input type="text" class="form-control" ng-model="vm.data.remarks"></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ui-sref="payroll.absentOrLeaveWithoutPay" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.saveAbsentData()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentTypeInputForIndividualEmployee/modal/confirmation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">confirmation</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p>{{vm.confirmationMsg.confirmationText}} {{vm.confirmationMsg.componentName}}</p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.noButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.yesButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/absentOrLeaveWithoutPay/absentTypeInputForIndividualEmployee/update/editAbsenceTypeForIndividual.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'monthlySalaryProcess.AbsenceTypeSalaryComponentHeading\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><div class="row"><div class="col-md-12"><label translate="">employeeName</label> <input type="text" class="form-control dark-bg" ng-model="vm.employeeData.employeeName" disabled=""></div></div><div class="row mt-10"><div class="col-md-6"><label translate="">designation</label> <input type="text" class="form-control dark-bg" ng-model="vm.employeeData.designation" disabled=""></div><div class="col-md-6"><label translate="">department</label> <input type="text" class="form-control dark-bg" ng-model="vm.employeeData.department" disabled=""></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">workplace</label> <input type="text" class="form-control dark-bg" ng-model="vm.employeeData.workplace" disabled=""></div></div><div class="row mt-10"><div class="col-md-12"><label class="text-capitalize mt-10" translate="">filters.salaryMonth</label><div class="filter-inline-item"><div class="input-group mb-0 width-80 dark-bg"><input type="text" class="form-control dark-bg" uib-datepicker-popup="MMM yyyy" datepicker-options="vm.monthPickerSalary.options" ng-model="vm.selectedMonth" is-open="vm.monthPickerSalary.opened" ng-required="false" show-button-bar="false" disabled="" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="" disabled=""><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">{{\'monthlySalaryProcess.absenceType\'}}</label><div class="custom-select dark-bg"><select ng-options="v.id as v.name for v in vm.absentType" ng-model="vm.selectedAbsentType" disabled="" readonly=""></select></div></div><div class="col-md-6"><label class="required" translate="">days</label> <input type="number" class="form-control" ng-model="vm.data.days"></div></div><div class="row mt-10"><div class="col-md-12"><label class="required" translate="">remarks</label> <input type="text" class="form-control" ng-model="vm.data.remarks"></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-primary" ng-click="vm.saveAbsentData()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/create/individualAdditionalSalaryComponent.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'monthlySalaryProcess.individualAdditionalSalaryComponentHeading\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><employee-type-ahead-search select-method="vm.getEmployeeProfile" keyword="vm.searchKeyword" show-label="true" is-required="true"></employee-type-ahead-search><form name="vm.createEmployeeComponentForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><label translate="">employeeName</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.name" readonly=""></div></div><div class="row mt-10"><div class="col-md-6"><label translate="">designation</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.designation.name" readonly=""></div><div class="col-md-6"><label translate="">department</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.department.name" readonly=""></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">workplace</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.workplace.name" readonly=""></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">from</label><div class="input-group form-group" ng-class="{\'has-error\': vm.createEmployeeComponentForm.startMonth.$invalid && vm.createEmployeeComponentForm.startMonth.$touched}"><input type="text" name="startMonth" class="form-control" uib-datepicker-popup="{{vm.startMonthPicker.format}}" datepicker-options="vm.startMonthPicker.options" ng-model="vm.selectedStartMonth" is-open="vm.startMonthPicker.opened" show-button-bar="false" tabindex="1" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openStartMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></div><div class="col-md-6"><label class="required" translate="">to</label><div class="input-group form-group" ng-class="{\'has-error\': vm.createEmployeeComponentForm.endMonth.$invalid && vm.createEmployeeComponentForm.endMonth.$touched}"><input type="text" name="endMonth" class="form-control" uib-datepicker-popup="{{vm.endMonthPicker.format}}" datepicker-options="vm.endMonthPicker.options" ng-model="vm.selectedEndMonth" is-open="vm.endMonthPicker.opened" show-button-bar="false" tabindex="2" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="vm.openEndMonthPicker()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row mt-10"><div class="col-md-12"><label class="required" translate="">{{\'payrollSettings.componentName\'}}</label><div class="custom-select" ng-class="{\'has-error\': vm.createEmployeeComponentForm.selectedComponent.$invalid && vm.createEmployeeComponentForm.selectedComponent.$touched}"><select ng-options="v.id as v.name for v in vm.componentList" name="selectedComponent" ng-model="vm.selectedComponent" tabindex="3" required=""><option value="" selected="" translate="">{{\'applyLeave.pleaseSelect\'}}</option></select></div></div></div><div class="row mt-10"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createEmployeeComponentForm.amount.$invalid && vm.createEmployeeComponentForm.amount.$touched}"><label class="required" translate="">amount</label> <input type="number" name="amount" class="form-control" ng-model="vm.amount" tabindex="4" required=""></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.createEmployeeComponentForm.remarks.$invalid && vm.createEmployeeComponentForm.remarks.$touched}"><label class="required" translate="">remarks</label> <input type="text" name="remarks" class="form-control" ng-model="vm.remarks" tabindex="5" required=""></div></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.invalidComponentForm()" ng-class="{\'btn-disable\' : vm.invalidComponentForm(), \'btn-primary\' : !vm.invalidComponentForm()}" ng-click="vm.saveAdditionalSalaryComponent()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/modal/confirmation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">confirmation</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16">{{vm.confirmationMsg.confirmationText}} {{vm.confirmationMsg.componentName}}</p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.noButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{ \'commonKeywords.yesButton\' }}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/monthlySalaryProcess/additionalSalaryComponentUpload/individualAdditionalSalaryComponent/update/editIndividualAdditionalSalaryComponent.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{\'monthlySalaryProcess.individualAdditionalSalaryComponentHeading\' | translate}}"><div class="row d-flex-center-center-inherit" ng-if="!vm.isDataLoaded"><div class="col-md-12"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div></div><div ng-if="vm.isDataLoaded"><form name="vm.editEmployeeComponentForm" novalidate="" autocomplete="off"><div class="row"><div class="col-md-12"><label translate="">employeeName</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.name" readonly=""></div></div><div class="row mt-10"><div class="col-md-6"><label translate="">designation</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.designation.name" readonly=""></div><div class="col-md-6"><label translate="">department</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.department.name" readonly=""></div></div><div class="row mt-10"><div class="col-md-12"><label translate="">workplace</label> <input type="text" class="form-control dark-bg" disabled="" ng-model="vm.selectedEmployee.workplace.name" readonly=""></div></div><div class="row mt-10"><div class="col-md-6"><label class="required" translate="">from</label><div class="input-group form-group dark-bg"><input type="text" name="startMonth" class="form-control dark-bg" uib-datepicker-popup="{{vm.startMonthPicker.format}}" datepicker-options="vm.startMonthPicker.options" ng-model="vm.selectedStartMonth" is-open="vm.startMonthPicker.opened" show-button-bar="false" tabindex="1" disabled="" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="" disabled=""><i class="fa fa-calendar"></i></button></span></div></div><div class="col-md-6"><label class="required" translate="">to</label><div class="input-group form-group dark-bg"><input type="text" name="endMonth" class="form-control dark-bg" uib-datepicker-popup="{{vm.endMonthPicker.format}}" datepicker-options="vm.endMonthPicker.options" ng-model="vm.selectedEndMonth" is-open="vm.endMonthPicker.opened" show-button-bar="false" tabindex="2" disabled="" readonly=""> <span class="input-group-btn"><button type="button" class="btn btn-default modified-input-box" ng-click="" disabled=""><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row mt-10"><div class="col-md-12"><label class="required" translate="">{{\'payrollSettings.componentName\'}}</label><div class="custom-select dark-bg"><select ng-options="v.id as v.name for v in vm.componentList" name="selectedComponent" ng-model="vm.selectedComponent" tabindex="3" disabled="" readonly=""><option value="" selected="" translate="">{{\'applyLeave.pleaseSelect\'}}</option></select></div></div></div><div class="row mt-10"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editEmployeeComponentForm.amount.$invalid && vm.editEmployeeComponentForm.amount.$touched}"><label class="required" translate="">amount</label> <input type="number" name="amount" class="form-control" ng-model="vm.amount" tabindex="4" required=""></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.editEmployeeComponentForm.remarks.$invalid && vm.editEmployeeComponentForm.remarks.$touched}"><label class="required" translate="">remarks</label> <input type="text" name="remarks" class="form-control" ng-model="vm.remarks" tabindex="5" required=""></div></div></div><div class="row mt-150"><div class="col-md-12"><div class="d-flex-flex-end-10"><button type="button" class="btn btn-md border-btn" ng-click="vm.cancelCurrentOperation()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md" ng-disabled="vm.invalidComponentForm()" ng-class="{\'btn-disable\' : vm.invalidComponentForm(), \'btn-primary\' : !vm.invalidComponentForm()}" ng-click="vm.saveAdditionalSalaryComponent()" translate="">{{ \'commonKeywords.saveButton\' }}</button></div></div></div></form></div></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/modals/closePFAccountingYearModal/closePFAccountingYear.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'providentFund.doYouWantToCloseAccounting\' | translate}} <span class="color-22222 font-weight-600" translate="">year</span> <span class="color-22222">{{vm.accountYear}}</span> {{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.closePFAccountingYear()" translate="">{{ vm.yesBtnClicked ? \'Please wait..\' : \'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/providentFund/providentFundAccountManagement/modals/uploadInterestYear/uploadInterest.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16 line-height-1_5">{{ \'providentFund.doYouWantToUploadInterest\' | translate}} <span class="color-22222 font-weight-600" translate="">year</span> <span class="color-22222">{{vm.accountYear}}</span> {{ \'departmentSettings.deleteModal.questionMark\' | translate}}</p><label translate="">{{\'providentFund.insertAmount\'}}</label> <input type="number" class="form-control" ng-model="vm.interestAmount"></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.noButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-secondary" ng-click="vm.uploadInterest()" translate="">{{vm.yesBtnClicked ? \'Please wait..\' : \'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicRemoveModal/profilePicRemove.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_5">{{\'profile.profilePicRemoveHeading\' | translate}}</p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="vm.removePicture()" translate="">{{\'commonKeywords.deleteButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicUploadModal/profilePicUpload.modal.html','<style>\n    .section-style{\n        background: #E4E4E4;\n        overflow: hidden;\n        width: 400px;\n        height: 300px;\n        margin: auto;"\n    }\n    .image-size{\n        height: 200px;\n        width: 200px\n    }\n</style><div class="modal-content"><form name="picUploadForm"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'profile.uploadProfilePicHeading\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="text-center"><div ng-show="!vm.isFileSelected" class="section-style"><img ng-src="{{vm.currentProfilePicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" class="section-style" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image-size="vm.resizeImage == true ? 500 : 800" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-md-with-icon btn-default mt-10 mb-10" ngf-change="vm.fileSelected()"><i class="ion-images"></i><span translate="">{{\'profile.selectImage\'}}</span></button><div><img class="image-size" ng-src="{{croppedDataUrl}}"></div></div><div class="footer" ng-if="vm.isFileSelected"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{ \'commonKeywords.cancelButton\' }}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="vm.uploadProfilePicture(croppedDataUrl, picFile.name)"><span class="white-text" translate="">{{\'commonKeywords.uploadButton\'}}</span></button></div></div></form></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkIn/modals/checkInConfirmation.modal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{ \'visitorManagement.reception.checkIn.confirmationModal.title\' }}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row"><div class="col-md-12"><p class="font-16 line-height-1_3">{{ \'visitorManagement.reception.checkIn.confirmationModal.confirmationText\' | translate }} <em>{{vm.visitorName}}</em><span translate="">{{\'commonKeywords.questionMark\'}}</span></p></div></div><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button type="button" class="btn btn-md btn-secondary" ng-click="$close()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkOut/checkOutProfile/checkOutModal.html','<div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-danger" translate="">{{\'profile.areYouSureHeading\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16 line-height-1_3"><span translate="">{{\'Do you want to checkout this visit\'}}</span> <span translate="">{{\'commonKeywords.questionMark\'}}</span></p><div class="footer"><button type="button" class="btn btn-md border-btn" ng-click="$dismiss()" translate="">{{\'commonKeywords.cancelButton\'}}</button> <button id="dismissButton" type="button" class="btn btn-md btn-danger" ng-click="$close()" translate="">{{\'Yes\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/visitorManagement/reception/partials/checkOut/checkOutProfile/checkOutProfile.html','<div class="row"><div><h5 class="text-center">{{\'Visitor Information\'}}</h5></div><table class="table table-bordered"><tbody><colgroup><col class="width-50"><col class="width-50"></colgroup><tr class="text-center th-bg th-width"><div><td class="text-center th-bg th-width border-0"><visitor-picture-and-information name="vm.checkOutToShow.visitorName+\' (Visitor)\'" picture-url="vm.checkOutToShow.visitorPictureUrl" visit-purpose="vm.checkOutToShow.visitReason" company-name="!vm.checkOutToShow.organisationName ? \'N/A\':vm.checkOutToShow.organisationName" is-clickable="false"></visitor-picture-and-information></td><td class="border-0"><employee-picture-and-information name="vm.checkOutToShow.hostName+ \'(Host)\'" picture-url="vm.checkOutToShow.hostPictureUrl" department-name="vm.checkOutToShow.departmentName" designation-name="!vm.checkOutToShow.designationName ? \'N/A\':vm.visitorCreatedBy.designationName" is-clickable="false"></employee-picture-and-information></td></div></tr><tr class="text-left"><td><span translate="">{{\'visitorManagement.myVisitorProfile.visitorMobile\'}}</span><span translate="">{{vm.checkOutToShow.visitorMobile}}</span></td><td><span translate="">{{\'visitorManagement.myVisitorProfile.visitorCategory\'}}</span><span translate="">{{vm.checkOutToShow.visitorCategory}}</span></td></tr><tr class="text-left"><td><span translate="">{{\'Accces Area : \'}}</span><span translate="">{{vm.checkOutToShow.visitorAccessArea}}</span></td><td><span translate="">{{\'Reason : \'}}</span><span translate="">{{vm.checkOutToShow.visitReason}}</span></td></tr><tr class="text-left"><td><span translate="">{{\'Organization :\'}}</span><span translate="">{{vm.checkOutToShow.visitorOrganisationName}}</span></td><td class="visitor-created-by-text-document"><div><span class="text-primary">Checked In:<span translate="">{{vm.checkOutToShow.checkInTime |date:\'hh:mm a\'}}</span></span></div></td></tr></tbody></table><div><h5 class="text-center mt-20">{{\'Item Carried In\'}}</h5></div><table class="table table-bordered"><tbody><colgroup><col class="width-33"><col class="width-33"><col class="width-33"></colgroup><tr class="text-center th-bg th-width"><div><td class="text-left th-bg th-width border-0"><span translate="">{{\'Item Name\'}}</span></td><td class="text-center border-0"><span translate="">{{\'Details\'}}</span></td><td class="text-center border-0"><span translate="">{{\'Quantity\'}}</span></td></div></tr><tr class="text-center th-bg th-width" ng-if="vm.checkOutToShow.visitorItems.length==0"><td colspan="3"><em>{{\'No items carried\'}}</em></td></tr><tr class="text-left" ng-repeat="items in vm.checkOutToShow.visitorItems"><td><span translate="">{{$index+1+\'. \'}}</span><span translate="">{{items.name}}</span></td><td class="text-center"><span translate="">{{items.description}}</span></td><td class="text-center"><span translate="">{{items.quantity}}</span></td></tr></tbody></table><div class="row mt-50"><div class="col-md-12"><button type="button" class="btn btn-md-with-icon pull-right" ng-class="vm.isCheckOutModalOpened?\'btn-disable\':\'btn-danger\'" ng-click="!vm.isCheckOuModalOpened && vm.openCheckOutModal(vm.checkOutToShow.id)"><span class="" translate="">{{ \'CHECK OUT\' }}</span></button> <button type="button" class="btn btn-md-with-icon pull-right border-btn mr-10" ng-click="vm.hideProfile()"><span class="" translate="">{{ \'CANCEL\' }}</span></button></div></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/amountComparisonModal/amountComparisonModal.html','<body><div class="modal-body pb-15"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'viewOrGenerateSalary.modalTitle\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16" translate="">{{\'viewOrGenerateSalary.amountComparisonModal.bodyHeading\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-md btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.selectAnotherRow()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/approveSalaryModal/approveSalaryModal.html','<body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'viewOrGenerateSalary.modalTitle\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16" translate="">{{\'viewOrGenerateSalary.approveSalaryModal.bodyHeading\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.approveSalary()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/paySalaryModal/paySalaryModal.html','<body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'viewOrGenerateSalary.modalTitle\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="text-center"><p class="font-17 font-weight-600 color-222222" translate="">{{\'viewOrGenerateSalary.paySalaryModal.bodyHeading\'}}</p><p>{{\'viewOrGenerateSalary.paySalaryModal.paySalaryText1\' | translate}}</p><p>{{\'viewOrGenerateSalary.paySalaryModal.paySalaryText2\' | translate}}</p></div><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-md btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.paySalary()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/processSalaryModal/processSalaryModal.html','<body><div class="modal-body"><div class="d-flex-space-between"><div class="" ng-if="vm.errorEmployees.length == 0"><h3 class="text-uppercase text-primary" translate="">{{\'viewOrGenerateSalary.modalTitle\'}}</h3></div><div class="" ng-if="vm.errorEmployees.length > 0"><h3 class="text-uppercase text-primary"><span class="text-danger" translate="">{{\'viewOrGenerateSalary.processSalaryModal.processFailedHeading\'}}</span></h3></div><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><span ng-if="!vm.isAllSelected && vm.selectedEmployees.length === 0 && vm.errorEmployees.length == 0"><p class="font-16" translate="">{{\'viewOrGenerateSalary.undoSalaryModal.processSalaryForAll\'}}</p></span> <span ng-if="vm.selectedEmployees.length === 1 && vm.errorEmployees.length == 0"><p class="font-16"><span translate="">{{\'viewOrGenerateSalary.processSalaryModal.processSalaryForOne\'}}</span> {{vm.selectedEmployees[0].employee.name}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p></span> <span ng-if="vm.selectedEmployees.length > 1 && vm.errorEmployees.length == 0"><p class="font-16" translate="">{{\'viewOrGenerateSalary.processSalaryModal.processSalaryForMultiple\'}}</p></span><div class="row" ng-if="vm.errorEmployees.length > 0"><div class="col-md-12"><table class="table table-bordered"><tr><th class="text-center" translate="">{{\'commonKeywords.id\'}}</th><th class="text-center" translate="">{{\'commonKeywords.name\'}}</th><th class="text-center" translate="">{{\'commonKeywords.reason\'}}</th></tr><tr ng-repeat="data in vm.errorEmployees"><td>{{data.employeeOfficeId}}</td><td>{{data.employeeName}}</td><td translate="">{{\'viewOrGenerateSalary.salaryNotSetup\'}}</td></tr></table></div></div><div class="footer"><button type="button" ng-if="vm.errorEmployees.length == 0" class="btn btn-md border-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-md btn-secondary pull-right ml-10 padding-9-17" ng-if="vm.errorEmployees.length == 0" ng-click="vm.processSalary()" translate="">{{\'commonKeywords.yesButton\'}}</button> <button type="button" class="btn btn-md btn-secondary pull-right ml-10 padding-9-17" ng-if="vm.errorEmployees.length > 0" ng-click="$dismiss()" translate="">{{\'commonKeywords.okButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/rollbackSalaryModal/rollbackSalaryModal.html','<style>\n    textarea.form-control {\n        height: 70px;\n    }\n</style><body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'viewOrGenerateSalary.modalTitle\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div><p class="font-16" translate="">{{\'viewOrGenerateSalary.rollbackSalaryModal.bodyHeading\'}}</p></div><div class="row mt-20"><div class="col-md-4 text-left"><span class="required">{{\'commonKeywords.reason\' | translate}}</span></div></div><div class="row mt-10"><div class="col-md-12"><textarea ng-model="vm.reason" class="form-control" placeholder="Write roll back reason here"></textarea></div></div><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-md btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.rollbackSalary()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/salaryLogModal/salaryLogModal.html','<style>\n    .border-style{\n        border-left-color: #f7f7f7;\n    }\n</style><div class="modal-content"><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'viewOrGenerateSalary.salaryLogModal.title\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><div class="row" ng-if="!vm.isDataLoaded"><div class="text-center"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div></div><table ng-show="vm.isDataLoaded" class="table table-bordered"><colgroup><col class="width-25"><col class="width-25"><col class="width-25"><col class="width-25"></colgroup><tbody><tr><td class="headers2 text-left font-weight-500" translate="">{{\'viewOrGenerateSalary.salaryState\'}}</td><td class="text-center bg-f8f8f8 font-weight-500 deepskyblue-text" translate="">{{\'viewOrGenerateSalary.inProcess\'}}</td><td class="text-center bg-f8f8f8 font-weight-500 limegreen-text border-style" translate="">{{\'viewOrGenerateSalary.approved\'}}</td><td class="text-center bg-f8f8f8 font-weight-500 green-text border-style" translate="">{{\'viewOrGenerateSalary.paid\'}}</td></tr><tr><td class="headers2 text-left font-weight-500" translate="">{{\'viewOrGenerateSalary.employeeId\'}}</td><td class="text-center">{{vm.salaryLog.processorOfficeId}}</td><td class="text-center">{{vm.salaryLog.approverOfficeId}}</td><td class="text-center">{{vm.salaryLog.payerOfficeId}}</td></tr><tr><td class="headers2 text-left font-weight-500" translate="">{{\'viewOrGenerateSalary.employeeName\'}}</td><td class="bg-f8f8f8"><employee-picture-and-information ng-if="vm.salaryLog.processorId != null" name="vm.salaryLog.processorName" picture-url="vm.salaryLog.processorPictureUrl" department-name="vm.salarylog.processorDepartmentName" designation-name="vm.salaryLog.processorDesignationName" id="vm.salaryLog.processorId" is-clickable="false"></employee-picture-and-information></td><td class="bg-f8f8f8"><employee-picture-and-information ng-if="vm.salaryLog.approverId != null" name="vm.salaryLog.approverName" picture-url="vm.salaryLog.approverPictureUrl" department-name="vm.salarylog.approverDepartmentName" designation-name="vm.salaryLog.approverDesignationName" id="vm.salaryLog.approverId" is-clickable="false"></employee-picture-and-information></td><td class="bg-f8f8f8"><employee-picture-and-information ng-if="vm.salaryLog.payerId != null" name="vm.salaryLog.payerName" picture-url="vm.salaryLog.payerPictureUrl" department-name="vm.salarylog.payerDepartmentName" designation-name="vm.salaryLog.payerDesignationName" id="vm.salaryLog.payerId" is-clickable="false"></employee-picture-and-information></td></tr><tr><td class="headers2 text-left" translate="">{{\'viewOrGenerateSalary.dateAndTime\'}}</td><td class="text-center">{{vm.salaryLog.processedAt | date : \'dd MMM yyyy, H:mm\'}}</td><td class="text-center">{{vm.salaryLog.approvedAt | date : \'dd MMM yyyy, H:mm\'}}</td><td class="text-center">{{vm.salaryLog.paidAt | date : \'dd MMM yyyy, H:mm\'}}</td></tr></tbody></table><div class="footer"><button type="button" class="btn btn-md btn-secondary pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.okButton\'}}</button></div></div></div>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/sendForApprovalModal/sendSalaryForApprovalModal.html','<body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary">{{\'viewOrGenerateSalary.modalTitle\' | translate}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><p class="font-16" translate="">{{\'viewOrGenerateSalary.sendSalaryForApprovalLogModal.bodyHeading\'}}</p><div class="footer"><button type="button" class="btn btn-md border-btn conformation-btn pull-right mr-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-md btn-secondary conformation-btn pull-right ml-10 padding-9-17" ng-click="vm.sendForApproval()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></body>');
$templateCache.put('app/pages/main/payroll/viewOrGenerateSalary/partials/viewSalary-partials/modals/undoSalaryModal/undoSalaryModal.html','<body><div class="modal-body"><div class="d-flex-space-between"><h3 class="text-uppercase text-primary" translate="">{{\'viewOrGenerateSalary.modalTitle\'}}</h3><button type="button" class="close mt-negative-20" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><hr><span ng-if="!vm.isAllSelected && vm.selectedEmployees.length === 0"><p class="font-16" translate="">{{\'viewOrGenerateSalary.undoSalaryModal.undoSalaryForAll\'}}</p></span> <span ng-if="vm.selectedEmployees.length === 1"><p class="font-16"><span translate="">{{\'viewOrGenerateSalary.undoSalaryModal.undoSalaryForOne\'}}</span> {{vm.selectedEmployees[0].employee.name}}<span translate="">{{\'commonKeywords.questionMark\'}}</span></p></span> <span ng-if="vm.selectedEmployees.length > 1"><p class="font-16" translate="">{{\'viewOrGenerateSalary.undoSalaryModal.undoSalaryForMultiple\'}}</p></span><div class="footer"><button type="button" class="btn btn-md border-btn pull-right ml-0 padding-9-17" ng-click="$dismiss()" aria-label="Close" translate="">{{\'commonKeywords.noButton\'}}</button> <button type="button" class="btn btn-md btn-secondary pull-right ml-10 padding-9-17" ng-click="vm.undoSalary()" translate="">{{\'commonKeywords.yesButton\'}}</button></div></div></body>');}]);